var oP = Object.defineProperty;
var aP = (ie, Z, ee) => Z in ie ? oP(ie, Z, { enumerable: !0, configurable: !0, writable: !0, value: ee }) : ie[Z] = ee;
var Sc = (ie, Z, ee) => (aP(ie, typeof Z != "symbol" ? Z + "" : Z, ee), ee);
function _mergeNamespaces(ie, Z) {
  for (var ee = 0; ee < Z.length; ee++) {
    const ae = Z[ee];
    if (typeof ae != "string" && !Array.isArray(ae)) {
      for (const ve in ae)
        if (ve !== "default" && !(ve in ie)) {
          const ye = Object.getOwnPropertyDescriptor(ae, ve);
          ye && Object.defineProperty(ie, ve, ye.get ? ye : {
            enumerable: !0,
            get: () => ae[ve]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(ie, Symbol.toStringTag, { value: "Module" }));
}
class BaseEvent {
  /**
   * @param {string} type Type.
   */
  constructor(Z) {
    this.propagationStopped, this.defaultPrevented, this.type = Z, this.target = null;
  }
  /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */
  preventDefault() {
    this.defaultPrevented = !0;
  }
  /**
   * Stop event propagation.
   * @api
   */
  stopPropagation() {
    this.propagationStopped = !0;
  }
}
const ObjectEventType = {
  /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */
  PROPERTYCHANGE: "propertychange"
};
class Disposable {
  constructor() {
    this.disposed = !1;
  }
  /**
   * Clean up.
   */
  dispose() {
    this.disposed || (this.disposed = !0, this.disposeInternal());
  }
  /**
   * Extension point for disposable objects.
   * @protected
   */
  disposeInternal() {
  }
}
function binarySearch(ie, Z, ee) {
  let ae, ve;
  ee = ee || ascending;
  let ye = 0, be = ie.length, Ye = !1;
  for (; ye < be; )
    ae = ye + (be - ye >> 1), ve = +ee(ie[ae], Z), ve < 0 ? ye = ae + 1 : (be = ae, Ye = !ve);
  return Ye ? ye : ~ye;
}
function ascending(ie, Z) {
  return ie > Z ? 1 : ie < Z ? -1 : 0;
}
function descending(ie, Z) {
  return ie < Z ? 1 : ie > Z ? -1 : 0;
}
function linearFindNearest(ie, Z, ee) {
  if (ie[0] <= Z)
    return 0;
  const ae = ie.length;
  if (Z <= ie[ae - 1])
    return ae - 1;
  if (typeof ee == "function") {
    for (let ve = 1; ve < ae; ++ve) {
      const ye = ie[ve];
      if (ye === Z)
        return ve;
      if (ye < Z)
        return ee(Z, ie[ve - 1], ye) > 0 ? ve - 1 : ve;
    }
    return ae - 1;
  }
  if (ee > 0) {
    for (let ve = 1; ve < ae; ++ve)
      if (ie[ve] < Z)
        return ve - 1;
    return ae - 1;
  }
  if (ee < 0) {
    for (let ve = 1; ve < ae; ++ve)
      if (ie[ve] <= Z)
        return ve;
    return ae - 1;
  }
  for (let ve = 1; ve < ae; ++ve) {
    if (ie[ve] == Z)
      return ve;
    if (ie[ve] < Z)
      return ie[ve - 1] - Z < Z - ie[ve] ? ve - 1 : ve;
  }
  return ae - 1;
}
function reverseSubArray(ie, Z, ee) {
  for (; Z < ee; ) {
    const ae = ie[Z];
    ie[Z] = ie[ee], ie[ee] = ae, ++Z, --ee;
  }
}
function extend$2(ie, Z) {
  const ee = Array.isArray(Z) ? Z : [Z], ae = ee.length;
  for (let ve = 0; ve < ae; ve++)
    ie[ie.length] = ee[ve];
}
function equals$2(ie, Z) {
  const ee = ie.length;
  if (ee !== Z.length)
    return !1;
  for (let ae = 0; ae < ee; ae++)
    if (ie[ae] !== Z[ae])
      return !1;
  return !0;
}
function isSorted(ie, Z, ee) {
  const ae = Z || ascending;
  return ie.every(function(ve, ye) {
    if (ye === 0)
      return !0;
    const be = ae(ie[ye - 1], ve);
    return !(be > 0 || ee && be === 0);
  });
}
function TRUE() {
  return !0;
}
function FALSE() {
  return !1;
}
function VOID() {
}
function memoizeOne(ie) {
  let Z = !1, ee, ae, ve;
  return function() {
    const ye = Array.prototype.slice.call(arguments);
    return (!Z || this !== ve || !equals$2(ye, ae)) && (Z = !0, ve = this, ae = ye, ee = ie.apply(this, arguments)), ee;
  };
}
function toPromise(ie) {
  function Z() {
    let ee;
    try {
      ee = ie();
    } catch (ae) {
      return Promise.reject(ae);
    }
    return ee instanceof Promise ? ee : Promise.resolve(ee);
  }
  return Z();
}
function clear(ie) {
  for (const Z in ie)
    delete ie[Z];
}
function isEmpty$1(ie) {
  let Z;
  for (Z in ie)
    return !1;
  return !Z;
}
class Target extends Disposable {
  /**
   * @param {*} [target] Default event target for dispatched events.
   */
  constructor(Z) {
    super(), this.eventTarget_ = Z, this.pendingRemovals_ = null, this.dispatching_ = null, this.listeners_ = null;
  }
  /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */
  addEventListener(Z, ee) {
    if (!Z || !ee)
      return;
    const ae = this.listeners_ || (this.listeners_ = {}), ve = ae[Z] || (ae[Z] = []);
    ve.includes(ee) || ve.push(ee);
  }
  /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */
  dispatchEvent(Z) {
    const ee = typeof Z == "string", ae = ee ? Z : Z.type, ve = this.listeners_ && this.listeners_[ae];
    if (!ve)
      return;
    const ye = ee ? new BaseEvent(Z) : (
      /** @type {Event} */
      Z
    );
    ye.target || (ye.target = this.eventTarget_ || this);
    const be = this.dispatching_ || (this.dispatching_ = {}), Ye = this.pendingRemovals_ || (this.pendingRemovals_ = {});
    ae in be || (be[ae] = 0, Ye[ae] = 0), ++be[ae];
    let Qe;
    for (let Je = 0, nt = ve.length; Je < nt; ++Je)
      if ("handleEvent" in ve[Je] ? Qe = /** @type {import("../events.js").ListenerObject} */
      ve[Je].handleEvent(ye) : Qe = /** @type {import("../events.js").ListenerFunction} */
      ve[Je].call(this, ye), Qe === !1 || ye.propagationStopped) {
        Qe = !1;
        break;
      }
    if (--be[ae] === 0) {
      let Je = Ye[ae];
      for (delete Ye[ae]; Je--; )
        this.removeEventListener(ae, VOID);
      delete be[ae];
    }
    return Qe;
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    this.listeners_ && clear(this.listeners_);
  }
  /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */
  getListeners(Z) {
    return this.listeners_ && this.listeners_[Z] || void 0;
  }
  /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */
  hasListener(Z) {
    return this.listeners_ ? Z ? Z in this.listeners_ : Object.keys(this.listeners_).length > 0 : !1;
  }
  /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */
  removeEventListener(Z, ee) {
    const ae = this.listeners_ && this.listeners_[Z];
    if (ae) {
      const ve = ae.indexOf(ee);
      ve !== -1 && (this.pendingRemovals_ && Z in this.pendingRemovals_ ? (ae[ve] = VOID, ++this.pendingRemovals_[Z]) : (ae.splice(ve, 1), ae.length === 0 && delete this.listeners_[Z]));
    }
  }
}
const EventType = {
  /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */
  CHANGE: "change",
  /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */
  ERROR: "error",
  BLUR: "blur",
  CLEAR: "clear",
  CONTEXTMENU: "contextmenu",
  CLICK: "click",
  DBLCLICK: "dblclick",
  DRAGENTER: "dragenter",
  DRAGOVER: "dragover",
  DROP: "drop",
  FOCUS: "focus",
  KEYDOWN: "keydown",
  KEYPRESS: "keypress",
  LOAD: "load",
  RESIZE: "resize",
  TOUCHMOVE: "touchmove",
  WHEEL: "wheel"
};
function listen(ie, Z, ee, ae, ve) {
  if (ae && ae !== ie && (ee = ee.bind(ae)), ve) {
    const be = ee;
    ee = function() {
      ie.removeEventListener(Z, ee), be.apply(this, arguments);
    };
  }
  const ye = {
    target: ie,
    type: Z,
    listener: ee
  };
  return ie.addEventListener(Z, ee), ye;
}
function listenOnce(ie, Z, ee, ae) {
  return listen(ie, Z, ee, ae, !0);
}
function unlistenByKey(ie) {
  ie && ie.target && (ie.target.removeEventListener(ie.type, ie.listener), clear(ie));
}
class Observable extends Target {
  constructor() {
    super(), this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */
    this.onInternal, this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */
    this.onceInternal, this.un = /** @type {ObservableOnSignature<void>} */
    this.unInternal, this.revision_ = 0;
  }
  /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */
  changed() {
    ++this.revision_, this.dispatchEvent(EventType.CHANGE);
  }
  /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */
  getRevision() {
    return this.revision_;
  }
  /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */
  onInternal(Z, ee) {
    if (Array.isArray(Z)) {
      const ae = Z.length, ve = new Array(ae);
      for (let ye = 0; ye < ae; ++ye)
        ve[ye] = listen(this, Z[ye], ee);
      return ve;
    }
    return listen(
      this,
      /** @type {string} */
      Z,
      ee
    );
  }
  /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */
  onceInternal(Z, ee) {
    let ae;
    if (Array.isArray(Z)) {
      const ve = Z.length;
      ae = new Array(ve);
      for (let ye = 0; ye < ve; ++ye)
        ae[ye] = listenOnce(this, Z[ye], ee);
    } else
      ae = listenOnce(
        this,
        /** @type {string} */
        Z,
        ee
      );
    return ee.ol_key = ae, ae;
  }
  /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */
  unInternal(Z, ee) {
    const ae = (
      /** @type {Object} */
      ee.ol_key
    );
    if (ae)
      unByKey(ae);
    else if (Array.isArray(Z))
      for (let ve = 0, ye = Z.length; ve < ye; ++ve)
        this.removeEventListener(Z[ve], ee);
    else
      this.removeEventListener(Z, ee);
  }
}
Observable.prototype.on;
Observable.prototype.once;
Observable.prototype.un;
function unByKey(ie) {
  if (Array.isArray(ie))
    for (let Z = 0, ee = ie.length; Z < ee; ++Z)
      unlistenByKey(ie[Z]);
  else
    unlistenByKey(
      /** @type {import("./events.js").EventsKey} */
      ie
    );
}
function abstract() {
  throw new Error("Unimplemented abstract method.");
}
let uidCounter_ = 0;
function getUid(ie) {
  return ie.ol_uid || (ie.ol_uid = String(++uidCounter_));
}
class ObjectEvent extends BaseEvent {
  /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */
  constructor(Z, ee, ae) {
    super(Z), this.key = ee, this.oldValue = ae;
  }
}
class BaseObject extends Observable {
  /**
   * @param {Object<string, *>} [values] An object with key-value pairs.
   */
  constructor(Z) {
    super(), this.on, this.once, this.un, getUid(this), this.values_ = null, Z !== void 0 && this.setProperties(Z);
  }
  /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */
  get(Z) {
    let ee;
    return this.values_ && this.values_.hasOwnProperty(Z) && (ee = this.values_[Z]), ee;
  }
  /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */
  getKeys() {
    return this.values_ && Object.keys(this.values_) || [];
  }
  /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */
  getProperties() {
    return this.values_ && Object.assign({}, this.values_) || {};
  }
  /**
   * Get an object of all property names and values.
   * @return {Object<string, *>?} Object.
   */
  getPropertiesInternal() {
    return this.values_;
  }
  /**
   * @return {boolean} The object has properties.
   */
  hasProperties() {
    return !!this.values_;
  }
  /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */
  notify(Z, ee) {
    let ae;
    ae = `change:${Z}`, this.hasListener(ae) && this.dispatchEvent(new ObjectEvent(ae, Z, ee)), ae = ObjectEventType.PROPERTYCHANGE, this.hasListener(ae) && this.dispatchEvent(new ObjectEvent(ae, Z, ee));
  }
  /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */
  addChangeListener(Z, ee) {
    this.addEventListener(`change:${Z}`, ee);
  }
  /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */
  removeChangeListener(Z, ee) {
    this.removeEventListener(`change:${Z}`, ee);
  }
  /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */
  set(Z, ee, ae) {
    const ve = this.values_ || (this.values_ = {});
    if (ae)
      ve[Z] = ee;
    else {
      const ye = ve[Z];
      ve[Z] = ee, ye !== ee && this.notify(Z, ye);
    }
  }
  /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */
  setProperties(Z, ee) {
    for (const ae in Z)
      this.set(ae, Z[ae], ee);
  }
  /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */
  applyProperties(Z) {
    Z.values_ && Object.assign(this.values_ || (this.values_ = {}), Z.values_);
  }
  /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */
  unset(Z, ee) {
    if (this.values_ && Z in this.values_) {
      const ae = this.values_[Z];
      delete this.values_[Z], isEmpty$1(this.values_) && (this.values_ = null), ee || this.notify(Z, ae);
    }
  }
}
const CollectionEventType = {
  /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */
  ADD: "add",
  /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */
  REMOVE: "remove"
}, Property$2 = {
  LENGTH: "length"
};
class CollectionEvent extends BaseEvent {
  /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */
  constructor(Z, ee, ae) {
    super(Z), this.element = ee, this.index = ae;
  }
}
class Collection extends BaseObject {
  /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */
  constructor(Z, ee) {
    if (super(), this.on, this.once, this.un, ee = ee || {}, this.unique_ = !!ee.unique, this.array_ = Z || [], this.unique_)
      for (let ae = 0, ve = this.array_.length; ae < ve; ++ae)
        this.assertUnique_(this.array_[ae], ae);
    this.updateLength_();
  }
  /**
   * Remove all elements from the collection.
   * @api
   */
  clear() {
    for (; this.getLength() > 0; )
      this.pop();
  }
  /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */
  extend(Z) {
    for (let ee = 0, ae = Z.length; ee < ae; ++ee)
      this.push(Z[ee]);
    return this;
  }
  /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */
  forEach(Z) {
    const ee = this.array_;
    for (let ae = 0, ve = ee.length; ae < ve; ++ae)
      Z(ee[ae], ae, ee);
  }
  /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */
  getArray() {
    return this.array_;
  }
  /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */
  item(Z) {
    return this.array_[Z];
  }
  /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */
  getLength() {
    return this.get(Property$2.LENGTH);
  }
  /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */
  insertAt(Z, ee) {
    if (Z < 0 || Z > this.getLength())
      throw new Error("Index out of bounds: " + Z);
    this.unique_ && this.assertUnique_(ee), this.array_.splice(Z, 0, ee), this.updateLength_(), this.dispatchEvent(
      new CollectionEvent(CollectionEventType.ADD, ee, Z)
    );
  }
  /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */
  pop() {
    return this.removeAt(this.getLength() - 1);
  }
  /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */
  push(Z) {
    this.unique_ && this.assertUnique_(Z);
    const ee = this.getLength();
    return this.insertAt(ee, Z), this.getLength();
  }
  /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */
  remove(Z) {
    const ee = this.array_;
    for (let ae = 0, ve = ee.length; ae < ve; ++ae)
      if (ee[ae] === Z)
        return this.removeAt(ae);
  }
  /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */
  removeAt(Z) {
    if (Z < 0 || Z >= this.getLength())
      return;
    const ee = this.array_[Z];
    return this.array_.splice(Z, 1), this.updateLength_(), this.dispatchEvent(
      /** @type {CollectionEvent<T>} */
      new CollectionEvent(CollectionEventType.REMOVE, ee, Z)
    ), ee;
  }
  /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */
  setAt(Z, ee) {
    const ae = this.getLength();
    if (Z >= ae) {
      this.insertAt(Z, ee);
      return;
    }
    if (Z < 0)
      throw new Error("Index out of bounds: " + Z);
    this.unique_ && this.assertUnique_(ee, Z);
    const ve = this.array_[Z];
    this.array_[Z] = ee, this.dispatchEvent(
      /** @type {CollectionEvent<T>} */
      new CollectionEvent(CollectionEventType.REMOVE, ve, Z)
    ), this.dispatchEvent(
      /** @type {CollectionEvent<T>} */
      new CollectionEvent(CollectionEventType.ADD, ee, Z)
    );
  }
  /**
   * @private
   */
  updateLength_() {
    this.set(Property$2.LENGTH, this.array_.length);
  }
  /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */
  assertUnique_(Z, ee) {
    for (let ae = 0, ve = this.array_.length; ae < ve; ++ae)
      if (this.array_[ae] === Z && ae !== ee)
        throw new Error("Duplicate item added to a unique collection");
  }
}
function assert(ie, Z) {
  if (!ie)
    throw new Error(Z);
}
class Feature extends BaseObject {
  /**
   * @param {Geometry|ObjectWithGeometry<Geometry>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */
  constructor(Z) {
    if (super(), this.on, this.once, this.un, this.id_ = void 0, this.geometryName_ = "geometry", this.style_ = null, this.styleFunction_ = void 0, this.geometryChangeKey_ = null, this.addChangeListener(this.geometryName_, this.handleGeometryChanged_), Z)
      if (typeof /** @type {?} */
      Z.getSimplifiedGeometry == "function") {
        const ee = (
          /** @type {Geometry} */
          Z
        );
        this.setGeometry(ee);
      } else {
        const ee = Z;
        this.setProperties(ee);
      }
  }
  /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */
  clone() {
    const Z = (
      /** @type {Feature<Geometry>} */
      new Feature(this.hasProperties() ? this.getProperties() : null)
    );
    Z.setGeometryName(this.getGeometryName());
    const ee = this.getGeometry();
    ee && Z.setGeometry(
      /** @type {Geometry} */
      ee.clone()
    );
    const ae = this.getStyle();
    return ae && Z.setStyle(ae), Z;
  }
  /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */
  getGeometry() {
    return (
      /** @type {Geometry|undefined} */
      this.get(this.geometryName_)
    );
  }
  /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */
  getId() {
    return this.id_;
  }
  /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */
  getGeometryName() {
    return this.geometryName_;
  }
  /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */
  getStyle() {
    return this.style_;
  }
  /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */
  getStyleFunction() {
    return this.styleFunction_;
  }
  /**
   * @private
   */
  handleGeometryChange_() {
    this.changed();
  }
  /**
   * @private
   */
  handleGeometryChanged_() {
    this.geometryChangeKey_ && (unlistenByKey(this.geometryChangeKey_), this.geometryChangeKey_ = null);
    const Z = this.getGeometry();
    Z && (this.geometryChangeKey_ = listen(
      Z,
      EventType.CHANGE,
      this.handleGeometryChange_,
      this
    )), this.changed();
  }
  /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */
  setGeometry(Z) {
    this.set(this.geometryName_, Z);
  }
  /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */
  setStyle(Z) {
    this.style_ = Z, this.styleFunction_ = Z ? createStyleFunction(Z) : void 0, this.changed();
  }
  /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */
  setId(Z) {
    this.id_ = Z, this.changed();
  }
  /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */
  setGeometryName(Z) {
    this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_), this.geometryName_ = Z, this.addChangeListener(this.geometryName_, this.handleGeometryChanged_), this.handleGeometryChanged_();
  }
}
function createStyleFunction(ie) {
  if (typeof ie == "function")
    return ie;
  let Z;
  return Array.isArray(ie) ? Z = ie : (assert(
    typeof /** @type {?} */
    ie.getZIndex == "function",
    "Expected an `ol/style/Style` or an array of `ol/style/Style.js`"
  ), Z = [
    /** @type {import("./style/Style.js").default} */
    ie
  ]), function() {
    return Z;
  };
}
const ua = typeof navigator < "u" && typeof navigator.userAgent < "u" ? navigator.userAgent.toLowerCase() : "", FIREFOX = ua.includes("firefox"), SAFARI = ua.includes("safari") && !ua.includes("chrom"), SAFARI_BUG_237906 = SAFARI && (ua.includes("version/15.4") || /cpu (os|iphone os) 15_4 like mac os x/.test(ua)), WEBKIT = ua.includes("webkit") && !ua.includes("edge"), MAC = ua.includes("macintosh"), DEVICE_PIXEL_RATIO = typeof devicePixelRatio < "u" ? devicePixelRatio : 1, WORKER_OFFSCREEN_CANVAS = typeof WorkerGlobalScope < "u" && typeof OffscreenCanvas < "u" && self instanceof WorkerGlobalScope, IMAGE_DECODE = typeof Image < "u" && Image.prototype.decode, PASSIVE_EVENT_LISTENERS = function() {
  let ie = !1;
  try {
    const Z = Object.defineProperty({}, "passive", {
      get: function() {
        ie = !0;
      }
    });
    window.addEventListener("_", null, Z), window.removeEventListener("_", null, Z);
  } catch {
  }
  return ie;
}(), tmp_ = new Array(6);
function create$2() {
  return [1, 0, 0, 1, 0, 0];
}
function reset(ie) {
  return set(ie, 1, 0, 0, 1, 0, 0);
}
function multiply(ie, Z) {
  const ee = ie[0], ae = ie[1], ve = ie[2], ye = ie[3], be = ie[4], Ye = ie[5], Qe = Z[0], Je = Z[1], nt = Z[2], st = Z[3], ot = Z[4], lt = Z[5];
  return ie[0] = ee * Qe + ve * Je, ie[1] = ae * Qe + ye * Je, ie[2] = ee * nt + ve * st, ie[3] = ae * nt + ye * st, ie[4] = ee * ot + ve * lt + be, ie[5] = ae * ot + ye * lt + Ye, ie;
}
function set(ie, Z, ee, ae, ve, ye, be) {
  return ie[0] = Z, ie[1] = ee, ie[2] = ae, ie[3] = ve, ie[4] = ye, ie[5] = be, ie;
}
function setFromArray(ie, Z) {
  return ie[0] = Z[0], ie[1] = Z[1], ie[2] = Z[2], ie[3] = Z[3], ie[4] = Z[4], ie[5] = Z[5], ie;
}
function apply(ie, Z) {
  const ee = Z[0], ae = Z[1];
  return Z[0] = ie[0] * ee + ie[2] * ae + ie[4], Z[1] = ie[1] * ee + ie[3] * ae + ie[5], Z;
}
function rotate$3(ie, Z) {
  const ee = Math.cos(Z), ae = Math.sin(Z);
  return multiply(ie, set(tmp_, ee, ae, -ae, ee, 0, 0));
}
function scale$3(ie, Z, ee) {
  return multiply(ie, set(tmp_, Z, 0, 0, ee, 0, 0));
}
function translate$1(ie, Z, ee) {
  return multiply(ie, set(tmp_, 1, 0, 0, 1, Z, ee));
}
function compose$1(ie, Z, ee, ae, ve, ye, be, Ye) {
  const Qe = Math.sin(ye), Je = Math.cos(ye);
  return ie[0] = ae * Je, ie[1] = ve * Qe, ie[2] = -ae * Qe, ie[3] = ve * Je, ie[4] = be * ae * Je - Ye * ae * Qe + Z, ie[5] = be * ve * Qe + Ye * ve * Je + ee, ie;
}
function makeInverse(ie, Z) {
  const ee = determinant(Z);
  assert(ee !== 0, "Transformation matrix cannot be inverted");
  const ae = Z[0], ve = Z[1], ye = Z[2], be = Z[3], Ye = Z[4], Qe = Z[5];
  return ie[0] = be / ee, ie[1] = -ve / ee, ie[2] = -ye / ee, ie[3] = ae / ee, ie[4] = (ye * Qe - be * Ye) / ee, ie[5] = -(ae * Qe - ve * Ye) / ee, ie;
}
function determinant(ie) {
  return ie[0] * ie[3] - ie[1] * ie[2];
}
let transformStringDiv;
function toString$1(ie) {
  const Z = "matrix(" + ie.join(", ") + ")";
  if (WORKER_OFFSCREEN_CANVAS)
    return Z;
  const ee = transformStringDiv || (transformStringDiv = document.createElement("div"));
  return ee.style.transform = Z, ee.style.transform;
}
const Relationship = {
  UNKNOWN: 0,
  INTERSECTING: 1,
  ABOVE: 2,
  RIGHT: 4,
  BELOW: 8,
  LEFT: 16
};
function boundingExtent(ie) {
  const Z = createEmpty();
  for (let ee = 0, ae = ie.length; ee < ae; ++ee)
    extendCoordinate(Z, ie[ee]);
  return Z;
}
function _boundingExtentXYs(ie, Z, ee) {
  const ae = Math.min.apply(null, ie), ve = Math.min.apply(null, Z), ye = Math.max.apply(null, ie), be = Math.max.apply(null, Z);
  return createOrUpdate$2(ae, ve, ye, be, ee);
}
function buffer$1(ie, Z, ee) {
  return ee ? (ee[0] = ie[0] - Z, ee[1] = ie[1] - Z, ee[2] = ie[2] + Z, ee[3] = ie[3] + Z, ee) : [
    ie[0] - Z,
    ie[1] - Z,
    ie[2] + Z,
    ie[3] + Z
  ];
}
function clone(ie, Z) {
  return Z ? (Z[0] = ie[0], Z[1] = ie[1], Z[2] = ie[2], Z[3] = ie[3], Z) : ie.slice();
}
function closestSquaredDistanceXY(ie, Z, ee) {
  let ae, ve;
  return Z < ie[0] ? ae = ie[0] - Z : ie[2] < Z ? ae = Z - ie[2] : ae = 0, ee < ie[1] ? ve = ie[1] - ee : ie[3] < ee ? ve = ee - ie[3] : ve = 0, ae * ae + ve * ve;
}
function containsCoordinate(ie, Z) {
  return containsXY(ie, Z[0], Z[1]);
}
function containsExtent(ie, Z) {
  return ie[0] <= Z[0] && Z[2] <= ie[2] && ie[1] <= Z[1] && Z[3] <= ie[3];
}
function containsXY(ie, Z, ee) {
  return ie[0] <= Z && Z <= ie[2] && ie[1] <= ee && ee <= ie[3];
}
function coordinateRelationship(ie, Z) {
  const ee = ie[0], ae = ie[1], ve = ie[2], ye = ie[3], be = Z[0], Ye = Z[1];
  let Qe = Relationship.UNKNOWN;
  return be < ee ? Qe = Qe | Relationship.LEFT : be > ve && (Qe = Qe | Relationship.RIGHT), Ye < ae ? Qe = Qe | Relationship.BELOW : Ye > ye && (Qe = Qe | Relationship.ABOVE), Qe === Relationship.UNKNOWN && (Qe = Relationship.INTERSECTING), Qe;
}
function createEmpty() {
  return [1 / 0, 1 / 0, -1 / 0, -1 / 0];
}
function createOrUpdate$2(ie, Z, ee, ae, ve) {
  return ve ? (ve[0] = ie, ve[1] = Z, ve[2] = ee, ve[3] = ae, ve) : [ie, Z, ee, ae];
}
function createOrUpdateEmpty(ie) {
  return createOrUpdate$2(1 / 0, 1 / 0, -1 / 0, -1 / 0, ie);
}
function createOrUpdateFromCoordinate(ie, Z) {
  const ee = ie[0], ae = ie[1];
  return createOrUpdate$2(ee, ae, ee, ae, Z);
}
function createOrUpdateFromFlatCoordinates(ie, Z, ee, ae, ve) {
  const ye = createOrUpdateEmpty(ve);
  return extendFlatCoordinates(ye, ie, Z, ee, ae);
}
function equals$1(ie, Z) {
  return ie[0] == Z[0] && ie[2] == Z[2] && ie[1] == Z[1] && ie[3] == Z[3];
}
function extend$1(ie, Z) {
  return Z[0] < ie[0] && (ie[0] = Z[0]), Z[2] > ie[2] && (ie[2] = Z[2]), Z[1] < ie[1] && (ie[1] = Z[1]), Z[3] > ie[3] && (ie[3] = Z[3]), ie;
}
function extendCoordinate(ie, Z) {
  Z[0] < ie[0] && (ie[0] = Z[0]), Z[0] > ie[2] && (ie[2] = Z[0]), Z[1] < ie[1] && (ie[1] = Z[1]), Z[1] > ie[3] && (ie[3] = Z[1]);
}
function extendFlatCoordinates(ie, Z, ee, ae, ve) {
  for (; ee < ae; ee += ve)
    extendXY(ie, Z[ee], Z[ee + 1]);
  return ie;
}
function extendXY(ie, Z, ee) {
  ie[0] = Math.min(ie[0], Z), ie[1] = Math.min(ie[1], ee), ie[2] = Math.max(ie[2], Z), ie[3] = Math.max(ie[3], ee);
}
function forEachCorner(ie, Z) {
  let ee;
  return ee = Z(getBottomLeft(ie)), ee || (ee = Z(getBottomRight(ie)), ee) || (ee = Z(getTopRight(ie)), ee) || (ee = Z(getTopLeft(ie)), ee) ? ee : !1;
}
function getArea(ie) {
  let Z = 0;
  return isEmpty(ie) || (Z = getWidth(ie) * getHeight(ie)), Z;
}
function getBottomLeft(ie) {
  return [ie[0], ie[1]];
}
function getBottomRight(ie) {
  return [ie[2], ie[1]];
}
function getCenter(ie) {
  return [(ie[0] + ie[2]) / 2, (ie[1] + ie[3]) / 2];
}
function getCorner(ie, Z) {
  let ee;
  if (Z === "bottom-left")
    ee = getBottomLeft(ie);
  else if (Z === "bottom-right")
    ee = getBottomRight(ie);
  else if (Z === "top-left")
    ee = getTopLeft(ie);
  else if (Z === "top-right")
    ee = getTopRight(ie);
  else
    throw new Error("Invalid corner");
  return ee;
}
function getForViewAndSize(ie, Z, ee, ae, ve) {
  const [ye, be, Ye, Qe, Je, nt, st, ot] = getRotatedViewport(
    ie,
    Z,
    ee,
    ae
  );
  return createOrUpdate$2(
    Math.min(ye, Ye, Je, st),
    Math.min(be, Qe, nt, ot),
    Math.max(ye, Ye, Je, st),
    Math.max(be, Qe, nt, ot),
    ve
  );
}
function getRotatedViewport(ie, Z, ee, ae) {
  const ve = Z * ae[0] / 2, ye = Z * ae[1] / 2, be = Math.cos(ee), Ye = Math.sin(ee), Qe = ve * be, Je = ve * Ye, nt = ye * be, st = ye * Ye, ot = ie[0], lt = ie[1];
  return [
    ot - Qe + st,
    lt - Je - nt,
    ot - Qe - st,
    lt - Je + nt,
    ot + Qe - st,
    lt + Je + nt,
    ot + Qe + st,
    lt + Je - nt,
    ot - Qe + st,
    lt - Je - nt
  ];
}
function getHeight(ie) {
  return ie[3] - ie[1];
}
function getIntersection(ie, Z, ee) {
  const ae = ee || createEmpty();
  return intersects$1(ie, Z) ? (ie[0] > Z[0] ? ae[0] = ie[0] : ae[0] = Z[0], ie[1] > Z[1] ? ae[1] = ie[1] : ae[1] = Z[1], ie[2] < Z[2] ? ae[2] = ie[2] : ae[2] = Z[2], ie[3] < Z[3] ? ae[3] = ie[3] : ae[3] = Z[3]) : createOrUpdateEmpty(ae), ae;
}
function getTopLeft(ie) {
  return [ie[0], ie[3]];
}
function getTopRight(ie) {
  return [ie[2], ie[3]];
}
function getWidth(ie) {
  return ie[2] - ie[0];
}
function intersects$1(ie, Z) {
  return ie[0] <= Z[2] && ie[2] >= Z[0] && ie[1] <= Z[3] && ie[3] >= Z[1];
}
function isEmpty(ie) {
  return ie[2] < ie[0] || ie[3] < ie[1];
}
function returnOrUpdate(ie, Z) {
  return Z ? (Z[0] = ie[0], Z[1] = ie[1], Z[2] = ie[2], Z[3] = ie[3], Z) : ie;
}
function intersectsSegment(ie, Z, ee) {
  let ae = !1;
  const ve = coordinateRelationship(ie, Z), ye = coordinateRelationship(ie, ee);
  if (ve === Relationship.INTERSECTING || ye === Relationship.INTERSECTING)
    ae = !0;
  else {
    const be = ie[0], Ye = ie[1], Qe = ie[2], Je = ie[3], nt = Z[0], st = Z[1], ot = ee[0], lt = ee[1], ft = (lt - st) / (ot - nt);
    let gt, ct;
    ye & Relationship.ABOVE && !(ve & Relationship.ABOVE) && (gt = ot - (lt - Je) / ft, ae = gt >= be && gt <= Qe), !ae && ye & Relationship.RIGHT && !(ve & Relationship.RIGHT) && (ct = lt - (ot - Qe) * ft, ae = ct >= Ye && ct <= Je), !ae && ye & Relationship.BELOW && !(ve & Relationship.BELOW) && (gt = ot - (lt - Ye) / ft, ae = gt >= be && gt <= Qe), !ae && ye & Relationship.LEFT && !(ve & Relationship.LEFT) && (ct = lt - (ot - be) * ft, ae = ct >= Ye && ct <= Je);
  }
  return ae;
}
function applyTransform(ie, Z, ee, ae) {
  if (isEmpty(ie))
    return createOrUpdateEmpty(ee);
  let ve = [];
  if (ae > 1) {
    const Ye = ie[2] - ie[0], Qe = ie[3] - ie[1];
    for (let Je = 0; Je < ae; ++Je)
      ve.push(
        ie[0] + Ye * Je / ae,
        ie[1],
        ie[2],
        ie[1] + Qe * Je / ae,
        ie[2] - Ye * Je / ae,
        ie[3],
        ie[0],
        ie[3] - Qe * Je / ae
      );
  } else
    ve = [
      ie[0],
      ie[1],
      ie[2],
      ie[1],
      ie[2],
      ie[3],
      ie[0],
      ie[3]
    ];
  Z(ve, ve, 2);
  const ye = [], be = [];
  for (let Ye = 0, Qe = ve.length; Ye < Qe; Ye += 2)
    ye.push(ve[Ye]), be.push(ve[Ye + 1]);
  return _boundingExtentXYs(ye, be, ee);
}
const unitByCode = {
  9001: "m",
  9002: "ft",
  9003: "us-ft",
  9101: "radians",
  9102: "degrees"
};
function fromCode(ie) {
  return unitByCode[ie];
}
const METERS_PER_UNIT$1 = {
  // use the radius of the Normal sphere
  radians: 6370997 / (2 * Math.PI),
  degrees: 2 * Math.PI * 6370997 / 360,
  ft: 0.3048,
  m: 1,
  "us-ft": 1200 / 3937
};
class Projection {
  /**
   * @param {Options} options Projection options.
   */
  constructor(Z) {
    this.code_ = Z.code, this.units_ = /** @type {import("./Units.js").Units} */
    Z.units, this.extent_ = Z.extent !== void 0 ? Z.extent : null, this.worldExtent_ = Z.worldExtent !== void 0 ? Z.worldExtent : null, this.axisOrientation_ = Z.axisOrientation !== void 0 ? Z.axisOrientation : "enu", this.global_ = Z.global !== void 0 ? Z.global : !1, this.canWrapX_ = !!(this.global_ && this.extent_), this.getPointResolutionFunc_ = Z.getPointResolution, this.defaultTileGrid_ = null, this.metersPerUnit_ = Z.metersPerUnit;
  }
  /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */
  canWrapX() {
    return this.canWrapX_;
  }
  /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */
  getCode() {
    return this.code_;
  }
  /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getExtent() {
    return this.extent_;
  }
  /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */
  getUnits() {
    return this.units_;
  }
  /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */
  getMetersPerUnit() {
    return this.metersPerUnit_ || METERS_PER_UNIT$1[this.units_];
  }
  /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getWorldExtent() {
    return this.worldExtent_;
  }
  /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */
  getAxisOrientation() {
    return this.axisOrientation_;
  }
  /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */
  isGlobal() {
    return this.global_;
  }
  /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */
  setGlobal(Z) {
    this.global_ = Z, this.canWrapX_ = !!(Z && this.extent_);
  }
  /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */
  getDefaultTileGrid() {
    return this.defaultTileGrid_;
  }
  /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */
  setDefaultTileGrid(Z) {
    this.defaultTileGrid_ = Z;
  }
  /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */
  setExtent(Z) {
    this.extent_ = Z, this.canWrapX_ = !!(this.global_ && Z);
  }
  /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */
  setWorldExtent(Z) {
    this.worldExtent_ = Z;
  }
  /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */
  setGetPointResolution(Z) {
    this.getPointResolutionFunc_ = Z;
  }
  /**
   * Get the custom point resolution function for this projection (if set).
   * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
   * resolution function (if set).
   */
  getPointResolutionFunc() {
    return this.getPointResolutionFunc_;
  }
}
const RADIUS$1 = 6378137, HALF_SIZE = Math.PI * RADIUS$1, EXTENT$1 = [-HALF_SIZE, -HALF_SIZE, HALF_SIZE, HALF_SIZE], WORLD_EXTENT = [-180, -85, 180, 85], MAX_SAFE_Y = RADIUS$1 * Math.log(Math.tan(Math.PI / 2));
class EPSG3857Projection extends Projection {
  /**
   * @param {string} code Code.
   */
  constructor(Z) {
    super({
      code: Z,
      units: "m",
      extent: EXTENT$1,
      global: !0,
      worldExtent: WORLD_EXTENT,
      getPointResolution: function(ee, ae) {
        return ee / Math.cosh(ae[1] / RADIUS$1);
      }
    });
  }
}
const PROJECTIONS$1 = [
  new EPSG3857Projection("EPSG:3857"),
  new EPSG3857Projection("EPSG:102100"),
  new EPSG3857Projection("EPSG:102113"),
  new EPSG3857Projection("EPSG:900913"),
  new EPSG3857Projection("http://www.opengis.net/def/crs/EPSG/0/3857"),
  new EPSG3857Projection("http://www.opengis.net/gml/srs/epsg.xml#3857")
];
function fromEPSG4326(ie, Z, ee) {
  const ae = ie.length;
  ee = ee > 1 ? ee : 2, Z === void 0 && (ee > 2 ? Z = ie.slice() : Z = new Array(ae));
  for (let ve = 0; ve < ae; ve += ee) {
    Z[ve] = HALF_SIZE * ie[ve] / 180;
    let ye = RADIUS$1 * Math.log(Math.tan(Math.PI * (+ie[ve + 1] + 90) / 360));
    ye > MAX_SAFE_Y ? ye = MAX_SAFE_Y : ye < -MAX_SAFE_Y && (ye = -MAX_SAFE_Y), Z[ve + 1] = ye;
  }
  return Z;
}
function toEPSG4326(ie, Z, ee) {
  const ae = ie.length;
  ee = ee > 1 ? ee : 2, Z === void 0 && (ee > 2 ? Z = ie.slice() : Z = new Array(ae));
  for (let ve = 0; ve < ae; ve += ee)
    Z[ve] = 180 * ie[ve] / HALF_SIZE, Z[ve + 1] = 360 * Math.atan(Math.exp(ie[ve + 1] / RADIUS$1)) / Math.PI - 90;
  return Z;
}
const RADIUS = 6378137, EXTENT = [-180, -90, 180, 90], METERS_PER_UNIT = Math.PI * RADIUS / 180;
class EPSG4326Projection extends Projection {
  /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */
  constructor(Z, ee) {
    super({
      code: Z,
      units: "degrees",
      extent: EXTENT,
      axisOrientation: ee,
      global: !0,
      metersPerUnit: METERS_PER_UNIT,
      worldExtent: EXTENT
    });
  }
}
const PROJECTIONS = [
  new EPSG4326Projection("CRS:84"),
  new EPSG4326Projection("EPSG:4326", "neu"),
  new EPSG4326Projection("urn:ogc:def:crs:OGC:1.3:CRS84"),
  new EPSG4326Projection("urn:ogc:def:crs:OGC:2:84"),
  new EPSG4326Projection("http://www.opengis.net/def/crs/OGC/1.3/CRS84"),
  new EPSG4326Projection("http://www.opengis.net/gml/srs/epsg.xml#4326", "neu"),
  new EPSG4326Projection("http://www.opengis.net/def/crs/EPSG/0/4326", "neu")
];
let cache = {};
function get$3(ie) {
  return cache[ie] || cache[ie.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, "EPSG:$3")] || null;
}
function add$2(ie, Z) {
  cache[ie] = Z;
}
let transforms = {};
function add$1(ie, Z, ee) {
  const ae = ie.getCode(), ve = Z.getCode();
  ae in transforms || (transforms[ae] = {}), transforms[ae][ve] = ee;
}
function get$2(ie, Z) {
  let ee;
  return ie in transforms && Z in transforms[ie] && (ee = transforms[ie][Z]), ee;
}
function clamp$1(ie, Z, ee) {
  return Math.min(Math.max(ie, Z), ee);
}
function squaredSegmentDistance(ie, Z, ee, ae, ve, ye) {
  const be = ve - ee, Ye = ye - ae;
  if (be !== 0 || Ye !== 0) {
    const Qe = ((ie - ee) * be + (Z - ae) * Ye) / (be * be + Ye * Ye);
    Qe > 1 ? (ee = ve, ae = ye) : Qe > 0 && (ee += be * Qe, ae += Ye * Qe);
  }
  return squaredDistance(ie, Z, ee, ae);
}
function squaredDistance(ie, Z, ee, ae) {
  const ve = ee - ie, ye = ae - Z;
  return ve * ve + ye * ye;
}
function solveLinearSystem(ie) {
  const Z = ie.length;
  for (let ae = 0; ae < Z; ae++) {
    let ve = ae, ye = Math.abs(ie[ae][ae]);
    for (let Ye = ae + 1; Ye < Z; Ye++) {
      const Qe = Math.abs(ie[Ye][ae]);
      Qe > ye && (ye = Qe, ve = Ye);
    }
    if (ye === 0)
      return null;
    const be = ie[ve];
    ie[ve] = ie[ae], ie[ae] = be;
    for (let Ye = ae + 1; Ye < Z; Ye++) {
      const Qe = -ie[Ye][ae] / ie[ae][ae];
      for (let Je = ae; Je < Z + 1; Je++)
        ae == Je ? ie[Ye][Je] = 0 : ie[Ye][Je] += Qe * ie[ae][Je];
    }
  }
  const ee = new Array(Z);
  for (let ae = Z - 1; ae >= 0; ae--) {
    ee[ae] = ie[ae][Z] / ie[ae][ae];
    for (let ve = ae - 1; ve >= 0; ve--)
      ie[ve][Z] -= ie[ve][ae] * ee[ae];
  }
  return ee;
}
function toRadians(ie) {
  return ie * Math.PI / 180;
}
function modulo(ie, Z) {
  const ee = ie % Z;
  return ee * Z < 0 ? ee + Z : ee;
}
function lerp$1(ie, Z, ee) {
  return ie + ee * (Z - ie);
}
function toFixed(ie, Z) {
  const ee = Math.pow(10, Z);
  return Math.round(ie * ee) / ee;
}
function floor$1(ie, Z) {
  return Math.floor(toFixed(ie, Z));
}
function ceil(ie, Z) {
  return Math.ceil(toFixed(ie, Z));
}
function add(ie, Z) {
  return ie[0] += +Z[0], ie[1] += +Z[1], ie;
}
function equals(ie, Z) {
  let ee = !0;
  for (let ae = ie.length - 1; ae >= 0; --ae)
    if (ie[ae] != Z[ae]) {
      ee = !1;
      break;
    }
  return ee;
}
function rotate$2(ie, Z) {
  const ee = Math.cos(Z), ae = Math.sin(Z), ve = ie[0] * ee - ie[1] * ae, ye = ie[1] * ee + ie[0] * ae;
  return ie[0] = ve, ie[1] = ye, ie;
}
function scale$2(ie, Z) {
  return ie[0] *= Z, ie[1] *= Z, ie;
}
function wrapX$1(ie, Z) {
  if (Z.canWrapX()) {
    const ee = getWidth(Z.getExtent()), ae = getWorldsAway(ie, Z, ee);
    ae && (ie[0] -= ae * ee);
  }
  return ie;
}
function getWorldsAway(ie, Z, ee) {
  const ae = Z.getExtent();
  let ve = 0;
  return Z.canWrapX() && (ie[0] < ae[0] || ie[0] > ae[2]) && (ee = ee || getWidth(ae), ve = Math.floor(
    (ie[0] - ae[0]) / ee
  )), ve;
}
const DEFAULT_RADIUS = 63710088e-1;
function getDistance(ie, Z, ee) {
  ee = ee || DEFAULT_RADIUS;
  const ae = toRadians(ie[1]), ve = toRadians(Z[1]), ye = (ve - ae) / 2, be = toRadians(Z[0] - ie[0]) / 2, Ye = Math.sin(ye) * Math.sin(ye) + Math.sin(be) * Math.sin(be) * Math.cos(ae) * Math.cos(ve);
  return 2 * ee * Math.atan2(Math.sqrt(Ye), Math.sqrt(1 - Ye));
}
const levels = {
  info: 1,
  warn: 2,
  error: 3,
  none: 4
};
let level = levels.info;
function warn(...ie) {
  console.warn(...ie);
}
function error(...ie) {
  level > levels.error || console.error(...ie);
}
let showCoordinateWarning = !0;
function disableCoordinateWarning(ie) {
  showCoordinateWarning = !(ie === void 0 ? !0 : ie);
}
function cloneTransform(ie, Z) {
  if (Z !== void 0) {
    for (let ee = 0, ae = ie.length; ee < ae; ++ee)
      Z[ee] = ie[ee];
    Z = Z;
  } else
    Z = ie.slice();
  return Z;
}
function identityTransform(ie, Z) {
  if (Z !== void 0 && ie !== Z) {
    for (let ee = 0, ae = ie.length; ee < ae; ++ee)
      Z[ee] = ie[ee];
    ie = Z;
  }
  return ie;
}
function addProjection(ie) {
  add$2(ie.getCode(), ie), add$1(ie, ie, cloneTransform);
}
function addProjections(ie) {
  ie.forEach(addProjection);
}
function get$1(ie) {
  return typeof ie == "string" ? get$3(
    /** @type {string} */
    ie
  ) : (
    /** @type {Projection} */
    ie || null
  );
}
function getPointResolution(ie, Z, ee, ae) {
  ie = get$1(ie);
  let ve;
  const ye = ie.getPointResolutionFunc();
  if (ye) {
    if (ve = ye(Z, ee), ae && ae !== ie.getUnits()) {
      const be = ie.getMetersPerUnit();
      be && (ve = ve * be / METERS_PER_UNIT$1[ae]);
    }
  } else {
    const be = ie.getUnits();
    if (be == "degrees" && !ae || ae == "degrees")
      ve = Z;
    else {
      const Ye = getTransformFromProjections(
        ie,
        get$1("EPSG:4326")
      );
      if (Ye === identityTransform && be !== "degrees")
        ve = Z * ie.getMetersPerUnit();
      else {
        let Je = [
          ee[0] - Z / 2,
          ee[1],
          ee[0] + Z / 2,
          ee[1],
          ee[0],
          ee[1] - Z / 2,
          ee[0],
          ee[1] + Z / 2
        ];
        Je = Ye(Je, Je, 2);
        const nt = getDistance(Je.slice(0, 2), Je.slice(2, 4)), st = getDistance(Je.slice(4, 6), Je.slice(6, 8));
        ve = (nt + st) / 2;
      }
      const Qe = ae ? METERS_PER_UNIT$1[ae] : ie.getMetersPerUnit();
      Qe !== void 0 && (ve /= Qe);
    }
  }
  return ve;
}
function addEquivalentProjections(ie) {
  addProjections(ie), ie.forEach(function(Z) {
    ie.forEach(function(ee) {
      Z !== ee && add$1(Z, ee, cloneTransform);
    });
  });
}
function addEquivalentTransforms(ie, Z, ee, ae) {
  ie.forEach(function(ve) {
    Z.forEach(function(ye) {
      add$1(ve, ye, ee), add$1(ye, ve, ae);
    });
  });
}
function createProjection(ie, Z) {
  return ie ? typeof ie == "string" ? get$1(ie) : (
    /** @type {Projection} */
    ie
  ) : get$1(Z);
}
function equivalent(ie, Z) {
  if (ie === Z)
    return !0;
  const ee = ie.getUnits() === Z.getUnits();
  return (ie.getCode() === Z.getCode() || getTransformFromProjections(ie, Z) === cloneTransform) && ee;
}
function getTransformFromProjections(ie, Z) {
  const ee = ie.getCode(), ae = Z.getCode();
  let ve = get$2(ee, ae);
  return ve || (ve = identityTransform), ve;
}
function getTransform(ie, Z) {
  const ee = get$1(ie), ae = get$1(Z);
  return getTransformFromProjections(ee, ae);
}
function transform(ie, Z, ee) {
  return getTransform(Z, ee)(ie, void 0, ie.length);
}
function transformExtent(ie, Z, ee, ae) {
  const ve = getTransform(Z, ee);
  return applyTransform(ie, ve, void 0, ae);
}
let userProjection = null;
function setUserProjection(ie) {
  userProjection = get$1(ie);
}
function getUserProjection() {
  return userProjection;
}
function useGeographic() {
  setUserProjection("EPSG:4326");
}
function toUserCoordinate(ie, Z) {
  return userProjection ? transform(ie, Z, userProjection) : ie;
}
function fromUserCoordinate(ie, Z) {
  return userProjection ? transform(ie, userProjection, Z) : (showCoordinateWarning && !equals(ie, [0, 0]) && ie[0] >= -180 && ie[0] <= 180 && ie[1] >= -90 && ie[1] <= 90 && (showCoordinateWarning = !1, warn(
    "Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates."
  )), ie);
}
function toUserExtent(ie, Z) {
  return userProjection ? transformExtent(ie, Z, userProjection) : ie;
}
function fromUserExtent(ie, Z) {
  return userProjection ? transformExtent(ie, userProjection, Z) : ie;
}
function addCommon() {
  addEquivalentProjections(PROJECTIONS$1), addEquivalentProjections(PROJECTIONS), addEquivalentTransforms(
    PROJECTIONS,
    PROJECTIONS$1,
    fromEPSG4326,
    toEPSG4326
  );
}
addCommon();
function transform2D(ie, Z, ee, ae, ve, ye) {
  ye = ye || [];
  let be = 0;
  for (let Ye = Z; Ye < ee; Ye += ae) {
    const Qe = ie[Ye], Je = ie[Ye + 1];
    ye[be++] = ve[0] * Qe + ve[2] * Je + ve[4], ye[be++] = ve[1] * Qe + ve[3] * Je + ve[5];
  }
  return ye && ye.length != be && (ye.length = be), ye;
}
function rotate$1(ie, Z, ee, ae, ve, ye, be) {
  be = be || [];
  const Ye = Math.cos(ve), Qe = Math.sin(ve), Je = ye[0], nt = ye[1];
  let st = 0;
  for (let ot = Z; ot < ee; ot += ae) {
    const lt = ie[ot] - Je, ft = ie[ot + 1] - nt;
    be[st++] = Je + lt * Ye - ft * Qe, be[st++] = nt + lt * Qe + ft * Ye;
    for (let gt = ot + 2; gt < ot + ae; ++gt)
      be[st++] = ie[gt];
  }
  return be && be.length != st && (be.length = st), be;
}
function scale$1(ie, Z, ee, ae, ve, ye, be, Ye) {
  Ye = Ye || [];
  const Qe = be[0], Je = be[1];
  let nt = 0;
  for (let st = Z; st < ee; st += ae) {
    const ot = ie[st] - Qe, lt = ie[st + 1] - Je;
    Ye[nt++] = Qe + ve * ot, Ye[nt++] = Je + ye * lt;
    for (let ft = st + 2; ft < st + ae; ++ft)
      Ye[nt++] = ie[ft];
  }
  return Ye && Ye.length != nt && (Ye.length = nt), Ye;
}
function translate(ie, Z, ee, ae, ve, ye, be) {
  be = be || [];
  let Ye = 0;
  for (let Qe = Z; Qe < ee; Qe += ae) {
    be[Ye++] = ie[Qe] + ve, be[Ye++] = ie[Qe + 1] + ye;
    for (let Je = Qe + 2; Je < Qe + ae; ++Je)
      be[Ye++] = ie[Je];
  }
  return be && be.length != Ye && (be.length = Ye), be;
}
const tmpTransform$1 = create$2();
class Geometry extends BaseObject {
  constructor() {
    super(), this.extent_ = createEmpty(), this.extentRevision_ = -1, this.simplifiedGeometryMaxMinSquaredTolerance = 0, this.simplifiedGeometryRevision = 0, this.simplifyTransformedInternal = memoizeOne(function(Z, ee, ae) {
      if (!ae)
        return this.getSimplifiedGeometry(ee);
      const ve = this.clone();
      return ve.applyTransform(ae), ve.getSimplifiedGeometry(ee);
    });
  }
  /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */
  simplifyTransformed(Z, ee) {
    return this.simplifyTransformedInternal(
      this.getRevision(),
      Z,
      ee
    );
  }
  /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */
  clone() {
    return abstract();
  }
  /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */
  closestPointXY(Z, ee, ae, ve) {
    return abstract();
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */
  containsXY(Z, ee) {
    const ae = this.getClosestPoint([Z, ee]);
    return ae[0] === Z && ae[1] === ee;
  }
  /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */
  getClosestPoint(Z, ee) {
    return ee = ee || [NaN, NaN], this.closestPointXY(Z[0], Z[1], ee, 1 / 0), ee;
  }
  /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */
  intersectsCoordinate(Z) {
    return this.containsXY(Z[0], Z[1]);
  }
  /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */
  computeExtent(Z) {
    return abstract();
  }
  /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */
  getExtent(Z) {
    if (this.extentRevision_ != this.getRevision()) {
      const ee = this.computeExtent(this.extent_);
      (isNaN(ee[0]) || isNaN(ee[1])) && createOrUpdateEmpty(ee), this.extentRevision_ = this.getRevision();
    }
    return returnOrUpdate(this.extent_, Z);
  }
  /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */
  rotate(Z, ee) {
    abstract();
  }
  /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */
  scale(Z, ee, ae) {
    abstract();
  }
  /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */
  simplify(Z) {
    return this.getSimplifiedGeometry(Z * Z);
  }
  /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */
  getSimplifiedGeometry(Z) {
    return abstract();
  }
  /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */
  getType() {
    return abstract();
  }
  /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */
  applyTransform(Z) {
    abstract();
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */
  intersectsExtent(Z) {
    return abstract();
  }
  /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */
  translate(Z, ee) {
    abstract();
  }
  /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {Geometry} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */
  transform(Z, ee) {
    const ae = get$1(Z), ve = ae.getUnits() == "tile-pixels" ? function(ye, be, Ye) {
      const Qe = ae.getExtent(), Je = ae.getWorldExtent(), nt = getHeight(Je) / getHeight(Qe);
      return compose$1(
        tmpTransform$1,
        Je[0],
        Je[3],
        nt,
        -nt,
        0,
        0,
        0
      ), transform2D(
        ye,
        0,
        ye.length,
        Ye,
        tmpTransform$1,
        be
      ), getTransform(ae, ee)(
        ye,
        be,
        Ye
      );
    } : getTransform(ae, ee);
    return this.applyTransform(ve), this;
  }
}
class SimpleGeometry extends Geometry {
  constructor() {
    super(), this.layout = "XY", this.stride = 2, this.flatCoordinates = null;
  }
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */
  computeExtent(Z) {
    return createOrUpdateFromFlatCoordinates(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      Z
    );
  }
  /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */
  getCoordinates() {
    return abstract();
  }
  /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */
  getFirstCoordinate() {
    return this.flatCoordinates.slice(0, this.stride);
  }
  /**
   * @return {Array<number>} Flat coordinates.
   */
  getFlatCoordinates() {
    return this.flatCoordinates;
  }
  /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */
  getLastCoordinate() {
    return this.flatCoordinates.slice(
      this.flatCoordinates.length - this.stride
    );
  }
  /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */
  getLayout() {
    return this.layout;
  }
  /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   */
  getSimplifiedGeometry(Z) {
    if (this.simplifiedGeometryRevision !== this.getRevision() && (this.simplifiedGeometryMaxMinSquaredTolerance = 0, this.simplifiedGeometryRevision = this.getRevision()), Z < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && Z <= this.simplifiedGeometryMaxMinSquaredTolerance)
      return this;
    const ee = this.getSimplifiedGeometryInternal(Z);
    return ee.getFlatCoordinates().length < this.flatCoordinates.length ? ee : (this.simplifiedGeometryMaxMinSquaredTolerance = Z, this);
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */
  getSimplifiedGeometryInternal(Z) {
    return this;
  }
  /**
   * @return {number} Stride.
   */
  getStride() {
    return this.stride;
  }
  /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */
  setFlatCoordinates(Z, ee) {
    this.stride = getStrideForLayout(Z), this.layout = Z, this.flatCoordinates = ee;
  }
  /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */
  setCoordinates(Z, ee) {
    abstract();
  }
  /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */
  setLayout(Z, ee, ae) {
    let ve;
    if (Z)
      ve = getStrideForLayout(Z);
    else {
      for (let ye = 0; ye < ae; ++ye) {
        if (ee.length === 0) {
          this.layout = "XY", this.stride = 2;
          return;
        }
        ee = /** @type {Array} */
        ee[0];
      }
      ve = ee.length, Z = getLayoutForStride(ve);
    }
    this.layout = Z, this.stride = ve;
  }
  /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   */
  applyTransform(Z) {
    this.flatCoordinates && (Z(this.flatCoordinates, this.flatCoordinates, this.stride), this.changed());
  }
  /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */
  rotate(Z, ee) {
    const ae = this.getFlatCoordinates();
    if (ae) {
      const ve = this.getStride();
      rotate$1(
        ae,
        0,
        ae.length,
        ve,
        Z,
        ee,
        ae
      ), this.changed();
    }
  }
  /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */
  scale(Z, ee, ae) {
    ee === void 0 && (ee = Z), ae || (ae = getCenter(this.getExtent()));
    const ve = this.getFlatCoordinates();
    if (ve) {
      const ye = this.getStride();
      scale$1(
        ve,
        0,
        ve.length,
        ye,
        Z,
        ee,
        ae,
        ve
      ), this.changed();
    }
  }
  /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */
  translate(Z, ee) {
    const ae = this.getFlatCoordinates();
    if (ae) {
      const ve = this.getStride();
      translate(
        ae,
        0,
        ae.length,
        ve,
        Z,
        ee,
        ae
      ), this.changed();
    }
  }
}
function getLayoutForStride(ie) {
  let Z;
  return ie == 2 ? Z = "XY" : ie == 3 ? Z = "XYZ" : ie == 4 && (Z = "XYZM"), /** @type {import("./Geometry.js").GeometryLayout} */
  Z;
}
function getStrideForLayout(ie) {
  let Z;
  return ie == "XY" ? Z = 2 : ie == "XYZ" || ie == "XYM" ? Z = 3 : ie == "XYZM" && (Z = 4), /** @type {number} */
  Z;
}
function transformGeom2D(ie, Z, ee) {
  const ae = ie.getFlatCoordinates();
  if (!ae)
    return null;
  const ve = ie.getStride();
  return transform2D(
    ae,
    0,
    ae.length,
    ve,
    Z,
    ee
  );
}
function assignClosest(ie, Z, ee, ae, ve, ye, be) {
  const Ye = ie[Z], Qe = ie[Z + 1], Je = ie[ee] - Ye, nt = ie[ee + 1] - Qe;
  let st;
  if (Je === 0 && nt === 0)
    st = Z;
  else {
    const ot = ((ve - Ye) * Je + (ye - Qe) * nt) / (Je * Je + nt * nt);
    if (ot > 1)
      st = ee;
    else if (ot > 0) {
      for (let lt = 0; lt < ae; ++lt)
        be[lt] = lerp$1(
          ie[Z + lt],
          ie[ee + lt],
          ot
        );
      be.length = ae;
      return;
    } else
      st = Z;
  }
  for (let ot = 0; ot < ae; ++ot)
    be[ot] = ie[st + ot];
  be.length = ae;
}
function maxSquaredDelta(ie, Z, ee, ae, ve) {
  let ye = ie[Z], be = ie[Z + 1];
  for (Z += ae; Z < ee; Z += ae) {
    const Ye = ie[Z], Qe = ie[Z + 1], Je = squaredDistance(ye, be, Ye, Qe);
    Je > ve && (ve = Je), ye = Ye, be = Qe;
  }
  return ve;
}
function arrayMaxSquaredDelta(ie, Z, ee, ae, ve) {
  for (let ye = 0, be = ee.length; ye < be; ++ye) {
    const Ye = ee[ye];
    ve = maxSquaredDelta(ie, Z, Ye, ae, ve), Z = Ye;
  }
  return ve;
}
function multiArrayMaxSquaredDelta(ie, Z, ee, ae, ve) {
  for (let ye = 0, be = ee.length; ye < be; ++ye) {
    const Ye = ee[ye];
    ve = arrayMaxSquaredDelta(ie, Z, Ye, ae, ve), Z = Ye[Ye.length - 1];
  }
  return ve;
}
function assignClosestPoint(ie, Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt) {
  if (Z == ee)
    return Je;
  let st, ot;
  if (ve === 0) {
    if (ot = squaredDistance(
      be,
      Ye,
      ie[Z],
      ie[Z + 1]
    ), ot < Je) {
      for (st = 0; st < ae; ++st)
        Qe[st] = ie[Z + st];
      return Qe.length = ae, ot;
    }
    return Je;
  }
  nt = nt || [NaN, NaN];
  let lt = Z + ae;
  for (; lt < ee; )
    if (assignClosest(
      ie,
      lt - ae,
      lt,
      ae,
      be,
      Ye,
      nt
    ), ot = squaredDistance(be, Ye, nt[0], nt[1]), ot < Je) {
      for (Je = ot, st = 0; st < ae; ++st)
        Qe[st] = nt[st];
      Qe.length = ae, lt += ae;
    } else
      lt += ae * Math.max(
        (Math.sqrt(ot) - Math.sqrt(Je)) / ve | 0,
        1
      );
  if (ye && (assignClosest(
    ie,
    ee - ae,
    Z,
    ae,
    be,
    Ye,
    nt
  ), ot = squaredDistance(be, Ye, nt[0], nt[1]), ot < Je)) {
    for (Je = ot, st = 0; st < ae; ++st)
      Qe[st] = nt[st];
    Qe.length = ae;
  }
  return Je;
}
function assignClosestArrayPoint(ie, Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt) {
  nt = nt || [NaN, NaN];
  for (let st = 0, ot = ee.length; st < ot; ++st) {
    const lt = ee[st];
    Je = assignClosestPoint(
      ie,
      Z,
      lt,
      ae,
      ve,
      ye,
      be,
      Ye,
      Qe,
      Je,
      nt
    ), Z = lt;
  }
  return Je;
}
function assignClosestMultiArrayPoint(ie, Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt) {
  nt = nt || [NaN, NaN];
  for (let st = 0, ot = ee.length; st < ot; ++st) {
    const lt = ee[st];
    Je = assignClosestArrayPoint(
      ie,
      Z,
      lt,
      ae,
      ve,
      ye,
      be,
      Ye,
      Qe,
      Je,
      nt
    ), Z = lt[lt.length - 1];
  }
  return Je;
}
function deflateCoordinate(ie, Z, ee, ae) {
  for (let ve = 0, ye = ee.length; ve < ye; ++ve)
    ie[Z++] = ee[ve];
  return Z;
}
function deflateCoordinates(ie, Z, ee, ae) {
  for (let ve = 0, ye = ee.length; ve < ye; ++ve) {
    const be = ee[ve];
    for (let Ye = 0; Ye < ae; ++Ye)
      ie[Z++] = be[Ye];
  }
  return Z;
}
function deflateCoordinatesArray(ie, Z, ee, ae, ve) {
  ve = ve || [];
  let ye = 0;
  for (let be = 0, Ye = ee.length; be < Ye; ++be) {
    const Qe = deflateCoordinates(
      ie,
      Z,
      ee[be],
      ae
    );
    ve[ye++] = Qe, Z = Qe;
  }
  return ve.length = ye, ve;
}
function deflateMultiCoordinatesArray(ie, Z, ee, ae, ve) {
  ve = ve || [];
  let ye = 0;
  for (let be = 0, Ye = ee.length; be < Ye; ++be) {
    const Qe = deflateCoordinatesArray(
      ie,
      Z,
      ee[be],
      ae,
      ve[ye]
    );
    Qe.length === 0 && (Qe[0] = Z), ve[ye++] = Qe, Z = Qe[Qe.length - 1];
  }
  return ve.length = ye, ve;
}
function douglasPeucker(ie, Z, ee, ae, ve, ye, be) {
  const Ye = (ee - Z) / ae;
  if (Ye < 3) {
    for (; Z < ee; Z += ae)
      ye[be++] = ie[Z], ye[be++] = ie[Z + 1];
    return be;
  }
  const Qe = new Array(Ye);
  Qe[0] = 1, Qe[Ye - 1] = 1;
  const Je = [Z, ee - ae];
  let nt = 0;
  for (; Je.length > 0; ) {
    const st = Je.pop(), ot = Je.pop();
    let lt = 0;
    const ft = ie[ot], gt = ie[ot + 1], ct = ie[st], _r = ie[st + 1];
    for (let Kr = ot + ae; Kr < st; Kr += ae) {
      const Xr = ie[Kr], Jr = ie[Kr + 1], ei = squaredSegmentDistance(Xr, Jr, ft, gt, ct, _r);
      ei > lt && (nt = Kr, lt = ei);
    }
    lt > ve && (Qe[(nt - Z) / ae] = 1, ot + ae < nt && Je.push(ot, nt), nt + ae < st && Je.push(nt, st));
  }
  for (let st = 0; st < Ye; ++st)
    Qe[st] && (ye[be++] = ie[Z + st * ae], ye[be++] = ie[Z + st * ae + 1]);
  return be;
}
function douglasPeuckerArray(ie, Z, ee, ae, ve, ye, be, Ye) {
  for (let Qe = 0, Je = ee.length; Qe < Je; ++Qe) {
    const nt = ee[Qe];
    be = douglasPeucker(
      ie,
      Z,
      nt,
      ae,
      ve,
      ye,
      be
    ), Ye.push(be), Z = nt;
  }
  return be;
}
function snap(ie, Z) {
  return Z * Math.round(ie / Z);
}
function quantize(ie, Z, ee, ae, ve, ye, be) {
  if (Z == ee)
    return be;
  let Ye = snap(ie[Z], ve), Qe = snap(ie[Z + 1], ve);
  Z += ae, ye[be++] = Ye, ye[be++] = Qe;
  let Je, nt;
  do
    if (Je = snap(ie[Z], ve), nt = snap(ie[Z + 1], ve), Z += ae, Z == ee)
      return ye[be++] = Je, ye[be++] = nt, be;
  while (Je == Ye && nt == Qe);
  for (; Z < ee; ) {
    const st = snap(ie[Z], ve), ot = snap(ie[Z + 1], ve);
    if (Z += ae, st == Je && ot == nt)
      continue;
    const lt = Je - Ye, ft = nt - Qe, gt = st - Ye, ct = ot - Qe;
    if (lt * ct == ft * gt && (lt < 0 && gt < lt || lt == gt || lt > 0 && gt > lt) && (ft < 0 && ct < ft || ft == ct || ft > 0 && ct > ft)) {
      Je = st, nt = ot;
      continue;
    }
    ye[be++] = Je, ye[be++] = nt, Ye = Je, Qe = nt, Je = st, nt = ot;
  }
  return ye[be++] = Je, ye[be++] = nt, be;
}
function quantizeArray(ie, Z, ee, ae, ve, ye, be, Ye) {
  for (let Qe = 0, Je = ee.length; Qe < Je; ++Qe) {
    const nt = ee[Qe];
    be = quantize(
      ie,
      Z,
      nt,
      ae,
      ve,
      ye,
      be
    ), Ye.push(be), Z = nt;
  }
  return be;
}
function quantizeMultiArray(ie, Z, ee, ae, ve, ye, be, Ye) {
  for (let Qe = 0, Je = ee.length; Qe < Je; ++Qe) {
    const nt = ee[Qe], st = [];
    be = quantizeArray(
      ie,
      Z,
      nt,
      ae,
      ve,
      ye,
      be,
      st
    ), Ye.push(st), Z = nt[nt.length - 1];
  }
  return be;
}
function inflateCoordinates(ie, Z, ee, ae, ve) {
  ve = ve !== void 0 ? ve : [];
  let ye = 0;
  for (let be = Z; be < ee; be += ae)
    ve[ye++] = ie.slice(be, be + ae);
  return ve.length = ye, ve;
}
function inflateCoordinatesArray(ie, Z, ee, ae, ve) {
  ve = ve !== void 0 ? ve : [];
  let ye = 0;
  for (let be = 0, Ye = ee.length; be < Ye; ++be) {
    const Qe = ee[be];
    ve[ye++] = inflateCoordinates(
      ie,
      Z,
      Qe,
      ae,
      ve[ye]
    ), Z = Qe;
  }
  return ve.length = ye, ve;
}
function inflateMultiCoordinatesArray(ie, Z, ee, ae, ve) {
  ve = ve !== void 0 ? ve : [];
  let ye = 0;
  for (let be = 0, Ye = ee.length; be < Ye; ++be) {
    const Qe = ee[be];
    ve[ye++] = Qe.length === 1 && Qe[0] === Z ? [] : inflateCoordinatesArray(
      ie,
      Z,
      Qe,
      ae,
      ve[ye]
    ), Z = Qe[Qe.length - 1];
  }
  return ve.length = ye, ve;
}
function linearRing(ie, Z, ee, ae) {
  let ve = 0, ye = ie[ee - ae], be = ie[ee - ae + 1];
  for (; Z < ee; Z += ae) {
    const Ye = ie[Z], Qe = ie[Z + 1];
    ve += be * Ye - ye * Qe, ye = Ye, be = Qe;
  }
  return ve / 2;
}
function linearRings(ie, Z, ee, ae) {
  let ve = 0;
  for (let ye = 0, be = ee.length; ye < be; ++ye) {
    const Ye = ee[ye];
    ve += linearRing(ie, Z, Ye, ae), Z = Ye;
  }
  return ve;
}
function linearRingss$1(ie, Z, ee, ae) {
  let ve = 0;
  for (let ye = 0, be = ee.length; ye < be; ++ye) {
    const Ye = ee[ye];
    ve += linearRings(ie, Z, Ye, ae), Z = Ye[Ye.length - 1];
  }
  return ve;
}
class LinearRing extends SimpleGeometry {
  /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */
  constructor(Z, ee) {
    super(), this.maxDelta_ = -1, this.maxDeltaRevision_ = -1, ee !== void 0 && !Array.isArray(Z[0]) ? this.setFlatCoordinates(
      ee,
      /** @type {Array<number>} */
      Z
    ) : this.setCoordinates(
      /** @type {Array<import("../coordinate.js").Coordinate>} */
      Z,
      ee
    );
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   */
  clone() {
    return new LinearRing(this.flatCoordinates.slice(), this.layout);
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */
  closestPointXY(Z, ee, ae, ve) {
    return ve < closestSquaredDistanceXY(this.getExtent(), Z, ee) ? ve : (this.maxDeltaRevision_ != this.getRevision() && (this.maxDelta_ = Math.sqrt(
      maxSquaredDelta(
        this.flatCoordinates,
        0,
        this.flatCoordinates.length,
        this.stride,
        0
      )
    ), this.maxDeltaRevision_ = this.getRevision()), assignClosestPoint(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      this.maxDelta_,
      !0,
      Z,
      ee,
      ae,
      ve
    ));
  }
  /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */
  getArea() {
    return linearRing(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride
    );
  }
  /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */
  getCoordinates() {
    return inflateCoordinates(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride
    );
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   */
  getSimplifiedGeometryInternal(Z) {
    const ee = [];
    return ee.length = douglasPeucker(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      Z,
      ee,
      0
    ), new LinearRing(ee, "XY");
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */
  getType() {
    return "LinearRing";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */
  intersectsExtent(Z) {
    return !1;
  }
  /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */
  setCoordinates(Z, ee) {
    this.setLayout(ee, Z, 1), this.flatCoordinates || (this.flatCoordinates = []), this.flatCoordinates.length = deflateCoordinates(
      this.flatCoordinates,
      0,
      Z,
      this.stride
    ), this.changed();
  }
}
class Point extends SimpleGeometry {
  /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */
  constructor(Z, ee) {
    super(), this.setCoordinates(Z, ee);
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   */
  clone() {
    const Z = new Point(this.flatCoordinates.slice(), this.layout);
    return Z.applyProperties(this), Z;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */
  closestPointXY(Z, ee, ae, ve) {
    const ye = this.flatCoordinates, be = squaredDistance(
      Z,
      ee,
      ye[0],
      ye[1]
    );
    if (be < ve) {
      const Ye = this.stride;
      for (let Qe = 0; Qe < Ye; ++Qe)
        ae[Qe] = ye[Qe];
      return ae.length = Ye, be;
    }
    return ve;
  }
  /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   */
  getCoordinates() {
    return this.flatCoordinates ? this.flatCoordinates.slice() : [];
  }
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */
  computeExtent(Z) {
    return createOrUpdateFromCoordinate(this.flatCoordinates, Z);
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */
  getType() {
    return "Point";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */
  intersectsExtent(Z) {
    return containsXY(Z, this.flatCoordinates[0], this.flatCoordinates[1]);
  }
  /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */
  setCoordinates(Z, ee) {
    this.setLayout(ee, Z, 0), this.flatCoordinates || (this.flatCoordinates = []), this.flatCoordinates.length = deflateCoordinate(
      this.flatCoordinates,
      0,
      Z,
      this.stride
    ), this.changed();
  }
}
const Point$1 = Point;
function linearRingContainsExtent(ie, Z, ee, ae, ve) {
  return !forEachCorner(
    ve,
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */
    function(be) {
      return !linearRingContainsXY(
        ie,
        Z,
        ee,
        ae,
        be[0],
        be[1]
      );
    }
  );
}
function linearRingContainsXY(ie, Z, ee, ae, ve, ye) {
  let be = 0, Ye = ie[ee - ae], Qe = ie[ee - ae + 1];
  for (; Z < ee; Z += ae) {
    const Je = ie[Z], nt = ie[Z + 1];
    Qe <= ye ? nt > ye && (Je - Ye) * (ye - Qe) - (ve - Ye) * (nt - Qe) > 0 && be++ : nt <= ye && (Je - Ye) * (ye - Qe) - (ve - Ye) * (nt - Qe) < 0 && be--, Ye = Je, Qe = nt;
  }
  return be !== 0;
}
function linearRingsContainsXY(ie, Z, ee, ae, ve, ye) {
  if (ee.length === 0 || !linearRingContainsXY(ie, Z, ee[0], ae, ve, ye))
    return !1;
  for (let be = 1, Ye = ee.length; be < Ye; ++be)
    if (linearRingContainsXY(ie, ee[be - 1], ee[be], ae, ve, ye))
      return !1;
  return !0;
}
function linearRingssContainsXY(ie, Z, ee, ae, ve, ye) {
  if (ee.length === 0)
    return !1;
  for (let be = 0, Ye = ee.length; be < Ye; ++be) {
    const Qe = ee[be];
    if (linearRingsContainsXY(ie, Z, Qe, ae, ve, ye))
      return !0;
    Z = Qe[Qe.length - 1];
  }
  return !1;
}
function getInteriorPointOfArray(ie, Z, ee, ae, ve, ye, be) {
  let Ye, Qe, Je, nt, st, ot, lt;
  const ft = ve[ye + 1], gt = [];
  for (let Kr = 0, Xr = ee.length; Kr < Xr; ++Kr) {
    const Jr = ee[Kr];
    for (nt = ie[Jr - ae], ot = ie[Jr - ae + 1], Ye = Z; Ye < Jr; Ye += ae)
      st = ie[Ye], lt = ie[Ye + 1], (ft <= ot && lt <= ft || ot <= ft && ft <= lt) && (Je = (ft - ot) / (lt - ot) * (st - nt) + nt, gt.push(Je)), nt = st, ot = lt;
  }
  let ct = NaN, _r = -1 / 0;
  for (gt.sort(ascending), nt = gt[0], Ye = 1, Qe = gt.length; Ye < Qe; ++Ye) {
    st = gt[Ye];
    const Kr = Math.abs(st - nt);
    Kr > _r && (Je = (nt + st) / 2, linearRingsContainsXY(ie, Z, ee, ae, Je, ft) && (ct = Je, _r = Kr)), nt = st;
  }
  return isNaN(ct) && (ct = ve[ye]), be ? (be.push(ct, ft, _r), be) : [ct, ft, _r];
}
function getInteriorPointsOfMultiArray(ie, Z, ee, ae, ve) {
  let ye = [];
  for (let be = 0, Ye = ee.length; be < Ye; ++be) {
    const Qe = ee[be];
    ye = getInteriorPointOfArray(
      ie,
      Z,
      Qe,
      ae,
      ve,
      2 * be,
      ye
    ), Z = Qe[Qe.length - 1];
  }
  return ye;
}
function forEach(ie, Z, ee, ae, ve) {
  let ye;
  for (Z += ae; Z < ee; Z += ae)
    if (ye = ve(
      ie.slice(Z - ae, Z),
      ie.slice(Z, Z + ae)
    ), ye)
      return ye;
  return !1;
}
function intersectsLineString(ie, Z, ee, ae, ve) {
  const ye = extendFlatCoordinates(
    createEmpty(),
    ie,
    Z,
    ee,
    ae
  );
  return intersects$1(ve, ye) ? containsExtent(ve, ye) || ye[0] >= ve[0] && ye[2] <= ve[2] || ye[1] >= ve[1] && ye[3] <= ve[3] ? !0 : forEach(
    ie,
    Z,
    ee,
    ae,
    /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */
    function(be, Ye) {
      return intersectsSegment(ve, be, Ye);
    }
  ) : !1;
}
function intersectsLineStringArray(ie, Z, ee, ae, ve) {
  for (let ye = 0, be = ee.length; ye < be; ++ye) {
    if (intersectsLineString(ie, Z, ee[ye], ae, ve))
      return !0;
    Z = ee[ye];
  }
  return !1;
}
function intersectsLinearRing(ie, Z, ee, ae, ve) {
  return !!(intersectsLineString(ie, Z, ee, ae, ve) || linearRingContainsXY(
    ie,
    Z,
    ee,
    ae,
    ve[0],
    ve[1]
  ) || linearRingContainsXY(
    ie,
    Z,
    ee,
    ae,
    ve[0],
    ve[3]
  ) || linearRingContainsXY(
    ie,
    Z,
    ee,
    ae,
    ve[2],
    ve[1]
  ) || linearRingContainsXY(
    ie,
    Z,
    ee,
    ae,
    ve[2],
    ve[3]
  ));
}
function intersectsLinearRingArray(ie, Z, ee, ae, ve) {
  if (!intersectsLinearRing(ie, Z, ee[0], ae, ve))
    return !1;
  if (ee.length === 1)
    return !0;
  for (let ye = 1, be = ee.length; ye < be; ++ye)
    if (linearRingContainsExtent(
      ie,
      ee[ye - 1],
      ee[ye],
      ae,
      ve
    ) && !intersectsLineString(
      ie,
      ee[ye - 1],
      ee[ye],
      ae,
      ve
    ))
      return !1;
  return !0;
}
function intersectsLinearRingMultiArray(ie, Z, ee, ae, ve) {
  for (let ye = 0, be = ee.length; ye < be; ++ye) {
    const Ye = ee[ye];
    if (intersectsLinearRingArray(ie, Z, Ye, ae, ve))
      return !0;
    Z = Ye[Ye.length - 1];
  }
  return !1;
}
function coordinates(ie, Z, ee, ae) {
  for (; Z < ee - ae; ) {
    for (let ve = 0; ve < ae; ++ve) {
      const ye = ie[Z + ve];
      ie[Z + ve] = ie[ee - ae + ve], ie[ee - ae + ve] = ye;
    }
    Z += ae, ee -= ae;
  }
}
function linearRingIsClockwise(ie, Z, ee, ae) {
  let ve = 0, ye = ie[ee - ae], be = ie[ee - ae + 1];
  for (; Z < ee; Z += ae) {
    const Ye = ie[Z], Qe = ie[Z + 1];
    ve += (Ye - ye) * (Qe + be), ye = Ye, be = Qe;
  }
  return ve === 0 ? void 0 : ve > 0;
}
function linearRingsAreOriented(ie, Z, ee, ae, ve) {
  ve = ve !== void 0 ? ve : !1;
  for (let ye = 0, be = ee.length; ye < be; ++ye) {
    const Ye = ee[ye], Qe = linearRingIsClockwise(
      ie,
      Z,
      Ye,
      ae
    );
    if (ye === 0) {
      if (ve && Qe || !ve && !Qe)
        return !1;
    } else if (ve && !Qe || !ve && Qe)
      return !1;
    Z = Ye;
  }
  return !0;
}
function linearRingssAreOriented(ie, Z, ee, ae, ve) {
  for (let ye = 0, be = ee.length; ye < be; ++ye) {
    const Ye = ee[ye];
    if (!linearRingsAreOriented(ie, Z, Ye, ae, ve))
      return !1;
    Ye.length && (Z = Ye[Ye.length - 1]);
  }
  return !0;
}
function orientLinearRings(ie, Z, ee, ae, ve) {
  ve = ve !== void 0 ? ve : !1;
  for (let ye = 0, be = ee.length; ye < be; ++ye) {
    const Ye = ee[ye], Qe = linearRingIsClockwise(
      ie,
      Z,
      Ye,
      ae
    );
    (ye === 0 ? ve && Qe || !ve && !Qe : ve && !Qe || !ve && Qe) && coordinates(ie, Z, Ye, ae), Z = Ye;
  }
  return Z;
}
function orientLinearRingsArray(ie, Z, ee, ae, ve) {
  for (let ye = 0, be = ee.length; ye < be; ++ye)
    Z = orientLinearRings(
      ie,
      Z,
      ee[ye],
      ae,
      ve
    );
  return Z;
}
function inflateEnds(ie, Z) {
  const ee = [];
  let ae = 0, ve = 0;
  for (let ye = 0, be = Z.length; ye < be; ++ye) {
    const Ye = Z[ye];
    if (!linearRingIsClockwise(ie, ae, Ye, 2))
      ee.push(Z.slice(ve, ye + 1));
    else {
      if (ee.length === 0)
        continue;
      ee[ee.length - 1].push(Z[ve]);
    }
    ve = ye + 1, ae = Ye;
  }
  return ee;
}
class Polygon extends SimpleGeometry {
  /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */
  constructor(Z, ee, ae) {
    super(), this.ends_ = [], this.flatInteriorPointRevision_ = -1, this.flatInteriorPoint_ = null, this.maxDelta_ = -1, this.maxDeltaRevision_ = -1, this.orientedRevision_ = -1, this.orientedFlatCoordinates_ = null, ee !== void 0 && ae ? (this.setFlatCoordinates(
      ee,
      /** @type {Array<number>} */
      Z
    ), this.ends_ = ae) : this.setCoordinates(
      /** @type {Array<Array<import("../coordinate.js").Coordinate>>} */
      Z,
      ee
    );
  }
  /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */
  appendLinearRing(Z) {
    this.flatCoordinates ? extend$2(this.flatCoordinates, Z.getFlatCoordinates()) : this.flatCoordinates = Z.getFlatCoordinates().slice(), this.ends_.push(this.flatCoordinates.length), this.changed();
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   */
  clone() {
    const Z = new Polygon(
      this.flatCoordinates.slice(),
      this.layout,
      this.ends_.slice()
    );
    return Z.applyProperties(this), Z;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */
  closestPointXY(Z, ee, ae, ve) {
    return ve < closestSquaredDistanceXY(this.getExtent(), Z, ee) ? ve : (this.maxDeltaRevision_ != this.getRevision() && (this.maxDelta_ = Math.sqrt(
      arrayMaxSquaredDelta(
        this.flatCoordinates,
        0,
        this.ends_,
        this.stride,
        0
      )
    ), this.maxDeltaRevision_ = this.getRevision()), assignClosestArrayPoint(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      this.maxDelta_,
      !0,
      Z,
      ee,
      ae,
      ve
    ));
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */
  containsXY(Z, ee) {
    return linearRingsContainsXY(
      this.getOrientedFlatCoordinates(),
      0,
      this.ends_,
      this.stride,
      Z,
      ee
    );
  }
  /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */
  getArea() {
    return linearRings(
      this.getOrientedFlatCoordinates(),
      0,
      this.ends_,
      this.stride
    );
  }
  /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   */
  getCoordinates(Z) {
    let ee;
    return Z !== void 0 ? (ee = this.getOrientedFlatCoordinates().slice(), orientLinearRings(ee, 0, this.ends_, this.stride, Z)) : ee = this.flatCoordinates, inflateCoordinatesArray(ee, 0, this.ends_, this.stride);
  }
  /**
   * @return {Array<number>} Ends.
   */
  getEnds() {
    return this.ends_;
  }
  /**
   * @return {Array<number>} Interior point.
   */
  getFlatInteriorPoint() {
    if (this.flatInteriorPointRevision_ != this.getRevision()) {
      const Z = getCenter(this.getExtent());
      this.flatInteriorPoint_ = getInteriorPointOfArray(
        this.getOrientedFlatCoordinates(),
        0,
        this.ends_,
        this.stride,
        Z,
        0
      ), this.flatInteriorPointRevision_ = this.getRevision();
    }
    return this.flatInteriorPoint_;
  }
  /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */
  getInteriorPoint() {
    return new Point$1(this.getFlatInteriorPoint(), "XYM");
  }
  /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */
  getLinearRingCount() {
    return this.ends_.length;
  }
  /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */
  getLinearRing(Z) {
    return Z < 0 || this.ends_.length <= Z ? null : new LinearRing(
      this.flatCoordinates.slice(
        Z === 0 ? 0 : this.ends_[Z - 1],
        this.ends_[Z]
      ),
      this.layout
    );
  }
  /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */
  getLinearRings() {
    const Z = this.layout, ee = this.flatCoordinates, ae = this.ends_, ve = [];
    let ye = 0;
    for (let be = 0, Ye = ae.length; be < Ye; ++be) {
      const Qe = ae[be], Je = new LinearRing(
        ee.slice(ye, Qe),
        Z
      );
      ve.push(Je), ye = Qe;
    }
    return ve;
  }
  /**
   * @return {Array<number>} Oriented flat coordinates.
   */
  getOrientedFlatCoordinates() {
    if (this.orientedRevision_ != this.getRevision()) {
      const Z = this.flatCoordinates;
      linearRingsAreOriented(Z, 0, this.ends_, this.stride) ? this.orientedFlatCoordinates_ = Z : (this.orientedFlatCoordinates_ = Z.slice(), this.orientedFlatCoordinates_.length = orientLinearRings(
        this.orientedFlatCoordinates_,
        0,
        this.ends_,
        this.stride
      )), this.orientedRevision_ = this.getRevision();
    }
    return this.orientedFlatCoordinates_;
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   */
  getSimplifiedGeometryInternal(Z) {
    const ee = [], ae = [];
    return ee.length = quantizeArray(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      Math.sqrt(Z),
      ee,
      0,
      ae
    ), new Polygon(ee, "XY", ae);
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */
  getType() {
    return "Polygon";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */
  intersectsExtent(Z) {
    return intersectsLinearRingArray(
      this.getOrientedFlatCoordinates(),
      0,
      this.ends_,
      this.stride,
      Z
    );
  }
  /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */
  setCoordinates(Z, ee) {
    this.setLayout(ee, Z, 2), this.flatCoordinates || (this.flatCoordinates = []);
    const ae = deflateCoordinatesArray(
      this.flatCoordinates,
      0,
      Z,
      this.stride,
      this.ends_
    );
    this.flatCoordinates.length = ae.length === 0 ? 0 : ae[ae.length - 1], this.changed();
  }
}
const Polygon$1 = Polygon;
function fromExtent(ie) {
  if (isEmpty(ie))
    throw new Error("Cannot create polygon from empty extent");
  const Z = ie[0], ee = ie[1], ae = ie[2], ve = ie[3], ye = [
    Z,
    ee,
    Z,
    ve,
    ae,
    ve,
    ae,
    ee,
    Z,
    ee
  ];
  return new Polygon(ye, "XY", [ye.length]);
}
const RenderEventType = {
  /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */
  PRERENDER: "prerender",
  /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */
  POSTRENDER: "postrender",
  /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */
  PRECOMPOSE: "precompose",
  /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */
  POSTCOMPOSE: "postcompose",
  /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */
  RENDERCOMPLETE: "rendercomplete"
};
class Fill {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {}, this.color_ = Z.color !== void 0 ? Z.color : null;
  }
  /**
   * Clones the style. The color is not cloned if it is an {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */
  clone() {
    const Z = this.getColor();
    return new Fill({
      color: Array.isArray(Z) ? Z.slice() : Z || void 0
    });
  }
  /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|null} Color.
   * @api
   */
  getColor() {
    return this.color_;
  }
  /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|null} color Color.
   * @api
   */
  setColor(Z) {
    this.color_ = Z;
  }
}
function interpolatePoint(ie, Z, ee, ae, ve, ye, be) {
  let Ye, Qe;
  const Je = (ee - Z) / ae;
  if (Je === 1)
    Ye = Z;
  else if (Je === 2)
    Ye = Z, Qe = ve;
  else if (Je !== 0) {
    let nt = ie[Z], st = ie[Z + 1], ot = 0;
    const lt = [0];
    for (let ct = Z + ae; ct < ee; ct += ae) {
      const _r = ie[ct], Kr = ie[ct + 1];
      ot += Math.sqrt((_r - nt) * (_r - nt) + (Kr - st) * (Kr - st)), lt.push(ot), nt = _r, st = Kr;
    }
    const ft = ve * ot, gt = binarySearch(lt, ft);
    gt < 0 ? (Qe = (ft - lt[-gt - 2]) / (lt[-gt - 1] - lt[-gt - 2]), Ye = Z + (-gt - 2) * ae) : Ye = Z + gt * ae;
  }
  be = be > 1 ? be : 2, ye = ye || new Array(be);
  for (let nt = 0; nt < be; ++nt)
    ye[nt] = Ye === void 0 ? NaN : Qe === void 0 ? ie[Ye + nt] : lerp$1(ie[Ye + nt], ie[Ye + ae + nt], Qe);
  return ye;
}
function lineStringCoordinateAtM(ie, Z, ee, ae, ve, ye) {
  if (ee == Z)
    return null;
  let be;
  if (ve < ie[Z + ae - 1])
    return ye ? (be = ie.slice(Z, Z + ae), be[ae - 1] = ve, be) : null;
  if (ie[ee - 1] < ve)
    return ye ? (be = ie.slice(ee - ae, ee), be[ae - 1] = ve, be) : null;
  if (ve == ie[Z + ae - 1])
    return ie.slice(Z, Z + ae);
  let Ye = Z / ae, Qe = ee / ae;
  for (; Ye < Qe; ) {
    const ot = Ye + Qe >> 1;
    ve < ie[(ot + 1) * ae - 1] ? Qe = ot : Ye = ot + 1;
  }
  const Je = ie[Ye * ae - 1];
  if (ve == Je)
    return ie.slice((Ye - 1) * ae, (Ye - 1) * ae + ae);
  const nt = ie[(Ye + 1) * ae - 1], st = (ve - Je) / (nt - Je);
  be = [];
  for (let ot = 0; ot < ae - 1; ++ot)
    be.push(
      lerp$1(
        ie[(Ye - 1) * ae + ot],
        ie[Ye * ae + ot],
        st
      )
    );
  return be.push(ve), be;
}
function lineStringsCoordinateAtM(ie, Z, ee, ae, ve, ye, be) {
  if (be)
    return lineStringCoordinateAtM(
      ie,
      Z,
      ee[ee.length - 1],
      ae,
      ve,
      ye
    );
  let Ye;
  if (ve < ie[ae - 1])
    return ye ? (Ye = ie.slice(0, ae), Ye[ae - 1] = ve, Ye) : null;
  if (ie[ie.length - 1] < ve)
    return ye ? (Ye = ie.slice(ie.length - ae), Ye[ae - 1] = ve, Ye) : null;
  for (let Qe = 0, Je = ee.length; Qe < Je; ++Qe) {
    const nt = ee[Qe];
    if (Z != nt) {
      if (ve < ie[Z + ae - 1])
        return null;
      if (ve <= ie[nt - 1])
        return lineStringCoordinateAtM(
          ie,
          Z,
          nt,
          ae,
          ve,
          !1
        );
      Z = nt;
    }
  }
  return null;
}
function lineStringLength(ie, Z, ee, ae) {
  let ve = ie[Z], ye = ie[Z + 1], be = 0;
  for (let Ye = Z + ae; Ye < ee; Ye += ae) {
    const Qe = ie[Ye], Je = ie[Ye + 1];
    be += Math.sqrt((Qe - ve) * (Qe - ve) + (Je - ye) * (Je - ye)), ve = Qe, ye = Je;
  }
  return be;
}
class LineString extends SimpleGeometry {
  /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */
  constructor(Z, ee) {
    super(), this.flatMidpoint_ = null, this.flatMidpointRevision_ = -1, this.maxDelta_ = -1, this.maxDeltaRevision_ = -1, ee !== void 0 && !Array.isArray(Z[0]) ? this.setFlatCoordinates(
      ee,
      /** @type {Array<number>} */
      Z
    ) : this.setCoordinates(
      /** @type {Array<import("../coordinate.js").Coordinate>} */
      Z,
      ee
    );
  }
  /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */
  appendCoordinate(Z) {
    this.flatCoordinates ? extend$2(this.flatCoordinates, Z) : this.flatCoordinates = Z.slice(), this.changed();
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   */
  clone() {
    const Z = new LineString(
      this.flatCoordinates.slice(),
      this.layout
    );
    return Z.applyProperties(this), Z;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */
  closestPointXY(Z, ee, ae, ve) {
    return ve < closestSquaredDistanceXY(this.getExtent(), Z, ee) ? ve : (this.maxDeltaRevision_ != this.getRevision() && (this.maxDelta_ = Math.sqrt(
      maxSquaredDelta(
        this.flatCoordinates,
        0,
        this.flatCoordinates.length,
        this.stride,
        0
      )
    ), this.maxDeltaRevision_ = this.getRevision()), assignClosestPoint(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      this.maxDelta_,
      !1,
      Z,
      ee,
      ae,
      ve
    ));
  }
  /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */
  forEachSegment(Z) {
    return forEach(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      Z
    );
  }
  /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */
  getCoordinateAtM(Z, ee) {
    return this.layout != "XYM" && this.layout != "XYZM" ? null : (ee = ee !== void 0 ? ee : !1, lineStringCoordinateAtM(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      Z,
      ee
    ));
  }
  /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */
  getCoordinates() {
    return inflateCoordinates(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride
    );
  }
  /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */
  getCoordinateAt(Z, ee) {
    return interpolatePoint(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      Z,
      ee,
      this.stride
    );
  }
  /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */
  getLength() {
    return lineStringLength(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride
    );
  }
  /**
   * @return {Array<number>} Flat midpoint.
   */
  getFlatMidpoint() {
    return this.flatMidpointRevision_ != this.getRevision() && (this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_), this.flatMidpointRevision_ = this.getRevision()), this.flatMidpoint_;
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   */
  getSimplifiedGeometryInternal(Z) {
    const ee = [];
    return ee.length = douglasPeucker(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      Z,
      ee,
      0
    ), new LineString(ee, "XY");
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */
  getType() {
    return "LineString";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */
  intersectsExtent(Z) {
    return intersectsLineString(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      Z
    );
  }
  /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */
  setCoordinates(Z, ee) {
    this.setLayout(ee, Z, 1), this.flatCoordinates || (this.flatCoordinates = []), this.flatCoordinates.length = deflateCoordinates(
      this.flatCoordinates,
      0,
      Z,
      this.stride
    ), this.changed();
  }
}
const LineString$1 = LineString;
class Stroke {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {}, this.color_ = Z.color !== void 0 ? Z.color : null, this.lineCap_ = Z.lineCap, this.lineDash_ = Z.lineDash !== void 0 ? Z.lineDash : null, this.lineDashOffset_ = Z.lineDashOffset, this.lineJoin_ = Z.lineJoin, this.miterLimit_ = Z.miterLimit, this.width_ = Z.width;
  }
  /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */
  clone() {
    const Z = this.getColor();
    return new Stroke({
      color: Array.isArray(Z) ? Z.slice() : Z || void 0,
      lineCap: this.getLineCap(),
      lineDash: this.getLineDash() ? this.getLineDash().slice() : void 0,
      lineDashOffset: this.getLineDashOffset(),
      lineJoin: this.getLineJoin(),
      miterLimit: this.getMiterLimit(),
      width: this.getWidth()
    });
  }
  /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */
  getColor() {
    return this.color_;
  }
  /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */
  getLineCap() {
    return this.lineCap_;
  }
  /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */
  getLineDash() {
    return this.lineDash_;
  }
  /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */
  getLineDashOffset() {
    return this.lineDashOffset_;
  }
  /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */
  getLineJoin() {
    return this.lineJoin_;
  }
  /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */
  getMiterLimit() {
    return this.miterLimit_;
  }
  /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */
  getWidth() {
    return this.width_;
  }
  /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */
  setColor(Z) {
    this.color_ = Z;
  }
  /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */
  setLineCap(Z) {
    this.lineCap_ = Z;
  }
  /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */
  setLineDash(Z) {
    this.lineDash_ = Z;
  }
  /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */
  setLineDashOffset(Z) {
    this.lineDashOffset_ = Z;
  }
  /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */
  setLineJoin(Z) {
    this.lineJoin_ = Z;
  }
  /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */
  setMiterLimit(Z) {
    this.miterLimit_ = Z;
  }
  /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */
  setWidth(Z) {
    this.width_ = Z;
  }
}
const ImageState = {
  IDLE: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
  EMPTY: 4
};
function hasArea(ie) {
  return ie[0] > 0 && ie[1] > 0;
}
function scale(ie, Z, ee) {
  return ee === void 0 && (ee = [0, 0]), ee[0] = ie[0] * Z + 0.5 | 0, ee[1] = ie[1] * Z + 0.5 | 0, ee;
}
function toSize(ie, Z) {
  return Array.isArray(ie) ? ie : (Z === void 0 ? Z = [ie, ie] : (Z[0] = ie, Z[1] = ie), Z);
}
class ImageStyle {
  /**
   * @param {Options} options Options.
   */
  constructor(Z) {
    this.opacity_ = Z.opacity, this.rotateWithView_ = Z.rotateWithView, this.rotation_ = Z.rotation, this.scale_ = Z.scale, this.scaleArray_ = toSize(Z.scale), this.displacement_ = Z.displacement, this.declutterMode_ = Z.declutterMode;
  }
  /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */
  clone() {
    const Z = this.getScale();
    return new ImageStyle({
      opacity: this.getOpacity(),
      scale: Array.isArray(Z) ? Z.slice() : Z,
      rotation: this.getRotation(),
      rotateWithView: this.getRotateWithView(),
      displacement: this.getDisplacement().slice(),
      declutterMode: this.getDeclutterMode()
    });
  }
  /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */
  getOpacity() {
    return this.opacity_;
  }
  /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */
  getRotateWithView() {
    return this.rotateWithView_;
  }
  /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */
  getRotation() {
    return this.rotation_;
  }
  /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */
  getScale() {
    return this.scale_;
  }
  /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */
  getScaleArray() {
    return this.scaleArray_;
  }
  /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */
  getDisplacement() {
    return this.displacement_;
  }
  /**
   * Get the declutter mode of the shape
   * @return {"declutter"|"obstacle"|"none"|undefined} Shape's declutter mode
   * @api
   */
  getDeclutterMode() {
    return this.declutterMode_;
  }
  /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */
  getAnchor() {
    return abstract();
  }
  /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */
  getImage(Z) {
    return abstract();
  }
  /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */
  getHitDetectionImage() {
    return abstract();
  }
  /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */
  getPixelRatio(Z) {
    return 1;
  }
  /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */
  getImageState() {
    return abstract();
  }
  /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */
  getImageSize() {
    return abstract();
  }
  /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */
  getOrigin() {
    return abstract();
  }
  /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */
  getSize() {
    return abstract();
  }
  /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */
  setDisplacement(Z) {
    this.displacement_ = Z;
  }
  /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */
  setOpacity(Z) {
    this.opacity_ = Z;
  }
  /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */
  setRotateWithView(Z) {
    this.rotateWithView_ = Z;
  }
  /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */
  setRotation(Z) {
    this.rotation_ = Z;
  }
  /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */
  setScale(Z) {
    this.scale_ = Z, this.scaleArray_ = toSize(Z);
  }
  /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */
  listenImageChange(Z) {
    abstract();
  }
  /**
   * Load not yet loaded URI.
   * @abstract
   */
  load() {
    abstract();
  }
  /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */
  unlistenImageChange(Z) {
    abstract();
  }
}
const HEX_COLOR_RE_ = /^#([a-f0-9]{3}|[a-f0-9]{4}(?:[a-f0-9]{2}){0,2})$/i, NAMED_COLOR_RE_ = /^([a-z]*)$|^hsla?\(.*\)$/i;
function asString(ie) {
  return typeof ie == "string" ? ie : toString(ie);
}
function fromNamed(ie) {
  const Z = document.createElement("div");
  if (Z.style.color = ie, Z.style.color !== "") {
    document.body.appendChild(Z);
    const ee = getComputedStyle(Z).color;
    return document.body.removeChild(Z), ee;
  }
  return "";
}
const fromString = /* @__PURE__ */ function() {
  const Z = {};
  let ee = 0;
  return (
    /**
     * @param {string} s String.
     * @return {Color} Color.
     */
    function(ae) {
      let ve;
      if (Z.hasOwnProperty(ae))
        ve = Z[ae];
      else {
        if (ee >= 1024) {
          let ye = 0;
          for (const be in Z)
            ye++ & 3 || (delete Z[be], --ee);
        }
        ve = fromStringInternal_(ae), Z[ae] = ve, ++ee;
      }
      return ve;
    }
  );
}();
function asArray(ie) {
  return Array.isArray(ie) ? ie : fromString(ie);
}
function fromStringInternal_(ie) {
  let Z, ee, ae, ve, ye;
  if (NAMED_COLOR_RE_.exec(ie) && (ie = fromNamed(ie)), HEX_COLOR_RE_.exec(ie)) {
    const be = ie.length - 1;
    let Ye;
    be <= 4 ? Ye = 1 : Ye = 2;
    const Qe = be === 4 || be === 8;
    Z = parseInt(ie.substr(1 + 0 * Ye, Ye), 16), ee = parseInt(ie.substr(1 + 1 * Ye, Ye), 16), ae = parseInt(ie.substr(1 + 2 * Ye, Ye), 16), Qe ? ve = parseInt(ie.substr(1 + 3 * Ye, Ye), 16) : ve = 255, Ye == 1 && (Z = (Z << 4) + Z, ee = (ee << 4) + ee, ae = (ae << 4) + ae, Qe && (ve = (ve << 4) + ve)), ye = [Z, ee, ae, ve / 255];
  } else if (ie.startsWith("rgba("))
    ye = ie.slice(5, -1).split(",").map(Number), normalize$1(ye);
  else if (ie.startsWith("rgb("))
    ye = ie.slice(4, -1).split(",").map(Number), ye.push(1), normalize$1(ye);
  else
    throw new Error("Invalid color");
  return ye;
}
function normalize$1(ie) {
  return ie[0] = clamp$1(ie[0] + 0.5 | 0, 0, 255), ie[1] = clamp$1(ie[1] + 0.5 | 0, 0, 255), ie[2] = clamp$1(ie[2] + 0.5 | 0, 0, 255), ie[3] = clamp$1(ie[3], 0, 1), ie;
}
function toString(ie) {
  let Z = ie[0];
  Z != (Z | 0) && (Z = Z + 0.5 | 0);
  let ee = ie[1];
  ee != (ee | 0) && (ee = ee + 0.5 | 0);
  let ae = ie[2];
  ae != (ae | 0) && (ae = ae + 0.5 | 0);
  const ve = ie[3] === void 0 ? 1 : Math.round(ie[3] * 100) / 100;
  return "rgba(" + Z + "," + ee + "," + ae + "," + ve + ")";
}
function isStringColor(ie) {
  return NAMED_COLOR_RE_.test(ie) && (ie = fromNamed(ie)), HEX_COLOR_RE_.test(ie) || ie.startsWith("rgba(") || ie.startsWith("rgb(");
}
function asColorLike(ie) {
  return Array.isArray(ie) ? toString(ie) : ie;
}
function createCanvasContext2D(ie, Z, ee, ae) {
  let ve;
  return ee && ee.length ? ve = ee.shift() : WORKER_OFFSCREEN_CANVAS ? ve = new OffscreenCanvas(ie || 300, Z || 300) : ve = document.createElement("canvas"), ie && (ve.width = ie), Z && (ve.height = Z), /** @type {CanvasRenderingContext2D} */
  ve.getContext("2d", ae);
}
function releaseCanvas$1(ie) {
  const Z = ie.canvas;
  Z.width = 1, Z.height = 1, ie.clearRect(0, 0, 1, 1);
}
function replaceNode(ie, Z) {
  const ee = Z.parentNode;
  ee && ee.replaceChild(ie, Z);
}
function removeNode(ie) {
  return ie && ie.parentNode ? ie.parentNode.removeChild(ie) : null;
}
function removeChildren(ie) {
  for (; ie.lastChild; )
    ie.removeChild(ie.lastChild);
}
function replaceChildren(ie, Z) {
  const ee = ie.childNodes;
  for (let ae = 0; ; ++ae) {
    const ve = ee[ae], ye = Z[ae];
    if (!ve && !ye)
      break;
    if (ve !== ye) {
      if (!ve) {
        ie.appendChild(ye);
        continue;
      }
      if (!ye) {
        ie.removeChild(ve), --ae;
        continue;
      }
      ie.insertBefore(ye, ve);
    }
  }
}
const CLASS_HIDDEN = "ol-hidden", CLASS_UNSELECTABLE = "ol-unselectable", CLASS_UNSUPPORTED = "ol-unsupported", CLASS_CONTROL = "ol-control", CLASS_COLLAPSED = "ol-collapsed", fontRegEx = new RegExp(
  [
    "^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)",
    "(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?",
    "(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))",
    "(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))",
    `?\\s*([-,\\"\\'\\sa-z]+?)\\s*$`
  ].join(""),
  "i"
), fontRegExMatchIndex = [
  "style",
  "variant",
  "weight",
  "size",
  "lineHeight",
  "family"
], getFontParameters = function(ie) {
  const Z = ie.match(fontRegEx);
  if (!Z)
    return null;
  const ee = (
    /** @type {FontParameters} */
    {
      lineHeight: "normal",
      size: "1.2em",
      style: "normal",
      weight: "normal",
      variant: "normal"
    }
  );
  for (let ae = 0, ve = fontRegExMatchIndex.length; ae < ve; ++ae) {
    const ye = Z[ae + 1];
    ye !== void 0 && (ee[fontRegExMatchIndex[ae]] = ye);
  }
  return ee.families = ee.family.split(/,\s?/), ee;
}, defaultFont = "10px sans-serif", defaultFillStyle = "#000", defaultLineCap = "round", defaultLineDash = [], defaultLineDashOffset = 0, defaultLineJoin = "round", defaultMiterLimit = 10, defaultStrokeStyle = "#000", defaultTextAlign = "center", defaultTextBaseline = "middle", defaultPadding = [0, 0, 0, 0], defaultLineWidth = 1, checkedFonts = new BaseObject();
let measureContext = null, measureFont;
const textHeights = {}, registerFont = function() {
  const Z = "32px ", ee = ["monospace", "serif"], ae = ee.length, ve = "wmytzilWMYTZIL@#/&?$%10";
  let ye, be;
  function Ye(Je, nt, st) {
    let ot = !0;
    for (let lt = 0; lt < ae; ++lt) {
      const ft = ee[lt];
      if (be = measureTextWidth(
        Je + " " + nt + " " + Z + ft,
        ve
      ), st != ft) {
        const gt = measureTextWidth(
          Je + " " + nt + " " + Z + st + "," + ft,
          ve
        );
        ot = ot && gt != be;
      }
    }
    return !!ot;
  }
  function Qe() {
    let Je = !0;
    const nt = checkedFonts.getKeys();
    for (let st = 0, ot = nt.length; st < ot; ++st) {
      const lt = nt[st];
      checkedFonts.get(lt) < 100 && (Ye.apply(this, lt.split(`
`)) ? (clear(textHeights), measureContext = null, measureFont = void 0, checkedFonts.set(lt, 100)) : (checkedFonts.set(lt, checkedFonts.get(lt) + 1, !0), Je = !1));
    }
    Je && (clearInterval(ye), ye = void 0);
  }
  return function(Je) {
    const nt = getFontParameters(Je);
    if (!nt)
      return;
    const st = nt.families;
    for (let ot = 0, lt = st.length; ot < lt; ++ot) {
      const ft = st[ot], gt = nt.style + `
` + nt.weight + `
` + ft;
      checkedFonts.get(gt) === void 0 && (checkedFonts.set(gt, 100, !0), Ye(nt.style, nt.weight, ft) || (checkedFonts.set(gt, 0, !0), ye === void 0 && (ye = setInterval(Qe, 32))));
    }
  };
}(), measureTextHeight = /* @__PURE__ */ function() {
  let ie;
  return function(Z) {
    let ee = textHeights[Z];
    if (ee == null) {
      if (WORKER_OFFSCREEN_CANVAS) {
        const ae = getFontParameters(Z), ve = measureText(Z, "Žg");
        ee = (isNaN(Number(ae.lineHeight)) ? 1.2 : Number(ae.lineHeight)) * (ve.actualBoundingBoxAscent + ve.actualBoundingBoxDescent);
      } else
        ie || (ie = document.createElement("div"), ie.innerHTML = "M", ie.style.minHeight = "0", ie.style.maxHeight = "none", ie.style.height = "auto", ie.style.padding = "0", ie.style.border = "none", ie.style.position = "absolute", ie.style.display = "block", ie.style.left = "-99999px"), ie.style.font = Z, document.body.appendChild(ie), ee = ie.offsetHeight, document.body.removeChild(ie);
      textHeights[Z] = ee;
    }
    return ee;
  };
}();
function measureText(ie, Z) {
  return measureContext || (measureContext = createCanvasContext2D(1, 1)), ie != measureFont && (measureContext.font = ie, measureFont = measureContext.font), measureContext.measureText(Z);
}
function measureTextWidth(ie, Z) {
  return measureText(ie, Z).width;
}
function measureAndCacheTextWidth(ie, Z, ee) {
  if (Z in ee)
    return ee[Z];
  const ae = Z.split(`
`).reduce((ve, ye) => Math.max(ve, measureTextWidth(ie, ye)), 0);
  return ee[Z] = ae, ae;
}
function getTextDimensions(ie, Z) {
  const ee = [], ae = [], ve = [];
  let ye = 0, be = 0, Ye = 0, Qe = 0;
  for (let Je = 0, nt = Z.length; Je <= nt; Je += 2) {
    const st = Z[Je];
    if (st === `
` || Je === nt) {
      ye = Math.max(ye, be), ve.push(be), be = 0, Ye += Qe;
      continue;
    }
    const ot = Z[Je + 1] || ie.font, lt = measureTextWidth(ot, st);
    ee.push(lt), be += lt;
    const ft = measureTextHeight(ot);
    ae.push(ft), Qe = Math.max(Qe, ft);
  }
  return { width: ye, height: Ye, widths: ee, heights: ae, lineWidths: ve };
}
function drawImageOrLabel(ie, Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt) {
  ie.save(), ee !== 1 && (ie.globalAlpha *= ee), Z && ie.transform.apply(ie, Z), /** @type {*} */
  ae.contextInstructions ? (ie.translate(Qe, Je), ie.scale(nt[0], nt[1]), executeLabelInstructions(
    /** @type {Label} */
    ae,
    ie
  )) : nt[0] < 0 || nt[1] < 0 ? (ie.translate(Qe, Je), ie.scale(nt[0], nt[1]), ie.drawImage(
    /** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */
    ae,
    ve,
    ye,
    be,
    Ye,
    0,
    0,
    be,
    Ye
  )) : ie.drawImage(
    /** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */
    ae,
    ve,
    ye,
    be,
    Ye,
    Qe,
    Je,
    be * nt[0],
    Ye * nt[1]
  ), ie.restore();
}
function executeLabelInstructions(ie, Z) {
  const ee = ie.contextInstructions;
  for (let ae = 0, ve = ee.length; ae < ve; ae += 2)
    Array.isArray(ee[ae + 1]) ? Z[ee[ae]].apply(
      Z,
      ee[ae + 1]
    ) : Z[ee[ae]] = ee[ae + 1];
}
class RegularShape extends ImageStyle {
  /**
   * @param {Options} options Options.
   */
  constructor(Z) {
    const ee = Z.rotateWithView !== void 0 ? Z.rotateWithView : !1;
    super({
      opacity: 1,
      rotateWithView: ee,
      rotation: Z.rotation !== void 0 ? Z.rotation : 0,
      scale: Z.scale !== void 0 ? Z.scale : 1,
      displacement: Z.displacement !== void 0 ? Z.displacement : [0, 0],
      declutterMode: Z.declutterMode
    }), this.canvas_ = void 0, this.hitDetectionCanvas_ = null, this.fill_ = Z.fill !== void 0 ? Z.fill : null, this.origin_ = [0, 0], this.points_ = Z.points, this.radius_ = Z.radius !== void 0 ? Z.radius : Z.radius1, this.radius2_ = Z.radius2, this.angle_ = Z.angle !== void 0 ? Z.angle : 0, this.stroke_ = Z.stroke !== void 0 ? Z.stroke : null, this.size_ = null, this.renderOptions_ = null, this.render();
  }
  /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   */
  clone() {
    const Z = this.getScale(), ee = new RegularShape({
      fill: this.getFill() ? this.getFill().clone() : void 0,
      points: this.getPoints(),
      radius: this.getRadius(),
      radius2: this.getRadius2(),
      angle: this.getAngle(),
      stroke: this.getStroke() ? this.getStroke().clone() : void 0,
      rotation: this.getRotation(),
      rotateWithView: this.getRotateWithView(),
      scale: Array.isArray(Z) ? Z.slice() : Z,
      displacement: this.getDisplacement().slice(),
      declutterMode: this.getDeclutterMode()
    });
    return ee.setOpacity(this.getOpacity()), ee;
  }
  /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   */
  getAnchor() {
    const Z = this.size_;
    if (!Z)
      return null;
    const ee = this.getDisplacement(), ae = this.getScaleArray();
    return [
      Z[0] / 2 - ee[0] / ae[0],
      Z[1] / 2 + ee[1] / ae[1]
    ];
  }
  /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */
  getAngle() {
    return this.angle_;
  }
  /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default} Fill style.
   * @api
   */
  getFill() {
    return this.fill_;
  }
  /**
   * Set the fill style.
   * @param {import("./Fill.js").default} fill Fill style.
   * @api
   */
  setFill(Z) {
    this.fill_ = Z, this.render();
  }
  /**
   * @return {HTMLCanvasElement} Image element.
   */
  getHitDetectionImage() {
    return this.hitDetectionCanvas_ || this.createHitDetectionCanvas_(this.renderOptions_), this.hitDetectionCanvas_;
  }
  /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement} Image or Canvas element.
   * @api
   */
  getImage(Z) {
    let ee = this.canvas_[Z];
    if (!ee) {
      const ae = this.renderOptions_, ve = createCanvasContext2D(
        ae.size * Z,
        ae.size * Z
      );
      this.draw_(ae, ve, Z), ee = ve.canvas, this.canvas_[Z] = ee;
    }
    return ee;
  }
  /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */
  getPixelRatio(Z) {
    return Z;
  }
  /**
   * @return {import("../size.js").Size} Image size.
   */
  getImageSize() {
    return this.size_;
  }
  /**
   * @return {import("../ImageState.js").default} Image state.
   */
  getImageState() {
    return ImageState.LOADED;
  }
  /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   */
  getOrigin() {
    return this.origin_;
  }
  /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */
  getPoints() {
    return this.points_;
  }
  /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */
  getRadius() {
    return this.radius_;
  }
  /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */
  getRadius2() {
    return this.radius2_;
  }
  /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   */
  getSize() {
    return this.size_;
  }
  /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default} Stroke style.
   * @api
   */
  getStroke() {
    return this.stroke_;
  }
  /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default} stroke Stroke style.
   * @api
   */
  setStroke(Z) {
    this.stroke_ = Z, this.render();
  }
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */
  listenImageChange(Z) {
  }
  /**
   * Load not yet loaded URI.
   */
  load() {
  }
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */
  unlistenImageChange(Z) {
  }
  /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */
  calculateLineJoinSize_(Z, ee, ae) {
    if (ee === 0 || this.points_ === 1 / 0 || Z !== "bevel" && Z !== "miter")
      return ee;
    let ve = this.radius_, ye = this.radius2_ === void 0 ? ve : this.radius2_;
    if (ve < ye) {
      const si = ve;
      ve = ye, ye = si;
    }
    const be = this.radius2_ === void 0 ? this.points_ : this.points_ * 2, Ye = 2 * Math.PI / be, Qe = ye * Math.sin(Ye), Je = Math.sqrt(ye * ye - Qe * Qe), nt = ve - Je, st = Math.sqrt(Qe * Qe + nt * nt), ot = st / Qe;
    if (Z === "miter" && ot <= ae)
      return ot * ee;
    const lt = ee / 2 / ot, ft = ee / 2 * (nt / st), ct = Math.sqrt((ve + lt) * (ve + lt) + ft * ft) - ve;
    if (this.radius2_ === void 0 || Z === "bevel")
      return ct * 2;
    const _r = ve * Math.sin(Ye), Kr = Math.sqrt(ve * ve - _r * _r), Xr = ye - Kr, ei = Math.sqrt(_r * _r + Xr * Xr) / _r;
    if (ei <= ae) {
      const si = ei * ee / 2 - ye - ve;
      return 2 * Math.max(ct, si);
    }
    return ct * 2;
  }
  /**
   * @return {RenderOptions}  The render options
   * @protected
   */
  createRenderOptions() {
    let Z = defaultLineCap, ee = defaultLineJoin, ae = 0, ve = null, ye = 0, be, Ye = 0;
    this.stroke_ && (be = this.stroke_.getColor(), be === null && (be = defaultStrokeStyle), be = asColorLike(be), Ye = this.stroke_.getWidth(), Ye === void 0 && (Ye = defaultLineWidth), ve = this.stroke_.getLineDash(), ye = this.stroke_.getLineDashOffset(), ee = this.stroke_.getLineJoin(), ee === void 0 && (ee = defaultLineJoin), Z = this.stroke_.getLineCap(), Z === void 0 && (Z = defaultLineCap), ae = this.stroke_.getMiterLimit(), ae === void 0 && (ae = defaultMiterLimit));
    const Qe = this.calculateLineJoinSize_(ee, Ye, ae), Je = Math.max(this.radius_, this.radius2_ || 0), nt = Math.ceil(2 * Je + Qe);
    return {
      strokeStyle: be,
      strokeWidth: Ye,
      size: nt,
      lineCap: Z,
      lineDash: ve,
      lineDashOffset: ye,
      lineJoin: ee,
      miterLimit: ae
    };
  }
  /**
   * @protected
   */
  render() {
    this.renderOptions_ = this.createRenderOptions();
    const Z = this.renderOptions_.size;
    this.canvas_ = {}, this.size_ = [Z, Z];
  }
  /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */
  draw_(Z, ee, ae) {
    if (ee.scale(ae, ae), ee.translate(Z.size / 2, Z.size / 2), this.createPath_(ee), this.fill_) {
      let ve = this.fill_.getColor();
      ve === null && (ve = defaultFillStyle), ee.fillStyle = asColorLike(ve), ee.fill();
    }
    this.stroke_ && (ee.strokeStyle = Z.strokeStyle, ee.lineWidth = Z.strokeWidth, Z.lineDash && (ee.setLineDash(Z.lineDash), ee.lineDashOffset = Z.lineDashOffset), ee.lineCap = Z.lineCap, ee.lineJoin = Z.lineJoin, ee.miterLimit = Z.miterLimit, ee.stroke());
  }
  /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   */
  createHitDetectionCanvas_(Z) {
    if (this.fill_) {
      let ee = this.fill_.getColor(), ae = 0;
      if (typeof ee == "string" && (ee = asArray(ee)), ee === null ? ae = 1 : Array.isArray(ee) && (ae = ee.length === 4 ? ee[3] : 1), ae === 0) {
        const ve = createCanvasContext2D(
          Z.size,
          Z.size
        );
        this.hitDetectionCanvas_ = ve.canvas, this.drawHitDetectionCanvas_(Z, ve);
      }
    }
    this.hitDetectionCanvas_ || (this.hitDetectionCanvas_ = this.getImage(1));
  }
  /**
   * @private
   * @param {CanvasRenderingContext2D} context The context to draw in.
   */
  createPath_(Z) {
    let ee = this.points_;
    const ae = this.radius_;
    if (ee === 1 / 0)
      Z.arc(0, 0, ae, 0, 2 * Math.PI);
    else {
      const ve = this.radius2_ === void 0 ? ae : this.radius2_;
      this.radius2_ !== void 0 && (ee *= 2);
      const ye = this.angle_ - Math.PI / 2, be = 2 * Math.PI / ee;
      for (let Ye = 0; Ye < ee; Ye++) {
        const Qe = ye + Ye * be, Je = Ye % 2 === 0 ? ae : ve;
        Z.lineTo(Je * Math.cos(Qe), Je * Math.sin(Qe));
      }
      Z.closePath();
    }
  }
  /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   */
  drawHitDetectionCanvas_(Z, ee) {
    ee.translate(Z.size / 2, Z.size / 2), this.createPath_(ee), ee.fillStyle = defaultFillStyle, ee.fill(), this.stroke_ && (ee.strokeStyle = Z.strokeStyle, ee.lineWidth = Z.strokeWidth, Z.lineDash && (ee.setLineDash(Z.lineDash), ee.lineDashOffset = Z.lineDashOffset), ee.lineJoin = Z.lineJoin, ee.miterLimit = Z.miterLimit, ee.stroke());
  }
}
class CircleStyle extends RegularShape {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || { radius: 5 }, super({
      points: 1 / 0,
      fill: Z.fill,
      radius: Z.radius,
      stroke: Z.stroke,
      scale: Z.scale !== void 0 ? Z.scale : 1,
      rotation: Z.rotation !== void 0 ? Z.rotation : 0,
      rotateWithView: Z.rotateWithView !== void 0 ? Z.rotateWithView : !1,
      displacement: Z.displacement !== void 0 ? Z.displacement : [0, 0],
      declutterMode: Z.declutterMode
    });
  }
  /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   */
  clone() {
    const Z = this.getScale(), ee = new CircleStyle({
      fill: this.getFill() ? this.getFill().clone() : void 0,
      stroke: this.getStroke() ? this.getStroke().clone() : void 0,
      radius: this.getRadius(),
      scale: Array.isArray(Z) ? Z.slice() : Z,
      rotation: this.getRotation(),
      rotateWithView: this.getRotateWithView(),
      displacement: this.getDisplacement().slice(),
      declutterMode: this.getDeclutterMode()
    });
    return ee.setOpacity(this.getOpacity()), ee;
  }
  /**
   * Set the circle radius.
   *
   * @param {number} radius Circle radius.
   * @api
   */
  setRadius(Z) {
    this.radius_ = Z, this.render();
  }
}
let Style$1 = class hC {
  /**
   * @param {Options} [options] Style options.
   */
  constructor(Z) {
    Z = Z || {}, this.geometry_ = null, this.geometryFunction_ = defaultGeometryFunction, Z.geometry !== void 0 && this.setGeometry(Z.geometry), this.fill_ = Z.fill !== void 0 ? Z.fill : null, this.image_ = Z.image !== void 0 ? Z.image : null, this.renderer_ = Z.renderer !== void 0 ? Z.renderer : null, this.hitDetectionRenderer_ = Z.hitDetectionRenderer !== void 0 ? Z.hitDetectionRenderer : null, this.stroke_ = Z.stroke !== void 0 ? Z.stroke : null, this.text_ = Z.text !== void 0 ? Z.text : null, this.zIndex_ = Z.zIndex;
  }
  /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */
  clone() {
    let Z = this.getGeometry();
    return Z && typeof Z == "object" && (Z = /** @type {import("../geom/Geometry.js").default} */
    Z.clone()), new hC({
      geometry: Z,
      fill: this.getFill() ? this.getFill().clone() : void 0,
      image: this.getImage() ? this.getImage().clone() : void 0,
      renderer: this.getRenderer(),
      stroke: this.getStroke() ? this.getStroke().clone() : void 0,
      text: this.getText() ? this.getText().clone() : void 0,
      zIndex: this.getZIndex()
    });
  }
  /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */
  getRenderer() {
    return this.renderer_;
  }
  /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */
  setRenderer(Z) {
    this.renderer_ = Z;
  }
  /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */
  setHitDetectionRenderer(Z) {
    this.hitDetectionRenderer_ = Z;
  }
  /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */
  getHitDetectionRenderer() {
    return this.hitDetectionRenderer_;
  }
  /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */
  getGeometry() {
    return this.geometry_;
  }
  /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */
  getGeometryFunction() {
    return this.geometryFunction_;
  }
  /**
   * Get the fill style.
   * @return {import("./Fill.js").default} Fill style.
   * @api
   */
  getFill() {
    return this.fill_;
  }
  /**
   * Set the fill style.
   * @param {import("./Fill.js").default} fill Fill style.
   * @api
   */
  setFill(Z) {
    this.fill_ = Z;
  }
  /**
   * Get the image style.
   * @return {import("./Image.js").default} Image style.
   * @api
   */
  getImage() {
    return this.image_;
  }
  /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */
  setImage(Z) {
    this.image_ = Z;
  }
  /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default} Stroke style.
   * @api
   */
  getStroke() {
    return this.stroke_;
  }
  /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default} stroke Stroke style.
   * @api
   */
  setStroke(Z) {
    this.stroke_ = Z;
  }
  /**
   * Get the text style.
   * @return {import("./Text.js").default} Text style.
   * @api
   */
  getText() {
    return this.text_;
  }
  /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */
  setText(Z) {
    this.text_ = Z;
  }
  /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */
  getZIndex() {
    return this.zIndex_;
  }
  /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */
  setGeometry(Z) {
    typeof Z == "function" ? this.geometryFunction_ = Z : typeof Z == "string" ? this.geometryFunction_ = function(ee) {
      return (
        /** @type {import("../geom/Geometry.js").default} */
        ee.get(Z)
      );
    } : Z ? Z !== void 0 && (this.geometryFunction_ = function() {
      return (
        /** @type {import("../geom/Geometry.js").default} */
        Z
      );
    }) : this.geometryFunction_ = defaultGeometryFunction, this.geometry_ = Z;
  }
  /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */
  setZIndex(Z) {
    this.zIndex_ = Z;
  }
};
function toFunction(ie) {
  let Z;
  if (typeof ie == "function")
    Z = ie;
  else {
    let ee;
    Array.isArray(ie) ? ee = ie : (assert(
      typeof /** @type {?} */
      ie.getZIndex == "function",
      "Expected an `Style` or an array of `Style`"
    ), ee = [
      /** @type {Style} */
      ie
    ]), Z = function() {
      return ee;
    };
  }
  return Z;
}
let defaultStyles = null;
function createDefaultStyle(ie, Z) {
  if (!defaultStyles) {
    const ee = new Fill({
      color: "rgba(255,255,255,0.4)"
    }), ae = new Stroke({
      color: "#3399CC",
      width: 1.25
    });
    defaultStyles = [
      new Style$1({
        image: new CircleStyle({
          fill: ee,
          stroke: ae,
          radius: 5
        }),
        fill: ee,
        stroke: ae
      })
    ];
  }
  return defaultStyles;
}
function defaultGeometryFunction(ie) {
  return ie.getGeometry();
}
const DEFAULT_FILL_COLOR = "#333";
let Text$1 = class pC {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {}, this.font_ = Z.font, this.rotation_ = Z.rotation, this.rotateWithView_ = Z.rotateWithView, this.scale_ = Z.scale, this.scaleArray_ = toSize(Z.scale !== void 0 ? Z.scale : 1), this.text_ = Z.text, this.textAlign_ = Z.textAlign, this.justify_ = Z.justify, this.repeat_ = Z.repeat, this.textBaseline_ = Z.textBaseline, this.fill_ = Z.fill !== void 0 ? Z.fill : new Fill({ color: DEFAULT_FILL_COLOR }), this.maxAngle_ = Z.maxAngle !== void 0 ? Z.maxAngle : Math.PI / 4, this.placement_ = Z.placement !== void 0 ? Z.placement : "point", this.overflow_ = !!Z.overflow, this.stroke_ = Z.stroke !== void 0 ? Z.stroke : null, this.offsetX_ = Z.offsetX !== void 0 ? Z.offsetX : 0, this.offsetY_ = Z.offsetY !== void 0 ? Z.offsetY : 0, this.backgroundFill_ = Z.backgroundFill ? Z.backgroundFill : null, this.backgroundStroke_ = Z.backgroundStroke ? Z.backgroundStroke : null, this.padding_ = Z.padding === void 0 ? null : Z.padding;
  }
  /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */
  clone() {
    const Z = this.getScale();
    return new pC({
      font: this.getFont(),
      placement: this.getPlacement(),
      repeat: this.getRepeat(),
      maxAngle: this.getMaxAngle(),
      overflow: this.getOverflow(),
      rotation: this.getRotation(),
      rotateWithView: this.getRotateWithView(),
      scale: Array.isArray(Z) ? Z.slice() : Z,
      text: this.getText(),
      textAlign: this.getTextAlign(),
      justify: this.getJustify(),
      textBaseline: this.getTextBaseline(),
      fill: this.getFill() ? this.getFill().clone() : void 0,
      stroke: this.getStroke() ? this.getStroke().clone() : void 0,
      offsetX: this.getOffsetX(),
      offsetY: this.getOffsetY(),
      backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : void 0,
      backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : void 0,
      padding: this.getPadding() || void 0
    });
  }
  /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */
  getOverflow() {
    return this.overflow_;
  }
  /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */
  getFont() {
    return this.font_;
  }
  /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */
  getMaxAngle() {
    return this.maxAngle_;
  }
  /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */
  getPlacement() {
    return this.placement_;
  }
  /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */
  getRepeat() {
    return this.repeat_;
  }
  /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */
  getOffsetX() {
    return this.offsetX_;
  }
  /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */
  getOffsetY() {
    return this.offsetY_;
  }
  /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default} Fill style.
   * @api
   */
  getFill() {
    return this.fill_;
  }
  /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */
  getRotateWithView() {
    return this.rotateWithView_;
  }
  /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */
  getRotation() {
    return this.rotation_;
  }
  /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */
  getScale() {
    return this.scale_;
  }
  /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */
  getScaleArray() {
    return this.scaleArray_;
  }
  /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default} Stroke style.
   * @api
   */
  getStroke() {
    return this.stroke_;
  }
  /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */
  getText() {
    return this.text_;
  }
  /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */
  getTextAlign() {
    return this.textAlign_;
  }
  /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */
  getJustify() {
    return this.justify_;
  }
  /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */
  getTextBaseline() {
    return this.textBaseline_;
  }
  /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default} Fill style.
   * @api
   */
  getBackgroundFill() {
    return this.backgroundFill_;
  }
  /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default} Stroke style.
   * @api
   */
  getBackgroundStroke() {
    return this.backgroundStroke_;
  }
  /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */
  getPadding() {
    return this.padding_;
  }
  /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */
  setOverflow(Z) {
    this.overflow_ = Z;
  }
  /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */
  setFont(Z) {
    this.font_ = Z;
  }
  /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */
  setMaxAngle(Z) {
    this.maxAngle_ = Z;
  }
  /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */
  setOffsetX(Z) {
    this.offsetX_ = Z;
  }
  /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */
  setOffsetY(Z) {
    this.offsetY_ = Z;
  }
  /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */
  setPlacement(Z) {
    this.placement_ = Z;
  }
  /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */
  setRepeat(Z) {
    this.repeat_ = Z;
  }
  /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */
  setRotateWithView(Z) {
    this.rotateWithView_ = Z;
  }
  /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default} fill Fill style.
   * @api
   */
  setFill(Z) {
    this.fill_ = Z;
  }
  /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */
  setRotation(Z) {
    this.rotation_ = Z;
  }
  /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */
  setScale(Z) {
    this.scale_ = Z, this.scaleArray_ = toSize(Z !== void 0 ? Z : 1);
  }
  /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default} stroke Stroke style.
   * @api
   */
  setStroke(Z) {
    this.stroke_ = Z;
  }
  /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */
  setText(Z) {
    this.text_ = Z;
  }
  /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */
  setTextAlign(Z) {
    this.textAlign_ = Z;
  }
  /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */
  setJustify(Z) {
    this.justify_ = Z;
  }
  /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */
  setTextBaseline(Z) {
    this.textBaseline_ = Z;
  }
  /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default} fill Fill style.
   * @api
   */
  setBackgroundFill(Z) {
    this.backgroundFill_ = Z;
  }
  /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default} stroke Stroke style.
   * @api
   */
  setBackgroundStroke(Z) {
    this.backgroundStroke_ = Z;
  }
  /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */
  setPadding(Z) {
    this.padding_ = Z;
  }
};
const LayerProperty = {
  OPACITY: "opacity",
  VISIBLE: "visible",
  EXTENT: "extent",
  Z_INDEX: "zIndex",
  MAX_RESOLUTION: "maxResolution",
  MIN_RESOLUTION: "minResolution",
  MAX_ZOOM: "maxZoom",
  MIN_ZOOM: "minZoom",
  SOURCE: "source",
  MAP: "map"
};
class BaseLayer extends BaseObject {
  /**
   * @param {Options} options Layer options.
   */
  constructor(Z) {
    super(), this.on, this.once, this.un, this.background_ = Z.background;
    const ee = Object.assign({}, Z);
    typeof Z.properties == "object" && (delete ee.properties, Object.assign(ee, Z.properties)), ee[LayerProperty.OPACITY] = Z.opacity !== void 0 ? Z.opacity : 1, assert(
      typeof ee[LayerProperty.OPACITY] == "number",
      "Layer opacity must be a number"
    ), ee[LayerProperty.VISIBLE] = Z.visible !== void 0 ? Z.visible : !0, ee[LayerProperty.Z_INDEX] = Z.zIndex, ee[LayerProperty.MAX_RESOLUTION] = Z.maxResolution !== void 0 ? Z.maxResolution : 1 / 0, ee[LayerProperty.MIN_RESOLUTION] = Z.minResolution !== void 0 ? Z.minResolution : 0, ee[LayerProperty.MIN_ZOOM] = Z.minZoom !== void 0 ? Z.minZoom : -1 / 0, ee[LayerProperty.MAX_ZOOM] = Z.maxZoom !== void 0 ? Z.maxZoom : 1 / 0, this.className_ = ee.className !== void 0 ? ee.className : "ol-layer", delete ee.className, this.setProperties(ee), this.state_ = null;
  }
  /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */
  getBackground() {
    return this.background_;
  }
  /**
   * @return {string} CSS class name.
   */
  getClassName() {
    return this.className_;
  }
  /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */
  getLayerState(Z) {
    const ee = this.state_ || /** @type {?} */
    {
      layer: this,
      managed: Z === void 0 ? !0 : Z
    }, ae = this.getZIndex();
    return ee.opacity = clamp$1(Math.round(this.getOpacity() * 100) / 100, 0, 1), ee.visible = this.getVisible(), ee.extent = this.getExtent(), ee.zIndex = ae === void 0 && !ee.managed ? 1 / 0 : ae, ee.maxResolution = this.getMaxResolution(), ee.minResolution = Math.max(this.getMinResolution(), 0), ee.minZoom = this.getMinZoom(), ee.maxZoom = this.getMaxZoom(), this.state_ = ee, ee;
  }
  /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */
  getLayersArray(Z) {
    return abstract();
  }
  /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */
  getLayerStatesArray(Z) {
    return abstract();
  }
  /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */
  getExtent() {
    return (
      /** @type {import("../extent.js").Extent|undefined} */
      this.get(LayerProperty.EXTENT)
    );
  }
  /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */
  getMaxResolution() {
    return (
      /** @type {number} */
      this.get(LayerProperty.MAX_RESOLUTION)
    );
  }
  /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */
  getMinResolution() {
    return (
      /** @type {number} */
      this.get(LayerProperty.MIN_RESOLUTION)
    );
  }
  /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */
  getMinZoom() {
    return (
      /** @type {number} */
      this.get(LayerProperty.MIN_ZOOM)
    );
  }
  /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */
  getMaxZoom() {
    return (
      /** @type {number} */
      this.get(LayerProperty.MAX_ZOOM)
    );
  }
  /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */
  getOpacity() {
    return (
      /** @type {number} */
      this.get(LayerProperty.OPACITY)
    );
  }
  /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */
  getSourceState() {
    return abstract();
  }
  /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */
  getVisible() {
    return (
      /** @type {boolean} */
      this.get(LayerProperty.VISIBLE)
    );
  }
  /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */
  getZIndex() {
    return (
      /** @type {number|undefined} */
      this.get(LayerProperty.Z_INDEX)
    );
  }
  /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */
  setBackground(Z) {
    this.background_ = Z, this.changed();
  }
  /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */
  setExtent(Z) {
    this.set(LayerProperty.EXTENT, Z);
  }
  /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */
  setMaxResolution(Z) {
    this.set(LayerProperty.MAX_RESOLUTION, Z);
  }
  /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */
  setMinResolution(Z) {
    this.set(LayerProperty.MIN_RESOLUTION, Z);
  }
  /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */
  setMaxZoom(Z) {
    this.set(LayerProperty.MAX_ZOOM, Z);
  }
  /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */
  setMinZoom(Z) {
    this.set(LayerProperty.MIN_ZOOM, Z);
  }
  /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */
  setOpacity(Z) {
    assert(typeof Z == "number", "Layer opacity must be a number"), this.set(LayerProperty.OPACITY, Z);
  }
  /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */
  setVisible(Z) {
    this.set(LayerProperty.VISIBLE, Z);
  }
  /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */
  setZIndex(Z) {
    this.set(LayerProperty.Z_INDEX, Z);
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    this.state_ && (this.state_.layer = null, this.state_ = null), super.disposeInternal();
  }
}
const ViewHint = {
  ANIMATING: 0,
  INTERACTING: 1
}, ViewProperty = {
  CENTER: "center",
  RESOLUTION: "resolution",
  ROTATION: "rotation"
}, DEFAULT_MAX_ZOOM = 42, DEFAULT_TILE_SIZE = 256;
function createExtent(ie, Z, ee) {
  return (
    /**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */
    function(ae, ve, ye, be, Ye) {
      if (!ae)
        return;
      if (!ve && !Z)
        return ae;
      const Qe = Z ? 0 : ye[0] * ve, Je = Z ? 0 : ye[1] * ve, nt = Ye ? Ye[0] : 0, st = Ye ? Ye[1] : 0;
      let ot = ie[0] + Qe / 2 + nt, lt = ie[2] - Qe / 2 + nt, ft = ie[1] + Je / 2 + st, gt = ie[3] - Je / 2 + st;
      ot > lt && (ot = (lt + ot) / 2, lt = ot), ft > gt && (ft = (gt + ft) / 2, gt = ft);
      let ct = clamp$1(ae[0], ot, lt), _r = clamp$1(ae[1], ft, gt);
      if (be && ee && ve) {
        const Kr = 30 * ve;
        ct += -Kr * Math.log(1 + Math.max(0, ot - ae[0]) / Kr) + Kr * Math.log(1 + Math.max(0, ae[0] - lt) / Kr), _r += -Kr * Math.log(1 + Math.max(0, ft - ae[1]) / Kr) + Kr * Math.log(1 + Math.max(0, ae[1] - gt) / Kr);
      }
      return [ct, _r];
    }
  );
}
function none$1(ie) {
  return ie;
}
function getViewportClampedResolution(ie, Z, ee, ae) {
  const ve = getWidth(Z) / ee[0], ye = getHeight(Z) / ee[1];
  return ae ? Math.min(ie, Math.max(ve, ye)) : Math.min(ie, Math.min(ve, ye));
}
function getSmoothClampedResolution(ie, Z, ee) {
  let ae = Math.min(ie, Z);
  const ve = 50;
  return ae *= Math.log(1 + ve * Math.max(0, ie / Z - 1)) / ve + 1, ee && (ae = Math.max(ae, ee), ae /= Math.log(1 + ve * Math.max(0, ee / ie - 1)) / ve + 1), clamp$1(ae, ee / 2, Z * 2);
}
function createSnapToResolutions(ie, Z, ee, ae) {
  return Z = Z !== void 0 ? Z : !0, /**
   * @param {number|undefined} resolution Resolution.
   * @param {number} direction Direction.
   * @param {import("./size.js").Size} size Viewport size.
   * @param {boolean} [isMoving] True if an interaction or animation is in progress.
   * @return {number|undefined} Resolution.
   */
  function(ve, ye, be, Ye) {
    if (ve !== void 0) {
      const Qe = ie[0], Je = ie[ie.length - 1], nt = ee ? getViewportClampedResolution(
        Qe,
        ee,
        be,
        ae
      ) : Qe;
      if (Ye)
        return Z ? getSmoothClampedResolution(
          ve,
          nt,
          Je
        ) : clamp$1(ve, Je, nt);
      const st = Math.min(nt, ve), ot = Math.floor(linearFindNearest(ie, st, ye));
      return ie[ot] > nt && ot < ie.length - 1 ? ie[ot + 1] : ie[ot];
    }
  };
}
function createSnapToPower(ie, Z, ee, ae, ve, ye) {
  return ae = ae !== void 0 ? ae : !0, ee = ee !== void 0 ? ee : 0, /**
   * @param {number|undefined} resolution Resolution.
   * @param {number} direction Direction.
   * @param {import("./size.js").Size} size Viewport size.
   * @param {boolean} [isMoving] True if an interaction or animation is in progress.
   * @return {number|undefined} Resolution.
   */
  function(be, Ye, Qe, Je) {
    if (be !== void 0) {
      const nt = ve ? getViewportClampedResolution(
        Z,
        ve,
        Qe,
        ye
      ) : Z;
      if (Je)
        return ae ? getSmoothClampedResolution(
          be,
          nt,
          ee
        ) : clamp$1(be, ee, nt);
      const st = 1e-9, ot = Math.ceil(
        Math.log(Z / nt) / Math.log(ie) - st
      ), lt = -Ye * (0.5 - st) + 0.5, ft = Math.min(nt, be), gt = Math.floor(
        Math.log(Z / ft) / Math.log(ie) + lt
      ), ct = Math.max(ot, gt), _r = Z / Math.pow(ie, ct);
      return clamp$1(_r, ee, nt);
    }
  };
}
function createMinMaxResolution(ie, Z, ee, ae, ve) {
  return ee = ee !== void 0 ? ee : !0, /**
   * @param {number|undefined} resolution Resolution.
   * @param {number} direction Direction.
   * @param {import("./size.js").Size} size Viewport size.
   * @param {boolean} [isMoving] True if an interaction or animation is in progress.
   * @return {number|undefined} Resolution.
   */
  function(ye, be, Ye, Qe) {
    if (ye !== void 0) {
      const Je = ae ? getViewportClampedResolution(
        ie,
        ae,
        Ye,
        ve
      ) : ie;
      return !ee || !Qe ? clamp$1(ye, Z, Je) : getSmoothClampedResolution(
        ye,
        Je,
        Z
      );
    }
  };
}
function disable(ie) {
  if (ie !== void 0)
    return 0;
}
function none(ie) {
  if (ie !== void 0)
    return ie;
}
function createSnapToN(ie) {
  const Z = 2 * Math.PI / ie;
  return (
    /**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */
    function(ee, ae) {
      if (ae)
        return ee;
      if (ee !== void 0)
        return ee = Math.floor(ee / Z + 0.5) * Z, ee;
    }
  );
}
function createSnapToZero(ie) {
  return ie = ie || toRadians(5), /**
   * @param {number|undefined} rotation Rotation.
   * @param {boolean} [isMoving] True if an interaction or animation is in progress.
   * @return {number|undefined} Rotation.
   */
  function(Z, ee) {
    if (ee)
      return Z;
    if (Z !== void 0)
      return Math.abs(Z) <= ie ? 0 : Z;
  };
}
function easeIn(ie) {
  return Math.pow(ie, 3);
}
function easeOut(ie) {
  return 1 - easeIn(1 - ie);
}
function inAndOut(ie) {
  return 3 * ie * ie - 2 * ie * ie * ie;
}
function linear(ie) {
  return ie;
}
const DEFAULT_MIN_ZOOM = 0;
class View extends BaseObject {
  /**
   * @param {ViewOptions} [options] View options.
   */
  constructor(Z) {
    super(), this.on, this.once, this.un, Z = Object.assign({}, Z), this.hints_ = [0, 0], this.animations_ = [], this.updateAnimationKey_, this.projection_ = createProjection(Z.projection, "EPSG:3857"), this.viewportSize_ = [100, 100], this.targetCenter_ = null, this.targetResolution_, this.targetRotation_, this.nextCenter_ = null, this.nextResolution_, this.nextRotation_, this.cancelAnchor_ = void 0, Z.projection && disableCoordinateWarning(), Z.center && (Z.center = fromUserCoordinate(Z.center, this.projection_)), Z.extent && (Z.extent = fromUserExtent(Z.extent, this.projection_)), this.applyOptions_(Z);
  }
  /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */
  applyOptions_(Z) {
    const ee = Object.assign({}, Z);
    for (const Ye in ViewProperty)
      delete ee[Ye];
    this.setProperties(ee, !0);
    const ae = createResolutionConstraint(Z);
    this.maxResolution_ = ae.maxResolution, this.minResolution_ = ae.minResolution, this.zoomFactor_ = ae.zoomFactor, this.resolutions_ = Z.resolutions, this.padding_ = Z.padding, this.minZoom_ = ae.minZoom;
    const ve = createCenterConstraint(Z), ye = ae.constraint, be = createRotationConstraint(Z);
    this.constraints_ = {
      center: ve,
      resolution: ye,
      rotation: be
    }, this.setRotation(Z.rotation !== void 0 ? Z.rotation : 0), this.setCenterInternal(
      Z.center !== void 0 ? Z.center : null
    ), Z.resolution !== void 0 ? this.setResolution(Z.resolution) : Z.zoom !== void 0 && this.setZoom(Z.zoom);
  }
  /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */
  get padding() {
    return this.padding_;
  }
  set padding(Z) {
    let ee = this.padding_;
    this.padding_ = Z;
    const ae = this.getCenterInternal();
    if (ae) {
      const ve = Z || [0, 0, 0, 0];
      ee = ee || [0, 0, 0, 0];
      const ye = this.getResolution(), be = ye / 2 * (ve[3] - ee[3] + ee[1] - ve[1]), Ye = ye / 2 * (ve[0] - ee[0] + ee[2] - ve[2]);
      this.setCenterInternal([ae[0] + be, ae[1] - Ye]);
    }
  }
  /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */
  getUpdatedOptions_(Z) {
    const ee = this.getProperties();
    return ee.resolution !== void 0 ? ee.resolution = this.getResolution() : ee.zoom = this.getZoom(), ee.center = this.getCenterInternal(), ee.rotation = this.getRotation(), Object.assign({}, ee, Z);
  }
  /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */
  animate(Z) {
    this.isDef() && !this.getAnimating() && this.resolveConstraints(0);
    const ee = new Array(arguments.length);
    for (let ae = 0; ae < ee.length; ++ae) {
      let ve = arguments[ae];
      ve.center && (ve = Object.assign({}, ve), ve.center = fromUserCoordinate(
        ve.center,
        this.getProjection()
      )), ve.anchor && (ve = Object.assign({}, ve), ve.anchor = fromUserCoordinate(
        ve.anchor,
        this.getProjection()
      )), ee[ae] = ve;
    }
    this.animateInternal.apply(this, ee);
  }
  /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */
  animateInternal(Z) {
    let ee = arguments.length, ae;
    ee > 1 && typeof arguments[ee - 1] == "function" && (ae = arguments[ee - 1], --ee);
    let ve = 0;
    for (; ve < ee && !this.isDef(); ++ve) {
      const nt = arguments[ve];
      nt.center && this.setCenterInternal(nt.center), nt.zoom !== void 0 ? this.setZoom(nt.zoom) : nt.resolution && this.setResolution(nt.resolution), nt.rotation !== void 0 && this.setRotation(nt.rotation);
    }
    if (ve === ee) {
      ae && animationCallback(ae, !0);
      return;
    }
    let ye = Date.now(), be = this.targetCenter_.slice(), Ye = this.targetResolution_, Qe = this.targetRotation_;
    const Je = [];
    for (; ve < ee; ++ve) {
      const nt = (
        /** @type {AnimationOptions} */
        arguments[ve]
      ), st = {
        start: ye,
        complete: !1,
        anchor: nt.anchor,
        duration: nt.duration !== void 0 ? nt.duration : 1e3,
        easing: nt.easing || inAndOut,
        callback: ae
      };
      if (nt.center && (st.sourceCenter = be, st.targetCenter = nt.center.slice(), be = st.targetCenter), nt.zoom !== void 0 ? (st.sourceResolution = Ye, st.targetResolution = this.getResolutionForZoom(nt.zoom), Ye = st.targetResolution) : nt.resolution && (st.sourceResolution = Ye, st.targetResolution = nt.resolution, Ye = st.targetResolution), nt.rotation !== void 0) {
        st.sourceRotation = Qe;
        const ot = modulo(nt.rotation - Qe + Math.PI, 2 * Math.PI) - Math.PI;
        st.targetRotation = Qe + ot, Qe = st.targetRotation;
      }
      isNoopAnimation(st) ? st.complete = !0 : ye += st.duration, Je.push(st);
    }
    this.animations_.push(Je), this.setHint(ViewHint.ANIMATING, 1), this.updateAnimations_();
  }
  /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */
  getAnimating() {
    return this.hints_[ViewHint.ANIMATING] > 0;
  }
  /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */
  getInteracting() {
    return this.hints_[ViewHint.INTERACTING] > 0;
  }
  /**
   * Cancel any ongoing animations.
   * @api
   */
  cancelAnimations() {
    this.setHint(ViewHint.ANIMATING, -this.hints_[ViewHint.ANIMATING]);
    let Z;
    for (let ee = 0, ae = this.animations_.length; ee < ae; ++ee) {
      const ve = this.animations_[ee];
      if (ve[0].callback && animationCallback(ve[0].callback, !1), !Z)
        for (let ye = 0, be = ve.length; ye < be; ++ye) {
          const Ye = ve[ye];
          if (!Ye.complete) {
            Z = Ye.anchor;
            break;
          }
        }
    }
    this.animations_.length = 0, this.cancelAnchor_ = Z, this.nextCenter_ = null, this.nextResolution_ = NaN, this.nextRotation_ = NaN;
  }
  /**
   * Update all animations.
   */
  updateAnimations_() {
    if (this.updateAnimationKey_ !== void 0 && (cancelAnimationFrame(this.updateAnimationKey_), this.updateAnimationKey_ = void 0), !this.getAnimating())
      return;
    const Z = Date.now();
    let ee = !1;
    for (let ae = this.animations_.length - 1; ae >= 0; --ae) {
      const ve = this.animations_[ae];
      let ye = !0;
      for (let be = 0, Ye = ve.length; be < Ye; ++be) {
        const Qe = ve[be];
        if (Qe.complete)
          continue;
        const Je = Z - Qe.start;
        let nt = Qe.duration > 0 ? Je / Qe.duration : 1;
        nt >= 1 ? (Qe.complete = !0, nt = 1) : ye = !1;
        const st = Qe.easing(nt);
        if (Qe.sourceCenter) {
          const ot = Qe.sourceCenter[0], lt = Qe.sourceCenter[1], ft = Qe.targetCenter[0], gt = Qe.targetCenter[1];
          this.nextCenter_ = Qe.targetCenter;
          const ct = ot + st * (ft - ot), _r = lt + st * (gt - lt);
          this.targetCenter_ = [ct, _r];
        }
        if (Qe.sourceResolution && Qe.targetResolution) {
          const ot = st === 1 ? Qe.targetResolution : Qe.sourceResolution + st * (Qe.targetResolution - Qe.sourceResolution);
          if (Qe.anchor) {
            const lt = this.getViewportSize_(this.getRotation()), ft = this.constraints_.resolution(
              ot,
              0,
              lt,
              !0
            );
            this.targetCenter_ = this.calculateCenterZoom(
              ft,
              Qe.anchor
            );
          }
          this.nextResolution_ = Qe.targetResolution, this.targetResolution_ = ot, this.applyTargetState_(!0);
        }
        if (Qe.sourceRotation !== void 0 && Qe.targetRotation !== void 0) {
          const ot = st === 1 ? modulo(Qe.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : Qe.sourceRotation + st * (Qe.targetRotation - Qe.sourceRotation);
          if (Qe.anchor) {
            const lt = this.constraints_.rotation(
              ot,
              !0
            );
            this.targetCenter_ = this.calculateCenterRotate(
              lt,
              Qe.anchor
            );
          }
          this.nextRotation_ = Qe.targetRotation, this.targetRotation_ = ot;
        }
        if (this.applyTargetState_(!0), ee = !0, !Qe.complete)
          break;
      }
      if (ye) {
        this.animations_[ae] = null, this.setHint(ViewHint.ANIMATING, -1), this.nextCenter_ = null, this.nextResolution_ = NaN, this.nextRotation_ = NaN;
        const be = ve[0].callback;
        be && animationCallback(be, !0);
      }
    }
    this.animations_ = this.animations_.filter(Boolean), ee && this.updateAnimationKey_ === void 0 && (this.updateAnimationKey_ = requestAnimationFrame(
      this.updateAnimations_.bind(this)
    ));
  }
  /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */
  calculateCenterRotate(Z, ee) {
    let ae;
    const ve = this.getCenterInternal();
    return ve !== void 0 && (ae = [ve[0] - ee[0], ve[1] - ee[1]], rotate$2(ae, Z - this.getRotation()), add(ae, ee)), ae;
  }
  /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */
  calculateCenterZoom(Z, ee) {
    let ae;
    const ve = this.getCenterInternal(), ye = this.getResolution();
    if (ve !== void 0 && ye !== void 0) {
      const be = ee[0] - Z * (ee[0] - ve[0]) / ye, Ye = ee[1] - Z * (ee[1] - ve[1]) / ye;
      ae = [be, Ye];
    }
    return ae;
  }
  /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */
  getViewportSize_(Z) {
    const ee = this.viewportSize_;
    if (Z) {
      const ae = ee[0], ve = ee[1];
      return [
        Math.abs(ae * Math.cos(Z)) + Math.abs(ve * Math.sin(Z)),
        Math.abs(ae * Math.sin(Z)) + Math.abs(ve * Math.cos(Z))
      ];
    }
    return ee;
  }
  /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */
  setViewportSize(Z) {
    this.viewportSize_ = Array.isArray(Z) ? Z.slice() : [100, 100], this.getAnimating() || this.resolveConstraints(0);
  }
  /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */
  getCenter() {
    const Z = this.getCenterInternal();
    return Z && toUserCoordinate(Z, this.getProjection());
  }
  /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */
  getCenterInternal() {
    return (
      /** @type {import("./coordinate.js").Coordinate|undefined} */
      this.get(ViewProperty.CENTER)
    );
  }
  /**
   * @return {Constraints} Constraints.
   */
  getConstraints() {
    return this.constraints_;
  }
  /**
   * @return {boolean} Resolution constraint is set
   */
  getConstrainResolution() {
    return this.get("constrainResolution");
  }
  /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */
  getHints(Z) {
    return Z !== void 0 ? (Z[0] = this.hints_[0], Z[1] = this.hints_[1], Z) : this.hints_.slice();
  }
  /**
   * Calculate the extent for the current view state and the passed size.
   * The size is the pixel dimensions of the box into which the calculated extent
   * should fit. In most cases you want to get the extent of the entire map,
   * that is `map.getSize()`.
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided, the size
   * of the map that uses this view will be used.
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */
  calculateExtent(Z) {
    const ee = this.calculateExtentInternal(Z);
    return toUserExtent(ee, this.getProjection());
  }
  /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */
  calculateExtentInternal(Z) {
    Z = Z || this.getViewportSizeMinusPadding_();
    const ee = (
      /** @type {!import("./coordinate.js").Coordinate} */
      this.getCenterInternal()
    );
    assert(ee, "The view center is not defined");
    const ae = (
      /** @type {!number} */
      this.getResolution()
    );
    assert(ae !== void 0, "The view resolution is not defined");
    const ve = (
      /** @type {!number} */
      this.getRotation()
    );
    return assert(ve !== void 0, "The view rotation is not defined"), getForViewAndSize(ee, ae, ve, Z);
  }
  /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */
  getMaxResolution() {
    return this.maxResolution_;
  }
  /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */
  getMinResolution() {
    return this.minResolution_;
  }
  /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */
  getMaxZoom() {
    return (
      /** @type {number} */
      this.getZoomForResolution(this.minResolution_)
    );
  }
  /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */
  setMaxZoom(Z) {
    this.applyOptions_(this.getUpdatedOptions_({ maxZoom: Z }));
  }
  /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */
  getMinZoom() {
    return (
      /** @type {number} */
      this.getZoomForResolution(this.maxResolution_)
    );
  }
  /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */
  setMinZoom(Z) {
    this.applyOptions_(this.getUpdatedOptions_({ minZoom: Z }));
  }
  /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */
  setConstrainResolution(Z) {
    this.applyOptions_(this.getUpdatedOptions_({ constrainResolution: Z }));
  }
  /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */
  getProjection() {
    return this.projection_;
  }
  /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */
  getResolution() {
    return (
      /** @type {number|undefined} */
      this.get(ViewProperty.RESOLUTION)
    );
  }
  /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */
  getResolutions() {
    return this.resolutions_;
  }
  /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */
  getResolutionForExtent(Z, ee) {
    return this.getResolutionForExtentInternal(
      fromUserExtent(Z, this.getProjection()),
      ee
    );
  }
  /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */
  getResolutionForExtentInternal(Z, ee) {
    ee = ee || this.getViewportSizeMinusPadding_();
    const ae = getWidth(Z) / ee[0], ve = getHeight(Z) / ee[1];
    return Math.max(ae, ve);
  }
  /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */
  getResolutionForValueFunction(Z) {
    Z = Z || 2;
    const ee = this.getConstrainedResolution(this.maxResolution_), ae = this.minResolution_, ve = Math.log(ee / ae) / Math.log(Z);
    return (
      /**
       * @param {number} value Value.
       * @return {number} Resolution.
       */
      function(ye) {
        return ee / Math.pow(Z, ye * ve);
      }
    );
  }
  /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */
  getRotation() {
    return (
      /** @type {number} */
      this.get(ViewProperty.ROTATION)
    );
  }
  /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */
  getValueForResolutionFunction(Z) {
    const ee = Math.log(Z || 2), ae = this.getConstrainedResolution(this.maxResolution_), ve = this.minResolution_, ye = Math.log(ae / ve) / ee;
    return (
      /**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */
      function(be) {
        return Math.log(ae / be) / ee / ye;
      }
    );
  }
  /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */
  getViewportSizeMinusPadding_(Z) {
    let ee = this.getViewportSize_(Z);
    const ae = this.padding_;
    return ae && (ee = [
      ee[0] - ae[1] - ae[3],
      ee[1] - ae[0] - ae[2]
    ]), ee;
  }
  /**
   * @return {State} View state.
   */
  getState() {
    const Z = this.getProjection(), ee = this.getResolution(), ae = this.getRotation();
    let ve = (
      /** @type {import("./coordinate.js").Coordinate} */
      this.getCenterInternal()
    );
    const ye = this.padding_;
    if (ye) {
      const be = this.getViewportSizeMinusPadding_();
      ve = calculateCenterOn(
        ve,
        this.getViewportSize_(),
        [be[0] / 2 + ye[3], be[1] / 2 + ye[0]],
        ee,
        ae
      );
    }
    return {
      center: ve.slice(0),
      projection: Z !== void 0 ? Z : null,
      resolution: ee,
      nextCenter: this.nextCenter_,
      nextResolution: this.nextResolution_,
      nextRotation: this.nextRotation_,
      rotation: ae,
      zoom: this.getZoom()
    };
  }
  /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */
  getViewStateAndExtent() {
    return {
      viewState: this.getState(),
      extent: this.calculateExtent()
    };
  }
  /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */
  getZoom() {
    let Z;
    const ee = this.getResolution();
    return ee !== void 0 && (Z = this.getZoomForResolution(ee)), Z;
  }
  /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */
  getZoomForResolution(Z) {
    let ee = this.minZoom_ || 0, ae, ve;
    if (this.resolutions_) {
      const ye = linearFindNearest(this.resolutions_, Z, 1);
      ee = ye, ae = this.resolutions_[ye], ye == this.resolutions_.length - 1 ? ve = 2 : ve = ae / this.resolutions_[ye + 1];
    } else
      ae = this.maxResolution_, ve = this.zoomFactor_;
    return ee + Math.log(ae / Z) / Math.log(ve);
  }
  /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */
  getResolutionForZoom(Z) {
    if (this.resolutions_) {
      if (this.resolutions_.length <= 1)
        return 0;
      const ee = clamp$1(
        Math.floor(Z),
        0,
        this.resolutions_.length - 2
      ), ae = this.resolutions_[ee] / this.resolutions_[ee + 1];
      return this.resolutions_[ee] / Math.pow(ae, clamp$1(Z - ee, 0, 1));
    }
    return this.maxResolution_ / Math.pow(this.zoomFactor_, Z - this.minZoom_);
  }
  /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */
  fit(Z, ee) {
    let ae;
    if (assert(
      Array.isArray(Z) || typeof /** @type {?} */
      Z.getSimplifiedGeometry == "function",
      "Invalid extent or geometry provided as `geometry`"
    ), Array.isArray(Z)) {
      assert(
        !isEmpty(Z),
        "Cannot fit empty extent provided as `geometry`"
      );
      const ve = fromUserExtent(Z, this.getProjection());
      ae = fromExtent(ve);
    } else if (Z.getType() === "Circle") {
      const ve = fromUserExtent(
        Z.getExtent(),
        this.getProjection()
      );
      ae = fromExtent(ve), ae.rotate(this.getRotation(), getCenter(ve));
    } else {
      const ve = getUserProjection();
      ve ? ae = /** @type {import("./geom/SimpleGeometry.js").default} */
      Z.clone().transform(ve, this.getProjection()) : ae = Z;
    }
    this.fitInternal(ae, ee);
  }
  /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */
  rotatedExtentForGeometry(Z) {
    const ee = this.getRotation(), ae = Math.cos(ee), ve = Math.sin(-ee), ye = Z.getFlatCoordinates(), be = Z.getStride();
    let Ye = 1 / 0, Qe = 1 / 0, Je = -1 / 0, nt = -1 / 0;
    for (let st = 0, ot = ye.length; st < ot; st += be) {
      const lt = ye[st] * ae - ye[st + 1] * ve, ft = ye[st] * ve + ye[st + 1] * ae;
      Ye = Math.min(Ye, lt), Qe = Math.min(Qe, ft), Je = Math.max(Je, lt), nt = Math.max(nt, ft);
    }
    return [Ye, Qe, Je, nt];
  }
  /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */
  fitInternal(Z, ee) {
    ee = ee || {};
    let ae = ee.size;
    ae || (ae = this.getViewportSizeMinusPadding_());
    const ve = ee.padding !== void 0 ? ee.padding : [0, 0, 0, 0], ye = ee.nearest !== void 0 ? ee.nearest : !1;
    let be;
    ee.minResolution !== void 0 ? be = ee.minResolution : ee.maxZoom !== void 0 ? be = this.getResolutionForZoom(ee.maxZoom) : be = 0;
    const Ye = this.rotatedExtentForGeometry(Z);
    let Qe = this.getResolutionForExtentInternal(Ye, [
      ae[0] - ve[1] - ve[3],
      ae[1] - ve[0] - ve[2]
    ]);
    Qe = isNaN(Qe) ? be : Math.max(Qe, be), Qe = this.getConstrainedResolution(Qe, ye ? 0 : 1);
    const Je = this.getRotation(), nt = Math.sin(Je), st = Math.cos(Je), ot = getCenter(Ye);
    ot[0] += (ve[1] - ve[3]) / 2 * Qe, ot[1] += (ve[0] - ve[2]) / 2 * Qe;
    const lt = ot[0] * st - ot[1] * nt, ft = ot[1] * st + ot[0] * nt, gt = this.getConstrainedCenter([lt, ft], Qe), ct = ee.callback ? ee.callback : VOID;
    ee.duration !== void 0 ? this.animateInternal(
      {
        resolution: Qe,
        center: gt,
        duration: ee.duration,
        easing: ee.easing
      },
      ct
    ) : (this.targetResolution_ = Qe, this.targetCenter_ = gt, this.applyTargetState_(!1, !0), animationCallback(ct, !0));
  }
  /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */
  centerOn(Z, ee, ae) {
    this.centerOnInternal(
      fromUserCoordinate(Z, this.getProjection()),
      ee,
      ae
    );
  }
  /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */
  centerOnInternal(Z, ee, ae) {
    this.setCenterInternal(
      calculateCenterOn(
        Z,
        ee,
        ae,
        this.getResolution(),
        this.getRotation()
      )
    );
  }
  /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */
  calculateCenterShift(Z, ee, ae, ve) {
    let ye;
    const be = this.padding_;
    if (be && Z) {
      const Ye = this.getViewportSizeMinusPadding_(-ae), Qe = calculateCenterOn(
        Z,
        ve,
        [Ye[0] / 2 + be[3], Ye[1] / 2 + be[0]],
        ee,
        ae
      );
      ye = [
        Z[0] - Qe[0],
        Z[1] - Qe[1]
      ];
    }
    return ye;
  }
  /**
   * @return {boolean} Is defined.
   */
  isDef() {
    return !!this.getCenterInternal() && this.getResolution() !== void 0;
  }
  /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */
  adjustCenter(Z) {
    const ee = toUserCoordinate(this.targetCenter_, this.getProjection());
    this.setCenter([
      ee[0] + Z[0],
      ee[1] + Z[1]
    ]);
  }
  /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */
  adjustCenterInternal(Z) {
    const ee = this.targetCenter_;
    this.setCenterInternal([
      ee[0] + Z[0],
      ee[1] + Z[1]
    ]);
  }
  /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */
  adjustResolution(Z, ee) {
    ee = ee && fromUserCoordinate(ee, this.getProjection()), this.adjustResolutionInternal(Z, ee);
  }
  /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */
  adjustResolutionInternal(Z, ee) {
    const ae = this.getAnimating() || this.getInteracting(), ve = this.getViewportSize_(this.getRotation()), ye = this.constraints_.resolution(
      this.targetResolution_ * Z,
      0,
      ve,
      ae
    );
    ee && (this.targetCenter_ = this.calculateCenterZoom(ye, ee)), this.targetResolution_ *= Z, this.applyTargetState_();
  }
  /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */
  adjustZoom(Z, ee) {
    this.adjustResolution(Math.pow(this.zoomFactor_, -Z), ee);
  }
  /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */
  adjustRotation(Z, ee) {
    ee && (ee = fromUserCoordinate(ee, this.getProjection())), this.adjustRotationInternal(Z, ee);
  }
  /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */
  adjustRotationInternal(Z, ee) {
    const ae = this.getAnimating() || this.getInteracting(), ve = this.constraints_.rotation(
      this.targetRotation_ + Z,
      ae
    );
    ee && (this.targetCenter_ = this.calculateCenterRotate(ve, ee)), this.targetRotation_ += Z, this.applyTargetState_();
  }
  /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */
  setCenter(Z) {
    this.setCenterInternal(
      Z && fromUserCoordinate(Z, this.getProjection())
    );
  }
  /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */
  setCenterInternal(Z) {
    this.targetCenter_ = Z, this.applyTargetState_();
  }
  /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */
  setHint(Z, ee) {
    return this.hints_[Z] += ee, this.changed(), this.hints_[Z];
  }
  /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */
  setResolution(Z) {
    this.targetResolution_ = Z, this.applyTargetState_();
  }
  /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */
  setRotation(Z) {
    this.targetRotation_ = Z, this.applyTargetState_();
  }
  /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */
  setZoom(Z) {
    this.setResolution(this.getResolutionForZoom(Z));
  }
  /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */
  applyTargetState_(Z, ee) {
    const ae = this.getAnimating() || this.getInteracting() || ee, ve = this.constraints_.rotation(
      this.targetRotation_,
      ae
    ), ye = this.getViewportSize_(ve), be = this.constraints_.resolution(
      this.targetResolution_,
      0,
      ye,
      ae
    ), Ye = this.constraints_.center(
      this.targetCenter_,
      be,
      ye,
      ae,
      this.calculateCenterShift(
        this.targetCenter_,
        be,
        ve,
        ye
      )
    );
    this.get(ViewProperty.ROTATION) !== ve && this.set(ViewProperty.ROTATION, ve), this.get(ViewProperty.RESOLUTION) !== be && (this.set(ViewProperty.RESOLUTION, be), this.set("zoom", this.getZoom(), !0)), (!Ye || !this.get(ViewProperty.CENTER) || !equals(this.get(ViewProperty.CENTER), Ye)) && this.set(ViewProperty.CENTER, Ye), this.getAnimating() && !Z && this.cancelAnimations(), this.cancelAnchor_ = void 0;
  }
  /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */
  resolveConstraints(Z, ee, ae) {
    Z = Z !== void 0 ? Z : 200;
    const ve = ee || 0, ye = this.constraints_.rotation(this.targetRotation_), be = this.getViewportSize_(ye), Ye = this.constraints_.resolution(
      this.targetResolution_,
      ve,
      be
    ), Qe = this.constraints_.center(
      this.targetCenter_,
      Ye,
      be,
      !1,
      this.calculateCenterShift(
        this.targetCenter_,
        Ye,
        ye,
        be
      )
    );
    if (Z === 0 && !this.cancelAnchor_) {
      this.targetResolution_ = Ye, this.targetRotation_ = ye, this.targetCenter_ = Qe, this.applyTargetState_();
      return;
    }
    ae = ae || (Z === 0 ? this.cancelAnchor_ : void 0), this.cancelAnchor_ = void 0, (this.getResolution() !== Ye || this.getRotation() !== ye || !this.getCenterInternal() || !equals(this.getCenterInternal(), Qe)) && (this.getAnimating() && this.cancelAnimations(), this.animateInternal({
      rotation: ye,
      center: Qe,
      resolution: Ye,
      duration: Z,
      easing: easeOut,
      anchor: ae
    }));
  }
  /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */
  beginInteraction() {
    this.resolveConstraints(0), this.setHint(ViewHint.INTERACTING, 1);
  }
  /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */
  endInteraction(Z, ee, ae) {
    ae = ae && fromUserCoordinate(ae, this.getProjection()), this.endInteractionInternal(Z, ee, ae);
  }
  /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */
  endInteractionInternal(Z, ee, ae) {
    this.getInteracting() && (this.setHint(ViewHint.INTERACTING, -1), this.resolveConstraints(Z, ee, ae));
  }
  /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */
  getConstrainedCenter(Z, ee) {
    const ae = this.getViewportSize_(this.getRotation());
    return this.constraints_.center(
      Z,
      ee || this.getResolution(),
      ae
    );
  }
  /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */
  getConstrainedZoom(Z, ee) {
    const ae = this.getResolutionForZoom(Z);
    return this.getZoomForResolution(
      this.getConstrainedResolution(ae, ee)
    );
  }
  /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */
  getConstrainedResolution(Z, ee) {
    ee = ee || 0;
    const ae = this.getViewportSize_(this.getRotation());
    return this.constraints_.resolution(Z, ee, ae);
  }
}
function animationCallback(ie, Z) {
  setTimeout(function() {
    ie(Z);
  }, 0);
}
function createCenterConstraint(ie) {
  if (ie.extent !== void 0) {
    const ee = ie.smoothExtentConstraint !== void 0 ? ie.smoothExtentConstraint : !0;
    return createExtent(ie.extent, ie.constrainOnlyCenter, ee);
  }
  const Z = createProjection(ie.projection, "EPSG:3857");
  if (ie.multiWorld !== !0 && Z.isGlobal()) {
    const ee = Z.getExtent().slice();
    return ee[0] = -1 / 0, ee[2] = 1 / 0, createExtent(ee, !1, !1);
  }
  return none$1;
}
function createResolutionConstraint(ie) {
  let Z, ee, ae, be = ie.minZoom !== void 0 ? ie.minZoom : DEFAULT_MIN_ZOOM, Ye = ie.maxZoom !== void 0 ? ie.maxZoom : 28;
  const Qe = ie.zoomFactor !== void 0 ? ie.zoomFactor : 2, Je = ie.multiWorld !== void 0 ? ie.multiWorld : !1, nt = ie.smoothResolutionConstraint !== void 0 ? ie.smoothResolutionConstraint : !0, st = ie.showFullExtent !== void 0 ? ie.showFullExtent : !1, ot = createProjection(ie.projection, "EPSG:3857"), lt = ot.getExtent();
  let ft = ie.constrainOnlyCenter, gt = ie.extent;
  if (!Je && !gt && ot.isGlobal() && (ft = !1, gt = lt), ie.resolutions !== void 0) {
    const ct = ie.resolutions;
    ee = ct[be], ae = ct[Ye] !== void 0 ? ct[Ye] : ct[ct.length - 1], ie.constrainResolution ? Z = createSnapToResolutions(
      ct,
      nt,
      !ft && gt,
      st
    ) : Z = createMinMaxResolution(
      ee,
      ae,
      nt,
      !ft && gt,
      st
    );
  } else {
    const _r = (lt ? Math.max(getWidth(lt), getHeight(lt)) : (
      // use an extent that can fit the whole world if need be
      360 * METERS_PER_UNIT$1.degrees / ot.getMetersPerUnit()
    )) / DEFAULT_TILE_SIZE / Math.pow(2, DEFAULT_MIN_ZOOM), Kr = _r / Math.pow(2, 28 - DEFAULT_MIN_ZOOM);
    ee = ie.maxResolution, ee !== void 0 ? be = 0 : ee = _r / Math.pow(Qe, be), ae = ie.minResolution, ae === void 0 && (ie.maxZoom !== void 0 ? ie.maxResolution !== void 0 ? ae = ee / Math.pow(Qe, Ye) : ae = _r / Math.pow(Qe, Ye) : ae = Kr), Ye = be + Math.floor(
      Math.log(ee / ae) / Math.log(Qe)
    ), ae = ee / Math.pow(Qe, Ye - be), ie.constrainResolution ? Z = createSnapToPower(
      Qe,
      ee,
      ae,
      nt,
      !ft && gt,
      st
    ) : Z = createMinMaxResolution(
      ee,
      ae,
      nt,
      !ft && gt,
      st
    );
  }
  return {
    constraint: Z,
    maxResolution: ee,
    minResolution: ae,
    minZoom: be,
    zoomFactor: Qe
  };
}
function createRotationConstraint(ie) {
  if (ie.enableRotation !== void 0 ? ie.enableRotation : !0) {
    const ee = ie.constrainRotation;
    return ee === void 0 || ee === !0 ? createSnapToZero() : ee === !1 ? none : typeof ee == "number" ? createSnapToN(ee) : none;
  }
  return disable;
}
function isNoopAnimation(ie) {
  return !(ie.sourceCenter && ie.targetCenter && !equals(ie.sourceCenter, ie.targetCenter) || ie.sourceResolution !== ie.targetResolution || ie.sourceRotation !== ie.targetRotation);
}
function calculateCenterOn(ie, Z, ee, ae, ve) {
  const ye = Math.cos(-ve);
  let be = Math.sin(-ve), Ye = ie[0] * ye - ie[1] * be, Qe = ie[1] * ye + ie[0] * be;
  Ye += (Z[0] / 2 - ee[0]) * ae, Qe += (ee[1] - Z[1] / 2) * ae, be = -be;
  const Je = Ye * ye - Qe * be, nt = Qe * ye + Ye * be;
  return [Je, nt];
}
class Layer extends BaseLayer {
  /**
   * @param {Options<SourceType>} options Layer options.
   */
  constructor(Z) {
    const ee = Object.assign({}, Z);
    delete ee.source, super(ee), this.on, this.once, this.un, this.mapPrecomposeKey_ = null, this.mapRenderKey_ = null, this.sourceChangeKey_ = null, this.renderer_ = null, this.sourceReady_ = !1, this.rendered = !1, Z.render && (this.render = Z.render), Z.map && this.setMap(Z.map), this.addChangeListener(
      LayerProperty.SOURCE,
      this.handleSourcePropertyChange_
    );
    const ae = Z.source ? (
      /** @type {SourceType} */
      Z.source
    ) : null;
    this.setSource(ae);
  }
  /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */
  getLayersArray(Z) {
    return Z = Z || [], Z.push(this), Z;
  }
  /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */
  getLayerStatesArray(Z) {
    return Z = Z || [], Z.push(this.getLayerState()), Z;
  }
  /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */
  getSource() {
    return (
      /** @type {SourceType} */
      this.get(LayerProperty.SOURCE) || null
    );
  }
  /**
   * @return {SourceType|null} The source being rendered.
   */
  getRenderSource() {
    return this.getSource();
  }
  /**
   * @return {import("../source/Source.js").State} Source state.
   */
  getSourceState() {
    const Z = this.getSource();
    return Z ? Z.getState() : "undefined";
  }
  /**
   * @private
   */
  handleSourceChange_() {
    this.changed(), !(this.sourceReady_ || this.getSource().getState() !== "ready") && (this.sourceReady_ = !0, this.dispatchEvent("sourceready"));
  }
  /**
   * @private
   */
  handleSourcePropertyChange_() {
    this.sourceChangeKey_ && (unlistenByKey(this.sourceChangeKey_), this.sourceChangeKey_ = null), this.sourceReady_ = !1;
    const Z = this.getSource();
    Z && (this.sourceChangeKey_ = listen(
      Z,
      EventType.CHANGE,
      this.handleSourceChange_,
      this
    ), Z.getState() === "ready" && (this.sourceReady_ = !0, setTimeout(() => {
      this.dispatchEvent("sourceready");
    }, 0))), this.changed();
  }
  /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */
  getFeatures(Z) {
    return this.renderer_ ? this.renderer_.getFeatures(Z) : Promise.resolve([]);
  }
  /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */
  getData(Z) {
    return !this.renderer_ || !this.rendered ? null : this.renderer_.getData(Z);
  }
  /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */
  isVisible(Z) {
    let ee;
    const ae = this.getMapInternal();
    !Z && ae && (Z = ae.getView()), Z instanceof View ? ee = {
      viewState: Z.getState(),
      extent: Z.calculateExtent()
    } : ee = Z, !ee.layerStatesArray && ae && (ee.layerStatesArray = ae.getLayerGroup().getLayerStatesArray());
    let ve;
    ee.layerStatesArray ? ve = ee.layerStatesArray.find(
      (be) => be.layer === this
    ) : ve = this.getLayerState();
    const ye = this.getExtent();
    return inView(ve, ee.viewState) && (!ye || intersects$1(ye, ee.extent));
  }
  /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */
  getAttributions(Z) {
    if (!this.isVisible(Z))
      return [];
    let ee;
    const ae = this.getSource();
    if (ae && (ee = ae.getAttributions()), !ee)
      return [];
    const ve = Z instanceof View ? Z.getViewStateAndExtent() : Z;
    let ye = ee(ve);
    return Array.isArray(ye) || (ye = [ye]), ye;
  }
  /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */
  render(Z, ee) {
    const ae = this.getRenderer();
    return ae.prepareFrame(Z) ? (this.rendered = !0, ae.renderFrame(Z, ee)) : null;
  }
  /**
   * Called when a layer is not visible during a map render.
   */
  unrender() {
    this.rendered = !1;
  }
  /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */
  setMapInternal(Z) {
    Z || this.unrender(), this.set(LayerProperty.MAP, Z);
  }
  /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */
  getMapInternal() {
    return this.get(LayerProperty.MAP);
  }
  /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */
  setMap(Z) {
    this.mapPrecomposeKey_ && (unlistenByKey(this.mapPrecomposeKey_), this.mapPrecomposeKey_ = null), Z || this.changed(), this.mapRenderKey_ && (unlistenByKey(this.mapRenderKey_), this.mapRenderKey_ = null), Z && (this.mapPrecomposeKey_ = listen(
      Z,
      RenderEventType.PRECOMPOSE,
      function(ee) {
        const ve = /** @type {import("../render/Event.js").default} */ ee.frameState.layerStatesArray, ye = this.getLayerState(!1);
        assert(
          !ve.some(function(be) {
            return be.layer === ye.layer;
          }),
          "A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both."
        ), ve.push(ye);
      },
      this
    ), this.mapRenderKey_ = listen(this, EventType.CHANGE, Z.render, Z), this.changed());
  }
  /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */
  setSource(Z) {
    this.set(LayerProperty.SOURCE, Z);
  }
  /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */
  getRenderer() {
    return this.renderer_ || (this.renderer_ = this.createRenderer()), this.renderer_;
  }
  /**
   * @return {boolean} The layer has a renderer.
   */
  hasRenderer() {
    return !!this.renderer_;
  }
  /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */
  createRenderer() {
    return null;
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    this.renderer_ && (this.renderer_.dispose(), delete this.renderer_), this.setSource(null), super.disposeInternal();
  }
}
function inView(ie, Z) {
  if (!ie.visible)
    return !1;
  const ee = Z.resolution;
  if (ee < ie.minResolution || ee >= ie.maxResolution)
    return !1;
  const ae = Z.zoom;
  return ae > ie.minZoom && ae <= ie.maxZoom;
}
function quickselect(ie, Z, ee, ae, ve) {
  quickselectStep(ie, Z, ee || 0, ae || ie.length - 1, ve || defaultCompare);
}
function quickselectStep(ie, Z, ee, ae, ve) {
  for (; ae > ee; ) {
    if (ae - ee > 600) {
      var ye = ae - ee + 1, be = Z - ee + 1, Ye = Math.log(ye), Qe = 0.5 * Math.exp(2 * Ye / 3), Je = 0.5 * Math.sqrt(Ye * Qe * (ye - Qe) / ye) * (be - ye / 2 < 0 ? -1 : 1), nt = Math.max(ee, Math.floor(Z - be * Qe / ye + Je)), st = Math.min(ae, Math.floor(Z + (ye - be) * Qe / ye + Je));
      quickselectStep(ie, Z, nt, st, ve);
    }
    var ot = ie[Z], lt = ee, ft = ae;
    for (swap(ie, ee, Z), ve(ie[ae], ot) > 0 && swap(ie, ee, ae); lt < ft; ) {
      for (swap(ie, lt, ft), lt++, ft--; ve(ie[lt], ot) < 0; )
        lt++;
      for (; ve(ie[ft], ot) > 0; )
        ft--;
    }
    ve(ie[ee], ot) === 0 ? swap(ie, ee, ft) : (ft++, swap(ie, ft, ae)), ft <= Z && (ee = ft + 1), Z <= ft && (ae = ft - 1);
  }
}
function swap(ie, Z, ee) {
  var ae = ie[Z];
  ie[Z] = ie[ee], ie[ee] = ae;
}
function defaultCompare(ie, Z) {
  return ie < Z ? -1 : ie > Z ? 1 : 0;
}
class RBush {
  constructor(Z = 9) {
    this._maxEntries = Math.max(4, Z), this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4)), this.clear();
  }
  all() {
    return this._all(this.data, []);
  }
  search(Z) {
    let ee = this.data;
    const ae = [];
    if (!intersects(Z, ee))
      return ae;
    const ve = this.toBBox, ye = [];
    for (; ee; ) {
      for (let be = 0; be < ee.children.length; be++) {
        const Ye = ee.children[be], Qe = ee.leaf ? ve(Ye) : Ye;
        intersects(Z, Qe) && (ee.leaf ? ae.push(Ye) : contains(Z, Qe) ? this._all(Ye, ae) : ye.push(Ye));
      }
      ee = ye.pop();
    }
    return ae;
  }
  collides(Z) {
    let ee = this.data;
    if (!intersects(Z, ee))
      return !1;
    const ae = [];
    for (; ee; ) {
      for (let ve = 0; ve < ee.children.length; ve++) {
        const ye = ee.children[ve], be = ee.leaf ? this.toBBox(ye) : ye;
        if (intersects(Z, be)) {
          if (ee.leaf || contains(Z, be))
            return !0;
          ae.push(ye);
        }
      }
      ee = ae.pop();
    }
    return !1;
  }
  load(Z) {
    if (!(Z && Z.length))
      return this;
    if (Z.length < this._minEntries) {
      for (let ae = 0; ae < Z.length; ae++)
        this.insert(Z[ae]);
      return this;
    }
    let ee = this._build(Z.slice(), 0, Z.length - 1, 0);
    if (!this.data.children.length)
      this.data = ee;
    else if (this.data.height === ee.height)
      this._splitRoot(this.data, ee);
    else {
      if (this.data.height < ee.height) {
        const ae = this.data;
        this.data = ee, ee = ae;
      }
      this._insert(ee, this.data.height - ee.height - 1, !0);
    }
    return this;
  }
  insert(Z) {
    return Z && this._insert(Z, this.data.height - 1), this;
  }
  clear() {
    return this.data = createNode([]), this;
  }
  remove(Z, ee) {
    if (!Z)
      return this;
    let ae = this.data;
    const ve = this.toBBox(Z), ye = [], be = [];
    let Ye, Qe, Je;
    for (; ae || ye.length; ) {
      if (ae || (ae = ye.pop(), Qe = ye[ye.length - 1], Ye = be.pop(), Je = !0), ae.leaf) {
        const nt = findItem(Z, ae.children, ee);
        if (nt !== -1)
          return ae.children.splice(nt, 1), ye.push(ae), this._condense(ye), this;
      }
      !Je && !ae.leaf && contains(ae, ve) ? (ye.push(ae), be.push(Ye), Ye = 0, Qe = ae, ae = ae.children[0]) : Qe ? (Ye++, ae = Qe.children[Ye], Je = !1) : ae = null;
    }
    return this;
  }
  toBBox(Z) {
    return Z;
  }
  compareMinX(Z, ee) {
    return Z.minX - ee.minX;
  }
  compareMinY(Z, ee) {
    return Z.minY - ee.minY;
  }
  toJSON() {
    return this.data;
  }
  fromJSON(Z) {
    return this.data = Z, this;
  }
  _all(Z, ee) {
    const ae = [];
    for (; Z; )
      Z.leaf ? ee.push(...Z.children) : ae.push(...Z.children), Z = ae.pop();
    return ee;
  }
  _build(Z, ee, ae, ve) {
    const ye = ae - ee + 1;
    let be = this._maxEntries, Ye;
    if (ye <= be)
      return Ye = createNode(Z.slice(ee, ae + 1)), calcBBox(Ye, this.toBBox), Ye;
    ve || (ve = Math.ceil(Math.log(ye) / Math.log(be)), be = Math.ceil(ye / Math.pow(be, ve - 1))), Ye = createNode([]), Ye.leaf = !1, Ye.height = ve;
    const Qe = Math.ceil(ye / be), Je = Qe * Math.ceil(Math.sqrt(be));
    multiSelect(Z, ee, ae, Je, this.compareMinX);
    for (let nt = ee; nt <= ae; nt += Je) {
      const st = Math.min(nt + Je - 1, ae);
      multiSelect(Z, nt, st, Qe, this.compareMinY);
      for (let ot = nt; ot <= st; ot += Qe) {
        const lt = Math.min(ot + Qe - 1, st);
        Ye.children.push(this._build(Z, ot, lt, ve - 1));
      }
    }
    return calcBBox(Ye, this.toBBox), Ye;
  }
  _chooseSubtree(Z, ee, ae, ve) {
    for (; ve.push(ee), !(ee.leaf || ve.length - 1 === ae); ) {
      let ye = 1 / 0, be = 1 / 0, Ye;
      for (let Qe = 0; Qe < ee.children.length; Qe++) {
        const Je = ee.children[Qe], nt = bboxArea(Je), st = enlargedArea(Z, Je) - nt;
        st < be ? (be = st, ye = nt < ye ? nt : ye, Ye = Je) : st === be && nt < ye && (ye = nt, Ye = Je);
      }
      ee = Ye || ee.children[0];
    }
    return ee;
  }
  _insert(Z, ee, ae) {
    const ve = ae ? Z : this.toBBox(Z), ye = [], be = this._chooseSubtree(ve, this.data, ee, ye);
    for (be.children.push(Z), extend(be, ve); ee >= 0 && ye[ee].children.length > this._maxEntries; )
      this._split(ye, ee), ee--;
    this._adjustParentBBoxes(ve, ye, ee);
  }
  // split overflowed node into two
  _split(Z, ee) {
    const ae = Z[ee], ve = ae.children.length, ye = this._minEntries;
    this._chooseSplitAxis(ae, ye, ve);
    const be = this._chooseSplitIndex(ae, ye, ve), Ye = createNode(ae.children.splice(be, ae.children.length - be));
    Ye.height = ae.height, Ye.leaf = ae.leaf, calcBBox(ae, this.toBBox), calcBBox(Ye, this.toBBox), ee ? Z[ee - 1].children.push(Ye) : this._splitRoot(ae, Ye);
  }
  _splitRoot(Z, ee) {
    this.data = createNode([Z, ee]), this.data.height = Z.height + 1, this.data.leaf = !1, calcBBox(this.data, this.toBBox);
  }
  _chooseSplitIndex(Z, ee, ae) {
    let ve, ye = 1 / 0, be = 1 / 0;
    for (let Ye = ee; Ye <= ae - ee; Ye++) {
      const Qe = distBBox(Z, 0, Ye, this.toBBox), Je = distBBox(Z, Ye, ae, this.toBBox), nt = intersectionArea(Qe, Je), st = bboxArea(Qe) + bboxArea(Je);
      nt < ye ? (ye = nt, ve = Ye, be = st < be ? st : be) : nt === ye && st < be && (be = st, ve = Ye);
    }
    return ve || ae - ee;
  }
  // sorts node children by the best axis for split
  _chooseSplitAxis(Z, ee, ae) {
    const ve = Z.leaf ? this.compareMinX : compareNodeMinX, ye = Z.leaf ? this.compareMinY : compareNodeMinY, be = this._allDistMargin(Z, ee, ae, ve), Ye = this._allDistMargin(Z, ee, ae, ye);
    be < Ye && Z.children.sort(ve);
  }
  // total margin of all possible split distributions where each node is at least m full
  _allDistMargin(Z, ee, ae, ve) {
    Z.children.sort(ve);
    const ye = this.toBBox, be = distBBox(Z, 0, ee, ye), Ye = distBBox(Z, ae - ee, ae, ye);
    let Qe = bboxMargin(be) + bboxMargin(Ye);
    for (let Je = ee; Je < ae - ee; Je++) {
      const nt = Z.children[Je];
      extend(be, Z.leaf ? ye(nt) : nt), Qe += bboxMargin(be);
    }
    for (let Je = ae - ee - 1; Je >= ee; Je--) {
      const nt = Z.children[Je];
      extend(Ye, Z.leaf ? ye(nt) : nt), Qe += bboxMargin(Ye);
    }
    return Qe;
  }
  _adjustParentBBoxes(Z, ee, ae) {
    for (let ve = ae; ve >= 0; ve--)
      extend(ee[ve], Z);
  }
  _condense(Z) {
    for (let ee = Z.length - 1, ae; ee >= 0; ee--)
      Z[ee].children.length === 0 ? ee > 0 ? (ae = Z[ee - 1].children, ae.splice(ae.indexOf(Z[ee]), 1)) : this.clear() : calcBBox(Z[ee], this.toBBox);
  }
}
function findItem(ie, Z, ee) {
  if (!ee)
    return Z.indexOf(ie);
  for (let ae = 0; ae < Z.length; ae++)
    if (ee(ie, Z[ae]))
      return ae;
  return -1;
}
function calcBBox(ie, Z) {
  distBBox(ie, 0, ie.children.length, Z, ie);
}
function distBBox(ie, Z, ee, ae, ve) {
  ve || (ve = createNode(null)), ve.minX = 1 / 0, ve.minY = 1 / 0, ve.maxX = -1 / 0, ve.maxY = -1 / 0;
  for (let ye = Z; ye < ee; ye++) {
    const be = ie.children[ye];
    extend(ve, ie.leaf ? ae(be) : be);
  }
  return ve;
}
function extend(ie, Z) {
  return ie.minX = Math.min(ie.minX, Z.minX), ie.minY = Math.min(ie.minY, Z.minY), ie.maxX = Math.max(ie.maxX, Z.maxX), ie.maxY = Math.max(ie.maxY, Z.maxY), ie;
}
function compareNodeMinX(ie, Z) {
  return ie.minX - Z.minX;
}
function compareNodeMinY(ie, Z) {
  return ie.minY - Z.minY;
}
function bboxArea(ie) {
  return (ie.maxX - ie.minX) * (ie.maxY - ie.minY);
}
function bboxMargin(ie) {
  return ie.maxX - ie.minX + (ie.maxY - ie.minY);
}
function enlargedArea(ie, Z) {
  return (Math.max(Z.maxX, ie.maxX) - Math.min(Z.minX, ie.minX)) * (Math.max(Z.maxY, ie.maxY) - Math.min(Z.minY, ie.minY));
}
function intersectionArea(ie, Z) {
  const ee = Math.max(ie.minX, Z.minX), ae = Math.max(ie.minY, Z.minY), ve = Math.min(ie.maxX, Z.maxX), ye = Math.min(ie.maxY, Z.maxY);
  return Math.max(0, ve - ee) * Math.max(0, ye - ae);
}
function contains(ie, Z) {
  return ie.minX <= Z.minX && ie.minY <= Z.minY && Z.maxX <= ie.maxX && Z.maxY <= ie.maxY;
}
function intersects(ie, Z) {
  return Z.minX <= ie.maxX && Z.minY <= ie.maxY && Z.maxX >= ie.minX && Z.maxY >= ie.minY;
}
function createNode(ie) {
  return {
    children: ie,
    height: 1,
    leaf: !0,
    minX: 1 / 0,
    minY: 1 / 0,
    maxX: -1 / 0,
    maxY: -1 / 0
  };
}
function multiSelect(ie, Z, ee, ae, ve) {
  const ye = [Z, ee];
  for (; ye.length; ) {
    if (ee = ye.pop(), Z = ye.pop(), ee - Z <= ae)
      continue;
    const be = Z + Math.ceil((ee - Z) / ae / 2) * ae;
    quickselect(ie, be, Z, ee, ve), ye.push(Z, be, be, ee);
  }
}
function listenImage(ie, Z, ee) {
  const ae = (
    /** @type {HTMLImageElement} */
    ie
  );
  let ve = !0, ye = !1, be = !1;
  const Ye = [
    listenOnce(ae, EventType.LOAD, function() {
      be = !0, ye || Z();
    })
  ];
  return ae.src && IMAGE_DECODE ? (ye = !0, ae.decode().then(function() {
    ve && Z();
  }).catch(function(Qe) {
    ve && (be ? Z() : ee());
  })) : Ye.push(listenOnce(ae, EventType.ERROR, ee)), function() {
    ve = !1, Ye.forEach(unlistenByKey);
  };
}
function load(ie, Z) {
  return new Promise((ee, ae) => {
    function ve() {
      be(), ee(ie);
    }
    function ye() {
      be(), ae(new Error("Image load error"));
    }
    function be() {
      ie.removeEventListener("load", ve), ie.removeEventListener("error", ye);
    }
    ie.addEventListener("load", ve), ie.addEventListener("error", ye), Z && (ie.src = Z);
  });
}
function decodeFallback(ie, Z) {
  return Z && (ie.src = Z), IMAGE_DECODE ? new Promise(
    (ee, ae) => ie.decode().then(() => ee(ie), ae)
  ) : load(ie);
}
class IconImageCache {
  constructor() {
    this.cache_ = {}, this.cacheSize_ = 0, this.maxCacheSize_ = 32;
  }
  /**
   * FIXME empty description for jsdoc
   */
  clear() {
    this.cache_ = {}, this.cacheSize_ = 0;
  }
  /**
   * @return {boolean} Can expire cache.
   */
  canExpireCache() {
    return this.cacheSize_ > this.maxCacheSize_;
  }
  /**
   * FIXME empty description for jsdoc
   */
  expire() {
    if (this.canExpireCache()) {
      let Z = 0;
      for (const ee in this.cache_) {
        const ae = this.cache_[ee];
        !(Z++ & 3) && !ae.hasListener() && (delete this.cache_[ee], --this.cacheSize_);
      }
    }
  }
  /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */
  get(Z, ee, ae) {
    const ve = getKey$1(Z, ee, ae);
    return ve in this.cache_ ? this.cache_[ve] : null;
  }
  /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color} color Color.
   * @param {import("./IconImage.js").default} iconImage Icon image.
   */
  set(Z, ee, ae, ve) {
    const ye = getKey$1(Z, ee, ae);
    this.cache_[ye] = ve, ++this.cacheSize_;
  }
  /**
   * Set the cache size of the icon cache. Default is `32`. Change this value when
   * your map uses more than 32 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */
  setSize(Z) {
    this.maxCacheSize_ = Z, this.expire();
  }
}
function getKey$1(ie, Z, ee) {
  const ae = ee ? asString(ee) : "null";
  return Z + ":" + ie + ":" + ae;
}
const shared = new IconImageCache();
let taintedTestContext = null;
class IconImage extends Target {
  /**
   * @param {HTMLImageElement|HTMLCanvasElement|ImageBitmap} image Image.
   * @param {string|undefined} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../ImageState.js").default} imageState Image state.
   * @param {import("../color.js").Color} color Color.
   */
  constructor(Z, ee, ae, ve, ye) {
    super(), this.hitDetectionImage_ = null, this.image_ = Z, this.crossOrigin_ = ae, this.canvas_ = {}, this.color_ = ye, this.imageState_ = ve === void 0 ? ImageState.IDLE : ve, this.size_ = Z && Z.width && Z.height ? [Z.width, Z.height] : null, this.src_ = ee, this.tainted_;
  }
  /**
   * @private
   */
  initializeImage_() {
    this.image_ = new Image(), this.crossOrigin_ !== null && (this.image_.crossOrigin = this.crossOrigin_);
  }
  /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */
  isTainted_() {
    if (this.tainted_ === void 0 && this.imageState_ === ImageState.LOADED) {
      taintedTestContext || (taintedTestContext = createCanvasContext2D(1, 1, void 0, {
        willReadFrequently: !0
      })), taintedTestContext.drawImage(this.image_, 0, 0);
      try {
        taintedTestContext.getImageData(0, 0, 1, 1), this.tainted_ = !1;
      } catch {
        taintedTestContext = null, this.tainted_ = !0;
      }
    }
    return this.tainted_ === !0;
  }
  /**
   * @private
   */
  dispatchChangeEvent_() {
    this.dispatchEvent(EventType.CHANGE);
  }
  /**
   * @private
   */
  handleImageError_() {
    this.imageState_ = ImageState.ERROR, this.dispatchChangeEvent_();
  }
  /**
   * @private
   */
  handleImageLoad_() {
    this.imageState_ = ImageState.LOADED, this.size_ = [this.image_.width, this.image_.height], this.dispatchChangeEvent_();
  }
  /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element or image bitmap.
   */
  getImage(Z) {
    return this.image_ || this.initializeImage_(), this.replaceColor_(Z), this.canvas_[Z] ? this.canvas_[Z] : this.image_;
  }
  /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */
  getPixelRatio(Z) {
    return this.replaceColor_(Z), this.canvas_[Z] ? Z : 1;
  }
  /**
   * @return {import("../ImageState.js").default} Image state.
   */
  getImageState() {
    return this.imageState_;
  }
  /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */
  getHitDetectionImage() {
    if (this.image_ || this.initializeImage_(), !this.hitDetectionImage_)
      if (this.isTainted_()) {
        const Z = this.size_[0], ee = this.size_[1], ae = createCanvasContext2D(Z, ee);
        ae.fillRect(0, 0, Z, ee), this.hitDetectionImage_ = ae.canvas;
      } else
        this.hitDetectionImage_ = this.image_;
    return this.hitDetectionImage_;
  }
  /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */
  getSize() {
    return this.size_;
  }
  /**
   * @return {string|undefined} Image src.
   */
  getSrc() {
    return this.src_;
  }
  /**
   * Load not yet loaded URI.
   */
  load() {
    if (this.imageState_ === ImageState.IDLE) {
      this.image_ || this.initializeImage_(), this.imageState_ = ImageState.LOADING;
      try {
        this.src_ !== void 0 && (this.image_.src = this.src_);
      } catch {
        this.handleImageError_();
      }
      this.image_ instanceof HTMLImageElement && decodeFallback(this.image_, this.src_).then((Z) => {
        this.image_ = Z, this.handleImageLoad_();
      }).catch(this.handleImageError_.bind(this));
    }
  }
  /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */
  replaceColor_(Z) {
    if (!this.color_ || this.canvas_[Z] || this.imageState_ !== ImageState.LOADED)
      return;
    const ee = this.image_, ae = document.createElement("canvas");
    ae.width = Math.ceil(ee.width * Z), ae.height = Math.ceil(ee.height * Z);
    const ve = ae.getContext("2d");
    ve.scale(Z, Z), ve.drawImage(ee, 0, 0), ve.globalCompositeOperation = "multiply", ve.fillStyle = asString(this.color_), ve.fillRect(0, 0, ae.width / Z, ae.height / Z), ve.globalCompositeOperation = "destination-in", ve.drawImage(ee, 0, 0), this.canvas_[Z] = ae;
  }
}
function get(ie, Z, ee, ae, ve) {
  let ye = Z === void 0 ? void 0 : shared.get(Z, ee, ve);
  return ye || (ye = new IconImage(
    ie,
    ie instanceof HTMLImageElement ? ie.src || void 0 : Z,
    ee,
    ae,
    ve
  ), shared.set(Z, ee, ve, ye)), ye;
}
function calculateScale(ie, Z, ee, ae) {
  return ee !== void 0 && ae !== void 0 ? [ee / ie, ae / Z] : ee !== void 0 ? ee / ie : ae !== void 0 ? ae / Z : 1;
}
class Icon extends ImageStyle {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {};
    const ee = Z.opacity !== void 0 ? Z.opacity : 1, ae = Z.rotation !== void 0 ? Z.rotation : 0, ve = Z.scale !== void 0 ? Z.scale : 1, ye = Z.rotateWithView !== void 0 ? Z.rotateWithView : !1;
    super({
      opacity: ee,
      rotation: ae,
      scale: ve,
      displacement: Z.displacement !== void 0 ? Z.displacement : [0, 0],
      rotateWithView: ye,
      declutterMode: Z.declutterMode
    }), this.anchor_ = Z.anchor !== void 0 ? Z.anchor : [0.5, 0.5], this.normalizedAnchor_ = null, this.anchorOrigin_ = Z.anchorOrigin !== void 0 ? Z.anchorOrigin : "top-left", this.anchorXUnits_ = Z.anchorXUnits !== void 0 ? Z.anchorXUnits : "fraction", this.anchorYUnits_ = Z.anchorYUnits !== void 0 ? Z.anchorYUnits : "fraction", this.crossOrigin_ = Z.crossOrigin !== void 0 ? Z.crossOrigin : null;
    const be = Z.img !== void 0 ? Z.img : null;
    let Ye = Z.src;
    assert(
      !(Ye !== void 0 && be),
      "`image` and `src` cannot be provided at the same time"
    ), (Ye === void 0 || Ye.length === 0) && be && (Ye = /** @type {HTMLImageElement} */
    be.src || getUid(be)), assert(
      Ye !== void 0 && Ye.length > 0,
      "A defined and non-empty `src` or `image` must be provided"
    ), assert(
      !((Z.width !== void 0 || Z.height !== void 0) && Z.scale !== void 0),
      "`width` or `height` cannot be provided together with `scale`"
    );
    let Qe;
    if (Z.src !== void 0 ? Qe = ImageState.IDLE : be !== void 0 && (be instanceof HTMLImageElement ? be.complete ? Qe = be.src ? ImageState.LOADED : ImageState.IDLE : Qe = ImageState.LOADING : Qe = ImageState.LOADED), this.color_ = Z.color !== void 0 ? asArray(Z.color) : null, this.iconImage_ = get(
      be,
      /** @type {string} */
      Ye,
      this.crossOrigin_,
      Qe,
      this.color_
    ), this.offset_ = Z.offset !== void 0 ? Z.offset : [0, 0], this.offsetOrigin_ = Z.offsetOrigin !== void 0 ? Z.offsetOrigin : "top-left", this.origin_ = null, this.size_ = Z.size !== void 0 ? Z.size : null, Z.width !== void 0 || Z.height !== void 0) {
      let Je, nt;
      if (Z.size)
        [Je, nt] = Z.size;
      else {
        const st = this.getImage(1);
        if (st.width && st.height)
          Je = st.width, nt = st.height;
        else if (st instanceof HTMLImageElement) {
          this.initialOptions_ = Z;
          const ot = () => {
            if (this.unlistenImageChange(ot), !this.initialOptions_)
              return;
            const lt = this.iconImage_.getSize();
            this.setScale(
              calculateScale(
                lt[0],
                lt[1],
                Z.width,
                Z.height
              )
            );
          };
          this.listenImageChange(ot);
          return;
        }
      }
      Je !== void 0 && this.setScale(
        calculateScale(Je, nt, Z.width, Z.height)
      );
    }
  }
  /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   */
  clone() {
    let Z, ee, ae;
    return this.initialOptions_ ? (ee = this.initialOptions_.width, ae = this.initialOptions_.height) : (Z = this.getScale(), Z = Array.isArray(Z) ? Z.slice() : Z), new Icon({
      anchor: this.anchor_.slice(),
      anchorOrigin: this.anchorOrigin_,
      anchorXUnits: this.anchorXUnits_,
      anchorYUnits: this.anchorYUnits_,
      color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || void 0,
      crossOrigin: this.crossOrigin_,
      offset: this.offset_.slice(),
      offsetOrigin: this.offsetOrigin_,
      opacity: this.getOpacity(),
      rotateWithView: this.getRotateWithView(),
      rotation: this.getRotation(),
      scale: Z,
      width: ee,
      height: ae,
      size: this.size_ !== null ? this.size_.slice() : void 0,
      src: this.getSrc(),
      displacement: this.getDisplacement().slice(),
      declutterMode: this.getDeclutterMode()
    });
  }
  /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   */
  getAnchor() {
    let Z = this.normalizedAnchor_;
    if (!Z) {
      Z = this.anchor_;
      const ve = this.getSize();
      if (this.anchorXUnits_ == "fraction" || this.anchorYUnits_ == "fraction") {
        if (!ve)
          return null;
        Z = this.anchor_.slice(), this.anchorXUnits_ == "fraction" && (Z[0] *= ve[0]), this.anchorYUnits_ == "fraction" && (Z[1] *= ve[1]);
      }
      if (this.anchorOrigin_ != "top-left") {
        if (!ve)
          return null;
        Z === this.anchor_ && (Z = this.anchor_.slice()), (this.anchorOrigin_ == "top-right" || this.anchorOrigin_ == "bottom-right") && (Z[0] = -Z[0] + ve[0]), (this.anchorOrigin_ == "bottom-left" || this.anchorOrigin_ == "bottom-right") && (Z[1] = -Z[1] + ve[1]);
      }
      this.normalizedAnchor_ = Z;
    }
    const ee = this.getDisplacement(), ae = this.getScaleArray();
    return [
      Z[0] - ee[0] / ae[0],
      Z[1] + ee[1] / ae[1]
    ];
  }
  /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */
  setAnchor(Z) {
    this.anchor_ = Z, this.normalizedAnchor_ = null;
  }
  /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */
  getColor() {
    return this.color_;
  }
  /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   */
  getImage(Z) {
    return this.iconImage_.getImage(Z);
  }
  /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   */
  getPixelRatio(Z) {
    return this.iconImage_.getPixelRatio(Z);
  }
  /**
   * @return {import("../size.js").Size} Image size.
   */
  getImageSize() {
    return this.iconImage_.getSize();
  }
  /**
   * @return {import("../ImageState.js").default} Image state.
   */
  getImageState() {
    return this.iconImage_.getImageState();
  }
  /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */
  getHitDetectionImage() {
    return this.iconImage_.getHitDetectionImage();
  }
  /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   */
  getOrigin() {
    if (this.origin_)
      return this.origin_;
    let Z = this.offset_;
    if (this.offsetOrigin_ != "top-left") {
      const ee = this.getSize(), ae = this.iconImage_.getSize();
      if (!ee || !ae)
        return null;
      Z = Z.slice(), (this.offsetOrigin_ == "top-right" || this.offsetOrigin_ == "bottom-right") && (Z[0] = ae[0] - ee[0] - Z[0]), (this.offsetOrigin_ == "bottom-left" || this.offsetOrigin_ == "bottom-right") && (Z[1] = ae[1] - ee[1] - Z[1]);
    }
    return this.origin_ = Z, this.origin_;
  }
  /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */
  getSrc() {
    return this.iconImage_.getSrc();
  }
  /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   */
  getSize() {
    return this.size_ ? this.size_ : this.iconImage_.getSize();
  }
  /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */
  getWidth() {
    const Z = this.getScaleArray();
    if (this.size_)
      return this.size_[0] * Z[0];
    if (this.iconImage_.getImageState() == ImageState.LOADED)
      return this.iconImage_.getSize()[0] * Z[0];
  }
  /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */
  getHeight() {
    const Z = this.getScaleArray();
    if (this.size_)
      return this.size_[1] * Z[1];
    if (this.iconImage_.getImageState() == ImageState.LOADED)
      return this.iconImage_.getSize()[1] * Z[1];
  }
  /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */
  setScale(Z) {
    delete this.initialOptions_, super.setScale(Z);
  }
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */
  listenImageChange(Z) {
    this.iconImage_.addEventListener(EventType.CHANGE, Z);
  }
  /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   */
  load() {
    this.iconImage_.load();
  }
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */
  unlistenImageChange(Z) {
    this.iconImage_.removeEventListener(EventType.CHANGE, Z);
  }
}
let numTypes = 0;
const BooleanType = 1 << numTypes++, NumberType = 1 << numTypes++, StringType = 1 << numTypes++, ColorType = 1 << numTypes++, NumberArrayType = 1 << numTypes++, AnyType = Math.pow(2, numTypes) - 1, typeNames = {
  [BooleanType]: "boolean",
  [NumberType]: "number",
  [StringType]: "string",
  [ColorType]: "color",
  [NumberArrayType]: "number[]"
}, namedTypes = Object.keys(typeNames).map(Number).sort(ascending);
function typeName(ie) {
  const Z = [];
  for (const ee of namedTypes)
    includesType(ie, ee) && Z.push(typeNames[ee]);
  return Z.length === 0 ? "untyped" : Z.length < 3 ? Z.join(" or ") : Z.slice(0, -1).join(", ") + ", or " + Z[Z.length - 1];
}
function includesType(ie, Z) {
  return (ie & Z) === Z;
}
function overlapsType(ie, Z) {
  return !!(ie & Z);
}
class LiteralExpression {
  /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */
  constructor(Z, ee) {
    this.type = Z, this.value = ee;
  }
}
class CallExpression {
  /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */
  constructor(Z, ee, ...ae) {
    this.type = Z, this.operator = ee, this.args = ae;
  }
}
function newParsingContext() {
  return {
    variables: /* @__PURE__ */ new Set(),
    properties: /* @__PURE__ */ new Set()
  };
}
function parse$9(ie, Z) {
  switch (typeof ie) {
    case "boolean":
      return new LiteralExpression(BooleanType, ie);
    case "number":
      return new LiteralExpression(NumberType, ie);
    case "string":
      return new LiteralExpression(StringType, ie);
  }
  if (!Array.isArray(ie))
    throw new Error("Expression must be an array or a primitive value");
  if (ie.length === 0)
    throw new Error("Empty expression");
  if (typeof ie[0] == "string")
    return parseCallExpression(ie, Z);
  for (const ae of ie)
    if (typeof ae != "number")
      throw new Error("Expected an array of numbers");
  let ee = NumberArrayType;
  return (ie.length === 3 || ie.length === 4) && (ee |= ColorType), new LiteralExpression(ee, ie);
}
const Ops = {
  Number: "number",
  String: "string",
  Get: "get",
  Var: "var",
  Any: "any",
  All: "all",
  Not: "!",
  Resolution: "resolution",
  Equal: "==",
  NotEqual: "!=",
  GreaterThan: ">",
  GreaterThanOrEqualTo: ">=",
  LessThan: "<",
  LessThanOrEqualTo: "<=",
  Multiply: "*",
  Divide: "/",
  Add: "+",
  Subtract: "-",
  Clamp: "clamp",
  Mod: "%",
  Pow: "^",
  Abs: "abs",
  Floor: "floor",
  Ceil: "ceil",
  Round: "round",
  Sin: "sin",
  Cos: "cos",
  Atan: "atan",
  Sqrt: "sqrt",
  Match: "match"
}, parsers = {
  [Ops.Number]: createParser(withArgs(1, 1 / 0, AnyType), NumberType),
  [Ops.String]: createParser(withArgs(1, 1 / 0, AnyType), StringType),
  [Ops.Get]: createParser(withGetArgs, AnyType),
  [Ops.Var]: createParser(withVarArgs, AnyType),
  [Ops.Resolution]: createParser(withNoArgs, NumberType),
  [Ops.Any]: createParser(withArgs(2, 1 / 0, BooleanType), BooleanType),
  [Ops.All]: createParser(withArgs(2, 1 / 0, BooleanType), BooleanType),
  [Ops.Not]: createParser(withArgs(1, 1, BooleanType), BooleanType),
  [Ops.Equal]: createParser(withArgs(2, 2, AnyType), BooleanType),
  [Ops.NotEqual]: createParser(withArgs(2, 2, AnyType), BooleanType),
  [Ops.GreaterThan]: createParser(withArgs(2, 2, AnyType), BooleanType),
  [Ops.GreaterThanOrEqualTo]: createParser(
    withArgs(2, 2, AnyType),
    BooleanType
  ),
  [Ops.LessThan]: createParser(withArgs(2, 2, AnyType), BooleanType),
  [Ops.LessThanOrEqualTo]: createParser(withArgs(2, 2, AnyType), BooleanType),
  [Ops.Multiply]: createParser(withArgs(2, 1 / 0, NumberType), NumberType),
  [Ops.Divide]: createParser(withArgs(2, 2, NumberType), NumberType),
  [Ops.Add]: createParser(withArgs(2, 1 / 0, NumberType), NumberType),
  [Ops.Subtract]: createParser(withArgs(2, 2, NumberType), NumberType),
  [Ops.Clamp]: createParser(withArgs(3, 3, NumberType), NumberType),
  [Ops.Mod]: createParser(withArgs(2, 2, NumberType), NumberType),
  [Ops.Pow]: createParser(withArgs(2, 2, NumberType), NumberType),
  [Ops.Abs]: createParser(withArgs(1, 1, NumberType), NumberType),
  [Ops.Floor]: createParser(withArgs(1, 1, NumberType), NumberType),
  [Ops.Ceil]: createParser(withArgs(1, 1, NumberType), NumberType),
  [Ops.Round]: createParser(withArgs(1, 1, NumberType), NumberType),
  [Ops.Sin]: createParser(withArgs(1, 1, NumberType), NumberType),
  [Ops.Cos]: createParser(withArgs(1, 1, NumberType), NumberType),
  [Ops.Atan]: createParser(withArgs(1, 2, NumberType), NumberType),
  [Ops.Sqrt]: createParser(withArgs(1, 1, NumberType), NumberType),
  [Ops.Match]: createParser(
    withArgs(4, 1 / 0, StringType | NumberType),
    AnyType
  )
};
function withGetArgs(ie, Z) {
  if (ie.length !== 2)
    throw new Error("Expected 1 argument for get operation");
  const ee = parse$9(ie[1], Z);
  if (!(ee instanceof LiteralExpression))
    throw new Error("Expected a literal argument for get operation");
  if (typeof ee.value != "string")
    throw new Error("Expected a string argument for get operation");
  return Z.properties.add(ee.value), [ee];
}
function withVarArgs(ie, Z) {
  if (ie.length !== 2)
    throw new Error("Expected 1 argument for var operation");
  const ee = parse$9(ie[1], Z);
  if (!(ee instanceof LiteralExpression))
    throw new Error("Expected a literal argument for var operation");
  if (typeof ee.value != "string")
    throw new Error("Expected a string argument for get operation");
  return Z.variables.add(ee.value), [ee];
}
function withNoArgs(ie, Z) {
  const ee = ie[0];
  if (ie.length !== 1)
    throw new Error(`Expected no arguments for ${ee} operation`);
  return [];
}
function withArgs(ie, Z, ee) {
  return function(ae, ve) {
    const ye = ae[0], be = ae.length - 1;
    if (ie === Z) {
      if (be !== ie) {
        const Qe = ie === 1 ? "" : "s";
        throw new Error(
          `Expected ${ie} argument${Qe} for operation ${ye}, got ${be}`
        );
      }
    } else if (be < ie || be > Z)
      throw new Error(
        `Expected ${ie} to ${Z} arguments for operation ${ye}, got ${be}`
      );
    const Ye = new Array(be);
    for (let Qe = 0; Qe < be; ++Qe) {
      const Je = parse$9(ae[Qe + 1], ve);
      if (!overlapsType(ee, Je.type)) {
        const nt = typeName(ee), st = typeName(Je.type);
        throw new Error(
          `Unexpected type for argument ${Qe} of ${ye} operation : got ${nt} but expected ${st}`
        );
      }
      Ye[Qe] = Je;
    }
    return Ye;
  };
}
function createParser(ie, Z) {
  return function(ee, ae) {
    const ve = ee[0], ye = ie(ee, ae);
    return new CallExpression(Z, ve, ...ye);
  };
}
function parseCallExpression(ie, Z) {
  const ee = ie[0], ae = parsers[ee];
  if (!ae)
    throw new Error(`Unknown operator: ${ee}`);
  return ae(ie, Z);
}
function newEvaluationContext() {
  return {
    variables: {},
    properties: {},
    resolution: NaN
  };
}
function buildExpression(ie, Z, ee) {
  const ae = parse$9(ie, ee);
  if (!overlapsType(Z, ae.type)) {
    const ve = typeName(Z), ye = typeName(ae.type);
    throw new Error(
      `Expected expression to be of type ${ve}, got ${ye}`
    );
  }
  return compileExpression(ae);
}
function compileExpression(ie, Z) {
  if (ie instanceof LiteralExpression)
    return function() {
      return ie.value;
    };
  const ee = ie.operator;
  switch (ee) {
    case Ops.Number:
    case Ops.String:
      return compileAssertionExpression(ie);
    case Ops.Get:
    case Ops.Var:
      return compileAccessorExpression(ie);
    case Ops.Resolution:
      return (ae) => ae.resolution;
    case Ops.Any:
    case Ops.All:
    case Ops.Not:
      return compileLogicalExpression(ie);
    case Ops.Equal:
    case Ops.NotEqual:
    case Ops.LessThan:
    case Ops.LessThanOrEqualTo:
    case Ops.GreaterThan:
    case Ops.GreaterThanOrEqualTo:
      return compileComparisonExpression(ie);
    case Ops.Multiply:
    case Ops.Divide:
    case Ops.Add:
    case Ops.Subtract:
    case Ops.Clamp:
    case Ops.Mod:
    case Ops.Pow:
    case Ops.Abs:
    case Ops.Floor:
    case Ops.Ceil:
    case Ops.Round:
    case Ops.Sin:
    case Ops.Cos:
    case Ops.Atan:
    case Ops.Sqrt:
      return compileNumericExpression(ie);
    case Ops.Match:
      return compileMatchExpression(ie);
    default:
      throw new Error(`Unsupported operator ${ee}`);
  }
}
function compileAssertionExpression(ie, Z) {
  const ee = ie.operator, ae = ie.args.length, ve = new Array(ae);
  for (let ye = 0; ye < ae; ++ye)
    ve[ye] = compileExpression(ie.args[ye]);
  switch (ee) {
    case Ops.Number:
    case Ops.String:
      return (ye) => {
        for (let be = 0; be < ae; ++be) {
          const Ye = ve[be](ye);
          if (typeof Ye === ee)
            return Ye;
        }
        throw new Error(`Expected one of the values to be a ${ee}`);
      };
    default:
      throw new Error(`Unsupported assertion operator ${ee}`);
  }
}
function compileAccessorExpression(ie, Z) {
  const ee = ie.args[0];
  if (!(ee instanceof LiteralExpression))
    throw new Error("Expected literal name");
  const ae = ee.value;
  if (typeof ae != "string")
    throw new Error("Expected string name");
  switch (ie.operator) {
    case Ops.Get:
      return (ve) => ve.properties[ae];
    case Ops.Var:
      return (ve) => ve.variables[ae];
    default:
      throw new Error(`Unsupported accessor operator ${ie.operator}`);
  }
}
function compileComparisonExpression(ie, Z) {
  const ee = ie.operator, ae = compileExpression(ie.args[0]), ve = compileExpression(ie.args[1]);
  switch (ee) {
    case Ops.Equal:
      return (ye) => ae(ye) === ve(ye);
    case Ops.NotEqual:
      return (ye) => ae(ye) !== ve(ye);
    case Ops.LessThan:
      return (ye) => ae(ye) < ve(ye);
    case Ops.LessThanOrEqualTo:
      return (ye) => ae(ye) <= ve(ye);
    case Ops.GreaterThan:
      return (ye) => ae(ye) > ve(ye);
    case Ops.GreaterThanOrEqualTo:
      return (ye) => ae(ye) >= ve(ye);
    default:
      throw new Error(`Unsupported comparison operator ${ee}`);
  }
}
function compileLogicalExpression(ie, Z) {
  const ee = ie.operator, ae = ie.args.length, ve = new Array(ae);
  for (let ye = 0; ye < ae; ++ye)
    ve[ye] = compileExpression(ie.args[ye]);
  switch (ee) {
    case Ops.Any:
      return (ye) => {
        for (let be = 0; be < ae; ++be)
          if (ve[be](ye))
            return !0;
        return !1;
      };
    case Ops.All:
      return (ye) => {
        for (let be = 0; be < ae; ++be)
          if (!ve[be](ye))
            return !1;
        return !0;
      };
    case Ops.Not:
      return (ye) => !ve[0](ye);
    default:
      throw new Error(`Unsupported logical operator ${ee}`);
  }
}
function compileNumericExpression(ie, Z) {
  const ee = ie.operator, ae = ie.args.length, ve = new Array(ae);
  for (let ye = 0; ye < ae; ++ye)
    ve[ye] = compileExpression(ie.args[ye]);
  switch (ee) {
    case Ops.Multiply:
      return (ye) => {
        let be = 1;
        for (let Ye = 0; Ye < ae; ++Ye)
          be *= ve[Ye](ye);
        return be;
      };
    case Ops.Divide:
      return (ye) => ve[0](ye) / ve[1](ye);
    case Ops.Add:
      return (ye) => {
        let be = 0;
        for (let Ye = 0; Ye < ae; ++Ye)
          be += ve[Ye](ye);
        return be;
      };
    case Ops.Subtract:
      return (ye) => ve[0](ye) - ve[1](ye);
    case Ops.Clamp:
      return (ye) => {
        const be = ve[0](ye), Ye = ve[1](ye);
        if (be < Ye)
          return Ye;
        const Qe = ve[2](ye);
        return be > Qe ? Qe : be;
      };
    case Ops.Mod:
      return (ye) => ve[0](ye) % ve[1](ye);
    case Ops.Pow:
      return (ye) => Math.pow(ve[0](ye), ve[1](ye));
    case Ops.Abs:
      return (ye) => Math.abs(ve[0](ye));
    case Ops.Floor:
      return (ye) => Math.floor(ve[0](ye));
    case Ops.Ceil:
      return (ye) => Math.ceil(ve[0](ye));
    case Ops.Round:
      return (ye) => Math.round(ve[0](ye));
    case Ops.Sin:
      return (ye) => Math.sin(ve[0](ye));
    case Ops.Cos:
      return (ye) => Math.cos(ve[0](ye));
    case Ops.Atan:
      return ae === 2 ? (ye) => Math.atan2(ve[0](ye), ve[1](ye)) : (ye) => Math.atan(ve[0](ye));
    case Ops.Sqrt:
      return (ye) => Math.sqrt(ve[0](ye));
    default:
      throw new Error(`Unsupported numeric operator ${ee}`);
  }
}
function compileMatchExpression(ie, Z) {
  const ee = ie.args.length, ae = new Array(ee);
  for (let ve = 0; ve < ee; ++ve)
    ae[ve] = compileExpression(ie.args[ve]);
  return (ve) => {
    const ye = ae[0](ve);
    for (let be = 1; be < ee; be += 2)
      if (ye === ae[be](ve))
        return ae[be + 1](ve);
    return ae[ee - 1](ve);
  };
}
function always$1(ie) {
  return !0;
}
function rulesToStyleFunction(ie) {
  const Z = newParsingContext(), ee = buildRuleSet(ie, Z), ae = newEvaluationContext();
  return function(ve, ye) {
    return ae.properties = ve.getPropertiesInternal(), ae.resolution = ye, ee(ae);
  };
}
function flatStylesToStyleFunction(ie) {
  const Z = newParsingContext(), ee = ie.length, ae = new Array(ee);
  for (let be = 0; be < ee; ++be)
    ae[be] = buildStyle(ie[be], Z);
  const ve = newEvaluationContext(), ye = new Array(ee);
  return function(be, Ye) {
    ve.properties = be.getPropertiesInternal(), ve.resolution = Ye;
    for (let Qe = 0; Qe < ee; ++Qe)
      ye[Qe] = ae[Qe](ve);
    return ye;
  };
}
function buildRuleSet(ie, Z) {
  const ee = ie.length, ae = new Array(ee);
  for (let ve = 0; ve < ee; ++ve) {
    const ye = ie[ve], be = "filter" in ye ? buildExpression(ye.filter, BooleanType, Z) : always$1;
    let Ye;
    if (Array.isArray(ye.style)) {
      const Qe = ye.style.length;
      Ye = new Array(Qe);
      for (let Je = 0; Je < Qe; ++Je)
        Ye[Je] = buildStyle(ye.style[Je], Z);
    } else
      Ye = [buildStyle(ye.style, Z)];
    ae[ve] = { filter: be, styles: Ye };
  }
  return function(ve) {
    const ye = [];
    let be = !1;
    for (let Ye = 0; Ye < ee; ++Ye) {
      const Qe = ae[Ye].filter;
      if (Qe(ve) && !(ie[Ye].else && be)) {
        be = !0;
        for (const Je of ae[Ye].styles) {
          const nt = Je(ve);
          nt && ye.push(nt);
        }
      }
    }
    return ye;
  };
}
function buildStyle(ie, Z) {
  const ee = buildFill(ie, "", Z), ae = buildStroke(ie, "", Z), ve = buildText(ie, Z), ye = buildImage(ie, Z), be = numberEvaluator(ie, "z-index", Z), Ye = new Style$1();
  return function(Qe) {
    let Je = !0;
    if (ee) {
      const nt = ee(Qe);
      nt && (Je = !1), Ye.setFill(nt);
    }
    if (ae) {
      const nt = ae(Qe);
      nt && (Je = !1), Ye.setStroke(nt);
    }
    if (ve) {
      const nt = ve(Qe);
      nt && (Je = !1), Ye.setText(nt);
    }
    if (ye) {
      const nt = ye(Qe);
      nt && (Je = !1), Ye.setImage(nt);
    }
    return be && Ye.setZIndex(be(Qe)), Je ? null : Ye;
  };
}
function buildFill(ie, Z, ee) {
  const ae = colorLikeEvaluator(
    ie,
    Z + "fill-color",
    ee
  );
  if (!ae)
    return null;
  const ve = new Fill();
  return function(ye) {
    const be = ae(ye);
    return be === "none" ? null : (ve.setColor(be), ve);
  };
}
function buildStroke(ie, Z, ee) {
  const ae = numberEvaluator(
    ie,
    Z + "stroke-width",
    ee
  ), ve = colorLikeEvaluator(
    ie,
    Z + "stroke-color",
    ee
  );
  if (!ae && !ve)
    return null;
  const ye = stringEvaluator(
    ie,
    Z + "stroke-line-cap",
    ee
  ), be = stringEvaluator(
    ie,
    Z + "stroke-line-join",
    ee
  ), Ye = numberArrayEvaluator(
    ie,
    Z + "stroke-line-dash",
    ee
  ), Qe = numberEvaluator(
    ie,
    Z + "stroke-line-dash-offset",
    ee
  ), Je = numberEvaluator(
    ie,
    Z + "stroke-miter-limit",
    ee
  ), nt = new Stroke();
  return function(st) {
    if (ve) {
      const ot = ve(st);
      if (ot === "none")
        return null;
      nt.setColor(ot);
    }
    if (ae && nt.setWidth(ae(st)), ye) {
      const ot = ye(st);
      if (ot !== "butt" && ot !== "round" && ot !== "square")
        throw new Error("Expected butt, round, or square line cap");
      nt.setLineCap(ot);
    }
    if (be) {
      const ot = be(st);
      if (ot !== "bevel" && ot !== "round" && ot !== "miter")
        throw new Error("Expected bevel, round, or miter line join");
      nt.setLineJoin(ot);
    }
    return Ye && nt.setLineDash(Ye(st)), Qe && nt.setLineDashOffset(Qe(st)), Je && nt.setMiterLimit(Je(st)), nt;
  };
}
function buildText(ie, Z) {
  const ee = "text-", ae = stringEvaluator(ie, ee + "value", Z);
  if (!ae)
    return null;
  const ve = buildFill(ie, ee, Z), ye = buildFill(
    ie,
    ee + "background-",
    Z
  ), be = buildStroke(ie, ee, Z), Ye = buildStroke(
    ie,
    ee + "background-",
    Z
  ), Qe = stringEvaluator(ie, ee + "font", Z), Je = numberEvaluator(
    ie,
    ee + "max-angle",
    Z
  ), nt = numberEvaluator(
    ie,
    ee + "offset-x",
    Z
  ), st = numberEvaluator(
    ie,
    ee + "offset-y",
    Z
  ), ot = booleanEvaluator(
    ie,
    ee + "overflow",
    Z
  ), lt = stringEvaluator(
    ie,
    ee + "placement",
    Z
  ), ft = numberEvaluator(ie, ee + "repeat", Z), gt = sizeLikeEvaluator(ie, ee + "scale", Z), ct = booleanEvaluator(
    ie,
    ee + "rotate-with-view",
    Z
  ), _r = numberEvaluator(
    ie,
    ee + "rotation",
    Z
  ), Kr = stringEvaluator(ie, ee + "align", Z), Xr = stringEvaluator(
    ie,
    ee + "justify",
    Z
  ), Jr = stringEvaluator(
    ie,
    ee + "baseline",
    Z
  ), ei = numberArrayEvaluator(
    ie,
    ee + "padding",
    Z
  ), si = new Text$1({});
  return function(ri) {
    if (si.setText(ae(ri)), ve && si.setFill(ve(ri)), ye && si.setBackgroundFill(ye(ri)), be && si.setStroke(be(ri)), Ye && si.setBackgroundStroke(Ye(ri)), Qe && si.setFont(Qe(ri)), Je && si.setMaxAngle(Je(ri)), nt && si.setOffsetX(nt(ri)), st && si.setOffsetY(st(ri)), ot && si.setOverflow(ot(ri)), lt) {
      const ai = lt(ri);
      if (ai !== "point" && ai !== "line")
        throw new Error("Expected point or line for text-placement");
      si.setPlacement(ai);
    }
    if (ft && si.setRepeat(ft(ri)), gt && si.setScale(gt(ri)), ct && si.setRotateWithView(ct(ri)), _r && si.setRotation(_r(ri)), Kr) {
      const ai = Kr(ri);
      if (ai !== "left" && ai !== "center" && ai !== "right" && ai !== "end" && ai !== "start")
        throw new Error(
          "Expected left, right, center, start, or end for text-align"
        );
      si.setTextAlign(ai);
    }
    if (Xr) {
      const ai = Xr(ri);
      if (ai !== "left" && ai !== "right" && ai !== "center")
        throw new Error("Expected left, right, or center for text-justify");
      si.setJustify(ai);
    }
    if (Jr) {
      const ai = Jr(ri);
      if (ai !== "bottom" && ai !== "top" && ai !== "middle" && ai !== "alphabetic" && ai !== "hanging")
        throw new Error(
          "Expected bottom, top, middle, alphabetic, or hanging for text-baseline"
        );
      si.setTextBaseline(ai);
    }
    return ei && si.setPadding(ei(ri)), si;
  };
}
function buildImage(ie, Z) {
  return "icon-src" in ie ? buildIcon(ie, Z) : "shape-points" in ie ? buildShape(ie, Z) : "circle-radius" in ie ? buildCircle(ie, Z) : null;
}
function buildIcon(ie, Z) {
  const ee = "icon-", ae = ee + "src", ve = requireString(ie[ae], ae), ye = coordinateEvaluator(
    ie,
    ee + "anchor",
    Z
  ), be = sizeLikeEvaluator(ie, ee + "scale", Z), Ye = numberEvaluator(
    ie,
    ee + "opacity",
    Z
  ), Qe = coordinateEvaluator(
    ie,
    ee + "displacement",
    Z
  ), Je = numberEvaluator(
    ie,
    ee + "rotation",
    Z
  ), nt = booleanEvaluator(
    ie,
    ee + "rotate-with-view",
    Z
  ), st = optionalIconOrigin(ie, ee + "anchor-origin"), ot = optionalIconAnchorUnits(
    ie,
    ee + "anchor-x-units"
  ), lt = optionalIconAnchorUnits(
    ie,
    ee + "anchor-y-units"
  ), ft = optionalColorLike(ie, ee + "color"), gt = optionalString(ie, ee + "cross-origin"), ct = optionalNumberArray(ie, ee + "offset"), _r = optionalIconOrigin(ie, ee + "offset-origin"), Kr = optionalNumber(ie, ee + "width"), Xr = optionalNumber(ie, ee + "height"), Jr = optionalSize(ie, ee + "size"), ei = optionalDeclutterMode(ie, ee + "declutter"), si = new Icon({
    src: ve,
    anchorOrigin: st,
    anchorXUnits: ot,
    anchorYUnits: lt,
    color: ft,
    crossOrigin: gt,
    offset: ct,
    offsetOrigin: _r,
    height: Xr,
    width: Kr,
    size: Jr,
    declutterMode: ei
  });
  return function(ri) {
    return Ye && si.setOpacity(Ye(ri)), Qe && si.setDisplacement(Qe(ri)), Je && si.setRotation(Je(ri)), nt && si.setRotateWithView(nt(ri)), be && si.setScale(be(ri)), ye && si.setAnchor(ye(ri)), si;
  };
}
function buildShape(ie, Z) {
  const ee = "shape-", ae = ee + "points", ve = requireNumber(ie[ae], ae), ye = buildFill(ie, ee, Z), be = buildStroke(ie, ee, Z), Ye = sizeLikeEvaluator(ie, ee + "scale", Z), Qe = coordinateEvaluator(
    ie,
    ee + "displacement",
    Z
  ), Je = numberEvaluator(
    ie,
    ee + "rotation",
    Z
  ), nt = booleanEvaluator(
    ie,
    ee + "rotate-with-view",
    Z
  ), st = optionalNumber(ie, ee + "radius"), ot = optionalNumber(ie, ee + "radius1"), lt = optionalNumber(ie, ee + "radius2"), ft = optionalNumber(ie, ee + "angle"), gt = optionalDeclutterMode(
    ie,
    ee + "declutter-mode"
  ), ct = new RegularShape({
    points: ve,
    radius: st,
    radius1: ot,
    radius2: lt,
    angle: ft,
    declutterMode: gt
  });
  return function(_r) {
    return ye && ct.setFill(ye(_r)), be && ct.setStroke(be(_r)), Qe && ct.setDisplacement(Qe(_r)), Je && ct.setRotation(Je(_r)), nt && ct.setRotateWithView(nt(_r)), Ye && ct.setScale(Ye(_r)), ct;
  };
}
function buildCircle(ie, Z) {
  const ee = "circle-", ae = buildFill(ie, ee, Z), ve = buildStroke(ie, ee, Z), ye = numberEvaluator(ie, ee + "radius", Z), be = sizeLikeEvaluator(ie, ee + "scale", Z), Ye = coordinateEvaluator(
    ie,
    ee + "displacement",
    Z
  ), Qe = numberEvaluator(
    ie,
    ee + "rotation",
    Z
  ), Je = booleanEvaluator(
    ie,
    ee + "rotate-with-view",
    Z
  ), nt = optionalDeclutterMode(
    ie,
    ee + "declutter-mode"
  ), st = new CircleStyle({
    radius: 5,
    // this is arbitrary, but required - the evaluated radius is used below
    declutterMode: nt
  });
  return function(ot) {
    return ye && st.setRadius(ye(ot)), ae && st.setFill(ae(ot)), ve && st.setStroke(ve(ot)), Ye && st.setDisplacement(Ye(ot)), Qe && st.setRotation(Qe(ot)), Je && st.setRotateWithView(Je(ot)), be && st.setScale(be(ot)), st;
  };
}
function numberEvaluator(ie, Z, ee) {
  if (!(Z in ie))
    return;
  const ae = buildExpression(ie[Z], NumberType, ee);
  return function(ve) {
    return requireNumber(ae(ve), Z);
  };
}
function stringEvaluator(ie, Z, ee) {
  if (!(Z in ie))
    return null;
  const ae = buildExpression(ie[Z], StringType, ee);
  return function(ve) {
    return requireString(ae(ve), Z);
  };
}
function booleanEvaluator(ie, Z, ee) {
  if (!(Z in ie))
    return null;
  const ae = buildExpression(ie[Z], BooleanType, ee);
  return function(ve) {
    const ye = ae(ve);
    if (typeof ye != "boolean")
      throw new Error(`Expected a boolean for ${Z}`);
    return ye;
  };
}
function colorLikeEvaluator(ie, Z, ee) {
  if (!(Z in ie))
    return null;
  const ae = buildExpression(
    ie[Z],
    ColorType | StringType,
    ee
  );
  return function(ve) {
    return requireColorLike(ae(ve), Z);
  };
}
function numberArrayEvaluator(ie, Z, ee) {
  if (!(Z in ie))
    return null;
  const ae = buildExpression(ie[Z], NumberArrayType, ee);
  return function(ve) {
    return requireNumberArray(ae(ve), Z);
  };
}
function coordinateEvaluator(ie, Z, ee) {
  if (!(Z in ie))
    return null;
  const ae = buildExpression(ie[Z], NumberArrayType, ee);
  return function(ve) {
    const ye = requireNumberArray(ae(ve), Z);
    if (ye.length !== 2)
      throw new Error(`Expected two numbers for ${Z}`);
    return ye;
  };
}
function sizeLikeEvaluator(ie, Z, ee) {
  if (!(Z in ie))
    return null;
  const ae = buildExpression(
    ie[Z],
    NumberArrayType | NumberType,
    ee
  );
  return function(ve) {
    return requireSizeLike(ae(ve), Z);
  };
}
function optionalNumber(ie, Z) {
  const ee = ie[Z];
  if (ee !== void 0) {
    if (typeof ee != "number")
      throw new Error(`Expected a number for ${Z}`);
    return ee;
  }
}
function optionalSize(ie, Z) {
  const ee = ie[Z];
  if (ee !== void 0) {
    if (typeof ee == "number")
      return toSize(ee);
    if (!Array.isArray(ee))
      throw new Error(`Expected a number or size array for ${Z}`);
    if (ee.length !== 2 || typeof ee[0] != "number" || typeof ee[1] != "number")
      throw new Error(`Expected a number or size array for ${Z}`);
    return ee;
  }
}
function optionalString(ie, Z) {
  const ee = ie[Z];
  if (ee !== void 0) {
    if (typeof ee != "string")
      throw new Error(`Expected a string for ${Z}`);
    return ee;
  }
}
function optionalIconOrigin(ie, Z) {
  const ee = ie[Z];
  if (ee !== void 0) {
    if (ee !== "bottom-left" && ee !== "bottom-right" && ee !== "top-left" && ee !== "top-right")
      throw new Error(
        `Expected bottom-left, bottom-right, top-left, or top-right for ${Z}`
      );
    return ee;
  }
}
function optionalIconAnchorUnits(ie, Z) {
  const ee = ie[Z];
  if (ee !== void 0) {
    if (ee !== "pixels" && ee !== "fraction")
      throw new Error(`Expected pixels or fraction for ${Z}`);
    return ee;
  }
}
function optionalNumberArray(ie, Z) {
  const ee = ie[Z];
  if (ee !== void 0)
    return requireNumberArray(ee, Z);
}
function optionalDeclutterMode(ie, Z) {
  const ee = ie[Z];
  if (ee !== void 0) {
    if (typeof ee != "string")
      throw new Error(`Expected a string for ${Z}`);
    if (ee !== "declutter" && ee !== "obstacle" && ee !== "none")
      throw new Error(`Expected declutter, obstacle, or none for ${Z}`);
    return ee;
  }
}
function optionalColorLike(ie, Z) {
  const ee = ie[Z];
  if (ee !== void 0)
    return requireColorLike(ee, Z);
}
function requireNumberArray(ie, Z) {
  if (!Array.isArray(ie))
    throw new Error(`Expected an array for ${Z}`);
  const ee = ie.length;
  for (let ae = 0; ae < ee; ++ae)
    if (typeof ie[ae] != "number")
      throw new Error(`Expected an array of numbers for ${Z}`);
  return ie;
}
function requireString(ie, Z) {
  if (typeof ie != "string")
    throw new Error(`Expected a string for ${Z}`);
  return ie;
}
function requireNumber(ie, Z) {
  if (typeof ie != "number")
    throw new Error(`Expected a number for ${Z}`);
  return ie;
}
function requireColorLike(ie, Z) {
  if (typeof ie == "string")
    return ie;
  const ee = requireNumberArray(ie, Z), ae = ee.length;
  if (ae < 3 || ae > 4)
    throw new Error(`Expected a color with 3 or 4 values for ${Z}`);
  return ee;
}
function requireSizeLike(ie, Z) {
  if (typeof ie == "number")
    return ie;
  const ee = requireNumberArray(ie, Z);
  if (ee.length !== 2)
    throw new Error(`Expected an array of two numbers for ${Z}`);
  return ee;
}
const Property$1 = {
  RENDER_ORDER: "renderOrder"
};
class BaseVectorLayer extends Layer {
  /**
   * @param {Options<VectorSourceType>} [options] Options.
   */
  constructor(Z) {
    Z = Z || {};
    const ee = Object.assign({}, Z);
    delete ee.style, delete ee.renderBuffer, delete ee.updateWhileAnimating, delete ee.updateWhileInteracting, super(ee), this.declutter_ = Z.declutter !== void 0 ? Z.declutter : !1, this.renderBuffer_ = Z.renderBuffer !== void 0 ? Z.renderBuffer : 100, this.style_ = null, this.styleFunction_ = void 0, this.setStyle(Z.style), this.updateWhileAnimating_ = Z.updateWhileAnimating !== void 0 ? Z.updateWhileAnimating : !1, this.updateWhileInteracting_ = Z.updateWhileInteracting !== void 0 ? Z.updateWhileInteracting : !1;
  }
  /**
   * @return {boolean} Declutter.
   */
  getDeclutter() {
    return this.declutter_;
  }
  /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   */
  getFeatures(Z) {
    return super.getFeatures(Z);
  }
  /**
   * @return {number|undefined} Render buffer.
   */
  getRenderBuffer() {
    return this.renderBuffer_;
  }
  /**
   * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
   *     order.
   */
  getRenderOrder() {
    return (
      /** @type {import("../render.js").OrderFunction|null|undefined} */
      this.get(Property$1.RENDER_ORDER)
    );
  }
  /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|null|undefined} Layer style.
   * @api
   */
  getStyle() {
    return this.style_;
  }
  /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */
  getStyleFunction() {
    return this.styleFunction_;
  }
  /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */
  getUpdateWhileAnimating() {
    return this.updateWhileAnimating_;
  }
  /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */
  getUpdateWhileInteracting() {
    return this.updateWhileInteracting_;
  }
  /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */
  renderDeclutter(Z) {
    Z.declutterTree || (Z.declutterTree = new RBush(9)), this.getRenderer().renderDeclutter(Z);
  }
  /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */
  setRenderOrder(Z) {
    this.set(Property$1.RENDER_ORDER, Z);
  }
  /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */
  setStyle(Z) {
    this.style_ = toStyleLike(Z), this.styleFunction_ = Z === null ? void 0 : toFunction(this.style_), this.changed();
  }
}
function toStyleLike(ie) {
  if (ie === void 0)
    return createDefaultStyle;
  if (!ie)
    return null;
  if (typeof ie == "function" || ie instanceof Style$1)
    return ie;
  if (!Array.isArray(ie))
    return flatStylesToStyleFunction([ie]);
  if (ie.length === 0)
    return [];
  const Z = ie.length, ee = ie[0];
  if (ee instanceof Style$1) {
    const ve = new Array(Z);
    for (let ye = 0; ye < Z; ++ye) {
      const be = ie[ye];
      if (!(be instanceof Style$1))
        throw new Error("Expected a list of style instances");
      ve[ye] = be;
    }
    return ve;
  }
  if ("style" in ee) {
    const ve = new Array(Z);
    for (let ye = 0; ye < Z; ++ye) {
      const be = ie[ye];
      if (!("style" in be))
        throw new Error("Expected a list of rules with a style property");
      ve[ye] = be;
    }
    return rulesToStyleFunction(ve);
  }
  return flatStylesToStyleFunction(
    /** @type {Array<import("../style/flat.js").FlatStyle>} */
    ie
  );
}
const Instruction = {
  BEGIN_GEOMETRY: 0,
  BEGIN_PATH: 1,
  CIRCLE: 2,
  CLOSE_PATH: 3,
  CUSTOM: 4,
  DRAW_CHARS: 5,
  DRAW_IMAGE: 6,
  END_GEOMETRY: 7,
  FILL: 8,
  MOVE_TO_LINE_TO: 9,
  SET_FILL_STYLE: 10,
  SET_STROKE_STYLE: 11,
  STROKE: 12
}, fillInstruction = [Instruction.FILL], strokeInstruction = [Instruction.STROKE], beginPathInstruction = [Instruction.BEGIN_PATH], closePathInstruction = [Instruction.CLOSE_PATH];
class VectorContext {
  /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   */
  drawCustom(Z, ee, ae, ve) {
  }
  /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */
  drawGeometry(Z) {
  }
  /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */
  setStyle(Z) {
  }
  /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   */
  drawCircle(Z, ee) {
  }
  /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   */
  drawFeature(Z, ee) {
  }
  /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   */
  drawGeometryCollection(Z, ee) {
  }
  /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */
  drawLineString(Z, ee) {
  }
  /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */
  drawMultiLineString(Z, ee) {
  }
  /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */
  drawMultiPoint(Z, ee) {
  }
  /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */
  drawMultiPolygon(Z, ee) {
  }
  /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */
  drawPoint(Z, ee) {
  }
  /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */
  drawPolygon(Z, ee) {
  }
  /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */
  drawText(Z, ee) {
  }
  /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */
  setFillStrokeStyle(Z, ee) {
  }
  /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */
  setImageStyle(Z, ee) {
  }
  /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */
  setTextStyle(Z, ee) {
  }
}
class CanvasBuilder extends VectorContext {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(Z, ee, ae, ve) {
    super(), this.tolerance = Z, this.maxExtent = ee, this.pixelRatio = ve, this.maxLineWidth = 0, this.resolution = ae, this.beginGeometryInstruction1_ = null, this.beginGeometryInstruction2_ = null, this.bufferedMaxExtent_ = null, this.instructions = [], this.coordinates = [], this.tmpCoordinate_ = [], this.hitDetectionInstructions = [], this.state = /** @type {import("../canvas.js").FillStrokeState} */
    {};
  }
  /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */
  applyPixelRatio(Z) {
    const ee = this.pixelRatio;
    return ee == 1 ? Z : Z.map(function(ae) {
      return ae * ee;
    });
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */
  appendFlatPointCoordinates(Z, ee) {
    const ae = this.getBufferedMaxExtent(), ve = this.tmpCoordinate_, ye = this.coordinates;
    let be = ye.length;
    for (let Ye = 0, Qe = Z.length; Ye < Qe; Ye += ee)
      ve[0] = Z[Ye], ve[1] = Z[Ye + 1], containsCoordinate(ae, ve) && (ye[be++] = ve[0], ye[be++] = ve[1]);
    return be;
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */
  appendFlatLineCoordinates(Z, ee, ae, ve, ye, be) {
    const Ye = this.coordinates;
    let Qe = Ye.length;
    const Je = this.getBufferedMaxExtent();
    be && (ee += ve);
    let nt = Z[ee], st = Z[ee + 1];
    const ot = this.tmpCoordinate_;
    let lt = !0, ft, gt, ct;
    for (ft = ee + ve; ft < ae; ft += ve)
      ot[0] = Z[ft], ot[1] = Z[ft + 1], ct = coordinateRelationship(Je, ot), ct !== gt ? (lt && (Ye[Qe++] = nt, Ye[Qe++] = st, lt = !1), Ye[Qe++] = ot[0], Ye[Qe++] = ot[1]) : ct === Relationship.INTERSECTING ? (Ye[Qe++] = ot[0], Ye[Qe++] = ot[1], lt = !1) : lt = !0, nt = ot[0], st = ot[1], gt = ct;
    return (ye && lt || ft === ee + ve) && (Ye[Qe++] = nt, Ye[Qe++] = st), Qe;
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */
  drawCustomCoordinates_(Z, ee, ae, ve, ye) {
    for (let be = 0, Ye = ae.length; be < Ye; ++be) {
      const Qe = ae[be], Je = this.appendFlatLineCoordinates(
        Z,
        ee,
        Qe,
        ve,
        !1,
        !1
      );
      ye.push(Je), ee = Qe;
    }
    return ee;
  }
  /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   */
  drawCustom(Z, ee, ae, ve) {
    this.beginGeometry(Z, ee);
    const ye = Z.getType(), be = Z.getStride(), Ye = this.coordinates.length;
    let Qe, Je, nt, st, ot;
    switch (ye) {
      case "MultiPolygon":
        Qe = /** @type {import("../../geom/MultiPolygon.js").default} */
        Z.getOrientedFlatCoordinates(), st = [];
        const lt = (
          /** @type {import("../../geom/MultiPolygon.js").default} */
          Z.getEndss()
        );
        ot = 0;
        for (let ft = 0, gt = lt.length; ft < gt; ++ft) {
          const ct = [];
          ot = this.drawCustomCoordinates_(
            Qe,
            ot,
            lt[ft],
            be,
            ct
          ), st.push(ct);
        }
        this.instructions.push([
          Instruction.CUSTOM,
          Ye,
          st,
          Z,
          ae,
          inflateMultiCoordinatesArray
        ]), this.hitDetectionInstructions.push([
          Instruction.CUSTOM,
          Ye,
          st,
          Z,
          ve || ae,
          inflateMultiCoordinatesArray
        ]);
        break;
      case "Polygon":
      case "MultiLineString":
        nt = [], Qe = ye == "Polygon" ? (
          /** @type {import("../../geom/Polygon.js").default} */
          Z.getOrientedFlatCoordinates()
        ) : Z.getFlatCoordinates(), ot = this.drawCustomCoordinates_(
          Qe,
          0,
          /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */
          Z.getEnds(),
          be,
          nt
        ), this.instructions.push([
          Instruction.CUSTOM,
          Ye,
          nt,
          Z,
          ae,
          inflateCoordinatesArray
        ]), this.hitDetectionInstructions.push([
          Instruction.CUSTOM,
          Ye,
          nt,
          Z,
          ve || ae,
          inflateCoordinatesArray
        ]);
        break;
      case "LineString":
      case "Circle":
        Qe = Z.getFlatCoordinates(), Je = this.appendFlatLineCoordinates(
          Qe,
          0,
          Qe.length,
          be,
          !1,
          !1
        ), this.instructions.push([
          Instruction.CUSTOM,
          Ye,
          Je,
          Z,
          ae,
          inflateCoordinates
        ]), this.hitDetectionInstructions.push([
          Instruction.CUSTOM,
          Ye,
          Je,
          Z,
          ve || ae,
          inflateCoordinates
        ]);
        break;
      case "MultiPoint":
        Qe = Z.getFlatCoordinates(), Je = this.appendFlatPointCoordinates(Qe, be), Je > Ye && (this.instructions.push([
          Instruction.CUSTOM,
          Ye,
          Je,
          Z,
          ae,
          inflateCoordinates
        ]), this.hitDetectionInstructions.push([
          Instruction.CUSTOM,
          Ye,
          Je,
          Z,
          ve || ae,
          inflateCoordinates
        ]));
        break;
      case "Point":
        Qe = Z.getFlatCoordinates(), this.coordinates.push(Qe[0], Qe[1]), Je = this.coordinates.length, this.instructions.push([
          Instruction.CUSTOM,
          Ye,
          Je,
          Z,
          ae
        ]), this.hitDetectionInstructions.push([
          Instruction.CUSTOM,
          Ye,
          Je,
          Z,
          ve || ae
        ]);
        break;
    }
    this.endGeometry(ee);
  }
  /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */
  beginGeometry(Z, ee) {
    this.beginGeometryInstruction1_ = [
      Instruction.BEGIN_GEOMETRY,
      ee,
      0,
      Z
    ], this.instructions.push(this.beginGeometryInstruction1_), this.beginGeometryInstruction2_ = [
      Instruction.BEGIN_GEOMETRY,
      ee,
      0,
      Z
    ], this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */
  finish() {
    return {
      instructions: this.instructions,
      hitDetectionInstructions: this.hitDetectionInstructions,
      coordinates: this.coordinates
    };
  }
  /**
   * Reverse the hit detection instructions.
   */
  reverseHitDetectionInstructions() {
    const Z = this.hitDetectionInstructions;
    Z.reverse();
    let ee;
    const ae = Z.length;
    let ve, ye, be = -1;
    for (ee = 0; ee < ae; ++ee)
      ve = Z[ee], ye = /** @type {import("./Instruction.js").default} */
      ve[0], ye == Instruction.END_GEOMETRY ? be = ee : ye == Instruction.BEGIN_GEOMETRY && (ve[2] = ee, reverseSubArray(this.hitDetectionInstructions, be, ee), be = -1);
  }
  /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   */
  setFillStrokeStyle(Z, ee) {
    const ae = this.state;
    if (Z) {
      const ve = Z.getColor();
      ae.fillStyle = asColorLike(
        ve || defaultFillStyle
      );
    } else
      ae.fillStyle = void 0;
    if (ee) {
      const ve = ee.getColor();
      ae.strokeStyle = asColorLike(
        ve || defaultStrokeStyle
      );
      const ye = ee.getLineCap();
      ae.lineCap = ye !== void 0 ? ye : defaultLineCap;
      const be = ee.getLineDash();
      ae.lineDash = be ? be.slice() : defaultLineDash;
      const Ye = ee.getLineDashOffset();
      ae.lineDashOffset = Ye || defaultLineDashOffset;
      const Qe = ee.getLineJoin();
      ae.lineJoin = Qe !== void 0 ? Qe : defaultLineJoin;
      const Je = ee.getWidth();
      ae.lineWidth = Je !== void 0 ? Je : defaultLineWidth;
      const nt = ee.getMiterLimit();
      ae.miterLimit = nt !== void 0 ? nt : defaultMiterLimit, ae.lineWidth > this.maxLineWidth && (this.maxLineWidth = ae.lineWidth, this.bufferedMaxExtent_ = null);
    } else
      ae.strokeStyle = void 0, ae.lineCap = void 0, ae.lineDash = null, ae.lineDashOffset = void 0, ae.lineJoin = void 0, ae.lineWidth = void 0, ae.miterLimit = void 0;
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */
  createFill(Z) {
    const ee = Z.fillStyle, ae = [Instruction.SET_FILL_STYLE, ee];
    return typeof ee != "string" && ae.push(!0), ae;
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */
  applyStroke(Z) {
    this.instructions.push(this.createStroke(Z));
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */
  createStroke(Z) {
    return [
      Instruction.SET_STROKE_STYLE,
      Z.strokeStyle,
      Z.lineWidth * this.pixelRatio,
      Z.lineCap,
      Z.lineJoin,
      Z.miterLimit,
      this.applyPixelRatio(Z.lineDash),
      Z.lineDashOffset * this.pixelRatio
    ];
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */
  updateFillStyle(Z, ee) {
    const ae = Z.fillStyle;
    (typeof ae != "string" || Z.currentFillStyle != ae) && (ae !== void 0 && this.instructions.push(ee.call(this, Z)), Z.currentFillStyle = ae);
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */
  updateStrokeStyle(Z, ee) {
    const ae = Z.strokeStyle, ve = Z.lineCap, ye = Z.lineDash, be = Z.lineDashOffset, Ye = Z.lineJoin, Qe = Z.lineWidth, Je = Z.miterLimit;
    (Z.currentStrokeStyle != ae || Z.currentLineCap != ve || ye != Z.currentLineDash && !equals$2(Z.currentLineDash, ye) || Z.currentLineDashOffset != be || Z.currentLineJoin != Ye || Z.currentLineWidth != Qe || Z.currentMiterLimit != Je) && (ae !== void 0 && ee.call(this, Z), Z.currentStrokeStyle = ae, Z.currentLineCap = ve, Z.currentLineDash = ye, Z.currentLineDashOffset = be, Z.currentLineJoin = Ye, Z.currentLineWidth = Qe, Z.currentMiterLimit = Je);
  }
  /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */
  endGeometry(Z) {
    this.beginGeometryInstruction1_[2] = this.instructions.length, this.beginGeometryInstruction1_ = null, this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length, this.beginGeometryInstruction2_ = null;
    const ee = [Instruction.END_GEOMETRY, Z];
    this.instructions.push(ee), this.hitDetectionInstructions.push(ee);
  }
  /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */
  getBufferedMaxExtent() {
    if (!this.bufferedMaxExtent_ && (this.bufferedMaxExtent_ = clone(this.maxExtent), this.maxLineWidth > 0)) {
      const Z = this.resolution * (this.maxLineWidth + 1) / 2;
      buffer$1(this.bufferedMaxExtent_, Z, this.bufferedMaxExtent_);
    }
    return this.bufferedMaxExtent_;
  }
}
class CanvasImageBuilder extends CanvasBuilder {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(Z, ee, ae, ve) {
    super(Z, ee, ae, ve), this.hitDetectionImage_ = null, this.image_ = null, this.imagePixelRatio_ = void 0, this.anchorX_ = void 0, this.anchorY_ = void 0, this.height_ = void 0, this.opacity_ = void 0, this.originX_ = void 0, this.originY_ = void 0, this.rotateWithView_ = void 0, this.rotation_ = void 0, this.scale_ = void 0, this.width_ = void 0, this.declutterMode_ = void 0, this.declutterImageWithText_ = void 0;
  }
  /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */
  drawPoint(Z, ee) {
    if (!this.image_)
      return;
    this.beginGeometry(Z, ee);
    const ae = Z.getFlatCoordinates(), ve = Z.getStride(), ye = this.coordinates.length, be = this.appendFlatPointCoordinates(ae, ve);
    this.instructions.push([
      Instruction.DRAW_IMAGE,
      ye,
      be,
      this.image_,
      // Remaining arguments to DRAW_IMAGE are in alphabetical order
      this.anchorX_ * this.imagePixelRatio_,
      this.anchorY_ * this.imagePixelRatio_,
      Math.ceil(this.height_ * this.imagePixelRatio_),
      this.opacity_,
      this.originX_ * this.imagePixelRatio_,
      this.originY_ * this.imagePixelRatio_,
      this.rotateWithView_,
      this.rotation_,
      [
        this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
        this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
      ],
      Math.ceil(this.width_ * this.imagePixelRatio_),
      this.declutterMode_,
      this.declutterImageWithText_
    ]), this.hitDetectionInstructions.push([
      Instruction.DRAW_IMAGE,
      ye,
      be,
      this.hitDetectionImage_,
      // Remaining arguments to DRAW_IMAGE are in alphabetical order
      this.anchorX_,
      this.anchorY_,
      this.height_,
      1,
      this.originX_,
      this.originY_,
      this.rotateWithView_,
      this.rotation_,
      this.scale_,
      this.width_,
      this.declutterMode_,
      this.declutterImageWithText_
    ]), this.endGeometry(ee);
  }
  /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */
  drawMultiPoint(Z, ee) {
    if (!this.image_)
      return;
    this.beginGeometry(Z, ee);
    const ae = Z.getFlatCoordinates(), ve = Z.getStride(), ye = this.coordinates.length, be = this.appendFlatPointCoordinates(ae, ve);
    this.instructions.push([
      Instruction.DRAW_IMAGE,
      ye,
      be,
      this.image_,
      // Remaining arguments to DRAW_IMAGE are in alphabetical order
      this.anchorX_ * this.imagePixelRatio_,
      this.anchorY_ * this.imagePixelRatio_,
      Math.ceil(this.height_ * this.imagePixelRatio_),
      this.opacity_,
      this.originX_ * this.imagePixelRatio_,
      this.originY_ * this.imagePixelRatio_,
      this.rotateWithView_,
      this.rotation_,
      [
        this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
        this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
      ],
      Math.ceil(this.width_ * this.imagePixelRatio_),
      this.declutterMode_,
      this.declutterImageWithText_
    ]), this.hitDetectionInstructions.push([
      Instruction.DRAW_IMAGE,
      ye,
      be,
      this.hitDetectionImage_,
      // Remaining arguments to DRAW_IMAGE are in alphabetical order
      this.anchorX_,
      this.anchorY_,
      this.height_,
      1,
      this.originX_,
      this.originY_,
      this.rotateWithView_,
      this.rotation_,
      this.scale_,
      this.width_,
      this.declutterMode_,
      this.declutterImageWithText_
    ]), this.endGeometry(ee);
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */
  finish() {
    return this.reverseHitDetectionInstructions(), this.anchorX_ = void 0, this.anchorY_ = void 0, this.hitDetectionImage_ = null, this.image_ = null, this.imagePixelRatio_ = void 0, this.height_ = void 0, this.scale_ = void 0, this.opacity_ = void 0, this.originX_ = void 0, this.originY_ = void 0, this.rotateWithView_ = void 0, this.rotation_ = void 0, this.width_ = void 0, super.finish();
  }
  /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   */
  setImageStyle(Z, ee) {
    const ae = Z.getAnchor(), ve = Z.getSize(), ye = Z.getOrigin();
    this.imagePixelRatio_ = Z.getPixelRatio(this.pixelRatio), this.anchorX_ = ae[0], this.anchorY_ = ae[1], this.hitDetectionImage_ = Z.getHitDetectionImage(), this.image_ = Z.getImage(this.pixelRatio), this.height_ = ve[1], this.opacity_ = Z.getOpacity(), this.originX_ = ye[0], this.originY_ = ye[1], this.rotateWithView_ = Z.getRotateWithView(), this.rotation_ = Z.getRotation(), this.scale_ = Z.getScaleArray(), this.width_ = ve[0], this.declutterMode_ = Z.getDeclutterMode(), this.declutterImageWithText_ = ee;
  }
}
const ImageBuilder = CanvasImageBuilder;
class CanvasLineStringBuilder extends CanvasBuilder {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(Z, ee, ae, ve) {
    super(Z, ee, ae, ve);
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */
  drawFlatCoordinates_(Z, ee, ae, ve) {
    const ye = this.coordinates.length, be = this.appendFlatLineCoordinates(
      Z,
      ee,
      ae,
      ve,
      !1,
      !1
    ), Ye = [
      Instruction.MOVE_TO_LINE_TO,
      ye,
      be
    ];
    return this.instructions.push(Ye), this.hitDetectionInstructions.push(Ye), ae;
  }
  /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */
  drawLineString(Z, ee) {
    const ae = this.state, ve = ae.strokeStyle, ye = ae.lineWidth;
    if (ve === void 0 || ye === void 0)
      return;
    this.updateStrokeStyle(ae, this.applyStroke), this.beginGeometry(Z, ee), this.hitDetectionInstructions.push(
      [
        Instruction.SET_STROKE_STYLE,
        ae.strokeStyle,
        ae.lineWidth,
        ae.lineCap,
        ae.lineJoin,
        ae.miterLimit,
        defaultLineDash,
        defaultLineDashOffset
      ],
      beginPathInstruction
    );
    const be = Z.getFlatCoordinates(), Ye = Z.getStride();
    this.drawFlatCoordinates_(
      be,
      0,
      be.length,
      Ye
    ), this.hitDetectionInstructions.push(strokeInstruction), this.endGeometry(ee);
  }
  /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */
  drawMultiLineString(Z, ee) {
    const ae = this.state, ve = ae.strokeStyle, ye = ae.lineWidth;
    if (ve === void 0 || ye === void 0)
      return;
    this.updateStrokeStyle(ae, this.applyStroke), this.beginGeometry(Z, ee), this.hitDetectionInstructions.push(
      [
        Instruction.SET_STROKE_STYLE,
        ae.strokeStyle,
        ae.lineWidth,
        ae.lineCap,
        ae.lineJoin,
        ae.miterLimit,
        defaultLineDash,
        defaultLineDashOffset
      ],
      beginPathInstruction
    );
    const be = Z.getEnds(), Ye = Z.getFlatCoordinates(), Qe = Z.getStride();
    let Je = 0;
    for (let nt = 0, st = be.length; nt < st; ++nt)
      Je = this.drawFlatCoordinates_(
        Ye,
        Je,
        /** @type {number} */
        be[nt],
        Qe
      );
    this.hitDetectionInstructions.push(strokeInstruction), this.endGeometry(ee);
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */
  finish() {
    const Z = this.state;
    return Z.lastStroke != null && Z.lastStroke != this.coordinates.length && this.instructions.push(strokeInstruction), this.reverseHitDetectionInstructions(), this.state = null, super.finish();
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */
  applyStroke(Z) {
    Z.lastStroke != null && Z.lastStroke != this.coordinates.length && (this.instructions.push(strokeInstruction), Z.lastStroke = this.coordinates.length), Z.lastStroke = 0, super.applyStroke(Z), this.instructions.push(beginPathInstruction);
  }
}
const LineStringBuilder = CanvasLineStringBuilder;
class CanvasPolygonBuilder extends CanvasBuilder {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(Z, ee, ae, ve) {
    super(Z, ee, ae, ve);
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */
  drawFlatCoordinatess_(Z, ee, ae, ve) {
    const ye = this.state, be = ye.fillStyle !== void 0, Ye = ye.strokeStyle !== void 0, Qe = ae.length;
    this.instructions.push(beginPathInstruction), this.hitDetectionInstructions.push(beginPathInstruction);
    for (let Je = 0; Je < Qe; ++Je) {
      const nt = ae[Je], st = this.coordinates.length, ot = this.appendFlatLineCoordinates(
        Z,
        ee,
        nt,
        ve,
        !0,
        !Ye
      ), lt = [
        Instruction.MOVE_TO_LINE_TO,
        st,
        ot
      ];
      this.instructions.push(lt), this.hitDetectionInstructions.push(lt), Ye && (this.instructions.push(closePathInstruction), this.hitDetectionInstructions.push(closePathInstruction)), ee = nt;
    }
    return be && (this.instructions.push(fillInstruction), this.hitDetectionInstructions.push(fillInstruction)), Ye && (this.instructions.push(strokeInstruction), this.hitDetectionInstructions.push(strokeInstruction)), ee;
  }
  /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   */
  drawCircle(Z, ee) {
    const ae = this.state, ve = ae.fillStyle, ye = ae.strokeStyle;
    if (ve === void 0 && ye === void 0)
      return;
    this.setFillStrokeStyles_(), this.beginGeometry(Z, ee), ae.fillStyle !== void 0 && this.hitDetectionInstructions.push([
      Instruction.SET_FILL_STYLE,
      defaultFillStyle
    ]), ae.strokeStyle !== void 0 && this.hitDetectionInstructions.push([
      Instruction.SET_STROKE_STYLE,
      ae.strokeStyle,
      ae.lineWidth,
      ae.lineCap,
      ae.lineJoin,
      ae.miterLimit,
      defaultLineDash,
      defaultLineDashOffset
    ]);
    const be = Z.getFlatCoordinates(), Ye = Z.getStride(), Qe = this.coordinates.length;
    this.appendFlatLineCoordinates(
      be,
      0,
      be.length,
      Ye,
      !1,
      !1
    );
    const Je = [Instruction.CIRCLE, Qe];
    this.instructions.push(beginPathInstruction, Je), this.hitDetectionInstructions.push(beginPathInstruction, Je), ae.fillStyle !== void 0 && (this.instructions.push(fillInstruction), this.hitDetectionInstructions.push(fillInstruction)), ae.strokeStyle !== void 0 && (this.instructions.push(strokeInstruction), this.hitDetectionInstructions.push(strokeInstruction)), this.endGeometry(ee);
  }
  /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */
  drawPolygon(Z, ee) {
    const ae = this.state, ve = ae.fillStyle, ye = ae.strokeStyle;
    if (ve === void 0 && ye === void 0)
      return;
    this.setFillStrokeStyles_(), this.beginGeometry(Z, ee), ae.fillStyle !== void 0 && this.hitDetectionInstructions.push([
      Instruction.SET_FILL_STYLE,
      defaultFillStyle
    ]), ae.strokeStyle !== void 0 && this.hitDetectionInstructions.push([
      Instruction.SET_STROKE_STYLE,
      ae.strokeStyle,
      ae.lineWidth,
      ae.lineCap,
      ae.lineJoin,
      ae.miterLimit,
      defaultLineDash,
      defaultLineDashOffset
    ]);
    const be = Z.getEnds(), Ye = Z.getOrientedFlatCoordinates(), Qe = Z.getStride();
    this.drawFlatCoordinatess_(
      Ye,
      0,
      /** @type {Array<number>} */
      be,
      Qe
    ), this.endGeometry(ee);
  }
  /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */
  drawMultiPolygon(Z, ee) {
    const ae = this.state, ve = ae.fillStyle, ye = ae.strokeStyle;
    if (ve === void 0 && ye === void 0)
      return;
    this.setFillStrokeStyles_(), this.beginGeometry(Z, ee), ae.fillStyle !== void 0 && this.hitDetectionInstructions.push([
      Instruction.SET_FILL_STYLE,
      defaultFillStyle
    ]), ae.strokeStyle !== void 0 && this.hitDetectionInstructions.push([
      Instruction.SET_STROKE_STYLE,
      ae.strokeStyle,
      ae.lineWidth,
      ae.lineCap,
      ae.lineJoin,
      ae.miterLimit,
      defaultLineDash,
      defaultLineDashOffset
    ]);
    const be = Z.getEndss(), Ye = Z.getOrientedFlatCoordinates(), Qe = Z.getStride();
    let Je = 0;
    for (let nt = 0, st = be.length; nt < st; ++nt)
      Je = this.drawFlatCoordinatess_(
        Ye,
        Je,
        be[nt],
        Qe
      );
    this.endGeometry(ee);
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */
  finish() {
    this.reverseHitDetectionInstructions(), this.state = null;
    const Z = this.tolerance;
    if (Z !== 0) {
      const ee = this.coordinates;
      for (let ae = 0, ve = ee.length; ae < ve; ++ae)
        ee[ae] = snap(ee[ae], Z);
    }
    return super.finish();
  }
  /**
   * @private
   */
  setFillStrokeStyles_() {
    const Z = this.state;
    Z.fillStyle !== void 0 && this.updateFillStyle(Z, this.createFill), Z.strokeStyle !== void 0 && this.updateStrokeStyle(Z, this.applyStroke);
  }
}
const PolygonBuilder = CanvasPolygonBuilder;
function lineChunk(ie, Z, ee, ae, ve) {
  const ye = [];
  let be = ee, Ye = 0, Qe = Z.slice(ee, 2);
  for (; Ye < ie && be + ve < ae; ) {
    const [Je, nt] = Qe.slice(-2), st = Z[be + ve], ot = Z[be + ve + 1], lt = Math.sqrt(
      (st - Je) * (st - Je) + (ot - nt) * (ot - nt)
    );
    if (Ye += lt, Ye >= ie) {
      const ft = (ie - Ye + lt) / lt, gt = lerp$1(Je, st, ft), ct = lerp$1(nt, ot, ft);
      Qe.push(gt, ct), ye.push(Qe), Qe = [gt, ct], Ye == ie && (be += ve), Ye = 0;
    } else if (Ye < ie)
      Qe.push(
        Z[be + ve],
        Z[be + ve + 1]
      ), be += ve;
    else {
      const ft = lt - Ye, gt = lerp$1(Je, st, ft / lt), ct = lerp$1(nt, ot, ft / lt);
      Qe.push(gt, ct), ye.push(Qe), Qe = [gt, ct], Ye = 0, be += ve;
    }
  }
  return Ye > 0 && ye.push(Qe), ye;
}
function matchingChunk(ie, Z, ee, ae, ve) {
  let ye = ee, be = ee, Ye = 0, Qe = 0, Je = ee, nt, st, ot, lt, ft, gt, ct, _r, Kr, Xr;
  for (st = ee; st < ae; st += ve) {
    const Jr = Z[st], ei = Z[st + 1];
    ft !== void 0 && (Kr = Jr - ft, Xr = ei - gt, lt = Math.sqrt(Kr * Kr + Xr * Xr), ct !== void 0 && (Qe += ot, nt = Math.acos((ct * Kr + _r * Xr) / (ot * lt)), nt > ie && (Qe > Ye && (Ye = Qe, ye = Je, be = st), Qe = 0, Je = st - ve)), ot = lt, ct = Kr, _r = Xr), ft = Jr, gt = ei;
  }
  return Qe += lt, Qe > Ye ? [Je, st] : [ye, be];
}
const TEXT_ALIGN = {
  left: 0,
  center: 0.5,
  right: 1,
  top: 0,
  middle: 0.5,
  hanging: 0.2,
  alphabetic: 0.8,
  ideographic: 0.8,
  bottom: 1
};
class CanvasTextBuilder extends CanvasBuilder {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(Z, ee, ae, ve) {
    super(Z, ee, ae, ve), this.labels_ = null, this.text_ = "", this.textOffsetX_ = 0, this.textOffsetY_ = 0, this.textRotateWithView_ = void 0, this.textRotation_ = 0, this.textFillState_ = null, this.fillStates = {}, this.fillStates[defaultFillStyle] = { fillStyle: defaultFillStyle }, this.textStrokeState_ = null, this.strokeStates = {}, this.textState_ = /** @type {import("../canvas.js").TextState} */
    {}, this.textStates = {}, this.textKey_ = "", this.fillKey_ = "", this.strokeKey_ = "", this.declutterImageWithText_ = void 0;
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */
  finish() {
    const Z = super.finish();
    return Z.textStates = this.textStates, Z.fillStates = this.fillStates, Z.strokeStates = this.strokeStates, Z;
  }
  /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */
  drawText(Z, ee) {
    const ae = this.textFillState_, ve = this.textStrokeState_, ye = this.textState_;
    if (this.text_ === "" || !ye || !ae && !ve)
      return;
    const be = this.coordinates;
    let Ye = be.length;
    const Qe = Z.getType();
    let Je = null, nt = Z.getStride();
    if (ye.placement === "line" && (Qe == "LineString" || Qe == "MultiLineString" || Qe == "Polygon" || Qe == "MultiPolygon")) {
      if (!intersects$1(this.getBufferedMaxExtent(), Z.getExtent()))
        return;
      let st;
      if (Je = Z.getFlatCoordinates(), Qe == "LineString")
        st = [Je.length];
      else if (Qe == "MultiLineString")
        st = /** @type {import("../../geom/MultiLineString.js").default} */
        Z.getEnds();
      else if (Qe == "Polygon")
        st = /** @type {import("../../geom/Polygon.js").default} */
        Z.getEnds().slice(0, 1);
      else if (Qe == "MultiPolygon") {
        const gt = (
          /** @type {import("../../geom/MultiPolygon.js").default} */
          Z.getEndss()
        );
        st = [];
        for (let ct = 0, _r = gt.length; ct < _r; ++ct)
          st.push(gt[ct][0]);
      }
      this.beginGeometry(Z, ee);
      const ot = ye.repeat, lt = ot ? void 0 : ye.textAlign;
      let ft = 0;
      for (let gt = 0, ct = st.length; gt < ct; ++gt) {
        let _r;
        ot ? _r = lineChunk(
          ot * this.resolution,
          Je,
          ft,
          st[gt],
          nt
        ) : _r = [Je.slice(ft, st[gt])];
        for (let Kr = 0, Xr = _r.length; Kr < Xr; ++Kr) {
          const Jr = _r[Kr];
          let ei = 0, si = Jr.length;
          if (lt == null) {
            const ai = matchingChunk(
              ye.maxAngle,
              Jr,
              0,
              Jr.length,
              2
            );
            ei = ai[0], si = ai[1];
          }
          for (let ai = ei; ai < si; ai += nt)
            be.push(Jr[ai], Jr[ai + 1]);
          const ri = be.length;
          ft = st[gt], this.drawChars_(Ye, ri), Ye = ri;
        }
      }
      this.endGeometry(ee);
    } else {
      let st = ye.overflow ? null : [];
      switch (Qe) {
        case "Point":
        case "MultiPoint":
          Je = /** @type {import("../../geom/MultiPoint.js").default} */
          Z.getFlatCoordinates();
          break;
        case "LineString":
          Je = /** @type {import("../../geom/LineString.js").default} */
          Z.getFlatMidpoint();
          break;
        case "Circle":
          Je = /** @type {import("../../geom/Circle.js").default} */
          Z.getCenter();
          break;
        case "MultiLineString":
          Je = /** @type {import("../../geom/MultiLineString.js").default} */
          Z.getFlatMidpoints(), nt = 2;
          break;
        case "Polygon":
          Je = /** @type {import("../../geom/Polygon.js").default} */
          Z.getFlatInteriorPoint(), ye.overflow || st.push(Je[2] / this.resolution), nt = 3;
          break;
        case "MultiPolygon":
          const _r = (
            /** @type {import("../../geom/MultiPolygon.js").default} */
            Z.getFlatInteriorPoints()
          );
          Je = [];
          for (let Kr = 0, Xr = _r.length; Kr < Xr; Kr += 3)
            ye.overflow || st.push(_r[Kr + 2] / this.resolution), Je.push(_r[Kr], _r[Kr + 1]);
          if (Je.length === 0)
            return;
          nt = 2;
          break;
      }
      const ot = this.appendFlatPointCoordinates(Je, nt);
      if (ot === Ye)
        return;
      if (st && (ot - Ye) / 2 !== Je.length / nt) {
        let _r = Ye / 2;
        st = st.filter((Kr, Xr) => {
          const Jr = be[(_r + Xr) * 2] === Je[Xr * nt] && be[(_r + Xr) * 2 + 1] === Je[Xr * nt + 1];
          return Jr || --_r, Jr;
        });
      }
      this.saveTextStates_(), (ye.backgroundFill || ye.backgroundStroke) && (this.setFillStrokeStyle(
        ye.backgroundFill,
        ye.backgroundStroke
      ), ye.backgroundFill && this.updateFillStyle(this.state, this.createFill), ye.backgroundStroke && (this.updateStrokeStyle(this.state, this.applyStroke), this.hitDetectionInstructions.push(this.createStroke(this.state)))), this.beginGeometry(Z, ee);
      let lt = ye.padding;
      if (lt != defaultPadding && (ye.scale[0] < 0 || ye.scale[1] < 0)) {
        let _r = ye.padding[0], Kr = ye.padding[1], Xr = ye.padding[2], Jr = ye.padding[3];
        ye.scale[0] < 0 && (Kr = -Kr, Jr = -Jr), ye.scale[1] < 0 && (_r = -_r, Xr = -Xr), lt = [_r, Kr, Xr, Jr];
      }
      const ft = this.pixelRatio;
      this.instructions.push([
        Instruction.DRAW_IMAGE,
        Ye,
        ot,
        null,
        NaN,
        NaN,
        NaN,
        1,
        0,
        0,
        this.textRotateWithView_,
        this.textRotation_,
        [1, 1],
        NaN,
        void 0,
        this.declutterImageWithText_,
        lt == defaultPadding ? defaultPadding : lt.map(function(_r) {
          return _r * ft;
        }),
        !!ye.backgroundFill,
        !!ye.backgroundStroke,
        this.text_,
        this.textKey_,
        this.strokeKey_,
        this.fillKey_,
        this.textOffsetX_,
        this.textOffsetY_,
        st
      ]);
      const gt = 1 / ft, ct = this.state.fillStyle;
      ye.backgroundFill && (this.state.fillStyle = defaultFillStyle, this.hitDetectionInstructions.push(this.createFill(this.state))), this.hitDetectionInstructions.push([
        Instruction.DRAW_IMAGE,
        Ye,
        ot,
        null,
        NaN,
        NaN,
        NaN,
        1,
        0,
        0,
        this.textRotateWithView_,
        this.textRotation_,
        [gt, gt],
        NaN,
        void 0,
        this.declutterImageWithText_,
        lt,
        !!ye.backgroundFill,
        !!ye.backgroundStroke,
        this.text_,
        this.textKey_,
        this.strokeKey_,
        this.fillKey_ ? defaultFillStyle : this.fillKey_,
        this.textOffsetX_,
        this.textOffsetY_,
        st
      ]), ye.backgroundFill && (this.state.fillStyle = ct, this.hitDetectionInstructions.push(this.createFill(this.state))), this.endGeometry(ee);
    }
  }
  /**
   * @private
   */
  saveTextStates_() {
    const Z = this.textStrokeState_, ee = this.textState_, ae = this.textFillState_, ve = this.strokeKey_;
    Z && (ve in this.strokeStates || (this.strokeStates[ve] = {
      strokeStyle: Z.strokeStyle,
      lineCap: Z.lineCap,
      lineDashOffset: Z.lineDashOffset,
      lineWidth: Z.lineWidth,
      lineJoin: Z.lineJoin,
      miterLimit: Z.miterLimit,
      lineDash: Z.lineDash
    }));
    const ye = this.textKey_;
    ye in this.textStates || (this.textStates[ye] = {
      font: ee.font,
      textAlign: ee.textAlign || defaultTextAlign,
      justify: ee.justify,
      textBaseline: ee.textBaseline || defaultTextBaseline,
      scale: ee.scale
    });
    const be = this.fillKey_;
    ae && (be in this.fillStates || (this.fillStates[be] = {
      fillStyle: ae.fillStyle
    }));
  }
  /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */
  drawChars_(Z, ee) {
    const ae = this.textStrokeState_, ve = this.textState_, ye = this.strokeKey_, be = this.textKey_, Ye = this.fillKey_;
    this.saveTextStates_();
    const Qe = this.pixelRatio, Je = TEXT_ALIGN[ve.textBaseline], nt = this.textOffsetY_ * Qe, st = this.text_, ot = ae ? ae.lineWidth * Math.abs(ve.scale[0]) / 2 : 0;
    this.instructions.push([
      Instruction.DRAW_CHARS,
      Z,
      ee,
      Je,
      ve.overflow,
      Ye,
      ve.maxAngle,
      Qe,
      nt,
      ye,
      ot * Qe,
      st,
      be,
      1
    ]), this.hitDetectionInstructions.push([
      Instruction.DRAW_CHARS,
      Z,
      ee,
      Je,
      ve.overflow,
      Ye && defaultFillStyle,
      ve.maxAngle,
      Qe,
      nt,
      ye,
      ot * Qe,
      st,
      be,
      1 / Qe
    ]);
  }
  /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   */
  setTextStyle(Z, ee) {
    let ae, ve, ye;
    if (!Z)
      this.text_ = "";
    else {
      const be = Z.getFill();
      be ? (ve = this.textFillState_, ve || (ve = /** @type {import("../canvas.js").FillState} */
      {}, this.textFillState_ = ve), ve.fillStyle = asColorLike(
        be.getColor() || defaultFillStyle
      )) : (ve = null, this.textFillState_ = ve);
      const Ye = Z.getStroke();
      if (!Ye)
        ye = null, this.textStrokeState_ = ye;
      else {
        ye = this.textStrokeState_, ye || (ye = /** @type {import("../canvas.js").StrokeState} */
        {}, this.textStrokeState_ = ye);
        const ft = Ye.getLineDash(), gt = Ye.getLineDashOffset(), ct = Ye.getWidth(), _r = Ye.getMiterLimit();
        ye.lineCap = Ye.getLineCap() || defaultLineCap, ye.lineDash = ft ? ft.slice() : defaultLineDash, ye.lineDashOffset = gt === void 0 ? defaultLineDashOffset : gt, ye.lineJoin = Ye.getLineJoin() || defaultLineJoin, ye.lineWidth = ct === void 0 ? defaultLineWidth : ct, ye.miterLimit = _r === void 0 ? defaultMiterLimit : _r, ye.strokeStyle = asColorLike(
          Ye.getColor() || defaultStrokeStyle
        );
      }
      ae = this.textState_;
      const Qe = Z.getFont() || defaultFont;
      registerFont(Qe);
      const Je = Z.getScaleArray();
      ae.overflow = Z.getOverflow(), ae.font = Qe, ae.maxAngle = Z.getMaxAngle(), ae.placement = Z.getPlacement(), ae.textAlign = Z.getTextAlign(), ae.repeat = Z.getRepeat(), ae.justify = Z.getJustify(), ae.textBaseline = Z.getTextBaseline() || defaultTextBaseline, ae.backgroundFill = Z.getBackgroundFill(), ae.backgroundStroke = Z.getBackgroundStroke(), ae.padding = Z.getPadding() || defaultPadding, ae.scale = Je === void 0 ? [1, 1] : Je;
      const nt = Z.getOffsetX(), st = Z.getOffsetY(), ot = Z.getRotateWithView(), lt = Z.getRotation();
      this.text_ = Z.getText() || "", this.textOffsetX_ = nt === void 0 ? 0 : nt, this.textOffsetY_ = st === void 0 ? 0 : st, this.textRotateWithView_ = ot === void 0 ? !1 : ot, this.textRotation_ = lt === void 0 ? 0 : lt, this.strokeKey_ = ye ? (typeof ye.strokeStyle == "string" ? ye.strokeStyle : getUid(ye.strokeStyle)) + ye.lineCap + ye.lineDashOffset + "|" + ye.lineWidth + ye.lineJoin + ye.miterLimit + "[" + ye.lineDash.join() + "]" : "", this.textKey_ = ae.font + ae.scale + (ae.textAlign || "?") + (ae.repeat || "?") + (ae.justify || "?") + (ae.textBaseline || "?"), this.fillKey_ = ve ? typeof ve.fillStyle == "string" ? ve.fillStyle : "|" + getUid(ve.fillStyle) : "";
    }
    this.declutterImageWithText_ = ee;
  }
}
const BATCH_CONSTRUCTORS = {
  Circle: PolygonBuilder,
  Default: CanvasBuilder,
  Image: ImageBuilder,
  LineString: LineStringBuilder,
  Polygon: PolygonBuilder,
  Text: CanvasTextBuilder
};
class BuilderGroup {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(Z, ee, ae, ve) {
    this.tolerance_ = Z, this.maxExtent_ = ee, this.pixelRatio_ = ve, this.resolution_ = ae, this.buildersByZIndex_ = {};
  }
  /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */
  finish() {
    const Z = {};
    for (const ee in this.buildersByZIndex_) {
      Z[ee] = Z[ee] || {};
      const ae = this.buildersByZIndex_[ee];
      for (const ve in ae) {
        const ye = ae[ve].finish();
        Z[ee][ve] = ye;
      }
    }
    return Z;
  }
  /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */
  getBuilder(Z, ee) {
    const ae = Z !== void 0 ? Z.toString() : "0";
    let ve = this.buildersByZIndex_[ae];
    ve === void 0 && (ve = {}, this.buildersByZIndex_[ae] = ve);
    let ye = ve[ee];
    if (ye === void 0) {
      const be = BATCH_CONSTRUCTORS[ee];
      ye = new be(
        this.tolerance_,
        this.maxExtent_,
        this.resolution_,
        this.pixelRatio_
      ), ve[ee] = ye;
    }
    return ye;
  }
}
class LayerRenderer extends Observable {
  /**
   * @param {LayerType} layer Layer.
   */
  constructor(Z) {
    super(), this.ready = !0, this.boundHandleImageChange_ = this.handleImageChange_.bind(this), this.layer_ = Z, this.declutterExecutorGroup = null;
  }
  /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */
  getFeatures(Z) {
    return abstract();
  }
  /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */
  getData(Z) {
    return null;
  }
  /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */
  prepareFrame(Z) {
    return abstract();
  }
  /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   */
  renderFrame(Z, ee) {
    return abstract();
  }
  /**
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @param {number} zoom Zoom level.
   * @param {import("../Tile.js").default} tile Tile.
   * @return {boolean|void} If `false`, the tile will not be considered loaded.
   */
  loadedTileCallback(Z, ee, ae) {
    Z[ee] || (Z[ee] = {}), Z[ee][ae.tileCoord.toString()] = ae;
  }
  /**
   * Create a function that adds loaded tiles to the tile lookup.
   * @param {import("../source/Tile.js").default} source Tile source.
   * @param {import("../proj/Projection.js").default} projection Projection of the tiles.
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @return {function(number, import("../TileRange.js").default):boolean} A function that can be
   *     called with a zoom level and a tile range to add loaded tiles to the lookup.
   * @protected
   */
  createLoadedTileFinder(Z, ee, ae) {
    return (
      /**
       * @param {number} zoom Zoom level.
       * @param {import("../TileRange.js").default} tileRange Tile range.
       * @return {boolean} The tile range is fully loaded.
       */
      (ve, ye) => {
        const be = this.loadedTileCallback.bind(this, ae, ve);
        return Z.forEachLoadedTile(ee, ve, ye, be);
      }
    );
  }
  /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */
  forEachFeatureAtCoordinate(Z, ee, ae, ve, ye) {
  }
  /**
   * @return {LayerType} Layer.
   */
  getLayer() {
    return this.layer_;
  }
  /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */
  handleFontsChanged() {
  }
  /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */
  handleImageChange_(Z) {
    const ee = (
      /** @type {import("../Image.js").default} */
      Z.target
    );
    (ee.getState() === ImageState.LOADED || ee.getState() === ImageState.ERROR) && this.renderIfReadyAndVisible();
  }
  /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */
  loadImage(Z) {
    let ee = Z.getState();
    return ee != ImageState.LOADED && ee != ImageState.ERROR && Z.addEventListener(EventType.CHANGE, this.boundHandleImageChange_), ee == ImageState.IDLE && (Z.load(), ee = Z.getState()), ee == ImageState.LOADED;
  }
  /**
   * @protected
   */
  renderIfReadyAndVisible() {
    const Z = this.getLayer();
    Z && Z.getVisible() && Z.getSourceState() === "ready" && Z.changed();
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    delete this.layer_, super.disposeInternal();
  }
}
class RenderEvent extends BaseEvent {
  /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */
  constructor(Z, ee, ae, ve) {
    super(Z), this.inversePixelTransform = ee, this.frameState = ae, this.context = ve;
  }
}
let pixelContext$1 = null;
function createPixelContext$1() {
  pixelContext$1 = createCanvasContext2D(1, 1, void 0, {
    willReadFrequently: !0
  });
}
class CanvasLayerRenderer extends LayerRenderer {
  /**
   * @param {LayerType} layer Layer.
   */
  constructor(Z) {
    super(Z), this.container = null, this.renderedResolution, this.tempTransform = create$2(), this.pixelTransform = create$2(), this.inversePixelTransform = create$2(), this.context = null, this.containerReused = !1, this.pixelContext_ = null, this.frameState = null;
  }
  /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */
  getImageData(Z, ee, ae) {
    pixelContext$1 || createPixelContext$1(), pixelContext$1.clearRect(0, 0, 1, 1);
    let ve;
    try {
      pixelContext$1.drawImage(Z, ee, ae, 1, 1, 0, 0, 1, 1), ve = pixelContext$1.getImageData(0, 0, 1, 1).data;
    } catch {
      return pixelContext$1 = null, null;
    }
    return ve;
  }
  /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */
  getBackground(Z) {
    let ae = this.getLayer().getBackground();
    return typeof ae == "function" && (ae = ae(Z.viewState.resolution)), ae || void 0;
  }
  /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS Transform.
   * @param {string} [backgroundColor] Background color.
   */
  useContainer(Z, ee, ae) {
    const ve = this.getLayer().getClassName();
    let ye, be;
    if (Z && Z.className === ve && (!ae || Z && Z.style.backgroundColor && equals$2(
      asArray(Z.style.backgroundColor),
      asArray(ae)
    ))) {
      const Ye = Z.firstElementChild;
      Ye instanceof HTMLCanvasElement && (be = Ye.getContext("2d"));
    }
    if (be && be.canvas.style.transform === ee ? (this.container = Z, this.context = be, this.containerReused = !0) : this.containerReused ? (this.container = null, this.context = null, this.containerReused = !1) : this.container && (this.container.style.backgroundColor = null), !this.container) {
      ye = document.createElement("div"), ye.className = ve;
      let Ye = ye.style;
      Ye.position = "absolute", Ye.width = "100%", Ye.height = "100%", be = createCanvasContext2D();
      const Qe = be.canvas;
      ye.appendChild(Qe), Ye = Qe.style, Ye.position = "absolute", Ye.left = "0", Ye.transformOrigin = "top left", this.container = ye, this.context = be;
    }
    !this.containerReused && ae && !this.container.style.backgroundColor && (this.container.style.backgroundColor = ae);
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */
  clipUnrotated(Z, ee, ae) {
    const ve = getTopLeft(ae), ye = getTopRight(ae), be = getBottomRight(ae), Ye = getBottomLeft(ae);
    apply(ee.coordinateToPixelTransform, ve), apply(ee.coordinateToPixelTransform, ye), apply(ee.coordinateToPixelTransform, be), apply(ee.coordinateToPixelTransform, Ye);
    const Qe = this.inversePixelTransform;
    apply(Qe, ve), apply(Qe, ye), apply(Qe, be), apply(Qe, Ye), Z.save(), Z.beginPath(), Z.moveTo(Math.round(ve[0]), Math.round(ve[1])), Z.lineTo(Math.round(ye[0]), Math.round(ye[1])), Z.lineTo(Math.round(be[0]), Math.round(be[1])), Z.lineTo(Math.round(Ye[0]), Math.round(Ye[1])), Z.clip();
  }
  /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */
  dispatchRenderEvent_(Z, ee, ae) {
    const ve = this.getLayer();
    if (ve.hasListener(Z)) {
      const ye = new RenderEvent(
        Z,
        this.inversePixelTransform,
        ae,
        ee
      );
      ve.dispatchEvent(ye);
    }
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */
  preRender(Z, ee) {
    this.frameState = ee, this.dispatchRenderEvent_(RenderEventType.PRERENDER, Z, ee);
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */
  postRender(Z, ee) {
    this.dispatchRenderEvent_(RenderEventType.POSTRENDER, Z, ee);
  }
  /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */
  getRenderTransform(Z, ee, ae, ve, ye, be, Ye) {
    const Qe = ye / 2, Je = be / 2, nt = ve / ee, st = -nt, ot = -Z[0] + Ye, lt = -Z[1];
    return compose$1(
      this.tempTransform,
      Qe,
      Je,
      nt,
      st,
      -ae,
      ot,
      lt
    );
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    delete this.frameState, super.disposeInternal();
  }
}
function drawTextOnPath(ie, Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt, st) {
  let ot = ie[Z], lt = ie[Z + 1], ft = 0, gt = 0, ct = 0, _r = 0;
  function Kr() {
    ft = ot, gt = lt, Z += ae, ot = ie[Z], lt = ie[Z + 1], _r += ct, ct = Math.sqrt((ot - ft) * (ot - ft) + (lt - gt) * (lt - gt));
  }
  do
    Kr();
  while (Z < ee - ae && _r + ct < ye);
  let Xr = ct === 0 ? 0 : (ye - _r) / ct;
  const Jr = lerp$1(ft, ot, Xr), ei = lerp$1(gt, lt, Xr), si = Z - ae, ri = _r, ai = ye + Ye * Qe(Je, ve, nt);
  for (; Z < ee - ae && _r + ct < ai; )
    Kr();
  Xr = ct === 0 ? 0 : (ai - _r) / ct;
  const yi = lerp$1(ft, ot, Xr), pi = lerp$1(gt, lt, Xr);
  let di;
  if (st) {
    const Si = [Jr, ei, yi, pi];
    rotate$1(Si, 0, 4, 2, st, Si, Si), di = Si[0] > Si[2];
  } else
    di = Jr > yi;
  const xi = Math.PI, Ti = [], Ai = si + ae === Z;
  Z = si, ct = 0, _r = ri, ot = ie[Z], lt = ie[Z + 1];
  let mi;
  if (Ai) {
    Kr(), mi = Math.atan2(lt - gt, ot - ft), di && (mi += mi > 0 ? -xi : xi);
    const Si = (yi + Jr) / 2, gi = (pi + ei) / 2;
    return Ti[0] = [Si, gi, (ai - ye) / 2, mi, ve], Ti;
  }
  ve = ve.replace(/\n/g, " ");
  for (let Si = 0, gi = ve.length; Si < gi; ) {
    Kr();
    let _i = Math.atan2(lt - gt, ot - ft);
    if (di && (_i += _i > 0 ? -xi : xi), mi !== void 0) {
      let Hi = _i - mi;
      if (Hi += Hi > xi ? -2 * xi : Hi < -xi ? 2 * xi : 0, Math.abs(Hi) > be)
        return null;
    }
    mi = _i;
    const Oi = Si;
    let hi = 0;
    for (; Si < gi; ++Si) {
      const Hi = di ? gi - Si - 1 : Si, qi = Ye * Qe(Je, ve[Hi], nt);
      if (Z + ae < ee && _r + ct < ye + hi + qi / 2)
        break;
      hi += qi;
    }
    if (Si === Oi)
      continue;
    const Di = di ? ve.substring(gi - Oi, gi - Si) : ve.substring(Oi, Si);
    Xr = ct === 0 ? 0 : (ye + hi / 2 - _r) / ct;
    const Ri = lerp$1(ft, ot, Xr), rs = lerp$1(gt, lt, Xr);
    Ti.push([Ri, rs, hi / 2, _i, Di]), ye += hi;
  }
  return Ti;
}
const tmpExtent = createEmpty(), p1 = [], p2 = [], p3 = [], p4 = [];
function getDeclutterBox(ie) {
  return ie[3].declutterBox;
}
const rtlRegEx = new RegExp(
  /* eslint-disable prettier/prettier */
  "[֑-ࣿיִ-﷿ﹰ-ﻼࠀ-࿿-]"
  /* eslint-enable prettier/prettier */
);
function horizontalTextAlign(ie, Z) {
  return Z === "start" ? Z = rtlRegEx.test(ie) ? "right" : "left" : Z === "end" && (Z = rtlRegEx.test(ie) ? "left" : "right"), TEXT_ALIGN[Z];
}
function createTextChunks(ie, Z, ee) {
  return ee > 0 && ie.push(`
`, ""), ie.push(Z, ""), ie;
}
class Executor {
  /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions
   */
  constructor(Z, ee, ae, ve) {
    this.overlaps = ae, this.pixelRatio = ee, this.resolution = Z, this.alignFill_, this.instructions = ve.instructions, this.coordinates = ve.coordinates, this.coordinateCache_ = {}, this.renderedTransform_ = create$2(), this.hitDetectionInstructions = ve.hitDetectionInstructions, this.pixelCoordinates_ = null, this.viewRotation_ = 0, this.fillStates = ve.fillStates || {}, this.strokeStates = ve.strokeStates || {}, this.textStates = ve.textStates || {}, this.widths_ = {}, this.labels_ = {};
  }
  /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */
  createLabel(Z, ee, ae, ve) {
    const ye = Z + ee + ae + ve;
    if (this.labels_[ye])
      return this.labels_[ye];
    const be = ve ? this.strokeStates[ve] : null, Ye = ae ? this.fillStates[ae] : null, Qe = this.textStates[ee], Je = this.pixelRatio, nt = [
      Qe.scale[0] * Je,
      Qe.scale[1] * Je
    ], st = Array.isArray(Z), ot = Qe.justify ? TEXT_ALIGN[Qe.justify] : horizontalTextAlign(
      Array.isArray(Z) ? Z[0] : Z,
      Qe.textAlign || defaultTextAlign
    ), lt = ve && be.lineWidth ? be.lineWidth : 0, ft = st ? Z : Z.split(`
`).reduce(createTextChunks, []), { width: gt, height: ct, widths: _r, heights: Kr, lineWidths: Xr } = getTextDimensions(
      Qe,
      ft
    ), Jr = gt + lt, ei = [], si = (Jr + 2) * nt[0], ri = (ct + lt) * nt[1], ai = {
      width: si < 0 ? Math.floor(si) : Math.ceil(si),
      height: ri < 0 ? Math.floor(ri) : Math.ceil(ri),
      contextInstructions: ei
    };
    (nt[0] != 1 || nt[1] != 1) && ei.push("scale", nt), ve && (ei.push("strokeStyle", be.strokeStyle), ei.push("lineWidth", lt), ei.push("lineCap", be.lineCap), ei.push("lineJoin", be.lineJoin), ei.push("miterLimit", be.miterLimit), ei.push("setLineDash", [be.lineDash]), ei.push("lineDashOffset", be.lineDashOffset)), ae && ei.push("fillStyle", Ye.fillStyle), ei.push("textBaseline", "middle"), ei.push("textAlign", "center");
    const yi = 0.5 - ot;
    let pi = ot * Jr + yi * lt;
    const di = [], xi = [];
    let Ti = 0, Ai = 0, mi = 0, Si = 0, gi;
    for (let _i = 0, Oi = ft.length; _i < Oi; _i += 2) {
      const hi = ft[_i];
      if (hi === `
`) {
        Ai += Ti, Ti = 0, pi = ot * Jr + yi * lt, ++Si;
        continue;
      }
      const Di = ft[_i + 1] || Qe.font;
      Di !== gi && (ve && di.push("font", Di), ae && xi.push("font", Di), gi = Di), Ti = Math.max(Ti, Kr[mi]);
      const Ri = [
        hi,
        pi + yi * _r[mi] + ot * (_r[mi] - Xr[Si]),
        0.5 * (lt + Ti) + Ai
      ];
      pi += _r[mi], ve && di.push("strokeText", Ri), ae && xi.push("fillText", Ri), ++mi;
    }
    return Array.prototype.push.apply(ei, di), Array.prototype.push.apply(ei, xi), this.labels_[ye] = ai, ai;
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */
  replayTextBackground_(Z, ee, ae, ve, ye, be, Ye) {
    Z.beginPath(), Z.moveTo.apply(Z, ee), Z.lineTo.apply(Z, ae), Z.lineTo.apply(Z, ve), Z.lineTo.apply(Z, ye), Z.lineTo.apply(Z, ee), be && (this.alignFill_ = /** @type {boolean} */
    be[2], this.fill_(Z)), Ye && (this.setStrokeStyle_(
      Z,
      /** @type {Array<*>} */
      Ye
    ), Z.stroke());
  }
  /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */
  calculateImageOrLabelDimensions_(Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt, st, ot, lt, ft, gt, ct) {
    Ye *= ot[0], Qe *= ot[1];
    let _r = ae - Ye, Kr = ve - Qe;
    const Xr = ye + Je > Z ? Z - Je : ye, Jr = be + nt > ee ? ee - nt : be, ei = ft[3] + Xr * ot[0] + ft[1], si = ft[0] + Jr * ot[1] + ft[2], ri = _r - ft[3], ai = Kr - ft[0];
    (gt || st !== 0) && (p1[0] = ri, p4[0] = ri, p1[1] = ai, p2[1] = ai, p2[0] = ri + ei, p3[0] = p2[0], p3[1] = ai + si, p4[1] = p3[1]);
    let yi;
    return st !== 0 ? (yi = compose$1(
      create$2(),
      ae,
      ve,
      1,
      1,
      st,
      -ae,
      -ve
    ), apply(yi, p1), apply(yi, p2), apply(yi, p3), apply(yi, p4), createOrUpdate$2(
      Math.min(p1[0], p2[0], p3[0], p4[0]),
      Math.min(p1[1], p2[1], p3[1], p4[1]),
      Math.max(p1[0], p2[0], p3[0], p4[0]),
      Math.max(p1[1], p2[1], p3[1], p4[1]),
      tmpExtent
    )) : createOrUpdate$2(
      Math.min(ri, ri + ei),
      Math.min(ai, ai + si),
      Math.max(ri, ri + ei),
      Math.max(ai, ai + si),
      tmpExtent
    ), lt && (_r = Math.round(_r), Kr = Math.round(Kr)), {
      drawImageX: _r,
      drawImageY: Kr,
      drawImageW: Xr,
      drawImageH: Jr,
      originX: Je,
      originY: nt,
      declutterBox: {
        minX: tmpExtent[0],
        minY: tmpExtent[1],
        maxX: tmpExtent[2],
        maxY: tmpExtent[3],
        value: ct
      },
      canvasTransform: yi,
      scale: ot
    };
  }
  /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} contextScale Scale of the context.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */
  replayImageOrLabel_(Z, ee, ae, ve, ye, be, Ye) {
    const Qe = !!(be || Ye), Je = ve.declutterBox, nt = Z.canvas, st = Ye ? Ye[2] * ve.scale[0] / 2 : 0;
    return Je.minX - st <= nt.width / ee && Je.maxX + st >= 0 && Je.minY - st <= nt.height / ee && Je.maxY + st >= 0 && (Qe && this.replayTextBackground_(
      Z,
      p1,
      p2,
      p3,
      p4,
      /** @type {Array<*>} */
      be,
      /** @type {Array<*>} */
      Ye
    ), drawImageOrLabel(
      Z,
      ve.canvasTransform,
      ye,
      ae,
      ve.originX,
      ve.originY,
      ve.drawImageW,
      ve.drawImageH,
      ve.drawImageX,
      ve.drawImageY,
      ve.scale
    )), !0;
  }
  /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   */
  fill_(Z) {
    if (this.alignFill_) {
      const ee = apply(this.renderedTransform_, [0, 0]), ae = 512 * this.pixelRatio;
      Z.save(), Z.translate(ee[0] % ae, ee[1] % ae), Z.rotate(this.viewRotation_);
    }
    Z.fill(), this.alignFill_ && Z.restore();
  }
  /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */
  setStrokeStyle_(Z, ee) {
    Z.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */
    ee[1], Z.lineWidth = /** @type {number} */
    ee[2], Z.lineCap = /** @type {CanvasLineCap} */
    ee[3], Z.lineJoin = /** @type {CanvasLineJoin} */
    ee[4], Z.miterLimit = /** @type {number} */
    ee[5], Z.lineDashOffset = /** @type {number} */
    ee[7], Z.setLineDash(
      /** @type {Array<number>} */
      ee[6]
    );
  }
  /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */
  drawLabelWithPointPlacement_(Z, ee, ae, ve) {
    const ye = this.textStates[ee], be = this.createLabel(Z, ee, ve, ae), Ye = this.strokeStates[ae], Qe = this.pixelRatio, Je = horizontalTextAlign(
      Array.isArray(Z) ? Z[0] : Z,
      ye.textAlign || defaultTextAlign
    ), nt = TEXT_ALIGN[ye.textBaseline || defaultTextBaseline], st = Ye && Ye.lineWidth ? Ye.lineWidth : 0, ot = be.width / Qe - 2 * ye.scale[0], lt = Je * ot + 2 * (0.5 - Je) * st, ft = nt * be.height / Qe + 2 * (0.5 - nt) * st;
    return {
      label: be,
      anchorX: lt,
      anchorY: ft
    };
  }
  /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} contextScale Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */
  execute_(Z, ee, ae, ve, ye, be, Ye, Qe) {
    let Je;
    this.pixelCoordinates_ && equals$2(ae, this.renderedTransform_) ? Je = this.pixelCoordinates_ : (this.pixelCoordinates_ || (this.pixelCoordinates_ = []), Je = transform2D(
      this.coordinates,
      0,
      this.coordinates.length,
      2,
      ae,
      this.pixelCoordinates_
    ), setFromArray(this.renderedTransform_, ae));
    let nt = 0;
    const st = ve.length;
    let ot = 0, lt, ft, gt, ct, _r, Kr, Xr, Jr, ei, si, ri, ai, yi = 0, pi = 0, di = null, xi = null;
    const Ti = this.coordinateCache_, Ai = this.viewRotation_, mi = Math.round(Math.atan2(-ae[1], ae[0]) * 1e12) / 1e12, Si = (
      /** @type {import("../../render.js").State} */
      {
        context: Z,
        pixelRatio: this.pixelRatio,
        resolution: this.resolution,
        rotation: Ai
      }
    ), gi = this.instructions != ve || this.overlaps ? 0 : 200;
    let _i, Oi, hi, Di;
    for (; nt < st; ) {
      const Ri = ve[nt];
      switch (
        /** @type {import("./Instruction.js").default} */
        Ri[0]
      ) {
        case Instruction.BEGIN_GEOMETRY:
          _i = /** @type {import("../../Feature.js").FeatureLike} */
          Ri[1], Di = Ri[3], _i.getGeometry() ? Ye !== void 0 && !intersects$1(Ye, Di.getExtent()) ? nt = /** @type {number} */
          Ri[2] + 1 : ++nt : nt = /** @type {number} */
          Ri[2];
          break;
        case Instruction.BEGIN_PATH:
          yi > gi && (this.fill_(Z), yi = 0), pi > gi && (Z.stroke(), pi = 0), !yi && !pi && (Z.beginPath(), ct = NaN, _r = NaN), ++nt;
          break;
        case Instruction.CIRCLE:
          ot = /** @type {number} */
          Ri[1];
          const Hi = Je[ot], qi = Je[ot + 1], us = Je[ot + 2], Yi = Je[ot + 3], is = us - Hi, Ss = Yi - qi, Gs = Math.sqrt(is * is + Ss * Ss);
          Z.moveTo(Hi + Gs, qi), Z.arc(Hi, qi, Gs, 0, 2 * Math.PI, !0), ++nt;
          break;
        case Instruction.CLOSE_PATH:
          Z.closePath(), ++nt;
          break;
        case Instruction.CUSTOM:
          ot = /** @type {number} */
          Ri[1], lt = Ri[2];
          const Vs = (
            /** @type {import("../../geom/SimpleGeometry.js").default} */
            Ri[3]
          ), Ws = Ri[4], ii = Ri.length == 6 ? Ri[5] : void 0;
          Si.geometry = Vs, Si.feature = _i, nt in Ti || (Ti[nt] = []);
          const bi = Ti[nt];
          ii ? ii(Je, ot, lt, 2, bi) : (bi[0] = Je[ot], bi[1] = Je[ot + 1], bi.length = 2), Ws(bi, Si), ++nt;
          break;
        case Instruction.DRAW_IMAGE:
          ot = /** @type {number} */
          Ri[1], lt = /** @type {number} */
          Ri[2], Jr = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */
          Ri[3], ft = /** @type {number} */
          Ri[4], gt = /** @type {number} */
          Ri[5];
          let Gi = (
            /** @type {number} */
            Ri[6]
          );
          const Qi = (
            /** @type {number} */
            Ri[7]
          ), ns = (
            /** @type {number} */
            Ri[8]
          ), Bs = (
            /** @type {number} */
            Ri[9]
          ), ms = (
            /** @type {boolean} */
            Ri[10]
          );
          let Ks = (
            /** @type {number} */
            Ri[11]
          );
          const Js = (
            /** @type {import("../../size.js").Size} */
            Ri[12]
          );
          let Ns = (
            /** @type {number} */
            Ri[13]
          );
          const Ts = (
            /** @type {"declutter"|"obstacle"|"none"|undefined} */
            Ri[14]
          ), lo = (
            /** @type {import("../canvas.js").DeclutterImageWithText} */
            Ri[15]
          );
          if (!Jr && Ri.length >= 20) {
            ei = /** @type {string} */
            Ri[19], si = /** @type {string} */
            Ri[20], ri = /** @type {string} */
            Ri[21], ai = /** @type {string} */
            Ri[22];
            const Us = this.drawLabelWithPointPlacement_(
              ei,
              si,
              ri,
              ai
            );
            Jr = Us.label, Ri[3] = Jr;
            const To = (
              /** @type {number} */
              Ri[23]
            );
            ft = (Us.anchorX - To) * this.pixelRatio, Ri[4] = ft;
            const Ms = (
              /** @type {number} */
              Ri[24]
            );
            gt = (Us.anchorY - Ms) * this.pixelRatio, Ri[5] = gt, Gi = Jr.height, Ri[6] = Gi, Ns = Jr.width, Ri[13] = Ns;
          }
          let Fs;
          Ri.length > 25 && (Fs = /** @type {number} */
          Ri[25]);
          let xo, mo, Wo;
          Ri.length > 17 ? (xo = /** @type {Array<number>} */
          Ri[16], mo = /** @type {boolean} */
          Ri[17], Wo = /** @type {boolean} */
          Ri[18]) : (xo = defaultPadding, mo = !1, Wo = !1), ms && mi ? Ks += Ai : !ms && !mi && (Ks -= Ai);
          let Ta = 0;
          for (; ot < lt; ot += 2) {
            if (Fs && Fs[Ta++] < Ns / this.pixelRatio)
              continue;
            const Us = this.calculateImageOrLabelDimensions_(
              Jr.width,
              Jr.height,
              Je[ot],
              Je[ot + 1],
              Ns,
              Gi,
              ft,
              gt,
              ns,
              Bs,
              Ks,
              Js,
              ye,
              xo,
              mo || Wo,
              _i
            ), To = [
              Z,
              ee,
              Jr,
              Us,
              Qi,
              mo ? (
                /** @type {Array<*>} */
                di
              ) : null,
              Wo ? (
                /** @type {Array<*>} */
                xi
              ) : null
            ];
            if (Qe) {
              if (Ts === "none")
                continue;
              if (Ts === "obstacle") {
                Qe.insert(Us.declutterBox);
                continue;
              } else {
                let Ms, da;
                if (lo) {
                  const qo = lt - ot;
                  if (!lo[qo]) {
                    lo[qo] = To;
                    continue;
                  }
                  if (Ms = lo[qo], delete lo[qo], da = getDeclutterBox(Ms), Qe.collides(da))
                    continue;
                }
                if (Qe.collides(Us.declutterBox))
                  continue;
                Ms && (Qe.insert(da), this.replayImageOrLabel_.apply(this, Ms)), Qe.insert(Us.declutterBox);
              }
            }
            this.replayImageOrLabel_.apply(this, To);
          }
          ++nt;
          break;
        case Instruction.DRAW_CHARS:
          const Aa = (
            /** @type {number} */
            Ri[1]
          ), hs = (
            /** @type {number} */
            Ri[2]
          ), Os = (
            /** @type {number} */
            Ri[3]
          ), ho = (
            /** @type {number} */
            Ri[4]
          );
          ai = /** @type {string} */
          Ri[5];
          const Ao = (
            /** @type {number} */
            Ri[6]
          ), ci = (
            /** @type {number} */
            Ri[7]
          ), li = (
            /** @type {number} */
            Ri[8]
          );
          ri = /** @type {string} */
          Ri[9];
          const Ci = (
            /** @type {number} */
            Ri[10]
          );
          ei = /** @type {string} */
          Ri[11], si = /** @type {string} */
          Ri[12];
          const Li = [
            /** @type {number} */
            Ri[13],
            /** @type {number} */
            Ri[13]
          ], es = this.textStates[si], Es = es.font, ls = [
            es.scale[0] * ci,
            es.scale[1] * ci
          ];
          let ss;
          Es in this.widths_ ? ss = this.widths_[Es] : (ss = {}, this.widths_[Es] = ss);
          const Hs = lineStringLength(Je, Aa, hs, 2), eo = Math.abs(ls[0]) * measureAndCacheTextWidth(Es, ei, ss);
          if (ho || eo <= Hs) {
            const Us = this.textStates[si].textAlign, To = (Hs - eo) * horizontalTextAlign(ei, Us), Ms = drawTextOnPath(
              Je,
              Aa,
              hs,
              2,
              ei,
              To,
              Ao,
              Math.abs(ls[0]),
              measureAndCacheTextWidth,
              Es,
              ss,
              mi ? 0 : this.viewRotation_
            );
            e:
              if (Ms) {
                const da = [];
                let qo, ba, ll, Yo, va;
                if (ri)
                  for (qo = 0, ba = Ms.length; qo < ba; ++qo) {
                    va = Ms[qo], ll = /** @type {string} */
                    va[4], Yo = this.createLabel(ll, si, "", ri), ft = /** @type {number} */
                    va[2] + (ls[0] < 0 ? -Ci : Ci), gt = Os * Yo.height + (0.5 - Os) * 2 * Ci * ls[1] / ls[0] - li;
                    const ia = this.calculateImageOrLabelDimensions_(
                      Yo.width,
                      Yo.height,
                      va[0],
                      va[1],
                      Yo.width,
                      Yo.height,
                      ft,
                      gt,
                      0,
                      0,
                      va[3],
                      Li,
                      !1,
                      defaultPadding,
                      !1,
                      _i
                    );
                    if (Qe && Qe.collides(ia.declutterBox))
                      break e;
                    da.push([
                      Z,
                      ee,
                      Yo,
                      ia,
                      1,
                      null,
                      null
                    ]);
                  }
                if (ai)
                  for (qo = 0, ba = Ms.length; qo < ba; ++qo) {
                    va = Ms[qo], ll = /** @type {string} */
                    va[4], Yo = this.createLabel(ll, si, ai, ""), ft = /** @type {number} */
                    va[2], gt = Os * Yo.height - li;
                    const ia = this.calculateImageOrLabelDimensions_(
                      Yo.width,
                      Yo.height,
                      va[0],
                      va[1],
                      Yo.width,
                      Yo.height,
                      ft,
                      gt,
                      0,
                      0,
                      va[3],
                      Li,
                      !1,
                      defaultPadding,
                      !1,
                      _i
                    );
                    if (Qe && Qe.collides(ia.declutterBox))
                      break e;
                    da.push([
                      Z,
                      ee,
                      Yo,
                      ia,
                      1,
                      null,
                      null
                    ]);
                  }
                Qe && Qe.load(da.map(getDeclutterBox));
                for (let ia = 0, Ul = da.length; ia < Ul; ++ia)
                  this.replayImageOrLabel_.apply(this, da[ia]);
              }
          }
          ++nt;
          break;
        case Instruction.END_GEOMETRY:
          if (be !== void 0) {
            _i = /** @type {import("../../Feature.js").FeatureLike} */
            Ri[1];
            const Us = be(_i, Di);
            if (Us)
              return Us;
          }
          ++nt;
          break;
        case Instruction.FILL:
          gi ? yi++ : this.fill_(Z), ++nt;
          break;
        case Instruction.MOVE_TO_LINE_TO:
          for (ot = /** @type {number} */
          Ri[1], lt = /** @type {number} */
          Ri[2], Oi = Je[ot], hi = Je[ot + 1], Kr = Oi + 0.5 | 0, Xr = hi + 0.5 | 0, (Kr !== ct || Xr !== _r) && (Z.moveTo(Oi, hi), ct = Kr, _r = Xr), ot += 2; ot < lt; ot += 2)
            Oi = Je[ot], hi = Je[ot + 1], Kr = Oi + 0.5 | 0, Xr = hi + 0.5 | 0, (ot == lt - 2 || Kr !== ct || Xr !== _r) && (Z.lineTo(Oi, hi), ct = Kr, _r = Xr);
          ++nt;
          break;
        case Instruction.SET_FILL_STYLE:
          di = Ri, this.alignFill_ = Ri[2], yi && (this.fill_(Z), yi = 0, pi && (Z.stroke(), pi = 0)), Z.fillStyle = /** @type {import("../../colorlike.js").ColorLike} */
          Ri[1], ++nt;
          break;
        case Instruction.SET_STROKE_STYLE:
          xi = Ri, pi && (Z.stroke(), pi = 0), this.setStrokeStyle_(
            Z,
            /** @type {Array<*>} */
            Ri
          ), ++nt;
          break;
        case Instruction.STROKE:
          gi ? pi++ : Z.stroke(), ++nt;
          break;
        default:
          ++nt;
          break;
      }
    }
    yi && this.fill_(Z), pi && Z.stroke();
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} contextScale Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   */
  execute(Z, ee, ae, ve, ye, be) {
    this.viewRotation_ = ve, this.execute_(
      Z,
      ee,
      ae,
      this.instructions,
      ye,
      void 0,
      void 0,
      be
    );
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */
  executeHitDetection(Z, ee, ae, ve, ye) {
    return this.viewRotation_ = ae, this.execute_(
      Z,
      1,
      ee,
      this.hitDetectionInstructions,
      !0,
      ve,
      ye
    );
  }
}
const ORDER = ["Polygon", "Circle", "LineString", "Image", "Text", "Default"];
class ExecutorGroup {
  /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   */
  constructor(Z, ee, ae, ve, ye, be) {
    this.maxExtent_ = Z, this.overlaps_ = ve, this.pixelRatio_ = ae, this.resolution_ = ee, this.renderBuffer_ = be, this.executorsByZIndex_ = {}, this.hitDetectionContext_ = null, this.hitDetectionTransform_ = create$2(), this.createExecutors_(ye);
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */
  clip(Z, ee) {
    const ae = this.getClipCoords(ee);
    Z.beginPath(), Z.moveTo(ae[0], ae[1]), Z.lineTo(ae[2], ae[3]), Z.lineTo(ae[4], ae[5]), Z.lineTo(ae[6], ae[7]), Z.clip();
  }
  /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   */
  createExecutors_(Z) {
    for (const ee in Z) {
      let ae = this.executorsByZIndex_[ee];
      ae === void 0 && (ae = {}, this.executorsByZIndex_[ee] = ae);
      const ve = Z[ee];
      for (const ye in ve) {
        const be = ve[ye];
        ae[ye] = new Executor(
          this.resolution_,
          this.pixelRatio_,
          this.overlaps_,
          be
        );
      }
    }
  }
  /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */
  hasExecutors(Z) {
    for (const ee in this.executorsByZIndex_) {
      const ae = this.executorsByZIndex_[ee];
      for (let ve = 0, ye = Z.length; ve < ye; ++ve)
        if (Z[ve] in ae)
          return !0;
    }
    return !1;
  }
  /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */
  forEachFeatureAtCoordinate(Z, ee, ae, ve, ye, be) {
    ve = Math.round(ve);
    const Ye = ve * 2 + 1, Qe = compose$1(
      this.hitDetectionTransform_,
      ve + 0.5,
      ve + 0.5,
      1 / ee,
      -1 / ee,
      -ae,
      -Z[0],
      -Z[1]
    ), Je = !this.hitDetectionContext_;
    Je && (this.hitDetectionContext_ = createCanvasContext2D(
      Ye,
      Ye,
      void 0,
      { willReadFrequently: !0 }
    ));
    const nt = this.hitDetectionContext_;
    nt.canvas.width !== Ye || nt.canvas.height !== Ye ? (nt.canvas.width = Ye, nt.canvas.height = Ye) : Je || nt.clearRect(0, 0, Ye, Ye);
    let st;
    this.renderBuffer_ !== void 0 && (st = createEmpty(), extendCoordinate(st, Z), buffer$1(
      st,
      ee * (this.renderBuffer_ + ve),
      st
    ));
    const ot = getPixelIndexArray(ve);
    let lt;
    function ft(ei, si) {
      const ri = nt.getImageData(
        0,
        0,
        Ye,
        Ye
      ).data;
      for (let ai = 0, yi = ot.length; ai < yi; ai++)
        if (ri[ot[ai]] > 0) {
          if (!be || lt !== "Image" && lt !== "Text" || be.includes(ei)) {
            const pi = (ot[ai] - 3) / 4, di = ve - pi % Ye, xi = ve - (pi / Ye | 0), Ti = ye(ei, si, di * di + xi * xi);
            if (Ti)
              return Ti;
          }
          nt.clearRect(0, 0, Ye, Ye);
          break;
        }
    }
    const gt = Object.keys(this.executorsByZIndex_).map(Number);
    gt.sort(ascending);
    let ct, _r, Kr, Xr, Jr;
    for (ct = gt.length - 1; ct >= 0; --ct) {
      const ei = gt[ct].toString();
      for (Kr = this.executorsByZIndex_[ei], _r = ORDER.length - 1; _r >= 0; --_r)
        if (lt = ORDER[_r], Xr = Kr[lt], Xr !== void 0 && (Jr = Xr.executeHitDetection(
          nt,
          Qe,
          ae,
          ft,
          st
        ), Jr))
          return Jr;
    }
  }
  /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */
  getClipCoords(Z) {
    const ee = this.maxExtent_;
    if (!ee)
      return null;
    const ae = ee[0], ve = ee[1], ye = ee[2], be = ee[3], Ye = [ae, ve, ae, be, ye, be, ye, ve];
    return transform2D(Ye, 0, 8, 2, Z, Ye), Ye;
  }
  /**
   * @return {boolean} Is empty.
   */
  isEmpty() {
    return isEmpty$1(this.executorsByZIndex_);
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} contextScale Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ORDER}
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   */
  execute(Z, ee, ae, ve, ye, be, Ye) {
    const Qe = Object.keys(this.executorsByZIndex_).map(Number);
    Qe.sort(ascending), this.maxExtent_ && (Z.save(), this.clip(Z, ae)), be = be || ORDER;
    let Je, nt, st, ot, lt, ft;
    for (Ye && Qe.reverse(), Je = 0, nt = Qe.length; Je < nt; ++Je) {
      const gt = Qe[Je].toString();
      for (lt = this.executorsByZIndex_[gt], st = 0, ot = be.length; st < ot; ++st) {
        const ct = be[st];
        ft = lt[ct], ft !== void 0 && ft.execute(
          Z,
          ee,
          ae,
          ve,
          ye,
          Ye
        );
      }
    }
    this.maxExtent_ && Z.restore();
  }
}
const circlePixelIndexArrayCache = {};
function getPixelIndexArray(ie) {
  if (circlePixelIndexArrayCache[ie] !== void 0)
    return circlePixelIndexArrayCache[ie];
  const Z = ie * 2 + 1, ee = ie * ie, ae = new Array(ee + 1);
  for (let ye = 0; ye <= ie; ++ye)
    for (let be = 0; be <= ie; ++be) {
      const Ye = ye * ye + be * be;
      if (Ye > ee)
        break;
      let Qe = ae[Ye];
      Qe || (Qe = [], ae[Ye] = Qe), Qe.push(((ie + ye) * Z + (ie + be)) * 4 + 3), ye > 0 && Qe.push(((ie - ye) * Z + (ie + be)) * 4 + 3), be > 0 && (Qe.push(((ie + ye) * Z + (ie - be)) * 4 + 3), ye > 0 && Qe.push(((ie - ye) * Z + (ie - be)) * 4 + 3));
    }
  const ve = [];
  for (let ye = 0, be = ae.length; ye < be; ++ye)
    ae[ye] && ve.push(...ae[ye]);
  return circlePixelIndexArrayCache[ie] = ve, ve;
}
class CanvasImmediateRenderer extends VectorContext {
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */
  constructor(Z, ee, ae, ve, ye, be, Ye) {
    super(), this.context_ = Z, this.pixelRatio_ = ee, this.extent_ = ae, this.transform_ = ve, this.transformRotation_ = ve ? toFixed(Math.atan2(ve[1], ve[0]), 10) : 0, this.viewRotation_ = ye, this.squaredTolerance_ = be, this.userTransform_ = Ye, this.contextFillState_ = null, this.contextStrokeState_ = null, this.contextTextState_ = null, this.fillState_ = null, this.strokeState_ = null, this.image_ = null, this.imageAnchorX_ = 0, this.imageAnchorY_ = 0, this.imageHeight_ = 0, this.imageOpacity_ = 0, this.imageOriginX_ = 0, this.imageOriginY_ = 0, this.imageRotateWithView_ = !1, this.imageRotation_ = 0, this.imageScale_ = [0, 0], this.imageWidth_ = 0, this.text_ = "", this.textOffsetX_ = 0, this.textOffsetY_ = 0, this.textRotateWithView_ = !1, this.textRotation_ = 0, this.textScale_ = [0, 0], this.textFillState_ = null, this.textStrokeState_ = null, this.textState_ = null, this.pixelCoordinates_ = [], this.tmpLocalTransform_ = create$2();
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */
  drawImages_(Z, ee, ae, ve) {
    if (!this.image_)
      return;
    const ye = transform2D(
      Z,
      ee,
      ae,
      ve,
      this.transform_,
      this.pixelCoordinates_
    ), be = this.context_, Ye = this.tmpLocalTransform_, Qe = be.globalAlpha;
    this.imageOpacity_ != 1 && (be.globalAlpha = Qe * this.imageOpacity_);
    let Je = this.imageRotation_;
    this.transformRotation_ === 0 && (Je -= this.viewRotation_), this.imageRotateWithView_ && (Je += this.viewRotation_);
    for (let nt = 0, st = ye.length; nt < st; nt += 2) {
      const ot = ye[nt] - this.imageAnchorX_, lt = ye[nt + 1] - this.imageAnchorY_;
      if (Je !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
        const ft = ot + this.imageAnchorX_, gt = lt + this.imageAnchorY_;
        compose$1(
          Ye,
          ft,
          gt,
          1,
          1,
          Je,
          -ft,
          -gt
        ), be.save(), be.transform.apply(be, Ye), be.translate(ft, gt), be.scale(this.imageScale_[0], this.imageScale_[1]), be.drawImage(
          this.image_,
          this.imageOriginX_,
          this.imageOriginY_,
          this.imageWidth_,
          this.imageHeight_,
          -this.imageAnchorX_,
          -this.imageAnchorY_,
          this.imageWidth_,
          this.imageHeight_
        ), be.restore();
      } else
        be.drawImage(
          this.image_,
          this.imageOriginX_,
          this.imageOriginY_,
          this.imageWidth_,
          this.imageHeight_,
          ot,
          lt,
          this.imageWidth_,
          this.imageHeight_
        );
    }
    this.imageOpacity_ != 1 && (be.globalAlpha = Qe);
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */
  drawText_(Z, ee, ae, ve) {
    if (!this.textState_ || this.text_ === "")
      return;
    this.textFillState_ && this.setContextFillState_(this.textFillState_), this.textStrokeState_ && this.setContextStrokeState_(this.textStrokeState_), this.setContextTextState_(this.textState_);
    const ye = transform2D(
      Z,
      ee,
      ae,
      ve,
      this.transform_,
      this.pixelCoordinates_
    ), be = this.context_;
    let Ye = this.textRotation_;
    for (this.transformRotation_ === 0 && (Ye -= this.viewRotation_), this.textRotateWithView_ && (Ye += this.viewRotation_); ee < ae; ee += ve) {
      const Qe = ye[ee] + this.textOffsetX_, Je = ye[ee + 1] + this.textOffsetY_;
      Ye !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1 ? (be.save(), be.translate(Qe - this.textOffsetX_, Je - this.textOffsetY_), be.rotate(Ye), be.translate(this.textOffsetX_, this.textOffsetY_), be.scale(this.textScale_[0], this.textScale_[1]), this.textStrokeState_ && be.strokeText(this.text_, 0, 0), this.textFillState_ && be.fillText(this.text_, 0, 0), be.restore()) : (this.textStrokeState_ && be.strokeText(this.text_, Qe, Je), this.textFillState_ && be.fillText(this.text_, Qe, Je));
    }
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */
  moveToLineTo_(Z, ee, ae, ve, ye) {
    const be = this.context_, Ye = transform2D(
      Z,
      ee,
      ae,
      ve,
      this.transform_,
      this.pixelCoordinates_
    );
    be.moveTo(Ye[0], Ye[1]);
    let Qe = Ye.length;
    ye && (Qe -= 2);
    for (let Je = 2; Je < Qe; Je += 2)
      be.lineTo(Ye[Je], Ye[Je + 1]);
    return ye && be.closePath(), ae;
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */
  drawRings_(Z, ee, ae, ve) {
    for (let ye = 0, be = ae.length; ye < be; ++ye)
      ee = this.moveToLineTo_(
        Z,
        ee,
        ae[ye],
        ve,
        !0
      );
    return ee;
  }
  /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   */
  drawCircle(Z) {
    if (this.squaredTolerance_ && (Z = /** @type {import("../../geom/Circle.js").default} */
    Z.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    )), !!intersects$1(this.extent_, Z.getExtent())) {
      if (this.fillState_ || this.strokeState_) {
        this.fillState_ && this.setContextFillState_(this.fillState_), this.strokeState_ && this.setContextStrokeState_(this.strokeState_);
        const ee = transformGeom2D(
          Z,
          this.transform_,
          this.pixelCoordinates_
        ), ae = ee[2] - ee[0], ve = ee[3] - ee[1], ye = Math.sqrt(ae * ae + ve * ve), be = this.context_;
        be.beginPath(), be.arc(
          ee[0],
          ee[1],
          ye,
          0,
          2 * Math.PI
        ), this.fillState_ && be.fill(), this.strokeState_ && be.stroke();
      }
      this.text_ !== "" && this.drawText_(Z.getCenter(), 0, 2, 2);
    }
  }
  /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   */
  setStyle(Z) {
    this.setFillStrokeStyle(Z.getFill(), Z.getStroke()), this.setImageStyle(Z.getImage()), this.setTextStyle(Z.getText());
  }
  /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */
  setTransform(Z) {
    this.transform_ = Z;
  }
  /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   */
  drawGeometry(Z) {
    switch (Z.getType()) {
      case "Point":
        this.drawPoint(
          /** @type {import("../../geom/Point.js").default} */
          Z
        );
        break;
      case "LineString":
        this.drawLineString(
          /** @type {import("../../geom/LineString.js").default} */
          Z
        );
        break;
      case "Polygon":
        this.drawPolygon(
          /** @type {import("../../geom/Polygon.js").default} */
          Z
        );
        break;
      case "MultiPoint":
        this.drawMultiPoint(
          /** @type {import("../../geom/MultiPoint.js").default} */
          Z
        );
        break;
      case "MultiLineString":
        this.drawMultiLineString(
          /** @type {import("../../geom/MultiLineString.js").default} */
          Z
        );
        break;
      case "MultiPolygon":
        this.drawMultiPolygon(
          /** @type {import("../../geom/MultiPolygon.js").default} */
          Z
        );
        break;
      case "GeometryCollection":
        this.drawGeometryCollection(
          /** @type {import("../../geom/GeometryCollection.js").default} */
          Z
        );
        break;
      case "Circle":
        this.drawCircle(
          /** @type {import("../../geom/Circle.js").default} */
          Z
        );
        break;
    }
  }
  /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   */
  drawFeature(Z, ee) {
    const ae = ee.getGeometryFunction()(Z);
    ae && (this.setStyle(ee), this.drawGeometry(ae));
  }
  /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   */
  drawGeometryCollection(Z) {
    const ee = Z.getGeometriesArray();
    for (let ae = 0, ve = ee.length; ae < ve; ++ae)
      this.drawGeometry(ee[ae]);
  }
  /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   */
  drawPoint(Z) {
    this.squaredTolerance_ && (Z = /** @type {import("../../geom/Point.js").default} */
    Z.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    ));
    const ee = Z.getFlatCoordinates(), ae = Z.getStride();
    this.image_ && this.drawImages_(ee, 0, ee.length, ae), this.text_ !== "" && this.drawText_(ee, 0, ee.length, ae);
  }
  /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   */
  drawMultiPoint(Z) {
    this.squaredTolerance_ && (Z = /** @type {import("../../geom/MultiPoint.js").default} */
    Z.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    ));
    const ee = Z.getFlatCoordinates(), ae = Z.getStride();
    this.image_ && this.drawImages_(ee, 0, ee.length, ae), this.text_ !== "" && this.drawText_(ee, 0, ee.length, ae);
  }
  /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   */
  drawLineString(Z) {
    if (this.squaredTolerance_ && (Z = /** @type {import("../../geom/LineString.js").default} */
    Z.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    )), !!intersects$1(this.extent_, Z.getExtent())) {
      if (this.strokeState_) {
        this.setContextStrokeState_(this.strokeState_);
        const ee = this.context_, ae = Z.getFlatCoordinates();
        ee.beginPath(), this.moveToLineTo_(
          ae,
          0,
          ae.length,
          Z.getStride(),
          !1
        ), ee.stroke();
      }
      if (this.text_ !== "") {
        const ee = Z.getFlatMidpoint();
        this.drawText_(ee, 0, 2, 2);
      }
    }
  }
  /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   */
  drawMultiLineString(Z) {
    this.squaredTolerance_ && (Z = /** @type {import("../../geom/MultiLineString.js").default} */
    Z.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    ));
    const ee = Z.getExtent();
    if (intersects$1(this.extent_, ee)) {
      if (this.strokeState_) {
        this.setContextStrokeState_(this.strokeState_);
        const ae = this.context_, ve = Z.getFlatCoordinates();
        let ye = 0;
        const be = (
          /** @type {Array<number>} */
          Z.getEnds()
        ), Ye = Z.getStride();
        ae.beginPath();
        for (let Qe = 0, Je = be.length; Qe < Je; ++Qe)
          ye = this.moveToLineTo_(
            ve,
            ye,
            be[Qe],
            Ye,
            !1
          );
        ae.stroke();
      }
      if (this.text_ !== "") {
        const ae = Z.getFlatMidpoints();
        this.drawText_(ae, 0, ae.length, 2);
      }
    }
  }
  /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   */
  drawPolygon(Z) {
    if (this.squaredTolerance_ && (Z = /** @type {import("../../geom/Polygon.js").default} */
    Z.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    )), !!intersects$1(this.extent_, Z.getExtent())) {
      if (this.strokeState_ || this.fillState_) {
        this.fillState_ && this.setContextFillState_(this.fillState_), this.strokeState_ && this.setContextStrokeState_(this.strokeState_);
        const ee = this.context_;
        ee.beginPath(), this.drawRings_(
          Z.getOrientedFlatCoordinates(),
          0,
          /** @type {Array<number>} */
          Z.getEnds(),
          Z.getStride()
        ), this.fillState_ && ee.fill(), this.strokeState_ && ee.stroke();
      }
      if (this.text_ !== "") {
        const ee = Z.getFlatInteriorPoint();
        this.drawText_(ee, 0, 2, 2);
      }
    }
  }
  /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   */
  drawMultiPolygon(Z) {
    if (this.squaredTolerance_ && (Z = /** @type {import("../../geom/MultiPolygon.js").default} */
    Z.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    )), !!intersects$1(this.extent_, Z.getExtent())) {
      if (this.strokeState_ || this.fillState_) {
        this.fillState_ && this.setContextFillState_(this.fillState_), this.strokeState_ && this.setContextStrokeState_(this.strokeState_);
        const ee = this.context_, ae = Z.getOrientedFlatCoordinates();
        let ve = 0;
        const ye = Z.getEndss(), be = Z.getStride();
        ee.beginPath();
        for (let Ye = 0, Qe = ye.length; Ye < Qe; ++Ye) {
          const Je = ye[Ye];
          ve = this.drawRings_(ae, ve, Je, be);
        }
        this.fillState_ && ee.fill(), this.strokeState_ && ee.stroke();
      }
      if (this.text_ !== "") {
        const ee = Z.getFlatInteriorPoints();
        this.drawText_(ee, 0, ee.length, 2);
      }
    }
  }
  /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */
  setContextFillState_(Z) {
    const ee = this.context_, ae = this.contextFillState_;
    ae ? ae.fillStyle != Z.fillStyle && (ae.fillStyle = Z.fillStyle, ee.fillStyle = Z.fillStyle) : (ee.fillStyle = Z.fillStyle, this.contextFillState_ = {
      fillStyle: Z.fillStyle
    });
  }
  /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */
  setContextStrokeState_(Z) {
    const ee = this.context_, ae = this.contextStrokeState_;
    ae ? (ae.lineCap != Z.lineCap && (ae.lineCap = Z.lineCap, ee.lineCap = Z.lineCap), equals$2(ae.lineDash, Z.lineDash) || ee.setLineDash(
      ae.lineDash = Z.lineDash
    ), ae.lineDashOffset != Z.lineDashOffset && (ae.lineDashOffset = Z.lineDashOffset, ee.lineDashOffset = Z.lineDashOffset), ae.lineJoin != Z.lineJoin && (ae.lineJoin = Z.lineJoin, ee.lineJoin = Z.lineJoin), ae.lineWidth != Z.lineWidth && (ae.lineWidth = Z.lineWidth, ee.lineWidth = Z.lineWidth), ae.miterLimit != Z.miterLimit && (ae.miterLimit = Z.miterLimit, ee.miterLimit = Z.miterLimit), ae.strokeStyle != Z.strokeStyle && (ae.strokeStyle = Z.strokeStyle, ee.strokeStyle = Z.strokeStyle)) : (ee.lineCap = Z.lineCap, ee.setLineDash(Z.lineDash), ee.lineDashOffset = Z.lineDashOffset, ee.lineJoin = Z.lineJoin, ee.lineWidth = Z.lineWidth, ee.miterLimit = Z.miterLimit, ee.strokeStyle = Z.strokeStyle, this.contextStrokeState_ = {
      lineCap: Z.lineCap,
      lineDash: Z.lineDash,
      lineDashOffset: Z.lineDashOffset,
      lineJoin: Z.lineJoin,
      lineWidth: Z.lineWidth,
      miterLimit: Z.miterLimit,
      strokeStyle: Z.strokeStyle
    });
  }
  /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */
  setContextTextState_(Z) {
    const ee = this.context_, ae = this.contextTextState_, ve = Z.textAlign ? Z.textAlign : defaultTextAlign;
    ae ? (ae.font != Z.font && (ae.font = Z.font, ee.font = Z.font), ae.textAlign != ve && (ae.textAlign = ve, ee.textAlign = ve), ae.textBaseline != Z.textBaseline && (ae.textBaseline = Z.textBaseline, ee.textBaseline = Z.textBaseline)) : (ee.font = Z.font, ee.textAlign = ve, ee.textBaseline = Z.textBaseline, this.contextTextState_ = {
      font: Z.font,
      textAlign: ve,
      textBaseline: Z.textBaseline
    });
  }
  /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   */
  setFillStrokeStyle(Z, ee) {
    if (!Z)
      this.fillState_ = null;
    else {
      const ae = Z.getColor();
      this.fillState_ = {
        fillStyle: asColorLike(
          ae || defaultFillStyle
        )
      };
    }
    if (!ee)
      this.strokeState_ = null;
    else {
      const ae = ee.getColor(), ve = ee.getLineCap(), ye = ee.getLineDash(), be = ee.getLineDashOffset(), Ye = ee.getLineJoin(), Qe = ee.getWidth(), Je = ee.getMiterLimit(), nt = ye || defaultLineDash;
      this.strokeState_ = {
        lineCap: ve !== void 0 ? ve : defaultLineCap,
        lineDash: this.pixelRatio_ === 1 ? nt : nt.map((st) => st * this.pixelRatio_),
        lineDashOffset: (be || defaultLineDashOffset) * this.pixelRatio_,
        lineJoin: Ye !== void 0 ? Ye : defaultLineJoin,
        lineWidth: (Qe !== void 0 ? Qe : defaultLineWidth) * this.pixelRatio_,
        miterLimit: Je !== void 0 ? Je : defaultMiterLimit,
        strokeStyle: asColorLike(
          ae || defaultStrokeStyle
        )
      };
    }
  }
  /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   */
  setImageStyle(Z) {
    let ee;
    if (!Z || !(ee = Z.getSize())) {
      this.image_ = null;
      return;
    }
    const ae = Z.getPixelRatio(this.pixelRatio_), ve = Z.getAnchor(), ye = Z.getOrigin();
    this.image_ = Z.getImage(this.pixelRatio_), this.imageAnchorX_ = ve[0] * ae, this.imageAnchorY_ = ve[1] * ae, this.imageHeight_ = ee[1] * ae, this.imageOpacity_ = Z.getOpacity(), this.imageOriginX_ = ye[0], this.imageOriginY_ = ye[1], this.imageRotateWithView_ = Z.getRotateWithView(), this.imageRotation_ = Z.getRotation();
    const be = Z.getScaleArray();
    this.imageScale_ = [
      be[0] * this.pixelRatio_ / ae,
      be[1] * this.pixelRatio_ / ae
    ], this.imageWidth_ = ee[0] * ae;
  }
  /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   */
  setTextStyle(Z) {
    if (!Z)
      this.text_ = "";
    else {
      const ee = Z.getFill();
      if (!ee)
        this.textFillState_ = null;
      else {
        const lt = ee.getColor();
        this.textFillState_ = {
          fillStyle: asColorLike(
            lt || defaultFillStyle
          )
        };
      }
      const ae = Z.getStroke();
      if (!ae)
        this.textStrokeState_ = null;
      else {
        const lt = ae.getColor(), ft = ae.getLineCap(), gt = ae.getLineDash(), ct = ae.getLineDashOffset(), _r = ae.getLineJoin(), Kr = ae.getWidth(), Xr = ae.getMiterLimit();
        this.textStrokeState_ = {
          lineCap: ft !== void 0 ? ft : defaultLineCap,
          lineDash: gt || defaultLineDash,
          lineDashOffset: ct || defaultLineDashOffset,
          lineJoin: _r !== void 0 ? _r : defaultLineJoin,
          lineWidth: Kr !== void 0 ? Kr : defaultLineWidth,
          miterLimit: Xr !== void 0 ? Xr : defaultMiterLimit,
          strokeStyle: asColorLike(
            lt || defaultStrokeStyle
          )
        };
      }
      const ve = Z.getFont(), ye = Z.getOffsetX(), be = Z.getOffsetY(), Ye = Z.getRotateWithView(), Qe = Z.getRotation(), Je = Z.getScaleArray(), nt = Z.getText(), st = Z.getTextAlign(), ot = Z.getTextBaseline();
      this.textState_ = {
        font: ve !== void 0 ? ve : defaultFont,
        textAlign: st !== void 0 ? st : defaultTextAlign,
        textBaseline: ot !== void 0 ? ot : defaultTextBaseline
      }, this.text_ = nt !== void 0 ? Array.isArray(nt) ? nt.reduce((lt, ft, gt) => lt += gt % 2 ? " " : ft, "") : nt : "", this.textOffsetX_ = ye !== void 0 ? this.pixelRatio_ * ye : 0, this.textOffsetY_ = be !== void 0 ? this.pixelRatio_ * be : 0, this.textRotateWithView_ = Ye !== void 0 ? Ye : !1, this.textRotation_ = Qe !== void 0 ? Qe : 0, this.textScale_ = [
        this.pixelRatio_ * Je[0],
        this.pixelRatio_ * Je[1]
      ];
    }
  }
}
const HIT_DETECT_RESOLUTION = 0.5;
function createHitDetectionImageData(ie, Z, ee, ae, ve, ye, be) {
  const Ye = ie[0] * HIT_DETECT_RESOLUTION, Qe = ie[1] * HIT_DETECT_RESOLUTION, Je = createCanvasContext2D(Ye, Qe);
  Je.imageSmoothingEnabled = !1;
  const nt = Je.canvas, st = new CanvasImmediateRenderer(
    Je,
    HIT_DETECT_RESOLUTION,
    ve,
    null,
    be
  ), ot = ee.length, lt = Math.floor((256 * 256 * 256 - 1) / ot), ft = {};
  for (let ct = 1; ct <= ot; ++ct) {
    const _r = ee[ct - 1], Kr = _r.getStyleFunction() || ae;
    if (!Kr)
      continue;
    let Xr = Kr(_r, ye);
    if (!Xr)
      continue;
    Array.isArray(Xr) || (Xr = [Xr]);
    const ei = (ct * lt).toString(16).padStart(7, "#00000");
    for (let si = 0, ri = Xr.length; si < ri; ++si) {
      const ai = Xr[si], yi = ai.getGeometryFunction()(_r);
      if (!yi || !intersects$1(ve, yi.getExtent()))
        continue;
      const pi = ai.clone(), di = pi.getFill();
      di && di.setColor(ei);
      const xi = pi.getStroke();
      xi && (xi.setColor(ei), xi.setLineDash(null)), pi.setText(void 0);
      const Ti = ai.getImage();
      if (Ti) {
        const gi = Ti.getImageSize();
        if (!gi)
          continue;
        const _i = createCanvasContext2D(
          gi[0],
          gi[1],
          void 0,
          { alpha: !1 }
        ), Oi = _i.canvas;
        _i.fillStyle = ei, _i.fillRect(0, 0, Oi.width, Oi.height), pi.setImage(
          new Icon({
            img: Oi,
            anchor: Ti.getAnchor(),
            anchorXUnits: "pixels",
            anchorYUnits: "pixels",
            offset: Ti.getOrigin(),
            opacity: 1,
            size: Ti.getSize(),
            scale: Ti.getScale(),
            rotation: Ti.getRotation(),
            rotateWithView: Ti.getRotateWithView()
          })
        );
      }
      const Ai = pi.getZIndex() || 0;
      let mi = ft[Ai];
      mi || (mi = {}, ft[Ai] = mi, mi.Polygon = [], mi.Circle = [], mi.LineString = [], mi.Point = []);
      const Si = yi.getType();
      if (Si === "GeometryCollection") {
        const gi = (
          /** @type {import("../../geom/GeometryCollection.js").default} */
          yi.getGeometriesArrayRecursive()
        );
        for (let _i = 0, Oi = gi.length; _i < Oi; ++_i) {
          const hi = gi[_i];
          mi[hi.getType().replace("Multi", "")].push(
            hi,
            pi
          );
        }
      } else
        mi[Si.replace("Multi", "")].push(yi, pi);
    }
  }
  const gt = Object.keys(ft).map(Number).sort(ascending);
  for (let ct = 0, _r = gt.length; ct < _r; ++ct) {
    const Kr = ft[gt[ct]];
    for (const Xr in Kr) {
      const Jr = Kr[Xr];
      for (let ei = 0, si = Jr.length; ei < si; ei += 2) {
        st.setStyle(Jr[ei + 1]);
        for (let ri = 0, ai = Z.length; ri < ai; ++ri)
          st.setTransform(Z[ri]), st.drawGeometry(Jr[ei]);
      }
    }
  }
  return Je.getImageData(0, 0, nt.width, nt.height);
}
function hitDetect(ie, Z, ee) {
  const ae = [];
  if (ee) {
    const ve = Math.floor(Math.round(ie[0]) * HIT_DETECT_RESOLUTION), ye = Math.floor(Math.round(ie[1]) * HIT_DETECT_RESOLUTION), be = (clamp$1(ve, 0, ee.width - 1) + clamp$1(ye, 0, ee.height - 1) * ee.width) * 4, Ye = ee.data[be], Qe = ee.data[be + 1], nt = ee.data[be + 2] + 256 * (Qe + 256 * Ye), st = Math.floor((256 * 256 * 256 - 1) / Z.length);
    nt && nt % st === 0 && ae.push(Z[nt / st - 1]);
  }
  return ae;
}
const SIMPLIFY_TOLERANCE = 0.5, GEOMETRY_RENDERERS = {
  Point: renderPointGeometry,
  LineString: renderLineStringGeometry,
  Polygon: renderPolygonGeometry,
  MultiPoint: renderMultiPointGeometry,
  MultiLineString: renderMultiLineStringGeometry,
  MultiPolygon: renderMultiPolygonGeometry,
  GeometryCollection: renderGeometryCollectionGeometry,
  Circle: renderCircleGeometry
};
function getSquaredTolerance(ie, Z) {
  const ee = getTolerance(ie, Z);
  return ee * ee;
}
function getTolerance(ie, Z) {
  return SIMPLIFY_TOLERANCE * ie / Z;
}
function renderCircleGeometry(ie, Z, ee, ae, ve) {
  const ye = ee.getFill(), be = ee.getStroke();
  if (ye || be) {
    const Qe = ie.getBuilder(ee.getZIndex(), "Circle");
    Qe.setFillStrokeStyle(ye, be), Qe.drawCircle(Z, ae);
  }
  const Ye = ee.getText();
  if (Ye && Ye.getText()) {
    const Qe = (ve || ie).getBuilder(
      ee.getZIndex(),
      "Text"
    );
    Qe.setTextStyle(Ye), Qe.drawText(Z, ae);
  }
}
function renderFeature(ie, Z, ee, ae, ve, ye, be) {
  let Ye = !1;
  const Qe = ee.getImage();
  if (Qe) {
    const Je = Qe.getImageState();
    Je == ImageState.LOADED || Je == ImageState.ERROR ? Qe.unlistenImageChange(ve) : (Je == ImageState.IDLE && Qe.load(), Qe.listenImageChange(ve), Ye = !0);
  }
  return renderFeatureInternal(
    ie,
    Z,
    ee,
    ae,
    ye,
    be
  ), Ye;
}
function renderFeatureInternal(ie, Z, ee, ae, ve, ye) {
  const be = ee.getGeometryFunction()(Z);
  if (!be)
    return;
  const Ye = be.simplifyTransformed(
    ae,
    ve
  );
  if (ee.getRenderer())
    renderGeometry(ie, Ye, ee, Z);
  else {
    const Je = GEOMETRY_RENDERERS[Ye.getType()];
    Je(
      ie,
      Ye,
      ee,
      Z,
      ye
    );
  }
}
function renderGeometry(ie, Z, ee, ae) {
  if (Z.getType() == "GeometryCollection") {
    const ye = (
      /** @type {import("../geom/GeometryCollection.js").default} */
      Z.getGeometries()
    );
    for (let be = 0, Ye = ye.length; be < Ye; ++be)
      renderGeometry(ie, ye[be], ee, ae);
    return;
  }
  ie.getBuilder(ee.getZIndex(), "Default").drawCustom(
    /** @type {import("../geom/SimpleGeometry.js").default} */
    Z,
    ae,
    ee.getRenderer(),
    ee.getHitDetectionRenderer()
  );
}
function renderGeometryCollectionGeometry(ie, Z, ee, ae, ve) {
  const ye = Z.getGeometriesArray();
  let be, Ye;
  for (be = 0, Ye = ye.length; be < Ye; ++be) {
    const Qe = GEOMETRY_RENDERERS[ye[be].getType()];
    Qe(
      ie,
      ye[be],
      ee,
      ae,
      ve
    );
  }
}
function renderLineStringGeometry(ie, Z, ee, ae, ve) {
  const ye = ee.getStroke();
  if (ye) {
    const Ye = ie.getBuilder(
      ee.getZIndex(),
      "LineString"
    );
    Ye.setFillStrokeStyle(null, ye), Ye.drawLineString(Z, ae);
  }
  const be = ee.getText();
  if (be && be.getText()) {
    const Ye = (ve || ie).getBuilder(
      ee.getZIndex(),
      "Text"
    );
    Ye.setTextStyle(be), Ye.drawText(Z, ae);
  }
}
function renderMultiLineStringGeometry(ie, Z, ee, ae, ve) {
  const ye = ee.getStroke();
  if (ye) {
    const Ye = ie.getBuilder(
      ee.getZIndex(),
      "LineString"
    );
    Ye.setFillStrokeStyle(null, ye), Ye.drawMultiLineString(Z, ae);
  }
  const be = ee.getText();
  if (be && be.getText()) {
    const Ye = (ve || ie).getBuilder(
      ee.getZIndex(),
      "Text"
    );
    Ye.setTextStyle(be), Ye.drawText(Z, ae);
  }
}
function renderMultiPolygonGeometry(ie, Z, ee, ae, ve) {
  const ye = ee.getFill(), be = ee.getStroke();
  if (be || ye) {
    const Qe = ie.getBuilder(ee.getZIndex(), "Polygon");
    Qe.setFillStrokeStyle(ye, be), Qe.drawMultiPolygon(Z, ae);
  }
  const Ye = ee.getText();
  if (Ye && Ye.getText()) {
    const Qe = (ve || ie).getBuilder(
      ee.getZIndex(),
      "Text"
    );
    Qe.setTextStyle(Ye), Qe.drawText(Z, ae);
  }
}
function renderPointGeometry(ie, Z, ee, ae, ve) {
  const ye = ee.getImage(), be = ee.getText();
  let Ye;
  if (ye) {
    if (ye.getImageState() != ImageState.LOADED)
      return;
    let Qe = ie;
    if (ve) {
      const nt = ye.getDeclutterMode();
      if (nt !== "none")
        if (Qe = ve, nt === "obstacle") {
          const st = ie.getBuilder(
            ee.getZIndex(),
            "Image"
          );
          st.setImageStyle(ye, Ye), st.drawPoint(Z, ae);
        } else
          be && be.getText() && (Ye = {});
    }
    const Je = Qe.getBuilder(
      ee.getZIndex(),
      "Image"
    );
    Je.setImageStyle(ye, Ye), Je.drawPoint(Z, ae);
  }
  if (be && be.getText()) {
    let Qe = ie;
    ve && (Qe = ve);
    const Je = Qe.getBuilder(ee.getZIndex(), "Text");
    Je.setTextStyle(be, Ye), Je.drawText(Z, ae);
  }
}
function renderMultiPointGeometry(ie, Z, ee, ae, ve) {
  const ye = ee.getImage(), be = ee.getText();
  let Ye;
  if (ye) {
    if (ye.getImageState() != ImageState.LOADED)
      return;
    let Qe = ie;
    if (ve) {
      const nt = ye.getDeclutterMode();
      if (nt !== "none")
        if (Qe = ve, nt === "obstacle") {
          const st = ie.getBuilder(
            ee.getZIndex(),
            "Image"
          );
          st.setImageStyle(ye, Ye), st.drawMultiPoint(Z, ae);
        } else
          be && be.getText() && (Ye = {});
    }
    const Je = Qe.getBuilder(
      ee.getZIndex(),
      "Image"
    );
    Je.setImageStyle(ye, Ye), Je.drawMultiPoint(Z, ae);
  }
  if (be && be.getText()) {
    let Qe = ie;
    ve && (Qe = ve);
    const Je = Qe.getBuilder(ee.getZIndex(), "Text");
    Je.setTextStyle(be, Ye), Je.drawText(Z, ae);
  }
}
function renderPolygonGeometry(ie, Z, ee, ae, ve) {
  const ye = ee.getFill(), be = ee.getStroke();
  if (ye || be) {
    const Qe = ie.getBuilder(ee.getZIndex(), "Polygon");
    Qe.setFillStrokeStyle(ye, be), Qe.drawPolygon(Z, ae);
  }
  const Ye = ee.getText();
  if (Ye && Ye.getText()) {
    const Qe = (ve || ie).getBuilder(
      ee.getZIndex(),
      "Text"
    );
    Qe.setTextStyle(Ye), Qe.drawText(Z, ae);
  }
}
class Source extends BaseObject {
  /**
   * @param {Options} options Source options.
   */
  constructor(Z) {
    super(), this.projection = get$1(Z.projection), this.attributions_ = adaptAttributions(Z.attributions), this.attributionsCollapsible_ = Z.attributionsCollapsible !== void 0 ? Z.attributionsCollapsible : !0, this.loading = !1, this.state_ = Z.state !== void 0 ? Z.state : "ready", this.wrapX_ = Z.wrapX !== void 0 ? Z.wrapX : !1, this.interpolate_ = !!Z.interpolate, this.viewResolver = null, this.viewRejector = null;
    const ee = this;
    this.viewPromise_ = new Promise(function(ae, ve) {
      ee.viewResolver = ae, ee.viewRejector = ve;
    });
  }
  /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */
  getAttributions() {
    return this.attributions_;
  }
  /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */
  getAttributionsCollapsible() {
    return this.attributionsCollapsible_;
  }
  /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */
  getProjection() {
    return this.projection;
  }
  /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */
  getResolutions(Z) {
    return null;
  }
  /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */
  getView() {
    return this.viewPromise_;
  }
  /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */
  getState() {
    return this.state_;
  }
  /**
   * @return {boolean|undefined} Wrap X.
   */
  getWrapX() {
    return this.wrapX_;
  }
  /**
   * @return {boolean} Use linear interpolation when resampling.
   */
  getInterpolate() {
    return this.interpolate_;
  }
  /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */
  refresh() {
    this.changed();
  }
  /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */
  setAttributions(Z) {
    this.attributions_ = adaptAttributions(Z), this.changed();
  }
  /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */
  setState(Z) {
    this.state_ = Z, this.changed();
  }
}
function adaptAttributions(ie) {
  return ie ? Array.isArray(ie) ? function(Z) {
    return ie;
  } : typeof ie == "function" ? ie : function(Z) {
    return [ie];
  } : null;
}
let withCredentials = !1;
function loadFeaturesXhr(ie, Z, ee, ae, ve, ye, be) {
  const Ye = new XMLHttpRequest();
  Ye.open(
    "GET",
    typeof ie == "function" ? ie(ee, ae, ve) : ie,
    !0
  ), Z.getType() == "arraybuffer" && (Ye.responseType = "arraybuffer"), Ye.withCredentials = withCredentials, Ye.onload = function(Qe) {
    if (!Ye.status || Ye.status >= 200 && Ye.status < 300) {
      const Je = Z.getType();
      let nt;
      Je == "json" || Je == "text" ? nt = Ye.responseText : Je == "xml" ? (nt = Ye.responseXML, nt || (nt = new DOMParser().parseFromString(
        Ye.responseText,
        "application/xml"
      ))) : Je == "arraybuffer" && (nt = /** @type {ArrayBuffer} */
      Ye.response), nt ? ye(
        /** @type {Array<import("./Feature.js").default>} */
        Z.readFeatures(nt, {
          extent: ee,
          featureProjection: ve
        }),
        Z.readProjection(nt)
      ) : be();
    } else
      be();
  }, Ye.onerror = be, Ye.send();
}
const TileState = {
  IDLE: 0,
  LOADING: 1,
  LOADED: 2,
  /**
   * Indicates that tile loading failed
   * @type {number}
   */
  ERROR: 3,
  EMPTY: 4
};
class Tile extends Target {
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */
  constructor(Z, ee, ae) {
    super(), ae = ae || {}, this.tileCoord = Z, this.state = ee, this.interimTile = null, this.key = "", this.transition_ = ae.transition === void 0 ? 250 : ae.transition, this.transitionStarts_ = {}, this.interpolate = !!ae.interpolate;
  }
  /**
   * @protected
   */
  changed() {
    this.dispatchEvent(EventType.CHANGE);
  }
  /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */
  release() {
    this.state === TileState.ERROR && this.setState(TileState.EMPTY);
  }
  /**
   * @return {string} Key.
   */
  getKey() {
    return this.key + "/" + this.tileCoord;
  }
  /**
   * Get the interim tile most suitable for rendering using the chain of interim
   * tiles. This corresponds to the  most recent tile that has been loaded, if no
   * such tile exists, the original tile is returned.
   * @return {!Tile} Best tile for rendering.
   */
  getInterimTile() {
    if (!this.interimTile)
      return this;
    let Z = this.interimTile;
    do {
      if (Z.getState() == TileState.LOADED)
        return this.transition_ = 0, Z;
      Z = Z.interimTile;
    } while (Z);
    return this;
  }
  /**
   * Goes through the chain of interim tiles and discards sections of the chain
   * that are no longer relevant.
   */
  refreshInterimChain() {
    if (!this.interimTile)
      return;
    let Z = this.interimTile, ee = this;
    do {
      if (Z.getState() == TileState.LOADED) {
        Z.interimTile = null;
        break;
      } else
        Z.getState() == TileState.LOADING ? ee = Z : Z.getState() == TileState.IDLE ? ee.interimTile = Z.interimTile : ee = Z;
      Z = ee.interimTile;
    } while (Z);
  }
  /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */
  getTileCoord() {
    return this.tileCoord;
  }
  /**
   * @return {import("./TileState.js").default} State.
   */
  getState() {
    return this.state;
  }
  /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */
  setState(Z) {
    if (this.state !== TileState.ERROR && this.state > Z)
      throw new Error("Tile load sequence violation");
    this.state = Z, this.changed();
  }
  /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */
  load() {
    abstract();
  }
  /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */
  getAlpha(Z, ee) {
    if (!this.transition_)
      return 1;
    let ae = this.transitionStarts_[Z];
    if (!ae)
      ae = ee, this.transitionStarts_[Z] = ae;
    else if (ae === -1)
      return 1;
    const ve = ee - ae + 1e3 / 60;
    return ve >= this.transition_ ? 1 : easeIn(ve / this.transition_);
  }
  /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */
  inTransition(Z) {
    return this.transition_ ? this.transitionStarts_[Z] !== -1 : !1;
  }
  /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */
  endTransition(Z) {
    this.transition_ && (this.transitionStarts_[Z] = -1);
  }
}
class ImageTile extends Tile {
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */
  constructor(Z, ee, ae, ve, ye, be) {
    super(Z, ee, be), this.crossOrigin_ = ve, this.src_ = ae, this.key = ae, this.image_ = new Image(), ve !== null && (this.image_.crossOrigin = ve), this.unlisten_ = null, this.tileLoadFunction_ = ye;
  }
  /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */
  getImage() {
    return this.image_;
  }
  /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|HTMLImageElement} element Element.
   */
  setImage(Z) {
    this.image_ = Z, this.state = TileState.LOADED, this.unlistenImage_(), this.changed();
  }
  /**
   * Tracks loading or read errors.
   *
   * @private
   */
  handleImageError_() {
    this.state = TileState.ERROR, this.unlistenImage_(), this.image_ = getBlankImage(), this.changed();
  }
  /**
   * Tracks successful image load.
   *
   * @private
   */
  handleImageLoad_() {
    const Z = (
      /** @type {HTMLImageElement} */
      this.image_
    );
    Z.naturalWidth && Z.naturalHeight ? this.state = TileState.LOADED : this.state = TileState.EMPTY, this.unlistenImage_(), this.changed();
  }
  /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   *
   * @api
   */
  load() {
    this.state == TileState.ERROR && (this.state = TileState.IDLE, this.image_ = new Image(), this.crossOrigin_ !== null && (this.image_.crossOrigin = this.crossOrigin_)), this.state == TileState.IDLE && (this.state = TileState.LOADING, this.changed(), this.tileLoadFunction_(this, this.src_), this.unlisten_ = listenImage(
      this.image_,
      this.handleImageLoad_.bind(this),
      this.handleImageError_.bind(this)
    ));
  }
  /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */
  unlistenImage_() {
    this.unlisten_ && (this.unlisten_(), this.unlisten_ = null);
  }
}
function getBlankImage() {
  const ie = createCanvasContext2D(1, 1);
  return ie.fillStyle = "rgba(0,0,0,0)", ie.fillRect(0, 0, 1, 1), ie.canvas;
}
class Kinetic {
  /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */
  constructor(Z, ee, ae) {
    this.decay_ = Z, this.minVelocity_ = ee, this.delay_ = ae, this.points_ = [], this.angle_ = 0, this.initialVelocity_ = 0;
  }
  /**
   * FIXME empty description for jsdoc
   */
  begin() {
    this.points_.length = 0, this.angle_ = 0, this.initialVelocity_ = 0;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   */
  update(Z, ee) {
    this.points_.push(Z, ee, Date.now());
  }
  /**
   * @return {boolean} Whether we should do kinetic animation.
   */
  end() {
    if (this.points_.length < 6)
      return !1;
    const Z = Date.now() - this.delay_, ee = this.points_.length - 3;
    if (this.points_[ee + 2] < Z)
      return !1;
    let ae = ee - 3;
    for (; ae > 0 && this.points_[ae + 2] > Z; )
      ae -= 3;
    const ve = this.points_[ee + 2] - this.points_[ae + 2];
    if (ve < 1e3 / 60)
      return !1;
    const ye = this.points_[ee] - this.points_[ae], be = this.points_[ee + 1] - this.points_[ae + 1];
    return this.angle_ = Math.atan2(be, ye), this.initialVelocity_ = Math.sqrt(ye * ye + be * be) / ve, this.initialVelocity_ > this.minVelocity_;
  }
  /**
   * @return {number} Total distance travelled (pixels).
   */
  getDistance() {
    return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
  }
  /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */
  getAngle() {
    return this.angle_;
  }
}
class MapRenderer extends Disposable {
  /**
   * @param {import("../Map.js").default} map Map.
   */
  constructor(Z) {
    super(), this.map_ = Z;
  }
  /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */
  dispatchRenderEvent(Z, ee) {
    abstract();
  }
  /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */
  calculateMatrices2D(Z) {
    const ee = Z.viewState, ae = Z.coordinateToPixelTransform, ve = Z.pixelToCoordinateTransform;
    compose$1(
      ae,
      Z.size[0] / 2,
      Z.size[1] / 2,
      1 / ee.resolution,
      -1 / ee.resolution,
      -ee.rotation,
      -ee.center[0],
      -ee.center[1]
    ), makeInverse(ve, ae);
  }
  /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */
  forEachFeatureAtCoordinate(Z, ee, ae, ve, ye, be, Ye, Qe) {
    let Je;
    const nt = ee.viewState;
    function st(Jr, ei, si, ri) {
      return ye.call(be, ei, Jr ? si : null, ri);
    }
    const ot = nt.projection, lt = wrapX$1(Z.slice(), ot), ft = [[0, 0]];
    if (ot.canWrapX() && ve) {
      const Jr = ot.getExtent(), ei = getWidth(Jr);
      ft.push([-ei, 0], [ei, 0]);
    }
    const gt = ee.layerStatesArray, ct = gt.length, _r = (
      /** @type {Array<HitMatch<T>>} */
      []
    ), Kr = [];
    for (let Jr = 0; Jr < ft.length; Jr++)
      for (let ei = ct - 1; ei >= 0; --ei) {
        const si = gt[ei], ri = si.layer;
        if (ri.hasRenderer() && inView(si, nt) && Ye.call(Qe, ri)) {
          const ai = ri.getRenderer(), yi = ri.getSource();
          if (ai && yi) {
            const pi = yi.getWrapX() ? lt : Z, di = st.bind(
              null,
              si.managed
            );
            Kr[0] = pi[0] + ft[Jr][0], Kr[1] = pi[1] + ft[Jr][1], Je = ai.forEachFeatureAtCoordinate(
              Kr,
              ee,
              ae,
              di,
              _r
            );
          }
          if (Je)
            return Je;
        }
      }
    if (_r.length === 0)
      return;
    const Xr = 1 / _r.length;
    return _r.forEach((Jr, ei) => Jr.distanceSq += ei * Xr), _r.sort((Jr, ei) => Jr.distanceSq - ei.distanceSq), _r.some((Jr) => Je = Jr.callback(Jr.feature, Jr.layer, Jr.geometry)), Je;
  }
  /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */
  hasFeatureAtCoordinate(Z, ee, ae, ve, ye, be) {
    return this.forEachFeatureAtCoordinate(
      Z,
      ee,
      ae,
      ve,
      TRUE,
      this,
      ye,
      be
    ) !== void 0;
  }
  /**
   * @return {import("../Map.js").default} Map.
   */
  getMap() {
    return this.map_;
  }
  /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */
  renderFrame(Z) {
    abstract();
  }
  /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */
  flushDeclutterItems(Z) {
  }
  /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */
  scheduleExpireIconCache(Z) {
    shared.canExpireCache() && Z.postRenderFunctions.push(expireIconCache);
  }
}
function expireIconCache(ie, Z) {
  shared.expire();
}
class CompositeMapRenderer extends MapRenderer {
  /**
   * @param {import("../Map.js").default} map Map.
   */
  constructor(Z) {
    super(Z), this.fontChangeListenerKey_ = listen(
      checkedFonts,
      ObjectEventType.PROPERTYCHANGE,
      Z.redrawText.bind(Z)
    ), this.element_ = document.createElement("div");
    const ee = this.element_.style;
    ee.position = "absolute", ee.width = "100%", ee.height = "100%", ee.zIndex = "0", this.element_.className = CLASS_UNSELECTABLE + " ol-layers";
    const ae = Z.getViewport();
    ae.insertBefore(this.element_, ae.firstChild || null), this.children_ = [], this.renderedVisible_ = !0, this.declutterLayers_ = [];
  }
  /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */
  dispatchRenderEvent(Z, ee) {
    const ae = this.getMap();
    if (ae.hasListener(Z)) {
      const ve = new RenderEvent(Z, void 0, ee);
      ae.dispatchEvent(ve);
    }
  }
  disposeInternal() {
    unlistenByKey(this.fontChangeListenerKey_), this.element_.parentNode.removeChild(this.element_), super.disposeInternal();
  }
  /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */
  renderFrame(Z) {
    if (!Z) {
      this.renderedVisible_ && (this.element_.style.display = "none", this.renderedVisible_ = !1);
      return;
    }
    this.calculateMatrices2D(Z), this.dispatchRenderEvent(RenderEventType.PRECOMPOSE, Z);
    const ee = Z.layerStatesArray.sort(function(be, Ye) {
      return be.zIndex - Ye.zIndex;
    }), ae = Z.viewState;
    this.children_.length = 0;
    const ve = this.declutterLayers_;
    ve.length = 0;
    let ye = null;
    for (let be = 0, Ye = ee.length; be < Ye; ++be) {
      const Qe = ee[be];
      Z.layerIndex = be;
      const Je = Qe.layer, nt = Je.getSourceState();
      if (!inView(Qe, ae) || nt != "ready" && nt != "undefined") {
        Je.unrender();
        continue;
      }
      const st = Je.render(Z, ye);
      st && (st !== ye && (this.children_.push(st), ye = st), "getDeclutter" in Je && ve.push(
        /** @type {import("../layer/BaseVector.js").default} */
        Je
      ));
    }
    this.flushDeclutterItems(Z), replaceChildren(this.element_, this.children_), this.dispatchRenderEvent(RenderEventType.POSTCOMPOSE, Z), this.renderedVisible_ || (this.element_.style.display = "", this.renderedVisible_ = !0), this.scheduleExpireIconCache(Z);
  }
  /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */
  flushDeclutterItems(Z) {
    const ee = this.declutterLayers_;
    for (let ae = ee.length - 1; ae >= 0; --ae)
      ee[ae].renderDeclutter(Z);
    ee.length = 0;
  }
}
class GroupEvent extends BaseEvent {
  /**
   * @param {EventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */
  constructor(Z, ee) {
    super(Z), this.layer = ee;
  }
}
const Property = {
  LAYERS: "layers"
};
class LayerGroup extends BaseLayer {
  /**
   * @param {Options} [options] Layer options.
   */
  constructor(Z) {
    Z = Z || {};
    const ee = (
      /** @type {Options} */
      Object.assign({}, Z)
    );
    delete ee.layers;
    let ae = Z.layers;
    super(ee), this.on, this.once, this.un, this.layersListenerKeys_ = [], this.listenerKeys_ = {}, this.addChangeListener(Property.LAYERS, this.handleLayersChanged_), ae ? Array.isArray(ae) ? ae = new Collection(ae.slice(), { unique: !0 }) : assert(
      typeof /** @type {?} */
      ae.getArray == "function",
      "Expected `layers` to be an array or a `Collection`"
    ) : ae = new Collection(void 0, { unique: !0 }), this.setLayers(ae);
  }
  /**
   * @private
   */
  handleLayerChange_() {
    this.changed();
  }
  /**
   * @private
   */
  handleLayersChanged_() {
    this.layersListenerKeys_.forEach(unlistenByKey), this.layersListenerKeys_.length = 0;
    const Z = this.getLayers();
    this.layersListenerKeys_.push(
      listen(Z, CollectionEventType.ADD, this.handleLayersAdd_, this),
      listen(Z, CollectionEventType.REMOVE, this.handleLayersRemove_, this)
    );
    for (const ae in this.listenerKeys_)
      this.listenerKeys_[ae].forEach(unlistenByKey);
    clear(this.listenerKeys_);
    const ee = Z.getArray();
    for (let ae = 0, ve = ee.length; ae < ve; ae++) {
      const ye = ee[ae];
      this.registerLayerListeners_(ye), this.dispatchEvent(new GroupEvent("addlayer", ye));
    }
    this.changed();
  }
  /**
   * @param {BaseLayer} layer The layer.
   */
  registerLayerListeners_(Z) {
    const ee = [
      listen(
        Z,
        ObjectEventType.PROPERTYCHANGE,
        this.handleLayerChange_,
        this
      ),
      listen(Z, EventType.CHANGE, this.handleLayerChange_, this)
    ];
    Z instanceof LayerGroup && ee.push(
      listen(Z, "addlayer", this.handleLayerGroupAdd_, this),
      listen(Z, "removelayer", this.handleLayerGroupRemove_, this)
    ), this.listenerKeys_[getUid(Z)] = ee;
  }
  /**
   * @param {GroupEvent} event The layer group event.
   */
  handleLayerGroupAdd_(Z) {
    this.dispatchEvent(new GroupEvent("addlayer", Z.layer));
  }
  /**
   * @param {GroupEvent} event The layer group event.
   */
  handleLayerGroupRemove_(Z) {
    this.dispatchEvent(new GroupEvent("removelayer", Z.layer));
  }
  /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */
  handleLayersAdd_(Z) {
    const ee = Z.element;
    this.registerLayerListeners_(ee), this.dispatchEvent(new GroupEvent("addlayer", ee)), this.changed();
  }
  /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */
  handleLayersRemove_(Z) {
    const ee = Z.element, ae = getUid(ee);
    this.listenerKeys_[ae].forEach(unlistenByKey), delete this.listenerKeys_[ae], this.dispatchEvent(new GroupEvent("removelayer", ee)), this.changed();
  }
  /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */
  getLayers() {
    return (
      /** @type {!Collection<import("./Base.js").default>} */
      this.get(Property.LAYERS)
    );
  }
  /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */
  setLayers(Z) {
    const ee = this.getLayers();
    if (ee) {
      const ae = ee.getArray();
      for (let ve = 0, ye = ae.length; ve < ye; ++ve)
        this.dispatchEvent(new GroupEvent("removelayer", ae[ve]));
    }
    this.set(Property.LAYERS, Z);
  }
  /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */
  getLayersArray(Z) {
    return Z = Z !== void 0 ? Z : [], this.getLayers().forEach(function(ee) {
      ee.getLayersArray(Z);
    }), Z;
  }
  /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */
  getLayerStatesArray(Z) {
    const ee = Z !== void 0 ? Z : [], ae = ee.length;
    this.getLayers().forEach(function(be) {
      be.getLayerStatesArray(ee);
    });
    const ve = this.getLayerState();
    let ye = ve.zIndex;
    !Z && ve.zIndex === void 0 && (ye = 0);
    for (let be = ae, Ye = ee.length; be < Ye; be++) {
      const Qe = ee[be];
      Qe.opacity *= ve.opacity, Qe.visible = Qe.visible && ve.visible, Qe.maxResolution = Math.min(
        Qe.maxResolution,
        ve.maxResolution
      ), Qe.minResolution = Math.max(
        Qe.minResolution,
        ve.minResolution
      ), Qe.minZoom = Math.max(Qe.minZoom, ve.minZoom), Qe.maxZoom = Math.min(Qe.maxZoom, ve.maxZoom), ve.extent !== void 0 && (Qe.extent !== void 0 ? Qe.extent = getIntersection(
        Qe.extent,
        ve.extent
      ) : Qe.extent = ve.extent), Qe.zIndex === void 0 && (Qe.zIndex = ye);
    }
    return ee;
  }
  /**
   * @return {import("../source/Source.js").State} Source state.
   */
  getSourceState() {
    return "ready";
  }
}
class MapEvent extends BaseEvent {
  /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */
  constructor(Z, ee, ae) {
    super(Z), this.map = ee, this.frameState = ae !== void 0 ? ae : null;
  }
}
class MapBrowserEvent extends MapEvent {
  /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */
  constructor(Z, ee, ae, ve, ye, be) {
    super(Z, ee, ye), this.originalEvent = ae, this.pixel_ = null, this.coordinate_ = null, this.dragging = ve !== void 0 ? ve : !1, this.activePointers = be;
  }
  /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */
  get pixel() {
    return this.pixel_ || (this.pixel_ = this.map.getEventPixel(this.originalEvent)), this.pixel_;
  }
  set pixel(Z) {
    this.pixel_ = Z;
  }
  /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */
  get coordinate() {
    return this.coordinate_ || (this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel)), this.coordinate_;
  }
  set coordinate(Z) {
    this.coordinate_ = Z;
  }
  /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   */
  preventDefault() {
    super.preventDefault(), "preventDefault" in this.originalEvent && this.originalEvent.preventDefault();
  }
  /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   */
  stopPropagation() {
    super.stopPropagation(), "stopPropagation" in this.originalEvent && this.originalEvent.stopPropagation();
  }
}
const MapBrowserEventType = {
  /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */
  SINGLECLICK: "singleclick",
  /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */
  CLICK: EventType.CLICK,
  /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */
  DBLCLICK: EventType.DBLCLICK,
  /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */
  POINTERDRAG: "pointerdrag",
  /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */
  POINTERMOVE: "pointermove",
  POINTERDOWN: "pointerdown",
  POINTERUP: "pointerup",
  POINTEROVER: "pointerover",
  POINTEROUT: "pointerout",
  POINTERENTER: "pointerenter",
  POINTERLEAVE: "pointerleave",
  POINTERCANCEL: "pointercancel"
}, PointerEventType = {
  POINTERMOVE: "pointermove",
  POINTERDOWN: "pointerdown",
  POINTERUP: "pointerup",
  POINTEROVER: "pointerover",
  POINTEROUT: "pointerout",
  POINTERENTER: "pointerenter",
  POINTERLEAVE: "pointerleave",
  POINTERCANCEL: "pointercancel"
};
class MapBrowserEventHandler extends Target {
  /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */
  constructor(Z, ee) {
    super(Z), this.map_ = Z, this.clickTimeoutId_, this.emulateClicks_ = !1, this.dragging_ = !1, this.dragListenerKeys_ = [], this.moveTolerance_ = ee === void 0 ? 1 : ee, this.down_ = null;
    const ae = this.map_.getViewport();
    this.activePointers_ = [], this.trackedTouches_ = {}, this.element_ = ae, this.pointerdownListenerKey_ = listen(
      ae,
      PointerEventType.POINTERDOWN,
      this.handlePointerDown_,
      this
    ), this.originalPointerMoveEvent_, this.relayedListenerKey_ = listen(
      ae,
      PointerEventType.POINTERMOVE,
      this.relayMoveEvent_,
      this
    ), this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this), this.element_.addEventListener(
      EventType.TOUCHMOVE,
      this.boundHandleTouchMove_,
      PASSIVE_EVENT_LISTENERS ? { passive: !1 } : !1
    );
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  emulateClick_(Z) {
    let ee = new MapBrowserEvent(
      MapBrowserEventType.CLICK,
      this.map_,
      Z
    );
    this.dispatchEvent(ee), this.clickTimeoutId_ !== void 0 ? (clearTimeout(this.clickTimeoutId_), this.clickTimeoutId_ = void 0, ee = new MapBrowserEvent(
      MapBrowserEventType.DBLCLICK,
      this.map_,
      Z
    ), this.dispatchEvent(ee)) : this.clickTimeoutId_ = setTimeout(() => {
      this.clickTimeoutId_ = void 0;
      const ae = new MapBrowserEvent(
        MapBrowserEventType.SINGLECLICK,
        this.map_,
        Z
      );
      this.dispatchEvent(ae);
    }, 250);
  }
  /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  updateActivePointers_(Z) {
    const ee = Z, ae = ee.pointerId;
    if (ee.type == MapBrowserEventType.POINTERUP || ee.type == MapBrowserEventType.POINTERCANCEL) {
      delete this.trackedTouches_[ae];
      for (const ve in this.trackedTouches_)
        if (this.trackedTouches_[ve].target !== ee.target) {
          delete this.trackedTouches_[ve];
          break;
        }
    } else
      (ee.type == MapBrowserEventType.POINTERDOWN || ee.type == MapBrowserEventType.POINTERMOVE) && (this.trackedTouches_[ae] = ee);
    this.activePointers_ = Object.values(this.trackedTouches_);
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  handlePointerUp_(Z) {
    this.updateActivePointers_(Z);
    const ee = new MapBrowserEvent(
      MapBrowserEventType.POINTERUP,
      this.map_,
      Z,
      void 0,
      void 0,
      this.activePointers_
    );
    this.dispatchEvent(ee), this.emulateClicks_ && !ee.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(Z) && this.emulateClick_(this.down_), this.activePointers_.length === 0 && (this.dragListenerKeys_.forEach(unlistenByKey), this.dragListenerKeys_.length = 0, this.dragging_ = !1, this.down_ = null);
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */
  isMouseActionButton_(Z) {
    return Z.button === 0;
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  handlePointerDown_(Z) {
    this.emulateClicks_ = this.activePointers_.length === 0, this.updateActivePointers_(Z);
    const ee = new MapBrowserEvent(
      MapBrowserEventType.POINTERDOWN,
      this.map_,
      Z,
      void 0,
      void 0,
      this.activePointers_
    );
    if (this.dispatchEvent(ee), this.down_ = new PointerEvent(Z.type, Z), Object.defineProperty(this.down_, "target", {
      writable: !1,
      value: Z.target
    }), this.dragListenerKeys_.length === 0) {
      const ae = this.map_.getOwnerDocument();
      this.dragListenerKeys_.push(
        listen(
          ae,
          MapBrowserEventType.POINTERMOVE,
          this.handlePointerMove_,
          this
        ),
        listen(ae, MapBrowserEventType.POINTERUP, this.handlePointerUp_, this),
        /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */
        listen(
          this.element_,
          MapBrowserEventType.POINTERCANCEL,
          this.handlePointerUp_,
          this
        )
      ), this.element_.getRootNode && this.element_.getRootNode() !== ae && this.dragListenerKeys_.push(
        listen(
          this.element_.getRootNode(),
          MapBrowserEventType.POINTERUP,
          this.handlePointerUp_,
          this
        )
      );
    }
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  handlePointerMove_(Z) {
    if (this.isMoving_(Z)) {
      this.updateActivePointers_(Z), this.dragging_ = !0;
      const ee = new MapBrowserEvent(
        MapBrowserEventType.POINTERDRAG,
        this.map_,
        Z,
        this.dragging_,
        void 0,
        this.activePointers_
      );
      this.dispatchEvent(ee);
    }
  }
  /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  relayMoveEvent_(Z) {
    this.originalPointerMoveEvent_ = Z;
    const ee = !!(this.down_ && this.isMoving_(Z));
    this.dispatchEvent(
      new MapBrowserEvent(
        MapBrowserEventType.POINTERMOVE,
        this.map_,
        Z,
        ee
      )
    );
  }
  /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */
  handleTouchMove_(Z) {
    const ee = this.originalPointerMoveEvent_;
    (!ee || ee.defaultPrevented) && (typeof Z.cancelable != "boolean" || Z.cancelable === !0) && Z.preventDefault();
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */
  isMoving_(Z) {
    return this.dragging_ || Math.abs(Z.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(Z.clientY - this.down_.clientY) > this.moveTolerance_;
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    this.relayedListenerKey_ && (unlistenByKey(this.relayedListenerKey_), this.relayedListenerKey_ = null), this.element_.removeEventListener(
      EventType.TOUCHMOVE,
      this.boundHandleTouchMove_
    ), this.pointerdownListenerKey_ && (unlistenByKey(this.pointerdownListenerKey_), this.pointerdownListenerKey_ = null), this.dragListenerKeys_.forEach(unlistenByKey), this.dragListenerKeys_.length = 0, this.element_ = null, super.disposeInternal();
  }
}
const MapEventType = {
  /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */
  POSTRENDER: "postrender",
  /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */
  MOVESTART: "movestart",
  /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */
  MOVEEND: "moveend",
  /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */
  LOADSTART: "loadstart",
  /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */
  LOADEND: "loadend"
}, MapProperty = {
  LAYERGROUP: "layergroup",
  SIZE: "size",
  TARGET: "target",
  VIEW: "view"
}, DROP = 1 / 0;
class PriorityQueue {
  /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */
  constructor(Z, ee) {
    this.priorityFunction_ = Z, this.keyFunction_ = ee, this.elements_ = [], this.priorities_ = [], this.queuedElements_ = {};
  }
  /**
   * FIXME empty description for jsdoc
   */
  clear() {
    this.elements_.length = 0, this.priorities_.length = 0, clear(this.queuedElements_);
  }
  /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */
  dequeue() {
    const Z = this.elements_, ee = this.priorities_, ae = Z[0];
    Z.length == 1 ? (Z.length = 0, ee.length = 0) : (Z[0] = Z.pop(), ee[0] = ee.pop(), this.siftUp_(0));
    const ve = this.keyFunction_(ae);
    return delete this.queuedElements_[ve], ae;
  }
  /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */
  enqueue(Z) {
    assert(
      !(this.keyFunction_(Z) in this.queuedElements_),
      "Tried to enqueue an `element` that was already added to the queue"
    );
    const ee = this.priorityFunction_(Z);
    return ee != DROP ? (this.elements_.push(Z), this.priorities_.push(ee), this.queuedElements_[this.keyFunction_(Z)] = !0, this.siftDown_(0, this.elements_.length - 1), !0) : !1;
  }
  /**
   * @return {number} Count.
   */
  getCount() {
    return this.elements_.length;
  }
  /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */
  getLeftChildIndex_(Z) {
    return Z * 2 + 1;
  }
  /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */
  getRightChildIndex_(Z) {
    return Z * 2 + 2;
  }
  /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */
  getParentIndex_(Z) {
    return Z - 1 >> 1;
  }
  /**
   * Make this a heap. O(N).
   * @private
   */
  heapify_() {
    let Z;
    for (Z = (this.elements_.length >> 1) - 1; Z >= 0; Z--)
      this.siftUp_(Z);
  }
  /**
   * @return {boolean} Is empty.
   */
  isEmpty() {
    return this.elements_.length === 0;
  }
  /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */
  isKeyQueued(Z) {
    return Z in this.queuedElements_;
  }
  /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */
  isQueued(Z) {
    return this.isKeyQueued(this.keyFunction_(Z));
  }
  /**
   * @param {number} index The index of the node to move down.
   * @private
   */
  siftUp_(Z) {
    const ee = this.elements_, ae = this.priorities_, ve = ee.length, ye = ee[Z], be = ae[Z], Ye = Z;
    for (; Z < ve >> 1; ) {
      const Qe = this.getLeftChildIndex_(Z), Je = this.getRightChildIndex_(Z), nt = Je < ve && ae[Je] < ae[Qe] ? Je : Qe;
      ee[Z] = ee[nt], ae[Z] = ae[nt], Z = nt;
    }
    ee[Z] = ye, ae[Z] = be, this.siftDown_(Ye, Z);
  }
  /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */
  siftDown_(Z, ee) {
    const ae = this.elements_, ve = this.priorities_, ye = ae[ee], be = ve[ee];
    for (; ee > Z; ) {
      const Ye = this.getParentIndex_(ee);
      if (ve[Ye] > be)
        ae[ee] = ae[Ye], ve[ee] = ve[Ye], ee = Ye;
      else
        break;
    }
    ae[ee] = ye, ve[ee] = be;
  }
  /**
   * FIXME empty description for jsdoc
   */
  reprioritize() {
    const Z = this.priorityFunction_, ee = this.elements_, ae = this.priorities_;
    let ve = 0;
    const ye = ee.length;
    let be, Ye, Qe;
    for (Ye = 0; Ye < ye; ++Ye)
      be = ee[Ye], Qe = Z(be), Qe == DROP ? delete this.queuedElements_[this.keyFunction_(be)] : (ae[ve] = Qe, ee[ve++] = be);
    ee.length = ve, ae.length = ve, this.heapify_();
  }
}
class TileQueue extends PriorityQueue {
  /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */
  constructor(Z, ee) {
    super(
      /**
       * @param {Array} element Element.
       * @return {number} Priority.
       */
      function(ae) {
        return Z.apply(null, ae);
      },
      /**
       * @param {Array} element Element.
       * @return {string} Key.
       */
      function(ae) {
        return (
          /** @type {import("./Tile.js").default} */
          ae[0].getKey()
        );
      }
    ), this.boundHandleTileChange_ = this.handleTileChange.bind(this), this.tileChangeCallback_ = ee, this.tilesLoading_ = 0, this.tilesLoadingKeys_ = {};
  }
  /**
   * @param {Array} element Element.
   * @return {boolean} The element was added to the queue.
   */
  enqueue(Z) {
    const ee = super.enqueue(Z);
    return ee && Z[0].addEventListener(EventType.CHANGE, this.boundHandleTileChange_), ee;
  }
  /**
   * @return {number} Number of tiles loading.
   */
  getTilesLoading() {
    return this.tilesLoading_;
  }
  /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */
  handleTileChange(Z) {
    const ee = (
      /** @type {import("./Tile.js").default} */
      Z.target
    ), ae = ee.getState();
    if (ae === TileState.LOADED || ae === TileState.ERROR || ae === TileState.EMPTY) {
      ae !== TileState.ERROR && ee.removeEventListener(EventType.CHANGE, this.boundHandleTileChange_);
      const ve = ee.getKey();
      ve in this.tilesLoadingKeys_ && (delete this.tilesLoadingKeys_[ve], --this.tilesLoading_), this.tileChangeCallback_();
    }
  }
  /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */
  loadMoreTiles(Z, ee) {
    let ae = 0, ve, ye, be;
    for (; this.tilesLoading_ < Z && ae < ee && this.getCount() > 0; )
      ye = /** @type {import("./Tile.js").default} */
      this.dequeue()[0], be = ye.getKey(), ve = ye.getState(), ve === TileState.IDLE && !(be in this.tilesLoadingKeys_) && (this.tilesLoadingKeys_[be] = !0, ++this.tilesLoading_, ++ae, ye.load());
  }
}
function getTilePriority(ie, Z, ee, ae, ve) {
  if (!ie || !(ee in ie.wantedTiles) || !ie.wantedTiles[ee][Z.getKey()])
    return DROP;
  const ye = ie.viewState.center, be = ae[0] - ye[0], Ye = ae[1] - ye[1];
  return 65536 * Math.log(ve) + Math.sqrt(be * be + Ye * Ye) / ve;
}
class Control extends BaseObject {
  /**
   * @param {Options} options Control options.
   */
  constructor(Z) {
    super();
    const ee = Z.element;
    ee && !Z.target && !ee.style.pointerEvents && (ee.style.pointerEvents = "auto"), this.element = ee || null, this.target_ = null, this.map_ = null, this.listenerKeys = [], Z.render && (this.render = Z.render), Z.target && this.setTarget(Z.target);
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    removeNode(this.element), super.disposeInternal();
  }
  /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */
  getMap() {
    return this.map_;
  }
  /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */
  setMap(Z) {
    this.map_ && removeNode(this.element);
    for (let ee = 0, ae = this.listenerKeys.length; ee < ae; ++ee)
      unlistenByKey(this.listenerKeys[ee]);
    this.listenerKeys.length = 0, this.map_ = Z, Z && ((this.target_ ? this.target_ : Z.getOverlayContainerStopEvent()).appendChild(this.element), this.render !== VOID && this.listenerKeys.push(
      listen(Z, MapEventType.POSTRENDER, this.render, this)
    ), Z.render());
  }
  /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */
  render(Z) {
  }
  /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */
  setTarget(Z) {
    this.target_ = typeof Z == "string" ? document.getElementById(Z) : Z;
  }
}
class Attribution extends Control {
  /**
   * @param {Options} [options] Attribution options.
   */
  constructor(Z) {
    Z = Z || {}, super({
      element: document.createElement("div"),
      render: Z.render,
      target: Z.target
    }), this.ulElement_ = document.createElement("ul"), this.collapsed_ = Z.collapsed !== void 0 ? Z.collapsed : !0, this.userCollapsed_ = this.collapsed_, this.overrideCollapsible_ = Z.collapsible !== void 0, this.collapsible_ = Z.collapsible !== void 0 ? Z.collapsible : !0, this.collapsible_ || (this.collapsed_ = !1);
    const ee = Z.className !== void 0 ? Z.className : "ol-attribution", ae = Z.tipLabel !== void 0 ? Z.tipLabel : "Attributions", ve = Z.expandClassName !== void 0 ? Z.expandClassName : ee + "-expand", ye = Z.collapseLabel !== void 0 ? Z.collapseLabel : "›", be = Z.collapseClassName !== void 0 ? Z.collapseClassName : ee + "-collapse";
    typeof ye == "string" ? (this.collapseLabel_ = document.createElement("span"), this.collapseLabel_.textContent = ye, this.collapseLabel_.className = be) : this.collapseLabel_ = ye;
    const Ye = Z.label !== void 0 ? Z.label : "i";
    typeof Ye == "string" ? (this.label_ = document.createElement("span"), this.label_.textContent = Ye, this.label_.className = ve) : this.label_ = Ye;
    const Qe = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
    this.toggleButton_ = document.createElement("button"), this.toggleButton_.setAttribute("type", "button"), this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_)), this.toggleButton_.title = ae, this.toggleButton_.appendChild(Qe), this.toggleButton_.addEventListener(
      EventType.CLICK,
      this.handleClick_.bind(this),
      !1
    );
    const Je = ee + " " + CLASS_UNSELECTABLE + " " + CLASS_CONTROL + (this.collapsed_ && this.collapsible_ ? " " + CLASS_COLLAPSED : "") + (this.collapsible_ ? "" : " ol-uncollapsible"), nt = this.element;
    nt.className = Je, nt.appendChild(this.toggleButton_), nt.appendChild(this.ulElement_), this.renderedAttributions_ = [], this.renderedVisible_ = !0;
  }
  /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */
  collectSourceAttributions_(Z) {
    const ee = Array.from(
      new Set(
        this.getMap().getAllLayers().flatMap((ve) => ve.getAttributions(Z))
      )
    ), ae = !this.getMap().getAllLayers().some(
      (ve) => ve.getSource() && ve.getSource().getAttributionsCollapsible() === !1
    );
    return this.overrideCollapsible_ || this.setCollapsible(ae), ee;
  }
  /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */
  updateElement_(Z) {
    if (!Z) {
      this.renderedVisible_ && (this.element.style.display = "none", this.renderedVisible_ = !1);
      return;
    }
    const ee = this.collectSourceAttributions_(Z), ae = ee.length > 0;
    if (this.renderedVisible_ != ae && (this.element.style.display = ae ? "" : "none", this.renderedVisible_ = ae), !equals$2(ee, this.renderedAttributions_)) {
      removeChildren(this.ulElement_);
      for (let ve = 0, ye = ee.length; ve < ye; ++ve) {
        const be = document.createElement("li");
        be.innerHTML = ee[ve], this.ulElement_.appendChild(be);
      }
      this.renderedAttributions_ = ee;
    }
  }
  /**
   * @param {MouseEvent} event The event to handle
   * @private
   */
  handleClick_(Z) {
    Z.preventDefault(), this.handleToggle_(), this.userCollapsed_ = this.collapsed_;
  }
  /**
   * @private
   */
  handleToggle_() {
    this.element.classList.toggle(CLASS_COLLAPSED), this.collapsed_ ? replaceNode(this.collapseLabel_, this.label_) : replaceNode(this.label_, this.collapseLabel_), this.collapsed_ = !this.collapsed_, this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_));
  }
  /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */
  getCollapsible() {
    return this.collapsible_;
  }
  /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */
  setCollapsible(Z) {
    this.collapsible_ !== Z && (this.collapsible_ = Z, this.element.classList.toggle("ol-uncollapsible"), this.userCollapsed_ && this.handleToggle_());
  }
  /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */
  setCollapsed(Z) {
    this.userCollapsed_ = Z, !(!this.collapsible_ || this.collapsed_ === Z) && this.handleToggle_();
  }
  /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */
  getCollapsed() {
    return this.collapsed_;
  }
  /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */
  render(Z) {
    this.updateElement_(Z.frameState);
  }
}
const Attribution$1 = Attribution;
class Rotate extends Control {
  /**
   * @param {Options} [options] Rotate options.
   */
  constructor(Z) {
    Z = Z || {}, super({
      element: document.createElement("div"),
      render: Z.render,
      target: Z.target
    });
    const ee = Z.className !== void 0 ? Z.className : "ol-rotate", ae = Z.label !== void 0 ? Z.label : "⇧", ve = Z.compassClassName !== void 0 ? Z.compassClassName : "ol-compass";
    this.label_ = null, typeof ae == "string" ? (this.label_ = document.createElement("span"), this.label_.className = ve, this.label_.textContent = ae) : (this.label_ = ae, this.label_.classList.add(ve));
    const ye = Z.tipLabel ? Z.tipLabel : "Reset rotation", be = document.createElement("button");
    be.className = ee + "-reset", be.setAttribute("type", "button"), be.title = ye, be.appendChild(this.label_), be.addEventListener(
      EventType.CLICK,
      this.handleClick_.bind(this),
      !1
    );
    const Ye = ee + " " + CLASS_UNSELECTABLE + " " + CLASS_CONTROL, Qe = this.element;
    Qe.className = Ye, Qe.appendChild(be), this.callResetNorth_ = Z.resetNorth ? Z.resetNorth : void 0, this.duration_ = Z.duration !== void 0 ? Z.duration : 250, this.autoHide_ = Z.autoHide !== void 0 ? Z.autoHide : !0, this.rotation_ = void 0, this.autoHide_ && this.element.classList.add(CLASS_HIDDEN);
  }
  /**
   * @param {MouseEvent} event The event to handle
   * @private
   */
  handleClick_(Z) {
    Z.preventDefault(), this.callResetNorth_ !== void 0 ? this.callResetNorth_() : this.resetNorth_();
  }
  /**
   * @private
   */
  resetNorth_() {
    const ee = this.getMap().getView();
    if (!ee)
      return;
    const ae = ee.getRotation();
    ae !== void 0 && (this.duration_ > 0 && ae % (2 * Math.PI) !== 0 ? ee.animate({
      rotation: 0,
      duration: this.duration_,
      easing: easeOut
    }) : ee.setRotation(0));
  }
  /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */
  render(Z) {
    const ee = Z.frameState;
    if (!ee)
      return;
    const ae = ee.viewState.rotation;
    if (ae != this.rotation_) {
      const ve = "rotate(" + ae + "rad)";
      if (this.autoHide_) {
        const ye = this.element.classList.contains(CLASS_HIDDEN);
        !ye && ae === 0 ? this.element.classList.add(CLASS_HIDDEN) : ye && ae !== 0 && this.element.classList.remove(CLASS_HIDDEN);
      }
      this.label_.style.transform = ve;
    }
    this.rotation_ = ae;
  }
}
const Rotate$1 = Rotate;
class Zoom extends Control {
  /**
   * @param {Options} [options] Zoom options.
   */
  constructor(Z) {
    Z = Z || {}, super({
      element: document.createElement("div"),
      target: Z.target
    });
    const ee = Z.className !== void 0 ? Z.className : "ol-zoom", ae = Z.delta !== void 0 ? Z.delta : 1, ve = Z.zoomInClassName !== void 0 ? Z.zoomInClassName : ee + "-in", ye = Z.zoomOutClassName !== void 0 ? Z.zoomOutClassName : ee + "-out", be = Z.zoomInLabel !== void 0 ? Z.zoomInLabel : "+", Ye = Z.zoomOutLabel !== void 0 ? Z.zoomOutLabel : "–", Qe = Z.zoomInTipLabel !== void 0 ? Z.zoomInTipLabel : "Zoom in", Je = Z.zoomOutTipLabel !== void 0 ? Z.zoomOutTipLabel : "Zoom out", nt = document.createElement("button");
    nt.className = ve, nt.setAttribute("type", "button"), nt.title = Qe, nt.appendChild(
      typeof be == "string" ? document.createTextNode(be) : be
    ), nt.addEventListener(
      EventType.CLICK,
      this.handleClick_.bind(this, ae),
      !1
    );
    const st = document.createElement("button");
    st.className = ye, st.setAttribute("type", "button"), st.title = Je, st.appendChild(
      typeof Ye == "string" ? document.createTextNode(Ye) : Ye
    ), st.addEventListener(
      EventType.CLICK,
      this.handleClick_.bind(this, -ae),
      !1
    );
    const ot = ee + " " + CLASS_UNSELECTABLE + " " + CLASS_CONTROL, lt = this.element;
    lt.className = ot, lt.appendChild(nt), lt.appendChild(st), this.duration_ = Z.duration !== void 0 ? Z.duration : 250;
  }
  /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */
  handleClick_(Z, ee) {
    ee.preventDefault(), this.zoomByDelta_(Z);
  }
  /**
   * @param {number} delta Zoom delta.
   * @private
   */
  zoomByDelta_(Z) {
    const ae = this.getMap().getView();
    if (!ae)
      return;
    const ve = ae.getZoom();
    if (ve !== void 0) {
      const ye = ae.getConstrainedZoom(ve + Z);
      this.duration_ > 0 ? (ae.getAnimating() && ae.cancelAnimations(), ae.animate({
        zoom: ye,
        duration: this.duration_,
        easing: easeOut
      })) : ae.setZoom(ye);
    }
  }
}
const Zoom$1 = Zoom;
function defaults$2(ie) {
  ie = ie || {};
  const Z = new Collection();
  return (ie.zoom !== void 0 ? ie.zoom : !0) && Z.push(new Zoom$1(ie.zoomOptions)), (ie.rotate !== void 0 ? ie.rotate : !0) && Z.push(new Rotate$1(ie.rotateOptions)), (ie.attribution !== void 0 ? ie.attribution : !0) && Z.push(new Attribution$1(ie.attributionOptions)), Z;
}
const InteractionProperty = {
  ACTIVE: "active"
};
class Interaction extends BaseObject {
  /**
   * @param {InteractionOptions} [options] Options.
   */
  constructor(Z) {
    super(), this.on, this.once, this.un, Z && Z.handleEvent && (this.handleEvent = Z.handleEvent), this.map_ = null, this.setActive(!0);
  }
  /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */
  getActive() {
    return (
      /** @type {boolean} */
      this.get(InteractionProperty.ACTIVE)
    );
  }
  /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */
  getMap() {
    return this.map_;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */
  handleEvent(Z) {
    return !0;
  }
  /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */
  setActive(Z) {
    this.set(InteractionProperty.ACTIVE, Z);
  }
  /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */
  setMap(Z) {
    this.map_ = Z;
  }
}
function pan(ie, Z, ee) {
  const ae = ie.getCenterInternal();
  if (ae) {
    const ve = [ae[0] + Z[0], ae[1] + Z[1]];
    ie.animateInternal({
      duration: ee !== void 0 ? ee : 250,
      easing: linear,
      center: ie.getConstrainedCenter(ve)
    });
  }
}
function zoomByDelta(ie, Z, ee, ae) {
  const ve = ie.getZoom();
  if (ve === void 0)
    return;
  const ye = ie.getConstrainedZoom(ve + Z), be = ie.getResolutionForZoom(ye);
  ie.getAnimating() && ie.cancelAnimations(), ie.animate({
    resolution: be,
    anchor: ee,
    duration: ae !== void 0 ? ae : 250,
    easing: easeOut
  });
}
class DoubleClickZoom extends Interaction {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    super(), Z = Z || {}, this.delta_ = Z.delta ? Z.delta : 1, this.duration_ = Z.duration !== void 0 ? Z.duration : 250;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */
  handleEvent(Z) {
    let ee = !1;
    if (Z.type == MapBrowserEventType.DBLCLICK) {
      const ae = (
        /** @type {MouseEvent} */
        Z.originalEvent
      ), ve = Z.map, ye = Z.coordinate, be = ae.shiftKey ? -this.delta_ : this.delta_, Ye = ve.getView();
      zoomByDelta(Ye, be, ye, this.duration_), ae.preventDefault(), ee = !0;
    }
    return !ee;
  }
}
const DoubleClickZoom$1 = DoubleClickZoom;
class PointerInteraction extends Interaction {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {}, super(
      /** @type {import("./Interaction.js").InteractionOptions} */
      Z
    ), Z.handleDownEvent && (this.handleDownEvent = Z.handleDownEvent), Z.handleDragEvent && (this.handleDragEvent = Z.handleDragEvent), Z.handleMoveEvent && (this.handleMoveEvent = Z.handleMoveEvent), Z.handleUpEvent && (this.handleUpEvent = Z.handleUpEvent), Z.stopDown && (this.stopDown = Z.stopDown), this.handlingDownUpSequence = !1, this.targetPointers = [];
  }
  /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */
  getPointerCount() {
    return this.targetPointers.length;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */
  handleDownEvent(Z) {
    return !1;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */
  handleDragEvent(Z) {
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */
  handleEvent(Z) {
    if (!Z.originalEvent)
      return !0;
    let ee = !1;
    if (this.updateTrackedPointers_(Z), this.handlingDownUpSequence) {
      if (Z.type == MapBrowserEventType.POINTERDRAG)
        this.handleDragEvent(Z), Z.originalEvent.preventDefault();
      else if (Z.type == MapBrowserEventType.POINTERUP) {
        const ae = this.handleUpEvent(Z);
        this.handlingDownUpSequence = ae && this.targetPointers.length > 0;
      }
    } else if (Z.type == MapBrowserEventType.POINTERDOWN) {
      const ae = this.handleDownEvent(Z);
      this.handlingDownUpSequence = ae, ee = this.stopDown(ae);
    } else
      Z.type == MapBrowserEventType.POINTERMOVE && this.handleMoveEvent(Z);
    return !ee;
  }
  /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */
  handleMoveEvent(Z) {
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */
  handleUpEvent(Z) {
    return !1;
  }
  /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */
  stopDown(Z) {
    return Z;
  }
  /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */
  updateTrackedPointers_(Z) {
    Z.activePointers && (this.targetPointers = Z.activePointers);
  }
}
function centroid(ie) {
  const Z = ie.length;
  let ee = 0, ae = 0;
  for (let ve = 0; ve < Z; ve++)
    ee += ie[ve].clientX, ae += ie[ve].clientY;
  return { clientX: ee / Z, clientY: ae / Z };
}
function all(ie) {
  const Z = arguments;
  return function(ee) {
    let ae = !0;
    for (let ve = 0, ye = Z.length; ve < ye && (ae = ae && Z[ve](ee), !!ae); ++ve)
      ;
    return ae;
  };
}
const altShiftKeysOnly = function(ie) {
  const Z = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    ie.originalEvent
  );
  return Z.altKey && !(Z.metaKey || Z.ctrlKey) && Z.shiftKey;
}, focus = function(ie) {
  const Z = ie.map.getTargetElement(), ee = ie.map.getOwnerDocument().activeElement;
  return Z.contains(ee);
}, focusWithTabindex = function(ie) {
  return ie.map.getTargetElement().hasAttribute("tabindex") ? focus(ie) : !0;
}, always = TRUE, mouseActionButton = function(ie) {
  const Z = (
    /** @type {MouseEvent} */
    ie.originalEvent
  );
  return Z.button == 0 && !(WEBKIT && MAC && Z.ctrlKey);
}, noModifierKeys = function(ie) {
  const Z = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    ie.originalEvent
  );
  return !Z.altKey && !(Z.metaKey || Z.ctrlKey) && !Z.shiftKey;
}, platformModifierKey = function(ie) {
  const Z = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    ie.originalEvent
  );
  return MAC ? Z.metaKey : Z.ctrlKey;
}, shiftKeyOnly = function(ie) {
  const Z = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    ie.originalEvent
  );
  return !Z.altKey && !(Z.metaKey || Z.ctrlKey) && Z.shiftKey;
}, targetNotEditable = function(ie) {
  const Z = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    ie.originalEvent
  ), ee = (
    /** @type {Element} */
    Z.target.tagName
  );
  return ee !== "INPUT" && ee !== "SELECT" && ee !== "TEXTAREA" && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
  // different type like `SVGElement`.
  // @ts-ignore
  !Z.target.isContentEditable;
}, mouseOnly = function(ie) {
  const Z = (
    /** @type {import("../MapBrowserEvent").default} */
    ie.originalEvent
  );
  return assert(
    Z !== void 0,
    "mapBrowserEvent must originate from a pointer event"
  ), Z.pointerType == "mouse";
}, primaryAction = function(ie) {
  const Z = (
    /** @type {import("../MapBrowserEvent").default} */
    ie.originalEvent
  );
  return assert(
    Z !== void 0,
    "mapBrowserEvent must originate from a pointer event"
  ), Z.isPrimary && Z.button === 0;
};
class DragPan extends PointerInteraction {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    super({
      stopDown: FALSE
    }), Z = Z || {}, this.kinetic_ = Z.kinetic, this.lastCentroid = null, this.lastPointersCount_, this.panning_ = !1;
    const ee = Z.condition ? Z.condition : all(noModifierKeys, primaryAction);
    this.condition_ = Z.onFocusOnly ? all(focusWithTabindex, ee) : ee, this.noKinetic_ = !1;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */
  handleDragEvent(Z) {
    const ee = Z.map;
    this.panning_ || (this.panning_ = !0, ee.getView().beginInteraction());
    const ae = this.targetPointers, ve = ee.getEventPixel(centroid(ae));
    if (ae.length == this.lastPointersCount_) {
      if (this.kinetic_ && this.kinetic_.update(ve[0], ve[1]), this.lastCentroid) {
        const ye = [
          this.lastCentroid[0] - ve[0],
          ve[1] - this.lastCentroid[1]
        ], Ye = Z.map.getView();
        scale$2(ye, Ye.getResolution()), rotate$2(ye, Ye.getRotation()), Ye.adjustCenterInternal(ye);
      }
    } else
      this.kinetic_ && this.kinetic_.begin();
    this.lastCentroid = ve, this.lastPointersCount_ = ae.length, Z.originalEvent.preventDefault();
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */
  handleUpEvent(Z) {
    const ee = Z.map, ae = ee.getView();
    if (this.targetPointers.length === 0) {
      if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
        const ve = this.kinetic_.getDistance(), ye = this.kinetic_.getAngle(), be = ae.getCenterInternal(), Ye = ee.getPixelFromCoordinateInternal(be), Qe = ee.getCoordinateFromPixelInternal([
          Ye[0] - ve * Math.cos(ye),
          Ye[1] - ve * Math.sin(ye)
        ]);
        ae.animateInternal({
          center: ae.getConstrainedCenter(Qe),
          duration: 500,
          easing: easeOut
        });
      }
      return this.panning_ && (this.panning_ = !1, ae.endInteraction()), !1;
    }
    return this.kinetic_ && this.kinetic_.begin(), this.lastCentroid = null, !0;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */
  handleDownEvent(Z) {
    if (this.targetPointers.length > 0 && this.condition_(Z)) {
      const ae = Z.map.getView();
      return this.lastCentroid = null, ae.getAnimating() && ae.cancelAnimations(), this.kinetic_ && this.kinetic_.begin(), this.noKinetic_ = this.targetPointers.length > 1, !0;
    }
    return !1;
  }
}
const DragPan$1 = DragPan;
class DragRotate extends PointerInteraction {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {}, super({
      stopDown: FALSE
    }), this.condition_ = Z.condition ? Z.condition : altShiftKeysOnly, this.lastAngle_ = void 0, this.duration_ = Z.duration !== void 0 ? Z.duration : 250;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */
  handleDragEvent(Z) {
    if (!mouseOnly(Z))
      return;
    const ee = Z.map, ae = ee.getView();
    if (ae.getConstraints().rotation === disable)
      return;
    const ve = ee.getSize(), ye = Z.pixel, be = Math.atan2(ve[1] / 2 - ye[1], ye[0] - ve[0] / 2);
    if (this.lastAngle_ !== void 0) {
      const Ye = be - this.lastAngle_;
      ae.adjustRotationInternal(-Ye);
    }
    this.lastAngle_ = be;
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */
  handleUpEvent(Z) {
    return mouseOnly(Z) ? (Z.map.getView().endInteraction(this.duration_), !1) : !0;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */
  handleDownEvent(Z) {
    return mouseOnly(Z) && mouseActionButton(Z) && this.condition_(Z) ? (Z.map.getView().beginInteraction(), this.lastAngle_ = void 0, !0) : !1;
  }
}
class RenderBox extends Disposable {
  /**
   * @param {string} className CSS class name.
   */
  constructor(Z) {
    super(), this.geometry_ = null, this.element_ = document.createElement("div"), this.element_.style.position = "absolute", this.element_.style.pointerEvents = "auto", this.element_.className = "ol-box " + Z, this.map_ = null, this.startPixel_ = null, this.endPixel_ = null;
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    this.setMap(null);
  }
  /**
   * @private
   */
  render_() {
    const Z = this.startPixel_, ee = this.endPixel_, ae = "px", ve = this.element_.style;
    ve.left = Math.min(Z[0], ee[0]) + ae, ve.top = Math.min(Z[1], ee[1]) + ae, ve.width = Math.abs(ee[0] - Z[0]) + ae, ve.height = Math.abs(ee[1] - Z[1]) + ae;
  }
  /**
   * @param {import("../Map.js").default|null} map Map.
   */
  setMap(Z) {
    if (this.map_) {
      this.map_.getOverlayContainer().removeChild(this.element_);
      const ee = this.element_.style;
      ee.left = "inherit", ee.top = "inherit", ee.width = "inherit", ee.height = "inherit";
    }
    this.map_ = Z, this.map_ && this.map_.getOverlayContainer().appendChild(this.element_);
  }
  /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */
  setPixels(Z, ee) {
    this.startPixel_ = Z, this.endPixel_ = ee, this.createOrUpdateGeometry(), this.render_();
  }
  /**
   * Creates or updates the cached geometry.
   */
  createOrUpdateGeometry() {
    const Z = this.startPixel_, ee = this.endPixel_, ve = [
      Z,
      [Z[0], ee[1]],
      ee,
      [ee[0], Z[1]]
    ].map(
      this.map_.getCoordinateFromPixelInternal,
      this.map_
    );
    ve[4] = ve[0].slice(), this.geometry_ ? this.geometry_.setCoordinates([ve]) : this.geometry_ = new Polygon$1([ve]);
  }
  /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */
  getGeometry() {
    return this.geometry_;
  }
}
const DragBoxEventType = {
  /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */
  BOXSTART: "boxstart",
  /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */
  BOXDRAG: "boxdrag",
  /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */
  BOXEND: "boxend",
  /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */
  BOXCANCEL: "boxcancel"
};
class DragBoxEvent extends BaseEvent {
  /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */
  constructor(Z, ee, ae) {
    super(Z), this.coordinate = ee, this.mapBrowserEvent = ae;
  }
}
class DragBox extends PointerInteraction {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    super(), this.on, this.once, this.un, Z = Z || {}, this.box_ = new RenderBox(Z.className || "ol-dragbox"), this.minArea_ = Z.minArea !== void 0 ? Z.minArea : 64, Z.onBoxEnd && (this.onBoxEnd = Z.onBoxEnd), this.startPixel_ = null, this.condition_ = Z.condition ? Z.condition : mouseActionButton, this.boxEndCondition_ = Z.boxEndCondition ? Z.boxEndCondition : this.defaultBoxEndCondition;
  }
  /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */
  defaultBoxEndCondition(Z, ee, ae) {
    const ve = ae[0] - ee[0], ye = ae[1] - ee[1];
    return ve * ve + ye * ye >= this.minArea_;
  }
  /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */
  getGeometry() {
    return this.box_.getGeometry();
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */
  handleDragEvent(Z) {
    this.box_.setPixels(this.startPixel_, Z.pixel), this.dispatchEvent(
      new DragBoxEvent(
        DragBoxEventType.BOXDRAG,
        Z.coordinate,
        Z
      )
    );
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */
  handleUpEvent(Z) {
    this.box_.setMap(null);
    const ee = this.boxEndCondition_(
      Z,
      this.startPixel_,
      Z.pixel
    );
    return ee && this.onBoxEnd(Z), this.dispatchEvent(
      new DragBoxEvent(
        ee ? DragBoxEventType.BOXEND : DragBoxEventType.BOXCANCEL,
        Z.coordinate,
        Z
      )
    ), !1;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */
  handleDownEvent(Z) {
    return this.condition_(Z) ? (this.startPixel_ = Z.pixel, this.box_.setMap(Z.map), this.box_.setPixels(this.startPixel_, this.startPixel_), this.dispatchEvent(
      new DragBoxEvent(
        DragBoxEventType.BOXSTART,
        Z.coordinate,
        Z
      )
    ), !0) : !1;
  }
  /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */
  onBoxEnd(Z) {
  }
}
class DragZoom extends DragBox {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {};
    const ee = Z.condition ? Z.condition : shiftKeyOnly;
    super({
      condition: ee,
      className: Z.className || "ol-dragzoom",
      minArea: Z.minArea
    }), this.duration_ = Z.duration !== void 0 ? Z.duration : 200, this.out_ = Z.out !== void 0 ? Z.out : !1;
  }
  /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */
  onBoxEnd(Z) {
    const ae = (
      /** @type {!import("../View.js").default} */
      this.getMap().getView()
    );
    let ve = this.getGeometry();
    if (this.out_) {
      const ye = ae.rotatedExtentForGeometry(ve), be = ae.getResolutionForExtentInternal(ye), Ye = ae.getResolution() / be;
      ve = ve.clone(), ve.scale(Ye * Ye);
    }
    ae.fitInternal(ve, {
      duration: this.duration_,
      easing: easeOut
    });
  }
}
const DragZoom$1 = DragZoom, Key = {
  LEFT: "ArrowLeft",
  UP: "ArrowUp",
  RIGHT: "ArrowRight",
  DOWN: "ArrowDown"
};
class KeyboardPan extends Interaction {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    super(), Z = Z || {}, this.defaultCondition_ = function(ee) {
      return noModifierKeys(ee) && targetNotEditable(ee);
    }, this.condition_ = Z.condition !== void 0 ? Z.condition : this.defaultCondition_, this.duration_ = Z.duration !== void 0 ? Z.duration : 100, this.pixelDelta_ = Z.pixelDelta !== void 0 ? Z.pixelDelta : 128;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */
  handleEvent(Z) {
    let ee = !1;
    if (Z.type == EventType.KEYDOWN) {
      const ae = (
        /** @type {KeyboardEvent} */
        Z.originalEvent
      ), ve = ae.key;
      if (this.condition_(Z) && (ve == Key.DOWN || ve == Key.LEFT || ve == Key.RIGHT || ve == Key.UP)) {
        const be = Z.map.getView(), Ye = be.getResolution() * this.pixelDelta_;
        let Qe = 0, Je = 0;
        ve == Key.DOWN ? Je = -Ye : ve == Key.LEFT ? Qe = -Ye : ve == Key.RIGHT ? Qe = Ye : Je = Ye;
        const nt = [Qe, Je];
        rotate$2(nt, be.getRotation()), pan(be, nt, this.duration_), ae.preventDefault(), ee = !0;
      }
    }
    return !ee;
  }
}
class KeyboardZoom extends Interaction {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    super(), Z = Z || {}, this.condition_ = Z.condition ? Z.condition : function(ee) {
      return !platformModifierKey(ee) && targetNotEditable(ee);
    }, this.delta_ = Z.delta ? Z.delta : 1, this.duration_ = Z.duration !== void 0 ? Z.duration : 100;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */
  handleEvent(Z) {
    let ee = !1;
    if (Z.type == EventType.KEYDOWN || Z.type == EventType.KEYPRESS) {
      const ae = (
        /** @type {KeyboardEvent} */
        Z.originalEvent
      ), ve = ae.key;
      if (this.condition_(Z) && (ve === "+" || ve === "-")) {
        const ye = Z.map, be = ve === "+" ? this.delta_ : -this.delta_, Ye = ye.getView();
        zoomByDelta(Ye, be, void 0, this.duration_), ae.preventDefault(), ee = !0;
      }
    }
    return !ee;
  }
}
const KeyboardZoom$1 = KeyboardZoom;
class MouseWheelZoom extends Interaction {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {}, super(
      /** @type {import("./Interaction.js").InteractionOptions} */
      Z
    ), this.totalDelta_ = 0, this.lastDelta_ = 0, this.maxDelta_ = Z.maxDelta !== void 0 ? Z.maxDelta : 1, this.duration_ = Z.duration !== void 0 ? Z.duration : 250, this.timeout_ = Z.timeout !== void 0 ? Z.timeout : 80, this.useAnchor_ = Z.useAnchor !== void 0 ? Z.useAnchor : !0, this.constrainResolution_ = Z.constrainResolution !== void 0 ? Z.constrainResolution : !1;
    const ee = Z.condition ? Z.condition : always;
    this.condition_ = Z.onFocusOnly ? all(focusWithTabindex, ee) : ee, this.lastAnchor_ = null, this.startTime_ = void 0, this.timeoutId_, this.mode_ = void 0, this.trackpadEventGap_ = 400, this.trackpadTimeoutId_, this.deltaPerZoom_ = 300;
  }
  /**
   * @private
   */
  endInteraction_() {
    this.trackpadTimeoutId_ = void 0;
    const Z = this.getMap();
    if (!Z)
      return;
    Z.getView().endInteraction(
      void 0,
      this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0,
      this.lastAnchor_
    );
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */
  handleEvent(Z) {
    if (!this.condition_(Z) || Z.type !== EventType.WHEEL)
      return !0;
    const ae = Z.map, ve = (
      /** @type {WheelEvent} */
      Z.originalEvent
    );
    ve.preventDefault(), this.useAnchor_ && (this.lastAnchor_ = Z.coordinate);
    let ye;
    if (Z.type == EventType.WHEEL && (ye = ve.deltaY, FIREFOX && ve.deltaMode === WheelEvent.DOM_DELTA_PIXEL && (ye /= DEVICE_PIXEL_RATIO), ve.deltaMode === WheelEvent.DOM_DELTA_LINE && (ye *= 40)), ye === 0)
      return !1;
    this.lastDelta_ = ye;
    const be = Date.now();
    this.startTime_ === void 0 && (this.startTime_ = be), (!this.mode_ || be - this.startTime_ > this.trackpadEventGap_) && (this.mode_ = Math.abs(ye) < 4 ? "trackpad" : "wheel");
    const Ye = ae.getView();
    if (this.mode_ === "trackpad" && !(Ye.getConstrainResolution() || this.constrainResolution_))
      return this.trackpadTimeoutId_ ? clearTimeout(this.trackpadTimeoutId_) : (Ye.getAnimating() && Ye.cancelAnimations(), Ye.beginInteraction()), this.trackpadTimeoutId_ = setTimeout(
        this.endInteraction_.bind(this),
        this.timeout_
      ), Ye.adjustZoom(-ye / this.deltaPerZoom_, this.lastAnchor_), this.startTime_ = be, !1;
    this.totalDelta_ += ye;
    const Qe = Math.max(this.timeout_ - (be - this.startTime_), 0);
    return clearTimeout(this.timeoutId_), this.timeoutId_ = setTimeout(
      this.handleWheelZoom_.bind(this, ae),
      Qe
    ), !1;
  }
  /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */
  handleWheelZoom_(Z) {
    const ee = Z.getView();
    ee.getAnimating() && ee.cancelAnimations();
    let ae = -clamp$1(
      this.totalDelta_,
      -this.maxDelta_ * this.deltaPerZoom_,
      this.maxDelta_ * this.deltaPerZoom_
    ) / this.deltaPerZoom_;
    (ee.getConstrainResolution() || this.constrainResolution_) && (ae = ae ? ae > 0 ? 1 : -1 : 0), zoomByDelta(ee, ae, this.lastAnchor_, this.duration_), this.mode_ = void 0, this.totalDelta_ = 0, this.lastAnchor_ = null, this.startTime_ = void 0, this.timeoutId_ = void 0;
  }
  /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */
  setMouseAnchor(Z) {
    this.useAnchor_ = Z, Z || (this.lastAnchor_ = null);
  }
}
const MouseWheelZoom$1 = MouseWheelZoom;
class PinchRotate extends PointerInteraction {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {};
    const ee = (
      /** @type {import("./Pointer.js").Options} */
      Z
    );
    ee.stopDown || (ee.stopDown = FALSE), super(ee), this.anchor_ = null, this.lastAngle_ = void 0, this.rotating_ = !1, this.rotationDelta_ = 0, this.threshold_ = Z.threshold !== void 0 ? Z.threshold : 0.3, this.duration_ = Z.duration !== void 0 ? Z.duration : 250;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */
  handleDragEvent(Z) {
    let ee = 0;
    const ae = this.targetPointers[0], ve = this.targetPointers[1], ye = Math.atan2(
      ve.clientY - ae.clientY,
      ve.clientX - ae.clientX
    );
    if (this.lastAngle_ !== void 0) {
      const Qe = ye - this.lastAngle_;
      this.rotationDelta_ += Qe, !this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_ && (this.rotating_ = !0), ee = Qe;
    }
    this.lastAngle_ = ye;
    const be = Z.map, Ye = be.getView();
    Ye.getConstraints().rotation !== disable && (this.anchor_ = be.getCoordinateFromPixelInternal(
      be.getEventPixel(centroid(this.targetPointers))
    ), this.rotating_ && (be.render(), Ye.adjustRotationInternal(ee, this.anchor_)));
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */
  handleUpEvent(Z) {
    return this.targetPointers.length < 2 ? (Z.map.getView().endInteraction(this.duration_), !1) : !0;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */
  handleDownEvent(Z) {
    if (this.targetPointers.length >= 2) {
      const ee = Z.map;
      return this.anchor_ = null, this.lastAngle_ = void 0, this.rotating_ = !1, this.rotationDelta_ = 0, this.handlingDownUpSequence || ee.getView().beginInteraction(), !0;
    }
    return !1;
  }
}
class PinchZoom extends PointerInteraction {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {};
    const ee = (
      /** @type {import("./Pointer.js").Options} */
      Z
    );
    ee.stopDown || (ee.stopDown = FALSE), super(ee), this.anchor_ = null, this.duration_ = Z.duration !== void 0 ? Z.duration : 400, this.lastDistance_ = void 0, this.lastScaleDelta_ = 1;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */
  handleDragEvent(Z) {
    let ee = 1;
    const ae = this.targetPointers[0], ve = this.targetPointers[1], ye = ae.clientX - ve.clientX, be = ae.clientY - ve.clientY, Ye = Math.sqrt(ye * ye + be * be);
    this.lastDistance_ !== void 0 && (ee = this.lastDistance_ / Ye), this.lastDistance_ = Ye;
    const Qe = Z.map, Je = Qe.getView();
    ee != 1 && (this.lastScaleDelta_ = ee), this.anchor_ = Qe.getCoordinateFromPixelInternal(
      Qe.getEventPixel(centroid(this.targetPointers))
    ), Qe.render(), Je.adjustResolutionInternal(ee, this.anchor_);
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */
  handleUpEvent(Z) {
    if (this.targetPointers.length < 2) {
      const ae = Z.map.getView(), ve = this.lastScaleDelta_ > 1 ? 1 : -1;
      return ae.endInteraction(this.duration_, ve), !1;
    }
    return !0;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */
  handleDownEvent(Z) {
    if (this.targetPointers.length >= 2) {
      const ee = Z.map;
      return this.anchor_ = null, this.lastDistance_ = void 0, this.lastScaleDelta_ = 1, this.handlingDownUpSequence || ee.getView().beginInteraction(), !0;
    }
    return !1;
  }
}
const PinchZoom$1 = PinchZoom;
function defaults$1(ie) {
  ie = ie || {};
  const Z = new Collection(), ee = new Kinetic(-5e-3, 0.05, 100);
  return (ie.altShiftDragRotate !== void 0 ? ie.altShiftDragRotate : !0) && Z.push(new DragRotate()), (ie.doubleClickZoom !== void 0 ? ie.doubleClickZoom : !0) && Z.push(
    new DoubleClickZoom$1({
      delta: ie.zoomDelta,
      duration: ie.zoomDuration
    })
  ), (ie.dragPan !== void 0 ? ie.dragPan : !0) && Z.push(
    new DragPan$1({
      onFocusOnly: ie.onFocusOnly,
      kinetic: ee
    })
  ), (ie.pinchRotate !== void 0 ? ie.pinchRotate : !0) && Z.push(new PinchRotate()), (ie.pinchZoom !== void 0 ? ie.pinchZoom : !0) && Z.push(
    new PinchZoom$1({
      duration: ie.zoomDuration
    })
  ), (ie.keyboard !== void 0 ? ie.keyboard : !0) && (Z.push(new KeyboardPan()), Z.push(
    new KeyboardZoom$1({
      delta: ie.zoomDelta,
      duration: ie.zoomDuration
    })
  )), (ie.mouseWheelZoom !== void 0 ? ie.mouseWheelZoom : !0) && Z.push(
    new MouseWheelZoom$1({
      onFocusOnly: ie.onFocusOnly,
      duration: ie.zoomDuration
    })
  ), (ie.shiftDragZoom !== void 0 ? ie.shiftDragZoom : !0) && Z.push(
    new DragZoom$1({
      duration: ie.zoomDuration
    })
  ), Z;
}
function removeLayerMapProperty(ie) {
  if (ie instanceof Layer) {
    ie.setMapInternal(null);
    return;
  }
  ie instanceof LayerGroup && ie.getLayers().forEach(removeLayerMapProperty);
}
function setLayerMapProperty(ie, Z) {
  if (ie instanceof Layer) {
    ie.setMapInternal(Z);
    return;
  }
  if (ie instanceof LayerGroup) {
    const ee = ie.getLayers().getArray();
    for (let ae = 0, ve = ee.length; ae < ve; ++ae)
      setLayerMapProperty(ee[ae], Z);
  }
}
let Map$1 = class extends BaseObject {
  /**
   * @param {MapOptions} [options] Map options.
   */
  constructor(Z) {
    super(), Z = Z || {}, this.on, this.once, this.un;
    const ee = createOptionsInternal(Z);
    this.renderComplete_, this.loaded_ = !0, this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this), this.maxTilesLoading_ = Z.maxTilesLoading !== void 0 ? Z.maxTilesLoading : 16, this.pixelRatio_ = Z.pixelRatio !== void 0 ? Z.pixelRatio : DEVICE_PIXEL_RATIO, this.postRenderTimeoutHandle_, this.animationDelayKey_, this.animationDelay_ = this.animationDelay_.bind(this), this.coordinateToPixelTransform_ = create$2(), this.pixelToCoordinateTransform_ = create$2(), this.frameIndex_ = 0, this.frameState_ = null, this.previousExtent_ = null, this.viewPropertyListenerKey_ = null, this.viewChangeListenerKey_ = null, this.layerGroupPropertyListenerKeys_ = null, this.viewport_ = document.createElement("div"), this.viewport_.className = "ol-viewport" + ("ontouchstart" in window ? " ol-touch" : ""), this.viewport_.style.position = "relative", this.viewport_.style.overflow = "hidden", this.viewport_.style.width = "100%", this.viewport_.style.height = "100%", this.overlayContainer_ = document.createElement("div"), this.overlayContainer_.style.position = "absolute", this.overlayContainer_.style.zIndex = "0", this.overlayContainer_.style.width = "100%", this.overlayContainer_.style.height = "100%", this.overlayContainer_.style.pointerEvents = "none", this.overlayContainer_.className = "ol-overlaycontainer", this.viewport_.appendChild(this.overlayContainer_), this.overlayContainerStopEvent_ = document.createElement("div"), this.overlayContainerStopEvent_.style.position = "absolute", this.overlayContainerStopEvent_.style.zIndex = "0", this.overlayContainerStopEvent_.style.width = "100%", this.overlayContainerStopEvent_.style.height = "100%", this.overlayContainerStopEvent_.style.pointerEvents = "none", this.overlayContainerStopEvent_.className = "ol-overlaycontainer-stopevent", this.viewport_.appendChild(this.overlayContainerStopEvent_), this.mapBrowserEventHandler_ = null, this.moveTolerance_ = Z.moveTolerance, this.keyboardEventTarget_ = ee.keyboardEventTarget, this.targetChangeHandlerKeys_ = null, this.targetElement_ = null, this.resizeObserver_ = new ResizeObserver(() => this.updateSize()), this.controls = ee.controls || defaults$2(), this.interactions = ee.interactions || defaults$1({
      onFocusOnly: !0
    }), this.overlays_ = ee.overlays, this.overlayIdIndex_ = {}, this.renderer_ = null, this.postRenderFunctions_ = [], this.tileQueue_ = new TileQueue(
      this.getTilePriority.bind(this),
      this.handleTileChange_.bind(this)
    ), this.addChangeListener(
      MapProperty.LAYERGROUP,
      this.handleLayerGroupChanged_
    ), this.addChangeListener(MapProperty.VIEW, this.handleViewChanged_), this.addChangeListener(MapProperty.SIZE, this.handleSizeChanged_), this.addChangeListener(MapProperty.TARGET, this.handleTargetChanged_), this.setProperties(ee.values);
    const ae = this;
    Z.view && !(Z.view instanceof View) && Z.view.then(function(ve) {
      ae.setView(new View(ve));
    }), this.controls.addEventListener(
      CollectionEventType.ADD,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */
      (ve) => {
        ve.element.setMap(this);
      }
    ), this.controls.addEventListener(
      CollectionEventType.REMOVE,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */
      (ve) => {
        ve.element.setMap(null);
      }
    ), this.interactions.addEventListener(
      CollectionEventType.ADD,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */
      (ve) => {
        ve.element.setMap(this);
      }
    ), this.interactions.addEventListener(
      CollectionEventType.REMOVE,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */
      (ve) => {
        ve.element.setMap(null);
      }
    ), this.overlays_.addEventListener(
      CollectionEventType.ADD,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */
      (ve) => {
        this.addOverlayInternal_(ve.element);
      }
    ), this.overlays_.addEventListener(
      CollectionEventType.REMOVE,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */
      (ve) => {
        const ye = ve.element.getId();
        ye !== void 0 && delete this.overlayIdIndex_[ye.toString()], ve.element.setMap(null);
      }
    ), this.controls.forEach(
      /**
       * @param {import("./control/Control.js").default} control Control.
       */
      (ve) => {
        ve.setMap(this);
      }
    ), this.interactions.forEach(
      /**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */
      (ve) => {
        ve.setMap(this);
      }
    ), this.overlays_.forEach(this.addOverlayInternal_.bind(this));
  }
  /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */
  addControl(Z) {
    this.getControls().push(Z);
  }
  /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */
  addInteraction(Z) {
    this.getInteractions().push(Z);
  }
  /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */
  addLayer(Z) {
    this.getLayerGroup().getLayers().push(Z);
  }
  /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */
  handleLayerAdd_(Z) {
    setLayerMapProperty(Z.layer, this);
  }
  /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */
  addOverlay(Z) {
    this.getOverlays().push(Z);
  }
  /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */
  addOverlayInternal_(Z) {
    const ee = Z.getId();
    ee !== void 0 && (this.overlayIdIndex_[ee.toString()] = Z), Z.setMap(this);
  }
  /**
   *
   * Clean up.
   */
  disposeInternal() {
    this.controls.clear(), this.interactions.clear(), this.overlays_.clear(), this.resizeObserver_.disconnect(), this.setTarget(null), super.disposeInternal();
  }
  /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */
  forEachFeatureAtPixel(Z, ee, ae) {
    if (!this.frameState_ || !this.renderer_)
      return;
    const ve = this.getCoordinateFromPixelInternal(Z);
    ae = ae !== void 0 ? ae : {};
    const ye = ae.hitTolerance !== void 0 ? ae.hitTolerance : 0, be = ae.layerFilter !== void 0 ? ae.layerFilter : TRUE, Ye = ae.checkWrapped !== !1;
    return this.renderer_.forEachFeatureAtCoordinate(
      ve,
      this.frameState_,
      ye,
      Ye,
      ee,
      null,
      be,
      null
    );
  }
  /**
   * Get all features that intersect a pixel on the viewport.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */
  getFeaturesAtPixel(Z, ee) {
    const ae = [];
    return this.forEachFeatureAtPixel(
      Z,
      function(ve) {
        ae.push(ve);
      },
      ee
    ), ae;
  }
  /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */
  getAllLayers() {
    const Z = [];
    function ee(ae) {
      ae.forEach(function(ve) {
        ve instanceof LayerGroup ? ee(ve.getLayers()) : Z.push(ve);
      });
    }
    return ee(this.getLayers()), Z;
  }
  /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */
  hasFeatureAtPixel(Z, ee) {
    if (!this.frameState_ || !this.renderer_)
      return !1;
    const ae = this.getCoordinateFromPixelInternal(Z);
    ee = ee !== void 0 ? ee : {};
    const ve = ee.layerFilter !== void 0 ? ee.layerFilter : TRUE, ye = ee.hitTolerance !== void 0 ? ee.hitTolerance : 0, be = ee.checkWrapped !== !1;
    return this.renderer_.hasFeatureAtCoordinate(
      ae,
      this.frameState_,
      ye,
      be,
      ve,
      null
    );
  }
  /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */
  getEventCoordinate(Z) {
    return this.getCoordinateFromPixel(this.getEventPixel(Z));
  }
  /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */
  getEventCoordinateInternal(Z) {
    return this.getCoordinateFromPixelInternal(this.getEventPixel(Z));
  }
  /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */
  getEventPixel(Z) {
    const ae = this.viewport_.getBoundingClientRect(), ve = this.getSize(), ye = ae.width / ve[0], be = ae.height / ve[1], Ye = (
      //FIXME Are we really calling this with a TouchEvent anywhere?
      "changedTouches" in Z ? (
        /** @type {TouchEvent} */
        Z.changedTouches[0]
      ) : (
        /** @type {MouseEvent} */
        Z
      )
    );
    return [
      (Ye.clientX - ae.left) / ye,
      (Ye.clientY - ae.top) / be
    ];
  }
  /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */
  getTarget() {
    return (
      /** @type {HTMLElement|string|undefined} */
      this.get(MapProperty.TARGET)
    );
  }
  /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */
  getTargetElement() {
    return this.targetElement_;
  }
  /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */
  getCoordinateFromPixel(Z) {
    return toUserCoordinate(
      this.getCoordinateFromPixelInternal(Z),
      this.getView().getProjection()
    );
  }
  /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */
  getCoordinateFromPixelInternal(Z) {
    const ee = this.frameState_;
    return ee ? apply(ee.pixelToCoordinateTransform, Z.slice()) : null;
  }
  /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */
  getControls() {
    return this.controls;
  }
  /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */
  getOverlays() {
    return this.overlays_;
  }
  /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default} Overlay.
   * @api
   */
  getOverlayById(Z) {
    const ee = this.overlayIdIndex_[Z.toString()];
    return ee !== void 0 ? ee : null;
  }
  /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */
  getInteractions() {
    return this.interactions;
  }
  /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */
  getLayerGroup() {
    return (
      /** @type {LayerGroup} */
      this.get(MapProperty.LAYERGROUP)
    );
  }
  /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */
  setLayers(Z) {
    const ee = this.getLayerGroup();
    if (Z instanceof Collection) {
      ee.setLayers(Z);
      return;
    }
    const ae = ee.getLayers();
    ae.clear(), ae.extend(Z);
  }
  /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */
  getLayers() {
    return this.getLayerGroup().getLayers();
  }
  /**
   * @return {boolean} Layers have sources that are still loading.
   */
  getLoadingOrNotReady() {
    const Z = this.getLayerGroup().getLayerStatesArray();
    for (let ee = 0, ae = Z.length; ee < ae; ++ee) {
      const ve = Z[ee];
      if (!ve.visible)
        continue;
      const ye = ve.layer.getRenderer();
      if (ye && !ye.ready)
        return !0;
      const be = ve.layer.getSource();
      if (be && be.loading)
        return !0;
    }
    return !1;
  }
  /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */
  getPixelFromCoordinate(Z) {
    const ee = fromUserCoordinate(
      Z,
      this.getView().getProjection()
    );
    return this.getPixelFromCoordinateInternal(ee);
  }
  /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */
  getPixelFromCoordinateInternal(Z) {
    const ee = this.frameState_;
    return ee ? apply(
      ee.coordinateToPixelTransform,
      Z.slice(0, 2)
    ) : null;
  }
  /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */
  getRenderer() {
    return this.renderer_;
  }
  /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */
  getSize() {
    return (
      /** @type {import("./size.js").Size|undefined} */
      this.get(MapProperty.SIZE)
    );
  }
  /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */
  getView() {
    return (
      /** @type {View} */
      this.get(MapProperty.VIEW)
    );
  }
  /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */
  getViewport() {
    return this.viewport_;
  }
  /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */
  getOverlayContainer() {
    return this.overlayContainer_;
  }
  /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */
  getOverlayContainerStopEvent() {
    return this.overlayContainerStopEvent_;
  }
  /**
   * @return {!Document} The document where the map is displayed.
   */
  getOwnerDocument() {
    const Z = this.getTargetElement();
    return Z ? Z.ownerDocument : document;
  }
  /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */
  getTilePriority(Z, ee, ae, ve) {
    return getTilePriority(
      this.frameState_,
      Z,
      ee,
      ae,
      ve
    );
  }
  /**
   * @param {UIEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */
  handleBrowserEvent(Z, ee) {
    ee = ee || Z.type;
    const ae = new MapBrowserEvent(ee, this, Z);
    this.handleMapBrowserEvent(ae);
  }
  /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */
  handleMapBrowserEvent(Z) {
    if (!this.frameState_)
      return;
    const ee = (
      /** @type {PointerEvent} */
      Z.originalEvent
    ), ae = ee.type;
    if (ae === PointerEventType.POINTERDOWN || ae === EventType.WHEEL || ae === EventType.KEYDOWN) {
      const ve = this.getOwnerDocument(), ye = this.viewport_.getRootNode ? this.viewport_.getRootNode() : ve, be = (
        /** @type {Node} */
        ee.target
      );
      if (
        // Abort if the target is a child of the container for elements whose events are not meant
        // to be handled by map interactions.
        this.overlayContainerStopEvent_.contains(be) || // Abort if the event target is a child of the container that is no longer in the page.
        // It's possible for the target to no longer be in the page if it has been removed in an
        // event listener, this might happen in a Control that recreates it's content based on
        // user interaction either manually or via a render in something like https://reactjs.org/
        !(ye === ve ? ve.documentElement : ye).contains(be)
      )
        return;
    }
    if (Z.frameState = this.frameState_, this.dispatchEvent(Z) !== !1) {
      const ve = this.getInteractions().getArray().slice();
      for (let ye = ve.length - 1; ye >= 0; ye--) {
        const be = ve[ye];
        if (be.getMap() !== this || !be.getActive() || !this.getTargetElement())
          continue;
        if (!be.handleEvent(Z) || Z.propagationStopped)
          break;
      }
    }
  }
  /**
   * @protected
   */
  handlePostRender() {
    const Z = this.frameState_, ee = this.tileQueue_;
    if (!ee.isEmpty()) {
      let ve = this.maxTilesLoading_, ye = ve;
      if (Z) {
        const be = Z.viewHints;
        if (be[ViewHint.ANIMATING] || be[ViewHint.INTERACTING]) {
          const Ye = Date.now() - Z.time > 8;
          ve = Ye ? 0 : 8, ye = Ye ? 0 : 2;
        }
      }
      ee.getTilesLoading() < ve && (ee.reprioritize(), ee.loadMoreTiles(ve, ye));
    }
    Z && this.renderer_ && !Z.animate && (this.renderComplete_ === !0 ? (this.hasListener(RenderEventType.RENDERCOMPLETE) && this.renderer_.dispatchRenderEvent(
      RenderEventType.RENDERCOMPLETE,
      Z
    ), this.loaded_ === !1 && (this.loaded_ = !0, this.dispatchEvent(
      new MapEvent(MapEventType.LOADEND, this, Z)
    ))) : this.loaded_ === !0 && (this.loaded_ = !1, this.dispatchEvent(
      new MapEvent(MapEventType.LOADSTART, this, Z)
    )));
    const ae = this.postRenderFunctions_;
    for (let ve = 0, ye = ae.length; ve < ye; ++ve)
      ae[ve](this, Z);
    ae.length = 0;
  }
  /**
   * @private
   */
  handleSizeChanged_() {
    this.getView() && !this.getView().getAnimating() && this.getView().resolveConstraints(0), this.render();
  }
  /**
   * @private
   */
  handleTargetChanged_() {
    if (this.mapBrowserEventHandler_) {
      for (let ae = 0, ve = this.targetChangeHandlerKeys_.length; ae < ve; ++ae)
        unlistenByKey(this.targetChangeHandlerKeys_[ae]);
      this.targetChangeHandlerKeys_ = null, this.viewport_.removeEventListener(
        EventType.CONTEXTMENU,
        this.boundHandleBrowserEvent_
      ), this.viewport_.removeEventListener(
        EventType.WHEEL,
        this.boundHandleBrowserEvent_
      ), this.mapBrowserEventHandler_.dispose(), this.mapBrowserEventHandler_ = null, removeNode(this.viewport_);
    }
    if (this.targetElement_) {
      this.resizeObserver_.unobserve(this.targetElement_);
      const ae = this.targetElement_.getRootNode();
      ae instanceof ShadowRoot && this.resizeObserver_.unobserve(ae.host), this.setSize(void 0);
    }
    const Z = this.getTarget(), ee = typeof Z == "string" ? document.getElementById(Z) : Z;
    if (this.targetElement_ = ee, !ee)
      this.renderer_ && (clearTimeout(this.postRenderTimeoutHandle_), this.postRenderTimeoutHandle_ = void 0, this.postRenderFunctions_.length = 0, this.renderer_.dispose(), this.renderer_ = null), this.animationDelayKey_ && (cancelAnimationFrame(this.animationDelayKey_), this.animationDelayKey_ = void 0);
    else {
      ee.appendChild(this.viewport_), this.renderer_ || (this.renderer_ = new CompositeMapRenderer(this)), this.mapBrowserEventHandler_ = new MapBrowserEventHandler(
        this,
        this.moveTolerance_
      );
      for (const ye in MapBrowserEventType)
        this.mapBrowserEventHandler_.addEventListener(
          MapBrowserEventType[ye],
          this.handleMapBrowserEvent.bind(this)
        );
      this.viewport_.addEventListener(
        EventType.CONTEXTMENU,
        this.boundHandleBrowserEvent_,
        !1
      ), this.viewport_.addEventListener(
        EventType.WHEEL,
        this.boundHandleBrowserEvent_,
        PASSIVE_EVENT_LISTENERS ? { passive: !1 } : !1
      );
      const ae = this.keyboardEventTarget_ ? this.keyboardEventTarget_ : ee;
      this.targetChangeHandlerKeys_ = [
        listen(
          ae,
          EventType.KEYDOWN,
          this.handleBrowserEvent,
          this
        ),
        listen(
          ae,
          EventType.KEYPRESS,
          this.handleBrowserEvent,
          this
        )
      ];
      const ve = ee.getRootNode();
      ve instanceof ShadowRoot && this.resizeObserver_.observe(ve.host), this.resizeObserver_.observe(ee);
    }
    this.updateSize();
  }
  /**
   * @private
   */
  handleTileChange_() {
    this.render();
  }
  /**
   * @private
   */
  handleViewPropertyChanged_() {
    this.render();
  }
  /**
   * @private
   */
  handleViewChanged_() {
    this.viewPropertyListenerKey_ && (unlistenByKey(this.viewPropertyListenerKey_), this.viewPropertyListenerKey_ = null), this.viewChangeListenerKey_ && (unlistenByKey(this.viewChangeListenerKey_), this.viewChangeListenerKey_ = null);
    const Z = this.getView();
    Z && (this.updateViewportSize_(), this.viewPropertyListenerKey_ = listen(
      Z,
      ObjectEventType.PROPERTYCHANGE,
      this.handleViewPropertyChanged_,
      this
    ), this.viewChangeListenerKey_ = listen(
      Z,
      EventType.CHANGE,
      this.handleViewPropertyChanged_,
      this
    ), Z.resolveConstraints(0)), this.render();
  }
  /**
   * @private
   */
  handleLayerGroupChanged_() {
    this.layerGroupPropertyListenerKeys_ && (this.layerGroupPropertyListenerKeys_.forEach(unlistenByKey), this.layerGroupPropertyListenerKeys_ = null);
    const Z = this.getLayerGroup();
    Z && (this.handleLayerAdd_(new GroupEvent("addlayer", Z)), this.layerGroupPropertyListenerKeys_ = [
      listen(Z, ObjectEventType.PROPERTYCHANGE, this.render, this),
      listen(Z, EventType.CHANGE, this.render, this),
      listen(Z, "addlayer", this.handleLayerAdd_, this),
      listen(Z, "removelayer", this.handleLayerRemove_, this)
    ]), this.render();
  }
  /**
   * @return {boolean} Is rendered.
   */
  isRendered() {
    return !!this.frameState_;
  }
  /**
   * @private
   */
  animationDelay_() {
    this.animationDelayKey_ = void 0, this.renderFrame_(Date.now());
  }
  /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */
  renderSync() {
    this.animationDelayKey_ && cancelAnimationFrame(this.animationDelayKey_), this.animationDelay_();
  }
  /**
   * Redraws all text after new fonts have loaded
   */
  redrawText() {
    const Z = this.getLayerGroup().getLayerStatesArray();
    for (let ee = 0, ae = Z.length; ee < ae; ++ee) {
      const ve = Z[ee].layer;
      ve.hasRenderer() && ve.getRenderer().handleFontsChanged();
    }
  }
  /**
   * Request a map rendering (at the next animation frame).
   * @api
   */
  render() {
    this.renderer_ && this.animationDelayKey_ === void 0 && (this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_));
  }
  /**
   * This method is meant to be called in a layer's `prerender` listener. It causes all collected
   * declutter items to be decluttered and rendered on the map immediately. This is useful for
   * layers that need to appear entirely above the decluttered items of layers lower in the layer
   * stack.
   * @api
   */
  flushDeclutterItems() {
    const Z = this.frameState_;
    Z && this.renderer_.flushDeclutterItems(Z);
  }
  /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */
  removeControl(Z) {
    return this.getControls().remove(Z);
  }
  /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */
  removeInteraction(Z) {
    return this.getInteractions().remove(Z);
  }
  /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */
  removeLayer(Z) {
    return this.getLayerGroup().getLayers().remove(Z);
  }
  /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */
  handleLayerRemove_(Z) {
    removeLayerMapProperty(Z.layer);
  }
  /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */
  removeOverlay(Z) {
    return this.getOverlays().remove(Z);
  }
  /**
   * @param {number} time Time.
   * @private
   */
  renderFrame_(Z) {
    const ee = this.getSize(), ae = this.getView(), ve = this.frameState_;
    let ye = null;
    if (ee !== void 0 && hasArea(ee) && ae && ae.isDef()) {
      const be = ae.getHints(
        this.frameState_ ? this.frameState_.viewHints : void 0
      ), Ye = ae.getState();
      if (ye = {
        animate: !1,
        coordinateToPixelTransform: this.coordinateToPixelTransform_,
        declutterTree: null,
        extent: getForViewAndSize(
          Ye.center,
          Ye.resolution,
          Ye.rotation,
          ee
        ),
        index: this.frameIndex_++,
        layerIndex: 0,
        layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
        pixelRatio: this.pixelRatio_,
        pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
        postRenderFunctions: [],
        size: ee,
        tileQueue: this.tileQueue_,
        time: Z,
        usedTiles: {},
        viewState: Ye,
        viewHints: be,
        wantedTiles: {},
        mapId: getUid(this),
        renderTargets: {}
      }, Ye.nextCenter && Ye.nextResolution) {
        const Qe = isNaN(Ye.nextRotation) ? Ye.rotation : Ye.nextRotation;
        ye.nextExtent = getForViewAndSize(
          Ye.nextCenter,
          Ye.nextResolution,
          Qe,
          ee
        );
      }
    }
    this.frameState_ = ye, this.renderer_.renderFrame(ye), ye && (ye.animate && this.render(), Array.prototype.push.apply(
      this.postRenderFunctions_,
      ye.postRenderFunctions
    ), ve && (!this.previousExtent_ || !isEmpty(this.previousExtent_) && !equals$1(ye.extent, this.previousExtent_)) && (this.dispatchEvent(
      new MapEvent(MapEventType.MOVESTART, this, ve)
    ), this.previousExtent_ = createOrUpdateEmpty(this.previousExtent_)), this.previousExtent_ && !ye.viewHints[ViewHint.ANIMATING] && !ye.viewHints[ViewHint.INTERACTING] && !equals$1(ye.extent, this.previousExtent_) && (this.dispatchEvent(
      new MapEvent(MapEventType.MOVEEND, this, ye)
    ), clone(ye.extent, this.previousExtent_))), this.dispatchEvent(new MapEvent(MapEventType.POSTRENDER, this, ye)), this.renderComplete_ = this.hasListener(MapEventType.LOADSTART) || this.hasListener(MapEventType.LOADEND) || this.hasListener(RenderEventType.RENDERCOMPLETE) ? !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady() : void 0, this.postRenderTimeoutHandle_ || (this.postRenderTimeoutHandle_ = setTimeout(() => {
      this.postRenderTimeoutHandle_ = void 0, this.handlePostRender();
    }, 0));
  }
  /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */
  setLayerGroup(Z) {
    const ee = this.getLayerGroup();
    ee && this.handleLayerRemove_(new GroupEvent("removelayer", ee)), this.set(MapProperty.LAYERGROUP, Z);
  }
  /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */
  setSize(Z) {
    this.set(MapProperty.SIZE, Z);
  }
  /**
   * Set the target element to render this map into.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */
  setTarget(Z) {
    this.set(MapProperty.TARGET, Z);
  }
  /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */
  setView(Z) {
    if (!Z || Z instanceof View) {
      this.set(MapProperty.VIEW, Z);
      return;
    }
    this.set(MapProperty.VIEW, new View());
    const ee = this;
    Z.then(function(ae) {
      ee.setView(new View(ae));
    });
  }
  /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */
  updateSize() {
    const Z = this.getTargetElement();
    let ee;
    if (Z) {
      const ve = getComputedStyle(Z), ye = Z.offsetWidth - parseFloat(ve.borderLeftWidth) - parseFloat(ve.paddingLeft) - parseFloat(ve.paddingRight) - parseFloat(ve.borderRightWidth), be = Z.offsetHeight - parseFloat(ve.borderTopWidth) - parseFloat(ve.paddingTop) - parseFloat(ve.paddingBottom) - parseFloat(ve.borderBottomWidth);
      !isNaN(ye) && !isNaN(be) && (ee = [ye, be], !hasArea(ee) && (Z.offsetWidth || Z.offsetHeight || Z.getClientRects().length) && warn(
        "No map visible because the map container's width or height are 0."
      ));
    }
    const ae = this.getSize();
    ee && (!ae || !equals$2(ee, ae)) && (this.setSize(ee), this.updateViewportSize_());
  }
  /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @private
   */
  updateViewportSize_() {
    const Z = this.getView();
    if (Z) {
      let ee;
      const ae = getComputedStyle(this.viewport_);
      ae.width && ae.height && (ee = [
        parseInt(ae.width, 10),
        parseInt(ae.height, 10)
      ]), Z.setViewportSize(ee);
    }
  }
};
function createOptionsInternal(ie) {
  let Z = null;
  ie.keyboardEventTarget !== void 0 && (Z = typeof ie.keyboardEventTarget == "string" ? document.getElementById(ie.keyboardEventTarget) : ie.keyboardEventTarget);
  const ee = {}, ae = ie.layers && typeof /** @type {?} */
  ie.layers.getLayers == "function" ? (
    /** @type {LayerGroup} */
    ie.layers
  ) : new LayerGroup({
    layers: (
      /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */
      ie.layers
    )
  });
  ee[MapProperty.LAYERGROUP] = ae, ee[MapProperty.TARGET] = ie.target, ee[MapProperty.VIEW] = ie.view instanceof View ? ie.view : new View();
  let ve;
  ie.controls !== void 0 && (Array.isArray(ie.controls) ? ve = new Collection(ie.controls.slice()) : (assert(
    typeof /** @type {?} */
    ie.controls.getArray == "function",
    "Expected `controls` to be an array or an `ol/Collection.js`"
  ), ve = ie.controls));
  let ye;
  ie.interactions !== void 0 && (Array.isArray(ie.interactions) ? ye = new Collection(ie.interactions.slice()) : (assert(
    typeof /** @type {?} */
    ie.interactions.getArray == "function",
    "Expected `interactions` to be an array or an `ol/Collection.js`"
  ), ye = ie.interactions));
  let be;
  return ie.overlays !== void 0 ? Array.isArray(ie.overlays) ? be = new Collection(ie.overlays.slice()) : (assert(
    typeof /** @type {?} */
    ie.overlays.getArray == "function",
    "Expected `overlays` to be an array or an `ol/Collection.js`"
  ), be = ie.overlays) : be = new Collection(), {
    controls: ve,
    interactions: ye,
    keyboardEventTarget: Z,
    overlays: be,
    values: ee
  };
}
class LRUCache {
  /**
   * @param {number} [highWaterMark] High water mark.
   */
  constructor(Z) {
    this.highWaterMark = Z !== void 0 ? Z : 2048, this.count_ = 0, this.entries_ = {}, this.oldest_ = null, this.newest_ = null;
  }
  /**
   * @return {boolean} Can expire cache.
   */
  canExpireCache() {
    return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
  }
  /**
   * Expire the cache.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */
  expireCache(Z) {
    for (; this.canExpireCache(); )
      this.pop();
  }
  /**
   * FIXME empty description for jsdoc
   */
  clear() {
    this.count_ = 0, this.entries_ = {}, this.oldest_ = null, this.newest_ = null;
  }
  /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */
  containsKey(Z) {
    return this.entries_.hasOwnProperty(Z);
  }
  /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */
  forEach(Z) {
    let ee = this.oldest_;
    for (; ee; )
      Z(ee.value_, ee.key_, this), ee = ee.newer;
  }
  /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */
  get(Z, ee) {
    const ae = this.entries_[Z];
    return assert(
      ae !== void 0,
      "Tried to get a value for a key that does not exist in the cache"
    ), ae === this.newest_ || (ae === this.oldest_ ? (this.oldest_ = /** @type {Entry} */
    this.oldest_.newer, this.oldest_.older = null) : (ae.newer.older = ae.older, ae.older.newer = ae.newer), ae.newer = null, ae.older = this.newest_, this.newest_.newer = ae, this.newest_ = ae), ae.value_;
  }
  /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */
  remove(Z) {
    const ee = this.entries_[Z];
    return assert(
      ee !== void 0,
      "Tried to get a value for a key that does not exist in the cache"
    ), ee === this.newest_ ? (this.newest_ = /** @type {Entry} */
    ee.older, this.newest_ && (this.newest_.newer = null)) : ee === this.oldest_ ? (this.oldest_ = /** @type {Entry} */
    ee.newer, this.oldest_ && (this.oldest_.older = null)) : (ee.newer.older = ee.older, ee.older.newer = ee.newer), delete this.entries_[Z], --this.count_, ee.value_;
  }
  /**
   * @return {number} Count.
   */
  getCount() {
    return this.count_;
  }
  /**
   * @return {Array<string>} Keys.
   */
  getKeys() {
    const Z = new Array(this.count_);
    let ee = 0, ae;
    for (ae = this.newest_; ae; ae = ae.older)
      Z[ee++] = ae.key_;
    return Z;
  }
  /**
   * @return {Array<T>} Values.
   */
  getValues() {
    const Z = new Array(this.count_);
    let ee = 0, ae;
    for (ae = this.newest_; ae; ae = ae.older)
      Z[ee++] = ae.value_;
    return Z;
  }
  /**
   * @return {T} Last value.
   */
  peekLast() {
    return this.oldest_.value_;
  }
  /**
   * @return {string} Last key.
   */
  peekLastKey() {
    return this.oldest_.key_;
  }
  /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */
  peekFirstKey() {
    return this.newest_.key_;
  }
  /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T} Value.
   */
  peek(Z) {
    if (this.containsKey(Z))
      return this.entries_[Z].value_;
  }
  /**
   * @return {T} value Value.
   */
  pop() {
    const Z = this.oldest_;
    return delete this.entries_[Z.key_], Z.newer && (Z.newer.older = null), this.oldest_ = /** @type {Entry} */
    Z.newer, this.oldest_ || (this.newest_ = null), --this.count_, Z.value_;
  }
  /**
   * @param {string} key Key.
   * @param {T} value Value.
   */
  replace(Z, ee) {
    this.get(Z), this.entries_[Z].value_ = ee;
  }
  /**
   * @param {string} key Key.
   * @param {T} value Value.
   */
  set(Z, ee) {
    assert(
      !(Z in this.entries_),
      "Tried to set a value for a key that is used already"
    );
    const ae = {
      key_: Z,
      newer: null,
      older: this.newest_,
      value_: ee
    };
    this.newest_ ? this.newest_.newer = ae : this.oldest_ = ae, this.newest_ = ae, this.entries_[Z] = ae, ++this.count_;
  }
  /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */
  setSize(Z) {
    this.highWaterMark = Z;
  }
}
function createOrUpdate$1(ie, Z, ee, ae) {
  return ae !== void 0 ? (ae[0] = ie, ae[1] = Z, ae[2] = ee, ae) : [ie, Z, ee];
}
function getKeyZXY(ie, Z, ee) {
  return ie + "/" + Z + "/" + ee;
}
function getKey(ie) {
  return getKeyZXY(ie[0], ie[1], ie[2]);
}
function getCacheKeyForTileKey(ie) {
  const [Z, ee, ae] = ie.substring(ie.lastIndexOf("/") + 1, ie.length).split(",").map(Number);
  return getKeyZXY(Z, ee, ae);
}
function fromKey(ie) {
  return ie.split("/").map(Number);
}
function hash$2(ie) {
  return (ie[1] << ie[0]) + ie[2];
}
function withinExtentAndZ(ie, Z) {
  const ee = ie[0], ae = ie[1], ve = ie[2];
  if (Z.getMinZoom() > ee || ee > Z.getMaxZoom())
    return !1;
  const ye = Z.getFullTileRange(ee);
  return ye ? ye.containsXY(ae, ve) : !0;
}
class TileCache extends LRUCache {
  clear() {
    for (; this.getCount() > 0; )
      this.pop().release();
    super.clear();
  }
  /**
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */
  expireCache(Z) {
    for (; this.canExpireCache() && !(this.peekLast().getKey() in Z); )
      this.pop().release();
  }
  /**
   * Prune all tiles from the cache that don't have the same z as the newest tile.
   */
  pruneExceptNewestZ() {
    if (this.getCount() === 0)
      return;
    const Z = this.peekFirstKey(), ae = fromKey(Z)[0];
    this.forEach((ve) => {
      ve.tileCoord[0] !== ae && (this.remove(getKey(ve.tileCoord)), ve.release());
    });
  }
}
class TileRange {
  /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */
  constructor(Z, ee, ae, ve) {
    this.minX = Z, this.maxX = ee, this.minY = ae, this.maxY = ve;
  }
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */
  contains(Z) {
    return this.containsXY(Z[1], Z[2]);
  }
  /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */
  containsTileRange(Z) {
    return this.minX <= Z.minX && Z.maxX <= this.maxX && this.minY <= Z.minY && Z.maxY <= this.maxY;
  }
  /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */
  containsXY(Z, ee) {
    return this.minX <= Z && Z <= this.maxX && this.minY <= ee && ee <= this.maxY;
  }
  /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */
  equals(Z) {
    return this.minX == Z.minX && this.minY == Z.minY && this.maxX == Z.maxX && this.maxY == Z.maxY;
  }
  /**
   * @param {TileRange} tileRange Tile range.
   */
  extend(Z) {
    Z.minX < this.minX && (this.minX = Z.minX), Z.maxX > this.maxX && (this.maxX = Z.maxX), Z.minY < this.minY && (this.minY = Z.minY), Z.maxY > this.maxY && (this.maxY = Z.maxY);
  }
  /**
   * @return {number} Height.
   */
  getHeight() {
    return this.maxY - this.minY + 1;
  }
  /**
   * @return {import("./size.js").Size} Size.
   */
  getSize() {
    return [this.getWidth(), this.getHeight()];
  }
  /**
   * @return {number} Width.
   */
  getWidth() {
    return this.maxX - this.minX + 1;
  }
  /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */
  intersects(Z) {
    return this.minX <= Z.maxX && this.maxX >= Z.minX && this.minY <= Z.maxY && this.maxY >= Z.minY;
  }
}
function createOrUpdate(ie, Z, ee, ae, ve) {
  return ve !== void 0 ? (ve.minX = ie, ve.maxX = Z, ve.minY = ee, ve.maxY = ae, ve) : new TileRange(ie, Z, ee, ae);
}
const canvasPool$1 = [];
class VectorRenderTile extends Tile {
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {import("./tilecoord.js").TileCoord} urlTileCoord Wrapped tile coordinate for source urls.
   * @param {function(VectorRenderTile):Array<import("./VectorTile").default>} getSourceTiles Function
   * to get source tiles for this tile.
   */
  constructor(Z, ee, ae, ve) {
    super(Z, ee, { transition: 0 }), this.context_ = {}, this.executorGroups = {}, this.declutterExecutorGroups = {}, this.loadingSourceTiles = 0, this.hitDetectionImageData = {}, this.replayState_ = {}, this.sourceTiles = [], this.errorTileKeys = {}, this.wantedResolution, this.getSourceTiles = ve.bind(void 0, this), this.wrappedTileCoord = ae;
  }
  /**
   * @param {import("./layer/Layer.js").default} layer Layer.
   * @return {CanvasRenderingContext2D} The rendering context.
   */
  getContext(Z) {
    const ee = getUid(Z);
    return ee in this.context_ || (this.context_[ee] = createCanvasContext2D(1, 1, canvasPool$1)), this.context_[ee];
  }
  /**
   * @param {import("./layer/Layer.js").default} layer Layer.
   * @return {boolean} Tile has a rendering context for the given layer.
   */
  hasContext(Z) {
    return getUid(Z) in this.context_;
  }
  /**
   * Get the Canvas for this tile.
   * @param {import("./layer/Layer.js").default} layer Layer.
   * @return {HTMLCanvasElement} Canvas.
   */
  getImage(Z) {
    return this.hasContext(Z) ? this.getContext(Z).canvas : null;
  }
  /**
   * @param {import("./layer/Layer.js").default} layer Layer.
   * @return {ReplayState} The replay state.
   */
  getReplayState(Z) {
    const ee = getUid(Z);
    return ee in this.replayState_ || (this.replayState_[ee] = {
      dirty: !1,
      renderedRenderOrder: null,
      renderedResolution: NaN,
      renderedRevision: -1,
      renderedTileResolution: NaN,
      renderedTileRevision: -1,
      renderedTileZ: -1
    }), this.replayState_[ee];
  }
  /**
   * Load the tile.
   */
  load() {
    this.getSourceTiles();
  }
  /**
   * Remove from the cache due to expiry
   */
  release() {
    for (const Z in this.context_) {
      const ee = this.context_[Z];
      releaseCanvas$1(ee), canvasPool$1.push(ee.canvas), delete this.context_[Z];
    }
    super.release();
  }
}
let VectorTile$1 = class extends Tile {
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Data source url.
   * @param {import("./format/Feature.js").default} format Feature format.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */
  constructor(Z, ee, ae, ve, ye, be) {
    super(Z, ee, be), this.extent = null, this.format_ = ve, this.features_ = null, this.loader_, this.projection = null, this.resolution, this.tileLoadFunction_ = ye, this.url_ = ae, this.key = ae;
  }
  /**
   * Get the feature format assigned for reading this tile's features.
   * @return {import("./format/Feature.js").default} Feature format.
   * @api
   */
  getFormat() {
    return this.format_;
  }
  /**
   * Get the features for this tile. Geometries will be in the view projection.
   * @return {Array<import("./Feature.js").FeatureLike>} Features.
   * @api
   */
  getFeatures() {
    return this.features_;
  }
  /**
   * Load not yet loaded URI.
   */
  load() {
    this.state == TileState.IDLE && (this.setState(TileState.LOADING), this.tileLoadFunction_(this, this.url_), this.loader_ && this.loader_(this.extent, this.resolution, this.projection));
  }
  /**
   * Handler for successful tile load.
   * @param {Array<import("./Feature.js").default>} features The loaded features.
   * @param {import("./proj/Projection.js").default} dataProjection Data projection.
   */
  onLoad(Z, ee) {
    this.setFeatures(Z);
  }
  /**
   * Handler for tile load errors.
   */
  onError() {
    this.setState(TileState.ERROR);
  }
  /**
   * Function for use in an {@link module:ol/source/VectorTile~VectorTile}'s `tileLoadFunction`.
   * Sets the features for the tile.
   * @param {Array<import("./Feature.js").default>} features Features.
   * @api
   */
  setFeatures(Z) {
    this.features_ = Z, this.setState(TileState.LOADED);
  }
  /**
   * Set the feature loader for reading this tile's features.
   * @param {import("./featureloader.js").FeatureLoader} loader Feature loader.
   * @api
   */
  setLoader(Z) {
    this.loader_ = Z;
  }
};
const TileProperty = {
  PRELOAD: "preload",
  USE_INTERIM_TILES_ON_ERROR: "useInterimTilesOnError"
};
class BaseTileLayer extends Layer {
  /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */
  constructor(Z) {
    Z = Z || {};
    const ee = Object.assign({}, Z);
    delete ee.preload, delete ee.useInterimTilesOnError, super(ee), this.on, this.once, this.un, this.setPreload(Z.preload !== void 0 ? Z.preload : 0), this.setUseInterimTilesOnError(
      Z.useInterimTilesOnError !== void 0 ? Z.useInterimTilesOnError : !0
    );
  }
  /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */
  getPreload() {
    return (
      /** @type {number} */
      this.get(TileProperty.PRELOAD)
    );
  }
  /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */
  setPreload(Z) {
    this.set(TileProperty.PRELOAD, Z);
  }
  /**
   * Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */
  getUseInterimTilesOnError() {
    return (
      /** @type {boolean} */
      this.get(TileProperty.USE_INTERIM_TILES_ON_ERROR)
    );
  }
  /**
   * Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */
  setUseInterimTilesOnError(Z) {
    this.set(TileProperty.USE_INTERIM_TILES_ON_ERROR, Z);
  }
  /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   */
  getData(Z) {
    return super.getData(Z);
  }
}
const ERROR_THRESHOLD = 0.5, MAX_SUBDIVISION = 10, MAX_TRIANGLE_WIDTH = 0.25;
class Triangulation {
  /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   */
  constructor(Z, ee, ae, ve, ye, be) {
    this.sourceProj_ = Z, this.targetProj_ = ee;
    let Ye = {};
    const Qe = getTransform(this.targetProj_, this.sourceProj_);
    this.transformInv_ = function(Kr) {
      const Xr = Kr[0] + "/" + Kr[1];
      return Ye[Xr] || (Ye[Xr] = Qe(Kr)), Ye[Xr];
    }, this.maxSourceExtent_ = ve, this.errorThresholdSquared_ = ye * ye, this.triangles_ = [], this.wrapsXInSource_ = !1, this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!ve && !!this.sourceProj_.getExtent() && getWidth(ve) >= getWidth(this.sourceProj_.getExtent()), this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? getWidth(this.sourceProj_.getExtent()) : null, this.targetWorldWidth_ = this.targetProj_.getExtent() ? getWidth(this.targetProj_.getExtent()) : null;
    const Je = getTopLeft(ae), nt = getTopRight(ae), st = getBottomRight(ae), ot = getBottomLeft(ae), lt = this.transformInv_(Je), ft = this.transformInv_(nt), gt = this.transformInv_(st), ct = this.transformInv_(ot), _r = MAX_SUBDIVISION + (be ? Math.max(
      0,
      Math.ceil(
        Math.log2(
          getArea(ae) / (be * be * 256 * 256)
        )
      )
    ) : 0);
    if (this.addQuad_(
      Je,
      nt,
      st,
      ot,
      lt,
      ft,
      gt,
      ct,
      _r
    ), this.wrapsXInSource_) {
      let Kr = 1 / 0;
      this.triangles_.forEach(function(Xr, Jr, ei) {
        Kr = Math.min(
          Kr,
          Xr.source[0][0],
          Xr.source[1][0],
          Xr.source[2][0]
        );
      }), this.triangles_.forEach((Xr) => {
        if (Math.max(
          Xr.source[0][0],
          Xr.source[1][0],
          Xr.source[2][0]
        ) - Kr > this.sourceWorldWidth_ / 2) {
          const Jr = [
            [Xr.source[0][0], Xr.source[0][1]],
            [Xr.source[1][0], Xr.source[1][1]],
            [Xr.source[2][0], Xr.source[2][1]]
          ];
          Jr[0][0] - Kr > this.sourceWorldWidth_ / 2 && (Jr[0][0] -= this.sourceWorldWidth_), Jr[1][0] - Kr > this.sourceWorldWidth_ / 2 && (Jr[1][0] -= this.sourceWorldWidth_), Jr[2][0] - Kr > this.sourceWorldWidth_ / 2 && (Jr[2][0] -= this.sourceWorldWidth_);
          const ei = Math.min(
            Jr[0][0],
            Jr[1][0],
            Jr[2][0]
          );
          Math.max(
            Jr[0][0],
            Jr[1][0],
            Jr[2][0]
          ) - ei < this.sourceWorldWidth_ / 2 && (Xr.source = Jr);
        }
      });
    }
    Ye = {};
  }
  /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */
  addTriangle_(Z, ee, ae, ve, ye, be) {
    this.triangles_.push({
      source: [ve, ye, be],
      target: [Z, ee, ae]
    });
  }
  /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */
  addQuad_(Z, ee, ae, ve, ye, be, Ye, Qe, Je) {
    const nt = boundingExtent([ye, be, Ye, Qe]), st = this.sourceWorldWidth_ ? getWidth(nt) / this.sourceWorldWidth_ : null, ot = (
      /** @type {number} */
      this.sourceWorldWidth_
    ), lt = this.sourceProj_.canWrapX() && st > 0.5 && st < 1;
    let ft = !1;
    if (Je > 0) {
      if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
        const ct = boundingExtent([Z, ee, ae, ve]);
        ft = getWidth(ct) / this.targetWorldWidth_ > MAX_TRIANGLE_WIDTH || ft;
      }
      !lt && this.sourceProj_.isGlobal() && st && (ft = st > MAX_TRIANGLE_WIDTH || ft);
    }
    if (!ft && this.maxSourceExtent_ && isFinite(nt[0]) && isFinite(nt[1]) && isFinite(nt[2]) && isFinite(nt[3]) && !intersects$1(nt, this.maxSourceExtent_))
      return;
    let gt = 0;
    if (!ft && (!isFinite(ye[0]) || !isFinite(ye[1]) || !isFinite(be[0]) || !isFinite(be[1]) || !isFinite(Ye[0]) || !isFinite(Ye[1]) || !isFinite(Qe[0]) || !isFinite(Qe[1]))) {
      if (Je > 0)
        ft = !0;
      else if (gt = (!isFinite(ye[0]) || !isFinite(ye[1]) ? 8 : 0) + (!isFinite(be[0]) || !isFinite(be[1]) ? 4 : 0) + (!isFinite(Ye[0]) || !isFinite(Ye[1]) ? 2 : 0) + (!isFinite(Qe[0]) || !isFinite(Qe[1]) ? 1 : 0), gt != 1 && gt != 2 && gt != 4 && gt != 8)
        return;
    }
    if (Je > 0) {
      if (!ft) {
        const ct = [(Z[0] + ae[0]) / 2, (Z[1] + ae[1]) / 2], _r = this.transformInv_(ct);
        let Kr;
        lt ? Kr = (modulo(ye[0], ot) + modulo(Ye[0], ot)) / 2 - modulo(_r[0], ot) : Kr = (ye[0] + Ye[0]) / 2 - _r[0];
        const Xr = (ye[1] + Ye[1]) / 2 - _r[1];
        ft = Kr * Kr + Xr * Xr > this.errorThresholdSquared_;
      }
      if (ft) {
        if (Math.abs(Z[0] - ae[0]) <= Math.abs(Z[1] - ae[1])) {
          const ct = [(ee[0] + ae[0]) / 2, (ee[1] + ae[1]) / 2], _r = this.transformInv_(ct), Kr = [(ve[0] + Z[0]) / 2, (ve[1] + Z[1]) / 2], Xr = this.transformInv_(Kr);
          this.addQuad_(
            Z,
            ee,
            ct,
            Kr,
            ye,
            be,
            _r,
            Xr,
            Je - 1
          ), this.addQuad_(
            Kr,
            ct,
            ae,
            ve,
            Xr,
            _r,
            Ye,
            Qe,
            Je - 1
          );
        } else {
          const ct = [(Z[0] + ee[0]) / 2, (Z[1] + ee[1]) / 2], _r = this.transformInv_(ct), Kr = [(ae[0] + ve[0]) / 2, (ae[1] + ve[1]) / 2], Xr = this.transformInv_(Kr);
          this.addQuad_(
            Z,
            ct,
            Kr,
            ve,
            ye,
            _r,
            Xr,
            Qe,
            Je - 1
          ), this.addQuad_(
            ct,
            ee,
            ae,
            Kr,
            _r,
            be,
            Ye,
            Xr,
            Je - 1
          );
        }
        return;
      }
    }
    if (lt) {
      if (!this.canWrapXInSource_)
        return;
      this.wrapsXInSource_ = !0;
    }
    gt & 11 || this.addTriangle_(Z, ae, ve, ye, Ye, Qe), gt & 14 || this.addTriangle_(Z, ae, ee, ye, Ye, be), gt && (gt & 13 || this.addTriangle_(ee, ve, Z, be, Qe, ye), gt & 7 || this.addTriangle_(ee, ve, ae, be, Qe, Ye));
  }
  /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */
  calculateSourceExtent() {
    const Z = createEmpty();
    return this.triangles_.forEach(function(ee, ae, ve) {
      const ye = ee.source;
      extendCoordinate(Z, ye[0]), extendCoordinate(Z, ye[1]), extendCoordinate(Z, ye[2]);
    }), Z;
  }
  /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */
  getTriangles() {
    return this.triangles_;
  }
}
let brokenDiagonalRendering_;
const canvasPool = [];
function drawTestTriangle(ie, Z, ee, ae, ve) {
  ie.beginPath(), ie.moveTo(0, 0), ie.lineTo(Z, ee), ie.lineTo(ae, ve), ie.closePath(), ie.save(), ie.clip(), ie.fillRect(0, 0, Math.max(Z, ae) + 1, Math.max(ee, ve)), ie.restore();
}
function verifyBrokenDiagonalRendering(ie, Z) {
  return Math.abs(ie[Z * 4] - 210) > 2 || Math.abs(ie[Z * 4 + 3] - 0.75 * 255) > 2;
}
function isBrokenDiagonalRendering() {
  if (brokenDiagonalRendering_ === void 0) {
    const ie = createCanvasContext2D(6, 6, canvasPool);
    ie.globalCompositeOperation = "lighter", ie.fillStyle = "rgba(210, 0, 0, 0.75)", drawTestTriangle(ie, 4, 5, 4, 0), drawTestTriangle(ie, 4, 5, 0, 5);
    const Z = ie.getImageData(0, 0, 3, 3).data;
    brokenDiagonalRendering_ = verifyBrokenDiagonalRendering(Z, 0) || verifyBrokenDiagonalRendering(Z, 4) || verifyBrokenDiagonalRendering(Z, 8), releaseCanvas$1(ie), canvasPool.push(ie.canvas);
  }
  return brokenDiagonalRendering_;
}
function calculateSourceResolution(ie, Z, ee, ae) {
  const ve = transform(ee, Z, ie);
  let ye = getPointResolution(
    Z,
    ae,
    ee
  );
  const be = Z.getMetersPerUnit();
  be !== void 0 && (ye *= be);
  const Ye = ie.getMetersPerUnit();
  Ye !== void 0 && (ye /= Ye);
  const Qe = ie.getExtent();
  if (!Qe || containsCoordinate(Qe, ve)) {
    const Je = getPointResolution(ie, ye, ve) / ye;
    isFinite(Je) && Je > 0 && (ye /= Je);
  }
  return ye;
}
function calculateSourceExtentResolution(ie, Z, ee, ae) {
  const ve = getCenter(ee);
  let ye = calculateSourceResolution(
    ie,
    Z,
    ve,
    ae
  );
  return (!isFinite(ye) || ye <= 0) && forEachCorner(ee, function(be) {
    return ye = calculateSourceResolution(
      ie,
      Z,
      be,
      ae
    ), isFinite(ye) && ye > 0;
  }), ye;
}
function render$1(ie, Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt, st) {
  const ot = createCanvasContext2D(
    Math.round(ee * ie),
    Math.round(ee * Z),
    canvasPool
  );
  if (st || (ot.imageSmoothingEnabled = !1), Qe.length === 0)
    return ot.canvas;
  ot.scale(ee, ee);
  function lt(Jr) {
    return Math.round(Jr * ee) / ee;
  }
  ot.globalCompositeOperation = "lighter";
  const ft = createEmpty();
  Qe.forEach(function(Jr, ei, si) {
    extend$1(ft, Jr.extent);
  });
  const gt = getWidth(ft), ct = getHeight(ft), _r = createCanvasContext2D(
    Math.round(ee * gt / ae),
    Math.round(ee * ct / ae),
    canvasPool
  );
  st || (_r.imageSmoothingEnabled = !1);
  const Kr = ee / ae;
  Qe.forEach(function(Jr, ei, si) {
    const ri = Jr.extent[0] - ft[0], ai = -(Jr.extent[3] - ft[3]), yi = getWidth(Jr.extent), pi = getHeight(Jr.extent);
    Jr.image.width > 0 && Jr.image.height > 0 && _r.drawImage(
      Jr.image,
      Je,
      Je,
      Jr.image.width - 2 * Je,
      Jr.image.height - 2 * Je,
      ri * Kr,
      ai * Kr,
      yi * Kr,
      pi * Kr
    );
  });
  const Xr = getTopLeft(be);
  return Ye.getTriangles().forEach(function(Jr, ei, si) {
    const ri = Jr.source, ai = Jr.target;
    let yi = ri[0][0], pi = ri[0][1], di = ri[1][0], xi = ri[1][1], Ti = ri[2][0], Ai = ri[2][1];
    const mi = lt((ai[0][0] - Xr[0]) / ye), Si = lt(
      -(ai[0][1] - Xr[1]) / ye
    ), gi = lt((ai[1][0] - Xr[0]) / ye), _i = lt(
      -(ai[1][1] - Xr[1]) / ye
    ), Oi = lt((ai[2][0] - Xr[0]) / ye), hi = lt(
      -(ai[2][1] - Xr[1]) / ye
    ), Di = yi, Ri = pi;
    yi = 0, pi = 0, di -= Di, xi -= Ri, Ti -= Di, Ai -= Ri;
    const rs = [
      [di, xi, 0, 0, gi - mi],
      [Ti, Ai, 0, 0, Oi - mi],
      [0, 0, di, xi, _i - Si],
      [0, 0, Ti, Ai, hi - Si]
    ], Hi = solveLinearSystem(rs);
    if (Hi) {
      if (ot.save(), ot.beginPath(), isBrokenDiagonalRendering() || !st) {
        ot.moveTo(gi, _i);
        const qi = 4, us = mi - gi, Yi = Si - _i;
        for (let is = 0; is < qi; is++)
          ot.lineTo(
            gi + lt((is + 1) * us / qi),
            _i + lt(is * Yi / (qi - 1))
          ), is != qi - 1 && ot.lineTo(
            gi + lt((is + 1) * us / qi),
            _i + lt((is + 1) * Yi / (qi - 1))
          );
        ot.lineTo(Oi, hi);
      } else
        ot.moveTo(gi, _i), ot.lineTo(mi, Si), ot.lineTo(Oi, hi);
      ot.clip(), ot.transform(
        Hi[0],
        Hi[2],
        Hi[1],
        Hi[3],
        mi,
        Si
      ), ot.translate(
        ft[0] - Di,
        ft[3] - Ri
      ), ot.scale(
        ae / ee,
        -ae / ee
      ), ot.drawImage(_r.canvas, 0, 0), ot.restore();
    }
  }), releaseCanvas$1(_r), canvasPool.push(_r.canvas), nt && (ot.save(), ot.globalCompositeOperation = "source-over", ot.strokeStyle = "black", ot.lineWidth = 1, Ye.getTriangles().forEach(function(Jr, ei, si) {
    const ri = Jr.target, ai = (ri[0][0] - Xr[0]) / ye, yi = -(ri[0][1] - Xr[1]) / ye, pi = (ri[1][0] - Xr[0]) / ye, di = -(ri[1][1] - Xr[1]) / ye, xi = (ri[2][0] - Xr[0]) / ye, Ti = -(ri[2][1] - Xr[1]) / ye;
    ot.beginPath(), ot.moveTo(pi, di), ot.lineTo(ai, yi), ot.lineTo(xi, Ti), ot.closePath(), ot.stroke();
  }), ot.restore()), ot.canvas;
}
class ReprojTile extends Tile {
  /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {boolean} [interpolate] Use linear interpolation when resampling.
   */
  constructor(Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt, st, ot) {
    super(ye, TileState.IDLE, { interpolate: !!ot }), this.renderEdges_ = st !== void 0 ? st : !1, this.pixelRatio_ = Ye, this.gutter_ = Qe, this.canvas_ = null, this.sourceTileGrid_ = ee, this.targetTileGrid_ = ve, this.wrappedTileCoord_ = be || ye, this.sourceTiles_ = [], this.sourcesListenerKeys_ = null, this.sourceZ_ = 0;
    const lt = ve.getTileCoordExtent(
      this.wrappedTileCoord_
    ), ft = this.targetTileGrid_.getExtent();
    let gt = this.sourceTileGrid_.getExtent();
    const ct = ft ? getIntersection(lt, ft) : lt;
    if (getArea(ct) === 0) {
      this.state = TileState.EMPTY;
      return;
    }
    const _r = Z.getExtent();
    _r && (gt ? gt = getIntersection(gt, _r) : gt = _r);
    const Kr = ve.getResolution(
      this.wrappedTileCoord_[0]
    ), Xr = calculateSourceExtentResolution(
      Z,
      ae,
      ct,
      Kr
    );
    if (!isFinite(Xr) || Xr <= 0) {
      this.state = TileState.EMPTY;
      return;
    }
    const Jr = nt !== void 0 ? nt : ERROR_THRESHOLD;
    if (this.triangulation_ = new Triangulation(
      Z,
      ae,
      ct,
      gt,
      Xr * Jr,
      Kr
    ), this.triangulation_.getTriangles().length === 0) {
      this.state = TileState.EMPTY;
      return;
    }
    this.sourceZ_ = ee.getZForResolution(Xr);
    let ei = this.triangulation_.calculateSourceExtent();
    if (gt && (Z.canWrapX() ? (ei[1] = clamp$1(
      ei[1],
      gt[1],
      gt[3]
    ), ei[3] = clamp$1(
      ei[3],
      gt[1],
      gt[3]
    )) : ei = getIntersection(ei, gt)), !getArea(ei))
      this.state = TileState.EMPTY;
    else {
      const si = ee.getTileRangeForExtentAndZ(
        ei,
        this.sourceZ_
      );
      for (let ri = si.minX; ri <= si.maxX; ri++)
        for (let ai = si.minY; ai <= si.maxY; ai++) {
          const yi = Je(this.sourceZ_, ri, ai, Ye);
          yi && this.sourceTiles_.push(yi);
        }
      this.sourceTiles_.length === 0 && (this.state = TileState.EMPTY);
    }
  }
  /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */
  getImage() {
    return this.canvas_;
  }
  /**
   * @private
   */
  reproject_() {
    const Z = [];
    if (this.sourceTiles_.forEach((ee) => {
      ee && ee.getState() == TileState.LOADED && Z.push({
        extent: this.sourceTileGrid_.getTileCoordExtent(ee.tileCoord),
        image: ee.getImage()
      });
    }), this.sourceTiles_.length = 0, Z.length === 0)
      this.state = TileState.ERROR;
    else {
      const ee = this.wrappedTileCoord_[0], ae = this.targetTileGrid_.getTileSize(ee), ve = typeof ae == "number" ? ae : ae[0], ye = typeof ae == "number" ? ae : ae[1], be = this.targetTileGrid_.getResolution(ee), Ye = this.sourceTileGrid_.getResolution(
        this.sourceZ_
      ), Qe = this.targetTileGrid_.getTileCoordExtent(
        this.wrappedTileCoord_
      );
      this.canvas_ = render$1(
        ve,
        ye,
        this.pixelRatio_,
        Ye,
        this.sourceTileGrid_.getExtent(),
        be,
        Qe,
        this.triangulation_,
        Z,
        this.gutter_,
        this.renderEdges_,
        this.interpolate
      ), this.state = TileState.LOADED;
    }
    this.changed();
  }
  /**
   * Load not yet loaded URI.
   */
  load() {
    if (this.state == TileState.IDLE) {
      this.state = TileState.LOADING, this.changed();
      let Z = 0;
      this.sourcesListenerKeys_ = [], this.sourceTiles_.forEach((ee) => {
        const ae = ee.getState();
        if (ae == TileState.IDLE || ae == TileState.LOADING) {
          Z++;
          const ve = listen(
            ee,
            EventType.CHANGE,
            function(ye) {
              const be = ee.getState();
              (be == TileState.LOADED || be == TileState.ERROR || be == TileState.EMPTY) && (unlistenByKey(ve), Z--, Z === 0 && (this.unlistenSources_(), this.reproject_()));
            },
            this
          );
          this.sourcesListenerKeys_.push(ve);
        }
      }), Z === 0 ? setTimeout(this.reproject_.bind(this), 0) : this.sourceTiles_.forEach(function(ee, ae, ve) {
        ee.getState() == TileState.IDLE && ee.load();
      });
    }
  }
  /**
   * @private
   */
  unlistenSources_() {
    this.sourcesListenerKeys_.forEach(unlistenByKey), this.sourcesListenerKeys_ = null;
  }
  /**
   * Remove from the cache due to expiry
   */
  release() {
    this.canvas_ && (releaseCanvas$1(this.canvas_.getContext("2d")), canvasPool.push(this.canvas_), this.canvas_ = null), super.release();
  }
}
class CanvasTileLayerRenderer extends CanvasLayerRenderer {
  /**
   * @param {LayerType} tileLayer Tile layer.
   */
  constructor(Z) {
    super(Z), this.extentChanged = !0, this.renderedExtent_ = null, this.renderedPixelRatio, this.renderedProjection = null, this.renderedRevision, this.renderedTiles = [], this.newTiles_ = !1, this.tmpExtent = createEmpty(), this.tmpTileRange_ = new TileRange(0, 0, 0, 0);
  }
  /**
   * @protected
   * @param {import("../../Tile.js").default} tile Tile.
   * @return {boolean} Tile is drawable.
   */
  isDrawableTile(Z) {
    const ee = this.getLayer(), ae = Z.getState(), ve = ee.getUseInterimTilesOnError();
    return ae == TileState.LOADED || ae == TileState.EMPTY || ae == TileState.ERROR && !ve;
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {!import("../../Tile.js").default} Tile.
   */
  getTile(Z, ee, ae, ve) {
    const ye = ve.pixelRatio, be = ve.viewState.projection, Ye = this.getLayer();
    let Je = Ye.getSource().getTile(Z, ee, ae, ye, be);
    return Je.getState() == TileState.ERROR && Ye.getUseInterimTilesOnError() && Ye.getPreload() > 0 && (this.newTiles_ = !0), this.isDrawableTile(Je) || (Je = Je.getInterimTile()), Je;
  }
  /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   */
  getData(Z) {
    const ee = this.frameState;
    if (!ee)
      return null;
    const ae = this.getLayer(), ve = apply(
      ee.pixelToCoordinateTransform,
      Z.slice()
    ), ye = ae.getExtent();
    if (ye && !containsCoordinate(ye, ve))
      return null;
    const be = ee.pixelRatio, Ye = ee.viewState.projection, Qe = ee.viewState, Je = ae.getRenderSource(), nt = Je.getTileGridForProjection(Qe.projection), st = Je.getTilePixelRatio(ee.pixelRatio);
    for (let ot = nt.getZForResolution(Qe.resolution); ot >= nt.getMinZoom(); --ot) {
      const lt = nt.getTileCoordForCoordAndZ(ve, ot), ft = Je.getTile(
        ot,
        lt[1],
        lt[2],
        be,
        Ye
      );
      if (!(ft instanceof ImageTile || ft instanceof ReprojTile) || ft instanceof ReprojTile && ft.getState() === TileState.EMPTY)
        return null;
      if (ft.getState() !== TileState.LOADED)
        continue;
      const gt = nt.getOrigin(ot), ct = toSize(nt.getTileSize(ot)), _r = nt.getResolution(ot), Kr = Math.floor(
        st * ((ve[0] - gt[0]) / _r - lt[1] * ct[0])
      ), Xr = Math.floor(
        st * ((gt[1] - ve[1]) / _r - lt[2] * ct[1])
      ), Jr = Math.round(
        st * Je.getGutterForProjection(Qe.projection)
      );
      return this.getImageData(ft.getImage(), Kr + Jr, Xr + Jr);
    }
    return null;
  }
  /**
   * @param {Object<number, Object<string, import("../../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @param {number} zoom Zoom level.
   * @param {import("../../Tile.js").default} tile Tile.
   * @return {boolean|void} If `false`, the tile will not be considered loaded.
   */
  loadedTileCallback(Z, ee, ae) {
    return this.isDrawableTile(ae) ? super.loadedTileCallback(Z, ee, ae) : !1;
  }
  /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */
  prepareFrame(Z) {
    return !!this.getLayer().getSource();
  }
  /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */
  renderFrame(Z, ee) {
    const ae = Z.layerStatesArray[Z.layerIndex], ve = Z.viewState, ye = ve.projection, be = ve.resolution, Ye = ve.center, Qe = ve.rotation, Je = Z.pixelRatio, nt = this.getLayer(), st = nt.getSource(), ot = st.getRevision(), lt = st.getTileGridForProjection(ye), ft = lt.getZForResolution(be, st.zDirection), gt = lt.getResolution(ft);
    let ct = Z.extent;
    const _r = Z.viewState.resolution, Kr = st.getTilePixelRatio(Je), Xr = Math.round(getWidth(ct) / _r * Je), Jr = Math.round(getHeight(ct) / _r * Je), ei = ae.extent && fromUserExtent(ae.extent, ye);
    ei && (ct = getIntersection(
      ct,
      fromUserExtent(ae.extent, ye)
    ));
    const si = gt * Xr / 2 / Kr, ri = gt * Jr / 2 / Kr, ai = [
      Ye[0] - si,
      Ye[1] - ri,
      Ye[0] + si,
      Ye[1] + ri
    ], yi = lt.getTileRangeForExtentAndZ(ct, ft), pi = {};
    pi[ft] = {};
    const di = this.createLoadedTileFinder(
      st,
      ye,
      pi
    ), xi = this.tmpExtent, Ti = this.tmpTileRange_;
    this.newTiles_ = !1;
    const Ai = Qe ? getRotatedViewport(
      ve.center,
      _r,
      Qe,
      Z.size
    ) : void 0;
    for (let rs = yi.minX; rs <= yi.maxX; ++rs)
      for (let Hi = yi.minY; Hi <= yi.maxY; ++Hi) {
        if (Qe && !lt.tileCoordIntersectsViewport([ft, rs, Hi], Ai))
          continue;
        const qi = this.getTile(ft, rs, Hi, Z);
        if (this.isDrawableTile(qi)) {
          const is = getUid(this);
          if (qi.getState() == TileState.LOADED) {
            pi[ft][qi.tileCoord.toString()] = qi;
            let Ss = qi.inTransition(is);
            Ss && ae.opacity !== 1 && (qi.endTransition(is), Ss = !1), !this.newTiles_ && (Ss || !this.renderedTiles.includes(qi)) && (this.newTiles_ = !0);
          }
          if (qi.getAlpha(is, Z.time) === 1)
            continue;
        }
        const us = lt.getTileCoordChildTileRange(
          qi.tileCoord,
          Ti,
          xi
        );
        let Yi = !1;
        us && (Yi = di(ft + 1, us)), Yi || lt.forEachTileCoordParentTileRange(
          qi.tileCoord,
          di,
          Ti,
          xi
        );
      }
    const mi = gt / be * Je / Kr;
    compose$1(
      this.pixelTransform,
      Z.size[0] / 2,
      Z.size[1] / 2,
      1 / Je,
      1 / Je,
      Qe,
      -Xr / 2,
      -Jr / 2
    );
    const Si = toString$1(this.pixelTransform);
    this.useContainer(ee, Si, this.getBackground(Z));
    const gi = this.context, _i = gi.canvas;
    makeInverse(this.inversePixelTransform, this.pixelTransform), compose$1(
      this.tempTransform,
      Xr / 2,
      Jr / 2,
      mi,
      mi,
      0,
      -Xr / 2,
      -Jr / 2
    ), _i.width != Xr || _i.height != Jr ? (_i.width = Xr, _i.height = Jr) : this.containerReused || gi.clearRect(0, 0, Xr, Jr), ei && this.clipUnrotated(gi, Z, ei), st.getInterpolate() || (gi.imageSmoothingEnabled = !1), this.preRender(gi, Z), this.renderedTiles.length = 0;
    let Oi = Object.keys(pi).map(Number);
    Oi.sort(ascending);
    let hi, Di, Ri;
    ae.opacity === 1 && (!this.containerReused || st.getOpaque(Z.viewState.projection)) ? Oi = Oi.reverse() : (hi = [], Di = []);
    for (let rs = Oi.length - 1; rs >= 0; --rs) {
      const Hi = Oi[rs], qi = st.getTilePixelSize(
        Hi,
        Je,
        ye
      ), Yi = lt.getResolution(Hi) / gt, is = qi[0] * Yi * mi, Ss = qi[1] * Yi * mi, Gs = lt.getTileCoordForCoordAndZ(
        getTopLeft(ai),
        Hi
      ), Vs = lt.getTileCoordExtent(Gs), Ws = apply(this.tempTransform, [
        Kr * (Vs[0] - ai[0]) / gt,
        Kr * (ai[3] - Vs[3]) / gt
      ]), ii = Kr * st.getGutterForProjection(ye), bi = pi[Hi];
      for (const Gi in bi) {
        const Qi = (
          /** @type {import("../../ImageTile.js").default} */
          bi[Gi]
        ), ns = Qi.tileCoord, Bs = Gs[1] - ns[1], ms = Math.round(Ws[0] - (Bs - 1) * is), Ks = Gs[2] - ns[2], Js = Math.round(Ws[1] - (Ks - 1) * Ss), Ns = Math.round(Ws[0] - Bs * is), Ts = Math.round(Ws[1] - Ks * Ss), lo = ms - Ns, Fs = Js - Ts, xo = ft === Hi, mo = xo && Qi.getAlpha(getUid(this), Z.time) !== 1;
        let Wo = !1;
        if (!mo)
          if (hi) {
            Ri = [Ns, Ts, Ns + lo, Ts, Ns + lo, Ts + Fs, Ns, Ts + Fs];
            for (let Ta = 0, Aa = hi.length; Ta < Aa; ++Ta)
              if (ft !== Hi && Hi < Di[Ta]) {
                const hs = hi[Ta];
                intersects$1(
                  [Ns, Ts, Ns + lo, Ts + Fs],
                  [hs[0], hs[3], hs[4], hs[7]]
                ) && (Wo || (gi.save(), Wo = !0), gi.beginPath(), gi.moveTo(Ri[0], Ri[1]), gi.lineTo(Ri[2], Ri[3]), gi.lineTo(Ri[4], Ri[5]), gi.lineTo(Ri[6], Ri[7]), gi.moveTo(hs[6], hs[7]), gi.lineTo(hs[4], hs[5]), gi.lineTo(hs[2], hs[3]), gi.lineTo(hs[0], hs[1]), gi.clip());
              }
            hi.push(Ri), Di.push(Hi);
          } else
            gi.clearRect(Ns, Ts, lo, Fs);
        this.drawTileImage(
          Qi,
          Z,
          Ns,
          Ts,
          lo,
          Fs,
          ii,
          xo
        ), hi && !mo ? (Wo && gi.restore(), this.renderedTiles.unshift(Qi)) : this.renderedTiles.push(Qi), this.updateUsedTiles(Z.usedTiles, st, Qi);
      }
    }
    return this.renderedRevision = ot, this.renderedResolution = gt, this.extentChanged = !this.renderedExtent_ || !equals$1(this.renderedExtent_, ai), this.renderedExtent_ = ai, this.renderedPixelRatio = Je, this.renderedProjection = ye, this.manageTilePyramid(
      Z,
      st,
      lt,
      Je,
      ye,
      ct,
      ft,
      nt.getPreload()
    ), this.scheduleExpireCache(Z, st), this.postRender(gi, Z), ae.extent && gi.restore(), gi.imageSmoothingEnabled = !0, Si !== _i.style.transform && (_i.style.transform = Si), this.container;
  }
  /**
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   */
  drawTileImage(Z, ee, ae, ve, ye, be, Ye, Qe) {
    const Je = this.getTileImage(Z);
    if (!Je)
      return;
    const nt = getUid(this), st = ee.layerStatesArray[ee.layerIndex], ot = st.opacity * (Qe ? Z.getAlpha(nt, ee.time) : 1), lt = ot !== this.context.globalAlpha;
    lt && (this.context.save(), this.context.globalAlpha = ot), this.context.drawImage(
      Je,
      Ye,
      Ye,
      Je.width - 2 * Ye,
      Je.height - 2 * Ye,
      ae,
      ve,
      ye,
      be
    ), lt && this.context.restore(), ot !== st.opacity ? ee.animate = !0 : Qe && Z.endTransition(nt);
  }
  /**
   * @return {HTMLCanvasElement} Image
   */
  getImage() {
    const Z = this.context;
    return Z ? Z.canvas : null;
  }
  /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */
  getTileImage(Z) {
    return Z.getImage();
  }
  /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @protected
   */
  scheduleExpireCache(Z, ee) {
    if (ee.canExpireCache()) {
      const ae = (function(ve, ye, be) {
        const Ye = getUid(ve);
        Ye in be.usedTiles && ve.expireCache(
          be.viewState.projection,
          be.usedTiles[Ye]
        );
      }).bind(null, ee);
      Z.postRenderFunctions.push(
        /** @type {import("../../Map.js").PostRenderFunction} */
        ae
      );
    }
  }
  /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */
  updateUsedTiles(Z, ee, ae) {
    const ve = getUid(ee);
    ve in Z || (Z[ve] = {}), Z[ve][ae.getKey()] = !0;
  }
  /**
   * Manage tile pyramid.
   * This function performs a number of functions related to the tiles at the
   * current zoom and lower zoom levels:
   * - registers idle tiles in frameState.wantedTiles so that they are not
   *   discarded by the tile queue
   * - enqueues missing tiles
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid Tile grid.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection.js").default} projection Projection.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {number} currentZ Current Z.
   * @param {number} preload Load low resolution tiles up to `preload` levels.
   * @param {function(import("../../Tile.js").default):void} [tileCallback] Tile callback.
   * @protected
   */
  manageTilePyramid(Z, ee, ae, ve, ye, be, Ye, Qe, Je) {
    const nt = getUid(ee);
    nt in Z.wantedTiles || (Z.wantedTiles[nt] = {});
    const st = Z.wantedTiles[nt], ot = Z.tileQueue, lt = ae.getMinZoom(), ft = Z.viewState.rotation, gt = ft ? getRotatedViewport(
      Z.viewState.center,
      Z.viewState.resolution,
      ft,
      Z.size
    ) : void 0;
    let ct = 0, _r, Kr, Xr, Jr, ei, si;
    for (si = lt; si <= Ye; ++si)
      for (Kr = ae.getTileRangeForExtentAndZ(be, si, Kr), Xr = ae.getResolution(si), Jr = Kr.minX; Jr <= Kr.maxX; ++Jr)
        for (ei = Kr.minY; ei <= Kr.maxY; ++ei)
          ft && !ae.tileCoordIntersectsViewport([si, Jr, ei], gt) || (Ye - si <= Qe ? (++ct, _r = ee.getTile(si, Jr, ei, ve, ye), _r.getState() == TileState.IDLE && (st[_r.getKey()] = !0, ot.isKeyQueued(_r.getKey()) || ot.enqueue([
            _r,
            nt,
            ae.getTileCoordCenter(_r.tileCoord),
            Xr
          ])), Je !== void 0 && Je(_r)) : ee.useTile(si, Jr, ei, ye));
    ee.updateCacheSize(ct, ye);
  }
}
class TileLayer extends BaseTileLayer {
  /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */
  constructor(Z) {
    super(Z);
  }
  createRenderer() {
    return new CanvasTileLayerRenderer(this);
  }
}
const IMAGE_REPLAYS = {
  image: ["Polygon", "Circle", "LineString", "Image", "Text"],
  hybrid: ["Polygon", "LineString"],
  vector: []
}, VECTOR_REPLAYS = {
  hybrid: ["Image", "Text", "Default"],
  vector: ["Polygon", "Circle", "LineString", "Image", "Text", "Default"]
};
class CanvasVectorTileLayerRenderer extends CanvasTileLayerRenderer {
  /**
   * @param {import("../../layer/VectorTile.js").default} layer VectorTile layer.
   */
  constructor(Z) {
    super(Z), this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this), this.renderedLayerRevision_, this.renderedPixelToCoordinateTransform_ = null, this.renderedRotation_, this.tmpTransform_ = create$2();
  }
  /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection").default} projection Projection.
   * @return {boolean|undefined} Tile needs to be rendered.
   */
  prepareTile(Z, ee, ae) {
    let ve;
    const ye = Z.getState();
    return (ye === TileState.LOADED || ye === TileState.ERROR) && (this.updateExecutorGroup_(Z, ee, ae), this.tileImageNeedsRender_(Z) && (ve = !0)), ve;
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {!import("../../Tile.js").default} Tile.
   */
  getTile(Z, ee, ae, ve) {
    const ye = ve.pixelRatio, be = ve.viewState, Ye = be.resolution, Qe = be.projection, Je = this.getLayer(), nt = Je.getSource().getTile(Z, ee, ae, ye, Qe), st = ve.viewHints, ot = !(st[ViewHint.ANIMATING] || st[ViewHint.INTERACTING]);
    return (ot || !nt.wantedResolution) && (nt.wantedResolution = Ye), this.prepareTile(nt, ye, Qe) && (ot || Date.now() - ve.time < 8) && Je.getRenderMode() !== "vector" && this.renderTileImage_(nt, ve), super.getTile(Z, ee, ae, ve);
  }
  /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @return {boolean} Tile is drawable.
   */
  isDrawableTile(Z) {
    const ee = this.getLayer();
    return super.isDrawableTile(Z) && (ee.getRenderMode() === "vector" ? getUid(ee) in Z.executorGroups : Z.hasContext(ee));
  }
  /**
   * @inheritDoc
   */
  getTileImage(Z) {
    return Z.getImage(this.getLayer());
  }
  /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */
  prepareFrame(Z) {
    const ee = this.getLayer().getRevision();
    return this.renderedLayerRevision_ !== ee && (this.renderedLayerRevision_ = ee, this.renderedTiles.length = 0), super.prepareFrame(Z);
  }
  /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection.js").default} projection Projection.
   * @private
   */
  updateExecutorGroup_(Z, ee, ae) {
    const ve = (
      /** @type {import("../../layer/VectorTile.js").default} */
      this.getLayer()
    ), ye = ve.getRevision(), be = ve.getRenderOrder() || null, Ye = Z.wantedResolution, Qe = Z.getReplayState(ve);
    if (!Qe.dirty && Qe.renderedResolution === Ye && Qe.renderedRevision == ye && Qe.renderedRenderOrder == be)
      return;
    const Je = ve.getSource(), nt = ve.getDeclutter(), st = Je.getTileGrid(), lt = Je.getTileGridForProjection(ae).getTileCoordExtent(Z.wrappedTileCoord), ft = Je.getSourceTiles(ee, ae, Z), gt = getUid(ve);
    delete Z.hitDetectionImageData[gt], Z.executorGroups[gt] = [], nt && (Z.declutterExecutorGroups[gt] = []), Qe.dirty = !1;
    for (let ct = 0, _r = ft.length; ct < _r; ++ct) {
      const Kr = ft[ct];
      if (Kr.getState() != TileState.LOADED)
        continue;
      const Xr = Kr.tileCoord, Jr = st.getTileCoordExtent(Xr), ei = getIntersection(lt, Jr), si = buffer$1(
        ei,
        ve.getRenderBuffer() * Ye,
        this.tmpExtent
      ), ri = equals$1(Jr, ei) ? null : si, ai = new BuilderGroup(
        0,
        si,
        Ye,
        ee
      ), yi = nt ? new BuilderGroup(0, ei, Ye, ee) : void 0, pi = getSquaredTolerance(
        Ye,
        ee
      ), di = function(Si) {
        let gi;
        const _i = Si.getStyleFunction() || ve.getStyleFunction();
        if (_i && (gi = _i(Si, Ye)), gi) {
          const Oi = this.renderFeature(
            Si,
            pi,
            gi,
            ai,
            yi
          );
          Qe.dirty = Qe.dirty || Oi;
        }
      }, xi = Kr.getFeatures();
      be && be !== Qe.renderedRenderOrder && xi.sort(be);
      for (let Si = 0, gi = xi.length; Si < gi; ++Si) {
        const _i = xi[Si];
        (!ri || intersects$1(ri, _i.getGeometry().getExtent())) && di.call(this, _i);
      }
      const Ti = ai.finish(), Ai = ve.getRenderMode() !== "vector" && nt && ft.length === 1 ? null : ei, mi = new ExecutorGroup(
        Ai,
        Ye,
        ee,
        Je.getOverlaps(),
        Ti,
        ve.getRenderBuffer()
      );
      if (Z.executorGroups[gt].push(mi), yi) {
        const Si = new ExecutorGroup(
          null,
          Ye,
          ee,
          Je.getOverlaps(),
          yi.finish(),
          ve.getRenderBuffer()
        );
        Z.declutterExecutorGroups[gt].push(Si);
      }
    }
    Qe.renderedRevision = ye, Qe.renderedRenderOrder = be, Qe.renderedResolution = Ye;
  }
  /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */
  forEachFeatureAtCoordinate(Z, ee, ae, ve, ye) {
    const be = ee.viewState.resolution, Ye = ee.viewState.rotation;
    ae = ae ?? 0;
    const Qe = this.getLayer(), nt = Qe.getSource().getTileGridForProjection(
      ee.viewState.projection
    ), st = boundingExtent([Z]);
    buffer$1(st, be * ae, st);
    const ot = {}, lt = function(ct, _r, Kr) {
      let Xr = ct.getId();
      Xr === void 0 && (Xr = getUid(ct));
      const Jr = ot[Xr];
      if (Jr) {
        if (Jr !== !0 && Kr < Jr.distanceSq) {
          if (Kr === 0)
            return ot[Xr] = !0, ye.splice(ye.lastIndexOf(Jr), 1), ve(ct, Qe, _r);
          Jr.geometry = _r, Jr.distanceSq = Kr;
        }
      } else {
        if (Kr === 0)
          return ot[Xr] = !0, ve(ct, Qe, _r);
        ye.push(
          ot[Xr] = {
            feature: ct,
            layer: Qe,
            geometry: _r,
            distanceSq: Kr,
            callback: ve
          }
        );
      }
    }, ft = (
      /** @type {Array<import("../../VectorRenderTile.js").default>} */
      this.renderedTiles
    );
    let gt;
    for (let ct = 0, _r = ft.length; !gt && ct < _r; ++ct) {
      const Kr = ft[ct], Xr = nt.getTileCoordExtent(Kr.wrappedTileCoord);
      if (!intersects$1(Xr, st))
        continue;
      const Jr = getUid(Qe), ei = [Kr.executorGroups[Jr]], si = Kr.declutterExecutorGroups[Jr];
      si && ei.push(si), ei.some((ri) => {
        const ai = ri === si ? ee.declutterTree.all().map((yi) => yi.value) : null;
        for (let yi = 0, pi = ri.length; yi < pi; ++yi)
          if (gt = ri[yi].forEachFeatureAtCoordinate(
            Z,
            be,
            Ye,
            ae,
            lt,
            ai
          ), gt)
            return !0;
      });
    }
    return gt;
  }
  /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature.js").FeatureLike>>} Promise that resolves with an array of features.
   */
  getFeatures(Z) {
    return new Promise((ee, ae) => {
      const ve = this.getLayer(), ye = getUid(ve), be = ve.getSource(), Ye = this.renderedProjection, Qe = Ye.getExtent(), Je = this.renderedResolution, nt = be.getTileGridForProjection(Ye), st = apply(
        this.renderedPixelToCoordinateTransform_,
        Z.slice()
      ), ot = nt.getTileCoordForCoordAndResolution(
        st,
        Je
      );
      let lt;
      for (let Xr = 0, Jr = this.renderedTiles.length; Xr < Jr; ++Xr)
        if (ot.toString() === this.renderedTiles[Xr].tileCoord.toString()) {
          if (lt = /** @type {import("../../VectorRenderTile.js").default} */
          this.renderedTiles[Xr], lt.getState() === TileState.LOADED) {
            const ei = nt.getTileCoordExtent(lt.tileCoord);
            be.getWrapX() && Ye.canWrapX() && !containsExtent(Qe, ei) && wrapX$1(st, Ye);
            break;
          }
          lt = void 0;
        }
      if (!lt || lt.loadingSourceTiles > 0) {
        ee([]);
        return;
      }
      const ft = nt.getTileCoordExtent(lt.wrappedTileCoord), gt = getTopLeft(ft), ct = [
        (st[0] - gt[0]) / Je,
        (gt[1] - st[1]) / Je
      ], _r = lt.getSourceTiles().reduce(function(Xr, Jr) {
        return Xr.concat(Jr.getFeatures());
      }, []);
      let Kr = lt.hitDetectionImageData[ye];
      if (!Kr) {
        const Xr = toSize(
          nt.getTileSize(
            nt.getZForResolution(Je, be.zDirection)
          )
        ), Jr = this.renderedRotation_, ei = [
          this.getRenderTransform(
            nt.getTileCoordCenter(lt.wrappedTileCoord),
            Je,
            0,
            HIT_DETECT_RESOLUTION,
            Xr[0] * HIT_DETECT_RESOLUTION,
            Xr[1] * HIT_DETECT_RESOLUTION,
            0
          )
        ];
        Kr = createHitDetectionImageData(
          Xr,
          ei,
          _r,
          ve.getStyleFunction(),
          nt.getTileCoordExtent(lt.wrappedTileCoord),
          lt.getReplayState(ve).renderedResolution,
          Jr
        ), lt.hitDetectionImageData[ye] = Kr;
      }
      ee(hitDetect(ct, _r, Kr));
    });
  }
  /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   */
  handleFontsChanged() {
    const Z = this.getLayer();
    Z.getVisible() && this.renderedLayerRevision_ !== void 0 && Z.changed();
  }
  /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */
  handleStyleImageChange_(Z) {
    this.renderIfReadyAndVisible();
  }
  /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */
  renderDeclutter(Z) {
    const ee = this.context, ae = ee.globalAlpha;
    ee.globalAlpha = this.getLayer().getOpacity();
    const ve = Z.viewHints, ye = !(ve[ViewHint.ANIMATING] || ve[ViewHint.INTERACTING]), be = (
      /** @type {Array<import("../../VectorRenderTile.js").default>} */
      this.renderedTiles
    );
    for (let Ye = 0, Qe = be.length; Ye < Qe; ++Ye) {
      const Je = be[Ye], nt = Je.declutterExecutorGroups[getUid(this.getLayer())];
      if (nt)
        for (let st = nt.length - 1; st >= 0; --st)
          nt[st].execute(
            this.context,
            1,
            this.getTileRenderTransform(Je, Z),
            Z.viewState.rotation,
            ye,
            void 0,
            Z.declutterTree
          );
    }
    ee.globalAlpha = ae;
  }
  getTileRenderTransform(Z, ee) {
    const ae = ee.pixelRatio, ve = ee.viewState, ye = ve.center, be = ve.resolution, Ye = ve.rotation, Qe = ee.size, Je = Math.round(Qe[0] * ae), nt = Math.round(Qe[1] * ae), ot = this.getLayer().getSource().getTileGridForProjection(
      ee.viewState.projection
    ), lt = Z.tileCoord, ft = ot.getTileCoordExtent(Z.wrappedTileCoord), gt = ot.getTileCoordExtent(lt, this.tmpExtent)[0] - ft[0];
    return multiply(
      scale$3(this.inversePixelTransform.slice(), 1 / ae, 1 / ae),
      this.getRenderTransform(
        ye,
        be,
        Ye,
        ae,
        Je,
        nt,
        gt
      )
    );
  }
  /**
   * Render the vectors for this layer.
   * @param {CanvasRenderingContext2D} context Target context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */
  postRender(Z, ee) {
    const ae = ee.viewHints, ve = !(ae[ViewHint.ANIMATING] || ae[ViewHint.INTERACTING]);
    this.renderedPixelToCoordinateTransform_ = ee.pixelToCoordinateTransform.slice(), this.renderedRotation_ = ee.viewState.rotation;
    const ye = (
      /** @type {import("../../layer/VectorTile.js").default} */
      this.getLayer()
    ), be = ye.getRenderMode(), Ye = Z.globalAlpha;
    Z.globalAlpha = ye.getOpacity();
    const Qe = VECTOR_REPLAYS[be], Je = ee.viewState, nt = Je.rotation, st = ye.getSource(), lt = st.getTileGridForProjection(Je.projection).getZForResolution(
      Je.resolution,
      st.zDirection
    ), ft = this.renderedTiles, gt = [], ct = [];
    let _r = !0;
    for (let Kr = ft.length - 1; Kr >= 0; --Kr) {
      const Xr = (
        /** @type {import("../../VectorRenderTile.js").default} */
        ft[Kr]
      );
      _r = _r && !Xr.getReplayState(ye).dirty;
      const Jr = Xr.executorGroups[getUid(ye)].filter(
        (yi) => yi.hasExecutors(Qe)
      );
      if (Jr.length === 0)
        continue;
      const ei = this.getTileRenderTransform(Xr, ee), si = Xr.tileCoord[0];
      let ri = !1;
      const ai = Jr[0].getClipCoords(ei);
      if (ai) {
        for (let yi = 0, pi = gt.length; yi < pi; ++yi)
          if (lt !== si && si < ct[yi]) {
            const di = gt[yi];
            intersects$1(
              [
                ai[0],
                ai[3],
                ai[4],
                ai[7]
              ],
              [di[0], di[3], di[4], di[7]]
            ) && (ri || (Z.save(), ri = !0), Z.beginPath(), Z.moveTo(ai[0], ai[1]), Z.lineTo(ai[2], ai[3]), Z.lineTo(ai[4], ai[5]), Z.lineTo(ai[6], ai[7]), Z.moveTo(di[6], di[7]), Z.lineTo(di[4], di[5]), Z.lineTo(di[2], di[3]), Z.lineTo(di[0], di[1]), Z.clip());
          }
        gt.push(ai), ct.push(si);
      }
      for (let yi = 0, pi = Jr.length; yi < pi; ++yi)
        Jr[yi].execute(
          Z,
          1,
          ei,
          nt,
          ve,
          Qe
        );
      ri && Z.restore();
    }
    Z.globalAlpha = Ye, this.ready = _r, super.postRender(Z, ee);
  }
  /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
   * @param {import("../../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder group for decluttering.
   * @return {boolean} `true` if an image is loading.
   */
  renderFeature(Z, ee, ae, ve, ye) {
    if (!ae)
      return !1;
    let be = !1;
    if (Array.isArray(ae))
      for (let Ye = 0, Qe = ae.length; Ye < Qe; ++Ye)
        be = renderFeature(
          ve,
          Z,
          ae[Ye],
          ee,
          this.boundHandleStyleImageChange_,
          void 0,
          ye
        ) || be;
    else
      be = renderFeature(
        ve,
        Z,
        ae,
        ee,
        this.boundHandleStyleImageChange_,
        void 0,
        ye
      );
    return be;
  }
  /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @return {boolean} A new tile image was rendered.
   * @private
   */
  tileImageNeedsRender_(Z) {
    const ee = (
      /** @type {import("../../layer/VectorTile.js").default} */
      this.getLayer()
    );
    if (ee.getRenderMode() === "vector")
      return !1;
    const ae = Z.getReplayState(ee), ve = ee.getRevision(), ye = Z.wantedResolution;
    return ae.renderedTileResolution !== ye || ae.renderedTileRevision !== ve;
  }
  /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @param {import("../../Map").FrameState} frameState Frame state.
   * @private
   */
  renderTileImage_(Z, ee) {
    const ae = (
      /** @type {import("../../layer/VectorTile.js").default} */
      this.getLayer()
    ), ve = Z.getReplayState(ae), ye = ae.getRevision(), be = Z.executorGroups[getUid(ae)];
    ve.renderedTileRevision = ye;
    const Ye = Z.wrappedTileCoord, Qe = Ye[0], Je = ae.getSource();
    let nt = ee.pixelRatio;
    const ot = ee.viewState.projection, lt = Je.getTileGridForProjection(ot), ft = lt.getResolution(Z.tileCoord[0]), gt = ee.pixelRatio / Z.wantedResolution * ft, ct = lt.getResolution(Qe), _r = Z.getContext(ae);
    nt = Math.round(
      Math.max(nt, gt / nt)
    );
    const Kr = Je.getTilePixelSize(Qe, nt, ot);
    _r.canvas.width = Kr[0], _r.canvas.height = Kr[1];
    const Xr = nt / gt;
    if (Xr !== 1) {
      const ri = reset(this.tmpTransform_);
      scale$3(ri, Xr, Xr), _r.setTransform.apply(_r, ri);
    }
    const Jr = lt.getTileCoordExtent(Ye, this.tmpExtent), ei = gt / ct, si = reset(this.tmpTransform_);
    scale$3(si, ei, -ei), translate$1(si, -Jr[0], -Jr[3]);
    for (let ri = 0, ai = be.length; ri < ai; ++ri)
      be[ri].execute(
        _r,
        Xr,
        si,
        0,
        !0,
        IMAGE_REPLAYS[ae.getRenderMode()]
      );
    ve.renderedTileResolution = Z.wantedResolution;
  }
}
class VectorTileLayer extends BaseVectorLayer {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {};
    const ee = (
      /** @type {Object} */
      Object.assign({}, Z)
    );
    delete ee.preload, delete ee.useInterimTilesOnError, super(
      /** @type {import("./BaseVector.js").Options<import("../source/VectorTile.js").default>} */
      ee
    ), this.on, this.once, this.un;
    const ae = Z.renderMode || "hybrid";
    assert(
      ae == "hybrid" || ae == "vector",
      "`renderMode` must be `'hybrid'` or `'vector'`"
    ), this.renderMode_ = ae, this.setPreload(Z.preload ? Z.preload : 0), this.setUseInterimTilesOnError(
      Z.useInterimTilesOnError !== void 0 ? Z.useInterimTilesOnError : !0
    ), this.getBackground, this.setBackground;
  }
  createRenderer() {
    return new CanvasVectorTileLayerRenderer(this);
  }
  /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   */
  getFeatures(Z) {
    return super.getFeatures(Z);
  }
  /**
   * @return {VectorTileRenderType} The render mode.
   */
  getRenderMode() {
    return this.renderMode_;
  }
  /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */
  getPreload() {
    return (
      /** @type {number} */
      this.get(TileProperty.PRELOAD)
    );
  }
  /**
   * Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */
  getUseInterimTilesOnError() {
    return (
      /** @type {boolean} */
      this.get(TileProperty.USE_INTERIM_TILES_ON_ERROR)
    );
  }
  /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */
  setPreload(Z) {
    this.set(TileProperty.PRELOAD, Z);
  }
  /**
   * Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */
  setUseInterimTilesOnError(Z) {
    this.set(TileProperty.USE_INTERIM_TILES_ON_ERROR, Z);
  }
}
const TileEventType = {
  /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */
  TILELOADSTART: "tileloadstart",
  /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */
  TILELOADEND: "tileloadend",
  /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */
  TILELOADERROR: "tileloaderror"
}, tmpTileCoord = [0, 0, 0], DECIMALS = 5;
class TileGrid {
  /**
   * @param {Options} options Tile grid options.
   */
  constructor(Z) {
    this.minZoom = Z.minZoom !== void 0 ? Z.minZoom : 0, this.resolutions_ = Z.resolutions, assert(
      isSorted(
        this.resolutions_,
        function(ve, ye) {
          return ye - ve;
        },
        !0
      ),
      "`resolutions` must be sorted in descending order"
    );
    let ee;
    if (!Z.origins) {
      for (let ve = 0, ye = this.resolutions_.length - 1; ve < ye; ++ve)
        if (!ee)
          ee = this.resolutions_[ve] / this.resolutions_[ve + 1];
        else if (this.resolutions_[ve] / this.resolutions_[ve + 1] !== ee) {
          ee = void 0;
          break;
        }
    }
    this.zoomFactor_ = ee, this.maxZoom = this.resolutions_.length - 1, this.origin_ = Z.origin !== void 0 ? Z.origin : null, this.origins_ = null, Z.origins !== void 0 && (this.origins_ = Z.origins, assert(
      this.origins_.length == this.resolutions_.length,
      "Number of `origins` and `resolutions` must be equal"
    ));
    const ae = Z.extent;
    ae !== void 0 && !this.origin_ && !this.origins_ && (this.origin_ = getTopLeft(ae)), assert(
      !this.origin_ && this.origins_ || this.origin_ && !this.origins_,
      "Either `origin` or `origins` must be configured, never both"
    ), this.tileSizes_ = null, Z.tileSizes !== void 0 && (this.tileSizes_ = Z.tileSizes, assert(
      this.tileSizes_.length == this.resolutions_.length,
      "Number of `tileSizes` and `resolutions` must be equal"
    )), this.tileSize_ = Z.tileSize !== void 0 ? Z.tileSize : this.tileSizes_ ? null : DEFAULT_TILE_SIZE, assert(
      !this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_,
      "Either `tileSize` or `tileSizes` must be configured, never both"
    ), this.extent_ = ae !== void 0 ? ae : null, this.fullTileRanges_ = null, this.tmpSize_ = [0, 0], this.tmpExtent_ = [0, 0, 0, 0], Z.sizes !== void 0 ? this.fullTileRanges_ = Z.sizes.map(function(ve, ye) {
      const be = new TileRange(
        Math.min(0, ve[0]),
        Math.max(ve[0] - 1, -1),
        Math.min(0, ve[1]),
        Math.max(ve[1] - 1, -1)
      );
      if (ae) {
        const Ye = this.getTileRangeForExtentAndZ(ae, ye);
        be.minX = Math.max(Ye.minX, be.minX), be.maxX = Math.min(Ye.maxX, be.maxX), be.minY = Math.max(Ye.minY, be.minY), be.maxY = Math.min(Ye.maxY, be.maxY);
      }
      return be;
    }, this) : ae && this.calculateTileRanges_(ae);
  }
  /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */
  forEachTileCoord(Z, ee, ae) {
    const ve = this.getTileRangeForExtentAndZ(Z, ee);
    for (let ye = ve.minX, be = ve.maxX; ye <= be; ++ye)
      for (let Ye = ve.minY, Qe = ve.maxY; Ye <= Qe; ++Ye)
        ae([ee, ye, Ye]);
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */
  forEachTileCoordParentTileRange(Z, ee, ae, ve) {
    let ye, be, Ye, Qe = null, Je = Z[0] - 1;
    for (this.zoomFactor_ === 2 ? (be = Z[1], Ye = Z[2]) : Qe = this.getTileCoordExtent(Z, ve); Je >= this.minZoom; ) {
      if (this.zoomFactor_ === 2 ? (be = Math.floor(be / 2), Ye = Math.floor(Ye / 2), ye = createOrUpdate(be, be, Ye, Ye, ae)) : ye = this.getTileRangeForExtentAndZ(
        Qe,
        Je,
        ae
      ), ee(Je, ye))
        return !0;
      --Je;
    }
    return !1;
  }
  /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getExtent() {
    return this.extent_;
  }
  /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */
  getMaxZoom() {
    return this.maxZoom;
  }
  /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */
  getMinZoom() {
    return this.minZoom;
  }
  /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */
  getOrigin(Z) {
    return this.origin_ ? this.origin_ : this.origins_[Z];
  }
  /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */
  getResolution(Z) {
    return this.resolutions_[Z];
  }
  /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */
  getResolutions() {
    return this.resolutions_;
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */
  getTileCoordChildTileRange(Z, ee, ae) {
    if (Z[0] < this.maxZoom) {
      if (this.zoomFactor_ === 2) {
        const ye = Z[1] * 2, be = Z[2] * 2;
        return createOrUpdate(
          ye,
          ye + 1,
          be,
          be + 1,
          ee
        );
      }
      const ve = this.getTileCoordExtent(
        Z,
        ae || this.tmpExtent_
      );
      return this.getTileRangeForExtentAndZ(
        ve,
        Z[0] + 1,
        ee
      );
    }
    return null;
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */
  getTileRangeForTileCoordAndZ(Z, ee, ae) {
    if (ee > this.maxZoom || ee < this.minZoom)
      return null;
    const ve = Z[0], ye = Z[1], be = Z[2];
    if (ee === ve)
      return createOrUpdate(
        ye,
        be,
        ye,
        be,
        ae
      );
    if (this.zoomFactor_) {
      const Qe = Math.pow(this.zoomFactor_, ee - ve), Je = Math.floor(ye * Qe), nt = Math.floor(be * Qe);
      if (ee < ve)
        return createOrUpdate(Je, Je, nt, nt, ae);
      const st = Math.floor(Qe * (ye + 1)) - 1, ot = Math.floor(Qe * (be + 1)) - 1;
      return createOrUpdate(Je, st, nt, ot, ae);
    }
    const Ye = this.getTileCoordExtent(Z, this.tmpExtent_);
    return this.getTileRangeForExtentAndZ(Ye, ee, ae);
  }
  /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */
  getTileRangeForExtentAndZ(Z, ee, ae) {
    this.getTileCoordForXYAndZ_(Z[0], Z[3], ee, !1, tmpTileCoord);
    const ve = tmpTileCoord[1], ye = tmpTileCoord[2];
    this.getTileCoordForXYAndZ_(Z[2], Z[1], ee, !0, tmpTileCoord);
    const be = tmpTileCoord[1], Ye = tmpTileCoord[2];
    return createOrUpdate(ve, be, ye, Ye, ae);
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */
  getTileCoordCenter(Z) {
    const ee = this.getOrigin(Z[0]), ae = this.getResolution(Z[0]), ve = toSize(this.getTileSize(Z[0]), this.tmpSize_);
    return [
      ee[0] + (Z[1] + 0.5) * ve[0] * ae,
      ee[1] - (Z[2] + 0.5) * ve[1] * ae
    ];
  }
  /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getTileCoordExtent(Z, ee) {
    const ae = this.getOrigin(Z[0]), ve = this.getResolution(Z[0]), ye = toSize(this.getTileSize(Z[0]), this.tmpSize_), be = ae[0] + Z[1] * ye[0] * ve, Ye = ae[1] - (Z[2] + 1) * ye[1] * ve, Qe = be + ye[0] * ve, Je = Ye + ye[1] * ve;
    return createOrUpdate$2(be, Ye, Qe, Je, ee);
  }
  /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */
  getTileCoordForCoordAndResolution(Z, ee, ae) {
    return this.getTileCoordForXYAndResolution_(
      Z[0],
      Z[1],
      ee,
      !1,
      ae
    );
  }
  /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */
  getTileCoordForXYAndResolution_(Z, ee, ae, ve, ye) {
    const be = this.getZForResolution(ae), Ye = ae / this.getResolution(be), Qe = this.getOrigin(be), Je = toSize(this.getTileSize(be), this.tmpSize_);
    let nt = Ye * (Z - Qe[0]) / ae / Je[0], st = Ye * (Qe[1] - ee) / ae / Je[1];
    return ve ? (nt = ceil(nt, DECIMALS) - 1, st = ceil(st, DECIMALS) - 1) : (nt = floor$1(nt, DECIMALS), st = floor$1(st, DECIMALS)), createOrUpdate$1(be, nt, st, ye);
  }
  /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */
  getTileCoordForXYAndZ_(Z, ee, ae, ve, ye) {
    const be = this.getOrigin(ae), Ye = this.getResolution(ae), Qe = toSize(this.getTileSize(ae), this.tmpSize_);
    let Je = (Z - be[0]) / Ye / Qe[0], nt = (be[1] - ee) / Ye / Qe[1];
    return ve ? (Je = ceil(Je, DECIMALS) - 1, nt = ceil(nt, DECIMALS) - 1) : (Je = floor$1(Je, DECIMALS), nt = floor$1(nt, DECIMALS)), createOrUpdate$1(ae, Je, nt, ye);
  }
  /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Zoom level.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */
  getTileCoordForCoordAndZ(Z, ee, ae) {
    return this.getTileCoordForXYAndZ_(
      Z[0],
      Z[1],
      ee,
      !1,
      ae
    );
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */
  getTileCoordResolution(Z) {
    return this.resolutions_[Z[0]];
  }
  /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */
  getTileSize(Z) {
    return this.tileSize_ ? this.tileSize_ : this.tileSizes_[Z];
  }
  /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default} Extent tile range for the specified zoom level.
   */
  getFullTileRange(Z) {
    return this.fullTileRanges_ ? this.fullTileRanges_[Z] : this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, Z) : null;
  }
  /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */
  getZForResolution(Z, ee) {
    const ae = linearFindNearest(
      this.resolutions_,
      Z,
      ee || 0
    );
    return clamp$1(ae, this.minZoom, this.maxZoom);
  }
  /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */
  tileCoordIntersectsViewport(Z, ee) {
    return intersectsLinearRing(
      ee,
      0,
      ee.length,
      2,
      this.getTileCoordExtent(Z)
    );
  }
  /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */
  calculateTileRanges_(Z) {
    const ee = this.resolutions_.length, ae = new Array(ee);
    for (let ve = this.minZoom; ve < ee; ++ve)
      ae[ve] = this.getTileRangeForExtentAndZ(Z, ve);
    this.fullTileRanges_ = ae;
  }
}
function getForProjection(ie) {
  let Z = ie.getDefaultTileGrid();
  return Z || (Z = createForProjection(ie), ie.setDefaultTileGrid(Z)), Z;
}
function wrapX(ie, Z, ee) {
  const ae = Z[0], ve = ie.getTileCoordCenter(Z), ye = extentFromProjection(ee);
  if (!containsCoordinate(ye, ve)) {
    const be = getWidth(ye), Ye = Math.ceil(
      (ye[0] - ve[0]) / be
    );
    return ve[0] += be * Ye, ie.getTileCoordForCoordAndZ(ve, ae);
  }
  return Z;
}
function createForExtent(ie, Z, ee, ae) {
  ae = ae !== void 0 ? ae : "top-left";
  const ve = resolutionsFromExtent(ie, Z, ee);
  return new TileGrid({
    extent: ie,
    origin: getCorner(ie, ae),
    resolutions: ve,
    tileSize: ee
  });
}
function createXYZ(ie) {
  const Z = ie || {}, ee = Z.extent || get$1("EPSG:3857").getExtent(), ae = {
    extent: ee,
    minZoom: Z.minZoom,
    tileSize: Z.tileSize,
    resolutions: resolutionsFromExtent(
      ee,
      Z.maxZoom,
      Z.tileSize,
      Z.maxResolution
    )
  };
  return new TileGrid(ae);
}
function resolutionsFromExtent(ie, Z, ee, ae) {
  Z = Z !== void 0 ? Z : DEFAULT_MAX_ZOOM, ee = toSize(ee !== void 0 ? ee : DEFAULT_TILE_SIZE);
  const ve = getHeight(ie), ye = getWidth(ie);
  ae = ae > 0 ? ae : Math.max(ye / ee[0], ve / ee[1]);
  const be = Z + 1, Ye = new Array(be);
  for (let Qe = 0; Qe < be; ++Qe)
    Ye[Qe] = ae / Math.pow(2, Qe);
  return Ye;
}
function createForProjection(ie, Z, ee, ae) {
  const ve = extentFromProjection(ie);
  return createForExtent(ve, Z, ee, ae);
}
function extentFromProjection(ie) {
  ie = get$1(ie);
  let Z = ie.getExtent();
  if (!Z) {
    const ee = 180 * METERS_PER_UNIT$1.degrees / ie.getMetersPerUnit();
    Z = createOrUpdate$2(-ee, -ee, ee, ee);
  }
  return Z;
}
class TileSource extends Source {
  /**
   * @param {Options} options SourceTile source options.
   */
  constructor(Z) {
    super({
      attributions: Z.attributions,
      attributionsCollapsible: Z.attributionsCollapsible,
      projection: Z.projection,
      state: Z.state,
      wrapX: Z.wrapX,
      interpolate: Z.interpolate
    }), this.on, this.once, this.un, this.opaque_ = Z.opaque !== void 0 ? Z.opaque : !1, this.tilePixelRatio_ = Z.tilePixelRatio !== void 0 ? Z.tilePixelRatio : 1, this.tileGrid = Z.tileGrid !== void 0 ? Z.tileGrid : null;
    const ee = [256, 256];
    this.tileGrid && toSize(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), ee), this.tileCache = new TileCache(Z.cacheSize || 0), this.tmpSize = [0, 0], this.key_ = Z.key || "", this.tileOptions = {
      transition: Z.transition,
      interpolate: Z.interpolate
    }, this.zDirection = Z.zDirection ? Z.zDirection : 0;
  }
  /**
   * @return {boolean} Can expire cache.
   */
  canExpireCache() {
    return this.tileCache.canExpireCache();
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */
  expireCache(Z, ee) {
    const ae = this.getTileCacheForProjection(Z);
    ae && ae.expireCache(ee);
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {number} z Zoom level.
   * @param {import("../TileRange.js").default} tileRange Tile range.
   * @param {function(import("../Tile.js").default):(boolean|void)} callback Called with each
   *     loaded tile.  If the callback returns `false`, the tile will not be
   *     considered loaded.
   * @return {boolean} The tile range is fully covered with loaded tiles.
   */
  forEachLoadedTile(Z, ee, ae, ve) {
    const ye = this.getTileCacheForProjection(Z);
    if (!ye)
      return !1;
    let be = !0, Ye, Qe, Je;
    for (let nt = ae.minX; nt <= ae.maxX; ++nt)
      for (let st = ae.minY; st <= ae.maxY; ++st)
        Qe = getKeyZXY(ee, nt, st), Je = !1, ye.containsKey(Qe) && (Ye = /** @type {!import("../Tile.js").default} */
        ye.get(Qe), Je = Ye.getState() === TileState.LOADED, Je && (Je = ve(Ye) !== !1)), Je || (be = !1);
    return be;
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */
  getGutterForProjection(Z) {
    return 0;
  }
  /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */
  getKey() {
    return this.key_;
  }
  /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */
  setKey(Z) {
    this.key_ !== Z && (this.key_ = Z, this.changed());
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {boolean} Opaque.
   */
  getOpaque(Z) {
    return this.opaque_;
  }
  /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */
  getResolutions(Z) {
    const ee = Z ? this.getTileGridForProjection(Z) : this.tileGrid;
    return ee ? ee.getResolutions() : null;
  }
  /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../Tile.js").default} Tile.
   */
  getTile(Z, ee, ae, ve, ye) {
    return abstract();
  }
  /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */
  getTileGrid() {
    return this.tileGrid;
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */
  getTileGridForProjection(Z) {
    return this.tileGrid ? this.tileGrid : getForProjection(Z);
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   * @protected
   */
  getTileCacheForProjection(Z) {
    const ee = this.getProjection();
    return assert(
      ee === null || equivalent(ee, Z),
      "A VectorTile source can only be rendered if it has a projection compatible with the view projection."
    ), this.tileCache;
  }
  /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */
  getTilePixelRatio(Z) {
    return this.tilePixelRatio_;
  }
  /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */
  getTilePixelSize(Z, ee, ae) {
    const ve = this.getTileGridForProjection(ae), ye = this.getTilePixelRatio(ee), be = toSize(ve.getTileSize(Z), this.tmpSize);
    return ye == 1 ? be : scale(be, ye, this.tmpSize);
  }
  /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */
  getTileCoordForTileUrlFunction(Z, ee) {
    ee = ee !== void 0 ? ee : this.getProjection();
    const ae = this.getTileGridForProjection(ee);
    return this.getWrapX() && ee.isGlobal() && (Z = wrapX(ae, Z, ee)), withinExtentAndZ(Z, ae) ? Z : null;
  }
  /**
   * Remove all cached tiles from the source. The next render cycle will fetch new tiles.
   * @api
   */
  clear() {
    this.tileCache.clear();
  }
  refresh() {
    this.clear(), super.refresh();
  }
  /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */
  updateCacheSize(Z, ee) {
    const ae = this.getTileCacheForProjection(ee);
    Z > ae.highWaterMark && (ae.highWaterMark = Z);
  }
  /**
   * Marks a tile coord as being used, without triggering a load.
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */
  useTile(Z, ee, ae, ve) {
  }
}
class TileSourceEvent extends BaseEvent {
  /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */
  constructor(Z, ee) {
    super(Z), this.tile = ee;
  }
}
function createFromTemplate(ie, Z) {
  const ee = /\{z\}/g, ae = /\{x\}/g, ve = /\{y\}/g, ye = /\{-y\}/g;
  return (
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */
    function(be, Ye, Qe) {
      if (be)
        return ie.replace(ee, be[0].toString()).replace(ae, be[1].toString()).replace(ve, be[2].toString()).replace(ye, function() {
          const Je = be[0], nt = Z.getFullTileRange(Je);
          return assert(
            nt,
            "The {-y} placeholder requires a tile grid with extent"
          ), (nt.getHeight() - be[2] - 1).toString();
        });
    }
  );
}
function createFromTemplates(ie, Z) {
  const ee = ie.length, ae = new Array(ee);
  for (let ve = 0; ve < ee; ++ve)
    ae[ve] = createFromTemplate(ie[ve], Z);
  return createFromTileUrlFunctions(ae);
}
function createFromTileUrlFunctions(ie) {
  return ie.length === 1 ? ie[0] : (
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */
    function(Z, ee, ae) {
      if (!Z)
        return;
      const ve = hash$2(Z), ye = modulo(ve, ie.length);
      return ie[ye](Z, ee, ae);
    }
  );
}
function expandUrl(ie) {
  const Z = [];
  let ee = /\{([a-z])-([a-z])\}/.exec(ie);
  if (ee) {
    const ae = ee[1].charCodeAt(0), ve = ee[2].charCodeAt(0);
    let ye;
    for (ye = ae; ye <= ve; ++ye)
      Z.push(ie.replace(ee[0], String.fromCharCode(ye)));
    return Z;
  }
  if (ee = /\{(\d+)-(\d+)\}/.exec(ie), ee) {
    const ae = parseInt(ee[2], 10);
    for (let ve = parseInt(ee[1], 10); ve <= ae; ve++)
      Z.push(ie.replace(ee[0], ve.toString()));
    return Z;
  }
  return Z.push(ie), Z;
}
class UrlTile extends TileSource {
  /**
   * @param {Options} options Image tile options.
   */
  constructor(Z) {
    super({
      attributions: Z.attributions,
      cacheSize: Z.cacheSize,
      opaque: Z.opaque,
      projection: Z.projection,
      state: Z.state,
      tileGrid: Z.tileGrid,
      tilePixelRatio: Z.tilePixelRatio,
      wrapX: Z.wrapX,
      transition: Z.transition,
      interpolate: Z.interpolate,
      key: Z.key,
      attributionsCollapsible: Z.attributionsCollapsible,
      zDirection: Z.zDirection
    }), this.generateTileUrlFunction_ = this.tileUrlFunction === UrlTile.prototype.tileUrlFunction, this.tileLoadFunction = Z.tileLoadFunction, Z.tileUrlFunction && (this.tileUrlFunction = Z.tileUrlFunction), this.urls = null, Z.urls ? this.setUrls(Z.urls) : Z.url && this.setUrl(Z.url), this.tileLoadingKeys_ = {};
  }
  /**
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */
  getTileLoadFunction() {
    return this.tileLoadFunction;
  }
  /**
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */
  getTileUrlFunction() {
    return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
  }
  /**
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */
  getUrls() {
    return this.urls;
  }
  /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */
  handleTileChange(Z) {
    const ee = (
      /** @type {import("../Tile.js").default} */
      Z.target
    ), ae = getUid(ee), ve = ee.getState();
    let ye;
    ve == TileState.LOADING ? (this.tileLoadingKeys_[ae] = !0, ye = TileEventType.TILELOADSTART) : ae in this.tileLoadingKeys_ && (delete this.tileLoadingKeys_[ae], ye = ve == TileState.ERROR ? TileEventType.TILELOADERROR : ve == TileState.LOADED ? TileEventType.TILELOADEND : void 0), ye != null && this.dispatchEvent(new TileSourceEvent(ye, ee));
  }
  /**
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */
  setTileLoadFunction(Z) {
    this.tileCache.clear(), this.tileLoadFunction = Z, this.changed();
  }
  /**
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */
  setTileUrlFunction(Z, ee) {
    this.tileUrlFunction = Z, this.tileCache.pruneExceptNewestZ(), typeof ee < "u" ? this.setKey(ee) : this.changed();
  }
  /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */
  setUrl(Z) {
    const ee = expandUrl(Z);
    this.urls = ee, this.setUrls(ee);
  }
  /**
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */
  setUrls(Z) {
    this.urls = Z;
    const ee = Z.join(`
`);
    this.generateTileUrlFunction_ ? this.setTileUrlFunction(createFromTemplates(Z, this.tileGrid), ee) : this.setKey(ee);
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */
  tileUrlFunction(Z, ee, ae) {
  }
  /**
   * Marks a tile coord as being used, without triggering a load.
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   */
  useTile(Z, ee, ae) {
    const ve = getKeyZXY(Z, ee, ae);
    this.tileCache.containsKey(ve) && this.tileCache.get(ve);
  }
}
class TileImage extends UrlTile {
  /**
   * @param {!Options} options Image tile options.
   */
  constructor(Z) {
    super({
      attributions: Z.attributions,
      cacheSize: Z.cacheSize,
      opaque: Z.opaque,
      projection: Z.projection,
      state: Z.state,
      tileGrid: Z.tileGrid,
      tileLoadFunction: Z.tileLoadFunction ? Z.tileLoadFunction : defaultTileLoadFunction,
      tilePixelRatio: Z.tilePixelRatio,
      tileUrlFunction: Z.tileUrlFunction,
      url: Z.url,
      urls: Z.urls,
      wrapX: Z.wrapX,
      transition: Z.transition,
      interpolate: Z.interpolate !== void 0 ? Z.interpolate : !0,
      key: Z.key,
      attributionsCollapsible: Z.attributionsCollapsible,
      zDirection: Z.zDirection
    }), this.crossOrigin = Z.crossOrigin !== void 0 ? Z.crossOrigin : null, this.tileClass = Z.tileClass !== void 0 ? Z.tileClass : ImageTile, this.tileCacheForProjection = {}, this.tileGridForProjection = {}, this.reprojectionErrorThreshold_ = Z.reprojectionErrorThreshold, this.renderReprojectionEdges_ = !1;
  }
  /**
   * @return {boolean} Can expire cache.
   */
  canExpireCache() {
    if (this.tileCache.canExpireCache())
      return !0;
    for (const Z in this.tileCacheForProjection)
      if (this.tileCacheForProjection[Z].canExpireCache())
        return !0;
    return !1;
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */
  expireCache(Z, ee) {
    const ae = this.getTileCacheForProjection(Z);
    this.tileCache.expireCache(
      this.tileCache == ae ? ee : {}
    );
    for (const ve in this.tileCacheForProjection) {
      const ye = this.tileCacheForProjection[ve];
      ye.expireCache(ye == ae ? ee : {});
    }
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */
  getGutterForProjection(Z) {
    return this.getProjection() && Z && !equivalent(this.getProjection(), Z) ? 0 : this.getGutter();
  }
  /**
   * @return {number} Gutter.
   */
  getGutter() {
    return 0;
  }
  /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */
  getKey() {
    let Z = super.getKey();
    return this.getInterpolate() || (Z += ":disable-interpolation"), Z;
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {boolean} Opaque.
   */
  getOpaque(Z) {
    return this.getProjection() && Z && !equivalent(this.getProjection(), Z) ? !1 : super.getOpaque(Z);
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */
  getTileGridForProjection(Z) {
    const ee = this.getProjection();
    if (this.tileGrid && (!ee || equivalent(ee, Z)))
      return this.tileGrid;
    const ae = getUid(Z);
    return ae in this.tileGridForProjection || (this.tileGridForProjection[ae] = getForProjection(Z)), this.tileGridForProjection[ae];
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   */
  getTileCacheForProjection(Z) {
    const ee = this.getProjection();
    if (!ee || equivalent(ee, Z))
      return this.tileCache;
    const ae = getUid(Z);
    return ae in this.tileCacheForProjection || (this.tileCacheForProjection[ae] = new TileCache(
      this.tileCache.highWaterMark
    )), this.tileCacheForProjection[ae];
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */
  createTile_(Z, ee, ae, ve, ye, be) {
    const Ye = [Z, ee, ae], Qe = this.getTileCoordForTileUrlFunction(
      Ye,
      ye
    ), Je = Qe ? this.tileUrlFunction(Qe, ve, ye) : void 0, nt = new this.tileClass(
      Ye,
      Je !== void 0 ? TileState.IDLE : TileState.EMPTY,
      Je !== void 0 ? Je : "",
      this.crossOrigin,
      this.tileLoadFunction,
      this.tileOptions
    );
    return nt.key = be, nt.addEventListener(EventType.CHANGE, this.handleTileChange.bind(this)), nt;
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!(ImageTile|ReprojTile)} Tile.
   */
  getTile(Z, ee, ae, ve, ye) {
    const be = this.getProjection();
    if (!be || !ye || equivalent(be, ye))
      return this.getTileInternal(
        Z,
        ee,
        ae,
        ve,
        be || ye
      );
    const Ye = this.getTileCacheForProjection(ye), Qe = [Z, ee, ae];
    let Je;
    const nt = getKey(Qe);
    Ye.containsKey(nt) && (Je = Ye.get(nt));
    const st = this.getKey();
    if (Je && Je.key == st)
      return Je;
    const ot = this.getTileGridForProjection(be), lt = this.getTileGridForProjection(ye), ft = this.getTileCoordForTileUrlFunction(
      Qe,
      ye
    ), gt = new ReprojTile(
      be,
      ot,
      ye,
      lt,
      Qe,
      ft,
      this.getTilePixelRatio(ve),
      this.getGutter(),
      (ct, _r, Kr, Xr) => this.getTileInternal(ct, _r, Kr, Xr, be),
      this.reprojectionErrorThreshold_,
      this.renderReprojectionEdges_,
      this.getInterpolate()
    );
    return gt.key = st, Je ? (gt.interimTile = Je, gt.refreshInterimChain(), Ye.replace(nt, gt)) : Ye.set(nt, gt), gt;
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @return {!ImageTile} Tile.
   * @protected
   */
  getTileInternal(Z, ee, ae, ve, ye) {
    let be = null;
    const Ye = getKeyZXY(Z, ee, ae), Qe = this.getKey();
    if (!this.tileCache.containsKey(Ye))
      be = this.createTile_(Z, ee, ae, ve, ye, Qe), this.tileCache.set(Ye, be);
    else if (be = this.tileCache.get(Ye), be.key != Qe) {
      const Je = be;
      be = this.createTile_(Z, ee, ae, ve, ye, Qe), Je.getState() == TileState.IDLE ? be.interimTile = Je.interimTile : be.interimTile = Je, be.refreshInterimChain(), this.tileCache.replace(Ye, be);
    }
    return be;
  }
  /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */
  setRenderReprojectionEdges(Z) {
    if (this.renderReprojectionEdges_ != Z) {
      this.renderReprojectionEdges_ = Z;
      for (const ee in this.tileCacheForProjection)
        this.tileCacheForProjection[ee].clear();
      this.changed();
    }
  }
  /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */
  setTileGridForProjection(Z, ee) {
    const ae = get$1(Z);
    if (ae) {
      const ve = getUid(ae);
      ve in this.tileGridForProjection || (this.tileGridForProjection[ve] = ee);
    }
  }
  clear() {
    super.clear();
    for (const Z in this.tileCacheForProjection)
      this.tileCacheForProjection[Z].clear();
  }
}
function defaultTileLoadFunction(ie, Z) {
  ie.getImage().src = Z;
}
class XYZ extends TileImage {
  /**
   * @param {Options} [options] XYZ options.
   */
  constructor(Z) {
    Z = Z || {};
    const ee = Z.projection !== void 0 ? Z.projection : "EPSG:3857", ae = Z.tileGrid !== void 0 ? Z.tileGrid : createXYZ({
      extent: extentFromProjection(ee),
      maxResolution: Z.maxResolution,
      maxZoom: Z.maxZoom,
      minZoom: Z.minZoom,
      tileSize: Z.tileSize
    });
    super({
      attributions: Z.attributions,
      cacheSize: Z.cacheSize,
      crossOrigin: Z.crossOrigin,
      interpolate: Z.interpolate,
      opaque: Z.opaque,
      projection: ee,
      reprojectionErrorThreshold: Z.reprojectionErrorThreshold,
      tileGrid: ae,
      tileLoadFunction: Z.tileLoadFunction,
      tilePixelRatio: Z.tilePixelRatio,
      tileUrlFunction: Z.tileUrlFunction,
      url: Z.url,
      urls: Z.urls,
      wrapX: Z.wrapX !== void 0 ? Z.wrapX : !0,
      transition: Z.transition,
      attributionsCollapsible: Z.attributionsCollapsible,
      zDirection: Z.zDirection
    }), this.gutter_ = Z.gutter !== void 0 ? Z.gutter : 0;
  }
  /**
   * @return {number} Gutter.
   */
  getGutter() {
    return this.gutter_;
  }
}
class GeometryCollection extends Geometry {
  /**
   * @param {Array<Geometry>} [geometries] Geometries.
   */
  constructor(Z) {
    super(), this.geometries_ = Z || null, this.changeEventsKeys_ = [], this.listenGeometriesChange_();
  }
  /**
   * @private
   */
  unlistenGeometriesChange_() {
    this.changeEventsKeys_.forEach(unlistenByKey), this.changeEventsKeys_.length = 0;
  }
  /**
   * @private
   */
  listenGeometriesChange_() {
    if (this.geometries_)
      for (let Z = 0, ee = this.geometries_.length; Z < ee; ++Z)
        this.changeEventsKeys_.push(
          listen(this.geometries_[Z], EventType.CHANGE, this.changed, this)
        );
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!GeometryCollection} Clone.
   * @api
   */
  clone() {
    const Z = new GeometryCollection(null);
    return Z.setGeometries(this.geometries_), Z.applyProperties(this), Z;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */
  closestPointXY(Z, ee, ae, ve) {
    if (ve < closestSquaredDistanceXY(this.getExtent(), Z, ee))
      return ve;
    const ye = this.geometries_;
    for (let be = 0, Ye = ye.length; be < Ye; ++be)
      ve = ye[be].closestPointXY(
        Z,
        ee,
        ae,
        ve
      );
    return ve;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */
  containsXY(Z, ee) {
    const ae = this.geometries_;
    for (let ve = 0, ye = ae.length; ve < ye; ++ve)
      if (ae[ve].containsXY(Z, ee))
        return !0;
    return !1;
  }
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */
  computeExtent(Z) {
    createOrUpdateEmpty(Z);
    const ee = this.geometries_;
    for (let ae = 0, ve = ee.length; ae < ve; ++ae)
      extend$1(Z, ee[ae].getExtent());
    return Z;
  }
  /**
   * Return the geometries that make up this geometry collection.
   * @return {Array<Geometry>} Geometries.
   * @api
   */
  getGeometries() {
    return cloneGeometries(this.geometries_);
  }
  /**
   * @return {Array<Geometry>} Geometries.
   */
  getGeometriesArray() {
    return this.geometries_;
  }
  /**
   * @return {Array<Geometry>} Geometries.
   */
  getGeometriesArrayRecursive() {
    let Z = [];
    const ee = this.geometries_;
    for (let ae = 0, ve = ee.length; ae < ve; ++ae)
      ee[ae].getType() === this.getType() ? Z = Z.concat(
        /** @type {GeometryCollection} */
        ee[ae].getGeometriesArrayRecursive()
      ) : Z.push(ee[ae]);
    return Z;
  }
  /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {GeometryCollection} Simplified GeometryCollection.
   */
  getSimplifiedGeometry(Z) {
    if (this.simplifiedGeometryRevision !== this.getRevision() && (this.simplifiedGeometryMaxMinSquaredTolerance = 0, this.simplifiedGeometryRevision = this.getRevision()), Z < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && Z < this.simplifiedGeometryMaxMinSquaredTolerance)
      return this;
    const ee = [], ae = this.geometries_;
    let ve = !1;
    for (let ye = 0, be = ae.length; ye < be; ++ye) {
      const Ye = ae[ye], Qe = Ye.getSimplifiedGeometry(Z);
      ee.push(Qe), Qe !== Ye && (ve = !0);
    }
    if (ve) {
      const ye = new GeometryCollection(null);
      return ye.setGeometriesArray(ee), ye;
    }
    return this.simplifiedGeometryMaxMinSquaredTolerance = Z, this;
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */
  getType() {
    return "GeometryCollection";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */
  intersectsExtent(Z) {
    const ee = this.geometries_;
    for (let ae = 0, ve = ee.length; ae < ve; ++ae)
      if (ee[ae].intersectsExtent(Z))
        return !0;
    return !1;
  }
  /**
   * @return {boolean} Is empty.
   */
  isEmpty() {
    return this.geometries_.length === 0;
  }
  /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */
  rotate(Z, ee) {
    const ae = this.geometries_;
    for (let ve = 0, ye = ae.length; ve < ye; ++ve)
      ae[ve].rotate(Z, ee);
    this.changed();
  }
  /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */
  scale(Z, ee, ae) {
    ae || (ae = getCenter(this.getExtent()));
    const ve = this.geometries_;
    for (let ye = 0, be = ve.length; ye < be; ++ye)
      ve[ye].scale(Z, ee, ae);
    this.changed();
  }
  /**
   * Set the geometries that make up this geometry collection.
   * @param {Array<Geometry>} geometries Geometries.
   * @api
   */
  setGeometries(Z) {
    this.setGeometriesArray(cloneGeometries(Z));
  }
  /**
   * @param {Array<Geometry>} geometries Geometries.
   */
  setGeometriesArray(Z) {
    this.unlistenGeometriesChange_(), this.geometries_ = Z, this.listenGeometriesChange_(), this.changed();
  }
  /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   */
  applyTransform(Z) {
    const ee = this.geometries_;
    for (let ae = 0, ve = ee.length; ae < ve; ++ae)
      ee[ae].applyTransform(Z);
    this.changed();
  }
  /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */
  translate(Z, ee) {
    const ae = this.geometries_;
    for (let ve = 0, ye = ae.length; ve < ye; ++ve)
      ae[ve].translate(Z, ee);
    this.changed();
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    this.unlistenGeometriesChange_(), super.disposeInternal();
  }
}
function cloneGeometries(ie) {
  const Z = [];
  for (let ee = 0, ae = ie.length; ee < ae; ++ee)
    Z.push(ie[ee].clone());
  return Z;
}
const GeometryCollection$1 = GeometryCollection;
class FeatureFormat {
  constructor() {
    this.dataProjection = void 0, this.defaultFeatureProjection = void 0, this.supportedMediaTypes = null;
  }
  /**
   * Adds the data projection to the read options.
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Options.
   * @return {ReadOptions|undefined} Options.
   * @protected
   */
  getReadOptions(Z, ee) {
    if (ee) {
      let ae = ee.dataProjection ? get$1(ee.dataProjection) : this.readProjection(Z);
      ee.extent && ae && ae.getUnits() === "tile-pixels" && (ae = get$1(ae), ae.setWorldExtent(ee.extent)), ee = {
        dataProjection: ae,
        featureProjection: ee.featureProjection
      };
    }
    return this.adaptOptions(ee);
  }
  /**
   * Sets the `dataProjection` on the options, if no `dataProjection`
   * is set.
   * @param {WriteOptions|ReadOptions|undefined} options
   *     Options.
   * @protected
   * @return {WriteOptions|ReadOptions|undefined}
   *     Updated options.
   */
  adaptOptions(Z) {
    return Object.assign(
      {
        dataProjection: this.dataProjection,
        featureProjection: this.defaultFeatureProjection
      },
      Z
    );
  }
  /**
   * @abstract
   * @return {Type} The format type.
   */
  getType() {
    return abstract();
  }
  /**
   * Read a single feature from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../Feature.js").FeatureLike} Feature.
   */
  readFeature(Z, ee) {
    return abstract();
  }
  /**
   * Read all features from a source.
   *
   * @abstract
   * @param {Document|Element|ArrayBuffer|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {Array<import("../Feature.js").FeatureLike>} Features.
   */
  readFeatures(Z, ee) {
    return abstract();
  }
  /**
   * Read a single geometry from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */
  readGeometry(Z, ee) {
    return abstract();
  }
  /**
   * Read the projection from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */
  readProjection(Z) {
    return abstract();
  }
  /**
   * Encode a feature in this format.
   *
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */
  writeFeature(Z, ee) {
    return abstract();
  }
  /**
   * Encode an array of features in this format.
   *
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */
  writeFeatures(Z, ee) {
    return abstract();
  }
  /**
   * Write a single geometry in this format.
   *
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */
  writeGeometry(Z, ee) {
    return abstract();
  }
}
function transformGeometryWithOptions(ie, Z, ee) {
  const ae = ee ? get$1(ee.featureProjection) : null, ve = ee ? get$1(ee.dataProjection) : null;
  let ye;
  if (ae && ve && !equivalent(ae, ve) ? ye = (Z ? ie.clone() : ie).transform(
    Z ? ae : ve,
    Z ? ve : ae
  ) : ye = ie, Z && ee && /** @type {WriteOptions} */
  ee.decimals !== void 0) {
    const be = Math.pow(
      10,
      /** @type {WriteOptions} */
      ee.decimals
    ), Ye = function(Qe) {
      for (let Je = 0, nt = Qe.length; Je < nt; ++Je)
        Qe[Je] = Math.round(Qe[Je] * be) / be;
      return Qe;
    };
    ye === ie && (ye = ie.clone()), ye.applyTransform(Ye);
  }
  return ye;
}
class JSONFeature extends FeatureFormat {
  constructor() {
    super();
  }
  /**
   * @return {import("./Feature.js").Type} Format.
   */
  getType() {
    return "json";
  }
  /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../Feature.js").default} Feature.
   * @api
   */
  readFeature(Z, ee) {
    return this.readFeatureFromObject(
      getObject(Z),
      this.getReadOptions(Z, ee)
    );
  }
  /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */
  readFeatures(Z, ee) {
    return this.readFeaturesFromObject(
      getObject(Z),
      this.getReadOptions(Z, ee)
    );
  }
  /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../Feature.js").default} Feature.
   */
  readFeatureFromObject(Z, ee) {
    return abstract();
  }
  /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<import("../Feature.js").default>} Features.
   */
  readFeaturesFromObject(Z, ee) {
    return abstract();
  }
  /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   */
  readGeometry(Z, ee) {
    return this.readGeometryFromObject(
      getObject(Z),
      this.getReadOptions(Z, ee)
    );
  }
  /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */
  readGeometryFromObject(Z, ee) {
    return abstract();
  }
  /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   */
  readProjection(Z) {
    return this.readProjectionFromObject(getObject(Z));
  }
  /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */
  readProjectionFromObject(Z) {
    return abstract();
  }
  /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   */
  writeFeature(Z, ee) {
    return JSON.stringify(this.writeFeatureObject(Z, ee));
  }
  /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */
  writeFeatureObject(Z, ee) {
    return abstract();
  }
  /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   */
  writeFeatures(Z, ee) {
    return JSON.stringify(this.writeFeaturesObject(Z, ee));
  }
  /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */
  writeFeaturesObject(Z, ee) {
    return abstract();
  }
  /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @api
   */
  writeGeometry(Z, ee) {
    return JSON.stringify(this.writeGeometryObject(Z, ee));
  }
  /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */
  writeGeometryObject(Z, ee) {
    return abstract();
  }
}
function getObject(ie) {
  if (typeof ie == "string") {
    const Z = JSON.parse(ie);
    return Z || null;
  }
  return ie !== null ? ie : null;
}
class MultiLineString extends SimpleGeometry {
  /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */
  constructor(Z, ee, ae) {
    if (super(), this.ends_ = [], this.maxDelta_ = -1, this.maxDeltaRevision_ = -1, Array.isArray(Z[0]))
      this.setCoordinates(
        /** @type {Array<Array<import("../coordinate.js").Coordinate>>} */
        Z,
        ee
      );
    else if (ee !== void 0 && ae)
      this.setFlatCoordinates(
        ee,
        /** @type {Array<number>} */
        Z
      ), this.ends_ = ae;
    else {
      let ve = this.getLayout();
      const ye = (
        /** @type {Array<LineString>} */
        Z
      ), be = [], Ye = [];
      for (let Qe = 0, Je = ye.length; Qe < Je; ++Qe) {
        const nt = ye[Qe];
        Qe === 0 && (ve = nt.getLayout()), extend$2(be, nt.getFlatCoordinates()), Ye.push(be.length);
      }
      this.setFlatCoordinates(ve, be), this.ends_ = Ye;
    }
  }
  /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */
  appendLineString(Z) {
    this.flatCoordinates ? extend$2(this.flatCoordinates, Z.getFlatCoordinates().slice()) : this.flatCoordinates = Z.getFlatCoordinates().slice(), this.ends_.push(this.flatCoordinates.length), this.changed();
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   */
  clone() {
    const Z = new MultiLineString(
      this.flatCoordinates.slice(),
      this.layout,
      this.ends_.slice()
    );
    return Z.applyProperties(this), Z;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */
  closestPointXY(Z, ee, ae, ve) {
    return ve < closestSquaredDistanceXY(this.getExtent(), Z, ee) ? ve : (this.maxDeltaRevision_ != this.getRevision() && (this.maxDelta_ = Math.sqrt(
      arrayMaxSquaredDelta(
        this.flatCoordinates,
        0,
        this.ends_,
        this.stride,
        0
      )
    ), this.maxDeltaRevision_ = this.getRevision()), assignClosestArrayPoint(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      this.maxDelta_,
      !1,
      Z,
      ee,
      ae,
      ve
    ));
  }
  /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */
  getCoordinateAtM(Z, ee, ae) {
    return this.layout != "XYM" && this.layout != "XYZM" || this.flatCoordinates.length === 0 ? null : (ee = ee !== void 0 ? ee : !1, ae = ae !== void 0 ? ae : !1, lineStringsCoordinateAtM(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      Z,
      ee,
      ae
    ));
  }
  /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   */
  getCoordinates() {
    return inflateCoordinatesArray(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride
    );
  }
  /**
   * @return {Array<number>} Ends.
   */
  getEnds() {
    return this.ends_;
  }
  /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */
  getLineString(Z) {
    return Z < 0 || this.ends_.length <= Z ? null : new LineString$1(
      this.flatCoordinates.slice(
        Z === 0 ? 0 : this.ends_[Z - 1],
        this.ends_[Z]
      ),
      this.layout
    );
  }
  /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */
  getLineStrings() {
    const Z = this.flatCoordinates, ee = this.ends_, ae = this.layout, ve = [];
    let ye = 0;
    for (let be = 0, Ye = ee.length; be < Ye; ++be) {
      const Qe = ee[be], Je = new LineString$1(
        Z.slice(ye, Qe),
        ae
      );
      ve.push(Je), ye = Qe;
    }
    return ve;
  }
  /**
   * @return {Array<number>} Flat midpoints.
   */
  getFlatMidpoints() {
    const Z = [], ee = this.flatCoordinates;
    let ae = 0;
    const ve = this.ends_, ye = this.stride;
    for (let be = 0, Ye = ve.length; be < Ye; ++be) {
      const Qe = ve[be], Je = interpolatePoint(
        ee,
        ae,
        Qe,
        ye,
        0.5
      );
      extend$2(Z, Je), ae = Qe;
    }
    return Z;
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   */
  getSimplifiedGeometryInternal(Z) {
    const ee = [], ae = [];
    return ee.length = douglasPeuckerArray(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      Z,
      ee,
      0,
      ae
    ), new MultiLineString(ee, "XY", ae);
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */
  getType() {
    return "MultiLineString";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */
  intersectsExtent(Z) {
    return intersectsLineStringArray(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      Z
    );
  }
  /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */
  setCoordinates(Z, ee) {
    this.setLayout(ee, Z, 2), this.flatCoordinates || (this.flatCoordinates = []);
    const ae = deflateCoordinatesArray(
      this.flatCoordinates,
      0,
      Z,
      this.stride,
      this.ends_
    );
    this.flatCoordinates.length = ae.length === 0 ? 0 : ae[ae.length - 1], this.changed();
  }
}
const MultiLineString$1 = MultiLineString;
class MultiPoint extends SimpleGeometry {
  /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */
  constructor(Z, ee) {
    super(), ee && !Array.isArray(Z[0]) ? this.setFlatCoordinates(
      ee,
      /** @type {Array<number>} */
      Z
    ) : this.setCoordinates(
      /** @type {Array<import("../coordinate.js").Coordinate>} */
      Z,
      ee
    );
  }
  /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */
  appendPoint(Z) {
    this.flatCoordinates ? extend$2(this.flatCoordinates, Z.getFlatCoordinates()) : this.flatCoordinates = Z.getFlatCoordinates().slice(), this.changed();
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   */
  clone() {
    const Z = new MultiPoint(
      this.flatCoordinates.slice(),
      this.layout
    );
    return Z.applyProperties(this), Z;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */
  closestPointXY(Z, ee, ae, ve) {
    if (ve < closestSquaredDistanceXY(this.getExtent(), Z, ee))
      return ve;
    const ye = this.flatCoordinates, be = this.stride;
    for (let Ye = 0, Qe = ye.length; Ye < Qe; Ye += be) {
      const Je = squaredDistance(
        Z,
        ee,
        ye[Ye],
        ye[Ye + 1]
      );
      if (Je < ve) {
        ve = Je;
        for (let nt = 0; nt < be; ++nt)
          ae[nt] = ye[Ye + nt];
        ae.length = be;
      }
    }
    return ve;
  }
  /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */
  getCoordinates() {
    return inflateCoordinates(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride
    );
  }
  /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */
  getPoint(Z) {
    const ee = this.flatCoordinates ? this.flatCoordinates.length / this.stride : 0;
    return Z < 0 || ee <= Z ? null : new Point$1(
      this.flatCoordinates.slice(
        Z * this.stride,
        (Z + 1) * this.stride
      ),
      this.layout
    );
  }
  /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */
  getPoints() {
    const Z = this.flatCoordinates, ee = this.layout, ae = this.stride, ve = [];
    for (let ye = 0, be = Z.length; ye < be; ye += ae) {
      const Ye = new Point$1(Z.slice(ye, ye + ae), ee);
      ve.push(Ye);
    }
    return ve;
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */
  getType() {
    return "MultiPoint";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */
  intersectsExtent(Z) {
    const ee = this.flatCoordinates, ae = this.stride;
    for (let ve = 0, ye = ee.length; ve < ye; ve += ae) {
      const be = ee[ve], Ye = ee[ve + 1];
      if (containsXY(Z, be, Ye))
        return !0;
    }
    return !1;
  }
  /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */
  setCoordinates(Z, ee) {
    this.setLayout(ee, Z, 1), this.flatCoordinates || (this.flatCoordinates = []), this.flatCoordinates.length = deflateCoordinates(
      this.flatCoordinates,
      0,
      Z,
      this.stride
    ), this.changed();
  }
}
const MultiPoint$1 = MultiPoint;
function linearRingss(ie, Z, ee, ae) {
  const ve = [];
  let ye = createEmpty();
  for (let be = 0, Ye = ee.length; be < Ye; ++be) {
    const Qe = ee[be];
    ye = createOrUpdateFromFlatCoordinates(
      ie,
      Z,
      Qe[0],
      ae
    ), ve.push((ye[0] + ye[2]) / 2, (ye[1] + ye[3]) / 2), Z = Qe[Qe.length - 1];
  }
  return ve;
}
class MultiPolygon extends SimpleGeometry {
  /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */
  constructor(Z, ee, ae) {
    if (super(), this.endss_ = [], this.flatInteriorPointsRevision_ = -1, this.flatInteriorPoints_ = null, this.maxDelta_ = -1, this.maxDeltaRevision_ = -1, this.orientedRevision_ = -1, this.orientedFlatCoordinates_ = null, !ae && !Array.isArray(Z[0])) {
      let ve = this.getLayout();
      const ye = (
        /** @type {Array<Polygon>} */
        Z
      ), be = [], Ye = [];
      for (let Qe = 0, Je = ye.length; Qe < Je; ++Qe) {
        const nt = ye[Qe];
        Qe === 0 && (ve = nt.getLayout());
        const st = be.length, ot = nt.getEnds();
        for (let lt = 0, ft = ot.length; lt < ft; ++lt)
          ot[lt] += st;
        extend$2(be, nt.getFlatCoordinates()), Ye.push(ot);
      }
      ee = ve, Z = be, ae = Ye;
    }
    ee !== void 0 && ae ? (this.setFlatCoordinates(
      ee,
      /** @type {Array<number>} */
      Z
    ), this.endss_ = ae) : this.setCoordinates(
      /** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */
      Z,
      ee
    );
  }
  /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */
  appendPolygon(Z) {
    let ee;
    if (!this.flatCoordinates)
      this.flatCoordinates = Z.getFlatCoordinates().slice(), ee = Z.getEnds().slice(), this.endss_.push();
    else {
      const ae = this.flatCoordinates.length;
      extend$2(this.flatCoordinates, Z.getFlatCoordinates()), ee = Z.getEnds().slice();
      for (let ve = 0, ye = ee.length; ve < ye; ++ve)
        ee[ve] += ae;
    }
    this.endss_.push(ee), this.changed();
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   */
  clone() {
    const Z = this.endss_.length, ee = new Array(Z);
    for (let ve = 0; ve < Z; ++ve)
      ee[ve] = this.endss_[ve].slice();
    const ae = new MultiPolygon(
      this.flatCoordinates.slice(),
      this.layout,
      ee
    );
    return ae.applyProperties(this), ae;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */
  closestPointXY(Z, ee, ae, ve) {
    return ve < closestSquaredDistanceXY(this.getExtent(), Z, ee) ? ve : (this.maxDeltaRevision_ != this.getRevision() && (this.maxDelta_ = Math.sqrt(
      multiArrayMaxSquaredDelta(
        this.flatCoordinates,
        0,
        this.endss_,
        this.stride,
        0
      )
    ), this.maxDeltaRevision_ = this.getRevision()), assignClosestMultiArrayPoint(
      this.getOrientedFlatCoordinates(),
      0,
      this.endss_,
      this.stride,
      this.maxDelta_,
      !0,
      Z,
      ee,
      ae,
      ve
    ));
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */
  containsXY(Z, ee) {
    return linearRingssContainsXY(
      this.getOrientedFlatCoordinates(),
      0,
      this.endss_,
      this.stride,
      Z,
      ee
    );
  }
  /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */
  getArea() {
    return linearRingss$1(
      this.getOrientedFlatCoordinates(),
      0,
      this.endss_,
      this.stride
    );
  }
  /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   */
  getCoordinates(Z) {
    let ee;
    return Z !== void 0 ? (ee = this.getOrientedFlatCoordinates().slice(), orientLinearRingsArray(
      ee,
      0,
      this.endss_,
      this.stride,
      Z
    )) : ee = this.flatCoordinates, inflateMultiCoordinatesArray(
      ee,
      0,
      this.endss_,
      this.stride
    );
  }
  /**
   * @return {Array<Array<number>>} Endss.
   */
  getEndss() {
    return this.endss_;
  }
  /**
   * @return {Array<number>} Flat interior points.
   */
  getFlatInteriorPoints() {
    if (this.flatInteriorPointsRevision_ != this.getRevision()) {
      const Z = linearRingss(
        this.flatCoordinates,
        0,
        this.endss_,
        this.stride
      );
      this.flatInteriorPoints_ = getInteriorPointsOfMultiArray(
        this.getOrientedFlatCoordinates(),
        0,
        this.endss_,
        this.stride,
        Z
      ), this.flatInteriorPointsRevision_ = this.getRevision();
    }
    return this.flatInteriorPoints_;
  }
  /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */
  getInteriorPoints() {
    return new MultiPoint$1(this.getFlatInteriorPoints().slice(), "XYM");
  }
  /**
   * @return {Array<number>} Oriented flat coordinates.
   */
  getOrientedFlatCoordinates() {
    if (this.orientedRevision_ != this.getRevision()) {
      const Z = this.flatCoordinates;
      linearRingssAreOriented(Z, 0, this.endss_, this.stride) ? this.orientedFlatCoordinates_ = Z : (this.orientedFlatCoordinates_ = Z.slice(), this.orientedFlatCoordinates_.length = orientLinearRingsArray(
        this.orientedFlatCoordinates_,
        0,
        this.endss_,
        this.stride
      )), this.orientedRevision_ = this.getRevision();
    }
    return this.orientedFlatCoordinates_;
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   */
  getSimplifiedGeometryInternal(Z) {
    const ee = [], ae = [];
    return ee.length = quantizeMultiArray(
      this.flatCoordinates,
      0,
      this.endss_,
      this.stride,
      Math.sqrt(Z),
      ee,
      0,
      ae
    ), new MultiPolygon(ee, "XY", ae);
  }
  /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */
  getPolygon(Z) {
    if (Z < 0 || this.endss_.length <= Z)
      return null;
    let ee;
    if (Z === 0)
      ee = 0;
    else {
      const ye = this.endss_[Z - 1];
      ee = ye[ye.length - 1];
    }
    const ae = this.endss_[Z].slice(), ve = ae[ae.length - 1];
    if (ee !== 0)
      for (let ye = 0, be = ae.length; ye < be; ++ye)
        ae[ye] -= ee;
    return new Polygon$1(
      this.flatCoordinates.slice(ee, ve),
      this.layout,
      ae
    );
  }
  /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */
  getPolygons() {
    const Z = this.layout, ee = this.flatCoordinates, ae = this.endss_, ve = [];
    let ye = 0;
    for (let be = 0, Ye = ae.length; be < Ye; ++be) {
      const Qe = ae[be].slice(), Je = Qe[Qe.length - 1];
      if (ye !== 0)
        for (let st = 0, ot = Qe.length; st < ot; ++st)
          Qe[st] -= ye;
      const nt = new Polygon$1(
        ee.slice(ye, Je),
        Z,
        Qe
      );
      ve.push(nt), ye = Je;
    }
    return ve;
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */
  getType() {
    return "MultiPolygon";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */
  intersectsExtent(Z) {
    return intersectsLinearRingMultiArray(
      this.getOrientedFlatCoordinates(),
      0,
      this.endss_,
      this.stride,
      Z
    );
  }
  /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */
  setCoordinates(Z, ee) {
    this.setLayout(ee, Z, 3), this.flatCoordinates || (this.flatCoordinates = []);
    const ae = deflateMultiCoordinatesArray(
      this.flatCoordinates,
      0,
      Z,
      this.stride,
      this.endss_
    );
    if (ae.length === 0)
      this.flatCoordinates.length = 0;
    else {
      const ve = ae[ae.length - 1];
      this.flatCoordinates.length = ve.length === 0 ? 0 : ve[ve.length - 1];
    }
    this.changed();
  }
}
const MultiPolygon$1 = MultiPolygon;
class GeoJSON extends JSONFeature {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {}, super(), this.dataProjection = get$1(
      Z.dataProjection ? Z.dataProjection : "EPSG:4326"
    ), Z.featureProjection && (this.defaultFeatureProjection = get$1(Z.featureProjection)), this.geometryName_ = Z.geometryName, this.extractGeometryName_ = Z.extractGeometryName, this.supportedMediaTypes = [
      "application/geo+json",
      "application/vnd.geo+json"
    ];
  }
  /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../Feature.js").default} Feature.
   */
  readFeatureFromObject(Z, ee) {
    let ae = null;
    Z.type === "Feature" ? ae = /** @type {GeoJSONFeature} */
    Z : ae = {
      type: "Feature",
      geometry: (
        /** @type {GeoJSONGeometry} */
        Z
      ),
      properties: null
    };
    const ve = readGeometry(ae.geometry, ee), ye = new Feature();
    return this.geometryName_ ? ye.setGeometryName(this.geometryName_) : this.extractGeometryName_ && "geometry_name" in ae !== void 0 && ye.setGeometryName(ae.geometry_name), ye.setGeometry(ve), "id" in ae && ye.setId(ae.id), ae.properties && ye.setProperties(ae.properties, !0), ye;
  }
  /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<Feature>} Features.
   */
  readFeaturesFromObject(Z, ee) {
    const ae = (
      /** @type {GeoJSONObject} */
      Z
    );
    let ve = null;
    if (ae.type === "FeatureCollection") {
      const ye = (
        /** @type {GeoJSONFeatureCollection} */
        Z
      );
      ve = [];
      const be = ye.features;
      for (let Ye = 0, Qe = be.length; Ye < Qe; ++Ye)
        ve.push(this.readFeatureFromObject(be[Ye], ee));
    } else
      ve = [this.readFeatureFromObject(Z, ee)];
    return ve;
  }
  /**
   * @param {GeoJSONGeometry} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */
  readGeometryFromObject(Z, ee) {
    return readGeometry(Z, ee);
  }
  /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */
  readProjectionFromObject(Z) {
    const ee = Z.crs;
    let ae;
    if (ee)
      if (ee.type == "name")
        ae = get$1(ee.properties.name);
      else if (ee.type === "EPSG")
        ae = get$1("EPSG:" + ee.properties.code);
      else
        throw new Error("Unknown SRS type");
    else
      ae = this.dataProjection;
    return (
      /** @type {import("../proj/Projection.js").default} */
      ae
    );
  }
  /**
   * Encode a feature as a GeoJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeature} Object.
   * @api
   */
  writeFeatureObject(Z, ee) {
    ee = this.adaptOptions(ee);
    const ae = {
      type: "Feature",
      geometry: null,
      properties: null
    }, ve = Z.getId();
    if (ve !== void 0 && (ae.id = ve), !Z.hasProperties())
      return ae;
    const ye = Z.getProperties(), be = Z.getGeometry();
    return be && (ae.geometry = writeGeometry(be, ee), delete ye[Z.getGeometryName()]), isEmpty$1(ye) || (ae.properties = ye), ae;
  }
  /**
   * Encode an array of features as a GeoJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeatureCollection} GeoJSON Object.
   * @api
   */
  writeFeaturesObject(Z, ee) {
    ee = this.adaptOptions(ee);
    const ae = [];
    for (let ve = 0, ye = Z.length; ve < ye; ++ve)
      ae.push(this.writeFeatureObject(Z[ve], ee));
    return {
      type: "FeatureCollection",
      features: ae
    };
  }
  /**
   * Encode a geometry as a GeoJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
   * @api
   */
  writeGeometryObject(Z, ee) {
    return writeGeometry(Z, this.adaptOptions(ee));
  }
}
function readGeometry(ie, Z) {
  if (!ie)
    return null;
  let ee;
  switch (ie.type) {
    case "Point": {
      ee = readPointGeometry(
        /** @type {GeoJSONPoint} */
        ie
      );
      break;
    }
    case "LineString": {
      ee = readLineStringGeometry(
        /** @type {GeoJSONLineString} */
        ie
      );
      break;
    }
    case "Polygon": {
      ee = readPolygonGeometry(
        /** @type {GeoJSONPolygon} */
        ie
      );
      break;
    }
    case "MultiPoint": {
      ee = readMultiPointGeometry(
        /** @type {GeoJSONMultiPoint} */
        ie
      );
      break;
    }
    case "MultiLineString": {
      ee = readMultiLineStringGeometry(
        /** @type {GeoJSONMultiLineString} */
        ie
      );
      break;
    }
    case "MultiPolygon": {
      ee = readMultiPolygonGeometry(
        /** @type {GeoJSONMultiPolygon} */
        ie
      );
      break;
    }
    case "GeometryCollection": {
      ee = readGeometryCollectionGeometry(
        /** @type {GeoJSONGeometryCollection} */
        ie
      );
      break;
    }
    default:
      throw new Error("Unsupported GeoJSON type: " + ie.type);
  }
  return transformGeometryWithOptions(ee, !1, Z);
}
function readGeometryCollectionGeometry(ie, Z) {
  const ee = ie.geometries.map(
    /**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("../geom/Geometry.js").default} geometry Geometry.
     */
    function(ae) {
      return readGeometry(ae, Z);
    }
  );
  return new GeometryCollection$1(ee);
}
function readPointGeometry(ie) {
  return new Point$1(ie.coordinates);
}
function readLineStringGeometry(ie) {
  return new LineString$1(ie.coordinates);
}
function readMultiLineStringGeometry(ie) {
  return new MultiLineString$1(ie.coordinates);
}
function readMultiPointGeometry(ie) {
  return new MultiPoint$1(ie.coordinates);
}
function readMultiPolygonGeometry(ie) {
  return new MultiPolygon$1(ie.coordinates);
}
function readPolygonGeometry(ie) {
  return new Polygon$1(ie.coordinates);
}
function writeGeometry(ie, Z) {
  ie = transformGeometryWithOptions(ie, !0, Z);
  const ee = ie.getType();
  let ae;
  switch (ee) {
    case "Point": {
      ae = writePointGeometry(
        /** @type {Point} */
        ie
      );
      break;
    }
    case "LineString": {
      ae = writeLineStringGeometry(
        /** @type {LineString} */
        ie
      );
      break;
    }
    case "Polygon": {
      ae = writePolygonGeometry(
        /** @type {Polygon} */
        ie,
        Z
      );
      break;
    }
    case "MultiPoint": {
      ae = writeMultiPointGeometry(
        /** @type {MultiPoint} */
        ie
      );
      break;
    }
    case "MultiLineString": {
      ae = writeMultiLineStringGeometry(
        /** @type {MultiLineString} */
        ie
      );
      break;
    }
    case "MultiPolygon": {
      ae = writeMultiPolygonGeometry(
        /** @type {MultiPolygon} */
        ie,
        Z
      );
      break;
    }
    case "GeometryCollection": {
      ae = writeGeometryCollectionGeometry(
        /** @type {GeometryCollection} */
        ie,
        Z
      );
      break;
    }
    case "Circle": {
      ae = {
        type: "GeometryCollection",
        geometries: []
      };
      break;
    }
    default:
      throw new Error("Unsupported geometry type: " + ee);
  }
  return ae;
}
function writeGeometryCollectionGeometry(ie, Z) {
  return Z = Object.assign({}, Z), delete Z.featureProjection, {
    type: "GeometryCollection",
    geometries: ie.getGeometriesArray().map(function(ae) {
      return writeGeometry(ae, Z);
    })
  };
}
function writeLineStringGeometry(ie, Z) {
  return {
    type: "LineString",
    coordinates: ie.getCoordinates()
  };
}
function writeMultiLineStringGeometry(ie, Z) {
  return {
    type: "MultiLineString",
    coordinates: ie.getCoordinates()
  };
}
function writeMultiPointGeometry(ie, Z) {
  return {
    type: "MultiPoint",
    coordinates: ie.getCoordinates()
  };
}
function writeMultiPolygonGeometry(ie, Z) {
  let ee;
  return Z && (ee = Z.rightHanded), {
    type: "MultiPolygon",
    coordinates: ie.getCoordinates(ee)
  };
}
function writePointGeometry(ie, Z) {
  return {
    type: "Point",
    coordinates: ie.getCoordinates()
  };
}
function writePolygonGeometry(ie, Z) {
  let ee;
  return Z && (ee = Z.rightHanded), {
    type: "Polygon",
    coordinates: ie.getCoordinates(ee)
  };
}
function asImageLike(ie) {
  return ie instanceof Image || ie instanceof HTMLCanvasElement || ie instanceof HTMLVideoElement || ie instanceof ImageBitmap ? ie : null;
}
function asArrayLike(ie) {
  return ie instanceof Uint8Array || ie instanceof Uint8ClampedArray || ie instanceof Float32Array || ie instanceof DataView ? ie : null;
}
let sharedContext = null;
function toArray(ie) {
  sharedContext || (sharedContext = createCanvasContext2D(
    ie.width,
    ie.height,
    void 0,
    { willReadFrequently: !0 }
  ));
  const Z = sharedContext.canvas, ee = ie.width;
  Z.width !== ee && (Z.width = ee);
  const ae = ie.height;
  return Z.height !== ae && (Z.height = ae), sharedContext.clearRect(0, 0, ee, ae), sharedContext.drawImage(ie, 0, 0), sharedContext.getImageData(0, 0, ee, ae).data;
}
const defaultSize = [256, 256];
class DataTile extends Tile {
  /**
   * @param {Options} options Tile options.
   */
  constructor(Z) {
    const ee = TileState.IDLE;
    super(Z.tileCoord, ee, {
      transition: Z.transition,
      interpolate: Z.interpolate
    }), this.loader_ = Z.loader, this.data_ = null, this.error_ = null, this.size_ = Z.size || null;
  }
  /**
   * Get the tile size.
   * @return {import('./size.js').Size} Tile size.
   */
  getSize() {
    if (this.size_)
      return this.size_;
    const Z = asImageLike(this.data_);
    return Z ? [Z.width, Z.height] : defaultSize;
  }
  /**
   * Get the data for the tile.
   * @return {Data} Tile data.
   * @api
   */
  getData() {
    return this.data_;
  }
  /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @api
   */
  getError() {
    return this.error_;
  }
  /**
   * Load not yet loaded URI.
   * @api
   */
  load() {
    if (this.state !== TileState.IDLE && this.state !== TileState.ERROR)
      return;
    this.state = TileState.LOADING, this.changed();
    const Z = this;
    this.loader_().then(function(ee) {
      Z.data_ = ee, Z.state = TileState.LOADED, Z.changed();
    }).catch(function(ee) {
      Z.error_ = ee, Z.state = TileState.ERROR, Z.changed();
    });
  }
}
class ReprojDataTile extends DataTile {
  /**
   * @param {Options} options Tile options.
   */
  constructor(Z) {
    super({
      tileCoord: Z.tileCoord,
      loader: () => Promise.resolve(new Uint8Array(4)),
      interpolate: Z.interpolate,
      transition: Z.transition
    }), this.pixelRatio_ = Z.pixelRatio, this.gutter_ = Z.gutter, this.reprojData_ = null, this.reprojError_ = null, this.reprojSize_ = void 0, this.sourceTileGrid_ = Z.sourceTileGrid, this.targetTileGrid_ = Z.targetTileGrid, this.wrappedTileCoord_ = Z.wrappedTileCoord || Z.tileCoord, this.sourceTiles_ = [], this.sourcesListenerKeys_ = null, this.sourceZ_ = 0;
    const ee = this.targetTileGrid_.getTileCoordExtent(
      this.wrappedTileCoord_
    ), ae = this.targetTileGrid_.getExtent();
    let ve = this.sourceTileGrid_.getExtent();
    const ye = ae ? getIntersection(ee, ae) : ee;
    if (getArea(ye) === 0) {
      this.state = TileState.EMPTY;
      return;
    }
    const be = Z.sourceProj, Ye = be.getExtent();
    Ye && (ve ? ve = getIntersection(ve, Ye) : ve = Ye);
    const Qe = this.targetTileGrid_.getResolution(
      this.wrappedTileCoord_[0]
    ), Je = Z.targetProj, nt = calculateSourceExtentResolution(
      be,
      Je,
      ye,
      Qe
    );
    if (!isFinite(nt) || nt <= 0) {
      this.state = TileState.EMPTY;
      return;
    }
    const st = Z.errorThreshold !== void 0 ? Z.errorThreshold : ERROR_THRESHOLD;
    if (this.triangulation_ = new Triangulation(
      be,
      Je,
      ye,
      ve,
      nt * st,
      Qe
    ), this.triangulation_.getTriangles().length === 0) {
      this.state = TileState.EMPTY;
      return;
    }
    this.sourceZ_ = this.sourceTileGrid_.getZForResolution(nt);
    let ot = this.triangulation_.calculateSourceExtent();
    if (ve && (be.canWrapX() ? (ot[1] = clamp$1(
      ot[1],
      ve[1],
      ve[3]
    ), ot[3] = clamp$1(
      ot[3],
      ve[1],
      ve[3]
    )) : ot = getIntersection(ot, ve)), !getArea(ot))
      this.state = TileState.EMPTY;
    else {
      const lt = this.sourceTileGrid_.getTileRangeForExtentAndZ(
        ot,
        this.sourceZ_
      ), ft = Z.getTileFunction;
      for (let gt = lt.minX; gt <= lt.maxX; gt++)
        for (let ct = lt.minY; ct <= lt.maxY; ct++) {
          const _r = ft(this.sourceZ_, gt, ct, this.pixelRatio_);
          _r && this.sourceTiles_.push(_r);
        }
      this.sourceTiles_.length === 0 && (this.state = TileState.EMPTY);
    }
  }
  /**
   * Get the tile size.
   * @return {import('../size.js').Size} Tile size.
   */
  getSize() {
    return this.reprojSize_;
  }
  /**
   * Get the data for the tile.
   * @return {import("../DataTile.js").Data} Tile data.
   */
  getData() {
    return this.reprojData_;
  }
  /**
   * Get any loading error.
   * @return {Error} Loading error.
   */
  getError() {
    return this.reprojError_;
  }
  /**
   * @private
   */
  reproject_() {
    const Z = [];
    if (this.sourceTiles_.forEach((ee) => {
      if (!ee || ee.getState() !== TileState.LOADED)
        return;
      const ae = ee.getSize(), ve = this.gutter_;
      let ye;
      const be = asArrayLike(ee.getData());
      be ? ye = be : ye = toArray(asImageLike(ee.getData()));
      const Ye = [ae[0] + 2 * ve, ae[1] + 2 * ve], Qe = ye instanceof Float32Array, Je = Ye[0] * Ye[1], nt = Qe ? Float32Array : Uint8Array, st = new nt(ye.buffer), ot = nt.BYTES_PER_ELEMENT, lt = ot * st.length / Je, ft = st.byteLength / Ye[1], gt = Math.floor(
        ft / ot / Ye[0]
      ), ct = Je * gt;
      let _r = st;
      if (st.length !== ct) {
        _r = new nt(ct);
        let Kr = 0, Xr = 0;
        const Jr = Ye[0] * gt;
        for (let ei = 0; ei < Ye[1]; ++ei) {
          for (let si = 0; si < Jr; ++si)
            _r[Kr++] = st[Xr + si];
          Xr += ft / ot;
        }
      }
      Z.push({
        extent: this.sourceTileGrid_.getTileCoordExtent(ee.tileCoord),
        data: new Uint8Array(_r.buffer),
        dataType: nt,
        bytesPerPixel: lt,
        pixelSize: Ye
      });
    }), this.sourceTiles_.length = 0, Z.length === 0)
      this.state = TileState.ERROR;
    else {
      const ee = this.wrappedTileCoord_[0], ae = this.targetTileGrid_.getTileSize(ee), ve = typeof ae == "number" ? ae : ae[0], ye = typeof ae == "number" ? ae : ae[1], be = this.targetTileGrid_.getResolution(ee), Ye = this.sourceTileGrid_.getResolution(
        this.sourceZ_
      ), Qe = this.targetTileGrid_.getTileCoordExtent(
        this.wrappedTileCoord_
      );
      let Je, nt;
      const st = Z[0].bytesPerPixel, ot = Math.ceil(st / 3);
      for (let lt = ot - 1; lt >= 0; --lt) {
        const ft = [];
        for (let Jr = 0, ei = Z.length; Jr < ei; ++Jr) {
          const si = Z[Jr], ri = si.data, ai = si.pixelSize, yi = ai[0], pi = ai[1], di = createCanvasContext2D(yi, pi, canvasPool), xi = di.createImageData(yi, pi), Ti = xi.data;
          let Ai = lt * 3;
          for (let mi = 0, Si = Ti.length; mi < Si; mi += 4)
            Ti[mi] = ri[Ai], Ti[mi + 1] = ri[Ai + 1], Ti[mi + 2] = ri[Ai + 2], Ti[mi + 3] = 255, Ai += st;
          di.putImageData(xi, 0, 0), ft.push({
            extent: si.extent,
            image: di.canvas
          });
        }
        const gt = render$1(
          ve,
          ye,
          this.pixelRatio_,
          Ye,
          this.sourceTileGrid_.getExtent(),
          be,
          Qe,
          this.triangulation_,
          ft,
          this.gutter_,
          !1,
          !1
        );
        for (let Jr = 0, ei = ft.length; Jr < ei; ++Jr) {
          const ri = ft[Jr].image.getContext("2d");
          releaseCanvas$1(ri), canvasPool.push(ri.canvas);
        }
        const ct = gt.getContext("2d"), _r = ct.getImageData(
          0,
          0,
          gt.width,
          gt.height
        );
        releaseCanvas$1(ct), canvasPool.push(gt), Je || (nt = new Uint8Array(
          st * _r.width * _r.height
        ), Je = new Z[0].dataType(nt.buffer));
        const Kr = _r.data;
        let Xr = lt * 3;
        for (let Jr = 0, ei = Kr.length; Jr < ei; Jr += 4)
          Kr[Jr + 3] === 255 ? (nt[Xr] = Kr[Jr], nt[Xr + 1] = Kr[Jr + 1], nt[Xr + 2] = Kr[Jr + 2]) : (nt[Xr] = 0, nt[Xr + 1] = 0, nt[Xr + 2] = 0), Xr += st;
      }
      this.reprojData_ = Je, this.reprojSize_ = [
        Math.round(ve * this.pixelRatio_),
        Math.round(ye * this.pixelRatio_)
      ], this.state = TileState.LOADED;
    }
    this.changed();
  }
  /**
   * Load not yet loaded URI.
   */
  load() {
    if (this.state !== TileState.IDLE && this.state !== TileState.ERROR)
      return;
    this.state = TileState.LOADING, this.changed();
    let Z = 0;
    this.sourcesListenerKeys_ = [], this.sourceTiles_.forEach((ee) => {
      const ae = ee.getState();
      if (ae !== TileState.IDLE && ae !== TileState.LOADING)
        return;
      Z++;
      const ve = listen(
        ee,
        EventType.CHANGE,
        function() {
          const ye = ee.getState();
          (ye == TileState.LOADED || ye == TileState.ERROR || ye == TileState.EMPTY) && (unlistenByKey(ve), Z--, Z === 0 && (this.unlistenSources_(), this.reproject_()));
        },
        this
      );
      this.sourcesListenerKeys_.push(ve);
    }), Z === 0 ? setTimeout(this.reproject_.bind(this), 0) : this.sourceTiles_.forEach(function(ee) {
      ee.getState() == TileState.IDLE && ee.load();
    });
  }
  /**
   * @private
   */
  unlistenSources_() {
    this.sourcesListenerKeys_.forEach(unlistenByKey), this.sourcesListenerKeys_ = null;
  }
}
class DataTileSource extends TileSource {
  /**
   * @param {Options} options DataTile source options.
   */
  constructor(Z) {
    const ee = Z.projection === void 0 ? "EPSG:3857" : Z.projection;
    let ae = Z.tileGrid;
    ae === void 0 && ee && (ae = createXYZ({
      extent: extentFromProjection(ee),
      maxResolution: Z.maxResolution,
      maxZoom: Z.maxZoom,
      minZoom: Z.minZoom,
      tileSize: Z.tileSize
    })), super({
      cacheSize: 0.1,
      // don't cache on the source
      attributions: Z.attributions,
      attributionsCollapsible: Z.attributionsCollapsible,
      projection: ee,
      tileGrid: ae,
      opaque: Z.opaque,
      state: Z.state,
      wrapX: Z.wrapX,
      transition: Z.transition,
      interpolate: Z.interpolate
    }), this.gutter_ = Z.gutter !== void 0 ? Z.gutter : 0, this.tileSize_ = Z.tileSize ? toSize(Z.tileSize) : null, this.tileSizes_ = null, this.tileLoadingKeys_ = {}, this.loader_ = Z.loader, this.handleTileChange_ = this.handleTileChange_.bind(this), this.bandCount = Z.bandCount === void 0 ? 4 : Z.bandCount, this.tileGridForProjection_ = {}, this.tileCacheForProjection_ = {};
  }
  /**
   * Set the source tile sizes.  The length of the array is expected to match the number of
   * levels in the tile grid.
   * @protected
   * @param {Array<import('../size.js').Size>} tileSizes An array of tile sizes.
   */
  setTileSizes(Z) {
    this.tileSizes_ = Z;
  }
  /**
   * Get the source tile size at the given zoom level.  This may be different than the rendered tile
   * size.
   * @protected
   * @param {number} z Tile zoom level.
   * @return {import('../size.js').Size} The source tile size.
   */
  getTileSize(Z) {
    if (this.tileSizes_)
      return this.tileSizes_[Z];
    if (this.tileSize_)
      return this.tileSize_;
    const ee = this.getTileGrid();
    return ee ? toSize(ee.getTileSize(Z)) : [256, 256];
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */
  getGutterForProjection(Z) {
    const ee = this.getProjection();
    return !ee || equivalent(ee, Z) ? this.gutter_ : 0;
  }
  /**
   * @param {Loader} loader The data loader.
   * @protected
   */
  setLoader(Z) {
    this.loader_ = Z;
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../proj/Projection.js").default} targetProj The output projection.
   * @param {import("../proj/Projection.js").default} sourceProj The input projection.
   * @return {!DataTile} Tile.
   */
  getReprojTile_(Z, ee, ae, ve, ye) {
    const be = this.getTileCacheForProjection(ve), Ye = getKeyZXY(Z, ee, ae);
    if (be.containsKey(Ye)) {
      const ct = be.get(Ye);
      if (ct && ct.key == this.getKey())
        return ct;
    }
    const Qe = this.getTileGrid(), Je = Math.max.apply(
      null,
      Qe.getResolutions().map((ct, _r) => {
        const Kr = toSize(Qe.getTileSize(_r)), Xr = this.getTileSize(_r);
        return Math.max(
          Xr[0] / Kr[0],
          Xr[1] / Kr[1]
        );
      })
    ), nt = this.getTileGridForProjection(ye), st = this.getTileGridForProjection(ve), ot = [Z, ee, ae], lt = this.getTileCoordForTileUrlFunction(
      ot,
      ve
    ), ft = Object.assign(
      {
        sourceProj: ye,
        sourceTileGrid: nt,
        targetProj: ve,
        targetTileGrid: st,
        tileCoord: ot,
        wrappedTileCoord: lt,
        pixelRatio: Je,
        gutter: this.getGutterForProjection(ye),
        getTileFunction: (ct, _r, Kr, Xr) => this.getTile(ct, _r, Kr, Xr, ye)
      },
      this.tileOptions
    ), gt = new ReprojDataTile(ft);
    return gt.key = this.getKey(), gt;
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!DataTile} Tile.
   */
  getTile(Z, ee, ae, ve, ye) {
    const be = this.getProjection();
    if (be && ye && !equivalent(be, ye))
      return this.getReprojTile_(Z, ee, ae, ye, be);
    const Ye = this.getTileSize(Z), Qe = getKeyZXY(Z, ee, ae);
    if (this.tileCache.containsKey(Qe))
      return this.tileCache.get(Qe);
    const Je = this.loader_;
    function nt() {
      return toPromise(function() {
        return Je(Z, ee, ae);
      });
    }
    const st = Object.assign(
      {
        tileCoord: [Z, ee, ae],
        loader: nt,
        size: Ye
      },
      this.tileOptions
    ), ot = new DataTile(st);
    return ot.key = this.getKey(), ot.addEventListener(EventType.CHANGE, this.handleTileChange_), this.tileCache.set(Qe, ot), ot;
  }
  /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   */
  handleTileChange_(Z) {
    const ee = (
      /** @type {import("../Tile.js").default} */
      Z.target
    ), ae = getUid(ee), ve = ee.getState();
    let ye;
    ve == TileState.LOADING ? (this.tileLoadingKeys_[ae] = !0, ye = TileEventType.TILELOADSTART) : ae in this.tileLoadingKeys_ && (delete this.tileLoadingKeys_[ae], ye = ve == TileState.ERROR ? TileEventType.TILELOADERROR : ve == TileState.LOADED ? TileEventType.TILELOADEND : void 0), ye && this.dispatchEvent(new TileSourceEvent(ye, ee));
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */
  getTileGridForProjection(Z) {
    const ee = this.getProjection();
    if (this.tileGrid && (!ee || equivalent(ee, Z)))
      return this.tileGrid;
    const ae = getUid(Z);
    return ae in this.tileGridForProjection_ || (this.tileGridForProjection_[ae] = getForProjection(Z)), this.tileGridForProjection_[ae];
  }
  /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */
  setTileGridForProjection(Z, ee) {
    const ae = get$1(Z);
    if (ae) {
      const ve = getUid(ae);
      ve in this.tileGridForProjection_ || (this.tileGridForProjection_[ve] = ee);
    }
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   */
  getTileCacheForProjection(Z) {
    const ee = this.getProjection();
    if (!ee || equivalent(ee, Z))
      return this.tileCache;
    const ae = getUid(Z);
    return ae in this.tileCacheForProjection_ || (this.tileCacheForProjection_[ae] = new TileCache(0.1)), this.tileCacheForProjection_[ae];
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */
  expireCache(Z, ee) {
    const ae = this.getTileCacheForProjection(Z);
    this.tileCache.expireCache(
      this.tileCache == ae ? ee : {}
    );
    for (const ve in this.tileCacheForProjection_) {
      const ye = this.tileCacheForProjection_[ve];
      ye.expireCache(ye == ae ? ee : {});
    }
  }
  clear() {
    super.clear();
    for (const Z in this.tileCacheForProjection_)
      this.tileCacheForProjection_[Z].clear();
  }
}
function uncurryThis(ie) {
  return (Z, ...ee) => ReflectApply(ie, Z, ee);
}
function uncurryThisGetter(ie, Z) {
  return uncurryThis(
    ReflectGetOwnPropertyDescriptor(
      ie,
      Z
    ).get
  );
}
const {
  apply: ReflectApply,
  construct: ReflectConstruct,
  defineProperty: ReflectDefineProperty,
  get: ReflectGet,
  getOwnPropertyDescriptor: ReflectGetOwnPropertyDescriptor,
  getPrototypeOf: ReflectGetPrototypeOf,
  has: ReflectHas,
  ownKeys: ReflectOwnKeys,
  set: ReflectSet,
  setPrototypeOf: ReflectSetPrototypeOf
} = Reflect, {
  iterator: SymbolIterator,
  species: SymbolSpecies,
  toStringTag: SymbolToStringTag,
  for: SymbolFor
} = Symbol, NativeObject = Object, {
  create: ObjectCreate,
  defineProperty: ObjectDefineProperty,
  freeze: ObjectFreeze,
  is: ObjectIs
} = NativeObject, NativeArray = Array, ArrayPrototype = NativeArray.prototype, NativeArrayPrototypeSymbolIterator = ArrayPrototype[SymbolIterator], ArrayPrototypeSymbolIterator = uncurryThis(NativeArrayPrototypeSymbolIterator), NativeArrayBuffer = ArrayBuffer, ArrayBufferPrototype = NativeArrayBuffer.prototype;
uncurryThisGetter(ArrayBufferPrototype, "byteLength");
const NativeSharedArrayBuffer = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : null;
NativeSharedArrayBuffer && uncurryThisGetter(NativeSharedArrayBuffer.prototype, "byteLength");
const TypedArray = ReflectGetPrototypeOf(Uint8Array);
TypedArray.from;
const TypedArrayPrototype = TypedArray.prototype;
TypedArrayPrototype[SymbolIterator];
uncurryThis(TypedArrayPrototype.keys);
uncurryThis(
  TypedArrayPrototype.values
);
uncurryThis(
  TypedArrayPrototype.entries
);
uncurryThis(TypedArrayPrototype.set);
uncurryThis(
  TypedArrayPrototype.reverse
);
uncurryThis(TypedArrayPrototype.fill);
uncurryThis(
  TypedArrayPrototype.copyWithin
);
uncurryThis(TypedArrayPrototype.sort);
uncurryThis(TypedArrayPrototype.slice);
uncurryThis(
  TypedArrayPrototype.subarray
);
uncurryThisGetter(
  TypedArrayPrototype,
  "buffer"
);
uncurryThisGetter(
  TypedArrayPrototype,
  "byteOffset"
);
uncurryThisGetter(
  TypedArrayPrototype,
  "length"
);
uncurryThisGetter(
  TypedArrayPrototype,
  SymbolToStringTag
);
const NativeUint8Array = Uint8Array, NativeUint16Array = Uint16Array, NativeUint32Array = Uint32Array, NativeFloat32Array = Float32Array, ArrayIteratorPrototype = ReflectGetPrototypeOf([][SymbolIterator]()), ArrayIteratorPrototypeNext = uncurryThis(ArrayIteratorPrototype.next), GeneratorPrototypeNext = uncurryThis(function* () {
}().next), IteratorPrototype = ReflectGetPrototypeOf(ArrayIteratorPrototype), DataViewPrototype = DataView.prototype, DataViewPrototypeGetUint16 = uncurryThis(
  DataViewPrototype.getUint16
), NativeWeakMap = WeakMap, WeakMapPrototype = NativeWeakMap.prototype, WeakMapPrototypeGet = uncurryThis(WeakMapPrototype.get), WeakMapPrototypeSet = uncurryThis(WeakMapPrototype.set), arrayIterators = new NativeWeakMap(), SafeIteratorPrototype = ObjectCreate(null, {
  next: {
    value: function() {
      const Z = WeakMapPrototypeGet(arrayIterators, this);
      return ArrayIteratorPrototypeNext(Z);
    }
  },
  [SymbolIterator]: {
    value: function() {
      return this;
    }
  }
});
function safeIfNeeded(ie) {
  if (ie[SymbolIterator] === NativeArrayPrototypeSymbolIterator && ArrayIteratorPrototype.next === ArrayIteratorPrototypeNext)
    return ie;
  const Z = ObjectCreate(SafeIteratorPrototype);
  return WeakMapPrototypeSet(arrayIterators, Z, ArrayPrototypeSymbolIterator(ie)), Z;
}
const generators = new NativeWeakMap(), DummyArrayIteratorPrototype = ObjectCreate(IteratorPrototype, {
  next: {
    value: function() {
      const Z = WeakMapPrototypeGet(generators, this);
      return GeneratorPrototypeNext(Z);
    },
    writable: !0,
    configurable: !0
  }
});
for (const ie of ReflectOwnKeys(ArrayIteratorPrototype))
  ie !== "next" && ObjectDefineProperty(DummyArrayIteratorPrototype, ie, ReflectGetOwnPropertyDescriptor(ArrayIteratorPrototype, ie));
const buffer = new NativeArrayBuffer(4), floatView = new NativeFloat32Array(buffer), uint32View = new NativeUint32Array(buffer), baseTable = new NativeUint16Array(512), shiftTable = new NativeUint8Array(512);
for (let ie = 0; ie < 256; ++ie) {
  const Z = ie - 127;
  Z < -27 ? (baseTable[ie] = 0, baseTable[ie | 256] = 32768, shiftTable[ie] = 24, shiftTable[ie | 256] = 24) : Z < -14 ? (baseTable[ie] = 1024 >> -Z - 14, baseTable[ie | 256] = 1024 >> -Z - 14 | 32768, shiftTable[ie] = -Z - 1, shiftTable[ie | 256] = -Z - 1) : Z <= 15 ? (baseTable[ie] = Z + 15 << 10, baseTable[ie | 256] = Z + 15 << 10 | 32768, shiftTable[ie] = 13, shiftTable[ie | 256] = 13) : Z < 128 ? (baseTable[ie] = 31744, baseTable[ie | 256] = 64512, shiftTable[ie] = 24, shiftTable[ie | 256] = 24) : (baseTable[ie] = 31744, baseTable[ie | 256] = 64512, shiftTable[ie] = 13, shiftTable[ie | 256] = 13);
}
const mantissaTable = new NativeUint32Array(2048);
for (let ie = 1; ie < 1024; ++ie) {
  let Z = ie << 13, ee = 0;
  for (; !(Z & 8388608); )
    Z <<= 1, ee -= 8388608;
  Z &= -8388609, ee += 947912704, mantissaTable[ie] = Z | ee;
}
for (let ie = 1024; ie < 2048; ++ie)
  mantissaTable[ie] = 939524096 + (ie - 1024 << 13);
const exponentTable = new NativeUint32Array(64);
for (let ie = 1; ie < 31; ++ie)
  exponentTable[ie] = ie << 23;
exponentTable[31] = 1199570944;
exponentTable[32] = 2147483648;
for (let ie = 33; ie < 63; ++ie)
  exponentTable[ie] = 2147483648 + (ie - 32 << 23);
exponentTable[63] = 3347054592;
const offsetTable = new NativeUint16Array(64);
for (let ie = 1; ie < 64; ++ie)
  ie !== 32 && (offsetTable[ie] = 1024);
function convertToNumber(ie) {
  const Z = ie >> 10;
  return uint32View[0] = mantissaTable[offsetTable[Z] + (ie & 1023)] + exponentTable[Z], floatView[0];
}
function getFloat16(ie, Z, ...ee) {
  return convertToNumber(
    DataViewPrototypeGetUint16(ie, Z, ...safeIfNeeded(ee))
  );
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs$1(ie) {
  return ie && ie.__esModule && Object.prototype.hasOwnProperty.call(ie, "default") ? ie.default : ie;
}
function getAugmentedNamespace(ie) {
  if (ie.__esModule)
    return ie;
  var Z = ie.default;
  if (typeof Z == "function") {
    var ee = function ae() {
      return this instanceof ae ? Reflect.construct(Z, arguments, this.constructor) : Z.apply(this, arguments);
    };
    ee.prototype = Z.prototype;
  } else
    ee = {};
  return Object.defineProperty(ee, "__esModule", { value: !0 }), Object.keys(ie).forEach(function(ae) {
    var ve = Object.getOwnPropertyDescriptor(ie, ae);
    Object.defineProperty(ee, ae, ve.get ? ve : {
      enumerable: !0,
      get: function() {
        return ie[ae];
      }
    });
  }), ee;
}
var getAttribute$2 = { exports: {} };
function getAttribute(ie, Z, ee) {
  const ae = ee && ee.debug || !1;
  ae && console.log("[xml-utils] getting " + Z + " in " + ie);
  const ve = typeof ie == "object" ? ie.outer : ie, ye = ve.slice(0, ve.indexOf(">") + 1), be = ['"', "'"];
  for (let Ye = 0; Ye < be.length; Ye++) {
    const Qe = be[Ye], Je = Z + "\\=" + Qe + "([^" + Qe + "]*)" + Qe;
    ae && console.log("[xml-utils] pattern:", Je);
    const st = new RegExp(Je).exec(ye);
    if (ae && console.log("[xml-utils] match:", st), st)
      return st[1];
  }
}
getAttribute$2.exports = getAttribute;
getAttribute$2.exports.default = getAttribute;
var getAttributeExports = getAttribute$2.exports;
const getAttribute$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(getAttributeExports);
var findTagsByName$2 = { exports: {} }, findTagByName$2 = { exports: {} }, indexOfMatch$2 = { exports: {} };
function indexOfMatch$1(ie, Z, ee) {
  const ve = new RegExp(Z).exec(ie.slice(ee));
  return ve ? ee + ve.index : -1;
}
indexOfMatch$2.exports = indexOfMatch$1;
indexOfMatch$2.exports.default = indexOfMatch$1;
var indexOfMatchExports = indexOfMatch$2.exports, indexOfMatchEnd$2 = { exports: {} };
function indexOfMatchEnd$1(ie, Z, ee) {
  const ve = new RegExp(Z).exec(ie.slice(ee));
  return ve ? ee + ve.index + ve[0].length - 1 : -1;
}
indexOfMatchEnd$2.exports = indexOfMatchEnd$1;
indexOfMatchEnd$2.exports.default = indexOfMatchEnd$1;
var indexOfMatchEndExports = indexOfMatchEnd$2.exports, countSubstring$2 = { exports: {} };
function countSubstring$1(ie, Z) {
  const ee = new RegExp(Z, "g"), ae = ie.match(ee);
  return ae ? ae.length : 0;
}
countSubstring$2.exports = countSubstring$1;
countSubstring$2.exports.default = countSubstring$1;
var countSubstringExports = countSubstring$2.exports;
const indexOfMatch = indexOfMatchExports, indexOfMatchEnd = indexOfMatchEndExports, countSubstring = countSubstringExports;
function findTagByName$1(ie, Z, ee) {
  const ae = ee && ee.debug || !1, ve = !(ee && typeof ee.nested === !1), ye = ee && ee.startIndex || 0;
  ae && console.log("[xml-utils] starting findTagByName with", Z, " and ", ee);
  const be = indexOfMatch(ie, `<${Z}[ 
>/]`, ye);
  if (ae && console.log("[xml-utils] start:", be), be === -1)
    return;
  const Ye = ie.slice(be + Z.length);
  let Qe = indexOfMatchEnd(Ye, "^[^<]*[ /]>", 0);
  const Je = Qe !== -1 && Ye[Qe - 1] === "/";
  if (ae && console.log("[xml-utils] selfClosing:", Je), Je === !1)
    if (ve) {
      let lt = 0, ft = 1, gt = 0;
      for (; (Qe = indexOfMatchEnd(Ye, "[ /]" + Z + ">", lt)) !== -1; ) {
        const ct = Ye.substring(lt, Qe + 1);
        if (ft += countSubstring(ct, "<" + Z + `[ 
	>]`), gt += countSubstring(ct, "</" + Z + ">"), gt >= ft)
          break;
        lt = Qe;
      }
    } else
      Qe = indexOfMatchEnd(Ye, "[ /]" + Z + ">", 0);
  const nt = be + Z.length + Qe + 1;
  if (ae && console.log("[xml-utils] end:", nt), nt === -1)
    return;
  const st = ie.slice(be, nt);
  let ot;
  return Je ? ot = null : ot = st.slice(st.indexOf(">") + 1, st.lastIndexOf("<")), { inner: ot, outer: st, start: be, end: nt };
}
findTagByName$2.exports = findTagByName$1;
findTagByName$2.exports.default = findTagByName$1;
var findTagByNameExports = findTagByName$2.exports;
const findTagByName = findTagByNameExports;
function findTagsByName(ie, Z, ee) {
  const ae = [], ve = ee && ee.debug || !1, ye = ee && typeof ee.nested == "boolean" ? ee.nested : !0;
  let be = ee && ee.startIndex || 0, Ye;
  for (; Ye = findTagByName(ie, Z, { debug: ve, startIndex: be }); )
    ye ? be = Ye.start + 1 + Z.length : be = Ye.end, ae.push(Ye);
  return ve && console.log("findTagsByName found", ae.length, "tags"), ae;
}
findTagsByName$2.exports = findTagsByName;
findTagsByName$2.exports.default = findTagsByName;
var findTagsByNameExports = findTagsByName$2.exports;
const findTagsByName$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(findTagsByNameExports), fieldTagNames = {
  // TIFF Baseline
  315: "Artist",
  258: "BitsPerSample",
  265: "CellLength",
  264: "CellWidth",
  320: "ColorMap",
  259: "Compression",
  33432: "Copyright",
  306: "DateTime",
  338: "ExtraSamples",
  266: "FillOrder",
  289: "FreeByteCounts",
  288: "FreeOffsets",
  291: "GrayResponseCurve",
  290: "GrayResponseUnit",
  316: "HostComputer",
  270: "ImageDescription",
  257: "ImageLength",
  256: "ImageWidth",
  271: "Make",
  281: "MaxSampleValue",
  280: "MinSampleValue",
  272: "Model",
  254: "NewSubfileType",
  274: "Orientation",
  262: "PhotometricInterpretation",
  284: "PlanarConfiguration",
  296: "ResolutionUnit",
  278: "RowsPerStrip",
  277: "SamplesPerPixel",
  305: "Software",
  279: "StripByteCounts",
  273: "StripOffsets",
  255: "SubfileType",
  263: "Threshholding",
  282: "XResolution",
  283: "YResolution",
  // TIFF Extended
  326: "BadFaxLines",
  327: "CleanFaxData",
  343: "ClipPath",
  328: "ConsecutiveBadFaxLines",
  433: "Decode",
  434: "DefaultImageColor",
  269: "DocumentName",
  336: "DotRange",
  321: "HalftoneHints",
  346: "Indexed",
  347: "JPEGTables",
  285: "PageName",
  297: "PageNumber",
  317: "Predictor",
  319: "PrimaryChromaticities",
  532: "ReferenceBlackWhite",
  339: "SampleFormat",
  340: "SMinSampleValue",
  341: "SMaxSampleValue",
  559: "StripRowCounts",
  330: "SubIFDs",
  292: "T4Options",
  293: "T6Options",
  325: "TileByteCounts",
  323: "TileLength",
  324: "TileOffsets",
  322: "TileWidth",
  301: "TransferFunction",
  318: "WhitePoint",
  344: "XClipPathUnits",
  286: "XPosition",
  529: "YCbCrCoefficients",
  531: "YCbCrPositioning",
  530: "YCbCrSubSampling",
  345: "YClipPathUnits",
  287: "YPosition",
  // EXIF
  37378: "ApertureValue",
  40961: "ColorSpace",
  36868: "DateTimeDigitized",
  36867: "DateTimeOriginal",
  34665: "Exif IFD",
  36864: "ExifVersion",
  33434: "ExposureTime",
  41728: "FileSource",
  37385: "Flash",
  40960: "FlashpixVersion",
  33437: "FNumber",
  42016: "ImageUniqueID",
  37384: "LightSource",
  37500: "MakerNote",
  37377: "ShutterSpeedValue",
  37510: "UserComment",
  // IPTC
  33723: "IPTC",
  // ICC
  34675: "ICC Profile",
  // XMP
  700: "XMP",
  // GDAL
  42112: "GDAL_METADATA",
  42113: "GDAL_NODATA",
  // Photoshop
  34377: "Photoshop",
  // GeoTiff
  33550: "ModelPixelScale",
  33922: "ModelTiepoint",
  34264: "ModelTransformation",
  34735: "GeoKeyDirectory",
  34736: "GeoDoubleParams",
  34737: "GeoAsciiParams",
  // LERC
  50674: "LercParameters"
}, fieldTags = {};
for (const ie in fieldTagNames)
  fieldTagNames.hasOwnProperty(ie) && (fieldTags[fieldTagNames[ie]] = parseInt(ie, 10));
const arrayFields = [
  fieldTags.BitsPerSample,
  fieldTags.ExtraSamples,
  fieldTags.SampleFormat,
  fieldTags.StripByteCounts,
  fieldTags.StripOffsets,
  fieldTags.StripRowCounts,
  fieldTags.TileByteCounts,
  fieldTags.TileOffsets,
  fieldTags.SubIFDs
], fieldTypeNames = {
  1: "BYTE",
  2: "ASCII",
  3: "SHORT",
  4: "LONG",
  5: "RATIONAL",
  6: "SBYTE",
  7: "UNDEFINED",
  8: "SSHORT",
  9: "SLONG",
  10: "SRATIONAL",
  11: "FLOAT",
  12: "DOUBLE",
  // IFD offset, suggested by https://owl.phy.queensu.ca/~phil/exiftool/standards.html
  13: "IFD",
  // introduced by BigTIFF
  16: "LONG8",
  17: "SLONG8",
  18: "IFD8"
}, fieldTypes = {};
for (const ie in fieldTypeNames)
  fieldTypeNames.hasOwnProperty(ie) && (fieldTypes[fieldTypeNames[ie]] = parseInt(ie, 10));
const photometricInterpretations = {
  WhiteIsZero: 0,
  BlackIsZero: 1,
  RGB: 2,
  Palette: 3,
  TransparencyMask: 4,
  CMYK: 5,
  YCbCr: 6,
  CIELab: 8,
  ICCLab: 9
}, ExtraSamplesValues = {
  Unspecified: 0,
  Assocalpha: 1,
  Unassalpha: 2
}, LercParameters = {
  Version: 0,
  AddCompression: 1
}, LercAddCompression = {
  None: 0,
  Deflate: 1,
  Zstandard: 2
}, geoKeyNames = {
  1024: "GTModelTypeGeoKey",
  1025: "GTRasterTypeGeoKey",
  1026: "GTCitationGeoKey",
  2048: "GeographicTypeGeoKey",
  2049: "GeogCitationGeoKey",
  2050: "GeogGeodeticDatumGeoKey",
  2051: "GeogPrimeMeridianGeoKey",
  2052: "GeogLinearUnitsGeoKey",
  2053: "GeogLinearUnitSizeGeoKey",
  2054: "GeogAngularUnitsGeoKey",
  2055: "GeogAngularUnitSizeGeoKey",
  2056: "GeogEllipsoidGeoKey",
  2057: "GeogSemiMajorAxisGeoKey",
  2058: "GeogSemiMinorAxisGeoKey",
  2059: "GeogInvFlatteningGeoKey",
  2060: "GeogAzimuthUnitsGeoKey",
  2061: "GeogPrimeMeridianLongGeoKey",
  2062: "GeogTOWGS84GeoKey",
  3072: "ProjectedCSTypeGeoKey",
  3073: "PCSCitationGeoKey",
  3074: "ProjectionGeoKey",
  3075: "ProjCoordTransGeoKey",
  3076: "ProjLinearUnitsGeoKey",
  3077: "ProjLinearUnitSizeGeoKey",
  3078: "ProjStdParallel1GeoKey",
  3079: "ProjStdParallel2GeoKey",
  3080: "ProjNatOriginLongGeoKey",
  3081: "ProjNatOriginLatGeoKey",
  3082: "ProjFalseEastingGeoKey",
  3083: "ProjFalseNorthingGeoKey",
  3084: "ProjFalseOriginLongGeoKey",
  3085: "ProjFalseOriginLatGeoKey",
  3086: "ProjFalseOriginEastingGeoKey",
  3087: "ProjFalseOriginNorthingGeoKey",
  3088: "ProjCenterLongGeoKey",
  3089: "ProjCenterLatGeoKey",
  3090: "ProjCenterEastingGeoKey",
  3091: "ProjCenterNorthingGeoKey",
  3092: "ProjScaleAtNatOriginGeoKey",
  3093: "ProjScaleAtCenterGeoKey",
  3094: "ProjAzimuthAngleGeoKey",
  3095: "ProjStraightVertPoleLongGeoKey",
  3096: "ProjRectifiedGridAngleGeoKey",
  4096: "VerticalCSTypeGeoKey",
  4097: "VerticalCitationGeoKey",
  4098: "VerticalDatumGeoKey",
  4099: "VerticalUnitsGeoKey"
};
function fromWhiteIsZero(ie, Z) {
  const { width: ee, height: ae } = ie, ve = new Uint8Array(ee * ae * 3);
  let ye;
  for (let be = 0, Ye = 0; be < ie.length; ++be, Ye += 3)
    ye = 256 - ie[be] / Z * 256, ve[Ye] = ye, ve[Ye + 1] = ye, ve[Ye + 2] = ye;
  return ve;
}
function fromBlackIsZero(ie, Z) {
  const { width: ee, height: ae } = ie, ve = new Uint8Array(ee * ae * 3);
  let ye;
  for (let be = 0, Ye = 0; be < ie.length; ++be, Ye += 3)
    ye = ie[be] / Z * 256, ve[Ye] = ye, ve[Ye + 1] = ye, ve[Ye + 2] = ye;
  return ve;
}
function fromPalette(ie, Z) {
  const { width: ee, height: ae } = ie, ve = new Uint8Array(ee * ae * 3), ye = Z.length / 3, be = Z.length / 3 * 2;
  for (let Ye = 0, Qe = 0; Ye < ie.length; ++Ye, Qe += 3) {
    const Je = ie[Ye];
    ve[Qe] = Z[Je] / 65536 * 256, ve[Qe + 1] = Z[Je + ye] / 65536 * 256, ve[Qe + 2] = Z[Je + be] / 65536 * 256;
  }
  return ve;
}
function fromCMYK(ie) {
  const { width: Z, height: ee } = ie, ae = new Uint8Array(Z * ee * 3);
  for (let ve = 0, ye = 0; ve < ie.length; ve += 4, ye += 3) {
    const be = ie[ve], Ye = ie[ve + 1], Qe = ie[ve + 2], Je = ie[ve + 3];
    ae[ye] = 255 * ((255 - be) / 256) * ((255 - Je) / 256), ae[ye + 1] = 255 * ((255 - Ye) / 256) * ((255 - Je) / 256), ae[ye + 2] = 255 * ((255 - Qe) / 256) * ((255 - Je) / 256);
  }
  return ae;
}
function fromYCbCr(ie) {
  const { width: Z, height: ee } = ie, ae = new Uint8ClampedArray(Z * ee * 3);
  for (let ve = 0, ye = 0; ve < ie.length; ve += 3, ye += 3) {
    const be = ie[ve], Ye = ie[ve + 1], Qe = ie[ve + 2];
    ae[ye] = be + 1.402 * (Qe - 128), ae[ye + 1] = be - 0.34414 * (Ye - 128) - 0.71414 * (Qe - 128), ae[ye + 2] = be + 1.772 * (Ye - 128);
  }
  return ae;
}
const Xn$1 = 0.95047, Yn$1 = 1, Zn$1 = 1.08883;
function fromCIELab(ie) {
  const { width: Z, height: ee } = ie, ae = new Uint8Array(Z * ee * 3);
  for (let ve = 0, ye = 0; ve < ie.length; ve += 3, ye += 3) {
    const be = ie[ve + 0], Ye = ie[ve + 1] << 24 >> 24, Qe = ie[ve + 2] << 24 >> 24;
    let Je = (be + 16) / 116, nt = Ye / 500 + Je, st = Je - Qe / 200, ot, lt, ft;
    nt = Xn$1 * (nt * nt * nt > 8856e-6 ? nt * nt * nt : (nt - 16 / 116) / 7.787), Je = Yn$1 * (Je * Je * Je > 8856e-6 ? Je * Je * Je : (Je - 16 / 116) / 7.787), st = Zn$1 * (st * st * st > 8856e-6 ? st * st * st : (st - 16 / 116) / 7.787), ot = nt * 3.2406 + Je * -1.5372 + st * -0.4986, lt = nt * -0.9689 + Je * 1.8758 + st * 0.0415, ft = nt * 0.0557 + Je * -0.204 + st * 1.057, ot = ot > 31308e-7 ? 1.055 * ot ** (1 / 2.4) - 0.055 : 12.92 * ot, lt = lt > 31308e-7 ? 1.055 * lt ** (1 / 2.4) - 0.055 : 12.92 * lt, ft = ft > 31308e-7 ? 1.055 * ft ** (1 / 2.4) - 0.055 : 12.92 * ft, ae[ye] = Math.max(0, Math.min(1, ot)) * 255, ae[ye + 1] = Math.max(0, Math.min(1, lt)) * 255, ae[ye + 2] = Math.max(0, Math.min(1, ft)) * 255;
  }
  return ae;
}
const registry = /* @__PURE__ */ new Map();
function addDecoder(ie, Z) {
  Array.isArray(ie) || (ie = [ie]), ie.forEach((ee) => registry.set(ee, Z));
}
async function getDecoder(ie) {
  const Z = registry.get(ie.Compression);
  if (!Z)
    throw new Error(`Unknown compression method identifier: ${ie.Compression}`);
  const ee = await Z();
  return new ee(ie);
}
addDecoder([void 0, 1], () => import("./raw-_eObXrMO.js").then((ie) => ie.default));
addDecoder(5, () => import("./lzw-5BnjP5Zu.js").then((ie) => ie.default));
addDecoder(6, () => {
  throw new Error("old style JPEG compression is not supported.");
});
addDecoder(7, () => import("./jpeg-cL5qbLGO.js").then((ie) => ie.default));
addDecoder([8, 32946], () => import("./deflate-vcCR2g03.js").then((ie) => ie.default));
addDecoder(32773, () => import("./packbits-QLsyzNt2.js").then((ie) => ie.default));
addDecoder(
  34887,
  () => import("./lerc-uk49vBKp.js").then(async (ie) => (await ie.zstd.init(), ie)).then((ie) => ie.default)
);
addDecoder(50001, () => import("./webimage-Hf-HYtMO.js").then((ie) => ie.default));
function copyNewSize(ie, Z, ee, ae = 1) {
  return new (Object.getPrototypeOf(ie)).constructor(Z * ee * ae);
}
function resampleNearest(ie, Z, ee, ae, ve) {
  const ye = Z / ae, be = ee / ve;
  return ie.map((Ye) => {
    const Qe = copyNewSize(Ye, ae, ve);
    for (let Je = 0; Je < ve; ++Je) {
      const nt = Math.min(Math.round(be * Je), ee - 1);
      for (let st = 0; st < ae; ++st) {
        const ot = Math.min(Math.round(ye * st), Z - 1), lt = Ye[nt * Z + ot];
        Qe[Je * ae + st] = lt;
      }
    }
    return Qe;
  });
}
function lerp(ie, Z, ee) {
  return (1 - ee) * ie + ee * Z;
}
function resampleBilinear(ie, Z, ee, ae, ve) {
  const ye = Z / ae, be = ee / ve;
  return ie.map((Ye) => {
    const Qe = copyNewSize(Ye, ae, ve);
    for (let Je = 0; Je < ve; ++Je) {
      const nt = be * Je, st = Math.floor(nt), ot = Math.min(Math.ceil(nt), ee - 1);
      for (let lt = 0; lt < ae; ++lt) {
        const ft = ye * lt, gt = ft % 1, ct = Math.floor(ft), _r = Math.min(Math.ceil(ft), Z - 1), Kr = Ye[st * Z + ct], Xr = Ye[st * Z + _r], Jr = Ye[ot * Z + ct], ei = Ye[ot * Z + _r], si = lerp(
          lerp(Kr, Xr, gt),
          lerp(Jr, ei, gt),
          nt % 1
        );
        Qe[Je * ae + lt] = si;
      }
    }
    return Qe;
  });
}
function resample(ie, Z, ee, ae, ve, ye = "nearest") {
  switch (ye.toLowerCase()) {
    case "nearest":
      return resampleNearest(ie, Z, ee, ae, ve);
    case "bilinear":
    case "linear":
      return resampleBilinear(ie, Z, ee, ae, ve);
    default:
      throw new Error(`Unsupported resampling method: '${ye}'`);
  }
}
function resampleNearestInterleaved(ie, Z, ee, ae, ve, ye) {
  const be = Z / ae, Ye = ee / ve, Qe = copyNewSize(ie, ae, ve, ye);
  for (let Je = 0; Je < ve; ++Je) {
    const nt = Math.min(Math.round(Ye * Je), ee - 1);
    for (let st = 0; st < ae; ++st) {
      const ot = Math.min(Math.round(be * st), Z - 1);
      for (let lt = 0; lt < ye; ++lt) {
        const ft = ie[nt * Z * ye + ot * ye + lt];
        Qe[Je * ae * ye + st * ye + lt] = ft;
      }
    }
  }
  return Qe;
}
function resampleBilinearInterleaved(ie, Z, ee, ae, ve, ye) {
  const be = Z / ae, Ye = ee / ve, Qe = copyNewSize(ie, ae, ve, ye);
  for (let Je = 0; Je < ve; ++Je) {
    const nt = Ye * Je, st = Math.floor(nt), ot = Math.min(Math.ceil(nt), ee - 1);
    for (let lt = 0; lt < ae; ++lt) {
      const ft = be * lt, gt = ft % 1, ct = Math.floor(ft), _r = Math.min(Math.ceil(ft), Z - 1);
      for (let Kr = 0; Kr < ye; ++Kr) {
        const Xr = ie[st * Z * ye + ct * ye + Kr], Jr = ie[st * Z * ye + _r * ye + Kr], ei = ie[ot * Z * ye + ct * ye + Kr], si = ie[ot * Z * ye + _r * ye + Kr], ri = lerp(
          lerp(Xr, Jr, gt),
          lerp(ei, si, gt),
          nt % 1
        );
        Qe[Je * ae * ye + lt * ye + Kr] = ri;
      }
    }
  }
  return Qe;
}
function resampleInterleaved(ie, Z, ee, ae, ve, ye, be = "nearest") {
  switch (be.toLowerCase()) {
    case "nearest":
      return resampleNearestInterleaved(
        ie,
        Z,
        ee,
        ae,
        ve,
        ye
      );
    case "bilinear":
    case "linear":
      return resampleBilinearInterleaved(
        ie,
        Z,
        ee,
        ae,
        ve,
        ye
      );
    default:
      throw new Error(`Unsupported resampling method: '${be}'`);
  }
}
function sum(ie, Z, ee) {
  let ae = 0;
  for (let ve = Z; ve < ee; ++ve)
    ae += ie[ve];
  return ae;
}
function arrayForType(ie, Z, ee) {
  switch (ie) {
    case 1:
      if (Z <= 8)
        return new Uint8Array(ee);
      if (Z <= 16)
        return new Uint16Array(ee);
      if (Z <= 32)
        return new Uint32Array(ee);
      break;
    case 2:
      if (Z === 8)
        return new Int8Array(ee);
      if (Z === 16)
        return new Int16Array(ee);
      if (Z === 32)
        return new Int32Array(ee);
      break;
    case 3:
      switch (Z) {
        case 16:
        case 32:
          return new Float32Array(ee);
        case 64:
          return new Float64Array(ee);
      }
      break;
  }
  throw Error("Unsupported data format/bitsPerSample");
}
function needsNormalization(ie, Z) {
  return (ie === 1 || ie === 2) && Z <= 32 && Z % 8 === 0 ? !1 : !(ie === 3 && (Z === 16 || Z === 32 || Z === 64));
}
function normalizeArray(ie, Z, ee, ae, ve, ye, be) {
  const Ye = new DataView(ie), Qe = ee === 2 ? be * ye : be * ye * ae, Je = ee === 2 ? 1 : ae, nt = arrayForType(Z, ve, Qe), st = parseInt("1".repeat(ve), 2);
  if (Z === 1) {
    let ot;
    ee === 1 ? ot = ae * ve : ot = ve;
    let lt = ye * ot;
    lt & 7 && (lt = lt + 7 & -8);
    for (let ft = 0; ft < be; ++ft) {
      const gt = ft * lt;
      for (let ct = 0; ct < ye; ++ct) {
        const _r = gt + ct * Je * ve;
        for (let Kr = 0; Kr < Je; ++Kr) {
          const Xr = _r + Kr * ve, Jr = (ft * ye + ct) * Je + Kr, ei = Math.floor(Xr / 8), si = Xr % 8;
          if (si + ve <= 8)
            nt[Jr] = Ye.getUint8(ei) >> 8 - ve - si & st;
          else if (si + ve <= 16)
            nt[Jr] = Ye.getUint16(ei) >> 16 - ve - si & st;
          else if (si + ve <= 24) {
            const ri = Ye.getUint16(ei) << 8 | Ye.getUint8(ei + 2);
            nt[Jr] = ri >> 24 - ve - si & st;
          } else
            nt[Jr] = Ye.getUint32(ei) >> 32 - ve - si & st;
        }
      }
    }
  }
  return nt.buffer;
}
class GeoTIFFImage {
  /**
   * @constructor
   * @param {Object} fileDirectory The parsed file directory
   * @param {Object} geoKeys The parsed geo-keys
   * @param {DataView} dataView The DataView for the underlying file.
   * @param {Boolean} littleEndian Whether the file is encoded in little or big endian
   * @param {Boolean} cache Whether or not decoded tiles shall be cached
   * @param {import('./source/basesource').BaseSource} source The datasource to read from
   */
  constructor(Z, ee, ae, ve, ye, be) {
    this.fileDirectory = Z, this.geoKeys = ee, this.dataView = ae, this.littleEndian = ve, this.tiles = ye ? {} : null, this.isTiled = !Z.StripOffsets;
    const Ye = Z.PlanarConfiguration;
    if (this.planarConfiguration = typeof Ye > "u" ? 1 : Ye, this.planarConfiguration !== 1 && this.planarConfiguration !== 2)
      throw new Error("Invalid planar configuration.");
    this.source = be;
  }
  /**
   * Returns the associated parsed file directory.
   * @returns {Object} the parsed file directory
   */
  getFileDirectory() {
    return this.fileDirectory;
  }
  /**
   * Returns the associated parsed geo keys.
   * @returns {Object} the parsed geo keys
   */
  getGeoKeys() {
    return this.geoKeys;
  }
  /**
   * Returns the width of the image.
   * @returns {Number} the width of the image
   */
  getWidth() {
    return this.fileDirectory.ImageWidth;
  }
  /**
   * Returns the height of the image.
   * @returns {Number} the height of the image
   */
  getHeight() {
    return this.fileDirectory.ImageLength;
  }
  /**
   * Returns the number of samples per pixel.
   * @returns {Number} the number of samples per pixel
   */
  getSamplesPerPixel() {
    return typeof this.fileDirectory.SamplesPerPixel < "u" ? this.fileDirectory.SamplesPerPixel : 1;
  }
  /**
   * Returns the width of each tile.
   * @returns {Number} the width of each tile
   */
  getTileWidth() {
    return this.isTiled ? this.fileDirectory.TileWidth : this.getWidth();
  }
  /**
   * Returns the height of each tile.
   * @returns {Number} the height of each tile
   */
  getTileHeight() {
    return this.isTiled ? this.fileDirectory.TileLength : typeof this.fileDirectory.RowsPerStrip < "u" ? Math.min(this.fileDirectory.RowsPerStrip, this.getHeight()) : this.getHeight();
  }
  getBlockWidth() {
    return this.getTileWidth();
  }
  getBlockHeight(Z) {
    return this.isTiled || (Z + 1) * this.getTileHeight() <= this.getHeight() ? this.getTileHeight() : this.getHeight() - Z * this.getTileHeight();
  }
  /**
   * Calculates the number of bytes for each pixel across all samples. Only full
   * bytes are supported, an exception is thrown when this is not the case.
   * @returns {Number} the bytes per pixel
   */
  getBytesPerPixel() {
    let Z = 0;
    for (let ee = 0; ee < this.fileDirectory.BitsPerSample.length; ++ee)
      Z += this.getSampleByteSize(ee);
    return Z;
  }
  getSampleByteSize(Z) {
    if (Z >= this.fileDirectory.BitsPerSample.length)
      throw new RangeError(`Sample index ${Z} is out of range.`);
    return Math.ceil(this.fileDirectory.BitsPerSample[Z] / 8);
  }
  getReaderForSample(Z) {
    const ee = this.fileDirectory.SampleFormat ? this.fileDirectory.SampleFormat[Z] : 1, ae = this.fileDirectory.BitsPerSample[Z];
    switch (ee) {
      case 1:
        if (ae <= 8)
          return DataView.prototype.getUint8;
        if (ae <= 16)
          return DataView.prototype.getUint16;
        if (ae <= 32)
          return DataView.prototype.getUint32;
        break;
      case 2:
        if (ae <= 8)
          return DataView.prototype.getInt8;
        if (ae <= 16)
          return DataView.prototype.getInt16;
        if (ae <= 32)
          return DataView.prototype.getInt32;
        break;
      case 3:
        switch (ae) {
          case 16:
            return function(ve, ye) {
              return getFloat16(this, ve, ye);
            };
          case 32:
            return DataView.prototype.getFloat32;
          case 64:
            return DataView.prototype.getFloat64;
        }
        break;
    }
    throw Error("Unsupported data format/bitsPerSample");
  }
  getSampleFormat(Z = 0) {
    return this.fileDirectory.SampleFormat ? this.fileDirectory.SampleFormat[Z] : 1;
  }
  getBitsPerSample(Z = 0) {
    return this.fileDirectory.BitsPerSample[Z];
  }
  getArrayForSample(Z, ee) {
    const ae = this.getSampleFormat(Z), ve = this.getBitsPerSample(Z);
    return arrayForType(ae, ve, ee);
  }
  /**
   * Returns the decoded strip or tile.
   * @param {Number} x the strip or tile x-offset
   * @param {Number} y the tile y-offset (0 for stripped images)
   * @param {Number} sample the sample to get for separated samples
   * @param {import("./geotiff").Pool|import("./geotiff").BaseDecoder} poolOrDecoder the decoder or decoder pool
   * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
   *                               to be aborted
   * @returns {Promise.<ArrayBuffer>}
   */
  async getTileOrStrip(Z, ee, ae, ve, ye) {
    const be = Math.ceil(this.getWidth() / this.getTileWidth()), Ye = Math.ceil(this.getHeight() / this.getTileHeight());
    let Qe;
    const { tiles: Je } = this;
    this.planarConfiguration === 1 ? Qe = ee * be + Z : this.planarConfiguration === 2 && (Qe = ae * be * Ye + ee * be + Z);
    let nt, st;
    this.isTiled ? (nt = this.fileDirectory.TileOffsets[Qe], st = this.fileDirectory.TileByteCounts[Qe]) : (nt = this.fileDirectory.StripOffsets[Qe], st = this.fileDirectory.StripByteCounts[Qe]);
    const ot = (await this.source.fetch([{ offset: nt, length: st }], ye))[0];
    let lt;
    return Je === null || !Je[Qe] ? (lt = (async () => {
      let ft = await ve.decode(this.fileDirectory, ot);
      const gt = this.getSampleFormat(), ct = this.getBitsPerSample();
      return needsNormalization(gt, ct) && (ft = normalizeArray(
        ft,
        gt,
        this.planarConfiguration,
        this.getSamplesPerPixel(),
        ct,
        this.getTileWidth(),
        this.getBlockHeight(ee)
      )), ft;
    })(), Je !== null && (Je[Qe] = lt)) : lt = Je[Qe], { x: Z, y: ee, sample: ae, data: await lt };
  }
  /**
   * Internal read function.
   * @private
   * @param {Array} imageWindow The image window in pixel coordinates
   * @param {Array} samples The selected samples (0-based indices)
   * @param {TypedArray|TypedArray[]} valueArrays The array(s) to write into
   * @param {Boolean} interleave Whether or not to write in an interleaved manner
   * @param {import("./geotiff").Pool|AbstractDecoder} poolOrDecoder the decoder or decoder pool
   * @param {number} width the width of window to be read into
   * @param {number} height the height of window to be read into
   * @param {number} resampleMethod the resampling method to be used when interpolating
   * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
   *                               to be aborted
   * @returns {Promise<ReadRasterResult>}
   */
  async _readRaster(Z, ee, ae, ve, ye, be, Ye, Qe, Je) {
    const nt = this.getTileWidth(), st = this.getTileHeight(), ot = this.getWidth(), lt = this.getHeight(), ft = Math.max(Math.floor(Z[0] / nt), 0), gt = Math.min(
      Math.ceil(Z[2] / nt),
      Math.ceil(ot / nt)
    ), ct = Math.max(Math.floor(Z[1] / st), 0), _r = Math.min(
      Math.ceil(Z[3] / st),
      Math.ceil(lt / st)
    ), Kr = Z[2] - Z[0];
    let Xr = this.getBytesPerPixel();
    const Jr = [], ei = [];
    for (let ai = 0; ai < ee.length; ++ai)
      this.planarConfiguration === 1 ? Jr.push(sum(this.fileDirectory.BitsPerSample, 0, ee[ai]) / 8) : Jr.push(0), ei.push(this.getReaderForSample(ee[ai]));
    const si = [], { littleEndian: ri } = this;
    for (let ai = ct; ai < _r; ++ai)
      for (let yi = ft; yi < gt; ++yi) {
        let pi;
        this.planarConfiguration === 1 && (pi = this.getTileOrStrip(yi, ai, 0, ye, Je));
        for (let di = 0; di < ee.length; ++di) {
          const xi = di, Ti = ee[di];
          this.planarConfiguration === 2 && (Xr = this.getSampleByteSize(Ti), pi = this.getTileOrStrip(yi, ai, Ti, ye, Je));
          const Ai = pi.then((mi) => {
            const Si = mi.data, gi = new DataView(Si), _i = this.getBlockHeight(mi.y), Oi = mi.y * st, hi = mi.x * nt, Di = Oi + _i, Ri = (mi.x + 1) * nt, rs = ei[xi], Hi = Math.min(_i, _i - (Di - Z[3]), lt - Oi), qi = Math.min(nt, nt - (Ri - Z[2]), ot - hi);
            for (let us = Math.max(0, Z[1] - Oi); us < Hi; ++us)
              for (let Yi = Math.max(0, Z[0] - hi); Yi < qi; ++Yi) {
                const is = (us * nt + Yi) * Xr, Ss = rs.call(
                  gi,
                  is + Jr[xi],
                  ri
                );
                let Gs;
                ve ? (Gs = (us + Oi - Z[1]) * Kr * ee.length + (Yi + hi - Z[0]) * ee.length + xi, ae[Gs] = Ss) : (Gs = (us + Oi - Z[1]) * Kr + Yi + hi - Z[0], ae[xi][Gs] = Ss);
              }
          });
          si.push(Ai);
        }
      }
    if (await Promise.all(si), be && Z[2] - Z[0] !== be || Ye && Z[3] - Z[1] !== Ye) {
      let ai;
      return ve ? ai = resampleInterleaved(
        ae,
        Z[2] - Z[0],
        Z[3] - Z[1],
        be,
        Ye,
        ee.length,
        Qe
      ) : ai = resample(
        ae,
        Z[2] - Z[0],
        Z[3] - Z[1],
        be,
        Ye,
        Qe
      ), ai.width = be, ai.height = Ye, ai;
    }
    return ae.width = be || Z[2] - Z[0], ae.height = Ye || Z[3] - Z[1], ae;
  }
  /**
   * Reads raster data from the image. This function reads all selected samples
   * into separate arrays of the correct type for that sample or into a single
   * combined array when `interleave` is set. When provided, only a subset
   * of the raster is read for each sample.
   *
   * @param {ReadRasterOptions} [options={}] optional parameters
   * @returns {Promise<ReadRasterResult>} the decoded arrays as a promise
   */
  async readRasters({
    window: Z,
    samples: ee = [],
    interleave: ae,
    pool: ve = null,
    width: ye,
    height: be,
    resampleMethod: Ye,
    fillValue: Qe,
    signal: Je
  } = {}) {
    const nt = Z || [0, 0, this.getWidth(), this.getHeight()];
    if (nt[0] > nt[2] || nt[1] > nt[3])
      throw new Error("Invalid subsets");
    const st = nt[2] - nt[0], ot = nt[3] - nt[1], lt = st * ot, ft = this.getSamplesPerPixel();
    if (!ee || !ee.length)
      for (let Kr = 0; Kr < ft; ++Kr)
        ee.push(Kr);
    else
      for (let Kr = 0; Kr < ee.length; ++Kr)
        if (ee[Kr] >= ft)
          return Promise.reject(new RangeError(`Invalid sample index '${ee[Kr]}'.`));
    let gt;
    if (ae) {
      const Kr = this.fileDirectory.SampleFormat ? Math.max.apply(null, this.fileDirectory.SampleFormat) : 1, Xr = Math.max.apply(null, this.fileDirectory.BitsPerSample);
      gt = arrayForType(Kr, Xr, lt * ee.length), Qe && gt.fill(Qe);
    } else {
      gt = [];
      for (let Kr = 0; Kr < ee.length; ++Kr) {
        const Xr = this.getArrayForSample(ee[Kr], lt);
        Array.isArray(Qe) && Kr < Qe.length ? Xr.fill(Qe[Kr]) : Qe && !Array.isArray(Qe) && Xr.fill(Qe), gt.push(Xr);
      }
    }
    const ct = ve || await getDecoder(this.fileDirectory);
    return await this._readRaster(
      nt,
      ee,
      gt,
      ae,
      ct,
      ye,
      be,
      Ye,
      Je
    );
  }
  /**
   * Reads raster data from the image as RGB. The result is always an
   * interleaved typed array.
   * Colorspaces other than RGB will be transformed to RGB, color maps expanded.
   * When no other method is applicable, the first sample is used to produce a
   * grayscale image.
   * When provided, only a subset of the raster is read for each sample.
   *
   * @param {Object} [options] optional parameters
   * @param {Array<number>} [options.window] the subset to read data from in pixels.
   * @param {boolean} [options.interleave=true] whether the data shall be read
   *                                             in one single array or separate
   *                                             arrays.
   * @param {import("./geotiff").Pool} [options.pool=null] The optional decoder pool to use.
   * @param {number} [options.width] The desired width of the output. When the width is no the
   *                                 same as the images, resampling will be performed.
   * @param {number} [options.height] The desired height of the output. When the width is no the
   *                                  same as the images, resampling will be performed.
   * @param {string} [options.resampleMethod='nearest'] The desired resampling method.
   * @param {boolean} [options.enableAlpha=false] Enable reading alpha channel if present.
   * @param {AbortSignal} [options.signal] An AbortSignal that may be signalled if the request is
   *                                       to be aborted
   * @returns {Promise<ReadRasterResult>} the RGB array as a Promise
   */
  async readRGB({
    window: Z,
    interleave: ee = !0,
    pool: ae = null,
    width: ve,
    height: ye,
    resampleMethod: be,
    enableAlpha: Ye = !1,
    signal: Qe
  } = {}) {
    const Je = Z || [0, 0, this.getWidth(), this.getHeight()];
    if (Je[0] > Je[2] || Je[1] > Je[3])
      throw new Error("Invalid subsets");
    const nt = this.fileDirectory.PhotometricInterpretation;
    if (nt === photometricInterpretations.RGB) {
      let _r = [0, 1, 2];
      if (this.fileDirectory.ExtraSamples !== ExtraSamplesValues.Unspecified && Ye) {
        _r = [];
        for (let Kr = 0; Kr < this.fileDirectory.BitsPerSample.length; Kr += 1)
          _r.push(Kr);
      }
      return this.readRasters({
        window: Z,
        interleave: ee,
        samples: _r,
        pool: ae,
        width: ve,
        height: ye,
        resampleMethod: be,
        signal: Qe
      });
    }
    let st;
    switch (nt) {
      case photometricInterpretations.WhiteIsZero:
      case photometricInterpretations.BlackIsZero:
      case photometricInterpretations.Palette:
        st = [0];
        break;
      case photometricInterpretations.CMYK:
        st = [0, 1, 2, 3];
        break;
      case photometricInterpretations.YCbCr:
      case photometricInterpretations.CIELab:
        st = [0, 1, 2];
        break;
      default:
        throw new Error("Invalid or unsupported photometric interpretation.");
    }
    const ot = {
      window: Je,
      interleave: !0,
      samples: st,
      pool: ae,
      width: ve,
      height: ye,
      resampleMethod: be,
      signal: Qe
    }, { fileDirectory: lt } = this, ft = await this.readRasters(ot), gt = 2 ** this.fileDirectory.BitsPerSample[0];
    let ct;
    switch (nt) {
      case photometricInterpretations.WhiteIsZero:
        ct = fromWhiteIsZero(ft, gt);
        break;
      case photometricInterpretations.BlackIsZero:
        ct = fromBlackIsZero(ft, gt);
        break;
      case photometricInterpretations.Palette:
        ct = fromPalette(ft, lt.ColorMap);
        break;
      case photometricInterpretations.CMYK:
        ct = fromCMYK(ft);
        break;
      case photometricInterpretations.YCbCr:
        ct = fromYCbCr(ft);
        break;
      case photometricInterpretations.CIELab:
        ct = fromCIELab(ft);
        break;
      default:
        throw new Error("Unsupported photometric interpretation.");
    }
    if (!ee) {
      const _r = new Uint8Array(ct.length / 3), Kr = new Uint8Array(ct.length / 3), Xr = new Uint8Array(ct.length / 3);
      for (let Jr = 0, ei = 0; Jr < ct.length; Jr += 3, ++ei)
        _r[ei] = ct[Jr], Kr[ei] = ct[Jr + 1], Xr[ei] = ct[Jr + 2];
      ct = [_r, Kr, Xr];
    }
    return ct.width = ft.width, ct.height = ft.height, ct;
  }
  /**
   * Returns an array of tiepoints.
   * @returns {Object[]}
   */
  getTiePoints() {
    if (!this.fileDirectory.ModelTiepoint)
      return [];
    const Z = [];
    for (let ee = 0; ee < this.fileDirectory.ModelTiepoint.length; ee += 6)
      Z.push({
        i: this.fileDirectory.ModelTiepoint[ee],
        j: this.fileDirectory.ModelTiepoint[ee + 1],
        k: this.fileDirectory.ModelTiepoint[ee + 2],
        x: this.fileDirectory.ModelTiepoint[ee + 3],
        y: this.fileDirectory.ModelTiepoint[ee + 4],
        z: this.fileDirectory.ModelTiepoint[ee + 5]
      });
    return Z;
  }
  /**
   * Returns the parsed GDAL metadata items.
   *
   * If sample is passed to null, dataset-level metadata will be returned.
   * Otherwise only metadata specific to the provided sample will be returned.
   *
   * @param {number} [sample=null] The sample index.
   * @returns {Object}
   */
  getGDALMetadata(Z = null) {
    const ee = {};
    if (!this.fileDirectory.GDAL_METADATA)
      return null;
    const ae = this.fileDirectory.GDAL_METADATA;
    let ve = findTagsByName$1(ae, "Item");
    Z === null ? ve = ve.filter((ye) => getAttribute$1(ye, "sample") === void 0) : ve = ve.filter((ye) => Number(getAttribute$1(ye, "sample")) === Z);
    for (let ye = 0; ye < ve.length; ++ye) {
      const be = ve[ye];
      ee[getAttribute$1(be, "name")] = be.inner;
    }
    return ee;
  }
  /**
   * Returns the GDAL nodata value
   * @returns {number|null}
   */
  getGDALNoData() {
    if (!this.fileDirectory.GDAL_NODATA)
      return null;
    const Z = this.fileDirectory.GDAL_NODATA;
    return Number(Z.substring(0, Z.length - 1));
  }
  /**
   * Returns the image origin as a XYZ-vector. When the image has no affine
   * transformation, then an exception is thrown.
   * @returns {Array<number>} The origin as a vector
   */
  getOrigin() {
    const Z = this.fileDirectory.ModelTiepoint, ee = this.fileDirectory.ModelTransformation;
    if (Z && Z.length === 6)
      return [
        Z[3],
        Z[4],
        Z[5]
      ];
    if (ee)
      return [
        ee[3],
        ee[7],
        ee[11]
      ];
    throw new Error("The image does not have an affine transformation.");
  }
  /**
   * Returns the image resolution as a XYZ-vector. When the image has no affine
   * transformation, then an exception is thrown.
   * @param {GeoTIFFImage} [referenceImage=null] A reference image to calculate the resolution from
   *                                             in cases when the current image does not have the
   *                                             required tags on its own.
   * @returns {Array<number>} The resolution as a vector
   */
  getResolution(Z = null) {
    const ee = this.fileDirectory.ModelPixelScale, ae = this.fileDirectory.ModelTransformation;
    if (ee)
      return [
        ee[0],
        -ee[1],
        ee[2]
      ];
    if (ae)
      return [
        ae[0],
        -ae[5],
        ae[10]
      ];
    if (Z) {
      const [ve, ye, be] = Z.getResolution();
      return [
        ve * Z.getWidth() / this.getWidth(),
        ye * Z.getHeight() / this.getHeight(),
        be * Z.getWidth() / this.getWidth()
      ];
    }
    throw new Error("The image does not have an affine transformation.");
  }
  /**
   * Returns whether or not the pixels of the image depict an area (or point).
   * @returns {Boolean} Whether the pixels are a point
   */
  pixelIsArea() {
    return this.geoKeys.GTRasterTypeGeoKey === 1;
  }
  /**
   * Returns the image bounding box as an array of 4 values: min-x, min-y,
   * max-x and max-y. When the image has no affine transformation, then an
   * exception is thrown.
   * @param {boolean} [tilegrid=false] If true return extent for a tilegrid 
   *                                   without adjustment for ModelTransformation.
   * @returns {Array<number>} The bounding box
   */
  getBoundingBox(Z = !1) {
    const ee = this.getHeight(), ae = this.getWidth();
    if (this.fileDirectory.ModelTransformation && !Z) {
      const [ve, ye, be, Ye, Qe, Je, nt, st] = this.fileDirectory.ModelTransformation, lt = [
        [0, 0],
        [0, ee],
        [ae, 0],
        [ae, ee]
      ].map(([ct, _r]) => [
        Ye + ve * ct + ye * _r,
        st + Qe * ct + Je * _r
      ]), ft = lt.map((ct) => ct[0]), gt = lt.map((ct) => ct[1]);
      return [
        Math.min(...ft),
        Math.min(...gt),
        Math.max(...ft),
        Math.max(...gt)
      ];
    } else {
      const ve = this.getOrigin(), ye = this.getResolution(), be = ve[0], Ye = ve[1], Qe = be + ye[0] * ae, Je = Ye + ye[1] * ee;
      return [
        Math.min(be, Qe),
        Math.min(Ye, Je),
        Math.max(be, Qe),
        Math.max(Ye, Je)
      ];
    }
  }
}
class DataView64 {
  constructor(Z) {
    this._dataView = new DataView(Z);
  }
  get buffer() {
    return this._dataView.buffer;
  }
  getUint64(Z, ee) {
    const ae = this.getUint32(Z, ee), ve = this.getUint32(Z + 4, ee);
    let ye;
    if (ee) {
      if (ye = ae + 2 ** 32 * ve, !Number.isSafeInteger(ye))
        throw new Error(
          `${ye} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
        );
      return ye;
    }
    if (ye = 2 ** 32 * ae + ve, !Number.isSafeInteger(ye))
      throw new Error(
        `${ye} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
      );
    return ye;
  }
  // adapted from https://stackoverflow.com/a/55338384/8060591
  getInt64(Z, ee) {
    let ae = 0;
    const ve = (this._dataView.getUint8(Z + (ee ? 7 : 0)) & 128) > 0;
    let ye = !0;
    for (let be = 0; be < 8; be++) {
      let Ye = this._dataView.getUint8(Z + (ee ? be : 7 - be));
      ve && (ye ? Ye !== 0 && (Ye = ~(Ye - 1) & 255, ye = !1) : Ye = ~Ye & 255), ae += Ye * 256 ** be;
    }
    return ve && (ae = -ae), ae;
  }
  getUint8(Z, ee) {
    return this._dataView.getUint8(Z, ee);
  }
  getInt8(Z, ee) {
    return this._dataView.getInt8(Z, ee);
  }
  getUint16(Z, ee) {
    return this._dataView.getUint16(Z, ee);
  }
  getInt16(Z, ee) {
    return this._dataView.getInt16(Z, ee);
  }
  getUint32(Z, ee) {
    return this._dataView.getUint32(Z, ee);
  }
  getInt32(Z, ee) {
    return this._dataView.getInt32(Z, ee);
  }
  getFloat16(Z, ee) {
    return getFloat16(this._dataView, Z, ee);
  }
  getFloat32(Z, ee) {
    return this._dataView.getFloat32(Z, ee);
  }
  getFloat64(Z, ee) {
    return this._dataView.getFloat64(Z, ee);
  }
}
class DataSlice {
  constructor(Z, ee, ae, ve) {
    this._dataView = new DataView(Z), this._sliceOffset = ee, this._littleEndian = ae, this._bigTiff = ve;
  }
  get sliceOffset() {
    return this._sliceOffset;
  }
  get sliceTop() {
    return this._sliceOffset + this.buffer.byteLength;
  }
  get littleEndian() {
    return this._littleEndian;
  }
  get bigTiff() {
    return this._bigTiff;
  }
  get buffer() {
    return this._dataView.buffer;
  }
  covers(Z, ee) {
    return this.sliceOffset <= Z && this.sliceTop >= Z + ee;
  }
  readUint8(Z) {
    return this._dataView.getUint8(
      Z - this._sliceOffset,
      this._littleEndian
    );
  }
  readInt8(Z) {
    return this._dataView.getInt8(
      Z - this._sliceOffset,
      this._littleEndian
    );
  }
  readUint16(Z) {
    return this._dataView.getUint16(
      Z - this._sliceOffset,
      this._littleEndian
    );
  }
  readInt16(Z) {
    return this._dataView.getInt16(
      Z - this._sliceOffset,
      this._littleEndian
    );
  }
  readUint32(Z) {
    return this._dataView.getUint32(
      Z - this._sliceOffset,
      this._littleEndian
    );
  }
  readInt32(Z) {
    return this._dataView.getInt32(
      Z - this._sliceOffset,
      this._littleEndian
    );
  }
  readFloat32(Z) {
    return this._dataView.getFloat32(
      Z - this._sliceOffset,
      this._littleEndian
    );
  }
  readFloat64(Z) {
    return this._dataView.getFloat64(
      Z - this._sliceOffset,
      this._littleEndian
    );
  }
  readUint64(Z) {
    const ee = this.readUint32(Z), ae = this.readUint32(Z + 4);
    let ve;
    if (this._littleEndian) {
      if (ve = ee + 2 ** 32 * ae, !Number.isSafeInteger(ve))
        throw new Error(
          `${ve} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
        );
      return ve;
    }
    if (ve = 2 ** 32 * ee + ae, !Number.isSafeInteger(ve))
      throw new Error(
        `${ve} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
      );
    return ve;
  }
  // adapted from https://stackoverflow.com/a/55338384/8060591
  readInt64(Z) {
    let ee = 0;
    const ae = (this._dataView.getUint8(Z + (this._littleEndian ? 7 : 0)) & 128) > 0;
    let ve = !0;
    for (let ye = 0; ye < 8; ye++) {
      let be = this._dataView.getUint8(
        Z + (this._littleEndian ? ye : 7 - ye)
      );
      ae && (ve ? be !== 0 && (be = ~(be - 1) & 255, ve = !1) : be = ~be & 255), ee += be * 256 ** ye;
    }
    return ae && (ee = -ee), ee;
  }
  readOffset(Z) {
    return this._bigTiff ? this.readUint64(Z) : this.readUint32(Z);
  }
}
const defaultPoolSize = typeof navigator < "u" && navigator.hardwareConcurrency || 2;
class Pool {
  /**
   * @constructor
   * @param {Number} [size] The size of the pool. Defaults to the number of CPUs
   *                      available. When this parameter is `null` or 0, then the
   *                      decoding will be done in the main thread.
   * @param {function(): Worker} [createWorker] A function that creates the decoder worker.
   * Defaults to a worker with all decoders that ship with geotiff.js. The `createWorker()`
   * function is expected to return a `Worker` compatible with Web Workers. For code that
   * runs in Node, [web-worker](https://www.npmjs.com/package/web-worker) is a good choice.
   *
   * A worker that uses a custom lzw decoder would look like this `my-custom-worker.js` file:
   * ```js
   * import { addDecoder, getDecoder } from 'geotiff';
   * addDecoder(5, () => import ('./my-custom-lzw').then((m) => m.default));
   * self.addEventListener('message', async (e) => {
   *   const { id, fileDirectory, buffer } = e.data;
   *   const decoder = await getDecoder(fileDirectory);
   *   const decoded = await decoder.decode(fileDirectory, buffer);
   *   self.postMessage({ decoded, id }, [decoded]);
   * });
   * ```
   * The way the above code is built into a worker by the `createWorker()` function
   * depends on the used bundler. For most bundlers, something like this will work:
   * ```js
   * function createWorker() {
   *   return new Worker(new URL('./my-custom-worker.js', import.meta.url));
   * }
   * ```
   */
  constructor(Z = defaultPoolSize, ee) {
    this.workers = null, this._awaitingDecoder = null, this.size = Z, this.messageId = 0, Z && (this._awaitingDecoder = ee ? Promise.resolve(ee) : new Promise((ae) => {
      import("./decoder-b0JuKe3x.js").then((ve) => {
        ae(ve.create);
      });
    }), this._awaitingDecoder.then((ae) => {
      this._awaitingDecoder = null, this.workers = [];
      for (let ve = 0; ve < Z; ve++)
        this.workers.push({ worker: ae(), idle: !0 });
    }));
  }
  /**
   * Decode the given block of bytes with the set compression method.
   * @param {ArrayBuffer} buffer the array buffer of bytes to decode.
   * @returns {Promise<ArrayBuffer>} the decoded result as a `Promise`
   */
  async decode(Z, ee) {
    return this._awaitingDecoder && await this._awaitingDecoder, this.size === 0 ? getDecoder(Z).then((ae) => ae.decode(Z, ee)) : new Promise((ae) => {
      const ve = this.workers.find((Ye) => Ye.idle) || this.workers[Math.floor(Math.random() * this.size)];
      ve.idle = !1;
      const ye = this.messageId++, be = (Ye) => {
        Ye.data.id === ye && (ve.idle = !0, ae(Ye.data.decoded), ve.worker.removeEventListener("message", be));
      };
      ve.worker.addEventListener("message", be), ve.worker.postMessage({ fileDirectory: Z, buffer: ee, id: ye }, [ee]);
    });
  }
  destroy() {
    this.workers && (this.workers.forEach((Z) => {
      Z.worker.terminate();
    }), this.workers = null);
  }
}
const CRLFCRLF = `\r
\r
`;
function itemsToObject(ie) {
  if (typeof Object.fromEntries < "u")
    return Object.fromEntries(ie);
  const Z = {};
  for (const [ee, ae] of ie)
    Z[ee.toLowerCase()] = ae;
  return Z;
}
function parseHeaders(ie) {
  const Z = ie.split(`\r
`).map((ee) => {
    const ae = ee.split(":").map((ve) => ve.trim());
    return ae[0] = ae[0].toLowerCase(), ae;
  });
  return itemsToObject(Z);
}
function parseContentType(ie) {
  const [Z, ...ee] = ie.split(";").map((ve) => ve.trim()), ae = ee.map((ve) => ve.split("="));
  return { type: Z, params: itemsToObject(ae) };
}
function parseContentRange(ie) {
  let Z, ee, ae;
  return ie && ([, Z, ee, ae] = ie.match(/bytes (\d+)-(\d+)\/(\d+)/), Z = parseInt(Z, 10), ee = parseInt(ee, 10), ae = parseInt(ae, 10)), { start: Z, end: ee, total: ae };
}
function parseByteRanges(ie, Z) {
  let ee = null;
  const ae = new TextDecoder("ascii"), ve = [], ye = `--${Z}`, be = `${ye}--`;
  for (let Ye = 0; Ye < 10; ++Ye)
    ae.decode(
      new Uint8Array(ie, Ye, ye.length)
    ) === ye && (ee = Ye);
  if (ee === null)
    throw new Error("Could not find initial boundary");
  for (; ee < ie.byteLength; ) {
    const Ye = ae.decode(
      new Uint8Array(
        ie,
        ee,
        Math.min(ye.length + 1024, ie.byteLength - ee)
      )
    );
    if (Ye.length === 0 || Ye.startsWith(be))
      break;
    if (!Ye.startsWith(ye))
      throw new Error("Part does not start with boundary");
    const Qe = Ye.substr(ye.length + 2);
    if (Qe.length === 0)
      break;
    const Je = Qe.indexOf(CRLFCRLF), nt = parseHeaders(Qe.substr(0, Je)), { start: st, end: ot, total: lt } = parseContentRange(nt["content-range"]), ft = ee + ye.length + Je + CRLFCRLF.length, gt = parseInt(ot, 10) + 1 - parseInt(st, 10);
    ve.push({
      headers: nt,
      data: ie.slice(ft, ft + gt),
      offset: st,
      length: gt,
      fileSize: lt
    }), ee = ft + gt + 4;
  }
  return ve;
}
class BaseSource {
  /**
   *
   * @param {Slice[]} slices
   * @returns {ArrayBuffer[]}
   */
  async fetch(Z, ee = void 0) {
    return Promise.all(
      Z.map((ae) => this.fetchSlice(ae, ee))
    );
  }
  /**
   *
   * @param {Slice} slice
   * @returns {ArrayBuffer}
   */
  async fetchSlice(Z) {
    throw new Error(`fetching of slice ${Z} not possible, not implemented`);
  }
  /**
   * Returns the filesize if already determined and null otherwise
   */
  get fileSize() {
    return null;
  }
  async close() {
  }
}
class QuickLRU extends Map {
  constructor(Z = {}) {
    if (super(), !(Z.maxSize && Z.maxSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    if (typeof Z.maxAge == "number" && Z.maxAge === 0)
      throw new TypeError("`maxAge` must be a number greater than 0");
    this.maxSize = Z.maxSize, this.maxAge = Z.maxAge || Number.POSITIVE_INFINITY, this.onEviction = Z.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
  }
  // TODO: Use private class methods when targeting Node.js 16.
  _emitEvictions(Z) {
    if (typeof this.onEviction == "function")
      for (const [ee, ae] of Z)
        this.onEviction(ee, ae.value);
  }
  _deleteIfExpired(Z, ee) {
    return typeof ee.expiry == "number" && ee.expiry <= Date.now() ? (typeof this.onEviction == "function" && this.onEviction(Z, ee.value), this.delete(Z)) : !1;
  }
  _getOrDeleteIfExpired(Z, ee) {
    if (this._deleteIfExpired(Z, ee) === !1)
      return ee.value;
  }
  _getItemValue(Z, ee) {
    return ee.expiry ? this._getOrDeleteIfExpired(Z, ee) : ee.value;
  }
  _peek(Z, ee) {
    const ae = ee.get(Z);
    return this._getItemValue(Z, ae);
  }
  _set(Z, ee) {
    this.cache.set(Z, ee), this._size++, this._size >= this.maxSize && (this._size = 0, this._emitEvictions(this.oldCache), this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map());
  }
  _moveToRecent(Z, ee) {
    this.oldCache.delete(Z), this._set(Z, ee);
  }
  *_entriesAscending() {
    for (const Z of this.oldCache) {
      const [ee, ae] = Z;
      this.cache.has(ee) || this._deleteIfExpired(ee, ae) === !1 && (yield Z);
    }
    for (const Z of this.cache) {
      const [ee, ae] = Z;
      this._deleteIfExpired(ee, ae) === !1 && (yield Z);
    }
  }
  get(Z) {
    if (this.cache.has(Z)) {
      const ee = this.cache.get(Z);
      return this._getItemValue(Z, ee);
    }
    if (this.oldCache.has(Z)) {
      const ee = this.oldCache.get(Z);
      if (this._deleteIfExpired(Z, ee) === !1)
        return this._moveToRecent(Z, ee), ee.value;
    }
  }
  set(Z, ee, { maxAge: ae = this.maxAge } = {}) {
    const ve = typeof ae == "number" && ae !== Number.POSITIVE_INFINITY ? Date.now() + ae : void 0;
    return this.cache.has(Z) ? this.cache.set(Z, {
      value: ee,
      expiry: ve
    }) : this._set(Z, { value: ee, expiry: ve }), this;
  }
  has(Z) {
    return this.cache.has(Z) ? !this._deleteIfExpired(Z, this.cache.get(Z)) : this.oldCache.has(Z) ? !this._deleteIfExpired(Z, this.oldCache.get(Z)) : !1;
  }
  peek(Z) {
    if (this.cache.has(Z))
      return this._peek(Z, this.cache);
    if (this.oldCache.has(Z))
      return this._peek(Z, this.oldCache);
  }
  delete(Z) {
    const ee = this.cache.delete(Z);
    return ee && this._size--, this.oldCache.delete(Z) || ee;
  }
  clear() {
    this.cache.clear(), this.oldCache.clear(), this._size = 0;
  }
  resize(Z) {
    if (!(Z && Z > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    const ee = [...this._entriesAscending()], ae = ee.length - Z;
    ae < 0 ? (this.cache = new Map(ee), this.oldCache = /* @__PURE__ */ new Map(), this._size = ee.length) : (ae > 0 && this._emitEvictions(ee.slice(0, ae)), this.oldCache = new Map(ee.slice(ae)), this.cache = /* @__PURE__ */ new Map(), this._size = 0), this.maxSize = Z;
  }
  *keys() {
    for (const [Z] of this)
      yield Z;
  }
  *values() {
    for (const [, Z] of this)
      yield Z;
  }
  *[Symbol.iterator]() {
    for (const Z of this.cache) {
      const [ee, ae] = Z;
      this._deleteIfExpired(ee, ae) === !1 && (yield [ee, ae.value]);
    }
    for (const Z of this.oldCache) {
      const [ee, ae] = Z;
      this.cache.has(ee) || this._deleteIfExpired(ee, ae) === !1 && (yield [ee, ae.value]);
    }
  }
  *entriesDescending() {
    let Z = [...this.cache];
    for (let ee = Z.length - 1; ee >= 0; --ee) {
      const ae = Z[ee], [ve, ye] = ae;
      this._deleteIfExpired(ve, ye) === !1 && (yield [ve, ye.value]);
    }
    Z = [...this.oldCache];
    for (let ee = Z.length - 1; ee >= 0; --ee) {
      const ae = Z[ee], [ve, ye] = ae;
      this.cache.has(ve) || this._deleteIfExpired(ve, ye) === !1 && (yield [ve, ye.value]);
    }
  }
  *entriesAscending() {
    for (const [Z, ee] of this._entriesAscending())
      yield [Z, ee.value];
  }
  get size() {
    if (!this._size)
      return this.oldCache.size;
    let Z = 0;
    for (const ee of this.oldCache.keys())
      this.cache.has(ee) || Z++;
    return Math.min(this._size + Z, this.maxSize);
  }
  entries() {
    return this.entriesAscending();
  }
  forEach(Z, ee = this) {
    for (const [ae, ve] of this.entriesAscending())
      Z.call(ee, ve, ae, this);
  }
  get [Symbol.toStringTag]() {
    return JSON.stringify([...this.entriesAscending()]);
  }
}
async function wait(ie) {
  return new Promise((Z) => setTimeout(Z, ie));
}
function zip(ie, Z) {
  const ee = Array.isArray(ie) ? ie : Array.from(ie), ae = Array.isArray(Z) ? Z : Array.from(Z);
  return ee.map((ve, ye) => [ve, ae[ye]]);
}
class AbortError extends Error {
  constructor(Z) {
    super(Z), Error.captureStackTrace && Error.captureStackTrace(this, AbortError), this.name = "AbortError";
  }
}
class CustomAggregateError extends Error {
  constructor(Z, ee) {
    super(ee), this.errors = Z, this.message = ee, this.name = "AggregateError";
  }
}
const AggregateError = CustomAggregateError;
class Block {
  /**
   *
   * @param {number} offset
   * @param {number} length
   * @param {ArrayBuffer} [data]
   */
  constructor(Z, ee, ae = null) {
    this.offset = Z, this.length = ee, this.data = ae;
  }
  /**
   * @returns {number} the top byte border
   */
  get top() {
    return this.offset + this.length;
  }
}
class BlockGroup {
  /**
   *
   * @param {number} offset
   * @param {number} length
   * @param {number[]} blockIds
   */
  constructor(Z, ee, ae) {
    this.offset = Z, this.length = ee, this.blockIds = ae;
  }
}
class BlockedSource extends BaseSource {
  /**
   *
   * @param {BaseSource} source The underlying source that shall be blocked and cached
   * @param {object} options
   * @param {number} [options.blockSize]
   * @param {number} [options.cacheSize]
   */
  constructor(Z, { blockSize: ee = 65536, cacheSize: ae = 100 } = {}) {
    super(), this.source = Z, this.blockSize = ee, this.blockCache = new QuickLRU({
      maxSize: ae,
      onEviction: (ve, ye) => {
        this.evictedBlocks.set(ve, ye);
      }
    }), this.evictedBlocks = /* @__PURE__ */ new Map(), this.blockRequests = /* @__PURE__ */ new Map(), this.blockIdsToFetch = /* @__PURE__ */ new Set(), this.abortedBlockIds = /* @__PURE__ */ new Set();
  }
  get fileSize() {
    return this.source.fileSize;
  }
  /**
   *
   * @param {import("./basesource").Slice[]} slices
   */
  async fetch(Z, ee) {
    const ae = [], ve = [], ye = [];
    this.evictedBlocks.clear();
    for (const { offset: ot, length: lt } of Z) {
      let ft = ot + lt;
      const { fileSize: gt } = this;
      gt !== null && (ft = Math.min(ft, gt));
      const ct = Math.floor(ot / this.blockSize) * this.blockSize;
      for (let _r = ct; _r < ft; _r += this.blockSize) {
        const Kr = Math.floor(_r / this.blockSize);
        !this.blockCache.has(Kr) && !this.blockRequests.has(Kr) && (this.blockIdsToFetch.add(Kr), ve.push(Kr)), this.blockRequests.has(Kr) && ae.push(this.blockRequests.get(Kr)), ye.push(Kr);
      }
    }
    await wait(), this.fetchBlocks(ee);
    const be = [];
    for (const ot of ve)
      this.blockRequests.has(ot) && be.push(this.blockRequests.get(ot));
    await Promise.allSettled(ae), await Promise.allSettled(be);
    const Ye = [], Qe = ye.filter((ot) => this.abortedBlockIds.has(ot) || !this.blockCache.has(ot));
    if (Qe.forEach((ot) => this.blockIdsToFetch.add(ot)), Qe.length > 0 && ee && !ee.aborted) {
      this.fetchBlocks(null);
      for (const ot of Qe) {
        const lt = this.blockRequests.get(ot);
        if (!lt)
          throw new Error(`Block ${ot} is not in the block requests`);
        Ye.push(lt);
      }
      await Promise.allSettled(Ye);
    }
    if (ee && ee.aborted)
      throw new AbortError("Request was aborted");
    const Je = ye.map((ot) => this.blockCache.get(ot) || this.evictedBlocks.get(ot)), nt = Je.filter((ot) => !ot);
    if (nt.length)
      throw new AggregateError(nt, "Request failed");
    const st = new Map(zip(ye, Je));
    return this.readSliceData(Z, st);
  }
  /**
   *
   * @param {AbortSignal} signal
   */
  fetchBlocks(Z) {
    if (this.blockIdsToFetch.size > 0) {
      const ee = this.groupBlocks(this.blockIdsToFetch), ae = this.source.fetch(ee, Z);
      for (let ve = 0; ve < ee.length; ++ve) {
        const ye = ee[ve];
        for (const be of ye.blockIds)
          this.blockRequests.set(be, (async () => {
            try {
              const Ye = (await ae)[ve], Qe = be * this.blockSize, Je = Qe - Ye.offset, nt = Math.min(Je + this.blockSize, Ye.data.byteLength), st = Ye.data.slice(Je, nt), ot = new Block(
                Qe,
                st.byteLength,
                st,
                be
              );
              this.blockCache.set(be, ot), this.abortedBlockIds.delete(be);
            } catch (Ye) {
              if (Ye.name === "AbortError")
                Ye.signal = Z, this.blockCache.delete(be), this.abortedBlockIds.add(be);
              else
                throw Ye;
            } finally {
              this.blockRequests.delete(be);
            }
          })());
      }
      this.blockIdsToFetch.clear();
    }
  }
  /**
   *
   * @param {Set} blockIds
   * @returns {BlockGroup[]}
   */
  groupBlocks(Z) {
    const ee = Array.from(Z).sort((be, Ye) => be - Ye);
    if (ee.length === 0)
      return [];
    let ae = [], ve = null;
    const ye = [];
    for (const be of ee)
      ve === null || ve + 1 === be ? (ae.push(be), ve = be) : (ye.push(new BlockGroup(
        ae[0] * this.blockSize,
        ae.length * this.blockSize,
        ae
      )), ae = [be], ve = be);
    return ye.push(new BlockGroup(
      ae[0] * this.blockSize,
      ae.length * this.blockSize,
      ae
    )), ye;
  }
  /**
   *
   * @param {import("./basesource").Slice[]} slices
   * @param {Map} blocks
   */
  readSliceData(Z, ee) {
    return Z.map((ae) => {
      let ve = ae.offset + ae.length;
      this.fileSize !== null && (ve = Math.min(this.fileSize, ve));
      const ye = Math.floor(ae.offset / this.blockSize), be = Math.floor(ve / this.blockSize), Ye = new ArrayBuffer(ae.length), Qe = new Uint8Array(Ye);
      for (let Je = ye; Je <= be; ++Je) {
        const nt = ee.get(Je), st = nt.offset - ae.offset, ot = nt.top - ve;
        let lt = 0, ft = 0, gt;
        st < 0 ? lt = -st : st > 0 && (ft = st), ot < 0 ? gt = nt.length - lt : gt = ve - nt.offset - lt;
        const ct = new Uint8Array(nt.data, lt, gt);
        Qe.set(ct, ft);
      }
      return Ye;
    });
  }
}
class BaseResponse {
  /**
   * Returns whether the response has an ok'ish status code
   */
  get ok() {
    return this.status >= 200 && this.status <= 299;
  }
  /**
   * Returns the status code of the response
   */
  get status() {
    throw new Error("not implemented");
  }
  /**
   * Returns the value of the specified header
   * @param {string} headerName the header name
   * @returns {string} the header value
   */
  getHeader(Z) {
    throw new Error("not implemented");
  }
  /**
   * @returns {ArrayBuffer} the response data of the request
   */
  async getData() {
    throw new Error("not implemented");
  }
}
class BaseClient {
  constructor(Z) {
    this.url = Z;
  }
  /**
   * Send a request with the options
   * @param {{headers: HeadersInit, signal: AbortSignal}} [options={}]
   * @returns {Promise<BaseResponse>}
   */
  async request({ headers: Z, signal: ee } = {}) {
    throw new Error("request is not implemented");
  }
}
class FetchResponse extends BaseResponse {
  /**
   * BaseResponse facade for fetch API Response
   * @param {Response} response
   */
  constructor(Z) {
    super(), this.response = Z;
  }
  get status() {
    return this.response.status;
  }
  getHeader(Z) {
    return this.response.headers.get(Z);
  }
  async getData() {
    return this.response.arrayBuffer ? await this.response.arrayBuffer() : (await this.response.buffer()).buffer;
  }
}
class FetchClient extends BaseClient {
  constructor(Z, ee) {
    super(Z), this.credentials = ee;
  }
  /**
   * @param {{headers: HeadersInit, signal: AbortSignal}} [options={}]
   * @returns {Promise<FetchResponse>}
   */
  async request({ headers: Z, signal: ee } = {}) {
    const ae = await fetch(this.url, {
      headers: Z,
      credentials: this.credentials,
      signal: ee
    });
    return new FetchResponse(ae);
  }
}
class XHRResponse extends BaseResponse {
  /**
   * BaseResponse facade for XMLHttpRequest
   * @param {XMLHttpRequest} xhr
   * @param {ArrayBuffer} data
   */
  constructor(Z, ee) {
    super(), this.xhr = Z, this.data = ee;
  }
  get status() {
    return this.xhr.status;
  }
  getHeader(Z) {
    return this.xhr.getResponseHeader(Z);
  }
  async getData() {
    return this.data;
  }
}
class XHRClient extends BaseClient {
  constructRequest(Z, ee) {
    return new Promise((ae, ve) => {
      const ye = new XMLHttpRequest();
      ye.open("GET", this.url), ye.responseType = "arraybuffer";
      for (const [be, Ye] of Object.entries(Z))
        ye.setRequestHeader(be, Ye);
      ye.onload = () => {
        const be = ye.response;
        ae(new XHRResponse(ye, be));
      }, ye.onerror = ve, ye.onabort = () => ve(new AbortError("Request aborted")), ye.send(), ee && (ee.aborted && ye.abort(), ee.addEventListener("abort", () => ye.abort()));
    });
  }
  async request({ headers: Z, signal: ee } = {}) {
    return await this.constructRequest(Z, ee);
  }
}
const fs = {}, __viteBrowserExternal = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fs
}, Symbol.toStringTag, { value: "Module" }));
class HttpResponse extends BaseResponse {
  /**
   * BaseResponse facade for node HTTP/HTTPS API Response
   * @param {http.ServerResponse} response
   */
  constructor(Z, ee) {
    super(), this.response = Z, this.dataPromise = ee;
  }
  get status() {
    return this.response.statusCode;
  }
  getHeader(Z) {
    return this.response.headers[Z];
  }
  async getData() {
    return await this.dataPromise;
  }
}
class HttpClient extends BaseClient {
  constructor(Z) {
    super(Z), this.parsedUrl = fs.parse(this.url), this.httpApi = (this.parsedUrl.protocol === "http:", fs);
  }
  constructRequest(Z, ee) {
    return new Promise((ae, ve) => {
      const ye = this.httpApi.get(
        {
          ...this.parsedUrl,
          headers: Z
        },
        (be) => {
          const Ye = new Promise((Qe) => {
            const Je = [];
            be.on("data", (nt) => {
              Je.push(nt);
            }), be.on("end", () => {
              const nt = Buffer.concat(Je).buffer;
              Qe(nt);
            }), be.on("error", ve);
          });
          ae(new HttpResponse(be, Ye));
        }
      );
      ye.on("error", ve), ee && (ee.aborted && ye.destroy(new AbortError("Request aborted")), ee.addEventListener("abort", () => ye.destroy(new AbortError("Request aborted"))));
    });
  }
  async request({ headers: Z, signal: ee } = {}) {
    return await this.constructRequest(Z, ee);
  }
}
class RemoteSource extends BaseSource {
  /**
   *
   * @param {BaseClient} client
   * @param {object} headers
   * @param {numbers} maxRanges
   * @param {boolean} allowFullFile
   */
  constructor(Z, ee, ae, ve) {
    super(), this.client = Z, this.headers = ee, this.maxRanges = ae, this.allowFullFile = ve, this._fileSize = null;
  }
  /**
   *
   * @param {Slice[]} slices
   */
  async fetch(Z, ee) {
    return this.maxRanges >= Z.length ? this.fetchSlices(Z, ee) : (this.maxRanges > 0 && Z.length > 1, Promise.all(
      Z.map((ae) => this.fetchSlice(ae, ee))
    ));
  }
  async fetchSlices(Z, ee) {
    const ae = await this.client.request({
      headers: {
        ...this.headers,
        Range: `bytes=${Z.map(({ offset: ve, length: ye }) => `${ve}-${ve + ye}`).join(",")}`
      },
      signal: ee
    });
    if (ae.ok)
      if (ae.status === 206) {
        const { type: ve, params: ye } = parseContentType(ae.getHeader("content-type"));
        if (ve === "multipart/byteranges") {
          const st = parseByteRanges(await ae.getData(), ye.boundary);
          return this._fileSize = st[0].fileSize || null, st;
        }
        const be = await ae.getData(), { start: Ye, end: Qe, total: Je } = parseContentRange(ae.getHeader("content-range"));
        this._fileSize = Je || null;
        const nt = [{
          data: be,
          offset: Ye,
          length: Qe - Ye
        }];
        if (Z.length > 1) {
          const st = await Promise.all(Z.slice(1).map((ot) => this.fetchSlice(ot, ee)));
          return nt.concat(st);
        }
        return nt;
      } else {
        if (!this.allowFullFile)
          throw new Error("Server responded with full file");
        const ve = await ae.getData();
        return this._fileSize = ve.byteLength, [{
          data: ve,
          offset: 0,
          length: ve.byteLength
        }];
      }
    else
      throw new Error("Error fetching data.");
  }
  async fetchSlice(Z, ee) {
    const { offset: ae, length: ve } = Z, ye = await this.client.request({
      headers: {
        ...this.headers,
        Range: `bytes=${ae}-${ae + ve}`
      },
      signal: ee
    });
    if (ye.ok)
      if (ye.status === 206) {
        const be = await ye.getData(), { total: Ye } = parseContentRange(ye.getHeader("content-range"));
        return this._fileSize = Ye || null, {
          data: be,
          offset: ae,
          length: ve
        };
      } else {
        if (!this.allowFullFile)
          throw new Error("Server responded with full file");
        const be = await ye.getData();
        return this._fileSize = be.byteLength, {
          data: be,
          offset: 0,
          length: be.byteLength
        };
      }
    else
      throw new Error("Error fetching data.");
  }
  get fileSize() {
    return this._fileSize;
  }
}
function maybeWrapInBlockedSource(ie, { blockSize: Z, cacheSize: ee }) {
  return Z === null ? ie : new BlockedSource(ie, { blockSize: Z, cacheSize: ee });
}
function makeFetchSource(ie, { headers: Z = {}, credentials: ee, maxRanges: ae = 0, allowFullFile: ve = !1, ...ye } = {}) {
  const be = new FetchClient(ie, ee), Ye = new RemoteSource(be, Z, ae, ve);
  return maybeWrapInBlockedSource(Ye, ye);
}
function makeXHRSource(ie, { headers: Z = {}, maxRanges: ee = 0, allowFullFile: ae = !1, ...ve } = {}) {
  const ye = new XHRClient(ie), be = new RemoteSource(ye, Z, ee, ae);
  return maybeWrapInBlockedSource(be, ve);
}
function makeHttpSource(ie, { headers: Z = {}, maxRanges: ee = 0, allowFullFile: ae = !1, ...ve } = {}) {
  const ye = new HttpClient(ie), be = new RemoteSource(ye, Z, ee, ae);
  return maybeWrapInBlockedSource(be, ve);
}
function makeRemoteSource(ie, { forceXHR: Z = !1, ...ee } = {}) {
  return typeof fetch == "function" && !Z ? makeFetchSource(ie, ee) : typeof XMLHttpRequest < "u" ? makeXHRSource(ie, ee) : makeHttpSource(ie, ee);
}
class FileReaderSource extends BaseSource {
  constructor(Z) {
    super(), this.file = Z;
  }
  async fetchSlice(Z, ee) {
    return new Promise((ae, ve) => {
      const ye = this.file.slice(Z.offset, Z.offset + Z.length), be = new FileReader();
      be.onload = (Ye) => ae(Ye.target.result), be.onerror = ve, be.onabort = ve, be.readAsArrayBuffer(ye), ee && ee.addEventListener("abort", () => be.abort());
    });
  }
}
function makeFileReaderSource(ie) {
  return new FileReaderSource(ie);
}
function getFieldTypeLength(ie) {
  switch (ie) {
    case fieldTypes.BYTE:
    case fieldTypes.ASCII:
    case fieldTypes.SBYTE:
    case fieldTypes.UNDEFINED:
      return 1;
    case fieldTypes.SHORT:
    case fieldTypes.SSHORT:
      return 2;
    case fieldTypes.LONG:
    case fieldTypes.SLONG:
    case fieldTypes.FLOAT:
    case fieldTypes.IFD:
      return 4;
    case fieldTypes.RATIONAL:
    case fieldTypes.SRATIONAL:
    case fieldTypes.DOUBLE:
    case fieldTypes.LONG8:
    case fieldTypes.SLONG8:
    case fieldTypes.IFD8:
      return 8;
    default:
      throw new RangeError(`Invalid field type: ${ie}`);
  }
}
function parseGeoKeyDirectory(ie) {
  const Z = ie.GeoKeyDirectory;
  if (!Z)
    return null;
  const ee = {};
  for (let ae = 4; ae <= Z[3] * 4; ae += 4) {
    const ve = geoKeyNames[Z[ae]], ye = Z[ae + 1] ? fieldTagNames[Z[ae + 1]] : null, be = Z[ae + 2], Ye = Z[ae + 3];
    let Qe = null;
    if (!ye)
      Qe = Ye;
    else {
      if (Qe = ie[ye], typeof Qe > "u" || Qe === null)
        throw new Error(`Could not get value of geoKey '${ve}'.`);
      typeof Qe == "string" ? Qe = Qe.substring(Ye, Ye + be - 1) : Qe.subarray && (Qe = Qe.subarray(Ye, Ye + be), be === 1 && (Qe = Qe[0]));
    }
    ee[ve] = Qe;
  }
  return ee;
}
function getValues(ie, Z, ee, ae) {
  let ve = null, ye = null;
  const be = getFieldTypeLength(Z);
  switch (Z) {
    case fieldTypes.BYTE:
    case fieldTypes.ASCII:
    case fieldTypes.UNDEFINED:
      ve = new Uint8Array(ee), ye = ie.readUint8;
      break;
    case fieldTypes.SBYTE:
      ve = new Int8Array(ee), ye = ie.readInt8;
      break;
    case fieldTypes.SHORT:
      ve = new Uint16Array(ee), ye = ie.readUint16;
      break;
    case fieldTypes.SSHORT:
      ve = new Int16Array(ee), ye = ie.readInt16;
      break;
    case fieldTypes.LONG:
    case fieldTypes.IFD:
      ve = new Uint32Array(ee), ye = ie.readUint32;
      break;
    case fieldTypes.SLONG:
      ve = new Int32Array(ee), ye = ie.readInt32;
      break;
    case fieldTypes.LONG8:
    case fieldTypes.IFD8:
      ve = new Array(ee), ye = ie.readUint64;
      break;
    case fieldTypes.SLONG8:
      ve = new Array(ee), ye = ie.readInt64;
      break;
    case fieldTypes.RATIONAL:
      ve = new Uint32Array(ee * 2), ye = ie.readUint32;
      break;
    case fieldTypes.SRATIONAL:
      ve = new Int32Array(ee * 2), ye = ie.readInt32;
      break;
    case fieldTypes.FLOAT:
      ve = new Float32Array(ee), ye = ie.readFloat32;
      break;
    case fieldTypes.DOUBLE:
      ve = new Float64Array(ee), ye = ie.readFloat64;
      break;
    default:
      throw new RangeError(`Invalid field type: ${Z}`);
  }
  if (Z === fieldTypes.RATIONAL || Z === fieldTypes.SRATIONAL)
    for (let Ye = 0; Ye < ee; Ye += 2)
      ve[Ye] = ye.call(
        ie,
        ae + Ye * be
      ), ve[Ye + 1] = ye.call(
        ie,
        ae + (Ye * be + 4)
      );
  else
    for (let Ye = 0; Ye < ee; ++Ye)
      ve[Ye] = ye.call(
        ie,
        ae + Ye * be
      );
  return Z === fieldTypes.ASCII ? new TextDecoder("utf-8").decode(ve) : ve;
}
class ImageFileDirectory {
  constructor(Z, ee, ae) {
    this.fileDirectory = Z, this.geoKeyDirectory = ee, this.nextIFDByteOffset = ae;
  }
}
class GeoTIFFImageIndexError extends Error {
  constructor(Z) {
    super(`No image at index ${Z}`), this.index = Z;
  }
}
class GeoTIFFBase {
  /**
   * (experimental) Reads raster data from the best fitting image. This function uses
   * the image with the lowest resolution that is still a higher resolution than the
   * requested resolution.
   * When specified, the `bbox` option is translated to the `window` option and the
   * `resX` and `resY` to `width` and `height` respectively.
   * Then, the [readRasters]{@link GeoTIFFImage#readRasters} method of the selected
   * image is called and the result returned.
   * @see GeoTIFFImage.readRasters
   * @param {import('./geotiffimage').ReadRasterOptions} [options={}] optional parameters
   * @returns {Promise<ReadRasterResult>} the decoded array(s), with `height` and `width`, as a promise
   */
  async readRasters(Z = {}) {
    const { window: ee, width: ae, height: ve } = Z;
    let { resX: ye, resY: be, bbox: Ye } = Z;
    const Qe = await this.getImage();
    let Je = Qe;
    const nt = await this.getImageCount(), st = Qe.getBoundingBox();
    if (ee && Ye)
      throw new Error('Both "bbox" and "window" passed.');
    if (ae || ve) {
      if (ee) {
        const [ft, gt] = Qe.getOrigin(), [ct, _r] = Qe.getResolution();
        Ye = [
          ft + ee[0] * ct,
          gt + ee[1] * _r,
          ft + ee[2] * ct,
          gt + ee[3] * _r
        ];
      }
      const lt = Ye || st;
      if (ae) {
        if (ye)
          throw new Error("Both width and resX passed");
        ye = (lt[2] - lt[0]) / ae;
      }
      if (ve) {
        if (be)
          throw new Error("Both width and resY passed");
        be = (lt[3] - lt[1]) / ve;
      }
    }
    if (ye || be) {
      const lt = [];
      for (let ft = 0; ft < nt; ++ft) {
        const gt = await this.getImage(ft), { SubfileType: ct, NewSubfileType: _r } = gt.fileDirectory;
        (ft === 0 || ct === 2 || _r & 1) && lt.push(gt);
      }
      lt.sort((ft, gt) => ft.getWidth() - gt.getWidth());
      for (let ft = 0; ft < lt.length; ++ft) {
        const gt = lt[ft], ct = (st[2] - st[0]) / gt.getWidth(), _r = (st[3] - st[1]) / gt.getHeight();
        if (Je = gt, ye && ye > ct || be && be > _r)
          break;
      }
    }
    let ot = ee;
    if (Ye) {
      const [lt, ft] = Qe.getOrigin(), [gt, ct] = Je.getResolution(Qe);
      ot = [
        Math.round((Ye[0] - lt) / gt),
        Math.round((Ye[1] - ft) / ct),
        Math.round((Ye[2] - lt) / gt),
        Math.round((Ye[3] - ft) / ct)
      ], ot = [
        Math.min(ot[0], ot[2]),
        Math.min(ot[1], ot[3]),
        Math.max(ot[0], ot[2]),
        Math.max(ot[1], ot[3])
      ];
    }
    return Je.readRasters({ ...Z, window: ot });
  }
}
class GeoTIFF extends GeoTIFFBase {
  /**
   * @constructor
   * @param {*} source The datasource to read from.
   * @param {boolean} littleEndian Whether the image uses little endian.
   * @param {boolean} bigTiff Whether the image uses bigTIFF conventions.
   * @param {number} firstIFDOffset The numeric byte-offset from the start of the image
   *                                to the first IFD.
   * @param {GeoTIFFOptions} [options] further options.
   */
  constructor(Z, ee, ae, ve, ye = {}) {
    super(), this.source = Z, this.littleEndian = ee, this.bigTiff = ae, this.firstIFDOffset = ve, this.cache = ye.cache || !1, this.ifdRequests = [], this.ghostValues = null;
  }
  async getSlice(Z, ee) {
    const ae = this.bigTiff ? 4048 : 1024;
    return new DataSlice(
      (await this.source.fetch([{
        offset: Z,
        length: typeof ee < "u" ? ee : ae
      }]))[0],
      Z,
      this.littleEndian,
      this.bigTiff
    );
  }
  /**
   * Instructs to parse an image file directory at the given file offset.
   * As there is no way to ensure that a location is indeed the start of an IFD,
   * this function must be called with caution (e.g only using the IFD offsets from
   * the headers or other IFDs).
   * @param {number} offset the offset to parse the IFD at
   * @returns {Promise<ImageFileDirectory>} the parsed IFD
   */
  async parseFileDirectoryAt(Z) {
    const ee = this.bigTiff ? 20 : 12, ae = this.bigTiff ? 8 : 2;
    let ve = await this.getSlice(Z);
    const ye = this.bigTiff ? ve.readUint64(Z) : ve.readUint16(Z), be = ye * ee + (this.bigTiff ? 16 : 6);
    ve.covers(Z, be) || (ve = await this.getSlice(Z, be));
    const Ye = {};
    let Qe = Z + (this.bigTiff ? 8 : 2);
    for (let st = 0; st < ye; Qe += ee, ++st) {
      const ot = ve.readUint16(Qe), lt = ve.readUint16(Qe + 2), ft = this.bigTiff ? ve.readUint64(Qe + 4) : ve.readUint32(Qe + 4);
      let gt, ct;
      const _r = getFieldTypeLength(lt), Kr = Qe + (this.bigTiff ? 12 : 8);
      if (_r * ft <= (this.bigTiff ? 8 : 4))
        gt = getValues(ve, lt, ft, Kr);
      else {
        const Xr = ve.readOffset(Kr), Jr = getFieldTypeLength(lt) * ft;
        if (ve.covers(Xr, Jr))
          gt = getValues(ve, lt, ft, Xr);
        else {
          const ei = await this.getSlice(Xr, Jr);
          gt = getValues(ei, lt, ft, Xr);
        }
      }
      ft === 1 && arrayFields.indexOf(ot) === -1 && !(lt === fieldTypes.RATIONAL || lt === fieldTypes.SRATIONAL) ? ct = gt[0] : ct = gt, Ye[fieldTagNames[ot]] = ct;
    }
    const Je = parseGeoKeyDirectory(Ye), nt = ve.readOffset(
      Z + ae + ee * ye
    );
    return new ImageFileDirectory(
      Ye,
      Je,
      nt
    );
  }
  async requestIFD(Z) {
    if (this.ifdRequests[Z])
      return this.ifdRequests[Z];
    if (Z === 0)
      return this.ifdRequests[Z] = this.parseFileDirectoryAt(this.firstIFDOffset), this.ifdRequests[Z];
    if (!this.ifdRequests[Z - 1])
      try {
        this.ifdRequests[Z - 1] = this.requestIFD(Z - 1);
      } catch (ee) {
        throw ee instanceof GeoTIFFImageIndexError ? new GeoTIFFImageIndexError(Z) : ee;
      }
    return this.ifdRequests[Z] = (async () => {
      const ee = await this.ifdRequests[Z - 1];
      if (ee.nextIFDByteOffset === 0)
        throw new GeoTIFFImageIndexError(Z);
      return this.parseFileDirectoryAt(ee.nextIFDByteOffset);
    })(), this.ifdRequests[Z];
  }
  /**
   * Get the n-th internal subfile of an image. By default, the first is returned.
   *
   * @param {number} [index=0] the index of the image to return.
   * @returns {Promise<GeoTIFFImage>} the image at the given index
   */
  async getImage(Z = 0) {
    const ee = await this.requestIFD(Z);
    return new GeoTIFFImage(
      ee.fileDirectory,
      ee.geoKeyDirectory,
      this.dataView,
      this.littleEndian,
      this.cache,
      this.source
    );
  }
  /**
   * Returns the count of the internal subfiles.
   *
   * @returns {Promise<number>} the number of internal subfile images
   */
  async getImageCount() {
    let Z = 0, ee = !0;
    for (; ee; )
      try {
        await this.requestIFD(Z), ++Z;
      } catch (ae) {
        if (ae instanceof GeoTIFFImageIndexError)
          ee = !1;
        else
          throw ae;
      }
    return Z;
  }
  /**
   * Get the values of the COG ghost area as a parsed map.
   * See https://gdal.org/drivers/raster/cog.html#header-ghost-area for reference
   * @returns {Promise<Object>} the parsed ghost area or null, if no such area was found
   */
  async getGhostValues() {
    const Z = this.bigTiff ? 16 : 8;
    if (this.ghostValues)
      return this.ghostValues;
    const ee = "GDAL_STRUCTURAL_METADATA_SIZE=", ae = ee.length + 100;
    let ve = await this.getSlice(Z, ae);
    if (ee === getValues(ve, fieldTypes.ASCII, ee.length, Z)) {
      const be = getValues(ve, fieldTypes.ASCII, ae, Z).split(`
`)[0], Ye = Number(be.split("=")[1].split(" ")[0]) + be.length;
      Ye > ae && (ve = await this.getSlice(Z, Ye));
      const Qe = getValues(ve, fieldTypes.ASCII, Ye, Z);
      this.ghostValues = {}, Qe.split(`
`).filter((Je) => Je.length > 0).map((Je) => Je.split("=")).forEach(([Je, nt]) => {
        this.ghostValues[Je] = nt;
      });
    }
    return this.ghostValues;
  }
  /**
   * Parse a (Geo)TIFF file from the given source.
   *
   * @param {*} source The source of data to parse from.
   * @param {GeoTIFFOptions} [options] Additional options.
   * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
   *                               to be aborted
   */
  static async fromSource(Z, ee, ae) {
    const ve = (await Z.fetch([{ offset: 0, length: 1024 }], ae))[0], ye = new DataView64(ve), be = ye.getUint16(0, 0);
    let Ye;
    if (be === 18761)
      Ye = !0;
    else if (be === 19789)
      Ye = !1;
    else
      throw new TypeError("Invalid byte order value.");
    const Qe = ye.getUint16(2, Ye);
    let Je;
    if (Qe === 42)
      Je = !1;
    else if (Qe === 43) {
      if (Je = !0, ye.getUint16(4, Ye) !== 8)
        throw new Error("Unsupported offset byte-size.");
    } else
      throw new TypeError("Invalid magic number.");
    const nt = Je ? ye.getUint64(8, Ye) : ye.getUint32(4, Ye);
    return new GeoTIFF(Z, Ye, Je, nt, ee);
  }
  /**
   * Closes the underlying file buffer
   * N.B. After the GeoTIFF has been completely processed it needs
   * to be closed but only if it has been constructed from a file.
   */
  close() {
    return typeof this.source.close == "function" ? this.source.close() : !1;
  }
}
class MultiGeoTIFF extends GeoTIFFBase {
  /**
   * Construct a new MultiGeoTIFF from a main and several overview files.
   * @param {GeoTIFF} mainFile The main GeoTIFF file.
   * @param {GeoTIFF[]} overviewFiles An array of overview files.
   */
  constructor(Z, ee) {
    super(), this.mainFile = Z, this.overviewFiles = ee, this.imageFiles = [Z].concat(ee), this.fileDirectoriesPerFile = null, this.fileDirectoriesPerFileParsing = null, this.imageCount = null;
  }
  async parseFileDirectoriesPerFile() {
    const Z = [this.mainFile.parseFileDirectoryAt(this.mainFile.firstIFDOffset)].concat(this.overviewFiles.map((ee) => ee.parseFileDirectoryAt(ee.firstIFDOffset)));
    return this.fileDirectoriesPerFile = await Promise.all(Z), this.fileDirectoriesPerFile;
  }
  /**
   * Get the n-th internal subfile of an image. By default, the first is returned.
   *
   * @param {number} [index=0] the index of the image to return.
   * @returns {Promise<GeoTIFFImage>} the image at the given index
   */
  async getImage(Z = 0) {
    await this.getImageCount(), await this.parseFileDirectoriesPerFile();
    let ee = 0, ae = 0;
    for (let ve = 0; ve < this.imageFiles.length; ve++) {
      const ye = this.imageFiles[ve];
      for (let be = 0; be < this.imageCounts[ve]; be++) {
        if (Z === ee) {
          const Ye = await ye.requestIFD(ae);
          return new GeoTIFFImage(
            Ye.fileDirectory,
            Ye.geoKeyDirectory,
            ye.dataView,
            ye.littleEndian,
            ye.cache,
            ye.source
          );
        }
        ee++, ae++;
      }
      ae = 0;
    }
    throw new RangeError("Invalid image index");
  }
  /**
   * Returns the count of the internal subfiles.
   *
   * @returns {Promise<number>} the number of internal subfile images
   */
  async getImageCount() {
    if (this.imageCount !== null)
      return this.imageCount;
    const Z = [this.mainFile.getImageCount()].concat(this.overviewFiles.map((ee) => ee.getImageCount()));
    return this.imageCounts = await Promise.all(Z), this.imageCount = this.imageCounts.reduce((ee, ae) => ee + ae, 0), this.imageCount;
  }
}
async function fromUrl(ie, Z = {}, ee) {
  return GeoTIFF.fromSource(makeRemoteSource(ie, Z), ee);
}
async function fromBlob(ie, Z) {
  return GeoTIFF.fromSource(makeFileReaderSource(ie), Z);
}
async function fromUrls(ie, Z = [], ee = {}, ae) {
  const ve = await GeoTIFF.fromSource(makeRemoteSource(ie, ee), ae), ye = await Promise.all(
    Z.map((be) => GeoTIFF.fromSource(makeRemoteSource(be, ee)))
  );
  return new MultiGeoTIFF(ve, ye);
}
function isMask(ie) {
  return ((ie.fileDirectory.NewSubfileType || 0) & 4) === 4;
}
function readRGB(ie, Z) {
  if (!ie)
    return !1;
  if (ie === !0)
    return !0;
  if (Z.getSamplesPerPixel() !== 3)
    return !1;
  const ee = Z.fileDirectory.PhotometricInterpretation, ae = photometricInterpretations;
  return ee === ae.CMYK || ee === ae.YCbCr || ee === ae.CIELab || ee === ae.ICCLab;
}
const STATISTICS_MAXIMUM = "STATISTICS_MAXIMUM", STATISTICS_MINIMUM = "STATISTICS_MINIMUM", defaultTileSize = 256;
let workerPool;
function getWorkerPool() {
  return workerPool || (workerPool = new Pool()), workerPool;
}
function getBoundingBox(ie) {
  try {
    return ie.getBoundingBox();
  } catch {
    return [0, 0, ie.getWidth(), ie.getHeight()];
  }
}
function getOrigin(ie) {
  try {
    return ie.getOrigin().slice(0, 2);
  } catch {
    return [0, ie.getHeight()];
  }
}
function getResolutions(ie, Z) {
  try {
    return ie.getResolution(Z);
  } catch {
    return [
      Z.getWidth() / ie.getWidth(),
      Z.getHeight() / ie.getHeight()
    ];
  }
}
function getProjection(ie) {
  const Z = ie.geoKeys;
  if (!Z)
    return null;
  if (Z.ProjectedCSTypeGeoKey && Z.ProjectedCSTypeGeoKey !== 32767) {
    const ee = "EPSG:" + Z.ProjectedCSTypeGeoKey;
    let ae = get$1(ee);
    if (!ae) {
      const ve = fromCode(Z.ProjLinearUnitsGeoKey);
      ve && (ae = new Projection({
        code: ee,
        units: ve
      }));
    }
    return ae;
  }
  if (Z.GeographicTypeGeoKey && Z.GeographicTypeGeoKey !== 32767) {
    const ee = "EPSG:" + Z.GeographicTypeGeoKey;
    let ae = get$1(ee);
    if (!ae) {
      const ve = fromCode(Z.GeogAngularUnitsGeoKey);
      ve && (ae = new Projection({
        code: ee,
        units: ve
      }));
    }
    return ae;
  }
  return null;
}
function getImagesForTIFF(ie) {
  return ie.getImageCount().then(function(Z) {
    const ee = new Array(Z);
    for (let ae = 0; ae < Z; ++ae)
      ee[ae] = ie.getImage(ae);
    return Promise.all(ee);
  });
}
function getImagesForSource(ie, Z) {
  let ee;
  return ie.blob ? ee = fromBlob(ie.blob) : ie.overviews ? ee = fromUrls(ie.url, ie.overviews, Z) : ee = fromUrl(ie.url, Z), ee.then(getImagesForTIFF);
}
function assertEqual(ie, Z, ee, ae, ve) {
  if (Array.isArray(ie)) {
    const ye = ie.length;
    if (!Array.isArray(Z) || ye != Z.length) {
      const be = new Error(ae);
      throw ve(be), be;
    }
    for (let be = 0; be < ye; ++be)
      assertEqual(ie[be], Z[be], ee, ae, ve);
    return;
  }
  if (Z = /** @type {number} */
  Z, Math.abs(ie - Z) > ee * ie)
    throw new Error(ae);
}
function getMinForDataType(ie) {
  return ie instanceof Int8Array ? -128 : ie instanceof Int16Array ? -32768 : ie instanceof Int32Array ? -2147483648 : ie instanceof Float32Array ? 12e-39 : 0;
}
function getMaxForDataType(ie) {
  return ie instanceof Int8Array ? 127 : ie instanceof Uint8Array || ie instanceof Uint8ClampedArray ? 255 : ie instanceof Int16Array ? 32767 : ie instanceof Uint16Array ? 65535 : ie instanceof Int32Array ? 2147483647 : ie instanceof Uint32Array ? 4294967295 : ie instanceof Float32Array ? 34e37 : 255;
}
class GeoTIFFSource extends DataTileSource {
  /**
   * @param {Options} options Data tile options.
   */
  constructor(Z) {
    super({
      state: "loading",
      tileGrid: null,
      projection: Z.projection || null,
      opaque: Z.opaque,
      transition: Z.transition,
      interpolate: Z.interpolate !== !1,
      wrapX: Z.wrapX
    }), this.sourceInfo_ = Z.sources;
    const ee = this.sourceInfo_.length;
    this.sourceOptions_ = Z.sourceOptions, this.sourceImagery_ = new Array(ee), this.sourceMasks_ = new Array(ee), this.resolutionFactors_ = new Array(ee), this.samplesPerPixel_, this.nodataValues_, this.metadata_, this.normalize_ = Z.normalize !== !1, this.addAlpha_ = !1, this.error_ = null, this.convertToRGB_ = Z.convertToRGB || !1, this.setKey(this.sourceInfo_.map((ye) => ye.url).join(","));
    const ae = this, ve = new Array(ee);
    for (let ye = 0; ye < ee; ++ye)
      ve[ye] = getImagesForSource(
        this.sourceInfo_[ye],
        this.sourceOptions_
      );
    Promise.all(ve).then(function(ye) {
      ae.configure_(ye);
    }).catch(function(ye) {
      error(ye), ae.error_ = ye, ae.setState("error");
    });
  }
  /**
   * @return {Error} A source loading error. When the source state is `error`, use this function
   * to get more information about the error. To debug a faulty configuration, you may want to use
   * a listener like
   * ```js
   * geotiffSource.on('change', () => {
   *   if (geotiffSource.getState() === 'error') {
   *     console.error(geotiffSource.getError());
   *   }
   * });
   * ```
   */
  getError() {
    return this.error_;
  }
  /**
   * Determine the projection of the images in this GeoTIFF.
   * The default implementation looks at the ProjectedCSTypeGeoKey and the GeographicTypeGeoKey
   * of each image in turn.
   * You can override this method in a subclass to support more projections.
   *
   * @param {Array<Array<GeoTIFFImage>>} sources Each source is a list of images
   * from a single GeoTIFF.
   */
  determineProjection(Z) {
    const ee = Z[0];
    for (let ae = ee.length - 1; ae >= 0; --ae) {
      const ve = ee[ae], ye = getProjection(ve);
      if (ye) {
        this.projection = ye;
        break;
      }
    }
  }
  /**
   * Configure the tile grid based on images within the source GeoTIFFs.  Each GeoTIFF
   * must have the same internal tiled structure.
   * @param {Array<Array<GeoTIFFImage>>} sources Each source is a list of images
   * from a single GeoTIFF.
   * @private
   */
  configure_(Z) {
    let ee, ae, ve, ye, be;
    const Ye = new Array(Z.length), Qe = new Array(Z.length), Je = new Array(Z.length);
    let nt = 0;
    const st = Z.length;
    for (let gt = 0; gt < st; ++gt) {
      const ct = [], _r = [];
      Z[gt].forEach((ai) => {
        isMask(ai) ? _r.push(ai) : ct.push(ai);
      });
      const Kr = ct.length;
      if (_r.length > 0 && _r.length !== Kr)
        throw new Error(
          `Expected one mask per image found ${_r.length} masks and ${Kr} images`
        );
      let Xr, Jr;
      const ei = new Array(Kr), si = new Array(Kr), ri = new Array(Kr);
      Qe[gt] = new Array(Kr), Je[gt] = new Array(Kr);
      for (let ai = 0; ai < Kr; ++ai) {
        const yi = ct[ai], pi = yi.getGDALNoData();
        Je[gt][ai] = yi.getGDALMetadata(0), Qe[gt][ai] = pi;
        const di = this.sourceInfo_[gt].bands;
        Ye[gt] = di ? di.length : yi.getSamplesPerPixel();
        const xi = Kr - (ai + 1);
        Xr || (Xr = getBoundingBox(yi)), Jr || (Jr = getOrigin(yi));
        const Ti = getResolutions(yi, ct[0]);
        ri[xi] = Ti[0];
        const Ai = [yi.getTileWidth(), yi.getTileHeight()];
        Ai[0] !== Ai[1] && Ai[1] < defaultTileSize && (Ai[0] = defaultTileSize, Ai[1] = defaultTileSize), ei[xi] = Ai;
        const mi = Ti[0] / Math.abs(Ti[1]);
        si[xi] = [
          Ai[0],
          Ai[1] / mi
        ];
      }
      if (ee ? getIntersection(ee, Xr, ee) : ee = Xr, !ae)
        ae = Jr;
      else {
        const ai = `Origin mismatch for source ${gt}, got [${Jr}] but expected [${ae}]`;
        assertEqual(ae, Jr, 0, ai, this.viewRejector);
      }
      if (!be)
        be = ri, this.resolutionFactors_[gt] = 1;
      else {
        be.length - nt > ri.length && (nt = be.length - ri.length);
        const ai = be[be.length - 1] / ri[ri.length - 1];
        this.resolutionFactors_[gt] = ai;
        const yi = ri.map(
          (di) => di *= ai
        ), pi = `Resolution mismatch for source ${gt}, got [${yi}] but expected [${be}]`;
        assertEqual(
          be.slice(nt, be.length),
          yi,
          0.02,
          pi,
          this.viewRejector
        );
      }
      ve ? assertEqual(
        ve.slice(nt, ve.length),
        si,
        0.01,
        `Tile size mismatch for source ${gt}`,
        this.viewRejector
      ) : ve = si, ye ? assertEqual(
        ye.slice(nt, ye.length),
        ei,
        0,
        `Tile size mismatch for source ${gt}`,
        this.viewRejector
      ) : ye = ei, this.sourceImagery_[gt] = ct.reverse(), this.sourceMasks_[gt] = _r.reverse();
    }
    for (let gt = 0, ct = this.sourceImagery_.length; gt < ct; ++gt) {
      const _r = this.sourceImagery_[gt];
      for (; _r.length < be.length; )
        _r.unshift(void 0);
    }
    this.getProjection() || this.determineProjection(Z), this.samplesPerPixel_ = Ye, this.nodataValues_ = Qe, this.metadata_ = Je;
    e:
      for (let gt = 0; gt < st; ++gt) {
        if (this.sourceInfo_[gt].nodata !== void 0) {
          this.addAlpha_ = !0;
          break;
        }
        if (this.sourceMasks_[gt].length) {
          this.addAlpha_ = !0;
          break;
        }
        const ct = Qe[gt], _r = this.sourceInfo_[gt].bands;
        if (_r) {
          for (let Kr = 0; Kr < _r.length; ++Kr)
            if (ct[_r[Kr] - 1] !== null) {
              this.addAlpha_ = !0;
              break e;
            }
          continue;
        }
        for (let Kr = 0; Kr < ct.length; ++Kr)
          if (ct[Kr] !== null) {
            this.addAlpha_ = !0;
            break e;
          }
      }
    let ot = this.addAlpha_ ? 1 : 0;
    for (let gt = 0; gt < st; ++gt)
      ot += Ye[gt];
    this.bandCount = ot;
    const lt = new TileGrid({
      extent: ee,
      minZoom: nt,
      origin: ae,
      resolutions: be,
      tileSizes: ve
    });
    this.tileGrid = lt, this.setTileSizes(ye), this.setLoader(this.loadTile_.bind(this)), this.setState("ready");
    const ft = 1;
    be.length === 2 ? be = [be[0], be[1], be[1] / 2] : be.length === 1 && (be = [be[0] * 2, be[0], be[0] / 2]), this.viewResolver({
      showFullExtent: !0,
      projection: this.projection,
      resolutions: be,
      center: toUserCoordinate(getCenter(ee), this.projection),
      extent: toUserExtent(ee, this.projection),
      zoom: ft
    });
  }
  /**
   * @param {number} z The z tile index.
   * @param {number} x The x tile index.
   * @param {number} y The y tile index.
   * @return {Promise} The composed tile data.
   * @private
   */
  loadTile_(Z, ee, ae) {
    const ve = this.getTileSize(Z), ye = this.sourceImagery_.length, be = new Array(ye * 2), Ye = this.nodataValues_, Qe = this.sourceInfo_, Je = getWorkerPool();
    for (let nt = 0; nt < ye; ++nt) {
      const st = Qe[nt], ot = this.resolutionFactors_[nt], lt = [
        Math.round(ee * (ve[0] * ot)),
        Math.round(ae * (ve[1] * ot)),
        Math.round((ee + 1) * (ve[0] * ot)),
        Math.round((ae + 1) * (ve[1] * ot))
      ], ft = this.sourceImagery_[nt][Z];
      let gt;
      st.bands && (gt = st.bands.map(function(Jr) {
        return Jr - 1;
      }));
      let ct;
      "nodata" in st && st.nodata !== null ? ct = st.nodata : gt ? ct = gt.map(function(Jr) {
        return Ye[nt][Jr];
      }) : ct = Ye[nt];
      const _r = {
        window: lt,
        width: ve[0],
        height: ve[1],
        samples: gt,
        fillValue: ct,
        pool: Je,
        interleave: !1
      };
      readRGB(this.convertToRGB_, ft) ? be[nt] = ft.readRGB(_r) : be[nt] = ft.readRasters(_r);
      const Kr = ye + nt, Xr = this.sourceMasks_[nt][Z];
      if (!Xr) {
        be[Kr] = Promise.resolve(null);
        continue;
      }
      be[Kr] = Xr.readRasters({
        window: lt,
        width: ve[0],
        height: ve[1],
        samples: [0],
        pool: Je,
        interleave: !1
      });
    }
    return Promise.all(be).then(this.composeTile_.bind(this, ve)).catch(function(nt) {
      throw error(nt), nt;
    });
  }
  /**
   * @param {import("../size.js").Size} sourceTileSize The source tile size.
   * @param {Array} sourceSamples The source samples.
   * @return {import("../DataTile.js").Data} The composed tile data.
   * @private
   */
  composeTile_(Z, ee) {
    const ae = this.metadata_, ve = this.sourceInfo_, ye = this.sourceImagery_.length, be = this.bandCount, Ye = this.samplesPerPixel_, Qe = this.nodataValues_, Je = this.normalize_, nt = this.addAlpha_, st = Z[0] * Z[1], ot = st * be;
    let lt;
    Je ? lt = new Uint8Array(ot) : lt = new Float32Array(ot);
    let ft = 0;
    for (let gt = 0; gt < st; ++gt) {
      let ct = nt;
      for (let _r = 0; _r < ye; ++_r) {
        const Kr = ve[_r];
        let Xr = Kr.min, Jr = Kr.max, ei, si;
        if (Je) {
          const ri = ae[_r][0];
          Xr === void 0 && (ri && STATISTICS_MINIMUM in ri ? Xr = parseFloat(ri[STATISTICS_MINIMUM]) : Xr = getMinForDataType(ee[_r][0])), Jr === void 0 && (ri && STATISTICS_MAXIMUM in ri ? Jr = parseFloat(ri[STATISTICS_MAXIMUM]) : Jr = getMaxForDataType(ee[_r][0])), ei = 255 / (Jr - Xr), si = -Xr * ei;
        }
        for (let ri = 0; ri < Ye[_r]; ++ri) {
          const ai = ee[_r][ri][gt];
          let yi;
          if (Je ? yi = clamp$1(ei * ai + si, 0, 255) : yi = ai, !nt)
            lt[ft] = yi;
          else {
            let pi = Kr.nodata;
            if (pi === void 0) {
              let xi;
              Kr.bands ? xi = Kr.bands[ri] - 1 : xi = ri, pi = Qe[_r][xi];
            }
            const di = isNaN(pi);
            (!di && ai !== pi || di && !isNaN(ai)) && (ct = !1, lt[ft] = yi);
          }
          ft++;
        }
        if (!ct) {
          const ri = ye + _r, ai = ee[ri];
          ai && !ai[0][gt] && (ct = !0);
        }
      }
      nt && (ct || (lt[ft] = 255), ft++);
    }
    return lt;
  }
}
class BaseTileRepresentation extends Target {
  /**
   * @param {TileRepresentationOptions<TileType>} options The tile representation options.
   */
  constructor(Z) {
    super(), this.tile, this.handleTileChange_ = this.handleTileChange_.bind(this), this.gutter_ = Z.gutter || 0, this.helper_ = Z.helper, this.loaded = !1, this.ready = !1;
  }
  /**
   * @param {TileType} tile Tile.
   */
  setTile(Z) {
    if (Z !== this.tile)
      if (this.tile && this.tile.removeEventListener(EventType.CHANGE, this.handleTileChange_), this.tile = Z, this.loaded = Z.getState() === TileState.LOADED, this.loaded)
        this.uploadTile();
      else {
        if (Z instanceof ImageTile) {
          const ee = Z.getImage();
          ee instanceof Image && !ee.crossOrigin && (ee.crossOrigin = "anonymous");
        }
        Z.addEventListener(EventType.CHANGE, this.handleTileChange_);
      }
  }
  /**
   * @abstract
   * @protected
   */
  uploadTile() {
    abstract();
  }
  setReady() {
    this.ready = !0, this.dispatchEvent(EventType.CHANGE);
  }
  handleTileChange_() {
    this.tile.getState() === TileState.LOADED && (this.loaded = !0, this.uploadTile());
  }
  disposeInternal() {
    this.tile.removeEventListener(EventType.CHANGE, this.handleTileChange_);
  }
}
const ARRAY_BUFFER = 34962, ELEMENT_ARRAY_BUFFER = 34963, STREAM_DRAW = 35040, STATIC_DRAW = 35044, DYNAMIC_DRAW = 35048, UNSIGNED_BYTE = 5121, UNSIGNED_SHORT = 5123, UNSIGNED_INT = 5125, FLOAT = 5126, CONTEXT_IDS = ["experimental-webgl", "webgl", "webkit-3d", "moz-webgl"];
function getContext(ie, Z) {
  Z = Object.assign(
    {
      preserveDrawingBuffer: !0,
      antialias: !SAFARI_BUG_237906
      // https://bugs.webkit.org/show_bug.cgi?id=237906
    },
    Z
  );
  const ee = CONTEXT_IDS.length;
  for (let ae = 0; ae < ee; ++ae)
    try {
      const ve = ie.getContext(CONTEXT_IDS[ae], Z);
      if (ve)
        return (
          /** @type {!WebGLRenderingContext} */
          ve
        );
    } catch {
    }
  return null;
}
const BufferUsage = {
  STATIC_DRAW,
  STREAM_DRAW,
  DYNAMIC_DRAW
};
class WebGLArrayBuffer {
  /**
   * @param {number} type Buffer type, either ARRAY_BUFFER or ELEMENT_ARRAY_BUFFER.
   * @param {number} [usage] Intended usage, either `STATIC_DRAW`, `STREAM_DRAW` or `DYNAMIC_DRAW`.
   * Default is `DYNAMIC_DRAW`.
   */
  constructor(Z, ee) {
    this.array = null, this.type = Z, assert(
      Z === ARRAY_BUFFER || Z === ELEMENT_ARRAY_BUFFER,
      "A `WebGLArrayBuffer` must either be of type `ELEMENT_ARRAY_BUFFER` or `ARRAY_BUFFER`"
    ), this.usage = ee !== void 0 ? ee : BufferUsage.STATIC_DRAW;
  }
  /**
   * Populates the buffer with an array of the given size (all values will be zeroes).
   * @param {number} size Array size
   * @return {WebGLArrayBuffer} This
   */
  ofSize(Z) {
    return this.array = new (getArrayClassForType(this.type))(Z), this;
  }
  /**
   * Populates the buffer with an array of the given size.
   * @param {Array<number>} array Numerical array
   * @return {WebGLArrayBuffer} This
   */
  fromArray(Z) {
    return this.array = getArrayClassForType(this.type).from(Z), this;
  }
  /**
   * Populates the buffer with a raw binary array buffer.
   * @param {ArrayBuffer} buffer Raw binary buffer to populate the array with. Note that this buffer must have been
   * initialized for the same typed array class.
   * @return {WebGLArrayBuffer} This
   */
  fromArrayBuffer(Z) {
    return this.array = new (getArrayClassForType(this.type))(Z), this;
  }
  /**
   * @return {number} Buffer type.
   */
  getType() {
    return this.type;
  }
  /**
   * Will return null if the buffer was not initialized
   * @return {Float32Array|Uint32Array} Array.
   */
  getArray() {
    return this.array;
  }
  /**
   * @return {number} Usage.
   */
  getUsage() {
    return this.usage;
  }
  /**
   * Will return 0 if the buffer is not initialized
   * @return {number} Array size
   */
  getSize() {
    return this.array ? this.array.length : 0;
  }
}
function getArrayClassForType(ie) {
  switch (ie) {
    case ARRAY_BUFFER:
      return Float32Array;
    case ELEMENT_ARRAY_BUFFER:
      return Uint32Array;
    default:
      return Float32Array;
  }
}
function bindAndConfigure(ie, Z, ee) {
  const ae = ee ? ie.LINEAR : ie.NEAREST;
  ie.bindTexture(ie.TEXTURE_2D, Z), ie.texParameteri(ie.TEXTURE_2D, ie.TEXTURE_WRAP_S, ie.CLAMP_TO_EDGE), ie.texParameteri(ie.TEXTURE_2D, ie.TEXTURE_WRAP_T, ie.CLAMP_TO_EDGE), ie.texParameteri(ie.TEXTURE_2D, ie.TEXTURE_MIN_FILTER, ae), ie.texParameteri(ie.TEXTURE_2D, ie.TEXTURE_MAG_FILTER, ae);
}
function uploadImageTexture(ie, Z, ee, ae) {
  bindAndConfigure(ie, Z, ae), ie.texImage2D(ie.TEXTURE_2D, 0, ie.RGBA, ie.RGBA, ie.UNSIGNED_BYTE, ee);
}
function uploadDataTexture(ie, Z, ee, ae, ve, ye) {
  const be = ie.getGL();
  let Ye, Qe;
  ee instanceof Float32Array ? (Ye = be.FLOAT, ie.getExtension("OES_texture_float"), Qe = ie.getExtension("OES_texture_float_linear") !== null) : (Ye = be.UNSIGNED_BYTE, Qe = !0), bindAndConfigure(be, Z, ye && Qe);
  const Je = ee.byteLength / ae[1];
  let nt = 1;
  Je % 8 === 0 ? nt = 8 : Je % 4 === 0 ? nt = 4 : Je % 2 === 0 && (nt = 2);
  let st;
  switch (ve) {
    case 1: {
      st = be.LUMINANCE;
      break;
    }
    case 2: {
      st = be.LUMINANCE_ALPHA;
      break;
    }
    case 3: {
      st = be.RGB;
      break;
    }
    case 4: {
      st = be.RGBA;
      break;
    }
    default:
      throw new Error(`Unsupported number of bands: ${ve}`);
  }
  const ot = be.getParameter(be.UNPACK_ALIGNMENT);
  be.pixelStorei(be.UNPACK_ALIGNMENT, nt), be.texImage2D(
    be.TEXTURE_2D,
    0,
    st,
    ae[0],
    ae[1],
    0,
    st,
    Ye,
    ee
  ), be.pixelStorei(be.UNPACK_ALIGNMENT, ot);
}
let pixelContext = null;
function createPixelContext() {
  pixelContext = createCanvasContext2D(1, 1, void 0, {
    willReadFrequently: !0
  });
}
class TileTexture extends BaseTileRepresentation {
  /**
   * @param {import("./BaseTileRepresentation.js").TileRepresentationOptions<TileType>} options The tile texture options.
   */
  constructor(Z) {
    super(Z), this.textures = [], this.renderSize_ = toSize(
      Z.grid.getTileSize(Z.tile.tileCoord[0])
    ), this.bandCount = NaN;
    const ee = new WebGLArrayBuffer(ARRAY_BUFFER, STATIC_DRAW);
    ee.fromArray([
      0,
      // P0
      1,
      1,
      // P1
      1,
      1,
      // P2
      0,
      0,
      // P3
      0
    ]), this.helper_.flushBufferData(ee), this.coords = ee, this.setTile(Z.tile);
  }
  uploadTile() {
    const Z = this.helper_, ee = Z.getGL(), ae = this.tile;
    this.textures.length = 0;
    let ve;
    ae instanceof ImageTile || ae instanceof ReprojTile ? ve = ae.getImage() : ve = ae.getData();
    const ye = asImageLike(ve);
    if (ye) {
      const Kr = ee.createTexture();
      this.textures.push(Kr), this.bandCount = 4, uploadImageTexture(ee, Kr, ye, ae.interpolate), this.setReady();
      return;
    }
    ve = asArrayLike(ve);
    const be = (
      /** @type {DataTile} */
      ae.getSize()
    ), Ye = [
      be[0] + 2 * this.gutter_,
      be[1] + 2 * this.gutter_
    ], Qe = ve instanceof Float32Array, Je = Ye[0] * Ye[1], nt = Qe ? Float32Array : Uint8Array, st = nt.BYTES_PER_ELEMENT, ot = ve.byteLength / Ye[1];
    this.bandCount = Math.floor(ot / st / Ye[0]);
    const lt = Math.ceil(this.bandCount / 4);
    if (lt === 1) {
      const Kr = ee.createTexture();
      this.textures.push(Kr), uploadDataTexture(
        Z,
        Kr,
        ve,
        Ye,
        this.bandCount,
        ae.interpolate
      ), this.setReady();
      return;
    }
    const ft = new Array(lt);
    for (let Kr = 0; Kr < lt; ++Kr) {
      const Xr = ee.createTexture();
      this.textures.push(Xr);
      const Jr = Kr < lt - 1 ? 4 : (this.bandCount - 1) % 4 + 1;
      ft[Kr] = new nt(Je * Jr);
    }
    let gt = 0, ct = 0;
    const _r = Ye[0] * this.bandCount;
    for (let Kr = 0; Kr < Ye[1]; ++Kr) {
      for (let Xr = 0; Xr < _r; ++Xr) {
        const Jr = ve[ct + Xr], ei = Math.floor(gt / this.bandCount), si = Xr % this.bandCount, ri = Math.floor(si / 4), ai = ft[ri], yi = ai.length / Je, pi = si % 4;
        ai[ei * yi + pi] = Jr, ++gt;
      }
      ct += ot / st;
    }
    for (let Kr = 0; Kr < lt; ++Kr) {
      const Xr = this.textures[Kr], Jr = ft[Kr], ei = Jr.length / Je;
      uploadDataTexture(
        Z,
        Xr,
        Jr,
        Ye,
        ei,
        ae.interpolate
      );
    }
    this.setReady();
  }
  disposeInternal() {
    const Z = this.helper_.getGL();
    this.helper_.deleteBuffer(this.coords);
    for (let ee = 0; ee < this.textures.length; ++ee)
      Z.deleteTexture(this.textures[ee]);
    this.tile.removeEventListener(EventType.CHANGE, this.handleTileChange_);
  }
  /**
   * @param {import("../DataTile.js").ImageLike} image The image.
   * @param {number} renderCol The column index (in rendered tile space).
   * @param {number} renderRow The row index (in rendered tile space).
   * @return {Uint8ClampedArray|null} The data.
   * @private
   */
  getImagePixelData_(Z, ee, ae) {
    const ve = this.gutter_, ye = this.renderSize_[0], be = this.renderSize_[1];
    pixelContext || createPixelContext(), pixelContext.clearRect(0, 0, 1, 1);
    const Ye = Z.width, Qe = Z.height, Je = Ye - 2 * ve, nt = Qe - 2 * ve, st = ve + Math.floor(Je * (ee / ye)), ot = ve + Math.floor(nt * (ae / be));
    let lt;
    try {
      pixelContext.drawImage(Z, st, ot, 1, 1, 0, 0, 1, 1), lt = pixelContext.getImageData(0, 0, 1, 1).data;
    } catch {
      return pixelContext = null, null;
    }
    return lt;
  }
  /**
   * @param {import("../DataTile.js").ArrayLike} data The data.
   * @param {import("../size.js").Size} sourceSize The size.
   * @param {number} renderCol The column index (in rendered tile space).
   * @param {number} renderRow The row index (in rendered tile space).
   * @return {import("../DataTile.js").ArrayLike|null} The data.
   * @private
   */
  getArrayPixelData_(Z, ee, ae, ve) {
    const ye = this.gutter_, be = this.renderSize_[0], Ye = this.renderSize_[1], Qe = ee[0], Je = ee[1], nt = Qe + 2 * ye, st = Je + 2 * ye, ot = ye + Math.floor(Qe * (ae / be)), lt = ye + Math.floor(Je * (ve / Ye));
    if (Z instanceof DataView) {
      const gt = Z.byteLength / (nt * st), ct = gt * (lt * nt + ot), _r = Z.buffer.slice(ct, ct + gt);
      return new DataView(_r);
    }
    const ft = this.bandCount * (lt * nt + ot);
    return Z.slice(ft, ft + this.bandCount);
  }
  /**
   * Get data for a pixel.  If the tile is not loaded, null is returned.
   * @param {number} renderCol The column index (in rendered tile space).
   * @param {number} renderRow The row index (in rendered tile space).
   * @return {import("../DataTile.js").ArrayLike|null} The data.
   */
  getPixelData(Z, ee) {
    if (!this.loaded)
      return null;
    if (this.tile instanceof DataTile) {
      const ae = this.tile.getData(), ve = asArrayLike(ae);
      if (ve) {
        const ye = this.tile.getSize();
        return this.getArrayPixelData_(
          ve,
          ye,
          Z,
          ee
        );
      }
      return this.getImagePixelData_(asImageLike(ae), Z, ee);
    }
    return this.getImagePixelData_(this.tile.getImage(), Z, ee);
  }
}
const ContextEventType = {
  LOST: "webglcontextlost",
  RESTORED: "webglcontextrestored"
}, DEFAULT_VERTEX_SHADER = `
  precision mediump float;
  
  attribute vec2 a_position;
  varying vec2 v_texCoord;
  varying vec2 v_screenCoord;
  
  uniform vec2 u_screenSize;
   
  void main() {
    v_texCoord = a_position * 0.5 + 0.5;
    v_screenCoord = v_texCoord * u_screenSize;
    gl_Position = vec4(a_position, 0.0, 1.0);
  }
`, DEFAULT_FRAGMENT_SHADER = `
  precision mediump float;
   
  uniform sampler2D u_image;
  uniform float u_opacity;
   
  varying vec2 v_texCoord;
   
  void main() {
    gl_FragColor = texture2D(u_image, v_texCoord) * u_opacity;
  }
`;
class WebGLPostProcessingPass {
  /**
   * @param {Options} options Options.
   */
  constructor(Z) {
    this.gl_ = Z.webGlContext;
    const ee = this.gl_;
    this.scaleRatio_ = Z.scaleRatio || 1, this.renderTargetTexture_ = ee.createTexture(), this.renderTargetTextureSize_ = null, this.frameBuffer_ = ee.createFramebuffer(), this.depthBuffer_ = ee.createRenderbuffer();
    const ae = ee.createShader(ee.VERTEX_SHADER);
    ee.shaderSource(
      ae,
      Z.vertexShader || DEFAULT_VERTEX_SHADER
    ), ee.compileShader(ae);
    const ve = ee.createShader(ee.FRAGMENT_SHADER);
    ee.shaderSource(
      ve,
      Z.fragmentShader || DEFAULT_FRAGMENT_SHADER
    ), ee.compileShader(ve), this.renderTargetProgram_ = ee.createProgram(), ee.attachShader(this.renderTargetProgram_, ae), ee.attachShader(this.renderTargetProgram_, ve), ee.linkProgram(this.renderTargetProgram_), this.renderTargetVerticesBuffer_ = ee.createBuffer();
    const ye = [-1, -1, 1, -1, -1, 1, 1, -1, 1, 1, -1, 1];
    ee.bindBuffer(ee.ARRAY_BUFFER, this.renderTargetVerticesBuffer_), ee.bufferData(
      ee.ARRAY_BUFFER,
      new Float32Array(ye),
      ee.STATIC_DRAW
    ), this.renderTargetAttribLocation_ = ee.getAttribLocation(
      this.renderTargetProgram_,
      "a_position"
    ), this.renderTargetUniformLocation_ = ee.getUniformLocation(
      this.renderTargetProgram_,
      "u_screenSize"
    ), this.renderTargetOpacityLocation_ = ee.getUniformLocation(
      this.renderTargetProgram_,
      "u_opacity"
    ), this.renderTargetTextureLocation_ = ee.getUniformLocation(
      this.renderTargetProgram_,
      "u_image"
    ), this.uniforms_ = [], Z.uniforms && Object.keys(Z.uniforms).forEach((be) => {
      this.uniforms_.push({
        value: Z.uniforms[be],
        location: ee.getUniformLocation(this.renderTargetProgram_, be)
      });
    });
  }
  /**
   * Get the WebGL rendering context
   * @return {WebGLRenderingContext} The rendering context.
   */
  getGL() {
    return this.gl_;
  }
  /**
   * Initialize the render target texture of the post process, make sure it is at the
   * right size and bind it as a render target for the next draw calls.
   * The last step to be initialized will be the one where the primitives are rendered.
   * @param {import("../Map.js").FrameState} frameState current frame state
   */
  init(Z) {
    const ee = this.getGL(), ae = [
      ee.drawingBufferWidth * this.scaleRatio_,
      ee.drawingBufferHeight * this.scaleRatio_
    ];
    if (ee.bindFramebuffer(ee.FRAMEBUFFER, this.getFrameBuffer()), ee.bindRenderbuffer(ee.RENDERBUFFER, this.getDepthBuffer()), ee.viewport(0, 0, ae[0], ae[1]), !this.renderTargetTextureSize_ || this.renderTargetTextureSize_[0] !== ae[0] || this.renderTargetTextureSize_[1] !== ae[1]) {
      this.renderTargetTextureSize_ = ae;
      const ve = 0, ye = ee.RGBA, be = 0, Ye = ee.RGBA, Qe = ee.UNSIGNED_BYTE, Je = null;
      ee.bindTexture(ee.TEXTURE_2D, this.renderTargetTexture_), ee.texImage2D(
        ee.TEXTURE_2D,
        ve,
        ye,
        ae[0],
        ae[1],
        be,
        Ye,
        Qe,
        Je
      ), ee.texParameteri(ee.TEXTURE_2D, ee.TEXTURE_MIN_FILTER, ee.LINEAR), ee.texParameteri(ee.TEXTURE_2D, ee.TEXTURE_WRAP_S, ee.CLAMP_TO_EDGE), ee.texParameteri(ee.TEXTURE_2D, ee.TEXTURE_WRAP_T, ee.CLAMP_TO_EDGE), ee.framebufferTexture2D(
        ee.FRAMEBUFFER,
        ee.COLOR_ATTACHMENT0,
        ee.TEXTURE_2D,
        this.renderTargetTexture_,
        0
      ), ee.renderbufferStorage(
        ee.RENDERBUFFER,
        ee.DEPTH_COMPONENT16,
        ae[0],
        ae[1]
      ), ee.framebufferRenderbuffer(
        ee.FRAMEBUFFER,
        ee.DEPTH_ATTACHMENT,
        ee.RENDERBUFFER,
        this.depthBuffer_
      );
    }
  }
  /**
   * Render to the next postprocessing pass (or to the canvas if final pass).
   * @param {import("../Map.js").FrameState} frameState current frame state
   * @param {WebGLPostProcessingPass} [nextPass] Next pass, optional
   * @param {function(WebGLRenderingContext, import("../Map.js").FrameState):void} [preCompose] Called before composing.
   * @param {function(WebGLRenderingContext, import("../Map.js").FrameState):void} [postCompose] Called before composing.
   */
  apply(Z, ee, ae, ve) {
    const ye = this.getGL(), be = Z.size;
    if (ye.bindFramebuffer(
      ye.FRAMEBUFFER,
      ee ? ee.getFrameBuffer() : null
    ), ye.activeTexture(ye.TEXTURE0), ye.bindTexture(ye.TEXTURE_2D, this.renderTargetTexture_), !ee) {
      const Qe = getUid(ye.canvas);
      if (!Z.renderTargets[Qe]) {
        const Je = ye.getContextAttributes();
        Je && Je.preserveDrawingBuffer && (ye.clearColor(0, 0, 0, 0), ye.clearDepth(1), ye.clear(ye.COLOR_BUFFER_BIT | ye.DEPTH_BUFFER_BIT)), Z.renderTargets[Qe] = !0;
      }
    }
    ye.disable(ye.DEPTH_TEST), ye.enable(ye.BLEND), ye.blendFunc(ye.ONE, ye.ONE_MINUS_SRC_ALPHA), ye.viewport(0, 0, ye.drawingBufferWidth, ye.drawingBufferHeight), ye.bindBuffer(ye.ARRAY_BUFFER, this.renderTargetVerticesBuffer_), ye.useProgram(this.renderTargetProgram_), ye.enableVertexAttribArray(this.renderTargetAttribLocation_), ye.vertexAttribPointer(
      this.renderTargetAttribLocation_,
      2,
      ye.FLOAT,
      !1,
      0,
      0
    ), ye.uniform2f(this.renderTargetUniformLocation_, be[0], be[1]), ye.uniform1i(this.renderTargetTextureLocation_, 0);
    const Ye = Z.layerStatesArray[Z.layerIndex].opacity;
    ye.uniform1f(this.renderTargetOpacityLocation_, Ye), this.applyUniforms(Z), ae && ae(ye, Z), ye.drawArrays(ye.TRIANGLES, 0, 6), ve && ve(ye, Z);
  }
  /**
   * @return {WebGLFramebuffer} Frame buffer
   */
  getFrameBuffer() {
    return this.frameBuffer_;
  }
  /**
   * @return {WebGLRenderbuffer} Depth buffer
   */
  getDepthBuffer() {
    return this.depthBuffer_;
  }
  /**
   * Sets the custom uniforms based on what was given in the constructor.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @private
   */
  applyUniforms(Z) {
    const ee = this.getGL();
    let ae, ve = 1;
    this.uniforms_.forEach(function(ye) {
      if (ae = typeof ye.value == "function" ? ye.value(Z) : ye.value, ae instanceof HTMLCanvasElement || ae instanceof ImageData)
        ye.texture || (ye.texture = ee.createTexture()), ee.activeTexture(ee[`TEXTURE${ve}`]), ee.bindTexture(ee.TEXTURE_2D, ye.texture), ee.texParameteri(ee.TEXTURE_2D, ee.TEXTURE_MIN_FILTER, ee.LINEAR), ee.texParameteri(ee.TEXTURE_2D, ee.TEXTURE_WRAP_S, ee.CLAMP_TO_EDGE), ee.texParameteri(ee.TEXTURE_2D, ee.TEXTURE_WRAP_T, ee.CLAMP_TO_EDGE), ae instanceof ImageData ? ee.texImage2D(
          ee.TEXTURE_2D,
          0,
          ee.RGBA,
          ee.RGBA,
          ae.width,
          ae.height,
          0,
          ee.UNSIGNED_BYTE,
          new Uint8Array(ae.data)
        ) : ee.texImage2D(
          ee.TEXTURE_2D,
          0,
          ee.RGBA,
          ee.RGBA,
          ee.UNSIGNED_BYTE,
          ae
        ), ee.uniform1i(ye.location, ve++);
      else if (Array.isArray(ae))
        switch (ae.length) {
          case 2:
            ee.uniform2f(ye.location, ae[0], ae[1]);
            return;
          case 3:
            ee.uniform3f(ye.location, ae[0], ae[1], ae[2]);
            return;
          case 4:
            ee.uniform4f(
              ye.location,
              ae[0],
              ae[1],
              ae[2],
              ae[3]
            );
            return;
          default:
            return;
        }
      else
        typeof ae == "number" && ee.uniform1f(ye.location, ae);
    });
  }
}
function create$1() {
  return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
}
function fromTransform(ie, Z) {
  return ie[0] = Z[0], ie[1] = Z[1], ie[4] = Z[2], ie[5] = Z[3], ie[12] = Z[4], ie[13] = Z[5], ie;
}
const DefaultUniform = {
  PROJECTION_MATRIX: "u_projectionMatrix",
  SCREEN_TO_WORLD_MATRIX: "u_screenToWorldMatrix",
  TIME: "u_time",
  ZOOM: "u_zoom",
  RESOLUTION: "u_resolution",
  ROTATION: "u_rotation",
  VIEWPORT_SIZE_PX: "u_viewportSizePx",
  PIXEL_RATIO: "u_pixelRatio",
  HIT_DETECTION: "u_hitDetection"
}, AttributeType = {
  UNSIGNED_BYTE,
  UNSIGNED_SHORT,
  UNSIGNED_INT,
  FLOAT
}, canvasCache = {};
function getSharedCanvasCacheKey(ie) {
  return "shared/" + ie;
}
let uniqueCanvasCacheKeyCount = 0;
function getUniqueCanvasCacheKey() {
  const ie = "unique/" + uniqueCanvasCacheKeyCount;
  return uniqueCanvasCacheKeyCount += 1, ie;
}
function getOrCreateContext(ie) {
  let Z = canvasCache[ie];
  if (!Z) {
    const ee = document.createElement("canvas");
    ee.width = 1, ee.height = 1, ee.style.position = "absolute", ee.style.left = "0", Z = { users: 0, context: getContext(ee) }, canvasCache[ie] = Z;
  }
  return Z.users += 1, Z.context;
}
function releaseCanvas(ie) {
  const Z = canvasCache[ie];
  if (!Z || (Z.users -= 1, Z.users > 0))
    return;
  const ee = Z.context, ae = ee.getExtension("WEBGL_lose_context");
  ae && ae.loseContext();
  const ve = ee.canvas;
  ve.width = 1, ve.height = 1, delete canvasCache[ie];
}
class WebGLHelper extends Disposable {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    super(), Z = Z || {}, this.boundHandleWebGLContextLost_ = this.handleWebGLContextLost.bind(this), this.boundHandleWebGLContextRestored_ = this.handleWebGLContextRestored.bind(this), this.canvasCacheKey_ = Z.canvasCacheKey ? getSharedCanvasCacheKey(Z.canvasCacheKey) : getUniqueCanvasCacheKey(), this.gl_ = getOrCreateContext(this.canvasCacheKey_), this.bufferCache_ = {}, this.extensionCache_ = {}, this.currentProgram_ = null, this.needsToBeRecreated_ = !1;
    const ee = this.gl_.canvas;
    ee.addEventListener(
      ContextEventType.LOST,
      this.boundHandleWebGLContextLost_
    ), ee.addEventListener(
      ContextEventType.RESTORED,
      this.boundHandleWebGLContextRestored_
    ), this.offsetRotateMatrix_ = create$2(), this.offsetScaleMatrix_ = create$2(), this.tmpMat4_ = create$1(), this.uniformLocationsByProgram_ = {}, this.attribLocationsByProgram_ = {}, this.uniforms_ = [], Z.uniforms && this.setUniforms(Z.uniforms), this.postProcessPasses_ = Z.postProcesses ? Z.postProcesses.map(
      (ae) => new WebGLPostProcessingPass({
        webGlContext: this.gl_,
        scaleRatio: ae.scaleRatio,
        vertexShader: ae.vertexShader,
        fragmentShader: ae.fragmentShader,
        uniforms: ae.uniforms
      })
    ) : [new WebGLPostProcessingPass({ webGlContext: this.gl_ })], this.shaderCompileErrors_ = null, this.startTime_ = Date.now();
  }
  /**
   * @param {Object<string, UniformValue>} uniforms Uniform definitions.
   */
  setUniforms(Z) {
    this.uniforms_ = [], this.addUniforms(Z);
  }
  /**
   * @param {Object<string, UniformValue>} uniforms Uniform definitions.
   */
  addUniforms(Z) {
    for (const ee in Z)
      this.uniforms_.push({
        name: ee,
        value: Z[ee]
      });
  }
  /**
   * @param {string} canvasCacheKey The canvas cache key.
   * @return {boolean} The provided key matches the one this helper was constructed with.
   */
  canvasCacheKeyMatches(Z) {
    return this.canvasCacheKey_ === getSharedCanvasCacheKey(Z);
  }
  /**
   * Get a WebGL extension.  If the extension is not supported, null is returned.
   * Extensions are cached after they are enabled for the first time.
   * @param {string} name The extension name.
   * @return {Object|null} The extension or null if not supported.
   */
  getExtension(Z) {
    if (Z in this.extensionCache_)
      return this.extensionCache_[Z];
    const ee = this.gl_.getExtension(Z);
    return this.extensionCache_[Z] = ee, ee;
  }
  /**
   * Just bind the buffer if it's in the cache. Otherwise create
   * the WebGL buffer, bind it, populate it, and add an entry to
   * the cache.
   * @param {import("./Buffer").default} buffer Buffer.
   */
  bindBuffer(Z) {
    const ee = this.gl_, ae = getUid(Z);
    let ve = this.bufferCache_[ae];
    if (!ve) {
      const ye = ee.createBuffer();
      ve = {
        buffer: Z,
        webGlBuffer: ye
      }, this.bufferCache_[ae] = ve;
    }
    ee.bindBuffer(Z.getType(), ve.webGlBuffer);
  }
  /**
   * Update the data contained in the buffer array; this is required for the
   * new data to be rendered
   * @param {import("./Buffer").default} buffer Buffer.
   */
  flushBufferData(Z) {
    const ee = this.gl_;
    this.bindBuffer(Z), ee.bufferData(Z.getType(), Z.getArray(), Z.getUsage());
  }
  /**
   * @param {import("./Buffer.js").default} buf Buffer.
   */
  deleteBuffer(Z) {
    const ee = this.gl_, ae = getUid(Z), ve = this.bufferCache_[ae];
    ve && !ee.isContextLost() && ee.deleteBuffer(ve.webGlBuffer), delete this.bufferCache_[ae];
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    const Z = this.gl_.canvas;
    Z.removeEventListener(
      ContextEventType.LOST,
      this.boundHandleWebGLContextLost_
    ), Z.removeEventListener(
      ContextEventType.RESTORED,
      this.boundHandleWebGLContextRestored_
    ), releaseCanvas(this.canvasCacheKey_), delete this.gl_;
  }
  /**
   * Clear the buffer & set the viewport to draw.
   * Post process passes will be initialized here, the first one being bound as a render target for
   * subsequent draw calls.
   * @param {import("../Map.js").FrameState} frameState current frame state
   * @param {boolean} [disableAlphaBlend] If true, no alpha blending will happen.
   * @param {boolean} [enableDepth] If true, enables depth testing.
   */
  prepareDraw(Z, ee, ae) {
    const ve = this.gl_, ye = this.getCanvas(), be = Z.size, Ye = Z.pixelRatio;
    (ye.width !== be[0] * Ye || ye.height !== be[1] * Ye) && (ye.width = be[0] * Ye, ye.height = be[1] * Ye, ye.style.width = be[0] + "px", ye.style.height = be[1] + "px");
    for (let Qe = this.postProcessPasses_.length - 1; Qe >= 0; Qe--)
      this.postProcessPasses_[Qe].init(Z);
    ve.bindTexture(ve.TEXTURE_2D, null), ve.clearColor(0, 0, 0, 0), ve.depthRange(0, 1), ve.clearDepth(1), ve.clear(ve.COLOR_BUFFER_BIT | ve.DEPTH_BUFFER_BIT), ve.enable(ve.BLEND), ve.blendFunc(ve.ONE, ee ? ve.ZERO : ve.ONE_MINUS_SRC_ALPHA), ae ? (ve.enable(ve.DEPTH_TEST), ve.depthFunc(ve.LEQUAL)) : ve.disable(ve.DEPTH_TEST);
  }
  /**
   * Prepare a program to use a texture.
   * @param {WebGLTexture} texture The texture.
   * @param {number} slot The texture slot.
   * @param {string} uniformName The corresponding uniform name.
   */
  bindTexture(Z, ee, ae) {
    const ve = this.gl_;
    ve.activeTexture(ve.TEXTURE0 + ee), ve.bindTexture(ve.TEXTURE_2D, Z), ve.uniform1i(this.getUniformLocation(ae), ee);
  }
  /**
   * Clear the render target & bind it for future draw operations.
   * This is similar to `prepareDraw`, only post processes will not be applied.
   * Note: the whole viewport will be drawn to the render target, regardless of its size.
   * @param {import("../Map.js").FrameState} frameState current frame state
   * @param {import("./RenderTarget.js").default} renderTarget Render target to draw to
   * @param {boolean} [disableAlphaBlend] If true, no alpha blending will happen.
   * @param {boolean} [enableDepth] If true, enables depth testing.
   */
  prepareDrawToRenderTarget(Z, ee, ae, ve) {
    const ye = this.gl_, be = ee.getSize();
    ye.bindFramebuffer(ye.FRAMEBUFFER, ee.getFramebuffer()), ye.bindRenderbuffer(ye.RENDERBUFFER, ee.getDepthbuffer()), ye.viewport(0, 0, be[0], be[1]), ye.bindTexture(ye.TEXTURE_2D, ee.getTexture()), ye.clearColor(0, 0, 0, 0), ye.depthRange(0, 1), ye.clearDepth(1), ye.clear(ye.COLOR_BUFFER_BIT | ye.DEPTH_BUFFER_BIT), ye.enable(ye.BLEND), ye.blendFunc(ye.ONE, ae ? ye.ZERO : ye.ONE_MINUS_SRC_ALPHA), ve ? (ye.enable(ye.DEPTH_TEST), ye.depthFunc(ye.LEQUAL)) : ye.disable(ye.DEPTH_TEST);
  }
  /**
   * Execute a draw call based on the currently bound program, texture, buffers, attributes.
   * @param {number} start Start index.
   * @param {number} end End index.
   */
  drawElements(Z, ee) {
    const ae = this.gl_;
    this.getExtension("OES_element_index_uint");
    const ve = ae.UNSIGNED_INT, ye = 4, be = ee - Z, Ye = Z * ye;
    ae.drawElements(ae.TRIANGLES, be, ve, Ye);
  }
  /**
   * Apply the successive post process passes which will eventually render to the actual canvas.
   * @param {import("../Map.js").FrameState} frameState current frame state
   * @param {function(WebGLRenderingContext, import("../Map.js").FrameState):void} [preCompose] Called before composing.
   * @param {function(WebGLRenderingContext, import("../Map.js").FrameState):void} [postCompose] Called before composing.
   */
  finalizeDraw(Z, ee, ae) {
    for (let ve = 0, ye = this.postProcessPasses_.length; ve < ye; ve++)
      ve === ye - 1 ? this.postProcessPasses_[ve].apply(
        Z,
        null,
        ee,
        ae
      ) : this.postProcessPasses_[ve].apply(
        Z,
        this.postProcessPasses_[ve + 1]
      );
  }
  /**
   * @return {HTMLCanvasElement} Canvas.
   */
  getCanvas() {
    return (
      /** @type {HTMLCanvasElement} */
      this.gl_.canvas
    );
  }
  /**
   * Get the WebGL rendering context
   * @return {WebGLRenderingContext} The rendering context.
   */
  getGL() {
    return this.gl_;
  }
  /**
   * Sets the default matrix uniforms for a given frame state. This is called internally in `prepareDraw`.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */
  applyFrameState(Z) {
    const ee = Z.size, ae = Z.viewState.rotation, ve = Z.pixelRatio;
    this.setUniformFloatValue(
      DefaultUniform.TIME,
      (Date.now() - this.startTime_) * 1e-3
    ), this.setUniformFloatValue(DefaultUniform.ZOOM, Z.viewState.zoom), this.setUniformFloatValue(
      DefaultUniform.RESOLUTION,
      Z.viewState.resolution
    ), this.setUniformFloatValue(DefaultUniform.PIXEL_RATIO, ve), this.setUniformFloatVec2(DefaultUniform.VIEWPORT_SIZE_PX, [
      ee[0],
      ee[1]
    ]), this.setUniformFloatValue(DefaultUniform.ROTATION, ae);
  }
  /**
   * Sets the `u_hitDetection` uniform.
   * @param {boolean} enabled Whether to enable the hit detection code path
   */
  applyHitDetectionUniform(Z) {
    const ee = this.getUniformLocation(DefaultUniform.HIT_DETECTION);
    this.getGL().uniform1i(ee, Z ? 1 : 0), Z && this.setUniformFloatValue(DefaultUniform.PIXEL_RATIO, 0.5);
  }
  /**
   * Sets the custom uniforms based on what was given in the constructor. This is called internally in `prepareDraw`.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */
  applyUniforms(Z) {
    const ee = this.gl_;
    let ae, ve = 0;
    this.uniforms_.forEach((ye) => {
      if (ae = typeof ye.value == "function" ? ye.value(Z) : ye.value, ae instanceof HTMLCanvasElement || ae instanceof HTMLImageElement || ae instanceof ImageData)
        ye.texture || (ye.prevValue = void 0, ye.texture = ee.createTexture()), this.bindTexture(ye.texture, ve, ye.name), ee.texParameteri(ee.TEXTURE_2D, ee.TEXTURE_MIN_FILTER, ee.LINEAR), ee.texParameteri(ee.TEXTURE_2D, ee.TEXTURE_WRAP_S, ee.CLAMP_TO_EDGE), ee.texParameteri(ee.TEXTURE_2D, ee.TEXTURE_WRAP_T, ee.CLAMP_TO_EDGE), (!(ae instanceof HTMLImageElement) || /** @type {HTMLImageElement} */
        ae.complete) && ye.prevValue !== ae && (ye.prevValue = ae, ee.texImage2D(
          ee.TEXTURE_2D,
          0,
          ee.RGBA,
          ee.RGBA,
          ee.UNSIGNED_BYTE,
          ae
        )), ve++;
      else if (Array.isArray(ae) && ae.length === 6)
        this.setUniformMatrixValue(
          ye.name,
          fromTransform(this.tmpMat4_, ae)
        );
      else if (Array.isArray(ae) && ae.length <= 4)
        switch (ae.length) {
          case 2:
            ee.uniform2f(
              this.getUniformLocation(ye.name),
              ae[0],
              ae[1]
            );
            return;
          case 3:
            ee.uniform3f(
              this.getUniformLocation(ye.name),
              ae[0],
              ae[1],
              ae[2]
            );
            return;
          case 4:
            ee.uniform4f(
              this.getUniformLocation(ye.name),
              ae[0],
              ae[1],
              ae[2],
              ae[3]
            );
            return;
          default:
            return;
        }
      else
        typeof ae == "number" && ee.uniform1f(this.getUniformLocation(ye.name), ae);
    });
  }
  /**
   * Set up a program for use. The program will be set as the current one. Then, the uniforms used
   * in the program will be set based on the current frame state and the helper configuration.
   * @param {WebGLProgram} program Program.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */
  useProgram(Z, ee) {
    this.gl_.useProgram(Z), this.currentProgram_ = Z, this.applyFrameState(ee), this.applyUniforms(ee);
  }
  /**
   * Will attempt to compile a vertex or fragment shader based on source
   * On error, the shader will be returned but
   * `gl.getShaderParameter(shader, gl.COMPILE_STATUS)` will return `true`
   * Use `gl.getShaderInfoLog(shader)` to have details
   * @param {string} source Shader source
   * @param {ShaderType} type VERTEX_SHADER or FRAGMENT_SHADER
   * @return {WebGLShader} Shader object
   */
  compileShader(Z, ee) {
    const ae = this.gl_, ve = ae.createShader(ee);
    return ae.shaderSource(ve, Z), ae.compileShader(ve), ve;
  }
  /**
   * Create a program for a vertex and fragment shader.  Throws if shader compilation fails.
   * @param {string} fragmentShaderSource Fragment shader source.
   * @param {string} vertexShaderSource Vertex shader source.
   * @return {WebGLProgram} Program
   */
  getProgram(Z, ee) {
    const ae = this.gl_, ve = this.compileShader(
      Z,
      ae.FRAGMENT_SHADER
    ), ye = this.compileShader(
      ee,
      ae.VERTEX_SHADER
    ), be = ae.createProgram();
    if (ae.attachShader(be, ve), ae.attachShader(be, ye), ae.linkProgram(be), !ae.getShaderParameter(ve, ae.COMPILE_STATUS)) {
      const Ye = `Fragment shader compilation failed: ${ae.getShaderInfoLog(
        ve
      )}`;
      throw new Error(Ye);
    }
    if (ae.deleteShader(ve), !ae.getShaderParameter(ye, ae.COMPILE_STATUS)) {
      const Ye = `Vertex shader compilation failed: ${ae.getShaderInfoLog(
        ye
      )}`;
      throw new Error(Ye);
    }
    if (ae.deleteShader(ye), !ae.getProgramParameter(be, ae.LINK_STATUS)) {
      const Ye = `GL program linking failed: ${ae.getProgramInfoLog(
        be
      )}`;
      throw new Error(Ye);
    }
    return be;
  }
  /**
   * Will get the location from the shader or the cache
   * @param {string} name Uniform name
   * @return {WebGLUniformLocation} uniformLocation
   */
  getUniformLocation(Z) {
    const ee = getUid(this.currentProgram_);
    return this.uniformLocationsByProgram_[ee] === void 0 && (this.uniformLocationsByProgram_[ee] = {}), this.uniformLocationsByProgram_[ee][Z] === void 0 && (this.uniformLocationsByProgram_[ee][Z] = this.gl_.getUniformLocation(this.currentProgram_, Z)), this.uniformLocationsByProgram_[ee][Z];
  }
  /**
   * Will get the location from the shader or the cache
   * @param {string} name Attribute name
   * @return {number} attribLocation
   */
  getAttributeLocation(Z) {
    const ee = getUid(this.currentProgram_);
    return this.attribLocationsByProgram_[ee] === void 0 && (this.attribLocationsByProgram_[ee] = {}), this.attribLocationsByProgram_[ee][Z] === void 0 && (this.attribLocationsByProgram_[ee][Z] = this.gl_.getAttribLocation(this.currentProgram_, Z)), this.attribLocationsByProgram_[ee][Z];
  }
  /**
   * Sets the given transform to apply the rotation/translation/scaling of the given frame state.
   * The resulting transform can be used to convert world space coordinates to view coordinates in the [-1, 1] range.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../transform").Transform} transform Transform to update.
   * @return {import("../transform").Transform} The updated transform object.
   */
  makeProjectionTransform(Z, ee) {
    const ae = Z.size, ve = Z.viewState.rotation, ye = Z.viewState.resolution, be = Z.viewState.center;
    return compose$1(
      ee,
      0,
      0,
      2 / (ye * ae[0]),
      2 / (ye * ae[1]),
      -ve,
      -be[0],
      -be[1]
    ), ee;
  }
  /**
   * Give a value for a standard float uniform
   * @param {string} uniform Uniform name
   * @param {number} value Value
   */
  setUniformFloatValue(Z, ee) {
    this.gl_.uniform1f(this.getUniformLocation(Z), ee);
  }
  /**
   * Give a value for a vec2 uniform
   * @param {string} uniform Uniform name
   * @param {Array<number>} value Array of length 4.
   */
  setUniformFloatVec2(Z, ee) {
    this.gl_.uniform2fv(this.getUniformLocation(Z), ee);
  }
  /**
   * Give a value for a vec4 uniform
   * @param {string} uniform Uniform name
   * @param {Array<number>} value Array of length 4.
   */
  setUniformFloatVec4(Z, ee) {
    this.gl_.uniform4fv(this.getUniformLocation(Z), ee);
  }
  /**
   * Give a value for a standard matrix4 uniform
   * @param {string} uniform Uniform name
   * @param {Array<number>} value Matrix value
   */
  setUniformMatrixValue(Z, ee) {
    this.gl_.uniformMatrix4fv(this.getUniformLocation(Z), !1, ee);
  }
  /**
   * Will set the currently bound buffer to an attribute of the shader program. Used by `#enableAttributes`
   * internally.
   * @param {string} attribName Attribute name
   * @param {number} size Number of components per attributes
   * @param {number} type UNSIGNED_INT, UNSIGNED_BYTE, UNSIGNED_SHORT or FLOAT
   * @param {number} stride Stride in bytes (0 means attribs are packed)
   * @param {number} offset Offset in bytes
   * @private
   */
  enableAttributeArray_(Z, ee, ae, ve, ye) {
    const be = this.getAttributeLocation(Z);
    be < 0 || (this.gl_.enableVertexAttribArray(be), this.gl_.vertexAttribPointer(be, ee, ae, !1, ve, ye));
  }
  /**
   * Will enable the following attributes to be read from the currently bound buffer,
   * i.e. tell the GPU where to read the different attributes in the buffer. An error in the
   * size/type/order of attributes will most likely break the rendering and throw a WebGL exception.
   * @param {Array<AttributeDescription>} attributes Ordered list of attributes to read from the buffer
   */
  enableAttributes(Z) {
    const ee = computeAttributesStride(Z);
    let ae = 0;
    for (let ve = 0; ve < Z.length; ve++) {
      const ye = Z[ve];
      this.enableAttributeArray_(
        ye.name,
        ye.size,
        ye.type || FLOAT,
        ee,
        ae
      ), ae += ye.size * getByteSizeFromType(ye.type);
    }
  }
  /**
   * WebGL context was lost
   * @param {WebGLContextEvent} event The context loss event.
   * @private
   */
  handleWebGLContextLost(Z) {
    clear(this.bufferCache_), this.currentProgram_ = null, Z.preventDefault();
  }
  /**
   * WebGL context was restored
   * @private
   */
  handleWebGLContextRestored() {
    this.needsToBeRecreated_ = !0;
  }
  /**
   * Returns whether this helper needs to be recreated, as the context was lost and then restored.
   * @return {boolean} Whether this helper needs to be recreated.
   */
  needsToBeRecreated() {
    return this.needsToBeRecreated_;
  }
  /**
   * Will create or reuse a given webgl texture and apply the given size. If no image data
   * specified, the texture will be empty, otherwise image data will be used and the `size`
   * parameter will be ignored.
   * Note: wrap parameters are set to clamp to edge, min filter is set to linear.
   * @param {Array<number>} size Expected size of the texture
   * @param {ImageData|HTMLImageElement|HTMLCanvasElement} [data] Image data/object to bind to the texture
   * @param {WebGLTexture} [texture] Existing texture to reuse
   * @return {WebGLTexture} The generated texture
   */
  createTexture(Z, ee, ae) {
    const ve = this.gl_;
    ae = ae || ve.createTexture();
    const ye = 0, be = ve.RGBA, Ye = 0, Qe = ve.RGBA, Je = ve.UNSIGNED_BYTE;
    return ve.bindTexture(ve.TEXTURE_2D, ae), ee ? ve.texImage2D(ve.TEXTURE_2D, ye, be, Qe, Je, ee) : ve.texImage2D(
      ve.TEXTURE_2D,
      ye,
      be,
      Z[0],
      Z[1],
      Ye,
      Qe,
      Je,
      null
    ), ve.texParameteri(ve.TEXTURE_2D, ve.TEXTURE_MIN_FILTER, ve.LINEAR), ve.texParameteri(ve.TEXTURE_2D, ve.TEXTURE_WRAP_S, ve.CLAMP_TO_EDGE), ve.texParameteri(ve.TEXTURE_2D, ve.TEXTURE_WRAP_T, ve.CLAMP_TO_EDGE), ae;
  }
}
function computeAttributesStride(ie) {
  let Z = 0;
  for (let ee = 0; ee < ie.length; ee++) {
    const ae = ie[ee];
    Z += ae.size * getByteSizeFromType(ae.type);
  }
  return Z;
}
function getByteSizeFromType(ie) {
  switch (ie) {
    case AttributeType.UNSIGNED_BYTE:
      return Uint8Array.BYTES_PER_ELEMENT;
    case AttributeType.UNSIGNED_SHORT:
      return Uint16Array.BYTES_PER_ELEMENT;
    case AttributeType.UNSIGNED_INT:
      return Uint32Array.BYTES_PER_ELEMENT;
    case AttributeType.FLOAT:
    default:
      return Float32Array.BYTES_PER_ELEMENT;
  }
}
class WebGLLayerRenderer extends LayerRenderer {
  /**
   * @param {LayerType} layer Layer.
   * @param {Options} [options] Options.
   */
  constructor(Z, ee) {
    super(Z), ee = ee || {}, this.inversePixelTransform_ = create$2(), this.pixelContext_ = null, this.postProcesses_ = ee.postProcesses, this.uniforms_ = ee.uniforms, this.helper, Z.addChangeListener(LayerProperty.MAP, this.removeHelper.bind(this)), this.dispatchPreComposeEvent = this.dispatchPreComposeEvent.bind(this), this.dispatchPostComposeEvent = this.dispatchPostComposeEvent.bind(this);
  }
  /**
   * @param {WebGLRenderingContext} context The WebGL rendering context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */
  dispatchPreComposeEvent(Z, ee) {
    const ae = this.getLayer();
    if (ae.hasListener(RenderEventType.PRECOMPOSE)) {
      const ve = new RenderEvent(
        RenderEventType.PRECOMPOSE,
        void 0,
        ee,
        Z
      );
      ae.dispatchEvent(ve);
    }
  }
  /**
   * @param {WebGLRenderingContext} context The WebGL rendering context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */
  dispatchPostComposeEvent(Z, ee) {
    const ae = this.getLayer();
    if (ae.hasListener(RenderEventType.POSTCOMPOSE)) {
      const ve = new RenderEvent(
        RenderEventType.POSTCOMPOSE,
        void 0,
        ee,
        Z
      );
      ae.dispatchEvent(ve);
    }
  }
  /**
   * Reset options (only handles uniforms).
   * @param {Options} options Options.
   */
  reset(Z) {
    this.uniforms_ = Z.uniforms, this.helper && this.helper.setUniforms(this.uniforms_);
  }
  /**
   * @protected
   */
  removeHelper() {
    this.helper && (this.helper.dispose(), delete this.helper);
  }
  /**
   * Determine whether renderFrame should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */
  prepareFrame(Z) {
    if (this.getLayer().getRenderSource()) {
      let ee = !0, ae = -1, ve;
      for (let be = 0, Ye = Z.layerStatesArray.length; be < Ye; be++) {
        const Qe = Z.layerStatesArray[be].layer, Je = Qe.getRenderer();
        if (!(Je instanceof WebGLLayerRenderer)) {
          ee = !0;
          continue;
        }
        const nt = Qe.getClassName();
        if ((ee || nt !== ve) && (ae += 1, ee = !1), ve = nt, Je === this)
          break;
      }
      const ye = "map/" + Z.mapId + "/group/" + ae;
      (!this.helper || !this.helper.canvasCacheKeyMatches(ye) || this.helper.needsToBeRecreated()) && (this.removeHelper(), this.helper = new WebGLHelper({
        postProcesses: this.postProcesses_,
        uniforms: this.uniforms_,
        canvasCacheKey: ye
      }), ve && (this.helper.getCanvas().className = ve), this.afterHelperCreated());
    }
    return this.prepareFrameInternal(Z);
  }
  /**
   * @protected
   */
  afterHelperCreated() {
  }
  /**
   * Determine whether renderFrame should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @protected
   */
  prepareFrameInternal(Z) {
    return !0;
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    this.removeHelper(), super.disposeInternal();
  }
  /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {WebGLRenderingContext} context The rendering context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */
  dispatchRenderEvent_(Z, ee, ae) {
    const ve = this.getLayer();
    if (ve.hasListener(Z)) {
      compose$1(
        this.inversePixelTransform_,
        0,
        0,
        ae.pixelRatio,
        -ae.pixelRatio,
        0,
        0,
        -ae.size[1]
      );
      const ye = new RenderEvent(
        Z,
        this.inversePixelTransform_,
        ae,
        ee
      );
      ve.dispatchEvent(ye);
    }
  }
  /**
   * @param {WebGLRenderingContext} context The rendering context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */
  preRender(Z, ee) {
    this.dispatchRenderEvent_(RenderEventType.PRERENDER, Z, ee);
  }
  /**
   * @param {WebGLRenderingContext} context The rendering context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */
  postRender(Z, ee) {
    this.dispatchRenderEvent_(RenderEventType.POSTRENDER, Z, ee);
  }
}
const Uniforms$1 = {
  TILE_TRANSFORM: "u_tileTransform",
  TRANSITION_ALPHA: "u_transitionAlpha",
  DEPTH: "u_depth",
  RENDER_EXTENT: "u_renderExtent",
  // intersection of layer, source, and view extent
  RESOLUTION: "u_resolution",
  ZOOM: "u_zoom",
  GLOBAL_ALPHA: "u_globalAlpha",
  PROJECTION_MATRIX: "u_projectionMatrix",
  SCREEN_TO_WORLD_MATRIX: "u_screenToWorldMatrix"
}, empty = {};
function depthForZ(ie) {
  return 1 / (ie + 2);
}
function newTileRepresentationLookup() {
  return { tileIds: /* @__PURE__ */ new Set(), representationsByZ: {} };
}
function lookupHasTile(ie, Z) {
  return ie.tileIds.has(getUid(Z));
}
function addTileRepresentationToLookup(ie, Z, ee) {
  const ae = ie.representationsByZ;
  ee in ae || (ae[ee] = /* @__PURE__ */ new Set()), ae[ee].add(Z), ie.tileIds.add(getUid(Z.tile));
}
function getRenderExtent(ie, Z) {
  const ee = ie.layerStatesArray[ie.layerIndex];
  ee.extent && (Z = getIntersection(
    Z,
    fromUserExtent(ee.extent, ie.viewState.projection)
  ));
  const ae = (
    /** @type {import("../../source/Tile.js").default} */
    ee.layer.getRenderSource()
  );
  if (!ae.getWrapX()) {
    const ve = ae.getTileGridForProjection(ie.viewState.projection).getExtent();
    ve && (Z = getIntersection(Z, ve));
  }
  return Z;
}
function getCacheKey(ie, Z) {
  return `${ie.getKey()},${getKey(Z)}`;
}
class WebGLBaseTileLayerRenderer extends WebGLLayerRenderer {
  /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} options Options.
   */
  constructor(Z, ee) {
    super(Z, {
      uniforms: ee.uniforms,
      postProcesses: ee.postProcesses
    }), this.renderComplete = !1, this.tileTransform_ = create$2(), this.tempMat4 = create$1(), this.tempTileRange_ = new TileRange(0, 0, 0, 0), this.tempTileCoord_ = createOrUpdate$1(0, 0, 0), this.tempSize_ = [0, 0];
    const ae = ee.cacheSize !== void 0 ? ee.cacheSize : 512;
    this.tileRepresentationCache = new LRUCache(ae), this.frameState = null, this.projection_ = void 0;
  }
  /**
   * @param {Options} options Options.
   */
  reset(Z) {
    super.reset({
      uniforms: Z.uniforms
    });
  }
  /**
   * @param {TileType} tile Tile.
   * @return {boolean} Tile is drawable.
   * @private
   */
  isDrawableTile_(Z) {
    const ee = this.getLayer(), ae = Z.getState(), ve = ee.getUseInterimTilesOnError();
    return ae == TileState.LOADED || ae == TileState.EMPTY || ae == TileState.ERROR && !ve;
  }
  /**
   * Determine whether renderFrame should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */
  prepareFrameInternal(Z) {
    this.projection_ ? Z.viewState.projection !== this.projection_ && (this.clearCache(), this.projection_ = Z.viewState.projection) : this.projection_ = Z.viewState.projection;
    const ae = this.getLayer().getRenderSource();
    return !ae || isEmpty(getRenderExtent(Z, Z.extent)) ? !1 : ae.getState() === "ready";
  }
  /**
   * @abstract
   * @param {import("../../webgl/BaseTileRepresentation.js").TileRepresentationOptions<TileType>} options tile representation options
   * @return {TileRepresentation} A new tile representation
   * @protected
   */
  createTileRepresentation(Z) {
    return abstract();
  }
  /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent The extent to be rendered.
   * @param {number} initialZ The zoom level.
   * @param {TileRepresentationLookup} tileRepresentationLookup The zoom level.
   * @param {number} preload Number of additional levels to load.
   */
  enqueueTiles(Z, ee, ae, ve, ye) {
    const be = Z.viewState, Ye = this.getLayer(), Qe = Ye.getRenderSource(), Je = Qe.getTileGridForProjection(be.projection), nt = Qe.getGutterForProjection(be.projection), st = getUid(Qe);
    st in Z.wantedTiles || (Z.wantedTiles[st] = {});
    const ot = Z.wantedTiles[st], lt = this.tileRepresentationCache, ft = Ye.getMapInternal(), gt = Math.max(
      ae - ye,
      Je.getMinZoom(),
      Je.getZForResolution(
        Math.min(
          Ye.getMaxResolution(),
          ft ? ft.getView().getResolutionForZoom(Math.max(Ye.getMinZoom(), 0)) : Je.getResolution(0)
        ),
        Qe.zDirection
      )
    );
    for (let ct = ae; ct >= gt; --ct) {
      const _r = Je.getTileRangeForExtentAndZ(
        ee,
        ct,
        this.tempTileRange_
      ), Kr = Je.getResolution(ct);
      for (let Xr = _r.minX; Xr <= _r.maxX; ++Xr)
        for (let Jr = _r.minY; Jr <= _r.maxY; ++Jr) {
          const ei = createOrUpdate$1(ct, Xr, Jr, this.tempTileCoord_), si = getCacheKey(Qe, ei);
          let ri, ai;
          if (lt.containsKey(si) && (ri = lt.get(si), ai = ri.tile), (!ri || ri.tile.key !== Qe.getKey()) && (ai = Qe.getTile(
            ct,
            Xr,
            Jr,
            Z.pixelRatio,
            be.projection
          )), lookupHasTile(ve, ai))
            continue;
          if (!ri)
            ri = this.createTileRepresentation({
              tile: ai,
              grid: Je,
              helper: this.helper,
              gutter: nt
            }), lt.set(si, ri);
          else if (this.isDrawableTile_(ai))
            ri.setTile(ai);
          else {
            const pi = (
              /** @type {TileType} */
              ai.getInterimTile()
            );
            ri.setTile(pi);
          }
          addTileRepresentationToLookup(
            ve,
            ri,
            ct
          );
          const yi = ai.getKey();
          ot[yi] = !0, ai.getState() === TileState.IDLE && (Z.tileQueue.isKeyQueued(yi) || Z.tileQueue.enqueue([
            ai,
            st,
            Je.getTileCoordCenter(ei),
            Kr
          ]));
        }
    }
  }
  /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} tilesWithAlpha True if at least one of the rendered tiles has alpha
   * @protected
   */
  beforeTilesRender(Z, ee) {
    this.helper.prepareDraw(this.frameState, !ee, !0);
  }
  /**
   * @param {TileRepresentation} tileRepresentation Tile representation
   * @param {import("../../transform.js").Transform} tileTransform Tile transform
   * @param {import("../../Map.js").FrameState} frameState Frame state
   * @param {import("../../extent.js").Extent} renderExtent Render extent
   * @param {number} tileResolution Tile resolution
   * @param {import("../../size.js").Size} tileSize Tile size
   * @param {import("../../coordinate.js").Coordinate} tileOrigin Tile origin
   * @param {import("../../extent.js").Extent} tileExtent tile Extent
   * @param {number} depth Depth
   * @param {number} gutter Gutter
   * @param {number} alpha Alpha
   * @protected
   */
  renderTile(Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt, st) {
  }
  drawTile_(Z, ee, ae, ve, ye, be, Ye) {
    if (!ee.loaded)
      return;
    const Je = ee.tile.tileCoord, nt = getKey(Je), st = nt in be ? be[nt] : 1, ot = Ye.getResolution(ae), lt = toSize(Ye.getTileSize(ae), this.tempSize_), ft = Ye.getOrigin(ae), gt = Ye.getTileCoordExtent(Je), ct = st < 1 ? -1 : depthForZ(ae);
    st < 1 && (Z.animate = !0);
    const _r = Z.viewState, Kr = _r.center[0], Xr = _r.center[1], Jr = lt[0] + 2 * ve, ei = lt[1] + 2 * ve, si = Jr / ei, ri = (Kr - ft[0]) / (lt[0] * ot), ai = (ft[1] - Xr) / (lt[1] * ot), yi = _r.resolution / ot, pi = Je[1], di = Je[2];
    reset(this.tileTransform_), scale$3(
      this.tileTransform_,
      2 / (Z.size[0] * yi / Jr),
      -2 / (Z.size[1] * yi / Jr)
    ), rotate$3(this.tileTransform_, _r.rotation), scale$3(this.tileTransform_, 1, 1 / si), translate$1(
      this.tileTransform_,
      (lt[0] * (pi - ri) - ve) / Jr,
      (lt[1] * (di - ai) - ve) / ei
    ), this.renderTile(
      /** @type {TileRepresentation} */
      ee,
      this.tileTransform_,
      Z,
      ye,
      ot,
      lt,
      ft,
      gt,
      ct,
      ve,
      st
    );
  }
  /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {HTMLElement} The rendered element.
   */
  renderFrame(Z) {
    this.frameState = Z, this.renderComplete = !0;
    const ee = this.helper.getGL();
    this.preRender(ee, Z);
    const ae = Z.viewState, ve = this.getLayer(), ye = ve.getRenderSource(), be = ye.getTileGridForProjection(ae.projection), Ye = ye.getGutterForProjection(ae.projection), Qe = getRenderExtent(Z, Z.extent), Je = be.getZForResolution(
      ae.resolution,
      ye.zDirection
    ), nt = newTileRepresentationLookup(), st = ve.getPreload();
    if (Z.nextExtent) {
      const ei = be.getZForResolution(
        ae.nextResolution,
        ye.zDirection
      ), si = getRenderExtent(Z, Z.nextExtent);
      this.enqueueTiles(
        Z,
        si,
        ei,
        nt,
        st
      );
    }
    this.enqueueTiles(Z, Qe, Je, nt, 0), st > 0 && setTimeout(() => {
      this.enqueueTiles(
        Z,
        Qe,
        Je - 1,
        nt,
        st - 1
      );
    }, 0);
    const ot = {}, lt = getUid(this), ft = Z.time;
    let gt = !1;
    for (const ei of nt.representationsByZ[Je]) {
      const si = ei.tile;
      if ((si instanceof ReprojTile || si instanceof ReprojDataTile) && si.getState() === TileState.EMPTY)
        continue;
      const ri = si.tileCoord;
      if (ei.loaded) {
        const pi = si.getAlpha(lt, ft);
        if (pi === 1) {
          si.endTransition(lt);
          continue;
        }
        gt = !0;
        const di = getKey(ri);
        ot[di] = pi;
      }
      if (this.renderComplete = !1, this.findAltTiles_(
        be,
        ri,
        Je + 1,
        nt
      ))
        continue;
      const yi = be.getMinZoom();
      for (let pi = Je - 1; pi >= yi && !this.findAltTiles_(
        be,
        ri,
        pi,
        nt
      ); --pi)
        ;
    }
    this.beforeTilesRender(Z, gt);
    const ct = nt.representationsByZ, _r = Object.keys(ct).map(Number).sort(descending);
    for (let ei = 0, si = _r.length; ei < si; ++ei) {
      const ri = _r[ei];
      for (const ai of ct[ri]) {
        const yi = ai.tile.tileCoord;
        getKey(yi) in ot || this.drawTile_(
          Z,
          ai,
          ri,
          Ye,
          Qe,
          ot,
          be
        );
      }
    }
    for (const ei of ct[Je]) {
      const si = ei.tile.tileCoord;
      getKey(si) in ot && this.drawTile_(
        Z,
        ei,
        Je,
        Ye,
        Qe,
        ot,
        be
      );
    }
    this.helper.finalizeDraw(
      Z,
      this.dispatchPreComposeEvent,
      this.dispatchPostComposeEvent
    );
    const Kr = this.helper.getCanvas(), Xr = this.tileRepresentationCache;
    for (; Xr.canExpireCache(); )
      Xr.pop().dispose();
    const Jr = function(ei, si) {
      ye.updateCacheSize(0.1, si.viewState.projection), ye.expireCache(si.viewState.projection, empty);
    };
    return Z.postRenderFunctions.push(Jr), this.postRender(ee, Z), Kr;
  }
  /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile representation lookup.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {number} altZ The alternate zoom level.
   * @param {TileRepresentationLookup} tileRepresentationLookup Lookup of
   * tile representations by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */
  findAltTiles_(Z, ee, ae, ve) {
    const ye = Z.getTileRangeForTileCoordAndZ(
      ee,
      ae,
      this.tempTileRange_
    );
    if (!ye)
      return !1;
    let be = !0;
    const Ye = this.tileRepresentationCache, Qe = this.getLayer().getRenderSource();
    for (let Je = ye.minX; Je <= ye.maxX; ++Je)
      for (let nt = ye.minY; nt <= ye.maxY; ++nt) {
        const st = getCacheKey(Qe, [ae, Je, nt]);
        let ot = !1;
        if (Ye.containsKey(st)) {
          const lt = Ye.get(st);
          lt.loaded && !lookupHasTile(ve, lt.tile) && (addTileRepresentationToLookup(
            ve,
            lt,
            ae
          ), ot = !0);
        }
        ot || (be = !1);
      }
    return be;
  }
  clearCache() {
    const Z = this.tileRepresentationCache;
    Z.forEach(
      (ee) => ee.dispose()
    ), Z.clear();
  }
  removeHelper() {
    this.helper && this.clearCache(), super.removeHelper();
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    super.disposeInternal(), delete this.frameState;
  }
}
const Uniforms = {
  ...Uniforms$1,
  TILE_TEXTURE_ARRAY: "u_tileTextures",
  TEXTURE_PIXEL_WIDTH: "u_texturePixelWidth",
  TEXTURE_PIXEL_HEIGHT: "u_texturePixelHeight",
  TEXTURE_RESOLUTION: "u_textureResolution",
  // map units per texture pixel
  TEXTURE_ORIGIN_X: "u_textureOriginX",
  // map x coordinate of left edge of texture
  TEXTURE_ORIGIN_Y: "u_textureOriginY"
  // map y coordinate of top edge of texture
}, Attributes = {
  TEXTURE_COORD: "a_textureCoord"
}, attributeDescriptions = [
  {
    name: Attributes.TEXTURE_COORD,
    size: 2,
    type: AttributeType.FLOAT
  }
];
class WebGLTileLayerRenderer extends WebGLBaseTileLayerRenderer {
  /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} options Options.
   */
  constructor(Z, ee) {
    super(Z, ee), this.program_, this.vertexShader_ = ee.vertexShader, this.fragmentShader_ = ee.fragmentShader, this.indices_ = new WebGLArrayBuffer(ELEMENT_ARRAY_BUFFER, STATIC_DRAW), this.indices_.fromArray([0, 1, 3, 1, 2, 3]), this.paletteTextures_ = ee.paletteTextures || [];
  }
  /**
   * @param {Options} options Options.
   */
  reset(Z) {
    super.reset(Z), this.vertexShader_ = Z.vertexShader, this.fragmentShader_ = Z.fragmentShader, this.helper && (this.program_ = this.helper.getProgram(
      this.fragmentShader_,
      this.vertexShader_
    ));
  }
  afterHelperCreated() {
    this.program_ = this.helper.getProgram(
      this.fragmentShader_,
      this.vertexShader_
    ), this.helper.flushBufferData(this.indices_);
  }
  createTileRepresentation(Z) {
    return new TileTexture(Z);
  }
  beforeTilesRender(Z, ee) {
    super.beforeTilesRender(Z, ee), this.helper.useProgram(this.program_, Z);
  }
  renderTile(Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt, st) {
    const ot = this.helper.getGL();
    this.helper.bindBuffer(Z.coords), this.helper.bindBuffer(this.indices_), this.helper.enableAttributes(attributeDescriptions);
    let lt = 0;
    for (; lt < Z.textures.length; ) {
      const si = `${Uniforms.TILE_TEXTURE_ARRAY}[${lt}]`;
      this.helper.bindTexture(
        Z.textures[lt],
        lt,
        si
      ), ++lt;
    }
    for (let si = 0; si < this.paletteTextures_.length; ++si) {
      const ri = this.paletteTextures_[si], ai = ri.getTexture(ot);
      this.helper.bindTexture(ai, lt, ri.name), ++lt;
    }
    const ft = ae.viewState, gt = be[0] + 2 * nt, ct = be[1] + 2 * nt, Kr = Z.tile.tileCoord, Xr = Kr[1], Jr = Kr[2];
    this.helper.setUniformMatrixValue(
      Uniforms.TILE_TRANSFORM,
      fromTransform(this.tempMat4, ee)
    ), this.helper.setUniformFloatValue(Uniforms.TRANSITION_ALPHA, st), this.helper.setUniformFloatValue(Uniforms.DEPTH, Je);
    let ei = ve;
    nt > 0 && (ei = Qe, getIntersection(ei, ve, ei)), this.helper.setUniformFloatVec4(Uniforms.RENDER_EXTENT, ei), this.helper.setUniformFloatValue(Uniforms.RESOLUTION, ft.resolution), this.helper.setUniformFloatValue(Uniforms.ZOOM, ft.zoom), this.helper.setUniformFloatValue(
      Uniforms.TEXTURE_PIXEL_WIDTH,
      gt
    ), this.helper.setUniformFloatValue(
      Uniforms.TEXTURE_PIXEL_HEIGHT,
      ct
    ), this.helper.setUniformFloatValue(
      Uniforms.TEXTURE_RESOLUTION,
      ye
    ), this.helper.setUniformFloatValue(
      Uniforms.TEXTURE_ORIGIN_X,
      Ye[0] + Xr * be[0] * ye - nt * ye
    ), this.helper.setUniformFloatValue(
      Uniforms.TEXTURE_ORIGIN_Y,
      Ye[1] - Jr * be[1] * ye + nt * ye
    ), this.helper.drawElements(0, this.indices_.getSize());
  }
  /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView} Data at the pixel location.
   */
  getData(Z) {
    if (!this.helper.getGL())
      return null;
    const ae = this.frameState;
    if (!ae)
      return null;
    const ve = this.getLayer(), ye = apply(
      ae.pixelToCoordinateTransform,
      Z.slice()
    ), be = ae.viewState, Ye = ve.getExtent();
    if (Ye && !containsCoordinate(
      fromUserExtent(Ye, be.projection),
      ye
    ))
      return null;
    const Qe = ve.getSources(
      boundingExtent([ye]),
      be.resolution
    );
    let Je, nt, st;
    for (Je = Qe.length - 1; Je >= 0; --Je)
      if (nt = Qe[Je], nt.getState() === "ready") {
        if (st = nt.getTileGridForProjection(be.projection), nt.getWrapX())
          break;
        const lt = st.getExtent();
        if (!lt || containsCoordinate(lt, ye))
          break;
      }
    if (Je < 0)
      return null;
    const ot = this.tileRepresentationCache;
    for (let lt = st.getZForResolution(be.resolution); lt >= st.getMinZoom(); --lt) {
      const ft = st.getTileCoordForCoordAndZ(ye, lt), gt = getCacheKey(nt, ft);
      if (!ot.containsKey(gt))
        continue;
      const ct = ot.get(gt), _r = ct.tile;
      if ((_r instanceof ReprojTile || _r instanceof ReprojDataTile) && _r.getState() === TileState.EMPTY)
        return null;
      if (!ct.loaded)
        continue;
      const Kr = st.getOrigin(lt), Xr = toSize(st.getTileSize(lt)), Jr = st.getResolution(lt), ei = (ye[0] - Kr[0]) / Jr - ft[1] * Xr[0], si = (Kr[1] - ye[1]) / Jr - ft[2] * Xr[1];
      return ct.getPixelData(ei, si);
    }
    return null;
  }
  /**
   * Clean up.
   */
  disposeInternal() {
    const Z = this.helper;
    Z && (Z.getGL().deleteProgram(this.program_), delete this.program_, Z.deleteBuffer(this.indices_)), super.disposeInternal(), delete this.indices_;
  }
}
class PaletteTexture {
  /**
   * @param {string} name The name of the texture.
   * @param {Uint8Array} data The texture data.
   */
  constructor(Z, ee) {
    this.name = Z, this.data = ee, this.texture_ = null;
  }
  /**
   * @param {WebGLRenderingContext} gl Rendering context.
   * @return {WebGLTexture} The texture.
   */
  getTexture(Z) {
    if (!this.texture_) {
      const ee = Z.createTexture();
      Z.bindTexture(Z.TEXTURE_2D, ee), Z.texParameteri(Z.TEXTURE_2D, Z.TEXTURE_WRAP_S, Z.CLAMP_TO_EDGE), Z.texParameteri(Z.TEXTURE_2D, Z.TEXTURE_WRAP_T, Z.CLAMP_TO_EDGE), Z.texParameteri(Z.TEXTURE_2D, Z.TEXTURE_MIN_FILTER, Z.NEAREST), Z.texParameteri(Z.TEXTURE_2D, Z.TEXTURE_MAG_FILTER, Z.NEAREST), Z.texImage2D(
        Z.TEXTURE_2D,
        0,
        Z.RGBA,
        this.data.length / 4,
        1,
        0,
        Z.RGBA,
        Z.UNSIGNED_BYTE,
        this.data
      ), this.texture_ = ee;
    }
    return this.texture_;
  }
}
const ValueTypes = {
  NUMBER: 1,
  STRING: 2,
  COLOR: 4,
  BOOLEAN: 8,
  NUMBER_ARRAY: 16,
  ANY: 31,
  NONE: 0
};
function getTypeFromHint(ie) {
  switch (ie) {
    case "string":
      return ValueTypes.STRING;
    case "color":
      return ValueTypes.COLOR;
    case "number":
      return ValueTypes.NUMBER;
    case "boolean":
      return ValueTypes.BOOLEAN;
    case "number[]":
      return ValueTypes.NUMBER_ARRAY;
    default:
      throw new Error(`Unrecognized type hint: ${ie}`);
  }
}
const Operators = {};
function getValueType(ie) {
  if (typeof ie == "number")
    return ValueTypes.NUMBER;
  if (typeof ie == "boolean")
    return ValueTypes.BOOLEAN;
  if (typeof ie == "string")
    return isStringColor(ie) ? ValueTypes.COLOR | ValueTypes.STRING : ValueTypes.STRING;
  if (!Array.isArray(ie))
    throw new Error(`Unhandled value type: ${JSON.stringify(ie)}`);
  const Z = (
    /** @type {Array<*>} */
    ie
  );
  if (Z.every(function(ve) {
    return typeof ve == "number";
  }))
    return Z.length === 3 || Z.length === 4 ? ValueTypes.COLOR | ValueTypes.NUMBER_ARRAY : ValueTypes.NUMBER_ARRAY;
  if (typeof Z[0] != "string")
    throw new Error(
      `Expected an expression operator but received: ${JSON.stringify(
        Z
      )}`
    );
  const ae = Operators[Z[0]];
  if (ae === void 0)
    throw new Error(
      `Unrecognized expression operator: ${JSON.stringify(Z)}`
    );
  return ae.getReturnType(Z.slice(1));
}
function isTypeUnique(ie) {
  return Math.log2(ie) % 1 === 0;
}
function printTypes(ie) {
  const Z = [];
  return (ie & ValueTypes.NUMBER) > 0 && Z.push("number"), (ie & ValueTypes.COLOR) > 0 && Z.push("color"), (ie & ValueTypes.BOOLEAN) > 0 && Z.push("boolean"), (ie & ValueTypes.NUMBER_ARRAY) > 0 && Z.push("number[]"), (ie & ValueTypes.STRING) > 0 && Z.push("string"), Z.length > 0 ? Z.join(", ") : "(no type)";
}
function computeOperatorFunctionName(ie, Z) {
  return `operator_${ie}_${Object.keys(Z.functions).length}`;
}
function numberToGlsl(ie) {
  const Z = ie.toString();
  return Z.includes(".") ? Z : Z + ".0";
}
function arrayToGlsl(ie) {
  if (ie.length < 2 || ie.length > 4)
    throw new Error(
      "`formatArray` can only output `vec2`, `vec3` or `vec4` arrays."
    );
  return `vec${ie.length}(${ie.map(numberToGlsl).join(", ")})`;
}
function colorToGlsl(ie) {
  const Z = asArray(ie), ee = Z.length > 3 ? Z[3] : 1;
  return arrayToGlsl([
    Z[0] / 255 * ee,
    Z[1] / 255 * ee,
    Z[2] / 255 * ee,
    ee
  ]);
}
const stringToFloatMap = {};
let stringToFloatCounter = 0;
function getStringNumberEquivalent(ie) {
  return ie in stringToFloatMap || (stringToFloatMap[ie] = stringToFloatCounter++), stringToFloatMap[ie];
}
function stringToGlsl(ie) {
  return numberToGlsl(getStringNumberEquivalent(ie));
}
function expressionToGlsl(ie, Z, ee) {
  const ae = ee !== void 0 ? ee : ValueTypes.NUMBER;
  if (Array.isArray(Z) && typeof Z[0] == "string") {
    const ye = Operators[Z[0]];
    if (ye === void 0)
      throw new Error(
        `Unrecognized expression operator: ${JSON.stringify(Z)}`
      );
    return ye.toGlsl(ie, Z.slice(1), ae);
  }
  const ve = getValueType(Z) & ae;
  if (assertNotEmptyType(Z, ve, ""), (ve & ValueTypes.NUMBER) > 0)
    return numberToGlsl(
      /** @type {number} */
      Z
    );
  if ((ve & ValueTypes.BOOLEAN) > 0)
    return Z.toString();
  if ((ve & ValueTypes.STRING) > 0)
    return stringToGlsl(Z.toString());
  if ((ve & ValueTypes.COLOR) > 0)
    return colorToGlsl(
      /** @type {Array<number> | string} */
      Z
    );
  if ((ve & ValueTypes.NUMBER_ARRAY) > 0)
    return arrayToGlsl(
      /** @type {Array<number>} */
      Z
    );
  throw new Error(
    `Unexpected expression ${Z} (expected type ${printTypes(ae)})`
  );
}
function assertNumber(ie) {
  if (!(getValueType(ie) & ValueTypes.NUMBER))
    throw new Error(
      `A numeric value was expected, got ${JSON.stringify(ie)} instead`
    );
}
function assertNumbers(ie) {
  for (let Z = 0; Z < ie.length; Z++)
    assertNumber(ie[Z]);
}
function assertString(ie) {
  if (!(getValueType(ie) & ValueTypes.STRING))
    throw new Error(
      `A string value was expected, got ${JSON.stringify(ie)} instead`
    );
}
function assertBoolean(ie) {
  if (!(getValueType(ie) & ValueTypes.BOOLEAN))
    throw new Error(
      `A boolean value was expected, got ${JSON.stringify(ie)} instead`
    );
}
function assertArgsCount(ie, Z) {
  if (ie.length !== Z)
    throw new Error(
      `Exactly ${Z} arguments were expected, got ${ie.length} instead`
    );
}
function assertArgsMinCount(ie, Z) {
  if (ie.length < Z)
    throw new Error(
      `At least ${Z} arguments were expected, got ${ie.length} instead`
    );
}
function assertArgsMaxCount(ie, Z) {
  if (ie.length > Z)
    throw new Error(
      `At most ${Z} arguments were expected, got ${ie.length} instead`
    );
}
function assertArgsEven(ie) {
  if (ie.length % 2 !== 0)
    throw new Error(
      `An even amount of arguments was expected, got ${JSON.stringify(
        ie
      )} instead`
    );
}
function assertArgsOdd(ie) {
  if (ie.length % 2 === 0)
    throw new Error(
      `An odd amount of arguments was expected, got ${JSON.stringify(
        ie
      )} instead`
    );
}
function assertNotEmptyType(ie, Z, ee) {
  if (Z === ValueTypes.NONE)
    throw new Error(
      `No matching type was found for the following expression ${ee}: ${JSON.stringify(
        ie
      )}`
    );
}
function assertSingleType(ie, Z, ee) {
  if (assertNotEmptyType(ie, Z, ee), !isTypeUnique(Z))
    throw new Error(
      `Expected to have a unique type for the following expression ${ee}: ${JSON.stringify(
        ie
      )}
Got the following types instead: ${printTypes(Z)}`
    );
}
function assertOfType(ie, Z, ee, ae) {
  if ((Z & ee) === ValueTypes.NONE)
    throw new Error(
      `Expected the ${ae} type of the following expression: ${JSON.stringify(
        ie
      )} to be of the following types: ${printTypes(ee)}
Got these types instead: ${printTypes(Z)}`
    );
}
Operators.get = {
  getReturnType: function(ie) {
    if (ie.length === 2) {
      const Z = ie[1];
      return getTypeFromHint(
        /** @type {string} */
        Z
      );
    }
    return ValueTypes.ANY;
  },
  toGlsl: function(ie, Z, ee) {
    assertArgsMinCount(Z, 1), assertArgsMaxCount(Z, 2), assertString(Z[0]);
    const ae = ee & Operators.get.getReturnType(Z);
    assertSingleType(["get", ...Z], ae, "");
    const ve = Z[0].toString(), ye = ie.attributes.find((Ye) => Ye.name === ve);
    if (!ye)
      ie.attributes.push({
        name: ve,
        type: ae
      });
    else if (ae !== ye.type)
      throw new Error(
        `The following attribute was used in different places with incompatible types: ${ve}
Types were: ${printTypes(ye.type)} and ${printTypes(ae)}`
      );
    return (ie.inFragmentShader ? "v_" : "a_") + ve;
  }
};
function uniformNameForVariable(ie) {
  return "u_var_" + ie;
}
Operators.var = {
  getReturnType: function() {
    return ValueTypes.ANY;
  },
  toGlsl: function(ie, Z, ee) {
    assertArgsCount(Z, 1), assertString(Z[0]);
    const ae = Z[0].toString();
    if (!ie.style.variables || ie.style.variables[ae] === void 0)
      throw new Error(
        `The following variable is missing from the style: ${ae}`
      );
    const ve = ie.style.variables[ae], ye = ee & getValueType(ve);
    assertSingleType(["var", ...Z], ye, "");
    const be = ie.variables.find((Ye) => Ye.name === ae);
    if (!be)
      ie.variables.push({
        name: ae,
        type: ye
      });
    else if (ye !== be.type)
      throw new Error(
        `The following variable was used in different places with incompatible types: ${ae}
Types were: ${printTypes(be.type)} and ${printTypes(ye)}`
      );
    return uniformNameForVariable(ae);
  }
};
const PALETTE_TEXTURE_ARRAY = "u_paletteTextures";
Operators.palette = {
  getReturnType: function() {
    return ValueTypes.COLOR;
  },
  toGlsl: function(ie, Z) {
    assertArgsCount(Z, 2), assertNumber(Z[0]);
    const ee = expressionToGlsl(ie, Z[0]), ae = Z[1];
    if (!Array.isArray(ae))
      throw new Error("The second argument of palette must be an array");
    const ve = ae.length, ye = new Uint8Array(ve * 4);
    for (let Qe = 0; Qe < ve; Qe++) {
      const Je = ae[Qe];
      let nt;
      if (typeof Je == "string")
        nt = fromString(Je);
      else {
        if (!Array.isArray(Je))
          throw new Error(
            "The second argument of palette must be an array of strings or colors"
          );
        const ot = Je.length;
        if (ot === 4)
          nt = Je;
        else {
          if (ot !== 3)
            throw new Error(
              `Expected palette color to have 3 or 4 values, got ${ot}`
            );
          nt = [Je[0], Je[1], Je[2], 1];
        }
      }
      const st = Qe * 4;
      ye[st] = nt[0], ye[st + 1] = nt[1], ye[st + 2] = nt[2], ye[st + 3] = nt[3] * 255;
    }
    ie.paletteTextures || (ie.paletteTextures = []);
    const be = `${PALETTE_TEXTURE_ARRAY}[${ie.paletteTextures.length}]`, Ye = new PaletteTexture(be, ye);
    return ie.paletteTextures.push(Ye), `texture2D(${be}, vec2((${ee} + 0.5) / ${ve}.0, 0.5))`;
  }
};
const GET_BAND_VALUE_FUNC = "getBandValue";
Operators.band = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    assertArgsMinCount(Z, 1), assertArgsMaxCount(Z, 3);
    const ee = Z[0];
    if (!(GET_BAND_VALUE_FUNC in ie.functions)) {
      let be = "";
      const Ye = ie.bandCount || 1;
      for (let Qe = 0; Qe < Ye; Qe++) {
        const Je = Math.floor(Qe / 4);
        let nt = Qe % 4;
        Qe === Ye - 1 && nt === 1 && (nt = 3);
        const st = `${Uniforms.TILE_TEXTURE_ARRAY}[${Je}]`;
        be += `
          if (band == ${Qe + 1}.0) {
            return texture2D(${st}, v_textureCoord + vec2(dx, dy))[${nt}];
          }
        `;
      }
      ie.functions[GET_BAND_VALUE_FUNC] = `
        float getBandValue(float band, float xOffset, float yOffset) {
          float dx = xOffset / ${Uniforms.TEXTURE_PIXEL_WIDTH};
          float dy = yOffset / ${Uniforms.TEXTURE_PIXEL_HEIGHT};
          ${be}
        }
      `;
    }
    const ae = expressionToGlsl(ie, ee), ve = expressionToGlsl(ie, Z[1] || 0), ye = expressionToGlsl(ie, Z[2] || 0);
    return `${GET_BAND_VALUE_FUNC}(${ae}, ${ve}, ${ye})`;
  }
};
Operators.time = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 0), "u_time";
  }
};
Operators.zoom = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 0), "u_zoom";
  }
};
Operators.resolution = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 0), "u_resolution";
  }
};
Operators["geometry-type"] = {
  getReturnType: function() {
    return ValueTypes.STRING;
  },
  toGlsl: function(ie, Z) {
    assertArgsCount(Z, 0);
    const ee = "geometryType", ae = (be) => {
      const Ye = be.getType();
      switch (Ye) {
        case "Point":
        case "LineString":
        case "Polygon":
          return Ye;
        case "MultiPoint":
        case "MultiLineString":
        case "MultiPolygon":
          return Ye.substring(5);
        case "Circle":
          return "Polygon";
        case "GeometryCollection":
          return ae(be.getGeometries()[0]);
      }
    };
    return ie.attributes.find((be) => be.name === ee) || ie.attributes.push({
      name: ee,
      type: ValueTypes.STRING,
      callback: (be) => ae(be.getGeometry())
    }), (ie.inFragmentShader ? "v_" : "a_") + ee;
  }
};
Operators["*"] = {
  getReturnType: function(ie) {
    let Z = ValueTypes.NUMBER | ValueTypes.COLOR;
    for (let ee = 0; ee < ie.length; ee++)
      Z = Z & getValueType(ie[ee]);
    return Z;
  },
  toGlsl: function(ie, Z, ee) {
    assertArgsMinCount(Z, 2);
    let ae = ee;
    for (let ve = 0; ve < Z.length; ve++)
      ae = ae & getValueType(Z[ve]);
    return assertOfType(
      Z,
      ae,
      ValueTypes.NUMBER | ValueTypes.COLOR,
      "output"
    ), `(${Z.map((ve) => expressionToGlsl(ie, ve, ae)).join(" * ")})`;
  }
};
Operators["/"] = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 2), assertNumbers(Z), `(${expressionToGlsl(ie, Z[0])} / ${expressionToGlsl(
      ie,
      Z[1]
    )})`;
  }
};
Operators["+"] = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsMinCount(Z, 2), assertNumbers(Z), `(${Z.map((ee) => expressionToGlsl(ie, ee)).join(" + ")})`;
  }
};
Operators["-"] = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 2), assertNumbers(Z), `(${expressionToGlsl(ie, Z[0])} - ${expressionToGlsl(
      ie,
      Z[1]
    )})`;
  }
};
Operators.clamp = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    assertArgsCount(Z, 3), assertNumbers(Z);
    const ee = expressionToGlsl(ie, Z[1]), ae = expressionToGlsl(ie, Z[2]);
    return `clamp(${expressionToGlsl(ie, Z[0])}, ${ee}, ${ae})`;
  }
};
Operators["%"] = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 2), assertNumbers(Z), `mod(${expressionToGlsl(ie, Z[0])}, ${expressionToGlsl(
      ie,
      Z[1]
    )})`;
  }
};
Operators["^"] = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 2), assertNumbers(Z), `pow(${expressionToGlsl(ie, Z[0])}, ${expressionToGlsl(
      ie,
      Z[1]
    )})`;
  }
};
Operators.abs = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 1), assertNumbers(Z), `abs(${expressionToGlsl(ie, Z[0])})`;
  }
};
Operators.floor = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 1), assertNumbers(Z), `floor(${expressionToGlsl(ie, Z[0])})`;
  }
};
Operators.round = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 1), assertNumbers(Z), `floor(${expressionToGlsl(ie, Z[0])} + 0.5)`;
  }
};
Operators.ceil = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 1), assertNumbers(Z), `ceil(${expressionToGlsl(ie, Z[0])})`;
  }
};
Operators.sin = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 1), assertNumbers(Z), `sin(${expressionToGlsl(ie, Z[0])})`;
  }
};
Operators.cos = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 1), assertNumbers(Z), `cos(${expressionToGlsl(ie, Z[0])})`;
  }
};
Operators.atan = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsMinCount(Z, 1), assertArgsMaxCount(Z, 2), assertNumbers(Z), Z.length === 2 ? `atan(${expressionToGlsl(ie, Z[0])}, ${expressionToGlsl(
      ie,
      Z[1]
    )})` : `atan(${expressionToGlsl(ie, Z[0])})`;
  }
};
Operators.sqrt = {
  getReturnType: function() {
    return ValueTypes.NUMBER;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 1), assertNumbers(Z), `sqrt(${expressionToGlsl(ie, Z[0])})`;
  }
};
Operators[">"] = {
  getReturnType: function() {
    return ValueTypes.BOOLEAN;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 2), assertNumbers(Z), `(${expressionToGlsl(ie, Z[0])} > ${expressionToGlsl(
      ie,
      Z[1]
    )})`;
  }
};
Operators[">="] = {
  getReturnType: function() {
    return ValueTypes.BOOLEAN;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 2), assertNumbers(Z), `(${expressionToGlsl(ie, Z[0])} >= ${expressionToGlsl(
      ie,
      Z[1]
    )})`;
  }
};
Operators["<"] = {
  getReturnType: function() {
    return ValueTypes.BOOLEAN;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 2), assertNumbers(Z), `(${expressionToGlsl(ie, Z[0])} < ${expressionToGlsl(
      ie,
      Z[1]
    )})`;
  }
};
Operators["<="] = {
  getReturnType: function() {
    return ValueTypes.BOOLEAN;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 2), assertNumbers(Z), `(${expressionToGlsl(ie, Z[0])} <= ${expressionToGlsl(
      ie,
      Z[1]
    )})`;
  }
};
function getEqualOperator(ie) {
  return {
    getReturnType: function() {
      return ValueTypes.BOOLEAN;
    },
    toGlsl: function(Z, ee) {
      assertArgsCount(ee, 2);
      let ae = ValueTypes.ANY;
      for (let ve = 0; ve < ee.length; ve++)
        ae &= getValueType(ee[ve]);
      if (ae === ValueTypes.NONE)
        throw new Error(
          `All arguments should be of compatible type, got ${JSON.stringify(
            ee
          )} instead`
        );
      return ae &= ~ValueTypes.COLOR, `(${expressionToGlsl(
        Z,
        ee[0],
        ae
      )} ${ie} ${expressionToGlsl(Z, ee[1], ae)})`;
    }
  };
}
Operators["=="] = getEqualOperator("==");
Operators["!="] = getEqualOperator("!=");
Operators["!"] = {
  getReturnType: function() {
    return ValueTypes.BOOLEAN;
  },
  toGlsl: function(ie, Z) {
    return assertArgsCount(Z, 1), assertBoolean(Z[0]), `(!${expressionToGlsl(ie, Z[0], ValueTypes.BOOLEAN)})`;
  }
};
function getDecisionOperator(ie) {
  return {
    getReturnType: function() {
      return ValueTypes.BOOLEAN;
    },
    toGlsl: function(Z, ee) {
      assertArgsMinCount(ee, 2);
      for (let ve = 0; ve < ee.length; ve++)
        assertBoolean(ee[ve]);
      let ae = ee.map((ve) => expressionToGlsl(Z, ve, ValueTypes.BOOLEAN)).join(` ${ie} `);
      return ae = `(${ae})`, ae;
    }
  };
}
Operators.all = getDecisionOperator("&&");
Operators.any = getDecisionOperator("||");
Operators.between = {
  getReturnType: function() {
    return ValueTypes.BOOLEAN;
  },
  toGlsl: function(ie, Z) {
    assertArgsCount(Z, 3), assertNumbers(Z);
    const ee = expressionToGlsl(ie, Z[1]), ae = expressionToGlsl(ie, Z[2]), ve = expressionToGlsl(ie, Z[0]);
    return `(${ve} >= ${ee} && ${ve} <= ${ae})`;
  }
};
Operators.array = {
  getReturnType: function() {
    return ValueTypes.NUMBER_ARRAY;
  },
  toGlsl: function(ie, Z) {
    assertArgsMinCount(Z, 2), assertArgsMaxCount(Z, 4), assertNumbers(Z);
    const ee = Z.map(function(ae) {
      return expressionToGlsl(ie, ae);
    });
    return `vec${Z.length}(${ee.join(", ")})`;
  }
};
Operators.color = {
  getReturnType: function() {
    return ValueTypes.COLOR;
  },
  toGlsl: function(ie, Z) {
    assertArgsMinCount(Z, 3), assertArgsMaxCount(Z, 4), assertNumbers(Z);
    const ee = Z.slice(0, 3).map((ve) => `${expressionToGlsl(ie, ve)} / 255.0`);
    return Z.length === 3 ? `vec4(${ee.join(", ")}, 1.0)` : `(${expressionToGlsl(ie, Z[3])} * vec4(${ee.join(", ")}, 1.0))`;
  }
};
Operators.interpolate = {
  getReturnType: function(ie) {
    let Z = ValueTypes.COLOR | ValueTypes.NUMBER;
    for (let ee = 3; ee < ie.length; ee += 2)
      Z = Z & getValueType(ie[ee]);
    return Z;
  },
  toGlsl: function(ie, Z, ee) {
    assertArgsEven(Z), assertArgsMinCount(Z, 6);
    const ae = Z[0];
    let ve;
    switch (ae[0]) {
      case "linear":
        ve = 1;
        break;
      case "exponential":
        ve = ae[1];
        break;
      default:
        ve = null;
    }
    if (!ve)
      throw new Error(
        `Invalid interpolation type for "interpolate" operator, received: ${JSON.stringify(
          ae
        )}`
      );
    const ye = ValueTypes.NUMBER, be = Operators.interpolate.getReturnType(Z) & ee;
    assertSingleType(["interpolate", ...Z], be, "output");
    const Ye = expressionToGlsl(ie, Z[1], ye), Qe = numberToGlsl(ve);
    let Je = "";
    for (let nt = 2; nt < Z.length - 2; nt += 2) {
      const st = expressionToGlsl(ie, Z[nt], ye), ot = Je || expressionToGlsl(ie, Z[nt + 1], be), lt = expressionToGlsl(ie, Z[nt + 2], ye), ft = expressionToGlsl(ie, Z[nt + 3], be);
      let gt;
      ve === 1 ? gt = `(${Ye} - ${st}) / (${lt} - ${st})` : gt = `(pow(${Qe}, (${Ye} - ${st})) - 1.0) / (pow(${Qe}, (${lt} - ${st})) - 1.0)`, Je = `mix(${ot}, ${ft}, clamp(${gt}, 0.0, 1.0))`;
    }
    return Je;
  }
};
Operators.match = {
  getReturnType: function(ie) {
    let Z = ValueTypes.ANY;
    for (let ee = 2; ee < ie.length; ee += 2)
      Z = Z & getValueType(ie[ee]);
    return Z = Z & getValueType(ie[ie.length - 1]), Z;
  },
  toGlsl: function(ie, Z, ee) {
    assertArgsEven(Z), assertArgsMinCount(Z, 4);
    let ae = getValueType(Z[0]);
    for (let Qe = 1; Qe < Z.length - 1; Qe += 2)
      ae = ae & getValueType(Z[Qe]);
    assertOfType(
      ["match", ...Z],
      ae,
      ValueTypes.STRING | ValueTypes.NUMBER | ValueTypes.BOOLEAN,
      "input"
    ), ae = (ValueTypes.STRING | ValueTypes.NUMBER | ValueTypes.BOOLEAN) & ae;
    const ve = Operators.match.getReturnType(Z) & ee;
    assertSingleType(["match", ...Z], ve, "output");
    const ye = expressionToGlsl(ie, Z[0], ae), be = expressionToGlsl(
      ie,
      Z[Z.length - 1],
      ve
    );
    let Ye = null;
    for (let Qe = Z.length - 3; Qe >= 1; Qe -= 2) {
      const Je = expressionToGlsl(ie, Z[Qe], ae), nt = expressionToGlsl(ie, Z[Qe + 1], ve);
      Ye = `(${ye} == ${Je} ? ${nt} : ${Ye || be})`;
    }
    return Ye;
  }
};
Operators.case = {
  getReturnType: function(ie) {
    let Z = ValueTypes.ANY;
    for (let ee = 1; ee < ie.length; ee += 2)
      Z = Z & getValueType(ie[ee]);
    return Z = Z & getValueType(ie[ie.length - 1]), Z;
  },
  toGlsl: function(ie, Z, ee) {
    assertArgsOdd(Z), assertArgsMinCount(Z, 3);
    const ae = Operators.case.getReturnType(Z) & ee;
    assertSingleType(["case", ...Z], ae, "output");
    for (let be = 0; be < Z.length - 1; be += 2)
      assertBoolean(Z[be]);
    const ve = expressionToGlsl(
      ie,
      Z[Z.length - 1],
      ae
    );
    let ye = null;
    for (let be = Z.length - 3; be >= 0; be -= 2) {
      const Ye = expressionToGlsl(ie, Z[be], ValueTypes.BOOLEAN), Qe = expressionToGlsl(ie, Z[be + 1], ae);
      ye = `(${Ye} ? ${Qe} : ${ye || ve})`;
    }
    return ye;
  }
};
Operators.in = {
  getReturnType: function(ie) {
    return ValueTypes.BOOLEAN;
  },
  toGlsl: function(ie, Z) {
    assertArgsCount(Z, 2);
    const ee = Z[0];
    let ae = Z[1];
    if (!Array.isArray(ae))
      throw new Error(
        'The "in" operator expects an array literal as its second argument.'
      );
    if (typeof ae[0] == "string") {
      if (ae[0] !== "literal")
        throw new Error(
          'For the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions.'
        );
      if (!Array.isArray(ae[1]))
        throw new Error(
          'The "in" operator was provided a literal value which was not an array as second argument.'
        );
      ae = ae[1];
    }
    let ve = getValueType(ee);
    for (let Ye = 0; Ye < ae.length - 1; Ye += 1)
      ve = ve & getValueType(ae[Ye]);
    assertOfType(
      ["match", ...Z],
      ve,
      ValueTypes.STRING | ValueTypes.NUMBER | ValueTypes.BOOLEAN,
      "input"
    ), ve = (ValueTypes.STRING | ValueTypes.NUMBER | ValueTypes.BOOLEAN) & ve;
    const ye = computeOperatorFunctionName("in", ie), be = [];
    for (let Ye = 0; Ye < ae.length; Ye += 1)
      be.push(
        `  if (inputValue == ${expressionToGlsl(
          ie,
          ae[Ye],
          ve
        )}) { return true; }`
      );
    return ie.functions[ye] = `bool ${ye}(float inputValue) {
${be.join(`
`)}
  return false;
}`, `${ye}(${expressionToGlsl(ie, ee, ve)})`;
  }
};
function parseStyle(ie, Z) {
  const ee = `
    attribute vec2 ${Attributes.TEXTURE_COORD};
    uniform mat4 ${Uniforms.TILE_TRANSFORM};
    uniform float ${Uniforms.TEXTURE_PIXEL_WIDTH};
    uniform float ${Uniforms.TEXTURE_PIXEL_HEIGHT};
    uniform float ${Uniforms.TEXTURE_RESOLUTION};
    uniform float ${Uniforms.TEXTURE_ORIGIN_X};
    uniform float ${Uniforms.TEXTURE_ORIGIN_Y};
    uniform float ${Uniforms.DEPTH};

    varying vec2 v_textureCoord;
    varying vec2 v_mapCoord;

    void main() {
      v_textureCoord = ${Attributes.TEXTURE_COORD};
      v_mapCoord = vec2(
        ${Uniforms.TEXTURE_ORIGIN_X} + ${Uniforms.TEXTURE_RESOLUTION} * ${Uniforms.TEXTURE_PIXEL_WIDTH} * v_textureCoord[0],
        ${Uniforms.TEXTURE_ORIGIN_Y} - ${Uniforms.TEXTURE_RESOLUTION} * ${Uniforms.TEXTURE_PIXEL_HEIGHT} * v_textureCoord[1]
      );
      gl_Position = ${Uniforms.TILE_TRANSFORM} * vec4(${Attributes.TEXTURE_COORD}, ${Uniforms.DEPTH}, 1.0);
    }
  `, ae = {
    inFragmentShader: !0,
    variables: [],
    attributes: [],
    functions: {},
    bandCount: Z,
    style: ie
  }, ve = [];
  if (ie.color !== void 0) {
    const st = expressionToGlsl(ae, ie.color, ValueTypes.COLOR);
    ve.push(`color = ${st};`);
  }
  if (ie.contrast !== void 0) {
    const st = expressionToGlsl(
      ae,
      ie.contrast,
      ValueTypes.NUMBER
    );
    ve.push(
      `color.rgb = clamp((${st} + 1.0) * color.rgb - (${st} / 2.0), vec3(0.0, 0.0, 0.0), vec3(1.0, 1.0, 1.0));`
    );
  }
  if (ie.exposure !== void 0) {
    const st = expressionToGlsl(
      ae,
      ie.exposure,
      ValueTypes.NUMBER
    );
    ve.push(
      `color.rgb = clamp((${st} + 1.0) * color.rgb, vec3(0.0, 0.0, 0.0), vec3(1.0, 1.0, 1.0));`
    );
  }
  if (ie.saturation !== void 0) {
    const st = expressionToGlsl(
      ae,
      ie.saturation,
      ValueTypes.NUMBER
    );
    ve.push(`
      float saturation = ${st} + 1.0;
      float sr = (1.0 - saturation) * 0.2126;
      float sg = (1.0 - saturation) * 0.7152;
      float sb = (1.0 - saturation) * 0.0722;
      mat3 saturationMatrix = mat3(
        sr + saturation, sr, sr,
        sg, sg + saturation, sg,
        sb, sb, sb + saturation
      );
      color.rgb = clamp(saturationMatrix * color.rgb, vec3(0.0, 0.0, 0.0), vec3(1.0, 1.0, 1.0));
    `);
  }
  if (ie.gamma !== void 0) {
    const st = expressionToGlsl(ae, ie.gamma, ValueTypes.NUMBER);
    ve.push(`color.rgb = pow(color.rgb, vec3(1.0 / ${st}));`);
  }
  if (ie.brightness !== void 0) {
    const st = expressionToGlsl(
      ae,
      ie.brightness,
      ValueTypes.NUMBER
    );
    ve.push(
      `color.rgb = clamp(color.rgb + ${st}, vec3(0.0, 0.0, 0.0), vec3(1.0, 1.0, 1.0));`
    );
  }
  const ye = {}, be = ae.variables.length;
  if (be > 1 && !ie.variables)
    throw new Error(
      `Missing variables in style (expected ${ae.variables})`
    );
  for (let st = 0; st < be; ++st) {
    const ot = ae.variables[st];
    if (!(ot.name in ie.variables))
      throw new Error(`Missing '${ot.name}' in style variables`);
    const lt = uniformNameForVariable(ot.name);
    ye[lt] = function() {
      let ft = ie.variables[ot.name];
      return typeof ft == "string" && (ft = getStringNumberEquivalent(ft)), ft !== void 0 ? ft : -9999999;
    };
  }
  const Ye = Object.keys(ye).map(function(st) {
    return `uniform float ${st};`;
  }), Qe = Math.ceil(Z / 4);
  Ye.push(
    `uniform sampler2D ${Uniforms.TILE_TEXTURE_ARRAY}[${Qe}];`
  ), ae.paletteTextures && Ye.push(
    `uniform sampler2D ${PALETTE_TEXTURE_ARRAY}[${ae.paletteTextures.length}];`
  );
  const Je = Object.keys(ae.functions).map(function(st) {
    return ae.functions[st];
  }), nt = `
    #ifdef GL_FRAGMENT_PRECISION_HIGH
    precision highp float;
    #else
    precision mediump float;
    #endif

    varying vec2 v_textureCoord;
    varying vec2 v_mapCoord;
    uniform vec4 ${Uniforms.RENDER_EXTENT};
    uniform float ${Uniforms.TRANSITION_ALPHA};
    uniform float ${Uniforms.TEXTURE_PIXEL_WIDTH};
    uniform float ${Uniforms.TEXTURE_PIXEL_HEIGHT};
    uniform float ${Uniforms.RESOLUTION};
    uniform float ${Uniforms.ZOOM};

    ${Ye.join(`
`)}

    ${Je.join(`
`)}

    void main() {
      if (
        v_mapCoord[0] < ${Uniforms.RENDER_EXTENT}[0] ||
        v_mapCoord[1] < ${Uniforms.RENDER_EXTENT}[1] ||
        v_mapCoord[0] > ${Uniforms.RENDER_EXTENT}[2] ||
        v_mapCoord[1] > ${Uniforms.RENDER_EXTENT}[3]
      ) {
        discard;
      }

      vec4 color = texture2D(${Uniforms.TILE_TEXTURE_ARRAY}[0],  v_textureCoord);

      ${ve.join(`
`)}

      gl_FragColor = color;
      gl_FragColor.rgb *= gl_FragColor.a;
      gl_FragColor *= ${Uniforms.TRANSITION_ALPHA};
    }`;
  return {
    vertexShader: ee,
    fragmentShader: nt,
    uniforms: ye,
    paletteTextures: ae.paletteTextures
  };
}
class WebGLTileLayer extends BaseTileLayer {
  /**
   * @param {Options} options Tile layer options.
   */
  constructor(Z) {
    Z = Z ? Object.assign({}, Z) : {};
    const ee = Z.style || {};
    delete Z.style;
    const ae = Z.cacheSize;
    delete Z.cacheSize, super(Z), this.sources_ = Z.sources, this.renderedSource_ = null, this.renderedResolution_ = NaN, this.style_ = ee, this.cacheSize_ = ae, this.styleVariables_ = this.style_.variables || {}, this.addChangeListener(LayerProperty.SOURCE, this.handleSourceUpdate_);
  }
  /**
   * Gets the sources for this layer, for a given extent and resolution.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @return {Array<SourceType>} Sources.
   */
  getSources(Z, ee) {
    const ae = this.getSource();
    return this.sources_ ? typeof this.sources_ == "function" ? this.sources_(Z, ee) : this.sources_ : ae ? [ae] : [];
  }
  /**
   * @return {SourceType} The source being rendered.
   */
  getRenderSource() {
    return this.renderedSource_ || this.getSource();
  }
  /**
   * @return {import("../source/Source.js").State} Source state.
   */
  getSourceState() {
    const Z = this.getRenderSource();
    return Z ? Z.getState() : "undefined";
  }
  /**
   * @private
   */
  handleSourceUpdate_() {
    this.hasRenderer() && this.getRenderer().clearCache(), this.getSource() && this.setStyle(this.style_);
  }
  /**
   * @private
   * @return {number} The number of source bands.
   */
  getSourceBandCount_() {
    const Z = Number.MAX_SAFE_INTEGER, ee = this.getSources([-Z, -Z, Z, Z], Z);
    return ee && ee.length && "bandCount" in ee[0] ? ee[0].bandCount : 4;
  }
  createRenderer() {
    const Z = parseStyle(this.style_, this.getSourceBandCount_());
    return new WebGLTileLayerRenderer(this, {
      vertexShader: Z.vertexShader,
      fragmentShader: Z.fragmentShader,
      uniforms: Z.uniforms,
      cacheSize: this.cacheSize_,
      paletteTextures: Z.paletteTextures
    });
  }
  /**
   * @param {import("../Map").FrameState} frameState Frame state.
   * @param {Array<SourceType>} sources Sources.
   * @return {HTMLElement} Canvas.
   */
  renderSources(Z, ee) {
    const ae = this.getRenderer();
    let ve;
    for (let ye = 0, be = ee.length; ye < be; ++ye)
      this.renderedSource_ = ee[ye], ae.prepareFrame(Z) && (ve = ae.renderFrame(Z));
    return ve;
  }
  /**
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement} The rendered element.
   */
  render(Z, ee) {
    this.rendered = !0;
    const ae = Z.viewState, ve = this.getSources(Z.extent, ae.resolution);
    let ye = !0;
    for (let Ye = 0, Qe = ve.length; Ye < Qe; ++Ye) {
      const Je = ve[Ye], nt = Je.getState();
      if (nt == "loading") {
        const st = () => {
          Je.getState() == "ready" && (Je.removeEventListener("change", st), this.changed());
        };
        Je.addEventListener("change", st);
      }
      ye = ye && nt == "ready";
    }
    const be = this.renderSources(Z, ve);
    if (this.getRenderer().renderComplete && ye)
      return this.renderedResolution_ = ae.resolution, be;
    if (this.renderedResolution_ > 0.5 * ae.resolution) {
      const Ye = this.getSources(
        Z.extent,
        this.renderedResolution_
      ).filter((Qe) => !ve.includes(Qe));
      if (Ye.length > 0)
        return this.renderSources(Z, Ye);
    }
    return be;
  }
  /**
   * Update the layer style.  The `updateStyleVariables` function is a more efficient
   * way to update layer rendering.  In cases where the whole style needs to be updated,
   * this method may be called instead.  Note that calling this method will also replace
   * any previously set variables, so the new style also needs to include new variables,
   * if needed.
   * @param {Style} style The new style.
   */
  setStyle(Z) {
    this.styleVariables_ = Z.variables || {}, this.style_ = Z;
    const ee = parseStyle(this.style_, this.getSourceBandCount_());
    this.getRenderer().reset({
      vertexShader: ee.vertexShader,
      fragmentShader: ee.fragmentShader,
      uniforms: ee.uniforms
    }), this.changed();
  }
  /**
   * Update any variables used by the layer style and trigger a re-render.
   * @param {Object<string, number>} variables Variables to update.
   * @api
   */
  updateStyleVariables(Z) {
    Object.assign(this.styleVariables_, Z), this.changed();
  }
}
WebGLTileLayer.prototype.dispose;
const events = [
  "fullscreenchange",
  "webkitfullscreenchange",
  "MSFullscreenChange"
], FullScreenEventType = {
  /**
   * Triggered after the map entered fullscreen.
   * @event FullScreenEventType#enterfullscreen
   * @api
   */
  ENTERFULLSCREEN: "enterfullscreen",
  /**
   * Triggered after the map leave fullscreen.
   * @event FullScreenEventType#leavefullscreen
   * @api
   */
  LEAVEFULLSCREEN: "leavefullscreen"
};
class FullScreen extends Control {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    Z = Z || {}, super({
      element: document.createElement("div"),
      target: Z.target
    }), this.on, this.once, this.un, this.keys_ = Z.keys !== void 0 ? Z.keys : !1, this.source_ = Z.source, this.isInFullscreen_ = !1, this.boundHandleMapTargetChange_ = this.handleMapTargetChange_.bind(this), this.cssClassName_ = Z.className !== void 0 ? Z.className : "ol-full-screen", this.documentListeners_ = [], this.activeClassName_ = Z.activeClassName !== void 0 ? Z.activeClassName.split(" ") : [this.cssClassName_ + "-true"], this.inactiveClassName_ = Z.inactiveClassName !== void 0 ? Z.inactiveClassName.split(" ") : [this.cssClassName_ + "-false"];
    const ee = Z.label !== void 0 ? Z.label : "⤢";
    this.labelNode_ = typeof ee == "string" ? document.createTextNode(ee) : ee;
    const ae = Z.labelActive !== void 0 ? Z.labelActive : "×";
    this.labelActiveNode_ = typeof ae == "string" ? document.createTextNode(ae) : ae;
    const ve = Z.tipLabel ? Z.tipLabel : "Toggle full-screen";
    this.button_ = document.createElement("button"), this.button_.title = ve, this.button_.setAttribute("type", "button"), this.button_.appendChild(this.labelNode_), this.button_.addEventListener(
      EventType.CLICK,
      this.handleClick_.bind(this),
      !1
    ), this.setClassName_(this.button_, this.isInFullscreen_), this.element.className = `${this.cssClassName_} ${CLASS_UNSELECTABLE} ${CLASS_CONTROL}`, this.element.appendChild(this.button_);
  }
  /**
   * @param {MouseEvent} event The event to handle
   * @private
   */
  handleClick_(Z) {
    Z.preventDefault(), this.handleFullScreen_();
  }
  /**
   * @private
   */
  handleFullScreen_() {
    const Z = this.getMap();
    if (!Z)
      return;
    const ee = Z.getOwnerDocument();
    if (isFullScreenSupported(ee))
      if (isFullScreen(ee))
        exitFullScreen(ee);
      else {
        let ae;
        this.source_ ? ae = typeof this.source_ == "string" ? ee.getElementById(this.source_) : this.source_ : ae = Z.getTargetElement(), this.keys_ ? requestFullScreenWithKeys(ae) : requestFullScreen(ae);
      }
  }
  /**
   * @private
   */
  handleFullScreenChange_() {
    const Z = this.getMap();
    if (!Z)
      return;
    const ee = this.isInFullscreen_;
    this.isInFullscreen_ = isFullScreen(Z.getOwnerDocument()), ee !== this.isInFullscreen_ && (this.setClassName_(this.button_, this.isInFullscreen_), this.isInFullscreen_ ? (replaceNode(this.labelActiveNode_, this.labelNode_), this.dispatchEvent(FullScreenEventType.ENTERFULLSCREEN)) : (replaceNode(this.labelNode_, this.labelActiveNode_), this.dispatchEvent(FullScreenEventType.LEAVEFULLSCREEN)), Z.updateSize());
  }
  /**
   * @param {HTMLElement} element Target element
   * @param {boolean} fullscreen True if fullscreen class name should be active
   * @private
   */
  setClassName_(Z, ee) {
    ee ? (Z.classList.remove(...this.inactiveClassName_), Z.classList.add(...this.activeClassName_)) : (Z.classList.remove(...this.activeClassName_), Z.classList.add(...this.inactiveClassName_));
  }
  /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */
  setMap(Z) {
    const ee = this.getMap();
    ee && ee.removeChangeListener(
      MapProperty.TARGET,
      this.boundHandleMapTargetChange_
    ), super.setMap(Z), this.handleMapTargetChange_(), Z && Z.addChangeListener(
      MapProperty.TARGET,
      this.boundHandleMapTargetChange_
    );
  }
  /**
   * @private
   */
  handleMapTargetChange_() {
    const Z = this.documentListeners_;
    for (let ae = 0, ve = Z.length; ae < ve; ++ae)
      unlistenByKey(Z[ae]);
    Z.length = 0;
    const ee = this.getMap();
    if (ee) {
      const ae = ee.getOwnerDocument();
      isFullScreenSupported(ae) ? this.element.classList.remove(CLASS_UNSUPPORTED) : this.element.classList.add(CLASS_UNSUPPORTED);
      for (let ve = 0, ye = events.length; ve < ye; ++ve)
        Z.push(
          listen(ae, events[ve], this.handleFullScreenChange_, this)
        );
      this.handleFullScreenChange_();
    }
  }
}
function isFullScreenSupported(ie) {
  const Z = ie.body;
  return !!(Z.webkitRequestFullscreen || Z.requestFullscreen && ie.fullscreenEnabled);
}
function isFullScreen(ie) {
  return !!(ie.webkitIsFullScreen || ie.fullscreenElement);
}
function requestFullScreen(ie) {
  ie.requestFullscreen ? ie.requestFullscreen() : ie.webkitRequestFullscreen && ie.webkitRequestFullscreen();
}
function requestFullScreenWithKeys(ie) {
  ie.webkitRequestFullscreen ? ie.webkitRequestFullscreen() : requestFullScreen(ie);
}
function exitFullScreen(ie) {
  ie.exitFullscreen ? ie.exitFullscreen() : ie.webkitExitFullscreen && ie.webkitExitFullscreen();
}
class VectorTile extends UrlTile {
  /**
   * @param {!Options} options Vector tile options.
   */
  constructor(Z) {
    const ee = Z.projection || "EPSG:3857", ae = Z.extent || extentFromProjection(ee), ve = Z.tileGrid || createXYZ({
      extent: ae,
      maxResolution: Z.maxResolution,
      maxZoom: Z.maxZoom !== void 0 ? Z.maxZoom : 22,
      minZoom: Z.minZoom,
      tileSize: Z.tileSize || 512
    });
    super({
      attributions: Z.attributions,
      attributionsCollapsible: Z.attributionsCollapsible,
      cacheSize: Z.cacheSize,
      interpolate: !0,
      opaque: !1,
      projection: ee,
      state: Z.state,
      tileGrid: ve,
      tileLoadFunction: Z.tileLoadFunction ? Z.tileLoadFunction : defaultLoadFunction,
      tileUrlFunction: Z.tileUrlFunction,
      url: Z.url,
      urls: Z.urls,
      wrapX: Z.wrapX === void 0 ? !0 : Z.wrapX,
      transition: Z.transition,
      zDirection: Z.zDirection === void 0 ? 1 : Z.zDirection
    }), this.format_ = Z.format ? Z.format : null, this.sourceTileCache = new TileCache(this.tileCache.highWaterMark), this.overlaps_ = Z.overlaps == null ? !0 : Z.overlaps, this.tileClass = Z.tileClass ? Z.tileClass : VectorTile$1, this.tileGrids_ = {};
  }
  /**
   * Get features whose bounding box intersects the provided extent. Only features for cached
   * tiles for the last rendered zoom level are available in the source. So this method is only
   * suitable for requesting tiles for extents that are currently rendered.
   *
   * Features are returned in random tile order and as they are included in the tiles. This means
   * they can be clipped, duplicated across tiles, and simplified to the render resolution.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<import("../Feature.js").FeatureLike>} Features.
   * @api
   */
  getFeaturesInExtent(Z) {
    const ee = [], ae = this.tileCache;
    if (ae.getCount() === 0)
      return ee;
    const ve = fromKey(ae.peekFirstKey())[0], ye = this.tileGrid;
    return ae.forEach(function(be) {
      if (be.tileCoord[0] !== ve || be.getState() !== TileState.LOADED)
        return;
      const Ye = be.getSourceTiles();
      for (let Qe = 0, Je = Ye.length; Qe < Je; ++Qe) {
        const nt = Ye[Qe], st = nt.tileCoord;
        if (intersects$1(Z, ye.getTileCoordExtent(st))) {
          const ot = nt.getFeatures();
          if (ot)
            for (let lt = 0, ft = ot.length; lt < ft; ++lt) {
              const gt = ot[lt], ct = gt.getGeometry();
              intersects$1(Z, ct.getExtent()) && ee.push(gt);
            }
        }
      }
    }), ee;
  }
  /**
   * @return {boolean} The source can have overlapping geometries.
   */
  getOverlaps() {
    return this.overlaps_;
  }
  /**
   * clear {@link module:ol/TileCache~TileCache} and delete all source tiles
   * @api
   */
  clear() {
    this.tileCache.clear(), this.sourceTileCache.clear();
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */
  expireCache(Z, ee) {
    const ae = this.getTileCacheForProjection(Z), ve = Object.keys(ee).reduce((ye, be) => {
      const Ye = getCacheKeyForTileKey(be), Qe = ae.peek(Ye);
      if (Qe) {
        const Je = Qe.sourceTiles;
        for (let nt = 0, st = Je.length; nt < st; ++nt)
          ye[Je[nt].getKey()] = !0;
      }
      return ye;
    }, {});
    super.expireCache(Z, ee), this.sourceTileCache.expireCache(ve);
  }
  /**
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection").default} projection Projection.
   * @param {VectorRenderTile} tile Vector image tile.
   * @return {Array<import("../VectorTile").default>} Tile keys.
   */
  getSourceTiles(Z, ee, ae) {
    if (ae.getState() === TileState.IDLE) {
      ae.setState(TileState.LOADING);
      const ve = ae.wrappedTileCoord, ye = this.getTileGridForProjection(ee), be = ye.getTileCoordExtent(ve), Ye = ve[0], Qe = ye.getResolution(Ye);
      buffer$1(be, -Qe, be);
      const Je = this.tileGrid, nt = Je.getExtent();
      nt && getIntersection(be, nt, be);
      const st = Je.getZForResolution(
        Qe,
        this.zDirection
      );
      Je.forEachTileCoord(be, st, (ot) => {
        const lt = this.tileUrlFunction(
          ot,
          Z,
          ee
        ), ft = this.sourceTileCache.containsKey(lt) ? this.sourceTileCache.get(lt) : new this.tileClass(
          ot,
          lt ? TileState.IDLE : TileState.EMPTY,
          lt,
          this.format_,
          this.tileLoadFunction
        );
        ae.sourceTiles.push(ft);
        const gt = ft.getState();
        if (gt < TileState.LOADED) {
          const ct = (_r) => {
            this.handleTileChange(_r);
            const Kr = ft.getState();
            if (Kr === TileState.LOADED || Kr === TileState.ERROR) {
              const Xr = ft.getKey();
              Xr in ae.errorTileKeys ? ft.getState() === TileState.LOADED && delete ae.errorTileKeys[Xr] : ae.loadingSourceTiles--, Kr === TileState.ERROR ? ae.errorTileKeys[Xr] = !0 : ft.removeEventListener(EventType.CHANGE, ct), ae.loadingSourceTiles === 0 && ae.setState(
                isEmpty$1(ae.errorTileKeys) ? TileState.LOADED : TileState.ERROR
              );
            }
          };
          ft.addEventListener(EventType.CHANGE, ct), ae.loadingSourceTiles++;
        }
        gt === TileState.IDLE && (ft.extent = Je.getTileCoordExtent(ot), ft.projection = ee, ft.resolution = Je.getResolution(
          ot[0]
        ), this.sourceTileCache.set(lt, ft), ft.load());
      }), ae.loadingSourceTiles || ae.setState(
        ae.sourceTiles.some(
          (ot) => ot.getState() === TileState.ERROR
        ) ? TileState.ERROR : TileState.LOADED
      );
    }
    return ae.sourceTiles;
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!VectorRenderTile} Tile.
   */
  getTile(Z, ee, ae, ve, ye) {
    const be = getKeyZXY(Z, ee, ae), Ye = this.getKey();
    let Qe;
    if (this.tileCache.containsKey(be) && (Qe = this.tileCache.get(be), Qe.key === Ye))
      return Qe;
    const Je = [Z, ee, ae];
    let nt = this.getTileCoordForTileUrlFunction(
      Je,
      ye
    );
    const st = this.getTileGrid().getExtent(), ot = this.getTileGridForProjection(ye);
    if (nt && st) {
      const gt = ot.getTileCoordExtent(nt);
      buffer$1(gt, -ot.getResolution(Z), gt), intersects$1(st, gt) || (nt = null);
    }
    let lt = !0;
    if (nt !== null) {
      const gt = this.tileGrid, ct = ot.getResolution(Z), _r = gt.getZForResolution(ct, 1), Kr = ot.getTileCoordExtent(nt);
      buffer$1(Kr, -ct, Kr), gt.forEachTileCoord(Kr, _r, (Xr) => {
        lt = lt && !this.tileUrlFunction(Xr, ve, ye);
      });
    }
    const ft = new VectorRenderTile(
      Je,
      lt ? TileState.EMPTY : TileState.IDLE,
      nt,
      this.getSourceTiles.bind(this, ve, ye)
    );
    return ft.key = Ye, Qe ? (ft.interimTile = Qe, ft.refreshInterimChain(), this.tileCache.replace(be, ft)) : this.tileCache.set(be, ft), ft;
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */
  getTileGridForProjection(Z) {
    const ee = Z.getCode();
    let ae = this.tileGrids_[ee];
    if (!ae) {
      const ve = this.tileGrid, ye = ve.getResolutions().slice(), be = ye.map(function(Je, nt) {
        return ve.getOrigin(nt);
      }), Ye = ye.map(function(Je, nt) {
        return ve.getTileSize(nt);
      }), Qe = DEFAULT_MAX_ZOOM + 1;
      for (let Je = ye.length; Je < Qe; ++Je)
        ye.push(ye[Je - 1] / 2), be.push(be[Je - 1]), Ye.push(Ye[Je - 1]);
      ae = new TileGrid({
        extent: ve.getExtent(),
        origins: be,
        resolutions: ye,
        tileSizes: Ye
      }), this.tileGrids_[ee] = ae;
    }
    return ae;
  }
  /**
   * Get the tile pixel ratio for this source.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */
  getTilePixelRatio(Z) {
    return Z;
  }
  /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */
  getTilePixelSize(Z, ee, ae) {
    const ve = this.getTileGridForProjection(ae), ye = toSize(ve.getTileSize(Z), this.tmpSize);
    return [
      Math.round(ye[0] * ee),
      Math.round(ye[1] * ee)
    ];
  }
  /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */
  updateCacheSize(Z, ee) {
    super.updateCacheSize(Z * 2, ee), this.sourceTileCache.highWaterMark = this.getTileCacheForProjection(ee).highWaterMark;
  }
}
function defaultLoadFunction(ie, Z) {
  ie.setLoader(
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */
    function(ee, ae, ve) {
      loadFeaturesXhr(
        Z,
        ie.getFormat(),
        ee,
        ae,
        ve,
        ie.onLoad.bind(ie),
        ie.onError.bind(ie)
      );
    }
  );
}
var ieee754$1 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754$1.read = function(ie, Z, ee, ae, ve) {
  var ye, be, Ye = ve * 8 - ae - 1, Qe = (1 << Ye) - 1, Je = Qe >> 1, nt = -7, st = ee ? ve - 1 : 0, ot = ee ? -1 : 1, lt = ie[Z + st];
  for (st += ot, ye = lt & (1 << -nt) - 1, lt >>= -nt, nt += Ye; nt > 0; ye = ye * 256 + ie[Z + st], st += ot, nt -= 8)
    ;
  for (be = ye & (1 << -nt) - 1, ye >>= -nt, nt += ae; nt > 0; be = be * 256 + ie[Z + st], st += ot, nt -= 8)
    ;
  if (ye === 0)
    ye = 1 - Je;
  else {
    if (ye === Qe)
      return be ? NaN : (lt ? -1 : 1) * (1 / 0);
    be = be + Math.pow(2, ae), ye = ye - Je;
  }
  return (lt ? -1 : 1) * be * Math.pow(2, ye - ae);
};
ieee754$1.write = function(ie, Z, ee, ae, ve, ye) {
  var be, Ye, Qe, Je = ye * 8 - ve - 1, nt = (1 << Je) - 1, st = nt >> 1, ot = ve === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, lt = ae ? 0 : ye - 1, ft = ae ? 1 : -1, gt = Z < 0 || Z === 0 && 1 / Z < 0 ? 1 : 0;
  for (Z = Math.abs(Z), isNaN(Z) || Z === 1 / 0 ? (Ye = isNaN(Z) ? 1 : 0, be = nt) : (be = Math.floor(Math.log(Z) / Math.LN2), Z * (Qe = Math.pow(2, -be)) < 1 && (be--, Qe *= 2), be + st >= 1 ? Z += ot / Qe : Z += ot * Math.pow(2, 1 - st), Z * Qe >= 2 && (be++, Qe /= 2), be + st >= nt ? (Ye = 0, be = nt) : be + st >= 1 ? (Ye = (Z * Qe - 1) * Math.pow(2, ve), be = be + st) : (Ye = Z * Math.pow(2, st - 1) * Math.pow(2, ve), be = 0)); ve >= 8; ie[ee + lt] = Ye & 255, lt += ft, Ye /= 256, ve -= 8)
    ;
  for (be = be << ve | Ye, Je += ve; Je > 0; ie[ee + lt] = be & 255, lt += ft, be /= 256, Je -= 8)
    ;
  ie[ee + lt - ft] |= gt * 128;
};
var pbf = Pbf, ieee754 = ieee754$1;
function Pbf(ie) {
  this.buf = ArrayBuffer.isView && ArrayBuffer.isView(ie) ? ie : new Uint8Array(ie || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
}
Pbf.Varint = 0;
Pbf.Fixed64 = 1;
Pbf.Bytes = 2;
Pbf.Fixed32 = 5;
var SHIFT_LEFT_32 = 65536 * 65536, SHIFT_RIGHT_32 = 1 / SHIFT_LEFT_32, TEXT_DECODER_MIN_LENGTH = 12, utf8TextDecoder = typeof TextDecoder > "u" ? null : new TextDecoder("utf8");
Pbf.prototype = {
  destroy: function() {
    this.buf = null;
  },
  // === READING =================================================================
  readFields: function(ie, Z, ee) {
    for (ee = ee || this.length; this.pos < ee; ) {
      var ae = this.readVarint(), ve = ae >> 3, ye = this.pos;
      this.type = ae & 7, ie(ve, Z, this), this.pos === ye && this.skip(ae);
    }
    return Z;
  },
  readMessage: function(ie, Z) {
    return this.readFields(ie, Z, this.readVarint() + this.pos);
  },
  readFixed32: function() {
    var ie = readUInt32(this.buf, this.pos);
    return this.pos += 4, ie;
  },
  readSFixed32: function() {
    var ie = readInt32(this.buf, this.pos);
    return this.pos += 4, ie;
  },
  // 64-bit int handling is based on github.com/dpw/node-buffer-more-ints (MIT-licensed)
  readFixed64: function() {
    var ie = readUInt32(this.buf, this.pos) + readUInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
    return this.pos += 8, ie;
  },
  readSFixed64: function() {
    var ie = readUInt32(this.buf, this.pos) + readInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
    return this.pos += 8, ie;
  },
  readFloat: function() {
    var ie = ieee754.read(this.buf, this.pos, !0, 23, 4);
    return this.pos += 4, ie;
  },
  readDouble: function() {
    var ie = ieee754.read(this.buf, this.pos, !0, 52, 8);
    return this.pos += 8, ie;
  },
  readVarint: function(ie) {
    var Z = this.buf, ee, ae;
    return ae = Z[this.pos++], ee = ae & 127, ae < 128 || (ae = Z[this.pos++], ee |= (ae & 127) << 7, ae < 128) || (ae = Z[this.pos++], ee |= (ae & 127) << 14, ae < 128) || (ae = Z[this.pos++], ee |= (ae & 127) << 21, ae < 128) ? ee : (ae = Z[this.pos], ee |= (ae & 15) << 28, readVarintRemainder$1(ee, ie, this));
  },
  readVarint64: function() {
    return this.readVarint(!0);
  },
  readSVarint: function() {
    var ie = this.readVarint();
    return ie % 2 === 1 ? (ie + 1) / -2 : ie / 2;
  },
  readBoolean: function() {
    return !!this.readVarint();
  },
  readString: function() {
    var ie = this.readVarint() + this.pos, Z = this.pos;
    return this.pos = ie, ie - Z >= TEXT_DECODER_MIN_LENGTH && utf8TextDecoder ? readUtf8TextDecoder(this.buf, Z, ie) : readUtf8(this.buf, Z, ie);
  },
  readBytes: function() {
    var ie = this.readVarint() + this.pos, Z = this.buf.subarray(this.pos, ie);
    return this.pos = ie, Z;
  },
  // verbose for performance reasons; doesn't affect gzipped size
  readPackedVarint: function(ie, Z) {
    if (this.type !== Pbf.Bytes)
      return ie.push(this.readVarint(Z));
    var ee = readPackedEnd(this);
    for (ie = ie || []; this.pos < ee; )
      ie.push(this.readVarint(Z));
    return ie;
  },
  readPackedSVarint: function(ie) {
    if (this.type !== Pbf.Bytes)
      return ie.push(this.readSVarint());
    var Z = readPackedEnd(this);
    for (ie = ie || []; this.pos < Z; )
      ie.push(this.readSVarint());
    return ie;
  },
  readPackedBoolean: function(ie) {
    if (this.type !== Pbf.Bytes)
      return ie.push(this.readBoolean());
    var Z = readPackedEnd(this);
    for (ie = ie || []; this.pos < Z; )
      ie.push(this.readBoolean());
    return ie;
  },
  readPackedFloat: function(ie) {
    if (this.type !== Pbf.Bytes)
      return ie.push(this.readFloat());
    var Z = readPackedEnd(this);
    for (ie = ie || []; this.pos < Z; )
      ie.push(this.readFloat());
    return ie;
  },
  readPackedDouble: function(ie) {
    if (this.type !== Pbf.Bytes)
      return ie.push(this.readDouble());
    var Z = readPackedEnd(this);
    for (ie = ie || []; this.pos < Z; )
      ie.push(this.readDouble());
    return ie;
  },
  readPackedFixed32: function(ie) {
    if (this.type !== Pbf.Bytes)
      return ie.push(this.readFixed32());
    var Z = readPackedEnd(this);
    for (ie = ie || []; this.pos < Z; )
      ie.push(this.readFixed32());
    return ie;
  },
  readPackedSFixed32: function(ie) {
    if (this.type !== Pbf.Bytes)
      return ie.push(this.readSFixed32());
    var Z = readPackedEnd(this);
    for (ie = ie || []; this.pos < Z; )
      ie.push(this.readSFixed32());
    return ie;
  },
  readPackedFixed64: function(ie) {
    if (this.type !== Pbf.Bytes)
      return ie.push(this.readFixed64());
    var Z = readPackedEnd(this);
    for (ie = ie || []; this.pos < Z; )
      ie.push(this.readFixed64());
    return ie;
  },
  readPackedSFixed64: function(ie) {
    if (this.type !== Pbf.Bytes)
      return ie.push(this.readSFixed64());
    var Z = readPackedEnd(this);
    for (ie = ie || []; this.pos < Z; )
      ie.push(this.readSFixed64());
    return ie;
  },
  skip: function(ie) {
    var Z = ie & 7;
    if (Z === Pbf.Varint)
      for (; this.buf[this.pos++] > 127; )
        ;
    else if (Z === Pbf.Bytes)
      this.pos = this.readVarint() + this.pos;
    else if (Z === Pbf.Fixed32)
      this.pos += 4;
    else if (Z === Pbf.Fixed64)
      this.pos += 8;
    else
      throw new Error("Unimplemented type: " + Z);
  },
  // === WRITING =================================================================
  writeTag: function(ie, Z) {
    this.writeVarint(ie << 3 | Z);
  },
  realloc: function(ie) {
    for (var Z = this.length || 16; Z < this.pos + ie; )
      Z *= 2;
    if (Z !== this.length) {
      var ee = new Uint8Array(Z);
      ee.set(this.buf), this.buf = ee, this.length = Z;
    }
  },
  finish: function() {
    return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
  },
  writeFixed32: function(ie) {
    this.realloc(4), writeInt32(this.buf, ie, this.pos), this.pos += 4;
  },
  writeSFixed32: function(ie) {
    this.realloc(4), writeInt32(this.buf, ie, this.pos), this.pos += 4;
  },
  writeFixed64: function(ie) {
    this.realloc(8), writeInt32(this.buf, ie & -1, this.pos), writeInt32(this.buf, Math.floor(ie * SHIFT_RIGHT_32), this.pos + 4), this.pos += 8;
  },
  writeSFixed64: function(ie) {
    this.realloc(8), writeInt32(this.buf, ie & -1, this.pos), writeInt32(this.buf, Math.floor(ie * SHIFT_RIGHT_32), this.pos + 4), this.pos += 8;
  },
  writeVarint: function(ie) {
    if (ie = +ie || 0, ie > 268435455 || ie < 0) {
      writeBigVarint(ie, this);
      return;
    }
    this.realloc(4), this.buf[this.pos++] = ie & 127 | (ie > 127 ? 128 : 0), !(ie <= 127) && (this.buf[this.pos++] = (ie >>>= 7) & 127 | (ie > 127 ? 128 : 0), !(ie <= 127) && (this.buf[this.pos++] = (ie >>>= 7) & 127 | (ie > 127 ? 128 : 0), !(ie <= 127) && (this.buf[this.pos++] = ie >>> 7 & 127)));
  },
  writeSVarint: function(ie) {
    this.writeVarint(ie < 0 ? -ie * 2 - 1 : ie * 2);
  },
  writeBoolean: function(ie) {
    this.writeVarint(!!ie);
  },
  writeString: function(ie) {
    ie = String(ie), this.realloc(ie.length * 4), this.pos++;
    var Z = this.pos;
    this.pos = writeUtf8(this.buf, ie, this.pos);
    var ee = this.pos - Z;
    ee >= 128 && makeRoomForExtraLength(Z, ee, this), this.pos = Z - 1, this.writeVarint(ee), this.pos += ee;
  },
  writeFloat: function(ie) {
    this.realloc(4), ieee754.write(this.buf, ie, this.pos, !0, 23, 4), this.pos += 4;
  },
  writeDouble: function(ie) {
    this.realloc(8), ieee754.write(this.buf, ie, this.pos, !0, 52, 8), this.pos += 8;
  },
  writeBytes: function(ie) {
    var Z = ie.length;
    this.writeVarint(Z), this.realloc(Z);
    for (var ee = 0; ee < Z; ee++)
      this.buf[this.pos++] = ie[ee];
  },
  writeRawMessage: function(ie, Z) {
    this.pos++;
    var ee = this.pos;
    ie(Z, this);
    var ae = this.pos - ee;
    ae >= 128 && makeRoomForExtraLength(ee, ae, this), this.pos = ee - 1, this.writeVarint(ae), this.pos += ae;
  },
  writeMessage: function(ie, Z, ee) {
    this.writeTag(ie, Pbf.Bytes), this.writeRawMessage(Z, ee);
  },
  writePackedVarint: function(ie, Z) {
    Z.length && this.writeMessage(ie, writePackedVarint, Z);
  },
  writePackedSVarint: function(ie, Z) {
    Z.length && this.writeMessage(ie, writePackedSVarint, Z);
  },
  writePackedBoolean: function(ie, Z) {
    Z.length && this.writeMessage(ie, writePackedBoolean, Z);
  },
  writePackedFloat: function(ie, Z) {
    Z.length && this.writeMessage(ie, writePackedFloat, Z);
  },
  writePackedDouble: function(ie, Z) {
    Z.length && this.writeMessage(ie, writePackedDouble, Z);
  },
  writePackedFixed32: function(ie, Z) {
    Z.length && this.writeMessage(ie, writePackedFixed32, Z);
  },
  writePackedSFixed32: function(ie, Z) {
    Z.length && this.writeMessage(ie, writePackedSFixed32, Z);
  },
  writePackedFixed64: function(ie, Z) {
    Z.length && this.writeMessage(ie, writePackedFixed64, Z);
  },
  writePackedSFixed64: function(ie, Z) {
    Z.length && this.writeMessage(ie, writePackedSFixed64, Z);
  },
  writeBytesField: function(ie, Z) {
    this.writeTag(ie, Pbf.Bytes), this.writeBytes(Z);
  },
  writeFixed32Field: function(ie, Z) {
    this.writeTag(ie, Pbf.Fixed32), this.writeFixed32(Z);
  },
  writeSFixed32Field: function(ie, Z) {
    this.writeTag(ie, Pbf.Fixed32), this.writeSFixed32(Z);
  },
  writeFixed64Field: function(ie, Z) {
    this.writeTag(ie, Pbf.Fixed64), this.writeFixed64(Z);
  },
  writeSFixed64Field: function(ie, Z) {
    this.writeTag(ie, Pbf.Fixed64), this.writeSFixed64(Z);
  },
  writeVarintField: function(ie, Z) {
    this.writeTag(ie, Pbf.Varint), this.writeVarint(Z);
  },
  writeSVarintField: function(ie, Z) {
    this.writeTag(ie, Pbf.Varint), this.writeSVarint(Z);
  },
  writeStringField: function(ie, Z) {
    this.writeTag(ie, Pbf.Bytes), this.writeString(Z);
  },
  writeFloatField: function(ie, Z) {
    this.writeTag(ie, Pbf.Fixed32), this.writeFloat(Z);
  },
  writeDoubleField: function(ie, Z) {
    this.writeTag(ie, Pbf.Fixed64), this.writeDouble(Z);
  },
  writeBooleanField: function(ie, Z) {
    this.writeVarintField(ie, !!Z);
  }
};
function readVarintRemainder$1(ie, Z, ee) {
  var ae = ee.buf, ve, ye;
  if (ye = ae[ee.pos++], ve = (ye & 112) >> 4, ye < 128 || (ye = ae[ee.pos++], ve |= (ye & 127) << 3, ye < 128) || (ye = ae[ee.pos++], ve |= (ye & 127) << 10, ye < 128) || (ye = ae[ee.pos++], ve |= (ye & 127) << 17, ye < 128) || (ye = ae[ee.pos++], ve |= (ye & 127) << 24, ye < 128) || (ye = ae[ee.pos++], ve |= (ye & 1) << 31, ye < 128))
    return toNum$1(ie, ve, Z);
  throw new Error("Expected varint not more than 10 bytes");
}
function readPackedEnd(ie) {
  return ie.type === Pbf.Bytes ? ie.readVarint() + ie.pos : ie.pos + 1;
}
function toNum$1(ie, Z, ee) {
  return ee ? Z * 4294967296 + (ie >>> 0) : (Z >>> 0) * 4294967296 + (ie >>> 0);
}
function writeBigVarint(ie, Z) {
  var ee, ae;
  if (ie >= 0 ? (ee = ie % 4294967296 | 0, ae = ie / 4294967296 | 0) : (ee = ~(-ie % 4294967296), ae = ~(-ie / 4294967296), ee ^ 4294967295 ? ee = ee + 1 | 0 : (ee = 0, ae = ae + 1 | 0)), ie >= 18446744073709552e3 || ie < -18446744073709552e3)
    throw new Error("Given varint doesn't fit into 10 bytes");
  Z.realloc(10), writeBigVarintLow(ee, ae, Z), writeBigVarintHigh(ae, Z);
}
function writeBigVarintLow(ie, Z, ee) {
  ee.buf[ee.pos++] = ie & 127 | 128, ie >>>= 7, ee.buf[ee.pos++] = ie & 127 | 128, ie >>>= 7, ee.buf[ee.pos++] = ie & 127 | 128, ie >>>= 7, ee.buf[ee.pos++] = ie & 127 | 128, ie >>>= 7, ee.buf[ee.pos] = ie & 127;
}
function writeBigVarintHigh(ie, Z) {
  var ee = (ie & 7) << 4;
  Z.buf[Z.pos++] |= ee | ((ie >>>= 3) ? 128 : 0), ie && (Z.buf[Z.pos++] = ie & 127 | ((ie >>>= 7) ? 128 : 0), ie && (Z.buf[Z.pos++] = ie & 127 | ((ie >>>= 7) ? 128 : 0), ie && (Z.buf[Z.pos++] = ie & 127 | ((ie >>>= 7) ? 128 : 0), ie && (Z.buf[Z.pos++] = ie & 127 | ((ie >>>= 7) ? 128 : 0), ie && (Z.buf[Z.pos++] = ie & 127)))));
}
function makeRoomForExtraLength(ie, Z, ee) {
  var ae = Z <= 16383 ? 1 : Z <= 2097151 ? 2 : Z <= 268435455 ? 3 : Math.floor(Math.log(Z) / (Math.LN2 * 7));
  ee.realloc(ae);
  for (var ve = ee.pos - 1; ve >= ie; ve--)
    ee.buf[ve + ae] = ee.buf[ve];
}
function writePackedVarint(ie, Z) {
  for (var ee = 0; ee < ie.length; ee++)
    Z.writeVarint(ie[ee]);
}
function writePackedSVarint(ie, Z) {
  for (var ee = 0; ee < ie.length; ee++)
    Z.writeSVarint(ie[ee]);
}
function writePackedFloat(ie, Z) {
  for (var ee = 0; ee < ie.length; ee++)
    Z.writeFloat(ie[ee]);
}
function writePackedDouble(ie, Z) {
  for (var ee = 0; ee < ie.length; ee++)
    Z.writeDouble(ie[ee]);
}
function writePackedBoolean(ie, Z) {
  for (var ee = 0; ee < ie.length; ee++)
    Z.writeBoolean(ie[ee]);
}
function writePackedFixed32(ie, Z) {
  for (var ee = 0; ee < ie.length; ee++)
    Z.writeFixed32(ie[ee]);
}
function writePackedSFixed32(ie, Z) {
  for (var ee = 0; ee < ie.length; ee++)
    Z.writeSFixed32(ie[ee]);
}
function writePackedFixed64(ie, Z) {
  for (var ee = 0; ee < ie.length; ee++)
    Z.writeFixed64(ie[ee]);
}
function writePackedSFixed64(ie, Z) {
  for (var ee = 0; ee < ie.length; ee++)
    Z.writeSFixed64(ie[ee]);
}
function readUInt32(ie, Z) {
  return (ie[Z] | ie[Z + 1] << 8 | ie[Z + 2] << 16) + ie[Z + 3] * 16777216;
}
function writeInt32(ie, Z, ee) {
  ie[ee] = Z, ie[ee + 1] = Z >>> 8, ie[ee + 2] = Z >>> 16, ie[ee + 3] = Z >>> 24;
}
function readInt32(ie, Z) {
  return (ie[Z] | ie[Z + 1] << 8 | ie[Z + 2] << 16) + (ie[Z + 3] << 24);
}
function readUtf8(ie, Z, ee) {
  for (var ae = "", ve = Z; ve < ee; ) {
    var ye = ie[ve], be = null, Ye = ye > 239 ? 4 : ye > 223 ? 3 : ye > 191 ? 2 : 1;
    if (ve + Ye > ee)
      break;
    var Qe, Je, nt;
    Ye === 1 ? ye < 128 && (be = ye) : Ye === 2 ? (Qe = ie[ve + 1], (Qe & 192) === 128 && (be = (ye & 31) << 6 | Qe & 63, be <= 127 && (be = null))) : Ye === 3 ? (Qe = ie[ve + 1], Je = ie[ve + 2], (Qe & 192) === 128 && (Je & 192) === 128 && (be = (ye & 15) << 12 | (Qe & 63) << 6 | Je & 63, (be <= 2047 || be >= 55296 && be <= 57343) && (be = null))) : Ye === 4 && (Qe = ie[ve + 1], Je = ie[ve + 2], nt = ie[ve + 3], (Qe & 192) === 128 && (Je & 192) === 128 && (nt & 192) === 128 && (be = (ye & 15) << 18 | (Qe & 63) << 12 | (Je & 63) << 6 | nt & 63, (be <= 65535 || be >= 1114112) && (be = null))), be === null ? (be = 65533, Ye = 1) : be > 65535 && (be -= 65536, ae += String.fromCharCode(be >>> 10 & 1023 | 55296), be = 56320 | be & 1023), ae += String.fromCharCode(be), ve += Ye;
  }
  return ae;
}
function readUtf8TextDecoder(ie, Z, ee) {
  return utf8TextDecoder.decode(ie.subarray(Z, ee));
}
function writeUtf8(ie, Z, ee) {
  for (var ae = 0, ve, ye; ae < Z.length; ae++) {
    if (ve = Z.charCodeAt(ae), ve > 55295 && ve < 57344)
      if (ye)
        if (ve < 56320) {
          ie[ee++] = 239, ie[ee++] = 191, ie[ee++] = 189, ye = ve;
          continue;
        } else
          ve = ye - 55296 << 10 | ve - 56320 | 65536, ye = null;
      else {
        ve > 56319 || ae + 1 === Z.length ? (ie[ee++] = 239, ie[ee++] = 191, ie[ee++] = 189) : ye = ve;
        continue;
      }
    else
      ye && (ie[ee++] = 239, ie[ee++] = 191, ie[ee++] = 189, ye = null);
    ve < 128 ? ie[ee++] = ve : (ve < 2048 ? ie[ee++] = ve >> 6 | 192 : (ve < 65536 ? ie[ee++] = ve >> 12 | 224 : (ie[ee++] = ve >> 18 | 240, ie[ee++] = ve >> 12 & 63 | 128), ie[ee++] = ve >> 6 & 63 | 128), ie[ee++] = ve & 63 | 128);
  }
  return ee;
}
const PBF = /* @__PURE__ */ getDefaultExportFromCjs$1(pbf), tmpTransform = create$2();
class RenderFeature {
  /**
   * @param {import("../geom/Geometry.js").Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>|Array<Array<number>>} ends Ends or Endss.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */
  constructor(Z, ee, ae, ve, ye) {
    this.styleFunction, this.extent_, this.id_ = ye, this.type_ = Z, this.flatCoordinates_ = ee, this.flatInteriorPoints_ = null, this.flatMidpoints_ = null, this.ends_ = ae, this.properties_ = ve;
  }
  /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */
  get(Z) {
    return this.properties_[Z];
  }
  /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getExtent() {
    return this.extent_ || (this.extent_ = this.type_ === "Point" ? createOrUpdateFromCoordinate(this.flatCoordinates_) : createOrUpdateFromFlatCoordinates(
      this.flatCoordinates_,
      0,
      this.flatCoordinates_.length,
      2
    )), this.extent_;
  }
  /**
   * @return {Array<number>} Flat interior points.
   */
  getFlatInteriorPoint() {
    if (!this.flatInteriorPoints_) {
      const Z = getCenter(this.getExtent());
      this.flatInteriorPoints_ = getInteriorPointOfArray(
        this.flatCoordinates_,
        0,
        /** @type {Array<number>} */
        this.ends_,
        2,
        Z,
        0
      );
    }
    return this.flatInteriorPoints_;
  }
  /**
   * @return {Array<number>} Flat interior points.
   */
  getFlatInteriorPoints() {
    if (!this.flatInteriorPoints_) {
      const Z = linearRingss(
        this.flatCoordinates_,
        0,
        /** @type {Array<Array<number>>} */
        this.ends_,
        2
      );
      this.flatInteriorPoints_ = getInteriorPointsOfMultiArray(
        this.flatCoordinates_,
        0,
        /** @type {Array<Array<number>>} */
        this.ends_,
        2,
        Z
      );
    }
    return this.flatInteriorPoints_;
  }
  /**
   * @return {Array<number>} Flat midpoint.
   */
  getFlatMidpoint() {
    return this.flatMidpoints_ || (this.flatMidpoints_ = interpolatePoint(
      this.flatCoordinates_,
      0,
      this.flatCoordinates_.length,
      2,
      0.5
    )), this.flatMidpoints_;
  }
  /**
   * @return {Array<number>} Flat midpoints.
   */
  getFlatMidpoints() {
    if (!this.flatMidpoints_) {
      this.flatMidpoints_ = [];
      const Z = this.flatCoordinates_;
      let ee = 0;
      const ae = (
        /** @type {Array<number>} */
        this.ends_
      );
      for (let ve = 0, ye = ae.length; ve < ye; ++ve) {
        const be = ae[ve], Ye = interpolatePoint(Z, ee, be, 2, 0.5);
        extend$2(this.flatMidpoints_, Ye), ee = be;
      }
    }
    return this.flatMidpoints_;
  }
  /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */
  getId() {
    return this.id_;
  }
  /**
   * @return {Array<number>} Flat coordinates.
   */
  getOrientedFlatCoordinates() {
    return this.flatCoordinates_;
  }
  /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */
  getGeometry() {
    return this;
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */
  getSimplifiedGeometry(Z) {
    return this;
  }
  /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */
  simplifyTransformed(Z, ee) {
    return this;
  }
  /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */
  getProperties() {
    return this.properties_;
  }
  /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */
  getPropertiesInternal() {
    return this.properties_;
  }
  /**
   * @return {number} Stride.
   */
  getStride() {
    return 2;
  }
  /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */
  getStyleFunction() {
    return this.styleFunction;
  }
  /**
   * Get the type of this feature's geometry.
   * @return {import("../geom/Geometry.js").Type} Geometry type.
   * @api
   */
  getType() {
    return this.type_;
  }
  /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */
  transform(Z) {
    Z = get$1(Z);
    const ee = Z.getExtent(), ae = Z.getWorldExtent();
    if (ee && ae) {
      const ve = getHeight(ae) / getHeight(ee);
      compose$1(
        tmpTransform,
        ae[0],
        ae[3],
        ve,
        -ve,
        0,
        0,
        0
      ), transform2D(
        this.flatCoordinates_,
        0,
        this.flatCoordinates_.length,
        2,
        tmpTransform,
        this.flatCoordinates_
      );
    }
  }
  /**
   * @return {Array<number>|Array<Array<number>>} Ends or endss.
   */
  getEnds() {
    return this.ends_;
  }
}
RenderFeature.prototype.getEndss = RenderFeature.prototype.getEnds;
RenderFeature.prototype.getFlatCoordinates = RenderFeature.prototype.getOrientedFlatCoordinates;
class MVT extends FeatureFormat {
  /**
   * @param {Options} [options] Options.
   */
  constructor(Z) {
    super(), Z = Z || {}, this.dataProjection = new Projection({
      code: "",
      units: "tile-pixels"
    }), this.featureClass_ = Z.featureClass ? Z.featureClass : RenderFeature, this.geometryName_ = Z.geometryName, this.layerName_ = Z.layerName ? Z.layerName : "layer", this.layers_ = Z.layers ? Z.layers : null, this.idProperty_ = Z.idProperty, this.supportedMediaTypes = [
      "application/vnd.mapbox-vector-tile",
      "application/x-protobuf"
    ];
  }
  /**
   * Read the raw geometry from the pbf offset stored in a raw feature's geometry
   * property.
   * @param {PBF} pbf PBF.
   * @param {Object} feature Raw feature.
   * @param {Array<number>} flatCoordinates Array to store flat coordinates in.
   * @param {Array<number>} ends Array to store ends in.
   * @private
   */
  readRawGeometry_(Z, ee, ae, ve) {
    Z.pos = ee.geometry;
    const ye = Z.readVarint() + Z.pos;
    let be = 1, Ye = 0, Qe = 0, Je = 0, nt = 0, st = 0;
    for (; Z.pos < ye; ) {
      if (!Ye) {
        const ot = Z.readVarint();
        be = ot & 7, Ye = ot >> 3;
      }
      if (Ye--, be === 1 || be === 2)
        Qe += Z.readSVarint(), Je += Z.readSVarint(), be === 1 && nt > st && (ve.push(nt), st = nt), ae.push(Qe, Je), nt += 2;
      else if (be === 7)
        nt > st && (ae.push(
          ae[st],
          ae[st + 1]
        ), nt += 2);
      else
        throw new Error("Invalid command found in the PBF");
    }
    nt > st && (ve.push(nt), st = nt);
  }
  /**
   * @private
   * @param {PBF} pbf PBF
   * @param {Object} rawFeature Raw Mapbox feature.
   * @param {import("./Feature.js").ReadOptions} options Read options.
   * @return {import("../Feature.js").FeatureLike|null} Feature.
   */
  createFeature_(Z, ee, ae) {
    const ve = ee.type;
    if (ve === 0)
      return null;
    let ye;
    const be = ee.properties;
    let Ye;
    this.idProperty_ ? (Ye = be[this.idProperty_], delete be[this.idProperty_]) : Ye = ee.id, be[this.layerName_] = ee.layer.name;
    const Qe = (
      /** @type {Array<number>} */
      []
    ), Je = (
      /** @type {Array<number>} */
      []
    );
    this.readRawGeometry_(Z, ee, Qe, Je);
    const nt = getGeometryType(ve, Je.length);
    if (this.featureClass_ === RenderFeature)
      ye = new this.featureClass_(
        nt,
        Qe,
        Je,
        be,
        Ye
      ), ye.transform(ae.dataProjection);
    else {
      let st;
      if (nt == "Polygon") {
        const ft = inflateEnds(Qe, Je);
        st = ft.length > 1 ? new MultiPolygon$1(Qe, "XY", ft) : new Polygon$1(Qe, "XY", Je);
      } else
        st = nt === "Point" ? new Point$1(Qe, "XY") : nt === "LineString" ? new LineString$1(Qe, "XY") : nt === "MultiPoint" ? new MultiPoint$1(Qe, "XY") : nt === "MultiLineString" ? new MultiLineString$1(Qe, "XY", Je) : null;
      const ot = (
        /** @type {typeof import("../Feature.js").default} */
        this.featureClass_
      );
      ye = new ot(), this.geometryName_ && ye.setGeometryName(this.geometryName_);
      const lt = transformGeometryWithOptions(st, !1, ae);
      ye.setGeometry(lt), Ye !== void 0 && ye.setId(Ye), ye.setProperties(be, !0);
    }
    return ye;
  }
  /**
   * @return {import("./Feature.js").Type} Format.
   */
  getType() {
    return "arraybuffer";
  }
  /**
   * Read all features.
   *
   * @param {ArrayBuffer} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<import("../Feature.js").FeatureLike>} Features.
   * @api
   */
  readFeatures(Z, ee) {
    const ae = this.layers_;
    ee = this.adaptOptions(ee);
    const ve = get$1(ee.dataProjection);
    ve.setWorldExtent(ee.extent), ee.dataProjection = ve;
    const ye = new PBF(
      /** @type {ArrayBuffer} */
      Z
    ), be = ye.readFields(layersPBFReader, {}), Ye = [];
    for (const Qe in be) {
      if (ae && !ae.includes(Qe))
        continue;
      const Je = be[Qe], nt = Je ? [0, 0, Je.extent, Je.extent] : null;
      ve.setExtent(nt);
      for (let st = 0, ot = Je.length; st < ot; ++st) {
        const lt = readRawFeature(ye, Je, st), ft = this.createFeature_(ye, lt, ee);
        ft !== null && Ye.push(ft);
      }
    }
    return Ye;
  }
  /**
   * Read the projection from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   */
  readProjection(Z) {
    return this.dataProjection;
  }
  /**
   * Sets the layers that features will be read from.
   * @param {Array<string>} layers Layers.
   * @api
   */
  setLayers(Z) {
    this.layers_ = Z;
  }
}
function layersPBFReader(ie, Z, ee) {
  if (ie === 3) {
    const ae = {
      keys: [],
      values: [],
      features: []
    }, ve = ee.readVarint() + ee.pos;
    ee.readFields(layerPBFReader, ae, ve), ae.length = ae.features.length, ae.length && (Z[ae.name] = ae);
  }
}
function layerPBFReader(ie, Z, ee) {
  if (ie === 15)
    Z.version = ee.readVarint();
  else if (ie === 1)
    Z.name = ee.readString();
  else if (ie === 5)
    Z.extent = ee.readVarint();
  else if (ie === 2)
    Z.features.push(ee.pos);
  else if (ie === 3)
    Z.keys.push(ee.readString());
  else if (ie === 4) {
    let ae = null;
    const ve = ee.readVarint() + ee.pos;
    for (; ee.pos < ve; )
      ie = ee.readVarint() >> 3, ae = ie === 1 ? ee.readString() : ie === 2 ? ee.readFloat() : ie === 3 ? ee.readDouble() : ie === 4 ? ee.readVarint64() : ie === 5 ? ee.readVarint() : ie === 6 ? ee.readSVarint() : ie === 7 ? ee.readBoolean() : null;
    Z.values.push(ae);
  }
}
function featurePBFReader(ie, Z, ee) {
  if (ie == 1)
    Z.id = ee.readVarint();
  else if (ie == 2) {
    const ae = ee.readVarint() + ee.pos;
    for (; ee.pos < ae; ) {
      const ve = Z.layer.keys[ee.readVarint()], ye = Z.layer.values[ee.readVarint()];
      Z.properties[ve] = ye;
    }
  } else
    ie == 3 ? Z.type = ee.readVarint() : ie == 4 && (Z.geometry = ee.pos);
}
function readRawFeature(ie, Z, ee) {
  ie.pos = Z.features[ee];
  const ae = ie.readVarint() + ie.pos, ve = {
    layer: Z,
    type: 0,
    properties: {}
  };
  return ie.readFields(featurePBFReader, ve, ae), ve;
}
function getGeometryType(ie, Z) {
  let ee;
  return ie === 1 ? ee = Z === 1 ? "Point" : "MultiPoint" : ie === 2 ? ee = Z === 1 ? "LineString" : "MultiLineString" : ie === 3 && (ee = "Polygon"), ee;
}
var __async = (ie, Z, ee) => new Promise((ae, ve) => {
  var ye = (Qe) => {
    try {
      Ye(ee.next(Qe));
    } catch (Je) {
      ve(Je);
    }
  }, be = (Qe) => {
    try {
      Ye(ee.throw(Qe));
    } catch (Je) {
      ve(Je);
    }
  }, Ye = (Qe) => Qe.done ? ae(Qe.value) : Promise.resolve(Qe.value).then(ye, be);
  Ye((ee = ee.apply(ie, Z)).next());
}), u8 = Uint8Array, u16 = Uint16Array, i32 = Int32Array, fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), freb = function(ie, Z) {
  for (var ee = new u16(31), ae = 0; ae < 31; ++ae)
    ee[ae] = Z += 1 << ie[ae - 1];
  for (var ve = new i32(ee[30]), ae = 1; ae < 30; ++ae)
    for (var ye = ee[ae]; ye < ee[ae + 1]; ++ye)
      ve[ye] = ye - ee[ae] << 5 | ae;
  return { b: ee, r: ve };
}, _a = freb(fleb, 2), fl = _a.b, revfl = _a.r;
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b.b, rev = new u16(32768);
for (i$2 = 0; i$2 < 32768; ++i$2)
  x$2 = (i$2 & 43690) >> 1 | (i$2 & 21845) << 1, x$2 = (x$2 & 52428) >> 2 | (x$2 & 13107) << 2, x$2 = (x$2 & 61680) >> 4 | (x$2 & 3855) << 4, rev[i$2] = ((x$2 & 65280) >> 8 | (x$2 & 255) << 8) >> 1;
var x$2, i$2, hMap = function(ie, Z, ee) {
  for (var ae = ie.length, ve = 0, ye = new u16(Z); ve < ae; ++ve)
    ie[ve] && ++ye[ie[ve] - 1];
  var be = new u16(Z);
  for (ve = 1; ve < Z; ++ve)
    be[ve] = be[ve - 1] + ye[ve - 1] << 1;
  var Ye;
  if (ee) {
    Ye = new u16(1 << Z);
    var Qe = 15 - Z;
    for (ve = 0; ve < ae; ++ve)
      if (ie[ve])
        for (var Je = ve << 4 | ie[ve], nt = Z - ie[ve], st = be[ie[ve] - 1]++ << nt, ot = st | (1 << nt) - 1; st <= ot; ++st)
          Ye[rev[st] >> Qe] = Je;
  } else
    for (Ye = new u16(ae), ve = 0; ve < ae; ++ve)
      ie[ve] && (Ye[ve] = rev[be[ie[ve] - 1]++] >> 15 - ie[ve]);
  return Ye;
}, flt = new u8(288);
for (i$2 = 0; i$2 < 144; ++i$2)
  flt[i$2] = 8;
var i$2;
for (i$2 = 144; i$2 < 256; ++i$2)
  flt[i$2] = 9;
var i$2;
for (i$2 = 256; i$2 < 280; ++i$2)
  flt[i$2] = 7;
var i$2;
for (i$2 = 280; i$2 < 288; ++i$2)
  flt[i$2] = 8;
var i$2, fdt = new u8(32);
for (i$2 = 0; i$2 < 32; ++i$2)
  fdt[i$2] = 5;
var i$2, flrm = /* @__PURE__ */ hMap(flt, 9, 1), fdrm = /* @__PURE__ */ hMap(fdt, 5, 1), max$1 = function(ie) {
  for (var Z = ie[0], ee = 1; ee < ie.length; ++ee)
    ie[ee] > Z && (Z = ie[ee]);
  return Z;
}, bits = function(ie, Z, ee) {
  var ae = Z / 8 | 0;
  return (ie[ae] | ie[ae + 1] << 8) >> (Z & 7) & ee;
}, bits16 = function(ie, Z) {
  var ee = Z / 8 | 0;
  return (ie[ee] | ie[ee + 1] << 8 | ie[ee + 2] << 16) >> (Z & 7);
}, shft = function(ie) {
  return (ie + 7) / 8 | 0;
}, slc = function(ie, Z, ee) {
  (Z == null || Z < 0) && (Z = 0), (ee == null || ee > ie.length) && (ee = ie.length);
  var ae = new u8(ee - Z);
  return ae.set(ie.subarray(Z, ee)), ae;
}, ec = [
  "unexpected EOF",
  "invalid block type",
  "invalid length/literal",
  "invalid distance",
  "stream finished",
  "no stream handler",
  ,
  "no callback",
  "invalid UTF-8 data",
  "extra field too long",
  "date not in range 1980-2099",
  "filename too long",
  "stream finishing",
  "invalid zip data"
], err = function(ie, Z, ee) {
  var ae = new Error(Z || ec[ie]);
  if (ae.code = ie, Error.captureStackTrace && Error.captureStackTrace(ae, err), !ee)
    throw ae;
  return ae;
}, inflt = function(ie, Z, ee, ae) {
  var ve = ie.length, ye = ae ? ae.length : 0;
  if (!ve || Z.f && !Z.l)
    return ee || new u8(0);
  var be = !ee || Z.i != 2, Ye = Z.i;
  ee || (ee = new u8(ve * 3));
  var Qe = function(Gs) {
    var Vs = ee.length;
    if (Gs > Vs) {
      var Ws = new u8(Math.max(Vs * 2, Gs));
      Ws.set(ee), ee = Ws;
    }
  }, Je = Z.f || 0, nt = Z.p || 0, st = Z.b || 0, ot = Z.l, lt = Z.d, ft = Z.m, gt = Z.n, ct = ve * 8;
  do {
    if (!ot) {
      Je = bits(ie, nt, 1);
      var _r = bits(ie, nt + 1, 3);
      if (nt += 3, _r)
        if (_r == 1)
          ot = flrm, lt = fdrm, ft = 9, gt = 5;
        else if (_r == 2) {
          var ei = bits(ie, nt, 31) + 257, si = bits(ie, nt + 10, 15) + 4, ri = ei + bits(ie, nt + 5, 31) + 1;
          nt += 14;
          for (var ai = new u8(ri), yi = new u8(19), pi = 0; pi < si; ++pi)
            yi[clim[pi]] = bits(ie, nt + pi * 3, 7);
          nt += si * 3;
          for (var di = max$1(yi), xi = (1 << di) - 1, Ti = hMap(yi, di, 1), pi = 0; pi < ri; ) {
            var Ai = Ti[bits(ie, nt, xi)];
            nt += Ai & 15;
            var Kr = Ai >> 4;
            if (Kr < 16)
              ai[pi++] = Kr;
            else {
              var mi = 0, Si = 0;
              for (Kr == 16 ? (Si = 3 + bits(ie, nt, 3), nt += 2, mi = ai[pi - 1]) : Kr == 17 ? (Si = 3 + bits(ie, nt, 7), nt += 3) : Kr == 18 && (Si = 11 + bits(ie, nt, 127), nt += 7); Si--; )
                ai[pi++] = mi;
            }
          }
          var gi = ai.subarray(0, ei), _i = ai.subarray(ei);
          ft = max$1(gi), gt = max$1(_i), ot = hMap(gi, ft, 1), lt = hMap(_i, gt, 1);
        } else
          err(1);
      else {
        var Kr = shft(nt) + 4, Xr = ie[Kr - 4] | ie[Kr - 3] << 8, Jr = Kr + Xr;
        if (Jr > ve) {
          Ye && err(0);
          break;
        }
        be && Qe(st + Xr), ee.set(ie.subarray(Kr, Jr), st), Z.b = st += Xr, Z.p = nt = Jr * 8, Z.f = Je;
        continue;
      }
      if (nt > ct) {
        Ye && err(0);
        break;
      }
    }
    be && Qe(st + 131072);
    for (var Oi = (1 << ft) - 1, hi = (1 << gt) - 1, Di = nt; ; Di = nt) {
      var mi = ot[bits16(ie, nt) & Oi], Ri = mi >> 4;
      if (nt += mi & 15, nt > ct) {
        Ye && err(0);
        break;
      }
      if (mi || err(2), Ri < 256)
        ee[st++] = Ri;
      else if (Ri == 256) {
        Di = nt, ot = null;
        break;
      } else {
        var rs = Ri - 254;
        if (Ri > 264) {
          var pi = Ri - 257, Hi = fleb[pi];
          rs = bits(ie, nt, (1 << Hi) - 1) + fl[pi], nt += Hi;
        }
        var qi = lt[bits16(ie, nt) & hi], us = qi >> 4;
        qi || err(3), nt += qi & 15;
        var _i = fd[us];
        if (us > 3) {
          var Hi = fdeb[us];
          _i += bits16(ie, nt) & (1 << Hi) - 1, nt += Hi;
        }
        if (nt > ct) {
          Ye && err(0);
          break;
        }
        be && Qe(st + 131072);
        var Yi = st + rs;
        if (st < _i) {
          var is = ye - _i, Ss = Math.min(_i, Yi);
          for (is + st < 0 && err(3); st < Ss; ++st)
            ee[st] = ae[is + st];
        }
        for (; st < Yi; st += 4)
          ee[st] = ee[st - _i], ee[st + 1] = ee[st + 1 - _i], ee[st + 2] = ee[st + 2 - _i], ee[st + 3] = ee[st + 3 - _i];
        st = Yi;
      }
    }
    Z.l = ot, Z.p = Di, Z.b = st, Z.f = Je, ot && (Je = 1, Z.m = ft, Z.d = lt, Z.n = gt);
  } while (!Je);
  return st == ee.length ? ee : slc(ee, 0, st);
}, et = /* @__PURE__ */ new u8(0), gzs = function(ie) {
  (ie[0] != 31 || ie[1] != 139 || ie[2] != 8) && err(6, "invalid gzip data");
  var Z = ie[3], ee = 10;
  Z & 4 && (ee += (ie[10] | ie[11] << 8) + 2);
  for (var ae = (Z >> 3 & 1) + (Z >> 4 & 1); ae > 0; ae -= !ie[ee++])
    ;
  return ee + (Z & 2);
}, gzl = function(ie) {
  var Z = ie.length;
  return (ie[Z - 4] | ie[Z - 3] << 8 | ie[Z - 2] << 16 | ie[Z - 1] << 24) >>> 0;
}, zls = function(ie, Z) {
  return ((ie[0] & 15) != 8 || ie[0] >> 4 > 7 || (ie[0] << 8 | ie[1]) % 31) && err(6, "invalid zlib data"), (ie[1] >> 5 & 1) == +!Z && err(6, "invalid zlib data: " + (ie[1] & 32 ? "need" : "unexpected") + " dictionary"), (ie[1] >> 3 & 4) + 2;
};
function inflateSync(ie, Z) {
  return inflt(ie, { i: 2 }, Z && Z.out, Z && Z.dictionary);
}
function gunzipSync(ie, Z) {
  var ee = gzs(ie);
  return ee + 8 > ie.length && err(6, "invalid gzip data"), inflt(ie.subarray(ee, -8), { i: 2 }, Z && Z.out || new u8(gzl(ie)), Z && Z.dictionary);
}
function unzlibSync(ie, Z) {
  return inflt(ie.subarray(zls(ie, Z && Z.dictionary), -4), { i: 2 }, Z && Z.out, Z && Z.dictionary);
}
function decompressSync(ie, Z) {
  return ie[0] == 31 && ie[1] == 139 && ie[2] == 8 ? gunzipSync(ie, Z) : (ie[0] & 15) != 8 || ie[0] >> 4 > 7 || (ie[0] << 8 | ie[1]) % 31 ? inflateSync(ie, Z) : unzlibSync(ie, Z);
}
var td = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), tds = 0;
try {
  td.decode(et, { stream: !0 }), tds = 1;
} catch {
}
var shift$2 = (ie, Z) => ie * Math.pow(2, Z), unshift = (ie, Z) => Math.floor(ie / Math.pow(2, Z)), getUint24 = (ie, Z) => shift$2(ie.getUint16(Z + 1, !0), 8) + ie.getUint8(Z), getUint48 = (ie, Z) => shift$2(ie.getUint32(Z + 2, !0), 16) + ie.getUint16(Z, !0), compare = (ie, Z, ee, ae, ve) => {
  if (ie != ae.getUint8(ve))
    return ie - ae.getUint8(ve);
  const ye = getUint24(ae, ve + 1);
  if (Z != ye)
    return Z - ye;
  const be = getUint24(ae, ve + 4);
  return ee != be ? ee - be : 0;
}, queryLeafdir = (ie, Z, ee, ae) => {
  const ve = queryView(ie, Z | 128, ee, ae);
  return ve ? {
    z: Z,
    x: ee,
    y: ae,
    offset: ve[0],
    length: ve[1],
    is_dir: !0
  } : null;
}, queryTile = (ie, Z, ee, ae) => {
  const ve = queryView(ie, Z, ee, ae);
  return ve ? {
    z: Z,
    x: ee,
    y: ae,
    offset: ve[0],
    length: ve[1],
    is_dir: !1
  } : null;
}, queryView = (ie, Z, ee, ae) => {
  let ve = 0, ye = ie.byteLength / 17 - 1;
  for (; ve <= ye; ) {
    const be = ye + ve >> 1, Ye = compare(Z, ee, ae, ie, be * 17);
    if (Ye > 0)
      ve = be + 1;
    else if (Ye < 0)
      ye = be - 1;
    else
      return [getUint48(ie, be * 17 + 7), ie.getUint32(be * 17 + 13, !0)];
  }
  return null;
}, entrySort = (ie, Z) => ie.is_dir && !Z.is_dir ? 1 : !ie.is_dir && Z.is_dir ? -1 : ie.z !== Z.z ? ie.z - Z.z : ie.x !== Z.x ? ie.x - Z.x : ie.y - Z.y, parseEntry = (ie, Z) => {
  const ee = ie.getUint8(Z * 17);
  return {
    z: ee & 127,
    x: getUint24(ie, Z * 17 + 1),
    y: getUint24(ie, Z * 17 + 4),
    offset: getUint48(ie, Z * 17 + 7),
    length: ie.getUint32(Z * 17 + 13, !0),
    is_dir: ee >> 7 === 1
  };
}, sortDir = (ie) => {
  const Z = [], ee = new DataView(ie);
  for (let ae = 0; ae < ee.byteLength / 17; ae++)
    Z.push(parseEntry(ee, ae));
  return createDirectory(Z);
}, createDirectory = (ie) => {
  ie.sort(entrySort);
  const Z = new ArrayBuffer(17 * ie.length), ee = new Uint8Array(Z);
  for (let ae = 0; ae < ie.length; ae++) {
    const ve = ie[ae];
    let ye = ve.z;
    ve.is_dir && (ye = ye | 128), ee[ae * 17] = ye, ee[ae * 17 + 1] = ve.x & 255, ee[ae * 17 + 2] = ve.x >> 8 & 255, ee[ae * 17 + 3] = ve.x >> 16 & 255, ee[ae * 17 + 4] = ve.y & 255, ee[ae * 17 + 5] = ve.y >> 8 & 255, ee[ae * 17 + 6] = ve.y >> 16 & 255, ee[ae * 17 + 7] = ve.offset & 255, ee[ae * 17 + 8] = unshift(ve.offset, 8) & 255, ee[ae * 17 + 9] = unshift(ve.offset, 16) & 255, ee[ae * 17 + 10] = unshift(ve.offset, 24) & 255, ee[ae * 17 + 11] = unshift(ve.offset, 32) & 255, ee[ae * 17 + 12] = unshift(ve.offset, 48) & 255, ee[ae * 17 + 13] = ve.length & 255, ee[ae * 17 + 14] = ve.length >> 8 & 255, ee[ae * 17 + 15] = ve.length >> 16 & 255, ee[ae * 17 + 16] = ve.length >> 24 & 255;
  }
  return Z;
}, deriveLeaf = (ie, Z) => {
  if (ie.byteLength < 17)
    return null;
  const ee = ie.byteLength / 17, ae = parseEntry(ie, ee - 1);
  if (ae.is_dir) {
    const ve = ae.z, ye = Z.z - ve, be = Math.trunc(Z.x / (1 << ye)), Ye = Math.trunc(Z.y / (1 << ye));
    return { z: ve, x: be, y: Ye };
  }
  return null;
};
function getHeader(ie) {
  return __async(this, null, function* () {
    const Z = yield ie.getBytes(0, 512e3), ee = new DataView(Z.data), ae = ee.getUint32(4, !0), ve = ee.getUint16(8, !0), ye = new TextDecoder("utf-8"), be = JSON.parse(
      ye.decode(new DataView(Z.data, 10, ae))
    );
    let Ye = 0;
    be.compression === "gzip" && (Ye = 2);
    let Qe = 0;
    "minzoom" in be && (Qe = +be.minzoom);
    let Je = 0;
    "maxzoom" in be && (Je = +be.maxzoom);
    let nt = 0, st = 0, ot = 0, lt = -180, ft = -85, gt = 180, ct = 85;
    if (be.bounds) {
      const Kr = be.bounds.split(",");
      lt = +Kr[0], ft = +Kr[1], gt = +Kr[2], ct = +Kr[3];
    }
    if (be.center) {
      const Kr = be.center.split(",");
      nt = +Kr[0], st = +Kr[1], ot = +Kr[2];
    }
    return {
      specVersion: ee.getUint16(2, !0),
      rootDirectoryOffset: 10 + ae,
      rootDirectoryLength: ve * 17,
      jsonMetadataOffset: 10,
      jsonMetadataLength: ae,
      leafDirectoryOffset: 0,
      leafDirectoryLength: void 0,
      tileDataOffset: 0,
      tileDataLength: void 0,
      numAddressedTiles: 0,
      numTileEntries: 0,
      numTileContents: 0,
      clustered: !1,
      internalCompression: 1,
      tileCompression: Ye,
      tileType: 1,
      minZoom: Qe,
      maxZoom: Je,
      minLon: lt,
      minLat: ft,
      maxLon: gt,
      maxLat: ct,
      centerZoom: ot,
      centerLon: nt,
      centerLat: st,
      etag: Z.etag
    };
  });
}
function getZxy(ie, Z, ee, ae, ve, ye, be) {
  return __async(this, null, function* () {
    let Ye = yield ee.getArrayBuffer(
      Z,
      ie.rootDirectoryOffset,
      ie.rootDirectoryLength,
      ie
    );
    ie.specVersion === 1 && (Ye = sortDir(Ye));
    const Qe = queryTile(new DataView(Ye), ae, ve, ye);
    if (Qe) {
      let st = (yield Z.getBytes(Qe.offset, Qe.length, be)).data;
      const ot = new DataView(st);
      return ot.getUint8(0) == 31 && ot.getUint8(1) == 139 && (st = decompressSync(new Uint8Array(st))), {
        data: st
      };
    }
    const Je = deriveLeaf(new DataView(Ye), { z: ae, x: ve, y: ye });
    if (Je) {
      const nt = queryLeafdir(
        new DataView(Ye),
        Je.z,
        Je.x,
        Je.y
      );
      if (nt) {
        let st = yield ee.getArrayBuffer(
          Z,
          nt.offset,
          nt.length,
          ie
        );
        ie.specVersion === 1 && (st = sortDir(st));
        const ot = queryTile(new DataView(st), ae, ve, ye);
        if (ot) {
          let ft = (yield Z.getBytes(
            ot.offset,
            ot.length,
            be
          )).data;
          const gt = new DataView(ft);
          return gt.getUint8(0) == 31 && gt.getUint8(1) == 139 && (ft = decompressSync(new Uint8Array(ft))), {
            data: ft
          };
        }
      }
    }
  });
}
var v2_default = {
  getHeader,
  getZxy
};
function toNum(ie, Z) {
  return (Z >>> 0) * 4294967296 + (ie >>> 0);
}
function readVarintRemainder(ie, Z) {
  const ee = Z.buf;
  let ae, ve;
  if (ve = ee[Z.pos++], ae = (ve & 112) >> 4, ve < 128 || (ve = ee[Z.pos++], ae |= (ve & 127) << 3, ve < 128) || (ve = ee[Z.pos++], ae |= (ve & 127) << 10, ve < 128) || (ve = ee[Z.pos++], ae |= (ve & 127) << 17, ve < 128) || (ve = ee[Z.pos++], ae |= (ve & 127) << 24, ve < 128) || (ve = ee[Z.pos++], ae |= (ve & 1) << 31, ve < 128))
    return toNum(ie, ae);
  throw new Error("Expected varint not more than 10 bytes");
}
function readVarint(ie) {
  const Z = ie.buf;
  let ee, ae;
  return ae = Z[ie.pos++], ee = ae & 127, ae < 128 || (ae = Z[ie.pos++], ee |= (ae & 127) << 7, ae < 128) || (ae = Z[ie.pos++], ee |= (ae & 127) << 14, ae < 128) || (ae = Z[ie.pos++], ee |= (ae & 127) << 21, ae < 128) ? ee : (ae = Z[ie.pos], ee |= (ae & 15) << 28, readVarintRemainder(ee, ie));
}
function rotate(ie, Z, ee, ae) {
  if (ae == 0) {
    ee == 1 && (Z[0] = ie - 1 - Z[0], Z[1] = ie - 1 - Z[1]);
    const ve = Z[0];
    Z[0] = Z[1], Z[1] = ve;
  }
}
var tzValues = [
  0,
  1,
  5,
  21,
  85,
  341,
  1365,
  5461,
  21845,
  87381,
  349525,
  1398101,
  5592405,
  22369621,
  89478485,
  357913941,
  1431655765,
  5726623061,
  22906492245,
  91625968981,
  366503875925,
  1466015503701,
  5864062014805,
  23456248059221,
  93824992236885,
  375299968947541,
  1501199875790165
];
function zxyToTileId(ie, Z, ee) {
  if (ie > 26)
    throw Error("Tile zoom level exceeds max safe number limit (26)");
  if (Z > Math.pow(2, ie) - 1 || ee > Math.pow(2, ie) - 1)
    throw Error("tile x/y outside zoom level bounds");
  const ae = tzValues[ie], ve = Math.pow(2, ie);
  let ye = 0, be = 0, Ye = 0;
  const Qe = [Z, ee];
  let Je = ve / 2;
  for (; Je > 0; )
    ye = (Qe[0] & Je) > 0 ? 1 : 0, be = (Qe[1] & Je) > 0 ? 1 : 0, Ye += Je * Je * (3 * ye ^ be), rotate(Je, Qe, ye, be), Je = Je / 2;
  return ae + Ye;
}
function defaultDecompress(ie, Z) {
  return __async(this, null, function* () {
    if (Z === 1 || Z === 0)
      return ie;
    if (Z === 2) {
      if (typeof globalThis.DecompressionStream > "u")
        return decompressSync(new Uint8Array(ie));
      {
        let ae = new Response(ie).body.pipeThrough(
          new globalThis.DecompressionStream("gzip")
        );
        return new Response(ae).arrayBuffer();
      }
    } else
      throw Error("Compression method not supported");
  });
}
var HEADER_SIZE_BYTES = 127;
function findTile(ie, Z) {
  let ee = 0, ae = ie.length - 1;
  for (; ee <= ae; ) {
    const ve = ae + ee >> 1, ye = Z - ie[ve].tileId;
    if (ye > 0)
      ee = ve + 1;
    else if (ye < 0)
      ae = ve - 1;
    else
      return ie[ve];
  }
  return ae >= 0 && (ie[ae].runLength === 0 || Z - ie[ae].tileId < ie[ae].runLength) ? ie[ae] : null;
}
var FetchSource = class {
  constructor(ie, Z = new Headers()) {
    this.url = ie, this.customHeaders = Z;
  }
  getKey() {
    return this.url;
  }
  setHeaders(ie) {
    this.customHeaders = ie;
  }
  getBytes(ie, Z, ee) {
    return __async(this, null, function* () {
      let ae;
      ee || (ae = new AbortController(), ee = ae.signal);
      const ve = new Headers(this.customHeaders);
      ve.set(
        "Range",
        "bytes=" + ie + "-" + (ie + Z - 1)
      );
      let ye = yield fetch(this.url, {
        signal: ee,
        headers: ve
      });
      if (ye.status === 416 && ie === 0) {
        const Qe = ye.headers.get("Content-Range");
        if (!Qe || !Qe.startsWith("bytes */"))
          throw Error("Missing content-length on 416 response");
        const Je = +Qe.substr(8);
        ye = yield fetch(this.url, {
          signal: ee,
          headers: { Range: "bytes=0-" + (Je - 1) }
        });
      }
      if (ye.status >= 300)
        throw Error("Bad response code: " + ye.status);
      const be = ye.headers.get("Content-Length");
      if (ye.status === 200 && (!be || +be > Z))
        throw ae && ae.abort(), Error(
          "Server returned no content-length header or content-length exceeding request. Check that your storage backend supports HTTP Byte Serving."
        );
      return {
        data: yield ye.arrayBuffer(),
        etag: ye.headers.get("ETag") || void 0,
        cacheControl: ye.headers.get("Cache-Control") || void 0,
        expires: ye.headers.get("Expires") || void 0
      };
    });
  }
};
function getUint64(ie, Z) {
  const ee = ie.getUint32(Z + 4, !0), ae = ie.getUint32(Z + 0, !0);
  return ee * Math.pow(2, 32) + ae;
}
function bytesToHeader(ie, Z) {
  const ee = new DataView(ie), ae = ee.getUint8(7);
  if (ae > 3)
    throw Error(
      `Archive is spec version ${ae} but this library supports up to spec version 3`
    );
  return {
    specVersion: ae,
    rootDirectoryOffset: getUint64(ee, 8),
    rootDirectoryLength: getUint64(ee, 16),
    jsonMetadataOffset: getUint64(ee, 24),
    jsonMetadataLength: getUint64(ee, 32),
    leafDirectoryOffset: getUint64(ee, 40),
    leafDirectoryLength: getUint64(ee, 48),
    tileDataOffset: getUint64(ee, 56),
    tileDataLength: getUint64(ee, 64),
    numAddressedTiles: getUint64(ee, 72),
    numTileEntries: getUint64(ee, 80),
    numTileContents: getUint64(ee, 88),
    clustered: ee.getUint8(96) === 1,
    internalCompression: ee.getUint8(97),
    tileCompression: ee.getUint8(98),
    tileType: ee.getUint8(99),
    minZoom: ee.getUint8(100),
    maxZoom: ee.getUint8(101),
    minLon: ee.getInt32(102, !0) / 1e7,
    minLat: ee.getInt32(106, !0) / 1e7,
    maxLon: ee.getInt32(110, !0) / 1e7,
    maxLat: ee.getInt32(114, !0) / 1e7,
    centerZoom: ee.getUint8(118),
    centerLon: ee.getInt32(119, !0) / 1e7,
    centerLat: ee.getInt32(123, !0) / 1e7,
    etag: Z
  };
}
function deserializeIndex(ie) {
  const Z = { buf: new Uint8Array(ie), pos: 0 }, ee = readVarint(Z), ae = [];
  let ve = 0;
  for (let ye = 0; ye < ee; ye++) {
    const be = readVarint(Z);
    ae.push({ tileId: ve + be, offset: 0, length: 0, runLength: 1 }), ve += be;
  }
  for (let ye = 0; ye < ee; ye++)
    ae[ye].runLength = readVarint(Z);
  for (let ye = 0; ye < ee; ye++)
    ae[ye].length = readVarint(Z);
  for (let ye = 0; ye < ee; ye++) {
    const be = readVarint(Z);
    be === 0 && ye > 0 ? ae[ye].offset = ae[ye - 1].offset + ae[ye - 1].length : ae[ye].offset = be - 1;
  }
  return ae;
}
function detectVersion(ie) {
  const Z = new DataView(ie);
  return Z.getUint16(2, !0) === 2 ? (console.warn(
    "PMTiles spec version 2 has been deprecated; please see github.com/protomaps/PMTiles for tools to upgrade"
  ), 2) : Z.getUint16(2, !0) === 1 ? (console.warn(
    "PMTiles spec version 1 has been deprecated; please see github.com/protomaps/PMTiles for tools to upgrade"
  ), 1) : 3;
}
var EtagMismatch = class extends Error {
};
function getHeaderAndRoot(ie, Z, ee, ae) {
  return __async(this, null, function* () {
    const ve = yield ie.getBytes(0, 16384);
    if (new DataView(ve.data).getUint16(0, !0) !== 19792)
      throw new Error("Wrong magic number for PMTiles archive");
    if (detectVersion(ve.data) < 3)
      return [yield v2_default.getHeader(ie)];
    const be = ve.data.slice(0, HEADER_SIZE_BYTES);
    let Ye = ve.etag;
    ae && ve.etag != ae && (console.warn(
      "ETag conflict detected; your HTTP server might not support content-based ETag headers. ETags disabled for " + ie.getKey()
    ), Ye = void 0);
    const Qe = bytesToHeader(be, Ye);
    if (ee) {
      const Je = ve.data.slice(
        Qe.rootDirectoryOffset,
        Qe.rootDirectoryOffset + Qe.rootDirectoryLength
      ), nt = ie.getKey() + "|" + (Qe.etag || "") + "|" + Qe.rootDirectoryOffset + "|" + Qe.rootDirectoryLength, st = deserializeIndex(
        yield Z(Je, Qe.internalCompression)
      );
      return [Qe, [nt, st.length, st]];
    }
    return [Qe, void 0];
  });
}
function getDirectory(ie, Z, ee, ae, ve) {
  return __async(this, null, function* () {
    const ye = yield ie.getBytes(ee, ae);
    if (ve.etag && ve.etag !== ye.etag)
      throw new EtagMismatch(ye.etag);
    const be = yield Z(ye.data, ve.internalCompression), Ye = deserializeIndex(be);
    if (Ye.length === 0)
      throw new Error("Empty directory is invalid");
    return Ye;
  });
}
var SharedPromiseCache = class {
  constructor(ie = 100, Z = !0, ee = defaultDecompress) {
    this.cache = /* @__PURE__ */ new Map(), this.maxCacheEntries = ie, this.counter = 1, this.prefetch = Z, this.decompress = ee;
  }
  getHeader(ie, Z) {
    return __async(this, null, function* () {
      const ee = ie.getKey();
      if (this.cache.has(ee))
        return this.cache.get(ee).lastUsed = this.counter++, yield this.cache.get(ee).data;
      const ae = new Promise((ve, ye) => {
        getHeaderAndRoot(ie, this.decompress, this.prefetch, Z).then((be) => {
          be[1] && this.cache.set(be[1][0], {
            lastUsed: this.counter++,
            data: Promise.resolve(be[1][2])
          }), ve(be[0]), this.prune();
        }).catch((be) => {
          ye(be);
        });
      });
      return this.cache.set(ee, { lastUsed: this.counter++, data: ae }), ae;
    });
  }
  getDirectory(ie, Z, ee, ae) {
    return __async(this, null, function* () {
      const ve = ie.getKey() + "|" + (ae.etag || "") + "|" + Z + "|" + ee;
      if (this.cache.has(ve))
        return this.cache.get(ve).lastUsed = this.counter++, yield this.cache.get(ve).data;
      const ye = new Promise((be, Ye) => {
        getDirectory(ie, this.decompress, Z, ee, ae).then((Qe) => {
          be(Qe), this.prune();
        }).catch((Qe) => {
          Ye(Qe);
        });
      });
      return this.cache.set(ve, { lastUsed: this.counter++, data: ye }), ye;
    });
  }
  getArrayBuffer(ie, Z, ee, ae) {
    return __async(this, null, function* () {
      const ve = ie.getKey() + "|" + (ae.etag || "") + "|" + Z + "|" + ee;
      if (this.cache.has(ve))
        return this.cache.get(ve).lastUsed = this.counter++, yield this.cache.get(ve).data;
      const ye = new Promise((be, Ye) => {
        ie.getBytes(Z, ee).then((Qe) => {
          if (ae.etag && ae.etag !== Qe.etag)
            throw new EtagMismatch(Qe.etag);
          be(Qe.data), this.cache.has(ve), this.prune();
        }).catch((Qe) => {
          Ye(Qe);
        });
      });
      return this.cache.set(ve, { lastUsed: this.counter++, data: ye }), ye;
    });
  }
  prune() {
    if (this.cache.size >= this.maxCacheEntries) {
      let ie = 1 / 0, Z;
      this.cache.forEach(
        (ee, ae) => {
          ee.lastUsed < ie && (ie = ee.lastUsed, Z = ae);
        }
      ), Z && this.cache.delete(Z);
    }
  }
  invalidate(ie, Z) {
    return __async(this, null, function* () {
      this.cache.delete(ie.getKey()), yield this.getHeader(ie, Z);
    });
  }
}, PMTiles = class {
  constructor(ie, Z, ee) {
    typeof ie == "string" ? this.source = new FetchSource(ie) : this.source = ie, ee ? this.decompress = ee : this.decompress = defaultDecompress, Z ? this.cache = Z : this.cache = new SharedPromiseCache();
  }
  getHeader() {
    return __async(this, null, function* () {
      return yield this.cache.getHeader(this.source);
    });
  }
  getZxyAttempt(ie, Z, ee, ae) {
    return __async(this, null, function* () {
      const ve = zxyToTileId(ie, Z, ee), ye = yield this.cache.getHeader(this.source);
      if (ye.specVersion < 3)
        return v2_default.getZxy(ye, this.source, this.cache, ie, Z, ee, ae);
      if (ie < ye.minZoom || ie > ye.maxZoom)
        return;
      let be = ye.rootDirectoryOffset, Ye = ye.rootDirectoryLength;
      for (let Qe = 0; Qe <= 3; Qe++) {
        const Je = yield this.cache.getDirectory(
          this.source,
          be,
          Ye,
          ye
        ), nt = findTile(Je, ve);
        if (nt)
          if (nt.runLength > 0) {
            const st = yield this.source.getBytes(
              ye.tileDataOffset + nt.offset,
              nt.length,
              ae
            );
            if (ye.etag && ye.etag !== st.etag)
              throw new EtagMismatch(st.etag);
            return {
              data: yield this.decompress(st.data, ye.tileCompression),
              cacheControl: st.cacheControl,
              expires: st.expires
            };
          } else
            be = ye.leafDirectoryOffset + nt.offset, Ye = nt.length;
        else
          return;
      }
      throw Error("Maximum directory depth exceeded");
    });
  }
  getZxy(ie, Z, ee, ae) {
    return __async(this, null, function* () {
      try {
        return yield this.getZxyAttempt(ie, Z, ee, ae);
      } catch (ve) {
        if (ve instanceof EtagMismatch)
          return this.cache.invalidate(this.source, ve.message), yield this.getZxyAttempt(ie, Z, ee, ae);
        throw ve;
      }
    });
  }
  getMetadataAttempt() {
    return __async(this, null, function* () {
      const ie = yield this.cache.getHeader(this.source), Z = yield this.source.getBytes(
        ie.jsonMetadataOffset,
        ie.jsonMetadataLength
      );
      if (ie.etag && ie.etag !== Z.etag)
        throw new EtagMismatch(Z.etag);
      const ee = yield this.decompress(
        Z.data,
        ie.internalCompression
      ), ae = new TextDecoder("utf-8");
      return JSON.parse(ae.decode(ee));
    });
  }
  getMetadata() {
    return __async(this, null, function* () {
      try {
        return yield this.getMetadataAttempt();
      } catch (ie) {
        if (ie instanceof EtagMismatch)
          return this.cache.invalidate(this.source, ie.message), yield this.getMetadataAttempt();
        throw ie;
      }
    });
  }
};
class PMTilesVectorSource extends VectorTile {
  constructor(ee) {
    super({
      ...ee,
      state: "loading",
      url: "pmtiles://" + ee.url + "/{z}/{x}/{y}",
      format: new MVT()
    });
    Sc(this, "tileLoadFunction", (ee, ae) => {
      const ve = new RegExp(/pmtiles:\/\/(.+)\/(\d+)\/(\d+)\/(\d+)/), ye = ae.match(ve), be = +ye[2], Ye = +ye[3], Qe = +ye[4];
      ee.setLoader((Je, nt, st) => {
        ee.setState(TileState.LOADING), this.pmtiles_.getZxy(be, Ye, Qe).then((ot) => {
          if (ot) {
            const lt = ee.getFormat();
            ee.setFeatures(
              lt.readFeatures(ot.data, {
                extent: Je,
                featureProjection: st
              })
            ), ee.setState(TileState.LOADED);
          } else
            ee.setFeatures([]), ee.setState(TileState.EMPTY);
        }).catch((ot) => {
          ee.setFeatures([]), ee.setState(TileState.ERROR);
        });
      });
    });
    const ae = new FetchSource(
      ee.url,
      new Headers(ee.headers)
    );
    this.pmtiles_ = new PMTiles(ae), this.pmtiles_.getHeader().then((ve) => {
      this.tileGrid.minZoom = ve.minZoom, this.tileGrid.maxZoom = ve.maxZoom, this.setTileLoadFunction(this.tileLoadFunction), this.setState("ready");
    });
  }
}
const openLayersBasemaps = {
  darkMatter: {
    url: "https://{a-d}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://carto.com/attributions">Carto</a>',
    maxZoom: 18
  },
  positron: {
    url: "https://{a-d}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://carto.com/attributions">Carto</a>',
    maxZoom: 18
  },
  positronLite: {
    url: "https://{a-d}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://carto.com/attributions">Carto</a>',
    maxZoom: 18
  },
  worldAntique: {
    url: "https://cartocdn_{a-d}.global.ssl.fastly.net/base-antique/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://carto.com/attributions">Carto</a>',
    maxZoom: 18
  },
  worldEco: {
    url: "https://cartocdn_{a-d}.global.ssl.fastly.net/base-eco/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://carto.com/attributions">Carto</a>',
    maxZoom: 18
  },
  flatBlue: {
    url: "https://cartocdn_{a-d}.global.ssl.fastly.net/base-flatblue/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://carto.com/attributions">Carto</a>',
    maxZoom: 18
  },
  midnightCommander: {
    url: "https://cartocdn_{a-d}.global.ssl.fastly.net/base-midnight/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://carto.com/attributions">Carto</a>',
    maxZoom: 18
  },
  openstreetmapHot: {
    url: "https://{a-c}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>',
    maxZoom: 19
  },
  openstreetmapStandard: {
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19
  }
};
class OlInitializer {
  constructor() {
    this.element = document.getElementById("ol-map"), this.element && (this.data = this.element.dataset, this.extent = new GeoJSON().readFeatures(this.data.mapGeom)[0].getGeometry().getExtent());
  }
  run() {
    if (!this.element)
      return !1;
    this.data.protocol === "Pmtiles" ? this.initializePmtiles() : this.data.protocol === "Cog" && this.initializeCog();
  }
  baseLayer() {
    const Z = openLayersBasemaps[this.data.basemap];
    return new TileLayer({
      source: new XYZ({
        attributions: Z.attribution,
        url: Z.url,
        maxZoom: Z.maxZoom
      })
    });
  }
  initializePmtiles() {
    const Z = new VectorTileLayer({
      declutter: !0,
      source: new PMTilesVectorSource({
        url: this.data.url
      }),
      style: new Style$1({
        stroke: new Stroke({
          color: "#7070B3",
          width: 1
        }),
        fill: new Fill({
          color: "#FFFFFF"
        }),
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({
            color: "#7070B3"
          }),
          stroke: new Stroke({
            color: "#FFFFFF",
            width: 2
          })
        })
      })
    });
    useGeographic();
    const ee = new Map$1({
      controls: defaults$2().extend([new FullScreen()]),
      layers: [this.baseLayer(), Z],
      target: "ol-map"
    });
    ee.getView().fit(this.extent, ee.getSize());
  }
  initializeCog() {
    const Z = new GeoTIFFSource({
      sources: [{ url: this.data.url }]
    });
    Z.getView().then((ee) => {
      const ae = new Map$1({
        controls: defaults$2().extend([new FullScreen()]),
        target: "ol-map",
        layers: [
          this.baseLayer(),
          new WebGLTileLayer({
            source: Z
          })
        ],
        view: new View({
          center: ee.center
        })
      });
      ae.getView().fit(ee.extent, ae.getSize());
    });
  }
}
var react = { exports: {} }, react_production_min = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReact_production_min;
function requireReact_production_min() {
  if (hasRequiredReact_production_min)
    return react_production_min;
  hasRequiredReact_production_min = 1;
  var ie = Symbol.for("react.element"), Z = Symbol.for("react.portal"), ee = Symbol.for("react.fragment"), ae = Symbol.for("react.strict_mode"), ve = Symbol.for("react.profiler"), ye = Symbol.for("react.provider"), be = Symbol.for("react.context"), Ye = Symbol.for("react.forward_ref"), Qe = Symbol.for("react.suspense"), Je = Symbol.for("react.memo"), nt = Symbol.for("react.lazy"), st = Symbol.iterator;
  function ot(hi) {
    return hi === null || typeof hi != "object" ? null : (hi = st && hi[st] || hi["@@iterator"], typeof hi == "function" ? hi : null);
  }
  var lt = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, ft = Object.assign, gt = {};
  function ct(hi, Di, Ri) {
    this.props = hi, this.context = Di, this.refs = gt, this.updater = Ri || lt;
  }
  ct.prototype.isReactComponent = {}, ct.prototype.setState = function(hi, Di) {
    if (typeof hi != "object" && typeof hi != "function" && hi != null)
      throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, hi, Di, "setState");
  }, ct.prototype.forceUpdate = function(hi) {
    this.updater.enqueueForceUpdate(this, hi, "forceUpdate");
  };
  function _r() {
  }
  _r.prototype = ct.prototype;
  function Kr(hi, Di, Ri) {
    this.props = hi, this.context = Di, this.refs = gt, this.updater = Ri || lt;
  }
  var Xr = Kr.prototype = new _r();
  Xr.constructor = Kr, ft(Xr, ct.prototype), Xr.isPureReactComponent = !0;
  var Jr = Array.isArray, ei = Object.prototype.hasOwnProperty, si = { current: null }, ri = { key: !0, ref: !0, __self: !0, __source: !0 };
  function ai(hi, Di, Ri) {
    var rs, Hi = {}, qi = null, us = null;
    if (Di != null)
      for (rs in Di.ref !== void 0 && (us = Di.ref), Di.key !== void 0 && (qi = "" + Di.key), Di)
        ei.call(Di, rs) && !ri.hasOwnProperty(rs) && (Hi[rs] = Di[rs]);
    var Yi = arguments.length - 2;
    if (Yi === 1)
      Hi.children = Ri;
    else if (1 < Yi) {
      for (var is = Array(Yi), Ss = 0; Ss < Yi; Ss++)
        is[Ss] = arguments[Ss + 2];
      Hi.children = is;
    }
    if (hi && hi.defaultProps)
      for (rs in Yi = hi.defaultProps, Yi)
        Hi[rs] === void 0 && (Hi[rs] = Yi[rs]);
    return { $$typeof: ie, type: hi, key: qi, ref: us, props: Hi, _owner: si.current };
  }
  function yi(hi, Di) {
    return { $$typeof: ie, type: hi.type, key: Di, ref: hi.ref, props: hi.props, _owner: hi._owner };
  }
  function pi(hi) {
    return typeof hi == "object" && hi !== null && hi.$$typeof === ie;
  }
  function di(hi) {
    var Di = { "=": "=0", ":": "=2" };
    return "$" + hi.replace(/[=:]/g, function(Ri) {
      return Di[Ri];
    });
  }
  var xi = /\/+/g;
  function Ti(hi, Di) {
    return typeof hi == "object" && hi !== null && hi.key != null ? di("" + hi.key) : Di.toString(36);
  }
  function Ai(hi, Di, Ri, rs, Hi) {
    var qi = typeof hi;
    (qi === "undefined" || qi === "boolean") && (hi = null);
    var us = !1;
    if (hi === null)
      us = !0;
    else
      switch (qi) {
        case "string":
        case "number":
          us = !0;
          break;
        case "object":
          switch (hi.$$typeof) {
            case ie:
            case Z:
              us = !0;
          }
      }
    if (us)
      return us = hi, Hi = Hi(us), hi = rs === "" ? "." + Ti(us, 0) : rs, Jr(Hi) ? (Ri = "", hi != null && (Ri = hi.replace(xi, "$&/") + "/"), Ai(Hi, Di, Ri, "", function(Ss) {
        return Ss;
      })) : Hi != null && (pi(Hi) && (Hi = yi(Hi, Ri + (!Hi.key || us && us.key === Hi.key ? "" : ("" + Hi.key).replace(xi, "$&/") + "/") + hi)), Di.push(Hi)), 1;
    if (us = 0, rs = rs === "" ? "." : rs + ":", Jr(hi))
      for (var Yi = 0; Yi < hi.length; Yi++) {
        qi = hi[Yi];
        var is = rs + Ti(qi, Yi);
        us += Ai(qi, Di, Ri, is, Hi);
      }
    else if (is = ot(hi), typeof is == "function")
      for (hi = is.call(hi), Yi = 0; !(qi = hi.next()).done; )
        qi = qi.value, is = rs + Ti(qi, Yi++), us += Ai(qi, Di, Ri, is, Hi);
    else if (qi === "object")
      throw Di = String(hi), Error("Objects are not valid as a React child (found: " + (Di === "[object Object]" ? "object with keys {" + Object.keys(hi).join(", ") + "}" : Di) + "). If you meant to render a collection of children, use an array instead.");
    return us;
  }
  function mi(hi, Di, Ri) {
    if (hi == null)
      return hi;
    var rs = [], Hi = 0;
    return Ai(hi, rs, "", "", function(qi) {
      return Di.call(Ri, qi, Hi++);
    }), rs;
  }
  function Si(hi) {
    if (hi._status === -1) {
      var Di = hi._result;
      Di = Di(), Di.then(function(Ri) {
        (hi._status === 0 || hi._status === -1) && (hi._status = 1, hi._result = Ri);
      }, function(Ri) {
        (hi._status === 0 || hi._status === -1) && (hi._status = 2, hi._result = Ri);
      }), hi._status === -1 && (hi._status = 0, hi._result = Di);
    }
    if (hi._status === 1)
      return hi._result.default;
    throw hi._result;
  }
  var gi = { current: null }, _i = { transition: null }, Oi = { ReactCurrentDispatcher: gi, ReactCurrentBatchConfig: _i, ReactCurrentOwner: si };
  return react_production_min.Children = { map: mi, forEach: function(hi, Di, Ri) {
    mi(hi, function() {
      Di.apply(this, arguments);
    }, Ri);
  }, count: function(hi) {
    var Di = 0;
    return mi(hi, function() {
      Di++;
    }), Di;
  }, toArray: function(hi) {
    return mi(hi, function(Di) {
      return Di;
    }) || [];
  }, only: function(hi) {
    if (!pi(hi))
      throw Error("React.Children.only expected to receive a single React element child.");
    return hi;
  } }, react_production_min.Component = ct, react_production_min.Fragment = ee, react_production_min.Profiler = ve, react_production_min.PureComponent = Kr, react_production_min.StrictMode = ae, react_production_min.Suspense = Qe, react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Oi, react_production_min.cloneElement = function(hi, Di, Ri) {
    if (hi == null)
      throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + hi + ".");
    var rs = ft({}, hi.props), Hi = hi.key, qi = hi.ref, us = hi._owner;
    if (Di != null) {
      if (Di.ref !== void 0 && (qi = Di.ref, us = si.current), Di.key !== void 0 && (Hi = "" + Di.key), hi.type && hi.type.defaultProps)
        var Yi = hi.type.defaultProps;
      for (is in Di)
        ei.call(Di, is) && !ri.hasOwnProperty(is) && (rs[is] = Di[is] === void 0 && Yi !== void 0 ? Yi[is] : Di[is]);
    }
    var is = arguments.length - 2;
    if (is === 1)
      rs.children = Ri;
    else if (1 < is) {
      Yi = Array(is);
      for (var Ss = 0; Ss < is; Ss++)
        Yi[Ss] = arguments[Ss + 2];
      rs.children = Yi;
    }
    return { $$typeof: ie, type: hi.type, key: Hi, ref: qi, props: rs, _owner: us };
  }, react_production_min.createContext = function(hi) {
    return hi = { $$typeof: be, _currentValue: hi, _currentValue2: hi, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, hi.Provider = { $$typeof: ye, _context: hi }, hi.Consumer = hi;
  }, react_production_min.createElement = ai, react_production_min.createFactory = function(hi) {
    var Di = ai.bind(null, hi);
    return Di.type = hi, Di;
  }, react_production_min.createRef = function() {
    return { current: null };
  }, react_production_min.forwardRef = function(hi) {
    return { $$typeof: Ye, render: hi };
  }, react_production_min.isValidElement = pi, react_production_min.lazy = function(hi) {
    return { $$typeof: nt, _payload: { _status: -1, _result: hi }, _init: Si };
  }, react_production_min.memo = function(hi, Di) {
    return { $$typeof: Je, type: hi, compare: Di === void 0 ? null : Di };
  }, react_production_min.startTransition = function(hi) {
    var Di = _i.transition;
    _i.transition = {};
    try {
      hi();
    } finally {
      _i.transition = Di;
    }
  }, react_production_min.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
  }, react_production_min.useCallback = function(hi, Di) {
    return gi.current.useCallback(hi, Di);
  }, react_production_min.useContext = function(hi) {
    return gi.current.useContext(hi);
  }, react_production_min.useDebugValue = function() {
  }, react_production_min.useDeferredValue = function(hi) {
    return gi.current.useDeferredValue(hi);
  }, react_production_min.useEffect = function(hi, Di) {
    return gi.current.useEffect(hi, Di);
  }, react_production_min.useId = function() {
    return gi.current.useId();
  }, react_production_min.useImperativeHandle = function(hi, Di, Ri) {
    return gi.current.useImperativeHandle(hi, Di, Ri);
  }, react_production_min.useInsertionEffect = function(hi, Di) {
    return gi.current.useInsertionEffect(hi, Di);
  }, react_production_min.useLayoutEffect = function(hi, Di) {
    return gi.current.useLayoutEffect(hi, Di);
  }, react_production_min.useMemo = function(hi, Di) {
    return gi.current.useMemo(hi, Di);
  }, react_production_min.useReducer = function(hi, Di, Ri) {
    return gi.current.useReducer(hi, Di, Ri);
  }, react_production_min.useRef = function(hi) {
    return gi.current.useRef(hi);
  }, react_production_min.useState = function(hi) {
    return gi.current.useState(hi);
  }, react_production_min.useSyncExternalStore = function(hi, Di, Ri) {
    return gi.current.useSyncExternalStore(hi, Di, Ri);
  }, react_production_min.useTransition = function() {
    return gi.current.useTransition();
  }, react_production_min.version = "18.2.0", react_production_min;
}
var react_development = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
react_development.exports;
var hasRequiredReact_development;
function requireReact_development() {
  return hasRequiredReact_development || (hasRequiredReact_development = 1, function(ie, Z) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var ee = "18.2.0", ae = Symbol.for("react.element"), ve = Symbol.for("react.portal"), ye = Symbol.for("react.fragment"), be = Symbol.for("react.strict_mode"), Ye = Symbol.for("react.profiler"), Qe = Symbol.for("react.provider"), Je = Symbol.for("react.context"), nt = Symbol.for("react.forward_ref"), st = Symbol.for("react.suspense"), ot = Symbol.for("react.suspense_list"), lt = Symbol.for("react.memo"), ft = Symbol.for("react.lazy"), gt = Symbol.for("react.offscreen"), ct = Symbol.iterator, _r = "@@iterator";
      function Kr(ui) {
        if (ui === null || typeof ui != "object")
          return null;
        var Ii = ct && ui[ct] || ui[_r];
        return typeof Ii == "function" ? Ii : null;
      }
      var Xr = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, Jr = {
        transition: null
      }, ei = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, si = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, ri = {}, ai = null;
      function yi(ui) {
        ai = ui;
      }
      ri.setExtraStackFrame = function(ui) {
        ai = ui;
      }, ri.getCurrentStack = null, ri.getStackAddendum = function() {
        var ui = "";
        ai && (ui += ai);
        var Ii = ri.getCurrentStack;
        return Ii && (ui += Ii() || ""), ui;
      };
      var pi = !1, di = !1, xi = !1, Ti = !1, Ai = !1, mi = {
        ReactCurrentDispatcher: Xr,
        ReactCurrentBatchConfig: Jr,
        ReactCurrentOwner: si
      };
      mi.ReactDebugCurrentFrame = ri, mi.ReactCurrentActQueue = ei;
      function Si(ui) {
        {
          for (var Ii = arguments.length, Vi = new Array(Ii > 1 ? Ii - 1 : 0), Ki = 1; Ki < Ii; Ki++)
            Vi[Ki - 1] = arguments[Ki];
          _i("warn", ui, Vi);
        }
      }
      function gi(ui) {
        {
          for (var Ii = arguments.length, Vi = new Array(Ii > 1 ? Ii - 1 : 0), Ki = 1; Ki < Ii; Ki++)
            Vi[Ki - 1] = arguments[Ki];
          _i("error", ui, Vi);
        }
      }
      function _i(ui, Ii, Vi) {
        {
          var Ki = mi.ReactDebugCurrentFrame, ps = Ki.getStackAddendum();
          ps !== "" && (Ii += "%s", Vi = Vi.concat([ps]));
          var Zs = Vi.map(function(xs) {
            return String(xs);
          });
          Zs.unshift("Warning: " + Ii), Function.prototype.apply.call(console[ui], console, Zs);
        }
      }
      var Oi = {};
      function hi(ui, Ii) {
        {
          var Vi = ui.constructor, Ki = Vi && (Vi.displayName || Vi.name) || "ReactClass", ps = Ki + "." + Ii;
          if (Oi[ps])
            return;
          gi("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", Ii, Ki), Oi[ps] = !0;
        }
      }
      var Di = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(ui) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(ui, Ii, Vi) {
          hi(ui, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(ui, Ii, Vi, Ki) {
          hi(ui, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(ui, Ii, Vi, Ki) {
          hi(ui, "setState");
        }
      }, Ri = Object.assign, rs = {};
      Object.freeze(rs);
      function Hi(ui, Ii, Vi) {
        this.props = ui, this.context = Ii, this.refs = rs, this.updater = Vi || Di;
      }
      Hi.prototype.isReactComponent = {}, Hi.prototype.setState = function(ui, Ii) {
        if (typeof ui != "object" && typeof ui != "function" && ui != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, ui, Ii, "setState");
      }, Hi.prototype.forceUpdate = function(ui) {
        this.updater.enqueueForceUpdate(this, ui, "forceUpdate");
      };
      {
        var qi = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, us = function(ui, Ii) {
          Object.defineProperty(Hi.prototype, ui, {
            get: function() {
              Si("%s(...) is deprecated in plain JavaScript React classes. %s", Ii[0], Ii[1]);
            }
          });
        };
        for (var Yi in qi)
          qi.hasOwnProperty(Yi) && us(Yi, qi[Yi]);
      }
      function is() {
      }
      is.prototype = Hi.prototype;
      function Ss(ui, Ii, Vi) {
        this.props = ui, this.context = Ii, this.refs = rs, this.updater = Vi || Di;
      }
      var Gs = Ss.prototype = new is();
      Gs.constructor = Ss, Ri(Gs, Hi.prototype), Gs.isPureReactComponent = !0;
      function Vs() {
        var ui = {
          current: null
        };
        return Object.seal(ui), ui;
      }
      var Ws = Array.isArray;
      function ii(ui) {
        return Ws(ui);
      }
      function bi(ui) {
        {
          var Ii = typeof Symbol == "function" && Symbol.toStringTag, Vi = Ii && ui[Symbol.toStringTag] || ui.constructor.name || "Object";
          return Vi;
        }
      }
      function Gi(ui) {
        try {
          return Qi(ui), !1;
        } catch {
          return !0;
        }
      }
      function Qi(ui) {
        return "" + ui;
      }
      function ns(ui) {
        if (Gi(ui))
          return gi("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", bi(ui)), Qi(ui);
      }
      function Bs(ui, Ii, Vi) {
        var Ki = ui.displayName;
        if (Ki)
          return Ki;
        var ps = Ii.displayName || Ii.name || "";
        return ps !== "" ? Vi + "(" + ps + ")" : Vi;
      }
      function ms(ui) {
        return ui.displayName || "Context";
      }
      function Ks(ui) {
        if (ui == null)
          return null;
        if (typeof ui.tag == "number" && gi("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof ui == "function")
          return ui.displayName || ui.name || null;
        if (typeof ui == "string")
          return ui;
        switch (ui) {
          case ye:
            return "Fragment";
          case ve:
            return "Portal";
          case Ye:
            return "Profiler";
          case be:
            return "StrictMode";
          case st:
            return "Suspense";
          case ot:
            return "SuspenseList";
        }
        if (typeof ui == "object")
          switch (ui.$$typeof) {
            case Je:
              var Ii = ui;
              return ms(Ii) + ".Consumer";
            case Qe:
              var Vi = ui;
              return ms(Vi._context) + ".Provider";
            case nt:
              return Bs(ui, ui.render, "ForwardRef");
            case lt:
              var Ki = ui.displayName || null;
              return Ki !== null ? Ki : Ks(ui.type) || "Memo";
            case ft: {
              var ps = ui, Zs = ps._payload, xs = ps._init;
              try {
                return Ks(xs(Zs));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Js = Object.prototype.hasOwnProperty, Ns = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ts, lo, Fs;
      Fs = {};
      function xo(ui) {
        if (Js.call(ui, "ref")) {
          var Ii = Object.getOwnPropertyDescriptor(ui, "ref").get;
          if (Ii && Ii.isReactWarning)
            return !1;
        }
        return ui.ref !== void 0;
      }
      function mo(ui) {
        if (Js.call(ui, "key")) {
          var Ii = Object.getOwnPropertyDescriptor(ui, "key").get;
          if (Ii && Ii.isReactWarning)
            return !1;
        }
        return ui.key !== void 0;
      }
      function Wo(ui, Ii) {
        var Vi = function() {
          Ts || (Ts = !0, gi("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ii));
        };
        Vi.isReactWarning = !0, Object.defineProperty(ui, "key", {
          get: Vi,
          configurable: !0
        });
      }
      function Ta(ui, Ii) {
        var Vi = function() {
          lo || (lo = !0, gi("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ii));
        };
        Vi.isReactWarning = !0, Object.defineProperty(ui, "ref", {
          get: Vi,
          configurable: !0
        });
      }
      function Aa(ui) {
        if (typeof ui.ref == "string" && si.current && ui.__self && si.current.stateNode !== ui.__self) {
          var Ii = Ks(si.current.type);
          Fs[Ii] || (gi('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Ii, ui.ref), Fs[Ii] = !0);
        }
      }
      var hs = function(ui, Ii, Vi, Ki, ps, Zs, xs) {
        var Ys = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: ae,
          // Built-in properties that belong on the element
          type: ui,
          key: Ii,
          ref: Vi,
          props: xs,
          // Record the component responsible for creating this element.
          _owner: Zs
        };
        return Ys._store = {}, Object.defineProperty(Ys._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Ys, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ki
        }), Object.defineProperty(Ys, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ps
        }), Object.freeze && (Object.freeze(Ys.props), Object.freeze(Ys)), Ys;
      };
      function Os(ui, Ii, Vi) {
        var Ki, ps = {}, Zs = null, xs = null, Ys = null, yo = null;
        if (Ii != null) {
          xo(Ii) && (xs = Ii.ref, Aa(Ii)), mo(Ii) && (ns(Ii.key), Zs = "" + Ii.key), Ys = Ii.__self === void 0 ? null : Ii.__self, yo = Ii.__source === void 0 ? null : Ii.__source;
          for (Ki in Ii)
            Js.call(Ii, Ki) && !Ns.hasOwnProperty(Ki) && (ps[Ki] = Ii[Ki]);
        }
        var Io = arguments.length - 2;
        if (Io === 1)
          ps.children = Vi;
        else if (Io > 1) {
          for (var Ho = Array(Io), Bo = 0; Bo < Io; Bo++)
            Ho[Bo] = arguments[Bo + 2];
          Object.freeze && Object.freeze(Ho), ps.children = Ho;
        }
        if (ui && ui.defaultProps) {
          var zo = ui.defaultProps;
          for (Ki in zo)
            ps[Ki] === void 0 && (ps[Ki] = zo[Ki]);
        }
        if (Zs || xs) {
          var Ko = typeof ui == "function" ? ui.displayName || ui.name || "Unknown" : ui;
          Zs && Wo(ps, Ko), xs && Ta(ps, Ko);
        }
        return hs(ui, Zs, xs, Ys, yo, si.current, ps);
      }
      function ho(ui, Ii) {
        var Vi = hs(ui.type, Ii, ui.ref, ui._self, ui._source, ui._owner, ui.props);
        return Vi;
      }
      function Ao(ui, Ii, Vi) {
        if (ui == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + ui + ".");
        var Ki, ps = Ri({}, ui.props), Zs = ui.key, xs = ui.ref, Ys = ui._self, yo = ui._source, Io = ui._owner;
        if (Ii != null) {
          xo(Ii) && (xs = Ii.ref, Io = si.current), mo(Ii) && (ns(Ii.key), Zs = "" + Ii.key);
          var Ho;
          ui.type && ui.type.defaultProps && (Ho = ui.type.defaultProps);
          for (Ki in Ii)
            Js.call(Ii, Ki) && !Ns.hasOwnProperty(Ki) && (Ii[Ki] === void 0 && Ho !== void 0 ? ps[Ki] = Ho[Ki] : ps[Ki] = Ii[Ki]);
        }
        var Bo = arguments.length - 2;
        if (Bo === 1)
          ps.children = Vi;
        else if (Bo > 1) {
          for (var zo = Array(Bo), Ko = 0; Ko < Bo; Ko++)
            zo[Ko] = arguments[Ko + 2];
          ps.children = zo;
        }
        return hs(ui.type, Zs, xs, Ys, yo, Io, ps);
      }
      function ci(ui) {
        return typeof ui == "object" && ui !== null && ui.$$typeof === ae;
      }
      var li = ".", Ci = ":";
      function Li(ui) {
        var Ii = /[=:]/g, Vi = {
          "=": "=0",
          ":": "=2"
        }, Ki = ui.replace(Ii, function(ps) {
          return Vi[ps];
        });
        return "$" + Ki;
      }
      var es = !1, Es = /\/+/g;
      function ls(ui) {
        return ui.replace(Es, "$&/");
      }
      function ss(ui, Ii) {
        return typeof ui == "object" && ui !== null && ui.key != null ? (ns(ui.key), Li("" + ui.key)) : Ii.toString(36);
      }
      function Hs(ui, Ii, Vi, Ki, ps) {
        var Zs = typeof ui;
        (Zs === "undefined" || Zs === "boolean") && (ui = null);
        var xs = !1;
        if (ui === null)
          xs = !0;
        else
          switch (Zs) {
            case "string":
            case "number":
              xs = !0;
              break;
            case "object":
              switch (ui.$$typeof) {
                case ae:
                case ve:
                  xs = !0;
              }
          }
        if (xs) {
          var Ys = ui, yo = ps(Ys), Io = Ki === "" ? li + ss(Ys, 0) : Ki;
          if (ii(yo)) {
            var Ho = "";
            Io != null && (Ho = ls(Io) + "/"), Hs(yo, Ii, Ho, "", function(hm) {
              return hm;
            });
          } else
            yo != null && (ci(yo) && (yo.key && (!Ys || Ys.key !== yo.key) && ns(yo.key), yo = ho(
              yo,
              // Keep both the (mapped) and old keys if they differ, just as
              // traverseAllChildren used to do for objects as children
              Vi + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
              (yo.key && (!Ys || Ys.key !== yo.key) ? (
                // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                // eslint-disable-next-line react-internal/safe-string-coercion
                ls("" + yo.key) + "/"
              ) : "") + Io
            )), Ii.push(yo));
          return 1;
        }
        var Bo, zo, Ko = 0, _o = Ki === "" ? li : Ki + Ci;
        if (ii(ui))
          for (var Yu = 0; Yu < ui.length; Yu++)
            Bo = ui[Yu], zo = _o + ss(Bo, Yu), Ko += Hs(Bo, Ii, Vi, zo, ps);
        else {
          var Ef = Kr(ui);
          if (typeof Ef == "function") {
            var Eh = ui;
            Ef === Eh.entries && (es || Si("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), es = !0);
            for (var fm = Ef.call(Eh), Tu, xh = 0; !(Tu = fm.next()).done; )
              Bo = Tu.value, zo = _o + ss(Bo, xh++), Ko += Hs(Bo, Ii, Vi, zo, ps);
          } else if (Zs === "object") {
            var Th = String(ui);
            throw new Error("Objects are not valid as a React child (found: " + (Th === "[object Object]" ? "object with keys {" + Object.keys(ui).join(", ") + "}" : Th) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return Ko;
      }
      function eo(ui, Ii, Vi) {
        if (ui == null)
          return ui;
        var Ki = [], ps = 0;
        return Hs(ui, Ki, "", "", function(Zs) {
          return Ii.call(Vi, Zs, ps++);
        }), Ki;
      }
      function Us(ui) {
        var Ii = 0;
        return eo(ui, function() {
          Ii++;
        }), Ii;
      }
      function To(ui, Ii, Vi) {
        eo(ui, function() {
          Ii.apply(this, arguments);
        }, Vi);
      }
      function Ms(ui) {
        return eo(ui, function(Ii) {
          return Ii;
        }) || [];
      }
      function da(ui) {
        if (!ci(ui))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return ui;
      }
      function qo(ui) {
        var Ii = {
          $$typeof: Je,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: ui,
          _currentValue2: ui,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        Ii.Provider = {
          $$typeof: Qe,
          _context: Ii
        };
        var Vi = !1, Ki = !1, ps = !1;
        {
          var Zs = {
            $$typeof: Je,
            _context: Ii
          };
          Object.defineProperties(Zs, {
            Provider: {
              get: function() {
                return Ki || (Ki = !0, gi("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), Ii.Provider;
              },
              set: function(xs) {
                Ii.Provider = xs;
              }
            },
            _currentValue: {
              get: function() {
                return Ii._currentValue;
              },
              set: function(xs) {
                Ii._currentValue = xs;
              }
            },
            _currentValue2: {
              get: function() {
                return Ii._currentValue2;
              },
              set: function(xs) {
                Ii._currentValue2 = xs;
              }
            },
            _threadCount: {
              get: function() {
                return Ii._threadCount;
              },
              set: function(xs) {
                Ii._threadCount = xs;
              }
            },
            Consumer: {
              get: function() {
                return Vi || (Vi = !0, gi("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), Ii.Consumer;
              }
            },
            displayName: {
              get: function() {
                return Ii.displayName;
              },
              set: function(xs) {
                ps || (Si("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", xs), ps = !0);
              }
            }
          }), Ii.Consumer = Zs;
        }
        return Ii._currentRenderer = null, Ii._currentRenderer2 = null, Ii;
      }
      var ba = -1, ll = 0, Yo = 1, va = 2;
      function ia(ui) {
        if (ui._status === ba) {
          var Ii = ui._result, Vi = Ii();
          if (Vi.then(function(Zs) {
            if (ui._status === ll || ui._status === ba) {
              var xs = ui;
              xs._status = Yo, xs._result = Zs;
            }
          }, function(Zs) {
            if (ui._status === ll || ui._status === ba) {
              var xs = ui;
              xs._status = va, xs._result = Zs;
            }
          }), ui._status === ba) {
            var Ki = ui;
            Ki._status = ll, Ki._result = Vi;
          }
        }
        if (ui._status === Yo) {
          var ps = ui._result;
          return ps === void 0 && gi(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, ps), "default" in ps || gi(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, ps), ps.default;
        } else
          throw ui._result;
      }
      function Ul(ui) {
        var Ii = {
          // We use these fields to store the result.
          _status: ba,
          _result: ui
        }, Vi = {
          $$typeof: ft,
          _payload: Ii,
          _init: ia
        };
        {
          var Ki, ps;
          Object.defineProperties(Vi, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return Ki;
              },
              set: function(Zs) {
                gi("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Ki = Zs, Object.defineProperty(Vi, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return ps;
              },
              set: function(Zs) {
                gi("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), ps = Zs, Object.defineProperty(Vi, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return Vi;
      }
      function _c(ui) {
        ui != null && ui.$$typeof === lt ? gi("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof ui != "function" ? gi("forwardRef requires a render function but was given %s.", ui === null ? "null" : typeof ui) : ui.length !== 0 && ui.length !== 2 && gi("forwardRef render functions accept exactly two parameters: props and ref. %s", ui.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), ui != null && (ui.defaultProps != null || ui.propTypes != null) && gi("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var Ii = {
          $$typeof: nt,
          render: ui
        };
        {
          var Vi;
          Object.defineProperty(Ii, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return Vi;
            },
            set: function(Ki) {
              Vi = Ki, !ui.name && !ui.displayName && (ui.displayName = Ki);
            }
          });
        }
        return Ii;
      }
      var wc;
      wc = Symbol.for("react.module.reference");
      function lf(ui) {
        return !!(typeof ui == "string" || typeof ui == "function" || ui === ye || ui === Ye || Ai || ui === be || ui === st || ui === ot || Ti || ui === gt || pi || di || xi || typeof ui == "object" && ui !== null && (ui.$$typeof === ft || ui.$$typeof === lt || ui.$$typeof === Qe || ui.$$typeof === Je || ui.$$typeof === nt || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        ui.$$typeof === wc || ui.getModuleId !== void 0));
      }
      function hh(ui, Ii) {
        lf(ui) || gi("memo: The first argument must be a component. Instead received: %s", ui === null ? "null" : typeof ui);
        var Vi = {
          $$typeof: lt,
          type: ui,
          compare: Ii === void 0 ? null : Ii
        };
        {
          var Ki;
          Object.defineProperty(Vi, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return Ki;
            },
            set: function(ps) {
              Ki = ps, !ui.name && !ui.displayName && (ui.displayName = ps);
            }
          });
        }
        return Vi;
      }
      function fa() {
        var ui = Xr.current;
        return ui === null && gi(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), ui;
      }
      function Ql(ui) {
        var Ii = fa();
        if (ui._context !== void 0) {
          var Vi = ui._context;
          Vi.Consumer === ui ? gi("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : Vi.Provider === ui && gi("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return Ii.useContext(ui);
      }
      function vd(ui) {
        var Ii = fa();
        return Ii.useState(ui);
      }
      function Cc(ui, Ii, Vi) {
        var Ki = fa();
        return Ki.useReducer(ui, Ii, Vi);
      }
      function za(ui) {
        var Ii = fa();
        return Ii.useRef(ui);
      }
      function Ep(ui, Ii) {
        var Vi = fa();
        return Vi.useEffect(ui, Ii);
      }
      function xp(ui, Ii) {
        var Vi = fa();
        return Vi.useInsertionEffect(ui, Ii);
      }
      function ph(ui, Ii) {
        var Vi = fa();
        return Vi.useLayoutEffect(ui, Ii);
      }
      function Tp(ui, Ii) {
        var Vi = fa();
        return Vi.useCallback(ui, Ii);
      }
      function lm(ui, Ii) {
        var Vi = fa();
        return Vi.useMemo(ui, Ii);
      }
      function um(ui, Ii, Vi) {
        var Ki = fa();
        return Ki.useImperativeHandle(ui, Ii, Vi);
      }
      function ta(ui, Ii) {
        {
          var Vi = fa();
          return Vi.useDebugValue(ui, Ii);
        }
      }
      function cm() {
        var ui = fa();
        return ui.useTransition();
      }
      function yu(ui) {
        var Ii = fa();
        return Ii.useDeferredValue(ui);
      }
      function vo() {
        var ui = fa();
        return ui.useId();
      }
      function Iu(ui, Ii, Vi) {
        var Ki = fa();
        return Ki.useSyncExternalStore(ui, Ii, Vi);
      }
      var Rc = 0, uf, Ac, Sl, gh, ul, mh, vh;
      function bp() {
      }
      bp.__reactDisabledLog = !0;
      function cf() {
        {
          if (Rc === 0) {
            uf = console.log, Ac = console.info, Sl = console.warn, gh = console.error, ul = console.group, mh = console.groupCollapsed, vh = console.groupEnd;
            var ui = {
              configurable: !0,
              enumerable: !0,
              value: bp,
              writable: !0
            };
            Object.defineProperties(console, {
              info: ui,
              log: ui,
              warn: ui,
              error: ui,
              group: ui,
              groupCollapsed: ui,
              groupEnd: ui
            });
          }
          Rc++;
        }
      }
      function Lc() {
        {
          if (Rc--, Rc === 0) {
            var ui = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: Ri({}, ui, {
                value: uf
              }),
              info: Ri({}, ui, {
                value: Ac
              }),
              warn: Ri({}, ui, {
                value: Sl
              }),
              error: Ri({}, ui, {
                value: gh
              }),
              group: Ri({}, ui, {
                value: ul
              }),
              groupCollapsed: Ri({}, ui, {
                value: mh
              }),
              groupEnd: Ri({}, ui, {
                value: vh
              })
            });
          }
          Rc < 0 && gi("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Eu = mi.ReactCurrentDispatcher, cl;
      function Ic(ui, Ii, Vi) {
        {
          if (cl === void 0)
            try {
              throw Error();
            } catch (ps) {
              var Ki = ps.stack.trim().match(/\n( *(at )?)/);
              cl = Ki && Ki[1] || "";
            }
          return `
` + cl + ui;
        }
      }
      var Pc = !1, Dc;
      {
        var df = typeof WeakMap == "function" ? WeakMap : Map;
        Dc = new df();
      }
      function ff(ui, Ii) {
        if (!ui || Pc)
          return "";
        {
          var Vi = Dc.get(ui);
          if (Vi !== void 0)
            return Vi;
        }
        var Ki;
        Pc = !0;
        var ps = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Zs;
        Zs = Eu.current, Eu.current = null, cf();
        try {
          if (Ii) {
            var xs = function() {
              throw Error();
            };
            if (Object.defineProperty(xs.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(xs, []);
              } catch (_o) {
                Ki = _o;
              }
              Reflect.construct(ui, [], xs);
            } else {
              try {
                xs.call();
              } catch (_o) {
                Ki = _o;
              }
              ui.call(xs.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (_o) {
              Ki = _o;
            }
            ui();
          }
        } catch (_o) {
          if (_o && Ki && typeof _o.stack == "string") {
            for (var Ys = _o.stack.split(`
`), yo = Ki.stack.split(`
`), Io = Ys.length - 1, Ho = yo.length - 1; Io >= 1 && Ho >= 0 && Ys[Io] !== yo[Ho]; )
              Ho--;
            for (; Io >= 1 && Ho >= 0; Io--, Ho--)
              if (Ys[Io] !== yo[Ho]) {
                if (Io !== 1 || Ho !== 1)
                  do
                    if (Io--, Ho--, Ho < 0 || Ys[Io] !== yo[Ho]) {
                      var Bo = `
` + Ys[Io].replace(" at new ", " at ");
                      return ui.displayName && Bo.includes("<anonymous>") && (Bo = Bo.replace("<anonymous>", ui.displayName)), typeof ui == "function" && Dc.set(ui, Bo), Bo;
                    }
                  while (Io >= 1 && Ho >= 0);
                break;
              }
          }
        } finally {
          Pc = !1, Eu.current = Zs, Lc(), Error.prepareStackTrace = ps;
        }
        var zo = ui ? ui.displayName || ui.name : "", Ko = zo ? Ic(zo) : "";
        return typeof ui == "function" && Dc.set(ui, Ko), Ko;
      }
      function Ku(ui, Ii, Vi) {
        return ff(ui, !1);
      }
      function dm(ui) {
        var Ii = ui.prototype;
        return !!(Ii && Ii.isReactComponent);
      }
      function Pu(ui, Ii, Vi) {
        if (ui == null)
          return "";
        if (typeof ui == "function")
          return ff(ui, dm(ui));
        if (typeof ui == "string")
          return Ic(ui);
        switch (ui) {
          case st:
            return Ic("Suspense");
          case ot:
            return Ic("SuspenseList");
        }
        if (typeof ui == "object")
          switch (ui.$$typeof) {
            case nt:
              return Ku(ui.render);
            case lt:
              return Pu(ui.type, Ii, Vi);
            case ft: {
              var Ki = ui, ps = Ki._payload, Zs = Ki._init;
              try {
                return Pu(Zs(ps), Ii, Vi);
              } catch {
              }
            }
          }
        return "";
      }
      var Do = {}, hf = mi.ReactDebugCurrentFrame;
      function yd(ui) {
        if (ui) {
          var Ii = ui._owner, Vi = Pu(ui.type, ui._source, Ii ? Ii.type : null);
          hf.setExtraStackFrame(Vi);
        } else
          hf.setExtraStackFrame(null);
      }
      function pf(ui, Ii, Vi, Ki, ps) {
        {
          var Zs = Function.call.bind(Js);
          for (var xs in ui)
            if (Zs(ui, xs)) {
              var Ys = void 0;
              try {
                if (typeof ui[xs] != "function") {
                  var yo = Error((Ki || "React class") + ": " + Vi + " type `" + xs + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ui[xs] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw yo.name = "Invariant Violation", yo;
                }
                Ys = ui[xs](Ii, xs, Ki, Vi, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Io) {
                Ys = Io;
              }
              Ys && !(Ys instanceof Error) && (yd(ps), gi("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ki || "React class", Vi, xs, typeof Ys), yd(null)), Ys instanceof Error && !(Ys.message in Do) && (Do[Ys.message] = !0, yd(ps), gi("Failed %s type: %s", Vi, Ys.message), yd(null));
            }
        }
      }
      function Lo(ui) {
        if (ui) {
          var Ii = ui._owner, Vi = Pu(ui.type, ui._source, Ii ? Ii.type : null);
          yi(Vi);
        } else
          yi(null);
      }
      var gf;
      gf = !1;
      function mf() {
        if (si.current) {
          var ui = Ks(si.current.type);
          if (ui)
            return `

Check the render method of \`` + ui + "`.";
        }
        return "";
      }
      function uo(ui) {
        if (ui !== void 0) {
          var Ii = ui.fileName.replace(/^.*[\\\/]/, ""), Vi = ui.lineNumber;
          return `

Check your code at ` + Ii + ":" + Vi + ".";
        }
        return "";
      }
      function Ed(ui) {
        return ui != null ? uo(ui.__source) : "";
      }
      var sa = {};
      function _l(ui) {
        var Ii = mf();
        if (!Ii) {
          var Vi = typeof ui == "string" ? ui : ui.displayName || ui.name;
          Vi && (Ii = `

Check the top-level render call using <` + Vi + ">.");
        }
        return Ii;
      }
      function dl(ui, Ii) {
        if (!(!ui._store || ui._store.validated || ui.key != null)) {
          ui._store.validated = !0;
          var Vi = _l(Ii);
          if (!sa[Vi]) {
            sa[Vi] = !0;
            var Ki = "";
            ui && ui._owner && ui._owner !== si.current && (Ki = " It was passed a child from " + Ks(ui._owner.type) + "."), Lo(ui), gi('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Vi, Ki), Lo(null);
          }
        }
      }
      function Oc(ui, Ii) {
        if (typeof ui == "object") {
          if (ii(ui))
            for (var Vi = 0; Vi < ui.length; Vi++) {
              var Ki = ui[Vi];
              ci(Ki) && dl(Ki, Ii);
            }
          else if (ci(ui))
            ui._store && (ui._store.validated = !0);
          else if (ui) {
            var ps = Kr(ui);
            if (typeof ps == "function" && ps !== ui.entries)
              for (var Zs = ps.call(ui), xs; !(xs = Zs.next()).done; )
                ci(xs.value) && dl(xs.value, Ii);
          }
        }
      }
      function ha(ui) {
        {
          var Ii = ui.type;
          if (Ii == null || typeof Ii == "string")
            return;
          var Vi;
          if (typeof Ii == "function")
            Vi = Ii.propTypes;
          else if (typeof Ii == "object" && (Ii.$$typeof === nt || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          Ii.$$typeof === lt))
            Vi = Ii.propTypes;
          else
            return;
          if (Vi) {
            var Ki = Ks(Ii);
            pf(Vi, ui.props, "prop", Ki, ui);
          } else if (Ii.PropTypes !== void 0 && !gf) {
            gf = !0;
            var ps = Ks(Ii);
            gi("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ps || "Unknown");
          }
          typeof Ii.getDefaultProps == "function" && !Ii.getDefaultProps.isReactClassApproved && gi("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function No(ui) {
        {
          for (var Ii = Object.keys(ui.props), Vi = 0; Vi < Ii.length; Vi++) {
            var Ki = Ii[Vi];
            if (Ki !== "children" && Ki !== "key") {
              Lo(ui), gi("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ki), Lo(null);
              break;
            }
          }
          ui.ref !== null && (Lo(ui), gi("Invalid attribute `ref` supplied to `React.Fragment`."), Lo(null));
        }
      }
      function Sp(ui, Ii, Vi) {
        var Ki = lf(ui);
        if (!Ki) {
          var ps = "";
          (ui === void 0 || typeof ui == "object" && ui !== null && Object.keys(ui).length === 0) && (ps += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Zs = Ed(Ii);
          Zs ? ps += Zs : ps += mf();
          var xs;
          ui === null ? xs = "null" : ii(ui) ? xs = "array" : ui !== void 0 && ui.$$typeof === ae ? (xs = "<" + (Ks(ui.type) || "Unknown") + " />", ps = " Did you accidentally export a JSX literal instead of a component?") : xs = typeof ui, gi("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", xs, ps);
        }
        var Ys = Os.apply(this, arguments);
        if (Ys == null)
          return Ys;
        if (Ki)
          for (var yo = 2; yo < arguments.length; yo++)
            Oc(arguments[yo], ui);
        return ui === ye ? No(Ys) : ha(Ys), Ys;
      }
      var wl = !1;
      function ka(ui) {
        var Ii = Sp.bind(null, ui);
        return Ii.type = ui, wl || (wl = !0, Si("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(Ii, "type", {
          enumerable: !1,
          get: function() {
            return Si("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: ui
            }), ui;
          }
        }), Ii;
      }
      function Du(ui, Ii, Vi) {
        for (var Ki = Ao.apply(this, arguments), ps = 2; ps < arguments.length; ps++)
          Oc(arguments[ps], Ki.type);
        return ha(Ki), Ki;
      }
      function _p(ui, Ii) {
        var Vi = Jr.transition;
        Jr.transition = {};
        var Ki = Jr.transition;
        Jr.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          ui();
        } finally {
          if (Jr.transition = Vi, Vi === null && Ki._updatedFibers) {
            var ps = Ki._updatedFibers.size;
            ps > 10 && Si("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), Ki._updatedFibers.clear();
          }
        }
      }
      var qu = !1, Mc = null;
      function wp(ui) {
        if (Mc === null)
          try {
            var Ii = ("require" + Math.random()).slice(0, 7), Vi = ie && ie[Ii];
            Mc = Vi.call(ie, "timers").setImmediate;
          } catch {
            Mc = function(ps) {
              qu === !1 && (qu = !0, typeof MessageChannel > "u" && gi("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var Zs = new MessageChannel();
              Zs.port1.onmessage = ps, Zs.port2.postMessage(void 0);
            };
          }
        return Mc(ui);
      }
      var Jl = 0, kc = !1;
      function Nc(ui) {
        {
          var Ii = Jl;
          Jl++, ei.current === null && (ei.current = []);
          var Vi = ei.isBatchingLegacy, Ki;
          try {
            if (ei.isBatchingLegacy = !0, Ki = ui(), !Vi && ei.didScheduleLegacyUpdate) {
              var ps = ei.current;
              ps !== null && (ei.didScheduleLegacyUpdate = !1, $c(ps));
            }
          } catch (zo) {
            throw eu(Ii), zo;
          } finally {
            ei.isBatchingLegacy = Vi;
          }
          if (Ki !== null && typeof Ki == "object" && typeof Ki.then == "function") {
            var Zs = Ki, xs = !1, Ys = {
              then: function(zo, Ko) {
                xs = !0, Zs.then(function(_o) {
                  eu(Ii), Jl === 0 ? vf(_o, zo, Ko) : zo(_o);
                }, function(_o) {
                  eu(Ii), Ko(_o);
                });
              }
            };
            return !kc && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              xs || (kc = !0, gi("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), Ys;
          } else {
            var yo = Ki;
            if (eu(Ii), Jl === 0) {
              var Io = ei.current;
              Io !== null && ($c(Io), ei.current = null);
              var Ho = {
                then: function(zo, Ko) {
                  ei.current === null ? (ei.current = [], vf(yo, zo, Ko)) : zo(yo);
                }
              };
              return Ho;
            } else {
              var Bo = {
                then: function(zo, Ko) {
                  zo(yo);
                }
              };
              return Bo;
            }
          }
        }
      }
      function eu(ui) {
        ui !== Jl - 1 && gi("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Jl = ui;
      }
      function vf(ui, Ii, Vi) {
        {
          var Ki = ei.current;
          if (Ki !== null)
            try {
              $c(Ki), wp(function() {
                Ki.length === 0 ? (ei.current = null, Ii(ui)) : vf(ui, Ii, Vi);
              });
            } catch (ps) {
              Vi(ps);
            }
          else
            Ii(ui);
        }
      }
      var Fc = !1;
      function $c(ui) {
        if (!Fc) {
          Fc = !0;
          var Ii = 0;
          try {
            for (; Ii < ui.length; Ii++) {
              var Vi = ui[Ii];
              do
                Vi = Vi(!0);
              while (Vi !== null);
            }
            ui.length = 0;
          } catch (Ki) {
            throw ui = ui.slice(Ii + 1), Ki;
          } finally {
            Fc = !1;
          }
        }
      }
      var xd = Sp, yf = Du, yh = ka, xu = {
        map: eo,
        forEach: To,
        count: Us,
        toArray: Ms,
        only: da
      };
      Z.Children = xu, Z.Component = Hi, Z.Fragment = ye, Z.Profiler = Ye, Z.PureComponent = Ss, Z.StrictMode = be, Z.Suspense = st, Z.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = mi, Z.cloneElement = yf, Z.createContext = qo, Z.createElement = xd, Z.createFactory = yh, Z.createRef = Vs, Z.forwardRef = _c, Z.isValidElement = ci, Z.lazy = Ul, Z.memo = hh, Z.startTransition = _p, Z.unstable_act = Nc, Z.useCallback = Tp, Z.useContext = Ql, Z.useDebugValue = ta, Z.useDeferredValue = yu, Z.useEffect = Ep, Z.useId = vo, Z.useImperativeHandle = um, Z.useInsertionEffect = xp, Z.useLayoutEffect = ph, Z.useMemo = lm, Z.useReducer = Cc, Z.useRef = za, Z.useState = vd, Z.useSyncExternalStore = Iu, Z.useTransition = cm, Z.version = ee, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(react_development, react_development.exports)), react_development.exports;
}
process.env.NODE_ENV === "production" ? react.exports = requireReact_production_min() : react.exports = requireReact_development();
var reactExports = react.exports;
const e$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(reactExports), $2AODx$react = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: e$1
}, [reactExports]);
var reactDom = { exports: {} }, reactDom_production_min = {}, scheduler = { exports: {} }, scheduler_production_min = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_production_min;
function requireScheduler_production_min() {
  return hasRequiredScheduler_production_min || (hasRequiredScheduler_production_min = 1, function(ie) {
    function Z(_i, Oi) {
      var hi = _i.length;
      _i.push(Oi);
      e:
        for (; 0 < hi; ) {
          var Di = hi - 1 >>> 1, Ri = _i[Di];
          if (0 < ve(Ri, Oi))
            _i[Di] = Oi, _i[hi] = Ri, hi = Di;
          else
            break e;
        }
    }
    function ee(_i) {
      return _i.length === 0 ? null : _i[0];
    }
    function ae(_i) {
      if (_i.length === 0)
        return null;
      var Oi = _i[0], hi = _i.pop();
      if (hi !== Oi) {
        _i[0] = hi;
        e:
          for (var Di = 0, Ri = _i.length, rs = Ri >>> 1; Di < rs; ) {
            var Hi = 2 * (Di + 1) - 1, qi = _i[Hi], us = Hi + 1, Yi = _i[us];
            if (0 > ve(qi, hi))
              us < Ri && 0 > ve(Yi, qi) ? (_i[Di] = Yi, _i[us] = hi, Di = us) : (_i[Di] = qi, _i[Hi] = hi, Di = Hi);
            else if (us < Ri && 0 > ve(Yi, hi))
              _i[Di] = Yi, _i[us] = hi, Di = us;
            else
              break e;
          }
      }
      return Oi;
    }
    function ve(_i, Oi) {
      var hi = _i.sortIndex - Oi.sortIndex;
      return hi !== 0 ? hi : _i.id - Oi.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var ye = performance;
      ie.unstable_now = function() {
        return ye.now();
      };
    } else {
      var be = Date, Ye = be.now();
      ie.unstable_now = function() {
        return be.now() - Ye;
      };
    }
    var Qe = [], Je = [], nt = 1, st = null, ot = 3, lt = !1, ft = !1, gt = !1, ct = typeof setTimeout == "function" ? setTimeout : null, _r = typeof clearTimeout == "function" ? clearTimeout : null, Kr = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function Xr(_i) {
      for (var Oi = ee(Je); Oi !== null; ) {
        if (Oi.callback === null)
          ae(Je);
        else if (Oi.startTime <= _i)
          ae(Je), Oi.sortIndex = Oi.expirationTime, Z(Qe, Oi);
        else
          break;
        Oi = ee(Je);
      }
    }
    function Jr(_i) {
      if (gt = !1, Xr(_i), !ft)
        if (ee(Qe) !== null)
          ft = !0, Si(ei);
        else {
          var Oi = ee(Je);
          Oi !== null && gi(Jr, Oi.startTime - _i);
        }
    }
    function ei(_i, Oi) {
      ft = !1, gt && (gt = !1, _r(ai), ai = -1), lt = !0;
      var hi = ot;
      try {
        for (Xr(Oi), st = ee(Qe); st !== null && (!(st.expirationTime > Oi) || _i && !di()); ) {
          var Di = st.callback;
          if (typeof Di == "function") {
            st.callback = null, ot = st.priorityLevel;
            var Ri = Di(st.expirationTime <= Oi);
            Oi = ie.unstable_now(), typeof Ri == "function" ? st.callback = Ri : st === ee(Qe) && ae(Qe), Xr(Oi);
          } else
            ae(Qe);
          st = ee(Qe);
        }
        if (st !== null)
          var rs = !0;
        else {
          var Hi = ee(Je);
          Hi !== null && gi(Jr, Hi.startTime - Oi), rs = !1;
        }
        return rs;
      } finally {
        st = null, ot = hi, lt = !1;
      }
    }
    var si = !1, ri = null, ai = -1, yi = 5, pi = -1;
    function di() {
      return !(ie.unstable_now() - pi < yi);
    }
    function xi() {
      if (ri !== null) {
        var _i = ie.unstable_now();
        pi = _i;
        var Oi = !0;
        try {
          Oi = ri(!0, _i);
        } finally {
          Oi ? Ti() : (si = !1, ri = null);
        }
      } else
        si = !1;
    }
    var Ti;
    if (typeof Kr == "function")
      Ti = function() {
        Kr(xi);
      };
    else if (typeof MessageChannel < "u") {
      var Ai = new MessageChannel(), mi = Ai.port2;
      Ai.port1.onmessage = xi, Ti = function() {
        mi.postMessage(null);
      };
    } else
      Ti = function() {
        ct(xi, 0);
      };
    function Si(_i) {
      ri = _i, si || (si = !0, Ti());
    }
    function gi(_i, Oi) {
      ai = ct(function() {
        _i(ie.unstable_now());
      }, Oi);
    }
    ie.unstable_IdlePriority = 5, ie.unstable_ImmediatePriority = 1, ie.unstable_LowPriority = 4, ie.unstable_NormalPriority = 3, ie.unstable_Profiling = null, ie.unstable_UserBlockingPriority = 2, ie.unstable_cancelCallback = function(_i) {
      _i.callback = null;
    }, ie.unstable_continueExecution = function() {
      ft || lt || (ft = !0, Si(ei));
    }, ie.unstable_forceFrameRate = function(_i) {
      0 > _i || 125 < _i ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : yi = 0 < _i ? Math.floor(1e3 / _i) : 5;
    }, ie.unstable_getCurrentPriorityLevel = function() {
      return ot;
    }, ie.unstable_getFirstCallbackNode = function() {
      return ee(Qe);
    }, ie.unstable_next = function(_i) {
      switch (ot) {
        case 1:
        case 2:
        case 3:
          var Oi = 3;
          break;
        default:
          Oi = ot;
      }
      var hi = ot;
      ot = Oi;
      try {
        return _i();
      } finally {
        ot = hi;
      }
    }, ie.unstable_pauseExecution = function() {
    }, ie.unstable_requestPaint = function() {
    }, ie.unstable_runWithPriority = function(_i, Oi) {
      switch (_i) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          _i = 3;
      }
      var hi = ot;
      ot = _i;
      try {
        return Oi();
      } finally {
        ot = hi;
      }
    }, ie.unstable_scheduleCallback = function(_i, Oi, hi) {
      var Di = ie.unstable_now();
      switch (typeof hi == "object" && hi !== null ? (hi = hi.delay, hi = typeof hi == "number" && 0 < hi ? Di + hi : Di) : hi = Di, _i) {
        case 1:
          var Ri = -1;
          break;
        case 2:
          Ri = 250;
          break;
        case 5:
          Ri = 1073741823;
          break;
        case 4:
          Ri = 1e4;
          break;
        default:
          Ri = 5e3;
      }
      return Ri = hi + Ri, _i = { id: nt++, callback: Oi, priorityLevel: _i, startTime: hi, expirationTime: Ri, sortIndex: -1 }, hi > Di ? (_i.sortIndex = hi, Z(Je, _i), ee(Qe) === null && _i === ee(Je) && (gt ? (_r(ai), ai = -1) : gt = !0, gi(Jr, hi - Di))) : (_i.sortIndex = Ri, Z(Qe, _i), ft || lt || (ft = !0, Si(ei))), _i;
    }, ie.unstable_shouldYield = di, ie.unstable_wrapCallback = function(_i) {
      var Oi = ot;
      return function() {
        var hi = ot;
        ot = Oi;
        try {
          return _i.apply(this, arguments);
        } finally {
          ot = hi;
        }
      };
    };
  }(scheduler_production_min)), scheduler_production_min;
}
var scheduler_development = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_development;
function requireScheduler_development() {
  return hasRequiredScheduler_development || (hasRequiredScheduler_development = 1, function(ie) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var Z = !1, ee = !1, ae = 5;
      function ve(hs, Os) {
        var ho = hs.length;
        hs.push(Os), Ye(hs, Os, ho);
      }
      function ye(hs) {
        return hs.length === 0 ? null : hs[0];
      }
      function be(hs) {
        if (hs.length === 0)
          return null;
        var Os = hs[0], ho = hs.pop();
        return ho !== Os && (hs[0] = ho, Qe(hs, ho, 0)), Os;
      }
      function Ye(hs, Os, ho) {
        for (var Ao = ho; Ao > 0; ) {
          var ci = Ao - 1 >>> 1, li = hs[ci];
          if (Je(li, Os) > 0)
            hs[ci] = Os, hs[Ao] = li, Ao = ci;
          else
            return;
        }
      }
      function Qe(hs, Os, ho) {
        for (var Ao = ho, ci = hs.length, li = ci >>> 1; Ao < li; ) {
          var Ci = (Ao + 1) * 2 - 1, Li = hs[Ci], es = Ci + 1, Es = hs[es];
          if (Je(Li, Os) < 0)
            es < ci && Je(Es, Li) < 0 ? (hs[Ao] = Es, hs[es] = Os, Ao = es) : (hs[Ao] = Li, hs[Ci] = Os, Ao = Ci);
          else if (es < ci && Je(Es, Os) < 0)
            hs[Ao] = Es, hs[es] = Os, Ao = es;
          else
            return;
        }
      }
      function Je(hs, Os) {
        var ho = hs.sortIndex - Os.sortIndex;
        return ho !== 0 ? ho : hs.id - Os.id;
      }
      var nt = 1, st = 2, ot = 3, lt = 4, ft = 5;
      function gt(hs, Os) {
      }
      var ct = typeof performance == "object" && typeof performance.now == "function";
      if (ct) {
        var _r = performance;
        ie.unstable_now = function() {
          return _r.now();
        };
      } else {
        var Kr = Date, Xr = Kr.now();
        ie.unstable_now = function() {
          return Kr.now() - Xr;
        };
      }
      var Jr = 1073741823, ei = -1, si = 250, ri = 5e3, ai = 1e4, yi = Jr, pi = [], di = [], xi = 1, Ti = null, Ai = ot, mi = !1, Si = !1, gi = !1, _i = typeof setTimeout == "function" ? setTimeout : null, Oi = typeof clearTimeout == "function" ? clearTimeout : null, hi = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function Di(hs) {
        for (var Os = ye(di); Os !== null; ) {
          if (Os.callback === null)
            be(di);
          else if (Os.startTime <= hs)
            be(di), Os.sortIndex = Os.expirationTime, ve(pi, Os);
          else
            return;
          Os = ye(di);
        }
      }
      function Ri(hs) {
        if (gi = !1, Di(hs), !Si)
          if (ye(pi) !== null)
            Si = !0, xo(rs);
          else {
            var Os = ye(di);
            Os !== null && mo(Ri, Os.startTime - hs);
          }
      }
      function rs(hs, Os) {
        Si = !1, gi && (gi = !1, Wo()), mi = !0;
        var ho = Ai;
        try {
          var Ao;
          if (!ee)
            return Hi(hs, Os);
        } finally {
          Ti = null, Ai = ho, mi = !1;
        }
      }
      function Hi(hs, Os) {
        var ho = Os;
        for (Di(ho), Ti = ye(pi); Ti !== null && !Z && !(Ti.expirationTime > ho && (!hs || ms())); ) {
          var Ao = Ti.callback;
          if (typeof Ao == "function") {
            Ti.callback = null, Ai = Ti.priorityLevel;
            var ci = Ti.expirationTime <= ho, li = Ao(ci);
            ho = ie.unstable_now(), typeof li == "function" ? Ti.callback = li : Ti === ye(pi) && be(pi), Di(ho);
          } else
            be(pi);
          Ti = ye(pi);
        }
        if (Ti !== null)
          return !0;
        var Ci = ye(di);
        return Ci !== null && mo(Ri, Ci.startTime - ho), !1;
      }
      function qi(hs, Os) {
        switch (hs) {
          case nt:
          case st:
          case ot:
          case lt:
          case ft:
            break;
          default:
            hs = ot;
        }
        var ho = Ai;
        Ai = hs;
        try {
          return Os();
        } finally {
          Ai = ho;
        }
      }
      function us(hs) {
        var Os;
        switch (Ai) {
          case nt:
          case st:
          case ot:
            Os = ot;
            break;
          default:
            Os = Ai;
            break;
        }
        var ho = Ai;
        Ai = Os;
        try {
          return hs();
        } finally {
          Ai = ho;
        }
      }
      function Yi(hs) {
        var Os = Ai;
        return function() {
          var ho = Ai;
          Ai = Os;
          try {
            return hs.apply(this, arguments);
          } finally {
            Ai = ho;
          }
        };
      }
      function is(hs, Os, ho) {
        var Ao = ie.unstable_now(), ci;
        if (typeof ho == "object" && ho !== null) {
          var li = ho.delay;
          typeof li == "number" && li > 0 ? ci = Ao + li : ci = Ao;
        } else
          ci = Ao;
        var Ci;
        switch (hs) {
          case nt:
            Ci = ei;
            break;
          case st:
            Ci = si;
            break;
          case ft:
            Ci = yi;
            break;
          case lt:
            Ci = ai;
            break;
          case ot:
          default:
            Ci = ri;
            break;
        }
        var Li = ci + Ci, es = {
          id: xi++,
          callback: Os,
          priorityLevel: hs,
          startTime: ci,
          expirationTime: Li,
          sortIndex: -1
        };
        return ci > Ao ? (es.sortIndex = ci, ve(di, es), ye(pi) === null && es === ye(di) && (gi ? Wo() : gi = !0, mo(Ri, ci - Ao))) : (es.sortIndex = Li, ve(pi, es), !Si && !mi && (Si = !0, xo(rs))), es;
      }
      function Ss() {
      }
      function Gs() {
        !Si && !mi && (Si = !0, xo(rs));
      }
      function Vs() {
        return ye(pi);
      }
      function Ws(hs) {
        hs.callback = null;
      }
      function ii() {
        return Ai;
      }
      var bi = !1, Gi = null, Qi = -1, ns = ae, Bs = -1;
      function ms() {
        var hs = ie.unstable_now() - Bs;
        return !(hs < ns);
      }
      function Ks() {
      }
      function Js(hs) {
        if (hs < 0 || hs > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        hs > 0 ? ns = Math.floor(1e3 / hs) : ns = ae;
      }
      var Ns = function() {
        if (Gi !== null) {
          var hs = ie.unstable_now();
          Bs = hs;
          var Os = !0, ho = !0;
          try {
            ho = Gi(Os, hs);
          } finally {
            ho ? Ts() : (bi = !1, Gi = null);
          }
        } else
          bi = !1;
      }, Ts;
      if (typeof hi == "function")
        Ts = function() {
          hi(Ns);
        };
      else if (typeof MessageChannel < "u") {
        var lo = new MessageChannel(), Fs = lo.port2;
        lo.port1.onmessage = Ns, Ts = function() {
          Fs.postMessage(null);
        };
      } else
        Ts = function() {
          _i(Ns, 0);
        };
      function xo(hs) {
        Gi = hs, bi || (bi = !0, Ts());
      }
      function mo(hs, Os) {
        Qi = _i(function() {
          hs(ie.unstable_now());
        }, Os);
      }
      function Wo() {
        Oi(Qi), Qi = -1;
      }
      var Ta = Ks, Aa = null;
      ie.unstable_IdlePriority = ft, ie.unstable_ImmediatePriority = nt, ie.unstable_LowPriority = lt, ie.unstable_NormalPriority = ot, ie.unstable_Profiling = Aa, ie.unstable_UserBlockingPriority = st, ie.unstable_cancelCallback = Ws, ie.unstable_continueExecution = Gs, ie.unstable_forceFrameRate = Js, ie.unstable_getCurrentPriorityLevel = ii, ie.unstable_getFirstCallbackNode = Vs, ie.unstable_next = us, ie.unstable_pauseExecution = Ss, ie.unstable_requestPaint = Ta, ie.unstable_runWithPriority = qi, ie.unstable_scheduleCallback = is, ie.unstable_shouldYield = ms, ie.unstable_wrapCallback = Yi, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(scheduler_development)), scheduler_development;
}
var hasRequiredScheduler;
function requireScheduler() {
  return hasRequiredScheduler || (hasRequiredScheduler = 1, process.env.NODE_ENV === "production" ? scheduler.exports = requireScheduler_production_min() : scheduler.exports = requireScheduler_development()), scheduler.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDom_production_min;
function requireReactDom_production_min() {
  if (hasRequiredReactDom_production_min)
    return reactDom_production_min;
  hasRequiredReactDom_production_min = 1;
  var ie = reactExports, Z = requireScheduler();
  function ee(tt) {
    for (var rt = "https://reactjs.org/docs/error-decoder.html?invariant=" + tt, dt = 1; dt < arguments.length; dt++)
      rt += "&args[]=" + encodeURIComponent(arguments[dt]);
    return "Minified React error #" + tt + "; visit " + rt + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var ae = /* @__PURE__ */ new Set(), ve = {};
  function ye(tt, rt) {
    be(tt, rt), be(tt + "Capture", rt);
  }
  function be(tt, rt) {
    for (ve[tt] = rt, tt = 0; tt < rt.length; tt++)
      ae.add(rt[tt]);
  }
  var Ye = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Qe = Object.prototype.hasOwnProperty, Je = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, nt = {}, st = {};
  function ot(tt) {
    return Qe.call(st, tt) ? !0 : Qe.call(nt, tt) ? !1 : Je.test(tt) ? st[tt] = !0 : (nt[tt] = !0, !1);
  }
  function lt(tt, rt, dt, mt) {
    if (dt !== null && dt.type === 0)
      return !1;
    switch (typeof rt) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return mt ? !1 : dt !== null ? !dt.acceptsBooleans : (tt = tt.toLowerCase().slice(0, 5), tt !== "data-" && tt !== "aria-");
      default:
        return !1;
    }
  }
  function ft(tt, rt, dt, mt) {
    if (rt === null || typeof rt > "u" || lt(tt, rt, dt, mt))
      return !0;
    if (mt)
      return !1;
    if (dt !== null)
      switch (dt.type) {
        case 3:
          return !rt;
        case 4:
          return rt === !1;
        case 5:
          return isNaN(rt);
        case 6:
          return isNaN(rt) || 1 > rt;
      }
    return !1;
  }
  function gt(tt, rt, dt, mt, Zr, ti, fi) {
    this.acceptsBooleans = rt === 2 || rt === 3 || rt === 4, this.attributeName = mt, this.attributeNamespace = Zr, this.mustUseProperty = dt, this.propertyName = tt, this.type = rt, this.sanitizeURL = ti, this.removeEmptyString = fi;
  }
  var ct = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(tt) {
    ct[tt] = new gt(tt, 0, !1, tt, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(tt) {
    var rt = tt[0];
    ct[rt] = new gt(rt, 1, !1, tt[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(tt) {
    ct[tt] = new gt(tt, 2, !1, tt.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(tt) {
    ct[tt] = new gt(tt, 2, !1, tt, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(tt) {
    ct[tt] = new gt(tt, 3, !1, tt.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(tt) {
    ct[tt] = new gt(tt, 3, !0, tt, null, !1, !1);
  }), ["capture", "download"].forEach(function(tt) {
    ct[tt] = new gt(tt, 4, !1, tt, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(tt) {
    ct[tt] = new gt(tt, 6, !1, tt, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(tt) {
    ct[tt] = new gt(tt, 5, !1, tt.toLowerCase(), null, !1, !1);
  });
  var _r = /[\-:]([a-z])/g;
  function Kr(tt) {
    return tt[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(tt) {
    var rt = tt.replace(
      _r,
      Kr
    );
    ct[rt] = new gt(rt, 1, !1, tt, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(tt) {
    var rt = tt.replace(_r, Kr);
    ct[rt] = new gt(rt, 1, !1, tt, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(tt) {
    var rt = tt.replace(_r, Kr);
    ct[rt] = new gt(rt, 1, !1, tt, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(tt) {
    ct[tt] = new gt(tt, 1, !1, tt.toLowerCase(), null, !1, !1);
  }), ct.xlinkHref = new gt("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(tt) {
    ct[tt] = new gt(tt, 1, !1, tt.toLowerCase(), null, !0, !0);
  });
  function Xr(tt, rt, dt, mt) {
    var Zr = ct.hasOwnProperty(rt) ? ct[rt] : null;
    (Zr !== null ? Zr.type !== 0 : mt || !(2 < rt.length) || rt[0] !== "o" && rt[0] !== "O" || rt[1] !== "n" && rt[1] !== "N") && (ft(rt, dt, Zr, mt) && (dt = null), mt || Zr === null ? ot(rt) && (dt === null ? tt.removeAttribute(rt) : tt.setAttribute(rt, "" + dt)) : Zr.mustUseProperty ? tt[Zr.propertyName] = dt === null ? Zr.type === 3 ? !1 : "" : dt : (rt = Zr.attributeName, mt = Zr.attributeNamespace, dt === null ? tt.removeAttribute(rt) : (Zr = Zr.type, dt = Zr === 3 || Zr === 4 && dt === !0 ? "" : "" + dt, mt ? tt.setAttributeNS(mt, rt, dt) : tt.setAttribute(rt, dt))));
  }
  var Jr = ie.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ei = Symbol.for("react.element"), si = Symbol.for("react.portal"), ri = Symbol.for("react.fragment"), ai = Symbol.for("react.strict_mode"), yi = Symbol.for("react.profiler"), pi = Symbol.for("react.provider"), di = Symbol.for("react.context"), xi = Symbol.for("react.forward_ref"), Ti = Symbol.for("react.suspense"), Ai = Symbol.for("react.suspense_list"), mi = Symbol.for("react.memo"), Si = Symbol.for("react.lazy"), gi = Symbol.for("react.offscreen"), _i = Symbol.iterator;
  function Oi(tt) {
    return tt === null || typeof tt != "object" ? null : (tt = _i && tt[_i] || tt["@@iterator"], typeof tt == "function" ? tt : null);
  }
  var hi = Object.assign, Di;
  function Ri(tt) {
    if (Di === void 0)
      try {
        throw Error();
      } catch (dt) {
        var rt = dt.stack.trim().match(/\n( *(at )?)/);
        Di = rt && rt[1] || "";
      }
    return `
` + Di + tt;
  }
  var rs = !1;
  function Hi(tt, rt) {
    if (!tt || rs)
      return "";
    rs = !0;
    var dt = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (rt)
        if (rt = function() {
          throw Error();
        }, Object.defineProperty(rt.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(rt, []);
          } catch (Wi) {
            var mt = Wi;
          }
          Reflect.construct(tt, [], rt);
        } else {
          try {
            rt.call();
          } catch (Wi) {
            mt = Wi;
          }
          tt.call(rt.prototype);
        }
      else {
        try {
          throw Error();
        } catch (Wi) {
          mt = Wi;
        }
        tt();
      }
    } catch (Wi) {
      if (Wi && mt && typeof Wi.stack == "string") {
        for (var Zr = Wi.stack.split(`
`), ti = mt.stack.split(`
`), fi = Zr.length - 1, wi = ti.length - 1; 1 <= fi && 0 <= wi && Zr[fi] !== ti[wi]; )
          wi--;
        for (; 1 <= fi && 0 <= wi; fi--, wi--)
          if (Zr[fi] !== ti[wi]) {
            if (fi !== 1 || wi !== 1)
              do
                if (fi--, wi--, 0 > wi || Zr[fi] !== ti[wi]) {
                  var Pi = `
` + Zr[fi].replace(" at new ", " at ");
                  return tt.displayName && Pi.includes("<anonymous>") && (Pi = Pi.replace("<anonymous>", tt.displayName)), Pi;
                }
              while (1 <= fi && 0 <= wi);
            break;
          }
      }
    } finally {
      rs = !1, Error.prepareStackTrace = dt;
    }
    return (tt = tt ? tt.displayName || tt.name : "") ? Ri(tt) : "";
  }
  function qi(tt) {
    switch (tt.tag) {
      case 5:
        return Ri(tt.type);
      case 16:
        return Ri("Lazy");
      case 13:
        return Ri("Suspense");
      case 19:
        return Ri("SuspenseList");
      case 0:
      case 2:
      case 15:
        return tt = Hi(tt.type, !1), tt;
      case 11:
        return tt = Hi(tt.type.render, !1), tt;
      case 1:
        return tt = Hi(tt.type, !0), tt;
      default:
        return "";
    }
  }
  function us(tt) {
    if (tt == null)
      return null;
    if (typeof tt == "function")
      return tt.displayName || tt.name || null;
    if (typeof tt == "string")
      return tt;
    switch (tt) {
      case ri:
        return "Fragment";
      case si:
        return "Portal";
      case yi:
        return "Profiler";
      case ai:
        return "StrictMode";
      case Ti:
        return "Suspense";
      case Ai:
        return "SuspenseList";
    }
    if (typeof tt == "object")
      switch (tt.$$typeof) {
        case di:
          return (tt.displayName || "Context") + ".Consumer";
        case pi:
          return (tt._context.displayName || "Context") + ".Provider";
        case xi:
          var rt = tt.render;
          return tt = tt.displayName, tt || (tt = rt.displayName || rt.name || "", tt = tt !== "" ? "ForwardRef(" + tt + ")" : "ForwardRef"), tt;
        case mi:
          return rt = tt.displayName || null, rt !== null ? rt : us(tt.type) || "Memo";
        case Si:
          rt = tt._payload, tt = tt._init;
          try {
            return us(tt(rt));
          } catch {
          }
      }
    return null;
  }
  function Yi(tt) {
    var rt = tt.type;
    switch (tt.tag) {
      case 24:
        return "Cache";
      case 9:
        return (rt.displayName || "Context") + ".Consumer";
      case 10:
        return (rt._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return tt = rt.render, tt = tt.displayName || tt.name || "", rt.displayName || (tt !== "" ? "ForwardRef(" + tt + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return rt;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return us(rt);
      case 8:
        return rt === ai ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof rt == "function")
          return rt.displayName || rt.name || null;
        if (typeof rt == "string")
          return rt;
    }
    return null;
  }
  function is(tt) {
    switch (typeof tt) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return tt;
      case "object":
        return tt;
      default:
        return "";
    }
  }
  function Ss(tt) {
    var rt = tt.type;
    return (tt = tt.nodeName) && tt.toLowerCase() === "input" && (rt === "checkbox" || rt === "radio");
  }
  function Gs(tt) {
    var rt = Ss(tt) ? "checked" : "value", dt = Object.getOwnPropertyDescriptor(tt.constructor.prototype, rt), mt = "" + tt[rt];
    if (!tt.hasOwnProperty(rt) && typeof dt < "u" && typeof dt.get == "function" && typeof dt.set == "function") {
      var Zr = dt.get, ti = dt.set;
      return Object.defineProperty(tt, rt, { configurable: !0, get: function() {
        return Zr.call(this);
      }, set: function(fi) {
        mt = "" + fi, ti.call(this, fi);
      } }), Object.defineProperty(tt, rt, { enumerable: dt.enumerable }), { getValue: function() {
        return mt;
      }, setValue: function(fi) {
        mt = "" + fi;
      }, stopTracking: function() {
        tt._valueTracker = null, delete tt[rt];
      } };
    }
  }
  function Vs(tt) {
    tt._valueTracker || (tt._valueTracker = Gs(tt));
  }
  function Ws(tt) {
    if (!tt)
      return !1;
    var rt = tt._valueTracker;
    if (!rt)
      return !0;
    var dt = rt.getValue(), mt = "";
    return tt && (mt = Ss(tt) ? tt.checked ? "true" : "false" : tt.value), tt = mt, tt !== dt ? (rt.setValue(tt), !0) : !1;
  }
  function ii(tt) {
    if (tt = tt || (typeof document < "u" ? document : void 0), typeof tt > "u")
      return null;
    try {
      return tt.activeElement || tt.body;
    } catch {
      return tt.body;
    }
  }
  function bi(tt, rt) {
    var dt = rt.checked;
    return hi({}, rt, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: dt ?? tt._wrapperState.initialChecked });
  }
  function Gi(tt, rt) {
    var dt = rt.defaultValue == null ? "" : rt.defaultValue, mt = rt.checked != null ? rt.checked : rt.defaultChecked;
    dt = is(rt.value != null ? rt.value : dt), tt._wrapperState = { initialChecked: mt, initialValue: dt, controlled: rt.type === "checkbox" || rt.type === "radio" ? rt.checked != null : rt.value != null };
  }
  function Qi(tt, rt) {
    rt = rt.checked, rt != null && Xr(tt, "checked", rt, !1);
  }
  function ns(tt, rt) {
    Qi(tt, rt);
    var dt = is(rt.value), mt = rt.type;
    if (dt != null)
      mt === "number" ? (dt === 0 && tt.value === "" || tt.value != dt) && (tt.value = "" + dt) : tt.value !== "" + dt && (tt.value = "" + dt);
    else if (mt === "submit" || mt === "reset") {
      tt.removeAttribute("value");
      return;
    }
    rt.hasOwnProperty("value") ? ms(tt, rt.type, dt) : rt.hasOwnProperty("defaultValue") && ms(tt, rt.type, is(rt.defaultValue)), rt.checked == null && rt.defaultChecked != null && (tt.defaultChecked = !!rt.defaultChecked);
  }
  function Bs(tt, rt, dt) {
    if (rt.hasOwnProperty("value") || rt.hasOwnProperty("defaultValue")) {
      var mt = rt.type;
      if (!(mt !== "submit" && mt !== "reset" || rt.value !== void 0 && rt.value !== null))
        return;
      rt = "" + tt._wrapperState.initialValue, dt || rt === tt.value || (tt.value = rt), tt.defaultValue = rt;
    }
    dt = tt.name, dt !== "" && (tt.name = ""), tt.defaultChecked = !!tt._wrapperState.initialChecked, dt !== "" && (tt.name = dt);
  }
  function ms(tt, rt, dt) {
    (rt !== "number" || ii(tt.ownerDocument) !== tt) && (dt == null ? tt.defaultValue = "" + tt._wrapperState.initialValue : tt.defaultValue !== "" + dt && (tt.defaultValue = "" + dt));
  }
  var Ks = Array.isArray;
  function Js(tt, rt, dt, mt) {
    if (tt = tt.options, rt) {
      rt = {};
      for (var Zr = 0; Zr < dt.length; Zr++)
        rt["$" + dt[Zr]] = !0;
      for (dt = 0; dt < tt.length; dt++)
        Zr = rt.hasOwnProperty("$" + tt[dt].value), tt[dt].selected !== Zr && (tt[dt].selected = Zr), Zr && mt && (tt[dt].defaultSelected = !0);
    } else {
      for (dt = "" + is(dt), rt = null, Zr = 0; Zr < tt.length; Zr++) {
        if (tt[Zr].value === dt) {
          tt[Zr].selected = !0, mt && (tt[Zr].defaultSelected = !0);
          return;
        }
        rt !== null || tt[Zr].disabled || (rt = tt[Zr]);
      }
      rt !== null && (rt.selected = !0);
    }
  }
  function Ns(tt, rt) {
    if (rt.dangerouslySetInnerHTML != null)
      throw Error(ee(91));
    return hi({}, rt, { value: void 0, defaultValue: void 0, children: "" + tt._wrapperState.initialValue });
  }
  function Ts(tt, rt) {
    var dt = rt.value;
    if (dt == null) {
      if (dt = rt.children, rt = rt.defaultValue, dt != null) {
        if (rt != null)
          throw Error(ee(92));
        if (Ks(dt)) {
          if (1 < dt.length)
            throw Error(ee(93));
          dt = dt[0];
        }
        rt = dt;
      }
      rt == null && (rt = ""), dt = rt;
    }
    tt._wrapperState = { initialValue: is(dt) };
  }
  function lo(tt, rt) {
    var dt = is(rt.value), mt = is(rt.defaultValue);
    dt != null && (dt = "" + dt, dt !== tt.value && (tt.value = dt), rt.defaultValue == null && tt.defaultValue !== dt && (tt.defaultValue = dt)), mt != null && (tt.defaultValue = "" + mt);
  }
  function Fs(tt) {
    var rt = tt.textContent;
    rt === tt._wrapperState.initialValue && rt !== "" && rt !== null && (tt.value = rt);
  }
  function xo(tt) {
    switch (tt) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function mo(tt, rt) {
    return tt == null || tt === "http://www.w3.org/1999/xhtml" ? xo(rt) : tt === "http://www.w3.org/2000/svg" && rt === "foreignObject" ? "http://www.w3.org/1999/xhtml" : tt;
  }
  var Wo, Ta = function(tt) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(rt, dt, mt, Zr) {
      MSApp.execUnsafeLocalFunction(function() {
        return tt(rt, dt, mt, Zr);
      });
    } : tt;
  }(function(tt, rt) {
    if (tt.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in tt)
      tt.innerHTML = rt;
    else {
      for (Wo = Wo || document.createElement("div"), Wo.innerHTML = "<svg>" + rt.valueOf().toString() + "</svg>", rt = Wo.firstChild; tt.firstChild; )
        tt.removeChild(tt.firstChild);
      for (; rt.firstChild; )
        tt.appendChild(rt.firstChild);
    }
  });
  function Aa(tt, rt) {
    if (rt) {
      var dt = tt.firstChild;
      if (dt && dt === tt.lastChild && dt.nodeType === 3) {
        dt.nodeValue = rt;
        return;
      }
    }
    tt.textContent = rt;
  }
  var hs = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Os = ["Webkit", "ms", "Moz", "O"];
  Object.keys(hs).forEach(function(tt) {
    Os.forEach(function(rt) {
      rt = rt + tt.charAt(0).toUpperCase() + tt.substring(1), hs[rt] = hs[tt];
    });
  });
  function ho(tt, rt, dt) {
    return rt == null || typeof rt == "boolean" || rt === "" ? "" : dt || typeof rt != "number" || rt === 0 || hs.hasOwnProperty(tt) && hs[tt] ? ("" + rt).trim() : rt + "px";
  }
  function Ao(tt, rt) {
    tt = tt.style;
    for (var dt in rt)
      if (rt.hasOwnProperty(dt)) {
        var mt = dt.indexOf("--") === 0, Zr = ho(dt, rt[dt], mt);
        dt === "float" && (dt = "cssFloat"), mt ? tt.setProperty(dt, Zr) : tt[dt] = Zr;
      }
  }
  var ci = hi({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function li(tt, rt) {
    if (rt) {
      if (ci[tt] && (rt.children != null || rt.dangerouslySetInnerHTML != null))
        throw Error(ee(137, tt));
      if (rt.dangerouslySetInnerHTML != null) {
        if (rt.children != null)
          throw Error(ee(60));
        if (typeof rt.dangerouslySetInnerHTML != "object" || !("__html" in rt.dangerouslySetInnerHTML))
          throw Error(ee(61));
      }
      if (rt.style != null && typeof rt.style != "object")
        throw Error(ee(62));
    }
  }
  function Ci(tt, rt) {
    if (tt.indexOf("-") === -1)
      return typeof rt.is == "string";
    switch (tt) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Li = null;
  function es(tt) {
    return tt = tt.target || tt.srcElement || window, tt.correspondingUseElement && (tt = tt.correspondingUseElement), tt.nodeType === 3 ? tt.parentNode : tt;
  }
  var Es = null, ls = null, ss = null;
  function Hs(tt) {
    if (tt = Dh(tt)) {
      if (typeof Es != "function")
        throw Error(ee(280));
      var rt = tt.stateNode;
      rt && (rt = js(rt), Es(tt.stateNode, tt.type, rt));
    }
  }
  function eo(tt) {
    ls ? ss ? ss.push(tt) : ss = [tt] : ls = tt;
  }
  function Us() {
    if (ls) {
      var tt = ls, rt = ss;
      if (ss = ls = null, Hs(tt), rt)
        for (tt = 0; tt < rt.length; tt++)
          Hs(rt[tt]);
    }
  }
  function To(tt, rt) {
    return tt(rt);
  }
  function Ms() {
  }
  var da = !1;
  function qo(tt, rt, dt) {
    if (da)
      return tt(rt, dt);
    da = !0;
    try {
      return To(tt, rt, dt);
    } finally {
      da = !1, (ls !== null || ss !== null) && (Ms(), Us());
    }
  }
  function ba(tt, rt) {
    var dt = tt.stateNode;
    if (dt === null)
      return null;
    var mt = js(dt);
    if (mt === null)
      return null;
    dt = mt[rt];
    e:
      switch (rt) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (mt = !mt.disabled) || (tt = tt.type, mt = !(tt === "button" || tt === "input" || tt === "select" || tt === "textarea")), tt = !mt;
          break e;
        default:
          tt = !1;
      }
    if (tt)
      return null;
    if (dt && typeof dt != "function")
      throw Error(ee(231, rt, typeof dt));
    return dt;
  }
  var ll = !1;
  if (Ye)
    try {
      var Yo = {};
      Object.defineProperty(Yo, "passive", { get: function() {
        ll = !0;
      } }), window.addEventListener("test", Yo, Yo), window.removeEventListener("test", Yo, Yo);
    } catch {
      ll = !1;
    }
  function va(tt, rt, dt, mt, Zr, ti, fi, wi, Pi) {
    var Wi = Array.prototype.slice.call(arguments, 3);
    try {
      rt.apply(dt, Wi);
    } catch (as) {
      this.onError(as);
    }
  }
  var ia = !1, Ul = null, _c = !1, wc = null, lf = { onError: function(tt) {
    ia = !0, Ul = tt;
  } };
  function hh(tt, rt, dt, mt, Zr, ti, fi, wi, Pi) {
    ia = !1, Ul = null, va.apply(lf, arguments);
  }
  function fa(tt, rt, dt, mt, Zr, ti, fi, wi, Pi) {
    if (hh.apply(this, arguments), ia) {
      if (ia) {
        var Wi = Ul;
        ia = !1, Ul = null;
      } else
        throw Error(ee(198));
      _c || (_c = !0, wc = Wi);
    }
  }
  function Ql(tt) {
    var rt = tt, dt = tt;
    if (tt.alternate)
      for (; rt.return; )
        rt = rt.return;
    else {
      tt = rt;
      do
        rt = tt, rt.flags & 4098 && (dt = rt.return), tt = rt.return;
      while (tt);
    }
    return rt.tag === 3 ? dt : null;
  }
  function vd(tt) {
    if (tt.tag === 13) {
      var rt = tt.memoizedState;
      if (rt === null && (tt = tt.alternate, tt !== null && (rt = tt.memoizedState)), rt !== null)
        return rt.dehydrated;
    }
    return null;
  }
  function Cc(tt) {
    if (Ql(tt) !== tt)
      throw Error(ee(188));
  }
  function za(tt) {
    var rt = tt.alternate;
    if (!rt) {
      if (rt = Ql(tt), rt === null)
        throw Error(ee(188));
      return rt !== tt ? null : tt;
    }
    for (var dt = tt, mt = rt; ; ) {
      var Zr = dt.return;
      if (Zr === null)
        break;
      var ti = Zr.alternate;
      if (ti === null) {
        if (mt = Zr.return, mt !== null) {
          dt = mt;
          continue;
        }
        break;
      }
      if (Zr.child === ti.child) {
        for (ti = Zr.child; ti; ) {
          if (ti === dt)
            return Cc(Zr), tt;
          if (ti === mt)
            return Cc(Zr), rt;
          ti = ti.sibling;
        }
        throw Error(ee(188));
      }
      if (dt.return !== mt.return)
        dt = Zr, mt = ti;
      else {
        for (var fi = !1, wi = Zr.child; wi; ) {
          if (wi === dt) {
            fi = !0, dt = Zr, mt = ti;
            break;
          }
          if (wi === mt) {
            fi = !0, mt = Zr, dt = ti;
            break;
          }
          wi = wi.sibling;
        }
        if (!fi) {
          for (wi = ti.child; wi; ) {
            if (wi === dt) {
              fi = !0, dt = ti, mt = Zr;
              break;
            }
            if (wi === mt) {
              fi = !0, mt = ti, dt = Zr;
              break;
            }
            wi = wi.sibling;
          }
          if (!fi)
            throw Error(ee(189));
        }
      }
      if (dt.alternate !== mt)
        throw Error(ee(190));
    }
    if (dt.tag !== 3)
      throw Error(ee(188));
    return dt.stateNode.current === dt ? tt : rt;
  }
  function Ep(tt) {
    return tt = za(tt), tt !== null ? xp(tt) : null;
  }
  function xp(tt) {
    if (tt.tag === 5 || tt.tag === 6)
      return tt;
    for (tt = tt.child; tt !== null; ) {
      var rt = xp(tt);
      if (rt !== null)
        return rt;
      tt = tt.sibling;
    }
    return null;
  }
  var ph = Z.unstable_scheduleCallback, Tp = Z.unstable_cancelCallback, lm = Z.unstable_shouldYield, um = Z.unstable_requestPaint, ta = Z.unstable_now, cm = Z.unstable_getCurrentPriorityLevel, yu = Z.unstable_ImmediatePriority, vo = Z.unstable_UserBlockingPriority, Iu = Z.unstable_NormalPriority, Rc = Z.unstable_LowPriority, uf = Z.unstable_IdlePriority, Ac = null, Sl = null;
  function gh(tt) {
    if (Sl && typeof Sl.onCommitFiberRoot == "function")
      try {
        Sl.onCommitFiberRoot(Ac, tt, void 0, (tt.current.flags & 128) === 128);
      } catch {
      }
  }
  var ul = Math.clz32 ? Math.clz32 : bp, mh = Math.log, vh = Math.LN2;
  function bp(tt) {
    return tt >>>= 0, tt === 0 ? 32 : 31 - (mh(tt) / vh | 0) | 0;
  }
  var cf = 64, Lc = 4194304;
  function Eu(tt) {
    switch (tt & -tt) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return tt & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return tt & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return tt;
    }
  }
  function cl(tt, rt) {
    var dt = tt.pendingLanes;
    if (dt === 0)
      return 0;
    var mt = 0, Zr = tt.suspendedLanes, ti = tt.pingedLanes, fi = dt & 268435455;
    if (fi !== 0) {
      var wi = fi & ~Zr;
      wi !== 0 ? mt = Eu(wi) : (ti &= fi, ti !== 0 && (mt = Eu(ti)));
    } else
      fi = dt & ~Zr, fi !== 0 ? mt = Eu(fi) : ti !== 0 && (mt = Eu(ti));
    if (mt === 0)
      return 0;
    if (rt !== 0 && rt !== mt && !(rt & Zr) && (Zr = mt & -mt, ti = rt & -rt, Zr >= ti || Zr === 16 && (ti & 4194240) !== 0))
      return rt;
    if (mt & 4 && (mt |= dt & 16), rt = tt.entangledLanes, rt !== 0)
      for (tt = tt.entanglements, rt &= mt; 0 < rt; )
        dt = 31 - ul(rt), Zr = 1 << dt, mt |= tt[dt], rt &= ~Zr;
    return mt;
  }
  function Ic(tt, rt) {
    switch (tt) {
      case 1:
      case 2:
      case 4:
        return rt + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return rt + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Pc(tt, rt) {
    for (var dt = tt.suspendedLanes, mt = tt.pingedLanes, Zr = tt.expirationTimes, ti = tt.pendingLanes; 0 < ti; ) {
      var fi = 31 - ul(ti), wi = 1 << fi, Pi = Zr[fi];
      Pi === -1 ? (!(wi & dt) || wi & mt) && (Zr[fi] = Ic(wi, rt)) : Pi <= rt && (tt.expiredLanes |= wi), ti &= ~wi;
    }
  }
  function Dc(tt) {
    return tt = tt.pendingLanes & -1073741825, tt !== 0 ? tt : tt & 1073741824 ? 1073741824 : 0;
  }
  function df() {
    var tt = cf;
    return cf <<= 1, !(cf & 4194240) && (cf = 64), tt;
  }
  function ff(tt) {
    for (var rt = [], dt = 0; 31 > dt; dt++)
      rt.push(tt);
    return rt;
  }
  function Ku(tt, rt, dt) {
    tt.pendingLanes |= rt, rt !== 536870912 && (tt.suspendedLanes = 0, tt.pingedLanes = 0), tt = tt.eventTimes, rt = 31 - ul(rt), tt[rt] = dt;
  }
  function dm(tt, rt) {
    var dt = tt.pendingLanes & ~rt;
    tt.pendingLanes = rt, tt.suspendedLanes = 0, tt.pingedLanes = 0, tt.expiredLanes &= rt, tt.mutableReadLanes &= rt, tt.entangledLanes &= rt, rt = tt.entanglements;
    var mt = tt.eventTimes;
    for (tt = tt.expirationTimes; 0 < dt; ) {
      var Zr = 31 - ul(dt), ti = 1 << Zr;
      rt[Zr] = 0, mt[Zr] = -1, tt[Zr] = -1, dt &= ~ti;
    }
  }
  function Pu(tt, rt) {
    var dt = tt.entangledLanes |= rt;
    for (tt = tt.entanglements; dt; ) {
      var mt = 31 - ul(dt), Zr = 1 << mt;
      Zr & rt | tt[mt] & rt && (tt[mt] |= rt), dt &= ~Zr;
    }
  }
  var Do = 0;
  function hf(tt) {
    return tt &= -tt, 1 < tt ? 4 < tt ? tt & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var yd, pf, Lo, gf, mf, uo = !1, Ed = [], sa = null, _l = null, dl = null, Oc = /* @__PURE__ */ new Map(), ha = /* @__PURE__ */ new Map(), No = [], Sp = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function wl(tt, rt) {
    switch (tt) {
      case "focusin":
      case "focusout":
        sa = null;
        break;
      case "dragenter":
      case "dragleave":
        _l = null;
        break;
      case "mouseover":
      case "mouseout":
        dl = null;
        break;
      case "pointerover":
      case "pointerout":
        Oc.delete(rt.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        ha.delete(rt.pointerId);
    }
  }
  function ka(tt, rt, dt, mt, Zr, ti) {
    return tt === null || tt.nativeEvent !== ti ? (tt = { blockedOn: rt, domEventName: dt, eventSystemFlags: mt, nativeEvent: ti, targetContainers: [Zr] }, rt !== null && (rt = Dh(rt), rt !== null && pf(rt)), tt) : (tt.eventSystemFlags |= mt, rt = tt.targetContainers, Zr !== null && rt.indexOf(Zr) === -1 && rt.push(Zr), tt);
  }
  function Du(tt, rt, dt, mt, Zr) {
    switch (rt) {
      case "focusin":
        return sa = ka(sa, tt, rt, dt, mt, Zr), !0;
      case "dragenter":
        return _l = ka(_l, tt, rt, dt, mt, Zr), !0;
      case "mouseover":
        return dl = ka(dl, tt, rt, dt, mt, Zr), !0;
      case "pointerover":
        var ti = Zr.pointerId;
        return Oc.set(ti, ka(Oc.get(ti) || null, tt, rt, dt, mt, Zr)), !0;
      case "gotpointercapture":
        return ti = Zr.pointerId, ha.set(ti, ka(ha.get(ti) || null, tt, rt, dt, mt, Zr)), !0;
    }
    return !1;
  }
  function _p(tt) {
    var rt = nu(tt.target);
    if (rt !== null) {
      var dt = Ql(rt);
      if (dt !== null) {
        if (rt = dt.tag, rt === 13) {
          if (rt = vd(dt), rt !== null) {
            tt.blockedOn = rt, mf(tt.priority, function() {
              Lo(dt);
            });
            return;
          }
        } else if (rt === 3 && dt.stateNode.current.memoizedState.isDehydrated) {
          tt.blockedOn = dt.tag === 3 ? dt.stateNode.containerInfo : null;
          return;
        }
      }
    }
    tt.blockedOn = null;
  }
  function qu(tt) {
    if (tt.blockedOn !== null)
      return !1;
    for (var rt = tt.targetContainers; 0 < rt.length; ) {
      var dt = yf(tt.domEventName, tt.eventSystemFlags, rt[0], tt.nativeEvent);
      if (dt === null) {
        dt = tt.nativeEvent;
        var mt = new dt.constructor(dt.type, dt);
        Li = mt, dt.target.dispatchEvent(mt), Li = null;
      } else
        return rt = Dh(dt), rt !== null && pf(rt), tt.blockedOn = dt, !1;
      rt.shift();
    }
    return !0;
  }
  function Mc(tt, rt, dt) {
    qu(tt) && dt.delete(rt);
  }
  function wp() {
    uo = !1, sa !== null && qu(sa) && (sa = null), _l !== null && qu(_l) && (_l = null), dl !== null && qu(dl) && (dl = null), Oc.forEach(Mc), ha.forEach(Mc);
  }
  function Jl(tt, rt) {
    tt.blockedOn === rt && (tt.blockedOn = null, uo || (uo = !0, Z.unstable_scheduleCallback(Z.unstable_NormalPriority, wp)));
  }
  function kc(tt) {
    function rt(Zr) {
      return Jl(Zr, tt);
    }
    if (0 < Ed.length) {
      Jl(Ed[0], tt);
      for (var dt = 1; dt < Ed.length; dt++) {
        var mt = Ed[dt];
        mt.blockedOn === tt && (mt.blockedOn = null);
      }
    }
    for (sa !== null && Jl(sa, tt), _l !== null && Jl(_l, tt), dl !== null && Jl(dl, tt), Oc.forEach(rt), ha.forEach(rt), dt = 0; dt < No.length; dt++)
      mt = No[dt], mt.blockedOn === tt && (mt.blockedOn = null);
    for (; 0 < No.length && (dt = No[0], dt.blockedOn === null); )
      _p(dt), dt.blockedOn === null && No.shift();
  }
  var Nc = Jr.ReactCurrentBatchConfig, eu = !0;
  function vf(tt, rt, dt, mt) {
    var Zr = Do, ti = Nc.transition;
    Nc.transition = null;
    try {
      Do = 1, $c(tt, rt, dt, mt);
    } finally {
      Do = Zr, Nc.transition = ti;
    }
  }
  function Fc(tt, rt, dt, mt) {
    var Zr = Do, ti = Nc.transition;
    Nc.transition = null;
    try {
      Do = 4, $c(tt, rt, dt, mt);
    } finally {
      Do = Zr, Nc.transition = ti;
    }
  }
  function $c(tt, rt, dt, mt) {
    if (eu) {
      var Zr = yf(tt, rt, dt, mt);
      if (Zr === null)
        Mp(tt, rt, mt, xd, dt), wl(tt, mt);
      else if (Du(Zr, tt, rt, dt, mt))
        mt.stopPropagation();
      else if (wl(tt, mt), rt & 4 && -1 < Sp.indexOf(tt)) {
        for (; Zr !== null; ) {
          var ti = Dh(Zr);
          if (ti !== null && yd(ti), ti = yf(tt, rt, dt, mt), ti === null && Mp(tt, rt, mt, xd, dt), ti === Zr)
            break;
          Zr = ti;
        }
        Zr !== null && mt.stopPropagation();
      } else
        Mp(tt, rt, mt, null, dt);
    }
  }
  var xd = null;
  function yf(tt, rt, dt, mt) {
    if (xd = null, tt = es(mt), tt = nu(tt), tt !== null)
      if (rt = Ql(tt), rt === null)
        tt = null;
      else if (dt = rt.tag, dt === 13) {
        if (tt = vd(rt), tt !== null)
          return tt;
        tt = null;
      } else if (dt === 3) {
        if (rt.stateNode.current.memoizedState.isDehydrated)
          return rt.tag === 3 ? rt.stateNode.containerInfo : null;
        tt = null;
      } else
        rt !== tt && (tt = null);
    return xd = tt, null;
  }
  function yh(tt) {
    switch (tt) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (cm()) {
          case yu:
            return 1;
          case vo:
            return 4;
          case Iu:
          case Rc:
            return 16;
          case uf:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var xu = null, ui = null, Ii = null;
  function Vi() {
    if (Ii)
      return Ii;
    var tt, rt = ui, dt = rt.length, mt, Zr = "value" in xu ? xu.value : xu.textContent, ti = Zr.length;
    for (tt = 0; tt < dt && rt[tt] === Zr[tt]; tt++)
      ;
    var fi = dt - tt;
    for (mt = 1; mt <= fi && rt[dt - mt] === Zr[ti - mt]; mt++)
      ;
    return Ii = Zr.slice(tt, 1 < mt ? 1 - mt : void 0);
  }
  function Ki(tt) {
    var rt = tt.keyCode;
    return "charCode" in tt ? (tt = tt.charCode, tt === 0 && rt === 13 && (tt = 13)) : tt = rt, tt === 10 && (tt = 13), 32 <= tt || tt === 13 ? tt : 0;
  }
  function ps() {
    return !0;
  }
  function Zs() {
    return !1;
  }
  function xs(tt) {
    function rt(dt, mt, Zr, ti, fi) {
      this._reactName = dt, this._targetInst = Zr, this.type = mt, this.nativeEvent = ti, this.target = fi, this.currentTarget = null;
      for (var wi in tt)
        tt.hasOwnProperty(wi) && (dt = tt[wi], this[wi] = dt ? dt(ti) : ti[wi]);
      return this.isDefaultPrevented = (ti.defaultPrevented != null ? ti.defaultPrevented : ti.returnValue === !1) ? ps : Zs, this.isPropagationStopped = Zs, this;
    }
    return hi(rt.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var dt = this.nativeEvent;
      dt && (dt.preventDefault ? dt.preventDefault() : typeof dt.returnValue != "unknown" && (dt.returnValue = !1), this.isDefaultPrevented = ps);
    }, stopPropagation: function() {
      var dt = this.nativeEvent;
      dt && (dt.stopPropagation ? dt.stopPropagation() : typeof dt.cancelBubble != "unknown" && (dt.cancelBubble = !0), this.isPropagationStopped = ps);
    }, persist: function() {
    }, isPersistent: ps }), rt;
  }
  var Ys = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(tt) {
    return tt.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, yo = xs(Ys), Io = hi({}, Ys, { view: 0, detail: 0 }), Ho = xs(Io), Bo, zo, Ko, _o = hi({}, Io, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: mm, button: 0, buttons: 0, relatedTarget: function(tt) {
    return tt.relatedTarget === void 0 ? tt.fromElement === tt.srcElement ? tt.toElement : tt.fromElement : tt.relatedTarget;
  }, movementX: function(tt) {
    return "movementX" in tt ? tt.movementX : (tt !== Ko && (Ko && tt.type === "mousemove" ? (Bo = tt.screenX - Ko.screenX, zo = tt.screenY - Ko.screenY) : zo = Bo = 0, Ko = tt), Bo);
  }, movementY: function(tt) {
    return "movementY" in tt ? tt.movementY : zo;
  } }), Yu = xs(_o), Ef = hi({}, _o, { dataTransfer: 0 }), Eh = xs(Ef), fm = hi({}, Io, { relatedTarget: 0 }), Tu = xs(fm), xh = hi({}, Ys, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Th = xs(xh), hm = hi({}, Ys, { clipboardData: function(tt) {
    return "clipboardData" in tt ? tt.clipboardData : window.clipboardData;
  } }), s1 = xs(hm), o1 = hi({}, Ys, { data: 0 }), pm = xs(o1), gm = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Ev = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, xv = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Tv(tt) {
    var rt = this.nativeEvent;
    return rt.getModifierState ? rt.getModifierState(tt) : (tt = xv[tt]) ? !!rt[tt] : !1;
  }
  function mm() {
    return Tv;
  }
  var Xu = hi({}, Io, { key: function(tt) {
    if (tt.key) {
      var rt = gm[tt.key] || tt.key;
      if (rt !== "Unidentified")
        return rt;
    }
    return tt.type === "keypress" ? (tt = Ki(tt), tt === 13 ? "Enter" : String.fromCharCode(tt)) : tt.type === "keydown" || tt.type === "keyup" ? Ev[tt.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: mm, charCode: function(tt) {
    return tt.type === "keypress" ? Ki(tt) : 0;
  }, keyCode: function(tt) {
    return tt.type === "keydown" || tt.type === "keyup" ? tt.keyCode : 0;
  }, which: function(tt) {
    return tt.type === "keypress" ? Ki(tt) : tt.type === "keydown" || tt.type === "keyup" ? tt.keyCode : 0;
  } }), a1 = xs(Xu), vm = hi({}, _o, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Cp = xs(vm), ym = hi({}, Io, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: mm }), l1 = xs(ym), Rp = hi({}, Ys, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), bv = xs(Rp), Cl = hi({}, _o, {
    deltaX: function(tt) {
      return "deltaX" in tt ? tt.deltaX : "wheelDeltaX" in tt ? -tt.wheelDeltaX : 0;
    },
    deltaY: function(tt) {
      return "deltaY" in tt ? tt.deltaY : "wheelDeltaY" in tt ? -tt.wheelDeltaY : "wheelDelta" in tt ? -tt.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Zu = xs(Cl), Sa = [9, 13, 27, 32], bu = Ye && "CompositionEvent" in window, Td = null;
  Ye && "documentMode" in document && (Td = document.documentMode);
  var Ap = Ye && "TextEvent" in window && !Td, Sv = Ye && (!bu || Td && 8 < Td && 11 >= Td), xf = " ", _v = !1;
  function wv(tt, rt) {
    switch (tt) {
      case "keyup":
        return Sa.indexOf(rt.keyCode) !== -1;
      case "keydown":
        return rt.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Lp(tt) {
    return tt = tt.detail, typeof tt == "object" && "data" in tt ? tt.data : null;
  }
  var Tf = !1;
  function u1(tt, rt) {
    switch (tt) {
      case "compositionend":
        return Lp(rt);
      case "keypress":
        return rt.which !== 32 ? null : (_v = !0, xf);
      case "textInput":
        return tt = rt.data, tt === xf && _v ? null : tt;
      default:
        return null;
    }
  }
  function c1(tt, rt) {
    if (Tf)
      return tt === "compositionend" || !bu && wv(tt, rt) ? (tt = Vi(), Ii = ui = xu = null, Tf = !1, tt) : null;
    switch (tt) {
      case "paste":
        return null;
      case "keypress":
        if (!(rt.ctrlKey || rt.altKey || rt.metaKey) || rt.ctrlKey && rt.altKey) {
          if (rt.char && 1 < rt.char.length)
            return rt.char;
          if (rt.which)
            return String.fromCharCode(rt.which);
        }
        return null;
      case "compositionend":
        return Sv && rt.locale !== "ko" ? null : rt.data;
      default:
        return null;
    }
  }
  var Cv = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Rv(tt) {
    var rt = tt && tt.nodeName && tt.nodeName.toLowerCase();
    return rt === "input" ? !!Cv[tt.type] : rt === "textarea";
  }
  function Av(tt, rt, dt, mt) {
    eo(mt), rt = Lh(rt, "onChange"), 0 < rt.length && (dt = new yo("onChange", "change", null, dt, mt), tt.push({ event: dt, listeners: rt }));
  }
  var bh = null, bf = null;
  function Sf(tt) {
    Op(tt, 0);
  }
  function _f(tt) {
    var rt = Cf(tt);
    if (Ws(rt))
      return tt;
  }
  function Lv(tt, rt) {
    if (tt === "change")
      return rt;
  }
  var Em = !1;
  if (Ye) {
    var xm;
    if (Ye) {
      var Tm = "oninput" in document;
      if (!Tm) {
        var Iv = document.createElement("div");
        Iv.setAttribute("oninput", "return;"), Tm = typeof Iv.oninput == "function";
      }
      xm = Tm;
    } else
      xm = !1;
    Em = xm && (!document.documentMode || 9 < document.documentMode);
  }
  function Pv() {
    bh && (bh.detachEvent("onpropertychange", Dv), bf = bh = null);
  }
  function Dv(tt) {
    if (tt.propertyName === "value" && _f(bf)) {
      var rt = [];
      Av(rt, bf, tt, es(tt)), qo(Sf, rt);
    }
  }
  function d1(tt, rt, dt) {
    tt === "focusin" ? (Pv(), bh = rt, bf = dt, bh.attachEvent("onpropertychange", Dv)) : tt === "focusout" && Pv();
  }
  function f1(tt) {
    if (tt === "selectionchange" || tt === "keyup" || tt === "keydown")
      return _f(bf);
  }
  function h1(tt, rt) {
    if (tt === "click")
      return _f(rt);
  }
  function Ov(tt, rt) {
    if (tt === "input" || tt === "change")
      return _f(rt);
  }
  function g1(tt, rt) {
    return tt === rt && (tt !== 0 || 1 / tt === 1 / rt) || tt !== tt && rt !== rt;
  }
  var tu = typeof Object.is == "function" ? Object.is : g1;
  function Sh(tt, rt) {
    if (tu(tt, rt))
      return !0;
    if (typeof tt != "object" || tt === null || typeof rt != "object" || rt === null)
      return !1;
    var dt = Object.keys(tt), mt = Object.keys(rt);
    if (dt.length !== mt.length)
      return !1;
    for (mt = 0; mt < dt.length; mt++) {
      var Zr = dt[mt];
      if (!Qe.call(rt, Zr) || !tu(tt[Zr], rt[Zr]))
        return !1;
    }
    return !0;
  }
  function Mv(tt) {
    for (; tt && tt.firstChild; )
      tt = tt.firstChild;
    return tt;
  }
  function kv(tt, rt) {
    var dt = Mv(tt);
    tt = 0;
    for (var mt; dt; ) {
      if (dt.nodeType === 3) {
        if (mt = tt + dt.textContent.length, tt <= rt && mt >= rt)
          return { node: dt, offset: rt - tt };
        tt = mt;
      }
      e: {
        for (; dt; ) {
          if (dt.nextSibling) {
            dt = dt.nextSibling;
            break e;
          }
          dt = dt.parentNode;
        }
        dt = void 0;
      }
      dt = Mv(dt);
    }
  }
  function Nv(tt, rt) {
    return tt && rt ? tt === rt ? !0 : tt && tt.nodeType === 3 ? !1 : rt && rt.nodeType === 3 ? Nv(tt, rt.parentNode) : "contains" in tt ? tt.contains(rt) : tt.compareDocumentPosition ? !!(tt.compareDocumentPosition(rt) & 16) : !1 : !1;
  }
  function Ip() {
    for (var tt = window, rt = ii(); rt instanceof tt.HTMLIFrameElement; ) {
      try {
        var dt = typeof rt.contentWindow.location.href == "string";
      } catch {
        dt = !1;
      }
      if (dt)
        tt = rt.contentWindow;
      else
        break;
      rt = ii(tt.document);
    }
    return rt;
  }
  function Qu(tt) {
    var rt = tt && tt.nodeName && tt.nodeName.toLowerCase();
    return rt && (rt === "input" && (tt.type === "text" || tt.type === "search" || tt.type === "tel" || tt.type === "url" || tt.type === "password") || rt === "textarea" || tt.contentEditable === "true");
  }
  function Pp(tt) {
    var rt = Ip(), dt = tt.focusedElem, mt = tt.selectionRange;
    if (rt !== dt && dt && dt.ownerDocument && Nv(dt.ownerDocument.documentElement, dt)) {
      if (mt !== null && Qu(dt)) {
        if (rt = mt.start, tt = mt.end, tt === void 0 && (tt = rt), "selectionStart" in dt)
          dt.selectionStart = rt, dt.selectionEnd = Math.min(tt, dt.value.length);
        else if (tt = (rt = dt.ownerDocument || document) && rt.defaultView || window, tt.getSelection) {
          tt = tt.getSelection();
          var Zr = dt.textContent.length, ti = Math.min(mt.start, Zr);
          mt = mt.end === void 0 ? ti : Math.min(mt.end, Zr), !tt.extend && ti > mt && (Zr = mt, mt = ti, ti = Zr), Zr = kv(dt, ti);
          var fi = kv(
            dt,
            mt
          );
          Zr && fi && (tt.rangeCount !== 1 || tt.anchorNode !== Zr.node || tt.anchorOffset !== Zr.offset || tt.focusNode !== fi.node || tt.focusOffset !== fi.offset) && (rt = rt.createRange(), rt.setStart(Zr.node, Zr.offset), tt.removeAllRanges(), ti > mt ? (tt.addRange(rt), tt.extend(fi.node, fi.offset)) : (rt.setEnd(fi.node, fi.offset), tt.addRange(rt)));
        }
      }
      for (rt = [], tt = dt; tt = tt.parentNode; )
        tt.nodeType === 1 && rt.push({ element: tt, left: tt.scrollLeft, top: tt.scrollTop });
      for (typeof dt.focus == "function" && dt.focus(), dt = 0; dt < rt.length; dt++)
        tt = rt[dt], tt.element.scrollLeft = tt.left, tt.element.scrollTop = tt.top;
    }
  }
  var Fv = Ye && "documentMode" in document && 11 >= document.documentMode, Su = null, bm = null, _h = null, Sm = !1;
  function $v(tt, rt, dt) {
    var mt = dt.window === dt ? dt.document : dt.nodeType === 9 ? dt : dt.ownerDocument;
    Sm || Su == null || Su !== ii(mt) || (mt = Su, "selectionStart" in mt && Qu(mt) ? mt = { start: mt.selectionStart, end: mt.selectionEnd } : (mt = (mt.ownerDocument && mt.ownerDocument.defaultView || window).getSelection(), mt = { anchorNode: mt.anchorNode, anchorOffset: mt.anchorOffset, focusNode: mt.focusNode, focusOffset: mt.focusOffset }), _h && Sh(_h, mt) || (_h = mt, mt = Lh(bm, "onSelect"), 0 < mt.length && (rt = new yo("onSelect", "select", null, rt, dt), tt.push({ event: rt, listeners: mt }), rt.target = Su)));
  }
  function Dp(tt, rt) {
    var dt = {};
    return dt[tt.toLowerCase()] = rt.toLowerCase(), dt["Webkit" + tt] = "webkit" + rt, dt["Moz" + tt] = "moz" + rt, dt;
  }
  var bd = { animationend: Dp("Animation", "AnimationEnd"), animationiteration: Dp("Animation", "AnimationIteration"), animationstart: Dp("Animation", "AnimationStart"), transitionend: Dp("Transition", "TransitionEnd") }, _m = {}, wm = {};
  Ye && (wm = document.createElement("div").style, "AnimationEvent" in window || (delete bd.animationend.animation, delete bd.animationiteration.animation, delete bd.animationstart.animation), "TransitionEvent" in window || delete bd.transitionend.transition);
  function Na(tt) {
    if (_m[tt])
      return _m[tt];
    if (!bd[tt])
      return tt;
    var rt = bd[tt], dt;
    for (dt in rt)
      if (rt.hasOwnProperty(dt) && dt in wm)
        return _m[tt] = rt[dt];
    return tt;
  }
  var Cm = Na("animationend"), Bv = Na("animationiteration"), Uv = Na("animationstart"), Gv = Na("transitionend"), Hv = /* @__PURE__ */ new Map(), zv = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Ju(tt, rt) {
    Hv.set(tt, rt), ye(rt, [tt]);
  }
  for (var wh = 0; wh < zv.length; wh++) {
    var Sd = zv[wh], m1 = Sd.toLowerCase(), Ch = Sd[0].toUpperCase() + Sd.slice(1);
    Ju(m1, "on" + Ch);
  }
  Ju(Cm, "onAnimationEnd"), Ju(Bv, "onAnimationIteration"), Ju(Uv, "onAnimationStart"), Ju("dblclick", "onDoubleClick"), Ju("focusin", "onFocus"), Ju("focusout", "onBlur"), Ju(Gv, "onTransitionEnd"), be("onMouseEnter", ["mouseout", "mouseover"]), be("onMouseLeave", ["mouseout", "mouseover"]), be("onPointerEnter", ["pointerout", "pointerover"]), be("onPointerLeave", ["pointerout", "pointerover"]), ye("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), ye("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), ye("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), ye("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), ye("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), ye("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Rh = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), v1 = new Set("cancel close invalid load scroll toggle".split(" ").concat(Rh));
  function Vv(tt, rt, dt) {
    var mt = tt.type || "unknown-event";
    tt.currentTarget = dt, fa(mt, rt, void 0, tt), tt.currentTarget = null;
  }
  function Op(tt, rt) {
    rt = (rt & 4) !== 0;
    for (var dt = 0; dt < tt.length; dt++) {
      var mt = tt[dt], Zr = mt.event;
      mt = mt.listeners;
      e: {
        var ti = void 0;
        if (rt)
          for (var fi = mt.length - 1; 0 <= fi; fi--) {
            var wi = mt[fi], Pi = wi.instance, Wi = wi.currentTarget;
            if (wi = wi.listener, Pi !== ti && Zr.isPropagationStopped())
              break e;
            Vv(Zr, wi, Wi), ti = Pi;
          }
        else
          for (fi = 0; fi < mt.length; fi++) {
            if (wi = mt[fi], Pi = wi.instance, Wi = wi.currentTarget, wi = wi.listener, Pi !== ti && Zr.isPropagationStopped())
              break e;
            Vv(Zr, wi, Wi), ti = Pi;
          }
      }
    }
    if (_c)
      throw tt = wc, _c = !1, wc = null, tt;
  }
  function Vo(tt, rt) {
    var dt = rt[Om];
    dt === void 0 && (dt = rt[Om] = /* @__PURE__ */ new Set());
    var mt = tt + "__bubble";
    dt.has(mt) || (jv(rt, tt, 2, !1), dt.add(mt));
  }
  function Bc(tt, rt, dt) {
    var mt = 0;
    rt && (mt |= 4), jv(dt, tt, mt, rt);
  }
  var tc = "_reactListening" + Math.random().toString(36).slice(2);
  function wf(tt) {
    if (!tt[tc]) {
      tt[tc] = !0, ae.forEach(function(dt) {
        dt !== "selectionchange" && (v1.has(dt) || Bc(dt, !1, tt), Bc(dt, !0, tt));
      });
      var rt = tt.nodeType === 9 ? tt : tt.ownerDocument;
      rt === null || rt[tc] || (rt[tc] = !0, Bc("selectionchange", !1, rt));
    }
  }
  function jv(tt, rt, dt, mt) {
    switch (yh(rt)) {
      case 1:
        var Zr = vf;
        break;
      case 4:
        Zr = Fc;
        break;
      default:
        Zr = $c;
    }
    dt = Zr.bind(null, rt, dt, tt), Zr = void 0, !ll || rt !== "touchstart" && rt !== "touchmove" && rt !== "wheel" || (Zr = !0), mt ? Zr !== void 0 ? tt.addEventListener(rt, dt, { capture: !0, passive: Zr }) : tt.addEventListener(rt, dt, !0) : Zr !== void 0 ? tt.addEventListener(rt, dt, { passive: Zr }) : tt.addEventListener(rt, dt, !1);
  }
  function Mp(tt, rt, dt, mt, Zr) {
    var ti = mt;
    if (!(rt & 1) && !(rt & 2) && mt !== null)
      e:
        for (; ; ) {
          if (mt === null)
            return;
          var fi = mt.tag;
          if (fi === 3 || fi === 4) {
            var wi = mt.stateNode.containerInfo;
            if (wi === Zr || wi.nodeType === 8 && wi.parentNode === Zr)
              break;
            if (fi === 4)
              for (fi = mt.return; fi !== null; ) {
                var Pi = fi.tag;
                if ((Pi === 3 || Pi === 4) && (Pi = fi.stateNode.containerInfo, Pi === Zr || Pi.nodeType === 8 && Pi.parentNode === Zr))
                  return;
                fi = fi.return;
              }
            for (; wi !== null; ) {
              if (fi = nu(wi), fi === null)
                return;
              if (Pi = fi.tag, Pi === 5 || Pi === 6) {
                mt = ti = fi;
                continue e;
              }
              wi = wi.parentNode;
            }
          }
          mt = mt.return;
        }
    qo(function() {
      var Wi = ti, as = es(dt), cs = [];
      e: {
        var os = Hv.get(tt);
        if (os !== void 0) {
          var _s = yo, Ls = tt;
          switch (tt) {
            case "keypress":
              if (Ki(dt) === 0)
                break e;
            case "keydown":
            case "keyup":
              _s = a1;
              break;
            case "focusin":
              Ls = "focus", _s = Tu;
              break;
            case "focusout":
              Ls = "blur", _s = Tu;
              break;
            case "beforeblur":
            case "afterblur":
              _s = Tu;
              break;
            case "click":
              if (dt.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              _s = Yu;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              _s = Eh;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              _s = l1;
              break;
            case Cm:
            case Bv:
            case Uv:
              _s = Th;
              break;
            case Gv:
              _s = bv;
              break;
            case "scroll":
              _s = Ho;
              break;
            case "wheel":
              _s = Zu;
              break;
            case "copy":
            case "cut":
            case "paste":
              _s = s1;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              _s = Cp;
          }
          var Ds = (rt & 4) !== 0, Ea = !Ds && tt === "scroll", Fi = Ds ? os !== null ? os + "Capture" : null : os;
          Ds = [];
          for (var ki = Wi, Ui; ki !== null; ) {
            Ui = ki;
            var gs = Ui.stateNode;
            if (Ui.tag === 5 && gs !== null && (Ui = gs, Fi !== null && (gs = ba(ki, Fi), gs != null && Ds.push(Ah(ki, gs, Ui)))), Ea)
              break;
            ki = ki.return;
          }
          0 < Ds.length && (os = new _s(os, Ls, null, dt, as), cs.push({ event: os, listeners: Ds }));
        }
      }
      if (!(rt & 7)) {
        e: {
          if (os = tt === "mouseover" || tt === "pointerover", _s = tt === "mouseout" || tt === "pointerout", os && dt !== Li && (Ls = dt.relatedTarget || dt.fromElement) && (nu(Ls) || Ls[nc]))
            break e;
          if ((_s || os) && (os = as.window === as ? as : (os = as.ownerDocument) ? os.defaultView || os.parentWindow : window, _s ? (Ls = dt.relatedTarget || dt.toElement, _s = Wi, Ls = Ls ? nu(Ls) : null, Ls !== null && (Ea = Ql(Ls), Ls !== Ea || Ls.tag !== 5 && Ls.tag !== 6) && (Ls = null)) : (_s = null, Ls = Wi), _s !== Ls)) {
            if (Ds = Yu, gs = "onMouseLeave", Fi = "onMouseEnter", ki = "mouse", (tt === "pointerout" || tt === "pointerover") && (Ds = Cp, gs = "onPointerLeave", Fi = "onPointerEnter", ki = "pointer"), Ea = _s == null ? os : Cf(_s), Ui = Ls == null ? os : Cf(Ls), os = new Ds(gs, ki + "leave", _s, dt, as), os.target = Ea, os.relatedTarget = Ui, gs = null, nu(as) === Wi && (Ds = new Ds(Fi, ki + "enter", Ls, dt, as), Ds.target = Ui, Ds.relatedTarget = Ea, gs = Ds), Ea = gs, _s && Ls)
              t: {
                for (Ds = _s, Fi = Ls, ki = 0, Ui = Ds; Ui; Ui = _d(Ui))
                  ki++;
                for (Ui = 0, gs = Fi; gs; gs = _d(gs))
                  Ui++;
                for (; 0 < ki - Ui; )
                  Ds = _d(Ds), ki--;
                for (; 0 < Ui - ki; )
                  Fi = _d(Fi), Ui--;
                for (; ki--; ) {
                  if (Ds === Fi || Fi !== null && Ds === Fi.alternate)
                    break t;
                  Ds = _d(Ds), Fi = _d(Fi);
                }
                Ds = null;
              }
            else
              Ds = null;
            _s !== null && Rm(cs, os, _s, Ds, !1), Ls !== null && Ea !== null && Rm(cs, Ea, Ls, Ds, !0);
          }
        }
        e: {
          if (os = Wi ? Cf(Wi) : window, _s = os.nodeName && os.nodeName.toLowerCase(), _s === "select" || _s === "input" && os.type === "file")
            var ks = Lv;
          else if (Rv(os))
            if (Em)
              ks = Ov;
            else {
              ks = f1;
              var Is = d1;
            }
          else
            (_s = os.nodeName) && _s.toLowerCase() === "input" && (os.type === "checkbox" || os.type === "radio") && (ks = h1);
          if (ks && (ks = ks(tt, Wi))) {
            Av(cs, ks, dt, as);
            break e;
          }
          Is && Is(tt, os, Wi), tt === "focusout" && (Is = os._wrapperState) && Is.controlled && os.type === "number" && ms(os, "number", os.value);
        }
        switch (Is = Wi ? Cf(Wi) : window, tt) {
          case "focusin":
            (Rv(Is) || Is.contentEditable === "true") && (Su = Is, bm = Wi, _h = null);
            break;
          case "focusout":
            _h = bm = Su = null;
            break;
          case "mousedown":
            Sm = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Sm = !1, $v(cs, dt, as);
            break;
          case "selectionchange":
            if (Fv)
              break;
          case "keydown":
          case "keyup":
            $v(cs, dt, as);
        }
        var zs;
        if (bu)
          e: {
            switch (tt) {
              case "compositionstart":
                var so = "onCompositionStart";
                break e;
              case "compositionend":
                so = "onCompositionEnd";
                break e;
              case "compositionupdate":
                so = "onCompositionUpdate";
                break e;
            }
            so = void 0;
          }
        else
          Tf ? wv(tt, dt) && (so = "onCompositionEnd") : tt === "keydown" && dt.keyCode === 229 && (so = "onCompositionStart");
        so && (Sv && dt.locale !== "ko" && (Tf || so !== "onCompositionStart" ? so === "onCompositionEnd" && Tf && (zs = Vi()) : (xu = as, ui = "value" in xu ? xu.value : xu.textContent, Tf = !0)), Is = Lh(Wi, so), 0 < Is.length && (so = new pm(so, tt, null, dt, as), cs.push({ event: so, listeners: Is }), zs ? so.data = zs : (zs = Lp(dt), zs !== null && (so.data = zs)))), (zs = Ap ? u1(tt, dt) : c1(tt, dt)) && (Wi = Lh(Wi, "onBeforeInput"), 0 < Wi.length && (as = new pm("onBeforeInput", "beforeinput", null, dt, as), cs.push({ event: as, listeners: Wi }), as.data = zs));
      }
      Op(cs, rt);
    });
  }
  function Ah(tt, rt, dt) {
    return { instance: tt, listener: rt, currentTarget: dt };
  }
  function Lh(tt, rt) {
    for (var dt = rt + "Capture", mt = []; tt !== null; ) {
      var Zr = tt, ti = Zr.stateNode;
      Zr.tag === 5 && ti !== null && (Zr = ti, ti = ba(tt, dt), ti != null && mt.unshift(Ah(tt, ti, Zr)), ti = ba(tt, rt), ti != null && mt.push(Ah(tt, ti, Zr))), tt = tt.return;
    }
    return mt;
  }
  function _d(tt) {
    if (tt === null)
      return null;
    do
      tt = tt.return;
    while (tt && tt.tag !== 5);
    return tt || null;
  }
  function Rm(tt, rt, dt, mt, Zr) {
    for (var ti = rt._reactName, fi = []; dt !== null && dt !== mt; ) {
      var wi = dt, Pi = wi.alternate, Wi = wi.stateNode;
      if (Pi !== null && Pi === mt)
        break;
      wi.tag === 5 && Wi !== null && (wi = Wi, Zr ? (Pi = ba(dt, ti), Pi != null && fi.unshift(Ah(dt, Pi, wi))) : Zr || (Pi = ba(dt, ti), Pi != null && fi.push(Ah(dt, Pi, wi)))), dt = dt.return;
    }
    fi.length !== 0 && tt.push({ event: rt, listeners: fi });
  }
  var Am = /\r\n?/g, y1 = /\u0000|\uFFFD/g;
  function Lm(tt) {
    return (typeof tt == "string" ? tt : "" + tt).replace(Am, `
`).replace(y1, "");
  }
  function kp(tt, rt, dt) {
    if (rt = Lm(rt), Lm(tt) !== rt && dt)
      throw Error(ee(425));
  }
  function Np() {
  }
  var Im = null, wd = null;
  function Ih(tt, rt) {
    return tt === "textarea" || tt === "noscript" || typeof rt.children == "string" || typeof rt.children == "number" || typeof rt.dangerouslySetInnerHTML == "object" && rt.dangerouslySetInnerHTML !== null && rt.dangerouslySetInnerHTML.__html != null;
  }
  var Cd = typeof setTimeout == "function" ? setTimeout : void 0, Wv = typeof clearTimeout == "function" ? clearTimeout : void 0, Pm = typeof Promise == "function" ? Promise : void 0, Dm = typeof queueMicrotask == "function" ? queueMicrotask : typeof Pm < "u" ? function(tt) {
    return Pm.resolve(null).then(tt).catch(E1);
  } : Cd;
  function E1(tt) {
    setTimeout(function() {
      throw tt;
    });
  }
  function Uc(tt, rt) {
    var dt = rt, mt = 0;
    do {
      var Zr = dt.nextSibling;
      if (tt.removeChild(dt), Zr && Zr.nodeType === 8)
        if (dt = Zr.data, dt === "/$") {
          if (mt === 0) {
            tt.removeChild(Zr), kc(rt);
            return;
          }
          mt--;
        } else
          dt !== "$" && dt !== "$?" && dt !== "$!" || mt++;
      dt = Zr;
    } while (dt);
    kc(rt);
  }
  function _u(tt) {
    for (; tt != null; tt = tt.nextSibling) {
      var rt = tt.nodeType;
      if (rt === 1 || rt === 3)
        break;
      if (rt === 8) {
        if (rt = tt.data, rt === "$" || rt === "$!" || rt === "$?")
          break;
        if (rt === "/$")
          return null;
      }
    }
    return tt;
  }
  function Ph(tt) {
    tt = tt.previousSibling;
    for (var rt = 0; tt; ) {
      if (tt.nodeType === 8) {
        var dt = tt.data;
        if (dt === "$" || dt === "$!" || dt === "$?") {
          if (rt === 0)
            return tt;
          rt--;
        } else
          dt === "/$" && rt++;
      }
      tt = tt.previousSibling;
    }
    return null;
  }
  var Gc = Math.random().toString(36).slice(2), Ou = "__reactFiber$" + Gc, Rd = "__reactProps$" + Gc, nc = "__reactContainer$" + Gc, Om = "__reactEvents$" + Gc, x1 = "__reactListeners$" + Gc, Mm = "__reactHandles$" + Gc;
  function nu(tt) {
    var rt = tt[Ou];
    if (rt)
      return rt;
    for (var dt = tt.parentNode; dt; ) {
      if (rt = dt[nc] || dt[Ou]) {
        if (dt = rt.alternate, rt.child !== null || dt !== null && dt.child !== null)
          for (tt = Ph(tt); tt !== null; ) {
            if (dt = tt[Ou])
              return dt;
            tt = Ph(tt);
          }
        return rt;
      }
      tt = dt, dt = tt.parentNode;
    }
    return null;
  }
  function Dh(tt) {
    return tt = tt[Ou] || tt[nc], !tt || tt.tag !== 5 && tt.tag !== 6 && tt.tag !== 13 && tt.tag !== 3 ? null : tt;
  }
  function Cf(tt) {
    if (tt.tag === 5 || tt.tag === 6)
      return tt.stateNode;
    throw Error(ee(33));
  }
  function js(tt) {
    return tt[Rd] || null;
  }
  var Hc = [], Xo = -1;
  function po(tt) {
    return { current: tt };
  }
  function ko(tt) {
    0 > Xo || (tt.current = Hc[Xo], Hc[Xo] = null, Xo--);
  }
  function Fo(tt, rt) {
    Xo++, Hc[Xo] = tt.current, tt.current = rt;
  }
  var Mu = {}, io = po(Mu), pa = po(!1), Rl = Mu;
  function ru(tt, rt) {
    var dt = tt.type.contextTypes;
    if (!dt)
      return Mu;
    var mt = tt.stateNode;
    if (mt && mt.__reactInternalMemoizedUnmaskedChildContext === rt)
      return mt.__reactInternalMemoizedMaskedChildContext;
    var Zr = {}, ti;
    for (ti in dt)
      Zr[ti] = rt[ti];
    return mt && (tt = tt.stateNode, tt.__reactInternalMemoizedUnmaskedChildContext = rt, tt.__reactInternalMemoizedMaskedChildContext = Zr), Zr;
  }
  function na(tt) {
    return tt = tt.childContextTypes, tt != null;
  }
  function iu() {
    ko(pa), ko(io);
  }
  function zc(tt, rt, dt) {
    if (io.current !== Mu)
      throw Error(ee(168));
    Fo(io, rt), Fo(pa, dt);
  }
  function Oh(tt, rt, dt) {
    var mt = tt.stateNode;
    if (rt = rt.childContextTypes, typeof mt.getChildContext != "function")
      return dt;
    mt = mt.getChildContext();
    for (var Zr in mt)
      if (!(Zr in rt))
        throw Error(ee(108, Yi(tt) || "Unknown", Zr));
    return hi({}, dt, mt);
  }
  function Fp(tt) {
    return tt = (tt = tt.stateNode) && tt.__reactInternalMemoizedMergedChildContext || Mu, Rl = io.current, Fo(io, tt), Fo(pa, pa.current), !0;
  }
  function Kv(tt, rt, dt) {
    var mt = tt.stateNode;
    if (!mt)
      throw Error(ee(169));
    dt ? (tt = Oh(tt, rt, Rl), mt.__reactInternalMemoizedMergedChildContext = tt, ko(pa), ko(io), Fo(io, tt)) : ko(pa), Fo(pa, dt);
  }
  var Gl = null, Fa = !1, Mh = !1;
  function km(tt) {
    Gl === null ? Gl = [tt] : Gl.push(tt);
  }
  function Nm(tt) {
    Fa = !0, km(tt);
  }
  function Al() {
    if (!Mh && Gl !== null) {
      Mh = !0;
      var tt = 0, rt = Do;
      try {
        var dt = Gl;
        for (Do = 1; tt < dt.length; tt++) {
          var mt = dt[tt];
          do
            mt = mt(!0);
          while (mt !== null);
        }
        Gl = null, Fa = !1;
      } catch (Zr) {
        throw Gl !== null && (Gl = Gl.slice(tt + 1)), ph(yu, Al), Zr;
      } finally {
        Do = rt, Mh = !1;
      }
    }
    return null;
  }
  var Vc = [], Ll = 0, Ad = null, Rf = 0, Il = [], tl = 0, su = null, Va = 1, rc = "";
  function Hl(tt, rt) {
    Vc[Ll++] = Rf, Vc[Ll++] = Ad, Ad = tt, Rf = rt;
  }
  function Fm(tt, rt, dt) {
    Il[tl++] = Va, Il[tl++] = rc, Il[tl++] = su, su = tt;
    var mt = Va;
    tt = rc;
    var Zr = 32 - ul(mt) - 1;
    mt &= ~(1 << Zr), dt += 1;
    var ti = 32 - ul(rt) + Zr;
    if (30 < ti) {
      var fi = Zr - Zr % 5;
      ti = (mt & (1 << fi) - 1).toString(32), mt >>= fi, Zr -= fi, Va = 1 << 32 - ul(rt) + Zr | dt << Zr | mt, rc = ti + tt;
    } else
      Va = 1 << ti | dt << Zr | mt, rc = tt;
  }
  function $p(tt) {
    tt.return !== null && (Hl(tt, 1), Fm(tt, 1, 0));
  }
  function $m(tt) {
    for (; tt === Ad; )
      Ad = Vc[--Ll], Vc[Ll] = null, Rf = Vc[--Ll], Vc[Ll] = null;
    for (; tt === su; )
      su = Il[--tl], Il[tl] = null, rc = Il[--tl], Il[tl] = null, Va = Il[--tl], Il[tl] = null;
  }
  var zl = null, Pl = null, Zo = !1, ou = null;
  function Bm(tt, rt) {
    var dt = fu(5, null, null, 0);
    dt.elementType = "DELETED", dt.stateNode = rt, dt.return = tt, rt = tt.deletions, rt === null ? (tt.deletions = [dt], tt.flags |= 16) : rt.push(dt);
  }
  function qv(tt, rt) {
    switch (tt.tag) {
      case 5:
        var dt = tt.type;
        return rt = rt.nodeType !== 1 || dt.toLowerCase() !== rt.nodeName.toLowerCase() ? null : rt, rt !== null ? (tt.stateNode = rt, zl = tt, Pl = _u(rt.firstChild), !0) : !1;
      case 6:
        return rt = tt.pendingProps === "" || rt.nodeType !== 3 ? null : rt, rt !== null ? (tt.stateNode = rt, zl = tt, Pl = null, !0) : !1;
      case 13:
        return rt = rt.nodeType !== 8 ? null : rt, rt !== null ? (dt = su !== null ? { id: Va, overflow: rc } : null, tt.memoizedState = { dehydrated: rt, treeContext: dt, retryLane: 1073741824 }, dt = fu(18, null, null, 0), dt.stateNode = rt, dt.return = tt, tt.child = dt, zl = tt, Pl = null, !0) : !1;
      default:
        return !1;
    }
  }
  function Bp(tt) {
    return (tt.mode & 1) !== 0 && (tt.flags & 128) === 0;
  }
  function Up(tt) {
    if (Zo) {
      var rt = Pl;
      if (rt) {
        var dt = rt;
        if (!qv(tt, rt)) {
          if (Bp(tt))
            throw Error(ee(418));
          rt = _u(dt.nextSibling);
          var mt = zl;
          rt && qv(tt, rt) ? Bm(mt, dt) : (tt.flags = tt.flags & -4097 | 2, Zo = !1, zl = tt);
        }
      } else {
        if (Bp(tt))
          throw Error(ee(418));
        tt.flags = tt.flags & -4097 | 2, Zo = !1, zl = tt;
      }
    }
  }
  function Yv(tt) {
    for (tt = tt.return; tt !== null && tt.tag !== 5 && tt.tag !== 3 && tt.tag !== 13; )
      tt = tt.return;
    zl = tt;
  }
  function Gp(tt) {
    if (tt !== zl)
      return !1;
    if (!Zo)
      return Yv(tt), Zo = !0, !1;
    var rt;
    if ((rt = tt.tag !== 3) && !(rt = tt.tag !== 5) && (rt = tt.type, rt = rt !== "head" && rt !== "body" && !Ih(tt.type, tt.memoizedProps)), rt && (rt = Pl)) {
      if (Bp(tt))
        throw Xv(), Error(ee(418));
      for (; rt; )
        Bm(tt, rt), rt = _u(rt.nextSibling);
    }
    if (Yv(tt), tt.tag === 13) {
      if (tt = tt.memoizedState, tt = tt !== null ? tt.dehydrated : null, !tt)
        throw Error(ee(317));
      e: {
        for (tt = tt.nextSibling, rt = 0; tt; ) {
          if (tt.nodeType === 8) {
            var dt = tt.data;
            if (dt === "/$") {
              if (rt === 0) {
                Pl = _u(tt.nextSibling);
                break e;
              }
              rt--;
            } else
              dt !== "$" && dt !== "$!" && dt !== "$?" || rt++;
          }
          tt = tt.nextSibling;
        }
        Pl = null;
      }
    } else
      Pl = zl ? _u(tt.stateNode.nextSibling) : null;
    return !0;
  }
  function Xv() {
    for (var tt = Pl; tt; )
      tt = _u(tt.nextSibling);
  }
  function oa() {
    Pl = zl = null, Zo = !1;
  }
  function Um(tt) {
    ou === null ? ou = [tt] : ou.push(tt);
  }
  var Hp = Jr.ReactCurrentBatchConfig;
  function Vl(tt, rt) {
    if (tt && tt.defaultProps) {
      rt = hi({}, rt), tt = tt.defaultProps;
      for (var dt in tt)
        rt[dt] === void 0 && (rt[dt] = tt[dt]);
      return rt;
    }
    return rt;
  }
  var ku = po(null), zp = null, jc = null, Gm = null;
  function Hm() {
    Gm = jc = zp = null;
  }
  function Wc(tt) {
    var rt = ku.current;
    ko(ku), tt._currentValue = rt;
  }
  function $a(tt, rt, dt) {
    for (; tt !== null; ) {
      var mt = tt.alternate;
      if ((tt.childLanes & rt) !== rt ? (tt.childLanes |= rt, mt !== null && (mt.childLanes |= rt)) : mt !== null && (mt.childLanes & rt) !== rt && (mt.childLanes |= rt), tt === dt)
        break;
      tt = tt.return;
    }
  }
  function vs(tt, rt) {
    zp = tt, Gm = jc = null, tt = tt.dependencies, tt !== null && tt.firstContext !== null && (tt.lanes & rt && (wa = !0), tt.firstContext = null);
  }
  function ya(tt) {
    var rt = tt._currentValue;
    if (Gm !== tt)
      if (tt = { context: tt, memoizedValue: rt, next: null }, jc === null) {
        if (zp === null)
          throw Error(ee(308));
        jc = tt, zp.dependencies = { lanes: 0, firstContext: tt };
      } else
        jc = jc.next = tt;
    return rt;
  }
  var ja = null;
  function zm(tt) {
    ja === null ? ja = [tt] : ja.push(tt);
  }
  function Zv(tt, rt, dt, mt) {
    var Zr = rt.interleaved;
    return Zr === null ? (dt.next = dt, zm(rt)) : (dt.next = Zr.next, Zr.next = dt), rt.interleaved = dt, ic(tt, mt);
  }
  function ic(tt, rt) {
    tt.lanes |= rt;
    var dt = tt.alternate;
    for (dt !== null && (dt.lanes |= rt), dt = tt, tt = tt.return; tt !== null; )
      tt.childLanes |= rt, dt = tt.alternate, dt !== null && (dt.childLanes |= rt), dt = tt, tt = tt.return;
    return dt.tag === 3 ? dt.stateNode : null;
  }
  var Kc = !1;
  function Vm(tt) {
    tt.updateQueue = { baseState: tt.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function La(tt, rt) {
    tt = tt.updateQueue, rt.updateQueue === tt && (rt.updateQueue = { baseState: tt.baseState, firstBaseUpdate: tt.firstBaseUpdate, lastBaseUpdate: tt.lastBaseUpdate, shared: tt.shared, effects: tt.effects });
  }
  function sc(tt, rt) {
    return { eventTime: tt, lane: rt, tag: 0, payload: null, callback: null, next: null };
  }
  function qc(tt, rt, dt) {
    var mt = tt.updateQueue;
    if (mt === null)
      return null;
    if (mt = mt.shared, bo & 2) {
      var Zr = mt.pending;
      return Zr === null ? rt.next = rt : (rt.next = Zr.next, Zr.next = rt), mt.pending = rt, ic(tt, dt);
    }
    return Zr = mt.interleaved, Zr === null ? (rt.next = rt, zm(mt)) : (rt.next = Zr.next, Zr.next = rt), mt.interleaved = rt, ic(tt, dt);
  }
  function Vp(tt, rt, dt) {
    if (rt = rt.updateQueue, rt !== null && (rt = rt.shared, (dt & 4194240) !== 0)) {
      var mt = rt.lanes;
      mt &= tt.pendingLanes, dt |= mt, rt.lanes = dt, Pu(tt, dt);
    }
  }
  function jm(tt, rt) {
    var dt = tt.updateQueue, mt = tt.alternate;
    if (mt !== null && (mt = mt.updateQueue, dt === mt)) {
      var Zr = null, ti = null;
      if (dt = dt.firstBaseUpdate, dt !== null) {
        do {
          var fi = { eventTime: dt.eventTime, lane: dt.lane, tag: dt.tag, payload: dt.payload, callback: dt.callback, next: null };
          ti === null ? Zr = ti = fi : ti = ti.next = fi, dt = dt.next;
        } while (dt !== null);
        ti === null ? Zr = ti = rt : ti = ti.next = rt;
      } else
        Zr = ti = rt;
      dt = { baseState: mt.baseState, firstBaseUpdate: Zr, lastBaseUpdate: ti, shared: mt.shared, effects: mt.effects }, tt.updateQueue = dt;
      return;
    }
    tt = dt.lastBaseUpdate, tt === null ? dt.firstBaseUpdate = rt : tt.next = rt, dt.lastBaseUpdate = rt;
  }
  function Yc(tt, rt, dt, mt) {
    var Zr = tt.updateQueue;
    Kc = !1;
    var ti = Zr.firstBaseUpdate, fi = Zr.lastBaseUpdate, wi = Zr.shared.pending;
    if (wi !== null) {
      Zr.shared.pending = null;
      var Pi = wi, Wi = Pi.next;
      Pi.next = null, fi === null ? ti = Wi : fi.next = Wi, fi = Pi;
      var as = tt.alternate;
      as !== null && (as = as.updateQueue, wi = as.lastBaseUpdate, wi !== fi && (wi === null ? as.firstBaseUpdate = Wi : wi.next = Wi, as.lastBaseUpdate = Pi));
    }
    if (ti !== null) {
      var cs = Zr.baseState;
      fi = 0, as = Wi = Pi = null, wi = ti;
      do {
        var os = wi.lane, _s = wi.eventTime;
        if ((mt & os) === os) {
          as !== null && (as = as.next = {
            eventTime: _s,
            lane: 0,
            tag: wi.tag,
            payload: wi.payload,
            callback: wi.callback,
            next: null
          });
          e: {
            var Ls = tt, Ds = wi;
            switch (os = rt, _s = dt, Ds.tag) {
              case 1:
                if (Ls = Ds.payload, typeof Ls == "function") {
                  cs = Ls.call(_s, cs, os);
                  break e;
                }
                cs = Ls;
                break e;
              case 3:
                Ls.flags = Ls.flags & -65537 | 128;
              case 0:
                if (Ls = Ds.payload, os = typeof Ls == "function" ? Ls.call(_s, cs, os) : Ls, os == null)
                  break e;
                cs = hi({}, cs, os);
                break e;
              case 2:
                Kc = !0;
            }
          }
          wi.callback !== null && wi.lane !== 0 && (tt.flags |= 64, os = Zr.effects, os === null ? Zr.effects = [wi] : os.push(wi));
        } else
          _s = { eventTime: _s, lane: os, tag: wi.tag, payload: wi.payload, callback: wi.callback, next: null }, as === null ? (Wi = as = _s, Pi = cs) : as = as.next = _s, fi |= os;
        if (wi = wi.next, wi === null) {
          if (wi = Zr.shared.pending, wi === null)
            break;
          os = wi, wi = os.next, os.next = null, Zr.lastBaseUpdate = os, Zr.shared.pending = null;
        }
      } while (!0);
      if (as === null && (Pi = cs), Zr.baseState = Pi, Zr.firstBaseUpdate = Wi, Zr.lastBaseUpdate = as, rt = Zr.shared.interleaved, rt !== null) {
        Zr = rt;
        do
          fi |= Zr.lane, Zr = Zr.next;
        while (Zr !== rt);
      } else
        ti === null && (Zr.shared.lanes = 0);
      uc |= fi, tt.lanes = fi, tt.memoizedState = cs;
    }
  }
  function Ld(tt, rt, dt) {
    if (tt = rt.effects, rt.effects = null, tt !== null)
      for (rt = 0; rt < tt.length; rt++) {
        var mt = tt[rt], Zr = mt.callback;
        if (Zr !== null) {
          if (mt.callback = null, mt = dt, typeof Zr != "function")
            throw Error(ee(191, Zr));
          Zr.call(mt);
        }
      }
  }
  var Qv = new ie.Component().refs;
  function Wm(tt, rt, dt, mt) {
    rt = tt.memoizedState, dt = dt(mt, rt), dt = dt == null ? rt : hi({}, rt, dt), tt.memoizedState = dt, tt.lanes === 0 && (tt.updateQueue.baseState = dt);
  }
  var jp = { isMounted: function(tt) {
    return (tt = tt._reactInternals) ? Ql(tt) === tt : !1;
  }, enqueueSetState: function(tt, rt, dt) {
    tt = tt._reactInternals;
    var mt = sl(), Zr = Ca(tt), ti = sc(mt, Zr);
    ti.payload = rt, dt != null && (ti.callback = dt), rt = qc(tt, ti, Zr), rt !== null && (ol(rt, tt, Zr, mt), Vp(rt, tt, Zr));
  }, enqueueReplaceState: function(tt, rt, dt) {
    tt = tt._reactInternals;
    var mt = sl(), Zr = Ca(tt), ti = sc(mt, Zr);
    ti.tag = 1, ti.payload = rt, dt != null && (ti.callback = dt), rt = qc(tt, ti, Zr), rt !== null && (ol(rt, tt, Zr, mt), Vp(rt, tt, Zr));
  }, enqueueForceUpdate: function(tt, rt) {
    tt = tt._reactInternals;
    var dt = sl(), mt = Ca(tt), Zr = sc(dt, mt);
    Zr.tag = 2, rt != null && (Zr.callback = rt), rt = qc(tt, Zr, mt), rt !== null && (ol(rt, tt, mt, dt), Vp(rt, tt, mt));
  } };
  function Jv(tt, rt, dt, mt, Zr, ti, fi) {
    return tt = tt.stateNode, typeof tt.shouldComponentUpdate == "function" ? tt.shouldComponentUpdate(mt, ti, fi) : rt.prototype && rt.prototype.isPureReactComponent ? !Sh(dt, mt) || !Sh(Zr, ti) : !0;
  }
  function ey(tt, rt, dt) {
    var mt = !1, Zr = Mu, ti = rt.contextType;
    return typeof ti == "object" && ti !== null ? ti = ya(ti) : (Zr = na(rt) ? Rl : io.current, mt = rt.contextTypes, ti = (mt = mt != null) ? ru(tt, Zr) : Mu), rt = new rt(dt, ti), tt.memoizedState = rt.state !== null && rt.state !== void 0 ? rt.state : null, rt.updater = jp, tt.stateNode = rt, rt._reactInternals = tt, mt && (tt = tt.stateNode, tt.__reactInternalMemoizedUnmaskedChildContext = Zr, tt.__reactInternalMemoizedMaskedChildContext = ti), rt;
  }
  function ty(tt, rt, dt, mt) {
    tt = rt.state, typeof rt.componentWillReceiveProps == "function" && rt.componentWillReceiveProps(dt, mt), typeof rt.UNSAFE_componentWillReceiveProps == "function" && rt.UNSAFE_componentWillReceiveProps(dt, mt), rt.state !== tt && jp.enqueueReplaceState(rt, rt.state, null);
  }
  function Wp(tt, rt, dt, mt) {
    var Zr = tt.stateNode;
    Zr.props = dt, Zr.state = tt.memoizedState, Zr.refs = Qv, Vm(tt);
    var ti = rt.contextType;
    typeof ti == "object" && ti !== null ? Zr.context = ya(ti) : (ti = na(rt) ? Rl : io.current, Zr.context = ru(tt, ti)), Zr.state = tt.memoizedState, ti = rt.getDerivedStateFromProps, typeof ti == "function" && (Wm(tt, rt, ti, dt), Zr.state = tt.memoizedState), typeof rt.getDerivedStateFromProps == "function" || typeof Zr.getSnapshotBeforeUpdate == "function" || typeof Zr.UNSAFE_componentWillMount != "function" && typeof Zr.componentWillMount != "function" || (rt = Zr.state, typeof Zr.componentWillMount == "function" && Zr.componentWillMount(), typeof Zr.UNSAFE_componentWillMount == "function" && Zr.UNSAFE_componentWillMount(), rt !== Zr.state && jp.enqueueReplaceState(Zr, Zr.state, null), Yc(tt, dt, Zr, mt), Zr.state = tt.memoizedState), typeof Zr.componentDidMount == "function" && (tt.flags |= 4194308);
  }
  function Af(tt, rt, dt) {
    if (tt = dt.ref, tt !== null && typeof tt != "function" && typeof tt != "object") {
      if (dt._owner) {
        if (dt = dt._owner, dt) {
          if (dt.tag !== 1)
            throw Error(ee(309));
          var mt = dt.stateNode;
        }
        if (!mt)
          throw Error(ee(147, tt));
        var Zr = mt, ti = "" + tt;
        return rt !== null && rt.ref !== null && typeof rt.ref == "function" && rt.ref._stringRef === ti ? rt.ref : (rt = function(fi) {
          var wi = Zr.refs;
          wi === Qv && (wi = Zr.refs = {}), fi === null ? delete wi[ti] : wi[ti] = fi;
        }, rt._stringRef = ti, rt);
      }
      if (typeof tt != "string")
        throw Error(ee(284));
      if (!dt._owner)
        throw Error(ee(290, tt));
    }
    return tt;
  }
  function Kp(tt, rt) {
    throw tt = Object.prototype.toString.call(rt), Error(ee(31, tt === "[object Object]" ? "object with keys {" + Object.keys(rt).join(", ") + "}" : tt));
  }
  function ny(tt) {
    var rt = tt._init;
    return rt(tt._payload);
  }
  function ry(tt) {
    function rt(Fi, ki) {
      if (tt) {
        var Ui = Fi.deletions;
        Ui === null ? (Fi.deletions = [ki], Fi.flags |= 16) : Ui.push(ki);
      }
    }
    function dt(Fi, ki) {
      if (!tt)
        return null;
      for (; ki !== null; )
        rt(Fi, ki), ki = ki.sibling;
      return null;
    }
    function mt(Fi, ki) {
      for (Fi = /* @__PURE__ */ new Map(); ki !== null; )
        ki.key !== null ? Fi.set(ki.key, ki) : Fi.set(ki.index, ki), ki = ki.sibling;
      return Fi;
    }
    function Zr(Fi, ki) {
      return Fi = id(Fi, ki), Fi.index = 0, Fi.sibling = null, Fi;
    }
    function ti(Fi, ki, Ui) {
      return Fi.index = Ui, tt ? (Ui = Fi.alternate, Ui !== null ? (Ui = Ui.index, Ui < ki ? (Fi.flags |= 2, ki) : Ui) : (Fi.flags |= 2, ki)) : (Fi.flags |= 1048576, ki);
    }
    function fi(Fi) {
      return tt && Fi.alternate === null && (Fi.flags |= 2), Fi;
    }
    function wi(Fi, ki, Ui, gs) {
      return ki === null || ki.tag !== 6 ? (ki = Jh(Ui, Fi.mode, gs), ki.return = Fi, ki) : (ki = Zr(ki, Ui), ki.return = Fi, ki);
    }
    function Pi(Fi, ki, Ui, gs) {
      var ks = Ui.type;
      return ks === ri ? as(Fi, ki, Ui.props.children, gs, Ui.key) : ki !== null && (ki.elementType === ks || typeof ks == "object" && ks !== null && ks.$$typeof === Si && ny(ks) === ki.type) ? (gs = Zr(ki, Ui.props), gs.ref = Af(Fi, ki, Ui), gs.return = Fi, gs) : (gs = wg(Ui.type, Ui.key, Ui.props, null, Fi.mode, gs), gs.ref = Af(Fi, ki, Ui), gs.return = Fi, gs);
    }
    function Wi(Fi, ki, Ui, gs) {
      return ki === null || ki.tag !== 4 || ki.stateNode.containerInfo !== Ui.containerInfo || ki.stateNode.implementation !== Ui.implementation ? (ki = qd(Ui, Fi.mode, gs), ki.return = Fi, ki) : (ki = Zr(ki, Ui.children || []), ki.return = Fi, ki);
    }
    function as(Fi, ki, Ui, gs, ks) {
      return ki === null || ki.tag !== 7 ? (ki = Kd(Ui, Fi.mode, gs, ks), ki.return = Fi, ki) : (ki = Zr(ki, Ui), ki.return = Fi, ki);
    }
    function cs(Fi, ki, Ui) {
      if (typeof ki == "string" && ki !== "" || typeof ki == "number")
        return ki = Jh("" + ki, Fi.mode, Ui), ki.return = Fi, ki;
      if (typeof ki == "object" && ki !== null) {
        switch (ki.$$typeof) {
          case ei:
            return Ui = wg(ki.type, ki.key, ki.props, null, Fi.mode, Ui), Ui.ref = Af(Fi, null, ki), Ui.return = Fi, Ui;
          case si:
            return ki = qd(ki, Fi.mode, Ui), ki.return = Fi, ki;
          case Si:
            var gs = ki._init;
            return cs(Fi, gs(ki._payload), Ui);
        }
        if (Ks(ki) || Oi(ki))
          return ki = Kd(ki, Fi.mode, Ui, null), ki.return = Fi, ki;
        Kp(Fi, ki);
      }
      return null;
    }
    function os(Fi, ki, Ui, gs) {
      var ks = ki !== null ? ki.key : null;
      if (typeof Ui == "string" && Ui !== "" || typeof Ui == "number")
        return ks !== null ? null : wi(Fi, ki, "" + Ui, gs);
      if (typeof Ui == "object" && Ui !== null) {
        switch (Ui.$$typeof) {
          case ei:
            return Ui.key === ks ? Pi(Fi, ki, Ui, gs) : null;
          case si:
            return Ui.key === ks ? Wi(Fi, ki, Ui, gs) : null;
          case Si:
            return ks = Ui._init, os(
              Fi,
              ki,
              ks(Ui._payload),
              gs
            );
        }
        if (Ks(Ui) || Oi(Ui))
          return ks !== null ? null : as(Fi, ki, Ui, gs, null);
        Kp(Fi, Ui);
      }
      return null;
    }
    function _s(Fi, ki, Ui, gs, ks) {
      if (typeof gs == "string" && gs !== "" || typeof gs == "number")
        return Fi = Fi.get(Ui) || null, wi(ki, Fi, "" + gs, ks);
      if (typeof gs == "object" && gs !== null) {
        switch (gs.$$typeof) {
          case ei:
            return Fi = Fi.get(gs.key === null ? Ui : gs.key) || null, Pi(ki, Fi, gs, ks);
          case si:
            return Fi = Fi.get(gs.key === null ? Ui : gs.key) || null, Wi(ki, Fi, gs, ks);
          case Si:
            var Is = gs._init;
            return _s(Fi, ki, Ui, Is(gs._payload), ks);
        }
        if (Ks(gs) || Oi(gs))
          return Fi = Fi.get(Ui) || null, as(ki, Fi, gs, ks, null);
        Kp(ki, gs);
      }
      return null;
    }
    function Ls(Fi, ki, Ui, gs) {
      for (var ks = null, Is = null, zs = ki, so = ki = 0, Ga = null; zs !== null && so < Ui.length; so++) {
        zs.index > so ? (Ga = zs, zs = null) : Ga = zs.sibling;
        var Po = os(Fi, zs, Ui[so], gs);
        if (Po === null) {
          zs === null && (zs = Ga);
          break;
        }
        tt && zs && Po.alternate === null && rt(Fi, zs), ki = ti(Po, ki, so), Is === null ? ks = Po : Is.sibling = Po, Is = Po, zs = Ga;
      }
      if (so === Ui.length)
        return dt(Fi, zs), Zo && Hl(Fi, so), ks;
      if (zs === null) {
        for (; so < Ui.length; so++)
          zs = cs(Fi, Ui[so], gs), zs !== null && (ki = ti(zs, ki, so), Is === null ? ks = zs : Is.sibling = zs, Is = zs);
        return Zo && Hl(Fi, so), ks;
      }
      for (zs = mt(Fi, zs); so < Ui.length; so++)
        Ga = _s(zs, Fi, so, Ui[so], gs), Ga !== null && (tt && Ga.alternate !== null && zs.delete(Ga.key === null ? so : Ga.key), ki = ti(Ga, ki, so), Is === null ? ks = Ga : Is.sibling = Ga, Is = Ga);
      return tt && zs.forEach(function(sd) {
        return rt(Fi, sd);
      }), Zo && Hl(Fi, so), ks;
    }
    function Ds(Fi, ki, Ui, gs) {
      var ks = Oi(Ui);
      if (typeof ks != "function")
        throw Error(ee(150));
      if (Ui = ks.call(Ui), Ui == null)
        throw Error(ee(151));
      for (var Is = ks = null, zs = ki, so = ki = 0, Ga = null, Po = Ui.next(); zs !== null && !Po.done; so++, Po = Ui.next()) {
        zs.index > so ? (Ga = zs, zs = null) : Ga = zs.sibling;
        var sd = os(Fi, zs, Po.value, gs);
        if (sd === null) {
          zs === null && (zs = Ga);
          break;
        }
        tt && zs && sd.alternate === null && rt(Fi, zs), ki = ti(sd, ki, so), Is === null ? ks = sd : Is.sibling = sd, Is = sd, zs = Ga;
      }
      if (Po.done)
        return dt(
          Fi,
          zs
        ), Zo && Hl(Fi, so), ks;
      if (zs === null) {
        for (; !Po.done; so++, Po = Ui.next())
          Po = cs(Fi, Po.value, gs), Po !== null && (ki = ti(Po, ki, so), Is === null ? ks = Po : Is.sibling = Po, Is = Po);
        return Zo && Hl(Fi, so), ks;
      }
      for (zs = mt(Fi, zs); !Po.done; so++, Po = Ui.next())
        Po = _s(zs, Fi, so, Po.value, gs), Po !== null && (tt && Po.alternate !== null && zs.delete(Po.key === null ? so : Po.key), ki = ti(Po, ki, so), Is === null ? ks = Po : Is.sibling = Po, Is = Po);
      return tt && zs.forEach(function(U1) {
        return rt(Fi, U1);
      }), Zo && Hl(Fi, so), ks;
    }
    function Ea(Fi, ki, Ui, gs) {
      if (typeof Ui == "object" && Ui !== null && Ui.type === ri && Ui.key === null && (Ui = Ui.props.children), typeof Ui == "object" && Ui !== null) {
        switch (Ui.$$typeof) {
          case ei:
            e: {
              for (var ks = Ui.key, Is = ki; Is !== null; ) {
                if (Is.key === ks) {
                  if (ks = Ui.type, ks === ri) {
                    if (Is.tag === 7) {
                      dt(Fi, Is.sibling), ki = Zr(Is, Ui.props.children), ki.return = Fi, Fi = ki;
                      break e;
                    }
                  } else if (Is.elementType === ks || typeof ks == "object" && ks !== null && ks.$$typeof === Si && ny(ks) === Is.type) {
                    dt(Fi, Is.sibling), ki = Zr(Is, Ui.props), ki.ref = Af(Fi, Is, Ui), ki.return = Fi, Fi = ki;
                    break e;
                  }
                  dt(Fi, Is);
                  break;
                } else
                  rt(Fi, Is);
                Is = Is.sibling;
              }
              Ui.type === ri ? (ki = Kd(Ui.props.children, Fi.mode, gs, Ui.key), ki.return = Fi, Fi = ki) : (gs = wg(Ui.type, Ui.key, Ui.props, null, Fi.mode, gs), gs.ref = Af(Fi, ki, Ui), gs.return = Fi, Fi = gs);
            }
            return fi(Fi);
          case si:
            e: {
              for (Is = Ui.key; ki !== null; ) {
                if (ki.key === Is)
                  if (ki.tag === 4 && ki.stateNode.containerInfo === Ui.containerInfo && ki.stateNode.implementation === Ui.implementation) {
                    dt(Fi, ki.sibling), ki = Zr(ki, Ui.children || []), ki.return = Fi, Fi = ki;
                    break e;
                  } else {
                    dt(Fi, ki);
                    break;
                  }
                else
                  rt(Fi, ki);
                ki = ki.sibling;
              }
              ki = qd(Ui, Fi.mode, gs), ki.return = Fi, Fi = ki;
            }
            return fi(Fi);
          case Si:
            return Is = Ui._init, Ea(Fi, ki, Is(Ui._payload), gs);
        }
        if (Ks(Ui))
          return Ls(Fi, ki, Ui, gs);
        if (Oi(Ui))
          return Ds(Fi, ki, Ui, gs);
        Kp(Fi, Ui);
      }
      return typeof Ui == "string" && Ui !== "" || typeof Ui == "number" ? (Ui = "" + Ui, ki !== null && ki.tag === 6 ? (dt(Fi, ki.sibling), ki = Zr(ki, Ui), ki.return = Fi, Fi = ki) : (dt(Fi, ki), ki = Jh(Ui, Fi.mode, gs), ki.return = Fi, Fi = ki), fi(Fi)) : dt(Fi, ki);
    }
    return Ea;
  }
  var Lf = ry(!0), iy = ry(!1), kh = {}, wu = po(kh), Nh = po(kh), If = po(kh);
  function Id(tt) {
    if (tt === kh)
      throw Error(ee(174));
    return tt;
  }
  function Km(tt, rt) {
    switch (Fo(If, rt), Fo(Nh, tt), Fo(wu, kh), tt = rt.nodeType, tt) {
      case 9:
      case 11:
        rt = (rt = rt.documentElement) ? rt.namespaceURI : mo(null, "");
        break;
      default:
        tt = tt === 8 ? rt.parentNode : rt, rt = tt.namespaceURI || null, tt = tt.tagName, rt = mo(rt, tt);
    }
    ko(wu), Fo(wu, rt);
  }
  function Xc() {
    ko(wu), ko(Nh), ko(If);
  }
  function Xs(tt) {
    Id(If.current);
    var rt = Id(wu.current), dt = mo(rt, tt.type);
    rt !== dt && (Fo(Nh, tt), Fo(wu, dt));
  }
  function Eo(tt) {
    Nh.current === tt && (ko(wu), ko(Nh));
  }
  var Qs = po(0);
  function aa(tt) {
    for (var rt = tt; rt !== null; ) {
      if (rt.tag === 13) {
        var dt = rt.memoizedState;
        if (dt !== null && (dt = dt.dehydrated, dt === null || dt.data === "$?" || dt.data === "$!"))
          return rt;
      } else if (rt.tag === 19 && rt.memoizedProps.revealOrder !== void 0) {
        if (rt.flags & 128)
          return rt;
      } else if (rt.child !== null) {
        rt.child.return = rt, rt = rt.child;
        continue;
      }
      if (rt === tt)
        break;
      for (; rt.sibling === null; ) {
        if (rt.return === null || rt.return === tt)
          return null;
        rt = rt.return;
      }
      rt.sibling.return = rt.return, rt = rt.sibling;
    }
    return null;
  }
  var au = [];
  function qp() {
    for (var tt = 0; tt < au.length; tt++)
      au[tt]._workInProgressVersionPrimary = null;
    au.length = 0;
  }
  var Yp = Jr.ReactCurrentDispatcher, qm = Jr.ReactCurrentBatchConfig, Pd = 0, Qo = null, Ji = null, wo = null, to = !1, Nu = !1, jl = 0, Dd = 0;
  function Jo() {
    throw Error(ee(321));
  }
  function Od(tt, rt) {
    if (rt === null)
      return !1;
    for (var dt = 0; dt < rt.length && dt < tt.length; dt++)
      if (!tu(tt[dt], rt[dt]))
        return !1;
    return !0;
  }
  function Zc(tt, rt, dt, mt, Zr, ti) {
    if (Pd = ti, Qo = rt, rt.memoizedState = null, rt.updateQueue = null, rt.lanes = 0, Yp.current = tt === null || tt.memoizedState === null ? b1 : S1, tt = dt(mt, Zr), Nu) {
      ti = 0;
      do {
        if (Nu = !1, jl = 0, 25 <= ti)
          throw Error(ee(301));
        ti += 1, wo = Ji = null, rt.updateQueue = null, Yp.current = Xm, tt = dt(mt, Zr);
      } while (Nu);
    }
    if (Yp.current = dg, rt = Ji !== null && Ji.next !== null, Pd = 0, wo = Ji = Qo = null, to = !1, rt)
      throw Error(ee(300));
    return tt;
  }
  function Md() {
    var tt = jl !== 0;
    return jl = 0, tt;
  }
  function lu() {
    var tt = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return wo === null ? Qo.memoizedState = wo = tt : wo = wo.next = tt, wo;
  }
  function Dl() {
    if (Ji === null) {
      var tt = Qo.alternate;
      tt = tt !== null ? tt.memoizedState : null;
    } else
      tt = Ji.next;
    var rt = wo === null ? Qo.memoizedState : wo.next;
    if (rt !== null)
      wo = rt, Ji = tt;
    else {
      if (tt === null)
        throw Error(ee(310));
      Ji = tt, tt = { memoizedState: Ji.memoizedState, baseState: Ji.baseState, baseQueue: Ji.baseQueue, queue: Ji.queue, next: null }, wo === null ? Qo.memoizedState = wo = tt : wo = wo.next = tt;
    }
    return wo;
  }
  function kd(tt, rt) {
    return typeof rt == "function" ? rt(tt) : rt;
  }
  function Fh(tt) {
    var rt = Dl(), dt = rt.queue;
    if (dt === null)
      throw Error(ee(311));
    dt.lastRenderedReducer = tt;
    var mt = Ji, Zr = mt.baseQueue, ti = dt.pending;
    if (ti !== null) {
      if (Zr !== null) {
        var fi = Zr.next;
        Zr.next = ti.next, ti.next = fi;
      }
      mt.baseQueue = Zr = ti, dt.pending = null;
    }
    if (Zr !== null) {
      ti = Zr.next, mt = mt.baseState;
      var wi = fi = null, Pi = null, Wi = ti;
      do {
        var as = Wi.lane;
        if ((Pd & as) === as)
          Pi !== null && (Pi = Pi.next = { lane: 0, action: Wi.action, hasEagerState: Wi.hasEagerState, eagerState: Wi.eagerState, next: null }), mt = Wi.hasEagerState ? Wi.eagerState : tt(mt, Wi.action);
        else {
          var cs = {
            lane: as,
            action: Wi.action,
            hasEagerState: Wi.hasEagerState,
            eagerState: Wi.eagerState,
            next: null
          };
          Pi === null ? (wi = Pi = cs, fi = mt) : Pi = Pi.next = cs, Qo.lanes |= as, uc |= as;
        }
        Wi = Wi.next;
      } while (Wi !== null && Wi !== ti);
      Pi === null ? fi = mt : Pi.next = wi, tu(mt, rt.memoizedState) || (wa = !0), rt.memoizedState = mt, rt.baseState = fi, rt.baseQueue = Pi, dt.lastRenderedState = mt;
    }
    if (tt = dt.interleaved, tt !== null) {
      Zr = tt;
      do
        ti = Zr.lane, Qo.lanes |= ti, uc |= ti, Zr = Zr.next;
      while (Zr !== tt);
    } else
      Zr === null && (dt.lanes = 0);
    return [rt.memoizedState, dt.dispatch];
  }
  function $h(tt) {
    var rt = Dl(), dt = rt.queue;
    if (dt === null)
      throw Error(ee(311));
    dt.lastRenderedReducer = tt;
    var mt = dt.dispatch, Zr = dt.pending, ti = rt.memoizedState;
    if (Zr !== null) {
      dt.pending = null;
      var fi = Zr = Zr.next;
      do
        ti = tt(ti, fi.action), fi = fi.next;
      while (fi !== Zr);
      tu(ti, rt.memoizedState) || (wa = !0), rt.memoizedState = ti, rt.baseQueue === null && (rt.baseState = ti), dt.lastRenderedState = ti;
    }
    return [ti, mt];
  }
  function Xp() {
  }
  function Zp(tt, rt) {
    var dt = Qo, mt = Dl(), Zr = rt(), ti = !tu(mt.memoizedState, Zr);
    if (ti && (mt.memoizedState = Zr, wa = !0), mt = mt.queue, Bh(eg.bind(null, dt, mt, tt), [tt]), mt.getSnapshot !== rt || ti || wo !== null && wo.memoizedState.tag & 1) {
      if (dt.flags |= 2048, Nd(9, Jp.bind(null, dt, mt, Zr, rt), void 0, null), la === null)
        throw Error(ee(349));
      Pd & 30 || Qp(dt, rt, Zr);
    }
    return Zr;
  }
  function Qp(tt, rt, dt) {
    tt.flags |= 16384, tt = { getSnapshot: rt, value: dt }, rt = Qo.updateQueue, rt === null ? (rt = { lastEffect: null, stores: null }, Qo.updateQueue = rt, rt.stores = [tt]) : (dt = rt.stores, dt === null ? rt.stores = [tt] : dt.push(tt));
  }
  function Jp(tt, rt, dt, mt) {
    rt.value = dt, rt.getSnapshot = mt, tg(rt) && ng(tt);
  }
  function eg(tt, rt, dt) {
    return dt(function() {
      tg(rt) && ng(tt);
    });
  }
  function tg(tt) {
    var rt = tt.getSnapshot;
    tt = tt.value;
    try {
      var dt = rt();
      return !tu(tt, dt);
    } catch {
      return !0;
    }
  }
  function ng(tt) {
    var rt = ic(tt, 1);
    rt !== null && ol(rt, tt, 1, -1);
  }
  function rg(tt) {
    var rt = lu();
    return typeof tt == "function" && (tt = tt()), rt.memoizedState = rt.baseState = tt, tt = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: kd, lastRenderedState: tt }, rt.queue = tt, tt = tt.dispatch = cg.bind(null, Qo, tt), [rt.memoizedState, tt];
  }
  function Nd(tt, rt, dt, mt) {
    return tt = { tag: tt, create: rt, destroy: dt, deps: mt, next: null }, rt = Qo.updateQueue, rt === null ? (rt = { lastEffect: null, stores: null }, Qo.updateQueue = rt, rt.lastEffect = tt.next = tt) : (dt = rt.lastEffect, dt === null ? rt.lastEffect = tt.next = tt : (mt = dt.next, dt.next = tt, tt.next = mt, rt.lastEffect = tt)), tt;
  }
  function ig() {
    return Dl().memoizedState;
  }
  function Fd(tt, rt, dt, mt) {
    var Zr = lu();
    Qo.flags |= tt, Zr.memoizedState = Nd(1 | rt, dt, void 0, mt === void 0 ? null : mt);
  }
  function oc(tt, rt, dt, mt) {
    var Zr = Dl();
    mt = mt === void 0 ? null : mt;
    var ti = void 0;
    if (Ji !== null) {
      var fi = Ji.memoizedState;
      if (ti = fi.destroy, mt !== null && Od(mt, fi.deps)) {
        Zr.memoizedState = Nd(rt, dt, ti, mt);
        return;
      }
    }
    Qo.flags |= tt, Zr.memoizedState = Nd(1 | rt, dt, ti, mt);
  }
  function sg(tt, rt) {
    return Fd(8390656, 8, tt, rt);
  }
  function Bh(tt, rt) {
    return oc(2048, 8, tt, rt);
  }
  function og(tt, rt) {
    return oc(4, 2, tt, rt);
  }
  function ag(tt, rt) {
    return oc(4, 4, tt, rt);
  }
  function Ym(tt, rt) {
    if (typeof rt == "function")
      return tt = tt(), rt(tt), function() {
        rt(null);
      };
    if (rt != null)
      return tt = tt(), rt.current = tt, function() {
        rt.current = null;
      };
  }
  function Pf(tt, rt, dt) {
    return dt = dt != null ? dt.concat([tt]) : null, oc(4, 4, Ym.bind(null, rt, tt), dt);
  }
  function lg() {
  }
  function Df(tt, rt) {
    var dt = Dl();
    rt = rt === void 0 ? null : rt;
    var mt = dt.memoizedState;
    return mt !== null && rt !== null && Od(rt, mt[1]) ? mt[0] : (dt.memoizedState = [tt, rt], tt);
  }
  function Qc(tt, rt) {
    var dt = Dl();
    rt = rt === void 0 ? null : rt;
    var mt = dt.memoizedState;
    return mt !== null && rt !== null && Od(rt, mt[1]) ? mt[0] : (tt = tt(), dt.memoizedState = [tt, rt], tt);
  }
  function Ol(tt, rt, dt) {
    return Pd & 21 ? (tu(dt, rt) || (dt = df(), Qo.lanes |= dt, uc |= dt, tt.baseState = !0), rt) : (tt.baseState && (tt.baseState = !1, wa = !0), tt.memoizedState = dt);
  }
  function T1(tt, rt) {
    var dt = Do;
    Do = dt !== 0 && 4 > dt ? dt : 4, tt(!0);
    var mt = qm.transition;
    qm.transition = {};
    try {
      tt(!1), rt();
    } finally {
      Do = dt, qm.transition = mt;
    }
  }
  function jo() {
    return Dl().memoizedState;
  }
  function ug(tt, rt, dt) {
    var mt = Ca(tt);
    if (dt = { lane: mt, action: dt, hasEagerState: !1, eagerState: null, next: null }, Of(tt))
      Uh(rt, dt);
    else if (dt = Zv(tt, rt, dt, mt), dt !== null) {
      var Zr = sl();
      ol(dt, tt, mt, Zr), sy(dt, rt, mt);
    }
  }
  function cg(tt, rt, dt) {
    var mt = Ca(tt), Zr = { lane: mt, action: dt, hasEagerState: !1, eagerState: null, next: null };
    if (Of(tt))
      Uh(rt, Zr);
    else {
      var ti = tt.alternate;
      if (tt.lanes === 0 && (ti === null || ti.lanes === 0) && (ti = rt.lastRenderedReducer, ti !== null))
        try {
          var fi = rt.lastRenderedState, wi = ti(fi, dt);
          if (Zr.hasEagerState = !0, Zr.eagerState = wi, tu(wi, fi)) {
            var Pi = rt.interleaved;
            Pi === null ? (Zr.next = Zr, zm(rt)) : (Zr.next = Pi.next, Pi.next = Zr), rt.interleaved = Zr;
            return;
          }
        } catch {
        } finally {
        }
      dt = Zv(tt, rt, Zr, mt), dt !== null && (Zr = sl(), ol(dt, tt, mt, Zr), sy(dt, rt, mt));
    }
  }
  function Of(tt) {
    var rt = tt.alternate;
    return tt === Qo || rt !== null && rt === Qo;
  }
  function Uh(tt, rt) {
    Nu = to = !0;
    var dt = tt.pending;
    dt === null ? rt.next = rt : (rt.next = dt.next, dt.next = rt), tt.pending = rt;
  }
  function sy(tt, rt, dt) {
    if (dt & 4194240) {
      var mt = rt.lanes;
      mt &= tt.pendingLanes, dt |= mt, rt.lanes = dt, Pu(tt, dt);
    }
  }
  var dg = { readContext: ya, useCallback: Jo, useContext: Jo, useEffect: Jo, useImperativeHandle: Jo, useInsertionEffect: Jo, useLayoutEffect: Jo, useMemo: Jo, useReducer: Jo, useRef: Jo, useState: Jo, useDebugValue: Jo, useDeferredValue: Jo, useTransition: Jo, useMutableSource: Jo, useSyncExternalStore: Jo, useId: Jo, unstable_isNewReconciler: !1 }, b1 = { readContext: ya, useCallback: function(tt, rt) {
    return lu().memoizedState = [tt, rt === void 0 ? null : rt], tt;
  }, useContext: ya, useEffect: sg, useImperativeHandle: function(tt, rt, dt) {
    return dt = dt != null ? dt.concat([tt]) : null, Fd(
      4194308,
      4,
      Ym.bind(null, rt, tt),
      dt
    );
  }, useLayoutEffect: function(tt, rt) {
    return Fd(4194308, 4, tt, rt);
  }, useInsertionEffect: function(tt, rt) {
    return Fd(4, 2, tt, rt);
  }, useMemo: function(tt, rt) {
    var dt = lu();
    return rt = rt === void 0 ? null : rt, tt = tt(), dt.memoizedState = [tt, rt], tt;
  }, useReducer: function(tt, rt, dt) {
    var mt = lu();
    return rt = dt !== void 0 ? dt(rt) : rt, mt.memoizedState = mt.baseState = rt, tt = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: tt, lastRenderedState: rt }, mt.queue = tt, tt = tt.dispatch = ug.bind(null, Qo, tt), [mt.memoizedState, tt];
  }, useRef: function(tt) {
    var rt = lu();
    return tt = { current: tt }, rt.memoizedState = tt;
  }, useState: rg, useDebugValue: lg, useDeferredValue: function(tt) {
    return lu().memoizedState = tt;
  }, useTransition: function() {
    var tt = rg(!1), rt = tt[0];
    return tt = T1.bind(null, tt[1]), lu().memoizedState = tt, [rt, tt];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(tt, rt, dt) {
    var mt = Qo, Zr = lu();
    if (Zo) {
      if (dt === void 0)
        throw Error(ee(407));
      dt = dt();
    } else {
      if (dt = rt(), la === null)
        throw Error(ee(349));
      Pd & 30 || Qp(mt, rt, dt);
    }
    Zr.memoizedState = dt;
    var ti = { value: dt, getSnapshot: rt };
    return Zr.queue = ti, sg(eg.bind(
      null,
      mt,
      ti,
      tt
    ), [tt]), mt.flags |= 2048, Nd(9, Jp.bind(null, mt, ti, dt, rt), void 0, null), dt;
  }, useId: function() {
    var tt = lu(), rt = la.identifierPrefix;
    if (Zo) {
      var dt = rc, mt = Va;
      dt = (mt & ~(1 << 32 - ul(mt) - 1)).toString(32) + dt, rt = ":" + rt + "R" + dt, dt = jl++, 0 < dt && (rt += "H" + dt.toString(32)), rt += ":";
    } else
      dt = Dd++, rt = ":" + rt + "r" + dt.toString(32) + ":";
    return tt.memoizedState = rt;
  }, unstable_isNewReconciler: !1 }, S1 = {
    readContext: ya,
    useCallback: Df,
    useContext: ya,
    useEffect: Bh,
    useImperativeHandle: Pf,
    useInsertionEffect: og,
    useLayoutEffect: ag,
    useMemo: Qc,
    useReducer: Fh,
    useRef: ig,
    useState: function() {
      return Fh(kd);
    },
    useDebugValue: lg,
    useDeferredValue: function(tt) {
      var rt = Dl();
      return Ol(rt, Ji.memoizedState, tt);
    },
    useTransition: function() {
      var tt = Fh(kd)[0], rt = Dl().memoizedState;
      return [tt, rt];
    },
    useMutableSource: Xp,
    useSyncExternalStore: Zp,
    useId: jo,
    unstable_isNewReconciler: !1
  }, Xm = { readContext: ya, useCallback: Df, useContext: ya, useEffect: Bh, useImperativeHandle: Pf, useInsertionEffect: og, useLayoutEffect: ag, useMemo: Qc, useReducer: $h, useRef: ig, useState: function() {
    return $h(kd);
  }, useDebugValue: lg, useDeferredValue: function(tt) {
    var rt = Dl();
    return Ji === null ? rt.memoizedState = tt : Ol(rt, Ji.memoizedState, tt);
  }, useTransition: function() {
    var tt = $h(kd)[0], rt = Dl().memoizedState;
    return [tt, rt];
  }, useMutableSource: Xp, useSyncExternalStore: Zp, useId: jo, unstable_isNewReconciler: !1 };
  function Mf(tt, rt) {
    try {
      var dt = "", mt = rt;
      do
        dt += qi(mt), mt = mt.return;
      while (mt);
      var Zr = dt;
    } catch (ti) {
      Zr = `
Error generating stack: ` + ti.message + `
` + ti.stack;
    }
    return { value: tt, source: rt, stack: Zr, digest: null };
  }
  function Gh(tt, rt, dt) {
    return { value: tt, source: null, stack: dt ?? null, digest: rt ?? null };
  }
  function fg(tt, rt) {
    try {
      console.error(rt.value);
    } catch (dt) {
      setTimeout(function() {
        throw dt;
      });
    }
  }
  var _1 = typeof WeakMap == "function" ? WeakMap : Map;
  function oy(tt, rt, dt) {
    dt = sc(-1, dt), dt.tag = 3, dt.payload = { element: null };
    var mt = rt.value;
    return dt.callback = function() {
      Eg || (Eg = !0, Hd = mt), fg(tt, rt);
    }, dt;
  }
  function Hh(tt, rt, dt) {
    dt = sc(-1, dt), dt.tag = 3;
    var mt = tt.type.getDerivedStateFromError;
    if (typeof mt == "function") {
      var Zr = rt.value;
      dt.payload = function() {
        return mt(Zr);
      }, dt.callback = function() {
        fg(tt, rt);
      };
    }
    var ti = tt.stateNode;
    return ti !== null && typeof ti.componentDidCatch == "function" && (dt.callback = function() {
      fg(tt, rt), typeof mt != "function" && (Bu === null ? Bu = /* @__PURE__ */ new Set([this]) : Bu.add(this));
      var fi = rt.stack;
      this.componentDidCatch(rt.value, { componentStack: fi !== null ? fi : "" });
    }), dt;
  }
  function ay(tt, rt, dt) {
    var mt = tt.pingCache;
    if (mt === null) {
      mt = tt.pingCache = new _1();
      var Zr = /* @__PURE__ */ new Set();
      mt.set(rt, Zr);
    } else
      Zr = mt.get(rt), Zr === void 0 && (Zr = /* @__PURE__ */ new Set(), mt.set(rt, Zr));
    Zr.has(dt) || (Zr.add(dt), tt = P1.bind(null, tt, rt, dt), rt.then(tt, tt));
  }
  function Zm(tt) {
    do {
      var rt;
      if ((rt = tt.tag === 13) && (rt = tt.memoizedState, rt = rt !== null ? rt.dehydrated !== null : !0), rt)
        return tt;
      tt = tt.return;
    } while (tt !== null);
    return null;
  }
  function Qm(tt, rt, dt, mt, Zr) {
    return tt.mode & 1 ? (tt.flags |= 65536, tt.lanes = Zr, tt) : (tt === rt ? tt.flags |= 65536 : (tt.flags |= 128, dt.flags |= 131072, dt.flags &= -52805, dt.tag === 1 && (dt.alternate === null ? dt.tag = 17 : (rt = sc(-1, 1), rt.tag = 2, qc(dt, rt, 1))), dt.lanes |= 1), tt);
  }
  var w1 = Jr.ReactCurrentOwner, wa = !1;
  function Ia(tt, rt, dt, mt) {
    rt.child = tt === null ? iy(rt, null, dt, mt) : Lf(rt, tt.child, dt, mt);
  }
  function Jc(tt, rt, dt, mt, Zr) {
    dt = dt.render;
    var ti = rt.ref;
    return vs(rt, Zr), mt = Zc(tt, rt, dt, mt, ti, Zr), dt = Md(), tt !== null && !wa ? (rt.updateQueue = tt.updateQueue, rt.flags &= -2053, tt.lanes &= ~Zr, Wa(tt, rt, Zr)) : (Zo && dt && $p(rt), rt.flags |= 1, Ia(tt, rt, mt, Zr), rt.child);
  }
  function hg(tt, rt, dt, mt, Zr) {
    if (tt === null) {
      var ti = dt.type;
      return typeof ti == "function" && !v0(ti) && ti.defaultProps === void 0 && dt.compare === null && dt.defaultProps === void 0 ? (rt.tag = 15, rt.type = ti, Ml(tt, rt, ti, mt, Zr)) : (tt = wg(dt.type, null, mt, rt, rt.mode, Zr), tt.ref = rt.ref, tt.return = rt, rt.child = tt);
    }
    if (ti = tt.child, !(tt.lanes & Zr)) {
      var fi = ti.memoizedProps;
      if (dt = dt.compare, dt = dt !== null ? dt : Sh, dt(fi, mt) && tt.ref === rt.ref)
        return Wa(tt, rt, Zr);
    }
    return rt.flags |= 1, tt = id(ti, mt), tt.ref = rt.ref, tt.return = rt, rt.child = tt;
  }
  function Ml(tt, rt, dt, mt, Zr) {
    if (tt !== null) {
      var ti = tt.memoizedProps;
      if (Sh(ti, mt) && tt.ref === rt.ref)
        if (wa = !1, rt.pendingProps = mt = ti, (tt.lanes & Zr) !== 0)
          tt.flags & 131072 && (wa = !0);
        else
          return rt.lanes = tt.lanes, Wa(tt, rt, Zr);
    }
    return kf(tt, rt, dt, mt, Zr);
  }
  function $d(tt, rt, dt) {
    var mt = rt.pendingProps, Zr = mt.children, ti = tt !== null ? tt.memoizedState : null;
    if (mt.mode === "hidden")
      if (!(rt.mode & 1))
        rt.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Fo(Gf, Wl), Wl |= dt;
      else {
        if (!(dt & 1073741824))
          return tt = ti !== null ? ti.baseLanes | dt : dt, rt.lanes = rt.childLanes = 1073741824, rt.memoizedState = { baseLanes: tt, cachePool: null, transitions: null }, rt.updateQueue = null, Fo(Gf, Wl), Wl |= tt, null;
        rt.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, mt = ti !== null ? ti.baseLanes : dt, Fo(Gf, Wl), Wl |= mt;
      }
    else
      ti !== null ? (mt = ti.baseLanes | dt, rt.memoizedState = null) : mt = dt, Fo(Gf, Wl), Wl |= mt;
    return Ia(tt, rt, Zr, dt), rt.child;
  }
  function go(tt, rt) {
    var dt = rt.ref;
    (tt === null && dt !== null || tt !== null && tt.ref !== dt) && (rt.flags |= 512, rt.flags |= 2097152);
  }
  function kf(tt, rt, dt, mt, Zr) {
    var ti = na(dt) ? Rl : io.current;
    return ti = ru(rt, ti), vs(rt, Zr), dt = Zc(tt, rt, dt, mt, ti, Zr), mt = Md(), tt !== null && !wa ? (rt.updateQueue = tt.updateQueue, rt.flags &= -2053, tt.lanes &= ~Zr, Wa(tt, rt, Zr)) : (Zo && mt && $p(rt), rt.flags |= 1, Ia(tt, rt, dt, Zr), rt.child);
  }
  function Jm(tt, rt, dt, mt, Zr) {
    if (na(dt)) {
      var ti = !0;
      Fp(rt);
    } else
      ti = !1;
    if (vs(rt, Zr), rt.stateNode === null)
      nl(tt, rt), ey(rt, dt, mt), Wp(rt, dt, mt, Zr), mt = !0;
    else if (tt === null) {
      var fi = rt.stateNode, wi = rt.memoizedProps;
      fi.props = wi;
      var Pi = fi.context, Wi = dt.contextType;
      typeof Wi == "object" && Wi !== null ? Wi = ya(Wi) : (Wi = na(dt) ? Rl : io.current, Wi = ru(rt, Wi));
      var as = dt.getDerivedStateFromProps, cs = typeof as == "function" || typeof fi.getSnapshotBeforeUpdate == "function";
      cs || typeof fi.UNSAFE_componentWillReceiveProps != "function" && typeof fi.componentWillReceiveProps != "function" || (wi !== mt || Pi !== Wi) && ty(rt, fi, mt, Wi), Kc = !1;
      var os = rt.memoizedState;
      fi.state = os, Yc(rt, mt, fi, Zr), Pi = rt.memoizedState, wi !== mt || os !== Pi || pa.current || Kc ? (typeof as == "function" && (Wm(rt, dt, as, mt), Pi = rt.memoizedState), (wi = Kc || Jv(rt, dt, wi, mt, os, Pi, Wi)) ? (cs || typeof fi.UNSAFE_componentWillMount != "function" && typeof fi.componentWillMount != "function" || (typeof fi.componentWillMount == "function" && fi.componentWillMount(), typeof fi.UNSAFE_componentWillMount == "function" && fi.UNSAFE_componentWillMount()), typeof fi.componentDidMount == "function" && (rt.flags |= 4194308)) : (typeof fi.componentDidMount == "function" && (rt.flags |= 4194308), rt.memoizedProps = mt, rt.memoizedState = Pi), fi.props = mt, fi.state = Pi, fi.context = Wi, mt = wi) : (typeof fi.componentDidMount == "function" && (rt.flags |= 4194308), mt = !1);
    } else {
      fi = rt.stateNode, La(tt, rt), wi = rt.memoizedProps, Wi = rt.type === rt.elementType ? wi : Vl(rt.type, wi), fi.props = Wi, cs = rt.pendingProps, os = fi.context, Pi = dt.contextType, typeof Pi == "object" && Pi !== null ? Pi = ya(Pi) : (Pi = na(dt) ? Rl : io.current, Pi = ru(rt, Pi));
      var _s = dt.getDerivedStateFromProps;
      (as = typeof _s == "function" || typeof fi.getSnapshotBeforeUpdate == "function") || typeof fi.UNSAFE_componentWillReceiveProps != "function" && typeof fi.componentWillReceiveProps != "function" || (wi !== cs || os !== Pi) && ty(rt, fi, mt, Pi), Kc = !1, os = rt.memoizedState, fi.state = os, Yc(rt, mt, fi, Zr);
      var Ls = rt.memoizedState;
      wi !== cs || os !== Ls || pa.current || Kc ? (typeof _s == "function" && (Wm(rt, dt, _s, mt), Ls = rt.memoizedState), (Wi = Kc || Jv(rt, dt, Wi, mt, os, Ls, Pi) || !1) ? (as || typeof fi.UNSAFE_componentWillUpdate != "function" && typeof fi.componentWillUpdate != "function" || (typeof fi.componentWillUpdate == "function" && fi.componentWillUpdate(mt, Ls, Pi), typeof fi.UNSAFE_componentWillUpdate == "function" && fi.UNSAFE_componentWillUpdate(mt, Ls, Pi)), typeof fi.componentDidUpdate == "function" && (rt.flags |= 4), typeof fi.getSnapshotBeforeUpdate == "function" && (rt.flags |= 1024)) : (typeof fi.componentDidUpdate != "function" || wi === tt.memoizedProps && os === tt.memoizedState || (rt.flags |= 4), typeof fi.getSnapshotBeforeUpdate != "function" || wi === tt.memoizedProps && os === tt.memoizedState || (rt.flags |= 1024), rt.memoizedProps = mt, rt.memoizedState = Ls), fi.props = mt, fi.state = Ls, fi.context = Pi, mt = Wi) : (typeof fi.componentDidUpdate != "function" || wi === tt.memoizedProps && os === tt.memoizedState || (rt.flags |= 4), typeof fi.getSnapshotBeforeUpdate != "function" || wi === tt.memoizedProps && os === tt.memoizedState || (rt.flags |= 1024), mt = !1);
    }
    return ly(tt, rt, dt, mt, ti, Zr);
  }
  function ly(tt, rt, dt, mt, Zr, ti) {
    go(tt, rt);
    var fi = (rt.flags & 128) !== 0;
    if (!mt && !fi)
      return Zr && Kv(rt, dt, !1), Wa(tt, rt, ti);
    mt = rt.stateNode, w1.current = rt;
    var wi = fi && typeof dt.getDerivedStateFromError != "function" ? null : mt.render();
    return rt.flags |= 1, tt !== null && fi ? (rt.child = Lf(rt, tt.child, null, ti), rt.child = Lf(rt, null, wi, ti)) : Ia(tt, rt, wi, ti), rt.memoizedState = mt.state, Zr && Kv(rt, dt, !0), rt.child;
  }
  function uy(tt) {
    var rt = tt.stateNode;
    rt.pendingContext ? zc(tt, rt.pendingContext, rt.pendingContext !== rt.context) : rt.context && zc(tt, rt.context, !1), Km(tt, rt.containerInfo);
  }
  function pg(tt, rt, dt, mt, Zr) {
    return oa(), Um(Zr), rt.flags |= 256, Ia(tt, rt, dt, mt), rt.child;
  }
  var Bd = { dehydrated: null, treeContext: null, retryLane: 0 };
  function e0(tt) {
    return { baseLanes: tt, cachePool: null, transitions: null };
  }
  function t0(tt, rt, dt) {
    var mt = rt.pendingProps, Zr = Qs.current, ti = !1, fi = (rt.flags & 128) !== 0, wi;
    if ((wi = fi) || (wi = tt !== null && tt.memoizedState === null ? !1 : (Zr & 2) !== 0), wi ? (ti = !0, rt.flags &= -129) : (tt === null || tt.memoizedState !== null) && (Zr |= 1), Fo(Qs, Zr & 1), tt === null)
      return Up(rt), tt = rt.memoizedState, tt !== null && (tt = tt.dehydrated, tt !== null) ? (rt.mode & 1 ? tt.data === "$!" ? rt.lanes = 8 : rt.lanes = 1073741824 : rt.lanes = 1, null) : (fi = mt.children, tt = mt.fallback, ti ? (mt = rt.mode, ti = rt.child, fi = { mode: "hidden", children: fi }, !(mt & 1) && ti !== null ? (ti.childLanes = 0, ti.pendingProps = fi) : ti = Qh(fi, mt, 0, null), tt = Kd(tt, mt, dt, null), ti.return = rt, tt.return = rt, ti.sibling = tt, rt.child = ti, rt.child.memoizedState = e0(dt), rt.memoizedState = Bd, tt) : n0(rt, fi));
    if (Zr = tt.memoizedState, Zr !== null && (wi = Zr.dehydrated, wi !== null))
      return C1(tt, rt, fi, mt, wi, Zr, dt);
    if (ti) {
      ti = mt.fallback, fi = rt.mode, Zr = tt.child, wi = Zr.sibling;
      var Pi = { mode: "hidden", children: mt.children };
      return !(fi & 1) && rt.child !== Zr ? (mt = rt.child, mt.childLanes = 0, mt.pendingProps = Pi, rt.deletions = null) : (mt = id(Zr, Pi), mt.subtreeFlags = Zr.subtreeFlags & 14680064), wi !== null ? ti = id(wi, ti) : (ti = Kd(ti, fi, dt, null), ti.flags |= 2), ti.return = rt, mt.return = rt, mt.sibling = ti, rt.child = mt, mt = ti, ti = rt.child, fi = tt.child.memoizedState, fi = fi === null ? e0(dt) : { baseLanes: fi.baseLanes | dt, cachePool: null, transitions: fi.transitions }, ti.memoizedState = fi, ti.childLanes = tt.childLanes & ~dt, rt.memoizedState = Bd, mt;
    }
    return ti = tt.child, tt = ti.sibling, mt = id(ti, { mode: "visible", children: mt.children }), !(rt.mode & 1) && (mt.lanes = dt), mt.return = rt, mt.sibling = null, tt !== null && (dt = rt.deletions, dt === null ? (rt.deletions = [tt], rt.flags |= 16) : dt.push(tt)), rt.child = mt, rt.memoizedState = null, mt;
  }
  function n0(tt, rt) {
    return rt = Qh({ mode: "visible", children: rt }, tt.mode, 0, null), rt.return = tt, tt.child = rt;
  }
  function Nf(tt, rt, dt, mt) {
    return mt !== null && Um(mt), Lf(rt, tt.child, null, dt), tt = n0(rt, rt.pendingProps.children), tt.flags |= 2, rt.memoizedState = null, tt;
  }
  function C1(tt, rt, dt, mt, Zr, ti, fi) {
    if (dt)
      return rt.flags & 256 ? (rt.flags &= -257, mt = Gh(Error(ee(422))), Nf(tt, rt, fi, mt)) : rt.memoizedState !== null ? (rt.child = tt.child, rt.flags |= 128, null) : (ti = mt.fallback, Zr = rt.mode, mt = Qh({ mode: "visible", children: mt.children }, Zr, 0, null), ti = Kd(ti, Zr, fi, null), ti.flags |= 2, mt.return = rt, ti.return = rt, mt.sibling = ti, rt.child = mt, rt.mode & 1 && Lf(rt, tt.child, null, fi), rt.child.memoizedState = e0(fi), rt.memoizedState = Bd, ti);
    if (!(rt.mode & 1))
      return Nf(tt, rt, fi, null);
    if (Zr.data === "$!") {
      if (mt = Zr.nextSibling && Zr.nextSibling.dataset, mt)
        var wi = mt.dgst;
      return mt = wi, ti = Error(ee(419)), mt = Gh(ti, mt, void 0), Nf(tt, rt, fi, mt);
    }
    if (wi = (fi & tt.childLanes) !== 0, wa || wi) {
      if (mt = la, mt !== null) {
        switch (fi & -fi) {
          case 4:
            Zr = 2;
            break;
          case 16:
            Zr = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            Zr = 32;
            break;
          case 536870912:
            Zr = 268435456;
            break;
          default:
            Zr = 0;
        }
        Zr = Zr & (mt.suspendedLanes | fi) ? 0 : Zr, Zr !== 0 && Zr !== ti.retryLane && (ti.retryLane = Zr, ic(tt, Zr), ol(mt, tt, Zr, -1));
      }
      return p0(), mt = Gh(Error(ee(421))), Nf(tt, rt, fi, mt);
    }
    return Zr.data === "$?" ? (rt.flags |= 128, rt.child = tt.child, rt = D1.bind(null, tt), Zr._reactRetry = rt, null) : (tt = ti.treeContext, Pl = _u(Zr.nextSibling), zl = rt, Zo = !0, ou = null, tt !== null && (Il[tl++] = Va, Il[tl++] = rc, Il[tl++] = su, Va = tt.id, rc = tt.overflow, su = rt), rt = n0(rt, mt.children), rt.flags |= 4096, rt);
  }
  function r0(tt, rt, dt) {
    tt.lanes |= rt;
    var mt = tt.alternate;
    mt !== null && (mt.lanes |= rt), $a(tt.return, rt, dt);
  }
  function gg(tt, rt, dt, mt, Zr) {
    var ti = tt.memoizedState;
    ti === null ? tt.memoizedState = { isBackwards: rt, rendering: null, renderingStartTime: 0, last: mt, tail: dt, tailMode: Zr } : (ti.isBackwards = rt, ti.rendering = null, ti.renderingStartTime = 0, ti.last = mt, ti.tail = dt, ti.tailMode = Zr);
  }
  function i0(tt, rt, dt) {
    var mt = rt.pendingProps, Zr = mt.revealOrder, ti = mt.tail;
    if (Ia(tt, rt, mt.children, dt), mt = Qs.current, mt & 2)
      mt = mt & 1 | 2, rt.flags |= 128;
    else {
      if (tt !== null && tt.flags & 128)
        e:
          for (tt = rt.child; tt !== null; ) {
            if (tt.tag === 13)
              tt.memoizedState !== null && r0(tt, dt, rt);
            else if (tt.tag === 19)
              r0(tt, dt, rt);
            else if (tt.child !== null) {
              tt.child.return = tt, tt = tt.child;
              continue;
            }
            if (tt === rt)
              break e;
            for (; tt.sibling === null; ) {
              if (tt.return === null || tt.return === rt)
                break e;
              tt = tt.return;
            }
            tt.sibling.return = tt.return, tt = tt.sibling;
          }
      mt &= 1;
    }
    if (Fo(Qs, mt), !(rt.mode & 1))
      rt.memoizedState = null;
    else
      switch (Zr) {
        case "forwards":
          for (dt = rt.child, Zr = null; dt !== null; )
            tt = dt.alternate, tt !== null && aa(tt) === null && (Zr = dt), dt = dt.sibling;
          dt = Zr, dt === null ? (Zr = rt.child, rt.child = null) : (Zr = dt.sibling, dt.sibling = null), gg(rt, !1, Zr, dt, ti);
          break;
        case "backwards":
          for (dt = null, Zr = rt.child, rt.child = null; Zr !== null; ) {
            if (tt = Zr.alternate, tt !== null && aa(tt) === null) {
              rt.child = Zr;
              break;
            }
            tt = Zr.sibling, Zr.sibling = dt, dt = Zr, Zr = tt;
          }
          gg(rt, !0, dt, null, ti);
          break;
        case "together":
          gg(rt, !1, null, null, void 0);
          break;
        default:
          rt.memoizedState = null;
      }
    return rt.child;
  }
  function nl(tt, rt) {
    !(rt.mode & 1) && tt !== null && (tt.alternate = null, rt.alternate = null, rt.flags |= 2);
  }
  function Wa(tt, rt, dt) {
    if (tt !== null && (rt.dependencies = tt.dependencies), uc |= rt.lanes, !(dt & rt.childLanes))
      return null;
    if (tt !== null && rt.child !== tt.child)
      throw Error(ee(153));
    if (rt.child !== null) {
      for (tt = rt.child, dt = id(tt, tt.pendingProps), rt.child = dt, dt.return = rt; tt.sibling !== null; )
        tt = tt.sibling, dt = dt.sibling = id(tt, tt.pendingProps), dt.return = rt;
      dt.sibling = null;
    }
    return rt.child;
  }
  function ac(tt, rt, dt) {
    switch (rt.tag) {
      case 3:
        uy(rt), oa();
        break;
      case 5:
        Xs(rt);
        break;
      case 1:
        na(rt.type) && Fp(rt);
        break;
      case 4:
        Km(rt, rt.stateNode.containerInfo);
        break;
      case 10:
        var mt = rt.type._context, Zr = rt.memoizedProps.value;
        Fo(ku, mt._currentValue), mt._currentValue = Zr;
        break;
      case 13:
        if (mt = rt.memoizedState, mt !== null)
          return mt.dehydrated !== null ? (Fo(Qs, Qs.current & 1), rt.flags |= 128, null) : dt & rt.child.childLanes ? t0(tt, rt, dt) : (Fo(Qs, Qs.current & 1), tt = Wa(tt, rt, dt), tt !== null ? tt.sibling : null);
        Fo(Qs, Qs.current & 1);
        break;
      case 19:
        if (mt = (dt & rt.childLanes) !== 0, tt.flags & 128) {
          if (mt)
            return i0(tt, rt, dt);
          rt.flags |= 128;
        }
        if (Zr = rt.memoizedState, Zr !== null && (Zr.rendering = null, Zr.tail = null, Zr.lastEffect = null), Fo(Qs, Qs.current), mt)
          break;
        return null;
      case 22:
      case 23:
        return rt.lanes = 0, $d(tt, rt, dt);
    }
    return Wa(tt, rt, dt);
  }
  var zh, Ud, uu, Pa;
  zh = function(tt, rt) {
    for (var dt = rt.child; dt !== null; ) {
      if (dt.tag === 5 || dt.tag === 6)
        tt.appendChild(dt.stateNode);
      else if (dt.tag !== 4 && dt.child !== null) {
        dt.child.return = dt, dt = dt.child;
        continue;
      }
      if (dt === rt)
        break;
      for (; dt.sibling === null; ) {
        if (dt.return === null || dt.return === rt)
          return;
        dt = dt.return;
      }
      dt.sibling.return = dt.return, dt = dt.sibling;
    }
  }, Ud = function() {
  }, uu = function(tt, rt, dt, mt) {
    var Zr = tt.memoizedProps;
    if (Zr !== mt) {
      tt = rt.stateNode, Id(wu.current);
      var ti = null;
      switch (dt) {
        case "input":
          Zr = bi(tt, Zr), mt = bi(tt, mt), ti = [];
          break;
        case "select":
          Zr = hi({}, Zr, { value: void 0 }), mt = hi({}, mt, { value: void 0 }), ti = [];
          break;
        case "textarea":
          Zr = Ns(tt, Zr), mt = Ns(tt, mt), ti = [];
          break;
        default:
          typeof Zr.onClick != "function" && typeof mt.onClick == "function" && (tt.onclick = Np);
      }
      li(dt, mt);
      var fi;
      dt = null;
      for (Wi in Zr)
        if (!mt.hasOwnProperty(Wi) && Zr.hasOwnProperty(Wi) && Zr[Wi] != null)
          if (Wi === "style") {
            var wi = Zr[Wi];
            for (fi in wi)
              wi.hasOwnProperty(fi) && (dt || (dt = {}), dt[fi] = "");
          } else
            Wi !== "dangerouslySetInnerHTML" && Wi !== "children" && Wi !== "suppressContentEditableWarning" && Wi !== "suppressHydrationWarning" && Wi !== "autoFocus" && (ve.hasOwnProperty(Wi) ? ti || (ti = []) : (ti = ti || []).push(Wi, null));
      for (Wi in mt) {
        var Pi = mt[Wi];
        if (wi = Zr != null ? Zr[Wi] : void 0, mt.hasOwnProperty(Wi) && Pi !== wi && (Pi != null || wi != null))
          if (Wi === "style")
            if (wi) {
              for (fi in wi)
                !wi.hasOwnProperty(fi) || Pi && Pi.hasOwnProperty(fi) || (dt || (dt = {}), dt[fi] = "");
              for (fi in Pi)
                Pi.hasOwnProperty(fi) && wi[fi] !== Pi[fi] && (dt || (dt = {}), dt[fi] = Pi[fi]);
            } else
              dt || (ti || (ti = []), ti.push(
                Wi,
                dt
              )), dt = Pi;
          else
            Wi === "dangerouslySetInnerHTML" ? (Pi = Pi ? Pi.__html : void 0, wi = wi ? wi.__html : void 0, Pi != null && wi !== Pi && (ti = ti || []).push(Wi, Pi)) : Wi === "children" ? typeof Pi != "string" && typeof Pi != "number" || (ti = ti || []).push(Wi, "" + Pi) : Wi !== "suppressContentEditableWarning" && Wi !== "suppressHydrationWarning" && (ve.hasOwnProperty(Wi) ? (Pi != null && Wi === "onScroll" && Vo("scroll", tt), ti || wi === Pi || (ti = [])) : (ti = ti || []).push(Wi, Pi));
      }
      dt && (ti = ti || []).push("style", dt);
      var Wi = ti;
      (rt.updateQueue = Wi) && (rt.flags |= 4);
    }
  }, Pa = function(tt, rt, dt, mt) {
    dt !== mt && (rt.flags |= 4);
  };
  function Vh(tt, rt) {
    if (!Zo)
      switch (tt.tailMode) {
        case "hidden":
          rt = tt.tail;
          for (var dt = null; rt !== null; )
            rt.alternate !== null && (dt = rt), rt = rt.sibling;
          dt === null ? tt.tail = null : dt.sibling = null;
          break;
        case "collapsed":
          dt = tt.tail;
          for (var mt = null; dt !== null; )
            dt.alternate !== null && (mt = dt), dt = dt.sibling;
          mt === null ? rt || tt.tail === null ? tt.tail = null : tt.tail.sibling = null : mt.sibling = null;
      }
  }
  function rl(tt) {
    var rt = tt.alternate !== null && tt.alternate.child === tt.child, dt = 0, mt = 0;
    if (rt)
      for (var Zr = tt.child; Zr !== null; )
        dt |= Zr.lanes | Zr.childLanes, mt |= Zr.subtreeFlags & 14680064, mt |= Zr.flags & 14680064, Zr.return = tt, Zr = Zr.sibling;
    else
      for (Zr = tt.child; Zr !== null; )
        dt |= Zr.lanes | Zr.childLanes, mt |= Zr.subtreeFlags, mt |= Zr.flags, Zr.return = tt, Zr = Zr.sibling;
    return tt.subtreeFlags |= mt, tt.childLanes = dt, rt;
  }
  function R1(tt, rt, dt) {
    var mt = rt.pendingProps;
    switch ($m(rt), rt.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return rl(rt), null;
      case 1:
        return na(rt.type) && iu(), rl(rt), null;
      case 3:
        return mt = rt.stateNode, Xc(), ko(pa), ko(io), qp(), mt.pendingContext && (mt.context = mt.pendingContext, mt.pendingContext = null), (tt === null || tt.child === null) && (Gp(rt) ? rt.flags |= 4 : tt === null || tt.memoizedState.isDehydrated && !(rt.flags & 256) || (rt.flags |= 1024, ou !== null && (Zh(ou), ou = null))), Ud(tt, rt), rl(rt), null;
      case 5:
        Eo(rt);
        var Zr = Id(If.current);
        if (dt = rt.type, tt !== null && rt.stateNode != null)
          uu(tt, rt, dt, mt, Zr), tt.ref !== rt.ref && (rt.flags |= 512, rt.flags |= 2097152);
        else {
          if (!mt) {
            if (rt.stateNode === null)
              throw Error(ee(166));
            return rl(rt), null;
          }
          if (tt = Id(wu.current), Gp(rt)) {
            mt = rt.stateNode, dt = rt.type;
            var ti = rt.memoizedProps;
            switch (mt[Ou] = rt, mt[Rd] = ti, tt = (rt.mode & 1) !== 0, dt) {
              case "dialog":
                Vo("cancel", mt), Vo("close", mt);
                break;
              case "iframe":
              case "object":
              case "embed":
                Vo("load", mt);
                break;
              case "video":
              case "audio":
                for (Zr = 0; Zr < Rh.length; Zr++)
                  Vo(Rh[Zr], mt);
                break;
              case "source":
                Vo("error", mt);
                break;
              case "img":
              case "image":
              case "link":
                Vo(
                  "error",
                  mt
                ), Vo("load", mt);
                break;
              case "details":
                Vo("toggle", mt);
                break;
              case "input":
                Gi(mt, ti), Vo("invalid", mt);
                break;
              case "select":
                mt._wrapperState = { wasMultiple: !!ti.multiple }, Vo("invalid", mt);
                break;
              case "textarea":
                Ts(mt, ti), Vo("invalid", mt);
            }
            li(dt, ti), Zr = null;
            for (var fi in ti)
              if (ti.hasOwnProperty(fi)) {
                var wi = ti[fi];
                fi === "children" ? typeof wi == "string" ? mt.textContent !== wi && (ti.suppressHydrationWarning !== !0 && kp(mt.textContent, wi, tt), Zr = ["children", wi]) : typeof wi == "number" && mt.textContent !== "" + wi && (ti.suppressHydrationWarning !== !0 && kp(
                  mt.textContent,
                  wi,
                  tt
                ), Zr = ["children", "" + wi]) : ve.hasOwnProperty(fi) && wi != null && fi === "onScroll" && Vo("scroll", mt);
              }
            switch (dt) {
              case "input":
                Vs(mt), Bs(mt, ti, !0);
                break;
              case "textarea":
                Vs(mt), Fs(mt);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof ti.onClick == "function" && (mt.onclick = Np);
            }
            mt = Zr, rt.updateQueue = mt, mt !== null && (rt.flags |= 4);
          } else {
            fi = Zr.nodeType === 9 ? Zr : Zr.ownerDocument, tt === "http://www.w3.org/1999/xhtml" && (tt = xo(dt)), tt === "http://www.w3.org/1999/xhtml" ? dt === "script" ? (tt = fi.createElement("div"), tt.innerHTML = "<script><\/script>", tt = tt.removeChild(tt.firstChild)) : typeof mt.is == "string" ? tt = fi.createElement(dt, { is: mt.is }) : (tt = fi.createElement(dt), dt === "select" && (fi = tt, mt.multiple ? fi.multiple = !0 : mt.size && (fi.size = mt.size))) : tt = fi.createElementNS(tt, dt), tt[Ou] = rt, tt[Rd] = mt, zh(tt, rt, !1, !1), rt.stateNode = tt;
            e: {
              switch (fi = Ci(dt, mt), dt) {
                case "dialog":
                  Vo("cancel", tt), Vo("close", tt), Zr = mt;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Vo("load", tt), Zr = mt;
                  break;
                case "video":
                case "audio":
                  for (Zr = 0; Zr < Rh.length; Zr++)
                    Vo(Rh[Zr], tt);
                  Zr = mt;
                  break;
                case "source":
                  Vo("error", tt), Zr = mt;
                  break;
                case "img":
                case "image":
                case "link":
                  Vo(
                    "error",
                    tt
                  ), Vo("load", tt), Zr = mt;
                  break;
                case "details":
                  Vo("toggle", tt), Zr = mt;
                  break;
                case "input":
                  Gi(tt, mt), Zr = bi(tt, mt), Vo("invalid", tt);
                  break;
                case "option":
                  Zr = mt;
                  break;
                case "select":
                  tt._wrapperState = { wasMultiple: !!mt.multiple }, Zr = hi({}, mt, { value: void 0 }), Vo("invalid", tt);
                  break;
                case "textarea":
                  Ts(tt, mt), Zr = Ns(tt, mt), Vo("invalid", tt);
                  break;
                default:
                  Zr = mt;
              }
              li(dt, Zr), wi = Zr;
              for (ti in wi)
                if (wi.hasOwnProperty(ti)) {
                  var Pi = wi[ti];
                  ti === "style" ? Ao(tt, Pi) : ti === "dangerouslySetInnerHTML" ? (Pi = Pi ? Pi.__html : void 0, Pi != null && Ta(tt, Pi)) : ti === "children" ? typeof Pi == "string" ? (dt !== "textarea" || Pi !== "") && Aa(tt, Pi) : typeof Pi == "number" && Aa(tt, "" + Pi) : ti !== "suppressContentEditableWarning" && ti !== "suppressHydrationWarning" && ti !== "autoFocus" && (ve.hasOwnProperty(ti) ? Pi != null && ti === "onScroll" && Vo("scroll", tt) : Pi != null && Xr(tt, ti, Pi, fi));
                }
              switch (dt) {
                case "input":
                  Vs(tt), Bs(tt, mt, !1);
                  break;
                case "textarea":
                  Vs(tt), Fs(tt);
                  break;
                case "option":
                  mt.value != null && tt.setAttribute("value", "" + is(mt.value));
                  break;
                case "select":
                  tt.multiple = !!mt.multiple, ti = mt.value, ti != null ? Js(tt, !!mt.multiple, ti, !1) : mt.defaultValue != null && Js(
                    tt,
                    !!mt.multiple,
                    mt.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof Zr.onClick == "function" && (tt.onclick = Np);
              }
              switch (dt) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  mt = !!mt.autoFocus;
                  break e;
                case "img":
                  mt = !0;
                  break e;
                default:
                  mt = !1;
              }
            }
            mt && (rt.flags |= 4);
          }
          rt.ref !== null && (rt.flags |= 512, rt.flags |= 2097152);
        }
        return rl(rt), null;
      case 6:
        if (tt && rt.stateNode != null)
          Pa(tt, rt, tt.memoizedProps, mt);
        else {
          if (typeof mt != "string" && rt.stateNode === null)
            throw Error(ee(166));
          if (dt = Id(If.current), Id(wu.current), Gp(rt)) {
            if (mt = rt.stateNode, dt = rt.memoizedProps, mt[Ou] = rt, (ti = mt.nodeValue !== dt) && (tt = zl, tt !== null))
              switch (tt.tag) {
                case 3:
                  kp(mt.nodeValue, dt, (tt.mode & 1) !== 0);
                  break;
                case 5:
                  tt.memoizedProps.suppressHydrationWarning !== !0 && kp(mt.nodeValue, dt, (tt.mode & 1) !== 0);
              }
            ti && (rt.flags |= 4);
          } else
            mt = (dt.nodeType === 9 ? dt : dt.ownerDocument).createTextNode(mt), mt[Ou] = rt, rt.stateNode = mt;
        }
        return rl(rt), null;
      case 13:
        if (ko(Qs), mt = rt.memoizedState, tt === null || tt.memoizedState !== null && tt.memoizedState.dehydrated !== null) {
          if (Zo && Pl !== null && rt.mode & 1 && !(rt.flags & 128))
            Xv(), oa(), rt.flags |= 98560, ti = !1;
          else if (ti = Gp(rt), mt !== null && mt.dehydrated !== null) {
            if (tt === null) {
              if (!ti)
                throw Error(ee(318));
              if (ti = rt.memoizedState, ti = ti !== null ? ti.dehydrated : null, !ti)
                throw Error(ee(317));
              ti[Ou] = rt;
            } else
              oa(), !(rt.flags & 128) && (rt.memoizedState = null), rt.flags |= 4;
            rl(rt), ti = !1;
          } else
            ou !== null && (Zh(ou), ou = null), ti = !0;
          if (!ti)
            return rt.flags & 65536 ? rt : null;
        }
        return rt.flags & 128 ? (rt.lanes = dt, rt) : (mt = mt !== null, mt !== (tt !== null && tt.memoizedState !== null) && mt && (rt.child.flags |= 8192, rt.mode & 1 && (tt === null || Qs.current & 1 ? Oa === 0 && (Oa = 3) : p0())), rt.updateQueue !== null && (rt.flags |= 4), rl(rt), null);
      case 4:
        return Xc(), Ud(tt, rt), tt === null && wf(rt.stateNode.containerInfo), rl(rt), null;
      case 10:
        return Wc(rt.type._context), rl(rt), null;
      case 17:
        return na(rt.type) && iu(), rl(rt), null;
      case 19:
        if (ko(Qs), ti = rt.memoizedState, ti === null)
          return rl(rt), null;
        if (mt = (rt.flags & 128) !== 0, fi = ti.rendering, fi === null)
          if (mt)
            Vh(ti, !1);
          else {
            if (Oa !== 0 || tt !== null && tt.flags & 128)
              for (tt = rt.child; tt !== null; ) {
                if (fi = aa(tt), fi !== null) {
                  for (rt.flags |= 128, Vh(ti, !1), mt = fi.updateQueue, mt !== null && (rt.updateQueue = mt, rt.flags |= 4), rt.subtreeFlags = 0, mt = dt, dt = rt.child; dt !== null; )
                    ti = dt, tt = mt, ti.flags &= 14680066, fi = ti.alternate, fi === null ? (ti.childLanes = 0, ti.lanes = tt, ti.child = null, ti.subtreeFlags = 0, ti.memoizedProps = null, ti.memoizedState = null, ti.updateQueue = null, ti.dependencies = null, ti.stateNode = null) : (ti.childLanes = fi.childLanes, ti.lanes = fi.lanes, ti.child = fi.child, ti.subtreeFlags = 0, ti.deletions = null, ti.memoizedProps = fi.memoizedProps, ti.memoizedState = fi.memoizedState, ti.updateQueue = fi.updateQueue, ti.type = fi.type, tt = fi.dependencies, ti.dependencies = tt === null ? null : { lanes: tt.lanes, firstContext: tt.firstContext }), dt = dt.sibling;
                  return Fo(Qs, Qs.current & 1 | 2), rt.child;
                }
                tt = tt.sibling;
              }
            ti.tail !== null && ta() > zf && (rt.flags |= 128, mt = !0, Vh(ti, !1), rt.lanes = 4194304);
          }
        else {
          if (!mt)
            if (tt = aa(fi), tt !== null) {
              if (rt.flags |= 128, mt = !0, dt = tt.updateQueue, dt !== null && (rt.updateQueue = dt, rt.flags |= 4), Vh(ti, !0), ti.tail === null && ti.tailMode === "hidden" && !fi.alternate && !Zo)
                return rl(rt), null;
            } else
              2 * ta() - ti.renderingStartTime > zf && dt !== 1073741824 && (rt.flags |= 128, mt = !0, Vh(ti, !1), rt.lanes = 4194304);
          ti.isBackwards ? (fi.sibling = rt.child, rt.child = fi) : (dt = ti.last, dt !== null ? dt.sibling = fi : rt.child = fi, ti.last = fi);
        }
        return ti.tail !== null ? (rt = ti.tail, ti.rendering = rt, ti.tail = rt.sibling, ti.renderingStartTime = ta(), rt.sibling = null, dt = Qs.current, Fo(Qs, mt ? dt & 1 | 2 : dt & 1), rt) : (rl(rt), null);
      case 22:
      case 23:
        return h0(), mt = rt.memoizedState !== null, tt !== null && tt.memoizedState !== null !== mt && (rt.flags |= 8192), mt && rt.mode & 1 ? Wl & 1073741824 && (rl(rt), rt.subtreeFlags & 6 && (rt.flags |= 8192)) : rl(rt), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(ee(156, rt.tag));
  }
  function s0(tt, rt) {
    switch ($m(rt), rt.tag) {
      case 1:
        return na(rt.type) && iu(), tt = rt.flags, tt & 65536 ? (rt.flags = tt & -65537 | 128, rt) : null;
      case 3:
        return Xc(), ko(pa), ko(io), qp(), tt = rt.flags, tt & 65536 && !(tt & 128) ? (rt.flags = tt & -65537 | 128, rt) : null;
      case 5:
        return Eo(rt), null;
      case 13:
        if (ko(Qs), tt = rt.memoizedState, tt !== null && tt.dehydrated !== null) {
          if (rt.alternate === null)
            throw Error(ee(340));
          oa();
        }
        return tt = rt.flags, tt & 65536 ? (rt.flags = tt & -65537 | 128, rt) : null;
      case 19:
        return ko(Qs), null;
      case 4:
        return Xc(), null;
      case 10:
        return Wc(rt.type._context), null;
      case 22:
      case 23:
        return h0(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var jh = !1, Da = !1, cy = typeof WeakSet == "function" ? WeakSet : Set, As = null;
  function Ff(tt, rt) {
    var dt = tt.ref;
    if (dt !== null)
      if (typeof dt == "function")
        try {
          dt(null);
        } catch (mt) {
          ma(tt, rt, mt);
        }
      else
        dt.current = null;
  }
  function Wh(tt, rt, dt) {
    try {
      dt();
    } catch (mt) {
      ma(tt, rt, mt);
    }
  }
  var dy = !1;
  function fy(tt, rt) {
    if (Im = eu, tt = Ip(), Qu(tt)) {
      if ("selectionStart" in tt)
        var dt = { start: tt.selectionStart, end: tt.selectionEnd };
      else
        e: {
          dt = (dt = tt.ownerDocument) && dt.defaultView || window;
          var mt = dt.getSelection && dt.getSelection();
          if (mt && mt.rangeCount !== 0) {
            dt = mt.anchorNode;
            var Zr = mt.anchorOffset, ti = mt.focusNode;
            mt = mt.focusOffset;
            try {
              dt.nodeType, ti.nodeType;
            } catch {
              dt = null;
              break e;
            }
            var fi = 0, wi = -1, Pi = -1, Wi = 0, as = 0, cs = tt, os = null;
            t:
              for (; ; ) {
                for (var _s; cs !== dt || Zr !== 0 && cs.nodeType !== 3 || (wi = fi + Zr), cs !== ti || mt !== 0 && cs.nodeType !== 3 || (Pi = fi + mt), cs.nodeType === 3 && (fi += cs.nodeValue.length), (_s = cs.firstChild) !== null; )
                  os = cs, cs = _s;
                for (; ; ) {
                  if (cs === tt)
                    break t;
                  if (os === dt && ++Wi === Zr && (wi = fi), os === ti && ++as === mt && (Pi = fi), (_s = cs.nextSibling) !== null)
                    break;
                  cs = os, os = cs.parentNode;
                }
                cs = _s;
              }
            dt = wi === -1 || Pi === -1 ? null : { start: wi, end: Pi };
          } else
            dt = null;
        }
      dt = dt || { start: 0, end: 0 };
    } else
      dt = null;
    for (wd = { focusedElem: tt, selectionRange: dt }, eu = !1, As = rt; As !== null; )
      if (rt = As, tt = rt.child, (rt.subtreeFlags & 1028) !== 0 && tt !== null)
        tt.return = rt, As = tt;
      else
        for (; As !== null; ) {
          rt = As;
          try {
            var Ls = rt.alternate;
            if (rt.flags & 1024)
              switch (rt.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (Ls !== null) {
                    var Ds = Ls.memoizedProps, Ea = Ls.memoizedState, Fi = rt.stateNode, ki = Fi.getSnapshotBeforeUpdate(rt.elementType === rt.type ? Ds : Vl(rt.type, Ds), Ea);
                    Fi.__reactInternalSnapshotBeforeUpdate = ki;
                  }
                  break;
                case 3:
                  var Ui = rt.stateNode.containerInfo;
                  Ui.nodeType === 1 ? Ui.textContent = "" : Ui.nodeType === 9 && Ui.documentElement && Ui.removeChild(Ui.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(ee(163));
              }
          } catch (gs) {
            ma(rt, rt.return, gs);
          }
          if (tt = rt.sibling, tt !== null) {
            tt.return = rt.return, As = tt;
            break;
          }
          As = rt.return;
        }
    return Ls = dy, dy = !1, Ls;
  }
  function Kh(tt, rt, dt) {
    var mt = rt.updateQueue;
    if (mt = mt !== null ? mt.lastEffect : null, mt !== null) {
      var Zr = mt = mt.next;
      do {
        if ((Zr.tag & tt) === tt) {
          var ti = Zr.destroy;
          Zr.destroy = void 0, ti !== void 0 && Wh(rt, dt, ti);
        }
        Zr = Zr.next;
      } while (Zr !== mt);
    }
  }
  function qh(tt, rt) {
    if (rt = rt.updateQueue, rt = rt !== null ? rt.lastEffect : null, rt !== null) {
      var dt = rt = rt.next;
      do {
        if ((dt.tag & tt) === tt) {
          var mt = dt.create;
          dt.destroy = mt();
        }
        dt = dt.next;
      } while (dt !== rt);
    }
  }
  function o0(tt) {
    var rt = tt.ref;
    if (rt !== null) {
      var dt = tt.stateNode;
      switch (tt.tag) {
        case 5:
          tt = dt;
          break;
        default:
          tt = dt;
      }
      typeof rt == "function" ? rt(tt) : rt.current = tt;
    }
  }
  function a0(tt) {
    var rt = tt.alternate;
    rt !== null && (tt.alternate = null, a0(rt)), tt.child = null, tt.deletions = null, tt.sibling = null, tt.tag === 5 && (rt = tt.stateNode, rt !== null && (delete rt[Ou], delete rt[Rd], delete rt[Om], delete rt[x1], delete rt[Mm])), tt.stateNode = null, tt.return = null, tt.dependencies = null, tt.memoizedProps = null, tt.memoizedState = null, tt.pendingProps = null, tt.stateNode = null, tt.updateQueue = null;
  }
  function hy(tt) {
    return tt.tag === 5 || tt.tag === 3 || tt.tag === 4;
  }
  function mg(tt) {
    e:
      for (; ; ) {
        for (; tt.sibling === null; ) {
          if (tt.return === null || hy(tt.return))
            return null;
          tt = tt.return;
        }
        for (tt.sibling.return = tt.return, tt = tt.sibling; tt.tag !== 5 && tt.tag !== 6 && tt.tag !== 18; ) {
          if (tt.flags & 2 || tt.child === null || tt.tag === 4)
            continue e;
          tt.child.return = tt, tt = tt.child;
        }
        if (!(tt.flags & 2))
          return tt.stateNode;
      }
  }
  function $f(tt, rt, dt) {
    var mt = tt.tag;
    if (mt === 5 || mt === 6)
      tt = tt.stateNode, rt ? dt.nodeType === 8 ? dt.parentNode.insertBefore(tt, rt) : dt.insertBefore(tt, rt) : (dt.nodeType === 8 ? (rt = dt.parentNode, rt.insertBefore(tt, dt)) : (rt = dt, rt.appendChild(tt)), dt = dt._reactRootContainer, dt != null || rt.onclick !== null || (rt.onclick = Np));
    else if (mt !== 4 && (tt = tt.child, tt !== null))
      for ($f(tt, rt, dt), tt = tt.sibling; tt !== null; )
        $f(tt, rt, dt), tt = tt.sibling;
  }
  function Fu(tt, rt, dt) {
    var mt = tt.tag;
    if (mt === 5 || mt === 6)
      tt = tt.stateNode, rt ? dt.insertBefore(tt, rt) : dt.appendChild(tt);
    else if (mt !== 4 && (tt = tt.child, tt !== null))
      for (Fu(tt, rt, dt), tt = tt.sibling; tt !== null; )
        Fu(tt, rt, dt), tt = tt.sibling;
  }
  var ra = null, Ba = !1;
  function cu(tt, rt, dt) {
    for (dt = dt.child; dt !== null; )
      Bf(tt, rt, dt), dt = dt.sibling;
  }
  function Bf(tt, rt, dt) {
    if (Sl && typeof Sl.onCommitFiberUnmount == "function")
      try {
        Sl.onCommitFiberUnmount(Ac, dt);
      } catch {
      }
    switch (dt.tag) {
      case 5:
        Da || Ff(dt, rt);
      case 6:
        var mt = ra, Zr = Ba;
        ra = null, cu(tt, rt, dt), ra = mt, Ba = Zr, ra !== null && (Ba ? (tt = ra, dt = dt.stateNode, tt.nodeType === 8 ? tt.parentNode.removeChild(dt) : tt.removeChild(dt)) : ra.removeChild(dt.stateNode));
        break;
      case 18:
        ra !== null && (Ba ? (tt = ra, dt = dt.stateNode, tt.nodeType === 8 ? Uc(tt.parentNode, dt) : tt.nodeType === 1 && Uc(tt, dt), kc(tt)) : Uc(ra, dt.stateNode));
        break;
      case 4:
        mt = ra, Zr = Ba, ra = dt.stateNode.containerInfo, Ba = !0, cu(tt, rt, dt), ra = mt, Ba = Zr;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Da && (mt = dt.updateQueue, mt !== null && (mt = mt.lastEffect, mt !== null))) {
          Zr = mt = mt.next;
          do {
            var ti = Zr, fi = ti.destroy;
            ti = ti.tag, fi !== void 0 && (ti & 2 || ti & 4) && Wh(dt, rt, fi), Zr = Zr.next;
          } while (Zr !== mt);
        }
        cu(tt, rt, dt);
        break;
      case 1:
        if (!Da && (Ff(dt, rt), mt = dt.stateNode, typeof mt.componentWillUnmount == "function"))
          try {
            mt.props = dt.memoizedProps, mt.state = dt.memoizedState, mt.componentWillUnmount();
          } catch (wi) {
            ma(dt, rt, wi);
          }
        cu(tt, rt, dt);
        break;
      case 21:
        cu(tt, rt, dt);
        break;
      case 22:
        dt.mode & 1 ? (Da = (mt = Da) || dt.memoizedState !== null, cu(tt, rt, dt), Da = mt) : cu(tt, rt, dt);
        break;
      default:
        cu(tt, rt, dt);
    }
  }
  function lc(tt) {
    var rt = tt.updateQueue;
    if (rt !== null) {
      tt.updateQueue = null;
      var dt = tt.stateNode;
      dt === null && (dt = tt.stateNode = new cy()), rt.forEach(function(mt) {
        var Zr = O1.bind(null, tt, mt);
        dt.has(mt) || (dt.add(mt), mt.then(Zr, Zr));
      });
    }
  }
  function Cu(tt, rt) {
    var dt = rt.deletions;
    if (dt !== null)
      for (var mt = 0; mt < dt.length; mt++) {
        var Zr = dt[mt];
        try {
          var ti = tt, fi = rt, wi = fi;
          e:
            for (; wi !== null; ) {
              switch (wi.tag) {
                case 5:
                  ra = wi.stateNode, Ba = !1;
                  break e;
                case 3:
                  ra = wi.stateNode.containerInfo, Ba = !0;
                  break e;
                case 4:
                  ra = wi.stateNode.containerInfo, Ba = !0;
                  break e;
              }
              wi = wi.return;
            }
          if (ra === null)
            throw Error(ee(160));
          Bf(ti, fi, Zr), ra = null, Ba = !1;
          var Pi = Zr.alternate;
          Pi !== null && (Pi.return = null), Zr.return = null;
        } catch (Wi) {
          ma(Zr, rt, Wi);
        }
      }
    if (rt.subtreeFlags & 12854)
      for (rt = rt.child; rt !== null; )
        py(rt, tt), rt = rt.sibling;
  }
  function py(tt, rt) {
    var dt = tt.alternate, mt = tt.flags;
    switch (tt.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Cu(rt, tt), $u(tt), mt & 4) {
          try {
            Kh(3, tt, tt.return), qh(3, tt);
          } catch (Ds) {
            ma(tt, tt.return, Ds);
          }
          try {
            Kh(5, tt, tt.return);
          } catch (Ds) {
            ma(tt, tt.return, Ds);
          }
        }
        break;
      case 1:
        Cu(rt, tt), $u(tt), mt & 512 && dt !== null && Ff(dt, dt.return);
        break;
      case 5:
        if (Cu(rt, tt), $u(tt), mt & 512 && dt !== null && Ff(dt, dt.return), tt.flags & 32) {
          var Zr = tt.stateNode;
          try {
            Aa(Zr, "");
          } catch (Ds) {
            ma(tt, tt.return, Ds);
          }
        }
        if (mt & 4 && (Zr = tt.stateNode, Zr != null)) {
          var ti = tt.memoizedProps, fi = dt !== null ? dt.memoizedProps : ti, wi = tt.type, Pi = tt.updateQueue;
          if (tt.updateQueue = null, Pi !== null)
            try {
              wi === "input" && ti.type === "radio" && ti.name != null && Qi(Zr, ti), Ci(wi, fi);
              var Wi = Ci(wi, ti);
              for (fi = 0; fi < Pi.length; fi += 2) {
                var as = Pi[fi], cs = Pi[fi + 1];
                as === "style" ? Ao(Zr, cs) : as === "dangerouslySetInnerHTML" ? Ta(Zr, cs) : as === "children" ? Aa(Zr, cs) : Xr(Zr, as, cs, Wi);
              }
              switch (wi) {
                case "input":
                  ns(Zr, ti);
                  break;
                case "textarea":
                  lo(Zr, ti);
                  break;
                case "select":
                  var os = Zr._wrapperState.wasMultiple;
                  Zr._wrapperState.wasMultiple = !!ti.multiple;
                  var _s = ti.value;
                  _s != null ? Js(Zr, !!ti.multiple, _s, !1) : os !== !!ti.multiple && (ti.defaultValue != null ? Js(
                    Zr,
                    !!ti.multiple,
                    ti.defaultValue,
                    !0
                  ) : Js(Zr, !!ti.multiple, ti.multiple ? [] : "", !1));
              }
              Zr[Rd] = ti;
            } catch (Ds) {
              ma(tt, tt.return, Ds);
            }
        }
        break;
      case 6:
        if (Cu(rt, tt), $u(tt), mt & 4) {
          if (tt.stateNode === null)
            throw Error(ee(162));
          Zr = tt.stateNode, ti = tt.memoizedProps;
          try {
            Zr.nodeValue = ti;
          } catch (Ds) {
            ma(tt, tt.return, Ds);
          }
        }
        break;
      case 3:
        if (Cu(rt, tt), $u(tt), mt & 4 && dt !== null && dt.memoizedState.isDehydrated)
          try {
            kc(rt.containerInfo);
          } catch (Ds) {
            ma(tt, tt.return, Ds);
          }
        break;
      case 4:
        Cu(rt, tt), $u(tt);
        break;
      case 13:
        Cu(rt, tt), $u(tt), Zr = tt.child, Zr.flags & 8192 && (ti = Zr.memoizedState !== null, Zr.stateNode.isHidden = ti, !ti || Zr.alternate !== null && Zr.alternate.memoizedState !== null || (c0 = ta())), mt & 4 && lc(tt);
        break;
      case 22:
        if (as = dt !== null && dt.memoizedState !== null, tt.mode & 1 ? (Da = (Wi = Da) || as, Cu(rt, tt), Da = Wi) : Cu(rt, tt), $u(tt), mt & 8192) {
          if (Wi = tt.memoizedState !== null, (tt.stateNode.isHidden = Wi) && !as && tt.mode & 1)
            for (As = tt, as = tt.child; as !== null; ) {
              for (cs = As = as; As !== null; ) {
                switch (os = As, _s = os.child, os.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    Kh(4, os, os.return);
                    break;
                  case 1:
                    Ff(os, os.return);
                    var Ls = os.stateNode;
                    if (typeof Ls.componentWillUnmount == "function") {
                      mt = os, dt = os.return;
                      try {
                        rt = mt, Ls.props = rt.memoizedProps, Ls.state = rt.memoizedState, Ls.componentWillUnmount();
                      } catch (Ds) {
                        ma(mt, dt, Ds);
                      }
                    }
                    break;
                  case 5:
                    Ff(os, os.return);
                    break;
                  case 22:
                    if (os.memoizedState !== null) {
                      l0(cs);
                      continue;
                    }
                }
                _s !== null ? (_s.return = os, As = _s) : l0(cs);
              }
              as = as.sibling;
            }
          e:
            for (as = null, cs = tt; ; ) {
              if (cs.tag === 5) {
                if (as === null) {
                  as = cs;
                  try {
                    Zr = cs.stateNode, Wi ? (ti = Zr.style, typeof ti.setProperty == "function" ? ti.setProperty("display", "none", "important") : ti.display = "none") : (wi = cs.stateNode, Pi = cs.memoizedProps.style, fi = Pi != null && Pi.hasOwnProperty("display") ? Pi.display : null, wi.style.display = ho("display", fi));
                  } catch (Ds) {
                    ma(tt, tt.return, Ds);
                  }
                }
              } else if (cs.tag === 6) {
                if (as === null)
                  try {
                    cs.stateNode.nodeValue = Wi ? "" : cs.memoizedProps;
                  } catch (Ds) {
                    ma(tt, tt.return, Ds);
                  }
              } else if ((cs.tag !== 22 && cs.tag !== 23 || cs.memoizedState === null || cs === tt) && cs.child !== null) {
                cs.child.return = cs, cs = cs.child;
                continue;
              }
              if (cs === tt)
                break e;
              for (; cs.sibling === null; ) {
                if (cs.return === null || cs.return === tt)
                  break e;
                as === cs && (as = null), cs = cs.return;
              }
              as === cs && (as = null), cs.sibling.return = cs.return, cs = cs.sibling;
            }
        }
        break;
      case 19:
        Cu(rt, tt), $u(tt), mt & 4 && lc(tt);
        break;
      case 21:
        break;
      default:
        Cu(
          rt,
          tt
        ), $u(tt);
    }
  }
  function $u(tt) {
    var rt = tt.flags;
    if (rt & 2) {
      try {
        e: {
          for (var dt = tt.return; dt !== null; ) {
            if (hy(dt)) {
              var mt = dt;
              break e;
            }
            dt = dt.return;
          }
          throw Error(ee(160));
        }
        switch (mt.tag) {
          case 5:
            var Zr = mt.stateNode;
            mt.flags & 32 && (Aa(Zr, ""), mt.flags &= -33);
            var ti = mg(tt);
            Fu(tt, ti, Zr);
            break;
          case 3:
          case 4:
            var fi = mt.stateNode.containerInfo, wi = mg(tt);
            $f(tt, wi, fi);
            break;
          default:
            throw Error(ee(161));
        }
      } catch (Pi) {
        ma(tt, tt.return, Pi);
      }
      tt.flags &= -3;
    }
    rt & 4096 && (tt.flags &= -4097);
  }
  function gy(tt, rt, dt) {
    As = tt, Uf(tt);
  }
  function Uf(tt, rt, dt) {
    for (var mt = (tt.mode & 1) !== 0; As !== null; ) {
      var Zr = As, ti = Zr.child;
      if (Zr.tag === 22 && mt) {
        var fi = Zr.memoizedState !== null || jh;
        if (!fi) {
          var wi = Zr.alternate, Pi = wi !== null && wi.memoizedState !== null || Da;
          wi = jh;
          var Wi = Da;
          if (jh = fi, (Da = Pi) && !Wi)
            for (As = Zr; As !== null; )
              fi = As, Pi = fi.child, fi.tag === 22 && fi.memoizedState !== null ? yy(Zr) : Pi !== null ? (Pi.return = fi, As = Pi) : yy(Zr);
          for (; ti !== null; )
            As = ti, Uf(ti), ti = ti.sibling;
          As = Zr, jh = wi, Da = Wi;
        }
        vy(tt);
      } else
        Zr.subtreeFlags & 8772 && ti !== null ? (ti.return = Zr, As = ti) : vy(tt);
    }
  }
  function vy(tt) {
    for (; As !== null; ) {
      var rt = As;
      if (rt.flags & 8772) {
        var dt = rt.alternate;
        try {
          if (rt.flags & 8772)
            switch (rt.tag) {
              case 0:
              case 11:
              case 15:
                Da || qh(5, rt);
                break;
              case 1:
                var mt = rt.stateNode;
                if (rt.flags & 4 && !Da)
                  if (dt === null)
                    mt.componentDidMount();
                  else {
                    var Zr = rt.elementType === rt.type ? dt.memoizedProps : Vl(rt.type, dt.memoizedProps);
                    mt.componentDidUpdate(Zr, dt.memoizedState, mt.__reactInternalSnapshotBeforeUpdate);
                  }
                var ti = rt.updateQueue;
                ti !== null && Ld(rt, ti, mt);
                break;
              case 3:
                var fi = rt.updateQueue;
                if (fi !== null) {
                  if (dt = null, rt.child !== null)
                    switch (rt.child.tag) {
                      case 5:
                        dt = rt.child.stateNode;
                        break;
                      case 1:
                        dt = rt.child.stateNode;
                    }
                  Ld(rt, fi, dt);
                }
                break;
              case 5:
                var wi = rt.stateNode;
                if (dt === null && rt.flags & 4) {
                  dt = wi;
                  var Pi = rt.memoizedProps;
                  switch (rt.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      Pi.autoFocus && dt.focus();
                      break;
                    case "img":
                      Pi.src && (dt.src = Pi.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (rt.memoizedState === null) {
                  var Wi = rt.alternate;
                  if (Wi !== null) {
                    var as = Wi.memoizedState;
                    if (as !== null) {
                      var cs = as.dehydrated;
                      cs !== null && kc(cs);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(ee(163));
            }
          Da || rt.flags & 512 && o0(rt);
        } catch (os) {
          ma(rt, rt.return, os);
        }
      }
      if (rt === tt) {
        As = null;
        break;
      }
      if (dt = rt.sibling, dt !== null) {
        dt.return = rt.return, As = dt;
        break;
      }
      As = rt.return;
    }
  }
  function l0(tt) {
    for (; As !== null; ) {
      var rt = As;
      if (rt === tt) {
        As = null;
        break;
      }
      var dt = rt.sibling;
      if (dt !== null) {
        dt.return = rt.return, As = dt;
        break;
      }
      As = rt.return;
    }
  }
  function yy(tt) {
    for (; As !== null; ) {
      var rt = As;
      try {
        switch (rt.tag) {
          case 0:
          case 11:
          case 15:
            var dt = rt.return;
            try {
              qh(4, rt);
            } catch (Pi) {
              ma(rt, dt, Pi);
            }
            break;
          case 1:
            var mt = rt.stateNode;
            if (typeof mt.componentDidMount == "function") {
              var Zr = rt.return;
              try {
                mt.componentDidMount();
              } catch (Pi) {
                ma(rt, Zr, Pi);
              }
            }
            var ti = rt.return;
            try {
              o0(rt);
            } catch (Pi) {
              ma(rt, ti, Pi);
            }
            break;
          case 5:
            var fi = rt.return;
            try {
              o0(rt);
            } catch (Pi) {
              ma(rt, fi, Pi);
            }
        }
      } catch (Pi) {
        ma(rt, rt.return, Pi);
      }
      if (rt === tt) {
        As = null;
        break;
      }
      var wi = rt.sibling;
      if (wi !== null) {
        wi.return = rt.return, As = wi;
        break;
      }
      As = rt.return;
    }
  }
  var vg = Math.ceil, Yh = Jr.ReactCurrentDispatcher, u0 = Jr.ReactCurrentOwner, il = Jr.ReactCurrentBatchConfig, bo = 0, la = null, ga = null, Ua = 0, Wl = 0, Gf = po(0), Oa = 0, Xh = null, uc = 0, yg = 0, Hf = 0, Gd = null, hl = null, c0 = 0, zf = 1 / 0, cc = null, Eg = !1, Hd = null, Bu = null, ed = !1, nd = null, xg = 0, Vf = 0, Tg = null, zd = -1, Vd = 0;
  function sl() {
    return bo & 6 ? ta() : zd !== -1 ? zd : zd = ta();
  }
  function Ca(tt) {
    return tt.mode & 1 ? bo & 2 && Ua !== 0 ? Ua & -Ua : Hp.transition !== null ? (Vd === 0 && (Vd = df()), Vd) : (tt = Do, tt !== 0 || (tt = window.event, tt = tt === void 0 ? 16 : yh(tt.type)), tt) : 1;
  }
  function ol(tt, rt, dt, mt) {
    if (50 < Vf)
      throw Vf = 0, Tg = null, Error(ee(185));
    Ku(tt, dt, mt), (!(bo & 2) || tt !== la) && (tt === la && (!(bo & 2) && (yg |= dt), Oa === 4 && du(tt, Ua)), al(tt, mt), dt === 1 && bo === 0 && !(rt.mode & 1) && (zf = ta() + 500, Fa && Al()));
  }
  function al(tt, rt) {
    var dt = tt.callbackNode;
    Pc(tt, rt);
    var mt = cl(tt, tt === la ? Ua : 0);
    if (mt === 0)
      dt !== null && Tp(dt), tt.callbackNode = null, tt.callbackPriority = 0;
    else if (rt = mt & -mt, tt.callbackPriority !== rt) {
      if (dt != null && Tp(dt), rt === 1)
        tt.tag === 0 ? Nm(Ey.bind(null, tt)) : km(Ey.bind(null, tt)), Dm(function() {
          !(bo & 6) && Al();
        }), dt = null;
      else {
        switch (hf(mt)) {
          case 1:
            dt = yu;
            break;
          case 4:
            dt = vo;
            break;
          case 16:
            dt = Iu;
            break;
          case 536870912:
            dt = uf;
            break;
          default:
            dt = Iu;
        }
        dt = m0(dt, jf.bind(null, tt));
      }
      tt.callbackPriority = rt, tt.callbackNode = dt;
    }
  }
  function jf(tt, rt) {
    if (zd = -1, Vd = 0, bo & 6)
      throw Error(ee(327));
    var dt = tt.callbackNode;
    if (Kf() && tt.callbackNode !== dt)
      return null;
    var mt = cl(tt, tt === la ? Ua : 0);
    if (mt === 0)
      return null;
    if (mt & 30 || mt & tt.expiredLanes || rt)
      rt = Sg(tt, mt);
    else {
      rt = mt;
      var Zr = bo;
      bo |= 2;
      var ti = bg();
      (la !== tt || Ua !== rt) && (cc = null, zf = ta() + 500, jd(tt, rt));
      do
        try {
          L1();
          break;
        } catch (wi) {
          xy(tt, wi);
        }
      while (!0);
      Hm(), Yh.current = ti, bo = Zr, ga !== null ? rt = 0 : (la = null, Ua = 0, rt = Oa);
    }
    if (rt !== 0) {
      if (rt === 2 && (Zr = Dc(tt), Zr !== 0 && (mt = Zr, rt = d0(tt, Zr))), rt === 1)
        throw dt = Xh, jd(tt, 0), du(tt, mt), al(tt, ta()), dt;
      if (rt === 6)
        du(tt, mt);
      else {
        if (Zr = tt.current.alternate, !(mt & 30) && !f0(Zr) && (rt = Sg(tt, mt), rt === 2 && (ti = Dc(tt), ti !== 0 && (mt = ti, rt = d0(tt, ti))), rt === 1))
          throw dt = Xh, jd(tt, 0), du(tt, mt), al(tt, ta()), dt;
        switch (tt.finishedWork = Zr, tt.finishedLanes = mt, rt) {
          case 0:
          case 1:
            throw Error(ee(345));
          case 2:
            Wd(tt, hl, cc);
            break;
          case 3:
            if (du(tt, mt), (mt & 130023424) === mt && (rt = c0 + 500 - ta(), 10 < rt)) {
              if (cl(tt, 0) !== 0)
                break;
              if (Zr = tt.suspendedLanes, (Zr & mt) !== mt) {
                sl(), tt.pingedLanes |= tt.suspendedLanes & Zr;
                break;
              }
              tt.timeoutHandle = Cd(Wd.bind(null, tt, hl, cc), rt);
              break;
            }
            Wd(tt, hl, cc);
            break;
          case 4:
            if (du(tt, mt), (mt & 4194240) === mt)
              break;
            for (rt = tt.eventTimes, Zr = -1; 0 < mt; ) {
              var fi = 31 - ul(mt);
              ti = 1 << fi, fi = rt[fi], fi > Zr && (Zr = fi), mt &= ~ti;
            }
            if (mt = Zr, mt = ta() - mt, mt = (120 > mt ? 120 : 480 > mt ? 480 : 1080 > mt ? 1080 : 1920 > mt ? 1920 : 3e3 > mt ? 3e3 : 4320 > mt ? 4320 : 1960 * vg(mt / 1960)) - mt, 10 < mt) {
              tt.timeoutHandle = Cd(Wd.bind(null, tt, hl, cc), mt);
              break;
            }
            Wd(tt, hl, cc);
            break;
          case 5:
            Wd(tt, hl, cc);
            break;
          default:
            throw Error(ee(329));
        }
      }
    }
    return al(tt, ta()), tt.callbackNode === dt ? jf.bind(null, tt) : null;
  }
  function d0(tt, rt) {
    var dt = Gd;
    return tt.current.memoizedState.isDehydrated && (jd(tt, rt).flags |= 256), tt = Sg(tt, rt), tt !== 2 && (rt = hl, hl = dt, rt !== null && Zh(rt)), tt;
  }
  function Zh(tt) {
    hl === null ? hl = tt : hl.push.apply(hl, tt);
  }
  function f0(tt) {
    for (var rt = tt; ; ) {
      if (rt.flags & 16384) {
        var dt = rt.updateQueue;
        if (dt !== null && (dt = dt.stores, dt !== null))
          for (var mt = 0; mt < dt.length; mt++) {
            var Zr = dt[mt], ti = Zr.getSnapshot;
            Zr = Zr.value;
            try {
              if (!tu(ti(), Zr))
                return !1;
            } catch {
              return !1;
            }
          }
      }
      if (dt = rt.child, rt.subtreeFlags & 16384 && dt !== null)
        dt.return = rt, rt = dt;
      else {
        if (rt === tt)
          break;
        for (; rt.sibling === null; ) {
          if (rt.return === null || rt.return === tt)
            return !0;
          rt = rt.return;
        }
        rt.sibling.return = rt.return, rt = rt.sibling;
      }
    }
    return !0;
  }
  function du(tt, rt) {
    for (rt &= ~Hf, rt &= ~yg, tt.suspendedLanes |= rt, tt.pingedLanes &= ~rt, tt = tt.expirationTimes; 0 < rt; ) {
      var dt = 31 - ul(rt), mt = 1 << dt;
      tt[dt] = -1, rt &= ~mt;
    }
  }
  function Ey(tt) {
    if (bo & 6)
      throw Error(ee(327));
    Kf();
    var rt = cl(tt, 0);
    if (!(rt & 1))
      return al(tt, ta()), null;
    var dt = Sg(tt, rt);
    if (tt.tag !== 0 && dt === 2) {
      var mt = Dc(tt);
      mt !== 0 && (rt = mt, dt = d0(tt, mt));
    }
    if (dt === 1)
      throw dt = Xh, jd(tt, 0), du(tt, rt), al(tt, ta()), dt;
    if (dt === 6)
      throw Error(ee(345));
    return tt.finishedWork = tt.current.alternate, tt.finishedLanes = rt, Wd(tt, hl, cc), al(tt, ta()), null;
  }
  function Wf(tt, rt) {
    var dt = bo;
    bo |= 1;
    try {
      return tt(rt);
    } finally {
      bo = dt, bo === 0 && (zf = ta() + 500, Fa && Al());
    }
  }
  function rd(tt) {
    nd !== null && nd.tag === 0 && !(bo & 6) && Kf();
    var rt = bo;
    bo |= 1;
    var dt = il.transition, mt = Do;
    try {
      if (il.transition = null, Do = 1, tt)
        return tt();
    } finally {
      Do = mt, il.transition = dt, bo = rt, !(bo & 6) && Al();
    }
  }
  function h0() {
    Wl = Gf.current, ko(Gf);
  }
  function jd(tt, rt) {
    tt.finishedWork = null, tt.finishedLanes = 0;
    var dt = tt.timeoutHandle;
    if (dt !== -1 && (tt.timeoutHandle = -1, Wv(dt)), ga !== null)
      for (dt = ga.return; dt !== null; ) {
        var mt = dt;
        switch ($m(mt), mt.tag) {
          case 1:
            mt = mt.type.childContextTypes, mt != null && iu();
            break;
          case 3:
            Xc(), ko(pa), ko(io), qp();
            break;
          case 5:
            Eo(mt);
            break;
          case 4:
            Xc();
            break;
          case 13:
            ko(Qs);
            break;
          case 19:
            ko(Qs);
            break;
          case 10:
            Wc(mt.type._context);
            break;
          case 22:
          case 23:
            h0();
        }
        dt = dt.return;
      }
    if (la = tt, ga = tt = id(tt.current, null), Ua = Wl = rt, Oa = 0, Xh = null, Hf = yg = uc = 0, hl = Gd = null, ja !== null) {
      for (rt = 0; rt < ja.length; rt++)
        if (dt = ja[rt], mt = dt.interleaved, mt !== null) {
          dt.interleaved = null;
          var Zr = mt.next, ti = dt.pending;
          if (ti !== null) {
            var fi = ti.next;
            ti.next = Zr, mt.next = fi;
          }
          dt.pending = mt;
        }
      ja = null;
    }
    return tt;
  }
  function xy(tt, rt) {
    do {
      var dt = ga;
      try {
        if (Hm(), Yp.current = dg, to) {
          for (var mt = Qo.memoizedState; mt !== null; ) {
            var Zr = mt.queue;
            Zr !== null && (Zr.pending = null), mt = mt.next;
          }
          to = !1;
        }
        if (Pd = 0, wo = Ji = Qo = null, Nu = !1, jl = 0, u0.current = null, dt === null || dt.return === null) {
          Oa = 1, Xh = rt, ga = null;
          break;
        }
        e: {
          var ti = tt, fi = dt.return, wi = dt, Pi = rt;
          if (rt = Ua, wi.flags |= 32768, Pi !== null && typeof Pi == "object" && typeof Pi.then == "function") {
            var Wi = Pi, as = wi, cs = as.tag;
            if (!(as.mode & 1) && (cs === 0 || cs === 11 || cs === 15)) {
              var os = as.alternate;
              os ? (as.updateQueue = os.updateQueue, as.memoizedState = os.memoizedState, as.lanes = os.lanes) : (as.updateQueue = null, as.memoizedState = null);
            }
            var _s = Zm(fi);
            if (_s !== null) {
              _s.flags &= -257, Qm(_s, fi, wi, ti, rt), _s.mode & 1 && ay(ti, Wi, rt), rt = _s, Pi = Wi;
              var Ls = rt.updateQueue;
              if (Ls === null) {
                var Ds = /* @__PURE__ */ new Set();
                Ds.add(Pi), rt.updateQueue = Ds;
              } else
                Ls.add(Pi);
              break e;
            } else {
              if (!(rt & 1)) {
                ay(ti, Wi, rt), p0();
                break e;
              }
              Pi = Error(ee(426));
            }
          } else if (Zo && wi.mode & 1) {
            var Ea = Zm(fi);
            if (Ea !== null) {
              !(Ea.flags & 65536) && (Ea.flags |= 256), Qm(Ea, fi, wi, ti, rt), Um(Mf(Pi, wi));
              break e;
            }
          }
          ti = Pi = Mf(Pi, wi), Oa !== 4 && (Oa = 2), Gd === null ? Gd = [ti] : Gd.push(ti), ti = fi;
          do {
            switch (ti.tag) {
              case 3:
                ti.flags |= 65536, rt &= -rt, ti.lanes |= rt;
                var Fi = oy(ti, Pi, rt);
                jm(ti, Fi);
                break e;
              case 1:
                wi = Pi;
                var ki = ti.type, Ui = ti.stateNode;
                if (!(ti.flags & 128) && (typeof ki.getDerivedStateFromError == "function" || Ui !== null && typeof Ui.componentDidCatch == "function" && (Bu === null || !Bu.has(Ui)))) {
                  ti.flags |= 65536, rt &= -rt, ti.lanes |= rt;
                  var gs = Hh(ti, wi, rt);
                  jm(ti, gs);
                  break e;
                }
            }
            ti = ti.return;
          } while (ti !== null);
        }
        g0(dt);
      } catch (ks) {
        rt = ks, ga === dt && dt !== null && (ga = dt = dt.return);
        continue;
      }
      break;
    } while (!0);
  }
  function bg() {
    var tt = Yh.current;
    return Yh.current = dg, tt === null ? dg : tt;
  }
  function p0() {
    (Oa === 0 || Oa === 3 || Oa === 2) && (Oa = 4), la === null || !(uc & 268435455) && !(yg & 268435455) || du(la, Ua);
  }
  function Sg(tt, rt) {
    var dt = bo;
    bo |= 2;
    var mt = bg();
    (la !== tt || Ua !== rt) && (cc = null, jd(tt, rt));
    do
      try {
        A1();
        break;
      } catch (Zr) {
        xy(tt, Zr);
      }
    while (!0);
    if (Hm(), bo = dt, Yh.current = mt, ga !== null)
      throw Error(ee(261));
    return la = null, Ua = 0, Oa;
  }
  function A1() {
    for (; ga !== null; )
      Ty(ga);
  }
  function L1() {
    for (; ga !== null && !lm(); )
      Ty(ga);
  }
  function Ty(tt) {
    var rt = Sy(tt.alternate, tt, Wl);
    tt.memoizedProps = tt.pendingProps, rt === null ? g0(tt) : ga = rt, u0.current = null;
  }
  function g0(tt) {
    var rt = tt;
    do {
      var dt = rt.alternate;
      if (tt = rt.return, rt.flags & 32768) {
        if (dt = s0(dt, rt), dt !== null) {
          dt.flags &= 32767, ga = dt;
          return;
        }
        if (tt !== null)
          tt.flags |= 32768, tt.subtreeFlags = 0, tt.deletions = null;
        else {
          Oa = 6, ga = null;
          return;
        }
      } else if (dt = R1(dt, rt, Wl), dt !== null) {
        ga = dt;
        return;
      }
      if (rt = rt.sibling, rt !== null) {
        ga = rt;
        return;
      }
      ga = rt = tt;
    } while (rt !== null);
    Oa === 0 && (Oa = 5);
  }
  function Wd(tt, rt, dt) {
    var mt = Do, Zr = il.transition;
    try {
      il.transition = null, Do = 1, I1(tt, rt, dt, mt);
    } finally {
      il.transition = Zr, Do = mt;
    }
    return null;
  }
  function I1(tt, rt, dt, mt) {
    do
      Kf();
    while (nd !== null);
    if (bo & 6)
      throw Error(ee(327));
    dt = tt.finishedWork;
    var Zr = tt.finishedLanes;
    if (dt === null)
      return null;
    if (tt.finishedWork = null, tt.finishedLanes = 0, dt === tt.current)
      throw Error(ee(177));
    tt.callbackNode = null, tt.callbackPriority = 0;
    var ti = dt.lanes | dt.childLanes;
    if (dm(tt, ti), tt === la && (ga = la = null, Ua = 0), !(dt.subtreeFlags & 2064) && !(dt.flags & 2064) || ed || (ed = !0, m0(Iu, function() {
      return Kf(), null;
    })), ti = (dt.flags & 15990) !== 0, dt.subtreeFlags & 15990 || ti) {
      ti = il.transition, il.transition = null;
      var fi = Do;
      Do = 1;
      var wi = bo;
      bo |= 4, u0.current = null, fy(tt, dt), py(dt, tt), Pp(wd), eu = !!Im, wd = Im = null, tt.current = dt, gy(dt), um(), bo = wi, Do = fi, il.transition = ti;
    } else
      tt.current = dt;
    if (ed && (ed = !1, nd = tt, xg = Zr), ti = tt.pendingLanes, ti === 0 && (Bu = null), gh(dt.stateNode), al(tt, ta()), rt !== null)
      for (mt = tt.onRecoverableError, dt = 0; dt < rt.length; dt++)
        Zr = rt[dt], mt(Zr.value, { componentStack: Zr.stack, digest: Zr.digest });
    if (Eg)
      throw Eg = !1, tt = Hd, Hd = null, tt;
    return xg & 1 && tt.tag !== 0 && Kf(), ti = tt.pendingLanes, ti & 1 ? tt === Tg ? Vf++ : (Vf = 0, Tg = tt) : Vf = 0, Al(), null;
  }
  function Kf() {
    if (nd !== null) {
      var tt = hf(xg), rt = il.transition, dt = Do;
      try {
        if (il.transition = null, Do = 16 > tt ? 16 : tt, nd === null)
          var mt = !1;
        else {
          if (tt = nd, nd = null, xg = 0, bo & 6)
            throw Error(ee(331));
          var Zr = bo;
          for (bo |= 4, As = tt.current; As !== null; ) {
            var ti = As, fi = ti.child;
            if (As.flags & 16) {
              var wi = ti.deletions;
              if (wi !== null) {
                for (var Pi = 0; Pi < wi.length; Pi++) {
                  var Wi = wi[Pi];
                  for (As = Wi; As !== null; ) {
                    var as = As;
                    switch (as.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Kh(8, as, ti);
                    }
                    var cs = as.child;
                    if (cs !== null)
                      cs.return = as, As = cs;
                    else
                      for (; As !== null; ) {
                        as = As;
                        var os = as.sibling, _s = as.return;
                        if (a0(as), as === Wi) {
                          As = null;
                          break;
                        }
                        if (os !== null) {
                          os.return = _s, As = os;
                          break;
                        }
                        As = _s;
                      }
                  }
                }
                var Ls = ti.alternate;
                if (Ls !== null) {
                  var Ds = Ls.child;
                  if (Ds !== null) {
                    Ls.child = null;
                    do {
                      var Ea = Ds.sibling;
                      Ds.sibling = null, Ds = Ea;
                    } while (Ds !== null);
                  }
                }
                As = ti;
              }
            }
            if (ti.subtreeFlags & 2064 && fi !== null)
              fi.return = ti, As = fi;
            else
              e:
                for (; As !== null; ) {
                  if (ti = As, ti.flags & 2048)
                    switch (ti.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Kh(9, ti, ti.return);
                    }
                  var Fi = ti.sibling;
                  if (Fi !== null) {
                    Fi.return = ti.return, As = Fi;
                    break e;
                  }
                  As = ti.return;
                }
          }
          var ki = tt.current;
          for (As = ki; As !== null; ) {
            fi = As;
            var Ui = fi.child;
            if (fi.subtreeFlags & 2064 && Ui !== null)
              Ui.return = fi, As = Ui;
            else
              e:
                for (fi = ki; As !== null; ) {
                  if (wi = As, wi.flags & 2048)
                    try {
                      switch (wi.tag) {
                        case 0:
                        case 11:
                        case 15:
                          qh(9, wi);
                      }
                    } catch (ks) {
                      ma(wi, wi.return, ks);
                    }
                  if (wi === fi) {
                    As = null;
                    break e;
                  }
                  var gs = wi.sibling;
                  if (gs !== null) {
                    gs.return = wi.return, As = gs;
                    break e;
                  }
                  As = wi.return;
                }
          }
          if (bo = Zr, Al(), Sl && typeof Sl.onPostCommitFiberRoot == "function")
            try {
              Sl.onPostCommitFiberRoot(Ac, tt);
            } catch {
            }
          mt = !0;
        }
        return mt;
      } finally {
        Do = dt, il.transition = rt;
      }
    }
    return !1;
  }
  function by(tt, rt, dt) {
    rt = Mf(dt, rt), rt = oy(tt, rt, 1), tt = qc(tt, rt, 1), rt = sl(), tt !== null && (Ku(tt, 1, rt), al(tt, rt));
  }
  function ma(tt, rt, dt) {
    if (tt.tag === 3)
      by(tt, tt, dt);
    else
      for (; rt !== null; ) {
        if (rt.tag === 3) {
          by(rt, tt, dt);
          break;
        } else if (rt.tag === 1) {
          var mt = rt.stateNode;
          if (typeof rt.type.getDerivedStateFromError == "function" || typeof mt.componentDidCatch == "function" && (Bu === null || !Bu.has(mt))) {
            tt = Mf(dt, tt), tt = Hh(rt, tt, 1), rt = qc(rt, tt, 1), tt = sl(), rt !== null && (Ku(rt, 1, tt), al(rt, tt));
            break;
          }
        }
        rt = rt.return;
      }
  }
  function P1(tt, rt, dt) {
    var mt = tt.pingCache;
    mt !== null && mt.delete(rt), rt = sl(), tt.pingedLanes |= tt.suspendedLanes & dt, la === tt && (Ua & dt) === dt && (Oa === 4 || Oa === 3 && (Ua & 130023424) === Ua && 500 > ta() - c0 ? jd(tt, 0) : Hf |= dt), al(tt, rt);
  }
  function _g(tt, rt) {
    rt === 0 && (tt.mode & 1 ? (rt = Lc, Lc <<= 1, !(Lc & 130023424) && (Lc = 4194304)) : rt = 1);
    var dt = sl();
    tt = ic(tt, rt), tt !== null && (Ku(tt, rt, dt), al(tt, dt));
  }
  function D1(tt) {
    var rt = tt.memoizedState, dt = 0;
    rt !== null && (dt = rt.retryLane), _g(tt, dt);
  }
  function O1(tt, rt) {
    var dt = 0;
    switch (tt.tag) {
      case 13:
        var mt = tt.stateNode, Zr = tt.memoizedState;
        Zr !== null && (dt = Zr.retryLane);
        break;
      case 19:
        mt = tt.stateNode;
        break;
      default:
        throw Error(ee(314));
    }
    mt !== null && mt.delete(rt), _g(tt, dt);
  }
  var Sy;
  Sy = function(tt, rt, dt) {
    if (tt !== null)
      if (tt.memoizedProps !== rt.pendingProps || pa.current)
        wa = !0;
      else {
        if (!(tt.lanes & dt) && !(rt.flags & 128))
          return wa = !1, ac(tt, rt, dt);
        wa = !!(tt.flags & 131072);
      }
    else
      wa = !1, Zo && rt.flags & 1048576 && Fm(rt, Rf, rt.index);
    switch (rt.lanes = 0, rt.tag) {
      case 2:
        var mt = rt.type;
        nl(tt, rt), tt = rt.pendingProps;
        var Zr = ru(rt, io.current);
        vs(rt, dt), Zr = Zc(null, rt, mt, tt, Zr, dt);
        var ti = Md();
        return rt.flags |= 1, typeof Zr == "object" && Zr !== null && typeof Zr.render == "function" && Zr.$$typeof === void 0 ? (rt.tag = 1, rt.memoizedState = null, rt.updateQueue = null, na(mt) ? (ti = !0, Fp(rt)) : ti = !1, rt.memoizedState = Zr.state !== null && Zr.state !== void 0 ? Zr.state : null, Vm(rt), Zr.updater = jp, rt.stateNode = Zr, Zr._reactInternals = rt, Wp(rt, mt, tt, dt), rt = ly(null, rt, mt, !0, ti, dt)) : (rt.tag = 0, Zo && ti && $p(rt), Ia(null, rt, Zr, dt), rt = rt.child), rt;
      case 16:
        mt = rt.elementType;
        e: {
          switch (nl(tt, rt), tt = rt.pendingProps, Zr = mt._init, mt = Zr(mt._payload), rt.type = mt, Zr = rt.tag = k1(mt), tt = Vl(mt, tt), Zr) {
            case 0:
              rt = kf(null, rt, mt, tt, dt);
              break e;
            case 1:
              rt = Jm(null, rt, mt, tt, dt);
              break e;
            case 11:
              rt = Jc(null, rt, mt, tt, dt);
              break e;
            case 14:
              rt = hg(null, rt, mt, Vl(mt.type, tt), dt);
              break e;
          }
          throw Error(ee(
            306,
            mt,
            ""
          ));
        }
        return rt;
      case 0:
        return mt = rt.type, Zr = rt.pendingProps, Zr = rt.elementType === mt ? Zr : Vl(mt, Zr), kf(tt, rt, mt, Zr, dt);
      case 1:
        return mt = rt.type, Zr = rt.pendingProps, Zr = rt.elementType === mt ? Zr : Vl(mt, Zr), Jm(tt, rt, mt, Zr, dt);
      case 3:
        e: {
          if (uy(rt), tt === null)
            throw Error(ee(387));
          mt = rt.pendingProps, ti = rt.memoizedState, Zr = ti.element, La(tt, rt), Yc(rt, mt, null, dt);
          var fi = rt.memoizedState;
          if (mt = fi.element, ti.isDehydrated)
            if (ti = { element: mt, isDehydrated: !1, cache: fi.cache, pendingSuspenseBoundaries: fi.pendingSuspenseBoundaries, transitions: fi.transitions }, rt.updateQueue.baseState = ti, rt.memoizedState = ti, rt.flags & 256) {
              Zr = Mf(Error(ee(423)), rt), rt = pg(tt, rt, mt, dt, Zr);
              break e;
            } else if (mt !== Zr) {
              Zr = Mf(Error(ee(424)), rt), rt = pg(tt, rt, mt, dt, Zr);
              break e;
            } else
              for (Pl = _u(rt.stateNode.containerInfo.firstChild), zl = rt, Zo = !0, ou = null, dt = iy(rt, null, mt, dt), rt.child = dt; dt; )
                dt.flags = dt.flags & -3 | 4096, dt = dt.sibling;
          else {
            if (oa(), mt === Zr) {
              rt = Wa(tt, rt, dt);
              break e;
            }
            Ia(tt, rt, mt, dt);
          }
          rt = rt.child;
        }
        return rt;
      case 5:
        return Xs(rt), tt === null && Up(rt), mt = rt.type, Zr = rt.pendingProps, ti = tt !== null ? tt.memoizedProps : null, fi = Zr.children, Ih(mt, Zr) ? fi = null : ti !== null && Ih(mt, ti) && (rt.flags |= 32), go(tt, rt), Ia(tt, rt, fi, dt), rt.child;
      case 6:
        return tt === null && Up(rt), null;
      case 13:
        return t0(tt, rt, dt);
      case 4:
        return Km(rt, rt.stateNode.containerInfo), mt = rt.pendingProps, tt === null ? rt.child = Lf(rt, null, mt, dt) : Ia(tt, rt, mt, dt), rt.child;
      case 11:
        return mt = rt.type, Zr = rt.pendingProps, Zr = rt.elementType === mt ? Zr : Vl(mt, Zr), Jc(tt, rt, mt, Zr, dt);
      case 7:
        return Ia(tt, rt, rt.pendingProps, dt), rt.child;
      case 8:
        return Ia(tt, rt, rt.pendingProps.children, dt), rt.child;
      case 12:
        return Ia(tt, rt, rt.pendingProps.children, dt), rt.child;
      case 10:
        e: {
          if (mt = rt.type._context, Zr = rt.pendingProps, ti = rt.memoizedProps, fi = Zr.value, Fo(ku, mt._currentValue), mt._currentValue = fi, ti !== null)
            if (tu(ti.value, fi)) {
              if (ti.children === Zr.children && !pa.current) {
                rt = Wa(tt, rt, dt);
                break e;
              }
            } else
              for (ti = rt.child, ti !== null && (ti.return = rt); ti !== null; ) {
                var wi = ti.dependencies;
                if (wi !== null) {
                  fi = ti.child;
                  for (var Pi = wi.firstContext; Pi !== null; ) {
                    if (Pi.context === mt) {
                      if (ti.tag === 1) {
                        Pi = sc(-1, dt & -dt), Pi.tag = 2;
                        var Wi = ti.updateQueue;
                        if (Wi !== null) {
                          Wi = Wi.shared;
                          var as = Wi.pending;
                          as === null ? Pi.next = Pi : (Pi.next = as.next, as.next = Pi), Wi.pending = Pi;
                        }
                      }
                      ti.lanes |= dt, Pi = ti.alternate, Pi !== null && (Pi.lanes |= dt), $a(
                        ti.return,
                        dt,
                        rt
                      ), wi.lanes |= dt;
                      break;
                    }
                    Pi = Pi.next;
                  }
                } else if (ti.tag === 10)
                  fi = ti.type === rt.type ? null : ti.child;
                else if (ti.tag === 18) {
                  if (fi = ti.return, fi === null)
                    throw Error(ee(341));
                  fi.lanes |= dt, wi = fi.alternate, wi !== null && (wi.lanes |= dt), $a(fi, dt, rt), fi = ti.sibling;
                } else
                  fi = ti.child;
                if (fi !== null)
                  fi.return = ti;
                else
                  for (fi = ti; fi !== null; ) {
                    if (fi === rt) {
                      fi = null;
                      break;
                    }
                    if (ti = fi.sibling, ti !== null) {
                      ti.return = fi.return, fi = ti;
                      break;
                    }
                    fi = fi.return;
                  }
                ti = fi;
              }
          Ia(tt, rt, Zr.children, dt), rt = rt.child;
        }
        return rt;
      case 9:
        return Zr = rt.type, mt = rt.pendingProps.children, vs(rt, dt), Zr = ya(Zr), mt = mt(Zr), rt.flags |= 1, Ia(tt, rt, mt, dt), rt.child;
      case 14:
        return mt = rt.type, Zr = Vl(mt, rt.pendingProps), Zr = Vl(mt.type, Zr), hg(tt, rt, mt, Zr, dt);
      case 15:
        return Ml(tt, rt, rt.type, rt.pendingProps, dt);
      case 17:
        return mt = rt.type, Zr = rt.pendingProps, Zr = rt.elementType === mt ? Zr : Vl(mt, Zr), nl(tt, rt), rt.tag = 1, na(mt) ? (tt = !0, Fp(rt)) : tt = !1, vs(rt, dt), ey(rt, mt, Zr), Wp(rt, mt, Zr, dt), ly(null, rt, mt, !0, tt, dt);
      case 19:
        return i0(tt, rt, dt);
      case 22:
        return $d(tt, rt, dt);
    }
    throw Error(ee(156, rt.tag));
  };
  function m0(tt, rt) {
    return ph(tt, rt);
  }
  function M1(tt, rt, dt, mt) {
    this.tag = tt, this.key = dt, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = rt, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = mt, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function fu(tt, rt, dt, mt) {
    return new M1(tt, rt, dt, mt);
  }
  function v0(tt) {
    return tt = tt.prototype, !(!tt || !tt.isReactComponent);
  }
  function k1(tt) {
    if (typeof tt == "function")
      return v0(tt) ? 1 : 0;
    if (tt != null) {
      if (tt = tt.$$typeof, tt === xi)
        return 11;
      if (tt === mi)
        return 14;
    }
    return 2;
  }
  function id(tt, rt) {
    var dt = tt.alternate;
    return dt === null ? (dt = fu(tt.tag, rt, tt.key, tt.mode), dt.elementType = tt.elementType, dt.type = tt.type, dt.stateNode = tt.stateNode, dt.alternate = tt, tt.alternate = dt) : (dt.pendingProps = rt, dt.type = tt.type, dt.flags = 0, dt.subtreeFlags = 0, dt.deletions = null), dt.flags = tt.flags & 14680064, dt.childLanes = tt.childLanes, dt.lanes = tt.lanes, dt.child = tt.child, dt.memoizedProps = tt.memoizedProps, dt.memoizedState = tt.memoizedState, dt.updateQueue = tt.updateQueue, rt = tt.dependencies, dt.dependencies = rt === null ? null : { lanes: rt.lanes, firstContext: rt.firstContext }, dt.sibling = tt.sibling, dt.index = tt.index, dt.ref = tt.ref, dt;
  }
  function wg(tt, rt, dt, mt, Zr, ti) {
    var fi = 2;
    if (mt = tt, typeof tt == "function")
      v0(tt) && (fi = 1);
    else if (typeof tt == "string")
      fi = 5;
    else
      e:
        switch (tt) {
          case ri:
            return Kd(dt.children, Zr, ti, rt);
          case ai:
            fi = 8, Zr |= 8;
            break;
          case yi:
            return tt = fu(12, dt, rt, Zr | 2), tt.elementType = yi, tt.lanes = ti, tt;
          case Ti:
            return tt = fu(13, dt, rt, Zr), tt.elementType = Ti, tt.lanes = ti, tt;
          case Ai:
            return tt = fu(19, dt, rt, Zr), tt.elementType = Ai, tt.lanes = ti, tt;
          case gi:
            return Qh(dt, Zr, ti, rt);
          default:
            if (typeof tt == "object" && tt !== null)
              switch (tt.$$typeof) {
                case pi:
                  fi = 10;
                  break e;
                case di:
                  fi = 9;
                  break e;
                case xi:
                  fi = 11;
                  break e;
                case mi:
                  fi = 14;
                  break e;
                case Si:
                  fi = 16, mt = null;
                  break e;
              }
            throw Error(ee(130, tt == null ? tt : typeof tt, ""));
        }
    return rt = fu(fi, dt, rt, Zr), rt.elementType = tt, rt.type = mt, rt.lanes = ti, rt;
  }
  function Kd(tt, rt, dt, mt) {
    return tt = fu(7, tt, mt, rt), tt.lanes = dt, tt;
  }
  function Qh(tt, rt, dt, mt) {
    return tt = fu(22, tt, mt, rt), tt.elementType = gi, tt.lanes = dt, tt.stateNode = { isHidden: !1 }, tt;
  }
  function Jh(tt, rt, dt) {
    return tt = fu(6, tt, null, rt), tt.lanes = dt, tt;
  }
  function qd(tt, rt, dt) {
    return rt = fu(4, tt.children !== null ? tt.children : [], tt.key, rt), rt.lanes = dt, rt.stateNode = { containerInfo: tt.containerInfo, pendingChildren: null, implementation: tt.implementation }, rt;
  }
  function N1(tt, rt, dt, mt, Zr) {
    this.tag = rt, this.containerInfo = tt, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = ff(0), this.expirationTimes = ff(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ff(0), this.identifierPrefix = mt, this.onRecoverableError = Zr, this.mutableSourceEagerHydrationData = null;
  }
  function Cg(tt, rt, dt, mt, Zr, ti, fi, wi, Pi) {
    return tt = new N1(tt, rt, dt, wi, Pi), rt === 1 ? (rt = 1, ti === !0 && (rt |= 8)) : rt = 0, ti = fu(3, null, null, rt), tt.current = ti, ti.stateNode = tt, ti.memoizedState = { element: mt, isDehydrated: dt, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Vm(ti), tt;
  }
  function _y(tt, rt, dt) {
    var mt = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: si, key: mt == null ? null : "" + mt, children: tt, containerInfo: rt, implementation: dt };
  }
  function y0(tt) {
    if (!tt)
      return Mu;
    tt = tt._reactInternals;
    e: {
      if (Ql(tt) !== tt || tt.tag !== 1)
        throw Error(ee(170));
      var rt = tt;
      do {
        switch (rt.tag) {
          case 3:
            rt = rt.stateNode.context;
            break e;
          case 1:
            if (na(rt.type)) {
              rt = rt.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        rt = rt.return;
      } while (rt !== null);
      throw Error(ee(171));
    }
    if (tt.tag === 1) {
      var dt = tt.type;
      if (na(dt))
        return Oh(tt, dt, rt);
    }
    return rt;
  }
  function wy(tt, rt, dt, mt, Zr, ti, fi, wi, Pi) {
    return tt = Cg(dt, mt, !0, tt, Zr, ti, fi, wi, Pi), tt.context = y0(null), dt = tt.current, mt = sl(), Zr = Ca(dt), ti = sc(mt, Zr), ti.callback = rt ?? null, qc(dt, ti, Zr), tt.current.lanes = Zr, Ku(tt, Zr, mt), al(tt, mt), tt;
  }
  function ep(tt, rt, dt, mt) {
    var Zr = rt.current, ti = sl(), fi = Ca(Zr);
    return dt = y0(dt), rt.context === null ? rt.context = dt : rt.pendingContext = dt, rt = sc(ti, fi), rt.payload = { element: tt }, mt = mt === void 0 ? null : mt, mt !== null && (rt.callback = mt), tt = qc(Zr, rt, fi), tt !== null && (ol(tt, Zr, fi, ti), Vp(tt, Zr, fi)), fi;
  }
  function Rg(tt) {
    if (tt = tt.current, !tt.child)
      return null;
    switch (tt.child.tag) {
      case 5:
        return tt.child.stateNode;
      default:
        return tt.child.stateNode;
    }
  }
  function Cy(tt, rt) {
    if (tt = tt.memoizedState, tt !== null && tt.dehydrated !== null) {
      var dt = tt.retryLane;
      tt.retryLane = dt !== 0 && dt < rt ? dt : rt;
    }
  }
  function E0(tt, rt) {
    Cy(tt, rt), (tt = tt.alternate) && Cy(tt, rt);
  }
  function Ry() {
    return null;
  }
  var x0 = typeof reportError == "function" ? reportError : function(tt) {
    console.error(tt);
  };
  function Ag(tt) {
    this._internalRoot = tt;
  }
  dc.prototype.render = Ag.prototype.render = function(tt) {
    var rt = this._internalRoot;
    if (rt === null)
      throw Error(ee(409));
    ep(tt, rt, null, null);
  }, dc.prototype.unmount = Ag.prototype.unmount = function() {
    var tt = this._internalRoot;
    if (tt !== null) {
      this._internalRoot = null;
      var rt = tt.containerInfo;
      rd(function() {
        ep(null, tt, null, null);
      }), rt[nc] = null;
    }
  };
  function dc(tt) {
    this._internalRoot = tt;
  }
  dc.prototype.unstable_scheduleHydration = function(tt) {
    if (tt) {
      var rt = gf();
      tt = { blockedOn: null, target: tt, priority: rt };
      for (var dt = 0; dt < No.length && rt !== 0 && rt < No[dt].priority; dt++)
        ;
      No.splice(dt, 0, tt), dt === 0 && _p(tt);
    }
  };
  function T0(tt) {
    return !(!tt || tt.nodeType !== 1 && tt.nodeType !== 9 && tt.nodeType !== 11);
  }
  function Lg(tt) {
    return !(!tt || tt.nodeType !== 1 && tt.nodeType !== 9 && tt.nodeType !== 11 && (tt.nodeType !== 8 || tt.nodeValue !== " react-mount-point-unstable "));
  }
  function Ay() {
  }
  function F1(tt, rt, dt, mt, Zr) {
    if (Zr) {
      if (typeof mt == "function") {
        var ti = mt;
        mt = function() {
          var Wi = Rg(fi);
          ti.call(Wi);
        };
      }
      var fi = wy(rt, mt, tt, 0, null, !1, !1, "", Ay);
      return tt._reactRootContainer = fi, tt[nc] = fi.current, wf(tt.nodeType === 8 ? tt.parentNode : tt), rd(), fi;
    }
    for (; Zr = tt.lastChild; )
      tt.removeChild(Zr);
    if (typeof mt == "function") {
      var wi = mt;
      mt = function() {
        var Wi = Rg(Pi);
        wi.call(Wi);
      };
    }
    var Pi = Cg(tt, 0, !1, null, null, !1, !1, "", Ay);
    return tt._reactRootContainer = Pi, tt[nc] = Pi.current, wf(tt.nodeType === 8 ? tt.parentNode : tt), rd(function() {
      ep(rt, Pi, dt, mt);
    }), Pi;
  }
  function Ig(tt, rt, dt, mt, Zr) {
    var ti = dt._reactRootContainer;
    if (ti) {
      var fi = ti;
      if (typeof Zr == "function") {
        var wi = Zr;
        Zr = function() {
          var Pi = Rg(fi);
          wi.call(Pi);
        };
      }
      ep(rt, fi, tt, Zr);
    } else
      fi = F1(dt, rt, tt, Zr, mt);
    return Rg(fi);
  }
  yd = function(tt) {
    switch (tt.tag) {
      case 3:
        var rt = tt.stateNode;
        if (rt.current.memoizedState.isDehydrated) {
          var dt = Eu(rt.pendingLanes);
          dt !== 0 && (Pu(rt, dt | 1), al(rt, ta()), !(bo & 6) && (zf = ta() + 500, Al()));
        }
        break;
      case 13:
        rd(function() {
          var mt = ic(tt, 1);
          if (mt !== null) {
            var Zr = sl();
            ol(mt, tt, 1, Zr);
          }
        }), E0(tt, 1);
    }
  }, pf = function(tt) {
    if (tt.tag === 13) {
      var rt = ic(tt, 134217728);
      if (rt !== null) {
        var dt = sl();
        ol(rt, tt, 134217728, dt);
      }
      E0(tt, 134217728);
    }
  }, Lo = function(tt) {
    if (tt.tag === 13) {
      var rt = Ca(tt), dt = ic(tt, rt);
      if (dt !== null) {
        var mt = sl();
        ol(dt, tt, rt, mt);
      }
      E0(tt, rt);
    }
  }, gf = function() {
    return Do;
  }, mf = function(tt, rt) {
    var dt = Do;
    try {
      return Do = tt, rt();
    } finally {
      Do = dt;
    }
  }, Es = function(tt, rt, dt) {
    switch (rt) {
      case "input":
        if (ns(tt, dt), rt = dt.name, dt.type === "radio" && rt != null) {
          for (dt = tt; dt.parentNode; )
            dt = dt.parentNode;
          for (dt = dt.querySelectorAll("input[name=" + JSON.stringify("" + rt) + '][type="radio"]'), rt = 0; rt < dt.length; rt++) {
            var mt = dt[rt];
            if (mt !== tt && mt.form === tt.form) {
              var Zr = js(mt);
              if (!Zr)
                throw Error(ee(90));
              Ws(mt), ns(mt, Zr);
            }
          }
        }
        break;
      case "textarea":
        lo(tt, dt);
        break;
      case "select":
        rt = dt.value, rt != null && Js(tt, !!dt.multiple, rt, !1);
    }
  }, To = Wf, Ms = rd;
  var $1 = { usingClientEntryPoint: !1, Events: [Dh, Cf, js, eo, Us, Wf] }, qf = { findFiberByHostInstance: nu, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, B1 = { bundleType: qf.bundleType, version: qf.version, rendererPackageName: qf.rendererPackageName, rendererConfig: qf.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Jr.ReactCurrentDispatcher, findHostInstanceByFiber: function(tt) {
    return tt = Ep(tt), tt === null ? null : tt.stateNode;
  }, findFiberByHostInstance: qf.findFiberByHostInstance || Ry, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Pg = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Pg.isDisabled && Pg.supportsFiber)
      try {
        Ac = Pg.inject(B1), Sl = Pg;
      } catch {
      }
  }
  return reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $1, reactDom_production_min.createPortal = function(tt, rt) {
    var dt = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!T0(rt))
      throw Error(ee(200));
    return _y(tt, rt, null, dt);
  }, reactDom_production_min.createRoot = function(tt, rt) {
    if (!T0(tt))
      throw Error(ee(299));
    var dt = !1, mt = "", Zr = x0;
    return rt != null && (rt.unstable_strictMode === !0 && (dt = !0), rt.identifierPrefix !== void 0 && (mt = rt.identifierPrefix), rt.onRecoverableError !== void 0 && (Zr = rt.onRecoverableError)), rt = Cg(tt, 1, !1, null, null, dt, !1, mt, Zr), tt[nc] = rt.current, wf(tt.nodeType === 8 ? tt.parentNode : tt), new Ag(rt);
  }, reactDom_production_min.findDOMNode = function(tt) {
    if (tt == null)
      return null;
    if (tt.nodeType === 1)
      return tt;
    var rt = tt._reactInternals;
    if (rt === void 0)
      throw typeof tt.render == "function" ? Error(ee(188)) : (tt = Object.keys(tt).join(","), Error(ee(268, tt)));
    return tt = Ep(rt), tt = tt === null ? null : tt.stateNode, tt;
  }, reactDom_production_min.flushSync = function(tt) {
    return rd(tt);
  }, reactDom_production_min.hydrate = function(tt, rt, dt) {
    if (!Lg(rt))
      throw Error(ee(200));
    return Ig(null, tt, rt, !0, dt);
  }, reactDom_production_min.hydrateRoot = function(tt, rt, dt) {
    if (!T0(tt))
      throw Error(ee(405));
    var mt = dt != null && dt.hydratedSources || null, Zr = !1, ti = "", fi = x0;
    if (dt != null && (dt.unstable_strictMode === !0 && (Zr = !0), dt.identifierPrefix !== void 0 && (ti = dt.identifierPrefix), dt.onRecoverableError !== void 0 && (fi = dt.onRecoverableError)), rt = wy(rt, null, tt, 1, dt ?? null, Zr, !1, ti, fi), tt[nc] = rt.current, wf(tt), mt)
      for (tt = 0; tt < mt.length; tt++)
        dt = mt[tt], Zr = dt._getVersion, Zr = Zr(dt._source), rt.mutableSourceEagerHydrationData == null ? rt.mutableSourceEagerHydrationData = [dt, Zr] : rt.mutableSourceEagerHydrationData.push(
          dt,
          Zr
        );
    return new dc(rt);
  }, reactDom_production_min.render = function(tt, rt, dt) {
    if (!Lg(rt))
      throw Error(ee(200));
    return Ig(null, tt, rt, !1, dt);
  }, reactDom_production_min.unmountComponentAtNode = function(tt) {
    if (!Lg(tt))
      throw Error(ee(40));
    return tt._reactRootContainer ? (rd(function() {
      Ig(null, null, tt, !1, function() {
        tt._reactRootContainer = null, tt[nc] = null;
      });
    }), !0) : !1;
  }, reactDom_production_min.unstable_batchedUpdates = Wf, reactDom_production_min.unstable_renderSubtreeIntoContainer = function(tt, rt, dt, mt) {
    if (!Lg(dt))
      throw Error(ee(200));
    if (tt == null || tt._reactInternals === void 0)
      throw Error(ee(38));
    return Ig(tt, rt, dt, !1, mt);
  }, reactDom_production_min.version = "18.2.0-next-9e3b772b8-20220608", reactDom_production_min;
}
var reactDom_development = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDom_development;
function requireReactDom_development() {
  return hasRequiredReactDom_development || (hasRequiredReactDom_development = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ie = reactExports, Z = requireScheduler(), ee = ie.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ae = !1;
    function ve(Ke) {
      ae = Ke;
    }
    function ye(Ke) {
      if (!ae) {
        for (var Xe = arguments.length, it = new Array(Xe > 1 ? Xe - 1 : 0), ut = 1; ut < Xe; ut++)
          it[ut - 1] = arguments[ut];
        Ye("warn", Ke, it);
      }
    }
    function be(Ke) {
      if (!ae) {
        for (var Xe = arguments.length, it = new Array(Xe > 1 ? Xe - 1 : 0), ut = 1; ut < Xe; ut++)
          it[ut - 1] = arguments[ut];
        Ye("error", Ke, it);
      }
    }
    function Ye(Ke, Xe, it) {
      {
        var ut = ee.ReactDebugCurrentFrame, pt = ut.getStackAddendum();
        pt !== "" && (Xe += "%s", it = it.concat([pt]));
        var Yr = it.map(function(Qr) {
          return String(Qr);
        });
        Yr.unshift("Warning: " + Xe), Function.prototype.apply.call(console[Ke], console, Yr);
      }
    }
    var Qe = 0, Je = 1, nt = 2, st = 3, ot = 4, lt = 5, ft = 6, gt = 7, ct = 8, _r = 9, Kr = 10, Xr = 11, Jr = 12, ei = 13, si = 14, ri = 15, ai = 16, yi = 17, pi = 18, di = 19, xi = 21, Ti = 22, Ai = 23, mi = 24, Si = 25, gi = !0, _i = !1, Oi = !1, hi = !1, Di = !1, Ri = !0, rs = !1, Hi = !1, qi = !0, us = !0, Yi = !0, is = /* @__PURE__ */ new Set(), Ss = {}, Gs = {};
    function Vs(Ke, Xe) {
      Ws(Ke, Xe), Ws(Ke + "Capture", Xe);
    }
    function Ws(Ke, Xe) {
      Ss[Ke] && be("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", Ke), Ss[Ke] = Xe;
      {
        var it = Ke.toLowerCase();
        Gs[it] = Ke, Ke === "onDoubleClick" && (Gs.ondblclick = Ke);
      }
      for (var ut = 0; ut < Xe.length; ut++)
        is.add(Xe[ut]);
    }
    var ii = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", bi = Object.prototype.hasOwnProperty;
    function Gi(Ke) {
      {
        var Xe = typeof Symbol == "function" && Symbol.toStringTag, it = Xe && Ke[Symbol.toStringTag] || Ke.constructor.name || "Object";
        return it;
      }
    }
    function Qi(Ke) {
      try {
        return ns(Ke), !1;
      } catch {
        return !0;
      }
    }
    function ns(Ke) {
      return "" + Ke;
    }
    function Bs(Ke, Xe) {
      if (Qi(Ke))
        return be("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", Xe, Gi(Ke)), ns(Ke);
    }
    function ms(Ke) {
      if (Qi(Ke))
        return be("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Gi(Ke)), ns(Ke);
    }
    function Ks(Ke, Xe) {
      if (Qi(Ke))
        return be("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", Xe, Gi(Ke)), ns(Ke);
    }
    function Js(Ke, Xe) {
      if (Qi(Ke))
        return be("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", Xe, Gi(Ke)), ns(Ke);
    }
    function Ns(Ke) {
      if (Qi(Ke))
        return be("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Gi(Ke)), ns(Ke);
    }
    function Ts(Ke) {
      if (Qi(Ke))
        return be("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Gi(Ke)), ns(Ke);
    }
    var lo = 0, Fs = 1, xo = 2, mo = 3, Wo = 4, Ta = 5, Aa = 6, hs = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Os = hs + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", ho = new RegExp("^[" + hs + "][" + Os + "]*$"), Ao = {}, ci = {};
    function li(Ke) {
      return bi.call(ci, Ke) ? !0 : bi.call(Ao, Ke) ? !1 : ho.test(Ke) ? (ci[Ke] = !0, !0) : (Ao[Ke] = !0, be("Invalid attribute name: `%s`", Ke), !1);
    }
    function Ci(Ke, Xe, it) {
      return Xe !== null ? Xe.type === lo : it ? !1 : Ke.length > 2 && (Ke[0] === "o" || Ke[0] === "O") && (Ke[1] === "n" || Ke[1] === "N");
    }
    function Li(Ke, Xe, it, ut) {
      if (it !== null && it.type === lo)
        return !1;
      switch (typeof Xe) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (ut)
            return !1;
          if (it !== null)
            return !it.acceptsBooleans;
          var pt = Ke.toLowerCase().slice(0, 5);
          return pt !== "data-" && pt !== "aria-";
        }
        default:
          return !1;
      }
    }
    function es(Ke, Xe, it, ut) {
      if (Xe === null || typeof Xe > "u" || Li(Ke, Xe, it, ut))
        return !0;
      if (ut)
        return !1;
      if (it !== null)
        switch (it.type) {
          case mo:
            return !Xe;
          case Wo:
            return Xe === !1;
          case Ta:
            return isNaN(Xe);
          case Aa:
            return isNaN(Xe) || Xe < 1;
        }
      return !1;
    }
    function Es(Ke) {
      return ss.hasOwnProperty(Ke) ? ss[Ke] : null;
    }
    function ls(Ke, Xe, it, ut, pt, Yr, Qr) {
      this.acceptsBooleans = Xe === xo || Xe === mo || Xe === Wo, this.attributeName = ut, this.attributeNamespace = pt, this.mustUseProperty = it, this.propertyName = Ke, this.type = Xe, this.sanitizeURL = Yr, this.removeEmptyString = Qr;
    }
    var ss = {}, Hs = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    Hs.forEach(function(Ke) {
      ss[Ke] = new ls(
        Ke,
        lo,
        !1,
        // mustUseProperty
        Ke,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(Ke) {
      var Xe = Ke[0], it = Ke[1];
      ss[Xe] = new ls(
        Xe,
        Fs,
        !1,
        // mustUseProperty
        it,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(Ke) {
      ss[Ke] = new ls(
        Ke,
        xo,
        !1,
        // mustUseProperty
        Ke.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(Ke) {
      ss[Ke] = new ls(
        Ke,
        xo,
        !1,
        // mustUseProperty
        Ke,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(Ke) {
      ss[Ke] = new ls(
        Ke,
        mo,
        !1,
        // mustUseProperty
        Ke.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Ke) {
      ss[Ke] = new ls(
        Ke,
        mo,
        !0,
        // mustUseProperty
        Ke,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Ke) {
      ss[Ke] = new ls(
        Ke,
        Wo,
        !1,
        // mustUseProperty
        Ke,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Ke) {
      ss[Ke] = new ls(
        Ke,
        Aa,
        !1,
        // mustUseProperty
        Ke,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(Ke) {
      ss[Ke] = new ls(
        Ke,
        Ta,
        !1,
        // mustUseProperty
        Ke.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var eo = /[\-\:]([a-z])/g, Us = function(Ke) {
      return Ke[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Ke) {
      var Xe = Ke.replace(eo, Us);
      ss[Xe] = new ls(
        Xe,
        Fs,
        !1,
        // mustUseProperty
        Ke,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Ke) {
      var Xe = Ke.replace(eo, Us);
      ss[Xe] = new ls(
        Xe,
        Fs,
        !1,
        // mustUseProperty
        Ke,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Ke) {
      var Xe = Ke.replace(eo, Us);
      ss[Xe] = new ls(
        Xe,
        Fs,
        !1,
        // mustUseProperty
        Ke,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(Ke) {
      ss[Ke] = new ls(
        Ke,
        Fs,
        !1,
        // mustUseProperty
        Ke.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var To = "xlinkHref";
    ss[To] = new ls(
      "xlinkHref",
      Fs,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(Ke) {
      ss[Ke] = new ls(
        Ke,
        Fs,
        !1,
        // mustUseProperty
        Ke.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Ms = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, da = !1;
    function qo(Ke) {
      !da && Ms.test(Ke) && (da = !0, be("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(Ke)));
    }
    function ba(Ke, Xe, it, ut) {
      if (ut.mustUseProperty) {
        var pt = ut.propertyName;
        return Ke[pt];
      } else {
        Bs(it, Xe), ut.sanitizeURL && qo("" + it);
        var Yr = ut.attributeName, Qr = null;
        if (ut.type === Wo) {
          if (Ke.hasAttribute(Yr)) {
            var ni = Ke.getAttribute(Yr);
            return ni === "" ? !0 : es(Xe, it, ut, !1) ? ni : ni === "" + it ? it : ni;
          }
        } else if (Ke.hasAttribute(Yr)) {
          if (es(Xe, it, ut, !1))
            return Ke.getAttribute(Yr);
          if (ut.type === mo)
            return it;
          Qr = Ke.getAttribute(Yr);
        }
        return es(Xe, it, ut, !1) ? Qr === null ? it : Qr : Qr === "" + it ? it : Qr;
      }
    }
    function ll(Ke, Xe, it, ut) {
      {
        if (!li(Xe))
          return;
        if (!Ke.hasAttribute(Xe))
          return it === void 0 ? void 0 : null;
        var pt = Ke.getAttribute(Xe);
        return Bs(it, Xe), pt === "" + it ? it : pt;
      }
    }
    function Yo(Ke, Xe, it, ut) {
      var pt = Es(Xe);
      if (!Ci(Xe, pt, ut)) {
        if (es(Xe, it, pt, ut) && (it = null), ut || pt === null) {
          if (li(Xe)) {
            var Yr = Xe;
            it === null ? Ke.removeAttribute(Yr) : (Bs(it, Xe), Ke.setAttribute(Yr, "" + it));
          }
          return;
        }
        var Qr = pt.mustUseProperty;
        if (Qr) {
          var ni = pt.propertyName;
          if (it === null) {
            var oi = pt.type;
            Ke[ni] = oi === mo ? !1 : "";
          } else
            Ke[ni] = it;
          return;
        }
        var vi = pt.attributeName, Ei = pt.attributeNamespace;
        if (it === null)
          Ke.removeAttribute(vi);
        else {
          var Ni = pt.type, Mi;
          Ni === mo || Ni === Wo && it === !0 ? Mi = "" : (Bs(it, vi), Mi = "" + it, pt.sanitizeURL && qo(Mi.toString())), Ei ? Ke.setAttributeNS(Ei, vi, Mi) : Ke.setAttribute(vi, Mi);
        }
      }
    }
    var va = Symbol.for("react.element"), ia = Symbol.for("react.portal"), Ul = Symbol.for("react.fragment"), _c = Symbol.for("react.strict_mode"), wc = Symbol.for("react.profiler"), lf = Symbol.for("react.provider"), hh = Symbol.for("react.context"), fa = Symbol.for("react.forward_ref"), Ql = Symbol.for("react.suspense"), vd = Symbol.for("react.suspense_list"), Cc = Symbol.for("react.memo"), za = Symbol.for("react.lazy"), Ep = Symbol.for("react.scope"), xp = Symbol.for("react.debug_trace_mode"), ph = Symbol.for("react.offscreen"), Tp = Symbol.for("react.legacy_hidden"), lm = Symbol.for("react.cache"), um = Symbol.for("react.tracing_marker"), ta = Symbol.iterator, cm = "@@iterator";
    function yu(Ke) {
      if (Ke === null || typeof Ke != "object")
        return null;
      var Xe = ta && Ke[ta] || Ke[cm];
      return typeof Xe == "function" ? Xe : null;
    }
    var vo = Object.assign, Iu = 0, Rc, uf, Ac, Sl, gh, ul, mh;
    function vh() {
    }
    vh.__reactDisabledLog = !0;
    function bp() {
      {
        if (Iu === 0) {
          Rc = console.log, uf = console.info, Ac = console.warn, Sl = console.error, gh = console.group, ul = console.groupCollapsed, mh = console.groupEnd;
          var Ke = {
            configurable: !0,
            enumerable: !0,
            value: vh,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Ke,
            log: Ke,
            warn: Ke,
            error: Ke,
            group: Ke,
            groupCollapsed: Ke,
            groupEnd: Ke
          });
        }
        Iu++;
      }
    }
    function cf() {
      {
        if (Iu--, Iu === 0) {
          var Ke = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: vo({}, Ke, {
              value: Rc
            }),
            info: vo({}, Ke, {
              value: uf
            }),
            warn: vo({}, Ke, {
              value: Ac
            }),
            error: vo({}, Ke, {
              value: Sl
            }),
            group: vo({}, Ke, {
              value: gh
            }),
            groupCollapsed: vo({}, Ke, {
              value: ul
            }),
            groupEnd: vo({}, Ke, {
              value: mh
            })
          });
        }
        Iu < 0 && be("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Lc = ee.ReactCurrentDispatcher, Eu;
    function cl(Ke, Xe, it) {
      {
        if (Eu === void 0)
          try {
            throw Error();
          } catch (pt) {
            var ut = pt.stack.trim().match(/\n( *(at )?)/);
            Eu = ut && ut[1] || "";
          }
        return `
` + Eu + Ke;
      }
    }
    var Ic = !1, Pc;
    {
      var Dc = typeof WeakMap == "function" ? WeakMap : Map;
      Pc = new Dc();
    }
    function df(Ke, Xe) {
      if (!Ke || Ic)
        return "";
      {
        var it = Pc.get(Ke);
        if (it !== void 0)
          return it;
      }
      var ut;
      Ic = !0;
      var pt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Yr;
      Yr = Lc.current, Lc.current = null, bp();
      try {
        if (Xe) {
          var Qr = function() {
            throw Error();
          };
          if (Object.defineProperty(Qr.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Qr, []);
            } catch (ji) {
              ut = ji;
            }
            Reflect.construct(Ke, [], Qr);
          } else {
            try {
              Qr.call();
            } catch (ji) {
              ut = ji;
            }
            Ke.call(Qr.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ji) {
            ut = ji;
          }
          Ke();
        }
      } catch (ji) {
        if (ji && ut && typeof ji.stack == "string") {
          for (var ni = ji.stack.split(`
`), oi = ut.stack.split(`
`), vi = ni.length - 1, Ei = oi.length - 1; vi >= 1 && Ei >= 0 && ni[vi] !== oi[Ei]; )
            Ei--;
          for (; vi >= 1 && Ei >= 0; vi--, Ei--)
            if (ni[vi] !== oi[Ei]) {
              if (vi !== 1 || Ei !== 1)
                do
                  if (vi--, Ei--, Ei < 0 || ni[vi] !== oi[Ei]) {
                    var Ni = `
` + ni[vi].replace(" at new ", " at ");
                    return Ke.displayName && Ni.includes("<anonymous>") && (Ni = Ni.replace("<anonymous>", Ke.displayName)), typeof Ke == "function" && Pc.set(Ke, Ni), Ni;
                  }
                while (vi >= 1 && Ei >= 0);
              break;
            }
        }
      } finally {
        Ic = !1, Lc.current = Yr, cf(), Error.prepareStackTrace = pt;
      }
      var Mi = Ke ? Ke.displayName || Ke.name : "", zi = Mi ? cl(Mi) : "";
      return typeof Ke == "function" && Pc.set(Ke, zi), zi;
    }
    function ff(Ke, Xe, it) {
      return df(Ke, !0);
    }
    function Ku(Ke, Xe, it) {
      return df(Ke, !1);
    }
    function dm(Ke) {
      var Xe = Ke.prototype;
      return !!(Xe && Xe.isReactComponent);
    }
    function Pu(Ke, Xe, it) {
      if (Ke == null)
        return "";
      if (typeof Ke == "function")
        return df(Ke, dm(Ke));
      if (typeof Ke == "string")
        return cl(Ke);
      switch (Ke) {
        case Ql:
          return cl("Suspense");
        case vd:
          return cl("SuspenseList");
      }
      if (typeof Ke == "object")
        switch (Ke.$$typeof) {
          case fa:
            return Ku(Ke.render);
          case Cc:
            return Pu(Ke.type, Xe, it);
          case za: {
            var ut = Ke, pt = ut._payload, Yr = ut._init;
            try {
              return Pu(Yr(pt), Xe, it);
            } catch {
            }
          }
        }
      return "";
    }
    function Do(Ke) {
      switch (Ke._debugOwner && Ke._debugOwner.type, Ke._debugSource, Ke.tag) {
        case lt:
          return cl(Ke.type);
        case ai:
          return cl("Lazy");
        case ei:
          return cl("Suspense");
        case di:
          return cl("SuspenseList");
        case Qe:
        case nt:
        case ri:
          return Ku(Ke.type);
        case Xr:
          return Ku(Ke.type.render);
        case Je:
          return ff(Ke.type);
        default:
          return "";
      }
    }
    function hf(Ke) {
      try {
        var Xe = "", it = Ke;
        do
          Xe += Do(it), it = it.return;
        while (it);
        return Xe;
      } catch (ut) {
        return `
Error generating stack: ` + ut.message + `
` + ut.stack;
      }
    }
    function yd(Ke, Xe, it) {
      var ut = Ke.displayName;
      if (ut)
        return ut;
      var pt = Xe.displayName || Xe.name || "";
      return pt !== "" ? it + "(" + pt + ")" : it;
    }
    function pf(Ke) {
      return Ke.displayName || "Context";
    }
    function Lo(Ke) {
      if (Ke == null)
        return null;
      if (typeof Ke.tag == "number" && be("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Ke == "function")
        return Ke.displayName || Ke.name || null;
      if (typeof Ke == "string")
        return Ke;
      switch (Ke) {
        case Ul:
          return "Fragment";
        case ia:
          return "Portal";
        case wc:
          return "Profiler";
        case _c:
          return "StrictMode";
        case Ql:
          return "Suspense";
        case vd:
          return "SuspenseList";
      }
      if (typeof Ke == "object")
        switch (Ke.$$typeof) {
          case hh:
            var Xe = Ke;
            return pf(Xe) + ".Consumer";
          case lf:
            var it = Ke;
            return pf(it._context) + ".Provider";
          case fa:
            return yd(Ke, Ke.render, "ForwardRef");
          case Cc:
            var ut = Ke.displayName || null;
            return ut !== null ? ut : Lo(Ke.type) || "Memo";
          case za: {
            var pt = Ke, Yr = pt._payload, Qr = pt._init;
            try {
              return Lo(Qr(Yr));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function gf(Ke, Xe, it) {
      var ut = Xe.displayName || Xe.name || "";
      return Ke.displayName || (ut !== "" ? it + "(" + ut + ")" : it);
    }
    function mf(Ke) {
      return Ke.displayName || "Context";
    }
    function uo(Ke) {
      var Xe = Ke.tag, it = Ke.type;
      switch (Xe) {
        case mi:
          return "Cache";
        case _r:
          var ut = it;
          return mf(ut) + ".Consumer";
        case Kr:
          var pt = it;
          return mf(pt._context) + ".Provider";
        case pi:
          return "DehydratedFragment";
        case Xr:
          return gf(it, it.render, "ForwardRef");
        case gt:
          return "Fragment";
        case lt:
          return it;
        case ot:
          return "Portal";
        case st:
          return "Root";
        case ft:
          return "Text";
        case ai:
          return Lo(it);
        case ct:
          return it === _c ? "StrictMode" : "Mode";
        case Ti:
          return "Offscreen";
        case Jr:
          return "Profiler";
        case xi:
          return "Scope";
        case ei:
          return "Suspense";
        case di:
          return "SuspenseList";
        case Si:
          return "TracingMarker";
        case Je:
        case Qe:
        case yi:
        case nt:
        case si:
        case ri:
          if (typeof it == "function")
            return it.displayName || it.name || null;
          if (typeof it == "string")
            return it;
          break;
      }
      return null;
    }
    var Ed = ee.ReactDebugCurrentFrame, sa = null, _l = !1;
    function dl() {
      {
        if (sa === null)
          return null;
        var Ke = sa._debugOwner;
        if (Ke !== null && typeof Ke < "u")
          return uo(Ke);
      }
      return null;
    }
    function Oc() {
      return sa === null ? "" : hf(sa);
    }
    function ha() {
      Ed.getCurrentStack = null, sa = null, _l = !1;
    }
    function No(Ke) {
      Ed.getCurrentStack = Ke === null ? null : Oc, sa = Ke, _l = !1;
    }
    function Sp() {
      return sa;
    }
    function wl(Ke) {
      _l = Ke;
    }
    function ka(Ke) {
      return "" + Ke;
    }
    function Du(Ke) {
      switch (typeof Ke) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return Ke;
        case "object":
          return Ts(Ke), Ke;
        default:
          return "";
      }
    }
    var _p = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function qu(Ke, Xe) {
      _p[Xe.type] || Xe.onChange || Xe.onInput || Xe.readOnly || Xe.disabled || Xe.value == null || be("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), Xe.onChange || Xe.readOnly || Xe.disabled || Xe.checked == null || be("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Mc(Ke) {
      var Xe = Ke.type, it = Ke.nodeName;
      return it && it.toLowerCase() === "input" && (Xe === "checkbox" || Xe === "radio");
    }
    function wp(Ke) {
      return Ke._valueTracker;
    }
    function Jl(Ke) {
      Ke._valueTracker = null;
    }
    function kc(Ke) {
      var Xe = "";
      return Ke && (Mc(Ke) ? Xe = Ke.checked ? "true" : "false" : Xe = Ke.value), Xe;
    }
    function Nc(Ke) {
      var Xe = Mc(Ke) ? "checked" : "value", it = Object.getOwnPropertyDescriptor(Ke.constructor.prototype, Xe);
      Ts(Ke[Xe]);
      var ut = "" + Ke[Xe];
      if (!(Ke.hasOwnProperty(Xe) || typeof it > "u" || typeof it.get != "function" || typeof it.set != "function")) {
        var pt = it.get, Yr = it.set;
        Object.defineProperty(Ke, Xe, {
          configurable: !0,
          get: function() {
            return pt.call(this);
          },
          set: function(ni) {
            Ts(ni), ut = "" + ni, Yr.call(this, ni);
          }
        }), Object.defineProperty(Ke, Xe, {
          enumerable: it.enumerable
        });
        var Qr = {
          getValue: function() {
            return ut;
          },
          setValue: function(ni) {
            Ts(ni), ut = "" + ni;
          },
          stopTracking: function() {
            Jl(Ke), delete Ke[Xe];
          }
        };
        return Qr;
      }
    }
    function eu(Ke) {
      wp(Ke) || (Ke._valueTracker = Nc(Ke));
    }
    function vf(Ke) {
      if (!Ke)
        return !1;
      var Xe = wp(Ke);
      if (!Xe)
        return !0;
      var it = Xe.getValue(), ut = kc(Ke);
      return ut !== it ? (Xe.setValue(ut), !0) : !1;
    }
    function Fc(Ke) {
      if (Ke = Ke || (typeof document < "u" ? document : void 0), typeof Ke > "u")
        return null;
      try {
        return Ke.activeElement || Ke.body;
      } catch {
        return Ke.body;
      }
    }
    var $c = !1, xd = !1, yf = !1, yh = !1;
    function xu(Ke) {
      var Xe = Ke.type === "checkbox" || Ke.type === "radio";
      return Xe ? Ke.checked != null : Ke.value != null;
    }
    function ui(Ke, Xe) {
      var it = Ke, ut = Xe.checked, pt = vo({}, Xe, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: ut ?? it._wrapperState.initialChecked
      });
      return pt;
    }
    function Ii(Ke, Xe) {
      qu("input", Xe), Xe.checked !== void 0 && Xe.defaultChecked !== void 0 && !xd && (be("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", dl() || "A component", Xe.type), xd = !0), Xe.value !== void 0 && Xe.defaultValue !== void 0 && !$c && (be("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", dl() || "A component", Xe.type), $c = !0);
      var it = Ke, ut = Xe.defaultValue == null ? "" : Xe.defaultValue;
      it._wrapperState = {
        initialChecked: Xe.checked != null ? Xe.checked : Xe.defaultChecked,
        initialValue: Du(Xe.value != null ? Xe.value : ut),
        controlled: xu(Xe)
      };
    }
    function Vi(Ke, Xe) {
      var it = Ke, ut = Xe.checked;
      ut != null && Yo(it, "checked", ut, !1);
    }
    function Ki(Ke, Xe) {
      var it = Ke;
      {
        var ut = xu(Xe);
        !it._wrapperState.controlled && ut && !yh && (be("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), yh = !0), it._wrapperState.controlled && !ut && !yf && (be("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), yf = !0);
      }
      Vi(Ke, Xe);
      var pt = Du(Xe.value), Yr = Xe.type;
      if (pt != null)
        Yr === "number" ? (pt === 0 && it.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        it.value != pt) && (it.value = ka(pt)) : it.value !== ka(pt) && (it.value = ka(pt));
      else if (Yr === "submit" || Yr === "reset") {
        it.removeAttribute("value");
        return;
      }
      Xe.hasOwnProperty("value") ? Ys(it, Xe.type, pt) : Xe.hasOwnProperty("defaultValue") && Ys(it, Xe.type, Du(Xe.defaultValue)), Xe.checked == null && Xe.defaultChecked != null && (it.defaultChecked = !!Xe.defaultChecked);
    }
    function ps(Ke, Xe, it) {
      var ut = Ke;
      if (Xe.hasOwnProperty("value") || Xe.hasOwnProperty("defaultValue")) {
        var pt = Xe.type, Yr = pt === "submit" || pt === "reset";
        if (Yr && (Xe.value === void 0 || Xe.value === null))
          return;
        var Qr = ka(ut._wrapperState.initialValue);
        it || Qr !== ut.value && (ut.value = Qr), ut.defaultValue = Qr;
      }
      var ni = ut.name;
      ni !== "" && (ut.name = ""), ut.defaultChecked = !ut.defaultChecked, ut.defaultChecked = !!ut._wrapperState.initialChecked, ni !== "" && (ut.name = ni);
    }
    function Zs(Ke, Xe) {
      var it = Ke;
      Ki(it, Xe), xs(it, Xe);
    }
    function xs(Ke, Xe) {
      var it = Xe.name;
      if (Xe.type === "radio" && it != null) {
        for (var ut = Ke; ut.parentNode; )
          ut = ut.parentNode;
        Bs(it, "name");
        for (var pt = ut.querySelectorAll("input[name=" + JSON.stringify("" + it) + '][type="radio"]'), Yr = 0; Yr < pt.length; Yr++) {
          var Qr = pt[Yr];
          if (!(Qr === Ke || Qr.form !== Ke.form)) {
            var ni = jy(Qr);
            if (!ni)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            vf(Qr), Ki(Qr, ni);
          }
        }
      }
    }
    function Ys(Ke, Xe, it) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (Xe !== "number" || Fc(Ke.ownerDocument) !== Ke) && (it == null ? Ke.defaultValue = ka(Ke._wrapperState.initialValue) : Ke.defaultValue !== ka(it) && (Ke.defaultValue = ka(it)));
    }
    var yo = !1, Io = !1, Ho = !1;
    function Bo(Ke, Xe) {
      Xe.value == null && (typeof Xe.children == "object" && Xe.children !== null ? ie.Children.forEach(Xe.children, function(it) {
        it != null && (typeof it == "string" || typeof it == "number" || Io || (Io = !0, be("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : Xe.dangerouslySetInnerHTML != null && (Ho || (Ho = !0, be("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), Xe.selected != null && !yo && (be("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), yo = !0);
    }
    function zo(Ke, Xe) {
      Xe.value != null && Ke.setAttribute("value", ka(Du(Xe.value)));
    }
    var Ko = Array.isArray;
    function _o(Ke) {
      return Ko(Ke);
    }
    var Yu;
    Yu = !1;
    function Ef() {
      var Ke = dl();
      return Ke ? `

Check the render method of \`` + Ke + "`." : "";
    }
    var Eh = ["value", "defaultValue"];
    function fm(Ke) {
      {
        qu("select", Ke);
        for (var Xe = 0; Xe < Eh.length; Xe++) {
          var it = Eh[Xe];
          if (Ke[it] != null) {
            var ut = _o(Ke[it]);
            Ke.multiple && !ut ? be("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", it, Ef()) : !Ke.multiple && ut && be("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", it, Ef());
          }
        }
      }
    }
    function Tu(Ke, Xe, it, ut) {
      var pt = Ke.options;
      if (Xe) {
        for (var Yr = it, Qr = {}, ni = 0; ni < Yr.length; ni++)
          Qr["$" + Yr[ni]] = !0;
        for (var oi = 0; oi < pt.length; oi++) {
          var vi = Qr.hasOwnProperty("$" + pt[oi].value);
          pt[oi].selected !== vi && (pt[oi].selected = vi), vi && ut && (pt[oi].defaultSelected = !0);
        }
      } else {
        for (var Ei = ka(Du(it)), Ni = null, Mi = 0; Mi < pt.length; Mi++) {
          if (pt[Mi].value === Ei) {
            pt[Mi].selected = !0, ut && (pt[Mi].defaultSelected = !0);
            return;
          }
          Ni === null && !pt[Mi].disabled && (Ni = pt[Mi]);
        }
        Ni !== null && (Ni.selected = !0);
      }
    }
    function xh(Ke, Xe) {
      return vo({}, Xe, {
        value: void 0
      });
    }
    function Th(Ke, Xe) {
      var it = Ke;
      fm(Xe), it._wrapperState = {
        wasMultiple: !!Xe.multiple
      }, Xe.value !== void 0 && Xe.defaultValue !== void 0 && !Yu && (be("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Yu = !0);
    }
    function hm(Ke, Xe) {
      var it = Ke;
      it.multiple = !!Xe.multiple;
      var ut = Xe.value;
      ut != null ? Tu(it, !!Xe.multiple, ut, !1) : Xe.defaultValue != null && Tu(it, !!Xe.multiple, Xe.defaultValue, !0);
    }
    function s1(Ke, Xe) {
      var it = Ke, ut = it._wrapperState.wasMultiple;
      it._wrapperState.wasMultiple = !!Xe.multiple;
      var pt = Xe.value;
      pt != null ? Tu(it, !!Xe.multiple, pt, !1) : ut !== !!Xe.multiple && (Xe.defaultValue != null ? Tu(it, !!Xe.multiple, Xe.defaultValue, !0) : Tu(it, !!Xe.multiple, Xe.multiple ? [] : "", !1));
    }
    function o1(Ke, Xe) {
      var it = Ke, ut = Xe.value;
      ut != null && Tu(it, !!Xe.multiple, ut, !1);
    }
    var pm = !1;
    function gm(Ke, Xe) {
      var it = Ke;
      if (Xe.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var ut = vo({}, Xe, {
        value: void 0,
        defaultValue: void 0,
        children: ka(it._wrapperState.initialValue)
      });
      return ut;
    }
    function Ev(Ke, Xe) {
      var it = Ke;
      qu("textarea", Xe), Xe.value !== void 0 && Xe.defaultValue !== void 0 && !pm && (be("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", dl() || "A component"), pm = !0);
      var ut = Xe.value;
      if (ut == null) {
        var pt = Xe.children, Yr = Xe.defaultValue;
        if (pt != null) {
          be("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (Yr != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (_o(pt)) {
              if (pt.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              pt = pt[0];
            }
            Yr = pt;
          }
        }
        Yr == null && (Yr = ""), ut = Yr;
      }
      it._wrapperState = {
        initialValue: Du(ut)
      };
    }
    function xv(Ke, Xe) {
      var it = Ke, ut = Du(Xe.value), pt = Du(Xe.defaultValue);
      if (ut != null) {
        var Yr = ka(ut);
        Yr !== it.value && (it.value = Yr), Xe.defaultValue == null && it.defaultValue !== Yr && (it.defaultValue = Yr);
      }
      pt != null && (it.defaultValue = ka(pt));
    }
    function Tv(Ke, Xe) {
      var it = Ke, ut = it.textContent;
      ut === it._wrapperState.initialValue && ut !== "" && ut !== null && (it.value = ut);
    }
    function mm(Ke, Xe) {
      xv(Ke, Xe);
    }
    var Xu = "http://www.w3.org/1999/xhtml", a1 = "http://www.w3.org/1998/Math/MathML", vm = "http://www.w3.org/2000/svg";
    function Cp(Ke) {
      switch (Ke) {
        case "svg":
          return vm;
        case "math":
          return a1;
        default:
          return Xu;
      }
    }
    function ym(Ke, Xe) {
      return Ke == null || Ke === Xu ? Cp(Xe) : Ke === vm && Xe === "foreignObject" ? Xu : Ke;
    }
    var l1 = function(Ke) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(Xe, it, ut, pt) {
        MSApp.execUnsafeLocalFunction(function() {
          return Ke(Xe, it, ut, pt);
        });
      } : Ke;
    }, Rp, bv = l1(function(Ke, Xe) {
      if (Ke.namespaceURI === vm && !("innerHTML" in Ke)) {
        Rp = Rp || document.createElement("div"), Rp.innerHTML = "<svg>" + Xe.valueOf().toString() + "</svg>";
        for (var it = Rp.firstChild; Ke.firstChild; )
          Ke.removeChild(Ke.firstChild);
        for (; it.firstChild; )
          Ke.appendChild(it.firstChild);
        return;
      }
      Ke.innerHTML = Xe;
    }), Cl = 1, Zu = 3, Sa = 8, bu = 9, Td = 11, Ap = function(Ke, Xe) {
      if (Xe) {
        var it = Ke.firstChild;
        if (it && it === Ke.lastChild && it.nodeType === Zu) {
          it.nodeValue = Xe;
          return;
        }
      }
      Ke.textContent = Xe;
    }, Sv = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, xf = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function _v(Ke, Xe) {
      return Ke + Xe.charAt(0).toUpperCase() + Xe.substring(1);
    }
    var wv = ["Webkit", "ms", "Moz", "O"];
    Object.keys(xf).forEach(function(Ke) {
      wv.forEach(function(Xe) {
        xf[_v(Xe, Ke)] = xf[Ke];
      });
    });
    function Lp(Ke, Xe, it) {
      var ut = Xe == null || typeof Xe == "boolean" || Xe === "";
      return ut ? "" : !it && typeof Xe == "number" && Xe !== 0 && !(xf.hasOwnProperty(Ke) && xf[Ke]) ? Xe + "px" : (Js(Xe, Ke), ("" + Xe).trim());
    }
    var Tf = /([A-Z])/g, u1 = /^ms-/;
    function c1(Ke) {
      return Ke.replace(Tf, "-$1").toLowerCase().replace(u1, "-ms-");
    }
    var Cv = function() {
    };
    {
      var Rv = /^(?:webkit|moz|o)[A-Z]/, Av = /^-ms-/, bh = /-(.)/g, bf = /;\s*$/, Sf = {}, _f = {}, Lv = !1, Em = !1, xm = function(Ke) {
        return Ke.replace(bh, function(Xe, it) {
          return it.toUpperCase();
        });
      }, Tm = function(Ke) {
        Sf.hasOwnProperty(Ke) && Sf[Ke] || (Sf[Ke] = !0, be(
          "Unsupported style property %s. Did you mean %s?",
          Ke,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          xm(Ke.replace(Av, "ms-"))
        ));
      }, Iv = function(Ke) {
        Sf.hasOwnProperty(Ke) && Sf[Ke] || (Sf[Ke] = !0, be("Unsupported vendor-prefixed style property %s. Did you mean %s?", Ke, Ke.charAt(0).toUpperCase() + Ke.slice(1)));
      }, Pv = function(Ke, Xe) {
        _f.hasOwnProperty(Xe) && _f[Xe] || (_f[Xe] = !0, be(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, Ke, Xe.replace(bf, "")));
      }, Dv = function(Ke, Xe) {
        Lv || (Lv = !0, be("`NaN` is an invalid value for the `%s` css style property.", Ke));
      }, d1 = function(Ke, Xe) {
        Em || (Em = !0, be("`Infinity` is an invalid value for the `%s` css style property.", Ke));
      };
      Cv = function(Ke, Xe) {
        Ke.indexOf("-") > -1 ? Tm(Ke) : Rv.test(Ke) ? Iv(Ke) : bf.test(Xe) && Pv(Ke, Xe), typeof Xe == "number" && (isNaN(Xe) ? Dv(Ke, Xe) : isFinite(Xe) || d1(Ke, Xe));
      };
    }
    var f1 = Cv;
    function h1(Ke) {
      {
        var Xe = "", it = "";
        for (var ut in Ke)
          if (Ke.hasOwnProperty(ut)) {
            var pt = Ke[ut];
            if (pt != null) {
              var Yr = ut.indexOf("--") === 0;
              Xe += it + (Yr ? ut : c1(ut)) + ":", Xe += Lp(ut, pt, Yr), it = ";";
            }
          }
        return Xe || null;
      }
    }
    function Ov(Ke, Xe) {
      var it = Ke.style;
      for (var ut in Xe)
        if (Xe.hasOwnProperty(ut)) {
          var pt = ut.indexOf("--") === 0;
          pt || f1(ut, Xe[ut]);
          var Yr = Lp(ut, Xe[ut], pt);
          ut === "float" && (ut = "cssFloat"), pt ? it.setProperty(ut, Yr) : it[ut] = Yr;
        }
    }
    function g1(Ke) {
      return Ke == null || typeof Ke == "boolean" || Ke === "";
    }
    function tu(Ke) {
      var Xe = {};
      for (var it in Ke)
        for (var ut = Sv[it] || [it], pt = 0; pt < ut.length; pt++)
          Xe[ut[pt]] = it;
      return Xe;
    }
    function Sh(Ke, Xe) {
      {
        if (!Xe)
          return;
        var it = tu(Ke), ut = tu(Xe), pt = {};
        for (var Yr in it) {
          var Qr = it[Yr], ni = ut[Yr];
          if (ni && Qr !== ni) {
            var oi = Qr + "," + ni;
            if (pt[oi])
              continue;
            pt[oi] = !0, be("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", g1(Ke[Qr]) ? "Removing" : "Updating", Qr, ni);
          }
        }
      }
    }
    var Mv = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, kv = vo({
      menuitem: !0
    }, Mv), Nv = "__html";
    function Ip(Ke, Xe) {
      if (Xe) {
        if (kv[Ke] && (Xe.children != null || Xe.dangerouslySetInnerHTML != null))
          throw new Error(Ke + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (Xe.dangerouslySetInnerHTML != null) {
          if (Xe.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof Xe.dangerouslySetInnerHTML != "object" || !(Nv in Xe.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!Xe.suppressContentEditableWarning && Xe.contentEditable && Xe.children != null && be("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), Xe.style != null && typeof Xe.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Qu(Ke, Xe) {
      if (Ke.indexOf("-") === -1)
        return typeof Xe.is == "string";
      switch (Ke) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Pp = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Fv = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Su = {}, bm = new RegExp("^(aria)-[" + Os + "]*$"), _h = new RegExp("^(aria)[A-Z][" + Os + "]*$");
    function Sm(Ke, Xe) {
      {
        if (bi.call(Su, Xe) && Su[Xe])
          return !0;
        if (_h.test(Xe)) {
          var it = "aria-" + Xe.slice(4).toLowerCase(), ut = Fv.hasOwnProperty(it) ? it : null;
          if (ut == null)
            return be("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", Xe), Su[Xe] = !0, !0;
          if (Xe !== ut)
            return be("Invalid ARIA attribute `%s`. Did you mean `%s`?", Xe, ut), Su[Xe] = !0, !0;
        }
        if (bm.test(Xe)) {
          var pt = Xe.toLowerCase(), Yr = Fv.hasOwnProperty(pt) ? pt : null;
          if (Yr == null)
            return Su[Xe] = !0, !1;
          if (Xe !== Yr)
            return be("Unknown ARIA attribute `%s`. Did you mean `%s`?", Xe, Yr), Su[Xe] = !0, !0;
        }
      }
      return !0;
    }
    function $v(Ke, Xe) {
      {
        var it = [];
        for (var ut in Xe) {
          var pt = Sm(Ke, ut);
          pt || it.push(ut);
        }
        var Yr = it.map(function(Qr) {
          return "`" + Qr + "`";
        }).join(", ");
        it.length === 1 ? be("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Yr, Ke) : it.length > 1 && be("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Yr, Ke);
      }
    }
    function Dp(Ke, Xe) {
      Qu(Ke, Xe) || $v(Ke, Xe);
    }
    var bd = !1;
    function _m(Ke, Xe) {
      {
        if (Ke !== "input" && Ke !== "textarea" && Ke !== "select")
          return;
        Xe != null && Xe.value === null && !bd && (bd = !0, Ke === "select" && Xe.multiple ? be("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", Ke) : be("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", Ke));
      }
    }
    var wm = function() {
    };
    {
      var Na = {}, Cm = /^on./, Bv = /^on[^A-Z]/, Uv = new RegExp("^(aria)-[" + Os + "]*$"), Gv = new RegExp("^(aria)[A-Z][" + Os + "]*$");
      wm = function(Ke, Xe, it, ut) {
        if (bi.call(Na, Xe) && Na[Xe])
          return !0;
        var pt = Xe.toLowerCase();
        if (pt === "onfocusin" || pt === "onfocusout")
          return be("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Na[Xe] = !0, !0;
        if (ut != null) {
          var Yr = ut.registrationNameDependencies, Qr = ut.possibleRegistrationNames;
          if (Yr.hasOwnProperty(Xe))
            return !0;
          var ni = Qr.hasOwnProperty(pt) ? Qr[pt] : null;
          if (ni != null)
            return be("Invalid event handler property `%s`. Did you mean `%s`?", Xe, ni), Na[Xe] = !0, !0;
          if (Cm.test(Xe))
            return be("Unknown event handler property `%s`. It will be ignored.", Xe), Na[Xe] = !0, !0;
        } else if (Cm.test(Xe))
          return Bv.test(Xe) && be("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", Xe), Na[Xe] = !0, !0;
        if (Uv.test(Xe) || Gv.test(Xe))
          return !0;
        if (pt === "innerhtml")
          return be("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Na[Xe] = !0, !0;
        if (pt === "aria")
          return be("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Na[Xe] = !0, !0;
        if (pt === "is" && it !== null && it !== void 0 && typeof it != "string")
          return be("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof it), Na[Xe] = !0, !0;
        if (typeof it == "number" && isNaN(it))
          return be("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", Xe), Na[Xe] = !0, !0;
        var oi = Es(Xe), vi = oi !== null && oi.type === lo;
        if (Pp.hasOwnProperty(pt)) {
          var Ei = Pp[pt];
          if (Ei !== Xe)
            return be("Invalid DOM property `%s`. Did you mean `%s`?", Xe, Ei), Na[Xe] = !0, !0;
        } else if (!vi && Xe !== pt)
          return be("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", Xe, pt), Na[Xe] = !0, !0;
        return typeof it == "boolean" && Li(Xe, it, oi, !1) ? (it ? be('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', it, Xe, Xe, it, Xe) : be('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', it, Xe, Xe, it, Xe, Xe, Xe), Na[Xe] = !0, !0) : vi ? !0 : Li(Xe, it, oi, !1) ? (Na[Xe] = !0, !1) : ((it === "false" || it === "true") && oi !== null && oi.type === mo && (be("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", it, Xe, it === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', Xe, it), Na[Xe] = !0), !0);
      };
    }
    var Hv = function(Ke, Xe, it) {
      {
        var ut = [];
        for (var pt in Xe) {
          var Yr = wm(Ke, pt, Xe[pt], it);
          Yr || ut.push(pt);
        }
        var Qr = ut.map(function(ni) {
          return "`" + ni + "`";
        }).join(", ");
        ut.length === 1 ? be("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Qr, Ke) : ut.length > 1 && be("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Qr, Ke);
      }
    };
    function zv(Ke, Xe, it) {
      Qu(Ke, Xe) || Hv(Ke, Xe, it);
    }
    var Ju = 1, wh = 2, Sd = 4, m1 = Ju | wh | Sd, Ch = null;
    function Rh(Ke) {
      Ch !== null && be("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Ch = Ke;
    }
    function v1() {
      Ch === null && be("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Ch = null;
    }
    function Vv(Ke) {
      return Ke === Ch;
    }
    function Op(Ke) {
      var Xe = Ke.target || Ke.srcElement || window;
      return Xe.correspondingUseElement && (Xe = Xe.correspondingUseElement), Xe.nodeType === Zu ? Xe.parentNode : Xe;
    }
    var Vo = null, Bc = null, tc = null;
    function wf(Ke) {
      var Xe = Zf(Ke);
      if (Xe) {
        if (typeof Vo != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var it = Xe.stateNode;
        if (it) {
          var ut = jy(it);
          Vo(Xe.stateNode, Xe.type, ut);
        }
      }
    }
    function jv(Ke) {
      Vo = Ke;
    }
    function Mp(Ke) {
      Bc ? tc ? tc.push(Ke) : tc = [Ke] : Bc = Ke;
    }
    function Ah() {
      return Bc !== null || tc !== null;
    }
    function Lh() {
      if (Bc) {
        var Ke = Bc, Xe = tc;
        if (Bc = null, tc = null, wf(Ke), Xe)
          for (var it = 0; it < Xe.length; it++)
            wf(Xe[it]);
      }
    }
    var _d = function(Ke, Xe) {
      return Ke(Xe);
    }, Rm = function() {
    }, Am = !1;
    function y1() {
      var Ke = Ah();
      Ke && (Rm(), Lh());
    }
    function Lm(Ke, Xe, it) {
      if (Am)
        return Ke(Xe, it);
      Am = !0;
      try {
        return _d(Ke, Xe, it);
      } finally {
        Am = !1, y1();
      }
    }
    function kp(Ke, Xe, it) {
      _d = Ke, Rm = it;
    }
    function Np(Ke) {
      return Ke === "button" || Ke === "input" || Ke === "select" || Ke === "textarea";
    }
    function Im(Ke, Xe, it) {
      switch (Ke) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(it.disabled && Np(Xe));
        default:
          return !1;
      }
    }
    function wd(Ke, Xe) {
      var it = Ke.stateNode;
      if (it === null)
        return null;
      var ut = jy(it);
      if (ut === null)
        return null;
      var pt = ut[Xe];
      if (Im(Xe, Ke.type, ut))
        return null;
      if (pt && typeof pt != "function")
        throw new Error("Expected `" + Xe + "` listener to be a function, instead got a value of `" + typeof pt + "` type.");
      return pt;
    }
    var Ih = !1;
    if (ii)
      try {
        var Cd = {};
        Object.defineProperty(Cd, "passive", {
          get: function() {
            Ih = !0;
          }
        }), window.addEventListener("test", Cd, Cd), window.removeEventListener("test", Cd, Cd);
      } catch {
        Ih = !1;
      }
    function Wv(Ke, Xe, it, ut, pt, Yr, Qr, ni, oi) {
      var vi = Array.prototype.slice.call(arguments, 3);
      try {
        Xe.apply(it, vi);
      } catch (Ei) {
        this.onError(Ei);
      }
    }
    var Pm = Wv;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var Dm = document.createElement("react");
      Pm = function(Xe, it, ut, pt, Yr, Qr, ni, oi, vi) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var Ei = document.createEvent("Event"), Ni = !1, Mi = !0, zi = window.event, ji = Object.getOwnPropertyDescriptor(window, "event");
        function Xi() {
          Dm.removeEventListener(Zi, qs, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = zi);
        }
        var Cs = Array.prototype.slice.call(arguments, 3);
        function qs() {
          Ni = !0, Xi(), it.apply(ut, Cs), Mi = !1;
        }
        var $s, Ro = !1, So = !1;
        function $i(Bi) {
          if ($s = Bi.error, Ro = !0, $s === null && Bi.colno === 0 && Bi.lineno === 0 && (So = !0), Bi.defaultPrevented && $s != null && typeof $s == "object")
            try {
              $s._suppressLogging = !0;
            } catch {
            }
        }
        var Zi = "react-" + (Xe || "invokeguardedcallback");
        if (window.addEventListener("error", $i), Dm.addEventListener(Zi, qs, !1), Ei.initEvent(Zi, !1, !1), Dm.dispatchEvent(Ei), ji && Object.defineProperty(window, "event", ji), Ni && Mi && (Ro ? So && ($s = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : $s = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError($s)), window.removeEventListener("error", $i), !Ni)
          return Xi(), Wv.apply(this, arguments);
      };
    }
    var E1 = Pm, Uc = !1, _u = null, Ph = !1, Gc = null, Ou = {
      onError: function(Ke) {
        Uc = !0, _u = Ke;
      }
    };
    function Rd(Ke, Xe, it, ut, pt, Yr, Qr, ni, oi) {
      Uc = !1, _u = null, E1.apply(Ou, arguments);
    }
    function nc(Ke, Xe, it, ut, pt, Yr, Qr, ni, oi) {
      if (Rd.apply(this, arguments), Uc) {
        var vi = Mm();
        Ph || (Ph = !0, Gc = vi);
      }
    }
    function Om() {
      if (Ph) {
        var Ke = Gc;
        throw Ph = !1, Gc = null, Ke;
      }
    }
    function x1() {
      return Uc;
    }
    function Mm() {
      if (Uc) {
        var Ke = _u;
        return Uc = !1, _u = null, Ke;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function nu(Ke) {
      return Ke._reactInternals;
    }
    function Dh(Ke) {
      return Ke._reactInternals !== void 0;
    }
    function Cf(Ke, Xe) {
      Ke._reactInternals = Xe;
    }
    var js = (
      /*                      */
      0
    ), Hc = (
      /*                */
      1
    ), Xo = (
      /*                    */
      2
    ), po = (
      /*                       */
      4
    ), ko = (
      /*                */
      16
    ), Fo = (
      /*                 */
      32
    ), Mu = (
      /*                     */
      64
    ), io = (
      /*                   */
      128
    ), pa = (
      /*            */
      256
    ), Rl = (
      /*                          */
      512
    ), ru = (
      /*                     */
      1024
    ), na = (
      /*                      */
      2048
    ), iu = (
      /*                    */
      4096
    ), zc = (
      /*                   */
      8192
    ), Oh = (
      /*             */
      16384
    ), Fp = na | po | Mu | Rl | ru | Oh, Kv = (
      /*               */
      32767
    ), Gl = (
      /*                   */
      32768
    ), Fa = (
      /*                */
      65536
    ), Mh = (
      /* */
      131072
    ), km = (
      /*                       */
      1048576
    ), Nm = (
      /*                    */
      2097152
    ), Al = (
      /*                 */
      4194304
    ), Vc = (
      /*                */
      8388608
    ), Ll = (
      /*               */
      16777216
    ), Ad = (
      /*              */
      33554432
    ), Rf = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      po | ru | 0
    ), Il = Xo | po | ko | Fo | Rl | iu | zc, tl = po | Mu | Rl | zc, su = na | ko, Va = Al | Vc | Nm, rc = ee.ReactCurrentOwner;
    function Hl(Ke) {
      var Xe = Ke, it = Ke;
      if (Ke.alternate)
        for (; Xe.return; )
          Xe = Xe.return;
      else {
        var ut = Xe;
        do
          Xe = ut, (Xe.flags & (Xo | iu)) !== js && (it = Xe.return), ut = Xe.return;
        while (ut);
      }
      return Xe.tag === st ? it : null;
    }
    function Fm(Ke) {
      if (Ke.tag === ei) {
        var Xe = Ke.memoizedState;
        if (Xe === null) {
          var it = Ke.alternate;
          it !== null && (Xe = it.memoizedState);
        }
        if (Xe !== null)
          return Xe.dehydrated;
      }
      return null;
    }
    function $p(Ke) {
      return Ke.tag === st ? Ke.stateNode.containerInfo : null;
    }
    function $m(Ke) {
      return Hl(Ke) === Ke;
    }
    function zl(Ke) {
      {
        var Xe = rc.current;
        if (Xe !== null && Xe.tag === Je) {
          var it = Xe, ut = it.stateNode;
          ut._warnedAboutRefsInRender || be("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", uo(it) || "A component"), ut._warnedAboutRefsInRender = !0;
        }
      }
      var pt = nu(Ke);
      return pt ? Hl(pt) === pt : !1;
    }
    function Pl(Ke) {
      if (Hl(Ke) !== Ke)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Zo(Ke) {
      var Xe = Ke.alternate;
      if (!Xe) {
        var it = Hl(Ke);
        if (it === null)
          throw new Error("Unable to find node on an unmounted component.");
        return it !== Ke ? null : Ke;
      }
      for (var ut = Ke, pt = Xe; ; ) {
        var Yr = ut.return;
        if (Yr === null)
          break;
        var Qr = Yr.alternate;
        if (Qr === null) {
          var ni = Yr.return;
          if (ni !== null) {
            ut = pt = ni;
            continue;
          }
          break;
        }
        if (Yr.child === Qr.child) {
          for (var oi = Yr.child; oi; ) {
            if (oi === ut)
              return Pl(Yr), Ke;
            if (oi === pt)
              return Pl(Yr), Xe;
            oi = oi.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (ut.return !== pt.return)
          ut = Yr, pt = Qr;
        else {
          for (var vi = !1, Ei = Yr.child; Ei; ) {
            if (Ei === ut) {
              vi = !0, ut = Yr, pt = Qr;
              break;
            }
            if (Ei === pt) {
              vi = !0, pt = Yr, ut = Qr;
              break;
            }
            Ei = Ei.sibling;
          }
          if (!vi) {
            for (Ei = Qr.child; Ei; ) {
              if (Ei === ut) {
                vi = !0, ut = Qr, pt = Yr;
                break;
              }
              if (Ei === pt) {
                vi = !0, pt = Qr, ut = Yr;
                break;
              }
              Ei = Ei.sibling;
            }
            if (!vi)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (ut.alternate !== pt)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (ut.tag !== st)
        throw new Error("Unable to find node on an unmounted component.");
      return ut.stateNode.current === ut ? Ke : Xe;
    }
    function ou(Ke) {
      var Xe = Zo(Ke);
      return Xe !== null ? Bm(Xe) : null;
    }
    function Bm(Ke) {
      if (Ke.tag === lt || Ke.tag === ft)
        return Ke;
      for (var Xe = Ke.child; Xe !== null; ) {
        var it = Bm(Xe);
        if (it !== null)
          return it;
        Xe = Xe.sibling;
      }
      return null;
    }
    function qv(Ke) {
      var Xe = Zo(Ke);
      return Xe !== null ? Bp(Xe) : null;
    }
    function Bp(Ke) {
      if (Ke.tag === lt || Ke.tag === ft)
        return Ke;
      for (var Xe = Ke.child; Xe !== null; ) {
        if (Xe.tag !== ot) {
          var it = Bp(Xe);
          if (it !== null)
            return it;
        }
        Xe = Xe.sibling;
      }
      return null;
    }
    var Up = Z.unstable_scheduleCallback, Yv = Z.unstable_cancelCallback, Gp = Z.unstable_shouldYield, Xv = Z.unstable_requestPaint, oa = Z.unstable_now, Um = Z.unstable_getCurrentPriorityLevel, Hp = Z.unstable_ImmediatePriority, Vl = Z.unstable_UserBlockingPriority, ku = Z.unstable_NormalPriority, zp = Z.unstable_LowPriority, jc = Z.unstable_IdlePriority, Gm = Z.unstable_yieldValue, Hm = Z.unstable_setDisableYieldValue, Wc = null, $a = null, vs = null, ya = !1, ja = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function zm(Ke) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var Xe = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (Xe.isDisabled)
        return !0;
      if (!Xe.supportsFiber)
        return be("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        qi && (Ke = vo({}, Ke, {
          getLaneLabelMap: qc,
          injectProfilingHooks: sc
        })), Wc = Xe.inject(Ke), $a = Xe;
      } catch (it) {
        be("React instrumentation encountered an error: %s.", it);
      }
      return !!Xe.checkDCE;
    }
    function Zv(Ke, Xe) {
      if ($a && typeof $a.onScheduleFiberRoot == "function")
        try {
          $a.onScheduleFiberRoot(Wc, Ke, Xe);
        } catch (it) {
          ya || (ya = !0, be("React instrumentation encountered an error: %s", it));
        }
    }
    function ic(Ke, Xe) {
      if ($a && typeof $a.onCommitFiberRoot == "function")
        try {
          var it = (Ke.current.flags & io) === io;
          if (us) {
            var ut;
            switch (Xe) {
              case nl:
                ut = Hp;
                break;
              case Wa:
                ut = Vl;
                break;
              case ac:
                ut = ku;
                break;
              case zh:
                ut = jc;
                break;
              default:
                ut = ku;
                break;
            }
            $a.onCommitFiberRoot(Wc, Ke, ut, it);
          }
        } catch (pt) {
          ya || (ya = !0, be("React instrumentation encountered an error: %s", pt));
        }
    }
    function Kc(Ke) {
      if ($a && typeof $a.onPostCommitFiberRoot == "function")
        try {
          $a.onPostCommitFiberRoot(Wc, Ke);
        } catch (Xe) {
          ya || (ya = !0, be("React instrumentation encountered an error: %s", Xe));
        }
    }
    function Vm(Ke) {
      if ($a && typeof $a.onCommitFiberUnmount == "function")
        try {
          $a.onCommitFiberUnmount(Wc, Ke);
        } catch (Xe) {
          ya || (ya = !0, be("React instrumentation encountered an error: %s", Xe));
        }
    }
    function La(Ke) {
      if (typeof Gm == "function" && (Hm(Ke), ve(Ke)), $a && typeof $a.setStrictMode == "function")
        try {
          $a.setStrictMode(Wc, Ke);
        } catch (Xe) {
          ya || (ya = !0, be("React instrumentation encountered an error: %s", Xe));
        }
    }
    function sc(Ke) {
      vs = Ke;
    }
    function qc() {
      {
        for (var Ke = /* @__PURE__ */ new Map(), Xe = 1, it = 0; it < Qo; it++) {
          var ut = T1(Xe);
          Ke.set(Xe, ut), Xe *= 2;
        }
        return Ke;
      }
    }
    function Vp(Ke) {
      vs !== null && typeof vs.markCommitStarted == "function" && vs.markCommitStarted(Ke);
    }
    function jm() {
      vs !== null && typeof vs.markCommitStopped == "function" && vs.markCommitStopped();
    }
    function Yc(Ke) {
      vs !== null && typeof vs.markComponentRenderStarted == "function" && vs.markComponentRenderStarted(Ke);
    }
    function Ld() {
      vs !== null && typeof vs.markComponentRenderStopped == "function" && vs.markComponentRenderStopped();
    }
    function Qv(Ke) {
      vs !== null && typeof vs.markComponentPassiveEffectMountStarted == "function" && vs.markComponentPassiveEffectMountStarted(Ke);
    }
    function Wm() {
      vs !== null && typeof vs.markComponentPassiveEffectMountStopped == "function" && vs.markComponentPassiveEffectMountStopped();
    }
    function jp(Ke) {
      vs !== null && typeof vs.markComponentPassiveEffectUnmountStarted == "function" && vs.markComponentPassiveEffectUnmountStarted(Ke);
    }
    function Jv() {
      vs !== null && typeof vs.markComponentPassiveEffectUnmountStopped == "function" && vs.markComponentPassiveEffectUnmountStopped();
    }
    function ey(Ke) {
      vs !== null && typeof vs.markComponentLayoutEffectMountStarted == "function" && vs.markComponentLayoutEffectMountStarted(Ke);
    }
    function ty() {
      vs !== null && typeof vs.markComponentLayoutEffectMountStopped == "function" && vs.markComponentLayoutEffectMountStopped();
    }
    function Wp(Ke) {
      vs !== null && typeof vs.markComponentLayoutEffectUnmountStarted == "function" && vs.markComponentLayoutEffectUnmountStarted(Ke);
    }
    function Af() {
      vs !== null && typeof vs.markComponentLayoutEffectUnmountStopped == "function" && vs.markComponentLayoutEffectUnmountStopped();
    }
    function Kp(Ke, Xe, it) {
      vs !== null && typeof vs.markComponentErrored == "function" && vs.markComponentErrored(Ke, Xe, it);
    }
    function ny(Ke, Xe, it) {
      vs !== null && typeof vs.markComponentSuspended == "function" && vs.markComponentSuspended(Ke, Xe, it);
    }
    function ry(Ke) {
      vs !== null && typeof vs.markLayoutEffectsStarted == "function" && vs.markLayoutEffectsStarted(Ke);
    }
    function Lf() {
      vs !== null && typeof vs.markLayoutEffectsStopped == "function" && vs.markLayoutEffectsStopped();
    }
    function iy(Ke) {
      vs !== null && typeof vs.markPassiveEffectsStarted == "function" && vs.markPassiveEffectsStarted(Ke);
    }
    function kh() {
      vs !== null && typeof vs.markPassiveEffectsStopped == "function" && vs.markPassiveEffectsStopped();
    }
    function wu(Ke) {
      vs !== null && typeof vs.markRenderStarted == "function" && vs.markRenderStarted(Ke);
    }
    function Nh() {
      vs !== null && typeof vs.markRenderYielded == "function" && vs.markRenderYielded();
    }
    function If() {
      vs !== null && typeof vs.markRenderStopped == "function" && vs.markRenderStopped();
    }
    function Id(Ke) {
      vs !== null && typeof vs.markRenderScheduled == "function" && vs.markRenderScheduled(Ke);
    }
    function Km(Ke, Xe) {
      vs !== null && typeof vs.markForceUpdateScheduled == "function" && vs.markForceUpdateScheduled(Ke, Xe);
    }
    function Xc(Ke, Xe) {
      vs !== null && typeof vs.markStateUpdateScheduled == "function" && vs.markStateUpdateScheduled(Ke, Xe);
    }
    var Xs = (
      /*                         */
      0
    ), Eo = (
      /*                 */
      1
    ), Qs = (
      /*                    */
      2
    ), aa = (
      /*               */
      8
    ), au = (
      /*              */
      16
    ), qp = Math.clz32 ? Math.clz32 : Pd, Yp = Math.log, qm = Math.LN2;
    function Pd(Ke) {
      var Xe = Ke >>> 0;
      return Xe === 0 ? 32 : 31 - (Yp(Xe) / qm | 0) | 0;
    }
    var Qo = 31, Ji = (
      /*                        */
      0
    ), wo = (
      /*                          */
      0
    ), to = (
      /*                        */
      1
    ), Nu = (
      /*    */
      2
    ), jl = (
      /*             */
      4
    ), Dd = (
      /*            */
      8
    ), Jo = (
      /*                     */
      16
    ), Od = (
      /*                */
      32
    ), Zc = (
      /*                       */
      4194240
    ), Md = (
      /*                        */
      64
    ), lu = (
      /*                        */
      128
    ), Dl = (
      /*                        */
      256
    ), kd = (
      /*                        */
      512
    ), Fh = (
      /*                        */
      1024
    ), $h = (
      /*                        */
      2048
    ), Xp = (
      /*                        */
      4096
    ), Zp = (
      /*                        */
      8192
    ), Qp = (
      /*                        */
      16384
    ), Jp = (
      /*                       */
      32768
    ), eg = (
      /*                       */
      65536
    ), tg = (
      /*                       */
      131072
    ), ng = (
      /*                       */
      262144
    ), rg = (
      /*                       */
      524288
    ), Nd = (
      /*                       */
      1048576
    ), ig = (
      /*                       */
      2097152
    ), Fd = (
      /*                            */
      130023424
    ), oc = (
      /*                             */
      4194304
    ), sg = (
      /*                             */
      8388608
    ), Bh = (
      /*                             */
      16777216
    ), og = (
      /*                             */
      33554432
    ), ag = (
      /*                             */
      67108864
    ), Ym = oc, Pf = (
      /*          */
      134217728
    ), lg = (
      /*                          */
      268435455
    ), Df = (
      /*               */
      268435456
    ), Qc = (
      /*                        */
      536870912
    ), Ol = (
      /*                   */
      1073741824
    );
    function T1(Ke) {
      {
        if (Ke & to)
          return "Sync";
        if (Ke & Nu)
          return "InputContinuousHydration";
        if (Ke & jl)
          return "InputContinuous";
        if (Ke & Dd)
          return "DefaultHydration";
        if (Ke & Jo)
          return "Default";
        if (Ke & Od)
          return "TransitionHydration";
        if (Ke & Zc)
          return "Transition";
        if (Ke & Fd)
          return "Retry";
        if (Ke & Pf)
          return "SelectiveHydration";
        if (Ke & Df)
          return "IdleHydration";
        if (Ke & Qc)
          return "Idle";
        if (Ke & Ol)
          return "Offscreen";
      }
    }
    var jo = -1, ug = Md, cg = oc;
    function Of(Ke) {
      switch (wa(Ke)) {
        case to:
          return to;
        case Nu:
          return Nu;
        case jl:
          return jl;
        case Dd:
          return Dd;
        case Jo:
          return Jo;
        case Od:
          return Od;
        case Md:
        case lu:
        case Dl:
        case kd:
        case Fh:
        case $h:
        case Xp:
        case Zp:
        case Qp:
        case Jp:
        case eg:
        case tg:
        case ng:
        case rg:
        case Nd:
        case ig:
          return Ke & Zc;
        case oc:
        case sg:
        case Bh:
        case og:
        case ag:
          return Ke & Fd;
        case Pf:
          return Pf;
        case Df:
          return Df;
        case Qc:
          return Qc;
        case Ol:
          return Ol;
        default:
          return be("Should have found matching lanes. This is a bug in React."), Ke;
      }
    }
    function Uh(Ke, Xe) {
      var it = Ke.pendingLanes;
      if (it === Ji)
        return Ji;
      var ut = Ji, pt = Ke.suspendedLanes, Yr = Ke.pingedLanes, Qr = it & lg;
      if (Qr !== Ji) {
        var ni = Qr & ~pt;
        if (ni !== Ji)
          ut = Of(ni);
        else {
          var oi = Qr & Yr;
          oi !== Ji && (ut = Of(oi));
        }
      } else {
        var vi = it & ~pt;
        vi !== Ji ? ut = Of(vi) : Yr !== Ji && (ut = Of(Yr));
      }
      if (ut === Ji)
        return Ji;
      if (Xe !== Ji && Xe !== ut && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (Xe & pt) === Ji) {
        var Ei = wa(ut), Ni = wa(Xe);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          Ei >= Ni || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          Ei === Jo && (Ni & Zc) !== Ji
        )
          return Xe;
      }
      (ut & jl) !== Ji && (ut |= it & Jo);
      var Mi = Ke.entangledLanes;
      if (Mi !== Ji)
        for (var zi = Ke.entanglements, ji = ut & Mi; ji > 0; ) {
          var Xi = Jc(ji), Cs = 1 << Xi;
          ut |= zi[Xi], ji &= ~Cs;
        }
      return ut;
    }
    function sy(Ke, Xe) {
      for (var it = Ke.eventTimes, ut = jo; Xe > 0; ) {
        var pt = Jc(Xe), Yr = 1 << pt, Qr = it[pt];
        Qr > ut && (ut = Qr), Xe &= ~Yr;
      }
      return ut;
    }
    function dg(Ke, Xe) {
      switch (Ke) {
        case to:
        case Nu:
        case jl:
          return Xe + 250;
        case Dd:
        case Jo:
        case Od:
        case Md:
        case lu:
        case Dl:
        case kd:
        case Fh:
        case $h:
        case Xp:
        case Zp:
        case Qp:
        case Jp:
        case eg:
        case tg:
        case ng:
        case rg:
        case Nd:
        case ig:
          return Xe + 5e3;
        case oc:
        case sg:
        case Bh:
        case og:
        case ag:
          return jo;
        case Pf:
        case Df:
        case Qc:
        case Ol:
          return jo;
        default:
          return be("Should have found matching lanes. This is a bug in React."), jo;
      }
    }
    function b1(Ke, Xe) {
      for (var it = Ke.pendingLanes, ut = Ke.suspendedLanes, pt = Ke.pingedLanes, Yr = Ke.expirationTimes, Qr = it; Qr > 0; ) {
        var ni = Jc(Qr), oi = 1 << ni, vi = Yr[ni];
        vi === jo ? ((oi & ut) === Ji || (oi & pt) !== Ji) && (Yr[ni] = dg(oi, Xe)) : vi <= Xe && (Ke.expiredLanes |= oi), Qr &= ~oi;
      }
    }
    function S1(Ke) {
      return Of(Ke.pendingLanes);
    }
    function Xm(Ke) {
      var Xe = Ke.pendingLanes & ~Ol;
      return Xe !== Ji ? Xe : Xe & Ol ? Ol : Ji;
    }
    function Mf(Ke) {
      return (Ke & to) !== Ji;
    }
    function Gh(Ke) {
      return (Ke & lg) !== Ji;
    }
    function fg(Ke) {
      return (Ke & Fd) === Ke;
    }
    function _1(Ke) {
      var Xe = to | jl | Jo;
      return (Ke & Xe) === Ji;
    }
    function oy(Ke) {
      return (Ke & Zc) === Ke;
    }
    function Hh(Ke, Xe) {
      var it = Nu | jl | Dd | Jo;
      return (Xe & it) !== Ji;
    }
    function ay(Ke, Xe) {
      return (Xe & Ke.expiredLanes) !== Ji;
    }
    function Zm(Ke) {
      return (Ke & Zc) !== Ji;
    }
    function Qm() {
      var Ke = ug;
      return ug <<= 1, (ug & Zc) === Ji && (ug = Md), Ke;
    }
    function w1() {
      var Ke = cg;
      return cg <<= 1, (cg & Fd) === Ji && (cg = oc), Ke;
    }
    function wa(Ke) {
      return Ke & -Ke;
    }
    function Ia(Ke) {
      return wa(Ke);
    }
    function Jc(Ke) {
      return 31 - qp(Ke);
    }
    function hg(Ke) {
      return Jc(Ke);
    }
    function Ml(Ke, Xe) {
      return (Ke & Xe) !== Ji;
    }
    function $d(Ke, Xe) {
      return (Ke & Xe) === Xe;
    }
    function go(Ke, Xe) {
      return Ke | Xe;
    }
    function kf(Ke, Xe) {
      return Ke & ~Xe;
    }
    function Jm(Ke, Xe) {
      return Ke & Xe;
    }
    function ly(Ke) {
      return Ke;
    }
    function uy(Ke, Xe) {
      return Ke !== wo && Ke < Xe ? Ke : Xe;
    }
    function pg(Ke) {
      for (var Xe = [], it = 0; it < Qo; it++)
        Xe.push(Ke);
      return Xe;
    }
    function Bd(Ke, Xe, it) {
      Ke.pendingLanes |= Xe, Xe !== Qc && (Ke.suspendedLanes = Ji, Ke.pingedLanes = Ji);
      var ut = Ke.eventTimes, pt = hg(Xe);
      ut[pt] = it;
    }
    function e0(Ke, Xe) {
      Ke.suspendedLanes |= Xe, Ke.pingedLanes &= ~Xe;
      for (var it = Ke.expirationTimes, ut = Xe; ut > 0; ) {
        var pt = Jc(ut), Yr = 1 << pt;
        it[pt] = jo, ut &= ~Yr;
      }
    }
    function t0(Ke, Xe, it) {
      Ke.pingedLanes |= Ke.suspendedLanes & Xe;
    }
    function n0(Ke, Xe) {
      var it = Ke.pendingLanes & ~Xe;
      Ke.pendingLanes = Xe, Ke.suspendedLanes = Ji, Ke.pingedLanes = Ji, Ke.expiredLanes &= Xe, Ke.mutableReadLanes &= Xe, Ke.entangledLanes &= Xe;
      for (var ut = Ke.entanglements, pt = Ke.eventTimes, Yr = Ke.expirationTimes, Qr = it; Qr > 0; ) {
        var ni = Jc(Qr), oi = 1 << ni;
        ut[ni] = Ji, pt[ni] = jo, Yr[ni] = jo, Qr &= ~oi;
      }
    }
    function Nf(Ke, Xe) {
      for (var it = Ke.entangledLanes |= Xe, ut = Ke.entanglements, pt = it; pt; ) {
        var Yr = Jc(pt), Qr = 1 << Yr;
        // Is this one of the newly entangled lanes?
        Qr & Xe | // Is this lane transitively entangled with the newly entangled lanes?
        ut[Yr] & Xe && (ut[Yr] |= Xe), pt &= ~Qr;
      }
    }
    function C1(Ke, Xe) {
      var it = wa(Xe), ut;
      switch (it) {
        case jl:
          ut = Nu;
          break;
        case Jo:
          ut = Dd;
          break;
        case Md:
        case lu:
        case Dl:
        case kd:
        case Fh:
        case $h:
        case Xp:
        case Zp:
        case Qp:
        case Jp:
        case eg:
        case tg:
        case ng:
        case rg:
        case Nd:
        case ig:
        case oc:
        case sg:
        case Bh:
        case og:
        case ag:
          ut = Od;
          break;
        case Qc:
          ut = Df;
          break;
        default:
          ut = wo;
          break;
      }
      return (ut & (Ke.suspendedLanes | Xe)) !== wo ? wo : ut;
    }
    function r0(Ke, Xe, it) {
      if (ja)
        for (var ut = Ke.pendingUpdatersLaneMap; it > 0; ) {
          var pt = hg(it), Yr = 1 << pt, Qr = ut[pt];
          Qr.add(Xe), it &= ~Yr;
        }
    }
    function gg(Ke, Xe) {
      if (ja)
        for (var it = Ke.pendingUpdatersLaneMap, ut = Ke.memoizedUpdaters; Xe > 0; ) {
          var pt = hg(Xe), Yr = 1 << pt, Qr = it[pt];
          Qr.size > 0 && (Qr.forEach(function(ni) {
            var oi = ni.alternate;
            (oi === null || !ut.has(oi)) && ut.add(ni);
          }), Qr.clear()), Xe &= ~Yr;
        }
    }
    function i0(Ke, Xe) {
      return null;
    }
    var nl = to, Wa = jl, ac = Jo, zh = Qc, Ud = wo;
    function uu() {
      return Ud;
    }
    function Pa(Ke) {
      Ud = Ke;
    }
    function Vh(Ke, Xe) {
      var it = Ud;
      try {
        return Ud = Ke, Xe();
      } finally {
        Ud = it;
      }
    }
    function rl(Ke, Xe) {
      return Ke !== 0 && Ke < Xe ? Ke : Xe;
    }
    function R1(Ke, Xe) {
      return Ke === 0 || Ke > Xe ? Ke : Xe;
    }
    function s0(Ke, Xe) {
      return Ke !== 0 && Ke < Xe;
    }
    function jh(Ke) {
      var Xe = wa(Ke);
      return s0(nl, Xe) ? s0(Wa, Xe) ? Gh(Xe) ? ac : zh : Wa : nl;
    }
    function Da(Ke) {
      var Xe = Ke.current.memoizedState;
      return Xe.isDehydrated;
    }
    var cy;
    function As(Ke) {
      cy = Ke;
    }
    function Ff(Ke) {
      cy(Ke);
    }
    var Wh;
    function dy(Ke) {
      Wh = Ke;
    }
    var fy;
    function Kh(Ke) {
      fy = Ke;
    }
    var qh;
    function o0(Ke) {
      qh = Ke;
    }
    var a0;
    function hy(Ke) {
      a0 = Ke;
    }
    var mg = !1, $f = [], Fu = null, ra = null, Ba = null, cu = /* @__PURE__ */ new Map(), Bf = /* @__PURE__ */ new Map(), lc = [], Cu = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function py(Ke) {
      return Cu.indexOf(Ke) > -1;
    }
    function $u(Ke, Xe, it, ut, pt) {
      return {
        blockedOn: Ke,
        domEventName: Xe,
        eventSystemFlags: it,
        nativeEvent: pt,
        targetContainers: [ut]
      };
    }
    function gy(Ke, Xe) {
      switch (Ke) {
        case "focusin":
        case "focusout":
          Fu = null;
          break;
        case "dragenter":
        case "dragleave":
          ra = null;
          break;
        case "mouseover":
        case "mouseout":
          Ba = null;
          break;
        case "pointerover":
        case "pointerout": {
          var it = Xe.pointerId;
          cu.delete(it);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var ut = Xe.pointerId;
          Bf.delete(ut);
          break;
        }
      }
    }
    function Uf(Ke, Xe, it, ut, pt, Yr) {
      if (Ke === null || Ke.nativeEvent !== Yr) {
        var Qr = $u(Xe, it, ut, pt, Yr);
        if (Xe !== null) {
          var ni = Zf(Xe);
          ni !== null && Wh(ni);
        }
        return Qr;
      }
      Ke.eventSystemFlags |= ut;
      var oi = Ke.targetContainers;
      return pt !== null && oi.indexOf(pt) === -1 && oi.push(pt), Ke;
    }
    function vy(Ke, Xe, it, ut, pt) {
      switch (Xe) {
        case "focusin": {
          var Yr = pt;
          return Fu = Uf(Fu, Ke, Xe, it, ut, Yr), !0;
        }
        case "dragenter": {
          var Qr = pt;
          return ra = Uf(ra, Ke, Xe, it, ut, Qr), !0;
        }
        case "mouseover": {
          var ni = pt;
          return Ba = Uf(Ba, Ke, Xe, it, ut, ni), !0;
        }
        case "pointerover": {
          var oi = pt, vi = oi.pointerId;
          return cu.set(vi, Uf(cu.get(vi) || null, Ke, Xe, it, ut, oi)), !0;
        }
        case "gotpointercapture": {
          var Ei = pt, Ni = Ei.pointerId;
          return Bf.set(Ni, Uf(Bf.get(Ni) || null, Ke, Xe, it, ut, Ei)), !0;
        }
      }
      return !1;
    }
    function l0(Ke) {
      var Xe = rp(Ke.target);
      if (Xe !== null) {
        var it = Hl(Xe);
        if (it !== null) {
          var ut = it.tag;
          if (ut === ei) {
            var pt = Fm(it);
            if (pt !== null) {
              Ke.blockedOn = pt, a0(Ke.priority, function() {
                fy(it);
              });
              return;
            }
          } else if (ut === st) {
            var Yr = it.stateNode;
            if (Da(Yr)) {
              Ke.blockedOn = $p(it);
              return;
            }
          }
        }
      }
      Ke.blockedOn = null;
    }
    function yy(Ke) {
      for (var Xe = qh(), it = {
        blockedOn: null,
        target: Ke,
        priority: Xe
      }, ut = 0; ut < lc.length && s0(Xe, lc[ut].priority); ut++)
        ;
      lc.splice(ut, 0, it), ut === 0 && l0(it);
    }
    function vg(Ke) {
      if (Ke.blockedOn !== null)
        return !1;
      for (var Xe = Ke.targetContainers; Xe.length > 0; ) {
        var it = Xe[0], ut = Gd(Ke.domEventName, Ke.eventSystemFlags, it, Ke.nativeEvent);
        if (ut === null) {
          var pt = Ke.nativeEvent, Yr = new pt.constructor(pt.type, pt);
          Rh(Yr), pt.target.dispatchEvent(Yr), v1();
        } else {
          var Qr = Zf(ut);
          return Qr !== null && Wh(Qr), Ke.blockedOn = ut, !1;
        }
        Xe.shift();
      }
      return !0;
    }
    function Yh(Ke, Xe, it) {
      vg(Ke) && it.delete(Xe);
    }
    function u0() {
      mg = !1, Fu !== null && vg(Fu) && (Fu = null), ra !== null && vg(ra) && (ra = null), Ba !== null && vg(Ba) && (Ba = null), cu.forEach(Yh), Bf.forEach(Yh);
    }
    function il(Ke, Xe) {
      Ke.blockedOn === Xe && (Ke.blockedOn = null, mg || (mg = !0, Z.unstable_scheduleCallback(Z.unstable_NormalPriority, u0)));
    }
    function bo(Ke) {
      if ($f.length > 0) {
        il($f[0], Ke);
        for (var Xe = 1; Xe < $f.length; Xe++) {
          var it = $f[Xe];
          it.blockedOn === Ke && (it.blockedOn = null);
        }
      }
      Fu !== null && il(Fu, Ke), ra !== null && il(ra, Ke), Ba !== null && il(Ba, Ke);
      var ut = function(ni) {
        return il(ni, Ke);
      };
      cu.forEach(ut), Bf.forEach(ut);
      for (var pt = 0; pt < lc.length; pt++) {
        var Yr = lc[pt];
        Yr.blockedOn === Ke && (Yr.blockedOn = null);
      }
      for (; lc.length > 0; ) {
        var Qr = lc[0];
        if (Qr.blockedOn !== null)
          break;
        l0(Qr), Qr.blockedOn === null && lc.shift();
      }
    }
    var la = ee.ReactCurrentBatchConfig, ga = !0;
    function Ua(Ke) {
      ga = !!Ke;
    }
    function Wl() {
      return ga;
    }
    function Gf(Ke, Xe, it) {
      var ut = hl(Xe), pt;
      switch (ut) {
        case nl:
          pt = Oa;
          break;
        case Wa:
          pt = Xh;
          break;
        case ac:
        default:
          pt = uc;
          break;
      }
      return pt.bind(null, Xe, it, Ke);
    }
    function Oa(Ke, Xe, it, ut) {
      var pt = uu(), Yr = la.transition;
      la.transition = null;
      try {
        Pa(nl), uc(Ke, Xe, it, ut);
      } finally {
        Pa(pt), la.transition = Yr;
      }
    }
    function Xh(Ke, Xe, it, ut) {
      var pt = uu(), Yr = la.transition;
      la.transition = null;
      try {
        Pa(Wa), uc(Ke, Xe, it, ut);
      } finally {
        Pa(pt), la.transition = Yr;
      }
    }
    function uc(Ke, Xe, it, ut) {
      ga && yg(Ke, Xe, it, ut);
    }
    function yg(Ke, Xe, it, ut) {
      var pt = Gd(Ke, Xe, it, ut);
      if (pt === null) {
        K1(Ke, Xe, ut, Hf, it), gy(Ke, ut);
        return;
      }
      if (vy(pt, Ke, Xe, it, ut)) {
        ut.stopPropagation();
        return;
      }
      if (gy(Ke, ut), Xe & Sd && py(Ke)) {
        for (; pt !== null; ) {
          var Yr = Zf(pt);
          Yr !== null && Ff(Yr);
          var Qr = Gd(Ke, Xe, it, ut);
          if (Qr === null && K1(Ke, Xe, ut, Hf, it), Qr === pt)
            break;
          pt = Qr;
        }
        pt !== null && ut.stopPropagation();
        return;
      }
      K1(Ke, Xe, ut, null, it);
    }
    var Hf = null;
    function Gd(Ke, Xe, it, ut) {
      Hf = null;
      var pt = Op(ut), Yr = rp(pt);
      if (Yr !== null) {
        var Qr = Hl(Yr);
        if (Qr === null)
          Yr = null;
        else {
          var ni = Qr.tag;
          if (ni === ei) {
            var oi = Fm(Qr);
            if (oi !== null)
              return oi;
            Yr = null;
          } else if (ni === st) {
            var vi = Qr.stateNode;
            if (Da(vi))
              return $p(Qr);
            Yr = null;
          } else
            Qr !== Yr && (Yr = null);
        }
      }
      return Hf = Yr, null;
    }
    function hl(Ke) {
      switch (Ke) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return nl;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Wa;
        case "message": {
          var Xe = Um();
          switch (Xe) {
            case Hp:
              return nl;
            case Vl:
              return Wa;
            case ku:
            case zp:
              return ac;
            case jc:
              return zh;
            default:
              return ac;
          }
        }
        default:
          return ac;
      }
    }
    function c0(Ke, Xe, it) {
      return Ke.addEventListener(Xe, it, !1), it;
    }
    function zf(Ke, Xe, it) {
      return Ke.addEventListener(Xe, it, !0), it;
    }
    function cc(Ke, Xe, it, ut) {
      return Ke.addEventListener(Xe, it, {
        capture: !0,
        passive: ut
      }), it;
    }
    function Eg(Ke, Xe, it, ut) {
      return Ke.addEventListener(Xe, it, {
        passive: ut
      }), it;
    }
    var Hd = null, Bu = null, ed = null;
    function nd(Ke) {
      return Hd = Ke, Bu = Tg(), !0;
    }
    function xg() {
      Hd = null, Bu = null, ed = null;
    }
    function Vf() {
      if (ed)
        return ed;
      var Ke, Xe = Bu, it = Xe.length, ut, pt = Tg(), Yr = pt.length;
      for (Ke = 0; Ke < it && Xe[Ke] === pt[Ke]; Ke++)
        ;
      var Qr = it - Ke;
      for (ut = 1; ut <= Qr && Xe[it - ut] === pt[Yr - ut]; ut++)
        ;
      var ni = ut > 1 ? 1 - ut : void 0;
      return ed = pt.slice(Ke, ni), ed;
    }
    function Tg() {
      return "value" in Hd ? Hd.value : Hd.textContent;
    }
    function zd(Ke) {
      var Xe, it = Ke.keyCode;
      return "charCode" in Ke ? (Xe = Ke.charCode, Xe === 0 && it === 13 && (Xe = 13)) : Xe = it, Xe === 10 && (Xe = 13), Xe >= 32 || Xe === 13 ? Xe : 0;
    }
    function Vd() {
      return !0;
    }
    function sl() {
      return !1;
    }
    function Ca(Ke) {
      function Xe(it, ut, pt, Yr, Qr) {
        this._reactName = it, this._targetInst = pt, this.type = ut, this.nativeEvent = Yr, this.target = Qr, this.currentTarget = null;
        for (var ni in Ke)
          if (Ke.hasOwnProperty(ni)) {
            var oi = Ke[ni];
            oi ? this[ni] = oi(Yr) : this[ni] = Yr[ni];
          }
        var vi = Yr.defaultPrevented != null ? Yr.defaultPrevented : Yr.returnValue === !1;
        return vi ? this.isDefaultPrevented = Vd : this.isDefaultPrevented = sl, this.isPropagationStopped = sl, this;
      }
      return vo(Xe.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var it = this.nativeEvent;
          it && (it.preventDefault ? it.preventDefault() : typeof it.returnValue != "unknown" && (it.returnValue = !1), this.isDefaultPrevented = Vd);
        },
        stopPropagation: function() {
          var it = this.nativeEvent;
          it && (it.stopPropagation ? it.stopPropagation() : typeof it.cancelBubble != "unknown" && (it.cancelBubble = !0), this.isPropagationStopped = Vd);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Vd
      }), Xe;
    }
    var ol = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(Ke) {
        return Ke.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, al = Ca(ol), jf = vo({}, ol, {
      view: 0,
      detail: 0
    }), d0 = Ca(jf), Zh, f0, du;
    function Ey(Ke) {
      Ke !== du && (du && Ke.type === "mousemove" ? (Zh = Ke.screenX - du.screenX, f0 = Ke.screenY - du.screenY) : (Zh = 0, f0 = 0), du = Ke);
    }
    var Wf = vo({}, jf, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: _g,
      button: 0,
      buttons: 0,
      relatedTarget: function(Ke) {
        return Ke.relatedTarget === void 0 ? Ke.fromElement === Ke.srcElement ? Ke.toElement : Ke.fromElement : Ke.relatedTarget;
      },
      movementX: function(Ke) {
        return "movementX" in Ke ? Ke.movementX : (Ey(Ke), Zh);
      },
      movementY: function(Ke) {
        return "movementY" in Ke ? Ke.movementY : f0;
      }
    }), rd = Ca(Wf), h0 = vo({}, Wf, {
      dataTransfer: 0
    }), jd = Ca(h0), xy = vo({}, jf, {
      relatedTarget: 0
    }), bg = Ca(xy), p0 = vo({}, ol, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Sg = Ca(p0), A1 = vo({}, ol, {
      clipboardData: function(Ke) {
        return "clipboardData" in Ke ? Ke.clipboardData : window.clipboardData;
      }
    }), L1 = Ca(A1), Ty = vo({}, ol, {
      data: 0
    }), g0 = Ca(Ty), Wd = g0, I1 = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, Kf = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function by(Ke) {
      if (Ke.key) {
        var Xe = I1[Ke.key] || Ke.key;
        if (Xe !== "Unidentified")
          return Xe;
      }
      if (Ke.type === "keypress") {
        var it = zd(Ke);
        return it === 13 ? "Enter" : String.fromCharCode(it);
      }
      return Ke.type === "keydown" || Ke.type === "keyup" ? Kf[Ke.keyCode] || "Unidentified" : "";
    }
    var ma = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function P1(Ke) {
      var Xe = this, it = Xe.nativeEvent;
      if (it.getModifierState)
        return it.getModifierState(Ke);
      var ut = ma[Ke];
      return ut ? !!it[ut] : !1;
    }
    function _g(Ke) {
      return P1;
    }
    var D1 = vo({}, jf, {
      key: by,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: _g,
      // Legacy Interface
      charCode: function(Ke) {
        return Ke.type === "keypress" ? zd(Ke) : 0;
      },
      keyCode: function(Ke) {
        return Ke.type === "keydown" || Ke.type === "keyup" ? Ke.keyCode : 0;
      },
      which: function(Ke) {
        return Ke.type === "keypress" ? zd(Ke) : Ke.type === "keydown" || Ke.type === "keyup" ? Ke.keyCode : 0;
      }
    }), O1 = Ca(D1), Sy = vo({}, Wf, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), m0 = Ca(Sy), M1 = vo({}, jf, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: _g
    }), fu = Ca(M1), v0 = vo({}, ol, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), k1 = Ca(v0), id = vo({}, Wf, {
      deltaX: function(Ke) {
        return "deltaX" in Ke ? Ke.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in Ke ? -Ke.wheelDeltaX : 0
        );
      },
      deltaY: function(Ke) {
        return "deltaY" in Ke ? Ke.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in Ke ? -Ke.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in Ke ? -Ke.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), wg = Ca(id), Kd = [9, 13, 27, 32], Qh = 229, Jh = ii && "CompositionEvent" in window, qd = null;
    ii && "documentMode" in document && (qd = document.documentMode);
    var N1 = ii && "TextEvent" in window && !qd, Cg = ii && (!Jh || qd && qd > 8 && qd <= 11), _y = 32, y0 = String.fromCharCode(_y);
    function wy() {
      Vs("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), Vs("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Vs("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Vs("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var ep = !1;
    function Rg(Ke) {
      return (Ke.ctrlKey || Ke.altKey || Ke.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(Ke.ctrlKey && Ke.altKey);
    }
    function Cy(Ke) {
      switch (Ke) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function E0(Ke, Xe) {
      return Ke === "keydown" && Xe.keyCode === Qh;
    }
    function Ry(Ke, Xe) {
      switch (Ke) {
        case "keyup":
          return Kd.indexOf(Xe.keyCode) !== -1;
        case "keydown":
          return Xe.keyCode !== Qh;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function x0(Ke) {
      var Xe = Ke.detail;
      return typeof Xe == "object" && "data" in Xe ? Xe.data : null;
    }
    function Ag(Ke) {
      return Ke.locale === "ko";
    }
    var dc = !1;
    function T0(Ke, Xe, it, ut, pt) {
      var Yr, Qr;
      if (Jh ? Yr = Cy(Xe) : dc ? Ry(Xe, ut) && (Yr = "onCompositionEnd") : E0(Xe, ut) && (Yr = "onCompositionStart"), !Yr)
        return null;
      Cg && !Ag(ut) && (!dc && Yr === "onCompositionStart" ? dc = nd(pt) : Yr === "onCompositionEnd" && dc && (Qr = Vf()));
      var ni = Dy(it, Yr);
      if (ni.length > 0) {
        var oi = new g0(Yr, Xe, null, ut, pt);
        if (Ke.push({
          event: oi,
          listeners: ni
        }), Qr)
          oi.data = Qr;
        else {
          var vi = x0(ut);
          vi !== null && (oi.data = vi);
        }
      }
    }
    function Lg(Ke, Xe) {
      switch (Ke) {
        case "compositionend":
          return x0(Xe);
        case "keypress":
          var it = Xe.which;
          return it !== _y ? null : (ep = !0, y0);
        case "textInput":
          var ut = Xe.data;
          return ut === y0 && ep ? null : ut;
        default:
          return null;
      }
    }
    function Ay(Ke, Xe) {
      if (dc) {
        if (Ke === "compositionend" || !Jh && Ry(Ke, Xe)) {
          var it = Vf();
          return xg(), dc = !1, it;
        }
        return null;
      }
      switch (Ke) {
        case "paste":
          return null;
        case "keypress":
          if (!Rg(Xe)) {
            if (Xe.char && Xe.char.length > 1)
              return Xe.char;
            if (Xe.which)
              return String.fromCharCode(Xe.which);
          }
          return null;
        case "compositionend":
          return Cg && !Ag(Xe) ? null : Xe.data;
        default:
          return null;
      }
    }
    function F1(Ke, Xe, it, ut, pt) {
      var Yr;
      if (N1 ? Yr = Lg(Xe, ut) : Yr = Ay(Xe, ut), !Yr)
        return null;
      var Qr = Dy(it, "onBeforeInput");
      if (Qr.length > 0) {
        var ni = new Wd("onBeforeInput", "beforeinput", null, ut, pt);
        Ke.push({
          event: ni,
          listeners: Qr
        }), ni.data = Yr;
      }
    }
    function Ig(Ke, Xe, it, ut, pt, Yr, Qr) {
      T0(Ke, Xe, it, ut, pt), F1(Ke, Xe, it, ut, pt);
    }
    var $1 = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function qf(Ke) {
      var Xe = Ke && Ke.nodeName && Ke.nodeName.toLowerCase();
      return Xe === "input" ? !!$1[Ke.type] : Xe === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function B1(Ke) {
      if (!ii)
        return !1;
      var Xe = "on" + Ke, it = Xe in document;
      if (!it) {
        var ut = document.createElement("div");
        ut.setAttribute(Xe, "return;"), it = typeof ut[Xe] == "function";
      }
      return it;
    }
    function Pg() {
      Vs("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function tt(Ke, Xe, it, ut) {
      Mp(ut);
      var pt = Dy(Xe, "onChange");
      if (pt.length > 0) {
        var Yr = new al("onChange", "change", null, it, ut);
        Ke.push({
          event: Yr,
          listeners: pt
        });
      }
    }
    var rt = null, dt = null;
    function mt(Ke) {
      var Xe = Ke.nodeName && Ke.nodeName.toLowerCase();
      return Xe === "select" || Xe === "input" && Ke.type === "file";
    }
    function Zr(Ke) {
      var Xe = [];
      tt(Xe, dt, Ke, Op(Ke)), Lm(ti, Xe);
    }
    function ti(Ke) {
      jb(Ke, 0);
    }
    function fi(Ke) {
      var Xe = Fg(Ke);
      if (vf(Xe))
        return Ke;
    }
    function wi(Ke, Xe) {
      if (Ke === "change")
        return Xe;
    }
    var Pi = !1;
    ii && (Pi = B1("input") && (!document.documentMode || document.documentMode > 9));
    function Wi(Ke, Xe) {
      rt = Ke, dt = Xe, rt.attachEvent("onpropertychange", cs);
    }
    function as() {
      rt && (rt.detachEvent("onpropertychange", cs), rt = null, dt = null);
    }
    function cs(Ke) {
      Ke.propertyName === "value" && fi(dt) && Zr(Ke);
    }
    function os(Ke, Xe, it) {
      Ke === "focusin" ? (as(), Wi(Xe, it)) : Ke === "focusout" && as();
    }
    function _s(Ke, Xe) {
      if (Ke === "selectionchange" || Ke === "keyup" || Ke === "keydown")
        return fi(dt);
    }
    function Ls(Ke) {
      var Xe = Ke.nodeName;
      return Xe && Xe.toLowerCase() === "input" && (Ke.type === "checkbox" || Ke.type === "radio");
    }
    function Ds(Ke, Xe) {
      if (Ke === "click")
        return fi(Xe);
    }
    function Ea(Ke, Xe) {
      if (Ke === "input" || Ke === "change")
        return fi(Xe);
    }
    function Fi(Ke) {
      var Xe = Ke._wrapperState;
      !Xe || !Xe.controlled || Ke.type !== "number" || Ys(Ke, "number", Ke.value);
    }
    function ki(Ke, Xe, it, ut, pt, Yr, Qr) {
      var ni = it ? Fg(it) : window, oi, vi;
      if (mt(ni) ? oi = wi : qf(ni) ? Pi ? oi = Ea : (oi = _s, vi = os) : Ls(ni) && (oi = Ds), oi) {
        var Ei = oi(Xe, it);
        if (Ei) {
          tt(Ke, Ei, ut, pt);
          return;
        }
      }
      vi && vi(Xe, ni, it), Xe === "focusout" && Fi(ni);
    }
    function Ui() {
      Ws("onMouseEnter", ["mouseout", "mouseover"]), Ws("onMouseLeave", ["mouseout", "mouseover"]), Ws("onPointerEnter", ["pointerout", "pointerover"]), Ws("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function gs(Ke, Xe, it, ut, pt, Yr, Qr) {
      var ni = Xe === "mouseover" || Xe === "pointerover", oi = Xe === "mouseout" || Xe === "pointerout";
      if (ni && !Vv(ut)) {
        var vi = ut.relatedTarget || ut.fromElement;
        if (vi && (rp(vi) || k0(vi)))
          return;
      }
      if (!(!oi && !ni)) {
        var Ei;
        if (pt.window === pt)
          Ei = pt;
        else {
          var Ni = pt.ownerDocument;
          Ni ? Ei = Ni.defaultView || Ni.parentWindow : Ei = window;
        }
        var Mi, zi;
        if (oi) {
          var ji = ut.relatedTarget || ut.toElement;
          if (Mi = it, zi = ji ? rp(ji) : null, zi !== null) {
            var Xi = Hl(zi);
            (zi !== Xi || zi.tag !== lt && zi.tag !== ft) && (zi = null);
          }
        } else
          Mi = null, zi = it;
        if (Mi !== zi) {
          var Cs = rd, qs = "onMouseLeave", $s = "onMouseEnter", Ro = "mouse";
          (Xe === "pointerout" || Xe === "pointerover") && (Cs = m0, qs = "onPointerLeave", $s = "onPointerEnter", Ro = "pointer");
          var So = Mi == null ? Ei : Fg(Mi), $i = zi == null ? Ei : Fg(zi), Zi = new Cs(qs, Ro + "leave", Mi, ut, pt);
          Zi.target = So, Zi.relatedTarget = $i;
          var Bi = null, ds = rp(pt);
          if (ds === it) {
            var Rs = new Cs($s, Ro + "enter", zi, ut, pt);
            Rs.target = $i, Rs.relatedTarget = So, Bi = Rs;
          }
          FC(Ke, Zi, Bi, Mi, zi);
        }
      }
    }
    function ks(Ke, Xe) {
      return Ke === Xe && (Ke !== 0 || 1 / Ke === 1 / Xe) || Ke !== Ke && Xe !== Xe;
    }
    var Is = typeof Object.is == "function" ? Object.is : ks;
    function zs(Ke, Xe) {
      if (Is(Ke, Xe))
        return !0;
      if (typeof Ke != "object" || Ke === null || typeof Xe != "object" || Xe === null)
        return !1;
      var it = Object.keys(Ke), ut = Object.keys(Xe);
      if (it.length !== ut.length)
        return !1;
      for (var pt = 0; pt < it.length; pt++) {
        var Yr = it[pt];
        if (!bi.call(Xe, Yr) || !Is(Ke[Yr], Xe[Yr]))
          return !1;
      }
      return !0;
    }
    function so(Ke) {
      for (; Ke && Ke.firstChild; )
        Ke = Ke.firstChild;
      return Ke;
    }
    function Ga(Ke) {
      for (; Ke; ) {
        if (Ke.nextSibling)
          return Ke.nextSibling;
        Ke = Ke.parentNode;
      }
    }
    function Po(Ke, Xe) {
      for (var it = so(Ke), ut = 0, pt = 0; it; ) {
        if (it.nodeType === Zu) {
          if (pt = ut + it.textContent.length, ut <= Xe && pt >= Xe)
            return {
              node: it,
              offset: Xe - ut
            };
          ut = pt;
        }
        it = so(Ga(it));
      }
    }
    function sd(Ke) {
      var Xe = Ke.ownerDocument, it = Xe && Xe.defaultView || window, ut = it.getSelection && it.getSelection();
      if (!ut || ut.rangeCount === 0)
        return null;
      var pt = ut.anchorNode, Yr = ut.anchorOffset, Qr = ut.focusNode, ni = ut.focusOffset;
      try {
        pt.nodeType, Qr.nodeType;
      } catch {
        return null;
      }
      return U1(Ke, pt, Yr, Qr, ni);
    }
    function U1(Ke, Xe, it, ut, pt) {
      var Yr = 0, Qr = -1, ni = -1, oi = 0, vi = 0, Ei = Ke, Ni = null;
      e:
        for (; ; ) {
          for (var Mi = null; Ei === Xe && (it === 0 || Ei.nodeType === Zu) && (Qr = Yr + it), Ei === ut && (pt === 0 || Ei.nodeType === Zu) && (ni = Yr + pt), Ei.nodeType === Zu && (Yr += Ei.nodeValue.length), (Mi = Ei.firstChild) !== null; )
            Ni = Ei, Ei = Mi;
          for (; ; ) {
            if (Ei === Ke)
              break e;
            if (Ni === Xe && ++oi === it && (Qr = Yr), Ni === ut && ++vi === pt && (ni = Yr), (Mi = Ei.nextSibling) !== null)
              break;
            Ei = Ni, Ni = Ei.parentNode;
          }
          Ei = Mi;
        }
      return Qr === -1 || ni === -1 ? null : {
        start: Qr,
        end: ni
      };
    }
    function yC(Ke, Xe) {
      var it = Ke.ownerDocument || document, ut = it && it.defaultView || window;
      if (ut.getSelection) {
        var pt = ut.getSelection(), Yr = Ke.textContent.length, Qr = Math.min(Xe.start, Yr), ni = Xe.end === void 0 ? Qr : Math.min(Xe.end, Yr);
        if (!pt.extend && Qr > ni) {
          var oi = ni;
          ni = Qr, Qr = oi;
        }
        var vi = Po(Ke, Qr), Ei = Po(Ke, ni);
        if (vi && Ei) {
          if (pt.rangeCount === 1 && pt.anchorNode === vi.node && pt.anchorOffset === vi.offset && pt.focusNode === Ei.node && pt.focusOffset === Ei.offset)
            return;
          var Ni = it.createRange();
          Ni.setStart(vi.node, vi.offset), pt.removeAllRanges(), Qr > ni ? (pt.addRange(Ni), pt.extend(Ei.node, Ei.offset)) : (Ni.setEnd(Ei.node, Ei.offset), pt.addRange(Ni));
        }
      }
    }
    function Ob(Ke) {
      return Ke && Ke.nodeType === Zu;
    }
    function Mb(Ke, Xe) {
      return !Ke || !Xe ? !1 : Ke === Xe ? !0 : Ob(Ke) ? !1 : Ob(Xe) ? Mb(Ke, Xe.parentNode) : "contains" in Ke ? Ke.contains(Xe) : Ke.compareDocumentPosition ? !!(Ke.compareDocumentPosition(Xe) & 16) : !1;
    }
    function EC(Ke) {
      return Ke && Ke.ownerDocument && Mb(Ke.ownerDocument.documentElement, Ke);
    }
    function xC(Ke) {
      try {
        return typeof Ke.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function kb() {
      for (var Ke = window, Xe = Fc(); Xe instanceof Ke.HTMLIFrameElement; ) {
        if (xC(Xe))
          Ke = Xe.contentWindow;
        else
          return Xe;
        Xe = Fc(Ke.document);
      }
      return Xe;
    }
    function G1(Ke) {
      var Xe = Ke && Ke.nodeName && Ke.nodeName.toLowerCase();
      return Xe && (Xe === "input" && (Ke.type === "text" || Ke.type === "search" || Ke.type === "tel" || Ke.type === "url" || Ke.type === "password") || Xe === "textarea" || Ke.contentEditable === "true");
    }
    function TC() {
      var Ke = kb();
      return {
        focusedElem: Ke,
        selectionRange: G1(Ke) ? SC(Ke) : null
      };
    }
    function bC(Ke) {
      var Xe = kb(), it = Ke.focusedElem, ut = Ke.selectionRange;
      if (Xe !== it && EC(it)) {
        ut !== null && G1(it) && _C(it, ut);
        for (var pt = [], Yr = it; Yr = Yr.parentNode; )
          Yr.nodeType === Cl && pt.push({
            element: Yr,
            left: Yr.scrollLeft,
            top: Yr.scrollTop
          });
        typeof it.focus == "function" && it.focus();
        for (var Qr = 0; Qr < pt.length; Qr++) {
          var ni = pt[Qr];
          ni.element.scrollLeft = ni.left, ni.element.scrollTop = ni.top;
        }
      }
    }
    function SC(Ke) {
      var Xe;
      return "selectionStart" in Ke ? Xe = {
        start: Ke.selectionStart,
        end: Ke.selectionEnd
      } : Xe = sd(Ke), Xe || {
        start: 0,
        end: 0
      };
    }
    function _C(Ke, Xe) {
      var it = Xe.start, ut = Xe.end;
      ut === void 0 && (ut = it), "selectionStart" in Ke ? (Ke.selectionStart = it, Ke.selectionEnd = Math.min(ut, Ke.value.length)) : yC(Ke, Xe);
    }
    var wC = ii && "documentMode" in document && document.documentMode <= 11;
    function CC() {
      Vs("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Dg = null, H1 = null, b0 = null, z1 = !1;
    function RC(Ke) {
      if ("selectionStart" in Ke && G1(Ke))
        return {
          start: Ke.selectionStart,
          end: Ke.selectionEnd
        };
      var Xe = Ke.ownerDocument && Ke.ownerDocument.defaultView || window, it = Xe.getSelection();
      return {
        anchorNode: it.anchorNode,
        anchorOffset: it.anchorOffset,
        focusNode: it.focusNode,
        focusOffset: it.focusOffset
      };
    }
    function AC(Ke) {
      return Ke.window === Ke ? Ke.document : Ke.nodeType === bu ? Ke : Ke.ownerDocument;
    }
    function Nb(Ke, Xe, it) {
      var ut = AC(it);
      if (!(z1 || Dg == null || Dg !== Fc(ut))) {
        var pt = RC(Dg);
        if (!b0 || !zs(b0, pt)) {
          b0 = pt;
          var Yr = Dy(H1, "onSelect");
          if (Yr.length > 0) {
            var Qr = new al("onSelect", "select", null, Xe, it);
            Ke.push({
              event: Qr,
              listeners: Yr
            }), Qr.target = Dg;
          }
        }
      }
    }
    function LC(Ke, Xe, it, ut, pt, Yr, Qr) {
      var ni = it ? Fg(it) : window;
      switch (Xe) {
        case "focusin":
          (qf(ni) || ni.contentEditable === "true") && (Dg = ni, H1 = it, b0 = null);
          break;
        case "focusout":
          Dg = null, H1 = null, b0 = null;
          break;
        case "mousedown":
          z1 = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          z1 = !1, Nb(Ke, ut, pt);
          break;
        case "selectionchange":
          if (wC)
            break;
        case "keydown":
        case "keyup":
          Nb(Ke, ut, pt);
      }
    }
    function Ly(Ke, Xe) {
      var it = {};
      return it[Ke.toLowerCase()] = Xe.toLowerCase(), it["Webkit" + Ke] = "webkit" + Xe, it["Moz" + Ke] = "moz" + Xe, it;
    }
    var Og = {
      animationend: Ly("Animation", "AnimationEnd"),
      animationiteration: Ly("Animation", "AnimationIteration"),
      animationstart: Ly("Animation", "AnimationStart"),
      transitionend: Ly("Transition", "TransitionEnd")
    }, V1 = {}, Fb = {};
    ii && (Fb = document.createElement("div").style, "AnimationEvent" in window || (delete Og.animationend.animation, delete Og.animationiteration.animation, delete Og.animationstart.animation), "TransitionEvent" in window || delete Og.transitionend.transition);
    function Iy(Ke) {
      if (V1[Ke])
        return V1[Ke];
      if (!Og[Ke])
        return Ke;
      var Xe = Og[Ke];
      for (var it in Xe)
        if (Xe.hasOwnProperty(it) && it in Fb)
          return V1[Ke] = Xe[it];
      return Ke;
    }
    var $b = Iy("animationend"), Bb = Iy("animationiteration"), Ub = Iy("animationstart"), Gb = Iy("transitionend"), Hb = /* @__PURE__ */ new Map(), zb = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Yf(Ke, Xe) {
      Hb.set(Ke, Xe), Vs(Xe, [Ke]);
    }
    function IC() {
      for (var Ke = 0; Ke < zb.length; Ke++) {
        var Xe = zb[Ke], it = Xe.toLowerCase(), ut = Xe[0].toUpperCase() + Xe.slice(1);
        Yf(it, "on" + ut);
      }
      Yf($b, "onAnimationEnd"), Yf(Bb, "onAnimationIteration"), Yf(Ub, "onAnimationStart"), Yf("dblclick", "onDoubleClick"), Yf("focusin", "onFocus"), Yf("focusout", "onBlur"), Yf(Gb, "onTransitionEnd");
    }
    function PC(Ke, Xe, it, ut, pt, Yr, Qr) {
      var ni = Hb.get(Xe);
      if (ni !== void 0) {
        var oi = al, vi = Xe;
        switch (Xe) {
          case "keypress":
            if (zd(ut) === 0)
              return;
          case "keydown":
          case "keyup":
            oi = O1;
            break;
          case "focusin":
            vi = "focus", oi = bg;
            break;
          case "focusout":
            vi = "blur", oi = bg;
            break;
          case "beforeblur":
          case "afterblur":
            oi = bg;
            break;
          case "click":
            if (ut.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            oi = rd;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            oi = jd;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            oi = fu;
            break;
          case $b:
          case Bb:
          case Ub:
            oi = Sg;
            break;
          case Gb:
            oi = k1;
            break;
          case "scroll":
            oi = d0;
            break;
          case "wheel":
            oi = wg;
            break;
          case "copy":
          case "cut":
          case "paste":
            oi = L1;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            oi = m0;
            break;
        }
        var Ei = (Yr & Sd) !== 0;
        {
          var Ni = !Ei && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          Xe === "scroll", Mi = kC(it, ni, ut.type, Ei, Ni);
          if (Mi.length > 0) {
            var zi = new oi(ni, vi, null, ut, pt);
            Ke.push({
              event: zi,
              listeners: Mi
            });
          }
        }
      }
    }
    IC(), Ui(), Pg(), CC(), wy();
    function DC(Ke, Xe, it, ut, pt, Yr, Qr) {
      PC(Ke, Xe, it, ut, pt, Yr);
      var ni = (Yr & m1) === 0;
      ni && (gs(Ke, Xe, it, ut, pt), ki(Ke, Xe, it, ut, pt), LC(Ke, Xe, it, ut, pt), Ig(Ke, Xe, it, ut, pt));
    }
    var S0 = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], j1 = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(S0));
    function Vb(Ke, Xe, it) {
      var ut = Ke.type || "unknown-event";
      Ke.currentTarget = it, nc(ut, Xe, void 0, Ke), Ke.currentTarget = null;
    }
    function OC(Ke, Xe, it) {
      var ut;
      if (it)
        for (var pt = Xe.length - 1; pt >= 0; pt--) {
          var Yr = Xe[pt], Qr = Yr.instance, ni = Yr.currentTarget, oi = Yr.listener;
          if (Qr !== ut && Ke.isPropagationStopped())
            return;
          Vb(Ke, oi, ni), ut = Qr;
        }
      else
        for (var vi = 0; vi < Xe.length; vi++) {
          var Ei = Xe[vi], Ni = Ei.instance, Mi = Ei.currentTarget, zi = Ei.listener;
          if (Ni !== ut && Ke.isPropagationStopped())
            return;
          Vb(Ke, zi, Mi), ut = Ni;
        }
    }
    function jb(Ke, Xe) {
      for (var it = (Xe & Sd) !== 0, ut = 0; ut < Ke.length; ut++) {
        var pt = Ke[ut], Yr = pt.event, Qr = pt.listeners;
        OC(Yr, Qr, it);
      }
      Om();
    }
    function MC(Ke, Xe, it, ut, pt) {
      var Yr = Op(it), Qr = [];
      DC(Qr, Ke, ut, it, Yr, Xe), jb(Qr, Xe);
    }
    function ca(Ke, Xe) {
      j1.has(Ke) || be('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', Ke);
      var it = !1, ut = d2(Xe), pt = $C(Ke, it);
      ut.has(pt) || (Wb(Xe, Ke, wh, it), ut.add(pt));
    }
    function W1(Ke, Xe, it) {
      j1.has(Ke) && !Xe && be('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', Ke);
      var ut = 0;
      Xe && (ut |= Sd), Wb(it, Ke, ut, Xe);
    }
    var Py = "_reactListening" + Math.random().toString(36).slice(2);
    function _0(Ke) {
      if (!Ke[Py]) {
        Ke[Py] = !0, is.forEach(function(it) {
          it !== "selectionchange" && (j1.has(it) || W1(it, !1, Ke), W1(it, !0, Ke));
        });
        var Xe = Ke.nodeType === bu ? Ke : Ke.ownerDocument;
        Xe !== null && (Xe[Py] || (Xe[Py] = !0, W1("selectionchange", !1, Xe)));
      }
    }
    function Wb(Ke, Xe, it, ut, pt) {
      var Yr = Gf(Ke, Xe, it), Qr = void 0;
      Ih && (Xe === "touchstart" || Xe === "touchmove" || Xe === "wheel") && (Qr = !0), Ke = Ke, ut ? Qr !== void 0 ? cc(Ke, Xe, Yr, Qr) : zf(Ke, Xe, Yr) : Qr !== void 0 ? Eg(Ke, Xe, Yr, Qr) : c0(Ke, Xe, Yr);
    }
    function Kb(Ke, Xe) {
      return Ke === Xe || Ke.nodeType === Sa && Ke.parentNode === Xe;
    }
    function K1(Ke, Xe, it, ut, pt) {
      var Yr = ut;
      if (!(Xe & Ju) && !(Xe & wh)) {
        var Qr = pt;
        if (ut !== null) {
          var ni = ut;
          e:
            for (; ; ) {
              if (ni === null)
                return;
              var oi = ni.tag;
              if (oi === st || oi === ot) {
                var vi = ni.stateNode.containerInfo;
                if (Kb(vi, Qr))
                  break;
                if (oi === ot)
                  for (var Ei = ni.return; Ei !== null; ) {
                    var Ni = Ei.tag;
                    if (Ni === st || Ni === ot) {
                      var Mi = Ei.stateNode.containerInfo;
                      if (Kb(Mi, Qr))
                        return;
                    }
                    Ei = Ei.return;
                  }
                for (; vi !== null; ) {
                  var zi = rp(vi);
                  if (zi === null)
                    return;
                  var ji = zi.tag;
                  if (ji === lt || ji === ft) {
                    ni = Yr = zi;
                    continue e;
                  }
                  vi = vi.parentNode;
                }
              }
              ni = ni.return;
            }
        }
      }
      Lm(function() {
        return MC(Ke, Xe, it, Yr);
      });
    }
    function w0(Ke, Xe, it) {
      return {
        instance: Ke,
        listener: Xe,
        currentTarget: it
      };
    }
    function kC(Ke, Xe, it, ut, pt, Yr) {
      for (var Qr = Xe !== null ? Xe + "Capture" : null, ni = ut ? Qr : Xe, oi = [], vi = Ke, Ei = null; vi !== null; ) {
        var Ni = vi, Mi = Ni.stateNode, zi = Ni.tag;
        if (zi === lt && Mi !== null && (Ei = Mi, ni !== null)) {
          var ji = wd(vi, ni);
          ji != null && oi.push(w0(vi, ji, Ei));
        }
        if (pt)
          break;
        vi = vi.return;
      }
      return oi;
    }
    function Dy(Ke, Xe) {
      for (var it = Xe + "Capture", ut = [], pt = Ke; pt !== null; ) {
        var Yr = pt, Qr = Yr.stateNode, ni = Yr.tag;
        if (ni === lt && Qr !== null) {
          var oi = Qr, vi = wd(pt, it);
          vi != null && ut.unshift(w0(pt, vi, oi));
          var Ei = wd(pt, Xe);
          Ei != null && ut.push(w0(pt, Ei, oi));
        }
        pt = pt.return;
      }
      return ut;
    }
    function Mg(Ke) {
      if (Ke === null)
        return null;
      do
        Ke = Ke.return;
      while (Ke && Ke.tag !== lt);
      return Ke || null;
    }
    function NC(Ke, Xe) {
      for (var it = Ke, ut = Xe, pt = 0, Yr = it; Yr; Yr = Mg(Yr))
        pt++;
      for (var Qr = 0, ni = ut; ni; ni = Mg(ni))
        Qr++;
      for (; pt - Qr > 0; )
        it = Mg(it), pt--;
      for (; Qr - pt > 0; )
        ut = Mg(ut), Qr--;
      for (var oi = pt; oi--; ) {
        if (it === ut || ut !== null && it === ut.alternate)
          return it;
        it = Mg(it), ut = Mg(ut);
      }
      return null;
    }
    function qb(Ke, Xe, it, ut, pt) {
      for (var Yr = Xe._reactName, Qr = [], ni = it; ni !== null && ni !== ut; ) {
        var oi = ni, vi = oi.alternate, Ei = oi.stateNode, Ni = oi.tag;
        if (vi !== null && vi === ut)
          break;
        if (Ni === lt && Ei !== null) {
          var Mi = Ei;
          if (pt) {
            var zi = wd(ni, Yr);
            zi != null && Qr.unshift(w0(ni, zi, Mi));
          } else if (!pt) {
            var ji = wd(ni, Yr);
            ji != null && Qr.push(w0(ni, ji, Mi));
          }
        }
        ni = ni.return;
      }
      Qr.length !== 0 && Ke.push({
        event: Xe,
        listeners: Qr
      });
    }
    function FC(Ke, Xe, it, ut, pt) {
      var Yr = ut && pt ? NC(ut, pt) : null;
      ut !== null && qb(Ke, Xe, ut, Yr, !1), pt !== null && it !== null && qb(Ke, it, pt, Yr, !0);
    }
    function $C(Ke, Xe) {
      return Ke + "__" + (Xe ? "capture" : "bubble");
    }
    var hu = !1, C0 = "dangerouslySetInnerHTML", Oy = "suppressContentEditableWarning", Xf = "suppressHydrationWarning", Yb = "autoFocus", tp = "children", np = "style", My = "__html", q1, ky, R0, Xb, Ny, Zb, Qb;
    q1 = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, ky = function(Ke, Xe) {
      Dp(Ke, Xe), _m(Ke, Xe), zv(Ke, Xe, {
        registrationNameDependencies: Ss,
        possibleRegistrationNames: Gs
      });
    }, Zb = ii && !document.documentMode, R0 = function(Ke, Xe, it) {
      if (!hu) {
        var ut = Fy(it), pt = Fy(Xe);
        pt !== ut && (hu = !0, be("Prop `%s` did not match. Server: %s Client: %s", Ke, JSON.stringify(pt), JSON.stringify(ut)));
      }
    }, Xb = function(Ke) {
      if (!hu) {
        hu = !0;
        var Xe = [];
        Ke.forEach(function(it) {
          Xe.push(it);
        }), be("Extra attributes from the server: %s", Xe);
      }
    }, Ny = function(Ke, Xe) {
      Xe === !1 ? be("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", Ke, Ke, Ke) : be("Expected `%s` listener to be a function, instead got a value of `%s` type.", Ke, typeof Xe);
    }, Qb = function(Ke, Xe) {
      var it = Ke.namespaceURI === Xu ? Ke.ownerDocument.createElement(Ke.tagName) : Ke.ownerDocument.createElementNS(Ke.namespaceURI, Ke.tagName);
      return it.innerHTML = Xe, it.innerHTML;
    };
    var BC = /\r\n?/g, UC = /\u0000|\uFFFD/g;
    function Fy(Ke) {
      Ns(Ke);
      var Xe = typeof Ke == "string" ? Ke : "" + Ke;
      return Xe.replace(BC, `
`).replace(UC, "");
    }
    function $y(Ke, Xe, it, ut) {
      var pt = Fy(Xe), Yr = Fy(Ke);
      if (Yr !== pt && (ut && (hu || (hu = !0, be('Text content did not match. Server: "%s" Client: "%s"', Yr, pt))), it && gi))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function Jb(Ke) {
      return Ke.nodeType === bu ? Ke : Ke.ownerDocument;
    }
    function GC() {
    }
    function By(Ke) {
      Ke.onclick = GC;
    }
    function HC(Ke, Xe, it, ut, pt) {
      for (var Yr in ut)
        if (ut.hasOwnProperty(Yr)) {
          var Qr = ut[Yr];
          if (Yr === np)
            Qr && Object.freeze(Qr), Ov(Xe, Qr);
          else if (Yr === C0) {
            var ni = Qr ? Qr[My] : void 0;
            ni != null && bv(Xe, ni);
          } else if (Yr === tp)
            if (typeof Qr == "string") {
              var oi = Ke !== "textarea" || Qr !== "";
              oi && Ap(Xe, Qr);
            } else
              typeof Qr == "number" && Ap(Xe, "" + Qr);
          else
            Yr === Oy || Yr === Xf || Yr === Yb || (Ss.hasOwnProperty(Yr) ? Qr != null && (typeof Qr != "function" && Ny(Yr, Qr), Yr === "onScroll" && ca("scroll", Xe)) : Qr != null && Yo(Xe, Yr, Qr, pt));
        }
    }
    function zC(Ke, Xe, it, ut) {
      for (var pt = 0; pt < Xe.length; pt += 2) {
        var Yr = Xe[pt], Qr = Xe[pt + 1];
        Yr === np ? Ov(Ke, Qr) : Yr === C0 ? bv(Ke, Qr) : Yr === tp ? Ap(Ke, Qr) : Yo(Ke, Yr, Qr, ut);
      }
    }
    function VC(Ke, Xe, it, ut) {
      var pt, Yr = Jb(it), Qr, ni = ut;
      if (ni === Xu && (ni = Cp(Ke)), ni === Xu) {
        if (pt = Qu(Ke, Xe), !pt && Ke !== Ke.toLowerCase() && be("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", Ke), Ke === "script") {
          var oi = Yr.createElement("div");
          oi.innerHTML = "<script><\/script>";
          var vi = oi.firstChild;
          Qr = oi.removeChild(vi);
        } else if (typeof Xe.is == "string")
          Qr = Yr.createElement(Ke, {
            is: Xe.is
          });
        else if (Qr = Yr.createElement(Ke), Ke === "select") {
          var Ei = Qr;
          Xe.multiple ? Ei.multiple = !0 : Xe.size && (Ei.size = Xe.size);
        }
      } else
        Qr = Yr.createElementNS(ni, Ke);
      return ni === Xu && !pt && Object.prototype.toString.call(Qr) === "[object HTMLUnknownElement]" && !bi.call(q1, Ke) && (q1[Ke] = !0, be("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", Ke)), Qr;
    }
    function jC(Ke, Xe) {
      return Jb(Xe).createTextNode(Ke);
    }
    function WC(Ke, Xe, it, ut) {
      var pt = Qu(Xe, it);
      ky(Xe, it);
      var Yr;
      switch (Xe) {
        case "dialog":
          ca("cancel", Ke), ca("close", Ke), Yr = it;
          break;
        case "iframe":
        case "object":
        case "embed":
          ca("load", Ke), Yr = it;
          break;
        case "video":
        case "audio":
          for (var Qr = 0; Qr < S0.length; Qr++)
            ca(S0[Qr], Ke);
          Yr = it;
          break;
        case "source":
          ca("error", Ke), Yr = it;
          break;
        case "img":
        case "image":
        case "link":
          ca("error", Ke), ca("load", Ke), Yr = it;
          break;
        case "details":
          ca("toggle", Ke), Yr = it;
          break;
        case "input":
          Ii(Ke, it), Yr = ui(Ke, it), ca("invalid", Ke);
          break;
        case "option":
          Bo(Ke, it), Yr = it;
          break;
        case "select":
          Th(Ke, it), Yr = xh(Ke, it), ca("invalid", Ke);
          break;
        case "textarea":
          Ev(Ke, it), Yr = gm(Ke, it), ca("invalid", Ke);
          break;
        default:
          Yr = it;
      }
      switch (Ip(Xe, Yr), HC(Xe, Ke, ut, Yr, pt), Xe) {
        case "input":
          eu(Ke), ps(Ke, it, !1);
          break;
        case "textarea":
          eu(Ke), Tv(Ke);
          break;
        case "option":
          zo(Ke, it);
          break;
        case "select":
          hm(Ke, it);
          break;
        default:
          typeof Yr.onClick == "function" && By(Ke);
          break;
      }
    }
    function KC(Ke, Xe, it, ut, pt) {
      ky(Xe, ut);
      var Yr = null, Qr, ni;
      switch (Xe) {
        case "input":
          Qr = ui(Ke, it), ni = ui(Ke, ut), Yr = [];
          break;
        case "select":
          Qr = xh(Ke, it), ni = xh(Ke, ut), Yr = [];
          break;
        case "textarea":
          Qr = gm(Ke, it), ni = gm(Ke, ut), Yr = [];
          break;
        default:
          Qr = it, ni = ut, typeof Qr.onClick != "function" && typeof ni.onClick == "function" && By(Ke);
          break;
      }
      Ip(Xe, ni);
      var oi, vi, Ei = null;
      for (oi in Qr)
        if (!(ni.hasOwnProperty(oi) || !Qr.hasOwnProperty(oi) || Qr[oi] == null))
          if (oi === np) {
            var Ni = Qr[oi];
            for (vi in Ni)
              Ni.hasOwnProperty(vi) && (Ei || (Ei = {}), Ei[vi] = "");
          } else
            oi === C0 || oi === tp || oi === Oy || oi === Xf || oi === Yb || (Ss.hasOwnProperty(oi) ? Yr || (Yr = []) : (Yr = Yr || []).push(oi, null));
      for (oi in ni) {
        var Mi = ni[oi], zi = Qr != null ? Qr[oi] : void 0;
        if (!(!ni.hasOwnProperty(oi) || Mi === zi || Mi == null && zi == null))
          if (oi === np)
            if (Mi && Object.freeze(Mi), zi) {
              for (vi in zi)
                zi.hasOwnProperty(vi) && (!Mi || !Mi.hasOwnProperty(vi)) && (Ei || (Ei = {}), Ei[vi] = "");
              for (vi in Mi)
                Mi.hasOwnProperty(vi) && zi[vi] !== Mi[vi] && (Ei || (Ei = {}), Ei[vi] = Mi[vi]);
            } else
              Ei || (Yr || (Yr = []), Yr.push(oi, Ei)), Ei = Mi;
          else if (oi === C0) {
            var ji = Mi ? Mi[My] : void 0, Xi = zi ? zi[My] : void 0;
            ji != null && Xi !== ji && (Yr = Yr || []).push(oi, ji);
          } else
            oi === tp ? (typeof Mi == "string" || typeof Mi == "number") && (Yr = Yr || []).push(oi, "" + Mi) : oi === Oy || oi === Xf || (Ss.hasOwnProperty(oi) ? (Mi != null && (typeof Mi != "function" && Ny(oi, Mi), oi === "onScroll" && ca("scroll", Ke)), !Yr && zi !== Mi && (Yr = [])) : (Yr = Yr || []).push(oi, Mi));
      }
      return Ei && (Sh(Ei, ni[np]), (Yr = Yr || []).push(np, Ei)), Yr;
    }
    function qC(Ke, Xe, it, ut, pt) {
      it === "input" && pt.type === "radio" && pt.name != null && Vi(Ke, pt);
      var Yr = Qu(it, ut), Qr = Qu(it, pt);
      switch (zC(Ke, Xe, Yr, Qr), it) {
        case "input":
          Ki(Ke, pt);
          break;
        case "textarea":
          xv(Ke, pt);
          break;
        case "select":
          s1(Ke, pt);
          break;
      }
    }
    function YC(Ke) {
      {
        var Xe = Ke.toLowerCase();
        return Pp.hasOwnProperty(Xe) && Pp[Xe] || null;
      }
    }
    function XC(Ke, Xe, it, ut, pt, Yr, Qr) {
      var ni, oi;
      switch (ni = Qu(Xe, it), ky(Xe, it), Xe) {
        case "dialog":
          ca("cancel", Ke), ca("close", Ke);
          break;
        case "iframe":
        case "object":
        case "embed":
          ca("load", Ke);
          break;
        case "video":
        case "audio":
          for (var vi = 0; vi < S0.length; vi++)
            ca(S0[vi], Ke);
          break;
        case "source":
          ca("error", Ke);
          break;
        case "img":
        case "image":
        case "link":
          ca("error", Ke), ca("load", Ke);
          break;
        case "details":
          ca("toggle", Ke);
          break;
        case "input":
          Ii(Ke, it), ca("invalid", Ke);
          break;
        case "option":
          Bo(Ke, it);
          break;
        case "select":
          Th(Ke, it), ca("invalid", Ke);
          break;
        case "textarea":
          Ev(Ke, it), ca("invalid", Ke);
          break;
      }
      Ip(Xe, it);
      {
        oi = /* @__PURE__ */ new Set();
        for (var Ei = Ke.attributes, Ni = 0; Ni < Ei.length; Ni++) {
          var Mi = Ei[Ni].name.toLowerCase();
          switch (Mi) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              oi.add(Ei[Ni].name);
          }
        }
      }
      var zi = null;
      for (var ji in it)
        if (it.hasOwnProperty(ji)) {
          var Xi = it[ji];
          if (ji === tp)
            typeof Xi == "string" ? Ke.textContent !== Xi && (it[Xf] !== !0 && $y(Ke.textContent, Xi, Yr, Qr), zi = [tp, Xi]) : typeof Xi == "number" && Ke.textContent !== "" + Xi && (it[Xf] !== !0 && $y(Ke.textContent, Xi, Yr, Qr), zi = [tp, "" + Xi]);
          else if (Ss.hasOwnProperty(ji))
            Xi != null && (typeof Xi != "function" && Ny(ji, Xi), ji === "onScroll" && ca("scroll", Ke));
          else if (Qr && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof ni == "boolean") {
            var Cs = void 0, qs = ni && rs ? null : Es(ji);
            if (it[Xf] !== !0) {
              if (!(ji === Oy || ji === Xf || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              ji === "value" || ji === "checked" || ji === "selected")) {
                if (ji === C0) {
                  var $s = Ke.innerHTML, Ro = Xi ? Xi[My] : void 0;
                  if (Ro != null) {
                    var So = Qb(Ke, Ro);
                    So !== $s && R0(ji, $s, So);
                  }
                } else if (ji === np) {
                  if (oi.delete(ji), Zb) {
                    var $i = h1(Xi);
                    Cs = Ke.getAttribute("style"), $i !== Cs && R0(ji, Cs, $i);
                  }
                } else if (ni && !rs)
                  oi.delete(ji.toLowerCase()), Cs = ll(Ke, ji, Xi), Xi !== Cs && R0(ji, Cs, Xi);
                else if (!Ci(ji, qs, ni) && !es(ji, Xi, qs, ni)) {
                  var Zi = !1;
                  if (qs !== null)
                    oi.delete(qs.attributeName), Cs = ba(Ke, ji, Xi, qs);
                  else {
                    var Bi = ut;
                    if (Bi === Xu && (Bi = Cp(Xe)), Bi === Xu)
                      oi.delete(ji.toLowerCase());
                    else {
                      var ds = YC(ji);
                      ds !== null && ds !== ji && (Zi = !0, oi.delete(ds)), oi.delete(ji);
                    }
                    Cs = ll(Ke, ji, Xi);
                  }
                  var Rs = rs;
                  !Rs && Xi !== Cs && !Zi && R0(ji, Cs, Xi);
                }
              }
            }
          }
        }
      switch (Qr && // $FlowFixMe - Should be inferred as not undefined.
      oi.size > 0 && it[Xf] !== !0 && Xb(oi), Xe) {
        case "input":
          eu(Ke), ps(Ke, it, !0);
          break;
        case "textarea":
          eu(Ke), Tv(Ke);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof it.onClick == "function" && By(Ke);
          break;
      }
      return zi;
    }
    function ZC(Ke, Xe, it) {
      var ut = Ke.nodeValue !== Xe;
      return ut;
    }
    function Y1(Ke, Xe) {
      {
        if (hu)
          return;
        hu = !0, be("Did not expect server HTML to contain a <%s> in <%s>.", Xe.nodeName.toLowerCase(), Ke.nodeName.toLowerCase());
      }
    }
    function X1(Ke, Xe) {
      {
        if (hu)
          return;
        hu = !0, be('Did not expect server HTML to contain the text node "%s" in <%s>.', Xe.nodeValue, Ke.nodeName.toLowerCase());
      }
    }
    function Z1(Ke, Xe, it) {
      {
        if (hu)
          return;
        hu = !0, be("Expected server HTML to contain a matching <%s> in <%s>.", Xe, Ke.nodeName.toLowerCase());
      }
    }
    function Q1(Ke, Xe) {
      {
        if (Xe === "" || hu)
          return;
        hu = !0, be('Expected server HTML to contain a matching text node for "%s" in <%s>.', Xe, Ke.nodeName.toLowerCase());
      }
    }
    function QC(Ke, Xe, it) {
      switch (Xe) {
        case "input":
          Zs(Ke, it);
          return;
        case "textarea":
          mm(Ke, it);
          return;
        case "select":
          o1(Ke, it);
          return;
      }
    }
    var A0 = function() {
    }, L0 = function() {
    };
    {
      var JC = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], eS = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], eR = eS.concat(["button"]), tR = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], tS = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      L0 = function(Ke, Xe) {
        var it = vo({}, Ke || tS), ut = {
          tag: Xe
        };
        return eS.indexOf(Xe) !== -1 && (it.aTagInScope = null, it.buttonTagInScope = null, it.nobrTagInScope = null), eR.indexOf(Xe) !== -1 && (it.pTagInButtonScope = null), JC.indexOf(Xe) !== -1 && Xe !== "address" && Xe !== "div" && Xe !== "p" && (it.listItemTagAutoclosing = null, it.dlItemTagAutoclosing = null), it.current = ut, Xe === "form" && (it.formTag = ut), Xe === "a" && (it.aTagInScope = ut), Xe === "button" && (it.buttonTagInScope = ut), Xe === "nobr" && (it.nobrTagInScope = ut), Xe === "p" && (it.pTagInButtonScope = ut), Xe === "li" && (it.listItemTagAutoclosing = ut), (Xe === "dd" || Xe === "dt") && (it.dlItemTagAutoclosing = ut), it;
      };
      var nR = function(Ke, Xe) {
        switch (Xe) {
          case "select":
            return Ke === "option" || Ke === "optgroup" || Ke === "#text";
          case "optgroup":
            return Ke === "option" || Ke === "#text";
          case "option":
            return Ke === "#text";
          case "tr":
            return Ke === "th" || Ke === "td" || Ke === "style" || Ke === "script" || Ke === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return Ke === "tr" || Ke === "style" || Ke === "script" || Ke === "template";
          case "colgroup":
            return Ke === "col" || Ke === "template";
          case "table":
            return Ke === "caption" || Ke === "colgroup" || Ke === "tbody" || Ke === "tfoot" || Ke === "thead" || Ke === "style" || Ke === "script" || Ke === "template";
          case "head":
            return Ke === "base" || Ke === "basefont" || Ke === "bgsound" || Ke === "link" || Ke === "meta" || Ke === "title" || Ke === "noscript" || Ke === "noframes" || Ke === "style" || Ke === "script" || Ke === "template";
          case "html":
            return Ke === "head" || Ke === "body" || Ke === "frameset";
          case "frameset":
            return Ke === "frame";
          case "#document":
            return Ke === "html";
        }
        switch (Ke) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return Xe !== "h1" && Xe !== "h2" && Xe !== "h3" && Xe !== "h4" && Xe !== "h5" && Xe !== "h6";
          case "rp":
          case "rt":
            return tR.indexOf(Xe) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return Xe == null;
        }
        return !0;
      }, rR = function(Ke, Xe) {
        switch (Ke) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return Xe.pTagInButtonScope;
          case "form":
            return Xe.formTag || Xe.pTagInButtonScope;
          case "li":
            return Xe.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return Xe.dlItemTagAutoclosing;
          case "button":
            return Xe.buttonTagInScope;
          case "a":
            return Xe.aTagInScope;
          case "nobr":
            return Xe.nobrTagInScope;
        }
        return null;
      }, nS = {};
      A0 = function(Ke, Xe, it) {
        it = it || tS;
        var ut = it.current, pt = ut && ut.tag;
        Xe != null && (Ke != null && be("validateDOMNesting: when childText is passed, childTag should be null"), Ke = "#text");
        var Yr = nR(Ke, pt) ? null : ut, Qr = Yr ? null : rR(Ke, it), ni = Yr || Qr;
        if (ni) {
          var oi = ni.tag, vi = !!Yr + "|" + Ke + "|" + oi;
          if (!nS[vi]) {
            nS[vi] = !0;
            var Ei = Ke, Ni = "";
            if (Ke === "#text" ? /\S/.test(Xe) ? Ei = "Text nodes" : (Ei = "Whitespace text nodes", Ni = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : Ei = "<" + Ke + ">", Yr) {
              var Mi = "";
              oi === "table" && Ke === "tr" && (Mi += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), be("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", Ei, oi, Ni, Mi);
            } else
              be("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", Ei, oi);
          }
        }
      };
    }
    var Uy = "suppressHydrationWarning", Gy = "$", Hy = "/$", I0 = "$?", P0 = "$!", iR = "style", J1 = null, ex = null;
    function sR(Ke) {
      var Xe, it, ut = Ke.nodeType;
      switch (ut) {
        case bu:
        case Td: {
          Xe = ut === bu ? "#document" : "#fragment";
          var pt = Ke.documentElement;
          it = pt ? pt.namespaceURI : ym(null, "");
          break;
        }
        default: {
          var Yr = ut === Sa ? Ke.parentNode : Ke, Qr = Yr.namespaceURI || null;
          Xe = Yr.tagName, it = ym(Qr, Xe);
          break;
        }
      }
      {
        var ni = Xe.toLowerCase(), oi = L0(null, ni);
        return {
          namespace: it,
          ancestorInfo: oi
        };
      }
    }
    function oR(Ke, Xe, it) {
      {
        var ut = Ke, pt = ym(ut.namespace, Xe), Yr = L0(ut.ancestorInfo, Xe);
        return {
          namespace: pt,
          ancestorInfo: Yr
        };
      }
    }
    function lP(Ke) {
      return Ke;
    }
    function aR(Ke) {
      J1 = Wl(), ex = TC();
      var Xe = null;
      return Ua(!1), Xe;
    }
    function lR(Ke) {
      bC(ex), Ua(J1), J1 = null, ex = null;
    }
    function uR(Ke, Xe, it, ut, pt) {
      var Yr;
      {
        var Qr = ut;
        if (A0(Ke, null, Qr.ancestorInfo), typeof Xe.children == "string" || typeof Xe.children == "number") {
          var ni = "" + Xe.children, oi = L0(Qr.ancestorInfo, Ke);
          A0(null, ni, oi);
        }
        Yr = Qr.namespace;
      }
      var vi = VC(Ke, Xe, it, Yr);
      return M0(pt, vi), lx(vi, Xe), vi;
    }
    function cR(Ke, Xe) {
      Ke.appendChild(Xe);
    }
    function dR(Ke, Xe, it, ut, pt) {
      switch (WC(Ke, Xe, it, ut), Xe) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!it.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function fR(Ke, Xe, it, ut, pt, Yr) {
      {
        var Qr = Yr;
        if (typeof ut.children != typeof it.children && (typeof ut.children == "string" || typeof ut.children == "number")) {
          var ni = "" + ut.children, oi = L0(Qr.ancestorInfo, Xe);
          A0(null, ni, oi);
        }
      }
      return KC(Ke, Xe, it, ut);
    }
    function tx(Ke, Xe) {
      return Ke === "textarea" || Ke === "noscript" || typeof Xe.children == "string" || typeof Xe.children == "number" || typeof Xe.dangerouslySetInnerHTML == "object" && Xe.dangerouslySetInnerHTML !== null && Xe.dangerouslySetInnerHTML.__html != null;
    }
    function hR(Ke, Xe, it, ut) {
      {
        var pt = it;
        A0(null, Ke, pt.ancestorInfo);
      }
      var Yr = jC(Ke, Xe);
      return M0(ut, Yr), Yr;
    }
    function pR() {
      var Ke = window.event;
      return Ke === void 0 ? ac : hl(Ke.type);
    }
    var nx = typeof setTimeout == "function" ? setTimeout : void 0, gR = typeof clearTimeout == "function" ? clearTimeout : void 0, rx = -1, rS = typeof Promise == "function" ? Promise : void 0, mR = typeof queueMicrotask == "function" ? queueMicrotask : typeof rS < "u" ? function(Ke) {
      return rS.resolve(null).then(Ke).catch(vR);
    } : nx;
    function vR(Ke) {
      setTimeout(function() {
        throw Ke;
      });
    }
    function yR(Ke, Xe, it, ut) {
      switch (Xe) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          it.autoFocus && Ke.focus();
          return;
        case "img": {
          it.src && (Ke.src = it.src);
          return;
        }
      }
    }
    function ER(Ke, Xe, it, ut, pt, Yr) {
      qC(Ke, Xe, it, ut, pt), lx(Ke, pt);
    }
    function iS(Ke) {
      Ap(Ke, "");
    }
    function xR(Ke, Xe, it) {
      Ke.nodeValue = it;
    }
    function TR(Ke, Xe) {
      Ke.appendChild(Xe);
    }
    function bR(Ke, Xe) {
      var it;
      Ke.nodeType === Sa ? (it = Ke.parentNode, it.insertBefore(Xe, Ke)) : (it = Ke, it.appendChild(Xe));
      var ut = Ke._reactRootContainer;
      ut == null && it.onclick === null && By(it);
    }
    function SR(Ke, Xe, it) {
      Ke.insertBefore(Xe, it);
    }
    function _R(Ke, Xe, it) {
      Ke.nodeType === Sa ? Ke.parentNode.insertBefore(Xe, it) : Ke.insertBefore(Xe, it);
    }
    function wR(Ke, Xe) {
      Ke.removeChild(Xe);
    }
    function RR(Ke, Xe) {
      Ke.nodeType === Sa ? Ke.parentNode.removeChild(Xe) : Ke.removeChild(Xe);
    }
    function ix(Ke, Xe) {
      var it = Xe, ut = 0;
      do {
        var pt = it.nextSibling;
        if (Ke.removeChild(it), pt && pt.nodeType === Sa) {
          var Yr = pt.data;
          if (Yr === Hy)
            if (ut === 0) {
              Ke.removeChild(pt), bo(Xe);
              return;
            } else
              ut--;
          else
            (Yr === Gy || Yr === I0 || Yr === P0) && ut++;
        }
        it = pt;
      } while (it);
      bo(Xe);
    }
    function AR(Ke, Xe) {
      Ke.nodeType === Sa ? ix(Ke.parentNode, Xe) : Ke.nodeType === Cl && ix(Ke, Xe), bo(Ke);
    }
    function LR(Ke) {
      Ke = Ke;
      var Xe = Ke.style;
      typeof Xe.setProperty == "function" ? Xe.setProperty("display", "none", "important") : Xe.display = "none";
    }
    function IR(Ke) {
      Ke.nodeValue = "";
    }
    function PR(Ke, Xe) {
      Ke = Ke;
      var it = Xe[iR], ut = it != null && it.hasOwnProperty("display") ? it.display : null;
      Ke.style.display = Lp("display", ut);
    }
    function DR(Ke, Xe) {
      Ke.nodeValue = Xe;
    }
    function OR(Ke) {
      Ke.nodeType === Cl ? Ke.textContent = "" : Ke.nodeType === bu && Ke.documentElement && Ke.removeChild(Ke.documentElement);
    }
    function MR(Ke, Xe, it) {
      return Ke.nodeType !== Cl || Xe.toLowerCase() !== Ke.nodeName.toLowerCase() ? null : Ke;
    }
    function kR(Ke, Xe) {
      return Xe === "" || Ke.nodeType !== Zu ? null : Ke;
    }
    function NR(Ke) {
      return Ke.nodeType !== Sa ? null : Ke;
    }
    function sS(Ke) {
      return Ke.data === I0;
    }
    function sx(Ke) {
      return Ke.data === P0;
    }
    function FR(Ke) {
      var Xe = Ke.nextSibling && Ke.nextSibling.dataset, it, ut, pt;
      return Xe && (it = Xe.dgst, ut = Xe.msg, pt = Xe.stck), {
        message: ut,
        digest: it,
        stack: pt
      };
    }
    function $R(Ke, Xe) {
      Ke._reactRetry = Xe;
    }
    function zy(Ke) {
      for (; Ke != null; Ke = Ke.nextSibling) {
        var Xe = Ke.nodeType;
        if (Xe === Cl || Xe === Zu)
          break;
        if (Xe === Sa) {
          var it = Ke.data;
          if (it === Gy || it === P0 || it === I0)
            break;
          if (it === Hy)
            return null;
        }
      }
      return Ke;
    }
    function D0(Ke) {
      return zy(Ke.nextSibling);
    }
    function BR(Ke) {
      return zy(Ke.firstChild);
    }
    function UR(Ke) {
      return zy(Ke.firstChild);
    }
    function GR(Ke) {
      return zy(Ke.nextSibling);
    }
    function HR(Ke, Xe, it, ut, pt, Yr, Qr) {
      M0(Yr, Ke), lx(Ke, it);
      var ni;
      {
        var oi = pt;
        ni = oi.namespace;
      }
      var vi = (Yr.mode & Eo) !== Xs;
      return XC(Ke, Xe, it, ni, ut, vi, Qr);
    }
    function zR(Ke, Xe, it, ut) {
      return M0(it, Ke), it.mode & Eo, ZC(Ke, Xe);
    }
    function VR(Ke, Xe) {
      M0(Xe, Ke);
    }
    function jR(Ke) {
      for (var Xe = Ke.nextSibling, it = 0; Xe; ) {
        if (Xe.nodeType === Sa) {
          var ut = Xe.data;
          if (ut === Hy) {
            if (it === 0)
              return D0(Xe);
            it--;
          } else
            (ut === Gy || ut === P0 || ut === I0) && it++;
        }
        Xe = Xe.nextSibling;
      }
      return null;
    }
    function oS(Ke) {
      for (var Xe = Ke.previousSibling, it = 0; Xe; ) {
        if (Xe.nodeType === Sa) {
          var ut = Xe.data;
          if (ut === Gy || ut === P0 || ut === I0) {
            if (it === 0)
              return Xe;
            it--;
          } else
            ut === Hy && it++;
        }
        Xe = Xe.previousSibling;
      }
      return null;
    }
    function WR(Ke) {
      bo(Ke);
    }
    function KR(Ke) {
      bo(Ke);
    }
    function qR(Ke) {
      return Ke !== "head" && Ke !== "body";
    }
    function YR(Ke, Xe, it, ut) {
      var pt = !0;
      $y(Xe.nodeValue, it, ut, pt);
    }
    function XR(Ke, Xe, it, ut, pt, Yr) {
      if (Xe[Uy] !== !0) {
        var Qr = !0;
        $y(ut.nodeValue, pt, Yr, Qr);
      }
    }
    function ZR(Ke, Xe) {
      Xe.nodeType === Cl ? Y1(Ke, Xe) : Xe.nodeType === Sa || X1(Ke, Xe);
    }
    function QR(Ke, Xe) {
      {
        var it = Ke.parentNode;
        it !== null && (Xe.nodeType === Cl ? Y1(it, Xe) : Xe.nodeType === Sa || X1(it, Xe));
      }
    }
    function JR(Ke, Xe, it, ut, pt) {
      (pt || Xe[Uy] !== !0) && (ut.nodeType === Cl ? Y1(it, ut) : ut.nodeType === Sa || X1(it, ut));
    }
    function e2(Ke, Xe, it) {
      Z1(Ke, Xe);
    }
    function t2(Ke, Xe) {
      Q1(Ke, Xe);
    }
    function n2(Ke, Xe, it) {
      {
        var ut = Ke.parentNode;
        ut !== null && Z1(ut, Xe);
      }
    }
    function r2(Ke, Xe) {
      {
        var it = Ke.parentNode;
        it !== null && Q1(it, Xe);
      }
    }
    function i2(Ke, Xe, it, ut, pt, Yr) {
      (Yr || Xe[Uy] !== !0) && Z1(it, ut);
    }
    function s2(Ke, Xe, it, ut, pt) {
      (pt || Xe[Uy] !== !0) && Q1(it, ut);
    }
    function o2(Ke) {
      be("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", Ke.nodeName.toLowerCase());
    }
    function a2(Ke) {
      _0(Ke);
    }
    var kg = Math.random().toString(36).slice(2), Ng = "__reactFiber$" + kg, ox = "__reactProps$" + kg, O0 = "__reactContainer$" + kg, ax = "__reactEvents$" + kg, l2 = "__reactListeners$" + kg, u2 = "__reactHandles$" + kg;
    function c2(Ke) {
      delete Ke[Ng], delete Ke[ox], delete Ke[ax], delete Ke[l2], delete Ke[u2];
    }
    function M0(Ke, Xe) {
      Xe[Ng] = Ke;
    }
    function Vy(Ke, Xe) {
      Xe[O0] = Ke;
    }
    function aS(Ke) {
      Ke[O0] = null;
    }
    function k0(Ke) {
      return !!Ke[O0];
    }
    function rp(Ke) {
      var Xe = Ke[Ng];
      if (Xe)
        return Xe;
      for (var it = Ke.parentNode; it; ) {
        if (Xe = it[O0] || it[Ng], Xe) {
          var ut = Xe.alternate;
          if (Xe.child !== null || ut !== null && ut.child !== null)
            for (var pt = oS(Ke); pt !== null; ) {
              var Yr = pt[Ng];
              if (Yr)
                return Yr;
              pt = oS(pt);
            }
          return Xe;
        }
        Ke = it, it = Ke.parentNode;
      }
      return null;
    }
    function Zf(Ke) {
      var Xe = Ke[Ng] || Ke[O0];
      return Xe && (Xe.tag === lt || Xe.tag === ft || Xe.tag === ei || Xe.tag === st) ? Xe : null;
    }
    function Fg(Ke) {
      if (Ke.tag === lt || Ke.tag === ft)
        return Ke.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function jy(Ke) {
      return Ke[ox] || null;
    }
    function lx(Ke, Xe) {
      Ke[ox] = Xe;
    }
    function d2(Ke) {
      var Xe = Ke[ax];
      return Xe === void 0 && (Xe = Ke[ax] = /* @__PURE__ */ new Set()), Xe;
    }
    var lS = {}, uS = ee.ReactDebugCurrentFrame;
    function Wy(Ke) {
      if (Ke) {
        var Xe = Ke._owner, it = Pu(Ke.type, Ke._source, Xe ? Xe.type : null);
        uS.setExtraStackFrame(it);
      } else
        uS.setExtraStackFrame(null);
    }
    function fc(Ke, Xe, it, ut, pt) {
      {
        var Yr = Function.call.bind(bi);
        for (var Qr in Ke)
          if (Yr(Ke, Qr)) {
            var ni = void 0;
            try {
              if (typeof Ke[Qr] != "function") {
                var oi = Error((ut || "React class") + ": " + it + " type `" + Qr + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Ke[Qr] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw oi.name = "Invariant Violation", oi;
              }
              ni = Ke[Qr](Xe, Qr, ut, it, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (vi) {
              ni = vi;
            }
            ni && !(ni instanceof Error) && (Wy(pt), be("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ut || "React class", it, Qr, typeof ni), Wy(null)), ni instanceof Error && !(ni.message in lS) && (lS[ni.message] = !0, Wy(pt), be("Failed %s type: %s", it, ni.message), Wy(null));
          }
      }
    }
    var ux = [], Ky;
    Ky = [];
    var Yd = -1;
    function Qf(Ke) {
      return {
        current: Ke
      };
    }
    function kl(Ke, Xe) {
      if (Yd < 0) {
        be("Unexpected pop.");
        return;
      }
      Xe !== Ky[Yd] && be("Unexpected Fiber popped."), Ke.current = ux[Yd], ux[Yd] = null, Ky[Yd] = null, Yd--;
    }
    function Nl(Ke, Xe, it) {
      Yd++, ux[Yd] = Ke.current, Ky[Yd] = it, Ke.current = Xe;
    }
    var cx;
    cx = {};
    var Ru = {};
    Object.freeze(Ru);
    var Xd = Qf(Ru), od = Qf(!1), dx = Ru;
    function $g(Ke, Xe, it) {
      return it && ad(Xe) ? dx : Xd.current;
    }
    function cS(Ke, Xe, it) {
      {
        var ut = Ke.stateNode;
        ut.__reactInternalMemoizedUnmaskedChildContext = Xe, ut.__reactInternalMemoizedMaskedChildContext = it;
      }
    }
    function Bg(Ke, Xe) {
      {
        var it = Ke.type, ut = it.contextTypes;
        if (!ut)
          return Ru;
        var pt = Ke.stateNode;
        if (pt && pt.__reactInternalMemoizedUnmaskedChildContext === Xe)
          return pt.__reactInternalMemoizedMaskedChildContext;
        var Yr = {};
        for (var Qr in ut)
          Yr[Qr] = Xe[Qr];
        {
          var ni = uo(Ke) || "Unknown";
          fc(ut, Yr, "context", ni);
        }
        return pt && cS(Ke, Xe, Yr), Yr;
      }
    }
    function qy() {
      return od.current;
    }
    function ad(Ke) {
      {
        var Xe = Ke.childContextTypes;
        return Xe != null;
      }
    }
    function Yy(Ke) {
      kl(od, Ke), kl(Xd, Ke);
    }
    function fx(Ke) {
      kl(od, Ke), kl(Xd, Ke);
    }
    function dS(Ke, Xe, it) {
      {
        if (Xd.current !== Ru)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Nl(Xd, Xe, Ke), Nl(od, it, Ke);
      }
    }
    function fS(Ke, Xe, it) {
      {
        var ut = Ke.stateNode, pt = Xe.childContextTypes;
        if (typeof ut.getChildContext != "function") {
          {
            var Yr = uo(Ke) || "Unknown";
            cx[Yr] || (cx[Yr] = !0, be("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", Yr, Yr));
          }
          return it;
        }
        var Qr = ut.getChildContext();
        for (var ni in Qr)
          if (!(ni in pt))
            throw new Error((uo(Ke) || "Unknown") + '.getChildContext(): key "' + ni + '" is not defined in childContextTypes.');
        {
          var oi = uo(Ke) || "Unknown";
          fc(pt, Qr, "child context", oi);
        }
        return vo({}, it, Qr);
      }
    }
    function Xy(Ke) {
      {
        var Xe = Ke.stateNode, it = Xe && Xe.__reactInternalMemoizedMergedChildContext || Ru;
        return dx = Xd.current, Nl(Xd, it, Ke), Nl(od, od.current, Ke), !0;
      }
    }
    function hS(Ke, Xe, it) {
      {
        var ut = Ke.stateNode;
        if (!ut)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (it) {
          var pt = fS(Ke, Xe, dx);
          ut.__reactInternalMemoizedMergedChildContext = pt, kl(od, Ke), kl(Xd, Ke), Nl(Xd, pt, Ke), Nl(od, it, Ke);
        } else
          kl(od, Ke), Nl(od, it, Ke);
      }
    }
    function f2(Ke) {
      {
        if (!$m(Ke) || Ke.tag !== Je)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var Xe = Ke;
        do {
          switch (Xe.tag) {
            case st:
              return Xe.stateNode.context;
            case Je: {
              var it = Xe.type;
              if (ad(it))
                return Xe.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          Xe = Xe.return;
        } while (Xe !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Jf = 0, Zy = 1, Zd = null, hx = !1, px = !1;
    function pS(Ke) {
      Zd === null ? Zd = [Ke] : Zd.push(Ke);
    }
    function h2(Ke) {
      hx = !0, pS(Ke);
    }
    function gS() {
      hx && eh();
    }
    function eh() {
      if (!px && Zd !== null) {
        px = !0;
        var Ke = 0, Xe = uu();
        try {
          var it = !0, ut = Zd;
          for (Pa(nl); Ke < ut.length; Ke++) {
            var pt = ut[Ke];
            do
              pt = pt(it);
            while (pt !== null);
          }
          Zd = null, hx = !1;
        } catch (Yr) {
          throw Zd !== null && (Zd = Zd.slice(Ke + 1)), Up(Hp, eh), Yr;
        } finally {
          Pa(Xe), px = !1;
        }
      }
      return null;
    }
    var Ug = [], Gg = 0, Qy = null, Jy = 0, Uu = [], Gu = 0, ip = null, Qd = 1, Jd = "";
    function g2(Ke) {
      return op(), (Ke.flags & km) !== js;
    }
    function m2(Ke) {
      return op(), Jy;
    }
    function v2() {
      var Ke = Jd, Xe = Qd, it = Xe & ~y2(Xe);
      return it.toString(32) + Ke;
    }
    function sp(Ke, Xe) {
      op(), Ug[Gg++] = Jy, Ug[Gg++] = Qy, Qy = Ke, Jy = Xe;
    }
    function mS(Ke, Xe, it) {
      op(), Uu[Gu++] = Qd, Uu[Gu++] = Jd, Uu[Gu++] = ip, ip = Ke;
      var ut = Qd, pt = Jd, Yr = eE(ut) - 1, Qr = ut & ~(1 << Yr), ni = it + 1, oi = eE(Xe) + Yr;
      if (oi > 30) {
        var vi = Yr - Yr % 5, Ei = (1 << vi) - 1, Ni = (Qr & Ei).toString(32), Mi = Qr >> vi, zi = Yr - vi, ji = eE(Xe) + zi, Xi = ni << zi, Cs = Xi | Mi, qs = Ni + pt;
        Qd = 1 << ji | Cs, Jd = qs;
      } else {
        var $s = ni << Yr, Ro = $s | Qr, So = pt;
        Qd = 1 << oi | Ro, Jd = So;
      }
    }
    function gx(Ke) {
      op();
      var Xe = Ke.return;
      if (Xe !== null) {
        var it = 1, ut = 0;
        sp(Ke, it), mS(Ke, it, ut);
      }
    }
    function eE(Ke) {
      return 32 - qp(Ke);
    }
    function y2(Ke) {
      return 1 << eE(Ke) - 1;
    }
    function mx(Ke) {
      for (; Ke === Qy; )
        Qy = Ug[--Gg], Ug[Gg] = null, Jy = Ug[--Gg], Ug[Gg] = null;
      for (; Ke === ip; )
        ip = Uu[--Gu], Uu[Gu] = null, Jd = Uu[--Gu], Uu[Gu] = null, Qd = Uu[--Gu], Uu[Gu] = null;
    }
    function E2() {
      return op(), ip !== null ? {
        id: Qd,
        overflow: Jd
      } : null;
    }
    function x2(Ke, Xe) {
      op(), Uu[Gu++] = Qd, Uu[Gu++] = Jd, Uu[Gu++] = ip, Qd = Xe.id, Jd = Xe.overflow, ip = Ke;
    }
    function op() {
      gl() || be("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var pl = null, Hu = null, hc = !1, ap = !1, th = null;
    function T2() {
      hc && be("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function vS() {
      ap = !0;
    }
    function b2() {
      return ap;
    }
    function S2(Ke) {
      var Xe = Ke.stateNode.containerInfo;
      return Hu = UR(Xe), pl = Ke, hc = !0, th = null, ap = !1, !0;
    }
    function _2(Ke, Xe, it) {
      return Hu = GR(Xe), pl = Ke, hc = !0, th = null, ap = !1, it !== null && x2(Ke, it), !0;
    }
    function yS(Ke, Xe) {
      switch (Ke.tag) {
        case st: {
          ZR(Ke.stateNode.containerInfo, Xe);
          break;
        }
        case lt: {
          var it = (Ke.mode & Eo) !== Xs;
          JR(
            Ke.type,
            Ke.memoizedProps,
            Ke.stateNode,
            Xe,
            // TODO: Delete this argument when we remove the legacy root API.
            it
          );
          break;
        }
        case ei: {
          var ut = Ke.memoizedState;
          ut.dehydrated !== null && QR(ut.dehydrated, Xe);
          break;
        }
      }
    }
    function ES(Ke, Xe) {
      yS(Ke, Xe);
      var it = RI();
      it.stateNode = Xe, it.return = Ke;
      var ut = Ke.deletions;
      ut === null ? (Ke.deletions = [it], Ke.flags |= ko) : ut.push(it);
    }
    function vx(Ke, Xe) {
      {
        if (ap)
          return;
        switch (Ke.tag) {
          case st: {
            var it = Ke.stateNode.containerInfo;
            switch (Xe.tag) {
              case lt:
                var ut = Xe.type;
                Xe.pendingProps, e2(it, ut);
                break;
              case ft:
                var pt = Xe.pendingProps;
                t2(it, pt);
                break;
            }
            break;
          }
          case lt: {
            var Yr = Ke.type, Qr = Ke.memoizedProps, ni = Ke.stateNode;
            switch (Xe.tag) {
              case lt: {
                var oi = Xe.type, vi = Xe.pendingProps, Ei = (Ke.mode & Eo) !== Xs;
                i2(
                  Yr,
                  Qr,
                  ni,
                  oi,
                  vi,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Ei
                );
                break;
              }
              case ft: {
                var Ni = Xe.pendingProps, Mi = (Ke.mode & Eo) !== Xs;
                s2(
                  Yr,
                  Qr,
                  ni,
                  Ni,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Mi
                );
                break;
              }
            }
            break;
          }
          case ei: {
            var zi = Ke.memoizedState, ji = zi.dehydrated;
            if (ji !== null)
              switch (Xe.tag) {
                case lt:
                  var Xi = Xe.type;
                  Xe.pendingProps, n2(ji, Xi);
                  break;
                case ft:
                  var Cs = Xe.pendingProps;
                  r2(ji, Cs);
                  break;
              }
            break;
          }
          default:
            return;
        }
      }
    }
    function xS(Ke, Xe) {
      Xe.flags = Xe.flags & ~iu | Xo, vx(Ke, Xe);
    }
    function TS(Ke, Xe) {
      switch (Ke.tag) {
        case lt: {
          var it = Ke.type;
          Ke.pendingProps;
          var ut = MR(Xe, it);
          return ut !== null ? (Ke.stateNode = ut, pl = Ke, Hu = BR(ut), !0) : !1;
        }
        case ft: {
          var pt = Ke.pendingProps, Yr = kR(Xe, pt);
          return Yr !== null ? (Ke.stateNode = Yr, pl = Ke, Hu = null, !0) : !1;
        }
        case ei: {
          var Qr = NR(Xe);
          if (Qr !== null) {
            var ni = {
              dehydrated: Qr,
              treeContext: E2(),
              retryLane: Ol
            };
            Ke.memoizedState = ni;
            var oi = AI(Qr);
            return oi.return = Ke, Ke.child = oi, pl = Ke, Hu = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function yx(Ke) {
      return (Ke.mode & Eo) !== Xs && (Ke.flags & io) === js;
    }
    function Ex(Ke) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function xx(Ke) {
      if (hc) {
        var Xe = Hu;
        if (!Xe) {
          yx(Ke) && (vx(pl, Ke), Ex()), xS(pl, Ke), hc = !1, pl = Ke;
          return;
        }
        var it = Xe;
        if (!TS(Ke, Xe)) {
          yx(Ke) && (vx(pl, Ke), Ex()), Xe = D0(it);
          var ut = pl;
          if (!Xe || !TS(Ke, Xe)) {
            xS(pl, Ke), hc = !1, pl = Ke;
            return;
          }
          ES(ut, it);
        }
      }
    }
    function w2(Ke, Xe, it) {
      var ut = Ke.stateNode, pt = !ap, Yr = HR(ut, Ke.type, Ke.memoizedProps, Xe, it, Ke, pt);
      return Ke.updateQueue = Yr, Yr !== null;
    }
    function C2(Ke) {
      var Xe = Ke.stateNode, it = Ke.memoizedProps, ut = zR(Xe, it, Ke);
      if (ut) {
        var pt = pl;
        if (pt !== null)
          switch (pt.tag) {
            case st: {
              var Yr = pt.stateNode.containerInfo, Qr = (pt.mode & Eo) !== Xs;
              YR(
                Yr,
                Xe,
                it,
                // TODO: Delete this argument when we remove the legacy root API.
                Qr
              );
              break;
            }
            case lt: {
              var ni = pt.type, oi = pt.memoizedProps, vi = pt.stateNode, Ei = (pt.mode & Eo) !== Xs;
              XR(
                ni,
                oi,
                vi,
                Xe,
                it,
                // TODO: Delete this argument when we remove the legacy root API.
                Ei
              );
              break;
            }
          }
      }
      return ut;
    }
    function R2(Ke) {
      var Xe = Ke.memoizedState, it = Xe !== null ? Xe.dehydrated : null;
      if (!it)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      VR(it, Ke);
    }
    function A2(Ke) {
      var Xe = Ke.memoizedState, it = Xe !== null ? Xe.dehydrated : null;
      if (!it)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return jR(it);
    }
    function bS(Ke) {
      for (var Xe = Ke.return; Xe !== null && Xe.tag !== lt && Xe.tag !== st && Xe.tag !== ei; )
        Xe = Xe.return;
      pl = Xe;
    }
    function tE(Ke) {
      if (Ke !== pl)
        return !1;
      if (!hc)
        return bS(Ke), hc = !0, !1;
      if (Ke.tag !== st && (Ke.tag !== lt || qR(Ke.type) && !tx(Ke.type, Ke.memoizedProps))) {
        var Xe = Hu;
        if (Xe)
          if (yx(Ke))
            SS(Ke), Ex();
          else
            for (; Xe; )
              ES(Ke, Xe), Xe = D0(Xe);
      }
      return bS(Ke), Ke.tag === ei ? Hu = A2(Ke) : Hu = pl ? D0(Ke.stateNode) : null, !0;
    }
    function L2() {
      return hc && Hu !== null;
    }
    function SS(Ke) {
      for (var Xe = Hu; Xe; )
        yS(Ke, Xe), Xe = D0(Xe);
    }
    function Hg() {
      pl = null, Hu = null, hc = !1, ap = !1;
    }
    function _S() {
      th !== null && (yw(th), th = null);
    }
    function gl() {
      return hc;
    }
    function Tx(Ke) {
      th === null ? th = [Ke] : th.push(Ke);
    }
    var I2 = ee.ReactCurrentBatchConfig, P2 = null;
    function D2() {
      return I2.transition;
    }
    var pc = {
      recordUnsafeLifecycleWarnings: function(Ke, Xe) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(Ke, Xe) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var O2 = function(Ke) {
        for (var Xe = null, it = Ke; it !== null; )
          it.mode & aa && (Xe = it), it = it.return;
        return Xe;
      }, lp = function(Ke) {
        var Xe = [];
        return Ke.forEach(function(it) {
          Xe.push(it);
        }), Xe.sort().join(", ");
      }, N0 = [], F0 = [], $0 = [], B0 = [], U0 = [], G0 = [], up = /* @__PURE__ */ new Set();
      pc.recordUnsafeLifecycleWarnings = function(Ke, Xe) {
        up.has(Ke.type) || (typeof Xe.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        Xe.componentWillMount.__suppressDeprecationWarning !== !0 && N0.push(Ke), Ke.mode & aa && typeof Xe.UNSAFE_componentWillMount == "function" && F0.push(Ke), typeof Xe.componentWillReceiveProps == "function" && Xe.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && $0.push(Ke), Ke.mode & aa && typeof Xe.UNSAFE_componentWillReceiveProps == "function" && B0.push(Ke), typeof Xe.componentWillUpdate == "function" && Xe.componentWillUpdate.__suppressDeprecationWarning !== !0 && U0.push(Ke), Ke.mode & aa && typeof Xe.UNSAFE_componentWillUpdate == "function" && G0.push(Ke));
      }, pc.flushPendingUnsafeLifecycleWarnings = function() {
        var Ke = /* @__PURE__ */ new Set();
        N0.length > 0 && (N0.forEach(function(Mi) {
          Ke.add(uo(Mi) || "Component"), up.add(Mi.type);
        }), N0 = []);
        var Xe = /* @__PURE__ */ new Set();
        F0.length > 0 && (F0.forEach(function(Mi) {
          Xe.add(uo(Mi) || "Component"), up.add(Mi.type);
        }), F0 = []);
        var it = /* @__PURE__ */ new Set();
        $0.length > 0 && ($0.forEach(function(Mi) {
          it.add(uo(Mi) || "Component"), up.add(Mi.type);
        }), $0 = []);
        var ut = /* @__PURE__ */ new Set();
        B0.length > 0 && (B0.forEach(function(Mi) {
          ut.add(uo(Mi) || "Component"), up.add(Mi.type);
        }), B0 = []);
        var pt = /* @__PURE__ */ new Set();
        U0.length > 0 && (U0.forEach(function(Mi) {
          pt.add(uo(Mi) || "Component"), up.add(Mi.type);
        }), U0 = []);
        var Yr = /* @__PURE__ */ new Set();
        if (G0.length > 0 && (G0.forEach(function(Mi) {
          Yr.add(uo(Mi) || "Component"), up.add(Mi.type);
        }), G0 = []), Xe.size > 0) {
          var Qr = lp(Xe);
          be(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, Qr);
        }
        if (ut.size > 0) {
          var ni = lp(ut);
          be(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, ni);
        }
        if (Yr.size > 0) {
          var oi = lp(Yr);
          be(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, oi);
        }
        if (Ke.size > 0) {
          var vi = lp(Ke);
          ye(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, vi);
        }
        if (it.size > 0) {
          var Ei = lp(it);
          ye(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Ei);
        }
        if (pt.size > 0) {
          var Ni = lp(pt);
          ye(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Ni);
        }
      };
      var nE = /* @__PURE__ */ new Map(), wS = /* @__PURE__ */ new Set();
      pc.recordLegacyContextWarning = function(Ke, Xe) {
        var it = O2(Ke);
        if (it === null) {
          be("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!wS.has(Ke.type)) {
          var ut = nE.get(it);
          (Ke.type.contextTypes != null || Ke.type.childContextTypes != null || Xe !== null && typeof Xe.getChildContext == "function") && (ut === void 0 && (ut = [], nE.set(it, ut)), ut.push(Ke));
        }
      }, pc.flushLegacyContextWarning = function() {
        nE.forEach(function(Ke, Xe) {
          if (Ke.length !== 0) {
            var it = Ke[0], ut = /* @__PURE__ */ new Set();
            Ke.forEach(function(Yr) {
              ut.add(uo(Yr) || "Component"), wS.add(Yr.type);
            });
            var pt = lp(ut);
            try {
              No(it), be(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, pt);
            } finally {
              ha();
            }
          }
        });
      }, pc.discardPendingWarnings = function() {
        N0 = [], F0 = [], $0 = [], B0 = [], U0 = [], G0 = [], nE = /* @__PURE__ */ new Map();
      };
    }
    function gc(Ke, Xe) {
      if (Ke && Ke.defaultProps) {
        var it = vo({}, Xe), ut = Ke.defaultProps;
        for (var pt in ut)
          it[pt] === void 0 && (it[pt] = ut[pt]);
        return it;
      }
      return Xe;
    }
    var bx = Qf(null), Sx;
    Sx = {};
    var rE = null, zg = null, _x = null, iE = !1;
    function sE() {
      rE = null, zg = null, _x = null, iE = !1;
    }
    function CS() {
      iE = !0;
    }
    function RS() {
      iE = !1;
    }
    function AS(Ke, Xe, it) {
      Nl(bx, Xe._currentValue, Ke), Xe._currentValue = it, Xe._currentRenderer !== void 0 && Xe._currentRenderer !== null && Xe._currentRenderer !== Sx && be("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), Xe._currentRenderer = Sx;
    }
    function wx(Ke, Xe) {
      var it = bx.current;
      kl(bx, Xe), Ke._currentValue = it;
    }
    function Cx(Ke, Xe, it) {
      for (var ut = Ke; ut !== null; ) {
        var pt = ut.alternate;
        if ($d(ut.childLanes, Xe) ? pt !== null && !$d(pt.childLanes, Xe) && (pt.childLanes = go(pt.childLanes, Xe)) : (ut.childLanes = go(ut.childLanes, Xe), pt !== null && (pt.childLanes = go(pt.childLanes, Xe))), ut === it)
          break;
        ut = ut.return;
      }
      ut !== it && be("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function M2(Ke, Xe, it) {
      k2(Ke, Xe, it);
    }
    function k2(Ke, Xe, it) {
      var ut = Ke.child;
      for (ut !== null && (ut.return = Ke); ut !== null; ) {
        var pt = void 0, Yr = ut.dependencies;
        if (Yr !== null) {
          pt = ut.child;
          for (var Qr = Yr.firstContext; Qr !== null; ) {
            if (Qr.context === Xe) {
              if (ut.tag === Je) {
                var ni = Ia(it), oi = ef(jo, ni);
                oi.tag = aE;
                var vi = ut.updateQueue;
                if (vi !== null) {
                  var Ei = vi.shared, Ni = Ei.pending;
                  Ni === null ? oi.next = oi : (oi.next = Ni.next, Ni.next = oi), Ei.pending = oi;
                }
              }
              ut.lanes = go(ut.lanes, it);
              var Mi = ut.alternate;
              Mi !== null && (Mi.lanes = go(Mi.lanes, it)), Cx(ut.return, it, Ke), Yr.lanes = go(Yr.lanes, it);
              break;
            }
            Qr = Qr.next;
          }
        } else if (ut.tag === Kr)
          pt = ut.type === Ke.type ? null : ut.child;
        else if (ut.tag === pi) {
          var zi = ut.return;
          if (zi === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          zi.lanes = go(zi.lanes, it);
          var ji = zi.alternate;
          ji !== null && (ji.lanes = go(ji.lanes, it)), Cx(zi, it, Ke), pt = ut.sibling;
        } else
          pt = ut.child;
        if (pt !== null)
          pt.return = ut;
        else
          for (pt = ut; pt !== null; ) {
            if (pt === Ke) {
              pt = null;
              break;
            }
            var Xi = pt.sibling;
            if (Xi !== null) {
              Xi.return = pt.return, pt = Xi;
              break;
            }
            pt = pt.return;
          }
        ut = pt;
      }
    }
    function Vg(Ke, Xe) {
      rE = Ke, zg = null, _x = null;
      var it = Ke.dependencies;
      if (it !== null) {
        var ut = it.firstContext;
        ut !== null && (Ml(it.lanes, Xe) && tv(), it.firstContext = null);
      }
    }
    function Ha(Ke) {
      iE && be("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var Xe = Ke._currentValue;
      if (_x !== Ke) {
        var it = {
          context: Ke,
          memoizedValue: Xe,
          next: null
        };
        if (zg === null) {
          if (rE === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          zg = it, rE.dependencies = {
            lanes: Ji,
            firstContext: it
          };
        } else
          zg = zg.next = it;
      }
      return Xe;
    }
    var cp = null;
    function Rx(Ke) {
      cp === null ? cp = [Ke] : cp.push(Ke);
    }
    function N2() {
      if (cp !== null) {
        for (var Ke = 0; Ke < cp.length; Ke++) {
          var Xe = cp[Ke], it = Xe.interleaved;
          if (it !== null) {
            Xe.interleaved = null;
            var ut = it.next, pt = Xe.pending;
            if (pt !== null) {
              var Yr = pt.next;
              pt.next = ut, it.next = Yr;
            }
            Xe.pending = it;
          }
        }
        cp = null;
      }
    }
    function LS(Ke, Xe, it, ut) {
      var pt = Xe.interleaved;
      return pt === null ? (it.next = it, Rx(Xe)) : (it.next = pt.next, pt.next = it), Xe.interleaved = it, oE(Ke, ut);
    }
    function F2(Ke, Xe, it, ut) {
      var pt = Xe.interleaved;
      pt === null ? (it.next = it, Rx(Xe)) : (it.next = pt.next, pt.next = it), Xe.interleaved = it;
    }
    function $2(Ke, Xe, it, ut) {
      var pt = Xe.interleaved;
      return pt === null ? (it.next = it, Rx(Xe)) : (it.next = pt.next, pt.next = it), Xe.interleaved = it, oE(Ke, ut);
    }
    function pu(Ke, Xe) {
      return oE(Ke, Xe);
    }
    var B2 = oE;
    function oE(Ke, Xe) {
      Ke.lanes = go(Ke.lanes, Xe);
      var it = Ke.alternate;
      it !== null && (it.lanes = go(it.lanes, Xe)), it === null && (Ke.flags & (Xo | iu)) !== js && Iw(Ke);
      for (var ut = Ke, pt = Ke.return; pt !== null; )
        pt.childLanes = go(pt.childLanes, Xe), it = pt.alternate, it !== null ? it.childLanes = go(it.childLanes, Xe) : (pt.flags & (Xo | iu)) !== js && Iw(Ke), ut = pt, pt = pt.return;
      if (ut.tag === st) {
        var Yr = ut.stateNode;
        return Yr;
      } else
        return null;
    }
    var IS = 0, PS = 1, aE = 2, Ax = 3, lE = !1, Lx, uE;
    Lx = !1, uE = null;
    function Ix(Ke) {
      var Xe = {
        baseState: Ke.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: Ji
        },
        effects: null
      };
      Ke.updateQueue = Xe;
    }
    function DS(Ke, Xe) {
      var it = Xe.updateQueue, ut = Ke.updateQueue;
      if (it === ut) {
        var pt = {
          baseState: ut.baseState,
          firstBaseUpdate: ut.firstBaseUpdate,
          lastBaseUpdate: ut.lastBaseUpdate,
          shared: ut.shared,
          effects: ut.effects
        };
        Xe.updateQueue = pt;
      }
    }
    function ef(Ke, Xe) {
      var it = {
        eventTime: Ke,
        lane: Xe,
        tag: IS,
        payload: null,
        callback: null,
        next: null
      };
      return it;
    }
    function nh(Ke, Xe, it) {
      var ut = Ke.updateQueue;
      if (ut === null)
        return null;
      var pt = ut.shared;
      if (uE === pt && !Lx && (be("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), Lx = !0), BL()) {
        var Yr = pt.pending;
        return Yr === null ? Xe.next = Xe : (Xe.next = Yr.next, Yr.next = Xe), pt.pending = Xe, B2(Ke, it);
      } else
        return $2(Ke, pt, Xe, it);
    }
    function cE(Ke, Xe, it) {
      var ut = Xe.updateQueue;
      if (ut !== null) {
        var pt = ut.shared;
        if (Zm(it)) {
          var Yr = pt.lanes;
          Yr = Jm(Yr, Ke.pendingLanes);
          var Qr = go(Yr, it);
          pt.lanes = Qr, Nf(Ke, Qr);
        }
      }
    }
    function Px(Ke, Xe) {
      var it = Ke.updateQueue, ut = Ke.alternate;
      if (ut !== null) {
        var pt = ut.updateQueue;
        if (it === pt) {
          var Yr = null, Qr = null, ni = it.firstBaseUpdate;
          if (ni !== null) {
            var oi = ni;
            do {
              var vi = {
                eventTime: oi.eventTime,
                lane: oi.lane,
                tag: oi.tag,
                payload: oi.payload,
                callback: oi.callback,
                next: null
              };
              Qr === null ? Yr = Qr = vi : (Qr.next = vi, Qr = vi), oi = oi.next;
            } while (oi !== null);
            Qr === null ? Yr = Qr = Xe : (Qr.next = Xe, Qr = Xe);
          } else
            Yr = Qr = Xe;
          it = {
            baseState: pt.baseState,
            firstBaseUpdate: Yr,
            lastBaseUpdate: Qr,
            shared: pt.shared,
            effects: pt.effects
          }, Ke.updateQueue = it;
          return;
        }
      }
      var Ei = it.lastBaseUpdate;
      Ei === null ? it.firstBaseUpdate = Xe : Ei.next = Xe, it.lastBaseUpdate = Xe;
    }
    function U2(Ke, Xe, it, ut, pt, Yr) {
      switch (it.tag) {
        case PS: {
          var Qr = it.payload;
          if (typeof Qr == "function") {
            CS();
            var ni = Qr.call(Yr, ut, pt);
            {
              if (Ke.mode & aa) {
                La(!0);
                try {
                  Qr.call(Yr, ut, pt);
                } finally {
                  La(!1);
                }
              }
              RS();
            }
            return ni;
          }
          return Qr;
        }
        case Ax:
          Ke.flags = Ke.flags & ~Fa | io;
        case IS: {
          var oi = it.payload, vi;
          if (typeof oi == "function") {
            CS(), vi = oi.call(Yr, ut, pt);
            {
              if (Ke.mode & aa) {
                La(!0);
                try {
                  oi.call(Yr, ut, pt);
                } finally {
                  La(!1);
                }
              }
              RS();
            }
          } else
            vi = oi;
          return vi == null ? ut : vo({}, ut, vi);
        }
        case aE:
          return lE = !0, ut;
      }
      return ut;
    }
    function dE(Ke, Xe, it, ut) {
      var pt = Ke.updateQueue;
      lE = !1, uE = pt.shared;
      var Yr = pt.firstBaseUpdate, Qr = pt.lastBaseUpdate, ni = pt.shared.pending;
      if (ni !== null) {
        pt.shared.pending = null;
        var oi = ni, vi = oi.next;
        oi.next = null, Qr === null ? Yr = vi : Qr.next = vi, Qr = oi;
        var Ei = Ke.alternate;
        if (Ei !== null) {
          var Ni = Ei.updateQueue, Mi = Ni.lastBaseUpdate;
          Mi !== Qr && (Mi === null ? Ni.firstBaseUpdate = vi : Mi.next = vi, Ni.lastBaseUpdate = oi);
        }
      }
      if (Yr !== null) {
        var zi = pt.baseState, ji = Ji, Xi = null, Cs = null, qs = null, $s = Yr;
        do {
          var Ro = $s.lane, So = $s.eventTime;
          if ($d(ut, Ro)) {
            if (qs !== null) {
              var Zi = {
                eventTime: So,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: wo,
                tag: $s.tag,
                payload: $s.payload,
                callback: $s.callback,
                next: null
              };
              qs = qs.next = Zi;
            }
            zi = U2(Ke, pt, $s, zi, Xe, it);
            var Bi = $s.callback;
            if (Bi !== null && // If the update was already committed, we should not queue its
            // callback again.
            $s.lane !== wo) {
              Ke.flags |= Mu;
              var ds = pt.effects;
              ds === null ? pt.effects = [$s] : ds.push($s);
            }
          } else {
            var $i = {
              eventTime: So,
              lane: Ro,
              tag: $s.tag,
              payload: $s.payload,
              callback: $s.callback,
              next: null
            };
            qs === null ? (Cs = qs = $i, Xi = zi) : qs = qs.next = $i, ji = go(ji, Ro);
          }
          if ($s = $s.next, $s === null) {
            if (ni = pt.shared.pending, ni === null)
              break;
            var Rs = ni, bs = Rs.next;
            Rs.next = null, $s = bs, pt.lastBaseUpdate = Rs, pt.shared.pending = null;
          }
        } while (!0);
        qs === null && (Xi = zi), pt.baseState = Xi, pt.firstBaseUpdate = Cs, pt.lastBaseUpdate = qs;
        var no = pt.shared.interleaved;
        if (no !== null) {
          var fo = no;
          do
            ji = go(ji, fo.lane), fo = fo.next;
          while (fo !== no);
        } else
          Yr === null && (pt.shared.lanes = Ji);
        hv(ji), Ke.lanes = ji, Ke.memoizedState = zi;
      }
      uE = null;
    }
    function G2(Ke, Xe) {
      if (typeof Ke != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + Ke));
      Ke.call(Xe);
    }
    function OS() {
      lE = !1;
    }
    function fE() {
      return lE;
    }
    function MS(Ke, Xe, it) {
      var ut = Xe.effects;
      if (Xe.effects = null, ut !== null)
        for (var pt = 0; pt < ut.length; pt++) {
          var Yr = ut[pt], Qr = Yr.callback;
          Qr !== null && (Yr.callback = null, G2(Qr, it));
        }
    }
    var Dx = {}, kS = new ie.Component().refs, Ox, Mx, kx, Nx, Fx, NS, hE, $x, Bx, Ux;
    {
      Ox = /* @__PURE__ */ new Set(), Mx = /* @__PURE__ */ new Set(), kx = /* @__PURE__ */ new Set(), Nx = /* @__PURE__ */ new Set(), $x = /* @__PURE__ */ new Set(), Fx = /* @__PURE__ */ new Set(), Bx = /* @__PURE__ */ new Set(), Ux = /* @__PURE__ */ new Set();
      var FS = /* @__PURE__ */ new Set();
      hE = function(Ke, Xe) {
        if (!(Ke === null || typeof Ke == "function")) {
          var it = Xe + "_" + Ke;
          FS.has(it) || (FS.add(it), be("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", Xe, Ke));
        }
      }, NS = function(Ke, Xe) {
        if (Xe === void 0) {
          var it = Lo(Ke) || "Component";
          Fx.has(it) || (Fx.add(it), be("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", it));
        }
      }, Object.defineProperty(Dx, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Dx);
    }
    function Gx(Ke, Xe, it, ut) {
      var pt = Ke.memoizedState, Yr = it(ut, pt);
      {
        if (Ke.mode & aa) {
          La(!0);
          try {
            Yr = it(ut, pt);
          } finally {
            La(!1);
          }
        }
        NS(Xe, Yr);
      }
      var Qr = Yr == null ? pt : vo({}, pt, Yr);
      if (Ke.memoizedState = Qr, Ke.lanes === Ji) {
        var ni = Ke.updateQueue;
        ni.baseState = Qr;
      }
    }
    var Hx = {
      isMounted: zl,
      enqueueSetState: function(Ke, Xe, it) {
        var ut = nu(Ke), pt = Yl(), Yr = ch(ut), Qr = ef(pt, Yr);
        Qr.payload = Xe, it != null && (hE(it, "setState"), Qr.callback = it);
        var ni = nh(ut, Qr, Yr);
        ni !== null && (el(ni, ut, Yr, pt), cE(ni, ut, Yr)), Xc(ut, Yr);
      },
      enqueueReplaceState: function(Ke, Xe, it) {
        var ut = nu(Ke), pt = Yl(), Yr = ch(ut), Qr = ef(pt, Yr);
        Qr.tag = PS, Qr.payload = Xe, it != null && (hE(it, "replaceState"), Qr.callback = it);
        var ni = nh(ut, Qr, Yr);
        ni !== null && (el(ni, ut, Yr, pt), cE(ni, ut, Yr)), Xc(ut, Yr);
      },
      enqueueForceUpdate: function(Ke, Xe) {
        var it = nu(Ke), ut = Yl(), pt = ch(it), Yr = ef(ut, pt);
        Yr.tag = aE, Xe != null && (hE(Xe, "forceUpdate"), Yr.callback = Xe);
        var Qr = nh(it, Yr, pt);
        Qr !== null && (el(Qr, it, pt, ut), cE(Qr, it, pt)), Km(it, pt);
      }
    };
    function $S(Ke, Xe, it, ut, pt, Yr, Qr) {
      var ni = Ke.stateNode;
      if (typeof ni.shouldComponentUpdate == "function") {
        var oi = ni.shouldComponentUpdate(ut, Yr, Qr);
        {
          if (Ke.mode & aa) {
            La(!0);
            try {
              oi = ni.shouldComponentUpdate(ut, Yr, Qr);
            } finally {
              La(!1);
            }
          }
          oi === void 0 && be("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Lo(Xe) || "Component");
        }
        return oi;
      }
      return Xe.prototype && Xe.prototype.isPureReactComponent ? !zs(it, ut) || !zs(pt, Yr) : !0;
    }
    function H2(Ke, Xe, it) {
      var ut = Ke.stateNode;
      {
        var pt = Lo(Xe) || "Component", Yr = ut.render;
        Yr || (Xe.prototype && typeof Xe.prototype.render == "function" ? be("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", pt) : be("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", pt)), ut.getInitialState && !ut.getInitialState.isReactClassApproved && !ut.state && be("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", pt), ut.getDefaultProps && !ut.getDefaultProps.isReactClassApproved && be("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", pt), ut.propTypes && be("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", pt), ut.contextType && be("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", pt), ut.contextTypes && be("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", pt), Xe.contextType && Xe.contextTypes && !Bx.has(Xe) && (Bx.add(Xe), be("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", pt)), typeof ut.componentShouldUpdate == "function" && be("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", pt), Xe.prototype && Xe.prototype.isPureReactComponent && typeof ut.shouldComponentUpdate < "u" && be("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Lo(Xe) || "A pure component"), typeof ut.componentDidUnmount == "function" && be("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", pt), typeof ut.componentDidReceiveProps == "function" && be("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", pt), typeof ut.componentWillRecieveProps == "function" && be("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", pt), typeof ut.UNSAFE_componentWillRecieveProps == "function" && be("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", pt);
        var Qr = ut.props !== it;
        ut.props !== void 0 && Qr && be("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", pt, pt), ut.defaultProps && be("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", pt, pt), typeof ut.getSnapshotBeforeUpdate == "function" && typeof ut.componentDidUpdate != "function" && !kx.has(Xe) && (kx.add(Xe), be("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Lo(Xe))), typeof ut.getDerivedStateFromProps == "function" && be("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", pt), typeof ut.getDerivedStateFromError == "function" && be("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", pt), typeof Xe.getSnapshotBeforeUpdate == "function" && be("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", pt);
        var ni = ut.state;
        ni && (typeof ni != "object" || _o(ni)) && be("%s.state: must be set to an object or null", pt), typeof ut.getChildContext == "function" && typeof Xe.childContextTypes != "object" && be("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", pt);
      }
    }
    function BS(Ke, Xe) {
      Xe.updater = Hx, Ke.stateNode = Xe, Cf(Xe, Ke), Xe._reactInternalInstance = Dx;
    }
    function US(Ke, Xe, it) {
      var ut = !1, pt = Ru, Yr = Ru, Qr = Xe.contextType;
      if ("contextType" in Xe) {
        var ni = (
          // Allow null for conditional declaration
          Qr === null || Qr !== void 0 && Qr.$$typeof === hh && Qr._context === void 0
        );
        if (!ni && !Ux.has(Xe)) {
          Ux.add(Xe);
          var oi = "";
          Qr === void 0 ? oi = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof Qr != "object" ? oi = " However, it is set to a " + typeof Qr + "." : Qr.$$typeof === lf ? oi = " Did you accidentally pass the Context.Provider instead?" : Qr._context !== void 0 ? oi = " Did you accidentally pass the Context.Consumer instead?" : oi = " However, it is set to an object with keys {" + Object.keys(Qr).join(", ") + "}.", be("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Lo(Xe) || "Component", oi);
        }
      }
      if (typeof Qr == "object" && Qr !== null)
        Yr = Ha(Qr);
      else {
        pt = $g(Ke, Xe, !0);
        var vi = Xe.contextTypes;
        ut = vi != null, Yr = ut ? Bg(Ke, pt) : Ru;
      }
      var Ei = new Xe(it, Yr);
      if (Ke.mode & aa) {
        La(!0);
        try {
          Ei = new Xe(it, Yr);
        } finally {
          La(!1);
        }
      }
      var Ni = Ke.memoizedState = Ei.state !== null && Ei.state !== void 0 ? Ei.state : null;
      BS(Ke, Ei);
      {
        if (typeof Xe.getDerivedStateFromProps == "function" && Ni === null) {
          var Mi = Lo(Xe) || "Component";
          Mx.has(Mi) || (Mx.add(Mi), be("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Mi, Ei.state === null ? "null" : "undefined", Mi));
        }
        if (typeof Xe.getDerivedStateFromProps == "function" || typeof Ei.getSnapshotBeforeUpdate == "function") {
          var zi = null, ji = null, Xi = null;
          if (typeof Ei.componentWillMount == "function" && Ei.componentWillMount.__suppressDeprecationWarning !== !0 ? zi = "componentWillMount" : typeof Ei.UNSAFE_componentWillMount == "function" && (zi = "UNSAFE_componentWillMount"), typeof Ei.componentWillReceiveProps == "function" && Ei.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? ji = "componentWillReceiveProps" : typeof Ei.UNSAFE_componentWillReceiveProps == "function" && (ji = "UNSAFE_componentWillReceiveProps"), typeof Ei.componentWillUpdate == "function" && Ei.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Xi = "componentWillUpdate" : typeof Ei.UNSAFE_componentWillUpdate == "function" && (Xi = "UNSAFE_componentWillUpdate"), zi !== null || ji !== null || Xi !== null) {
            var Cs = Lo(Xe) || "Component", qs = typeof Xe.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Nx.has(Cs) || (Nx.add(Cs), be(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Cs, qs, zi !== null ? `
  ` + zi : "", ji !== null ? `
  ` + ji : "", Xi !== null ? `
  ` + Xi : ""));
          }
        }
      }
      return ut && cS(Ke, pt, Yr), Ei;
    }
    function z2(Ke, Xe) {
      var it = Xe.state;
      typeof Xe.componentWillMount == "function" && Xe.componentWillMount(), typeof Xe.UNSAFE_componentWillMount == "function" && Xe.UNSAFE_componentWillMount(), it !== Xe.state && (be("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", uo(Ke) || "Component"), Hx.enqueueReplaceState(Xe, Xe.state, null));
    }
    function GS(Ke, Xe, it, ut) {
      var pt = Xe.state;
      if (typeof Xe.componentWillReceiveProps == "function" && Xe.componentWillReceiveProps(it, ut), typeof Xe.UNSAFE_componentWillReceiveProps == "function" && Xe.UNSAFE_componentWillReceiveProps(it, ut), Xe.state !== pt) {
        {
          var Yr = uo(Ke) || "Component";
          Ox.has(Yr) || (Ox.add(Yr), be("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Yr));
        }
        Hx.enqueueReplaceState(Xe, Xe.state, null);
      }
    }
    function zx(Ke, Xe, it, ut) {
      H2(Ke, Xe, it);
      var pt = Ke.stateNode;
      pt.props = it, pt.state = Ke.memoizedState, pt.refs = kS, Ix(Ke);
      var Yr = Xe.contextType;
      if (typeof Yr == "object" && Yr !== null)
        pt.context = Ha(Yr);
      else {
        var Qr = $g(Ke, Xe, !0);
        pt.context = Bg(Ke, Qr);
      }
      {
        if (pt.state === it) {
          var ni = Lo(Xe) || "Component";
          $x.has(ni) || ($x.add(ni), be("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", ni));
        }
        Ke.mode & aa && pc.recordLegacyContextWarning(Ke, pt), pc.recordUnsafeLifecycleWarnings(Ke, pt);
      }
      pt.state = Ke.memoizedState;
      var oi = Xe.getDerivedStateFromProps;
      if (typeof oi == "function" && (Gx(Ke, Xe, oi, it), pt.state = Ke.memoizedState), typeof Xe.getDerivedStateFromProps != "function" && typeof pt.getSnapshotBeforeUpdate != "function" && (typeof pt.UNSAFE_componentWillMount == "function" || typeof pt.componentWillMount == "function") && (z2(Ke, pt), dE(Ke, it, pt, ut), pt.state = Ke.memoizedState), typeof pt.componentDidMount == "function") {
        var vi = po;
        vi |= Al, (Ke.mode & au) !== Xs && (vi |= Ll), Ke.flags |= vi;
      }
    }
    function V2(Ke, Xe, it, ut) {
      var pt = Ke.stateNode, Yr = Ke.memoizedProps;
      pt.props = Yr;
      var Qr = pt.context, ni = Xe.contextType, oi = Ru;
      if (typeof ni == "object" && ni !== null)
        oi = Ha(ni);
      else {
        var vi = $g(Ke, Xe, !0);
        oi = Bg(Ke, vi);
      }
      var Ei = Xe.getDerivedStateFromProps, Ni = typeof Ei == "function" || typeof pt.getSnapshotBeforeUpdate == "function";
      !Ni && (typeof pt.UNSAFE_componentWillReceiveProps == "function" || typeof pt.componentWillReceiveProps == "function") && (Yr !== it || Qr !== oi) && GS(Ke, pt, it, oi), OS();
      var Mi = Ke.memoizedState, zi = pt.state = Mi;
      if (dE(Ke, it, pt, ut), zi = Ke.memoizedState, Yr === it && Mi === zi && !qy() && !fE()) {
        if (typeof pt.componentDidMount == "function") {
          var ji = po;
          ji |= Al, (Ke.mode & au) !== Xs && (ji |= Ll), Ke.flags |= ji;
        }
        return !1;
      }
      typeof Ei == "function" && (Gx(Ke, Xe, Ei, it), zi = Ke.memoizedState);
      var Xi = fE() || $S(Ke, Xe, Yr, it, Mi, zi, oi);
      if (Xi) {
        if (!Ni && (typeof pt.UNSAFE_componentWillMount == "function" || typeof pt.componentWillMount == "function") && (typeof pt.componentWillMount == "function" && pt.componentWillMount(), typeof pt.UNSAFE_componentWillMount == "function" && pt.UNSAFE_componentWillMount()), typeof pt.componentDidMount == "function") {
          var Cs = po;
          Cs |= Al, (Ke.mode & au) !== Xs && (Cs |= Ll), Ke.flags |= Cs;
        }
      } else {
        if (typeof pt.componentDidMount == "function") {
          var qs = po;
          qs |= Al, (Ke.mode & au) !== Xs && (qs |= Ll), Ke.flags |= qs;
        }
        Ke.memoizedProps = it, Ke.memoizedState = zi;
      }
      return pt.props = it, pt.state = zi, pt.context = oi, Xi;
    }
    function j2(Ke, Xe, it, ut, pt) {
      var Yr = Xe.stateNode;
      DS(Ke, Xe);
      var Qr = Xe.memoizedProps, ni = Xe.type === Xe.elementType ? Qr : gc(Xe.type, Qr);
      Yr.props = ni;
      var oi = Xe.pendingProps, vi = Yr.context, Ei = it.contextType, Ni = Ru;
      if (typeof Ei == "object" && Ei !== null)
        Ni = Ha(Ei);
      else {
        var Mi = $g(Xe, it, !0);
        Ni = Bg(Xe, Mi);
      }
      var zi = it.getDerivedStateFromProps, ji = typeof zi == "function" || typeof Yr.getSnapshotBeforeUpdate == "function";
      !ji && (typeof Yr.UNSAFE_componentWillReceiveProps == "function" || typeof Yr.componentWillReceiveProps == "function") && (Qr !== oi || vi !== Ni) && GS(Xe, Yr, ut, Ni), OS();
      var Xi = Xe.memoizedState, Cs = Yr.state = Xi;
      if (dE(Xe, ut, Yr, pt), Cs = Xe.memoizedState, Qr === oi && Xi === Cs && !qy() && !fE() && !Oi)
        return typeof Yr.componentDidUpdate == "function" && (Qr !== Ke.memoizedProps || Xi !== Ke.memoizedState) && (Xe.flags |= po), typeof Yr.getSnapshotBeforeUpdate == "function" && (Qr !== Ke.memoizedProps || Xi !== Ke.memoizedState) && (Xe.flags |= ru), !1;
      typeof zi == "function" && (Gx(Xe, it, zi, ut), Cs = Xe.memoizedState);
      var qs = fE() || $S(Xe, it, ni, ut, Xi, Cs, Ni) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      Oi;
      return qs ? (!ji && (typeof Yr.UNSAFE_componentWillUpdate == "function" || typeof Yr.componentWillUpdate == "function") && (typeof Yr.componentWillUpdate == "function" && Yr.componentWillUpdate(ut, Cs, Ni), typeof Yr.UNSAFE_componentWillUpdate == "function" && Yr.UNSAFE_componentWillUpdate(ut, Cs, Ni)), typeof Yr.componentDidUpdate == "function" && (Xe.flags |= po), typeof Yr.getSnapshotBeforeUpdate == "function" && (Xe.flags |= ru)) : (typeof Yr.componentDidUpdate == "function" && (Qr !== Ke.memoizedProps || Xi !== Ke.memoizedState) && (Xe.flags |= po), typeof Yr.getSnapshotBeforeUpdate == "function" && (Qr !== Ke.memoizedProps || Xi !== Ke.memoizedState) && (Xe.flags |= ru), Xe.memoizedProps = ut, Xe.memoizedState = Cs), Yr.props = ut, Yr.state = Cs, Yr.context = Ni, qs;
    }
    var Vx, jx, Wx, Kx, qx, HS = function(Ke, Xe) {
    };
    Vx = !1, jx = !1, Wx = {}, Kx = {}, qx = {}, HS = function(Ke, Xe) {
      if (!(Ke === null || typeof Ke != "object") && !(!Ke._store || Ke._store.validated || Ke.key != null)) {
        if (typeof Ke._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        Ke._store.validated = !0;
        var it = uo(Xe) || "Component";
        Kx[it] || (Kx[it] = !0, be('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function H0(Ke, Xe, it) {
      var ut = it.ref;
      if (ut !== null && typeof ut != "function" && typeof ut != "object") {
        if ((Ke.mode & aa || Hi) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(it._owner && it._self && it._owner.stateNode !== it._self)) {
          var pt = uo(Ke) || "Component";
          Wx[pt] || (be('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ut), Wx[pt] = !0);
        }
        if (it._owner) {
          var Yr = it._owner, Qr;
          if (Yr) {
            var ni = Yr;
            if (ni.tag !== Je)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            Qr = ni.stateNode;
          }
          if (!Qr)
            throw new Error("Missing owner for string ref " + ut + ". This error is likely caused by a bug in React. Please file an issue.");
          var oi = Qr;
          Ks(ut, "ref");
          var vi = "" + ut;
          if (Xe !== null && Xe.ref !== null && typeof Xe.ref == "function" && Xe.ref._stringRef === vi)
            return Xe.ref;
          var Ei = function(Ni) {
            var Mi = oi.refs;
            Mi === kS && (Mi = oi.refs = {}), Ni === null ? delete Mi[vi] : Mi[vi] = Ni;
          };
          return Ei._stringRef = vi, Ei;
        } else {
          if (typeof ut != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!it._owner)
            throw new Error("Element ref was specified as a string (" + ut + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return ut;
    }
    function pE(Ke, Xe) {
      var it = Object.prototype.toString.call(Xe);
      throw new Error("Objects are not valid as a React child (found: " + (it === "[object Object]" ? "object with keys {" + Object.keys(Xe).join(", ") + "}" : it) + "). If you meant to render a collection of children, use an array instead.");
    }
    function gE(Ke) {
      {
        var Xe = uo(Ke) || "Component";
        if (qx[Xe])
          return;
        qx[Xe] = !0, be("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function zS(Ke) {
      var Xe = Ke._payload, it = Ke._init;
      return it(Xe);
    }
    function VS(Ke) {
      function Xe($i, Zi) {
        if (Ke) {
          var Bi = $i.deletions;
          Bi === null ? ($i.deletions = [Zi], $i.flags |= ko) : Bi.push(Zi);
        }
      }
      function it($i, Zi) {
        if (!Ke)
          return null;
        for (var Bi = Zi; Bi !== null; )
          Xe($i, Bi), Bi = Bi.sibling;
        return null;
      }
      function ut($i, Zi) {
        for (var Bi = /* @__PURE__ */ new Map(), ds = Zi; ds !== null; )
          ds.key !== null ? Bi.set(ds.key, ds) : Bi.set(ds.index, ds), ds = ds.sibling;
        return Bi;
      }
      function pt($i, Zi) {
        var Bi = yp($i, Zi);
        return Bi.index = 0, Bi.sibling = null, Bi;
      }
      function Yr($i, Zi, Bi) {
        if ($i.index = Bi, !Ke)
          return $i.flags |= km, Zi;
        var ds = $i.alternate;
        if (ds !== null) {
          var Rs = ds.index;
          return Rs < Zi ? ($i.flags |= Xo, Zi) : Rs;
        } else
          return $i.flags |= Xo, Zi;
      }
      function Qr($i) {
        return Ke && $i.alternate === null && ($i.flags |= Xo), $i;
      }
      function ni($i, Zi, Bi, ds) {
        if (Zi === null || Zi.tag !== ft) {
          var Rs = bb(Bi, $i.mode, ds);
          return Rs.return = $i, Rs;
        } else {
          var bs = pt(Zi, Bi);
          return bs.return = $i, bs;
        }
      }
      function oi($i, Zi, Bi, ds) {
        var Rs = Bi.type;
        if (Rs === Ul)
          return Ei($i, Zi, Bi.props.children, ds, Bi.key);
        if (Zi !== null && (Zi.elementType === Rs || // Keep this check inline so it only runs on the false path:
        Mw(Zi, Bi) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Rs == "object" && Rs !== null && Rs.$$typeof === za && zS(Rs) === Zi.type)) {
          var bs = pt(Zi, Bi.props);
          return bs.ref = H0($i, Zi, Bi), bs.return = $i, bs._debugSource = Bi._source, bs._debugOwner = Bi._owner, bs;
        }
        var no = Tb(Bi, $i.mode, ds);
        return no.ref = H0($i, Zi, Bi), no.return = $i, no;
      }
      function vi($i, Zi, Bi, ds) {
        if (Zi === null || Zi.tag !== ot || Zi.stateNode.containerInfo !== Bi.containerInfo || Zi.stateNode.implementation !== Bi.implementation) {
          var Rs = Sb(Bi, $i.mode, ds);
          return Rs.return = $i, Rs;
        } else {
          var bs = pt(Zi, Bi.children || []);
          return bs.return = $i, bs;
        }
      }
      function Ei($i, Zi, Bi, ds, Rs) {
        if (Zi === null || Zi.tag !== gt) {
          var bs = fh(Bi, $i.mode, ds, Rs);
          return bs.return = $i, bs;
        } else {
          var no = pt(Zi, Bi);
          return no.return = $i, no;
        }
      }
      function Ni($i, Zi, Bi) {
        if (typeof Zi == "string" && Zi !== "" || typeof Zi == "number") {
          var ds = bb("" + Zi, $i.mode, Bi);
          return ds.return = $i, ds;
        }
        if (typeof Zi == "object" && Zi !== null) {
          switch (Zi.$$typeof) {
            case va: {
              var Rs = Tb(Zi, $i.mode, Bi);
              return Rs.ref = H0($i, null, Zi), Rs.return = $i, Rs;
            }
            case ia: {
              var bs = Sb(Zi, $i.mode, Bi);
              return bs.return = $i, bs;
            }
            case za: {
              var no = Zi._payload, fo = Zi._init;
              return Ni($i, fo(no), Bi);
            }
          }
          if (_o(Zi) || yu(Zi)) {
            var Go = fh(Zi, $i.mode, Bi, null);
            return Go.return = $i, Go;
          }
          pE($i, Zi);
        }
        return typeof Zi == "function" && gE($i), null;
      }
      function Mi($i, Zi, Bi, ds) {
        var Rs = Zi !== null ? Zi.key : null;
        if (typeof Bi == "string" && Bi !== "" || typeof Bi == "number")
          return Rs !== null ? null : ni($i, Zi, "" + Bi, ds);
        if (typeof Bi == "object" && Bi !== null) {
          switch (Bi.$$typeof) {
            case va:
              return Bi.key === Rs ? oi($i, Zi, Bi, ds) : null;
            case ia:
              return Bi.key === Rs ? vi($i, Zi, Bi, ds) : null;
            case za: {
              var bs = Bi._payload, no = Bi._init;
              return Mi($i, Zi, no(bs), ds);
            }
          }
          if (_o(Bi) || yu(Bi))
            return Rs !== null ? null : Ei($i, Zi, Bi, ds, null);
          pE($i, Bi);
        }
        return typeof Bi == "function" && gE($i), null;
      }
      function zi($i, Zi, Bi, ds, Rs) {
        if (typeof ds == "string" && ds !== "" || typeof ds == "number") {
          var bs = $i.get(Bi) || null;
          return ni(Zi, bs, "" + ds, Rs);
        }
        if (typeof ds == "object" && ds !== null) {
          switch (ds.$$typeof) {
            case va: {
              var no = $i.get(ds.key === null ? Bi : ds.key) || null;
              return oi(Zi, no, ds, Rs);
            }
            case ia: {
              var fo = $i.get(ds.key === null ? Bi : ds.key) || null;
              return vi(Zi, fo, ds, Rs);
            }
            case za:
              var Go = ds._payload, Oo = ds._init;
              return zi($i, Zi, Bi, Oo(Go), Rs);
          }
          if (_o(ds) || yu(ds)) {
            var Ma = $i.get(Bi) || null;
            return Ei(Zi, Ma, ds, Rs, null);
          }
          pE(Zi, ds);
        }
        return typeof ds == "function" && gE(Zi), null;
      }
      function ji($i, Zi, Bi) {
        {
          if (typeof $i != "object" || $i === null)
            return Zi;
          switch ($i.$$typeof) {
            case va:
            case ia:
              HS($i, Bi);
              var ds = $i.key;
              if (typeof ds != "string")
                break;
              if (Zi === null) {
                Zi = /* @__PURE__ */ new Set(), Zi.add(ds);
                break;
              }
              if (!Zi.has(ds)) {
                Zi.add(ds);
                break;
              }
              be("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", ds);
              break;
            case za:
              var Rs = $i._payload, bs = $i._init;
              ji(bs(Rs), Zi, Bi);
              break;
          }
        }
        return Zi;
      }
      function Xi($i, Zi, Bi, ds) {
        for (var Rs = null, bs = 0; bs < Bi.length; bs++) {
          var no = Bi[bs];
          Rs = ji(no, Rs, $i);
        }
        for (var fo = null, Go = null, Oo = Zi, Ma = 0, Mo = 0, Ra = null; Oo !== null && Mo < Bi.length; Mo++) {
          Oo.index > Mo ? (Ra = Oo, Oo = null) : Ra = Oo.sibling;
          var $l = Mi($i, Oo, Bi[Mo], ds);
          if ($l === null) {
            Oo === null && (Oo = Ra);
            break;
          }
          Ke && Oo && $l.alternate === null && Xe($i, Oo), Ma = Yr($l, Ma, Mo), Go === null ? fo = $l : Go.sibling = $l, Go = $l, Oo = Ra;
        }
        if (Mo === Bi.length) {
          if (it($i, Oo), gl()) {
            var bl = Mo;
            sp($i, bl);
          }
          return fo;
        }
        if (Oo === null) {
          for (; Mo < Bi.length; Mo++) {
            var Lu = Ni($i, Bi[Mo], ds);
            Lu !== null && (Ma = Yr(Lu, Ma, Mo), Go === null ? fo = Lu : Go.sibling = Lu, Go = Lu);
          }
          if (gl()) {
            var Xl = Mo;
            sp($i, Xl);
          }
          return fo;
        }
        for (var Zl = ut($i, Oo); Mo < Bi.length; Mo++) {
          var Bl = zi(Zl, $i, Mo, Bi[Mo], ds);
          Bl !== null && (Ke && Bl.alternate !== null && Zl.delete(Bl.key === null ? Mo : Bl.key), Ma = Yr(Bl, Ma, Mo), Go === null ? fo = Bl : Go.sibling = Bl, Go = Bl);
        }
        if (Ke && Zl.forEach(function(am) {
          return Xe($i, am);
        }), gl()) {
          var af = Mo;
          sp($i, af);
        }
        return fo;
      }
      function Cs($i, Zi, Bi, ds) {
        var Rs = yu(Bi);
        if (typeof Rs != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          Bi[Symbol.toStringTag] === "Generator" && (jx || be("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), jx = !0), Bi.entries === Rs && (Vx || be("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Vx = !0);
          var bs = Rs.call(Bi);
          if (bs)
            for (var no = null, fo = bs.next(); !fo.done; fo = bs.next()) {
              var Go = fo.value;
              no = ji(Go, no, $i);
            }
        }
        var Oo = Rs.call(Bi);
        if (Oo == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Ma = null, Mo = null, Ra = Zi, $l = 0, bl = 0, Lu = null, Xl = Oo.next(); Ra !== null && !Xl.done; bl++, Xl = Oo.next()) {
          Ra.index > bl ? (Lu = Ra, Ra = null) : Lu = Ra.sibling;
          var Zl = Mi($i, Ra, Xl.value, ds);
          if (Zl === null) {
            Ra === null && (Ra = Lu);
            break;
          }
          Ke && Ra && Zl.alternate === null && Xe($i, Ra), $l = Yr(Zl, $l, bl), Mo === null ? Ma = Zl : Mo.sibling = Zl, Mo = Zl, Ra = Lu;
        }
        if (Xl.done) {
          if (it($i, Ra), gl()) {
            var Bl = bl;
            sp($i, Bl);
          }
          return Ma;
        }
        if (Ra === null) {
          for (; !Xl.done; bl++, Xl = Oo.next()) {
            var af = Ni($i, Xl.value, ds);
            af !== null && ($l = Yr(af, $l, bl), Mo === null ? Ma = af : Mo.sibling = af, Mo = af);
          }
          if (gl()) {
            var am = bl;
            sp($i, am);
          }
          return Ma;
        }
        for (var yv = ut($i, Ra); !Xl.done; bl++, Xl = Oo.next()) {
          var md = zi(yv, $i, bl, Xl.value, ds);
          md !== null && (Ke && md.alternate !== null && yv.delete(md.key === null ? bl : md.key), $l = Yr(md, $l, bl), Mo === null ? Ma = md : Mo.sibling = md, Mo = md);
        }
        if (Ke && yv.forEach(function(sP) {
          return Xe($i, sP);
        }), gl()) {
          var iP = bl;
          sp($i, iP);
        }
        return Ma;
      }
      function qs($i, Zi, Bi, ds) {
        if (Zi !== null && Zi.tag === ft) {
          it($i, Zi.sibling);
          var Rs = pt(Zi, Bi);
          return Rs.return = $i, Rs;
        }
        it($i, Zi);
        var bs = bb(Bi, $i.mode, ds);
        return bs.return = $i, bs;
      }
      function $s($i, Zi, Bi, ds) {
        for (var Rs = Bi.key, bs = Zi; bs !== null; ) {
          if (bs.key === Rs) {
            var no = Bi.type;
            if (no === Ul) {
              if (bs.tag === gt) {
                it($i, bs.sibling);
                var fo = pt(bs, Bi.props.children);
                return fo.return = $i, fo._debugSource = Bi._source, fo._debugOwner = Bi._owner, fo;
              }
            } else if (bs.elementType === no || // Keep this check inline so it only runs on the false path:
            Mw(bs, Bi) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof no == "object" && no !== null && no.$$typeof === za && zS(no) === bs.type) {
              it($i, bs.sibling);
              var Go = pt(bs, Bi.props);
              return Go.ref = H0($i, bs, Bi), Go.return = $i, Go._debugSource = Bi._source, Go._debugOwner = Bi._owner, Go;
            }
            it($i, bs);
            break;
          } else
            Xe($i, bs);
          bs = bs.sibling;
        }
        if (Bi.type === Ul) {
          var Oo = fh(Bi.props.children, $i.mode, ds, Bi.key);
          return Oo.return = $i, Oo;
        } else {
          var Ma = Tb(Bi, $i.mode, ds);
          return Ma.ref = H0($i, Zi, Bi), Ma.return = $i, Ma;
        }
      }
      function Ro($i, Zi, Bi, ds) {
        for (var Rs = Bi.key, bs = Zi; bs !== null; ) {
          if (bs.key === Rs)
            if (bs.tag === ot && bs.stateNode.containerInfo === Bi.containerInfo && bs.stateNode.implementation === Bi.implementation) {
              it($i, bs.sibling);
              var no = pt(bs, Bi.children || []);
              return no.return = $i, no;
            } else {
              it($i, bs);
              break;
            }
          else
            Xe($i, bs);
          bs = bs.sibling;
        }
        var fo = Sb(Bi, $i.mode, ds);
        return fo.return = $i, fo;
      }
      function So($i, Zi, Bi, ds) {
        var Rs = typeof Bi == "object" && Bi !== null && Bi.type === Ul && Bi.key === null;
        if (Rs && (Bi = Bi.props.children), typeof Bi == "object" && Bi !== null) {
          switch (Bi.$$typeof) {
            case va:
              return Qr($s($i, Zi, Bi, ds));
            case ia:
              return Qr(Ro($i, Zi, Bi, ds));
            case za:
              var bs = Bi._payload, no = Bi._init;
              return So($i, Zi, no(bs), ds);
          }
          if (_o(Bi))
            return Xi($i, Zi, Bi, ds);
          if (yu(Bi))
            return Cs($i, Zi, Bi, ds);
          pE($i, Bi);
        }
        return typeof Bi == "string" && Bi !== "" || typeof Bi == "number" ? Qr(qs($i, Zi, "" + Bi, ds)) : (typeof Bi == "function" && gE($i), it($i, Zi));
      }
      return So;
    }
    var jg = VS(!0), jS = VS(!1);
    function W2(Ke, Xe) {
      if (Ke !== null && Xe.child !== Ke.child)
        throw new Error("Resuming work not yet implemented.");
      if (Xe.child !== null) {
        var it = Xe.child, ut = yp(it, it.pendingProps);
        for (Xe.child = ut, ut.return = Xe; it.sibling !== null; )
          it = it.sibling, ut = ut.sibling = yp(it, it.pendingProps), ut.return = Xe;
        ut.sibling = null;
      }
    }
    function K2(Ke, Xe) {
      for (var it = Ke.child; it !== null; )
        bI(it, Xe), it = it.sibling;
    }
    var z0 = {}, rh = Qf(z0), V0 = Qf(z0), mE = Qf(z0);
    function vE(Ke) {
      if (Ke === z0)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return Ke;
    }
    function WS() {
      var Ke = vE(mE.current);
      return Ke;
    }
    function Yx(Ke, Xe) {
      Nl(mE, Xe, Ke), Nl(V0, Ke, Ke), Nl(rh, z0, Ke);
      var it = sR(Xe);
      kl(rh, Ke), Nl(rh, it, Ke);
    }
    function Wg(Ke) {
      kl(rh, Ke), kl(V0, Ke), kl(mE, Ke);
    }
    function Xx() {
      var Ke = vE(rh.current);
      return Ke;
    }
    function KS(Ke) {
      vE(mE.current);
      var Xe = vE(rh.current), it = oR(Xe, Ke.type);
      Xe !== it && (Nl(V0, Ke, Ke), Nl(rh, it, Ke));
    }
    function Zx(Ke) {
      V0.current === Ke && (kl(rh, Ke), kl(V0, Ke));
    }
    var q2 = 0, qS = 1, YS = 1, j0 = 2, mc = Qf(q2);
    function Qx(Ke, Xe) {
      return (Ke & Xe) !== 0;
    }
    function Kg(Ke) {
      return Ke & qS;
    }
    function Jx(Ke, Xe) {
      return Ke & qS | Xe;
    }
    function Y2(Ke, Xe) {
      return Ke | Xe;
    }
    function ih(Ke, Xe) {
      Nl(mc, Xe, Ke);
    }
    function qg(Ke) {
      kl(mc, Ke);
    }
    function X2(Ke, Xe) {
      var it = Ke.memoizedState;
      return it !== null ? it.dehydrated !== null : (Ke.memoizedProps, !0);
    }
    function yE(Ke) {
      for (var Xe = Ke; Xe !== null; ) {
        if (Xe.tag === ei) {
          var it = Xe.memoizedState;
          if (it !== null) {
            var ut = it.dehydrated;
            if (ut === null || sS(ut) || sx(ut))
              return Xe;
          }
        } else if (Xe.tag === di && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        Xe.memoizedProps.revealOrder !== void 0) {
          var pt = (Xe.flags & io) !== js;
          if (pt)
            return Xe;
        } else if (Xe.child !== null) {
          Xe.child.return = Xe, Xe = Xe.child;
          continue;
        }
        if (Xe === Ke)
          return null;
        for (; Xe.sibling === null; ) {
          if (Xe.return === null || Xe.return === Ke)
            return null;
          Xe = Xe.return;
        }
        Xe.sibling.return = Xe.return, Xe = Xe.sibling;
      }
      return null;
    }
    var gu = (
      /*   */
      0
    ), Ka = (
      /* */
      1
    ), ld = (
      /*  */
      2
    ), qa = (
      /*    */
      4
    ), ml = (
      /*   */
      8
    ), eT = [];
    function tT() {
      for (var Ke = 0; Ke < eT.length; Ke++) {
        var Xe = eT[Ke];
        Xe._workInProgressVersionPrimary = null;
      }
      eT.length = 0;
    }
    function Z2(Ke, Xe) {
      var it = Xe._getVersion, ut = it(Xe._source);
      Ke.mutableSourceEagerHydrationData == null ? Ke.mutableSourceEagerHydrationData = [Xe, ut] : Ke.mutableSourceEagerHydrationData.push(Xe, ut);
    }
    var ws = ee.ReactCurrentDispatcher, W0 = ee.ReactCurrentBatchConfig, nT, Yg;
    nT = /* @__PURE__ */ new Set();
    var dp = Ji, Uo = null, Ya = null, Xa = null, EE = !1, K0 = !1, q0 = 0, Q2 = 0, J2 = 25, ts = null, zu = null, sh = -1, rT = !1;
    function $o() {
      {
        var Ke = ts;
        zu === null ? zu = [Ke] : zu.push(Ke);
      }
    }
    function ys() {
      {
        var Ke = ts;
        zu !== null && (sh++, zu[sh] !== Ke && eA(Ke));
      }
    }
    function Xg(Ke) {
      Ke != null && !_o(Ke) && be("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", ts, typeof Ke);
    }
    function eA(Ke) {
      {
        var Xe = uo(Uo);
        if (!nT.has(Xe) && (nT.add(Xe), zu !== null)) {
          for (var it = "", ut = 30, pt = 0; pt <= sh; pt++) {
            for (var Yr = zu[pt], Qr = pt === sh ? Ke : Yr, ni = pt + 1 + ". " + Yr; ni.length < ut; )
              ni += " ";
            ni += Qr + `
`, it += ni;
          }
          be(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, Xe, it);
        }
      }
    }
    function Fl() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function iT(Ke, Xe) {
      if (rT)
        return !1;
      if (Xe === null)
        return be("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", ts), !1;
      Ke.length !== Xe.length && be(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, ts, "[" + Xe.join(", ") + "]", "[" + Ke.join(", ") + "]");
      for (var it = 0; it < Xe.length && it < Ke.length; it++)
        if (!Is(Ke[it], Xe[it]))
          return !1;
      return !0;
    }
    function Zg(Ke, Xe, it, ut, pt, Yr) {
      dp = Yr, Uo = Xe, zu = Ke !== null ? Ke._debugHookTypes : null, sh = -1, rT = Ke !== null && Ke.type !== Xe.type, Xe.memoizedState = null, Xe.updateQueue = null, Xe.lanes = Ji, Ke !== null && Ke.memoizedState !== null ? ws.current = v_ : zu !== null ? ws.current = m_ : ws.current = g_;
      var Qr = it(ut, pt);
      if (K0) {
        var ni = 0;
        do {
          if (K0 = !1, q0 = 0, ni >= J2)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          ni += 1, rT = !1, Ya = null, Xa = null, Xe.updateQueue = null, sh = -1, ws.current = y_, Qr = it(ut, pt);
        } while (K0);
      }
      ws.current = DE, Xe._debugHookTypes = zu;
      var oi = Ya !== null && Ya.next !== null;
      if (dp = Ji, Uo = null, Ya = null, Xa = null, ts = null, zu = null, sh = -1, Ke !== null && (Ke.flags & Va) !== (Xe.flags & Va) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (Ke.mode & Eo) !== Xs && be("Internal React error: Expected static flag was missing. Please notify the React team."), EE = !1, oi)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return Qr;
    }
    function Qg() {
      var Ke = q0 !== 0;
      return q0 = 0, Ke;
    }
    function XS(Ke, Xe, it) {
      Xe.updateQueue = Ke.updateQueue, (Xe.mode & au) !== Xs ? Xe.flags &= ~(Ad | Ll | na | po) : Xe.flags &= ~(na | po), Ke.lanes = kf(Ke.lanes, it);
    }
    function ZS() {
      if (ws.current = DE, EE) {
        for (var Ke = Uo.memoizedState; Ke !== null; ) {
          var Xe = Ke.queue;
          Xe !== null && (Xe.pending = null), Ke = Ke.next;
        }
        EE = !1;
      }
      dp = Ji, Uo = null, Ya = null, Xa = null, zu = null, sh = -1, ts = null, c_ = !1, K0 = !1, q0 = 0;
    }
    function ud() {
      var Ke = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Xa === null ? Uo.memoizedState = Xa = Ke : Xa = Xa.next = Ke, Xa;
    }
    function Vu() {
      var Ke;
      if (Ya === null) {
        var Xe = Uo.alternate;
        Xe !== null ? Ke = Xe.memoizedState : Ke = null;
      } else
        Ke = Ya.next;
      var it;
      if (Xa === null ? it = Uo.memoizedState : it = Xa.next, it !== null)
        Xa = it, it = Xa.next, Ya = Ke;
      else {
        if (Ke === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Ya = Ke;
        var ut = {
          memoizedState: Ya.memoizedState,
          baseState: Ya.baseState,
          baseQueue: Ya.baseQueue,
          queue: Ya.queue,
          next: null
        };
        Xa === null ? Uo.memoizedState = Xa = ut : Xa = Xa.next = ut;
      }
      return Xa;
    }
    function QS() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function sT(Ke, Xe) {
      return typeof Xe == "function" ? Xe(Ke) : Xe;
    }
    function oT(Ke, Xe, it) {
      var ut = ud(), pt;
      it !== void 0 ? pt = it(Xe) : pt = Xe, ut.memoizedState = ut.baseState = pt;
      var Yr = {
        pending: null,
        interleaved: null,
        lanes: Ji,
        dispatch: null,
        lastRenderedReducer: Ke,
        lastRenderedState: pt
      };
      ut.queue = Yr;
      var Qr = Yr.dispatch = iA.bind(null, Uo, Yr);
      return [ut.memoizedState, Qr];
    }
    function aT(Ke, Xe, it) {
      var ut = Vu(), pt = ut.queue;
      if (pt === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      pt.lastRenderedReducer = Ke;
      var Yr = Ya, Qr = Yr.baseQueue, ni = pt.pending;
      if (ni !== null) {
        if (Qr !== null) {
          var oi = Qr.next, vi = ni.next;
          Qr.next = vi, ni.next = oi;
        }
        Yr.baseQueue !== Qr && be("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), Yr.baseQueue = Qr = ni, pt.pending = null;
      }
      if (Qr !== null) {
        var Ei = Qr.next, Ni = Yr.baseState, Mi = null, zi = null, ji = null, Xi = Ei;
        do {
          var Cs = Xi.lane;
          if ($d(dp, Cs)) {
            if (ji !== null) {
              var $s = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: wo,
                action: Xi.action,
                hasEagerState: Xi.hasEagerState,
                eagerState: Xi.eagerState,
                next: null
              };
              ji = ji.next = $s;
            }
            if (Xi.hasEagerState)
              Ni = Xi.eagerState;
            else {
              var Ro = Xi.action;
              Ni = Ke(Ni, Ro);
            }
          } else {
            var qs = {
              lane: Cs,
              action: Xi.action,
              hasEagerState: Xi.hasEagerState,
              eagerState: Xi.eagerState,
              next: null
            };
            ji === null ? (zi = ji = qs, Mi = Ni) : ji = ji.next = qs, Uo.lanes = go(Uo.lanes, Cs), hv(Cs);
          }
          Xi = Xi.next;
        } while (Xi !== null && Xi !== Ei);
        ji === null ? Mi = Ni : ji.next = zi, Is(Ni, ut.memoizedState) || tv(), ut.memoizedState = Ni, ut.baseState = Mi, ut.baseQueue = ji, pt.lastRenderedState = Ni;
      }
      var So = pt.interleaved;
      if (So !== null) {
        var $i = So;
        do {
          var Zi = $i.lane;
          Uo.lanes = go(Uo.lanes, Zi), hv(Zi), $i = $i.next;
        } while ($i !== So);
      } else
        Qr === null && (pt.lanes = Ji);
      var Bi = pt.dispatch;
      return [ut.memoizedState, Bi];
    }
    function lT(Ke, Xe, it) {
      var ut = Vu(), pt = ut.queue;
      if (pt === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      pt.lastRenderedReducer = Ke;
      var Yr = pt.dispatch, Qr = pt.pending, ni = ut.memoizedState;
      if (Qr !== null) {
        pt.pending = null;
        var oi = Qr.next, vi = oi;
        do {
          var Ei = vi.action;
          ni = Ke(ni, Ei), vi = vi.next;
        } while (vi !== oi);
        Is(ni, ut.memoizedState) || tv(), ut.memoizedState = ni, ut.baseQueue === null && (ut.baseState = ni), pt.lastRenderedState = ni;
      }
      return [ni, Yr];
    }
    function uP(Ke, Xe, it) {
    }
    function cP(Ke, Xe, it) {
    }
    function uT(Ke, Xe, it) {
      var ut = Uo, pt = ud(), Yr, Qr = gl();
      if (Qr) {
        if (it === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        Yr = it(), Yg || Yr !== it() && (be("The result of getServerSnapshot should be cached to avoid an infinite loop"), Yg = !0);
      } else {
        if (Yr = Xe(), !Yg) {
          var ni = Xe();
          Is(Yr, ni) || (be("The result of getSnapshot should be cached to avoid an infinite loop"), Yg = !0);
        }
        var oi = XE();
        if (oi === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Hh(oi, dp) || JS(ut, Xe, Yr);
      }
      pt.memoizedState = Yr;
      var vi = {
        value: Yr,
        getSnapshot: Xe
      };
      return pt.queue = vi, _E(t_.bind(null, ut, vi, Ke), [Ke]), ut.flags |= na, Y0(Ka | ml, e_.bind(null, ut, vi, Yr, Xe), void 0, null), Yr;
    }
    function xE(Ke, Xe, it) {
      var ut = Uo, pt = Vu(), Yr = Xe();
      if (!Yg) {
        var Qr = Xe();
        Is(Yr, Qr) || (be("The result of getSnapshot should be cached to avoid an infinite loop"), Yg = !0);
      }
      var ni = pt.memoizedState, oi = !Is(ni, Yr);
      oi && (pt.memoizedState = Yr, tv());
      var vi = pt.queue;
      if (Z0(t_.bind(null, ut, vi, Ke), [Ke]), vi.getSnapshot !== Xe || oi || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Xa !== null && Xa.memoizedState.tag & Ka) {
        ut.flags |= na, Y0(Ka | ml, e_.bind(null, ut, vi, Yr, Xe), void 0, null);
        var Ei = XE();
        if (Ei === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Hh(Ei, dp) || JS(ut, Xe, Yr);
      }
      return Yr;
    }
    function JS(Ke, Xe, it) {
      Ke.flags |= Oh;
      var ut = {
        getSnapshot: Xe,
        value: it
      }, pt = Uo.updateQueue;
      if (pt === null)
        pt = QS(), Uo.updateQueue = pt, pt.stores = [ut];
      else {
        var Yr = pt.stores;
        Yr === null ? pt.stores = [ut] : Yr.push(ut);
      }
    }
    function e_(Ke, Xe, it, ut) {
      Xe.value = it, Xe.getSnapshot = ut, n_(Xe) && r_(Ke);
    }
    function t_(Ke, Xe, it) {
      var ut = function() {
        n_(Xe) && r_(Ke);
      };
      return it(ut);
    }
    function n_(Ke) {
      var Xe = Ke.getSnapshot, it = Ke.value;
      try {
        var ut = Xe();
        return !Is(it, ut);
      } catch {
        return !0;
      }
    }
    function r_(Ke) {
      var Xe = pu(Ke, to);
      Xe !== null && el(Xe, Ke, to, jo);
    }
    function TE(Ke) {
      var Xe = ud();
      typeof Ke == "function" && (Ke = Ke()), Xe.memoizedState = Xe.baseState = Ke;
      var it = {
        pending: null,
        interleaved: null,
        lanes: Ji,
        dispatch: null,
        lastRenderedReducer: sT,
        lastRenderedState: Ke
      };
      Xe.queue = it;
      var ut = it.dispatch = sA.bind(null, Uo, it);
      return [Xe.memoizedState, ut];
    }
    function cT(Ke) {
      return aT(sT);
    }
    function dT(Ke) {
      return lT(sT);
    }
    function Y0(Ke, Xe, it, ut) {
      var pt = {
        tag: Ke,
        create: Xe,
        destroy: it,
        deps: ut,
        // Circular
        next: null
      }, Yr = Uo.updateQueue;
      if (Yr === null)
        Yr = QS(), Uo.updateQueue = Yr, Yr.lastEffect = pt.next = pt;
      else {
        var Qr = Yr.lastEffect;
        if (Qr === null)
          Yr.lastEffect = pt.next = pt;
        else {
          var ni = Qr.next;
          Qr.next = pt, pt.next = ni, Yr.lastEffect = pt;
        }
      }
      return pt;
    }
    function fT(Ke) {
      var Xe = ud();
      {
        var it = {
          current: Ke
        };
        return Xe.memoizedState = it, it;
      }
    }
    function bE(Ke) {
      var Xe = Vu();
      return Xe.memoizedState;
    }
    function X0(Ke, Xe, it, ut) {
      var pt = ud(), Yr = ut === void 0 ? null : ut;
      Uo.flags |= Ke, pt.memoizedState = Y0(Ka | Xe, it, void 0, Yr);
    }
    function SE(Ke, Xe, it, ut) {
      var pt = Vu(), Yr = ut === void 0 ? null : ut, Qr = void 0;
      if (Ya !== null) {
        var ni = Ya.memoizedState;
        if (Qr = ni.destroy, Yr !== null) {
          var oi = ni.deps;
          if (iT(Yr, oi)) {
            pt.memoizedState = Y0(Xe, it, Qr, Yr);
            return;
          }
        }
      }
      Uo.flags |= Ke, pt.memoizedState = Y0(Ka | Xe, it, Qr, Yr);
    }
    function _E(Ke, Xe) {
      return (Uo.mode & au) !== Xs ? X0(Ad | na | Vc, ml, Ke, Xe) : X0(na | Vc, ml, Ke, Xe);
    }
    function Z0(Ke, Xe) {
      return SE(na, ml, Ke, Xe);
    }
    function hT(Ke, Xe) {
      return X0(po, ld, Ke, Xe);
    }
    function wE(Ke, Xe) {
      return SE(po, ld, Ke, Xe);
    }
    function pT(Ke, Xe) {
      var it = po;
      return it |= Al, (Uo.mode & au) !== Xs && (it |= Ll), X0(it, qa, Ke, Xe);
    }
    function CE(Ke, Xe) {
      return SE(po, qa, Ke, Xe);
    }
    function i_(Ke, Xe) {
      if (typeof Xe == "function") {
        var it = Xe, ut = Ke();
        return it(ut), function() {
          it(null);
        };
      } else if (Xe != null) {
        var pt = Xe;
        pt.hasOwnProperty("current") || be("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(pt).join(", ") + "}");
        var Yr = Ke();
        return pt.current = Yr, function() {
          pt.current = null;
        };
      }
    }
    function gT(Ke, Xe, it) {
      typeof Xe != "function" && be("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", Xe !== null ? typeof Xe : "null");
      var ut = it != null ? it.concat([Ke]) : null, pt = po;
      return pt |= Al, (Uo.mode & au) !== Xs && (pt |= Ll), X0(pt, qa, i_.bind(null, Xe, Ke), ut);
    }
    function RE(Ke, Xe, it) {
      typeof Xe != "function" && be("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", Xe !== null ? typeof Xe : "null");
      var ut = it != null ? it.concat([Ke]) : null;
      return SE(po, qa, i_.bind(null, Xe, Ke), ut);
    }
    function tA(Ke, Xe) {
    }
    var AE = tA;
    function mT(Ke, Xe) {
      var it = ud(), ut = Xe === void 0 ? null : Xe;
      return it.memoizedState = [Ke, ut], Ke;
    }
    function LE(Ke, Xe) {
      var it = Vu(), ut = Xe === void 0 ? null : Xe, pt = it.memoizedState;
      if (pt !== null && ut !== null) {
        var Yr = pt[1];
        if (iT(ut, Yr))
          return pt[0];
      }
      return it.memoizedState = [Ke, ut], Ke;
    }
    function vT(Ke, Xe) {
      var it = ud(), ut = Xe === void 0 ? null : Xe, pt = Ke();
      return it.memoizedState = [pt, ut], pt;
    }
    function IE(Ke, Xe) {
      var it = Vu(), ut = Xe === void 0 ? null : Xe, pt = it.memoizedState;
      if (pt !== null && ut !== null) {
        var Yr = pt[1];
        if (iT(ut, Yr))
          return pt[0];
      }
      var Qr = Ke();
      return it.memoizedState = [Qr, ut], Qr;
    }
    function yT(Ke) {
      var Xe = ud();
      return Xe.memoizedState = Ke, Ke;
    }
    function s_(Ke) {
      var Xe = Vu(), it = Ya, ut = it.memoizedState;
      return a_(Xe, ut, Ke);
    }
    function o_(Ke) {
      var Xe = Vu();
      if (Ya === null)
        return Xe.memoizedState = Ke, Ke;
      var it = Ya.memoizedState;
      return a_(Xe, it, Ke);
    }
    function a_(Ke, Xe, it) {
      var ut = !_1(dp);
      if (ut) {
        if (!Is(it, Xe)) {
          var pt = Qm();
          Uo.lanes = go(Uo.lanes, pt), hv(pt), Ke.baseState = !0;
        }
        return Xe;
      } else
        return Ke.baseState && (Ke.baseState = !1, tv()), Ke.memoizedState = it, it;
    }
    function nA(Ke, Xe, it) {
      var ut = uu();
      Pa(rl(ut, Wa)), Ke(!0);
      var pt = W0.transition;
      W0.transition = {};
      var Yr = W0.transition;
      W0.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        Ke(!1), Xe();
      } finally {
        if (Pa(ut), W0.transition = pt, pt === null && Yr._updatedFibers) {
          var Qr = Yr._updatedFibers.size;
          Qr > 10 && ye("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), Yr._updatedFibers.clear();
        }
      }
    }
    function ET() {
      var Ke = TE(!1), Xe = Ke[0], it = Ke[1], ut = nA.bind(null, it), pt = ud();
      return pt.memoizedState = ut, [Xe, ut];
    }
    function l_() {
      var Ke = cT(), Xe = Ke[0], it = Vu(), ut = it.memoizedState;
      return [Xe, ut];
    }
    function u_() {
      var Ke = dT(), Xe = Ke[0], it = Vu(), ut = it.memoizedState;
      return [Xe, ut];
    }
    var c_ = !1;
    function rA() {
      return c_;
    }
    function xT() {
      var Ke = ud(), Xe = XE(), it = Xe.identifierPrefix, ut;
      if (gl()) {
        var pt = v2();
        ut = ":" + it + "R" + pt;
        var Yr = q0++;
        Yr > 0 && (ut += "H" + Yr.toString(32)), ut += ":";
      } else {
        var Qr = Q2++;
        ut = ":" + it + "r" + Qr.toString(32) + ":";
      }
      return Ke.memoizedState = ut, ut;
    }
    function PE() {
      var Ke = Vu(), Xe = Ke.memoizedState;
      return Xe;
    }
    function iA(Ke, Xe, it) {
      typeof arguments[3] == "function" && be("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var ut = ch(Ke), pt = {
        lane: ut,
        action: it,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (d_(Ke))
        f_(Xe, pt);
      else {
        var Yr = LS(Ke, Xe, pt, ut);
        if (Yr !== null) {
          var Qr = Yl();
          el(Yr, Ke, ut, Qr), h_(Yr, Xe, ut);
        }
      }
      p_(Ke, ut);
    }
    function sA(Ke, Xe, it) {
      typeof arguments[3] == "function" && be("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var ut = ch(Ke), pt = {
        lane: ut,
        action: it,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (d_(Ke))
        f_(Xe, pt);
      else {
        var Yr = Ke.alternate;
        if (Ke.lanes === Ji && (Yr === null || Yr.lanes === Ji)) {
          var Qr = Xe.lastRenderedReducer;
          if (Qr !== null) {
            var ni;
            ni = ws.current, ws.current = vc;
            try {
              var oi = Xe.lastRenderedState, vi = Qr(oi, it);
              if (pt.hasEagerState = !0, pt.eagerState = vi, Is(vi, oi)) {
                F2(Ke, Xe, pt, ut);
                return;
              }
            } catch {
            } finally {
              ws.current = ni;
            }
          }
        }
        var Ei = LS(Ke, Xe, pt, ut);
        if (Ei !== null) {
          var Ni = Yl();
          el(Ei, Ke, ut, Ni), h_(Ei, Xe, ut);
        }
      }
      p_(Ke, ut);
    }
    function d_(Ke) {
      var Xe = Ke.alternate;
      return Ke === Uo || Xe !== null && Xe === Uo;
    }
    function f_(Ke, Xe) {
      K0 = EE = !0;
      var it = Ke.pending;
      it === null ? Xe.next = Xe : (Xe.next = it.next, it.next = Xe), Ke.pending = Xe;
    }
    function h_(Ke, Xe, it) {
      if (Zm(it)) {
        var ut = Xe.lanes;
        ut = Jm(ut, Ke.pendingLanes);
        var pt = go(ut, it);
        Xe.lanes = pt, Nf(Ke, pt);
      }
    }
    function p_(Ke, Xe, it) {
      Xc(Ke, Xe);
    }
    var DE = {
      readContext: Ha,
      useCallback: Fl,
      useContext: Fl,
      useEffect: Fl,
      useImperativeHandle: Fl,
      useInsertionEffect: Fl,
      useLayoutEffect: Fl,
      useMemo: Fl,
      useReducer: Fl,
      useRef: Fl,
      useState: Fl,
      useDebugValue: Fl,
      useDeferredValue: Fl,
      useTransition: Fl,
      useMutableSource: Fl,
      useSyncExternalStore: Fl,
      useId: Fl,
      unstable_isNewReconciler: _i
    }, g_ = null, m_ = null, v_ = null, y_ = null, cd = null, vc = null, OE = null;
    {
      var TT = function() {
        be("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, co = function() {
        be("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      g_ = {
        readContext: function(Ke) {
          return Ha(Ke);
        },
        useCallback: function(Ke, Xe) {
          return ts = "useCallback", $o(), Xg(Xe), mT(Ke, Xe);
        },
        useContext: function(Ke) {
          return ts = "useContext", $o(), Ha(Ke);
        },
        useEffect: function(Ke, Xe) {
          return ts = "useEffect", $o(), Xg(Xe), _E(Ke, Xe);
        },
        useImperativeHandle: function(Ke, Xe, it) {
          return ts = "useImperativeHandle", $o(), Xg(it), gT(Ke, Xe, it);
        },
        useInsertionEffect: function(Ke, Xe) {
          return ts = "useInsertionEffect", $o(), Xg(Xe), hT(Ke, Xe);
        },
        useLayoutEffect: function(Ke, Xe) {
          return ts = "useLayoutEffect", $o(), Xg(Xe), pT(Ke, Xe);
        },
        useMemo: function(Ke, Xe) {
          ts = "useMemo", $o(), Xg(Xe);
          var it = ws.current;
          ws.current = cd;
          try {
            return vT(Ke, Xe);
          } finally {
            ws.current = it;
          }
        },
        useReducer: function(Ke, Xe, it) {
          ts = "useReducer", $o();
          var ut = ws.current;
          ws.current = cd;
          try {
            return oT(Ke, Xe, it);
          } finally {
            ws.current = ut;
          }
        },
        useRef: function(Ke) {
          return ts = "useRef", $o(), fT(Ke);
        },
        useState: function(Ke) {
          ts = "useState", $o();
          var Xe = ws.current;
          ws.current = cd;
          try {
            return TE(Ke);
          } finally {
            ws.current = Xe;
          }
        },
        useDebugValue: function(Ke, Xe) {
          return ts = "useDebugValue", $o(), void 0;
        },
        useDeferredValue: function(Ke) {
          return ts = "useDeferredValue", $o(), yT(Ke);
        },
        useTransition: function() {
          return ts = "useTransition", $o(), ET();
        },
        useMutableSource: function(Ke, Xe, it) {
          return ts = "useMutableSource", $o(), void 0;
        },
        useSyncExternalStore: function(Ke, Xe, it) {
          return ts = "useSyncExternalStore", $o(), uT(Ke, Xe, it);
        },
        useId: function() {
          return ts = "useId", $o(), xT();
        },
        unstable_isNewReconciler: _i
      }, m_ = {
        readContext: function(Ke) {
          return Ha(Ke);
        },
        useCallback: function(Ke, Xe) {
          return ts = "useCallback", ys(), mT(Ke, Xe);
        },
        useContext: function(Ke) {
          return ts = "useContext", ys(), Ha(Ke);
        },
        useEffect: function(Ke, Xe) {
          return ts = "useEffect", ys(), _E(Ke, Xe);
        },
        useImperativeHandle: function(Ke, Xe, it) {
          return ts = "useImperativeHandle", ys(), gT(Ke, Xe, it);
        },
        useInsertionEffect: function(Ke, Xe) {
          return ts = "useInsertionEffect", ys(), hT(Ke, Xe);
        },
        useLayoutEffect: function(Ke, Xe) {
          return ts = "useLayoutEffect", ys(), pT(Ke, Xe);
        },
        useMemo: function(Ke, Xe) {
          ts = "useMemo", ys();
          var it = ws.current;
          ws.current = cd;
          try {
            return vT(Ke, Xe);
          } finally {
            ws.current = it;
          }
        },
        useReducer: function(Ke, Xe, it) {
          ts = "useReducer", ys();
          var ut = ws.current;
          ws.current = cd;
          try {
            return oT(Ke, Xe, it);
          } finally {
            ws.current = ut;
          }
        },
        useRef: function(Ke) {
          return ts = "useRef", ys(), fT(Ke);
        },
        useState: function(Ke) {
          ts = "useState", ys();
          var Xe = ws.current;
          ws.current = cd;
          try {
            return TE(Ke);
          } finally {
            ws.current = Xe;
          }
        },
        useDebugValue: function(Ke, Xe) {
          return ts = "useDebugValue", ys(), void 0;
        },
        useDeferredValue: function(Ke) {
          return ts = "useDeferredValue", ys(), yT(Ke);
        },
        useTransition: function() {
          return ts = "useTransition", ys(), ET();
        },
        useMutableSource: function(Ke, Xe, it) {
          return ts = "useMutableSource", ys(), void 0;
        },
        useSyncExternalStore: function(Ke, Xe, it) {
          return ts = "useSyncExternalStore", ys(), uT(Ke, Xe, it);
        },
        useId: function() {
          return ts = "useId", ys(), xT();
        },
        unstable_isNewReconciler: _i
      }, v_ = {
        readContext: function(Ke) {
          return Ha(Ke);
        },
        useCallback: function(Ke, Xe) {
          return ts = "useCallback", ys(), LE(Ke, Xe);
        },
        useContext: function(Ke) {
          return ts = "useContext", ys(), Ha(Ke);
        },
        useEffect: function(Ke, Xe) {
          return ts = "useEffect", ys(), Z0(Ke, Xe);
        },
        useImperativeHandle: function(Ke, Xe, it) {
          return ts = "useImperativeHandle", ys(), RE(Ke, Xe, it);
        },
        useInsertionEffect: function(Ke, Xe) {
          return ts = "useInsertionEffect", ys(), wE(Ke, Xe);
        },
        useLayoutEffect: function(Ke, Xe) {
          return ts = "useLayoutEffect", ys(), CE(Ke, Xe);
        },
        useMemo: function(Ke, Xe) {
          ts = "useMemo", ys();
          var it = ws.current;
          ws.current = vc;
          try {
            return IE(Ke, Xe);
          } finally {
            ws.current = it;
          }
        },
        useReducer: function(Ke, Xe, it) {
          ts = "useReducer", ys();
          var ut = ws.current;
          ws.current = vc;
          try {
            return aT(Ke, Xe, it);
          } finally {
            ws.current = ut;
          }
        },
        useRef: function(Ke) {
          return ts = "useRef", ys(), bE();
        },
        useState: function(Ke) {
          ts = "useState", ys();
          var Xe = ws.current;
          ws.current = vc;
          try {
            return cT(Ke);
          } finally {
            ws.current = Xe;
          }
        },
        useDebugValue: function(Ke, Xe) {
          return ts = "useDebugValue", ys(), AE();
        },
        useDeferredValue: function(Ke) {
          return ts = "useDeferredValue", ys(), s_(Ke);
        },
        useTransition: function() {
          return ts = "useTransition", ys(), l_();
        },
        useMutableSource: function(Ke, Xe, it) {
          return ts = "useMutableSource", ys(), void 0;
        },
        useSyncExternalStore: function(Ke, Xe, it) {
          return ts = "useSyncExternalStore", ys(), xE(Ke, Xe);
        },
        useId: function() {
          return ts = "useId", ys(), PE();
        },
        unstable_isNewReconciler: _i
      }, y_ = {
        readContext: function(Ke) {
          return Ha(Ke);
        },
        useCallback: function(Ke, Xe) {
          return ts = "useCallback", ys(), LE(Ke, Xe);
        },
        useContext: function(Ke) {
          return ts = "useContext", ys(), Ha(Ke);
        },
        useEffect: function(Ke, Xe) {
          return ts = "useEffect", ys(), Z0(Ke, Xe);
        },
        useImperativeHandle: function(Ke, Xe, it) {
          return ts = "useImperativeHandle", ys(), RE(Ke, Xe, it);
        },
        useInsertionEffect: function(Ke, Xe) {
          return ts = "useInsertionEffect", ys(), wE(Ke, Xe);
        },
        useLayoutEffect: function(Ke, Xe) {
          return ts = "useLayoutEffect", ys(), CE(Ke, Xe);
        },
        useMemo: function(Ke, Xe) {
          ts = "useMemo", ys();
          var it = ws.current;
          ws.current = OE;
          try {
            return IE(Ke, Xe);
          } finally {
            ws.current = it;
          }
        },
        useReducer: function(Ke, Xe, it) {
          ts = "useReducer", ys();
          var ut = ws.current;
          ws.current = OE;
          try {
            return lT(Ke, Xe, it);
          } finally {
            ws.current = ut;
          }
        },
        useRef: function(Ke) {
          return ts = "useRef", ys(), bE();
        },
        useState: function(Ke) {
          ts = "useState", ys();
          var Xe = ws.current;
          ws.current = OE;
          try {
            return dT(Ke);
          } finally {
            ws.current = Xe;
          }
        },
        useDebugValue: function(Ke, Xe) {
          return ts = "useDebugValue", ys(), AE();
        },
        useDeferredValue: function(Ke) {
          return ts = "useDeferredValue", ys(), o_(Ke);
        },
        useTransition: function() {
          return ts = "useTransition", ys(), u_();
        },
        useMutableSource: function(Ke, Xe, it) {
          return ts = "useMutableSource", ys(), void 0;
        },
        useSyncExternalStore: function(Ke, Xe, it) {
          return ts = "useSyncExternalStore", ys(), xE(Ke, Xe);
        },
        useId: function() {
          return ts = "useId", ys(), PE();
        },
        unstable_isNewReconciler: _i
      }, cd = {
        readContext: function(Ke) {
          return TT(), Ha(Ke);
        },
        useCallback: function(Ke, Xe) {
          return ts = "useCallback", co(), $o(), mT(Ke, Xe);
        },
        useContext: function(Ke) {
          return ts = "useContext", co(), $o(), Ha(Ke);
        },
        useEffect: function(Ke, Xe) {
          return ts = "useEffect", co(), $o(), _E(Ke, Xe);
        },
        useImperativeHandle: function(Ke, Xe, it) {
          return ts = "useImperativeHandle", co(), $o(), gT(Ke, Xe, it);
        },
        useInsertionEffect: function(Ke, Xe) {
          return ts = "useInsertionEffect", co(), $o(), hT(Ke, Xe);
        },
        useLayoutEffect: function(Ke, Xe) {
          return ts = "useLayoutEffect", co(), $o(), pT(Ke, Xe);
        },
        useMemo: function(Ke, Xe) {
          ts = "useMemo", co(), $o();
          var it = ws.current;
          ws.current = cd;
          try {
            return vT(Ke, Xe);
          } finally {
            ws.current = it;
          }
        },
        useReducer: function(Ke, Xe, it) {
          ts = "useReducer", co(), $o();
          var ut = ws.current;
          ws.current = cd;
          try {
            return oT(Ke, Xe, it);
          } finally {
            ws.current = ut;
          }
        },
        useRef: function(Ke) {
          return ts = "useRef", co(), $o(), fT(Ke);
        },
        useState: function(Ke) {
          ts = "useState", co(), $o();
          var Xe = ws.current;
          ws.current = cd;
          try {
            return TE(Ke);
          } finally {
            ws.current = Xe;
          }
        },
        useDebugValue: function(Ke, Xe) {
          return ts = "useDebugValue", co(), $o(), void 0;
        },
        useDeferredValue: function(Ke) {
          return ts = "useDeferredValue", co(), $o(), yT(Ke);
        },
        useTransition: function() {
          return ts = "useTransition", co(), $o(), ET();
        },
        useMutableSource: function(Ke, Xe, it) {
          return ts = "useMutableSource", co(), $o(), void 0;
        },
        useSyncExternalStore: function(Ke, Xe, it) {
          return ts = "useSyncExternalStore", co(), $o(), uT(Ke, Xe, it);
        },
        useId: function() {
          return ts = "useId", co(), $o(), xT();
        },
        unstable_isNewReconciler: _i
      }, vc = {
        readContext: function(Ke) {
          return TT(), Ha(Ke);
        },
        useCallback: function(Ke, Xe) {
          return ts = "useCallback", co(), ys(), LE(Ke, Xe);
        },
        useContext: function(Ke) {
          return ts = "useContext", co(), ys(), Ha(Ke);
        },
        useEffect: function(Ke, Xe) {
          return ts = "useEffect", co(), ys(), Z0(Ke, Xe);
        },
        useImperativeHandle: function(Ke, Xe, it) {
          return ts = "useImperativeHandle", co(), ys(), RE(Ke, Xe, it);
        },
        useInsertionEffect: function(Ke, Xe) {
          return ts = "useInsertionEffect", co(), ys(), wE(Ke, Xe);
        },
        useLayoutEffect: function(Ke, Xe) {
          return ts = "useLayoutEffect", co(), ys(), CE(Ke, Xe);
        },
        useMemo: function(Ke, Xe) {
          ts = "useMemo", co(), ys();
          var it = ws.current;
          ws.current = vc;
          try {
            return IE(Ke, Xe);
          } finally {
            ws.current = it;
          }
        },
        useReducer: function(Ke, Xe, it) {
          ts = "useReducer", co(), ys();
          var ut = ws.current;
          ws.current = vc;
          try {
            return aT(Ke, Xe, it);
          } finally {
            ws.current = ut;
          }
        },
        useRef: function(Ke) {
          return ts = "useRef", co(), ys(), bE();
        },
        useState: function(Ke) {
          ts = "useState", co(), ys();
          var Xe = ws.current;
          ws.current = vc;
          try {
            return cT(Ke);
          } finally {
            ws.current = Xe;
          }
        },
        useDebugValue: function(Ke, Xe) {
          return ts = "useDebugValue", co(), ys(), AE();
        },
        useDeferredValue: function(Ke) {
          return ts = "useDeferredValue", co(), ys(), s_(Ke);
        },
        useTransition: function() {
          return ts = "useTransition", co(), ys(), l_();
        },
        useMutableSource: function(Ke, Xe, it) {
          return ts = "useMutableSource", co(), ys(), void 0;
        },
        useSyncExternalStore: function(Ke, Xe, it) {
          return ts = "useSyncExternalStore", co(), ys(), xE(Ke, Xe);
        },
        useId: function() {
          return ts = "useId", co(), ys(), PE();
        },
        unstable_isNewReconciler: _i
      }, OE = {
        readContext: function(Ke) {
          return TT(), Ha(Ke);
        },
        useCallback: function(Ke, Xe) {
          return ts = "useCallback", co(), ys(), LE(Ke, Xe);
        },
        useContext: function(Ke) {
          return ts = "useContext", co(), ys(), Ha(Ke);
        },
        useEffect: function(Ke, Xe) {
          return ts = "useEffect", co(), ys(), Z0(Ke, Xe);
        },
        useImperativeHandle: function(Ke, Xe, it) {
          return ts = "useImperativeHandle", co(), ys(), RE(Ke, Xe, it);
        },
        useInsertionEffect: function(Ke, Xe) {
          return ts = "useInsertionEffect", co(), ys(), wE(Ke, Xe);
        },
        useLayoutEffect: function(Ke, Xe) {
          return ts = "useLayoutEffect", co(), ys(), CE(Ke, Xe);
        },
        useMemo: function(Ke, Xe) {
          ts = "useMemo", co(), ys();
          var it = ws.current;
          ws.current = vc;
          try {
            return IE(Ke, Xe);
          } finally {
            ws.current = it;
          }
        },
        useReducer: function(Ke, Xe, it) {
          ts = "useReducer", co(), ys();
          var ut = ws.current;
          ws.current = vc;
          try {
            return lT(Ke, Xe, it);
          } finally {
            ws.current = ut;
          }
        },
        useRef: function(Ke) {
          return ts = "useRef", co(), ys(), bE();
        },
        useState: function(Ke) {
          ts = "useState", co(), ys();
          var Xe = ws.current;
          ws.current = vc;
          try {
            return dT(Ke);
          } finally {
            ws.current = Xe;
          }
        },
        useDebugValue: function(Ke, Xe) {
          return ts = "useDebugValue", co(), ys(), AE();
        },
        useDeferredValue: function(Ke) {
          return ts = "useDeferredValue", co(), ys(), o_(Ke);
        },
        useTransition: function() {
          return ts = "useTransition", co(), ys(), u_();
        },
        useMutableSource: function(Ke, Xe, it) {
          return ts = "useMutableSource", co(), ys(), void 0;
        },
        useSyncExternalStore: function(Ke, Xe, it) {
          return ts = "useSyncExternalStore", co(), ys(), xE(Ke, Xe);
        },
        useId: function() {
          return ts = "useId", co(), ys(), PE();
        },
        unstable_isNewReconciler: _i
      };
    }
    var oh = Z.unstable_now, E_ = 0, ME = -1, Q0 = -1, kE = -1, bT = !1, NE = !1;
    function x_() {
      return bT;
    }
    function oA() {
      NE = !0;
    }
    function aA() {
      bT = !1, NE = !1;
    }
    function lA() {
      bT = NE, NE = !1;
    }
    function T_() {
      return E_;
    }
    function b_() {
      E_ = oh();
    }
    function ST(Ke) {
      Q0 = oh(), Ke.actualStartTime < 0 && (Ke.actualStartTime = oh());
    }
    function S_(Ke) {
      Q0 = -1;
    }
    function FE(Ke, Xe) {
      if (Q0 >= 0) {
        var it = oh() - Q0;
        Ke.actualDuration += it, Xe && (Ke.selfBaseDuration = it), Q0 = -1;
      }
    }
    function dd(Ke) {
      if (ME >= 0) {
        var Xe = oh() - ME;
        ME = -1;
        for (var it = Ke.return; it !== null; ) {
          switch (it.tag) {
            case st:
              var ut = it.stateNode;
              ut.effectDuration += Xe;
              return;
            case Jr:
              var pt = it.stateNode;
              pt.effectDuration += Xe;
              return;
          }
          it = it.return;
        }
      }
    }
    function _T(Ke) {
      if (kE >= 0) {
        var Xe = oh() - kE;
        kE = -1;
        for (var it = Ke.return; it !== null; ) {
          switch (it.tag) {
            case st:
              var ut = it.stateNode;
              ut !== null && (ut.passiveEffectDuration += Xe);
              return;
            case Jr:
              var pt = it.stateNode;
              pt !== null && (pt.passiveEffectDuration += Xe);
              return;
          }
          it = it.return;
        }
      }
    }
    function hd() {
      ME = oh();
    }
    function wT() {
      kE = oh();
    }
    function CT(Ke) {
      for (var Xe = Ke.child; Xe; )
        Ke.actualDuration += Xe.actualDuration, Xe = Xe.sibling;
    }
    function fp(Ke, Xe) {
      return {
        value: Ke,
        source: Xe,
        stack: hf(Xe),
        digest: null
      };
    }
    function RT(Ke, Xe, it) {
      return {
        value: Ke,
        source: null,
        stack: it ?? null,
        digest: Xe ?? null
      };
    }
    function uA(Ke, Xe) {
      return !0;
    }
    function LT(Ke, Xe) {
      try {
        var it = uA(Ke, Xe);
        if (it === !1)
          return;
        var ut = Xe.value, pt = Xe.source, Yr = Xe.stack, Qr = Yr !== null ? Yr : "";
        if (ut != null && ut._suppressLogging) {
          if (Ke.tag === Je)
            return;
          console.error(ut);
        }
        var ni = pt ? uo(pt) : null, oi = ni ? "The above error occurred in the <" + ni + "> component:" : "The above error occurred in one of your React components:", vi;
        if (Ke.tag === st)
          vi = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var Ei = uo(Ke) || "Anonymous";
          vi = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + Ei + ".");
        }
        var Ni = oi + `
` + Qr + `

` + ("" + vi);
        console.error(Ni);
      } catch (Mi) {
        setTimeout(function() {
          throw Mi;
        });
      }
    }
    var cA = typeof WeakMap == "function" ? WeakMap : Map;
    function __(Ke, Xe, it) {
      var ut = ef(jo, it);
      ut.tag = Ax, ut.payload = {
        element: null
      };
      var pt = Xe.value;
      return ut.callback = function() {
        nI(pt), LT(Ke, Xe);
      }, ut;
    }
    function IT(Ke, Xe, it) {
      var ut = ef(jo, it);
      ut.tag = Ax;
      var pt = Ke.type.getDerivedStateFromError;
      if (typeof pt == "function") {
        var Yr = Xe.value;
        ut.payload = function() {
          return pt(Yr);
        }, ut.callback = function() {
          kw(Ke), LT(Ke, Xe);
        };
      }
      var Qr = Ke.stateNode;
      return Qr !== null && typeof Qr.componentDidCatch == "function" && (ut.callback = function() {
        kw(Ke), LT(Ke, Xe), typeof pt != "function" && eI(this);
        var oi = Xe.value, vi = Xe.stack;
        this.componentDidCatch(oi, {
          componentStack: vi !== null ? vi : ""
        }), typeof pt != "function" && (Ml(Ke.lanes, to) || be("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", uo(Ke) || "Unknown"));
      }), ut;
    }
    function w_(Ke, Xe, it) {
      var ut = Ke.pingCache, pt;
      if (ut === null ? (ut = Ke.pingCache = new cA(), pt = /* @__PURE__ */ new Set(), ut.set(Xe, pt)) : (pt = ut.get(Xe), pt === void 0 && (pt = /* @__PURE__ */ new Set(), ut.set(Xe, pt))), !pt.has(it)) {
        pt.add(it);
        var Yr = rI.bind(null, Ke, Xe, it);
        ja && pv(Ke, it), Xe.then(Yr, Yr);
      }
    }
    function dA(Ke, Xe, it, ut) {
      var pt = Ke.updateQueue;
      if (pt === null) {
        var Yr = /* @__PURE__ */ new Set();
        Yr.add(it), Ke.updateQueue = Yr;
      } else
        pt.add(it);
    }
    function fA(Ke, Xe) {
      var it = Ke.tag;
      if ((Ke.mode & Eo) === Xs && (it === Qe || it === Xr || it === ri)) {
        var ut = Ke.alternate;
        ut ? (Ke.updateQueue = ut.updateQueue, Ke.memoizedState = ut.memoizedState, Ke.lanes = ut.lanes) : (Ke.updateQueue = null, Ke.memoizedState = null);
      }
    }
    function C_(Ke) {
      var Xe = Ke;
      do {
        if (Xe.tag === ei && X2(Xe))
          return Xe;
        Xe = Xe.return;
      } while (Xe !== null);
      return null;
    }
    function R_(Ke, Xe, it, ut, pt) {
      if ((Ke.mode & Eo) === Xs) {
        if (Ke === Xe)
          Ke.flags |= Fa;
        else {
          if (Ke.flags |= io, it.flags |= Mh, it.flags &= ~(Fp | Gl), it.tag === Je) {
            var Yr = it.alternate;
            if (Yr === null)
              it.tag = yi;
            else {
              var Qr = ef(jo, to);
              Qr.tag = aE, nh(it, Qr, to);
            }
          }
          it.lanes = go(it.lanes, to);
        }
        return Ke;
      }
      return Ke.flags |= Fa, Ke.lanes = pt, Ke;
    }
    function hA(Ke, Xe, it, ut, pt) {
      if (it.flags |= Gl, ja && pv(Ke, pt), ut !== null && typeof ut == "object" && typeof ut.then == "function") {
        var Yr = ut;
        fA(it), gl() && it.mode & Eo && vS();
        var Qr = C_(Xe);
        if (Qr !== null) {
          Qr.flags &= ~pa, R_(Qr, Xe, it, Ke, pt), Qr.mode & Eo && w_(Ke, Yr, pt), dA(Qr, Ke, Yr);
          return;
        } else {
          if (!Mf(pt)) {
            w_(Ke, Yr, pt), ub();
            return;
          }
          var ni = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          ut = ni;
        }
      } else if (gl() && it.mode & Eo) {
        vS();
        var oi = C_(Xe);
        if (oi !== null) {
          (oi.flags & Fa) === js && (oi.flags |= pa), R_(oi, Xe, it, Ke, pt), Tx(fp(ut, it));
          return;
        }
      }
      ut = fp(ut, it), WL(ut);
      var vi = Xe;
      do {
        switch (vi.tag) {
          case st: {
            var Ei = ut;
            vi.flags |= Fa;
            var Ni = Ia(pt);
            vi.lanes = go(vi.lanes, Ni);
            var Mi = __(vi, Ei, Ni);
            Px(vi, Mi);
            return;
          }
          case Je:
            var zi = ut, ji = vi.type, Xi = vi.stateNode;
            if ((vi.flags & io) === js && (typeof ji.getDerivedStateFromError == "function" || Xi !== null && typeof Xi.componentDidCatch == "function" && !Cw(Xi))) {
              vi.flags |= Fa;
              var Cs = Ia(pt);
              vi.lanes = go(vi.lanes, Cs);
              var qs = IT(vi, zi, Cs);
              Px(vi, qs);
              return;
            }
            break;
        }
        vi = vi.return;
      } while (vi !== null);
    }
    function pA() {
      return null;
    }
    var J0 = ee.ReactCurrentOwner, yc = !1, PT, ev, DT, OT, MT, hp, kT, $E;
    PT = {}, ev = {}, DT = {}, OT = {}, MT = {}, hp = !1, kT = {}, $E = {};
    function Kl(Ke, Xe, it, ut) {
      Ke === null ? Xe.child = jS(Xe, null, it, ut) : Xe.child = jg(Xe, Ke.child, it, ut);
    }
    function gA(Ke, Xe, it, ut) {
      Xe.child = jg(Xe, Ke.child, null, ut), Xe.child = jg(Xe, null, it, ut);
    }
    function A_(Ke, Xe, it, ut, pt) {
      if (Xe.type !== Xe.elementType) {
        var Yr = it.propTypes;
        Yr && fc(
          Yr,
          ut,
          // Resolved props
          "prop",
          Lo(it)
        );
      }
      var Qr = it.render, ni = Xe.ref, oi, vi;
      Vg(Xe, pt), Yc(Xe);
      {
        if (J0.current = Xe, wl(!0), oi = Zg(Ke, Xe, Qr, ut, ni, pt), vi = Qg(), Xe.mode & aa) {
          La(!0);
          try {
            oi = Zg(Ke, Xe, Qr, ut, ni, pt), vi = Qg();
          } finally {
            La(!1);
          }
        }
        wl(!1);
      }
      return Ld(), Ke !== null && !yc ? (XS(Ke, Xe, pt), tf(Ke, Xe, pt)) : (gl() && vi && gx(Xe), Xe.flags |= Hc, Kl(Ke, Xe, oi, pt), Xe.child);
    }
    function L_(Ke, Xe, it, ut, pt) {
      if (Ke === null) {
        var Yr = it.type;
        if (xI(Yr) && it.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        it.defaultProps === void 0) {
          var Qr = Yr;
          return Qr = om(Yr), Xe.tag = ri, Xe.type = Qr, $T(Xe, Yr), I_(Ke, Xe, Qr, ut, pt);
        }
        {
          var ni = Yr.propTypes;
          ni && fc(
            ni,
            ut,
            // Resolved props
            "prop",
            Lo(Yr)
          );
        }
        var oi = xb(it.type, null, ut, Xe, Xe.mode, pt);
        return oi.ref = Xe.ref, oi.return = Xe, Xe.child = oi, oi;
      }
      {
        var vi = it.type, Ei = vi.propTypes;
        Ei && fc(
          Ei,
          ut,
          // Resolved props
          "prop",
          Lo(vi)
        );
      }
      var Ni = Ke.child, Mi = VT(Ke, pt);
      if (!Mi) {
        var zi = Ni.memoizedProps, ji = it.compare;
        if (ji = ji !== null ? ji : zs, ji(zi, ut) && Ke.ref === Xe.ref)
          return tf(Ke, Xe, pt);
      }
      Xe.flags |= Hc;
      var Xi = yp(Ni, ut);
      return Xi.ref = Xe.ref, Xi.return = Xe, Xe.child = Xi, Xi;
    }
    function I_(Ke, Xe, it, ut, pt) {
      if (Xe.type !== Xe.elementType) {
        var Yr = Xe.elementType;
        if (Yr.$$typeof === za) {
          var Qr = Yr, ni = Qr._payload, oi = Qr._init;
          try {
            Yr = oi(ni);
          } catch {
            Yr = null;
          }
          var vi = Yr && Yr.propTypes;
          vi && fc(
            vi,
            ut,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Lo(Yr)
          );
        }
      }
      if (Ke !== null) {
        var Ei = Ke.memoizedProps;
        if (zs(Ei, ut) && Ke.ref === Xe.ref && // Prevent bailout if the implementation changed due to hot reload.
        Xe.type === Ke.type)
          if (yc = !1, Xe.pendingProps = ut = Ei, VT(Ke, pt))
            (Ke.flags & Mh) !== js && (yc = !0);
          else
            return Xe.lanes = Ke.lanes, tf(Ke, Xe, pt);
      }
      return NT(Ke, Xe, it, ut, pt);
    }
    function P_(Ke, Xe, it) {
      var ut = Xe.pendingProps, pt = ut.children, Yr = Ke !== null ? Ke.memoizedState : null;
      if (ut.mode === "hidden" || hi)
        if ((Xe.mode & Eo) === Xs) {
          var Qr = {
            baseLanes: Ji,
            cachePool: null,
            transitions: null
          };
          Xe.memoizedState = Qr, ZE(Xe, it);
        } else if (Ml(it, Ol)) {
          var Ni = {
            baseLanes: Ji,
            cachePool: null,
            transitions: null
          };
          Xe.memoizedState = Ni;
          var Mi = Yr !== null ? Yr.baseLanes : it;
          ZE(Xe, Mi);
        } else {
          var ni = null, oi;
          if (Yr !== null) {
            var vi = Yr.baseLanes;
            oi = go(vi, it);
          } else
            oi = it;
          Xe.lanes = Xe.childLanes = Ol;
          var Ei = {
            baseLanes: oi,
            cachePool: ni,
            transitions: null
          };
          return Xe.memoizedState = Ei, Xe.updateQueue = null, ZE(Xe, oi), null;
        }
      else {
        var zi;
        Yr !== null ? (zi = go(Yr.baseLanes, it), Xe.memoizedState = null) : zi = it, ZE(Xe, zi);
      }
      return Kl(Ke, Xe, pt, it), Xe.child;
    }
    function mA(Ke, Xe, it) {
      var ut = Xe.pendingProps;
      return Kl(Ke, Xe, ut, it), Xe.child;
    }
    function vA(Ke, Xe, it) {
      var ut = Xe.pendingProps.children;
      return Kl(Ke, Xe, ut, it), Xe.child;
    }
    function yA(Ke, Xe, it) {
      {
        Xe.flags |= po;
        {
          var ut = Xe.stateNode;
          ut.effectDuration = 0, ut.passiveEffectDuration = 0;
        }
      }
      var pt = Xe.pendingProps, Yr = pt.children;
      return Kl(Ke, Xe, Yr, it), Xe.child;
    }
    function D_(Ke, Xe) {
      var it = Xe.ref;
      (Ke === null && it !== null || Ke !== null && Ke.ref !== it) && (Xe.flags |= Rl, Xe.flags |= Nm);
    }
    function NT(Ke, Xe, it, ut, pt) {
      if (Xe.type !== Xe.elementType) {
        var Yr = it.propTypes;
        Yr && fc(
          Yr,
          ut,
          // Resolved props
          "prop",
          Lo(it)
        );
      }
      var Qr;
      {
        var ni = $g(Xe, it, !0);
        Qr = Bg(Xe, ni);
      }
      var oi, vi;
      Vg(Xe, pt), Yc(Xe);
      {
        if (J0.current = Xe, wl(!0), oi = Zg(Ke, Xe, it, ut, Qr, pt), vi = Qg(), Xe.mode & aa) {
          La(!0);
          try {
            oi = Zg(Ke, Xe, it, ut, Qr, pt), vi = Qg();
          } finally {
            La(!1);
          }
        }
        wl(!1);
      }
      return Ld(), Ke !== null && !yc ? (XS(Ke, Xe, pt), tf(Ke, Xe, pt)) : (gl() && vi && gx(Xe), Xe.flags |= Hc, Kl(Ke, Xe, oi, pt), Xe.child);
    }
    function O_(Ke, Xe, it, ut, pt) {
      {
        switch (kI(Xe)) {
          case !1: {
            var Yr = Xe.stateNode, Qr = Xe.type, ni = new Qr(Xe.memoizedProps, Yr.context), oi = ni.state;
            Yr.updater.enqueueSetState(Yr, oi, null);
            break;
          }
          case !0: {
            Xe.flags |= io, Xe.flags |= Fa;
            var vi = new Error("Simulated error coming from DevTools"), Ei = Ia(pt);
            Xe.lanes = go(Xe.lanes, Ei);
            var Ni = IT(Xe, fp(vi, Xe), Ei);
            Px(Xe, Ni);
            break;
          }
        }
        if (Xe.type !== Xe.elementType) {
          var Mi = it.propTypes;
          Mi && fc(
            Mi,
            ut,
            // Resolved props
            "prop",
            Lo(it)
          );
        }
      }
      var zi;
      ad(it) ? (zi = !0, Xy(Xe)) : zi = !1, Vg(Xe, pt);
      var ji = Xe.stateNode, Xi;
      ji === null ? (UE(Ke, Xe), US(Xe, it, ut), zx(Xe, it, ut, pt), Xi = !0) : Ke === null ? Xi = V2(Xe, it, ut, pt) : Xi = j2(Ke, Xe, it, ut, pt);
      var Cs = FT(Ke, Xe, it, Xi, zi, pt);
      {
        var qs = Xe.stateNode;
        Xi && qs.props !== ut && (hp || be("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", uo(Xe) || "a component"), hp = !0);
      }
      return Cs;
    }
    function FT(Ke, Xe, it, ut, pt, Yr) {
      D_(Ke, Xe);
      var Qr = (Xe.flags & io) !== js;
      if (!ut && !Qr)
        return pt && hS(Xe, it, !1), tf(Ke, Xe, Yr);
      var ni = Xe.stateNode;
      J0.current = Xe;
      var oi;
      if (Qr && typeof it.getDerivedStateFromError != "function")
        oi = null, S_();
      else {
        Yc(Xe);
        {
          if (wl(!0), oi = ni.render(), Xe.mode & aa) {
            La(!0);
            try {
              ni.render();
            } finally {
              La(!1);
            }
          }
          wl(!1);
        }
        Ld();
      }
      return Xe.flags |= Hc, Ke !== null && Qr ? gA(Ke, Xe, oi, Yr) : Kl(Ke, Xe, oi, Yr), Xe.memoizedState = ni.state, pt && hS(Xe, it, !0), Xe.child;
    }
    function M_(Ke) {
      var Xe = Ke.stateNode;
      Xe.pendingContext ? dS(Ke, Xe.pendingContext, Xe.pendingContext !== Xe.context) : Xe.context && dS(Ke, Xe.context, !1), Yx(Ke, Xe.containerInfo);
    }
    function EA(Ke, Xe, it) {
      if (M_(Xe), Ke === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var ut = Xe.pendingProps, pt = Xe.memoizedState, Yr = pt.element;
      DS(Ke, Xe), dE(Xe, ut, null, it);
      var Qr = Xe.memoizedState;
      Xe.stateNode;
      var ni = Qr.element;
      if (pt.isDehydrated) {
        var oi = {
          element: ni,
          isDehydrated: !1,
          cache: Qr.cache,
          pendingSuspenseBoundaries: Qr.pendingSuspenseBoundaries,
          transitions: Qr.transitions
        }, vi = Xe.updateQueue;
        if (vi.baseState = oi, Xe.memoizedState = oi, Xe.flags & pa) {
          var Ei = fp(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), Xe);
          return k_(Ke, Xe, ni, it, Ei);
        } else if (ni !== Yr) {
          var Ni = fp(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), Xe);
          return k_(Ke, Xe, ni, it, Ni);
        } else {
          S2(Xe);
          var Mi = jS(Xe, null, ni, it);
          Xe.child = Mi;
          for (var zi = Mi; zi; )
            zi.flags = zi.flags & ~Xo | iu, zi = zi.sibling;
        }
      } else {
        if (Hg(), ni === Yr)
          return tf(Ke, Xe, it);
        Kl(Ke, Xe, ni, it);
      }
      return Xe.child;
    }
    function k_(Ke, Xe, it, ut, pt) {
      return Hg(), Tx(pt), Xe.flags |= pa, Kl(Ke, Xe, it, ut), Xe.child;
    }
    function xA(Ke, Xe, it) {
      KS(Xe), Ke === null && xx(Xe);
      var ut = Xe.type, pt = Xe.pendingProps, Yr = Ke !== null ? Ke.memoizedProps : null, Qr = pt.children, ni = tx(ut, pt);
      return ni ? Qr = null : Yr !== null && tx(ut, Yr) && (Xe.flags |= Fo), D_(Ke, Xe), Kl(Ke, Xe, Qr, it), Xe.child;
    }
    function TA(Ke, Xe) {
      return Ke === null && xx(Xe), null;
    }
    function bA(Ke, Xe, it, ut) {
      UE(Ke, Xe);
      var pt = Xe.pendingProps, Yr = it, Qr = Yr._payload, ni = Yr._init, oi = ni(Qr);
      Xe.type = oi;
      var vi = Xe.tag = TI(oi), Ei = gc(oi, pt), Ni;
      switch (vi) {
        case Qe:
          return $T(Xe, oi), Xe.type = oi = om(oi), Ni = NT(null, Xe, oi, Ei, ut), Ni;
        case Je:
          return Xe.type = oi = pb(oi), Ni = O_(null, Xe, oi, Ei, ut), Ni;
        case Xr:
          return Xe.type = oi = gb(oi), Ni = A_(null, Xe, oi, Ei, ut), Ni;
        case si: {
          if (Xe.type !== Xe.elementType) {
            var Mi = oi.propTypes;
            Mi && fc(
              Mi,
              Ei,
              // Resolved for outer only
              "prop",
              Lo(oi)
            );
          }
          return Ni = L_(
            null,
            Xe,
            oi,
            gc(oi.type, Ei),
            // The inner type can have defaults too
            ut
          ), Ni;
        }
      }
      var zi = "";
      throw oi !== null && typeof oi == "object" && oi.$$typeof === za && (zi = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + oi + ". " + ("Lazy element type must resolve to a class or function." + zi));
    }
    function SA(Ke, Xe, it, ut, pt) {
      UE(Ke, Xe), Xe.tag = Je;
      var Yr;
      return ad(it) ? (Yr = !0, Xy(Xe)) : Yr = !1, Vg(Xe, pt), US(Xe, it, ut), zx(Xe, it, ut, pt), FT(null, Xe, it, !0, Yr, pt);
    }
    function _A(Ke, Xe, it, ut) {
      UE(Ke, Xe);
      var pt = Xe.pendingProps, Yr;
      {
        var Qr = $g(Xe, it, !1);
        Yr = Bg(Xe, Qr);
      }
      Vg(Xe, ut);
      var ni, oi;
      Yc(Xe);
      {
        if (it.prototype && typeof it.prototype.render == "function") {
          var vi = Lo(it) || "Unknown";
          PT[vi] || (be("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", vi, vi), PT[vi] = !0);
        }
        Xe.mode & aa && pc.recordLegacyContextWarning(Xe, null), wl(!0), J0.current = Xe, ni = Zg(null, Xe, it, pt, Yr, ut), oi = Qg(), wl(!1);
      }
      if (Ld(), Xe.flags |= Hc, typeof ni == "object" && ni !== null && typeof ni.render == "function" && ni.$$typeof === void 0) {
        var Ei = Lo(it) || "Unknown";
        ev[Ei] || (be("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Ei, Ei, Ei), ev[Ei] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof ni == "object" && ni !== null && typeof ni.render == "function" && ni.$$typeof === void 0
      ) {
        {
          var Ni = Lo(it) || "Unknown";
          ev[Ni] || (be("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Ni, Ni, Ni), ev[Ni] = !0);
        }
        Xe.tag = Je, Xe.memoizedState = null, Xe.updateQueue = null;
        var Mi = !1;
        return ad(it) ? (Mi = !0, Xy(Xe)) : Mi = !1, Xe.memoizedState = ni.state !== null && ni.state !== void 0 ? ni.state : null, Ix(Xe), BS(Xe, ni), zx(Xe, it, pt, ut), FT(null, Xe, it, !0, Mi, ut);
      } else {
        if (Xe.tag = Qe, Xe.mode & aa) {
          La(!0);
          try {
            ni = Zg(null, Xe, it, pt, Yr, ut), oi = Qg();
          } finally {
            La(!1);
          }
        }
        return gl() && oi && gx(Xe), Kl(null, Xe, ni, ut), $T(Xe, it), Xe.child;
      }
    }
    function $T(Ke, Xe) {
      {
        if (Xe && Xe.childContextTypes && be("%s(...): childContextTypes cannot be defined on a function component.", Xe.displayName || Xe.name || "Component"), Ke.ref !== null) {
          var it = "", ut = dl();
          ut && (it += `

Check the render method of \`` + ut + "`.");
          var pt = ut || "", Yr = Ke._debugSource;
          Yr && (pt = Yr.fileName + ":" + Yr.lineNumber), MT[pt] || (MT[pt] = !0, be("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", it));
        }
        if (typeof Xe.getDerivedStateFromProps == "function") {
          var Qr = Lo(Xe) || "Unknown";
          OT[Qr] || (be("%s: Function components do not support getDerivedStateFromProps.", Qr), OT[Qr] = !0);
        }
        if (typeof Xe.contextType == "object" && Xe.contextType !== null) {
          var ni = Lo(Xe) || "Unknown";
          DT[ni] || (be("%s: Function components do not support contextType.", ni), DT[ni] = !0);
        }
      }
    }
    var BT = {
      dehydrated: null,
      treeContext: null,
      retryLane: wo
    };
    function UT(Ke) {
      return {
        baseLanes: Ke,
        cachePool: pA(),
        transitions: null
      };
    }
    function wA(Ke, Xe) {
      var it = null;
      return {
        baseLanes: go(Ke.baseLanes, Xe),
        cachePool: it,
        transitions: Ke.transitions
      };
    }
    function CA(Ke, Xe, it, ut) {
      if (Xe !== null) {
        var pt = Xe.memoizedState;
        if (pt === null)
          return !1;
      }
      return Qx(Ke, j0);
    }
    function RA(Ke, Xe) {
      return kf(Ke.childLanes, Xe);
    }
    function N_(Ke, Xe, it) {
      var ut = Xe.pendingProps;
      NI(Xe) && (Xe.flags |= io);
      var pt = mc.current, Yr = !1, Qr = (Xe.flags & io) !== js;
      if (Qr || CA(pt, Ke) ? (Yr = !0, Xe.flags &= ~io) : (Ke === null || Ke.memoizedState !== null) && (pt = Y2(pt, YS)), pt = Kg(pt), ih(Xe, pt), Ke === null) {
        xx(Xe);
        var ni = Xe.memoizedState;
        if (ni !== null) {
          var oi = ni.dehydrated;
          if (oi !== null)
            return DA(Xe, oi);
        }
        var vi = ut.children, Ei = ut.fallback;
        if (Yr) {
          var Ni = AA(Xe, vi, Ei, it), Mi = Xe.child;
          return Mi.memoizedState = UT(it), Xe.memoizedState = BT, Ni;
        } else
          return GT(Xe, vi);
      } else {
        var zi = Ke.memoizedState;
        if (zi !== null) {
          var ji = zi.dehydrated;
          if (ji !== null)
            return OA(Ke, Xe, Qr, ut, ji, zi, it);
        }
        if (Yr) {
          var Xi = ut.fallback, Cs = ut.children, qs = IA(Ke, Xe, Cs, Xi, it), $s = Xe.child, Ro = Ke.child.memoizedState;
          return $s.memoizedState = Ro === null ? UT(it) : wA(Ro, it), $s.childLanes = RA(Ke, it), Xe.memoizedState = BT, qs;
        } else {
          var So = ut.children, $i = LA(Ke, Xe, So, it);
          return Xe.memoizedState = null, $i;
        }
      }
    }
    function GT(Ke, Xe, it) {
      var ut = Ke.mode, pt = {
        mode: "visible",
        children: Xe
      }, Yr = HT(pt, ut);
      return Yr.return = Ke, Ke.child = Yr, Yr;
    }
    function AA(Ke, Xe, it, ut) {
      var pt = Ke.mode, Yr = Ke.child, Qr = {
        mode: "hidden",
        children: Xe
      }, ni, oi;
      return (pt & Eo) === Xs && Yr !== null ? (ni = Yr, ni.childLanes = Ji, ni.pendingProps = Qr, Ke.mode & Qs && (ni.actualDuration = 0, ni.actualStartTime = -1, ni.selfBaseDuration = 0, ni.treeBaseDuration = 0), oi = fh(it, pt, ut, null)) : (ni = HT(Qr, pt), oi = fh(it, pt, ut, null)), ni.return = Ke, oi.return = Ke, ni.sibling = oi, Ke.child = ni, oi;
    }
    function HT(Ke, Xe, it) {
      return Fw(Ke, Xe, Ji, null);
    }
    function F_(Ke, Xe) {
      return yp(Ke, Xe);
    }
    function LA(Ke, Xe, it, ut) {
      var pt = Ke.child, Yr = pt.sibling, Qr = F_(pt, {
        mode: "visible",
        children: it
      });
      if ((Xe.mode & Eo) === Xs && (Qr.lanes = ut), Qr.return = Xe, Qr.sibling = null, Yr !== null) {
        var ni = Xe.deletions;
        ni === null ? (Xe.deletions = [Yr], Xe.flags |= ko) : ni.push(Yr);
      }
      return Xe.child = Qr, Qr;
    }
    function IA(Ke, Xe, it, ut, pt) {
      var Yr = Xe.mode, Qr = Ke.child, ni = Qr.sibling, oi = {
        mode: "hidden",
        children: it
      }, vi;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (Yr & Eo) === Xs && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        Xe.child !== Qr
      ) {
        var Ei = Xe.child;
        vi = Ei, vi.childLanes = Ji, vi.pendingProps = oi, Xe.mode & Qs && (vi.actualDuration = 0, vi.actualStartTime = -1, vi.selfBaseDuration = Qr.selfBaseDuration, vi.treeBaseDuration = Qr.treeBaseDuration), Xe.deletions = null;
      } else
        vi = F_(Qr, oi), vi.subtreeFlags = Qr.subtreeFlags & Va;
      var Ni;
      return ni !== null ? Ni = yp(ni, ut) : (Ni = fh(ut, Yr, pt, null), Ni.flags |= Xo), Ni.return = Xe, vi.return = Xe, vi.sibling = Ni, Xe.child = vi, Ni;
    }
    function BE(Ke, Xe, it, ut) {
      ut !== null && Tx(ut), jg(Xe, Ke.child, null, it);
      var pt = Xe.pendingProps, Yr = pt.children, Qr = GT(Xe, Yr);
      return Qr.flags |= Xo, Xe.memoizedState = null, Qr;
    }
    function PA(Ke, Xe, it, ut, pt) {
      var Yr = Xe.mode, Qr = {
        mode: "visible",
        children: it
      }, ni = HT(Qr, Yr), oi = fh(ut, Yr, pt, null);
      return oi.flags |= Xo, ni.return = Xe, oi.return = Xe, ni.sibling = oi, Xe.child = ni, (Xe.mode & Eo) !== Xs && jg(Xe, Ke.child, null, pt), oi;
    }
    function DA(Ke, Xe, it) {
      return (Ke.mode & Eo) === Xs ? (be("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), Ke.lanes = to) : sx(Xe) ? Ke.lanes = Dd : Ke.lanes = Ol, null;
    }
    function OA(Ke, Xe, it, ut, pt, Yr, Qr) {
      if (it)
        if (Xe.flags & pa) {
          Xe.flags &= ~pa;
          var $i = RT(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return BE(Ke, Xe, Qr, $i);
        } else {
          if (Xe.memoizedState !== null)
            return Xe.child = Ke.child, Xe.flags |= io, null;
          var Zi = ut.children, Bi = ut.fallback, ds = PA(Ke, Xe, Zi, Bi, Qr), Rs = Xe.child;
          return Rs.memoizedState = UT(Qr), Xe.memoizedState = BT, ds;
        }
      else {
        if (T2(), (Xe.mode & Eo) === Xs)
          return BE(
            Ke,
            Xe,
            Qr,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (sx(pt)) {
          var ni, oi, vi;
          {
            var Ei = FR(pt);
            ni = Ei.digest, oi = Ei.message, vi = Ei.stack;
          }
          var Ni;
          oi ? Ni = new Error(oi) : Ni = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Mi = RT(Ni, ni, vi);
          return BE(Ke, Xe, Qr, Mi);
        }
        var zi = Ml(Qr, Ke.childLanes);
        if (yc || zi) {
          var ji = XE();
          if (ji !== null) {
            var Xi = C1(ji, Qr);
            if (Xi !== wo && Xi !== Yr.retryLane) {
              Yr.retryLane = Xi;
              var Cs = jo;
              pu(Ke, Xi), el(ji, Ke, Xi, Cs);
            }
          }
          ub();
          var qs = RT(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return BE(Ke, Xe, Qr, qs);
        } else if (sS(pt)) {
          Xe.flags |= io, Xe.child = Ke.child;
          var $s = iI.bind(null, Ke);
          return $R(pt, $s), null;
        } else {
          _2(Xe, pt, Yr.treeContext);
          var Ro = ut.children, So = GT(Xe, Ro);
          return So.flags |= iu, So;
        }
      }
    }
    function $_(Ke, Xe, it) {
      Ke.lanes = go(Ke.lanes, Xe);
      var ut = Ke.alternate;
      ut !== null && (ut.lanes = go(ut.lanes, Xe)), Cx(Ke.return, Xe, it);
    }
    function MA(Ke, Xe, it) {
      for (var ut = Xe; ut !== null; ) {
        if (ut.tag === ei) {
          var pt = ut.memoizedState;
          pt !== null && $_(ut, it, Ke);
        } else if (ut.tag === di)
          $_(ut, it, Ke);
        else if (ut.child !== null) {
          ut.child.return = ut, ut = ut.child;
          continue;
        }
        if (ut === Ke)
          return;
        for (; ut.sibling === null; ) {
          if (ut.return === null || ut.return === Ke)
            return;
          ut = ut.return;
        }
        ut.sibling.return = ut.return, ut = ut.sibling;
      }
    }
    function kA(Ke) {
      for (var Xe = Ke, it = null; Xe !== null; ) {
        var ut = Xe.alternate;
        ut !== null && yE(ut) === null && (it = Xe), Xe = Xe.sibling;
      }
      return it;
    }
    function NA(Ke) {
      if (Ke !== void 0 && Ke !== "forwards" && Ke !== "backwards" && Ke !== "together" && !kT[Ke])
        if (kT[Ke] = !0, typeof Ke == "string")
          switch (Ke.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              be('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', Ke, Ke.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              be('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', Ke, Ke.toLowerCase());
              break;
            }
            default:
              be('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', Ke);
              break;
          }
        else
          be('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', Ke);
    }
    function FA(Ke, Xe) {
      Ke !== void 0 && !$E[Ke] && (Ke !== "collapsed" && Ke !== "hidden" ? ($E[Ke] = !0, be('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', Ke)) : Xe !== "forwards" && Xe !== "backwards" && ($E[Ke] = !0, be('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', Ke)));
    }
    function B_(Ke, Xe) {
      {
        var it = _o(Ke), ut = !it && typeof yu(Ke) == "function";
        if (it || ut) {
          var pt = it ? "array" : "iterable";
          return be("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", pt, Xe, pt), !1;
        }
      }
      return !0;
    }
    function $A(Ke, Xe) {
      if ((Xe === "forwards" || Xe === "backwards") && Ke !== void 0 && Ke !== null && Ke !== !1)
        if (_o(Ke)) {
          for (var it = 0; it < Ke.length; it++)
            if (!B_(Ke[it], it))
              return;
        } else {
          var ut = yu(Ke);
          if (typeof ut == "function") {
            var pt = ut.call(Ke);
            if (pt)
              for (var Yr = pt.next(), Qr = 0; !Yr.done; Yr = pt.next()) {
                if (!B_(Yr.value, Qr))
                  return;
                Qr++;
              }
          } else
            be('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', Xe);
        }
    }
    function zT(Ke, Xe, it, ut, pt) {
      var Yr = Ke.memoizedState;
      Yr === null ? Ke.memoizedState = {
        isBackwards: Xe,
        rendering: null,
        renderingStartTime: 0,
        last: ut,
        tail: it,
        tailMode: pt
      } : (Yr.isBackwards = Xe, Yr.rendering = null, Yr.renderingStartTime = 0, Yr.last = ut, Yr.tail = it, Yr.tailMode = pt);
    }
    function U_(Ke, Xe, it) {
      var ut = Xe.pendingProps, pt = ut.revealOrder, Yr = ut.tail, Qr = ut.children;
      NA(pt), FA(Yr, pt), $A(Qr, pt), Kl(Ke, Xe, Qr, it);
      var ni = mc.current, oi = Qx(ni, j0);
      if (oi)
        ni = Jx(ni, j0), Xe.flags |= io;
      else {
        var vi = Ke !== null && (Ke.flags & io) !== js;
        vi && MA(Xe, Xe.child, it), ni = Kg(ni);
      }
      if (ih(Xe, ni), (Xe.mode & Eo) === Xs)
        Xe.memoizedState = null;
      else
        switch (pt) {
          case "forwards": {
            var Ei = kA(Xe.child), Ni;
            Ei === null ? (Ni = Xe.child, Xe.child = null) : (Ni = Ei.sibling, Ei.sibling = null), zT(
              Xe,
              !1,
              // isBackwards
              Ni,
              Ei,
              Yr
            );
            break;
          }
          case "backwards": {
            var Mi = null, zi = Xe.child;
            for (Xe.child = null; zi !== null; ) {
              var ji = zi.alternate;
              if (ji !== null && yE(ji) === null) {
                Xe.child = zi;
                break;
              }
              var Xi = zi.sibling;
              zi.sibling = Mi, Mi = zi, zi = Xi;
            }
            zT(
              Xe,
              !0,
              // isBackwards
              Mi,
              null,
              // last
              Yr
            );
            break;
          }
          case "together": {
            zT(
              Xe,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            Xe.memoizedState = null;
        }
      return Xe.child;
    }
    function BA(Ke, Xe, it) {
      Yx(Xe, Xe.stateNode.containerInfo);
      var ut = Xe.pendingProps;
      return Ke === null ? Xe.child = jg(Xe, null, ut, it) : Kl(Ke, Xe, ut, it), Xe.child;
    }
    var G_ = !1;
    function UA(Ke, Xe, it) {
      var ut = Xe.type, pt = ut._context, Yr = Xe.pendingProps, Qr = Xe.memoizedProps, ni = Yr.value;
      {
        "value" in Yr || G_ || (G_ = !0, be("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var oi = Xe.type.propTypes;
        oi && fc(oi, Yr, "prop", "Context.Provider");
      }
      if (AS(Xe, pt, ni), Qr !== null) {
        var vi = Qr.value;
        if (Is(vi, ni)) {
          if (Qr.children === Yr.children && !qy())
            return tf(Ke, Xe, it);
        } else
          M2(Xe, pt, it);
      }
      var Ei = Yr.children;
      return Kl(Ke, Xe, Ei, it), Xe.child;
    }
    var H_ = !1;
    function GA(Ke, Xe, it) {
      var ut = Xe.type;
      ut._context === void 0 ? ut !== ut.Consumer && (H_ || (H_ = !0, be("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : ut = ut._context;
      var pt = Xe.pendingProps, Yr = pt.children;
      typeof Yr != "function" && be("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Vg(Xe, it);
      var Qr = Ha(ut);
      Yc(Xe);
      var ni;
      return J0.current = Xe, wl(!0), ni = Yr(Qr), wl(!1), Ld(), Xe.flags |= Hc, Kl(Ke, Xe, ni, it), Xe.child;
    }
    function tv() {
      yc = !0;
    }
    function UE(Ke, Xe) {
      (Xe.mode & Eo) === Xs && Ke !== null && (Ke.alternate = null, Xe.alternate = null, Xe.flags |= Xo);
    }
    function tf(Ke, Xe, it) {
      return Ke !== null && (Xe.dependencies = Ke.dependencies), S_(), hv(Xe.lanes), Ml(it, Xe.childLanes) ? (W2(Ke, Xe), Xe.child) : null;
    }
    function HA(Ke, Xe, it) {
      {
        var ut = Xe.return;
        if (ut === null)
          throw new Error("Cannot swap the root fiber.");
        if (Ke.alternate = null, Xe.alternate = null, it.index = Xe.index, it.sibling = Xe.sibling, it.return = Xe.return, it.ref = Xe.ref, Xe === ut.child)
          ut.child = it;
        else {
          var pt = ut.child;
          if (pt === null)
            throw new Error("Expected parent to have a child.");
          for (; pt.sibling !== Xe; )
            if (pt = pt.sibling, pt === null)
              throw new Error("Expected to find the previous sibling.");
          pt.sibling = it;
        }
        var Yr = ut.deletions;
        return Yr === null ? (ut.deletions = [Ke], ut.flags |= ko) : Yr.push(Ke), it.flags |= Xo, it;
      }
    }
    function VT(Ke, Xe) {
      var it = Ke.lanes;
      return !!Ml(it, Xe);
    }
    function zA(Ke, Xe, it) {
      switch (Xe.tag) {
        case st:
          M_(Xe), Xe.stateNode, Hg();
          break;
        case lt:
          KS(Xe);
          break;
        case Je: {
          var ut = Xe.type;
          ad(ut) && Xy(Xe);
          break;
        }
        case ot:
          Yx(Xe, Xe.stateNode.containerInfo);
          break;
        case Kr: {
          var pt = Xe.memoizedProps.value, Yr = Xe.type._context;
          AS(Xe, Yr, pt);
          break;
        }
        case Jr:
          {
            var Qr = Ml(it, Xe.childLanes);
            Qr && (Xe.flags |= po);
            {
              var ni = Xe.stateNode;
              ni.effectDuration = 0, ni.passiveEffectDuration = 0;
            }
          }
          break;
        case ei: {
          var oi = Xe.memoizedState;
          if (oi !== null) {
            if (oi.dehydrated !== null)
              return ih(Xe, Kg(mc.current)), Xe.flags |= io, null;
            var vi = Xe.child, Ei = vi.childLanes;
            if (Ml(it, Ei))
              return N_(Ke, Xe, it);
            ih(Xe, Kg(mc.current));
            var Ni = tf(Ke, Xe, it);
            return Ni !== null ? Ni.sibling : null;
          } else
            ih(Xe, Kg(mc.current));
          break;
        }
        case di: {
          var Mi = (Ke.flags & io) !== js, zi = Ml(it, Xe.childLanes);
          if (Mi) {
            if (zi)
              return U_(Ke, Xe, it);
            Xe.flags |= io;
          }
          var ji = Xe.memoizedState;
          if (ji !== null && (ji.rendering = null, ji.tail = null, ji.lastEffect = null), ih(Xe, mc.current), zi)
            break;
          return null;
        }
        case Ti:
        case Ai:
          return Xe.lanes = Ji, P_(Ke, Xe, it);
      }
      return tf(Ke, Xe, it);
    }
    function z_(Ke, Xe, it) {
      if (Xe._debugNeedsRemount && Ke !== null)
        return HA(Ke, Xe, xb(Xe.type, Xe.key, Xe.pendingProps, Xe._debugOwner || null, Xe.mode, Xe.lanes));
      if (Ke !== null) {
        var ut = Ke.memoizedProps, pt = Xe.pendingProps;
        if (ut !== pt || qy() || // Force a re-render if the implementation changed due to hot reload:
        Xe.type !== Ke.type)
          yc = !0;
        else {
          var Yr = VT(Ke, it);
          if (!Yr && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (Xe.flags & io) === js)
            return yc = !1, zA(Ke, Xe, it);
          (Ke.flags & Mh) !== js ? yc = !0 : yc = !1;
        }
      } else if (yc = !1, gl() && g2(Xe)) {
        var Qr = Xe.index, ni = m2();
        mS(Xe, ni, Qr);
      }
      switch (Xe.lanes = Ji, Xe.tag) {
        case nt:
          return _A(Ke, Xe, Xe.type, it);
        case ai: {
          var oi = Xe.elementType;
          return bA(Ke, Xe, oi, it);
        }
        case Qe: {
          var vi = Xe.type, Ei = Xe.pendingProps, Ni = Xe.elementType === vi ? Ei : gc(vi, Ei);
          return NT(Ke, Xe, vi, Ni, it);
        }
        case Je: {
          var Mi = Xe.type, zi = Xe.pendingProps, ji = Xe.elementType === Mi ? zi : gc(Mi, zi);
          return O_(Ke, Xe, Mi, ji, it);
        }
        case st:
          return EA(Ke, Xe, it);
        case lt:
          return xA(Ke, Xe, it);
        case ft:
          return TA(Ke, Xe);
        case ei:
          return N_(Ke, Xe, it);
        case ot:
          return BA(Ke, Xe, it);
        case Xr: {
          var Xi = Xe.type, Cs = Xe.pendingProps, qs = Xe.elementType === Xi ? Cs : gc(Xi, Cs);
          return A_(Ke, Xe, Xi, qs, it);
        }
        case gt:
          return mA(Ke, Xe, it);
        case ct:
          return vA(Ke, Xe, it);
        case Jr:
          return yA(Ke, Xe, it);
        case Kr:
          return UA(Ke, Xe, it);
        case _r:
          return GA(Ke, Xe, it);
        case si: {
          var $s = Xe.type, Ro = Xe.pendingProps, So = gc($s, Ro);
          if (Xe.type !== Xe.elementType) {
            var $i = $s.propTypes;
            $i && fc(
              $i,
              So,
              // Resolved for outer only
              "prop",
              Lo($s)
            );
          }
          return So = gc($s.type, So), L_(Ke, Xe, $s, So, it);
        }
        case ri:
          return I_(Ke, Xe, Xe.type, Xe.pendingProps, it);
        case yi: {
          var Zi = Xe.type, Bi = Xe.pendingProps, ds = Xe.elementType === Zi ? Bi : gc(Zi, Bi);
          return SA(Ke, Xe, Zi, ds, it);
        }
        case di:
          return U_(Ke, Xe, it);
        case xi:
          break;
        case Ti:
          return P_(Ke, Xe, it);
      }
      throw new Error("Unknown unit of work tag (" + Xe.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Jg(Ke) {
      Ke.flags |= po;
    }
    function V_(Ke) {
      Ke.flags |= Rl, Ke.flags |= Nm;
    }
    var j_, jT, W_, K_;
    j_ = function(Ke, Xe, it, ut) {
      for (var pt = Xe.child; pt !== null; ) {
        if (pt.tag === lt || pt.tag === ft)
          cR(Ke, pt.stateNode);
        else if (pt.tag !== ot) {
          if (pt.child !== null) {
            pt.child.return = pt, pt = pt.child;
            continue;
          }
        }
        if (pt === Xe)
          return;
        for (; pt.sibling === null; ) {
          if (pt.return === null || pt.return === Xe)
            return;
          pt = pt.return;
        }
        pt.sibling.return = pt.return, pt = pt.sibling;
      }
    }, jT = function(Ke, Xe) {
    }, W_ = function(Ke, Xe, it, ut, pt) {
      var Yr = Ke.memoizedProps;
      if (Yr !== ut) {
        var Qr = Xe.stateNode, ni = Xx(), oi = fR(Qr, it, Yr, ut, pt, ni);
        Xe.updateQueue = oi, oi && Jg(Xe);
      }
    }, K_ = function(Ke, Xe, it, ut) {
      it !== ut && Jg(Xe);
    };
    function nv(Ke, Xe) {
      if (!gl())
        switch (Ke.tailMode) {
          case "hidden": {
            for (var it = Ke.tail, ut = null; it !== null; )
              it.alternate !== null && (ut = it), it = it.sibling;
            ut === null ? Ke.tail = null : ut.sibling = null;
            break;
          }
          case "collapsed": {
            for (var pt = Ke.tail, Yr = null; pt !== null; )
              pt.alternate !== null && (Yr = pt), pt = pt.sibling;
            Yr === null ? !Xe && Ke.tail !== null ? Ke.tail.sibling = null : Ke.tail = null : Yr.sibling = null;
            break;
          }
        }
    }
    function vl(Ke) {
      var Xe = Ke.alternate !== null && Ke.alternate.child === Ke.child, it = Ji, ut = js;
      if (Xe) {
        if ((Ke.mode & Qs) !== Xs) {
          for (var oi = Ke.selfBaseDuration, vi = Ke.child; vi !== null; )
            it = go(it, go(vi.lanes, vi.childLanes)), ut |= vi.subtreeFlags & Va, ut |= vi.flags & Va, oi += vi.treeBaseDuration, vi = vi.sibling;
          Ke.treeBaseDuration = oi;
        } else
          for (var Ei = Ke.child; Ei !== null; )
            it = go(it, go(Ei.lanes, Ei.childLanes)), ut |= Ei.subtreeFlags & Va, ut |= Ei.flags & Va, Ei.return = Ke, Ei = Ei.sibling;
        Ke.subtreeFlags |= ut;
      } else {
        if ((Ke.mode & Qs) !== Xs) {
          for (var pt = Ke.actualDuration, Yr = Ke.selfBaseDuration, Qr = Ke.child; Qr !== null; )
            it = go(it, go(Qr.lanes, Qr.childLanes)), ut |= Qr.subtreeFlags, ut |= Qr.flags, pt += Qr.actualDuration, Yr += Qr.treeBaseDuration, Qr = Qr.sibling;
          Ke.actualDuration = pt, Ke.treeBaseDuration = Yr;
        } else
          for (var ni = Ke.child; ni !== null; )
            it = go(it, go(ni.lanes, ni.childLanes)), ut |= ni.subtreeFlags, ut |= ni.flags, ni.return = Ke, ni = ni.sibling;
        Ke.subtreeFlags |= ut;
      }
      return Ke.childLanes = it, Xe;
    }
    function VA(Ke, Xe, it) {
      if (L2() && (Xe.mode & Eo) !== Xs && (Xe.flags & io) === js)
        return SS(Xe), Hg(), Xe.flags |= pa | Gl | Fa, !1;
      var ut = tE(Xe);
      if (it !== null && it.dehydrated !== null)
        if (Ke === null) {
          if (!ut)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (R2(Xe), vl(Xe), (Xe.mode & Qs) !== Xs) {
            var pt = it !== null;
            if (pt) {
              var Yr = Xe.child;
              Yr !== null && (Xe.treeBaseDuration -= Yr.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Hg(), (Xe.flags & io) === js && (Xe.memoizedState = null), Xe.flags |= po, vl(Xe), (Xe.mode & Qs) !== Xs) {
            var Qr = it !== null;
            if (Qr) {
              var ni = Xe.child;
              ni !== null && (Xe.treeBaseDuration -= ni.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return _S(), !0;
    }
    function q_(Ke, Xe, it) {
      var ut = Xe.pendingProps;
      switch (mx(Xe), Xe.tag) {
        case nt:
        case ai:
        case ri:
        case Qe:
        case Xr:
        case gt:
        case ct:
        case Jr:
        case _r:
        case si:
          return vl(Xe), null;
        case Je: {
          var pt = Xe.type;
          return ad(pt) && Yy(Xe), vl(Xe), null;
        }
        case st: {
          var Yr = Xe.stateNode;
          if (Wg(Xe), fx(Xe), tT(), Yr.pendingContext && (Yr.context = Yr.pendingContext, Yr.pendingContext = null), Ke === null || Ke.child === null) {
            var Qr = tE(Xe);
            if (Qr)
              Jg(Xe);
            else if (Ke !== null) {
              var ni = Ke.memoizedState;
              // Check if this is a client root
              (!ni.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (Xe.flags & pa) !== js) && (Xe.flags |= ru, _S());
            }
          }
          return jT(Ke, Xe), vl(Xe), null;
        }
        case lt: {
          Zx(Xe);
          var oi = WS(), vi = Xe.type;
          if (Ke !== null && Xe.stateNode != null)
            W_(Ke, Xe, vi, ut, oi), Ke.ref !== Xe.ref && V_(Xe);
          else {
            if (!ut) {
              if (Xe.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return vl(Xe), null;
            }
            var Ei = Xx(), Ni = tE(Xe);
            if (Ni)
              w2(Xe, oi, Ei) && Jg(Xe);
            else {
              var Mi = uR(vi, ut, oi, Ei, Xe);
              j_(Mi, Xe, !1, !1), Xe.stateNode = Mi, dR(Mi, vi, ut, oi) && Jg(Xe);
            }
            Xe.ref !== null && V_(Xe);
          }
          return vl(Xe), null;
        }
        case ft: {
          var zi = ut;
          if (Ke && Xe.stateNode != null) {
            var ji = Ke.memoizedProps;
            K_(Ke, Xe, ji, zi);
          } else {
            if (typeof zi != "string" && Xe.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Xi = WS(), Cs = Xx(), qs = tE(Xe);
            qs ? C2(Xe) && Jg(Xe) : Xe.stateNode = hR(zi, Xi, Cs, Xe);
          }
          return vl(Xe), null;
        }
        case ei: {
          qg(Xe);
          var $s = Xe.memoizedState;
          if (Ke === null || Ke.memoizedState !== null && Ke.memoizedState.dehydrated !== null) {
            var Ro = VA(Ke, Xe, $s);
            if (!Ro)
              return Xe.flags & Fa ? Xe : null;
          }
          if ((Xe.flags & io) !== js)
            return Xe.lanes = it, (Xe.mode & Qs) !== Xs && CT(Xe), Xe;
          var So = $s !== null, $i = Ke !== null && Ke.memoizedState !== null;
          if (So !== $i && So) {
            var Zi = Xe.child;
            if (Zi.flags |= zc, (Xe.mode & Eo) !== Xs) {
              var Bi = Ke === null && (Xe.memoizedProps.unstable_avoidThisFallback !== !0 || !Di);
              Bi || Qx(mc.current, YS) ? jL() : ub();
            }
          }
          var ds = Xe.updateQueue;
          if (ds !== null && (Xe.flags |= po), vl(Xe), (Xe.mode & Qs) !== Xs && So) {
            var Rs = Xe.child;
            Rs !== null && (Xe.treeBaseDuration -= Rs.treeBaseDuration);
          }
          return null;
        }
        case ot:
          return Wg(Xe), jT(Ke, Xe), Ke === null && a2(Xe.stateNode.containerInfo), vl(Xe), null;
        case Kr:
          var bs = Xe.type._context;
          return wx(bs, Xe), vl(Xe), null;
        case yi: {
          var no = Xe.type;
          return ad(no) && Yy(Xe), vl(Xe), null;
        }
        case di: {
          qg(Xe);
          var fo = Xe.memoizedState;
          if (fo === null)
            return vl(Xe), null;
          var Go = (Xe.flags & io) !== js, Oo = fo.rendering;
          if (Oo === null)
            if (Go)
              nv(fo, !1);
            else {
              var Ma = KL() && (Ke === null || (Ke.flags & io) === js);
              if (!Ma)
                for (var Mo = Xe.child; Mo !== null; ) {
                  var Ra = yE(Mo);
                  if (Ra !== null) {
                    Go = !0, Xe.flags |= io, nv(fo, !1);
                    var $l = Ra.updateQueue;
                    return $l !== null && (Xe.updateQueue = $l, Xe.flags |= po), Xe.subtreeFlags = js, K2(Xe, it), ih(Xe, Jx(mc.current, j0)), Xe.child;
                  }
                  Mo = Mo.sibling;
                }
              fo.tail !== null && oa() > gw() && (Xe.flags |= io, Go = !0, nv(fo, !1), Xe.lanes = Ym);
            }
          else {
            if (!Go) {
              var bl = yE(Oo);
              if (bl !== null) {
                Xe.flags |= io, Go = !0;
                var Lu = bl.updateQueue;
                if (Lu !== null && (Xe.updateQueue = Lu, Xe.flags |= po), nv(fo, !0), fo.tail === null && fo.tailMode === "hidden" && !Oo.alternate && !gl())
                  return vl(Xe), null;
              } else
                // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                oa() * 2 - fo.renderingStartTime > gw() && it !== Ol && (Xe.flags |= io, Go = !0, nv(fo, !1), Xe.lanes = Ym);
            }
            if (fo.isBackwards)
              Oo.sibling = Xe.child, Xe.child = Oo;
            else {
              var Xl = fo.last;
              Xl !== null ? Xl.sibling = Oo : Xe.child = Oo, fo.last = Oo;
            }
          }
          if (fo.tail !== null) {
            var Zl = fo.tail;
            fo.rendering = Zl, fo.tail = Zl.sibling, fo.renderingStartTime = oa(), Zl.sibling = null;
            var Bl = mc.current;
            return Go ? Bl = Jx(Bl, j0) : Bl = Kg(Bl), ih(Xe, Bl), Zl;
          }
          return vl(Xe), null;
        }
        case xi:
          break;
        case Ti:
        case Ai: {
          lb(Xe);
          var af = Xe.memoizedState, am = af !== null;
          if (Ke !== null) {
            var yv = Ke.memoizedState, md = yv !== null;
            md !== am && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !hi && (Xe.flags |= zc);
          }
          return !am || (Xe.mode & Eo) === Xs ? vl(Xe) : Ml(gd, Ol) && (vl(Xe), Xe.subtreeFlags & (Xo | po) && (Xe.flags |= zc)), null;
        }
        case mi:
          return null;
        case Si:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + Xe.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function jA(Ke, Xe, it) {
      switch (mx(Xe), Xe.tag) {
        case Je: {
          var ut = Xe.type;
          ad(ut) && Yy(Xe);
          var pt = Xe.flags;
          return pt & Fa ? (Xe.flags = pt & ~Fa | io, (Xe.mode & Qs) !== Xs && CT(Xe), Xe) : null;
        }
        case st: {
          Xe.stateNode, Wg(Xe), fx(Xe), tT();
          var Yr = Xe.flags;
          return (Yr & Fa) !== js && (Yr & io) === js ? (Xe.flags = Yr & ~Fa | io, Xe) : null;
        }
        case lt:
          return Zx(Xe), null;
        case ei: {
          qg(Xe);
          var Qr = Xe.memoizedState;
          if (Qr !== null && Qr.dehydrated !== null) {
            if (Xe.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Hg();
          }
          var ni = Xe.flags;
          return ni & Fa ? (Xe.flags = ni & ~Fa | io, (Xe.mode & Qs) !== Xs && CT(Xe), Xe) : null;
        }
        case di:
          return qg(Xe), null;
        case ot:
          return Wg(Xe), null;
        case Kr:
          var oi = Xe.type._context;
          return wx(oi, Xe), null;
        case Ti:
        case Ai:
          return lb(Xe), null;
        case mi:
          return null;
        default:
          return null;
      }
    }
    function Y_(Ke, Xe, it) {
      switch (mx(Xe), Xe.tag) {
        case Je: {
          var ut = Xe.type.childContextTypes;
          ut != null && Yy(Xe);
          break;
        }
        case st: {
          Xe.stateNode, Wg(Xe), fx(Xe), tT();
          break;
        }
        case lt: {
          Zx(Xe);
          break;
        }
        case ot:
          Wg(Xe);
          break;
        case ei:
          qg(Xe);
          break;
        case di:
          qg(Xe);
          break;
        case Kr:
          var pt = Xe.type._context;
          wx(pt, Xe);
          break;
        case Ti:
        case Ai:
          lb(Xe);
          break;
      }
    }
    var X_ = null;
    X_ = /* @__PURE__ */ new Set();
    var GE = !1, yl = !1, WA = typeof WeakSet == "function" ? WeakSet : Set, Ps = null, em = null, tm = null;
    function KA(Ke) {
      Rd(null, function() {
        throw Ke;
      }), Mm();
    }
    var qA = function(Ke, Xe) {
      if (Xe.props = Ke.memoizedProps, Xe.state = Ke.memoizedState, Ke.mode & Qs)
        try {
          hd(), Xe.componentWillUnmount();
        } finally {
          dd(Ke);
        }
      else
        Xe.componentWillUnmount();
    };
    function Z_(Ke, Xe) {
      try {
        ah(qa, Ke);
      } catch (it) {
        ea(Ke, Xe, it);
      }
    }
    function WT(Ke, Xe, it) {
      try {
        qA(Ke, it);
      } catch (ut) {
        ea(Ke, Xe, ut);
      }
    }
    function YA(Ke, Xe, it) {
      try {
        it.componentDidMount();
      } catch (ut) {
        ea(Ke, Xe, ut);
      }
    }
    function Q_(Ke, Xe) {
      try {
        ew(Ke);
      } catch (it) {
        ea(Ke, Xe, it);
      }
    }
    function nm(Ke, Xe) {
      var it = Ke.ref;
      if (it !== null)
        if (typeof it == "function") {
          var ut;
          try {
            if (us && Yi && Ke.mode & Qs)
              try {
                hd(), ut = it(null);
              } finally {
                dd(Ke);
              }
            else
              ut = it(null);
          } catch (pt) {
            ea(Ke, Xe, pt);
          }
          typeof ut == "function" && be("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", uo(Ke));
        } else
          it.current = null;
    }
    function HE(Ke, Xe, it) {
      try {
        it();
      } catch (ut) {
        ea(Ke, Xe, ut);
      }
    }
    var J_ = !1;
    function XA(Ke, Xe) {
      aR(Ke.containerInfo), Ps = Xe, ZA();
      var it = J_;
      return J_ = !1, it;
    }
    function ZA() {
      for (; Ps !== null; ) {
        var Ke = Ps, Xe = Ke.child;
        (Ke.subtreeFlags & Rf) !== js && Xe !== null ? (Xe.return = Ke, Ps = Xe) : QA();
      }
    }
    function QA() {
      for (; Ps !== null; ) {
        var Ke = Ps;
        No(Ke);
        try {
          JA(Ke);
        } catch (it) {
          ea(Ke, Ke.return, it);
        }
        ha();
        var Xe = Ke.sibling;
        if (Xe !== null) {
          Xe.return = Ke.return, Ps = Xe;
          return;
        }
        Ps = Ke.return;
      }
    }
    function JA(Ke) {
      var Xe = Ke.alternate, it = Ke.flags;
      if ((it & ru) !== js) {
        switch (No(Ke), Ke.tag) {
          case Qe:
          case Xr:
          case ri:
            break;
          case Je: {
            if (Xe !== null) {
              var ut = Xe.memoizedProps, pt = Xe.memoizedState, Yr = Ke.stateNode;
              Ke.type === Ke.elementType && !hp && (Yr.props !== Ke.memoizedProps && be("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", uo(Ke) || "instance"), Yr.state !== Ke.memoizedState && be("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", uo(Ke) || "instance"));
              var Qr = Yr.getSnapshotBeforeUpdate(Ke.elementType === Ke.type ? ut : gc(Ke.type, ut), pt);
              {
                var ni = X_;
                Qr === void 0 && !ni.has(Ke.type) && (ni.add(Ke.type), be("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", uo(Ke)));
              }
              Yr.__reactInternalSnapshotBeforeUpdate = Qr;
            }
            break;
          }
          case st: {
            {
              var oi = Ke.stateNode;
              OR(oi.containerInfo);
            }
            break;
          }
          case lt:
          case ft:
          case ot:
          case yi:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        ha();
      }
    }
    function Ec(Ke, Xe, it) {
      var ut = Xe.updateQueue, pt = ut !== null ? ut.lastEffect : null;
      if (pt !== null) {
        var Yr = pt.next, Qr = Yr;
        do {
          if ((Qr.tag & Ke) === Ke) {
            var ni = Qr.destroy;
            Qr.destroy = void 0, ni !== void 0 && ((Ke & ml) !== gu ? jp(Xe) : (Ke & qa) !== gu && Wp(Xe), (Ke & ld) !== gu && gv(!0), HE(Xe, it, ni), (Ke & ld) !== gu && gv(!1), (Ke & ml) !== gu ? Jv() : (Ke & qa) !== gu && Af());
          }
          Qr = Qr.next;
        } while (Qr !== Yr);
      }
    }
    function ah(Ke, Xe) {
      var it = Xe.updateQueue, ut = it !== null ? it.lastEffect : null;
      if (ut !== null) {
        var pt = ut.next, Yr = pt;
        do {
          if ((Yr.tag & Ke) === Ke) {
            (Ke & ml) !== gu ? Qv(Xe) : (Ke & qa) !== gu && ey(Xe);
            var Qr = Yr.create;
            (Ke & ld) !== gu && gv(!0), Yr.destroy = Qr(), (Ke & ld) !== gu && gv(!1), (Ke & ml) !== gu ? Wm() : (Ke & qa) !== gu && ty();
            {
              var ni = Yr.destroy;
              if (ni !== void 0 && typeof ni != "function") {
                var oi = void 0;
                (Yr.tag & qa) !== js ? oi = "useLayoutEffect" : (Yr.tag & ld) !== js ? oi = "useInsertionEffect" : oi = "useEffect";
                var vi = void 0;
                ni === null ? vi = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof ni.then == "function" ? vi = `

It looks like you wrote ` + oi + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + oi + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : vi = " You returned: " + ni, be("%s must not return anything besides a function, which is used for clean-up.%s", oi, vi);
              }
            }
          }
          Yr = Yr.next;
        } while (Yr !== pt);
      }
    }
    function eL(Ke, Xe) {
      if ((Xe.flags & po) !== js)
        switch (Xe.tag) {
          case Jr: {
            var it = Xe.stateNode.passiveEffectDuration, ut = Xe.memoizedProps, pt = ut.id, Yr = ut.onPostCommit, Qr = T_(), ni = Xe.alternate === null ? "mount" : "update";
            x_() && (ni = "nested-update"), typeof Yr == "function" && Yr(pt, ni, it, Qr);
            var oi = Xe.return;
            e:
              for (; oi !== null; ) {
                switch (oi.tag) {
                  case st:
                    var vi = oi.stateNode;
                    vi.passiveEffectDuration += it;
                    break e;
                  case Jr:
                    var Ei = oi.stateNode;
                    Ei.passiveEffectDuration += it;
                    break e;
                }
                oi = oi.return;
              }
            break;
          }
        }
    }
    function tL(Ke, Xe, it, ut) {
      if ((it.flags & tl) !== js)
        switch (it.tag) {
          case Qe:
          case Xr:
          case ri: {
            if (!yl)
              if (it.mode & Qs)
                try {
                  hd(), ah(qa | Ka, it);
                } finally {
                  dd(it);
                }
              else
                ah(qa | Ka, it);
            break;
          }
          case Je: {
            var pt = it.stateNode;
            if (it.flags & po && !yl)
              if (Xe === null)
                if (it.type === it.elementType && !hp && (pt.props !== it.memoizedProps && be("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", uo(it) || "instance"), pt.state !== it.memoizedState && be("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", uo(it) || "instance")), it.mode & Qs)
                  try {
                    hd(), pt.componentDidMount();
                  } finally {
                    dd(it);
                  }
                else
                  pt.componentDidMount();
              else {
                var Yr = it.elementType === it.type ? Xe.memoizedProps : gc(it.type, Xe.memoizedProps), Qr = Xe.memoizedState;
                if (it.type === it.elementType && !hp && (pt.props !== it.memoizedProps && be("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", uo(it) || "instance"), pt.state !== it.memoizedState && be("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", uo(it) || "instance")), it.mode & Qs)
                  try {
                    hd(), pt.componentDidUpdate(Yr, Qr, pt.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    dd(it);
                  }
                else
                  pt.componentDidUpdate(Yr, Qr, pt.__reactInternalSnapshotBeforeUpdate);
              }
            var ni = it.updateQueue;
            ni !== null && (it.type === it.elementType && !hp && (pt.props !== it.memoizedProps && be("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", uo(it) || "instance"), pt.state !== it.memoizedState && be("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", uo(it) || "instance")), MS(it, ni, pt));
            break;
          }
          case st: {
            var oi = it.updateQueue;
            if (oi !== null) {
              var vi = null;
              if (it.child !== null)
                switch (it.child.tag) {
                  case lt:
                    vi = it.child.stateNode;
                    break;
                  case Je:
                    vi = it.child.stateNode;
                    break;
                }
              MS(it, oi, vi);
            }
            break;
          }
          case lt: {
            var Ei = it.stateNode;
            if (Xe === null && it.flags & po) {
              var Ni = it.type, Mi = it.memoizedProps;
              yR(Ei, Ni, Mi);
            }
            break;
          }
          case ft:
            break;
          case ot:
            break;
          case Jr: {
            {
              var zi = it.memoizedProps, ji = zi.onCommit, Xi = zi.onRender, Cs = it.stateNode.effectDuration, qs = T_(), $s = Xe === null ? "mount" : "update";
              x_() && ($s = "nested-update"), typeof Xi == "function" && Xi(it.memoizedProps.id, $s, it.actualDuration, it.treeBaseDuration, it.actualStartTime, qs);
              {
                typeof ji == "function" && ji(it.memoizedProps.id, $s, Cs, qs), QL(it);
                var Ro = it.return;
                e:
                  for (; Ro !== null; ) {
                    switch (Ro.tag) {
                      case st:
                        var So = Ro.stateNode;
                        So.effectDuration += Cs;
                        break e;
                      case Jr:
                        var $i = Ro.stateNode;
                        $i.effectDuration += Cs;
                        break e;
                    }
                    Ro = Ro.return;
                  }
              }
            }
            break;
          }
          case ei: {
            uL(Ke, it);
            break;
          }
          case di:
          case yi:
          case xi:
          case Ti:
          case Ai:
          case Si:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      yl || it.flags & Rl && ew(it);
    }
    function nL(Ke) {
      switch (Ke.tag) {
        case Qe:
        case Xr:
        case ri: {
          if (Ke.mode & Qs)
            try {
              hd(), Z_(Ke, Ke.return);
            } finally {
              dd(Ke);
            }
          else
            Z_(Ke, Ke.return);
          break;
        }
        case Je: {
          var Xe = Ke.stateNode;
          typeof Xe.componentDidMount == "function" && YA(Ke, Ke.return, Xe), Q_(Ke, Ke.return);
          break;
        }
        case lt: {
          Q_(Ke, Ke.return);
          break;
        }
      }
    }
    function rL(Ke, Xe) {
      for (var it = null, ut = Ke; ; ) {
        if (ut.tag === lt) {
          if (it === null) {
            it = ut;
            try {
              var pt = ut.stateNode;
              Xe ? LR(pt) : PR(ut.stateNode, ut.memoizedProps);
            } catch (Qr) {
              ea(Ke, Ke.return, Qr);
            }
          }
        } else if (ut.tag === ft) {
          if (it === null)
            try {
              var Yr = ut.stateNode;
              Xe ? IR(Yr) : DR(Yr, ut.memoizedProps);
            } catch (Qr) {
              ea(Ke, Ke.return, Qr);
            }
        } else if (!((ut.tag === Ti || ut.tag === Ai) && ut.memoizedState !== null && ut !== Ke)) {
          if (ut.child !== null) {
            ut.child.return = ut, ut = ut.child;
            continue;
          }
        }
        if (ut === Ke)
          return;
        for (; ut.sibling === null; ) {
          if (ut.return === null || ut.return === Ke)
            return;
          it === ut && (it = null), ut = ut.return;
        }
        it === ut && (it = null), ut.sibling.return = ut.return, ut = ut.sibling;
      }
    }
    function ew(Ke) {
      var Xe = Ke.ref;
      if (Xe !== null) {
        var it = Ke.stateNode, ut;
        switch (Ke.tag) {
          case lt:
            ut = it;
            break;
          default:
            ut = it;
        }
        if (typeof Xe == "function") {
          var pt;
          if (Ke.mode & Qs)
            try {
              hd(), pt = Xe(ut);
            } finally {
              dd(Ke);
            }
          else
            pt = Xe(ut);
          typeof pt == "function" && be("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", uo(Ke));
        } else
          Xe.hasOwnProperty("current") || be("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", uo(Ke)), Xe.current = ut;
      }
    }
    function iL(Ke) {
      var Xe = Ke.alternate;
      Xe !== null && (Xe.return = null), Ke.return = null;
    }
    function tw(Ke) {
      var Xe = Ke.alternate;
      Xe !== null && (Ke.alternate = null, tw(Xe));
      {
        if (Ke.child = null, Ke.deletions = null, Ke.sibling = null, Ke.tag === lt) {
          var it = Ke.stateNode;
          it !== null && c2(it);
        }
        Ke.stateNode = null, Ke._debugOwner = null, Ke.return = null, Ke.dependencies = null, Ke.memoizedProps = null, Ke.memoizedState = null, Ke.pendingProps = null, Ke.stateNode = null, Ke.updateQueue = null;
      }
    }
    function sL(Ke) {
      for (var Xe = Ke.return; Xe !== null; ) {
        if (nw(Xe))
          return Xe;
        Xe = Xe.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function nw(Ke) {
      return Ke.tag === lt || Ke.tag === st || Ke.tag === ot;
    }
    function rw(Ke) {
      var Xe = Ke;
      e:
        for (; ; ) {
          for (; Xe.sibling === null; ) {
            if (Xe.return === null || nw(Xe.return))
              return null;
            Xe = Xe.return;
          }
          for (Xe.sibling.return = Xe.return, Xe = Xe.sibling; Xe.tag !== lt && Xe.tag !== ft && Xe.tag !== pi; ) {
            if (Xe.flags & Xo || Xe.child === null || Xe.tag === ot)
              continue e;
            Xe.child.return = Xe, Xe = Xe.child;
          }
          if (!(Xe.flags & Xo))
            return Xe.stateNode;
        }
    }
    function oL(Ke) {
      var Xe = sL(Ke);
      switch (Xe.tag) {
        case lt: {
          var it = Xe.stateNode;
          Xe.flags & Fo && (iS(it), Xe.flags &= ~Fo);
          var ut = rw(Ke);
          qT(Ke, ut, it);
          break;
        }
        case st:
        case ot: {
          var pt = Xe.stateNode.containerInfo, Yr = rw(Ke);
          KT(Ke, Yr, pt);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function KT(Ke, Xe, it) {
      var ut = Ke.tag, pt = ut === lt || ut === ft;
      if (pt) {
        var Yr = Ke.stateNode;
        Xe ? _R(it, Yr, Xe) : bR(it, Yr);
      } else if (ut !== ot) {
        var Qr = Ke.child;
        if (Qr !== null) {
          KT(Qr, Xe, it);
          for (var ni = Qr.sibling; ni !== null; )
            KT(ni, Xe, it), ni = ni.sibling;
        }
      }
    }
    function qT(Ke, Xe, it) {
      var ut = Ke.tag, pt = ut === lt || ut === ft;
      if (pt) {
        var Yr = Ke.stateNode;
        Xe ? SR(it, Yr, Xe) : TR(it, Yr);
      } else if (ut !== ot) {
        var Qr = Ke.child;
        if (Qr !== null) {
          qT(Qr, Xe, it);
          for (var ni = Qr.sibling; ni !== null; )
            qT(ni, Xe, it), ni = ni.sibling;
        }
      }
    }
    var El = null, xc = !1;
    function aL(Ke, Xe, it) {
      {
        var ut = Xe;
        e:
          for (; ut !== null; ) {
            switch (ut.tag) {
              case lt: {
                El = ut.stateNode, xc = !1;
                break e;
              }
              case st: {
                El = ut.stateNode.containerInfo, xc = !0;
                break e;
              }
              case ot: {
                El = ut.stateNode.containerInfo, xc = !0;
                break e;
              }
            }
            ut = ut.return;
          }
        if (El === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        iw(Ke, Xe, it), El = null, xc = !1;
      }
      iL(it);
    }
    function lh(Ke, Xe, it) {
      for (var ut = it.child; ut !== null; )
        iw(Ke, Xe, ut), ut = ut.sibling;
    }
    function iw(Ke, Xe, it) {
      switch (Vm(it), it.tag) {
        case lt:
          yl || nm(it, Xe);
        case ft: {
          {
            var ut = El, pt = xc;
            El = null, lh(Ke, Xe, it), El = ut, xc = pt, El !== null && (xc ? RR(El, it.stateNode) : wR(El, it.stateNode));
          }
          return;
        }
        case pi: {
          El !== null && (xc ? AR(El, it.stateNode) : ix(El, it.stateNode));
          return;
        }
        case ot: {
          {
            var Yr = El, Qr = xc;
            El = it.stateNode.containerInfo, xc = !0, lh(Ke, Xe, it), El = Yr, xc = Qr;
          }
          return;
        }
        case Qe:
        case Xr:
        case si:
        case ri: {
          if (!yl) {
            var ni = it.updateQueue;
            if (ni !== null) {
              var oi = ni.lastEffect;
              if (oi !== null) {
                var vi = oi.next, Ei = vi;
                do {
                  var Ni = Ei, Mi = Ni.destroy, zi = Ni.tag;
                  Mi !== void 0 && ((zi & ld) !== gu ? HE(it, Xe, Mi) : (zi & qa) !== gu && (Wp(it), it.mode & Qs ? (hd(), HE(it, Xe, Mi), dd(it)) : HE(it, Xe, Mi), Af())), Ei = Ei.next;
                } while (Ei !== vi);
              }
            }
          }
          lh(Ke, Xe, it);
          return;
        }
        case Je: {
          if (!yl) {
            nm(it, Xe);
            var ji = it.stateNode;
            typeof ji.componentWillUnmount == "function" && WT(it, Xe, ji);
          }
          lh(Ke, Xe, it);
          return;
        }
        case xi: {
          lh(Ke, Xe, it);
          return;
        }
        case Ti: {
          if (
            // TODO: Remove this dead flag
            it.mode & Eo
          ) {
            var Xi = yl;
            yl = Xi || it.memoizedState !== null, lh(Ke, Xe, it), yl = Xi;
          } else
            lh(Ke, Xe, it);
          break;
        }
        default: {
          lh(Ke, Xe, it);
          return;
        }
      }
    }
    function lL(Ke) {
      Ke.memoizedState;
    }
    function uL(Ke, Xe) {
      var it = Xe.memoizedState;
      if (it === null) {
        var ut = Xe.alternate;
        if (ut !== null) {
          var pt = ut.memoizedState;
          if (pt !== null) {
            var Yr = pt.dehydrated;
            Yr !== null && KR(Yr);
          }
        }
      }
    }
    function sw(Ke) {
      var Xe = Ke.updateQueue;
      if (Xe !== null) {
        Ke.updateQueue = null;
        var it = Ke.stateNode;
        it === null && (it = Ke.stateNode = new WA()), Xe.forEach(function(ut) {
          var pt = sI.bind(null, Ke, ut);
          if (!it.has(ut)) {
            if (it.add(ut), ja)
              if (em !== null && tm !== null)
                pv(tm, em);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            ut.then(pt, pt);
          }
        });
      }
    }
    function cL(Ke, Xe, it) {
      em = it, tm = Ke, No(Xe), ow(Xe, Ke), No(Xe), em = null, tm = null;
    }
    function Tc(Ke, Xe, it) {
      var ut = Xe.deletions;
      if (ut !== null)
        for (var pt = 0; pt < ut.length; pt++) {
          var Yr = ut[pt];
          try {
            aL(Ke, Xe, Yr);
          } catch (oi) {
            ea(Yr, Xe, oi);
          }
        }
      var Qr = Sp();
      if (Xe.subtreeFlags & Il)
        for (var ni = Xe.child; ni !== null; )
          No(ni), ow(ni, Ke), ni = ni.sibling;
      No(Qr);
    }
    function ow(Ke, Xe, it) {
      var ut = Ke.alternate, pt = Ke.flags;
      switch (Ke.tag) {
        case Qe:
        case Xr:
        case si:
        case ri: {
          if (Tc(Xe, Ke), pd(Ke), pt & po) {
            try {
              Ec(ld | Ka, Ke, Ke.return), ah(ld | Ka, Ke);
            } catch (no) {
              ea(Ke, Ke.return, no);
            }
            if (Ke.mode & Qs) {
              try {
                hd(), Ec(qa | Ka, Ke, Ke.return);
              } catch (no) {
                ea(Ke, Ke.return, no);
              }
              dd(Ke);
            } else
              try {
                Ec(qa | Ka, Ke, Ke.return);
              } catch (no) {
                ea(Ke, Ke.return, no);
              }
          }
          return;
        }
        case Je: {
          Tc(Xe, Ke), pd(Ke), pt & Rl && ut !== null && nm(ut, ut.return);
          return;
        }
        case lt: {
          Tc(Xe, Ke), pd(Ke), pt & Rl && ut !== null && nm(ut, ut.return);
          {
            if (Ke.flags & Fo) {
              var Yr = Ke.stateNode;
              try {
                iS(Yr);
              } catch (no) {
                ea(Ke, Ke.return, no);
              }
            }
            if (pt & po) {
              var Qr = Ke.stateNode;
              if (Qr != null) {
                var ni = Ke.memoizedProps, oi = ut !== null ? ut.memoizedProps : ni, vi = Ke.type, Ei = Ke.updateQueue;
                if (Ke.updateQueue = null, Ei !== null)
                  try {
                    ER(Qr, Ei, vi, oi, ni, Ke);
                  } catch (no) {
                    ea(Ke, Ke.return, no);
                  }
              }
            }
          }
          return;
        }
        case ft: {
          if (Tc(Xe, Ke), pd(Ke), pt & po) {
            if (Ke.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var Ni = Ke.stateNode, Mi = Ke.memoizedProps, zi = ut !== null ? ut.memoizedProps : Mi;
            try {
              xR(Ni, zi, Mi);
            } catch (no) {
              ea(Ke, Ke.return, no);
            }
          }
          return;
        }
        case st: {
          if (Tc(Xe, Ke), pd(Ke), pt & po && ut !== null) {
            var ji = ut.memoizedState;
            if (ji.isDehydrated)
              try {
                WR(Xe.containerInfo);
              } catch (no) {
                ea(Ke, Ke.return, no);
              }
          }
          return;
        }
        case ot: {
          Tc(Xe, Ke), pd(Ke);
          return;
        }
        case ei: {
          Tc(Xe, Ke), pd(Ke);
          var Xi = Ke.child;
          if (Xi.flags & zc) {
            var Cs = Xi.stateNode, qs = Xi.memoizedState, $s = qs !== null;
            if (Cs.isHidden = $s, $s) {
              var Ro = Xi.alternate !== null && Xi.alternate.memoizedState !== null;
              Ro || VL();
            }
          }
          if (pt & po) {
            try {
              lL(Ke);
            } catch (no) {
              ea(Ke, Ke.return, no);
            }
            sw(Ke);
          }
          return;
        }
        case Ti: {
          var So = ut !== null && ut.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            Ke.mode & Eo
          ) {
            var $i = yl;
            yl = $i || So, Tc(Xe, Ke), yl = $i;
          } else
            Tc(Xe, Ke);
          if (pd(Ke), pt & zc) {
            var Zi = Ke.stateNode, Bi = Ke.memoizedState, ds = Bi !== null, Rs = Ke;
            if (Zi.isHidden = ds, ds && !So && (Rs.mode & Eo) !== Xs) {
              Ps = Rs;
              for (var bs = Rs.child; bs !== null; )
                Ps = bs, fL(bs), bs = bs.sibling;
            }
            rL(Rs, ds);
          }
          return;
        }
        case di: {
          Tc(Xe, Ke), pd(Ke), pt & po && sw(Ke);
          return;
        }
        case xi:
          return;
        default: {
          Tc(Xe, Ke), pd(Ke);
          return;
        }
      }
    }
    function pd(Ke) {
      var Xe = Ke.flags;
      if (Xe & Xo) {
        try {
          oL(Ke);
        } catch (it) {
          ea(Ke, Ke.return, it);
        }
        Ke.flags &= ~Xo;
      }
      Xe & iu && (Ke.flags &= ~iu);
    }
    function dL(Ke, Xe, it) {
      em = it, tm = Xe, Ps = Ke, aw(Ke, Xe, it), em = null, tm = null;
    }
    function aw(Ke, Xe, it) {
      for (var ut = (Ke.mode & Eo) !== Xs; Ps !== null; ) {
        var pt = Ps, Yr = pt.child;
        if (pt.tag === Ti && ut) {
          var Qr = pt.memoizedState !== null, ni = Qr || GE;
          if (ni) {
            YT(Ke, Xe, it);
            continue;
          } else {
            var oi = pt.alternate, vi = oi !== null && oi.memoizedState !== null, Ei = vi || yl, Ni = GE, Mi = yl;
            GE = ni, yl = Ei, yl && !Mi && (Ps = pt, hL(pt));
            for (var zi = Yr; zi !== null; )
              Ps = zi, aw(
                zi,
                // New root; bubble back up to here and stop.
                Xe,
                it
              ), zi = zi.sibling;
            Ps = pt, GE = Ni, yl = Mi, YT(Ke, Xe, it);
            continue;
          }
        }
        (pt.subtreeFlags & tl) !== js && Yr !== null ? (Yr.return = pt, Ps = Yr) : YT(Ke, Xe, it);
      }
    }
    function YT(Ke, Xe, it) {
      for (; Ps !== null; ) {
        var ut = Ps;
        if ((ut.flags & tl) !== js) {
          var pt = ut.alternate;
          No(ut);
          try {
            tL(Xe, pt, ut, it);
          } catch (Qr) {
            ea(ut, ut.return, Qr);
          }
          ha();
        }
        if (ut === Ke) {
          Ps = null;
          return;
        }
        var Yr = ut.sibling;
        if (Yr !== null) {
          Yr.return = ut.return, Ps = Yr;
          return;
        }
        Ps = ut.return;
      }
    }
    function fL(Ke) {
      for (; Ps !== null; ) {
        var Xe = Ps, it = Xe.child;
        switch (Xe.tag) {
          case Qe:
          case Xr:
          case si:
          case ri: {
            if (Xe.mode & Qs)
              try {
                hd(), Ec(qa, Xe, Xe.return);
              } finally {
                dd(Xe);
              }
            else
              Ec(qa, Xe, Xe.return);
            break;
          }
          case Je: {
            nm(Xe, Xe.return);
            var ut = Xe.stateNode;
            typeof ut.componentWillUnmount == "function" && WT(Xe, Xe.return, ut);
            break;
          }
          case lt: {
            nm(Xe, Xe.return);
            break;
          }
          case Ti: {
            var pt = Xe.memoizedState !== null;
            if (pt) {
              lw(Ke);
              continue;
            }
            break;
          }
        }
        it !== null ? (it.return = Xe, Ps = it) : lw(Ke);
      }
    }
    function lw(Ke) {
      for (; Ps !== null; ) {
        var Xe = Ps;
        if (Xe === Ke) {
          Ps = null;
          return;
        }
        var it = Xe.sibling;
        if (it !== null) {
          it.return = Xe.return, Ps = it;
          return;
        }
        Ps = Xe.return;
      }
    }
    function hL(Ke) {
      for (; Ps !== null; ) {
        var Xe = Ps, it = Xe.child;
        if (Xe.tag === Ti) {
          var ut = Xe.memoizedState !== null;
          if (ut) {
            uw(Ke);
            continue;
          }
        }
        it !== null ? (it.return = Xe, Ps = it) : uw(Ke);
      }
    }
    function uw(Ke) {
      for (; Ps !== null; ) {
        var Xe = Ps;
        No(Xe);
        try {
          nL(Xe);
        } catch (ut) {
          ea(Xe, Xe.return, ut);
        }
        if (ha(), Xe === Ke) {
          Ps = null;
          return;
        }
        var it = Xe.sibling;
        if (it !== null) {
          it.return = Xe.return, Ps = it;
          return;
        }
        Ps = Xe.return;
      }
    }
    function pL(Ke, Xe, it, ut) {
      Ps = Xe, gL(Xe, Ke, it, ut);
    }
    function gL(Ke, Xe, it, ut) {
      for (; Ps !== null; ) {
        var pt = Ps, Yr = pt.child;
        (pt.subtreeFlags & su) !== js && Yr !== null ? (Yr.return = pt, Ps = Yr) : mL(Ke, Xe, it, ut);
      }
    }
    function mL(Ke, Xe, it, ut) {
      for (; Ps !== null; ) {
        var pt = Ps;
        if ((pt.flags & na) !== js) {
          No(pt);
          try {
            vL(Xe, pt, it, ut);
          } catch (Qr) {
            ea(pt, pt.return, Qr);
          }
          ha();
        }
        if (pt === Ke) {
          Ps = null;
          return;
        }
        var Yr = pt.sibling;
        if (Yr !== null) {
          Yr.return = pt.return, Ps = Yr;
          return;
        }
        Ps = pt.return;
      }
    }
    function vL(Ke, Xe, it, ut) {
      switch (Xe.tag) {
        case Qe:
        case Xr:
        case ri: {
          if (Xe.mode & Qs) {
            wT();
            try {
              ah(ml | Ka, Xe);
            } finally {
              _T(Xe);
            }
          } else
            ah(ml | Ka, Xe);
          break;
        }
      }
    }
    function yL(Ke) {
      Ps = Ke, EL();
    }
    function EL() {
      for (; Ps !== null; ) {
        var Ke = Ps, Xe = Ke.child;
        if ((Ps.flags & ko) !== js) {
          var it = Ke.deletions;
          if (it !== null) {
            for (var ut = 0; ut < it.length; ut++) {
              var pt = it[ut];
              Ps = pt, bL(pt, Ke);
            }
            {
              var Yr = Ke.alternate;
              if (Yr !== null) {
                var Qr = Yr.child;
                if (Qr !== null) {
                  Yr.child = null;
                  do {
                    var ni = Qr.sibling;
                    Qr.sibling = null, Qr = ni;
                  } while (Qr !== null);
                }
              }
            }
            Ps = Ke;
          }
        }
        (Ke.subtreeFlags & su) !== js && Xe !== null ? (Xe.return = Ke, Ps = Xe) : xL();
      }
    }
    function xL() {
      for (; Ps !== null; ) {
        var Ke = Ps;
        (Ke.flags & na) !== js && (No(Ke), TL(Ke), ha());
        var Xe = Ke.sibling;
        if (Xe !== null) {
          Xe.return = Ke.return, Ps = Xe;
          return;
        }
        Ps = Ke.return;
      }
    }
    function TL(Ke) {
      switch (Ke.tag) {
        case Qe:
        case Xr:
        case ri: {
          Ke.mode & Qs ? (wT(), Ec(ml | Ka, Ke, Ke.return), _T(Ke)) : Ec(ml | Ka, Ke, Ke.return);
          break;
        }
      }
    }
    function bL(Ke, Xe) {
      for (; Ps !== null; ) {
        var it = Ps;
        No(it), _L(it, Xe), ha();
        var ut = it.child;
        ut !== null ? (ut.return = it, Ps = ut) : SL(Ke);
      }
    }
    function SL(Ke) {
      for (; Ps !== null; ) {
        var Xe = Ps, it = Xe.sibling, ut = Xe.return;
        if (tw(Xe), Xe === Ke) {
          Ps = null;
          return;
        }
        if (it !== null) {
          it.return = ut, Ps = it;
          return;
        }
        Ps = ut;
      }
    }
    function _L(Ke, Xe) {
      switch (Ke.tag) {
        case Qe:
        case Xr:
        case ri: {
          Ke.mode & Qs ? (wT(), Ec(ml, Ke, Xe), _T(Ke)) : Ec(ml, Ke, Xe);
          break;
        }
      }
    }
    function wL(Ke) {
      switch (Ke.tag) {
        case Qe:
        case Xr:
        case ri: {
          try {
            ah(qa | Ka, Ke);
          } catch (it) {
            ea(Ke, Ke.return, it);
          }
          break;
        }
        case Je: {
          var Xe = Ke.stateNode;
          try {
            Xe.componentDidMount();
          } catch (it) {
            ea(Ke, Ke.return, it);
          }
          break;
        }
      }
    }
    function CL(Ke) {
      switch (Ke.tag) {
        case Qe:
        case Xr:
        case ri: {
          try {
            ah(ml | Ka, Ke);
          } catch (Xe) {
            ea(Ke, Ke.return, Xe);
          }
          break;
        }
      }
    }
    function RL(Ke) {
      switch (Ke.tag) {
        case Qe:
        case Xr:
        case ri: {
          try {
            Ec(qa | Ka, Ke, Ke.return);
          } catch (it) {
            ea(Ke, Ke.return, it);
          }
          break;
        }
        case Je: {
          var Xe = Ke.stateNode;
          typeof Xe.componentWillUnmount == "function" && WT(Ke, Ke.return, Xe);
          break;
        }
      }
    }
    function AL(Ke) {
      switch (Ke.tag) {
        case Qe:
        case Xr:
        case ri:
          try {
            Ec(ml | Ka, Ke, Ke.return);
          } catch (Xe) {
            ea(Ke, Ke.return, Xe);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var rv = Symbol.for;
      rv("selector.component"), rv("selector.has_pseudo_class"), rv("selector.role"), rv("selector.test_id"), rv("selector.text");
    }
    var LL = [];
    function IL() {
      LL.forEach(function(Ke) {
        return Ke();
      });
    }
    var PL = ee.ReactCurrentActQueue;
    function DL(Ke) {
      {
        var Xe = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), it = typeof jest < "u";
        return it && Xe !== !1;
      }
    }
    function cw() {
      {
        var Ke = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !Ke && PL.current !== null && be("The current testing environment is not configured to support act(...)"), Ke;
      }
    }
    var OL = Math.ceil, XT = ee.ReactCurrentDispatcher, ZT = ee.ReactCurrentOwner, xl = ee.ReactCurrentBatchConfig, bc = ee.ReactCurrentActQueue, Za = (
      /*             */
      0
    ), dw = (
      /*               */
      1
    ), Tl = (
      /*                */
      2
    ), ju = (
      /*                */
      4
    ), nf = 0, iv = 1, pp = 2, zE = 3, sv = 4, fw = 5, QT = 6, Co = Za, ql = null, xa = null, Qa = Ji, gd = Ji, JT = Qf(Ji), Ja = nf, ov = null, VE = Ji, av = Ji, jE = Ji, lv = null, mu = null, eb = 0, hw = 500, pw = 1 / 0, ML = 500, rf = null;
    function uv() {
      pw = oa() + ML;
    }
    function gw() {
      return pw;
    }
    var WE = !1, tb = null, rm = null, gp = !1, uh = null, cv = Ji, nb = [], rb = null, kL = 50, dv = 0, ib = null, sb = !1, KE = !1, NL = 50, im = 0, qE = null, fv = jo, YE = Ji, mw = !1;
    function XE() {
      return ql;
    }
    function Yl() {
      return (Co & (Tl | ju)) !== Za ? oa() : (fv !== jo || (fv = oa()), fv);
    }
    function ch(Ke) {
      var Xe = Ke.mode;
      if ((Xe & Eo) === Xs)
        return to;
      if ((Co & Tl) !== Za && Qa !== Ji)
        return Ia(Qa);
      var it = D2() !== P2;
      if (it) {
        if (xl.transition !== null) {
          var ut = xl.transition;
          ut._updatedFibers || (ut._updatedFibers = /* @__PURE__ */ new Set()), ut._updatedFibers.add(Ke);
        }
        return YE === wo && (YE = Qm()), YE;
      }
      var pt = uu();
      if (pt !== wo)
        return pt;
      var Yr = pR();
      return Yr;
    }
    function FL(Ke) {
      var Xe = Ke.mode;
      return (Xe & Eo) === Xs ? to : w1();
    }
    function el(Ke, Xe, it, ut) {
      aI(), mw && be("useInsertionEffect must not schedule updates."), sb && (KE = !0), Bd(Ke, it, ut), (Co & Tl) !== Ji && Ke === ql ? cI(Xe) : (ja && r0(Ke, Xe, it), dI(Xe), Ke === ql && ((Co & Tl) === Za && (av = go(av, it)), Ja === sv && dh(Ke, Qa)), vu(Ke, ut), it === to && Co === Za && (Xe.mode & Eo) === Xs && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !bc.isBatchingLegacy && (uv(), gS()));
    }
    function $L(Ke, Xe, it) {
      var ut = Ke.current;
      ut.lanes = Xe, Bd(Ke, Xe, it), vu(Ke, it);
    }
    function BL(Ke) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Co & Tl) !== Za
      );
    }
    function vu(Ke, Xe) {
      var it = Ke.callbackNode;
      b1(Ke, Xe);
      var ut = Uh(Ke, Ke === ql ? Qa : Ji);
      if (ut === Ji) {
        it !== null && Dw(it), Ke.callbackNode = null, Ke.callbackPriority = wo;
        return;
      }
      var pt = wa(ut), Yr = Ke.callbackPriority;
      if (Yr === pt && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(bc.current !== null && it !== fb)) {
        it == null && Yr !== to && be("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      it != null && Dw(it);
      var Qr;
      if (pt === to)
        Ke.tag === Jf ? (bc.isBatchingLegacy !== null && (bc.didScheduleLegacyUpdate = !0), h2(Ew.bind(null, Ke))) : pS(Ew.bind(null, Ke)), bc.current !== null ? bc.current.push(eh) : mR(function() {
          (Co & (Tl | ju)) === Za && eh();
        }), Qr = null;
      else {
        var ni;
        switch (jh(ut)) {
          case nl:
            ni = Hp;
            break;
          case Wa:
            ni = Vl;
            break;
          case ac:
            ni = ku;
            break;
          case zh:
            ni = jc;
            break;
          default:
            ni = ku;
            break;
        }
        Qr = hb(ni, vw.bind(null, Ke));
      }
      Ke.callbackPriority = pt, Ke.callbackNode = Qr;
    }
    function vw(Ke, Xe) {
      if (aA(), fv = jo, YE = Ji, (Co & (Tl | ju)) !== Za)
        throw new Error("Should not already be working.");
      var it = Ke.callbackNode, ut = of();
      if (ut && Ke.callbackNode !== it)
        return null;
      var pt = Uh(Ke, Ke === ql ? Qa : Ji);
      if (pt === Ji)
        return null;
      var Yr = !Hh(Ke, pt) && !ay(Ke, pt) && !Xe, Qr = Yr ? YL(Ke, pt) : QE(Ke, pt);
      if (Qr !== nf) {
        if (Qr === pp) {
          var ni = Xm(Ke);
          ni !== Ji && (pt = ni, Qr = ob(Ke, ni));
        }
        if (Qr === iv) {
          var oi = ov;
          throw mp(Ke, Ji), dh(Ke, pt), vu(Ke, oa()), oi;
        }
        if (Qr === QT)
          dh(Ke, pt);
        else {
          var vi = !Hh(Ke, pt), Ei = Ke.current.alternate;
          if (vi && !GL(Ei)) {
            if (Qr = QE(Ke, pt), Qr === pp) {
              var Ni = Xm(Ke);
              Ni !== Ji && (pt = Ni, Qr = ob(Ke, Ni));
            }
            if (Qr === iv) {
              var Mi = ov;
              throw mp(Ke, Ji), dh(Ke, pt), vu(Ke, oa()), Mi;
            }
          }
          Ke.finishedWork = Ei, Ke.finishedLanes = pt, UL(Ke, Qr, pt);
        }
      }
      return vu(Ke, oa()), Ke.callbackNode === it ? vw.bind(null, Ke) : null;
    }
    function ob(Ke, Xe) {
      var it = lv;
      if (Da(Ke)) {
        var ut = mp(Ke, Xe);
        ut.flags |= pa, o2(Ke.containerInfo);
      }
      var pt = QE(Ke, Xe);
      if (pt !== pp) {
        var Yr = mu;
        mu = it, Yr !== null && yw(Yr);
      }
      return pt;
    }
    function yw(Ke) {
      mu === null ? mu = Ke : mu.push.apply(mu, Ke);
    }
    function UL(Ke, Xe, it) {
      switch (Xe) {
        case nf:
        case iv:
          throw new Error("Root did not complete. This is a bug in React.");
        case pp: {
          vp(Ke, mu, rf);
          break;
        }
        case zE: {
          if (dh(Ke, it), fg(it) && // do not delay if we're inside an act() scope
          !Ow()) {
            var ut = eb + hw - oa();
            if (ut > 10) {
              var pt = Uh(Ke, Ji);
              if (pt !== Ji)
                break;
              var Yr = Ke.suspendedLanes;
              if (!$d(Yr, it)) {
                Yl(), t0(Ke, Yr);
                break;
              }
              Ke.timeoutHandle = nx(vp.bind(null, Ke, mu, rf), ut);
              break;
            }
          }
          vp(Ke, mu, rf);
          break;
        }
        case sv: {
          if (dh(Ke, it), oy(it))
            break;
          if (!Ow()) {
            var Qr = sy(Ke, it), ni = Qr, oi = oa() - ni, vi = oI(oi) - oi;
            if (vi > 10) {
              Ke.timeoutHandle = nx(vp.bind(null, Ke, mu, rf), vi);
              break;
            }
          }
          vp(Ke, mu, rf);
          break;
        }
        case fw: {
          vp(Ke, mu, rf);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function GL(Ke) {
      for (var Xe = Ke; ; ) {
        if (Xe.flags & Oh) {
          var it = Xe.updateQueue;
          if (it !== null) {
            var ut = it.stores;
            if (ut !== null)
              for (var pt = 0; pt < ut.length; pt++) {
                var Yr = ut[pt], Qr = Yr.getSnapshot, ni = Yr.value;
                try {
                  if (!Is(Qr(), ni))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var oi = Xe.child;
        if (Xe.subtreeFlags & Oh && oi !== null) {
          oi.return = Xe, Xe = oi;
          continue;
        }
        if (Xe === Ke)
          return !0;
        for (; Xe.sibling === null; ) {
          if (Xe.return === null || Xe.return === Ke)
            return !0;
          Xe = Xe.return;
        }
        Xe.sibling.return = Xe.return, Xe = Xe.sibling;
      }
      return !0;
    }
    function dh(Ke, Xe) {
      Xe = kf(Xe, jE), Xe = kf(Xe, av), e0(Ke, Xe);
    }
    function Ew(Ke) {
      if (lA(), (Co & (Tl | ju)) !== Za)
        throw new Error("Should not already be working.");
      of();
      var Xe = Uh(Ke, Ji);
      if (!Ml(Xe, to))
        return vu(Ke, oa()), null;
      var it = QE(Ke, Xe);
      if (Ke.tag !== Jf && it === pp) {
        var ut = Xm(Ke);
        ut !== Ji && (Xe = ut, it = ob(Ke, ut));
      }
      if (it === iv) {
        var pt = ov;
        throw mp(Ke, Ji), dh(Ke, Xe), vu(Ke, oa()), pt;
      }
      if (it === QT)
        throw new Error("Root did not complete. This is a bug in React.");
      var Yr = Ke.current.alternate;
      return Ke.finishedWork = Yr, Ke.finishedLanes = Xe, vp(Ke, mu, rf), vu(Ke, oa()), null;
    }
    function HL(Ke, Xe) {
      Xe !== Ji && (Nf(Ke, go(Xe, to)), vu(Ke, oa()), (Co & (Tl | ju)) === Za && (uv(), eh()));
    }
    function ab(Ke, Xe) {
      var it = Co;
      Co |= dw;
      try {
        return Ke(Xe);
      } finally {
        Co = it, Co === Za && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !bc.isBatchingLegacy && (uv(), gS());
      }
    }
    function zL(Ke, Xe, it, ut, pt) {
      var Yr = uu(), Qr = xl.transition;
      try {
        return xl.transition = null, Pa(nl), Ke(Xe, it, ut, pt);
      } finally {
        Pa(Yr), xl.transition = Qr, Co === Za && uv();
      }
    }
    function sf(Ke) {
      uh !== null && uh.tag === Jf && (Co & (Tl | ju)) === Za && of();
      var Xe = Co;
      Co |= dw;
      var it = xl.transition, ut = uu();
      try {
        return xl.transition = null, Pa(nl), Ke ? Ke() : void 0;
      } finally {
        Pa(ut), xl.transition = it, Co = Xe, (Co & (Tl | ju)) === Za && eh();
      }
    }
    function xw() {
      return (Co & (Tl | ju)) !== Za;
    }
    function ZE(Ke, Xe) {
      Nl(JT, gd, Ke), gd = go(gd, Xe);
    }
    function lb(Ke) {
      gd = JT.current, kl(JT, Ke);
    }
    function mp(Ke, Xe) {
      Ke.finishedWork = null, Ke.finishedLanes = Ji;
      var it = Ke.timeoutHandle;
      if (it !== rx && (Ke.timeoutHandle = rx, gR(it)), xa !== null)
        for (var ut = xa.return; ut !== null; ) {
          var pt = ut.alternate;
          Y_(pt, ut), ut = ut.return;
        }
      ql = Ke;
      var Yr = yp(Ke.current, null);
      return xa = Yr, Qa = gd = Xe, Ja = nf, ov = null, VE = Ji, av = Ji, jE = Ji, lv = null, mu = null, N2(), pc.discardPendingWarnings(), Yr;
    }
    function Tw(Ke, Xe) {
      do {
        var it = xa;
        try {
          if (sE(), ZS(), ha(), ZT.current = null, it === null || it.return === null) {
            Ja = iv, ov = Xe, xa = null;
            return;
          }
          if (us && it.mode & Qs && FE(it, !0), qi)
            if (Ld(), Xe !== null && typeof Xe == "object" && typeof Xe.then == "function") {
              var ut = Xe;
              ny(it, ut, Qa);
            } else
              Kp(it, Xe, Qa);
          hA(Ke, it.return, it, Xe, Qa), ww(it);
        } catch (pt) {
          Xe = pt, xa === it && it !== null ? (it = it.return, xa = it) : it = xa;
          continue;
        }
        return;
      } while (!0);
    }
    function bw() {
      var Ke = XT.current;
      return XT.current = DE, Ke === null ? DE : Ke;
    }
    function Sw(Ke) {
      XT.current = Ke;
    }
    function VL() {
      eb = oa();
    }
    function hv(Ke) {
      VE = go(Ke, VE);
    }
    function jL() {
      Ja === nf && (Ja = zE);
    }
    function ub() {
      (Ja === nf || Ja === zE || Ja === pp) && (Ja = sv), ql !== null && (Gh(VE) || Gh(av)) && dh(ql, Qa);
    }
    function WL(Ke) {
      Ja !== sv && (Ja = pp), lv === null ? lv = [Ke] : lv.push(Ke);
    }
    function KL() {
      return Ja === nf;
    }
    function QE(Ke, Xe) {
      var it = Co;
      Co |= Tl;
      var ut = bw();
      if (ql !== Ke || Qa !== Xe) {
        if (ja) {
          var pt = Ke.memoizedUpdaters;
          pt.size > 0 && (pv(Ke, Qa), pt.clear()), gg(Ke, Xe);
        }
        rf = i0(), mp(Ke, Xe);
      }
      wu(Xe);
      do
        try {
          qL();
          break;
        } catch (Yr) {
          Tw(Ke, Yr);
        }
      while (!0);
      if (sE(), Co = it, Sw(ut), xa !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return If(), ql = null, Qa = Ji, Ja;
    }
    function qL() {
      for (; xa !== null; )
        _w(xa);
    }
    function YL(Ke, Xe) {
      var it = Co;
      Co |= Tl;
      var ut = bw();
      if (ql !== Ke || Qa !== Xe) {
        if (ja) {
          var pt = Ke.memoizedUpdaters;
          pt.size > 0 && (pv(Ke, Qa), pt.clear()), gg(Ke, Xe);
        }
        rf = i0(), uv(), mp(Ke, Xe);
      }
      wu(Xe);
      do
        try {
          XL();
          break;
        } catch (Yr) {
          Tw(Ke, Yr);
        }
      while (!0);
      return sE(), Sw(ut), Co = it, xa !== null ? (Nh(), nf) : (If(), ql = null, Qa = Ji, Ja);
    }
    function XL() {
      for (; xa !== null && !Gp(); )
        _w(xa);
    }
    function _w(Ke) {
      var Xe = Ke.alternate;
      No(Ke);
      var it;
      (Ke.mode & Qs) !== Xs ? (ST(Ke), it = cb(Xe, Ke, gd), FE(Ke, !0)) : it = cb(Xe, Ke, gd), ha(), Ke.memoizedProps = Ke.pendingProps, it === null ? ww(Ke) : xa = it, ZT.current = null;
    }
    function ww(Ke) {
      var Xe = Ke;
      do {
        var it = Xe.alternate, ut = Xe.return;
        if ((Xe.flags & Gl) === js) {
          No(Xe);
          var pt = void 0;
          if ((Xe.mode & Qs) === Xs ? pt = q_(it, Xe, gd) : (ST(Xe), pt = q_(it, Xe, gd), FE(Xe, !1)), ha(), pt !== null) {
            xa = pt;
            return;
          }
        } else {
          var Yr = jA(it, Xe);
          if (Yr !== null) {
            Yr.flags &= Kv, xa = Yr;
            return;
          }
          if ((Xe.mode & Qs) !== Xs) {
            FE(Xe, !1);
            for (var Qr = Xe.actualDuration, ni = Xe.child; ni !== null; )
              Qr += ni.actualDuration, ni = ni.sibling;
            Xe.actualDuration = Qr;
          }
          if (ut !== null)
            ut.flags |= Gl, ut.subtreeFlags = js, ut.deletions = null;
          else {
            Ja = QT, xa = null;
            return;
          }
        }
        var oi = Xe.sibling;
        if (oi !== null) {
          xa = oi;
          return;
        }
        Xe = ut, xa = Xe;
      } while (Xe !== null);
      Ja === nf && (Ja = fw);
    }
    function vp(Ke, Xe, it) {
      var ut = uu(), pt = xl.transition;
      try {
        xl.transition = null, Pa(nl), ZL(Ke, Xe, it, ut);
      } finally {
        xl.transition = pt, Pa(ut);
      }
      return null;
    }
    function ZL(Ke, Xe, it, ut) {
      do
        of();
      while (uh !== null);
      if (lI(), (Co & (Tl | ju)) !== Za)
        throw new Error("Should not already be working.");
      var pt = Ke.finishedWork, Yr = Ke.finishedLanes;
      if (Vp(Yr), pt === null)
        return jm(), null;
      if (Yr === Ji && be("root.finishedLanes should not be empty during a commit. This is a bug in React."), Ke.finishedWork = null, Ke.finishedLanes = Ji, pt === Ke.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      Ke.callbackNode = null, Ke.callbackPriority = wo;
      var Qr = go(pt.lanes, pt.childLanes);
      n0(Ke, Qr), Ke === ql && (ql = null, xa = null, Qa = Ji), ((pt.subtreeFlags & su) !== js || (pt.flags & su) !== js) && (gp || (gp = !0, rb = it, hb(ku, function() {
        return of(), null;
      })));
      var ni = (pt.subtreeFlags & (Rf | Il | tl | su)) !== js, oi = (pt.flags & (Rf | Il | tl | su)) !== js;
      if (ni || oi) {
        var vi = xl.transition;
        xl.transition = null;
        var Ei = uu();
        Pa(nl);
        var Ni = Co;
        Co |= ju, ZT.current = null, XA(Ke, pt), b_(), cL(Ke, pt, Yr), lR(Ke.containerInfo), Ke.current = pt, ry(Yr), dL(pt, Ke, Yr), Lf(), Xv(), Co = Ni, Pa(Ei), xl.transition = vi;
      } else
        Ke.current = pt, b_();
      var Mi = gp;
      if (gp ? (gp = !1, uh = Ke, cv = Yr) : (im = 0, qE = null), Qr = Ke.pendingLanes, Qr === Ji && (rm = null), Mi || Lw(Ke.current, !1), ic(pt.stateNode, ut), ja && Ke.memoizedUpdaters.clear(), IL(), vu(Ke, oa()), Xe !== null)
        for (var zi = Ke.onRecoverableError, ji = 0; ji < Xe.length; ji++) {
          var Xi = Xe[ji], Cs = Xi.stack, qs = Xi.digest;
          zi(Xi.value, {
            componentStack: Cs,
            digest: qs
          });
        }
      if (WE) {
        WE = !1;
        var $s = tb;
        throw tb = null, $s;
      }
      return Ml(cv, to) && Ke.tag !== Jf && of(), Qr = Ke.pendingLanes, Ml(Qr, to) ? (oA(), Ke === ib ? dv++ : (dv = 0, ib = Ke)) : dv = 0, eh(), jm(), null;
    }
    function of() {
      if (uh !== null) {
        var Ke = jh(cv), Xe = R1(ac, Ke), it = xl.transition, ut = uu();
        try {
          return xl.transition = null, Pa(Xe), JL();
        } finally {
          Pa(ut), xl.transition = it;
        }
      }
      return !1;
    }
    function QL(Ke) {
      nb.push(Ke), gp || (gp = !0, hb(ku, function() {
        return of(), null;
      }));
    }
    function JL() {
      if (uh === null)
        return !1;
      var Ke = rb;
      rb = null;
      var Xe = uh, it = cv;
      if (uh = null, cv = Ji, (Co & (Tl | ju)) !== Za)
        throw new Error("Cannot flush passive effects while already rendering.");
      sb = !0, KE = !1, iy(it);
      var ut = Co;
      Co |= ju, yL(Xe.current), pL(Xe, Xe.current, it, Ke);
      {
        var pt = nb;
        nb = [];
        for (var Yr = 0; Yr < pt.length; Yr++) {
          var Qr = pt[Yr];
          eL(Xe, Qr);
        }
      }
      kh(), Lw(Xe.current, !0), Co = ut, eh(), KE ? Xe === qE ? im++ : (im = 0, qE = Xe) : im = 0, sb = !1, KE = !1, Kc(Xe);
      {
        var ni = Xe.current.stateNode;
        ni.effectDuration = 0, ni.passiveEffectDuration = 0;
      }
      return !0;
    }
    function Cw(Ke) {
      return rm !== null && rm.has(Ke);
    }
    function eI(Ke) {
      rm === null ? rm = /* @__PURE__ */ new Set([Ke]) : rm.add(Ke);
    }
    function tI(Ke) {
      WE || (WE = !0, tb = Ke);
    }
    var nI = tI;
    function Rw(Ke, Xe, it) {
      var ut = fp(it, Xe), pt = __(Ke, ut, to), Yr = nh(Ke, pt, to), Qr = Yl();
      Yr !== null && (Bd(Yr, to, Qr), vu(Yr, Qr));
    }
    function ea(Ke, Xe, it) {
      if (KA(it), gv(!1), Ke.tag === st) {
        Rw(Ke, Ke, it);
        return;
      }
      var ut = null;
      for (ut = Xe; ut !== null; ) {
        if (ut.tag === st) {
          Rw(ut, Ke, it);
          return;
        } else if (ut.tag === Je) {
          var pt = ut.type, Yr = ut.stateNode;
          if (typeof pt.getDerivedStateFromError == "function" || typeof Yr.componentDidCatch == "function" && !Cw(Yr)) {
            var Qr = fp(it, Ke), ni = IT(ut, Qr, to), oi = nh(ut, ni, to), vi = Yl();
            oi !== null && (Bd(oi, to, vi), vu(oi, vi));
            return;
          }
        }
        ut = ut.return;
      }
      be(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, it);
    }
    function rI(Ke, Xe, it) {
      var ut = Ke.pingCache;
      ut !== null && ut.delete(Xe);
      var pt = Yl();
      t0(Ke, it), fI(Ke), ql === Ke && $d(Qa, it) && (Ja === sv || Ja === zE && fg(Qa) && oa() - eb < hw ? mp(Ke, Ji) : jE = go(jE, it)), vu(Ke, pt);
    }
    function Aw(Ke, Xe) {
      Xe === wo && (Xe = FL(Ke));
      var it = Yl(), ut = pu(Ke, Xe);
      ut !== null && (Bd(ut, Xe, it), vu(ut, it));
    }
    function iI(Ke) {
      var Xe = Ke.memoizedState, it = wo;
      Xe !== null && (it = Xe.retryLane), Aw(Ke, it);
    }
    function sI(Ke, Xe) {
      var it = wo, ut;
      switch (Ke.tag) {
        case ei:
          ut = Ke.stateNode;
          var pt = Ke.memoizedState;
          pt !== null && (it = pt.retryLane);
          break;
        case di:
          ut = Ke.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      ut !== null && ut.delete(Xe), Aw(Ke, it);
    }
    function oI(Ke) {
      return Ke < 120 ? 120 : Ke < 480 ? 480 : Ke < 1080 ? 1080 : Ke < 1920 ? 1920 : Ke < 3e3 ? 3e3 : Ke < 4320 ? 4320 : OL(Ke / 1960) * 1960;
    }
    function aI() {
      if (dv > kL)
        throw dv = 0, ib = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      im > NL && (im = 0, qE = null, be("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function lI() {
      pc.flushLegacyContextWarning(), pc.flushPendingUnsafeLifecycleWarnings();
    }
    function Lw(Ke, Xe) {
      No(Ke), JE(Ke, Ll, RL), Xe && JE(Ke, Ad, AL), JE(Ke, Ll, wL), Xe && JE(Ke, Ad, CL), ha();
    }
    function JE(Ke, Xe, it) {
      for (var ut = Ke, pt = null; ut !== null; ) {
        var Yr = ut.subtreeFlags & Xe;
        ut !== pt && ut.child !== null && Yr !== js ? ut = ut.child : ((ut.flags & Xe) !== js && it(ut), ut.sibling !== null ? ut = ut.sibling : ut = pt = ut.return);
      }
    }
    var e1 = null;
    function Iw(Ke) {
      {
        if ((Co & Tl) !== Za || !(Ke.mode & Eo))
          return;
        var Xe = Ke.tag;
        if (Xe !== nt && Xe !== st && Xe !== Je && Xe !== Qe && Xe !== Xr && Xe !== si && Xe !== ri)
          return;
        var it = uo(Ke) || "ReactComponent";
        if (e1 !== null) {
          if (e1.has(it))
            return;
          e1.add(it);
        } else
          e1 = /* @__PURE__ */ new Set([it]);
        var ut = sa;
        try {
          No(Ke), be("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          ut ? No(Ke) : ha();
        }
      }
    }
    var cb;
    {
      var uI = null;
      cb = function(Ke, Xe, it) {
        var ut = $w(uI, Xe);
        try {
          return z_(Ke, Xe, it);
        } catch (Yr) {
          if (b2() || Yr !== null && typeof Yr == "object" && typeof Yr.then == "function")
            throw Yr;
          if (sE(), ZS(), Y_(Ke, Xe), $w(Xe, ut), Xe.mode & Qs && ST(Xe), Rd(null, z_, null, Ke, Xe, it), x1()) {
            var pt = Mm();
            typeof pt == "object" && pt !== null && pt._suppressLogging && typeof Yr == "object" && Yr !== null && !Yr._suppressLogging && (Yr._suppressLogging = !0);
          }
          throw Yr;
        }
      };
    }
    var Pw = !1, db;
    db = /* @__PURE__ */ new Set();
    function cI(Ke) {
      if (_l && !rA())
        switch (Ke.tag) {
          case Qe:
          case Xr:
          case ri: {
            var Xe = xa && uo(xa) || "Unknown", it = Xe;
            if (!db.has(it)) {
              db.add(it);
              var ut = uo(Ke) || "Unknown";
              be("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", ut, Xe, Xe);
            }
            break;
          }
          case Je: {
            Pw || (be("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), Pw = !0);
            break;
          }
        }
    }
    function pv(Ke, Xe) {
      if (ja) {
        var it = Ke.memoizedUpdaters;
        it.forEach(function(ut) {
          r0(Ke, ut, Xe);
        });
      }
    }
    var fb = {};
    function hb(Ke, Xe) {
      {
        var it = bc.current;
        return it !== null ? (it.push(Xe), fb) : Up(Ke, Xe);
      }
    }
    function Dw(Ke) {
      if (Ke !== fb)
        return Yv(Ke);
    }
    function Ow() {
      return bc.current !== null;
    }
    function dI(Ke) {
      {
        if (Ke.mode & Eo) {
          if (!cw())
            return;
        } else if (!DL() || Co !== Za || Ke.tag !== Qe && Ke.tag !== Xr && Ke.tag !== ri)
          return;
        if (bc.current === null) {
          var Xe = sa;
          try {
            No(Ke), be(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, uo(Ke));
          } finally {
            Xe ? No(Ke) : ha();
          }
        }
      }
    }
    function fI(Ke) {
      Ke.tag !== Jf && cw() && bc.current === null && be(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function gv(Ke) {
      mw = Ke;
    }
    var Wu = null, sm = null, hI = function(Ke) {
      Wu = Ke;
    };
    function om(Ke) {
      {
        if (Wu === null)
          return Ke;
        var Xe = Wu(Ke);
        return Xe === void 0 ? Ke : Xe.current;
      }
    }
    function pb(Ke) {
      return om(Ke);
    }
    function gb(Ke) {
      {
        if (Wu === null)
          return Ke;
        var Xe = Wu(Ke);
        if (Xe === void 0) {
          if (Ke != null && typeof Ke.render == "function") {
            var it = om(Ke.render);
            if (Ke.render !== it) {
              var ut = {
                $$typeof: fa,
                render: it
              };
              return Ke.displayName !== void 0 && (ut.displayName = Ke.displayName), ut;
            }
          }
          return Ke;
        }
        return Xe.current;
      }
    }
    function Mw(Ke, Xe) {
      {
        if (Wu === null)
          return !1;
        var it = Ke.elementType, ut = Xe.type, pt = !1, Yr = typeof ut == "object" && ut !== null ? ut.$$typeof : null;
        switch (Ke.tag) {
          case Je: {
            typeof ut == "function" && (pt = !0);
            break;
          }
          case Qe: {
            (typeof ut == "function" || Yr === za) && (pt = !0);
            break;
          }
          case Xr: {
            (Yr === fa || Yr === za) && (pt = !0);
            break;
          }
          case si:
          case ri: {
            (Yr === Cc || Yr === za) && (pt = !0);
            break;
          }
          default:
            return !1;
        }
        if (pt) {
          var Qr = Wu(it);
          if (Qr !== void 0 && Qr === Wu(ut))
            return !0;
        }
        return !1;
      }
    }
    function kw(Ke) {
      {
        if (Wu === null || typeof WeakSet != "function")
          return;
        sm === null && (sm = /* @__PURE__ */ new WeakSet()), sm.add(Ke);
      }
    }
    var pI = function(Ke, Xe) {
      {
        if (Wu === null)
          return;
        var it = Xe.staleFamilies, ut = Xe.updatedFamilies;
        of(), sf(function() {
          mb(Ke.current, ut, it);
        });
      }
    }, gI = function(Ke, Xe) {
      {
        if (Ke.context !== Ru)
          return;
        of(), sf(function() {
          mv(Xe, Ke, null, null);
        });
      }
    };
    function mb(Ke, Xe, it) {
      {
        var ut = Ke.alternate, pt = Ke.child, Yr = Ke.sibling, Qr = Ke.tag, ni = Ke.type, oi = null;
        switch (Qr) {
          case Qe:
          case ri:
          case Je:
            oi = ni;
            break;
          case Xr:
            oi = ni.render;
            break;
        }
        if (Wu === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var vi = !1, Ei = !1;
        if (oi !== null) {
          var Ni = Wu(oi);
          Ni !== void 0 && (it.has(Ni) ? Ei = !0 : Xe.has(Ni) && (Qr === Je ? Ei = !0 : vi = !0));
        }
        if (sm !== null && (sm.has(Ke) || ut !== null && sm.has(ut)) && (Ei = !0), Ei && (Ke._debugNeedsRemount = !0), Ei || vi) {
          var Mi = pu(Ke, to);
          Mi !== null && el(Mi, Ke, to, jo);
        }
        pt !== null && !Ei && mb(pt, Xe, it), Yr !== null && mb(Yr, Xe, it);
      }
    }
    var mI = function(Ke, Xe) {
      {
        var it = /* @__PURE__ */ new Set(), ut = new Set(Xe.map(function(pt) {
          return pt.current;
        }));
        return vb(Ke.current, ut, it), it;
      }
    };
    function vb(Ke, Xe, it) {
      {
        var ut = Ke.child, pt = Ke.sibling, Yr = Ke.tag, Qr = Ke.type, ni = null;
        switch (Yr) {
          case Qe:
          case ri:
          case Je:
            ni = Qr;
            break;
          case Xr:
            ni = Qr.render;
            break;
        }
        var oi = !1;
        ni !== null && Xe.has(ni) && (oi = !0), oi ? vI(Ke, it) : ut !== null && vb(ut, Xe, it), pt !== null && vb(pt, Xe, it);
      }
    }
    function vI(Ke, Xe) {
      {
        var it = yI(Ke, Xe);
        if (it)
          return;
        for (var ut = Ke; ; ) {
          switch (ut.tag) {
            case lt:
              Xe.add(ut.stateNode);
              return;
            case ot:
              Xe.add(ut.stateNode.containerInfo);
              return;
            case st:
              Xe.add(ut.stateNode.containerInfo);
              return;
          }
          if (ut.return === null)
            throw new Error("Expected to reach root first.");
          ut = ut.return;
        }
      }
    }
    function yI(Ke, Xe) {
      for (var it = Ke, ut = !1; ; ) {
        if (it.tag === lt)
          ut = !0, Xe.add(it.stateNode);
        else if (it.child !== null) {
          it.child.return = it, it = it.child;
          continue;
        }
        if (it === Ke)
          return ut;
        for (; it.sibling === null; ) {
          if (it.return === null || it.return === Ke)
            return ut;
          it = it.return;
        }
        it.sibling.return = it.return, it = it.sibling;
      }
      return !1;
    }
    var yb;
    {
      yb = !1;
      try {
        var Nw = Object.preventExtensions({});
      } catch {
        yb = !0;
      }
    }
    function EI(Ke, Xe, it, ut) {
      this.tag = Ke, this.key = it, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = Xe, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = ut, this.flags = js, this.subtreeFlags = js, this.deletions = null, this.lanes = Ji, this.childLanes = Ji, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !yb && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var Au = function(Ke, Xe, it, ut) {
      return new EI(Ke, Xe, it, ut);
    };
    function Eb(Ke) {
      var Xe = Ke.prototype;
      return !!(Xe && Xe.isReactComponent);
    }
    function xI(Ke) {
      return typeof Ke == "function" && !Eb(Ke) && Ke.defaultProps === void 0;
    }
    function TI(Ke) {
      if (typeof Ke == "function")
        return Eb(Ke) ? Je : Qe;
      if (Ke != null) {
        var Xe = Ke.$$typeof;
        if (Xe === fa)
          return Xr;
        if (Xe === Cc)
          return si;
      }
      return nt;
    }
    function yp(Ke, Xe) {
      var it = Ke.alternate;
      it === null ? (it = Au(Ke.tag, Xe, Ke.key, Ke.mode), it.elementType = Ke.elementType, it.type = Ke.type, it.stateNode = Ke.stateNode, it._debugSource = Ke._debugSource, it._debugOwner = Ke._debugOwner, it._debugHookTypes = Ke._debugHookTypes, it.alternate = Ke, Ke.alternate = it) : (it.pendingProps = Xe, it.type = Ke.type, it.flags = js, it.subtreeFlags = js, it.deletions = null, it.actualDuration = 0, it.actualStartTime = -1), it.flags = Ke.flags & Va, it.childLanes = Ke.childLanes, it.lanes = Ke.lanes, it.child = Ke.child, it.memoizedProps = Ke.memoizedProps, it.memoizedState = Ke.memoizedState, it.updateQueue = Ke.updateQueue;
      var ut = Ke.dependencies;
      switch (it.dependencies = ut === null ? null : {
        lanes: ut.lanes,
        firstContext: ut.firstContext
      }, it.sibling = Ke.sibling, it.index = Ke.index, it.ref = Ke.ref, it.selfBaseDuration = Ke.selfBaseDuration, it.treeBaseDuration = Ke.treeBaseDuration, it._debugNeedsRemount = Ke._debugNeedsRemount, it.tag) {
        case nt:
        case Qe:
        case ri:
          it.type = om(Ke.type);
          break;
        case Je:
          it.type = pb(Ke.type);
          break;
        case Xr:
          it.type = gb(Ke.type);
          break;
      }
      return it;
    }
    function bI(Ke, Xe) {
      Ke.flags &= Va | Xo;
      var it = Ke.alternate;
      if (it === null)
        Ke.childLanes = Ji, Ke.lanes = Xe, Ke.child = null, Ke.subtreeFlags = js, Ke.memoizedProps = null, Ke.memoizedState = null, Ke.updateQueue = null, Ke.dependencies = null, Ke.stateNode = null, Ke.selfBaseDuration = 0, Ke.treeBaseDuration = 0;
      else {
        Ke.childLanes = it.childLanes, Ke.lanes = it.lanes, Ke.child = it.child, Ke.subtreeFlags = js, Ke.deletions = null, Ke.memoizedProps = it.memoizedProps, Ke.memoizedState = it.memoizedState, Ke.updateQueue = it.updateQueue, Ke.type = it.type;
        var ut = it.dependencies;
        Ke.dependencies = ut === null ? null : {
          lanes: ut.lanes,
          firstContext: ut.firstContext
        }, Ke.selfBaseDuration = it.selfBaseDuration, Ke.treeBaseDuration = it.treeBaseDuration;
      }
      return Ke;
    }
    function SI(Ke, Xe, it) {
      var ut;
      return Ke === Zy ? (ut = Eo, Xe === !0 && (ut |= aa, ut |= au)) : ut = Xs, ja && (ut |= Qs), Au(st, null, null, ut);
    }
    function xb(Ke, Xe, it, ut, pt, Yr) {
      var Qr = nt, ni = Ke;
      if (typeof Ke == "function")
        Eb(Ke) ? (Qr = Je, ni = pb(ni)) : ni = om(ni);
      else if (typeof Ke == "string")
        Qr = lt;
      else
        e:
          switch (Ke) {
            case Ul:
              return fh(it.children, pt, Yr, Xe);
            case _c:
              Qr = ct, pt |= aa, (pt & Eo) !== Xs && (pt |= au);
              break;
            case wc:
              return _I(it, pt, Yr, Xe);
            case Ql:
              return wI(it, pt, Yr, Xe);
            case vd:
              return CI(it, pt, Yr, Xe);
            case ph:
              return Fw(it, pt, Yr, Xe);
            case Tp:
            case Ep:
            case lm:
            case um:
            case xp:
            default: {
              if (typeof Ke == "object" && Ke !== null)
                switch (Ke.$$typeof) {
                  case lf:
                    Qr = Kr;
                    break e;
                  case hh:
                    Qr = _r;
                    break e;
                  case fa:
                    Qr = Xr, ni = gb(ni);
                    break e;
                  case Cc:
                    Qr = si;
                    break e;
                  case za:
                    Qr = ai, ni = null;
                    break e;
                }
              var oi = "";
              {
                (Ke === void 0 || typeof Ke == "object" && Ke !== null && Object.keys(Ke).length === 0) && (oi += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var vi = ut ? uo(ut) : null;
                vi && (oi += `

Check the render method of \`` + vi + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (Ke == null ? Ke : typeof Ke) + "." + oi));
            }
          }
      var Ei = Au(Qr, it, Xe, pt);
      return Ei.elementType = Ke, Ei.type = ni, Ei.lanes = Yr, Ei._debugOwner = ut, Ei;
    }
    function Tb(Ke, Xe, it) {
      var ut = null;
      ut = Ke._owner;
      var pt = Ke.type, Yr = Ke.key, Qr = Ke.props, ni = xb(pt, Yr, Qr, ut, Xe, it);
      return ni._debugSource = Ke._source, ni._debugOwner = Ke._owner, ni;
    }
    function fh(Ke, Xe, it, ut) {
      var pt = Au(gt, Ke, ut, Xe);
      return pt.lanes = it, pt;
    }
    function _I(Ke, Xe, it, ut) {
      typeof Ke.id != "string" && be('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof Ke.id);
      var pt = Au(Jr, Ke, ut, Xe | Qs);
      return pt.elementType = wc, pt.lanes = it, pt.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, pt;
    }
    function wI(Ke, Xe, it, ut) {
      var pt = Au(ei, Ke, ut, Xe);
      return pt.elementType = Ql, pt.lanes = it, pt;
    }
    function CI(Ke, Xe, it, ut) {
      var pt = Au(di, Ke, ut, Xe);
      return pt.elementType = vd, pt.lanes = it, pt;
    }
    function Fw(Ke, Xe, it, ut) {
      var pt = Au(Ti, Ke, ut, Xe);
      pt.elementType = ph, pt.lanes = it;
      var Yr = {
        isHidden: !1
      };
      return pt.stateNode = Yr, pt;
    }
    function bb(Ke, Xe, it) {
      var ut = Au(ft, Ke, null, Xe);
      return ut.lanes = it, ut;
    }
    function RI() {
      var Ke = Au(lt, null, null, Xs);
      return Ke.elementType = "DELETED", Ke;
    }
    function AI(Ke) {
      var Xe = Au(pi, null, null, Xs);
      return Xe.stateNode = Ke, Xe;
    }
    function Sb(Ke, Xe, it) {
      var ut = Ke.children !== null ? Ke.children : [], pt = Au(ot, ut, Ke.key, Xe);
      return pt.lanes = it, pt.stateNode = {
        containerInfo: Ke.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: Ke.implementation
      }, pt;
    }
    function $w(Ke, Xe) {
      return Ke === null && (Ke = Au(nt, null, null, Xs)), Ke.tag = Xe.tag, Ke.key = Xe.key, Ke.elementType = Xe.elementType, Ke.type = Xe.type, Ke.stateNode = Xe.stateNode, Ke.return = Xe.return, Ke.child = Xe.child, Ke.sibling = Xe.sibling, Ke.index = Xe.index, Ke.ref = Xe.ref, Ke.pendingProps = Xe.pendingProps, Ke.memoizedProps = Xe.memoizedProps, Ke.updateQueue = Xe.updateQueue, Ke.memoizedState = Xe.memoizedState, Ke.dependencies = Xe.dependencies, Ke.mode = Xe.mode, Ke.flags = Xe.flags, Ke.subtreeFlags = Xe.subtreeFlags, Ke.deletions = Xe.deletions, Ke.lanes = Xe.lanes, Ke.childLanes = Xe.childLanes, Ke.alternate = Xe.alternate, Ke.actualDuration = Xe.actualDuration, Ke.actualStartTime = Xe.actualStartTime, Ke.selfBaseDuration = Xe.selfBaseDuration, Ke.treeBaseDuration = Xe.treeBaseDuration, Ke._debugSource = Xe._debugSource, Ke._debugOwner = Xe._debugOwner, Ke._debugNeedsRemount = Xe._debugNeedsRemount, Ke._debugHookTypes = Xe._debugHookTypes, Ke;
    }
    function LI(Ke, Xe, it, ut, pt) {
      this.tag = Xe, this.containerInfo = Ke, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = rx, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = wo, this.eventTimes = pg(Ji), this.expirationTimes = pg(jo), this.pendingLanes = Ji, this.suspendedLanes = Ji, this.pingedLanes = Ji, this.expiredLanes = Ji, this.mutableReadLanes = Ji, this.finishedLanes = Ji, this.entangledLanes = Ji, this.entanglements = pg(Ji), this.identifierPrefix = ut, this.onRecoverableError = pt, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var Yr = this.pendingUpdatersLaneMap = [], Qr = 0; Qr < Qo; Qr++)
          Yr.push(/* @__PURE__ */ new Set());
      }
      switch (Xe) {
        case Zy:
          this._debugRootType = it ? "hydrateRoot()" : "createRoot()";
          break;
        case Jf:
          this._debugRootType = it ? "hydrate()" : "render()";
          break;
      }
    }
    function Bw(Ke, Xe, it, ut, pt, Yr, Qr, ni, oi, vi) {
      var Ei = new LI(Ke, Xe, it, ni, oi), Ni = SI(Xe, Yr);
      Ei.current = Ni, Ni.stateNode = Ei;
      {
        var Mi = {
          element: ut,
          isDehydrated: it,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        Ni.memoizedState = Mi;
      }
      return Ix(Ni), Ei;
    }
    var wb = "18.2.0";
    function II(Ke, Xe, it) {
      var ut = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return ms(ut), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: ia,
        key: ut == null ? null : "" + ut,
        children: Ke,
        containerInfo: Xe,
        implementation: it
      };
    }
    var Cb, Rb;
    Cb = !1, Rb = {};
    function Uw(Ke) {
      if (!Ke)
        return Ru;
      var Xe = nu(Ke), it = f2(Xe);
      if (Xe.tag === Je) {
        var ut = Xe.type;
        if (ad(ut))
          return fS(Xe, ut, it);
      }
      return it;
    }
    function PI(Ke, Xe) {
      {
        var it = nu(Ke);
        if (it === void 0) {
          if (typeof Ke.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var ut = Object.keys(Ke).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + ut);
        }
        var pt = ou(it);
        if (pt === null)
          return null;
        if (pt.mode & aa) {
          var Yr = uo(it) || "Component";
          if (!Rb[Yr]) {
            Rb[Yr] = !0;
            var Qr = sa;
            try {
              No(pt), it.mode & aa ? be("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", Xe, Xe, Yr) : be("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", Xe, Xe, Yr);
            } finally {
              Qr ? No(Qr) : ha();
            }
          }
        }
        return pt.stateNode;
      }
    }
    function Gw(Ke, Xe, it, ut, pt, Yr, Qr, ni) {
      var oi = !1, vi = null;
      return Bw(Ke, Xe, oi, vi, it, ut, pt, Yr, Qr);
    }
    function Hw(Ke, Xe, it, ut, pt, Yr, Qr, ni, oi, vi) {
      var Ei = !0, Ni = Bw(it, ut, Ei, Ke, pt, Yr, Qr, ni, oi);
      Ni.context = Uw(null);
      var Mi = Ni.current, zi = Yl(), ji = ch(Mi), Xi = ef(zi, ji);
      return Xi.callback = Xe ?? null, nh(Mi, Xi, ji), $L(Ni, ji, zi), Ni;
    }
    function mv(Ke, Xe, it, ut) {
      Zv(Xe, Ke);
      var pt = Xe.current, Yr = Yl(), Qr = ch(pt);
      Id(Qr);
      var ni = Uw(it);
      Xe.context === null ? Xe.context = ni : Xe.pendingContext = ni, _l && sa !== null && !Cb && (Cb = !0, be(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, uo(sa) || "Unknown"));
      var oi = ef(Yr, Qr);
      oi.payload = {
        element: Ke
      }, ut = ut === void 0 ? null : ut, ut !== null && (typeof ut != "function" && be("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", ut), oi.callback = ut);
      var vi = nh(pt, oi, Qr);
      return vi !== null && (el(vi, pt, Qr, Yr), cE(vi, pt, Qr)), Qr;
    }
    function t1(Ke) {
      var Xe = Ke.current;
      if (!Xe.child)
        return null;
      switch (Xe.child.tag) {
        case lt:
          return Xe.child.stateNode;
        default:
          return Xe.child.stateNode;
      }
    }
    function DI(Ke) {
      switch (Ke.tag) {
        case st: {
          var Xe = Ke.stateNode;
          if (Da(Xe)) {
            var it = S1(Xe);
            HL(Xe, it);
          }
          break;
        }
        case ei: {
          sf(function() {
            var pt = pu(Ke, to);
            if (pt !== null) {
              var Yr = Yl();
              el(pt, Ke, to, Yr);
            }
          });
          var ut = to;
          Ab(Ke, ut);
          break;
        }
      }
    }
    function zw(Ke, Xe) {
      var it = Ke.memoizedState;
      it !== null && it.dehydrated !== null && (it.retryLane = uy(it.retryLane, Xe));
    }
    function Ab(Ke, Xe) {
      zw(Ke, Xe);
      var it = Ke.alternate;
      it && zw(it, Xe);
    }
    function OI(Ke) {
      if (Ke.tag === ei) {
        var Xe = Pf, it = pu(Ke, Xe);
        if (it !== null) {
          var ut = Yl();
          el(it, Ke, Xe, ut);
        }
        Ab(Ke, Xe);
      }
    }
    function MI(Ke) {
      if (Ke.tag === ei) {
        var Xe = ch(Ke), it = pu(Ke, Xe);
        if (it !== null) {
          var ut = Yl();
          el(it, Ke, Xe, ut);
        }
        Ab(Ke, Xe);
      }
    }
    function Vw(Ke) {
      var Xe = qv(Ke);
      return Xe === null ? null : Xe.stateNode;
    }
    var jw = function(Ke) {
      return null;
    };
    function kI(Ke) {
      return jw(Ke);
    }
    var Ww = function(Ke) {
      return !1;
    };
    function NI(Ke) {
      return Ww(Ke);
    }
    var Kw = null, qw = null, Yw = null, Xw = null, Zw = null, Qw = null, Jw = null, eC = null, tC = null;
    {
      var nC = function(Ke, Xe, it) {
        var ut = Xe[it], pt = _o(Ke) ? Ke.slice() : vo({}, Ke);
        return it + 1 === Xe.length ? (_o(pt) ? pt.splice(ut, 1) : delete pt[ut], pt) : (pt[ut] = nC(Ke[ut], Xe, it + 1), pt);
      }, rC = function(Ke, Xe) {
        return nC(Ke, Xe, 0);
      }, iC = function(Ke, Xe, it, ut) {
        var pt = Xe[ut], Yr = _o(Ke) ? Ke.slice() : vo({}, Ke);
        if (ut + 1 === Xe.length) {
          var Qr = it[ut];
          Yr[Qr] = Yr[pt], _o(Yr) ? Yr.splice(pt, 1) : delete Yr[pt];
        } else
          Yr[pt] = iC(
            // $FlowFixMe number or string is fine here
            Ke[pt],
            Xe,
            it,
            ut + 1
          );
        return Yr;
      }, sC = function(Ke, Xe, it) {
        if (Xe.length !== it.length) {
          ye("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var ut = 0; ut < it.length - 1; ut++)
            if (Xe[ut] !== it[ut]) {
              ye("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return iC(Ke, Xe, it, 0);
      }, oC = function(Ke, Xe, it, ut) {
        if (it >= Xe.length)
          return ut;
        var pt = Xe[it], Yr = _o(Ke) ? Ke.slice() : vo({}, Ke);
        return Yr[pt] = oC(Ke[pt], Xe, it + 1, ut), Yr;
      }, aC = function(Ke, Xe, it) {
        return oC(Ke, Xe, 0, it);
      }, Lb = function(Ke, Xe) {
        for (var it = Ke.memoizedState; it !== null && Xe > 0; )
          it = it.next, Xe--;
        return it;
      };
      Kw = function(Ke, Xe, it, ut) {
        var pt = Lb(Ke, Xe);
        if (pt !== null) {
          var Yr = aC(pt.memoizedState, it, ut);
          pt.memoizedState = Yr, pt.baseState = Yr, Ke.memoizedProps = vo({}, Ke.memoizedProps);
          var Qr = pu(Ke, to);
          Qr !== null && el(Qr, Ke, to, jo);
        }
      }, qw = function(Ke, Xe, it) {
        var ut = Lb(Ke, Xe);
        if (ut !== null) {
          var pt = rC(ut.memoizedState, it);
          ut.memoizedState = pt, ut.baseState = pt, Ke.memoizedProps = vo({}, Ke.memoizedProps);
          var Yr = pu(Ke, to);
          Yr !== null && el(Yr, Ke, to, jo);
        }
      }, Yw = function(Ke, Xe, it, ut) {
        var pt = Lb(Ke, Xe);
        if (pt !== null) {
          var Yr = sC(pt.memoizedState, it, ut);
          pt.memoizedState = Yr, pt.baseState = Yr, Ke.memoizedProps = vo({}, Ke.memoizedProps);
          var Qr = pu(Ke, to);
          Qr !== null && el(Qr, Ke, to, jo);
        }
      }, Xw = function(Ke, Xe, it) {
        Ke.pendingProps = aC(Ke.memoizedProps, Xe, it), Ke.alternate && (Ke.alternate.pendingProps = Ke.pendingProps);
        var ut = pu(Ke, to);
        ut !== null && el(ut, Ke, to, jo);
      }, Zw = function(Ke, Xe) {
        Ke.pendingProps = rC(Ke.memoizedProps, Xe), Ke.alternate && (Ke.alternate.pendingProps = Ke.pendingProps);
        var it = pu(Ke, to);
        it !== null && el(it, Ke, to, jo);
      }, Qw = function(Ke, Xe, it) {
        Ke.pendingProps = sC(Ke.memoizedProps, Xe, it), Ke.alternate && (Ke.alternate.pendingProps = Ke.pendingProps);
        var ut = pu(Ke, to);
        ut !== null && el(ut, Ke, to, jo);
      }, Jw = function(Ke) {
        var Xe = pu(Ke, to);
        Xe !== null && el(Xe, Ke, to, jo);
      }, eC = function(Ke) {
        jw = Ke;
      }, tC = function(Ke) {
        Ww = Ke;
      };
    }
    function FI(Ke) {
      var Xe = ou(Ke);
      return Xe === null ? null : Xe.stateNode;
    }
    function $I(Ke) {
      return null;
    }
    function BI() {
      return sa;
    }
    function UI(Ke) {
      var Xe = Ke.findFiberByHostInstance, it = ee.ReactCurrentDispatcher;
      return zm({
        bundleType: Ke.bundleType,
        version: Ke.version,
        rendererPackageName: Ke.rendererPackageName,
        rendererConfig: Ke.rendererConfig,
        overrideHookState: Kw,
        overrideHookStateDeletePath: qw,
        overrideHookStateRenamePath: Yw,
        overrideProps: Xw,
        overridePropsDeletePath: Zw,
        overridePropsRenamePath: Qw,
        setErrorHandler: eC,
        setSuspenseHandler: tC,
        scheduleUpdate: Jw,
        currentDispatcherRef: it,
        findHostInstanceByFiber: FI,
        findFiberByHostInstance: Xe || $I,
        // React Refresh
        findHostInstancesForRefresh: mI,
        scheduleRefresh: pI,
        scheduleRoot: gI,
        setRefreshHandler: hI,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: BI,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: wb
      });
    }
    var lC = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(Ke) {
      console.error(Ke);
    };
    function Ib(Ke) {
      this._internalRoot = Ke;
    }
    n1.prototype.render = Ib.prototype.render = function(Ke) {
      var Xe = this._internalRoot;
      if (Xe === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? be("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : r1(arguments[1]) ? be("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && be("You passed a second argument to root.render(...) but it only accepts one argument.");
        var it = Xe.containerInfo;
        if (it.nodeType !== Sa) {
          var ut = Vw(Xe.current);
          ut && ut.parentNode !== it && be("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      mv(Ke, Xe, null, null);
    }, n1.prototype.unmount = Ib.prototype.unmount = function() {
      typeof arguments[0] == "function" && be("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var Ke = this._internalRoot;
      if (Ke !== null) {
        this._internalRoot = null;
        var Xe = Ke.containerInfo;
        xw() && be("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), sf(function() {
          mv(null, Ke, null, null);
        }), aS(Xe);
      }
    };
    function GI(Ke, Xe) {
      if (!r1(Ke))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      uC(Ke);
      var it = !1, ut = !1, pt = "", Yr = lC;
      Xe != null && (Xe.hydrate ? ye("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof Xe == "object" && Xe !== null && Xe.$$typeof === va && be(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), Xe.unstable_strictMode === !0 && (it = !0), Xe.identifierPrefix !== void 0 && (pt = Xe.identifierPrefix), Xe.onRecoverableError !== void 0 && (Yr = Xe.onRecoverableError), Xe.transitionCallbacks !== void 0 && Xe.transitionCallbacks);
      var Qr = Gw(Ke, Zy, null, it, ut, pt, Yr);
      Vy(Qr.current, Ke);
      var ni = Ke.nodeType === Sa ? Ke.parentNode : Ke;
      return _0(ni), new Ib(Qr);
    }
    function n1(Ke) {
      this._internalRoot = Ke;
    }
    function HI(Ke) {
      Ke && yy(Ke);
    }
    n1.prototype.unstable_scheduleHydration = HI;
    function zI(Ke, Xe, it) {
      if (!r1(Ke))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      uC(Ke), Xe === void 0 && be("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var ut = it ?? null, pt = it != null && it.hydratedSources || null, Yr = !1, Qr = !1, ni = "", oi = lC;
      it != null && (it.unstable_strictMode === !0 && (Yr = !0), it.identifierPrefix !== void 0 && (ni = it.identifierPrefix), it.onRecoverableError !== void 0 && (oi = it.onRecoverableError));
      var vi = Hw(Xe, null, Ke, Zy, ut, Yr, Qr, ni, oi);
      if (Vy(vi.current, Ke), _0(Ke), pt)
        for (var Ei = 0; Ei < pt.length; Ei++) {
          var Ni = pt[Ei];
          Z2(vi, Ni);
        }
      return new n1(vi);
    }
    function r1(Ke) {
      return !!(Ke && (Ke.nodeType === Cl || Ke.nodeType === bu || Ke.nodeType === Td || !Ri));
    }
    function vv(Ke) {
      return !!(Ke && (Ke.nodeType === Cl || Ke.nodeType === bu || Ke.nodeType === Td || Ke.nodeType === Sa && Ke.nodeValue === " react-mount-point-unstable "));
    }
    function uC(Ke) {
      Ke.nodeType === Cl && Ke.tagName && Ke.tagName.toUpperCase() === "BODY" && be("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), k0(Ke) && (Ke._reactRootContainer ? be("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : be("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var VI = ee.ReactCurrentOwner, cC;
    cC = function(Ke) {
      if (Ke._reactRootContainer && Ke.nodeType !== Sa) {
        var Xe = Vw(Ke._reactRootContainer.current);
        Xe && Xe.parentNode !== Ke && be("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var it = !!Ke._reactRootContainer, ut = Pb(Ke), pt = !!(ut && Zf(ut));
      pt && !it && be("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), Ke.nodeType === Cl && Ke.tagName && Ke.tagName.toUpperCase() === "BODY" && be("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function Pb(Ke) {
      return Ke ? Ke.nodeType === bu ? Ke.documentElement : Ke.firstChild : null;
    }
    function dC() {
    }
    function jI(Ke, Xe, it, ut, pt) {
      if (pt) {
        if (typeof ut == "function") {
          var Yr = ut;
          ut = function() {
            var Mi = t1(Qr);
            Yr.call(Mi);
          };
        }
        var Qr = Hw(
          Xe,
          ut,
          Ke,
          Jf,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          dC
        );
        Ke._reactRootContainer = Qr, Vy(Qr.current, Ke);
        var ni = Ke.nodeType === Sa ? Ke.parentNode : Ke;
        return _0(ni), sf(), Qr;
      } else {
        for (var oi; oi = Ke.lastChild; )
          Ke.removeChild(oi);
        if (typeof ut == "function") {
          var vi = ut;
          ut = function() {
            var Mi = t1(Ei);
            vi.call(Mi);
          };
        }
        var Ei = Gw(
          Ke,
          Jf,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          dC
        );
        Ke._reactRootContainer = Ei, Vy(Ei.current, Ke);
        var Ni = Ke.nodeType === Sa ? Ke.parentNode : Ke;
        return _0(Ni), sf(function() {
          mv(Xe, Ei, it, ut);
        }), Ei;
      }
    }
    function WI(Ke, Xe) {
      Ke !== null && typeof Ke != "function" && be("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", Xe, Ke);
    }
    function i1(Ke, Xe, it, ut, pt) {
      cC(it), WI(pt === void 0 ? null : pt, "render");
      var Yr = it._reactRootContainer, Qr;
      if (!Yr)
        Qr = jI(it, Xe, Ke, pt, ut);
      else {
        if (Qr = Yr, typeof pt == "function") {
          var ni = pt;
          pt = function() {
            var oi = t1(Qr);
            ni.call(oi);
          };
        }
        mv(Xe, Qr, Ke, pt);
      }
      return t1(Qr);
    }
    function KI(Ke) {
      {
        var Xe = VI.current;
        if (Xe !== null && Xe.stateNode !== null) {
          var it = Xe.stateNode._warnedAboutRefsInRender;
          it || be("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Lo(Xe.type) || "A component"), Xe.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return Ke == null ? null : Ke.nodeType === Cl ? Ke : PI(Ke, "findDOMNode");
    }
    function qI(Ke, Xe, it) {
      if (be("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !vv(Xe))
        throw new Error("Target container is not a DOM element.");
      {
        var ut = k0(Xe) && Xe._reactRootContainer === void 0;
        ut && be("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return i1(null, Ke, Xe, !0, it);
    }
    function YI(Ke, Xe, it) {
      if (be("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !vv(Xe))
        throw new Error("Target container is not a DOM element.");
      {
        var ut = k0(Xe) && Xe._reactRootContainer === void 0;
        ut && be("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return i1(null, Ke, Xe, !1, it);
    }
    function XI(Ke, Xe, it, ut) {
      if (be("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !vv(it))
        throw new Error("Target container is not a DOM element.");
      if (Ke == null || !Dh(Ke))
        throw new Error("parentComponent must be a valid React Component");
      return i1(Ke, Xe, it, !1, ut);
    }
    function ZI(Ke) {
      if (!vv(Ke))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var Xe = k0(Ke) && Ke._reactRootContainer === void 0;
        Xe && be("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (Ke._reactRootContainer) {
        {
          var it = Pb(Ke), ut = it && !Zf(it);
          ut && be("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return sf(function() {
          i1(null, null, Ke, !1, function() {
            Ke._reactRootContainer = null, aS(Ke);
          });
        }), !0;
      } else {
        {
          var pt = Pb(Ke), Yr = !!(pt && Zf(pt)), Qr = Ke.nodeType === Cl && vv(Ke.parentNode) && !!Ke.parentNode._reactRootContainer;
          Yr && be("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", Qr ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    As(DI), dy(OI), Kh(MI), o0(uu), hy(Vh), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && be("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), jv(QC), kp(ab, zL, sf);
    function QI(Ke, Xe) {
      var it = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!r1(Xe))
        throw new Error("Target container is not a DOM element.");
      return II(Ke, Xe, null, it);
    }
    function JI(Ke, Xe, it, ut) {
      return XI(Ke, Xe, it, ut);
    }
    var Db = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Zf, Fg, jy, Mp, Lh, ab]
    };
    function eP(Ke, Xe) {
      return Db.usingClientEntryPoint || be('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), GI(Ke, Xe);
    }
    function tP(Ke, Xe, it) {
      return Db.usingClientEntryPoint || be('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), zI(Ke, Xe, it);
    }
    function nP(Ke) {
      return xw() && be("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), sf(Ke);
    }
    var rP = UI({
      findFiberByHostInstance: rp,
      bundleType: 1,
      version: wb,
      rendererPackageName: "react-dom"
    });
    if (!rP && ii && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var fC = window.location.protocol;
      /^(https?|file):$/.test(fC) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (fC === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    reactDom_development.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Db, reactDom_development.createPortal = QI, reactDom_development.createRoot = eP, reactDom_development.findDOMNode = KI, reactDom_development.flushSync = nP, reactDom_development.hydrate = qI, reactDom_development.hydrateRoot = tP, reactDom_development.render = YI, reactDom_development.unmountComponentAtNode = ZI, reactDom_development.unstable_batchedUpdates = ab, reactDom_development.unstable_renderSubtreeIntoContainer = JI, reactDom_development.version = wb, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), reactDom_development;
}
function checkDCE() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (ie) {
      console.error(ie);
    }
  }
}
process.env.NODE_ENV === "production" ? (checkDCE(), reactDom.exports = requireReactDom_production_min()) : reactDom.exports = requireReactDom_development();
var reactDomExports = reactDom.exports;
const $7SXl2$reactdom = /* @__PURE__ */ getDefaultExportFromCjs$1(reactDomExports);
var createRoot, m$2 = reactDomExports;
if (process.env.NODE_ENV === "production")
  createRoot = m$2.createRoot, m$2.hydrateRoot;
else {
  var i$1 = m$2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  createRoot = function(ie, Z) {
    i$1.usingClientEntryPoint = !0;
    try {
      return m$2.createRoot(ie, Z);
    } finally {
      i$1.usingClientEntryPoint = !1;
    }
  };
}
var __defProp = Object.defineProperty, __defNormalProp = (ie, Z, ee) => Z in ie ? __defProp(ie, Z, { enumerable: !0, configurable: !0, writable: !0, value: ee }) : ie[Z] = ee, __publicField = (ie, Z, ee) => (__defNormalProp(ie, typeof Z != "symbol" ? Z + "" : Z, ee), ee);
const EMPTY = [];
Object.freeze(EMPTY);
const emptyAnnotationPage = {
  id: "https://iiif-parser/annotation-page",
  type: "AnnotationPage",
  behavior: EMPTY,
  motivation: null,
  label: null,
  thumbnail: EMPTY,
  summary: null,
  requiredStatement: null,
  metadata: EMPTY,
  rights: null,
  provider: EMPTY,
  items: EMPTY,
  seeAlso: EMPTY,
  homepage: EMPTY,
  logo: EMPTY,
  rendering: EMPTY,
  service: EMPTY
}, emptyCanvas = {
  id: "https://iiif-parser/empty-canvas",
  type: "Canvas",
  label: null,
  behavior: EMPTY,
  motivation: null,
  thumbnail: EMPTY,
  posterCanvas: null,
  accompanyingCanvas: null,
  placeholderCanvas: null,
  summary: null,
  requiredStatement: null,
  metadata: EMPTY,
  rights: null,
  navDate: null,
  provider: EMPTY,
  items: EMPTY,
  annotations: EMPTY,
  seeAlso: EMPTY,
  homepage: EMPTY,
  logo: EMPTY,
  partOf: EMPTY,
  rendering: EMPTY,
  service: EMPTY,
  duration: 0,
  height: 0,
  width: 0
}, emptyCollection = {
  id: "https://iiif-parser/empty-collection",
  type: "Collection",
  label: null,
  viewingDirection: "left-to-right",
  behavior: EMPTY,
  motivation: null,
  thumbnail: EMPTY,
  posterCanvas: null,
  accompanyingCanvas: null,
  placeholderCanvas: null,
  summary: null,
  requiredStatement: null,
  metadata: EMPTY,
  rights: null,
  navDate: null,
  provider: EMPTY,
  items: EMPTY,
  annotations: EMPTY,
  seeAlso: EMPTY,
  homepage: EMPTY,
  logo: EMPTY,
  partOf: EMPTY,
  rendering: EMPTY,
  service: EMPTY,
  services: EMPTY
}, emptyManifest = {
  id: "https://iiif-parser/empty-manifest",
  type: "Manifest",
  annotations: EMPTY,
  behavior: EMPTY,
  homepage: EMPTY,
  items: EMPTY,
  label: null,
  logo: EMPTY,
  metadata: EMPTY,
  motivation: null,
  navDate: null,
  provider: EMPTY,
  partOf: EMPTY,
  posterCanvas: null,
  accompanyingCanvas: null,
  placeholderCanvas: null,
  rendering: EMPTY,
  requiredStatement: null,
  rights: null,
  seeAlso: EMPTY,
  service: EMPTY,
  services: EMPTY,
  start: null,
  structures: EMPTY,
  summary: null,
  thumbnail: EMPTY,
  viewingDirection: "left-to-right"
}, emptyRange = {
  id: "https://iiif-parser/empty-canvas",
  type: "Range",
  label: null,
  behavior: EMPTY,
  motivation: null,
  thumbnail: EMPTY,
  posterCanvas: null,
  accompanyingCanvas: null,
  placeholderCanvas: null,
  summary: null,
  requiredStatement: null,
  metadata: EMPTY,
  rights: null,
  navDate: null,
  provider: EMPTY,
  items: EMPTY,
  annotations: EMPTY,
  seeAlso: EMPTY,
  homepage: EMPTY,
  logo: EMPTY,
  partOf: EMPTY,
  rendering: EMPTY,
  service: EMPTY,
  start: null,
  supplementary: null,
  viewingDirection: "left-to-right"
}, emptyAgent = {
  id: "https://iiif-parser/empty-agent",
  type: "Agent",
  label: {},
  logo: EMPTY,
  seeAlso: EMPTY,
  homepage: EMPTY
};
function ensureArray$1(ie) {
  return Array.isArray(ie) ? ie : [ie];
}
const types$1 = [
  "Collection",
  "Manifest",
  "Canvas",
  "AnnotationPage",
  "AnnotationCollection",
  "Annotation",
  "ContentResource",
  "Range",
  "Service",
  "Selector",
  "Agent"
];
function identifyResource$1(ie) {
  if (typeof ie > "u" || ie === null)
    throw new Error("Null or undefined is not a valid entity.");
  if (Array.isArray(ie))
    throw new Error("Array is not a valid entity");
  if (typeof ie != "object")
    throw new Error(`${typeof ie} is not a valid entity`);
  if (typeof ie.type == "string") {
    const Z = types$1.indexOf(ie.type);
    if (Z !== -1)
      return types$1[Z];
  }
  if (ie.profile)
    return "Service";
  throw new Error("Resource type is not known");
}
class Traverse$1 {
  constructor(Z, ee = {}) {
    __publicField(this, "traversals"), __publicField(this, "options"), this.traversals = {
      collection: [],
      manifest: [],
      canvas: [],
      annotationCollection: [],
      annotationPage: [],
      annotation: [],
      contentResource: [],
      choice: [],
      range: [],
      service: [],
      agent: [],
      ...Z
    }, this.options = {
      allowUndefinedReturn: !1,
      ...ee
    };
  }
  static all(Z) {
    return new Traverse$1({
      collection: [Z],
      manifest: [Z],
      canvas: [Z],
      annotationCollection: [Z],
      annotationPage: [Z],
      annotation: [Z],
      contentResource: [Z],
      choice: [Z],
      range: [Z],
      service: [Z]
    });
  }
  traverseDescriptive(Z) {
    return Z.thumbnail && (Z.thumbnail = Z.thumbnail.map(
      (ee) => this.traverseType(ee, this.traversals.contentResource)
    )), Z.provider && (Z.provider = Z.provider.map((ee) => this.traverseAgent(ee))), Z;
  }
  traverseLinking(Z) {
    return Z.seeAlso && (Z.seeAlso = Z.seeAlso.map((ee) => this.traverseType(ee, this.traversals.contentResource))), Z.service && (Z.service = ensureArray$1(Z.service).map(
      (ee) => this.traverseType(ee, this.traversals.service)
    )), Z.services && (Z.services = Z.services.map((ee) => this.traverseType(ee, this.traversals.service))), Z.logo && (Z.logo = Z.logo.map((ee) => this.traverseType(ee, this.traversals.contentResource))), Z.homepage && (Z.homepage = Z.homepage.map(
      (ee) => this.traverseType(ee, this.traversals.contentResource)
    )), Z.partOf && (Z.partOf = Z.partOf.map((ee) => typeof ee == "string" || !ee.type ? this.traverseType(ee, this.traversals.contentResource) : ee.type === "Canvas" ? this.traverseType(ee, this.traversals.canvas) : ee.type === "AnnotationCollection" ? this.traverseType(ee, this.traversals.annotationCollection) : ee.type === "Collection" ? this.traverseType(ee, this.traversals.collection) : this.traverseType(ee, this.traversals.contentResource))), Z.start && (Z.start = Z.start ? this.traverseType(Z.start, this.traversals.canvas) : null), Z.rendering && (Z.rendering = Z.rendering.map(
      (ee) => this.traverseType(ee, this.traversals.contentResource)
    )), Z.supplementary && (Z.supplementary = Z.supplementary.map(
      (ee) => this.traverseType(ee, this.traversals.contentResource)
    )), Z;
  }
  traverseCollectionItems(Z) {
    return Z.items && Z.items.map((ee) => ee.type === "Collection" ? this.traverseCollection(ee) : this.traverseManifest(ee)), Z;
  }
  traverseCollection(Z) {
    return this.traverseType(
      this.traverseDescriptive(
        this.traverseInlineAnnotationPages(
          this.traverseLinking(this.traversePosterCanvas(this.traverseCollectionItems(Z)))
        )
      ),
      this.traversals.collection
    );
  }
  traverseManifestItems(Z) {
    return Z.items && (Z.items = Z.items.map((ee) => this.traverseCanvas(ee))), Z;
  }
  traverseManifestStructures(Z) {
    return Z.structures && (Z.structures = Z.structures.map((ee) => this.traverseRange(ee))), Z;
  }
  traverseManifest(Z) {
    return this.traverseType(
      this.traverseInlineAnnotationPages(
        this.traverseManifestStructures(
          this.traversePosterCanvas(
            this.traverseDescriptive(this.traverseLinking(this.traverseManifestItems(Z)))
          )
        )
      ),
      this.traversals.manifest
    );
  }
  traverseCanvasItems(Z) {
    return Z.items = (Z.items || []).map((ee) => this.traverseAnnotationPage(ee)), Z;
  }
  traverseInlineAnnotationPages(Z) {
    return typeof Z == "string" || !Z || Z.annotations && (Z.annotations = Z.annotations.map((ee) => this.traverseAnnotationPage(ee))), Z;
  }
  traverseCanvas(Z) {
    return this.traverseType(
      this.traverseInlineAnnotationPages(
        this.traversePosterCanvas(this.traverseDescriptive(this.traverseLinking(this.traverseCanvasItems(Z))))
      ),
      this.traversals.canvas
    );
  }
  traverseAnnotationPageItems(Z) {
    return Z.items && (Z.items = Z.items.map((ee) => this.traverseAnnotation(ee))), Z;
  }
  traverseAnnotationPage(Z) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseAnnotationPageItems(Z))),
      this.traversals.annotationPage
    );
  }
  traverseAnnotationBody(Z) {
    return Array.isArray(Z.body) ? Z.body = Z.body.map((ee) => this.traverseContentResource(ee)) : Z.body && (Z.body = this.traverseContentResource(Z.body)), Z;
  }
  traversePosterCanvas(Z) {
    return Z.posterCanvas && (Z.posterCanvas = this.traverseCanvas(Z.posterCanvas)), Z.placeholderCanvas && (Z.placeholderCanvas = this.traverseCanvas(Z.placeholderCanvas)), Z.accompanyingCanvas && (Z.accompanyingCanvas = this.traverseCanvas(Z.accompanyingCanvas)), Z;
  }
  traverseAnnotation(Z) {
    return this.traverseType(
      this.traverseLinking(this.traverseAnnotationBody(Z)),
      this.traversals.annotation
    );
  }
  traverseContentResourceLinking(Z) {
    return typeof Z == "string" || !Z || Z && Z.service && (Z.service = ensureArray$1(
      Z.service || []
    ).map((ee) => this.traverseType(ee, this.traversals.service))), Z;
  }
  traverseContentResource(Z) {
    return Z.type === "Choice" && (Z.items = Z.items.map((ee) => this.traverseContentResource(ee))), this.traverseType(
      this.traverseInlineAnnotationPages(this.traverseContentResourceLinking(Z)),
      this.traversals.contentResource
    );
  }
  traverseRangeRanges(Z) {
    return Z.items && (Z.items = Z.items.map((ee) => typeof ee == "string" ? this.traverseCanvas({ id: ee, type: "Canvas" }) : ee.type === "Manifest" ? this.traverseManifest(ee) : this.traverseRange(ee))), Z;
  }
  traverseRange(Z) {
    return this.traverseType(
      this.traversePosterCanvas(this.traverseDescriptive(this.traverseLinking(this.traverseRangeRanges(Z)))),
      this.traversals.range
    );
  }
  traverseAgent(Z) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(Z)),
      this.traversals.agent
    );
  }
  traverseType(Z, ee) {
    return ee.reduce((ae, ve) => {
      const ye = ve(ae);
      return typeof ye > "u" && !this.options.allowUndefinedReturn ? ae : ye;
    }, Z);
  }
  traverseService(Z) {
    return this.traverseType(Z, this.traversals.service);
  }
  traverseUnknown(Z) {
    const ee = identifyResource$1(Z);
    switch (ee) {
      case "Collection":
        return this.traverseCollection(Z);
      case "Manifest":
        return this.traverseManifest(Z);
      case "Canvas":
        return this.traverseCanvas(Z);
      case "AnnotationPage":
        return this.traverseAnnotationPage(Z);
      case "Annotation":
        return this.traverseAnnotation(Z);
      case "ContentResource":
        return this.traverseContentResource(Z);
      case "Range":
        return this.traverseRange(Z);
      case "Service":
        return this.traverseService(Z);
      case "Agent":
        return this.traverseAgent(Z);
      default:
        throw new Error(`Unknown or unsupported resource type of ${ee}`);
    }
  }
}
const types = [
  "sc:Collection",
  "sc:Manifest",
  "sc:Canvas",
  "sc:AnnotationList",
  "oa:Annotation",
  "sc:Range",
  "sc:Layer",
  "sc:Sequence",
  "oa:Choice",
  "Service",
  "ContentResource"
];
function identifyResource(ie) {
  if (typeof ie > "u" || ie === null)
    throw new Error("Null or undefined is not a valid entity.");
  if (Array.isArray(ie))
    throw new Error("Array is not a valid entity");
  if (typeof ie != "object")
    throw new Error(`${typeof ie} is not a valid entity`);
  if (typeof ie["@type"] == "string") {
    const Z = types.indexOf(ie["@type"]);
    if (Z !== -1)
      return types[Z];
  }
  if (ie.profile)
    return "Service";
  if (ie.format || ie["@type"])
    return "ContentResource";
  throw new Error("Resource type is not known");
}
class Traverse {
  constructor(Z, ee = {}) {
    __publicField(this, "traversals"), __publicField(this, "options"), this.traversals = {
      collection: [],
      manifest: [],
      canvas: [],
      annotationList: [],
      sequence: [],
      annotation: [],
      contentResource: [],
      choice: [],
      range: [],
      service: [],
      layer: [],
      ...Z
    }, this.options = {
      convertPropsToArray: !0,
      mergeMemberProperties: !0,
      allowUndefinedReturn: !1,
      ...ee
    };
  }
  static all(Z) {
    return new Traverse({
      collection: [Z],
      manifest: [Z],
      canvas: [Z],
      annotationList: [Z],
      sequence: [Z],
      annotation: [Z],
      contentResource: [Z],
      choice: [Z],
      range: [Z],
      service: [Z],
      layer: [Z]
    });
  }
  traverseCollection(Z) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseCollectionItems(Z))),
      this.traversals.collection
    );
  }
  traverseCollectionItems(Z) {
    if (this.options.mergeMemberProperties) {
      const ee = [
        ...(Z.manifests || []).map((ae) => typeof ae == "string" ? { "@id": ae, "@type": "sc:Manifest" } : ae),
        ...(Z.collections || []).map((ae) => typeof ae == "string" ? { "@id": ae, "@type": "sc:Collection" } : ae),
        ...Z.members || []
      ];
      delete Z.collections, delete Z.manifests, Z.members = ee;
    }
    return Z.manifests && (Z.manifests = Z.manifests.map(
      (ee) => this.traverseManifest(
        typeof ee == "string" ? { "@id": ee, "@type": "sc:Manifest" } : ee
      )
    )), Z.collections && (Z.collections = Z.collections.map(
      (ee) => this.traverseCollection(
        typeof ee == "string" ? { "@id": ee, "@type": "sc:Collection" } : ee
      )
    )), Z.members && (Z.members = Z.members.map((ee) => typeof ee == "string" ? ee : this.traverseUnknown(ee))), Z;
  }
  traverseManifest(Z) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseManifestItems(Z))),
      this.traversals.manifest
    );
  }
  traverseManifestItems(Z) {
    return Z.sequences && (Z.sequences = Z.sequences.map((ee) => this.traverseSequence(ee))), Z.structures && (Z.structures = Z.structures.map((ee) => this.traverseRange(ee))), Z;
  }
  traverseSequence(Z) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseSequenceItems(Z))),
      this.traversals.sequence
    );
  }
  traverseSequenceItems(Z) {
    return Z.canvases && (Z.canvases = Z.canvases.map((ee) => this.traverseCanvas(ee))), Z;
  }
  traverseCanvas(Z) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseCanvasItems(Z))),
      this.traversals.canvas
    );
  }
  traverseCanvasItems(Z) {
    return Z.images && (Z.images = Z.images.map((ee) => this.traverseAnnotation(ee))), Z.otherContent && (Z.otherContent = Z.otherContent.map((ee) => this.traverseAnnotationList(ee))), Z;
  }
  traverseRange(Z) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseRangeItems(Z))),
      this.traversals.range
    );
  }
  traverseRangeItems(Z) {
    if (this.options.mergeMemberProperties) {
      const ee = [
        ...(Z.ranges || []).map((ae) => typeof ae == "string" ? { "@id": ae, "@type": "sc:Range" } : ae),
        ...(Z.canvases || []).map((ae) => typeof ae == "string" ? { "@id": ae, "@type": "sc:Canvas" } : ae),
        ...Z.members || []
      ];
      delete Z.ranges, delete Z.canvases, Z.members = ee.length ? ee.map((ae) => this.traverseUnknown(ae)) : void 0;
    }
    return Z;
  }
  traverseAnnotationList(Z) {
    const ee = typeof Z == "string" ? { "@id": Z, "@type": "sc:AnnotationList" } : Z;
    return this.traverseType(
      this.traverseDescriptive(this.traverseAnnotationListItems(ee)),
      this.traversals.annotationList
    );
  }
  traverseAnnotationListItems(Z) {
    return Z.resources && (Z.resources = Z.resources.map((ee) => this.traverseAnnotation(ee))), Z;
  }
  traverseAnnotation(Z) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseAnnotationItems(Z))),
      this.traversals.annotation
    );
  }
  traverseAnnotationItems(Z) {
    return Z.resource && (Array.isArray(Z.resource) ? Z.resource = Z.resource.map(
      (ee) => this.traverseContentResource(ee)
    ) : Z.resource = this.traverseContentResource(Z.resource)), Z.on, Z;
  }
  traverseLayer(Z) {
    return this.traverseType(this.traverseLinking(this.traverseLayerItems(Z)), this.traversals.layer);
  }
  traverseLayerItems(Z) {
    return Z.otherContent && (Z.otherContent = Z.otherContent.map((ee) => this.traverseAnnotationList(ee))), Z;
  }
  traverseChoice(Z) {
    return this.traverseType(this.traverseChoiceItems(Z), this.traversals.choice);
  }
  traverseChoiceItems(Z) {
    return Z.default && Z.default !== "rdf:nil" && (Z.default = this.traverseContentResource(Z.default)), Z.item && Z.item !== "rdf:nil" && (Z.item = Z.item.map((ee) => this.traverseContentResource(ee))), Z;
  }
  traverseService(Z) {
    return this.traverseType(this.traverseLinking(Z), this.traversals.service);
  }
  traverseContentResource(Z) {
    return Z["@type"] === "oa:Choice" ? this.traverseChoice(Z) : this.traverseType(
      this.traverseDescriptive(this.traverseLinking(Z)),
      this.traversals.contentResource
    );
  }
  traverseUnknown(Z) {
    if (!Z["@type"] || typeof Z == "string")
      return Z;
    switch (identifyResource(Z)) {
      case "sc:Collection":
        return this.traverseCollection(Z);
      case "sc:Manifest":
        return this.traverseManifest(Z);
      case "sc:Canvas":
        return this.traverseCanvas(Z);
      case "sc:Sequence":
        return this.traverseSequence(Z);
      case "sc:Range":
        return this.traverseRange(Z);
      case "oa:Annotation":
        return this.traverseAnnotation(Z);
      case "sc:AnnotationList":
        return this.traverseAnnotationList(Z);
      case "sc:Layer":
        return this.traverseLayer(Z);
      case "Service":
        return this.traverseService(Z);
      case "oa:Choice":
        return this.traverseChoice(Z);
      case "ContentResource":
        return this.traverseContentResource(Z);
    }
    return Z.profile ? this.traverseService(Z) : Z;
  }
  traverseImageResource(Z) {
    const ee = Array.isArray(Z), ae = Array.isArray(Z) ? Z : [Z], ve = [];
    for (const ye of ae)
      typeof ye == "string" ? ve.push(
        this.traverseContentResource({
          "@id": ye,
          "@type": "dctypes:Image"
        })
      ) : ve.push(this.traverseContentResource(ye));
    return !ee && !this.options.convertPropsToArray ? ve[0] : ve;
  }
  traverseDescriptive(Z) {
    return Z.thumbnail && (Z.thumbnail = this.traverseImageResource(Z.thumbnail)), Z.logo && (Z.logo = this.traverseImageResource(Z.logo)), Z;
  }
  traverseOneOrMoreServices(Z) {
    const ee = Array.isArray(Z), ae = Array.isArray(Z) ? Z : [Z], ve = [];
    for (const ye of ae)
      ve.push(this.traverseService(ye));
    return !ee && !this.options.convertPropsToArray ? ve[0] : ve;
  }
  traverseLinking(Z) {
    return Z.related && (Z.related = this.traverseOneOrManyType(Z.related, this.traversals.contentResource)), Z.rendering && (Z.rendering = this.traverseOneOrManyType(Z.rendering, this.traversals.contentResource)), Z.service && (Z.service = this.traverseOneOrMoreServices(Z.service)), Z.seeAlso && (Z.seeAlso = this.traverseOneOrManyType(Z.seeAlso, this.traversals.contentResource)), Z.within && (typeof Z.within == "string" || (Z.within = this.traverseOneOrManyType(
      Z.within,
      this.traversals.contentResource
    ))), Z.startCanvas && (typeof Z.startCanvas == "string" ? Z.startCanvas = this.traverseType(
      { "@id": Z.startCanvas, "@type": "sc:Canvas" },
      this.traversals.canvas
    ) : Z.startCanvas && this.traverseType(Z.startCanvas, this.traversals.canvas)), Z.contentLayer && (typeof Z.contentLayer == "string" ? Z.contentLayer = this.traverseLayer({
      "@id": Z.contentLayer,
      "@type": "sc:Layer"
    }) : Z.contentLayer = this.traverseLayer(Z.contentLayer)), Z;
  }
  traverseOneOrManyType(Z, ee) {
    if (!Array.isArray(Z))
      if (this.options.convertPropsToArray)
        Z = [Z];
      else
        return this.traverseType(Z, ee);
    return Z.map((ae) => this.traverseType(ae, ee));
  }
  traverseType(Z, ee) {
    return ee.reduce((ae, ve) => {
      const ye = ve(ae);
      return typeof ye > "u" && !this.options.allowUndefinedReturn ? ae : ye;
    }, Z);
  }
}
const STANFORD_IIIF_IMAGE_COMPLIANCE_0 = "http://library.stanford.edu/iiif/image-api/compliance.html#level0", STANFORD_IIIF_IMAGE_COMPLIANCE_1 = "http://library.stanford.edu/iiif/image-api/compliance.html#level1", STANFORD_IIIF_IMAGE_COMPLIANCE_2 = "http://library.stanford.edu/iiif/image-api/compliance.html#level2", STANFORD_IIIF_IMAGE_CONFORMANCE_0 = "http://library.stanford.edu/iiif/image-api/conformance.html#level0", STANFORD_IIIF_IMAGE_CONFORMANCE_1 = "http://library.stanford.edu/iiif/image-api/conformance.html#level1", STANFORD_IIIF_IMAGE_CONFORMANCE_2 = "http://library.stanford.edu/iiif/image-api/conformance.html#level2", STANFORD_IIIF_1_IMAGE_COMPLIANCE_0 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0", STANFORD_IIIF_1_IMAGE_COMPLIANCE_1 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level1", STANFORD_IIIF_1_IMAGE_COMPLIANCE_2 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2", STANFORD_IIIF_1_IMAGE_CONFORMANCE_0 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level0", STANFORD_IIIF_1_IMAGE_CONFORMANCE_1 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level1", STANFORD_IIIF_1_IMAGE_CONFORMANCE_2 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level2", IIIF_1_IMAGE_LEVEL_0 = "http://iiif.io/api/image/1/level0.json", IIIF_1_IMAGE_LEVEL_0_PROFILE = "http://iiif.io/api/image/1/profiles/level0.json", IIIF_1_IMAGE_LEVEL_1 = "http://iiif.io/api/image/1/level1.json", IIIF_1_IMAGE_LEVEL_1_PROFILE = "http://iiif.io/api/image/1/profiles/level1.json", IIIF_1_IMAGE_LEVEL_2 = "http://iiif.io/api/image/1/level2.json", IIIF_1_IMAGE_LEVEL_2_PROFILE = "http://iiif.io/api/image/1/profiles/level2.json", IIIF_2_IMAGE_LEVEL_0 = "http://iiif.io/api/image/2/level0.json", IIIF_2_IMAGE_LEVEL_0_PROFILE = "http://iiif.io/api/image/2/profiles/level0.json", IIIF_2_IMAGE_LEVEL_1 = "http://iiif.io/api/image/2/level1.json", IIIF_2_IMAGE_LEVEL_1_PROFILE = "http://iiif.io/api/image/2/profiles/level1.json", IIIF_2_IMAGE_LEVEL_2 = "http://iiif.io/api/image/2/level2.json", IIIF_2_IMAGE_LEVEL_2_PROFILE = "http://iiif.io/api/image/2/profiles/level2.json", IIIF_3_IMAGE_LEVEL_0 = "level0", IIIF_3_IMAGE_LEVEL_1 = "level1", IIIF_3_IMAGE_LEVEL_2 = "level2", IIIF_2_IMAGE_LEVEL_0_NO_JSON = "http://iiif.io/api/image/2/level0", IIIF_2_IMAGE_LEVEL_1_NO_JSON = "http://iiif.io/api/image/2/level1", IIIF_2_IMAGE_LEVEL_2_NO_JSON = "http://iiif.io/api/image/2/level2", level1Support = [
  IIIF_2_IMAGE_LEVEL_1_NO_JSON,
  IIIF_2_IMAGE_LEVEL_2_NO_JSON,
  STANFORD_IIIF_IMAGE_COMPLIANCE_1,
  STANFORD_IIIF_IMAGE_COMPLIANCE_2,
  STANFORD_IIIF_IMAGE_CONFORMANCE_1,
  STANFORD_IIIF_IMAGE_CONFORMANCE_2,
  STANFORD_IIIF_1_IMAGE_COMPLIANCE_1,
  STANFORD_IIIF_1_IMAGE_COMPLIANCE_2,
  STANFORD_IIIF_1_IMAGE_CONFORMANCE_1,
  STANFORD_IIIF_1_IMAGE_CONFORMANCE_2,
  IIIF_1_IMAGE_LEVEL_1,
  IIIF_1_IMAGE_LEVEL_1_PROFILE,
  IIIF_1_IMAGE_LEVEL_2,
  IIIF_1_IMAGE_LEVEL_2_PROFILE,
  IIIF_2_IMAGE_LEVEL_1,
  IIIF_2_IMAGE_LEVEL_1_PROFILE,
  IIIF_2_IMAGE_LEVEL_2,
  IIIF_2_IMAGE_LEVEL_2_PROFILE,
  IIIF_3_IMAGE_LEVEL_1,
  IIIF_3_IMAGE_LEVEL_2
], imageServiceProfiles = [
  IIIF_2_IMAGE_LEVEL_0_NO_JSON,
  IIIF_2_IMAGE_LEVEL_1_NO_JSON,
  IIIF_2_IMAGE_LEVEL_2_NO_JSON,
  STANFORD_IIIF_IMAGE_COMPLIANCE_0,
  STANFORD_IIIF_IMAGE_COMPLIANCE_1,
  STANFORD_IIIF_IMAGE_COMPLIANCE_2,
  STANFORD_IIIF_IMAGE_CONFORMANCE_0,
  STANFORD_IIIF_IMAGE_CONFORMANCE_1,
  STANFORD_IIIF_IMAGE_CONFORMANCE_2,
  STANFORD_IIIF_1_IMAGE_COMPLIANCE_0,
  STANFORD_IIIF_1_IMAGE_COMPLIANCE_1,
  STANFORD_IIIF_1_IMAGE_COMPLIANCE_2,
  STANFORD_IIIF_1_IMAGE_CONFORMANCE_0,
  STANFORD_IIIF_1_IMAGE_CONFORMANCE_1,
  STANFORD_IIIF_1_IMAGE_CONFORMANCE_2,
  IIIF_1_IMAGE_LEVEL_0,
  IIIF_1_IMAGE_LEVEL_0_PROFILE,
  IIIF_1_IMAGE_LEVEL_1,
  IIIF_1_IMAGE_LEVEL_1_PROFILE,
  IIIF_1_IMAGE_LEVEL_2,
  IIIF_1_IMAGE_LEVEL_2_PROFILE,
  IIIF_2_IMAGE_LEVEL_0,
  IIIF_2_IMAGE_LEVEL_0_PROFILE,
  IIIF_2_IMAGE_LEVEL_1,
  IIIF_2_IMAGE_LEVEL_1_PROFILE,
  IIIF_2_IMAGE_LEVEL_2,
  IIIF_2_IMAGE_LEVEL_2_PROFILE,
  IIIF_3_IMAGE_LEVEL_0,
  IIIF_3_IMAGE_LEVEL_1,
  IIIF_3_IMAGE_LEVEL_2
], configuration = {
  attributionLabel: "Attribution",
  lang: "none",
  providerId: "http://example.org/provider",
  providerName: "Unknown"
};
function convertLanguageMapping(ie, Z = "none") {
  if (!ie)
    return {};
  const ee = Array.isArray(ie) ? ie : [ie], ae = {};
  for (const ve of ee) {
    if (typeof ve == "string") {
      ae[Z] = ae[Z] ? ae[Z] : [], ae[Z].push(ve || "");
      continue;
    }
    if (!ve["@language"]) {
      ae[Z] = ae[Z] ? ae[Z] : [], ae[Z].push(ve["@value"] || "");
      continue;
    }
    const ye = ve["@language"];
    ae[ye] = ae[ye] ? ae[ye] : [], ae[ye].push(ve["@value"] || "");
  }
  return ae;
}
function getProfile(ie) {
  if (Array.isArray(ie))
    return getProfile(ie.find((Z) => typeof Z == "string"));
  if (imageServiceProfiles.indexOf(ie) !== -1)
    return "level2";
  if (level1Support.indexOf(ie) !== -1)
    return "level1";
  if (typeof ie == "string")
    return ie;
}
function getTypeFromContext(ie) {
  const Z = Array.isArray(ie) ? ie : [ie];
  for (const ee of Z)
    switch (ee) {
      case "http://iiif.io/api/image/2/context.json":
      case "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2":
        return "ImageService2";
      case "http://iiif.io/api/image/1/context.json":
      case "http://library.stanford.edu/iiif/image-api/1.1/context.json":
        return "ImageService1";
      case "http://iiif.io/api/annex/openannotation/context.json":
        return "ImageApiSelector";
    }
}
function getTypeFromProfile(ie) {
  switch (ie) {
    case "http://iiif.io/api/image/2/level0.json":
    case "http://iiif.io/api/image/2/level1.json":
    case "http://iiif.io/api/image/2/level2.json":
      return "ImageService2";
    case "http://iiif.io/api/auth/1/kiosk":
    case "http://iiif.io/api/auth/1/login":
    case "http://iiif.io/api/auth/1/clickthrough":
    case "http://iiif.io/api/auth/1/external":
    case "http://iiif.io/api/auth/0/kiosk":
    case "http://iiif.io/api/auth/0/login":
    case "http://iiif.io/api/auth/0/clickthrough":
    case "http://iiif.io/api/auth/0/external":
      return "AuthCookieService1";
    case "http://iiif.io/api/auth/1/token":
    case "http://iiif.io/api/auth/0/token":
      return "AuthTokenService1";
    case "http://iiif.io/api/auth/1/logout":
    case "http://iiif.io/api/auth/0/logout":
      return "AuthLogoutService1";
    case "http://iiif.io/api/search/1/search":
    case "http://iiif.io/api/search/0/search":
      return "SearchService1";
    case "http://iiif.io/api/search/1/autocomplete":
    case "http://iiif.io/api/search/0/autocomplete":
      return "AutoCompleteService1";
  }
}
function removePrefix(ie) {
  for (const Z of ["sc", "oa", "dcterms", "dctypes", "iiif"])
    if (ie.startsWith(`${Z}:`))
      return ie.slice(Z.length + 1);
  return ie;
}
const knownTypes = ["Collection", "Manifest", "Annotation", "AnnotationPage", "Range", "Service"];
function getNewType(ie) {
  const Z = ie["@id"] || ie.id;
  let ee = ie["@type"] || ie.type;
  const ae = ie.profile || void 0, ve = ie["@context"] || void 0;
  if (ae) {
    const ye = getTypeFromProfile(ae);
    if (ye)
      return ye;
  }
  if (ve) {
    const ye = getTypeFromContext(ve);
    if (ye)
      return ye;
  }
  if (ee) {
    if (Array.isArray(ee)) {
      if (ee.indexOf("oa:CssStylesheet") !== -1)
        return "CssStylesheet";
      if (ee.indexOf("cnt:ContentAsText") !== -1)
        return "TextualBody";
      ee = ee[0];
    }
    for (const ye of ["sc", "oa", "dcterms", "dctypes", "iiif"])
      if (ee.startsWith(`${ye}:`)) {
        ee = ee.slice(ye.length + 1);
        break;
      }
    switch (ee) {
      case "Layer":
        return "AnnotationCollection";
      case "AnnotationList":
        return "AnnotationPage";
      case "cnt:ContentAsText":
        return "TextualBody";
    }
  }
  if (ee && knownTypes.indexOf(ee) !== -1)
    return ee;
  if (ie.format) {
    if (ie.format.startsWith("image/"))
      return "Image";
    if (ie.format.startsWith("text/") || ie.format === "application/pdf")
      return "Text";
    if (ie.format.startsWith("application/"))
      return "Dataset";
  }
  return Z && (Z.endsWith(".jpg") || Z.endsWith(".png") || Z.endsWith(".jpeg")) ? "Image" : ee || "unknown";
}
const licenseRegex = /http(s)?:\/\/(creativecommons.org|rightsstatements.org)[^"'\\<\n]+/gm;
function extractLicense(ie) {
  const Z = ie.match(licenseRegex);
  return Z ? Z[0] : ie;
}
function fixLicense(ie, Z = "Rights/License", ee = "none") {
  let ae = null;
  const ve = [], ye = Array.isArray(ie) ? ie : [ie];
  for (const be of ye) {
    const Ye = be ? extractLicense(be) : void 0;
    if (Ye && (Ye.indexOf("creativecommons.org") !== -1 || Ye.indexOf("rightsstatements.org") !== -1)) {
      Ye.startsWith("https://") ? ae = `http://${Ye.slice(8)}` : ae = Ye;
      continue;
    }
    Ye && ve.push({
      label: { [ee]: [Z] },
      value: { [ee]: [Ye] }
    });
  }
  return [ae, ve];
}
const removeContexts = [
  "http://iiif.io/api/presentation/2/context.json",
  "http://iiif.io/api/image/2/context.json",
  "http://iiif.io/api/image/1/context.json",
  "http://library.stanford.edu/iiif/image-api/1.1/context.json",
  "http://iiif.io/api/search/1/context.json",
  "http://iiif.io/api/search/0/context.json",
  "http://iiif.io/api/auth/1/context.json",
  "http://iiif.io/api/auth/0/context.json",
  "http://iiif.io/api/annex/openannotation/context.json"
];
function fixContext(ie) {
  if (ie) {
    const Z = Array.isArray(ie) ? ie : [ie], ee = [];
    for (const ae of Z)
      ae === "http://iiif.io/api/presentation/2/context.json" && ee.push("http://iiif.io/api/presentation/3/context.json"), removeContexts.indexOf(ae) === -1 && ee.push(ae);
    if (Z.length)
      return ee.length === 1 ? ee[0] : ee;
  }
}
function convertMetadata(ie) {
  return ie ? ie.map((Z) => ({
    label: convertLanguageMapping(Z.label),
    value: convertLanguageMapping(Z.value)
  })) : [];
}
function removeUndefinedProperties(ie) {
  for (const Z in ie)
    (typeof ie[Z] > "u" || ie[Z] === null) && delete ie[Z];
  return ie;
}
let mintedIdCounter = 0;
function mintNewIdFromResource(ie, Z) {
  const ee = encodeURI(ie.id || ie["@id"] || "").trim();
  return ee && Z ? `${ee}/${Z}` : ee || (mintedIdCounter++, `http://example.org/${ie["@type"]}${Z ? `/${Z}` : ""}/${mintedIdCounter}`);
}
function technicalProperties$2(ie) {
  const Z = [...ie.behavior || []];
  ie.viewingHint && Z.push(ie.viewingHint);
  let ee;
  return Array.isArray(ie.motivation) ? ee = ie.motivation.map(removePrefix) : ie.motivation && (ee = removePrefix(ie.motivation)), {
    "@context": ie["@context"] ? fixContext(ie["@context"]) : void 0,
    id: (ie["@id"] || mintNewIdFromResource(ie)).trim(),
    type: getNewType(ie),
    behavior: Z.length ? Z : void 0,
    height: ie.height ? ie.height : void 0,
    width: ie.width ? ie.width : void 0,
    motivation: ee,
    viewingDirection: ie.viewingDirection,
    profile: ie.profile,
    format: ie.format ? ie.format : void 0,
    duration: void 0,
    timeMode: void 0
  };
}
function descriptiveProperties$2(ie) {
  const [Z, ee] = fixLicense(ie.license), ae = [...ie.metadata ? convertMetadata(ie.metadata) : [], ...ee];
  return {
    rights: Z,
    metadata: ae.length ? ae : void 0,
    label: ie.label ? convertLanguageMapping(ie.label) : void 0,
    requiredStatement: ie.attribution ? {
      label: convertLanguageMapping(configuration.attributionLabel),
      value: convertLanguageMapping(ie.attribution)
    } : void 0,
    navDate: ie.navDate,
    summary: ie.description ? convertLanguageMapping(ie.description) : void 0,
    thumbnail: ie.thumbnail
  };
}
function parseWithin(ie) {
  if (!ie.within)
    return;
  const Z = Array.isArray(ie.within) ? ie.within : [ie.within], ee = [];
  for (const ae of Z)
    if (typeof ae == "string") {
      if (ae)
        switch (ie["@type"]) {
          case "sc:Manifest":
            ee.push({ id: ae, type: "Collection" });
            break;
        }
    } else
      ae["@id"] && ee.push({
        id: ae["@id"],
        type: getNewType(ae)
      });
  return ee.length ? ee : void 0;
}
function linkingProperties$2(ie) {
  const Z = ie.related ? Array.isArray(ie.related) ? ie.related : [ie.related] : [], ee = ie.contentLayer;
  return {
    provider: ie.logo || Z.length ? [
      {
        id: configuration.providerId,
        type: "Agent",
        homepage: Z.length ? [Z[0]] : void 0,
        logo: ie.logo ? Array.isArray(ie.logo) ? ie.logo : [ie.logo] : void 0,
        label: convertLanguageMapping(configuration.providerName)
      }
    ] : void 0,
    partOf: parseWithin(ie),
    rendering: ie.rendering,
    seeAlso: ie.seeAlso,
    start: ie.startCanvas,
    service: ie.service ? ensureArray$1(ie.service) : void 0,
    supplementary: ee ? [ee] : void 0
  };
}
function embeddedContentProperties(ie) {
  return {
    chars: ie.chars,
    format: ie.format ? ie.format : void 0,
    language: ie.language
  };
}
function upgradeCollection(ie) {
  return removeUndefinedProperties({
    ...technicalProperties$2(ie),
    ...descriptiveProperties$2(ie),
    ...linkingProperties$2(ie),
    items: ie.members
  });
}
function upgradeManifest(ie) {
  const Z = [], ee = [];
  for (const ve of ie.sequences || [])
    ve.canvases.length && Z.push(...ve.canvases), ve.behavior && ee.push(...ve.behavior);
  const ae = technicalProperties$2(ie);
  return ee.length && (ae.behavior ? ae.behavior.push(...ee) : ae.behavior = ee), removeUndefinedProperties({
    ...ae,
    ...descriptiveProperties$2(ie),
    ...linkingProperties$2(ie),
    items: Z,
    structures: ie.structures
  });
}
function upgradeCanvas(ie) {
  return removeUndefinedProperties({
    ...technicalProperties$2(ie),
    ...descriptiveProperties$2(ie),
    ...linkingProperties$2(ie),
    annotations: ie.otherContent && ie.otherContent.length ? ie.otherContent : void 0,
    items: ie.images && ie.images.length ? [
      {
        id: mintNewIdFromResource(ie, "annotation-page"),
        type: "AnnotationPage",
        items: ie.images
      }
    ] : void 0
  });
}
function upgradeAnnotationList(ie) {
  return removeUndefinedProperties({
    ...technicalProperties$2(ie),
    ...descriptiveProperties$2(ie),
    ...linkingProperties$2(ie),
    items: ie.resources && ie.resources.length ? ie.resources : void 0
  });
}
function upgradeSequence(ie) {
  return !ie.canvases || ie.canvases.length === 0 ? {
    canvases: [],
    behavior: []
  } : {
    canvases: ie.canvases,
    behavior: ie.viewingHint ? [ie.viewingHint] : []
  };
}
function upgradeAnnotation(ie) {
  function Z(ee) {
    if (Array.isArray(ee)) {
      if (ee.length > 1)
        return { type: "List", items: ee.map(Z) };
      ee = ee[0];
    }
    if (typeof ee == "string")
      return encodeURI(ee).trim();
    if ("@type" in ee) {
      let ae;
      if (typeof ee.full == "string")
        ae = ee.full;
      else if (ee.full["@type"] === "dctypes:Image")
        ae = { id: ee.full["@id"], type: "Image" };
      else if (ee.full["@type"] === "sc:Canvas")
        ae = { id: ee.full["@id"], type: "Canvas" };
      else
        throw new Error(`Unsupported source type on annotation: ${ee.full["@type"]}`);
      return {
        type: "SpecificResource",
        source: ae,
        selector: upgradeSelector(ee.selector)
      };
    } else
      return encodeURI(ee["@id"]).trim();
  }
  return removeUndefinedProperties({
    ...technicalProperties$2(ie),
    ...descriptiveProperties$2(ie),
    ...linkingProperties$2(ie),
    target: Z(ie.on),
    body: Array.isArray(ie.resource) ? ie.resource.map(upgradeContentResource) : upgradeContentResource(ie.resource)
  });
}
function upgradeContentResource(ie) {
  const Z = ie;
  return removeUndefinedProperties({
    ...technicalProperties$2(Z),
    ...descriptiveProperties$2(Z),
    ...linkingProperties$2(Z),
    ...embeddedContentProperties(Z)
  });
}
function upgradeChoice(ie) {
  const Z = [];
  return ie.default && ie.default !== "rdf:nil" && Z.push(ie.default), ie.item && ie.item !== "rdf:nil" && Z.push(...ie.item), {
    ...technicalProperties$2(ie),
    ...descriptiveProperties$2(ie),
    items: Z
  };
}
function upgradeRange(ie) {
  return removeUndefinedProperties({
    ...technicalProperties$2(ie),
    ...descriptiveProperties$2(ie),
    ...linkingProperties$2(ie),
    items: ie.members
  });
}
function upgradeService(ie) {
  const { "@id": Z, "@type": ee, "@context": ae, profile: ve, ...ye } = ie, be = {};
  return Z && (be["@id"] = Z), be["@type"] = getNewType(ie), be["@type"] === "unknown" && (ae && ae.length && (be["@context"] = ae), be["@type"] = "Service"), ve && (be.profile = getProfile(ve)), removeUndefinedProperties({
    ...be,
    ...ye
  });
}
function upgradeLayer(ie) {
  return removeUndefinedProperties({
    ...technicalProperties$2(ie),
    ...descriptiveProperties$2(ie),
    ...linkingProperties$2(ie)
  });
}
const presentation2to3 = new Traverse({
  collection: [upgradeCollection],
  manifest: [upgradeManifest],
  canvas: [upgradeCanvas],
  annotationList: [upgradeAnnotationList],
  sequence: [upgradeSequence],
  annotation: [upgradeAnnotation],
  contentResource: [upgradeContentResource],
  choice: [upgradeChoice],
  range: [upgradeRange],
  service: [upgradeService],
  layer: [upgradeLayer]
});
function convertPresentation2(ie) {
  return ie && ie["@context"] && (ie["@context"] === "http://iiif.io/api/presentation/2/context.json" || ie["@context"].indexOf("http://iiif.io/api/presentation/2/context.json") !== -1 || ie["@context"] === "http://www.shared-canvas.org/ns/context.json") || ie["@context"] === "http://iiif.io/api/image/2/context.json" ? presentation2to3.traverseUnknown(ie) : ie;
}
function upgradeSelector(ie) {
  if ((Array.isArray(ie["@type"]) && ie["@type"].includes("oa:SvgSelector") || ie["@type"] == "oa:SvgSelector") && ("chars" in ie || "value" in ie))
    return {
      type: "SvgSelector",
      value: "chars" in ie ? ie.chars : ie.value
    };
  if (ie["@type"] === "oa:FragmentSelector")
    return {
      type: "FragmentSelector",
      value: ie.value
    };
  if (ie["@type"] === "oa:Choice")
    return [
      upgradeSelector(ie.default),
      ...(Array.isArray(ie.item) ? ie.item : [ie.item]).map(
        upgradeSelector
      )
    ];
  if (ie["@type"] == "iiif:ImageApiSelector")
    return {
      type: "ImageApiSelector",
      region: "region" in ie ? ie.region : void 0,
      rotation: "rotation" in ie ? ie.rotation : void 0
    };
  throw new Error(`Unsupported selector type: ${ie["@type"]}`);
}
function getDefaultEntities$1() {
  return {
    Collection: {},
    Manifest: {},
    Canvas: {},
    AnnotationPage: {},
    AnnotationCollection: {},
    Annotation: {},
    ContentResource: {},
    Range: {},
    Service: {},
    Selector: {},
    Agent: {}
  };
}
function getResource(ie, Z) {
  if (typeof ie == "string")
    return { id: ie, type: Z };
  if (!ie.id)
    throw new Error(`Invalid resource does not have an ID (${Z})`);
  return ie;
}
function mapToEntities(ie) {
  return (Z, ee) => {
    const ae = ie[Z] ? ie[Z] : {};
    return (ve) => {
      const ye = getResource(ve, ee || Z);
      return ye && ye.id && Z ? (ae[ye.id] = ae[ye.id] ? mergeEntities(ae[ye.id], ye) : Object.assign({}, ye), {
        id: ye.id,
        type: Z === "ContentResource" ? Z : ye.type
      }) : ye;
    };
  };
}
function merge(ie, Z) {
  if (!Z)
    return ie;
  if (Array.isArray(ie)) {
    if (!Array.isArray(Z))
      throw new Error("Cannot merge array with non-array");
    const ee = [...ie];
    for (const ae of Z)
      if (ae != null)
        if (Array.isArray(ae))
          ee.push(ae);
        else if (typeof ae == "object" && ae.id && ae.type) {
          const ve = ee.findIndex((ye) => ye.id === ae.id && ye.type === ae.type);
          ve >= 0 && (ee[ve] = merge(ee[ve], ae));
        } else
          ie.indexOf(ae) === -1 && ee.push(ae);
    return ee;
  } else if (typeof ie == "object") {
    if (Array.isArray(Z) || typeof Z != "object")
      throw new Error("Cannot merge object with non-object");
    const ee = { ...ie };
    for (const [ae, ve] of Object.entries(Z)) {
      const ye = ee[ae];
      ye === EMPTY || !ye ? ee[ae] = ve : ee[ae] = merge(ye, ve);
    }
    return ee;
  } else if (ie)
    return ie;
  return Z;
}
function mergeEntities(ie, Z) {
  if (typeof ie == "string")
    return ie;
  if (Z.id !== ie.id || Z.type !== ie.type)
    throw new Error("Can only merge entities with identical identifiers and type!");
  return merge({ ...ie }, Z);
}
function recordTypeInMapping(ie) {
  return (Z, ee) => (ae) => {
    const { id: ve, type: ye } = getResource(ae, ee || Z);
    if (typeof ve > "u")
      throw new Error("Found invalid entity without an ID.");
    return Z === "ContentResource" ? ie[ve] = Z : ie[ve] = ye, ae;
  };
}
function hash$1(ie) {
  const Z = JSON.stringify(ie);
  let ee = 5381, ae = Z.length;
  for (; ae; )
    ee = ee * 33 ^ Z.charCodeAt(--ae);
  const ye = (ee >>> 0).toString(16);
  return ye.length % 2 ? "0" + ye : ye;
}
function addMissingIdToContentResource(ie) {
  return (Z) => typeof Z == "string" ? { id: Z, type: ie } : Z.id ? Z.type ? Z : { type: ie, ...Z } : { id: `vault://${hash$1(Z)}`, type: ie, ...Z };
}
function ensureDefaultFields(ie) {
  return (Z) => ({
    ...ie,
    ...Z
  });
}
function ensureArray(ie) {
  return Array.isArray(ie) ? ie : [ie];
}
function ensureArrayOnAnnotation(ie) {
  return ie.body && (ie.body = ensureArray(ie.body)), ie.seeAlso && (ie.seeAlso = ensureArray(ie.seeAlso)), ie.body && (ie.body = ensureArray(ie.body)), ie.audience && (ie.audience = ensureArray(ie.audience)), ie.accessibility && (ie.accessibility = ensureArray(ie.accessibility)), ie.motivation && (ie.motivation = ensureArray(ie.motivation)), ie;
}
function normalize(ie) {
  const Z = convertPresentation2(ie), ee = getDefaultEntities$1(), ae = {}, ve = mapToEntities(ee), ye = recordTypeInMapping(ae), Ye = new Traverse$1({
    collection: [
      ensureDefaultFields(emptyCollection),
      ye("Collection"),
      ve("Collection")
    ],
    manifest: [
      ensureDefaultFields(emptyManifest),
      ye("Manifest"),
      ve("Manifest")
    ],
    canvas: [
      ensureDefaultFields(emptyCanvas),
      ye("Canvas"),
      ve("Canvas")
    ],
    annotationPage: [
      addMissingIdToContentResource("AnnotationPage"),
      ensureDefaultFields(emptyAnnotationPage),
      ye("AnnotationPage"),
      ve("AnnotationPage")
    ],
    annotation: [
      addMissingIdToContentResource("Annotation"),
      ensureArrayOnAnnotation,
      ye("Annotation"),
      ve("Annotation")
    ],
    contentResource: [
      addMissingIdToContentResource("ContentResource"),
      ye("ContentResource"),
      ve("ContentResource")
    ],
    range: [
      ensureDefaultFields(emptyRange),
      ye("Range", "Canvas"),
      ve("Range", "Canvas")
    ],
    agent: [
      ensureDefaultFields(emptyAgent),
      ye("Agent"),
      ve("Agent")
    ]
  }).traverseUnknown(Z);
  return { entities: ee, resource: Ye, mapping: ae };
}
const UNSET = "__$UNSET$__", UNWRAP = "__$UNWRAP$__";
function resolveIfExists$1(ie, Z) {
  const ee = ie.requests[Z], ae = ie.mapping[Z];
  if (!(!ae || ee && ee.resourceUri && !ie.entities[ae][ee.resourceUri]))
    return ie.entities[ae][ee ? ee.resourceUri : Z];
}
function serializedFieldsToObject(ie) {
  const Z = {};
  for (const [ee, ae] of ie) {
    if (ee === UNWRAP && ae !== UNSET)
      return ae;
    ae !== UNSET && typeof ae < "u" && ae !== null && (Z[ee] = ae);
  }
  return Z;
}
function serialize(ie, Z, ee) {
  if (!Z.type || !Z.id)
    throw new Error("Unknown entity");
  if (!ee[Z.type])
    throw new Error(`Serializer not found for ${Z.type}`);
  function ae(ve) {
    const ye = ee[ve.type];
    if (!ye)
      return UNSET;
    const be = resolveIfExists$1(ie, ve.id) || (ve.id && ve.type ? ve : null);
    if (!be)
      return UNSET;
    const Ye = ye(be, ie, { isTopLevel: Z.id === ve.id });
    let Qe = Ye.next();
    for (; !Qe.done; ) {
      const Je = Qe.value;
      let nt = UNSET;
      if (Je)
        if (Array.isArray(Je)) {
          const st = [];
          for (const ot of Je)
            st.push(ae(ot));
          nt = st;
        } else
          nt = ae(Je);
      Qe = Ye.next(nt);
    }
    return Qe.value === UNSET ? UNSET : serializedFieldsToObject(Qe.value);
  }
  return ae(Z);
}
function languageString2to3(ie) {
  if (!ie)
    return;
  const Z = Object.keys(ie);
  if (Z.length !== 0) {
    if (Z.length === 1) {
      const ee = Z[0];
      if (!ee)
        return "";
      const ae = (ie[ee] || []).join("");
      return ee === "@none" || ee === "none" || ee === "en" ? ae : {
        "@language": ee,
        "@value": ae
      };
    }
    return Z.map((ee) => ({
      "@language": ee,
      "@value": (ie[ee] || []).join("")
    }));
  }
}
function parseCanvasTarget(ie) {
  return Array.isArray(ie) ? ie.map((Z) => parseCanvasTarget(Z)) : typeof ie == "string" ? ie : ie.type && ie.type === "Canvas" ? ie.id : ie;
}
function unNestArray(ie, Z = !1) {
  if (ie)
    return ie.length > 1 && !Z ? ie : ie[0] || void 0;
}
function convertService(ie) {
  if (ie) {
    if (typeof ie == "string")
      return {
        "@id": ie
      };
    if ("@id" in ie) {
      const Z = { ...ie };
      return delete Z["@type"], Z;
    }
    return {
      "@context": "http://iiif.io/api/image/2/context.json",
      "@id": ie.id,
      profile: `http://iiif.io/api/image/2/profiles/${ie.profile}.json`
    };
  }
}
function technicalProperties$1(ie, Z) {
  return [
    ["@id", ie.id],
    ["@type", Z],
    ["format", ie.format],
    ["height", ie.height],
    ["width", ie.width],
    ["viewingDirection", ie.viewingDirection !== "left-to-right" ? ie.viewingDirection : void 0]
  ];
}
function* descriptiveProperties$1(ie) {
  const Z = ie.provider ? yield ie.provider[0] : void 0;
  return [
    ["label", languageString2to3(ie.label)],
    [
      "metadata",
      ie.metadata && ie.metadata.length ? ie.metadata.map((ee) => ({
        label: languageString2to3(ee.label) || "",
        value: languageString2to3(ee.value) || ""
      })) : void 0
    ],
    ["description", languageString2to3(ie.summary)],
    ["thumbnail", unNestArray(yield ie.thumbnail)],
    ["navDate", ie.navDate],
    ["logo", Z ? unNestArray(Z.logo) : void 0],
    ["homepage", Z ? Z.homepage : void 0],
    ["attribution", ie.requiredStatement ? languageString2to3(ie.requiredStatement.value) : void 0]
  ];
}
function* linkingProperties$1(ie) {
  return [
    ["seeAlso", unNestArray(yield ie.seeAlso)],
    ["service", unNestArray((ie.service || []).map(convertService))],
    ["rendering", unNestArray(yield ie.rendering)],
    ["startCanvas", ie.start ? ie.start.id : void 0]
  ];
}
const serializeConfigPresentation2 = {
  Manifest: function* (ie) {
    return [
      ...technicalProperties$1(ie, "sc:Manifest"),
      ...yield* descriptiveProperties$1(ie),
      ...yield* linkingProperties$1(ie),
      [
        "sequences",
        [
          {
            "@id": `${ie.id}/sequence0`,
            "@type": "sc:Sequence",
            canvases: yield ie.items
          }
        ]
      ],
      ["structures", yield ie.structures]
    ];
  },
  Canvas: function* (ie) {
    const ee = (yield ie.items)[0];
    return [
      ...technicalProperties$1(ie, "sc:Canvas"),
      ...yield* descriptiveProperties$1(ie),
      ...yield* linkingProperties$1(ie),
      ["images", ee ? [ee.resources] : void 0],
      [
        "annotations",
        ie.annotations && ie.annotations.length ? unNestArray(yield ie.annotations) : void 0
      ]
    ];
  },
  AnnotationPage: function* (ie) {
    return [
      ...technicalProperties$1(ie, "sc:AnnotationList"),
      ...yield* descriptiveProperties$1(ie),
      ["resources", ie.items && ie.items.length ? unNestArray(yield ie.items) : void 0]
    ];
  },
  Annotation: function* (ie) {
    return [
      ["@id", ie.id],
      ["@type", "oa:Annotation"],
      ["motivation", "sc:painting"],
      ["on", parseCanvasTarget(ie.target)],
      ["resource", unNestArray(yield ie.body, !0)]
    ];
  },
  ContentResource: function* (ie) {
    switch (ie.type) {
      case "Image":
        return [
          ...technicalProperties$1(ie, "dctypes:Image"),
          ...yield* descriptiveProperties$1(ie),
          ...yield* linkingProperties$1(ie)
        ];
      case "Text":
      case "Dataset":
      default:
        return [...technicalProperties$1(ie, void 0), ...yield* descriptiveProperties$1(ie)];
    }
  },
  AnnotationCollection: function* (ie) {
    return [
      ["@id", ie.id],
      ["@type", "sc:Layer"],
      ["label", languageString2to3(ie.label)]
    ];
  },
  Collection: function* (ie) {
    return [
      ...technicalProperties$1(ie, "sc:Collection"),
      ...yield* descriptiveProperties$1(ie),
      ...yield* linkingProperties$1(ie),
      ["members", yield* ie.items]
    ];
  },
  Range: function* (ie) {
    const Z = [], ee = [];
    if (ie.items)
      for (const ae of ie.items) {
        const ve = yield ae;
        Z.push({
          "@id": ae.id,
          "@type": ae.type,
          label: ve ? ve.label : void 0,
          within: ie.id
        }), ae.type === "Canvas" && ee.push(ae.id);
      }
    return [
      ...technicalProperties$1(ie, "sc:Range"),
      ...yield* descriptiveProperties$1(ie),
      ...yield* linkingProperties$1(ie),
      ["canvases", ee.length === Z.length ? ee : void 0],
      ["members", ee.length !== Z.length ? Z : void 0]
    ];
  }
};
function technicalProperties(ie) {
  var Z;
  return [
    ["id", (Z = ie.id) != null && Z.startsWith("vault://") ? void 0 : ie.id],
    ["type", ie.type],
    ["format", ie.format],
    ["profile", ie.profile],
    ["height", ie.height],
    ["width", ie.width],
    ["duration", ie.duration || void 0],
    ["viewingDirection", ie.viewingDirection !== "left-to-right" ? ie.viewingDirection : void 0],
    ["behavior", ie.behavior && ie.behavior.length ? ie.behavior : void 0],
    ["timeMode", ie.timeMode],
    ["motivation", Array.isArray(ie.motivation) ? ie.motivation[0] : ie.motivation]
  ];
}
function filterEmpty(ie) {
  if (!(!ie || ie.length === 0))
    return ie;
}
function service2compat(ie) {
  if (ie && ie.type && ie.type === "ImageService2") {
    const { id: Z, type: ee, profile: ae, ...ve } = ie, ye = typeof ae == "string" ? ae : Array.isArray(ae) ? ae.find((be) => typeof be == "string") : "";
    return {
      "@id": Z,
      "@type": ee,
      profile: ye ? ye.startsWith("http") ? ye : `http://iiif.io/api/image/2/${ye}.json` : "http://iiif.io/api/image/2/level0.json",
      ...ve
    };
  }
  return ie;
}
function filterService2Compat(ie) {
  if (!(!ie || ie.length === 0))
    return ie.map(service2compat);
}
function* descriptiveProperties(ie) {
  return [
    ["label", ie.label],
    ["metadata", filterEmpty(ie.metadata)],
    ["summary", ie.summary],
    ["requiredStatement", ie.requiredStatement],
    ["rights", ie.rights],
    ["navDate", ie.navDate],
    ["language", ie.language],
    ["thumbnail", filterEmpty(yield ie.thumbnail)],
    ["placeholderCanvas", yield ie.placeholderCanvas],
    ["accompanyingCanvas", yield ie.accompanyingCanvas],
    ["provider", filterEmpty(yield ie.provider)]
  ];
}
function* linkingProperties(ie) {
  return [
    ["seeAlso", filterEmpty(yield ie.seeAlso)],
    ["service", filterService2Compat(ie.service)],
    ["services", filterService2Compat(ie.services)],
    ["rendering", filterEmpty(yield ie.rendering)],
    ["supplementary", filterEmpty(yield ie.supplementary)],
    ["homepage", filterEmpty(yield ie.homepage)],
    ["logo", filterEmpty(yield ie.logo)],
    ["partOf", filterEmpty(yield ie.partOf)],
    ["start", ie.start]
  ];
}
const serializeConfigPresentation3 = {
  Manifest: function* (ie, Z, { isTopLevel: ee }) {
    return ee ? [
      ["@context", "http://iiif.io/api/presentation/3/context.json"],
      ...technicalProperties(ie),
      ...yield* descriptiveProperties(ie),
      ...yield* linkingProperties(ie),
      ["items", yield ie.items],
      ["structures", filterEmpty(yield ie.structures)],
      ["annotations", filterEmpty(yield ie.annotations)]
    ] : [
      ...technicalProperties(ie),
      ...yield* descriptiveProperties(ie)
    ];
  },
  Canvas: function* (ie) {
    return [
      ...technicalProperties(ie),
      ...yield* descriptiveProperties(ie),
      ...yield* linkingProperties(ie),
      ["items", yield ie.items],
      ["annotations", filterEmpty(yield ie.annotations)]
    ];
  },
  Agent: function* (ie) {
    return [
      ["id", ie.id],
      ["type", "Agent"],
      ["label", ie.label],
      ...yield* linkingProperties(ie)
    ];
  },
  AnnotationPage: function* (ie) {
    return [
      ...Object.entries(ie).map(([ee, ae]) => [ee, Array.isArray(ae) ? filterEmpty(ae) : ae]).filter(([ee, ae]) => ee !== "items"),
      ...yield* linkingProperties(ie),
      ["items", yield ie.items]
    ];
  },
  Service: function* (ie) {
    return [[UNWRAP, service2compat(ie)]];
  },
  Annotation: function* (ie) {
    const Z = Object.entries(ie).map(([ae, ve]) => ae === "motivation" ? [ae, Array.isArray(ve) ? ve[0] : ve] : [ae, Array.isArray(ve) ? filterEmpty(ve) : ve]).filter(([ae]) => ae !== "body"), ee = yield ie.body;
    return [...Z, ["body", ee.length === 1 ? ee[0] : ee]];
  },
  ContentResource: function* (ie) {
    return [
      ...technicalProperties(ie),
      ...yield* descriptiveProperties(ie),
      ...yield* linkingProperties(ie),
      ["annotations", filterEmpty(yield ie.annotations)],
      ["items", filterEmpty(yield ie.items)]
    ];
  },
  AnnotationCollection: function* (ie) {
    return [
      ["id", ie.id],
      ["type", "AnnotationCollection"],
      ["label", ie.label]
    ];
  },
  Collection: function* (ie, Z, { isTopLevel: ee }) {
    return ee ? [
      ["@context", "http://iiif.io/api/presentation/3/context.json"],
      ...technicalProperties(ie),
      ...yield* descriptiveProperties(ie),
      ...yield* linkingProperties(ie),
      ["items", filterEmpty(yield ie.items)]
    ] : [...technicalProperties(ie), ...yield* descriptiveProperties(ie)];
  },
  Range: function* (ie) {
    const Z = [];
    for (const ee of ie.items)
      ee.type === "Range" ? Z.push(yield ee) : Z.push(ee);
    return [
      ...technicalProperties(ie),
      ...yield* descriptiveProperties(ie),
      ...yield* linkingProperties(ie),
      ["items", Z],
      ["annotations", filterEmpty(yield ie.annotations)]
    ];
  }
};
function n$1(ie) {
  return ie == null;
}
function t$1(ie) {
  throw new Error("Argument " + ie + " is empty.");
}
function o$1(ie) {
  return typeof ie == "string" || typeof ie == "symbol";
}
function u$1(ie) {
  return !o$1(ie);
}
function a$1(ie) {
  throw new Error("Argument " + ie + " is invalid, it should be an action type of type: string | symbol");
}
function s$1(ie, Z) {
  return n$1(ie) && t$1(1), u$1(ie) && a$1(1), Object.assign(function() {
    var ee = Z != null ? Z.apply(void 0, arguments) : void 0;
    return Object.assign({ type: ie }, ee);
  }, { getType: function() {
    return ie;
  }, toString: function() {
    return ie;
  } });
}
function y$1(ie, Z, ee) {
  return n$1(ie) && t$1(1), u$1(ie) && a$1(1), function() {
    return s$1(ie, function() {
      var ae = arguments.length <= 0 ? void 0 : arguments[0], ve = arguments.length <= 1 ? void 0 : arguments[1];
      return Z == null && ee == null || (ae = Z != null ? Z.apply(void 0, arguments) : void 0, ve = ee != null ? ee.apply(void 0, arguments) : void 0), Object.assign({}, ae !== void 0 && { payload: ae }, {}, ve !== void 0 && { meta: ve });
    });
  };
}
function _typeof(ie) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Z) {
    return typeof Z;
  } : function(Z) {
    return Z && typeof Symbol == "function" && Z.constructor === Symbol && Z !== Symbol.prototype ? "symbol" : typeof Z;
  }, _typeof(ie);
}
function toPrimitive(ie, Z) {
  if (_typeof(ie) != "object" || !ie)
    return ie;
  var ee = ie[Symbol.toPrimitive];
  if (ee !== void 0) {
    var ae = ee.call(ie, Z || "default");
    if (_typeof(ae) != "object")
      return ae;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (Z === "string" ? String : Number)(ie);
}
function toPropertyKey(ie) {
  var Z = toPrimitive(ie, "string");
  return _typeof(Z) == "symbol" ? Z : String(Z);
}
function _defineProperty$1(ie, Z, ee) {
  return Z = toPropertyKey(Z), Z in ie ? Object.defineProperty(ie, Z, {
    value: ee,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : ie[Z] = ee, ie;
}
function ownKeys$1(ie, Z) {
  var ee = Object.keys(ie);
  if (Object.getOwnPropertySymbols) {
    var ae = Object.getOwnPropertySymbols(ie);
    Z && (ae = ae.filter(function(ve) {
      return Object.getOwnPropertyDescriptor(ie, ve).enumerable;
    })), ee.push.apply(ee, ae);
  }
  return ee;
}
function _objectSpread2$1(ie) {
  for (var Z = 1; Z < arguments.length; Z++) {
    var ee = arguments[Z] != null ? arguments[Z] : {};
    Z % 2 ? ownKeys$1(Object(ee), !0).forEach(function(ae) {
      _defineProperty$1(ie, ae, ee[ae]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ie, Object.getOwnPropertyDescriptors(ee)) : ownKeys$1(Object(ee)).forEach(function(ae) {
      Object.defineProperty(ie, ae, Object.getOwnPropertyDescriptor(ee, ae));
    });
  }
  return ie;
}
function formatProdErrorMessage(ie) {
  return "Minified Redux error #" + ie + "; visit https://redux.js.org/Errors?code=" + ie + " for the full message or use the non-minified dev environment for full errors. ";
}
var $$observable = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), randomString = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
function isPlainObject$3(ie) {
  if (typeof ie != "object" || ie === null)
    return !1;
  for (var Z = ie; Object.getPrototypeOf(Z) !== null; )
    Z = Object.getPrototypeOf(Z);
  return Object.getPrototypeOf(ie) === Z;
}
function miniKindOf(ie) {
  if (ie === void 0)
    return "undefined";
  if (ie === null)
    return "null";
  var Z = typeof ie;
  switch (Z) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return Z;
  }
  if (Array.isArray(ie))
    return "array";
  if (isDate(ie))
    return "date";
  if (isError(ie))
    return "error";
  var ee = ctorName(ie);
  switch (ee) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return ee;
  }
  return Z.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(ie) {
  return typeof ie.constructor == "function" ? ie.constructor.name : null;
}
function isError(ie) {
  return ie instanceof Error || typeof ie.message == "string" && ie.constructor && typeof ie.constructor.stackTraceLimit == "number";
}
function isDate(ie) {
  return ie instanceof Date ? !0 : typeof ie.toDateString == "function" && typeof ie.getDate == "function" && typeof ie.setDate == "function";
}
function kindOf(ie) {
  var Z = typeof ie;
  return process.env.NODE_ENV !== "production" && (Z = miniKindOf(ie)), Z;
}
function createStore$1(ie, Z, ee) {
  var ae;
  if (typeof Z == "function" && typeof ee == "function" || typeof ee == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof Z == "function" && typeof ee > "u" && (ee = Z, Z = void 0), typeof ee < "u") {
    if (typeof ee != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(ee) + "'");
    return ee(createStore$1)(ie, Z);
  }
  if (typeof ie != "function")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(ie) + "'");
  var ve = ie, ye = Z, be = [], Ye = be, Qe = !1;
  function Je() {
    Ye === be && (Ye = be.slice());
  }
  function nt() {
    if (Qe)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return ye;
  }
  function st(gt) {
    if (typeof gt != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(gt) + "'");
    if (Qe)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var ct = !0;
    return Je(), Ye.push(gt), function() {
      if (ct) {
        if (Qe)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        ct = !1, Je();
        var Kr = Ye.indexOf(gt);
        Ye.splice(Kr, 1), be = null;
      }
    };
  }
  function ot(gt) {
    if (!isPlainObject$3(gt))
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(gt) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof gt.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (Qe)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : "Reducers may not dispatch actions.");
    try {
      Qe = !0, ye = ve(ye, gt);
    } finally {
      Qe = !1;
    }
    for (var ct = be = Ye, _r = 0; _r < ct.length; _r++) {
      var Kr = ct[_r];
      Kr();
    }
    return gt;
  }
  function lt(gt) {
    if (typeof gt != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(gt));
    ve = gt, ot({
      type: ActionTypes.REPLACE
    });
  }
  function ft() {
    var gt, ct = st;
    return gt = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(Kr) {
        if (typeof Kr != "object" || Kr === null)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(Kr) + "'");
        function Xr() {
          Kr.next && Kr.next(nt());
        }
        Xr();
        var Jr = ct(Xr);
        return {
          unsubscribe: Jr
        };
      }
    }, gt[$$observable] = function() {
      return this;
    }, gt;
  }
  return ot({
    type: ActionTypes.INIT
  }), ae = {
    dispatch: ot,
    subscribe: st,
    getState: nt,
    replaceReducer: lt
  }, ae[$$observable] = ft, ae;
}
function warning$1(ie) {
  typeof console < "u" && typeof console.error == "function" && console.error(ie);
  try {
    throw new Error(ie);
  } catch {
  }
}
function getUnexpectedStateShapeWarningMessage(ie, Z, ee, ae) {
  var ve = Object.keys(Z), ye = ee && ee.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (ve.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!isPlainObject$3(ie))
    return "The " + ye + ' has unexpected type of "' + kindOf(ie) + '". Expected argument to be an object with the following ' + ('keys: "' + ve.join('", "') + '"');
  var be = Object.keys(ie).filter(function(Ye) {
    return !Z.hasOwnProperty(Ye) && !ae[Ye];
  });
  if (be.forEach(function(Ye) {
    ae[Ye] = !0;
  }), !(ee && ee.type === ActionTypes.REPLACE) && be.length > 0)
    return "Unexpected " + (be.length > 1 ? "keys" : "key") + " " + ('"' + be.join('", "') + '" found in ' + ye + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + ve.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(ie) {
  Object.keys(ie).forEach(function(Z) {
    var ee = ie[Z], ae = ee(void 0, {
      type: ActionTypes.INIT
    });
    if (typeof ae > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(12) : 'The slice reducer for key "' + Z + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof ee(void 0, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(13) : 'The slice reducer for key "' + Z + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + ActionTypes.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function combineReducers(ie) {
  for (var Z = Object.keys(ie), ee = {}, ae = 0; ae < Z.length; ae++) {
    var ve = Z[ae];
    process.env.NODE_ENV !== "production" && typeof ie[ve] > "u" && warning$1('No reducer provided for key "' + ve + '"'), typeof ie[ve] == "function" && (ee[ve] = ie[ve]);
  }
  var ye = Object.keys(ee), be;
  process.env.NODE_ENV !== "production" && (be = {});
  var Ye;
  try {
    assertReducerShape(ee);
  } catch (Qe) {
    Ye = Qe;
  }
  return function(Je, nt) {
    if (Je === void 0 && (Je = {}), Ye)
      throw Ye;
    if (process.env.NODE_ENV !== "production") {
      var st = getUnexpectedStateShapeWarningMessage(Je, ee, nt, be);
      st && warning$1(st);
    }
    for (var ot = !1, lt = {}, ft = 0; ft < ye.length; ft++) {
      var gt = ye[ft], ct = ee[gt], _r = Je[gt], Kr = ct(_r, nt);
      if (typeof Kr > "u") {
        var Xr = nt && nt.type;
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(14) : "When called with an action of type " + (Xr ? '"' + String(Xr) + '"' : "(unknown type)") + ', the slice reducer for key "' + gt + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      lt[gt] = Kr, ot = ot || Kr !== _r;
    }
    return ot = ot || ye.length !== Object.keys(Je).length, ot ? lt : Je;
  };
}
function compose() {
  for (var ie = arguments.length, Z = new Array(ie), ee = 0; ee < ie; ee++)
    Z[ee] = arguments[ee];
  return Z.length === 0 ? function(ae) {
    return ae;
  } : Z.length === 1 ? Z[0] : Z.reduce(function(ae, ve) {
    return function() {
      return ae(ve.apply(void 0, arguments));
    };
  });
}
function applyMiddleware() {
  for (var ie = arguments.length, Z = new Array(ie), ee = 0; ee < ie; ee++)
    Z[ee] = arguments[ee];
  return function(ae) {
    return function() {
      var ve = ae.apply(void 0, arguments), ye = function() {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, be = {
        getState: ve.getState,
        dispatch: function() {
          return ye.apply(void 0, arguments);
        }
      }, Ye = Z.map(function(Qe) {
        return Qe(be);
      });
      return ye = compose.apply(void 0, Ye)(ve.dispatch), _objectSpread2$1(_objectSpread2$1({}, ve), {}, {
        dispatch: ye
      });
    };
  };
}
const IMPORT_ENTITIES = "@iiif/IMPORT_ENTITIES", MODIFY_ENTITY_FIELD = "@iiif/MODIFY_ENTITY_FIELD", REORDER_ENTITY_FIELD = "@iiif/REORDER_ENTITY_FIELD", ADD_REFERENCE = "@iiif/ADD_REFERENCE", REMOVE_REFERENCE = "@iiif/REMOVE_REFERENCE", importEntities = y$1(IMPORT_ENTITIES)(), modifyEntityField = y$1(MODIFY_ENTITY_FIELD)(), reorderEntityField = y$1(REORDER_ENTITY_FIELD)(), addReference = y$1(ADD_REFERENCE)(), removeReference = y$1(REMOVE_REFERENCE)(), entityActions = { importEntities, modifyEntityField, reorderEntityField, addReference, removeReference }, ADD_MAPPING = "@iiif/ADD_MAPPING", ADD_MAPPINGS = "@iiif/ADD_MAPPINGS", addMapping = y$1(ADD_MAPPING)(), addMappings = y$1(ADD_MAPPINGS)(), SET_META_VALUE = "@iiif/SET_META_VALUE", SET_META_VALUE_DYNAMIC = "@iiif/SET_META_VALUE_DYNAMIC", UNSET_META_VALUE = "@iiif/UNSET_META_VALUE", setMetaValue = y$1(SET_META_VALUE)(), setMetaValueDynamic = y$1(SET_META_VALUE_DYNAMIC)(), unsetMetaValue = y$1(UNSET_META_VALUE)(), metaActions = {
  setMetaValue,
  setMetaValueDynamic,
  unsetMetaValue
}, RESOURCE_ERROR = "RESOURCE_ERROR", RESOURCE_LOADING = "RESOURCE_LOADING", RESOURCE_READY = "RESOURCE_READY", REQUEST_RESOURCE = "@iiif/REQUEST_RESOURCE", REQUEST_ERROR = "@iiif/REQUEST_ERROR", REQUEST_MISMATCH = "@iiif/REQUEST_MISMATCH", REQUEST_COMPLETE = "@iiif/REQUEST_COMPLETE", REQUEST_OFFLINE_RESOURCE = "@iiif/REQUEST_OFFLINE_RESOURCE", requestResource = y$1(REQUEST_RESOURCE)(), requestError = y$1(REQUEST_ERROR)(), requestMismatch = y$1(REQUEST_MISMATCH)(), requestComplete = y$1(REQUEST_COMPLETE)();
y$1(REQUEST_OFFLINE_RESOURCE)();
const BATCH_ACTIONS = "@iiif/BATCH", BATCH_IMPORT = "@iiif/BATCH_IMPORT", batchActions = y$1(BATCH_ACTIONS)();
y$1(BATCH_IMPORT)();
const actionListFromResource = (ie, Z) => {
  const { entities: ee, resource: ae, mapping: ve } = normalize(Z);
  if (ae.id === void 0)
    return [requestError({ id: ie, message: "ID is not defined in resource." })];
  const ye = [importEntities({ entities: ee }), addMappings({ mapping: ve })];
  return ae.id !== ie && (ye.push(addMapping({ id: ie, type: ae.type })), ye.push(requestMismatch({ requestId: ie, actualId: ae.id }))), ye.push(requestComplete({ id: ie })), ye;
}, safeIsNaN = Number.isNaN || function(Z) {
  return typeof Z == "number" && Z !== Z;
};
function isEqual(ie, Z) {
  return !!(ie === Z || safeIsNaN(ie) && safeIsNaN(Z));
}
function areInputsEqual(ie, Z) {
  if (!Array.isArray(ie) || !Array.isArray(Z))
    return ie === Z;
  if (ie.length !== Z.length)
    return !1;
  for (let ee = 0; ee < ie.length; ee++)
    if (!isEqual(ie[ee], Z[ee]))
      return !1;
  return !0;
}
function resolveIfExists(ie, Z) {
  const ee = ie.iiif.requests[Z], ae = ie.iiif.mapping[Z];
  if (!(!ae || !ie.iiif.entities[ae][ee.resourceUri]))
    return ie.iiif.entities[ae][ee.resourceUri];
}
function createFetchHelper(ie, Z, { waitTimeout: ee = 30 } = {}) {
  return async (ae, ve) => {
    const ye = ie.getState(), be = ye.iiif.requests[ae];
    if (be)
      switch (be.loadingState) {
        case RESOURCE_ERROR:
          break;
        case RESOURCE_LOADING: {
          let Ye, Qe = !1;
          try {
            const Je = await Promise.race([
              new Promise((nt, st) => {
                Qe || (Ye = ie.subscribe(() => {
                  const ot = ie.getState();
                  if (ot.iiif.requests[ae].loadingState === RESOURCE_ERROR) {
                    st();
                    return;
                  }
                  if (ot.iiif.requests[ae].loadingState === RESOURCE_READY) {
                    const lt = resolveIfExists(ot, ae);
                    lt ? nt(lt) : st();
                  }
                }));
              }),
              new Promise((nt, st) => setTimeout(() => {
                Qe = !0, st();
              }, ee * 60))
            ]);
            if (Ye && Ye(), Je)
              return Je;
          } catch {
            Ye && Ye();
            break;
          }
          break;
        }
        case RESOURCE_READY: {
          const Ye = resolveIfExists(ye, ae);
          if (Ye)
            return Ye;
          break;
        }
      }
    ie.dispatch(requestResource({ id: ae }));
    try {
      const Ye = await Z(ae, ve);
      !Ye.id && !Ye["@id"] && (Ye["@type"] && (Ye["@id"] = ae), Ye.id = ae);
      const Qe = actionListFromResource(ae, Ye);
      return ie.dispatch(batchActions({ actions: Qe })), resolveIfExists(ie.getState(), ae);
    } catch (Ye) {
      throw ie.dispatch(requestError({ id: ae, message: Ye.toString() })), Ye;
    }
  };
}
function getDefaultEntities() {
  return {
    Collection: {},
    Manifest: {},
    Canvas: {},
    AnnotationPage: {},
    AnnotationCollection: {},
    Annotation: {},
    ContentResource: {},
    Range: {},
    Service: {},
    Selector: {},
    Agent: {}
  };
}
const mappingReducer = (ie = {}, Z) => {
  switch (Z.type) {
    case ADD_MAPPING:
      return {
        ...ie,
        [Z.payload.id]: Z.payload.type
      };
    case ADD_MAPPINGS:
      return {
        ...ie,
        ...Z.payload.mapping
      };
    default:
      return ie;
  }
};
function isReferenceList(ie, Z, ee, ae) {
  return !(!ie[ee] || !ie[ee][Z] || !ie[ee][Z][ae] || !Array.isArray(ie[ee][Z][ae]));
}
function quickMerge(ie, Z) {
  const ee = {}, ae = [];
  for (const [ve, ye] of Object.entries(ie || {})) {
    ae.push(ve);
    const be = (Z || {})[ve];
    if (!be || be.length === 0) {
      ee[ve] = ye;
      continue;
    }
    ee[ve] = be;
  }
  for (const [ve, ye] of Object.entries(Z || {}))
    ae.indexOf(ve) === -1 && (ee[ve] = ye);
  return ee;
}
const entitiesReducer = (ie = getDefaultEntities(), Z) => {
  var ee;
  switch (Z.type) {
    case MODIFY_ENTITY_FIELD: {
      if (!ie[Z.payload.type] || !ie[Z.payload.type][Z.payload.id])
        return ie;
      const ae = ie[Z.payload.type][Z.payload.id];
      return typeof ae == "string" ? ie : {
        ...ie,
        [Z.payload.type]: {
          ...ie[Z.payload.type],
          [Z.payload.id]: {
            ...ae,
            [Z.payload.key]: Z.payload.value
          }
        }
      };
    }
    case REORDER_ENTITY_FIELD: {
      if (!isReferenceList(ie, Z.payload.id, Z.payload.type, Z.payload.key))
        return ie;
      const ae = ie[Z.payload.type][Z.payload.id];
      if (typeof ae == "string")
        return ie;
      const ve = Array.from(ae[Z.payload.key]), [ye] = ve.splice(Z.payload.startIndex, 1);
      return ve.splice(Z.payload.endIndex, 0, ye), {
        ...ie,
        [Z.payload.type]: {
          ...ie[Z.payload.type],
          [Z.payload.id]: {
            ...ae,
            [Z.payload.key]: ve
          }
        }
      };
    }
    case IMPORT_ENTITIES: {
      const ae = Object.keys(Z.payload.entities), ve = { ...ie };
      for (const ye of ae) {
        const be = Z.payload.entities[ye], Ye = { ...ie[ye] || {} };
        let Qe = !1;
        const Je = Object.keys(be || {}) || [];
        if (be && Je) {
          for (const nt of Je)
            Qe = !0, Ye[nt] = ie[ye][nt] ? quickMerge(ie[ye][nt], be[nt]) : be[nt];
          Qe && (ve[ye] = Ye);
        }
      }
      return ve;
    }
    case ADD_REFERENCE: {
      if (!isReferenceList(ie, Z.payload.id, Z.payload.type, Z.payload.key))
        return ie;
      const ae = ie[Z.payload.type][Z.payload.id], ve = Array.from(ae[Z.payload.key]);
      return ve.splice(Z.payload.index || ve.length + 1, 0, Z.payload.reference), {
        ...ie,
        [Z.payload.type]: {
          ...ie[Z.payload.type],
          [Z.payload.id]: {
            ...ae,
            [Z.payload.key]: ve
          }
        }
      };
    }
    case REMOVE_REFERENCE: {
      if (!isReferenceList(ie, Z.payload.id, Z.payload.type, Z.payload.key))
        return ie;
      const ae = ie[Z.payload.type][Z.payload.id], ve = Array.from(ae[Z.payload.key]), ye = Z.payload.index || ve.findIndex((be) => be && be.id === Z.payload.reference.id);
      return ye === -1 || ((ee = ve[ye]) == null ? void 0 : ee.id) !== Z.payload.reference.id ? ie : (ve.splice(ye, 1), {
        ...ie,
        [Z.payload.type]: {
          ...ie[Z.payload.type],
          [Z.payload.id]: {
            ...ae,
            [Z.payload.key]: ve
          }
        }
      });
    }
    default:
      return ie;
  }
}, requestReducer = (ie = {}, Z) => {
  switch (Z.type) {
    case REQUEST_RESOURCE:
    case REQUEST_OFFLINE_RESOURCE:
      return {
        ...ie,
        [Z.payload.id]: {
          requestUri: Z.payload.id,
          loadingState: RESOURCE_LOADING,
          uriMismatch: !1,
          resourceUri: Z.payload.id
        }
      };
    case REQUEST_MISMATCH:
      return {
        ...ie,
        [Z.payload.requestId]: {
          ...ie[Z.payload.requestId] || {},
          uriMismatch: !0,
          resourceUri: Z.payload.actualId
        },
        [Z.payload.actualId]: {
          requestUri: Z.payload.requestId,
          loadingState: ie[Z.payload.requestId].loadingState,
          uriMismatch: !0,
          resourceUri: Z.payload.actualId
        }
      };
    case REQUEST_ERROR:
      return {
        ...ie,
        [Z.payload.id]: {
          ...ie[Z.payload.id] || {},
          loadingState: RESOURCE_ERROR,
          error: Z.payload.message
        }
      };
    case REQUEST_COMPLETE:
      return {
        ...ie,
        [Z.payload.id]: {
          ...ie[Z.payload.id] || {},
          loadingState: RESOURCE_READY,
          error: void 0
        }
      };
  }
  return ie;
}, metaReducer = (ie = {}, Z) => {
  const { id: ee, updateValue: ae, value: ve, meta: ye, key: be } = Z && Z.payload || {};
  switch (Z.type) {
    case SET_META_VALUE:
      return {
        ...ie,
        [ee]: {
          ...ie[ee] || {},
          [ye]: {
            ...ie[ee] ? ie[ee][ye] || {} : {},
            [be]: ve
          }
        }
      };
    case SET_META_VALUE_DYNAMIC:
      return {
        ...ie,
        [ee]: {
          ...ie[ee] || {},
          [ye]: {
            ...ie[ee] ? ie[ee][ye] || {} : {},
            [be]: ie[ee] && ie[ee][ye] ? ae(ie[ee][ye][be]) : ae(void 0)
          }
        }
      };
    case UNSET_META_VALUE:
      return ie[ee] && ie[ee][ye] && ie[ee][ye][be] ? {
        ...ie,
        [ee]: {
          ...ie[ee] || {},
          [ye]: {
            ...ie[ee] ? ie[ee][ye] || {} : {},
            [be]: void 0
          }
        }
      } : ie;
    default:
      return ie;
  }
};
function createBatchReducer(ie) {
  return (Z, ee) => ee && ee.type === BATCH_ACTIONS ? ee.payload.actions.reduce(ie, Z) : ee && ee.type === BATCH_IMPORT ? ee.payload.state : ie(Z, ee);
}
const reducers = combineReducers({
  mapping: mappingReducer,
  entities: entitiesReducer,
  requests: requestReducer,
  meta: metaReducer
}), composeEnhancers = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
function createStore(ie = {}) {
  const {
    enableDevtools: Z = !0,
    iiifStoreName: ee = "iiif",
    defaultState: ae = {},
    extraMiddleware: ve = [],
    customReducers: ye = {}
  } = ie, be = combineReducers({ [ee]: reducers, ...ye });
  return createStore$1(createBatchReducer(be), ae, Z ? composeEnhancers(applyMiddleware(...ve)) : compose(applyMiddleware(...ve)));
}
function mitt(ie) {
  return { all: ie = ie || /* @__PURE__ */ new Map(), on: function(Z, ee) {
    var ae = ie.get(Z);
    ae ? ae.push(ee) : ie.set(Z, [ee]);
  }, off: function(Z, ee) {
    var ae = ie.get(Z);
    ae && (ee ? ae.splice(ae.indexOf(ee) >>> 0, 1) : ie.set(Z, []));
  }, emit: function(Z, ee) {
    var ae = ie.get(Z);
    ae && ae.slice().map(function(ve) {
      ve(ee);
    }), (ae = ie.get("*")) && ae.slice().map(function(ve) {
      ve(Z, ee);
    });
  } };
}
class Vault {
  constructor(Z, ee) {
    Sc(this, "options");
    Sc(this, "store");
    Sc(this, "emitter");
    Sc(this, "isBatching", !1);
    Sc(this, "batchQueue", []);
    Sc(this, "remoteFetcher");
    Sc(this, "staticFetcher");
    Sc(this, "defaultFetcher", (Z) => fetch(Z).then((ee) => ee.json()));
    Sc(this, "middleware", (Z) => (ee) => (ae) => {
      if (ae.type === BATCH_ACTIONS) {
        for (const be of ae.payload.actions)
          this.emitter.emit(be.type, { realAction: be, state: Z.getState() });
        const ye = ee(ae);
        for (const be of ae.payload.actions)
          this.emitter.emit(`after:${ae.type}`, { action: ae, state: ye });
        return ye;
      }
      this.emitter.emit(ae.type, { action: ae, state: Z.getState() });
      const ve = ee(ae);
      return this.emitter.emit(`after:${ae.type}`, { action: ae, state: ve }), ve;
    });
    this.options = Object.assign({
      reducers: {},
      middleware: [],
      defaultState: {},
      customFetcher: this.defaultFetcher,
      enableDevtools: !0
    }, Z || {}), this.store = ee || createStore({
      customReducers: this.options.reducers,
      extraMiddleware: [...this.options.middleware, this.middleware],
      defaultState: this.options.defaultState,
      enableDevtools: this.options.enableDevtools
    }), this.emitter = mitt(), this.remoteFetcher = createFetchHelper(this.store, this.options.customFetcher), this.staticFetcher = createFetchHelper(this.store, (ae, ve) => ve);
  }
  batch(Z) {
    this.isBatching = !0;
    try {
      Z(this), this.store.dispatch(batchActions({ actions: this.batchQueue }));
    } catch (ee) {
      throw this.batchQueue = [], this.isBatching = !1, ee;
    }
    this.batchQueue = [], this.isBatching = !1;
  }
  async asyncBatch(Z) {
    this.isBatching = !0;
    try {
      await Z(this), this.store.dispatch(batchActions({ actions: this.batchQueue }));
    } catch (ee) {
      throw this.batchQueue = [], this.isBatching = !1, ee;
    }
    this.batchQueue = [], this.isBatching = !1;
  }
  modifyEntityField(Z, ee, ae) {
    this.dispatch(entityActions.modifyEntityField({
      id: Z.id,
      type: Z.type,
      key: ee,
      value: ae
    }));
  }
  dispatch(Z) {
    this.isBatching ? this.batchQueue.push(Z) : this.store.dispatch(Z);
  }
  serialize(Z, ee) {
    return serialize(this.getState().iiif, Z, ee);
  }
  toPresentation2(Z) {
    return this.serialize(Z, serializeConfigPresentation2);
  }
  toPresentation3(Z) {
    return this.serialize(Z, serializeConfigPresentation3);
  }
  hydrate(Z, ee) {
    return this.get(Z, ee, { skipSelfReturn: !1 });
  }
  get(Z, ee, ae = {}) {
    typeof ee != "string" && (ae = ee || {}, ee = void 0);
    const { skipSelfReturn: ve = !0 } = ae || {};
    if (Array.isArray(Z))
      return Z.map((Je) => this.get(Je, ae));
    const ye = this.getState();
    if (typeof Z == "string") {
      const Je = ee || ye.iiif.mapping[Z];
      if (!Je)
        return ve ? null : { id: Z, type: "unknown" };
      Z = { id: Z, type: Je };
    }
    const be = ee || Z.type, Ye = Z.id, Qe = ye.iiif.entities[be];
    if (!Qe) {
      const Je = ye.iiif.requests[Ye];
      return Je && Je.resourceUri !== Ye ? this.get(Je.resourceUri, ae) : ve ? null : Z;
    }
    return Qe[Z.id] || (ve ? null : Z);
  }
  select(Z) {
    return Z(this.getState());
  }
  getStore() {
    return this.store;
  }
  getState() {
    return this.store.getState();
  }
  loadManifest(Z, ee) {
    const ae = typeof Z == "string" ? Z : Z.id;
    return this.load(ae, ee);
  }
  loadCollection(Z, ee) {
    const ae = typeof Z == "string" ? Z : Z.id;
    return this.load(ae, ee);
  }
  load(Z, ee) {
    const ae = typeof Z == "string" ? Z : Z.id;
    return ee ? this.staticFetcher(ae, ee) : this.remoteFetcher(ae);
  }
  areInputsEqual(Z, ee) {
    return areInputsEqual(Z, ee);
  }
  subscribe(Z, ee, ae) {
    typeof ae > "u" && (typeof ee > "u" || ee === !1 || ee === !0) && (ae = ee, ee = Z, Z = (ye) => ye);
    let ve = ae ? null : Z(this.store.getState());
    return ae || ee(ve, this), this.store.subscribe(() => {
      const ye = this.store.getState(), be = Z(ye);
      ve !== be && !areInputsEqual(ve, be) && ee(be, this), ve = be;
    });
  }
  async ensureLoaded(Z) {
    const ee = typeof Z == "string" ? Z : Z.id;
    this.requestStatus(ee) || await this.load(ee);
  }
  requestStatus(Z) {
    return this.select((ee) => ee.iiif.requests[Z]);
  }
  getResourceMeta(Z, ee) {
    const ae = this.getState().iiif.meta[Z];
    if (ae)
      return ee ? ae[ee] : ae;
  }
  setMetaValue([Z, ee, ae], ve) {
    this.dispatch(typeof ve == "function" ? metaActions.setMetaValueDynamic({
      id: Z,
      meta: ee,
      key: ae,
      updateValue: ve
    }) : metaActions.setMetaValue({
      id: Z,
      meta: ee,
      key: ae,
      value: ve
    }));
  }
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(ie) {
    for (var Z = 1; Z < arguments.length; Z++) {
      var ee = arguments[Z];
      for (var ae in ee)
        Object.prototype.hasOwnProperty.call(ee, ae) && (ie[ae] = ee[ae]);
    }
    return ie;
  }, _extends$1.apply(this, arguments);
}
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie, Z, { checkForDefaultPrevented: ee = !0 } = {}) {
  return function(ve) {
    if (ie == null || ie(ve), ee === !1 || !ve.defaultPrevented)
      return Z == null ? void 0 : Z(ve);
  };
}
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(ie, Z = []) {
  let ee = [];
  function ae(ye, be) {
    const Ye = /* @__PURE__ */ reactExports.createContext(be), Qe = ee.length;
    ee = [
      ...ee,
      be
    ];
    function Je(st) {
      const { scope: ot, children: lt, ...ft } = st, gt = (ot == null ? void 0 : ot[ie][Qe]) || Ye, ct = reactExports.useMemo(
        () => ft,
        Object.values(ft)
      );
      return /* @__PURE__ */ reactExports.createElement(gt.Provider, {
        value: ct
      }, lt);
    }
    function nt(st, ot) {
      const lt = (ot == null ? void 0 : ot[ie][Qe]) || Ye, ft = reactExports.useContext(lt);
      if (ft)
        return ft;
      if (be !== void 0)
        return be;
      throw new Error(`\`${st}\` must be used within \`${ye}\``);
    }
    return Je.displayName = ye + "Provider", [
      Je,
      nt
    ];
  }
  const ve = () => {
    const ye = ee.map((be) => /* @__PURE__ */ reactExports.createContext(be));
    return function(Ye) {
      const Qe = (Ye == null ? void 0 : Ye[ie]) || ye;
      return reactExports.useMemo(
        () => ({
          [`__scope${ie}`]: {
            ...Ye,
            [ie]: Qe
          }
        }),
        [
          Ye,
          Qe
        ]
      );
    };
  };
  return ve.scopeName = ie, [
    ae,
    $c512c27ab02ef895$var$composeContextScopes(ve, ...Z)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes(...ie) {
  const Z = ie[0];
  if (ie.length === 1)
    return Z;
  const ee = () => {
    const ae = ie.map(
      (ve) => ({
        useScope: ve(),
        scopeName: ve.scopeName
      })
    );
    return function(ye) {
      const be = ae.reduce((Ye, { useScope: Qe, scopeName: Je }) => {
        const st = Qe(ye)[`__scope${Je}`];
        return {
          ...Ye,
          ...st
        };
      }, {});
      return reactExports.useMemo(
        () => ({
          [`__scope${Z.scopeName}`]: be
        }),
        [
          be
        ]
      );
    };
  };
  return ee.scopeName = Z.scopeName, ee;
}
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(ie) {
  const Z = reactExports.useRef(ie);
  return reactExports.useEffect(() => {
    Z.current = ie;
  }), reactExports.useMemo(
    () => (...ee) => {
      var ae;
      return (ae = Z.current) === null || ae === void 0 ? void 0 : ae.call(Z, ...ee);
    },
    []
  );
}
function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop: ie, defaultProp: Z, onChange: ee = () => {
} }) {
  const [ae, ve] = $71cd76cc60e0454e$var$useUncontrolledState({
    defaultProp: Z,
    onChange: ee
  }), ye = ie !== void 0, be = ye ? ie : ae, Ye = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(ee), Qe = reactExports.useCallback((Je) => {
    if (ye) {
      const st = typeof Je == "function" ? Je(ie) : Je;
      st !== ie && Ye(st);
    } else
      ve(Je);
  }, [
    ye,
    ie,
    ve,
    Ye
  ]);
  return [
    be,
    Qe
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: ie, onChange: Z }) {
  const ee = reactExports.useState(ie), [ae] = ee, ve = reactExports.useRef(ae), ye = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(Z);
  return reactExports.useEffect(() => {
    ve.current !== ae && (ye(ae), ve.current = ae);
  }, [
    ae,
    ve,
    ye
  ]), ee;
}
const $9f79659886946c16$export$e5c5a5f917a5871c = globalThis != null && globalThis.document ? reactExports.useLayoutEffect : () => {
};
function $6ed0406888f73fc4$var$setRef(ie, Z) {
  typeof ie == "function" ? ie(Z) : ie != null && (ie.current = Z);
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...ie) {
  return (Z) => ie.forEach(
    (ee) => $6ed0406888f73fc4$var$setRef(ee, Z)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...ie) {
  return reactExports.useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...ie), ie);
}
const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { children: ee, ...ae } = ie, ve = reactExports.Children.toArray(ee), ye = ve.find($5e63c961fc1ce211$var$isSlottable);
  if (ye) {
    const be = ye.props.children, Ye = ve.map((Qe) => Qe === ye ? reactExports.Children.count(be) > 1 ? reactExports.Children.only(null) : /* @__PURE__ */ reactExports.isValidElement(be) ? be.props.children : null : Qe);
    return /* @__PURE__ */ reactExports.createElement($5e63c961fc1ce211$var$SlotClone, _extends$1({}, ae, {
      ref: Z
    }), /* @__PURE__ */ reactExports.isValidElement(be) ? /* @__PURE__ */ reactExports.cloneElement(be, void 0, Ye) : null);
  }
  return /* @__PURE__ */ reactExports.createElement($5e63c961fc1ce211$var$SlotClone, _extends$1({}, ae, {
    ref: Z
  }), ee);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { children: ee, ...ae } = ie;
  return /* @__PURE__ */ reactExports.isValidElement(ee) ? /* @__PURE__ */ reactExports.cloneElement(ee, {
    ...$5e63c961fc1ce211$var$mergeProps(ae, ee.props),
    ref: Z ? $6ed0406888f73fc4$export$43e446d32b3d21af(Z, ee.ref) : ee.ref
  }) : reactExports.Children.count(ee) > 1 ? reactExports.Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: ie }) => /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, ie);
function $5e63c961fc1ce211$var$isSlottable(ie) {
  return /* @__PURE__ */ reactExports.isValidElement(ie) && ie.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(ie, Z) {
  const ee = {
    ...Z
  };
  for (const ae in Z) {
    const ve = ie[ae], ye = Z[ae];
    /^on[A-Z]/.test(ae) ? ve && ye ? ee[ae] = (...Ye) => {
      ye(...Ye), ve(...Ye);
    } : ve && (ee[ae] = ve) : ae === "style" ? ee[ae] = {
      ...ve,
      ...ye
    } : ae === "className" && (ee[ae] = [
      ve,
      ye
    ].filter(Boolean).join(" "));
  }
  return {
    ...ie,
    ...ee
  };
}
const $8927f6f2acc4f386$var$NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((ie, Z) => {
  const ee = /* @__PURE__ */ reactExports.forwardRef((ae, ve) => {
    const { asChild: ye, ...be } = ae, Ye = ye ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : Z;
    return reactExports.useEffect(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ reactExports.createElement(Ye, _extends$1({}, be, {
      ref: ve
    }));
  });
  return ee.displayName = `Primitive.${Z}`, {
    ...ie,
    [Z]: ee
  };
}, {});
function $8927f6f2acc4f386$export$6d1a0317bde7de7f(ie, Z) {
  ie && reactDomExports.flushSync(
    () => ie.dispatchEvent(Z)
  );
}
function $fe963b355347cc68$export$3e6543de14f8614f(ie, Z) {
  return reactExports.useReducer((ee, ae) => {
    const ve = Z[ee][ae];
    return ve ?? ee;
  }, ie);
}
const $921a889cee6df7e8$export$99c2b779aa4e8b8b = (ie) => {
  const { present: Z, children: ee } = ie, ae = $921a889cee6df7e8$var$usePresence(Z), ve = typeof ee == "function" ? ee({
    present: ae.isPresent
  }) : reactExports.Children.only(ee), ye = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(ae.ref, ve.ref);
  return typeof ee == "function" || ae.isPresent ? /* @__PURE__ */ reactExports.cloneElement(ve, {
    ref: ye
  }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = "Presence";
function $921a889cee6df7e8$var$usePresence(ie) {
  const [Z, ee] = reactExports.useState(), ae = reactExports.useRef({}), ve = reactExports.useRef(ie), ye = reactExports.useRef("none"), be = ie ? "mounted" : "unmounted", [Ye, Qe] = $fe963b355347cc68$export$3e6543de14f8614f(be, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return reactExports.useEffect(() => {
    const Je = $921a889cee6df7e8$var$getAnimationName(ae.current);
    ye.current = Ye === "mounted" ? Je : "none";
  }, [
    Ye
  ]), $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    const Je = ae.current, nt = ve.current;
    if (nt !== ie) {
      const ot = ye.current, lt = $921a889cee6df7e8$var$getAnimationName(Je);
      ie ? Qe("MOUNT") : lt === "none" || (Je == null ? void 0 : Je.display) === "none" ? Qe("UNMOUNT") : Qe(nt && ot !== lt ? "ANIMATION_OUT" : "UNMOUNT"), ve.current = ie;
    }
  }, [
    ie,
    Qe
  ]), $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (Z) {
      const Je = (st) => {
        const lt = $921a889cee6df7e8$var$getAnimationName(ae.current).includes(st.animationName);
        st.target === Z && lt && reactDomExports.flushSync(
          () => Qe("ANIMATION_END")
        );
      }, nt = (st) => {
        st.target === Z && (ye.current = $921a889cee6df7e8$var$getAnimationName(ae.current));
      };
      return Z.addEventListener("animationstart", nt), Z.addEventListener("animationcancel", Je), Z.addEventListener("animationend", Je), () => {
        Z.removeEventListener("animationstart", nt), Z.removeEventListener("animationcancel", Je), Z.removeEventListener("animationend", Je);
      };
    } else
      Qe("ANIMATION_END");
  }, [
    Z,
    Qe
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(Ye),
    ref: reactExports.useCallback((Je) => {
      Je && (ae.current = getComputedStyle(Je)), ee(Je);
    }, [])
  };
}
function $921a889cee6df7e8$var$getAnimationName(ie) {
  return (ie == null ? void 0 : ie.animationName) || "none";
}
const $1746a345f3d73bb7$var$useReactId = $2AODx$react.useId || (() => {
});
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(ie) {
  const [Z, ee] = reactExports.useState($1746a345f3d73bb7$var$useReactId());
  return $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    ie || ee(
      (ae) => ae ?? String($1746a345f3d73bb7$var$count++)
    );
  }, [
    ie
  ]), ie || (Z ? `radix-${Z}` : "");
}
const $409067139f391064$var$COLLAPSIBLE_NAME = "Collapsible", [$409067139f391064$var$createCollapsibleContext, $409067139f391064$export$952b32dcbe73087a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($409067139f391064$var$COLLAPSIBLE_NAME), [$409067139f391064$var$CollapsibleProvider, $409067139f391064$var$useCollapsibleContext] = $409067139f391064$var$createCollapsibleContext($409067139f391064$var$COLLAPSIBLE_NAME), $409067139f391064$export$6eb0f7ddcda6131f = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeCollapsible: ee, open: ae, defaultOpen: ve, disabled: ye, onOpenChange: be, ...Ye } = ie, [Qe = !1, Je] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: ae,
    defaultProp: ve,
    onChange: be
  });
  return /* @__PURE__ */ reactExports.createElement($409067139f391064$var$CollapsibleProvider, {
    scope: ee,
    disabled: ye,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    open: Qe,
    onOpenToggle: reactExports.useCallback(
      () => Je(
        (nt) => !nt
      ),
      [
        Je
      ]
    )
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    "data-state": $409067139f391064$var$getState(Qe),
    "data-disabled": ye ? "" : void 0
  }, Ye, {
    ref: Z
  })));
}), $409067139f391064$var$TRIGGER_NAME = "CollapsibleTrigger", $409067139f391064$export$c135dce7b15bbbdc = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeCollapsible: ee, ...ae } = ie, ve = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$TRIGGER_NAME, ee);
  return /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button",
    "aria-controls": ve.contentId,
    "aria-expanded": ve.open || !1,
    "data-state": $409067139f391064$var$getState(ve.open),
    "data-disabled": ve.disabled ? "" : void 0,
    disabled: ve.disabled
  }, ae, {
    ref: Z,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onClick, ve.onOpenToggle)
  }));
}), $409067139f391064$var$CONTENT_NAME = "CollapsibleContent", $409067139f391064$export$aadde00976f34151 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { forceMount: ee, ...ae } = ie, ve = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, ie.__scopeCollapsible);
  return /* @__PURE__ */ reactExports.createElement(
    $921a889cee6df7e8$export$99c2b779aa4e8b8b,
    {
      present: ee || ve.open
    },
    ({ present: ye }) => /* @__PURE__ */ reactExports.createElement($409067139f391064$var$CollapsibleContentImpl, _extends$1({}, ae, {
      ref: Z,
      present: ye
    }))
  );
}), $409067139f391064$var$CollapsibleContentImpl = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeCollapsible: ee, present: ae, children: ve, ...ye } = ie, be = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, ee), [Ye, Qe] = reactExports.useState(ae), Je = reactExports.useRef(null), nt = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, Je), st = reactExports.useRef(0), ot = st.current, lt = reactExports.useRef(0), ft = lt.current, gt = be.open || Ye, ct = reactExports.useRef(gt), _r = reactExports.useRef();
  return reactExports.useEffect(() => {
    const Kr = requestAnimationFrame(
      () => ct.current = !1
    );
    return () => cancelAnimationFrame(Kr);
  }, []), $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    const Kr = Je.current;
    if (Kr) {
      _r.current = _r.current || {
        transitionDuration: Kr.style.transitionDuration,
        animationName: Kr.style.animationName
      }, Kr.style.transitionDuration = "0s", Kr.style.animationName = "none";
      const Xr = Kr.getBoundingClientRect();
      st.current = Xr.height, lt.current = Xr.width, ct.current || (Kr.style.transitionDuration = _r.current.transitionDuration, Kr.style.animationName = _r.current.animationName), Qe(ae);
    }
  }, [
    be.open,
    ae
  ]), /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    "data-state": $409067139f391064$var$getState(be.open),
    "data-disabled": be.disabled ? "" : void 0,
    id: be.contentId,
    hidden: !gt
  }, ye, {
    ref: nt,
    style: {
      "--radix-collapsible-content-height": ot ? `${ot}px` : void 0,
      "--radix-collapsible-content-width": ft ? `${ft}px` : void 0,
      ...ie.style
    }
  }), gt && ve);
});
function $409067139f391064$var$getState(ie) {
  return ie ? "open" : "closed";
}
const $409067139f391064$export$be92b6f5f03c0fe9 = $409067139f391064$export$6eb0f7ddcda6131f, $409067139f391064$export$41fb9f06171c75f4 = $409067139f391064$export$c135dce7b15bbbdc, $409067139f391064$export$7c6e2c02157bb7d2 = $409067139f391064$export$aadde00976f34151, ErrorBoundaryContext = reactExports.createContext(null), initialState = {
  didCatch: !1,
  error: null
};
class ErrorBoundary extends reactExports.Component {
  constructor(Z) {
    super(Z), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = initialState;
  }
  static getDerivedStateFromError(Z) {
    return {
      didCatch: !0,
      error: Z
    };
  }
  resetErrorBoundary() {
    const {
      error: Z
    } = this.state;
    if (Z !== null) {
      for (var ee, ae, ve = arguments.length, ye = new Array(ve), be = 0; be < ve; be++)
        ye[be] = arguments[be];
      (ee = (ae = this.props).onReset) === null || ee === void 0 || ee.call(ae, {
        args: ye,
        reason: "imperative-api"
      }), this.setState(initialState);
    }
  }
  componentDidCatch(Z, ee) {
    var ae, ve;
    (ae = (ve = this.props).onError) === null || ae === void 0 || ae.call(ve, Z, ee);
  }
  componentDidUpdate(Z, ee) {
    const {
      didCatch: ae
    } = this.state, {
      resetKeys: ve
    } = this.props;
    if (ae && ee.error !== null && hasArrayChanged(Z.resetKeys, ve)) {
      var ye, be;
      (ye = (be = this.props).onReset) === null || ye === void 0 || ye.call(be, {
        next: ve,
        prev: Z.resetKeys,
        reason: "keys"
      }), this.setState(initialState);
    }
  }
  render() {
    const {
      children: Z,
      fallbackRender: ee,
      FallbackComponent: ae,
      fallback: ve
    } = this.props, {
      didCatch: ye,
      error: be
    } = this.state;
    let Ye = Z;
    if (ye) {
      const Qe = {
        error: be,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof ee == "function")
        Ye = ee(Qe);
      else if (ae)
        Ye = reactExports.createElement(ae, Qe);
      else if (ve === null || reactExports.isValidElement(ve))
        Ye = ve;
      else
        throw be;
    }
    return reactExports.createElement(ErrorBoundaryContext.Provider, {
      value: {
        didCatch: ye,
        error: be,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, Ye);
  }
}
function hasArrayChanged() {
  let ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], Z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return ie.length !== Z.length || ie.some((ee, ae) => !Object.is(ee, Z[ae]));
}
var e = "colors", t = "sizes", r = "space", n = { gap: r, gridGap: r, columnGap: r, gridColumnGap: r, rowGap: r, gridRowGap: r, inset: r, insetBlock: r, insetBlockEnd: r, insetBlockStart: r, insetInline: r, insetInlineEnd: r, insetInlineStart: r, margin: r, marginTop: r, marginRight: r, marginBottom: r, marginLeft: r, marginBlock: r, marginBlockEnd: r, marginBlockStart: r, marginInline: r, marginInlineEnd: r, marginInlineStart: r, padding: r, paddingTop: r, paddingRight: r, paddingBottom: r, paddingLeft: r, paddingBlock: r, paddingBlockEnd: r, paddingBlockStart: r, paddingInline: r, paddingInlineEnd: r, paddingInlineStart: r, top: r, right: r, bottom: r, left: r, scrollMargin: r, scrollMarginTop: r, scrollMarginRight: r, scrollMarginBottom: r, scrollMarginLeft: r, scrollMarginX: r, scrollMarginY: r, scrollMarginBlock: r, scrollMarginBlockEnd: r, scrollMarginBlockStart: r, scrollMarginInline: r, scrollMarginInlineEnd: r, scrollMarginInlineStart: r, scrollPadding: r, scrollPaddingTop: r, scrollPaddingRight: r, scrollPaddingBottom: r, scrollPaddingLeft: r, scrollPaddingX: r, scrollPaddingY: r, scrollPaddingBlock: r, scrollPaddingBlockEnd: r, scrollPaddingBlockStart: r, scrollPaddingInline: r, scrollPaddingInlineEnd: r, scrollPaddingInlineStart: r, fontSize: "fontSizes", background: e, backgroundColor: e, backgroundImage: e, borderImage: e, border: e, borderBlock: e, borderBlockEnd: e, borderBlockStart: e, borderBottom: e, borderBottomColor: e, borderColor: e, borderInline: e, borderInlineEnd: e, borderInlineStart: e, borderLeft: e, borderLeftColor: e, borderRight: e, borderRightColor: e, borderTop: e, borderTopColor: e, caretColor: e, color: e, columnRuleColor: e, fill: e, outline: e, outlineColor: e, stroke: e, textDecorationColor: e, fontFamily: "fonts", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", blockSize: t, minBlockSize: t, maxBlockSize: t, inlineSize: t, minInlineSize: t, maxInlineSize: t, width: t, minWidth: t, maxWidth: t, height: t, minHeight: t, maxHeight: t, flexBasis: t, gridTemplateColumns: t, gridTemplateRows: t, borderWidth: "borderWidths", borderTopWidth: "borderWidths", borderRightWidth: "borderWidths", borderBottomWidth: "borderWidths", borderLeftWidth: "borderWidths", borderStyle: "borderStyles", borderTopStyle: "borderStyles", borderRightStyle: "borderStyles", borderBottomStyle: "borderStyles", borderLeftStyle: "borderStyles", borderRadius: "radii", borderTopLeftRadius: "radii", borderTopRightRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", boxShadow: "shadows", textShadow: "shadows", transition: "transitions", zIndex: "zIndices" }, i = (ie, Z) => typeof Z == "function" ? { "()": Function.prototype.toString.call(Z) } : Z, o = () => {
  const ie = /* @__PURE__ */ Object.create(null);
  return (Z, ee, ...ae) => {
    const ve = ((ye) => JSON.stringify(ye, i))(Z);
    return ve in ie ? ie[ve] : ie[ve] = ee(Z, ...ae);
  };
}, l = Symbol.for("sxs.internal"), s = (ie, Z) => Object.defineProperties(ie, Object.getOwnPropertyDescriptors(Z)), a = (ie) => {
  for (const Z in ie)
    return !0;
  return !1;
}, { hasOwnProperty: c } = Object.prototype, d = (ie) => ie.includes("-") ? ie : ie.replace(/[A-Z]/g, (Z) => "-" + Z.toLowerCase()), g = /\s+(?![^()]*\))/, p = (ie) => (Z) => ie(...typeof Z == "string" ? String(Z).split(g) : [Z]), u = { appearance: (ie) => ({ WebkitAppearance: ie, appearance: ie }), backfaceVisibility: (ie) => ({ WebkitBackfaceVisibility: ie, backfaceVisibility: ie }), backdropFilter: (ie) => ({ WebkitBackdropFilter: ie, backdropFilter: ie }), backgroundClip: (ie) => ({ WebkitBackgroundClip: ie, backgroundClip: ie }), boxDecorationBreak: (ie) => ({ WebkitBoxDecorationBreak: ie, boxDecorationBreak: ie }), clipPath: (ie) => ({ WebkitClipPath: ie, clipPath: ie }), content: (ie) => ({ content: ie.includes('"') || ie.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(ie) ? ie : `"${ie}"` }), hyphens: (ie) => ({ WebkitHyphens: ie, hyphens: ie }), maskImage: (ie) => ({ WebkitMaskImage: ie, maskImage: ie }), maskSize: (ie) => ({ WebkitMaskSize: ie, maskSize: ie }), tabSize: (ie) => ({ MozTabSize: ie, tabSize: ie }), textSizeAdjust: (ie) => ({ WebkitTextSizeAdjust: ie, textSizeAdjust: ie }), userSelect: (ie) => ({ WebkitUserSelect: ie, userSelect: ie }), marginBlock: p((ie, Z) => ({ marginBlockStart: ie, marginBlockEnd: Z || ie })), marginInline: p((ie, Z) => ({ marginInlineStart: ie, marginInlineEnd: Z || ie })), maxSize: p((ie, Z) => ({ maxBlockSize: ie, maxInlineSize: Z || ie })), minSize: p((ie, Z) => ({ minBlockSize: ie, minInlineSize: Z || ie })), paddingBlock: p((ie, Z) => ({ paddingBlockStart: ie, paddingBlockEnd: Z || ie })), paddingInline: p((ie, Z) => ({ paddingInlineStart: ie, paddingInlineEnd: Z || ie })) }, h = /([\d.]+)([^]*)/, f = (ie, Z) => ie.length ? ie.reduce((ee, ae) => (ee.push(...Z.map((ve) => ve.includes("&") ? ve.replace(/&/g, /[ +>|~]/.test(ae) && /&.*&/.test(ve) ? `:is(${ae})` : ae) : ae + " " + ve)), ee), []) : Z, m$1 = (ie, Z) => ie in b && typeof Z == "string" ? Z.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (ee, ae, ve, ye) => ae + (ve === "stretch" ? `-moz-available${ye};${d(ie)}:${ae}-webkit-fill-available` : `-moz-fit-content${ye};${d(ie)}:${ae}fit-content`) + ye) : String(Z), b = { blockSize: 1, height: 1, inlineSize: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, width: 1 }, S$1 = (ie) => ie ? ie + "-" : "", k$1 = (ie, Z, ee) => ie.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (ae, ve, ye, be, Ye) => be == "$" == !!ye ? ae : (ve || be == "--" ? "calc(" : "") + "var(--" + (be === "$" ? S$1(Z) + (Ye.includes("$") ? "" : S$1(ee)) + Ye.replace(/\$/g, "-") : Ye) + ")" + (ve || be == "--" ? "*" + (ve || "") + (ye || "1") + ")" : "")), y = /\s*,\s*(?![^()]*\))/, B = Object.prototype.toString, $ = (ie, Z, ee, ae, ve) => {
  let ye, be, Ye;
  const Qe = (Je, nt, st) => {
    let ot, lt;
    const ft = (gt) => {
      for (ot in gt) {
        const Kr = ot.charCodeAt(0) === 64, Xr = Kr && Array.isArray(gt[ot]) ? gt[ot] : [gt[ot]];
        for (lt of Xr) {
          const Jr = /[A-Z]/.test(_r = ot) ? _r : _r.replace(/-[^]/g, (si) => si[1].toUpperCase()), ei = typeof lt == "object" && lt && lt.toString === B && (!ae.utils[Jr] || !nt.length);
          if (Jr in ae.utils && !ei) {
            const si = ae.utils[Jr];
            if (si !== be) {
              be = si, ft(si(lt)), be = null;
              continue;
            }
          } else if (Jr in u) {
            const si = u[Jr];
            if (si !== Ye) {
              Ye = si, ft(si(lt)), Ye = null;
              continue;
            }
          }
          if (Kr && (ct = ot.slice(1) in ae.media ? "@media " + ae.media[ot.slice(1)] : ot, ot = ct.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (si, ri, ai, yi, pi, di) => {
            const xi = h.test(ri), Ti = 0.0625 * (xi ? -1 : 1), [Ai, mi] = xi ? [yi, ri] : [ri, yi];
            return "(" + (ai[0] === "=" ? "" : ai[0] === ">" === xi ? "max-" : "min-") + Ai + ":" + (ai[0] !== "=" && ai.length === 1 ? mi.replace(h, (Si, gi, _i) => Number(gi) + Ti * (ai === ">" ? 1 : -1) + _i) : mi) + (pi ? ") and (" + (pi[0] === ">" ? "min-" : "max-") + Ai + ":" + (pi.length === 1 ? di.replace(h, (Si, gi, _i) => Number(gi) + Ti * (pi === ">" ? -1 : 1) + _i) : di) : "") + ")";
          })), ei) {
            const si = Kr ? st.concat(ot) : [...st], ri = Kr ? [...nt] : f(nt, ot.split(y));
            ye !== void 0 && ve(x$1(...ye)), ye = void 0, Qe(lt, ri, si);
          } else
            ye === void 0 && (ye = [[], nt, st]), ot = Kr || ot.charCodeAt(0) !== 36 ? ot : `--${S$1(ae.prefix)}${ot.slice(1).replace(/\$/g, "-")}`, lt = ei ? lt : typeof lt == "number" ? lt && Jr in I ? String(lt) + "px" : String(lt) : k$1(m$1(Jr, lt ?? ""), ae.prefix, ae.themeMap[Jr]), ye[0].push(`${Kr ? `${ot} ` : `${d(ot)}:`}${lt}`);
        }
      }
      var ct, _r;
    };
    ft(Je), ye !== void 0 && ve(x$1(...ye)), ye = void 0;
  };
  Qe(ie, Z, ee);
}, x$1 = (ie, Z, ee) => `${ee.map((ae) => `${ae}{`).join("")}${Z.length ? `${Z.join(",")}{` : ""}${ie.join(";")}${Z.length ? "}" : ""}${Array(ee.length ? ee.length + 1 : 0).join("}")}`, I = { animationDelay: 1, animationDuration: 1, backgroundSize: 1, blockSize: 1, border: 1, borderBlock: 1, borderBlockEnd: 1, borderBlockEndWidth: 1, borderBlockStart: 1, borderBlockStartWidth: 1, borderBlockWidth: 1, borderBottom: 1, borderBottomLeftRadius: 1, borderBottomRightRadius: 1, borderBottomWidth: 1, borderEndEndRadius: 1, borderEndStartRadius: 1, borderInlineEnd: 1, borderInlineEndWidth: 1, borderInlineStart: 1, borderInlineStartWidth: 1, borderInlineWidth: 1, borderLeft: 1, borderLeftWidth: 1, borderRadius: 1, borderRight: 1, borderRightWidth: 1, borderSpacing: 1, borderStartEndRadius: 1, borderStartStartRadius: 1, borderTop: 1, borderTopLeftRadius: 1, borderTopRightRadius: 1, borderTopWidth: 1, borderWidth: 1, bottom: 1, columnGap: 1, columnRule: 1, columnRuleWidth: 1, columnWidth: 1, containIntrinsicSize: 1, flexBasis: 1, fontSize: 1, gap: 1, gridAutoColumns: 1, gridAutoRows: 1, gridTemplateColumns: 1, gridTemplateRows: 1, height: 1, inlineSize: 1, inset: 1, insetBlock: 1, insetBlockEnd: 1, insetBlockStart: 1, insetInline: 1, insetInlineEnd: 1, insetInlineStart: 1, left: 1, letterSpacing: 1, margin: 1, marginBlock: 1, marginBlockEnd: 1, marginBlockStart: 1, marginBottom: 1, marginInline: 1, marginInlineEnd: 1, marginInlineStart: 1, marginLeft: 1, marginRight: 1, marginTop: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, offsetDistance: 1, offsetRotate: 1, outline: 1, outlineOffset: 1, outlineWidth: 1, overflowClipMargin: 1, padding: 1, paddingBlock: 1, paddingBlockEnd: 1, paddingBlockStart: 1, paddingBottom: 1, paddingInline: 1, paddingInlineEnd: 1, paddingInlineStart: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1, perspective: 1, right: 1, rowGap: 1, scrollMargin: 1, scrollMarginBlock: 1, scrollMarginBlockEnd: 1, scrollMarginBlockStart: 1, scrollMarginBottom: 1, scrollMarginInline: 1, scrollMarginInlineEnd: 1, scrollMarginInlineStart: 1, scrollMarginLeft: 1, scrollMarginRight: 1, scrollMarginTop: 1, scrollPadding: 1, scrollPaddingBlock: 1, scrollPaddingBlockEnd: 1, scrollPaddingBlockStart: 1, scrollPaddingBottom: 1, scrollPaddingInline: 1, scrollPaddingInlineEnd: 1, scrollPaddingInlineStart: 1, scrollPaddingLeft: 1, scrollPaddingRight: 1, scrollPaddingTop: 1, shapeMargin: 1, textDecoration: 1, textDecorationThickness: 1, textIndent: 1, textUnderlineOffset: 1, top: 1, transitionDelay: 1, transitionDuration: 1, verticalAlign: 1, width: 1, wordSpacing: 1 }, R$1 = (ie) => String.fromCharCode(ie + (ie > 25 ? 39 : 97)), z$1 = (ie) => ((Z) => {
  let ee, ae = "";
  for (ee = Math.abs(Z); ee > 52; ee = ee / 52 | 0)
    ae = R$1(ee % 52) + ae;
  return R$1(ee % 52) + ae;
})(((Z, ee) => {
  let ae = ee.length;
  for (; ae; )
    Z = 33 * Z ^ ee.charCodeAt(--ae);
  return Z;
})(5381, JSON.stringify(ie)) >>> 0), W$1 = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"], j$1 = (ie) => {
  if (ie.href && !ie.href.startsWith(location.origin))
    return !1;
  try {
    return !!ie.cssRules;
  } catch {
    return !1;
  }
}, E = (ie) => {
  let Z;
  const ee = () => {
    const { cssRules: ve } = Z.sheet;
    return [].map.call(ve, (ye, be) => {
      const { cssText: Ye } = ye;
      let Qe = "";
      if (Ye.startsWith("--sxs"))
        return "";
      if (ve[be - 1] && (Qe = ve[be - 1].cssText).startsWith("--sxs")) {
        if (!ye.cssRules.length)
          return "";
        for (const Je in Z.rules)
          if (Z.rules[Je].group === ye)
            return `--sxs{--sxs:${[...Z.rules[Je].cache].join(" ")}}${Ye}`;
        return ye.cssRules.length ? `${Qe}${Ye}` : "";
      }
      return Ye;
    }).join("");
  }, ae = () => {
    if (Z) {
      const { rules: Ye, sheet: Qe } = Z;
      if (!Qe.deleteRule) {
        for (; Object(Object(Qe.cssRules)[0]).type === 3; )
          Qe.cssRules.splice(0, 1);
        Qe.cssRules = [];
      }
      for (const Je in Ye)
        delete Ye[Je];
    }
    const ve = Object(ie).styleSheets || [];
    for (const Ye of ve)
      if (j$1(Ye)) {
        for (let Qe = 0, Je = Ye.cssRules; Je[Qe]; ++Qe) {
          const nt = Object(Je[Qe]);
          if (nt.type !== 1)
            continue;
          const st = Object(Je[Qe + 1]);
          if (st.type !== 4)
            continue;
          ++Qe;
          const { cssText: ot } = nt;
          if (!ot.startsWith("--sxs"))
            continue;
          const lt = ot.slice(14, -3).trim().split(/\s+/), ft = W$1[lt[0]];
          ft && (Z || (Z = { sheet: Ye, reset: ae, rules: {}, toString: ee }), Z.rules[ft] = { group: st, index: Qe, cache: new Set(lt) });
        }
        if (Z)
          break;
      }
    if (!Z) {
      const Ye = (Qe, Je) => ({ type: Je, cssRules: [], insertRule(nt, st) {
        this.cssRules.splice(st, 0, Ye(nt, { import: 3, undefined: 1 }[(nt.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
      }, get cssText() {
        return Qe === "@media{}" ? `@media{${[].map.call(this.cssRules, (nt) => nt.cssText).join("")}}` : Qe;
      } });
      Z = { sheet: ie ? (ie.head || ie).appendChild(document.createElement("style")).sheet : Ye("", "text/css"), rules: {}, reset: ae, toString: ee };
    }
    const { sheet: ye, rules: be } = Z;
    for (let Ye = W$1.length - 1; Ye >= 0; --Ye) {
      const Qe = W$1[Ye];
      if (!be[Qe]) {
        const Je = W$1[Ye + 1], nt = be[Je] ? be[Je].index : ye.cssRules.length;
        ye.insertRule("@media{}", nt), ye.insertRule(`--sxs{--sxs:${Ye}}`, nt), be[Qe] = { group: ye.cssRules[nt + 1], index: nt, cache: /* @__PURE__ */ new Set([Ye]) };
      }
      v(be[Qe]);
    }
  };
  return ae(), Z;
}, v = (ie) => {
  const Z = ie.group;
  let ee = Z.cssRules.length;
  ie.apply = (ae) => {
    try {
      Z.insertRule(ae, ee), ++ee;
    } catch {
    }
  };
}, T$1 = Symbol(), w = o(), M = (ie, Z) => w(ie, () => (...ee) => {
  let ae = { type: null, composers: /* @__PURE__ */ new Set() };
  for (const ve of ee)
    if (ve != null)
      if (ve[l]) {
        ae.type == null && (ae.type = ve[l].type);
        for (const ye of ve[l].composers)
          ae.composers.add(ye);
      } else
        ve.constructor !== Object || ve.$$typeof ? ae.type == null && (ae.type = ve) : ae.composers.add(C(ve, ie));
  return ae.type == null && (ae.type = "span"), ae.composers.size || ae.composers.add(["PJLV", {}, [], [], {}, []]), P(ie, ae, Z);
}), C = ({ variants: ie, compoundVariants: Z, defaultVariants: ee, ...ae }, ve) => {
  const ye = `${S$1(ve.prefix)}c-${z$1(ae)}`, be = [], Ye = [], Qe = /* @__PURE__ */ Object.create(null), Je = [];
  for (const ot in ee)
    Qe[ot] = String(ee[ot]);
  if (typeof ie == "object" && ie)
    for (const ot in ie) {
      nt = Qe, st = ot, c.call(nt, st) || (Qe[ot] = "undefined");
      const lt = ie[ot];
      for (const ft in lt) {
        const gt = { [ot]: String(ft) };
        String(ft) === "undefined" && Je.push(ot);
        const ct = lt[ft], _r = [gt, ct, !a(ct)];
        be.push(_r);
      }
    }
  var nt, st;
  if (typeof Z == "object" && Z)
    for (const ot of Z) {
      let { css: lt, ...ft } = ot;
      lt = typeof lt == "object" && lt || {};
      for (const ct in ft)
        ft[ct] = String(ft[ct]);
      const gt = [ft, lt, !a(lt)];
      Ye.push(gt);
    }
  return [ye, ae, be, Ye, Qe, Je];
}, P = (ie, Z, ee) => {
  const [ae, ve, ye, be] = L$1(Z.composers), Ye = typeof Z.type == "function" || Z.type.$$typeof ? ((st) => {
    function ot() {
      for (let lt = 0; lt < ot[T$1].length; lt++) {
        const [ft, gt] = ot[T$1][lt];
        st.rules[ft].apply(gt);
      }
      return ot[T$1] = [], null;
    }
    return ot[T$1] = [], ot.rules = {}, W$1.forEach((lt) => ot.rules[lt] = { apply: (ft) => ot[T$1].push([lt, ft]) }), ot;
  })(ee) : null, Qe = (Ye || ee).rules, Je = `.${ae}${ve.length > 1 ? `:where(.${ve.slice(1).join(".")})` : ""}`, nt = (st) => {
    st = typeof st == "object" && st || A;
    const { css: ot, ...lt } = st, ft = {};
    for (const _r in ye)
      if (delete lt[_r], _r in st) {
        let Kr = st[_r];
        typeof Kr == "object" && Kr ? ft[_r] = { "@initial": ye[_r], ...Kr } : (Kr = String(Kr), ft[_r] = Kr !== "undefined" || be.has(_r) ? Kr : ye[_r]);
      } else
        ft[_r] = ye[_r];
    const gt = /* @__PURE__ */ new Set([...ve]);
    for (const [_r, Kr, Xr, Jr] of Z.composers) {
      ee.rules.styled.cache.has(_r) || (ee.rules.styled.cache.add(_r), $(Kr, [`.${_r}`], [], ie, (ri) => {
        Qe.styled.apply(ri);
      }));
      const ei = O$1(Xr, ft, ie.media), si = O$1(Jr, ft, ie.media, !0);
      for (const ri of ei)
        if (ri !== void 0)
          for (const [ai, yi, pi] of ri) {
            const di = `${_r}-${z$1(yi)}-${ai}`;
            gt.add(di);
            const xi = (pi ? ee.rules.resonevar : ee.rules.onevar).cache, Ti = pi ? Qe.resonevar : Qe.onevar;
            xi.has(di) || (xi.add(di), $(yi, [`.${di}`], [], ie, (Ai) => {
              Ti.apply(Ai);
            }));
          }
      for (const ri of si)
        if (ri !== void 0)
          for (const [ai, yi] of ri) {
            const pi = `${_r}-${z$1(yi)}-${ai}`;
            gt.add(pi), ee.rules.allvar.cache.has(pi) || (ee.rules.allvar.cache.add(pi), $(yi, [`.${pi}`], [], ie, (di) => {
              Qe.allvar.apply(di);
            }));
          }
    }
    if (typeof ot == "object" && ot) {
      const _r = `${ae}-i${z$1(ot)}-css`;
      gt.add(_r), ee.rules.inline.cache.has(_r) || (ee.rules.inline.cache.add(_r), $(ot, [`.${_r}`], [], ie, (Kr) => {
        Qe.inline.apply(Kr);
      }));
    }
    for (const _r of String(st.className || "").trim().split(/\s+/))
      _r && gt.add(_r);
    const ct = lt.className = [...gt].join(" ");
    return { type: Z.type, className: ct, selector: Je, props: lt, toString: () => ct, deferredInjector: Ye };
  };
  return s(nt, { className: ae, selector: Je, [l]: Z, toString: () => (ee.rules.styled.cache.has(ae) || nt(), ae) });
}, L$1 = (ie) => {
  let Z = "";
  const ee = [], ae = {}, ve = [];
  for (const [ye, , , , be, Ye] of ie) {
    Z === "" && (Z = ye), ee.push(ye), ve.push(...Ye);
    for (const Qe in be) {
      const Je = be[Qe];
      (ae[Qe] === void 0 || Je !== "undefined" || Ye.includes(Je)) && (ae[Qe] = Je);
    }
  }
  return [Z, ee, ae, new Set(ve)];
}, O$1 = (ie, Z, ee, ae) => {
  const ve = [];
  e:
    for (let [ye, be, Ye] of ie) {
      if (Ye)
        continue;
      let Qe, Je = 0, nt = !1;
      for (Qe in ye) {
        const st = ye[Qe];
        let ot = Z[Qe];
        if (ot !== st) {
          if (typeof ot != "object" || !ot)
            continue e;
          {
            let lt, ft, gt = 0;
            for (const ct in ot) {
              if (st === String(ot[ct])) {
                if (ct !== "@initial") {
                  const _r = ct.slice(1);
                  (ft = ft || []).push(_r in ee ? ee[_r] : ct.replace(/^@media ?/, "")), nt = !0;
                }
                Je += gt, lt = !0;
              }
              ++gt;
            }
            if (ft && ft.length && (be = { ["@media " + ft.join(", ")]: be }), !lt)
              continue e;
          }
        }
      }
      (ve[Je] = ve[Je] || []).push([ae ? "cv" : `${Qe}-${ye[Qe]}`, be, nt]);
    }
  return ve;
}, A = {}, N$1 = o(), D$1 = (ie, Z) => N$1(ie, () => (...ee) => {
  const ae = () => {
    for (let ve of ee) {
      ve = typeof ve == "object" && ve || {};
      let ye = z$1(ve);
      if (!Z.rules.global.cache.has(ye)) {
        if (Z.rules.global.cache.add(ye), "@import" in ve) {
          let be = [].indexOf.call(Z.sheet.cssRules, Z.rules.themed.group) - 1;
          for (let Ye of [].concat(ve["@import"]))
            Ye = Ye.includes('"') || Ye.includes("'") ? Ye : `"${Ye}"`, Z.sheet.insertRule(`@import ${Ye};`, be++);
          delete ve["@import"];
        }
        $(ve, [], [], ie, (be) => {
          Z.rules.global.apply(be);
        });
      }
    }
    return "";
  };
  return s(ae, { toString: ae });
}), H = o(), V = (ie, Z) => H(ie, () => (ee) => {
  const ae = `${S$1(ie.prefix)}k-${z$1(ee)}`, ve = () => {
    if (!Z.rules.global.cache.has(ae)) {
      Z.rules.global.cache.add(ae);
      const ye = [];
      $(ee, [], [], ie, (Ye) => ye.push(Ye));
      const be = `@keyframes ${ae}{${ye.join("")}}`;
      Z.rules.global.apply(be);
    }
    return ae;
  };
  return s(ve, { get name() {
    return ve();
  }, toString: ve });
}), G = class {
  constructor(ie, Z, ee, ae) {
    this.token = ie == null ? "" : String(ie), this.value = Z == null ? "" : String(Z), this.scale = ee == null ? "" : String(ee), this.prefix = ae == null ? "" : String(ae);
  }
  get computedValue() {
    return "var(" + this.variable + ")";
  }
  get variable() {
    return "--" + S$1(this.prefix) + S$1(this.scale) + this.token;
  }
  toString() {
    return this.computedValue;
  }
}, F = o(), J$1 = (ie, Z) => F(ie, () => (ee, ae) => {
  ae = typeof ee == "object" && ee || Object(ae);
  const ve = `.${ee = (ee = typeof ee == "string" ? ee : "") || `${S$1(ie.prefix)}t-${z$1(ae)}`}`, ye = {}, be = [];
  for (const Qe in ae) {
    ye[Qe] = {};
    for (const Je in ae[Qe]) {
      const nt = `--${S$1(ie.prefix)}${Qe}-${Je}`, st = k$1(String(ae[Qe][Je]), ie.prefix, Qe);
      ye[Qe][Je] = new G(Je, st, Qe, ie.prefix), be.push(`${nt}:${st}`);
    }
  }
  const Ye = () => {
    if (be.length && !Z.rules.themed.cache.has(ee)) {
      Z.rules.themed.cache.add(ee);
      const Qe = `${ae === ie.theme ? ":root," : ""}.${ee}{${be.join(";")}}`;
      Z.rules.themed.apply(Qe);
    }
    return ee;
  };
  return { ...ye, get className() {
    return Ye();
  }, selector: ve, toString: Ye };
}), U = o(), X$1, Y$1 = o(), q = (ie) => {
  const Z = ((ee) => {
    let ae = !1;
    const ve = U(ee, (ye) => {
      ae = !0;
      const be = "prefix" in (ye = typeof ye == "object" && ye || {}) ? String(ye.prefix) : "", Ye = typeof ye.media == "object" && ye.media || {}, Qe = typeof ye.root == "object" ? ye.root || null : globalThis.document || null, Je = typeof ye.theme == "object" && ye.theme || {}, nt = { prefix: be, media: Ye, theme: Je, themeMap: typeof ye.themeMap == "object" && ye.themeMap || { ...n }, utils: typeof ye.utils == "object" && ye.utils || {} }, st = E(Qe), ot = { css: M(nt, st), globalCss: D$1(nt, st), keyframes: V(nt, st), createTheme: J$1(nt, st), reset() {
        st.reset(), ot.theme.toString();
      }, theme: {}, sheet: st, config: nt, prefix: be, getCssText: st.toString, toString: st.toString };
      return String(ot.theme = ot.createTheme(Je)), ot;
    });
    return ae || ve.reset(), ve;
  })(ie);
  return Z.styled = (({ config: ee, sheet: ae }) => Y$1(ee, () => {
    const ve = M(ee, ae);
    return (...ye) => {
      const be = ve(...ye), Ye = be[l].type, Qe = e$1.forwardRef((Je, nt) => {
        const st = Je && Je.as || Ye, { props: ot, deferredInjector: lt } = be(Je);
        return delete ot.as, ot.ref = nt, lt ? e$1.createElement(e$1.Fragment, null, e$1.createElement(st, ot), e$1.createElement(lt, null)) : e$1.createElement(st, ot);
      });
      return Qe.className = be.className, Qe.displayName = `Styled.${Ye.displayName || Ye.name || Ye}`, Qe.selector = be.selector, Qe.toString = () => be.selector, Qe[l] = be[l], Qe;
    };
  }))(Z), Z;
}, K$1 = () => X$1 || (X$1 = q()), Q$1 = (...ie) => K$1().createTheme(...ie);
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(ie) {
  const Z = ie + "CollectionProvider", [ee, ae] = $c512c27ab02ef895$export$50c7b4e9d9f19c1(Z), [ve, ye] = ee(Z, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), be = (lt) => {
    const { scope: ft, children: gt } = lt, ct = e$1.useRef(null), _r = e$1.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ e$1.createElement(ve, {
      scope: ft,
      itemMap: _r,
      collectionRef: ct
    }, gt);
  }, Ye = ie + "CollectionSlot", Qe = /* @__PURE__ */ e$1.forwardRef((lt, ft) => {
    const { scope: gt, children: ct } = lt, _r = ye(Ye, gt), Kr = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(ft, _r.collectionRef);
    return /* @__PURE__ */ e$1.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
      ref: Kr
    }, ct);
  }), Je = ie + "CollectionItemSlot", nt = "data-radix-collection-item", st = /* @__PURE__ */ e$1.forwardRef((lt, ft) => {
    const { scope: gt, children: ct, ..._r } = lt, Kr = e$1.useRef(null), Xr = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(ft, Kr), Jr = ye(Je, gt);
    return e$1.useEffect(() => (Jr.itemMap.set(Kr, {
      ref: Kr,
      ..._r
    }), () => void Jr.itemMap.delete(Kr))), /* @__PURE__ */ e$1.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
      [nt]: "",
      ref: Xr
    }, ct);
  });
  function ot(lt) {
    const ft = ye(ie + "CollectionConsumer", lt);
    return e$1.useCallback(() => {
      const ct = ft.collectionRef.current;
      if (!ct)
        return [];
      const _r = Array.from(ct.querySelectorAll(`[${nt}]`));
      return Array.from(ft.itemMap.values()).sort(
        (Jr, ei) => _r.indexOf(Jr.ref.current) - _r.indexOf(ei.ref.current)
      );
    }, [
      ft.collectionRef,
      ft.itemMap
    ]);
  }
  return [
    {
      Provider: be,
      Slot: Qe,
      ItemSlot: st
    },
    ot,
    ae
  ];
}
const $f631663db3294ace$var$DirectionContext = /* @__PURE__ */ reactExports.createContext(void 0);
function $f631663db3294ace$export$b39126d51d94e6f3(ie) {
  const Z = reactExports.useContext($f631663db3294ace$var$DirectionContext);
  return ie || Z || "ltr";
}
const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus", $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
  bubbles: !1,
  cancelable: !0
}, $d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup", [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($d7bdfb9eb0fdf311$var$GROUP_NAME), [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d7bdfb9eb0fdf311$var$GROUP_NAME, [
  $d7bdfb9eb0fdf311$var$createCollectionScope
]), [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME), $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => /* @__PURE__ */ reactExports.createElement($d7bdfb9eb0fdf311$var$Collection.Provider, {
  scope: ie.__scopeRovingFocusGroup
}, /* @__PURE__ */ reactExports.createElement($d7bdfb9eb0fdf311$var$Collection.Slot, {
  scope: ie.__scopeRovingFocusGroup
}, /* @__PURE__ */ reactExports.createElement($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, _extends$1({}, ie, {
  ref: Z
}))))), $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeRovingFocusGroup: ee, orientation: ae, loop: ve = !1, dir: ye, currentTabStopId: be, defaultCurrentTabStopId: Ye, onCurrentTabStopIdChange: Qe, onEntryFocus: Je, ...nt } = ie, st = reactExports.useRef(null), ot = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, st), lt = $f631663db3294ace$export$b39126d51d94e6f3(ye), [ft = null, gt] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: be,
    defaultProp: Ye,
    onChange: Qe
  }), [ct, _r] = reactExports.useState(!1), Kr = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(Je), Xr = $d7bdfb9eb0fdf311$var$useCollection(ee), Jr = reactExports.useRef(!1), [ei, si] = reactExports.useState(0);
  return reactExports.useEffect(() => {
    const ri = st.current;
    if (ri)
      return ri.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, Kr), () => ri.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, Kr);
  }, [
    Kr
  ]), /* @__PURE__ */ reactExports.createElement($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
    scope: ee,
    orientation: ae,
    dir: lt,
    loop: ve,
    currentTabStopId: ft,
    onItemFocus: reactExports.useCallback(
      (ri) => gt(ri),
      [
        gt
      ]
    ),
    onItemShiftTab: reactExports.useCallback(
      () => _r(!0),
      []
    ),
    onFocusableItemAdd: reactExports.useCallback(
      () => si(
        (ri) => ri + 1
      ),
      []
    ),
    onFocusableItemRemove: reactExports.useCallback(
      () => si(
        (ri) => ri - 1
      ),
      []
    )
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    tabIndex: ct || ei === 0 ? -1 : 0,
    "data-orientation": ae
  }, nt, {
    ref: ot,
    style: {
      outline: "none",
      ...ie.style
    },
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onMouseDown, () => {
      Jr.current = !0;
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onFocus, (ri) => {
      const ai = !Jr.current;
      if (ri.target === ri.currentTarget && ai && !ct) {
        const yi = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
        if (ri.currentTarget.dispatchEvent(yi), !yi.defaultPrevented) {
          const pi = Xr().filter(
            (mi) => mi.focusable
          ), di = pi.find(
            (mi) => mi.active
          ), xi = pi.find(
            (mi) => mi.id === ft
          ), Ai = [
            di,
            xi,
            ...pi
          ].filter(Boolean).map(
            (mi) => mi.ref.current
          );
          $d7bdfb9eb0fdf311$var$focusFirst(Ai);
        }
      }
      Jr.current = !1;
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      ie.onBlur,
      () => _r(!1)
    )
  })));
}), $d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem", $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeRovingFocusGroup: ee, focusable: ae = !0, active: ve = !1, tabStopId: ye, ...be } = ie, Ye = $1746a345f3d73bb7$export$f680877a34711e37(), Qe = ye || Ye, Je = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, ee), nt = Je.currentTabStopId === Qe, st = $d7bdfb9eb0fdf311$var$useCollection(ee), { onFocusableItemAdd: ot, onFocusableItemRemove: lt } = Je;
  return reactExports.useEffect(() => {
    if (ae)
      return ot(), () => lt();
  }, [
    ae,
    ot,
    lt
  ]), /* @__PURE__ */ reactExports.createElement($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
    scope: ee,
    id: Qe,
    focusable: ae,
    active: ve
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({
    tabIndex: nt ? 0 : -1,
    "data-orientation": Je.orientation
  }, be, {
    ref: Z,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onMouseDown, (ft) => {
      ae ? Je.onItemFocus(Qe) : ft.preventDefault();
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      ie.onFocus,
      () => Je.onItemFocus(Qe)
    ),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onKeyDown, (ft) => {
      if (ft.key === "Tab" && ft.shiftKey) {
        Je.onItemShiftTab();
        return;
      }
      if (ft.target !== ft.currentTarget)
        return;
      const gt = $d7bdfb9eb0fdf311$var$getFocusIntent(ft, Je.orientation, Je.dir);
      if (gt !== void 0) {
        ft.preventDefault();
        let _r = st().filter(
          (Kr) => Kr.focusable
        ).map(
          (Kr) => Kr.ref.current
        );
        if (gt === "last")
          _r.reverse();
        else if (gt === "prev" || gt === "next") {
          gt === "prev" && _r.reverse();
          const Kr = _r.indexOf(ft.currentTarget);
          _r = Je.loop ? $d7bdfb9eb0fdf311$var$wrapArray(_r, Kr + 1) : _r.slice(Kr + 1);
        }
        setTimeout(
          () => $d7bdfb9eb0fdf311$var$focusFirst(_r)
        );
      }
    })
  })));
}), $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(ie, Z) {
  return Z !== "rtl" ? ie : ie === "ArrowLeft" ? "ArrowRight" : ie === "ArrowRight" ? "ArrowLeft" : ie;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(ie, Z, ee) {
  const ae = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(ie.key, ee);
  if (!(Z === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(ae)) && !(Z === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(ae)))
    return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[ae];
}
function $d7bdfb9eb0fdf311$var$focusFirst(ie) {
  const Z = document.activeElement;
  for (const ee of ie)
    if (ee === Z || (ee.focus(), document.activeElement !== Z))
      return;
}
function $d7bdfb9eb0fdf311$var$wrapArray(ie, Z) {
  return ie.map(
    (ee, ae) => ie[(Z + ae) % ie.length]
  );
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338, $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454, $69cb30bb0017df05$var$TABS_NAME = "Tabs", [$69cb30bb0017df05$var$createTabsContext, $69cb30bb0017df05$export$355f5bd209d7b13a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($69cb30bb0017df05$var$TABS_NAME, [
  $d7bdfb9eb0fdf311$export$c7109489551a4f4
]), $69cb30bb0017df05$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4(), [$69cb30bb0017df05$var$TabsProvider, $69cb30bb0017df05$var$useTabsContext] = $69cb30bb0017df05$var$createTabsContext($69cb30bb0017df05$var$TABS_NAME), $69cb30bb0017df05$export$b2539bed5023c21c = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeTabs: ee, value: ae, onValueChange: ve, defaultValue: ye, orientation: be = "horizontal", dir: Ye, activationMode: Qe = "automatic", ...Je } = ie, nt = $f631663db3294ace$export$b39126d51d94e6f3(Ye), [st, ot] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: ae,
    onChange: ve,
    defaultProp: ye
  });
  return /* @__PURE__ */ reactExports.createElement($69cb30bb0017df05$var$TabsProvider, {
    scope: ee,
    baseId: $1746a345f3d73bb7$export$f680877a34711e37(),
    value: st,
    onValueChange: ot,
    orientation: be,
    dir: nt,
    activationMode: Qe
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    dir: nt,
    "data-orientation": be
  }, Je, {
    ref: Z
  })));
}), $69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList", $69cb30bb0017df05$export$9712d22edc0d78c1 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeTabs: ee, loop: ae = !0, ...ve } = ie, ye = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TAB_LIST_NAME, ee), be = $69cb30bb0017df05$var$useRovingFocusGroupScope(ee);
  return /* @__PURE__ */ reactExports.createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends$1({
    asChild: !0
  }, be, {
    orientation: ye.orientation,
    dir: ye.dir,
    loop: ae
  }), /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    role: "tablist",
    "aria-orientation": ye.orientation
  }, ve, {
    ref: Z
  })));
}), $69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger", $69cb30bb0017df05$export$8114b9fdfdf9f3ba = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeTabs: ee, value: ae, disabled: ve = !1, ...ye } = ie, be = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TRIGGER_NAME, ee), Ye = $69cb30bb0017df05$var$useRovingFocusGroupScope(ee), Qe = $69cb30bb0017df05$var$makeTriggerId(be.baseId, ae), Je = $69cb30bb0017df05$var$makeContentId(be.baseId, ae), nt = ae === be.value;
  return /* @__PURE__ */ reactExports.createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends$1({
    asChild: !0
  }, Ye, {
    focusable: !ve,
    active: nt
  }), /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button",
    role: "tab",
    "aria-selected": nt,
    "aria-controls": Je,
    "data-state": nt ? "active" : "inactive",
    "data-disabled": ve ? "" : void 0,
    disabled: ve,
    id: Qe
  }, ye, {
    ref: Z,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onMouseDown, (st) => {
      !ve && st.button === 0 && st.ctrlKey === !1 ? be.onValueChange(ae) : st.preventDefault();
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onKeyDown, (st) => {
      [
        " ",
        "Enter"
      ].includes(st.key) && be.onValueChange(ae);
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onFocus, () => {
      const st = be.activationMode !== "manual";
      !nt && !ve && st && be.onValueChange(ae);
    })
  })));
}), $69cb30bb0017df05$var$CONTENT_NAME = "TabsContent", $69cb30bb0017df05$export$bd905d70e8fd2ebb = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeTabs: ee, value: ae, forceMount: ve, children: ye, ...be } = ie, Ye = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$CONTENT_NAME, ee), Qe = $69cb30bb0017df05$var$makeTriggerId(Ye.baseId, ae), Je = $69cb30bb0017df05$var$makeContentId(Ye.baseId, ae), nt = ae === Ye.value, st = reactExports.useRef(nt);
  return reactExports.useEffect(() => {
    const ot = requestAnimationFrame(
      () => st.current = !1
    );
    return () => cancelAnimationFrame(ot);
  }, []), /* @__PURE__ */ reactExports.createElement(
    $921a889cee6df7e8$export$99c2b779aa4e8b8b,
    {
      present: ve || nt
    },
    ({ present: ot }) => /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
      "data-state": nt ? "active" : "inactive",
      "data-orientation": Ye.orientation,
      role: "tabpanel",
      "aria-labelledby": Qe,
      hidden: !ot,
      id: Je,
      tabIndex: 0
    }, be, {
      ref: Z,
      style: {
        ...ie.style,
        animationDuration: st.current ? "0s" : void 0
      }
    }), ot && ye)
  );
});
function $69cb30bb0017df05$var$makeTriggerId(ie, Z) {
  return `${ie}-trigger-${Z}`;
}
function $69cb30bb0017df05$var$makeContentId(ie, Z) {
  return `${ie}-content-${Z}`;
}
const $69cb30bb0017df05$export$be92b6f5f03c0fe9 = $69cb30bb0017df05$export$b2539bed5023c21c, $69cb30bb0017df05$export$54c2e3dc7acea9f5 = $69cb30bb0017df05$export$9712d22edc0d78c1, $69cb30bb0017df05$export$41fb9f06171c75f4 = $69cb30bb0017df05$export$8114b9fdfdf9f3ba, $69cb30bb0017df05$export$7c6e2c02157bb7d2 = $69cb30bb0017df05$export$bd905d70e8fd2ebb;
var lib$5 = {}, Parser$3 = {}, Tokenizer = {}, decode = {}, decodeDataHtml = {};
Object.defineProperty(decodeDataHtml, "__esModule", { value: !0 });
decodeDataHtml.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(ie) {
    return ie.charCodeAt(0);
  })
);
var decodeDataXml = {};
Object.defineProperty(decodeDataXml, "__esModule", { value: !0 });
decodeDataXml.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(ie) {
    return ie.charCodeAt(0);
  })
);
var decode_codepoint = {};
(function(ie) {
  var Z;
  Object.defineProperty(ie, "__esModule", { value: !0 }), ie.replaceCodePoint = ie.fromCodePoint = void 0;
  var ee = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  ie.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (Z = String.fromCodePoint) !== null && Z !== void 0 ? Z : function(ye) {
    var be = "";
    return ye > 65535 && (ye -= 65536, be += String.fromCharCode(ye >>> 10 & 1023 | 55296), ye = 56320 | ye & 1023), be += String.fromCharCode(ye), be;
  };
  function ae(ye) {
    var be;
    return ye >= 55296 && ye <= 57343 || ye > 1114111 ? 65533 : (be = ee.get(ye)) !== null && be !== void 0 ? be : ye;
  }
  ie.replaceCodePoint = ae;
  function ve(ye) {
    return (0, ie.fromCodePoint)(ae(ye));
  }
  ie.default = ve;
})(decode_codepoint);
(function(ie) {
  var Z = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(di, xi, Ti, Ai) {
    Ai === void 0 && (Ai = Ti);
    var mi = Object.getOwnPropertyDescriptor(xi, Ti);
    (!mi || ("get" in mi ? !xi.__esModule : mi.writable || mi.configurable)) && (mi = { enumerable: !0, get: function() {
      return xi[Ti];
    } }), Object.defineProperty(di, Ai, mi);
  } : function(di, xi, Ti, Ai) {
    Ai === void 0 && (Ai = Ti), di[Ai] = xi[Ti];
  }), ee = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(di, xi) {
    Object.defineProperty(di, "default", { enumerable: !0, value: xi });
  } : function(di, xi) {
    di.default = xi;
  }), ae = commonjsGlobal && commonjsGlobal.__importStar || function(di) {
    if (di && di.__esModule)
      return di;
    var xi = {};
    if (di != null)
      for (var Ti in di)
        Ti !== "default" && Object.prototype.hasOwnProperty.call(di, Ti) && Z(xi, di, Ti);
    return ee(xi, di), xi;
  }, ve = commonjsGlobal && commonjsGlobal.__importDefault || function(di) {
    return di && di.__esModule ? di : { default: di };
  };
  Object.defineProperty(ie, "__esModule", { value: !0 }), ie.decodeXML = ie.decodeHTMLStrict = ie.decodeHTMLAttribute = ie.decodeHTML = ie.determineBranch = ie.EntityDecoder = ie.DecodingMode = ie.BinTrieFlags = ie.fromCodePoint = ie.replaceCodePoint = ie.decodeCodePoint = ie.xmlDecodeTree = ie.htmlDecodeTree = void 0;
  var ye = ve(decodeDataHtml);
  ie.htmlDecodeTree = ye.default;
  var be = ve(decodeDataXml);
  ie.xmlDecodeTree = be.default;
  var Ye = ae(decode_codepoint);
  ie.decodeCodePoint = Ye.default;
  var Qe = decode_codepoint;
  Object.defineProperty(ie, "replaceCodePoint", { enumerable: !0, get: function() {
    return Qe.replaceCodePoint;
  } }), Object.defineProperty(ie, "fromCodePoint", { enumerable: !0, get: function() {
    return Qe.fromCodePoint;
  } });
  var Je;
  (function(di) {
    di[di.NUM = 35] = "NUM", di[di.SEMI = 59] = "SEMI", di[di.EQUALS = 61] = "EQUALS", di[di.ZERO = 48] = "ZERO", di[di.NINE = 57] = "NINE", di[di.LOWER_A = 97] = "LOWER_A", di[di.LOWER_F = 102] = "LOWER_F", di[di.LOWER_X = 120] = "LOWER_X", di[di.LOWER_Z = 122] = "LOWER_Z", di[di.UPPER_A = 65] = "UPPER_A", di[di.UPPER_F = 70] = "UPPER_F", di[di.UPPER_Z = 90] = "UPPER_Z";
  })(Je || (Je = {}));
  var nt = 32, st;
  (function(di) {
    di[di.VALUE_LENGTH = 49152] = "VALUE_LENGTH", di[di.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", di[di.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(st = ie.BinTrieFlags || (ie.BinTrieFlags = {}));
  function ot(di) {
    return di >= Je.ZERO && di <= Je.NINE;
  }
  function lt(di) {
    return di >= Je.UPPER_A && di <= Je.UPPER_F || di >= Je.LOWER_A && di <= Je.LOWER_F;
  }
  function ft(di) {
    return di >= Je.UPPER_A && di <= Je.UPPER_Z || di >= Je.LOWER_A && di <= Je.LOWER_Z || ot(di);
  }
  function gt(di) {
    return di === Je.EQUALS || ft(di);
  }
  var ct;
  (function(di) {
    di[di.EntityStart = 0] = "EntityStart", di[di.NumericStart = 1] = "NumericStart", di[di.NumericDecimal = 2] = "NumericDecimal", di[di.NumericHex = 3] = "NumericHex", di[di.NamedEntity = 4] = "NamedEntity";
  })(ct || (ct = {}));
  var _r;
  (function(di) {
    di[di.Legacy = 0] = "Legacy", di[di.Strict = 1] = "Strict", di[di.Attribute = 2] = "Attribute";
  })(_r = ie.DecodingMode || (ie.DecodingMode = {}));
  var Kr = (
    /** @class */
    function() {
      function di(xi, Ti, Ai) {
        this.decodeTree = xi, this.emitCodePoint = Ti, this.errors = Ai, this.state = ct.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = _r.Strict;
      }
      return di.prototype.startEntity = function(xi) {
        this.decodeMode = xi, this.state = ct.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, di.prototype.write = function(xi, Ti) {
        switch (this.state) {
          case ct.EntityStart:
            return xi.charCodeAt(Ti) === Je.NUM ? (this.state = ct.NumericStart, this.consumed += 1, this.stateNumericStart(xi, Ti + 1)) : (this.state = ct.NamedEntity, this.stateNamedEntity(xi, Ti));
          case ct.NumericStart:
            return this.stateNumericStart(xi, Ti);
          case ct.NumericDecimal:
            return this.stateNumericDecimal(xi, Ti);
          case ct.NumericHex:
            return this.stateNumericHex(xi, Ti);
          case ct.NamedEntity:
            return this.stateNamedEntity(xi, Ti);
        }
      }, di.prototype.stateNumericStart = function(xi, Ti) {
        return Ti >= xi.length ? -1 : (xi.charCodeAt(Ti) | nt) === Je.LOWER_X ? (this.state = ct.NumericHex, this.consumed += 1, this.stateNumericHex(xi, Ti + 1)) : (this.state = ct.NumericDecimal, this.stateNumericDecimal(xi, Ti));
      }, di.prototype.addToNumericResult = function(xi, Ti, Ai, mi) {
        if (Ti !== Ai) {
          var Si = Ai - Ti;
          this.result = this.result * Math.pow(mi, Si) + parseInt(xi.substr(Ti, Si), mi), this.consumed += Si;
        }
      }, di.prototype.stateNumericHex = function(xi, Ti) {
        for (var Ai = Ti; Ti < xi.length; ) {
          var mi = xi.charCodeAt(Ti);
          if (ot(mi) || lt(mi))
            Ti += 1;
          else
            return this.addToNumericResult(xi, Ai, Ti, 16), this.emitNumericEntity(mi, 3);
        }
        return this.addToNumericResult(xi, Ai, Ti, 16), -1;
      }, di.prototype.stateNumericDecimal = function(xi, Ti) {
        for (var Ai = Ti; Ti < xi.length; ) {
          var mi = xi.charCodeAt(Ti);
          if (ot(mi))
            Ti += 1;
          else
            return this.addToNumericResult(xi, Ai, Ti, 10), this.emitNumericEntity(mi, 2);
        }
        return this.addToNumericResult(xi, Ai, Ti, 10), -1;
      }, di.prototype.emitNumericEntity = function(xi, Ti) {
        var Ai;
        if (this.consumed <= Ti)
          return (Ai = this.errors) === null || Ai === void 0 || Ai.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (xi === Je.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === _r.Strict)
          return 0;
        return this.emitCodePoint((0, Ye.replaceCodePoint)(this.result), this.consumed), this.errors && (xi !== Je.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, di.prototype.stateNamedEntity = function(xi, Ti) {
        for (var Ai = this.decodeTree, mi = Ai[this.treeIndex], Si = (mi & st.VALUE_LENGTH) >> 14; Ti < xi.length; Ti++, this.excess++) {
          var gi = xi.charCodeAt(Ti);
          if (this.treeIndex = Jr(Ai, mi, this.treeIndex + Math.max(1, Si), gi), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === _r.Attribute && // We shouldn't have consumed any characters after the entity,
            (Si === 0 || // And there should be no invalid characters.
            gt(gi)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (mi = Ai[this.treeIndex], Si = (mi & st.VALUE_LENGTH) >> 14, Si !== 0) {
            if (gi === Je.SEMI)
              return this.emitNamedEntityData(this.treeIndex, Si, this.consumed + this.excess);
            this.decodeMode !== _r.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, di.prototype.emitNotTerminatedNamedEntity = function() {
        var xi, Ti = this, Ai = Ti.result, mi = Ti.decodeTree, Si = (mi[Ai] & st.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(Ai, Si, this.consumed), (xi = this.errors) === null || xi === void 0 || xi.missingSemicolonAfterCharacterReference(), this.consumed;
      }, di.prototype.emitNamedEntityData = function(xi, Ti, Ai) {
        var mi = this.decodeTree;
        return this.emitCodePoint(Ti === 1 ? mi[xi] & ~st.VALUE_LENGTH : mi[xi + 1], Ai), Ti === 3 && this.emitCodePoint(mi[xi + 2], Ai), Ai;
      }, di.prototype.end = function() {
        var xi;
        switch (this.state) {
          case ct.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== _r.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case ct.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case ct.NumericHex:
            return this.emitNumericEntity(0, 3);
          case ct.NumericStart:
            return (xi = this.errors) === null || xi === void 0 || xi.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case ct.EntityStart:
            return 0;
        }
      }, di;
    }()
  );
  ie.EntityDecoder = Kr;
  function Xr(di) {
    var xi = "", Ti = new Kr(di, function(Ai) {
      return xi += (0, Ye.fromCodePoint)(Ai);
    });
    return function(mi, Si) {
      for (var gi = 0, _i = 0; (_i = mi.indexOf("&", _i)) >= 0; ) {
        xi += mi.slice(gi, _i), Ti.startEntity(Si);
        var Oi = Ti.write(
          mi,
          // Skip the "&"
          _i + 1
        );
        if (Oi < 0) {
          gi = _i + Ti.end();
          break;
        }
        gi = _i + Oi, _i = Oi === 0 ? gi + 1 : gi;
      }
      var hi = xi + mi.slice(gi);
      return xi = "", hi;
    };
  }
  function Jr(di, xi, Ti, Ai) {
    var mi = (xi & st.BRANCH_LENGTH) >> 7, Si = xi & st.JUMP_TABLE;
    if (mi === 0)
      return Si !== 0 && Ai === Si ? Ti : -1;
    if (Si) {
      var gi = Ai - Si;
      return gi < 0 || gi >= mi ? -1 : di[Ti + gi] - 1;
    }
    for (var _i = Ti, Oi = _i + mi - 1; _i <= Oi; ) {
      var hi = _i + Oi >>> 1, Di = di[hi];
      if (Di < Ai)
        _i = hi + 1;
      else if (Di > Ai)
        Oi = hi - 1;
      else
        return di[hi + mi];
    }
    return -1;
  }
  ie.determineBranch = Jr;
  var ei = Xr(ye.default), si = Xr(be.default);
  function ri(di, xi) {
    return xi === void 0 && (xi = _r.Legacy), ei(di, xi);
  }
  ie.decodeHTML = ri;
  function ai(di) {
    return ei(di, _r.Attribute);
  }
  ie.decodeHTMLAttribute = ai;
  function yi(di) {
    return ei(di, _r.Strict);
  }
  ie.decodeHTMLStrict = yi;
  function pi(di) {
    return si(di, _r.Strict);
  }
  ie.decodeXML = pi;
})(decode);
(function(ie) {
  Object.defineProperty(ie, "__esModule", { value: !0 }), ie.QuoteType = void 0;
  var Z = decode, ee;
  (function(ot) {
    ot[ot.Tab = 9] = "Tab", ot[ot.NewLine = 10] = "NewLine", ot[ot.FormFeed = 12] = "FormFeed", ot[ot.CarriageReturn = 13] = "CarriageReturn", ot[ot.Space = 32] = "Space", ot[ot.ExclamationMark = 33] = "ExclamationMark", ot[ot.Number = 35] = "Number", ot[ot.Amp = 38] = "Amp", ot[ot.SingleQuote = 39] = "SingleQuote", ot[ot.DoubleQuote = 34] = "DoubleQuote", ot[ot.Dash = 45] = "Dash", ot[ot.Slash = 47] = "Slash", ot[ot.Zero = 48] = "Zero", ot[ot.Nine = 57] = "Nine", ot[ot.Semi = 59] = "Semi", ot[ot.Lt = 60] = "Lt", ot[ot.Eq = 61] = "Eq", ot[ot.Gt = 62] = "Gt", ot[ot.Questionmark = 63] = "Questionmark", ot[ot.UpperA = 65] = "UpperA", ot[ot.LowerA = 97] = "LowerA", ot[ot.UpperF = 70] = "UpperF", ot[ot.LowerF = 102] = "LowerF", ot[ot.UpperZ = 90] = "UpperZ", ot[ot.LowerZ = 122] = "LowerZ", ot[ot.LowerX = 120] = "LowerX", ot[ot.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(ee || (ee = {}));
  var ae;
  (function(ot) {
    ot[ot.Text = 1] = "Text", ot[ot.BeforeTagName = 2] = "BeforeTagName", ot[ot.InTagName = 3] = "InTagName", ot[ot.InSelfClosingTag = 4] = "InSelfClosingTag", ot[ot.BeforeClosingTagName = 5] = "BeforeClosingTagName", ot[ot.InClosingTagName = 6] = "InClosingTagName", ot[ot.AfterClosingTagName = 7] = "AfterClosingTagName", ot[ot.BeforeAttributeName = 8] = "BeforeAttributeName", ot[ot.InAttributeName = 9] = "InAttributeName", ot[ot.AfterAttributeName = 10] = "AfterAttributeName", ot[ot.BeforeAttributeValue = 11] = "BeforeAttributeValue", ot[ot.InAttributeValueDq = 12] = "InAttributeValueDq", ot[ot.InAttributeValueSq = 13] = "InAttributeValueSq", ot[ot.InAttributeValueNq = 14] = "InAttributeValueNq", ot[ot.BeforeDeclaration = 15] = "BeforeDeclaration", ot[ot.InDeclaration = 16] = "InDeclaration", ot[ot.InProcessingInstruction = 17] = "InProcessingInstruction", ot[ot.BeforeComment = 18] = "BeforeComment", ot[ot.CDATASequence = 19] = "CDATASequence", ot[ot.InSpecialComment = 20] = "InSpecialComment", ot[ot.InCommentLike = 21] = "InCommentLike", ot[ot.BeforeSpecialS = 22] = "BeforeSpecialS", ot[ot.SpecialStartSequence = 23] = "SpecialStartSequence", ot[ot.InSpecialTag = 24] = "InSpecialTag", ot[ot.BeforeEntity = 25] = "BeforeEntity", ot[ot.BeforeNumericEntity = 26] = "BeforeNumericEntity", ot[ot.InNamedEntity = 27] = "InNamedEntity", ot[ot.InNumericEntity = 28] = "InNumericEntity", ot[ot.InHexEntity = 29] = "InHexEntity";
  })(ae || (ae = {}));
  function ve(ot) {
    return ot === ee.Space || ot === ee.NewLine || ot === ee.Tab || ot === ee.FormFeed || ot === ee.CarriageReturn;
  }
  function ye(ot) {
    return ot === ee.Slash || ot === ee.Gt || ve(ot);
  }
  function be(ot) {
    return ot >= ee.Zero && ot <= ee.Nine;
  }
  function Ye(ot) {
    return ot >= ee.LowerA && ot <= ee.LowerZ || ot >= ee.UpperA && ot <= ee.UpperZ;
  }
  function Qe(ot) {
    return ot >= ee.UpperA && ot <= ee.UpperF || ot >= ee.LowerA && ot <= ee.LowerF;
  }
  var Je;
  (function(ot) {
    ot[ot.NoValue = 0] = "NoValue", ot[ot.Unquoted = 1] = "Unquoted", ot[ot.Single = 2] = "Single", ot[ot.Double = 3] = "Double";
  })(Je = ie.QuoteType || (ie.QuoteType = {}));
  var nt = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, st = (
    /** @class */
    function() {
      function ot(lt, ft) {
        var gt = lt.xmlMode, ct = gt === void 0 ? !1 : gt, _r = lt.decodeEntities, Kr = _r === void 0 ? !0 : _r;
        this.cbs = ft, this.state = ae.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = ae.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = ct, this.decodeEntities = Kr, this.entityTrie = ct ? Z.xmlDecodeTree : Z.htmlDecodeTree;
      }
      return ot.prototype.reset = function() {
        this.state = ae.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = ae.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
      }, ot.prototype.write = function(lt) {
        this.offset += this.buffer.length, this.buffer = lt, this.parse();
      }, ot.prototype.end = function() {
        this.running && this.finish();
      }, ot.prototype.pause = function() {
        this.running = !1;
      }, ot.prototype.resume = function() {
        this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
      }, ot.prototype.getIndex = function() {
        return this.index;
      }, ot.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, ot.prototype.stateText = function(lt) {
        lt === ee.Lt || !this.decodeEntities && this.fastForwardTo(ee.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = ae.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && lt === ee.Amp && (this.state = ae.BeforeEntity);
      }, ot.prototype.stateSpecialStartSequence = function(lt) {
        var ft = this.sequenceIndex === this.currentSequence.length, gt = ft ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          ye(lt)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (lt | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!gt)
          this.isSpecial = !1;
        else if (!ft) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = ae.InTagName, this.stateInTagName(lt);
      }, ot.prototype.stateInSpecialTag = function(lt) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (lt === ee.Gt || ve(lt)) {
            var ft = this.index - this.currentSequence.length;
            if (this.sectionStart < ft) {
              var gt = this.index;
              this.index = ft, this.cbs.ontext(this.sectionStart, ft), this.index = gt;
            }
            this.isSpecial = !1, this.sectionStart = ft + 2, this.stateInClosingTagName(lt);
            return;
          }
          this.sequenceIndex = 0;
        }
        (lt | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === nt.TitleEnd ? this.decodeEntities && lt === ee.Amp && (this.state = ae.BeforeEntity) : this.fastForwardTo(ee.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(lt === ee.Lt);
      }, ot.prototype.stateCDATASequence = function(lt) {
        lt === nt.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === nt.Cdata.length && (this.state = ae.InCommentLike, this.currentSequence = nt.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = ae.InDeclaration, this.stateInDeclaration(lt));
      }, ot.prototype.fastForwardTo = function(lt) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === lt)
            return !0;
        return this.index = this.buffer.length + this.offset - 1, !1;
      }, ot.prototype.stateInCommentLike = function(lt) {
        lt === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === nt.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = ae.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : lt !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, ot.prototype.isTagStartChar = function(lt) {
        return this.xmlMode ? !ye(lt) : Ye(lt);
      }, ot.prototype.startSpecial = function(lt, ft) {
        this.isSpecial = !0, this.currentSequence = lt, this.sequenceIndex = ft, this.state = ae.SpecialStartSequence;
      }, ot.prototype.stateBeforeTagName = function(lt) {
        if (lt === ee.ExclamationMark)
          this.state = ae.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (lt === ee.Questionmark)
          this.state = ae.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(lt)) {
          var ft = lt | 32;
          this.sectionStart = this.index, !this.xmlMode && ft === nt.TitleEnd[2] ? this.startSpecial(nt.TitleEnd, 3) : this.state = !this.xmlMode && ft === nt.ScriptEnd[2] ? ae.BeforeSpecialS : ae.InTagName;
        } else
          lt === ee.Slash ? this.state = ae.BeforeClosingTagName : (this.state = ae.Text, this.stateText(lt));
      }, ot.prototype.stateInTagName = function(lt) {
        ye(lt) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = ae.BeforeAttributeName, this.stateBeforeAttributeName(lt));
      }, ot.prototype.stateBeforeClosingTagName = function(lt) {
        ve(lt) || (lt === ee.Gt ? this.state = ae.Text : (this.state = this.isTagStartChar(lt) ? ae.InClosingTagName : ae.InSpecialComment, this.sectionStart = this.index));
      }, ot.prototype.stateInClosingTagName = function(lt) {
        (lt === ee.Gt || ve(lt)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = ae.AfterClosingTagName, this.stateAfterClosingTagName(lt));
      }, ot.prototype.stateAfterClosingTagName = function(lt) {
        (lt === ee.Gt || this.fastForwardTo(ee.Gt)) && (this.state = ae.Text, this.baseState = ae.Text, this.sectionStart = this.index + 1);
      }, ot.prototype.stateBeforeAttributeName = function(lt) {
        lt === ee.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = ae.InSpecialTag, this.sequenceIndex = 0) : this.state = ae.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : lt === ee.Slash ? this.state = ae.InSelfClosingTag : ve(lt) || (this.state = ae.InAttributeName, this.sectionStart = this.index);
      }, ot.prototype.stateInSelfClosingTag = function(lt) {
        lt === ee.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = ae.Text, this.baseState = ae.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : ve(lt) || (this.state = ae.BeforeAttributeName, this.stateBeforeAttributeName(lt));
      }, ot.prototype.stateInAttributeName = function(lt) {
        (lt === ee.Eq || ye(lt)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = ae.AfterAttributeName, this.stateAfterAttributeName(lt));
      }, ot.prototype.stateAfterAttributeName = function(lt) {
        lt === ee.Eq ? this.state = ae.BeforeAttributeValue : lt === ee.Slash || lt === ee.Gt ? (this.cbs.onattribend(Je.NoValue, this.index), this.state = ae.BeforeAttributeName, this.stateBeforeAttributeName(lt)) : ve(lt) || (this.cbs.onattribend(Je.NoValue, this.index), this.state = ae.InAttributeName, this.sectionStart = this.index);
      }, ot.prototype.stateBeforeAttributeValue = function(lt) {
        lt === ee.DoubleQuote ? (this.state = ae.InAttributeValueDq, this.sectionStart = this.index + 1) : lt === ee.SingleQuote ? (this.state = ae.InAttributeValueSq, this.sectionStart = this.index + 1) : ve(lt) || (this.sectionStart = this.index, this.state = ae.InAttributeValueNq, this.stateInAttributeValueNoQuotes(lt));
      }, ot.prototype.handleInAttributeValue = function(lt, ft) {
        lt === ft || !this.decodeEntities && this.fastForwardTo(ft) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(ft === ee.DoubleQuote ? Je.Double : Je.Single, this.index), this.state = ae.BeforeAttributeName) : this.decodeEntities && lt === ee.Amp && (this.baseState = this.state, this.state = ae.BeforeEntity);
      }, ot.prototype.stateInAttributeValueDoubleQuotes = function(lt) {
        this.handleInAttributeValue(lt, ee.DoubleQuote);
      }, ot.prototype.stateInAttributeValueSingleQuotes = function(lt) {
        this.handleInAttributeValue(lt, ee.SingleQuote);
      }, ot.prototype.stateInAttributeValueNoQuotes = function(lt) {
        ve(lt) || lt === ee.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(Je.Unquoted, this.index), this.state = ae.BeforeAttributeName, this.stateBeforeAttributeName(lt)) : this.decodeEntities && lt === ee.Amp && (this.baseState = this.state, this.state = ae.BeforeEntity);
      }, ot.prototype.stateBeforeDeclaration = function(lt) {
        lt === ee.OpeningSquareBracket ? (this.state = ae.CDATASequence, this.sequenceIndex = 0) : this.state = lt === ee.Dash ? ae.BeforeComment : ae.InDeclaration;
      }, ot.prototype.stateInDeclaration = function(lt) {
        (lt === ee.Gt || this.fastForwardTo(ee.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = ae.Text, this.sectionStart = this.index + 1);
      }, ot.prototype.stateInProcessingInstruction = function(lt) {
        (lt === ee.Gt || this.fastForwardTo(ee.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = ae.Text, this.sectionStart = this.index + 1);
      }, ot.prototype.stateBeforeComment = function(lt) {
        lt === ee.Dash ? (this.state = ae.InCommentLike, this.currentSequence = nt.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = ae.InDeclaration;
      }, ot.prototype.stateInSpecialComment = function(lt) {
        (lt === ee.Gt || this.fastForwardTo(ee.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = ae.Text, this.sectionStart = this.index + 1);
      }, ot.prototype.stateBeforeSpecialS = function(lt) {
        var ft = lt | 32;
        ft === nt.ScriptEnd[3] ? this.startSpecial(nt.ScriptEnd, 4) : ft === nt.StyleEnd[3] ? this.startSpecial(nt.StyleEnd, 4) : (this.state = ae.InTagName, this.stateInTagName(lt));
      }, ot.prototype.stateBeforeEntity = function(lt) {
        this.entityExcess = 1, this.entityResult = 0, lt === ee.Number ? this.state = ae.BeforeNumericEntity : lt === ee.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = ae.InNamedEntity, this.stateInNamedEntity(lt));
      }, ot.prototype.stateInNamedEntity = function(lt) {
        if (this.entityExcess += 1, this.trieIndex = (0, Z.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, lt), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var ft = this.trieCurrent & Z.BinTrieFlags.VALUE_LENGTH;
        if (ft) {
          var gt = (ft >> 14) - 1;
          if (!this.allowLegacyEntity() && lt !== ee.Semi)
            this.trieIndex += gt;
          else {
            var ct = this.index - this.entityExcess + 1;
            ct > this.sectionStart && this.emitPartial(this.sectionStart, ct), this.entityResult = this.trieIndex, this.trieIndex += gt, this.entityExcess = 0, this.sectionStart = this.index + 1, gt === 0 && this.emitNamedEntity();
          }
        }
      }, ot.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var lt = (this.entityTrie[this.entityResult] & Z.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (lt) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~Z.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, ot.prototype.stateBeforeNumericEntity = function(lt) {
        (lt | 32) === ee.LowerX ? (this.entityExcess++, this.state = ae.InHexEntity) : (this.state = ae.InNumericEntity, this.stateInNumericEntity(lt));
      }, ot.prototype.emitNumericEntity = function(lt) {
        var ft = this.index - this.entityExcess - 1, gt = ft + 2 + +(this.state === ae.InHexEntity);
        gt !== this.index && (ft > this.sectionStart && this.emitPartial(this.sectionStart, ft), this.sectionStart = this.index + Number(lt), this.emitCodePoint((0, Z.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, ot.prototype.stateInNumericEntity = function(lt) {
        lt === ee.Semi ? this.emitNumericEntity(!0) : be(lt) ? (this.entityResult = this.entityResult * 10 + (lt - ee.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, ot.prototype.stateInHexEntity = function(lt) {
        lt === ee.Semi ? this.emitNumericEntity(!0) : be(lt) ? (this.entityResult = this.entityResult * 16 + (lt - ee.Zero), this.entityExcess++) : Qe(lt) ? (this.entityResult = this.entityResult * 16 + ((lt | 32) - ee.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, ot.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === ae.Text || this.baseState === ae.InSpecialTag);
      }, ot.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === ae.Text || this.state === ae.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === ae.InAttributeValueDq || this.state === ae.InAttributeValueSq || this.state === ae.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, ot.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, ot.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var lt = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case ae.Text: {
              this.stateText(lt);
              break;
            }
            case ae.SpecialStartSequence: {
              this.stateSpecialStartSequence(lt);
              break;
            }
            case ae.InSpecialTag: {
              this.stateInSpecialTag(lt);
              break;
            }
            case ae.CDATASequence: {
              this.stateCDATASequence(lt);
              break;
            }
            case ae.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(lt);
              break;
            }
            case ae.InAttributeName: {
              this.stateInAttributeName(lt);
              break;
            }
            case ae.InCommentLike: {
              this.stateInCommentLike(lt);
              break;
            }
            case ae.InSpecialComment: {
              this.stateInSpecialComment(lt);
              break;
            }
            case ae.BeforeAttributeName: {
              this.stateBeforeAttributeName(lt);
              break;
            }
            case ae.InTagName: {
              this.stateInTagName(lt);
              break;
            }
            case ae.InClosingTagName: {
              this.stateInClosingTagName(lt);
              break;
            }
            case ae.BeforeTagName: {
              this.stateBeforeTagName(lt);
              break;
            }
            case ae.AfterAttributeName: {
              this.stateAfterAttributeName(lt);
              break;
            }
            case ae.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(lt);
              break;
            }
            case ae.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(lt);
              break;
            }
            case ae.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(lt);
              break;
            }
            case ae.AfterClosingTagName: {
              this.stateAfterClosingTagName(lt);
              break;
            }
            case ae.BeforeSpecialS: {
              this.stateBeforeSpecialS(lt);
              break;
            }
            case ae.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(lt);
              break;
            }
            case ae.InSelfClosingTag: {
              this.stateInSelfClosingTag(lt);
              break;
            }
            case ae.InDeclaration: {
              this.stateInDeclaration(lt);
              break;
            }
            case ae.BeforeDeclaration: {
              this.stateBeforeDeclaration(lt);
              break;
            }
            case ae.BeforeComment: {
              this.stateBeforeComment(lt);
              break;
            }
            case ae.InProcessingInstruction: {
              this.stateInProcessingInstruction(lt);
              break;
            }
            case ae.InNamedEntity: {
              this.stateInNamedEntity(lt);
              break;
            }
            case ae.BeforeEntity: {
              this.stateBeforeEntity(lt);
              break;
            }
            case ae.InHexEntity: {
              this.stateInHexEntity(lt);
              break;
            }
            case ae.InNumericEntity: {
              this.stateInNumericEntity(lt);
              break;
            }
            default:
              this.stateBeforeNumericEntity(lt);
          }
          this.index++;
        }
        this.cleanup();
      }, ot.prototype.finish = function() {
        this.state === ae.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, ot.prototype.handleTrailingData = function() {
        var lt = this.buffer.length + this.offset;
        this.state === ae.InCommentLike ? this.currentSequence === nt.CdataEnd ? this.cbs.oncdata(this.sectionStart, lt, 0) : this.cbs.oncomment(this.sectionStart, lt, 0) : this.state === ae.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === ae.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === ae.InTagName || this.state === ae.BeforeAttributeName || this.state === ae.BeforeAttributeValue || this.state === ae.AfterAttributeName || this.state === ae.InAttributeName || this.state === ae.InAttributeValueSq || this.state === ae.InAttributeValueDq || this.state === ae.InAttributeValueNq || this.state === ae.InClosingTagName || this.cbs.ontext(this.sectionStart, lt);
      }, ot.prototype.emitPartial = function(lt, ft) {
        this.baseState !== ae.Text && this.baseState !== ae.InSpecialTag ? this.cbs.onattribdata(lt, ft) : this.cbs.ontext(lt, ft);
      }, ot.prototype.emitCodePoint = function(lt) {
        this.baseState !== ae.Text && this.baseState !== ae.InSpecialTag ? this.cbs.onattribentity(lt) : this.cbs.ontextentity(lt);
      }, ot;
    }()
  );
  ie.default = st;
})(Tokenizer);
var __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(ie, Z, ee, ae) {
  ae === void 0 && (ae = ee);
  var ve = Object.getOwnPropertyDescriptor(Z, ee);
  (!ve || ("get" in ve ? !Z.__esModule : ve.writable || ve.configurable)) && (ve = { enumerable: !0, get: function() {
    return Z[ee];
  } }), Object.defineProperty(ie, ae, ve);
} : function(ie, Z, ee, ae) {
  ae === void 0 && (ae = ee), ie[ae] = Z[ee];
}), __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(ie, Z) {
  Object.defineProperty(ie, "default", { enumerable: !0, value: Z });
} : function(ie, Z) {
  ie.default = Z;
}), __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(ie) {
  if (ie && ie.__esModule)
    return ie;
  var Z = {};
  if (ie != null)
    for (var ee in ie)
      ee !== "default" && Object.prototype.hasOwnProperty.call(ie, ee) && __createBinding$1(Z, ie, ee);
  return __setModuleDefault$1(Z, ie), Z;
};
Object.defineProperty(Parser$3, "__esModule", { value: !0 });
Parser$3.Parser = void 0;
var Tokenizer_js_1 = __importStar$1(Tokenizer), decode_js_1 = decode, formTags = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), pTag = /* @__PURE__ */ new Set(["p"]), tableSectionTags = /* @__PURE__ */ new Set(["thead", "tbody"]), ddtTags = /* @__PURE__ */ new Set(["dd", "dt"]), rtpTags = /* @__PURE__ */ new Set(["rt", "rp"]), openImpliesClose = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", pTag],
  ["h1", pTag],
  ["h2", pTag],
  ["h3", pTag],
  ["h4", pTag],
  ["h5", pTag],
  ["h6", pTag],
  ["select", formTags],
  ["input", formTags],
  ["output", formTags],
  ["button", formTags],
  ["datalist", formTags],
  ["textarea", formTags],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", ddtTags],
  ["dt", ddtTags],
  ["address", pTag],
  ["article", pTag],
  ["aside", pTag],
  ["blockquote", pTag],
  ["details", pTag],
  ["div", pTag],
  ["dl", pTag],
  ["fieldset", pTag],
  ["figcaption", pTag],
  ["figure", pTag],
  ["footer", pTag],
  ["form", pTag],
  ["header", pTag],
  ["hr", pTag],
  ["main", pTag],
  ["nav", pTag],
  ["ol", pTag],
  ["pre", pTag],
  ["section", pTag],
  ["table", pTag],
  ["ul", pTag],
  ["rt", rtpTags],
  ["rp", rtpTags],
  ["tbody", tableSectionTags],
  ["tfoot", tableSectionTags]
]), voidElements = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), foreignContextElements = /* @__PURE__ */ new Set(["math", "svg"]), htmlIntegrationElements = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), reNameEnd = /\s|\//, Parser$2 = (
  /** @class */
  function() {
    function ie(Z, ee) {
      ee === void 0 && (ee = {});
      var ae, ve, ye, be, Ye;
      this.options = ee, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = Z ?? {}, this.lowerCaseTagNames = (ae = ee.lowerCaseTags) !== null && ae !== void 0 ? ae : !ee.xmlMode, this.lowerCaseAttributeNames = (ve = ee.lowerCaseAttributeNames) !== null && ve !== void 0 ? ve : !ee.xmlMode, this.tokenizer = new ((ye = ee.Tokenizer) !== null && ye !== void 0 ? ye : Tokenizer_js_1.default)(this.options, this), (Ye = (be = this.cbs).onparserinit) === null || Ye === void 0 || Ye.call(be, this);
    }
    return ie.prototype.ontext = function(Z, ee) {
      var ae, ve, ye = this.getSlice(Z, ee);
      this.endIndex = ee - 1, (ve = (ae = this.cbs).ontext) === null || ve === void 0 || ve.call(ae, ye), this.startIndex = ee;
    }, ie.prototype.ontextentity = function(Z) {
      var ee, ae, ve = this.tokenizer.getSectionStart();
      this.endIndex = ve - 1, (ae = (ee = this.cbs).ontext) === null || ae === void 0 || ae.call(ee, (0, decode_js_1.fromCodePoint)(Z)), this.startIndex = ve;
    }, ie.prototype.isVoidElement = function(Z) {
      return !this.options.xmlMode && voidElements.has(Z);
    }, ie.prototype.onopentagname = function(Z, ee) {
      this.endIndex = ee;
      var ae = this.getSlice(Z, ee);
      this.lowerCaseTagNames && (ae = ae.toLowerCase()), this.emitOpenTag(ae);
    }, ie.prototype.emitOpenTag = function(Z) {
      var ee, ae, ve, ye;
      this.openTagStart = this.startIndex, this.tagname = Z;
      var be = !this.options.xmlMode && openImpliesClose.get(Z);
      if (be)
        for (; this.stack.length > 0 && be.has(this.stack[this.stack.length - 1]); ) {
          var Ye = this.stack.pop();
          (ae = (ee = this.cbs).onclosetag) === null || ae === void 0 || ae.call(ee, Ye, !0);
        }
      this.isVoidElement(Z) || (this.stack.push(Z), foreignContextElements.has(Z) ? this.foreignContext.push(!0) : htmlIntegrationElements.has(Z) && this.foreignContext.push(!1)), (ye = (ve = this.cbs).onopentagname) === null || ye === void 0 || ye.call(ve, Z), this.cbs.onopentag && (this.attribs = {});
    }, ie.prototype.endOpenTag = function(Z) {
      var ee, ae;
      this.startIndex = this.openTagStart, this.attribs && ((ae = (ee = this.cbs).onopentag) === null || ae === void 0 || ae.call(ee, this.tagname, this.attribs, Z), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, ie.prototype.onopentagend = function(Z) {
      this.endIndex = Z, this.endOpenTag(!1), this.startIndex = Z + 1;
    }, ie.prototype.onclosetag = function(Z, ee) {
      var ae, ve, ye, be, Ye, Qe;
      this.endIndex = ee;
      var Je = this.getSlice(Z, ee);
      if (this.lowerCaseTagNames && (Je = Je.toLowerCase()), (foreignContextElements.has(Je) || htmlIntegrationElements.has(Je)) && this.foreignContext.pop(), this.isVoidElement(Je))
        !this.options.xmlMode && Je === "br" && ((ve = (ae = this.cbs).onopentagname) === null || ve === void 0 || ve.call(ae, "br"), (be = (ye = this.cbs).onopentag) === null || be === void 0 || be.call(ye, "br", {}, !0), (Qe = (Ye = this.cbs).onclosetag) === null || Qe === void 0 || Qe.call(Ye, "br", !1));
      else {
        var nt = this.stack.lastIndexOf(Je);
        if (nt !== -1)
          if (this.cbs.onclosetag)
            for (var st = this.stack.length - nt; st--; )
              this.cbs.onclosetag(this.stack.pop(), st !== 0);
          else
            this.stack.length = nt;
        else
          !this.options.xmlMode && Je === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = ee + 1;
    }, ie.prototype.onselfclosingtag = function(Z) {
      this.endIndex = Z, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = Z + 1) : this.onopentagend(Z);
    }, ie.prototype.closeCurrentTag = function(Z) {
      var ee, ae, ve = this.tagname;
      this.endOpenTag(Z), this.stack[this.stack.length - 1] === ve && ((ae = (ee = this.cbs).onclosetag) === null || ae === void 0 || ae.call(ee, ve, !Z), this.stack.pop());
    }, ie.prototype.onattribname = function(Z, ee) {
      this.startIndex = Z;
      var ae = this.getSlice(Z, ee);
      this.attribname = this.lowerCaseAttributeNames ? ae.toLowerCase() : ae;
    }, ie.prototype.onattribdata = function(Z, ee) {
      this.attribvalue += this.getSlice(Z, ee);
    }, ie.prototype.onattribentity = function(Z) {
      this.attribvalue += (0, decode_js_1.fromCodePoint)(Z);
    }, ie.prototype.onattribend = function(Z, ee) {
      var ae, ve;
      this.endIndex = ee, (ve = (ae = this.cbs).onattribute) === null || ve === void 0 || ve.call(ae, this.attribname, this.attribvalue, Z === Tokenizer_js_1.QuoteType.Double ? '"' : Z === Tokenizer_js_1.QuoteType.Single ? "'" : Z === Tokenizer_js_1.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, ie.prototype.getInstructionName = function(Z) {
      var ee = Z.search(reNameEnd), ae = ee < 0 ? Z : Z.substr(0, ee);
      return this.lowerCaseTagNames && (ae = ae.toLowerCase()), ae;
    }, ie.prototype.ondeclaration = function(Z, ee) {
      this.endIndex = ee;
      var ae = this.getSlice(Z, ee);
      if (this.cbs.onprocessinginstruction) {
        var ve = this.getInstructionName(ae);
        this.cbs.onprocessinginstruction("!".concat(ve), "!".concat(ae));
      }
      this.startIndex = ee + 1;
    }, ie.prototype.onprocessinginstruction = function(Z, ee) {
      this.endIndex = ee;
      var ae = this.getSlice(Z, ee);
      if (this.cbs.onprocessinginstruction) {
        var ve = this.getInstructionName(ae);
        this.cbs.onprocessinginstruction("?".concat(ve), "?".concat(ae));
      }
      this.startIndex = ee + 1;
    }, ie.prototype.oncomment = function(Z, ee, ae) {
      var ve, ye, be, Ye;
      this.endIndex = ee, (ye = (ve = this.cbs).oncomment) === null || ye === void 0 || ye.call(ve, this.getSlice(Z, ee - ae)), (Ye = (be = this.cbs).oncommentend) === null || Ye === void 0 || Ye.call(be), this.startIndex = ee + 1;
    }, ie.prototype.oncdata = function(Z, ee, ae) {
      var ve, ye, be, Ye, Qe, Je, nt, st, ot, lt;
      this.endIndex = ee;
      var ft = this.getSlice(Z, ee - ae);
      this.options.xmlMode || this.options.recognizeCDATA ? ((ye = (ve = this.cbs).oncdatastart) === null || ye === void 0 || ye.call(ve), (Ye = (be = this.cbs).ontext) === null || Ye === void 0 || Ye.call(be, ft), (Je = (Qe = this.cbs).oncdataend) === null || Je === void 0 || Je.call(Qe)) : ((st = (nt = this.cbs).oncomment) === null || st === void 0 || st.call(nt, "[CDATA[".concat(ft, "]]")), (lt = (ot = this.cbs).oncommentend) === null || lt === void 0 || lt.call(ot)), this.startIndex = ee + 1;
    }, ie.prototype.onend = function() {
      var Z, ee;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var ae = this.stack.length; ae > 0; this.cbs.onclosetag(this.stack[--ae], !0))
          ;
      }
      (ee = (Z = this.cbs).onend) === null || ee === void 0 || ee.call(Z);
    }, ie.prototype.reset = function() {
      var Z, ee, ae, ve;
      (ee = (Z = this.cbs).onreset) === null || ee === void 0 || ee.call(Z), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (ve = (ae = this.cbs).onparserinit) === null || ve === void 0 || ve.call(ae, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, ie.prototype.parseComplete = function(Z) {
      this.reset(), this.end(Z);
    }, ie.prototype.getSlice = function(Z, ee) {
      for (; Z - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var ae = this.buffers[0].slice(Z - this.bufferOffset, ee - this.bufferOffset); ee - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), ae += this.buffers[0].slice(0, ee - this.bufferOffset);
      return ae;
    }, ie.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, ie.prototype.write = function(Z) {
      var ee, ae;
      if (this.ended) {
        (ae = (ee = this.cbs).onerror) === null || ae === void 0 || ae.call(ee, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(Z), this.tokenizer.running && (this.tokenizer.write(Z), this.writeIndex++);
    }, ie.prototype.end = function(Z) {
      var ee, ae;
      if (this.ended) {
        (ae = (ee = this.cbs).onerror) === null || ae === void 0 || ae.call(ee, new Error(".end() after done!"));
        return;
      }
      Z && this.write(Z), this.ended = !0, this.tokenizer.end();
    }, ie.prototype.pause = function() {
      this.tokenizer.pause();
    }, ie.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, ie.prototype.parseChunk = function(Z) {
      this.write(Z);
    }, ie.prototype.done = function(Z) {
      this.end(Z);
    }, ie;
  }()
);
Parser$3.Parser = Parser$2;
var lib$4 = {}, lib$3 = {};
(function(ie) {
  Object.defineProperty(ie, "__esModule", { value: !0 }), ie.Doctype = ie.CDATA = ie.Tag = ie.Style = ie.Script = ie.Comment = ie.Directive = ie.Text = ie.Root = ie.isTag = ie.ElementType = void 0;
  var Z;
  (function(ae) {
    ae.Root = "root", ae.Text = "text", ae.Directive = "directive", ae.Comment = "comment", ae.Script = "script", ae.Style = "style", ae.Tag = "tag", ae.CDATA = "cdata", ae.Doctype = "doctype";
  })(Z = ie.ElementType || (ie.ElementType = {}));
  function ee(ae) {
    return ae.type === Z.Tag || ae.type === Z.Script || ae.type === Z.Style;
  }
  ie.isTag = ee, ie.Root = Z.Root, ie.Text = Z.Text, ie.Directive = Z.Directive, ie.Comment = Z.Comment, ie.Script = Z.Script, ie.Style = Z.Style, ie.Tag = Z.Tag, ie.CDATA = Z.CDATA, ie.Doctype = Z.Doctype;
})(lib$3);
var node$1 = {}, __extends = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var ie = function(Z, ee) {
    return ie = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ae, ve) {
      ae.__proto__ = ve;
    } || function(ae, ve) {
      for (var ye in ve)
        Object.prototype.hasOwnProperty.call(ve, ye) && (ae[ye] = ve[ye]);
    }, ie(Z, ee);
  };
  return function(Z, ee) {
    if (typeof ee != "function" && ee !== null)
      throw new TypeError("Class extends value " + String(ee) + " is not a constructor or null");
    ie(Z, ee);
    function ae() {
      this.constructor = Z;
    }
    Z.prototype = ee === null ? Object.create(ee) : (ae.prototype = ee.prototype, new ae());
  };
}(), __assign$2 = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign$2 = Object.assign || function(ie) {
    for (var Z, ee = 1, ae = arguments.length; ee < ae; ee++) {
      Z = arguments[ee];
      for (var ve in Z)
        Object.prototype.hasOwnProperty.call(Z, ve) && (ie[ve] = Z[ve]);
    }
    return ie;
  }, __assign$2.apply(this, arguments);
};
Object.defineProperty(node$1, "__esModule", { value: !0 });
node$1.cloneNode = node$1.hasChildren = node$1.isDocument = node$1.isDirective = node$1.isComment = node$1.isText = node$1.isCDATA = node$1.isTag = node$1.Element = node$1.Document = node$1.CDATA = node$1.NodeWithChildren = node$1.ProcessingInstruction = node$1.Comment = node$1.Text = node$1.DataNode = node$1.Node = void 0;
var domelementtype_1$1 = lib$3, Node$6 = (
  /** @class */
  function() {
    function ie() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(ie.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(Z) {
        this.parent = Z;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(ie.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(Z) {
        this.prev = Z;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(ie.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(Z) {
        this.next = Z;
      },
      enumerable: !1,
      configurable: !0
    }), ie.prototype.cloneNode = function(Z) {
      return Z === void 0 && (Z = !1), cloneNode$1(this, Z);
    }, ie;
  }()
);
node$1.Node = Node$6;
var DataNode = (
  /** @class */
  function(ie) {
    __extends(Z, ie);
    function Z(ee) {
      var ae = ie.call(this) || this;
      return ae.data = ee, ae;
    }
    return Object.defineProperty(Z.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(ee) {
        this.data = ee;
      },
      enumerable: !1,
      configurable: !0
    }), Z;
  }(Node$6)
);
node$1.DataNode = DataNode;
var Text = (
  /** @class */
  function(ie) {
    __extends(Z, ie);
    function Z() {
      var ee = ie !== null && ie.apply(this, arguments) || this;
      return ee.type = domelementtype_1$1.ElementType.Text, ee;
    }
    return Object.defineProperty(Z.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), Z;
  }(DataNode)
);
node$1.Text = Text;
var Comment$5 = (
  /** @class */
  function(ie) {
    __extends(Z, ie);
    function Z() {
      var ee = ie !== null && ie.apply(this, arguments) || this;
      return ee.type = domelementtype_1$1.ElementType.Comment, ee;
    }
    return Object.defineProperty(Z.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), Z;
  }(DataNode)
);
node$1.Comment = Comment$5;
var ProcessingInstruction = (
  /** @class */
  function(ie) {
    __extends(Z, ie);
    function Z(ee, ae) {
      var ve = ie.call(this, ae) || this;
      return ve.name = ee, ve.type = domelementtype_1$1.ElementType.Directive, ve;
    }
    return Object.defineProperty(Z.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Z;
  }(DataNode)
);
node$1.ProcessingInstruction = ProcessingInstruction;
var NodeWithChildren = (
  /** @class */
  function(ie) {
    __extends(Z, ie);
    function Z(ee) {
      var ae = ie.call(this) || this;
      return ae.children = ee, ae;
    }
    return Object.defineProperty(Z.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var ee;
        return (ee = this.children[0]) !== null && ee !== void 0 ? ee : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Z.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Z.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(ee) {
        this.children = ee;
      },
      enumerable: !1,
      configurable: !0
    }), Z;
  }(Node$6)
);
node$1.NodeWithChildren = NodeWithChildren;
var CDATA = (
  /** @class */
  function(ie) {
    __extends(Z, ie);
    function Z() {
      var ee = ie !== null && ie.apply(this, arguments) || this;
      return ee.type = domelementtype_1$1.ElementType.CDATA, ee;
    }
    return Object.defineProperty(Z.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), Z;
  }(NodeWithChildren)
);
node$1.CDATA = CDATA;
var Document$4 = (
  /** @class */
  function(ie) {
    __extends(Z, ie);
    function Z() {
      var ee = ie !== null && ie.apply(this, arguments) || this;
      return ee.type = domelementtype_1$1.ElementType.Root, ee;
    }
    return Object.defineProperty(Z.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), Z;
  }(NodeWithChildren)
);
node$1.Document = Document$4;
var Element$1 = (
  /** @class */
  function(ie) {
    __extends(Z, ie);
    function Z(ee, ae, ve, ye) {
      ve === void 0 && (ve = []), ye === void 0 && (ye = ee === "script" ? domelementtype_1$1.ElementType.Script : ee === "style" ? domelementtype_1$1.ElementType.Style : domelementtype_1$1.ElementType.Tag);
      var be = ie.call(this, ve) || this;
      return be.name = ee, be.attribs = ae, be.type = ye, be;
    }
    return Object.defineProperty(Z.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Z.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(ee) {
        this.name = ee;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Z.prototype, "attributes", {
      get: function() {
        var ee = this;
        return Object.keys(this.attribs).map(function(ae) {
          var ve, ye;
          return {
            name: ae,
            value: ee.attribs[ae],
            namespace: (ve = ee["x-attribsNamespace"]) === null || ve === void 0 ? void 0 : ve[ae],
            prefix: (ye = ee["x-attribsPrefix"]) === null || ye === void 0 ? void 0 : ye[ae]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), Z;
  }(NodeWithChildren)
);
node$1.Element = Element$1;
function isTag(ie) {
  return (0, domelementtype_1$1.isTag)(ie);
}
node$1.isTag = isTag;
function isCDATA(ie) {
  return ie.type === domelementtype_1$1.ElementType.CDATA;
}
node$1.isCDATA = isCDATA;
function isText(ie) {
  return ie.type === domelementtype_1$1.ElementType.Text;
}
node$1.isText = isText;
function isComment(ie) {
  return ie.type === domelementtype_1$1.ElementType.Comment;
}
node$1.isComment = isComment;
function isDirective(ie) {
  return ie.type === domelementtype_1$1.ElementType.Directive;
}
node$1.isDirective = isDirective;
function isDocument(ie) {
  return ie.type === domelementtype_1$1.ElementType.Root;
}
node$1.isDocument = isDocument;
function hasChildren(ie) {
  return Object.prototype.hasOwnProperty.call(ie, "children");
}
node$1.hasChildren = hasChildren;
function cloneNode$1(ie, Z) {
  Z === void 0 && (Z = !1);
  var ee;
  if (isText(ie))
    ee = new Text(ie.data);
  else if (isComment(ie))
    ee = new Comment$5(ie.data);
  else if (isTag(ie)) {
    var ae = Z ? cloneChildren(ie.children) : [], ve = new Element$1(ie.name, __assign$2({}, ie.attribs), ae);
    ae.forEach(function(Qe) {
      return Qe.parent = ve;
    }), ie.namespace != null && (ve.namespace = ie.namespace), ie["x-attribsNamespace"] && (ve["x-attribsNamespace"] = __assign$2({}, ie["x-attribsNamespace"])), ie["x-attribsPrefix"] && (ve["x-attribsPrefix"] = __assign$2({}, ie["x-attribsPrefix"])), ee = ve;
  } else if (isCDATA(ie)) {
    var ae = Z ? cloneChildren(ie.children) : [], ye = new CDATA(ae);
    ae.forEach(function(Je) {
      return Je.parent = ye;
    }), ee = ye;
  } else if (isDocument(ie)) {
    var ae = Z ? cloneChildren(ie.children) : [], be = new Document$4(ae);
    ae.forEach(function(Je) {
      return Je.parent = be;
    }), ie["x-mode"] && (be["x-mode"] = ie["x-mode"]), ee = be;
  } else if (isDirective(ie)) {
    var Ye = new ProcessingInstruction(ie.name, ie.data);
    ie["x-name"] != null && (Ye["x-name"] = ie["x-name"], Ye["x-publicId"] = ie["x-publicId"], Ye["x-systemId"] = ie["x-systemId"]), ee = Ye;
  } else
    throw new Error("Not implemented yet: ".concat(ie.type));
  return ee.startIndex = ie.startIndex, ee.endIndex = ie.endIndex, ie.sourceCodeLocation != null && (ee.sourceCodeLocation = ie.sourceCodeLocation), ee;
}
node$1.cloneNode = cloneNode$1;
function cloneChildren(ie) {
  for (var Z = ie.map(function(ae) {
    return cloneNode$1(ae, !0);
  }), ee = 1; ee < Z.length; ee++)
    Z[ee].prev = Z[ee - 1], Z[ee - 1].next = Z[ee];
  return Z;
}
(function(ie) {
  var Z = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Ye, Qe, Je, nt) {
    nt === void 0 && (nt = Je);
    var st = Object.getOwnPropertyDescriptor(Qe, Je);
    (!st || ("get" in st ? !Qe.__esModule : st.writable || st.configurable)) && (st = { enumerable: !0, get: function() {
      return Qe[Je];
    } }), Object.defineProperty(Ye, nt, st);
  } : function(Ye, Qe, Je, nt) {
    nt === void 0 && (nt = Je), Ye[nt] = Qe[Je];
  }), ee = commonjsGlobal && commonjsGlobal.__exportStar || function(Ye, Qe) {
    for (var Je in Ye)
      Je !== "default" && !Object.prototype.hasOwnProperty.call(Qe, Je) && Z(Qe, Ye, Je);
  };
  Object.defineProperty(ie, "__esModule", { value: !0 }), ie.DomHandler = void 0;
  var ae = lib$3, ve = node$1;
  ee(node$1, ie);
  var ye = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, be = (
    /** @class */
    function() {
      function Ye(Qe, Je, nt) {
        this.dom = [], this.root = new ve.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof Je == "function" && (nt = Je, Je = ye), typeof Qe == "object" && (Je = Qe, Qe = void 0), this.callback = Qe ?? null, this.options = Je ?? ye, this.elementCB = nt ?? null;
      }
      return Ye.prototype.onparserinit = function(Qe) {
        this.parser = Qe;
      }, Ye.prototype.onreset = function() {
        this.dom = [], this.root = new ve.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, Ye.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, Ye.prototype.onerror = function(Qe) {
        this.handleCallback(Qe);
      }, Ye.prototype.onclosetag = function() {
        this.lastNode = null;
        var Qe = this.tagStack.pop();
        this.options.withEndIndices && (Qe.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(Qe);
      }, Ye.prototype.onopentag = function(Qe, Je) {
        var nt = this.options.xmlMode ? ae.ElementType.Tag : void 0, st = new ve.Element(Qe, Je, void 0, nt);
        this.addNode(st), this.tagStack.push(st);
      }, Ye.prototype.ontext = function(Qe) {
        var Je = this.lastNode;
        if (Je && Je.type === ae.ElementType.Text)
          Je.data += Qe, this.options.withEndIndices && (Je.endIndex = this.parser.endIndex);
        else {
          var nt = new ve.Text(Qe);
          this.addNode(nt), this.lastNode = nt;
        }
      }, Ye.prototype.oncomment = function(Qe) {
        if (this.lastNode && this.lastNode.type === ae.ElementType.Comment) {
          this.lastNode.data += Qe;
          return;
        }
        var Je = new ve.Comment(Qe);
        this.addNode(Je), this.lastNode = Je;
      }, Ye.prototype.oncommentend = function() {
        this.lastNode = null;
      }, Ye.prototype.oncdatastart = function() {
        var Qe = new ve.Text(""), Je = new ve.CDATA([Qe]);
        this.addNode(Je), Qe.parent = Je, this.lastNode = Qe;
      }, Ye.prototype.oncdataend = function() {
        this.lastNode = null;
      }, Ye.prototype.onprocessinginstruction = function(Qe, Je) {
        var nt = new ve.ProcessingInstruction(Qe, Je);
        this.addNode(nt);
      }, Ye.prototype.handleCallback = function(Qe) {
        if (typeof this.callback == "function")
          this.callback(Qe, this.dom);
        else if (Qe)
          throw Qe;
      }, Ye.prototype.addNode = function(Qe) {
        var Je = this.tagStack[this.tagStack.length - 1], nt = Je.children[Je.children.length - 1];
        this.options.withStartIndices && (Qe.startIndex = this.parser.startIndex), this.options.withEndIndices && (Qe.endIndex = this.parser.endIndex), Je.children.push(Qe), nt && (Qe.prev = nt, nt.next = Qe), Qe.parent = Je, this.lastNode = null;
      }, Ye;
    }()
  );
  ie.DomHandler = be, ie.default = be;
})(lib$4);
var lib$2 = {}, stringify$5 = {}, lib$1 = {}, lib = {}, encode = {}, encodeHtml = {};
Object.defineProperty(encodeHtml, "__esModule", { value: !0 });
function restoreDiff(ie) {
  for (var Z = 1; Z < ie.length; Z++)
    ie[Z][0] += ie[Z - 1][0] + 1;
  return ie;
}
encodeHtml.default = new Map(/* @__PURE__ */ restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var _escape = {};
(function(ie) {
  Object.defineProperty(ie, "__esModule", { value: !0 }), ie.escapeText = ie.escapeAttribute = ie.escapeUTF8 = ie.escape = ie.encodeXML = ie.getCodePoint = ie.xmlReplacer = void 0, ie.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var Z = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  ie.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(ve, ye) {
    return ve.codePointAt(ye);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(ve, ye) {
      return (ve.charCodeAt(ye) & 64512) === 55296 ? (ve.charCodeAt(ye) - 55296) * 1024 + ve.charCodeAt(ye + 1) - 56320 + 65536 : ve.charCodeAt(ye);
    }
  );
  function ee(ve) {
    for (var ye = "", be = 0, Ye; (Ye = ie.xmlReplacer.exec(ve)) !== null; ) {
      var Qe = Ye.index, Je = ve.charCodeAt(Qe), nt = Z.get(Je);
      nt !== void 0 ? (ye += ve.substring(be, Qe) + nt, be = Qe + 1) : (ye += "".concat(ve.substring(be, Qe), "&#x").concat((0, ie.getCodePoint)(ve, Qe).toString(16), ";"), be = ie.xmlReplacer.lastIndex += +((Je & 64512) === 55296));
    }
    return ye + ve.substr(be);
  }
  ie.encodeXML = ee, ie.escape = ee;
  function ae(ve, ye) {
    return function(Ye) {
      for (var Qe, Je = 0, nt = ""; Qe = ve.exec(Ye); )
        Je !== Qe.index && (nt += Ye.substring(Je, Qe.index)), nt += ye.get(Qe[0].charCodeAt(0)), Je = Qe.index + 1;
      return nt + Ye.substring(Je);
    };
  }
  ie.escapeUTF8 = ae(/[&<>'"]/g, Z), ie.escapeAttribute = ae(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), ie.escapeText = ae(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(_escape);
var __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(ie) {
  return ie && ie.__esModule ? ie : { default: ie };
};
Object.defineProperty(encode, "__esModule", { value: !0 });
encode.encodeNonAsciiHTML = encode.encodeHTML = void 0;
var encode_html_js_1 = __importDefault$1(encodeHtml), escape_js_1 = _escape, htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function encodeHTML(ie) {
  return encodeHTMLTrieRe(htmlReplacer, ie);
}
encode.encodeHTML = encodeHTML;
function encodeNonAsciiHTML(ie) {
  return encodeHTMLTrieRe(escape_js_1.xmlReplacer, ie);
}
encode.encodeNonAsciiHTML = encodeNonAsciiHTML;
function encodeHTMLTrieRe(ie, Z) {
  for (var ee = "", ae = 0, ve; (ve = ie.exec(Z)) !== null; ) {
    var ye = ve.index;
    ee += Z.substring(ae, ye);
    var be = Z.charCodeAt(ye), Ye = encode_html_js_1.default.get(be);
    if (typeof Ye == "object") {
      if (ye + 1 < Z.length) {
        var Qe = Z.charCodeAt(ye + 1), Je = typeof Ye.n == "number" ? Ye.n === Qe ? Ye.o : void 0 : Ye.n.get(Qe);
        if (Je !== void 0) {
          ee += Je, ae = ie.lastIndex += 1;
          continue;
        }
      }
      Ye = Ye.v;
    }
    if (Ye !== void 0)
      ee += Ye, ae = ye + 1;
    else {
      var nt = (0, escape_js_1.getCodePoint)(Z, ye);
      ee += "&#x".concat(nt.toString(16), ";"), ae = ie.lastIndex += +(nt !== be);
    }
  }
  return ee + Z.substr(ae);
}
(function(ie) {
  Object.defineProperty(ie, "__esModule", { value: !0 }), ie.decodeXMLStrict = ie.decodeHTML5Strict = ie.decodeHTML4Strict = ie.decodeHTML5 = ie.decodeHTML4 = ie.decodeHTMLAttribute = ie.decodeHTMLStrict = ie.decodeHTML = ie.decodeXML = ie.DecodingMode = ie.EntityDecoder = ie.encodeHTML5 = ie.encodeHTML4 = ie.encodeNonAsciiHTML = ie.encodeHTML = ie.escapeText = ie.escapeAttribute = ie.escapeUTF8 = ie.escape = ie.encodeXML = ie.encode = ie.decodeStrict = ie.decode = ie.EncodingMode = ie.EntityLevel = void 0;
  var Z = decode, ee = encode, ae = _escape, ve;
  (function(ot) {
    ot[ot.XML = 0] = "XML", ot[ot.HTML = 1] = "HTML";
  })(ve = ie.EntityLevel || (ie.EntityLevel = {}));
  var ye;
  (function(ot) {
    ot[ot.UTF8 = 0] = "UTF8", ot[ot.ASCII = 1] = "ASCII", ot[ot.Extensive = 2] = "Extensive", ot[ot.Attribute = 3] = "Attribute", ot[ot.Text = 4] = "Text";
  })(ye = ie.EncodingMode || (ie.EncodingMode = {}));
  function be(ot, lt) {
    lt === void 0 && (lt = ve.XML);
    var ft = typeof lt == "number" ? lt : lt.level;
    if (ft === ve.HTML) {
      var gt = typeof lt == "object" ? lt.mode : void 0;
      return (0, Z.decodeHTML)(ot, gt);
    }
    return (0, Z.decodeXML)(ot);
  }
  ie.decode = be;
  function Ye(ot, lt) {
    var ft;
    lt === void 0 && (lt = ve.XML);
    var gt = typeof lt == "number" ? { level: lt } : lt;
    return (ft = gt.mode) !== null && ft !== void 0 || (gt.mode = Z.DecodingMode.Strict), be(ot, gt);
  }
  ie.decodeStrict = Ye;
  function Qe(ot, lt) {
    lt === void 0 && (lt = ve.XML);
    var ft = typeof lt == "number" ? { level: lt } : lt;
    return ft.mode === ye.UTF8 ? (0, ae.escapeUTF8)(ot) : ft.mode === ye.Attribute ? (0, ae.escapeAttribute)(ot) : ft.mode === ye.Text ? (0, ae.escapeText)(ot) : ft.level === ve.HTML ? ft.mode === ye.ASCII ? (0, ee.encodeNonAsciiHTML)(ot) : (0, ee.encodeHTML)(ot) : (0, ae.encodeXML)(ot);
  }
  ie.encode = Qe;
  var Je = _escape;
  Object.defineProperty(ie, "encodeXML", { enumerable: !0, get: function() {
    return Je.encodeXML;
  } }), Object.defineProperty(ie, "escape", { enumerable: !0, get: function() {
    return Je.escape;
  } }), Object.defineProperty(ie, "escapeUTF8", { enumerable: !0, get: function() {
    return Je.escapeUTF8;
  } }), Object.defineProperty(ie, "escapeAttribute", { enumerable: !0, get: function() {
    return Je.escapeAttribute;
  } }), Object.defineProperty(ie, "escapeText", { enumerable: !0, get: function() {
    return Je.escapeText;
  } });
  var nt = encode;
  Object.defineProperty(ie, "encodeHTML", { enumerable: !0, get: function() {
    return nt.encodeHTML;
  } }), Object.defineProperty(ie, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return nt.encodeNonAsciiHTML;
  } }), Object.defineProperty(ie, "encodeHTML4", { enumerable: !0, get: function() {
    return nt.encodeHTML;
  } }), Object.defineProperty(ie, "encodeHTML5", { enumerable: !0, get: function() {
    return nt.encodeHTML;
  } });
  var st = decode;
  Object.defineProperty(ie, "EntityDecoder", { enumerable: !0, get: function() {
    return st.EntityDecoder;
  } }), Object.defineProperty(ie, "DecodingMode", { enumerable: !0, get: function() {
    return st.DecodingMode;
  } }), Object.defineProperty(ie, "decodeXML", { enumerable: !0, get: function() {
    return st.decodeXML;
  } }), Object.defineProperty(ie, "decodeHTML", { enumerable: !0, get: function() {
    return st.decodeHTML;
  } }), Object.defineProperty(ie, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return st.decodeHTMLStrict;
  } }), Object.defineProperty(ie, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return st.decodeHTMLAttribute;
  } }), Object.defineProperty(ie, "decodeHTML4", { enumerable: !0, get: function() {
    return st.decodeHTML;
  } }), Object.defineProperty(ie, "decodeHTML5", { enumerable: !0, get: function() {
    return st.decodeHTML;
  } }), Object.defineProperty(ie, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return st.decodeHTMLStrict;
  } }), Object.defineProperty(ie, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return st.decodeHTMLStrict;
  } }), Object.defineProperty(ie, "decodeXMLStrict", { enumerable: !0, get: function() {
    return st.decodeXML;
  } });
})(lib);
var foreignNames = {};
Object.defineProperty(foreignNames, "__esModule", { value: !0 });
foreignNames.attributeNames = foreignNames.elementNames = void 0;
foreignNames.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(ie) {
  return [ie.toLowerCase(), ie];
}));
foreignNames.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(ie) {
  return [ie.toLowerCase(), ie];
}));
var __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign$1 = Object.assign || function(ie) {
    for (var Z, ee = 1, ae = arguments.length; ee < ae; ee++) {
      Z = arguments[ee];
      for (var ve in Z)
        Object.prototype.hasOwnProperty.call(Z, ve) && (ie[ve] = Z[ve]);
    }
    return ie;
  }, __assign$1.apply(this, arguments);
}, __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(ie, Z, ee, ae) {
  ae === void 0 && (ae = ee);
  var ve = Object.getOwnPropertyDescriptor(Z, ee);
  (!ve || ("get" in ve ? !Z.__esModule : ve.writable || ve.configurable)) && (ve = { enumerable: !0, get: function() {
    return Z[ee];
  } }), Object.defineProperty(ie, ae, ve);
} : function(ie, Z, ee, ae) {
  ae === void 0 && (ae = ee), ie[ae] = Z[ee];
}), __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(ie, Z) {
  Object.defineProperty(ie, "default", { enumerable: !0, value: Z });
} : function(ie, Z) {
  ie.default = Z;
}), __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(ie) {
  if (ie && ie.__esModule)
    return ie;
  var Z = {};
  if (ie != null)
    for (var ee in ie)
      ee !== "default" && Object.prototype.hasOwnProperty.call(ie, ee) && __createBinding(Z, ie, ee);
  return __setModuleDefault(Z, ie), Z;
};
Object.defineProperty(lib$1, "__esModule", { value: !0 });
lib$1.render = void 0;
var ElementType = __importStar(lib$3), entities_1 = lib, foreignNames_js_1 = foreignNames, unencodedElements = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function replaceQuotes(ie) {
  return ie.replace(/"/g, "&quot;");
}
function formatAttributes(ie, Z) {
  var ee;
  if (ie) {
    var ae = ((ee = Z.encodeEntities) !== null && ee !== void 0 ? ee : Z.decodeEntities) === !1 ? replaceQuotes : Z.xmlMode || Z.encodeEntities !== "utf8" ? entities_1.encodeXML : entities_1.escapeAttribute;
    return Object.keys(ie).map(function(ve) {
      var ye, be, Ye = (ye = ie[ve]) !== null && ye !== void 0 ? ye : "";
      return Z.xmlMode === "foreign" && (ve = (be = foreignNames_js_1.attributeNames.get(ve)) !== null && be !== void 0 ? be : ve), !Z.emptyAttrs && !Z.xmlMode && Ye === "" ? ve : "".concat(ve, '="').concat(ae(Ye), '"');
    }).join(" ");
  }
}
var singleTag = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function render(ie, Z) {
  Z === void 0 && (Z = {});
  for (var ee = ("length" in ie) ? ie : [ie], ae = "", ve = 0; ve < ee.length; ve++)
    ae += renderNode(ee[ve], Z);
  return ae;
}
lib$1.render = render;
lib$1.default = render;
function renderNode(ie, Z) {
  switch (ie.type) {
    case ElementType.Root:
      return render(ie.children, Z);
    case ElementType.Doctype:
    case ElementType.Directive:
      return renderDirective(ie);
    case ElementType.Comment:
      return renderComment(ie);
    case ElementType.CDATA:
      return renderCdata(ie);
    case ElementType.Script:
    case ElementType.Style:
    case ElementType.Tag:
      return renderTag(ie, Z);
    case ElementType.Text:
      return renderText(ie, Z);
  }
}
var foreignModeIntegrationPoints = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), foreignElements = /* @__PURE__ */ new Set(["svg", "math"]);
function renderTag(ie, Z) {
  var ee;
  Z.xmlMode === "foreign" && (ie.name = (ee = foreignNames_js_1.elementNames.get(ie.name)) !== null && ee !== void 0 ? ee : ie.name, ie.parent && foreignModeIntegrationPoints.has(ie.parent.name) && (Z = __assign$1(__assign$1({}, Z), { xmlMode: !1 }))), !Z.xmlMode && foreignElements.has(ie.name) && (Z = __assign$1(__assign$1({}, Z), { xmlMode: "foreign" }));
  var ae = "<".concat(ie.name), ve = formatAttributes(ie.attribs, Z);
  return ve && (ae += " ".concat(ve)), ie.children.length === 0 && (Z.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    Z.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    Z.selfClosingTags && singleTag.has(ie.name)
  )) ? (Z.xmlMode || (ae += " "), ae += "/>") : (ae += ">", ie.children.length > 0 && (ae += render(ie.children, Z)), (Z.xmlMode || !singleTag.has(ie.name)) && (ae += "</".concat(ie.name, ">"))), ae;
}
function renderDirective(ie) {
  return "<".concat(ie.data, ">");
}
function renderText(ie, Z) {
  var ee, ae = ie.data || "";
  return ((ee = Z.encodeEntities) !== null && ee !== void 0 ? ee : Z.decodeEntities) !== !1 && !(!Z.xmlMode && ie.parent && unencodedElements.has(ie.parent.name)) && (ae = Z.xmlMode || Z.encodeEntities !== "utf8" ? (0, entities_1.encodeXML)(ae) : (0, entities_1.escapeText)(ae)), ae;
}
function renderCdata(ie) {
  return "<![CDATA[".concat(ie.children[0].data, "]]>");
}
function renderComment(ie) {
  return "<!--".concat(ie.data, "-->");
}
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(ie) {
  return ie && ie.__esModule ? ie : { default: ie };
};
Object.defineProperty(stringify$5, "__esModule", { value: !0 });
stringify$5.innerText = stringify$5.textContent = stringify$5.getText = stringify$5.getInnerHTML = stringify$5.getOuterHTML = void 0;
var domhandler_1$3 = lib$4, dom_serializer_1 = __importDefault(lib$1), domelementtype_1 = lib$3;
function getOuterHTML(ie, Z) {
  return (0, dom_serializer_1.default)(ie, Z);
}
stringify$5.getOuterHTML = getOuterHTML;
function getInnerHTML(ie, Z) {
  return (0, domhandler_1$3.hasChildren)(ie) ? ie.children.map(function(ee) {
    return getOuterHTML(ee, Z);
  }).join("") : "";
}
stringify$5.getInnerHTML = getInnerHTML;
function getText(ie) {
  return Array.isArray(ie) ? ie.map(getText).join("") : (0, domhandler_1$3.isTag)(ie) ? ie.name === "br" ? `
` : getText(ie.children) : (0, domhandler_1$3.isCDATA)(ie) ? getText(ie.children) : (0, domhandler_1$3.isText)(ie) ? ie.data : "";
}
stringify$5.getText = getText;
function textContent(ie) {
  return Array.isArray(ie) ? ie.map(textContent).join("") : (0, domhandler_1$3.hasChildren)(ie) && !(0, domhandler_1$3.isComment)(ie) ? textContent(ie.children) : (0, domhandler_1$3.isText)(ie) ? ie.data : "";
}
stringify$5.textContent = textContent;
function innerText(ie) {
  return Array.isArray(ie) ? ie.map(innerText).join("") : (0, domhandler_1$3.hasChildren)(ie) && (ie.type === domelementtype_1.ElementType.Tag || (0, domhandler_1$3.isCDATA)(ie)) ? innerText(ie.children) : (0, domhandler_1$3.isText)(ie) ? ie.data : "";
}
stringify$5.innerText = innerText;
var traversal = {};
Object.defineProperty(traversal, "__esModule", { value: !0 });
traversal.prevElementSibling = traversal.nextElementSibling = traversal.getName = traversal.hasAttrib = traversal.getAttributeValue = traversal.getSiblings = traversal.getParent = traversal.getChildren = void 0;
var domhandler_1$2 = lib$4;
function getChildren(ie) {
  return (0, domhandler_1$2.hasChildren)(ie) ? ie.children : [];
}
traversal.getChildren = getChildren;
function getParent(ie) {
  return ie.parent || null;
}
traversal.getParent = getParent;
function getSiblings(ie) {
  var Z, ee, ae = getParent(ie);
  if (ae != null)
    return getChildren(ae);
  for (var ve = [ie], ye = ie.prev, be = ie.next; ye != null; )
    ve.unshift(ye), Z = ye, ye = Z.prev;
  for (; be != null; )
    ve.push(be), ee = be, be = ee.next;
  return ve;
}
traversal.getSiblings = getSiblings;
function getAttributeValue(ie, Z) {
  var ee;
  return (ee = ie.attribs) === null || ee === void 0 ? void 0 : ee[Z];
}
traversal.getAttributeValue = getAttributeValue;
function hasAttrib(ie, Z) {
  return ie.attribs != null && Object.prototype.hasOwnProperty.call(ie.attribs, Z) && ie.attribs[Z] != null;
}
traversal.hasAttrib = hasAttrib;
function getName(ie) {
  return ie.name;
}
traversal.getName = getName;
function nextElementSibling(ie) {
  for (var Z, ee = ie.next; ee !== null && !(0, domhandler_1$2.isTag)(ee); )
    Z = ee, ee = Z.next;
  return ee;
}
traversal.nextElementSibling = nextElementSibling;
function prevElementSibling(ie) {
  for (var Z, ee = ie.prev; ee !== null && !(0, domhandler_1$2.isTag)(ee); )
    Z = ee, ee = Z.prev;
  return ee;
}
traversal.prevElementSibling = prevElementSibling;
var manipulation = {};
Object.defineProperty(manipulation, "__esModule", { value: !0 });
manipulation.prepend = manipulation.prependChild = manipulation.append = manipulation.appendChild = manipulation.replaceElement = manipulation.removeElement = void 0;
function removeElement(ie) {
  if (ie.prev && (ie.prev.next = ie.next), ie.next && (ie.next.prev = ie.prev), ie.parent) {
    var Z = ie.parent.children, ee = Z.lastIndexOf(ie);
    ee >= 0 && Z.splice(ee, 1);
  }
  ie.next = null, ie.prev = null, ie.parent = null;
}
manipulation.removeElement = removeElement;
function replaceElement(ie, Z) {
  var ee = Z.prev = ie.prev;
  ee && (ee.next = Z);
  var ae = Z.next = ie.next;
  ae && (ae.prev = Z);
  var ve = Z.parent = ie.parent;
  if (ve) {
    var ye = ve.children;
    ye[ye.lastIndexOf(ie)] = Z, ie.parent = null;
  }
}
manipulation.replaceElement = replaceElement;
function appendChild(ie, Z) {
  if (removeElement(Z), Z.next = null, Z.parent = ie, ie.children.push(Z) > 1) {
    var ee = ie.children[ie.children.length - 2];
    ee.next = Z, Z.prev = ee;
  } else
    Z.prev = null;
}
manipulation.appendChild = appendChild;
function append(ie, Z) {
  removeElement(Z);
  var ee = ie.parent, ae = ie.next;
  if (Z.next = ae, Z.prev = ie, ie.next = Z, Z.parent = ee, ae) {
    if (ae.prev = Z, ee) {
      var ve = ee.children;
      ve.splice(ve.lastIndexOf(ae), 0, Z);
    }
  } else
    ee && ee.children.push(Z);
}
manipulation.append = append;
function prependChild(ie, Z) {
  if (removeElement(Z), Z.parent = ie, Z.prev = null, ie.children.unshift(Z) !== 1) {
    var ee = ie.children[1];
    ee.prev = Z, Z.next = ee;
  } else
    Z.next = null;
}
manipulation.prependChild = prependChild;
function prepend(ie, Z) {
  removeElement(Z);
  var ee = ie.parent;
  if (ee) {
    var ae = ee.children;
    ae.splice(ae.indexOf(ie), 0, Z);
  }
  ie.prev && (ie.prev.next = Z), Z.parent = ee, Z.prev = ie.prev, Z.next = ie, ie.prev = Z;
}
manipulation.prepend = prepend;
var querying = {};
Object.defineProperty(querying, "__esModule", { value: !0 });
querying.findAll = querying.existsOne = querying.findOne = querying.findOneChild = querying.find = querying.filter = void 0;
var domhandler_1$1 = lib$4;
function filter$1(ie, Z, ee, ae) {
  return ee === void 0 && (ee = !0), ae === void 0 && (ae = 1 / 0), find(ie, Array.isArray(Z) ? Z : [Z], ee, ae);
}
querying.filter = filter$1;
function find(ie, Z, ee, ae) {
  for (var ve = [], ye = [Z], be = [0]; ; ) {
    if (be[0] >= ye[0].length) {
      if (be.length === 1)
        return ve;
      ye.shift(), be.shift();
      continue;
    }
    var Ye = ye[0][be[0]++];
    if (ie(Ye) && (ve.push(Ye), --ae <= 0))
      return ve;
    ee && (0, domhandler_1$1.hasChildren)(Ye) && Ye.children.length > 0 && (be.unshift(0), ye.unshift(Ye.children));
  }
}
querying.find = find;
function findOneChild(ie, Z) {
  return Z.find(ie);
}
querying.findOneChild = findOneChild;
function findOne(ie, Z, ee) {
  ee === void 0 && (ee = !0);
  for (var ae = null, ve = 0; ve < Z.length && !ae; ve++) {
    var ye = Z[ve];
    if ((0, domhandler_1$1.isTag)(ye))
      ie(ye) ? ae = ye : ee && ye.children.length > 0 && (ae = findOne(ie, ye.children, !0));
    else
      continue;
  }
  return ae;
}
querying.findOne = findOne;
function existsOne(ie, Z) {
  return Z.some(function(ee) {
    return (0, domhandler_1$1.isTag)(ee) && (ie(ee) || existsOne(ie, ee.children));
  });
}
querying.existsOne = existsOne;
function findAll(ie, Z) {
  for (var ee = [], ae = [Z], ve = [0]; ; ) {
    if (ve[0] >= ae[0].length) {
      if (ae.length === 1)
        return ee;
      ae.shift(), ve.shift();
      continue;
    }
    var ye = ae[0][ve[0]++];
    (0, domhandler_1$1.isTag)(ye) && (ie(ye) && ee.push(ye), ye.children.length > 0 && (ve.unshift(0), ae.unshift(ye.children)));
  }
}
querying.findAll = findAll;
var legacy = {};
Object.defineProperty(legacy, "__esModule", { value: !0 });
legacy.getElementsByTagType = legacy.getElementsByTagName = legacy.getElementById = legacy.getElements = legacy.testElement = void 0;
var domhandler_1 = lib$4, querying_js_1 = querying, Checks = {
  tag_name: function(ie) {
    return typeof ie == "function" ? function(Z) {
      return (0, domhandler_1.isTag)(Z) && ie(Z.name);
    } : ie === "*" ? domhandler_1.isTag : function(Z) {
      return (0, domhandler_1.isTag)(Z) && Z.name === ie;
    };
  },
  tag_type: function(ie) {
    return typeof ie == "function" ? function(Z) {
      return ie(Z.type);
    } : function(Z) {
      return Z.type === ie;
    };
  },
  tag_contains: function(ie) {
    return typeof ie == "function" ? function(Z) {
      return (0, domhandler_1.isText)(Z) && ie(Z.data);
    } : function(Z) {
      return (0, domhandler_1.isText)(Z) && Z.data === ie;
    };
  }
};
function getAttribCheck(ie, Z) {
  return typeof Z == "function" ? function(ee) {
    return (0, domhandler_1.isTag)(ee) && Z(ee.attribs[ie]);
  } : function(ee) {
    return (0, domhandler_1.isTag)(ee) && ee.attribs[ie] === Z;
  };
}
function combineFuncs(ie, Z) {
  return function(ee) {
    return ie(ee) || Z(ee);
  };
}
function compileTest(ie) {
  var Z = Object.keys(ie).map(function(ee) {
    var ae = ie[ee];
    return Object.prototype.hasOwnProperty.call(Checks, ee) ? Checks[ee](ae) : getAttribCheck(ee, ae);
  });
  return Z.length === 0 ? null : Z.reduce(combineFuncs);
}
function testElement(ie, Z) {
  var ee = compileTest(ie);
  return ee ? ee(Z) : !0;
}
legacy.testElement = testElement;
function getElements(ie, Z, ee, ae) {
  ae === void 0 && (ae = 1 / 0);
  var ve = compileTest(ie);
  return ve ? (0, querying_js_1.filter)(ve, Z, ee, ae) : [];
}
legacy.getElements = getElements;
function getElementById(ie, Z, ee) {
  return ee === void 0 && (ee = !0), Array.isArray(Z) || (Z = [Z]), (0, querying_js_1.findOne)(getAttribCheck("id", ie), Z, ee);
}
legacy.getElementById = getElementById;
function getElementsByTagName(ie, Z, ee, ae) {
  return ee === void 0 && (ee = !0), ae === void 0 && (ae = 1 / 0), (0, querying_js_1.filter)(Checks.tag_name(ie), Z, ee, ae);
}
legacy.getElementsByTagName = getElementsByTagName;
function getElementsByTagType(ie, Z, ee, ae) {
  return ee === void 0 && (ee = !0), ae === void 0 && (ae = 1 / 0), (0, querying_js_1.filter)(Checks.tag_type(ie), Z, ee, ae);
}
legacy.getElementsByTagType = getElementsByTagType;
var helpers = {};
(function(ie) {
  Object.defineProperty(ie, "__esModule", { value: !0 }), ie.uniqueSort = ie.compareDocumentPosition = ie.DocumentPosition = ie.removeSubsets = void 0;
  var Z = lib$4;
  function ee(be) {
    for (var Ye = be.length; --Ye >= 0; ) {
      var Qe = be[Ye];
      if (Ye > 0 && be.lastIndexOf(Qe, Ye - 1) >= 0) {
        be.splice(Ye, 1);
        continue;
      }
      for (var Je = Qe.parent; Je; Je = Je.parent)
        if (be.includes(Je)) {
          be.splice(Ye, 1);
          break;
        }
    }
    return be;
  }
  ie.removeSubsets = ee;
  var ae;
  (function(be) {
    be[be.DISCONNECTED = 1] = "DISCONNECTED", be[be.PRECEDING = 2] = "PRECEDING", be[be.FOLLOWING = 4] = "FOLLOWING", be[be.CONTAINS = 8] = "CONTAINS", be[be.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(ae = ie.DocumentPosition || (ie.DocumentPosition = {}));
  function ve(be, Ye) {
    var Qe = [], Je = [];
    if (be === Ye)
      return 0;
    for (var nt = (0, Z.hasChildren)(be) ? be : be.parent; nt; )
      Qe.unshift(nt), nt = nt.parent;
    for (nt = (0, Z.hasChildren)(Ye) ? Ye : Ye.parent; nt; )
      Je.unshift(nt), nt = nt.parent;
    for (var st = Math.min(Qe.length, Je.length), ot = 0; ot < st && Qe[ot] === Je[ot]; )
      ot++;
    if (ot === 0)
      return ae.DISCONNECTED;
    var lt = Qe[ot - 1], ft = lt.children, gt = Qe[ot], ct = Je[ot];
    return ft.indexOf(gt) > ft.indexOf(ct) ? lt === Ye ? ae.FOLLOWING | ae.CONTAINED_BY : ae.FOLLOWING : lt === be ? ae.PRECEDING | ae.CONTAINS : ae.PRECEDING;
  }
  ie.compareDocumentPosition = ve;
  function ye(be) {
    return be = be.filter(function(Ye, Qe, Je) {
      return !Je.includes(Ye, Qe + 1);
    }), be.sort(function(Ye, Qe) {
      var Je = ve(Ye, Qe);
      return Je & ae.PRECEDING ? -1 : Je & ae.FOLLOWING ? 1 : 0;
    }), be;
  }
  ie.uniqueSort = ye;
})(helpers);
var feeds = {};
Object.defineProperty(feeds, "__esModule", { value: !0 });
feeds.getFeed = void 0;
var stringify_js_1 = stringify$5, legacy_js_1 = legacy;
function getFeed(ie) {
  var Z = getOneElement(isValidFeed, ie);
  return Z ? Z.name === "feed" ? getAtomFeed(Z) : getRssFeed(Z) : null;
}
feeds.getFeed = getFeed;
function getAtomFeed(ie) {
  var Z, ee = ie.children, ae = {
    type: "atom",
    items: (0, legacy_js_1.getElementsByTagName)("entry", ee).map(function(be) {
      var Ye, Qe = be.children, Je = { media: getMediaElements(Qe) };
      addConditionally(Je, "id", "id", Qe), addConditionally(Je, "title", "title", Qe);
      var nt = (Ye = getOneElement("link", Qe)) === null || Ye === void 0 ? void 0 : Ye.attribs.href;
      nt && (Je.link = nt);
      var st = fetch$1("summary", Qe) || fetch$1("content", Qe);
      st && (Je.description = st);
      var ot = fetch$1("updated", Qe);
      return ot && (Je.pubDate = new Date(ot)), Je;
    })
  };
  addConditionally(ae, "id", "id", ee), addConditionally(ae, "title", "title", ee);
  var ve = (Z = getOneElement("link", ee)) === null || Z === void 0 ? void 0 : Z.attribs.href;
  ve && (ae.link = ve), addConditionally(ae, "description", "subtitle", ee);
  var ye = fetch$1("updated", ee);
  return ye && (ae.updated = new Date(ye)), addConditionally(ae, "author", "email", ee, !0), ae;
}
function getRssFeed(ie) {
  var Z, ee, ae = (ee = (Z = getOneElement("channel", ie.children)) === null || Z === void 0 ? void 0 : Z.children) !== null && ee !== void 0 ? ee : [], ve = {
    type: ie.name.substr(0, 3),
    id: "",
    items: (0, legacy_js_1.getElementsByTagName)("item", ie.children).map(function(be) {
      var Ye = be.children, Qe = { media: getMediaElements(Ye) };
      addConditionally(Qe, "id", "guid", Ye), addConditionally(Qe, "title", "title", Ye), addConditionally(Qe, "link", "link", Ye), addConditionally(Qe, "description", "description", Ye);
      var Je = fetch$1("pubDate", Ye) || fetch$1("dc:date", Ye);
      return Je && (Qe.pubDate = new Date(Je)), Qe;
    })
  };
  addConditionally(ve, "title", "title", ae), addConditionally(ve, "link", "link", ae), addConditionally(ve, "description", "description", ae);
  var ye = fetch$1("lastBuildDate", ae);
  return ye && (ve.updated = new Date(ye)), addConditionally(ve, "author", "managingEditor", ae, !0), ve;
}
var MEDIA_KEYS_STRING = ["url", "type", "lang"], MEDIA_KEYS_INT = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function getMediaElements(ie) {
  return (0, legacy_js_1.getElementsByTagName)("media:content", ie).map(function(Z) {
    for (var ee = Z.attribs, ae = {
      medium: ee.medium,
      isDefault: !!ee.isDefault
    }, ve = 0, ye = MEDIA_KEYS_STRING; ve < ye.length; ve++) {
      var be = ye[ve];
      ee[be] && (ae[be] = ee[be]);
    }
    for (var Ye = 0, Qe = MEDIA_KEYS_INT; Ye < Qe.length; Ye++) {
      var be = Qe[Ye];
      ee[be] && (ae[be] = parseInt(ee[be], 10));
    }
    return ee.expression && (ae.expression = ee.expression), ae;
  });
}
function getOneElement(ie, Z) {
  return (0, legacy_js_1.getElementsByTagName)(ie, Z, !0, 1)[0];
}
function fetch$1(ie, Z, ee) {
  return ee === void 0 && (ee = !1), (0, stringify_js_1.textContent)((0, legacy_js_1.getElementsByTagName)(ie, Z, ee, 1)).trim();
}
function addConditionally(ie, Z, ee, ae, ve) {
  ve === void 0 && (ve = !1);
  var ye = fetch$1(ee, ae, ve);
  ye && (ie[Z] = ye);
}
function isValidFeed(ie) {
  return ie === "rss" || ie === "feed" || ie === "rdf:RDF";
}
(function(ie) {
  var Z = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(ve, ye, be, Ye) {
    Ye === void 0 && (Ye = be);
    var Qe = Object.getOwnPropertyDescriptor(ye, be);
    (!Qe || ("get" in Qe ? !ye.__esModule : Qe.writable || Qe.configurable)) && (Qe = { enumerable: !0, get: function() {
      return ye[be];
    } }), Object.defineProperty(ve, Ye, Qe);
  } : function(ve, ye, be, Ye) {
    Ye === void 0 && (Ye = be), ve[Ye] = ye[be];
  }), ee = commonjsGlobal && commonjsGlobal.__exportStar || function(ve, ye) {
    for (var be in ve)
      be !== "default" && !Object.prototype.hasOwnProperty.call(ye, be) && Z(ye, ve, be);
  };
  Object.defineProperty(ie, "__esModule", { value: !0 }), ie.hasChildren = ie.isDocument = ie.isComment = ie.isText = ie.isCDATA = ie.isTag = void 0, ee(stringify$5, ie), ee(traversal, ie), ee(manipulation, ie), ee(querying, ie), ee(legacy, ie), ee(helpers, ie), ee(feeds, ie);
  var ae = lib$4;
  Object.defineProperty(ie, "isTag", { enumerable: !0, get: function() {
    return ae.isTag;
  } }), Object.defineProperty(ie, "isCDATA", { enumerable: !0, get: function() {
    return ae.isCDATA;
  } }), Object.defineProperty(ie, "isText", { enumerable: !0, get: function() {
    return ae.isText;
  } }), Object.defineProperty(ie, "isComment", { enumerable: !0, get: function() {
    return ae.isComment;
  } }), Object.defineProperty(ie, "isDocument", { enumerable: !0, get: function() {
    return ae.isDocument;
  } }), Object.defineProperty(ie, "hasChildren", { enumerable: !0, get: function() {
    return ae.hasChildren;
  } });
})(lib$2);
(function(ie) {
  var Z = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(_r, Kr, Xr, Jr) {
    Jr === void 0 && (Jr = Xr);
    var ei = Object.getOwnPropertyDescriptor(Kr, Xr);
    (!ei || ("get" in ei ? !Kr.__esModule : ei.writable || ei.configurable)) && (ei = { enumerable: !0, get: function() {
      return Kr[Xr];
    } }), Object.defineProperty(_r, Jr, ei);
  } : function(_r, Kr, Xr, Jr) {
    Jr === void 0 && (Jr = Xr), _r[Jr] = Kr[Xr];
  }), ee = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(_r, Kr) {
    Object.defineProperty(_r, "default", { enumerable: !0, value: Kr });
  } : function(_r, Kr) {
    _r.default = Kr;
  }), ae = commonjsGlobal && commonjsGlobal.__importStar || function(_r) {
    if (_r && _r.__esModule)
      return _r;
    var Kr = {};
    if (_r != null)
      for (var Xr in _r)
        Xr !== "default" && Object.prototype.hasOwnProperty.call(_r, Xr) && Z(Kr, _r, Xr);
    return ee(Kr, _r), Kr;
  }, ve = commonjsGlobal && commonjsGlobal.__importDefault || function(_r) {
    return _r && _r.__esModule ? _r : { default: _r };
  };
  Object.defineProperty(ie, "__esModule", { value: !0 }), ie.DomUtils = ie.parseFeed = ie.getFeed = ie.ElementType = ie.Tokenizer = ie.createDomStream = ie.parseDOM = ie.parseDocument = ie.DefaultHandler = ie.DomHandler = ie.Parser = void 0;
  var ye = Parser$3, be = Parser$3;
  Object.defineProperty(ie, "Parser", { enumerable: !0, get: function() {
    return be.Parser;
  } });
  var Ye = lib$4, Qe = lib$4;
  Object.defineProperty(ie, "DomHandler", { enumerable: !0, get: function() {
    return Qe.DomHandler;
  } }), Object.defineProperty(ie, "DefaultHandler", { enumerable: !0, get: function() {
    return Qe.DomHandler;
  } });
  function Je(_r, Kr) {
    var Xr = new Ye.DomHandler(void 0, Kr);
    return new ye.Parser(Xr, Kr).end(_r), Xr.root;
  }
  ie.parseDocument = Je;
  function nt(_r, Kr) {
    return Je(_r, Kr).children;
  }
  ie.parseDOM = nt;
  function st(_r, Kr, Xr) {
    var Jr = new Ye.DomHandler(_r, Kr, Xr);
    return new ye.Parser(Jr, Kr);
  }
  ie.createDomStream = st;
  var ot = Tokenizer;
  Object.defineProperty(ie, "Tokenizer", { enumerable: !0, get: function() {
    return ve(ot).default;
  } }), ie.ElementType = ae(lib$3);
  var lt = lib$2, ft = lib$2;
  Object.defineProperty(ie, "getFeed", { enumerable: !0, get: function() {
    return ft.getFeed;
  } });
  var gt = { xmlMode: !0 };
  function ct(_r, Kr) {
    return Kr === void 0 && (Kr = gt), (0, lt.getFeed)(nt(_r, Kr));
  }
  ie.parseFeed = ct, ie.DomUtils = ae(lib$2);
})(lib$5);
var escapeStringRegexp$1 = (ie) => {
  if (typeof ie != "string")
    throw new TypeError("Expected a string");
  return ie.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, isPlainObject$2 = {};
Object.defineProperty(isPlainObject$2, "__esModule", { value: !0 });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function isObject(ie) {
  return Object.prototype.toString.call(ie) === "[object Object]";
}
function isPlainObject$1(ie) {
  var Z, ee;
  return isObject(ie) === !1 ? !1 : (Z = ie.constructor, Z === void 0 ? !0 : (ee = Z.prototype, !(isObject(ee) === !1 || ee.hasOwnProperty("isPrototypeOf") === !1)));
}
isPlainObject$2.isPlainObject = isPlainObject$1;
var isMergeableObject = function(Z) {
  return isNonNullObject(Z) && !isSpecial(Z);
};
function isNonNullObject(ie) {
  return !!ie && typeof ie == "object";
}
function isSpecial(ie) {
  var Z = Object.prototype.toString.call(ie);
  return Z === "[object RegExp]" || Z === "[object Date]" || isReactElement(ie);
}
var canUseSymbol = typeof Symbol == "function" && Symbol.for, REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(ie) {
  return ie.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(ie) {
  return Array.isArray(ie) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(ie, Z) {
  return Z.clone !== !1 && Z.isMergeableObject(ie) ? deepmerge$1(emptyTarget(ie), ie, Z) : ie;
}
function defaultArrayMerge(ie, Z, ee) {
  return ie.concat(Z).map(function(ae) {
    return cloneUnlessOtherwiseSpecified(ae, ee);
  });
}
function getMergeFunction(ie, Z) {
  if (!Z.customMerge)
    return deepmerge$1;
  var ee = Z.customMerge(ie);
  return typeof ee == "function" ? ee : deepmerge$1;
}
function getEnumerableOwnPropertySymbols(ie) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(ie).filter(function(Z) {
    return Object.propertyIsEnumerable.call(ie, Z);
  }) : [];
}
function getKeys(ie) {
  return Object.keys(ie).concat(getEnumerableOwnPropertySymbols(ie));
}
function propertyIsOnObject(ie, Z) {
  try {
    return Z in ie;
  } catch {
    return !1;
  }
}
function propertyIsUnsafe(ie, Z) {
  return propertyIsOnObject(ie, Z) && !(Object.hasOwnProperty.call(ie, Z) && Object.propertyIsEnumerable.call(ie, Z));
}
function mergeObject(ie, Z, ee) {
  var ae = {};
  return ee.isMergeableObject(ie) && getKeys(ie).forEach(function(ve) {
    ae[ve] = cloneUnlessOtherwiseSpecified(ie[ve], ee);
  }), getKeys(Z).forEach(function(ve) {
    propertyIsUnsafe(ie, ve) || (propertyIsOnObject(ie, ve) && ee.isMergeableObject(Z[ve]) ? ae[ve] = getMergeFunction(ve, ee)(ie[ve], Z[ve], ee) : ae[ve] = cloneUnlessOtherwiseSpecified(Z[ve], ee));
  }), ae;
}
function deepmerge$1(ie, Z, ee) {
  ee = ee || {}, ee.arrayMerge = ee.arrayMerge || defaultArrayMerge, ee.isMergeableObject = ee.isMergeableObject || isMergeableObject, ee.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var ae = Array.isArray(Z), ve = Array.isArray(ie), ye = ae === ve;
  return ye ? ae ? ee.arrayMerge(ie, Z, ee) : mergeObject(ie, Z, ee) : cloneUnlessOtherwiseSpecified(Z, ee);
}
deepmerge$1.all = function(Z, ee) {
  if (!Array.isArray(Z))
    throw new Error("first argument should be an array");
  return Z.reduce(function(ae, ve) {
    return deepmerge$1(ae, ve, ee);
  }, {});
};
var deepmerge_1 = deepmerge$1, cjs = deepmerge_1, parseSrcset$1 = { exports: {} };
(function(ie) {
  (function(Z, ee) {
    ie.exports ? ie.exports = ee() : Z.parseSrcset = ee();
  })(commonjsGlobal, function() {
    return function(Z) {
      function ee(Jr) {
        return Jr === " " || // space
        Jr === "	" || // horizontal tab
        Jr === `
` || // new line
        Jr === "\f" || // form feed
        Jr === "\r";
      }
      function ae(Jr) {
        var ei, si = Jr.exec(Z.substring(ct));
        if (si)
          return ei = si[0], ct += ei.length, ei;
      }
      for (var ve = Z.length, ye = /^[ \t\n\r\u000c]+/, be = /^[, \t\n\r\u000c]+/, Ye = /^[^ \t\n\r\u000c]+/, Qe = /[,]+$/, Je = /^\d+$/, nt = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, st, ot, lt, ft, gt, ct = 0, _r = []; ; ) {
        if (ae(be), ct >= ve)
          return _r;
        st = ae(Ye), ot = [], st.slice(-1) === "," ? (st = st.replace(Qe, ""), Xr()) : Kr();
      }
      function Kr() {
        for (ae(ye), lt = "", ft = "in descriptor"; ; ) {
          if (gt = Z.charAt(ct), ft === "in descriptor")
            if (ee(gt))
              lt && (ot.push(lt), lt = "", ft = "after descriptor");
            else if (gt === ",") {
              ct += 1, lt && ot.push(lt), Xr();
              return;
            } else if (gt === "(")
              lt = lt + gt, ft = "in parens";
            else if (gt === "") {
              lt && ot.push(lt), Xr();
              return;
            } else
              lt = lt + gt;
          else if (ft === "in parens")
            if (gt === ")")
              lt = lt + gt, ft = "in descriptor";
            else if (gt === "") {
              ot.push(lt), Xr();
              return;
            } else
              lt = lt + gt;
          else if (ft === "after descriptor" && !ee(gt))
            if (gt === "") {
              Xr();
              return;
            } else
              ft = "in descriptor", ct -= 1;
          ct += 1;
        }
      }
      function Xr() {
        var Jr = !1, ei, si, ri, ai, yi = {}, pi, di, xi, Ti, Ai;
        for (ai = 0; ai < ot.length; ai++)
          pi = ot[ai], di = pi[pi.length - 1], xi = pi.substring(0, pi.length - 1), Ti = parseInt(xi, 10), Ai = parseFloat(xi), Je.test(xi) && di === "w" ? ((ei || si) && (Jr = !0), Ti === 0 ? Jr = !0 : ei = Ti) : nt.test(xi) && di === "x" ? ((ei || si || ri) && (Jr = !0), Ai < 0 ? Jr = !0 : si = Ai) : Je.test(xi) && di === "h" ? ((ri || si) && (Jr = !0), Ti === 0 ? Jr = !0 : ri = Ti) : Jr = !0;
        Jr ? console && console.log && console.log("Invalid srcset descriptor found in '" + Z + "' at '" + pi + "'.") : (yi.url = st, ei && (yi.w = ei), si && (yi.d = si), ri && (yi.h = ri), _r.push(yi));
      }
    };
  });
})(parseSrcset$1);
var parseSrcsetExports = parseSrcset$1.exports, picocolors_browser = { exports: {} }, x = String, create = function() {
  return { isColorSupported: !1, reset: x, bold: x, dim: x, italic: x, underline: x, inverse: x, hidden: x, strikethrough: x, black: x, red: x, green: x, yellow: x, blue: x, magenta: x, cyan: x, white: x, gray: x, bgBlack: x, bgRed: x, bgGreen: x, bgYellow: x, bgBlue: x, bgMagenta: x, bgCyan: x, bgWhite: x };
};
picocolors_browser.exports = create();
picocolors_browser.exports.createColors = create;
var picocolors_browserExports = picocolors_browser.exports;
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal);
let pico = picocolors_browserExports, terminalHighlight$1 = require$$2, CssSyntaxError$3 = class gC extends Error {
  constructor(Z, ee, ae, ve, ye, be) {
    super(Z), this.name = "CssSyntaxError", this.reason = Z, ye && (this.file = ye), ve && (this.source = ve), be && (this.plugin = be), typeof ee < "u" && typeof ae < "u" && (typeof ee == "number" ? (this.line = ee, this.column = ae) : (this.line = ee.line, this.column = ee.column, this.endLine = ae.line, this.endColumn = ae.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, gC);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(Z) {
    if (!this.source)
      return "";
    let ee = this.source;
    Z == null && (Z = pico.isColorSupported), terminalHighlight$1 && Z && (ee = terminalHighlight$1(ee));
    let ae = ee.split(/\r?\n/), ve = Math.max(this.line - 3, 0), ye = Math.min(this.line + 2, ae.length), be = String(ye).length, Ye, Qe;
    if (Z) {
      let { bold: Je, gray: nt, red: st } = pico.createColors(!0);
      Ye = (ot) => Je(st(ot)), Qe = (ot) => nt(ot);
    } else
      Ye = Qe = (Je) => Je;
    return ae.slice(ve, ye).map((Je, nt) => {
      let st = ve + 1 + nt, ot = " " + (" " + st).slice(-be) + " | ";
      if (st === this.line) {
        let lt = Qe(ot.replace(/\d/g, " ")) + Je.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return Ye(">") + Qe(ot) + Je + `
 ` + lt + Ye("^");
      }
      return " " + Qe(ot) + Je;
    }).join(`
`);
  }
  toString() {
    let Z = this.showSourceCode();
    return Z && (Z = `

` + Z + `
`), this.name + ": " + this.message + Z;
  }
};
var cssSyntaxError = CssSyntaxError$3;
CssSyntaxError$3.default = CssSyntaxError$3;
var symbols = {};
symbols.isClean = Symbol("isClean");
symbols.my = Symbol("my");
const DEFAULT_RAW = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function capitalize(ie) {
  return ie[0].toUpperCase() + ie.slice(1);
}
let Stringifier$2 = class {
  constructor(Z) {
    this.builder = Z;
  }
  atrule(Z, ee) {
    let ae = "@" + Z.name, ve = Z.params ? this.rawValue(Z, "params") : "";
    if (typeof Z.raws.afterName < "u" ? ae += Z.raws.afterName : ve && (ae += " "), Z.nodes)
      this.block(Z, ae + ve);
    else {
      let ye = (Z.raws.between || "") + (ee ? ";" : "");
      this.builder(ae + ve + ye, Z);
    }
  }
  beforeAfter(Z, ee) {
    let ae;
    Z.type === "decl" ? ae = this.raw(Z, null, "beforeDecl") : Z.type === "comment" ? ae = this.raw(Z, null, "beforeComment") : ee === "before" ? ae = this.raw(Z, null, "beforeRule") : ae = this.raw(Z, null, "beforeClose");
    let ve = Z.parent, ye = 0;
    for (; ve && ve.type !== "root"; )
      ye += 1, ve = ve.parent;
    if (ae.includes(`
`)) {
      let be = this.raw(Z, null, "indent");
      if (be.length)
        for (let Ye = 0; Ye < ye; Ye++)
          ae += be;
    }
    return ae;
  }
  block(Z, ee) {
    let ae = this.raw(Z, "between", "beforeOpen");
    this.builder(ee + ae + "{", Z, "start");
    let ve;
    Z.nodes && Z.nodes.length ? (this.body(Z), ve = this.raw(Z, "after")) : ve = this.raw(Z, "after", "emptyBody"), ve && this.builder(ve), this.builder("}", Z, "end");
  }
  body(Z) {
    let ee = Z.nodes.length - 1;
    for (; ee > 0 && Z.nodes[ee].type === "comment"; )
      ee -= 1;
    let ae = this.raw(Z, "semicolon");
    for (let ve = 0; ve < Z.nodes.length; ve++) {
      let ye = Z.nodes[ve], be = this.raw(ye, "before");
      be && this.builder(be), this.stringify(ye, ee !== ve || ae);
    }
  }
  comment(Z) {
    let ee = this.raw(Z, "left", "commentLeft"), ae = this.raw(Z, "right", "commentRight");
    this.builder("/*" + ee + Z.text + ae + "*/", Z);
  }
  decl(Z, ee) {
    let ae = this.raw(Z, "between", "colon"), ve = Z.prop + ae + this.rawValue(Z, "value");
    Z.important && (ve += Z.raws.important || " !important"), ee && (ve += ";"), this.builder(ve, Z);
  }
  document(Z) {
    this.body(Z);
  }
  raw(Z, ee, ae) {
    let ve;
    if (ae || (ae = ee), ee && (ve = Z.raws[ee], typeof ve < "u"))
      return ve;
    let ye = Z.parent;
    if (ae === "before" && (!ye || ye.type === "root" && ye.first === Z || ye && ye.type === "document"))
      return "";
    if (!ye)
      return DEFAULT_RAW[ae];
    let be = Z.root();
    if (be.rawCache || (be.rawCache = {}), typeof be.rawCache[ae] < "u")
      return be.rawCache[ae];
    if (ae === "before" || ae === "after")
      return this.beforeAfter(Z, ae);
    {
      let Ye = "raw" + capitalize(ae);
      this[Ye] ? ve = this[Ye](be, Z) : be.walk((Qe) => {
        if (ve = Qe.raws[ee], typeof ve < "u")
          return !1;
      });
    }
    return typeof ve > "u" && (ve = DEFAULT_RAW[ae]), be.rawCache[ae] = ve, ve;
  }
  rawBeforeClose(Z) {
    let ee;
    return Z.walk((ae) => {
      if (ae.nodes && ae.nodes.length > 0 && typeof ae.raws.after < "u")
        return ee = ae.raws.after, ee.includes(`
`) && (ee = ee.replace(/[^\n]+$/, "")), !1;
    }), ee && (ee = ee.replace(/\S/g, "")), ee;
  }
  rawBeforeComment(Z, ee) {
    let ae;
    return Z.walkComments((ve) => {
      if (typeof ve.raws.before < "u")
        return ae = ve.raws.before, ae.includes(`
`) && (ae = ae.replace(/[^\n]+$/, "")), !1;
    }), typeof ae > "u" ? ae = this.raw(ee, null, "beforeDecl") : ae && (ae = ae.replace(/\S/g, "")), ae;
  }
  rawBeforeDecl(Z, ee) {
    let ae;
    return Z.walkDecls((ve) => {
      if (typeof ve.raws.before < "u")
        return ae = ve.raws.before, ae.includes(`
`) && (ae = ae.replace(/[^\n]+$/, "")), !1;
    }), typeof ae > "u" ? ae = this.raw(ee, null, "beforeRule") : ae && (ae = ae.replace(/\S/g, "")), ae;
  }
  rawBeforeOpen(Z) {
    let ee;
    return Z.walk((ae) => {
      if (ae.type !== "decl" && (ee = ae.raws.between, typeof ee < "u"))
        return !1;
    }), ee;
  }
  rawBeforeRule(Z) {
    let ee;
    return Z.walk((ae) => {
      if (ae.nodes && (ae.parent !== Z || Z.first !== ae) && typeof ae.raws.before < "u")
        return ee = ae.raws.before, ee.includes(`
`) && (ee = ee.replace(/[^\n]+$/, "")), !1;
    }), ee && (ee = ee.replace(/\S/g, "")), ee;
  }
  rawColon(Z) {
    let ee;
    return Z.walkDecls((ae) => {
      if (typeof ae.raws.between < "u")
        return ee = ae.raws.between.replace(/[^\s:]/g, ""), !1;
    }), ee;
  }
  rawEmptyBody(Z) {
    let ee;
    return Z.walk((ae) => {
      if (ae.nodes && ae.nodes.length === 0 && (ee = ae.raws.after, typeof ee < "u"))
        return !1;
    }), ee;
  }
  rawIndent(Z) {
    if (Z.raws.indent)
      return Z.raws.indent;
    let ee;
    return Z.walk((ae) => {
      let ve = ae.parent;
      if (ve && ve !== Z && ve.parent && ve.parent === Z && typeof ae.raws.before < "u") {
        let ye = ae.raws.before.split(`
`);
        return ee = ye[ye.length - 1], ee = ee.replace(/\S/g, ""), !1;
      }
    }), ee;
  }
  rawSemicolon(Z) {
    let ee;
    return Z.walk((ae) => {
      if (ae.nodes && ae.nodes.length && ae.last.type === "decl" && (ee = ae.raws.semicolon, typeof ee < "u"))
        return !1;
    }), ee;
  }
  rawValue(Z, ee) {
    let ae = Z[ee], ve = Z.raws[ee];
    return ve && ve.value === ae ? ve.raw : ae;
  }
  root(Z) {
    this.body(Z), Z.raws.after && this.builder(Z.raws.after);
  }
  rule(Z) {
    this.block(Z, this.rawValue(Z, "selector")), Z.raws.ownSemicolon && this.builder(Z.raws.ownSemicolon, Z, "end");
  }
  stringify(Z, ee) {
    if (!this[Z.type])
      throw new Error(
        "Unknown AST node type " + Z.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[Z.type](Z, ee);
  }
};
var stringifier = Stringifier$2;
Stringifier$2.default = Stringifier$2;
let Stringifier$1 = stringifier;
function stringify$4(ie, Z) {
  new Stringifier$1(Z).stringify(ie);
}
var stringify_1 = stringify$4;
stringify$4.default = stringify$4;
let { isClean: isClean$2, my: my$2 } = symbols, CssSyntaxError$2 = cssSyntaxError, Stringifier = stringifier, stringify$3 = stringify_1;
function cloneNode(ie, Z) {
  let ee = new ie.constructor();
  for (let ae in ie) {
    if (!Object.prototype.hasOwnProperty.call(ie, ae) || ae === "proxyCache")
      continue;
    let ve = ie[ae], ye = typeof ve;
    ae === "parent" && ye === "object" ? Z && (ee[ae] = Z) : ae === "source" ? ee[ae] = ve : Array.isArray(ve) ? ee[ae] = ve.map((be) => cloneNode(be, ee)) : (ye === "object" && ve !== null && (ve = cloneNode(ve)), ee[ae] = ve);
  }
  return ee;
}
let Node$5 = class {
  constructor(Z = {}) {
    this.raws = {}, this[isClean$2] = !1, this[my$2] = !0;
    for (let ee in Z)
      if (ee === "nodes") {
        this.nodes = [];
        for (let ae of Z[ee])
          typeof ae.clone == "function" ? this.append(ae.clone()) : this.append(ae);
      } else
        this[ee] = Z[ee];
  }
  addToError(Z) {
    if (Z.postcssNode = this, Z.stack && this.source && /\n\s{4}at /.test(Z.stack)) {
      let ee = this.source;
      Z.stack = Z.stack.replace(
        /\n\s{4}at /,
        `$&${ee.input.from}:${ee.start.line}:${ee.start.column}$&`
      );
    }
    return Z;
  }
  after(Z) {
    return this.parent.insertAfter(this, Z), this;
  }
  assign(Z = {}) {
    for (let ee in Z)
      this[ee] = Z[ee];
    return this;
  }
  before(Z) {
    return this.parent.insertBefore(this, Z), this;
  }
  cleanRaws(Z) {
    delete this.raws.before, delete this.raws.after, Z || delete this.raws.between;
  }
  clone(Z = {}) {
    let ee = cloneNode(this);
    for (let ae in Z)
      ee[ae] = Z[ae];
    return ee;
  }
  cloneAfter(Z = {}) {
    let ee = this.clone(Z);
    return this.parent.insertAfter(this, ee), ee;
  }
  cloneBefore(Z = {}) {
    let ee = this.clone(Z);
    return this.parent.insertBefore(this, ee), ee;
  }
  error(Z, ee = {}) {
    if (this.source) {
      let { end: ae, start: ve } = this.rangeBy(ee);
      return this.source.input.error(
        Z,
        { column: ve.column, line: ve.line },
        { column: ae.column, line: ae.line },
        ee
      );
    }
    return new CssSyntaxError$2(Z);
  }
  getProxyProcessor() {
    return {
      get(Z, ee) {
        return ee === "proxyOf" ? Z : ee === "root" ? () => Z.root().toProxy() : Z[ee];
      },
      set(Z, ee, ae) {
        return Z[ee] === ae || (Z[ee] = ae, (ee === "prop" || ee === "value" || ee === "name" || ee === "params" || ee === "important" || /* c8 ignore next */
        ee === "text") && Z.markDirty()), !0;
      }
    };
  }
  markDirty() {
    if (this[isClean$2]) {
      this[isClean$2] = !1;
      let Z = this;
      for (; Z = Z.parent; )
        Z[isClean$2] = !1;
    }
  }
  next() {
    if (!this.parent)
      return;
    let Z = this.parent.index(this);
    return this.parent.nodes[Z + 1];
  }
  positionBy(Z, ee) {
    let ae = this.source.start;
    if (Z.index)
      ae = this.positionInside(Z.index, ee);
    else if (Z.word) {
      ee = this.toString();
      let ve = ee.indexOf(Z.word);
      ve !== -1 && (ae = this.positionInside(ve, ee));
    }
    return ae;
  }
  positionInside(Z, ee) {
    let ae = ee || this.toString(), ve = this.source.start.column, ye = this.source.start.line;
    for (let be = 0; be < Z; be++)
      ae[be] === `
` ? (ve = 1, ye += 1) : ve += 1;
    return { column: ve, line: ye };
  }
  prev() {
    if (!this.parent)
      return;
    let Z = this.parent.index(this);
    return this.parent.nodes[Z - 1];
  }
  rangeBy(Z) {
    let ee = {
      column: this.source.start.column,
      line: this.source.start.line
    }, ae = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: ee.column + 1,
      line: ee.line
    };
    if (Z.word) {
      let ve = this.toString(), ye = ve.indexOf(Z.word);
      ye !== -1 && (ee = this.positionInside(ye, ve), ae = this.positionInside(ye + Z.word.length, ve));
    } else
      Z.start ? ee = {
        column: Z.start.column,
        line: Z.start.line
      } : Z.index && (ee = this.positionInside(Z.index)), Z.end ? ae = {
        column: Z.end.column,
        line: Z.end.line
      } : Z.endIndex ? ae = this.positionInside(Z.endIndex) : Z.index && (ae = this.positionInside(Z.index + 1));
    return (ae.line < ee.line || ae.line === ee.line && ae.column <= ee.column) && (ae = { column: ee.column + 1, line: ee.line }), { end: ae, start: ee };
  }
  raw(Z, ee) {
    return new Stringifier().raw(this, Z, ee);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...Z) {
    if (this.parent) {
      let ee = this, ae = !1;
      for (let ve of Z)
        ve === this ? ae = !0 : ae ? (this.parent.insertAfter(ee, ve), ee = ve) : this.parent.insertBefore(ee, ve);
      ae || this.remove();
    }
    return this;
  }
  root() {
    let Z = this;
    for (; Z.parent && Z.parent.type !== "document"; )
      Z = Z.parent;
    return Z;
  }
  toJSON(Z, ee) {
    let ae = {}, ve = ee == null;
    ee = ee || /* @__PURE__ */ new Map();
    let ye = 0;
    for (let be in this) {
      if (!Object.prototype.hasOwnProperty.call(this, be) || be === "parent" || be === "proxyCache")
        continue;
      let Ye = this[be];
      if (Array.isArray(Ye))
        ae[be] = Ye.map((Qe) => typeof Qe == "object" && Qe.toJSON ? Qe.toJSON(null, ee) : Qe);
      else if (typeof Ye == "object" && Ye.toJSON)
        ae[be] = Ye.toJSON(null, ee);
      else if (be === "source") {
        let Qe = ee.get(Ye.input);
        Qe == null && (Qe = ye, ee.set(Ye.input, ye), ye++), ae[be] = {
          end: Ye.end,
          inputId: Qe,
          start: Ye.start
        };
      } else
        ae[be] = Ye;
    }
    return ve && (ae.inputs = [...ee.keys()].map((be) => be.toJSON())), ae;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(Z = stringify$3) {
    Z.stringify && (Z = Z.stringify);
    let ee = "";
    return Z(this, (ae) => {
      ee += ae;
    }), ee;
  }
  warn(Z, ee, ae) {
    let ve = { node: this };
    for (let ye in ae)
      ve[ye] = ae[ye];
    return Z.warn(ee, ve);
  }
  get proxyOf() {
    return this;
  }
};
var node = Node$5;
Node$5.default = Node$5;
let Node$4 = node, Declaration$4 = class extends Node$4 {
  constructor(Z) {
    Z && typeof Z.value < "u" && typeof Z.value != "string" && (Z = { ...Z, value: String(Z.value) }), super(Z), this.type = "decl";
  }
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
};
var declaration = Declaration$4;
Declaration$4.default = Declaration$4;
let urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", customAlphabet = (ie, Z = 21) => (ee = Z) => {
  let ae = "", ve = ee;
  for (; ve--; )
    ae += ie[Math.random() * ie.length | 0];
  return ae;
}, nanoid$1 = (ie = 21) => {
  let Z = "", ee = ie;
  for (; ee--; )
    Z += urlAlphabet[Math.random() * 64 | 0];
  return Z;
};
var nonSecure = { nanoid: nanoid$1, customAlphabet };
let { SourceMapConsumer: SourceMapConsumer$2, SourceMapGenerator: SourceMapGenerator$2 } = require$$2, { existsSync, readFileSync } = require$$2, { dirname: dirname$1, join } = require$$2;
function fromBase64(ie) {
  return Buffer ? Buffer.from(ie, "base64").toString() : window.atob(ie);
}
let PreviousMap$2 = class {
  constructor(Z, ee) {
    if (ee.map === !1)
      return;
    this.loadAnnotation(Z), this.inline = this.startWith(this.annotation, "data:");
    let ae = ee.map ? ee.map.prev : void 0, ve = this.loadMap(ee.from, ae);
    !this.mapFile && ee.from && (this.mapFile = ee.from), this.mapFile && (this.root = dirname$1(this.mapFile)), ve && (this.text = ve);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new SourceMapConsumer$2(this.text)), this.consumerCache;
  }
  decodeInline(Z) {
    let ee = /^data:application\/json;charset=utf-?8;base64,/, ae = /^data:application\/json;base64,/, ve = /^data:application\/json;charset=utf-?8,/, ye = /^data:application\/json,/;
    if (ve.test(Z) || ye.test(Z))
      return decodeURIComponent(Z.substr(RegExp.lastMatch.length));
    if (ee.test(Z) || ae.test(Z))
      return fromBase64(Z.substr(RegExp.lastMatch.length));
    let be = Z.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + be);
  }
  getAnnotationURL(Z) {
    return Z.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(Z) {
    return typeof Z != "object" ? !1 : typeof Z.mappings == "string" || typeof Z._mappings == "string" || Array.isArray(Z.sections);
  }
  loadAnnotation(Z) {
    let ee = Z.match(/\/\*\s*# sourceMappingURL=/gm);
    if (!ee)
      return;
    let ae = Z.lastIndexOf(ee.pop()), ve = Z.indexOf("*/", ae);
    ae > -1 && ve > -1 && (this.annotation = this.getAnnotationURL(Z.substring(ae, ve)));
  }
  loadFile(Z) {
    if (this.root = dirname$1(Z), existsSync(Z))
      return this.mapFile = Z, readFileSync(Z, "utf-8").toString().trim();
  }
  loadMap(Z, ee) {
    if (ee === !1)
      return !1;
    if (ee) {
      if (typeof ee == "string")
        return ee;
      if (typeof ee == "function") {
        let ae = ee(Z);
        if (ae) {
          let ve = this.loadFile(ae);
          if (!ve)
            throw new Error(
              "Unable to load previous source map: " + ae.toString()
            );
          return ve;
        }
      } else {
        if (ee instanceof SourceMapConsumer$2)
          return SourceMapGenerator$2.fromSourceMap(ee).toString();
        if (ee instanceof SourceMapGenerator$2)
          return ee.toString();
        if (this.isMap(ee))
          return JSON.stringify(ee);
        throw new Error(
          "Unsupported previous source map format: " + ee.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let ae = this.annotation;
        return Z && (ae = join(dirname$1(Z), ae)), this.loadFile(ae);
      }
    }
  }
  startWith(Z, ee) {
    return Z ? Z.substr(0, ee.length) === ee : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var previousMap = PreviousMap$2;
PreviousMap$2.default = PreviousMap$2;
let { SourceMapConsumer: SourceMapConsumer$1, SourceMapGenerator: SourceMapGenerator$1 } = require$$2, { fileURLToPath, pathToFileURL: pathToFileURL$1 } = require$$2, { isAbsolute, resolve: resolve$1 } = require$$2, { nanoid } = nonSecure, terminalHighlight = require$$2, CssSyntaxError$1 = cssSyntaxError, PreviousMap$1 = previousMap, fromOffsetCache = Symbol("fromOffsetCache"), sourceMapAvailable$1 = !!(SourceMapConsumer$1 && SourceMapGenerator$1), pathAvailable$1 = !!(resolve$1 && isAbsolute), Input$4 = class {
  constructor(Z, ee = {}) {
    if (Z === null || typeof Z > "u" || typeof Z == "object" && !Z.toString)
      throw new Error(`PostCSS received ${Z} instead of CSS string`);
    if (this.css = Z.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, ee.from && (!pathAvailable$1 || /^\w+:\/\//.test(ee.from) || isAbsolute(ee.from) ? this.file = ee.from : this.file = resolve$1(ee.from)), pathAvailable$1 && sourceMapAvailable$1) {
      let ae = new PreviousMap$1(this.css, ee);
      if (ae.text) {
        this.map = ae;
        let ve = ae.consumer().file;
        !this.file && ve && (this.file = this.mapResolve(ve));
      }
    }
    this.file || (this.id = "<input css " + nanoid(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(Z, ee, ae, ve = {}) {
    let ye, be, Ye;
    if (ee && typeof ee == "object") {
      let Je = ee, nt = ae;
      if (typeof Je.offset == "number") {
        let st = this.fromOffset(Je.offset);
        ee = st.line, ae = st.col;
      } else
        ee = Je.line, ae = Je.column;
      if (typeof nt.offset == "number") {
        let st = this.fromOffset(nt.offset);
        be = st.line, Ye = st.col;
      } else
        be = nt.line, Ye = nt.column;
    } else if (!ae) {
      let Je = this.fromOffset(ee);
      ee = Je.line, ae = Je.col;
    }
    let Qe = this.origin(ee, ae, be, Ye);
    return Qe ? ye = new CssSyntaxError$1(
      Z,
      Qe.endLine === void 0 ? Qe.line : { column: Qe.column, line: Qe.line },
      Qe.endLine === void 0 ? Qe.column : { column: Qe.endColumn, line: Qe.endLine },
      Qe.source,
      Qe.file,
      ve.plugin
    ) : ye = new CssSyntaxError$1(
      Z,
      be === void 0 ? ee : { column: ae, line: ee },
      be === void 0 ? ae : { column: Ye, line: be },
      this.css,
      this.file,
      ve.plugin
    ), ye.input = { column: ae, endColumn: Ye, endLine: be, line: ee, source: this.css }, this.file && (pathToFileURL$1 && (ye.input.url = pathToFileURL$1(this.file).toString()), ye.input.file = this.file), ye;
  }
  fromOffset(Z) {
    let ee, ae;
    if (this[fromOffsetCache])
      ae = this[fromOffsetCache];
    else {
      let ye = this.css.split(`
`);
      ae = new Array(ye.length);
      let be = 0;
      for (let Ye = 0, Qe = ye.length; Ye < Qe; Ye++)
        ae[Ye] = be, be += ye[Ye].length + 1;
      this[fromOffsetCache] = ae;
    }
    ee = ae[ae.length - 1];
    let ve = 0;
    if (Z >= ee)
      ve = ae.length - 1;
    else {
      let ye = ae.length - 2, be;
      for (; ve < ye; )
        if (be = ve + (ye - ve >> 1), Z < ae[be])
          ye = be - 1;
        else if (Z >= ae[be + 1])
          ve = be + 1;
        else {
          ve = be;
          break;
        }
    }
    return {
      col: Z - ae[ve] + 1,
      line: ve + 1
    };
  }
  mapResolve(Z) {
    return /^\w+:\/\//.test(Z) ? Z : resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", Z);
  }
  origin(Z, ee, ae, ve) {
    if (!this.map)
      return !1;
    let ye = this.map.consumer(), be = ye.originalPositionFor({ column: ee, line: Z });
    if (!be.source)
      return !1;
    let Ye;
    typeof ae == "number" && (Ye = ye.originalPositionFor({ column: ve, line: ae }));
    let Qe;
    isAbsolute(be.source) ? Qe = pathToFileURL$1(be.source) : Qe = new URL(
      be.source,
      this.map.consumer().sourceRoot || pathToFileURL$1(this.map.mapFile)
    );
    let Je = {
      column: be.column,
      endColumn: Ye && Ye.column,
      endLine: Ye && Ye.line,
      line: be.line,
      url: Qe.toString()
    };
    if (Qe.protocol === "file:")
      if (fileURLToPath)
        Je.file = fileURLToPath(Qe);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let nt = ye.sourceContentFor(be.source);
    return nt && (Je.source = nt), Je;
  }
  toJSON() {
    let Z = {};
    for (let ee of ["hasBOM", "css", "file", "id"])
      this[ee] != null && (Z[ee] = this[ee]);
    return this.map && (Z.map = { ...this.map }, Z.map.consumerCache && (Z.map.consumerCache = void 0)), Z;
  }
  get from() {
    return this.file || this.id;
  }
};
var input = Input$4;
Input$4.default = Input$4;
terminalHighlight && terminalHighlight.registerInput && terminalHighlight.registerInput(Input$4);
let { SourceMapConsumer, SourceMapGenerator } = require$$2, { dirname, relative, resolve, sep } = require$$2, { pathToFileURL } = require$$2, Input$3 = input, sourceMapAvailable = !!(SourceMapConsumer && SourceMapGenerator), pathAvailable = !!(dirname && resolve && relative && sep), MapGenerator$2 = class {
  constructor(Z, ee, ae, ve) {
    this.stringify = Z, this.mapOpts = ae.map || {}, this.root = ee, this.opts = ae, this.css = ve, this.originalCSS = ve, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let Z;
    this.isInline() ? Z = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? Z = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? Z = this.mapOpts.annotation(this.opts.to, this.root) : Z = this.outputFile() + ".map";
    let ee = `
`;
    this.css.includes(`\r
`) && (ee = `\r
`), this.css += ee + "/*# sourceMappingURL=" + Z + " */";
  }
  applyPrevMaps() {
    for (let Z of this.previous()) {
      let ee = this.toUrl(this.path(Z.file)), ae = Z.root || dirname(Z.file), ve;
      this.mapOpts.sourcesContent === !1 ? (ve = new SourceMapConsumer(Z.text), ve.sourcesContent && (ve.sourcesContent = ve.sourcesContent.map(() => null))) : ve = Z.consumer(), this.map.applySourceMap(ve, ee, this.toUrl(this.path(ae)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let Z;
        for (let ee = this.root.nodes.length - 1; ee >= 0; ee--)
          Z = this.root.nodes[ee], Z.type === "comment" && Z.text.indexOf("# sourceMappingURL=") === 0 && this.root.removeChild(ee);
      } else
        this.css && (this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), pathAvailable && sourceMapAvailable && this.isMap())
      return this.generateMap();
    {
      let Z = "";
      return this.stringify(this.root, (ee) => {
        Z += ee;
      }), [Z];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let Z = this.previous()[0].consumer();
      Z.file = this.outputFile(), this.map = SourceMapGenerator.fromSourceMap(Z);
    } else
      this.map = new SourceMapGenerator({ file: this.outputFile() }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new SourceMapGenerator({ file: this.outputFile() });
    let Z = 1, ee = 1, ae = "<no source>", ve = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, ye, be;
    this.stringify(this.root, (Ye, Qe, Je) => {
      if (this.css += Ye, Qe && Je !== "end" && (ve.generated.line = Z, ve.generated.column = ee - 1, Qe.source && Qe.source.start ? (ve.source = this.sourcePath(Qe), ve.original.line = Qe.source.start.line, ve.original.column = Qe.source.start.column - 1, this.map.addMapping(ve)) : (ve.source = ae, ve.original.line = 1, ve.original.column = 0, this.map.addMapping(ve))), ye = Ye.match(/\n/g), ye ? (Z += ye.length, be = Ye.lastIndexOf(`
`), ee = Ye.length - be) : ee += Ye.length, Qe && Je !== "start") {
        let nt = Qe.parent || { raws: {} };
        (!(Qe.type === "decl" || Qe.type === "atrule" && !Qe.nodes) || Qe !== nt.last || nt.raws.semicolon) && (Qe.source && Qe.source.end ? (ve.source = this.sourcePath(Qe), ve.original.line = Qe.source.end.line, ve.original.column = Qe.source.end.column - 1, ve.generated.line = Z, ve.generated.column = ee - 2, this.map.addMapping(ve)) : (ve.source = ae, ve.original.line = 1, ve.original.column = 0, ve.generated.line = Z, ve.generated.column = ee - 1, this.map.addMapping(ve)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((Z) => Z.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let Z = this.mapOpts.annotation;
    return typeof Z < "u" && Z !== !0 ? !1 : this.previous().length ? this.previous().some((ee) => ee.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((Z) => Z.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(Z) {
    if (this.mapOpts.absolute || Z.charCodeAt(0) === 60 || /^\w+:\/\//.test(Z))
      return Z;
    let ee = this.memoizedPaths.get(Z);
    if (ee)
      return ee;
    let ae = this.opts.to ? dirname(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (ae = dirname(resolve(ae, this.mapOpts.annotation)));
    let ve = relative(ae, Z);
    return this.memoizedPaths.set(Z, ve), ve;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((Z) => {
          if (Z.source && Z.source.input.map) {
            let ee = Z.source.input.map;
            this.previousMaps.includes(ee) || this.previousMaps.push(ee);
          }
        });
      else {
        let Z = new Input$3(this.originalCSS, this.opts);
        Z.map && this.previousMaps.push(Z.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let Z = {};
    if (this.root)
      this.root.walk((ee) => {
        if (ee.source) {
          let ae = ee.source.input.from;
          if (ae && !Z[ae]) {
            Z[ae] = !0;
            let ve = this.usesFileUrls ? this.toFileUrl(ae) : this.toUrl(this.path(ae));
            this.map.setSourceContent(ve, ee.source.input.css);
          }
        }
      });
    else if (this.css) {
      let ee = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(ee, this.css);
    }
  }
  sourcePath(Z) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(Z.source.input.from) : this.toUrl(this.path(Z.source.input.from));
  }
  toBase64(Z) {
    return Buffer ? Buffer.from(Z).toString("base64") : window.btoa(unescape(encodeURIComponent(Z)));
  }
  toFileUrl(Z) {
    let ee = this.memoizedFileURLs.get(Z);
    if (ee)
      return ee;
    if (pathToFileURL) {
      let ae = pathToFileURL(Z).toString();
      return this.memoizedFileURLs.set(Z, ae), ae;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(Z) {
    let ee = this.memoizedURLs.get(Z);
    if (ee)
      return ee;
    sep === "\\" && (Z = Z.replace(/\\/g, "/"));
    let ae = encodeURI(Z).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(Z, ae), ae;
  }
};
var mapGenerator = MapGenerator$2;
let Node$3 = node, Comment$4 = class extends Node$3 {
  constructor(Z) {
    super(Z), this.type = "comment";
  }
};
var comment = Comment$4;
Comment$4.default = Comment$4;
let { isClean: isClean$1, my: my$1 } = symbols, Declaration$3 = declaration, Comment$3 = comment, Node$2 = node, parse$8, Rule$4, AtRule$4, Root$6;
function cleanSource(ie) {
  return ie.map((Z) => (Z.nodes && (Z.nodes = cleanSource(Z.nodes)), delete Z.source, Z));
}
function markDirtyUp(ie) {
  if (ie[isClean$1] = !1, ie.proxyOf.nodes)
    for (let Z of ie.proxyOf.nodes)
      markDirtyUp(Z);
}
let Container$7 = class mC extends Node$2 {
  append(...Z) {
    for (let ee of Z) {
      let ae = this.normalize(ee, this.last);
      for (let ve of ae)
        this.proxyOf.nodes.push(ve);
    }
    return this.markDirty(), this;
  }
  cleanRaws(Z) {
    if (super.cleanRaws(Z), this.nodes)
      for (let ee of this.nodes)
        ee.cleanRaws(Z);
  }
  each(Z) {
    if (!this.proxyOf.nodes)
      return;
    let ee = this.getIterator(), ae, ve;
    for (; this.indexes[ee] < this.proxyOf.nodes.length && (ae = this.indexes[ee], ve = Z(this.proxyOf.nodes[ae], ae), ve !== !1); )
      this.indexes[ee] += 1;
    return delete this.indexes[ee], ve;
  }
  every(Z) {
    return this.nodes.every(Z);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let Z = this.lastEach;
    return this.indexes[Z] = 0, Z;
  }
  getProxyProcessor() {
    return {
      get(Z, ee) {
        return ee === "proxyOf" ? Z : Z[ee] ? ee === "each" || typeof ee == "string" && ee.startsWith("walk") ? (...ae) => Z[ee](
          ...ae.map((ve) => typeof ve == "function" ? (ye, be) => ve(ye.toProxy(), be) : ve)
        ) : ee === "every" || ee === "some" ? (ae) => Z[ee](
          (ve, ...ye) => ae(ve.toProxy(), ...ye)
        ) : ee === "root" ? () => Z.root().toProxy() : ee === "nodes" ? Z.nodes.map((ae) => ae.toProxy()) : ee === "first" || ee === "last" ? Z[ee].toProxy() : Z[ee] : Z[ee];
      },
      set(Z, ee, ae) {
        return Z[ee] === ae || (Z[ee] = ae, (ee === "name" || ee === "params" || ee === "selector") && Z.markDirty()), !0;
      }
    };
  }
  index(Z) {
    return typeof Z == "number" ? Z : (Z.proxyOf && (Z = Z.proxyOf), this.proxyOf.nodes.indexOf(Z));
  }
  insertAfter(Z, ee) {
    let ae = this.index(Z), ve = this.normalize(ee, this.proxyOf.nodes[ae]).reverse();
    ae = this.index(Z);
    for (let be of ve)
      this.proxyOf.nodes.splice(ae + 1, 0, be);
    let ye;
    for (let be in this.indexes)
      ye = this.indexes[be], ae < ye && (this.indexes[be] = ye + ve.length);
    return this.markDirty(), this;
  }
  insertBefore(Z, ee) {
    let ae = this.index(Z), ve = ae === 0 ? "prepend" : !1, ye = this.normalize(ee, this.proxyOf.nodes[ae], ve).reverse();
    ae = this.index(Z);
    for (let Ye of ye)
      this.proxyOf.nodes.splice(ae, 0, Ye);
    let be;
    for (let Ye in this.indexes)
      be = this.indexes[Ye], ae <= be && (this.indexes[Ye] = be + ye.length);
    return this.markDirty(), this;
  }
  normalize(Z, ee) {
    if (typeof Z == "string")
      Z = cleanSource(parse$8(Z).nodes);
    else if (Array.isArray(Z)) {
      Z = Z.slice(0);
      for (let ve of Z)
        ve.parent && ve.parent.removeChild(ve, "ignore");
    } else if (Z.type === "root" && this.type !== "document") {
      Z = Z.nodes.slice(0);
      for (let ve of Z)
        ve.parent && ve.parent.removeChild(ve, "ignore");
    } else if (Z.type)
      Z = [Z];
    else if (Z.prop) {
      if (typeof Z.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof Z.value != "string" && (Z.value = String(Z.value)), Z = [new Declaration$3(Z)];
    } else if (Z.selector)
      Z = [new Rule$4(Z)];
    else if (Z.name)
      Z = [new AtRule$4(Z)];
    else if (Z.text)
      Z = [new Comment$3(Z)];
    else
      throw new Error("Unknown node type in node creation");
    return Z.map((ve) => (ve[my$1] || mC.rebuild(ve), ve = ve.proxyOf, ve.parent && ve.parent.removeChild(ve), ve[isClean$1] && markDirtyUp(ve), typeof ve.raws.before > "u" && ee && typeof ee.raws.before < "u" && (ve.raws.before = ee.raws.before.replace(/\S/g, "")), ve.parent = this.proxyOf, ve));
  }
  prepend(...Z) {
    Z = Z.reverse();
    for (let ee of Z) {
      let ae = this.normalize(ee, this.first, "prepend").reverse();
      for (let ve of ae)
        this.proxyOf.nodes.unshift(ve);
      for (let ve in this.indexes)
        this.indexes[ve] = this.indexes[ve] + ae.length;
    }
    return this.markDirty(), this;
  }
  push(Z) {
    return Z.parent = this, this.proxyOf.nodes.push(Z), this;
  }
  removeAll() {
    for (let Z of this.proxyOf.nodes)
      Z.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(Z) {
    Z = this.index(Z), this.proxyOf.nodes[Z].parent = void 0, this.proxyOf.nodes.splice(Z, 1);
    let ee;
    for (let ae in this.indexes)
      ee = this.indexes[ae], ee >= Z && (this.indexes[ae] = ee - 1);
    return this.markDirty(), this;
  }
  replaceValues(Z, ee, ae) {
    return ae || (ae = ee, ee = {}), this.walkDecls((ve) => {
      ee.props && !ee.props.includes(ve.prop) || ee.fast && !ve.value.includes(ee.fast) || (ve.value = ve.value.replace(Z, ae));
    }), this.markDirty(), this;
  }
  some(Z) {
    return this.nodes.some(Z);
  }
  walk(Z) {
    return this.each((ee, ae) => {
      let ve;
      try {
        ve = Z(ee, ae);
      } catch (ye) {
        throw ee.addToError(ye);
      }
      return ve !== !1 && ee.walk && (ve = ee.walk(Z)), ve;
    });
  }
  walkAtRules(Z, ee) {
    return ee ? Z instanceof RegExp ? this.walk((ae, ve) => {
      if (ae.type === "atrule" && Z.test(ae.name))
        return ee(ae, ve);
    }) : this.walk((ae, ve) => {
      if (ae.type === "atrule" && ae.name === Z)
        return ee(ae, ve);
    }) : (ee = Z, this.walk((ae, ve) => {
      if (ae.type === "atrule")
        return ee(ae, ve);
    }));
  }
  walkComments(Z) {
    return this.walk((ee, ae) => {
      if (ee.type === "comment")
        return Z(ee, ae);
    });
  }
  walkDecls(Z, ee) {
    return ee ? Z instanceof RegExp ? this.walk((ae, ve) => {
      if (ae.type === "decl" && Z.test(ae.prop))
        return ee(ae, ve);
    }) : this.walk((ae, ve) => {
      if (ae.type === "decl" && ae.prop === Z)
        return ee(ae, ve);
    }) : (ee = Z, this.walk((ae, ve) => {
      if (ae.type === "decl")
        return ee(ae, ve);
    }));
  }
  walkRules(Z, ee) {
    return ee ? Z instanceof RegExp ? this.walk((ae, ve) => {
      if (ae.type === "rule" && Z.test(ae.selector))
        return ee(ae, ve);
    }) : this.walk((ae, ve) => {
      if (ae.type === "rule" && ae.selector === Z)
        return ee(ae, ve);
    }) : (ee = Z, this.walk((ae, ve) => {
      if (ae.type === "rule")
        return ee(ae, ve);
    }));
  }
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
};
Container$7.registerParse = (ie) => {
  parse$8 = ie;
};
Container$7.registerRule = (ie) => {
  Rule$4 = ie;
};
Container$7.registerAtRule = (ie) => {
  AtRule$4 = ie;
};
Container$7.registerRoot = (ie) => {
  Root$6 = ie;
};
var container = Container$7;
Container$7.default = Container$7;
Container$7.rebuild = (ie) => {
  ie.type === "atrule" ? Object.setPrototypeOf(ie, AtRule$4.prototype) : ie.type === "rule" ? Object.setPrototypeOf(ie, Rule$4.prototype) : ie.type === "decl" ? Object.setPrototypeOf(ie, Declaration$3.prototype) : ie.type === "comment" ? Object.setPrototypeOf(ie, Comment$3.prototype) : ie.type === "root" && Object.setPrototypeOf(ie, Root$6.prototype), ie[my$1] = !0, ie.nodes && ie.nodes.forEach((Z) => {
    Container$7.rebuild(Z);
  });
};
let Container$6 = container, LazyResult$4, Processor$3, Document$3 = class extends Container$6 {
  constructor(Z) {
    super({ type: "document", ...Z }), this.nodes || (this.nodes = []);
  }
  toResult(Z = {}) {
    return new LazyResult$4(new Processor$3(), this, Z).stringify();
  }
};
Document$3.registerLazyResult = (ie) => {
  LazyResult$4 = ie;
};
Document$3.registerProcessor = (ie) => {
  Processor$3 = ie;
};
var document$1 = Document$3;
Document$3.default = Document$3;
let printed = {};
var warnOnce$2 = function(Z) {
  printed[Z] || (printed[Z] = !0, typeof console < "u" && console.warn && console.warn(Z));
};
let Warning$2 = class {
  constructor(Z, ee = {}) {
    if (this.type = "warning", this.text = Z, ee.node && ee.node.source) {
      let ae = ee.node.rangeBy(ee);
      this.line = ae.start.line, this.column = ae.start.column, this.endLine = ae.end.line, this.endColumn = ae.end.column;
    }
    for (let ae in ee)
      this[ae] = ee[ae];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var warning = Warning$2;
Warning$2.default = Warning$2;
let Warning$1 = warning, Result$3 = class {
  constructor(Z, ee, ae) {
    this.processor = Z, this.messages = [], this.root = ee, this.opts = ae, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(Z, ee = {}) {
    ee.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (ee.plugin = this.lastPlugin.postcssPlugin);
    let ae = new Warning$1(Z, ee);
    return this.messages.push(ae), ae;
  }
  warnings() {
    return this.messages.filter((Z) => Z.type === "warning");
  }
  get content() {
    return this.css;
  }
};
var result = Result$3;
Result$3.default = Result$3;
const SINGLE_QUOTE = 39, DOUBLE_QUOTE = 34, BACKSLASH = 92, SLASH = 47, NEWLINE = 10, SPACE = 32, FEED = 12, TAB = 9, CR = 13, OPEN_SQUARE = 91, CLOSE_SQUARE = 93, OPEN_PARENTHESES = 40, CLOSE_PARENTHESES = 41, OPEN_CURLY = 123, CLOSE_CURLY = 125, SEMICOLON = 59, ASTERISK = 42, COLON = 58, AT = 64, RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g, RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, RE_BAD_BRACKET = /.[\r\n"'(/\\]/, RE_HEX_ESCAPE = /[\da-f]/i;
var tokenize = function(Z, ee = {}) {
  let ae = Z.css.valueOf(), ve = ee.ignoreErrors, ye, be, Ye, Qe, Je, nt, st, ot, lt, ft, gt = ae.length, ct = 0, _r = [], Kr = [];
  function Xr() {
    return ct;
  }
  function Jr(ai) {
    throw Z.error("Unclosed " + ai, ct);
  }
  function ei() {
    return Kr.length === 0 && ct >= gt;
  }
  function si(ai) {
    if (Kr.length)
      return Kr.pop();
    if (ct >= gt)
      return;
    let yi = ai ? ai.ignoreUnclosed : !1;
    switch (ye = ae.charCodeAt(ct), ye) {
      case NEWLINE:
      case SPACE:
      case TAB:
      case CR:
      case FEED: {
        be = ct;
        do
          be += 1, ye = ae.charCodeAt(be);
        while (ye === SPACE || ye === NEWLINE || ye === TAB || ye === CR || ye === FEED);
        ft = ["space", ae.slice(ct, be)], ct = be - 1;
        break;
      }
      case OPEN_SQUARE:
      case CLOSE_SQUARE:
      case OPEN_CURLY:
      case CLOSE_CURLY:
      case COLON:
      case SEMICOLON:
      case CLOSE_PARENTHESES: {
        let pi = String.fromCharCode(ye);
        ft = [pi, pi, ct];
        break;
      }
      case OPEN_PARENTHESES: {
        if (ot = _r.length ? _r.pop()[1] : "", lt = ae.charCodeAt(ct + 1), ot === "url" && lt !== SINGLE_QUOTE && lt !== DOUBLE_QUOTE && lt !== SPACE && lt !== NEWLINE && lt !== TAB && lt !== FEED && lt !== CR) {
          be = ct;
          do {
            if (nt = !1, be = ae.indexOf(")", be + 1), be === -1)
              if (ve || yi) {
                be = ct;
                break;
              } else
                Jr("bracket");
            for (st = be; ae.charCodeAt(st - 1) === BACKSLASH; )
              st -= 1, nt = !nt;
          } while (nt);
          ft = ["brackets", ae.slice(ct, be + 1), ct, be], ct = be;
        } else
          be = ae.indexOf(")", ct + 1), Qe = ae.slice(ct, be + 1), be === -1 || RE_BAD_BRACKET.test(Qe) ? ft = ["(", "(", ct] : (ft = ["brackets", Qe, ct, be], ct = be);
        break;
      }
      case SINGLE_QUOTE:
      case DOUBLE_QUOTE: {
        Ye = ye === SINGLE_QUOTE ? "'" : '"', be = ct;
        do {
          if (nt = !1, be = ae.indexOf(Ye, be + 1), be === -1)
            if (ve || yi) {
              be = ct + 1;
              break;
            } else
              Jr("string");
          for (st = be; ae.charCodeAt(st - 1) === BACKSLASH; )
            st -= 1, nt = !nt;
        } while (nt);
        ft = ["string", ae.slice(ct, be + 1), ct, be], ct = be;
        break;
      }
      case AT: {
        RE_AT_END.lastIndex = ct + 1, RE_AT_END.test(ae), RE_AT_END.lastIndex === 0 ? be = ae.length - 1 : be = RE_AT_END.lastIndex - 2, ft = ["at-word", ae.slice(ct, be + 1), ct, be], ct = be;
        break;
      }
      case BACKSLASH: {
        for (be = ct, Je = !0; ae.charCodeAt(be + 1) === BACKSLASH; )
          be += 1, Je = !Je;
        if (ye = ae.charCodeAt(be + 1), Je && ye !== SLASH && ye !== SPACE && ye !== NEWLINE && ye !== TAB && ye !== CR && ye !== FEED && (be += 1, RE_HEX_ESCAPE.test(ae.charAt(be)))) {
          for (; RE_HEX_ESCAPE.test(ae.charAt(be + 1)); )
            be += 1;
          ae.charCodeAt(be + 1) === SPACE && (be += 1);
        }
        ft = ["word", ae.slice(ct, be + 1), ct, be], ct = be;
        break;
      }
      default: {
        ye === SLASH && ae.charCodeAt(ct + 1) === ASTERISK ? (be = ae.indexOf("*/", ct + 2) + 1, be === 0 && (ve || yi ? be = ae.length : Jr("comment")), ft = ["comment", ae.slice(ct, be + 1), ct, be], ct = be) : (RE_WORD_END.lastIndex = ct + 1, RE_WORD_END.test(ae), RE_WORD_END.lastIndex === 0 ? be = ae.length - 1 : be = RE_WORD_END.lastIndex - 2, ft = ["word", ae.slice(ct, be + 1), ct, be], _r.push(ft), ct = be);
        break;
      }
    }
    return ct++, ft;
  }
  function ri(ai) {
    Kr.push(ai);
  }
  return {
    back: ri,
    endOfFile: ei,
    nextToken: si,
    position: Xr
  };
};
let Container$5 = container, AtRule$3 = class extends Container$5 {
  constructor(Z) {
    super(Z), this.type = "atrule";
  }
  append(...Z) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...Z);
  }
  prepend(...Z) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...Z);
  }
};
var atRule = AtRule$3;
AtRule$3.default = AtRule$3;
Container$5.registerAtRule(AtRule$3);
let Container$4 = container, LazyResult$3, Processor$2, Root$5 = class extends Container$4 {
  constructor(Z) {
    super(Z), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(Z, ee, ae) {
    let ve = super.normalize(Z);
    if (ee) {
      if (ae === "prepend")
        this.nodes.length > 1 ? ee.raws.before = this.nodes[1].raws.before : delete ee.raws.before;
      else if (this.first !== ee)
        for (let ye of ve)
          ye.raws.before = ee.raws.before;
    }
    return ve;
  }
  removeChild(Z, ee) {
    let ae = this.index(Z);
    return !ee && ae === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[ae].raws.before), super.removeChild(Z);
  }
  toResult(Z = {}) {
    return new LazyResult$3(new Processor$2(), this, Z).stringify();
  }
};
Root$5.registerLazyResult = (ie) => {
  LazyResult$3 = ie;
};
Root$5.registerProcessor = (ie) => {
  Processor$2 = ie;
};
var root = Root$5;
Root$5.default = Root$5;
Container$4.registerRoot(Root$5);
let list$2 = {
  comma(ie) {
    return list$2.split(ie, [","], !0);
  },
  space(ie) {
    let Z = [" ", `
`, "	"];
    return list$2.split(ie, Z);
  },
  split(ie, Z, ee) {
    let ae = [], ve = "", ye = !1, be = 0, Ye = !1, Qe = "", Je = !1;
    for (let nt of ie)
      Je ? Je = !1 : nt === "\\" ? Je = !0 : Ye ? nt === Qe && (Ye = !1) : nt === '"' || nt === "'" ? (Ye = !0, Qe = nt) : nt === "(" ? be += 1 : nt === ")" ? be > 0 && (be -= 1) : be === 0 && Z.includes(nt) && (ye = !0), ye ? (ve !== "" && ae.push(ve.trim()), ve = "", ye = !1) : ve += nt;
    return (ee || ve !== "") && ae.push(ve.trim()), ae;
  }
};
var list_1 = list$2;
list$2.default = list$2;
let Container$3 = container, list$1 = list_1, Rule$3 = class extends Container$3 {
  constructor(Z) {
    super(Z), this.type = "rule", this.nodes || (this.nodes = []);
  }
  get selectors() {
    return list$1.comma(this.selector);
  }
  set selectors(Z) {
    let ee = this.selector ? this.selector.match(/,\s*/) : null, ae = ee ? ee[0] : "," + this.raw("between", "beforeOpen");
    this.selector = Z.join(ae);
  }
};
var rule = Rule$3;
Rule$3.default = Rule$3;
Container$3.registerRule(Rule$3);
let Declaration$2 = declaration, tokenizer = tokenize, Comment$2 = comment, AtRule$2 = atRule, Root$4 = root, Rule$2 = rule;
const SAFE_COMMENT_NEIGHBOR = {
  empty: !0,
  space: !0
};
function findLastWithPosition(ie) {
  for (let Z = ie.length - 1; Z >= 0; Z--) {
    let ee = ie[Z], ae = ee[3] || ee[2];
    if (ae)
      return ae;
  }
}
let Parser$1 = class {
  constructor(Z) {
    this.input = Z, this.root = new Root$4(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.customProperty = !1, this.createTokenizer(), this.root.source = { input: Z, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(Z) {
    let ee = new AtRule$2();
    ee.name = Z[1].slice(1), ee.name === "" && this.unnamedAtrule(ee, Z), this.init(ee, Z[2]);
    let ae, ve, ye, be = !1, Ye = !1, Qe = [], Je = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (Z = this.tokenizer.nextToken(), ae = Z[0], ae === "(" || ae === "[" ? Je.push(ae === "(" ? ")" : "]") : ae === "{" && Je.length > 0 ? Je.push("}") : ae === Je[Je.length - 1] && Je.pop(), Je.length === 0)
        if (ae === ";") {
          ee.source.end = this.getPosition(Z[2]), ee.source.end.offset++, this.semicolon = !0;
          break;
        } else if (ae === "{") {
          Ye = !0;
          break;
        } else if (ae === "}") {
          if (Qe.length > 0) {
            for (ye = Qe.length - 1, ve = Qe[ye]; ve && ve[0] === "space"; )
              ve = Qe[--ye];
            ve && (ee.source.end = this.getPosition(ve[3] || ve[2]), ee.source.end.offset++);
          }
          this.end(Z);
          break;
        } else
          Qe.push(Z);
      else
        Qe.push(Z);
      if (this.tokenizer.endOfFile()) {
        be = !0;
        break;
      }
    }
    ee.raws.between = this.spacesAndCommentsFromEnd(Qe), Qe.length ? (ee.raws.afterName = this.spacesAndCommentsFromStart(Qe), this.raw(ee, "params", Qe), be && (Z = Qe[Qe.length - 1], ee.source.end = this.getPosition(Z[3] || Z[2]), ee.source.end.offset++, this.spaces = ee.raws.between, ee.raws.between = "")) : (ee.raws.afterName = "", ee.params = ""), Ye && (ee.nodes = [], this.current = ee);
  }
  checkMissedSemicolon(Z) {
    let ee = this.colon(Z);
    if (ee === !1)
      return;
    let ae = 0, ve;
    for (let ye = ee - 1; ye >= 0 && (ve = Z[ye], !(ve[0] !== "space" && (ae += 1, ae === 2))); ye--)
      ;
    throw this.input.error(
      "Missed semicolon",
      ve[0] === "word" ? ve[3] + 1 : ve[2]
    );
  }
  colon(Z) {
    let ee = 0, ae, ve, ye;
    for (let [be, Ye] of Z.entries()) {
      if (ae = Ye, ve = ae[0], ve === "(" && (ee += 1), ve === ")" && (ee -= 1), ee === 0 && ve === ":")
        if (!ye)
          this.doubleColon(ae);
        else {
          if (ye[0] === "word" && ye[1] === "progid")
            continue;
          return be;
        }
      ye = ae;
    }
    return !1;
  }
  comment(Z) {
    let ee = new Comment$2();
    this.init(ee, Z[2]), ee.source.end = this.getPosition(Z[3] || Z[2]), ee.source.end.offset++;
    let ae = Z[1].slice(2, -2);
    if (/^\s*$/.test(ae))
      ee.text = "", ee.raws.left = ae, ee.raws.right = "";
    else {
      let ve = ae.match(/^(\s*)([^]*\S)(\s*)$/);
      ee.text = ve[2], ee.raws.left = ve[1], ee.raws.right = ve[3];
    }
  }
  createTokenizer() {
    this.tokenizer = tokenizer(this.input);
  }
  decl(Z, ee) {
    let ae = new Declaration$2();
    this.init(ae, Z[0][2]);
    let ve = Z[Z.length - 1];
    for (ve[0] === ";" && (this.semicolon = !0, Z.pop()), ae.source.end = this.getPosition(
      ve[3] || ve[2] || findLastWithPosition(Z)
    ), ae.source.end.offset++; Z[0][0] !== "word"; )
      Z.length === 1 && this.unknownWord(Z), ae.raws.before += Z.shift()[1];
    for (ae.source.start = this.getPosition(Z[0][2]), ae.prop = ""; Z.length; ) {
      let Je = Z[0][0];
      if (Je === ":" || Je === "space" || Je === "comment")
        break;
      ae.prop += Z.shift()[1];
    }
    ae.raws.between = "";
    let ye;
    for (; Z.length; )
      if (ye = Z.shift(), ye[0] === ":") {
        ae.raws.between += ye[1];
        break;
      } else
        ye[0] === "word" && /\w/.test(ye[1]) && this.unknownWord([ye]), ae.raws.between += ye[1];
    (ae.prop[0] === "_" || ae.prop[0] === "*") && (ae.raws.before += ae.prop[0], ae.prop = ae.prop.slice(1));
    let be = [], Ye;
    for (; Z.length && (Ye = Z[0][0], !(Ye !== "space" && Ye !== "comment")); )
      be.push(Z.shift());
    this.precheckMissedSemicolon(Z);
    for (let Je = Z.length - 1; Je >= 0; Je--) {
      if (ye = Z[Je], ye[1].toLowerCase() === "!important") {
        ae.important = !0;
        let nt = this.stringFrom(Z, Je);
        nt = this.spacesFromEnd(Z) + nt, nt !== " !important" && (ae.raws.important = nt);
        break;
      } else if (ye[1].toLowerCase() === "important") {
        let nt = Z.slice(0), st = "";
        for (let ot = Je; ot > 0; ot--) {
          let lt = nt[ot][0];
          if (st.trim().indexOf("!") === 0 && lt !== "space")
            break;
          st = nt.pop()[1] + st;
        }
        st.trim().indexOf("!") === 0 && (ae.important = !0, ae.raws.important = st, Z = nt);
      }
      if (ye[0] !== "space" && ye[0] !== "comment")
        break;
    }
    Z.some((Je) => Je[0] !== "space" && Je[0] !== "comment") && (ae.raws.between += be.map((Je) => Je[1]).join(""), be = []), this.raw(ae, "value", be.concat(Z), ee), ae.value.includes(":") && !ee && this.checkMissedSemicolon(Z);
  }
  doubleColon(Z) {
    throw this.input.error(
      "Double colon",
      { offset: Z[2] },
      { offset: Z[2] + Z[1].length }
    );
  }
  emptyRule(Z) {
    let ee = new Rule$2();
    this.init(ee, Z[2]), ee.selector = "", ee.raws.between = "", this.current = ee;
  }
  end(Z) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(Z[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(Z);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(Z) {
    if (this.spaces += Z[1], this.current.nodes) {
      let ee = this.current.nodes[this.current.nodes.length - 1];
      ee && ee.type === "rule" && !ee.raws.ownSemicolon && (ee.raws.ownSemicolon = this.spaces, this.spaces = "");
    }
  }
  // Helpers
  getPosition(Z) {
    let ee = this.input.fromOffset(Z);
    return {
      column: ee.col,
      line: ee.line,
      offset: Z
    };
  }
  init(Z, ee) {
    this.current.push(Z), Z.source = {
      input: this.input,
      start: this.getPosition(ee)
    }, Z.raws.before = this.spaces, this.spaces = "", Z.type !== "comment" && (this.semicolon = !1);
  }
  other(Z) {
    let ee = !1, ae = null, ve = !1, ye = null, be = [], Ye = Z[1].startsWith("--"), Qe = [], Je = Z;
    for (; Je; ) {
      if (ae = Je[0], Qe.push(Je), ae === "(" || ae === "[")
        ye || (ye = Je), be.push(ae === "(" ? ")" : "]");
      else if (Ye && ve && ae === "{")
        ye || (ye = Je), be.push("}");
      else if (be.length === 0)
        if (ae === ";")
          if (ve) {
            this.decl(Qe, Ye);
            return;
          } else
            break;
        else if (ae === "{") {
          this.rule(Qe);
          return;
        } else if (ae === "}") {
          this.tokenizer.back(Qe.pop()), ee = !0;
          break;
        } else
          ae === ":" && (ve = !0);
      else
        ae === be[be.length - 1] && (be.pop(), be.length === 0 && (ye = null));
      Je = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (ee = !0), be.length > 0 && this.unclosedBracket(ye), ee && ve) {
      if (!Ye)
        for (; Qe.length && (Je = Qe[Qe.length - 1][0], !(Je !== "space" && Je !== "comment")); )
          this.tokenizer.back(Qe.pop());
      this.decl(Qe, Ye);
    } else
      this.unknownWord(Qe);
  }
  parse() {
    let Z;
    for (; !this.tokenizer.endOfFile(); )
      switch (Z = this.tokenizer.nextToken(), Z[0]) {
        case "space":
          this.spaces += Z[1];
          break;
        case ";":
          this.freeSemicolon(Z);
          break;
        case "}":
          this.end(Z);
          break;
        case "comment":
          this.comment(Z);
          break;
        case "at-word":
          this.atrule(Z);
          break;
        case "{":
          this.emptyRule(Z);
          break;
        default:
          this.other(Z);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(Z, ee, ae, ve) {
    let ye, be, Ye = ae.length, Qe = "", Je = !0, nt, st;
    for (let ot = 0; ot < Ye; ot += 1)
      ye = ae[ot], be = ye[0], be === "space" && ot === Ye - 1 && !ve ? Je = !1 : be === "comment" ? (st = ae[ot - 1] ? ae[ot - 1][0] : "empty", nt = ae[ot + 1] ? ae[ot + 1][0] : "empty", !SAFE_COMMENT_NEIGHBOR[st] && !SAFE_COMMENT_NEIGHBOR[nt] ? Qe.slice(-1) === "," ? Je = !1 : Qe += ye[1] : Je = !1) : Qe += ye[1];
    if (!Je) {
      let ot = ae.reduce((lt, ft) => lt + ft[1], "");
      Z.raws[ee] = { raw: ot, value: Qe };
    }
    Z[ee] = Qe;
  }
  rule(Z) {
    Z.pop();
    let ee = new Rule$2();
    this.init(ee, Z[0][2]), ee.raws.between = this.spacesAndCommentsFromEnd(Z), this.raw(ee, "selector", Z), this.current = ee;
  }
  spacesAndCommentsFromEnd(Z) {
    let ee, ae = "";
    for (; Z.length && (ee = Z[Z.length - 1][0], !(ee !== "space" && ee !== "comment")); )
      ae = Z.pop()[1] + ae;
    return ae;
  }
  // Errors
  spacesAndCommentsFromStart(Z) {
    let ee, ae = "";
    for (; Z.length && (ee = Z[0][0], !(ee !== "space" && ee !== "comment")); )
      ae += Z.shift()[1];
    return ae;
  }
  spacesFromEnd(Z) {
    let ee, ae = "";
    for (; Z.length && (ee = Z[Z.length - 1][0], ee === "space"); )
      ae = Z.pop()[1] + ae;
    return ae;
  }
  stringFrom(Z, ee) {
    let ae = "";
    for (let ve = ee; ve < Z.length; ve++)
      ae += Z[ve][1];
    return Z.splice(ee, Z.length - ee), ae;
  }
  unclosedBlock() {
    let Z = this.current.source.start;
    throw this.input.error("Unclosed block", Z.line, Z.column);
  }
  unclosedBracket(Z) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: Z[2] },
      { offset: Z[2] + 1 }
    );
  }
  unexpectedClose(Z) {
    throw this.input.error(
      "Unexpected }",
      { offset: Z[2] },
      { offset: Z[2] + 1 }
    );
  }
  unknownWord(Z) {
    throw this.input.error(
      "Unknown word",
      { offset: Z[0][2] },
      { offset: Z[0][2] + Z[0][1].length }
    );
  }
  unnamedAtrule(Z, ee) {
    throw this.input.error(
      "At-rule without name",
      { offset: ee[2] },
      { offset: ee[2] + ee[1].length }
    );
  }
};
var parser$1 = Parser$1;
let Container$2 = container, Parser = parser$1, Input$2 = input;
function parse$7(ie, Z) {
  let ee = new Input$2(ie, Z), ae = new Parser(ee);
  try {
    ae.parse();
  } catch (ve) {
    throw process.env.NODE_ENV !== "production" && ve.name === "CssSyntaxError" && Z && Z.from && (/\.scss$/i.test(Z.from) ? ve.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(Z.from) ? ve.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(Z.from) && (ve.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), ve;
  }
  return ae.root;
}
var parse_1 = parse$7;
parse$7.default = parse$7;
Container$2.registerParse(parse$7);
let { isClean, my } = symbols, MapGenerator$1 = mapGenerator, stringify$2 = stringify_1, Container$1 = container, Document$2 = document$1, warnOnce$1 = warnOnce$2, Result$2 = result, parse$6 = parse_1, Root$3 = root;
const TYPE_TO_CLASS_NAME = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, PLUGIN_PROPS = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, NOT_VISITORS = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, CHILDREN = 0;
function isPromise$1(ie) {
  return typeof ie == "object" && typeof ie.then == "function";
}
function getEvents(ie) {
  let Z = !1, ee = TYPE_TO_CLASS_NAME[ie.type];
  return ie.type === "decl" ? Z = ie.prop.toLowerCase() : ie.type === "atrule" && (Z = ie.name.toLowerCase()), Z && ie.append ? [
    ee,
    ee + "-" + Z,
    CHILDREN,
    ee + "Exit",
    ee + "Exit-" + Z
  ] : Z ? [ee, ee + "-" + Z, ee + "Exit", ee + "Exit-" + Z] : ie.append ? [ee, CHILDREN, ee + "Exit"] : [ee, ee + "Exit"];
}
function toStack(ie) {
  let Z;
  return ie.type === "document" ? Z = ["Document", CHILDREN, "DocumentExit"] : ie.type === "root" ? Z = ["Root", CHILDREN, "RootExit"] : Z = getEvents(ie), {
    eventIndex: 0,
    events: Z,
    iterator: 0,
    node: ie,
    visitorIndex: 0,
    visitors: []
  };
}
function cleanMarks(ie) {
  return ie[isClean] = !1, ie.nodes && ie.nodes.forEach((Z) => cleanMarks(Z)), ie;
}
let postcss$1 = {}, LazyResult$2 = class vC {
  constructor(Z, ee, ae) {
    this.stringified = !1, this.processed = !1;
    let ve;
    if (typeof ee == "object" && ee !== null && (ee.type === "root" || ee.type === "document"))
      ve = cleanMarks(ee);
    else if (ee instanceof vC || ee instanceof Result$2)
      ve = cleanMarks(ee.root), ee.map && (typeof ae.map > "u" && (ae.map = {}), ae.map.inline || (ae.map.inline = !1), ae.map.prev = ee.map);
    else {
      let ye = parse$6;
      ae.syntax && (ye = ae.syntax.parse), ae.parser && (ye = ae.parser), ye.parse && (ye = ye.parse);
      try {
        ve = ye(ee, ae);
      } catch (be) {
        this.processed = !0, this.error = be;
      }
      ve && !ve[my] && Container$1.rebuild(ve);
    }
    this.result = new Result$2(Z, ve, ae), this.helpers = { ...postcss$1, postcss: postcss$1, result: this.result }, this.plugins = this.processor.plugins.map((ye) => typeof ye == "object" && ye.prepare ? { ...ye, ...ye.prepare(this.result) } : ye);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(Z) {
    return this.async().catch(Z);
  }
  finally(Z) {
    return this.async().then(Z, Z);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(Z, ee) {
    let ae = this.result.lastPlugin;
    try {
      if (ee && ee.addToError(Z), this.error = Z, Z.name === "CssSyntaxError" && !Z.plugin)
        Z.plugin = ae.postcssPlugin, Z.setMessage();
      else if (ae.postcssVersion && process.env.NODE_ENV !== "production") {
        let ve = ae.postcssPlugin, ye = ae.postcssVersion, be = this.result.processor.version, Ye = ye.split("."), Qe = be.split(".");
        (Ye[0] !== Qe[0] || parseInt(Ye[1]) > parseInt(Qe[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + be + ", but " + ve + " uses " + ye + ". Perhaps this is the source of the error below."
        );
      }
    } catch (ve) {
      console && console.error && console.error(ve);
    }
    return Z;
  }
  prepareVisitors() {
    this.listeners = {};
    let Z = (ee, ae, ve) => {
      this.listeners[ae] || (this.listeners[ae] = []), this.listeners[ae].push([ee, ve]);
    };
    for (let ee of this.plugins)
      if (typeof ee == "object")
        for (let ae in ee) {
          if (!PLUGIN_PROPS[ae] && /^[A-Z]/.test(ae))
            throw new Error(
              `Unknown event ${ae} in ${ee.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!NOT_VISITORS[ae])
            if (typeof ee[ae] == "object")
              for (let ve in ee[ae])
                ve === "*" ? Z(ee, ae, ee[ae][ve]) : Z(
                  ee,
                  ae + "-" + ve.toLowerCase(),
                  ee[ae][ve]
                );
            else
              typeof ee[ae] == "function" && Z(ee, ae, ee[ae]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let Z = 0; Z < this.plugins.length; Z++) {
      let ee = this.plugins[Z], ae = this.runOnRoot(ee);
      if (isPromise$1(ae))
        try {
          await ae;
        } catch (ve) {
          throw this.handleError(ve);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let Z = this.result.root;
      for (; !Z[isClean]; ) {
        Z[isClean] = !0;
        let ee = [toStack(Z)];
        for (; ee.length > 0; ) {
          let ae = this.visitTick(ee);
          if (isPromise$1(ae))
            try {
              await ae;
            } catch (ve) {
              let ye = ee[ee.length - 1].node;
              throw this.handleError(ve, ye);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [ee, ae] of this.listeners.OnceExit) {
          this.result.lastPlugin = ee;
          try {
            if (Z.type === "document") {
              let ve = Z.nodes.map(
                (ye) => ae(ye, this.helpers)
              );
              await Promise.all(ve);
            } else
              await ae(Z, this.helpers);
          } catch (ve) {
            throw this.handleError(ve);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(Z) {
    this.result.lastPlugin = Z;
    try {
      if (typeof Z == "object" && Z.Once) {
        if (this.result.root.type === "document") {
          let ee = this.result.root.nodes.map(
            (ae) => Z.Once(ae, this.helpers)
          );
          return isPromise$1(ee[0]) ? Promise.all(ee) : ee;
        }
        return Z.Once(this.result.root, this.helpers);
      } else if (typeof Z == "function")
        return Z(this.result.root, this.result);
    } catch (ee) {
      throw this.handleError(ee);
    }
  }
  stringify() {
    if (this.error)
      throw this.error;
    if (this.stringified)
      return this.result;
    this.stringified = !0, this.sync();
    let Z = this.result.opts, ee = stringify$2;
    Z.syntax && (ee = Z.syntax.stringify), Z.stringifier && (ee = Z.stringifier), ee.stringify && (ee = ee.stringify);
    let ve = new MapGenerator$1(ee, this.result.root, this.result.opts).generate();
    return this.result.css = ve[0], this.result.map = ve[1], this.result;
  }
  sync() {
    if (this.error)
      throw this.error;
    if (this.processed)
      return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let Z of this.plugins) {
      let ee = this.runOnRoot(Z);
      if (isPromise$1(ee))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let Z = this.result.root;
      for (; !Z[isClean]; )
        Z[isClean] = !0, this.walkSync(Z);
      if (this.listeners.OnceExit)
        if (Z.type === "document")
          for (let ee of Z.nodes)
            this.visitSync(this.listeners.OnceExit, ee);
        else
          this.visitSync(this.listeners.OnceExit, Z);
    }
    return this.result;
  }
  then(Z, ee) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || warnOnce$1(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(Z, ee);
  }
  toString() {
    return this.css;
  }
  visitSync(Z, ee) {
    for (let [ae, ve] of Z) {
      this.result.lastPlugin = ae;
      let ye;
      try {
        ye = ve(ee, this.helpers);
      } catch (be) {
        throw this.handleError(be, ee.proxyOf);
      }
      if (ee.type !== "root" && ee.type !== "document" && !ee.parent)
        return !0;
      if (isPromise$1(ye))
        throw this.getAsyncError();
    }
  }
  visitTick(Z) {
    let ee = Z[Z.length - 1], { node: ae, visitors: ve } = ee;
    if (ae.type !== "root" && ae.type !== "document" && !ae.parent) {
      Z.pop();
      return;
    }
    if (ve.length > 0 && ee.visitorIndex < ve.length) {
      let [be, Ye] = ve[ee.visitorIndex];
      ee.visitorIndex += 1, ee.visitorIndex === ve.length && (ee.visitors = [], ee.visitorIndex = 0), this.result.lastPlugin = be;
      try {
        return Ye(ae.toProxy(), this.helpers);
      } catch (Qe) {
        throw this.handleError(Qe, ae);
      }
    }
    if (ee.iterator !== 0) {
      let be = ee.iterator, Ye;
      for (; Ye = ae.nodes[ae.indexes[be]]; )
        if (ae.indexes[be] += 1, !Ye[isClean]) {
          Ye[isClean] = !0, Z.push(toStack(Ye));
          return;
        }
      ee.iterator = 0, delete ae.indexes[be];
    }
    let ye = ee.events;
    for (; ee.eventIndex < ye.length; ) {
      let be = ye[ee.eventIndex];
      if (ee.eventIndex += 1, be === CHILDREN) {
        ae.nodes && ae.nodes.length && (ae[isClean] = !0, ee.iterator = ae.getIterator());
        return;
      } else if (this.listeners[be]) {
        ee.visitors = this.listeners[be];
        return;
      }
    }
    Z.pop();
  }
  walkSync(Z) {
    Z[isClean] = !0;
    let ee = getEvents(Z);
    for (let ae of ee)
      if (ae === CHILDREN)
        Z.nodes && Z.each((ve) => {
          ve[isClean] || this.walkSync(ve);
        });
      else {
        let ve = this.listeners[ae];
        if (ve && this.visitSync(ve, Z.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
};
LazyResult$2.registerPostcss = (ie) => {
  postcss$1 = ie;
};
var lazyResult = LazyResult$2;
LazyResult$2.default = LazyResult$2;
Root$3.registerLazyResult(LazyResult$2);
Document$2.registerLazyResult(LazyResult$2);
let MapGenerator = mapGenerator, stringify$1 = stringify_1, warnOnce = warnOnce$2, parse$5 = parse_1;
const Result$1 = result;
let NoWorkResult$1 = class {
  constructor(Z, ee, ae) {
    ee = ee.toString(), this.stringified = !1, this._processor = Z, this._css = ee, this._opts = ae, this._map = void 0;
    let ve, ye = stringify$1;
    this.result = new Result$1(this._processor, ve, this._opts), this.result.css = ee;
    let be = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return be.root;
      }
    });
    let Ye = new MapGenerator(ye, ve, this._opts, ee);
    if (Ye.isMap()) {
      let [Qe, Je] = Ye.generate();
      Qe && (this.result.css = Qe), Je && (this.result.map = Je);
    } else
      Ye.clearAnnotation(), this.result.css = Ye.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(Z) {
    return this.async().catch(Z);
  }
  finally(Z) {
    return this.async().then(Z, Z);
  }
  sync() {
    if (this.error)
      throw this.error;
    return this.result;
  }
  then(Z, ee) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || warnOnce(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(Z, ee);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let Z, ee = parse$5;
    try {
      Z = ee(this._css, this._opts);
    } catch (ae) {
      this.error = ae;
    }
    if (this.error)
      throw this.error;
    return this._root = Z, Z;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
};
var noWorkResult = NoWorkResult$1;
NoWorkResult$1.default = NoWorkResult$1;
let NoWorkResult = noWorkResult, LazyResult$1 = lazyResult, Document$1 = document$1, Root$2 = root, Processor$1 = class {
  constructor(Z = []) {
    this.version = "8.4.33", this.plugins = this.normalize(Z);
  }
  normalize(Z) {
    let ee = [];
    for (let ae of Z)
      if (ae.postcss === !0 ? ae = ae() : ae.postcss && (ae = ae.postcss), typeof ae == "object" && Array.isArray(ae.plugins))
        ee = ee.concat(ae.plugins);
      else if (typeof ae == "object" && ae.postcssPlugin)
        ee.push(ae);
      else if (typeof ae == "function")
        ee.push(ae);
      else if (typeof ae == "object" && (ae.parse || ae.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(ae + " is not a PostCSS plugin");
    return ee;
  }
  process(Z, ee = {}) {
    return !this.plugins.length && !ee.parser && !ee.stringifier && !ee.syntax ? new NoWorkResult(this, Z, ee) : new LazyResult$1(this, Z, ee);
  }
  use(Z) {
    return this.plugins = this.plugins.concat(this.normalize([Z])), this;
  }
};
var processor = Processor$1;
Processor$1.default = Processor$1;
Root$2.registerProcessor(Processor$1);
Document$1.registerProcessor(Processor$1);
let Declaration$1 = declaration, PreviousMap = previousMap, Comment$1 = comment, AtRule$1 = atRule, Input$1 = input, Root$1 = root, Rule$1 = rule;
function fromJSON$1(ie, Z) {
  if (Array.isArray(ie))
    return ie.map((ve) => fromJSON$1(ve));
  let { inputs: ee, ...ae } = ie;
  if (ee) {
    Z = [];
    for (let ve of ee) {
      let ye = { ...ve, __proto__: Input$1.prototype };
      ye.map && (ye.map = {
        ...ye.map,
        __proto__: PreviousMap.prototype
      }), Z.push(ye);
    }
  }
  if (ae.nodes && (ae.nodes = ie.nodes.map((ve) => fromJSON$1(ve, Z))), ae.source) {
    let { inputId: ve, ...ye } = ae.source;
    ae.source = ye, ve != null && (ae.source.input = Z[ve]);
  }
  if (ae.type === "root")
    return new Root$1(ae);
  if (ae.type === "decl")
    return new Declaration$1(ae);
  if (ae.type === "rule")
    return new Rule$1(ae);
  if (ae.type === "comment")
    return new Comment$1(ae);
  if (ae.type === "atrule")
    return new AtRule$1(ae);
  throw new Error("Unknown node type: " + ie.type);
}
var fromJSON_1 = fromJSON$1;
fromJSON$1.default = fromJSON$1;
let CssSyntaxError = cssSyntaxError, Declaration = declaration, LazyResult = lazyResult, Container = container, Processor = processor, stringify = stringify_1, fromJSON = fromJSON_1, Document = document$1, Warning = warning, Comment = comment, AtRule = atRule, Result = result, Input = input, parse$4 = parse_1, list = list_1, Rule = rule, Root = root, Node$1 = node;
function postcss(...ie) {
  return ie.length === 1 && Array.isArray(ie[0]) && (ie = ie[0]), new Processor(ie);
}
postcss.plugin = function(Z, ee) {
  let ae = !1;
  function ve(...be) {
    console && console.warn && !ae && (ae = !0, console.warn(
      Z + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      Z + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let Ye = ee(...be);
    return Ye.postcssPlugin = Z, Ye.postcssVersion = new Processor().version, Ye;
  }
  let ye;
  return Object.defineProperty(ve, "postcss", {
    get() {
      return ye || (ye = ve()), ye;
    }
  }), ve.process = function(be, Ye, Qe) {
    return postcss([ve(Qe)]).process(be, Ye);
  }, ve;
};
postcss.stringify = stringify;
postcss.parse = parse$4;
postcss.fromJSON = fromJSON;
postcss.list = list;
postcss.comment = (ie) => new Comment(ie);
postcss.atRule = (ie) => new AtRule(ie);
postcss.decl = (ie) => new Declaration(ie);
postcss.rule = (ie) => new Rule(ie);
postcss.root = (ie) => new Root(ie);
postcss.document = (ie) => new Document(ie);
postcss.CssSyntaxError = CssSyntaxError;
postcss.Declaration = Declaration;
postcss.Container = Container;
postcss.Processor = Processor;
postcss.Document = Document;
postcss.Comment = Comment;
postcss.Warning = Warning;
postcss.AtRule = AtRule;
postcss.Result = Result;
postcss.Input = Input;
postcss.Rule = Rule;
postcss.Root = Root;
postcss.Node = Node$1;
LazyResult.registerPostcss(postcss);
var postcss_1 = postcss;
postcss.default = postcss;
const htmlparser = lib$5, escapeStringRegexp = escapeStringRegexp$1, { isPlainObject } = isPlainObject$2, deepmerge = cjs, parseSrcset = parseSrcsetExports, { parse: postcssParse } = postcss_1, mediaTags = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], vulnerableTags = ["script", "style"];
function each(ie, Z) {
  ie && Object.keys(ie).forEach(function(ee) {
    Z(ie[ee], ee);
  });
}
function has(ie, Z) {
  return {}.hasOwnProperty.call(ie, Z);
}
function filter(ie, Z) {
  const ee = [];
  return each(ie, function(ae) {
    Z(ae) && ee.push(ae);
  }), ee;
}
function isEmptyObject(ie) {
  for (const Z in ie)
    if (has(ie, Z))
      return !1;
  return !0;
}
function stringifySrcset(ie) {
  return ie.map(function(Z) {
    if (!Z.url)
      throw new Error("URL missing");
    return Z.url + (Z.w ? ` ${Z.w}w` : "") + (Z.h ? ` ${Z.h}h` : "") + (Z.d ? ` ${Z.d}x` : "");
  }).join(", ");
}
var sanitizeHtml_1 = sanitizeHtml;
const VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
function sanitizeHtml(ie, Z, ee) {
  if (ie == null)
    return "";
  typeof ie == "number" && (ie = ie.toString());
  let ae = "", ve = "";
  function ye(mi, Si) {
    const gi = this;
    this.tag = mi, this.attribs = Si || {}, this.tagPosition = ae.length, this.text = "", this.mediaChildren = [], this.updateParentNodeText = function() {
      if (ct.length) {
        const _i = ct[ct.length - 1];
        _i.text += gi.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      ct.length && mediaTags.includes(this.tag) && ct[ct.length - 1].mediaChildren.push(this.tag);
    };
  }
  Z = Object.assign({}, sanitizeHtml.defaults, Z), Z.parser = Object.assign({}, htmlParserDefaults, Z.parser);
  const be = function(mi) {
    return Z.allowedTags === !1 || (Z.allowedTags || []).indexOf(mi) > -1;
  };
  vulnerableTags.forEach(function(mi) {
    be(mi) && !Z.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${mi}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const Ye = Z.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let Qe, Je;
  Z.allowedAttributes && (Qe = {}, Je = {}, each(Z.allowedAttributes, function(mi, Si) {
    Qe[Si] = [];
    const gi = [];
    mi.forEach(function(_i) {
      typeof _i == "string" && _i.indexOf("*") >= 0 ? gi.push(escapeStringRegexp(_i).replace(/\\\*/g, ".*")) : Qe[Si].push(_i);
    }), gi.length && (Je[Si] = new RegExp("^(" + gi.join("|") + ")$"));
  }));
  const nt = {}, st = {}, ot = {};
  each(Z.allowedClasses, function(mi, Si) {
    if (Qe && (has(Qe, Si) || (Qe[Si] = []), Qe[Si].push("class")), nt[Si] = mi, Array.isArray(mi)) {
      const gi = [];
      nt[Si] = [], ot[Si] = [], mi.forEach(function(_i) {
        typeof _i == "string" && _i.indexOf("*") >= 0 ? gi.push(escapeStringRegexp(_i).replace(/\\\*/g, ".*")) : _i instanceof RegExp ? ot[Si].push(_i) : nt[Si].push(_i);
      }), gi.length && (st[Si] = new RegExp("^(" + gi.join("|") + ")$"));
    }
  });
  const lt = {};
  let ft;
  each(Z.transformTags, function(mi, Si) {
    let gi;
    typeof mi == "function" ? gi = mi : typeof mi == "string" && (gi = sanitizeHtml.simpleTransform(mi)), Si === "*" ? ft = gi : lt[Si] = gi;
  });
  let gt, ct, _r, Kr, Xr, Jr, ei = !1;
  ri();
  const si = new htmlparser.Parser({
    onopentag: function(mi, Si) {
      if (Z.enforceHtmlBoundary && mi === "html" && ri(), Xr) {
        Jr++;
        return;
      }
      const gi = new ye(mi, Si);
      ct.push(gi);
      let _i = !1;
      const Oi = !!gi.text;
      let hi;
      if (has(lt, mi) && (hi = lt[mi](mi, Si), gi.attribs = Si = hi.attribs, hi.text !== void 0 && (gi.innerText = hi.text), mi !== hi.tagName && (gi.name = mi = hi.tagName, Kr[gt] = hi.tagName)), ft && (hi = ft(mi, Si), gi.attribs = Si = hi.attribs, mi !== hi.tagName && (gi.name = mi = hi.tagName, Kr[gt] = hi.tagName)), (!be(mi) || Z.disallowedTagsMode === "recursiveEscape" && !isEmptyObject(_r) || Z.nestingLimit != null && gt >= Z.nestingLimit) && (_i = !0, _r[gt] = !0, Z.disallowedTagsMode === "discard" && Ye.indexOf(mi) !== -1 && (Xr = !0, Jr = 1), _r[gt] = !0), gt++, _i) {
        if (Z.disallowedTagsMode === "discard")
          return;
        ve = ae, ae = "";
      }
      ae += "<" + mi, mi === "script" && (Z.allowedScriptHostnames || Z.allowedScriptDomains) && (gi.innerText = ""), (!Qe || has(Qe, mi) || Qe["*"]) && each(Si, function(Di, Ri) {
        if (!VALID_HTML_ATTRIBUTE_NAME.test(Ri)) {
          delete gi.attribs[Ri];
          return;
        }
        if (Di === "" && (Z.nonBooleanAttributes.includes(Ri) || Z.nonBooleanAttributes.includes("*"))) {
          delete gi.attribs[Ri];
          return;
        }
        let rs = !1;
        if (!Qe || has(Qe, mi) && Qe[mi].indexOf(Ri) !== -1 || Qe["*"] && Qe["*"].indexOf(Ri) !== -1 || has(Je, mi) && Je[mi].test(Ri) || Je["*"] && Je["*"].test(Ri))
          rs = !0;
        else if (Qe && Qe[mi]) {
          for (const Hi of Qe[mi])
            if (isPlainObject(Hi) && Hi.name && Hi.name === Ri) {
              rs = !0;
              let qi = "";
              if (Hi.multiple === !0) {
                const us = Di.split(" ");
                for (const Yi of us)
                  Hi.values.indexOf(Yi) !== -1 && (qi === "" ? qi = Yi : qi += " " + Yi);
              } else
                Hi.values.indexOf(Di) >= 0 && (qi = Di);
              Di = qi;
            }
        }
        if (rs) {
          if (Z.allowedSchemesAppliedToAttributes.indexOf(Ri) !== -1 && yi(mi, Di)) {
            delete gi.attribs[Ri];
            return;
          }
          if (mi === "script" && Ri === "src") {
            let Hi = !0;
            try {
              const qi = pi(Di);
              if (Z.allowedScriptHostnames || Z.allowedScriptDomains) {
                const us = (Z.allowedScriptHostnames || []).find(function(is) {
                  return is === qi.url.hostname;
                }), Yi = (Z.allowedScriptDomains || []).find(function(is) {
                  return qi.url.hostname === is || qi.url.hostname.endsWith(`.${is}`);
                });
                Hi = us || Yi;
              }
            } catch {
              Hi = !1;
            }
            if (!Hi) {
              delete gi.attribs[Ri];
              return;
            }
          }
          if (mi === "iframe" && Ri === "src") {
            let Hi = !0;
            try {
              const qi = pi(Di);
              if (qi.isRelativeUrl)
                Hi = has(Z, "allowIframeRelativeUrls") ? Z.allowIframeRelativeUrls : !Z.allowedIframeHostnames && !Z.allowedIframeDomains;
              else if (Z.allowedIframeHostnames || Z.allowedIframeDomains) {
                const us = (Z.allowedIframeHostnames || []).find(function(is) {
                  return is === qi.url.hostname;
                }), Yi = (Z.allowedIframeDomains || []).find(function(is) {
                  return qi.url.hostname === is || qi.url.hostname.endsWith(`.${is}`);
                });
                Hi = us || Yi;
              }
            } catch {
              Hi = !1;
            }
            if (!Hi) {
              delete gi.attribs[Ri];
              return;
            }
          }
          if (Ri === "srcset")
            try {
              let Hi = parseSrcset(Di);
              if (Hi.forEach(function(qi) {
                yi("srcset", qi.url) && (qi.evil = !0);
              }), Hi = filter(Hi, function(qi) {
                return !qi.evil;
              }), Hi.length)
                Di = stringifySrcset(filter(Hi, function(qi) {
                  return !qi.evil;
                })), gi.attribs[Ri] = Di;
              else {
                delete gi.attribs[Ri];
                return;
              }
            } catch {
              delete gi.attribs[Ri];
              return;
            }
          if (Ri === "class") {
            const Hi = nt[mi], qi = nt["*"], us = st[mi], Yi = ot[mi], is = st["*"], Ss = [
              us,
              is
            ].concat(Yi).filter(function(Gs) {
              return Gs;
            });
            if (Hi && qi ? Di = Ai(Di, deepmerge(Hi, qi), Ss) : Di = Ai(Di, Hi || qi, Ss), !Di.length) {
              delete gi.attribs[Ri];
              return;
            }
          }
          if (Ri === "style") {
            if (Z.parseStyleAttributes)
              try {
                const Hi = postcssParse(mi + " {" + Di + "}"), qi = di(Hi, Z.allowedStyles);
                if (Di = xi(qi), Di.length === 0) {
                  delete gi.attribs[Ri];
                  return;
                }
              } catch {
                typeof window < "u" && console.warn('Failed to parse "' + mi + " {" + Di + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete gi.attribs[Ri];
                return;
              }
            else if (Z.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          ae += " " + Ri, Di && Di.length && (ae += '="' + ai(Di, !0) + '"');
        } else
          delete gi.attribs[Ri];
      }), Z.selfClosing.indexOf(mi) !== -1 ? ae += " />" : (ae += ">", gi.innerText && !Oi && !Z.textFilter && (ae += ai(gi.innerText), ei = !0)), _i && (ae = ve + ai(ae), ve = "");
    },
    ontext: function(mi) {
      if (Xr)
        return;
      const Si = ct[ct.length - 1];
      let gi;
      if (Si && (gi = Si.tag, mi = Si.innerText !== void 0 ? Si.innerText : mi), Z.disallowedTagsMode === "discard" && (gi === "script" || gi === "style"))
        ae += mi;
      else {
        const _i = ai(mi, !1);
        Z.textFilter && !ei ? ae += Z.textFilter(_i, gi) : ei || (ae += _i);
      }
      if (ct.length) {
        const _i = ct[ct.length - 1];
        _i.text += mi;
      }
    },
    onclosetag: function(mi, Si) {
      if (Xr)
        if (Jr--, !Jr)
          Xr = !1;
        else
          return;
      const gi = ct.pop();
      if (!gi)
        return;
      if (gi.tag !== mi) {
        ct.push(gi);
        return;
      }
      Xr = Z.enforceHtmlBoundary ? mi === "html" : !1, gt--;
      const _i = _r[gt];
      if (_i) {
        if (delete _r[gt], Z.disallowedTagsMode === "discard") {
          gi.updateParentNodeText();
          return;
        }
        ve = ae, ae = "";
      }
      if (Kr[gt] && (mi = Kr[gt], delete Kr[gt]), Z.exclusiveFilter && Z.exclusiveFilter(gi)) {
        ae = ae.substr(0, gi.tagPosition);
        return;
      }
      if (gi.updateParentNodeMediaChildren(), gi.updateParentNodeText(), // Already output />
      Z.selfClosing.indexOf(mi) !== -1 || // Escaped tag, closing tag is implied
      Si && !be(mi) && ["escape", "recursiveEscape"].indexOf(Z.disallowedTagsMode) >= 0) {
        _i && (ae = ve, ve = "");
        return;
      }
      ae += "</" + mi + ">", _i && (ae = ve + ai(ae), ve = ""), ei = !1;
    }
  }, Z.parser);
  return si.write(ie), si.end(), ae;
  function ri() {
    ae = "", gt = 0, ct = [], _r = {}, Kr = {}, Xr = !1, Jr = 0;
  }
  function ai(mi, Si) {
    return typeof mi != "string" && (mi = mi + ""), Z.parser.decodeEntities && (mi = mi.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Si && (mi = mi.replace(/"/g, "&quot;"))), mi = mi.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Si && (mi = mi.replace(/"/g, "&quot;")), mi;
  }
  function yi(mi, Si) {
    for (Si = Si.replace(/[\x00-\x20]+/g, ""); ; ) {
      const Oi = Si.indexOf("<!--");
      if (Oi === -1)
        break;
      const hi = Si.indexOf("-->", Oi + 4);
      if (hi === -1)
        break;
      Si = Si.substring(0, Oi) + Si.substring(hi + 3);
    }
    const gi = Si.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!gi)
      return Si.match(/^[/\\]{2}/) ? !Z.allowProtocolRelative : !1;
    const _i = gi[1].toLowerCase();
    return has(Z.allowedSchemesByTag, mi) ? Z.allowedSchemesByTag[mi].indexOf(_i) === -1 : !Z.allowedSchemes || Z.allowedSchemes.indexOf(_i) === -1;
  }
  function pi(mi) {
    if (mi = mi.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), mi.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let Si = "relative://relative-site";
    for (let Oi = 0; Oi < 100; Oi++)
      Si += `/${Oi}`;
    const gi = new URL(mi, Si);
    return {
      isRelativeUrl: gi && gi.hostname === "relative-site" && gi.protocol === "relative:",
      url: gi
    };
  }
  function di(mi, Si) {
    if (!Si)
      return mi;
    const gi = mi.nodes[0];
    let _i;
    return Si[gi.selector] && Si["*"] ? _i = deepmerge(
      Si[gi.selector],
      Si["*"]
    ) : _i = Si[gi.selector] || Si["*"], _i && (mi.nodes[0].nodes = gi.nodes.reduce(Ti(_i), [])), mi;
  }
  function xi(mi) {
    return mi.nodes[0].nodes.reduce(function(Si, gi) {
      return Si.push(
        `${gi.prop}:${gi.value}${gi.important ? " !important" : ""}`
      ), Si;
    }, []).join(";");
  }
  function Ti(mi) {
    return function(Si, gi) {
      return has(mi, gi.prop) && mi[gi.prop].some(function(Oi) {
        return Oi.test(gi.value);
      }) && Si.push(gi), Si;
    };
  }
  function Ai(mi, Si, gi) {
    return Si ? (mi = mi.split(/\s+/), mi.filter(function(_i) {
      return Si.indexOf(_i) !== -1 || gi.some(function(Oi) {
        return Oi.test(_i);
      });
    }).join(" ")) : mi;
  }
}
const htmlParserDefaults = {
  decodeEntities: !0
};
sanitizeHtml.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "main",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: !0,
  enforceHtmlBoundary: !1,
  parseStyleAttributes: !0
};
sanitizeHtml.simpleTransform = function(ie, Z, ee) {
  return ee = ee === void 0 ? !0 : ee, Z = Z || {}, function(ae, ve) {
    let ye;
    if (ee)
      for (ye in Z)
        ve[ye] = Z[ye];
    else
      ve = Z;
    return {
      tagName: ie,
      attribs: ve
    };
  };
};
const at = /* @__PURE__ */ getDefaultExportFromCjs$1(sanitizeHtml_1);
function getDefaultExportFromCjs(ie) {
  return ie && ie.__esModule && Object.prototype.hasOwnProperty.call(ie, "default") ? ie.default : ie;
}
var urlToolkit = { exports: {} };
(function(ie, Z) {
  (function(ee) {
    var ae = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, ve = /^(?=([^\/?#]*))\1([^]*)$/, ye = /(?:\/|^)\.(?=\/)/g, be = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, Ye = {
      // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
      // E.g
      // With opts.alwaysNormalize = false (default, spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
      // With opts.alwaysNormalize = true (not spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
      buildAbsoluteURL: function(Qe, Je, nt) {
        if (nt = nt || {}, Qe = Qe.trim(), Je = Je.trim(), !Je) {
          if (!nt.alwaysNormalize)
            return Qe;
          var st = Ye.parseURL(Qe);
          if (!st)
            throw new Error("Error trying to parse base URL.");
          return st.path = Ye.normalizePath(
            st.path
          ), Ye.buildURLFromParts(st);
        }
        var ot = Ye.parseURL(Je);
        if (!ot)
          throw new Error("Error trying to parse relative URL.");
        if (ot.scheme)
          return nt.alwaysNormalize ? (ot.path = Ye.normalizePath(ot.path), Ye.buildURLFromParts(ot)) : Je;
        var lt = Ye.parseURL(Qe);
        if (!lt)
          throw new Error("Error trying to parse base URL.");
        if (!lt.netLoc && lt.path && lt.path[0] !== "/") {
          var ft = ve.exec(lt.path);
          lt.netLoc = ft[1], lt.path = ft[2];
        }
        lt.netLoc && !lt.path && (lt.path = "/");
        var gt = {
          // 2c) Otherwise, the embedded URL inherits the scheme of
          // the base URL.
          scheme: lt.scheme,
          netLoc: ot.netLoc,
          path: null,
          params: ot.params,
          query: ot.query,
          fragment: ot.fragment
        };
        if (!ot.netLoc && (gt.netLoc = lt.netLoc, ot.path[0] !== "/"))
          if (!ot.path)
            gt.path = lt.path, ot.params || (gt.params = lt.params, ot.query || (gt.query = lt.query));
          else {
            var ct = lt.path, _r = ct.substring(0, ct.lastIndexOf("/") + 1) + ot.path;
            gt.path = Ye.normalizePath(_r);
          }
        return gt.path === null && (gt.path = nt.alwaysNormalize ? Ye.normalizePath(ot.path) : ot.path), Ye.buildURLFromParts(gt);
      },
      parseURL: function(Qe) {
        var Je = ae.exec(Qe);
        return Je ? {
          scheme: Je[1] || "",
          netLoc: Je[2] || "",
          path: Je[3] || "",
          params: Je[4] || "",
          query: Je[5] || "",
          fragment: Je[6] || ""
        } : null;
      },
      normalizePath: function(Qe) {
        for (Qe = Qe.split("").reverse().join("").replace(ye, ""); Qe.length !== (Qe = Qe.replace(be, "")).length; )
          ;
        return Qe.split("").reverse().join("");
      },
      buildURLFromParts: function(Qe) {
        return Qe.scheme + Qe.netLoc + Qe.path + Qe.params + Qe.query + Qe.fragment;
      }
    };
    ie.exports = Ye;
  })();
})(urlToolkit);
var urlToolkitExports = urlToolkit.exports;
function ownKeys(ie, Z) {
  var ee = Object.keys(ie);
  if (Object.getOwnPropertySymbols) {
    var ae = Object.getOwnPropertySymbols(ie);
    Z && (ae = ae.filter(function(ve) {
      return Object.getOwnPropertyDescriptor(ie, ve).enumerable;
    })), ee.push.apply(ee, ae);
  }
  return ee;
}
function _objectSpread2(ie) {
  for (var Z = 1; Z < arguments.length; Z++) {
    var ee = arguments[Z] != null ? arguments[Z] : {};
    Z % 2 ? ownKeys(Object(ee), !0).forEach(function(ae) {
      _defineProperty(ie, ae, ee[ae]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ie, Object.getOwnPropertyDescriptors(ee)) : ownKeys(Object(ee)).forEach(function(ae) {
      Object.defineProperty(ie, ae, Object.getOwnPropertyDescriptor(ee, ae));
    });
  }
  return ie;
}
function _toPrimitive(ie, Z) {
  if (typeof ie != "object" || !ie)
    return ie;
  var ee = ie[Symbol.toPrimitive];
  if (ee !== void 0) {
    var ae = ee.call(ie, Z || "default");
    if (typeof ae != "object")
      return ae;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (Z === "string" ? String : Number)(ie);
}
function _toPropertyKey(ie) {
  var Z = _toPrimitive(ie, "string");
  return typeof Z == "symbol" ? Z : String(Z);
}
function _defineProperty(ie, Z, ee) {
  return Z = _toPropertyKey(Z), Z in ie ? Object.defineProperty(ie, Z, {
    value: ee,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : ie[Z] = ee, ie;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(ie) {
    for (var Z = 1; Z < arguments.length; Z++) {
      var ee = arguments[Z];
      for (var ae in ee)
        Object.prototype.hasOwnProperty.call(ee, ae) && (ie[ae] = ee[ae]);
    }
    return ie;
  }, _extends.apply(this, arguments);
}
const isFiniteNumber = Number.isFinite || function(ie) {
  return typeof ie == "number" && isFinite(ie);
}, isSafeInteger = Number.isSafeInteger || function(ie) {
  return typeof ie == "number" && Math.abs(ie) <= MAX_SAFE_INTEGER;
}, MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
let Events = /* @__PURE__ */ function(ie) {
  return ie.MEDIA_ATTACHING = "hlsMediaAttaching", ie.MEDIA_ATTACHED = "hlsMediaAttached", ie.MEDIA_DETACHING = "hlsMediaDetaching", ie.MEDIA_DETACHED = "hlsMediaDetached", ie.BUFFER_RESET = "hlsBufferReset", ie.BUFFER_CODECS = "hlsBufferCodecs", ie.BUFFER_CREATED = "hlsBufferCreated", ie.BUFFER_APPENDING = "hlsBufferAppending", ie.BUFFER_APPENDED = "hlsBufferAppended", ie.BUFFER_EOS = "hlsBufferEos", ie.BUFFER_FLUSHING = "hlsBufferFlushing", ie.BUFFER_FLUSHED = "hlsBufferFlushed", ie.MANIFEST_LOADING = "hlsManifestLoading", ie.MANIFEST_LOADED = "hlsManifestLoaded", ie.MANIFEST_PARSED = "hlsManifestParsed", ie.LEVEL_SWITCHING = "hlsLevelSwitching", ie.LEVEL_SWITCHED = "hlsLevelSwitched", ie.LEVEL_LOADING = "hlsLevelLoading", ie.LEVEL_LOADED = "hlsLevelLoaded", ie.LEVEL_UPDATED = "hlsLevelUpdated", ie.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", ie.LEVELS_UPDATED = "hlsLevelsUpdated", ie.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", ie.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", ie.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", ie.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", ie.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", ie.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", ie.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", ie.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", ie.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", ie.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", ie.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", ie.CUES_PARSED = "hlsCuesParsed", ie.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", ie.INIT_PTS_FOUND = "hlsInitPtsFound", ie.FRAG_LOADING = "hlsFragLoading", ie.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", ie.FRAG_LOADED = "hlsFragLoaded", ie.FRAG_DECRYPTED = "hlsFragDecrypted", ie.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", ie.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", ie.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", ie.FRAG_PARSED = "hlsFragParsed", ie.FRAG_BUFFERED = "hlsFragBuffered", ie.FRAG_CHANGED = "hlsFragChanged", ie.FPS_DROP = "hlsFpsDrop", ie.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", ie.MAX_AUTO_LEVEL_UPDATED = "hlsMaxAutoLevelUpdated", ie.ERROR = "hlsError", ie.DESTROYING = "hlsDestroying", ie.KEY_LOADING = "hlsKeyLoading", ie.KEY_LOADED = "hlsKeyLoaded", ie.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", ie.BACK_BUFFER_REACHED = "hlsBackBufferReached", ie.STEERING_MANIFEST_LOADED = "hlsSteeringManifestLoaded", ie;
}({}), ErrorTypes = /* @__PURE__ */ function(ie) {
  return ie.NETWORK_ERROR = "networkError", ie.MEDIA_ERROR = "mediaError", ie.KEY_SYSTEM_ERROR = "keySystemError", ie.MUX_ERROR = "muxError", ie.OTHER_ERROR = "otherError", ie;
}({}), ErrorDetails = /* @__PURE__ */ function(ie) {
  return ie.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", ie.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", ie.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", ie.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", ie.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", ie.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", ie.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", ie.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", ie.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", ie.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", ie.MANIFEST_LOAD_ERROR = "manifestLoadError", ie.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", ie.MANIFEST_PARSING_ERROR = "manifestParsingError", ie.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", ie.LEVEL_EMPTY_ERROR = "levelEmptyError", ie.LEVEL_LOAD_ERROR = "levelLoadError", ie.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", ie.LEVEL_PARSING_ERROR = "levelParsingError", ie.LEVEL_SWITCH_ERROR = "levelSwitchError", ie.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", ie.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", ie.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", ie.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", ie.FRAG_LOAD_ERROR = "fragLoadError", ie.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", ie.FRAG_DECRYPT_ERROR = "fragDecryptError", ie.FRAG_PARSING_ERROR = "fragParsingError", ie.FRAG_GAP = "fragGap", ie.REMUX_ALLOC_ERROR = "remuxAllocError", ie.KEY_LOAD_ERROR = "keyLoadError", ie.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", ie.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", ie.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", ie.BUFFER_APPEND_ERROR = "bufferAppendError", ie.BUFFER_APPENDING_ERROR = "bufferAppendingError", ie.BUFFER_STALLED_ERROR = "bufferStalledError", ie.BUFFER_FULL_ERROR = "bufferFullError", ie.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", ie.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", ie.INTERNAL_EXCEPTION = "internalException", ie.INTERNAL_ABORTED = "aborted", ie.UNKNOWN = "unknown", ie;
}({});
const noop = function() {
}, fakeLogger = {
  trace: noop,
  debug: noop,
  log: noop,
  warn: noop,
  info: noop,
  error: noop
};
let exportedLogger = fakeLogger;
function consolePrintFn(ie) {
  const Z = self.console[ie];
  return Z ? Z.bind(self.console, `[${ie}] >`) : noop;
}
function exportLoggerFunctions(ie, ...Z) {
  Z.forEach(function(ee) {
    exportedLogger[ee] = ie[ee] ? ie[ee].bind(ie) : consolePrintFn(ee);
  });
}
function enableLogs(ie, Z) {
  if (typeof console == "object" && ie === !0 || typeof ie == "object") {
    exportLoggerFunctions(
      ie,
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      "debug",
      "log",
      "info",
      "warn",
      "error"
    );
    try {
      exportedLogger.log(`Debug logs enabled for "${Z}" in hls.js version 1.5.3`);
    } catch {
      exportedLogger = fakeLogger;
    }
  } else
    exportedLogger = fakeLogger;
}
const logger = exportedLogger, DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/, ATTR_LIST_REGEX = /(.+?)=(".*?"|.*?)(?:,|$)/g;
class AttrList {
  constructor(Z) {
    typeof Z == "string" && (Z = AttrList.parseAttrList(Z)), _extends(this, Z);
  }
  get clientAttrs() {
    return Object.keys(this).filter((Z) => Z.substring(0, 2) === "X-");
  }
  decimalInteger(Z) {
    const ee = parseInt(this[Z], 10);
    return ee > Number.MAX_SAFE_INTEGER ? 1 / 0 : ee;
  }
  hexadecimalInteger(Z) {
    if (this[Z]) {
      let ee = (this[Z] || "0x").slice(2);
      ee = (ee.length & 1 ? "0" : "") + ee;
      const ae = new Uint8Array(ee.length / 2);
      for (let ve = 0; ve < ee.length / 2; ve++)
        ae[ve] = parseInt(ee.slice(ve * 2, ve * 2 + 2), 16);
      return ae;
    } else
      return null;
  }
  hexadecimalIntegerAsNumber(Z) {
    const ee = parseInt(this[Z], 16);
    return ee > Number.MAX_SAFE_INTEGER ? 1 / 0 : ee;
  }
  decimalFloatingPoint(Z) {
    return parseFloat(this[Z]);
  }
  optionalFloat(Z, ee) {
    const ae = this[Z];
    return ae ? parseFloat(ae) : ee;
  }
  enumeratedString(Z) {
    return this[Z];
  }
  bool(Z) {
    return this[Z] === "YES";
  }
  decimalResolution(Z) {
    const ee = DECIMAL_RESOLUTION_REGEX.exec(this[Z]);
    if (ee !== null)
      return {
        width: parseInt(ee[1], 10),
        height: parseInt(ee[2], 10)
      };
  }
  static parseAttrList(Z) {
    let ee;
    const ae = {}, ve = '"';
    for (ATTR_LIST_REGEX.lastIndex = 0; (ee = ATTR_LIST_REGEX.exec(Z)) !== null; ) {
      let ye = ee[2];
      ye.indexOf(ve) === 0 && ye.lastIndexOf(ve) === ye.length - 1 && (ye = ye.slice(1, -1));
      const be = ee[1].trim();
      ae[be] = ye;
    }
    return ae;
  }
}
function isDateRangeCueAttribute(ie) {
  return ie !== "ID" && ie !== "CLASS" && ie !== "START-DATE" && ie !== "DURATION" && ie !== "END-DATE" && ie !== "END-ON-NEXT";
}
function isSCTE35Attribute(ie) {
  return ie === "SCTE35-OUT" || ie === "SCTE35-IN";
}
class DateRange {
  constructor(Z, ee) {
    if (this.attr = void 0, this._startDate = void 0, this._endDate = void 0, this._badValueForSameId = void 0, ee) {
      const ae = ee.attr;
      for (const ve in ae)
        if (Object.prototype.hasOwnProperty.call(Z, ve) && Z[ve] !== ae[ve]) {
          logger.warn(`DATERANGE tag attribute: "${ve}" does not match for tags with ID: "${Z.ID}"`), this._badValueForSameId = ve;
          break;
        }
      Z = _extends(new AttrList({}), ae, Z);
    }
    if (this.attr = Z, this._startDate = new Date(Z["START-DATE"]), "END-DATE" in this.attr) {
      const ae = new Date(this.attr["END-DATE"]);
      isFiniteNumber(ae.getTime()) && (this._endDate = ae);
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    if (this._endDate)
      return this._endDate;
    const Z = this.duration;
    return Z !== null ? new Date(this._startDate.getTime() + Z * 1e3) : null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const Z = this.attr.decimalFloatingPoint("DURATION");
      if (isFiniteNumber(Z))
        return Z;
    } else if (this._endDate)
      return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
    return null;
  }
  get plannedDuration() {
    return "PLANNED-DURATION" in this.attr ? this.attr.decimalFloatingPoint("PLANNED-DURATION") : null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && isFiniteNumber(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
  }
}
class LoadStats {
  constructor() {
    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
      start: 0,
      first: 0,
      end: 0
    }, this.parsing = {
      start: 0,
      end: 0
    }, this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}
var ElementaryStreamTypes = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class BaseSegment {
  constructor(Z) {
    this._byteRange = null, this._url = null, this.baseurl = void 0, this.relurl = void 0, this.elementaryStreams = {
      [ElementaryStreamTypes.AUDIO]: null,
      [ElementaryStreamTypes.VIDEO]: null,
      [ElementaryStreamTypes.AUDIOVIDEO]: null
    }, this.baseurl = Z;
  }
  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(Z, ee) {
    const ae = Z.split("@", 2);
    let ve;
    ae.length === 1 ? ve = (ee == null ? void 0 : ee.byteRangeEndOffset) || 0 : ve = parseInt(ae[1]), this._byteRange = [ve, parseInt(ae[0]) + ve];
  }
  get byteRange() {
    return this._byteRange ? this._byteRange : [];
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get url() {
    return !this._url && this.baseurl && this.relurl && (this._url = urlToolkitExports.buildAbsoluteURL(this.baseurl, this.relurl, {
      alwaysNormalize: !0
    })), this._url || "";
  }
  set url(Z) {
    this._url = Z;
  }
}
class Fragment extends BaseSegment {
  constructor(Z, ee) {
    super(ee), this._decryptdata = null, this.rawProgramDateTime = null, this.programDateTime = null, this.tagList = [], this.duration = 0, this.sn = 0, this.levelkeys = void 0, this.type = void 0, this.loader = null, this.keyLoader = null, this.level = -1, this.cc = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.start = 0, this.deltaPTS = void 0, this.maxStartPTS = void 0, this.minEndPTS = void 0, this.stats = new LoadStats(), this.data = void 0, this.bitrateTest = !1, this.title = null, this.initSegment = null, this.endList = void 0, this.gap = void 0, this.urlId = 0, this.type = Z;
  }
  get decryptdata() {
    const {
      levelkeys: Z
    } = this;
    if (!Z && !this._decryptdata)
      return null;
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const ee = this.levelkeys.identity;
      if (ee)
        this._decryptdata = ee.getDecryptData(this.sn);
      else {
        const ae = Object.keys(this.levelkeys);
        if (ae.length === 1)
          return this._decryptdata = this.levelkeys[ae[0]].getDecryptData(this.sn);
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null || !isFiniteNumber(this.programDateTime))
      return null;
    const Z = isFiniteNumber(this.duration) ? this.duration : 0;
    return this.programDateTime + Z * 1e3;
  }
  get encrypted() {
    var Z;
    if ((Z = this._decryptdata) != null && Z.encrypted)
      return !0;
    if (this.levelkeys) {
      const ee = Object.keys(this.levelkeys), ae = ee.length;
      if (ae > 1 || ae === 1 && this.levelkeys[ee[0]].encrypted)
        return !0;
    }
    return !1;
  }
  setKeyFormat(Z) {
    if (this.levelkeys) {
      const ee = this.levelkeys[Z];
      ee && !this._decryptdata && (this._decryptdata = ee.getDecryptData(this.sn));
    }
  }
  abortRequests() {
    var Z, ee;
    (Z = this.loader) == null || Z.abort(), (ee = this.keyLoader) == null || ee.abort();
  }
  setElementaryStreamInfo(Z, ee, ae, ve, ye, be = !1) {
    const {
      elementaryStreams: Ye
    } = this, Qe = Ye[Z];
    if (!Qe) {
      Ye[Z] = {
        startPTS: ee,
        endPTS: ae,
        startDTS: ve,
        endDTS: ye,
        partial: be
      };
      return;
    }
    Qe.startPTS = Math.min(Qe.startPTS, ee), Qe.endPTS = Math.max(Qe.endPTS, ae), Qe.startDTS = Math.min(Qe.startDTS, ve), Qe.endDTS = Math.max(Qe.endDTS, ye);
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams: Z
    } = this;
    Z[ElementaryStreamTypes.AUDIO] = null, Z[ElementaryStreamTypes.VIDEO] = null, Z[ElementaryStreamTypes.AUDIOVIDEO] = null;
  }
}
class Part extends BaseSegment {
  constructor(Z, ee, ae, ve, ye) {
    super(ae), this.fragOffset = 0, this.duration = 0, this.gap = !1, this.independent = !1, this.relurl = void 0, this.fragment = void 0, this.index = void 0, this.stats = new LoadStats(), this.duration = Z.decimalFloatingPoint("DURATION"), this.gap = Z.bool("GAP"), this.independent = Z.bool("INDEPENDENT"), this.relurl = Z.enumeratedString("URI"), this.fragment = ee, this.index = ve;
    const be = Z.enumeratedString("BYTERANGE");
    be && this.setByteRange(be, ye), ye && (this.fragOffset = ye.fragOffset + ye.duration);
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams: Z
    } = this;
    return !!(Z.audio || Z.video || Z.audiovideo);
  }
}
const DEFAULT_TARGET_DURATION = 10;
class LevelDetails {
  constructor(Z) {
    this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.live = !0, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.availabilityDelay = void 0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.playlistParsingError = null, this.variableList = null, this.hasVariableRefs = !1, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = Z;
  }
  reloaded(Z) {
    if (!Z) {
      this.advanced = !0, this.updated = !0;
      return;
    }
    const ee = this.lastPartSn - Z.lastPartSn, ae = this.lastPartIndex - Z.lastPartIndex;
    this.updated = this.endSN !== Z.endSN || !!ae || !!ee || !this.live, this.advanced = this.endSN > Z.endSN || ee > 0 || ee === 0 && ae > 0, this.updated || this.advanced ? this.misses = Math.floor(Z.misses * 0.6) : this.misses = Z.misses + 1, this.availabilityDelay = Z.availabilityDelay;
  }
  get hasProgramDateTime() {
    return this.fragments.length ? isFiniteNumber(this.fragments[this.fragments.length - 1].programDateTime) : !1;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || DEFAULT_TARGET_DURATION;
  }
  get drift() {
    const Z = this.driftEndTime - this.driftStartTime;
    return Z > 0 ? (this.driftEnd - this.driftStart) * 1e3 / Z : 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var Z;
    return (Z = this.partList) != null && Z.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
  }
  get fragmentEnd() {
    var Z;
    return (Z = this.fragments) != null && Z.length ? this.fragments[this.fragments.length - 1].end : 0;
  }
  get age() {
    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
  }
  get lastPartIndex() {
    var Z;
    return (Z = this.partList) != null && Z.length ? this.partList[this.partList.length - 1].index : -1;
  }
  get lastPartSn() {
    var Z;
    return (Z = this.partList) != null && Z.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
  }
}
function base64Decode(ie) {
  return Uint8Array.from(atob(ie), (Z) => Z.charCodeAt(0));
}
function getKeyIdBytes(ie) {
  const Z = strToUtf8array(ie).subarray(0, 16), ee = new Uint8Array(16);
  return ee.set(Z, 16 - Z.length), ee;
}
function changeEndianness(ie) {
  const Z = function(ae, ve, ye) {
    const be = ae[ve];
    ae[ve] = ae[ye], ae[ye] = be;
  };
  Z(ie, 0, 3), Z(ie, 1, 2), Z(ie, 4, 5), Z(ie, 6, 7);
}
function convertDataUriToArrayBytes(ie) {
  const Z = ie.split(":");
  let ee = null;
  if (Z[0] === "data" && Z.length === 2) {
    const ae = Z[1].split(";"), ve = ae[ae.length - 1].split(",");
    if (ve.length === 2) {
      const ye = ve[0] === "base64", be = ve[1];
      ye ? (ae.splice(-1, 1), ee = base64Decode(be)) : ee = getKeyIdBytes(be);
    }
  }
  return ee;
}
function strToUtf8array(ie) {
  return Uint8Array.from(unescape(encodeURIComponent(ie)), (Z) => Z.charCodeAt(0));
}
const optionalSelf = typeof self < "u" ? self : void 0;
var KeySystems = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
}, KeySystemFormats = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function keySystemFormatToKeySystemDomain(ie) {
  switch (ie) {
    case KeySystemFormats.FAIRPLAY:
      return KeySystems.FAIRPLAY;
    case KeySystemFormats.PLAYREADY:
      return KeySystems.PLAYREADY;
    case KeySystemFormats.WIDEVINE:
      return KeySystems.WIDEVINE;
    case KeySystemFormats.CLEARKEY:
      return KeySystems.CLEARKEY;
  }
}
var KeySystemIds = {
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function keySystemIdToKeySystemDomain(ie) {
  if (ie === KeySystemIds.WIDEVINE)
    return KeySystems.WIDEVINE;
}
function keySystemDomainToKeySystemFormat(ie) {
  switch (ie) {
    case KeySystems.FAIRPLAY:
      return KeySystemFormats.FAIRPLAY;
    case KeySystems.PLAYREADY:
      return KeySystemFormats.PLAYREADY;
    case KeySystems.WIDEVINE:
      return KeySystemFormats.WIDEVINE;
    case KeySystems.CLEARKEY:
      return KeySystemFormats.CLEARKEY;
  }
}
function getKeySystemsForConfig(ie) {
  const {
    drmSystems: Z,
    widevineLicenseUrl: ee
  } = ie, ae = Z ? [KeySystems.FAIRPLAY, KeySystems.WIDEVINE, KeySystems.PLAYREADY, KeySystems.CLEARKEY].filter((ve) => !!Z[ve]) : [];
  return !ae[KeySystems.WIDEVINE] && ee && ae.push(KeySystems.WIDEVINE), ae;
}
const requestMediaKeySystemAccess = function(ie) {
  return optionalSelf != null && (ie = optionalSelf.navigator) != null && ie.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
}();
function getSupportedMediaKeySystemConfigurations(ie, Z, ee, ae) {
  let ve;
  switch (ie) {
    case KeySystems.FAIRPLAY:
      ve = ["cenc", "sinf"];
      break;
    case KeySystems.WIDEVINE:
    case KeySystems.PLAYREADY:
      ve = ["cenc"];
      break;
    case KeySystems.CLEARKEY:
      ve = ["cenc", "keyids"];
      break;
    default:
      throw new Error(`Unknown key-system: ${ie}`);
  }
  return createMediaKeySystemConfigurations(ve, Z, ee, ae);
}
function createMediaKeySystemConfigurations(ie, Z, ee, ae) {
  return [{
    initDataTypes: ie,
    persistentState: ae.persistentState || "optional",
    distinctiveIdentifier: ae.distinctiveIdentifier || "optional",
    sessionTypes: ae.sessionTypes || [ae.sessionType || "temporary"],
    audioCapabilities: Z.map((ye) => ({
      contentType: `audio/mp4; codecs="${ye}"`,
      robustness: ae.audioRobustness || "",
      encryptionScheme: ae.audioEncryptionScheme || null
    })),
    videoCapabilities: ee.map((ye) => ({
      contentType: `video/mp4; codecs="${ye}"`,
      robustness: ae.videoRobustness || "",
      encryptionScheme: ae.videoEncryptionScheme || null
    }))
  }];
}
function sliceUint8(ie, Z, ee) {
  return Uint8Array.prototype.slice ? ie.slice(Z, ee) : new Uint8Array(Array.prototype.slice.call(ie, Z, ee));
}
const isHeader$2 = (ie, Z) => Z + 10 <= ie.length && ie[Z] === 73 && ie[Z + 1] === 68 && ie[Z + 2] === 51 && ie[Z + 3] < 255 && ie[Z + 4] < 255 && ie[Z + 6] < 128 && ie[Z + 7] < 128 && ie[Z + 8] < 128 && ie[Z + 9] < 128, isFooter = (ie, Z) => Z + 10 <= ie.length && ie[Z] === 51 && ie[Z + 1] === 68 && ie[Z + 2] === 73 && ie[Z + 3] < 255 && ie[Z + 4] < 255 && ie[Z + 6] < 128 && ie[Z + 7] < 128 && ie[Z + 8] < 128 && ie[Z + 9] < 128, getID3Data = (ie, Z) => {
  const ee = Z;
  let ae = 0;
  for (; isHeader$2(ie, Z); ) {
    ae += 10;
    const ve = readSize(ie, Z + 6);
    ae += ve, isFooter(ie, Z + 10) && (ae += 10), Z += ae;
  }
  if (ae > 0)
    return ie.subarray(ee, ee + ae);
}, readSize = (ie, Z) => {
  let ee = 0;
  return ee = (ie[Z] & 127) << 21, ee |= (ie[Z + 1] & 127) << 14, ee |= (ie[Z + 2] & 127) << 7, ee |= ie[Z + 3] & 127, ee;
}, canParse$2 = (ie, Z) => isHeader$2(ie, Z) && readSize(ie, Z + 6) + 10 <= ie.length - Z, getTimeStamp = (ie) => {
  const Z = getID3Frames(ie);
  for (let ee = 0; ee < Z.length; ee++) {
    const ae = Z[ee];
    if (isTimeStampFrame(ae))
      return readTimeStamp(ae);
  }
}, isTimeStampFrame = (ie) => ie && ie.key === "PRIV" && ie.info === "com.apple.streaming.transportStreamTimestamp", getFrameData = (ie) => {
  const Z = String.fromCharCode(ie[0], ie[1], ie[2], ie[3]), ee = readSize(ie, 4), ae = 10;
  return {
    type: Z,
    size: ee,
    data: ie.subarray(ae, ae + ee)
  };
}, getID3Frames = (ie) => {
  let Z = 0;
  const ee = [];
  for (; isHeader$2(ie, Z); ) {
    const ae = readSize(ie, Z + 6);
    Z += 10;
    const ve = Z + ae;
    for (; Z + 8 < ve; ) {
      const ye = getFrameData(ie.subarray(Z)), be = decodeFrame(ye);
      be && ee.push(be), Z += ye.size + 10;
    }
    isFooter(ie, Z) && (Z += 10);
  }
  return ee;
}, decodeFrame = (ie) => ie.type === "PRIV" ? decodePrivFrame(ie) : ie.type[0] === "W" ? decodeURLFrame(ie) : decodeTextFrame(ie), decodePrivFrame = (ie) => {
  if (ie.size < 2)
    return;
  const Z = utf8ArrayToStr(ie.data, !0), ee = new Uint8Array(ie.data.subarray(Z.length + 1));
  return {
    key: ie.type,
    info: Z,
    data: ee.buffer
  };
}, decodeTextFrame = (ie) => {
  if (ie.size < 2)
    return;
  if (ie.type === "TXXX") {
    let ee = 1;
    const ae = utf8ArrayToStr(ie.data.subarray(ee), !0);
    ee += ae.length + 1;
    const ve = utf8ArrayToStr(ie.data.subarray(ee));
    return {
      key: ie.type,
      info: ae,
      data: ve
    };
  }
  const Z = utf8ArrayToStr(ie.data.subarray(1));
  return {
    key: ie.type,
    data: Z
  };
}, decodeURLFrame = (ie) => {
  if (ie.type === "WXXX") {
    if (ie.size < 2)
      return;
    let ee = 1;
    const ae = utf8ArrayToStr(ie.data.subarray(ee), !0);
    ee += ae.length + 1;
    const ve = utf8ArrayToStr(ie.data.subarray(ee));
    return {
      key: ie.type,
      info: ae,
      data: ve
    };
  }
  const Z = utf8ArrayToStr(ie.data);
  return {
    key: ie.type,
    data: Z
  };
}, readTimeStamp = (ie) => {
  if (ie.data.byteLength === 8) {
    const Z = new Uint8Array(ie.data), ee = Z[3] & 1;
    let ae = (Z[4] << 23) + (Z[5] << 15) + (Z[6] << 7) + Z[7];
    return ae /= 45, ee && (ae += 4772185884e-2), Math.round(ae);
  }
}, utf8ArrayToStr = (ie, Z = !1) => {
  const ee = getTextDecoder();
  if (ee) {
    const Je = ee.decode(ie);
    if (Z) {
      const nt = Je.indexOf("\0");
      return nt !== -1 ? Je.substring(0, nt) : Je;
    }
    return Je.replace(/\0/g, "");
  }
  const ae = ie.length;
  let ve, ye, be, Ye = "", Qe = 0;
  for (; Qe < ae; ) {
    if (ve = ie[Qe++], ve === 0 && Z)
      return Ye;
    if (ve === 0 || ve === 3)
      continue;
    switch (ve >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        Ye += String.fromCharCode(ve);
        break;
      case 12:
      case 13:
        ye = ie[Qe++], Ye += String.fromCharCode((ve & 31) << 6 | ye & 63);
        break;
      case 14:
        ye = ie[Qe++], be = ie[Qe++], Ye += String.fromCharCode((ve & 15) << 12 | (ye & 63) << 6 | (be & 63) << 0);
        break;
    }
  }
  return Ye;
};
let decoder;
function getTextDecoder() {
  if (!navigator.userAgent.includes("PlayStation 4"))
    return !decoder && typeof self.TextDecoder < "u" && (decoder = new self.TextDecoder("utf-8")), decoder;
}
const Hex = {
  hexDump: function(ie) {
    let Z = "";
    for (let ee = 0; ee < ie.length; ee++) {
      let ae = ie[ee].toString(16);
      ae.length < 2 && (ae = "0" + ae), Z += ae;
    }
    return Z;
  }
}, UINT32_MAX$1 = Math.pow(2, 32) - 1, push = [].push, RemuxerTrackIdConfig = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function bin2str(ie) {
  return String.fromCharCode.apply(null, ie);
}
function readUint16(ie, Z) {
  const ee = ie[Z] << 8 | ie[Z + 1];
  return ee < 0 ? 65536 + ee : ee;
}
function readUint32(ie, Z) {
  const ee = readSint32(ie, Z);
  return ee < 0 ? 4294967296 + ee : ee;
}
function readSint32(ie, Z) {
  return ie[Z] << 24 | ie[Z + 1] << 16 | ie[Z + 2] << 8 | ie[Z + 3];
}
function writeUint32(ie, Z, ee) {
  ie[Z] = ee >> 24, ie[Z + 1] = ee >> 16 & 255, ie[Z + 2] = ee >> 8 & 255, ie[Z + 3] = ee & 255;
}
function hasMoofData(ie) {
  const Z = ie.byteLength;
  for (let ee = 0; ee < Z; ) {
    const ae = readUint32(ie, ee);
    if (ae > 8 && ie[ee + 4] === 109 && ie[ee + 5] === 111 && ie[ee + 6] === 111 && ie[ee + 7] === 102)
      return !0;
    ee = ae > 1 ? ee + ae : Z;
  }
  return !1;
}
function findBox(ie, Z) {
  const ee = [];
  if (!Z.length)
    return ee;
  const ae = ie.byteLength;
  for (let ve = 0; ve < ae; ) {
    const ye = readUint32(ie, ve), be = bin2str(ie.subarray(ve + 4, ve + 8)), Ye = ye > 1 ? ve + ye : ae;
    if (be === Z[0])
      if (Z.length === 1)
        ee.push(ie.subarray(ve + 8, Ye));
      else {
        const Qe = findBox(ie.subarray(ve + 8, Ye), Z.slice(1));
        Qe.length && push.apply(ee, Qe);
      }
    ve = Ye;
  }
  return ee;
}
function parseSegmentIndex(ie) {
  const Z = [], ee = ie[0];
  let ae = 8;
  const ve = readUint32(ie, ae);
  ae += 4;
  const ye = 0, be = 0;
  ee === 0 ? ae += 8 : ae += 16, ae += 2;
  let Ye = ie.length + be;
  const Qe = readUint16(ie, ae);
  ae += 2;
  for (let Je = 0; Je < Qe; Je++) {
    let nt = ae;
    const st = readUint32(ie, nt);
    nt += 4;
    const ot = st & 2147483647;
    if ((st & 2147483648) >>> 31 === 1)
      return logger.warn("SIDX has hierarchical references (not supported)"), null;
    const ft = readUint32(ie, nt);
    nt += 4, Z.push({
      referenceSize: ot,
      subsegmentDuration: ft,
      // unscaled
      info: {
        duration: ft / ve,
        start: Ye,
        end: Ye + ot - 1
      }
    }), Ye += ot, nt += 4, ae = nt;
  }
  return {
    earliestPresentationTime: ye,
    timescale: ve,
    version: ee,
    referencesCount: Qe,
    references: Z
  };
}
function parseInitSegment(ie) {
  const Z = [], ee = findBox(ie, ["moov", "trak"]);
  for (let ve = 0; ve < ee.length; ve++) {
    const ye = ee[ve], be = findBox(ye, ["tkhd"])[0];
    if (be) {
      let Ye = be[0];
      const Qe = readUint32(be, Ye === 0 ? 12 : 20), Je = findBox(ye, ["mdia", "mdhd"])[0];
      if (Je) {
        Ye = Je[0];
        const nt = readUint32(Je, Ye === 0 ? 12 : 20), st = findBox(ye, ["mdia", "hdlr"])[0];
        if (st) {
          const ot = bin2str(st.subarray(8, 12)), lt = {
            soun: ElementaryStreamTypes.AUDIO,
            vide: ElementaryStreamTypes.VIDEO
          }[ot];
          if (lt) {
            const ft = findBox(ye, ["mdia", "minf", "stbl", "stsd"])[0], gt = parseStsd(ft);
            Z[Qe] = {
              timescale: nt,
              type: lt
            }, Z[lt] = _objectSpread2({
              timescale: nt,
              id: Qe
            }, gt);
          }
        }
      }
    }
  }
  return findBox(ie, ["moov", "mvex", "trex"]).forEach((ve) => {
    const ye = readUint32(ve, 4), be = Z[ye];
    be && (be.default = {
      duration: readUint32(ve, 12),
      flags: readUint32(ve, 20)
    });
  }), Z;
}
function parseStsd(ie) {
  const Z = ie.subarray(8), ee = Z.subarray(86), ae = bin2str(Z.subarray(4, 8));
  let ve = ae;
  const ye = ae === "enca" || ae === "encv";
  if (ye) {
    const Ye = findBox(Z, [ae])[0].subarray(ae === "enca" ? 28 : 78);
    findBox(Ye, ["sinf"]).forEach((Je) => {
      const nt = findBox(Je, ["schm"])[0];
      if (nt) {
        const st = bin2str(nt.subarray(4, 8));
        if (st === "cbcs" || st === "cenc") {
          const ot = findBox(Je, ["frma"])[0];
          ot && (ve = bin2str(ot));
        }
      }
    });
  }
  switch (ve) {
    case "avc1":
    case "avc2":
    case "avc3":
    case "avc4": {
      const be = findBox(ee, ["avcC"])[0];
      ve += "." + toHex(be[1]) + toHex(be[2]) + toHex(be[3]);
      break;
    }
    case "mp4a": {
      const be = findBox(Z, [ae])[0], Ye = findBox(be.subarray(28), ["esds"])[0];
      if (Ye && Ye.length > 12) {
        let Qe = 4;
        if (Ye[Qe++] !== 3)
          break;
        Qe = skipBERInteger(Ye, Qe), Qe += 2;
        const Je = Ye[Qe++];
        if (Je & 128 && (Qe += 2), Je & 64 && (Qe += Ye[Qe++]), Ye[Qe++] !== 4)
          break;
        Qe = skipBERInteger(Ye, Qe);
        const nt = Ye[Qe++];
        if (nt === 64)
          ve += "." + toHex(nt);
        else
          break;
        if (Qe += 12, Ye[Qe++] !== 5)
          break;
        Qe = skipBERInteger(Ye, Qe);
        const st = Ye[Qe++];
        let ot = (st & 248) >> 3;
        ot === 31 && (ot += 1 + ((st & 7) << 3) + ((Ye[Qe] & 224) >> 5)), ve += "." + ot;
      }
      break;
    }
    case "hvc1":
    case "hev1": {
      const be = findBox(ee, ["hvcC"])[0], Ye = be[1], Qe = ["", "A", "B", "C"][Ye >> 6], Je = Ye & 31, nt = readUint32(be, 2), st = (Ye & 32) >> 5 ? "H" : "L", ot = be[12], lt = be.subarray(6, 12);
      ve += "." + Qe + Je, ve += "." + nt.toString(16).toUpperCase(), ve += "." + st + ot;
      let ft = "";
      for (let gt = lt.length; gt--; ) {
        const ct = lt[gt];
        (ct || ft) && (ft = "." + ct.toString(16).toUpperCase() + ft);
      }
      ve += ft;
      break;
    }
    case "dvh1":
    case "dvhe": {
      const be = findBox(ee, ["dvcC"])[0], Ye = be[2] >> 1 & 127, Qe = be[2] << 5 & 32 | be[3] >> 3 & 31;
      ve += "." + addLeadingZero(Ye) + "." + addLeadingZero(Qe);
      break;
    }
    case "vp09": {
      const be = findBox(ee, ["vpcC"])[0], Ye = be[4], Qe = be[5], Je = be[6] >> 4 & 15;
      ve += "." + addLeadingZero(Ye) + "." + addLeadingZero(Qe) + "." + addLeadingZero(Je);
      break;
    }
    case "av01": {
      const be = findBox(ee, ["av1C"])[0], Ye = be[1] >>> 5, Qe = be[1] & 31, Je = be[2] >>> 7 ? "H" : "M", nt = (be[2] & 64) >> 6, st = (be[2] & 32) >> 5, ot = Ye === 2 && nt ? st ? 12 : 10 : nt ? 10 : 8, lt = (be[2] & 16) >> 4, ft = (be[2] & 8) >> 3, gt = (be[2] & 4) >> 2, ct = be[2] & 3;
      ve += "." + Ye + "." + addLeadingZero(Qe) + Je + "." + addLeadingZero(ot) + "." + lt + "." + ft + gt + ct + "." + addLeadingZero(1) + "." + addLeadingZero(1) + "." + addLeadingZero(1) + "." + 0;
      break;
    }
  }
  return {
    codec: ve,
    encrypted: ye
  };
}
function skipBERInteger(ie, Z) {
  const ee = Z + 5;
  for (; ie[Z++] & 128 && Z < ee; )
    ;
  return Z;
}
function toHex(ie) {
  return ("0" + ie.toString(16).toUpperCase()).slice(-2);
}
function addLeadingZero(ie) {
  return (ie < 10 ? "0" : "") + ie;
}
function patchEncyptionData(ie, Z) {
  if (!ie || !Z)
    return ie;
  const ee = Z.keyId;
  return ee && Z.isCommonEncryption && findBox(ie, ["moov", "trak"]).forEach((ve) => {
    const be = findBox(ve, ["mdia", "minf", "stbl", "stsd"])[0].subarray(8);
    let Ye = findBox(be, ["enca"]);
    const Qe = Ye.length > 0;
    Qe || (Ye = findBox(be, ["encv"])), Ye.forEach((Je) => {
      const nt = Qe ? Je.subarray(28) : Je.subarray(78);
      findBox(nt, ["sinf"]).forEach((ot) => {
        const lt = parseSinf(ot);
        if (lt) {
          const ft = lt.subarray(8, 24);
          ft.some((gt) => gt !== 0) || (logger.log(`[eme] Patching keyId in 'enc${Qe ? "a" : "v"}>sinf>>tenc' box: ${Hex.hexDump(ft)} -> ${Hex.hexDump(ee)}`), lt.set(ee, 8));
        }
      });
    });
  }), ie;
}
function parseSinf(ie) {
  const Z = findBox(ie, ["schm"])[0];
  if (Z) {
    const ee = bin2str(Z.subarray(4, 8));
    if (ee === "cbcs" || ee === "cenc")
      return findBox(ie, ["schi", "tenc"])[0];
  }
  return logger.error("[eme] missing 'schm' box"), null;
}
function getStartDTS(ie, Z) {
  return findBox(Z, ["moof", "traf"]).reduce((ee, ae) => {
    const ve = findBox(ae, ["tfdt"])[0], ye = ve[0], be = findBox(ae, ["tfhd"]).reduce((Ye, Qe) => {
      const Je = readUint32(Qe, 4), nt = ie[Je];
      if (nt) {
        let st = readUint32(ve, 4);
        if (ye === 1) {
          if (st === UINT32_MAX$1)
            return logger.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time"), Ye;
          st *= UINT32_MAX$1 + 1, st += readUint32(ve, 8);
        }
        const ot = nt.timescale || 9e4, lt = st / ot;
        if (isFiniteNumber(lt) && (Ye === null || lt < Ye))
          return lt;
      }
      return Ye;
    }, null);
    return be !== null && isFiniteNumber(be) && (ee === null || be < ee) ? be : ee;
  }, null);
}
function getDuration(ie, Z) {
  let ee = 0, ae = 0, ve = 0;
  const ye = findBox(ie, ["moof", "traf"]);
  for (let be = 0; be < ye.length; be++) {
    const Ye = ye[be], Qe = findBox(Ye, ["tfhd"])[0], Je = readUint32(Qe, 4), nt = Z[Je];
    if (!nt)
      continue;
    const st = nt.default, ot = readUint32(Qe, 0) | (st == null ? void 0 : st.flags);
    let lt = st == null ? void 0 : st.duration;
    ot & 8 && (ot & 2 ? lt = readUint32(Qe, 12) : lt = readUint32(Qe, 8));
    const ft = nt.timescale || 9e4, gt = findBox(Ye, ["trun"]);
    for (let ct = 0; ct < gt.length; ct++) {
      if (ee = computeRawDurationFromSamples(gt[ct]), !ee && lt) {
        const _r = readUint32(gt[ct], 4);
        ee = lt * _r;
      }
      nt.type === ElementaryStreamTypes.VIDEO ? ae += ee / ft : nt.type === ElementaryStreamTypes.AUDIO && (ve += ee / ft);
    }
  }
  if (ae === 0 && ve === 0) {
    let be = 0;
    const Ye = findBox(ie, ["sidx"]);
    for (let Qe = 0; Qe < Ye.length; Qe++) {
      const Je = parseSegmentIndex(Ye[Qe]);
      Je != null && Je.references && (be += Je.references.reduce((nt, st) => nt + st.info.duration || 0, 0));
    }
    return be;
  }
  return ae || ve;
}
function computeRawDurationFromSamples(ie) {
  const Z = readUint32(ie, 0);
  let ee = 8;
  Z & 1 && (ee += 4), Z & 4 && (ee += 4);
  let ae = 0;
  const ve = readUint32(ie, 4);
  for (let ye = 0; ye < ve; ye++) {
    if (Z & 256) {
      const be = readUint32(ie, ee);
      ae += be, ee += 4;
    }
    Z & 512 && (ee += 4), Z & 1024 && (ee += 4), Z & 2048 && (ee += 4);
  }
  return ae;
}
function offsetStartDTS(ie, Z, ee) {
  findBox(Z, ["moof", "traf"]).forEach((ae) => {
    findBox(ae, ["tfhd"]).forEach((ve) => {
      const ye = readUint32(ve, 4), be = ie[ye];
      if (!be)
        return;
      const Ye = be.timescale || 9e4;
      findBox(ae, ["tfdt"]).forEach((Qe) => {
        const Je = Qe[0], nt = ee * Ye;
        if (nt) {
          let st = readUint32(Qe, 4);
          if (Je === 0)
            st -= nt, st = Math.max(st, 0), writeUint32(Qe, 4, st);
          else {
            st *= Math.pow(2, 32), st += readUint32(Qe, 8), st -= nt, st = Math.max(st, 0);
            const ot = Math.floor(st / (UINT32_MAX$1 + 1)), lt = Math.floor(st % (UINT32_MAX$1 + 1));
            writeUint32(Qe, 4, ot), writeUint32(Qe, 8, lt);
          }
        }
      });
    });
  });
}
function segmentValidRange(ie) {
  const Z = {
    valid: null,
    remainder: null
  }, ee = findBox(ie, ["moof"]);
  if (ee.length < 2)
    return Z.remainder = ie, Z;
  const ae = ee[ee.length - 1];
  return Z.valid = sliceUint8(ie, 0, ae.byteOffset - 8), Z.remainder = sliceUint8(ie, ae.byteOffset - 8), Z;
}
function appendUint8Array(ie, Z) {
  const ee = new Uint8Array(ie.length + Z.length);
  return ee.set(ie), ee.set(Z, ie.length), ee;
}
function parseSamples(ie, Z) {
  const ee = [], ae = Z.samples, ve = Z.timescale, ye = Z.id;
  let be = !1;
  return findBox(ae, ["moof"]).map((Qe) => {
    const Je = Qe.byteOffset - 8;
    findBox(Qe, ["traf"]).map((st) => {
      const ot = findBox(st, ["tfdt"]).map((lt) => {
        const ft = lt[0];
        let gt = readUint32(lt, 4);
        return ft === 1 && (gt *= Math.pow(2, 32), gt += readUint32(lt, 8)), gt / ve;
      })[0];
      return ot !== void 0 && (ie = ot), findBox(st, ["tfhd"]).map((lt) => {
        const ft = readUint32(lt, 4), gt = readUint32(lt, 0) & 16777215, ct = (gt & 1) !== 0, _r = (gt & 2) !== 0, Kr = (gt & 8) !== 0;
        let Xr = 0;
        const Jr = (gt & 16) !== 0;
        let ei = 0;
        const si = (gt & 32) !== 0;
        let ri = 8;
        ft === ye && (ct && (ri += 8), _r && (ri += 4), Kr && (Xr = readUint32(lt, ri), ri += 4), Jr && (ei = readUint32(lt, ri), ri += 4), si && (ri += 4), Z.type === "video" && (be = isHEVC(Z.codec)), findBox(st, ["trun"]).map((ai) => {
          const yi = ai[0], pi = readUint32(ai, 0) & 16777215, di = (pi & 1) !== 0;
          let xi = 0;
          const Ti = (pi & 4) !== 0, Ai = (pi & 256) !== 0;
          let mi = 0;
          const Si = (pi & 512) !== 0;
          let gi = 0;
          const _i = (pi & 1024) !== 0, Oi = (pi & 2048) !== 0;
          let hi = 0;
          const Di = readUint32(ai, 4);
          let Ri = 8;
          di && (xi = readUint32(ai, Ri), Ri += 4), Ti && (Ri += 4);
          let rs = xi + Je;
          for (let Hi = 0; Hi < Di; Hi++) {
            if (Ai ? (mi = readUint32(ai, Ri), Ri += 4) : mi = Xr, Si ? (gi = readUint32(ai, Ri), Ri += 4) : gi = ei, _i && (Ri += 4), Oi && (yi === 0 ? hi = readUint32(ai, Ri) : hi = readSint32(ai, Ri), Ri += 4), Z.type === ElementaryStreamTypes.VIDEO) {
              let qi = 0;
              for (; qi < gi; ) {
                const us = readUint32(ae, rs);
                if (rs += 4, isSEIMessage(be, ae[rs])) {
                  const Yi = ae.subarray(rs, rs + us);
                  parseSEIMessageFromNALu(Yi, be ? 2 : 1, ie + hi / ve, ee);
                }
                rs += us, qi += us + 4;
              }
            }
            ie += mi / ve;
          }
        }));
      });
    });
  }), ee;
}
function isHEVC(ie) {
  if (!ie)
    return !1;
  const Z = ie.indexOf("."), ee = Z < 0 ? ie : ie.substring(0, Z);
  return ee === "hvc1" || ee === "hev1" || // Dolby Vision
  ee === "dvh1" || ee === "dvhe";
}
function isSEIMessage(ie, Z) {
  if (ie) {
    const ee = Z >> 1 & 63;
    return ee === 39 || ee === 40;
  } else
    return (Z & 31) === 6;
}
function parseSEIMessageFromNALu(ie, Z, ee, ae) {
  const ve = discardEPB(ie);
  let ye = 0;
  ye += Z;
  let be = 0, Ye = 0, Qe = 0;
  for (; ye < ve.length; ) {
    be = 0;
    do {
      if (ye >= ve.length)
        break;
      Qe = ve[ye++], be += Qe;
    } while (Qe === 255);
    Ye = 0;
    do {
      if (ye >= ve.length)
        break;
      Qe = ve[ye++], Ye += Qe;
    } while (Qe === 255);
    const Je = ve.length - ye;
    let nt = ye;
    if (Ye < Je)
      ye += Ye;
    else if (Ye > Je) {
      logger.error(`Malformed SEI payload. ${Ye} is too small, only ${Je} bytes left to parse.`);
      break;
    }
    if (be === 4) {
      if (ve[nt++] === 181) {
        const ot = readUint16(ve, nt);
        if (nt += 2, ot === 49) {
          const lt = readUint32(ve, nt);
          if (nt += 4, lt === 1195456820) {
            const ft = ve[nt++];
            if (ft === 3) {
              const gt = ve[nt++], ct = 31 & gt, _r = 64 & gt, Kr = _r ? 2 + ct * 3 : 0, Xr = new Uint8Array(Kr);
              if (_r) {
                Xr[0] = gt;
                for (let Jr = 1; Jr < Kr; Jr++)
                  Xr[Jr] = ve[nt++];
              }
              ae.push({
                type: ft,
                payloadType: be,
                pts: ee,
                bytes: Xr
              });
            }
          }
        }
      }
    } else if (be === 5 && Ye > 16) {
      const st = [];
      for (let ft = 0; ft < 16; ft++) {
        const gt = ve[nt++].toString(16);
        st.push(gt.length == 1 ? "0" + gt : gt), (ft === 3 || ft === 5 || ft === 7 || ft === 9) && st.push("-");
      }
      const ot = Ye - 16, lt = new Uint8Array(ot);
      for (let ft = 0; ft < ot; ft++)
        lt[ft] = ve[nt++];
      ae.push({
        payloadType: be,
        pts: ee,
        uuid: st.join(""),
        userData: utf8ArrayToStr(lt),
        userDataBytes: lt
      });
    }
  }
}
function discardEPB(ie) {
  const Z = ie.byteLength, ee = [];
  let ae = 1;
  for (; ae < Z - 2; )
    ie[ae] === 0 && ie[ae + 1] === 0 && ie[ae + 2] === 3 ? (ee.push(ae + 2), ae += 2) : ae++;
  if (ee.length === 0)
    return ie;
  const ve = Z - ee.length, ye = new Uint8Array(ve);
  let be = 0;
  for (ae = 0; ae < ve; be++, ae++)
    be === ee[0] && (be++, ee.shift()), ye[ae] = ie[be];
  return ye;
}
function parseEmsg(ie) {
  const Z = ie[0];
  let ee = "", ae = "", ve = 0, ye = 0, be = 0, Ye = 0, Qe = 0, Je = 0;
  if (Z === 0) {
    for (; bin2str(ie.subarray(Je, Je + 1)) !== "\0"; )
      ee += bin2str(ie.subarray(Je, Je + 1)), Je += 1;
    for (ee += bin2str(ie.subarray(Je, Je + 1)), Je += 1; bin2str(ie.subarray(Je, Je + 1)) !== "\0"; )
      ae += bin2str(ie.subarray(Je, Je + 1)), Je += 1;
    ae += bin2str(ie.subarray(Je, Je + 1)), Je += 1, ve = readUint32(ie, 12), ye = readUint32(ie, 16), Ye = readUint32(ie, 20), Qe = readUint32(ie, 24), Je = 28;
  } else if (Z === 1) {
    Je += 4, ve = readUint32(ie, Je), Je += 4;
    const st = readUint32(ie, Je);
    Je += 4;
    const ot = readUint32(ie, Je);
    for (Je += 4, be = 2 ** 32 * st + ot, isSafeInteger(be) || (be = Number.MAX_SAFE_INTEGER, logger.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), Ye = readUint32(ie, Je), Je += 4, Qe = readUint32(ie, Je), Je += 4; bin2str(ie.subarray(Je, Je + 1)) !== "\0"; )
      ee += bin2str(ie.subarray(Je, Je + 1)), Je += 1;
    for (ee += bin2str(ie.subarray(Je, Je + 1)), Je += 1; bin2str(ie.subarray(Je, Je + 1)) !== "\0"; )
      ae += bin2str(ie.subarray(Je, Je + 1)), Je += 1;
    ae += bin2str(ie.subarray(Je, Je + 1)), Je += 1;
  }
  const nt = ie.subarray(Je, ie.byteLength);
  return {
    schemeIdUri: ee,
    value: ae,
    timeScale: ve,
    presentationTime: be,
    presentationTimeDelta: ye,
    eventDuration: Ye,
    id: Qe,
    payload: nt
  };
}
function mp4Box(ie, ...Z) {
  const ee = Z.length;
  let ae = 8, ve = ee;
  for (; ve--; )
    ae += Z[ve].byteLength;
  const ye = new Uint8Array(ae);
  for (ye[0] = ae >> 24 & 255, ye[1] = ae >> 16 & 255, ye[2] = ae >> 8 & 255, ye[3] = ae & 255, ye.set(ie, 4), ve = 0, ae = 8; ve < ee; ve++)
    ye.set(Z[ve], ae), ae += Z[ve].byteLength;
  return ye;
}
function mp4pssh(ie, Z, ee) {
  if (ie.byteLength !== 16)
    throw new RangeError("Invalid system id");
  let ae, ve;
  if (Z) {
    ae = 1, ve = new Uint8Array(Z.length * 16);
    for (let Ye = 0; Ye < Z.length; Ye++) {
      const Qe = Z[Ye];
      if (Qe.byteLength !== 16)
        throw new RangeError("Invalid key");
      ve.set(Qe, Ye * 16);
    }
  } else
    ae = 0, ve = new Uint8Array();
  let ye;
  ae > 0 ? (ye = new Uint8Array(4), Z.length > 0 && new DataView(ye.buffer).setUint32(0, Z.length, !1)) : ye = new Uint8Array();
  const be = new Uint8Array(4);
  return ee && ee.byteLength > 0 && new DataView(be.buffer).setUint32(0, ee.byteLength, !1), mp4Box(
    [112, 115, 115, 104],
    new Uint8Array([
      ae,
      0,
      0,
      0
      // Flags
    ]),
    ie,
    // 16 bytes
    ye,
    ve,
    be,
    ee || new Uint8Array()
  );
}
function parsePssh(ie) {
  if (!(ie instanceof ArrayBuffer) || ie.byteLength < 32)
    return null;
  const Z = {
    version: 0,
    systemId: "",
    kids: null,
    data: null
  }, ee = new DataView(ie), ae = ee.getUint32(0);
  if (ie.byteLength !== ae && ae > 44 || ee.getUint32(4) !== 1886614376 || (Z.version = ee.getUint32(8) >>> 24, Z.version > 1))
    return null;
  Z.systemId = Hex.hexDump(new Uint8Array(ie, 12, 16));
  const ye = ee.getUint32(28);
  if (Z.version === 0) {
    if (ae - 32 < ye)
      return null;
    Z.data = new Uint8Array(ie, 32, ye);
  } else if (Z.version === 1) {
    Z.kids = [];
    for (let be = 0; be < ye; be++)
      Z.kids.push(new Uint8Array(ie, 32 + be * 16, 16));
  }
  return Z;
}
let keyUriToKeyIdMap = {};
class LevelKey {
  static clearKeyUriToKeyIdMap() {
    keyUriToKeyIdMap = {};
  }
  constructor(Z, ee, ae, ve = [1], ye = null) {
    this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = Z, this.uri = ee, this.keyFormat = ae, this.keyFormatVersions = ve, this.iv = ye, this.encrypted = Z ? Z !== "NONE" : !1, this.isCommonEncryption = this.encrypted && Z !== "AES-128";
  }
  isSupported() {
    if (this.method) {
      if (this.method === "AES-128" || this.method === "NONE")
        return !0;
      if (this.keyFormat === "identity")
        return this.method === "SAMPLE-AES";
      switch (this.keyFormat) {
        case KeySystemFormats.FAIRPLAY:
        case KeySystemFormats.WIDEVINE:
        case KeySystemFormats.PLAYREADY:
        case KeySystemFormats.CLEARKEY:
          return ["ISO-23001-7", "SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
      }
    }
    return !1;
  }
  getDecryptData(Z) {
    if (!this.encrypted || !this.uri)
      return null;
    if (this.method === "AES-128" && this.uri && !this.iv) {
      typeof Z != "number" && (this.method === "AES-128" && !this.iv && logger.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`), Z = 0);
      const ae = createInitializationVector(Z);
      return new LevelKey(this.method, this.uri, "identity", this.keyFormatVersions, ae);
    }
    const ee = convertDataUriToArrayBytes(this.uri);
    if (ee)
      switch (this.keyFormat) {
        case KeySystemFormats.WIDEVINE:
          this.pssh = ee, ee.length >= 22 && (this.keyId = ee.subarray(ee.length - 22, ee.length - 6));
          break;
        case KeySystemFormats.PLAYREADY: {
          const ae = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
          this.pssh = mp4pssh(ae, null, ee);
          const ve = new Uint16Array(ee.buffer, ee.byteOffset, ee.byteLength / 2), ye = String.fromCharCode.apply(null, Array.from(ve)), be = ye.substring(ye.indexOf("<"), ye.length), Je = new DOMParser().parseFromString(be, "text/xml").getElementsByTagName("KID")[0];
          if (Je) {
            const nt = Je.childNodes[0] ? Je.childNodes[0].nodeValue : Je.getAttribute("VALUE");
            if (nt) {
              const st = base64Decode(nt).subarray(0, 16);
              changeEndianness(st), this.keyId = st;
            }
          }
          break;
        }
        default: {
          let ae = ee.subarray(0, 16);
          if (ae.length !== 16) {
            const ve = new Uint8Array(16);
            ve.set(ae, 16 - ae.length), ae = ve;
          }
          this.keyId = ae;
          break;
        }
      }
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let ae = keyUriToKeyIdMap[this.uri];
      if (!ae) {
        const ve = Object.keys(keyUriToKeyIdMap).length % Number.MAX_SAFE_INTEGER;
        ae = new Uint8Array(16), new DataView(ae.buffer, 12, 4).setUint32(0, ve), keyUriToKeyIdMap[this.uri] = ae;
      }
      this.keyId = ae;
    }
    return this;
  }
}
function createInitializationVector(ie) {
  const Z = new Uint8Array(16);
  for (let ee = 12; ee < 16; ee++)
    Z[ee] = ie >> 8 * (15 - ee) & 255;
  return Z;
}
const VARIABLE_REPLACEMENT_REGEX = /\{\$([a-zA-Z0-9-_]+)\}/g;
function hasVariableReferences(ie) {
  return VARIABLE_REPLACEMENT_REGEX.test(ie);
}
function substituteVariablesInAttributes(ie, Z, ee) {
  if (ie.variableList !== null || ie.hasVariableRefs)
    for (let ae = ee.length; ae--; ) {
      const ve = ee[ae], ye = Z[ve];
      ye && (Z[ve] = substituteVariables(ie, ye));
    }
}
function substituteVariables(ie, Z) {
  if (ie.variableList !== null || ie.hasVariableRefs) {
    const ee = ie.variableList;
    return Z.replace(VARIABLE_REPLACEMENT_REGEX, (ae) => {
      const ve = ae.substring(2, ae.length - 1), ye = ee == null ? void 0 : ee[ve];
      return ye === void 0 ? (ie.playlistParsingError || (ie.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${ve}"`)), ae) : ye;
    });
  }
  return Z;
}
function addVariableDefinition(ie, Z, ee) {
  let ae = ie.variableList;
  ae || (ie.variableList = ae = {});
  let ve, ye;
  if ("QUERYPARAM" in Z) {
    ve = Z.QUERYPARAM;
    try {
      const be = new self.URL(ee).searchParams;
      if (be.has(ve))
        ye = be.get(ve);
      else
        throw new Error(`"${ve}" does not match any query parameter in URI: "${ee}"`);
    } catch (be) {
      ie.playlistParsingError || (ie.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${be.message}`));
    }
  } else
    ve = Z.NAME, ye = Z.VALUE;
  ve in ae ? ie.playlistParsingError || (ie.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${ve}"`)) : ae[ve] = ye || "";
}
function importVariableDefinition(ie, Z, ee) {
  const ae = Z.IMPORT;
  if (ee && ae in ee) {
    let ve = ie.variableList;
    ve || (ie.variableList = ve = {}), ve[ae] = ee[ae];
  } else
    ie.playlistParsingError || (ie.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${ae}"`));
}
function getMediaSource(ie = !0) {
  return typeof self > "u" ? void 0 : (ie || !self.MediaSource) && self.ManagedMediaSource || self.MediaSource || self.WebKitMediaSource;
}
const sampleEntryCodesISO = {
  audio: {
    a3ds: 1,
    "ac-3": 0.95,
    "ac-4": 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    "dts+": 1,
    "dts-": 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    "ec-3": 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    "raw ": 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    "vc-1": 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function isCodecType(ie, Z) {
  const ee = sampleEntryCodesISO[Z];
  return !!ee && !!ee[ie.slice(0, 4)];
}
function areCodecsMediaSourceSupported(ie, Z, ee = !0) {
  return !ie.split(",").some((ae) => !isCodecMediaSourceSupported(ae, Z, ee));
}
function isCodecMediaSourceSupported(ie, Z, ee = !0) {
  var ae;
  const ve = getMediaSource(ee);
  return (ae = ve == null ? void 0 : ve.isTypeSupported(mimeTypeForCodec(ie, Z))) != null ? ae : !1;
}
function mimeTypeForCodec(ie, Z) {
  return `${Z}/mp4;codecs="${ie}"`;
}
function videoCodecPreferenceValue(ie) {
  if (ie) {
    const Z = ie.substring(0, 4);
    return sampleEntryCodesISO.video[Z];
  }
  return 2;
}
function codecsSetSelectionPreferenceValue(ie) {
  return ie.split(",").reduce((Z, ee) => {
    const ae = sampleEntryCodesISO.video[ee];
    return ae ? (ae * 2 + Z) / (Z ? 3 : 2) : (sampleEntryCodesISO.audio[ee] + Z) / (Z ? 2 : 1);
  }, 0);
}
const CODEC_COMPATIBLE_NAMES = {};
function getCodecCompatibleNameLower(ie, Z = !0) {
  if (CODEC_COMPATIBLE_NAMES[ie])
    return CODEC_COMPATIBLE_NAMES[ie];
  const ee = {
    flac: ["flac", "fLaC", "FLAC"],
    opus: ["opus", "Opus"]
  }[ie];
  for (let ae = 0; ae < ee.length; ae++)
    if (isCodecMediaSourceSupported(ee[ae], "audio", Z))
      return CODEC_COMPATIBLE_NAMES[ie] = ee[ae], ee[ae];
  return ie;
}
const AUDIO_CODEC_REGEXP = /flac|opus/i;
function getCodecCompatibleName(ie, Z = !0) {
  return ie.replace(AUDIO_CODEC_REGEXP, (ee) => getCodecCompatibleNameLower(ee.toLowerCase(), Z));
}
function pickMostCompleteCodecName(ie, Z) {
  return ie && ie !== "mp4a" ? ie : Z;
}
function convertAVC1ToAVCOTI(ie) {
  const Z = ie.split(".");
  if (Z.length > 2) {
    let ee = Z.shift() + ".";
    return ee += parseInt(Z.shift()).toString(16), ee += ("000" + parseInt(Z.shift()).toString(16)).slice(-4), ee;
  }
  return ie;
}
const MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g, MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g, IS_MEDIA_PLAYLIST = /^#EXT(?:INF|-X-TARGETDURATION):/m, LEVEL_PLAYLIST_REGEX_FAST = new RegExp([
  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
  // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /(?!#) *(\S[\S ]*)/.source,
  // segment URI, group 3 => the URI (note newline is not eaten)
  /#EXT-X-BYTERANGE:*(.+)/.source,
  // next segment's byterange, group 4 => range spec (x@y)
  /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
  // next segment's program date/time group 5 => the datetime spec
  /#.*/.source
  // All other non-segment oriented tags will match with all groups empty
].join("|"), "g"), LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
class M3U8Parser {
  static findGroup(Z, ee) {
    for (let ae = 0; ae < Z.length; ae++) {
      const ve = Z[ae];
      if (ve.id === ee)
        return ve;
    }
  }
  static resolve(Z, ee) {
    return urlToolkitExports.buildAbsoluteURL(ee, Z, {
      alwaysNormalize: !0
    });
  }
  static isMediaPlaylist(Z) {
    return IS_MEDIA_PLAYLIST.test(Z);
  }
  static parseMasterPlaylist(Z, ee) {
    const ae = hasVariableReferences(Z), ve = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs: ae
    }, ye = [];
    MASTER_PLAYLIST_REGEX.lastIndex = 0;
    let be;
    for (; (be = MASTER_PLAYLIST_REGEX.exec(Z)) != null; )
      if (be[1]) {
        var Ye;
        const Je = new AttrList(be[1]);
        substituteVariablesInAttributes(ve, Je, ["CODECS", "SUPPLEMENTAL-CODECS", "ALLOWED-CPC", "PATHWAY-ID", "STABLE-VARIANT-ID", "AUDIO", "VIDEO", "SUBTITLES", "CLOSED-CAPTIONS", "NAME"]);
        const nt = substituteVariables(ve, be[2]), st = {
          attrs: Je,
          bitrate: Je.decimalInteger("BANDWIDTH") || Je.decimalInteger("AVERAGE-BANDWIDTH"),
          name: Je.NAME,
          url: M3U8Parser.resolve(nt, ee)
        }, ot = Je.decimalResolution("RESOLUTION");
        ot && (st.width = ot.width, st.height = ot.height), setCodecs(Je.CODECS, st), (Ye = st.unknownCodecs) != null && Ye.length || ye.push(st), ve.levels.push(st);
      } else if (be[3]) {
        const Je = be[3], nt = be[4];
        switch (Je) {
          case "SESSION-DATA": {
            const st = new AttrList(nt);
            substituteVariablesInAttributes(ve, st, ["DATA-ID", "LANGUAGE", "VALUE", "URI"]);
            const ot = st["DATA-ID"];
            ot && (ve.sessionData === null && (ve.sessionData = {}), ve.sessionData[ot] = st);
            break;
          }
          case "SESSION-KEY": {
            const st = parseKey(nt, ee, ve);
            st.encrypted && st.isSupported() ? (ve.sessionKeys === null && (ve.sessionKeys = []), ve.sessionKeys.push(st)) : logger.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${nt}"`);
            break;
          }
          case "DEFINE": {
            {
              const st = new AttrList(nt);
              substituteVariablesInAttributes(ve, st, ["NAME", "VALUE", "QUERYPARAM"]), addVariableDefinition(ve, st, ee);
            }
            break;
          }
          case "CONTENT-STEERING": {
            const st = new AttrList(nt);
            substituteVariablesInAttributes(ve, st, ["SERVER-URI", "PATHWAY-ID"]), ve.contentSteering = {
              uri: M3U8Parser.resolve(st["SERVER-URI"], ee),
              pathwayId: st["PATHWAY-ID"] || "."
            };
            break;
          }
          case "START": {
            ve.startTimeOffset = parseStartTimeOffset(nt);
            break;
          }
        }
      }
    const Qe = ye.length > 0 && ye.length < ve.levels.length;
    return ve.levels = Qe ? ye : ve.levels, ve.levels.length === 0 && (ve.playlistParsingError = new Error("no levels found in manifest")), ve;
  }
  static parseMasterPlaylistMedia(Z, ee, ae) {
    let ve;
    const ye = {}, be = ae.levels, Ye = {
      AUDIO: be.map((Je) => ({
        id: Je.attrs.AUDIO,
        audioCodec: Je.audioCodec
      })),
      SUBTITLES: be.map((Je) => ({
        id: Je.attrs.SUBTITLES,
        textCodec: Je.textCodec
      })),
      "CLOSED-CAPTIONS": []
    };
    let Qe = 0;
    for (MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0; (ve = MASTER_PLAYLIST_MEDIA_REGEX.exec(Z)) !== null; ) {
      const Je = new AttrList(ve[1]), nt = Je.TYPE;
      if (nt) {
        const st = Ye[nt], ot = ye[nt] || [];
        ye[nt] = ot, substituteVariablesInAttributes(ae, Je, ["URI", "GROUP-ID", "LANGUAGE", "ASSOC-LANGUAGE", "STABLE-RENDITION-ID", "NAME", "INSTREAM-ID", "CHARACTERISTICS", "CHANNELS"]);
        const lt = Je.LANGUAGE, ft = Je["ASSOC-LANGUAGE"], gt = Je.CHANNELS, ct = Je.CHARACTERISTICS, _r = Je["INSTREAM-ID"], Kr = {
          attrs: Je,
          bitrate: 0,
          id: Qe++,
          groupId: Je["GROUP-ID"] || "",
          name: Je.NAME || lt || "",
          type: nt,
          default: Je.bool("DEFAULT"),
          autoselect: Je.bool("AUTOSELECT"),
          forced: Je.bool("FORCED"),
          lang: lt,
          url: Je.URI ? M3U8Parser.resolve(Je.URI, ee) : ""
        };
        if (ft && (Kr.assocLang = ft), gt && (Kr.channels = gt), ct && (Kr.characteristics = ct), _r && (Kr.instreamId = _r), st != null && st.length) {
          const Xr = M3U8Parser.findGroup(st, Kr.groupId) || st[0];
          assignCodec(Kr, Xr, "audioCodec"), assignCodec(Kr, Xr, "textCodec");
        }
        ot.push(Kr);
      }
    }
    return ye;
  }
  static parseLevelPlaylist(Z, ee, ae, ve, ye, be) {
    const Ye = new LevelDetails(ee), Qe = Ye.fragments;
    let Je = null, nt = 0, st = 0, ot = 0, lt = 0, ft = null, gt = new Fragment(ve, ee), ct, _r, Kr, Xr = -1, Jr = !1, ei = null;
    for (LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0, Ye.m3u8 = Z, Ye.hasVariableRefs = hasVariableReferences(Z); (ct = LEVEL_PLAYLIST_REGEX_FAST.exec(Z)) !== null; ) {
      Jr && (Jr = !1, gt = new Fragment(ve, ee), gt.start = ot, gt.sn = nt, gt.cc = lt, gt.level = ae, Je && (gt.initSegment = Je, gt.rawProgramDateTime = Je.rawProgramDateTime, Je.rawProgramDateTime = null, ei && (gt.setByteRange(ei), ei = null)));
      const yi = ct[1];
      if (yi) {
        gt.duration = parseFloat(yi);
        const pi = (" " + ct[2]).slice(1);
        gt.title = pi || null, gt.tagList.push(pi ? ["INF", yi, pi] : ["INF", yi]);
      } else if (ct[3]) {
        if (isFiniteNumber(gt.duration)) {
          gt.start = ot, Kr && setFragLevelKeys(gt, Kr, Ye), gt.sn = nt, gt.level = ae, gt.cc = lt, Qe.push(gt);
          const pi = (" " + ct[3]).slice(1);
          gt.relurl = substituteVariables(Ye, pi), assignProgramDateTime(gt, ft), ft = gt, ot += gt.duration, nt++, st = 0, Jr = !0;
        }
      } else if (ct[4]) {
        const pi = (" " + ct[4]).slice(1);
        ft ? gt.setByteRange(pi, ft) : gt.setByteRange(pi);
      } else if (ct[5])
        gt.rawProgramDateTime = (" " + ct[5]).slice(1), gt.tagList.push(["PROGRAM-DATE-TIME", gt.rawProgramDateTime]), Xr === -1 && (Xr = Qe.length);
      else {
        if (ct = ct[0].match(LEVEL_PLAYLIST_REGEX_SLOW), !ct) {
          logger.warn("No matches on slow regex match for level playlist!");
          continue;
        }
        for (_r = 1; _r < ct.length && !(typeof ct[_r] < "u"); _r++)
          ;
        const pi = (" " + ct[_r]).slice(1), di = (" " + ct[_r + 1]).slice(1), xi = ct[_r + 2] ? (" " + ct[_r + 2]).slice(1) : "";
        switch (pi) {
          case "PLAYLIST-TYPE":
            Ye.type = di.toUpperCase();
            break;
          case "MEDIA-SEQUENCE":
            nt = Ye.startSN = parseInt(di);
            break;
          case "SKIP": {
            const Ti = new AttrList(di);
            substituteVariablesInAttributes(Ye, Ti, ["RECENTLY-REMOVED-DATERANGES"]);
            const Ai = Ti.decimalInteger("SKIPPED-SEGMENTS");
            if (isFiniteNumber(Ai)) {
              Ye.skippedSegments = Ai;
              for (let Si = Ai; Si--; )
                Qe.unshift(null);
              nt += Ai;
            }
            const mi = Ti.enumeratedString("RECENTLY-REMOVED-DATERANGES");
            mi && (Ye.recentlyRemovedDateranges = mi.split("	"));
            break;
          }
          case "TARGETDURATION":
            Ye.targetduration = Math.max(parseInt(di), 1);
            break;
          case "VERSION":
            Ye.version = parseInt(di);
            break;
          case "INDEPENDENT-SEGMENTS":
          case "EXTM3U":
            break;
          case "ENDLIST":
            Ye.live = !1;
            break;
          case "#":
            (di || xi) && gt.tagList.push(xi ? [di, xi] : [di]);
            break;
          case "DISCONTINUITY":
            lt++, gt.tagList.push(["DIS"]);
            break;
          case "GAP":
            gt.gap = !0, gt.tagList.push([pi]);
            break;
          case "BITRATE":
            gt.tagList.push([pi, di]);
            break;
          case "DATERANGE": {
            const Ti = new AttrList(di);
            substituteVariablesInAttributes(Ye, Ti, ["ID", "CLASS", "START-DATE", "END-DATE", "SCTE35-CMD", "SCTE35-OUT", "SCTE35-IN"]), substituteVariablesInAttributes(Ye, Ti, Ti.clientAttrs);
            const Ai = new DateRange(Ti, Ye.dateRanges[Ti.ID]);
            Ai.isValid || Ye.skippedSegments ? Ye.dateRanges[Ai.id] = Ai : logger.warn(`Ignoring invalid DATERANGE tag: "${di}"`), gt.tagList.push(["EXT-X-DATERANGE", di]);
            break;
          }
          case "DEFINE": {
            {
              const Ti = new AttrList(di);
              substituteVariablesInAttributes(Ye, Ti, ["NAME", "VALUE", "IMPORT", "QUERYPARAM"]), "IMPORT" in Ti ? importVariableDefinition(Ye, Ti, be) : addVariableDefinition(Ye, Ti, ee);
            }
            break;
          }
          case "DISCONTINUITY-SEQUENCE":
            lt = parseInt(di);
            break;
          case "KEY": {
            const Ti = parseKey(di, ee, Ye);
            if (Ti.isSupported()) {
              if (Ti.method === "NONE") {
                Kr = void 0;
                break;
              }
              Kr || (Kr = {}), Kr[Ti.keyFormat] && (Kr = _extends({}, Kr)), Kr[Ti.keyFormat] = Ti;
            } else
              logger.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${di}"`);
            break;
          }
          case "START":
            Ye.startTimeOffset = parseStartTimeOffset(di);
            break;
          case "MAP": {
            const Ti = new AttrList(di);
            if (substituteVariablesInAttributes(Ye, Ti, ["BYTERANGE", "URI"]), gt.duration) {
              const Ai = new Fragment(ve, ee);
              setInitSegment(Ai, Ti, ae, Kr), Je = Ai, gt.initSegment = Je, Je.rawProgramDateTime && !gt.rawProgramDateTime && (gt.rawProgramDateTime = Je.rawProgramDateTime);
            } else {
              const Ai = gt.byteRangeEndOffset;
              if (Ai) {
                const mi = gt.byteRangeStartOffset;
                ei = `${Ai - mi}@${mi}`;
              } else
                ei = null;
              setInitSegment(gt, Ti, ae, Kr), Je = gt, Jr = !0;
            }
            break;
          }
          case "SERVER-CONTROL": {
            const Ti = new AttrList(di);
            Ye.canBlockReload = Ti.bool("CAN-BLOCK-RELOAD"), Ye.canSkipUntil = Ti.optionalFloat("CAN-SKIP-UNTIL", 0), Ye.canSkipDateRanges = Ye.canSkipUntil > 0 && Ti.bool("CAN-SKIP-DATERANGES"), Ye.partHoldBack = Ti.optionalFloat("PART-HOLD-BACK", 0), Ye.holdBack = Ti.optionalFloat("HOLD-BACK", 0);
            break;
          }
          case "PART-INF": {
            const Ti = new AttrList(di);
            Ye.partTarget = Ti.decimalFloatingPoint("PART-TARGET");
            break;
          }
          case "PART": {
            let Ti = Ye.partList;
            Ti || (Ti = Ye.partList = []);
            const Ai = st > 0 ? Ti[Ti.length - 1] : void 0, mi = st++, Si = new AttrList(di);
            substituteVariablesInAttributes(Ye, Si, ["BYTERANGE", "URI"]);
            const gi = new Part(Si, gt, ee, mi, Ai);
            Ti.push(gi), gt.duration += gi.duration;
            break;
          }
          case "PRELOAD-HINT": {
            const Ti = new AttrList(di);
            substituteVariablesInAttributes(Ye, Ti, ["URI"]), Ye.preloadHint = Ti;
            break;
          }
          case "RENDITION-REPORT": {
            const Ti = new AttrList(di);
            substituteVariablesInAttributes(Ye, Ti, ["URI"]), Ye.renditionReports = Ye.renditionReports || [], Ye.renditionReports.push(Ti);
            break;
          }
          default:
            logger.warn(`line parsed but not handled: ${ct}`);
            break;
        }
      }
    }
    ft && !ft.relurl ? (Qe.pop(), ot -= ft.duration, Ye.partList && (Ye.fragmentHint = ft)) : Ye.partList && (assignProgramDateTime(gt, ft), gt.cc = lt, Ye.fragmentHint = gt, Kr && setFragLevelKeys(gt, Kr, Ye));
    const si = Qe.length, ri = Qe[0], ai = Qe[si - 1];
    if (ot += Ye.skippedSegments * Ye.targetduration, ot > 0 && si && ai) {
      Ye.averagetargetduration = ot / si;
      const yi = ai.sn;
      Ye.endSN = yi !== "initSegment" ? yi : 0, Ye.live || (ai.endList = !0), ri && (Ye.startCC = ri.cc);
    } else
      Ye.endSN = 0, Ye.startCC = 0;
    return Ye.fragmentHint && (ot += Ye.fragmentHint.duration), Ye.totalduration = ot, Ye.endCC = lt, Xr > 0 && backfillProgramDateTimes(Qe, Xr), Ye;
  }
}
function parseKey(ie, Z, ee) {
  var ae, ve;
  const ye = new AttrList(ie);
  substituteVariablesInAttributes(ee, ye, ["KEYFORMAT", "KEYFORMATVERSIONS", "URI", "IV", "URI"]);
  const be = (ae = ye.METHOD) != null ? ae : "", Ye = ye.URI, Qe = ye.hexadecimalInteger("IV"), Je = ye.KEYFORMATVERSIONS, nt = (ve = ye.KEYFORMAT) != null ? ve : "identity";
  Ye && ye.IV && !Qe && logger.error(`Invalid IV: ${ye.IV}`);
  const st = Ye ? M3U8Parser.resolve(Ye, Z) : "", ot = (Je || "1").split("/").map(Number).filter(Number.isFinite);
  return new LevelKey(be, st, nt, ot, Qe);
}
function parseStartTimeOffset(ie) {
  const ee = new AttrList(ie).decimalFloatingPoint("TIME-OFFSET");
  return isFiniteNumber(ee) ? ee : null;
}
function setCodecs(ie, Z) {
  let ee = (ie || "").split(/[ ,]+/).filter((ae) => ae);
  ["video", "audio", "text"].forEach((ae) => {
    const ve = ee.filter((ye) => isCodecType(ye, ae));
    ve.length && (Z[`${ae}Codec`] = ve.join(","), ee = ee.filter((ye) => ve.indexOf(ye) === -1));
  }), Z.unknownCodecs = ee;
}
function assignCodec(ie, Z, ee) {
  const ae = Z[ee];
  ae && (ie[ee] = ae);
}
function backfillProgramDateTimes(ie, Z) {
  let ee = ie[Z];
  for (let ae = Z; ae--; ) {
    const ve = ie[ae];
    if (!ve)
      return;
    ve.programDateTime = ee.programDateTime - ve.duration * 1e3, ee = ve;
  }
}
function assignProgramDateTime(ie, Z) {
  ie.rawProgramDateTime ? ie.programDateTime = Date.parse(ie.rawProgramDateTime) : Z != null && Z.programDateTime && (ie.programDateTime = Z.endProgramDateTime), isFiniteNumber(ie.programDateTime) || (ie.programDateTime = null, ie.rawProgramDateTime = null);
}
function setInitSegment(ie, Z, ee, ae) {
  ie.relurl = Z.URI, Z.BYTERANGE && ie.setByteRange(Z.BYTERANGE), ie.level = ee, ie.sn = "initSegment", ae && (ie.levelkeys = ae), ie.initSegment = null;
}
function setFragLevelKeys(ie, Z, ee) {
  ie.levelkeys = Z;
  const {
    encryptedFragments: ae
  } = ee;
  (!ae.length || ae[ae.length - 1].levelkeys !== Z) && Object.keys(Z).some((ve) => Z[ve].isCommonEncryption) && ae.push(ie);
}
var PlaylistContextType = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
}, PlaylistLevelType = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};
function mapContextToLevelType(ie) {
  const {
    type: Z
  } = ie;
  switch (Z) {
    case PlaylistContextType.AUDIO_TRACK:
      return PlaylistLevelType.AUDIO;
    case PlaylistContextType.SUBTITLE_TRACK:
      return PlaylistLevelType.SUBTITLE;
    default:
      return PlaylistLevelType.MAIN;
  }
}
function getResponseUrl(ie, Z) {
  let ee = ie.url;
  return (ee === void 0 || ee.indexOf("data:") === 0) && (ee = Z.url), ee;
}
class PlaylistLoader {
  constructor(Z) {
    this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.variableList = null, this.hls = Z, this.registerListeners();
  }
  startLoad(Z) {
  }
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.LEVEL_LOADING, this.onLevelLoading, this), Z.on(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), Z.on(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.LEVEL_LOADING, this.onLevelLoading, this), Z.off(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), Z.off(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(Z) {
    const ee = this.hls.config, ae = ee.pLoader, ve = ee.loader, ye = ae || ve, be = new ye(ee);
    return this.loaders[Z.type] = be, be;
  }
  getInternalLoader(Z) {
    return this.loaders[Z.type];
  }
  resetInternalLoader(Z) {
    this.loaders[Z] && delete this.loaders[Z];
  }
  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const Z in this.loaders) {
      const ee = this.loaders[Z];
      ee && ee.destroy(), this.resetInternalLoader(Z);
    }
  }
  destroy() {
    this.variableList = null, this.unregisterListeners(), this.destroyInternalLoaders();
  }
  onManifestLoading(Z, ee) {
    const {
      url: ae
    } = ee;
    this.variableList = null, this.load({
      id: null,
      level: 0,
      responseType: "text",
      type: PlaylistContextType.MANIFEST,
      url: ae,
      deliveryDirectives: null
    });
  }
  onLevelLoading(Z, ee) {
    const {
      id: ae,
      level: ve,
      pathwayId: ye,
      url: be,
      deliveryDirectives: Ye
    } = ee;
    this.load({
      id: ae,
      level: ve,
      pathwayId: ye,
      responseType: "text",
      type: PlaylistContextType.LEVEL,
      url: be,
      deliveryDirectives: Ye
    });
  }
  onAudioTrackLoading(Z, ee) {
    const {
      id: ae,
      groupId: ve,
      url: ye,
      deliveryDirectives: be
    } = ee;
    this.load({
      id: ae,
      groupId: ve,
      level: null,
      responseType: "text",
      type: PlaylistContextType.AUDIO_TRACK,
      url: ye,
      deliveryDirectives: be
    });
  }
  onSubtitleTrackLoading(Z, ee) {
    const {
      id: ae,
      groupId: ve,
      url: ye,
      deliveryDirectives: be
    } = ee;
    this.load({
      id: ae,
      groupId: ve,
      level: null,
      responseType: "text",
      type: PlaylistContextType.SUBTITLE_TRACK,
      url: ye,
      deliveryDirectives: be
    });
  }
  load(Z) {
    var ee;
    const ae = this.hls.config;
    let ve = this.getInternalLoader(Z);
    if (ve) {
      const Je = ve.context;
      if (Je && Je.url === Z.url && Je.level === Z.level) {
        logger.trace("[playlist-loader]: playlist request ongoing");
        return;
      }
      logger.log(`[playlist-loader]: aborting previous loader for type: ${Z.type}`), ve.abort();
    }
    let ye;
    if (Z.type === PlaylistContextType.MANIFEST ? ye = ae.manifestLoadPolicy.default : ye = _extends({}, ae.playlistLoadPolicy.default, {
      timeoutRetry: null,
      errorRetry: null
    }), ve = this.createInternalLoader(Z), isFiniteNumber((ee = Z.deliveryDirectives) == null ? void 0 : ee.part)) {
      let Je;
      if (Z.type === PlaylistContextType.LEVEL && Z.level !== null ? Je = this.hls.levels[Z.level].details : Z.type === PlaylistContextType.AUDIO_TRACK && Z.id !== null ? Je = this.hls.audioTracks[Z.id].details : Z.type === PlaylistContextType.SUBTITLE_TRACK && Z.id !== null && (Je = this.hls.subtitleTracks[Z.id].details), Je) {
        const nt = Je.partTarget, st = Je.targetduration;
        if (nt && st) {
          const ot = Math.max(nt * 3, st * 0.8) * 1e3;
          ye = _extends({}, ye, {
            maxTimeToFirstByteMs: Math.min(ot, ye.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(ot, ye.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const be = ye.errorRetry || ye.timeoutRetry || {}, Ye = {
      loadPolicy: ye,
      timeout: ye.maxLoadTimeMs,
      maxRetry: be.maxNumRetry || 0,
      retryDelay: be.retryDelayMs || 0,
      maxRetryDelay: be.maxRetryDelayMs || 0
    }, Qe = {
      onSuccess: (Je, nt, st, ot) => {
        const lt = this.getInternalLoader(st);
        this.resetInternalLoader(st.type);
        const ft = Je.data;
        if (ft.indexOf("#EXTM3U") !== 0) {
          this.handleManifestParsingError(Je, st, new Error("no EXTM3U delimiter"), ot || null, nt);
          return;
        }
        nt.parsing.start = performance.now(), M3U8Parser.isMediaPlaylist(ft) ? this.handleTrackOrLevelPlaylist(Je, nt, st, ot || null, lt) : this.handleMasterPlaylist(Je, nt, st, ot);
      },
      onError: (Je, nt, st, ot) => {
        this.handleNetworkError(nt, st, !1, Je, ot);
      },
      onTimeout: (Je, nt, st) => {
        this.handleNetworkError(nt, st, !0, void 0, Je);
      }
    };
    ve.load(Z, Ye, Qe);
  }
  handleMasterPlaylist(Z, ee, ae, ve) {
    const ye = this.hls, be = Z.data, Ye = getResponseUrl(Z, ae), Qe = M3U8Parser.parseMasterPlaylist(be, Ye);
    if (Qe.playlistParsingError) {
      this.handleManifestParsingError(Z, ae, Qe.playlistParsingError, ve, ee);
      return;
    }
    const {
      contentSteering: Je,
      levels: nt,
      sessionData: st,
      sessionKeys: ot,
      startTimeOffset: lt,
      variableList: ft
    } = Qe;
    this.variableList = ft;
    const {
      AUDIO: gt = [],
      SUBTITLES: ct,
      "CLOSED-CAPTIONS": _r
    } = M3U8Parser.parseMasterPlaylistMedia(be, Ye, Qe);
    gt.length && !gt.some((Xr) => !Xr.url) && nt[0].audioCodec && !nt[0].attrs.AUDIO && (logger.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), gt.unshift({
      type: "main",
      name: "main",
      groupId: "main",
      default: !1,
      autoselect: !1,
      forced: !1,
      id: -1,
      attrs: new AttrList({}),
      bitrate: 0,
      url: ""
    })), ye.trigger(Events.MANIFEST_LOADED, {
      levels: nt,
      audioTracks: gt,
      subtitles: ct,
      captions: _r,
      contentSteering: Je,
      url: Ye,
      stats: ee,
      networkDetails: ve,
      sessionData: st,
      sessionKeys: ot,
      startTimeOffset: lt,
      variableList: ft
    });
  }
  handleTrackOrLevelPlaylist(Z, ee, ae, ve, ye) {
    const be = this.hls, {
      id: Ye,
      level: Qe,
      type: Je
    } = ae, nt = getResponseUrl(Z, ae), st = 0, ot = isFiniteNumber(Qe) ? Qe : isFiniteNumber(Ye) ? Ye : 0, lt = mapContextToLevelType(ae), ft = M3U8Parser.parseLevelPlaylist(Z.data, nt, ot, lt, st, this.variableList);
    if (Je === PlaylistContextType.MANIFEST) {
      const gt = {
        attrs: new AttrList({}),
        bitrate: 0,
        details: ft,
        name: "",
        url: nt
      };
      be.trigger(Events.MANIFEST_LOADED, {
        levels: [gt],
        audioTracks: [],
        url: nt,
        stats: ee,
        networkDetails: ve,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }
    ee.parsing.end = performance.now(), ae.levelDetails = ft, this.handlePlaylistLoaded(ft, Z, ee, ae, ve, ye);
  }
  handleManifestParsingError(Z, ee, ae, ve, ye) {
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.NETWORK_ERROR,
      details: ErrorDetails.MANIFEST_PARSING_ERROR,
      fatal: ee.type === PlaylistContextType.MANIFEST,
      url: Z.url,
      err: ae,
      error: ae,
      reason: ae.message,
      response: Z,
      context: ee,
      networkDetails: ve,
      stats: ye
    });
  }
  handleNetworkError(Z, ee, ae = !1, ve, ye) {
    let be = `A network ${ae ? "timeout" : "error" + (ve ? " (status " + ve.code + ")" : "")} occurred while loading ${Z.type}`;
    Z.type === PlaylistContextType.LEVEL ? be += `: ${Z.level} id: ${Z.id}` : (Z.type === PlaylistContextType.AUDIO_TRACK || Z.type === PlaylistContextType.SUBTITLE_TRACK) && (be += ` id: ${Z.id} group-id: "${Z.groupId}"`);
    const Ye = new Error(be);
    logger.warn(`[playlist-loader]: ${be}`);
    let Qe = ErrorDetails.UNKNOWN, Je = !1;
    const nt = this.getInternalLoader(Z);
    switch (Z.type) {
      case PlaylistContextType.MANIFEST:
        Qe = ae ? ErrorDetails.MANIFEST_LOAD_TIMEOUT : ErrorDetails.MANIFEST_LOAD_ERROR, Je = !0;
        break;
      case PlaylistContextType.LEVEL:
        Qe = ae ? ErrorDetails.LEVEL_LOAD_TIMEOUT : ErrorDetails.LEVEL_LOAD_ERROR, Je = !1;
        break;
      case PlaylistContextType.AUDIO_TRACK:
        Qe = ae ? ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : ErrorDetails.AUDIO_TRACK_LOAD_ERROR, Je = !1;
        break;
      case PlaylistContextType.SUBTITLE_TRACK:
        Qe = ae ? ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : ErrorDetails.SUBTITLE_LOAD_ERROR, Je = !1;
        break;
    }
    nt && this.resetInternalLoader(Z.type);
    const st = {
      type: ErrorTypes.NETWORK_ERROR,
      details: Qe,
      fatal: Je,
      url: Z.url,
      loader: nt,
      context: Z,
      error: Ye,
      networkDetails: ee,
      stats: ye
    };
    if (ve) {
      const ot = (ee == null ? void 0 : ee.url) || Z.url;
      st.response = _objectSpread2({
        url: ot,
        data: void 0
      }, ve);
    }
    this.hls.trigger(Events.ERROR, st);
  }
  handlePlaylistLoaded(Z, ee, ae, ve, ye, be) {
    const Ye = this.hls, {
      type: Qe,
      level: Je,
      id: nt,
      groupId: st,
      deliveryDirectives: ot
    } = ve, lt = getResponseUrl(ee, ve), ft = mapContextToLevelType(ve), gt = typeof ve.level == "number" && ft === PlaylistLevelType.MAIN ? Je : void 0;
    if (!Z.fragments.length) {
      const _r = new Error("No Segments found in Playlist");
      Ye.trigger(Events.ERROR, {
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.LEVEL_EMPTY_ERROR,
        fatal: !1,
        url: lt,
        error: _r,
        reason: _r.message,
        response: ee,
        context: ve,
        level: gt,
        parent: ft,
        networkDetails: ye,
        stats: ae
      });
      return;
    }
    Z.targetduration || (Z.playlistParsingError = new Error("Missing Target Duration"));
    const ct = Z.playlistParsingError;
    if (ct) {
      Ye.trigger(Events.ERROR, {
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.LEVEL_PARSING_ERROR,
        fatal: !1,
        url: lt,
        error: ct,
        reason: ct.message,
        response: ee,
        context: ve,
        level: gt,
        parent: ft,
        networkDetails: ye,
        stats: ae
      });
      return;
    }
    switch (Z.live && be && (be.getCacheAge && (Z.ageHeader = be.getCacheAge() || 0), (!be.getCacheAge || isNaN(Z.ageHeader)) && (Z.ageHeader = 0)), Qe) {
      case PlaylistContextType.MANIFEST:
      case PlaylistContextType.LEVEL:
        Ye.trigger(Events.LEVEL_LOADED, {
          details: Z,
          level: gt || 0,
          id: nt || 0,
          stats: ae,
          networkDetails: ye,
          deliveryDirectives: ot
        });
        break;
      case PlaylistContextType.AUDIO_TRACK:
        Ye.trigger(Events.AUDIO_TRACK_LOADED, {
          details: Z,
          id: nt || 0,
          groupId: st || "",
          stats: ae,
          networkDetails: ye,
          deliveryDirectives: ot
        });
        break;
      case PlaylistContextType.SUBTITLE_TRACK:
        Ye.trigger(Events.SUBTITLE_TRACK_LOADED, {
          details: Z,
          id: nt || 0,
          groupId: st || "",
          stats: ae,
          networkDetails: ye,
          deliveryDirectives: ot
        });
        break;
    }
  }
}
function sendAddTrackEvent(ie, Z) {
  let ee;
  try {
    ee = new Event("addtrack");
  } catch {
    ee = document.createEvent("Event"), ee.initEvent("addtrack", !1, !1);
  }
  ee.track = ie, Z.dispatchEvent(ee);
}
function addCueToTrack(ie, Z) {
  const ee = ie.mode;
  if (ee === "disabled" && (ie.mode = "hidden"), ie.cues && !ie.cues.getCueById(Z.id))
    try {
      if (ie.addCue(Z), !ie.cues.getCueById(Z.id))
        throw new Error(`addCue is failed for: ${Z}`);
    } catch (ae) {
      logger.debug(`[texttrack-utils]: ${ae}`);
      try {
        const ve = new self.TextTrackCue(Z.startTime, Z.endTime, Z.text);
        ve.id = Z.id, ie.addCue(ve);
      } catch (ve) {
        logger.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${ve}`);
      }
    }
  ee === "disabled" && (ie.mode = ee);
}
function clearCurrentCues(ie) {
  const Z = ie.mode;
  if (Z === "disabled" && (ie.mode = "hidden"), ie.cues)
    for (let ee = ie.cues.length; ee--; )
      ie.removeCue(ie.cues[ee]);
  Z === "disabled" && (ie.mode = Z);
}
function removeCuesInRange(ie, Z, ee, ae) {
  const ve = ie.mode;
  if (ve === "disabled" && (ie.mode = "hidden"), ie.cues && ie.cues.length > 0) {
    const ye = getCuesInRange(ie.cues, Z, ee);
    for (let be = 0; be < ye.length; be++)
      (!ae || ae(ye[be])) && ie.removeCue(ye[be]);
  }
  ve === "disabled" && (ie.mode = ve);
}
function getFirstCueIndexAfterTime(ie, Z) {
  if (Z < ie[0].startTime)
    return 0;
  const ee = ie.length - 1;
  if (Z > ie[ee].endTime)
    return -1;
  let ae = 0, ve = ee;
  for (; ae <= ve; ) {
    const ye = Math.floor((ve + ae) / 2);
    if (Z < ie[ye].startTime)
      ve = ye - 1;
    else if (Z > ie[ye].startTime && ae < ee)
      ae = ye + 1;
    else
      return ye;
  }
  return ie[ae].startTime - Z < Z - ie[ve].startTime ? ae : ve;
}
function getCuesInRange(ie, Z, ee) {
  const ae = [], ve = getFirstCueIndexAfterTime(ie, Z);
  if (ve > -1)
    for (let ye = ve, be = ie.length; ye < be; ye++) {
      const Ye = ie[ye];
      if (Ye.startTime >= Z && Ye.endTime <= ee)
        ae.push(Ye);
      else if (Ye.startTime > ee)
        return ae;
    }
  return ae;
}
function filterSubtitleTracks(ie) {
  const Z = [];
  for (let ee = 0; ee < ie.length; ee++) {
    const ae = ie[ee];
    (ae.kind === "subtitles" || ae.kind === "captions") && ae.label && Z.push(ie[ee]);
  }
  return Z;
}
var MetadataSchema = {
  audioId3: "org.id3",
  dateRange: "com.apple.quicktime.HLS",
  emsg: "https://aomedia.org/emsg/ID3"
};
const MIN_CUE_DURATION = 0.25;
function getCueClass() {
  if (!(typeof self > "u"))
    return self.VTTCue || self.TextTrackCue;
}
function createCueWithDataFields(ie, Z, ee, ae, ve) {
  let ye = new ie(Z, ee, "");
  try {
    ye.value = ae, ve && (ye.type = ve);
  } catch {
    ye = new ie(Z, ee, JSON.stringify(ve ? _objectSpread2({
      type: ve
    }, ae) : ae));
  }
  return ye;
}
const MAX_CUE_ENDTIME = (() => {
  const ie = getCueClass();
  try {
    ie && new ie(0, Number.POSITIVE_INFINITY, "");
  } catch {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function dateRangeDateToTimelineSeconds(ie, Z) {
  return ie.getTime() / 1e3 - Z;
}
function hexToArrayBuffer(ie) {
  return Uint8Array.from(ie.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
class ID3TrackController {
  constructor(Z) {
    this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = Z, this._registerListeners();
  }
  destroy() {
    this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = null;
  }
  _registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), Z.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this), Z.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), Z.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this), Z.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  // Add ID3 metatadata text track.
  onMediaAttached(Z, ee) {
    this.media = ee.media;
  }
  onMediaDetaching() {
    this.id3Track && (clearCurrentCues(this.id3Track), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {});
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(Z) {
    const ee = this.getID3Track(Z.textTracks);
    return ee.mode = "hidden", ee;
  }
  getID3Track(Z) {
    if (this.media) {
      for (let ee = 0; ee < Z.length; ee++) {
        const ae = Z[ee];
        if (ae.kind === "metadata" && ae.label === "id3")
          return sendAddTrackEvent(ae, this.media), ae;
      }
      return this.media.addTextTrack("metadata", "id3");
    }
  }
  onFragParsingMetadata(Z, ee) {
    if (!this.media)
      return;
    const {
      hls: {
        config: {
          enableEmsgMetadataCues: ae,
          enableID3MetadataCues: ve
        }
      }
    } = this;
    if (!ae && !ve)
      return;
    const {
      samples: ye
    } = ee;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const be = getCueClass();
    if (be)
      for (let Ye = 0; Ye < ye.length; Ye++) {
        const Qe = ye[Ye].type;
        if (Qe === MetadataSchema.emsg && !ae || !ve)
          continue;
        const Je = getID3Frames(ye[Ye].data);
        if (Je) {
          const nt = ye[Ye].pts;
          let st = nt + ye[Ye].duration;
          st > MAX_CUE_ENDTIME && (st = MAX_CUE_ENDTIME), st - nt <= 0 && (st = nt + MIN_CUE_DURATION);
          for (let lt = 0; lt < Je.length; lt++) {
            const ft = Je[lt];
            if (!isTimeStampFrame(ft)) {
              this.updateId3CueEnds(nt, Qe);
              const gt = createCueWithDataFields(be, nt, st, ft, Qe);
              gt && this.id3Track.addCue(gt);
            }
          }
        }
      }
  }
  updateId3CueEnds(Z, ee) {
    var ae;
    const ve = (ae = this.id3Track) == null ? void 0 : ae.cues;
    if (ve)
      for (let ye = ve.length; ye--; ) {
        const be = ve[ye];
        be.type === ee && be.startTime < Z && be.endTime === MAX_CUE_ENDTIME && (be.endTime = Z);
      }
  }
  onBufferFlushing(Z, {
    startOffset: ee,
    endOffset: ae,
    type: ve
  }) {
    const {
      id3Track: ye,
      hls: be
    } = this;
    if (!be)
      return;
    const {
      config: {
        enableEmsgMetadataCues: Ye,
        enableID3MetadataCues: Qe
      }
    } = be;
    if (ye && (Ye || Qe)) {
      let Je;
      ve === "audio" ? Je = (nt) => nt.type === MetadataSchema.audioId3 && Qe : ve === "video" ? Je = (nt) => nt.type === MetadataSchema.emsg && Ye : Je = (nt) => nt.type === MetadataSchema.audioId3 && Qe || nt.type === MetadataSchema.emsg && Ye, removeCuesInRange(ye, ee, ae, Je);
    }
  }
  onLevelUpdated(Z, {
    details: ee
  }) {
    if (!this.media || !ee.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues)
      return;
    const {
      dateRangeCuesAppended: ae,
      id3Track: ve
    } = this, {
      dateRanges: ye
    } = ee, be = Object.keys(ye);
    if (ve) {
      const nt = Object.keys(ae).filter((st) => !be.includes(st));
      for (let st = nt.length; st--; ) {
        const ot = nt[st];
        Object.keys(ae[ot].cues).forEach((lt) => {
          ve.removeCue(ae[ot].cues[lt]);
        }), delete ae[ot];
      }
    }
    const Ye = ee.fragments[ee.fragments.length - 1];
    if (be.length === 0 || !isFiniteNumber(Ye == null ? void 0 : Ye.programDateTime))
      return;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const Qe = Ye.programDateTime / 1e3 - Ye.start, Je = getCueClass();
    for (let nt = 0; nt < be.length; nt++) {
      const st = be[nt], ot = ye[st], lt = dateRangeDateToTimelineSeconds(ot.startDate, Qe), ft = ae[st], gt = (ft == null ? void 0 : ft.cues) || {};
      let ct = (ft == null ? void 0 : ft.durationKnown) || !1, _r = MAX_CUE_ENDTIME;
      const Kr = ot.endDate;
      if (Kr)
        _r = dateRangeDateToTimelineSeconds(Kr, Qe), ct = !0;
      else if (ot.endOnNext && !ct) {
        const Jr = be.reduce((ei, si) => {
          if (si !== ot.id) {
            const ri = ye[si];
            if (ri.class === ot.class && ri.startDate > ot.startDate && (!ei || ot.startDate < ei.startDate))
              return ri;
          }
          return ei;
        }, null);
        Jr && (_r = dateRangeDateToTimelineSeconds(Jr.startDate, Qe), ct = !0);
      }
      const Xr = Object.keys(ot.attr);
      for (let Jr = 0; Jr < Xr.length; Jr++) {
        const ei = Xr[Jr];
        if (!isDateRangeCueAttribute(ei))
          continue;
        const si = gt[ei];
        if (si)
          ct && !ft.durationKnown && (si.endTime = _r);
        else if (Je) {
          let ri = ot.attr[ei];
          isSCTE35Attribute(ei) && (ri = hexToArrayBuffer(ri));
          const ai = createCueWithDataFields(Je, lt, _r, {
            key: ei,
            data: ri
          }, MetadataSchema.dateRange);
          ai && (ai.id = st, this.id3Track.addCue(ai), gt[ei] = ai);
        }
      }
      ae[st] = {
        cues: gt,
        dateRange: ot,
        durationKnown: ct
      };
    }
  }
}
class LatencyController {
  constructor(Z) {
    this.hls = void 0, this.config = void 0, this.media = null, this.levelDetails = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this.timeupdateHandler = () => this.timeupdate(), this.hls = Z, this.config = Z.config, this.registerListeners();
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config: Z,
      levelDetails: ee
    } = this;
    return Z.liveMaxLatencyDuration !== void 0 ? Z.liveMaxLatencyDuration : ee ? Z.liveMaxLatencyDurationCount * ee.targetduration : 0;
  }
  get targetLatency() {
    const {
      levelDetails: Z
    } = this;
    if (Z === null)
      return null;
    const {
      holdBack: ee,
      partHoldBack: ae,
      targetduration: ve
    } = Z, {
      liveSyncDuration: ye,
      liveSyncDurationCount: be,
      lowLatencyMode: Ye
    } = this.config, Qe = this.hls.userConfig;
    let Je = Ye && ae || ee;
    (Qe.liveSyncDuration || Qe.liveSyncDurationCount || Je === 0) && (Je = ye !== void 0 ? ye : be * ve);
    const nt = ve;
    return Je + Math.min(this.stallCount * 1, nt);
  }
  get liveSyncPosition() {
    const Z = this.estimateLiveEdge(), ee = this.targetLatency, ae = this.levelDetails;
    if (Z === null || ee === null || ae === null)
      return null;
    const ve = ae.edge, ye = Z - ee - this.edgeStalled, be = ve - ae.totalduration, Ye = ve - (this.config.lowLatencyMode && ae.partTarget || ae.targetduration);
    return Math.min(Math.max(be, ye), Ye);
  }
  get drift() {
    const {
      levelDetails: Z
    } = this;
    return Z === null ? 1 : Z.drift;
  }
  get edgeStalled() {
    const {
      levelDetails: Z
    } = this;
    if (Z === null)
      return 0;
    const ee = (this.config.lowLatencyMode && Z.partTarget || Z.targetduration) * 3;
    return Math.max(Z.age - ee, 0);
  }
  get forwardBufferLength() {
    const {
      media: Z,
      levelDetails: ee
    } = this;
    if (!Z || !ee)
      return 0;
    const ae = Z.buffered.length;
    return (ae ? Z.buffered.end(ae - 1) : ee.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetaching(), this.levelDetails = null, this.hls = this.timeupdateHandler = null;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.off(Events.ERROR, this.onError, this);
  }
  onMediaAttached(Z, ee) {
    this.media = ee.media, this.media.addEventListener("timeupdate", this.timeupdateHandler);
  }
  onMediaDetaching() {
    this.media && (this.media.removeEventListener("timeupdate", this.timeupdateHandler), this.media = null);
  }
  onManifestLoading() {
    this.levelDetails = null, this._latency = null, this.stallCount = 0;
  }
  onLevelUpdated(Z, {
    details: ee
  }) {
    this.levelDetails = ee, ee.advanced && this.timeupdate(), !ee.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
  }
  onError(Z, ee) {
    var ae;
    ee.details === ErrorDetails.BUFFER_STALLED_ERROR && (this.stallCount++, (ae = this.levelDetails) != null && ae.live && logger.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
  }
  timeupdate() {
    const {
      media: Z,
      levelDetails: ee
    } = this;
    if (!Z || !ee)
      return;
    this.currentTime = Z.currentTime;
    const ae = this.computeLatency();
    if (ae === null)
      return;
    this._latency = ae;
    const {
      lowLatencyMode: ve,
      maxLiveSyncPlaybackRate: ye
    } = this.config;
    if (!ve || ye === 1 || !ee.live)
      return;
    const be = this.targetLatency;
    if (be === null)
      return;
    const Ye = ae - be, Qe = Math.min(this.maxLatency, be + ee.targetduration);
    if (Ye < Qe && Ye > 0.05 && this.forwardBufferLength > 1) {
      const nt = Math.min(2, Math.max(1, ye)), st = Math.round(2 / (1 + Math.exp(-0.75 * Ye - this.edgeStalled)) * 20) / 20;
      Z.playbackRate = Math.min(nt, Math.max(1, st));
    } else
      Z.playbackRate !== 1 && Z.playbackRate !== 0 && (Z.playbackRate = 1);
  }
  estimateLiveEdge() {
    const {
      levelDetails: Z
    } = this;
    return Z === null ? null : Z.edge + Z.age;
  }
  computeLatency() {
    const Z = this.estimateLiveEdge();
    return Z === null ? null : Z - this.currentTime;
  }
}
const HdcpLevels = ["NONE", "TYPE-0", "TYPE-1", null];
function isHdcpLevel(ie) {
  return HdcpLevels.indexOf(ie) > -1;
}
const VideoRangeValues = ["SDR", "PQ", "HLG"];
function isVideoRange(ie) {
  return !!ie && VideoRangeValues.indexOf(ie) > -1;
}
var HlsSkip = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function getSkipValue(ie, Z) {
  const {
    canSkipUntil: ee,
    canSkipDateRanges: ae,
    endSN: ve
  } = ie, ye = Z !== void 0 ? Z - ve : 0;
  return ee && ye < ee ? ae ? HlsSkip.v2 : HlsSkip.Yes : HlsSkip.No;
}
class HlsUrlParameters {
  constructor(Z, ee, ae) {
    this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = Z, this.part = ee, this.skip = ae;
  }
  addDirectives(Z) {
    const ee = new self.URL(Z);
    return this.msn !== void 0 && ee.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && ee.searchParams.set("_HLS_part", this.part.toString()), this.skip && ee.searchParams.set("_HLS_skip", this.skip), ee.href;
  }
}
class Level {
  constructor(Z) {
    this._attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.url = void 0, this.frameRate = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.videoCodec = void 0, this.width = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.supportedPromise = void 0, this.supportedResult = void 0, this._avgBitrate = 0, this._audioGroups = void 0, this._subtitleGroups = void 0, this._urlId = 0, this.url = [Z.url], this._attrs = [Z.attrs], this.bitrate = Z.bitrate, Z.details && (this.details = Z.details), this.id = Z.id || 0, this.name = Z.name, this.width = Z.width || 0, this.height = Z.height || 0, this.frameRate = Z.attrs.optionalFloat("FRAME-RATE", 0), this._avgBitrate = Z.attrs.decimalInteger("AVERAGE-BANDWIDTH"), this.audioCodec = Z.audioCodec, this.videoCodec = Z.videoCodec, this.codecSet = [Z.videoCodec, Z.audioCodec].filter((ee) => !!ee).map((ee) => ee.substring(0, 4)).join(","), this.addGroupId("audio", Z.attrs.AUDIO), this.addGroupId("text", Z.attrs.SUBTITLES);
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[0];
  }
  get codecs() {
    return this.attrs.CODECS || "";
  }
  get pathwayId() {
    return this.attrs["PATHWAY-ID"] || ".";
  }
  get videoRange() {
    return this.attrs["VIDEO-RANGE"] || "SDR";
  }
  get score() {
    return this.attrs.optionalFloat("SCORE", 0);
  }
  get uri() {
    return this.url[0] || "";
  }
  hasAudioGroup(Z) {
    return hasGroup(this._audioGroups, Z);
  }
  hasSubtitleGroup(Z) {
    return hasGroup(this._subtitleGroups, Z);
  }
  get audioGroups() {
    return this._audioGroups;
  }
  get subtitleGroups() {
    return this._subtitleGroups;
  }
  addGroupId(Z, ee) {
    if (ee) {
      if (Z === "audio") {
        let ae = this._audioGroups;
        ae || (ae = this._audioGroups = []), ae.indexOf(ee) === -1 && ae.push(ee);
      } else if (Z === "text") {
        let ae = this._subtitleGroups;
        ae || (ae = this._subtitleGroups = []), ae.indexOf(ee) === -1 && ae.push(ee);
      }
    }
  }
  // Deprecated methods (retained for backwards compatibility)
  get urlId() {
    return 0;
  }
  set urlId(Z) {
  }
  get audioGroupIds() {
    return this.audioGroups ? [this.audioGroupId] : void 0;
  }
  get textGroupIds() {
    return this.subtitleGroups ? [this.textGroupId] : void 0;
  }
  get audioGroupId() {
    var Z;
    return (Z = this.audioGroups) == null ? void 0 : Z[0];
  }
  get textGroupId() {
    var Z;
    return (Z = this.subtitleGroups) == null ? void 0 : Z[0];
  }
  addFallback() {
  }
}
function hasGroup(ie, Z) {
  return !Z || !ie ? !1 : ie.indexOf(Z) !== -1;
}
function updateFromToPTS(ie, Z) {
  const ee = Z.startPTS;
  if (isFiniteNumber(ee)) {
    let ae = 0, ve;
    Z.sn > ie.sn ? (ae = ee - ie.start, ve = ie) : (ae = ie.start - ee, ve = Z), ve.duration !== ae && (ve.duration = ae);
  } else
    Z.sn > ie.sn ? ie.cc === Z.cc && ie.minEndPTS ? Z.start = ie.start + (ie.minEndPTS - ie.start) : Z.start = ie.start + ie.duration : Z.start = Math.max(ie.start - Z.duration, 0);
}
function updateFragPTSDTS(ie, Z, ee, ae, ve, ye) {
  ae - ee <= 0 && (logger.warn("Fragment should have a positive duration", Z), ae = ee + Z.duration, ye = ve + Z.duration);
  let Ye = ee, Qe = ae;
  const Je = Z.startPTS, nt = Z.endPTS;
  if (isFiniteNumber(Je)) {
    const ct = Math.abs(Je - ee);
    isFiniteNumber(Z.deltaPTS) ? Z.deltaPTS = Math.max(ct, Z.deltaPTS) : Z.deltaPTS = ct, Ye = Math.max(ee, Je), ee = Math.min(ee, Je), ve = Math.min(ve, Z.startDTS), Qe = Math.min(ae, nt), ae = Math.max(ae, nt), ye = Math.max(ye, Z.endDTS);
  }
  const st = ee - Z.start;
  Z.start !== 0 && (Z.start = ee), Z.duration = ae - Z.start, Z.startPTS = ee, Z.maxStartPTS = Ye, Z.startDTS = ve, Z.endPTS = ae, Z.minEndPTS = Qe, Z.endDTS = ye;
  const ot = Z.sn;
  if (!ie || ot < ie.startSN || ot > ie.endSN)
    return 0;
  let lt;
  const ft = ot - ie.startSN, gt = ie.fragments;
  for (gt[ft] = Z, lt = ft; lt > 0; lt--)
    updateFromToPTS(gt[lt], gt[lt - 1]);
  for (lt = ft; lt < gt.length - 1; lt++)
    updateFromToPTS(gt[lt], gt[lt + 1]);
  return ie.fragmentHint && updateFromToPTS(gt[gt.length - 1], ie.fragmentHint), ie.PTSKnown = ie.alignedSliding = !0, st;
}
function mergeDetails(ie, Z) {
  let ee = null;
  const ae = ie.fragments;
  for (let Qe = ae.length - 1; Qe >= 0; Qe--) {
    const Je = ae[Qe].initSegment;
    if (Je) {
      ee = Je;
      break;
    }
  }
  ie.fragmentHint && delete ie.fragmentHint.endPTS;
  let ve = 0, ye;
  if (mapFragmentIntersection(ie, Z, (Qe, Je) => {
    Qe.relurl && (ve = Qe.cc - Je.cc), isFiniteNumber(Qe.startPTS) && isFiniteNumber(Qe.endPTS) && (Je.start = Je.startPTS = Qe.startPTS, Je.startDTS = Qe.startDTS, Je.maxStartPTS = Qe.maxStartPTS, Je.endPTS = Qe.endPTS, Je.endDTS = Qe.endDTS, Je.minEndPTS = Qe.minEndPTS, Je.duration = Qe.endPTS - Qe.startPTS, Je.duration && (ye = Je), Z.PTSKnown = Z.alignedSliding = !0), Je.elementaryStreams = Qe.elementaryStreams, Je.loader = Qe.loader, Je.stats = Qe.stats, Qe.initSegment && (Je.initSegment = Qe.initSegment, ee = Qe.initSegment);
  }), ee && (Z.fragmentHint ? Z.fragments.concat(Z.fragmentHint) : Z.fragments).forEach((Je) => {
    var nt;
    Je && (!Je.initSegment || Je.initSegment.relurl === ((nt = ee) == null ? void 0 : nt.relurl)) && (Je.initSegment = ee);
  }), Z.skippedSegments)
    if (Z.deltaUpdateFailed = Z.fragments.some((Qe) => !Qe), Z.deltaUpdateFailed) {
      logger.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
      for (let Qe = Z.skippedSegments; Qe--; )
        Z.fragments.shift();
      Z.startSN = Z.fragments[0].sn, Z.startCC = Z.fragments[0].cc;
    } else
      Z.canSkipDateRanges && (Z.dateRanges = mergeDateRanges(ie.dateRanges, Z.dateRanges, Z.recentlyRemovedDateranges));
  const be = Z.fragments;
  if (ve) {
    logger.warn("discontinuity sliding from playlist, take drift into account");
    for (let Qe = 0; Qe < be.length; Qe++)
      be[Qe].cc += ve;
  }
  Z.skippedSegments && (Z.startCC = Z.fragments[0].cc), mapPartIntersection(ie.partList, Z.partList, (Qe, Je) => {
    Je.elementaryStreams = Qe.elementaryStreams, Je.stats = Qe.stats;
  }), ye ? updateFragPTSDTS(Z, ye, ye.startPTS, ye.endPTS, ye.startDTS, ye.endDTS) : adjustSliding(ie, Z), be.length && (Z.totalduration = Z.edge - be[0].start), Z.driftStartTime = ie.driftStartTime, Z.driftStart = ie.driftStart;
  const Ye = Z.advancedDateTime;
  if (Z.advanced && Ye) {
    const Qe = Z.edge;
    Z.driftStart || (Z.driftStartTime = Ye, Z.driftStart = Qe), Z.driftEndTime = Ye, Z.driftEnd = Qe;
  } else
    Z.driftEndTime = ie.driftEndTime, Z.driftEnd = ie.driftEnd, Z.advancedDateTime = ie.advancedDateTime;
}
function mergeDateRanges(ie, Z, ee) {
  const ae = _extends({}, ie);
  return ee && ee.forEach((ve) => {
    delete ae[ve];
  }), Object.keys(Z).forEach((ve) => {
    const ye = new DateRange(Z[ve].attr, ae[ve]);
    ye.isValid ? ae[ve] = ye : logger.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(Z[ve].attr)}"`);
  }), ae;
}
function mapPartIntersection(ie, Z, ee) {
  if (ie && Z) {
    let ae = 0;
    for (let ve = 0, ye = ie.length; ve <= ye; ve++) {
      const be = ie[ve], Ye = Z[ve + ae];
      be && Ye && be.index === Ye.index && be.fragment.sn === Ye.fragment.sn ? ee(be, Ye) : ae--;
    }
  }
}
function mapFragmentIntersection(ie, Z, ee) {
  const ae = Z.skippedSegments, ve = Math.max(ie.startSN, Z.startSN) - Z.startSN, ye = (ie.fragmentHint ? 1 : 0) + (ae ? Z.endSN : Math.min(ie.endSN, Z.endSN)) - Z.startSN, be = Z.startSN - ie.startSN, Ye = Z.fragmentHint ? Z.fragments.concat(Z.fragmentHint) : Z.fragments, Qe = ie.fragmentHint ? ie.fragments.concat(ie.fragmentHint) : ie.fragments;
  for (let Je = ve; Je <= ye; Je++) {
    const nt = Qe[be + Je];
    let st = Ye[Je];
    ae && !st && Je < ae && (st = Z.fragments[Je] = nt), nt && st && ee(nt, st);
  }
}
function adjustSliding(ie, Z) {
  const ee = Z.startSN + Z.skippedSegments - ie.startSN, ae = ie.fragments;
  ee < 0 || ee >= ae.length || addSliding(Z, ae[ee].start);
}
function addSliding(ie, Z) {
  if (Z) {
    const ee = ie.fragments;
    for (let ae = ie.skippedSegments; ae < ee.length; ae++)
      ee[ae].start += Z;
    ie.fragmentHint && (ie.fragmentHint.start += Z);
  }
}
function computeReloadInterval(ie, Z = 1 / 0) {
  let ee = 1e3 * ie.targetduration;
  if (ie.updated) {
    const ae = ie.fragments;
    if (ae.length && ee * 4 > Z) {
      const ye = ae[ae.length - 1].duration * 1e3;
      ye < ee && (ee = ye);
    }
  } else
    ee /= 2;
  return Math.round(ee);
}
function getFragmentWithSN(ie, Z, ee) {
  if (!(ie != null && ie.details))
    return null;
  const ae = ie.details;
  let ve = ae.fragments[Z - ae.startSN];
  return ve || (ve = ae.fragmentHint, ve && ve.sn === Z) ? ve : Z < ae.startSN && ee && ee.sn === Z ? ee : null;
}
function getPartWith(ie, Z, ee) {
  var ae;
  return ie != null && ie.details ? findPart((ae = ie.details) == null ? void 0 : ae.partList, Z, ee) : null;
}
function findPart(ie, Z, ee) {
  if (ie)
    for (let ae = ie.length; ae--; ) {
      const ve = ie[ae];
      if (ve.index === ee && ve.fragment.sn === Z)
        return ve;
    }
  return null;
}
function reassignFragmentLevelIndexes(ie) {
  ie.forEach((Z, ee) => {
    const {
      details: ae
    } = Z;
    ae != null && ae.fragments && ae.fragments.forEach((ve) => {
      ve.level = ee;
    });
  });
}
function isTimeoutError(ie) {
  switch (ie.details) {
    case ErrorDetails.FRAG_LOAD_TIMEOUT:
    case ErrorDetails.KEY_LOAD_TIMEOUT:
    case ErrorDetails.LEVEL_LOAD_TIMEOUT:
    case ErrorDetails.MANIFEST_LOAD_TIMEOUT:
      return !0;
  }
  return !1;
}
function getRetryConfig(ie, Z) {
  const ee = isTimeoutError(Z);
  return ie.default[`${ee ? "timeout" : "error"}Retry`];
}
function getRetryDelay(ie, Z) {
  const ee = ie.backoff === "linear" ? 1 : Math.pow(2, Z);
  return Math.min(ee * ie.retryDelayMs, ie.maxRetryDelayMs);
}
function getLoaderConfigWithoutReties(ie) {
  return _objectSpread2(_objectSpread2({}, ie), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function shouldRetry(ie, Z, ee, ae) {
  if (!ie)
    return !1;
  const ve = ae == null ? void 0 : ae.code, ye = Z < ie.maxNumRetry && (retryForHttpStatus(ve) || !!ee);
  return ie.shouldRetry ? ie.shouldRetry(ie, Z, ee, ae, ye) : ye;
}
function retryForHttpStatus(ie) {
  return ie === 0 && navigator.onLine === !1 || !!ie && (ie < 400 || ie > 499);
}
const BinarySearch = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function(ie, Z) {
    let ee = 0, ae = ie.length - 1, ve = null, ye = null;
    for (; ee <= ae; ) {
      ve = (ee + ae) / 2 | 0, ye = ie[ve];
      const be = Z(ye);
      if (be > 0)
        ee = ve + 1;
      else if (be < 0)
        ae = ve - 1;
      else
        return ye;
    }
    return null;
  }
};
function findFragmentByPDT(ie, Z, ee) {
  if (Z === null || !Array.isArray(ie) || !ie.length || !isFiniteNumber(Z))
    return null;
  const ae = ie[0].programDateTime;
  if (Z < (ae || 0))
    return null;
  const ve = ie[ie.length - 1].endProgramDateTime;
  if (Z >= (ve || 0))
    return null;
  ee = ee || 0;
  for (let ye = 0; ye < ie.length; ++ye) {
    const be = ie[ye];
    if (pdtWithinToleranceTest(Z, ee, be))
      return be;
  }
  return null;
}
function findFragmentByPTS(ie, Z, ee = 0, ae = 0) {
  let ve = null;
  if (ie) {
    ve = Z[ie.sn - Z[0].sn + 1] || null;
    const be = ie.endDTS - ee;
    be > 0 && be < 15e-7 && (ee += 15e-7);
  } else
    ee === 0 && Z[0].start === 0 && (ve = Z[0]);
  if (ve && (!ie || ie.level === ve.level) && fragmentWithinToleranceTest(ee, ae, ve) === 0)
    return ve;
  const ye = BinarySearch.search(Z, fragmentWithinToleranceTest.bind(null, ee, ae));
  return ye && (ye !== ie || !ve) ? ye : ve;
}
function fragmentWithinToleranceTest(ie = 0, Z = 0, ee) {
  if (ee.start <= ie && ee.start + ee.duration > ie)
    return 0;
  const ae = Math.min(Z, ee.duration + (ee.deltaPTS ? ee.deltaPTS : 0));
  return ee.start + ee.duration - ae <= ie ? 1 : ee.start - ae > ie && ee.start ? -1 : 0;
}
function pdtWithinToleranceTest(ie, Z, ee) {
  const ae = Math.min(Z, ee.duration + (ee.deltaPTS ? ee.deltaPTS : 0)) * 1e3;
  return (ee.endProgramDateTime || 0) - ae > ie;
}
function findFragWithCC(ie, Z) {
  return BinarySearch.search(ie, (ee) => ee.cc < Z ? 1 : ee.cc > Z ? -1 : 0);
}
var NetworkErrorAction = {
  DoNothing: 0,
  SendEndCallback: 1,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  InsertDiscontinuity: 4,
  RetryRequest: 5
}, ErrorActionFlags = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2,
  SwitchToSDR: 4
};
class ErrorController {
  constructor(Z) {
    this.hls = void 0, this.playlistError = 0, this.penalizedRenditions = {}, this.log = void 0, this.warn = void 0, this.error = void 0, this.hls = Z, this.log = logger.log.bind(logger, "[info]:"), this.warn = logger.warn.bind(logger, "[warning]:"), this.error = logger.error.bind(logger, "[error]:"), this.registerListeners();
  }
  registerListeners() {
    const Z = this.hls;
    Z.on(Events.ERROR, this.onError, this), Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const Z = this.hls;
    Z && (Z.off(Events.ERROR, this.onError, this), Z.off(Events.ERROR, this.onErrorOut, this), Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this));
  }
  destroy() {
    this.unregisterListeners(), this.hls = null, this.penalizedRenditions = {};
  }
  startLoad(Z) {
  }
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(Z) {
    return (Z == null ? void 0 : Z.type) === PlaylistLevelType.MAIN ? Z.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0, this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(Z, ee) {
    var ae, ve;
    if (ee.fatal)
      return;
    const ye = this.hls, be = ee.context;
    switch (ee.details) {
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        ee.errorAction = this.getFragRetryOrSwitchAction(ee);
        return;
      case ErrorDetails.FRAG_PARSING_ERROR:
        if ((ae = ee.frag) != null && ae.gap) {
          ee.errorAction = {
            action: NetworkErrorAction.DoNothing,
            flags: ErrorActionFlags.None
          };
          return;
        }
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_DECRYPT_ERROR: {
        ee.errorAction = this.getFragRetryOrSwitchAction(ee), ee.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
        return;
      }
      case ErrorDetails.LEVEL_EMPTY_ERROR:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        {
          var Ye, Qe;
          const Je = ee.parent === PlaylistLevelType.MAIN ? ee.level : ye.loadLevel;
          ee.details === ErrorDetails.LEVEL_EMPTY_ERROR && ((Ye = ee.context) != null && (Qe = Ye.levelDetails) != null && Qe.live) ? ee.errorAction = this.getPlaylistRetryOrSwitchAction(ee, Je) : (ee.levelRetry = !1, ee.errorAction = this.getLevelSwitchAction(ee, Je));
        }
        return;
      case ErrorDetails.LEVEL_LOAD_ERROR:
      case ErrorDetails.LEVEL_LOAD_TIMEOUT:
        typeof (be == null ? void 0 : be.level) == "number" && (ee.errorAction = this.getPlaylistRetryOrSwitchAction(ee, be.level));
        return;
      case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
      case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
      case ErrorDetails.SUBTITLE_LOAD_ERROR:
      case ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (be) {
          const Je = ye.levels[ye.loadLevel];
          if (Je && (be.type === PlaylistContextType.AUDIO_TRACK && Je.hasAudioGroup(be.groupId) || be.type === PlaylistContextType.SUBTITLE_TRACK && Je.hasSubtitleGroup(be.groupId))) {
            ee.errorAction = this.getPlaylistRetryOrSwitchAction(ee, ye.loadLevel), ee.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox, ee.errorAction.flags = ErrorActionFlags.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const Je = ye.levels[ye.loadLevel], nt = Je == null ? void 0 : Je.attrs["HDCP-LEVEL"];
          nt ? ee.errorAction = {
            action: NetworkErrorAction.SendAlternateToPenaltyBox,
            flags: ErrorActionFlags.MoveAllAlternatesMatchingHDCP,
            hdcpLevel: nt
          } : this.keySystemError(ee);
        }
        return;
      case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
      case ErrorDetails.REMUX_ALLOC_ERROR:
      case ErrorDetails.BUFFER_APPEND_ERROR:
        ee.errorAction = this.getLevelSwitchAction(ee, (ve = ee.level) != null ? ve : ye.loadLevel);
        return;
      case ErrorDetails.INTERNAL_EXCEPTION:
      case ErrorDetails.BUFFER_APPENDING_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
      case ErrorDetails.LEVEL_SWITCH_ERROR:
      case ErrorDetails.BUFFER_STALLED_ERROR:
      case ErrorDetails.BUFFER_SEEK_OVER_HOLE:
      case ErrorDetails.BUFFER_NUDGE_ON_STALL:
        ee.errorAction = {
          action: NetworkErrorAction.DoNothing,
          flags: ErrorActionFlags.None
        };
        return;
    }
    ee.type === ErrorTypes.KEY_SYSTEM_ERROR && this.keySystemError(ee);
  }
  keySystemError(Z) {
    const ee = this.getVariantLevelIndex(Z.frag);
    Z.levelRetry = !1, Z.errorAction = this.getLevelSwitchAction(Z, ee);
  }
  getPlaylistRetryOrSwitchAction(Z, ee) {
    const ae = this.hls, ve = getRetryConfig(ae.config.playlistLoadPolicy, Z), ye = this.playlistError++;
    if (shouldRetry(ve, ye, isTimeoutError(Z), Z.response))
      return {
        action: NetworkErrorAction.RetryRequest,
        flags: ErrorActionFlags.None,
        retryConfig: ve,
        retryCount: ye
      };
    const Ye = this.getLevelSwitchAction(Z, ee);
    return ve && (Ye.retryConfig = ve, Ye.retryCount = ye), Ye;
  }
  getFragRetryOrSwitchAction(Z) {
    const ee = this.hls, ae = this.getVariantLevelIndex(Z.frag), ve = ee.levels[ae], {
      fragLoadPolicy: ye,
      keyLoadPolicy: be
    } = ee.config, Ye = getRetryConfig(Z.details.startsWith("key") ? be : ye, Z), Qe = ee.levels.reduce((nt, st) => nt + st.fragmentError, 0);
    if (ve && (Z.details !== ErrorDetails.FRAG_GAP && ve.fragmentError++, shouldRetry(Ye, Qe, isTimeoutError(Z), Z.response)))
      return {
        action: NetworkErrorAction.RetryRequest,
        flags: ErrorActionFlags.None,
        retryConfig: Ye,
        retryCount: Qe
      };
    const Je = this.getLevelSwitchAction(Z, ae);
    return Ye && (Je.retryConfig = Ye, Je.retryCount = Qe), Je;
  }
  getLevelSwitchAction(Z, ee) {
    const ae = this.hls;
    ee == null && (ee = ae.loadLevel);
    const ve = this.hls.levels[ee];
    if (ve) {
      var ye, be;
      const Je = Z.details;
      ve.loadError++, Je === ErrorDetails.BUFFER_APPEND_ERROR && ve.fragmentError++;
      let nt = -1;
      const {
        levels: st,
        loadLevel: ot,
        minAutoLevel: lt,
        maxAutoLevel: ft
      } = ae;
      ae.autoLevelEnabled || (ae.loadLevel = -1);
      const gt = (ye = Z.frag) == null ? void 0 : ye.type, _r = (gt === PlaylistLevelType.AUDIO && Je === ErrorDetails.FRAG_PARSING_ERROR || Z.sourceBufferName === "audio" && (Je === ErrorDetails.BUFFER_ADD_CODEC_ERROR || Je === ErrorDetails.BUFFER_APPEND_ERROR)) && st.some(({
        audioCodec: si
      }) => ve.audioCodec !== si), Xr = Z.sourceBufferName === "video" && (Je === ErrorDetails.BUFFER_ADD_CODEC_ERROR || Je === ErrorDetails.BUFFER_APPEND_ERROR) && st.some(({
        codecSet: si,
        audioCodec: ri
      }) => ve.codecSet !== si && ve.audioCodec === ri), {
        type: Jr,
        groupId: ei
      } = (be = Z.context) != null ? be : {};
      for (let si = st.length; si--; ) {
        const ri = (si + ot) % st.length;
        if (ri !== ot && ri >= lt && ri <= ft && st[ri].loadError === 0) {
          var Ye, Qe;
          const ai = st[ri];
          if (Je === ErrorDetails.FRAG_GAP && Z.frag) {
            const yi = st[ri].details;
            if (yi) {
              const pi = findFragmentByPTS(Z.frag, yi.fragments, Z.frag.start);
              if (pi != null && pi.gap)
                continue;
            }
          } else {
            if (Jr === PlaylistContextType.AUDIO_TRACK && ai.hasAudioGroup(ei) || Jr === PlaylistContextType.SUBTITLE_TRACK && ai.hasSubtitleGroup(ei))
              continue;
            if (gt === PlaylistLevelType.AUDIO && (Ye = ve.audioGroups) != null && Ye.some((yi) => ai.hasAudioGroup(yi)) || gt === PlaylistLevelType.SUBTITLE && (Qe = ve.subtitleGroups) != null && Qe.some((yi) => ai.hasSubtitleGroup(yi)) || _r && ve.audioCodec === ai.audioCodec || !_r && ve.audioCodec !== ai.audioCodec || Xr && ve.codecSet === ai.codecSet)
              continue;
          }
          nt = ri;
          break;
        }
      }
      if (nt > -1 && ae.loadLevel !== nt)
        return Z.levelRetry = !0, this.playlistError = 0, {
          action: NetworkErrorAction.SendAlternateToPenaltyBox,
          flags: ErrorActionFlags.None,
          nextAutoLevel: nt
        };
    }
    return {
      action: NetworkErrorAction.SendAlternateToPenaltyBox,
      flags: ErrorActionFlags.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(Z, ee) {
    var ae;
    switch ((ae = ee.errorAction) == null ? void 0 : ae.action) {
      case NetworkErrorAction.DoNothing:
        break;
      case NetworkErrorAction.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(ee), !ee.errorAction.resolved && ee.details !== ErrorDetails.FRAG_GAP ? ee.fatal = !0 : /MediaSource readyState: ended/.test(ee.error.message) && (this.warn(`MediaSource ended after "${ee.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`), this.hls.recoverMediaError());
        break;
    }
    if (ee.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(Z) {
    const ee = this.hls, ae = Z.errorAction;
    if (!ae)
      return;
    const {
      flags: ve,
      hdcpLevel: ye,
      nextAutoLevel: be
    } = ae;
    switch (ve) {
      case ErrorActionFlags.None:
        this.switchLevel(Z, be);
        break;
      case ErrorActionFlags.MoveAllAlternatesMatchingHDCP:
        ye && (ee.maxHdcpLevel = HdcpLevels[HdcpLevels.indexOf(ye) - 1], ae.resolved = !0), this.warn(`Restricting playback to HDCP-LEVEL of "${ee.maxHdcpLevel}" or lower`);
        break;
    }
    ae.resolved || this.switchLevel(Z, be);
  }
  switchLevel(Z, ee) {
    ee !== void 0 && Z.errorAction && (this.warn(`switching to level ${ee} after ${Z.details}`), this.hls.nextAutoLevel = ee, Z.errorAction.resolved = !0, this.hls.nextLoadLevel = this.hls.nextAutoLevel);
  }
}
class BasePlaylistController {
  constructor(Z, ee) {
    this.hls = void 0, this.timer = -1, this.requestScheduled = -1, this.canLoad = !1, this.log = void 0, this.warn = void 0, this.log = logger.log.bind(logger, `${ee}:`), this.warn = logger.warn.bind(logger, `${ee}:`), this.hls = Z;
  }
  destroy() {
    this.clearTimer(), this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    this.timer !== -1 && (self.clearTimeout(this.timer), this.timer = -1);
  }
  startLoad() {
    this.canLoad = !0, this.requestScheduled = -1, this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = !1, this.clearTimer();
  }
  switchParams(Z, ee) {
    const ae = ee == null ? void 0 : ee.renditionReports;
    if (ae) {
      let ve = -1;
      for (let ye = 0; ye < ae.length; ye++) {
        const be = ae[ye];
        let Ye;
        try {
          Ye = new self.URL(be.URI, ee.url).href;
        } catch (Qe) {
          logger.warn(`Could not construct new URL for Rendition Report: ${Qe}`), Ye = be.URI || "";
        }
        if (Ye === Z) {
          ve = ye;
          break;
        } else
          Ye === Z.substring(0, Ye.length) && (ve = ye);
      }
      if (ve !== -1) {
        const ye = ae[ve], be = parseInt(ye["LAST-MSN"]) || (ee == null ? void 0 : ee.lastPartSn);
        let Ye = parseInt(ye["LAST-PART"]) || (ee == null ? void 0 : ee.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const Qe = Math.min(ee.age - ee.partTarget, ee.targetduration);
          Ye >= 0 && Qe > ee.partTarget && (Ye += 1);
        }
        return new HlsUrlParameters(be, Ye >= 0 ? Ye : void 0, HlsSkip.No);
      }
    }
  }
  loadPlaylist(Z) {
    this.requestScheduled === -1 && (this.requestScheduled = self.performance.now());
  }
  shouldLoadPlaylist(Z) {
    return this.canLoad && !!Z && !!Z.url && (!Z.details || Z.details.live);
  }
  shouldReloadPlaylist(Z) {
    return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(Z);
  }
  playlistLoaded(Z, ee, ae) {
    const {
      details: ve,
      stats: ye
    } = ee, be = self.performance.now(), Ye = ye.loading.first ? Math.max(0, be - ye.loading.first) : 0;
    if (ve.advancedDateTime = Date.now() - Ye, ve.live || ae != null && ae.live) {
      if (ve.reloaded(ae), ae && this.log(`live playlist ${Z} ${ve.advanced ? "REFRESHED " + ve.lastPartSn + "-" + ve.lastPartIndex : ve.updated ? "UPDATED" : "MISSED"}`), ae && ve.fragments.length > 0 && mergeDetails(ae, ve), !this.canLoad || !ve.live)
        return;
      let Qe, Je, nt;
      if (ve.canBlockReload && ve.endSN && ve.advanced) {
        const ct = this.hls.config.lowLatencyMode, _r = ve.lastPartSn, Kr = ve.endSN, Xr = ve.lastPartIndex, Jr = Xr !== -1, ei = _r === Kr, si = ct ? 0 : Xr;
        Jr ? (Je = ei ? Kr + 1 : _r, nt = ei ? si : Xr + 1) : Je = Kr + 1;
        const ri = ve.age, ai = ri + ve.ageHeader;
        let yi = Math.min(ai - ve.partTarget, ve.targetduration * 1.5);
        if (yi > 0) {
          if (ae && yi > ae.tuneInGoal)
            this.warn(`CDN Tune-in goal increased from: ${ae.tuneInGoal} to: ${yi} with playlist age: ${ve.age}`), yi = 0;
          else {
            const pi = Math.floor(yi / ve.targetduration);
            if (Je += pi, nt !== void 0) {
              const di = Math.round(yi % ve.targetduration / ve.partTarget);
              nt += di;
            }
            this.log(`CDN Tune-in age: ${ve.ageHeader}s last advanced ${ri.toFixed(2)}s goal: ${yi} skip sn ${pi} to part ${nt}`);
          }
          ve.tuneInGoal = yi;
        }
        if (Qe = this.getDeliveryDirectives(ve, ee.deliveryDirectives, Je, nt), ct || !ei) {
          this.loadPlaylist(Qe);
          return;
        }
      } else
        (ve.canBlockReload || ve.canSkipUntil) && (Qe = this.getDeliveryDirectives(ve, ee.deliveryDirectives, Je, nt));
      const st = this.hls.mainForwardBufferInfo, ot = st ? st.end - st.len : 0, lt = (ve.edge - ot) * 1e3, ft = computeReloadInterval(ve, lt);
      ve.updated && be > this.requestScheduled + ft && (this.requestScheduled = ye.loading.start), Je !== void 0 && ve.canBlockReload ? this.requestScheduled = ye.loading.first + ft - (ve.partTarget * 1e3 || 1e3) : this.requestScheduled === -1 || this.requestScheduled + ft < be ? this.requestScheduled = be : this.requestScheduled - be <= 0 && (this.requestScheduled += ft);
      let gt = this.requestScheduled - be;
      gt = Math.max(0, gt), this.log(`reload live playlist ${Z} in ${Math.round(gt)} ms`), this.timer = self.setTimeout(() => this.loadPlaylist(Qe), gt);
    } else
      this.clearTimer();
  }
  getDeliveryDirectives(Z, ee, ae, ve) {
    let ye = getSkipValue(Z, ae);
    return ee != null && ee.skip && Z.deltaUpdateFailed && (ae = ee.msn, ve = ee.part, ye = HlsSkip.No), new HlsUrlParameters(ae, ve, ye);
  }
  checkRetry(Z) {
    const ee = Z.details, ae = isTimeoutError(Z), ve = Z.errorAction, {
      action: ye,
      retryCount: be = 0,
      retryConfig: Ye
    } = ve || {}, Qe = !!ve && !!Ye && (ye === NetworkErrorAction.RetryRequest || !ve.resolved && ye === NetworkErrorAction.SendAlternateToPenaltyBox);
    if (Qe) {
      var Je;
      if (this.requestScheduled = -1, be >= Ye.maxNumRetry)
        return !1;
      if (ae && (Je = Z.context) != null && Je.deliveryDirectives)
        this.warn(`Retrying playlist loading ${be + 1}/${Ye.maxNumRetry} after "${ee}" without delivery-directives`), this.loadPlaylist();
      else {
        const nt = getRetryDelay(Ye, be);
        this.timer = self.setTimeout(() => this.loadPlaylist(), nt), this.warn(`Retrying playlist loading ${be + 1}/${Ye.maxNumRetry} after "${ee}" in ${nt}ms`);
      }
      Z.levelRetry = !0, ve.resolved = !0;
    }
    return Qe;
  }
}
class EWMA {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(Z, ee = 0, ae = 0) {
    this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = Z, this.alpha_ = Z ? Math.exp(Math.log(0.5) / Z) : 0, this.estimate_ = ee, this.totalWeight_ = ae;
  }
  sample(Z, ee) {
    const ae = Math.pow(this.alpha_, Z);
    this.estimate_ = ee * (1 - ae) + ae * this.estimate_, this.totalWeight_ += Z;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const Z = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (Z)
        return this.estimate_ / Z;
    }
    return this.estimate_;
  }
}
class EwmaBandWidthEstimator {
  constructor(Z, ee, ae, ve = 100) {
    this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultTTFB_ = void 0, this.ttfb_ = void 0, this.defaultEstimate_ = ae, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new EWMA(Z), this.fast_ = new EWMA(ee), this.defaultTTFB_ = ve, this.ttfb_ = new EWMA(Z);
  }
  update(Z, ee) {
    const {
      slow_: ae,
      fast_: ve,
      ttfb_: ye
    } = this;
    ae.halfLife !== Z && (this.slow_ = new EWMA(Z, ae.getEstimate(), ae.getTotalWeight())), ve.halfLife !== ee && (this.fast_ = new EWMA(ee, ve.getEstimate(), ve.getTotalWeight())), ye.halfLife !== Z && (this.ttfb_ = new EWMA(Z, ye.getEstimate(), ye.getTotalWeight()));
  }
  sample(Z, ee) {
    Z = Math.max(Z, this.minDelayMs_);
    const ae = 8 * ee, ve = Z / 1e3, ye = ae / ve;
    this.fast_.sample(ve, ye), this.slow_.sample(ve, ye);
  }
  sampleTTFB(Z) {
    const ee = Z / 1e3, ae = Math.sqrt(2) * Math.exp(-Math.pow(ee, 2) / 2);
    this.ttfb_.sample(ae, Math.max(Z, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
  }
  getEstimateTTFB() {
    return this.ttfb_.getTotalWeight() >= this.minWeight_ ? this.ttfb_.getEstimate() : this.defaultTTFB_;
  }
  destroy() {
  }
}
const SUPPORTED_INFO_DEFAULT = {
  supported: !0,
  configurations: [],
  decodingInfoResults: [{
    supported: !0,
    powerEfficient: !0,
    smooth: !0
  }]
}, SUPPORTED_INFO_CACHE = {};
function requiresMediaCapabilitiesDecodingInfo(ie, Z, ee, ae, ve, ye) {
  const be = ie.audioCodec ? ie.audioGroups : null, Ye = ye == null ? void 0 : ye.audioCodec, Qe = ye == null ? void 0 : ye.channels, Je = Qe ? parseInt(Qe) : Ye ? 1 / 0 : 2;
  let nt = null;
  if (be != null && be.length)
    try {
      be.length === 1 && be[0] ? nt = Z.groups[be[0]].channels : nt = be.reduce((st, ot) => {
        if (ot) {
          const lt = Z.groups[ot];
          if (!lt)
            throw new Error(`Audio track group ${ot} not found`);
          Object.keys(lt.channels).forEach((ft) => {
            st[ft] = (st[ft] || 0) + lt.channels[ft];
          });
        }
        return st;
      }, {
        2: 0
      });
    } catch {
      return !0;
    }
  return ie.videoCodec !== void 0 && (ie.width > 1920 && ie.height > 1088 || ie.height > 1920 && ie.width > 1088 || ie.frameRate > Math.max(ae, 30) || ie.videoRange !== "SDR" && ie.videoRange !== ee || ie.bitrate > Math.max(ve, 8e6)) || !!nt && isFiniteNumber(Je) && Object.keys(nt).some((st) => parseInt(st) > Je);
}
function getMediaDecodingInfoPromise(ie, Z, ee) {
  const ae = ie.videoCodec, ve = ie.audioCodec;
  if (!ae || !ve || !ee)
    return Promise.resolve(SUPPORTED_INFO_DEFAULT);
  const ye = {
    width: ie.width,
    height: ie.height,
    bitrate: Math.ceil(Math.max(ie.bitrate * 0.9, ie.averageBitrate)),
    // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
    framerate: ie.frameRate || 30
  }, be = ie.videoRange;
  be !== "SDR" && (ye.transferFunction = be.toLowerCase());
  const Ye = ae.split(",").map((Qe) => ({
    type: "media-source",
    video: _objectSpread2(_objectSpread2({}, ye), {}, {
      contentType: mimeTypeForCodec(Qe, "video")
    })
  }));
  return ve && ie.audioGroups && ie.audioGroups.forEach((Qe) => {
    var Je;
    Qe && ((Je = Z.groups[Qe]) == null || Je.tracks.forEach((nt) => {
      if (nt.groupId === Qe) {
        const st = nt.channels || "", ot = parseFloat(st);
        isFiniteNumber(ot) && ot > 2 && Ye.push.apply(Ye, ve.split(",").map((lt) => ({
          type: "media-source",
          audio: {
            contentType: mimeTypeForCodec(lt, "audio"),
            channels: "" + ot
            // spatialRendering:
            //   audioCodec === 'ec-3' && channels.indexOf('JOC'),
          }
        })));
      }
    }));
  }), Promise.all(Ye.map((Qe) => {
    const Je = getMediaDecodingInfoKey(Qe);
    return SUPPORTED_INFO_CACHE[Je] || (SUPPORTED_INFO_CACHE[Je] = ee.decodingInfo(Qe));
  })).then((Qe) => ({
    supported: !Qe.some((Je) => !Je.supported),
    configurations: Ye,
    decodingInfoResults: Qe
  })).catch((Qe) => ({
    supported: !1,
    configurations: Ye,
    decodingInfoResults: [],
    error: Qe
  }));
}
function getMediaDecodingInfoKey(ie) {
  const {
    audio: Z,
    video: ee
  } = ie, ae = ee || Z;
  if (ae) {
    const ve = ae.contentType.split('"')[1];
    if (ee)
      return `r${ee.height}x${ee.width}f${Math.ceil(ee.framerate)}${ee.transferFunction || "sd"}_${ve}_${Math.ceil(ee.bitrate / 1e5)}`;
    if (Z)
      return `c${Z.channels}${Z.spatialRendering ? "s" : "n"}_${ve}`;
  }
  return "";
}
function isHdrSupported() {
  if (typeof matchMedia == "function") {
    const ie = matchMedia("(dynamic-range: high)"), Z = matchMedia("bad query");
    if (ie.media !== Z.media)
      return ie.matches === !0;
  }
  return !1;
}
function getVideoSelectionOptions(ie, Z) {
  let ee = !1, ae = [];
  return ie && (ee = ie !== "SDR", ae = [ie]), Z && (ae = Z.allowedVideoRanges || VideoRangeValues.slice(0), ee = Z.preferHDR !== void 0 ? Z.preferHDR : isHdrSupported(), ee ? ae = ae.filter((ve) => ve !== "SDR") : ae = ["SDR"]), {
    preferHDR: ee,
    allowedVideoRanges: ae
  };
}
function getStartCodecTier(ie, Z, ee, ae, ve) {
  const ye = Object.keys(ie), be = ae == null ? void 0 : ae.channels, Ye = ae == null ? void 0 : ae.audioCodec, Qe = be && parseInt(be) === 2;
  let Je = !0, nt = !1, st = 1 / 0, ot = 1 / 0, lt = 1 / 0, ft = 0, gt = [];
  const {
    preferHDR: ct,
    allowedVideoRanges: _r
  } = getVideoSelectionOptions(Z, ve);
  for (let ei = ye.length; ei--; ) {
    const si = ie[ye[ei]];
    Je = si.channels[2] > 0, st = Math.min(st, si.minHeight), ot = Math.min(ot, si.minFramerate), lt = Math.min(lt, si.minBitrate);
    const ri = _r.filter((ai) => si.videoRanges[ai] > 0);
    ri.length > 0 && (nt = !0, gt = ri);
  }
  st = isFiniteNumber(st) ? st : 0, ot = isFiniteNumber(ot) ? ot : 0;
  const Kr = Math.max(1080, st), Xr = Math.max(30, ot);
  return lt = isFiniteNumber(lt) ? lt : ee, ee = Math.max(lt, ee), nt || (Z = void 0, gt = []), {
    codecSet: ye.reduce((ei, si) => {
      const ri = ie[si];
      if (si === ei)
        return ei;
      if (ri.minBitrate > ee)
        return logStartCodecCandidateIgnored(si, `min bitrate of ${ri.minBitrate} > current estimate of ${ee}`), ei;
      if (!ri.hasDefaultAudio)
        return logStartCodecCandidateIgnored(si, "no renditions with default or auto-select sound found"), ei;
      if (Ye && si.indexOf(Ye.substring(0, 4)) % 5 !== 0)
        return logStartCodecCandidateIgnored(si, `audio codec preference "${Ye}" not found`), ei;
      if (be && !Qe) {
        if (!ri.channels[be])
          return logStartCodecCandidateIgnored(si, `no renditions with ${be} channel sound found (channels options: ${Object.keys(ri.channels)})`), ei;
      } else if ((!Ye || Qe) && Je && ri.channels[2] === 0)
        return logStartCodecCandidateIgnored(si, "no renditions with stereo sound found"), ei;
      return ri.minHeight > Kr ? (logStartCodecCandidateIgnored(si, `min resolution of ${ri.minHeight} > maximum of ${Kr}`), ei) : ri.minFramerate > Xr ? (logStartCodecCandidateIgnored(si, `min framerate of ${ri.minFramerate} > maximum of ${Xr}`), ei) : gt.some((ai) => ri.videoRanges[ai] > 0) ? ri.maxScore < ft ? (logStartCodecCandidateIgnored(si, `max score of ${ri.maxScore} < selected max of ${ft}`), ei) : ei && (codecsSetSelectionPreferenceValue(si) >= codecsSetSelectionPreferenceValue(ei) || ri.fragmentError > ie[ei].fragmentError) ? ei : (ft = ri.maxScore, si) : (logStartCodecCandidateIgnored(si, `no variants with VIDEO-RANGE of ${JSON.stringify(gt)} found`), ei);
    }, void 0),
    videoRanges: gt,
    preferHDR: ct,
    minFramerate: ot,
    minBitrate: lt
  };
}
function logStartCodecCandidateIgnored(ie, Z) {
  logger.log(`[abr] start candidates with "${ie}" ignored because ${Z}`);
}
function getAudioTracksByGroup(ie) {
  return ie.reduce((Z, ee) => {
    let ae = Z.groups[ee.groupId];
    ae || (ae = Z.groups[ee.groupId] = {
      tracks: [],
      channels: {
        2: 0
      },
      hasDefault: !1,
      hasAutoSelect: !1
    }), ae.tracks.push(ee);
    const ve = ee.channels || "2";
    return ae.channels[ve] = (ae.channels[ve] || 0) + 1, ae.hasDefault = ae.hasDefault || ee.default, ae.hasAutoSelect = ae.hasAutoSelect || ee.autoselect, ae.hasDefault && (Z.hasDefaultAudio = !0), ae.hasAutoSelect && (Z.hasAutoSelectAudio = !0), Z;
  }, {
    hasDefaultAudio: !1,
    hasAutoSelectAudio: !1,
    groups: {}
  });
}
function getCodecTiers(ie, Z, ee, ae) {
  return ie.slice(ee, ae + 1).reduce((ve, ye) => {
    if (!ye.codecSet)
      return ve;
    const be = ye.audioGroups;
    let Ye = ve[ye.codecSet];
    Ye || (ve[ye.codecSet] = Ye = {
      minBitrate: 1 / 0,
      minHeight: 1 / 0,
      minFramerate: 1 / 0,
      maxScore: 0,
      videoRanges: {
        SDR: 0
      },
      channels: {
        2: 0
      },
      hasDefaultAudio: !be,
      fragmentError: 0
    }), Ye.minBitrate = Math.min(Ye.minBitrate, ye.bitrate);
    const Qe = Math.min(ye.height, ye.width);
    return Ye.minHeight = Math.min(Ye.minHeight, Qe), Ye.minFramerate = Math.min(Ye.minFramerate, ye.frameRate), Ye.maxScore = Math.max(Ye.maxScore, ye.score), Ye.fragmentError += ye.fragmentError, Ye.videoRanges[ye.videoRange] = (Ye.videoRanges[ye.videoRange] || 0) + 1, be && be.forEach((Je) => {
      if (!Je)
        return;
      const nt = Z.groups[Je];
      Ye.hasDefaultAudio = Ye.hasDefaultAudio || Z.hasDefaultAudio ? nt.hasDefault : nt.hasAutoSelect || !Z.hasDefaultAudio && !Z.hasAutoSelectAudio, Object.keys(nt.channels).forEach((st) => {
        Ye.channels[st] = (Ye.channels[st] || 0) + nt.channels[st];
      });
    }), ve;
  }, {});
}
function findMatchingOption(ie, Z, ee) {
  if ("attrs" in ie) {
    const ae = Z.indexOf(ie);
    if (ae !== -1)
      return ae;
  }
  for (let ae = 0; ae < Z.length; ae++) {
    const ve = Z[ae];
    if (matchesOption(ie, ve, ee))
      return ae;
  }
  return -1;
}
function matchesOption(ie, Z, ee) {
  const {
    groupId: ae,
    name: ve,
    lang: ye,
    assocLang: be,
    characteristics: Ye,
    default: Qe
  } = ie, Je = ie.forced;
  return (ae === void 0 || Z.groupId === ae) && (ve === void 0 || Z.name === ve) && (ye === void 0 || Z.lang === ye) && (ye === void 0 || Z.assocLang === be) && (Qe === void 0 || Z.default === Qe) && (Je === void 0 || Z.forced === Je) && (Ye === void 0 || characteristicsMatch(Ye, Z.characteristics)) && (ee === void 0 || ee(ie, Z));
}
function characteristicsMatch(ie, Z = "") {
  const ee = ie.split(","), ae = Z.split(",");
  return ee.length === ae.length && !ee.some((ve) => ae.indexOf(ve) === -1);
}
function audioMatchPredicate(ie, Z) {
  const {
    audioCodec: ee,
    channels: ae
  } = ie;
  return (ee === void 0 || (Z.audioCodec || "").substring(0, 4) === ee.substring(0, 4)) && (ae === void 0 || ae === (Z.channels || "2"));
}
function findClosestLevelWithAudioGroup(ie, Z, ee, ae, ve) {
  const ye = Z[ae], Ye = Z.reduce((ot, lt, ft) => {
    const gt = lt.uri;
    return (ot[gt] || (ot[gt] = [])).push(ft), ot;
  }, {})[ye.uri];
  Ye.length > 1 && (ae = Math.max.apply(Math, Ye));
  const Qe = ye.videoRange, Je = ye.frameRate, nt = ye.codecSet.substring(0, 4), st = searchDownAndUpList(Z, ae, (ot) => {
    if (ot.videoRange !== Qe || ot.frameRate !== Je || ot.codecSet.substring(0, 4) !== nt)
      return !1;
    const lt = ot.audioGroups, ft = ee.filter((gt) => !lt || lt.indexOf(gt.groupId) !== -1);
    return findMatchingOption(ie, ft, ve) > -1;
  });
  return st > -1 ? st : searchDownAndUpList(Z, ae, (ot) => {
    const lt = ot.audioGroups, ft = ee.filter((gt) => !lt || lt.indexOf(gt.groupId) !== -1);
    return findMatchingOption(ie, ft, ve) > -1;
  });
}
function searchDownAndUpList(ie, Z, ee) {
  for (let ae = Z; ae; ae--)
    if (ee(ie[ae]))
      return ae;
  for (let ae = Z + 1; ae < ie.length; ae++)
    if (ee(ie[ae]))
      return ae;
  return -1;
}
class AbrController {
  constructor(Z) {
    this.hls = void 0, this.lastLevelLoadSec = 0, this.lastLoadedFragLevel = -1, this.firstSelection = -1, this._nextAutoLevel = -1, this.nextAutoLevelKey = "", this.audioTracksByGroup = null, this.codecTiers = null, this.timer = -1, this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.bwEstimator = void 0, this._abandonRulesCheck = () => {
      const {
        fragCurrent: ee,
        partCurrent: ae,
        hls: ve
      } = this, {
        autoLevelEnabled: ye,
        media: be
      } = ve;
      if (!ee || !be)
        return;
      const Ye = performance.now(), Qe = ae ? ae.stats : ee.stats, Je = ae ? ae.duration : ee.duration, nt = Ye - Qe.loading.start, st = ve.minAutoLevel;
      if (Qe.aborted || Qe.loaded && Qe.loaded === Qe.total || ee.level <= st) {
        this.clearTimer(), this._nextAutoLevel = -1;
        return;
      }
      if (!ye || be.paused || !be.playbackRate || !be.readyState)
        return;
      const ot = ve.mainForwardBufferInfo;
      if (ot === null)
        return;
      const lt = this.bwEstimator.getEstimateTTFB(), ft = Math.abs(be.playbackRate);
      if (nt <= Math.max(lt, 1e3 * (Je / (ft * 2))))
        return;
      const gt = ot.len / ft, ct = Qe.loading.first ? Qe.loading.first - Qe.loading.start : -1, _r = Qe.loaded && ct > -1, Kr = this.getBwEstimate(), Xr = ve.levels, Jr = Xr[ee.level], ei = Qe.total || Math.max(Qe.loaded, Math.round(Je * Jr.averageBitrate / 8));
      let si = _r ? nt - ct : nt;
      si < 1 && _r && (si = Math.min(nt, Qe.loaded * 8 / Kr));
      const ri = _r ? Qe.loaded * 1e3 / si : 0, ai = ri ? (ei - Qe.loaded) / ri : ei * 8 / Kr + lt / 1e3;
      if (ai <= gt)
        return;
      const yi = ri ? ri * 8 : Kr;
      let pi = Number.POSITIVE_INFINITY, di;
      for (di = ee.level - 1; di > st; di--) {
        const Ti = Xr[di].maxBitrate;
        if (pi = this.getTimeToLoadFrag(lt / 1e3, yi, Je * Ti, !Xr[di].details), pi < gt)
          break;
      }
      if (pi >= ai || pi > Je * 10)
        return;
      ve.nextLoadLevel = ve.nextAutoLevel = di, _r ? this.bwEstimator.sample(nt - Math.min(lt, ct), Qe.loaded) : this.bwEstimator.sampleTTFB(nt);
      const xi = Xr[di].maxBitrate;
      this.getBwEstimate() * this.hls.config.abrBandWidthUpFactor > xi && this.resetEstimator(xi), this.clearTimer(), logger.warn(`[abr] Fragment ${ee.sn}${ae ? " part " + ae.index : ""} of level ${ee.level} is loading too slowly;
      Time to underbuffer: ${gt.toFixed(3)} s
      Estimated load time for current fragment: ${ai.toFixed(3)} s
      Estimated load time for down switch fragment: ${pi.toFixed(3)} s
      TTFB estimate: ${ct | 0} ms
      Current BW estimate: ${isFiniteNumber(Kr) ? Kr | 0 : "Unknown"} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${di} @ ${xi | 0} bps`), ve.trigger(Events.FRAG_LOAD_EMERGENCY_ABORTED, {
        frag: ee,
        part: ae,
        stats: Qe
      });
    }, this.hls = Z, this.bwEstimator = this.initEstimator(), this.registerListeners();
  }
  resetEstimator(Z) {
    Z && (logger.log(`setting initial bwe to ${Z}`), this.hls.config.abrEwmaDefaultEstimate = Z), this.firstSelection = -1, this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const Z = this.hls.config;
    return new EwmaBandWidthEstimator(Z.abrEwmaSlowVoD, Z.abrEwmaFastVoD, Z.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.FRAG_LOADING, this.onFragLoading, this), Z.on(Events.FRAG_LOADED, this.onFragLoaded, this), Z.on(Events.FRAG_BUFFERED, this.onFragBuffered, this), Z.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this), Z.on(Events.LEVEL_LOADED, this.onLevelLoaded, this), Z.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this), Z.on(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), Z.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z && (Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.FRAG_LOADING, this.onFragLoading, this), Z.off(Events.FRAG_LOADED, this.onFragLoaded, this), Z.off(Events.FRAG_BUFFERED, this.onFragBuffered, this), Z.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this), Z.off(Events.LEVEL_LOADED, this.onLevelLoaded, this), Z.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this), Z.off(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), Z.off(Events.ERROR, this.onError, this));
  }
  destroy() {
    this.unregisterListeners(), this.clearTimer(), this.hls = this._abandonRulesCheck = null, this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(Z, ee) {
    this.lastLoadedFragLevel = -1, this.firstSelection = -1, this.lastLevelLoadSec = 0, this.fragCurrent = this.partCurrent = null, this.onLevelsUpdated(), this.clearTimer();
  }
  onLevelsUpdated() {
    this.lastLoadedFragLevel > -1 && this.fragCurrent && (this.lastLoadedFragLevel = this.fragCurrent.level), this._nextAutoLevel = -1, this.onMaxAutoLevelUpdated(), this.codecTiers = null, this.audioTracksByGroup = null;
  }
  onMaxAutoLevelUpdated() {
    this.firstSelection = -1, this.nextAutoLevelKey = "";
  }
  onFragLoading(Z, ee) {
    const ae = ee.frag;
    if (!this.ignoreFragment(ae)) {
      if (!ae.bitrateTest) {
        var ve;
        this.fragCurrent = ae, this.partCurrent = (ve = ee.part) != null ? ve : null;
      }
      this.clearTimer(), this.timer = self.setInterval(this._abandonRulesCheck, 100);
    }
  }
  onLevelSwitching(Z, ee) {
    this.clearTimer();
  }
  onError(Z, ee) {
    if (!ee.fatal)
      switch (ee.details) {
        case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
        case ErrorDetails.BUFFER_APPEND_ERROR:
          this.lastLoadedFragLevel = -1, this.firstSelection = -1;
          break;
        case ErrorDetails.FRAG_LOAD_TIMEOUT: {
          const ae = ee.frag, {
            fragCurrent: ve,
            partCurrent: ye
          } = this;
          if (ae && ve && ae.sn === ve.sn && ae.level === ve.level) {
            const be = performance.now(), Ye = ye ? ye.stats : ae.stats, Qe = be - Ye.loading.start, Je = Ye.loading.first ? Ye.loading.first - Ye.loading.start : -1;
            if (Ye.loaded && Je > -1) {
              const st = this.bwEstimator.getEstimateTTFB();
              this.bwEstimator.sample(Qe - Math.min(st, Je), Ye.loaded);
            } else
              this.bwEstimator.sampleTTFB(Qe);
          }
          break;
        }
      }
  }
  getTimeToLoadFrag(Z, ee, ae, ve) {
    const ye = Z + ae / ee, be = ve ? this.lastLevelLoadSec : 0;
    return ye + be;
  }
  onLevelLoaded(Z, ee) {
    const ae = this.hls.config, {
      loading: ve
    } = ee.stats, ye = ve.end - ve.start;
    isFiniteNumber(ye) && (this.lastLevelLoadSec = ye / 1e3), ee.details.live ? this.bwEstimator.update(ae.abrEwmaSlowLive, ae.abrEwmaFastLive) : this.bwEstimator.update(ae.abrEwmaSlowVoD, ae.abrEwmaFastVoD);
  }
  onFragLoaded(Z, {
    frag: ee,
    part: ae
  }) {
    const ve = ae ? ae.stats : ee.stats;
    if (ee.type === PlaylistLevelType.MAIN && this.bwEstimator.sampleTTFB(ve.loading.first - ve.loading.start), !this.ignoreFragment(ee)) {
      if (this.clearTimer(), ee.level === this._nextAutoLevel && (this._nextAutoLevel = -1), this.firstSelection = -1, this.hls.config.abrMaxWithRealBitrate) {
        const ye = ae ? ae.duration : ee.duration, be = this.hls.levels[ee.level], Ye = (be.loaded ? be.loaded.bytes : 0) + ve.loaded, Qe = (be.loaded ? be.loaded.duration : 0) + ye;
        be.loaded = {
          bytes: Ye,
          duration: Qe
        }, be.realBitrate = Math.round(8 * Ye / Qe);
      }
      if (ee.bitrateTest) {
        const ye = {
          stats: ve,
          frag: ee,
          part: ae,
          id: ee.type
        };
        this.onFragBuffered(Events.FRAG_BUFFERED, ye), ee.bitrateTest = !1;
      } else
        this.lastLoadedFragLevel = ee.level;
    }
  }
  onFragBuffered(Z, ee) {
    const {
      frag: ae,
      part: ve
    } = ee, ye = ve != null && ve.stats.loaded ? ve.stats : ae.stats;
    if (ye.aborted || this.ignoreFragment(ae))
      return;
    const be = ye.parsing.end - ye.loading.start - Math.min(ye.loading.first - ye.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(be, ye.loaded), ye.bwEstimate = this.getBwEstimate(), ae.bitrateTest ? this.bitrateTestDelay = be / 1e3 : this.bitrateTestDelay = 0;
  }
  ignoreFragment(Z) {
    return Z.type !== PlaylistLevelType.MAIN || Z.sn === "initSegment";
  }
  clearTimer() {
    this.timer > -1 && (self.clearInterval(this.timer), this.timer = -1);
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel: Z,
      minAutoLevel: ee
    } = this.hls, ae = this.getBwEstimate(), ve = this.hls.config.maxStarvationDelay, ye = this.findBestLevel(ae, ee, Z, 0, ve, 1, 1);
    if (ye > -1)
      return ye;
    const be = this.hls.firstLevel, Ye = Math.min(Math.max(be, ee), Z);
    return logger.warn(`[abr] Could not find best starting auto level. Defaulting to first in playlist ${be} clamped to ${Ye}`), Ye;
  }
  get forcedAutoLevel() {
    return this.nextAutoLevelKey ? -1 : this._nextAutoLevel;
  }
  // return next auto level
  get nextAutoLevel() {
    const Z = this.forcedAutoLevel, ae = this.bwEstimator.canEstimate(), ve = this.lastLoadedFragLevel > -1;
    if (Z !== -1 && (!ae || !ve || this.nextAutoLevelKey === this.getAutoLevelKey()))
      return Z;
    const ye = ae && ve ? this.getNextABRAutoLevel() : this.firstAutoLevel;
    if (Z !== -1) {
      const be = this.hls.levels;
      if (be.length > Math.max(Z, ye) && be[Z].loadError <= be[ye].loadError)
        return Z;
    }
    return this._nextAutoLevel = ye, this.nextAutoLevelKey = this.getAutoLevelKey(), ye;
  }
  getAutoLevelKey() {
    var Z;
    return `${this.getBwEstimate()}_${(Z = this.hls.mainForwardBufferInfo) == null ? void 0 : Z.len}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent: Z,
      partCurrent: ee,
      hls: ae
    } = this, {
      maxAutoLevel: ve,
      config: ye,
      minAutoLevel: be,
      media: Ye
    } = ae, Qe = ee ? ee.duration : Z ? Z.duration : 0, Je = Ye && Ye.playbackRate !== 0 ? Math.abs(Ye.playbackRate) : 1, nt = this.getBwEstimate(), st = ae.mainForwardBufferInfo, ot = (st ? st.len : 0) / Je;
    let lt = ye.abrBandWidthFactor, ft = ye.abrBandWidthUpFactor;
    if (ot) {
      const Xr = this.findBestLevel(nt, be, ve, ot, 0, lt, ft);
      if (Xr >= 0)
        return Xr;
    }
    let gt = Qe ? Math.min(Qe, ye.maxStarvationDelay) : ye.maxStarvationDelay;
    if (!ot) {
      const Xr = this.bitrateTestDelay;
      Xr && (gt = (Qe ? Math.min(Qe, ye.maxLoadingDelay) : ye.maxLoadingDelay) - Xr, logger.info(`[abr] bitrate test took ${Math.round(1e3 * Xr)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * gt)} ms`), lt = ft = 1);
    }
    const ct = this.findBestLevel(nt, be, ve, ot, gt, lt, ft);
    if (logger.info(`[abr] ${ot ? "rebuffering expected" : "buffer is empty"}, optimal quality level ${ct}`), ct > -1)
      return ct;
    const _r = ae.levels[be], Kr = ae.levels[ae.loadLevel];
    return (_r == null ? void 0 : _r.bitrate) < (Kr == null ? void 0 : Kr.bitrate) ? be : ae.loadLevel;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(Z, ee, ae, ve, ye, be, Ye) {
    var Qe;
    const Je = ve + ye, nt = this.lastLoadedFragLevel, st = nt === -1 ? this.hls.firstLevel : nt, {
      fragCurrent: ot,
      partCurrent: lt
    } = this, {
      levels: ft,
      allAudioTracks: gt,
      loadLevel: ct,
      config: _r
    } = this.hls;
    if (ft.length === 1)
      return 0;
    const Kr = ft[st], Xr = !!(Kr != null && (Qe = Kr.details) != null && Qe.live), Jr = ct === -1 || nt === -1;
    let ei, si = "SDR", ri = (Kr == null ? void 0 : Kr.frameRate) || 0;
    const {
      audioPreference: ai,
      videoPreference: yi
    } = _r, pi = this.audioTracksByGroup || (this.audioTracksByGroup = getAudioTracksByGroup(gt));
    if (Jr) {
      if (this.firstSelection !== -1)
        return this.firstSelection;
      const mi = this.codecTiers || (this.codecTiers = getCodecTiers(ft, pi, ee, ae)), Si = getStartCodecTier(mi, si, Z, ai, yi), {
        codecSet: gi,
        videoRanges: _i,
        minFramerate: Oi,
        minBitrate: hi,
        preferHDR: Di
      } = Si;
      ei = gi, si = Di ? _i[_i.length - 1] : _i[0], ri = Oi, Z = Math.max(Z, hi), logger.log(`[abr] picked start tier ${JSON.stringify(Si)}`);
    } else
      ei = Kr == null ? void 0 : Kr.codecSet, si = Kr == null ? void 0 : Kr.videoRange;
    const di = lt ? lt.duration : ot ? ot.duration : 0, xi = this.bwEstimator.getEstimateTTFB() / 1e3, Ti = [];
    for (let mi = ae; mi >= ee; mi--) {
      var Ai;
      const Si = ft[mi], gi = mi > st;
      if (!Si)
        continue;
      if (_r.useMediaCapabilities && !Si.supportedResult && !Si.supportedPromise) {
        const Hi = navigator.mediaCapabilities;
        typeof (Hi == null ? void 0 : Hi.decodingInfo) == "function" && requiresMediaCapabilitiesDecodingInfo(Si, pi, si, ri, Z, ai) ? (Si.supportedPromise = getMediaDecodingInfoPromise(Si, pi, Hi), Si.supportedPromise.then((qi) => {
          Si.supportedResult = qi;
          const us = this.hls.levels, Yi = us.indexOf(Si);
          qi.error ? logger.warn(`[abr] MediaCapabilities decodingInfo error: "${qi.error}" for level ${Yi} ${JSON.stringify(qi)}`) : qi.supported || (logger.warn(`[abr] Unsupported MediaCapabilities decodingInfo result for level ${Yi} ${JSON.stringify(qi)}`), Yi > -1 && us.length > 1 && (logger.log(`[abr] Removing unsupported level ${Yi}`), this.hls.removeLevel(Yi)));
        })) : Si.supportedResult = SUPPORTED_INFO_DEFAULT;
      }
      if (ei && Si.codecSet !== ei || si && Si.videoRange !== si || gi && ri > Si.frameRate || !gi && ri > 0 && ri < Si.frameRate || Si.supportedResult && !((Ai = Si.supportedResult.decodingInfoResults) != null && Ai[0].smooth)) {
        Ti.push(mi);
        continue;
      }
      const _i = Si.details, Oi = (lt ? _i == null ? void 0 : _i.partTarget : _i == null ? void 0 : _i.averagetargetduration) || di;
      let hi;
      gi ? hi = Ye * Z : hi = be * Z;
      const Di = di && ve >= di * 2 && ye === 0 ? ft[mi].averageBitrate : ft[mi].maxBitrate, Ri = this.getTimeToLoadFrag(xi, hi, Di * Oi, _i === void 0);
      if (
        // if adjusted bw is greater than level bitrate AND
        hi >= Di && // no level change, or new level has no error history
        (mi === nt || Si.loadError === 0 && Si.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
        (Ri <= xi || !isFiniteNumber(Ri) || Xr && !this.bitrateTestDelay || Ri < Je)
      ) {
        const Hi = this.forcedAutoLevel;
        return mi !== ct && (Hi === -1 || Hi !== ct) && (Ti.length && logger.trace(`[abr] Skipped level(s) ${Ti.join(",")} of ${ae} max with CODECS and VIDEO-RANGE:"${ft[Ti[0]].codecs}" ${ft[Ti[0]].videoRange}; not compatible with "${Kr.codecs}" ${si}`), logger.info(`[abr] switch candidate:${st}->${mi} adjustedbw(${Math.round(hi)})-bitrate=${Math.round(hi - Di)} ttfb:${xi.toFixed(1)} avgDuration:${Oi.toFixed(1)} maxFetchDuration:${Je.toFixed(1)} fetchDuration:${Ri.toFixed(1)} firstSelection:${Jr} codecSet:${ei} videoRange:${si} hls.loadLevel:${ct}`)), Jr && (this.firstSelection = mi), mi;
      }
    }
    return -1;
  }
  set nextAutoLevel(Z) {
    const ee = Math.max(this.hls.minAutoLevel, Z);
    this._nextAutoLevel != ee && (this.nextAutoLevelKey = "", this._nextAutoLevel = ee);
  }
}
class TaskLoop {
  constructor() {
    this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying(), this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    this.clearNextTick(), this.clearInterval();
  }
  onHandlerDestroyed() {
  }
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }
  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(Z) {
    return this._tickInterval ? !1 : (this._tickCallCount = 0, this._tickInterval = self.setInterval(this._boundTick, Z), !0);
  }
  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
  }
  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
  }
  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
  }
  tickImmediate() {
    this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
  }
  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {
  }
}
var FragmentState = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class FragmentTracker {
  constructor(Z) {
    this.activePartLists = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hasGaps = !1, this.hls = Z, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.BUFFER_APPENDED, this.onBufferAppended, this), Z.on(Events.FRAG_BUFFERED, this.onFragBuffered, this), Z.on(Events.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z.off(Events.BUFFER_APPENDED, this.onBufferAppended, this), Z.off(Events.FRAG_BUFFERED, this.onFragBuffered, this), Z.off(Events.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners(), this.fragments = // @ts-ignore
    this.activePartLists = // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }
  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(Z, ee) {
    const ae = this.activePartLists[ee];
    if (ae)
      for (let ve = ae.length; ve--; ) {
        const ye = ae[ve];
        if (!ye)
          break;
        const be = ye.end;
        if (ye.start <= Z && be !== null && Z <= be)
          return ye;
      }
    return this.getBufferedFrag(Z, ee);
  }
  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(Z, ee) {
    const {
      fragments: ae
    } = this, ve = Object.keys(ae);
    for (let ye = ve.length; ye--; ) {
      const be = ae[ve[ye]];
      if ((be == null ? void 0 : be.body.type) === ee && be.buffered) {
        const Ye = be.body;
        if (Ye.start <= Z && Z <= Ye.end)
          return Ye;
      }
    }
    return null;
  }
  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(Z, ee, ae, ve) {
    this.timeRanges && (this.timeRanges[Z] = ee);
    const ye = (ve == null ? void 0 : ve.fragment.sn) || -1;
    Object.keys(this.fragments).forEach((be) => {
      const Ye = this.fragments[be];
      if (!Ye || ye >= Ye.body.sn)
        return;
      if (!Ye.buffered && !Ye.loaded) {
        Ye.body.type === ae && this.removeFragment(Ye.body);
        return;
      }
      const Qe = Ye.range[Z];
      Qe && Qe.time.some((Je) => {
        const nt = !this.isTimeBuffered(Je.startPTS, Je.endPTS, ee);
        return nt && this.removeFragment(Ye.body), nt;
      });
    });
  }
  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(Z) {
    const ee = this.timeRanges, {
      frag: ae,
      part: ve
    } = Z;
    if (!ee || ae.sn === "initSegment")
      return;
    const ye = getFragmentKey(ae), be = this.fragments[ye];
    if (!be || be.buffered && ae.gap)
      return;
    const Ye = !ae.relurl;
    Object.keys(ee).forEach((Qe) => {
      const Je = ae.elementaryStreams[Qe];
      if (!Je)
        return;
      const nt = ee[Qe], st = Ye || Je.partial === !0;
      be.range[Qe] = this.getBufferedTimes(ae, ve, st, nt);
    }), be.loaded = null, Object.keys(be.range).length ? (be.buffered = !0, (be.body.endList = ae.endList || be.body.endList) && (this.endListFragments[be.body.type] = be), isPartial(be) || this.removeParts(ae.sn - 1, ae.type)) : this.removeFragment(be.body);
  }
  removeParts(Z, ee) {
    const ae = this.activePartLists[ee];
    ae && (this.activePartLists[ee] = ae.filter((ve) => ve.fragment.sn >= Z));
  }
  fragBuffered(Z, ee) {
    const ae = getFragmentKey(Z);
    let ve = this.fragments[ae];
    !ve && ee && (ve = this.fragments[ae] = {
      body: Z,
      appendedPTS: null,
      loaded: null,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    }, Z.gap && (this.hasGaps = !0)), ve && (ve.loaded = null, ve.buffered = !0);
  }
  getBufferedTimes(Z, ee, ae, ve) {
    const ye = {
      time: [],
      partial: ae
    }, be = Z.start, Ye = Z.end, Qe = Z.minEndPTS || Ye, Je = Z.maxStartPTS || be;
    for (let nt = 0; nt < ve.length; nt++) {
      const st = ve.start(nt) - this.bufferPadding, ot = ve.end(nt) + this.bufferPadding;
      if (Je >= st && Qe <= ot) {
        ye.time.push({
          startPTS: Math.max(be, ve.start(nt)),
          endPTS: Math.min(Ye, ve.end(nt))
        });
        break;
      } else if (be < ot && Ye > st) {
        const lt = Math.max(be, ve.start(nt)), ft = Math.min(Ye, ve.end(nt));
        ft > lt && (ye.partial = !0, ye.time.push({
          startPTS: lt,
          endPTS: ft
        }));
      } else if (Ye <= st)
        break;
    }
    return ye;
  }
  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(Z) {
    let ee = null, ae, ve, ye, be = 0;
    const {
      bufferPadding: Ye,
      fragments: Qe
    } = this;
    return Object.keys(Qe).forEach((Je) => {
      const nt = Qe[Je];
      nt && isPartial(nt) && (ve = nt.body.start - Ye, ye = nt.body.end + Ye, Z >= ve && Z <= ye && (ae = Math.min(Z - ve, ye - Z), be <= ae && (ee = nt.body, be = ae)));
    }), ee;
  }
  isEndListAppended(Z) {
    const ee = this.endListFragments[Z];
    return ee !== void 0 && (ee.buffered || isPartial(ee));
  }
  getState(Z) {
    const ee = getFragmentKey(Z), ae = this.fragments[ee];
    return ae ? ae.buffered ? isPartial(ae) ? FragmentState.PARTIAL : FragmentState.OK : FragmentState.APPENDING : FragmentState.NOT_LOADED;
  }
  isTimeBuffered(Z, ee, ae) {
    let ve, ye;
    for (let be = 0; be < ae.length; be++) {
      if (ve = ae.start(be) - this.bufferPadding, ye = ae.end(be) + this.bufferPadding, Z >= ve && ee <= ye)
        return !0;
      if (ee <= ve)
        return !1;
    }
    return !1;
  }
  onFragLoaded(Z, ee) {
    const {
      frag: ae,
      part: ve
    } = ee;
    if (ae.sn === "initSegment" || ae.bitrateTest)
      return;
    const ye = ve ? null : ee, be = getFragmentKey(ae);
    this.fragments[be] = {
      body: ae,
      appendedPTS: null,
      loaded: ye,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    };
  }
  onBufferAppended(Z, ee) {
    const {
      frag: ae,
      part: ve,
      timeRanges: ye
    } = ee;
    if (ae.sn === "initSegment")
      return;
    const be = ae.type;
    if (ve) {
      let Ye = this.activePartLists[be];
      Ye || (this.activePartLists[be] = Ye = []), Ye.push(ve);
    }
    this.timeRanges = ye, Object.keys(ye).forEach((Ye) => {
      const Qe = ye[Ye];
      this.detectEvictedFragments(Ye, Qe, be, ve);
    });
  }
  onFragBuffered(Z, ee) {
    this.detectPartialFragments(ee);
  }
  hasFragment(Z) {
    const ee = getFragmentKey(Z);
    return !!this.fragments[ee];
  }
  hasParts(Z) {
    var ee;
    return !!((ee = this.activePartLists[Z]) != null && ee.length);
  }
  removeFragmentsInRange(Z, ee, ae, ve, ye) {
    ve && !this.hasGaps || Object.keys(this.fragments).forEach((be) => {
      const Ye = this.fragments[be];
      if (!Ye)
        return;
      const Qe = Ye.body;
      Qe.type !== ae || ve && !Qe.gap || Qe.start < ee && Qe.end > Z && (Ye.buffered || ye) && this.removeFragment(Qe);
    });
  }
  removeFragment(Z) {
    const ee = getFragmentKey(Z);
    Z.stats.loaded = 0, Z.clearElementaryStreamInfo();
    const ae = this.activePartLists[Z.type];
    if (ae) {
      const ve = Z.sn;
      this.activePartLists[Z.type] = ae.filter((ye) => ye.fragment.sn !== ve);
    }
    delete this.fragments[ee], Z.endList && delete this.endListFragments[Z.type];
  }
  removeAllFragments() {
    this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activePartLists = /* @__PURE__ */ Object.create(null), this.hasGaps = !1;
  }
}
function isPartial(ie) {
  var Z, ee, ae;
  return ie.buffered && (ie.body.gap || ((Z = ie.range.video) == null ? void 0 : Z.partial) || ((ee = ie.range.audio) == null ? void 0 : ee.partial) || ((ae = ie.range.audiovideo) == null ? void 0 : ae.partial));
}
function getFragmentKey(ie) {
  return `${ie.type}_${ie.level}_${ie.sn}`;
}
const noopBuffered = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class BufferHelper {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(Z, ee) {
    try {
      if (Z) {
        const ae = BufferHelper.getBuffered(Z);
        for (let ve = 0; ve < ae.length; ve++)
          if (ee >= ae.start(ve) && ee <= ae.end(ve))
            return !0;
      }
    } catch {
    }
    return !1;
  }
  static bufferInfo(Z, ee, ae) {
    try {
      if (Z) {
        const ve = BufferHelper.getBuffered(Z), ye = [];
        let be;
        for (be = 0; be < ve.length; be++)
          ye.push({
            start: ve.start(be),
            end: ve.end(be)
          });
        return this.bufferedInfo(ye, ee, ae);
      }
    } catch {
    }
    return {
      len: 0,
      start: ee,
      end: ee,
      nextStart: void 0
    };
  }
  static bufferedInfo(Z, ee, ae) {
    ee = Math.max(0, ee), Z.sort(function(Je, nt) {
      const st = Je.start - nt.start;
      return st || nt.end - Je.end;
    });
    let ve = [];
    if (ae)
      for (let Je = 0; Je < Z.length; Je++) {
        const nt = ve.length;
        if (nt) {
          const st = ve[nt - 1].end;
          Z[Je].start - st < ae ? Z[Je].end > st && (ve[nt - 1].end = Z[Je].end) : ve.push(Z[Je]);
        } else
          ve.push(Z[Je]);
      }
    else
      ve = Z;
    let ye = 0, be, Ye = ee, Qe = ee;
    for (let Je = 0; Je < ve.length; Je++) {
      const nt = ve[Je].start, st = ve[Je].end;
      if (ee + ae >= nt && ee < st)
        Ye = nt, Qe = st, ye = Qe - ee;
      else if (ee + ae < nt) {
        be = nt;
        break;
      }
    }
    return {
      len: ye,
      start: Ye || 0,
      end: Qe || 0,
      nextStart: be
    };
  }
  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(Z) {
    try {
      return Z.buffered;
    } catch (ee) {
      return logger.log("failed to get media.buffered", ee), noopBuffered;
    }
  }
}
class ChunkMetadata {
  constructor(Z, ee, ae, ve = 0, ye = -1, be = !1) {
    this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = getNewPerformanceTiming(), this.buffering = {
      audio: getNewPerformanceTiming(),
      video: getNewPerformanceTiming(),
      audiovideo: getNewPerformanceTiming()
    }, this.level = Z, this.sn = ee, this.id = ae, this.size = ve, this.part = ye, this.partial = be;
  }
}
function getNewPerformanceTiming() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}
function findFirstFragWithCC(ie, Z) {
  for (let ae = 0, ve = ie.length; ae < ve; ae++) {
    var ee;
    if (((ee = ie[ae]) == null ? void 0 : ee.cc) === Z)
      return ie[ae];
  }
  return null;
}
function shouldAlignOnDiscontinuities(ie, Z, ee) {
  return !!(Z && (ee.endCC > ee.startCC || ie && ie.cc < ee.startCC));
}
function findDiscontinuousReferenceFrag(ie, Z) {
  const ee = ie.fragments, ae = Z.fragments;
  if (!ae.length || !ee.length) {
    logger.log("No fragments to align");
    return;
  }
  const ve = findFirstFragWithCC(ee, ae[0].cc);
  if (!ve || ve && !ve.startPTS) {
    logger.log("No frag in previous level to align on");
    return;
  }
  return ve;
}
function adjustFragmentStart(ie, Z) {
  if (ie) {
    const ee = ie.start + Z;
    ie.start = ie.startPTS = ee, ie.endPTS = ee + ie.duration;
  }
}
function adjustSlidingStart(ie, Z) {
  const ee = Z.fragments;
  for (let ae = 0, ve = ee.length; ae < ve; ae++)
    adjustFragmentStart(ee[ae], ie);
  Z.fragmentHint && adjustFragmentStart(Z.fragmentHint, ie), Z.alignedSliding = !0;
}
function alignStream(ie, Z, ee) {
  Z && (alignDiscontinuities(ie, ee, Z), !ee.alignedSliding && Z && alignMediaPlaylistByPDT(ee, Z), !ee.alignedSliding && Z && !ee.skippedSegments && adjustSliding(Z, ee));
}
function alignDiscontinuities(ie, Z, ee) {
  if (shouldAlignOnDiscontinuities(ie, ee, Z)) {
    const ae = findDiscontinuousReferenceFrag(ee, Z);
    ae && isFiniteNumber(ae.start) && (logger.log(`Adjusting PTS using last level due to CC increase within current level ${Z.url}`), adjustSlidingStart(ae.start, Z));
  }
}
function alignMediaPlaylistByPDT(ie, Z) {
  if (!ie.hasProgramDateTime || !Z.hasProgramDateTime)
    return;
  const ee = ie.fragments, ae = Z.fragments;
  if (!ee.length || !ae.length)
    return;
  let ve, ye;
  const be = Math.min(Z.endCC, ie.endCC);
  Z.startCC < be && ie.startCC < be && (ve = findFirstFragWithCC(ae, be), ye = findFirstFragWithCC(ee, be)), (!ve || !ye) && (ve = ae[Math.floor(ae.length / 2)], ye = findFirstFragWithCC(ee, ve.cc) || ee[Math.floor(ee.length / 2)]);
  const Ye = ve.programDateTime, Qe = ye.programDateTime;
  if (!Ye || !Qe)
    return;
  const Je = (Qe - Ye) / 1e3 - (ye.start - ve.start);
  adjustSlidingStart(Je, ie);
}
const MIN_CHUNK_SIZE = Math.pow(2, 17);
class FragmentLoader {
  constructor(Z) {
    this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = Z;
  }
  destroy() {
    this.loader && (this.loader.destroy(), this.loader = null);
  }
  abort() {
    this.loader && this.loader.abort();
  }
  load(Z, ee) {
    const ae = Z.url;
    if (!ae)
      return Promise.reject(new LoadError({
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.FRAG_LOAD_ERROR,
        fatal: !1,
        frag: Z,
        error: new Error(`Fragment does not have a ${ae ? "part list" : "url"}`),
        networkDetails: null
      }));
    this.abort();
    const ve = this.config, ye = ve.fLoader, be = ve.loader;
    return new Promise((Ye, Qe) => {
      if (this.loader && this.loader.destroy(), Z.gap)
        if (Z.tagList.some((lt) => lt[0] === "GAP")) {
          Qe(createGapLoadError(Z));
          return;
        } else
          Z.gap = !1;
      const Je = this.loader = Z.loader = ye ? new ye(ve) : new be(ve), nt = createLoaderContext(Z), st = getLoaderConfigWithoutReties(ve.fragLoadPolicy.default), ot = {
        loadPolicy: st,
        timeout: st.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: Z.sn === "initSegment" ? 1 / 0 : MIN_CHUNK_SIZE
      };
      Z.stats = Je.stats, Je.load(nt, ot, {
        onSuccess: (lt, ft, gt, ct) => {
          this.resetLoader(Z, Je);
          let _r = lt.data;
          gt.resetIV && Z.decryptdata && (Z.decryptdata.iv = new Uint8Array(_r.slice(0, 16)), _r = _r.slice(16)), Ye({
            frag: Z,
            part: null,
            payload: _r,
            networkDetails: ct
          });
        },
        onError: (lt, ft, gt, ct) => {
          this.resetLoader(Z, Je), Qe(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: Z,
            response: _objectSpread2({
              url: ae,
              data: void 0
            }, lt),
            error: new Error(`HTTP Error ${lt.code} ${lt.text}`),
            networkDetails: gt,
            stats: ct
          }));
        },
        onAbort: (lt, ft, gt) => {
          this.resetLoader(Z, Je), Qe(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.INTERNAL_ABORTED,
            fatal: !1,
            frag: Z,
            error: new Error("Aborted"),
            networkDetails: gt,
            stats: lt
          }));
        },
        onTimeout: (lt, ft, gt) => {
          this.resetLoader(Z, Je), Qe(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: Z,
            error: new Error(`Timeout after ${ot.timeout}ms`),
            networkDetails: gt,
            stats: lt
          }));
        },
        onProgress: (lt, ft, gt, ct) => {
          ee && ee({
            frag: Z,
            part: null,
            payload: gt,
            networkDetails: ct
          });
        }
      });
    });
  }
  loadPart(Z, ee, ae) {
    this.abort();
    const ve = this.config, ye = ve.fLoader, be = ve.loader;
    return new Promise((Ye, Qe) => {
      if (this.loader && this.loader.destroy(), Z.gap || ee.gap) {
        Qe(createGapLoadError(Z, ee));
        return;
      }
      const Je = this.loader = Z.loader = ye ? new ye(ve) : new be(ve), nt = createLoaderContext(Z, ee), st = getLoaderConfigWithoutReties(ve.fragLoadPolicy.default), ot = {
        loadPolicy: st,
        timeout: st.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: MIN_CHUNK_SIZE
      };
      ee.stats = Je.stats, Je.load(nt, ot, {
        onSuccess: (lt, ft, gt, ct) => {
          this.resetLoader(Z, Je), this.updateStatsFromPart(Z, ee);
          const _r = {
            frag: Z,
            part: ee,
            payload: lt.data,
            networkDetails: ct
          };
          ae(_r), Ye(_r);
        },
        onError: (lt, ft, gt, ct) => {
          this.resetLoader(Z, Je), Qe(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: Z,
            part: ee,
            response: _objectSpread2({
              url: nt.url,
              data: void 0
            }, lt),
            error: new Error(`HTTP Error ${lt.code} ${lt.text}`),
            networkDetails: gt,
            stats: ct
          }));
        },
        onAbort: (lt, ft, gt) => {
          Z.stats.aborted = ee.stats.aborted, this.resetLoader(Z, Je), Qe(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.INTERNAL_ABORTED,
            fatal: !1,
            frag: Z,
            part: ee,
            error: new Error("Aborted"),
            networkDetails: gt,
            stats: lt
          }));
        },
        onTimeout: (lt, ft, gt) => {
          this.resetLoader(Z, Je), Qe(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: Z,
            part: ee,
            error: new Error(`Timeout after ${ot.timeout}ms`),
            networkDetails: gt,
            stats: lt
          }));
        }
      });
    });
  }
  updateStatsFromPart(Z, ee) {
    const ae = Z.stats, ve = ee.stats, ye = ve.total;
    if (ae.loaded += ve.loaded, ye) {
      const Qe = Math.round(Z.duration / ee.duration), Je = Math.min(Math.round(ae.loaded / ye), Qe), st = (Qe - Je) * Math.round(ae.loaded / Je);
      ae.total = ae.loaded + st;
    } else
      ae.total = Math.max(ae.loaded, ae.total);
    const be = ae.loading, Ye = ve.loading;
    be.start ? be.first += Ye.first - Ye.start : (be.start = Ye.start, be.first = Ye.first), be.end = Ye.end;
  }
  resetLoader(Z, ee) {
    Z.loader = null, this.loader === ee && (self.clearTimeout(this.partLoadTimeout), this.loader = null), ee.destroy();
  }
}
function createLoaderContext(ie, Z = null) {
  const ee = Z || ie, ae = {
    frag: ie,
    part: Z,
    responseType: "arraybuffer",
    url: ee.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  }, ve = ee.byteRangeStartOffset, ye = ee.byteRangeEndOffset;
  if (isFiniteNumber(ve) && isFiniteNumber(ye)) {
    var be;
    let Ye = ve, Qe = ye;
    if (ie.sn === "initSegment" && ((be = ie.decryptdata) == null ? void 0 : be.method) === "AES-128") {
      const Je = ye - ve;
      Je % 16 && (Qe = ye + (16 - Je % 16)), ve !== 0 && (ae.resetIV = !0, Ye = ve - 16);
    }
    ae.rangeStart = Ye, ae.rangeEnd = Qe;
  }
  return ae;
}
function createGapLoadError(ie, Z) {
  const ee = new Error(`GAP ${ie.gap ? "tag" : "attribute"} found`), ae = {
    type: ErrorTypes.MEDIA_ERROR,
    details: ErrorDetails.FRAG_GAP,
    fatal: !1,
    frag: ie,
    error: ee,
    networkDetails: null
  };
  return Z && (ae.part = Z), (Z || ie).stats.aborted = !0, new LoadError(ae);
}
class LoadError extends Error {
  constructor(Z) {
    super(Z.error.message), this.data = void 0, this.data = Z;
  }
}
class AESCrypto {
  constructor(Z, ee) {
    this.subtle = void 0, this.aesIV = void 0, this.subtle = Z, this.aesIV = ee;
  }
  decrypt(Z, ee) {
    return this.subtle.decrypt({
      name: "AES-CBC",
      iv: this.aesIV
    }, ee, Z);
  }
}
class FastAESKey {
  constructor(Z, ee) {
    this.subtle = void 0, this.key = void 0, this.subtle = Z, this.key = ee;
  }
  expandKey() {
    return this.subtle.importKey("raw", this.key, {
      name: "AES-CBC"
    }, !1, ["encrypt", "decrypt"]);
  }
}
function removePadding(ie) {
  const Z = ie.byteLength, ee = Z && new DataView(ie.buffer).getUint8(Z - 1);
  return ee ? sliceUint8(ie, 0, Z - ee) : ie;
}
class AESDecryptor {
  constructor() {
    this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
  }
  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(Z) {
    const ee = new DataView(Z), ae = new Uint32Array(4);
    for (let ve = 0; ve < 4; ve++)
      ae[ve] = ee.getUint32(ve * 4);
    return ae;
  }
  initTable() {
    const Z = this.sBox, ee = this.invSBox, ae = this.subMix, ve = ae[0], ye = ae[1], be = ae[2], Ye = ae[3], Qe = this.invSubMix, Je = Qe[0], nt = Qe[1], st = Qe[2], ot = Qe[3], lt = new Uint32Array(256);
    let ft = 0, gt = 0, ct = 0;
    for (ct = 0; ct < 256; ct++)
      ct < 128 ? lt[ct] = ct << 1 : lt[ct] = ct << 1 ^ 283;
    for (ct = 0; ct < 256; ct++) {
      let _r = gt ^ gt << 1 ^ gt << 2 ^ gt << 3 ^ gt << 4;
      _r = _r >>> 8 ^ _r & 255 ^ 99, Z[ft] = _r, ee[_r] = ft;
      const Kr = lt[ft], Xr = lt[Kr], Jr = lt[Xr];
      let ei = lt[_r] * 257 ^ _r * 16843008;
      ve[ft] = ei << 24 | ei >>> 8, ye[ft] = ei << 16 | ei >>> 16, be[ft] = ei << 8 | ei >>> 24, Ye[ft] = ei, ei = Jr * 16843009 ^ Xr * 65537 ^ Kr * 257 ^ ft * 16843008, Je[_r] = ei << 24 | ei >>> 8, nt[_r] = ei << 16 | ei >>> 16, st[_r] = ei << 8 | ei >>> 24, ot[_r] = ei, ft ? (ft = Kr ^ lt[lt[lt[Jr ^ Kr]]], gt ^= lt[lt[gt]]) : ft = gt = 1;
    }
  }
  expandKey(Z) {
    const ee = this.uint8ArrayToUint32Array_(Z);
    let ae = !0, ve = 0;
    for (; ve < ee.length && ae; )
      ae = ee[ve] === this.key[ve], ve++;
    if (ae)
      return;
    this.key = ee;
    const ye = this.keySize = ee.length;
    if (ye !== 4 && ye !== 6 && ye !== 8)
      throw new Error("Invalid aes key size=" + ye);
    const be = this.ksRows = (ye + 6 + 1) * 4;
    let Ye, Qe;
    const Je = this.keySchedule = new Uint32Array(be), nt = this.invKeySchedule = new Uint32Array(be), st = this.sBox, ot = this.rcon, lt = this.invSubMix, ft = lt[0], gt = lt[1], ct = lt[2], _r = lt[3];
    let Kr, Xr;
    for (Ye = 0; Ye < be; Ye++) {
      if (Ye < ye) {
        Kr = Je[Ye] = ee[Ye];
        continue;
      }
      Xr = Kr, Ye % ye === 0 ? (Xr = Xr << 8 | Xr >>> 24, Xr = st[Xr >>> 24] << 24 | st[Xr >>> 16 & 255] << 16 | st[Xr >>> 8 & 255] << 8 | st[Xr & 255], Xr ^= ot[Ye / ye | 0] << 24) : ye > 6 && Ye % ye === 4 && (Xr = st[Xr >>> 24] << 24 | st[Xr >>> 16 & 255] << 16 | st[Xr >>> 8 & 255] << 8 | st[Xr & 255]), Je[Ye] = Kr = (Je[Ye - ye] ^ Xr) >>> 0;
    }
    for (Qe = 0; Qe < be; Qe++)
      Ye = be - Qe, Qe & 3 ? Xr = Je[Ye] : Xr = Je[Ye - 4], Qe < 4 || Ye <= 4 ? nt[Qe] = Xr : nt[Qe] = ft[st[Xr >>> 24]] ^ gt[st[Xr >>> 16 & 255]] ^ ct[st[Xr >>> 8 & 255]] ^ _r[st[Xr & 255]], nt[Qe] = nt[Qe] >>> 0;
  }
  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(Z) {
    return Z << 24 | (Z & 65280) << 8 | (Z & 16711680) >> 8 | Z >>> 24;
  }
  decrypt(Z, ee, ae) {
    const ve = this.keySize + 6, ye = this.invKeySchedule, be = this.invSBox, Ye = this.invSubMix, Qe = Ye[0], Je = Ye[1], nt = Ye[2], st = Ye[3], ot = this.uint8ArrayToUint32Array_(ae);
    let lt = ot[0], ft = ot[1], gt = ot[2], ct = ot[3];
    const _r = new Int32Array(Z), Kr = new Int32Array(_r.length);
    let Xr, Jr, ei, si, ri, ai, yi, pi, di, xi, Ti, Ai, mi, Si;
    const gi = this.networkToHostOrderSwap;
    for (; ee < _r.length; ) {
      for (di = gi(_r[ee]), xi = gi(_r[ee + 1]), Ti = gi(_r[ee + 2]), Ai = gi(_r[ee + 3]), ri = di ^ ye[0], ai = Ai ^ ye[1], yi = Ti ^ ye[2], pi = xi ^ ye[3], mi = 4, Si = 1; Si < ve; Si++)
        Xr = Qe[ri >>> 24] ^ Je[ai >> 16 & 255] ^ nt[yi >> 8 & 255] ^ st[pi & 255] ^ ye[mi], Jr = Qe[ai >>> 24] ^ Je[yi >> 16 & 255] ^ nt[pi >> 8 & 255] ^ st[ri & 255] ^ ye[mi + 1], ei = Qe[yi >>> 24] ^ Je[pi >> 16 & 255] ^ nt[ri >> 8 & 255] ^ st[ai & 255] ^ ye[mi + 2], si = Qe[pi >>> 24] ^ Je[ri >> 16 & 255] ^ nt[ai >> 8 & 255] ^ st[yi & 255] ^ ye[mi + 3], ri = Xr, ai = Jr, yi = ei, pi = si, mi = mi + 4;
      Xr = be[ri >>> 24] << 24 ^ be[ai >> 16 & 255] << 16 ^ be[yi >> 8 & 255] << 8 ^ be[pi & 255] ^ ye[mi], Jr = be[ai >>> 24] << 24 ^ be[yi >> 16 & 255] << 16 ^ be[pi >> 8 & 255] << 8 ^ be[ri & 255] ^ ye[mi + 1], ei = be[yi >>> 24] << 24 ^ be[pi >> 16 & 255] << 16 ^ be[ri >> 8 & 255] << 8 ^ be[ai & 255] ^ ye[mi + 2], si = be[pi >>> 24] << 24 ^ be[ri >> 16 & 255] << 16 ^ be[ai >> 8 & 255] << 8 ^ be[yi & 255] ^ ye[mi + 3], Kr[ee] = gi(Xr ^ lt), Kr[ee + 1] = gi(si ^ ft), Kr[ee + 2] = gi(ei ^ gt), Kr[ee + 3] = gi(Jr ^ ct), lt = di, ft = xi, gt = Ti, ct = Ai, ee = ee + 4;
    }
    return Kr.buffer;
  }
}
const CHUNK_SIZE = 16;
class Decrypter {
  constructor(Z, {
    removePKCS7Padding: ee = !0
  } = {}) {
    if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.useSoftware = Z.enableSoftwareAES, this.removePKCS7Padding = ee, ee)
      try {
        const ae = self.crypto;
        ae && (this.subtle = ae.subtle || ae.webkitSubtle);
      } catch {
      }
    this.subtle === null && (this.useSoftware = !0);
  }
  destroy() {
    this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult: Z,
      remainderData: ee
    } = this;
    if (!Z || ee)
      return this.reset(), null;
    const ae = new Uint8Array(Z);
    return this.reset(), this.removePKCS7Padding ? removePadding(ae) : ae;
  }
  reset() {
    this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
  }
  decrypt(Z, ee, ae) {
    return this.useSoftware ? new Promise((ve, ye) => {
      this.softwareDecrypt(new Uint8Array(Z), ee, ae);
      const be = this.flush();
      be ? ve(be.buffer) : ye(new Error("[softwareDecrypt] Failed to decrypt data"));
    }) : this.webCryptoDecrypt(new Uint8Array(Z), ee, ae);
  }
  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(Z, ee, ae) {
    const {
      currentIV: ve,
      currentResult: ye,
      remainderData: be
    } = this;
    this.logOnce("JS AES decrypt"), be && (Z = appendUint8Array(be, Z), this.remainderData = null);
    const Ye = this.getValidChunk(Z);
    if (!Ye.length)
      return null;
    ve && (ae = ve);
    let Qe = this.softwareDecrypter;
    Qe || (Qe = this.softwareDecrypter = new AESDecryptor()), Qe.expandKey(ee);
    const Je = ye;
    return this.currentResult = Qe.decrypt(Ye.buffer, 0, ae), this.currentIV = sliceUint8(Ye, -16).buffer, Je || null;
  }
  webCryptoDecrypt(Z, ee, ae) {
    const ve = this.subtle;
    return (this.key !== ee || !this.fastAesKey) && (this.key = ee, this.fastAesKey = new FastAESKey(ve, ee)), this.fastAesKey.expandKey().then((ye) => ve ? (this.logOnce("WebCrypto AES decrypt"), new AESCrypto(ve, new Uint8Array(ae)).decrypt(Z.buffer, ye)) : Promise.reject(new Error("web crypto not initialized"))).catch((ye) => (logger.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${ye.name}: ${ye.message}`), this.onWebCryptoError(Z, ee, ae)));
  }
  onWebCryptoError(Z, ee, ae) {
    this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(Z, ee, ae);
    const ve = this.flush();
    if (ve)
      return ve.buffer;
    throw new Error("WebCrypto and softwareDecrypt: failed to decrypt data");
  }
  getValidChunk(Z) {
    let ee = Z;
    const ae = Z.length - Z.length % CHUNK_SIZE;
    return ae !== Z.length && (ee = sliceUint8(Z, 0, ae), this.remainderData = sliceUint8(Z, ae)), ee;
  }
  logOnce(Z) {
    this.logEnabled && (logger.log(`[decrypter]: ${Z}`), this.logEnabled = !1);
  }
}
const TimeRanges = {
  toString: function(ie) {
    let Z = "";
    const ee = ie.length;
    for (let ae = 0; ae < ee; ae++)
      Z += `[${ie.start(ae).toFixed(3)}-${ie.end(ae).toFixed(3)}]`;
    return Z;
  }
}, State = {
  STOPPED: "STOPPED",
  IDLE: "IDLE",
  KEY_LOADING: "KEY_LOADING",
  FRAG_LOADING: "FRAG_LOADING",
  FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
  WAITING_TRACK: "WAITING_TRACK",
  PARSING: "PARSING",
  PARSED: "PARSED",
  ENDED: "ENDED",
  ERROR: "ERROR",
  WAITING_INIT_PTS: "WAITING_INIT_PTS",
  WAITING_LEVEL: "WAITING_LEVEL"
};
class BaseStreamController extends TaskLoop {
  constructor(Z, ee, ae, ve, ye) {
    super(), this.hls = void 0, this.fragPrevious = null, this.fragCurrent = null, this.fragmentTracker = void 0, this.transmuxer = null, this._state = State.STOPPED, this.playlistType = void 0, this.media = null, this.mediaBuffer = null, this.config = void 0, this.bitrateTest = !1, this.lastCurrentTime = 0, this.nextLoadPosition = 0, this.startPosition = 0, this.startTimeOffset = null, this.loadedmetadata = !1, this.retryDate = 0, this.levels = null, this.fragmentLoader = void 0, this.keyLoader = void 0, this.levelLastLoaded = null, this.startFragRequested = !1, this.decrypter = void 0, this.initPTS = [], this.onvseeking = null, this.onvended = null, this.logPrefix = "", this.log = void 0, this.warn = void 0, this.playlistType = ye, this.logPrefix = ve, this.log = logger.log.bind(logger, `${ve}:`), this.warn = logger.warn.bind(logger, `${ve}:`), this.hls = Z, this.fragmentLoader = new FragmentLoader(Z.config), this.keyLoader = ae, this.fragmentTracker = ee, this.config = Z.config, this.decrypter = new Decrypter(Z.config), Z.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  startLoad(Z) {
  }
  stopLoad() {
    this.fragmentLoader.abort(), this.keyLoader.abort(this.playlistType);
    const Z = this.fragCurrent;
    Z != null && Z.loader && (Z.abortRequests(), this.fragmentTracker.removeFragment(Z)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = State.STOPPED;
  }
  _streamEnded(Z, ee) {
    if (ee.live || Z.nextStart || !Z.end || !this.media)
      return !1;
    const ae = ee.partList;
    if (ae != null && ae.length) {
      const ye = ae[ae.length - 1];
      return BufferHelper.isBuffered(this.media, ye.start + ye.duration / 2);
    }
    const ve = ee.fragments[ee.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(ve);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var Z;
      return (Z = this.levelLastLoaded) == null ? void 0 : Z.details;
    }
  }
  onMediaAttached(Z, ee) {
    const ae = this.media = this.mediaBuffer = ee.media;
    this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), ae.addEventListener("seeking", this.onvseeking), ae.addEventListener("ended", this.onvended);
    const ve = this.config;
    this.levels && ve.autoStartLoad && this.state === State.STOPPED && this.startLoad(ve.startPosition);
  }
  onMediaDetaching() {
    const Z = this.media;
    Z != null && Z.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), Z && this.onvseeking && this.onvended && (Z.removeEventListener("seeking", this.onvseeking), Z.removeEventListener("ended", this.onvended), this.onvseeking = this.onvended = null), this.keyLoader && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
  }
  onMediaSeeking() {
    const {
      config: Z,
      fragCurrent: ee,
      media: ae,
      mediaBuffer: ve,
      state: ye
    } = this, be = ae ? ae.currentTime : 0, Ye = BufferHelper.bufferInfo(ve || ae, be, Z.maxBufferHole);
    if (this.log(`media seeking to ${isFiniteNumber(be) ? be.toFixed(3) : be}, state: ${ye}`), this.state === State.ENDED)
      this.resetLoadingState();
    else if (ee) {
      const Qe = Z.maxFragLookUpTolerance, Je = ee.start - Qe, nt = ee.start + ee.duration + Qe;
      if (!Ye.len || nt < Ye.start || Je > Ye.end) {
        const st = be > nt;
        (be < Je || st) && (st && ee.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), ee.abortRequests(), this.resetLoadingState()), this.fragPrevious = null);
      }
    }
    ae && (this.fragmentTracker.removeFragmentsInRange(be, 1 / 0, this.playlistType, !0), this.lastCurrentTime = be), !this.loadedmetadata && !Ye.len && (this.nextLoadPosition = this.startPosition = be), this.tickImmediate();
  }
  onMediaEnded() {
    this.startPosition = this.lastCurrentTime = 0;
  }
  onManifestLoaded(Z, ee) {
    this.startTimeOffset = ee.startTimeOffset, this.initPTS = [];
  }
  onHandlerDestroying() {
    this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this), this.stopLoad(), super.onHandlerDestroying(), this.hls = null;
  }
  onHandlerDestroyed() {
    this.state = State.STOPPED, this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, super.onHandlerDestroyed();
  }
  loadFragment(Z, ee, ae) {
    this._loadFragForPlayback(Z, ee, ae);
  }
  _loadFragForPlayback(Z, ee, ae) {
    const ve = (ye) => {
      if (this.fragContextChanged(Z)) {
        this.warn(`Fragment ${Z.sn}${ye.part ? " p: " + ye.part.index : ""} of level ${Z.level} was dropped during download.`), this.fragmentTracker.removeFragment(Z);
        return;
      }
      Z.stats.chunkCount++, this._handleFragmentLoadProgress(ye);
    };
    this._doFragLoad(Z, ee, ae, ve).then((ye) => {
      if (!ye)
        return;
      const be = this.state;
      if (this.fragContextChanged(Z)) {
        (be === State.FRAG_LOADING || !this.fragCurrent && be === State.PARSING) && (this.fragmentTracker.removeFragment(Z), this.state = State.IDLE);
        return;
      }
      "payload" in ye && (this.log(`Loaded fragment ${Z.sn} of level ${Z.level}`), this.hls.trigger(Events.FRAG_LOADED, ye)), this._handleFragmentLoadComplete(ye);
    }).catch((ye) => {
      this.state === State.STOPPED || this.state === State.ERROR || (this.warn(ye), this.resetFragmentLoading(Z));
    });
  }
  clearTrackerIfNeeded(Z) {
    var ee;
    const {
      fragmentTracker: ae
    } = this;
    if (ae.getState(Z) === FragmentState.APPENDING) {
      const ye = Z.type, be = this.getFwdBufferInfo(this.mediaBuffer, ye), Ye = Math.max(Z.duration, be ? be.len : this.config.maxBufferLength);
      this.reduceMaxBufferLength(Ye) && ae.removeFragment(Z);
    } else
      ((ee = this.mediaBuffer) == null ? void 0 : ee.buffered.length) === 0 ? ae.removeAllFragments() : ae.hasParts(Z.type) && (ae.detectPartialFragments({
        frag: Z,
        part: null,
        stats: Z.stats,
        id: Z.type
      }), ae.getState(Z) === FragmentState.PARTIAL && ae.removeFragment(Z));
  }
  checkLiveUpdate(Z) {
    if (Z.updated && !Z.live) {
      const ee = Z.fragments[Z.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: ee,
        part: null,
        stats: ee.stats,
        id: ee.type
      });
    }
    Z.fragments[0] || (Z.deltaUpdateFailed = !0);
  }
  flushMainBuffer(Z, ee, ae = null) {
    if (!(Z - ee))
      return;
    const ve = {
      startOffset: Z,
      endOffset: ee,
      type: ae
    };
    this.hls.trigger(Events.BUFFER_FLUSHING, ve);
  }
  _loadInitSegment(Z, ee) {
    this._doFragLoad(Z, ee).then((ae) => {
      if (!ae || this.fragContextChanged(Z) || !this.levels)
        throw new Error("init load aborted");
      return ae;
    }).then((ae) => {
      const {
        hls: ve
      } = this, {
        payload: ye
      } = ae, be = Z.decryptdata;
      if (ye && ye.byteLength > 0 && be != null && be.key && be.iv && be.method === "AES-128") {
        const Ye = self.performance.now();
        return this.decrypter.decrypt(new Uint8Array(ye), be.key.buffer, be.iv.buffer).catch((Qe) => {
          throw ve.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.FRAG_DECRYPT_ERROR,
            fatal: !1,
            error: Qe,
            reason: Qe.message,
            frag: Z
          }), Qe;
        }).then((Qe) => {
          const Je = self.performance.now();
          return ve.trigger(Events.FRAG_DECRYPTED, {
            frag: Z,
            payload: Qe,
            stats: {
              tstart: Ye,
              tdecrypt: Je
            }
          }), ae.payload = Qe, this.completeInitSegmentLoad(ae);
        });
      }
      return this.completeInitSegmentLoad(ae);
    }).catch((ae) => {
      this.state === State.STOPPED || this.state === State.ERROR || (this.warn(ae), this.resetFragmentLoading(Z));
    });
  }
  completeInitSegmentLoad(Z) {
    const {
      levels: ee
    } = this;
    if (!ee)
      throw new Error("init load aborted, missing levels");
    const ae = Z.frag.stats;
    this.state = State.IDLE, Z.frag.data = new Uint8Array(Z.payload), ae.parsing.start = ae.buffering.start = self.performance.now(), ae.parsing.end = ae.buffering.end = self.performance.now(), this.tick();
  }
  fragContextChanged(Z) {
    const {
      fragCurrent: ee
    } = this;
    return !Z || !ee || Z.sn !== ee.sn || Z.level !== ee.level;
  }
  fragBufferedComplete(Z, ee) {
    var ae, ve, ye, be;
    const Ye = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.log(`Buffered ${Z.type} sn: ${Z.sn}${ee ? " part: " + ee.index : ""} of ${this.playlistType === PlaylistLevelType.MAIN ? "level" : "track"} ${Z.level} (frag:[${((ae = Z.startPTS) != null ? ae : NaN).toFixed(3)}-${((ve = Z.endPTS) != null ? ve : NaN).toFixed(3)}] > buffer:${Ye ? TimeRanges.toString(BufferHelper.getBuffered(Ye)) : "(detached)"})`), Z.sn !== "initSegment") {
      var Qe;
      if (Z.type !== PlaylistLevelType.SUBTITLE) {
        const nt = Z.elementaryStreams;
        if (!Object.keys(nt).some((st) => !!nt[st])) {
          this.state = State.IDLE;
          return;
        }
      }
      const Je = (Qe = this.levels) == null ? void 0 : Qe[Z.level];
      Je != null && Je.fragmentError && (this.log(`Resetting level fragment error count of ${Je.fragmentError} on frag buffered`), Je.fragmentError = 0);
    }
    this.state = State.IDLE, Ye && (!this.loadedmetadata && Z.type == PlaylistLevelType.MAIN && Ye.buffered.length && ((ye = this.fragCurrent) == null ? void 0 : ye.sn) === ((be = this.fragPrevious) == null ? void 0 : be.sn) && (this.loadedmetadata = !0, this.seekToStartPos()), this.tick());
  }
  seekToStartPos() {
  }
  _handleFragmentLoadComplete(Z) {
    const {
      transmuxer: ee
    } = this;
    if (!ee)
      return;
    const {
      frag: ae,
      part: ve,
      partsLoaded: ye
    } = Z, be = !ye || ye.length === 0 || ye.some((Qe) => !Qe), Ye = new ChunkMetadata(ae.level, ae.sn, ae.stats.chunkCount + 1, 0, ve ? ve.index : -1, !be);
    ee.flush(Ye);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _handleFragmentLoadProgress(Z) {
  }
  _doFragLoad(Z, ee, ae = null, ve) {
    var ye;
    const be = ee == null ? void 0 : ee.details;
    if (!this.levels || !be)
      throw new Error(`frag load aborted, missing level${be ? "" : " detail"}s`);
    let Ye = null;
    if (Z.encrypted && !((ye = Z.decryptdata) != null && ye.key) ? (this.log(`Loading key for ${Z.sn} of [${be.startSN}-${be.endSN}], ${this.logPrefix === "[stream-controller]" ? "level" : "track"} ${Z.level}`), this.state = State.KEY_LOADING, this.fragCurrent = Z, Ye = this.keyLoader.load(Z).then((nt) => {
      if (!this.fragContextChanged(nt.frag))
        return this.hls.trigger(Events.KEY_LOADED, nt), this.state === State.KEY_LOADING && (this.state = State.IDLE), nt;
    }), this.hls.trigger(Events.KEY_LOADING, {
      frag: Z
    }), this.fragCurrent === null && (Ye = Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING")))) : !Z.encrypted && be.encryptedFragments.length && this.keyLoader.loadClear(Z, be.encryptedFragments), ae = Math.max(Z.start, ae || 0), this.config.lowLatencyMode && Z.sn !== "initSegment") {
      const nt = be.partList;
      if (nt && ve) {
        ae > Z.end && be.fragmentHint && (Z = be.fragmentHint);
        const st = this.getNextPart(nt, Z, ae);
        if (st > -1) {
          const ot = nt[st];
          this.log(`Loading part sn: ${Z.sn} p: ${ot.index} cc: ${Z.cc} of playlist [${be.startSN}-${be.endSN}] parts [0-${st}-${nt.length - 1}] ${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${Z.level}, target: ${parseFloat(ae.toFixed(3))}`), this.nextLoadPosition = ot.start + ot.duration, this.state = State.FRAG_LOADING;
          let lt;
          return Ye ? lt = Ye.then((ft) => !ft || this.fragContextChanged(ft.frag) ? null : this.doFragPartsLoad(Z, ot, ee, ve)).catch((ft) => this.handleFragLoadError(ft)) : lt = this.doFragPartsLoad(Z, ot, ee, ve).catch((ft) => this.handleFragLoadError(ft)), this.hls.trigger(Events.FRAG_LOADING, {
            frag: Z,
            part: ot,
            targetBufferTime: ae
          }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")) : lt;
        } else if (!Z.url || this.loadedEndOfParts(nt, ae))
          return Promise.resolve(null);
      }
    }
    this.log(`Loading fragment ${Z.sn} cc: ${Z.cc} ${be ? "of [" + be.startSN + "-" + be.endSN + "] " : ""}${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${Z.level}, target: ${parseFloat(ae.toFixed(3))}`), isFiniteNumber(Z.sn) && !this.bitrateTest && (this.nextLoadPosition = Z.start + Z.duration), this.state = State.FRAG_LOADING;
    const Qe = this.config.progressive;
    let Je;
    return Qe && Ye ? Je = Ye.then((nt) => !nt || this.fragContextChanged(nt == null ? void 0 : nt.frag) ? null : this.fragmentLoader.load(Z, ve)).catch((nt) => this.handleFragLoadError(nt)) : Je = Promise.all([this.fragmentLoader.load(Z, Qe ? ve : void 0), Ye]).then(([nt]) => (!Qe && nt && ve && ve(nt), nt)).catch((nt) => this.handleFragLoadError(nt)), this.hls.trigger(Events.FRAG_LOADING, {
      frag: Z,
      targetBufferTime: ae
    }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")) : Je;
  }
  doFragPartsLoad(Z, ee, ae, ve) {
    return new Promise((ye, be) => {
      var Ye;
      const Qe = [], Je = (Ye = ae.details) == null ? void 0 : Ye.partList, nt = (st) => {
        this.fragmentLoader.loadPart(Z, st, ve).then((ot) => {
          Qe[st.index] = ot;
          const lt = ot.part;
          this.hls.trigger(Events.FRAG_LOADED, ot);
          const ft = getPartWith(ae, Z.sn, st.index + 1) || findPart(Je, Z.sn, st.index + 1);
          if (ft)
            nt(ft);
          else
            return ye({
              frag: Z,
              part: lt,
              partsLoaded: Qe
            });
        }).catch(be);
      };
      nt(ee);
    });
  }
  handleFragLoadError(Z) {
    if ("data" in Z) {
      const ee = Z.data;
      Z.data && ee.details === ErrorDetails.INTERNAL_ABORTED ? this.handleFragLoadAborted(ee.frag, ee.part) : this.hls.trigger(Events.ERROR, ee);
    } else
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.INTERNAL_EXCEPTION,
        err: Z,
        error: Z,
        fatal: !0
      });
    return null;
  }
  _handleTransmuxerFlush(Z) {
    const ee = this.getCurrentContext(Z);
    if (!ee || this.state !== State.PARSING) {
      !this.fragCurrent && this.state !== State.STOPPED && this.state !== State.ERROR && (this.state = State.IDLE);
      return;
    }
    const {
      frag: ae,
      part: ve,
      level: ye
    } = ee, be = self.performance.now();
    ae.stats.parsing.end = be, ve && (ve.stats.parsing.end = be), this.updateLevelTiming(ae, ve, ye, Z.partial);
  }
  getCurrentContext(Z) {
    const {
      levels: ee,
      fragCurrent: ae
    } = this, {
      level: ve,
      sn: ye,
      part: be
    } = Z;
    if (!(ee != null && ee[ve]))
      return this.warn(`Levels object was unset while buffering fragment ${ye} of level ${ve}. The current chunk will not be buffered.`), null;
    const Ye = ee[ve], Qe = be > -1 ? getPartWith(Ye, ye, be) : null, Je = Qe ? Qe.fragment : getFragmentWithSN(Ye, ye, ae);
    return Je ? (ae && ae !== Je && (Je.stats = ae.stats), {
      frag: Je,
      part: Qe,
      level: Ye
    }) : null;
  }
  bufferFragmentData(Z, ee, ae, ve, ye) {
    var be;
    if (!Z || this.state !== State.PARSING)
      return;
    const {
      data1: Ye,
      data2: Qe
    } = Z;
    let Je = Ye;
    if (Ye && Qe && (Je = appendUint8Array(Ye, Qe)), !((be = Je) != null && be.length))
      return;
    const nt = {
      type: Z.type,
      frag: ee,
      part: ae,
      chunkMeta: ve,
      parent: ee.type,
      data: Je
    };
    if (this.hls.trigger(Events.BUFFER_APPENDING, nt), Z.dropped && Z.independent && !ae) {
      if (ye)
        return;
      this.flushBufferGap(ee);
    }
  }
  flushBufferGap(Z) {
    const ee = this.media;
    if (!ee)
      return;
    if (!BufferHelper.isBuffered(ee, ee.currentTime)) {
      this.flushMainBuffer(0, Z.start);
      return;
    }
    const ae = ee.currentTime, ve = BufferHelper.bufferInfo(ee, ae, 0), ye = Z.duration, be = Math.min(this.config.maxFragLookUpTolerance * 2, ye * 0.25), Ye = Math.max(Math.min(Z.start - be, ve.end - be), ae + be);
    Z.start - Ye > be && this.flushMainBuffer(Ye, Z.start);
  }
  getFwdBufferInfo(Z, ee) {
    const ae = this.getLoadPosition();
    return isFiniteNumber(ae) ? this.getFwdBufferInfoAtPos(Z, ae, ee) : null;
  }
  getFwdBufferInfoAtPos(Z, ee, ae) {
    const {
      config: {
        maxBufferHole: ve
      }
    } = this, ye = BufferHelper.bufferInfo(Z, ee, ve);
    if (ye.len === 0 && ye.nextStart !== void 0) {
      const be = this.fragmentTracker.getBufferedFrag(ee, ae);
      if (be && ye.nextStart < be.end)
        return BufferHelper.bufferInfo(Z, ee, Math.max(ye.nextStart, ve));
    }
    return ye;
  }
  getMaxBufferLength(Z) {
    const {
      config: ee
    } = this;
    let ae;
    return Z ? ae = Math.max(8 * ee.maxBufferSize / Z, ee.maxBufferLength) : ae = ee.maxBufferLength, Math.min(ae, ee.maxMaxBufferLength);
  }
  reduceMaxBufferLength(Z) {
    const ee = this.config, ae = Z || ee.maxBufferLength;
    return ee.maxMaxBufferLength >= ae ? (ee.maxMaxBufferLength /= 2, this.warn(`Reduce max buffer length to ${ee.maxMaxBufferLength}s`), !0) : !1;
  }
  getAppendedFrag(Z, ee = PlaylistLevelType.MAIN) {
    const ae = this.fragmentTracker.getAppendedFrag(Z, PlaylistLevelType.MAIN);
    return ae && "fragment" in ae ? ae.fragment : ae;
  }
  getNextFragment(Z, ee) {
    const ae = ee.fragments, ve = ae.length;
    if (!ve)
      return null;
    const {
      config: ye
    } = this, be = ae[0].start;
    let Ye;
    if (ee.live) {
      const Qe = ye.initialLiveManifestSize;
      if (ve < Qe)
        return this.warn(`Not enough fragments to start playback (have: ${ve}, need: ${Qe})`), null;
      (!ee.PTSKnown && !this.startFragRequested && this.startPosition === -1 || Z < be) && (Ye = this.getInitialLiveFragment(ee, ae), this.startPosition = this.nextLoadPosition = Ye ? this.hls.liveSyncPosition || Ye.start : Z);
    } else
      Z <= be && (Ye = ae[0]);
    if (!Ye) {
      const Qe = ye.lowLatencyMode ? ee.partEnd : ee.fragmentEnd;
      Ye = this.getFragmentAtPosition(Z, Qe, ee);
    }
    return this.mapToInitFragWhenRequired(Ye);
  }
  isLoopLoading(Z, ee) {
    const ae = this.fragmentTracker.getState(Z);
    return (ae === FragmentState.OK || ae === FragmentState.PARTIAL && !!Z.gap) && this.nextLoadPosition > ee;
  }
  getNextFragmentLoopLoading(Z, ee, ae, ve, ye) {
    const be = Z.gap, Ye = this.getNextFragment(this.nextLoadPosition, ee);
    if (Ye === null)
      return Ye;
    if (Z = Ye, be && Z && !Z.gap && ae.nextStart) {
      const Qe = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, ae.nextStart, ve);
      if (Qe !== null && ae.len + Qe.len >= ye)
        return this.log(`buffer full after gaps in "${ve}" playlist starting at sn: ${Z.sn}`), null;
    }
    return Z;
  }
  mapToInitFragWhenRequired(Z) {
    return Z != null && Z.initSegment && !(Z != null && Z.initSegment.data) && !this.bitrateTest ? Z.initSegment : Z;
  }
  getNextPart(Z, ee, ae) {
    let ve = -1, ye = !1, be = !0;
    for (let Ye = 0, Qe = Z.length; Ye < Qe; Ye++) {
      const Je = Z[Ye];
      if (be = be && !Je.independent, ve > -1 && ae < Je.start)
        break;
      const nt = Je.loaded;
      nt ? ve = -1 : (ye || Je.independent || be) && Je.fragment === ee && (ve = Ye), ye = nt;
    }
    return ve;
  }
  loadedEndOfParts(Z, ee) {
    const ae = Z[Z.length - 1];
    return ae && ee > ae.start && ae.loaded;
  }
  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(Z, ee) {
    const ae = this.fragPrevious;
    let ve = null;
    if (ae) {
      if (Z.hasProgramDateTime && (this.log(`Live playlist, switching playlist, load frag with same PDT: ${ae.programDateTime}`), ve = findFragmentByPDT(ee, ae.endProgramDateTime, this.config.maxFragLookUpTolerance)), !ve) {
        const ye = ae.sn + 1;
        if (ye >= Z.startSN && ye <= Z.endSN) {
          const be = ee[ye - Z.startSN];
          ae.cc === be.cc && (ve = be, this.log(`Live playlist, switching playlist, load frag with next SN: ${ve.sn}`));
        }
        ve || (ve = findFragWithCC(ee, ae.cc), ve && this.log(`Live playlist, switching playlist, load frag with same CC: ${ve.sn}`));
      }
    } else {
      const ye = this.hls.liveSyncPosition;
      ye !== null && (ve = this.getFragmentAtPosition(ye, this.bitrateTest ? Z.fragmentEnd : Z.edge, Z));
    }
    return ve;
  }
  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(Z, ee, ae) {
    const {
      config: ve
    } = this;
    let {
      fragPrevious: ye
    } = this, {
      fragments: be,
      endSN: Ye
    } = ae;
    const {
      fragmentHint: Qe
    } = ae, Je = ve.maxFragLookUpTolerance, nt = ae.partList, st = !!(ve.lowLatencyMode && nt != null && nt.length && Qe);
    st && Qe && !this.bitrateTest && (be = be.concat(Qe), Ye = Qe.sn);
    let ot;
    if (Z < ee) {
      const lt = Z > ee - Je ? 0 : Je;
      ot = findFragmentByPTS(ye, be, Z, lt);
    } else
      ot = be[be.length - 1];
    if (ot) {
      const lt = ot.sn - ae.startSN, ft = this.fragmentTracker.getState(ot);
      if ((ft === FragmentState.OK || ft === FragmentState.PARTIAL && ot.gap) && (ye = ot), ye && ot.sn === ye.sn && (!st || nt[0].fragment.sn > ot.sn) && ye && ot.level === ye.level) {
        const ct = be[lt + 1];
        ot.sn < Ye && this.fragmentTracker.getState(ct) !== FragmentState.OK ? ot = ct : ot = null;
      }
    }
    return ot;
  }
  synchronizeToLiveEdge(Z) {
    const {
      config: ee,
      media: ae
    } = this;
    if (!ae)
      return;
    const ve = this.hls.liveSyncPosition, ye = ae.currentTime, be = Z.fragments[0].start, Ye = Z.edge, Qe = ye >= be - ee.maxFragLookUpTolerance && ye <= Ye;
    if (ve !== null && ae.duration > ve && (ye < ve || !Qe)) {
      const Je = ee.liveMaxLatencyDuration !== void 0 ? ee.liveMaxLatencyDuration : ee.liveMaxLatencyDurationCount * Z.targetduration;
      (!Qe && ae.readyState < 4 || ye < Ye - Je) && (this.loadedmetadata || (this.nextLoadPosition = ve), ae.readyState && (this.warn(`Playback: ${ye.toFixed(3)} is located too far from the end of live sliding playlist: ${Ye}, reset currentTime to : ${ve.toFixed(3)}`), ae.currentTime = ve));
    }
  }
  alignPlaylists(Z, ee, ae) {
    const ve = Z.fragments.length;
    if (!ve)
      return this.warn("No fragments in live playlist"), 0;
    const ye = Z.fragments[0].start, be = !ee, Ye = Z.alignedSliding && isFiniteNumber(ye);
    if (be || !Ye && !ye) {
      const {
        fragPrevious: Qe
      } = this;
      alignStream(Qe, ae, Z);
      const Je = Z.fragments[0].start;
      return this.log(`Live playlist sliding: ${Je.toFixed(2)} start-sn: ${ee ? ee.startSN : "na"}->${Z.startSN} prev-sn: ${Qe ? Qe.sn : "na"} fragments: ${ve}`), Je;
    }
    return ye;
  }
  waitForCdnTuneIn(Z) {
    return Z.live && Z.canBlockReload && Z.partTarget && Z.tuneInGoal > Math.max(Z.partHoldBack, Z.partTarget * 3);
  }
  setStartPosition(Z, ee) {
    let ae = this.startPosition;
    if (ae < ee && (ae = -1), ae === -1 || this.lastCurrentTime === -1) {
      const ve = this.startTimeOffset !== null, ye = ve ? this.startTimeOffset : Z.startTimeOffset;
      ye !== null && isFiniteNumber(ye) ? (ae = ee + ye, ye < 0 && (ae += Z.totalduration), ae = Math.min(Math.max(ee, ae), ee + Z.totalduration), this.log(`Start time offset ${ye} found in ${ve ? "multivariant" : "media"} playlist, adjust startPosition to ${ae}`), this.startPosition = ae) : Z.live ? ae = this.hls.liveSyncPosition || ee : this.startPosition = ae = 0, this.lastCurrentTime = ae;
    }
    this.nextLoadPosition = ae;
  }
  getLoadPosition() {
    const {
      media: Z
    } = this;
    let ee = 0;
    return this.loadedmetadata && Z ? ee = Z.currentTime : this.nextLoadPosition && (ee = this.nextLoadPosition), ee;
  }
  handleFragLoadAborted(Z, ee) {
    this.transmuxer && Z.sn !== "initSegment" && Z.stats.aborted && (this.warn(`Fragment ${Z.sn}${ee ? " part " + ee.index : ""} of level ${Z.level} was aborted`), this.resetFragmentLoading(Z));
  }
  resetFragmentLoading(Z) {
    (!this.fragCurrent || !this.fragContextChanged(Z) && this.state !== State.FRAG_LOADING_WAITING_RETRY) && (this.state = State.IDLE);
  }
  onFragmentOrKeyLoadError(Z, ee) {
    if (ee.chunkMeta && !ee.frag) {
      const nt = this.getCurrentContext(ee.chunkMeta);
      nt && (ee.frag = nt.frag);
    }
    const ae = ee.frag;
    if (!ae || ae.type !== Z || !this.levels)
      return;
    if (this.fragContextChanged(ae)) {
      var ve;
      this.warn(`Frag load error must match current frag to retry ${ae.url} > ${(ve = this.fragCurrent) == null ? void 0 : ve.url}`);
      return;
    }
    const ye = ee.details === ErrorDetails.FRAG_GAP;
    ye && this.fragmentTracker.fragBuffered(ae, !0);
    const be = ee.errorAction, {
      action: Ye,
      retryCount: Qe = 0,
      retryConfig: Je
    } = be || {};
    if (be && Ye === NetworkErrorAction.RetryRequest && Je) {
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      const nt = getRetryDelay(Je, Qe);
      this.warn(`Fragment ${ae.sn} of ${Z} ${ae.level} errored with ${ee.details}, retrying loading ${Qe + 1}/${Je.maxNumRetry} in ${nt}ms`), be.resolved = !0, this.retryDate = self.performance.now() + nt, this.state = State.FRAG_LOADING_WAITING_RETRY;
    } else if (Je && be)
      if (this.resetFragmentErrors(Z), Qe < Je.maxNumRetry)
        !ye && Ye !== NetworkErrorAction.RemoveAlternatePermanently && (be.resolved = !0);
      else {
        logger.warn(`${ee.details} reached or exceeded max retry (${Qe})`);
        return;
      }
    else
      (be == null ? void 0 : be.action) === NetworkErrorAction.SendAlternateToPenaltyBox ? this.state = State.WAITING_LEVEL : this.state = State.ERROR;
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(Z) {
    if (this.state === State.PARSING || this.state === State.PARSED) {
      const ee = Z.parent, ae = this.getFwdBufferInfo(this.mediaBuffer, ee), ve = ae && ae.len > 0.5;
      ve && this.reduceMaxBufferLength(ae.len);
      const ye = !ve;
      return ye && this.warn(`Buffer full error while media.currentTime is not buffered, flush ${ee} buffer`), Z.frag && (this.fragmentTracker.removeFragment(Z.frag), this.nextLoadPosition = Z.frag.start), this.resetLoadingState(), ye;
    }
    return !1;
  }
  resetFragmentErrors(Z) {
    Z === PlaylistLevelType.AUDIO && (this.fragCurrent = null), this.loadedmetadata || (this.startFragRequested = !1), this.state !== State.STOPPED && (this.state = State.IDLE);
  }
  afterBufferFlushed(Z, ee, ae) {
    if (!Z)
      return;
    const ve = BufferHelper.getBuffered(Z);
    this.fragmentTracker.detectEvictedFragments(ee, ve, ae), this.state === State.ENDED && this.resetLoadingState();
  }
  resetLoadingState() {
    this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state = State.IDLE;
  }
  resetStartWhenNotLoaded(Z) {
    if (!this.loadedmetadata) {
      this.startFragRequested = !1;
      const ee = Z ? Z.details : null;
      ee != null && ee.live ? (this.startPosition = -1, this.setStartPosition(ee, 0), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
    }
  }
  resetWhenMissingContext(Z) {
    this.warn(`The loading context changed while buffering fragment ${Z.sn} of level ${Z.level}. This chunk will not be buffered.`), this.removeUnbufferedFrags(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState();
  }
  removeUnbufferedFrags(Z = 0) {
    this.fragmentTracker.removeFragmentsInRange(Z, 1 / 0, this.playlistType, !1, !0);
  }
  updateLevelTiming(Z, ee, ae, ve) {
    var ye;
    const be = ae.details;
    if (!be) {
      this.warn("level.details undefined");
      return;
    }
    if (!Object.keys(Z.elementaryStreams).reduce((Qe, Je) => {
      const nt = Z.elementaryStreams[Je];
      if (nt) {
        const st = nt.endPTS - nt.startPTS;
        if (st <= 0)
          return this.warn(`Could not parse fragment ${Z.sn} ${Je} duration reliably (${st})`), Qe || !1;
        const ot = ve ? 0 : updateFragPTSDTS(be, Z, nt.startPTS, nt.endPTS, nt.startDTS, nt.endDTS);
        return this.hls.trigger(Events.LEVEL_PTS_UPDATED, {
          details: be,
          level: ae,
          drift: ot,
          type: Je,
          frag: Z,
          start: nt.startPTS,
          end: nt.endPTS
        }), !0;
      }
      return Qe;
    }, !1) && ((ye = this.transmuxer) == null ? void 0 : ye.error) === null) {
      const Qe = new Error(`Found no media in fragment ${Z.sn} of level ${Z.level} resetting transmuxer to fallback to playlist timing`);
      if (ae.fragmentError === 0 && (ae.fragmentError++, Z.gap = !0, this.fragmentTracker.removeFragment(Z), this.fragmentTracker.fragBuffered(Z, !0)), this.warn(Qe.message), this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.FRAG_PARSING_ERROR,
        fatal: !1,
        error: Qe,
        frag: Z,
        reason: `Found no media in msn ${Z.sn} of level "${ae.url}"`
      }), !this.hls)
        return;
      this.resetTransmuxer();
    }
    this.state = State.PARSED, this.hls.trigger(Events.FRAG_PARSED, {
      frag: Z,
      part: ee
    });
  }
  resetTransmuxer() {
    this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null);
  }
  recoverWorkerError(Z) {
    Z.event === "demuxerWorker" && (this.fragmentTracker.removeAllFragments(), this.resetTransmuxer(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState());
  }
  set state(Z) {
    const ee = this._state;
    ee !== Z && (this._state = Z, this.log(`${ee}->${Z}`));
  }
  get state() {
    return this._state;
  }
}
class ChunkCache {
  constructor() {
    this.chunks = [], this.dataLength = 0;
  }
  push(Z) {
    this.chunks.push(Z), this.dataLength += Z.length;
  }
  flush() {
    const {
      chunks: Z,
      dataLength: ee
    } = this;
    let ae;
    if (Z.length)
      Z.length === 1 ? ae = Z[0] : ae = concatUint8Arrays(Z, ee);
    else
      return new Uint8Array(0);
    return this.reset(), ae;
  }
  reset() {
    this.chunks.length = 0, this.dataLength = 0;
  }
}
function concatUint8Arrays(ie, Z) {
  const ee = new Uint8Array(Z);
  let ae = 0;
  for (let ve = 0; ve < ie.length; ve++) {
    const ye = ie[ve];
    ee.set(ye, ae), ae += ye.length;
  }
  return ee;
}
function hasUMDWorker() {
  return typeof __HLS_WORKER_BUNDLE__ == "function";
}
function injectWorker() {
  const ie = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: "text/javascript"
  }), Z = self.URL.createObjectURL(ie);
  return {
    worker: new self.Worker(Z),
    objectURL: Z
  };
}
function loadWorker(ie) {
  const Z = new self.URL(ie, self.location.href).href;
  return {
    worker: new self.Worker(Z),
    scriptURL: Z
  };
}
function dummyTrack(ie = "", Z = 9e4) {
  return {
    type: ie,
    id: -1,
    pid: -1,
    inputTimeScale: Z,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}
class BaseAudioDemuxer {
  constructor() {
    this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
  }
  resetInitSegment(Z, ee, ae, ve) {
    this._id3Track = {
      type: "id3",
      id: 3,
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(Z) {
    this.initPTS = Z, this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
  }
  canParse(Z, ee) {
    return !1;
  }
  appendFrame(Z, ee, ae) {
  }
  // feed incoming data to the front of the parsing pipeline
  demux(Z, ee) {
    this.cachedData && (Z = appendUint8Array(this.cachedData, Z), this.cachedData = null);
    let ae = getID3Data(Z, 0), ve = ae ? ae.length : 0, ye;
    const be = this._audioTrack, Ye = this._id3Track, Qe = ae ? getTimeStamp(ae) : void 0, Je = Z.length;
    for ((this.basePTS === null || this.frameIndex === 0 && isFiniteNumber(Qe)) && (this.basePTS = initPTSFn(Qe, ee, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), ae && ae.length > 0 && Ye.samples.push({
      pts: this.lastPTS,
      dts: this.lastPTS,
      data: ae,
      type: MetadataSchema.audioId3,
      duration: Number.POSITIVE_INFINITY
    }); ve < Je; ) {
      if (this.canParse(Z, ve)) {
        const nt = this.appendFrame(be, Z, ve);
        nt ? (this.frameIndex++, this.lastPTS = nt.sample.pts, ve += nt.length, ye = ve) : ve = Je;
      } else
        canParse$2(Z, ve) ? (ae = getID3Data(Z, ve), Ye.samples.push({
          pts: this.lastPTS,
          dts: this.lastPTS,
          data: ae,
          type: MetadataSchema.audioId3,
          duration: Number.POSITIVE_INFINITY
        }), ve += ae.length, ye = ve) : ve++;
      if (ve === Je && ye !== Je) {
        const nt = sliceUint8(Z, ye);
        this.cachedData ? this.cachedData = appendUint8Array(this.cachedData, nt) : this.cachedData = nt;
      }
    }
    return {
      audioTrack: be,
      videoTrack: dummyTrack(),
      id3Track: Ye,
      textTrack: dummyTrack()
    };
  }
  demuxSampleAes(Z, ee, ae) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(Z) {
    const ee = this.cachedData;
    return ee && (this.cachedData = null, this.demux(ee, 0)), {
      audioTrack: this._audioTrack,
      videoTrack: dummyTrack(),
      id3Track: this._id3Track,
      textTrack: dummyTrack()
    };
  }
  destroy() {
  }
}
const initPTSFn = (ie, Z, ee) => {
  if (isFiniteNumber(ie))
    return ie * 90;
  const ae = ee ? ee.baseTime * 9e4 / ee.timescale : 0;
  return Z * 9e4 + ae;
};
function getAudioConfig(ie, Z, ee, ae) {
  let ve, ye, be, Ye;
  const Qe = navigator.userAgent.toLowerCase(), Je = ae, nt = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  ve = ((Z[ee + 2] & 192) >>> 6) + 1;
  const st = (Z[ee + 2] & 60) >>> 2;
  if (st > nt.length - 1) {
    const ot = new Error(`invalid ADTS sampling index:${st}`);
    ie.emit(Events.ERROR, Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.FRAG_PARSING_ERROR,
      fatal: !0,
      error: ot,
      reason: ot.message
    });
    return;
  }
  return be = (Z[ee + 2] & 1) << 2, be |= (Z[ee + 3] & 192) >>> 6, logger.log(`manifest codec:${ae}, ADTS type:${ve}, samplingIndex:${st}`), /firefox/i.test(Qe) ? st >= 6 ? (ve = 5, Ye = new Array(4), ye = st - 3) : (ve = 2, Ye = new Array(2), ye = st) : Qe.indexOf("android") !== -1 ? (ve = 2, Ye = new Array(2), ye = st) : (ve = 5, Ye = new Array(4), ae && (ae.indexOf("mp4a.40.29") !== -1 || ae.indexOf("mp4a.40.5") !== -1) || !ae && st >= 6 ? ye = st - 3 : ((ae && ae.indexOf("mp4a.40.2") !== -1 && (st >= 6 && be === 1 || /vivaldi/i.test(Qe)) || !ae && be === 1) && (ve = 2, Ye = new Array(2)), ye = st)), Ye[0] = ve << 3, Ye[0] |= (st & 14) >> 1, Ye[1] |= (st & 1) << 7, Ye[1] |= be << 3, ve === 5 && (Ye[1] |= (ye & 14) >> 1, Ye[2] = (ye & 1) << 7, Ye[2] |= 8, Ye[3] = 0), {
    config: Ye,
    samplerate: nt[st],
    channelCount: be,
    codec: "mp4a.40." + ve,
    manifestCodec: Je
  };
}
function isHeaderPattern$1(ie, Z) {
  return ie[Z] === 255 && (ie[Z + 1] & 246) === 240;
}
function getHeaderLength(ie, Z) {
  return ie[Z + 1] & 1 ? 7 : 9;
}
function getFullFrameLength(ie, Z) {
  return (ie[Z + 3] & 3) << 11 | ie[Z + 4] << 3 | (ie[Z + 5] & 224) >>> 5;
}
function canGetFrameLength(ie, Z) {
  return Z + 5 < ie.length;
}
function isHeader$1(ie, Z) {
  return Z + 1 < ie.length && isHeaderPattern$1(ie, Z);
}
function canParse$1(ie, Z) {
  return canGetFrameLength(ie, Z) && isHeaderPattern$1(ie, Z) && getFullFrameLength(ie, Z) <= ie.length - Z;
}
function probe$1(ie, Z) {
  if (isHeader$1(ie, Z)) {
    const ee = getHeaderLength(ie, Z);
    if (Z + ee >= ie.length)
      return !1;
    const ae = getFullFrameLength(ie, Z);
    if (ae <= ee)
      return !1;
    const ve = Z + ae;
    return ve === ie.length || isHeader$1(ie, ve);
  }
  return !1;
}
function initTrackConfig(ie, Z, ee, ae, ve) {
  if (!ie.samplerate) {
    const ye = getAudioConfig(Z, ee, ae, ve);
    if (!ye)
      return;
    ie.config = ye.config, ie.samplerate = ye.samplerate, ie.channelCount = ye.channelCount, ie.codec = ye.codec, ie.manifestCodec = ye.manifestCodec, logger.log(`parsed codec:${ie.codec}, rate:${ye.samplerate}, channels:${ye.channelCount}`);
  }
}
function getFrameDuration(ie) {
  return 1024 * 9e4 / ie;
}
function parseFrameHeader(ie, Z) {
  const ee = getHeaderLength(ie, Z);
  if (Z + ee <= ie.length) {
    const ae = getFullFrameLength(ie, Z) - ee;
    if (ae > 0)
      return {
        headerLength: ee,
        frameLength: ae
      };
  }
}
function appendFrame$2(ie, Z, ee, ae, ve) {
  const ye = getFrameDuration(ie.samplerate), be = ae + ve * ye, Ye = parseFrameHeader(Z, ee);
  let Qe;
  if (Ye) {
    const {
      frameLength: st,
      headerLength: ot
    } = Ye, lt = ot + st, ft = Math.max(0, ee + lt - Z.length);
    ft ? (Qe = new Uint8Array(lt - ot), Qe.set(Z.subarray(ee + ot, Z.length), 0)) : Qe = Z.subarray(ee + ot, ee + lt);
    const gt = {
      unit: Qe,
      pts: be
    };
    return ft || ie.samples.push(gt), {
      sample: gt,
      length: lt,
      missing: ft
    };
  }
  const Je = Z.length - ee;
  return Qe = new Uint8Array(Je), Qe.set(Z.subarray(ee, Z.length), 0), {
    sample: {
      unit: Qe,
      pts: be
    },
    length: Je,
    missing: -1
  };
}
let chromeVersion$1 = null;
const BitratesMap = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], SamplingRateMap = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], SamplesCoefficients = [
  // MPEG 2.5
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // Reserved
  [
    0,
    // Reserved
    0,
    // Layer3
    0,
    // Layer2
    0
    // Layer1
  ],
  // MPEG 2
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // MPEG 1
  [
    0,
    // Reserved
    144,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ]
], BytesInSlot = [
  0,
  // Reserved
  1,
  // Layer3
  1,
  // Layer2
  4
  // Layer1
];
function appendFrame$1(ie, Z, ee, ae, ve) {
  if (ee + 24 > Z.length)
    return;
  const ye = parseHeader(Z, ee);
  if (ye && ee + ye.frameLength <= Z.length) {
    const be = ye.samplesPerFrame * 9e4 / ye.sampleRate, Ye = ae + ve * be, Qe = {
      unit: Z.subarray(ee, ee + ye.frameLength),
      pts: Ye,
      dts: Ye
    };
    return ie.config = [], ie.channelCount = ye.channelCount, ie.samplerate = ye.sampleRate, ie.samples.push(Qe), {
      sample: Qe,
      length: ye.frameLength,
      missing: 0
    };
  }
}
function parseHeader(ie, Z) {
  const ee = ie[Z + 1] >> 3 & 3, ae = ie[Z + 1] >> 1 & 3, ve = ie[Z + 2] >> 4 & 15, ye = ie[Z + 2] >> 2 & 3;
  if (ee !== 1 && ve !== 0 && ve !== 15 && ye !== 3) {
    const be = ie[Z + 2] >> 1 & 1, Ye = ie[Z + 3] >> 6, Qe = ee === 3 ? 3 - ae : ae === 3 ? 3 : 4, Je = BitratesMap[Qe * 14 + ve - 1] * 1e3, st = SamplingRateMap[(ee === 3 ? 0 : ee === 2 ? 1 : 2) * 3 + ye], ot = Ye === 3 ? 1 : 2, lt = SamplesCoefficients[ee][ae], ft = BytesInSlot[ae], gt = lt * 8 * ft, ct = Math.floor(lt * Je / st + be) * ft;
    if (chromeVersion$1 === null) {
      const Xr = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      chromeVersion$1 = Xr ? parseInt(Xr[1]) : 0;
    }
    return !!chromeVersion$1 && chromeVersion$1 <= 87 && ae === 2 && Je >= 224e3 && Ye === 0 && (ie[Z + 3] = ie[Z + 3] | 128), {
      sampleRate: st,
      channelCount: ot,
      frameLength: ct,
      samplesPerFrame: gt
    };
  }
}
function isHeaderPattern(ie, Z) {
  return ie[Z] === 255 && (ie[Z + 1] & 224) === 224 && (ie[Z + 1] & 6) !== 0;
}
function isHeader(ie, Z) {
  return Z + 1 < ie.length && isHeaderPattern(ie, Z);
}
function canParse(ie, Z) {
  return isHeaderPattern(ie, Z) && 4 <= ie.length - Z;
}
function probe(ie, Z) {
  if (Z + 1 < ie.length && isHeaderPattern(ie, Z)) {
    const ae = parseHeader(ie, Z);
    let ve = 4;
    ae != null && ae.frameLength && (ve = ae.frameLength);
    const ye = Z + ve;
    return ye === ie.length || isHeader(ie, ye);
  }
  return !1;
}
class AACDemuxer extends BaseAudioDemuxer {
  constructor(Z, ee) {
    super(), this.observer = void 0, this.config = void 0, this.observer = Z, this.config = ee;
  }
  resetInitSegment(Z, ee, ae, ve) {
    super.resetInitSegment(Z, ee, ae, ve), this._audioTrack = {
      container: "audio/adts",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "aac",
      samples: [],
      manifestCodec: ee,
      duration: ve,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(Z) {
    if (!Z)
      return !1;
    const ee = getID3Data(Z, 0);
    let ae = (ee == null ? void 0 : ee.length) || 0;
    if (probe(Z, ae))
      return !1;
    for (let ve = Z.length; ae < ve; ae++)
      if (probe$1(Z, ae))
        return logger.log("ADTS sync word found !"), !0;
    return !1;
  }
  canParse(Z, ee) {
    return canParse$1(Z, ee);
  }
  appendFrame(Z, ee, ae) {
    initTrackConfig(Z, this.observer, ee, ae, Z.manifestCodec);
    const ve = appendFrame$2(Z, ee, ae, this.basePTS, this.frameIndex);
    if (ve && ve.missing === 0)
      return ve;
  }
}
const emsgSchemePattern = /\/emsg[-/]ID3/i;
class MP4Demuxer {
  constructor(Z, ee) {
    this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = ee;
  }
  resetTimeStamp() {
  }
  resetInitSegment(Z, ee, ae, ve) {
    const ye = this.videoTrack = dummyTrack("video", 1), be = this.audioTrack = dummyTrack("audio", 1), Ye = this.txtTrack = dummyTrack("text", 1);
    if (this.id3Track = dummyTrack("id3", 1), this.timeOffset = 0, !(Z != null && Z.byteLength))
      return;
    const Qe = parseInitSegment(Z);
    if (Qe.video) {
      const {
        id: Je,
        timescale: nt,
        codec: st
      } = Qe.video;
      ye.id = Je, ye.timescale = Ye.timescale = nt, ye.codec = st;
    }
    if (Qe.audio) {
      const {
        id: Je,
        timescale: nt,
        codec: st
      } = Qe.audio;
      be.id = Je, be.timescale = nt, be.codec = st;
    }
    Ye.id = RemuxerTrackIdConfig.text, ye.sampleDuration = 0, ye.duration = be.duration = ve;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(Z) {
    return hasMoofData(Z);
  }
  demux(Z, ee) {
    this.timeOffset = ee;
    let ae = Z;
    const ve = this.videoTrack, ye = this.txtTrack;
    if (this.config.progressive) {
      this.remainderData && (ae = appendUint8Array(this.remainderData, Z));
      const Ye = segmentValidRange(ae);
      this.remainderData = Ye.remainder, ve.samples = Ye.valid || new Uint8Array();
    } else
      ve.samples = ae;
    const be = this.extractID3Track(ve, ee);
    return ye.samples = parseSamples(ee, ve), {
      videoTrack: ve,
      audioTrack: this.audioTrack,
      id3Track: be,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const Z = this.timeOffset, ee = this.videoTrack, ae = this.txtTrack;
    ee.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
    const ve = this.extractID3Track(ee, this.timeOffset);
    return ae.samples = parseSamples(Z, ee), {
      videoTrack: ee,
      audioTrack: dummyTrack(),
      id3Track: ve,
      textTrack: dummyTrack()
    };
  }
  extractID3Track(Z, ee) {
    const ae = this.id3Track;
    if (Z.samples.length) {
      const ve = findBox(Z.samples, ["emsg"]);
      ve && ve.forEach((ye) => {
        const be = parseEmsg(ye);
        if (emsgSchemePattern.test(be.schemeIdUri)) {
          const Ye = isFiniteNumber(be.presentationTime) ? be.presentationTime / be.timeScale : ee + be.presentationTimeDelta / be.timeScale;
          let Qe = be.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : be.eventDuration / be.timeScale;
          Qe <= 1e-3 && (Qe = Number.POSITIVE_INFINITY);
          const Je = be.payload;
          ae.samples.push({
            data: Je,
            len: Je.byteLength,
            dts: Ye,
            pts: Ye,
            type: MetadataSchema.emsg,
            duration: Qe
          });
        }
      });
    }
    return ae;
  }
  demuxSampleAes(Z, ee, ae) {
    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
  }
  destroy() {
  }
}
const getAudioBSID = (ie, Z) => {
  let ee = 0, ae = 5;
  Z += ae;
  const ve = new Uint32Array(1), ye = new Uint32Array(1), be = new Uint8Array(1);
  for (; ae > 0; ) {
    be[0] = ie[Z];
    const Ye = Math.min(ae, 8), Qe = 8 - Ye;
    ye[0] = 4278190080 >>> 24 + Qe << Qe, ve[0] = (be[0] & ye[0]) >> Qe, ee = ee ? ee << Ye | ve[0] : ve[0], Z += 1, ae -= Ye;
  }
  return ee;
};
class AC3Demuxer extends BaseAudioDemuxer {
  constructor(Z) {
    super(), this.observer = void 0, this.observer = Z;
  }
  resetInitSegment(Z, ee, ae, ve) {
    super.resetInitSegment(Z, ee, ae, ve), this._audioTrack = {
      container: "audio/ac-3",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "ac3",
      samples: [],
      manifestCodec: ee,
      duration: ve,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  canParse(Z, ee) {
    return ee + 64 < Z.length;
  }
  appendFrame(Z, ee, ae) {
    const ve = appendFrame(Z, ee, ae, this.basePTS, this.frameIndex);
    if (ve !== -1)
      return {
        sample: Z.samples[Z.samples.length - 1],
        length: ve,
        missing: 0
      };
  }
  static probe(Z) {
    if (!Z)
      return !1;
    const ee = getID3Data(Z, 0);
    if (!ee)
      return !1;
    const ae = ee.length;
    return Z[ae] === 11 && Z[ae + 1] === 119 && getTimeStamp(ee) !== void 0 && // check the bsid to confirm ac-3
    getAudioBSID(Z, ae) < 16;
  }
}
function appendFrame(ie, Z, ee, ae, ve) {
  if (ee + 8 > Z.length || Z[ee] !== 11 || Z[ee + 1] !== 119)
    return -1;
  const ye = Z[ee + 4] >> 6;
  if (ye >= 3)
    return -1;
  const Ye = [48e3, 44100, 32e3][ye], Qe = Z[ee + 4] & 63, nt = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920][Qe * 3 + ye] * 2;
  if (ee + nt > Z.length)
    return -1;
  const st = Z[ee + 6] >> 5;
  let ot = 0;
  st === 2 ? ot += 2 : (st & 1 && st !== 1 && (ot += 2), st & 4 && (ot += 2));
  const lt = (Z[ee + 6] << 8 | Z[ee + 7]) >> 12 - ot & 1, gt = [2, 1, 2, 3, 3, 4, 4, 5][st] + lt, ct = Z[ee + 5] >> 3, _r = Z[ee + 5] & 7, Kr = new Uint8Array([ye << 6 | ct << 1 | _r >> 2, (_r & 3) << 6 | st << 3 | lt << 2 | Qe >> 4, Qe << 4 & 224]), Xr = 1536 / Ye * 9e4, Jr = ae + ve * Xr, ei = Z.subarray(ee, ee + nt);
  return ie.config = Kr, ie.channelCount = gt, ie.samplerate = Ye, ie.samples.push({
    unit: ei,
    pts: Jr
  }), nt;
}
class BaseVideoParser {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(Z, ee, ae, ve) {
    return {
      key: Z,
      frame: !1,
      pts: ee,
      dts: ae,
      units: [],
      debug: ve,
      length: 0
    };
  }
  getLastNalUnit(Z) {
    var ee;
    let ae = this.VideoSample, ve;
    if ((!ae || ae.units.length === 0) && (ae = Z[Z.length - 1]), (ee = ae) != null && ee.units) {
      const ye = ae.units;
      ve = ye[ye.length - 1];
    }
    return ve;
  }
  pushAccessUnit(Z, ee) {
    if (Z.units.length && Z.frame) {
      if (Z.pts === void 0) {
        const ae = ee.samples, ve = ae.length;
        if (ve) {
          const ye = ae[ve - 1];
          Z.pts = ye.pts, Z.dts = ye.dts;
        } else {
          ee.dropped++;
          return;
        }
      }
      ee.samples.push(Z);
    }
    Z.debug.length && logger.log(Z.pts + "/" + Z.dts + ":" + Z.debug);
  }
}
class ExpGolomb {
  constructor(Z) {
    this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = Z, this.bytesAvailable = Z.byteLength, this.word = 0, this.bitsAvailable = 0;
  }
  // ():void
  loadWord() {
    const Z = this.data, ee = this.bytesAvailable, ae = Z.byteLength - ee, ve = new Uint8Array(4), ye = Math.min(4, ee);
    if (ye === 0)
      throw new Error("no bytes available");
    ve.set(Z.subarray(ae, ae + ye)), this.word = new DataView(ve.buffer).getUint32(0), this.bitsAvailable = ye * 8, this.bytesAvailable -= ye;
  }
  // (count:int):void
  skipBits(Z) {
    let ee;
    Z = Math.min(Z, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > Z ? (this.word <<= Z, this.bitsAvailable -= Z) : (Z -= this.bitsAvailable, ee = Z >> 3, Z -= ee << 3, this.bytesAvailable -= ee, this.loadWord(), this.word <<= Z, this.bitsAvailable -= Z);
  }
  // (size:int):uint
  readBits(Z) {
    let ee = Math.min(this.bitsAvailable, Z);
    const ae = this.word >>> 32 - ee;
    if (Z > 32 && logger.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= ee, this.bitsAvailable > 0)
      this.word <<= ee;
    else if (this.bytesAvailable > 0)
      this.loadWord();
    else
      throw new Error("no bits available");
    return ee = Z - ee, ee > 0 && this.bitsAvailable ? ae << ee | this.readBits(ee) : ae;
  }
  // ():uint
  skipLZ() {
    let Z;
    for (Z = 0; Z < this.bitsAvailable; ++Z)
      if (this.word & 2147483648 >>> Z)
        return this.word <<= Z, this.bitsAvailable -= Z, Z;
    return this.loadWord(), Z + this.skipLZ();
  }
  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():uint
  readUEG() {
    const Z = this.skipLZ();
    return this.readBits(Z + 1) - 1;
  }
  // ():int
  readEG() {
    const Z = this.readUEG();
    return 1 & Z ? 1 + Z >>> 1 : -1 * (Z >>> 1);
  }
  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }
  // ():int
  readUByte() {
    return this.readBits(8);
  }
  // ():int
  readUShort() {
    return this.readBits(16);
  }
  // ():int
  readUInt() {
    return this.readBits(32);
  }
  /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(Z) {
    let ee = 8, ae = 8, ve;
    for (let ye = 0; ye < Z; ye++)
      ae !== 0 && (ve = this.readEG(), ae = (ee + ve + 256) % 256), ee = ae === 0 ? ee : ae;
  }
  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS() {
    let Z = 0, ee = 0, ae = 0, ve = 0, ye, be, Ye;
    const Qe = this.readUByte.bind(this), Je = this.readBits.bind(this), nt = this.readUEG.bind(this), st = this.readBoolean.bind(this), ot = this.skipBits.bind(this), lt = this.skipEG.bind(this), ft = this.skipUEG.bind(this), gt = this.skipScalingList.bind(this);
    Qe();
    const ct = Qe();
    if (Je(5), ot(3), Qe(), ft(), ct === 100 || ct === 110 || ct === 122 || ct === 244 || ct === 44 || ct === 83 || ct === 86 || ct === 118 || ct === 128) {
      const si = nt();
      if (si === 3 && ot(1), ft(), ft(), ot(1), st())
        for (be = si !== 3 ? 8 : 12, Ye = 0; Ye < be; Ye++)
          st() && (Ye < 6 ? gt(16) : gt(64));
    }
    ft();
    const _r = nt();
    if (_r === 0)
      nt();
    else if (_r === 1)
      for (ot(1), lt(), lt(), ye = nt(), Ye = 0; Ye < ye; Ye++)
        lt();
    ft(), ot(1);
    const Kr = nt(), Xr = nt(), Jr = Je(1);
    Jr === 0 && ot(1), ot(1), st() && (Z = nt(), ee = nt(), ae = nt(), ve = nt());
    let ei = [1, 1];
    if (st() && st())
      switch (Qe()) {
        case 1:
          ei = [1, 1];
          break;
        case 2:
          ei = [12, 11];
          break;
        case 3:
          ei = [10, 11];
          break;
        case 4:
          ei = [16, 11];
          break;
        case 5:
          ei = [40, 33];
          break;
        case 6:
          ei = [24, 11];
          break;
        case 7:
          ei = [20, 11];
          break;
        case 8:
          ei = [32, 11];
          break;
        case 9:
          ei = [80, 33];
          break;
        case 10:
          ei = [18, 11];
          break;
        case 11:
          ei = [15, 11];
          break;
        case 12:
          ei = [64, 33];
          break;
        case 13:
          ei = [160, 99];
          break;
        case 14:
          ei = [4, 3];
          break;
        case 15:
          ei = [3, 2];
          break;
        case 16:
          ei = [2, 1];
          break;
        case 255: {
          ei = [Qe() << 8 | Qe(), Qe() << 8 | Qe()];
          break;
        }
      }
    return {
      width: Math.ceil((Kr + 1) * 16 - Z * 2 - ee * 2),
      height: (2 - Jr) * (Xr + 1) * 16 - (Jr ? 2 : 4) * (ae + ve),
      pixelRatio: ei
    };
  }
  readSliceType() {
    return this.readUByte(), this.readUEG(), this.readUEG();
  }
}
class AvcVideoParser extends BaseVideoParser {
  parseAVCPES(Z, ee, ae, ve, ye) {
    const be = this.parseAVCNALu(Z, ae.data);
    let Ye = this.VideoSample, Qe, Je = !1;
    ae.data = null, Ye && be.length && !Z.audFound && (this.pushAccessUnit(Ye, Z), Ye = this.VideoSample = this.createVideoSample(!1, ae.pts, ae.dts, "")), be.forEach((nt) => {
      var st;
      switch (nt.type) {
        case 1: {
          let gt = !1;
          Qe = !0;
          const ct = nt.data;
          if (Je && ct.length > 4) {
            const _r = new ExpGolomb(ct).readSliceType();
            (_r === 2 || _r === 4 || _r === 7 || _r === 9) && (gt = !0);
          }
          if (gt) {
            var ot;
            (ot = Ye) != null && ot.frame && !Ye.key && (this.pushAccessUnit(Ye, Z), Ye = this.VideoSample = null);
          }
          Ye || (Ye = this.VideoSample = this.createVideoSample(!0, ae.pts, ae.dts, "")), Ye.frame = !0, Ye.key = gt;
          break;
        }
        case 5:
          Qe = !0, (st = Ye) != null && st.frame && !Ye.key && (this.pushAccessUnit(Ye, Z), Ye = this.VideoSample = null), Ye || (Ye = this.VideoSample = this.createVideoSample(!0, ae.pts, ae.dts, "")), Ye.key = !0, Ye.frame = !0;
          break;
        case 6: {
          Qe = !0, parseSEIMessageFromNALu(nt.data, 1, ae.pts, ee.samples);
          break;
        }
        case 7: {
          var lt, ft;
          Qe = !0, Je = !0;
          const gt = nt.data, _r = new ExpGolomb(gt).readSPS();
          if (!Z.sps || Z.width !== _r.width || Z.height !== _r.height || ((lt = Z.pixelRatio) == null ? void 0 : lt[0]) !== _r.pixelRatio[0] || ((ft = Z.pixelRatio) == null ? void 0 : ft[1]) !== _r.pixelRatio[1]) {
            Z.width = _r.width, Z.height = _r.height, Z.pixelRatio = _r.pixelRatio, Z.sps = [gt], Z.duration = ye;
            const Kr = gt.subarray(1, 4);
            let Xr = "avc1.";
            for (let Jr = 0; Jr < 3; Jr++) {
              let ei = Kr[Jr].toString(16);
              ei.length < 2 && (ei = "0" + ei), Xr += ei;
            }
            Z.codec = Xr;
          }
          break;
        }
        case 8:
          Qe = !0, Z.pps = [nt.data];
          break;
        case 9:
          Qe = !0, Z.audFound = !0, Ye && this.pushAccessUnit(Ye, Z), Ye = this.VideoSample = this.createVideoSample(!1, ae.pts, ae.dts, "");
          break;
        case 12:
          Qe = !0;
          break;
        default:
          Qe = !1, Ye && (Ye.debug += "unknown NAL " + nt.type + " ");
          break;
      }
      Ye && Qe && Ye.units.push(nt);
    }), ve && Ye && (this.pushAccessUnit(Ye, Z), this.VideoSample = null);
  }
  parseAVCNALu(Z, ee) {
    const ae = ee.byteLength;
    let ve = Z.naluState || 0;
    const ye = ve, be = [];
    let Ye = 0, Qe, Je, nt, st = -1, ot = 0;
    for (ve === -1 && (st = 0, ot = ee[0] & 31, ve = 0, Ye = 1); Ye < ae; ) {
      if (Qe = ee[Ye++], !ve) {
        ve = Qe ? 0 : 1;
        continue;
      }
      if (ve === 1) {
        ve = Qe ? 0 : 2;
        continue;
      }
      if (!Qe)
        ve = 3;
      else if (Qe === 1) {
        if (Je = Ye - ve - 1, st >= 0) {
          const lt = {
            data: ee.subarray(st, Je),
            type: ot
          };
          be.push(lt);
        } else {
          const lt = this.getLastNalUnit(Z.samples);
          lt && (ye && Ye <= 4 - ye && lt.state && (lt.data = lt.data.subarray(0, lt.data.byteLength - ye)), Je > 0 && (lt.data = appendUint8Array(lt.data, ee.subarray(0, Je)), lt.state = 0));
        }
        Ye < ae ? (nt = ee[Ye] & 31, st = Ye, ot = nt, ve = 0) : ve = -1;
      } else
        ve = 0;
    }
    if (st >= 0 && ve >= 0) {
      const lt = {
        data: ee.subarray(st, ae),
        type: ot,
        state: ve
      };
      be.push(lt);
    }
    if (be.length === 0) {
      const lt = this.getLastNalUnit(Z.samples);
      lt && (lt.data = appendUint8Array(lt.data, ee));
    }
    return Z.naluState = ve, be;
  }
}
class SampleAesDecrypter {
  constructor(Z, ee, ae) {
    this.keyData = void 0, this.decrypter = void 0, this.keyData = ae, this.decrypter = new Decrypter(ee, {
      removePKCS7Padding: !1
    });
  }
  decryptBuffer(Z) {
    return this.decrypter.decrypt(Z, this.keyData.key.buffer, this.keyData.iv.buffer);
  }
  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(Z, ee, ae) {
    const ve = Z[ee].unit;
    if (ve.length <= 16)
      return;
    const ye = ve.subarray(16, ve.length - ve.length % 16), be = ye.buffer.slice(ye.byteOffset, ye.byteOffset + ye.length);
    this.decryptBuffer(be).then((Ye) => {
      const Qe = new Uint8Array(Ye);
      ve.set(Qe, 16), this.decrypter.isSync() || this.decryptAacSamples(Z, ee + 1, ae);
    });
  }
  decryptAacSamples(Z, ee, ae) {
    for (; ; ee++) {
      if (ee >= Z.length) {
        ae();
        return;
      }
      if (!(Z[ee].unit.length < 32) && (this.decryptAacSample(Z, ee, ae), !this.decrypter.isSync()))
        return;
    }
  }
  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(Z) {
    const ee = Math.floor((Z.length - 48) / 160) * 16 + 16, ae = new Int8Array(ee);
    let ve = 0;
    for (let ye = 32; ye < Z.length - 16; ye += 160, ve += 16)
      ae.set(Z.subarray(ye, ye + 16), ve);
    return ae;
  }
  getAvcDecryptedUnit(Z, ee) {
    const ae = new Uint8Array(ee);
    let ve = 0;
    for (let ye = 32; ye < Z.length - 16; ye += 160, ve += 16)
      Z.set(ae.subarray(ve, ve + 16), ye);
    return Z;
  }
  decryptAvcSample(Z, ee, ae, ve, ye) {
    const be = discardEPB(ye.data), Ye = this.getAvcEncryptedData(be);
    this.decryptBuffer(Ye.buffer).then((Qe) => {
      ye.data = this.getAvcDecryptedUnit(be, Qe), this.decrypter.isSync() || this.decryptAvcSamples(Z, ee, ae + 1, ve);
    });
  }
  decryptAvcSamples(Z, ee, ae, ve) {
    if (Z instanceof Uint8Array)
      throw new Error("Cannot decrypt samples of type Uint8Array");
    for (; ; ee++, ae = 0) {
      if (ee >= Z.length) {
        ve();
        return;
      }
      const ye = Z[ee].units;
      for (; !(ae >= ye.length); ae++) {
        const be = ye[ae];
        if (!(be.data.length <= 48 || be.type !== 1 && be.type !== 5) && (this.decryptAvcSample(Z, ee, ae, ve, be), !this.decrypter.isSync()))
          return;
      }
    }
  }
}
const PACKET_LENGTH = 188;
class TSDemuxer {
  constructor(Z, ee, ae) {
    this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._duration = 0, this._pmtId = -1, this._videoTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.remainderData = null, this.videoParser = void 0, this.observer = Z, this.config = ee, this.typeSupported = ae, this.videoParser = new AvcVideoParser();
  }
  static probe(Z) {
    const ee = TSDemuxer.syncOffset(Z);
    return ee > 0 && logger.warn(`MPEG2-TS detected but first sync word found @ offset ${ee}`), ee !== -1;
  }
  static syncOffset(Z) {
    const ee = Z.length;
    let ae = Math.min(PACKET_LENGTH * 5, ee - PACKET_LENGTH) + 1, ve = 0;
    for (; ve < ae; ) {
      let ye = !1, be = -1, Ye = 0;
      for (let Qe = ve; Qe < ee; Qe += PACKET_LENGTH)
        if (Z[Qe] === 71 && (ee - Qe === PACKET_LENGTH || Z[Qe + PACKET_LENGTH] === 71)) {
          if (Ye++, be === -1 && (be = Qe, be !== 0 && (ae = Math.min(be + PACKET_LENGTH * 99, Z.length - PACKET_LENGTH) + 1)), ye || (ye = parsePID(Z, Qe) === 0), ye && Ye > 1 && (be === 0 && Ye > 2 || Qe + PACKET_LENGTH > ae))
            return be;
        } else {
          if (Ye)
            return -1;
          break;
        }
      ve++;
    }
    return -1;
  }
  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(Z, ee) {
    return {
      container: Z === "video" || Z === "audio" ? "video/mp2t" : void 0,
      type: Z,
      id: RemuxerTrackIdConfig[Z],
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: Z === "audio" ? ee : void 0
    };
  }
  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(Z, ee, ae, ve) {
    this.pmtParsed = !1, this._pmtId = -1, this._videoTrack = TSDemuxer.createTrack("video"), this._audioTrack = TSDemuxer.createTrack("audio", ve), this._id3Track = TSDemuxer.createTrack("id3"), this._txtTrack = TSDemuxer.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.aacOverFlow = null, this.remainderData = null, this.audioCodec = ee, this.videoCodec = ae, this._duration = ve;
  }
  resetTimeStamp() {
  }
  resetContiguity() {
    const {
      _audioTrack: Z,
      _videoTrack: ee,
      _id3Track: ae
    } = this;
    Z && (Z.pesData = null), ee && (ee.pesData = null), ae && (ae.pesData = null), this.aacOverFlow = null, this.remainderData = null;
  }
  demux(Z, ee, ae = !1, ve = !1) {
    ae || (this.sampleAes = null);
    let ye;
    const be = this._videoTrack, Ye = this._audioTrack, Qe = this._id3Track, Je = this._txtTrack;
    let nt = be.pid, st = be.pesData, ot = Ye.pid, lt = Qe.pid, ft = Ye.pesData, gt = Qe.pesData, ct = null, _r = this.pmtParsed, Kr = this._pmtId, Xr = Z.length;
    if (this.remainderData && (Z = appendUint8Array(this.remainderData, Z), Xr = Z.length, this.remainderData = null), Xr < PACKET_LENGTH && !ve)
      return this.remainderData = Z, {
        audioTrack: Ye,
        videoTrack: be,
        id3Track: Qe,
        textTrack: Je
      };
    const Jr = Math.max(0, TSDemuxer.syncOffset(Z));
    Xr -= (Xr - Jr) % PACKET_LENGTH, Xr < Z.byteLength && !ve && (this.remainderData = new Uint8Array(Z.buffer, Xr, Z.buffer.byteLength - Xr));
    let ei = 0;
    for (let ri = Jr; ri < Xr; ri += PACKET_LENGTH)
      if (Z[ri] === 71) {
        const ai = !!(Z[ri + 1] & 64), yi = parsePID(Z, ri), pi = (Z[ri + 3] & 48) >> 4;
        let di;
        if (pi > 1) {
          if (di = ri + 5 + Z[ri + 4], di === ri + PACKET_LENGTH)
            continue;
        } else
          di = ri + 4;
        switch (yi) {
          case nt:
            ai && (st && (ye = parsePES(st)) && this.videoParser.parseAVCPES(be, Je, ye, !1, this._duration), st = {
              data: [],
              size: 0
            }), st && (st.data.push(Z.subarray(di, ri + PACKET_LENGTH)), st.size += ri + PACKET_LENGTH - di);
            break;
          case ot:
            if (ai) {
              if (ft && (ye = parsePES(ft)))
                switch (Ye.segmentCodec) {
                  case "aac":
                    this.parseAACPES(Ye, ye);
                    break;
                  case "mp3":
                    this.parseMPEGPES(Ye, ye);
                    break;
                  case "ac3":
                    this.parseAC3PES(Ye, ye);
                    break;
                }
              ft = {
                data: [],
                size: 0
              };
            }
            ft && (ft.data.push(Z.subarray(di, ri + PACKET_LENGTH)), ft.size += ri + PACKET_LENGTH - di);
            break;
          case lt:
            ai && (gt && (ye = parsePES(gt)) && this.parseID3PES(Qe, ye), gt = {
              data: [],
              size: 0
            }), gt && (gt.data.push(Z.subarray(di, ri + PACKET_LENGTH)), gt.size += ri + PACKET_LENGTH - di);
            break;
          case 0:
            ai && (di += Z[di] + 1), Kr = this._pmtId = parsePAT(Z, di);
            break;
          case Kr: {
            ai && (di += Z[di] + 1);
            const xi = parsePMT(Z, di, this.typeSupported, ae);
            nt = xi.videoPid, nt > 0 && (be.pid = nt, be.segmentCodec = xi.segmentVideoCodec), ot = xi.audioPid, ot > 0 && (Ye.pid = ot, Ye.segmentCodec = xi.segmentAudioCodec), lt = xi.id3Pid, lt > 0 && (Qe.pid = lt), ct !== null && !_r && (logger.warn(`MPEG-TS PMT found at ${ri} after unknown PID '${ct}'. Backtracking to sync byte @${Jr} to parse all TS packets.`), ct = null, ri = Jr - 188), _r = this.pmtParsed = !0;
            break;
          }
          case 17:
          case 8191:
            break;
          default:
            ct = yi;
            break;
        }
      } else
        ei++;
    if (ei > 0) {
      const ri = new Error(`Found ${ei} TS packet/s that do not start with 0x47`);
      this.observer.emit(Events.ERROR, Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.FRAG_PARSING_ERROR,
        fatal: !1,
        error: ri,
        reason: ri.message
      });
    }
    be.pesData = st, Ye.pesData = ft, Qe.pesData = gt;
    const si = {
      audioTrack: Ye,
      videoTrack: be,
      id3Track: Qe,
      textTrack: Je
    };
    return ve && this.extractRemainingSamples(si), si;
  }
  flush() {
    const {
      remainderData: Z
    } = this;
    this.remainderData = null;
    let ee;
    return Z ? ee = this.demux(Z, -1, !1, !0) : ee = {
      videoTrack: this._videoTrack,
      audioTrack: this._audioTrack,
      id3Track: this._id3Track,
      textTrack: this._txtTrack
    }, this.extractRemainingSamples(ee), this.sampleAes ? this.decrypt(ee, this.sampleAes) : ee;
  }
  extractRemainingSamples(Z) {
    const {
      audioTrack: ee,
      videoTrack: ae,
      id3Track: ve,
      textTrack: ye
    } = Z, be = ae.pesData, Ye = ee.pesData, Qe = ve.pesData;
    let Je;
    if (be && (Je = parsePES(be)) ? (this.videoParser.parseAVCPES(ae, ye, Je, !0, this._duration), ae.pesData = null) : ae.pesData = be, Ye && (Je = parsePES(Ye))) {
      switch (ee.segmentCodec) {
        case "aac":
          this.parseAACPES(ee, Je);
          break;
        case "mp3":
          this.parseMPEGPES(ee, Je);
          break;
        case "ac3":
          this.parseAC3PES(ee, Je);
          break;
      }
      ee.pesData = null;
    } else
      Ye != null && Ye.size && logger.log("last AAC PES packet truncated,might overlap between fragments"), ee.pesData = Ye;
    Qe && (Je = parsePES(Qe)) ? (this.parseID3PES(ve, Je), ve.pesData = null) : ve.pesData = Qe;
  }
  demuxSampleAes(Z, ee, ae) {
    const ve = this.demux(Z, ae, !0, !this.config.progressive), ye = this.sampleAes = new SampleAesDecrypter(this.observer, this.config, ee);
    return this.decrypt(ve, ye);
  }
  decrypt(Z, ee) {
    return new Promise((ae) => {
      const {
        audioTrack: ve,
        videoTrack: ye
      } = Z;
      ve.samples && ve.segmentCodec === "aac" ? ee.decryptAacSamples(ve.samples, 0, () => {
        ye.samples ? ee.decryptAvcSamples(ye.samples, 0, 0, () => {
          ae(Z);
        }) : ae(Z);
      }) : ye.samples && ee.decryptAvcSamples(ye.samples, 0, 0, () => {
        ae(Z);
      });
    });
  }
  destroy() {
    this._duration = 0;
  }
  parseAACPES(Z, ee) {
    let ae = 0;
    const ve = this.aacOverFlow;
    let ye = ee.data;
    if (ve) {
      this.aacOverFlow = null;
      const st = ve.missing, ot = ve.sample.unit.byteLength;
      if (st === -1)
        ye = appendUint8Array(ve.sample.unit, ye);
      else {
        const lt = ot - st;
        ve.sample.unit.set(ye.subarray(0, st), lt), Z.samples.push(ve.sample), ae = ve.missing;
      }
    }
    let be, Ye;
    for (be = ae, Ye = ye.length; be < Ye - 1 && !isHeader$1(ye, be); be++)
      ;
    if (be !== ae) {
      let st;
      const ot = be < Ye - 1;
      ot ? st = `AAC PES did not start with ADTS header,offset:${be}` : st = "No ADTS header found in AAC PES";
      const lt = new Error(st);
      if (logger.warn(`parsing error: ${st}`), this.observer.emit(Events.ERROR, Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.FRAG_PARSING_ERROR,
        fatal: !1,
        levelRetry: ot,
        error: lt,
        reason: st
      }), !ot)
        return;
    }
    initTrackConfig(Z, this.observer, ye, be, this.audioCodec);
    let Qe;
    if (ee.pts !== void 0)
      Qe = ee.pts;
    else if (ve) {
      const st = getFrameDuration(Z.samplerate);
      Qe = ve.sample.pts + st;
    } else {
      logger.warn("[tsdemuxer]: AAC PES unknown PTS");
      return;
    }
    let Je = 0, nt;
    for (; be < Ye; )
      if (nt = appendFrame$2(Z, ye, be, Qe, Je), be += nt.length, nt.missing) {
        this.aacOverFlow = nt;
        break;
      } else
        for (Je++; be < Ye - 1 && !isHeader$1(ye, be); be++)
          ;
  }
  parseMPEGPES(Z, ee) {
    const ae = ee.data, ve = ae.length;
    let ye = 0, be = 0;
    const Ye = ee.pts;
    if (Ye === void 0) {
      logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
      return;
    }
    for (; be < ve; )
      if (isHeader(ae, be)) {
        const Qe = appendFrame$1(Z, ae, be, Ye, ye);
        if (Qe)
          be += Qe.length, ye++;
        else
          break;
      } else
        be++;
  }
  parseAC3PES(Z, ee) {
    {
      const ae = ee.data, ve = ee.pts;
      if (ve === void 0) {
        logger.warn("[tsdemuxer]: AC3 PES unknown PTS");
        return;
      }
      const ye = ae.length;
      let be = 0, Ye = 0, Qe;
      for (; Ye < ye && (Qe = appendFrame(Z, ae, Ye, ve, be++)) > 0; )
        Ye += Qe;
    }
  }
  parseID3PES(Z, ee) {
    if (ee.pts === void 0) {
      logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
      return;
    }
    const ae = _extends({}, ee, {
      type: this._videoTrack ? MetadataSchema.emsg : MetadataSchema.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    Z.samples.push(ae);
  }
}
function parsePID(ie, Z) {
  return ((ie[Z + 1] & 31) << 8) + ie[Z + 2];
}
function parsePAT(ie, Z) {
  return (ie[Z + 10] & 31) << 8 | ie[Z + 11];
}
function parsePMT(ie, Z, ee, ae) {
  const ve = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: "avc",
    segmentAudioCodec: "aac"
  }, ye = (ie[Z + 1] & 15) << 8 | ie[Z + 2], be = Z + 3 + ye - 4, Ye = (ie[Z + 10] & 15) << 8 | ie[Z + 11];
  for (Z += 12 + Ye; Z < be; ) {
    const Qe = parsePID(ie, Z), Je = (ie[Z + 3] & 15) << 8 | ie[Z + 4];
    switch (ie[Z]) {
      case 207:
        if (!ae) {
          logEncryptedSamplesFoundInUnencryptedStream("ADTS AAC");
          break;
        }
      case 15:
        ve.audioPid === -1 && (ve.audioPid = Qe);
        break;
      case 21:
        ve.id3Pid === -1 && (ve.id3Pid = Qe);
        break;
      case 219:
        if (!ae) {
          logEncryptedSamplesFoundInUnencryptedStream("H.264");
          break;
        }
      case 27:
        ve.videoPid === -1 && (ve.videoPid = Qe, ve.segmentVideoCodec = "avc");
        break;
      case 3:
      case 4:
        !ee.mpeg && !ee.mp3 ? logger.log("MPEG audio found, not supported in this browser") : ve.audioPid === -1 && (ve.audioPid = Qe, ve.segmentAudioCodec = "mp3");
        break;
      case 193:
        if (!ae) {
          logEncryptedSamplesFoundInUnencryptedStream("AC-3");
          break;
        }
      case 129:
        ee.ac3 ? ve.audioPid === -1 && (ve.audioPid = Qe, ve.segmentAudioCodec = "ac3") : logger.log("AC-3 audio found, not supported in this browser");
        break;
      case 6:
        if (ve.audioPid === -1 && Je > 0) {
          let nt = Z + 5, st = Je;
          for (; st > 2; ) {
            switch (ie[nt]) {
              case 106:
                ee.ac3 !== !0 ? logger.log("AC-3 audio found, not supported in this browser for now") : (ve.audioPid = Qe, ve.segmentAudioCodec = "ac3");
                break;
            }
            const lt = ie[nt + 1] + 2;
            nt += lt, st -= lt;
          }
        }
        break;
      case 194:
      case 135:
        logger.warn("Unsupported EC-3 in M2TS found");
        break;
      case 36:
        logger.warn("Unsupported HEVC in M2TS found");
        break;
    }
    Z += Je + 5;
  }
  return ve;
}
function logEncryptedSamplesFoundInUnencryptedStream(ie) {
  logger.log(`${ie} with AES-128-CBC encryption found in unencrypted stream`);
}
function parsePES(ie) {
  let Z = 0, ee, ae, ve, ye, be;
  const Ye = ie.data;
  if (!ie || ie.size === 0)
    return null;
  for (; Ye[0].length < 19 && Ye.length > 1; )
    Ye[0] = appendUint8Array(Ye[0], Ye[1]), Ye.splice(1, 1);
  if (ee = Ye[0], (ee[0] << 16) + (ee[1] << 8) + ee[2] === 1) {
    if (ae = (ee[4] << 8) + ee[5], ae && ae > ie.size - 6)
      return null;
    const Je = ee[7];
    Je & 192 && (ye = (ee[9] & 14) * 536870912 + // 1 << 29
    (ee[10] & 255) * 4194304 + // 1 << 22
    (ee[11] & 254) * 16384 + // 1 << 14
    (ee[12] & 255) * 128 + // 1 << 7
    (ee[13] & 254) / 2, Je & 64 ? (be = (ee[14] & 14) * 536870912 + // 1 << 29
    (ee[15] & 255) * 4194304 + // 1 << 22
    (ee[16] & 254) * 16384 + // 1 << 14
    (ee[17] & 255) * 128 + // 1 << 7
    (ee[18] & 254) / 2, ye - be > 60 * 9e4 && (logger.warn(`${Math.round((ye - be) / 9e4)}s delta between PTS and DTS, align them`), ye = be)) : be = ye), ve = ee[8];
    let nt = ve + 9;
    if (ie.size <= nt)
      return null;
    ie.size -= nt;
    const st = new Uint8Array(ie.size);
    for (let ot = 0, lt = Ye.length; ot < lt; ot++) {
      ee = Ye[ot];
      let ft = ee.byteLength;
      if (nt)
        if (nt > ft) {
          nt -= ft;
          continue;
        } else
          ee = ee.subarray(nt), ft -= nt, nt = 0;
      st.set(ee, Z), Z += ft;
    }
    return ae && (ae -= ve + 3), {
      data: st,
      pts: ye,
      dts: be,
      len: ae
    };
  }
  return null;
}
class MP3Demuxer extends BaseAudioDemuxer {
  resetInitSegment(Z, ee, ae, ve) {
    super.resetInitSegment(Z, ee, ae, ve), this._audioTrack = {
      container: "audio/mpeg",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "mp3",
      samples: [],
      manifestCodec: ee,
      duration: ve,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  static probe(Z) {
    if (!Z)
      return !1;
    const ee = getID3Data(Z, 0);
    let ae = (ee == null ? void 0 : ee.length) || 0;
    if (ee && Z[ae] === 11 && Z[ae + 1] === 119 && getTimeStamp(ee) !== void 0 && // check the bsid to confirm ac-3 or ec-3 (not mp3)
    getAudioBSID(Z, ae) <= 16)
      return !1;
    for (let ve = Z.length; ae < ve; ae++)
      if (probe(Z, ae))
        return logger.log("MPEG Audio sync word found !"), !0;
    return !1;
  }
  canParse(Z, ee) {
    return canParse(Z, ee);
  }
  appendFrame(Z, ee, ae) {
    if (this.basePTS !== null)
      return appendFrame$1(Z, ee, ae, this.basePTS, this.frameIndex);
  }
}
class AAC {
  static getSilentFrame(Z, ee) {
    switch (Z) {
      case "mp4a.40.2":
        if (ee === 1)
          return new Uint8Array([0, 200, 0, 128, 35, 128]);
        if (ee === 2)
          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
        if (ee === 3)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
        if (ee === 4)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
        if (ee === 5)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
        if (ee === 6)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
        break;
      default:
        if (ee === 1)
          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (ee === 2)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (ee === 3)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        break;
    }
  }
}
const UINT32_MAX = Math.pow(2, 32) - 1;
class MP4 {
  static init() {
    MP4.types = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      ".mp3": [],
      dac3: [],
      "ac-3": [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let Z;
    for (Z in MP4.types)
      MP4.types.hasOwnProperty(Z) && (MP4.types[Z] = [Z.charCodeAt(0), Z.charCodeAt(1), Z.charCodeAt(2), Z.charCodeAt(3)]);
    const ee = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      118,
      105,
      100,
      101,
      // handler_type: 'vide'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'VideoHandler'
    ]), ae = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      115,
      111,
      117,
      110,
      // handler_type: 'soun'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'SoundHandler'
    ]);
    MP4.HDLR_TYPES = {
      video: ee,
      audio: ae
    };
    const ve = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // entry_count
      0,
      0,
      0,
      12,
      // entry_size
      117,
      114,
      108,
      32,
      // 'url' type
      0,
      // version 0
      0,
      0,
      1
      // entry_flags
    ]), ye = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0
      // entry_count
    ]);
    MP4.STTS = MP4.STSC = MP4.STCO = ye, MP4.STSZ = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // sample_size
      0,
      0,
      0,
      0
      // sample_count
    ]), MP4.VMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      1,
      // flags
      0,
      0,
      // graphicsmode
      0,
      0,
      0,
      0,
      0,
      0
      // opcolor
    ]), MP4.SMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      // balance
      0,
      0
      // reserved
    ]), MP4.STSD = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1
    ]);
    const be = new Uint8Array([105, 115, 111, 109]), Ye = new Uint8Array([97, 118, 99, 49]), Qe = new Uint8Array([0, 0, 0, 1]);
    MP4.FTYP = MP4.box(MP4.types.ftyp, be, Qe, be, Ye), MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, ve));
  }
  static box(Z, ...ee) {
    let ae = 8, ve = ee.length;
    const ye = ve;
    for (; ve--; )
      ae += ee[ve].byteLength;
    const be = new Uint8Array(ae);
    for (be[0] = ae >> 24 & 255, be[1] = ae >> 16 & 255, be[2] = ae >> 8 & 255, be[3] = ae & 255, be.set(Z, 4), ve = 0, ae = 8; ve < ye; ve++)
      be.set(ee[ve], ae), ae += ee[ve].byteLength;
    return be;
  }
  static hdlr(Z) {
    return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[Z]);
  }
  static mdat(Z) {
    return MP4.box(MP4.types.mdat, Z);
  }
  static mdhd(Z, ee) {
    ee *= Z;
    const ae = Math.floor(ee / (UINT32_MAX + 1)), ve = Math.floor(ee % (UINT32_MAX + 1));
    return MP4.box(MP4.types.mdhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      Z >> 24 & 255,
      Z >> 16 & 255,
      Z >> 8 & 255,
      Z & 255,
      // timescale
      ae >> 24,
      ae >> 16 & 255,
      ae >> 8 & 255,
      ae & 255,
      ve >> 24,
      ve >> 16 & 255,
      ve >> 8 & 255,
      ve & 255,
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]));
  }
  static mdia(Z) {
    return MP4.box(MP4.types.mdia, MP4.mdhd(Z.timescale, Z.duration), MP4.hdlr(Z.type), MP4.minf(Z));
  }
  static mfhd(Z) {
    return MP4.box(MP4.types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      Z >> 24,
      Z >> 16 & 255,
      Z >> 8 & 255,
      Z & 255
      // sequence_number
    ]));
  }
  static minf(Z) {
    return Z.type === "audio" ? MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(Z)) : MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(Z));
  }
  static moof(Z, ee, ae) {
    return MP4.box(MP4.types.moof, MP4.mfhd(Z), MP4.traf(ae, ee));
  }
  static moov(Z) {
    let ee = Z.length;
    const ae = [];
    for (; ee--; )
      ae[ee] = MP4.trak(Z[ee]);
    return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(Z[0].timescale, Z[0].duration)].concat(ae).concat(MP4.mvex(Z)));
  }
  static mvex(Z) {
    let ee = Z.length;
    const ae = [];
    for (; ee--; )
      ae[ee] = MP4.trex(Z[ee]);
    return MP4.box.apply(null, [MP4.types.mvex, ...ae]);
  }
  static mvhd(Z, ee) {
    ee *= Z;
    const ae = Math.floor(ee / (UINT32_MAX + 1)), ve = Math.floor(ee % (UINT32_MAX + 1)), ye = new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      Z >> 24 & 255,
      Z >> 16 & 255,
      Z >> 8 & 255,
      Z & 255,
      // timescale
      ae >> 24,
      ae >> 16 & 255,
      ae >> 8 & 255,
      ae & 255,
      ve >> 24,
      ve >> 16 & 255,
      ve >> 8 & 255,
      ve & 255,
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return MP4.box(MP4.types.mvhd, ye);
  }
  static sdtp(Z) {
    const ee = Z.samples || [], ae = new Uint8Array(4 + ee.length);
    let ve, ye;
    for (ve = 0; ve < ee.length; ve++)
      ye = ee[ve].flags, ae[ve + 4] = ye.dependsOn << 4 | ye.isDependedOn << 2 | ye.hasRedundancy;
    return MP4.box(MP4.types.sdtp, ae);
  }
  static stbl(Z) {
    return MP4.box(MP4.types.stbl, MP4.stsd(Z), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
  }
  static avc1(Z) {
    let ee = [], ae = [], ve, ye, be;
    for (ve = 0; ve < Z.sps.length; ve++)
      ye = Z.sps[ve], be = ye.byteLength, ee.push(be >>> 8 & 255), ee.push(be & 255), ee = ee.concat(Array.prototype.slice.call(ye));
    for (ve = 0; ve < Z.pps.length; ve++)
      ye = Z.pps[ve], be = ye.byteLength, ae.push(be >>> 8 & 255), ae.push(be & 255), ae = ae.concat(Array.prototype.slice.call(ye));
    const Ye = MP4.box(MP4.types.avcC, new Uint8Array([
      1,
      // version
      ee[3],
      // profile
      ee[4],
      // profile compat
      ee[5],
      // level
      255,
      // lengthSizeMinusOne, hard-coded to 4 bytes
      224 | Z.sps.length
      // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(ee).concat([
      Z.pps.length
      // numOfPictureParameterSets
    ]).concat(ae))), Qe = Z.width, Je = Z.height, nt = Z.pixelRatio[0], st = Z.pixelRatio[1];
    return MP4.box(
      MP4.types.avc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        Qe >> 8 & 255,
        Qe & 255,
        // width
        Je >> 8 & 255,
        Je & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      Ye,
      MP4.box(MP4.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      MP4.box(MP4.types.pasp, new Uint8Array([
        nt >> 24,
        // hSpacing
        nt >> 16 & 255,
        nt >> 8 & 255,
        nt & 255,
        st >> 24,
        // vSpacing
        st >> 16 & 255,
        st >> 8 & 255,
        st & 255
      ]))
    );
  }
  static esds(Z) {
    const ee = Z.config.length;
    return new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      3,
      // descriptor_type
      23 + ee,
      // length
      0,
      1,
      // es_id
      0,
      // stream_priority
      4,
      // descriptor_type
      15 + ee,
      // length
      64,
      // codec : mpeg4_audio
      21,
      // stream_type
      0,
      0,
      0,
      // buffer_size
      0,
      0,
      0,
      0,
      // maxBitrate
      0,
      0,
      0,
      0,
      // avgBitrate
      5
      // descriptor_type
    ].concat([ee]).concat(Z.config).concat([6, 1, 2]));
  }
  static audioStsd(Z) {
    const ee = Z.samplerate;
    return new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      Z.channelCount,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      ee >> 8 & 255,
      ee & 255,
      //
      0,
      0
    ]);
  }
  static mp4a(Z) {
    return MP4.box(MP4.types.mp4a, MP4.audioStsd(Z), MP4.box(MP4.types.esds, MP4.esds(Z)));
  }
  static mp3(Z) {
    return MP4.box(MP4.types[".mp3"], MP4.audioStsd(Z));
  }
  static ac3(Z) {
    return MP4.box(MP4.types["ac-3"], MP4.audioStsd(Z), MP4.box(MP4.types.dac3, Z.config));
  }
  static stsd(Z) {
    return Z.type === "audio" ? Z.segmentCodec === "mp3" && Z.codec === "mp3" ? MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(Z)) : Z.segmentCodec === "ac3" ? MP4.box(MP4.types.stsd, MP4.STSD, MP4.ac3(Z)) : MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(Z)) : MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(Z));
  }
  static tkhd(Z) {
    const ee = Z.id, ae = Z.duration * Z.timescale, ve = Z.width, ye = Z.height, be = Math.floor(ae / (UINT32_MAX + 1)), Ye = Math.floor(ae % (UINT32_MAX + 1));
    return MP4.box(MP4.types.tkhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      ee >> 24 & 255,
      ee >> 16 & 255,
      ee >> 8 & 255,
      ee & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      be >> 24,
      be >> 16 & 255,
      be >> 8 & 255,
      be & 255,
      Ye >> 24,
      Ye >> 16 & 255,
      Ye >> 8 & 255,
      Ye & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      0,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      ve >> 8 & 255,
      ve & 255,
      0,
      0,
      // width
      ye >> 8 & 255,
      ye & 255,
      0,
      0
      // height
    ]));
  }
  static traf(Z, ee) {
    const ae = MP4.sdtp(Z), ve = Z.id, ye = Math.floor(ee / (UINT32_MAX + 1)), be = Math.floor(ee % (UINT32_MAX + 1));
    return MP4.box(
      MP4.types.traf,
      MP4.box(MP4.types.tfhd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        ve >> 24,
        ve >> 16 & 255,
        ve >> 8 & 255,
        ve & 255
        // track_ID
      ])),
      MP4.box(MP4.types.tfdt, new Uint8Array([
        1,
        // version 1
        0,
        0,
        0,
        // flags
        ye >> 24,
        ye >> 16 & 255,
        ye >> 8 & 255,
        ye & 255,
        be >> 24,
        be >> 16 & 255,
        be >> 8 & 255,
        be & 255
      ])),
      MP4.trun(Z, ae.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8),
      // mdat header
      ae
    );
  }
  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(Z) {
    return Z.duration = Z.duration || 4294967295, MP4.box(MP4.types.trak, MP4.tkhd(Z), MP4.mdia(Z));
  }
  static trex(Z) {
    const ee = Z.id;
    return MP4.box(MP4.types.trex, new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      ee >> 24,
      ee >> 16 & 255,
      ee >> 8 & 255,
      ee & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]));
  }
  static trun(Z, ee) {
    const ae = Z.samples || [], ve = ae.length, ye = 12 + 16 * ve, be = new Uint8Array(ye);
    let Ye, Qe, Je, nt, st, ot;
    for (ee += 8 + ye, be.set([
      Z.type === "video" ? 1 : 0,
      // version 1 for video with signed-int sample_composition_time_offset
      0,
      15,
      1,
      // flags
      ve >>> 24 & 255,
      ve >>> 16 & 255,
      ve >>> 8 & 255,
      ve & 255,
      // sample_count
      ee >>> 24 & 255,
      ee >>> 16 & 255,
      ee >>> 8 & 255,
      ee & 255
      // data_offset
    ], 0), Ye = 0; Ye < ve; Ye++)
      Qe = ae[Ye], Je = Qe.duration, nt = Qe.size, st = Qe.flags, ot = Qe.cts, be.set([
        Je >>> 24 & 255,
        Je >>> 16 & 255,
        Je >>> 8 & 255,
        Je & 255,
        // sample_duration
        nt >>> 24 & 255,
        nt >>> 16 & 255,
        nt >>> 8 & 255,
        nt & 255,
        // sample_size
        st.isLeading << 2 | st.dependsOn,
        st.isDependedOn << 6 | st.hasRedundancy << 4 | st.paddingValue << 1 | st.isNonSync,
        st.degradPrio & 61440,
        st.degradPrio & 15,
        // sample_flags
        ot >>> 24 & 255,
        ot >>> 16 & 255,
        ot >>> 8 & 255,
        ot & 255
        // sample_composition_time_offset
      ], 12 + 16 * Ye);
    return MP4.box(MP4.types.trun, be);
  }
  static initSegment(Z) {
    MP4.types || MP4.init();
    const ee = MP4.moov(Z);
    return appendUint8Array(MP4.FTYP, ee);
  }
}
MP4.types = void 0;
MP4.HDLR_TYPES = void 0;
MP4.STTS = void 0;
MP4.STSC = void 0;
MP4.STCO = void 0;
MP4.STSZ = void 0;
MP4.VMHD = void 0;
MP4.SMHD = void 0;
MP4.STSD = void 0;
MP4.FTYP = void 0;
MP4.DINF = void 0;
const MPEG_TS_CLOCK_FREQ_HZ = 9e4;
function toTimescaleFromBase(ie, Z, ee = 1, ae = !1) {
  const ve = ie * Z * ee;
  return ae ? Math.round(ve) : ve;
}
function toTimescaleFromScale(ie, Z, ee = 1, ae = !1) {
  return toTimescaleFromBase(ie, Z, 1 / ee, ae);
}
function toMsFromMpegTsClock(ie, Z = !1) {
  return toTimescaleFromBase(ie, 1e3, 1 / MPEG_TS_CLOCK_FREQ_HZ, Z);
}
function toMpegTsClockFromTimescale(ie, Z = 1) {
  return toTimescaleFromBase(ie, MPEG_TS_CLOCK_FREQ_HZ, 1 / Z);
}
const MAX_SILENT_FRAME_DURATION = 10 * 1e3, AAC_SAMPLES_PER_FRAME = 1024, MPEG_AUDIO_SAMPLE_PER_FRAME = 1152, AC3_SAMPLES_PER_FRAME = 1536;
let chromeVersion = null, safariWebkitVersion = null;
class MP4Remuxer {
  constructor(Z, ee, ae, ve = "") {
    if (this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = null, this._initDTS = null, this.nextAvcDts = null, this.nextAudioPts = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.videoTrackConfig = void 0, this.observer = Z, this.config = ee, this.typeSupported = ae, this.ISGenerated = !1, chromeVersion === null) {
      const be = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      chromeVersion = be ? parseInt(be[1]) : 0;
    }
    if (safariWebkitVersion === null) {
      const ye = navigator.userAgent.match(/Safari\/(\d+)/i);
      safariWebkitVersion = ye ? parseInt(ye[1]) : 0;
    }
  }
  destroy() {
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(Z) {
    logger.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = Z;
  }
  resetNextTimestamp() {
    logger.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
  }
  resetInitSegment() {
    logger.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1, this.videoTrackConfig = void 0;
  }
  getVideoStartPts(Z) {
    let ee = !1;
    const ae = Z.reduce((ve, ye) => {
      const be = ye.pts - ve;
      return be < -4294967296 ? (ee = !0, normalizePts(ve, ye.pts)) : be > 0 ? ve : ye.pts;
    }, Z[0].pts);
    return ee && logger.debug("PTS rollover detected"), ae;
  }
  remux(Z, ee, ae, ve, ye, be, Ye, Qe) {
    let Je, nt, st, ot, lt, ft, gt = ye, ct = ye;
    const _r = Z.pid > -1, Kr = ee.pid > -1, Xr = ee.samples.length, Jr = Z.samples.length > 0, ei = Ye && Xr > 0 || Xr > 1;
    if ((!_r || Jr) && (!Kr || ei) || this.ISGenerated || Ye) {
      if (this.ISGenerated) {
        var ri, ai, yi, pi;
        const Ai = this.videoTrackConfig;
        Ai && (ee.width !== Ai.width || ee.height !== Ai.height || ((ri = ee.pixelRatio) == null ? void 0 : ri[0]) !== ((ai = Ai.pixelRatio) == null ? void 0 : ai[0]) || ((yi = ee.pixelRatio) == null ? void 0 : yi[1]) !== ((pi = Ai.pixelRatio) == null ? void 0 : pi[1])) && this.resetInitSegment();
      } else
        st = this.generateIS(Z, ee, ye, be);
      const di = this.isVideoContiguous;
      let xi = -1, Ti;
      if (ei && (xi = findKeyframeIndex(ee.samples), !di && this.config.forceKeyFrameOnDiscontinuity))
        if (ft = !0, xi > 0) {
          logger.warn(`[mp4-remuxer]: Dropped ${xi} out of ${Xr} video samples due to a missing keyframe`);
          const Ai = this.getVideoStartPts(ee.samples);
          ee.samples = ee.samples.slice(xi), ee.dropped += xi, ct += (ee.samples[0].pts - Ai) / ee.inputTimeScale, Ti = ct;
        } else
          xi === -1 && (logger.warn(`[mp4-remuxer]: No keyframe found out of ${Xr} video samples`), ft = !1);
      if (this.ISGenerated) {
        if (Jr && ei) {
          const Ai = this.getVideoStartPts(ee.samples), Si = (normalizePts(Z.samples[0].pts, Ai) - Ai) / ee.inputTimeScale;
          gt += Math.max(0, Si), ct += Math.max(0, -Si);
        }
        if (Jr) {
          if (Z.samplerate || (logger.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), st = this.generateIS(Z, ee, ye, be)), nt = this.remuxAudio(Z, gt, this.isAudioContiguous, be, Kr || ei || Qe === PlaylistLevelType.AUDIO ? ct : void 0), ei) {
            const Ai = nt ? nt.endPTS - nt.startPTS : 0;
            ee.inputTimeScale || (logger.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), st = this.generateIS(Z, ee, ye, be)), Je = this.remuxVideo(ee, ct, di, Ai);
          }
        } else
          ei && (Je = this.remuxVideo(ee, ct, di, 0));
        Je && (Je.firstKeyFrame = xi, Je.independent = xi !== -1, Je.firstKeyFramePTS = Ti);
      }
    }
    return this.ISGenerated && this._initPTS && this._initDTS && (ae.samples.length && (lt = flushTextTrackMetadataCueSamples(ae, ye, this._initPTS, this._initDTS)), ve.samples.length && (ot = flushTextTrackUserdataCueSamples(ve, ye, this._initPTS))), {
      audio: nt,
      video: Je,
      initSegment: st,
      independent: ft,
      text: ot,
      id3: lt
    };
  }
  generateIS(Z, ee, ae, ve) {
    const ye = Z.samples, be = ee.samples, Ye = this.typeSupported, Qe = {}, Je = this._initPTS;
    let nt = !Je || ve, st = "audio/mp4", ot, lt, ft;
    if (nt && (ot = lt = 1 / 0), Z.config && ye.length) {
      switch (Z.timescale = Z.samplerate, Z.segmentCodec) {
        case "mp3":
          Ye.mpeg ? (st = "audio/mpeg", Z.codec = "") : Ye.mp3 && (Z.codec = "mp3");
          break;
        case "ac3":
          Z.codec = "ac-3";
          break;
      }
      Qe.audio = {
        id: "audio",
        container: st,
        codec: Z.codec,
        initSegment: Z.segmentCodec === "mp3" && Ye.mpeg ? new Uint8Array(0) : MP4.initSegment([Z]),
        metadata: {
          channelCount: Z.channelCount
        }
      }, nt && (ft = Z.inputTimeScale, !Je || ft !== Je.timescale ? ot = lt = ye[0].pts - Math.round(ft * ae) : nt = !1);
    }
    if (ee.sps && ee.pps && be.length) {
      if (ee.timescale = ee.inputTimeScale, Qe.video = {
        id: "main",
        container: "video/mp4",
        codec: ee.codec,
        initSegment: MP4.initSegment([ee]),
        metadata: {
          width: ee.width,
          height: ee.height
        }
      }, nt)
        if (ft = ee.inputTimeScale, !Je || ft !== Je.timescale) {
          const gt = this.getVideoStartPts(be), ct = Math.round(ft * ae);
          lt = Math.min(lt, normalizePts(be[0].dts, gt) - ct), ot = Math.min(ot, gt - ct);
        } else
          nt = !1;
      this.videoTrackConfig = {
        width: ee.width,
        height: ee.height,
        pixelRatio: ee.pixelRatio
      };
    }
    if (Object.keys(Qe).length)
      return this.ISGenerated = !0, nt ? (this._initPTS = {
        baseTime: ot,
        timescale: ft
      }, this._initDTS = {
        baseTime: lt,
        timescale: ft
      }) : ot = ft = void 0, {
        tracks: Qe,
        initPTS: ot,
        timescale: ft
      };
  }
  remuxVideo(Z, ee, ae, ve) {
    const ye = Z.inputTimeScale, be = Z.samples, Ye = [], Qe = be.length, Je = this._initPTS;
    let nt = this.nextAvcDts, st = 8, ot = this.videoSampleDuration, lt, ft, gt = Number.POSITIVE_INFINITY, ct = Number.NEGATIVE_INFINITY, _r = !1;
    if (!ae || nt === null) {
      const Oi = ee * ye, hi = be[0].pts - normalizePts(be[0].dts, be[0].pts);
      chromeVersion && nt !== null && Math.abs(Oi - hi - nt) < 15e3 ? ae = !0 : nt = Oi - hi;
    }
    const Kr = Je.baseTime * ye / Je.timescale;
    for (let Oi = 0; Oi < Qe; Oi++) {
      const hi = be[Oi];
      hi.pts = normalizePts(hi.pts - Kr, nt), hi.dts = normalizePts(hi.dts - Kr, nt), hi.dts < be[Oi > 0 ? Oi - 1 : Oi].dts && (_r = !0);
    }
    _r && be.sort(function(Oi, hi) {
      const Di = Oi.dts - hi.dts, Ri = Oi.pts - hi.pts;
      return Di || Ri;
    }), lt = be[0].dts, ft = be[be.length - 1].dts;
    const Xr = ft - lt, Jr = Xr ? Math.round(Xr / (Qe - 1)) : ot || Z.inputTimeScale / 30;
    if (ae) {
      const Oi = lt - nt, hi = Oi > Jr, Di = Oi < -1;
      if ((hi || Di) && (hi ? logger.warn(`AVC: ${toMsFromMpegTsClock(Oi, !0)} ms (${Oi}dts) hole between fragments detected at ${ee.toFixed(3)}`) : logger.warn(`AVC: ${toMsFromMpegTsClock(-Oi, !0)} ms (${Oi}dts) overlapping between fragments detected at ${ee.toFixed(3)}`), !Di || nt >= be[0].pts || chromeVersion)) {
        lt = nt;
        const Ri = be[0].pts - Oi;
        if (hi)
          be[0].dts = lt, be[0].pts = Ri;
        else
          for (let rs = 0; rs < be.length && !(be[rs].dts > Ri); rs++)
            be[rs].dts -= Oi, be[rs].pts -= Oi;
        logger.log(`Video: Initial PTS/DTS adjusted: ${toMsFromMpegTsClock(Ri, !0)}/${toMsFromMpegTsClock(lt, !0)}, delta: ${toMsFromMpegTsClock(Oi, !0)} ms`);
      }
    }
    lt = Math.max(0, lt);
    let ei = 0, si = 0, ri = lt;
    for (let Oi = 0; Oi < Qe; Oi++) {
      const hi = be[Oi], Di = hi.units, Ri = Di.length;
      let rs = 0;
      for (let Hi = 0; Hi < Ri; Hi++)
        rs += Di[Hi].data.length;
      si += rs, ei += Ri, hi.length = rs, hi.dts < ri ? (hi.dts = ri, ri += Jr / 4 | 0 || 1) : ri = hi.dts, gt = Math.min(hi.pts, gt), ct = Math.max(hi.pts, ct);
    }
    ft = be[Qe - 1].dts;
    const ai = si + 4 * ei + 8;
    let yi;
    try {
      yi = new Uint8Array(ai);
    } catch (Oi) {
      this.observer.emit(Events.ERROR, Events.ERROR, {
        type: ErrorTypes.MUX_ERROR,
        details: ErrorDetails.REMUX_ALLOC_ERROR,
        fatal: !1,
        error: Oi,
        bytes: ai,
        reason: `fail allocating video mdat ${ai}`
      });
      return;
    }
    const pi = new DataView(yi.buffer);
    pi.setUint32(0, ai), yi.set(MP4.types.mdat, 4);
    let di = !1, xi = Number.POSITIVE_INFINITY, Ti = Number.POSITIVE_INFINITY, Ai = Number.NEGATIVE_INFINITY, mi = Number.NEGATIVE_INFINITY;
    for (let Oi = 0; Oi < Qe; Oi++) {
      const hi = be[Oi], Di = hi.units;
      let Ri = 0;
      for (let qi = 0, us = Di.length; qi < us; qi++) {
        const Yi = Di[qi], is = Yi.data, Ss = Yi.data.byteLength;
        pi.setUint32(st, Ss), st += 4, yi.set(is, st), st += Ss, Ri += 4 + Ss;
      }
      let rs;
      if (Oi < Qe - 1)
        ot = be[Oi + 1].dts - hi.dts, rs = be[Oi + 1].pts - hi.pts;
      else {
        const qi = this.config, us = Oi > 0 ? hi.dts - be[Oi - 1].dts : Jr;
        if (rs = Oi > 0 ? hi.pts - be[Oi - 1].pts : Jr, qi.stretchShortVideoTrack && this.nextAudioPts !== null) {
          const Yi = Math.floor(qi.maxBufferHole * ye), is = (ve ? gt + ve * ye : this.nextAudioPts) - hi.pts;
          is > Yi ? (ot = is - us, ot < 0 ? ot = us : di = !0, logger.log(`[mp4-remuxer]: It is approximately ${is / 90} ms to the next segment; using duration ${ot / 90} ms for the last video frame.`)) : ot = us;
        } else
          ot = us;
      }
      const Hi = Math.round(hi.pts - hi.dts);
      xi = Math.min(xi, ot), Ai = Math.max(Ai, ot), Ti = Math.min(Ti, rs), mi = Math.max(mi, rs), Ye.push(new Mp4Sample(hi.key, ot, Ri, Hi));
    }
    if (Ye.length) {
      if (chromeVersion) {
        if (chromeVersion < 70) {
          const Oi = Ye[0].flags;
          Oi.dependsOn = 2, Oi.isNonSync = 0;
        }
      } else if (safariWebkitVersion && mi - Ti < Ai - xi && Jr / Ai < 0.025 && Ye[0].cts === 0) {
        logger.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
        let Oi = lt;
        for (let hi = 0, Di = Ye.length; hi < Di; hi++) {
          const Ri = Oi + Ye[hi].duration, rs = Oi + Ye[hi].cts;
          if (hi < Di - 1) {
            const Hi = Ri + Ye[hi + 1].cts;
            Ye[hi].duration = Hi - rs;
          } else
            Ye[hi].duration = hi ? Ye[hi - 1].duration : Jr;
          Ye[hi].cts = 0, Oi = Ri;
        }
      }
    }
    ot = di || !ot ? Jr : ot, this.nextAvcDts = nt = ft + ot, this.videoSampleDuration = ot, this.isVideoContiguous = !0;
    const _i = {
      data1: MP4.moof(Z.sequenceNumber++, lt, _extends({}, Z, {
        samples: Ye
      })),
      data2: yi,
      startPTS: gt / ye,
      endPTS: (ct + ot) / ye,
      startDTS: lt / ye,
      endDTS: nt / ye,
      type: "video",
      hasAudio: !1,
      hasVideo: !0,
      nb: Ye.length,
      dropped: Z.dropped
    };
    return Z.samples = [], Z.dropped = 0, _i;
  }
  getSamplesPerFrame(Z) {
    switch (Z.segmentCodec) {
      case "mp3":
        return MPEG_AUDIO_SAMPLE_PER_FRAME;
      case "ac3":
        return AC3_SAMPLES_PER_FRAME;
      default:
        return AAC_SAMPLES_PER_FRAME;
    }
  }
  remuxAudio(Z, ee, ae, ve, ye) {
    const be = Z.inputTimeScale, Ye = Z.samplerate ? Z.samplerate : be, Qe = be / Ye, Je = this.getSamplesPerFrame(Z), nt = Je * Qe, st = this._initPTS, ot = Z.segmentCodec === "mp3" && this.typeSupported.mpeg, lt = [], ft = ye !== void 0;
    let gt = Z.samples, ct = ot ? 0 : 8, _r = this.nextAudioPts || -1;
    const Kr = ee * be, Xr = st.baseTime * be / st.timescale;
    if (this.isAudioContiguous = ae = ae || gt.length && _r > 0 && (ve && Math.abs(Kr - _r) < 9e3 || Math.abs(normalizePts(gt[0].pts - Xr, Kr) - _r) < 20 * nt), gt.forEach(function(Si) {
      Si.pts = normalizePts(Si.pts - Xr, Kr);
    }), !ae || _r < 0) {
      if (gt = gt.filter((Si) => Si.pts >= 0), !gt.length)
        return;
      ye === 0 ? _r = 0 : ve && !ft ? _r = Math.max(0, Kr) : _r = gt[0].pts;
    }
    if (Z.segmentCodec === "aac") {
      const Si = this.config.maxAudioFramesDrift;
      for (let gi = 0, _i = _r; gi < gt.length; gi++) {
        const Oi = gt[gi], hi = Oi.pts, Di = hi - _i, Ri = Math.abs(1e3 * Di / be);
        if (Di <= -Si * nt && ft)
          gi === 0 && (logger.warn(`Audio frame @ ${(hi / be).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1e3 * Di / be)} ms.`), this.nextAudioPts = _r = _i = hi);
        else if (Di >= Si * nt && Ri < MAX_SILENT_FRAME_DURATION && ft) {
          let rs = Math.round(Di / nt);
          _i = hi - rs * nt, _i < 0 && (rs--, _i += nt), gi === 0 && (this.nextAudioPts = _r = _i), logger.warn(`[mp4-remuxer]: Injecting ${rs} audio frame @ ${(_i / be).toFixed(3)}s due to ${Math.round(1e3 * Di / be)} ms gap.`);
          for (let Hi = 0; Hi < rs; Hi++) {
            const qi = Math.max(_i, 0);
            let us = AAC.getSilentFrame(Z.manifestCodec || Z.codec, Z.channelCount);
            us || (logger.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), us = Oi.unit.subarray()), gt.splice(gi, 0, {
              unit: us,
              pts: qi
            }), _i += nt, gi++;
          }
        }
        Oi.pts = _i, _i += nt;
      }
    }
    let Jr = null, ei = null, si, ri = 0, ai = gt.length;
    for (; ai--; )
      ri += gt[ai].unit.byteLength;
    for (let Si = 0, gi = gt.length; Si < gi; Si++) {
      const _i = gt[Si], Oi = _i.unit;
      let hi = _i.pts;
      if (ei !== null) {
        const Ri = lt[Si - 1];
        Ri.duration = Math.round((hi - ei) / Qe);
      } else if (ae && Z.segmentCodec === "aac" && (hi = _r), Jr = hi, ri > 0) {
        ri += ct;
        try {
          si = new Uint8Array(ri);
        } catch (Ri) {
          this.observer.emit(Events.ERROR, Events.ERROR, {
            type: ErrorTypes.MUX_ERROR,
            details: ErrorDetails.REMUX_ALLOC_ERROR,
            fatal: !1,
            error: Ri,
            bytes: ri,
            reason: `fail allocating audio mdat ${ri}`
          });
          return;
        }
        ot || (new DataView(si.buffer).setUint32(0, ri), si.set(MP4.types.mdat, 4));
      } else
        return;
      si.set(Oi, ct);
      const Di = Oi.byteLength;
      ct += Di, lt.push(new Mp4Sample(!0, Je, Di, 0)), ei = hi;
    }
    const yi = lt.length;
    if (!yi)
      return;
    const pi = lt[lt.length - 1];
    this.nextAudioPts = _r = ei + Qe * pi.duration;
    const di = ot ? new Uint8Array(0) : MP4.moof(Z.sequenceNumber++, Jr / Qe, _extends({}, Z, {
      samples: lt
    }));
    Z.samples = [];
    const xi = Jr / be, Ti = _r / be, mi = {
      data1: di,
      data2: si,
      startPTS: xi,
      endPTS: Ti,
      startDTS: xi,
      endDTS: Ti,
      type: "audio",
      hasAudio: !0,
      hasVideo: !1,
      nb: yi
    };
    return this.isAudioContiguous = !0, mi;
  }
  remuxEmptyAudio(Z, ee, ae, ve) {
    const ye = Z.inputTimeScale, be = Z.samplerate ? Z.samplerate : ye, Ye = ye / be, Qe = this.nextAudioPts, Je = this._initDTS, nt = Je.baseTime * 9e4 / Je.timescale, st = (Qe !== null ? Qe : ve.startDTS * ye) + nt, ot = ve.endDTS * ye + nt, lt = Ye * AAC_SAMPLES_PER_FRAME, ft = Math.ceil((ot - st) / lt), gt = AAC.getSilentFrame(Z.manifestCodec || Z.codec, Z.channelCount);
    if (logger.warn("[mp4-remuxer]: remux empty Audio"), !gt) {
      logger.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
      return;
    }
    const ct = [];
    for (let _r = 0; _r < ft; _r++) {
      const Kr = st + _r * lt;
      ct.push({
        unit: gt,
        pts: Kr,
        dts: Kr
      });
    }
    return Z.samples = ct, this.remuxAudio(Z, ee, ae, !1);
  }
}
function normalizePts(ie, Z) {
  let ee;
  if (Z === null)
    return ie;
  for (Z < ie ? ee = -8589934592 : ee = 8589934592; Math.abs(ie - Z) > 4294967296; )
    ie += ee;
  return ie;
}
function findKeyframeIndex(ie) {
  for (let Z = 0; Z < ie.length; Z++)
    if (ie[Z].key)
      return Z;
  return -1;
}
function flushTextTrackMetadataCueSamples(ie, Z, ee, ae) {
  const ve = ie.samples.length;
  if (!ve)
    return;
  const ye = ie.inputTimeScale;
  for (let Ye = 0; Ye < ve; Ye++) {
    const Qe = ie.samples[Ye];
    Qe.pts = normalizePts(Qe.pts - ee.baseTime * ye / ee.timescale, Z * ye) / ye, Qe.dts = normalizePts(Qe.dts - ae.baseTime * ye / ae.timescale, Z * ye) / ye;
  }
  const be = ie.samples;
  return ie.samples = [], {
    samples: be
  };
}
function flushTextTrackUserdataCueSamples(ie, Z, ee) {
  const ae = ie.samples.length;
  if (!ae)
    return;
  const ve = ie.inputTimeScale;
  for (let be = 0; be < ae; be++) {
    const Ye = ie.samples[be];
    Ye.pts = normalizePts(Ye.pts - ee.baseTime * ve / ee.timescale, Z * ve) / ve;
  }
  ie.samples.sort((be, Ye) => be.pts - Ye.pts);
  const ye = ie.samples;
  return ie.samples = [], {
    samples: ye
  };
}
class Mp4Sample {
  constructor(Z, ee, ae, ve) {
    this.size = void 0, this.duration = void 0, this.cts = void 0, this.flags = void 0, this.duration = ee, this.size = ae, this.cts = ve, this.flags = {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: Z ? 2 : 1,
      isNonSync: Z ? 0 : 1
    };
  }
}
class PassThroughRemuxer {
  constructor() {
    this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = null, this.initTracks = void 0, this.lastEndTime = null;
  }
  destroy() {
  }
  resetTimeStamp(Z) {
    this.initPTS = Z, this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.lastEndTime = null;
  }
  resetInitSegment(Z, ee, ae, ve) {
    this.audioCodec = ee, this.videoCodec = ae, this.generateInitSegment(patchEncyptionData(Z, ve)), this.emitInitSegment = !0;
  }
  generateInitSegment(Z) {
    let {
      audioCodec: ee,
      videoCodec: ae
    } = this;
    if (!(Z != null && Z.byteLength)) {
      this.initTracks = void 0, this.initData = void 0;
      return;
    }
    const ve = this.initData = parseInitSegment(Z);
    ve.audio && (ee = getParsedTrackCodec(ve.audio, ElementaryStreamTypes.AUDIO)), ve.video && (ae = getParsedTrackCodec(ve.video, ElementaryStreamTypes.VIDEO));
    const ye = {};
    ve.audio && ve.video ? ye.audiovideo = {
      container: "video/mp4",
      codec: ee + "," + ae,
      initSegment: Z,
      id: "main"
    } : ve.audio ? ye.audio = {
      container: "audio/mp4",
      codec: ee,
      initSegment: Z,
      id: "audio"
    } : ve.video ? ye.video = {
      container: "video/mp4",
      codec: ae,
      initSegment: Z,
      id: "main"
    } : logger.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = ye;
  }
  remux(Z, ee, ae, ve, ye, be) {
    var Ye, Qe;
    let {
      initPTS: Je,
      lastEndTime: nt
    } = this;
    const st = {
      audio: void 0,
      video: void 0,
      text: ve,
      id3: ae,
      initSegment: void 0
    };
    isFiniteNumber(nt) || (nt = this.lastEndTime = ye || 0);
    const ot = ee.samples;
    if (!(ot != null && ot.length))
      return st;
    const lt = {
      initPTS: void 0,
      timescale: 1
    };
    let ft = this.initData;
    if ((Ye = ft) != null && Ye.length || (this.generateInitSegment(ot), ft = this.initData), !((Qe = ft) != null && Qe.length))
      return logger.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), st;
    this.emitInitSegment && (lt.tracks = this.initTracks, this.emitInitSegment = !1);
    const gt = getDuration(ot, ft), ct = getStartDTS(ft, ot), _r = ct === null ? ye : ct;
    (isInvalidInitPts(Je, _r, ye, gt) || lt.timescale !== Je.timescale && be) && (lt.initPTS = _r - ye, Je && Je.timescale === 1 && logger.warn(`Adjusting initPTS by ${lt.initPTS - Je.baseTime}`), this.initPTS = Je = {
      baseTime: lt.initPTS,
      timescale: 1
    });
    const Kr = Z ? _r - Je.baseTime / Je.timescale : nt, Xr = Kr + gt;
    offsetStartDTS(ft, ot, Je.baseTime / Je.timescale), gt > 0 ? this.lastEndTime = Xr : (logger.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
    const Jr = !!ft.audio, ei = !!ft.video;
    let si = "";
    Jr && (si += "audio"), ei && (si += "video");
    const ri = {
      data1: ot,
      startPTS: Kr,
      startDTS: Kr,
      endPTS: Xr,
      endDTS: Xr,
      type: si,
      hasAudio: Jr,
      hasVideo: ei,
      nb: 1,
      dropped: 0
    };
    return st.audio = ri.type === "audio" ? ri : void 0, st.video = ri.type !== "audio" ? ri : void 0, st.initSegment = lt, st.id3 = flushTextTrackMetadataCueSamples(ae, ye, Je, Je), ve.samples.length && (st.text = flushTextTrackUserdataCueSamples(ve, ye, Je)), st;
  }
}
function isInvalidInitPts(ie, Z, ee, ae) {
  if (ie === null)
    return !0;
  const ve = Math.max(ae, 1), ye = Z - ie.baseTime / ie.timescale;
  return Math.abs(ye - ee) > ve;
}
function getParsedTrackCodec(ie, Z) {
  const ee = ie == null ? void 0 : ie.codec;
  if (ee && ee.length > 4)
    return ee;
  if (Z === ElementaryStreamTypes.AUDIO) {
    if (ee === "ec-3" || ee === "ac-3" || ee === "alac")
      return ee;
    if (ee === "fLaC" || ee === "Opus")
      return getCodecCompatibleName(ee, !1);
    const ae = "mp4a.40.5";
    return logger.info(`Parsed audio codec "${ee}" or audio object type not handled. Using "${ae}"`), ae;
  }
  return logger.warn(`Unhandled video codec "${ee}"`), ee === "hvc1" || ee === "hev1" ? "hvc1.1.6.L120.90" : ee === "av01" ? "av01.0.04M.08" : "avc1.42e01e";
}
let now;
try {
  now = self.performance.now.bind(self.performance);
} catch {
  logger.debug("Unable to use Performance API on this environment"), now = optionalSelf == null ? void 0 : optionalSelf.Date.now;
}
const muxConfig = [{
  demux: MP4Demuxer,
  remux: PassThroughRemuxer
}, {
  demux: TSDemuxer,
  remux: MP4Remuxer
}, {
  demux: AACDemuxer,
  remux: MP4Remuxer
}, {
  demux: MP3Demuxer,
  remux: MP4Remuxer
}];
muxConfig.splice(2, 0, {
  demux: AC3Demuxer,
  remux: MP4Remuxer
});
class Transmuxer {
  constructor(Z, ee, ae, ve, ye) {
    this.async = !1, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.vendor = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = Z, this.typeSupported = ee, this.config = ae, this.vendor = ve, this.id = ye;
  }
  configure(Z) {
    this.transmuxConfig = Z, this.decrypter && this.decrypter.reset();
  }
  push(Z, ee, ae, ve) {
    const ye = ae.transmuxing;
    ye.executeStart = now();
    let be = new Uint8Array(Z);
    const {
      currentTransmuxState: Ye,
      transmuxConfig: Qe
    } = this;
    ve && (this.currentTransmuxState = ve);
    const {
      contiguous: Je,
      discontinuity: nt,
      trackSwitch: st,
      accurateTimeOffset: ot,
      timeOffset: lt,
      initSegmentChange: ft
    } = ve || Ye, {
      audioCodec: gt,
      videoCodec: ct,
      defaultInitPts: _r,
      duration: Kr,
      initSegmentData: Xr
    } = Qe, Jr = getEncryptionType(be, ee);
    if (Jr && Jr.method === "AES-128") {
      const ai = this.getDecrypter();
      if (ai.isSync()) {
        let yi = ai.softwareDecrypt(be, Jr.key.buffer, Jr.iv.buffer);
        if (ae.part > -1 && (yi = ai.flush()), !yi)
          return ye.executeEnd = now(), emptyResult(ae);
        be = new Uint8Array(yi);
      } else
        return this.decryptionPromise = ai.webCryptoDecrypt(be, Jr.key.buffer, Jr.iv.buffer).then((yi) => {
          const pi = this.push(yi, null, ae);
          return this.decryptionPromise = null, pi;
        }), this.decryptionPromise;
    }
    const ei = this.needsProbing(nt, st);
    if (ei) {
      const ai = this.configureTransmuxer(be);
      if (ai)
        return logger.warn(`[transmuxer] ${ai.message}`), this.observer.emit(Events.ERROR, Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_PARSING_ERROR,
          fatal: !1,
          error: ai,
          reason: ai.message
        }), ye.executeEnd = now(), emptyResult(ae);
    }
    (nt || st || ft || ei) && this.resetInitSegment(Xr, gt, ct, Kr, ee), (nt || ft || ei) && this.resetInitialTimestamp(_r), Je || this.resetContiguity();
    const si = this.transmux(be, Jr, lt, ot, ae), ri = this.currentTransmuxState;
    return ri.contiguous = !0, ri.discontinuity = !1, ri.trackSwitch = !1, ye.executeEnd = now(), si;
  }
  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(Z) {
    const ee = Z.transmuxing;
    ee.executeStart = now();
    const {
      decrypter: ae,
      currentTransmuxState: ve,
      decryptionPromise: ye
    } = this;
    if (ye)
      return ye.then(() => this.flush(Z));
    const be = [], {
      timeOffset: Ye
    } = ve;
    if (ae) {
      const st = ae.flush();
      st && be.push(this.push(st, null, Z));
    }
    const {
      demuxer: Qe,
      remuxer: Je
    } = this;
    if (!Qe || !Je)
      return ee.executeEnd = now(), [emptyResult(Z)];
    const nt = Qe.flush(Ye);
    return isPromise(nt) ? nt.then((st) => (this.flushRemux(be, st, Z), be)) : (this.flushRemux(be, nt, Z), be);
  }
  flushRemux(Z, ee, ae) {
    const {
      audioTrack: ve,
      videoTrack: ye,
      id3Track: be,
      textTrack: Ye
    } = ee, {
      accurateTimeOffset: Qe,
      timeOffset: Je
    } = this.currentTransmuxState;
    logger.log(`[transmuxer.ts]: Flushed fragment ${ae.sn}${ae.part > -1 ? " p: " + ae.part : ""} of level ${ae.level}`);
    const nt = this.remuxer.remux(ve, ye, be, Ye, Je, Qe, !0, this.id);
    Z.push({
      remuxResult: nt,
      chunkMeta: ae
    }), ae.transmuxing.executeEnd = now();
  }
  resetInitialTimestamp(Z) {
    const {
      demuxer: ee,
      remuxer: ae
    } = this;
    !ee || !ae || (ee.resetTimeStamp(Z), ae.resetTimeStamp(Z));
  }
  resetContiguity() {
    const {
      demuxer: Z,
      remuxer: ee
    } = this;
    !Z || !ee || (Z.resetContiguity(), ee.resetNextTimestamp());
  }
  resetInitSegment(Z, ee, ae, ve, ye) {
    const {
      demuxer: be,
      remuxer: Ye
    } = this;
    !be || !Ye || (be.resetInitSegment(Z, ee, ae, ve), Ye.resetInitSegment(Z, ee, ae, ye));
  }
  destroy() {
    this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
  }
  transmux(Z, ee, ae, ve, ye) {
    let be;
    return ee && ee.method === "SAMPLE-AES" ? be = this.transmuxSampleAes(Z, ee, ae, ve, ye) : be = this.transmuxUnencrypted(Z, ae, ve, ye), be;
  }
  transmuxUnencrypted(Z, ee, ae, ve) {
    const {
      audioTrack: ye,
      videoTrack: be,
      id3Track: Ye,
      textTrack: Qe
    } = this.demuxer.demux(Z, ee, !1, !this.config.progressive);
    return {
      remuxResult: this.remuxer.remux(ye, be, Ye, Qe, ee, ae, !1, this.id),
      chunkMeta: ve
    };
  }
  transmuxSampleAes(Z, ee, ae, ve, ye) {
    return this.demuxer.demuxSampleAes(Z, ee, ae).then((be) => ({
      remuxResult: this.remuxer.remux(be.audioTrack, be.videoTrack, be.id3Track, be.textTrack, ae, ve, !1, this.id),
      chunkMeta: ye
    }));
  }
  configureTransmuxer(Z) {
    const {
      config: ee,
      observer: ae,
      typeSupported: ve,
      vendor: ye
    } = this;
    let be;
    for (let ot = 0, lt = muxConfig.length; ot < lt; ot++) {
      var Ye;
      if ((Ye = muxConfig[ot].demux) != null && Ye.probe(Z)) {
        be = muxConfig[ot];
        break;
      }
    }
    if (!be)
      return new Error("Failed to find demuxer by probing fragment data");
    const Qe = this.demuxer, Je = this.remuxer, nt = be.remux, st = be.demux;
    (!Je || !(Je instanceof nt)) && (this.remuxer = new nt(ae, ee, ve, ye)), (!Qe || !(Qe instanceof st)) && (this.demuxer = new st(ae, ee, ve), this.probe = st.probe);
  }
  needsProbing(Z, ee) {
    return !this.demuxer || !this.remuxer || Z || ee;
  }
  getDecrypter() {
    let Z = this.decrypter;
    return Z || (Z = this.decrypter = new Decrypter(this.config)), Z;
  }
}
function getEncryptionType(ie, Z) {
  let ee = null;
  return ie.byteLength > 0 && (Z == null ? void 0 : Z.key) != null && Z.iv !== null && Z.method != null && (ee = Z), ee;
}
const emptyResult = (ie) => ({
  remuxResult: {},
  chunkMeta: ie
});
function isPromise(ie) {
  return "then" in ie && ie.then instanceof Function;
}
class TransmuxConfig {
  constructor(Z, ee, ae, ve, ye) {
    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = Z, this.videoCodec = ee, this.initSegmentData = ae, this.duration = ve, this.defaultInitPts = ye || null;
  }
}
class TransmuxState {
  constructor(Z, ee, ae, ve, ye, be) {
    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = Z, this.contiguous = ee, this.accurateTimeOffset = ae, this.trackSwitch = ve, this.timeOffset = ye, this.initSegmentChange = be;
  }
}
var eventemitter3 = { exports: {} };
(function(ie) {
  var Z = Object.prototype.hasOwnProperty, ee = "~";
  function ae() {
  }
  Object.create && (ae.prototype = /* @__PURE__ */ Object.create(null), new ae().__proto__ || (ee = !1));
  function ve(Qe, Je, nt) {
    this.fn = Qe, this.context = Je, this.once = nt || !1;
  }
  function ye(Qe, Je, nt, st, ot) {
    if (typeof nt != "function")
      throw new TypeError("The listener must be a function");
    var lt = new ve(nt, st || Qe, ot), ft = ee ? ee + Je : Je;
    return Qe._events[ft] ? Qe._events[ft].fn ? Qe._events[ft] = [Qe._events[ft], lt] : Qe._events[ft].push(lt) : (Qe._events[ft] = lt, Qe._eventsCount++), Qe;
  }
  function be(Qe, Je) {
    --Qe._eventsCount === 0 ? Qe._events = new ae() : delete Qe._events[Je];
  }
  function Ye() {
    this._events = new ae(), this._eventsCount = 0;
  }
  Ye.prototype.eventNames = function() {
    var Je = [], nt, st;
    if (this._eventsCount === 0)
      return Je;
    for (st in nt = this._events)
      Z.call(nt, st) && Je.push(ee ? st.slice(1) : st);
    return Object.getOwnPropertySymbols ? Je.concat(Object.getOwnPropertySymbols(nt)) : Je;
  }, Ye.prototype.listeners = function(Je) {
    var nt = ee ? ee + Je : Je, st = this._events[nt];
    if (!st)
      return [];
    if (st.fn)
      return [st.fn];
    for (var ot = 0, lt = st.length, ft = new Array(lt); ot < lt; ot++)
      ft[ot] = st[ot].fn;
    return ft;
  }, Ye.prototype.listenerCount = function(Je) {
    var nt = ee ? ee + Je : Je, st = this._events[nt];
    return st ? st.fn ? 1 : st.length : 0;
  }, Ye.prototype.emit = function(Je, nt, st, ot, lt, ft) {
    var gt = ee ? ee + Je : Je;
    if (!this._events[gt])
      return !1;
    var ct = this._events[gt], _r = arguments.length, Kr, Xr;
    if (ct.fn) {
      switch (ct.once && this.removeListener(Je, ct.fn, void 0, !0), _r) {
        case 1:
          return ct.fn.call(ct.context), !0;
        case 2:
          return ct.fn.call(ct.context, nt), !0;
        case 3:
          return ct.fn.call(ct.context, nt, st), !0;
        case 4:
          return ct.fn.call(ct.context, nt, st, ot), !0;
        case 5:
          return ct.fn.call(ct.context, nt, st, ot, lt), !0;
        case 6:
          return ct.fn.call(ct.context, nt, st, ot, lt, ft), !0;
      }
      for (Xr = 1, Kr = new Array(_r - 1); Xr < _r; Xr++)
        Kr[Xr - 1] = arguments[Xr];
      ct.fn.apply(ct.context, Kr);
    } else {
      var Jr = ct.length, ei;
      for (Xr = 0; Xr < Jr; Xr++)
        switch (ct[Xr].once && this.removeListener(Je, ct[Xr].fn, void 0, !0), _r) {
          case 1:
            ct[Xr].fn.call(ct[Xr].context);
            break;
          case 2:
            ct[Xr].fn.call(ct[Xr].context, nt);
            break;
          case 3:
            ct[Xr].fn.call(ct[Xr].context, nt, st);
            break;
          case 4:
            ct[Xr].fn.call(ct[Xr].context, nt, st, ot);
            break;
          default:
            if (!Kr)
              for (ei = 1, Kr = new Array(_r - 1); ei < _r; ei++)
                Kr[ei - 1] = arguments[ei];
            ct[Xr].fn.apply(ct[Xr].context, Kr);
        }
    }
    return !0;
  }, Ye.prototype.on = function(Je, nt, st) {
    return ye(this, Je, nt, st, !1);
  }, Ye.prototype.once = function(Je, nt, st) {
    return ye(this, Je, nt, st, !0);
  }, Ye.prototype.removeListener = function(Je, nt, st, ot) {
    var lt = ee ? ee + Je : Je;
    if (!this._events[lt])
      return this;
    if (!nt)
      return be(this, lt), this;
    var ft = this._events[lt];
    if (ft.fn)
      ft.fn === nt && (!ot || ft.once) && (!st || ft.context === st) && be(this, lt);
    else {
      for (var gt = 0, ct = [], _r = ft.length; gt < _r; gt++)
        (ft[gt].fn !== nt || ot && !ft[gt].once || st && ft[gt].context !== st) && ct.push(ft[gt]);
      ct.length ? this._events[lt] = ct.length === 1 ? ct[0] : ct : be(this, lt);
    }
    return this;
  }, Ye.prototype.removeAllListeners = function(Je) {
    var nt;
    return Je ? (nt = ee ? ee + Je : Je, this._events[nt] && be(this, nt)) : (this._events = new ae(), this._eventsCount = 0), this;
  }, Ye.prototype.off = Ye.prototype.removeListener, Ye.prototype.addListener = Ye.prototype.on, Ye.prefixed = ee, Ye.EventEmitter = Ye, ie.exports = Ye;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports, EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
class TransmuxerInterface {
  constructor(Z, ee, ae, ve) {
    this.error = null, this.hls = void 0, this.id = void 0, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.workerContext = null, this.onwmsg = void 0, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0;
    const ye = Z.config;
    this.hls = Z, this.id = ee, this.useWorker = !!ye.enableWorker, this.onTransmuxComplete = ae, this.onFlush = ve;
    const be = (nt, st) => {
      st = st || {}, st.frag = this.frag, st.id = this.id, nt === Events.ERROR && (this.error = st.error), this.hls.trigger(nt, st);
    };
    this.observer = new EventEmitter(), this.observer.on(Events.FRAG_DECRYPTED, be), this.observer.on(Events.ERROR, be);
    const Ye = getMediaSource(ye.preferManagedMediaSource) || {
      isTypeSupported: () => !1
    }, Qe = {
      mpeg: Ye.isTypeSupported("audio/mpeg"),
      mp3: Ye.isTypeSupported('audio/mp4; codecs="mp3"'),
      ac3: Ye.isTypeSupported('audio/mp4; codecs="ac-3"')
    }, Je = navigator.vendor;
    if (this.useWorker && typeof Worker < "u" && (ye.workerPath || hasUMDWorker())) {
      try {
        ye.workerPath ? (logger.log(`loading Web Worker ${ye.workerPath} for "${ee}"`), this.workerContext = loadWorker(ye.workerPath)) : (logger.log(`injecting Web Worker for "${ee}"`), this.workerContext = injectWorker()), this.onwmsg = (ot) => this.onWorkerMessage(ot);
        const {
          worker: st
        } = this.workerContext;
        st.addEventListener("message", this.onwmsg), st.onerror = (ot) => {
          const lt = new Error(`${ot.message}  (${ot.filename}:${ot.lineno})`);
          ye.enableWorker = !1, logger.warn(`Error in "${ee}" Web Worker, fallback to inline`), this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.OTHER_ERROR,
            details: ErrorDetails.INTERNAL_EXCEPTION,
            fatal: !1,
            event: "demuxerWorker",
            error: lt
          });
        }, st.postMessage({
          cmd: "init",
          typeSupported: Qe,
          vendor: Je,
          id: ee,
          config: JSON.stringify(ye)
        });
      } catch (st) {
        logger.warn(`Error setting up "${ee}" Web Worker, fallback to inline`, st), this.resetWorker(), this.error = null, this.transmuxer = new Transmuxer(this.observer, Qe, ye, Je, ee);
      }
      return;
    }
    this.transmuxer = new Transmuxer(this.observer, Qe, ye, Je, ee);
  }
  resetWorker() {
    if (this.workerContext) {
      const {
        worker: Z,
        objectURL: ee
      } = this.workerContext;
      ee && self.URL.revokeObjectURL(ee), Z.removeEventListener("message", this.onwmsg), Z.onerror = null, Z.terminate(), this.workerContext = null;
    }
  }
  destroy() {
    if (this.workerContext)
      this.resetWorker(), this.onwmsg = void 0;
    else {
      const ee = this.transmuxer;
      ee && (ee.destroy(), this.transmuxer = null);
    }
    const Z = this.observer;
    Z && Z.removeAllListeners(), this.frag = null, this.observer = null, this.hls = null;
  }
  push(Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt) {
    var st, ot;
    Je.transmuxing.start = self.performance.now();
    const {
      transmuxer: lt
    } = this, ft = be ? be.start : ye.start, gt = ye.decryptdata, ct = this.frag, _r = !(ct && ye.cc === ct.cc), Kr = !(ct && Je.level === ct.level), Xr = ct ? Je.sn - ct.sn : -1, Jr = this.part ? Je.part - this.part.index : -1, ei = Xr === 0 && Je.id > 1 && Je.id === (ct == null ? void 0 : ct.stats.chunkCount), si = !Kr && (Xr === 1 || Xr === 0 && (Jr === 1 || ei && Jr <= 0)), ri = self.performance.now();
    (Kr || Xr || ye.stats.parsing.start === 0) && (ye.stats.parsing.start = ri), be && (Jr || !si) && (be.stats.parsing.start = ri);
    const ai = !(ct && ((st = ye.initSegment) == null ? void 0 : st.url) === ((ot = ct.initSegment) == null ? void 0 : ot.url)), yi = new TransmuxState(_r, si, Qe, Kr, ft, ai);
    if (!si || _r || ai) {
      logger.log(`[transmuxer-interface, ${ye.type}]: Starting new transmux session for sn: ${Je.sn} p: ${Je.part} level: ${Je.level} id: ${Je.id}
        discontinuity: ${_r}
        trackSwitch: ${Kr}
        contiguous: ${si}
        accurateTimeOffset: ${Qe}
        timeOffset: ${ft}
        initSegmentChange: ${ai}`);
      const pi = new TransmuxConfig(ae, ve, ee, Ye, nt);
      this.configureTransmuxer(pi);
    }
    if (this.frag = ye, this.part = be, this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "demux",
        data: Z,
        decryptdata: gt,
        chunkMeta: Je,
        state: yi
      }, Z instanceof ArrayBuffer ? [Z] : []);
    else if (lt) {
      const pi = lt.push(Z, gt, Je, yi);
      isPromise(pi) ? (lt.async = !0, pi.then((di) => {
        this.handleTransmuxComplete(di);
      }).catch((di) => {
        this.transmuxerError(di, Je, "transmuxer-interface push error");
      })) : (lt.async = !1, this.handleTransmuxComplete(pi));
    }
  }
  flush(Z) {
    Z.transmuxing.start = self.performance.now();
    const {
      transmuxer: ee
    } = this;
    if (this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "flush",
        chunkMeta: Z
      });
    else if (ee) {
      let ae = ee.flush(Z);
      isPromise(ae) || ee.async ? (isPromise(ae) || (ae = Promise.resolve(ae)), ae.then((ye) => {
        this.handleFlushResult(ye, Z);
      }).catch((ye) => {
        this.transmuxerError(ye, Z, "transmuxer-interface flush error");
      })) : this.handleFlushResult(ae, Z);
    }
  }
  transmuxerError(Z, ee, ae) {
    this.hls && (this.error = Z, this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.FRAG_PARSING_ERROR,
      chunkMeta: ee,
      fatal: !1,
      error: Z,
      err: Z,
      reason: ae
    }));
  }
  handleFlushResult(Z, ee) {
    Z.forEach((ae) => {
      this.handleTransmuxComplete(ae);
    }), this.onFlush(ee);
  }
  onWorkerMessage(Z) {
    const ee = Z.data, ae = this.hls;
    switch (ee.event) {
      case "init": {
        var ve;
        const ye = (ve = this.workerContext) == null ? void 0 : ve.objectURL;
        ye && self.URL.revokeObjectURL(ye);
        break;
      }
      case "transmuxComplete": {
        this.handleTransmuxComplete(ee.data);
        break;
      }
      case "flush": {
        this.onFlush(ee.data);
        break;
      }
      case "workerLog":
        logger[ee.data.logType] && logger[ee.data.logType](ee.data.message);
        break;
      default: {
        ee.data = ee.data || {}, ee.data.frag = this.frag, ee.data.id = this.id, ae.trigger(ee.event, ee.data);
        break;
      }
    }
  }
  configureTransmuxer(Z) {
    const {
      transmuxer: ee
    } = this;
    this.workerContext ? this.workerContext.worker.postMessage({
      cmd: "configure",
      config: Z
    }) : ee && ee.configure(Z);
  }
  handleTransmuxComplete(Z) {
    Z.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(Z);
  }
}
function subtitleOptionsIdentical(ie, Z) {
  if (ie.length !== Z.length)
    return !1;
  for (let ee = 0; ee < ie.length; ee++)
    if (!mediaAttributesIdentical(ie[ee].attrs, Z[ee].attrs))
      return !1;
  return !0;
}
function mediaAttributesIdentical(ie, Z, ee) {
  const ae = ie["STABLE-RENDITION-ID"];
  return ae && !ee ? ae === Z["STABLE-RENDITION-ID"] : !(ee || ["LANGUAGE", "NAME", "CHARACTERISTICS", "AUTOSELECT", "DEFAULT", "FORCED", "ASSOC-LANGUAGE"]).some((ve) => ie[ve] !== Z[ve]);
}
function subtitleTrackMatchesTextTrack(ie, Z) {
  return Z.label.toLowerCase() === ie.name.toLowerCase() && (!Z.language || Z.language.toLowerCase() === (ie.lang || "").toLowerCase());
}
const TICK_INTERVAL$2 = 100;
class AudioStreamController extends BaseStreamController {
  constructor(Z, ee, ae) {
    super(Z, ee, ae, "[audio-stream-controller]", PlaylistLevelType.AUDIO), this.videoBuffer = null, this.videoTrackCC = -1, this.waitingVideoCC = -1, this.bufferedTrack = null, this.switchingTrack = null, this.trackId = -1, this.waitingData = null, this.mainDetails = null, this.flushing = !1, this.bufferFlushed = !1, this.cachedTrackLoadedData = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null, this.bufferedTrack = null, this.switchingTrack = null;
  }
  _registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.LEVEL_LOADED, this.onLevelLoaded, this), Z.on(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), Z.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), Z.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), Z.on(Events.ERROR, this.onError, this), Z.on(Events.BUFFER_RESET, this.onBufferReset, this), Z.on(Events.BUFFER_CREATED, this.onBufferCreated, this), Z.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this), Z.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this), Z.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this), Z.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.LEVEL_LOADED, this.onLevelLoaded, this), Z.off(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), Z.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), Z.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), Z.off(Events.ERROR, this.onError, this), Z.off(Events.BUFFER_RESET, this.onBufferReset, this), Z.off(Events.BUFFER_CREATED, this.onBufferCreated, this), Z.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this), Z.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this), Z.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this), Z.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(Z, {
    frag: ee,
    id: ae,
    initPTS: ve,
    timescale: ye
  }) {
    if (ae === "main") {
      const be = ee.cc;
      this.initPTS[ee.cc] = {
        baseTime: ve,
        timescale: ye
      }, this.log(`InitPTS for cc: ${be} found from main: ${ve}`), this.videoTrackCC = be, this.state === State.WAITING_INIT_PTS && this.tick();
    }
  }
  startLoad(Z) {
    if (!this.levels) {
      this.startPosition = Z, this.state = State.STOPPED;
      return;
    }
    const ee = this.lastCurrentTime;
    this.stopLoad(), this.setInterval(TICK_INTERVAL$2), ee > 0 && Z === -1 ? (this.log(`Override startPosition with lastCurrentTime @${ee.toFixed(3)}`), Z = ee, this.state = State.IDLE) : (this.loadedmetadata = !1, this.state = State.WAITING_TRACK), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = Z, this.tick();
  }
  doTick() {
    switch (this.state) {
      case State.IDLE:
        this.doTickIdle();
        break;
      case State.WAITING_TRACK: {
        var Z;
        const {
          levels: ae,
          trackId: ve
        } = this, ye = ae == null || (Z = ae[ve]) == null ? void 0 : Z.details;
        if (ye) {
          if (this.waitForCdnTuneIn(ye))
            break;
          this.state = State.WAITING_INIT_PTS;
        }
        break;
      }
      case State.FRAG_LOADING_WAITING_RETRY: {
        var ee;
        const ae = performance.now(), ve = this.retryDate;
        if (!ve || ae >= ve || (ee = this.media) != null && ee.seeking) {
          const {
            levels: ye,
            trackId: be
          } = this;
          this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded((ye == null ? void 0 : ye[be]) || null), this.state = State.IDLE;
        }
        break;
      }
      case State.WAITING_INIT_PTS: {
        const ae = this.waitingData;
        if (ae) {
          const {
            frag: ve,
            part: ye,
            cache: be,
            complete: Ye
          } = ae;
          if (this.initPTS[ve.cc] !== void 0) {
            this.waitingData = null, this.waitingVideoCC = -1, this.state = State.FRAG_LOADING;
            const Qe = be.flush(), Je = {
              frag: ve,
              part: ye,
              payload: Qe,
              networkDetails: null
            };
            this._handleFragmentLoadProgress(Je), Ye && super._handleFragmentLoadComplete(Je);
          } else if (this.videoTrackCC !== this.waitingVideoCC)
            this.log(`Waiting fragment cc (${ve.cc}) cancelled because video is at cc ${this.videoTrackCC}`), this.clearWaitingFragment();
          else {
            const Qe = this.getLoadPosition(), Je = BufferHelper.bufferInfo(this.mediaBuffer, Qe, this.config.maxBufferHole);
            fragmentWithinToleranceTest(Je.end, this.config.maxFragLookUpTolerance, ve) < 0 && (this.log(`Waiting fragment cc (${ve.cc}) @ ${ve.start} cancelled because another fragment at ${Je.end} is needed`), this.clearWaitingFragment());
          }
        } else
          this.state = State.IDLE;
      }
    }
    this.onTickEnd();
  }
  clearWaitingFragment() {
    const Z = this.waitingData;
    Z && (this.fragmentTracker.removeFragment(Z.frag), this.waitingData = null, this.waitingVideoCC = -1, this.state = State.IDLE);
  }
  resetLoadingState() {
    this.clearWaitingFragment(), super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media: Z
    } = this;
    Z != null && Z.readyState && (this.lastCurrentTime = Z.currentTime);
  }
  doTickIdle() {
    const {
      hls: Z,
      levels: ee,
      media: ae,
      trackId: ve
    } = this, ye = Z.config;
    if (!ae && (this.startFragRequested || !ye.startFragPrefetch) || !(ee != null && ee[ve]))
      return;
    const be = ee[ve], Ye = be.details;
    if (!Ye || Ye.live && this.levelLastLoaded !== be || this.waitForCdnTuneIn(Ye)) {
      this.state = State.WAITING_TRACK;
      return;
    }
    const Qe = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.bufferFlushed && Qe && (this.bufferFlushed = !1, this.afterBufferFlushed(Qe, ElementaryStreamTypes.AUDIO, PlaylistLevelType.AUDIO));
    const Je = this.getFwdBufferInfo(Qe, PlaylistLevelType.AUDIO);
    if (Je === null)
      return;
    const {
      bufferedTrack: nt,
      switchingTrack: st
    } = this;
    if (!st && this._streamEnded(Je, Ye)) {
      Z.trigger(Events.BUFFER_EOS, {
        type: "audio"
      }), this.state = State.ENDED;
      return;
    }
    const ot = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, PlaylistLevelType.MAIN), lt = Je.len, ft = this.getMaxBufferLength(ot == null ? void 0 : ot.len), gt = Ye.fragments, ct = gt[0].start;
    let _r = this.flushing ? this.getLoadPosition() : Je.end;
    if (st && ae) {
      const ei = this.getLoadPosition();
      nt && !mediaAttributesIdentical(st.attrs, nt.attrs) && (_r = ei), Ye.PTSKnown && ei < ct && (Je.end > ct || Je.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), ae.currentTime = ct + 0.05);
    }
    if (lt >= ft && !st && _r < gt[gt.length - 1].start)
      return;
    let Kr = this.getNextFragment(_r, Ye), Xr = !1;
    if (Kr && this.isLoopLoading(Kr, _r) && (Xr = !!Kr.gap, Kr = this.getNextFragmentLoopLoading(Kr, Ye, Je, PlaylistLevelType.MAIN, ft)), !Kr) {
      this.bufferFlushed = !0;
      return;
    }
    const Jr = ot && Kr.start > ot.end + Ye.targetduration;
    if (Jr || // Or wait for main buffer after buffing some audio
    !(ot != null && ot.len) && Je.len) {
      const ei = this.getAppendedFrag(Kr.start, PlaylistLevelType.MAIN);
      if (ei === null || (Xr || (Xr = !!ei.gap || !!Jr && ot.len === 0), Jr && !Xr || Xr && Je.nextStart && Je.nextStart < ei.end))
        return;
    }
    this.loadFragment(Kr, be, _r);
  }
  getMaxBufferLength(Z) {
    const ee = super.getMaxBufferLength();
    return Z ? Math.min(Math.max(ee, Z), this.config.maxMaxBufferLength) : ee;
  }
  onMediaDetaching() {
    this.videoBuffer = null, this.bufferFlushed = this.flushing = !1, super.onMediaDetaching();
  }
  onAudioTracksUpdated(Z, {
    audioTracks: ee
  }) {
    this.resetTransmuxer(), this.levels = ee.map((ae) => new Level(ae));
  }
  onAudioTrackSwitching(Z, ee) {
    const ae = !!ee.url;
    this.trackId = ee.id;
    const {
      fragCurrent: ve
    } = this;
    ve && (ve.abortRequests(), this.removeUnbufferedFrags(ve.start)), this.resetLoadingState(), ae ? this.setInterval(TICK_INTERVAL$2) : this.resetTransmuxer(), ae ? (this.switchingTrack = ee, this.state = State.IDLE, this.flushAudioIfNeeded(ee)) : (this.switchingTrack = null, this.bufferedTrack = ee, this.state = State.STOPPED), this.tick();
  }
  onManifestLoading() {
    this.fragmentTracker.removeAllFragments(), this.startPosition = this.lastCurrentTime = 0, this.bufferFlushed = this.flushing = !1, this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null, this.startFragRequested = !1, this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
  }
  onLevelLoaded(Z, ee) {
    this.mainDetails = ee.details, this.cachedTrackLoadedData !== null && (this.hls.trigger(Events.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData), this.cachedTrackLoadedData = null);
  }
  onAudioTrackLoaded(Z, ee) {
    var ae;
    if (this.mainDetails == null) {
      this.cachedTrackLoadedData = ee;
      return;
    }
    const {
      levels: ve
    } = this, {
      details: ye,
      id: be
    } = ee;
    if (!ve) {
      this.warn(`Audio tracks were reset while loading level ${be}`);
      return;
    }
    this.log(`Audio track ${be} loaded [${ye.startSN},${ye.endSN}]${ye.lastPartSn ? `[part-${ye.lastPartSn}-${ye.lastPartIndex}]` : ""},duration:${ye.totalduration}`);
    const Ye = ve[be];
    let Qe = 0;
    if (ye.live || (ae = Ye.details) != null && ae.live) {
      this.checkLiveUpdate(ye);
      const nt = this.mainDetails;
      if (ye.deltaUpdateFailed || !nt)
        return;
      if (!Ye.details && ye.hasProgramDateTime && nt.hasProgramDateTime)
        alignMediaPlaylistByPDT(ye, nt), Qe = ye.fragments[0].start;
      else {
        var Je;
        Qe = this.alignPlaylists(ye, Ye.details, (Je = this.levelLastLoaded) == null ? void 0 : Je.details);
      }
    }
    Ye.details = ye, this.levelLastLoaded = Ye, !this.startFragRequested && (this.mainDetails || !ye.live) && this.setStartPosition(Ye.details, Qe), this.state === State.WAITING_TRACK && !this.waitForCdnTuneIn(ye) && (this.state = State.IDLE), this.tick();
  }
  _handleFragmentLoadProgress(Z) {
    var ee;
    const {
      frag: ae,
      part: ve,
      payload: ye
    } = Z, {
      config: be,
      trackId: Ye,
      levels: Qe
    } = this;
    if (!Qe) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${ae.sn} of level ${ae.level} will not be buffered`);
      return;
    }
    const Je = Qe[Ye];
    if (!Je) {
      this.warn("Audio track is undefined on fragment load progress");
      return;
    }
    const nt = Je.details;
    if (!nt) {
      this.warn("Audio track details undefined on fragment load progress"), this.removeUnbufferedFrags(ae.start);
      return;
    }
    const st = be.defaultAudioCodec || Je.audioCodec || "mp4a.40.2";
    let ot = this.transmuxer;
    ot || (ot = this.transmuxer = new TransmuxerInterface(this.hls, PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
    const lt = this.initPTS[ae.cc], ft = (ee = ae.initSegment) == null ? void 0 : ee.data;
    if (lt !== void 0) {
      const ct = ve ? ve.index : -1, _r = ct !== -1, Kr = new ChunkMetadata(ae.level, ae.sn, ae.stats.chunkCount, ye.byteLength, ct, _r);
      ot.push(ye, ft, st, "", ae, ve, nt.totalduration, !1, Kr, lt);
    } else {
      this.log(`Unknown video PTS for cc ${ae.cc}, waiting for video PTS before demuxing audio frag ${ae.sn} of [${nt.startSN} ,${nt.endSN}],track ${Ye}`);
      const {
        cache: gt
      } = this.waitingData = this.waitingData || {
        frag: ae,
        part: ve,
        cache: new ChunkCache(),
        complete: !1
      };
      gt.push(new Uint8Array(ye)), this.waitingVideoCC = this.videoTrackCC, this.state = State.WAITING_INIT_PTS;
    }
  }
  _handleFragmentLoadComplete(Z) {
    if (this.waitingData) {
      this.waitingData.complete = !0;
      return;
    }
    super._handleFragmentLoadComplete(Z);
  }
  onBufferReset() {
    this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
  }
  onBufferCreated(Z, ee) {
    const ae = ee.tracks.audio;
    ae && (this.mediaBuffer = ae.buffer || null), ee.tracks.video && (this.videoBuffer = ee.tracks.video.buffer || null);
  }
  onFragBuffered(Z, ee) {
    const {
      frag: ae,
      part: ve
    } = ee;
    if (ae.type !== PlaylistLevelType.AUDIO) {
      if (!this.loadedmetadata && ae.type === PlaylistLevelType.MAIN) {
        const ye = this.videoBuffer || this.media;
        ye && BufferHelper.getBuffered(ye).length && (this.loadedmetadata = !0);
      }
      return;
    }
    if (this.fragContextChanged(ae)) {
      this.warn(`Fragment ${ae.sn}${ve ? " p: " + ve.index : ""} of level ${ae.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
      return;
    }
    if (ae.sn !== "initSegment") {
      this.fragPrevious = ae;
      const ye = this.switchingTrack;
      ye && (this.bufferedTrack = ye, this.switchingTrack = null, this.hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, ye)));
    }
    this.fragBufferedComplete(ae, ve);
  }
  onError(Z, ee) {
    var ae;
    if (ee.fatal) {
      this.state = State.ERROR;
      return;
    }
    switch (ee.details) {
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_PARSING_ERROR:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(PlaylistLevelType.AUDIO, ee);
        break;
      case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
      case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        !ee.levelRetry && this.state === State.WAITING_TRACK && ((ae = ee.context) == null ? void 0 : ae.type) === PlaylistContextType.AUDIO_TRACK && (this.state = State.IDLE);
        break;
      case ErrorDetails.BUFFER_APPEND_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
        if (!ee.parent || ee.parent !== "audio")
          return;
        if (ee.details === ErrorDetails.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        this.reduceLengthAndFlushBuffer(ee) && (this.bufferedTrack = null, super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"));
        break;
      case ErrorDetails.INTERNAL_EXCEPTION:
        this.recoverWorkerError(ee);
        break;
    }
  }
  onBufferFlushing(Z, {
    type: ee
  }) {
    ee !== ElementaryStreamTypes.VIDEO && (this.flushing = !0);
  }
  onBufferFlushed(Z, {
    type: ee
  }) {
    if (ee !== ElementaryStreamTypes.VIDEO) {
      this.flushing = !1, this.bufferFlushed = !0, this.state === State.ENDED && (this.state = State.IDLE);
      const ae = this.mediaBuffer || this.media;
      ae && (this.afterBufferFlushed(ae, ee, PlaylistLevelType.AUDIO), this.tick());
    }
  }
  _handleTransmuxComplete(Z) {
    var ee;
    const ae = "audio", {
      hls: ve
    } = this, {
      remuxResult: ye,
      chunkMeta: be
    } = Z, Ye = this.getCurrentContext(be);
    if (!Ye) {
      this.resetWhenMissingContext(be);
      return;
    }
    const {
      frag: Qe,
      part: Je,
      level: nt
    } = Ye, {
      details: st
    } = nt, {
      audio: ot,
      text: lt,
      id3: ft,
      initSegment: gt
    } = ye;
    if (this.fragContextChanged(Qe) || !st) {
      this.fragmentTracker.removeFragment(Qe);
      return;
    }
    if (this.state = State.PARSING, this.switchingTrack && ot && this.completeAudioSwitch(this.switchingTrack), gt != null && gt.tracks) {
      const ct = Qe.initSegment || Qe;
      this._bufferInitSegment(nt, gt.tracks, ct, be), ve.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
        frag: ct,
        id: ae,
        tracks: gt.tracks
      });
    }
    if (ot) {
      const {
        startPTS: ct,
        endPTS: _r,
        startDTS: Kr,
        endDTS: Xr
      } = ot;
      Je && (Je.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
        startPTS: ct,
        endPTS: _r,
        startDTS: Kr,
        endDTS: Xr
      }), Qe.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, ct, _r, Kr, Xr), this.bufferFragmentData(ot, Qe, Je, be);
    }
    if (ft != null && (ee = ft.samples) != null && ee.length) {
      const ct = _extends({
        id: ae,
        frag: Qe,
        details: st
      }, ft);
      ve.trigger(Events.FRAG_PARSING_METADATA, ct);
    }
    if (lt) {
      const ct = _extends({
        id: ae,
        frag: Qe,
        details: st
      }, lt);
      ve.trigger(Events.FRAG_PARSING_USERDATA, ct);
    }
  }
  _bufferInitSegment(Z, ee, ae, ve) {
    if (this.state !== State.PARSING)
      return;
    ee.video && delete ee.video;
    const ye = ee.audio;
    if (!ye)
      return;
    ye.id = "audio";
    const be = Z.audioCodec;
    this.log(`Init audio buffer, container:${ye.container}, codecs[level/parsed]=[${be}/${ye.codec}]`), be && be.split(",").length === 1 && (ye.levelCodec = be), this.hls.trigger(Events.BUFFER_CODECS, ee);
    const Ye = ye.initSegment;
    if (Ye != null && Ye.byteLength) {
      const Qe = {
        type: "audio",
        frag: ae,
        part: null,
        chunkMeta: ve,
        parent: ae.type,
        data: Ye
      };
      this.hls.trigger(Events.BUFFER_APPENDING, Qe);
    }
    this.tickImmediate();
  }
  loadFragment(Z, ee, ae) {
    const ve = this.fragmentTracker.getState(Z);
    if (this.fragCurrent = Z, this.switchingTrack || ve === FragmentState.NOT_LOADED || ve === FragmentState.PARTIAL) {
      var ye;
      if (Z.sn === "initSegment")
        this._loadInitSegment(Z, ee);
      else if ((ye = ee.details) != null && ye.live && !this.initPTS[Z.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${Z.cc} of live stream before loading audio fragment ${Z.sn} of level ${this.trackId}`), this.state = State.WAITING_INIT_PTS;
        const be = this.mainDetails;
        be && be.fragments[0].start !== ee.details.fragments[0].start && alignMediaPlaylistByPDT(ee.details, be);
      } else
        this.startFragRequested = !0, super.loadFragment(Z, ee, ae);
    } else
      this.clearTrackerIfNeeded(Z);
  }
  flushAudioIfNeeded(Z) {
    const {
      media: ee,
      bufferedTrack: ae
    } = this, ve = ae == null ? void 0 : ae.attrs, ye = Z.attrs;
    ee && ve && (ve.CHANNELS !== ye.CHANNELS || ae.name !== Z.name || ae.lang !== Z.lang) && (this.log("Switching audio track : flushing all audio"), super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"), this.bufferedTrack = null);
  }
  completeAudioSwitch(Z) {
    const {
      hls: ee
    } = this;
    this.flushAudioIfNeeded(Z), this.bufferedTrack = Z, this.switchingTrack = null, ee.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, Z));
  }
}
class AudioTrackController extends BasePlaylistController {
  constructor(Z) {
    super(Z, "[audio-track-controller]"), this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.on(Events.LEVEL_LOADING, this.onLevelLoading, this), Z.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this), Z.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), Z.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.off(Events.LEVEL_LOADING, this.onLevelLoading, this), Z.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this), Z.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), Z.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, super.destroy();
  }
  onManifestLoading() {
    this.tracks = [], this.tracksInGroup = [], this.groupIds = null, this.currentTrack = null, this.trackId = -1, this.selectDefaultTrack = !0;
  }
  onManifestParsed(Z, ee) {
    this.tracks = ee.audioTracks || [];
  }
  onAudioTrackLoaded(Z, ee) {
    const {
      id: ae,
      groupId: ve,
      details: ye
    } = ee, be = this.tracksInGroup[ae];
    if (!be || be.groupId !== ve) {
      this.warn(`Audio track with id:${ae} and group:${ve} not found in active group ${be == null ? void 0 : be.groupId}`);
      return;
    }
    const Ye = be.details;
    be.details = ee.details, this.log(`Audio track ${ae} "${be.name}" lang:${be.lang} group:${ve} loaded [${ye.startSN}-${ye.endSN}]`), ae === this.trackId && this.playlistLoaded(ae, ee, Ye);
  }
  onLevelLoading(Z, ee) {
    this.switchLevel(ee.level);
  }
  onLevelSwitching(Z, ee) {
    this.switchLevel(ee.level);
  }
  switchLevel(Z) {
    const ee = this.hls.levels[Z];
    if (!ee)
      return;
    const ae = ee.audioGroups || null, ve = this.groupIds;
    let ye = this.currentTrack;
    if (!ae || (ve == null ? void 0 : ve.length) !== (ae == null ? void 0 : ae.length) || ae != null && ae.some((Ye) => (ve == null ? void 0 : ve.indexOf(Ye)) === -1)) {
      this.groupIds = ae, this.trackId = -1, this.currentTrack = null;
      const Ye = this.tracks.filter((ot) => !ae || ae.indexOf(ot.groupId) !== -1);
      if (Ye.length)
        this.selectDefaultTrack && !Ye.some((ot) => ot.default) && (this.selectDefaultTrack = !1), Ye.forEach((ot, lt) => {
          ot.id = lt;
        });
      else if (!ye && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = Ye;
      const Qe = this.hls.config.audioPreference;
      if (!ye && Qe) {
        const ot = findMatchingOption(Qe, Ye, audioMatchPredicate);
        if (ot > -1)
          ye = Ye[ot];
        else {
          const lt = findMatchingOption(Qe, this.tracks);
          ye = this.tracks[lt];
        }
      }
      let Je = this.findTrackId(ye);
      Je === -1 && ye && (Je = this.findTrackId(null));
      const nt = {
        audioTracks: Ye
      };
      this.log(`Updating audio tracks, ${Ye.length} track(s) found in group(s): ${ae == null ? void 0 : ae.join(",")}`), this.hls.trigger(Events.AUDIO_TRACKS_UPDATED, nt);
      const st = this.trackId;
      if (Je !== -1 && st === -1)
        this.setAudioTrack(Je);
      else if (Ye.length && st === -1) {
        var be;
        const ot = new Error(`No audio track selected for current audio group-ID(s): ${(be = this.groupIds) == null ? void 0 : be.join(",")} track count: ${Ye.length}`);
        this.warn(ot.message), this.hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
          fatal: !0,
          error: ot
        });
      }
    } else
      this.shouldReloadPlaylist(ye) && this.setAudioTrack(this.trackId);
  }
  onError(Z, ee) {
    ee.fatal || !ee.context || ee.context.type === PlaylistContextType.AUDIO_TRACK && ee.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(ee.context.groupId) !== -1) && (this.requestScheduled = -1, this.checkRetry(ee));
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(Z) {
    this.selectDefaultTrack = !1, this.setAudioTrack(Z);
  }
  setAudioOption(Z) {
    const ee = this.hls;
    if (ee.config.audioPreference = Z, Z) {
      const ae = this.allAudioTracks;
      if (this.selectDefaultTrack = !1, ae.length) {
        const ve = this.currentTrack;
        if (ve && matchesOption(Z, ve, audioMatchPredicate))
          return ve;
        const ye = findMatchingOption(Z, this.tracksInGroup, audioMatchPredicate);
        if (ye > -1) {
          const be = this.tracksInGroup[ye];
          return this.setAudioTrack(ye), be;
        } else if (ve) {
          let be = ee.loadLevel;
          be === -1 && (be = ee.firstAutoLevel);
          const Ye = findClosestLevelWithAudioGroup(Z, ee.levels, ae, be, audioMatchPredicate);
          if (Ye === -1)
            return null;
          ee.nextLoadLevel = Ye;
        }
        if (Z.channels || Z.audioCodec) {
          const be = findMatchingOption(Z, ae);
          if (be > -1)
            return ae[be];
        }
      }
    }
    return null;
  }
  setAudioTrack(Z) {
    const ee = this.tracksInGroup;
    if (Z < 0 || Z >= ee.length) {
      this.warn(`Invalid audio track id: ${Z}`);
      return;
    }
    this.clearTimer(), this.selectDefaultTrack = !1;
    const ae = this.currentTrack, ve = ee[Z], ye = ve.details && !ve.details.live;
    if (Z === this.trackId && ve === ae && ye || (this.log(`Switching to audio-track ${Z} "${ve.name}" lang:${ve.lang} group:${ve.groupId} channels:${ve.channels}`), this.trackId = Z, this.currentTrack = ve, this.hls.trigger(Events.AUDIO_TRACK_SWITCHING, _objectSpread2({}, ve)), ye))
      return;
    const be = this.switchParams(ve.url, ae == null ? void 0 : ae.details);
    this.loadPlaylist(be);
  }
  findTrackId(Z) {
    const ee = this.tracksInGroup;
    for (let ae = 0; ae < ee.length; ae++) {
      const ve = ee[ae];
      if (!(this.selectDefaultTrack && !ve.default) && (!Z || matchesOption(Z, ve, audioMatchPredicate)))
        return ae;
    }
    if (Z) {
      const {
        name: ae,
        lang: ve,
        assocLang: ye,
        characteristics: be,
        audioCodec: Ye,
        channels: Qe
      } = Z;
      for (let Je = 0; Je < ee.length; Je++) {
        const nt = ee[Je];
        if (matchesOption({
          name: ae,
          lang: ve,
          assocLang: ye,
          characteristics: be,
          audioCodec: Ye,
          channels: Qe
        }, nt, audioMatchPredicate))
          return Je;
      }
      for (let Je = 0; Je < ee.length; Je++) {
        const nt = ee[Je];
        if (mediaAttributesIdentical(Z.attrs, nt.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return Je;
      }
      for (let Je = 0; Je < ee.length; Je++) {
        const nt = ee[Je];
        if (mediaAttributesIdentical(Z.attrs, nt.attrs, ["LANGUAGE"]))
          return Je;
      }
    }
    return -1;
  }
  loadPlaylist(Z) {
    const ee = this.currentTrack;
    if (this.shouldLoadPlaylist(ee) && ee) {
      super.loadPlaylist();
      const ae = ee.id, ve = ee.groupId;
      let ye = ee.url;
      if (Z)
        try {
          ye = Z.addDirectives(ye);
        } catch (be) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${be}`);
        }
      this.log(`loading audio-track playlist ${ae} "${ee.name}" lang:${ee.lang} group:${ve}`), this.clearTimer(), this.hls.trigger(Events.AUDIO_TRACK_LOADING, {
        url: ye,
        id: ae,
        groupId: ve,
        deliveryDirectives: Z || null
      });
    }
  }
}
const TICK_INTERVAL$1 = 500;
class SubtitleStreamController extends BaseStreamController {
  constructor(Z, ee, ae) {
    super(Z, ee, ae, "[subtitle-stream-controller]", PlaylistLevelType.SUBTITLE), this.currentTrackId = -1, this.tracksBuffered = [], this.mainDetails = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null;
  }
  _registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.LEVEL_LOADED, this.onLevelLoaded, this), Z.on(Events.ERROR, this.onError, this), Z.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), Z.on(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), Z.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), Z.on(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), Z.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this), Z.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.LEVEL_LOADED, this.onLevelLoaded, this), Z.off(Events.ERROR, this.onError, this), Z.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), Z.off(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), Z.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), Z.off(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), Z.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this), Z.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  startLoad(Z) {
    this.stopLoad(), this.state = State.IDLE, this.setInterval(TICK_INTERVAL$1), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = Z, this.tick();
  }
  onManifestLoading() {
    this.mainDetails = null, this.fragmentTracker.removeAllFragments();
  }
  onMediaDetaching() {
    this.tracksBuffered = [], super.onMediaDetaching();
  }
  onLevelLoaded(Z, ee) {
    this.mainDetails = ee.details;
  }
  onSubtitleFragProcessed(Z, ee) {
    const {
      frag: ae,
      success: ve
    } = ee;
    if (this.fragPrevious = ae, this.state = State.IDLE, !ve)
      return;
    const ye = this.tracksBuffered[this.currentTrackId];
    if (!ye)
      return;
    let be;
    const Ye = ae.start;
    for (let Je = 0; Je < ye.length; Je++)
      if (Ye >= ye[Je].start && Ye <= ye[Je].end) {
        be = ye[Je];
        break;
      }
    const Qe = ae.start + ae.duration;
    be ? be.end = Qe : (be = {
      start: Ye,
      end: Qe
    }, ye.push(be)), this.fragmentTracker.fragBuffered(ae), this.fragBufferedComplete(ae, null);
  }
  onBufferFlushing(Z, ee) {
    const {
      startOffset: ae,
      endOffset: ve
    } = ee;
    if (ae === 0 && ve !== Number.POSITIVE_INFINITY) {
      const ye = ve - 1;
      if (ye <= 0)
        return;
      ee.endOffsetSubtitles = Math.max(0, ye), this.tracksBuffered.forEach((be) => {
        for (let Ye = 0; Ye < be.length; ) {
          if (be[Ye].end <= ye) {
            be.shift();
            continue;
          } else if (be[Ye].start < ye)
            be[Ye].start = ye;
          else
            break;
          Ye++;
        }
      }), this.fragmentTracker.removeFragmentsInRange(ae, ye, PlaylistLevelType.SUBTITLE);
    }
  }
  onFragBuffered(Z, ee) {
    if (!this.loadedmetadata && ee.frag.type === PlaylistLevelType.MAIN) {
      var ae;
      (ae = this.media) != null && ae.buffered.length && (this.loadedmetadata = !0);
    }
  }
  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(Z, ee) {
    const ae = ee.frag;
    (ae == null ? void 0 : ae.type) === PlaylistLevelType.SUBTITLE && (this.fragCurrent && this.fragCurrent.abortRequests(), this.state !== State.STOPPED && (this.state = State.IDLE));
  }
  // Got all new subtitle levels.
  onSubtitleTracksUpdated(Z, {
    subtitleTracks: ee
  }) {
    if (!this.levels || subtitleOptionsIdentical(this.levels, ee)) {
      this.levels = ee.map((ae) => new Level(ae));
      return;
    }
    this.tracksBuffered = [], this.levels = ee.map((ae) => {
      const ve = new Level(ae);
      return this.tracksBuffered[ve.id] = [], ve;
    }), this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, PlaylistLevelType.SUBTITLE), this.fragPrevious = null, this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(Z, ee) {
    var ae;
    if (this.currentTrackId = ee.id, !((ae = this.levels) != null && ae.length) || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }
    const ve = this.levels[this.currentTrackId];
    ve != null && ve.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, ve && this.setInterval(TICK_INTERVAL$1);
  }
  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(Z, ee) {
    var ae;
    const {
      currentTrackId: ve,
      levels: ye
    } = this, {
      details: be,
      id: Ye
    } = ee;
    if (!ye) {
      this.warn(`Subtitle tracks were reset while loading level ${Ye}`);
      return;
    }
    const Qe = ye[ve];
    if (Ye >= ye.length || Ye !== ve || !Qe)
      return;
    this.log(`Subtitle track ${Ye} loaded [${be.startSN},${be.endSN}]${be.lastPartSn ? `[part-${be.lastPartSn}-${be.lastPartIndex}]` : ""},duration:${be.totalduration}`), this.mediaBuffer = this.mediaBufferTimeRanges;
    let Je = 0;
    if (be.live || (ae = Qe.details) != null && ae.live) {
      const st = this.mainDetails;
      if (be.deltaUpdateFailed || !st)
        return;
      const ot = st.fragments[0];
      if (!Qe.details)
        be.hasProgramDateTime && st.hasProgramDateTime ? (alignMediaPlaylistByPDT(be, st), Je = be.fragments[0].start) : ot && (Je = ot.start, addSliding(be, Je));
      else {
        var nt;
        Je = this.alignPlaylists(be, Qe.details, (nt = this.levelLastLoaded) == null ? void 0 : nt.details), Je === 0 && ot && (Je = ot.start, addSliding(be, Je));
      }
    }
    Qe.details = be, this.levelLastLoaded = Qe, !this.startFragRequested && (this.mainDetails || !be.live) && this.setStartPosition(Qe.details, Je), this.tick(), be.live && !this.fragCurrent && this.media && this.state === State.IDLE && (findFragmentByPTS(null, be.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), Qe.details = void 0));
  }
  _handleFragmentLoadComplete(Z) {
    const {
      frag: ee,
      payload: ae
    } = Z, ve = ee.decryptdata, ye = this.hls;
    if (!this.fragContextChanged(ee) && ae && ae.byteLength > 0 && ve != null && ve.key && ve.iv && ve.method === "AES-128") {
      const be = performance.now();
      this.decrypter.decrypt(new Uint8Array(ae), ve.key.buffer, ve.iv.buffer).catch((Ye) => {
        throw ye.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_DECRYPT_ERROR,
          fatal: !1,
          error: Ye,
          reason: Ye.message,
          frag: ee
        }), Ye;
      }).then((Ye) => {
        const Qe = performance.now();
        ye.trigger(Events.FRAG_DECRYPTED, {
          frag: ee,
          payload: Ye,
          stats: {
            tstart: be,
            tdecrypt: Qe
          }
        });
      }).catch((Ye) => {
        this.warn(`${Ye.name}: ${Ye.message}`), this.state = State.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = State.IDLE;
      return;
    }
    if (this.state === State.IDLE) {
      const {
        currentTrackId: Z,
        levels: ee
      } = this, ae = ee == null ? void 0 : ee[Z];
      if (!ae || !ee.length || !ae.details)
        return;
      const {
        config: ve
      } = this, ye = this.getLoadPosition(), be = BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], ye, ve.maxBufferHole), {
        end: Ye,
        len: Qe
      } = be, Je = this.getFwdBufferInfo(this.media, PlaylistLevelType.MAIN), nt = ae.details, st = this.getMaxBufferLength(Je == null ? void 0 : Je.len) + nt.levelTargetDuration;
      if (Qe > st)
        return;
      const ot = nt.fragments, lt = ot.length, ft = nt.edge;
      let gt = null;
      const ct = this.fragPrevious;
      if (Ye < ft) {
        const _r = ve.maxFragLookUpTolerance, Kr = Ye > ft - _r ? 0 : _r;
        gt = findFragmentByPTS(ct, ot, Math.max(ot[0].start, Ye), Kr), !gt && ct && ct.start < ot[0].start && (gt = ot[0]);
      } else
        gt = ot[lt - 1];
      if (!gt)
        return;
      if (gt = this.mapToInitFragWhenRequired(gt), gt.sn !== "initSegment") {
        const _r = gt.sn - nt.startSN, Kr = ot[_r - 1];
        Kr && Kr.cc === gt.cc && this.fragmentTracker.getState(Kr) === FragmentState.NOT_LOADED && (gt = Kr);
      }
      this.fragmentTracker.getState(gt) === FragmentState.NOT_LOADED && this.loadFragment(gt, ae, Ye);
    }
  }
  getMaxBufferLength(Z) {
    const ee = super.getMaxBufferLength();
    return Z ? Math.max(ee, Z) : ee;
  }
  loadFragment(Z, ee, ae) {
    this.fragCurrent = Z, Z.sn === "initSegment" ? this._loadInitSegment(Z, ee) : (this.startFragRequested = !0, super.loadFragment(Z, ee, ae));
  }
  get mediaBufferTimeRanges() {
    return new BufferableInstance(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class BufferableInstance {
  constructor(Z) {
    this.buffered = void 0;
    const ee = (ae, ve, ye) => {
      if (ve = ve >>> 0, ve > ye - 1)
        throw new DOMException(`Failed to execute '${ae}' on 'TimeRanges': The index provided (${ve}) is greater than the maximum bound (${ye})`);
      return Z[ve][ae];
    };
    this.buffered = {
      get length() {
        return Z.length;
      },
      end(ae) {
        return ee("end", ae, Z.length);
      },
      start(ae) {
        return ee("start", ae, Z.length);
      }
    };
  }
}
class SubtitleTrackController extends BasePlaylistController {
  constructor(Z) {
    super(Z, "[subtitle-track-controller]"), this.media = null, this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.queuedDefaultTrack = -1, this.asyncPollTrackChange = () => this.pollTrackChange(0), this.useTextTrackPolling = !1, this.subtitlePollingInterval = -1, this._subtitleDisplay = !0, this.onTextTracksChanged = () => {
      if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !this.media || !this.hls.config.renderTextTracksNatively)
        return;
      let ee = null;
      const ae = filterSubtitleTracks(this.media.textTracks);
      for (let ye = 0; ye < ae.length; ye++)
        if (ae[ye].mode === "hidden")
          ee = ae[ye];
        else if (ae[ye].mode === "showing") {
          ee = ae[ye];
          break;
        }
      const ve = this.findTrackForTextTrack(ee);
      this.subtitleTrack !== ve && this.setSubtitleTrack(ve);
    }, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, this.onTextTracksChanged = this.asyncPollTrackChange = null, super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(Z) {
    this._subtitleDisplay = Z, this.trackId > -1 && this.toggleTrackModes();
  }
  registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.on(Events.LEVEL_LOADING, this.onLevelLoading, this), Z.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this), Z.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), Z.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.off(Events.LEVEL_LOADING, this.onLevelLoading, this), Z.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this), Z.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), Z.off(Events.ERROR, this.onError, this);
  }
  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(Z, ee) {
    this.media = ee.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
  }
  pollTrackChange(Z) {
    self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, Z);
  }
  onMediaDetaching() {
    if (!this.media)
      return;
    self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), filterSubtitleTracks(this.media.textTracks).forEach((ee) => {
      clearCurrentCues(ee);
    }), this.subtitleTrack = -1, this.media = null;
  }
  onManifestLoading() {
    this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0;
  }
  // Fired whenever a new manifest is loaded.
  onManifestParsed(Z, ee) {
    this.tracks = ee.subtitleTracks;
  }
  onSubtitleTrackLoaded(Z, ee) {
    const {
      id: ae,
      groupId: ve,
      details: ye
    } = ee, be = this.tracksInGroup[ae];
    if (!be || be.groupId !== ve) {
      this.warn(`Subtitle track with id:${ae} and group:${ve} not found in active group ${be == null ? void 0 : be.groupId}`);
      return;
    }
    const Ye = be.details;
    be.details = ee.details, this.log(`Subtitle track ${ae} "${be.name}" lang:${be.lang} group:${ve} loaded [${ye.startSN}-${ye.endSN}]`), ae === this.trackId && this.playlistLoaded(ae, ee, Ye);
  }
  onLevelLoading(Z, ee) {
    this.switchLevel(ee.level);
  }
  onLevelSwitching(Z, ee) {
    this.switchLevel(ee.level);
  }
  switchLevel(Z) {
    const ee = this.hls.levels[Z];
    if (!ee)
      return;
    const ae = ee.subtitleGroups || null, ve = this.groupIds;
    let ye = this.currentTrack;
    if (!ae || (ve == null ? void 0 : ve.length) !== (ae == null ? void 0 : ae.length) || ae != null && ae.some((be) => (ve == null ? void 0 : ve.indexOf(be)) === -1)) {
      this.groupIds = ae, this.trackId = -1, this.currentTrack = null;
      const be = this.tracks.filter((nt) => !ae || ae.indexOf(nt.groupId) !== -1);
      if (be.length)
        this.selectDefaultTrack && !be.some((nt) => nt.default) && (this.selectDefaultTrack = !1), be.forEach((nt, st) => {
          nt.id = st;
        });
      else if (!ye && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = be;
      const Ye = this.hls.config.subtitlePreference;
      if (!ye && Ye) {
        this.selectDefaultTrack = !1;
        const nt = findMatchingOption(Ye, be);
        if (nt > -1)
          ye = be[nt];
        else {
          const st = findMatchingOption(Ye, this.tracks);
          ye = this.tracks[st];
        }
      }
      let Qe = this.findTrackId(ye);
      Qe === -1 && ye && (Qe = this.findTrackId(null));
      const Je = {
        subtitleTracks: be
      };
      this.log(`Updating subtitle tracks, ${be.length} track(s) found in "${ae == null ? void 0 : ae.join(",")}" group-id`), this.hls.trigger(Events.SUBTITLE_TRACKS_UPDATED, Je), Qe !== -1 && this.trackId === -1 && this.setSubtitleTrack(Qe);
    } else
      this.shouldReloadPlaylist(ye) && this.setSubtitleTrack(this.trackId);
  }
  findTrackId(Z) {
    const ee = this.tracksInGroup, ae = this.selectDefaultTrack;
    for (let ve = 0; ve < ee.length; ve++) {
      const ye = ee[ve];
      if (!(ae && !ye.default || !ae && !Z) && (!Z || matchesOption(ye, Z)))
        return ve;
    }
    if (Z) {
      for (let ve = 0; ve < ee.length; ve++) {
        const ye = ee[ve];
        if (mediaAttributesIdentical(Z.attrs, ye.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return ve;
      }
      for (let ve = 0; ve < ee.length; ve++) {
        const ye = ee[ve];
        if (mediaAttributesIdentical(Z.attrs, ye.attrs, ["LANGUAGE"]))
          return ve;
      }
    }
    return -1;
  }
  findTrackForTextTrack(Z) {
    if (Z) {
      const ee = this.tracksInGroup;
      for (let ae = 0; ae < ee.length; ae++) {
        const ve = ee[ae];
        if (subtitleTrackMatchesTextTrack(ve, Z))
          return ae;
      }
    }
    return -1;
  }
  onError(Z, ee) {
    ee.fatal || !ee.context || ee.context.type === PlaylistContextType.SUBTITLE_TRACK && ee.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(ee.context.groupId) !== -1) && this.checkRetry(ee);
  }
  get allSubtitleTracks() {
    return this.tracks;
  }
  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }
  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(Z) {
    this.selectDefaultTrack = !1, this.setSubtitleTrack(Z);
  }
  setSubtitleOption(Z) {
    if (this.hls.config.subtitlePreference = Z, Z) {
      const ee = this.allSubtitleTracks;
      if (this.selectDefaultTrack = !1, ee.length) {
        const ae = this.currentTrack;
        if (ae && matchesOption(Z, ae))
          return ae;
        const ve = findMatchingOption(Z, this.tracksInGroup);
        if (ve > -1) {
          const ye = this.tracksInGroup[ve];
          return this.setSubtitleTrack(ve), ye;
        } else {
          if (ae)
            return null;
          {
            const ye = findMatchingOption(Z, ee);
            if (ye > -1)
              return ee[ye];
          }
        }
      }
    }
    return null;
  }
  loadPlaylist(Z) {
    super.loadPlaylist();
    const ee = this.currentTrack;
    if (this.shouldLoadPlaylist(ee) && ee) {
      const ae = ee.id, ve = ee.groupId;
      let ye = ee.url;
      if (Z)
        try {
          ye = Z.addDirectives(ye);
        } catch (be) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${be}`);
        }
      this.log(`Loading subtitle playlist for id ${ae}`), this.hls.trigger(Events.SUBTITLE_TRACK_LOADING, {
        url: ye,
        id: ae,
        groupId: ve,
        deliveryDirectives: Z || null
      });
    }
  }
  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes() {
    const {
      media: Z
    } = this;
    if (!Z)
      return;
    const ee = filterSubtitleTracks(Z.textTracks), ae = this.currentTrack;
    let ve;
    if (ae && (ve = ee.filter((ye) => subtitleTrackMatchesTextTrack(ae, ye))[0], ve || this.warn(`Unable to find subtitle TextTrack with name "${ae.name}" and language "${ae.lang}"`)), [].slice.call(ee).forEach((ye) => {
      ye.mode !== "disabled" && ye !== ve && (ye.mode = "disabled");
    }), ve) {
      const ye = this.subtitleDisplay ? "showing" : "hidden";
      ve.mode !== ye && (ve.mode = ye);
    }
  }
  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(Z) {
    const ee = this.tracksInGroup;
    if (!this.media) {
      this.queuedDefaultTrack = Z;
      return;
    }
    if (Z < -1 || Z >= ee.length || !isFiniteNumber(Z)) {
      this.warn(`Invalid subtitle track id: ${Z}`);
      return;
    }
    this.clearTimer(), this.selectDefaultTrack = !1;
    const ae = this.currentTrack, ve = ee[Z] || null;
    if (this.trackId = Z, this.currentTrack = ve, this.toggleTrackModes(), !ve) {
      this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
        id: Z
      });
      return;
    }
    const ye = !!ve.details && !ve.details.live;
    if (Z === this.trackId && ve === ae && ye)
      return;
    this.log(`Switching to subtitle-track ${Z}` + (ve ? ` "${ve.name}" lang:${ve.lang} group:${ve.groupId}` : ""));
    const {
      id: be,
      groupId: Ye = "",
      name: Qe,
      type: Je,
      url: nt
    } = ve;
    this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
      id: be,
      groupId: Ye,
      name: Qe,
      type: Je,
      url: nt
    });
    const st = this.switchParams(ve.url, ae == null ? void 0 : ae.details);
    this.loadPlaylist(st);
  }
}
class BufferOperationQueue {
  constructor(Z) {
    this.buffers = void 0, this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    }, this.buffers = Z;
  }
  append(Z, ee, ae) {
    const ve = this.queues[ee];
    ve.push(Z), ve.length === 1 && !ae && this.executeNext(ee);
  }
  insertAbort(Z, ee) {
    this.queues[ee].unshift(Z), this.executeNext(ee);
  }
  appendBlocker(Z) {
    let ee;
    const ae = new Promise((ye) => {
      ee = ye;
    }), ve = {
      execute: ee,
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: () => {
      }
    };
    return this.append(ve, Z), ae;
  }
  executeNext(Z) {
    const ee = this.queues[Z];
    if (ee.length) {
      const ae = ee[0];
      try {
        ae.execute();
      } catch (ve) {
        logger.warn(`[buffer-operation-queue]: Exception executing "${Z}" SourceBuffer operation: ${ve}`), ae.onError(ve);
        const ye = this.buffers[Z];
        ye != null && ye.updating || this.shiftAndExecuteNext(Z);
      }
    }
  }
  shiftAndExecuteNext(Z) {
    this.queues[Z].shift(), this.executeNext(Z);
  }
  current(Z) {
    return this.queues[Z][0];
  }
}
const VIDEO_CODEC_PROFILE_REPLACE = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
class BufferController {
  constructor(Z) {
    this.details = null, this._objectUrl = null, this.operationQueue = void 0, this.listeners = void 0, this.hls = void 0, this.bufferCodecEventsExpected = 0, this._bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.appendSource = void 0, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.tracks = {}, this.pendingTracks = {}, this.sourceBuffer = void 0, this.log = void 0, this.warn = void 0, this.error = void 0, this._onEndStreaming = (ae) => {
      this.hls && this.hls.pauseBuffering();
    }, this._onStartStreaming = (ae) => {
      this.hls && this.hls.resumeBuffering();
    }, this._onMediaSourceOpen = () => {
      const {
        media: ae,
        mediaSource: ve
      } = this;
      this.log("Media source opened"), ae && (ae.removeEventListener("emptied", this._onMediaEmptied), this.updateMediaElementDuration(), this.hls.trigger(Events.MEDIA_ATTACHED, {
        media: ae,
        mediaSource: ve
      })), ve && ve.removeEventListener("sourceopen", this._onMediaSourceOpen), this.checkPendingTracks();
    }, this._onMediaSourceClose = () => {
      this.log("Media source closed");
    }, this._onMediaSourceEnded = () => {
      this.log("Media source ended");
    }, this._onMediaEmptied = () => {
      const {
        mediaSrc: ae,
        _objectUrl: ve
      } = this;
      ae !== ve && logger.error(`Media element src was set while attaching MediaSource (${ve} > ${ae})`);
    }, this.hls = Z;
    const ee = "[buffer-controller]";
    this.appendSource = Z.config.preferManagedMediaSource, this.log = logger.log.bind(logger, ee), this.warn = logger.warn.bind(logger, ee), this.error = logger.error.bind(logger, ee), this._initSourceBuffer(), this.registerListeners();
  }
  hasSourceTypes() {
    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
  }
  destroy() {
    this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = null, this.hls = null;
  }
  registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this), Z.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.on(Events.BUFFER_RESET, this.onBufferReset, this), Z.on(Events.BUFFER_APPENDING, this.onBufferAppending, this), Z.on(Events.BUFFER_CODECS, this.onBufferCodecs, this), Z.on(Events.BUFFER_EOS, this.onBufferEos, this), Z.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this), Z.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this), Z.on(Events.FRAG_PARSED, this.onFragParsed, this), Z.on(Events.FRAG_CHANGED, this.onFragChanged, this);
  }
  unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this), Z.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.off(Events.BUFFER_RESET, this.onBufferReset, this), Z.off(Events.BUFFER_APPENDING, this.onBufferAppending, this), Z.off(Events.BUFFER_CODECS, this.onBufferCodecs, this), Z.off(Events.BUFFER_EOS, this.onBufferEos, this), Z.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this), Z.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this), Z.off(Events.FRAG_PARSED, this.onFragParsed, this), Z.off(Events.FRAG_CHANGED, this.onFragChanged, this);
  }
  _initSourceBuffer() {
    this.sourceBuffer = {}, this.operationQueue = new BufferOperationQueue(this.sourceBuffer), this.listeners = {
      audio: [],
      video: [],
      audiovideo: []
    }, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.lastMpegAudioChunk = null;
  }
  onManifestLoading() {
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0, this.details = null;
  }
  onManifestParsed(Z, ee) {
    let ae = 2;
    (ee.audio && !ee.video || !ee.altAudio) && (ae = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = ae, this.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
  }
  onMediaAttaching(Z, ee) {
    const ae = this.media = ee.media, ve = getMediaSource(this.appendSource);
    if (ae && ve) {
      var ye;
      const be = this.mediaSource = new ve();
      this.log(`created media source: ${(ye = be.constructor) == null ? void 0 : ye.name}`), be.addEventListener("sourceopen", this._onMediaSourceOpen), be.addEventListener("sourceended", this._onMediaSourceEnded), be.addEventListener("sourceclose", this._onMediaSourceClose), be.addEventListener("startstreaming", this._onStartStreaming), be.addEventListener("endstreaming", this._onEndStreaming);
      const Ye = this._objectUrl = self.URL.createObjectURL(be);
      if (this.appendSource)
        try {
          ae.removeAttribute("src");
          const Qe = self.ManagedMediaSource;
          ae.disableRemotePlayback = ae.disableRemotePlayback || Qe && be instanceof Qe, removeSourceChildren(ae), addSource(ae, Ye), ae.load();
        } catch {
          ae.src = Ye;
        }
      else
        ae.src = Ye;
      ae.addEventListener("emptied", this._onMediaEmptied);
    }
  }
  onMediaDetaching() {
    const {
      media: Z,
      mediaSource: ee,
      _objectUrl: ae
    } = this;
    if (ee) {
      if (this.log("media source detaching"), ee.readyState === "open")
        try {
          ee.endOfStream();
        } catch (ve) {
          this.warn(`onMediaDetaching: ${ve.message} while calling endOfStream`);
        }
      this.onBufferReset(), ee.removeEventListener("sourceopen", this._onMediaSourceOpen), ee.removeEventListener("sourceended", this._onMediaSourceEnded), ee.removeEventListener("sourceclose", this._onMediaSourceClose), ee.removeEventListener("startstreaming", this._onStartStreaming), ee.removeEventListener("endstreaming", this._onEndStreaming), Z && (Z.removeEventListener("emptied", this._onMediaEmptied), ae && self.URL.revokeObjectURL(ae), this.mediaSrc === ae ? (Z.removeAttribute("src"), this.appendSource && removeSourceChildren(Z), Z.load()) : this.warn("media|source.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {};
    }
    this.hls.trigger(Events.MEDIA_DETACHED, void 0);
  }
  onBufferReset() {
    this.getSourceBufferTypes().forEach((Z) => {
      this.resetBuffer(Z);
    }), this._initSourceBuffer();
  }
  resetBuffer(Z) {
    const ee = this.sourceBuffer[Z];
    try {
      if (ee) {
        var ae;
        this.removeBufferListeners(Z), this.sourceBuffer[Z] = void 0, (ae = this.mediaSource) != null && ae.sourceBuffers.length && this.mediaSource.removeSourceBuffer(ee);
      }
    } catch (ve) {
      this.warn(`onBufferReset ${Z}`, ve);
    }
  }
  onBufferCodecs(Z, ee) {
    const ae = this.getSourceBufferTypes().length, ve = Object.keys(ee);
    if (ve.forEach((be) => {
      if (ae) {
        const Qe = this.tracks[be];
        if (Qe && typeof Qe.buffer.changeType == "function") {
          var Ye;
          const {
            id: Je,
            codec: nt,
            levelCodec: st,
            container: ot,
            metadata: lt
          } = ee[be], ft = pickMostCompleteCodecName(Qe.codec, Qe.levelCodec), gt = ft == null ? void 0 : ft.replace(VIDEO_CODEC_PROFILE_REPLACE, "$1");
          let ct = pickMostCompleteCodecName(nt, st);
          const _r = (Ye = ct) == null ? void 0 : Ye.replace(VIDEO_CODEC_PROFILE_REPLACE, "$1");
          if (ct && gt !== _r) {
            be.slice(0, 5) === "audio" && (ct = getCodecCompatibleName(ct, this.hls.config.preferManagedMediaSource));
            const Kr = `${ot};codecs=${ct}`;
            this.appendChangeType(be, Kr), this.log(`switching codec ${ft} to ${ct}`), this.tracks[be] = {
              buffer: Qe.buffer,
              codec: nt,
              container: ot,
              levelCodec: st,
              metadata: lt,
              id: Je
            };
          }
        }
      } else
        this.pendingTracks[be] = ee[be];
    }), ae)
      return;
    const ye = Math.max(this.bufferCodecEventsExpected - 1, 0);
    this.bufferCodecEventsExpected !== ye && (this.log(`${ye} bufferCodec event(s) expected ${ve.join(",")}`), this.bufferCodecEventsExpected = ye), this.mediaSource && this.mediaSource.readyState === "open" && this.checkPendingTracks();
  }
  appendChangeType(Z, ee) {
    const {
      operationQueue: ae
    } = this, ve = {
      execute: () => {
        const ye = this.sourceBuffer[Z];
        ye && (this.log(`changing ${Z} sourceBuffer type to ${ee}`), ye.changeType(ee)), ae.shiftAndExecuteNext(Z);
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (ye) => {
        this.warn(`Failed to change ${Z} SourceBuffer type`, ye);
      }
    };
    ae.append(ve, Z, !!this.pendingTracks[Z]);
  }
  onBufferAppending(Z, ee) {
    const {
      hls: ae,
      operationQueue: ve,
      tracks: ye
    } = this, {
      data: be,
      type: Ye,
      frag: Qe,
      part: Je,
      chunkMeta: nt
    } = ee, st = nt.buffering[Ye], ot = self.performance.now();
    st.start = ot;
    const lt = Qe.stats.buffering, ft = Je ? Je.stats.buffering : null;
    lt.start === 0 && (lt.start = ot), ft && ft.start === 0 && (ft.start = ot);
    const gt = ye.audio;
    let ct = !1;
    Ye === "audio" && (gt == null ? void 0 : gt.container) === "audio/mpeg" && (ct = !this.lastMpegAudioChunk || nt.id === 1 || this.lastMpegAudioChunk.sn !== nt.sn, this.lastMpegAudioChunk = nt);
    const _r = Qe.start, Kr = {
      execute: () => {
        if (st.executeStart = self.performance.now(), ct) {
          const Xr = this.sourceBuffer[Ye];
          if (Xr) {
            const Jr = _r - Xr.timestampOffset;
            Math.abs(Jr) >= 0.1 && (this.log(`Updating audio SourceBuffer timestampOffset to ${_r} (delta: ${Jr}) sn: ${Qe.sn})`), Xr.timestampOffset = _r);
          }
        }
        this.appendExecutor(be, Ye);
      },
      onStart: () => {
      },
      onComplete: () => {
        const Xr = self.performance.now();
        st.executeEnd = st.end = Xr, lt.first === 0 && (lt.first = Xr), ft && ft.first === 0 && (ft.first = Xr);
        const {
          sourceBuffer: Jr
        } = this, ei = {};
        for (const si in Jr)
          ei[si] = BufferHelper.getBuffered(Jr[si]);
        this.appendErrors[Ye] = 0, Ye === "audio" || Ye === "video" ? this.appendErrors.audiovideo = 0 : (this.appendErrors.audio = 0, this.appendErrors.video = 0), this.hls.trigger(Events.BUFFER_APPENDED, {
          type: Ye,
          frag: Qe,
          part: Je,
          chunkMeta: nt,
          parent: Qe.type,
          timeRanges: ei
        });
      },
      onError: (Xr) => {
        const Jr = {
          type: ErrorTypes.MEDIA_ERROR,
          parent: Qe.type,
          details: ErrorDetails.BUFFER_APPEND_ERROR,
          sourceBufferName: Ye,
          frag: Qe,
          part: Je,
          chunkMeta: nt,
          error: Xr,
          err: Xr,
          fatal: !1
        };
        if (Xr.code === DOMException.QUOTA_EXCEEDED_ERR)
          Jr.details = ErrorDetails.BUFFER_FULL_ERROR;
        else {
          const ei = ++this.appendErrors[Ye];
          Jr.details = ErrorDetails.BUFFER_APPEND_ERROR, this.warn(`Failed ${ei}/${ae.config.appendErrorMaxRetry} times to append segment in "${Ye}" sourceBuffer`), ei >= ae.config.appendErrorMaxRetry && (Jr.fatal = !0);
        }
        ae.trigger(Events.ERROR, Jr);
      }
    };
    ve.append(Kr, Ye, !!this.pendingTracks[Ye]);
  }
  onBufferFlushing(Z, ee) {
    const {
      operationQueue: ae
    } = this, ve = (ye) => ({
      execute: this.removeExecutor.bind(this, ye, ee.startOffset, ee.endOffset),
      onStart: () => {
      },
      onComplete: () => {
        this.hls.trigger(Events.BUFFER_FLUSHED, {
          type: ye
        });
      },
      onError: (be) => {
        this.warn(`Failed to remove from ${ye} SourceBuffer`, be);
      }
    });
    ee.type ? ae.append(ve(ee.type), ee.type) : this.getSourceBufferTypes().forEach((ye) => {
      ae.append(ve(ye), ye);
    });
  }
  onFragParsed(Z, ee) {
    const {
      frag: ae,
      part: ve
    } = ee, ye = [], be = ve ? ve.elementaryStreams : ae.elementaryStreams;
    be[ElementaryStreamTypes.AUDIOVIDEO] ? ye.push("audiovideo") : (be[ElementaryStreamTypes.AUDIO] && ye.push("audio"), be[ElementaryStreamTypes.VIDEO] && ye.push("video"));
    const Ye = () => {
      const Qe = self.performance.now();
      ae.stats.buffering.end = Qe, ve && (ve.stats.buffering.end = Qe);
      const Je = ve ? ve.stats : ae.stats;
      this.hls.trigger(Events.FRAG_BUFFERED, {
        frag: ae,
        part: ve,
        stats: Je,
        id: ae.type
      });
    };
    ye.length === 0 && this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${ae.type} level: ${ae.level} sn: ${ae.sn}`), this.blockBuffers(Ye, ye);
  }
  onFragChanged(Z, ee) {
    this.trimBuffers();
  }
  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(Z, ee) {
    this.getSourceBufferTypes().reduce((ve, ye) => {
      const be = this.sourceBuffer[ye];
      return be && (!ee.type || ee.type === ye) && (be.ending = !0, be.ended || (be.ended = !0, this.log(`${ye} sourceBuffer now EOS`))), ve && !!(!be || be.ended);
    }, !0) && (this.log("Queueing mediaSource.endOfStream()"), this.blockBuffers(() => {
      this.getSourceBufferTypes().forEach((ye) => {
        const be = this.sourceBuffer[ye];
        be && (be.ending = !1);
      });
      const {
        mediaSource: ve
      } = this;
      if (!ve || ve.readyState !== "open") {
        ve && this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${ve.readyState}`);
        return;
      }
      this.log("Calling mediaSource.endOfStream()"), ve.endOfStream();
    }));
  }
  onLevelUpdated(Z, {
    details: ee
  }) {
    ee.fragments.length && (this.details = ee, this.getSourceBufferTypes().length ? this.blockBuffers(this.updateMediaElementDuration.bind(this)) : this.updateMediaElementDuration());
  }
  trimBuffers() {
    const {
      hls: Z,
      details: ee,
      media: ae
    } = this;
    if (!ae || ee === null || !this.getSourceBufferTypes().length)
      return;
    const ye = Z.config, be = ae.currentTime, Ye = ee.levelTargetDuration, Qe = ee.live && ye.liveBackBufferLength !== null ? ye.liveBackBufferLength : ye.backBufferLength;
    if (isFiniteNumber(Qe) && Qe > 0) {
      const Je = Math.max(Qe, Ye), nt = Math.floor(be / Ye) * Ye - Je;
      this.flushBackBuffer(be, Ye, nt);
    }
    if (isFiniteNumber(ye.frontBufferFlushThreshold) && ye.frontBufferFlushThreshold > 0) {
      const Je = Math.max(ye.maxBufferLength, ye.frontBufferFlushThreshold), nt = Math.max(Je, Ye), st = Math.floor(be / Ye) * Ye + nt;
      this.flushFrontBuffer(be, Ye, st);
    }
  }
  flushBackBuffer(Z, ee, ae) {
    const {
      details: ve,
      sourceBuffer: ye
    } = this;
    this.getSourceBufferTypes().forEach((Ye) => {
      const Qe = ye[Ye];
      if (Qe) {
        const Je = BufferHelper.getBuffered(Qe);
        if (Je.length > 0 && ae > Je.start(0)) {
          if (this.hls.trigger(Events.BACK_BUFFER_REACHED, {
            bufferEnd: ae
          }), ve != null && ve.live)
            this.hls.trigger(Events.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: ae
            });
          else if (Qe.ended && Je.end(Je.length - 1) - Z < ee * 2) {
            this.log(`Cannot flush ${Ye} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(Events.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: ae,
            type: Ye
          });
        }
      }
    });
  }
  flushFrontBuffer(Z, ee, ae) {
    const {
      sourceBuffer: ve
    } = this;
    this.getSourceBufferTypes().forEach((be) => {
      const Ye = ve[be];
      if (Ye) {
        const Qe = BufferHelper.getBuffered(Ye), Je = Qe.length;
        if (Je < 2)
          return;
        const nt = Qe.start(Je - 1), st = Qe.end(Je - 1);
        if (ae > nt || Z >= nt && Z <= st)
          return;
        if (Ye.ended && Z - st < 2 * ee) {
          this.log(`Cannot flush ${be} front buffer while SourceBuffer is in ended state`);
          return;
        }
        this.hls.trigger(Events.BUFFER_FLUSHING, {
          startOffset: nt,
          endOffset: 1 / 0,
          type: be
        });
      }
    });
  }
  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  updateMediaElementDuration() {
    if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== "open")
      return;
    const {
      details: Z,
      hls: ee,
      media: ae,
      mediaSource: ve
    } = this, ye = Z.fragments[0].start + Z.totalduration, be = ae.duration, Ye = isFiniteNumber(ve.duration) ? ve.duration : 0;
    Z.live && ee.config.liveDurationInfinity ? (ve.duration = 1 / 0, this.updateSeekableRange(Z)) : (ye > Ye && ye > be || !isFiniteNumber(be)) && (this.log(`Updating Media Source duration to ${ye.toFixed(3)}`), ve.duration = ye);
  }
  updateSeekableRange(Z) {
    const ee = this.mediaSource, ae = Z.fragments;
    if (ae.length && Z.live && ee != null && ee.setLiveSeekableRange) {
      const ye = Math.max(0, ae[0].start), be = Math.max(ye, ye + Z.totalduration);
      this.log(`Media Source duration is set to ${ee.duration}. Setting seekable range to ${ye}-${be}.`), ee.setLiveSeekableRange(ye, be);
    }
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsExpected: Z,
      operationQueue: ee,
      pendingTracks: ae
    } = this, ve = Object.keys(ae).length;
    if (ve && (!Z || ve === 2 || "audiovideo" in ae)) {
      this.createSourceBuffers(ae), this.pendingTracks = {};
      const ye = this.getSourceBufferTypes();
      if (ye.length)
        this.hls.trigger(Events.BUFFER_CREATED, {
          tracks: this.tracks
        }), ye.forEach((be) => {
          ee.executeNext(be);
        });
      else {
        const be = new Error("could not create source buffer for media codec(s)");
        this.hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
          fatal: !0,
          error: be,
          reason: be.message
        });
      }
    }
  }
  createSourceBuffers(Z) {
    const {
      sourceBuffer: ee,
      mediaSource: ae
    } = this;
    if (!ae)
      throw Error("createSourceBuffers called when mediaSource was null");
    for (const ve in Z)
      if (!ee[ve]) {
        const ye = Z[ve];
        if (!ye)
          throw Error(`source buffer exists for track ${ve}, however track does not`);
        let be = ye.levelCodec || ye.codec;
        be && ve.slice(0, 5) === "audio" && (be = getCodecCompatibleName(be, this.hls.config.preferManagedMediaSource));
        const Ye = `${ye.container};codecs=${be}`;
        this.log(`creating sourceBuffer(${Ye})`);
        try {
          const Qe = ee[ve] = ae.addSourceBuffer(Ye), Je = ve;
          this.addBufferListener(Je, "updatestart", this._onSBUpdateStart), this.addBufferListener(Je, "updateend", this._onSBUpdateEnd), this.addBufferListener(Je, "error", this._onSBUpdateError), this.addBufferListener(Je, "bufferedchange", (nt, st) => {
            const ot = st.removedRanges;
            ot != null && ot.length && this.hls.trigger(Events.BUFFER_FLUSHED, {
              type: ve
            });
          }), this.tracks[ve] = {
            buffer: Qe,
            codec: be,
            container: ye.container,
            levelCodec: ye.levelCodec,
            metadata: ye.metadata,
            id: ye.id
          };
        } catch (Qe) {
          this.error(`error while trying to add sourceBuffer: ${Qe.message}`), this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_ADD_CODEC_ERROR,
            fatal: !1,
            error: Qe,
            sourceBufferName: ve,
            mimeType: Ye
          });
        }
      }
  }
  get mediaSrc() {
    var Z;
    const ee = ((Z = this.media) == null ? void 0 : Z.firstChild) || this.media;
    return ee == null ? void 0 : ee.src;
  }
  _onSBUpdateStart(Z) {
    const {
      operationQueue: ee
    } = this;
    ee.current(Z).onStart();
  }
  _onSBUpdateEnd(Z) {
    var ee;
    if (((ee = this.mediaSource) == null ? void 0 : ee.readyState) === "closed") {
      this.resetBuffer(Z);
      return;
    }
    const {
      operationQueue: ae
    } = this;
    ae.current(Z).onComplete(), ae.shiftAndExecuteNext(Z);
  }
  _onSBUpdateError(Z, ee) {
    var ae;
    const ve = new Error(`${Z} SourceBuffer error. MediaSource readyState: ${(ae = this.mediaSource) == null ? void 0 : ae.readyState}`);
    this.error(`${ve}`, ee), this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.BUFFER_APPENDING_ERROR,
      sourceBufferName: Z,
      error: ve,
      fatal: !1
    });
    const ye = this.operationQueue.current(Z);
    ye && ye.onError(ve);
  }
  // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
  removeExecutor(Z, ee, ae) {
    const {
      media: ve,
      mediaSource: ye,
      operationQueue: be,
      sourceBuffer: Ye
    } = this, Qe = Ye[Z];
    if (!ve || !ye || !Qe) {
      this.warn(`Attempting to remove from the ${Z} SourceBuffer, but it does not exist`), be.shiftAndExecuteNext(Z);
      return;
    }
    const Je = isFiniteNumber(ve.duration) ? ve.duration : 1 / 0, nt = isFiniteNumber(ye.duration) ? ye.duration : 1 / 0, st = Math.max(0, ee), ot = Math.min(ae, Je, nt);
    ot > st && (!Qe.ending || Qe.ended) ? (Qe.ended = !1, this.log(`Removing [${st},${ot}] from the ${Z} SourceBuffer`), Qe.remove(st, ot)) : be.shiftAndExecuteNext(Z);
  }
  // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
  appendExecutor(Z, ee) {
    const ae = this.sourceBuffer[ee];
    if (!ae) {
      if (!this.pendingTracks[ee])
        throw new Error(`Attempting to append to the ${ee} SourceBuffer, but it does not exist`);
      return;
    }
    ae.ended = !1, ae.appendBuffer(Z);
  }
  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(Z, ee = this.getSourceBufferTypes()) {
    if (!ee.length) {
      this.log("Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(Z);
      return;
    }
    const {
      operationQueue: ae
    } = this, ve = ee.map((ye) => ae.appendBlocker(ye));
    Promise.all(ve).then(() => {
      Z(), ee.forEach((ye) => {
        const be = this.sourceBuffer[ye];
        be != null && be.updating || ae.shiftAndExecuteNext(ye);
      });
    });
  }
  getSourceBufferTypes() {
    return Object.keys(this.sourceBuffer);
  }
  addBufferListener(Z, ee, ae) {
    const ve = this.sourceBuffer[Z];
    if (!ve)
      return;
    const ye = ae.bind(this, Z);
    this.listeners[Z].push({
      event: ee,
      listener: ye
    }), ve.addEventListener(ee, ye);
  }
  removeBufferListeners(Z) {
    const ee = this.sourceBuffer[Z];
    ee && this.listeners[Z].forEach((ae) => {
      ee.removeEventListener(ae.event, ae.listener);
    });
  }
}
function removeSourceChildren(ie) {
  const Z = ie.querySelectorAll("source");
  [].slice.call(Z).forEach((ee) => {
    ie.removeChild(ee);
  });
}
function addSource(ie, Z) {
  const ee = self.document.createElement("source");
  ee.type = "video/mp4", ee.src = Z, ie.appendChild(ee);
}
const specialCea608CharsCodes = {
  42: 225,
  // lowercase a, acute accent
  92: 233,
  // lowercase e, acute accent
  94: 237,
  // lowercase i, acute accent
  95: 243,
  // lowercase o, acute accent
  96: 250,
  // lowercase u, acute accent
  123: 231,
  // lowercase c with cedilla
  124: 247,
  // division symbol
  125: 209,
  // uppercase N tilde
  126: 241,
  // lowercase n tilde
  127: 9608,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  128: 174,
  // Registered symbol (R)
  129: 176,
  // degree sign
  130: 189,
  // 1/2 symbol
  131: 191,
  // Inverted (open) question mark
  132: 8482,
  // Trademark symbol (TM)
  133: 162,
  // Cents symbol
  134: 163,
  // Pounds sterling
  135: 9834,
  // Music 8'th note
  136: 224,
  // lowercase a, grave accent
  137: 32,
  // transparent space (regular)
  138: 232,
  // lowercase e, grave accent
  139: 226,
  // lowercase a, circumflex accent
  140: 234,
  // lowercase e, circumflex accent
  141: 238,
  // lowercase i, circumflex accent
  142: 244,
  // lowercase o, circumflex accent
  143: 251,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  144: 193,
  // capital letter A with acute
  145: 201,
  // capital letter E with acute
  146: 211,
  // capital letter O with acute
  147: 218,
  // capital letter U with acute
  148: 220,
  // capital letter U with diaresis
  149: 252,
  // lowercase letter U with diaeresis
  150: 8216,
  // opening single quote
  151: 161,
  // inverted exclamation mark
  152: 42,
  // asterisk
  153: 8217,
  // closing single quote
  154: 9473,
  // box drawings heavy horizontal
  155: 169,
  // copyright sign
  156: 8480,
  // Service mark
  157: 8226,
  // (round) bullet
  158: 8220,
  // Left double quotation mark
  159: 8221,
  // Right double quotation mark
  160: 192,
  // uppercase A, grave accent
  161: 194,
  // uppercase A, circumflex
  162: 199,
  // uppercase C with cedilla
  163: 200,
  // uppercase E, grave accent
  164: 202,
  // uppercase E, circumflex
  165: 203,
  // capital letter E with diaresis
  166: 235,
  // lowercase letter e with diaresis
  167: 206,
  // uppercase I, circumflex
  168: 207,
  // uppercase I, with diaresis
  169: 239,
  // lowercase i, with diaresis
  170: 212,
  // uppercase O, circumflex
  171: 217,
  // uppercase U, grave accent
  172: 249,
  // lowercase u, grave accent
  173: 219,
  // uppercase U, circumflex
  174: 171,
  // left-pointing double angle quotation mark
  175: 187,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  176: 195,
  // Uppercase A, tilde
  177: 227,
  // Lowercase a, tilde
  178: 205,
  // Uppercase I, acute accent
  179: 204,
  // Uppercase I, grave accent
  180: 236,
  // Lowercase i, grave accent
  181: 210,
  // Uppercase O, grave accent
  182: 242,
  // Lowercase o, grave accent
  183: 213,
  // Uppercase O, tilde
  184: 245,
  // Lowercase o, tilde
  185: 123,
  // Open curly brace
  186: 125,
  // Closing curly brace
  187: 92,
  // Backslash
  188: 94,
  // Caret
  189: 95,
  // Underscore
  190: 124,
  // Pipe (vertical line)
  191: 8764,
  // Tilde operator
  192: 196,
  // Uppercase A, umlaut
  193: 228,
  // Lowercase A, umlaut
  194: 214,
  // Uppercase O, umlaut
  195: 246,
  // Lowercase o, umlaut
  196: 223,
  // Esszett (sharp S)
  197: 165,
  // Yen symbol
  198: 164,
  // Generic currency sign
  199: 9475,
  // Box drawings heavy vertical
  200: 197,
  // Uppercase A, ring
  201: 229,
  // Lowercase A, ring
  202: 216,
  // Uppercase O, stroke
  203: 248,
  // Lowercase o, strok
  204: 9487,
  // Box drawings heavy down and right
  205: 9491,
  // Box drawings heavy down and left
  206: 9495,
  // Box drawings heavy up and right
  207: 9499
  // Box drawings heavy up and left
}, getCharForByte = function(Z) {
  let ee = Z;
  return specialCea608CharsCodes.hasOwnProperty(Z) && (ee = specialCea608CharsCodes[Z]), String.fromCharCode(ee);
}, NR_ROWS = 15, NR_COLS = 100, rowsLowCh1 = {
  17: 1,
  18: 3,
  21: 5,
  22: 7,
  23: 9,
  16: 11,
  19: 12,
  20: 14
}, rowsHighCh1 = {
  17: 2,
  18: 4,
  21: 6,
  22: 8,
  23: 10,
  19: 13,
  20: 15
}, rowsLowCh2 = {
  25: 1,
  26: 3,
  29: 5,
  30: 7,
  31: 9,
  24: 11,
  27: 12,
  28: 14
}, rowsHighCh2 = {
  25: 2,
  26: 4,
  29: 6,
  30: 8,
  31: 10,
  27: 13,
  28: 15
}, backgroundColors = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
class CaptionsLogger {
  constructor() {
    this.time = null, this.verboseLevel = 0;
  }
  log(Z, ee) {
    if (this.verboseLevel >= Z) {
      const ae = typeof ee == "function" ? ee() : ee;
      logger.log(`${this.time} [${Z}] ${ae}`);
    }
  }
}
const numArrayToHexArray = function(Z) {
  const ee = [];
  for (let ae = 0; ae < Z.length; ae++)
    ee.push(Z[ae].toString(16));
  return ee;
};
class PenState {
  constructor() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  reset() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  setStyles(Z) {
    const ee = ["foreground", "underline", "italics", "background", "flash"];
    for (let ae = 0; ae < ee.length; ae++) {
      const ve = ee[ae];
      Z.hasOwnProperty(ve) && (this[ve] = Z[ve]);
    }
  }
  isDefault() {
    return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
  }
  equals(Z) {
    return this.foreground === Z.foreground && this.underline === Z.underline && this.italics === Z.italics && this.background === Z.background && this.flash === Z.flash;
  }
  copy(Z) {
    this.foreground = Z.foreground, this.underline = Z.underline, this.italics = Z.italics, this.background = Z.background, this.flash = Z.flash;
  }
  toString() {
    return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
  }
}
class StyledUnicodeChar {
  constructor() {
    this.uchar = " ", this.penState = new PenState();
  }
  reset() {
    this.uchar = " ", this.penState.reset();
  }
  setChar(Z, ee) {
    this.uchar = Z, this.penState.copy(ee);
  }
  setPenState(Z) {
    this.penState.copy(Z);
  }
  equals(Z) {
    return this.uchar === Z.uchar && this.penState.equals(Z.penState);
  }
  copy(Z) {
    this.uchar = Z.uchar, this.penState.copy(Z.penState);
  }
  isEmpty() {
    return this.uchar === " " && this.penState.isDefault();
  }
}
class Row {
  constructor(Z) {
    this.chars = [], this.pos = 0, this.currPenState = new PenState(), this.cueStartTime = null, this.logger = void 0;
    for (let ee = 0; ee < NR_COLS; ee++)
      this.chars.push(new StyledUnicodeChar());
    this.logger = Z;
  }
  equals(Z) {
    for (let ee = 0; ee < NR_COLS; ee++)
      if (!this.chars[ee].equals(Z.chars[ee]))
        return !1;
    return !0;
  }
  copy(Z) {
    for (let ee = 0; ee < NR_COLS; ee++)
      this.chars[ee].copy(Z.chars[ee]);
  }
  isEmpty() {
    let Z = !0;
    for (let ee = 0; ee < NR_COLS; ee++)
      if (!this.chars[ee].isEmpty()) {
        Z = !1;
        break;
      }
    return Z;
  }
  /**
   *  Set the cursor to a valid column.
   */
  setCursor(Z) {
    this.pos !== Z && (this.pos = Z), this.pos < 0 ? (this.logger.log(3, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > NR_COLS && (this.logger.log(3, "Too large cursor position " + this.pos), this.pos = NR_COLS);
  }
  /**
   * Move the cursor relative to current position.
   */
  moveCursor(Z) {
    const ee = this.pos + Z;
    if (Z > 1)
      for (let ae = this.pos + 1; ae < ee + 1; ae++)
        this.chars[ae].setPenState(this.currPenState);
    this.setCursor(ee);
  }
  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
  }
  insertChar(Z) {
    Z >= 144 && this.backSpace();
    const ee = getCharForByte(Z);
    if (this.pos >= NR_COLS) {
      this.logger.log(0, () => "Cannot insert " + Z.toString(16) + " (" + ee + ") at position " + this.pos + ". Skipping it!");
      return;
    }
    this.chars[this.pos].setChar(ee, this.currPenState), this.moveCursor(1);
  }
  clearFromPos(Z) {
    let ee;
    for (ee = Z; ee < NR_COLS; ee++)
      this.chars[ee].reset();
  }
  clear() {
    this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const Z = [];
    let ee = !0;
    for (let ae = 0; ae < NR_COLS; ae++) {
      const ve = this.chars[ae].uchar;
      ve !== " " && (ee = !1), Z.push(ve);
    }
    return ee ? "" : Z.join("");
  }
  setPenStyles(Z) {
    this.currPenState.setStyles(Z), this.chars[this.pos].setPenState(this.currPenState);
  }
}
class CaptionScreen {
  constructor(Z) {
    this.rows = [], this.currRow = NR_ROWS - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.logger = void 0;
    for (let ee = 0; ee < NR_ROWS; ee++)
      this.rows.push(new Row(Z));
    this.logger = Z;
  }
  reset() {
    for (let Z = 0; Z < NR_ROWS; Z++)
      this.rows[Z].clear();
    this.currRow = NR_ROWS - 1;
  }
  equals(Z) {
    let ee = !0;
    for (let ae = 0; ae < NR_ROWS; ae++)
      if (!this.rows[ae].equals(Z.rows[ae])) {
        ee = !1;
        break;
      }
    return ee;
  }
  copy(Z) {
    for (let ee = 0; ee < NR_ROWS; ee++)
      this.rows[ee].copy(Z.rows[ee]);
  }
  isEmpty() {
    let Z = !0;
    for (let ee = 0; ee < NR_ROWS; ee++)
      if (!this.rows[ee].isEmpty()) {
        Z = !1;
        break;
      }
    return Z;
  }
  backSpace() {
    this.rows[this.currRow].backSpace();
  }
  clearToEndOfRow() {
    this.rows[this.currRow].clearToEndOfRow();
  }
  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(Z) {
    this.rows[this.currRow].insertChar(Z);
  }
  setPen(Z) {
    this.rows[this.currRow].setPenStyles(Z);
  }
  moveCursor(Z) {
    this.rows[this.currRow].moveCursor(Z);
  }
  setCursor(Z) {
    this.logger.log(2, "setCursor: " + Z), this.rows[this.currRow].setCursor(Z);
  }
  setPAC(Z) {
    this.logger.log(2, () => "pacData = " + JSON.stringify(Z));
    let ee = Z.row - 1;
    if (this.nrRollUpRows && ee < this.nrRollUpRows - 1 && (ee = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== ee) {
      for (let Ye = 0; Ye < NR_ROWS; Ye++)
        this.rows[Ye].clear();
      const ye = this.currRow + 1 - this.nrRollUpRows, be = this.lastOutputScreen;
      if (be) {
        const Ye = be.rows[ye].cueStartTime, Qe = this.logger.time;
        if (Ye !== null && Qe !== null && Ye < Qe)
          for (let Je = 0; Je < this.nrRollUpRows; Je++)
            this.rows[ee - this.nrRollUpRows + Je + 1].copy(be.rows[ye + Je]);
      }
    }
    this.currRow = ee;
    const ae = this.rows[this.currRow];
    if (Z.indent !== null) {
      const ye = Z.indent, be = Math.max(ye - 1, 0);
      ae.setCursor(Z.indent), Z.color = ae.chars[be].penState.foreground;
    }
    const ve = {
      foreground: Z.color,
      underline: Z.underline,
      italics: Z.italics,
      background: "black",
      flash: !1
    };
    this.setPen(ve);
  }
  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(Z) {
    this.logger.log(2, () => "bkgData = " + JSON.stringify(Z)), this.backSpace(), this.setPen(Z), this.insertChar(32);
  }
  setRollUpRows(Z) {
    this.nrRollUpRows = Z;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, "roll_up but nrRollUpRows not set yet");
      return;
    }
    this.logger.log(1, () => this.getDisplayText());
    const Z = this.currRow + 1 - this.nrRollUpRows, ee = this.rows.splice(Z, 1)[0];
    ee.clear(), this.rows.splice(this.currRow, 0, ee), this.logger.log(2, "Rolling up");
  }
  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(Z) {
    Z = Z || !1;
    const ee = [];
    let ae = "", ve = -1;
    for (let ye = 0; ye < NR_ROWS; ye++) {
      const be = this.rows[ye].getTextString();
      be && (ve = ye + 1, Z ? ee.push("Row " + ve + ": '" + be + "'") : ee.push(be.trim()));
    }
    return ee.length > 0 && (Z ? ae = "[" + ee.join(" | ") + "]" : ae = ee.join(`
`)), ae;
  }
  getTextAndFormat() {
    return this.rows;
  }
}
class Cea608Channel {
  constructor(Z, ee, ae) {
    this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = Z, this.outputFilter = ee, this.mode = null, this.verbose = 0, this.displayedMemory = new CaptionScreen(ae), this.nonDisplayedMemory = new CaptionScreen(ae), this.lastOutputScreen = new CaptionScreen(ae), this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = ae;
  }
  reset() {
    this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(Z) {
    this.outputFilter = Z;
  }
  setPAC(Z) {
    this.writeScreen.setPAC(Z);
  }
  setBkgData(Z) {
    this.writeScreen.setBkgData(Z);
  }
  setMode(Z) {
    Z !== this.mode && (this.mode = Z, this.logger.log(2, () => "MODE=" + Z), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = Z);
  }
  insertChars(Z) {
    for (let ae = 0; ae < Z.length; ae++)
      this.writeScreen.insertChar(Z[ae]);
    const ee = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
    this.logger.log(2, () => ee + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
  }
  ccRCL() {
    this.logger.log(2, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
  }
  ccBS() {
    this.logger.log(2, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
  }
  ccAOF() {
  }
  ccAON() {
  }
  ccDER() {
    this.logger.log(2, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
  }
  ccRU(Z) {
    this.logger.log(2, "RU(" + Z + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(Z);
  }
  ccFON() {
    this.logger.log(2, "FON - Flash On"), this.writeScreen.setPen({
      flash: !0
    });
  }
  ccRDC() {
    this.logger.log(2, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
  }
  ccTR() {
    this.logger.log(2, "TR"), this.setMode("MODE_TEXT");
  }
  ccRTD() {
    this.logger.log(2, "RTD"), this.setMode("MODE_TEXT");
  }
  ccEDM() {
    this.logger.log(2, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
  }
  ccCR() {
    this.logger.log(2, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
  }
  ccENM() {
    this.logger.log(2, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    if (this.logger.log(2, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
      const Z = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = Z, this.writeScreen = this.nonDisplayedMemory, this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(!0);
  }
  ccTO(Z) {
    this.logger.log(2, "TO(" + Z + ") - Tab Offset"), this.writeScreen.moveCursor(Z);
  }
  ccMIDROW(Z) {
    const ee = {
      flash: !1
    };
    if (ee.underline = Z % 2 === 1, ee.italics = Z >= 46, ee.italics)
      ee.foreground = "white";
    else {
      const ae = Math.floor(Z / 2) - 16, ve = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
      ee.foreground = ve[ae];
    }
    this.logger.log(2, "MIDROW: " + JSON.stringify(ee)), this.writeScreen.setPen(ee);
  }
  outputDataUpdate(Z = !1) {
    const ee = this.logger.time;
    ee !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = ee : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, ee, this.lastOutputScreen), Z && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : ee), this.lastOutputScreen.copy(this.displayedMemory));
  }
  cueSplitAtTime(Z) {
    this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, Z, this.displayedMemory), this.cueStartTime = Z));
  }
}
class Cea608Parser {
  constructor(Z, ee, ae) {
    this.channels = void 0, this.currentChannel = 0, this.cmdHistory = createCmdHistory(), this.logger = void 0;
    const ve = this.logger = new CaptionsLogger();
    this.channels = [null, new Cea608Channel(Z, ee, ve), new Cea608Channel(Z + 1, ae, ve)];
  }
  getHandler(Z) {
    return this.channels[Z].getHandler();
  }
  setHandler(Z, ee) {
    this.channels[Z].setHandler(ee);
  }
  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(Z, ee) {
    let ae, ve, ye, be = !1;
    this.logger.time = Z;
    for (let Ye = 0; Ye < ee.length; Ye += 2)
      if (ve = ee[Ye] & 127, ye = ee[Ye + 1] & 127, !(ve === 0 && ye === 0)) {
        if (this.logger.log(3, "[" + numArrayToHexArray([ee[Ye], ee[Ye + 1]]) + "] -> (" + numArrayToHexArray([ve, ye]) + ")"), ae = this.parseCmd(ve, ye), ae || (ae = this.parseMidrow(ve, ye)), ae || (ae = this.parsePAC(ve, ye)), ae || (ae = this.parseBackgroundAttributes(ve, ye)), !ae && (be = this.parseChars(ve, ye), be)) {
          const Qe = this.currentChannel;
          Qe && Qe > 0 ? this.channels[Qe].insertChars(be) : this.logger.log(2, "No channel found yet. TEXT-MODE?");
        }
        !ae && !be && this.logger.log(2, "Couldn't parse cleaned data " + numArrayToHexArray([ve, ye]) + " orig: " + numArrayToHexArray([ee[Ye], ee[Ye + 1]]));
      }
  }
  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(Z, ee) {
    const {
      cmdHistory: ae
    } = this, ve = (Z === 20 || Z === 28 || Z === 21 || Z === 29) && ee >= 32 && ee <= 47, ye = (Z === 23 || Z === 31) && ee >= 33 && ee <= 35;
    if (!(ve || ye))
      return !1;
    if (hasCmdRepeated(Z, ee, ae))
      return setLastCmd(null, null, ae), this.logger.log(3, "Repeated command (" + numArrayToHexArray([Z, ee]) + ") is dropped"), !0;
    const be = Z === 20 || Z === 21 || Z === 23 ? 1 : 2, Ye = this.channels[be];
    return Z === 20 || Z === 21 || Z === 28 || Z === 29 ? ee === 32 ? Ye.ccRCL() : ee === 33 ? Ye.ccBS() : ee === 34 ? Ye.ccAOF() : ee === 35 ? Ye.ccAON() : ee === 36 ? Ye.ccDER() : ee === 37 ? Ye.ccRU(2) : ee === 38 ? Ye.ccRU(3) : ee === 39 ? Ye.ccRU(4) : ee === 40 ? Ye.ccFON() : ee === 41 ? Ye.ccRDC() : ee === 42 ? Ye.ccTR() : ee === 43 ? Ye.ccRTD() : ee === 44 ? Ye.ccEDM() : ee === 45 ? Ye.ccCR() : ee === 46 ? Ye.ccENM() : ee === 47 && Ye.ccEOC() : Ye.ccTO(ee - 32), setLastCmd(Z, ee, ae), this.currentChannel = be, !0;
  }
  /**
   * Parse midrow styling command
   */
  parseMidrow(Z, ee) {
    let ae = 0;
    if ((Z === 17 || Z === 25) && ee >= 32 && ee <= 47) {
      if (Z === 17 ? ae = 1 : ae = 2, ae !== this.currentChannel)
        return this.logger.log(0, "Mismatch channel in midrow parsing"), !1;
      const ve = this.channels[ae];
      return ve ? (ve.ccMIDROW(ee), this.logger.log(3, "MIDROW (" + numArrayToHexArray([Z, ee]) + ")"), !0) : !1;
    }
    return !1;
  }
  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(Z, ee) {
    let ae;
    const ve = this.cmdHistory, ye = (Z >= 17 && Z <= 23 || Z >= 25 && Z <= 31) && ee >= 64 && ee <= 127, be = (Z === 16 || Z === 24) && ee >= 64 && ee <= 95;
    if (!(ye || be))
      return !1;
    if (hasCmdRepeated(Z, ee, ve))
      return setLastCmd(null, null, ve), !0;
    const Ye = Z <= 23 ? 1 : 2;
    ee >= 64 && ee <= 95 ? ae = Ye === 1 ? rowsLowCh1[Z] : rowsLowCh2[Z] : ae = Ye === 1 ? rowsHighCh1[Z] : rowsHighCh2[Z];
    const Qe = this.channels[Ye];
    return Qe ? (Qe.setPAC(this.interpretPAC(ae, ee)), setLastCmd(Z, ee, ve), this.currentChannel = Ye, !0) : !1;
  }
  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(Z, ee) {
    let ae;
    const ve = {
      color: null,
      italics: !1,
      indent: null,
      underline: !1,
      row: Z
    };
    return ee > 95 ? ae = ee - 96 : ae = ee - 64, ve.underline = (ae & 1) === 1, ae <= 13 ? ve.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(ae / 2)] : ae <= 15 ? (ve.italics = !0, ve.color = "white") : ve.indent = Math.floor((ae - 16) / 2) * 4, ve;
  }
  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(Z, ee) {
    let ae, ve = null, ye = null;
    if (Z >= 25 ? (ae = 2, ye = Z - 8) : (ae = 1, ye = Z), ye >= 17 && ye <= 19) {
      let be;
      ye === 17 ? be = ee + 80 : ye === 18 ? be = ee + 112 : be = ee + 144, this.logger.log(2, "Special char '" + getCharForByte(be) + "' in channel " + ae), ve = [be];
    } else
      Z >= 32 && Z <= 127 && (ve = ee === 0 ? [Z] : [Z, ee]);
    if (ve) {
      const be = numArrayToHexArray(ve);
      this.logger.log(3, "Char codes =  " + be.join(",")), setLastCmd(Z, ee, this.cmdHistory);
    }
    return ve;
  }
  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(Z, ee) {
    const ae = (Z === 16 || Z === 24) && ee >= 32 && ee <= 47, ve = (Z === 23 || Z === 31) && ee >= 45 && ee <= 47;
    if (!(ae || ve))
      return !1;
    let ye;
    const be = {};
    Z === 16 || Z === 24 ? (ye = Math.floor((ee - 32) / 2), be.background = backgroundColors[ye], ee % 2 === 1 && (be.background = be.background + "_semi")) : ee === 45 ? be.background = "transparent" : (be.foreground = "black", ee === 47 && (be.underline = !0));
    const Ye = Z <= 23 ? 1 : 2;
    return this.channels[Ye].setBkgData(be), setLastCmd(Z, ee, this.cmdHistory), !0;
  }
  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let Z = 0; Z < Object.keys(this.channels).length; Z++) {
      const ee = this.channels[Z];
      ee && ee.reset();
    }
    this.cmdHistory = createCmdHistory();
  }
  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(Z) {
    for (let ee = 0; ee < this.channels.length; ee++) {
      const ae = this.channels[ee];
      ae && ae.cueSplitAtTime(Z);
    }
  }
}
function setLastCmd(ie, Z, ee) {
  ee.a = ie, ee.b = Z;
}
function hasCmdRepeated(ie, Z, ee) {
  return ee.a === ie && ee.b === Z;
}
function createCmdHistory() {
  return {
    a: null,
    b: null
  };
}
class OutputFilter {
  constructor(Z, ee) {
    this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = Z, this.trackName = ee;
  }
  dispatchCue() {
    this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
  }
  newCue(Z, ee, ae) {
    (this.startTime === null || this.startTime > Z) && (this.startTime = Z), this.endTime = ee, this.screen = ae, this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [], this.startTime = null;
  }
}
var VTTCue = function() {
  if (optionalSelf != null && optionalSelf.VTTCue)
    return self.VTTCue;
  const ie = ["", "lr", "rl"], Z = ["start", "middle", "end", "left", "right"];
  function ee(Ye, Qe) {
    if (typeof Qe != "string" || !Array.isArray(Ye))
      return !1;
    const Je = Qe.toLowerCase();
    return ~Ye.indexOf(Je) ? Je : !1;
  }
  function ae(Ye) {
    return ee(ie, Ye);
  }
  function ve(Ye) {
    return ee(Z, Ye);
  }
  function ye(Ye, ...Qe) {
    let Je = 1;
    for (; Je < arguments.length; Je++) {
      const nt = arguments[Je];
      for (const st in nt)
        Ye[st] = nt[st];
    }
    return Ye;
  }
  function be(Ye, Qe, Je) {
    const nt = this, st = {
      enumerable: !0
    };
    nt.hasBeenReset = !1;
    let ot = "", lt = !1, ft = Ye, gt = Qe, ct = Je, _r = null, Kr = "", Xr = !0, Jr = "auto", ei = "start", si = 50, ri = "middle", ai = 50, yi = "middle";
    Object.defineProperty(nt, "id", ye({}, st, {
      get: function() {
        return ot;
      },
      set: function(pi) {
        ot = "" + pi;
      }
    })), Object.defineProperty(nt, "pauseOnExit", ye({}, st, {
      get: function() {
        return lt;
      },
      set: function(pi) {
        lt = !!pi;
      }
    })), Object.defineProperty(nt, "startTime", ye({}, st, {
      get: function() {
        return ft;
      },
      set: function(pi) {
        if (typeof pi != "number")
          throw new TypeError("Start time must be set to a number.");
        ft = pi, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "endTime", ye({}, st, {
      get: function() {
        return gt;
      },
      set: function(pi) {
        if (typeof pi != "number")
          throw new TypeError("End time must be set to a number.");
        gt = pi, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "text", ye({}, st, {
      get: function() {
        return ct;
      },
      set: function(pi) {
        ct = "" + pi, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "region", ye({}, st, {
      get: function() {
        return _r;
      },
      set: function(pi) {
        _r = pi, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "vertical", ye({}, st, {
      get: function() {
        return Kr;
      },
      set: function(pi) {
        const di = ae(pi);
        if (di === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        Kr = di, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "snapToLines", ye({}, st, {
      get: function() {
        return Xr;
      },
      set: function(pi) {
        Xr = !!pi, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "line", ye({}, st, {
      get: function() {
        return Jr;
      },
      set: function(pi) {
        if (typeof pi != "number" && pi !== "auto")
          throw new SyntaxError("An invalid number or illegal string was specified.");
        Jr = pi, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "lineAlign", ye({}, st, {
      get: function() {
        return ei;
      },
      set: function(pi) {
        const di = ve(pi);
        if (!di)
          throw new SyntaxError("An invalid or illegal string was specified.");
        ei = di, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "position", ye({}, st, {
      get: function() {
        return si;
      },
      set: function(pi) {
        if (pi < 0 || pi > 100)
          throw new Error("Position must be between 0 and 100.");
        si = pi, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "positionAlign", ye({}, st, {
      get: function() {
        return ri;
      },
      set: function(pi) {
        const di = ve(pi);
        if (!di)
          throw new SyntaxError("An invalid or illegal string was specified.");
        ri = di, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "size", ye({}, st, {
      get: function() {
        return ai;
      },
      set: function(pi) {
        if (pi < 0 || pi > 100)
          throw new Error("Size must be between 0 and 100.");
        ai = pi, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(nt, "align", ye({}, st, {
      get: function() {
        return yi;
      },
      set: function(pi) {
        const di = ve(pi);
        if (!di)
          throw new SyntaxError("An invalid or illegal string was specified.");
        yi = di, this.hasBeenReset = !0;
      }
    })), nt.displayState = void 0;
  }
  return be.prototype.getCueAsHTML = function() {
    return self.WebVTT.convertCueToDOMTree(self, this.text);
  }, be;
}();
class StringDecoder {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decode(Z, ee) {
    if (!Z)
      return "";
    if (typeof Z != "string")
      throw new Error("Error - expected string data.");
    return decodeURIComponent(encodeURIComponent(Z));
  }
}
function parseTimeStamp(ie) {
  function Z(ae, ve, ye, be) {
    return (ae | 0) * 3600 + (ve | 0) * 60 + (ye | 0) + parseFloat(be || 0);
  }
  const ee = ie.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  return ee ? parseFloat(ee[2]) > 59 ? Z(ee[2], ee[3], 0, ee[4]) : Z(ee[1], ee[2], ee[3], ee[4]) : null;
}
class Settings {
  constructor() {
    this.values = /* @__PURE__ */ Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(Z, ee) {
    !this.get(Z) && ee !== "" && (this.values[Z] = ee);
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(Z, ee, ae) {
    return ae ? this.has(Z) ? this.values[Z] : ee[ae] : this.has(Z) ? this.values[Z] : ee;
  }
  // Check whether we have a value for a key.
  has(Z) {
    return Z in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(Z, ee, ae) {
    for (let ve = 0; ve < ae.length; ++ve)
      if (ee === ae[ve]) {
        this.set(Z, ee);
        break;
      }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(Z, ee) {
    /^-?\d+$/.test(ee) && this.set(Z, parseInt(ee, 10));
  }
  // Accept a setting if its a valid percentage.
  percent(Z, ee) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(ee)) {
      const ae = parseFloat(ee);
      if (ae >= 0 && ae <= 100)
        return this.set(Z, ae), !0;
    }
    return !1;
  }
}
function parseOptions(ie, Z, ee, ae) {
  const ve = ae ? ie.split(ae) : [ie];
  for (const ye in ve) {
    if (typeof ve[ye] != "string")
      continue;
    const be = ve[ye].split(ee);
    if (be.length !== 2)
      continue;
    const Ye = be[0], Qe = be[1];
    Z(Ye, Qe);
  }
}
const defaults = new VTTCue(0, 0, ""), center = defaults.align === "middle" ? "middle" : "center";
function parseCue$1(ie, Z, ee) {
  const ae = ie;
  function ve() {
    const Ye = parseTimeStamp(ie);
    if (Ye === null)
      throw new Error("Malformed timestamp: " + ae);
    return ie = ie.replace(/^[^\sa-zA-Z-]+/, ""), Ye;
  }
  function ye(Ye, Qe) {
    const Je = new Settings();
    parseOptions(Ye, function(ot, lt) {
      let ft;
      switch (ot) {
        case "region":
          for (let gt = ee.length - 1; gt >= 0; gt--)
            if (ee[gt].id === lt) {
              Je.set(ot, ee[gt].region);
              break;
            }
          break;
        case "vertical":
          Je.alt(ot, lt, ["rl", "lr"]);
          break;
        case "line":
          ft = lt.split(","), Je.integer(ot, ft[0]), Je.percent(ot, ft[0]) && Je.set("snapToLines", !1), Je.alt(ot, ft[0], ["auto"]), ft.length === 2 && Je.alt("lineAlign", ft[1], ["start", center, "end"]);
          break;
        case "position":
          ft = lt.split(","), Je.percent(ot, ft[0]), ft.length === 2 && Je.alt("positionAlign", ft[1], ["start", center, "end", "line-left", "line-right", "auto"]);
          break;
        case "size":
          Je.percent(ot, lt);
          break;
        case "align":
          Je.alt(ot, lt, ["start", center, "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), Qe.region = Je.get("region", null), Qe.vertical = Je.get("vertical", "");
    let nt = Je.get("line", "auto");
    nt === "auto" && defaults.line === -1 && (nt = -1), Qe.line = nt, Qe.lineAlign = Je.get("lineAlign", "start"), Qe.snapToLines = Je.get("snapToLines", !0), Qe.size = Je.get("size", 100), Qe.align = Je.get("align", center);
    let st = Je.get("position", "auto");
    st === "auto" && defaults.position === 50 && (st = Qe.align === "start" || Qe.align === "left" ? 0 : Qe.align === "end" || Qe.align === "right" ? 100 : 50), Qe.position = st;
  }
  function be() {
    ie = ie.replace(/^\s+/, "");
  }
  if (be(), Z.startTime = ve(), be(), ie.slice(0, 3) !== "-->")
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + ae);
  ie = ie.slice(3), be(), Z.endTime = ve(), be(), ye(ie, Z);
}
function fixLineBreaks(ie) {
  return ie.replace(/<br(?: \/)?>/gi, `
`);
}
class VTTParser {
  constructor() {
    this.state = "INITIAL", this.buffer = "", this.decoder = new StringDecoder(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
  }
  parse(Z) {
    const ee = this;
    Z && (ee.buffer += ee.decoder.decode(Z, {
      stream: !0
    }));
    function ae() {
      let ye = ee.buffer, be = 0;
      for (ye = fixLineBreaks(ye); be < ye.length && ye[be] !== "\r" && ye[be] !== `
`; )
        ++be;
      const Ye = ye.slice(0, be);
      return ye[be] === "\r" && ++be, ye[be] === `
` && ++be, ee.buffer = ye.slice(be), Ye;
    }
    function ve(ye) {
      parseOptions(ye, function(be, Ye) {
      }, /:/);
    }
    try {
      let ye = "";
      if (ee.state === "INITIAL") {
        if (!/\r\n|\n/.test(ee.buffer))
          return this;
        ye = ae();
        const Ye = ye.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(Ye != null && Ye[0]))
          throw new Error("Malformed WebVTT signature.");
        ee.state = "HEADER";
      }
      let be = !1;
      for (; ee.buffer; ) {
        if (!/\r\n|\n/.test(ee.buffer))
          return this;
        switch (be ? be = !1 : ye = ae(), ee.state) {
          case "HEADER":
            /:/.test(ye) ? ve(ye) : ye || (ee.state = "ID");
            continue;
          case "NOTE":
            ye || (ee.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(ye)) {
              ee.state = "NOTE";
              break;
            }
            if (!ye)
              continue;
            if (ee.cue = new VTTCue(0, 0, ""), ee.state = "CUE", ye.indexOf("-->") === -1) {
              ee.cue.id = ye;
              continue;
            }
          case "CUE":
            if (!ee.cue) {
              ee.state = "BADCUE";
              continue;
            }
            try {
              parseCue$1(ye, ee.cue, ee.regionList);
            } catch {
              ee.cue = null, ee.state = "BADCUE";
              continue;
            }
            ee.state = "CUETEXT";
            continue;
          case "CUETEXT":
            {
              const Ye = ye.indexOf("-->") !== -1;
              if (!ye || Ye && (be = !0)) {
                ee.oncue && ee.cue && ee.oncue(ee.cue), ee.cue = null, ee.state = "ID";
                continue;
              }
              if (ee.cue === null)
                continue;
              ee.cue.text && (ee.cue.text += `
`), ee.cue.text += ye;
            }
            continue;
          case "BADCUE":
            ye || (ee.state = "ID");
        }
      }
    } catch {
      ee.state === "CUETEXT" && ee.cue && ee.oncue && ee.oncue(ee.cue), ee.cue = null, ee.state = ee.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  }
  flush() {
    const Z = this;
    try {
      if ((Z.cue || Z.state === "HEADER") && (Z.buffer += `

`, Z.parse()), Z.state === "INITIAL" || Z.state === "BADWEBVTT")
        throw new Error("Malformed WebVTT signature.");
    } catch (ee) {
      Z.onparsingerror && Z.onparsingerror(ee);
    }
    return Z.onflush && Z.onflush(), this;
  }
}
const LINEBREAKS = /\r\n|\n\r|\n|\r/g, startsWith = function(Z, ee, ae = 0) {
  return Z.slice(ae, ae + ee.length) === ee;
}, cueString2millis = function(Z) {
  let ee = parseInt(Z.slice(-3));
  const ae = parseInt(Z.slice(-6, -4)), ve = parseInt(Z.slice(-9, -7)), ye = Z.length > 9 ? parseInt(Z.substring(0, Z.indexOf(":"))) : 0;
  if (!isFiniteNumber(ee) || !isFiniteNumber(ae) || !isFiniteNumber(ve) || !isFiniteNumber(ye))
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${Z}`);
  return ee += 1e3 * ae, ee += 60 * 1e3 * ve, ee += 60 * 60 * 1e3 * ye, ee;
}, hash = function(Z) {
  let ee = 5381, ae = Z.length;
  for (; ae; )
    ee = ee * 33 ^ Z.charCodeAt(--ae);
  return (ee >>> 0).toString();
};
function generateCueId(ie, Z, ee) {
  return hash(ie.toString()) + hash(Z.toString()) + hash(ee);
}
const calculateOffset = function(Z, ee, ae) {
  let ve = Z[ee], ye = Z[ve.prevCC];
  if (!ye || !ye.new && ve.new) {
    Z.ccOffset = Z.presentationOffset = ve.start, ve.new = !1;
    return;
  }
  for (; (be = ye) != null && be.new; ) {
    var be;
    Z.ccOffset += ve.start - ye.start, ve.new = !1, ve = ye, ye = Z[ve.prevCC];
  }
  Z.presentationOffset = ae;
};
function parseWebVTT(ie, Z, ee, ae, ve, ye, be) {
  const Ye = new VTTParser(), Qe = utf8ArrayToStr(new Uint8Array(ie)).trim().replace(LINEBREAKS, `
`).split(`
`), Je = [], nt = Z ? toMpegTsClockFromTimescale(Z.baseTime, Z.timescale) : 0;
  let st = "00:00.000", ot = 0, lt = 0, ft, gt = !0;
  Ye.oncue = function(ct) {
    const _r = ee[ae];
    let Kr = ee.ccOffset;
    const Xr = (ot - nt) / 9e4;
    if (_r != null && _r.new && (lt !== void 0 ? Kr = ee.ccOffset = _r.start : calculateOffset(ee, ae, Xr)), Xr) {
      if (!Z) {
        ft = new Error("Missing initPTS for VTT MPEGTS");
        return;
      }
      Kr = Xr - ee.presentationOffset;
    }
    const Jr = ct.endTime - ct.startTime, ei = normalizePts((ct.startTime + Kr - lt) * 9e4, ve * 9e4) / 9e4;
    ct.startTime = Math.max(ei, 0), ct.endTime = Math.max(ei + Jr, 0);
    const si = ct.text.trim();
    ct.text = decodeURIComponent(encodeURIComponent(si)), ct.id || (ct.id = generateCueId(ct.startTime, ct.endTime, si)), ct.endTime > 0 && Je.push(ct);
  }, Ye.onparsingerror = function(ct) {
    ft = ct;
  }, Ye.onflush = function() {
    if (ft) {
      be(ft);
      return;
    }
    ye(Je);
  }, Qe.forEach((ct) => {
    if (gt)
      if (startsWith(ct, "X-TIMESTAMP-MAP=")) {
        gt = !1, ct.slice(16).split(",").forEach((_r) => {
          startsWith(_r, "LOCAL:") ? st = _r.slice(6) : startsWith(_r, "MPEGTS:") && (ot = parseInt(_r.slice(7)));
        });
        try {
          lt = cueString2millis(st) / 1e3;
        } catch (_r) {
          ft = _r;
        }
        return;
      } else
        ct === "" && (gt = !1);
    Ye.parse(ct + `
`);
  }), Ye.flush();
}
const IMSC1_CODEC = "stpp.ttml.im1t", HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, textAlignToLineAlign = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
};
function parseIMSC1(ie, Z, ee, ae) {
  const ve = findBox(new Uint8Array(ie), ["mdat"]);
  if (ve.length === 0) {
    ae(new Error("Could not parse IMSC1 mdat"));
    return;
  }
  const ye = ve.map((Ye) => utf8ArrayToStr(Ye)), be = toTimescaleFromScale(Z.baseTime, 1, Z.timescale);
  try {
    ye.forEach((Ye) => ee(parseTTML(Ye, be)));
  } catch (Ye) {
    ae(Ye);
  }
}
function parseTTML(ie, Z) {
  const ve = new DOMParser().parseFromString(ie, "text/xml").getElementsByTagName("tt")[0];
  if (!ve)
    throw new Error("Invalid ttml");
  const ye = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  }, be = Object.keys(ye).reduce((st, ot) => (st[ot] = ve.getAttribute(`ttp:${ot}`) || ye[ot], st), {}), Ye = ve.getAttribute("xml:space") !== "preserve", Qe = collectionToDictionary(getElementCollection(ve, "styling", "style")), Je = collectionToDictionary(getElementCollection(ve, "layout", "region")), nt = getElementCollection(ve, "body", "[begin]");
  return [].map.call(nt, (st) => {
    const ot = getTextContent(st, Ye);
    if (!ot || !st.hasAttribute("begin"))
      return null;
    const lt = parseTtmlTime(st.getAttribute("begin"), be), ft = parseTtmlTime(st.getAttribute("dur"), be);
    let gt = parseTtmlTime(st.getAttribute("end"), be);
    if (lt === null)
      throw timestampParsingError(st);
    if (gt === null) {
      if (ft === null)
        throw timestampParsingError(st);
      gt = lt + ft;
    }
    const ct = new VTTCue(lt - Z, gt - Z, ot);
    ct.id = generateCueId(ct.startTime, ct.endTime, ct.text);
    const _r = Je[st.getAttribute("region")], Kr = Qe[st.getAttribute("style")], Xr = getTtmlStyles(_r, Kr, Qe), {
      textAlign: Jr
    } = Xr;
    if (Jr) {
      const ei = textAlignToLineAlign[Jr];
      ei && (ct.lineAlign = ei), ct.align = Jr;
    }
    return _extends(ct, Xr), ct;
  }).filter((st) => st !== null);
}
function getElementCollection(ie, Z, ee) {
  const ae = ie.getElementsByTagName(Z)[0];
  return ae ? [].slice.call(ae.querySelectorAll(ee)) : [];
}
function collectionToDictionary(ie) {
  return ie.reduce((Z, ee) => {
    const ae = ee.getAttribute("xml:id");
    return ae && (Z[ae] = ee), Z;
  }, {});
}
function getTextContent(ie, Z) {
  return [].slice.call(ie.childNodes).reduce((ee, ae, ve) => {
    var ye;
    return ae.nodeName === "br" && ve ? ee + `
` : (ye = ae.childNodes) != null && ye.length ? getTextContent(ae, Z) : Z ? ee + ae.textContent.trim().replace(/\s+/g, " ") : ee + ae.textContent;
  }, "");
}
function getTtmlStyles(ie, Z, ee) {
  const ae = "http://www.w3.org/ns/ttml#styling";
  let ve = null;
  const ye = [
    "displayAlign",
    "textAlign",
    "color",
    "backgroundColor",
    "fontSize",
    "fontFamily"
    // 'fontWeight',
    // 'lineHeight',
    // 'wrapOption',
    // 'fontStyle',
    // 'direction',
    // 'writingMode'
  ], be = ie != null && ie.hasAttribute("style") ? ie.getAttribute("style") : null;
  return be && ee.hasOwnProperty(be) && (ve = ee[be]), ye.reduce((Ye, Qe) => {
    const Je = getAttributeNS(Z, ae, Qe) || getAttributeNS(ie, ae, Qe) || getAttributeNS(ve, ae, Qe);
    return Je && (Ye[Qe] = Je), Ye;
  }, {});
}
function getAttributeNS(ie, Z, ee) {
  return ie && ie.hasAttributeNS(Z, ee) ? ie.getAttributeNS(Z, ee) : null;
}
function timestampParsingError(ie) {
  return new Error(`Could not parse ttml timestamp ${ie}`);
}
function parseTtmlTime(ie, Z) {
  if (!ie)
    return null;
  let ee = parseTimeStamp(ie);
  return ee === null && (HMSF_REGEX.test(ie) ? ee = parseHoursMinutesSecondsFrames(ie, Z) : TIME_UNIT_REGEX.test(ie) && (ee = parseTimeUnits(ie, Z))), ee;
}
function parseHoursMinutesSecondsFrames(ie, Z) {
  const ee = HMSF_REGEX.exec(ie), ae = (ee[4] | 0) + (ee[5] | 0) / Z.subFrameRate;
  return (ee[1] | 0) * 3600 + (ee[2] | 0) * 60 + (ee[3] | 0) + ae / Z.frameRate;
}
function parseTimeUnits(ie, Z) {
  const ee = TIME_UNIT_REGEX.exec(ie), ae = Number(ee[1]);
  switch (ee[2]) {
    case "h":
      return ae * 3600;
    case "m":
      return ae * 60;
    case "ms":
      return ae * 1e3;
    case "f":
      return ae / Z.frameRate;
    case "t":
      return ae / Z.tickRate;
  }
  return ae;
}
class TimelineController {
  constructor(Z) {
    this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = newVTTCCs(), this.captionsProperties = void 0, this.hls = Z, this.config = Z.config, this.Cues = Z.config.cueHandler, this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    }, Z.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this), Z.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this), Z.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), Z.on(Events.FRAG_LOADING, this.onFragLoading, this), Z.on(Events.FRAG_LOADED, this.onFragLoaded, this), Z.on(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), Z.on(Events.FRAG_DECRYPTED, this.onFragDecrypted, this), Z.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this), Z.on(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), Z.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls: Z
    } = this;
    Z.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this), Z.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this), Z.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), Z.off(Events.FRAG_LOADING, this.onFragLoading, this), Z.off(Events.FRAG_LOADED, this.onFragLoaded, this), Z.off(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), Z.off(Events.FRAG_DECRYPTED, this.onFragDecrypted, this), Z.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this), Z.off(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), Z.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = null, this.cea608Parser1 = this.cea608Parser2 = void 0;
  }
  initCea608Parsers() {
    if (this.config.enableCEA708Captions && (!this.cea608Parser1 || !this.cea608Parser2)) {
      const Z = new OutputFilter(this, "textTrack1"), ee = new OutputFilter(this, "textTrack2"), ae = new OutputFilter(this, "textTrack3"), ve = new OutputFilter(this, "textTrack4");
      this.cea608Parser1 = new Cea608Parser(1, Z, ee), this.cea608Parser2 = new Cea608Parser(3, ae, ve);
    }
  }
  addCues(Z, ee, ae, ve, ye) {
    let be = !1;
    for (let Ye = ye.length; Ye--; ) {
      const Qe = ye[Ye], Je = intersection(Qe[0], Qe[1], ee, ae);
      if (Je >= 0 && (Qe[0] = Math.min(Qe[0], ee), Qe[1] = Math.max(Qe[1], ae), be = !0, Je / (ae - ee) > 0.5))
        return;
    }
    if (be || ye.push([ee, ae]), this.config.renderTextTracksNatively) {
      const Ye = this.captionsTracks[Z];
      this.Cues.newCue(Ye, ee, ae, ve);
    } else {
      const Ye = this.Cues.newCue(null, ee, ae, ve);
      this.hls.trigger(Events.CUES_PARSED, {
        type: "captions",
        cues: Ye,
        track: Z
      });
    }
  }
  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(Z, {
    frag: ee,
    id: ae,
    initPTS: ve,
    timescale: ye
  }) {
    const {
      unparsedVttFrags: be
    } = this;
    ae === "main" && (this.initPTS[ee.cc] = {
      baseTime: ve,
      timescale: ye
    }), be.length && (this.unparsedVttFrags = [], be.forEach((Ye) => {
      this.onFragLoaded(Events.FRAG_LOADED, Ye);
    }));
  }
  getExistingTrack(Z, ee) {
    const {
      media: ae
    } = this;
    if (ae)
      for (let ve = 0; ve < ae.textTracks.length; ve++) {
        const ye = ae.textTracks[ve];
        if (canReuseVttTextTrack(ye, {
          name: Z,
          lang: ee,
          attrs: {}
        }))
          return ye;
      }
    return null;
  }
  createCaptionsTrack(Z) {
    this.config.renderTextTracksNatively ? this.createNativeTrack(Z) : this.createNonNativeTrack(Z);
  }
  createNativeTrack(Z) {
    if (this.captionsTracks[Z])
      return;
    const {
      captionsProperties: ee,
      captionsTracks: ae,
      media: ve
    } = this, {
      label: ye,
      languageCode: be
    } = ee[Z], Ye = this.getExistingTrack(ye, be);
    if (Ye)
      ae[Z] = Ye, clearCurrentCues(ae[Z]), sendAddTrackEvent(ae[Z], ve);
    else {
      const Qe = this.createTextTrack("captions", ye, be);
      Qe && (Qe[Z] = !0, ae[Z] = Qe);
    }
  }
  createNonNativeTrack(Z) {
    if (this.nonNativeCaptionsTracks[Z])
      return;
    const ee = this.captionsProperties[Z];
    if (!ee)
      return;
    const ae = ee.label, ve = {
      _id: Z,
      label: ae,
      kind: "captions",
      default: ee.media ? !!ee.media.default : !1,
      closedCaptions: ee.media
    };
    this.nonNativeCaptionsTracks[Z] = ve, this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [ve]
    });
  }
  createTextTrack(Z, ee, ae) {
    const ve = this.media;
    if (ve)
      return ve.addTextTrack(Z, ee, ae);
  }
  onMediaAttaching(Z, ee) {
    this.media = ee.media, this._cleanTracks();
  }
  onMediaDetaching() {
    const {
      captionsTracks: Z
    } = this;
    Object.keys(Z).forEach((ee) => {
      clearCurrentCues(Z[ee]), delete Z[ee];
    }), this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = newVTTCCs(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
  }
  _cleanTracks() {
    const {
      media: Z
    } = this;
    if (!Z)
      return;
    const ee = Z.textTracks;
    if (ee)
      for (let ae = 0; ae < ee.length; ae++)
        clearCurrentCues(ee[ae]);
  }
  onSubtitleTracksUpdated(Z, ee) {
    const ae = ee.subtitleTracks || [], ve = ae.some((ye) => ye.textCodec === IMSC1_CODEC);
    if (this.config.enableWebVTT || ve && this.config.enableIMSC1) {
      if (subtitleOptionsIdentical(this.tracks, ae)) {
        this.tracks = ae;
        return;
      }
      if (this.textTracks = [], this.tracks = ae, this.config.renderTextTracksNatively) {
        const be = this.media, Ye = be ? filterSubtitleTracks(be.textTracks) : null;
        if (this.tracks.forEach((Qe, Je) => {
          let nt;
          if (Ye) {
            let st = null;
            for (let ot = 0; ot < Ye.length; ot++)
              if (Ye[ot] && canReuseVttTextTrack(Ye[ot], Qe)) {
                st = Ye[ot], Ye[ot] = null;
                break;
              }
            st && (nt = st);
          }
          if (nt)
            clearCurrentCues(nt);
          else {
            const st = captionsOrSubtitlesFromCharacteristics(Qe);
            nt = this.createTextTrack(st, Qe.name, Qe.lang), nt && (nt.mode = "disabled");
          }
          nt && this.textTracks.push(nt);
        }), Ye != null && Ye.length) {
          const Qe = Ye.filter((Je) => Je !== null).map((Je) => Je.label);
          Qe.length && logger.warn(`Media element contains unused subtitle tracks: ${Qe.join(", ")}. Replace media element for each source to clear TextTracks and captions menu.`);
        }
      } else if (this.tracks.length) {
        const be = this.tracks.map((Ye) => ({
          label: Ye.name,
          kind: Ye.type.toLowerCase(),
          default: Ye.default,
          subtitleTrack: Ye
        }));
        this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: be
        });
      }
    }
  }
  onManifestLoaded(Z, ee) {
    this.config.enableCEA708Captions && ee.captions && ee.captions.forEach((ae) => {
      const ve = /(?:CC|SERVICE)([1-4])/.exec(ae.instreamId);
      if (!ve)
        return;
      const ye = `textTrack${ve[1]}`, be = this.captionsProperties[ye];
      be && (be.label = ae.name, ae.lang && (be.languageCode = ae.lang), be.media = ae);
    });
  }
  closedCaptionsForLevel(Z) {
    const ee = this.hls.levels[Z.level];
    return ee == null ? void 0 : ee.attrs["CLOSED-CAPTIONS"];
  }
  onFragLoading(Z, ee) {
    this.initCea608Parsers();
    const {
      cea608Parser1: ae,
      cea608Parser2: ve,
      lastCc: ye,
      lastSn: be,
      lastPartIndex: Ye
    } = this;
    if (!(!this.enabled || !ae || !ve) && ee.frag.type === PlaylistLevelType.MAIN) {
      var Qe, Je;
      const {
        cc: nt,
        sn: st
      } = ee.frag, ot = (Qe = ee == null || (Je = ee.part) == null ? void 0 : Je.index) != null ? Qe : -1;
      st === be + 1 || st === be && ot === Ye + 1 || nt === ye || (ae.reset(), ve.reset()), this.lastCc = nt, this.lastSn = st, this.lastPartIndex = ot;
    }
  }
  onFragLoaded(Z, ee) {
    const {
      frag: ae,
      payload: ve
    } = ee;
    if (ae.type === PlaylistLevelType.SUBTITLE)
      if (ve.byteLength) {
        const ye = ae.decryptdata, be = "stats" in ee;
        if (ye == null || !ye.encrypted || be) {
          const Ye = this.tracks[ae.level], Qe = this.vttCCs;
          Qe[ae.cc] || (Qe[ae.cc] = {
            start: ae.start,
            prevCC: this.prevCC,
            new: !0
          }, this.prevCC = ae.cc), Ye && Ye.textCodec === IMSC1_CODEC ? this._parseIMSC1(ae, ve) : this._parseVTTs(ee);
        }
      } else
        this.hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
          success: !1,
          frag: ae,
          error: new Error("Empty subtitle payload")
        });
  }
  _parseIMSC1(Z, ee) {
    const ae = this.hls;
    parseIMSC1(ee, this.initPTS[Z.cc], (ve) => {
      this._appendCues(ve, Z.level), ae.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: Z
      });
    }, (ve) => {
      logger.log(`Failed to parse IMSC1: ${ve}`), ae.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: Z,
        error: ve
      });
    });
  }
  _parseVTTs(Z) {
    var ee;
    const {
      frag: ae,
      payload: ve
    } = Z, {
      initPTS: ye,
      unparsedVttFrags: be
    } = this, Ye = ye.length - 1;
    if (!ye[ae.cc] && Ye === -1) {
      be.push(Z);
      return;
    }
    const Qe = this.hls, Je = (ee = ae.initSegment) != null && ee.data ? appendUint8Array(ae.initSegment.data, new Uint8Array(ve)) : ve;
    parseWebVTT(Je, this.initPTS[ae.cc], this.vttCCs, ae.cc, ae.start, (nt) => {
      this._appendCues(nt, ae.level), Qe.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: ae
      });
    }, (nt) => {
      const st = nt.message === "Missing initPTS for VTT MPEGTS";
      st ? be.push(Z) : this._fallbackToIMSC1(ae, ve), logger.log(`Failed to parse VTT cue: ${nt}`), !(st && Ye > ae.cc) && Qe.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: ae,
        error: nt
      });
    });
  }
  _fallbackToIMSC1(Z, ee) {
    const ae = this.tracks[Z.level];
    ae.textCodec || parseIMSC1(ee, this.initPTS[Z.cc], () => {
      ae.textCodec = IMSC1_CODEC, this._parseIMSC1(Z, ee);
    }, () => {
      ae.textCodec = "wvtt";
    });
  }
  _appendCues(Z, ee) {
    const ae = this.hls;
    if (this.config.renderTextTracksNatively) {
      const ve = this.textTracks[ee];
      if (!ve || ve.mode === "disabled")
        return;
      Z.forEach((ye) => addCueToTrack(ve, ye));
    } else {
      const ve = this.tracks[ee];
      if (!ve)
        return;
      const ye = ve.default ? "default" : "subtitles" + ee;
      ae.trigger(Events.CUES_PARSED, {
        type: "subtitles",
        cues: Z,
        track: ye
      });
    }
  }
  onFragDecrypted(Z, ee) {
    const {
      frag: ae
    } = ee;
    ae.type === PlaylistLevelType.SUBTITLE && this.onFragLoaded(Events.FRAG_LOADED, ee);
  }
  onSubtitleTracksCleared() {
    this.tracks = [], this.captionsTracks = {};
  }
  onFragParsingUserdata(Z, ee) {
    this.initCea608Parsers();
    const {
      cea608Parser1: ae,
      cea608Parser2: ve
    } = this;
    if (!this.enabled || !ae || !ve)
      return;
    const {
      frag: ye,
      samples: be
    } = ee;
    if (!(ye.type === PlaylistLevelType.MAIN && this.closedCaptionsForLevel(ye) === "NONE"))
      for (let Ye = 0; Ye < be.length; Ye++) {
        const Qe = be[Ye].bytes;
        if (Qe) {
          const Je = this.extractCea608Data(Qe);
          ae.addData(be[Ye].pts, Je[0]), ve.addData(be[Ye].pts, Je[1]);
        }
      }
  }
  onBufferFlushing(Z, {
    startOffset: ee,
    endOffset: ae,
    endOffsetSubtitles: ve,
    type: ye
  }) {
    const {
      media: be
    } = this;
    if (!(!be || be.currentTime < ae)) {
      if (!ye || ye === "video") {
        const {
          captionsTracks: Ye
        } = this;
        Object.keys(Ye).forEach((Qe) => removeCuesInRange(Ye[Qe], ee, ae));
      }
      if (this.config.renderTextTracksNatively && ee === 0 && ve !== void 0) {
        const {
          textTracks: Ye
        } = this;
        Object.keys(Ye).forEach((Qe) => removeCuesInRange(Ye[Qe], ee, ve));
      }
    }
  }
  extractCea608Data(Z) {
    const ee = [[], []], ae = Z[0] & 31;
    let ve = 2;
    for (let ye = 0; ye < ae; ye++) {
      const be = Z[ve++], Ye = 127 & Z[ve++], Qe = 127 & Z[ve++];
      if (Ye === 0 && Qe === 0)
        continue;
      if ((4 & be) !== 0) {
        const nt = 3 & be;
        (nt === 0 || nt === 1) && (ee[nt].push(Ye), ee[nt].push(Qe));
      }
    }
    return ee;
  }
}
function captionsOrSubtitlesFromCharacteristics(ie) {
  return ie.characteristics && /transcribes-spoken-dialog/gi.test(ie.characteristics) && /describes-music-and-sound/gi.test(ie.characteristics) ? "captions" : "subtitles";
}
function canReuseVttTextTrack(ie, Z) {
  return !!ie && ie.kind === captionsOrSubtitlesFromCharacteristics(Z) && subtitleTrackMatchesTextTrack(Z, ie);
}
function intersection(ie, Z, ee, ae) {
  return Math.min(Z, ae) - Math.max(ie, ee);
}
function newVTTCCs() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: !0
    }
  };
}
class CapLevelController {
  constructor(Z) {
    this.hls = void 0, this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.clientRect = void 0, this.streamController = void 0, this.hls = Z, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
  }
  setStreamController(Z) {
    this.streamController = Z;
  }
  destroy() {
    this.hls && this.unregisterListener(), this.timer && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), Z.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this), Z.on(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this), Z.on(Events.BUFFER_CODECS, this.onBufferCodecs, this), Z.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls: Z
    } = this;
    Z.off(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), Z.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this), Z.off(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this), Z.off(Events.BUFFER_CODECS, this.onBufferCodecs, this), Z.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(Z, ee) {
    const ae = this.hls.levels[ee.droppedLevel];
    this.isLevelAllowed(ae) && this.restrictedLevels.push({
      bitrate: ae.bitrate,
      height: ae.height,
      width: ae.width
    });
  }
  onMediaAttaching(Z, ee) {
    this.media = ee.media instanceof HTMLVideoElement ? ee.media : null, this.clientRect = null, this.timer && this.hls.levels.length && this.detectPlayerSize();
  }
  onManifestParsed(Z, ee) {
    const ae = this.hls;
    this.restrictedLevels = [], this.firstLevel = ee.firstLevel, ae.config.capLevelToPlayerSize && ee.video && this.startCapping();
  }
  onLevelsUpdated(Z, ee) {
    this.timer && isFiniteNumber(this.autoLevelCapping) && this.detectPlayerSize();
  }
  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(Z, ee) {
    this.hls.config.capLevelToPlayerSize && ee.video && this.startCapping();
  }
  onMediaDetaching() {
    this.stopCapping();
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const Z = this.hls.levels;
      if (Z.length) {
        const ee = this.hls, ae = this.getMaxLevel(Z.length - 1);
        ae !== this.autoLevelCapping && logger.log(`Setting autoLevelCapping to ${ae}: ${Z[ae].height}p@${Z[ae].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`), ee.autoLevelCapping = ae, ee.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = ee.autoLevelCapping;
      }
    }
  }
  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(Z) {
    const ee = this.hls.levels;
    if (!ee.length)
      return -1;
    const ae = ee.filter((ve, ye) => this.isLevelAllowed(ve) && ye <= Z);
    return this.clientRect = null, CapLevelController.getMaxLevelByMediaSize(ae, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
  }
  stopCapping() {
    this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
  }
  getDimensions() {
    if (this.clientRect)
      return this.clientRect;
    const Z = this.media, ee = {
      width: 0,
      height: 0
    };
    if (Z) {
      const ae = Z.getBoundingClientRect();
      ee.width = ae.width, ee.height = ae.height, !ee.width && !ee.height && (ee.width = ae.right - ae.left || Z.width || 0, ee.height = ae.bottom - ae.top || Z.height || 0);
    }
    return this.clientRect = ee, ee;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let Z = 1;
    if (!this.hls.config.ignoreDevicePixelRatio)
      try {
        Z = self.devicePixelRatio;
      } catch {
      }
    return Z;
  }
  isLevelAllowed(Z) {
    return !this.restrictedLevels.some((ae) => Z.bitrate === ae.bitrate && Z.width === ae.width && Z.height === ae.height);
  }
  static getMaxLevelByMediaSize(Z, ee, ae) {
    if (!(Z != null && Z.length))
      return -1;
    const ve = (Ye, Qe) => Qe ? Ye.width !== Qe.width || Ye.height !== Qe.height : !0;
    let ye = Z.length - 1;
    const be = Math.max(ee, ae);
    for (let Ye = 0; Ye < Z.length; Ye += 1) {
      const Qe = Z[Ye];
      if ((Qe.width >= be || Qe.height >= be) && ve(Qe, Z[Ye + 1])) {
        ye = Ye;
        break;
      }
    }
    return ye;
  }
}
class FPSController {
  constructor(Z) {
    this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = Z, this.registerListeners();
  }
  setStreamController(Z) {
    this.streamController = Z;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  destroy() {
    this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
  }
  onMediaAttaching(Z, ee) {
    const ae = this.hls.config;
    if (ae.capLevelOnFPSDrop) {
      const ve = ee.media instanceof self.HTMLVideoElement ? ee.media : null;
      this.media = ve, ve && typeof ve.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), ae.fpsDroppedMonitoringPeriod);
    }
  }
  checkFPS(Z, ee, ae) {
    const ve = performance.now();
    if (ee) {
      if (this.lastTime) {
        const ye = ve - this.lastTime, be = ae - this.lastDroppedFrames, Ye = ee - this.lastDecodedFrames, Qe = 1e3 * be / ye, Je = this.hls;
        if (Je.trigger(Events.FPS_DROP, {
          currentDropped: be,
          currentDecoded: Ye,
          totalDroppedFrames: ae
        }), Qe > 0 && be > Je.config.fpsDroppedMonitoringThreshold * Ye) {
          let nt = Je.currentLevel;
          logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + nt), nt > 0 && (Je.autoLevelCapping === -1 || Je.autoLevelCapping >= nt) && (nt = nt - 1, Je.trigger(Events.FPS_DROP_LEVEL_CAPPING, {
            level: nt,
            droppedLevel: Je.currentLevel
          }), Je.autoLevelCapping = nt, this.streamController.nextLevelSwitch());
        }
      }
      this.lastTime = ve, this.lastDroppedFrames = ae, this.lastDecodedFrames = ee;
    }
  }
  checkFPSInterval() {
    const Z = this.media;
    if (Z)
      if (this.isVideoPlaybackQualityAvailable) {
        const ee = Z.getVideoPlaybackQuality();
        this.checkFPS(Z, ee.totalVideoFrames, ee.droppedVideoFrames);
      } else
        this.checkFPS(Z, Z.webkitDecodedFrameCount, Z.webkitDroppedFrameCount);
  }
}
const LOGGER_PREFIX = "[eme]";
class EMEController {
  constructor(Z) {
    this.hls = void 0, this.config = void 0, this.media = null, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.setMediaKeysQueue = EMEController.CDMCleanupPromise ? [EMEController.CDMCleanupPromise] : [], this.onMediaEncrypted = this._onMediaEncrypted.bind(this), this.onWaitingForKey = this._onWaitingForKey.bind(this), this.debug = logger.debug.bind(logger, LOGGER_PREFIX), this.log = logger.log.bind(logger, LOGGER_PREFIX), this.warn = logger.warn.bind(logger, LOGGER_PREFIX), this.error = logger.error.bind(logger, LOGGER_PREFIX), this.hls = Z, this.config = Z.config, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached();
    const Z = this.config;
    Z.requestMediaKeySystemAccessFunc = null, Z.licenseXhrSetup = Z.licenseResponseCallback = void 0, Z.drmSystems = Z.drmSystemOptions = {}, this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null, this.config = null;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  getLicenseServerUrl(Z) {
    const {
      drmSystems: ee,
      widevineLicenseUrl: ae
    } = this.config, ve = ee[Z];
    if (ve)
      return ve.licenseUrl;
    if (Z === KeySystems.WIDEVINE && ae)
      return ae;
    throw new Error(`no license server URL configured for key-system "${Z}"`);
  }
  getServerCertificateUrl(Z) {
    const {
      drmSystems: ee
    } = this.config, ae = ee[Z];
    if (ae)
      return ae.serverCertificateUrl;
    this.log(`No Server Certificate in config.drmSystems["${Z}"]`);
  }
  attemptKeySystemAccess(Z) {
    const ee = this.hls.levels, ae = (be, Ye, Qe) => !!be && Qe.indexOf(be) === Ye, ve = ee.map((be) => be.audioCodec).filter(ae), ye = ee.map((be) => be.videoCodec).filter(ae);
    return ve.length + ye.length === 0 && ye.push("avc1.42e01e"), new Promise((be, Ye) => {
      const Qe = (Je) => {
        const nt = Je.shift();
        this.getMediaKeysPromise(nt, ve, ye).then((st) => be({
          keySystem: nt,
          mediaKeys: st
        })).catch((st) => {
          Je.length ? Qe(Je) : st instanceof EMEKeyError ? Ye(st) : Ye(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_NO_ACCESS,
            error: st,
            fatal: !0
          }, st.message));
        });
      };
      Qe(Z);
    });
  }
  requestMediaKeySystemAccess(Z, ee) {
    const {
      requestMediaKeySystemAccessFunc: ae
    } = this.config;
    if (typeof ae != "function") {
      let ve = `Configured requestMediaKeySystemAccess is not a function ${ae}`;
      return requestMediaKeySystemAccess === null && self.location.protocol === "http:" && (ve = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`), Promise.reject(new Error(ve));
    }
    return ae(Z, ee);
  }
  getMediaKeysPromise(Z, ee, ae) {
    const ve = getSupportedMediaKeySystemConfigurations(Z, ee, ae, this.config.drmSystemOptions), ye = this.keySystemAccessPromises[Z];
    let be = ye == null ? void 0 : ye.keySystemAccess;
    if (!be) {
      this.log(`Requesting encrypted media "${Z}" key-system access with config: ${JSON.stringify(ve)}`), be = this.requestMediaKeySystemAccess(Z, ve);
      const Ye = this.keySystemAccessPromises[Z] = {
        keySystemAccess: be
      };
      return be.catch((Qe) => {
        this.log(`Failed to obtain access to key-system "${Z}": ${Qe}`);
      }), be.then((Qe) => {
        this.log(`Access for key-system "${Qe.keySystem}" obtained`);
        const Je = this.fetchServerCertificate(Z);
        return this.log(`Create media-keys for "${Z}"`), Ye.mediaKeys = Qe.createMediaKeys().then((nt) => (this.log(`Media-keys created for "${Z}"`), Je.then((st) => st ? this.setMediaKeysServerCertificate(nt, Z, st) : nt))), Ye.mediaKeys.catch((nt) => {
          this.error(`Failed to create media-keys for "${Z}"}: ${nt}`);
        }), Ye.mediaKeys;
      });
    }
    return be.then(() => ye.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata: Z,
    keySystem: ee,
    mediaKeys: ae
  }) {
    this.log(`Creating key-system session "${ee}" keyId: ${Hex.hexDump(Z.keyId || [])}`);
    const ve = ae.createSession(), ye = {
      decryptdata: Z,
      keySystem: ee,
      mediaKeys: ae,
      mediaKeysSession: ve,
      keyStatus: "status-pending"
    };
    return this.mediaKeySessions.push(ye), ye;
  }
  renewKeySession(Z) {
    const ee = Z.decryptdata;
    if (ee.pssh) {
      const ae = this.createMediaKeySessionContext(Z), ve = this.getKeyIdString(ee), ye = "cenc";
      this.keyIdToKeySessionPromise[ve] = this.generateRequestWithPreferredKeySession(ae, ye, ee.pssh, "expired");
    } else
      this.warn("Could not renew expired session. Missing pssh initData.");
    this.removeSession(Z);
  }
  getKeyIdString(Z) {
    if (!Z)
      throw new Error("Could not read keyId of undefined decryptdata");
    if (Z.keyId === null)
      throw new Error("keyId is null");
    return Hex.hexDump(Z.keyId);
  }
  updateKeySession(Z, ee) {
    var ae;
    const ve = Z.mediaKeysSession;
    return this.log(`Updating key-session "${ve.sessionId}" for keyID ${Hex.hexDump(((ae = Z.decryptdata) == null ? void 0 : ae.keyId) || [])}
      } (data length: ${ee && ee.byteLength})`), ve.update(ee);
  }
  selectKeySystemFormat(Z) {
    const ee = Object.keys(Z.levelkeys || {});
    return this.keyFormatPromise || (this.log(`Selecting key-system from fragment (sn: ${Z.sn} ${Z.type}: ${Z.level}) key formats ${ee.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(ee)), this.keyFormatPromise;
  }
  getKeyFormatPromise(Z) {
    return new Promise((ee, ae) => {
      const ve = getKeySystemsForConfig(this.config), ye = Z.map(keySystemFormatToKeySystemDomain).filter((be) => !!be && ve.indexOf(be) !== -1);
      return this.getKeySystemSelectionPromise(ye).then(({
        keySystem: be
      }) => {
        const Ye = keySystemDomainToKeySystemFormat(be);
        Ye ? ee(Ye) : ae(new Error(`Unable to find format for key-system "${be}"`));
      }).catch(ae);
    });
  }
  loadKey(Z) {
    const ee = Z.keyInfo.decryptdata, ae = this.getKeyIdString(ee), ve = `(keyId: ${ae} format: "${ee.keyFormat}" method: ${ee.method} uri: ${ee.uri})`;
    this.log(`Starting session for key ${ve}`);
    let ye = this.keyIdToKeySessionPromise[ae];
    return ye || (ye = this.keyIdToKeySessionPromise[ae] = this.getKeySystemForKeyPromise(ee).then(({
      keySystem: be,
      mediaKeys: Ye
    }) => (this.throwIfDestroyed(), this.log(`Handle encrypted media sn: ${Z.frag.sn} ${Z.frag.type}: ${Z.frag.level} using key ${ve}`), this.attemptSetMediaKeys(be, Ye).then(() => {
      this.throwIfDestroyed();
      const Qe = this.createMediaKeySessionContext({
        keySystem: be,
        mediaKeys: Ye,
        decryptdata: ee
      });
      return this.generateRequestWithPreferredKeySession(Qe, "cenc", ee.pssh, "playlist-key");
    }))), ye.catch((be) => this.handleError(be))), ye;
  }
  throwIfDestroyed(Z = "Invalid state") {
    if (!this.hls)
      throw new Error("invalid state");
  }
  handleError(Z) {
    this.hls && (this.error(Z.message), Z instanceof EMEKeyError ? this.hls.trigger(Events.ERROR, Z.data) : this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.KEY_SYSTEM_ERROR,
      details: ErrorDetails.KEY_SYSTEM_NO_KEYS,
      error: Z,
      fatal: !0
    }));
  }
  getKeySystemForKeyPromise(Z) {
    const ee = this.getKeyIdString(Z), ae = this.keyIdToKeySessionPromise[ee];
    if (!ae) {
      const ve = keySystemFormatToKeySystemDomain(Z.keyFormat), ye = ve ? [ve] : getKeySystemsForConfig(this.config);
      return this.attemptKeySystemAccess(ye);
    }
    return ae;
  }
  getKeySystemSelectionPromise(Z) {
    if (Z.length || (Z = getKeySystemsForConfig(this.config)), Z.length === 0)
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: !0
      }, `Missing key-system license configuration options ${JSON.stringify({
        drmSystems: this.config.drmSystems
      })}`);
    return this.attemptKeySystemAccess(Z);
  }
  _onMediaEncrypted(Z) {
    const {
      initDataType: ee,
      initData: ae
    } = Z;
    if (this.debug(`"${Z.type}" event: init data type: "${ee}"`), ae === null)
      return;
    let ve, ye;
    if (ee === "sinf" && this.config.drmSystems[KeySystems.FAIRPLAY]) {
      const nt = bin2str(new Uint8Array(ae));
      try {
        const st = base64Decode(JSON.parse(nt).sinf), ot = parseSinf(new Uint8Array(st));
        if (!ot)
          return;
        ve = ot.subarray(8, 24), ye = KeySystems.FAIRPLAY;
      } catch {
        this.warn('Failed to parse sinf "encrypted" event message initData');
        return;
      }
    } else {
      const nt = parsePssh(ae);
      if (nt === null)
        return;
      nt.version === 0 && nt.systemId === KeySystemIds.WIDEVINE && nt.data && (ve = nt.data.subarray(8, 24)), ye = keySystemIdToKeySystemDomain(nt.systemId);
    }
    if (!ye || !ve)
      return;
    const be = Hex.hexDump(ve), {
      keyIdToKeySessionPromise: Ye,
      mediaKeySessions: Qe
    } = this;
    let Je = Ye[be];
    for (let nt = 0; nt < Qe.length; nt++) {
      const st = Qe[nt], ot = st.decryptdata;
      if (ot.pssh || !ot.keyId)
        continue;
      const lt = Hex.hexDump(ot.keyId);
      if (be === lt || ot.uri.replace(/-/g, "").indexOf(be) !== -1) {
        Je = Ye[lt], delete Ye[lt], ot.pssh = new Uint8Array(ae), ot.keyId = ve, Je = Ye[be] = Je.then(() => this.generateRequestWithPreferredKeySession(st, ee, ae, "encrypted-event-key-match"));
        break;
      }
    }
    Je || (Je = Ye[be] = this.getKeySystemSelectionPromise([ye]).then(({
      keySystem: nt,
      mediaKeys: st
    }) => {
      var ot;
      this.throwIfDestroyed();
      const lt = new LevelKey("ISO-23001-7", be, (ot = keySystemDomainToKeySystemFormat(nt)) != null ? ot : "");
      return lt.pssh = new Uint8Array(ae), lt.keyId = ve, this.attemptSetMediaKeys(nt, st).then(() => {
        this.throwIfDestroyed();
        const ft = this.createMediaKeySessionContext({
          decryptdata: lt,
          keySystem: nt,
          mediaKeys: st
        });
        return this.generateRequestWithPreferredKeySession(ft, ee, ae, "encrypted-event-no-match");
      });
    })), Je.catch((nt) => this.handleError(nt));
  }
  _onWaitingForKey(Z) {
    this.log(`"${Z.type}" event`);
  }
  attemptSetMediaKeys(Z, ee) {
    const ae = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${Z}"`);
    const ve = Promise.all(ae).then(() => {
      if (!this.media)
        throw new Error("Attempted to set mediaKeys without media element attached");
      return this.media.setMediaKeys(ee);
    });
    return this.setMediaKeysQueue.push(ve), ve.then(() => {
      this.log(`Media-keys set for "${Z}"`), ae.push(ve), this.setMediaKeysQueue = this.setMediaKeysQueue.filter((ye) => ae.indexOf(ye) === -1);
    });
  }
  generateRequestWithPreferredKeySession(Z, ee, ae, ve) {
    var ye, be;
    const Ye = (ye = this.config.drmSystems) == null || (be = ye[Z.keySystem]) == null ? void 0 : be.generateRequest;
    if (Ye)
      try {
        const ft = Ye.call(this.hls, ee, ae, Z);
        if (!ft)
          throw new Error("Invalid response from configured generateRequest filter");
        ee = ft.initDataType, ae = Z.decryptdata.pssh = ft.initData ? new Uint8Array(ft.initData) : null;
      } catch (ft) {
        var Qe;
        if (this.warn(ft.message), (Qe = this.hls) != null && Qe.config.debug)
          throw ft;
      }
    if (ae === null)
      return this.log(`Skipping key-session request for "${ve}" (no initData)`), Promise.resolve(Z);
    const Je = this.getKeyIdString(Z.decryptdata);
    this.log(`Generating key-session request for "${ve}": ${Je} (init data type: ${ee} length: ${ae ? ae.byteLength : null})`);
    const nt = new EventEmitter(), st = Z._onmessage = (ft) => {
      const gt = Z.mediaKeysSession;
      if (!gt) {
        nt.emit("error", new Error("invalid state"));
        return;
      }
      const {
        messageType: ct,
        message: _r
      } = ft;
      this.log(`"${ct}" message event for session "${gt.sessionId}" message size: ${_r.byteLength}`), ct === "license-request" || ct === "license-renewal" ? this.renewLicense(Z, _r).catch((Kr) => {
        this.handleError(Kr), nt.emit("error", Kr);
      }) : ct === "license-release" ? Z.keySystem === KeySystems.FAIRPLAY && (this.updateKeySession(Z, strToUtf8array("acknowledged")), this.removeSession(Z)) : this.warn(`unhandled media key message type "${ct}"`);
    }, ot = Z._onkeystatuseschange = (ft) => {
      if (!Z.mediaKeysSession) {
        nt.emit("error", new Error("invalid state"));
        return;
      }
      this.onKeyStatusChange(Z);
      const ct = Z.keyStatus;
      nt.emit("keyStatus", ct), ct === "expired" && (this.warn(`${Z.keySystem} expired for key ${Je}`), this.renewKeySession(Z));
    };
    Z.mediaKeysSession.addEventListener("message", st), Z.mediaKeysSession.addEventListener("keystatuseschange", ot);
    const lt = new Promise((ft, gt) => {
      nt.on("error", gt), nt.on("keyStatus", (ct) => {
        ct.startsWith("usable") ? ft() : ct === "output-restricted" ? gt(new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
          fatal: !1
        }, "HDCP level output restricted")) : ct === "internal-error" ? gt(new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
          fatal: !0
        }, `key status changed to "${ct}"`)) : ct === "expired" ? gt(new Error("key expired while generating request")) : this.warn(`unhandled key status change "${ct}"`);
      });
    });
    return Z.mediaKeysSession.generateRequest(ee, ae).then(() => {
      var ft;
      this.log(`Request generated for key-session "${(ft = Z.mediaKeysSession) == null ? void 0 : ft.sessionId}" keyId: ${Je}`);
    }).catch((ft) => {
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_SESSION,
        error: ft,
        fatal: !1
      }, `Error generating key-session request: ${ft}`);
    }).then(() => lt).catch((ft) => {
      throw nt.removeAllListeners(), this.removeSession(Z), ft;
    }).then(() => (nt.removeAllListeners(), Z));
  }
  onKeyStatusChange(Z) {
    Z.mediaKeysSession.keyStatuses.forEach((ee, ae) => {
      this.log(`key status change "${ee}" for keyStatuses keyId: ${Hex.hexDump("buffer" in ae ? new Uint8Array(ae.buffer, ae.byteOffset, ae.byteLength) : new Uint8Array(ae))} session keyId: ${Hex.hexDump(new Uint8Array(Z.decryptdata.keyId || []))} uri: ${Z.decryptdata.uri}`), Z.keyStatus = ee;
    });
  }
  fetchServerCertificate(Z) {
    const ee = this.config, ae = ee.loader, ve = new ae(ee), ye = this.getServerCertificateUrl(Z);
    return ye ? (this.log(`Fetching server certificate for "${Z}"`), new Promise((be, Ye) => {
      const Qe = {
        responseType: "arraybuffer",
        url: ye
      }, Je = ee.certLoadPolicy.default, nt = {
        loadPolicy: Je,
        timeout: Je.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, st = {
        onSuccess: (ot, lt, ft, gt) => {
          be(ot.data);
        },
        onError: (ot, lt, ft, gt) => {
          Ye(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: ft,
            response: _objectSpread2({
              url: Qe.url,
              data: void 0
            }, ot)
          }, `"${Z}" certificate request failed (${ye}). Status: ${ot.code} (${ot.text})`));
        },
        onTimeout: (ot, lt, ft) => {
          Ye(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: ft,
            response: {
              url: Qe.url,
              data: void 0
            }
          }, `"${Z}" certificate request timed out (${ye})`));
        },
        onAbort: (ot, lt, ft) => {
          Ye(new Error("aborted"));
        }
      };
      ve.load(Qe, nt, st);
    })) : Promise.resolve();
  }
  setMediaKeysServerCertificate(Z, ee, ae) {
    return new Promise((ve, ye) => {
      Z.setServerCertificate(ae).then((be) => {
        this.log(`setServerCertificate ${be ? "success" : "not supported by CDM"} (${ae == null ? void 0 : ae.byteLength}) on "${ee}"`), ve(Z);
      }).catch((be) => {
        ye(new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error: be,
          fatal: !0
        }, be.message));
      });
    });
  }
  renewLicense(Z, ee) {
    return this.requestLicense(Z, new Uint8Array(ee)).then((ae) => this.updateKeySession(Z, new Uint8Array(ae)).catch((ve) => {
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED,
        error: ve,
        fatal: !0
      }, ve.message);
    }));
  }
  unpackPlayReadyKeyMessage(Z, ee) {
    const ae = String.fromCharCode.apply(null, new Uint16Array(ee.buffer));
    if (!ae.includes("PlayReadyKeyMessage"))
      return Z.setRequestHeader("Content-Type", "text/xml; charset=utf-8"), ee;
    const ve = new DOMParser().parseFromString(ae, "application/xml"), ye = ve.querySelectorAll("HttpHeader");
    if (ye.length > 0) {
      let nt;
      for (let st = 0, ot = ye.length; st < ot; st++) {
        var be, Ye;
        nt = ye[st];
        const lt = (be = nt.querySelector("name")) == null ? void 0 : be.textContent, ft = (Ye = nt.querySelector("value")) == null ? void 0 : Ye.textContent;
        lt && ft && Z.setRequestHeader(lt, ft);
      }
    }
    const Qe = ve.querySelector("Challenge"), Je = Qe == null ? void 0 : Qe.textContent;
    if (!Je)
      throw new Error("Cannot find <Challenge> in key message");
    return strToUtf8array(atob(Je));
  }
  setupLicenseXHR(Z, ee, ae, ve) {
    const ye = this.config.licenseXhrSetup;
    return ye ? Promise.resolve().then(() => {
      if (!ae.decryptdata)
        throw new Error("Key removed");
      return ye.call(this.hls, Z, ee, ae, ve);
    }).catch((be) => {
      if (!ae.decryptdata)
        throw be;
      return Z.open("POST", ee, !0), ye.call(this.hls, Z, ee, ae, ve);
    }).then((be) => (Z.readyState || Z.open("POST", ee, !0), {
      xhr: Z,
      licenseChallenge: be || ve
    })) : (Z.open("POST", ee, !0), Promise.resolve({
      xhr: Z,
      licenseChallenge: ve
    }));
  }
  requestLicense(Z, ee) {
    const ae = this.config.keyLoadPolicy.default;
    return new Promise((ve, ye) => {
      const be = this.getLicenseServerUrl(Z.keySystem);
      this.log(`Sending license request to URL: ${be}`);
      const Ye = new XMLHttpRequest();
      Ye.responseType = "arraybuffer", Ye.onreadystatechange = () => {
        if (!this.hls || !Z.mediaKeysSession)
          return ye(new Error("invalid state"));
        if (Ye.readyState === 4)
          if (Ye.status === 200) {
            this._requestLicenseFailureCount = 0;
            let Qe = Ye.response;
            this.log(`License received ${Qe instanceof ArrayBuffer ? Qe.byteLength : Qe}`);
            const Je = this.config.licenseResponseCallback;
            if (Je)
              try {
                Qe = Je.call(this.hls, Ye, be, Z);
              } catch (nt) {
                this.error(nt);
              }
            ve(Qe);
          } else {
            const Qe = ae.errorRetry, Je = Qe ? Qe.maxNumRetry : 0;
            if (this._requestLicenseFailureCount++, this._requestLicenseFailureCount > Je || Ye.status >= 400 && Ye.status < 500)
              ye(new EMEKeyError({
                type: ErrorTypes.KEY_SYSTEM_ERROR,
                details: ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: !0,
                networkDetails: Ye,
                response: {
                  url: be,
                  data: void 0,
                  code: Ye.status,
                  text: Ye.statusText
                }
              }, `License Request XHR failed (${be}). Status: ${Ye.status} (${Ye.statusText})`));
            else {
              const nt = Je - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${nt} attempts left`), this.requestLicense(Z, ee).then(ve, ye);
            }
          }
      }, Z.licenseXhr && Z.licenseXhr.readyState !== XMLHttpRequest.DONE && Z.licenseXhr.abort(), Z.licenseXhr = Ye, this.setupLicenseXHR(Ye, be, Z, ee).then(({
        xhr: Qe,
        licenseChallenge: Je
      }) => {
        Z.keySystem == KeySystems.PLAYREADY && (Je = this.unpackPlayReadyKeyMessage(Qe, Je)), Qe.send(Je);
      });
    });
  }
  onMediaAttached(Z, ee) {
    if (!this.config.emeEnabled)
      return;
    const ae = ee.media;
    this.media = ae, ae.addEventListener("encrypted", this.onMediaEncrypted), ae.addEventListener("waitingforkey", this.onWaitingForKey);
  }
  onMediaDetached() {
    const Z = this.media, ee = this.mediaKeySessions;
    Z && (Z.removeEventListener("encrypted", this.onMediaEncrypted), Z.removeEventListener("waitingforkey", this.onWaitingForKey), this.media = null), this._requestLicenseFailureCount = 0, this.setMediaKeysQueue = [], this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, LevelKey.clearKeyUriToKeyIdMap();
    const ae = ee.length;
    EMEController.CDMCleanupPromise = Promise.all(ee.map((ve) => this.removeSession(ve)).concat(Z == null ? void 0 : Z.setMediaKeys(null).catch((ve) => {
      this.log(`Could not clear media keys: ${ve}`);
    }))).then(() => {
      ae && (this.log("finished closing key sessions and clearing media keys"), ee.length = 0);
    }).catch((ve) => {
      this.log(`Could not close sessions and clear media keys: ${ve}`);
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(Z, {
    sessionKeys: ee
  }) {
    if (!(!ee || !this.config.emeEnabled) && !this.keyFormatPromise) {
      const ae = ee.reduce((ve, ye) => (ve.indexOf(ye.keyFormat) === -1 && ve.push(ye.keyFormat), ve), []);
      this.log(`Selecting key-system from session-keys ${ae.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(ae);
    }
  }
  removeSession(Z) {
    const {
      mediaKeysSession: ee,
      licenseXhr: ae
    } = Z;
    if (ee) {
      this.log(`Remove licenses and keys and close session ${ee.sessionId}`), Z._onmessage && (ee.removeEventListener("message", Z._onmessage), Z._onmessage = void 0), Z._onkeystatuseschange && (ee.removeEventListener("keystatuseschange", Z._onkeystatuseschange), Z._onkeystatuseschange = void 0), ae && ae.readyState !== XMLHttpRequest.DONE && ae.abort(), Z.mediaKeysSession = Z.decryptdata = Z.licenseXhr = void 0;
      const ve = this.mediaKeySessions.indexOf(Z);
      return ve > -1 && this.mediaKeySessions.splice(ve, 1), ee.remove().catch((ye) => {
        this.log(`Could not remove session: ${ye}`);
      }).then(() => ee.close()).catch((ye) => {
        this.log(`Could not close session: ${ye}`);
      });
    }
  }
}
EMEController.CDMCleanupPromise = void 0;
class EMEKeyError extends Error {
  constructor(Z, ee) {
    super(ee), this.data = void 0, Z.error || (Z.error = new Error(ee)), this.data = Z, Z.err = Z.error;
  }
}
var CmObjectType;
(function(ie) {
  ie.MANIFEST = "m", ie.AUDIO = "a", ie.VIDEO = "v", ie.MUXED = "av", ie.INIT = "i", ie.CAPTION = "c", ie.TIMED_TEXT = "tt", ie.KEY = "k", ie.OTHER = "o";
})(CmObjectType || (CmObjectType = {}));
var CmStreamingFormat;
(function(ie) {
  ie.DASH = "d", ie.HLS = "h", ie.SMOOTH = "s", ie.OTHER = "o";
})(CmStreamingFormat || (CmStreamingFormat = {}));
var CmcdHeaderField;
(function(ie) {
  ie.OBJECT = "CMCD-Object", ie.REQUEST = "CMCD-Request", ie.SESSION = "CMCD-Session", ie.STATUS = "CMCD-Status";
})(CmcdHeaderField || (CmcdHeaderField = {}));
const CmcdHeaderMap = {
  [CmcdHeaderField.OBJECT]: ["br", "d", "ot", "tb"],
  [CmcdHeaderField.REQUEST]: ["bl", "dl", "mtp", "nor", "nrr", "su"],
  [CmcdHeaderField.SESSION]: ["cid", "pr", "sf", "sid", "st", "v"],
  [CmcdHeaderField.STATUS]: ["bs", "rtp"]
};
class SfItem {
  constructor(Z, ee) {
    this.value = void 0, this.params = void 0, Array.isArray(Z) && (Z = Z.map((ae) => ae instanceof SfItem ? ae : new SfItem(ae))), this.value = Z, this.params = ee;
  }
}
class SfToken {
  constructor(Z) {
    this.description = void 0, this.description = Z;
  }
}
const DICT = "Dict";
function format(ie) {
  return Array.isArray(ie) ? JSON.stringify(ie) : ie instanceof Map ? "Map{}" : ie instanceof Set ? "Set{}" : typeof ie == "object" ? JSON.stringify(ie) : String(ie);
}
function throwError(ie, Z, ee, ae) {
  return new Error(`failed to ${ie} "${format(Z)}" as ${ee}`, {
    cause: ae
  });
}
const BARE_ITEM = "Bare Item", BOOLEAN = "Boolean", BYTES = "Byte Sequence", DECIMAL = "Decimal", INTEGER = "Integer";
function isInvalidInt(ie) {
  return ie < -999999999999999 || 999999999999999 < ie;
}
const STRING_REGEX = /[\x00-\x1f\x7f]+/, TOKEN = "Token", KEY = "Key";
function serializeError(ie, Z, ee) {
  return throwError("serialize", ie, Z, ee);
}
function serializeBoolean(ie) {
  if (typeof ie != "boolean")
    throw serializeError(ie, BOOLEAN);
  return ie ? "?1" : "?0";
}
function base64encode(ie) {
  return btoa(String.fromCharCode(...ie));
}
function serializeByteSequence(ie) {
  if (ArrayBuffer.isView(ie) === !1)
    throw serializeError(ie, BYTES);
  return `:${base64encode(ie)}:`;
}
function serializeInteger(ie) {
  if (isInvalidInt(ie))
    throw serializeError(ie, INTEGER);
  return ie.toString();
}
function serializeDate(ie) {
  return `@${serializeInteger(ie.getTime() / 1e3)}`;
}
function roundToEven(ie, Z) {
  if (ie < 0)
    return -roundToEven(-ie, Z);
  const ee = Math.pow(10, Z);
  if (Math.abs(ie * ee % 1 - 0.5) < Number.EPSILON) {
    const ve = Math.floor(ie * ee);
    return (ve % 2 === 0 ? ve : ve + 1) / ee;
  } else
    return Math.round(ie * ee) / ee;
}
function serializeDecimal(ie) {
  const Z = roundToEven(ie, 3);
  if (Math.floor(Math.abs(Z)).toString().length > 12)
    throw serializeError(ie, DECIMAL);
  const ee = Z.toString();
  return ee.includes(".") ? ee : `${ee}.0`;
}
const STRING = "String";
function serializeString(ie) {
  if (STRING_REGEX.test(ie))
    throw serializeError(ie, STRING);
  return `"${ie.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function symbolToStr(ie) {
  return ie.description || ie.toString().slice(7, -1);
}
function serializeToken(ie) {
  const Z = symbolToStr(ie);
  if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(Z) === !1)
    throw serializeError(Z, TOKEN);
  return Z;
}
function serializeBareItem(ie) {
  switch (typeof ie) {
    case "number":
      if (!isFiniteNumber(ie))
        throw serializeError(ie, BARE_ITEM);
      return Number.isInteger(ie) ? serializeInteger(ie) : serializeDecimal(ie);
    case "string":
      return serializeString(ie);
    case "symbol":
      return serializeToken(ie);
    case "boolean":
      return serializeBoolean(ie);
    case "object":
      if (ie instanceof Date)
        return serializeDate(ie);
      if (ie instanceof Uint8Array)
        return serializeByteSequence(ie);
      if (ie instanceof SfToken)
        return serializeToken(ie);
    default:
      throw serializeError(ie, BARE_ITEM);
  }
}
function serializeKey(ie) {
  if (/^[a-z*][a-z0-9\-_.*]*$/.test(ie) === !1)
    throw serializeError(ie, KEY);
  return ie;
}
function serializeParams(ie) {
  return ie == null ? "" : Object.entries(ie).map(([Z, ee]) => ee === !0 ? `;${serializeKey(Z)}` : `;${serializeKey(Z)}=${serializeBareItem(ee)}`).join("");
}
function serializeItem(ie) {
  return ie instanceof SfItem ? `${serializeBareItem(ie.value)}${serializeParams(ie.params)}` : serializeBareItem(ie);
}
function serializeInnerList(ie) {
  return `(${ie.value.map(serializeItem).join(" ")})${serializeParams(ie.params)}`;
}
function serializeDict(ie, Z = {
  whitespace: !0
}) {
  if (typeof ie != "object")
    throw serializeError(ie, DICT);
  const ee = ie instanceof Map ? ie.entries() : Object.entries(ie), ae = Z != null && Z.whitespace ? " " : "";
  return Array.from(ee).map(([ve, ye]) => {
    ye instanceof SfItem || (ye = new SfItem(ye));
    let be = serializeKey(ve);
    return ye.value === !0 ? be += serializeParams(ye.params) : (be += "=", Array.isArray(ye.value) ? be += serializeInnerList(ye) : be += serializeItem(ye)), be;
  }).join(`,${ae}`);
}
function encodeSfDict(ie, Z) {
  return serializeDict(ie, Z);
}
const isTokenField = (ie) => ie === "ot" || ie === "sf" || ie === "st", isValid = (ie) => typeof ie == "number" ? isFiniteNumber(ie) : ie != null && ie !== "" && ie !== !1;
function urlToRelativePath(ie, Z) {
  const ee = new URL(ie), ae = new URL(Z);
  if (ee.origin !== ae.origin)
    return ie;
  const ve = ee.pathname.split("/").slice(1), ye = ae.pathname.split("/").slice(1, -1);
  for (; ve[0] === ye[0]; )
    ve.shift(), ye.shift();
  for (; ye.length; )
    ye.shift(), ve.unshift("..");
  return ve.join("/");
}
function uuid() {
  try {
    return crypto.randomUUID();
  } catch {
    try {
      const Z = URL.createObjectURL(new Blob()), ee = Z.toString();
      return URL.revokeObjectURL(Z), ee.slice(ee.lastIndexOf("/") + 1);
    } catch {
      let ee = (/* @__PURE__ */ new Date()).getTime();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (ve) => {
        const ye = (ee + Math.random() * 16) % 16 | 0;
        return ee = Math.floor(ee / 16), (ve == "x" ? ye : ye & 3 | 8).toString(16);
      });
    }
  }
}
const toRounded = (ie) => Math.round(ie), toUrlSafe = (ie, Z) => (Z != null && Z.baseUrl && (ie = urlToRelativePath(ie, Z.baseUrl)), encodeURIComponent(ie)), toHundred = (ie) => toRounded(ie / 100) * 100, CmcdFormatters = {
  /**
   * Bitrate (kbps) rounded integer
   */
  br: toRounded,
  /**
   * Duration (milliseconds) rounded integer
   */
  d: toRounded,
  /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */
  bl: toHundred,
  /**
   * Deadline (milliseconds) rounded nearest 100ms
   */
  dl: toHundred,
  /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */
  mtp: toHundred,
  /**
   * Next Object Request URL encoded
   */
  nor: toUrlSafe,
  /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */
  rtp: toHundred,
  /**
   * Top Bitrate (kbps) rounded integer
   */
  tb: toRounded
};
function processCmcd(ie, Z) {
  const ee = {};
  if (ie == null || typeof ie != "object")
    return ee;
  const ae = Object.keys(ie).sort(), ve = _extends({}, CmcdFormatters, Z == null ? void 0 : Z.formatters), ye = Z == null ? void 0 : Z.filter;
  return ae.forEach((be) => {
    if (ye != null && ye(be))
      return;
    let Ye = ie[be];
    const Qe = ve[be];
    Qe && (Ye = Qe(Ye, Z)), !(be === "v" && Ye === 1) && (be == "pr" && Ye === 1 || isValid(Ye) && (isTokenField(be) && typeof Ye == "string" && (Ye = new SfToken(Ye)), ee[be] = Ye));
  }), ee;
}
function encodeCmcd(ie, Z = {}) {
  return ie ? encodeSfDict(processCmcd(ie, Z), _extends({
    whitespace: !1
  }, Z)) : "";
}
function toCmcdHeaders(ie, Z = {}) {
  if (!ie)
    return {};
  const ee = Object.entries(ie), ae = Object.entries(CmcdHeaderMap).concat(Object.entries((Z == null ? void 0 : Z.customHeaderMap) || {})), ve = ee.reduce((ye, be) => {
    var Ye, Qe;
    const [Je, nt] = be, st = ((Ye = ae.find((ot) => ot[1].includes(Je))) == null ? void 0 : Ye[0]) || CmcdHeaderField.REQUEST;
    return (Qe = ye[st]) != null || (ye[st] = {}), ye[st][Je] = nt, ye;
  }, {});
  return Object.entries(ve).reduce((ye, [be, Ye]) => (ye[be] = encodeCmcd(Ye, Z), ye), {});
}
function appendCmcdHeaders(ie, Z, ee) {
  return _extends(ie, toCmcdHeaders(Z, ee));
}
const CMCD_PARAM = "CMCD";
function toCmcdQuery(ie, Z = {}) {
  if (!ie)
    return "";
  const ee = encodeCmcd(ie, Z);
  return `${CMCD_PARAM}=${encodeURIComponent(ee)}`;
}
const REGEX = /CMCD=[^&#]+/;
function appendCmcdQuery(ie, Z, ee) {
  const ae = toCmcdQuery(Z, ee);
  if (!ae)
    return ie;
  if (REGEX.test(ie))
    return ie.replace(REGEX, ae);
  const ve = ie.includes("?") ? "&" : "?";
  return `${ie}${ve}${ae}`;
}
class CMCDController {
  // eslint-disable-line no-restricted-globals
  constructor(Z) {
    this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.includeKeys = void 0, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = () => {
      this.initialized && (this.starved = !0), this.buffering = !0;
    }, this.onPlaying = () => {
      this.initialized || (this.initialized = !0), this.buffering = !1;
    }, this.applyPlaylistData = (ve) => {
      try {
        this.apply(ve, {
          ot: CmObjectType.MANIFEST,
          su: !this.initialized
        });
      } catch (ye) {
        logger.warn("Could not generate manifest CMCD data.", ye);
      }
    }, this.applyFragmentData = (ve) => {
      try {
        const ye = ve.frag, be = this.hls.levels[ye.level], Ye = this.getObjectType(ye), Qe = {
          d: ye.duration * 1e3,
          ot: Ye
        };
        (Ye === CmObjectType.VIDEO || Ye === CmObjectType.AUDIO || Ye == CmObjectType.MUXED) && (Qe.br = be.bitrate / 1e3, Qe.tb = this.getTopBandwidth(Ye) / 1e3, Qe.bl = this.getBufferLength(Ye)), this.apply(ve, Qe);
      } catch (ye) {
        logger.warn("Could not generate segment CMCD data.", ye);
      }
    }, this.hls = Z;
    const ee = this.config = Z.config, {
      cmcd: ae
    } = ee;
    ae != null && (ee.pLoader = this.createPlaylistLoader(), ee.fLoader = this.createFragmentLoader(), this.sid = ae.sessionId || uuid(), this.cid = ae.contentId, this.useHeaders = ae.useHeaders === !0, this.includeKeys = ae.includeKeys, this.registerListeners());
  }
  registerListeners() {
    const Z = this.hls;
    Z.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.on(Events.MEDIA_DETACHED, this.onMediaDetached, this), Z.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const Z = this.hls;
    Z.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.off(Events.MEDIA_DETACHED, this.onMediaDetached, this), Z.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null, this.onWaiting = this.onPlaying = null;
  }
  onMediaAttached(Z, ee) {
    this.media = ee.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
  }
  onMediaDetached() {
    this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
  }
  onBufferCreated(Z, ee) {
    var ae, ve;
    this.audioBuffer = (ae = ee.tracks.audio) == null ? void 0 : ae.buffer, this.videoBuffer = (ve = ee.tracks.video) == null ? void 0 : ve.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var Z;
    return {
      v: 1,
      sf: CmStreamingFormat.HLS,
      sid: this.sid,
      cid: this.cid,
      pr: (Z = this.media) == null ? void 0 : Z.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1e3
    };
  }
  /**
   * Apply CMCD data to a request.
   */
  apply(Z, ee = {}) {
    _extends(ee, this.createData());
    const ae = ee.ot === CmObjectType.INIT || ee.ot === CmObjectType.VIDEO || ee.ot === CmObjectType.MUXED;
    this.starved && ae && (ee.bs = !0, ee.su = !0, this.starved = !1), ee.su == null && (ee.su = this.buffering);
    const {
      includeKeys: ve
    } = this;
    ve && (ee = Object.keys(ee).reduce((ye, be) => (ve.includes(be) && (ye[be] = ee[be]), ye), {})), this.useHeaders ? (Z.headers || (Z.headers = {}), appendCmcdHeaders(Z.headers, ee)) : Z.url = appendCmcdQuery(Z.url, ee);
  }
  /**
   * The CMCD object type.
   */
  getObjectType(Z) {
    const {
      type: ee
    } = Z;
    if (ee === "subtitle")
      return CmObjectType.TIMED_TEXT;
    if (Z.sn === "initSegment")
      return CmObjectType.INIT;
    if (ee === "audio")
      return CmObjectType.AUDIO;
    if (ee === "main")
      return this.hls.audioTracks.length ? CmObjectType.VIDEO : CmObjectType.MUXED;
  }
  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(Z) {
    let ee = 0, ae;
    const ve = this.hls;
    if (Z === CmObjectType.AUDIO)
      ae = ve.audioTracks;
    else {
      const ye = ve.maxAutoLevel, be = ye > -1 ? ye + 1 : ve.levels.length;
      ae = ve.levels.slice(0, be);
    }
    for (const ye of ae)
      ye.bitrate > ee && (ee = ye.bitrate);
    return ee > 0 ? ee : NaN;
  }
  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(Z) {
    const ee = this.hls.media, ae = Z === CmObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
    return !ae || !ee ? NaN : BufferHelper.bufferInfo(ae, ee.currentTime, this.config.maxBufferHole).len * 1e3;
  }
  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader: Z
    } = this.config, ee = this.applyPlaylistData, ae = Z || this.config.loader;
    return class {
      constructor(ye) {
        this.loader = void 0, this.loader = new ae(ye);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(ye, be, Ye) {
        ee(ye), this.loader.load(ye, be, Ye);
      }
    };
  }
  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader: Z
    } = this.config, ee = this.applyFragmentData, ae = Z || this.config.loader;
    return class {
      constructor(ye) {
        this.loader = void 0, this.loader = new ae(ye);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(ye, be, Ye) {
        ee(ye), this.loader.load(ye, be, Ye);
      }
    };
  }
}
const PATHWAY_PENALTY_DURATION_MS = 3e5;
class ContentSteeringController {
  constructor(Z) {
    this.hls = void 0, this.log = void 0, this.loader = null, this.uri = null, this.pathwayId = ".", this.pathwayPriority = null, this.timeToLoad = 300, this.reloadTimer = -1, this.updated = 0, this.started = !1, this.enabled = !0, this.levels = null, this.audioTracks = null, this.subtitleTracks = null, this.penalizedPathways = {}, this.hls = Z, this.log = logger.log.bind(logger, "[content-steering]:"), this.registerListeners();
  }
  registerListeners() {
    const Z = this.hls;
    Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this), Z.on(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const Z = this.hls;
    Z && (Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this), Z.off(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.off(Events.ERROR, this.onError, this));
  }
  startLoad() {
    if (this.started = !0, this.clearTimeout(), this.enabled && this.uri) {
      if (this.updated) {
        const Z = this.timeToLoad * 1e3 - (performance.now() - this.updated);
        if (Z > 0) {
          this.scheduleRefresh(this.uri, Z);
          return;
        }
      }
      this.loadSteeringManifest(this.uri);
    }
  }
  stopLoad() {
    this.started = !1, this.loader && (this.loader.destroy(), this.loader = null), this.clearTimeout();
  }
  clearTimeout() {
    this.reloadTimer !== -1 && (self.clearTimeout(this.reloadTimer), this.reloadTimer = -1);
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.hls = null, this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(Z) {
    const ee = this.levels;
    ee && (this.levels = ee.filter((ae) => ae !== Z));
  }
  onManifestLoading() {
    this.stopLoad(), this.enabled = !0, this.timeToLoad = 300, this.updated = 0, this.uri = null, this.pathwayId = ".", this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(Z, ee) {
    const {
      contentSteering: ae
    } = ee;
    ae !== null && (this.pathwayId = ae.pathwayId, this.uri = ae.uri, this.started && this.startLoad());
  }
  onManifestParsed(Z, ee) {
    this.audioTracks = ee.audioTracks, this.subtitleTracks = ee.subtitleTracks;
  }
  onError(Z, ee) {
    const {
      errorAction: ae
    } = ee;
    if ((ae == null ? void 0 : ae.action) === NetworkErrorAction.SendAlternateToPenaltyBox && ae.flags === ErrorActionFlags.MoveAllAlternatesMatchingHost) {
      const ve = this.levels;
      let ye = this.pathwayPriority, be = this.pathwayId;
      if (ee.context) {
        const {
          groupId: Ye,
          pathwayId: Qe,
          type: Je
        } = ee.context;
        Ye && ve ? be = this.getPathwayForGroupId(Ye, Je, be) : Qe && (be = Qe);
      }
      be in this.penalizedPathways || (this.penalizedPathways[be] = performance.now()), !ye && ve && (ye = ve.reduce((Ye, Qe) => (Ye.indexOf(Qe.pathwayId) === -1 && Ye.push(Qe.pathwayId), Ye), [])), ye && ye.length > 1 && (this.updatePathwayPriority(ye), ae.resolved = this.pathwayId !== be), ae.resolved || logger.warn(`Could not resolve ${ee.details} ("${ee.error.message}") with content-steering for Pathway: ${be} levels: ${ve && ve.length} priorities: ${JSON.stringify(ye)} penalized: ${JSON.stringify(this.penalizedPathways)}`);
    }
  }
  filterParsedLevels(Z) {
    this.levels = Z;
    let ee = this.getLevelsForPathway(this.pathwayId);
    if (ee.length === 0) {
      const ae = Z[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${ae}"`), ee = this.getLevelsForPathway(ae), this.pathwayId = ae;
    }
    return ee.length !== Z.length ? (this.log(`Found ${ee.length}/${Z.length} levels in Pathway "${this.pathwayId}"`), ee) : Z;
  }
  getLevelsForPathway(Z) {
    return this.levels === null ? [] : this.levels.filter((ee) => Z === ee.pathwayId);
  }
  updatePathwayPriority(Z) {
    this.pathwayPriority = Z;
    let ee;
    const ae = this.penalizedPathways, ve = performance.now();
    Object.keys(ae).forEach((ye) => {
      ve - ae[ye] > PATHWAY_PENALTY_DURATION_MS && delete ae[ye];
    });
    for (let ye = 0; ye < Z.length; ye++) {
      const be = Z[ye];
      if (be in ae)
        continue;
      if (be === this.pathwayId)
        return;
      const Ye = this.hls.nextLoadLevel, Qe = this.hls.levels[Ye];
      if (ee = this.getLevelsForPathway(be), ee.length > 0) {
        this.log(`Setting Pathway to "${be}"`), this.pathwayId = be, reassignFragmentLevelIndexes(ee), this.hls.trigger(Events.LEVELS_UPDATED, {
          levels: ee
        });
        const Je = this.hls.levels[Ye];
        Qe && Je && this.levels && (Je.attrs["STABLE-VARIANT-ID"] !== Qe.attrs["STABLE-VARIANT-ID"] && Je.bitrate !== Qe.bitrate && this.log(`Unstable Pathways change from bitrate ${Qe.bitrate} to ${Je.bitrate}`), this.hls.nextLoadLevel = Ye);
        break;
      }
    }
  }
  getPathwayForGroupId(Z, ee, ae) {
    const ve = this.getLevelsForPathway(ae).concat(this.levels || []);
    for (let ye = 0; ye < ve.length; ye++)
      if (ee === PlaylistContextType.AUDIO_TRACK && ve[ye].hasAudioGroup(Z) || ee === PlaylistContextType.SUBTITLE_TRACK && ve[ye].hasSubtitleGroup(Z))
        return ve[ye].pathwayId;
    return ae;
  }
  clonePathways(Z) {
    const ee = this.levels;
    if (!ee)
      return;
    const ae = {}, ve = {};
    Z.forEach((ye) => {
      const {
        ID: be,
        "BASE-ID": Ye,
        "URI-REPLACEMENT": Qe
      } = ye;
      if (ee.some((nt) => nt.pathwayId === be))
        return;
      const Je = this.getLevelsForPathway(Ye).map((nt) => {
        const st = new AttrList(nt.attrs);
        st["PATHWAY-ID"] = be;
        const ot = st.AUDIO && `${st.AUDIO}_clone_${be}`, lt = st.SUBTITLES && `${st.SUBTITLES}_clone_${be}`;
        ot && (ae[st.AUDIO] = ot, st.AUDIO = ot), lt && (ve[st.SUBTITLES] = lt, st.SUBTITLES = lt);
        const ft = performUriReplacement(nt.uri, st["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", Qe), gt = new Level({
          attrs: st,
          audioCodec: nt.audioCodec,
          bitrate: nt.bitrate,
          height: nt.height,
          name: nt.name,
          url: ft,
          videoCodec: nt.videoCodec,
          width: nt.width
        });
        if (nt.audioGroups)
          for (let ct = 1; ct < nt.audioGroups.length; ct++)
            gt.addGroupId("audio", `${nt.audioGroups[ct]}_clone_${be}`);
        if (nt.subtitleGroups)
          for (let ct = 1; ct < nt.subtitleGroups.length; ct++)
            gt.addGroupId("text", `${nt.subtitleGroups[ct]}_clone_${be}`);
        return gt;
      });
      ee.push(...Je), cloneRenditionGroups(this.audioTracks, ae, Qe, be), cloneRenditionGroups(this.subtitleTracks, ve, Qe, be);
    });
  }
  loadSteeringManifest(Z) {
    const ee = this.hls.config, ae = ee.loader;
    this.loader && this.loader.destroy(), this.loader = new ae(ee);
    let ve;
    try {
      ve = new self.URL(Z);
    } catch {
      this.enabled = !1, this.log(`Failed to parse Steering Manifest URI: ${Z}`);
      return;
    }
    if (ve.protocol !== "data:") {
      const nt = (this.hls.bandwidthEstimate || ee.abrEwmaDefaultEstimate) | 0;
      ve.searchParams.set("_HLS_pathway", this.pathwayId), ve.searchParams.set("_HLS_throughput", "" + nt);
    }
    const ye = {
      responseType: "json",
      url: ve.href
    }, be = ee.steeringManifestLoadPolicy.default, Ye = be.errorRetry || be.timeoutRetry || {}, Qe = {
      loadPolicy: be,
      timeout: be.maxLoadTimeMs,
      maxRetry: Ye.maxNumRetry || 0,
      retryDelay: Ye.retryDelayMs || 0,
      maxRetryDelay: Ye.maxRetryDelayMs || 0
    }, Je = {
      onSuccess: (nt, st, ot, lt) => {
        this.log(`Loaded steering manifest: "${ve}"`);
        const ft = nt.data;
        if (ft.VERSION !== 1) {
          this.log(`Steering VERSION ${ft.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now(), this.timeToLoad = ft.TTL;
        const {
          "RELOAD-URI": gt,
          "PATHWAY-CLONES": ct,
          "PATHWAY-PRIORITY": _r
        } = ft;
        if (gt)
          try {
            this.uri = new self.URL(gt, ve).href;
          } catch {
            this.enabled = !1, this.log(`Failed to parse Steering Manifest RELOAD-URI: ${gt}`);
            return;
          }
        this.scheduleRefresh(this.uri || ot.url), ct && this.clonePathways(ct);
        const Kr = {
          steeringManifest: ft,
          url: ve.toString()
        };
        this.hls.trigger(Events.STEERING_MANIFEST_LOADED, Kr), _r && this.updatePathwayPriority(_r);
      },
      onError: (nt, st, ot, lt) => {
        if (this.log(`Error loading steering manifest: ${nt.code} ${nt.text} (${st.url})`), this.stopLoad(), nt.code === 410) {
          this.enabled = !1, this.log(`Steering manifest ${st.url} no longer available`);
          return;
        }
        let ft = this.timeToLoad * 1e3;
        if (nt.code === 429) {
          const gt = this.loader;
          if (typeof (gt == null ? void 0 : gt.getResponseHeader) == "function") {
            const ct = gt.getResponseHeader("Retry-After");
            ct && (ft = parseFloat(ct) * 1e3);
          }
          this.log(`Steering manifest ${st.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || st.url, ft);
      },
      onTimeout: (nt, st, ot) => {
        this.log(`Timeout loading steering manifest (${st.url})`), this.scheduleRefresh(this.uri || st.url);
      }
    };
    this.log(`Requesting steering manifest: ${ve}`), this.loader.load(ye, Qe, Je);
  }
  scheduleRefresh(Z, ee = this.timeToLoad * 1e3) {
    this.clearTimeout(), this.reloadTimer = self.setTimeout(() => {
      var ae;
      const ve = (ae = this.hls) == null ? void 0 : ae.media;
      if (ve && !ve.ended) {
        this.loadSteeringManifest(Z);
        return;
      }
      this.scheduleRefresh(Z, this.timeToLoad * 1e3);
    }, ee);
  }
}
function cloneRenditionGroups(ie, Z, ee, ae) {
  ie && Object.keys(Z).forEach((ve) => {
    const ye = ie.filter((be) => be.groupId === ve).map((be) => {
      const Ye = _extends({}, be);
      return Ye.details = void 0, Ye.attrs = new AttrList(Ye.attrs), Ye.url = Ye.attrs.URI = performUriReplacement(be.url, be.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", ee), Ye.groupId = Ye.attrs["GROUP-ID"] = Z[ve], Ye.attrs["PATHWAY-ID"] = ae, Ye;
    });
    ie.push(...ye);
  });
}
function performUriReplacement(ie, Z, ee, ae) {
  const {
    HOST: ve,
    PARAMS: ye,
    [ee]: be
  } = ae;
  let Ye;
  Z && (Ye = be == null ? void 0 : be[Z], Ye && (ie = Ye));
  const Qe = new self.URL(ie);
  return ve && !Ye && (Qe.host = ve), ye && Object.keys(ye).sort().forEach((Je) => {
    Je && Qe.searchParams.set(Je, ye[Je]);
  }), Qe.href;
}
const AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/im;
class XhrLoader {
  constructor(Z) {
    this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = null, this.loader = null, this.stats = void 0, this.xhrSetup = Z && Z.xhrSetup || null, this.stats = new LoadStats(), this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null, this.context = null, this.xhrSetup = null, this.stats = null;
  }
  abortInternal() {
    const Z = this.loader;
    self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), Z && (Z.onreadystatechange = null, Z.onprogress = null, Z.readyState !== 4 && (this.stats.aborted = !0, Z.abort()));
  }
  abort() {
    var Z;
    this.abortInternal(), (Z = this.callbacks) != null && Z.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
  }
  load(Z, ee, ae) {
    if (this.stats.loading.start)
      throw new Error("Loader can only be used once.");
    this.stats.loading.start = self.performance.now(), this.context = Z, this.config = ee, this.callbacks = ae, this.loadInternal();
  }
  loadInternal() {
    const {
      config: Z,
      context: ee
    } = this;
    if (!Z || !ee)
      return;
    const ae = this.loader = new self.XMLHttpRequest(), ve = this.stats;
    ve.loading.first = 0, ve.loaded = 0, ve.aborted = !1;
    const ye = this.xhrSetup;
    ye ? Promise.resolve().then(() => {
      if (!this.stats.aborted)
        return ye(ae, ee.url);
    }).catch((be) => (ae.open("GET", ee.url, !0), ye(ae, ee.url))).then(() => {
      this.stats.aborted || this.openAndSendXhr(ae, ee, Z);
    }).catch((be) => {
      this.callbacks.onError({
        code: ae.status,
        text: be.message
      }, ee, ae, ve);
    }) : this.openAndSendXhr(ae, ee, Z);
  }
  openAndSendXhr(Z, ee, ae) {
    Z.readyState || Z.open("GET", ee.url, !0);
    const ve = ee.headers, {
      maxTimeToFirstByteMs: ye,
      maxLoadTimeMs: be
    } = ae.loadPolicy;
    if (ve)
      for (const Ye in ve)
        Z.setRequestHeader(Ye, ve[Ye]);
    ee.rangeEnd && Z.setRequestHeader("Range", "bytes=" + ee.rangeStart + "-" + (ee.rangeEnd - 1)), Z.onreadystatechange = this.readystatechange.bind(this), Z.onprogress = this.loadprogress.bind(this), Z.responseType = ee.responseType, self.clearTimeout(this.requestTimeout), ae.timeout = ye && isFiniteNumber(ye) ? ye : be, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), ae.timeout), Z.send();
  }
  readystatechange() {
    const {
      context: Z,
      loader: ee,
      stats: ae
    } = this;
    if (!Z || !ee)
      return;
    const ve = ee.readyState, ye = this.config;
    if (!ae.aborted && ve >= 2 && (ae.loading.first === 0 && (ae.loading.first = Math.max(self.performance.now(), ae.loading.start), ye.timeout !== ye.loadPolicy.maxLoadTimeMs && (self.clearTimeout(this.requestTimeout), ye.timeout = ye.loadPolicy.maxLoadTimeMs, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), ye.loadPolicy.maxLoadTimeMs - (ae.loading.first - ae.loading.start)))), ve === 4)) {
      self.clearTimeout(this.requestTimeout), ee.onreadystatechange = null, ee.onprogress = null;
      const be = ee.status, Ye = ee.responseType !== "text";
      if (be >= 200 && be < 300 && (Ye && ee.response || ee.responseText !== null)) {
        ae.loading.end = Math.max(self.performance.now(), ae.loading.first);
        const Qe = Ye ? ee.response : ee.responseText, Je = ee.responseType === "arraybuffer" ? Qe.byteLength : Qe.length;
        if (ae.loaded = ae.total = Je, ae.bwEstimate = ae.total * 8e3 / (ae.loading.end - ae.loading.first), !this.callbacks)
          return;
        const nt = this.callbacks.onProgress;
        if (nt && nt(ae, Z, Qe, ee), !this.callbacks)
          return;
        const st = {
          url: ee.responseURL,
          data: Qe,
          code: be
        };
        this.callbacks.onSuccess(st, ae, Z, ee);
      } else {
        const Qe = ye.loadPolicy.errorRetry, Je = ae.retry, nt = {
          url: Z.url,
          data: void 0,
          code: be
        };
        shouldRetry(Qe, Je, !1, nt) ? this.retry(Qe) : (logger.error(`${be} while loading ${Z.url}`), this.callbacks.onError({
          code: be,
          text: ee.statusText
        }, Z, ee, ae));
      }
    }
  }
  loadtimeout() {
    var Z;
    const ee = (Z = this.config) == null ? void 0 : Z.loadPolicy.timeoutRetry, ae = this.stats.retry;
    if (shouldRetry(ee, ae, !0))
      this.retry(ee);
    else {
      var ve;
      logger.warn(`timeout while loading ${(ve = this.context) == null ? void 0 : ve.url}`);
      const ye = this.callbacks;
      ye && (this.abortInternal(), ye.onTimeout(this.stats, this.context, this.loader));
    }
  }
  retry(Z) {
    const {
      context: ee,
      stats: ae
    } = this;
    this.retryDelay = getRetryDelay(Z, ae.retry), ae.retry++, logger.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${ee == null ? void 0 : ee.url}, retrying ${ae.retry}/${Z.maxNumRetry} in ${this.retryDelay}ms`), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(Z) {
    const ee = this.stats;
    ee.loaded = Z.loaded, Z.lengthComputable && (ee.total = Z.total);
  }
  getCacheAge() {
    let Z = null;
    if (this.loader && AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())) {
      const ee = this.loader.getResponseHeader("age");
      Z = ee ? parseFloat(ee) : null;
    }
    return Z;
  }
  getResponseHeader(Z) {
    return this.loader && new RegExp(`^${Z}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders()) ? this.loader.getResponseHeader(Z) : null;
  }
}
function fetchSupported() {
  if (
    // @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request
  )
    try {
      return new self.ReadableStream({}), !0;
    } catch {
    }
  return !1;
}
const BYTERANGE = /(\d+)-(\d+)\/(\d+)/;
class FetchLoader {
  constructor(Z) {
    this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = null, this.response = null, this.controller = void 0, this.context = null, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = Z.fetchSetup || getRequest, this.controller = new self.AbortController(), this.stats = new LoadStats();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null, this.abortInternal(), this.response = null, this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    this.controller && !this.stats.loading.end && (this.stats.aborted = !0, this.controller.abort());
  }
  abort() {
    var Z;
    this.abortInternal(), (Z = this.callbacks) != null && Z.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
  }
  load(Z, ee, ae) {
    const ve = this.stats;
    if (ve.loading.start)
      throw new Error("Loader can only be used once.");
    ve.loading.start = self.performance.now();
    const ye = getRequestParameters(Z, this.controller.signal), be = ae.onProgress, Ye = Z.responseType === "arraybuffer", Qe = Ye ? "byteLength" : "length", {
      maxTimeToFirstByteMs: Je,
      maxLoadTimeMs: nt
    } = ee.loadPolicy;
    this.context = Z, this.config = ee, this.callbacks = ae, this.request = this.fetchSetup(Z, ye), self.clearTimeout(this.requestTimeout), ee.timeout = Je && isFiniteNumber(Je) ? Je : nt, this.requestTimeout = self.setTimeout(() => {
      this.abortInternal(), ae.onTimeout(ve, Z, this.response);
    }, ee.timeout), self.fetch(this.request).then((st) => {
      this.response = this.loader = st;
      const ot = Math.max(self.performance.now(), ve.loading.start);
      if (self.clearTimeout(this.requestTimeout), ee.timeout = nt, this.requestTimeout = self.setTimeout(() => {
        this.abortInternal(), ae.onTimeout(ve, Z, this.response);
      }, nt - (ot - ve.loading.start)), !st.ok) {
        const {
          status: lt,
          statusText: ft
        } = st;
        throw new FetchError(ft || "fetch, bad network response", lt, st);
      }
      return ve.loading.first = ot, ve.total = getContentLength(st.headers) || ve.total, be && isFiniteNumber(ee.highWaterMark) ? this.loadProgressively(st, ve, Z, ee.highWaterMark, be) : Ye ? st.arrayBuffer() : Z.responseType === "json" ? st.json() : st.text();
    }).then((st) => {
      const ot = this.response;
      if (!ot)
        throw new Error("loader destroyed");
      self.clearTimeout(this.requestTimeout), ve.loading.end = Math.max(self.performance.now(), ve.loading.first);
      const lt = st[Qe];
      lt && (ve.loaded = ve.total = lt);
      const ft = {
        url: ot.url,
        data: st,
        code: ot.status
      };
      be && !isFiniteNumber(ee.highWaterMark) && be(ve, Z, st, ot), ae.onSuccess(ft, ve, Z, ot);
    }).catch((st) => {
      if (self.clearTimeout(this.requestTimeout), ve.aborted)
        return;
      const ot = st && st.code || 0, lt = st ? st.message : null;
      ae.onError({
        code: ot,
        text: lt
      }, Z, st ? st.details : null, ve);
    });
  }
  getCacheAge() {
    let Z = null;
    if (this.response) {
      const ee = this.response.headers.get("age");
      Z = ee ? parseFloat(ee) : null;
    }
    return Z;
  }
  getResponseHeader(Z) {
    return this.response ? this.response.headers.get(Z) : null;
  }
  loadProgressively(Z, ee, ae, ve = 0, ye) {
    const be = new ChunkCache(), Ye = Z.body.getReader(), Qe = () => Ye.read().then((Je) => {
      if (Je.done)
        return be.dataLength && ye(ee, ae, be.flush(), Z), Promise.resolve(new ArrayBuffer(0));
      const nt = Je.value, st = nt.length;
      return ee.loaded += st, st < ve || be.dataLength ? (be.push(nt), be.dataLength >= ve && ye(ee, ae, be.flush(), Z)) : ye(ee, ae, nt, Z), Qe();
    }).catch(() => Promise.reject());
    return Qe();
  }
}
function getRequestParameters(ie, Z) {
  const ee = {
    method: "GET",
    mode: "cors",
    credentials: "same-origin",
    signal: Z,
    headers: new self.Headers(_extends({}, ie.headers))
  };
  return ie.rangeEnd && ee.headers.set("Range", "bytes=" + ie.rangeStart + "-" + String(ie.rangeEnd - 1)), ee;
}
function getByteRangeLength(ie) {
  const Z = BYTERANGE.exec(ie);
  if (Z)
    return parseInt(Z[2]) - parseInt(Z[1]) + 1;
}
function getContentLength(ie) {
  const Z = ie.get("Content-Range");
  if (Z) {
    const ae = getByteRangeLength(Z);
    if (isFiniteNumber(ae))
      return ae;
  }
  const ee = ie.get("Content-Length");
  if (ee)
    return parseInt(ee);
}
function getRequest(ie, Z) {
  return new self.Request(ie.url, Z);
}
class FetchError extends Error {
  constructor(Z, ee, ae) {
    super(Z), this.code = void 0, this.details = void 0, this.code = ee, this.details = ae;
  }
}
const WHITESPACE_CHAR = /\s/, Cues = {
  newCue(ie, Z, ee, ae) {
    const ve = [];
    let ye, be, Ye, Qe, Je;
    const nt = self.VTTCue || self.TextTrackCue;
    for (let ot = 0; ot < ae.rows.length; ot++)
      if (ye = ae.rows[ot], Ye = !0, Qe = 0, Je = "", !ye.isEmpty()) {
        var st;
        for (let gt = 0; gt < ye.chars.length; gt++)
          WHITESPACE_CHAR.test(ye.chars[gt].uchar) && Ye ? Qe++ : (Je += ye.chars[gt].uchar, Ye = !1);
        ye.cueStartTime = Z, Z === ee && (ee += 1e-4), Qe >= 16 ? Qe-- : Qe++;
        const lt = fixLineBreaks(Je.trim()), ft = generateCueId(Z, ee, lt);
        ie != null && (st = ie.cues) != null && st.getCueById(ft) || (be = new nt(Z, ee, lt), be.id = ft, be.line = ot + 1, be.align = "left", be.position = 10 + Math.min(80, Math.floor(Qe * 8 / 32) * 10), ve.push(be));
      }
    return ie && ve.length && (ve.sort((ot, lt) => ot.line === "auto" || lt.line === "auto" ? 0 : ot.line > 8 && lt.line > 8 ? lt.line - ot.line : ot.line - lt.line), ve.forEach((ot) => addCueToTrack(ie, ot))), ve;
  }
}, defaultLoadPolicy = {
  maxTimeToFirstByteMs: 8e3,
  maxLoadTimeMs: 2e4,
  timeoutRetry: null,
  errorRetry: null
}, hlsDefaultConfig = _objectSpread2(_objectSpread2({
  autoStartLoad: !0,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: void 0,
  // used by stream-controller
  debug: !1,
  // used by logger
  capLevelOnFPSDrop: !1,
  // used by fps-controller
  capLevelToPlayerSize: !1,
  // used by cap-level-controller
  ignoreDevicePixelRatio: !1,
  // used by cap-level-controller
  preferManagedMediaSource: !0,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: 1 / 0,
  // used by buffer-controller
  frontBufferFlushThreshold: 1 / 0,
  maxBufferSize: 60 * 1e3 * 1e3,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller
  highBufferWatchdogPeriod: 2,
  // used by stream-controller
  nudgeOffset: 0.1,
  // used by stream-controller
  nudgeMaxRetry: 3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveMaxLatencyDurationCount: 1 / 0,
  // used by latency-controller
  liveSyncDuration: void 0,
  // used by latency-controller
  liveMaxLatencyDuration: void 0,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: !1,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: !0,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: !0,
  // used by decrypter
  startLevel: void 0,
  // used by level-controller
  startFragPrefetch: !1,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5e3,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  loader: XhrLoader,
  // loader: FetchLoader,
  fLoader: void 0,
  // used by fragment-loader
  pLoader: void 0,
  // used by playlist-loader
  xhrSetup: void 0,
  // used by xhr-loader
  licenseXhrSetup: void 0,
  // used by eme-controller
  licenseResponseCallback: void 0,
  // used by eme-controller
  abrController: AbrController,
  bufferController: BufferController,
  capLevelController: CapLevelController,
  errorController: ErrorController,
  fpsController: FPSController,
  stretchShortVideoTrack: !1,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: !0,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: !1,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: !1,
  // used by eme-controller
  widevineLicenseUrl: void 0,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess,
  // used by eme-controller
  testBandwidth: !0,
  progressive: !1,
  lowLatencyMode: !0,
  cmcd: void 0,
  enableDateRangeMetadataCues: !0,
  enableEmsgMetadataCues: !0,
  enableID3MetadataCues: !0,
  useMediaCapabilities: !0,
  certLoadPolicy: {
    default: defaultLoadPolicy
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8e3,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 12e4,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 1e4,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1e3,
  manifestLoadingMaxRetryTimeout: 64e3,
  levelLoadingTimeOut: 1e4,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1e3,
  levelLoadingMaxRetryTimeout: 64e3,
  fragLoadingTimeOut: 2e4,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1e3,
  fragLoadingMaxRetryTimeout: 64e3
}, timelineConfig()), {}, {
  subtitleStreamController: SubtitleStreamController,
  subtitleTrackController: SubtitleTrackController,
  timelineController: TimelineController,
  audioStreamController: AudioStreamController,
  audioTrackController: AudioTrackController,
  emeController: EMEController,
  cmcdController: CMCDController,
  contentSteeringController: ContentSteeringController
});
function timelineConfig() {
  return {
    cueHandler: Cues,
    // used by timeline-controller
    enableWebVTT: !0,
    // used by timeline-controller
    enableIMSC1: !0,
    // used by timeline-controller
    enableCEA708Captions: !0,
    // used by timeline-controller
    captionsTextTrack1Label: "English",
    // used by timeline-controller
    captionsTextTrack1LanguageCode: "en",
    // used by timeline-controller
    captionsTextTrack2Label: "Spanish",
    // used by timeline-controller
    captionsTextTrack2LanguageCode: "es",
    // used by timeline-controller
    captionsTextTrack3Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack3LanguageCode: "",
    // used by timeline-controller
    captionsTextTrack4Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack4LanguageCode: "",
    // used by timeline-controller
    renderTextTracksNatively: !0
  };
}
function mergeConfig(ie, Z) {
  if ((Z.liveSyncDurationCount || Z.liveMaxLatencyDurationCount) && (Z.liveSyncDuration || Z.liveMaxLatencyDuration))
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  if (Z.liveMaxLatencyDurationCount !== void 0 && (Z.liveSyncDurationCount === void 0 || Z.liveMaxLatencyDurationCount <= Z.liveSyncDurationCount))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  if (Z.liveMaxLatencyDuration !== void 0 && (Z.liveSyncDuration === void 0 || Z.liveMaxLatencyDuration <= Z.liveSyncDuration))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  const ee = deepCpy(ie), ae = ["manifest", "level", "frag"], ve = ["TimeOut", "MaxRetry", "RetryDelay", "MaxRetryTimeout"];
  return ae.forEach((ye) => {
    const be = `${ye === "level" ? "playlist" : ye}LoadPolicy`, Ye = Z[be] === void 0, Qe = [];
    ve.forEach((Je) => {
      const nt = `${ye}Loading${Je}`, st = Z[nt];
      if (st !== void 0 && Ye) {
        Qe.push(nt);
        const ot = ee[be].default;
        switch (Z[be] = {
          default: ot
        }, Je) {
          case "TimeOut":
            ot.maxLoadTimeMs = st, ot.maxTimeToFirstByteMs = st;
            break;
          case "MaxRetry":
            ot.errorRetry.maxNumRetry = st, ot.timeoutRetry.maxNumRetry = st;
            break;
          case "RetryDelay":
            ot.errorRetry.retryDelayMs = st, ot.timeoutRetry.retryDelayMs = st;
            break;
          case "MaxRetryTimeout":
            ot.errorRetry.maxRetryDelayMs = st, ot.timeoutRetry.maxRetryDelayMs = st;
            break;
        }
      }
    }), Qe.length && logger.warn(`hls.js config: "${Qe.join('", "')}" setting(s) are deprecated, use "${be}": ${JSON.stringify(Z[be])}`);
  }), _objectSpread2(_objectSpread2({}, ee), Z);
}
function deepCpy(ie) {
  return ie && typeof ie == "object" ? Array.isArray(ie) ? ie.map(deepCpy) : Object.keys(ie).reduce((Z, ee) => (Z[ee] = deepCpy(ie[ee]), Z), {}) : ie;
}
function enableStreamingMode(ie) {
  const Z = ie.loader;
  Z !== FetchLoader && Z !== XhrLoader ? (logger.log("[config]: Custom loader detected, cannot enable progressive streaming"), ie.progressive = !1) : fetchSupported() && (ie.loader = FetchLoader, ie.progressive = !0, ie.enableSoftwareAES = !0, logger.log("[config]: Progressive streaming enabled, using FetchLoader"));
}
let chromeOrFirefox;
class LevelController extends BasePlaylistController {
  constructor(Z, ee) {
    super(Z, "[level-controller]"), this._levels = [], this._firstLevel = -1, this._maxAutoLevel = -1, this._startLevel = void 0, this.currentLevel = null, this.currentLevelIndex = -1, this.manualLevelIndex = -1, this.steering = void 0, this.onParsedComplete = void 0, this.steering = ee, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this), Z.on(Events.LEVEL_LOADED, this.onLevelLoaded, this), Z.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this), Z.on(Events.FRAG_BUFFERED, this.onFragBuffered, this), Z.on(Events.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this), Z.off(Events.LEVEL_LOADED, this.onLevelLoaded, this), Z.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this), Z.off(Events.FRAG_BUFFERED, this.onFragBuffered, this), Z.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners(), this.steering = null, this.resetLevels(), super.destroy();
  }
  stopLoad() {
    this._levels.forEach((ee) => {
      ee.loadError = 0, ee.fragmentError = 0;
    }), super.stopLoad();
  }
  resetLevels() {
    this._startLevel = void 0, this.manualLevelIndex = -1, this.currentLevelIndex = -1, this.currentLevel = null, this._levels = [], this._maxAutoLevel = -1;
  }
  onManifestLoading(Z, ee) {
    this.resetLevels();
  }
  onManifestLoaded(Z, ee) {
    const ae = this.hls.config.preferManagedMediaSource, ve = [], ye = {}, be = {};
    let Ye = !1, Qe = !1, Je = !1;
    ee.levels.forEach((nt) => {
      var st, ot;
      const lt = nt.attrs;
      let {
        audioCodec: ft,
        videoCodec: gt
      } = nt;
      ((st = ft) == null ? void 0 : st.indexOf("mp4a.40.34")) !== -1 && (chromeOrFirefox || (chromeOrFirefox = /chrome|firefox/i.test(navigator.userAgent)), chromeOrFirefox && (nt.audioCodec = ft = void 0)), ft && (nt.audioCodec = ft = getCodecCompatibleName(ft, ae)), ((ot = gt) == null ? void 0 : ot.indexOf("avc1")) === 0 && (gt = nt.videoCodec = convertAVC1ToAVCOTI(gt));
      const {
        width: ct,
        height: _r,
        unknownCodecs: Kr
      } = nt;
      if (Ye || (Ye = !!(ct && _r)), Qe || (Qe = !!gt), Je || (Je = !!ft), Kr != null && Kr.length || ft && !areCodecsMediaSourceSupported(ft, "audio", ae) || gt && !areCodecsMediaSourceSupported(gt, "video", ae))
        return;
      const {
        CODECS: Xr,
        "FRAME-RATE": Jr,
        "HDCP-LEVEL": ei,
        "PATHWAY-ID": si,
        RESOLUTION: ri,
        "VIDEO-RANGE": ai
      } = lt, pi = `${`${si || "."}-`}${nt.bitrate}-${ri}-${Jr}-${Xr}-${ai}-${ei}`;
      if (ye[pi])
        if (ye[pi].uri !== nt.url && !nt.attrs["PATHWAY-ID"]) {
          const di = be[pi] += 1;
          nt.attrs["PATHWAY-ID"] = new Array(di + 1).join(".");
          const xi = new Level(nt);
          ye[pi] = xi, ve.push(xi);
        } else
          ye[pi].addGroupId("audio", lt.AUDIO), ye[pi].addGroupId("text", lt.SUBTITLES);
      else {
        const di = new Level(nt);
        ye[pi] = di, be[pi] = 1, ve.push(di);
      }
    }), this.filterAndSortMediaOptions(ve, ee, Ye, Qe, Je);
  }
  filterAndSortMediaOptions(Z, ee, ae, ve, ye) {
    let be = [], Ye = [], Qe = Z;
    if ((ae || ve) && ye && (Qe = Qe.filter(({
      videoCodec: ft,
      videoRange: gt,
      width: ct,
      height: _r
    }) => (!!ft || !!(ct && _r)) && isVideoRange(gt))), Qe.length === 0) {
      Promise.resolve().then(() => {
        if (this.hls) {
          ee.levels.length && this.warn(`One or more CODECS in variant not supported: ${JSON.stringify(ee.levels[0].attrs)}`);
          const ft = new Error("no level with compatible codecs found in manifest");
          this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: !0,
            url: ee.url,
            error: ft,
            reason: ft.message
          });
        }
      });
      return;
    }
    if (ee.audioTracks) {
      const {
        preferManagedMediaSource: ft
      } = this.hls.config;
      be = ee.audioTracks.filter((gt) => !gt.audioCodec || areCodecsMediaSourceSupported(gt.audioCodec, "audio", ft)), assignTrackIdsByGroup(be);
    }
    ee.subtitles && (Ye = ee.subtitles, assignTrackIdsByGroup(Ye));
    const Je = Qe.slice(0);
    Qe.sort((ft, gt) => {
      if (ft.attrs["HDCP-LEVEL"] !== gt.attrs["HDCP-LEVEL"])
        return (ft.attrs["HDCP-LEVEL"] || "") > (gt.attrs["HDCP-LEVEL"] || "") ? 1 : -1;
      if (ae && ft.height !== gt.height)
        return ft.height - gt.height;
      if (ft.frameRate !== gt.frameRate)
        return ft.frameRate - gt.frameRate;
      if (ft.videoRange !== gt.videoRange)
        return VideoRangeValues.indexOf(ft.videoRange) - VideoRangeValues.indexOf(gt.videoRange);
      if (ft.videoCodec !== gt.videoCodec) {
        const ct = videoCodecPreferenceValue(ft.videoCodec), _r = videoCodecPreferenceValue(gt.videoCodec);
        if (ct !== _r)
          return _r - ct;
      }
      if (ft.uri === gt.uri && ft.codecSet !== gt.codecSet) {
        const ct = codecsSetSelectionPreferenceValue(ft.codecSet), _r = codecsSetSelectionPreferenceValue(gt.codecSet);
        if (ct !== _r)
          return _r - ct;
      }
      return ft.averageBitrate !== gt.averageBitrate ? ft.averageBitrate - gt.averageBitrate : 0;
    });
    let nt = Je[0];
    if (this.steering && (Qe = this.steering.filterParsedLevels(Qe), Qe.length !== Je.length)) {
      for (let ft = 0; ft < Je.length; ft++)
        if (Je[ft].pathwayId === Qe[0].pathwayId) {
          nt = Je[ft];
          break;
        }
    }
    this._levels = Qe;
    for (let ft = 0; ft < Qe.length; ft++)
      if (Qe[ft] === nt) {
        var st;
        this._firstLevel = ft;
        const gt = nt.bitrate, ct = this.hls.bandwidthEstimate;
        if (this.log(`manifest loaded, ${Qe.length} level(s) found, first bitrate: ${gt}`), ((st = this.hls.userConfig) == null ? void 0 : st.abrEwmaDefaultEstimate) === void 0) {
          const _r = Math.min(gt, this.hls.config.abrEwmaDefaultEstimateMax);
          _r > ct && ct === hlsDefaultConfig.abrEwmaDefaultEstimate && (this.hls.bandwidthEstimate = _r);
        }
        break;
      }
    const ot = ye && !ve, lt = {
      levels: Qe,
      audioTracks: be,
      subtitleTracks: Ye,
      sessionData: ee.sessionData,
      sessionKeys: ee.sessionKeys,
      firstLevel: this._firstLevel,
      stats: ee.stats,
      audio: ye,
      video: ve,
      altAudio: !ot && be.some((ft) => !!ft.url)
    };
    this.hls.trigger(Events.MANIFEST_PARSED, lt), (this.hls.config.autoStartLoad || this.hls.forceStartLoad) && this.hls.startLoad(this.hls.config.startPosition);
  }
  get levels() {
    return this._levels.length === 0 ? null : this._levels;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(Z) {
    const ee = this._levels;
    if (ee.length === 0)
      return;
    if (Z < 0 || Z >= ee.length) {
      const nt = new Error("invalid level idx"), st = Z < 0;
      if (this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.LEVEL_SWITCH_ERROR,
        level: Z,
        fatal: st,
        error: nt,
        reason: nt.message
      }), st)
        return;
      Z = Math.min(Z, ee.length - 1);
    }
    const ae = this.currentLevelIndex, ve = this.currentLevel, ye = ve ? ve.attrs["PATHWAY-ID"] : void 0, be = ee[Z], Ye = be.attrs["PATHWAY-ID"];
    if (this.currentLevelIndex = Z, this.currentLevel = be, ae === Z && be.details && ve && ye === Ye)
      return;
    this.log(`Switching to level ${Z} (${be.height ? be.height + "p " : ""}${be.videoRange ? be.videoRange + " " : ""}${be.codecSet ? be.codecSet + " " : ""}@${be.bitrate})${Ye ? " with Pathway " + Ye : ""} from level ${ae}${ye ? " with Pathway " + ye : ""}`);
    const Qe = {
      level: Z,
      attrs: be.attrs,
      details: be.details,
      bitrate: be.bitrate,
      averageBitrate: be.averageBitrate,
      maxBitrate: be.maxBitrate,
      realBitrate: be.realBitrate,
      width: be.width,
      height: be.height,
      codecSet: be.codecSet,
      audioCodec: be.audioCodec,
      videoCodec: be.videoCodec,
      audioGroups: be.audioGroups,
      subtitleGroups: be.subtitleGroups,
      loaded: be.loaded,
      loadError: be.loadError,
      fragmentError: be.fragmentError,
      name: be.name,
      id: be.id,
      uri: be.uri,
      url: be.url,
      urlId: 0,
      audioGroupIds: be.audioGroupIds,
      textGroupIds: be.textGroupIds
    };
    this.hls.trigger(Events.LEVEL_SWITCHING, Qe);
    const Je = be.details;
    if (!Je || Je.live) {
      const nt = this.switchParams(be.uri, ve == null ? void 0 : ve.details);
      this.loadPlaylist(nt);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(Z) {
    this.manualLevelIndex = Z, this._startLevel === void 0 && (this._startLevel = Z), Z !== -1 && (this.level = Z);
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(Z) {
    this._firstLevel = Z;
  }
  get startLevel() {
    if (this._startLevel === void 0) {
      const Z = this.hls.config.startLevel;
      return Z !== void 0 ? Z : this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(Z) {
    this._startLevel = Z;
  }
  onError(Z, ee) {
    ee.fatal || !ee.context || ee.context.type === PlaylistContextType.LEVEL && ee.context.level === this.level && this.checkRetry(ee);
  }
  // reset errors on the successful load of a fragment
  onFragBuffered(Z, {
    frag: ee
  }) {
    if (ee !== void 0 && ee.type === PlaylistLevelType.MAIN) {
      const ae = ee.elementaryStreams;
      if (!Object.keys(ae).some((ye) => !!ae[ye]))
        return;
      const ve = this._levels[ee.level];
      ve != null && ve.loadError && (this.log(`Resetting level error count of ${ve.loadError} on frag buffered`), ve.loadError = 0);
    }
  }
  onLevelLoaded(Z, ee) {
    var ae;
    const {
      level: ve,
      details: ye
    } = ee, be = this._levels[ve];
    if (!be) {
      var Ye;
      this.warn(`Invalid level index ${ve}`), (Ye = ee.deliveryDirectives) != null && Ye.skip && (ye.deltaUpdateFailed = !0);
      return;
    }
    ve === this.currentLevelIndex ? (be.fragmentError === 0 && (be.loadError = 0), this.playlistLoaded(ve, ee, be.details)) : (ae = ee.deliveryDirectives) != null && ae.skip && (ye.deltaUpdateFailed = !0);
  }
  loadPlaylist(Z) {
    super.loadPlaylist();
    const ee = this.currentLevelIndex, ae = this.currentLevel;
    if (ae && this.shouldLoadPlaylist(ae)) {
      let ve = ae.uri;
      if (Z)
        try {
          ve = Z.addDirectives(ve);
        } catch (be) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${be}`);
        }
      const ye = ae.attrs["PATHWAY-ID"];
      this.log(`Loading level index ${ee}${(Z == null ? void 0 : Z.msn) !== void 0 ? " at sn " + Z.msn + " part " + Z.part : ""} with${ye ? " Pathway " + ye : ""} ${ve}`), this.clearTimer(), this.hls.trigger(Events.LEVEL_LOADING, {
        url: ve,
        level: ee,
        pathwayId: ae.attrs["PATHWAY-ID"],
        id: 0,
        // Deprecated Level urlId
        deliveryDirectives: Z || null
      });
    }
  }
  get nextLoadLevel() {
    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
  }
  set nextLoadLevel(Z) {
    this.level = Z, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = Z);
  }
  removeLevel(Z) {
    var ee;
    const ae = this._levels.filter((ve, ye) => ye !== Z ? !0 : (this.steering && this.steering.removeLevel(ve), ve === this.currentLevel && (this.currentLevel = null, this.currentLevelIndex = -1, ve.details && ve.details.fragments.forEach((be) => be.level = -1)), !1));
    reassignFragmentLevelIndexes(ae), this._levels = ae, this.currentLevelIndex > -1 && (ee = this.currentLevel) != null && ee.details && (this.currentLevelIndex = this.currentLevel.details.fragments[0].level), this.hls.trigger(Events.LEVELS_UPDATED, {
      levels: ae
    });
  }
  onLevelsUpdated(Z, {
    levels: ee
  }) {
    this._levels = ee;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping: Z,
      maxAutoLevel: ee,
      maxHdcpLevel: ae
    } = this.hls;
    this._maxAutoLevel !== ee && (this._maxAutoLevel = ee, this.hls.trigger(Events.MAX_AUTO_LEVEL_UPDATED, {
      autoLevelCapping: Z,
      levels: this.levels,
      maxAutoLevel: ee,
      minAutoLevel: this.hls.minAutoLevel,
      maxHdcpLevel: ae
    }));
  }
}
function assignTrackIdsByGroup(ie) {
  const Z = {};
  ie.forEach((ee) => {
    const ae = ee.groupId || "";
    ee.id = Z[ae] = Z[ae] || 0, Z[ae]++;
  });
}
class KeyLoader {
  constructor(Z) {
    this.config = void 0, this.keyUriToKeyInfo = {}, this.emeController = null, this.config = Z;
  }
  abort(Z) {
    for (const ae in this.keyUriToKeyInfo) {
      const ve = this.keyUriToKeyInfo[ae].loader;
      if (ve) {
        var ee;
        if (Z && Z !== ((ee = ve.context) == null ? void 0 : ee.frag.type))
          return;
        ve.abort();
      }
    }
  }
  detach() {
    for (const Z in this.keyUriToKeyInfo) {
      const ee = this.keyUriToKeyInfo[Z];
      (ee.mediaKeySessionContext || ee.decryptdata.isCommonEncryption) && delete this.keyUriToKeyInfo[Z];
    }
  }
  destroy() {
    this.detach();
    for (const Z in this.keyUriToKeyInfo) {
      const ee = this.keyUriToKeyInfo[Z].loader;
      ee && ee.destroy();
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(Z, ee = ErrorDetails.KEY_LOAD_ERROR, ae, ve, ye) {
    return new LoadError({
      type: ErrorTypes.NETWORK_ERROR,
      details: ee,
      fatal: !1,
      frag: Z,
      response: ye,
      error: ae,
      networkDetails: ve
    });
  }
  loadClear(Z, ee) {
    if (this.emeController && this.config.emeEnabled) {
      const {
        sn: ae,
        cc: ve
      } = Z;
      for (let ye = 0; ye < ee.length; ye++) {
        const be = ee[ye];
        if (ve <= be.cc && (ae === "initSegment" || be.sn === "initSegment" || ae < be.sn)) {
          this.emeController.selectKeySystemFormat(be).then((Ye) => {
            be.setKeyFormat(Ye);
          });
          break;
        }
      }
    }
  }
  load(Z) {
    return !Z.decryptdata && Z.encrypted && this.emeController ? this.emeController.selectKeySystemFormat(Z).then((ee) => this.loadInternal(Z, ee)) : this.loadInternal(Z);
  }
  loadInternal(Z, ee) {
    var ae, ve;
    ee && Z.setKeyFormat(ee);
    const ye = Z.decryptdata;
    if (!ye) {
      const Je = new Error(ee ? `Expected frag.decryptdata to be defined after setting format ${ee}` : "Missing decryption data on fragment in onKeyLoading");
      return Promise.reject(this.createKeyLoadError(Z, ErrorDetails.KEY_LOAD_ERROR, Je));
    }
    const be = ye.uri;
    if (!be)
      return Promise.reject(this.createKeyLoadError(Z, ErrorDetails.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${be}"`)));
    let Ye = this.keyUriToKeyInfo[be];
    if ((ae = Ye) != null && ae.decryptdata.key)
      return ye.key = Ye.decryptdata.key, Promise.resolve({
        frag: Z,
        keyInfo: Ye
      });
    if ((ve = Ye) != null && ve.keyLoadPromise) {
      var Qe;
      switch ((Qe = Ye.mediaKeySessionContext) == null ? void 0 : Qe.keyStatus) {
        case void 0:
        case "status-pending":
        case "usable":
        case "usable-in-future":
          return Ye.keyLoadPromise.then((Je) => (ye.key = Je.keyInfo.decryptdata.key, {
            frag: Z,
            keyInfo: Ye
          }));
      }
    }
    switch (Ye = this.keyUriToKeyInfo[be] = {
      decryptdata: ye,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    }, ye.method) {
      case "ISO-23001-7":
      case "SAMPLE-AES":
      case "SAMPLE-AES-CENC":
      case "SAMPLE-AES-CTR":
        return ye.keyFormat === "identity" ? this.loadKeyHTTP(Ye, Z) : this.loadKeyEME(Ye, Z);
      case "AES-128":
        return this.loadKeyHTTP(Ye, Z);
      default:
        return Promise.reject(this.createKeyLoadError(Z, ErrorDetails.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${ye.method}"`)));
    }
  }
  loadKeyEME(Z, ee) {
    const ae = {
      frag: ee,
      keyInfo: Z
    };
    if (this.emeController && this.config.emeEnabled) {
      const ve = this.emeController.loadKey(ae);
      if (ve)
        return (Z.keyLoadPromise = ve.then((ye) => (Z.mediaKeySessionContext = ye, ae))).catch((ye) => {
          throw Z.keyLoadPromise = null, ye;
        });
    }
    return Promise.resolve(ae);
  }
  loadKeyHTTP(Z, ee) {
    const ae = this.config, ve = ae.loader, ye = new ve(ae);
    return ee.keyLoader = Z.loader = ye, Z.keyLoadPromise = new Promise((be, Ye) => {
      const Qe = {
        keyInfo: Z,
        frag: ee,
        responseType: "arraybuffer",
        url: Z.decryptdata.uri
      }, Je = ae.keyLoadPolicy.default, nt = {
        loadPolicy: Je,
        timeout: Je.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, st = {
        onSuccess: (ot, lt, ft, gt) => {
          const {
            frag: ct,
            keyInfo: _r,
            url: Kr
          } = ft;
          if (!ct.decryptdata || _r !== this.keyUriToKeyInfo[Kr])
            return Ye(this.createKeyLoadError(ct, ErrorDetails.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), gt));
          _r.decryptdata.key = ct.decryptdata.key = new Uint8Array(ot.data), ct.keyLoader = null, _r.loader = null, be({
            frag: ct,
            keyInfo: _r
          });
        },
        onError: (ot, lt, ft, gt) => {
          this.resetLoader(lt), Ye(this.createKeyLoadError(ee, ErrorDetails.KEY_LOAD_ERROR, new Error(`HTTP Error ${ot.code} loading key ${ot.text}`), ft, _objectSpread2({
            url: Qe.url,
            data: void 0
          }, ot)));
        },
        onTimeout: (ot, lt, ft) => {
          this.resetLoader(lt), Ye(this.createKeyLoadError(ee, ErrorDetails.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), ft));
        },
        onAbort: (ot, lt, ft) => {
          this.resetLoader(lt), Ye(this.createKeyLoadError(ee, ErrorDetails.INTERNAL_ABORTED, new Error("key loading aborted"), ft));
        }
      };
      ye.load(Qe, nt, st);
    });
  }
  resetLoader(Z) {
    const {
      frag: ee,
      keyInfo: ae,
      url: ve
    } = Z, ye = ae.loader;
    ee.keyLoader === ye && (ee.keyLoader = null, ae.loader = null), delete this.keyUriToKeyInfo[ve], ye && ye.destroy();
  }
}
function getSourceBuffer() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function isMSESupported() {
  if (!getMediaSource())
    return !1;
  const Z = getSourceBuffer();
  return !Z || Z.prototype && typeof Z.prototype.appendBuffer == "function" && typeof Z.prototype.remove == "function";
}
function isSupported() {
  if (!isMSESupported())
    return !1;
  const ie = getMediaSource();
  return typeof (ie == null ? void 0 : ie.isTypeSupported) == "function" && (["avc1.42E01E,mp4a.40.2", "av01.0.01M.08", "vp09.00.50.08"].some((Z) => ie.isTypeSupported(mimeTypeForCodec(Z, "video"))) || ["mp4a.40.2", "fLaC"].some((Z) => ie.isTypeSupported(mimeTypeForCodec(Z, "audio"))));
}
function changeTypeSupported() {
  var ie;
  const Z = getSourceBuffer();
  return typeof (Z == null || (ie = Z.prototype) == null ? void 0 : ie.changeType) == "function";
}
const STALL_MINIMUM_DURATION_MS = 250, MAX_START_GAP_JUMP = 2, SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1, SKIP_BUFFER_RANGE_START = 0.05;
class GapController {
  constructor(Z, ee, ae, ve) {
    this.config = void 0, this.media = null, this.fragmentTracker = void 0, this.hls = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.config = Z, this.media = ee, this.fragmentTracker = ae, this.hls = ve;
  }
  destroy() {
    this.media = null, this.hls = this.fragmentTracker = null;
  }
  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(Z, ee) {
    const {
      config: ae,
      media: ve,
      stalled: ye
    } = this;
    if (ve === null)
      return;
    const {
      currentTime: be,
      seeking: Ye
    } = ve, Qe = this.seeking && !Ye, Je = !this.seeking && Ye;
    if (this.seeking = Ye, be !== Z) {
      if (this.moved = !0, Ye || (this.nudgeRetry = 0), ye !== null) {
        if (this.stallReported) {
          const ct = self.performance.now() - ye;
          logger.warn(`playback not stuck anymore @${be}, after ${Math.round(ct)}ms`), this.stallReported = !1;
        }
        this.stalled = null;
      }
      return;
    }
    if (Je || Qe) {
      this.stalled = null;
      return;
    }
    if (ve.paused && !Ye || ve.ended || ve.playbackRate === 0 || !BufferHelper.getBuffered(ve).length) {
      this.nudgeRetry = 0;
      return;
    }
    const nt = BufferHelper.bufferInfo(ve, be, 0), st = nt.nextStart || 0;
    if (Ye) {
      const ct = nt.len > MAX_START_GAP_JUMP, _r = !st || ee && ee.start <= be || st - be > MAX_START_GAP_JUMP && !this.fragmentTracker.getPartialFragment(be);
      if (ct || _r)
        return;
      this.moved = !1;
    }
    if (!this.moved && this.stalled !== null) {
      var ot;
      if (!(nt.len > 0) && !st)
        return;
      const _r = Math.max(st, nt.start || 0) - be, Kr = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null, Jr = (Kr == null || (ot = Kr.details) == null ? void 0 : ot.live) ? Kr.details.targetduration * 2 : MAX_START_GAP_JUMP, ei = this.fragmentTracker.getPartialFragment(be);
      if (_r > 0 && (_r <= Jr || ei)) {
        ve.paused || this._trySkipBufferHole(ei);
        return;
      }
    }
    const lt = self.performance.now();
    if (ye === null) {
      this.stalled = lt;
      return;
    }
    const ft = lt - ye;
    if (!Ye && ft >= STALL_MINIMUM_DURATION_MS && (this._reportStall(nt), !this.media))
      return;
    const gt = BufferHelper.bufferInfo(ve, be, ae.maxBufferHole);
    this._tryFixBufferStall(gt, ft);
  }
  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(Z, ee) {
    const {
      config: ae,
      fragmentTracker: ve,
      media: ye
    } = this;
    if (ye === null)
      return;
    const be = ye.currentTime, Ye = ve.getPartialFragment(be);
    Ye && (this._trySkipBufferHole(Ye) || !this.media) || (Z.len > ae.maxBufferHole || Z.nextStart && Z.nextStart - be < ae.maxBufferHole) && ee > ae.highBufferWatchdogPeriod * 1e3 && (logger.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
  }
  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(Z) {
    const {
      hls: ee,
      media: ae,
      stallReported: ve
    } = this;
    if (!ve && ae) {
      this.stallReported = !0;
      const ye = new Error(`Playback stalling at @${ae.currentTime} due to low buffer (${JSON.stringify(Z)})`);
      logger.warn(ye.message), ee.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_STALLED_ERROR,
        fatal: !1,
        error: ye,
        buffer: Z.len
      });
    }
  }
  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(Z) {
    const {
      config: ee,
      hls: ae,
      media: ve
    } = this;
    if (ve === null)
      return 0;
    const ye = ve.currentTime, be = BufferHelper.bufferInfo(ve, ye, 0), Ye = ye < be.start ? be.start : be.nextStart;
    if (Ye) {
      const Qe = be.len <= ee.maxBufferHole, Je = be.len > 0 && be.len < 1 && ve.readyState < 3, nt = Ye - ye;
      if (nt > 0 && (Qe || Je)) {
        if (nt > ee.maxBufferHole) {
          const {
            fragmentTracker: ot
          } = this;
          let lt = !1;
          if (ye === 0) {
            const ft = ot.getAppendedFrag(0, PlaylistLevelType.MAIN);
            ft && Ye < ft.end && (lt = !0);
          }
          if (!lt) {
            const ft = Z || ot.getAppendedFrag(ye, PlaylistLevelType.MAIN);
            if (ft) {
              let gt = !1, ct = ft.end;
              for (; ct < Ye; ) {
                const _r = ot.getPartialFragment(ct);
                if (_r)
                  ct += _r.duration;
                else {
                  gt = !0;
                  break;
                }
              }
              if (gt)
                return 0;
            }
          }
        }
        const st = Math.max(Ye + SKIP_BUFFER_RANGE_START, ye + SKIP_BUFFER_HOLE_STEP_SECONDS);
        if (logger.warn(`skipping hole, adjusting currentTime from ${ye} to ${st}`), this.moved = !0, this.stalled = null, ve.currentTime = st, Z && !Z.gap) {
          const ot = new Error(`fragment loaded with buffer holes, seeking from ${ye} to ${st}`);
          ae.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_SEEK_OVER_HOLE,
            fatal: !1,
            error: ot,
            reason: ot.message,
            frag: Z
          });
        }
        return st;
      }
    }
    return 0;
  }
  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer() {
    const {
      config: Z,
      hls: ee,
      media: ae,
      nudgeRetry: ve
    } = this;
    if (ae === null)
      return;
    const ye = ae.currentTime;
    if (this.nudgeRetry++, ve < Z.nudgeMaxRetry) {
      const be = ye + (ve + 1) * Z.nudgeOffset, Ye = new Error(`Nudging 'currentTime' from ${ye} to ${be}`);
      logger.warn(Ye.message), ae.currentTime = be, ee.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_NUDGE_ON_STALL,
        error: Ye,
        fatal: !1
      });
    } else {
      const be = new Error(`Playhead still not moving while enough data buffered @${ye} after ${Z.nudgeMaxRetry} nudges`);
      logger.error(be.message), ee.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_STALLED_ERROR,
        error: be,
        fatal: !0
      });
    }
  }
}
const TICK_INTERVAL = 100;
class StreamController extends BaseStreamController {
  constructor(Z, ee, ae) {
    super(Z, ee, ae, "[stream-controller]", PlaylistLevelType.MAIN), this.audioCodecSwap = !1, this.gapController = null, this.level = -1, this._forceStartLoad = !1, this.altAudio = !1, this.audioOnly = !1, this.fragPlaying = null, this.onvplaying = null, this.onvseeked = null, this.fragLastKbps = 0, this.couldBacktrack = !1, this.backtrackFragment = null, this.audioCodecSwitch = !1, this.videoBuffer = null, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: Z
    } = this;
    Z.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.on(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.on(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.on(Events.LEVEL_LOADING, this.onLevelLoading, this), Z.on(Events.LEVEL_LOADED, this.onLevelLoaded, this), Z.on(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), Z.on(Events.ERROR, this.onError, this), Z.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), Z.on(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), Z.on(Events.BUFFER_CREATED, this.onBufferCreated, this), Z.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this), Z.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this), Z.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: Z
    } = this;
    Z.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this), Z.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this), Z.off(Events.MANIFEST_LOADING, this.onManifestLoading, this), Z.off(Events.MANIFEST_PARSED, this.onManifestParsed, this), Z.off(Events.LEVEL_LOADED, this.onLevelLoaded, this), Z.off(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), Z.off(Events.ERROR, this.onError, this), Z.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), Z.off(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), Z.off(Events.BUFFER_CREATED, this.onBufferCreated, this), Z.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this), Z.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this), Z.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying();
  }
  startLoad(Z) {
    if (this.levels) {
      const {
        lastCurrentTime: ee,
        hls: ae
      } = this;
      if (this.stopLoad(), this.setInterval(TICK_INTERVAL), this.level = -1, !this.startFragRequested) {
        let ve = ae.startLevel;
        ve === -1 && (ae.config.testBandwidth && this.levels.length > 1 ? (ve = 0, this.bitrateTest = !0) : ve = ae.firstAutoLevel), this.level = ae.nextLoadLevel = ve, this.loadedmetadata = !1;
      }
      ee > 0 && Z === -1 && (this.log(`Override startPosition with lastCurrentTime @${ee.toFixed(3)}`), Z = ee), this.state = State.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = Z, this.tick();
    } else
      this._forceStartLoad = !0, this.state = State.STOPPED;
  }
  stopLoad() {
    this._forceStartLoad = !1, super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case State.WAITING_LEVEL: {
        const {
          levels: ee,
          level: ae
        } = this, ve = ee == null ? void 0 : ee[ae], ye = ve == null ? void 0 : ve.details;
        if (ye && (!ye.live || this.levelLastLoaded === ve)) {
          if (this.waitForCdnTuneIn(ye))
            break;
          this.state = State.IDLE;
          break;
        } else if (this.hls.nextLoadLevel !== this.level) {
          this.state = State.IDLE;
          break;
        }
        break;
      }
      case State.FRAG_LOADING_WAITING_RETRY:
        {
          var Z;
          const ee = self.performance.now(), ae = this.retryDate;
          if (!ae || ee >= ae || (Z = this.media) != null && Z.seeking) {
            const {
              levels: ve,
              level: ye
            } = this, be = ve == null ? void 0 : ve[ye];
            this.resetStartWhenNotLoaded(be || null), this.state = State.IDLE;
          }
        }
        break;
    }
    this.state === State.IDLE && this.doTickIdle(), this.onTickEnd();
  }
  onTickEnd() {
    super.onTickEnd(), this.checkBuffer(), this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls: Z,
      levelLastLoaded: ee,
      levels: ae,
      media: ve
    } = this, {
      config: ye,
      nextLoadLevel: be
    } = Z;
    if (ee === null || !ve && (this.startFragRequested || !ye.startFragPrefetch) || this.altAudio && this.audioOnly || !(ae != null && ae[be]))
      return;
    const Ye = ae[be], Qe = this.getMainFwdBufferInfo();
    if (Qe === null)
      return;
    const Je = this.getLevelDetails();
    if (Je && this._streamEnded(Qe, Je)) {
      const ct = {};
      this.altAudio && (ct.type = "video"), this.hls.trigger(Events.BUFFER_EOS, ct), this.state = State.ENDED;
      return;
    }
    Z.loadLevel !== be && Z.manualLevel === -1 && this.log(`Adapting to level ${be} from level ${this.level}`), this.level = Z.nextLoadLevel = be;
    const nt = Ye.details;
    if (!nt || this.state === State.WAITING_LEVEL || nt.live && this.levelLastLoaded !== Ye) {
      this.level = be, this.state = State.WAITING_LEVEL;
      return;
    }
    const st = Qe.len, ot = this.getMaxBufferLength(Ye.maxBitrate);
    if (st >= ot)
      return;
    this.backtrackFragment && this.backtrackFragment.start > Qe.end && (this.backtrackFragment = null);
    const lt = this.backtrackFragment ? this.backtrackFragment.start : Qe.end;
    let ft = this.getNextFragment(lt, nt);
    if (this.couldBacktrack && !this.fragPrevious && ft && ft.sn !== "initSegment" && this.fragmentTracker.getState(ft) !== FragmentState.OK) {
      var gt;
      const _r = ((gt = this.backtrackFragment) != null ? gt : ft).sn - nt.startSN, Kr = nt.fragments[_r - 1];
      Kr && ft.cc === Kr.cc && (ft = Kr, this.fragmentTracker.removeFragment(Kr));
    } else
      this.backtrackFragment && Qe.len && (this.backtrackFragment = null);
    if (ft && this.isLoopLoading(ft, lt)) {
      if (!ft.gap) {
        const _r = this.audioOnly && !this.altAudio ? ElementaryStreamTypes.AUDIO : ElementaryStreamTypes.VIDEO, Kr = (_r === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        Kr && this.afterBufferFlushed(Kr, _r, PlaylistLevelType.MAIN);
      }
      ft = this.getNextFragmentLoopLoading(ft, nt, Qe, PlaylistLevelType.MAIN, ot);
    }
    ft && (ft.initSegment && !ft.initSegment.data && !this.bitrateTest && (ft = ft.initSegment), this.loadFragment(ft, Ye, lt));
  }
  loadFragment(Z, ee, ae) {
    const ve = this.fragmentTracker.getState(Z);
    this.fragCurrent = Z, ve === FragmentState.NOT_LOADED || ve === FragmentState.PARTIAL ? Z.sn === "initSegment" ? this._loadInitSegment(Z, ee) : this.bitrateTest ? (this.log(`Fragment ${Z.sn} of level ${Z.level} is being downloaded to test bitrate and will not be buffered`), this._loadBitrateTestFrag(Z, ee)) : (this.startFragRequested = !0, super.loadFragment(Z, ee, ae)) : this.clearTrackerIfNeeded(Z);
  }
  getBufferedFrag(Z) {
    return this.fragmentTracker.getBufferedFrag(Z, PlaylistLevelType.MAIN);
  }
  followingBufferedFrag(Z) {
    return Z ? this.getBufferedFrag(Z.end + 0.5) : null;
  }
  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }
  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels: Z,
      media: ee
    } = this;
    if (ee != null && ee.readyState) {
      let ae;
      const ve = this.getAppendedFrag(ee.currentTime);
      ve && ve.start > 1 && this.flushMainBuffer(0, ve.start - 1);
      const ye = this.getLevelDetails();
      if (ye != null && ye.live) {
        const Ye = this.getMainFwdBufferInfo();
        if (!Ye || Ye.len < ye.targetduration * 2)
          return;
      }
      if (!ee.paused && Z) {
        const Ye = this.hls.nextLoadLevel, Qe = Z[Ye], Je = this.fragLastKbps;
        Je && this.fragCurrent ? ae = this.fragCurrent.duration * Qe.maxBitrate / (1e3 * Je) + 1 : ae = 0;
      } else
        ae = 0;
      const be = this.getBufferedFrag(ee.currentTime + ae);
      if (be) {
        const Ye = this.followingBufferedFrag(be);
        if (Ye) {
          this.abortCurrentFrag();
          const Qe = Ye.maxStartPTS ? Ye.maxStartPTS : Ye.start, Je = Ye.duration, nt = Math.max(be.end, Qe + Math.min(Math.max(Je - this.config.maxFragLookUpTolerance, Je * (this.couldBacktrack ? 0.5 : 0.125)), Je * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(nt, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const Z = this.fragCurrent;
    switch (this.fragCurrent = null, this.backtrackFragment = null, Z && (Z.abortRequests(), this.fragmentTracker.removeFragment(Z)), this.state) {
      case State.KEY_LOADING:
      case State.FRAG_LOADING:
      case State.FRAG_LOADING_WAITING_RETRY:
      case State.PARSING:
      case State.PARSED:
        this.state = State.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(Z, ee) {
    super.flushMainBuffer(Z, ee, this.altAudio ? "video" : null);
  }
  onMediaAttached(Z, ee) {
    super.onMediaAttached(Z, ee);
    const ae = ee.media;
    this.onvplaying = this.onMediaPlaying.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), ae.addEventListener("playing", this.onvplaying), ae.addEventListener("seeked", this.onvseeked), this.gapController = new GapController(this.config, ae, this.fragmentTracker, this.hls);
  }
  onMediaDetaching() {
    const {
      media: Z
    } = this;
    Z && this.onvplaying && this.onvseeked && (Z.removeEventListener("playing", this.onvplaying), Z.removeEventListener("seeked", this.onvseeked), this.onvplaying = this.onvseeked = null, this.videoBuffer = null), this.fragPlaying = null, this.gapController && (this.gapController.destroy(), this.gapController = null), super.onMediaDetaching();
  }
  onMediaPlaying() {
    this.tick();
  }
  onMediaSeeked() {
    const Z = this.media, ee = Z ? Z.currentTime : null;
    isFiniteNumber(ee) && this.log(`Media seeked to ${ee.toFixed(3)}`);
    const ae = this.getMainFwdBufferInfo();
    if (ae === null || ae.len === 0) {
      this.warn(`Main forward buffer length on "seeked" event ${ae ? ae.len : "empty"})`);
      return;
    }
    this.tick();
  }
  onManifestLoading() {
    this.log("Trigger BUFFER_RESET"), this.hls.trigger(Events.BUFFER_RESET, void 0), this.fragmentTracker.removeAllFragments(), this.couldBacktrack = !1, this.startPosition = this.lastCurrentTime = this.fragLastKbps = 0, this.levels = this.fragPlaying = this.backtrackFragment = this.levelLastLoaded = null, this.altAudio = this.audioOnly = this.startFragRequested = !1;
  }
  onManifestParsed(Z, ee) {
    let ae = !1, ve = !1;
    ee.levels.forEach((ye) => {
      const be = ye.audioCodec;
      be && (ae = ae || be.indexOf("mp4a.40.2") !== -1, ve = ve || be.indexOf("mp4a.40.5") !== -1);
    }), this.audioCodecSwitch = ae && ve && !changeTypeSupported(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = ee.levels, this.startFragRequested = !1;
  }
  onLevelLoading(Z, ee) {
    const {
      levels: ae
    } = this;
    if (!ae || this.state !== State.IDLE)
      return;
    const ve = ae[ee.level];
    (!ve.details || ve.details.live && this.levelLastLoaded !== ve || this.waitForCdnTuneIn(ve.details)) && (this.state = State.WAITING_LEVEL);
  }
  onLevelLoaded(Z, ee) {
    var ae;
    const {
      levels: ve
    } = this, ye = ee.level, be = ee.details, Ye = be.totalduration;
    if (!ve) {
      this.warn(`Levels were reset while loading level ${ye}`);
      return;
    }
    this.log(`Level ${ye} loaded [${be.startSN},${be.endSN}]${be.lastPartSn ? `[part-${be.lastPartSn}-${be.lastPartIndex}]` : ""}, cc [${be.startCC}, ${be.endCC}] duration:${Ye}`);
    const Qe = ve[ye], Je = this.fragCurrent;
    Je && (this.state === State.FRAG_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY) && Je.level !== ee.level && Je.loader && this.abortCurrentFrag();
    let nt = 0;
    if (be.live || (ae = Qe.details) != null && ae.live) {
      var st;
      if (this.checkLiveUpdate(be), be.deltaUpdateFailed)
        return;
      nt = this.alignPlaylists(be, Qe.details, (st = this.levelLastLoaded) == null ? void 0 : st.details);
    }
    if (Qe.details = be, this.levelLastLoaded = Qe, this.hls.trigger(Events.LEVEL_UPDATED, {
      details: be,
      level: ye
    }), this.state === State.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(be))
        return;
      this.state = State.IDLE;
    }
    this.startFragRequested ? be.live && this.synchronizeToLiveEdge(be) : this.setStartPosition(be, nt), this.tick();
  }
  _handleFragmentLoadProgress(Z) {
    var ee;
    const {
      frag: ae,
      part: ve,
      payload: ye
    } = Z, {
      levels: be
    } = this;
    if (!be) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${ae.sn} of level ${ae.level} will not be buffered`);
      return;
    }
    const Ye = be[ae.level], Qe = Ye.details;
    if (!Qe) {
      this.warn(`Dropping fragment ${ae.sn} of level ${ae.level} after level details were reset`), this.fragmentTracker.removeFragment(ae);
      return;
    }
    const Je = Ye.videoCodec, nt = Qe.PTSKnown || !Qe.live, st = (ee = ae.initSegment) == null ? void 0 : ee.data, ot = this._getAudioCodec(Ye), lt = this.transmuxer = this.transmuxer || new TransmuxerInterface(this.hls, PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), ft = ve ? ve.index : -1, gt = ft !== -1, ct = new ChunkMetadata(ae.level, ae.sn, ae.stats.chunkCount, ye.byteLength, ft, gt), _r = this.initPTS[ae.cc];
    lt.push(ye, st, ot, Je, ae, ve, Qe.totalduration, nt, ct, _r);
  }
  onAudioTrackSwitching(Z, ee) {
    const ae = this.altAudio;
    if (!!!ee.url) {
      if (this.mediaBuffer !== this.media) {
        this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
        const be = this.fragCurrent;
        be && (this.log("Switching to main audio track, cancel main fragment load"), be.abortRequests(), this.fragmentTracker.removeFragment(be)), this.resetTransmuxer(), this.resetLoadingState();
      } else
        this.audioOnly && this.resetTransmuxer();
      const ye = this.hls;
      ae && (ye.trigger(Events.BUFFER_FLUSHING, {
        startOffset: 0,
        endOffset: Number.POSITIVE_INFINITY,
        type: null
      }), this.fragmentTracker.removeAllFragments()), ye.trigger(Events.AUDIO_TRACK_SWITCHED, ee);
    }
  }
  onAudioTrackSwitched(Z, ee) {
    const ae = ee.id, ve = !!this.hls.audioTracks[ae].url;
    if (ve) {
      const ye = this.videoBuffer;
      ye && this.mediaBuffer !== ye && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = ye);
    }
    this.altAudio = ve, this.tick();
  }
  onBufferCreated(Z, ee) {
    const ae = ee.tracks;
    let ve, ye, be = !1;
    for (const Ye in ae) {
      const Qe = ae[Ye];
      if (Qe.id === "main") {
        if (ye = Ye, ve = Qe, Ye === "video") {
          const Je = ae[Ye];
          Je && (this.videoBuffer = Je.buffer);
        }
      } else
        be = !0;
    }
    be && ve ? (this.log(`Alternate track found, use ${ye}.buffered to schedule main fragment loading`), this.mediaBuffer = ve.buffer) : this.mediaBuffer = this.media;
  }
  onFragBuffered(Z, ee) {
    const {
      frag: ae,
      part: ve
    } = ee;
    if (ae && ae.type !== PlaylistLevelType.MAIN)
      return;
    if (this.fragContextChanged(ae)) {
      this.warn(`Fragment ${ae.sn}${ve ? " p: " + ve.index : ""} of level ${ae.level} finished buffering, but was aborted. state: ${this.state}`), this.state === State.PARSED && (this.state = State.IDLE);
      return;
    }
    const ye = ve ? ve.stats : ae.stats;
    this.fragLastKbps = Math.round(8 * ye.total / (ye.buffering.end - ye.loading.first)), ae.sn !== "initSegment" && (this.fragPrevious = ae), this.fragBufferedComplete(ae, ve);
  }
  onError(Z, ee) {
    var ae;
    if (ee.fatal) {
      this.state = State.ERROR;
      return;
    }
    switch (ee.details) {
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_PARSING_ERROR:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(PlaylistLevelType.MAIN, ee);
        break;
      case ErrorDetails.LEVEL_LOAD_ERROR:
      case ErrorDetails.LEVEL_LOAD_TIMEOUT:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        !ee.levelRetry && this.state === State.WAITING_LEVEL && ((ae = ee.context) == null ? void 0 : ae.type) === PlaylistContextType.LEVEL && (this.state = State.IDLE);
        break;
      case ErrorDetails.BUFFER_APPEND_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
        if (!ee.parent || ee.parent !== "main")
          return;
        if (ee.details === ErrorDetails.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        this.reduceLengthAndFlushBuffer(ee) && this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        break;
      case ErrorDetails.INTERNAL_EXCEPTION:
        this.recoverWorkerError(ee);
        break;
    }
  }
  // Checks the health of the buffer and attempts to resolve playback stalls.
  checkBuffer() {
    const {
      media: Z,
      gapController: ee
    } = this;
    if (!(!Z || !ee || !Z.readyState)) {
      if (this.loadedmetadata || !BufferHelper.getBuffered(Z).length) {
        const ae = this.state !== State.IDLE ? this.fragCurrent : null;
        ee.poll(this.lastCurrentTime, ae);
      }
      this.lastCurrentTime = Z.currentTime;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = State.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tickImmediate();
  }
  onBufferFlushed(Z, {
    type: ee
  }) {
    if (ee !== ElementaryStreamTypes.AUDIO || this.audioOnly && !this.altAudio) {
      const ae = (ee === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      this.afterBufferFlushed(ae, ee, PlaylistLevelType.MAIN), this.tick();
    }
  }
  onLevelsUpdated(Z, ee) {
    this.level > -1 && this.fragCurrent && (this.level = this.fragCurrent.level), this.levels = ee.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }
  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media: Z
    } = this;
    if (!Z)
      return;
    const ee = Z.currentTime;
    let ae = this.startPosition;
    if (ae >= 0 && ee < ae) {
      if (Z.seeking) {
        this.log(`could not seek to ${ae}, already seeking at ${ee}`);
        return;
      }
      const ve = BufferHelper.getBuffered(Z), be = (ve.length ? ve.start(0) : 0) - ae;
      be > 0 && (be < this.config.maxBufferHole || be < this.config.maxFragLookUpTolerance) && (this.log(`adjusting start position by ${be} to match buffer start`), ae += be, this.startPosition = ae), this.log(`seek to target start position ${ae} from current time ${ee}`), Z.currentTime = ae;
    }
  }
  _getAudioCodec(Z) {
    let ee = this.config.defaultAudioCodec || Z.audioCodec;
    return this.audioCodecSwap && ee && (this.log("Swapping audio codec"), ee.indexOf("mp4a.40.5") !== -1 ? ee = "mp4a.40.2" : ee = "mp4a.40.5"), ee;
  }
  _loadBitrateTestFrag(Z, ee) {
    Z.bitrateTest = !0, this._doFragLoad(Z, ee).then((ae) => {
      const {
        hls: ve
      } = this;
      if (!ae || this.fragContextChanged(Z))
        return;
      ee.fragmentError = 0, this.state = State.IDLE, this.startFragRequested = !1, this.bitrateTest = !1;
      const ye = Z.stats;
      ye.parsing.start = ye.parsing.end = ye.buffering.start = ye.buffering.end = self.performance.now(), ve.trigger(Events.FRAG_LOADED, ae), Z.bitrateTest = !1;
    });
  }
  _handleTransmuxComplete(Z) {
    var ee;
    const ae = "main", {
      hls: ve
    } = this, {
      remuxResult: ye,
      chunkMeta: be
    } = Z, Ye = this.getCurrentContext(be);
    if (!Ye) {
      this.resetWhenMissingContext(be);
      return;
    }
    const {
      frag: Qe,
      part: Je,
      level: nt
    } = Ye, {
      video: st,
      text: ot,
      id3: lt,
      initSegment: ft
    } = ye, {
      details: gt
    } = nt, ct = this.altAudio ? void 0 : ye.audio;
    if (this.fragContextChanged(Qe)) {
      this.fragmentTracker.removeFragment(Qe);
      return;
    }
    if (this.state = State.PARSING, ft) {
      if (ft != null && ft.tracks) {
        const Xr = Qe.initSegment || Qe;
        this._bufferInitSegment(nt, ft.tracks, Xr, be), ve.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
          frag: Xr,
          id: ae,
          tracks: ft.tracks
        });
      }
      const _r = ft.initPTS, Kr = ft.timescale;
      isFiniteNumber(_r) && (this.initPTS[Qe.cc] = {
        baseTime: _r,
        timescale: Kr
      }, ve.trigger(Events.INIT_PTS_FOUND, {
        frag: Qe,
        id: ae,
        initPTS: _r,
        timescale: Kr
      }));
    }
    if (st && gt && Qe.sn !== "initSegment") {
      const _r = gt.fragments[Qe.sn - 1 - gt.startSN], Kr = Qe.sn === gt.startSN, Xr = !_r || Qe.cc > _r.cc;
      if (ye.independent !== !1) {
        const {
          startPTS: Jr,
          endPTS: ei,
          startDTS: si,
          endDTS: ri
        } = st;
        if (Je)
          Je.elementaryStreams[st.type] = {
            startPTS: Jr,
            endPTS: ei,
            startDTS: si,
            endDTS: ri
          };
        else if (st.firstKeyFrame && st.independent && be.id === 1 && !Xr && (this.couldBacktrack = !0), st.dropped && st.independent) {
          const ai = this.getMainFwdBufferInfo(), yi = (ai ? ai.end : this.getLoadPosition()) + this.config.maxBufferHole, pi = st.firstKeyFramePTS ? st.firstKeyFramePTS : Jr;
          if (!Kr && yi < pi - this.config.maxBufferHole && !Xr) {
            this.backtrack(Qe);
            return;
          } else
            Xr && (Qe.gap = !0);
          Qe.setElementaryStreamInfo(st.type, Qe.start, ei, Qe.start, ri, !0);
        } else
          Kr && Jr > MAX_START_GAP_JUMP && (Qe.gap = !0);
        Qe.setElementaryStreamInfo(st.type, Jr, ei, si, ri), this.backtrackFragment && (this.backtrackFragment = Qe), this.bufferFragmentData(st, Qe, Je, be, Kr || Xr);
      } else if (Kr || Xr)
        Qe.gap = !0;
      else {
        this.backtrack(Qe);
        return;
      }
    }
    if (ct) {
      const {
        startPTS: _r,
        endPTS: Kr,
        startDTS: Xr,
        endDTS: Jr
      } = ct;
      Je && (Je.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
        startPTS: _r,
        endPTS: Kr,
        startDTS: Xr,
        endDTS: Jr
      }), Qe.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, _r, Kr, Xr, Jr), this.bufferFragmentData(ct, Qe, Je, be);
    }
    if (gt && lt != null && (ee = lt.samples) != null && ee.length) {
      const _r = {
        id: ae,
        frag: Qe,
        details: gt,
        samples: lt.samples
      };
      ve.trigger(Events.FRAG_PARSING_METADATA, _r);
    }
    if (gt && ot) {
      const _r = {
        id: ae,
        frag: Qe,
        details: gt,
        samples: ot.samples
      };
      ve.trigger(Events.FRAG_PARSING_USERDATA, _r);
    }
  }
  _bufferInitSegment(Z, ee, ae, ve) {
    if (this.state !== State.PARSING)
      return;
    this.audioOnly = !!ee.audio && !ee.video, this.altAudio && !this.audioOnly && delete ee.audio;
    const {
      audio: ye,
      video: be,
      audiovideo: Ye
    } = ee;
    if (ye) {
      let Qe = Z.audioCodec;
      const Je = navigator.userAgent.toLowerCase();
      this.audioCodecSwitch && (Qe && (Qe.indexOf("mp4a.40.5") !== -1 ? Qe = "mp4a.40.2" : Qe = "mp4a.40.5"), ye.metadata.channelCount !== 1 && Je.indexOf("firefox") === -1 && (Qe = "mp4a.40.5")), Qe && Qe.indexOf("mp4a.40.5") !== -1 && Je.indexOf("android") !== -1 && ye.container !== "audio/mpeg" && (Qe = "mp4a.40.2", this.log(`Android: force audio codec to ${Qe}`)), Z.audioCodec && Z.audioCodec !== Qe && this.log(`Swapping manifest audio codec "${Z.audioCodec}" for "${Qe}"`), ye.levelCodec = Qe, ye.id = "main", this.log(`Init audio buffer, container:${ye.container}, codecs[selected/level/parsed]=[${Qe || ""}/${Z.audioCodec || ""}/${ye.codec}]`);
    }
    be && (be.levelCodec = Z.videoCodec, be.id = "main", this.log(`Init video buffer, container:${be.container}, codecs[level/parsed]=[${Z.videoCodec || ""}/${be.codec}]`)), Ye && this.log(`Init audiovideo buffer, container:${Ye.container}, codecs[level/parsed]=[${Z.codecs}/${Ye.codec}]`), this.hls.trigger(Events.BUFFER_CODECS, ee), Object.keys(ee).forEach((Qe) => {
      const nt = ee[Qe].initSegment;
      nt != null && nt.byteLength && this.hls.trigger(Events.BUFFER_APPENDING, {
        type: Qe,
        data: nt,
        frag: ae,
        part: null,
        chunkMeta: ve,
        parent: ae.type
      });
    }), this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, PlaylistLevelType.MAIN);
  }
  backtrack(Z) {
    this.couldBacktrack = !0, this.backtrackFragment = Z, this.resetTransmuxer(), this.flushBufferGap(Z), this.fragmentTracker.removeFragment(Z), this.fragPrevious = null, this.nextLoadPosition = Z.start, this.state = State.IDLE;
  }
  checkFragmentChanged() {
    const Z = this.media;
    let ee = null;
    if (Z && Z.readyState > 1 && Z.seeking === !1) {
      const ae = Z.currentTime;
      if (BufferHelper.isBuffered(Z, ae) ? ee = this.getAppendedFrag(ae) : BufferHelper.isBuffered(Z, ae + 0.1) && (ee = this.getAppendedFrag(ae + 0.1)), ee) {
        this.backtrackFragment = null;
        const ve = this.fragPlaying, ye = ee.level;
        (!ve || ee.sn !== ve.sn || ve.level !== ye) && (this.fragPlaying = ee, this.hls.trigger(Events.FRAG_CHANGED, {
          frag: ee
        }), (!ve || ve.level !== ye) && this.hls.trigger(Events.LEVEL_SWITCHED, {
          level: ye
        }));
      }
    }
  }
  get nextLevel() {
    const Z = this.nextBufferedFrag;
    return Z ? Z.level : -1;
  }
  get currentFrag() {
    const Z = this.media;
    return Z ? this.fragPlaying || this.getAppendedFrag(Z.currentTime) : null;
  }
  get currentProgramDateTime() {
    const Z = this.media;
    if (Z) {
      const ee = Z.currentTime, ae = this.currentFrag;
      if (ae && isFiniteNumber(ee) && isFiniteNumber(ae.programDateTime)) {
        const ve = ae.programDateTime + (ee - ae.start) * 1e3;
        return new Date(ve);
      }
    }
    return null;
  }
  get currentLevel() {
    const Z = this.currentFrag;
    return Z ? Z.level : -1;
  }
  get nextBufferedFrag() {
    const Z = this.currentFrag;
    return Z ? this.followingBufferedFrag(Z) : null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}
class Hls {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return "1.5.3";
  }
  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isMSESupported() {
    return isMSESupported();
  }
  /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */
  static isSupported() {
    return isSupported();
  }
  /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */
  static getMediaSource() {
    return getMediaSource();
  }
  static get Events() {
    return Events;
  }
  static get ErrorTypes() {
    return ErrorTypes;
  }
  static get ErrorDetails() {
    return ErrorDetails;
  }
  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    return Hls.defaultConfig ? Hls.defaultConfig : hlsDefaultConfig;
  }
  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(Z) {
    Hls.defaultConfig = Z;
  }
  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(Z = {}) {
    this.config = void 0, this.userConfig = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this.started = !1, this._emitter = new EventEmitter(), this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this.url = null, this.triggeringException = void 0, enableLogs(Z.debug || !1, "Hls instance");
    const ee = this.config = mergeConfig(Hls.DefaultConfig, Z);
    this.userConfig = Z, ee.progressive && enableStreamingMode(ee);
    const {
      abrController: ae,
      bufferController: ve,
      capLevelController: ye,
      errorController: be,
      fpsController: Ye
    } = ee, Qe = new be(this), Je = this.abrController = new ae(this), nt = this.bufferController = new ve(this), st = this.capLevelController = new ye(this), ot = new Ye(this), lt = new PlaylistLoader(this), ft = new ID3TrackController(this), gt = ee.contentSteeringController, ct = gt ? new gt(this) : null, _r = this.levelController = new LevelController(this, ct), Kr = new FragmentTracker(this), Xr = new KeyLoader(this.config), Jr = this.streamController = new StreamController(this, Kr, Xr);
    st.setStreamController(Jr), ot.setStreamController(Jr);
    const ei = [lt, _r, Jr];
    ct && ei.splice(1, 0, ct), this.networkControllers = ei;
    const si = [Je, nt, st, ot, ft, Kr];
    this.audioTrackController = this.createController(ee.audioTrackController, ei);
    const ri = ee.audioStreamController;
    ri && ei.push(new ri(this, Kr, Xr)), this.subtitleTrackController = this.createController(ee.subtitleTrackController, ei);
    const ai = ee.subtitleStreamController;
    ai && ei.push(new ai(this, Kr, Xr)), this.createController(ee.timelineController, si), Xr.emeController = this.emeController = this.createController(ee.emeController, si), this.cmcdController = this.createController(ee.cmcdController, si), this.latencyController = this.createController(LatencyController, si), this.coreComponents = si, ei.push(Qe);
    const yi = Qe.onErrorOut;
    typeof yi == "function" && this.on(Events.ERROR, yi, Qe);
  }
  createController(Z, ee) {
    if (Z) {
      const ae = new Z(this);
      return ee && ee.push(ae), ae;
    }
    return null;
  }
  // Delegate the EventEmitter through the public API of Hls.js
  on(Z, ee, ae = this) {
    this._emitter.on(Z, ee, ae);
  }
  once(Z, ee, ae = this) {
    this._emitter.once(Z, ee, ae);
  }
  removeAllListeners(Z) {
    this._emitter.removeAllListeners(Z);
  }
  off(Z, ee, ae = this, ve) {
    this._emitter.off(Z, ee, ae, ve);
  }
  listeners(Z) {
    return this._emitter.listeners(Z);
  }
  emit(Z, ee, ae) {
    return this._emitter.emit(Z, ee, ae);
  }
  trigger(Z, ee) {
    if (this.config.debug)
      return this.emit(Z, Z, ee);
    try {
      return this.emit(Z, Z, ee);
    } catch (ae) {
      if (logger.error("An internal error happened while handling event " + Z + '. Error message: "' + ae.message + '". Here is a stacktrace:', ae), !this.triggeringException) {
        this.triggeringException = !0;
        const ve = Z === Events.ERROR;
        this.trigger(Events.ERROR, {
          type: ErrorTypes.OTHER_ERROR,
          details: ErrorDetails.INTERNAL_EXCEPTION,
          fatal: ve,
          event: Z,
          error: ae
        }), this.triggeringException = !1;
      }
    }
    return !1;
  }
  listenerCount(Z) {
    return this._emitter.listenerCount(Z);
  }
  /**
   * Dispose of the instance
   */
  destroy() {
    logger.log("destroy"), this.trigger(Events.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this.url = null, this.networkControllers.forEach((ee) => ee.destroy()), this.networkControllers.length = 0, this.coreComponents.forEach((ee) => ee.destroy()), this.coreComponents.length = 0;
    const Z = this.config;
    Z.xhrSetup = Z.fetchSetup = void 0, this.userConfig = null;
  }
  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(Z) {
    logger.log("attachMedia"), this._media = Z, this.trigger(Events.MEDIA_ATTACHING, {
      media: Z
    });
  }
  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    logger.log("detachMedia"), this.trigger(Events.MEDIA_DETACHING, void 0), this._media = null;
  }
  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(Z) {
    this.stopLoad();
    const ee = this.media, ae = this.url, ve = this.url = urlToolkitExports.buildAbsoluteURL(self.location.href, Z, {
      alwaysNormalize: !0
    });
    this._autoLevelCapping = -1, this._maxHdcpLevel = null, logger.log(`loadSource:${ve}`), ee && ae && (ae !== ve || this.bufferController.hasSourceTypes()) && (this.detachMedia(), this.attachMedia(ee)), this.trigger(Events.MANIFEST_LOADING, {
      url: Z
    });
  }
  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(Z = -1) {
    logger.log(`startLoad(${Z})`), this.started = !0, this.networkControllers.forEach((ee) => {
      ee.startLoad(Z);
    });
  }
  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    logger.log("stopLoad"), this.started = !1, this.networkControllers.forEach((Z) => {
      Z.stopLoad();
    });
  }
  /**
   * Resumes stream controller segment loading if previously started.
   */
  resumeBuffering() {
    this.started && this.networkControllers.forEach((Z) => {
      "fragmentLoader" in Z && Z.startLoad(-1);
    });
  }
  /**
   * Stops stream controller segment loading without changing 'started' state like stopLoad().
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    this.networkControllers.forEach((Z) => {
      "fragmentLoader" in Z && Z.stopLoad();
    });
  }
  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
  }
  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    logger.log("recoverMediaError");
    const Z = this._media;
    this.detachMedia(), Z && this.attachMedia(Z);
  }
  removeLevel(Z) {
    this.levelController.removeLevel(Z);
  }
  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const Z = this.levelController.levels;
    return Z || [];
  }
  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }
  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(Z) {
    logger.log(`set currentLevel:${Z}`), this.levelController.manualLevel = Z, this.streamController.immediateLevelSwitch();
  }
  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }
  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(Z) {
    logger.log(`set nextLevel:${Z}`), this.levelController.manualLevel = Z, this.streamController.nextLevelSwitch();
  }
  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }
  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(Z) {
    logger.log(`set loadLevel:${Z}`), this.levelController.manualLevel = Z;
  }
  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }
  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(Z) {
    this.levelController.nextLoadLevel = Z;
  }
  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }
  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(Z) {
    logger.log(`set firstLevel:${Z}`), this.levelController.firstLevel = Z;
  }
  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const Z = this.levelController.startLevel;
    return Z === -1 && this.abrController.forcedAutoLevel > -1 ? this.abrController.forcedAutoLevel : Z;
  }
  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(Z) {
    logger.log(`set startLevel:${Z}`), Z !== -1 && (Z = Math.max(Z, this.minAutoLevel)), this.levelController.startLevel = Z;
  }
  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }
  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(Z) {
    const ee = !!Z;
    ee !== this.config.capLevelToPlayerSize && (ee ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = ee);
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }
  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator: Z
    } = this.abrController;
    return Z ? Z.getEstimate() : NaN;
  }
  set bandwidthEstimate(Z) {
    this.abrController.resetEstimator(Z);
  }
  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator: Z
    } = this.abrController;
    return Z ? Z.getEstimateTTFB() : NaN;
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(Z) {
    this._autoLevelCapping !== Z && (logger.log(`set autoLevelCapping:${Z}`), this._autoLevelCapping = Z, this.levelController.checkMaxAutoUpdated());
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(Z) {
    isHdcpLevel(Z) && this._maxHdcpLevel !== Z && (this._maxHdcpLevel = Z, this.levelController.checkMaxAutoUpdated());
  }
  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }
  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }
  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels: Z,
      config: {
        minAutoBitrate: ee
      }
    } = this;
    if (!Z)
      return 0;
    const ae = Z.length;
    for (let ve = 0; ve < ae; ve++)
      if (Z[ve].maxBitrate >= ee)
        return ve;
    return 0;
  }
  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels: Z,
      autoLevelCapping: ee,
      maxHdcpLevel: ae
    } = this;
    let ve;
    if (ee === -1 && Z != null && Z.length ? ve = Z.length - 1 : ve = ee, ae)
      for (let ye = ve; ye--; ) {
        const be = Z[ye].attrs["HDCP-LEVEL"];
        if (be && be <= ae)
          return ye;
      }
    return ve;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }
  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }
  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(Z) {
    this.abrController.nextAutoLevel = Z;
  }
  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */
  setAudioOption(Z) {
    var ee;
    return (ee = this.audioTrackController) == null ? void 0 : ee.setAudioOption(Z);
  }
  /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */
  setSubtitleOption(Z) {
    var ee;
    return (ee = this.subtitleTrackController) == null || ee.setSubtitleOption(Z), null;
  }
  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const Z = this.audioTrackController;
    return Z ? Z.allAudioTracks : [];
  }
  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const Z = this.audioTrackController;
    return Z ? Z.audioTracks : [];
  }
  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const Z = this.audioTrackController;
    return Z ? Z.audioTrack : -1;
  }
  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(Z) {
    const ee = this.audioTrackController;
    ee && (ee.audioTrack = Z);
  }
  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const Z = this.subtitleTrackController;
    return Z ? Z.allSubtitleTracks : [];
  }
  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const Z = this.subtitleTrackController;
    return Z ? Z.subtitleTracks : [];
  }
  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const Z = this.subtitleTrackController;
    return Z ? Z.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }
  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(Z) {
    const ee = this.subtitleTrackController;
    ee && (ee.subtitleTrack = Z);
  }
  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const Z = this.subtitleTrackController;
    return Z ? Z.subtitleDisplay : !1;
  }
  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(Z) {
    const ee = this.subtitleTrackController;
    ee && (ee.subtitleDisplay = Z);
  }
  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }
  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(Z) {
    this.config.lowLatencyMode = Z;
  }
  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }
  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }
  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }
  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }
  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
}
Hls.defaultConfig = void 0;
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let ie = 0; ie < 256; ++ie)
  byteToHex.push((ie + 256).toString(16).slice(1));
function unsafeStringify(ie, Z = 0) {
  return byteToHex[ie[Z + 0]] + byteToHex[ie[Z + 1]] + byteToHex[ie[Z + 2]] + byteToHex[ie[Z + 3]] + "-" + byteToHex[ie[Z + 4]] + byteToHex[ie[Z + 5]] + "-" + byteToHex[ie[Z + 6]] + byteToHex[ie[Z + 7]] + "-" + byteToHex[ie[Z + 8]] + byteToHex[ie[Z + 9]] + "-" + byteToHex[ie[Z + 10]] + byteToHex[ie[Z + 11]] + byteToHex[ie[Z + 12]] + byteToHex[ie[Z + 13]] + byteToHex[ie[Z + 14]] + byteToHex[ie[Z + 15]];
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = {
  randomUUID
};
function v4(ie, Z, ee) {
  if (native.randomUUID && !Z && !ie)
    return native.randomUUID();
  ie = ie || {};
  const ae = ie.random || (ie.rng || rng)();
  if (ae[6] = ae[6] & 15 | 64, ae[8] = ae[8] & 63 | 128, Z) {
    ee = ee || 0;
    for (let ve = 0; ve < 16; ++ve)
      Z[ee + ve] = ae[ve];
    return Z;
  }
  return unsafeStringify(ae);
}
function $db6c3485150b8e66$export$1ab7ae714698c4b8(ie) {
  const [Z, ee] = reactExports.useState(void 0);
  return $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (ie) {
      ee({
        width: ie.offsetWidth,
        height: ie.offsetHeight
      });
      const ae = new ResizeObserver((ve) => {
        if (!Array.isArray(ve) || !ve.length)
          return;
        const ye = ve[0];
        let be, Ye;
        if ("borderBoxSize" in ye) {
          const Qe = ye.borderBoxSize, Je = Array.isArray(Qe) ? Qe[0] : Qe;
          be = Je.inlineSize, Ye = Je.blockSize;
        } else
          be = ie.offsetWidth, Ye = ie.offsetHeight;
        ee({
          width: be,
          height: Ye
        });
      });
      return ae.observe(ie, {
        box: "border-box"
      }), () => ae.unobserve(ie);
    } else
      ee(void 0);
  }, [
    ie
  ]), Z;
}
function $010c2913dbd2fe3d$export$5cae361ad82dce8b(ie) {
  const Z = reactExports.useRef({
    value: ie,
    previous: ie
  });
  return reactExports.useMemo(() => (Z.current.value !== ie && (Z.current.previous = Z.current.value, Z.current.value = ie), Z.current.previous), [
    ie
  ]);
}
const $ce77a8961b41be9e$var$RADIO_NAME = "Radio", [$ce77a8961b41be9e$var$createRadioContext, $ce77a8961b41be9e$export$67d2296460f1b002] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($ce77a8961b41be9e$var$RADIO_NAME), [$ce77a8961b41be9e$var$RadioProvider, $ce77a8961b41be9e$var$useRadioContext] = $ce77a8961b41be9e$var$createRadioContext($ce77a8961b41be9e$var$RADIO_NAME), $ce77a8961b41be9e$export$d7b12c4107be0d61 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeRadio: ee, name: ae, checked: ve = !1, required: ye, disabled: be, value: Ye = "on", onCheck: Qe, ...Je } = ie, [nt, st] = reactExports.useState(null), ot = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    Z,
    (gt) => st(gt)
  ), lt = reactExports.useRef(!1), ft = nt ? !!nt.closest("form") : !0;
  return /* @__PURE__ */ reactExports.createElement($ce77a8961b41be9e$var$RadioProvider, {
    scope: ee,
    checked: ve,
    disabled: be
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button",
    role: "radio",
    "aria-checked": ve,
    "data-state": $ce77a8961b41be9e$var$getState(ve),
    "data-disabled": be ? "" : void 0,
    disabled: be,
    value: Ye
  }, Je, {
    ref: ot,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onClick, (gt) => {
      ve || Qe == null || Qe(), ft && (lt.current = gt.isPropagationStopped(), lt.current || gt.stopPropagation());
    })
  })), ft && /* @__PURE__ */ reactExports.createElement($ce77a8961b41be9e$var$BubbleInput, {
    control: nt,
    bubbles: !lt.current,
    name: ae,
    value: Ye,
    checked: ve,
    required: ye,
    disabled: be,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), $ce77a8961b41be9e$var$BubbleInput = (ie) => {
  const { control: Z, checked: ee, bubbles: ae = !0, ...ve } = ie, ye = reactExports.useRef(null), be = $010c2913dbd2fe3d$export$5cae361ad82dce8b(ee), Ye = $db6c3485150b8e66$export$1ab7ae714698c4b8(Z);
  return reactExports.useEffect(() => {
    const Qe = ye.current, Je = window.HTMLInputElement.prototype, st = Object.getOwnPropertyDescriptor(Je, "checked").set;
    if (be !== ee && st) {
      const ot = new Event("click", {
        bubbles: ae
      });
      st.call(Qe, ee), Qe.dispatchEvent(ot);
    }
  }, [
    be,
    ee,
    ae
  ]), /* @__PURE__ */ reactExports.createElement("input", _extends$1({
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: ee
  }, ve, {
    tabIndex: -1,
    ref: ye,
    style: {
      ...ie.style,
      ...Ye,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function $ce77a8961b41be9e$var$getState(ie) {
  return ie ? "checked" : "unchecked";
}
const $f99a8c78507165f7$var$ARROW_KEYS = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], $f99a8c78507165f7$var$RADIO_GROUP_NAME = "RadioGroup", [$f99a8c78507165f7$var$createRadioGroupContext, $f99a8c78507165f7$export$c547093f11b76da2] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($f99a8c78507165f7$var$RADIO_GROUP_NAME, [
  $d7bdfb9eb0fdf311$export$c7109489551a4f4,
  $ce77a8961b41be9e$export$67d2296460f1b002
]), $f99a8c78507165f7$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4(), $f99a8c78507165f7$var$useRadioScope = $ce77a8961b41be9e$export$67d2296460f1b002(), [$f99a8c78507165f7$var$RadioGroupProvider, $f99a8c78507165f7$var$useRadioGroupContext] = $f99a8c78507165f7$var$createRadioGroupContext($f99a8c78507165f7$var$RADIO_GROUP_NAME), $f99a8c78507165f7$export$a98f0dcb43a68a25 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeRadioGroup: ee, name: ae, defaultValue: ve, value: ye, required: be = !1, disabled: Ye = !1, orientation: Qe, dir: Je, loop: nt = !0, onValueChange: st, ...ot } = ie, lt = $f99a8c78507165f7$var$useRovingFocusGroupScope(ee), ft = $f631663db3294ace$export$b39126d51d94e6f3(Je), [gt, ct] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: ye,
    defaultProp: ve,
    onChange: st
  });
  return /* @__PURE__ */ reactExports.createElement($f99a8c78507165f7$var$RadioGroupProvider, {
    scope: ee,
    name: ae,
    required: be,
    disabled: Ye,
    value: gt,
    onValueChange: ct
  }, /* @__PURE__ */ reactExports.createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends$1({
    asChild: !0
  }, lt, {
    orientation: Qe,
    dir: ft,
    loop: nt
  }), /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    role: "radiogroup",
    "aria-required": be,
    "aria-orientation": Qe,
    "data-disabled": Ye ? "" : void 0,
    dir: ft
  }, ot, {
    ref: Z
  }))));
}), $f99a8c78507165f7$var$ITEM_NAME = "RadioGroupItem", $f99a8c78507165f7$export$9f866c100ef519e4 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeRadioGroup: ee, disabled: ae, ...ve } = ie, ye = $f99a8c78507165f7$var$useRadioGroupContext($f99a8c78507165f7$var$ITEM_NAME, ee), be = ye.disabled || ae, Ye = $f99a8c78507165f7$var$useRovingFocusGroupScope(ee), Qe = $f99a8c78507165f7$var$useRadioScope(ee), Je = reactExports.useRef(null), nt = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, Je), st = ye.value === ve.value, ot = reactExports.useRef(!1);
  return reactExports.useEffect(() => {
    const lt = (gt) => {
      $f99a8c78507165f7$var$ARROW_KEYS.includes(gt.key) && (ot.current = !0);
    }, ft = () => ot.current = !1;
    return document.addEventListener("keydown", lt), document.addEventListener("keyup", ft), () => {
      document.removeEventListener("keydown", lt), document.removeEventListener("keyup", ft);
    };
  }, []), /* @__PURE__ */ reactExports.createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends$1({
    asChild: !0
  }, Ye, {
    focusable: !be,
    active: st
  }), /* @__PURE__ */ reactExports.createElement($ce77a8961b41be9e$export$d7b12c4107be0d61, _extends$1({
    disabled: be,
    required: ye.required,
    checked: st
  }, Qe, ve, {
    name: ye.name,
    ref: nt,
    onCheck: () => ye.onValueChange(ve.value),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10((lt) => {
      lt.key === "Enter" && lt.preventDefault();
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ve.onFocus, () => {
      var lt;
      ot.current && ((lt = Je.current) === null || lt === void 0 || lt.click());
    })
  })));
}), $f99a8c78507165f7$export$be92b6f5f03c0fe9 = $f99a8c78507165f7$export$a98f0dcb43a68a25, $f99a8c78507165f7$export$6d08773d2e66f8f2 = $f99a8c78507165f7$export$9f866c100ef519e4;
function ParserError(ie, Z) {
  this.message = ie, this.error = Z;
}
ParserError.prototype = Object.create(Error.prototype);
const TIMESTAMP_REGEXP = /([0-9]+)?:?([0-9]{2}):([0-9]{2}\.[0-9]{2,3})/;
function parse$3(ie, Z) {
  Z || (Z = {});
  const { meta: ee = !1, strict: ae = !0 } = Z;
  if (typeof ie != "string")
    throw new ParserError("Input must be a string");
  ie = ie.trim(), ie = ie.replace(/\r\n/g, `
`), ie = ie.replace(/\r/g, `
`);
  const ve = ie.split(`

`), ye = ve.shift();
  if (!ye.startsWith("WEBVTT"))
    throw new ParserError('Must start with "WEBVTT"');
  const be = ye.split(`
`), Ye = be[0].replace("WEBVTT", "");
  if (Ye.length > 0 && Ye[0] !== " " && Ye[0] !== "	")
    throw new ParserError("Header comment must start with space or tab");
  if (ve.length === 0 && be.length === 1)
    return { valid: !0, strict: ae, cues: [], errors: [] };
  if (!ee && be.length > 1 && be[1] !== "")
    throw new ParserError("Missing blank line after signature");
  const { cues: Qe, errors: Je } = parseCues(ve, ae);
  if (ae && Je.length > 0)
    throw Je[0];
  const nt = ee ? parseMeta(be) : null, st = { valid: Je.length === 0, strict: ae, cues: Qe, errors: Je };
  return ee && (st.meta = nt), st;
}
function parseMeta(ie) {
  const Z = {};
  return ie.slice(1).forEach((ee) => {
    const ae = ee.indexOf(":"), ve = ee.slice(0, ae).trim(), ye = ee.slice(ae + 1).trim();
    Z[ve] = ye;
  }), Object.keys(Z).length > 0 ? Z : null;
}
function parseCues(ie, Z) {
  const ee = [];
  return {
    cues: ie.map((ve, ye) => {
      try {
        return parseCue(ve, ye, Z);
      } catch (be) {
        return ee.push(be), null;
      }
    }).filter(Boolean),
    errors: ee
  };
}
function parseCue(ie, Z, ee) {
  let ae = "", ve = 0, ye = 0.01, be = "", Ye = "";
  const Qe = ie.split(`
`).filter(Boolean);
  if (Qe.length > 0 && Qe[0].trim().startsWith("NOTE"))
    return null;
  if (Qe.length === 1 && !Qe[0].includes("-->"))
    throw new ParserError(`Cue identifier cannot be standalone (cue #${Z})`);
  if (Qe.length > 1 && !(Qe[0].includes("-->") || Qe[1].includes("-->"))) {
    const nt = `Cue identifier needs to be followed by timestamp (cue #${Z})`;
    throw new ParserError(nt);
  }
  Qe.length > 1 && Qe[1].includes("-->") && (ae = Qe.shift());
  const Je = typeof Qe[0] == "string" && Qe[0].split(" --> ");
  if (Je.length !== 2 || !validTimestamp(Je[0]) || !validTimestamp(Je[1]))
    throw new ParserError(`Invalid cue timestamp (cue #${Z})`);
  if (ve = parseTimestamp(Je[0]), ye = parseTimestamp(Je[1]), ee) {
    if (ve > ye)
      throw new ParserError(`Start timestamp greater than end (cue #${Z})`);
    if (ye <= ve)
      throw new ParserError(`End must be greater than start (cue #${Z})`);
  }
  if (!ee && ye < ve)
    throw new ParserError(
      `End must be greater or equal to start when not strict (cue #${Z})`
    );
  return Ye = Je[1].replace(TIMESTAMP_REGEXP, "").trim(), Qe.shift(), be = Qe.join(`
`), be ? { identifier: ae, start: ve, end: ye, text: be, styles: Ye } : !1;
}
function validTimestamp(ie) {
  return TIMESTAMP_REGEXP.test(ie);
}
function parseTimestamp(ie) {
  const Z = ie.match(TIMESTAMP_REGEXP);
  let ee = parseFloat(Z[1] || 0) * 60 * 60;
  return ee += parseFloat(Z[2]) * 60, ee += parseFloat(Z[3]), ee;
}
var parser = { ParserError, parse: parse$3 };
function CompilerError(ie, Z) {
  this.message = ie, this.error = Z;
}
CompilerError.prototype = Object.create(Error.prototype);
function compile$1(ie) {
  if (!ie)
    throw new CompilerError("Input must be non-null");
  if (typeof ie != "object")
    throw new CompilerError("Input must be an object");
  if (Array.isArray(ie))
    throw new CompilerError("Input cannot be array");
  if (!ie.valid)
    throw new CompilerError("Input must be valid");
  let Z = `WEBVTT
`;
  if (ie.meta) {
    if (typeof ie.meta != "object" || Array.isArray(ie.meta))
      throw new CompilerError("Metadata must be an object");
    Object.entries(ie.meta).forEach((ae) => {
      if (typeof ae[1] != "string")
        throw new CompilerError(`Metadata value for "${ae[0]}" must be string`);
      Z += `${ae[0]}: ${ae[1]}
`;
    });
  }
  let ee = null;
  return ie.cues.forEach((ae, ve) => {
    if (ee && ee > ae.start)
      throw new CompilerError(`Cue number ${ve} is not in chronological order`);
    ee = ae.start, Z += `
`, Z += compileCue(ae), Z += `
`;
  }), Z;
}
function compileCue(ie) {
  if (typeof ie != "object")
    throw new CompilerError("Cue malformed: not of type object");
  if (typeof ie.identifier != "string" && typeof ie.identifier != "number" && ie.identifier !== null)
    throw new CompilerError(`Cue malformed: identifier value is not a string.
    ${JSON.stringify(ie)}`);
  if (isNaN(ie.start))
    throw new CompilerError(`Cue malformed: null start value.
    ${JSON.stringify(ie)}`);
  if (isNaN(ie.end))
    throw new CompilerError(`Cue malformed: null end value.
    ${JSON.stringify(ie)}`);
  if (ie.start >= ie.end)
    throw new CompilerError(`Cue malformed: start timestamp greater than end
    ${JSON.stringify(ie)}`);
  if (typeof ie.text != "string")
    throw new CompilerError(`Cue malformed: null text value.
    ${JSON.stringify(ie)}`);
  if (typeof ie.styles != "string")
    throw new CompilerError(`Cue malformed: null styles value.
    ${JSON.stringify(ie)}`);
  let Z = "";
  ie.identifier.length > 0 && (Z += `${ie.identifier}
`);
  const ee = convertTimestamp(ie.start), ae = convertTimestamp(ie.end);
  return Z += `${ee} --> ${ae}`, Z += ie.styles ? ` ${ie.styles}` : "", Z += `
${ie.text}`, Z;
}
function convertTimestamp(ie) {
  const Z = pad$1(calculateHours(ie), 2), ee = pad$1(calculateMinutes(ie), 2), ae = pad$1(calculateSeconds(ie), 2), ve = pad$1(calculateMs(ie), 3);
  return `${Z}:${ee}:${ae}.${ve}`;
}
function pad$1(ie, Z) {
  let ee = `${ie}`;
  for (; ee.length < Z; )
    ee = `0${ee}`;
  return ee;
}
function calculateHours(ie) {
  return Math.floor(ie / 60 / 60);
}
function calculateMinutes(ie) {
  return Math.floor(ie / 60) % 60;
}
function calculateSeconds(ie) {
  return Math.floor(ie % 60);
}
function calculateMs(ie) {
  return Math.floor((ie % 1).toFixed(4) * 1e3);
}
var compiler = { CompilerError, compile: compile$1 };
const parse$2 = parser.parse;
function segment$2(ie, Z) {
  Z = Z || 10;
  const ee = parse$2(ie), ae = [];
  let ve = [], ye = null, be = 0, Ye = 0;
  return ee.cues.forEach((Qe, Je) => {
    const nt = Je === 0, st = Je === ee.cues.length - 1, ot = Qe.start, lt = Qe.end, ft = st ? 1 / 0 : ee.cues[Je + 1].start, gt = nt ? lt : lt - ot, ct = nt ? 0 : ot - ee.cues[Je - 1].end;
    be = be + gt + ct, `${Je}`, ae.length + 1, ye && (ve.push(ye), be += ye.end - Ye, ye = null), ve.push(Qe);
    let _r = ft - lt < Z && ct < Z && be > Z;
    if (shouldSegment(
      Ye,
      Z,
      ft,
      ct
    )) {
      const Kr = segmentDuration(
        st,
        lt,
        Z,
        be,
        Ye
      );
      ae.push({ duration: Kr, cues: ve }), Ye += Kr, be = 0, ve = [];
    } else
      _r = !1;
    _r && (ye = Qe);
  }), ae;
}
function shouldSegment(ie, Z, ee, ae) {
  const ve = alignToSegmentLength(ae, Z);
  return (ae <= Z || ve + ie < ee) && ee - ie >= Z;
}
function segmentDuration(ie, Z, ee, ae, ve) {
  let ye = ee;
  return ae > ee && (ye = alignToSegmentLength(ae - ee, ee)), ie ? ye = parseFloat((Z - ve).toFixed(2)) : ye = Math.round(ye), ye;
}
function alignToSegmentLength(ie, Z) {
  return ie += Z - ie % Z, ie;
}
function debug(ie) {
}
var segmenter = { segment: segment$2 };
const segment$1 = segmenter.segment;
function hlsSegment(ie, Z, ee) {
  typeof ee > "u" && (ee = "900000");
  const ae = segment$1(ie, Z), ve = [];
  return ae.forEach((ye, be) => {
    const Ye = `WEBVTT
X-TIMESTAMP-MAP=MPEGTS:${ee},LOCAL:00:00:00.000

${printableCues(ye.cues)}
`, Qe = generateSegmentFilename(be);
    ve.push({ filename: Qe, content: Ye });
  }), ve;
}
function hlsSegmentPlaylist(ie, Z) {
  const ee = segment$1(ie, Z), ae = printableSegments(ee);
  return `#EXTM3U
#EXT-X-TARGETDURATION:${Math.round(findLongestSegment(ee))}
#EXT-X-VERSION:3
#EXT-X-MEDIA-SEQUENCE:0
#EXT-X-PLAYLIST-TYPE:VOD
${ae}
#EXT-X-ENDLIST
`;
}
function pad(ie, Z) {
  return `${"0".repeat(Math.max(0, Z - ie.toString().length))}${ie}`;
}
function generateSegmentFilename(ie) {
  return `${ie}.vtt`;
}
function printableSegments(ie) {
  const Z = [];
  return ie.forEach((ee, ae) => {
    Z.push(`#EXTINF:${ee.duration.toFixed(5)},
${generateSegmentFilename(ae)}`);
  }), Z.join(`
`);
}
function findLongestSegment(ie) {
  let Z = 0;
  return ie.forEach((ee) => {
    ee.duration > Z && (Z = ee.duration);
  }), Z;
}
function printableCues(ie) {
  const Z = [];
  return ie.forEach((ee) => {
    Z.push(printableCue(ee));
  }), Z.join(`

`);
}
function printableCue(ie) {
  const Z = [];
  ie.identifier && Z.push(ie.identifier);
  const ee = printableTimestamp(ie.start), ae = printableTimestamp(ie.end), ve = ie.styles ? `${ie.styles}` : "";
  return Z.push(`${ee} --> ${ae} ${ve}`), Z.push(ie.text), Z.join(`
`);
}
function printableTimestamp(ie) {
  const Z = (ie % 1).toFixed(3);
  ie = Math.round(ie - Z);
  const ee = Math.floor(ie / 3600), ae = Math.floor((ie - ee * 3600) / 60), ve = ie - ee * 3600 - ae * 60;
  return `${`${pad(ee, 2)}:`}${pad(ae, 2)}:${pad(ve, 2)}.${pad(Z * 1e3, 3)}`;
}
var hls$1 = { hlsSegment, hlsSegmentPlaylist };
const parse$1 = parser.parse, compile = compiler.compile, segment = segmenter.segment, hls = hls$1;
var nodeWebvtt = { parse: parse$1, compile, segment, hls };
function $addc16e1bbe58fd0$export$3a72a57244d6e765(ie, Z = globalThis == null ? void 0 : globalThis.document) {
  const ee = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(ie);
  reactExports.useEffect(() => {
    const ae = (ve) => {
      ve.key === "Escape" && ee(ve);
    };
    return Z.addEventListener("keydown", ae), () => Z.removeEventListener("keydown", ae);
  }, [
    ee,
    Z
  ]);
}
const $5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update", $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside", $5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $5cb92bef7577960e$var$originalBodyPointerEvents;
const $5cb92bef7577960e$var$DismissableLayerContext = /* @__PURE__ */ reactExports.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), $5cb92bef7577960e$export$177fb62ff3ec1f22 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  var ee;
  const { disableOutsidePointerEvents: ae = !1, onEscapeKeyDown: ve, onPointerDownOutside: ye, onFocusOutside: be, onInteractOutside: Ye, onDismiss: Qe, ...Je } = ie, nt = reactExports.useContext($5cb92bef7577960e$var$DismissableLayerContext), [st, ot] = reactExports.useState(null), lt = (ee = st == null ? void 0 : st.ownerDocument) !== null && ee !== void 0 ? ee : globalThis == null ? void 0 : globalThis.document, [, ft] = reactExports.useState({}), gt = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    Z,
    (ai) => ot(ai)
  ), ct = Array.from(nt.layers), [_r] = [
    ...nt.layersWithOutsidePointerEventsDisabled
  ].slice(-1), Kr = ct.indexOf(_r), Xr = st ? ct.indexOf(st) : -1, Jr = nt.layersWithOutsidePointerEventsDisabled.size > 0, ei = Xr >= Kr, si = $5cb92bef7577960e$var$usePointerDownOutside((ai) => {
    const yi = ai.target, pi = [
      ...nt.branches
    ].some(
      (di) => di.contains(yi)
    );
    !ei || pi || (ye == null || ye(ai), Ye == null || Ye(ai), ai.defaultPrevented || Qe == null || Qe());
  }, lt), ri = $5cb92bef7577960e$var$useFocusOutside((ai) => {
    const yi = ai.target;
    [
      ...nt.branches
    ].some(
      (di) => di.contains(yi)
    ) || (be == null || be(ai), Ye == null || Ye(ai), ai.defaultPrevented || Qe == null || Qe());
  }, lt);
  return $addc16e1bbe58fd0$export$3a72a57244d6e765((ai) => {
    Xr === nt.layers.size - 1 && (ve == null || ve(ai), !ai.defaultPrevented && Qe && (ai.preventDefault(), Qe()));
  }, lt), reactExports.useEffect(() => {
    if (st)
      return ae && (nt.layersWithOutsidePointerEventsDisabled.size === 0 && ($5cb92bef7577960e$var$originalBodyPointerEvents = lt.body.style.pointerEvents, lt.body.style.pointerEvents = "none"), nt.layersWithOutsidePointerEventsDisabled.add(st)), nt.layers.add(st), $5cb92bef7577960e$var$dispatchUpdate(), () => {
        ae && nt.layersWithOutsidePointerEventsDisabled.size === 1 && (lt.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents);
      };
  }, [
    st,
    lt,
    ae,
    nt
  ]), reactExports.useEffect(() => () => {
    st && (nt.layers.delete(st), nt.layersWithOutsidePointerEventsDisabled.delete(st), $5cb92bef7577960e$var$dispatchUpdate());
  }, [
    st,
    nt
  ]), reactExports.useEffect(() => {
    const ai = () => ft({});
    return document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, ai), () => document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, ai);
  }, []), /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, Je, {
    ref: gt,
    style: {
      pointerEvents: Jr ? ei ? "auto" : "none" : void 0,
      ...ie.style
    },
    onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onFocusCapture, ri.onFocusCapture),
    onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onBlurCapture, ri.onBlurCapture),
    onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onPointerDownCapture, si.onPointerDownCapture)
  }));
});
function $5cb92bef7577960e$var$usePointerDownOutside(ie, Z = globalThis == null ? void 0 : globalThis.document) {
  const ee = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(ie), ae = reactExports.useRef(!1), ve = reactExports.useRef(() => {
  });
  return reactExports.useEffect(() => {
    const ye = (Ye) => {
      if (Ye.target && !ae.current) {
        let Je = function() {
          $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, ee, Qe, {
            discrete: !0
          });
        };
        const Qe = {
          originalEvent: Ye
        };
        Ye.pointerType === "touch" ? (Z.removeEventListener("click", ve.current), ve.current = Je, Z.addEventListener("click", ve.current, {
          once: !0
        })) : Je();
      } else
        Z.removeEventListener("click", ve.current);
      ae.current = !1;
    }, be = window.setTimeout(() => {
      Z.addEventListener("pointerdown", ye);
    }, 0);
    return () => {
      window.clearTimeout(be), Z.removeEventListener("pointerdown", ye), Z.removeEventListener("click", ve.current);
    };
  }, [
    Z,
    ee
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => ae.current = !0
  };
}
function $5cb92bef7577960e$var$useFocusOutside(ie, Z = globalThis == null ? void 0 : globalThis.document) {
  const ee = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(ie), ae = reactExports.useRef(!1);
  return reactExports.useEffect(() => {
    const ve = (ye) => {
      ye.target && !ae.current && $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, ee, {
        originalEvent: ye
      }, {
        discrete: !1
      });
    };
    return Z.addEventListener("focusin", ve), () => Z.removeEventListener("focusin", ve);
  }, [
    Z,
    ee
  ]), {
    onFocusCapture: () => ae.current = !0,
    onBlurCapture: () => ae.current = !1
  };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
  const ie = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
  document.dispatchEvent(ie);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(ie, Z, ee, { discrete: ae }) {
  const ve = ee.originalEvent.target, ye = new CustomEvent(ie, {
    bubbles: !1,
    cancelable: !0,
    detail: ee
  });
  Z && ve.addEventListener(ie, Z, {
    once: !0
  }), ae ? $8927f6f2acc4f386$export$6d1a0317bde7de7f(ve, ye) : ve.dispatchEvent(ye);
}
let $3db38b7d1fb3fe6a$var$count = 0;
function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
  reactExports.useEffect(() => {
    var ie, Z;
    const ee = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (ie = ee[0]) !== null && ie !== void 0 ? ie : $3db38b7d1fb3fe6a$var$createFocusGuard()), document.body.insertAdjacentElement("beforeend", (Z = ee[1]) !== null && Z !== void 0 ? Z : $3db38b7d1fb3fe6a$var$createFocusGuard()), $3db38b7d1fb3fe6a$var$count++, () => {
      $3db38b7d1fb3fe6a$var$count === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (ae) => ae.remove()
      ), $3db38b7d1fb3fe6a$var$count--;
    };
  }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
  const ie = document.createElement("span");
  return ie.setAttribute("data-radix-focus-guard", ""), ie.tabIndex = 0, ie.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", ie;
}
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount", $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount", $d3863c46a17e8a28$var$EVENT_OPTIONS = {
  bubbles: !1,
  cancelable: !0
}, $d3863c46a17e8a28$export$20e40289641fbbb6 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { loop: ee = !1, trapped: ae = !1, onMountAutoFocus: ve, onUnmountAutoFocus: ye, ...be } = ie, [Ye, Qe] = reactExports.useState(null), Je = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(ve), nt = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(ye), st = reactExports.useRef(null), ot = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    Z,
    (gt) => Qe(gt)
  ), lt = reactExports.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  reactExports.useEffect(() => {
    if (ae) {
      let gt = function(Xr) {
        if (lt.paused || !Ye)
          return;
        const Jr = Xr.target;
        Ye.contains(Jr) ? st.current = Jr : $d3863c46a17e8a28$var$focus(st.current, {
          select: !0
        });
      }, ct = function(Xr) {
        if (lt.paused || !Ye)
          return;
        const Jr = Xr.relatedTarget;
        Jr !== null && (Ye.contains(Jr) || $d3863c46a17e8a28$var$focus(st.current, {
          select: !0
        }));
      }, _r = function(Xr) {
        if (document.activeElement === document.body)
          for (const ei of Xr)
            ei.removedNodes.length > 0 && $d3863c46a17e8a28$var$focus(Ye);
      };
      document.addEventListener("focusin", gt), document.addEventListener("focusout", ct);
      const Kr = new MutationObserver(_r);
      return Ye && Kr.observe(Ye, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", gt), document.removeEventListener("focusout", ct), Kr.disconnect();
      };
    }
  }, [
    ae,
    Ye,
    lt.paused
  ]), reactExports.useEffect(() => {
    if (Ye) {
      $d3863c46a17e8a28$var$focusScopesStack.add(lt);
      const gt = document.activeElement;
      if (!Ye.contains(gt)) {
        const _r = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
        Ye.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, Je), Ye.dispatchEvent(_r), _r.defaultPrevented || ($d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(Ye)), {
          select: !0
        }), document.activeElement === gt && $d3863c46a17e8a28$var$focus(Ye));
      }
      return () => {
        Ye.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, Je), setTimeout(() => {
          const _r = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
          Ye.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, nt), Ye.dispatchEvent(_r), _r.defaultPrevented || $d3863c46a17e8a28$var$focus(gt ?? document.body, {
            select: !0
          }), Ye.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, nt), $d3863c46a17e8a28$var$focusScopesStack.remove(lt);
        }, 0);
      };
    }
  }, [
    Ye,
    Je,
    nt,
    lt
  ]);
  const ft = reactExports.useCallback((gt) => {
    if (!ee && !ae || lt.paused)
      return;
    const ct = gt.key === "Tab" && !gt.altKey && !gt.ctrlKey && !gt.metaKey, _r = document.activeElement;
    if (ct && _r) {
      const Kr = gt.currentTarget, [Xr, Jr] = $d3863c46a17e8a28$var$getTabbableEdges(Kr);
      Xr && Jr ? !gt.shiftKey && _r === Jr ? (gt.preventDefault(), ee && $d3863c46a17e8a28$var$focus(Xr, {
        select: !0
      })) : gt.shiftKey && _r === Xr && (gt.preventDefault(), ee && $d3863c46a17e8a28$var$focus(Jr, {
        select: !0
      })) : _r === Kr && gt.preventDefault();
    }
  }, [
    ee,
    ae,
    lt.paused
  ]);
  return /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    tabIndex: -1
  }, be, {
    ref: ot,
    onKeyDown: ft
  }));
});
function $d3863c46a17e8a28$var$focusFirst(ie, { select: Z = !1 } = {}) {
  const ee = document.activeElement;
  for (const ae of ie)
    if ($d3863c46a17e8a28$var$focus(ae, {
      select: Z
    }), document.activeElement !== ee)
      return;
}
function $d3863c46a17e8a28$var$getTabbableEdges(ie) {
  const Z = $d3863c46a17e8a28$var$getTabbableCandidates(ie), ee = $d3863c46a17e8a28$var$findVisible(Z, ie), ae = $d3863c46a17e8a28$var$findVisible(Z.reverse(), ie);
  return [
    ee,
    ae
  ];
}
function $d3863c46a17e8a28$var$getTabbableCandidates(ie) {
  const Z = [], ee = document.createTreeWalker(ie, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (ae) => {
      const ve = ae.tagName === "INPUT" && ae.type === "hidden";
      return ae.disabled || ae.hidden || ve ? NodeFilter.FILTER_SKIP : ae.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; ee.nextNode(); )
    Z.push(ee.currentNode);
  return Z;
}
function $d3863c46a17e8a28$var$findVisible(ie, Z) {
  for (const ee of ie)
    if (!$d3863c46a17e8a28$var$isHidden(ee, {
      upTo: Z
    }))
      return ee;
}
function $d3863c46a17e8a28$var$isHidden(ie, { upTo: Z }) {
  if (getComputedStyle(ie).visibility === "hidden")
    return !0;
  for (; ie; ) {
    if (Z !== void 0 && ie === Z)
      return !1;
    if (getComputedStyle(ie).display === "none")
      return !0;
    ie = ie.parentElement;
  }
  return !1;
}
function $d3863c46a17e8a28$var$isSelectableInput(ie) {
  return ie instanceof HTMLInputElement && "select" in ie;
}
function $d3863c46a17e8a28$var$focus(ie, { select: Z = !1 } = {}) {
  if (ie && ie.focus) {
    const ee = document.activeElement;
    ie.focus({
      preventScroll: !0
    }), ie !== ee && $d3863c46a17e8a28$var$isSelectableInput(ie) && Z && ie.select();
  }
}
const $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
  let ie = [];
  return {
    add(Z) {
      const ee = ie[0];
      Z !== ee && (ee == null || ee.pause()), ie = $d3863c46a17e8a28$var$arrayRemove(ie, Z), ie.unshift(Z);
    },
    remove(Z) {
      var ee;
      ie = $d3863c46a17e8a28$var$arrayRemove(ie, Z), (ee = ie[0]) === null || ee === void 0 || ee.resume();
    }
  };
}
function $d3863c46a17e8a28$var$arrayRemove(ie, Z) {
  const ee = [
    ...ie
  ], ae = ee.indexOf(Z);
  return ae !== -1 && ee.splice(ae, 1), ee;
}
function $d3863c46a17e8a28$var$removeLinks(ie) {
  return ie.filter(
    (Z) => Z.tagName !== "A"
  );
}
const sides = ["top", "right", "bottom", "left"], min = Math.min, max = Math.max, round = Math.round, floor = Math.floor, createCoords = (ie) => ({
  x: ie,
  y: ie
}), oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(ie, Z, ee) {
  return max(ie, min(Z, ee));
}
function evaluate(ie, Z) {
  return typeof ie == "function" ? ie(Z) : ie;
}
function getSide(ie) {
  return ie.split("-")[0];
}
function getAlignment(ie) {
  return ie.split("-")[1];
}
function getOppositeAxis(ie) {
  return ie === "x" ? "y" : "x";
}
function getAxisLength(ie) {
  return ie === "y" ? "height" : "width";
}
function getSideAxis(ie) {
  return ["top", "bottom"].includes(getSide(ie)) ? "y" : "x";
}
function getAlignmentAxis(ie) {
  return getOppositeAxis(getSideAxis(ie));
}
function getAlignmentSides(ie, Z, ee) {
  ee === void 0 && (ee = !1);
  const ae = getAlignment(ie), ve = getAlignmentAxis(ie), ye = getAxisLength(ve);
  let be = ve === "x" ? ae === (ee ? "end" : "start") ? "right" : "left" : ae === "start" ? "bottom" : "top";
  return Z.reference[ye] > Z.floating[ye] && (be = getOppositePlacement(be)), [be, getOppositePlacement(be)];
}
function getExpandedPlacements(ie) {
  const Z = getOppositePlacement(ie);
  return [getOppositeAlignmentPlacement(ie), Z, getOppositeAlignmentPlacement(Z)];
}
function getOppositeAlignmentPlacement(ie) {
  return ie.replace(/start|end/g, (Z) => oppositeAlignmentMap[Z]);
}
function getSideList(ie, Z, ee) {
  const ae = ["left", "right"], ve = ["right", "left"], ye = ["top", "bottom"], be = ["bottom", "top"];
  switch (ie) {
    case "top":
    case "bottom":
      return ee ? Z ? ve : ae : Z ? ae : ve;
    case "left":
    case "right":
      return Z ? ye : be;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(ie, Z, ee, ae) {
  const ve = getAlignment(ie);
  let ye = getSideList(getSide(ie), ee === "start", ae);
  return ve && (ye = ye.map((be) => be + "-" + ve), Z && (ye = ye.concat(ye.map(getOppositeAlignmentPlacement)))), ye;
}
function getOppositePlacement(ie) {
  return ie.replace(/left|right|bottom|top/g, (Z) => oppositeSideMap[Z]);
}
function expandPaddingObject(ie) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...ie
  };
}
function getPaddingObject(ie) {
  return typeof ie != "number" ? expandPaddingObject(ie) : {
    top: ie,
    right: ie,
    bottom: ie,
    left: ie
  };
}
function rectToClientRect(ie) {
  return {
    ...ie,
    top: ie.y,
    left: ie.x,
    right: ie.x + ie.width,
    bottom: ie.y + ie.height
  };
}
function computeCoordsFromPlacement(ie, Z, ee) {
  let {
    reference: ae,
    floating: ve
  } = ie;
  const ye = getSideAxis(Z), be = getAlignmentAxis(Z), Ye = getAxisLength(be), Qe = getSide(Z), Je = ye === "y", nt = ae.x + ae.width / 2 - ve.width / 2, st = ae.y + ae.height / 2 - ve.height / 2, ot = ae[Ye] / 2 - ve[Ye] / 2;
  let lt;
  switch (Qe) {
    case "top":
      lt = {
        x: nt,
        y: ae.y - ve.height
      };
      break;
    case "bottom":
      lt = {
        x: nt,
        y: ae.y + ae.height
      };
      break;
    case "right":
      lt = {
        x: ae.x + ae.width,
        y: st
      };
      break;
    case "left":
      lt = {
        x: ae.x - ve.width,
        y: st
      };
      break;
    default:
      lt = {
        x: ae.x,
        y: ae.y
      };
  }
  switch (getAlignment(Z)) {
    case "start":
      lt[be] -= ot * (ee && Je ? -1 : 1);
      break;
    case "end":
      lt[be] += ot * (ee && Je ? -1 : 1);
      break;
  }
  return lt;
}
const computePosition$1 = async (ie, Z, ee) => {
  const {
    placement: ae = "bottom",
    strategy: ve = "absolute",
    middleware: ye = [],
    platform: be
  } = ee, Ye = ye.filter(Boolean), Qe = await (be.isRTL == null ? void 0 : be.isRTL(Z));
  let Je = await be.getElementRects({
    reference: ie,
    floating: Z,
    strategy: ve
  }), {
    x: nt,
    y: st
  } = computeCoordsFromPlacement(Je, ae, Qe), ot = ae, lt = {}, ft = 0;
  for (let gt = 0; gt < Ye.length; gt++) {
    const {
      name: ct,
      fn: _r
    } = Ye[gt], {
      x: Kr,
      y: Xr,
      data: Jr,
      reset: ei
    } = await _r({
      x: nt,
      y: st,
      initialPlacement: ae,
      placement: ot,
      strategy: ve,
      middlewareData: lt,
      rects: Je,
      platform: be,
      elements: {
        reference: ie,
        floating: Z
      }
    });
    nt = Kr ?? nt, st = Xr ?? st, lt = {
      ...lt,
      [ct]: {
        ...lt[ct],
        ...Jr
      }
    }, ei && ft <= 50 && (ft++, typeof ei == "object" && (ei.placement && (ot = ei.placement), ei.rects && (Je = ei.rects === !0 ? await be.getElementRects({
      reference: ie,
      floating: Z,
      strategy: ve
    }) : ei.rects), {
      x: nt,
      y: st
    } = computeCoordsFromPlacement(Je, ot, Qe)), gt = -1);
  }
  return {
    x: nt,
    y: st,
    placement: ot,
    strategy: ve,
    middlewareData: lt
  };
};
async function detectOverflow(ie, Z) {
  var ee;
  Z === void 0 && (Z = {});
  const {
    x: ae,
    y: ve,
    platform: ye,
    rects: be,
    elements: Ye,
    strategy: Qe
  } = ie, {
    boundary: Je = "clippingAncestors",
    rootBoundary: nt = "viewport",
    elementContext: st = "floating",
    altBoundary: ot = !1,
    padding: lt = 0
  } = evaluate(Z, ie), ft = getPaddingObject(lt), ct = Ye[ot ? st === "floating" ? "reference" : "floating" : st], _r = rectToClientRect(await ye.getClippingRect({
    element: (ee = await (ye.isElement == null ? void 0 : ye.isElement(ct))) == null || ee ? ct : ct.contextElement || await (ye.getDocumentElement == null ? void 0 : ye.getDocumentElement(Ye.floating)),
    boundary: Je,
    rootBoundary: nt,
    strategy: Qe
  })), Kr = st === "floating" ? {
    ...be.floating,
    x: ae,
    y: ve
  } : be.reference, Xr = await (ye.getOffsetParent == null ? void 0 : ye.getOffsetParent(Ye.floating)), Jr = await (ye.isElement == null ? void 0 : ye.isElement(Xr)) ? await (ye.getScale == null ? void 0 : ye.getScale(Xr)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, ei = rectToClientRect(ye.convertOffsetParentRelativeRectToViewportRelativeRect ? await ye.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: Ye,
    rect: Kr,
    offsetParent: Xr,
    strategy: Qe
  }) : Kr);
  return {
    top: (_r.top - ei.top + ft.top) / Jr.y,
    bottom: (ei.bottom - _r.bottom + ft.bottom) / Jr.y,
    left: (_r.left - ei.left + ft.left) / Jr.x,
    right: (ei.right - _r.right + ft.right) / Jr.x
  };
}
const arrow$2 = (ie) => ({
  name: "arrow",
  options: ie,
  async fn(Z) {
    const {
      x: ee,
      y: ae,
      placement: ve,
      rects: ye,
      platform: be,
      elements: Ye,
      middlewareData: Qe
    } = Z, {
      element: Je,
      padding: nt = 0
    } = evaluate(ie, Z) || {};
    if (Je == null)
      return {};
    const st = getPaddingObject(nt), ot = {
      x: ee,
      y: ae
    }, lt = getAlignmentAxis(ve), ft = getAxisLength(lt), gt = await be.getDimensions(Je), ct = lt === "y", _r = ct ? "top" : "left", Kr = ct ? "bottom" : "right", Xr = ct ? "clientHeight" : "clientWidth", Jr = ye.reference[ft] + ye.reference[lt] - ot[lt] - ye.floating[ft], ei = ot[lt] - ye.reference[lt], si = await (be.getOffsetParent == null ? void 0 : be.getOffsetParent(Je));
    let ri = si ? si[Xr] : 0;
    (!ri || !await (be.isElement == null ? void 0 : be.isElement(si))) && (ri = Ye.floating[Xr] || ye.floating[ft]);
    const ai = Jr / 2 - ei / 2, yi = ri / 2 - gt[ft] / 2 - 1, pi = min(st[_r], yi), di = min(st[Kr], yi), xi = pi, Ti = ri - gt[ft] - di, Ai = ri / 2 - gt[ft] / 2 + ai, mi = clamp(xi, Ai, Ti), Si = !Qe.arrow && getAlignment(ve) != null && Ai !== mi && ye.reference[ft] / 2 - (Ai < xi ? pi : di) - gt[ft] / 2 < 0, gi = Si ? Ai < xi ? Ai - xi : Ai - Ti : 0;
    return {
      [lt]: ot[lt] + gi,
      data: {
        [lt]: mi,
        centerOffset: Ai - mi - gi,
        ...Si && {
          alignmentOffset: gi
        }
      },
      reset: Si
    };
  }
}), flip$1 = function(ie) {
  return ie === void 0 && (ie = {}), {
    name: "flip",
    options: ie,
    async fn(Z) {
      var ee, ae;
      const {
        placement: ve,
        middlewareData: ye,
        rects: be,
        initialPlacement: Ye,
        platform: Qe,
        elements: Je
      } = Z, {
        mainAxis: nt = !0,
        crossAxis: st = !0,
        fallbackPlacements: ot,
        fallbackStrategy: lt = "bestFit",
        fallbackAxisSideDirection: ft = "none",
        flipAlignment: gt = !0,
        ...ct
      } = evaluate(ie, Z);
      if ((ee = ye.arrow) != null && ee.alignmentOffset)
        return {};
      const _r = getSide(ve), Kr = getSide(Ye) === Ye, Xr = await (Qe.isRTL == null ? void 0 : Qe.isRTL(Je.floating)), Jr = ot || (Kr || !gt ? [getOppositePlacement(Ye)] : getExpandedPlacements(Ye));
      !ot && ft !== "none" && Jr.push(...getOppositeAxisPlacements(Ye, gt, ft, Xr));
      const ei = [Ye, ...Jr], si = await detectOverflow(Z, ct), ri = [];
      let ai = ((ae = ye.flip) == null ? void 0 : ae.overflows) || [];
      if (nt && ri.push(si[_r]), st) {
        const xi = getAlignmentSides(ve, be, Xr);
        ri.push(si[xi[0]], si[xi[1]]);
      }
      if (ai = [...ai, {
        placement: ve,
        overflows: ri
      }], !ri.every((xi) => xi <= 0)) {
        var yi, pi;
        const xi = (((yi = ye.flip) == null ? void 0 : yi.index) || 0) + 1, Ti = ei[xi];
        if (Ti)
          return {
            data: {
              index: xi,
              overflows: ai
            },
            reset: {
              placement: Ti
            }
          };
        let Ai = (pi = ai.filter((mi) => mi.overflows[0] <= 0).sort((mi, Si) => mi.overflows[1] - Si.overflows[1])[0]) == null ? void 0 : pi.placement;
        if (!Ai)
          switch (lt) {
            case "bestFit": {
              var di;
              const mi = (di = ai.map((Si) => [Si.placement, Si.overflows.filter((gi) => gi > 0).reduce((gi, _i) => gi + _i, 0)]).sort((Si, gi) => Si[1] - gi[1])[0]) == null ? void 0 : di[0];
              mi && (Ai = mi);
              break;
            }
            case "initialPlacement":
              Ai = Ye;
              break;
          }
        if (ve !== Ai)
          return {
            reset: {
              placement: Ai
            }
          };
      }
      return {};
    }
  };
};
function getSideOffsets(ie, Z) {
  return {
    top: ie.top - Z.height,
    right: ie.right - Z.width,
    bottom: ie.bottom - Z.height,
    left: ie.left - Z.width
  };
}
function isAnySideFullyClipped(ie) {
  return sides.some((Z) => ie[Z] >= 0);
}
const hide$1 = function(ie) {
  return ie === void 0 && (ie = {}), {
    name: "hide",
    options: ie,
    async fn(Z) {
      const {
        rects: ee
      } = Z, {
        strategy: ae = "referenceHidden",
        ...ve
      } = evaluate(ie, Z);
      switch (ae) {
        case "referenceHidden": {
          const ye = await detectOverflow(Z, {
            ...ve,
            elementContext: "reference"
          }), be = getSideOffsets(ye, ee.reference);
          return {
            data: {
              referenceHiddenOffsets: be,
              referenceHidden: isAnySideFullyClipped(be)
            }
          };
        }
        case "escaped": {
          const ye = await detectOverflow(Z, {
            ...ve,
            altBoundary: !0
          }), be = getSideOffsets(ye, ee.floating);
          return {
            data: {
              escapedOffsets: be,
              escaped: isAnySideFullyClipped(be)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function convertValueToCoords(ie, Z) {
  const {
    placement: ee,
    platform: ae,
    elements: ve
  } = ie, ye = await (ae.isRTL == null ? void 0 : ae.isRTL(ve.floating)), be = getSide(ee), Ye = getAlignment(ee), Qe = getSideAxis(ee) === "y", Je = ["left", "top"].includes(be) ? -1 : 1, nt = ye && Qe ? -1 : 1, st = evaluate(Z, ie);
  let {
    mainAxis: ot,
    crossAxis: lt,
    alignmentAxis: ft
  } = typeof st == "number" ? {
    mainAxis: st,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...st
  };
  return Ye && typeof ft == "number" && (lt = Ye === "end" ? ft * -1 : ft), Qe ? {
    x: lt * nt,
    y: ot * Je
  } : {
    x: ot * Je,
    y: lt * nt
  };
}
const offset = function(ie) {
  return ie === void 0 && (ie = 0), {
    name: "offset",
    options: ie,
    async fn(Z) {
      var ee, ae;
      const {
        x: ve,
        y: ye,
        placement: be,
        middlewareData: Ye
      } = Z, Qe = await convertValueToCoords(Z, ie);
      return be === ((ee = Ye.offset) == null ? void 0 : ee.placement) && (ae = Ye.arrow) != null && ae.alignmentOffset ? {} : {
        x: ve + Qe.x,
        y: ye + Qe.y,
        data: {
          ...Qe,
          placement: be
        }
      };
    }
  };
}, shift$1 = function(ie) {
  return ie === void 0 && (ie = {}), {
    name: "shift",
    options: ie,
    async fn(Z) {
      const {
        x: ee,
        y: ae,
        placement: ve
      } = Z, {
        mainAxis: ye = !0,
        crossAxis: be = !1,
        limiter: Ye = {
          fn: (ct) => {
            let {
              x: _r,
              y: Kr
            } = ct;
            return {
              x: _r,
              y: Kr
            };
          }
        },
        ...Qe
      } = evaluate(ie, Z), Je = {
        x: ee,
        y: ae
      }, nt = await detectOverflow(Z, Qe), st = getSideAxis(getSide(ve)), ot = getOppositeAxis(st);
      let lt = Je[ot], ft = Je[st];
      if (ye) {
        const ct = ot === "y" ? "top" : "left", _r = ot === "y" ? "bottom" : "right", Kr = lt + nt[ct], Xr = lt - nt[_r];
        lt = clamp(Kr, lt, Xr);
      }
      if (be) {
        const ct = st === "y" ? "top" : "left", _r = st === "y" ? "bottom" : "right", Kr = ft + nt[ct], Xr = ft - nt[_r];
        ft = clamp(Kr, ft, Xr);
      }
      const gt = Ye.fn({
        ...Z,
        [ot]: lt,
        [st]: ft
      });
      return {
        ...gt,
        data: {
          x: gt.x - ee,
          y: gt.y - ae
        }
      };
    }
  };
}, limitShift$1 = function(ie) {
  return ie === void 0 && (ie = {}), {
    options: ie,
    fn(Z) {
      const {
        x: ee,
        y: ae,
        placement: ve,
        rects: ye,
        middlewareData: be
      } = Z, {
        offset: Ye = 0,
        mainAxis: Qe = !0,
        crossAxis: Je = !0
      } = evaluate(ie, Z), nt = {
        x: ee,
        y: ae
      }, st = getSideAxis(ve), ot = getOppositeAxis(st);
      let lt = nt[ot], ft = nt[st];
      const gt = evaluate(Ye, Z), ct = typeof gt == "number" ? {
        mainAxis: gt,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...gt
      };
      if (Qe) {
        const Xr = ot === "y" ? "height" : "width", Jr = ye.reference[ot] - ye.floating[Xr] + ct.mainAxis, ei = ye.reference[ot] + ye.reference[Xr] - ct.mainAxis;
        lt < Jr ? lt = Jr : lt > ei && (lt = ei);
      }
      if (Je) {
        var _r, Kr;
        const Xr = ot === "y" ? "width" : "height", Jr = ["top", "left"].includes(getSide(ve)), ei = ye.reference[st] - ye.floating[Xr] + (Jr && ((_r = be.offset) == null ? void 0 : _r[st]) || 0) + (Jr ? 0 : ct.crossAxis), si = ye.reference[st] + ye.reference[Xr] + (Jr ? 0 : ((Kr = be.offset) == null ? void 0 : Kr[st]) || 0) - (Jr ? ct.crossAxis : 0);
        ft < ei ? ft = ei : ft > si && (ft = si);
      }
      return {
        [ot]: lt,
        [st]: ft
      };
    }
  };
}, size$1 = function(ie) {
  return ie === void 0 && (ie = {}), {
    name: "size",
    options: ie,
    async fn(Z) {
      const {
        placement: ee,
        rects: ae,
        platform: ve,
        elements: ye
      } = Z, {
        apply: be = () => {
        },
        ...Ye
      } = evaluate(ie, Z), Qe = await detectOverflow(Z, Ye), Je = getSide(ee), nt = getAlignment(ee), st = getSideAxis(ee) === "y", {
        width: ot,
        height: lt
      } = ae.floating;
      let ft, gt;
      Je === "top" || Je === "bottom" ? (ft = Je, gt = nt === (await (ve.isRTL == null ? void 0 : ve.isRTL(ye.floating)) ? "start" : "end") ? "left" : "right") : (gt = Je, ft = nt === "end" ? "top" : "bottom");
      const ct = lt - Qe[ft], _r = ot - Qe[gt], Kr = !Z.middlewareData.shift;
      let Xr = ct, Jr = _r;
      if (st) {
        const si = ot - Qe.left - Qe.right;
        Jr = nt || Kr ? min(_r, si) : si;
      } else {
        const si = lt - Qe.top - Qe.bottom;
        Xr = nt || Kr ? min(ct, si) : si;
      }
      if (Kr && !nt) {
        const si = max(Qe.left, 0), ri = max(Qe.right, 0), ai = max(Qe.top, 0), yi = max(Qe.bottom, 0);
        st ? Jr = ot - 2 * (si !== 0 || ri !== 0 ? si + ri : max(Qe.left, Qe.right)) : Xr = lt - 2 * (ai !== 0 || yi !== 0 ? ai + yi : max(Qe.top, Qe.bottom));
      }
      await be({
        ...Z,
        availableWidth: Jr,
        availableHeight: Xr
      });
      const ei = await ve.getDimensions(ye.floating);
      return ot !== ei.width || lt !== ei.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function getNodeName(ie) {
  return isNode(ie) ? (ie.nodeName || "").toLowerCase() : "#document";
}
function getWindow(ie) {
  var Z;
  return (ie == null || (Z = ie.ownerDocument) == null ? void 0 : Z.defaultView) || window;
}
function getDocumentElement(ie) {
  var Z;
  return (Z = (isNode(ie) ? ie.ownerDocument : ie.document) || window.document) == null ? void 0 : Z.documentElement;
}
function isNode(ie) {
  return ie instanceof Node || ie instanceof getWindow(ie).Node;
}
function isElement(ie) {
  return ie instanceof Element || ie instanceof getWindow(ie).Element;
}
function isHTMLElement(ie) {
  return ie instanceof HTMLElement || ie instanceof getWindow(ie).HTMLElement;
}
function isShadowRoot(ie) {
  return typeof ShadowRoot > "u" ? !1 : ie instanceof ShadowRoot || ie instanceof getWindow(ie).ShadowRoot;
}
function isOverflowElement(ie) {
  const {
    overflow: Z,
    overflowX: ee,
    overflowY: ae,
    display: ve
  } = getComputedStyle$1(ie);
  return /auto|scroll|overlay|hidden|clip/.test(Z + ae + ee) && !["inline", "contents"].includes(ve);
}
function isTableElement(ie) {
  return ["table", "td", "th"].includes(getNodeName(ie));
}
function isContainingBlock(ie) {
  const Z = isWebKit(), ee = getComputedStyle$1(ie);
  return ee.transform !== "none" || ee.perspective !== "none" || (ee.containerType ? ee.containerType !== "normal" : !1) || !Z && (ee.backdropFilter ? ee.backdropFilter !== "none" : !1) || !Z && (ee.filter ? ee.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((ae) => (ee.willChange || "").includes(ae)) || ["paint", "layout", "strict", "content"].some((ae) => (ee.contain || "").includes(ae));
}
function getContainingBlock(ie) {
  let Z = getParentNode(ie);
  for (; isHTMLElement(Z) && !isLastTraversableNode(Z); ) {
    if (isContainingBlock(Z))
      return Z;
    Z = getParentNode(Z);
  }
  return null;
}
function isWebKit() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(ie) {
  return ["html", "body", "#document"].includes(getNodeName(ie));
}
function getComputedStyle$1(ie) {
  return getWindow(ie).getComputedStyle(ie);
}
function getNodeScroll(ie) {
  return isElement(ie) ? {
    scrollLeft: ie.scrollLeft,
    scrollTop: ie.scrollTop
  } : {
    scrollLeft: ie.pageXOffset,
    scrollTop: ie.pageYOffset
  };
}
function getParentNode(ie) {
  if (getNodeName(ie) === "html")
    return ie;
  const Z = (
    // Step into the shadow DOM of the parent of a slotted node.
    ie.assignedSlot || // DOM Element detected.
    ie.parentNode || // ShadowRoot detected.
    isShadowRoot(ie) && ie.host || // Fallback.
    getDocumentElement(ie)
  );
  return isShadowRoot(Z) ? Z.host : Z;
}
function getNearestOverflowAncestor(ie) {
  const Z = getParentNode(ie);
  return isLastTraversableNode(Z) ? ie.ownerDocument ? ie.ownerDocument.body : ie.body : isHTMLElement(Z) && isOverflowElement(Z) ? Z : getNearestOverflowAncestor(Z);
}
function getOverflowAncestors(ie, Z, ee) {
  var ae;
  Z === void 0 && (Z = []), ee === void 0 && (ee = !0);
  const ve = getNearestOverflowAncestor(ie), ye = ve === ((ae = ie.ownerDocument) == null ? void 0 : ae.body), be = getWindow(ve);
  return ye ? Z.concat(be, be.visualViewport || [], isOverflowElement(ve) ? ve : [], be.frameElement && ee ? getOverflowAncestors(be.frameElement) : []) : Z.concat(ve, getOverflowAncestors(ve, [], ee));
}
function getCssDimensions(ie) {
  const Z = getComputedStyle$1(ie);
  let ee = parseFloat(Z.width) || 0, ae = parseFloat(Z.height) || 0;
  const ve = isHTMLElement(ie), ye = ve ? ie.offsetWidth : ee, be = ve ? ie.offsetHeight : ae, Ye = round(ee) !== ye || round(ae) !== be;
  return Ye && (ee = ye, ae = be), {
    width: ee,
    height: ae,
    $: Ye
  };
}
function unwrapElement(ie) {
  return isElement(ie) ? ie : ie.contextElement;
}
function getScale(ie) {
  const Z = unwrapElement(ie);
  if (!isHTMLElement(Z))
    return createCoords(1);
  const ee = Z.getBoundingClientRect(), {
    width: ae,
    height: ve,
    $: ye
  } = getCssDimensions(Z);
  let be = (ye ? round(ee.width) : ee.width) / ae, Ye = (ye ? round(ee.height) : ee.height) / ve;
  return (!be || !Number.isFinite(be)) && (be = 1), (!Ye || !Number.isFinite(Ye)) && (Ye = 1), {
    x: be,
    y: Ye
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(ie) {
  const Z = getWindow(ie);
  return !isWebKit() || !Z.visualViewport ? noOffsets : {
    x: Z.visualViewport.offsetLeft,
    y: Z.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(ie, Z, ee) {
  return Z === void 0 && (Z = !1), !ee || Z && ee !== getWindow(ie) ? !1 : Z;
}
function getBoundingClientRect(ie, Z, ee, ae) {
  Z === void 0 && (Z = !1), ee === void 0 && (ee = !1);
  const ve = ie.getBoundingClientRect(), ye = unwrapElement(ie);
  let be = createCoords(1);
  Z && (ae ? isElement(ae) && (be = getScale(ae)) : be = getScale(ie));
  const Ye = shouldAddVisualOffsets(ye, ee, ae) ? getVisualOffsets(ye) : createCoords(0);
  let Qe = (ve.left + Ye.x) / be.x, Je = (ve.top + Ye.y) / be.y, nt = ve.width / be.x, st = ve.height / be.y;
  if (ye) {
    const ot = getWindow(ye), lt = ae && isElement(ae) ? getWindow(ae) : ae;
    let ft = ot.frameElement;
    for (; ft && ae && lt !== ot; ) {
      const gt = getScale(ft), ct = ft.getBoundingClientRect(), _r = getComputedStyle$1(ft), Kr = ct.left + (ft.clientLeft + parseFloat(_r.paddingLeft)) * gt.x, Xr = ct.top + (ft.clientTop + parseFloat(_r.paddingTop)) * gt.y;
      Qe *= gt.x, Je *= gt.y, nt *= gt.x, st *= gt.y, Qe += Kr, Je += Xr, ft = getWindow(ft).frameElement;
    }
  }
  return rectToClientRect({
    width: nt,
    height: st,
    x: Qe,
    y: Je
  });
}
const topLayerSelectors = [":popover-open", ":modal"];
function topLayer(ie) {
  let Z = !1, ee = 0, ae = 0;
  function ve(ye) {
    try {
      Z = Z || ie.matches(ye);
    } catch {
    }
  }
  if (topLayerSelectors.forEach((ye) => {
    ve(ye);
  }), Z) {
    const ye = getContainingBlock(ie);
    if (ye) {
      const be = ye.getBoundingClientRect();
      ee = be.x, ae = be.y;
    }
  }
  return [Z, ee, ae];
}
function convertOffsetParentRelativeRectToViewportRelativeRect(ie) {
  let {
    elements: Z,
    rect: ee,
    offsetParent: ae,
    strategy: ve
  } = ie;
  const ye = getDocumentElement(ae), [be] = Z ? topLayer(Z.floating) : [!1];
  if (ae === ye || be)
    return ee;
  let Ye = {
    scrollLeft: 0,
    scrollTop: 0
  }, Qe = createCoords(1);
  const Je = createCoords(0), nt = isHTMLElement(ae);
  if ((nt || !nt && ve !== "fixed") && ((getNodeName(ae) !== "body" || isOverflowElement(ye)) && (Ye = getNodeScroll(ae)), isHTMLElement(ae))) {
    const st = getBoundingClientRect(ae);
    Qe = getScale(ae), Je.x = st.x + ae.clientLeft, Je.y = st.y + ae.clientTop;
  }
  return {
    width: ee.width * Qe.x,
    height: ee.height * Qe.y,
    x: ee.x * Qe.x - Ye.scrollLeft * Qe.x + Je.x,
    y: ee.y * Qe.y - Ye.scrollTop * Qe.y + Je.y
  };
}
function getClientRects(ie) {
  return Array.from(ie.getClientRects());
}
function getWindowScrollBarX(ie) {
  return getBoundingClientRect(getDocumentElement(ie)).left + getNodeScroll(ie).scrollLeft;
}
function getDocumentRect(ie) {
  const Z = getDocumentElement(ie), ee = getNodeScroll(ie), ae = ie.ownerDocument.body, ve = max(Z.scrollWidth, Z.clientWidth, ae.scrollWidth, ae.clientWidth), ye = max(Z.scrollHeight, Z.clientHeight, ae.scrollHeight, ae.clientHeight);
  let be = -ee.scrollLeft + getWindowScrollBarX(ie);
  const Ye = -ee.scrollTop;
  return getComputedStyle$1(ae).direction === "rtl" && (be += max(Z.clientWidth, ae.clientWidth) - ve), {
    width: ve,
    height: ye,
    x: be,
    y: Ye
  };
}
function getViewportRect(ie, Z) {
  const ee = getWindow(ie), ae = getDocumentElement(ie), ve = ee.visualViewport;
  let ye = ae.clientWidth, be = ae.clientHeight, Ye = 0, Qe = 0;
  if (ve) {
    ye = ve.width, be = ve.height;
    const Je = isWebKit();
    (!Je || Je && Z === "fixed") && (Ye = ve.offsetLeft, Qe = ve.offsetTop);
  }
  return {
    width: ye,
    height: be,
    x: Ye,
    y: Qe
  };
}
function getInnerBoundingClientRect(ie, Z) {
  const ee = getBoundingClientRect(ie, !0, Z === "fixed"), ae = ee.top + ie.clientTop, ve = ee.left + ie.clientLeft, ye = isHTMLElement(ie) ? getScale(ie) : createCoords(1), be = ie.clientWidth * ye.x, Ye = ie.clientHeight * ye.y, Qe = ve * ye.x, Je = ae * ye.y;
  return {
    width: be,
    height: Ye,
    x: Qe,
    y: Je
  };
}
function getClientRectFromClippingAncestor(ie, Z, ee) {
  let ae;
  if (Z === "viewport")
    ae = getViewportRect(ie, ee);
  else if (Z === "document")
    ae = getDocumentRect(getDocumentElement(ie));
  else if (isElement(Z))
    ae = getInnerBoundingClientRect(Z, ee);
  else {
    const ve = getVisualOffsets(ie);
    ae = {
      ...Z,
      x: Z.x - ve.x,
      y: Z.y - ve.y
    };
  }
  return rectToClientRect(ae);
}
function hasFixedPositionAncestor(ie, Z) {
  const ee = getParentNode(ie);
  return ee === Z || !isElement(ee) || isLastTraversableNode(ee) ? !1 : getComputedStyle$1(ee).position === "fixed" || hasFixedPositionAncestor(ee, Z);
}
function getClippingElementAncestors(ie, Z) {
  const ee = Z.get(ie);
  if (ee)
    return ee;
  let ae = getOverflowAncestors(ie, [], !1).filter((Ye) => isElement(Ye) && getNodeName(Ye) !== "body"), ve = null;
  const ye = getComputedStyle$1(ie).position === "fixed";
  let be = ye ? getParentNode(ie) : ie;
  for (; isElement(be) && !isLastTraversableNode(be); ) {
    const Ye = getComputedStyle$1(be), Qe = isContainingBlock(be);
    !Qe && Ye.position === "fixed" && (ve = null), (ye ? !Qe && !ve : !Qe && Ye.position === "static" && !!ve && ["absolute", "fixed"].includes(ve.position) || isOverflowElement(be) && !Qe && hasFixedPositionAncestor(ie, be)) ? ae = ae.filter((nt) => nt !== be) : ve = Ye, be = getParentNode(be);
  }
  return Z.set(ie, ae), ae;
}
function getClippingRect(ie) {
  let {
    element: Z,
    boundary: ee,
    rootBoundary: ae,
    strategy: ve
  } = ie;
  const be = [...ee === "clippingAncestors" ? getClippingElementAncestors(Z, this._c) : [].concat(ee), ae], Ye = be[0], Qe = be.reduce((Je, nt) => {
    const st = getClientRectFromClippingAncestor(Z, nt, ve);
    return Je.top = max(st.top, Je.top), Je.right = min(st.right, Je.right), Je.bottom = min(st.bottom, Je.bottom), Je.left = max(st.left, Je.left), Je;
  }, getClientRectFromClippingAncestor(Z, Ye, ve));
  return {
    width: Qe.right - Qe.left,
    height: Qe.bottom - Qe.top,
    x: Qe.left,
    y: Qe.top
  };
}
function getDimensions(ie) {
  const {
    width: Z,
    height: ee
  } = getCssDimensions(ie);
  return {
    width: Z,
    height: ee
  };
}
function getRectRelativeToOffsetParent(ie, Z, ee, ae) {
  const ve = isHTMLElement(Z), ye = getDocumentElement(Z), be = ee === "fixed", Ye = getBoundingClientRect(ie, !0, be, Z);
  let Qe = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const Je = createCoords(0);
  if (ve || !ve && !be)
    if ((getNodeName(Z) !== "body" || isOverflowElement(ye)) && (Qe = getNodeScroll(Z)), ve) {
      const gt = getBoundingClientRect(Z, !0, be, Z);
      Je.x = gt.x + Z.clientLeft, Je.y = gt.y + Z.clientTop;
    } else
      ye && (Je.x = getWindowScrollBarX(ye));
  let nt = Ye.left + Qe.scrollLeft - Je.x, st = Ye.top + Qe.scrollTop - Je.y;
  const [ot, lt, ft] = topLayer(ae);
  return ot && (nt += lt, st += ft, ve && (nt += Z.clientLeft, st += Z.clientTop)), {
    x: nt,
    y: st,
    width: Ye.width,
    height: Ye.height
  };
}
function getTrueOffsetParent(ie, Z) {
  return !isHTMLElement(ie) || getComputedStyle$1(ie).position === "fixed" ? null : Z ? Z(ie) : ie.offsetParent;
}
function getOffsetParent(ie, Z) {
  const ee = getWindow(ie);
  if (!isHTMLElement(ie))
    return ee;
  let ae = getTrueOffsetParent(ie, Z);
  for (; ae && isTableElement(ae) && getComputedStyle$1(ae).position === "static"; )
    ae = getTrueOffsetParent(ae, Z);
  return ae && (getNodeName(ae) === "html" || getNodeName(ae) === "body" && getComputedStyle$1(ae).position === "static" && !isContainingBlock(ae)) ? ee : ae || getContainingBlock(ie) || ee;
}
const getElementRects = async function(ie) {
  const Z = this.getOffsetParent || getOffsetParent, ee = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(ie.reference, await Z(ie.floating), ie.strategy, ie.floating),
    floating: {
      x: 0,
      y: 0,
      ...await ee(ie.floating)
    }
  };
};
function isRTL(ie) {
  return getComputedStyle$1(ie).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(ie, Z) {
  let ee = null, ae;
  const ve = getDocumentElement(ie);
  function ye() {
    var Ye;
    clearTimeout(ae), (Ye = ee) == null || Ye.disconnect(), ee = null;
  }
  function be(Ye, Qe) {
    Ye === void 0 && (Ye = !1), Qe === void 0 && (Qe = 1), ye();
    const {
      left: Je,
      top: nt,
      width: st,
      height: ot
    } = ie.getBoundingClientRect();
    if (Ye || Z(), !st || !ot)
      return;
    const lt = floor(nt), ft = floor(ve.clientWidth - (Je + st)), gt = floor(ve.clientHeight - (nt + ot)), ct = floor(Je), Kr = {
      rootMargin: -lt + "px " + -ft + "px " + -gt + "px " + -ct + "px",
      threshold: max(0, min(1, Qe)) || 1
    };
    let Xr = !0;
    function Jr(ei) {
      const si = ei[0].intersectionRatio;
      if (si !== Qe) {
        if (!Xr)
          return be();
        si ? be(!1, si) : ae = setTimeout(() => {
          be(!1, 1e-7);
        }, 100);
      }
      Xr = !1;
    }
    try {
      ee = new IntersectionObserver(Jr, {
        ...Kr,
        // Handle <iframe>s
        root: ve.ownerDocument
      });
    } catch {
      ee = new IntersectionObserver(Jr, Kr);
    }
    ee.observe(ie);
  }
  return be(!0), ye;
}
function autoUpdate(ie, Z, ee, ae) {
  ae === void 0 && (ae = {});
  const {
    ancestorScroll: ve = !0,
    ancestorResize: ye = !0,
    elementResize: be = typeof ResizeObserver == "function",
    layoutShift: Ye = typeof IntersectionObserver == "function",
    animationFrame: Qe = !1
  } = ae, Je = unwrapElement(ie), nt = ve || ye ? [...Je ? getOverflowAncestors(Je) : [], ...getOverflowAncestors(Z)] : [];
  nt.forEach((_r) => {
    ve && _r.addEventListener("scroll", ee, {
      passive: !0
    }), ye && _r.addEventListener("resize", ee);
  });
  const st = Je && Ye ? observeMove(Je, ee) : null;
  let ot = -1, lt = null;
  be && (lt = new ResizeObserver((_r) => {
    let [Kr] = _r;
    Kr && Kr.target === Je && lt && (lt.unobserve(Z), cancelAnimationFrame(ot), ot = requestAnimationFrame(() => {
      var Xr;
      (Xr = lt) == null || Xr.observe(Z);
    })), ee();
  }), Je && !Qe && lt.observe(Je), lt.observe(Z));
  let ft, gt = Qe ? getBoundingClientRect(ie) : null;
  Qe && ct();
  function ct() {
    const _r = getBoundingClientRect(ie);
    gt && (_r.x !== gt.x || _r.y !== gt.y || _r.width !== gt.width || _r.height !== gt.height) && ee(), gt = _r, ft = requestAnimationFrame(ct);
  }
  return ee(), () => {
    var _r;
    nt.forEach((Kr) => {
      ve && Kr.removeEventListener("scroll", ee), ye && Kr.removeEventListener("resize", ee);
    }), st == null || st(), (_r = lt) == null || _r.disconnect(), lt = null, Qe && cancelAnimationFrame(ft);
  };
}
const shift = shift$1, flip = flip$1, size = size$1, hide = hide$1, arrow$1 = arrow$2, limitShift = limitShift$1, computePosition = (ie, Z, ee) => {
  const ae = /* @__PURE__ */ new Map(), ve = {
    platform,
    ...ee
  }, ye = {
    ...ve.platform,
    _c: ae
  };
  return computePosition$1(ie, Z, {
    ...ve,
    platform: ye
  });
}, arrow = (ie) => {
  function Z(ee) {
    return {}.hasOwnProperty.call(ee, "current");
  }
  return {
    name: "arrow",
    options: ie,
    fn(ee) {
      const {
        element: ae,
        padding: ve
      } = typeof ie == "function" ? ie(ee) : ie;
      return ae && Z(ae) ? ae.current != null ? arrow$1({
        element: ae.current,
        padding: ve
      }).fn(ee) : {} : ae ? arrow$1({
        element: ae,
        padding: ve
      }).fn(ee) : {};
    }
  };
};
var index = typeof document < "u" ? reactExports.useLayoutEffect : reactExports.useEffect;
function deepEqual(ie, Z) {
  if (ie === Z)
    return !0;
  if (typeof ie != typeof Z)
    return !1;
  if (typeof ie == "function" && ie.toString() === Z.toString())
    return !0;
  let ee, ae, ve;
  if (ie && Z && typeof ie == "object") {
    if (Array.isArray(ie)) {
      if (ee = ie.length, ee !== Z.length)
        return !1;
      for (ae = ee; ae-- !== 0; )
        if (!deepEqual(ie[ae], Z[ae]))
          return !1;
      return !0;
    }
    if (ve = Object.keys(ie), ee = ve.length, ee !== Object.keys(Z).length)
      return !1;
    for (ae = ee; ae-- !== 0; )
      if (!{}.hasOwnProperty.call(Z, ve[ae]))
        return !1;
    for (ae = ee; ae-- !== 0; ) {
      const ye = ve[ae];
      if (!(ye === "_owner" && ie.$$typeof) && !deepEqual(ie[ye], Z[ye]))
        return !1;
    }
    return !0;
  }
  return ie !== ie && Z !== Z;
}
function getDPR(ie) {
  return typeof window > "u" ? 1 : (ie.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function roundByDPR(ie, Z) {
  const ee = getDPR(ie);
  return Math.round(Z * ee) / ee;
}
function useLatestRef(ie) {
  const Z = reactExports.useRef(ie);
  return index(() => {
    Z.current = ie;
  }), Z;
}
function useFloating(ie) {
  ie === void 0 && (ie = {});
  const {
    placement: Z = "bottom",
    strategy: ee = "absolute",
    middleware: ae = [],
    platform: ve,
    elements: {
      reference: ye,
      floating: be
    } = {},
    transform: Ye = !0,
    whileElementsMounted: Qe,
    open: Je
  } = ie, [nt, st] = reactExports.useState({
    x: 0,
    y: 0,
    strategy: ee,
    placement: Z,
    middlewareData: {},
    isPositioned: !1
  }), [ot, lt] = reactExports.useState(ae);
  deepEqual(ot, ae) || lt(ae);
  const [ft, gt] = reactExports.useState(null), [ct, _r] = reactExports.useState(null), Kr = reactExports.useCallback((gi) => {
    gi !== si.current && (si.current = gi, gt(gi));
  }, []), Xr = reactExports.useCallback((gi) => {
    gi !== ri.current && (ri.current = gi, _r(gi));
  }, []), Jr = ye || ft, ei = be || ct, si = reactExports.useRef(null), ri = reactExports.useRef(null), ai = reactExports.useRef(nt), yi = Qe != null, pi = useLatestRef(Qe), di = useLatestRef(ve), xi = reactExports.useCallback(() => {
    if (!si.current || !ri.current)
      return;
    const gi = {
      placement: Z,
      strategy: ee,
      middleware: ot
    };
    di.current && (gi.platform = di.current), computePosition(si.current, ri.current, gi).then((_i) => {
      const Oi = {
        ..._i,
        isPositioned: !0
      };
      Ti.current && !deepEqual(ai.current, Oi) && (ai.current = Oi, reactDomExports.flushSync(() => {
        st(Oi);
      }));
    });
  }, [ot, Z, ee, di]);
  index(() => {
    Je === !1 && ai.current.isPositioned && (ai.current.isPositioned = !1, st((gi) => ({
      ...gi,
      isPositioned: !1
    })));
  }, [Je]);
  const Ti = reactExports.useRef(!1);
  index(() => (Ti.current = !0, () => {
    Ti.current = !1;
  }), []), index(() => {
    if (Jr && (si.current = Jr), ei && (ri.current = ei), Jr && ei) {
      if (pi.current)
        return pi.current(Jr, ei, xi);
      xi();
    }
  }, [Jr, ei, xi, pi, yi]);
  const Ai = reactExports.useMemo(() => ({
    reference: si,
    floating: ri,
    setReference: Kr,
    setFloating: Xr
  }), [Kr, Xr]), mi = reactExports.useMemo(() => ({
    reference: Jr,
    floating: ei
  }), [Jr, ei]), Si = reactExports.useMemo(() => {
    const gi = {
      position: ee,
      left: 0,
      top: 0
    };
    if (!mi.floating)
      return gi;
    const _i = roundByDPR(mi.floating, nt.x), Oi = roundByDPR(mi.floating, nt.y);
    return Ye ? {
      ...gi,
      transform: "translate(" + _i + "px, " + Oi + "px)",
      ...getDPR(mi.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: ee,
      left: _i,
      top: Oi
    };
  }, [ee, Ye, mi.floating, nt.x, nt.y]);
  return reactExports.useMemo(() => ({
    ...nt,
    update: xi,
    refs: Ai,
    elements: mi,
    floatingStyles: Si
  }), [nt, xi, Ai, mi, Si]);
}
const $7e8f5cd07187803e$export$21b07c8f274aebd5 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { children: ee, width: ae = 10, height: ve = 5, ...ye } = ie;
  return /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.svg, _extends$1({}, ye, {
    ref: Z,
    width: ae,
    height: ve,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), ie.asChild ? ee : /* @__PURE__ */ reactExports.createElement("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5, $cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper", [$cf1ac5d9fe0e8206$var$createPopperContext, $cf1ac5d9fe0e8206$export$722aac194ae923] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cf1ac5d9fe0e8206$var$POPPER_NAME), [$cf1ac5d9fe0e8206$var$PopperProvider, $cf1ac5d9fe0e8206$var$usePopperContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME), $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = (ie) => {
  const { __scopePopper: Z, children: ee } = ie, [ae, ve] = reactExports.useState(null);
  return /* @__PURE__ */ reactExports.createElement($cf1ac5d9fe0e8206$var$PopperProvider, {
    scope: Z,
    anchor: ae,
    onAnchorChange: ve
  }, ee);
}, $cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor", $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopePopper: ee, virtualRef: ae, ...ve } = ie, ye = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, ee), be = reactExports.useRef(null), Ye = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, be);
  return reactExports.useEffect(() => {
    ye.onAnchorChange((ae == null ? void 0 : ae.current) || be.current);
  }), ae ? null : /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, ve, {
    ref: Ye
  }));
}), $cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent", [$cf1ac5d9fe0e8206$var$PopperContentProvider, $cf1ac5d9fe0e8206$var$useContentContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME), $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  var ee, ae, ve, ye, be, Ye, Qe, Je;
  const { __scopePopper: nt, side: st = "bottom", sideOffset: ot = 0, align: lt = "center", alignOffset: ft = 0, arrowPadding: gt = 0, avoidCollisions: ct = !0, collisionBoundary: _r = [], collisionPadding: Kr = 0, sticky: Xr = "partial", hideWhenDetached: Jr = !1, updatePositionStrategy: ei = "optimized", onPlaced: si, ...ri } = ie, ai = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, nt), [yi, pi] = reactExports.useState(null), di = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    Z,
    (Gi) => pi(Gi)
  ), [xi, Ti] = reactExports.useState(null), Ai = $db6c3485150b8e66$export$1ab7ae714698c4b8(xi), mi = (ee = Ai == null ? void 0 : Ai.width) !== null && ee !== void 0 ? ee : 0, Si = (ae = Ai == null ? void 0 : Ai.height) !== null && ae !== void 0 ? ae : 0, gi = st + (lt !== "center" ? "-" + lt : ""), _i = typeof Kr == "number" ? Kr : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...Kr
  }, Oi = Array.isArray(_r) ? _r : [
    _r
  ], hi = Oi.length > 0, Di = {
    padding: _i,
    boundary: Oi.filter($cf1ac5d9fe0e8206$var$isNotNull),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: hi
  }, { refs: Ri, floatingStyles: rs, placement: Hi, isPositioned: qi, middlewareData: us } = useFloating({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: gi,
    whileElementsMounted: (...Gi) => autoUpdate(...Gi, {
      animationFrame: ei === "always"
    }),
    elements: {
      reference: ai.anchor
    },
    middleware: [
      offset({
        mainAxis: ot + Si,
        alignmentAxis: ft
      }),
      ct && shift({
        mainAxis: !0,
        crossAxis: !1,
        limiter: Xr === "partial" ? limitShift() : void 0,
        ...Di
      }),
      ct && flip({
        ...Di
      }),
      size({
        ...Di,
        apply: ({ elements: Gi, rects: Qi, availableWidth: ns, availableHeight: Bs }) => {
          const { width: ms, height: Ks } = Qi.reference, Js = Gi.floating.style;
          Js.setProperty("--radix-popper-available-width", `${ns}px`), Js.setProperty("--radix-popper-available-height", `${Bs}px`), Js.setProperty("--radix-popper-anchor-width", `${ms}px`), Js.setProperty("--radix-popper-anchor-height", `${Ks}px`);
        }
      }),
      xi && arrow({
        element: xi,
        padding: gt
      }),
      $cf1ac5d9fe0e8206$var$transformOrigin({
        arrowWidth: mi,
        arrowHeight: Si
      }),
      Jr && hide({
        strategy: "referenceHidden",
        ...Di
      })
    ]
  }), [Yi, is] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(Hi), Ss = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(si);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    qi && (Ss == null || Ss());
  }, [
    qi,
    Ss
  ]);
  const Gs = (ve = us.arrow) === null || ve === void 0 ? void 0 : ve.x, Vs = (ye = us.arrow) === null || ye === void 0 ? void 0 : ye.y, Ws = ((be = us.arrow) === null || be === void 0 ? void 0 : be.centerOffset) !== 0, [ii, bi] = reactExports.useState();
  return $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    yi && bi(window.getComputedStyle(yi).zIndex);
  }, [
    yi
  ]), /* @__PURE__ */ reactExports.createElement("div", {
    ref: Ri.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...rs,
      transform: qi ? rs.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: ii,
      "--radix-popper-transform-origin": [
        (Ye = us.transformOrigin) === null || Ye === void 0 ? void 0 : Ye.x,
        (Qe = us.transformOrigin) === null || Qe === void 0 ? void 0 : Qe.y
      ].join(" ")
    },
    dir: ie.dir
  }, /* @__PURE__ */ reactExports.createElement($cf1ac5d9fe0e8206$var$PopperContentProvider, {
    scope: nt,
    placedSide: Yi,
    onArrowChange: Ti,
    arrowX: Gs,
    arrowY: Vs,
    shouldHideArrow: Ws
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    "data-side": Yi,
    "data-align": is
  }, ri, {
    ref: di,
    style: {
      ...ri.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: qi ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (Je = us.hide) !== null && Je !== void 0 && Je.referenceHidden ? 0 : void 0
    }
  }))));
}), $cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow", $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0 = /* @__PURE__ */ reactExports.forwardRef(function(Z, ee) {
  const { __scopePopper: ae, ...ve } = Z, ye = $cf1ac5d9fe0e8206$var$useContentContext($cf1ac5d9fe0e8206$var$ARROW_NAME, ae), be = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[ye.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ reactExports.createElement("span", {
      ref: ye.onArrowChange,
      style: {
        position: "absolute",
        left: ye.arrowX,
        top: ye.arrowY,
        [be]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[ye.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[ye.placedSide],
        visibility: ye.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ reactExports.createElement($7e8f5cd07187803e$export$be92b6f5f03c0fe9, _extends$1({}, ve, {
      ref: ee,
      style: {
        ...ve.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function $cf1ac5d9fe0e8206$var$isNotNull(ie) {
  return ie !== null;
}
const $cf1ac5d9fe0e8206$var$transformOrigin = (ie) => ({
  name: "transformOrigin",
  options: ie,
  fn(Z) {
    var ee, ae, ve, ye, be;
    const { placement: Ye, rects: Qe, middlewareData: Je } = Z, st = ((ee = Je.arrow) === null || ee === void 0 ? void 0 : ee.centerOffset) !== 0, ot = st ? 0 : ie.arrowWidth, lt = st ? 0 : ie.arrowHeight, [ft, gt] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(Ye), ct = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[gt], _r = ((ae = (ve = Je.arrow) === null || ve === void 0 ? void 0 : ve.x) !== null && ae !== void 0 ? ae : 0) + ot / 2, Kr = ((ye = (be = Je.arrow) === null || be === void 0 ? void 0 : be.y) !== null && ye !== void 0 ? ye : 0) + lt / 2;
    let Xr = "", Jr = "";
    return ft === "bottom" ? (Xr = st ? ct : `${_r}px`, Jr = `${-lt}px`) : ft === "top" ? (Xr = st ? ct : `${_r}px`, Jr = `${Qe.floating.height + lt}px`) : ft === "right" ? (Xr = `${-lt}px`, Jr = st ? ct : `${Kr}px`) : ft === "left" && (Xr = `${Qe.floating.width + lt}px`, Jr = st ? ct : `${Kr}px`), {
      data: {
        x: Xr,
        y: Jr
      }
    };
  }
});
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(ie) {
  const [Z, ee = "center"] = ie.split("-");
  return [
    Z,
    ee
  ];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9, $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d, $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc, $cf1ac5d9fe0e8206$export$21b07c8f274aebd5 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0, $f1701beae083dbae$export$602eac185826482c = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  var ee;
  const { container: ae = globalThis == null || (ee = globalThis.document) === null || ee === void 0 ? void 0 : ee.body, ...ve } = ie;
  return ae ? /* @__PURE__ */ $7SXl2$reactdom.createPortal(/* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, ve, {
    ref: Z
  })), ae) : null;
});
var getDefaultParent = function(ie) {
  if (typeof document > "u")
    return null;
  var Z = Array.isArray(ie) ? ie[0] : ie;
  return Z.ownerDocument.body;
}, counterMap = /* @__PURE__ */ new WeakMap(), uncontrolledNodes = /* @__PURE__ */ new WeakMap(), markerMap = {}, lockCount = 0, unwrapHost = function(ie) {
  return ie && (ie.host || unwrapHost(ie.parentNode));
}, correctTargets = function(ie, Z) {
  return Z.map(function(ee) {
    if (ie.contains(ee))
      return ee;
    var ae = unwrapHost(ee);
    return ae && ie.contains(ae) ? ae : (console.error("aria-hidden", ee, "in not contained inside", ie, ". Doing nothing"), null);
  }).filter(function(ee) {
    return !!ee;
  });
}, applyAttributeToOthers = function(ie, Z, ee, ae) {
  var ve = correctTargets(Z, Array.isArray(ie) ? ie : [ie]);
  markerMap[ee] || (markerMap[ee] = /* @__PURE__ */ new WeakMap());
  var ye = markerMap[ee], be = [], Ye = /* @__PURE__ */ new Set(), Qe = new Set(ve), Je = function(st) {
    !st || Ye.has(st) || (Ye.add(st), Je(st.parentNode));
  };
  ve.forEach(Je);
  var nt = function(st) {
    !st || Qe.has(st) || Array.prototype.forEach.call(st.children, function(ot) {
      if (Ye.has(ot))
        nt(ot);
      else {
        var lt = ot.getAttribute(ae), ft = lt !== null && lt !== "false", gt = (counterMap.get(ot) || 0) + 1, ct = (ye.get(ot) || 0) + 1;
        counterMap.set(ot, gt), ye.set(ot, ct), be.push(ot), gt === 1 && ft && uncontrolledNodes.set(ot, !0), ct === 1 && ot.setAttribute(ee, "true"), ft || ot.setAttribute(ae, "true");
      }
    });
  };
  return nt(Z), Ye.clear(), lockCount++, function() {
    be.forEach(function(st) {
      var ot = counterMap.get(st) - 1, lt = ye.get(st) - 1;
      counterMap.set(st, ot), ye.set(st, lt), ot || (uncontrolledNodes.has(st) || st.removeAttribute(ae), uncontrolledNodes.delete(st)), lt || st.removeAttribute(ee);
    }), lockCount--, lockCount || (counterMap = /* @__PURE__ */ new WeakMap(), counterMap = /* @__PURE__ */ new WeakMap(), uncontrolledNodes = /* @__PURE__ */ new WeakMap(), markerMap = {});
  };
}, hideOthers = function(ie, Z, ee) {
  ee === void 0 && (ee = "data-aria-hidden");
  var ae = Array.from(Array.isArray(ie) ? ie : [ie]), ve = Z || getDefaultParent(ie);
  return ve ? (ae.push.apply(ae, Array.from(ve.querySelectorAll("[aria-live]"))), applyAttributeToOthers(ae, ve, ee, "aria-hidden")) : function() {
    return null;
  };
}, __assign = function() {
  return __assign = Object.assign || function(Z) {
    for (var ee, ae = 1, ve = arguments.length; ae < ve; ae++) {
      ee = arguments[ae];
      for (var ye in ee)
        Object.prototype.hasOwnProperty.call(ee, ye) && (Z[ye] = ee[ye]);
    }
    return Z;
  }, __assign.apply(this, arguments);
};
function __rest(ie, Z) {
  var ee = {};
  for (var ae in ie)
    Object.prototype.hasOwnProperty.call(ie, ae) && Z.indexOf(ae) < 0 && (ee[ae] = ie[ae]);
  if (ie != null && typeof Object.getOwnPropertySymbols == "function")
    for (var ve = 0, ae = Object.getOwnPropertySymbols(ie); ve < ae.length; ve++)
      Z.indexOf(ae[ve]) < 0 && Object.prototype.propertyIsEnumerable.call(ie, ae[ve]) && (ee[ae[ve]] = ie[ae[ve]]);
  return ee;
}
function __spreadArray(ie, Z, ee) {
  if (ee || arguments.length === 2)
    for (var ae = 0, ve = Z.length, ye; ae < ve; ae++)
      (ye || !(ae in Z)) && (ye || (ye = Array.prototype.slice.call(Z, 0, ae)), ye[ae] = Z[ae]);
  return ie.concat(ye || Array.prototype.slice.call(Z));
}
typeof SuppressedError == "function" && SuppressedError;
var zeroRightClassName = "right-scroll-bar-position", fullWidthClassName = "width-before-scroll-bar", noScrollbarsClassName = "with-scroll-bars-hidden", removedBarSizeVariable = "--removed-body-scroll-bar-size";
function assignRef(ie, Z) {
  return typeof ie == "function" ? ie(Z) : ie && (ie.current = Z), ie;
}
function useCallbackRef(ie, Z) {
  var ee = reactExports.useState(function() {
    return {
      // value
      value: ie,
      // last callback
      callback: Z,
      // "memoized" public interface
      facade: {
        get current() {
          return ee.value;
        },
        set current(ae) {
          var ve = ee.value;
          ve !== ae && (ee.value = ae, ee.callback(ae, ve));
        }
      }
    };
  })[0];
  return ee.callback = Z, ee.facade;
}
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(ie, Z) {
  var ee = useCallbackRef(Z || null, function(ae) {
    return ie.forEach(function(ve) {
      return assignRef(ve, ae);
    });
  });
  return reactExports.useLayoutEffect(function() {
    var ae = currentValues.get(ee);
    if (ae) {
      var ve = new Set(ae), ye = new Set(ie), be = ee.current;
      ve.forEach(function(Ye) {
        ye.has(Ye) || assignRef(Ye, null);
      }), ye.forEach(function(Ye) {
        ve.has(Ye) || assignRef(Ye, be);
      });
    }
    currentValues.set(ee, ie);
  }, [ie]), ee;
}
function ItoI(ie) {
  return ie;
}
function innerCreateMedium(ie, Z) {
  Z === void 0 && (Z = ItoI);
  var ee = [], ae = !1, ve = {
    read: function() {
      if (ae)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return ee.length ? ee[ee.length - 1] : ie;
    },
    useMedium: function(ye) {
      var be = Z(ye, ae);
      return ee.push(be), function() {
        ee = ee.filter(function(Ye) {
          return Ye !== be;
        });
      };
    },
    assignSyncMedium: function(ye) {
      for (ae = !0; ee.length; ) {
        var be = ee;
        ee = [], be.forEach(ye);
      }
      ee = {
        push: function(Ye) {
          return ye(Ye);
        },
        filter: function() {
          return ee;
        }
      };
    },
    assignMedium: function(ye) {
      ae = !0;
      var be = [];
      if (ee.length) {
        var Ye = ee;
        ee = [], Ye.forEach(ye), be = ee;
      }
      var Qe = function() {
        var nt = be;
        be = [], nt.forEach(ye);
      }, Je = function() {
        return Promise.resolve().then(Qe);
      };
      Je(), ee = {
        push: function(nt) {
          be.push(nt), Je();
        },
        filter: function(nt) {
          return be = be.filter(nt), ee;
        }
      };
    }
  };
  return ve;
}
function createSidecarMedium(ie) {
  ie === void 0 && (ie = {});
  var Z = innerCreateMedium(null);
  return Z.options = __assign({ async: !0, ssr: !1 }, ie), Z;
}
var SideCar$1 = function(ie) {
  var Z = ie.sideCar, ee = __rest(ie, ["sideCar"]);
  if (!Z)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var ae = Z.read();
  if (!ae)
    throw new Error("Sidecar medium not found");
  return reactExports.createElement(ae, __assign({}, ee));
};
SideCar$1.isSideCarExport = !0;
function exportSidecar(ie, Z) {
  return ie.useMedium(Z), SideCar$1;
}
var effectCar = createSidecarMedium(), nothing = function() {
}, RemoveScroll = reactExports.forwardRef(function(ie, Z) {
  var ee = reactExports.useRef(null), ae = reactExports.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), ve = ae[0], ye = ae[1], be = ie.forwardProps, Ye = ie.children, Qe = ie.className, Je = ie.removeScrollBar, nt = ie.enabled, st = ie.shards, ot = ie.sideCar, lt = ie.noIsolation, ft = ie.inert, gt = ie.allowPinchZoom, ct = ie.as, _r = ct === void 0 ? "div" : ct, Kr = __rest(ie, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), Xr = ot, Jr = useMergeRefs([ee, Z]), ei = __assign(__assign({}, Kr), ve);
  return reactExports.createElement(
    reactExports.Fragment,
    null,
    nt && reactExports.createElement(Xr, { sideCar: effectCar, removeScrollBar: Je, shards: st, noIsolation: lt, inert: ft, setCallbacks: ye, allowPinchZoom: !!gt, lockRef: ee }),
    be ? reactExports.cloneElement(reactExports.Children.only(Ye), __assign(__assign({}, ei), { ref: Jr })) : reactExports.createElement(_r, __assign({}, ei, { className: Qe, ref: Jr }), Ye)
  );
});
RemoveScroll.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var getNonce = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function makeStyleTag() {
  if (!document)
    return null;
  var ie = document.createElement("style");
  ie.type = "text/css";
  var Z = getNonce();
  return Z && ie.setAttribute("nonce", Z), ie;
}
function injectStyles(ie, Z) {
  ie.styleSheet ? ie.styleSheet.cssText = Z : ie.appendChild(document.createTextNode(Z));
}
function insertStyleTag(ie) {
  var Z = document.head || document.getElementsByTagName("head")[0];
  Z.appendChild(ie);
}
var stylesheetSingleton = function() {
  var ie = 0, Z = null;
  return {
    add: function(ee) {
      ie == 0 && (Z = makeStyleTag()) && (injectStyles(Z, ee), insertStyleTag(Z)), ie++;
    },
    remove: function() {
      ie--, !ie && Z && (Z.parentNode && Z.parentNode.removeChild(Z), Z = null);
    }
  };
}, styleHookSingleton = function() {
  var ie = stylesheetSingleton();
  return function(Z, ee) {
    reactExports.useEffect(function() {
      return ie.add(Z), function() {
        ie.remove();
      };
    }, [Z && ee]);
  };
}, styleSingleton = function() {
  var ie = styleHookSingleton(), Z = function(ee) {
    var ae = ee.styles, ve = ee.dynamic;
    return ie(ae, ve), null;
  };
  return Z;
}, zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, parse = function(ie) {
  return parseInt(ie || "", 10) || 0;
}, getOffset = function(ie) {
  var Z = window.getComputedStyle(document.body), ee = Z[ie === "padding" ? "paddingLeft" : "marginLeft"], ae = Z[ie === "padding" ? "paddingTop" : "marginTop"], ve = Z[ie === "padding" ? "paddingRight" : "marginRight"];
  return [parse(ee), parse(ae), parse(ve)];
}, getGapWidth = function(ie) {
  if (ie === void 0 && (ie = "margin"), typeof window > "u")
    return zeroGap;
  var Z = getOffset(ie), ee = document.documentElement.clientWidth, ae = window.innerWidth;
  return {
    left: Z[0],
    top: Z[1],
    right: Z[2],
    gap: Math.max(0, ae - ee + Z[2] - Z[0])
  };
}, Style = styleSingleton(), getStyles = function(ie, Z, ee, ae) {
  var ve = ie.left, ye = ie.top, be = ie.right, Ye = ie.gap;
  return ee === void 0 && (ee = "margin"), `
  .`.concat(noScrollbarsClassName, ` {
   overflow: hidden `).concat(ae, `;
   padding-right: `).concat(Ye, "px ").concat(ae, `;
  }
  body {
    overflow: hidden `).concat(ae, `;
    overscroll-behavior: contain;
    `).concat([
    Z && "position: relative ".concat(ae, ";"),
    ee === "margin" && `
    padding-left: `.concat(ve, `px;
    padding-top: `).concat(ye, `px;
    padding-right: `).concat(be, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(Ye, "px ").concat(ae, `;
    `),
    ee === "padding" && "padding-right: ".concat(Ye, "px ").concat(ae, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(zeroRightClassName, ` {
    right: `).concat(Ye, "px ").concat(ae, `;
  }
  
  .`).concat(fullWidthClassName, ` {
    margin-right: `).concat(Ye, "px ").concat(ae, `;
  }
  
  .`).concat(zeroRightClassName, " .").concat(zeroRightClassName, ` {
    right: 0 `).concat(ae, `;
  }
  
  .`).concat(fullWidthClassName, " .").concat(fullWidthClassName, ` {
    margin-right: 0 `).concat(ae, `;
  }
  
  body {
    `).concat(removedBarSizeVariable, ": ").concat(Ye, `px;
  }
`);
}, RemoveScrollBar = function(ie) {
  var Z = ie.noRelative, ee = ie.noImportant, ae = ie.gapMode, ve = ae === void 0 ? "margin" : ae, ye = reactExports.useMemo(function() {
    return getGapWidth(ve);
  }, [ve]);
  return reactExports.createElement(Style, { styles: getStyles(ye, !Z, ve, ee ? "" : "!important") });
}, passiveSupported = !1;
if (typeof window < "u")
  try {
    var options = Object.defineProperty({}, "passive", {
      get: function() {
        return passiveSupported = !0, !0;
      }
    });
    window.addEventListener("test", options, options), window.removeEventListener("test", options, options);
  } catch {
    passiveSupported = !1;
  }
var nonPassive = passiveSupported ? { passive: !1 } : !1, alwaysContainsScroll = function(ie) {
  return ie.tagName === "TEXTAREA";
}, elementCanBeScrolled = function(ie, Z) {
  var ee = window.getComputedStyle(ie);
  return (
    // not-not-scrollable
    ee[Z] !== "hidden" && // contains scroll inside self
    !(ee.overflowY === ee.overflowX && !alwaysContainsScroll(ie) && ee[Z] === "visible")
  );
}, elementCouldBeVScrolled = function(ie) {
  return elementCanBeScrolled(ie, "overflowY");
}, elementCouldBeHScrolled = function(ie) {
  return elementCanBeScrolled(ie, "overflowX");
}, locationCouldBeScrolled = function(ie, Z) {
  var ee = Z;
  do {
    typeof ShadowRoot < "u" && ee instanceof ShadowRoot && (ee = ee.host);
    var ae = elementCouldBeScrolled(ie, ee);
    if (ae) {
      var ve = getScrollVariables(ie, ee), ye = ve[1], be = ve[2];
      if (ye > be)
        return !0;
    }
    ee = ee.parentNode;
  } while (ee && ee !== document.body);
  return !1;
}, getVScrollVariables = function(ie) {
  var Z = ie.scrollTop, ee = ie.scrollHeight, ae = ie.clientHeight;
  return [
    Z,
    ee,
    ae
  ];
}, getHScrollVariables = function(ie) {
  var Z = ie.scrollLeft, ee = ie.scrollWidth, ae = ie.clientWidth;
  return [
    Z,
    ee,
    ae
  ];
}, elementCouldBeScrolled = function(ie, Z) {
  return ie === "v" ? elementCouldBeVScrolled(Z) : elementCouldBeHScrolled(Z);
}, getScrollVariables = function(ie, Z) {
  return ie === "v" ? getVScrollVariables(Z) : getHScrollVariables(Z);
}, getDirectionFactor = function(ie, Z) {
  return ie === "h" && Z === "rtl" ? -1 : 1;
}, handleScroll = function(ie, Z, ee, ae, ve) {
  var ye = getDirectionFactor(ie, window.getComputedStyle(Z).direction), be = ye * ae, Ye = ee.target, Qe = Z.contains(Ye), Je = !1, nt = be > 0, st = 0, ot = 0;
  do {
    var lt = getScrollVariables(ie, Ye), ft = lt[0], gt = lt[1], ct = lt[2], _r = gt - ct - ye * ft;
    (ft || _r) && elementCouldBeScrolled(ie, Ye) && (st += _r, ot += ft), Ye = Ye.parentNode;
  } while (
    // portaled content
    !Qe && Ye !== document.body || // self content
    Qe && (Z.contains(Ye) || Z === Ye)
  );
  return (nt && (ve && st === 0 || !ve && be > st) || !nt && (ve && ot === 0 || !ve && -be > ot)) && (Je = !0), Je;
}, getTouchXY = function(ie) {
  return "changedTouches" in ie ? [ie.changedTouches[0].clientX, ie.changedTouches[0].clientY] : [0, 0];
}, getDeltaXY = function(ie) {
  return [ie.deltaX, ie.deltaY];
}, extractRef = function(ie) {
  return ie && "current" in ie ? ie.current : ie;
}, deltaCompare = function(ie, Z) {
  return ie[0] === Z[0] && ie[1] === Z[1];
}, generateStyle = function(ie) {
  return `
  .block-interactivity-`.concat(ie, ` {pointer-events: none;}
  .allow-interactivity-`).concat(ie, ` {pointer-events: all;}
`);
}, idCounter = 0, lockStack = [];
function RemoveScrollSideCar(ie) {
  var Z = reactExports.useRef([]), ee = reactExports.useRef([0, 0]), ae = reactExports.useRef(), ve = reactExports.useState(idCounter++)[0], ye = reactExports.useState(function() {
    return styleSingleton();
  })[0], be = reactExports.useRef(ie);
  reactExports.useEffect(function() {
    be.current = ie;
  }, [ie]), reactExports.useEffect(function() {
    if (ie.inert) {
      document.body.classList.add("block-interactivity-".concat(ve));
      var gt = __spreadArray([ie.lockRef.current], (ie.shards || []).map(extractRef), !0).filter(Boolean);
      return gt.forEach(function(ct) {
        return ct.classList.add("allow-interactivity-".concat(ve));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(ve)), gt.forEach(function(ct) {
          return ct.classList.remove("allow-interactivity-".concat(ve));
        });
      };
    }
  }, [ie.inert, ie.lockRef.current, ie.shards]);
  var Ye = reactExports.useCallback(function(gt, ct) {
    if ("touches" in gt && gt.touches.length === 2)
      return !be.current.allowPinchZoom;
    var _r = getTouchXY(gt), Kr = ee.current, Xr = "deltaX" in gt ? gt.deltaX : Kr[0] - _r[0], Jr = "deltaY" in gt ? gt.deltaY : Kr[1] - _r[1], ei, si = gt.target, ri = Math.abs(Xr) > Math.abs(Jr) ? "h" : "v";
    if ("touches" in gt && ri === "h" && si.type === "range")
      return !1;
    var ai = locationCouldBeScrolled(ri, si);
    if (!ai)
      return !0;
    if (ai ? ei = ri : (ei = ri === "v" ? "h" : "v", ai = locationCouldBeScrolled(ri, si)), !ai)
      return !1;
    if (!ae.current && "changedTouches" in gt && (Xr || Jr) && (ae.current = ei), !ei)
      return !0;
    var yi = ae.current || ei;
    return handleScroll(yi, ct, gt, yi === "h" ? Xr : Jr, !0);
  }, []), Qe = reactExports.useCallback(function(gt) {
    var ct = gt;
    if (!(!lockStack.length || lockStack[lockStack.length - 1] !== ye)) {
      var _r = "deltaY" in ct ? getDeltaXY(ct) : getTouchXY(ct), Kr = Z.current.filter(function(ei) {
        return ei.name === ct.type && ei.target === ct.target && deltaCompare(ei.delta, _r);
      })[0];
      if (Kr && Kr.should) {
        ct.cancelable && ct.preventDefault();
        return;
      }
      if (!Kr) {
        var Xr = (be.current.shards || []).map(extractRef).filter(Boolean).filter(function(ei) {
          return ei.contains(ct.target);
        }), Jr = Xr.length > 0 ? Ye(ct, Xr[0]) : !be.current.noIsolation;
        Jr && ct.cancelable && ct.preventDefault();
      }
    }
  }, []), Je = reactExports.useCallback(function(gt, ct, _r, Kr) {
    var Xr = { name: gt, delta: ct, target: _r, should: Kr };
    Z.current.push(Xr), setTimeout(function() {
      Z.current = Z.current.filter(function(Jr) {
        return Jr !== Xr;
      });
    }, 1);
  }, []), nt = reactExports.useCallback(function(gt) {
    ee.current = getTouchXY(gt), ae.current = void 0;
  }, []), st = reactExports.useCallback(function(gt) {
    Je(gt.type, getDeltaXY(gt), gt.target, Ye(gt, ie.lockRef.current));
  }, []), ot = reactExports.useCallback(function(gt) {
    Je(gt.type, getTouchXY(gt), gt.target, Ye(gt, ie.lockRef.current));
  }, []);
  reactExports.useEffect(function() {
    return lockStack.push(ye), ie.setCallbacks({
      onScrollCapture: st,
      onWheelCapture: st,
      onTouchMoveCapture: ot
    }), document.addEventListener("wheel", Qe, nonPassive), document.addEventListener("touchmove", Qe, nonPassive), document.addEventListener("touchstart", nt, nonPassive), function() {
      lockStack = lockStack.filter(function(gt) {
        return gt !== ye;
      }), document.removeEventListener("wheel", Qe, nonPassive), document.removeEventListener("touchmove", Qe, nonPassive), document.removeEventListener("touchstart", nt, nonPassive);
    };
  }, []);
  var lt = ie.removeScrollBar, ft = ie.inert;
  return reactExports.createElement(
    reactExports.Fragment,
    null,
    ft ? reactExports.createElement(ye, { styles: generateStyle(ve) }) : null,
    lt ? reactExports.createElement(RemoveScrollBar, { gapMode: "margin" }) : null
  );
}
const SideCar = exportSidecar(effectCar, RemoveScrollSideCar);
var ReactRemoveScroll = reactExports.forwardRef(function(ie, Z) {
  return reactExports.createElement(RemoveScroll, __assign({}, ie, { ref: Z, sideCar: SideCar }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
const $01b9c$RemoveScroll = ReactRemoveScroll, $cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover", [$cb5cc270b50c6fcd$var$createPopoverContext, $cb5cc270b50c6fcd$export$c8393c9e73286932] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cb5cc270b50c6fcd$var$POPOVER_NAME, [
  $cf1ac5d9fe0e8206$export$722aac194ae923
]), $cb5cc270b50c6fcd$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923(), [$cb5cc270b50c6fcd$var$PopoverProvider, $cb5cc270b50c6fcd$var$usePopoverContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$POPOVER_NAME), $cb5cc270b50c6fcd$export$5b6b19405a83ff9d = (ie) => {
  const { __scopePopover: Z, children: ee, open: ae, defaultOpen: ve, onOpenChange: ye, modal: be = !1 } = ie, Ye = $cb5cc270b50c6fcd$var$usePopperScope(Z), Qe = reactExports.useRef(null), [Je, nt] = reactExports.useState(!1), [st = !1, ot] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: ae,
    defaultProp: ve,
    onChange: ye
  });
  return /* @__PURE__ */ reactExports.createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, Ye, /* @__PURE__ */ reactExports.createElement($cb5cc270b50c6fcd$var$PopoverProvider, {
    scope: Z,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    triggerRef: Qe,
    open: st,
    onOpenChange: ot,
    onOpenToggle: reactExports.useCallback(
      () => ot(
        (lt) => !lt
      ),
      [
        ot
      ]
    ),
    hasCustomAnchor: Je,
    onCustomAnchorAdd: reactExports.useCallback(
      () => nt(!0),
      []
    ),
    onCustomAnchorRemove: reactExports.useCallback(
      () => nt(!1),
      []
    ),
    modal: be
  }, ee));
}, $cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger", $cb5cc270b50c6fcd$export$7dacb05d26466c3 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopePopover: ee, ...ae } = ie, ve = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$TRIGGER_NAME, ee), ye = $cb5cc270b50c6fcd$var$usePopperScope(ee), be = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, ve.triggerRef), Ye = /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": ve.open,
    "aria-controls": ve.contentId,
    "data-state": $cb5cc270b50c6fcd$var$getState(ve.open)
  }, ae, {
    ref: be,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onClick, ve.onOpenToggle)
  }));
  return ve.hasCustomAnchor ? Ye : /* @__PURE__ */ reactExports.createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$1({
    asChild: !0
  }, ye), Ye);
}), $cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal", [$cb5cc270b50c6fcd$var$PortalProvider, $cb5cc270b50c6fcd$var$usePortalContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$PORTAL_NAME, {
  forceMount: void 0
}), $cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent", $cb5cc270b50c6fcd$export$d7e1f420b25549ff = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const ee = $cb5cc270b50c6fcd$var$usePortalContext($cb5cc270b50c6fcd$var$CONTENT_NAME, ie.__scopePopover), { forceMount: ae = ee.forceMount, ...ve } = ie, ye = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, ie.__scopePopover);
  return /* @__PURE__ */ reactExports.createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: ae || ye.open
  }, ye.modal ? /* @__PURE__ */ reactExports.createElement($cb5cc270b50c6fcd$var$PopoverContentModal, _extends$1({}, ve, {
    ref: Z
  })) : /* @__PURE__ */ reactExports.createElement($cb5cc270b50c6fcd$var$PopoverContentNonModal, _extends$1({}, ve, {
    ref: Z
  })));
}), $cb5cc270b50c6fcd$var$PopoverContentModal = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const ee = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, ie.__scopePopover), ae = reactExports.useRef(null), ve = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, ae), ye = reactExports.useRef(!1);
  return reactExports.useEffect(() => {
    const be = ae.current;
    if (be)
      return hideOthers(be);
  }, []), /* @__PURE__ */ reactExports.createElement($01b9c$RemoveScroll, {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
    allowPinchZoom: !0
  }, /* @__PURE__ */ reactExports.createElement($cb5cc270b50c6fcd$var$PopoverContentImpl, _extends$1({}, ie, {
    ref: ve,
    trapFocus: ee.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onCloseAutoFocus, (be) => {
      var Ye;
      be.preventDefault(), ye.current || (Ye = ee.triggerRef.current) === null || Ye === void 0 || Ye.focus();
    }),
    onPointerDownOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onPointerDownOutside, (be) => {
      const Ye = be.detail.originalEvent, Qe = Ye.button === 0 && Ye.ctrlKey === !0, Je = Ye.button === 2 || Qe;
      ye.current = Je;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      ie.onFocusOutside,
      (be) => be.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), $cb5cc270b50c6fcd$var$PopoverContentNonModal = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const ee = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, ie.__scopePopover), ae = reactExports.useRef(!1), ve = reactExports.useRef(!1);
  return /* @__PURE__ */ reactExports.createElement($cb5cc270b50c6fcd$var$PopoverContentImpl, _extends$1({}, ie, {
    ref: Z,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (ye) => {
      var be;
      if ((be = ie.onCloseAutoFocus) === null || be === void 0 || be.call(ie, ye), !ye.defaultPrevented) {
        var Ye;
        ae.current || (Ye = ee.triggerRef.current) === null || Ye === void 0 || Ye.focus(), ye.preventDefault();
      }
      ae.current = !1, ve.current = !1;
    },
    onInteractOutside: (ye) => {
      var be, Ye;
      (be = ie.onInteractOutside) === null || be === void 0 || be.call(ie, ye), ye.defaultPrevented || (ae.current = !0, ye.detail.originalEvent.type === "pointerdown" && (ve.current = !0));
      const Qe = ye.target;
      ((Ye = ee.triggerRef.current) === null || Ye === void 0 ? void 0 : Ye.contains(Qe)) && ye.preventDefault(), ye.detail.originalEvent.type === "focusin" && ve.current && ye.preventDefault();
    }
  }));
}), $cb5cc270b50c6fcd$var$PopoverContentImpl = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopePopover: ee, trapFocus: ae, onOpenAutoFocus: ve, onCloseAutoFocus: ye, disableOutsidePointerEvents: be, onEscapeKeyDown: Ye, onPointerDownOutside: Qe, onFocusOutside: Je, onInteractOutside: nt, ...st } = ie, ot = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, ee), lt = $cb5cc270b50c6fcd$var$usePopperScope(ee);
  return $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c(), /* @__PURE__ */ reactExports.createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
    asChild: !0,
    loop: !0,
    trapped: ae,
    onMountAutoFocus: ve,
    onUnmountAutoFocus: ye
  }, /* @__PURE__ */ reactExports.createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: !0,
    disableOutsidePointerEvents: be,
    onInteractOutside: nt,
    onEscapeKeyDown: Ye,
    onPointerDownOutside: Qe,
    onFocusOutside: Je,
    onDismiss: () => ot.onOpenChange(!1)
  }, /* @__PURE__ */ reactExports.createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$1({
    "data-state": $cb5cc270b50c6fcd$var$getState(ot.open),
    role: "dialog",
    id: ot.contentId
  }, lt, st, {
    ref: Z,
    style: {
      ...st.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), $cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose", $cb5cc270b50c6fcd$export$d6ac43ebaa40d53e = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopePopover: ee, ...ae } = ie, ve = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CLOSE_NAME, ee);
  return /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button"
  }, ae, {
    ref: Z,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      ie.onClick,
      () => ve.onOpenChange(!1)
    )
  }));
}), $cb5cc270b50c6fcd$export$3152841115e061b2 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopePopover: ee, ...ae } = ie, ve = $cb5cc270b50c6fcd$var$usePopperScope(ee);
  return /* @__PURE__ */ reactExports.createElement($cf1ac5d9fe0e8206$export$21b07c8f274aebd5, _extends$1({}, ve, ae, {
    ref: Z
  }));
});
function $cb5cc270b50c6fcd$var$getState(ie) {
  return ie ? "open" : "closed";
}
const $cb5cc270b50c6fcd$export$be92b6f5f03c0fe9 = $cb5cc270b50c6fcd$export$5b6b19405a83ff9d, $cb5cc270b50c6fcd$export$41fb9f06171c75f4 = $cb5cc270b50c6fcd$export$7dacb05d26466c3, $cb5cc270b50c6fcd$export$7c6e2c02157bb7d2 = $cb5cc270b50c6fcd$export$d7e1f420b25549ff, $cb5cc270b50c6fcd$export$f39c2d165cd861fe = $cb5cc270b50c6fcd$export$d6ac43ebaa40d53e, $cb5cc270b50c6fcd$export$21b07c8f274aebd5 = $cb5cc270b50c6fcd$export$3152841115e061b2;
function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(ie, [Z, ee]) {
  return Math.min(ee, Math.max(Z, ie));
}
const $ea1ef594cf570d83$export$439d29a4e110a164 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({}, ie, {
  ref: Z,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...ie.style
  }
}))), $cc7e05a45900e73f$var$OPEN_KEYS = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], $cc7e05a45900e73f$var$SELECTION_KEYS = [
  " ",
  "Enter"
], $cc7e05a45900e73f$var$SELECT_NAME = "Select", [$cc7e05a45900e73f$var$Collection, $cc7e05a45900e73f$var$useCollection, $cc7e05a45900e73f$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($cc7e05a45900e73f$var$SELECT_NAME), [$cc7e05a45900e73f$var$createSelectContext, $cc7e05a45900e73f$export$286727a75dc039bd] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cc7e05a45900e73f$var$SELECT_NAME, [
  $cc7e05a45900e73f$var$createCollectionScope,
  $cf1ac5d9fe0e8206$export$722aac194ae923
]), $cc7e05a45900e73f$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923(), [$cc7e05a45900e73f$var$SelectProvider, $cc7e05a45900e73f$var$useSelectContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$SELECT_NAME), [$cc7e05a45900e73f$var$SelectNativeOptionsProvider, $cc7e05a45900e73f$var$useSelectNativeOptionsContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$SELECT_NAME), $cc7e05a45900e73f$export$ef9b1a59e592288f = (ie) => {
  const { __scopeSelect: Z, children: ee, open: ae, defaultOpen: ve, onOpenChange: ye, value: be, defaultValue: Ye, onValueChange: Qe, dir: Je, name: nt, autoComplete: st, disabled: ot, required: lt } = ie, ft = $cc7e05a45900e73f$var$usePopperScope(Z), [gt, ct] = reactExports.useState(null), [_r, Kr] = reactExports.useState(null), [Xr, Jr] = reactExports.useState(!1), ei = $f631663db3294ace$export$b39126d51d94e6f3(Je), [si = !1, ri] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: ae,
    defaultProp: ve,
    onChange: ye
  }), [ai, yi] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: be,
    defaultProp: Ye,
    onChange: Qe
  }), pi = reactExports.useRef(null), di = gt ? !!gt.closest("form") : !0, [xi, Ti] = reactExports.useState(/* @__PURE__ */ new Set()), Ai = Array.from(xi).map(
    (mi) => mi.props.value
  ).join(";");
  return /* @__PURE__ */ reactExports.createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, ft, /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$SelectProvider, {
    required: lt,
    scope: Z,
    trigger: gt,
    onTriggerChange: ct,
    valueNode: _r,
    onValueNodeChange: Kr,
    valueNodeHasChildren: Xr,
    onValueNodeHasChildrenChange: Jr,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    value: ai,
    onValueChange: yi,
    open: si,
    onOpenChange: ri,
    dir: ei,
    triggerPointerDownPosRef: pi,
    disabled: ot
  }, /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$Collection.Provider, {
    scope: Z
  }, /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$SelectNativeOptionsProvider, {
    scope: ie.__scopeSelect,
    onNativeOptionAdd: reactExports.useCallback((mi) => {
      Ti(
        (Si) => new Set(Si).add(mi)
      );
    }, []),
    onNativeOptionRemove: reactExports.useCallback((mi) => {
      Ti((Si) => {
        const gi = new Set(Si);
        return gi.delete(mi), gi;
      });
    }, [])
  }, ee)), di ? /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$BubbleSelect, {
    key: Ai,
    "aria-hidden": !0,
    required: lt,
    tabIndex: -1,
    name: nt,
    autoComplete: st,
    value: ai,
    onChange: (mi) => yi(mi.target.value),
    disabled: ot
  }, ai === void 0 ? /* @__PURE__ */ reactExports.createElement("option", {
    value: ""
  }) : null, Array.from(xi)) : null));
}, $cc7e05a45900e73f$var$TRIGGER_NAME = "SelectTrigger", $cc7e05a45900e73f$export$3ac1e88a1c0b9f1 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, disabled: ae = !1, ...ve } = ie, ye = $cc7e05a45900e73f$var$usePopperScope(ee), be = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$TRIGGER_NAME, ee), Ye = be.disabled || ae, Qe = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, be.onTriggerChange), Je = $cc7e05a45900e73f$var$useCollection(ee), [nt, st, ot] = $cc7e05a45900e73f$var$useTypeaheadSearch((ft) => {
    const gt = Je().filter(
      (Kr) => !Kr.disabled
    ), ct = gt.find(
      (Kr) => Kr.value === be.value
    ), _r = $cc7e05a45900e73f$var$findNextItem(gt, ft, ct);
    _r !== void 0 && be.onValueChange(_r.value);
  }), lt = () => {
    Ye || (be.onOpenChange(!0), ot());
  };
  return /* @__PURE__ */ reactExports.createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$1({
    asChild: !0
  }, ye), /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button",
    role: "combobox",
    "aria-controls": be.contentId,
    "aria-expanded": be.open,
    "aria-required": be.required,
    "aria-autocomplete": "none",
    dir: be.dir,
    "data-state": be.open ? "open" : "closed",
    disabled: Ye,
    "data-disabled": Ye ? "" : void 0,
    "data-placeholder": $cc7e05a45900e73f$var$shouldShowPlaceholder(be.value) ? "" : void 0
  }, ve, {
    ref: Qe,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ve.onClick, (ft) => {
      ft.currentTarget.focus();
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ve.onPointerDown, (ft) => {
      const gt = ft.target;
      gt.hasPointerCapture(ft.pointerId) && gt.releasePointerCapture(ft.pointerId), ft.button === 0 && ft.ctrlKey === !1 && (lt(), be.triggerPointerDownPosRef.current = {
        x: Math.round(ft.pageX),
        y: Math.round(ft.pageY)
      }, ft.preventDefault());
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ve.onKeyDown, (ft) => {
      const gt = nt.current !== "";
      !(ft.ctrlKey || ft.altKey || ft.metaKey) && ft.key.length === 1 && st(ft.key), !(gt && ft.key === " ") && $cc7e05a45900e73f$var$OPEN_KEYS.includes(ft.key) && (lt(), ft.preventDefault());
    })
  })));
}), $cc7e05a45900e73f$var$VALUE_NAME = "SelectValue", $cc7e05a45900e73f$export$e288731fd71264f0 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, className: ae, style: ve, children: ye, placeholder: be = "", ...Ye } = ie, Qe = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$VALUE_NAME, ee), { onValueNodeHasChildrenChange: Je } = Qe, nt = ye !== void 0, st = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, Qe.onValueNodeChange);
  return $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    Je(nt);
  }, [
    Je,
    nt
  ]), /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({}, Ye, {
    ref: st,
    style: {
      pointerEvents: "none"
    }
  }), $cc7e05a45900e73f$var$shouldShowPlaceholder(Qe.value) ? /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, be) : ye);
}), $cc7e05a45900e73f$export$99b400cabb58c515 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, children: ae, ...ve } = ie;
  return /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({
    "aria-hidden": !0
  }, ve, {
    ref: Z
  }), ae || "▼");
}), $cc7e05a45900e73f$export$b2af6c9944296213 = (ie) => /* @__PURE__ */ reactExports.createElement($f1701beae083dbae$export$602eac185826482c, _extends$1({
  asChild: !0
}, ie)), $cc7e05a45900e73f$var$CONTENT_NAME = "SelectContent", $cc7e05a45900e73f$export$c973a4b3cb86a03d = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const ee = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, ie.__scopeSelect), [ae, ve] = reactExports.useState();
  if ($9f79659886946c16$export$e5c5a5f917a5871c(() => {
    ve(new DocumentFragment());
  }, []), !ee.open) {
    const ye = ae;
    return ye ? /* @__PURE__ */ reactDomExports.createPortal(/* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$SelectContentProvider, {
      scope: ie.__scopeSelect
    }, /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$Collection.Slot, {
      scope: ie.__scopeSelect
    }, /* @__PURE__ */ reactExports.createElement("div", null, ie.children))), ye) : null;
  }
  return /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$SelectContentImpl, _extends$1({}, ie, {
    ref: Z
  }));
}), $cc7e05a45900e73f$var$CONTENT_MARGIN = 10, [$cc7e05a45900e73f$var$SelectContentProvider, $cc7e05a45900e73f$var$useSelectContentContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$CONTENT_NAME), $cc7e05a45900e73f$var$SelectContentImpl = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const {
    __scopeSelect: ee,
    position: ae = "item-aligned",
    onCloseAutoFocus: ve,
    onEscapeKeyDown: ye,
    onPointerDownOutside: be,
    side: Ye,
    sideOffset: Qe,
    align: Je,
    alignOffset: nt,
    arrowPadding: st,
    collisionBoundary: ot,
    collisionPadding: lt,
    sticky: ft,
    hideWhenDetached: gt,
    avoidCollisions: ct,
    //
    ..._r
  } = ie, Kr = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, ee), [Xr, Jr] = reactExports.useState(null), [ei, si] = reactExports.useState(null), ri = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    Z,
    (Yi) => Jr(Yi)
  ), [ai, yi] = reactExports.useState(null), [pi, di] = reactExports.useState(null), xi = $cc7e05a45900e73f$var$useCollection(ee), [Ti, Ai] = reactExports.useState(!1), mi = reactExports.useRef(!1);
  reactExports.useEffect(() => {
    if (Xr)
      return hideOthers(Xr);
  }, [
    Xr
  ]), $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  const Si = reactExports.useCallback((Yi) => {
    const [is, ...Ss] = xi().map(
      (Ws) => Ws.ref.current
    ), [Gs] = Ss.slice(-1), Vs = document.activeElement;
    for (const Ws of Yi)
      if (Ws === Vs || (Ws == null || Ws.scrollIntoView({
        block: "nearest"
      }), Ws === is && ei && (ei.scrollTop = 0), Ws === Gs && ei && (ei.scrollTop = ei.scrollHeight), Ws == null || Ws.focus(), document.activeElement !== Vs))
        return;
  }, [
    xi,
    ei
  ]), gi = reactExports.useCallback(
    () => Si([
      ai,
      Xr
    ]),
    [
      Si,
      ai,
      Xr
    ]
  );
  reactExports.useEffect(() => {
    Ti && gi();
  }, [
    Ti,
    gi
  ]);
  const { onOpenChange: _i, triggerPointerDownPosRef: Oi } = Kr;
  reactExports.useEffect(() => {
    if (Xr) {
      let Yi = {
        x: 0,
        y: 0
      };
      const is = (Gs) => {
        var Vs, Ws, ii, bi;
        Yi = {
          x: Math.abs(Math.round(Gs.pageX) - ((Vs = (Ws = Oi.current) === null || Ws === void 0 ? void 0 : Ws.x) !== null && Vs !== void 0 ? Vs : 0)),
          y: Math.abs(Math.round(Gs.pageY) - ((ii = (bi = Oi.current) === null || bi === void 0 ? void 0 : bi.y) !== null && ii !== void 0 ? ii : 0))
        };
      }, Ss = (Gs) => {
        Yi.x <= 10 && Yi.y <= 10 ? Gs.preventDefault() : Xr.contains(Gs.target) || _i(!1), document.removeEventListener("pointermove", is), Oi.current = null;
      };
      return Oi.current !== null && (document.addEventListener("pointermove", is), document.addEventListener("pointerup", Ss, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", is), document.removeEventListener("pointerup", Ss, {
          capture: !0
        });
      };
    }
  }, [
    Xr,
    _i,
    Oi
  ]), reactExports.useEffect(() => {
    const Yi = () => _i(!1);
    return window.addEventListener("blur", Yi), window.addEventListener("resize", Yi), () => {
      window.removeEventListener("blur", Yi), window.removeEventListener("resize", Yi);
    };
  }, [
    _i
  ]);
  const [hi, Di] = $cc7e05a45900e73f$var$useTypeaheadSearch((Yi) => {
    const is = xi().filter(
      (Vs) => !Vs.disabled
    ), Ss = is.find(
      (Vs) => Vs.ref.current === document.activeElement
    ), Gs = $cc7e05a45900e73f$var$findNextItem(is, Yi, Ss);
    Gs && setTimeout(
      () => Gs.ref.current.focus()
    );
  }), Ri = reactExports.useCallback((Yi, is, Ss) => {
    const Gs = !mi.current && !Ss;
    (Kr.value !== void 0 && Kr.value === is || Gs) && (yi(Yi), Gs && (mi.current = !0));
  }, [
    Kr.value
  ]), rs = reactExports.useCallback(
    () => Xr == null ? void 0 : Xr.focus(),
    [
      Xr
    ]
  ), Hi = reactExports.useCallback((Yi, is, Ss) => {
    const Gs = !mi.current && !Ss;
    (Kr.value !== void 0 && Kr.value === is || Gs) && di(Yi);
  }, [
    Kr.value
  ]), qi = ae === "popper" ? $cc7e05a45900e73f$var$SelectPopperPosition : $cc7e05a45900e73f$var$SelectItemAlignedPosition, us = qi === $cc7e05a45900e73f$var$SelectPopperPosition ? {
    side: Ye,
    sideOffset: Qe,
    align: Je,
    alignOffset: nt,
    arrowPadding: st,
    collisionBoundary: ot,
    collisionPadding: lt,
    sticky: ft,
    hideWhenDetached: gt,
    avoidCollisions: ct
  } : {};
  return /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$SelectContentProvider, {
    scope: ee,
    content: Xr,
    viewport: ei,
    onViewportChange: si,
    itemRefCallback: Ri,
    selectedItem: ai,
    onItemLeave: rs,
    itemTextRefCallback: Hi,
    focusSelectedItem: gi,
    selectedItemText: pi,
    position: ae,
    isPositioned: Ti,
    searchRef: hi
  }, /* @__PURE__ */ reactExports.createElement($01b9c$RemoveScroll, {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
    allowPinchZoom: !0
  }, /* @__PURE__ */ reactExports.createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
    asChild: !0,
    trapped: Kr.open,
    onMountAutoFocus: (Yi) => {
      Yi.preventDefault();
    },
    onUnmountAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ve, (Yi) => {
      var is;
      (is = Kr.trigger) === null || is === void 0 || is.focus({
        preventScroll: !0
      }), Yi.preventDefault();
    })
  }, /* @__PURE__ */ reactExports.createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: !0,
    disableOutsidePointerEvents: !0,
    onEscapeKeyDown: ye,
    onPointerDownOutside: be,
    onFocusOutside: (Yi) => Yi.preventDefault(),
    onDismiss: () => Kr.onOpenChange(!1)
  }, /* @__PURE__ */ reactExports.createElement(qi, _extends$1({
    role: "listbox",
    id: Kr.contentId,
    "data-state": Kr.open ? "open" : "closed",
    dir: Kr.dir,
    onContextMenu: (Yi) => Yi.preventDefault()
  }, _r, us, {
    onPlaced: () => Ai(!0),
    ref: ri,
    style: {
      // flex layout so we can place the scroll buttons properly
      display: "flex",
      flexDirection: "column",
      // reset the outline by default as the content MAY get focused
      outline: "none",
      ..._r.style
    },
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(_r.onKeyDown, (Yi) => {
      const is = Yi.ctrlKey || Yi.altKey || Yi.metaKey;
      if (Yi.key === "Tab" && Yi.preventDefault(), !is && Yi.key.length === 1 && Di(Yi.key), [
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(Yi.key)) {
        let Gs = xi().filter(
          (Vs) => !Vs.disabled
        ).map(
          (Vs) => Vs.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(Yi.key) && (Gs = Gs.slice().reverse()), [
          "ArrowUp",
          "ArrowDown"
        ].includes(Yi.key)) {
          const Vs = Yi.target, Ws = Gs.indexOf(Vs);
          Gs = Gs.slice(Ws + 1);
        }
        setTimeout(
          () => Si(Gs)
        ), Yi.preventDefault();
      }
    })
  }))))));
}), $cc7e05a45900e73f$var$SelectItemAlignedPosition = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, onPlaced: ae, ...ve } = ie, ye = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, ee), be = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$CONTENT_NAME, ee), [Ye, Qe] = reactExports.useState(null), [Je, nt] = reactExports.useState(null), st = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    Z,
    (ri) => nt(ri)
  ), ot = $cc7e05a45900e73f$var$useCollection(ee), lt = reactExports.useRef(!1), ft = reactExports.useRef(!0), { viewport: gt, selectedItem: ct, selectedItemText: _r, focusSelectedItem: Kr } = be, Xr = reactExports.useCallback(() => {
    if (ye.trigger && ye.valueNode && Ye && Je && gt && ct && _r) {
      const ri = ye.trigger.getBoundingClientRect(), ai = Je.getBoundingClientRect(), yi = ye.valueNode.getBoundingClientRect(), pi = _r.getBoundingClientRect();
      if (ye.dir !== "rtl") {
        const Vs = pi.left - ai.left, Ws = yi.left - Vs, ii = ri.left - Ws, bi = ri.width + ii, Gi = Math.max(bi, ai.width), Qi = window.innerWidth - $cc7e05a45900e73f$var$CONTENT_MARGIN, ns = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(Ws, [
          $cc7e05a45900e73f$var$CONTENT_MARGIN,
          Qi - Gi
        ]);
        Ye.style.minWidth = bi + "px", Ye.style.left = ns + "px";
      } else {
        const Vs = ai.right - pi.right, Ws = window.innerWidth - yi.right - Vs, ii = window.innerWidth - ri.right - Ws, bi = ri.width + ii, Gi = Math.max(bi, ai.width), Qi = window.innerWidth - $cc7e05a45900e73f$var$CONTENT_MARGIN, ns = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(Ws, [
          $cc7e05a45900e73f$var$CONTENT_MARGIN,
          Qi - Gi
        ]);
        Ye.style.minWidth = bi + "px", Ye.style.right = ns + "px";
      }
      const di = ot(), xi = window.innerHeight - $cc7e05a45900e73f$var$CONTENT_MARGIN * 2, Ti = gt.scrollHeight, Ai = window.getComputedStyle(Je), mi = parseInt(Ai.borderTopWidth, 10), Si = parseInt(Ai.paddingTop, 10), gi = parseInt(Ai.borderBottomWidth, 10), _i = parseInt(Ai.paddingBottom, 10), Oi = mi + Si + Ti + _i + gi, hi = Math.min(ct.offsetHeight * 5, Oi), Di = window.getComputedStyle(gt), Ri = parseInt(Di.paddingTop, 10), rs = parseInt(Di.paddingBottom, 10), Hi = ri.top + ri.height / 2 - $cc7e05a45900e73f$var$CONTENT_MARGIN, qi = xi - Hi, us = ct.offsetHeight / 2, Yi = ct.offsetTop + us, is = mi + Si + Yi, Ss = Oi - is;
      if (is <= Hi) {
        const Vs = ct === di[di.length - 1].ref.current;
        Ye.style.bottom = "0px";
        const Ws = Je.clientHeight - gt.offsetTop - gt.offsetHeight, ii = Math.max(qi, us + (Vs ? rs : 0) + Ws + gi), bi = is + ii;
        Ye.style.height = bi + "px";
      } else {
        const Vs = ct === di[0].ref.current;
        Ye.style.top = "0px";
        const ii = Math.max(Hi, mi + gt.offsetTop + (Vs ? Ri : 0) + us) + Ss;
        Ye.style.height = ii + "px", gt.scrollTop = is - Hi + gt.offsetTop;
      }
      Ye.style.margin = `${$cc7e05a45900e73f$var$CONTENT_MARGIN}px 0`, Ye.style.minHeight = hi + "px", Ye.style.maxHeight = xi + "px", ae == null || ae(), requestAnimationFrame(
        () => lt.current = !0
      );
    }
  }, [
    ot,
    ye.trigger,
    ye.valueNode,
    Ye,
    Je,
    gt,
    ct,
    _r,
    ye.dir,
    ae
  ]);
  $9f79659886946c16$export$e5c5a5f917a5871c(
    () => Xr(),
    [
      Xr
    ]
  );
  const [Jr, ei] = reactExports.useState();
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    Je && ei(window.getComputedStyle(Je).zIndex);
  }, [
    Je
  ]);
  const si = reactExports.useCallback((ri) => {
    ri && ft.current === !0 && (Xr(), Kr == null || Kr(), ft.current = !1);
  }, [
    Xr,
    Kr
  ]);
  return /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$SelectViewportProvider, {
    scope: ee,
    contentWrapper: Ye,
    shouldExpandOnScrollRef: lt,
    onScrollButtonChange: si
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: Qe,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: Jr
    }
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, ve, {
    ref: st,
    style: {
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      // We need to ensure the content doesn't get taller than the wrapper
      maxHeight: "100%",
      ...ve.style
    }
  }))));
}), $cc7e05a45900e73f$var$SelectPopperPosition = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, align: ae = "start", collisionPadding: ve = $cc7e05a45900e73f$var$CONTENT_MARGIN, ...ye } = ie, be = $cc7e05a45900e73f$var$usePopperScope(ee);
  return /* @__PURE__ */ reactExports.createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$1({}, be, ye, {
    ref: Z,
    align: ae,
    collisionPadding: ve,
    style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      ...ye.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), [$cc7e05a45900e73f$var$SelectViewportProvider, $cc7e05a45900e73f$var$useSelectViewportContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, {}), $cc7e05a45900e73f$var$VIEWPORT_NAME = "SelectViewport", $cc7e05a45900e73f$export$9ed6e7b40248d36d = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, ...ae } = ie, ve = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$VIEWPORT_NAME, ee), ye = $cc7e05a45900e73f$var$useSelectViewportContext($cc7e05a45900e73f$var$VIEWPORT_NAME, ee), be = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, ve.onViewportChange), Ye = reactExports.useRef(0);
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$Collection.Slot, {
    scope: ee
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, ae, {
    ref: be,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...ae.style
    },
    onScroll: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ae.onScroll, (Qe) => {
      const Je = Qe.currentTarget, { contentWrapper: nt, shouldExpandOnScrollRef: st } = ye;
      if (st != null && st.current && nt) {
        const ot = Math.abs(Ye.current - Je.scrollTop);
        if (ot > 0) {
          const lt = window.innerHeight - $cc7e05a45900e73f$var$CONTENT_MARGIN * 2, ft = parseFloat(nt.style.minHeight), gt = parseFloat(nt.style.height), ct = Math.max(ft, gt);
          if (ct < lt) {
            const _r = ct + ot, Kr = Math.min(lt, _r), Xr = _r - Kr;
            nt.style.height = Kr + "px", nt.style.bottom === "0px" && (Je.scrollTop = Xr > 0 ? Xr : 0, nt.style.justifyContent = "flex-end");
          }
        }
      }
      Ye.current = Je.scrollTop;
    })
  }))));
}), $cc7e05a45900e73f$var$GROUP_NAME = "SelectGroup", [$cc7e05a45900e73f$var$SelectGroupContextProvider, $cc7e05a45900e73f$var$useSelectGroupContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$GROUP_NAME), $cc7e05a45900e73f$export$ee25a334c55de1f4 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, ...ae } = ie, ve = $1746a345f3d73bb7$export$f680877a34711e37();
  return /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$SelectGroupContextProvider, {
    scope: ee,
    id: ve
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    role: "group",
    "aria-labelledby": ve
  }, ae, {
    ref: Z
  })));
}), $cc7e05a45900e73f$var$LABEL_NAME = "SelectLabel", $cc7e05a45900e73f$export$f67338d29bd972f8 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, ...ae } = ie, ve = $cc7e05a45900e73f$var$useSelectGroupContext($cc7e05a45900e73f$var$LABEL_NAME, ee);
  return /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    id: ve.id
  }, ae, {
    ref: Z
  }));
}), $cc7e05a45900e73f$var$ITEM_NAME = "SelectItem", [$cc7e05a45900e73f$var$SelectItemContextProvider, $cc7e05a45900e73f$var$useSelectItemContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$ITEM_NAME), $cc7e05a45900e73f$export$13ef48a934230896 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, value: ae, disabled: ve = !1, textValue: ye, ...be } = ie, Ye = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$ITEM_NAME, ee), Qe = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$ITEM_NAME, ee), Je = Ye.value === ae, [nt, st] = reactExports.useState(ye ?? ""), [ot, lt] = reactExports.useState(!1), ft = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, (_r) => {
    var Kr;
    return (Kr = Qe.itemRefCallback) === null || Kr === void 0 ? void 0 : Kr.call(Qe, _r, ae, ve);
  }), gt = $1746a345f3d73bb7$export$f680877a34711e37(), ct = () => {
    ve || (Ye.onValueChange(ae), Ye.onOpenChange(!1));
  };
  if (ae === "")
    throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
  return /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$SelectItemContextProvider, {
    scope: ee,
    value: ae,
    disabled: ve,
    textId: gt,
    isSelected: Je,
    onItemTextChange: reactExports.useCallback((_r) => {
      st((Kr) => {
        var Xr;
        return Kr || ((Xr = _r == null ? void 0 : _r.textContent) !== null && Xr !== void 0 ? Xr : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$Collection.ItemSlot, {
    scope: ee,
    value: ae,
    disabled: ve,
    textValue: nt
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    role: "option",
    "aria-labelledby": gt,
    "data-highlighted": ot ? "" : void 0,
    "aria-selected": Je && ot,
    "data-state": Je ? "checked" : "unchecked",
    "aria-disabled": ve || void 0,
    "data-disabled": ve ? "" : void 0,
    tabIndex: ve ? void 0 : -1
  }, be, {
    ref: ft,
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      be.onFocus,
      () => lt(!0)
    ),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      be.onBlur,
      () => lt(!1)
    ),
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(be.onPointerUp, ct),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(be.onPointerMove, (_r) => {
      if (ve) {
        var Kr;
        (Kr = Qe.onItemLeave) === null || Kr === void 0 || Kr.call(Qe);
      } else
        _r.currentTarget.focus({
          preventScroll: !0
        });
    }),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(be.onPointerLeave, (_r) => {
      if (_r.currentTarget === document.activeElement) {
        var Kr;
        (Kr = Qe.onItemLeave) === null || Kr === void 0 || Kr.call(Qe);
      }
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(be.onKeyDown, (_r) => {
      var Kr;
      ((Kr = Qe.searchRef) === null || Kr === void 0 ? void 0 : Kr.current) !== "" && _r.key === " " || ($cc7e05a45900e73f$var$SELECTION_KEYS.includes(_r.key) && ct(), _r.key === " " && _r.preventDefault());
    })
  }))));
}), $cc7e05a45900e73f$var$ITEM_TEXT_NAME = "SelectItemText", $cc7e05a45900e73f$export$3572fb0fb821ff49 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, className: ae, style: ve, ...ye } = ie, be = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, ee), Ye = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, ee), Qe = $cc7e05a45900e73f$var$useSelectItemContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, ee), Je = $cc7e05a45900e73f$var$useSelectNativeOptionsContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, ee), [nt, st] = reactExports.useState(null), ot = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    Z,
    (_r) => st(_r),
    Qe.onItemTextChange,
    (_r) => {
      var Kr;
      return (Kr = Ye.itemTextRefCallback) === null || Kr === void 0 ? void 0 : Kr.call(Ye, _r, Qe.value, Qe.disabled);
    }
  ), lt = nt == null ? void 0 : nt.textContent, ft = reactExports.useMemo(
    () => /* @__PURE__ */ reactExports.createElement("option", {
      key: Qe.value,
      value: Qe.value,
      disabled: Qe.disabled
    }, lt),
    [
      Qe.disabled,
      Qe.value,
      lt
    ]
  ), { onNativeOptionAdd: gt, onNativeOptionRemove: ct } = Je;
  return $9f79659886946c16$export$e5c5a5f917a5871c(() => (gt(ft), () => ct(ft)), [
    gt,
    ct,
    ft
  ]), /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({
    id: Qe.textId
  }, ye, {
    ref: ot
  })), Qe.isSelected && be.valueNode && !be.valueNodeHasChildren ? /* @__PURE__ */ reactDomExports.createPortal(ye.children, be.valueNode) : null);
}), $cc7e05a45900e73f$var$ITEM_INDICATOR_NAME = "SelectItemIndicator", $cc7e05a45900e73f$export$6b9198de19accfe6 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, ...ae } = ie;
  return $cc7e05a45900e73f$var$useSelectItemContext($cc7e05a45900e73f$var$ITEM_INDICATOR_NAME, ee).isSelected ? /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({
    "aria-hidden": !0
  }, ae, {
    ref: Z
  })) : null;
}), $cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton", $cc7e05a45900e73f$export$d8117927658af6d7 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const ee = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, ie.__scopeSelect), ae = $cc7e05a45900e73f$var$useSelectViewportContext($cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, ie.__scopeSelect), [ve, ye] = reactExports.useState(!1), be = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, ae.onScrollButtonChange);
  return $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (ee.viewport && ee.isPositioned) {
      let Qe = function() {
        const Je = Ye.scrollTop > 0;
        ye(Je);
      };
      const Ye = ee.viewport;
      return Qe(), Ye.addEventListener("scroll", Qe), () => Ye.removeEventListener("scroll", Qe);
    }
  }, [
    ee.viewport,
    ee.isPositioned
  ]), ve ? /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$SelectScrollButtonImpl, _extends$1({}, ie, {
    ref: be,
    onAutoScroll: () => {
      const { viewport: Ye, selectedItem: Qe } = ee;
      Ye && Qe && (Ye.scrollTop = Ye.scrollTop - Qe.offsetHeight);
    }
  })) : null;
}), $cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton", $cc7e05a45900e73f$export$ff951e476c12189 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const ee = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, ie.__scopeSelect), ae = $cc7e05a45900e73f$var$useSelectViewportContext($cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, ie.__scopeSelect), [ve, ye] = reactExports.useState(!1), be = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, ae.onScrollButtonChange);
  return $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (ee.viewport && ee.isPositioned) {
      let Qe = function() {
        const Je = Ye.scrollHeight - Ye.clientHeight, nt = Math.ceil(Ye.scrollTop) < Je;
        ye(nt);
      };
      const Ye = ee.viewport;
      return Qe(), Ye.addEventListener("scroll", Qe), () => Ye.removeEventListener("scroll", Qe);
    }
  }, [
    ee.viewport,
    ee.isPositioned
  ]), ve ? /* @__PURE__ */ reactExports.createElement($cc7e05a45900e73f$var$SelectScrollButtonImpl, _extends$1({}, ie, {
    ref: be,
    onAutoScroll: () => {
      const { viewport: Ye, selectedItem: Qe } = ee;
      Ye && Qe && (Ye.scrollTop = Ye.scrollTop + Qe.offsetHeight);
    }
  })) : null;
}), $cc7e05a45900e73f$var$SelectScrollButtonImpl = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSelect: ee, onAutoScroll: ae, ...ve } = ie, ye = $cc7e05a45900e73f$var$useSelectContentContext("SelectScrollButton", ee), be = reactExports.useRef(null), Ye = $cc7e05a45900e73f$var$useCollection(ee), Qe = reactExports.useCallback(() => {
    be.current !== null && (window.clearInterval(be.current), be.current = null);
  }, []);
  return reactExports.useEffect(() => () => Qe(), [
    Qe
  ]), $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    var Je;
    const nt = Ye().find(
      (st) => st.ref.current === document.activeElement
    );
    nt == null || (Je = nt.ref.current) === null || Je === void 0 || Je.scrollIntoView({
      block: "nearest"
    });
  }, [
    Ye
  ]), /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    "aria-hidden": !0
  }, ve, {
    ref: Z,
    style: {
      flexShrink: 0,
      ...ve.style
    },
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ve.onPointerDown, () => {
      be.current === null && (be.current = window.setInterval(ae, 50));
    }),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ve.onPointerMove, () => {
      var Je;
      (Je = ye.onItemLeave) === null || Je === void 0 || Je.call(ye), be.current === null && (be.current = window.setInterval(ae, 50));
    }),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ve.onPointerLeave, () => {
      Qe();
    })
  }));
});
function $cc7e05a45900e73f$var$shouldShowPlaceholder(ie) {
  return ie === "" || ie === void 0;
}
const $cc7e05a45900e73f$var$BubbleSelect = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { value: ee, ...ae } = ie, ve = reactExports.useRef(null), ye = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(Z, ve), be = $010c2913dbd2fe3d$export$5cae361ad82dce8b(ee);
  return reactExports.useEffect(() => {
    const Ye = ve.current, Qe = window.HTMLSelectElement.prototype, nt = Object.getOwnPropertyDescriptor(Qe, "value").set;
    if (be !== ee && nt) {
      const st = new Event("change", {
        bubbles: !0
      });
      nt.call(Ye, ee), Ye.dispatchEvent(st);
    }
  }, [
    be,
    ee
  ]), /* @__PURE__ */ reactExports.createElement($ea1ef594cf570d83$export$439d29a4e110a164, {
    asChild: !0
  }, /* @__PURE__ */ reactExports.createElement("select", _extends$1({}, ae, {
    ref: ye,
    defaultValue: ee
  })));
});
$cc7e05a45900e73f$var$BubbleSelect.displayName = "BubbleSelect";
function $cc7e05a45900e73f$var$useTypeaheadSearch(ie) {
  const Z = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(ie), ee = reactExports.useRef(""), ae = reactExports.useRef(0), ve = reactExports.useCallback((be) => {
    const Ye = ee.current + be;
    Z(Ye), function Qe(Je) {
      ee.current = Je, window.clearTimeout(ae.current), Je !== "" && (ae.current = window.setTimeout(
        () => Qe(""),
        1e3
      ));
    }(Ye);
  }, [
    Z
  ]), ye = reactExports.useCallback(() => {
    ee.current = "", window.clearTimeout(ae.current);
  }, []);
  return reactExports.useEffect(() => () => window.clearTimeout(ae.current), []), [
    ee,
    ve,
    ye
  ];
}
function $cc7e05a45900e73f$var$findNextItem(ie, Z, ee) {
  const ve = Z.length > 1 && Array.from(Z).every(
    (Je) => Je === Z[0]
  ) ? Z[0] : Z, ye = ee ? ie.indexOf(ee) : -1;
  let be = $cc7e05a45900e73f$var$wrapArray(ie, Math.max(ye, 0));
  ve.length === 1 && (be = be.filter(
    (Je) => Je !== ee
  ));
  const Qe = be.find(
    (Je) => Je.textValue.toLowerCase().startsWith(ve.toLowerCase())
  );
  return Qe !== ee ? Qe : void 0;
}
function $cc7e05a45900e73f$var$wrapArray(ie, Z) {
  return ie.map(
    (ee, ae) => ie[(Z + ae) % ie.length]
  );
}
const $cc7e05a45900e73f$export$be92b6f5f03c0fe9 = $cc7e05a45900e73f$export$ef9b1a59e592288f, $cc7e05a45900e73f$export$41fb9f06171c75f4 = $cc7e05a45900e73f$export$3ac1e88a1c0b9f1, $cc7e05a45900e73f$export$7c6e2c02157bb7d2 = $cc7e05a45900e73f$export$c973a4b3cb86a03d, $cc7e05a45900e73f$export$b04be29aa201d4f5 = $cc7e05a45900e73f$export$f67338d29bd972f8, $cc7e05a45900e73f$export$6d08773d2e66f8f2 = $cc7e05a45900e73f$export$13ef48a934230896;
var openseadragon = { exports: {} };
(function(module) {
  //! openseadragon 2.4.2
  //! Built on 2020-03-05
  //! Git commit: v2.4.2-0-c450749
  //! http://openseadragon.github.io
  //! License: http://openseadragon.github.io/license/
  function OpenSeadragon(ie) {
    return new OpenSeadragon.Viewer(ie);
  }
  (function(ie) {
    ie.version = {
      versionStr: "2.4.2",
      major: parseInt("2", 10),
      minor: parseInt("4", 10),
      revision: parseInt("2", 10)
    };
    var Z = {
      "[object Boolean]": "boolean",
      "[object Number]": "number",
      "[object String]": "string",
      "[object Function]": "function",
      "[object Array]": "array",
      "[object Date]": "date",
      "[object RegExp]": "regexp",
      "[object Object]": "object"
    }, ee = Object.prototype.toString, ae = Object.prototype.hasOwnProperty;
    ie.isFunction = function(ve) {
      return ie.type(ve) === "function";
    }, ie.isArray = Array.isArray || function(ve) {
      return ie.type(ve) === "array";
    }, ie.isWindow = function(ve) {
      return ve && typeof ve == "object" && "setInterval" in ve;
    }, ie.type = function(ve) {
      return ve == null ? String(ve) : Z[ee.call(ve)] || "object";
    }, ie.isPlainObject = function(ve) {
      if (!ve || OpenSeadragon.type(ve) !== "object" || ve.nodeType || ie.isWindow(ve) || ve.constructor && !ae.call(ve, "constructor") && !ae.call(ve.constructor.prototype, "isPrototypeOf"))
        return !1;
      var ye;
      for (var be in ve)
        ye = be;
      return ye === void 0 || ae.call(ve, ye);
    }, ie.isEmptyObject = function(ve) {
      for (var ye in ve)
        return !1;
      return !0;
    }, ie.freezeObject = function(ve) {
      return Object.freeze ? ie.freezeObject = Object.freeze : ie.freezeObject = function(ye) {
        return ye;
      }, ie.freezeObject(ve);
    }, ie.supportsCanvas = function() {
      var ve = document.createElement("canvas");
      return !!(ie.isFunction(ve.getContext) && ve.getContext("2d"));
    }(), ie.isCanvasTainted = function(ve) {
      var ye = !1;
      try {
        ve.getContext("2d").getImageData(0, 0, 1, 1);
      } catch {
        ye = !0;
      }
      return ye;
    }, ie.pixelDensityRatio = function() {
      if (ie.supportsCanvas) {
        var ve = document.createElement("canvas").getContext("2d"), ye = window.devicePixelRatio || 1, be = ve.webkitBackingStorePixelRatio || ve.mozBackingStorePixelRatio || ve.msBackingStorePixelRatio || ve.oBackingStorePixelRatio || ve.backingStorePixelRatio || 1;
        return Math.max(ye, 1) / be;
      } else
        return 1;
    }();
  })(OpenSeadragon), function($) {
    $.extend = function() {
      var ie, Z, ee, ae, ve, ye, be = arguments[0] || {}, Ye = arguments.length, Qe = !1, Je = 1;
      for (typeof be == "boolean" && (Qe = be, be = arguments[1] || {}, Je = 2), typeof be != "object" && !OpenSeadragon.isFunction(be) && (be = {}), Ye === Je && (be = this, --Je); Je < Ye; Je++)
        if (ie = arguments[Je], ie !== null || ie !== void 0)
          for (Z in ie)
            ee = be[Z], ae = ie[Z], be !== ae && (Qe && ae && (OpenSeadragon.isPlainObject(ae) || (ve = OpenSeadragon.isArray(ae))) ? (ve ? (ve = !1, ye = ee && OpenSeadragon.isArray(ee) ? ee : []) : ye = ee && OpenSeadragon.isPlainObject(ee) ? ee : {}, be[Z] = OpenSeadragon.extend(Qe, ye, ae)) : ae !== void 0 && (be[Z] = ae));
      return be;
    };
    var isIOSDevice = function() {
      if (typeof navigator != "object")
        return !1;
      var ie = navigator.userAgent;
      return typeof ie != "string" ? !1 : ie.indexOf("iPhone") !== -1 || ie.indexOf("iPad") !== -1 || ie.indexOf("iPod") !== -1;
    };
    $.extend(
      $,
      /** @lends OpenSeadragon */
      {
        /**
         * The default values for the optional settings documented at {@link OpenSeadragon.Options}.
         * @static
         * @type {Object}
         */
        DEFAULT_SETTINGS: {
          //DATA SOURCE DETAILS
          xmlPath: null,
          tileSources: null,
          tileHost: null,
          initialPage: 0,
          crossOriginPolicy: !1,
          ajaxWithCredentials: !1,
          loadTilesWithAjax: !1,
          ajaxHeaders: {},
          //PAN AND ZOOM SETTINGS AND CONSTRAINTS
          panHorizontal: !0,
          panVertical: !0,
          constrainDuringPan: !1,
          wrapHorizontal: !1,
          wrapVertical: !1,
          visibilityRatio: 0.5,
          //-> how much of the viewer can be negative space
          minPixelRatio: 0.5,
          //->closer to 0 draws tiles meant for a higher zoom at this zoom
          defaultZoomLevel: 0,
          minZoomLevel: null,
          maxZoomLevel: null,
          homeFillsViewer: !1,
          //UI RESPONSIVENESS AND FEEL
          clickTimeThreshold: 300,
          clickDistThreshold: 5,
          dblClickTimeThreshold: 300,
          dblClickDistThreshold: 20,
          springStiffness: 6.5,
          animationTime: 1.2,
          gestureSettingsMouse: {
            scrollToZoom: !0,
            clickToZoom: !0,
            dblClickToZoom: !1,
            pinchToZoom: !1,
            zoomToRefPoint: !0,
            flickEnabled: !1,
            flickMinSpeed: 120,
            flickMomentum: 0.25,
            pinchRotate: !1
          },
          gestureSettingsTouch: {
            scrollToZoom: !1,
            clickToZoom: !1,
            dblClickToZoom: !0,
            pinchToZoom: !0,
            zoomToRefPoint: !0,
            flickEnabled: !0,
            flickMinSpeed: 120,
            flickMomentum: 0.25,
            pinchRotate: !1
          },
          gestureSettingsPen: {
            scrollToZoom: !1,
            clickToZoom: !0,
            dblClickToZoom: !1,
            pinchToZoom: !1,
            zoomToRefPoint: !0,
            flickEnabled: !1,
            flickMinSpeed: 120,
            flickMomentum: 0.25,
            pinchRotate: !1
          },
          gestureSettingsUnknown: {
            scrollToZoom: !1,
            clickToZoom: !1,
            dblClickToZoom: !0,
            pinchToZoom: !0,
            zoomToRefPoint: !0,
            flickEnabled: !0,
            flickMinSpeed: 120,
            flickMomentum: 0.25,
            pinchRotate: !1
          },
          zoomPerClick: 2,
          zoomPerScroll: 1.2,
          zoomPerSecond: 1,
          blendTime: 0,
          alwaysBlend: !1,
          autoHideControls: !0,
          immediateRender: !1,
          minZoomImageRatio: 0.9,
          //-> closer to 0 allows zoom out to infinity
          maxZoomPixelRatio: 1.1,
          //-> higher allows 'over zoom' into pixels
          smoothTileEdgesMinZoom: 1.1,
          //-> higher than maxZoomPixelRatio disables it
          iOSDevice: isIOSDevice(),
          pixelsPerWheelLine: 40,
          pixelsPerArrowPress: 40,
          autoResize: !0,
          preserveImageSizeOnResize: !1,
          // requires autoResize=true
          minScrollDeltaTime: 50,
          rotationIncrement: 90,
          //DEFAULT CONTROL SETTINGS
          showSequenceControl: !0,
          //SEQUENCE
          sequenceControlAnchor: null,
          //SEQUENCE
          preserveViewport: !1,
          //SEQUENCE
          preserveOverlays: !1,
          //SEQUENCE
          navPrevNextWrap: !1,
          //SEQUENCE
          showNavigationControl: !0,
          //ZOOM/HOME/FULL/ROTATION
          navigationControlAnchor: null,
          //ZOOM/HOME/FULL/ROTATION
          showZoomControl: !0,
          //ZOOM
          showHomeControl: !0,
          //HOME
          showFullPageControl: !0,
          //FULL
          showRotationControl: !1,
          //ROTATION
          showFlipControl: !1,
          //FLIP
          controlsFadeDelay: 2e3,
          //ZOOM/HOME/FULL/SEQUENCE
          controlsFadeLength: 1500,
          //ZOOM/HOME/FULL/SEQUENCE
          mouseNavEnabled: !0,
          //GENERAL MOUSE INTERACTIVITY
          //VIEWPORT NAVIGATOR SETTINGS
          showNavigator: !1,
          navigatorId: null,
          navigatorPosition: null,
          navigatorSizeRatio: 0.2,
          navigatorMaintainSizeRatio: !1,
          navigatorTop: null,
          navigatorLeft: null,
          navigatorHeight: null,
          navigatorWidth: null,
          navigatorAutoResize: !0,
          navigatorAutoFade: !0,
          navigatorRotate: !0,
          navigatorBackground: "#000",
          navigatorOpacity: 0.8,
          navigatorBorderColor: "#555",
          navigatorDisplayRegionColor: "#900",
          // INITIAL ROTATION
          degrees: 0,
          // INITIAL FLIP STATE
          flipped: !1,
          // APPEARANCE
          opacity: 1,
          preload: !1,
          compositeOperation: null,
          imageSmoothingEnabled: !0,
          placeholderFillStyle: null,
          //REFERENCE STRIP SETTINGS
          showReferenceStrip: !1,
          referenceStripScroll: "horizontal",
          referenceStripElement: null,
          referenceStripHeight: null,
          referenceStripWidth: null,
          referenceStripPosition: "BOTTOM_LEFT",
          referenceStripSizeRatio: 0.2,
          //COLLECTION VISUALIZATION SETTINGS
          collectionRows: 3,
          //or columns depending on layout
          collectionColumns: 0,
          //columns in horizontal layout, rows in vertical layout
          collectionLayout: "horizontal",
          //vertical
          collectionMode: !1,
          collectionTileSize: 800,
          collectionTileMargin: 80,
          //PERFORMANCE SETTINGS
          imageLoaderLimit: 0,
          maxImageCacheCount: 200,
          timeout: 3e4,
          useCanvas: !0,
          // Use canvas element for drawing if available
          //INTERFACE RESOURCE SETTINGS
          prefixUrl: "/images/",
          navImages: {
            zoomIn: {
              REST: "zoomin_rest.png",
              GROUP: "zoomin_grouphover.png",
              HOVER: "zoomin_hover.png",
              DOWN: "zoomin_pressed.png"
            },
            zoomOut: {
              REST: "zoomout_rest.png",
              GROUP: "zoomout_grouphover.png",
              HOVER: "zoomout_hover.png",
              DOWN: "zoomout_pressed.png"
            },
            home: {
              REST: "home_rest.png",
              GROUP: "home_grouphover.png",
              HOVER: "home_hover.png",
              DOWN: "home_pressed.png"
            },
            fullpage: {
              REST: "fullpage_rest.png",
              GROUP: "fullpage_grouphover.png",
              HOVER: "fullpage_hover.png",
              DOWN: "fullpage_pressed.png"
            },
            rotateleft: {
              REST: "rotateleft_rest.png",
              GROUP: "rotateleft_grouphover.png",
              HOVER: "rotateleft_hover.png",
              DOWN: "rotateleft_pressed.png"
            },
            rotateright: {
              REST: "rotateright_rest.png",
              GROUP: "rotateright_grouphover.png",
              HOVER: "rotateright_hover.png",
              DOWN: "rotateright_pressed.png"
            },
            flip: {
              // Flip icon designed by Yaroslav Samoylov from the Noun Project and modified by Nelson Campos ncampos@criteriamarathon.com, https://thenounproject.com/term/flip/136289/
              REST: "flip_rest.png",
              GROUP: "flip_grouphover.png",
              HOVER: "flip_hover.png",
              DOWN: "flip_pressed.png"
            },
            previous: {
              REST: "previous_rest.png",
              GROUP: "previous_grouphover.png",
              HOVER: "previous_hover.png",
              DOWN: "previous_pressed.png"
            },
            next: {
              REST: "next_rest.png",
              GROUP: "next_grouphover.png",
              HOVER: "next_hover.png",
              DOWN: "next_pressed.png"
            }
          },
          //DEVELOPER SETTINGS
          debugMode: !1,
          debugGridColor: ["#437AB2", "#1B9E77", "#D95F02", "#7570B3", "#E7298A", "#66A61E", "#E6AB02", "#A6761D", "#666666"]
        },
        /**
         * TODO: get rid of this.  I can't see how it's required at all.  Looks
         *       like an early legacy code artifact.
         * @static
         * @ignore
         */
        SIGNAL: "----seadragon----",
        /**
         * Returns a function which invokes the method as if it were a method belonging to the object.
         * @function
         * @param {Object} object
         * @param {Function} method
         * @returns {Function}
         */
        delegate: function(ie, Z) {
          return function() {
            var ee = arguments;
            return ee === void 0 && (ee = []), Z.apply(ie, ee);
          };
        },
        /**
         * An enumeration of Browser vendors.
         * @static
         * @type {Object}
         * @property {Number} UNKNOWN
         * @property {Number} IE
         * @property {Number} FIREFOX
         * @property {Number} SAFARI
         * @property {Number} CHROME
         * @property {Number} OPERA
         */
        BROWSERS: {
          UNKNOWN: 0,
          IE: 1,
          FIREFOX: 2,
          SAFARI: 3,
          CHROME: 4,
          OPERA: 5
        },
        /**
         * Returns a DOM Element for the given id or element.
         * @function
         * @param {String|Element} element Accepts an id or element.
         * @returns {Element} The element with the given id, null, or the element itself.
         */
        getElement: function(ie) {
          return typeof ie == "string" && (ie = document.getElementById(ie)), ie;
        },
        /**
         * Determines the position of the upper-left corner of the element.
         * @function
         * @param {Element|String} element - the element we want the position for.
         * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element.
         */
        getElementPosition: function(ie) {
          var Z = new $.Point(), ee, ae;
          for (ie = $.getElement(ie), ee = $.getElementStyle(ie).position == "fixed", ae = getOffsetParent(ie, ee); ae; )
            Z.x += ie.offsetLeft, Z.y += ie.offsetTop, ee && (Z = Z.plus($.getPageScroll())), ie = ae, ee = $.getElementStyle(ie).position == "fixed", ae = getOffsetParent(ie, ee);
          return Z;
        },
        /**
         * Determines the position of the upper-left corner of the element adjusted for current page and/or element scroll.
         * @function
         * @param {Element|String} element - the element we want the position for.
         * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element adjusted for current page and/or element scroll.
         */
        getElementOffset: function(ie) {
          ie = $.getElement(ie);
          var Z = ie && ie.ownerDocument, ee, ae, ve = { top: 0, left: 0 };
          return Z ? (ee = Z.documentElement, typeof ie.getBoundingClientRect < "u" && (ve = ie.getBoundingClientRect()), ae = Z == Z.window ? Z : Z.nodeType === 9 ? Z.defaultView || Z.parentWindow : !1, new $.Point(
            ve.left + (ae.pageXOffset || ee.scrollLeft) - (ee.clientLeft || 0),
            ve.top + (ae.pageYOffset || ee.scrollTop) - (ee.clientTop || 0)
          )) : new $.Point();
        },
        /**
         * Determines the height and width of the given element.
         * @function
         * @param {Element|String} element
         * @returns {OpenSeadragon.Point}
         */
        getElementSize: function(ie) {
          return ie = $.getElement(ie), new $.Point(
            ie.clientWidth,
            ie.clientHeight
          );
        },
        /**
         * Returns the CSSStyle object for the given element.
         * @function
         * @param {Element|String} element
         * @returns {CSSStyle}
         */
        getElementStyle: document.documentElement.currentStyle ? function(ie) {
          return ie = $.getElement(ie), ie.currentStyle;
        } : function(ie) {
          return ie = $.getElement(ie), window.getComputedStyle(ie, "");
        },
        /**
         * Returns the property with the correct vendor prefix appended.
         * @param {String} property the property name
         * @returns {String} the property with the correct prefix or null if not
         * supported.
         */
        getCssPropertyWithVendorPrefix: function(ie) {
          var Z = {};
          return $.getCssPropertyWithVendorPrefix = function(ee) {
            if (Z[ee] !== void 0)
              return Z[ee];
            var ae = document.createElement("div").style, ve = null;
            if (ae[ee] !== void 0)
              ve = ee;
            else
              for (var ye = [
                "Webkit",
                "Moz",
                "MS",
                "O",
                "webkit",
                "moz",
                "ms",
                "o"
              ], be = $.capitalizeFirstLetter(ee), Ye = 0; Ye < ye.length; Ye++) {
                var Qe = ye[Ye] + be;
                if (ae[Qe] !== void 0) {
                  ve = Qe;
                  break;
                }
              }
            return Z[ee] = ve, ve;
          }, $.getCssPropertyWithVendorPrefix(ie);
        },
        /**
         * Capitalizes the first letter of a string
         * @param {String} string
         * @returns {String} The string with the first letter capitalized
         */
        capitalizeFirstLetter: function(ie) {
          return ie.charAt(0).toUpperCase() + ie.slice(1);
        },
        /**
         * Compute the modulo of a number but makes sure to always return
         * a positive value.
         * @param {Number} number the number to computes the modulo of
         * @param {Number} modulo the modulo
         * @returns {Number} the result of the modulo of number
         */
        positiveModulo: function(ie, Z) {
          var ee = ie % Z;
          return ee < 0 && (ee += Z), ee;
        },
        /**
         * Determines if a point is within the bounding rectangle of the given element (hit-test).
         * @function
         * @param {Element|String} element
         * @param {OpenSeadragon.Point} point
         * @returns {Boolean}
         */
        pointInElement: function(ie, Z) {
          ie = $.getElement(ie);
          var ee = $.getElementOffset(ie), ae = $.getElementSize(ie);
          return Z.x >= ee.x && Z.x < ee.x + ae.x && Z.y < ee.y + ae.y && Z.y >= ee.y;
        },
        /**
         * Gets the latest event, really only useful internally since its
         * specific to IE behavior.
         * @function
         * @param {Event} [event]
         * @returns {Event}
         * @deprecated For internal use only
         * @private
         */
        getEvent: function(ie) {
          return ie ? $.getEvent = function(Z) {
            return Z;
          } : $.getEvent = function() {
            return window.event;
          }, $.getEvent(ie);
        },
        /**
         * Gets the position of the mouse on the screen for a given event.
         * @function
         * @param {Event} [event]
         * @returns {OpenSeadragon.Point}
         */
        getMousePosition: function(ie) {
          if (typeof ie.pageX == "number")
            $.getMousePosition = function(Z) {
              var ee = new $.Point();
              return Z = $.getEvent(Z), ee.x = Z.pageX, ee.y = Z.pageY, ee;
            };
          else if (typeof ie.clientX == "number")
            $.getMousePosition = function(Z) {
              var ee = new $.Point();
              return Z = $.getEvent(Z), ee.x = Z.clientX + document.body.scrollLeft + document.documentElement.scrollLeft, ee.y = Z.clientY + document.body.scrollTop + document.documentElement.scrollTop, ee;
            };
          else
            throw new Error(
              "Unknown event mouse position, no known technique."
            );
          return $.getMousePosition(ie);
        },
        /**
         * Determines the page's current scroll position.
         * @function
         * @returns {OpenSeadragon.Point}
         */
        getPageScroll: function() {
          var ie = document.documentElement || {}, Z = document.body || {};
          if (typeof window.pageXOffset == "number")
            $.getPageScroll = function() {
              return new $.Point(
                window.pageXOffset,
                window.pageYOffset
              );
            };
          else if (Z.scrollLeft || Z.scrollTop)
            $.getPageScroll = function() {
              return new $.Point(
                document.body.scrollLeft,
                document.body.scrollTop
              );
            };
          else if (ie.scrollLeft || ie.scrollTop)
            $.getPageScroll = function() {
              return new $.Point(
                document.documentElement.scrollLeft,
                document.documentElement.scrollTop
              );
            };
          else
            return new $.Point(0, 0);
          return $.getPageScroll();
        },
        /**
         * Set the page scroll position.
         * @function
         * @returns {OpenSeadragon.Point}
         */
        setPageScroll: function(ie) {
          if (typeof window.scrollTo < "u")
            $.setPageScroll = function(ae) {
              window.scrollTo(ae.x, ae.y);
            };
          else {
            var Z = $.getPageScroll();
            if (Z.x === ie.x && Z.y === ie.y)
              return;
            document.body.scrollLeft = ie.x, document.body.scrollTop = ie.y;
            var ee = $.getPageScroll();
            if (ee.x !== Z.x && ee.y !== Z.y) {
              $.setPageScroll = function(ae) {
                document.body.scrollLeft = ae.x, document.body.scrollTop = ae.y;
              };
              return;
            }
            if (document.documentElement.scrollLeft = ie.x, document.documentElement.scrollTop = ie.y, ee = $.getPageScroll(), ee.x !== Z.x && ee.y !== Z.y) {
              $.setPageScroll = function(ae) {
                document.documentElement.scrollLeft = ae.x, document.documentElement.scrollTop = ae.y;
              };
              return;
            }
            $.setPageScroll = function(ae) {
            };
          }
          return $.setPageScroll(ie);
        },
        /**
         * Determines the size of the browsers window.
         * @function
         * @returns {OpenSeadragon.Point}
         */
        getWindowSize: function() {
          var ie = document.documentElement || {}, Z = document.body || {};
          if (typeof window.innerWidth == "number")
            $.getWindowSize = function() {
              return new $.Point(
                window.innerWidth,
                window.innerHeight
              );
            };
          else if (ie.clientWidth || ie.clientHeight)
            $.getWindowSize = function() {
              return new $.Point(
                document.documentElement.clientWidth,
                document.documentElement.clientHeight
              );
            };
          else if (Z.clientWidth || Z.clientHeight)
            $.getWindowSize = function() {
              return new $.Point(
                document.body.clientWidth,
                document.body.clientHeight
              );
            };
          else
            throw new Error("Unknown window size, no known technique.");
          return $.getWindowSize();
        },
        /**
         * Wraps the given element in a nest of divs so that the element can
         * be easily centered using CSS tables
         * @function
         * @param {Element|String} element
         * @returns {Element} outermost wrapper element
         */
        makeCenteredNode: function(ie) {
          ie = $.getElement(ie);
          var Z = [
            $.makeNeutralElement("div"),
            $.makeNeutralElement("div"),
            $.makeNeutralElement("div")
          ];
          return $.extend(Z[0].style, {
            display: "table",
            height: "100%",
            width: "100%"
          }), $.extend(Z[1].style, {
            display: "table-row"
          }), $.extend(Z[2].style, {
            display: "table-cell",
            verticalAlign: "middle",
            textAlign: "center"
          }), Z[0].appendChild(Z[1]), Z[1].appendChild(Z[2]), Z[2].appendChild(ie), Z[0];
        },
        /**
         * Creates an easily positionable element of the given type that therefor
         * serves as an excellent container element.
         * @function
         * @param {String} tagName
         * @returns {Element}
         */
        makeNeutralElement: function(ie) {
          var Z = document.createElement(ie), ee = Z.style;
          return ee.background = "transparent none", ee.border = "none", ee.margin = "0px", ee.padding = "0px", ee.position = "static", Z;
        },
        /**
         * Returns the current milliseconds, using Date.now() if available
         * @function
         */
        now: function() {
          return Date.now ? $.now = Date.now : $.now = function() {
            return (/* @__PURE__ */ new Date()).getTime();
          }, $.now();
        },
        /**
         * Ensures an image is loaded correctly to support alpha transparency.
         * Generally only IE has issues doing this correctly for formats like
         * png.
         * @function
         * @param {String} src
         * @returns {Element}
         */
        makeTransparentImage: function(ie) {
          return $.makeTransparentImage = function(Z) {
            var ee = $.makeNeutralElement("img");
            return ee.src = Z, ee;
          }, $.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 7 && ($.makeTransparentImage = function(Z) {
            var ee = $.makeNeutralElement("img"), ae = null;
            return ae = $.makeNeutralElement("span"), ae.style.display = "inline-block", ee.onload = function() {
              ae.style.width = ae.style.width || ee.width + "px", ae.style.height = ae.style.height || ee.height + "px", ee.onload = null, ee = null;
            }, ee.src = Z, ae.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + Z + "', sizingMethod='scale')", ae;
          }), $.makeTransparentImage(ie);
        },
        /**
         * Sets the opacity of the specified element.
         * @function
         * @param {Element|String} element
         * @param {Number} opacity
         * @param {Boolean} [usesAlpha]
         */
        setElementOpacity: function(ie, Z, ee) {
          var ae, ve;
          ie = $.getElement(ie), ee && !$.Browser.alpha && (Z = Math.round(Z)), $.Browser.opacity ? ie.style.opacity = Z < 1 ? Z : "" : Z < 1 ? (ae = Math.round(100 * Z), ve = "alpha(opacity=" + ae + ")", ie.style.filter = ve) : ie.style.filter = "";
        },
        /**
         * Sets the specified element's touch-action style attribute to 'none'.
         * @function
         * @param {Element|String} element
         */
        setElementTouchActionNone: function(ie) {
          ie = $.getElement(ie), typeof ie.style.touchAction < "u" ? ie.style.touchAction = "none" : typeof ie.style.msTouchAction < "u" && (ie.style.msTouchAction = "none");
        },
        /**
         * Add the specified CSS class to the element if not present.
         * @function
         * @param {Element|String} element
         * @param {String} className
         */
        addClass: function(ie, Z) {
          ie = $.getElement(ie), ie.className ? (" " + ie.className + " ").indexOf(" " + Z + " ") === -1 && (ie.className += " " + Z) : ie.className = Z;
        },
        /**
         * Find the first index at which an element is found in an array or -1
         * if not present.
         *
         * Code taken and adapted from
         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Compatibility
         *
         * @function
         * @param {Array} array The array from which to find the element
         * @param {Object} searchElement The element to find
         * @param {Number} [fromIndex=0] Index to start research.
         * @returns {Number} The index of the element in the array.
         */
        indexOf: function(ie, Z, ee) {
          return Array.prototype.indexOf ? this.indexOf = function(ae, ve, ye) {
            return ae.indexOf(ve, ye);
          } : this.indexOf = function(ae, ve, ye) {
            var be, Ye = ye || 0, Qe;
            if (!ae)
              throw new TypeError();
            if (Qe = ae.length, Qe === 0 || Ye >= Qe)
              return -1;
            for (Ye < 0 && (Ye = Qe - Math.abs(Ye)), be = Ye; be < Qe; be++)
              if (ae[be] === ve)
                return be;
            return -1;
          }, this.indexOf(ie, Z, ee);
        },
        /**
         * Remove the specified CSS class from the element.
         * @function
         * @param {Element|String} element
         * @param {String} className
         */
        removeClass: function(ie, Z) {
          var ee, ae = [], ve;
          for (ie = $.getElement(ie), ee = ie.className.split(/\s+/), ve = 0; ve < ee.length; ve++)
            ee[ve] && ee[ve] !== Z && ae.push(ee[ve]);
          ie.className = ae.join(" ");
        },
        /**
         * Adds an event listener for the given element, eventName and handler.
         * @function
         * @param {Element|String} element
         * @param {String} eventName
         * @param {Function} handler
         * @param {Boolean} [useCapture]
         */
        addEvent: function() {
          if (window.addEventListener)
            return function(ie, Z, ee, ae) {
              ie = $.getElement(ie), ie.addEventListener(Z, ee, ae);
            };
          if (window.attachEvent)
            return function(ie, Z, ee, ae) {
              ie = $.getElement(ie), ie.attachEvent("on" + Z, ee);
            };
          throw new Error("No known event model.");
        }(),
        /**
         * Remove a given event listener for the given element, event type and
         * handler.
         * @function
         * @param {Element|String} element
         * @param {String} eventName
         * @param {Function} handler
         * @param {Boolean} [useCapture]
         */
        removeEvent: function() {
          if (window.removeEventListener)
            return function(ie, Z, ee, ae) {
              ie = $.getElement(ie), ie.removeEventListener(Z, ee, ae);
            };
          if (window.detachEvent)
            return function(ie, Z, ee, ae) {
              ie = $.getElement(ie), ie.detachEvent("on" + Z, ee);
            };
          throw new Error("No known event model.");
        }(),
        /**
         * Cancels the default browser behavior had the event propagated all
         * the way up the DOM to the window object.
         * @function
         * @param {Event} [event]
         */
        cancelEvent: function(ie) {
          ie = $.getEvent(ie), ie.preventDefault ? $.cancelEvent = function(Z) {
            Z.preventDefault();
          } : $.cancelEvent = function(Z) {
            Z = $.getEvent(Z), Z.cancel = !0, Z.returnValue = !1;
          }, $.cancelEvent(ie);
        },
        /**
         * Stops the propagation of the event up the DOM.
         * @function
         * @param {Event} [event]
         */
        stopEvent: function(ie) {
          ie = $.getEvent(ie), ie.stopPropagation ? $.stopEvent = function(Z) {
            Z.stopPropagation();
          } : $.stopEvent = function(Z) {
            Z = $.getEvent(Z), Z.cancelBubble = !0;
          }, $.stopEvent(ie);
        },
        /**
         * Similar to OpenSeadragon.delegate, but it does not immediately call
         * the method on the object, returning a function which can be called
         * repeatedly to delegate the method. It also allows additional arguments
         * to be passed during construction which will be added during each
         * invocation, and each invocation can add additional arguments as well.
         *
         * @function
         * @param {Object} object
         * @param {Function} method
         * @param [args] any additional arguments are passed as arguments to the
         *  created callback
         * @returns {Function}
         */
        createCallback: function(ie, Z) {
          var ee = [], ae;
          for (ae = 2; ae < arguments.length; ae++)
            ee.push(arguments[ae]);
          return function() {
            var ve = ee.concat([]), ye;
            for (ye = 0; ye < arguments.length; ye++)
              ve.push(arguments[ye]);
            return Z.apply(ie, ve);
          };
        },
        /**
         * Retrieves the value of a url parameter from the window.location string.
         * @function
         * @param {String} key
         * @returns {String} The value of the url parameter or null if no param matches.
         */
        getUrlParameter: function(ie) {
          var Z = URLPARAMS[ie];
          return Z || null;
        },
        /**
         * Retrieves the protocol used by the url. The url can either be absolute
         * or relative.
         * @function
         * @private
         * @param {String} url The url to retrieve the protocol from.
         * @return {String} The protocol (http:, https:, file:, ftp: ...)
         */
        getUrlProtocol: function(ie) {
          var Z = ie.match(/^([a-z]+:)\/\//i);
          return Z === null ? window.location.protocol : Z[1].toLowerCase();
        },
        /**
         * Create an XHR object
         * @private
         * @param {type} [local] If set to true, the XHR will be file: protocol
         * compatible if possible (but may raise a warning in the browser).
         * @returns {XMLHttpRequest}
         */
        createAjaxRequest: function(ie) {
          var Z;
          try {
            Z = !!new ActiveXObject("Microsoft.XMLHTTP");
          } catch {
            Z = !1;
          }
          if (Z)
            window.XMLHttpRequest ? $.createAjaxRequest = function(ee) {
              return ee ? new ActiveXObject("Microsoft.XMLHTTP") : new XMLHttpRequest();
            } : $.createAjaxRequest = function() {
              return new ActiveXObject("Microsoft.XMLHTTP");
            };
          else if (window.XMLHttpRequest)
            $.createAjaxRequest = function() {
              return new XMLHttpRequest();
            };
          else
            throw new Error("Browser doesn't support XMLHttpRequest.");
          return $.createAjaxRequest(ie);
        },
        /**
         * Makes an AJAX request.
         * @param {Object} options
         * @param {String} options.url - the url to request
         * @param {Function} options.success - a function to call on a successful response
         * @param {Function} options.error - a function to call on when an error occurs
         * @param {Object} options.headers - headers to add to the AJAX request
         * @param {String} options.responseType - the response type of the the AJAX request
         * @param {Boolean} [options.withCredentials=false] - whether to set the XHR's withCredentials
         * @throws {Error}
         * @returns {XMLHttpRequest}
         */
        makeAjaxRequest: function(ie, Z, ee) {
          var ae, ve, ye;
          $.isPlainObject(ie) && (Z = ie.success, ee = ie.error, ae = ie.withCredentials, ve = ie.headers, ye = ie.responseType || null, ie = ie.url);
          var be = $.getUrlProtocol(ie), Ye = $.createAjaxRequest(be === "file:");
          if (!$.isFunction(Z))
            throw new Error("makeAjaxRequest requires a success callback");
          Ye.onreadystatechange = function() {
            Ye.readyState == 4 && (Ye.onreadystatechange = function() {
            }, Ye.status >= 200 && Ye.status < 300 || Ye.status === 0 && be !== "http:" && be !== "https:" ? Z(Ye) : ($.console.log("AJAX request returned %d: %s", Ye.status, ie), $.isFunction(ee) && ee(Ye)));
          };
          try {
            if (Ye.open("GET", ie, !0), ye && (Ye.responseType = ye), ve)
              for (var Qe in ve)
                Object.prototype.hasOwnProperty.call(ve, Qe) && ve[Qe] && Ye.setRequestHeader(Qe, ve[Qe]);
            ae && (Ye.withCredentials = !0), Ye.send(null);
          } catch (ot) {
            var Je = ot.message, nt = $.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 10;
            if (nt && typeof ot.number < "u" && ot.number == -2147024891 && (Je += `
See http://msdn.microsoft.com/en-us/library/ms537505(v=vs.85).aspx#xdomain`), $.console.log("%s while making AJAX request: %s", ot.name, Je), Ye.onreadystatechange = function() {
            }, window.XDomainRequest) {
              var st = new window.XDomainRequest();
              if (st) {
                st.onload = function(lt) {
                  $.isFunction(Z) && Z({
                    // Faking an xhr object
                    responseText: st.responseText,
                    status: 200,
                    // XDomainRequest doesn't support status codes, so we just fake one! :/
                    statusText: "OK"
                  });
                }, st.onerror = function(lt) {
                  $.isFunction(ee) && ee({
                    // Faking an xhr object
                    responseText: st.responseText,
                    status: 444,
                    // 444 No Response
                    statusText: "An error happened. Due to an XDomainRequest deficiency we can not extract any information about this error. Upgrade your browser."
                  });
                };
                try {
                  st.open("GET", ie), st.send();
                } catch {
                  $.isFunction(ee) && ee(Ye, ot);
                }
              }
            } else
              $.isFunction(ee) && ee(Ye, ot);
          }
          return Ye;
        },
        /**
         * Taken from jQuery 1.6.1
         * @function
         * @param {Object} options
         * @param {String} options.url
         * @param {Function} options.callback
         * @param {String} [options.param='callback'] The name of the url parameter
         *      to request the jsonp provider with.
         * @param {String} [options.callbackName=] The name of the callback to
         *      request the jsonp provider with.
         */
        jsonp: function(ie) {
          var Z, ee = ie.url, ae = document.head || document.getElementsByTagName("head")[0] || document.documentElement, ve = ie.callbackName || "openseadragon" + $.now(), ye = window[ve], be = "$1" + ve + "$2", Ye = ie.param || "callback", Qe = ie.callback;
          ee = ee.replace(/(\=)\?(&|$)|\?\?/i, be), ee += (/\?/.test(ee) ? "&" : "?") + Ye + "=" + ve, window[ve] = function(Je) {
            if (ye)
              window[ve] = ye;
            else
              try {
                delete window[ve];
              } catch {
              }
            Qe && $.isFunction(Qe) && Qe(Je);
          }, Z = document.createElement("script"), (ie.async !== void 0 || ie.async !== !1) && (Z.async = "async"), ie.scriptCharset && (Z.charset = ie.scriptCharset), Z.src = ee, Z.onload = Z.onreadystatechange = function(Je, nt) {
            (nt || !Z.readyState || /loaded|complete/.test(Z.readyState)) && (Z.onload = Z.onreadystatechange = null, ae && Z.parentNode && ae.removeChild(Z), Z = void 0);
          }, ae.insertBefore(Z, ae.firstChild);
        },
        /**
         * Fully deprecated. Will throw an error.
         * @function
         * @deprecated use {@link OpenSeadragon.Viewer#open}
         */
        createFromDZI: function() {
          throw "OpenSeadragon.createFromDZI is deprecated, use Viewer.open.";
        },
        /**
         * Parses an XML string into a DOM Document.
         * @function
         * @param {String} string
         * @returns {Document}
         */
        parseXml: function(ie) {
          if (window.DOMParser)
            $.parseXml = function(Z) {
              var ee = null, ae;
              return ae = new DOMParser(), ee = ae.parseFromString(Z, "text/xml"), ee;
            };
          else if (window.ActiveXObject)
            $.parseXml = function(Z) {
              var ee = null;
              return ee = new ActiveXObject("Microsoft.XMLDOM"), ee.async = !1, ee.loadXML(Z), ee;
            };
          else
            throw new Error("Browser doesn't support XML DOM.");
          return $.parseXml(ie);
        },
        /**
         * Parses a JSON string into a Javascript object.
         * @function
         * @param {String} string
         * @returns {Object}
         */
        parseJSON: function(string) {
          return window.JSON && window.JSON.parse ? $.parseJSON = window.JSON.parse : $.parseJSON = function(string) {
            return eval("(" + string + ")");
          }, $.parseJSON(string);
        },
        /**
         * Reports whether the image format is supported for tiling in this
         * version.
         * @function
         * @param {String} [extension]
         * @returns {Boolean}
         */
        imageFormatSupported: function(ie) {
          return ie = ie || "", !!FILEFORMATS[ie.toLowerCase()];
        }
      }
    );
    var nullfunction = function(ie) {
    };
    $.console = window.console || {
      log: nullfunction,
      debug: nullfunction,
      info: nullfunction,
      warn: nullfunction,
      error: nullfunction,
      assert: nullfunction
    }, $.Browser = {
      vendor: $.BROWSERS.UNKNOWN,
      version: 0,
      alpha: !0
    };
    var FILEFORMATS = {
      bmp: !1,
      jpeg: !0,
      jpg: !0,
      png: !0,
      tif: !1,
      wdp: !1
    }, URLPARAMS = {};
    (function() {
      var ie = navigator.appVersion, Z = navigator.userAgent, ee;
      switch (navigator.appName) {
        case "Microsoft Internet Explorer":
          window.attachEvent && window.ActiveXObject && ($.Browser.vendor = $.BROWSERS.IE, $.Browser.version = parseFloat(
            Z.substring(
              Z.indexOf("MSIE") + 5,
              Z.indexOf(";", Z.indexOf("MSIE"))
            )
          ));
          break;
        case "Netscape":
          window.addEventListener && (Z.indexOf("Firefox") >= 0 ? ($.Browser.vendor = $.BROWSERS.FIREFOX, $.Browser.version = parseFloat(
            Z.substring(Z.indexOf("Firefox") + 8)
          )) : Z.indexOf("Safari") >= 0 ? ($.Browser.vendor = Z.indexOf("Chrome") >= 0 ? $.BROWSERS.CHROME : $.BROWSERS.SAFARI, $.Browser.version = parseFloat(
            Z.substring(
              Z.substring(0, Z.indexOf("Safari")).lastIndexOf("/") + 1,
              Z.indexOf("Safari")
            )
          )) : (ee = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})"), ee.exec(Z) !== null && ($.Browser.vendor = $.BROWSERS.IE, $.Browser.version = parseFloat(RegExp.$1))));
          break;
        case "Opera":
          $.Browser.vendor = $.BROWSERS.OPERA, $.Browser.version = parseFloat(ie);
          break;
      }
      var ae = window.location.search.substring(1), ve = ae.split("&"), ye, be, Ye;
      for (Ye = 0; Ye < ve.length; Ye++)
        if (ye = ve[Ye], be = ye.indexOf("="), be > 0) {
          var Qe = ye.substring(0, be), Je = ye.substring(be + 1);
          try {
            URLPARAMS[Qe] = decodeURIComponent(Je);
          } catch {
            $.console.error("Ignoring malformed URL parameter: %s=%s", Qe, Je);
          }
        }
      $.Browser.alpha = !($.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 9 || $.Browser.vendor == $.BROWSERS.CHROME && $.Browser.version < 2), $.Browser.opacity = !($.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 9);
    })(), function(ie) {
      var Z = ie.requestAnimationFrame || ie.mozRequestAnimationFrame || ie.webkitRequestAnimationFrame || ie.msRequestAnimationFrame, ee = ie.cancelAnimationFrame || ie.mozCancelAnimationFrame || ie.webkitCancelAnimationFrame || ie.msCancelAnimationFrame;
      if (Z && ee)
        $.requestAnimationFrame = function() {
          return Z.apply(ie, arguments);
        }, $.cancelAnimationFrame = function() {
          return ee.apply(ie, arguments);
        };
      else {
        var ae = [], ve = [], ye = 0, be;
        $.requestAnimationFrame = function(Ye) {
          return ae.push([++ye, Ye]), be || (be = setInterval(function() {
            if (ae.length) {
              var Qe = $.now(), Je = ve;
              for (ve = ae, ae = Je; ve.length; )
                ve.shift()[1](Qe);
            } else
              clearInterval(be), be = void 0;
          }, 1e3 / 50)), ye;
        }, $.cancelAnimationFrame = function(Ye) {
          var Qe, Je;
          for (Qe = 0, Je = ae.length; Qe < Je; Qe += 1)
            if (ae[Qe][0] === Ye) {
              ae.splice(Qe, 1);
              return;
            }
          for (Qe = 0, Je = ve.length; Qe < Je; Qe += 1)
            if (ve[Qe][0] === Ye) {
              ve.splice(Qe, 1);
              return;
            }
        };
      }
    }(window);
    function getOffsetParent(ie, Z) {
      return Z && ie != document.body ? document.body : ie.offsetParent;
    }
  }(OpenSeadragon), function(ie, Z) {
    module.exports ? module.exports = Z() : ie.OpenSeadragon = Z();
  }(commonjsGlobal, function() {
    return OpenSeadragon;
  }), function(ie) {
    var Z = {
      supportsFullScreen: !1,
      isFullScreen: function() {
        return !1;
      },
      getFullScreenElement: function() {
        return null;
      },
      requestFullScreen: function() {
      },
      exitFullScreen: function() {
      },
      cancelFullScreen: function() {
      },
      fullScreenEventName: "",
      fullScreenErrorEventName: ""
    };
    document.exitFullscreen ? (Z.supportsFullScreen = !0, Z.getFullScreenElement = function() {
      return document.fullscreenElement;
    }, Z.requestFullScreen = function(ee) {
      return ee.requestFullscreen();
    }, Z.exitFullScreen = function() {
      document.exitFullscreen();
    }, Z.fullScreenEventName = "fullscreenchange", Z.fullScreenErrorEventName = "fullscreenerror") : document.msExitFullscreen ? (Z.supportsFullScreen = !0, Z.getFullScreenElement = function() {
      return document.msFullscreenElement;
    }, Z.requestFullScreen = function(ee) {
      return ee.msRequestFullscreen();
    }, Z.exitFullScreen = function() {
      document.msExitFullscreen();
    }, Z.fullScreenEventName = "MSFullscreenChange", Z.fullScreenErrorEventName = "MSFullscreenError") : document.webkitExitFullscreen ? (Z.supportsFullScreen = !0, Z.getFullScreenElement = function() {
      return document.webkitFullscreenElement;
    }, Z.requestFullScreen = function(ee) {
      return ee.webkitRequestFullscreen();
    }, Z.exitFullScreen = function() {
      document.webkitExitFullscreen();
    }, Z.fullScreenEventName = "webkitfullscreenchange", Z.fullScreenErrorEventName = "webkitfullscreenerror") : document.webkitCancelFullScreen ? (Z.supportsFullScreen = !0, Z.getFullScreenElement = function() {
      return document.webkitCurrentFullScreenElement;
    }, Z.requestFullScreen = function(ee) {
      return ee.webkitRequestFullScreen();
    }, Z.exitFullScreen = function() {
      document.webkitCancelFullScreen();
    }, Z.fullScreenEventName = "webkitfullscreenchange", Z.fullScreenErrorEventName = "webkitfullscreenerror") : document.mozCancelFullScreen && (Z.supportsFullScreen = !0, Z.getFullScreenElement = function() {
      return document.mozFullScreenElement;
    }, Z.requestFullScreen = function(ee) {
      return ee.mozRequestFullScreen();
    }, Z.exitFullScreen = function() {
      document.mozCancelFullScreen();
    }, Z.fullScreenEventName = "mozfullscreenchange", Z.fullScreenErrorEventName = "mozfullscreenerror"), Z.isFullScreen = function() {
      return Z.getFullScreenElement() !== null;
    }, Z.cancelFullScreen = function() {
      ie.console.error("cancelFullScreen is deprecated. Use exitFullScreen instead."), Z.exitFullScreen();
    }, ie.extend(ie, Z);
  }(OpenSeadragon), function(ie) {
    ie.EventSource = function() {
      this.events = {};
    }, ie.EventSource.prototype = {
      /**
       * Add an event handler to be triggered only once (or a given number of times)
       * for a given event.
       * @function
       * @param {String} eventName - Name of event to register.
       * @param {OpenSeadragon.EventHandler} handler - Function to call when event
       * is triggered.
       * @param {Object} [userData=null] - Arbitrary object to be passed unchanged
       * to the handler.
       * @param {Number} [times=1] - The number of times to handle the event
       * before removing it.
       */
      addOnceHandler: function(Z, ee, ae, ve) {
        var ye = this;
        ve = ve || 1;
        var be = 0, Ye = function(Qe) {
          be++, be === ve && ye.removeHandler(Z, Ye), ee(Qe);
        };
        this.addHandler(Z, Ye, ae);
      },
      /**
       * Add an event handler for a given event.
       * @function
       * @param {String} eventName - Name of event to register.
       * @param {OpenSeadragon.EventHandler} handler - Function to call when event is triggered.
       * @param {Object} [userData=null] - Arbitrary object to be passed unchanged to the handler.
       */
      addHandler: function(Z, ee, ae) {
        var ve = this.events[Z];
        ve || (this.events[Z] = ve = []), ee && ie.isFunction(ee) && (ve[ve.length] = { handler: ee, userData: ae || null });
      },
      /**
       * Remove a specific event handler for a given event.
       * @function
       * @param {String} eventName - Name of event for which the handler is to be removed.
       * @param {OpenSeadragon.EventHandler} handler - Function to be removed.
       */
      removeHandler: function(Z, ee) {
        var ae = this.events[Z], ve = [], ye;
        if (ae && ie.isArray(ae)) {
          for (ye = 0; ye < ae.length; ye++)
            ae[ye].handler !== ee && ve.push(ae[ye]);
          this.events[Z] = ve;
        }
      },
      /**
       * Remove all event handlers for a given event type. If no type is given all
       * event handlers for every event type are removed.
       * @function
       * @param {String} eventName - Name of event for which all handlers are to be removed.
       */
      removeAllHandlers: function(Z) {
        if (Z)
          this.events[Z] = [];
        else
          for (var ee in this.events)
            this.events[ee] = [];
      },
      /**
       * Get a function which iterates the list of all handlers registered for a given event, calling the handler for each.
       * @function
       * @param {String} eventName - Name of event to get handlers for.
       */
      getHandler: function(Z) {
        var ee = this.events[Z];
        return !ee || !ee.length ? null : (ee = ee.length === 1 ? [ee[0]] : Array.apply(null, ee), function(ae, ve) {
          var ye, be = ee.length;
          for (ye = 0; ye < be; ye++)
            ee[ye] && (ve.eventSource = ae, ve.userData = ee[ye].userData, ee[ye].handler(ve));
        });
      },
      /**
       * Trigger an event, optionally passing additional information.
       * @function
       * @param {String} eventName - Name of event to register.
       * @param {Object} eventArgs - Event-specific data.
       */
      raiseEvent: function(Z, ee) {
        var ae = this.getHandler(Z);
        ae && (ee || (ee = {}), ae(this, ee));
      }
    };
  }(OpenSeadragon), function(ie) {
    var Z = [], ee = {};
    ie.MouseTracker = function(ci) {
      Z.push(this);
      var li = arguments;
      ie.isPlainObject(ci) || (ci = {
        element: li[0],
        clickTimeThreshold: li[1],
        clickDistThreshold: li[2]
      }), this.hash = Math.random(), this.element = ie.getElement(ci.element), this.clickTimeThreshold = ci.clickTimeThreshold || ie.DEFAULT_SETTINGS.clickTimeThreshold, this.clickDistThreshold = ci.clickDistThreshold || ie.DEFAULT_SETTINGS.clickDistThreshold, this.dblClickTimeThreshold = ci.dblClickTimeThreshold || ie.DEFAULT_SETTINGS.dblClickTimeThreshold, this.dblClickDistThreshold = ci.dblClickDistThreshold || ie.DEFAULT_SETTINGS.dblClickDistThreshold, this.userData = ci.userData || null, this.stopDelay = ci.stopDelay || 50, this.enterHandler = ci.enterHandler || null, this.exitHandler = ci.exitHandler || null, this.pressHandler = ci.pressHandler || null, this.nonPrimaryPressHandler = ci.nonPrimaryPressHandler || null, this.releaseHandler = ci.releaseHandler || null, this.nonPrimaryReleaseHandler = ci.nonPrimaryReleaseHandler || null, this.moveHandler = ci.moveHandler || null, this.scrollHandler = ci.scrollHandler || null, this.clickHandler = ci.clickHandler || null, this.dblClickHandler = ci.dblClickHandler || null, this.dragHandler = ci.dragHandler || null, this.dragEndHandler = ci.dragEndHandler || null, this.pinchHandler = ci.pinchHandler || null, this.stopHandler = ci.stopHandler || null, this.keyDownHandler = ci.keyDownHandler || null, this.keyUpHandler = ci.keyUpHandler || null, this.keyHandler = ci.keyHandler || null, this.focusHandler = ci.focusHandler || null, this.blurHandler = ci.blurHandler || null;
      var Ci = this;
      ee[this.hash] = {
        click: function(Li) {
          ft(Ci, Li);
        },
        dblclick: function(Li) {
          gt(Ci, Li);
        },
        keydown: function(Li) {
          ct(Ci, Li);
        },
        keyup: function(Li) {
          _r(Ci, Li);
        },
        keypress: function(Li) {
          Kr(Ci, Li);
        },
        focus: function(Li) {
          Xr(Ci, Li);
        },
        blur: function(Li) {
          Jr(Ci, Li);
        },
        wheel: function(Li) {
          ei(Ci, Li);
        },
        mousewheel: function(Li) {
          si(Ci, Li);
        },
        DOMMouseScroll: function(Li) {
          si(Ci, Li);
        },
        MozMousePixelScroll: function(Li) {
          si(Ci, Li);
        },
        mouseenter: function(Li) {
          yi(Ci, Li);
        },
        // Used on IE8 only
        mouseleave: function(Li) {
          xi(Ci, Li);
        },
        // Used on IE8 only
        mouseover: function(Li) {
          pi(Ci, Li);
        },
        mouseout: function(Li) {
          Ti(Ci, Li);
        },
        mousedown: function(Li) {
          Si(Ci, Li);
        },
        mouseup: function(Li) {
          gi(Ci, Li);
        },
        mouseupcaptured: function(Li) {
          _i(Ci, Li);
        },
        mousemove: function(Li) {
          hi(Ci, Li);
        },
        mousemovecaptured: function(Li) {
          Di(Ci, Li);
        },
        touchstart: function(Li) {
          Hi(Ci, Li);
        },
        touchend: function(Li) {
          qi(Ci, Li);
        },
        touchendcaptured: function(Li) {
          us(Ci, Li);
        },
        touchmove: function(Li) {
          is(Ci, Li);
        },
        touchmovecaptured: function(Li) {
          Ss(Ci, Li);
        },
        touchcancel: function(Li) {
          Vs(Ci, Li);
        },
        gesturestart: function(Li) {
          Ws(Ci, Li);
        },
        gesturechange: function(Li) {
          ii(Ci, Li);
        },
        pointerover: function(Li) {
          bi(Ci, Li);
        },
        MSPointerOver: function(Li) {
          bi(Ci, Li);
        },
        pointerout: function(Li) {
          Gi(Ci, Li);
        },
        MSPointerOut: function(Li) {
          Gi(Ci, Li);
        },
        pointerdown: function(Li) {
          Qi(Ci, Li);
        },
        MSPointerDown: function(Li) {
          Qi(Ci, Li);
        },
        pointerup: function(Li) {
          ns(Ci, Li);
        },
        MSPointerUp: function(Li) {
          ns(Ci, Li);
        },
        pointermove: function(Li) {
          Ks(Ci, Li);
        },
        MSPointerMove: function(Li) {
          Ks(Ci, Li);
        },
        pointercancel: function(Li) {
          Ts(Ci, Li);
        },
        MSPointerCancel: function(Li) {
          Ts(Ci, Li);
        },
        pointerupcaptured: function(Li) {
          Bs(Ci, Li);
        },
        pointermovecaptured: function(Li) {
          Js(Ci, Li);
        },
        tracking: !1,
        // Active pointers lists. Array of GesturePointList objects, one for each pointer device type.
        // GesturePointList objects are added each time a pointer is tracked by a new pointer device type (see getActivePointersListByType()).
        // Active pointers are any pointer being tracked for this element which are in the hit-test area
        //     of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
        activePointersLists: [],
        // Tracking for double-click gesture
        lastClickPos: null,
        dblClickTimeOut: null,
        // Tracking for pinch gesture
        pinchGPoints: [],
        lastPinchDist: 0,
        currentPinchDist: 0,
        lastPinchCenter: null,
        currentPinchCenter: null
      }, ci.startDisabled || this.setTracking(!0);
    }, ie.MouseTracker.prototype = {
      /**
       * Clean up any events or objects created by the tracker.
       * @function
       */
      destroy: function() {
        var ci;
        for (ye(this), this.element = null, ci = 0; ci < Z.length; ci++)
          if (Z[ci] === this) {
            Z.splice(ci, 1);
            break;
          }
        ee[this.hash] = null, delete ee[this.hash];
      },
      /**
       * Are we currently tracking events on this element.
       * @deprecated Just use this.tracking
       * @function
       * @returns {Boolean} Are we currently tracking events on this element.
       */
      isTracking: function() {
        return ee[this.hash].tracking;
      },
      /**
       * Enable or disable whether or not we are tracking events on this element.
       * @function
       * @param {Boolean} track True to start tracking, false to stop tracking.
       * @returns {OpenSeadragon.MouseTracker} Chainable.
       */
      setTracking: function(ci) {
        return ci ? ve(this) : ye(this), this;
      },
      /**
       * Returns the {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} for all but the given pointer device type.
       * @function
       * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
       * @returns {Array.<OpenSeadragon.MouseTracker.GesturePointList>}
       */
      getActivePointersListsExceptType: function(ci) {
        for (var li = ee[this.hash], Ci = [], Li = 0; Li < li.activePointersLists.length; ++Li)
          li.activePointersLists[Li].type !== ci && Ci.push(li.activePointersLists[Li]);
        return Ci;
      },
      /**
       * Returns the {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} for the given pointer device type,
       * creating and caching a new {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} if one doesn't already exist for the type.
       * @function
       * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
       * @returns {OpenSeadragon.MouseTracker.GesturePointList}
       */
      getActivePointersListByType: function(ci) {
        var li = ee[this.hash], Ci, Li = li.activePointersLists.length, es;
        for (Ci = 0; Ci < Li; Ci++)
          if (li.activePointersLists[Ci].type === ci)
            return li.activePointersLists[Ci];
        return es = new ie.MouseTracker.GesturePointList(ci), li.activePointersLists.push(es), es;
      },
      /**
       * Returns the total number of pointers currently active on the tracked element.
       * @function
       * @returns {Number}
       */
      getActivePointerCount: function() {
        var ci = ee[this.hash], li, Ci = ci.activePointersLists.length, Li = 0;
        for (li = 0; li < Ci; li++)
          Li += ci.activePointersLists[li].getLength();
        return Li;
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.buttons
       *      Current buttons pressed.
       *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
       * @param {Number} event.pointers
       *      Number of pointers (all types) active in the tracked element.
       * @param {Boolean} event.insideElementPressed
       *      True if the left mouse button is currently being pressed and was
       *      initiated inside the tracked element, otherwise false.
       * @param {Boolean} event.buttonDownAny
       *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      enterHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.buttons
       *      Current buttons pressed.
       *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
       * @param {Number} event.pointers
       *      Number of pointers (all types) active in the tracked element.
       * @param {Boolean} event.insideElementPressed
       *      True if the left mouse button is currently being pressed and was
       *      initiated inside the tracked element, otherwise false.
       * @param {Boolean} event.buttonDownAny
       *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      exitHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.buttons
       *      Current buttons pressed.
       *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      pressHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.button
       *      Button which caused the event.
       *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
       * @param {Number} event.buttons
       *      Current buttons pressed.
       *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      nonPrimaryPressHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.buttons
       *      Current buttons pressed.
       *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
       * @param {Boolean} event.insideElementPressed
       *      True if the left mouse button is currently being pressed and was
       *      initiated inside the tracked element, otherwise false.
       * @param {Boolean} event.insideElementReleased
       *      True if the cursor inside the tracked element when the button was released.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      releaseHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.button
       *      Button which caused the event.
       *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
       * @param {Number} event.buttons
       *      Current buttons pressed.
       *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      nonPrimaryReleaseHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.buttons
       *      Current buttons pressed.
       *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      moveHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.scroll
       *      The scroll delta for the event.
       * @param {Boolean} event.shift
       *      True if the shift key was pressed during this event.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead. Touch devices no longer generate scroll event.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      scrollHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Boolean} event.quick
       *      True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for ignoring drag events.
       * @param {Boolean} event.shift
       *      True if the shift key was pressed during this event.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      clickHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Boolean} event.shift
       *      True if the shift key was pressed during this event.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      dblClickHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.buttons
       *      Current buttons pressed.
       *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
       * @param {OpenSeadragon.Point} event.delta
       *      The x,y components of the difference between the current position and the last drag event position.  Useful for ignoring or weighting the events.
       * @param {Number} event.speed
       *     Current computed speed, in pixels per second.
       * @param {Number} event.direction
       *     Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
       * @param {Boolean} event.shift
       *      True if the shift key was pressed during this event.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      dragHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.speed
       *     Speed at the end of a drag gesture, in pixels per second.
       * @param {Number} event.direction
       *     Direction at the end of a drag gesture, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
       * @param {Boolean} event.shift
       *      True if the shift key was pressed during this event.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      dragEndHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} event.gesturePoints
       *      Gesture points associated with the gesture. Velocity data can be found here.
       * @param {OpenSeadragon.Point} event.lastCenter
       *      The previous center point of the two pinch contact points relative to the tracked element.
       * @param {OpenSeadragon.Point} event.center
       *      The center point of the two pinch contact points relative to the tracked element.
       * @param {Number} event.lastDistance
       *      The previous distance between the two pinch contact points in CSS pixels.
       * @param {Number} event.distance
       *      The distance between the two pinch contact points in CSS pixels.
       * @param {Boolean} event.shift
       *      True if the shift key was pressed during this event.
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      pinchHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {String} event.pointerType
       *     "mouse", "touch", "pen", etc.
       * @param {OpenSeadragon.Point} event.position
       *      The position of the event relative to the tracked element.
       * @param {Number} event.buttons
       *      Current buttons pressed.
       *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
       * @param {Boolean} event.isTouchEvent
       *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      stopHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {Number} event.keyCode
       *      The key code that was pressed.
       * @param {Boolean} event.ctrl
       *      True if the ctrl key was pressed during this event.
       * @param {Boolean} event.shift
       *      True if the shift key was pressed during this event.
       * @param {Boolean} event.alt
       *      True if the alt key was pressed during this event.
       * @param {Boolean} event.meta
       *      True if the meta key was pressed during this event.
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      keyDownHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {Number} event.keyCode
       *      The key code that was pressed.
       * @param {Boolean} event.ctrl
       *      True if the ctrl key was pressed during this event.
       * @param {Boolean} event.shift
       *      True if the shift key was pressed during this event.
       * @param {Boolean} event.alt
       *      True if the alt key was pressed during this event.
       * @param {Boolean} event.meta
       *      True if the meta key was pressed during this event.
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      keyUpHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {Number} event.keyCode
       *      The key code that was pressed.
       * @param {Boolean} event.ctrl
       *      True if the ctrl key was pressed during this event.
       * @param {Boolean} event.shift
       *      True if the shift key was pressed during this event.
       * @param {Boolean} event.alt
       *      True if the alt key was pressed during this event.
       * @param {Boolean} event.meta
       *      True if the meta key was pressed during this event.
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      keyHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      focusHandler: function() {
      },
      /**
       * Implement or assign implementation to these handlers during or after
       * calling the constructor.
       * @function
       * @param {Object} event
       * @param {OpenSeadragon.MouseTracker} event.eventSource
       *      A reference to the tracker instance.
       * @param {Object} event.originalEvent
       *      The original event object.
       * @param {Boolean} event.preventDefaultAction
       *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
       * @param {Object} event.userData
       *      Arbitrary user-defined object.
       */
      blurHandler: function() {
      }
    }, ie.MouseTracker.resetAllMouseTrackers = function() {
      for (var ci = 0; ci < Z.length; ci++)
        Z[ci].isTracking() && (Z[ci].setTracking(!1), Z[ci].setTracking(!0));
    }, ie.MouseTracker.gesturePointVelocityTracker = /* @__PURE__ */ function() {
      var ci = [], li = 0, Ci = 0, Li = function(ss, Hs) {
        return ss.hash.toString() + Hs.type + Hs.id.toString();
      }, es = function() {
        var ss, Hs = ci.length, eo, Us, To = ie.now(), Ms, da, qo;
        for (Ms = To - Ci, Ci = To, ss = 0; ss < Hs; ss++)
          eo = ci[ss], Us = eo.gPoint, Us.direction = Math.atan2(Us.currentPos.y - eo.lastPos.y, Us.currentPos.x - eo.lastPos.x), da = eo.lastPos.distanceTo(Us.currentPos), eo.lastPos = Us.currentPos, qo = 1e3 * da / (Ms + 1), Us.speed = 0.75 * qo + 0.25 * Us.speed;
      }, Es = function(ss, Hs) {
        var eo = Li(ss, Hs);
        ci.push(
          {
            guid: eo,
            gPoint: Hs,
            lastPos: Hs.currentPos
          }
        ), ci.length === 1 && (Ci = ie.now(), li = window.setInterval(es, 50));
      }, ls = function(ss, Hs) {
        var eo = Li(ss, Hs), Us, To = ci.length;
        for (Us = 0; Us < To; Us++)
          if (ci[Us].guid === eo) {
            ci.splice(Us, 1), To--, To === 0 && window.clearInterval(li);
            break;
          }
      };
      return {
        addPoint: Es,
        removePoint: ls
      };
    }(), ie.MouseTracker.captureElement = document, ie.MouseTracker.wheelEventName = ie.Browser.vendor == ie.BROWSERS.IE && ie.Browser.version > 8 || "onwheel" in document.createElement("div") ? "wheel" : (
      // Modern browsers support 'wheel'
      document.onmousewheel !== void 0 ? "mousewheel" : (
        // Webkit and IE support at least 'mousewheel'
        "DOMMouseScroll"
      )
    ), ie.MouseTracker.supportsMouseCapture = function() {
      var ci = document.createElement("div");
      return ie.isFunction(ci.setCapture) && ie.isFunction(ci.releaseCapture);
    }(), ie.MouseTracker.subscribeEvents = ["click", "dblclick", "keydown", "keyup", "keypress", "focus", "blur", ie.MouseTracker.wheelEventName], ie.MouseTracker.wheelEventName == "DOMMouseScroll" && ie.MouseTracker.subscribeEvents.push("MozMousePixelScroll"), window.PointerEvent && (window.navigator.pointerEnabled || ie.Browser.vendor !== ie.BROWSERS.IE) ? (ie.MouseTracker.havePointerEvents = !0, ie.MouseTracker.subscribeEvents.push("pointerover", "pointerout", "pointerdown", "pointerup", "pointermove", "pointercancel"), ie.MouseTracker.unprefixedPointerEvents = !0, navigator.maxTouchPoints ? ie.MouseTracker.maxTouchPoints = navigator.maxTouchPoints : ie.MouseTracker.maxTouchPoints = 0, ie.MouseTracker.haveMouseEnter = !1) : window.MSPointerEvent && window.navigator.msPointerEnabled ? (ie.MouseTracker.havePointerEvents = !0, ie.MouseTracker.subscribeEvents.push("MSPointerOver", "MSPointerOut", "MSPointerDown", "MSPointerUp", "MSPointerMove", "MSPointerCancel"), ie.MouseTracker.unprefixedPointerEvents = !1, navigator.msMaxTouchPoints ? ie.MouseTracker.maxTouchPoints = navigator.msMaxTouchPoints : ie.MouseTracker.maxTouchPoints = 0, ie.MouseTracker.haveMouseEnter = !1) : (ie.MouseTracker.havePointerEvents = !1, ie.Browser.vendor === ie.BROWSERS.IE && ie.Browser.version < 9 ? (ie.MouseTracker.subscribeEvents.push("mouseenter", "mouseleave"), ie.MouseTracker.haveMouseEnter = !0) : (ie.MouseTracker.subscribeEvents.push("mouseover", "mouseout"), ie.MouseTracker.haveMouseEnter = !1), ie.MouseTracker.subscribeEvents.push("mousedown", "mouseup", "mousemove"), "ontouchstart" in window && ie.MouseTracker.subscribeEvents.push("touchstart", "touchend", "touchmove", "touchcancel"), "ongesturestart" in window && ie.MouseTracker.subscribeEvents.push("gesturestart", "gesturechange"), ie.MouseTracker.mousePointerId = "legacy-mouse", ie.MouseTracker.maxTouchPoints = 10), ie.MouseTracker.GesturePointList = function(ci) {
      this._gPoints = [], this.type = ci, this.buttons = 0, this.contacts = 0, this.clicks = 0, this.captureCount = 0;
    }, ie.MouseTracker.GesturePointList.prototype = {
      /**
       * @function
       * @returns {Number} Number of gesture points in the list.
       */
      getLength: function() {
        return this._gPoints.length;
      },
      /**
       * @function
       * @returns {Array.<OpenSeadragon.MouseTracker.GesturePoint>} The list of gesture points in the list as an array (read-only).
       */
      asArray: function() {
        return this._gPoints;
      },
      /**
       * @function
       * @param {OpenSeadragon.MouseTracker.GesturePoint} gesturePoint - A gesture point to add to the list.
       * @returns {Number} Number of gesture points in the list.
       */
      add: function(ci) {
        return this._gPoints.push(ci);
      },
      /**
       * @function
       * @param {Number} id - The id of the gesture point to remove from the list.
       * @returns {Number} Number of gesture points in the list.
       */
      removeById: function(ci) {
        var li, Ci = this._gPoints.length;
        for (li = 0; li < Ci; li++)
          if (this._gPoints[li].id === ci) {
            this._gPoints.splice(li, 1);
            break;
          }
        return this._gPoints.length;
      },
      /**
       * @function
       * @param {Number} index - The index of the gesture point to retrieve from the list.
       * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point at the given index, or null if not found.
       */
      getByIndex: function(ci) {
        return ci < this._gPoints.length ? this._gPoints[ci] : null;
      },
      /**
       * @function
       * @param {Number} id - The id of the gesture point to retrieve from the list.
       * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point with the given id, or null if not found.
       */
      getById: function(ci) {
        var li, Ci = this._gPoints.length;
        for (li = 0; li < Ci; li++)
          if (this._gPoints[li].id === ci)
            return this._gPoints[li];
        return null;
      },
      /**
       * @function
       * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The primary gesture point in the list, or null if not found.
       */
      getPrimary: function(ci) {
        var li, Ci = this._gPoints.length;
        for (li = 0; li < Ci; li++)
          if (this._gPoints[li].isPrimary)
            return this._gPoints[li];
        return null;
      },
      /**
       * Increment this pointer's contact count.
       * It will evaluate whether this pointer type is allowed to have multiple contacts.
       * @function
       */
      addContact: function() {
        ++this.contacts, this.contacts > 1 && (this.type === "mouse" || this.type === "pen") && (this.contacts = 1);
      },
      /**
       * Decrement this pointer's contact count.
       * It will make sure the count does not go below 0.
       * @function
       */
      removeContact: function() {
        --this.contacts, this.contacts < 0 && (this.contacts = 0);
      }
    };
    function ae(ci) {
      var li = ee[ci.hash], Ci, Li = li.activePointersLists.length;
      for (Ci = 0; Ci < Li; Ci++)
        li.activePointersLists[Ci].captureCount > 0 && (ie.removeEvent(
          ie.MouseTracker.captureElement,
          "mousemove",
          li.mousemovecaptured,
          !0
        ), ie.removeEvent(
          ie.MouseTracker.captureElement,
          "mouseup",
          li.mouseupcaptured,
          !0
        ), ie.removeEvent(
          ie.MouseTracker.captureElement,
          ie.MouseTracker.unprefixedPointerEvents ? "pointermove" : "MSPointerMove",
          li.pointermovecaptured,
          !0
        ), ie.removeEvent(
          ie.MouseTracker.captureElement,
          ie.MouseTracker.unprefixedPointerEvents ? "pointerup" : "MSPointerUp",
          li.pointerupcaptured,
          !0
        ), ie.removeEvent(
          ie.MouseTracker.captureElement,
          "touchmove",
          li.touchmovecaptured,
          !0
        ), ie.removeEvent(
          ie.MouseTracker.captureElement,
          "touchend",
          li.touchendcaptured,
          !0
        ), li.activePointersLists[Ci].captureCount = 0);
      for (Ci = 0; Ci < Li; Ci++)
        li.activePointersLists.pop();
    }
    function ve(ci) {
      var li = ee[ci.hash], Ci, Li;
      if (!li.tracking) {
        for (Li = 0; Li < ie.MouseTracker.subscribeEvents.length; Li++)
          Ci = ie.MouseTracker.subscribeEvents[Li], ie.addEvent(
            ci.element,
            Ci,
            li[Ci],
            !1
          );
        ae(ci), li.tracking = !0;
      }
    }
    function ye(ci) {
      var li = ee[ci.hash], Ci, Li;
      if (li.tracking) {
        for (Li = 0; Li < ie.MouseTracker.subscribeEvents.length; Li++)
          Ci = ie.MouseTracker.subscribeEvents[Li], ie.removeEvent(
            ci.element,
            Ci,
            li[Ci],
            !1
          );
        ae(ci), li.tracking = !1;
      }
    }
    function be(ci, li) {
      var Ci = ee[ci.hash];
      if (li === "pointerevent")
        return {
          upName: ie.MouseTracker.unprefixedPointerEvents ? "pointerup" : "MSPointerUp",
          upHandler: Ci.pointerupcaptured,
          moveName: ie.MouseTracker.unprefixedPointerEvents ? "pointermove" : "MSPointerMove",
          moveHandler: Ci.pointermovecaptured
        };
      if (li === "mouse")
        return {
          upName: "mouseup",
          upHandler: Ci.mouseupcaptured,
          moveName: "mousemove",
          moveHandler: Ci.mousemovecaptured
        };
      if (li === "touch")
        return {
          upName: "touchend",
          upHandler: Ci.touchendcaptured,
          moveName: "touchmove",
          moveHandler: Ci.touchmovecaptured
        };
      throw new Error("MouseTracker.getCaptureEventParams: Unknown pointer type.");
    }
    function Ye(ci, li, Ci) {
      var Li = ci.getActivePointersListByType(li), es;
      Li.captureCount += Ci || 1, Li.captureCount === 1 && (ie.Browser.vendor === ie.BROWSERS.IE && ie.Browser.version < 9 ? ci.element.setCapture(!0) : (es = be(ci, ie.MouseTracker.havePointerEvents ? "pointerevent" : li), ho && Ao(window.top) && ie.addEvent(
        window.top,
        es.upName,
        es.upHandler,
        !0
      ), ie.addEvent(
        ie.MouseTracker.captureElement,
        es.upName,
        es.upHandler,
        !0
      ), ie.addEvent(
        ie.MouseTracker.captureElement,
        es.moveName,
        es.moveHandler,
        !0
      )));
    }
    function Qe(ci, li, Ci) {
      var Li = ci.getActivePointersListByType(li), es;
      Li.captureCount -= Ci || 1, Li.captureCount === 0 && (ie.Browser.vendor === ie.BROWSERS.IE && ie.Browser.version < 9 ? ci.element.releaseCapture() : (es = be(ci, ie.MouseTracker.havePointerEvents ? "pointerevent" : li), ho && Ao(window.top) && ie.removeEvent(
        window.top,
        es.upName,
        es.upHandler,
        !0
      ), ie.removeEvent(
        ie.MouseTracker.captureElement,
        es.moveName,
        es.moveHandler,
        !0
      ), ie.removeEvent(
        ie.MouseTracker.captureElement,
        es.upName,
        es.upHandler,
        !0
      )));
    }
    function Je(ci) {
      var li;
      if (ie.MouseTracker.unprefixedPointerEvents)
        li = ci.pointerType;
      else
        switch (ci.pointerType) {
          case 2:
            li = "touch";
            break;
          case 3:
            li = "pen";
            break;
          case 4:
            li = "mouse";
            break;
          default:
            li = "";
        }
      return li;
    }
    function nt(ci) {
      return ie.getMousePosition(ci);
    }
    function st(ci, li) {
      return ot(nt(ci), li);
    }
    function ot(ci, li) {
      var Ci = ie.getElementOffset(li);
      return ci.minus(Ci);
    }
    function lt(ci, li) {
      return new ie.Point((ci.x + li.x) / 2, (ci.y + li.y) / 2);
    }
    function ft(ci, li) {
      ci.clickHandler && ie.cancelEvent(li);
    }
    function gt(ci, li) {
      ci.dblClickHandler && ie.cancelEvent(li);
    }
    function ct(ci, li) {
      var Ci;
      ci.keyDownHandler && (li = ie.getEvent(li), Ci = ci.keyDownHandler(
        {
          eventSource: ci,
          keyCode: li.keyCode ? li.keyCode : li.charCode,
          ctrl: li.ctrlKey,
          shift: li.shiftKey,
          alt: li.altKey,
          meta: li.metaKey,
          originalEvent: li,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), Ci || ie.cancelEvent(li));
    }
    function _r(ci, li) {
      var Ci;
      ci.keyUpHandler && (li = ie.getEvent(li), Ci = ci.keyUpHandler(
        {
          eventSource: ci,
          keyCode: li.keyCode ? li.keyCode : li.charCode,
          ctrl: li.ctrlKey,
          shift: li.shiftKey,
          alt: li.altKey,
          meta: li.metaKey,
          originalEvent: li,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), Ci || ie.cancelEvent(li));
    }
    function Kr(ci, li) {
      var Ci;
      ci.keyHandler && (li = ie.getEvent(li), Ci = ci.keyHandler(
        {
          eventSource: ci,
          keyCode: li.keyCode ? li.keyCode : li.charCode,
          ctrl: li.ctrlKey,
          shift: li.shiftKey,
          alt: li.altKey,
          meta: li.metaKey,
          originalEvent: li,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), Ci || ie.cancelEvent(li));
    }
    function Xr(ci, li) {
      var Ci;
      ci.focusHandler && (li = ie.getEvent(li), Ci = ci.focusHandler(
        {
          eventSource: ci,
          originalEvent: li,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), Ci === !1 && ie.cancelEvent(li));
    }
    function Jr(ci, li) {
      var Ci;
      ci.blurHandler && (li = ie.getEvent(li), Ci = ci.blurHandler(
        {
          eventSource: ci,
          originalEvent: li,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), Ci === !1 && ie.cancelEvent(li));
    }
    function ei(ci, li) {
      ri(ci, li, li);
    }
    function si(ci, li) {
      li = ie.getEvent(li);
      var Ci = {
        target: li.target || li.srcElement,
        type: "wheel",
        shiftKey: li.shiftKey || !1,
        clientX: li.clientX,
        clientY: li.clientY,
        pageX: li.pageX ? li.pageX : li.clientX,
        pageY: li.pageY ? li.pageY : li.clientY,
        deltaMode: li.type == "MozMousePixelScroll" ? 0 : 1,
        // 0=pixel, 1=line, 2=page
        deltaX: 0,
        deltaZ: 0
      };
      ie.MouseTracker.wheelEventName == "mousewheel" ? Ci.deltaY = -li.wheelDelta / ie.DEFAULT_SETTINGS.pixelsPerWheelLine : Ci.deltaY = li.detail, ri(ci, Ci, li);
    }
    function ri(ci, li, Ci) {
      var Li = 0, es;
      Li = li.deltaY < 0 ? 1 : -1, ci.scrollHandler && (es = ci.scrollHandler(
        {
          eventSource: ci,
          pointerType: "mouse",
          position: st(li, ci.element),
          scroll: Li,
          shift: li.shiftKey,
          isTouchEvent: !1,
          originalEvent: Ci,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), es === !1 && ie.cancelEvent(Ci));
    }
    function ai(ci, li) {
      if (ci === li)
        return !1;
      for (; li && li !== ci; )
        li = li.parentNode;
      return li === ci;
    }
    function yi(ci, li) {
      li = ie.getEvent(li), di(ci, li);
    }
    function pi(ci, li) {
      li = ie.getEvent(li), !(li.currentTarget === li.relatedTarget || ai(li.currentTarget, li.relatedTarget)) && di(ci, li);
    }
    function di(ci, li) {
      var Ci = {
        id: ie.MouseTracker.mousePointerId,
        type: "mouse",
        isPrimary: !0,
        currentPos: nt(li),
        currentTime: ie.now()
      };
      xo(ci, li, [Ci]);
    }
    function xi(ci, li) {
      li = ie.getEvent(li), Ai(ci, li);
    }
    function Ti(ci, li) {
      li = ie.getEvent(li), !(li.currentTarget === li.relatedTarget || ai(li.currentTarget, li.relatedTarget)) && Ai(ci, li);
    }
    function Ai(ci, li) {
      var Ci = {
        id: ie.MouseTracker.mousePointerId,
        type: "mouse",
        isPrimary: !0,
        currentPos: nt(li),
        currentTime: ie.now()
      };
      mo(ci, li, [Ci]);
    }
    function mi(ci) {
      return ie.Browser.vendor === ie.BROWSERS.IE && ie.Browser.version < 9 ? ci === 1 ? 0 : ci === 2 ? 2 : ci === 4 ? 1 : -1 : ci;
    }
    function Si(ci, li) {
      var Ci;
      li = ie.getEvent(li), Ci = {
        id: ie.MouseTracker.mousePointerId,
        type: "mouse",
        isPrimary: !0,
        currentPos: nt(li),
        currentTime: ie.now()
      }, Wo(ci, li, [Ci], mi(li.button)) && (ie.stopEvent(li), Ye(ci, "mouse")), (ci.clickHandler || ci.dblClickHandler || ci.pressHandler || ci.dragHandler || ci.dragEndHandler) && ie.cancelEvent(li);
    }
    function gi(ci, li) {
      Oi(ci, li);
    }
    function _i(ci, li) {
      Oi(ci, li), ie.stopEvent(li);
    }
    function Oi(ci, li) {
      var Ci;
      li = ie.getEvent(li), Ci = {
        id: ie.MouseTracker.mousePointerId,
        type: "mouse",
        isPrimary: !0,
        currentPos: nt(li),
        currentTime: ie.now()
      }, Ta(ci, li, [Ci], mi(li.button)) && Qe(ci, "mouse");
    }
    function hi(ci, li) {
      Ri(ci, li);
    }
    function Di(ci, li) {
      Ri(ci, li), ie.stopEvent(li);
    }
    function Ri(ci, li) {
      var Ci;
      li = ie.getEvent(li), Ci = {
        id: ie.MouseTracker.mousePointerId,
        type: "mouse",
        isPrimary: !0,
        currentPos: nt(li),
        currentTime: ie.now()
      }, Aa(ci, li, [Ci]);
    }
    function rs(ci, li, Ci) {
      var Li, es = Ci.getLength(), Es = [];
      if (Ci.type === "touch" || Ci.contacts > 0) {
        for (Li = 0; Li < es; Li++)
          Es.push(Ci.getByIndex(Li));
        Es.length > 0 && (Ta(ci, li, Es, 0), Ci.captureCount = 1, Qe(ci, Ci.type), mo(ci, li, Es));
      }
    }
    function Hi(ci, li) {
      var Ci, Li, es, Es = li.changedTouches.length, ls = [], ss, Hs = ci.getActivePointersListByType("touch");
      for (Ci = ie.now(), Hs.getLength() > li.touches.length - Es && (ie.console.warn("Tracked touch contact count doesn't match event.touches.length. Removing all tracked touch pointers."), rs(ci, li, Hs)), Li = 0; Li < Es; Li++)
        ls.push({
          id: li.changedTouches[Li].identifier,
          type: "touch",
          // isPrimary not set - let the updatePointers functions determine it
          currentPos: nt(li.changedTouches[Li]),
          currentTime: Ci
        });
      for (xo(ci, li, ls), Li = 0; Li < Z.length; Li++)
        if (Z[Li] !== ci && Z[Li].isTracking() && ai(Z[Li].element, ci.element)) {
          for (ss = [], es = 0; es < Es; es++)
            ss.push({
              id: li.changedTouches[es].identifier,
              type: "touch",
              // isPrimary not set - let the updatePointers functions determine it
              currentPos: nt(li.changedTouches[es]),
              currentTime: Ci
            });
          xo(Z[Li], li, ss);
        }
      Wo(ci, li, ls, 0) && (ie.stopEvent(li), Ye(ci, "touch", Es)), ie.cancelEvent(li);
    }
    function qi(ci, li) {
      Yi(ci, li);
    }
    function us(ci, li) {
      Yi(ci, li), ie.stopEvent(li);
    }
    function Yi(ci, li) {
      var Ci, Li, es, Es = li.changedTouches.length, ls = [], ss;
      for (Ci = ie.now(), Li = 0; Li < Es; Li++)
        ls.push({
          id: li.changedTouches[Li].identifier,
          type: "touch",
          // isPrimary not set - let the updatePointers functions determine it
          currentPos: nt(li.changedTouches[Li]),
          currentTime: Ci
        });
      for (Ta(ci, li, ls, 0) && Qe(ci, "touch", Es), mo(ci, li, ls), Li = 0; Li < Z.length; Li++)
        if (Z[Li] !== ci && Z[Li].isTracking() && ai(Z[Li].element, ci.element)) {
          for (ss = [], es = 0; es < Es; es++)
            ss.push({
              id: li.changedTouches[es].identifier,
              type: "touch",
              // isPrimary not set - let the updatePointers functions determine it
              currentPos: nt(li.changedTouches[es]),
              currentTime: Ci
            });
          mo(Z[Li], li, ss);
        }
      ie.cancelEvent(li);
    }
    function is(ci, li) {
      Gs(ci, li);
    }
    function Ss(ci, li) {
      Gs(ci, li), ie.stopEvent(li);
    }
    function Gs(ci, li) {
      var Ci, Li = li.changedTouches.length, es = [];
      for (Ci = 0; Ci < Li; Ci++)
        es.push({
          id: li.changedTouches[Ci].identifier,
          type: "touch",
          // isPrimary not set - let the updatePointers functions determine it
          currentPos: nt(li.changedTouches[Ci]),
          currentTime: ie.now()
        });
      Aa(ci, li, es), ie.cancelEvent(li);
    }
    function Vs(ci, li) {
      var Ci = ci.getActivePointersListByType("touch");
      rs(ci, li, Ci);
    }
    function Ws(ci, li) {
      return li.stopPropagation(), li.preventDefault(), !1;
    }
    function ii(ci, li) {
      return li.stopPropagation(), li.preventDefault(), !1;
    }
    function bi(ci, li) {
      var Ci;
      li.currentTarget === li.relatedTarget || ai(li.currentTarget, li.relatedTarget) || (Ci = {
        id: li.pointerId,
        type: Je(li),
        isPrimary: li.isPrimary,
        currentPos: nt(li),
        currentTime: ie.now()
      }, xo(ci, li, [Ci]));
    }
    function Gi(ci, li) {
      var Ci;
      li.currentTarget === li.relatedTarget || ai(li.currentTarget, li.relatedTarget) || (Ci = {
        id: li.pointerId,
        type: Je(li),
        isPrimary: li.isPrimary,
        currentPos: nt(li),
        currentTime: ie.now()
      }, mo(ci, li, [Ci]));
    }
    function Qi(ci, li) {
      var Ci;
      Ci = {
        id: li.pointerId,
        type: Je(li),
        isPrimary: li.isPrimary,
        currentPos: nt(li),
        currentTime: ie.now()
      }, Wo(ci, li, [Ci], li.button) && (ie.stopEvent(li), Ye(ci, Ci.type)), (ci.clickHandler || ci.dblClickHandler || ci.pressHandler || ci.dragHandler || ci.dragEndHandler || ci.pinchHandler) && ie.cancelEvent(li);
    }
    function ns(ci, li) {
      ms(ci, li);
    }
    function Bs(ci, li) {
      var Ci = ci.getActivePointersListByType(Je(li));
      Ci.getById(li.pointerId) && ms(ci, li), ie.stopEvent(li);
    }
    function ms(ci, li) {
      var Ci;
      Ci = {
        id: li.pointerId,
        type: Je(li),
        isPrimary: li.isPrimary,
        currentPos: nt(li),
        currentTime: ie.now()
      }, Ta(ci, li, [Ci], li.button) && Qe(ci, Ci.type);
    }
    function Ks(ci, li) {
      Ns(ci, li);
    }
    function Js(ci, li) {
      var Ci = ci.getActivePointersListByType(Je(li));
      Ci.getById(li.pointerId) && Ns(ci, li), ie.stopEvent(li);
    }
    function Ns(ci, li) {
      var Ci;
      Ci = {
        id: li.pointerId,
        type: Je(li),
        isPrimary: li.isPrimary,
        currentPos: nt(li),
        currentTime: ie.now()
      }, Aa(ci, li, [Ci]);
    }
    function Ts(ci, li) {
      var Ci;
      Ci = {
        id: li.pointerId,
        type: Je(li)
      }, hs(ci, li, [Ci]);
    }
    function lo(ci, li) {
      return Object.prototype.hasOwnProperty.call(li, "isPrimary") || (ci.getLength() === 0 ? li.isPrimary = !0 : li.isPrimary = !1), li.speed = 0, li.direction = 0, li.contactPos = li.currentPos, li.contactTime = li.currentTime, li.lastPos = li.currentPos, li.lastTime = li.currentTime, ci.add(li);
    }
    function Fs(ci, li) {
      var Ci, Li;
      return ci.getById(li.id) ? (Ci = ci.removeById(li.id), Object.prototype.hasOwnProperty.call(li, "isPrimary") || (Li = ci.getPrimary(), Li || (Li = ci.getByIndex(0), Li && (Li.isPrimary = !0)))) : Ci = ci.getLength(), Ci;
    }
    function xo(ci, li, Ci) {
      var Li = ci.getActivePointersListByType(Ci[0].type), es, Es = Ci.length, ls, ss, Hs;
      for (es = 0; es < Es; es++)
        ls = Ci[es], ss = Li.getById(ls.id), ss ? (ss.insideElement = !0, ss.lastPos = ss.currentPos, ss.lastTime = ss.currentTime, ss.currentPos = ls.currentPos, ss.currentTime = ls.currentTime, ls = ss) : (ls.captured = !1, ls.insideElementPressed = !1, ls.insideElement = !0, lo(Li, ls)), ci.enterHandler && (Hs = ci.enterHandler(
          {
            eventSource: ci,
            pointerType: ls.type,
            position: ot(ls.currentPos, ci.element),
            buttons: Li.buttons,
            pointers: ci.getActivePointerCount(),
            insideElementPressed: ls.insideElementPressed,
            buttonDownAny: Li.buttons !== 0,
            isTouchEvent: ls.type === "touch",
            originalEvent: li,
            preventDefaultAction: !1,
            userData: ci.userData
          }
        ), Hs === !1 && ie.cancelEvent(li));
    }
    function mo(ci, li, Ci) {
      var Li = ci.getActivePointersListByType(Ci[0].type), es, Es = Ci.length, ls, ss, Hs;
      for (es = 0; es < Es; es++)
        ls = Ci[es], ss = Li.getById(ls.id), ss && (ss.captured ? (ss.insideElement = !1, ss.lastPos = ss.currentPos, ss.lastTime = ss.currentTime, ss.currentPos = ls.currentPos, ss.currentTime = ls.currentTime) : Fs(Li, ss), ls = ss), ci.exitHandler && (Hs = ci.exitHandler(
          {
            eventSource: ci,
            pointerType: ls.type,
            position: ls.currentPos && ot(ls.currentPos, ci.element),
            buttons: Li.buttons,
            pointers: ci.getActivePointerCount(),
            insideElementPressed: ss ? ss.insideElementPressed : !1,
            buttonDownAny: Li.buttons !== 0,
            isTouchEvent: ls.type === "touch",
            originalEvent: li,
            preventDefaultAction: !1,
            userData: ci.userData
          }
        ), Hs === !1 && ie.cancelEvent(li));
    }
    function Wo(ci, li, Ci, Li) {
      var es = ee[ci.hash], Es, ls = ci.getActivePointersListByType(Ci[0].type), ss, Hs = Ci.length, eo, Us;
      typeof li.buttons < "u" ? ls.buttons = li.buttons : ie.Browser.vendor === ie.BROWSERS.IE && ie.Browser.version < 9 ? Li === 0 ? ls.buttons += 1 : Li === 1 ? ls.buttons += 4 : Li === 2 ? ls.buttons += 2 : Li === 3 ? ls.buttons += 8 : Li === 4 ? ls.buttons += 16 : Li === 5 && (ls.buttons += 32) : Li === 0 ? ls.buttons |= 1 : Li === 1 ? ls.buttons |= 4 : Li === 2 ? ls.buttons |= 2 : Li === 3 ? ls.buttons |= 8 : Li === 4 ? ls.buttons |= 16 : Li === 5 && (ls.buttons |= 32);
      var To = ci.getActivePointersListsExceptType(Ci[0].type);
      for (ss = 0; ss < To.length; ss++)
        rs(ci, li, To[ss]);
      if (Li !== 0)
        return ci.nonPrimaryPressHandler && (Es = ci.nonPrimaryPressHandler(
          {
            eventSource: ci,
            pointerType: Ci[0].type,
            position: ot(Ci[0].currentPos, ci.element),
            button: Li,
            buttons: ls.buttons,
            isTouchEvent: Ci[0].type === "touch",
            originalEvent: li,
            preventDefaultAction: !1,
            userData: ci.userData
          }
        ), Es === !1 && ie.cancelEvent(li)), !1;
      for (ss = 0; ss < Hs; ss++)
        eo = Ci[ss], Us = ls.getById(eo.id), Us ? (Us.captured = !0, Us.insideElementPressed = !0, Us.insideElement = !0, Us.contactPos = eo.currentPos, Us.contactTime = eo.currentTime, Us.lastPos = Us.currentPos, Us.lastTime = Us.currentTime, Us.currentPos = eo.currentPos, Us.currentTime = eo.currentTime, eo = Us) : (eo.captured = !0, eo.insideElementPressed = !0, eo.insideElement = !0, lo(ls, eo)), ls.addContact(), (ci.dragHandler || ci.dragEndHandler || ci.pinchHandler) && ie.MouseTracker.gesturePointVelocityTracker.addPoint(ci, eo), ls.contacts === 1 ? ci.pressHandler && (Es = ci.pressHandler(
          {
            eventSource: ci,
            pointerType: eo.type,
            position: ot(eo.contactPos, ci.element),
            buttons: ls.buttons,
            isTouchEvent: eo.type === "touch",
            originalEvent: li,
            preventDefaultAction: !1,
            userData: ci.userData
          }
        ), Es === !1 && ie.cancelEvent(li)) : ls.contacts === 2 && ci.pinchHandler && eo.type === "touch" && (es.pinchGPoints = ls.asArray(), es.lastPinchDist = es.currentPinchDist = es.pinchGPoints[0].currentPos.distanceTo(es.pinchGPoints[1].currentPos), es.lastPinchCenter = es.currentPinchCenter = lt(es.pinchGPoints[0].currentPos, es.pinchGPoints[1].currentPos));
      return !0;
    }
    function Ta(ci, li, Ci, Li) {
      var es = ee[ci.hash], Es = ci.getActivePointersListByType(Ci[0].type), ls, ss, Hs, eo, Us = Ci.length, To, Ms, da = !1, qo = !1, ba;
      if (typeof li.buttons < "u" ? Es.buttons = li.buttons : ie.Browser.vendor === ie.BROWSERS.IE && ie.Browser.version < 9 ? Li === 0 ? Es.buttons -= 1 : Li === 1 ? Es.buttons -= 4 : Li === 2 ? Es.buttons -= 2 : Li === 3 ? Es.buttons -= 8 : Li === 4 ? Es.buttons -= 16 : Li === 5 && (Es.buttons -= 32) : Li === 0 ? Es.buttons ^= -2 : Li === 1 ? Es.buttons ^= -5 : Li === 2 ? Es.buttons ^= -3 : Li === 3 ? Es.buttons ^= -9 : Li === 4 ? Es.buttons ^= -17 : Li === 5 && (Es.buttons ^= -33), Li !== 0) {
        ci.nonPrimaryReleaseHandler && (ls = ci.nonPrimaryReleaseHandler(
          {
            eventSource: ci,
            pointerType: Ci[0].type,
            position: ot(Ci[0].currentPos, ci.element),
            button: Li,
            buttons: Es.buttons,
            isTouchEvent: Ci[0].type === "touch",
            originalEvent: li,
            preventDefaultAction: !1,
            userData: ci.userData
          }
        ), ls === !1 && ie.cancelEvent(li));
        var ll = ci.getActivePointersListByType("mouse");
        return rs(ci, li, ll), !1;
      }
      if (typeof Ci[0].currentPos > "u")
        return rs(ci, li, Es), !1;
      for (eo = 0; eo < Us; eo++)
        To = Ci[eo], Ms = Es.getById(To.id), Ms && (Ms.captured && (Ms.captured = !1, da = !0, qo = !0), Ms.lastPos = Ms.currentPos, Ms.lastTime = Ms.currentTime, Ms.currentPos = To.currentPos, Ms.currentTime = To.currentTime, Ms.insideElement || Fs(Es, Ms), ss = Ms.currentPos, Hs = Ms.currentTime, qo ? (Es.removeContact(), (ci.dragHandler || ci.dragEndHandler || ci.pinchHandler) && ie.MouseTracker.gesturePointVelocityTracker.removePoint(ci, Ms), Es.contacts === 0 ? (ci.releaseHandler && (ls = ci.releaseHandler(
          {
            eventSource: ci,
            pointerType: Ms.type,
            position: ot(ss, ci.element),
            buttons: Es.buttons,
            insideElementPressed: Ms.insideElementPressed,
            insideElementReleased: Ms.insideElement,
            isTouchEvent: Ms.type === "touch",
            originalEvent: li,
            preventDefaultAction: !1,
            userData: ci.userData
          }
        ), ls === !1 && ie.cancelEvent(li)), ci.dragEndHandler && !Ms.currentPos.equals(Ms.contactPos) && (ls = ci.dragEndHandler(
          {
            eventSource: ci,
            pointerType: Ms.type,
            position: ot(Ms.currentPos, ci.element),
            speed: Ms.speed,
            direction: Ms.direction,
            shift: li.shiftKey,
            isTouchEvent: Ms.type === "touch",
            originalEvent: li,
            preventDefaultAction: !1,
            userData: ci.userData
          }
        ), ls === !1 && ie.cancelEvent(li)), (ci.clickHandler || ci.dblClickHandler) && Ms.insideElement && (ba = Hs - Ms.contactTime <= ci.clickTimeThreshold && Ms.contactPos.distanceTo(ss) <= ci.clickDistThreshold, ci.clickHandler && (ls = ci.clickHandler(
          {
            eventSource: ci,
            pointerType: Ms.type,
            position: ot(Ms.currentPos, ci.element),
            quick: ba,
            shift: li.shiftKey,
            isTouchEvent: Ms.type === "touch",
            originalEvent: li,
            preventDefaultAction: !1,
            userData: ci.userData
          }
        ), ls === !1 && ie.cancelEvent(li)), ci.dblClickHandler && ba && (Es.clicks++, Es.clicks === 1 ? (es.lastClickPos = ss, es.dblClickTimeOut = setTimeout(function() {
          Es.clicks = 0;
        }, ci.dblClickTimeThreshold)) : Es.clicks === 2 && (clearTimeout(es.dblClickTimeOut), Es.clicks = 0, es.lastClickPos.distanceTo(ss) <= ci.dblClickDistThreshold && (ls = ci.dblClickHandler(
          {
            eventSource: ci,
            pointerType: Ms.type,
            position: ot(Ms.currentPos, ci.element),
            shift: li.shiftKey,
            isTouchEvent: Ms.type === "touch",
            originalEvent: li,
            preventDefaultAction: !1,
            userData: ci.userData
          }
        ), ls === !1 && ie.cancelEvent(li)), es.lastClickPos = null)))) : Es.contacts === 2 && ci.pinchHandler && Ms.type === "touch" && (es.pinchGPoints = Es.asArray(), es.lastPinchDist = es.currentPinchDist = es.pinchGPoints[0].currentPos.distanceTo(es.pinchGPoints[1].currentPos), es.lastPinchCenter = es.currentPinchCenter = lt(es.pinchGPoints[0].currentPos, es.pinchGPoints[1].currentPos))) : ci.releaseHandler && (ls = ci.releaseHandler(
          {
            eventSource: ci,
            pointerType: Ms.type,
            position: ot(ss, ci.element),
            buttons: Es.buttons,
            insideElementPressed: Ms.insideElementPressed,
            insideElementReleased: Ms.insideElement,
            isTouchEvent: Ms.type === "touch",
            originalEvent: li,
            preventDefaultAction: !1,
            userData: ci.userData
          }
        ), ls === !1 && ie.cancelEvent(li)));
      return da;
    }
    function Aa(ci, li, Ci) {
      var Li = ee[ci.hash], es = ci.getActivePointersListByType(Ci[0].type), Es, ls = Ci.length, ss, Hs, eo, Us, To;
      for (typeof li.buttons < "u" && (es.buttons = li.buttons), Es = 0; Es < ls; Es++)
        ss = Ci[Es], Hs = es.getById(ss.id), Hs ? (Object.prototype.hasOwnProperty.call(ss, "isPrimary") && (Hs.isPrimary = ss.isPrimary), Hs.lastPos = Hs.currentPos, Hs.lastTime = Hs.currentTime, Hs.currentPos = ss.currentPos, Hs.currentTime = ss.currentTime) : (ss.captured = !1, ss.insideElementPressed = !1, ss.insideElement = !0, lo(es, ss));
      ci.stopHandler && Ci[0].type === "mouse" && (clearTimeout(ci.stopTimeOut), ci.stopTimeOut = setTimeout(function() {
        Os(ci, li, Ci[0].type);
      }, ci.stopDelay)), es.contacts === 0 ? ci.moveHandler && (To = ci.moveHandler(
        {
          eventSource: ci,
          pointerType: Ci[0].type,
          position: ot(Ci[0].currentPos, ci.element),
          buttons: es.buttons,
          isTouchEvent: Ci[0].type === "touch",
          originalEvent: li,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), To === !1 && ie.cancelEvent(li)) : es.contacts === 1 ? (ci.moveHandler && (Hs = es.asArray()[0], To = ci.moveHandler(
        {
          eventSource: ci,
          pointerType: Hs.type,
          position: ot(Hs.currentPos, ci.element),
          buttons: es.buttons,
          isTouchEvent: Hs.type === "touch",
          originalEvent: li,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), To === !1 && ie.cancelEvent(li)), ci.dragHandler && (Hs = es.asArray()[0], Us = Hs.currentPos.minus(Hs.lastPos), To = ci.dragHandler(
        {
          eventSource: ci,
          pointerType: Hs.type,
          position: ot(Hs.currentPos, ci.element),
          buttons: es.buttons,
          delta: Us,
          speed: Hs.speed,
          direction: Hs.direction,
          shift: li.shiftKey,
          isTouchEvent: Hs.type === "touch",
          originalEvent: li,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), To === !1 && ie.cancelEvent(li))) : es.contacts === 2 && (ci.moveHandler && (eo = es.asArray(), To = ci.moveHandler(
        {
          eventSource: ci,
          pointerType: eo[0].type,
          position: ot(lt(eo[0].currentPos, eo[1].currentPos), ci.element),
          buttons: es.buttons,
          isTouchEvent: eo[0].type === "touch",
          originalEvent: li,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), To === !1 && ie.cancelEvent(li)), ci.pinchHandler && Ci[0].type === "touch" && (Us = Li.pinchGPoints[0].currentPos.distanceTo(Li.pinchGPoints[1].currentPos), Us != Li.currentPinchDist && (Li.lastPinchDist = Li.currentPinchDist, Li.currentPinchDist = Us, Li.lastPinchCenter = Li.currentPinchCenter, Li.currentPinchCenter = lt(Li.pinchGPoints[0].currentPos, Li.pinchGPoints[1].currentPos), To = ci.pinchHandler(
        {
          eventSource: ci,
          pointerType: "touch",
          gesturePoints: Li.pinchGPoints,
          lastCenter: ot(Li.lastPinchCenter, ci.element),
          center: ot(Li.currentPinchCenter, ci.element),
          lastDistance: Li.lastPinchDist,
          distance: Li.currentPinchDist,
          shift: li.shiftKey,
          originalEvent: li,
          preventDefaultAction: !1,
          userData: ci.userData
        }
      ), To === !1 && ie.cancelEvent(li))));
    }
    function hs(ci, li, Ci) {
      Ta(ci, li, Ci, 0), mo(ci, li, Ci);
    }
    function Os(ci, li, Ci) {
      ci.stopHandler && ci.stopHandler({
        eventSource: ci,
        pointerType: Ci,
        position: st(li, ci.element),
        buttons: ci.getActivePointersListByType(Ci).buttons,
        isTouchEvent: Ci === "touch",
        originalEvent: li,
        preventDefaultAction: !1,
        userData: ci.userData
      });
    }
    var ho = function() {
      try {
        return window.self !== window.top;
      } catch {
        return !0;
      }
    }();
    function Ao(ci) {
      try {
        return ci.addEventListener && ci.removeEventListener;
      } catch {
        return !1;
      }
    }
  }(OpenSeadragon), function(ie) {
    ie.ControlAnchor = {
      NONE: 0,
      TOP_LEFT: 1,
      TOP_RIGHT: 2,
      BOTTOM_RIGHT: 3,
      BOTTOM_LEFT: 4,
      ABSOLUTE: 5
    }, ie.Control = function(Z, ee, ae) {
      var ve = Z.parentNode;
      typeof ee == "number" && (ie.console.error("Passing an anchor directly into the OpenSeadragon.Control constructor is deprecated; please use an options object instead.  Support for this deprecated variant is scheduled for removal in December 2013"), ee = { anchor: ee }), ee.attachToViewer = typeof ee.attachToViewer > "u" ? !0 : ee.attachToViewer, this.autoFade = typeof ee.autoFade > "u" ? !0 : ee.autoFade, this.element = Z, this.anchor = ee.anchor, this.container = ae, this.anchor == ie.ControlAnchor.ABSOLUTE ? (this.wrapper = ie.makeNeutralElement("div"), this.wrapper.style.position = "absolute", this.wrapper.style.top = typeof ee.top == "number" ? ee.top + "px" : ee.top, this.wrapper.style.left = typeof ee.left == "number" ? ee.left + "px" : ee.left, this.wrapper.style.height = typeof ee.height == "number" ? ee.height + "px" : ee.height, this.wrapper.style.width = typeof ee.width == "number" ? ee.width + "px" : ee.width, this.wrapper.style.margin = "0px", this.wrapper.style.padding = "0px", this.element.style.position = "relative", this.element.style.top = "0px", this.element.style.left = "0px", this.element.style.height = "100%", this.element.style.width = "100%") : (this.wrapper = ie.makeNeutralElement("div"), this.wrapper.style.display = "inline-block", this.anchor == ie.ControlAnchor.NONE && (this.wrapper.style.width = this.wrapper.style.height = "100%")), this.wrapper.appendChild(this.element), ee.attachToViewer ? this.anchor == ie.ControlAnchor.TOP_RIGHT || this.anchor == ie.ControlAnchor.BOTTOM_RIGHT ? this.container.insertBefore(
        this.wrapper,
        this.container.firstChild
      ) : this.container.appendChild(this.wrapper) : ve.appendChild(this.wrapper);
    }, ie.Control.prototype = {
      /**
       * Removes the control from the container.
       * @function
       */
      destroy: function() {
        this.wrapper.removeChild(this.element), this.container.removeChild(this.wrapper);
      },
      /**
       * Determines if the control is currently visible.
       * @function
       * @return {Boolean} true if currently visible, false otherwise.
       */
      isVisible: function() {
        return this.wrapper.style.display != "none";
      },
      /**
       * Toggles the visibility of the control.
       * @function
       * @param {Boolean} visible - true to make visible, false to hide.
       */
      setVisible: function(Z) {
        this.wrapper.style.display = Z ? this.anchor == ie.ControlAnchor.ABSOLUTE ? "block" : "inline-block" : "none";
      },
      /**
       * Sets the opacity level for the control.
       * @function
       * @param {Number} opactiy - a value between 1 and 0 inclusively.
       */
      setOpacity: function(Z) {
        this.element[ie.SIGNAL] && ie.Browser.vendor == ie.BROWSERS.IE ? ie.setElementOpacity(this.element, Z, !0) : ie.setElementOpacity(this.wrapper, Z, !0);
      }
    };
  }(OpenSeadragon), function(ie) {
    ie.ControlDock = function(ee) {
      var ae = ["topleft", "topright", "bottomright", "bottomleft"], ve, ye;
      for (ie.extend(!0, this, {
        id: "controldock-" + ie.now() + "-" + Math.floor(Math.random() * 1e6),
        container: ie.makeNeutralElement("div"),
        controls: []
      }, ee), this.container.onsubmit = function() {
        return !1;
      }, this.element && (this.element = ie.getElement(this.element), this.element.appendChild(this.container), this.element.style.position = "relative", this.container.style.width = "100%", this.container.style.height = "100%"), ye = 0; ye < ae.length; ye++)
        ve = ae[ye], this.controls[ve] = ie.makeNeutralElement("div"), this.controls[ve].style.position = "absolute", ve.match("left") && (this.controls[ve].style.left = "0px"), ve.match("right") && (this.controls[ve].style.right = "0px"), ve.match("top") && (this.controls[ve].style.top = "0px"), ve.match("bottom") && (this.controls[ve].style.bottom = "0px");
      this.container.appendChild(this.controls.topleft), this.container.appendChild(this.controls.topright), this.container.appendChild(this.controls.bottomright), this.container.appendChild(this.controls.bottomleft);
    }, ie.ControlDock.prototype = {
      /**
       * @function
       */
      addControl: function(ee, ae) {
        ee = ie.getElement(ee);
        var ve = null;
        if (!(Z(this, ee) >= 0)) {
          switch (ae.anchor) {
            case ie.ControlAnchor.TOP_RIGHT:
              ve = this.controls.topright, ee.style.position = "relative", ee.style.paddingRight = "0px", ee.style.paddingTop = "0px";
              break;
            case ie.ControlAnchor.BOTTOM_RIGHT:
              ve = this.controls.bottomright, ee.style.position = "relative", ee.style.paddingRight = "0px", ee.style.paddingBottom = "0px";
              break;
            case ie.ControlAnchor.BOTTOM_LEFT:
              ve = this.controls.bottomleft, ee.style.position = "relative", ee.style.paddingLeft = "0px", ee.style.paddingBottom = "0px";
              break;
            case ie.ControlAnchor.TOP_LEFT:
              ve = this.controls.topleft, ee.style.position = "relative", ee.style.paddingLeft = "0px", ee.style.paddingTop = "0px";
              break;
            case ie.ControlAnchor.ABSOLUTE:
              ve = this.container, ee.style.margin = "0px", ee.style.padding = "0px";
              break;
            default:
            case ie.ControlAnchor.NONE:
              ve = this.container, ee.style.margin = "0px", ee.style.padding = "0px";
              break;
          }
          this.controls.push(
            new ie.Control(ee, ae, ve)
          ), ee.style.display = "inline-block";
        }
      },
      /**
       * @function
       * @return {OpenSeadragon.ControlDock} Chainable.
       */
      removeControl: function(ee) {
        ee = ie.getElement(ee);
        var ae = Z(this, ee);
        return ae >= 0 && (this.controls[ae].destroy(), this.controls.splice(ae, 1)), this;
      },
      /**
       * @function
       * @return {OpenSeadragon.ControlDock} Chainable.
       */
      clearControls: function() {
        for (; this.controls.length > 0; )
          this.controls.pop().destroy();
        return this;
      },
      /**
       * @function
       * @return {Boolean}
       */
      areControlsEnabled: function() {
        var ee;
        for (ee = this.controls.length - 1; ee >= 0; ee--)
          if (this.controls[ee].isVisible())
            return !0;
        return !1;
      },
      /**
       * @function
       * @return {OpenSeadragon.ControlDock} Chainable.
       */
      setControlsEnabled: function(ee) {
        var ae;
        for (ae = this.controls.length - 1; ae >= 0; ae--)
          this.controls[ae].setVisible(ee);
        return this;
      }
    };
    function Z(ee, ae) {
      var ve = ee.controls, ye;
      for (ye = ve.length - 1; ye >= 0; ye--)
        if (ve[ye].element == ae)
          return ye;
      return -1;
    }
  }(OpenSeadragon), function(ie) {
    ie.Placement = ie.freezeObject({
      CENTER: 0,
      TOP_LEFT: 1,
      TOP: 2,
      TOP_RIGHT: 3,
      RIGHT: 4,
      BOTTOM_RIGHT: 5,
      BOTTOM: 6,
      BOTTOM_LEFT: 7,
      LEFT: 8,
      properties: {
        0: {
          isLeft: !1,
          isHorizontallyCentered: !0,
          isRight: !1,
          isTop: !1,
          isVerticallyCentered: !0,
          isBottom: !1
        },
        1: {
          isLeft: !0,
          isHorizontallyCentered: !1,
          isRight: !1,
          isTop: !0,
          isVerticallyCentered: !1,
          isBottom: !1
        },
        2: {
          isLeft: !1,
          isHorizontallyCentered: !0,
          isRight: !1,
          isTop: !0,
          isVerticallyCentered: !1,
          isBottom: !1
        },
        3: {
          isLeft: !1,
          isHorizontallyCentered: !1,
          isRight: !0,
          isTop: !0,
          isVerticallyCentered: !1,
          isBottom: !1
        },
        4: {
          isLeft: !1,
          isHorizontallyCentered: !1,
          isRight: !0,
          isTop: !1,
          isVerticallyCentered: !0,
          isBottom: !1
        },
        5: {
          isLeft: !1,
          isHorizontallyCentered: !1,
          isRight: !0,
          isTop: !1,
          isVerticallyCentered: !1,
          isBottom: !0
        },
        6: {
          isLeft: !1,
          isHorizontallyCentered: !0,
          isRight: !1,
          isTop: !1,
          isVerticallyCentered: !1,
          isBottom: !0
        },
        7: {
          isLeft: !0,
          isHorizontallyCentered: !1,
          isRight: !1,
          isTop: !1,
          isVerticallyCentered: !1,
          isBottom: !0
        },
        8: {
          isLeft: !0,
          isHorizontallyCentered: !1,
          isRight: !1,
          isTop: !1,
          isVerticallyCentered: !0,
          isBottom: !1
        }
      }
    });
  }(OpenSeadragon), function(ie) {
    var Z = {}, ee = 1;
    ie.Viewer = function(ii) {
      var bi = arguments, Gi = this, Qi;
      if (ie.isPlainObject(ii) || (ii = {
        id: bi[0],
        xmlPath: bi.length > 1 ? bi[1] : void 0,
        prefixUrl: bi.length > 2 ? bi[2] : void 0,
        controls: bi.length > 3 ? bi[3] : void 0,
        overlays: bi.length > 4 ? bi[4] : void 0
      }), ii.config && (ie.extend(!0, ii, ii.config), delete ii.config), ie.extend(!0, this, {
        //internal state and dom identifiers
        id: ii.id,
        hash: ii.hash || ee++,
        /**
         * Index for page to be shown first next time open() is called (only used in sequenceMode).
         * @member {Number} initialPage
         * @memberof OpenSeadragon.Viewer#
         */
        initialPage: 0,
        //dom nodes
        /**
         * The parent element of this Viewer instance, passed in when the Viewer was created.
         * @member {Element} element
         * @memberof OpenSeadragon.Viewer#
         */
        element: null,
        /**
         * A &lt;div&gt; element (provided by {@link OpenSeadragon.ControlDock}), the base element of this Viewer instance.<br><br>
         * Child element of {@link OpenSeadragon.Viewer#element}.
         * @member {Element} container
         * @memberof OpenSeadragon.Viewer#
         */
        container: null,
        /**
         * A &lt;div&gt; element, the element where user-input events are handled for panning and zooming.<br><br>
         * Child element of {@link OpenSeadragon.Viewer#container},
         * positioned on top of {@link OpenSeadragon.Viewer#keyboardCommandArea}.<br><br>
         * The parent of {@link OpenSeadragon.Drawer#canvas} instances.
         * @member {Element} canvas
         * @memberof OpenSeadragon.Viewer#
         */
        canvas: null,
        // Overlays list. An overlay allows to add html on top of the viewer.
        overlays: [],
        // Container inside the canvas where overlays are drawn.
        overlaysContainer: null,
        //private state properties
        previousBody: [],
        //This was originally initialized in the constructor and so could never
        //have anything in it.  now it can because we allow it to be specified
        //in the options and is only empty by default if not specified. Also
        //this array was returned from get_controls which I find confusing
        //since this object has a controls property which is treated in other
        //functions like clearControls.  I'm removing the accessors.
        customControls: [],
        //These are originally not part options but declared as members
        //in initialize.  It's still considered idiomatic to put them here
        //source is here for backwards compatibility. It is not an official
        //part of the API and should not be relied upon.
        source: null,
        /**
         * Handles rendering of tiles in the viewer. Created for each TileSource opened.
         * @member {OpenSeadragon.Drawer} drawer
         * @memberof OpenSeadragon.Viewer#
         */
        drawer: null,
        /**
         * Keeps track of all of the tiled images in the scene.
         * @member {OpenSeadragon.World} world
         * @memberof OpenSeadragon.Viewer#
         */
        world: null,
        /**
         * Handles coordinate-related functionality - zoom, pan, rotation, etc. Created for each TileSource opened.
         * @member {OpenSeadragon.Viewport} viewport
         * @memberof OpenSeadragon.Viewer#
         */
        viewport: null,
        /**
         * @member {OpenSeadragon.Navigator} navigator
         * @memberof OpenSeadragon.Viewer#
         */
        navigator: null,
        //A collection viewport is a separate viewport used to provide
        //simultaneous rendering of sets of tiles
        collectionViewport: null,
        collectionDrawer: null,
        //UI image resources
        //TODO: rename navImages to uiImages
        navImages: null,
        //interface button controls
        buttons: null,
        //TODO: this is defunct so safely remove it
        profiler: null
      }, ie.DEFAULT_SETTINGS, ii), typeof this.hash > "u")
        throw new Error("A hash must be defined, either by specifying options.id or options.hash.");
      for (typeof Z[this.hash] < "u" && ie.console.warn("Hash " + this.hash + " has already been used."), Z[this.hash] = {
        fsBoundsDelta: new ie.Point(1, 1),
        prevContainerSize: null,
        animating: !1,
        forceRedraw: !1,
        mouseInside: !1,
        group: null,
        // whether we should be continuously zooming
        zooming: !1,
        // how much we should be continuously zooming by
        zoomFactor: null,
        lastZoomTime: null,
        fullPage: !1,
        onfullscreenchange: null
      }, this._sequenceIndex = 0, this._firstOpen = !0, this._updateRequestId = null, this._loadQueue = [], this.currentOverlays = [], this._lastScrollTime = ie.now(), ie.EventSource.call(this), this.addHandler("open-failed", function(ns) {
        var Bs = ie.getString("Errors.OpenFailed", ns.eventSource, ns.message);
        Gi._showMessage(Bs);
      }), ie.ControlDock.call(this, ii), this.xmlPath && (this.tileSources = [this.xmlPath]), this.element = this.element || document.getElementById(this.id), this.canvas = ie.makeNeutralElement("div"), this.canvas.className = "openseadragon-canvas", function(ns) {
        ns.width = "100%", ns.height = "100%", ns.overflow = "hidden", ns.position = "absolute", ns.top = "0px", ns.left = "0px";
      }(this.canvas.style), ie.setElementTouchActionNone(this.canvas), ii.tabIndex !== "" && (this.canvas.tabIndex = ii.tabIndex === void 0 ? 0 : ii.tabIndex), this.container.className = "openseadragon-container", function(ns) {
        ns.width = "100%", ns.height = "100%", ns.position = "relative", ns.overflow = "hidden", ns.left = "0px", ns.top = "0px", ns.textAlign = "left";
      }(this.container.style), this.container.insertBefore(this.canvas, this.container.firstChild), this.element.appendChild(this.container), this.bodyWidth = document.body.style.width, this.bodyHeight = document.body.style.height, this.bodyOverflow = document.body.style.overflow, this.docOverflow = document.documentElement.style.overflow, this.innerTracker = new ie.MouseTracker({
        element: this.canvas,
        startDisabled: !this.mouseNavEnabled,
        clickTimeThreshold: this.clickTimeThreshold,
        clickDistThreshold: this.clickDistThreshold,
        dblClickTimeThreshold: this.dblClickTimeThreshold,
        dblClickDistThreshold: this.dblClickDistThreshold,
        keyDownHandler: ie.delegate(this, ft),
        keyHandler: ie.delegate(this, gt),
        clickHandler: ie.delegate(this, ct),
        dblClickHandler: ie.delegate(this, _r),
        dragHandler: ie.delegate(this, Kr),
        dragEndHandler: ie.delegate(this, Xr),
        enterHandler: ie.delegate(this, Jr),
        exitHandler: ie.delegate(this, ei),
        pressHandler: ie.delegate(this, si),
        releaseHandler: ie.delegate(this, ri),
        nonPrimaryPressHandler: ie.delegate(this, ai),
        nonPrimaryReleaseHandler: ie.delegate(this, yi),
        scrollHandler: ie.delegate(this, di),
        pinchHandler: ie.delegate(this, pi)
      }), this.outerTracker = new ie.MouseTracker({
        element: this.container,
        startDisabled: !this.mouseNavEnabled,
        clickTimeThreshold: this.clickTimeThreshold,
        clickDistThreshold: this.clickDistThreshold,
        dblClickTimeThreshold: this.dblClickTimeThreshold,
        dblClickDistThreshold: this.dblClickDistThreshold,
        enterHandler: ie.delegate(this, xi),
        exitHandler: ie.delegate(this, Ti)
      }), this.toolbar && (this.toolbar = new ie.ControlDock({ element: this.toolbar })), this.bindStandardControls(), Z[this.hash].prevContainerSize = ae(this.container), this.world = new ie.World({
        viewer: this
      }), this.world.addHandler("add-item", function(ns) {
        Gi.source = Gi.world.getItemAt(0).source, Z[Gi.hash].forceRedraw = !0, Gi._updateRequestId || (Gi._updateRequestId = Ye(Gi, Ai));
      }), this.world.addHandler("remove-item", function(ns) {
        Gi.world.getItemCount() ? Gi.source = Gi.world.getItemAt(0).source : Gi.source = null, Z[Gi.hash].forceRedraw = !0;
      }), this.world.addHandler("metrics-change", function(ns) {
        Gi.viewport && Gi.viewport._setContentBounds(Gi.world.getHomeBounds(), Gi.world.getContentFactor());
      }), this.world.addHandler("item-index-change", function(ns) {
        Gi.source = Gi.world.getItemAt(0).source;
      }), this.viewport = new ie.Viewport({
        containerSize: Z[this.hash].prevContainerSize,
        springStiffness: this.springStiffness,
        animationTime: this.animationTime,
        minZoomImageRatio: this.minZoomImageRatio,
        maxZoomPixelRatio: this.maxZoomPixelRatio,
        visibilityRatio: this.visibilityRatio,
        wrapHorizontal: this.wrapHorizontal,
        wrapVertical: this.wrapVertical,
        defaultZoomLevel: this.defaultZoomLevel,
        minZoomLevel: this.minZoomLevel,
        maxZoomLevel: this.maxZoomLevel,
        viewer: this,
        degrees: this.degrees,
        flipped: this.flipped,
        navigatorRotate: this.navigatorRotate,
        homeFillsViewer: this.homeFillsViewer,
        margins: this.viewportMargins
      }), this.viewport._setContentBounds(this.world.getHomeBounds(), this.world.getContentFactor()), this.imageLoader = new ie.ImageLoader({
        jobLimit: this.imageLoaderLimit,
        timeout: ii.timeout
      }), this.tileCache = new ie.TileCache({
        maxImageCacheCount: this.maxImageCacheCount
      }), this.drawer = new ie.Drawer({
        viewer: this,
        viewport: this.viewport,
        element: this.canvas,
        debugGridColor: this.debugGridColor
      }), this.overlaysContainer = ie.makeNeutralElement("div"), this.canvas.appendChild(this.overlaysContainer), this.drawer.canRotate() || (this.rotateLeft && (Qi = this.buttons.buttons.indexOf(this.rotateLeft), this.buttons.buttons.splice(Qi, 1), this.buttons.element.removeChild(this.rotateLeft.element)), this.rotateRight && (Qi = this.buttons.buttons.indexOf(this.rotateRight), this.buttons.buttons.splice(Qi, 1), this.buttons.element.removeChild(this.rotateRight.element))), this.showNavigator && (this.navigator = new ie.Navigator({
        id: this.navigatorId,
        position: this.navigatorPosition,
        sizeRatio: this.navigatorSizeRatio,
        maintainSizeRatio: this.navigatorMaintainSizeRatio,
        top: this.navigatorTop,
        left: this.navigatorLeft,
        width: this.navigatorWidth,
        height: this.navigatorHeight,
        autoResize: this.navigatorAutoResize,
        autoFade: this.navigatorAutoFade,
        prefixUrl: this.prefixUrl,
        viewer: this,
        navigatorRotate: this.navigatorRotate,
        background: this.navigatorBackground,
        opacity: this.navigatorOpacity,
        borderColor: this.navigatorBorderColor,
        displayRegionColor: this.navigatorDisplayRegionColor,
        crossOriginPolicy: this.crossOriginPolicy
      })), this.sequenceMode && this.bindSequenceControls(), this.tileSources && this.open(this.tileSources), Qi = 0; Qi < this.customControls.length; Qi++)
        this.addControl(
          this.customControls[Qi].id,
          { anchor: this.customControls[Qi].anchor }
        );
      ie.requestAnimationFrame(function() {
        Je(Gi);
      }), this.imageSmoothingEnabled !== void 0 && !this.imageSmoothingEnabled && this.drawer.setImageSmoothingEnabled(this.imageSmoothingEnabled);
    }, ie.extend(
      ie.Viewer.prototype,
      ie.EventSource.prototype,
      ie.ControlDock.prototype,
      /** @lends OpenSeadragon.Viewer.prototype */
      {
        /**
         * @function
         * @return {Boolean}
         */
        isOpen: function() {
          return !!this.world.getItemCount();
        },
        // deprecated
        openDzi: function(ii) {
          return ie.console.error("[Viewer.openDzi] this function is deprecated; use Viewer.open() instead."), this.open(ii);
        },
        // deprecated
        openTileSource: function(ii) {
          return ie.console.error("[Viewer.openTileSource] this function is deprecated; use Viewer.open() instead."), this.open(ii);
        },
        /**
         * Open tiled images into the viewer, closing any others.
         * To get the TiledImage instance created by open, add an event listener for
         * {@link OpenSeadragon.Viewer.html#.event:open}, which when fired can be used to get access
         * to the instance, i.e., viewer.world.getItemAt(0).
         * @function
         * @param {Array|String|Object|Function} tileSources - This can be a TiledImage
         * specifier, a TileSource specifier, or an array of either. A TiledImage specifier
         * is the same as the options parameter for {@link OpenSeadragon.Viewer#addTiledImage},
         * except for the index property; images are added in sequence.
         * A TileSource specifier is anything you could pass as the tileSource property
         * of the options parameter for {@link OpenSeadragon.Viewer#addTiledImage}.
         * @param {Number} initialPage - If sequenceMode is true, display this page initially
         * for the given tileSources. If specified, will overwrite the Viewer's existing initialPage property.
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:open
         * @fires OpenSeadragon.Viewer.event:open-failed
         */
        open: function(ii, bi) {
          var Gi = this;
          if (this.close(), !!ii) {
            if (this.sequenceMode && ie.isArray(ii)) {
              this.referenceStrip && (this.referenceStrip.destroy(), this.referenceStrip = null), typeof bi < "u" && !isNaN(bi) && (this.initialPage = bi), this.tileSources = ii, this._sequenceIndex = Math.max(0, Math.min(this.tileSources.length - 1, this.initialPage)), this.tileSources.length && (this.open(this.tileSources[this._sequenceIndex]), this.showReferenceStrip && this.addReferenceStrip()), this._updateSequenceButtons(this._sequenceIndex);
              return;
            }
            if (ie.isArray(ii) || (ii = [ii]), !!ii.length) {
              this._opening = !0;
              for (var Qi = ii.length, ns = 0, Bs = 0, ms, Ks = function() {
                if (ns + Bs === Qi)
                  if (ns) {
                    (Gi._firstOpen || !Gi.preserveViewport) && (Gi.viewport.goHome(!0), Gi.viewport.update()), Gi._firstOpen = !1;
                    var Ts = ii[0];
                    if (Ts.tileSource && (Ts = Ts.tileSource), Gi.overlays && !Gi.preserveOverlays)
                      for (var lo = 0; lo < Gi.overlays.length; lo++)
                        Gi.currentOverlays[lo] = ye(Gi, Gi.overlays[lo]);
                    Gi._drawOverlays(), Gi._opening = !1, Gi.raiseEvent("open", { source: Ts });
                  } else
                    Gi._opening = !1, Gi.raiseEvent("open-failed", ms);
              }, Js = function(Ts) {
                (!ie.isPlainObject(Ts) || !Ts.tileSource) && (Ts = {
                  tileSource: Ts
                }), Ts.index !== void 0 && (ie.console.error("[Viewer.open] setting indexes here is not supported; use addTiledImage instead"), delete Ts.index), Ts.collectionImmediately === void 0 && (Ts.collectionImmediately = !0);
                var lo = Ts.success;
                Ts.success = function(xo) {
                  if (ns++, Ts.tileSource.overlays)
                    for (var mo = 0; mo < Ts.tileSource.overlays.length; mo++)
                      Gi.addOverlay(Ts.tileSource.overlays[mo]);
                  lo && lo(xo), Ks();
                };
                var Fs = Ts.error;
                Ts.error = function(xo) {
                  Bs++, ms || (ms = xo), Fs && Fs(xo), Ks();
                }, Gi.addTiledImage(Ts);
              }, Ns = 0; Ns < ii.length; Ns++)
                Js(ii[Ns]);
              return this;
            }
          }
        },
        /**
         * @function
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:close
         */
        close: function() {
          return Z[this.hash] ? (this._opening = !1, this.navigator && this.navigator.close(), this.preserveOverlays || (this.clearOverlays(), this.overlaysContainer.innerHTML = ""), Z[this.hash].animating = !1, this.world.removeAll(), this.imageLoader.clear(), this.raiseEvent("close"), this) : this;
        },
        /**
         * Function to destroy the viewer and clean up everything created by OpenSeadragon.
         *
         * Example:
         * var viewer = OpenSeadragon({
         *   [...]
         * });
         *
         * //when you are done with the viewer:
         * viewer.destroy();
         * viewer = null; //important
         *
         * @function
         */
        destroy: function() {
          if (Z[this.hash]) {
            if (this.close(), this.clearOverlays(), this.overlaysContainer.innerHTML = "", this.referenceStrip && (this.referenceStrip.destroy(), this.referenceStrip = null), this._updateRequestId !== null && (ie.cancelAnimationFrame(this._updateRequestId), this._updateRequestId = null), this.drawer && this.drawer.destroy(), this.removeAllHandlers(), this.element)
              for (; this.element.firstChild; )
                this.element.removeChild(this.element.firstChild);
            this.innerTracker && this.innerTracker.destroy(), this.outerTracker && this.outerTracker.destroy(), Z[this.hash] = null, delete Z[this.hash], this.canvas = null, this.container = null, this.element = null;
          }
        },
        /**
         * @function
         * @return {Boolean}
         */
        isMouseNavEnabled: function() {
          return this.innerTracker.isTracking();
        },
        /**
         * @function
         * @param {Boolean} enabled - true to enable, false to disable
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:mouse-enabled
         */
        setMouseNavEnabled: function(ii) {
          return this.innerTracker.setTracking(ii), this.outerTracker.setTracking(ii), this.raiseEvent("mouse-enabled", { enabled: ii }), this;
        },
        /**
         * @function
         * @return {Boolean}
         */
        areControlsEnabled: function() {
          var ii = this.controls.length, bi;
          for (bi = 0; bi < this.controls.length; bi++)
            ii = ii && this.controls[bi].isVisible();
          return ii;
        },
        /**
         * Shows or hides the controls (e.g. the default navigation buttons).
         *
         * @function
         * @param {Boolean} true to show, false to hide.
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:controls-enabled
         */
        setControlsEnabled: function(ii) {
          return ii ? st(this) : Je(this), this.raiseEvent("controls-enabled", { enabled: ii }), this;
        },
        /**
         * Turns debugging mode on or off for this viewer.
         *
         * @function
         * @param {Boolean} true to turn debug on, false to turn debug off.
         */
        setDebugMode: function(ii) {
          for (var bi = 0; bi < this.world.getItemCount(); bi++)
            this.world.getItemAt(bi).debugMode = ii;
          this.debugMode = ii, this.forceRedraw();
        },
        /**
         * @function
         * @return {Boolean}
         */
        isFullPage: function() {
          return Z[this.hash].fullPage;
        },
        /**
         * Toggle full page mode.
         * @function
         * @param {Boolean} fullPage
         *      If true, enter full page mode.  If false, exit full page mode.
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:pre-full-page
         * @fires OpenSeadragon.Viewer.event:full-page
         */
        setFullPage: function(ii) {
          var bi = document.body, Gi = bi.style, Qi = document.documentElement.style, ns = this, Bs, ms;
          if (ii == this.isFullPage())
            return this;
          var Ks = {
            fullPage: ii,
            preventDefaultAction: !1
          };
          if (this.raiseEvent("pre-full-page", Ks), Ks.preventDefaultAction)
            return this;
          if (ii) {
            for (this.elementSize = ie.getElementSize(this.element), this.pageScroll = ie.getPageScroll(), this.elementMargin = this.element.style.margin, this.element.style.margin = "0", this.elementPadding = this.element.style.padding, this.element.style.padding = "0", this.bodyMargin = Gi.margin, this.docMargin = Qi.margin, Gi.margin = "0", Qi.margin = "0", this.bodyPadding = Gi.padding, this.docPadding = Qi.padding, Gi.padding = "0", Qi.padding = "0", this.bodyWidth = Gi.width, this.docWidth = Qi.width, Gi.width = "100%", Qi.width = "100%", this.bodyHeight = Gi.height, this.docHeight = Qi.height, Gi.height = "100%", Qi.height = "100%", this.previousBody = [], Z[this.hash].prevElementParent = this.element.parentNode, Z[this.hash].prevNextSibling = this.element.nextSibling, Z[this.hash].prevElementWidth = this.element.style.width, Z[this.hash].prevElementHeight = this.element.style.height, Bs = bi.childNodes.length, ms = 0; ms < Bs; ms++)
              this.previousBody.push(bi.childNodes[0]), bi.removeChild(bi.childNodes[0]);
            this.toolbar && this.toolbar.element && (this.toolbar.parentNode = this.toolbar.element.parentNode, this.toolbar.nextSibling = this.toolbar.element.nextSibling, bi.appendChild(this.toolbar.element), ie.addClass(this.toolbar.element, "fullpage")), ie.addClass(this.element, "fullpage"), bi.appendChild(this.element), this.element.style.height = ie.getWindowSize().y + "px", this.element.style.width = ie.getWindowSize().x + "px", this.toolbar && this.toolbar.element && (this.element.style.height = ie.getElementSize(this.element).y - ie.getElementSize(this.toolbar.element).y + "px"), Z[this.hash].fullPage = !0, ie.delegate(this, xi)({});
          } else {
            for (this.element.style.margin = this.elementMargin, this.element.style.padding = this.elementPadding, Gi.margin = this.bodyMargin, Qi.margin = this.docMargin, Gi.padding = this.bodyPadding, Qi.padding = this.docPadding, Gi.width = this.bodyWidth, Qi.width = this.docWidth, Gi.height = this.bodyHeight, Qi.height = this.docHeight, bi.removeChild(this.element), Bs = this.previousBody.length, ms = 0; ms < Bs; ms++)
              bi.appendChild(this.previousBody.shift());
            ie.removeClass(this.element, "fullpage"), Z[this.hash].prevElementParent.insertBefore(
              this.element,
              Z[this.hash].prevNextSibling
            ), this.toolbar && this.toolbar.element && (bi.removeChild(this.toolbar.element), ie.removeClass(this.toolbar.element, "fullpage"), this.toolbar.parentNode.insertBefore(
              this.toolbar.element,
              this.toolbar.nextSibling
            ), delete this.toolbar.parentNode, delete this.toolbar.nextSibling), this.element.style.width = Z[this.hash].prevElementWidth, this.element.style.height = Z[this.hash].prevElementHeight;
            var Js = 0, Ns = function() {
              ie.setPageScroll(ns.pageScroll);
              var Ts = ie.getPageScroll();
              Js++, Js < 10 && (Ts.x !== ns.pageScroll.x || Ts.y !== ns.pageScroll.y) && ie.requestAnimationFrame(Ns);
            };
            ie.requestAnimationFrame(Ns), Z[this.hash].fullPage = !1, ie.delegate(this, Ti)({});
          }
          return this.navigator && this.viewport && this.navigator.update(this.viewport), this.raiseEvent("full-page", { fullPage: ii }), this;
        },
        /**
         * Toggle full screen mode if supported. Toggle full page mode otherwise.
         * @function
         * @param {Boolean} fullScreen
         *      If true, enter full screen mode.  If false, exit full screen mode.
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:pre-full-screen
         * @fires OpenSeadragon.Viewer.event:full-screen
         */
        setFullScreen: function(ii) {
          var bi = this;
          if (!ie.supportsFullScreen)
            return this.setFullPage(ii);
          if (ie.isFullScreen() === ii)
            return this;
          var Gi = {
            fullScreen: ii,
            preventDefaultAction: !1
          };
          if (this.raiseEvent("pre-full-screen", Gi), Gi.preventDefaultAction)
            return this;
          if (ii) {
            if (this.setFullPage(!0), !this.isFullPage())
              return this;
            this.fullPageStyleWidth = this.element.style.width, this.fullPageStyleHeight = this.element.style.height, this.element.style.width = "100%", this.element.style.height = "100%";
            var Qi = function() {
              var ns = ie.isFullScreen();
              ns || (ie.removeEvent(document, ie.fullScreenEventName, Qi), ie.removeEvent(document, ie.fullScreenErrorEventName, Qi), bi.setFullPage(!1), bi.isFullPage() && (bi.element.style.width = bi.fullPageStyleWidth, bi.element.style.height = bi.fullPageStyleHeight)), bi.navigator && bi.viewport && setTimeout(function() {
                bi.navigator.update(bi.viewport);
              }), bi.raiseEvent("full-screen", { fullScreen: ns });
            };
            ie.addEvent(document, ie.fullScreenEventName, Qi), ie.addEvent(document, ie.fullScreenErrorEventName, Qi), ie.requestFullScreen(document.body);
          } else
            ie.exitFullScreen();
          return this;
        },
        /**
         * @function
         * @return {Boolean}
         */
        isVisible: function() {
          return this.container.style.visibility != "hidden";
        },
        /**
         * @function
         * @param {Boolean} visible
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:visible
         */
        setVisible: function(ii) {
          return this.container.style.visibility = ii ? "" : "hidden", this.raiseEvent("visible", { visible: ii }), this;
        },
        /**
         * Add a tiled image to the viewer.
         * options.tileSource can be anything that {@link OpenSeadragon.Viewer#open}
         *  supports except arrays of images.
         * Note that you can specify options.width or options.height, but not both.
         * The other dimension will be calculated according to the item's aspect ratio.
         * If collectionMode is on (see {@link OpenSeadragon.Options}), the new image is
         * automatically arranged with the others.
         * @function
         * @param {Object} options
         * @param {String|Object|Function} options.tileSource - The TileSource specifier.
         * A String implies a url used to determine the tileSource implementation
         *      based on the file extension of url. JSONP is implied by *.js,
         *      otherwise the url is retrieved as text and the resulting text is
         *      introspected to determine if its json, xml, or text and parsed.
         * An Object implies an inline configuration which has a single
         *      property sufficient for being able to determine tileSource
         *      implementation. If the object has a property which is a function
         *      named 'getTileUrl', it is treated as a custom TileSource.
         * @param {Number} [options.index] The index of the item. Added on top of
         * all other items if not specified.
         * @param {Boolean} [options.replace=false] If true, the item at options.index will be
         * removed and the new item is added in its place. options.tileSource will be
         * interpreted and fetched if necessary before the old item is removed to avoid leaving
         * a gap in the world.
         * @param {Number} [options.x=0] The X position for the image in viewport coordinates.
         * @param {Number} [options.y=0] The Y position for the image in viewport coordinates.
         * @param {Number} [options.width=1] The width for the image in viewport coordinates.
         * @param {Number} [options.height] The height for the image in viewport coordinates.
         * @param {OpenSeadragon.Rect} [options.fitBounds] The bounds in viewport coordinates
         * to fit the image into. If specified, x, y, width and height get ignored.
         * @param {OpenSeadragon.Placement} [options.fitBoundsPlacement=OpenSeadragon.Placement.CENTER]
         * How to anchor the image in the bounds if options.fitBounds is set.
         * @param {OpenSeadragon.Rect} [options.clip] - An area, in image pixels, to clip to
         * (portions of the image outside of this area will not be visible). Only works on
         * browsers that support the HTML5 canvas.
         * @param {Number} [options.opacity=1] Proportional opacity of the tiled images (1=opaque, 0=hidden)
         * @param {Boolean} [options.preload=false]  Default switch for loading hidden images (true loads, false blocks)
         * @param {Number} [options.degrees=0] Initial rotation of the tiled image around
         * its top left corner in degrees.
         * @param {String} [options.compositeOperation] How the image is composited onto other images.
         * @param {String} [options.crossOriginPolicy] The crossOriginPolicy for this specific image,
         * overriding viewer.crossOriginPolicy.
         * @param {Boolean} [options.ajaxWithCredentials] Whether to set withCredentials on tile AJAX
         * @param {Boolean} [options.loadTilesWithAjax]
         *      Whether to load tile data using AJAX requests.
         *      Defaults to the setting in {@link OpenSeadragon.Options}.
         * @param {Object} [options.ajaxHeaders]
         *      A set of headers to include when making tile AJAX requests.
         *      Note that these headers will be merged over any headers specified in {@link OpenSeadragon.Options}.
         *      Specifying a falsy value for a header will clear its existing value set at the Viewer level (if any).
         * requests.
         * @param {Function} [options.success] A function that gets called when the image is
         * successfully added. It's passed the event object which contains a single property:
         * "item", which is the resulting instance of TiledImage.
         * @param {Function} [options.error] A function that gets called if the image is
         * unable to be added. It's passed the error event object, which contains "message"
         * and "source" properties.
         * @param {Boolean} [options.collectionImmediately=false] If collectionMode is on,
         * specifies whether to snap to the new arrangement immediately or to animate to it.
         * @param {String|CanvasGradient|CanvasPattern|Function} [options.placeholderFillStyle] - See {@link OpenSeadragon.Options}.
         * @fires OpenSeadragon.World.event:add-item
         * @fires OpenSeadragon.Viewer.event:add-item-failed
         */
        addTiledImage: function(ii) {
          ie.console.assert(ii, "[Viewer.addTiledImage] options is required"), ie.console.assert(ii.tileSource, "[Viewer.addTiledImage] options.tileSource is required"), ie.console.assert(
            !ii.replace || ii.index > -1 && ii.index < this.world.getItemCount(),
            "[Viewer.addTiledImage] if options.replace is used, options.index must be a valid index in Viewer.world"
          );
          var bi = this;
          ii.replace && (ii.replaceItem = bi.world.getItemAt(ii.index)), this._hideMessage(), ii.placeholderFillStyle === void 0 && (ii.placeholderFillStyle = this.placeholderFillStyle), ii.opacity === void 0 && (ii.opacity = this.opacity), ii.preload === void 0 && (ii.preload = this.preload), ii.compositeOperation === void 0 && (ii.compositeOperation = this.compositeOperation), ii.crossOriginPolicy === void 0 && (ii.crossOriginPolicy = ii.tileSource.crossOriginPolicy !== void 0 ? ii.tileSource.crossOriginPolicy : this.crossOriginPolicy), ii.ajaxWithCredentials === void 0 && (ii.ajaxWithCredentials = this.ajaxWithCredentials), ii.loadTilesWithAjax === void 0 && (ii.loadTilesWithAjax = this.loadTilesWithAjax), ii.ajaxHeaders === void 0 || ii.ajaxHeaders === null ? ii.ajaxHeaders = this.ajaxHeaders : ie.isPlainObject(ii.ajaxHeaders) && ie.isPlainObject(this.ajaxHeaders) && (ii.ajaxHeaders = ie.extend({}, this.ajaxHeaders, ii.ajaxHeaders));
          var Gi = {
            options: ii
          };
          function Qi(ms) {
            for (var Ks = 0; Ks < bi._loadQueue.length; Ks++)
              if (bi._loadQueue[Ks] === Gi) {
                bi._loadQueue.splice(Ks, 1);
                break;
              }
            bi._loadQueue.length === 0 && ns(Gi), bi.raiseEvent("add-item-failed", ms), ii.error && ii.error(ms);
          }
          function ns(ms) {
            bi.collectionMode && (bi.world.arrange({
              immediately: ms.options.collectionImmediately,
              rows: bi.collectionRows,
              columns: bi.collectionColumns,
              layout: bi.collectionLayout,
              tileSize: bi.collectionTileSize,
              tileMargin: bi.collectionTileMargin
            }), bi.world.setAutoRefigureSizes(!0));
          }
          if (ie.isArray(ii.tileSource)) {
            setTimeout(function() {
              Qi({
                message: "[Viewer.addTiledImage] Sequences can not be added; add them one at a time instead.",
                source: ii.tileSource,
                options: ii
              });
            });
            return;
          }
          this._loadQueue.push(Gi);
          function Bs() {
            for (var ms, Ks, Js; bi._loadQueue.length && (ms = bi._loadQueue[0], !!ms.tileSource); ) {
              if (bi._loadQueue.splice(0, 1), ms.options.replace) {
                var Ns = bi.world.getIndexOfItem(ms.options.replaceItem);
                Ns != -1 && (ms.options.index = Ns), bi.world.removeItem(ms.options.replaceItem);
              }
              Ks = new ie.TiledImage({
                viewer: bi,
                source: ms.tileSource,
                viewport: bi.viewport,
                drawer: bi.drawer,
                tileCache: bi.tileCache,
                imageLoader: bi.imageLoader,
                x: ms.options.x,
                y: ms.options.y,
                width: ms.options.width,
                height: ms.options.height,
                fitBounds: ms.options.fitBounds,
                fitBoundsPlacement: ms.options.fitBoundsPlacement,
                clip: ms.options.clip,
                placeholderFillStyle: ms.options.placeholderFillStyle,
                opacity: ms.options.opacity,
                preload: ms.options.preload,
                degrees: ms.options.degrees,
                compositeOperation: ms.options.compositeOperation,
                springStiffness: bi.springStiffness,
                animationTime: bi.animationTime,
                minZoomImageRatio: bi.minZoomImageRatio,
                wrapHorizontal: bi.wrapHorizontal,
                wrapVertical: bi.wrapVertical,
                immediateRender: bi.immediateRender,
                blendTime: bi.blendTime,
                alwaysBlend: bi.alwaysBlend,
                minPixelRatio: bi.minPixelRatio,
                smoothTileEdgesMinZoom: bi.smoothTileEdgesMinZoom,
                iOSDevice: bi.iOSDevice,
                crossOriginPolicy: ms.options.crossOriginPolicy,
                ajaxWithCredentials: ms.options.ajaxWithCredentials,
                loadTilesWithAjax: ms.options.loadTilesWithAjax,
                ajaxHeaders: ms.options.ajaxHeaders,
                debugMode: bi.debugMode
              }), bi.collectionMode && bi.world.setAutoRefigureSizes(!1), bi.world.addItem(Ks, {
                index: ms.options.index
              }), bi._loadQueue.length === 0 && ns(ms), bi.world.getItemCount() === 1 && !bi.preserveViewport && bi.viewport.goHome(!0), bi.navigator && (Js = ie.extend({}, ms.options, {
                replace: !1,
                // navigator already removed the layer, nothing to replace
                originalTiledImage: Ks,
                tileSource: ms.tileSource
              }), bi.navigator.addTiledImage(Js)), ms.options.success && ms.options.success({
                item: Ks
              });
            }
          }
          ve(this, ii.tileSource, ii, function(ms) {
            Gi.tileSource = ms, Bs();
          }, function(ms) {
            ms.options = ii, Qi(ms), Bs();
          });
        },
        /**
         * Add a simple image to the viewer.
         * The options are the same as the ones in {@link OpenSeadragon.Viewer#addTiledImage}
         * except for options.tileSource which is replaced by options.url.
         * @function
         * @param {Object} options - See {@link OpenSeadragon.Viewer#addTiledImage}
         * for all the options
         * @param {String} options.url - The URL of the image to add.
         * @fires OpenSeadragon.World.event:add-item
         * @fires OpenSeadragon.Viewer.event:add-item-failed
         */
        addSimpleImage: function(ii) {
          ie.console.assert(ii, "[Viewer.addSimpleImage] options is required"), ie.console.assert(ii.url, "[Viewer.addSimpleImage] options.url is required");
          var bi = ie.extend({}, ii, {
            tileSource: {
              type: "image",
              url: ii.url
            }
          });
          delete bi.url, this.addTiledImage(bi);
        },
        // deprecated
        addLayer: function(ii) {
          var bi = this;
          ie.console.error("[Viewer.addLayer] this function is deprecated; use Viewer.addTiledImage() instead.");
          var Gi = ie.extend({}, ii, {
            success: function(Qi) {
              bi.raiseEvent("add-layer", {
                options: ii,
                drawer: Qi.item
              });
            },
            error: function(Qi) {
              bi.raiseEvent("add-layer-failed", Qi);
            }
          });
          return this.addTiledImage(Gi), this;
        },
        // deprecated
        getLayerAtLevel: function(ii) {
          return ie.console.error("[Viewer.getLayerAtLevel] this function is deprecated; use World.getItemAt() instead."), this.world.getItemAt(ii);
        },
        // deprecated
        getLevelOfLayer: function(ii) {
          return ie.console.error("[Viewer.getLevelOfLayer] this function is deprecated; use World.getIndexOfItem() instead."), this.world.getIndexOfItem(ii);
        },
        // deprecated
        getLayersCount: function() {
          return ie.console.error("[Viewer.getLayersCount] this function is deprecated; use World.getItemCount() instead."), this.world.getItemCount();
        },
        // deprecated
        setLayerLevel: function(ii, bi) {
          return ie.console.error("[Viewer.setLayerLevel] this function is deprecated; use World.setItemIndex() instead."), this.world.setItemIndex(ii, bi);
        },
        // deprecated
        removeLayer: function(ii) {
          return ie.console.error("[Viewer.removeLayer] this function is deprecated; use World.removeItem() instead."), this.world.removeItem(ii);
        },
        /**
         * Force the viewer to redraw its contents.
         * @returns {OpenSeadragon.Viewer} Chainable.
         */
        forceRedraw: function() {
          return Z[this.hash].forceRedraw = !0, this;
        },
        /**
         * @function
         * @return {OpenSeadragon.Viewer} Chainable.
         */
        bindSequenceControls: function() {
          var ii = ie.delegate(this, ot), bi = ie.delegate(this, lt), Gi = ie.delegate(this, Ws), Qi = ie.delegate(this, Vs), ns = this.navImages, Bs = !0;
          return this.showSequenceControl && ((this.previousButton || this.nextButton) && (Bs = !1), this.previousButton = new ie.Button({
            element: this.previousButton ? ie.getElement(this.previousButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: ie.getString("Tooltips.PreviousPage"),
            srcRest: gi(this.prefixUrl, ns.previous.REST),
            srcGroup: gi(this.prefixUrl, ns.previous.GROUP),
            srcHover: gi(this.prefixUrl, ns.previous.HOVER),
            srcDown: gi(this.prefixUrl, ns.previous.DOWN),
            onRelease: Qi,
            onFocus: ii,
            onBlur: bi
          }), this.nextButton = new ie.Button({
            element: this.nextButton ? ie.getElement(this.nextButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: ie.getString("Tooltips.NextPage"),
            srcRest: gi(this.prefixUrl, ns.next.REST),
            srcGroup: gi(this.prefixUrl, ns.next.GROUP),
            srcHover: gi(this.prefixUrl, ns.next.HOVER),
            srcDown: gi(this.prefixUrl, ns.next.DOWN),
            onRelease: Gi,
            onFocus: ii,
            onBlur: bi
          }), this.navPrevNextWrap || this.previousButton.disable(), (!this.tileSources || !this.tileSources.length) && this.nextButton.disable(), Bs && (this.paging = new ie.ButtonGroup({
            buttons: [
              this.previousButton,
              this.nextButton
            ],
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold
          }), this.pagingControl = this.paging.element, this.toolbar ? this.toolbar.addControl(
            this.pagingControl,
            { anchor: ie.ControlAnchor.BOTTOM_RIGHT }
          ) : this.addControl(
            this.pagingControl,
            { anchor: this.sequenceControlAnchor || ie.ControlAnchor.TOP_LEFT }
          ))), this;
        },
        /**
         * @function
         * @return {OpenSeadragon.Viewer} Chainable.
         */
        bindStandardControls: function() {
          var ii = ie.delegate(this, _i), bi = ie.delegate(this, hi), Gi = ie.delegate(this, rs), Qi = ie.delegate(this, Oi), ns = ie.delegate(this, Hi), Bs = ie.delegate(this, us), ms = ie.delegate(this, Yi), Ks = ie.delegate(this, is), Js = ie.delegate(this, Ss), Ns = ie.delegate(this, Gs), Ts = ie.delegate(this, ot), lo = ie.delegate(this, lt), Fs = this.navImages, xo = [], mo = !0;
          return this.showNavigationControl && ((this.zoomInButton || this.zoomOutButton || this.homeButton || this.fullPageButton || this.rotateLeftButton || this.rotateRightButton || this.flipButton) && (mo = !1), this.showZoomControl && (xo.push(this.zoomInButton = new ie.Button({
            element: this.zoomInButton ? ie.getElement(this.zoomInButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: ie.getString("Tooltips.ZoomIn"),
            srcRest: gi(this.prefixUrl, Fs.zoomIn.REST),
            srcGroup: gi(this.prefixUrl, Fs.zoomIn.GROUP),
            srcHover: gi(this.prefixUrl, Fs.zoomIn.HOVER),
            srcDown: gi(this.prefixUrl, Fs.zoomIn.DOWN),
            onPress: ii,
            onRelease: bi,
            onClick: Gi,
            onEnter: ii,
            onExit: bi,
            onFocus: Ts,
            onBlur: lo
          })), xo.push(this.zoomOutButton = new ie.Button({
            element: this.zoomOutButton ? ie.getElement(this.zoomOutButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: ie.getString("Tooltips.ZoomOut"),
            srcRest: gi(this.prefixUrl, Fs.zoomOut.REST),
            srcGroup: gi(this.prefixUrl, Fs.zoomOut.GROUP),
            srcHover: gi(this.prefixUrl, Fs.zoomOut.HOVER),
            srcDown: gi(this.prefixUrl, Fs.zoomOut.DOWN),
            onPress: Qi,
            onRelease: bi,
            onClick: ns,
            onEnter: Qi,
            onExit: bi,
            onFocus: Ts,
            onBlur: lo
          }))), this.showHomeControl && xo.push(this.homeButton = new ie.Button({
            element: this.homeButton ? ie.getElement(this.homeButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: ie.getString("Tooltips.Home"),
            srcRest: gi(this.prefixUrl, Fs.home.REST),
            srcGroup: gi(this.prefixUrl, Fs.home.GROUP),
            srcHover: gi(this.prefixUrl, Fs.home.HOVER),
            srcDown: gi(this.prefixUrl, Fs.home.DOWN),
            onRelease: Bs,
            onFocus: Ts,
            onBlur: lo
          })), this.showFullPageControl && xo.push(this.fullPageButton = new ie.Button({
            element: this.fullPageButton ? ie.getElement(this.fullPageButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: ie.getString("Tooltips.FullPage"),
            srcRest: gi(this.prefixUrl, Fs.fullpage.REST),
            srcGroup: gi(this.prefixUrl, Fs.fullpage.GROUP),
            srcHover: gi(this.prefixUrl, Fs.fullpage.HOVER),
            srcDown: gi(this.prefixUrl, Fs.fullpage.DOWN),
            onRelease: ms,
            onFocus: Ts,
            onBlur: lo
          })), this.showRotationControl && (xo.push(this.rotateLeftButton = new ie.Button({
            element: this.rotateLeftButton ? ie.getElement(this.rotateLeftButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: ie.getString("Tooltips.RotateLeft"),
            srcRest: gi(this.prefixUrl, Fs.rotateleft.REST),
            srcGroup: gi(this.prefixUrl, Fs.rotateleft.GROUP),
            srcHover: gi(this.prefixUrl, Fs.rotateleft.HOVER),
            srcDown: gi(this.prefixUrl, Fs.rotateleft.DOWN),
            onRelease: Ks,
            onFocus: Ts,
            onBlur: lo
          })), xo.push(this.rotateRightButton = new ie.Button({
            element: this.rotateRightButton ? ie.getElement(this.rotateRightButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: ie.getString("Tooltips.RotateRight"),
            srcRest: gi(this.prefixUrl, Fs.rotateright.REST),
            srcGroup: gi(this.prefixUrl, Fs.rotateright.GROUP),
            srcHover: gi(this.prefixUrl, Fs.rotateright.HOVER),
            srcDown: gi(this.prefixUrl, Fs.rotateright.DOWN),
            onRelease: Js,
            onFocus: Ts,
            onBlur: lo
          }))), this.showFlipControl && xo.push(this.flipButton = new ie.Button({
            element: this.flipButton ? ie.getElement(this.flipButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: ie.getString("Tooltips.Flip"),
            srcRest: gi(this.prefixUrl, Fs.flip.REST),
            srcGroup: gi(this.prefixUrl, Fs.flip.GROUP),
            srcHover: gi(this.prefixUrl, Fs.flip.HOVER),
            srcDown: gi(this.prefixUrl, Fs.flip.DOWN),
            onRelease: Ns,
            onFocus: Ts,
            onBlur: lo
          })), mo && (this.buttons = new ie.ButtonGroup({
            buttons: xo,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold
          }), this.navControl = this.buttons.element, this.addHandler("open", ie.delegate(this, qi)), this.toolbar ? this.toolbar.addControl(
            this.navControl,
            { anchor: this.navigationControlAnchor || ie.ControlAnchor.TOP_LEFT }
          ) : this.addControl(
            this.navControl,
            { anchor: this.navigationControlAnchor || ie.ControlAnchor.TOP_LEFT }
          ))), this;
        },
        /**
         * Gets the active page of a sequence
         * @function
         * @return {Number}
         */
        currentPage: function() {
          return this._sequenceIndex;
        },
        /**
         * @function
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:page
         */
        goToPage: function(ii) {
          return this.tileSources && ii >= 0 && ii < this.tileSources.length && (this._sequenceIndex = ii, this._updateSequenceButtons(ii), this.open(this.tileSources[ii]), this.referenceStrip && this.referenceStrip.setFocus(ii), this.raiseEvent("page", { page: ii })), this;
        },
        /**
          * Adds an html element as an overlay to the current viewport.  Useful for
          * highlighting words or areas of interest on an image or other zoomable
          * interface. The overlays added via this method are removed when the viewport
          * is closed which include when changing page.
          * @method
          * @param {Element|String|Object} element - A reference to an element or an id for
          *      the element which will be overlaid. Or an Object specifying the configuration for the overlay.
          *      If using an object, see {@link OpenSeadragon.Overlay} for a list of
          *      all available options.
          * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
          *      rectangle which will be overlaid. This is a viewport relative location.
          * @param {OpenSeadragon.Placement} [placement=OpenSeadragon.Placement.TOP_LEFT] - The position of the
          *      viewport which the location coordinates will be treated as relative
          *      to.
          * @param {function} [onDraw] - If supplied the callback is called when the overlay
          *      needs to be drawn. It it the responsibility of the callback to do any drawing/positioning.
          *      It is passed position, size and element.
          * @return {OpenSeadragon.Viewer} Chainable.
          * @fires OpenSeadragon.Viewer.event:add-overlay
          */
        addOverlay: function(ii, bi, Gi, Qi) {
          var ns;
          if (ie.isPlainObject(ii) ? ns = ii : ns = {
            element: ii,
            location: bi,
            placement: Gi,
            onDraw: Qi
          }, ii = ie.getElement(ns.element), be(this.currentOverlays, ii) >= 0)
            return this;
          var Bs = ye(this, ns);
          return this.currentOverlays.push(Bs), Bs.drawHTML(this.overlaysContainer, this.viewport), this.raiseEvent("add-overlay", {
            element: ii,
            location: ns.location,
            placement: ns.placement
          }), this;
        },
        /**
         * Updates the overlay represented by the reference to the element or
         * element id moving it to the new location, relative to the new placement.
         * @method
         * @param {Element|String} element - A reference to an element or an id for
         *      the element which is overlaid.
         * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
         *      rectangle which will be overlaid. This is a viewport relative location.
         * @param {OpenSeadragon.Placement} [placement=OpenSeadragon.Placement.TOP_LEFT] - The position of the
         *      viewport which the location coordinates will be treated as relative
         *      to.
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:update-overlay
         */
        updateOverlay: function(ii, bi, Gi) {
          var Qi;
          return ii = ie.getElement(ii), Qi = be(this.currentOverlays, ii), Qi >= 0 && (this.currentOverlays[Qi].update(bi, Gi), Z[this.hash].forceRedraw = !0, this.raiseEvent("update-overlay", {
            element: ii,
            location: bi,
            placement: Gi
          })), this;
        },
        /**
         * Removes an overlay identified by the reference element or element id
         * and schedules an update.
         * @method
         * @param {Element|String} element - A reference to the element or an
         *      element id which represent the ovelay content to be removed.
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:remove-overlay
         */
        removeOverlay: function(ii) {
          var bi;
          return ii = ie.getElement(ii), bi = be(this.currentOverlays, ii), bi >= 0 && (this.currentOverlays[bi].destroy(), this.currentOverlays.splice(bi, 1), Z[this.hash].forceRedraw = !0, this.raiseEvent("remove-overlay", {
            element: ii
          })), this;
        },
        /**
         * Removes all currently configured Overlays from this Viewer and schedules
         * an update.
         * @method
         * @return {OpenSeadragon.Viewer} Chainable.
         * @fires OpenSeadragon.Viewer.event:clear-overlay
         */
        clearOverlays: function() {
          for (; this.currentOverlays.length > 0; )
            this.currentOverlays.pop().destroy();
          return Z[this.hash].forceRedraw = !0, this.raiseEvent("clear-overlay", {}), this;
        },
        /**
        * Finds an overlay identified by the reference element or element id
        * and returns it as an object, return null if not found.
        * @method
        * @param {Element|String} element - A reference to the element or an
        *      element id which represents the overlay content.
        * @return {OpenSeadragon.Overlay} the matching overlay or null if none found.
        */
        getOverlayById: function(ii) {
          var bi;
          return ii = ie.getElement(ii), bi = be(this.currentOverlays, ii), bi >= 0 ? this.currentOverlays[bi] : null;
        },
        /**
         * Updates the sequence buttons.
         * @function OpenSeadragon.Viewer.prototype._updateSequenceButtons
         * @private
         * @param {Number} Sequence Value
         */
        _updateSequenceButtons: function(ii) {
          this.nextButton && (!this.tileSources || this.tileSources.length - 1 === ii ? this.navPrevNextWrap || this.nextButton.disable() : this.nextButton.enable()), this.previousButton && (ii > 0 ? this.previousButton.enable() : this.navPrevNextWrap || this.previousButton.disable());
        },
        /**
         * Display a message in the viewport
         * @function OpenSeadragon.Viewer.prototype._showMessage
         * @private
         * @param {String} text message
         */
        _showMessage: function(ii) {
          this._hideMessage();
          var bi = ie.makeNeutralElement("div");
          bi.appendChild(document.createTextNode(ii)), this.messageDiv = ie.makeCenteredNode(bi), ie.addClass(this.messageDiv, "openseadragon-message"), this.container.appendChild(this.messageDiv);
        },
        /**
         * Hide any currently displayed viewport message
         * @function OpenSeadragon.Viewer.prototype._hideMessage
         * @private
         */
        _hideMessage: function() {
          var ii = this.messageDiv;
          ii && (ii.parentNode.removeChild(ii), delete this.messageDiv);
        },
        /**
         * Gets this viewer's gesture settings for the given pointer device type.
         * @method
         * @param {String} type - The pointer device type to get the gesture settings for ("mouse", "touch", "pen", etc.).
         * @return {OpenSeadragon.GestureSettings}
         */
        gestureSettingsByDeviceType: function(ii) {
          switch (ii) {
            case "mouse":
              return this.gestureSettingsMouse;
            case "touch":
              return this.gestureSettingsTouch;
            case "pen":
              return this.gestureSettingsPen;
            default:
              return this.gestureSettingsUnknown;
          }
        },
        // private
        _drawOverlays: function() {
          var ii, bi = this.currentOverlays.length;
          for (ii = 0; ii < bi; ii++)
            this.currentOverlays[ii].drawHTML(this.overlaysContainer, this.viewport);
        },
        /**
         * Cancel the "in flight" images.
         */
        _cancelPendingImages: function() {
          this._loadQueue = [];
        },
        /**
         * Removes the reference strip and disables displaying it.
         * @function
         */
        removeReferenceStrip: function() {
          this.showReferenceStrip = !1, this.referenceStrip && (this.referenceStrip.destroy(), this.referenceStrip = null);
        },
        /**
         * Enables and displays the reference strip based on the currently set tileSources.
         * Works only when the Viewer has sequenceMode set to true.
         * @function
         */
        addReferenceStrip: function() {
          if (this.showReferenceStrip = !0, this.sequenceMode) {
            if (this.referenceStrip)
              return;
            this.tileSources.length && this.tileSources.length > 1 && (this.referenceStrip = new ie.ReferenceStrip({
              id: this.referenceStripElement,
              position: this.referenceStripPosition,
              sizeRatio: this.referenceStripSizeRatio,
              scroll: this.referenceStripScroll,
              height: this.referenceStripHeight,
              width: this.referenceStripWidth,
              tileSources: this.tileSources,
              prefixUrl: this.prefixUrl,
              useCanvas: this.useCanvas,
              viewer: this
            }), this.referenceStrip.setFocus(this._sequenceIndex));
          } else
            ie.console.warn('Attempting to display a reference strip while "sequenceMode" is off.');
        }
      }
    );
    function ae(ii) {
      return ii = ie.getElement(ii), new ie.Point(
        ii.clientWidth === 0 ? 1 : ii.clientWidth,
        ii.clientHeight === 0 ? 1 : ii.clientHeight
      );
    }
    function ve(ii, bi, Gi, Qi, ns) {
      var Bs = ii;
      if (ie.type(bi) == "string") {
        if (bi.match(/^\s*<.*>\s*$/))
          bi = ie.parseXml(bi);
        else if (bi.match(/^\s*[\{\[].*[\}\]]\s*$/))
          try {
            var ms = ie.parseJSON(bi);
            bi = ms;
          } catch {
          }
      }
      function Ks(Js, Ns) {
        Js.ready ? Qi(Js) : (Js.addHandler("ready", function() {
          Qi(Js);
        }), Js.addHandler("open-failed", function(Ts) {
          ns({
            message: Ts.message,
            source: Ns
          });
        }));
      }
      setTimeout(function() {
        if (ie.type(bi) == "string")
          bi = new ie.TileSource({
            url: bi,
            crossOriginPolicy: Gi.crossOriginPolicy !== void 0 ? Gi.crossOriginPolicy : ii.crossOriginPolicy,
            ajaxWithCredentials: ii.ajaxWithCredentials,
            ajaxHeaders: ii.ajaxHeaders,
            useCanvas: ii.useCanvas,
            success: function(lo) {
              Qi(lo.tileSource);
            }
          }), bi.addHandler("open-failed", function(lo) {
            ns(lo);
          });
        else if (ie.isPlainObject(bi) || bi.nodeType)
          if (bi.crossOriginPolicy === void 0 && (Gi.crossOriginPolicy !== void 0 || ii.crossOriginPolicy !== void 0) && (bi.crossOriginPolicy = Gi.crossOriginPolicy !== void 0 ? Gi.crossOriginPolicy : ii.crossOriginPolicy), bi.ajaxWithCredentials === void 0 && (bi.ajaxWithCredentials = ii.ajaxWithCredentials), bi.useCanvas === void 0 && (bi.useCanvas = ii.useCanvas), ie.isFunction(bi.getTileUrl)) {
            var Js = new ie.TileSource(bi);
            Js.getTileUrl = bi.getTileUrl, Qi(Js);
          } else {
            var Ns = ie.TileSource.determineType(Bs, bi);
            if (!Ns) {
              ns({
                message: "Unable to load TileSource",
                source: bi
              });
              return;
            }
            var Ts = Ns.prototype.configure.apply(Bs, [bi]);
            Ks(new Ns(Ts), bi);
          }
        else
          Ks(bi, bi);
      });
    }
    function ye(ii, bi) {
      if (bi instanceof ie.Overlay)
        return bi;
      var Gi = null;
      if (bi.element)
        Gi = ie.getElement(bi.element);
      else {
        var Qi = bi.id ? bi.id : "openseadragon-overlay-" + Math.floor(Math.random() * 1e7);
        Gi = ie.getElement(bi.id), Gi || (Gi = document.createElement("a"), Gi.href = "#/overlay/" + Qi), Gi.id = Qi, ie.addClass(
          Gi,
          bi.className ? bi.className : "openseadragon-overlay"
        );
      }
      var ns = bi.location, Bs = bi.width, ms = bi.height;
      if (!ns) {
        var Ks = bi.x, Js = bi.y;
        if (bi.px !== void 0) {
          var Ns = ii.viewport.imageToViewportRectangle(new ie.Rect(
            bi.px,
            bi.py,
            Bs || 0,
            ms || 0
          ));
          Ks = Ns.x, Js = Ns.y, Bs = Bs !== void 0 ? Ns.width : void 0, ms = ms !== void 0 ? Ns.height : void 0;
        }
        ns = new ie.Point(Ks, Js);
      }
      var Ts = bi.placement;
      return Ts && ie.type(Ts) === "string" && (Ts = ie.Placement[bi.placement.toUpperCase()]), new ie.Overlay({
        element: Gi,
        location: ns,
        placement: Ts,
        onDraw: bi.onDraw,
        checkResize: bi.checkResize,
        width: Bs,
        height: ms,
        rotationMode: bi.rotationMode
      });
    }
    function be(ii, bi) {
      var Gi;
      for (Gi = ii.length - 1; Gi >= 0; Gi--)
        if (ii[Gi].element === bi)
          return Gi;
      return -1;
    }
    function Ye(ii, bi) {
      return ie.requestAnimationFrame(function() {
        bi(ii);
      });
    }
    function Qe(ii) {
      ie.requestAnimationFrame(function() {
        nt(ii);
      });
    }
    function Je(ii) {
      ii.autoHideControls && (ii.controlsShouldFade = !0, ii.controlsFadeBeginTime = ie.now() + ii.controlsFadeDelay, window.setTimeout(function() {
        Qe(ii);
      }, ii.controlsFadeDelay));
    }
    function nt(ii) {
      var bi, Gi, Qi, ns;
      if (ii.controlsShouldFade) {
        for (bi = ie.now(), Gi = bi - ii.controlsFadeBeginTime, Qi = 1 - Gi / ii.controlsFadeLength, Qi = Math.min(1, Qi), Qi = Math.max(0, Qi), ns = ii.controls.length - 1; ns >= 0; ns--)
          ii.controls[ns].autoFade && ii.controls[ns].setOpacity(Qi);
        Qi > 0 && Qe(ii);
      }
    }
    function st(ii) {
      var bi;
      for (ii.controlsShouldFade = !1, bi = ii.controls.length - 1; bi >= 0; bi--)
        ii.controls[bi].setOpacity(1);
    }
    function ot() {
      st(this);
    }
    function lt() {
      Je(this);
    }
    function ft(ii) {
      var bi = {
        originalEvent: ii.originalEvent,
        preventDefaultAction: ii.preventDefaultAction,
        preventVerticalPan: ii.preventVerticalPan,
        preventHorizontalPan: ii.preventHorizontalPan
      };
      if (this.raiseEvent("canvas-key", bi), !bi.preventDefaultAction && !ii.ctrl && !ii.alt && !ii.meta)
        switch (ii.keyCode) {
          case 38:
            return bi.preventVerticalPan || (ii.shift ? this.viewport.zoomBy(1.1) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new ie.Point(0, -this.pixelsPerArrowPress))), this.viewport.applyConstraints()), !1;
          case 40:
            return bi.preventVerticalPan || (ii.shift ? this.viewport.zoomBy(0.9) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new ie.Point(0, this.pixelsPerArrowPress))), this.viewport.applyConstraints()), !1;
          case 37:
            return bi.preventHorizontalPan || (this.viewport.panBy(this.viewport.deltaPointsFromPixels(new ie.Point(-this.pixelsPerArrowPress, 0))), this.viewport.applyConstraints()), !1;
          case 39:
            return bi.preventHorizontalPan || (this.viewport.panBy(this.viewport.deltaPointsFromPixels(new ie.Point(this.pixelsPerArrowPress, 0))), this.viewport.applyConstraints()), !1;
          default:
            return !0;
        }
      else
        return !0;
    }
    function gt(ii) {
      var bi = {
        originalEvent: ii.originalEvent,
        preventDefaultAction: ii.preventDefaultAction,
        preventVerticalPan: ii.preventVerticalPan,
        preventHorizontalPan: ii.preventHorizontalPan
      };
      if (this.raiseEvent("canvas-key", bi), !bi.preventDefaultAction && !ii.ctrl && !ii.alt && !ii.meta)
        switch (ii.keyCode) {
          case 43:
          case 61:
            return this.viewport.zoomBy(1.1), this.viewport.applyConstraints(), !1;
          case 45:
            return this.viewport.zoomBy(0.9), this.viewport.applyConstraints(), !1;
          case 48:
            return this.viewport.goHome(), this.viewport.applyConstraints(), !1;
          case 119:
          case 87:
            return bi.preventVerticalPan || (ii.shift ? this.viewport.zoomBy(1.1) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new ie.Point(0, -40))), this.viewport.applyConstraints()), !1;
          case 115:
          case 83:
            return bi.preventVerticalPan || (ii.shift ? this.viewport.zoomBy(0.9) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new ie.Point(0, 40))), this.viewport.applyConstraints()), !1;
          case 97:
            return bi.preventHorizontalPan || (this.viewport.panBy(this.viewport.deltaPointsFromPixels(new ie.Point(-40, 0))), this.viewport.applyConstraints()), !1;
          case 100:
            return bi.preventHorizontalPan || (this.viewport.panBy(this.viewport.deltaPointsFromPixels(new ie.Point(40, 0))), this.viewport.applyConstraints()), !1;
          case 114:
            return this.viewport.flipped ? this.viewport.setRotation(ie.positiveModulo(this.viewport.degrees - this.rotationIncrement, 360)) : this.viewport.setRotation(ie.positiveModulo(this.viewport.degrees + this.rotationIncrement, 360)), this.viewport.applyConstraints(), !1;
          case 82:
            return this.viewport.flipped ? this.viewport.setRotation(ie.positiveModulo(this.viewport.degrees + this.rotationIncrement, 360)) : this.viewport.setRotation(ie.positiveModulo(this.viewport.degrees - this.rotationIncrement, 360)), this.viewport.applyConstraints(), !1;
          case 102:
            return this.viewport.toggleFlip(), !1;
          default:
            return !0;
        }
      else
        return !0;
    }
    function ct(ii) {
      var bi, Gi = document.activeElement == this.canvas;
      Gi || this.canvas.focus(), this.viewport.flipped && (ii.position.x = this.viewport.getContainerSize().x - ii.position.x);
      var Qi = {
        tracker: ii.eventSource,
        position: ii.position,
        quick: ii.quick,
        shift: ii.shift,
        originalEvent: ii.originalEvent,
        preventDefaultAction: ii.preventDefaultAction
      };
      this.raiseEvent("canvas-click", Qi), !Qi.preventDefaultAction && this.viewport && ii.quick && (bi = this.gestureSettingsByDeviceType(ii.pointerType), bi.clickToZoom && (this.viewport.zoomBy(
        ii.shift ? 1 / this.zoomPerClick : this.zoomPerClick,
        bi.zoomToRefPoint ? this.viewport.pointFromPixel(ii.position, !0) : null
      ), this.viewport.applyConstraints()));
    }
    function _r(ii) {
      var bi, Gi = {
        tracker: ii.eventSource,
        position: ii.position,
        shift: ii.shift,
        originalEvent: ii.originalEvent,
        preventDefaultAction: ii.preventDefaultAction
      };
      this.raiseEvent("canvas-double-click", Gi), !Gi.preventDefaultAction && this.viewport && (bi = this.gestureSettingsByDeviceType(ii.pointerType), bi.dblClickToZoom && (this.viewport.zoomBy(
        ii.shift ? 1 / this.zoomPerClick : this.zoomPerClick,
        bi.zoomToRefPoint ? this.viewport.pointFromPixel(ii.position, !0) : null
      ), this.viewport.applyConstraints()));
    }
    function Kr(ii) {
      var bi, Gi = {
        tracker: ii.eventSource,
        position: ii.position,
        delta: ii.delta,
        speed: ii.speed,
        direction: ii.direction,
        shift: ii.shift,
        originalEvent: ii.originalEvent,
        preventDefaultAction: ii.preventDefaultAction
      };
      if (this.raiseEvent("canvas-drag", Gi), !Gi.preventDefaultAction && this.viewport) {
        if (bi = this.gestureSettingsByDeviceType(ii.pointerType), this.panHorizontal || (ii.delta.x = 0), this.panVertical || (ii.delta.y = 0), this.viewport.flipped && (ii.delta.x = -ii.delta.x), this.constrainDuringPan) {
          var Qi = this.viewport.deltaPointsFromPixels(ii.delta.negate());
          this.viewport.centerSpringX.target.value += Qi.x, this.viewport.centerSpringY.target.value += Qi.y;
          var ns = this.viewport.getBounds(), Bs = this.viewport.getConstrainedBounds();
          this.viewport.centerSpringX.target.value -= Qi.x, this.viewport.centerSpringY.target.value -= Qi.y, ns.x != Bs.x && (ii.delta.x = 0), ns.y != Bs.y && (ii.delta.y = 0);
        }
        this.viewport.panBy(this.viewport.deltaPointsFromPixels(ii.delta.negate()), bi.flickEnabled && !this.constrainDuringPan);
      }
    }
    function Xr(ii) {
      if (!ii.preventDefaultAction && this.viewport) {
        var bi = this.gestureSettingsByDeviceType(ii.pointerType);
        if (bi.flickEnabled && ii.speed >= bi.flickMinSpeed) {
          var Gi = 0;
          this.panHorizontal && (Gi = bi.flickMomentum * ii.speed * Math.cos(ii.direction));
          var Qi = 0;
          this.panVertical && (Qi = bi.flickMomentum * ii.speed * Math.sin(ii.direction));
          var ns = this.viewport.pixelFromPoint(
            this.viewport.getCenter(!0)
          ), Bs = this.viewport.pointFromPixel(
            new ie.Point(ns.x - Gi, ns.y - Qi)
          );
          this.viewport.panTo(Bs, !1);
        }
        this.viewport.applyConstraints();
      }
      this.raiseEvent("canvas-drag-end", {
        tracker: ii.eventSource,
        position: ii.position,
        speed: ii.speed,
        direction: ii.direction,
        shift: ii.shift,
        originalEvent: ii.originalEvent
      });
    }
    function Jr(ii) {
      this.raiseEvent("canvas-enter", {
        tracker: ii.eventSource,
        pointerType: ii.pointerType,
        position: ii.position,
        buttons: ii.buttons,
        pointers: ii.pointers,
        insideElementPressed: ii.insideElementPressed,
        buttonDownAny: ii.buttonDownAny,
        originalEvent: ii.originalEvent
      });
    }
    function ei(ii) {
      window.location != window.parent.location && ie.MouseTracker.resetAllMouseTrackers(), this.raiseEvent("canvas-exit", {
        tracker: ii.eventSource,
        pointerType: ii.pointerType,
        position: ii.position,
        buttons: ii.buttons,
        pointers: ii.pointers,
        insideElementPressed: ii.insideElementPressed,
        buttonDownAny: ii.buttonDownAny,
        originalEvent: ii.originalEvent
      });
    }
    function si(ii) {
      this.raiseEvent("canvas-press", {
        tracker: ii.eventSource,
        pointerType: ii.pointerType,
        position: ii.position,
        insideElementPressed: ii.insideElementPressed,
        insideElementReleased: ii.insideElementReleased,
        originalEvent: ii.originalEvent
      });
    }
    function ri(ii) {
      this.raiseEvent("canvas-release", {
        tracker: ii.eventSource,
        pointerType: ii.pointerType,
        position: ii.position,
        insideElementPressed: ii.insideElementPressed,
        insideElementReleased: ii.insideElementReleased,
        originalEvent: ii.originalEvent
      });
    }
    function ai(ii) {
      this.raiseEvent("canvas-nonprimary-press", {
        tracker: ii.eventSource,
        position: ii.position,
        pointerType: ii.pointerType,
        button: ii.button,
        buttons: ii.buttons,
        originalEvent: ii.originalEvent
      });
    }
    function yi(ii) {
      this.raiseEvent("canvas-nonprimary-release", {
        tracker: ii.eventSource,
        position: ii.position,
        pointerType: ii.pointerType,
        button: ii.button,
        buttons: ii.buttons,
        originalEvent: ii.originalEvent
      });
    }
    function pi(ii) {
      var bi, Gi, Qi, ns;
      if (!ii.preventDefaultAction && this.viewport && (bi = this.gestureSettingsByDeviceType(ii.pointerType), bi.pinchToZoom && (Gi = this.viewport.pointFromPixel(ii.center, !0), Qi = this.viewport.pointFromPixel(ii.lastCenter, !0), ns = Qi.minus(Gi), this.panHorizontal || (ns.x = 0), this.panVertical || (ns.y = 0), this.viewport.zoomBy(ii.distance / ii.lastDistance, Gi, !0), bi.zoomToRefPoint && this.viewport.panBy(ns, !0), this.viewport.applyConstraints()), bi.pinchRotate)) {
        var Bs = Math.atan2(
          ii.gesturePoints[0].currentPos.y - ii.gesturePoints[1].currentPos.y,
          ii.gesturePoints[0].currentPos.x - ii.gesturePoints[1].currentPos.x
        ), ms = Math.atan2(
          ii.gesturePoints[0].lastPos.y - ii.gesturePoints[1].lastPos.y,
          ii.gesturePoints[0].lastPos.x - ii.gesturePoints[1].lastPos.x
        );
        this.viewport.setRotation(this.viewport.getRotation() + (Bs - ms) * (180 / Math.PI));
      }
      return this.raiseEvent("canvas-pinch", {
        tracker: ii.eventSource,
        gesturePoints: ii.gesturePoints,
        lastCenter: ii.lastCenter,
        center: ii.center,
        lastDistance: ii.lastDistance,
        distance: ii.distance,
        shift: ii.shift,
        originalEvent: ii.originalEvent
      }), !1;
    }
    function di(ii) {
      var bi, Gi, Qi, ns;
      if (Qi = ie.now(), ns = Qi - this._lastScrollTime, ns > this.minScrollDeltaTime) {
        if (this._lastScrollTime = Qi, this.viewport.flipped && (ii.position.x = this.viewport.getContainerSize().x - ii.position.x), !ii.preventDefaultAction && this.viewport && (bi = this.gestureSettingsByDeviceType(ii.pointerType), bi.scrollToZoom && (Gi = Math.pow(this.zoomPerScroll, ii.scroll), this.viewport.zoomBy(
          Gi,
          bi.zoomToRefPoint ? this.viewport.pointFromPixel(ii.position, !0) : null
        ), this.viewport.applyConstraints())), this.raiseEvent("canvas-scroll", {
          tracker: ii.eventSource,
          position: ii.position,
          scroll: ii.scroll,
          shift: ii.shift,
          originalEvent: ii.originalEvent
        }), bi && bi.scrollToZoom)
          return !1;
      } else if (bi = this.gestureSettingsByDeviceType(ii.pointerType), bi && bi.scrollToZoom)
        return !1;
    }
    function xi(ii) {
      Z[this.hash].mouseInside = !0, st(this), this.raiseEvent("container-enter", {
        tracker: ii.eventSource,
        position: ii.position,
        buttons: ii.buttons,
        pointers: ii.pointers,
        insideElementPressed: ii.insideElementPressed,
        buttonDownAny: ii.buttonDownAny,
        originalEvent: ii.originalEvent
      });
    }
    function Ti(ii) {
      ii.pointers < 1 && (Z[this.hash].mouseInside = !1, Z[this.hash].animating || Je(this)), this.raiseEvent("container-exit", {
        tracker: ii.eventSource,
        position: ii.position,
        buttons: ii.buttons,
        pointers: ii.pointers,
        insideElementPressed: ii.insideElementPressed,
        buttonDownAny: ii.buttonDownAny,
        originalEvent: ii.originalEvent
      });
    }
    function Ai(ii) {
      mi(ii), ii.isOpen() ? ii._updateRequestId = Ye(ii, Ai) : ii._updateRequestId = !1;
    }
    function mi(ii) {
      if (!ii._opening) {
        if (ii.autoResize) {
          var bi = ae(ii.container), Gi = Z[ii.hash].prevContainerSize;
          if (!bi.equals(Gi)) {
            var Qi = ii.viewport;
            if (ii.preserveImageSizeOnResize) {
              var ns = Gi.x / bi.x, Bs = Qi.getZoom() * ns, ms = Qi.getCenter();
              Qi.resize(bi, !1), Qi.zoomTo(Bs, null, !0), Qi.panTo(ms, !0);
            } else {
              var Ks = Qi.getBounds();
              Qi.resize(bi, !0), Qi.fitBoundsWithConstraints(Ks, !0);
            }
            Z[ii.hash].prevContainerSize = bi, Z[ii.hash].forceRedraw = !0;
          }
        }
        var Js = ii.viewport.update(), Ns = ii.world.update() || Js;
        Js && ii.raiseEvent("viewport-change"), ii.referenceStrip && (Ns = ii.referenceStrip.update(ii.viewport) || Ns), !Z[ii.hash].animating && Ns && (ii.raiseEvent("animation-start"), st(ii)), (Ns || Z[ii.hash].forceRedraw || ii.world.needsDraw()) && (Si(ii), ii._drawOverlays(), ii.navigator && ii.navigator.update(ii.viewport), Z[ii.hash].forceRedraw = !1, Ns && ii.raiseEvent("animation")), Z[ii.hash].animating && !Ns && (ii.raiseEvent("animation-finish"), Z[ii.hash].mouseInside || Je(ii)), Z[ii.hash].animating = Ns;
      }
    }
    function Si(ii) {
      ii.imageLoader.clear(), ii.drawer.clear(), ii.world.draw(), ii.raiseEvent("update-viewport", {});
    }
    function gi(ii, bi) {
      return ii ? ii + bi : bi;
    }
    function _i() {
      Z[this.hash].lastZoomTime = ie.now(), Z[this.hash].zoomFactor = this.zoomPerSecond, Z[this.hash].zooming = !0, Di(this);
    }
    function Oi() {
      Z[this.hash].lastZoomTime = ie.now(), Z[this.hash].zoomFactor = 1 / this.zoomPerSecond, Z[this.hash].zooming = !0, Di(this);
    }
    function hi() {
      Z[this.hash].zooming = !1;
    }
    function Di(ii) {
      ie.requestAnimationFrame(ie.delegate(ii, Ri));
    }
    function Ri() {
      var ii, bi, Gi;
      Z[this.hash].zooming && this.viewport && (ii = ie.now(), bi = ii - Z[this.hash].lastZoomTime, Gi = Math.pow(Z[this.hash].zoomFactor, bi / 1e3), this.viewport.zoomBy(Gi), this.viewport.applyConstraints(), Z[this.hash].lastZoomTime = ii, Di(this));
    }
    function rs() {
      this.viewport && (Z[this.hash].zooming = !1, this.viewport.zoomBy(
        this.zoomPerClick / 1
      ), this.viewport.applyConstraints());
    }
    function Hi() {
      this.viewport && (Z[this.hash].zooming = !1, this.viewport.zoomBy(
        1 / this.zoomPerClick
      ), this.viewport.applyConstraints());
    }
    function qi() {
      this.buttons.emulateEnter(), this.buttons.emulateExit();
    }
    function us() {
      this.viewport && this.viewport.goHome();
    }
    function Yi() {
      this.isFullPage() && !ie.isFullScreen() ? this.setFullPage(!1) : this.setFullScreen(!this.isFullPage()), this.buttons && this.buttons.emulateExit(), this.fullPageButton.element.focus(), this.viewport && this.viewport.applyConstraints();
    }
    function is() {
      if (this.viewport) {
        var ii = this.viewport.getRotation();
        this.viewport.flipped ? ii = ie.positiveModulo(ii + this.rotationIncrement, 360) : ii = ie.positiveModulo(ii - this.rotationIncrement, 360), this.viewport.setRotation(ii);
      }
    }
    function Ss() {
      if (this.viewport) {
        var ii = this.viewport.getRotation();
        this.viewport.flipped ? ii = ie.positiveModulo(ii - this.rotationIncrement, 360) : ii = ie.positiveModulo(ii + this.rotationIncrement, 360), this.viewport.setRotation(ii);
      }
    }
    function Gs() {
      this.viewport.toggleFlip();
    }
    function Vs() {
      var ii = this._sequenceIndex - 1;
      this.navPrevNextWrap && ii < 0 && (ii += this.tileSources.length), this.goToPage(ii);
    }
    function Ws() {
      var ii = this._sequenceIndex + 1;
      this.navPrevNextWrap && ii >= this.tileSources.length && (ii = 0), this.goToPage(ii);
    }
  }(OpenSeadragon), function(ie) {
    ie.Navigator = function(Ye) {
      var Qe = Ye.viewer, Je = this, nt, st;
      Ye.id ? (this.element = document.getElementById(Ye.id), Ye.controlOptions = {
        anchor: ie.ControlAnchor.NONE,
        attachToViewer: !1,
        autoFade: !1
      }) : (Ye.id = "navigator-" + ie.now(), this.element = ie.makeNeutralElement("div"), Ye.controlOptions = {
        anchor: ie.ControlAnchor.TOP_RIGHT,
        attachToViewer: !0,
        autoFade: Ye.autoFade
      }, Ye.position && (Ye.position == "BOTTOM_RIGHT" ? Ye.controlOptions.anchor = ie.ControlAnchor.BOTTOM_RIGHT : Ye.position == "BOTTOM_LEFT" ? Ye.controlOptions.anchor = ie.ControlAnchor.BOTTOM_LEFT : Ye.position == "TOP_RIGHT" ? Ye.controlOptions.anchor = ie.ControlAnchor.TOP_RIGHT : Ye.position == "TOP_LEFT" ? Ye.controlOptions.anchor = ie.ControlAnchor.TOP_LEFT : Ye.position == "ABSOLUTE" && (Ye.controlOptions.anchor = ie.ControlAnchor.ABSOLUTE, Ye.controlOptions.top = Ye.top, Ye.controlOptions.left = Ye.left, Ye.controlOptions.height = Ye.height, Ye.controlOptions.width = Ye.width))), this.element.id = Ye.id, this.element.className += " navigator", Ye = ie.extend(!0, {
        sizeRatio: ie.DEFAULT_SETTINGS.navigatorSizeRatio
      }, Ye, {
        element: this.element,
        tabIndex: -1,
        // No keyboard navigation, omit from tab order
        //These need to be overridden to prevent recursion since
        //the navigator is a viewer and a viewer has a navigator
        showNavigator: !1,
        mouseNavEnabled: !1,
        showNavigationControl: !1,
        showSequenceControl: !1,
        immediateRender: !0,
        blendTime: 0,
        animationTime: 0,
        autoResize: Ye.autoResize,
        // prevent resizing the navigator from adding unwanted space around the image
        minZoomImageRatio: 1,
        background: Ye.background,
        opacity: Ye.opacity,
        borderColor: Ye.borderColor,
        displayRegionColor: Ye.displayRegionColor
      }), Ye.minPixelRatio = this.minPixelRatio = Qe.minPixelRatio, ie.setElementTouchActionNone(this.element), this.borderWidth = 2, this.fudge = new ie.Point(1, 1), this.totalBorderWidths = new ie.Point(this.borderWidth * 2, this.borderWidth * 2).minus(this.fudge), Ye.controlOptions.anchor != ie.ControlAnchor.NONE && function(ft, gt) {
        ft.margin = "0px", ft.border = gt + "px solid " + Ye.borderColor, ft.padding = "0px", ft.background = Ye.background, ft.opacity = Ye.opacity, ft.overflow = "hidden";
      }(this.element.style, this.borderWidth), this.displayRegion = ie.makeNeutralElement("div"), this.displayRegion.id = this.element.id + "-displayregion", this.displayRegion.className = "displayregion", function(ft, gt) {
        ft.position = "relative", ft.top = "0px", ft.left = "0px", ft.fontSize = "0px", ft.overflow = "hidden", ft.border = gt + "px solid " + Ye.displayRegionColor, ft.margin = "0px", ft.padding = "0px", ft.background = "transparent", ft.float = "left", ft.cssFloat = "left", ft.styleFloat = "left", ft.zIndex = 999999999, ft.cursor = "default";
      }(this.displayRegion.style, this.borderWidth), this.displayRegionContainer = ie.makeNeutralElement("div"), this.displayRegionContainer.id = this.element.id + "-displayregioncontainer", this.displayRegionContainer.className = "displayregioncontainer", this.displayRegionContainer.style.width = "100%", this.displayRegionContainer.style.height = "100%", Qe.addControl(
        this.element,
        Ye.controlOptions
      ), this._resizeWithViewer = Ye.controlOptions.anchor != ie.ControlAnchor.ABSOLUTE && Ye.controlOptions.anchor != ie.ControlAnchor.NONE, Ye.width && Ye.height ? (this.setWidth(Ye.width), this.setHeight(Ye.height)) : this._resizeWithViewer && (nt = ie.getElementSize(Qe.element), this.element.style.height = Math.round(nt.y * Ye.sizeRatio) + "px", this.element.style.width = Math.round(nt.x * Ye.sizeRatio) + "px", this.oldViewerSize = nt, st = ie.getElementSize(this.element), this.elementArea = st.x * st.y), this.oldContainerSize = new ie.Point(0, 0), ie.Viewer.apply(this, [Ye]), this.displayRegionContainer.appendChild(this.displayRegion), this.element.getElementsByTagName("div")[0].appendChild(this.displayRegionContainer);
      function ot(ft) {
        ye(Je.displayRegionContainer, ft), ye(Je.displayRegion, -ft), Je.viewport.setRotation(ft);
      }
      if (Ye.navigatorRotate) {
        var lt = Ye.viewer.viewport ? Ye.viewer.viewport.getRotation() : Ye.viewer.degrees || 0;
        ot(lt), Ye.viewer.addHandler("rotate", function(ft) {
          ot(ft.degrees);
        });
      }
      this.innerTracker.destroy(), this.innerTracker = new ie.MouseTracker({
        element: this.element,
        dragHandler: ie.delegate(this, ee),
        clickHandler: ie.delegate(this, Z),
        releaseHandler: ie.delegate(this, ae),
        scrollHandler: ie.delegate(this, ve)
      }), this.addHandler("reset-size", function() {
        Je.viewport && Je.viewport.goHome(!0);
      }), Qe.world.addHandler("item-index-change", function(ft) {
        window.setTimeout(function() {
          var gt = Je.world.getItemAt(ft.previousIndex);
          Je.world.setItemIndex(gt, ft.newIndex);
        }, 1);
      }), Qe.world.addHandler("remove-item", function(ft) {
        var gt = ft.item, ct = Je._getMatchingItem(gt);
        ct && Je.world.removeItem(ct);
      }), this.update(Qe.viewport);
    }, ie.extend(
      ie.Navigator.prototype,
      ie.EventSource.prototype,
      ie.Viewer.prototype,
      /** @lends OpenSeadragon.Navigator.prototype */
      {
        /**
         * Used to notify the navigator when its size has changed.
         * Especially useful when {@link OpenSeadragon.Options}.navigatorAutoResize is set to false and the navigator is resizable.
         * @function
         */
        updateSize: function() {
          if (this.viewport) {
            var Ye = new ie.Point(
              this.container.clientWidth === 0 ? 1 : this.container.clientWidth,
              this.container.clientHeight === 0 ? 1 : this.container.clientHeight
            );
            Ye.equals(this.oldContainerSize) || (this.viewport.resize(Ye, !0), this.viewport.goHome(!0), this.oldContainerSize = Ye, this.drawer.clear(), this.world.draw());
          }
        },
        /**
         * Explicitly sets the width of the navigator, in web coordinates. Disables automatic resizing.
         * @param {Number|String} width - the new width, either a number of pixels or a CSS string, such as "100%"
         */
        setWidth: function(Ye) {
          this.width = Ye, this.element.style.width = typeof Ye == "number" ? Ye + "px" : Ye, this._resizeWithViewer = !1;
        },
        /**
         * Explicitly sets the height of the navigator, in web coordinates. Disables automatic resizing.
         * @param {Number|String} height - the new height, either a number of pixels or a CSS string, such as "100%"
         */
        setHeight: function(Ye) {
          this.height = Ye, this.element.style.height = typeof Ye == "number" ? Ye + "px" : Ye, this._resizeWithViewer = !1;
        },
        /**
          * Flip navigator element
          * @param {Boolean} state - Flip state to set.
          */
        setFlip: function(Ye) {
          return this.viewport.setFlip(Ye), this.setDisplayTransform(this.viewer.viewport.getFlip() ? "scale(-1,1)" : "scale(1,1)"), this;
        },
        setDisplayTransform: function(Ye) {
          be(this.displayRegion, Ye), be(this.canvas, Ye), be(this.element, Ye);
        },
        /**
         * Used to update the navigator minimap's viewport rectangle when a change in the viewer's viewport occurs.
         * @function
         * @param {OpenSeadragon.Viewport} The viewport this navigator is tracking.
         */
        update: function(Ye) {
          var Qe, Je, nt, st, ot, lt;
          if (Qe = ie.getElementSize(this.viewer.element), this._resizeWithViewer && Qe.x && Qe.y && !Qe.equals(this.oldViewerSize) && (this.oldViewerSize = Qe, this.maintainSizeRatio || !this.elementArea ? (Je = Qe.x * this.sizeRatio, nt = Qe.y * this.sizeRatio) : (Je = Math.sqrt(this.elementArea * (Qe.x / Qe.y)), nt = this.elementArea / Je), this.element.style.width = Math.round(Je) + "px", this.element.style.height = Math.round(nt) + "px", this.elementArea || (this.elementArea = Je * nt), this.updateSize()), Ye && this.viewport) {
            st = Ye.getBoundsNoRotate(!0), ot = this.viewport.pixelFromPointNoRotate(st.getTopLeft(), !1), lt = this.viewport.pixelFromPointNoRotate(st.getBottomRight(), !1).minus(this.totalBorderWidths);
            var ft = this.displayRegion.style;
            ft.display = this.world.getItemCount() ? "block" : "none", ft.top = Math.round(ot.y) + "px", ft.left = Math.round(ot.x) + "px";
            var gt = Math.abs(ot.x - lt.x), ct = Math.abs(ot.y - lt.y);
            ft.width = Math.round(Math.max(gt, 0)) + "px", ft.height = Math.round(Math.max(ct, 0)) + "px";
          }
        },
        // overrides Viewer.addTiledImage
        addTiledImage: function(Ye) {
          var Qe = this, Je = Ye.originalTiledImage;
          delete Ye.original;
          var nt = ie.extend({}, Ye, {
            success: function(st) {
              var ot = st.item;
              ot._originalForNavigator = Je, Qe._matchBounds(ot, Je, !0);
              function lt() {
                Qe._matchBounds(ot, Je);
              }
              function ft() {
                Qe._matchOpacity(ot, Je);
              }
              function gt() {
                Qe._matchCompositeOperation(ot, Je);
              }
              Je.addHandler("bounds-change", lt), Je.addHandler("clip-change", lt), Je.addHandler("opacity-change", ft), Je.addHandler("composite-operation-change", gt);
            }
          });
          return ie.Viewer.prototype.addTiledImage.apply(this, [nt]);
        },
        // private
        _getMatchingItem: function(Ye) {
          for (var Qe = this.world.getItemCount(), Je, nt = 0; nt < Qe; nt++)
            if (Je = this.world.getItemAt(nt), Je._originalForNavigator === Ye)
              return Je;
          return null;
        },
        // private
        _matchBounds: function(Ye, Qe, Je) {
          var nt = Qe.getBoundsNoRotate();
          Ye.setPosition(nt.getTopLeft(), Je), Ye.setWidth(nt.width, Je), Ye.setRotation(Qe.getRotation(), Je), Ye.setClip(Qe.getClip());
        },
        // private
        _matchOpacity: function(Ye, Qe) {
          Ye.setOpacity(Qe.opacity);
        },
        // private
        _matchCompositeOperation: function(Ye, Qe) {
          Ye.setCompositeOperation(Qe.compositeOperation);
        }
      }
    );
    function Z(Ye) {
      var Qe = {
        tracker: Ye.eventSource,
        position: Ye.position,
        quick: Ye.quick,
        shift: Ye.shift,
        originalEvent: Ye.originalEvent,
        preventDefaultAction: Ye.preventDefaultAction
      };
      if (this.viewer.raiseEvent("navigator-click", Qe), !Qe.preventDefaultAction && Ye.quick && this.viewer.viewport && (this.panVertical || this.panHorizontal)) {
        this.viewer.viewport.flipped && (Ye.position.x = this.viewport.getContainerSize().x - Ye.position.x);
        var Je = this.viewport.pointFromPixel(Ye.position);
        this.panVertical ? this.panHorizontal || (Je.x = this.viewer.viewport.getCenter(!0).x) : Je.y = this.viewer.viewport.getCenter(!0).y, this.viewer.viewport.panTo(Je), this.viewer.viewport.applyConstraints();
      }
    }
    function ee(Ye) {
      var Qe = {
        tracker: Ye.eventSource,
        position: Ye.position,
        delta: Ye.delta,
        speed: Ye.speed,
        direction: Ye.direction,
        shift: Ye.shift,
        originalEvent: Ye.originalEvent,
        preventDefaultAction: Ye.preventDefaultAction
      };
      this.viewer.raiseEvent("navigator-drag", Qe), !Qe.preventDefaultAction && this.viewer.viewport && (this.panHorizontal || (Ye.delta.x = 0), this.panVertical || (Ye.delta.y = 0), this.viewer.viewport.flipped && (Ye.delta.x = -Ye.delta.x), this.viewer.viewport.panBy(
        this.viewport.deltaPointsFromPixels(
          Ye.delta
        )
      ), this.viewer.constrainDuringPan && this.viewer.viewport.applyConstraints());
    }
    function ae(Ye) {
      Ye.insideElementPressed && this.viewer.viewport && this.viewer.viewport.applyConstraints();
    }
    function ve(Ye) {
      return this.viewer.raiseEvent("navigator-scroll", {
        tracker: Ye.eventSource,
        position: Ye.position,
        scroll: Ye.scroll,
        shift: Ye.shift,
        originalEvent: Ye.originalEvent
      }), !1;
    }
    function ye(Ye, Qe) {
      be(Ye, "rotate(" + Qe + "deg)");
    }
    function be(Ye, Qe) {
      Ye.style.webkitTransform = Qe, Ye.style.mozTransform = Qe, Ye.style.msTransform = Qe, Ye.style.oTransform = Qe, Ye.style.transform = Qe;
    }
  }(OpenSeadragon), function(ie) {
    var Z = {
      Errors: {
        Dzc: "Sorry, we don't support Deep Zoom Collections!",
        Dzi: "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
        Xml: "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
        ImageFormat: "Sorry, we don't support {0}-based Deep Zoom Images.",
        Security: "It looks like a security restriction stopped us from loading this Deep Zoom Image.",
        Status: "This space unintentionally left blank ({0} {1}).",
        OpenFailed: "Unable to open {0}: {1}"
      },
      Tooltips: {
        FullPage: "Toggle full page",
        Home: "Go home",
        ZoomIn: "Zoom in",
        ZoomOut: "Zoom out",
        NextPage: "Next page",
        PreviousPage: "Previous page",
        RotateLeft: "Rotate left",
        RotateRight: "Rotate right",
        Flip: "Flip Horizontally"
      }
    };
    ie.extend(
      ie,
      /** @lends OpenSeadragon */
      {
        /**
         * @function
         * @param {String} property
         */
        getString: function(ee) {
          var ae = ee.split("."), ve = null, ye = arguments, be = Z, Ye;
          for (Ye = 0; Ye < ae.length - 1; Ye++)
            be = be[ae[Ye]] || {};
          return ve = be[ae[Ye]], typeof ve != "string" && (ie.console.log("Untranslated source string:", ee), ve = ""), ve.replace(/\{\d+\}/g, function(Qe) {
            var Je = parseInt(Qe.match(/\d+/), 10) + 1;
            return Je < ye.length ? ye[Je] : "";
          });
        },
        /**
         * @function
         * @param {String} property
         * @param {*} value
         */
        setString: function(ee, ae) {
          var ve = ee.split("."), ye = Z, be;
          for (be = 0; be < ve.length - 1; be++)
            ye[ve[be]] || (ye[ve[be]] = {}), ye = ye[ve[be]];
          ye[ve[be]] = ae;
        }
      }
    );
  }(OpenSeadragon), function(ie) {
    ie.Point = function(Z, ee) {
      this.x = typeof Z == "number" ? Z : 0, this.y = typeof ee == "number" ? ee : 0;
    }, ie.Point.prototype = {
      /**
       * @function
       * @returns {OpenSeadragon.Point} a duplicate of this Point
       */
      clone: function() {
        return new ie.Point(this.x, this.y);
      },
      /**
       * Add another Point to this point and return a new Point.
       * @function
       * @param {OpenSeadragon.Point} point The point to add vector components.
       * @returns {OpenSeadragon.Point} A new point representing the sum of the
       *  vector components
       */
      plus: function(Z) {
        return new ie.Point(
          this.x + Z.x,
          this.y + Z.y
        );
      },
      /**
       * Subtract another Point to this point and return a new Point.
       * @function
       * @param {OpenSeadragon.Point} point The point to subtract vector components.
       * @returns {OpenSeadragon.Point} A new point representing the subtraction of the
       *  vector components
       */
      minus: function(Z) {
        return new ie.Point(
          this.x - Z.x,
          this.y - Z.y
        );
      },
      /**
       * Multiply this point by a factor and return a new Point.
       * @function
       * @param {Number} factor The factor to multiply vector components.
       * @returns {OpenSeadragon.Point} A new point representing the multiplication
       *  of the vector components by the factor
       */
      times: function(Z) {
        return new ie.Point(
          this.x * Z,
          this.y * Z
        );
      },
      /**
       * Divide this point by a factor and return a new Point.
       * @function
       * @param {Number} factor The factor to divide vector components.
       * @returns {OpenSeadragon.Point} A new point representing the division of the
       *  vector components by the factor
       */
      divide: function(Z) {
        return new ie.Point(
          this.x / Z,
          this.y / Z
        );
      },
      /**
       * Compute the opposite of this point and return a new Point.
       * @function
       * @returns {OpenSeadragon.Point} A new point representing the opposite of the
       *  vector components
       */
      negate: function() {
        return new ie.Point(-this.x, -this.y);
      },
      /**
       * Compute the distance between this point and another point.
       * @function
       * @param {OpenSeadragon.Point} point The point to compute the distance with.
       * @returns {Number} The distance between the 2 points
       */
      distanceTo: function(Z) {
        return Math.sqrt(
          Math.pow(this.x - Z.x, 2) + Math.pow(this.y - Z.y, 2)
        );
      },
      /**
       * Compute the squared distance between this point and another point.
       * Useful for optimizing things like comparing distances.
       * @function
       * @param {OpenSeadragon.Point} point The point to compute the squared distance with.
       * @returns {Number} The squared distance between the 2 points
       */
      squaredDistanceTo: function(Z) {
        return Math.pow(this.x - Z.x, 2) + Math.pow(this.y - Z.y, 2);
      },
      /**
       * Apply a function to each coordinate of this point and return a new point.
       * @function
       * @param {function} func The function to apply to each coordinate.
       * @returns {OpenSeadragon.Point} A new point with the coordinates computed
       * by the specified function
       */
      apply: function(Z) {
        return new ie.Point(Z(this.x), Z(this.y));
      },
      /**
       * Check if this point is equal to another one.
       * @function
       * @param {OpenSeadragon.Point} point The point to compare this point with.
       * @returns {Boolean} true if they are equal, false otherwise.
       */
      equals: function(Z) {
        return Z instanceof ie.Point && this.x === Z.x && this.y === Z.y;
      },
      /**
       * Rotates the point around the specified pivot
       * From http://stackoverflow.com/questions/4465931/rotate-rectangle-around-a-point
       * @function
       * @param {Number} degress to rotate around the pivot.
       * @param {OpenSeadragon.Point} [pivot=(0,0)] Point around which to rotate.
       * Defaults to the origin.
       * @returns {OpenSeadragon.Point}. A new point representing the point rotated around the specified pivot
       */
      rotate: function(Z, ee) {
        ee = ee || new ie.Point(0, 0);
        var ae, ve;
        if (Z % 90 === 0) {
          var ye = ie.positiveModulo(Z, 360);
          switch (ye) {
            case 0:
              ae = 1, ve = 0;
              break;
            case 90:
              ae = 0, ve = 1;
              break;
            case 180:
              ae = -1, ve = 0;
              break;
            case 270:
              ae = 0, ve = -1;
              break;
          }
        } else {
          var be = Z * Math.PI / 180;
          ae = Math.cos(be), ve = Math.sin(be);
        }
        var Ye = ae * (this.x - ee.x) - ve * (this.y - ee.y) + ee.x, Qe = ve * (this.x - ee.x) + ae * (this.y - ee.y) + ee.y;
        return new ie.Point(Ye, Qe);
      },
      /**
       * Convert this point to a string in the format (x,y) where x and y are
       * rounded to the nearest integer.
       * @function
       * @returns {String} A string representation of this point.
       */
      toString: function() {
        return "(" + Math.round(this.x * 100) / 100 + "," + Math.round(this.y * 100) / 100 + ")";
      }
    };
  }(OpenSeadragon), function(ie) {
    ie.TileSource = function(ee, ae, ve, ye, be, Ye) {
      var Qe = this, Je = arguments, nt, st;
      if (ie.isPlainObject(ee) ? nt = ee : nt = {
        width: Je[0],
        height: Je[1],
        tileSize: Je[2],
        tileOverlap: Je[3],
        minLevel: Je[4],
        maxLevel: Je[5]
      }, ie.EventSource.call(this), ie.extend(!0, this, nt), !this.success) {
        for (st = 0; st < arguments.length; st++)
          if (ie.isFunction(arguments[st])) {
            this.success = arguments[st];
            break;
          }
      }
      this.success && this.addHandler("ready", function(ot) {
        Qe.success(ot);
      }), ie.type(arguments[0]) == "string" && (this.url = arguments[0]), this.url ? (this.aspectRatio = 1, this.dimensions = new ie.Point(10, 10), this._tileWidth = 0, this._tileHeight = 0, this.tileOverlap = 0, this.minLevel = 0, this.maxLevel = 0, this.ready = !1, this.getImageInfo(this.url)) : (this.ready = !0, this.aspectRatio = nt.width && nt.height ? nt.width / nt.height : 1, this.dimensions = new ie.Point(nt.width, nt.height), this.tileSize ? (this._tileWidth = this._tileHeight = this.tileSize, delete this.tileSize) : (this.tileWidth ? (this._tileWidth = this.tileWidth, delete this.tileWidth) : this._tileWidth = 0, this.tileHeight ? (this._tileHeight = this.tileHeight, delete this.tileHeight) : this._tileHeight = 0), this.tileOverlap = nt.tileOverlap ? nt.tileOverlap : 0, this.minLevel = nt.minLevel ? nt.minLevel : 0, this.maxLevel = nt.maxLevel !== void 0 && nt.maxLevel !== null ? nt.maxLevel : nt.width && nt.height ? Math.ceil(
        Math.log(Math.max(nt.width, nt.height)) / Math.log(2)
      ) : 0, this.success && ie.isFunction(this.success) && this.success(this));
    }, ie.TileSource.prototype = {
      getTileSize: function(ee) {
        return ie.console.error(
          "[TileSource.getTileSize] is deprecated. Use TileSource.getTileWidth() and TileSource.getTileHeight() instead"
        ), this._tileWidth;
      },
      /**
       * Return the tileWidth for a given level.
       * Subclasses should override this if tileWidth can be different at different levels
       *   such as in IIIFTileSource.  Code should use this function rather than reading
       *   from ._tileWidth directly.
       * @function
       * @param {Number} level
       */
      getTileWidth: function(ee) {
        return this._tileWidth ? this._tileWidth : this.getTileSize(ee);
      },
      /**
       * Return the tileHeight for a given level.
       * Subclasses should override this if tileHeight can be different at different levels
       *   such as in IIIFTileSource.  Code should use this function rather than reading
       *   from ._tileHeight directly.
       * @function
       * @param {Number} level
       */
      getTileHeight: function(ee) {
        return this._tileHeight ? this._tileHeight : this.getTileSize(ee);
      },
      /**
       * @function
       * @param {Number} level
       */
      getLevelScale: function(ee) {
        var ae = {}, ve;
        for (ve = 0; ve <= this.maxLevel; ve++)
          ae[ve] = 1 / Math.pow(2, this.maxLevel - ve);
        return this.getLevelScale = function(ye) {
          return ae[ye];
        }, this.getLevelScale(ee);
      },
      /**
       * @function
       * @param {Number} level
       */
      getNumTiles: function(ee) {
        var ae = this.getLevelScale(ee), ve = Math.ceil(ae * this.dimensions.x / this.getTileWidth(ee)), ye = Math.ceil(ae * this.dimensions.y / this.getTileHeight(ee));
        return new ie.Point(ve, ye);
      },
      /**
       * @function
       * @param {Number} level
       */
      getPixelRatio: function(ee) {
        var ae = this.dimensions.times(this.getLevelScale(ee)), ve = 1 / ae.x, ye = 1 / ae.y;
        return new ie.Point(ve, ye);
      },
      /**
       * @function
       * @returns {Number} The highest level in this tile source that can be contained in a single tile.
       */
      getClosestLevel: function() {
        var ee, ae;
        for (ee = this.minLevel + 1; ee <= this.maxLevel && (ae = this.getNumTiles(ee), !(ae.x > 1 || ae.y > 1)); ee++)
          ;
        return ee - 1;
      },
      /**
       * @function
       * @param {Number} level
       * @param {OpenSeadragon.Point} point
       */
      getTileAtPoint: function(ee, ae) {
        var ve = ae.x >= 0 && ae.x <= 1 && ae.y >= 0 && ae.y <= 1 / this.aspectRatio;
        ie.console.assert(ve, "[TileSource.getTileAtPoint] must be called with a valid point.");
        var ye = this.dimensions.x * this.getLevelScale(ee), be = ae.x * ye, Ye = ae.y * ye, Qe = Math.floor(be / this.getTileWidth(ee)), Je = Math.floor(Ye / this.getTileHeight(ee));
        ae.x >= 1 && (Qe = this.getNumTiles(ee).x - 1);
        var nt = 1e-15;
        return ae.y >= 1 / this.aspectRatio - nt && (Je = this.getNumTiles(ee).y - 1), new ie.Point(Qe, Je);
      },
      /**
       * @function
       * @param {Number} level
       * @param {Number} x
       * @param {Number} y
       * @param {Boolean} [isSource=false] Whether to return the source bounds of the tile.
       * @returns {OpenSeadragon.Rect} Either where this tile fits (in normalized coordinates) or the
       * portion of the tile to use as the source of the drawing operation (in pixels), depending on
       * the isSource parameter.
       */
      getTileBounds: function(ee, ae, ve, ye) {
        var be = this.dimensions.times(this.getLevelScale(ee)), Ye = this.getTileWidth(ee), Qe = this.getTileHeight(ee), Je = ae === 0 ? 0 : Ye * ae - this.tileOverlap, nt = ve === 0 ? 0 : Qe * ve - this.tileOverlap, st = Ye + (ae === 0 ? 1 : 2) * this.tileOverlap, ot = Qe + (ve === 0 ? 1 : 2) * this.tileOverlap, lt = 1 / be.x;
        return st = Math.min(st, be.x - Je), ot = Math.min(ot, be.y - nt), ye ? new ie.Rect(0, 0, st, ot) : new ie.Rect(Je * lt, nt * lt, st * lt, ot * lt);
      },
      /**
       * Responsible for retrieving, and caching the
       * image metadata pertinent to this TileSources implementation.
       * @function
       * @param {String} url
       * @throws {Error}
       */
      getImageInfo: function(ee) {
        var ae = this, ve, ye, be, Ye, Qe, Je, nt;
        ee && (Qe = ee.split("/"), Je = Qe[Qe.length - 1], nt = Je.lastIndexOf("."), nt > -1 && (Qe[Qe.length - 1] = Je.slice(0, nt))), ye = function(st) {
          typeof st == "string" && (st = ie.parseXml(st));
          var ot = ie.TileSource.determineType(ae, st, ee);
          if (!ot) {
            ae.raiseEvent("open-failed", { message: "Unable to load TileSource", source: ee });
            return;
          }
          Ye = ot.prototype.configure.apply(ae, [st, ee]), Ye.ajaxWithCredentials === void 0 && (Ye.ajaxWithCredentials = ae.ajaxWithCredentials), be = new ot(Ye), ae.ready = !0, ae.raiseEvent("ready", { tileSource: be });
        }, ee.match(/\.js$/) ? (ve = ee.split("/").pop().replace(".js", ""), ie.jsonp({
          url: ee,
          async: !1,
          callbackName: ve,
          callback: ye
        })) : ie.makeAjaxRequest({
          url: ee,
          withCredentials: this.ajaxWithCredentials,
          headers: this.ajaxHeaders,
          success: function(st) {
            var ot = Z(st);
            ye(ot);
          },
          error: function(st, ot) {
            var lt;
            try {
              lt = "HTTP " + st.status + " attempting to load TileSource";
            } catch {
              var ft;
              typeof ot > "u" || !ot.toString ? ft = "Unknown error" : ft = ot.toString(), lt = ft + " attempting to load TileSource";
            }
            ae.raiseEvent("open-failed", {
              message: lt,
              source: ee
            });
          }
        });
      },
      /**
       * Responsible determining if a the particular TileSource supports the
       * data format ( and allowed to apply logic against the url the data was
       * loaded from, if any ). Overriding implementations are expected to do
       * something smart with data and / or url to determine support.  Also
       * understand that iteration order of TileSources is not guarunteed so
       * please make sure your data or url is expressive enough to ensure a simple
       * and sufficient mechanisim for clear determination.
       * @function
       * @param {String|Object|Array|Document} data
       * @param {String} url - the url the data was loaded
       *      from if any.
       * @return {Boolean}
       */
      supports: function(ee, ae) {
        return !1;
      },
      /**
       * Responsible for parsing and configuring the
       * image metadata pertinent to this TileSources implementation.
       * This method is not implemented by this class other than to throw an Error
       * announcing you have to implement it.  Because of the variety of tile
       * server technologies, and various specifications for building image
       * pyramids, this method is here to allow easy integration.
       * @function
       * @param {String|Object|Array|Document} data
       * @param {String} url - the url the data was loaded
       *      from if any.
       * @return {Object} options - A dictionary of keyword arguments sufficient
       *      to configure this tile sources constructor.
       * @throws {Error}
       */
      configure: function(ee, ae) {
        throw new Error("Method not implemented.");
      },
      /**
       * Responsible for retrieving the url which will return an image for the
       * region specified by the given x, y, and level components.
       * This method is not implemented by this class other than to throw an Error
       * announcing you have to implement it.  Because of the variety of tile
       * server technologies, and various specifications for building image
       * pyramids, this method is here to allow easy integration.
       * @function
       * @param {Number} level
       * @param {Number} x
       * @param {Number} y
       * @throws {Error}
       */
      getTileUrl: function(ee, ae, ve) {
        throw new Error("Method not implemented.");
      },
      /**
       * Responsible for retrieving the headers which will be attached to the image request for the
       * region specified by the given x, y, and level components.
       * This option is only relevant if {@link OpenSeadragon.Options}.loadTilesWithAjax is set to true.
       * The headers returned here will override headers specified at the Viewer or TiledImage level.
       * Specifying a falsy value for a header will clear its existing value set at the Viewer or
       * TiledImage level (if any).
       * @function
       * @param {Number} level
       * @param {Number} x
       * @param {Number} y
       * @returns {Object}
       */
      getTileAjaxHeaders: function(ee, ae, ve) {
        return {};
      },
      /**
       * @function
       * @param {Number} level
       * @param {Number} x
       * @param {Number} y
       */
      tileExists: function(ee, ae, ve) {
        var ye = this.getNumTiles(ee);
        return ee >= this.minLevel && ee <= this.maxLevel && ae >= 0 && ve >= 0 && ae < ye.x && ve < ye.y;
      }
    }, ie.extend(!0, ie.TileSource.prototype, ie.EventSource.prototype);
    function Z(ee) {
      var ae = ee.responseText, ve = ee.status, ye, be;
      if (ee) {
        if (ee.status !== 200 && ee.status !== 0)
          throw ve = ee.status, ye = ve == 404 ? "Not Found" : ee.statusText, new Error(ie.getString("Errors.Status", ve, ye));
      } else
        throw new Error(ie.getString("Errors.Security"));
      if (ae.match(/\s*<.*/))
        try {
          be = ee.responseXML && ee.responseXML.documentElement ? ee.responseXML : ie.parseXml(ae);
        } catch {
          be = ee.responseText;
        }
      else if (ae.match(/\s*[\{\[].*/))
        try {
          be = ie.parseJSON(ae);
        } catch {
          be = ae;
        }
      else
        be = ae;
      return be;
    }
    ie.TileSource.determineType = function(ee, ae, ve) {
      var ye;
      for (ye in OpenSeadragon)
        if (ye.match(/.+TileSource$/) && ie.isFunction(OpenSeadragon[ye]) && ie.isFunction(OpenSeadragon[ye].prototype.supports) && OpenSeadragon[ye].prototype.supports.call(ee, ae, ve))
          return OpenSeadragon[ye];
      ie.console.error("No TileSource was able to open %s %s", ve, ae);
    };
  }(OpenSeadragon), function(ie) {
    ie.DziTileSource = function(ae, ve, ye, be, Ye, Qe, Je, nt, st) {
      var ot, lt, ft, gt;
      if (ie.isPlainObject(ae) ? gt = ae : gt = {
        width: arguments[0],
        height: arguments[1],
        tileSize: arguments[2],
        tileOverlap: arguments[3],
        tilesUrl: arguments[4],
        fileFormat: arguments[5],
        displayRects: arguments[6],
        minLevel: arguments[7],
        maxLevel: arguments[8]
      }, this._levelRects = {}, this.tilesUrl = gt.tilesUrl, this.fileFormat = gt.fileFormat, this.displayRects = gt.displayRects, this.displayRects)
        for (ot = this.displayRects.length - 1; ot >= 0; ot--)
          for (lt = this.displayRects[ot], ft = lt.minLevel; ft <= lt.maxLevel; ft++)
            this._levelRects[ft] || (this._levelRects[ft] = []), this._levelRects[ft].push(lt);
      ie.TileSource.apply(this, [gt]);
    }, ie.extend(
      ie.DziTileSource.prototype,
      ie.TileSource.prototype,
      /** @lends OpenSeadragon.DziTileSource.prototype */
      {
        /**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */
        supports: function(ae, ve) {
          var ye;
          return ae.Image ? ye = ae.Image.xmlns : ae.documentElement && (ae.documentElement.localName == "Image" || ae.documentElement.tagName == "Image") && (ye = ae.documentElement.namespaceURI), ye = (ye || "").toLowerCase(), ye.indexOf("schemas.microsoft.com/deepzoom/2008") !== -1 || ye.indexOf("schemas.microsoft.com/deepzoom/2009") !== -1;
        },
        /**
         *
         * @function
         * @param {Object|XMLDocument} data - the raw configuration
         * @param {String} url - the url the data was retrieved from if any.
         * @return {Object} options - A dictionary of keyword arguments sufficient
         *      to configure this tile sources constructor.
         */
        configure: function(ae, ve) {
          var ye;
          return ie.isPlainObject(ae) ? ye = ee(this, ae) : ye = Z(this, ae), ve && !ye.tilesUrl && (ye.tilesUrl = ve.replace(
            /([^\/]+?)(\.(dzi|xml|js)?(\?[^\/]*)?)?\/?$/,
            "$1_files/"
          ), ve.search(/\.(dzi|xml|js)\?/) != -1 ? ye.queryParams = ve.match(/\?.*/) : ye.queryParams = ""), ye;
        },
        /**
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         */
        getTileUrl: function(ae, ve, ye) {
          return [this.tilesUrl, ae, "/", ve, "_", ye, ".", this.fileFormat, this.queryParams].join("");
        },
        /**
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         */
        tileExists: function(ae, ve, ye) {
          var be = this._levelRects[ae], Ye, Qe, Je, nt, st, ot, lt;
          if (this.minLevel && ae < this.minLevel || this.maxLevel && ae > this.maxLevel)
            return !1;
          if (!be || !be.length)
            return !0;
          for (lt = be.length - 1; lt >= 0; lt--)
            if (Ye = be[lt], !(ae < Ye.minLevel || ae > Ye.maxLevel) && (Qe = this.getLevelScale(ae), Je = Ye.x * Qe, nt = Ye.y * Qe, st = Je + Ye.width * Qe, ot = nt + Ye.height * Qe, Je = Math.floor(Je / this._tileWidth), nt = Math.floor(nt / this._tileWidth), st = Math.ceil(st / this._tileWidth), ot = Math.ceil(ot / this._tileWidth), Je <= ve && ve < st && nt <= ye && ye < ot))
              return !0;
          return !1;
        }
      }
    );
    function Z(ae, ve) {
      if (!ve || !ve.documentElement)
        throw new Error(ie.getString("Errors.Xml"));
      var ye = ve.documentElement, be = ye.localName || ye.tagName, Ye = ve.documentElement.namespaceURI, Qe = null, Je = [], nt, st, ot, lt, ft;
      if (be == "Image")
        try {
          if (lt = ye.getElementsByTagName("Size")[0], lt === void 0 && (lt = ye.getElementsByTagNameNS(Ye, "Size")[0]), Qe = {
            Image: {
              xmlns: "http://schemas.microsoft.com/deepzoom/2008",
              Url: ye.getAttribute("Url"),
              Format: ye.getAttribute("Format"),
              DisplayRect: null,
              Overlap: parseInt(ye.getAttribute("Overlap"), 10),
              TileSize: parseInt(ye.getAttribute("TileSize"), 10),
              Size: {
                Height: parseInt(lt.getAttribute("Height"), 10),
                Width: parseInt(lt.getAttribute("Width"), 10)
              }
            }
          }, !ie.imageFormatSupported(Qe.Image.Format))
            throw new Error(
              ie.getString("Errors.ImageFormat", Qe.Image.Format.toUpperCase())
            );
          for (nt = ye.getElementsByTagName("DisplayRect"), nt === void 0 && (nt = ye.getElementsByTagNameNS(Ye, "DisplayRect")[0]), ft = 0; ft < nt.length; ft++)
            st = nt[ft], ot = st.getElementsByTagName("Rect")[0], ot === void 0 && (ot = st.getElementsByTagNameNS(Ye, "Rect")[0]), Je.push({
              Rect: {
                X: parseInt(ot.getAttribute("X"), 10),
                Y: parseInt(ot.getAttribute("Y"), 10),
                Width: parseInt(ot.getAttribute("Width"), 10),
                Height: parseInt(ot.getAttribute("Height"), 10),
                MinLevel: parseInt(st.getAttribute("MinLevel"), 10),
                MaxLevel: parseInt(st.getAttribute("MaxLevel"), 10)
              }
            });
          return Je.length && (Qe.Image.DisplayRect = Je), ee(ae, Qe);
        } catch (_r) {
          throw _r instanceof Error ? _r : new Error(ie.getString("Errors.Dzi"));
        }
      else {
        if (be == "Collection")
          throw new Error(ie.getString("Errors.Dzc"));
        if (be == "Error") {
          var gt = ye.getElementsByTagName("Message")[0], ct = gt.firstChild.nodeValue;
          throw new Error(ct);
        }
      }
      throw new Error(ie.getString("Errors.Dzi"));
    }
    function ee(ae, ve) {
      var ye = ve.Image, be = ye.Url, Ye = ye.Format, Qe = ye.Size, Je = ye.DisplayRect || [], nt = parseInt(Qe.Width, 10), st = parseInt(Qe.Height, 10), ot = parseInt(ye.TileSize, 10), lt = parseInt(ye.Overlap, 10), ft = [], gt, ct;
      for (ct = 0; ct < Je.length; ct++)
        gt = Je[ct].Rect, ft.push(new ie.DisplayRect(
          parseInt(gt.X, 10),
          parseInt(gt.Y, 10),
          parseInt(gt.Width, 10),
          parseInt(gt.Height, 10),
          parseInt(gt.MinLevel, 10),
          parseInt(gt.MaxLevel, 10)
        ));
      return ie.extend(!0, {
        width: nt,
        /* width *required */
        height: st,
        /* height *required */
        tileSize: ot,
        /* tileSize *required */
        tileOverlap: lt,
        /* tileOverlap *required */
        minLevel: null,
        /* minLevel */
        maxLevel: null,
        /* maxLevel */
        tilesUrl: be,
        /* tilesUrl */
        fileFormat: Ye,
        /* fileFormat */
        displayRects: ft
        /* displayRects */
      }, ve);
    }
  }(OpenSeadragon), function(ie) {
    ie.IIIFTileSource = function(ye) {
      if (ie.extend(!0, this, ye), !(this.height && this.width && this["@id"]))
        throw new Error("IIIF required parameters not provided.");
      if (ye.tileSizePerScaleFactor = {}, this.tileFormat = this.tileFormat || "jpg", this.version = ye.version, this.tile_width && this.tile_height)
        ye.tileWidth = this.tile_width, ye.tileHeight = this.tile_height;
      else if (this.tile_width)
        ye.tileSize = this.tile_width;
      else if (this.tile_height)
        ye.tileSize = this.tile_height;
      else if (this.tiles)
        if (this.tiles.length == 1)
          ye.tileWidth = this.tiles[0].width, ye.tileHeight = this.tiles[0].height || this.tiles[0].width, this.scale_factors = this.tiles[0].scaleFactors;
        else {
          this.scale_factors = [];
          for (var be = 0; be < this.tiles.length; be++)
            for (var Ye = 0; Ye < this.tiles[be].scaleFactors.length; Ye++) {
              var Qe = this.tiles[be].scaleFactors[Ye];
              this.scale_factors.push(Qe), ye.tileSizePerScaleFactor[Qe] = {
                width: this.tiles[be].width,
                height: this.tiles[be].height || this.tiles[be].width
              };
            }
        }
      else if (Z(ye)) {
        for (var Je = Math.min(this.height, this.width), nt = [256, 512, 1024], st = [], ot = 0; ot < nt.length; ot++)
          nt[ot] <= Je && st.push(nt[ot]);
        st.length > 0 ? ye.tileSize = Math.max.apply(null, st) : ye.tileSize = Je;
      } else
        this.sizes && this.sizes.length > 0 ? (this.emulateLegacyImagePyramid = !0, ye.levels = ee(this), ie.extend(!0, ye, {
          width: ye.levels[ye.levels.length - 1].width,
          height: ye.levels[ye.levels.length - 1].height,
          tileSize: Math.max(ye.height, ye.width),
          tileOverlap: 0,
          minLevel: 0,
          maxLevel: ye.levels.length - 1
        }), this.levels = ye.levels) : ie.console.error("Nothing in the info.json to construct image pyramids from");
      if (!ye.maxLevel && !this.emulateLegacyImagePyramid)
        if (!this.scale_factors)
          ye.maxLevel = Number(Math.ceil(Math.log(Math.max(this.width, this.height), 2)));
        else {
          var lt = Math.max.apply(null, this.scale_factors);
          ye.maxLevel = Math.round(Math.log(lt) * Math.LOG2E);
        }
      ie.TileSource.apply(this, [ye]);
    }, ie.extend(
      ie.IIIFTileSource.prototype,
      ie.TileSource.prototype,
      /** @lends OpenSeadragon.IIIFTileSource.prototype */
      {
        /**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */
        supports: function(ye, be) {
          return ye.protocol && ye.protocol == "http://iiif.io/api/image" || ye["@context"] && (ye["@context"] == "http://library.stanford.edu/iiif/image-api/1.1/context.json" || ye["@context"] == "http://iiif.io/api/image/1/context.json") || ye.profile && ye.profile.indexOf("http://library.stanford.edu/iiif/image-api/compliance.html") === 0 || ye.identifier && ye.width && ye.height ? !0 : !!(ye.documentElement && ye.documentElement.tagName == "info" && ye.documentElement.namespaceURI == "http://library.stanford.edu/iiif/image-api/ns/");
        },
        /**
         *
         * @function
         * @param {Object} data - the raw configuration
         * @example <caption>IIIF 1.1 Info Looks like this</caption>
         * {
         *   "@context" : "http://library.stanford.edu/iiif/image-api/1.1/context.json",
         *   "@id" : "http://iiif.example.com/prefix/1E34750D-38DB-4825-A38A-B60A345E591C",
         *   "width" : 6000,
         *   "height" : 4000,
         *   "scale_factors" : [ 1, 2, 4 ],
         *   "tile_width" : 1024,
         *   "tile_height" : 1024,
         *   "formats" : [ "jpg", "png" ],
         *   "qualities" : [ "native", "grey" ],
         *   "profile" : "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0"
         * }
         */
        configure: function(ye, be) {
          if (ie.isPlainObject(ye)) {
            if (!ye["@context"])
              ye["@context"] = "http://iiif.io/api/image/1.0/context.json", ye["@id"] = be.replace("/info.json", ""), ye.version = 1;
            else {
              var Qe = ye["@context"];
              if (Array.isArray(Qe)) {
                for (var Je = 0; Je < Qe.length; Je++)
                  if (typeof Qe[Je] == "string" && (/^http:\/\/iiif\.io\/api\/image\/[1-3]\/context\.json$/.test(Qe[Je]) || Qe[Je] === "http://library.stanford.edu/iiif/image-api/1.1/context.json")) {
                    Qe = Qe[Je];
                    break;
                  }
              }
              switch (Qe) {
                case "http://iiif.io/api/image/1/context.json":
                case "http://library.stanford.edu/iiif/image-api/1.1/context.json":
                  ye.version = 1;
                  break;
                case "http://iiif.io/api/image/2/context.json":
                  ye.version = 2;
                  break;
                case "http://iiif.io/api/image/3/context.json":
                  ye.version = 3;
                  break;
                default:
                  ie.console.error("Data has a @context property which contains no known IIIF context URI.");
              }
            }
            if (!ye["@id"] && ye.id && (ye["@id"] = ye.id), ye.preferredFormats) {
              for (var nt = 0; nt < ye.preferredFormats.length; nt++)
                if (OpenSeadragon.imageFormatSupported(ye.preferredFormats[nt])) {
                  ye.tileFormat = ye.preferredFormats[nt];
                  break;
                }
            }
            return ye;
          } else {
            var Ye = ae(ye);
            return Ye["@context"] = "http://iiif.io/api/image/1.0/context.json", Ye["@id"] = be.replace("/info.xml", ""), Ye.version = 1, Ye;
          }
        },
        /**
         * Return the tileWidth for the given level.
         * @function
         * @param {Number} level
         */
        getTileWidth: function(ye) {
          if (this.emulateLegacyImagePyramid)
            return ie.TileSource.prototype.getTileWidth.call(this, ye);
          var be = Math.pow(2, this.maxLevel - ye);
          return this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[be] ? this.tileSizePerScaleFactor[be].width : this._tileWidth;
        },
        /**
         * Return the tileHeight for the given level.
         * @function
         * @param {Number} level
         */
        getTileHeight: function(ye) {
          if (this.emulateLegacyImagePyramid)
            return ie.TileSource.prototype.getTileHeight.call(this, ye);
          var be = Math.pow(2, this.maxLevel - ye);
          return this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[be] ? this.tileSizePerScaleFactor[be].height : this._tileHeight;
        },
        /**
         * @function
         * @param {Number} level
         */
        getLevelScale: function(ye) {
          if (this.emulateLegacyImagePyramid) {
            var be = NaN;
            return this.levels.length > 0 && ye >= this.minLevel && ye <= this.maxLevel && (be = this.levels[ye].width / this.levels[this.maxLevel].width), be;
          }
          return ie.TileSource.prototype.getLevelScale.call(this, ye);
        },
        /**
         * @function
         * @param {Number} level
         */
        getNumTiles: function(ye) {
          if (this.emulateLegacyImagePyramid) {
            var be = this.getLevelScale(ye);
            return be ? new ie.Point(1, 1) : new ie.Point(0, 0);
          }
          return ie.TileSource.prototype.getNumTiles.call(this, ye);
        },
        /**
         * @function
         * @param {Number} level
         * @param {OpenSeadragon.Point} point
         */
        getTileAtPoint: function(ye, be) {
          return this.emulateLegacyImagePyramid ? new ie.Point(0, 0) : ie.TileSource.prototype.getTileAtPoint.call(this, ye, be);
        },
        /**
         * Responsible for retrieving the url which will return an image for the
         * region specified by the given x, y, and level components.
         * @function
         * @param {Number} level - z index
         * @param {Number} x
         * @param {Number} y
         * @throws {Error}
         */
        getTileUrl: function(ye, be, Ye) {
          if (this.emulateLegacyImagePyramid) {
            var Qe = null;
            return this.levels.length > 0 && ye >= this.minLevel && ye <= this.maxLevel && (Qe = this.levels[ye].url), Qe;
          }
          var Je = "0", nt = Math.pow(0.5, this.maxLevel - ye), st = Math.ceil(this.width * nt), ot = Math.ceil(this.height * nt), lt, ft, gt, ct, _r, Kr, Xr, Jr, ei, si, ri, ai, yi, pi;
          return lt = this.getTileWidth(ye), ft = this.getTileHeight(ye), gt = Math.ceil(lt / nt), ct = Math.ceil(ft / nt), this.version === 1 ? yi = "native." + this.tileFormat : yi = "default." + this.tileFormat, st < lt && ot < ft ? (this.version === 2 && st === this.width || this.version === 3 && st === this.width && ot === this.height ? si = "max" : this.version === 3 ? si = st + "," + ot : si = st + ",", _r = "full") : (Kr = be * gt, Xr = Ye * ct, Jr = Math.min(gt, this.width - Kr), ei = Math.min(ct, this.height - Xr), be === 0 && Ye === 0 && Jr === this.width && ei === this.height ? _r = "full" : _r = [Kr, Xr, Jr, ei].join(","), ri = Math.ceil(Jr * nt), ai = Math.ceil(ei * nt), this.version === 2 && ri === this.width || this.version === 3 && ri === this.width && ai === this.height ? si = "max" : this.version === 3 ? si = ri + "," + ai : si = ri + ","), pi = [this["@id"], _r, si, Je, yi].join("/"), pi;
        },
        __testonly__: {
          canBeTiled: Z,
          constructLevels: ee
        }
      }
    );
    function Z(ye) {
      var be = [
        "http://library.stanford.edu/iiif/image-api/compliance.html#level0",
        "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0",
        "http://iiif.io/api/image/2/level0.json",
        "level0",
        "https://iiif.io/api/image/3/level0.json"
      ], Ye = Array.isArray(ye.profile) ? ye.profile[0] : ye.profile, Qe = be.indexOf(Ye) !== -1, Je = !1;
      return ye.version === 2 && ye.profile.length > 1 && ye.profile[1].supports && (Je = ye.profile[1].supports.indexOf("sizeByW") !== -1), ye.version === 3 && ye.extraFeatures && (Je = ye.extraFeatures.indexOf("sizeByWh") !== -1), !Qe || Je;
    }
    function ee(ye) {
      for (var be = [], Ye = 0; Ye < ye.sizes.length; Ye++)
        be.push({
          url: ye["@id"] + "/full/" + ye.sizes[Ye].width + "," + (ye.version === 3 ? ye.sizes[Ye].height : "") + "/0/default." + ye.tileFormat,
          width: ye.sizes[Ye].width,
          height: ye.sizes[Ye].height
        });
      return be.sort(function(Qe, Je) {
        return Qe.width - Je.width;
      });
    }
    function ae(ye) {
      if (!ye || !ye.documentElement)
        throw new Error(ie.getString("Errors.Xml"));
      var be = ye.documentElement, Ye = be.tagName, Qe = null;
      if (Ye == "info")
        try {
          return Qe = {}, ve(be, Qe), Qe;
        } catch (Je) {
          throw Je instanceof Error ? Je : new Error(ie.getString("Errors.IIIF"));
        }
      throw new Error(ie.getString("Errors.IIIF"));
    }
    function ve(ye, be, Ye) {
      var Qe, Je;
      if (ye.nodeType == 3 && Ye)
        Je = ye.nodeValue.trim(), Je.match(/^\d*$/) && (Je = Number(Je)), be[Ye] ? (ie.isArray(be[Ye]) || (be[Ye] = [be[Ye]]), be[Ye].push(Je)) : be[Ye] = Je;
      else if (ye.nodeType == 1)
        for (Qe = 0; Qe < ye.childNodes.length; Qe++)
          ve(ye.childNodes[Qe], be, ye.nodeName);
    }
  }(OpenSeadragon), function(ie) {
    ie.OsmTileSource = function(Z, ee, ae, ve, ye) {
      var be;
      ie.isPlainObject(Z) ? be = Z : be = {
        width: arguments[0],
        height: arguments[1],
        tileSize: arguments[2],
        tileOverlap: arguments[3],
        tilesUrl: arguments[4]
      }, (!be.width || !be.height) && (be.width = 65572864, be.height = 65572864), be.tileSize || (be.tileSize = 256, be.tileOverlap = 0), be.tilesUrl || (be.tilesUrl = "http://tile.openstreetmap.org/"), be.minLevel = 8, ie.TileSource.apply(this, [be]);
    }, ie.extend(
      ie.OsmTileSource.prototype,
      ie.TileSource.prototype,
      /** @lends OpenSeadragon.OsmTileSource.prototype */
      {
        /**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */
        supports: function(Z, ee) {
          return Z.type && Z.type == "openstreetmaps";
        },
        /**
         *
         * @function
         * @param {Object} data - the raw configuration
         * @param {String} url - the url the data was retrieved from if any.
         * @return {Object} options - A dictionary of keyword arguments sufficient
         *      to configure this tile sources constructor.
         */
        configure: function(Z, ee) {
          return Z;
        },
        /**
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         */
        getTileUrl: function(Z, ee, ae) {
          return this.tilesUrl + (Z - 8) + "/" + ee + "/" + ae + ".png";
        }
      }
    );
  }(OpenSeadragon), function(ie) {
    ie.TmsTileSource = function(Z, ee, ae, ve, ye) {
      var be;
      ie.isPlainObject(Z) ? be = Z : be = {
        width: arguments[0],
        height: arguments[1],
        tileSize: arguments[2],
        tileOverlap: arguments[3],
        tilesUrl: arguments[4]
      };
      var Ye = Math.ceil(be.width / 256) * 256, Qe = Math.ceil(be.height / 256) * 256, Je;
      Ye > Qe ? Je = Ye / 256 : Je = Qe / 256, be.maxLevel = Math.ceil(Math.log(Je) / Math.log(2)) - 1, be.tileSize = 256, be.width = Ye, be.height = Qe, ie.TileSource.apply(this, [be]);
    }, ie.extend(
      ie.TmsTileSource.prototype,
      ie.TileSource.prototype,
      /** @lends OpenSeadragon.TmsTileSource.prototype */
      {
        /**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */
        supports: function(Z, ee) {
          return Z.type && Z.type == "tiledmapservice";
        },
        /**
         *
         * @function
         * @param {Object} data - the raw configuration
         * @param {String} url - the url the data was retrieved from if any.
         * @return {Object} options - A dictionary of keyword arguments sufficient
         *      to configure this tile sources constructor.
         */
        configure: function(Z, ee) {
          return Z;
        },
        /**
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         */
        getTileUrl: function(Z, ee, ae) {
          var ve = this.getNumTiles(Z).y - 1;
          return this.tilesUrl + Z + "/" + ee + "/" + (ve - ae) + ".png";
        }
      }
    );
  }(OpenSeadragon), function(ie) {
    ie.ZoomifyTileSource = function(Z) {
      Z.tileSize = 256;
      var ee = {
        x: Z.width,
        y: Z.height
      };
      for (Z.imageSizes = [{
        x: Z.width,
        y: Z.height
      }], Z.gridSize = [this._getGridSize(Z.width, Z.height, Z.tileSize)]; parseInt(ee.x, 10) > Z.tileSize || parseInt(ee.y, 10) > Z.tileSize; )
        ee.x = Math.floor(ee.x / 2), ee.y = Math.floor(ee.y / 2), Z.imageSizes.push({
          x: ee.x,
          y: ee.y
        }), Z.gridSize.push(this._getGridSize(ee.x, ee.y, Z.tileSize));
      Z.imageSizes.reverse(), Z.gridSize.reverse(), Z.minLevel = 0, Z.maxLevel = Z.gridSize.length - 1, OpenSeadragon.TileSource.apply(this, [Z]);
    }, ie.extend(
      ie.ZoomifyTileSource.prototype,
      ie.TileSource.prototype,
      /** @lends OpenSeadragon.ZoomifyTileSource.prototype */
      {
        //private
        _getGridSize: function(Z, ee, ae) {
          return {
            x: Math.ceil(Z / ae),
            y: Math.ceil(ee / ae)
          };
        },
        //private
        _calculateAbsoluteTileNumber: function(Z, ee, ae) {
          for (var ve = 0, ye = {}, be = 0; be < Z; be++)
            ye = this.gridSize[be], ve += ye.x * ye.y;
          return ye = this.gridSize[Z], ve += ye.x * ae + ee, ve;
        },
        /**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */
        supports: function(Z, ee) {
          return Z.type && Z.type == "zoomifytileservice";
        },
        /**
         *
         * @function
         * @param {Object} data - the raw configuration
         * @param {String} url - the url the data was retrieved from if any.
         * @return {Object} options - A dictionary of keyword arguments sufficient
         *      to configure this tile sources constructor.
         */
        configure: function(Z, ee) {
          return Z;
        },
        /**
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         */
        getTileUrl: function(Z, ee, ae) {
          var ve = 0, ye = this._calculateAbsoluteTileNumber(Z, ee, ae);
          return ve = Math.floor(ye / 256), this.tilesUrl + "TileGroup" + ve + "/" + Z + "-" + ee + "-" + ae + ".jpg";
        }
      }
    );
  }(OpenSeadragon), function(ie) {
    ie.LegacyTileSource = function(ve) {
      var ye, be, Ye;
      ie.isArray(ve) && (ye = {
        type: "legacy-image-pyramid",
        levels: ve
      }), ye.levels = Z(ye.levels), ye.levels.length > 0 ? (be = ye.levels[ye.levels.length - 1].width, Ye = ye.levels[ye.levels.length - 1].height) : (be = 0, Ye = 0, ie.console.error("No supported image formats found")), ie.extend(!0, ye, {
        width: be,
        height: Ye,
        tileSize: Math.max(Ye, be),
        tileOverlap: 0,
        minLevel: 0,
        maxLevel: ye.levels.length > 0 ? ye.levels.length - 1 : 0
      }), ie.TileSource.apply(this, [ye]), this.levels = ye.levels;
    }, ie.extend(
      ie.LegacyTileSource.prototype,
      ie.TileSource.prototype,
      /** @lends OpenSeadragon.LegacyTileSource.prototype */
      {
        /**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */
        supports: function(ve, ye) {
          return ve.type && ve.type == "legacy-image-pyramid" || ve.documentElement && ve.documentElement.getAttribute("type") == "legacy-image-pyramid";
        },
        /**
         *
         * @function
         * @param {Object|XMLDocument} configuration - the raw configuration
         * @param {String} dataUrl - the url the data was retrieved from if any.
         * @return {Object} options - A dictionary of keyword arguments sufficient
         *      to configure this tile sources constructor.
         */
        configure: function(ve, ye) {
          var be;
          return ie.isPlainObject(ve) ? be = ae(this, ve) : be = ee(this, ve), be;
        },
        /**
         * @function
         * @param {Number} level
         */
        getLevelScale: function(ve) {
          var ye = NaN;
          return this.levels.length > 0 && ve >= this.minLevel && ve <= this.maxLevel && (ye = this.levels[ve].width / this.levels[this.maxLevel].width), ye;
        },
        /**
         * @function
         * @param {Number} level
         */
        getNumTiles: function(ve) {
          var ye = this.getLevelScale(ve);
          return ye ? new ie.Point(1, 1) : new ie.Point(0, 0);
        },
        /**
         * This method is not implemented by this class other than to throw an Error
         * announcing you have to implement it.  Because of the variety of tile
         * server technologies, and various specifications for building image
         * pyramids, this method is here to allow easy integration.
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         * @throws {Error}
         */
        getTileUrl: function(ve, ye, be) {
          var Ye = null;
          return this.levels.length > 0 && ve >= this.minLevel && ve <= this.maxLevel && (Ye = this.levels[ve].url), Ye;
        }
      }
    );
    function Z(ve) {
      var ye = [], be, Ye;
      for (Ye = 0; Ye < ve.length; Ye++)
        be = ve[Ye], be.height && be.width && be.url ? ye.push({
          url: be.url,
          width: Number(be.width),
          height: Number(be.height)
        }) : ie.console.error("Unsupported image format: %s", be.url ? be.url : "<no URL>");
      return ye.sort(function(Qe, Je) {
        return Qe.height - Je.height;
      });
    }
    function ee(ve, ye) {
      if (!ye || !ye.documentElement)
        throw new Error(ie.getString("Errors.Xml"));
      var be = ye.documentElement, Ye = be.tagName, Qe = null, Je = [], nt, st;
      if (Ye == "image")
        try {
          for (Qe = {
            type: be.getAttribute("type"),
            levels: []
          }, Je = be.getElementsByTagName("level"), st = 0; st < Je.length; st++)
            nt = Je[st], Qe.levels.push({
              url: nt.getAttribute("url"),
              width: parseInt(nt.getAttribute("width"), 10),
              height: parseInt(nt.getAttribute("height"), 10)
            });
          return ae(ve, Qe);
        } catch (ot) {
          throw ot instanceof Error ? ot : new Error("Unknown error parsing Legacy Image Pyramid XML.");
        }
      else {
        if (Ye == "collection")
          throw new Error("Legacy Image Pyramid Collections not yet supported.");
        if (Ye == "error")
          throw new Error("Error: " + ye);
      }
      throw new Error("Unknown element " + Ye);
    }
    function ae(ve, ye) {
      return ye.levels;
    }
  }(OpenSeadragon), function(ie) {
    ie.ImageTileSource = function(Z) {
      Z = ie.extend({
        buildPyramid: !0,
        crossOriginPolicy: !1,
        ajaxWithCredentials: !1,
        useCanvas: !0
      }, Z), ie.TileSource.apply(this, [Z]);
    }, ie.extend(
      ie.ImageTileSource.prototype,
      ie.TileSource.prototype,
      /** @lends OpenSeadragon.ImageTileSource.prototype */
      {
        /**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */
        supports: function(Z, ee) {
          return Z.type && Z.type === "image";
        },
        /**
         *
         * @function
         * @param {Object} options - the options
         * @param {String} dataUrl - the url the image was retrieved from, if any.
         * @return {Object} options - A dictionary of keyword arguments sufficient
         *      to configure this tile sources constructor.
         */
        configure: function(Z, ee) {
          return Z;
        },
        /**
         * Responsible for retrieving, and caching the
         * image metadata pertinent to this TileSources implementation.
         * @function
         * @param {String} url
         * @throws {Error}
         */
        getImageInfo: function(Z) {
          var ee = this._image = new Image(), ae = this;
          this.crossOriginPolicy && (ee.crossOrigin = this.crossOriginPolicy), this.ajaxWithCredentials && (ee.useCredentials = this.ajaxWithCredentials), ie.addEvent(ee, "load", function() {
            ae.width = Object.prototype.hasOwnProperty.call(ee, "naturalWidth") ? ee.naturalWidth : ee.width, ae.height = Object.prototype.hasOwnProperty.call(ee, "naturalHeight") ? ee.naturalHeight : ee.height, ae.aspectRatio = ae.width / ae.height, ae.dimensions = new ie.Point(ae.width, ae.height), ae._tileWidth = ae.width, ae._tileHeight = ae.height, ae.tileOverlap = 0, ae.minLevel = 0, ae.levels = ae._buildLevels(), ae.maxLevel = ae.levels.length - 1, ae.ready = !0, ae.raiseEvent("ready", { tileSource: ae });
          }), ie.addEvent(ee, "error", function() {
            ae.raiseEvent("open-failed", {
              message: "Error loading image at " + Z,
              source: Z
            });
          }), ee.src = Z;
        },
        /**
         * @function
         * @param {Number} level
         */
        getLevelScale: function(Z) {
          var ee = NaN;
          return Z >= this.minLevel && Z <= this.maxLevel && (ee = this.levels[Z].width / this.levels[this.maxLevel].width), ee;
        },
        /**
         * @function
         * @param {Number} level
         */
        getNumTiles: function(Z) {
          var ee = this.getLevelScale(Z);
          return ee ? new ie.Point(1, 1) : new ie.Point(0, 0);
        },
        /**
         * Retrieves a tile url
         * @function
         * @param {Number} level Level of the tile
         * @param {Number} x x coordinate of the tile
         * @param {Number} y y coordinate of the tile
         */
        getTileUrl: function(Z, ee, ae) {
          var ve = null;
          return Z >= this.minLevel && Z <= this.maxLevel && (ve = this.levels[Z].url), ve;
        },
        /**
         * Retrieves a tile context 2D
         * @function
         * @param {Number} level Level of the tile
         * @param {Number} x x coordinate of the tile
         * @param {Number} y y coordinate of the tile
         */
        getContext2D: function(Z, ee, ae) {
          var ve = null;
          return Z >= this.minLevel && Z <= this.maxLevel && (ve = this.levels[Z].context2D), ve;
        },
        // private
        //
        // Builds the different levels of the pyramid if possible
        // (i.e. if canvas API enabled and no canvas tainting issue).
        _buildLevels: function() {
          var Z = [{
            url: this._image.src,
            /* IE8 fix since it has no naturalWidth and naturalHeight */
            width: Object.prototype.hasOwnProperty.call(this._image, "naturalWidth") ? this._image.naturalWidth : this._image.width,
            height: Object.prototype.hasOwnProperty.call(this._image, "naturalHeight") ? this._image.naturalHeight : this._image.height
          }];
          if (!this.buildPyramid || !ie.supportsCanvas || !this.useCanvas)
            return delete this._image, Z;
          var ee = Object.prototype.hasOwnProperty.call(this._image, "naturalWidth") ? this._image.naturalWidth : this._image.width, ae = Object.prototype.hasOwnProperty.call(this._image, "naturalHeight") ? this._image.naturalHeight : this._image.height, ve = document.createElement("canvas"), ye = ve.getContext("2d");
          if (ve.width = ee, ve.height = ae, ye.drawImage(this._image, 0, 0, ee, ae), Z[0].context2D = ye, delete this._image, ie.isCanvasTainted(ve))
            return Z;
          for (; ee >= 2 && ae >= 2; ) {
            ee = Math.floor(ee / 2), ae = Math.floor(ae / 2);
            var be = document.createElement("canvas"), Ye = be.getContext("2d");
            be.width = ee, be.height = ae, Ye.drawImage(ve, 0, 0, ee, ae), Z.splice(0, 0, {
              context2D: Ye,
              width: ee,
              height: ae
            }), ve = be, ye = Ye;
          }
          return Z;
        }
      }
    );
  }(OpenSeadragon), function(ie) {
    ie.TileSourceCollection = function(Z, ee, ae, ve) {
      ie.console.error("TileSourceCollection is deprecated; use World instead");
    };
  }(OpenSeadragon), function(ie) {
    ie.ButtonState = {
      REST: 0,
      GROUP: 1,
      HOVER: 2,
      DOWN: 3
    }, ie.Button = function(Ye) {
      var Qe = this;
      ie.EventSource.call(this), ie.extend(!0, this, {
        tooltip: null,
        srcRest: null,
        srcGroup: null,
        srcHover: null,
        srcDown: null,
        clickTimeThreshold: ie.DEFAULT_SETTINGS.clickTimeThreshold,
        clickDistThreshold: ie.DEFAULT_SETTINGS.clickDistThreshold,
        /**
         * How long to wait before fading.
         * @member {Number} fadeDelay
         * @memberof OpenSeadragon.Button#
         */
        fadeDelay: 0,
        /**
         * How long should it take to fade the button.
         * @member {Number} fadeLength
         * @memberof OpenSeadragon.Button#
         */
        fadeLength: 2e3,
        onPress: null,
        onRelease: null,
        onClick: null,
        onEnter: null,
        onExit: null,
        onFocus: null,
        onBlur: null
      }, Ye), this.element = Ye.element || ie.makeNeutralElement("div"), Ye.element || (this.imgRest = ie.makeTransparentImage(this.srcRest), this.imgGroup = ie.makeTransparentImage(this.srcGroup), this.imgHover = ie.makeTransparentImage(this.srcHover), this.imgDown = ie.makeTransparentImage(this.srcDown), this.imgRest.alt = this.imgGroup.alt = this.imgHover.alt = this.imgDown.alt = this.tooltip, this.element.style.position = "relative", ie.setElementTouchActionNone(this.element), this.imgGroup.style.position = this.imgHover.style.position = this.imgDown.style.position = "absolute", this.imgGroup.style.top = this.imgHover.style.top = this.imgDown.style.top = "0px", this.imgGroup.style.left = this.imgHover.style.left = this.imgDown.style.left = "0px", this.imgHover.style.visibility = this.imgDown.style.visibility = "hidden", ie.Browser.vendor == ie.BROWSERS.FIREFOX && ie.Browser.version < 3 && (this.imgGroup.style.top = this.imgHover.style.top = this.imgDown.style.top = ""), this.element.appendChild(this.imgRest), this.element.appendChild(this.imgGroup), this.element.appendChild(this.imgHover), this.element.appendChild(this.imgDown)), this.addHandler("press", this.onPress), this.addHandler("release", this.onRelease), this.addHandler("click", this.onClick), this.addHandler("enter", this.onEnter), this.addHandler("exit", this.onExit), this.addHandler("focus", this.onFocus), this.addHandler("blur", this.onBlur), this.currentState = ie.ButtonState.GROUP, this.fadeBeginTime = null, this.shouldFade = !1, this.element.style.display = "inline-block", this.element.style.position = "relative", this.element.title = this.tooltip, this.tracker = new ie.MouseTracker({
        element: this.element,
        clickTimeThreshold: this.clickTimeThreshold,
        clickDistThreshold: this.clickDistThreshold,
        enterHandler: function(Je) {
          Je.insideElementPressed ? (ye(Qe, ie.ButtonState.DOWN), Qe.raiseEvent("enter", { originalEvent: Je.originalEvent })) : Je.buttonDownAny || ye(Qe, ie.ButtonState.HOVER);
        },
        focusHandler: function(Je) {
          this.enterHandler(Je), Qe.raiseEvent("focus", { originalEvent: Je.originalEvent });
        },
        exitHandler: function(Je) {
          be(Qe, ie.ButtonState.GROUP), Je.insideElementPressed && Qe.raiseEvent("exit", { originalEvent: Je.originalEvent });
        },
        blurHandler: function(Je) {
          this.exitHandler(Je), Qe.raiseEvent("blur", { originalEvent: Je.originalEvent });
        },
        pressHandler: function(Je) {
          ye(Qe, ie.ButtonState.DOWN), Qe.raiseEvent("press", { originalEvent: Je.originalEvent });
        },
        releaseHandler: function(Je) {
          Je.insideElementPressed && Je.insideElementReleased ? (be(Qe, ie.ButtonState.HOVER), Qe.raiseEvent("release", { originalEvent: Je.originalEvent })) : Je.insideElementPressed ? be(Qe, ie.ButtonState.GROUP) : ye(Qe, ie.ButtonState.HOVER);
        },
        clickHandler: function(Je) {
          Je.quick && Qe.raiseEvent("click", { originalEvent: Je.originalEvent });
        },
        keyHandler: function(Je) {
          return Je.keyCode === 13 ? (Qe.raiseEvent("click", { originalEvent: Je.originalEvent }), Qe.raiseEvent("release", { originalEvent: Je.originalEvent }), !1) : !0;
        }
      }), be(this, ie.ButtonState.REST);
    }, ie.extend(
      ie.Button.prototype,
      ie.EventSource.prototype,
      /** @lends OpenSeadragon.Button.prototype */
      {
        /**
         * TODO: Determine what this function is intended to do and if it's actually
         * useful as an API point.
         * @function
         */
        notifyGroupEnter: function() {
          ye(this, ie.ButtonState.GROUP);
        },
        /**
         * TODO: Determine what this function is intended to do and if it's actually
         * useful as an API point.
         * @function
         */
        notifyGroupExit: function() {
          be(this, ie.ButtonState.REST);
        },
        /**
         * @function
         */
        disable: function() {
          this.notifyGroupExit(), this.element.disabled = !0, ie.setElementOpacity(this.element, 0.2, !0);
        },
        /**
         * @function
         */
        enable: function() {
          this.element.disabled = !1, ie.setElementOpacity(this.element, 1, !0), this.notifyGroupEnter();
        }
      }
    );
    function Z(Ye) {
      ie.requestAnimationFrame(function() {
        ee(Ye);
      });
    }
    function ee(Ye) {
      var Qe, Je, nt;
      Ye.shouldFade && (Qe = ie.now(), Je = Qe - Ye.fadeBeginTime, nt = 1 - Je / Ye.fadeLength, nt = Math.min(1, nt), nt = Math.max(0, nt), Ye.imgGroup && ie.setElementOpacity(Ye.imgGroup, nt, !0), nt > 0 && Z(Ye));
    }
    function ae(Ye) {
      Ye.shouldFade = !0, Ye.fadeBeginTime = ie.now() + Ye.fadeDelay, window.setTimeout(function() {
        Z(Ye);
      }, Ye.fadeDelay);
    }
    function ve(Ye) {
      Ye.shouldFade = !1, Ye.imgGroup && ie.setElementOpacity(Ye.imgGroup, 1, !0);
    }
    function ye(Ye, Qe) {
      Ye.element.disabled || (Qe >= ie.ButtonState.GROUP && Ye.currentState == ie.ButtonState.REST && (ve(Ye), Ye.currentState = ie.ButtonState.GROUP), Qe >= ie.ButtonState.HOVER && Ye.currentState == ie.ButtonState.GROUP && (Ye.imgHover && (Ye.imgHover.style.visibility = ""), Ye.currentState = ie.ButtonState.HOVER), Qe >= ie.ButtonState.DOWN && Ye.currentState == ie.ButtonState.HOVER && (Ye.imgDown && (Ye.imgDown.style.visibility = ""), Ye.currentState = ie.ButtonState.DOWN));
    }
    function be(Ye, Qe) {
      Ye.element.disabled || (Qe <= ie.ButtonState.HOVER && Ye.currentState == ie.ButtonState.DOWN && (Ye.imgDown && (Ye.imgDown.style.visibility = "hidden"), Ye.currentState = ie.ButtonState.HOVER), Qe <= ie.ButtonState.GROUP && Ye.currentState == ie.ButtonState.HOVER && (Ye.imgHover && (Ye.imgHover.style.visibility = "hidden"), Ye.currentState = ie.ButtonState.GROUP), Qe <= ie.ButtonState.REST && Ye.currentState == ie.ButtonState.GROUP && (ae(Ye), Ye.currentState = ie.ButtonState.REST));
    }
  }(OpenSeadragon), function(ie) {
    ie.ButtonGroup = function(Z) {
      ie.extend(!0, this, {
        /**
         * An array containing the buttons themselves.
         * @member {Array} buttons
         * @memberof OpenSeadragon.ButtonGroup#
         */
        buttons: [],
        clickTimeThreshold: ie.DEFAULT_SETTINGS.clickTimeThreshold,
        clickDistThreshold: ie.DEFAULT_SETTINGS.clickDistThreshold,
        labelText: ""
      }, Z);
      var ee = this.buttons.concat([]), ae = this, ve;
      if (this.element = Z.element || ie.makeNeutralElement("div"), !Z.group)
        for (this.element.style.display = "inline-block", ve = 0; ve < ee.length; ve++)
          this.element.appendChild(ee[ve].element);
      ie.setElementTouchActionNone(this.element), this.tracker = new ie.MouseTracker({
        element: this.element,
        clickTimeThreshold: this.clickTimeThreshold,
        clickDistThreshold: this.clickDistThreshold,
        enterHandler: function(ye) {
          var be;
          for (be = 0; be < ae.buttons.length; be++)
            ae.buttons[be].notifyGroupEnter();
        },
        exitHandler: function(ye) {
          var be;
          if (!ye.insideElementPressed)
            for (be = 0; be < ae.buttons.length; be++)
              ae.buttons[be].notifyGroupExit();
        }
      });
    }, ie.ButtonGroup.prototype = {
      /**
       * TODO: Figure out why this is used on the public API and if a more useful
       * api can be created.
       * @function
       * @private
       */
      emulateEnter: function() {
        this.tracker.enterHandler({ eventSource: this.tracker });
      },
      /**
       * TODO: Figure out why this is used on the public API and if a more useful
       * api can be created.
       * @function
       * @private
       */
      emulateExit: function() {
        this.tracker.exitHandler({ eventSource: this.tracker });
      }
    };
  }(OpenSeadragon), function(ie) {
    ie.Rect = function(Z, ee, ae, ve, ye) {
      this.x = typeof Z == "number" ? Z : 0, this.y = typeof ee == "number" ? ee : 0, this.width = typeof ae == "number" ? ae : 0, this.height = typeof ve == "number" ? ve : 0, this.degrees = typeof ye == "number" ? ye : 0, this.degrees = ie.positiveModulo(this.degrees, 360);
      var be, Ye;
      this.degrees >= 270 ? (be = this.getTopRight(), this.x = be.x, this.y = be.y, Ye = this.height, this.height = this.width, this.width = Ye, this.degrees -= 270) : this.degrees >= 180 ? (be = this.getBottomRight(), this.x = be.x, this.y = be.y, this.degrees -= 180) : this.degrees >= 90 && (be = this.getBottomLeft(), this.x = be.x, this.y = be.y, Ye = this.height, this.height = this.width, this.width = Ye, this.degrees -= 90);
    }, ie.Rect.fromSummits = function(Z, ee, ae) {
      var ve = Z.distanceTo(ee), ye = Z.distanceTo(ae), be = ee.minus(Z), Ye = Math.atan(be.y / be.x);
      return be.x < 0 ? Ye += Math.PI : be.y < 0 && (Ye += 2 * Math.PI), new ie.Rect(
        Z.x,
        Z.y,
        ve,
        ye,
        Ye / Math.PI * 180
      );
    }, ie.Rect.prototype = {
      /**
       * @function
       * @returns {OpenSeadragon.Rect} a duplicate of this Rect
       */
      clone: function() {
        return new ie.Rect(
          this.x,
          this.y,
          this.width,
          this.height,
          this.degrees
        );
      },
      /**
       * The aspect ratio is simply the ratio of width to height.
       * @function
       * @returns {Number} The ratio of width to height.
       */
      getAspectRatio: function() {
        return this.width / this.height;
      },
      /**
       * Provides the coordinates of the upper-left corner of the rectangle as a
       * point.
       * @function
       * @returns {OpenSeadragon.Point} The coordinate of the upper-left corner of
       *  the rectangle.
       */
      getTopLeft: function() {
        return new ie.Point(
          this.x,
          this.y
        );
      },
      /**
       * Provides the coordinates of the bottom-right corner of the rectangle as a
       * point.
       * @function
       * @returns {OpenSeadragon.Point} The coordinate of the bottom-right corner of
       *  the rectangle.
       */
      getBottomRight: function() {
        return new ie.Point(this.x + this.width, this.y + this.height).rotate(this.degrees, this.getTopLeft());
      },
      /**
       * Provides the coordinates of the top-right corner of the rectangle as a
       * point.
       * @function
       * @returns {OpenSeadragon.Point} The coordinate of the top-right corner of
       *  the rectangle.
       */
      getTopRight: function() {
        return new ie.Point(this.x + this.width, this.y).rotate(this.degrees, this.getTopLeft());
      },
      /**
       * Provides the coordinates of the bottom-left corner of the rectangle as a
       * point.
       * @function
       * @returns {OpenSeadragon.Point} The coordinate of the bottom-left corner of
       *  the rectangle.
       */
      getBottomLeft: function() {
        return new ie.Point(this.x, this.y + this.height).rotate(this.degrees, this.getTopLeft());
      },
      /**
       * Computes the center of the rectangle.
       * @function
       * @returns {OpenSeadragon.Point} The center of the rectangle as represented
       *  as represented by a 2-dimensional vector (x,y)
       */
      getCenter: function() {
        return new ie.Point(
          this.x + this.width / 2,
          this.y + this.height / 2
        ).rotate(this.degrees, this.getTopLeft());
      },
      /**
       * Returns the width and height component as a vector OpenSeadragon.Point
       * @function
       * @returns {OpenSeadragon.Point} The 2 dimensional vector representing the
       *  the width and height of the rectangle.
       */
      getSize: function() {
        return new ie.Point(this.width, this.height);
      },
      /**
       * Determines if two Rectangles have equivalent components.
       * @function
       * @param {OpenSeadragon.Rect} rectangle The Rectangle to compare to.
       * @return {Boolean} 'true' if all components are equal, otherwise 'false'.
       */
      equals: function(Z) {
        return Z instanceof ie.Rect && this.x === Z.x && this.y === Z.y && this.width === Z.width && this.height === Z.height && this.degrees === Z.degrees;
      },
      /**
      * Multiply all dimensions (except degrees) in this Rect by a factor and
      * return a new Rect.
      * @function
      * @param {Number} factor The factor to multiply vector components.
      * @returns {OpenSeadragon.Rect} A new rect representing the multiplication
      *  of the vector components by the factor
      */
      times: function(Z) {
        return new ie.Rect(
          this.x * Z,
          this.y * Z,
          this.width * Z,
          this.height * Z,
          this.degrees
        );
      },
      /**
      * Translate/move this Rect by a vector and return new Rect.
      * @function
      * @param {OpenSeadragon.Point} delta The translation vector.
      * @returns {OpenSeadragon.Rect} A new rect with altered position
      */
      translate: function(Z) {
        return new ie.Rect(
          this.x + Z.x,
          this.y + Z.y,
          this.width,
          this.height,
          this.degrees
        );
      },
      /**
       * Returns the smallest rectangle that will contain this and the given
       * rectangle bounding boxes.
       * @param {OpenSeadragon.Rect} rect
       * @return {OpenSeadragon.Rect} The new rectangle.
       */
      union: function(Z) {
        var ee = this.getBoundingBox(), ae = Z.getBoundingBox(), ve = Math.min(ee.x, ae.x), ye = Math.min(ee.y, ae.y), be = Math.max(
          ee.x + ee.width,
          ae.x + ae.width
        ), Ye = Math.max(
          ee.y + ee.height,
          ae.y + ae.height
        );
        return new ie.Rect(
          ve,
          ye,
          be - ve,
          Ye - ye
        );
      },
      /**
       * Returns the bounding box of the intersection of this rectangle with the
       * given rectangle.
       * @param {OpenSeadragon.Rect} rect
       * @return {OpenSeadragon.Rect} the bounding box of the intersection
       * or null if the rectangles don't intersect.
       */
      intersection: function(Z) {
        var ee = 1e-10, ae = [], ve = this.getTopLeft();
        Z.containsPoint(ve, ee) && ae.push(ve);
        var ye = this.getTopRight();
        Z.containsPoint(ye, ee) && ae.push(ye);
        var be = this.getBottomLeft();
        Z.containsPoint(be, ee) && ae.push(be);
        var Ye = this.getBottomRight();
        Z.containsPoint(Ye, ee) && ae.push(Ye);
        var Qe = Z.getTopLeft();
        this.containsPoint(Qe, ee) && ae.push(Qe);
        var Je = Z.getTopRight();
        this.containsPoint(Je, ee) && ae.push(Je);
        var nt = Z.getBottomLeft();
        this.containsPoint(nt, ee) && ae.push(nt);
        var st = Z.getBottomRight();
        this.containsPoint(st, ee) && ae.push(st);
        for (var ot = this._getSegments(), lt = Z._getSegments(), ft = 0; ft < ot.length; ft++)
          for (var gt = ot[ft], ct = 0; ct < lt.length; ct++) {
            var _r = lt[ct], Kr = Xr(
              gt[0],
              gt[1],
              _r[0],
              _r[1]
            );
            Kr && ae.push(Kr);
          }
        function Xr(pi, di, xi, Ti) {
          var Ai = di.minus(pi), mi = Ti.minus(xi), Si = -mi.x * Ai.y + Ai.x * mi.y;
          if (Si === 0)
            return null;
          var gi = (Ai.x * (pi.y - xi.y) - Ai.y * (pi.x - xi.x)) / Si, _i = (mi.x * (pi.y - xi.y) - mi.y * (pi.x - xi.x)) / Si;
          return -ee <= gi && gi <= 1 - ee && -ee <= _i && _i <= 1 - ee ? new ie.Point(pi.x + _i * Ai.x, pi.y + _i * Ai.y) : null;
        }
        if (ae.length === 0)
          return null;
        for (var Jr = ae[0].x, ei = ae[0].x, si = ae[0].y, ri = ae[0].y, ai = 1; ai < ae.length; ai++) {
          var yi = ae[ai];
          yi.x < Jr && (Jr = yi.x), yi.x > ei && (ei = yi.x), yi.y < si && (si = yi.y), yi.y > ri && (ri = yi.y);
        }
        return new ie.Rect(Jr, si, ei - Jr, ri - si);
      },
      // private
      _getSegments: function() {
        var Z = this.getTopLeft(), ee = this.getTopRight(), ae = this.getBottomLeft(), ve = this.getBottomRight();
        return [
          [Z, ee],
          [ee, ve],
          [ve, ae],
          [ae, Z]
        ];
      },
      /**
       * Rotates a rectangle around a point.
       * @function
       * @param {Number} degrees The angle in degrees to rotate.
       * @param {OpenSeadragon.Point} [pivot] The point about which to rotate.
       * Defaults to the center of the rectangle.
       * @return {OpenSeadragon.Rect}
       */
      rotate: function(Z, ee) {
        if (Z = ie.positiveModulo(Z, 360), Z === 0)
          return this.clone();
        ee = ee || this.getCenter();
        var ae = this.getTopLeft().rotate(Z, ee), ve = this.getTopRight().rotate(Z, ee), ye = ve.minus(ae);
        ye = ye.apply(function(Ye) {
          var Qe = 1e-15;
          return Math.abs(Ye) < Qe ? 0 : Ye;
        });
        var be = Math.atan(ye.y / ye.x);
        return ye.x < 0 ? be += Math.PI : ye.y < 0 && (be += 2 * Math.PI), new ie.Rect(
          ae.x,
          ae.y,
          this.width,
          this.height,
          be / Math.PI * 180
        );
      },
      /**
       * Retrieves the smallest horizontal (degrees=0) rectangle which contains
       * this rectangle.
       * @returns {OpenSeadragon.Rect}
       */
      getBoundingBox: function() {
        if (this.degrees === 0)
          return this.clone();
        var Z = this.getTopLeft(), ee = this.getTopRight(), ae = this.getBottomLeft(), ve = this.getBottomRight(), ye = Math.min(Z.x, ee.x, ae.x, ve.x), be = Math.max(Z.x, ee.x, ae.x, ve.x), Ye = Math.min(Z.y, ee.y, ae.y, ve.y), Qe = Math.max(Z.y, ee.y, ae.y, ve.y);
        return new ie.Rect(
          ye,
          Ye,
          be - ye,
          Qe - Ye
        );
      },
      /**
       * Retrieves the smallest horizontal (degrees=0) rectangle which contains
       * this rectangle and has integers x, y, width and height
       * @returns {OpenSeadragon.Rect}
       */
      getIntegerBoundingBox: function() {
        var Z = this.getBoundingBox(), ee = Math.floor(Z.x), ae = Math.floor(Z.y), ve = Math.ceil(Z.width + Z.x - ee), ye = Math.ceil(Z.height + Z.y - ae);
        return new ie.Rect(ee, ae, ve, ye);
      },
      /**
       * Determines whether a point is inside this rectangle (edge included).
       * @function
       * @param {OpenSeadragon.Point} point
       * @param {Number} [epsilon=0] the margin of error allowed
       * @returns {Boolean} true if the point is inside this rectangle, false
       * otherwise.
       */
      containsPoint: function(Z, ee) {
        ee = ee || 0;
        var ae = this.getTopLeft(), ve = this.getTopRight(), ye = this.getBottomLeft(), be = ve.minus(ae), Ye = ye.minus(ae);
        return (Z.x - ae.x) * be.x + (Z.y - ae.y) * be.y >= -ee && (Z.x - ve.x) * be.x + (Z.y - ve.y) * be.y <= ee && (Z.x - ae.x) * Ye.x + (Z.y - ae.y) * Ye.y >= -ee && (Z.x - ye.x) * Ye.x + (Z.y - ye.y) * Ye.y <= ee;
      },
      /**
       * Provides a string representation of the rectangle which is useful for
       * debugging.
       * @function
       * @returns {String} A string representation of the rectangle.
       */
      toString: function() {
        return "[" + Math.round(this.x * 100) / 100 + ", " + Math.round(this.y * 100) / 100 + ", " + Math.round(this.width * 100) / 100 + "x" + Math.round(this.height * 100) / 100 + ", " + Math.round(this.degrees * 100) / 100 + "deg]";
      }
    };
  }(OpenSeadragon), function(ie) {
    var Z = {};
    ie.ReferenceStrip = function(Je) {
      var nt = this, st = Je.viewer, ot = ie.getElementSize(st.element), lt, ft, gt;
      for (Je.id || (Je.id = "referencestrip-" + ie.now(), this.element = ie.makeNeutralElement("div"), this.element.id = Je.id, this.element.className = "referencestrip"), Je = ie.extend(!0, {
        sizeRatio: ie.DEFAULT_SETTINGS.referenceStripSizeRatio,
        position: ie.DEFAULT_SETTINGS.referenceStripPosition,
        scroll: ie.DEFAULT_SETTINGS.referenceStripScroll,
        clickTimeThreshold: ie.DEFAULT_SETTINGS.clickTimeThreshold
      }, Je, {
        //required overrides
        element: this.element,
        //These need to be overridden to prevent recursion since
        //the navigator is a viewer and a viewer has a navigator
        showNavigator: !1,
        mouseNavEnabled: !1,
        showNavigationControl: !1,
        showSequenceControl: !1
      }), ie.extend(this, Je), Z[this.id] = {
        animating: !1
      }, this.minPixelRatio = this.viewer.minPixelRatio, ft = this.element.style, ft.marginTop = "0px", ft.marginRight = "0px", ft.marginBottom = "0px", ft.marginLeft = "0px", ft.left = "0px", ft.bottom = "0px", ft.border = "0px", ft.background = "#000", ft.position = "relative", ie.setElementTouchActionNone(this.element), ie.setElementOpacity(this.element, 0.8), this.viewer = st, this.innerTracker = new ie.MouseTracker({
        element: this.element,
        dragHandler: ie.delegate(this, ee),
        scrollHandler: ie.delegate(this, ae),
        enterHandler: ie.delegate(this, ye),
        exitHandler: ie.delegate(this, be),
        keyDownHandler: ie.delegate(this, Ye),
        keyHandler: ie.delegate(this, Qe)
      }), Je.width && Je.height ? (this.element.style.width = Je.width + "px", this.element.style.height = Je.height + "px", st.addControl(
        this.element,
        { anchor: ie.ControlAnchor.BOTTOM_LEFT }
      )) : Je.scroll == "horizontal" ? (this.element.style.width = ot.x * Je.sizeRatio * st.tileSources.length + 12 * st.tileSources.length + "px", this.element.style.height = ot.y * Je.sizeRatio + "px", st.addControl(
        this.element,
        { anchor: ie.ControlAnchor.BOTTOM_LEFT }
      )) : (this.element.style.height = ot.y * Je.sizeRatio * st.tileSources.length + 12 * st.tileSources.length + "px", this.element.style.width = ot.x * Je.sizeRatio + "px", st.addControl(
        this.element,
        { anchor: ie.ControlAnchor.TOP_LEFT }
      )), this.panelWidth = ot.x * this.sizeRatio + 8, this.panelHeight = ot.y * this.sizeRatio + 8, this.panels = [], this.miniViewers = {}, gt = 0; gt < st.tileSources.length; gt++)
        lt = ie.makeNeutralElement("div"), lt.id = this.element.id + "-" + gt, lt.style.width = nt.panelWidth + "px", lt.style.height = nt.panelHeight + "px", lt.style.display = "inline", lt.style.float = "left", lt.style.cssFloat = "left", lt.style.styleFloat = "left", lt.style.padding = "2px", ie.setElementTouchActionNone(lt), lt.innerTracker = new ie.MouseTracker({
          element: lt,
          clickTimeThreshold: this.clickTimeThreshold,
          clickDistThreshold: this.clickDistThreshold,
          pressHandler: function(ct) {
            ct.eventSource.dragging = ie.now();
          },
          releaseHandler: function(ct) {
            var _r = ct.eventSource, Kr = _r.element.id, Xr = Number(Kr.split("-")[2]), Jr = ie.now();
            ct.insideElementPressed && ct.insideElementReleased && _r.dragging && Jr - _r.dragging < _r.clickTimeThreshold && (_r.dragging = null, st.goToPage(Xr));
          }
        }), this.element.appendChild(lt), lt.activePanel = !1, this.panels.push(lt);
      ve(this, this.scroll == "vertical" ? ot.y : ot.x, 0), this.setFocus(0);
    }, ie.extend(
      ie.ReferenceStrip.prototype,
      ie.EventSource.prototype,
      ie.Viewer.prototype,
      /** @lends OpenSeadragon.ReferenceStrip.prototype */
      {
        /**
         * @function
         */
        setFocus: function(Je) {
          var nt = this.element.querySelector("#" + this.element.id + "-" + Je), st = ie.getElementSize(this.viewer.canvas), ot = Number(this.element.style.width.replace("px", "")), lt = Number(this.element.style.height.replace("px", "")), ft = -Number(this.element.style.marginLeft.replace("px", "")), gt = -Number(this.element.style.marginTop.replace("px", "")), ct;
          this.currentSelected !== nt && (this.currentSelected && (this.currentSelected.style.background = "#000"), this.currentSelected = nt, this.currentSelected.style.background = "#999", this.scroll == "horizontal" ? (ct = Number(Je) * (this.panelWidth + 3), ct > ft + st.x - this.panelWidth ? (ct = Math.min(ct, ot - st.x), this.element.style.marginLeft = -ct + "px", ve(this, st.x, -ct)) : ct < ft && (ct = Math.max(0, ct - st.x / 2), this.element.style.marginLeft = -ct + "px", ve(this, st.x, -ct))) : (ct = Number(Je) * (this.panelHeight + 3), ct > gt + st.y - this.panelHeight ? (ct = Math.min(ct, lt - st.y), this.element.style.marginTop = -ct + "px", ve(this, st.y, -ct)) : ct < gt && (ct = Math.max(0, ct - st.y / 2), this.element.style.marginTop = -ct + "px", ve(this, st.y, -ct))), this.currentPage = Je, ye.call(this, { eventSource: this.innerTracker }));
        },
        /**
         * @function
         */
        update: function() {
          return Z[this.id].animating ? (ie.console.log("image reference strip update"), !0) : !1;
        },
        // Overrides Viewer.destroy
        destroy: function() {
          if (this.miniViewers)
            for (var Je in this.miniViewers)
              this.miniViewers[Je].destroy();
          this.element && this.element.parentNode.removeChild(this.element);
        }
      }
    );
    function ee(Je) {
      var nt = Number(this.element.style.marginLeft.replace("px", "")), st = Number(this.element.style.marginTop.replace("px", "")), ot = Number(this.element.style.width.replace("px", "")), lt = Number(this.element.style.height.replace("px", "")), ft = ie.getElementSize(this.viewer.canvas);
      return this.dragging = !0, this.element && (this.scroll == "horizontal" ? -Je.delta.x > 0 ? nt > -(ot - ft.x) && (this.element.style.marginLeft = nt + Je.delta.x * 2 + "px", ve(this, ft.x, nt + Je.delta.x * 2)) : -Je.delta.x < 0 && nt < 0 && (this.element.style.marginLeft = nt + Je.delta.x * 2 + "px", ve(this, ft.x, nt + Je.delta.x * 2)) : -Je.delta.y > 0 ? st > -(lt - ft.y) && (this.element.style.marginTop = st + Je.delta.y * 2 + "px", ve(this, ft.y, st + Je.delta.y * 2)) : -Je.delta.y < 0 && st < 0 && (this.element.style.marginTop = st + Je.delta.y * 2 + "px", ve(this, ft.y, st + Je.delta.y * 2))), !1;
    }
    function ae(Je) {
      var nt = Number(this.element.style.marginLeft.replace("px", "")), st = Number(this.element.style.marginTop.replace("px", "")), ot = Number(this.element.style.width.replace("px", "")), lt = Number(this.element.style.height.replace("px", "")), ft = ie.getElementSize(this.viewer.canvas);
      return this.element && (this.scroll == "horizontal" ? Je.scroll > 0 ? nt > -(ot - ft.x) && (this.element.style.marginLeft = nt - Je.scroll * 60 + "px", ve(this, ft.x, nt - Je.scroll * 60)) : Je.scroll < 0 && nt < 0 && (this.element.style.marginLeft = nt - Je.scroll * 60 + "px", ve(this, ft.x, nt - Je.scroll * 60)) : Je.scroll < 0 ? st > ft.y - lt && (this.element.style.marginTop = st + Je.scroll * 60 + "px", ve(this, ft.y, st + Je.scroll * 60)) : Je.scroll > 0 && st < 0 && (this.element.style.marginTop = st + Je.scroll * 60 + "px", ve(this, ft.y, st + Je.scroll * 60))), !1;
    }
    function ve(Je, nt, st) {
      var ot, lt, ft, gt, ct, _r, Kr;
      for (Je.scroll == "horizontal" ? ot = Je.panelWidth : ot = Je.panelHeight, lt = Math.ceil(nt / ot) + 5, ft = Math.ceil((Math.abs(st) + nt) / ot) + 1, lt = ft - lt, lt = lt < 0 ? 0 : lt, _r = lt; _r < ft && _r < Je.panels.length; _r++)
        if (Kr = Je.panels[_r], !Kr.activePanel) {
          var Xr, Jr = Je.viewer.tileSources[_r];
          Jr.referenceStripThumbnailUrl ? Xr = {
            type: "image",
            url: Jr.referenceStripThumbnailUrl
          } : Xr = Jr, gt = new ie.Viewer({
            id: Kr.id,
            tileSources: [Xr],
            element: Kr,
            navigatorSizeRatio: Je.sizeRatio,
            showNavigator: !1,
            mouseNavEnabled: !1,
            showNavigationControl: !1,
            showSequenceControl: !1,
            immediateRender: !0,
            blendTime: 0,
            animationTime: 0,
            loadTilesWithAjax: Je.viewer.loadTilesWithAjax,
            ajaxHeaders: Je.viewer.ajaxHeaders,
            useCanvas: Je.useCanvas
          }), gt.displayRegion = ie.makeNeutralElement("div"), gt.displayRegion.id = Kr.id + "-displayregion", gt.displayRegion.className = "displayregion", ct = gt.displayRegion.style, ct.position = "relative", ct.top = "0px", ct.left = "0px", ct.fontSize = "0px", ct.overflow = "hidden", ct.float = "left", ct.cssFloat = "left", ct.styleFloat = "left", ct.zIndex = 999999999, ct.cursor = "default", ct.width = Je.panelWidth - 4 + "px", ct.height = Je.panelHeight - 4 + "px", gt.displayRegion.innerTracker = new ie.MouseTracker({
            element: gt.displayRegion,
            startDisabled: !0
          }), Kr.getElementsByTagName("div")[0].appendChild(
            gt.displayRegion
          ), Je.miniViewers[Kr.id] = gt, Kr.activePanel = !0;
        }
    }
    function ye(Je) {
      var nt = Je.eventSource.element;
      return this.scroll == "horizontal" ? nt.style.marginBottom = "0px" : nt.style.marginLeft = "0px", !1;
    }
    function be(Je) {
      var nt = Je.eventSource.element;
      return this.scroll == "horizontal" ? nt.style.marginBottom = "-" + ie.getElementSize(nt).y / 2 + "px" : nt.style.marginLeft = "-" + ie.getElementSize(nt).x / 2 + "px", !1;
    }
    function Ye(Je) {
      if (!Je.preventDefaultAction && !Je.ctrl && !Je.alt && !Je.meta)
        switch (Je.keyCode) {
          case 38:
            return ae.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null }), !1;
          case 40:
            return ae.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null }), !1;
          case 37:
            return ae.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null }), !1;
          case 39:
            return ae.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null }), !1;
          default:
            return !0;
        }
      else
        return !0;
    }
    function Qe(Je) {
      if (!Je.preventDefaultAction && !Je.ctrl && !Je.alt && !Je.meta)
        switch (Je.keyCode) {
          case 61:
            return ae.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null }), !1;
          case 45:
            return ae.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null }), !1;
          case 48:
          case 119:
          case 87:
            return ae.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null }), !1;
          case 115:
          case 83:
            return ae.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null }), !1;
          case 97:
            return ae.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null }), !1;
          case 100:
            return ae.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null }), !1;
          default:
            return !0;
        }
      else
        return !0;
    }
  }(OpenSeadragon), function(ie) {
    ie.DisplayRect = function(Z, ee, ae, ve, ye, be) {
      ie.Rect.apply(this, [Z, ee, ae, ve]), this.minLevel = ye, this.maxLevel = be;
    }, ie.extend(ie.DisplayRect.prototype, ie.Rect.prototype);
  }(OpenSeadragon), function(ie) {
    ie.Spring = function(ee) {
      var ae = arguments;
      typeof ee != "object" && (ee = {
        initial: ae.length && typeof ae[0] == "number" ? ae[0] : void 0,
        /**
         * Spring stiffness.
         * @member {Number} springStiffness
         * @memberof OpenSeadragon.Spring#
         */
        springStiffness: ae.length > 1 ? ae[1].springStiffness : 5,
        /**
         * Animation duration per spring.
         * @member {Number} animationTime
         * @memberof OpenSeadragon.Spring#
         */
        animationTime: ae.length > 1 ? ae[1].animationTime : 1.5
      }), ie.console.assert(
        typeof ee.springStiffness == "number" && ee.springStiffness !== 0,
        "[OpenSeadragon.Spring] options.springStiffness must be a non-zero number"
      ), ie.console.assert(
        typeof ee.animationTime == "number" && ee.animationTime >= 0,
        "[OpenSeadragon.Spring] options.animationTime must be a number greater than or equal to 0"
      ), ee.exponential && (this._exponential = !0, delete ee.exponential), ie.extend(!0, this, ee), this.current = {
        value: typeof this.initial == "number" ? this.initial : this._exponential ? 0 : 1,
        time: ie.now()
        // always work in milliseconds
      }, ie.console.assert(
        !this._exponential || this.current.value !== 0,
        "[OpenSeadragon.Spring] value must be non-zero for exponential springs"
      ), this.start = {
        value: this.current.value,
        time: this.current.time
      }, this.target = {
        value: this.current.value,
        time: this.current.time
      }, this._exponential && (this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value), this.current._logValue = Math.log(this.current.value));
    }, ie.Spring.prototype = {
      /**
       * @function
       * @param {Number} target
       */
      resetTo: function(ee) {
        ie.console.assert(
          !this._exponential || ee !== 0,
          "[OpenSeadragon.Spring.resetTo] target must be non-zero for exponential springs"
        ), this.start.value = this.target.value = this.current.value = ee, this.start.time = this.target.time = this.current.time = ie.now(), this._exponential && (this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value), this.current._logValue = Math.log(this.current.value));
      },
      /**
       * @function
       * @param {Number} target
       */
      springTo: function(ee) {
        ie.console.assert(
          !this._exponential || ee !== 0,
          "[OpenSeadragon.Spring.springTo] target must be non-zero for exponential springs"
        ), this.start.value = this.current.value, this.start.time = this.current.time, this.target.value = ee, this.target.time = this.start.time + 1e3 * this.animationTime, this._exponential && (this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value));
      },
      /**
       * @function
       * @param {Number} delta
       */
      shiftBy: function(ee) {
        this.start.value += ee, this.target.value += ee, this._exponential && (ie.console.assert(
          this.target.value !== 0 && this.start.value !== 0,
          "[OpenSeadragon.Spring.shiftBy] spring value must be non-zero for exponential springs"
        ), this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value));
      },
      setExponential: function(ee) {
        this._exponential = ee, this._exponential && (ie.console.assert(
          this.current.value !== 0 && this.target.value !== 0 && this.start.value !== 0,
          "[OpenSeadragon.Spring.setExponential] spring value must be non-zero for exponential springs"
        ), this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value), this.current._logValue = Math.log(this.current.value));
      },
      /**
       * @function
       * @returns true if the value got updated, false otherwise
       */
      update: function() {
        this.current.time = ie.now();
        var ee, ae;
        this._exponential ? (ee = this.start._logValue, ae = this.target._logValue) : (ee = this.start.value, ae = this.target.value);
        var ve = this.current.time >= this.target.time ? ae : ee + (ae - ee) * Z(
          this.springStiffness,
          (this.current.time - this.start.time) / (this.target.time - this.start.time)
        ), ye = this.current.value;
        return this._exponential ? this.current.value = Math.exp(ve) : this.current.value = ve, ye != this.current.value;
      },
      /**
       * Returns whether the spring is at the target value
       * @function
       * @returns {Boolean} True if at target value, false otherwise
       */
      isAtTargetValue: function() {
        return this.current.value === this.target.value;
      }
    };
    function Z(ee, ae) {
      return (1 - Math.exp(ee * -ae)) / (1 - Math.exp(-ee));
    }
  }(OpenSeadragon), function(ie) {
    function Z(ae) {
      ie.extend(!0, this, {
        timeout: ie.DEFAULT_SETTINGS.timeout,
        jobId: null
      }, ae), this.image = null;
    }
    Z.prototype = {
      errorMsg: null,
      /**
       * Starts the image job.
       * @method
       */
      start: function() {
        var ae = this, ve = this.abort;
        this.image = new Image(), this.image.onload = function() {
          ae.finish(!0);
        }, this.image.onabort = this.image.onerror = function() {
          ae.errorMsg = "Image load aborted", ae.finish(!1);
        }, this.jobId = window.setTimeout(function() {
          ae.errorMsg = "Image load exceeded timeout (" + ae.timeout + " ms)", ae.finish(!1);
        }, this.timeout), this.loadWithAjax ? (this.request = ie.makeAjaxRequest({
          url: this.src,
          withCredentials: this.ajaxWithCredentials,
          headers: this.ajaxHeaders,
          responseType: "arraybuffer",
          success: function(ye) {
            var be;
            try {
              be = new window.Blob([ye.response]);
            } catch (nt) {
              var Ye = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
              if (nt.name === "TypeError" && Ye) {
                var Qe = new Ye();
                Qe.append(ye.response), be = Qe.getBlob();
              }
            }
            be.size === 0 && (ae.errorMsg = "Empty image response.", ae.finish(!1));
            var Je = (window.URL || window.webkitURL).createObjectURL(be);
            ae.image.src = Je;
          },
          error: function(ye) {
            ae.errorMsg = "Image load aborted - XHR error", ae.finish(!1);
          }
        }), this.abort = function() {
          ae.request.abort(), typeof ve == "function" && ve();
        }) : (this.crossOriginPolicy !== !1 && (this.image.crossOrigin = this.crossOriginPolicy), this.image.src = this.src);
      },
      finish: function(ae) {
        this.image.onload = this.image.onerror = this.image.onabort = null, ae || (this.image = null), this.jobId && window.clearTimeout(this.jobId), this.callback(this);
      }
    }, ie.ImageLoader = function(ae) {
      ie.extend(!0, this, {
        jobLimit: ie.DEFAULT_SETTINGS.imageLoaderLimit,
        timeout: ie.DEFAULT_SETTINGS.timeout,
        jobQueue: [],
        jobsInProgress: 0
      }, ae);
    }, ie.ImageLoader.prototype = {
      /**
       * Add an unloaded image to the loader queue.
       * @method
       * @param {Object} options - Options for this job.
       * @param {String} [options.src] - URL of image to download.
       * @param {String} [options.loadWithAjax] - Whether to load this image with AJAX.
       * @param {String} [options.ajaxHeaders] - Headers to add to the image request if using AJAX.
       * @param {String|Boolean} [options.crossOriginPolicy] - CORS policy to use for downloads
       * @param {Boolean} [options.ajaxWithCredentials] - Whether to set withCredentials on AJAX
       * requests.
       * @param {Function} [options.callback] - Called once image has been downloaded.
       * @param {Function} [options.abort] - Called when this image job is aborted.
       */
      addJob: function(ae) {
        var ve = this, ye = function(Qe) {
          ee(ve, Qe, ae.callback);
        }, be = {
          src: ae.src,
          loadWithAjax: ae.loadWithAjax,
          ajaxHeaders: ae.loadWithAjax ? ae.ajaxHeaders : null,
          crossOriginPolicy: ae.crossOriginPolicy,
          ajaxWithCredentials: ae.ajaxWithCredentials,
          callback: ye,
          abort: ae.abort,
          timeout: this.timeout
        }, Ye = new Z(be);
        !this.jobLimit || this.jobsInProgress < this.jobLimit ? (Ye.start(), this.jobsInProgress++) : this.jobQueue.push(Ye);
      },
      /**
       * Clear any unstarted image loading jobs from the queue.
       * @method
       */
      clear: function() {
        for (var ae = 0; ae < this.jobQueue.length; ae++) {
          var ve = this.jobQueue[ae];
          typeof ve.abort == "function" && ve.abort();
        }
        this.jobQueue = [];
      }
    };
    function ee(ae, ve, ye) {
      var be;
      ae.jobsInProgress--, (!ae.jobLimit || ae.jobsInProgress < ae.jobLimit) && ae.jobQueue.length > 0 && (be = ae.jobQueue.shift(), be.start(), ae.jobsInProgress++), ye(ve.image, ve.errorMsg, ve.request);
    }
  }(OpenSeadragon), function(ie) {
    ie.Tile = function(Z, ee, ae, ve, ye, be, Ye, Qe, Je, nt) {
      this.level = Z, this.x = ee, this.y = ae, this.bounds = ve, this.sourceBounds = nt, this.exists = ye, this.url = be, this.context2D = Ye, this.loadWithAjax = Qe, this.ajaxHeaders = Je, this.ajaxHeaders ? this.cacheKey = this.url + "+" + JSON.stringify(this.ajaxHeaders) : this.cacheKey = this.url, this.loaded = !1, this.loading = !1, this.element = null, this.imgElement = null, this.image = null, this.style = null, this.position = null, this.size = null, this.blendStart = null, this.opacity = null, this.squaredDistance = null, this.visibility = null, this.beingDrawn = !1, this.lastTouchTime = 0, this.isRightMost = !1, this.isBottomMost = !1;
    }, ie.Tile.prototype = {
      /**
       * Provides a string representation of this tiles level and (x,y)
       * components.
       * @function
       * @returns {String}
       */
      toString: function() {
        return this.level + "/" + this.x + "_" + this.y;
      },
      // private
      _hasTransparencyChannel: function() {
        return !!this.context2D || this.url.match(".png");
      },
      /**
       * Renders the tile in an html container.
       * @function
       * @param {Element} container
       */
      drawHTML: function(Z) {
        if (!this.cacheImageRecord) {
          ie.console.warn(
            "[Tile.drawHTML] attempting to draw tile %s when it's not cached",
            this.toString()
          );
          return;
        }
        if (!this.loaded) {
          ie.console.warn(
            "Attempting to draw tile %s when it's not yet loaded.",
            this.toString()
          );
          return;
        }
        this.element || (this.element = ie.makeNeutralElement("div"), this.imgElement = this.cacheImageRecord.getImage().cloneNode(), this.imgElement.style.msInterpolationMode = "nearest-neighbor", this.imgElement.style.width = "100%", this.imgElement.style.height = "100%", this.style = this.element.style, this.style.position = "absolute"), this.element.parentNode != Z && Z.appendChild(this.element), this.imgElement.parentNode != this.element && this.element.appendChild(this.imgElement), this.style.top = this.position.y + "px", this.style.left = this.position.x + "px", this.style.height = this.size.y + "px", this.style.width = this.size.x + "px", ie.setElementOpacity(this.element, this.opacity);
      },
      /**
       * Renders the tile in a canvas-based context.
       * @function
       * @param {Canvas} context
       * @param {Function} drawingHandler - Method for firing the drawing event.
       * drawingHandler({context, tile, rendered})
       * where <code>rendered</code> is the context with the pre-drawn image.
       * @param {Number} [scale=1] - Apply a scale to position and size
       * @param {OpenSeadragon.Point} [translate] - A translation vector
       */
      drawCanvas: function(Z, ee, ae, ve) {
        var ye = this.position.times(ie.pixelDensityRatio), be = this.size.times(ie.pixelDensityRatio), Ye;
        if (!this.context2D && !this.cacheImageRecord) {
          ie.console.warn(
            "[Tile.drawCanvas] attempting to draw tile %s when it's not cached",
            this.toString()
          );
          return;
        }
        if (Ye = this.context2D || this.cacheImageRecord.getRenderedContext(), !this.loaded || !Ye) {
          ie.console.warn(
            "Attempting to draw tile %s when it's not yet loaded.",
            this.toString()
          );
          return;
        }
        Z.save(), Z.globalAlpha = this.opacity, typeof ae == "number" && ae !== 1 && (ye = ye.times(ae), be = be.times(ae)), ve instanceof ie.Point && (ye = ye.plus(ve)), Z.globalAlpha === 1 && this._hasTransparencyChannel() && Z.clearRect(
          ye.x,
          ye.y,
          be.x,
          be.y
        ), ee({ context: Z, tile: this, rendered: Ye });
        var Qe, Je;
        this.sourceBounds ? (Qe = Math.min(this.sourceBounds.width, Ye.canvas.width), Je = Math.min(this.sourceBounds.height, Ye.canvas.height)) : (Qe = Ye.canvas.width, Je = Ye.canvas.height), Z.drawImage(
          Ye.canvas,
          0,
          0,
          Qe,
          Je,
          ye.x,
          ye.y,
          be.x,
          be.y
        ), Z.restore();
      },
      /**
       * Get the ratio between current and original size.
       * @function
       * @return {Float}
       */
      getScaleForEdgeSmoothing: function() {
        var Z;
        if (this.cacheImageRecord)
          Z = this.cacheImageRecord.getRenderedContext();
        else if (this.context2D)
          Z = this.context2D;
        else
          return ie.console.warn(
            "[Tile.drawCanvas] attempting to get tile scale %s when tile's not cached",
            this.toString()
          ), 1;
        return Z.canvas.width / (this.size.x * ie.pixelDensityRatio);
      },
      /**
       * Get a translation vector that when applied to the tile position produces integer coordinates.
       * Needed to avoid swimming and twitching.
       * @function
       * @param {Number} [scale=1] - Scale to be applied to position.
       * @return {OpenSeadragon.Point}
       */
      getTranslationForEdgeSmoothing: function(Z, ee, ae) {
        var ve = Math.max(1, Math.ceil((ae.x - ee.x) / 2)), ye = Math.max(1, Math.ceil((ae.y - ee.y) / 2));
        return new ie.Point(ve, ye).minus(
          this.position.times(ie.pixelDensityRatio).times(Z || 1).apply(function(be) {
            return be % 1;
          })
        );
      },
      /**
       * Removes tile from its container.
       * @function
       */
      unload: function() {
        this.imgElement && this.imgElement.parentNode && this.imgElement.parentNode.removeChild(this.imgElement), this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element), this.element = null, this.imgElement = null, this.loaded = !1, this.loading = !1;
      }
    };
  }(OpenSeadragon), function(ie) {
    ie.OverlayPlacement = ie.Placement, ie.OverlayRotationMode = ie.freezeObject({
      NO_ROTATION: 1,
      EXACT: 2,
      BOUNDING_BOX: 3
    }), ie.Overlay = function(Z, ee, ae) {
      var ve;
      ie.isPlainObject(Z) ? ve = Z : ve = {
        element: Z,
        location: ee,
        placement: ae
      }, this.element = ve.element, this.style = ve.element.style, this._init(ve);
    }, ie.Overlay.prototype = {
      // private
      _init: function(Z) {
        this.location = Z.location, this.placement = Z.placement === void 0 ? ie.Placement.TOP_LEFT : Z.placement, this.onDraw = Z.onDraw, this.checkResize = Z.checkResize === void 0 ? !0 : Z.checkResize, this.width = Z.width === void 0 ? null : Z.width, this.height = Z.height === void 0 ? null : Z.height, this.rotationMode = Z.rotationMode || ie.OverlayRotationMode.EXACT, this.location instanceof ie.Rect && (this.width = this.location.width, this.height = this.location.height, this.location = this.location.getTopLeft(), this.placement = ie.Placement.TOP_LEFT), this.scales = this.width !== null && this.height !== null, this.bounds = new ie.Rect(
          this.location.x,
          this.location.y,
          this.width,
          this.height
        ), this.position = this.location;
      },
      /**
       * Internal function to adjust the position of an overlay
       * depending on it size and placement.
       * @function
       * @param {OpenSeadragon.Point} position
       * @param {OpenSeadragon.Point} size
       */
      adjust: function(Z, ee) {
        var ae = ie.Placement.properties[this.placement];
        ae && (ae.isHorizontallyCentered ? Z.x -= ee.x / 2 : ae.isRight && (Z.x -= ee.x), ae.isVerticallyCentered ? Z.y -= ee.y / 2 : ae.isBottom && (Z.y -= ee.y));
      },
      /**
       * @function
       */
      destroy: function() {
        var Z = this.element, ee = this.style;
        Z.parentNode && (Z.parentNode.removeChild(Z), Z.prevElementParent && (ee.display = "none", document.body.appendChild(Z))), this.onDraw = null, ee.top = "", ee.left = "", ee.position = "", this.width !== null && (ee.width = ""), this.height !== null && (ee.height = "");
        var ae = ie.getCssPropertyWithVendorPrefix(
          "transformOrigin"
        ), ve = ie.getCssPropertyWithVendorPrefix(
          "transform"
        );
        ae && ve && (ee[ae] = "", ee[ve] = "");
      },
      /**
       * @function
       * @param {Element} container
       */
      drawHTML: function(Z, ee) {
        var ae = this.element;
        ae.parentNode !== Z && (ae.prevElementParent = ae.parentNode, ae.prevNextSibling = ae.nextSibling, Z.appendChild(ae), this.style.position = "absolute", this.size = ie.getElementSize(ae));
        var ve = this._getOverlayPositionAndSize(ee), ye = ve.position, be = this.size = ve.size, Ye = ve.rotate;
        if (this.onDraw)
          this.onDraw(ye, be, this.element);
        else {
          var Qe = this.style;
          Qe.left = ye.x + "px", Qe.top = ye.y + "px", this.width !== null && (Qe.width = be.x + "px"), this.height !== null && (Qe.height = be.y + "px");
          var Je = ie.getCssPropertyWithVendorPrefix(
            "transformOrigin"
          ), nt = ie.getCssPropertyWithVendorPrefix(
            "transform"
          );
          Je && nt && (Ye ? (Qe[Je] = this._getTransformOrigin(), Qe[nt] = "rotate(" + Ye + "deg)") : (Qe[Je] = "", Qe[nt] = "")), Qe.display !== "none" && (Qe.display = "block");
        }
      },
      // private
      _getOverlayPositionAndSize: function(Z) {
        var ee = Z.pixelFromPoint(this.location, !0), ae = this._getSizeInPixels(Z);
        this.adjust(ee, ae);
        var ve = 0;
        if (Z.degrees && this.rotationMode !== ie.OverlayRotationMode.NO_ROTATION)
          if (this.rotationMode === ie.OverlayRotationMode.BOUNDING_BOX && this.width !== null && this.height !== null) {
            var ye = new ie.Rect(ee.x, ee.y, ae.x, ae.y), be = this._getBoundingBox(ye, Z.degrees);
            ee = be.getTopLeft(), ae = be.getSize();
          } else
            ve = Z.degrees;
        return {
          position: ee,
          size: ae,
          rotate: ve
        };
      },
      // private
      _getSizeInPixels: function(Z) {
        var ee = this.size.x, ae = this.size.y;
        if (this.width !== null || this.height !== null) {
          var ve = Z.deltaPixelsFromPointsNoRotate(
            new ie.Point(this.width || 0, this.height || 0),
            !0
          );
          this.width !== null && (ee = ve.x), this.height !== null && (ae = ve.y);
        }
        if (this.checkResize && (this.width === null || this.height === null)) {
          var ye = this.size = ie.getElementSize(this.element);
          this.width === null && (ee = ye.x), this.height === null && (ae = ye.y);
        }
        return new ie.Point(ee, ae);
      },
      // private
      _getBoundingBox: function(Z, ee) {
        var ae = this._getPlacementPoint(Z);
        return Z.rotate(ee, ae).getBoundingBox();
      },
      // private
      _getPlacementPoint: function(Z) {
        var ee = new ie.Point(Z.x, Z.y), ae = ie.Placement.properties[this.placement];
        return ae && (ae.isHorizontallyCentered ? ee.x += Z.width / 2 : ae.isRight && (ee.x += Z.width), ae.isVerticallyCentered ? ee.y += Z.height / 2 : ae.isBottom && (ee.y += Z.height)), ee;
      },
      // private
      _getTransformOrigin: function() {
        var Z = "", ee = ie.Placement.properties[this.placement];
        return ee && (ee.isLeft ? Z = "left" : ee.isRight && (Z = "right"), ee.isTop ? Z += " top" : ee.isBottom && (Z += " bottom")), Z;
      },
      /**
       * Changes the overlay settings.
       * @function
       * @param {OpenSeadragon.Point|OpenSeadragon.Rect|Object} location
       * If an object is specified, the options are the same than the constructor
       * except for the element which can not be changed.
       * @param {OpenSeadragon.Placement} placement
       */
      update: function(Z, ee) {
        var ae = ie.isPlainObject(Z) ? Z : {
          location: Z,
          placement: ee
        };
        this._init({
          location: ae.location || this.location,
          placement: ae.placement !== void 0 ? ae.placement : this.placement,
          onDraw: ae.onDraw || this.onDraw,
          checkResize: ae.checkResize || this.checkResize,
          width: ae.width !== void 0 ? ae.width : this.width,
          height: ae.height !== void 0 ? ae.height : this.height,
          rotationMode: ae.rotationMode || this.rotationMode
        });
      },
      /**
       * Returns the current bounds of the overlay in viewport coordinates
       * @function
       * @param {OpenSeadragon.Viewport} viewport the viewport
       * @returns {OpenSeadragon.Rect} overlay bounds
       */
      getBounds: function(Z) {
        ie.console.assert(
          Z,
          "A viewport must now be passed to Overlay.getBounds."
        );
        var ee = this.width, ae = this.height;
        if (ee === null || ae === null) {
          var ve = Z.deltaPointsFromPixelsNoRotate(this.size, !0);
          ee === null && (ee = ve.x), ae === null && (ae = ve.y);
        }
        var ye = this.location.clone();
        return this.adjust(ye, new ie.Point(ee, ae)), this._adjustBoundsForRotation(
          Z,
          new ie.Rect(ye.x, ye.y, ee, ae)
        );
      },
      // private
      _adjustBoundsForRotation: function(Z, ee) {
        if (!Z || Z.degrees === 0 || this.rotationMode === ie.OverlayRotationMode.EXACT)
          return ee;
        if (this.rotationMode === ie.OverlayRotationMode.BOUNDING_BOX) {
          if (this.width === null || this.height === null)
            return ee;
          var ae = this._getOverlayPositionAndSize(Z);
          return Z.viewerElementToViewportRectangle(new ie.Rect(
            ae.position.x,
            ae.position.y,
            ae.size.x,
            ae.size.y
          ));
        }
        return ee.rotate(
          -Z.degrees,
          this._getPlacementPoint(ee)
        );
      }
    };
  }(OpenSeadragon), function(ie) {
    ie.Drawer = function(Z) {
      ie.console.assert(Z.viewer, "[Drawer] options.viewer is required");
      var ee = arguments;
      if (ie.isPlainObject(Z) || (Z = {
        source: ee[0],
        // Reference to Viewer tile source.
        viewport: ee[1],
        // Reference to Viewer viewport.
        element: ee[2]
        // Parent element.
      }), ie.console.assert(Z.viewport, "[Drawer] options.viewport is required"), ie.console.assert(Z.element, "[Drawer] options.element is required"), Z.source && ie.console.error("[Drawer] options.source is no longer accepted; use TiledImage instead"), this.viewer = Z.viewer, this.viewport = Z.viewport, this.debugGridColor = typeof Z.debugGridColor == "string" ? [Z.debugGridColor] : Z.debugGridColor || ie.DEFAULT_SETTINGS.debugGridColor, Z.opacity && ie.console.error("[Drawer] options.opacity is no longer accepted; set the opacity on the TiledImage instead"), this.useCanvas = ie.supportsCanvas && (this.viewer ? this.viewer.useCanvas : !0), this.container = ie.getElement(Z.element), this.canvas = ie.makeNeutralElement(this.useCanvas ? "canvas" : "div"), this.context = this.useCanvas ? this.canvas.getContext("2d") : null, this.sketchCanvas = null, this.sketchContext = null, this.element = this.container, this.container.dir = "ltr", this.useCanvas) {
        var ae = this._calculateCanvasSize();
        this.canvas.width = ae.x, this.canvas.height = ae.y;
      }
      this.canvas.style.width = "100%", this.canvas.style.height = "100%", this.canvas.style.position = "absolute", ie.setElementOpacity(this.canvas, this.opacity, !0), this.container.style.textAlign = "left", this.container.appendChild(this.canvas), this._imageSmoothingEnabled = !0;
    }, ie.Drawer.prototype = {
      // deprecated
      addOverlay: function(Z, ee, ae, ve) {
        return ie.console.error("drawer.addOverlay is deprecated. Use viewer.addOverlay instead."), this.viewer.addOverlay(Z, ee, ae, ve), this;
      },
      // deprecated
      updateOverlay: function(Z, ee, ae) {
        return ie.console.error("drawer.updateOverlay is deprecated. Use viewer.updateOverlay instead."), this.viewer.updateOverlay(Z, ee, ae), this;
      },
      // deprecated
      removeOverlay: function(Z) {
        return ie.console.error("drawer.removeOverlay is deprecated. Use viewer.removeOverlay instead."), this.viewer.removeOverlay(Z), this;
      },
      // deprecated
      clearOverlays: function() {
        return ie.console.error("drawer.clearOverlays is deprecated. Use viewer.clearOverlays instead."), this.viewer.clearOverlays(), this;
      },
      /**
       * This function converts the given point from to the drawer coordinate by
       * multiplying it with the pixel density.
       * This function does not take rotation into account, thus assuming provided
       * point is at 0 degree.
       * @param {OpenSeadragon.Point} point - the pixel point to convert
       */
      viewportCoordToDrawerCoord: function(Z) {
        var ee = this.viewport.pixelFromPointNoRotate(Z, !0);
        return new ie.Point(
          ee.x * ie.pixelDensityRatio,
          ee.y * ie.pixelDensityRatio
        );
      },
      /**
       * This function will create multiple polygon paths on the drawing context by provided polygons,
       * then clip the context to the paths.
       * @param {(OpenSeadragon.Point[])[]} polygons - an array of polygons. A polygon is an array of OpenSeadragon.Point
       * @param {Boolean} useSketch - Whether to use the sketch canvas or not.
       */
      clipWithPolygons: function(Z, ee) {
        if (this.useCanvas) {
          var ae = this._getContext(ee);
          ae.beginPath(), Z.forEach(function(ve) {
            ve.forEach(function(ye, be) {
              ae[be === 0 ? "moveTo" : "lineTo"](ye.x, ye.y);
            });
          }), ae.clip();
        }
      },
      /**
       * Set the opacity of the drawer.
       * @param {Number} opacity
       * @return {OpenSeadragon.Drawer} Chainable.
       */
      setOpacity: function(Z) {
        ie.console.error("drawer.setOpacity is deprecated. Use tiledImage.setOpacity instead.");
        for (var ee = this.viewer.world, ae = 0; ae < ee.getItemCount(); ae++)
          ee.getItemAt(ae).setOpacity(Z);
        return this;
      },
      /**
       * Get the opacity of the drawer.
       * @returns {Number}
       */
      getOpacity: function() {
        ie.console.error("drawer.getOpacity is deprecated. Use tiledImage.getOpacity instead.");
        for (var Z = this.viewer.world, ee = 0, ae = 0; ae < Z.getItemCount(); ae++) {
          var ve = Z.getItemAt(ae).getOpacity();
          ve > ee && (ee = ve);
        }
        return ee;
      },
      // deprecated
      needsUpdate: function() {
        return ie.console.error("[Drawer.needsUpdate] this function is deprecated. Use World.needsDraw instead."), this.viewer.world.needsDraw();
      },
      // deprecated
      numTilesLoaded: function() {
        return ie.console.error("[Drawer.numTilesLoaded] this function is deprecated. Use TileCache.numTilesLoaded instead."), this.viewer.tileCache.numTilesLoaded();
      },
      // deprecated
      reset: function() {
        return ie.console.error("[Drawer.reset] this function is deprecated. Use World.resetItems instead."), this.viewer.world.resetItems(), this;
      },
      // deprecated
      update: function() {
        return ie.console.error("[Drawer.update] this function is deprecated. Use Drawer.clear and World.draw instead."), this.clear(), this.viewer.world.draw(), this;
      },
      /**
       * @return {Boolean} True if rotation is supported.
       */
      canRotate: function() {
        return this.useCanvas;
      },
      /**
       * Destroy the drawer (unload current loaded tiles)
       */
      destroy: function() {
        this.canvas.width = 1, this.canvas.height = 1, this.sketchCanvas = null, this.sketchContext = null;
      },
      /**
       * Clears the Drawer so it's ready to draw another frame.
       */
      clear: function() {
        if (this.canvas.innerHTML = "", this.useCanvas) {
          var Z = this._calculateCanvasSize();
          if ((this.canvas.width != Z.x || this.canvas.height != Z.y) && (this.canvas.width = Z.x, this.canvas.height = Z.y, this._updateImageSmoothingEnabled(this.context), this.sketchCanvas !== null)) {
            var ee = this._calculateSketchCanvasSize();
            this.sketchCanvas.width = ee.x, this.sketchCanvas.height = ee.y, this._updateImageSmoothingEnabled(this.sketchContext);
          }
          this._clear();
        }
      },
      _clear: function(Z, ee) {
        if (this.useCanvas) {
          var ae = this._getContext(Z);
          if (ee)
            ae.clearRect(ee.x, ee.y, ee.width, ee.height);
          else {
            var ve = ae.canvas;
            ae.clearRect(0, 0, ve.width, ve.height);
          }
        }
      },
      /**
       * Scale from OpenSeadragon viewer rectangle to drawer rectangle
       * (ignoring rotation)
       * @param {OpenSeadragon.Rect} rectangle - The rectangle in viewport coordinate system.
       * @return {OpenSeadragon.Rect} Rectangle in drawer coordinate system.
       */
      viewportToDrawerRectangle: function(Z) {
        var ee = this.viewport.pixelFromPointNoRotate(Z.getTopLeft(), !0), ae = this.viewport.deltaPixelsFromPointsNoRotate(Z.getSize(), !0);
        return new ie.Rect(
          ee.x * ie.pixelDensityRatio,
          ee.y * ie.pixelDensityRatio,
          ae.x * ie.pixelDensityRatio,
          ae.y * ie.pixelDensityRatio
        );
      },
      /**
       * Draws the given tile.
       * @param {OpenSeadragon.Tile} tile - The tile to draw.
       * @param {Function} drawingHandler - Method for firing the drawing event if using canvas.
       * drawingHandler({context, tile, rendered})
       * @param {Boolean} useSketch - Whether to use the sketch canvas or not.
       * where <code>rendered</code> is the context with the pre-drawn image.
       * @param {Float} [scale=1] - Apply a scale to tile position and size. Defaults to 1.
       * @param {OpenSeadragon.Point} [translate] A translation vector to offset tile position
       */
      drawTile: function(Z, ee, ae, ve, ye) {
        if (ie.console.assert(Z, "[Drawer.drawTile] tile is required"), ie.console.assert(ee, "[Drawer.drawTile] drawingHandler is required"), this.useCanvas) {
          var be = this._getContext(ae);
          ve = ve || 1, Z.drawCanvas(be, ee, ve, ye);
        } else
          Z.drawHTML(this.canvas);
      },
      _getContext: function(Z) {
        var ee = this.context;
        if (Z) {
          if (this.sketchCanvas === null) {
            this.sketchCanvas = document.createElement("canvas");
            var ae = this._calculateSketchCanvasSize();
            if (this.sketchCanvas.width = ae.x, this.sketchCanvas.height = ae.y, this.sketchContext = this.sketchCanvas.getContext("2d"), this.viewport.getRotation() === 0) {
              var ve = this;
              this.viewer.addHandler("rotate", function ye() {
                if (ve.viewport.getRotation() !== 0) {
                  ve.viewer.removeHandler("rotate", ye);
                  var be = ve._calculateSketchCanvasSize();
                  ve.sketchCanvas.width = be.x, ve.sketchCanvas.height = be.y;
                }
              });
            }
            this._updateImageSmoothingEnabled(this.sketchContext);
          }
          ee = this.sketchContext;
        }
        return ee;
      },
      // private
      saveContext: function(Z) {
        this.useCanvas && this._getContext(Z).save();
      },
      // private
      restoreContext: function(Z) {
        this.useCanvas && this._getContext(Z).restore();
      },
      // private
      setClip: function(Z, ee) {
        if (this.useCanvas) {
          var ae = this._getContext(ee);
          ae.beginPath(), ae.rect(Z.x, Z.y, Z.width, Z.height), ae.clip();
        }
      },
      // private
      drawRectangle: function(Z, ee, ae) {
        if (this.useCanvas) {
          var ve = this._getContext(ae);
          ve.save(), ve.fillStyle = ee, ve.fillRect(Z.x, Z.y, Z.width, Z.height), ve.restore();
        }
      },
      /**
       * Blends the sketch canvas in the main canvas.
       * @param {Object} options The options
       * @param {Float} options.opacity The opacity of the blending.
       * @param {Float} [options.scale=1] The scale at which tiles were drawn on
       * the sketch. Default is 1.
       * Use scale to draw at a lower scale and then enlarge onto the main canvas.
       * @param {OpenSeadragon.Point} [options.translate] A translation vector
       * that was used to draw the tiles
       * @param {String} [options.compositeOperation] - How the image is
       * composited onto other images; see compositeOperation in
       * {@link OpenSeadragon.Options} for possible values.
       * @param {OpenSeadragon.Rect} [options.bounds] The part of the sketch
       * canvas to blend in the main canvas. If specified, options.scale and
       * options.translate get ignored.
       */
      blendSketch: function(Z, ee, ae, ve) {
        var ye = Z;
        if (ie.isPlainObject(ye) || (ye = {
          opacity: Z,
          scale: ee,
          translate: ae,
          compositeOperation: ve
        }), !(!this.useCanvas || !this.sketchCanvas)) {
          Z = ye.opacity, ve = ye.compositeOperation;
          var be = ye.bounds;
          if (this.context.save(), this.context.globalAlpha = Z, ve && (this.context.globalCompositeOperation = ve), be)
            be.x < 0 && (be.width += be.x, be.x = 0), be.x + be.width > this.canvas.width && (be.width = this.canvas.width - be.x), be.y < 0 && (be.height += be.y, be.y = 0), be.y + be.height > this.canvas.height && (be.height = this.canvas.height - be.y), this.context.drawImage(
              this.sketchCanvas,
              be.x,
              be.y,
              be.width,
              be.height,
              be.x,
              be.y,
              be.width,
              be.height
            );
          else {
            ee = ye.scale || 1, ae = ye.translate;
            var Ye = ae instanceof ie.Point ? ae : new ie.Point(0, 0), Qe = 0, Je = 0;
            if (ae) {
              var nt = this.sketchCanvas.width - this.canvas.width, st = this.sketchCanvas.height - this.canvas.height;
              Qe = Math.round(nt / 2), Je = Math.round(st / 2);
            }
            this.context.drawImage(
              this.sketchCanvas,
              Ye.x - Qe * ee,
              Ye.y - Je * ee,
              (this.canvas.width + 2 * Qe) * ee,
              (this.canvas.height + 2 * Je) * ee,
              -Qe,
              -Je,
              this.canvas.width + 2 * Qe,
              this.canvas.height + 2 * Je
            );
          }
          this.context.restore();
        }
      },
      // private
      drawDebugInfo: function(Z, ee, ae, ve) {
        if (this.useCanvas) {
          var ye = this.viewer.world.getIndexOfItem(ve) % this.debugGridColor.length, be = this.context;
          be.save(), be.lineWidth = 2 * ie.pixelDensityRatio, be.font = "small-caps bold " + 13 * ie.pixelDensityRatio + "px arial", be.strokeStyle = this.debugGridColor[ye], be.fillStyle = this.debugGridColor[ye], this.viewport.degrees !== 0 && this._offsetForRotation({ degrees: this.viewport.degrees }), ve.getRotation(!0) % 360 !== 0 && this._offsetForRotation({
            degrees: ve.getRotation(!0),
            point: ve.viewport.pixelFromPointNoRotate(
              ve._getRotationPoint(!0),
              !0
            )
          }), ve.viewport.degrees === 0 && ve.getRotation(!0) % 360 === 0 && ve._drawer.viewer.viewport.getFlip() && ve._drawer._flip(), be.strokeRect(
            Z.position.x * ie.pixelDensityRatio,
            Z.position.y * ie.pixelDensityRatio,
            Z.size.x * ie.pixelDensityRatio,
            Z.size.y * ie.pixelDensityRatio
          );
          var Ye = (Z.position.x + Z.size.x / 2) * ie.pixelDensityRatio, Qe = (Z.position.y + Z.size.y / 2) * ie.pixelDensityRatio;
          be.translate(Ye, Qe), be.rotate(Math.PI / 180 * -this.viewport.degrees), be.translate(-Ye, -Qe), Z.x === 0 && Z.y === 0 && (be.fillText(
            "Zoom: " + this.viewport.getZoom(),
            Z.position.x * ie.pixelDensityRatio,
            (Z.position.y - 30) * ie.pixelDensityRatio
          ), be.fillText(
            "Pan: " + this.viewport.getBounds().toString(),
            Z.position.x * ie.pixelDensityRatio,
            (Z.position.y - 20) * ie.pixelDensityRatio
          )), be.fillText(
            "Level: " + Z.level,
            (Z.position.x + 10) * ie.pixelDensityRatio,
            (Z.position.y + 20) * ie.pixelDensityRatio
          ), be.fillText(
            "Column: " + Z.x,
            (Z.position.x + 10) * ie.pixelDensityRatio,
            (Z.position.y + 30) * ie.pixelDensityRatio
          ), be.fillText(
            "Row: " + Z.y,
            (Z.position.x + 10) * ie.pixelDensityRatio,
            (Z.position.y + 40) * ie.pixelDensityRatio
          ), be.fillText(
            "Order: " + ae + " of " + ee,
            (Z.position.x + 10) * ie.pixelDensityRatio,
            (Z.position.y + 50) * ie.pixelDensityRatio
          ), be.fillText(
            "Size: " + Z.size.toString(),
            (Z.position.x + 10) * ie.pixelDensityRatio,
            (Z.position.y + 60) * ie.pixelDensityRatio
          ), be.fillText(
            "Position: " + Z.position.toString(),
            (Z.position.x + 10) * ie.pixelDensityRatio,
            (Z.position.y + 70) * ie.pixelDensityRatio
          ), this.viewport.degrees !== 0 && this._restoreRotationChanges(), ve.getRotation(!0) % 360 !== 0 && this._restoreRotationChanges(), ve.viewport.degrees === 0 && ve.getRotation(!0) % 360 === 0 && ve._drawer.viewer.viewport.getFlip() && ve._drawer._flip(), be.restore();
        }
      },
      // private
      debugRect: function(Z) {
        if (this.useCanvas) {
          var ee = this.context;
          ee.save(), ee.lineWidth = 2 * ie.pixelDensityRatio, ee.strokeStyle = this.debugGridColor[0], ee.fillStyle = this.debugGridColor[0], ee.strokeRect(
            Z.x * ie.pixelDensityRatio,
            Z.y * ie.pixelDensityRatio,
            Z.width * ie.pixelDensityRatio,
            Z.height * ie.pixelDensityRatio
          ), ee.restore();
        }
      },
      /**
       * Turns image smoothing on or off for this viewer. Note: Ignored in some (especially older) browsers that do not support this property.
       *
       * @function
       * @param {Boolean} [imageSmoothingEnabled] - Whether or not the image is
       * drawn smoothly on the canvas; see imageSmoothingEnabled in
       * {@link OpenSeadragon.Options} for more explanation.
       */
      setImageSmoothingEnabled: function(Z) {
        this.useCanvas && (this._imageSmoothingEnabled = Z, this._updateImageSmoothingEnabled(this.context), this.viewer.forceRedraw());
      },
      // private
      _updateImageSmoothingEnabled: function(Z) {
        Z.msImageSmoothingEnabled = this._imageSmoothingEnabled, Z.imageSmoothingEnabled = this._imageSmoothingEnabled;
      },
      /**
       * Get the canvas size
       * @param {Boolean} sketch If set to true return the size of the sketch canvas
       * @returns {OpenSeadragon.Point} The size of the canvas
       */
      getCanvasSize: function(Z) {
        var ee = this._getContext(Z).canvas;
        return new ie.Point(ee.width, ee.height);
      },
      getCanvasCenter: function() {
        return new ie.Point(this.canvas.width / 2, this.canvas.height / 2);
      },
      // private
      _offsetForRotation: function(Z) {
        var ee = Z.point ? Z.point.times(ie.pixelDensityRatio) : this.getCanvasCenter(), ae = this._getContext(Z.useSketch);
        ae.save(), ae.translate(ee.x, ee.y), this.viewer.viewport.flipped ? (ae.rotate(Math.PI / 180 * -Z.degrees), ae.scale(-1, 1)) : ae.rotate(Math.PI / 180 * Z.degrees), ae.translate(-ee.x, -ee.y);
      },
      // private
      _flip: function(Z) {
        Z = Z || {};
        var ee = Z.point ? Z.point.times(ie.pixelDensityRatio) : this.getCanvasCenter(), ae = this._getContext(Z.useSketch);
        ae.translate(ee.x, 0), ae.scale(-1, 1), ae.translate(-ee.x, 0);
      },
      // private
      _restoreRotationChanges: function(Z) {
        var ee = this._getContext(Z);
        ee.restore();
      },
      // private
      _calculateCanvasSize: function() {
        var Z = ie.pixelDensityRatio, ee = this.viewport.getContainerSize();
        return {
          // canvas width and height are integers
          x: Math.round(ee.x * Z),
          y: Math.round(ee.y * Z)
        };
      },
      // private
      _calculateSketchCanvasSize: function() {
        var Z = this._calculateCanvasSize();
        if (this.viewport.getRotation() === 0)
          return Z;
        var ee = Math.ceil(Math.sqrt(
          Z.x * Z.x + Z.y * Z.y
        ));
        return {
          x: ee,
          y: ee
        };
      }
    };
  }(OpenSeadragon), function(ie) {
    ie.Viewport = function(Z) {
      var ee = arguments;
      ee.length && ee[0] instanceof ie.Point && (Z = {
        containerSize: ee[0],
        contentSize: ee[1],
        config: ee[2]
      }), Z.config && (ie.extend(!0, Z, Z.config), delete Z.config), this._margins = ie.extend({
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      }, Z.margins || {}), delete Z.margins, ie.extend(!0, this, {
        //required settings
        containerSize: null,
        contentSize: null,
        //internal state properties
        zoomPoint: null,
        viewer: null,
        //configurable options
        springStiffness: ie.DEFAULT_SETTINGS.springStiffness,
        animationTime: ie.DEFAULT_SETTINGS.animationTime,
        minZoomImageRatio: ie.DEFAULT_SETTINGS.minZoomImageRatio,
        maxZoomPixelRatio: ie.DEFAULT_SETTINGS.maxZoomPixelRatio,
        visibilityRatio: ie.DEFAULT_SETTINGS.visibilityRatio,
        wrapHorizontal: ie.DEFAULT_SETTINGS.wrapHorizontal,
        wrapVertical: ie.DEFAULT_SETTINGS.wrapVertical,
        defaultZoomLevel: ie.DEFAULT_SETTINGS.defaultZoomLevel,
        minZoomLevel: ie.DEFAULT_SETTINGS.minZoomLevel,
        maxZoomLevel: ie.DEFAULT_SETTINGS.maxZoomLevel,
        degrees: ie.DEFAULT_SETTINGS.degrees,
        flipped: ie.DEFAULT_SETTINGS.flipped,
        homeFillsViewer: ie.DEFAULT_SETTINGS.homeFillsViewer
      }, Z), this._updateContainerInnerSize(), this.centerSpringX = new ie.Spring({
        initial: 0,
        springStiffness: this.springStiffness,
        animationTime: this.animationTime
      }), this.centerSpringY = new ie.Spring({
        initial: 0,
        springStiffness: this.springStiffness,
        animationTime: this.animationTime
      }), this.zoomSpring = new ie.Spring({
        exponential: !0,
        initial: 1,
        springStiffness: this.springStiffness,
        animationTime: this.animationTime
      }), this._oldCenterX = this.centerSpringX.current.value, this._oldCenterY = this.centerSpringY.current.value, this._oldZoom = this.zoomSpring.current.value, this._setContentBounds(new ie.Rect(0, 0, 1, 1), 1), this.goHome(!0), this.update();
    }, ie.Viewport.prototype = {
      /**
       * Updates the viewport's home bounds and constraints for the given content size.
       * @function
       * @param {OpenSeadragon.Point} contentSize - size of the content in content units
       * @return {OpenSeadragon.Viewport} Chainable.
       * @fires OpenSeadragon.Viewer.event:reset-size
       */
      resetContentSize: function(Z) {
        return ie.console.assert(Z, "[Viewport.resetContentSize] contentSize is required"), ie.console.assert(Z instanceof ie.Point, "[Viewport.resetContentSize] contentSize must be an OpenSeadragon.Point"), ie.console.assert(Z.x > 0, "[Viewport.resetContentSize] contentSize.x must be greater than 0"), ie.console.assert(Z.y > 0, "[Viewport.resetContentSize] contentSize.y must be greater than 0"), this._setContentBounds(new ie.Rect(0, 0, 1, Z.y / Z.x), Z.x), this;
      },
      // deprecated
      setHomeBounds: function(Z, ee) {
        ie.console.error("[Viewport.setHomeBounds] this function is deprecated; The content bounds should not be set manually."), this._setContentBounds(Z, ee);
      },
      // Set the viewport's content bounds
      // @param {OpenSeadragon.Rect} bounds - the new bounds in viewport coordinates
      // without rotation
      // @param {Number} contentFactor - how many content units per viewport unit
      // @fires OpenSeadragon.Viewer.event:reset-size
      // @private
      _setContentBounds: function(Z, ee) {
        ie.console.assert(Z, "[Viewport._setContentBounds] bounds is required"), ie.console.assert(Z instanceof ie.Rect, "[Viewport._setContentBounds] bounds must be an OpenSeadragon.Rect"), ie.console.assert(Z.width > 0, "[Viewport._setContentBounds] bounds.width must be greater than 0"), ie.console.assert(Z.height > 0, "[Viewport._setContentBounds] bounds.height must be greater than 0"), this._contentBoundsNoRotate = Z.clone(), this._contentSizeNoRotate = this._contentBoundsNoRotate.getSize().times(
          ee
        ), this._contentBounds = Z.rotate(this.degrees).getBoundingBox(), this._contentSize = this._contentBounds.getSize().times(ee), this._contentAspectRatio = this._contentSize.x / this._contentSize.y, this.viewer && this.viewer.raiseEvent("reset-size", {
          contentSize: this._contentSizeNoRotate.clone(),
          contentFactor: ee,
          homeBounds: this._contentBoundsNoRotate.clone(),
          contentBounds: this._contentBounds.clone()
        });
      },
      /**
       * Returns the home zoom in "viewport zoom" value.
       * @function
       * @returns {Number} The home zoom in "viewport zoom".
       */
      getHomeZoom: function() {
        if (this.defaultZoomLevel)
          return this.defaultZoomLevel;
        var Z = this._contentAspectRatio / this.getAspectRatio(), ee;
        return this.homeFillsViewer ? ee = Z >= 1 ? Z : 1 : ee = Z >= 1 ? 1 : Z, ee / this._contentBounds.width;
      },
      /**
       * Returns the home bounds in viewport coordinates.
       * @function
       * @returns {OpenSeadragon.Rect} The home bounds in vewport coordinates.
       */
      getHomeBounds: function() {
        return this.getHomeBoundsNoRotate().rotate(-this.getRotation());
      },
      /**
       * Returns the home bounds in viewport coordinates.
       * This method ignores the viewport rotation. Use
       * {@link OpenSeadragon.Viewport#getHomeBounds} to take it into account.
       * @function
       * @returns {OpenSeadragon.Rect} The home bounds in vewport coordinates.
       */
      getHomeBoundsNoRotate: function() {
        var Z = this._contentBounds.getCenter(), ee = 1 / this.getHomeZoom(), ae = ee / this.getAspectRatio();
        return new ie.Rect(
          Z.x - ee / 2,
          Z.y - ae / 2,
          ee,
          ae
        );
      },
      /**
       * @function
       * @param {Boolean} immediately
       * @fires OpenSeadragon.Viewer.event:home
       */
      goHome: function(Z) {
        return this.viewer && this.viewer.raiseEvent("home", {
          immediately: Z
        }), this.fitBounds(this.getHomeBounds(), Z);
      },
      /**
       * @function
       */
      getMinZoom: function() {
        var Z = this.getHomeZoom(), ee = this.minZoomLevel ? this.minZoomLevel : this.minZoomImageRatio * Z;
        return ee;
      },
      /**
       * @function
       */
      getMaxZoom: function() {
        var Z = this.maxZoomLevel;
        return Z || (Z = this._contentSize.x * this.maxZoomPixelRatio / this._containerInnerSize.x, Z /= this._contentBounds.width), Math.max(Z, this.getHomeZoom());
      },
      /**
       * @function
       */
      getAspectRatio: function() {
        return this._containerInnerSize.x / this._containerInnerSize.y;
      },
      /**
       * @function
       * @returns {OpenSeadragon.Point} The size of the container, in screen coordinates.
       */
      getContainerSize: function() {
        return new ie.Point(
          this.containerSize.x,
          this.containerSize.y
        );
      },
      /**
       * The margins push the "home" region in from the sides by the specified amounts.
       * @function
       * @returns {Object} Properties (Numbers, in screen coordinates): left, top, right, bottom.
       */
      getMargins: function() {
        return ie.extend({}, this._margins);
      },
      /**
       * The margins push the "home" region in from the sides by the specified amounts.
       * @function
       * @param {Object} margins - Properties (Numbers, in screen coordinates): left, top, right, bottom.
       */
      setMargins: function(Z) {
        ie.console.assert(ie.type(Z) === "object", "[Viewport.setMargins] margins must be an object"), this._margins = ie.extend({
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        }, Z), this._updateContainerInnerSize(), this.viewer && this.viewer.forceRedraw();
      },
      /**
       * Returns the bounds of the visible area in viewport coordinates.
       * @function
       * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
       * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
       */
      getBounds: function(Z) {
        return this.getBoundsNoRotate(Z).rotate(-this.getRotation());
      },
      /**
       * Returns the bounds of the visible area in viewport coordinates.
       * This method ignores the viewport rotation. Use
       * {@link OpenSeadragon.Viewport#getBounds} to take it into account.
       * @function
       * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
       * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
       */
      getBoundsNoRotate: function(Z) {
        var ee = this.getCenter(Z), ae = 1 / this.getZoom(Z), ve = ae / this.getAspectRatio();
        return new ie.Rect(
          ee.x - ae / 2,
          ee.y - ve / 2,
          ae,
          ve
        );
      },
      /**
       * @function
       * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
       * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
       * including the space taken by margins, in viewport coordinates.
       */
      getBoundsWithMargins: function(Z) {
        return this.getBoundsNoRotateWithMargins(Z).rotate(
          -this.getRotation(),
          this.getCenter(Z)
        );
      },
      /**
       * @function
       * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
       * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
       * including the space taken by margins, in viewport coordinates.
       */
      getBoundsNoRotateWithMargins: function(Z) {
        var ee = this.getBoundsNoRotate(Z), ae = this._containerInnerSize.x * this.getZoom(Z);
        return ee.x -= this._margins.left / ae, ee.y -= this._margins.top / ae, ee.width += (this._margins.left + this._margins.right) / ae, ee.height += (this._margins.top + this._margins.bottom) / ae, ee;
      },
      /**
       * @function
       * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
       */
      getCenter: function(Z) {
        var ee = new ie.Point(
          this.centerSpringX.current.value,
          this.centerSpringY.current.value
        ), ae = new ie.Point(
          this.centerSpringX.target.value,
          this.centerSpringY.target.value
        ), ve, ye, be, Ye, Qe, Je, nt, st;
        return Z ? ee : this.zoomPoint ? (ve = this.pixelFromPoint(this.zoomPoint, !0), ye = this.getZoom(), be = 1 / ye, Ye = be / this.getAspectRatio(), Qe = new ie.Rect(
          ee.x - be / 2,
          ee.y - Ye / 2,
          be,
          Ye
        ), Je = this._pixelFromPoint(this.zoomPoint, Qe), nt = Je.minus(ve), st = nt.divide(this._containerInnerSize.x * ye), ae.plus(st)) : ae;
      },
      /**
       * @function
       * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
       */
      getZoom: function(Z) {
        return Z ? this.zoomSpring.current.value : this.zoomSpring.target.value;
      },
      // private
      _applyZoomConstraints: function(Z) {
        return Math.max(
          Math.min(Z, this.getMaxZoom()),
          this.getMinZoom()
        );
      },
      /**
       * @function
       * @private
       * @param {OpenSeadragon.Rect} bounds
       * @return {OpenSeadragon.Rect} constrained bounds.
       */
      _applyBoundaryConstraints: function(Z) {
        var ee = new ie.Rect(
          Z.x,
          Z.y,
          Z.width,
          Z.height
        );
        if (!this.wrapHorizontal) {
          var ae = this.visibilityRatio * ee.width, ve = ee.x + ee.width, ye = this._contentBoundsNoRotate.x + this._contentBoundsNoRotate.width, be = this._contentBoundsNoRotate.x - ve + ae, Ye = ye - ee.x - ae;
          ae > this._contentBoundsNoRotate.width ? ee.x += (be + Ye) / 2 : Ye < 0 ? ee.x += Ye : be > 0 && (ee.x += be);
        }
        if (!this.wrapVertical) {
          var Qe = this.visibilityRatio * ee.height, Je = ee.y + ee.height, nt = this._contentBoundsNoRotate.y + this._contentBoundsNoRotate.height, st = this._contentBoundsNoRotate.y - Je + Qe, ot = nt - ee.y - Qe;
          Qe > this._contentBoundsNoRotate.height ? ee.y += (st + ot) / 2 : ot < 0 ? ee.y += ot : st > 0 && (ee.y += st);
        }
        return ee;
      },
      /**
       * @function
       * @private
       * @param {Boolean} [immediately=false] - whether the function that triggered this event was
       * called with the "immediately" flag
       */
      _raiseConstraintsEvent: function(Z) {
        this.viewer && this.viewer.raiseEvent("constrain", {
          immediately: Z
        });
      },
      /**
       * Enforces the minZoom, maxZoom and visibilityRatio constraints by
       * zooming and panning to the closest acceptable zoom and location.
       * @function
       * @param {Boolean} [immediately=false]
       * @return {OpenSeadragon.Viewport} Chainable.
       * @fires OpenSeadragon.Viewer.event:constrain
       */
      applyConstraints: function(Z) {
        var ee = this.getZoom(), ae = this._applyZoomConstraints(ee);
        ee !== ae && this.zoomTo(ae, this.zoomPoint, Z);
        var ve = this.getBoundsNoRotate(), ye = this._applyBoundaryConstraints(ve);
        return this._raiseConstraintsEvent(Z), (ve.x !== ye.x || ve.y !== ye.y || Z) && this.fitBounds(
          ye.rotate(-this.getRotation()),
          Z
        ), this;
      },
      /**
       * Equivalent to {@link OpenSeadragon.Viewport#applyConstraints}
       * @function
       * @param {Boolean} [immediately=false]
       * @return {OpenSeadragon.Viewport} Chainable.
       * @fires OpenSeadragon.Viewer.event:constrain
       */
      ensureVisible: function(Z) {
        return this.applyConstraints(Z);
      },
      /**
       * @function
       * @private
       * @param {OpenSeadragon.Rect} bounds
       * @param {Object} options (immediately=false, constraints=false)
       * @return {OpenSeadragon.Viewport} Chainable.
       */
      _fitBounds: function(Z, ee) {
        ee = ee || {};
        var ae = ee.immediately || !1, ve = ee.constraints || !1, ye = this.getAspectRatio(), be = Z.getCenter(), Ye = new ie.Rect(
          Z.x,
          Z.y,
          Z.width,
          Z.height,
          Z.degrees + this.getRotation()
        ).getBoundingBox();
        Ye.getAspectRatio() >= ye ? Ye.height = Ye.width / ye : Ye.width = Ye.height * ye, Ye.x = be.x - Ye.width / 2, Ye.y = be.y - Ye.height / 2;
        var Qe = 1 / Ye.width;
        if (ve) {
          var Je = Ye.getAspectRatio(), nt = this._applyZoomConstraints(Qe);
          Qe !== nt && (Qe = nt, Ye.width = 1 / Qe, Ye.x = be.x - Ye.width / 2, Ye.height = Ye.width / Je, Ye.y = be.y - Ye.height / 2), Ye = this._applyBoundaryConstraints(Ye), be = Ye.getCenter(), this._raiseConstraintsEvent(ae);
        }
        if (ae)
          return this.panTo(be, !0), this.zoomTo(Qe, null, !0);
        this.panTo(this.getCenter(!0), !0), this.zoomTo(this.getZoom(!0), null, !0);
        var st = this.getBounds(), ot = this.getZoom();
        if (ot === 0 || Math.abs(Qe / ot - 1) < 1e-8)
          return this.zoomTo(Qe, !0), this.panTo(be, ae);
        Ye = Ye.rotate(-this.getRotation());
        var lt = Ye.getTopLeft().times(Qe).minus(st.getTopLeft().times(ot)).divide(Qe - ot);
        return this.zoomTo(Qe, lt, ae);
      },
      /**
       * Makes the viewport zoom and pan so that the specified bounds take
       * as much space as possible in the viewport.
       * Note: this method ignores the constraints (minZoom, maxZoom and
       * visibilityRatio).
       * Use {@link OpenSeadragon.Viewport#fitBoundsWithConstraints} to enforce
       * them.
       * @function
       * @param {OpenSeadragon.Rect} bounds
       * @param {Boolean} [immediately=false]
       * @return {OpenSeadragon.Viewport} Chainable.
       */
      fitBounds: function(Z, ee) {
        return this._fitBounds(Z, {
          immediately: ee,
          constraints: !1
        });
      },
      /**
       * Makes the viewport zoom and pan so that the specified bounds take
       * as much space as possible in the viewport while enforcing the constraints
       * (minZoom, maxZoom and visibilityRatio).
       * Note: because this method enforces the constraints, part of the
       * provided bounds may end up outside of the viewport.
       * Use {@link OpenSeadragon.Viewport#fitBounds} to ignore them.
       * @function
       * @param {OpenSeadragon.Rect} bounds
       * @param {Boolean} [immediately=false]
       * @return {OpenSeadragon.Viewport} Chainable.
       */
      fitBoundsWithConstraints: function(Z, ee) {
        return this._fitBounds(Z, {
          immediately: ee,
          constraints: !0
        });
      },
      /**
       * Zooms so the image just fills the viewer vertically.
       * @param {Boolean} immediately
       * @return {OpenSeadragon.Viewport} Chainable.
       */
      fitVertically: function(Z) {
        var ee = new ie.Rect(
          this._contentBounds.x + this._contentBounds.width / 2,
          this._contentBounds.y,
          0,
          this._contentBounds.height
        );
        return this.fitBounds(ee, Z);
      },
      /**
       * Zooms so the image just fills the viewer horizontally.
       * @param {Boolean} immediately
       * @return {OpenSeadragon.Viewport} Chainable.
       */
      fitHorizontally: function(Z) {
        var ee = new ie.Rect(
          this._contentBounds.x,
          this._contentBounds.y + this._contentBounds.height / 2,
          this._contentBounds.width,
          0
        );
        return this.fitBounds(ee, Z);
      },
      /**
       * Returns bounds taking constraints into account
       * Added to improve constrained panning
       * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
       * @return {OpenSeadragon.Viewport} Chainable.
       */
      getConstrainedBounds: function(Z) {
        var ee, ae;
        return ee = this.getBounds(Z), ae = this._applyBoundaryConstraints(ee), ae;
      },
      /**
       * @function
       * @param {OpenSeadragon.Point} delta
       * @param {Boolean} immediately
       * @return {OpenSeadragon.Viewport} Chainable.
       * @fires OpenSeadragon.Viewer.event:pan
       */
      panBy: function(Z, ee) {
        var ae = new ie.Point(
          this.centerSpringX.target.value,
          this.centerSpringY.target.value
        );
        return this.panTo(ae.plus(Z), ee);
      },
      /**
       * @function
       * @param {OpenSeadragon.Point} center
       * @param {Boolean} immediately
       * @return {OpenSeadragon.Viewport} Chainable.
       * @fires OpenSeadragon.Viewer.event:pan
       */
      panTo: function(Z, ee) {
        return ee ? (this.centerSpringX.resetTo(Z.x), this.centerSpringY.resetTo(Z.y)) : (this.centerSpringX.springTo(Z.x), this.centerSpringY.springTo(Z.y)), this.viewer && this.viewer.raiseEvent("pan", {
          center: Z,
          immediately: ee
        }), this;
      },
      /**
       * @function
       * @return {OpenSeadragon.Viewport} Chainable.
       * @fires OpenSeadragon.Viewer.event:zoom
       */
      zoomBy: function(Z, ee, ae) {
        return this.zoomTo(
          this.zoomSpring.target.value * Z,
          ee,
          ae
        );
      },
      /**
       * Zooms to the specified zoom level
       * @function
       * @param {Number} zoom The zoom level to zoom to.
       * @param {OpenSeadragon.Point} [refPoint] The point which will stay at
       * the same screen location. Defaults to the viewport center.
       * @param {Boolean} [immediately=false]
       * @return {OpenSeadragon.Viewport} Chainable.
       * @fires OpenSeadragon.Viewer.event:zoom
       */
      zoomTo: function(Z, ee, ae) {
        var ve = this;
        return this.zoomPoint = ee instanceof ie.Point && !isNaN(ee.x) && !isNaN(ee.y) ? ee : null, ae ? this._adjustCenterSpringsForZoomPoint(function() {
          ve.zoomSpring.resetTo(Z);
        }) : this.zoomSpring.springTo(Z), this.viewer && this.viewer.raiseEvent("zoom", {
          zoom: Z,
          refPoint: ee,
          immediately: ae
        }), this;
      },
      /**
       * Rotates this viewport to the angle specified.
       * @function
       * @param {Number} degrees The degrees to set the rotation to.
       * @return {OpenSeadragon.Viewport} Chainable.
       */
      setRotation: function(Z) {
        return !this.viewer || !this.viewer.drawer.canRotate() ? this : (this.degrees = ie.positiveModulo(Z, 360), this._setContentBounds(
          this.viewer.world.getHomeBounds(),
          this.viewer.world.getContentFactor()
        ), this.viewer.forceRedraw(), this.viewer.raiseEvent("rotate", { degrees: Z }), this);
      },
      /**
       * Gets the current rotation in degrees.
       * @function
       * @return {Number} The current rotation in degrees.
       */
      getRotation: function() {
        return this.degrees;
      },
      /**
       * @function
       * @return {OpenSeadragon.Viewport} Chainable.
       * @fires OpenSeadragon.Viewer.event:resize
       */
      resize: function(Z, ee) {
        var ae = this.getBoundsNoRotate(), ve = ae, ye;
        return this.containerSize.x = Z.x, this.containerSize.y = Z.y, this._updateContainerInnerSize(), ee && (ye = Z.x / this.containerSize.x, ve.width = ae.width * ye, ve.height = ve.width / this.getAspectRatio()), this.viewer && this.viewer.raiseEvent("resize", {
          newContainerSize: Z,
          maintain: ee
        }), this.fitBounds(ve, !0);
      },
      // private
      _updateContainerInnerSize: function() {
        this._containerInnerSize = new ie.Point(
          Math.max(1, this.containerSize.x - (this._margins.left + this._margins.right)),
          Math.max(1, this.containerSize.y - (this._margins.top + this._margins.bottom))
        );
      },
      /**
       * Update the zoom and center (X and Y) springs.
       * @function
       * @returns {Boolean} True if any change has been made, false otherwise.
       */
      update: function() {
        var Z = this;
        this._adjustCenterSpringsForZoomPoint(function() {
          Z.zoomSpring.update();
        }), this.centerSpringX.update(), this.centerSpringY.update();
        var ee = this.centerSpringX.current.value !== this._oldCenterX || this.centerSpringY.current.value !== this._oldCenterY || this.zoomSpring.current.value !== this._oldZoom;
        return this._oldCenterX = this.centerSpringX.current.value, this._oldCenterY = this.centerSpringY.current.value, this._oldZoom = this.zoomSpring.current.value, ee;
      },
      _adjustCenterSpringsForZoomPoint: function(Z) {
        if (this.zoomPoint) {
          var ee = this.pixelFromPoint(this.zoomPoint, !0);
          Z();
          var ae = this.pixelFromPoint(this.zoomPoint, !0), ve = ae.minus(ee), ye = this.deltaPointsFromPixels(
            ve,
            !0
          );
          this.centerSpringX.shiftBy(ye.x), this.centerSpringY.shiftBy(ye.y), this.zoomSpring.isAtTargetValue() && (this.zoomPoint = null);
        } else
          Z();
      },
      /**
       * Convert a delta (translation vector) from viewport coordinates to pixels
       * coordinates. This method does not take rotation into account.
       * Consider using deltaPixelsFromPoints if you need to account for rotation.
       * @param {OpenSeadragon.Point} deltaPoints - The translation vector to convert.
       * @param {Boolean} [current=false] - Pass true for the current location;
       * defaults to false (target location).
       * @returns {OpenSeadragon.Point}
       */
      deltaPixelsFromPointsNoRotate: function(Z, ee) {
        return Z.times(
          this._containerInnerSize.x * this.getZoom(ee)
        );
      },
      /**
       * Convert a delta (translation vector) from viewport coordinates to pixels
       * coordinates.
       * @param {OpenSeadragon.Point} deltaPoints - The translation vector to convert.
       * @param {Boolean} [current=false] - Pass true for the current location;
       * defaults to false (target location).
       * @returns {OpenSeadragon.Point}
       */
      deltaPixelsFromPoints: function(Z, ee) {
        return this.deltaPixelsFromPointsNoRotate(
          Z.rotate(this.getRotation()),
          ee
        );
      },
      /**
       * Convert a delta (translation vector) from pixels coordinates to viewport
       * coordinates. This method does not take rotation into account.
       * Consider using deltaPointsFromPixels if you need to account for rotation.
       * @param {OpenSeadragon.Point} deltaPixels - The translation vector to convert.
       * @param {Boolean} [current=false] - Pass true for the current location;
       * defaults to false (target location).
       * @returns {OpenSeadragon.Point}
       */
      deltaPointsFromPixelsNoRotate: function(Z, ee) {
        return Z.divide(
          this._containerInnerSize.x * this.getZoom(ee)
        );
      },
      /**
       * Convert a delta (translation vector) from pixels coordinates to viewport
       * coordinates.
       * @param {OpenSeadragon.Point} deltaPixels - The translation vector to convert.
       * @param {Boolean} [current=false] - Pass true for the current location;
       * defaults to false (target location).
       * @returns {OpenSeadragon.Point}
       */
      deltaPointsFromPixels: function(Z, ee) {
        return this.deltaPointsFromPixelsNoRotate(Z, ee).rotate(-this.getRotation());
      },
      /**
       * Convert viewport coordinates to pixels coordinates.
       * This method does not take rotation into account.
       * Consider using pixelFromPoint if you need to account for rotation.
       * @param {OpenSeadragon.Point} point the viewport coordinates
       * @param {Boolean} [current=false] - Pass true for the current location;
       * defaults to false (target location).
       * @returns {OpenSeadragon.Point}
       */
      pixelFromPointNoRotate: function(Z, ee) {
        return this._pixelFromPointNoRotate(
          Z,
          this.getBoundsNoRotate(ee)
        );
      },
      /**
       * Convert viewport coordinates to pixel coordinates.
       * @param {OpenSeadragon.Point} point the viewport coordinates
       * @param {Boolean} [current=false] - Pass true for the current location;
       * defaults to false (target location).
       * @returns {OpenSeadragon.Point}
       */
      pixelFromPoint: function(Z, ee) {
        return this._pixelFromPoint(Z, this.getBoundsNoRotate(ee));
      },
      // private
      _pixelFromPointNoRotate: function(Z, ee) {
        return Z.minus(
          ee.getTopLeft()
        ).times(
          this._containerInnerSize.x / ee.width
        ).plus(
          new ie.Point(this._margins.left, this._margins.top)
        );
      },
      // private
      _pixelFromPoint: function(Z, ee) {
        return this._pixelFromPointNoRotate(
          Z.rotate(this.getRotation(), this.getCenter(!0)),
          ee
        );
      },
      /**
       * Convert pixel coordinates to viewport coordinates.
       * This method does not take rotation into account.
       * Consider using pointFromPixel if you need to account for rotation.
       * @param {OpenSeadragon.Point} pixel Pixel coordinates
       * @param {Boolean} [current=false] - Pass true for the current location;
       * defaults to false (target location).
       * @returns {OpenSeadragon.Point}
       */
      pointFromPixelNoRotate: function(Z, ee) {
        var ae = this.getBoundsNoRotate(ee);
        return Z.minus(
          new ie.Point(this._margins.left, this._margins.top)
        ).divide(
          this._containerInnerSize.x / ae.width
        ).plus(
          ae.getTopLeft()
        );
      },
      /**
       * Convert pixel coordinates to viewport coordinates.
       * @param {OpenSeadragon.Point} pixel Pixel coordinates
       * @param {Boolean} [current=false] - Pass true for the current location;
       * defaults to false (target location).
       * @returns {OpenSeadragon.Point}
       */
      pointFromPixel: function(Z, ee) {
        return this.pointFromPixelNoRotate(Z, ee).rotate(
          -this.getRotation(),
          this.getCenter(!0)
        );
      },
      // private
      _viewportToImageDelta: function(Z, ee) {
        var ae = this._contentBoundsNoRotate.width;
        return new ie.Point(
          Z * this._contentSizeNoRotate.x / ae,
          ee * this._contentSizeNoRotate.x / ae
        );
      },
      /**
       * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
       * This method can be called either by passing X,Y coordinates or an
       * OpenSeadragon.Point
       * Note: not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.
       * @function
       * @param {(OpenSeadragon.Point|Number)} viewerX either a point or the X
       * coordinate in viewport coordinate system.
       * @param {Number} [viewerY] Y coordinate in viewport coordinate system.
       * @return {OpenSeadragon.Point} a point representing the coordinates in the image.
       */
      viewportToImageCoordinates: function(Z, ee) {
        if (Z instanceof ie.Point)
          return this.viewportToImageCoordinates(Z.x, Z.y);
        if (this.viewer) {
          var ae = this.viewer.world.getItemCount();
          if (ae > 1)
            ie.console.error("[Viewport.viewportToImageCoordinates] is not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.");
          else if (ae === 1) {
            var ve = this.viewer.world.getItemAt(0);
            return ve.viewportToImageCoordinates(Z, ee, !0);
          }
        }
        return this._viewportToImageDelta(
          Z - this._contentBoundsNoRotate.x,
          ee - this._contentBoundsNoRotate.y
        );
      },
      // private
      _imageToViewportDelta: function(Z, ee) {
        var ae = this._contentBoundsNoRotate.width;
        return new ie.Point(
          Z / this._contentSizeNoRotate.x * ae,
          ee / this._contentSizeNoRotate.x * ae
        );
      },
      /**
       * Translates from image coordinate system to OpenSeadragon viewer coordinate system
       * This method can be called either by passing X,Y coordinates or an
       * OpenSeadragon.Point
       * Note: not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.
       * @function
       * @param {(OpenSeadragon.Point | Number)} imageX the point or the
       * X coordinate in image coordinate system.
       * @param {Number} [imageY] Y coordinate in image coordinate system.
       * @return {OpenSeadragon.Point} a point representing the coordinates in the viewport.
       */
      imageToViewportCoordinates: function(Z, ee) {
        if (Z instanceof ie.Point)
          return this.imageToViewportCoordinates(Z.x, Z.y);
        if (this.viewer) {
          var ae = this.viewer.world.getItemCount();
          if (ae > 1)
            ie.console.error("[Viewport.imageToViewportCoordinates] is not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.");
          else if (ae === 1) {
            var ve = this.viewer.world.getItemAt(0);
            return ve.imageToViewportCoordinates(Z, ee, !0);
          }
        }
        var ye = this._imageToViewportDelta(Z, ee);
        return ye.x += this._contentBoundsNoRotate.x, ye.y += this._contentBoundsNoRotate.y, ye;
      },
      /**
       * Translates from a rectangle which describes a portion of the image in
       * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
       * This method can be called either by passing X,Y,width,height or an
       * OpenSeadragon.Rect
       * Note: not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.
       * @function
       * @param {(OpenSeadragon.Rect | Number)} imageX the rectangle or the X
       * coordinate of the top left corner of the rectangle in image coordinate system.
       * @param {Number} [imageY] the Y coordinate of the top left corner of the rectangle
       * in image coordinate system.
       * @param {Number} [pixelWidth] the width in pixel of the rectangle.
       * @param {Number} [pixelHeight] the height in pixel of the rectangle.
       * @returns {OpenSeadragon.Rect} This image's bounds in viewport coordinates
       */
      imageToViewportRectangle: function(Z, ee, ae, ve) {
        var ye = Z;
        if (ye instanceof ie.Rect || (ye = new ie.Rect(Z, ee, ae, ve)), this.viewer) {
          var be = this.viewer.world.getItemCount();
          if (be > 1)
            ie.console.error("[Viewport.imageToViewportRectangle] is not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.");
          else if (be === 1) {
            var Ye = this.viewer.world.getItemAt(0);
            return Ye.imageToViewportRectangle(
              Z,
              ee,
              ae,
              ve,
              !0
            );
          }
        }
        var Qe = this.imageToViewportCoordinates(ye.x, ye.y), Je = this._imageToViewportDelta(ye.width, ye.height);
        return new ie.Rect(
          Qe.x,
          Qe.y,
          Je.x,
          Je.y,
          ye.degrees
        );
      },
      /**
       * Translates from a rectangle which describes a portion of
       * the viewport in point coordinates to image rectangle coordinates.
       * This method can be called either by passing X,Y,width,height or an
       * OpenSeadragon.Rect
       * Note: not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.
       * @function
       * @param {(OpenSeadragon.Rect | Number)} viewerX either a rectangle or
       * the X coordinate of the top left corner of the rectangle in viewport
       * coordinate system.
       * @param {Number} [viewerY] the Y coordinate of the top left corner of the rectangle
       * in viewport coordinate system.
       * @param {Number} [pointWidth] the width of the rectangle in viewport coordinate system.
       * @param {Number} [pointHeight] the height of the rectangle in viewport coordinate system.
       */
      viewportToImageRectangle: function(Z, ee, ae, ve) {
        var ye = Z;
        if (ye instanceof ie.Rect || (ye = new ie.Rect(Z, ee, ae, ve)), this.viewer) {
          var be = this.viewer.world.getItemCount();
          if (be > 1)
            ie.console.error("[Viewport.viewportToImageRectangle] is not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.");
          else if (be === 1) {
            var Ye = this.viewer.world.getItemAt(0);
            return Ye.viewportToImageRectangle(
              Z,
              ee,
              ae,
              ve,
              !0
            );
          }
        }
        var Qe = this.viewportToImageCoordinates(ye.x, ye.y), Je = this._viewportToImageDelta(ye.width, ye.height);
        return new ie.Rect(
          Qe.x,
          Qe.y,
          Je.x,
          Je.y,
          ye.degrees
        );
      },
      /**
       * Convert pixel coordinates relative to the viewer element to image
       * coordinates.
       * Note: not accurate with multi-image.
       * @param {OpenSeadragon.Point} pixel
       * @returns {OpenSeadragon.Point}
       */
      viewerElementToImageCoordinates: function(Z) {
        var ee = this.pointFromPixel(Z, !0);
        return this.viewportToImageCoordinates(ee);
      },
      /**
       * Convert pixel coordinates relative to the image to
       * viewer element coordinates.
       * Note: not accurate with multi-image.
       * @param {OpenSeadragon.Point} pixel
       * @returns {OpenSeadragon.Point}
       */
      imageToViewerElementCoordinates: function(Z) {
        var ee = this.imageToViewportCoordinates(Z);
        return this.pixelFromPoint(ee, !0);
      },
      /**
       * Convert pixel coordinates relative to the window to image coordinates.
       * Note: not accurate with multi-image.
       * @param {OpenSeadragon.Point} pixel
       * @returns {OpenSeadragon.Point}
       */
      windowToImageCoordinates: function(Z) {
        ie.console.assert(
          this.viewer,
          "[Viewport.windowToImageCoordinates] the viewport must have a viewer."
        );
        var ee = Z.minus(
          ie.getElementPosition(this.viewer.element)
        );
        return this.viewerElementToImageCoordinates(ee);
      },
      /**
       * Convert image coordinates to pixel coordinates relative to the window.
       * Note: not accurate with multi-image.
       * @param {OpenSeadragon.Point} pixel
       * @returns {OpenSeadragon.Point}
       */
      imageToWindowCoordinates: function(Z) {
        ie.console.assert(
          this.viewer,
          "[Viewport.imageToWindowCoordinates] the viewport must have a viewer."
        );
        var ee = this.imageToViewerElementCoordinates(Z);
        return ee.plus(
          ie.getElementPosition(this.viewer.element)
        );
      },
      /**
       * Convert pixel coordinates relative to the viewer element to viewport
       * coordinates.
       * @param {OpenSeadragon.Point} pixel
       * @returns {OpenSeadragon.Point}
       */
      viewerElementToViewportCoordinates: function(Z) {
        return this.pointFromPixel(Z, !0);
      },
      /**
       * Convert viewport coordinates to pixel coordinates relative to the
       * viewer element.
       * @param {OpenSeadragon.Point} point
       * @returns {OpenSeadragon.Point}
       */
      viewportToViewerElementCoordinates: function(Z) {
        return this.pixelFromPoint(Z, !0);
      },
      /**
       * Convert a rectangle in pixel coordinates relative to the viewer element
       * to viewport coordinates.
       * @param {OpenSeadragon.Rect} rectangle the rectangle to convert
       * @returns {OpenSeadragon.Rect} the converted rectangle
       */
      viewerElementToViewportRectangle: function(Z) {
        return ie.Rect.fromSummits(
          this.pointFromPixel(Z.getTopLeft(), !0),
          this.pointFromPixel(Z.getTopRight(), !0),
          this.pointFromPixel(Z.getBottomLeft(), !0)
        );
      },
      /**
       * Convert a rectangle in viewport coordinates to pixel coordinates relative
       * to the viewer element.
       * @param {OpenSeadragon.Rect} rectangle the rectangle to convert
       * @returns {OpenSeadragon.Rect} the converted rectangle
       */
      viewportToViewerElementRectangle: function(Z) {
        return ie.Rect.fromSummits(
          this.pixelFromPoint(Z.getTopLeft(), !0),
          this.pixelFromPoint(Z.getTopRight(), !0),
          this.pixelFromPoint(Z.getBottomLeft(), !0)
        );
      },
      /**
       * Convert pixel coordinates relative to the window to viewport coordinates.
       * @param {OpenSeadragon.Point} pixel
       * @returns {OpenSeadragon.Point}
       */
      windowToViewportCoordinates: function(Z) {
        ie.console.assert(
          this.viewer,
          "[Viewport.windowToViewportCoordinates] the viewport must have a viewer."
        );
        var ee = Z.minus(
          ie.getElementPosition(this.viewer.element)
        );
        return this.viewerElementToViewportCoordinates(ee);
      },
      /**
       * Convert viewport coordinates to pixel coordinates relative to the window.
       * @param {OpenSeadragon.Point} point
       * @returns {OpenSeadragon.Point}
       */
      viewportToWindowCoordinates: function(Z) {
        ie.console.assert(
          this.viewer,
          "[Viewport.viewportToWindowCoordinates] the viewport must have a viewer."
        );
        var ee = this.viewportToViewerElementCoordinates(Z);
        return ee.plus(
          ie.getElementPosition(this.viewer.element)
        );
      },
      /**
       * Convert a viewport zoom to an image zoom.
       * Image zoom: ratio of the original image size to displayed image size.
       * 1 means original image size, 0.5 half size...
       * Viewport zoom: ratio of the displayed image's width to viewport's width.
       * 1 means identical width, 2 means image's width is twice the viewport's width...
       * Note: not accurate with multi-image.
       * @function
       * @param {Number} viewportZoom The viewport zoom
       * target zoom.
       * @returns {Number} imageZoom The image zoom
       */
      viewportToImageZoom: function(Z) {
        if (this.viewer) {
          var ee = this.viewer.world.getItemCount();
          if (ee > 1)
            ie.console.error("[Viewport.viewportToImageZoom] is not accurate with multi-image.");
          else if (ee === 1) {
            var ae = this.viewer.world.getItemAt(0);
            return ae.viewportToImageZoom(Z);
          }
        }
        var ve = this._contentSizeNoRotate.x, ye = this._containerInnerSize.x, be = this._contentBoundsNoRotate.width, Ye = ye / ve * be;
        return Z * Ye;
      },
      /**
       * Convert an image zoom to a viewport zoom.
       * Image zoom: ratio of the original image size to displayed image size.
       * 1 means original image size, 0.5 half size...
       * Viewport zoom: ratio of the displayed image's width to viewport's width.
       * 1 means identical width, 2 means image's width is twice the viewport's width...
       * Note: not accurate with multi-image.
       * @function
       * @param {Number} imageZoom The image zoom
       * target zoom.
       * @returns {Number} viewportZoom The viewport zoom
       */
      imageToViewportZoom: function(Z) {
        if (this.viewer) {
          var ee = this.viewer.world.getItemCount();
          if (ee > 1)
            ie.console.error("[Viewport.imageToViewportZoom] is not accurate with multi-image.");
          else if (ee === 1) {
            var ae = this.viewer.world.getItemAt(0);
            return ae.imageToViewportZoom(Z);
          }
        }
        var ve = this._contentSizeNoRotate.x, ye = this._containerInnerSize.x, be = this._contentBoundsNoRotate.width, Ye = ve / ye / be;
        return Z * Ye;
      },
      /**
       * Toggles flip state and demands a new drawing on navigator and viewer objects.
       * @function
       * @return {OpenSeadragon.Viewport} Chainable.
       */
      toggleFlip: function() {
        return this.setFlip(!this.getFlip()), this;
      },
      /**
       * Get flip state stored on viewport.
       * @function
       * @return {Boolean} Flip state.
       */
      getFlip: function() {
        return this.flipped;
      },
      /**
       * Sets flip state according to the state input argument.
       * @function
       * @param {Boolean} state - Flip state to set.
       * @return {OpenSeadragon.Viewport} Chainable.
       */
      setFlip: function(Z) {
        return this.flipped === Z ? this : (this.flipped = Z, this.viewer.navigator && this.viewer.navigator.setFlip(this.getFlip()), this.viewer.forceRedraw(), this.viewer.raiseEvent("flip", { flipped: Z }), this);
      }
    };
  }(OpenSeadragon), function(ie) {
    ie.TiledImage = function(ct) {
      var _r = this;
      ie.console.assert(ct.tileCache, "[TiledImage] options.tileCache is required"), ie.console.assert(ct.drawer, "[TiledImage] options.drawer is required"), ie.console.assert(ct.viewer, "[TiledImage] options.viewer is required"), ie.console.assert(ct.imageLoader, "[TiledImage] options.imageLoader is required"), ie.console.assert(ct.source, "[TiledImage] options.source is required"), ie.console.assert(
        !ct.clip || ct.clip instanceof ie.Rect,
        "[TiledImage] options.clip must be an OpenSeadragon.Rect if present"
      ), ie.EventSource.call(this), this._tileCache = ct.tileCache, delete ct.tileCache, this._drawer = ct.drawer, delete ct.drawer, this._imageLoader = ct.imageLoader, delete ct.imageLoader, ct.clip instanceof ie.Rect && (this._clip = ct.clip.clone()), delete ct.clip;
      var Kr = ct.x || 0;
      delete ct.x;
      var Xr = ct.y || 0;
      delete ct.y, this.normHeight = ct.source.dimensions.y / ct.source.dimensions.x, this.contentAspectX = ct.source.dimensions.x / ct.source.dimensions.y;
      var Jr = 1;
      ct.width ? (Jr = ct.width, delete ct.width, ct.height && (ie.console.error("specifying both width and height to a tiledImage is not supported"), delete ct.height)) : ct.height && (Jr = ct.height / this.normHeight, delete ct.height);
      var ei = ct.fitBounds;
      delete ct.fitBounds;
      var si = ct.fitBoundsPlacement || OpenSeadragon.Placement.CENTER;
      delete ct.fitBoundsPlacement;
      var ri = ct.degrees || 0;
      delete ct.degrees, ie.extend(!0, this, {
        //internal state properties
        viewer: null,
        tilesMatrix: {},
        // A '3d' dictionary [level][x][y] --> Tile.
        coverage: {},
        // A '3d' dictionary [level][x][y] --> Boolean; shows what areas have been drawn.
        loadingCoverage: {},
        // A '3d' dictionary [level][x][y] --> Boolean; shows what areas are loaded or are being loaded/blended.
        lastDrawn: [],
        // An unordered list of Tiles drawn last frame.
        lastResetTime: 0,
        // Last time for which the tiledImage was reset.
        _midDraw: !1,
        // Is the tiledImage currently updating the viewport?
        _needsDraw: !0,
        // Does the tiledImage need to update the viewport again?
        _hasOpaqueTile: !1,
        // Do we have even one fully opaque tile?
        _tilesLoading: 0,
        // The number of pending tile requests.
        //configurable settings
        springStiffness: ie.DEFAULT_SETTINGS.springStiffness,
        animationTime: ie.DEFAULT_SETTINGS.animationTime,
        minZoomImageRatio: ie.DEFAULT_SETTINGS.minZoomImageRatio,
        wrapHorizontal: ie.DEFAULT_SETTINGS.wrapHorizontal,
        wrapVertical: ie.DEFAULT_SETTINGS.wrapVertical,
        immediateRender: ie.DEFAULT_SETTINGS.immediateRender,
        blendTime: ie.DEFAULT_SETTINGS.blendTime,
        alwaysBlend: ie.DEFAULT_SETTINGS.alwaysBlend,
        minPixelRatio: ie.DEFAULT_SETTINGS.minPixelRatio,
        smoothTileEdgesMinZoom: ie.DEFAULT_SETTINGS.smoothTileEdgesMinZoom,
        iOSDevice: ie.DEFAULT_SETTINGS.iOSDevice,
        debugMode: ie.DEFAULT_SETTINGS.debugMode,
        crossOriginPolicy: ie.DEFAULT_SETTINGS.crossOriginPolicy,
        ajaxWithCredentials: ie.DEFAULT_SETTINGS.ajaxWithCredentials,
        placeholderFillStyle: ie.DEFAULT_SETTINGS.placeholderFillStyle,
        opacity: ie.DEFAULT_SETTINGS.opacity,
        preload: ie.DEFAULT_SETTINGS.preload,
        compositeOperation: ie.DEFAULT_SETTINGS.compositeOperation
      }, ct), this._preload = this.preload, delete this.preload, this._fullyLoaded = !1, this._xSpring = new ie.Spring({
        initial: Kr,
        springStiffness: this.springStiffness,
        animationTime: this.animationTime
      }), this._ySpring = new ie.Spring({
        initial: Xr,
        springStiffness: this.springStiffness,
        animationTime: this.animationTime
      }), this._scaleSpring = new ie.Spring({
        initial: Jr,
        springStiffness: this.springStiffness,
        animationTime: this.animationTime
      }), this._degreesSpring = new ie.Spring({
        initial: ri,
        springStiffness: this.springStiffness,
        animationTime: this.animationTime
      }), this._updateForScale(), ei && this.fitBounds(ei, si, !0), this._drawingHandler = function(ai) {
        _r.viewer.raiseEvent("tile-drawing", ie.extend({
          tiledImage: _r
        }, ai));
      };
    }, ie.extend(
      ie.TiledImage.prototype,
      ie.EventSource.prototype,
      /** @lends OpenSeadragon.TiledImage.prototype */
      {
        /**
         * @returns {Boolean} Whether the TiledImage needs to be drawn.
         */
        needsDraw: function() {
          return this._needsDraw;
        },
        /**
         * @returns {Boolean} Whether all tiles necessary for this TiledImage to draw at the current view have been loaded.
         */
        getFullyLoaded: function() {
          return this._fullyLoaded;
        },
        // private
        _setFullyLoaded: function(ct) {
          ct !== this._fullyLoaded && (this._fullyLoaded = ct, this.raiseEvent("fully-loaded-change", {
            fullyLoaded: this._fullyLoaded
          }));
        },
        /**
         * Clears all tiles and triggers an update on the next call to
         * {@link OpenSeadragon.TiledImage#update}.
         */
        reset: function() {
          this._tileCache.clearTilesFor(this), this.lastResetTime = ie.now(), this._needsDraw = !0;
        },
        /**
         * Updates the TiledImage's bounds, animating if needed.
         * @returns {Boolean} Whether the TiledImage animated.
         */
        update: function() {
          var ct = this._xSpring.update(), _r = this._ySpring.update(), Kr = this._scaleSpring.update(), Xr = this._degreesSpring.update();
          return ct || _r || Kr || Xr ? (this._updateForScale(), this._needsDraw = !0, !0) : !1;
        },
        /**
         * Draws the TiledImage to its Drawer.
         */
        draw: function() {
          this.opacity !== 0 || this._preload ? (this._midDraw = !0, this._updateViewport(), this._midDraw = !1) : this._needsDraw = !1;
        },
        /**
         * Destroy the TiledImage (unload current loaded tiles).
         */
        destroy: function() {
          this.reset();
        },
        /**
         * Get this TiledImage's bounds in viewport coordinates.
         * @param {Boolean} [current=false] - Pass true for the current location;
         * false for target location.
         * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
         */
        getBounds: function(ct) {
          return this.getBoundsNoRotate(ct).rotate(this.getRotation(ct), this._getRotationPoint(ct));
        },
        /**
         * Get this TiledImage's bounds in viewport coordinates without taking
         * rotation into account.
         * @param {Boolean} [current=false] - Pass true for the current location;
         * false for target location.
         * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
         */
        getBoundsNoRotate: function(ct) {
          return ct ? new ie.Rect(
            this._xSpring.current.value,
            this._ySpring.current.value,
            this._worldWidthCurrent,
            this._worldHeightCurrent
          ) : new ie.Rect(
            this._xSpring.target.value,
            this._ySpring.target.value,
            this._worldWidthTarget,
            this._worldHeightTarget
          );
        },
        // deprecated
        getWorldBounds: function() {
          return ie.console.error("[TiledImage.getWorldBounds] is deprecated; use TiledImage.getBounds instead"), this.getBounds();
        },
        /**
         * Get the bounds of the displayed part of the tiled image.
         * @param {Boolean} [current=false] Pass true for the current location,
         * false for the target location.
         * @returns {$.Rect} The clipped bounds in viewport coordinates.
         */
        getClippedBounds: function(ct) {
          var _r = this.getBoundsNoRotate(ct);
          if (this._clip) {
            var Kr = ct ? this._worldWidthCurrent : this._worldWidthTarget, Xr = Kr / this.source.dimensions.x, Jr = this._clip.times(Xr);
            _r = new ie.Rect(
              _r.x + Jr.x,
              _r.y + Jr.y,
              Jr.width,
              Jr.height
            );
          }
          return _r.rotate(this.getRotation(ct), this._getRotationPoint(ct));
        },
        /**
         * @returns {OpenSeadragon.Point} This TiledImage's content size, in original pixels.
         */
        getContentSize: function() {
          return new ie.Point(this.source.dimensions.x, this.source.dimensions.y);
        },
        // private
        _viewportToImageDelta: function(ct, _r, Kr) {
          var Xr = Kr ? this._scaleSpring.current.value : this._scaleSpring.target.value;
          return new ie.Point(
            ct * (this.source.dimensions.x / Xr),
            _r * (this.source.dimensions.y * this.contentAspectX / Xr)
          );
        },
        /**
         * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
         * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
         * @param {Number|OpenSeadragon.Point} viewerX - The X coordinate or point in viewport coordinate system.
         * @param {Number} [viewerY] - The Y coordinate in viewport coordinate system.
         * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
         * @return {OpenSeadragon.Point} A point representing the coordinates in the image.
         */
        viewportToImageCoordinates: function(ct, _r, Kr) {
          var Xr;
          return ct instanceof ie.Point ? (Kr = _r, Xr = ct) : Xr = new ie.Point(ct, _r), Xr = Xr.rotate(-this.getRotation(Kr), this._getRotationPoint(Kr)), Kr ? this._viewportToImageDelta(
            Xr.x - this._xSpring.current.value,
            Xr.y - this._ySpring.current.value
          ) : this._viewportToImageDelta(
            Xr.x - this._xSpring.target.value,
            Xr.y - this._ySpring.target.value
          );
        },
        // private
        _imageToViewportDelta: function(ct, _r, Kr) {
          var Xr = Kr ? this._scaleSpring.current.value : this._scaleSpring.target.value;
          return new ie.Point(
            ct / this.source.dimensions.x * Xr,
            _r / this.source.dimensions.y / this.contentAspectX * Xr
          );
        },
        /**
         * Translates from image coordinate system to OpenSeadragon viewer coordinate system
         * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
         * @param {Number|OpenSeadragon.Point} imageX - The X coordinate or point in image coordinate system.
         * @param {Number} [imageY] - The Y coordinate in image coordinate system.
         * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
         * @return {OpenSeadragon.Point} A point representing the coordinates in the viewport.
         */
        imageToViewportCoordinates: function(ct, _r, Kr) {
          ct instanceof ie.Point && (Kr = _r, _r = ct.y, ct = ct.x);
          var Xr = this._imageToViewportDelta(ct, _r);
          return Kr ? (Xr.x += this._xSpring.current.value, Xr.y += this._ySpring.current.value) : (Xr.x += this._xSpring.target.value, Xr.y += this._ySpring.target.value), Xr.rotate(this.getRotation(Kr), this._getRotationPoint(Kr));
        },
        /**
         * Translates from a rectangle which describes a portion of the image in
         * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
         * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
         * @param {Number|OpenSeadragon.Rect} imageX - The left coordinate or rectangle in image coordinate system.
         * @param {Number} [imageY] - The top coordinate in image coordinate system.
         * @param {Number} [pixelWidth] - The width in pixel of the rectangle.
         * @param {Number} [pixelHeight] - The height in pixel of the rectangle.
         * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
         * @return {OpenSeadragon.Rect} A rect representing the coordinates in the viewport.
         */
        imageToViewportRectangle: function(ct, _r, Kr, Xr, Jr) {
          var ei = ct;
          ei instanceof ie.Rect ? Jr = _r : ei = new ie.Rect(ct, _r, Kr, Xr);
          var si = this.imageToViewportCoordinates(ei.getTopLeft(), Jr), ri = this._imageToViewportDelta(ei.width, ei.height, Jr);
          return new ie.Rect(
            si.x,
            si.y,
            ri.x,
            ri.y,
            ei.degrees + this.getRotation(Jr)
          );
        },
        /**
         * Translates from a rectangle which describes a portion of
         * the viewport in point coordinates to image rectangle coordinates.
         * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
         * @param {Number|OpenSeadragon.Rect} viewerX - The left coordinate or rectangle in viewport coordinate system.
         * @param {Number} [viewerY] - The top coordinate in viewport coordinate system.
         * @param {Number} [pointWidth] - The width in viewport coordinate system.
         * @param {Number} [pointHeight] - The height in viewport coordinate system.
         * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
         * @return {OpenSeadragon.Rect} A rect representing the coordinates in the image.
         */
        viewportToImageRectangle: function(ct, _r, Kr, Xr, Jr) {
          var ei = ct;
          ct instanceof ie.Rect ? Jr = _r : ei = new ie.Rect(ct, _r, Kr, Xr);
          var si = this.viewportToImageCoordinates(ei.getTopLeft(), Jr), ri = this._viewportToImageDelta(ei.width, ei.height, Jr);
          return new ie.Rect(
            si.x,
            si.y,
            ri.x,
            ri.y,
            ei.degrees - this.getRotation(Jr)
          );
        },
        /**
         * Convert pixel coordinates relative to the viewer element to image
         * coordinates.
         * @param {OpenSeadragon.Point} pixel
         * @returns {OpenSeadragon.Point}
         */
        viewerElementToImageCoordinates: function(ct) {
          var _r = this.viewport.pointFromPixel(ct, !0);
          return this.viewportToImageCoordinates(_r);
        },
        /**
         * Convert pixel coordinates relative to the image to
         * viewer element coordinates.
         * @param {OpenSeadragon.Point} pixel
         * @returns {OpenSeadragon.Point}
         */
        imageToViewerElementCoordinates: function(ct) {
          var _r = this.imageToViewportCoordinates(ct);
          return this.viewport.pixelFromPoint(_r, !0);
        },
        /**
         * Convert pixel coordinates relative to the window to image coordinates.
         * @param {OpenSeadragon.Point} pixel
         * @returns {OpenSeadragon.Point}
         */
        windowToImageCoordinates: function(ct) {
          var _r = ct.minus(
            OpenSeadragon.getElementPosition(this.viewer.element)
          );
          return this.viewerElementToImageCoordinates(_r);
        },
        /**
         * Convert image coordinates to pixel coordinates relative to the window.
         * @param {OpenSeadragon.Point} pixel
         * @returns {OpenSeadragon.Point}
         */
        imageToWindowCoordinates: function(ct) {
          var _r = this.imageToViewerElementCoordinates(ct);
          return _r.plus(
            OpenSeadragon.getElementPosition(this.viewer.element)
          );
        },
        // private
        // Convert rectangle in viewport coordinates to this tiled image point
        // coordinates (x in [0, 1] and y in [0, aspectRatio])
        _viewportToTiledImageRectangle: function(ct) {
          var _r = this._scaleSpring.current.value;
          return ct = ct.rotate(-this.getRotation(!0), this._getRotationPoint(!0)), new ie.Rect(
            (ct.x - this._xSpring.current.value) / _r,
            (ct.y - this._ySpring.current.value) / _r,
            ct.width / _r,
            ct.height / _r,
            ct.degrees
          );
        },
        /**
         * Convert a viewport zoom to an image zoom.
         * Image zoom: ratio of the original image size to displayed image size.
         * 1 means original image size, 0.5 half size...
         * Viewport zoom: ratio of the displayed image's width to viewport's width.
         * 1 means identical width, 2 means image's width is twice the viewport's width...
         * @function
         * @param {Number} viewportZoom The viewport zoom
         * @returns {Number} imageZoom The image zoom
         */
        viewportToImageZoom: function(ct) {
          var _r = this._scaleSpring.current.value * this.viewport._containerInnerSize.x / this.source.dimensions.x;
          return _r * ct;
        },
        /**
         * Convert an image zoom to a viewport zoom.
         * Image zoom: ratio of the original image size to displayed image size.
         * 1 means original image size, 0.5 half size...
         * Viewport zoom: ratio of the displayed image's width to viewport's width.
         * 1 means identical width, 2 means image's width is twice the viewport's width...
         * Note: not accurate with multi-image.
         * @function
         * @param {Number} imageZoom The image zoom
         * @returns {Number} viewportZoom The viewport zoom
         */
        imageToViewportZoom: function(ct) {
          var _r = this._scaleSpring.current.value * this.viewport._containerInnerSize.x / this.source.dimensions.x;
          return ct / _r;
        },
        /**
         * Sets the TiledImage's position in the world.
         * @param {OpenSeadragon.Point} position - The new position, in viewport coordinates.
         * @param {Boolean} [immediately=false] - Whether to animate to the new position or snap immediately.
         * @fires OpenSeadragon.TiledImage.event:bounds-change
         */
        setPosition: function(ct, _r) {
          var Kr = this._xSpring.target.value === ct.x && this._ySpring.target.value === ct.y;
          if (_r) {
            if (Kr && this._xSpring.current.value === ct.x && this._ySpring.current.value === ct.y)
              return;
            this._xSpring.resetTo(ct.x), this._ySpring.resetTo(ct.y), this._needsDraw = !0;
          } else {
            if (Kr)
              return;
            this._xSpring.springTo(ct.x), this._ySpring.springTo(ct.y), this._needsDraw = !0;
          }
          Kr || this._raiseBoundsChange();
        },
        /**
         * Sets the TiledImage's width in the world, adjusting the height to match based on aspect ratio.
         * @param {Number} width - The new width, in viewport coordinates.
         * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
         * @fires OpenSeadragon.TiledImage.event:bounds-change
         */
        setWidth: function(ct, _r) {
          this._setScale(ct, _r);
        },
        /**
         * Sets the TiledImage's height in the world, adjusting the width to match based on aspect ratio.
         * @param {Number} height - The new height, in viewport coordinates.
         * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
         * @fires OpenSeadragon.TiledImage.event:bounds-change
         */
        setHeight: function(ct, _r) {
          this._setScale(ct / this.normHeight, _r);
        },
        /**
         * Sets an array of polygons to crop the TiledImage during draw tiles.
         * The render function will use the default non-zero winding rule.
         * @param Polygons represented in an array of point object in image coordinates.
         * Example format: [
         *  [{x: 197, y:172}, {x: 226, y:172}, {x: 226, y:198}, {x: 197, y:198}], // First polygon
         *  [{x: 328, y:200}, {x: 330, y:199}, {x: 332, y:201}, {x: 329, y:202}]  // Second polygon
         *  [{x: 321, y:201}, {x: 356, y:205}, {x: 341, y:250}] // Third polygon
         * ]
         */
        setCroppingPolygons: function(ct) {
          var _r = function(Xr) {
            return Xr instanceof ie.Point || typeof Xr.x == "number" && typeof Xr.y == "number";
          }, Kr = function(Xr) {
            return Xr.map(function(Jr) {
              try {
                if (_r(Jr))
                  return { x: Jr.x, y: Jr.y };
                throw new Error();
              } catch {
                throw new Error("A Provided cropping polygon point is not supported");
              }
            });
          };
          try {
            if (!ie.isArray(ct))
              throw new Error("Provided cropping polygon is not an array");
            this._croppingPolygons = ct.map(function(Xr) {
              return Kr(Xr);
            });
          } catch (Xr) {
            ie.console.error("[TiledImage.setCroppingPolygons] Cropping polygon format not supported"), ie.console.error(Xr), this._croppingPolygons = null;
          }
        },
        /**
         * Resets the cropping polygons, thus next render will remove all cropping
         * polygon effects.
         */
        resetCroppingPolygons: function() {
          this._croppingPolygons = null;
        },
        /**
         * Positions and scales the TiledImage to fit in the specified bounds.
         * Note: this method fires OpenSeadragon.TiledImage.event:bounds-change
         * twice
         * @param {OpenSeadragon.Rect} bounds The bounds to fit the image into.
         * @param {OpenSeadragon.Placement} [anchor=OpenSeadragon.Placement.CENTER]
         * How to anchor the image in the bounds.
         * @param {Boolean} [immediately=false] Whether to animate to the new size
         * or snap immediately.
         * @fires OpenSeadragon.TiledImage.event:bounds-change
         */
        fitBounds: function(ct, _r, Kr) {
          _r = _r || ie.Placement.CENTER;
          var Xr = ie.Placement.properties[_r], Jr = this.contentAspectX, ei = 0, si = 0, ri = 1, ai = 1;
          if (this._clip && (Jr = this._clip.getAspectRatio(), ri = this._clip.width / this.source.dimensions.x, ai = this._clip.height / this.source.dimensions.y, ct.getAspectRatio() > Jr ? (ei = this._clip.x / this._clip.height * ct.height, si = this._clip.y / this._clip.height * ct.height) : (ei = this._clip.x / this._clip.width * ct.width, si = this._clip.y / this._clip.width * ct.width)), ct.getAspectRatio() > Jr) {
            var yi = ct.height / ai, pi = 0;
            Xr.isHorizontallyCentered ? pi = (ct.width - ct.height * Jr) / 2 : Xr.isRight && (pi = ct.width - ct.height * Jr), this.setPosition(
              new ie.Point(ct.x - ei + pi, ct.y - si),
              Kr
            ), this.setHeight(yi, Kr);
          } else {
            var di = ct.width / ri, xi = 0;
            Xr.isVerticallyCentered ? xi = (ct.height - ct.width / Jr) / 2 : Xr.isBottom && (xi = ct.height - ct.width / Jr), this.setPosition(
              new ie.Point(ct.x - ei, ct.y - si + xi),
              Kr
            ), this.setWidth(di, Kr);
          }
        },
        /**
         * @returns {OpenSeadragon.Rect|null} The TiledImage's current clip rectangle,
         * in image pixels, or null if none.
         */
        getClip: function() {
          return this._clip ? this._clip.clone() : null;
        },
        /**
         * @param {OpenSeadragon.Rect|null} newClip - An area, in image pixels, to clip to
         * (portions of the image outside of this area will not be visible). Only works on
         * browsers that support the HTML5 canvas.
         * @fires OpenSeadragon.TiledImage.event:clip-change
         */
        setClip: function(ct) {
          ie.console.assert(
            !ct || ct instanceof ie.Rect,
            "[TiledImage.setClip] newClip must be an OpenSeadragon.Rect or null"
          ), ct instanceof ie.Rect ? this._clip = ct.clone() : this._clip = null, this._needsDraw = !0, this.raiseEvent("clip-change");
        },
        /**
         * @returns {Number} The TiledImage's current opacity.
         */
        getOpacity: function() {
          return this.opacity;
        },
        /**
         * @param {Number} opacity Opacity the tiled image should be drawn at.
         * @fires OpenSeadragon.TiledImage.event:opacity-change
         */
        setOpacity: function(ct) {
          ct !== this.opacity && (this.opacity = ct, this._needsDraw = !0, this.raiseEvent("opacity-change", {
            opacity: this.opacity
          }));
        },
        /**
         * @returns {Boolean} whether the tiledImage can load its tiles even when it has zero opacity.
         */
        getPreload: function() {
          return this._preload;
        },
        /**
         * Set true to load even when hidden. Set false to block loading when hidden.
         */
        setPreload: function(ct) {
          this._preload = !!ct, this._needsDraw = !0;
        },
        /**
         * Get the rotation of this tiled image in degrees.
         * @param {Boolean} [current=false] True for current rotation, false for target.
         * @returns {Number} the rotation of this tiled image in degrees.
         */
        getRotation: function(ct) {
          return ct ? this._degreesSpring.current.value : this._degreesSpring.target.value;
        },
        /**
         * Set the current rotation of this tiled image in degrees.
         * @param {Number} degrees the rotation in degrees.
         * @param {Boolean} [immediately=false] Whether to animate to the new angle
         * or rotate immediately.
         * @fires OpenSeadragon.TiledImage.event:bounds-change
         */
        setRotation: function(ct, _r) {
          this._degreesSpring.target.value === ct && this._degreesSpring.isAtTargetValue() || (_r ? this._degreesSpring.resetTo(ct) : this._degreesSpring.springTo(ct), this._needsDraw = !0, this._raiseBoundsChange());
        },
        /**
         * Get the point around which this tiled image is rotated
         * @private
         * @param {Boolean} current True for current rotation point, false for target.
         * @returns {OpenSeadragon.Point}
         */
        _getRotationPoint: function(ct) {
          return this.getBoundsNoRotate(ct).getCenter();
        },
        /**
         * @returns {String} The TiledImage's current compositeOperation.
         */
        getCompositeOperation: function() {
          return this.compositeOperation;
        },
        /**
         * @param {String} compositeOperation the tiled image should be drawn with this globalCompositeOperation.
         * @fires OpenSeadragon.TiledImage.event:composite-operation-change
         */
        setCompositeOperation: function(ct) {
          ct !== this.compositeOperation && (this.compositeOperation = ct, this._needsDraw = !0, this.raiseEvent("composite-operation-change", {
            compositeOperation: this.compositeOperation
          }));
        },
        // private
        _setScale: function(ct, _r) {
          var Kr = this._scaleSpring.target.value === ct;
          if (_r) {
            if (Kr && this._scaleSpring.current.value === ct)
              return;
            this._scaleSpring.resetTo(ct), this._updateForScale(), this._needsDraw = !0;
          } else {
            if (Kr)
              return;
            this._scaleSpring.springTo(ct), this._updateForScale(), this._needsDraw = !0;
          }
          Kr || this._raiseBoundsChange();
        },
        // private
        _updateForScale: function() {
          this._worldWidthTarget = this._scaleSpring.target.value, this._worldHeightTarget = this.normHeight * this._scaleSpring.target.value, this._worldWidthCurrent = this._scaleSpring.current.value, this._worldHeightCurrent = this.normHeight * this._scaleSpring.current.value;
        },
        // private
        _raiseBoundsChange: function() {
          this.raiseEvent("bounds-change");
        },
        // private
        _isBottomItem: function() {
          return this.viewer.world.getItemAt(0) === this;
        },
        // private
        _getLevelsInterval: function() {
          var ct = Math.max(
            this.source.minLevel,
            Math.floor(Math.log(this.minZoomImageRatio) / Math.log(2))
          ), _r = this.viewport.deltaPixelsFromPointsNoRotate(
            this.source.getPixelRatio(0),
            !0
          ).x * this._scaleSpring.current.value, Kr = Math.min(
            Math.abs(this.source.maxLevel),
            Math.abs(Math.floor(
              Math.log(_r / this.minPixelRatio) / Math.log(2)
            ))
          );
          return Kr = Math.max(Kr, this.source.minLevel || 0), ct = Math.min(ct, Kr), {
            lowestLevel: ct,
            highestLevel: Kr
          };
        },
        /**
         * @private
         * @inner
         * Pretty much every other line in this needs to be documented so it's clear
         * how each piece of this routine contributes to the drawing process.  That's
         * why there are so many TODO's inside this function.
         */
        _updateViewport: function() {
          for (this._needsDraw = !1, this._tilesLoading = 0, this.loadingCoverage = {}; this.lastDrawn.length > 0; ) {
            var ct = this.lastDrawn.pop();
            ct.beingDrawn = !1;
          }
          var _r = this.viewport, Kr = this._viewportToTiledImageRectangle(
            _r.getBoundsWithMargins(!0)
          );
          if (!this.wrapHorizontal && !this.wrapVertical) {
            var Xr = this._viewportToTiledImageRectangle(
              this.getClippedBounds(!0)
            );
            if (Kr = Kr.intersection(Xr), Kr === null)
              return;
          }
          for (var Jr = this._getLevelsInterval(), ei = Jr.lowestLevel, si = Jr.highestLevel, ri = null, ai = !1, yi = ie.now(), pi = si; pi >= ei; pi--) {
            var di = !1, xi = _r.deltaPixelsFromPointsNoRotate(
              this.source.getPixelRatio(pi),
              !0
            ).x * this._scaleSpring.current.value;
            if (pi === ei || !ai && xi >= this.minPixelRatio)
              di = !0, ai = !0;
            else if (!ai)
              continue;
            var Ti = _r.deltaPixelsFromPointsNoRotate(
              this.source.getPixelRatio(pi),
              !1
            ).x * this._scaleSpring.current.value, Ai = _r.deltaPixelsFromPointsNoRotate(
              this.source.getPixelRatio(
                Math.max(
                  this.source.getClosestLevel(),
                  0
                )
              ),
              !1
            ).x * this._scaleSpring.current.value, mi = this.immediateRender ? 1 : Ai, Si = Math.min(1, (xi - 0.5) / 0.5), gi = mi / Math.abs(
              mi - Ti
            );
            if (ri = Z(
              this,
              ai,
              di,
              pi,
              Si,
              gi,
              Kr,
              yi,
              ri
            ), Je(this.coverage, pi))
              break;
          }
          ft(this, this.lastDrawn), ri && !ri.context2D ? (ve(this, ri, yi), this._needsDraw = !0, this._setFullyLoaded(!1)) : this._setFullyLoaded(this._tilesLoading === 0);
        },
        // private
        _getCornerTiles: function(ct, _r, Kr) {
          var Xr, Jr;
          this.wrapHorizontal ? (Xr = ie.positiveModulo(_r.x, 1), Jr = ie.positiveModulo(Kr.x, 1)) : (Xr = Math.max(0, _r.x), Jr = Math.min(1, Kr.x));
          var ei, si, ri = 1 / this.source.aspectRatio;
          this.wrapVertical ? (ei = ie.positiveModulo(_r.y, ri), si = ie.positiveModulo(Kr.y, ri)) : (ei = Math.max(0, _r.y), si = Math.min(ri, Kr.y));
          var ai = this.source.getTileAtPoint(ct, new ie.Point(Xr, ei)), yi = this.source.getTileAtPoint(ct, new ie.Point(Jr, si)), pi = this.source.getNumTiles(ct);
          return this.wrapHorizontal && (ai.x += pi.x * Math.floor(_r.x), yi.x += pi.x * Math.floor(Kr.x)), this.wrapVertical && (ai.y += pi.y * Math.floor(_r.y / ri), yi.y += pi.y * Math.floor(Kr.y / ri)), {
            topLeft: ai,
            bottomRight: yi
          };
        }
      }
    );
    function Z(ct, _r, Kr, Xr, Jr, ei, si, ri, ai) {
      var yi = si.getBoundingBox().getTopLeft(), pi = si.getBoundingBox().getBottomRight();
      ct.viewer && ct.viewer.raiseEvent("update-level", {
        tiledImage: ct,
        havedrawn: _r,
        level: Xr,
        opacity: Jr,
        visibility: ei,
        drawArea: si,
        topleft: yi,
        bottomright: pi,
        currenttime: ri,
        best: ai
      }), ot(ct.coverage, Xr), ot(ct.loadingCoverage, Xr);
      for (var di = ct._getCornerTiles(Xr, yi, pi), xi = di.topLeft, Ti = di.bottomRight, Ai = ct.source.getNumTiles(Xr), mi = ct.viewport.pixelFromPoint(
        ct.viewport.getCenter()
      ), Si = xi.x; Si <= Ti.x; Si++)
        for (var gi = xi.y; gi <= Ti.y; gi++) {
          if (!ct.wrapHorizontal && !ct.wrapVertical) {
            var _i = ct.source.getTileBounds(Xr, Si, gi);
            if (si.intersection(_i) === null)
              continue;
          }
          ai = ee(
            ct,
            Kr,
            _r,
            Si,
            gi,
            Xr,
            Jr,
            ei,
            mi,
            Ai,
            ri,
            ai
          );
        }
      return ai;
    }
    function ee(ct, _r, Kr, Xr, Jr, ei, si, ri, ai, yi, pi, di) {
      var xi = ae(
        Xr,
        Jr,
        ei,
        ct,
        ct.source,
        ct.tilesMatrix,
        pi,
        yi,
        ct._worldWidthCurrent,
        ct._worldHeightCurrent
      ), Ti = Kr;
      ct.viewer && ct.viewer.raiseEvent("update-tile", {
        tiledImage: ct,
        tile: xi
      }), st(ct.coverage, ei, Xr, Jr, !1);
      var Ai = xi.loaded || xi.loading || nt(ct.loadingCoverage, ei, Xr, Jr);
      if (st(ct.loadingCoverage, ei, Xr, Jr, Ai), !xi.exists || (_r && !Ti && (nt(ct.coverage, ei, Xr, Jr) ? st(ct.coverage, ei, Xr, Jr, !0) : Ti = !0), !Ti))
        return di;
      if (Ye(
        xi,
        ct.source.tileOverlap,
        ct.viewport,
        ai,
        ri,
        ct
      ), !xi.loaded)
        if (xi.context2D)
          be(ct, xi);
        else {
          var mi = ct._tileCache.getImageRecord(xi.cacheKey);
          if (mi) {
            var Si = mi.getImage();
            be(ct, xi, Si);
          }
        }
      if (xi.loaded) {
        var gi = Qe(
          ct,
          xi,
          Xr,
          Jr,
          ei,
          si,
          pi
        );
        gi && (ct._needsDraw = !0);
      } else
        xi.loading ? ct._tilesLoading++ : Ai || (di = lt(di, xi));
      return di;
    }
    function ae(ct, _r, Kr, Xr, Jr, ei, si, ri, ai, yi) {
      var pi, di, xi, Ti, Ai, mi, Si, gi, _i;
      return ei[Kr] || (ei[Kr] = {}), ei[Kr][ct] || (ei[Kr][ct] = {}), ei[Kr][ct][_r] || (pi = (ri.x + ct % ri.x) % ri.x, di = (ri.y + _r % ri.y) % ri.y, xi = Jr.getTileBounds(Kr, pi, di), Ti = Jr.getTileBounds(Kr, pi, di, !0), Ai = Jr.tileExists(Kr, pi, di), mi = Jr.getTileUrl(Kr, pi, di), Xr.loadTilesWithAjax ? (Si = Jr.getTileAjaxHeaders(Kr, pi, di), ie.isPlainObject(Xr.ajaxHeaders) && (Si = ie.extend({}, Xr.ajaxHeaders, Si))) : Si = null, gi = Jr.getContext2D ? Jr.getContext2D(Kr, pi, di) : void 0, xi.x += (ct - pi) / ri.x, xi.y += yi / ai * ((_r - di) / ri.y), _i = new ie.Tile(
        Kr,
        ct,
        _r,
        xi,
        Ai,
        mi,
        gi,
        Xr.loadTilesWithAjax,
        Si,
        Ti
      ), pi === ri.x - 1 && (_i.isRightMost = !0), di === ri.y - 1 && (_i.isBottomMost = !0), ei[Kr][ct][_r] = _i), _i = ei[Kr][ct][_r], _i.lastTouchTime = si, _i;
    }
    function ve(ct, _r, Kr) {
      _r.loading = !0, ct._imageLoader.addJob({
        src: _r.url,
        loadWithAjax: _r.loadWithAjax,
        ajaxHeaders: _r.ajaxHeaders,
        crossOriginPolicy: ct.crossOriginPolicy,
        ajaxWithCredentials: ct.ajaxWithCredentials,
        callback: function(Xr, Jr, ei) {
          ye(ct, _r, Kr, Xr, Jr, ei);
        },
        abort: function() {
          _r.loading = !1;
        }
      });
    }
    function ye(ct, _r, Kr, Xr, Jr, ei) {
      if (!Xr) {
        ie.console.log("Tile %s failed to load: %s - error: %s", _r, _r.url, Jr), ct.viewer.raiseEvent("tile-load-failed", {
          tile: _r,
          tiledImage: ct,
          time: Kr,
          message: Jr,
          tileRequest: ei
        }), _r.loading = !1, _r.exists = !1;
        return;
      }
      if (Kr < ct.lastResetTime) {
        ie.console.log("Ignoring tile %s loaded before reset: %s", _r, _r.url), _r.loading = !1;
        return;
      }
      var si = function() {
        var ri = ct.source.getClosestLevel();
        be(ct, _r, Xr, ri, ei);
      };
      ct._midDraw ? window.setTimeout(si, 1) : si();
    }
    function be(ct, _r, Kr, Xr, Jr) {
      var ei = 0;
      function si() {
        return ei++, ri;
      }
      function ri() {
        ei--, ei === 0 && (_r.loading = !1, _r.loaded = !0, _r.context2D || ct._tileCache.cacheTile({
          image: Kr,
          tile: _r,
          cutoff: Xr,
          tiledImage: ct
        }), ct._needsDraw = !0);
      }
      ct.viewer.raiseEvent("tile-loaded", {
        tile: _r,
        tiledImage: ct,
        tileRequest: Jr,
        image: Kr,
        getCompletionCallback: si
      }), si()();
    }
    function Ye(ct, _r, Kr, Xr, Jr, ei) {
      var si = ct.bounds.getTopLeft();
      si.x *= ei._scaleSpring.current.value, si.y *= ei._scaleSpring.current.value, si.x += ei._xSpring.current.value, si.y += ei._ySpring.current.value;
      var ri = ct.bounds.getSize();
      ri.x *= ei._scaleSpring.current.value, ri.y *= ei._scaleSpring.current.value;
      var ai = Kr.pixelFromPointNoRotate(si, !0), yi = Kr.pixelFromPointNoRotate(si, !1), pi = Kr.deltaPixelsFromPointsNoRotate(ri, !0), di = Kr.deltaPixelsFromPointsNoRotate(ri, !1), xi = yi.plus(di.divide(2)), Ti = Xr.squaredDistanceTo(xi);
      _r || (pi = pi.plus(new ie.Point(1, 1))), ct.isRightMost && ei.wrapHorizontal && (pi.x += 0.75), ct.isBottomMost && ei.wrapVertical && (pi.y += 0.75), ct.position = ai, ct.size = pi, ct.squaredDistance = Ti, ct.visibility = Jr;
    }
    function Qe(ct, _r, Kr, Xr, Jr, ei, si) {
      var ri = 1e3 * ct.blendTime, ai, yi;
      if (_r.blendStart || (_r.blendStart = si), ai = si - _r.blendStart, yi = ri ? Math.min(1, ai / ri) : 1, ct.alwaysBlend && (yi *= ei), _r.opacity = yi, ct.lastDrawn.push(_r), yi === 1)
        st(ct.coverage, Jr, Kr, Xr, !0), ct._hasOpaqueTile = !0;
      else if (ai < ri)
        return !0;
      return !1;
    }
    function Je(ct, _r, Kr, Xr) {
      var Jr, ei, si, ri;
      if (!ct[_r])
        return !1;
      if (Kr === void 0 || Xr === void 0) {
        Jr = ct[_r];
        for (si in Jr)
          if (Object.prototype.hasOwnProperty.call(Jr, si)) {
            ei = Jr[si];
            for (ri in ei)
              if (Object.prototype.hasOwnProperty.call(ei, ri) && !ei[ri])
                return !1;
          }
        return !0;
      }
      return ct[_r][Kr] === void 0 || ct[_r][Kr][Xr] === void 0 || ct[_r][Kr][Xr] === !0;
    }
    function nt(ct, _r, Kr, Xr) {
      return Kr === void 0 || Xr === void 0 ? Je(ct, _r + 1) : Je(ct, _r + 1, 2 * Kr, 2 * Xr) && Je(ct, _r + 1, 2 * Kr, 2 * Xr + 1) && Je(ct, _r + 1, 2 * Kr + 1, 2 * Xr) && Je(ct, _r + 1, 2 * Kr + 1, 2 * Xr + 1);
    }
    function st(ct, _r, Kr, Xr, Jr) {
      if (!ct[_r]) {
        ie.console.warn(
          "Setting coverage for a tile before its level's coverage has been reset: %s",
          _r
        );
        return;
      }
      ct[_r][Kr] || (ct[_r][Kr] = {}), ct[_r][Kr][Xr] = Jr;
    }
    function ot(ct, _r) {
      ct[_r] = {};
    }
    function lt(ct, _r) {
      return !ct || _r.visibility > ct.visibility || _r.visibility == ct.visibility && _r.squaredDistance < ct.squaredDistance ? _r : ct;
    }
    function ft(ct, _r) {
      if (!(ct.opacity === 0 || _r.length === 0 && !ct.placeholderFillStyle)) {
        var Kr = _r[0], Xr;
        Kr && (Xr = ct.opacity < 1 || ct.compositeOperation && ct.compositeOperation !== "source-over" || !ct._isBottomItem() && Kr._hasTransparencyChannel());
        var Jr, ei, si = ct.viewport.getZoom(!0), ri = ct.viewportToImageZoom(si);
        _r.length > 1 && ri > ct.smoothTileEdgesMinZoom && !ct.iOSDevice && ct.getRotation(!0) % 360 === 0 && // TODO: support tile edge smoothing with tiled image rotation.
        ie.supportsCanvas && (Xr = !0, Jr = Kr.getScaleForEdgeSmoothing(), ei = Kr.getTranslationForEdgeSmoothing(
          Jr,
          ct._drawer.getCanvasSize(!1),
          ct._drawer.getCanvasSize(!0)
        ));
        var ai;
        Xr && (Jr || (ai = ct.viewport.viewportToViewerElementRectangle(
          ct.getClippedBounds(!0)
        ).getIntegerBoundingBox(), ct._drawer.viewer.viewport.getFlip() && (ct.viewport.degrees !== 0 || ct.getRotation(!0) % 360 !== 0) && (ai.x = ct._drawer.viewer.container.clientWidth - (ai.x + ai.width)), ai = ai.times(ie.pixelDensityRatio)), ct._drawer._clear(!0, ai)), Jr || (ct.viewport.degrees !== 0 && ct._drawer._offsetForRotation({
          degrees: ct.viewport.degrees,
          useSketch: Xr
        }), ct.getRotation(!0) % 360 !== 0 && ct._drawer._offsetForRotation({
          degrees: ct.getRotation(!0),
          point: ct.viewport.pixelFromPointNoRotate(
            ct._getRotationPoint(!0),
            !0
          ),
          useSketch: Xr
        }), ct.viewport.degrees === 0 && ct.getRotation(!0) % 360 === 0 && ct._drawer.viewer.viewport.getFlip() && ct._drawer._flip());
        var yi = !1;
        if (ct._clip) {
          ct._drawer.saveContext(Xr);
          var pi = ct.imageToViewportRectangle(ct._clip, !0);
          pi = pi.rotate(-ct.getRotation(!0), ct._getRotationPoint(!0));
          var di = ct._drawer.viewportToDrawerRectangle(pi);
          Jr && (di = di.times(Jr)), ei && (di = di.translate(ei)), ct._drawer.setClip(di, Xr), yi = !0;
        }
        if (ct._croppingPolygons) {
          ct._drawer.saveContext(Xr);
          try {
            var xi = ct._croppingPolygons.map(function(Si) {
              return Si.map(function(gi) {
                var _i = ct.imageToViewportCoordinates(gi.x, gi.y, !0).rotate(-ct.getRotation(!0), ct._getRotationPoint(!0)), Oi = ct._drawer.viewportCoordToDrawerCoord(_i);
                return Jr && (Oi = Oi.times(Jr)), Oi;
              });
            });
            ct._drawer.clipWithPolygons(xi, Xr);
          } catch (Si) {
            ie.console.error(Si);
          }
          yi = !0;
        }
        if (ct.placeholderFillStyle && ct._hasOpaqueTile === !1) {
          var Ti = ct._drawer.viewportToDrawerRectangle(ct.getBounds(!0));
          Jr && (Ti = Ti.times(Jr)), ei && (Ti = Ti.translate(ei));
          var Ai = null;
          typeof ct.placeholderFillStyle == "function" ? Ai = ct.placeholderFillStyle(ct, ct._drawer.context) : Ai = ct.placeholderFillStyle, ct._drawer.drawRectangle(Ti, Ai, Xr);
        }
        for (var mi = _r.length - 1; mi >= 0; mi--)
          Kr = _r[mi], ct._drawer.drawTile(Kr, ct._drawingHandler, Xr, Jr, ei), Kr.beingDrawn = !0, ct.viewer && ct.viewer.raiseEvent("tile-drawn", {
            tiledImage: ct,
            tile: Kr
          });
        yi && ct._drawer.restoreContext(Xr), Jr || (ct.getRotation(!0) % 360 !== 0 && ct._drawer._restoreRotationChanges(Xr), ct.viewport.degrees !== 0 && ct._drawer._restoreRotationChanges(Xr)), Xr && (Jr && (ct.viewport.degrees !== 0 && ct._drawer._offsetForRotation({
          degrees: ct.viewport.degrees,
          useSketch: !1
        }), ct.getRotation(!0) % 360 !== 0 && ct._drawer._offsetForRotation({
          degrees: ct.getRotation(!0),
          point: ct.viewport.pixelFromPointNoRotate(
            ct._getRotationPoint(!0),
            !0
          ),
          useSketch: !1
        })), ct._drawer.blendSketch({
          opacity: ct.opacity,
          scale: Jr,
          translate: ei,
          compositeOperation: ct.compositeOperation,
          bounds: ai
        }), Jr && (ct.getRotation(!0) % 360 !== 0 && ct._drawer._restoreRotationChanges(!1), ct.viewport.degrees !== 0 && ct._drawer._restoreRotationChanges(!1))), Jr || ct.viewport.degrees === 0 && ct.getRotation(!0) % 360 === 0 && ct._drawer.viewer.viewport.getFlip() && ct._drawer._flip(), gt(ct, _r);
      }
    }
    function gt(ct, _r) {
      if (ct.debugMode)
        for (var Kr = _r.length - 1; Kr >= 0; Kr--) {
          var Xr = _r[Kr];
          try {
            ct._drawer.drawDebugInfo(
              Xr,
              _r.length,
              Kr,
              ct
            );
          } catch (Jr) {
            ie.console.error(Jr);
          }
        }
    }
  }(OpenSeadragon), function(ie) {
    var Z = function(ae) {
      ie.console.assert(ae, "[TileCache.cacheTile] options is required"), ie.console.assert(ae.tile, "[TileCache.cacheTile] options.tile is required"), ie.console.assert(ae.tiledImage, "[TileCache.cacheTile] options.tiledImage is required"), this.tile = ae.tile, this.tiledImage = ae.tiledImage;
    }, ee = function(ae) {
      ie.console.assert(ae, "[ImageRecord] options is required"), ie.console.assert(ae.image, "[ImageRecord] options.image is required"), this._image = ae.image, this._tiles = [];
    };
    ee.prototype = {
      destroy: function() {
        this._image = null, this._renderedContext = null, this._tiles = null;
      },
      getImage: function() {
        return this._image;
      },
      getRenderedContext: function() {
        if (!this._renderedContext) {
          var ae = document.createElement("canvas");
          ae.width = this._image.width, ae.height = this._image.height, this._renderedContext = ae.getContext("2d"), this._renderedContext.drawImage(this._image, 0, 0), this._image = null;
        }
        return this._renderedContext;
      },
      setRenderedContext: function(ae) {
        ie.console.error("ImageRecord.setRenderedContext is deprecated. The rendered context should be created by the ImageRecord itself when calling ImageRecord.getRenderedContext."), this._renderedContext = ae;
      },
      addTile: function(ae) {
        ie.console.assert(ae, "[ImageRecord.addTile] tile is required"), this._tiles.push(ae);
      },
      removeTile: function(ae) {
        for (var ve = 0; ve < this._tiles.length; ve++)
          if (this._tiles[ve] === ae) {
            this._tiles.splice(ve, 1);
            return;
          }
        ie.console.warn("[ImageRecord.removeTile] trying to remove unknown tile", ae);
      },
      getTileCount: function() {
        return this._tiles.length;
      }
    }, ie.TileCache = function(ae) {
      ae = ae || {}, this._maxImageCacheCount = ae.maxImageCacheCount || ie.DEFAULT_SETTINGS.maxImageCacheCount, this._tilesLoaded = [], this._imagesLoaded = [], this._imagesLoadedCount = 0;
    }, ie.TileCache.prototype = {
      /**
       * @returns {Number} The total number of tiles that have been loaded by
       * this TileCache.
       */
      numTilesLoaded: function() {
        return this._tilesLoaded.length;
      },
      /**
       * Caches the specified tile, removing an old tile if necessary to stay under the
       * maxImageCacheCount specified on construction. Note that if multiple tiles reference
       * the same image, there may be more tiles than maxImageCacheCount; the goal is to keep
       * the number of images below that number. Note, as well, that even the number of images
       * may temporarily surpass that number, but should eventually come back down to the max specified.
       * @param {Object} options - Tile info.
       * @param {OpenSeadragon.Tile} options.tile - The tile to cache.
       * @param {String} options.tile.cacheKey - The unique key used to identify this tile in the cache.
       * @param {Image} options.image - The image of the tile to cache.
       * @param {OpenSeadragon.TiledImage} options.tiledImage - The TiledImage that owns that tile.
       * @param {Number} [options.cutoff=0] - If adding this tile goes over the cache max count, this
       * function will release an old tile. The cutoff option specifies a tile level at or below which
       * tiles will not be released.
       */
      cacheTile: function(ae) {
        ie.console.assert(ae, "[TileCache.cacheTile] options is required"), ie.console.assert(ae.tile, "[TileCache.cacheTile] options.tile is required"), ie.console.assert(ae.tile.cacheKey, "[TileCache.cacheTile] options.tile.cacheKey is required"), ie.console.assert(ae.tiledImage, "[TileCache.cacheTile] options.tiledImage is required");
        var ve = ae.cutoff || 0, ye = this._tilesLoaded.length, be = this._imagesLoaded[ae.tile.cacheKey];
        if (be || (ie.console.assert(ae.image, "[TileCache.cacheTile] options.image is required to create an ImageRecord"), be = this._imagesLoaded[ae.tile.cacheKey] = new ee({
          image: ae.image
        }), this._imagesLoadedCount++), be.addTile(ae.tile), ae.tile.cacheImageRecord = be, this._imagesLoadedCount > this._maxImageCacheCount) {
          for (var Ye = null, Qe = -1, Je = null, nt, st, ot, lt, ft, gt, ct = this._tilesLoaded.length - 1; ct >= 0; ct--)
            if (gt = this._tilesLoaded[ct], nt = gt.tile, !(nt.level <= ve || nt.beingDrawn)) {
              if (!Ye) {
                Ye = nt, Qe = ct, Je = gt;
                continue;
              }
              lt = nt.lastTouchTime, st = Ye.lastTouchTime, ft = nt.level, ot = Ye.level, (lt < st || lt == st && ft > ot) && (Ye = nt, Qe = ct, Je = gt);
            }
          Ye && Qe >= 0 && (this._unloadTile(Je), ye = Qe);
        }
        this._tilesLoaded[ye] = new Z({
          tile: ae.tile,
          tiledImage: ae.tiledImage
        });
      },
      /**
       * Clears all tiles associated with the specified tiledImage.
       * @param {OpenSeadragon.TiledImage} tiledImage
       */
      clearTilesFor: function(ae) {
        ie.console.assert(ae, "[TileCache.clearTilesFor] tiledImage is required");
        for (var ve, ye = 0; ye < this._tilesLoaded.length; ++ye)
          ve = this._tilesLoaded[ye], ve.tiledImage === ae && (this._unloadTile(ve), this._tilesLoaded.splice(ye, 1), ye--);
      },
      // private
      getImageRecord: function(ae) {
        return ie.console.assert(ae, "[TileCache.getImageRecord] cacheKey is required"), this._imagesLoaded[ae];
      },
      // private
      _unloadTile: function(ae) {
        ie.console.assert(ae, "[TileCache._unloadTile] tileRecord is required");
        var ve = ae.tile, ye = ae.tiledImage;
        ve.unload(), ve.cacheImageRecord = null;
        var be = this._imagesLoaded[ve.cacheKey];
        be.removeTile(ve), be.getTileCount() || (be.destroy(), delete this._imagesLoaded[ve.cacheKey], this._imagesLoadedCount--), ye.viewer.raiseEvent("tile-unloaded", {
          tile: ve,
          tiledImage: ye
        });
      }
    };
  }(OpenSeadragon), function(ie) {
    ie.World = function(Z) {
      var ee = this;
      ie.console.assert(Z.viewer, "[World] options.viewer is required"), ie.EventSource.call(this), this.viewer = Z.viewer, this._items = [], this._needsDraw = !1, this._autoRefigureSizes = !0, this._needsSizesFigured = !1, this._delegatedFigureSizes = function(ae) {
        ee._autoRefigureSizes ? ee._figureSizes() : ee._needsSizesFigured = !0;
      }, this._figureSizes();
    }, ie.extend(
      ie.World.prototype,
      ie.EventSource.prototype,
      /** @lends OpenSeadragon.World.prototype */
      {
        /**
         * Add the specified item.
         * @param {OpenSeadragon.TiledImage} item - The item to add.
         * @param {Number} [options.index] - Index for the item. If not specified, goes at the top.
         * @fires OpenSeadragon.World.event:add-item
         * @fires OpenSeadragon.World.event:metrics-change
         */
        addItem: function(Z, ee) {
          if (ie.console.assert(Z, "[World.addItem] item is required"), ie.console.assert(Z instanceof ie.TiledImage, "[World.addItem] only TiledImages supported at this time"), ee = ee || {}, ee.index !== void 0) {
            var ae = Math.max(0, Math.min(this._items.length, ee.index));
            this._items.splice(ae, 0, Z);
          } else
            this._items.push(Z);
          this._autoRefigureSizes ? this._figureSizes() : this._needsSizesFigured = !0, this._needsDraw = !0, Z.addHandler("bounds-change", this._delegatedFigureSizes), Z.addHandler("clip-change", this._delegatedFigureSizes), this.raiseEvent("add-item", {
            item: Z
          });
        },
        /**
         * Get the item at the specified index.
         * @param {Number} index - The item's index.
         * @returns {OpenSeadragon.TiledImage} The item at the specified index.
         */
        getItemAt: function(Z) {
          return ie.console.assert(Z !== void 0, "[World.getItemAt] index is required"), this._items[Z];
        },
        /**
         * Get the index of the given item or -1 if not present.
         * @param {OpenSeadragon.TiledImage} item - The item.
         * @returns {Number} The index of the item or -1 if not present.
         */
        getIndexOfItem: function(Z) {
          return ie.console.assert(Z, "[World.getIndexOfItem] item is required"), ie.indexOf(this._items, Z);
        },
        /**
         * @returns {Number} The number of items used.
         */
        getItemCount: function() {
          return this._items.length;
        },
        /**
         * Change the index of a item so that it appears over or under others.
         * @param {OpenSeadragon.TiledImage} item - The item to move.
         * @param {Number} index - The new index.
         * @fires OpenSeadragon.World.event:item-index-change
         */
        setItemIndex: function(Z, ee) {
          ie.console.assert(Z, "[World.setItemIndex] item is required"), ie.console.assert(ee !== void 0, "[World.setItemIndex] index is required");
          var ae = this.getIndexOfItem(Z);
          if (ee >= this._items.length)
            throw new Error("Index bigger than number of layers.");
          ee === ae || ae === -1 || (this._items.splice(ae, 1), this._items.splice(ee, 0, Z), this._needsDraw = !0, this.raiseEvent("item-index-change", {
            item: Z,
            previousIndex: ae,
            newIndex: ee
          }));
        },
        /**
         * Remove an item.
         * @param {OpenSeadragon.TiledImage} item - The item to remove.
         * @fires OpenSeadragon.World.event:remove-item
         * @fires OpenSeadragon.World.event:metrics-change
         */
        removeItem: function(Z) {
          ie.console.assert(Z, "[World.removeItem] item is required");
          var ee = ie.indexOf(this._items, Z);
          ee !== -1 && (Z.removeHandler("bounds-change", this._delegatedFigureSizes), Z.removeHandler("clip-change", this._delegatedFigureSizes), Z.destroy(), this._items.splice(ee, 1), this._figureSizes(), this._needsDraw = !0, this._raiseRemoveItem(Z));
        },
        /**
         * Remove all items.
         * @fires OpenSeadragon.World.event:remove-item
         * @fires OpenSeadragon.World.event:metrics-change
         */
        removeAll: function() {
          this.viewer._cancelPendingImages();
          var Z, ee;
          for (ee = 0; ee < this._items.length; ee++)
            Z = this._items[ee], Z.removeHandler("bounds-change", this._delegatedFigureSizes), Z.removeHandler("clip-change", this._delegatedFigureSizes), Z.destroy();
          var ae = this._items;
          for (this._items = [], this._figureSizes(), this._needsDraw = !0, ee = 0; ee < ae.length; ee++)
            Z = ae[ee], this._raiseRemoveItem(Z);
        },
        /**
         * Clears all tiles and triggers updates for all items.
         */
        resetItems: function() {
          for (var Z = 0; Z < this._items.length; Z++)
            this._items[Z].reset();
        },
        /**
         * Updates (i.e. animates bounds of) all items.
         */
        update: function() {
          for (var Z = !1, ee = 0; ee < this._items.length; ee++)
            Z = this._items[ee].update() || Z;
          return Z;
        },
        /**
         * Draws all items.
         */
        draw: function() {
          for (var Z = 0; Z < this._items.length; Z++)
            this._items[Z].draw();
          this._needsDraw = !1;
        },
        /**
         * @returns {Boolean} true if any items need updating.
         */
        needsDraw: function() {
          for (var Z = 0; Z < this._items.length; Z++)
            if (this._items[Z].needsDraw())
              return !0;
          return this._needsDraw;
        },
        /**
         * @returns {OpenSeadragon.Rect} The smallest rectangle that encloses all items, in viewport coordinates.
         */
        getHomeBounds: function() {
          return this._homeBounds.clone();
        },
        /**
         * To facilitate zoom constraints, we keep track of the pixel density of the
         * densest item in the World (i.e. the item whose content size to viewport size
         * ratio is the highest) and save it as this "content factor".
         * @returns {Number} the number of content units per viewport unit.
         */
        getContentFactor: function() {
          return this._contentFactor;
        },
        /**
         * As a performance optimization, setting this flag to false allows the bounds-change event handler
         * on tiledImages to skip calculations on the world bounds. If a lot of images are going to be positioned in
         * rapid succession, this is a good idea. When finished, setAutoRefigureSizes should be called with true
         * or the system may behave oddly.
         * @param {Boolean} [value] The value to which to set the flag.
         */
        setAutoRefigureSizes: function(Z) {
          this._autoRefigureSizes = Z, Z & this._needsSizesFigured && (this._figureSizes(), this._needsSizesFigured = !1);
        },
        /**
         * Arranges all of the TiledImages with the specified settings.
         * @param {Object} options - Specifies how to arrange.
         * @param {Boolean} [options.immediately=false] - Whether to animate to the new arrangement.
         * @param {String} [options.layout] - See collectionLayout in {@link OpenSeadragon.Options}.
         * @param {Number} [options.rows] - See collectionRows in {@link OpenSeadragon.Options}.
         * @param {Number} [options.columns] - See collectionColumns in {@link OpenSeadragon.Options}.
         * @param {Number} [options.tileSize] - See collectionTileSize in {@link OpenSeadragon.Options}.
         * @param {Number} [options.tileMargin] - See collectionTileMargin in {@link OpenSeadragon.Options}.
         * @fires OpenSeadragon.World.event:metrics-change
         */
        arrange: function(Z) {
          Z = Z || {};
          var ee = Z.immediately || !1, ae = Z.layout || ie.DEFAULT_SETTINGS.collectionLayout, ve = Z.rows || ie.DEFAULT_SETTINGS.collectionRows, ye = Z.columns || ie.DEFAULT_SETTINGS.collectionColumns, be = Z.tileSize || ie.DEFAULT_SETTINGS.collectionTileSize, Ye = Z.tileMargin || ie.DEFAULT_SETTINGS.collectionTileMargin, Qe = be + Ye, Je;
          !Z.rows && ye ? Je = ye : Je = Math.ceil(this._items.length / ve);
          var nt = 0, st = 0, ot, lt, ft, gt, ct;
          this.setAutoRefigureSizes(!1);
          for (var _r = 0; _r < this._items.length; _r++)
            _r && _r % Je === 0 && (ae === "horizontal" ? (st += Qe, nt = 0) : (nt += Qe, st = 0)), ot = this._items[_r], lt = ot.getBounds(), lt.width > lt.height ? ft = be : ft = be * (lt.width / lt.height), gt = ft * (lt.height / lt.width), ct = new ie.Point(
              nt + (be - ft) / 2,
              st + (be - gt) / 2
            ), ot.setPosition(ct, ee), ot.setWidth(ft, ee), ae === "horizontal" ? nt += Qe : st += Qe;
          this.setAutoRefigureSizes(!0);
        },
        // private
        _figureSizes: function() {
          var Z = this._homeBounds ? this._homeBounds.clone() : null, ee = this._contentSize ? this._contentSize.clone() : null, ae = this._contentFactor || 0;
          if (!this._items.length)
            this._homeBounds = new ie.Rect(0, 0, 1, 1), this._contentSize = new ie.Point(1, 1), this._contentFactor = 1;
          else {
            var ve = this._items[0], ye = ve.getBounds();
            this._contentFactor = ve.getContentSize().x / ye.width;
            for (var be = ve.getClippedBounds().getBoundingBox(), Ye = be.x, Qe = be.y, Je = be.x + be.width, nt = be.y + be.height, st = 1; st < this._items.length; st++)
              ve = this._items[st], ye = ve.getBounds(), this._contentFactor = Math.max(
                this._contentFactor,
                ve.getContentSize().x / ye.width
              ), be = ve.getClippedBounds().getBoundingBox(), Ye = Math.min(Ye, be.x), Qe = Math.min(Qe, be.y), Je = Math.max(Je, be.x + be.width), nt = Math.max(nt, be.y + be.height);
            this._homeBounds = new ie.Rect(Ye, Qe, Je - Ye, nt - Qe), this._contentSize = new ie.Point(
              this._homeBounds.width * this._contentFactor,
              this._homeBounds.height * this._contentFactor
            );
          }
          (this._contentFactor !== ae || !this._homeBounds.equals(Z) || !this._contentSize.equals(ee)) && this.raiseEvent("metrics-change", {});
        },
        // private
        _raiseRemoveItem: function(Z) {
          this.raiseEvent("remove-item", { item: Z });
        }
      }
    );
  }(OpenSeadragon);
})(openseadragon);
var openseadragonExports = openseadragon.exports;
const le = /* @__PURE__ */ getDefaultExportFromCjs$1(openseadragonExports), $6be4966fd9bbc698$var$SWITCH_NAME = "Switch", [$6be4966fd9bbc698$var$createSwitchContext, $6be4966fd9bbc698$export$cf7f5f17f69cbd43] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($6be4966fd9bbc698$var$SWITCH_NAME), [$6be4966fd9bbc698$var$SwitchProvider, $6be4966fd9bbc698$var$useSwitchContext] = $6be4966fd9bbc698$var$createSwitchContext($6be4966fd9bbc698$var$SWITCH_NAME), $6be4966fd9bbc698$export$b5d5cf8927ab7262 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSwitch: ee, name: ae, checked: ve, defaultChecked: ye, required: be, disabled: Ye, value: Qe = "on", onCheckedChange: Je, ...nt } = ie, [st, ot] = reactExports.useState(null), lt = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    Z,
    (Kr) => ot(Kr)
  ), ft = reactExports.useRef(!1), gt = st ? !!st.closest("form") : !0, [ct = !1, _r] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: ve,
    defaultProp: ye,
    onChange: Je
  });
  return /* @__PURE__ */ reactExports.createElement($6be4966fd9bbc698$var$SwitchProvider, {
    scope: ee,
    checked: ct,
    disabled: Ye
  }, /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button",
    role: "switch",
    "aria-checked": ct,
    "aria-required": be,
    "data-state": $6be4966fd9bbc698$var$getState(ct),
    "data-disabled": Ye ? "" : void 0,
    disabled: Ye,
    value: Qe
  }, nt, {
    ref: lt,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(ie.onClick, (Kr) => {
      _r(
        (Xr) => !Xr
      ), gt && (ft.current = Kr.isPropagationStopped(), ft.current || Kr.stopPropagation());
    })
  })), gt && /* @__PURE__ */ reactExports.createElement($6be4966fd9bbc698$var$BubbleInput, {
    control: st,
    bubbles: !ft.current,
    name: ae,
    value: Qe,
    checked: ct,
    required: be,
    disabled: Ye,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), $6be4966fd9bbc698$var$THUMB_NAME = "SwitchThumb", $6be4966fd9bbc698$export$4d07bf653ea69106 = /* @__PURE__ */ reactExports.forwardRef((ie, Z) => {
  const { __scopeSwitch: ee, ...ae } = ie, ve = $6be4966fd9bbc698$var$useSwitchContext($6be4966fd9bbc698$var$THUMB_NAME, ee);
  return /* @__PURE__ */ reactExports.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({
    "data-state": $6be4966fd9bbc698$var$getState(ve.checked),
    "data-disabled": ve.disabled ? "" : void 0
  }, ae, {
    ref: Z
  }));
}), $6be4966fd9bbc698$var$BubbleInput = (ie) => {
  const { control: Z, checked: ee, bubbles: ae = !0, ...ve } = ie, ye = reactExports.useRef(null), be = $010c2913dbd2fe3d$export$5cae361ad82dce8b(ee), Ye = $db6c3485150b8e66$export$1ab7ae714698c4b8(Z);
  return reactExports.useEffect(() => {
    const Qe = ye.current, Je = window.HTMLInputElement.prototype, st = Object.getOwnPropertyDescriptor(Je, "checked").set;
    if (be !== ee && st) {
      const ot = new Event("click", {
        bubbles: ae
      });
      st.call(Qe, ee), Qe.dispatchEvent(ot);
    }
  }, [
    be,
    ee,
    ae
  ]), /* @__PURE__ */ reactExports.createElement("input", _extends$1({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: ee
  }, ve, {
    tabIndex: -1,
    ref: ye,
    style: {
      ...ie.style,
      ...Ye,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function $6be4966fd9bbc698$var$getState(ie) {
  return ie ? "checked" : "unchecked";
}
const $6be4966fd9bbc698$export$be92b6f5f03c0fe9 = $6be4966fd9bbc698$export$b5d5cf8927ab7262, $6be4966fd9bbc698$export$6521433ed15a34db = $6be4966fd9bbc698$export$4d07bf653ea69106, ht = (ie) => {
  const Z = ie.toString().split(":"), ee = Math.ceil(parseInt(Z[0])), ae = Math.ceil(parseInt(Z[1])), ve = xt(Math.ceil(parseInt(Z[2])), 2);
  let ye = `${ee !== 0 && ae < 10 ? (ae + "").padStart(2, "0") : ae}:${ve}`;
  return ee !== 0 && (ye = `${ee}:${ye}`), ye;
}, Ee = (ie) => {
  const Z = new Date(ie * 1e3).toISOString().substr(11, 8);
  return ht(Z);
}, we = (ie, Z) => {
  if (typeof ie != "object" || ie === null)
    return Z;
  for (const ee in Z)
    typeof Z[ee] == "object" && Z[ee] !== null && !Array.isArray(Z[ee]) ? (ie[ee] || (ie[ee] = {}), ie[ee] = we(ie[ee], Z[ee])) : ie[ee] = Z[ee];
  return ie;
}, Ce = (ie, Z) => Object.hasOwn(ie, Z) ? ie[Z].toString() : void 0, xt = (ie, Z) => String(ie).padStart(Z, "0"), j = {
  background: "transparent",
  canvasBackgroundColor: "#6662",
  canvasHeight: "61.8vh",
  ignoreCaptionLabels: [],
  informationPanel: {
    open: !0,
    renderAbout: !0,
    renderSupplementing: !0,
    renderToggle: !0
  },
  openSeadragon: {},
  requestHeaders: { "Content-Type": "application/json" },
  showIIIFBadge: !0,
  showTitle: !0,
  withCredentials: !1
};
var xe;
const _ = {
  activeCanvas: "",
  activeManifest: "",
  collection: {},
  configOptions: j,
  customDisplays: [],
  informationOpen: (xe = j == null ? void 0 : j.informationPanel) == null ? void 0 : xe.open,
  isLoaded: !1,
  vault: new Vault()
}, Se = e$1.createContext(_), ke = e$1.createContext(_);
function vt(ie, Z) {
  switch (Z.type) {
    case "updateActiveCanvas":
      return Z.canvasId || (Z.canvasId = ""), {
        ...ie,
        activeCanvas: Z.canvasId
      };
    case "updateActiveManifest":
      return {
        ...ie,
        activeManifest: Z.manifestId
      };
    case "updateCollection":
      return {
        ...ie,
        collection: Z.collection
      };
    case "updateConfigOptions":
      return {
        ...ie,
        configOptions: we(ie.configOptions, Z.configOptions)
      };
    case "updateInformationOpen":
      return {
        ...ie,
        informationOpen: Z.informationOpen
      };
    case "updateIsLoaded":
      return {
        ...ie,
        isLoaded: Z.isLoaded
      };
    default:
      throw new Error(`Unhandled action type: ${Z.type}`);
  }
}
const bt = ({
  initialState: ie = _,
  children: Z
}) => {
  const [ee, ae] = reactExports.useReducer(vt, ie);
  return /* @__PURE__ */ e$1.createElement(Se.Provider, { value: ee }, /* @__PURE__ */ e$1.createElement(
    ke.Provider,
    {
      value: ae
    },
    Z
  ));
};
function k() {
  const ie = e$1.useContext(Se);
  if (ie === void 0)
    throw new Error("useViewerState must be used within a ViewerProvider");
  return ie;
}
function O() {
  const ie = e$1.useContext(ke);
  if (ie === void 0)
    throw new Error("useViewerDispatch must be used within a ViewerProvider");
  return ie;
}
const Ie = (ie, Z, ee, ae) => {
  var ve, ye;
  const be = {
    canvas: void 0,
    accompanyingCanvas: void 0,
    annotationPage: void 0,
    annotations: []
  }, Ye = (Qe) => {
    if (Qe) {
      if (!Qe.body || !Qe.motivation) {
        console.error(
          "Invalid annotation after Hyperion parsing: missing either 'body' or 'motivation'",
          Qe
        );
        return;
      }
      let Je = Qe.body;
      Array.isArray(Je) && (Je = Je[0]);
      const nt = ie.get(Je.id);
      if (!nt)
        return;
      switch (ee) {
        case "painting":
          return Qe.target === Z.id && Qe.motivation && Qe.motivation[0] === "painting" && ae.includes(nt.type) && (Qe.body = nt), !!Qe;
        case "supplementing":
          return;
        default:
          throw new Error("Invalid annotation motivation.");
      }
    }
  };
  if (be.canvas = ie.get(Z), be.canvas && (be.annotationPage = ie.get(be.canvas.items[0]), be.accompanyingCanvas = (ve = be.canvas) != null && ve.accompanyingCanvas ? ie.get((ye = be.canvas) == null ? void 0 : ye.accompanyingCanvas) : void 0), be.annotationPage) {
    const Qe = ie.get(be.annotationPage.items).map((nt) => ({
      body: ie.get(nt.body[0].id),
      motivation: nt.motivation,
      type: "Annotation"
    })), Je = [];
    Qe.forEach((nt) => {
      nt.body.type === "Choice" ? nt.body.items.forEach(
        (st) => Je.push({
          ...nt,
          id: st.id,
          body: ie.get(st.id)
        })
      ) : Je.push(nt);
    }), be.annotations = Je.filter(Ye);
  }
  return be;
}, D = (ie, Z = "en") => {
  if (!ie)
    return "";
  if (!ie[Z]) {
    const ee = Object.getOwnPropertyNames(ie);
    if (ee.length > 0)
      return ie[ee[0]];
  }
  return ie[Z];
}, N = (ie, Z) => {
  const ee = Ie(
    ie,
    { id: Z, type: "Canvas" },
    "painting",
    ["Image", "Sound", "Video"]
  );
  if (ee.annotations.length !== 0 && ee.annotations && ee.annotations)
    return ee.annotations.map(
      (ae) => ae == null ? void 0 : ae.body
    );
}, yt = (ie, Z, ee) => {
  const ae = ie.get({
    id: Z,
    type: "Canvas"
  });
  if (!(ae != null && ae.annotations) || !ae.annotations[0])
    return [];
  const ve = ie.get(ae.annotations[0]), ye = ie.get(ve.items);
  return Array.isArray(ye) ? ye.filter((be) => {
    var Ye;
    if (be.body && (Ye = be.motivation) != null && Ye.includes("supplementing")) {
      let Qe = be.body;
      Array.isArray(Qe) && (Qe = Qe[0]);
      const Je = ie.get(Qe.id);
      if (Je.format === ee)
        return be.body = Je, be;
    }
  }).map((be) => be.body) : [];
}, Et = (ie, Z, ee, ae) => {
  const ve = [];
  if (Z.canvas && Z.canvas.thumbnail.length > 0) {
    const ye = ie.get(
      Z.canvas.thumbnail[0]
    );
    ve.push(ye);
  }
  if (Z.annotations[0]) {
    if (Z.annotations[0].thumbnail && Z.annotations[0].thumbnail.length > 0) {
      const be = ie.get(
        Z.annotations[0].thumbnail[0]
      );
      ve.push(be);
    }
    if (!Z.annotations[0].body)
      return;
    const ye = Z.annotations[0].body;
    ye.type === "Image" && ve.push(ye);
  }
  return ve.length === 0 ? void 0 : {
    id: ve[0].id,
    format: ve[0].format,
    type: ve[0].type,
    width: ee,
    height: ae
  };
}, X = 209, wt = {
  colors: {
    /*
     * Black and dark grays in a light theme.
     * Must contrast to 4.5 or greater with `secondary`.
     */
    primary: "#1a1d1e",
    primaryMuted: "#26292b",
    primaryAlt: "#151718",
    /*
     * Key brand color(s).
     * Must contrast to 4.5 or greater with `secondary`.
     */
    accent: `hsl(${X} 100% 38.2%)`,
    accentMuted: `hsl(${X} 80% 61.8%)`,
    accentAlt: `hsl(${X} 80% 30%)`,
    /*
     * White and light grays in a light theme.
     * Must contrast to 4.5 or greater with `primary` and  `accent`.
     */
    secondary: "#FFFFFF",
    secondaryMuted: "#e6e8eb",
    secondaryAlt: "#c1c8cd"
  },
  fontSizes: {
    1: "12px",
    2: "13px",
    3: "15px",
    4: "17px",
    5: "19px",
    6: "21px",
    7: "27px",
    8: "35px",
    9: "59px"
  },
  lineHeights: {
    1: "12px",
    2: "13px",
    3: "15px",
    4: "17px",
    5: "19px",
    6: "21px",
    7: "27px",
    8: "35px",
    9: "59px"
  },
  sizes: {
    1: "5px",
    2: "10px",
    3: "15px",
    4: "20px",
    5: "25px",
    6: "35px",
    7: "45px",
    8: "65px",
    9: "80px"
  },
  space: {
    1: "5px",
    2: "10px",
    3: "15px",
    4: "20px",
    5: "25px",
    6: "35px",
    7: "45px",
    8: "65px",
    9: "80px"
  },
  radii: {
    1: "4px",
    2: "6px",
    3: "8px",
    4: "12px",
    round: "50%",
    pill: "9999px"
  },
  transitions: {
    all: "all 300ms cubic-bezier(0.16, 1, 0.3, 1)"
  },
  zIndices: {
    1: "100",
    2: "200",
    3: "300",
    4: "400",
    max: "999"
  }
}, te = {
  xxs: "(max-width: 349px)",
  xs: "(max-width: 575px)",
  sm: "(max-width: 767px)",
  md: "(max-width: 991px)",
  lg: "(max-width: 90rem)",
  xl: "(min-width: calc(90rem + 1px))"
}, { styled: m, css: ro, keyframes: ne, createTheme: oo } = q({
  theme: wt,
  media: te
}), Ct = m("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
}), St = m("p", {
  fontWeight: "bold",
  fontSize: "x-large"
}), kt = m("span", {
  fontSize: "medium"
}), It = ({ error: ie }) => {
  const { message: Z } = ie;
  return /* @__PURE__ */ e$1.createElement(Ct, { role: "alert" }, /* @__PURE__ */ e$1.createElement(St, { "data-testid": "headline" }, "Something went wrong"), Z && /* @__PURE__ */ e$1.createElement(kt, null, `Error message: ${Z}`, " "));
}, $e = m("div", {
  position: "relative",
  zIndex: "0"
}), Ae = m("div", {
  display: "flex",
  flexDirection: "row",
  overflow: "hidden",
  "@sm": {
    flexDirection: "column"
  }
}), Te = m("div", {
  display: "flex",
  flexDirection: "column",
  flexGrow: "1",
  flexShrink: "1",
  width: "61.8%",
  "@sm": {
    width: "100%"
  }
}), Me = m($409067139f391064$export$41fb9f06171c75f4, {
  display: "none",
  border: "none",
  padding: "0",
  transition: "$all",
  opacity: "1",
  background: "#6663",
  margin: "1rem 0",
  borderRadius: "6px",
  "&[data-information-panel='false']": {
    opacity: "0",
    marginTop: "-59px"
  },
  "@sm": {
    display: "flex",
    "> span": {
      display: "flex",
      flexGrow: "1",
      fontSize: "0.8333em",
      justifyContent: "center",
      padding: "0.5rem",
      fontFamily: "inherit"
    }
  }
}), Re = m($409067139f391064$export$7c6e2c02157bb7d2, {
  width: "100%",
  display: "flex"
}), $t = m("aside", {
  display: "flex",
  flexGrow: "1",
  flexShrink: "0",
  width: "38.2%",
  maxHeight: "100%",
  "@sm": {
    width: "100%"
  }
}), At = m("div", {
  display: "flex",
  flexDirection: "column",
  fontSmooth: "auto",
  webkitFontSmoothing: "antialiased",
  "> div": {
    display: "flex",
    flexDirection: "column",
    flexGrow: "1",
    justifyContent: "flex-start",
    "@sm": {
      [`& ${Ae}`]: {
        flexGrow: "1"
      },
      [`& ${Te}`]: {
        flexGrow: "0"
      }
    }
  },
  "@sm": {
    padding: "0"
  },
  "&[data-information-panel-open='true']": {
    "@sm": {
      position: "fixed",
      height: "100%",
      width: "100%",
      top: "0",
      left: "0",
      zIndex: "2500000000",
      [`& ${$e}`]: {
        display: "none"
      },
      [`& ${Me}`]: {
        margin: "1rem"
      },
      [`& ${Re}`]: {
        height: "100%"
      }
    }
  }
}), Tt = m($69cb30bb0017df05$export$be92b6f5f03c0fe9, {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  flexGrow: "1",
  flexShrink: "0",
  position: "relative",
  zIndex: "1",
  maskImage: "linear-gradient(180deg, rgba(0, 0, 0, 1) calc(100% - 2rem), transparent 100%)",
  "@sm": {
    marginTop: "0.5rem",
    boxShadow: "none"
  }
}), Mt = m($69cb30bb0017df05$export$54c2e3dc7acea9f5, {
  display: "flex",
  flexGrow: "0",
  margin: "0 1.618rem",
  borderBottom: "4px solid #6663",
  "@sm": {
    margin: "0 1rem"
  }
}), se = m($69cb30bb0017df05$export$41fb9f06171c75f4, {
  display: "flex",
  position: "relative",
  padding: "0.5rem 1rem",
  background: "none",
  backgroundColor: "transparent",
  fontFamily: "inherit",
  border: "none",
  opacity: "0.7",
  fontSize: "1rem",
  marginRight: "1rem",
  lineHeight: "1rem",
  whiteSpace: "nowrap",
  cursor: "pointer",
  fontWeight: 400,
  transition: "$all",
  "&::after": {
    width: "0",
    height: "4px",
    content: "",
    position: "absolute",
    bottom: "-4px",
    left: "0",
    transition: "$all"
  },
  "&[data-state='active']": {
    opacity: "1",
    fontWeight: 700,
    "&::after": {
      width: "100%",
      backgroundColor: "$accent"
    }
  }
}), ce = m($69cb30bb0017df05$export$7c6e2c02157bb7d2, {
  display: "flex",
  flexGrow: "1",
  flexShrink: "0",
  position: "absolute",
  top: "0",
  left: "0",
  "&[data-state='active']": {
    width: "100%",
    height: "calc(100% - 2rem)",
    padding: "1.618rem 0"
  }
}), Rt = m("div", {
  position: "relative",
  height: "100%",
  width: "100%",
  overflowY: "scroll"
}), zt = m("div", {
  padding: " 0 1.618rem 2rem",
  display: "flex",
  flexDirection: "column",
  overflow: "scroll",
  position: "absolute",
  fontWeight: "400",
  fontSize: "1rem",
  zIndex: "0",
  img: {
    maxWidth: "100px",
    maxHeight: "100px",
    objectFit: "contain",
    color: "transparent",
    margin: "0 0 1rem",
    borderRadius: "3px",
    backgroundColor: "$secondaryMuted"
  },
  video: {
    display: "none"
  },
  "a, a:visited": {
    color: "$accent"
  },
  p: {
    fontSize: "1rem",
    lineHeight: "1.45em",
    margin: "0"
  },
  dl: {
    margin: "0",
    dt: {
      fontWeight: "700",
      margin: "1rem 0 0.25rem"
    },
    dd: {
      margin: "0"
    }
  },
  ".manifest-property-title": {
    fontWeight: "700",
    margin: "1rem 0 0.25rem"
  },
  "ul, ol": {
    padding: "0",
    margin: "0",
    li: {
      fontSize: "1rem",
      lineHeight: "1.45em",
      listStyle: "none",
      margin: "0.25rem 0 0.25rem"
    }
  }
}), Lt = m("div", {
  position: "relative",
  width: "100%",
  height: "100%",
  zIndex: "0"
}), ze = (ie, Z = "none") => {
  if (!ie)
    return null;
  if (typeof ie == "string")
    return [ie];
  if (!ie[Z]) {
    const ee = Object.getOwnPropertyNames(ie);
    if (ee.length > 0)
      return ie[ee[0]];
  }
  return !ie[Z] || !Array.isArray(ie[Z]) ? null : ie[Z];
}, R = (ie, Z = "none", ee = ", ") => {
  const ae = ze(ie, Z);
  return Array.isArray(ae) ? ae.join(`${ee}`) : ae;
};
function Ft(ie) {
  return { __html: Pt(ie) };
}
function T(ie, Z) {
  const ee = Object.keys(ie).filter(
    (ve) => Z.includes(ve) ? null : ve
  ), ae = new Object();
  return ee.forEach((ve) => {
    ae[ve] = ie[ve];
  }), ae;
}
function Pt(ie) {
  return at(ie, {
    allowedAttributes: {
      a: ["href"],
      img: ["alt", "src", "height", "width"]
    },
    allowedSchemes: ["http", "https", "mailto"],
    allowedTags: [
      "a",
      "b",
      "br",
      "i",
      "img",
      "p",
      "small",
      "span",
      "sub",
      "sup"
    ]
  });
}
const Vt = m("span", {}), L = (ie) => {
  const { as: Z, label: ee } = ie, ae = T(ie, ["as", "label"]);
  return /* @__PURE__ */ e$1.createElement(Vt, { as: Z, ...ae }, R(ee, ae.lang));
}, Bt = (ie, Z = "200,", ee = "full") => {
  Array.isArray(ie) && (ie = ie[0]);
  const { id: ae, service: ve } = ie;
  let ye;
  if (!ve)
    return ae;
  if (Array.isArray(ie.service) && ie.service.length > 0 && (ye = ve[0]), ye) {
    if (ye["@id"])
      return `${ye["@id"]}/${ee}/${Z}/0/default.jpg`;
    if (ye.id)
      return `${ye.id}/${ee}/${Z}/0/default.jpg`;
  }
}, de = m("img", { objectFit: "cover" }), Ht = (ie) => {
  const Z = reactExports.useRef(null), { contentResource: ee, altAsLabel: ae, region: ve = "full" } = ie;
  let ye;
  ae && (ye = R(ae));
  const be = T(ie, ["contentResource", "altAsLabel"]), { type: Ye, id: Qe, width: Je = 200, height: nt = 200, duration: st } = ee;
  reactExports.useEffect(() => {
    if (!Qe && !Z.current || ["Image"].includes(Ye) || !Qe.includes("m3u8"))
      return;
    const ft = new Hls();
    return Z.current && (ft.attachMedia(Z.current), ft.on(Hls.Events.MEDIA_ATTACHED, function() {
      ft.loadSource(Qe);
    })), ft.on(Hls.Events.ERROR, function(gt, ct) {
      if (ct.fatal)
        switch (ct.type) {
          case Hls.ErrorTypes.NETWORK_ERROR:
            console.error(
              `fatal ${gt} network error encountered, try to recover`
            ), ft.startLoad();
            break;
          case Hls.ErrorTypes.MEDIA_ERROR:
            console.error(
              `fatal ${gt} media error encountered, try to recover`
            ), ft.recoverMediaError();
            break;
          default:
            ft.destroy();
            break;
        }
    }), () => {
      ft && (ft.detachMedia(), ft.destroy());
    };
  }, [Qe, Ye]);
  const ot = reactExports.useCallback(() => {
    if (!Z.current)
      return;
    let ft = 0, gt = 30;
    if (st && (gt = st), !Qe.split("#t=") && st && (ft = st * 0.1), Qe.split("#t=").pop()) {
      const _r = Qe.split("#t=").pop();
      _r && (ft = parseInt(_r.split(",")[0]));
    }
    const ct = Z.current;
    ct.autoplay = !0, ct.currentTime = ft, setTimeout(() => ot(), gt * 1e3);
  }, [st, Qe]);
  reactExports.useEffect(() => ot(), [ot]);
  const lt = Bt(
    ee,
    `${Je},${nt}`,
    ve
  );
  switch (Ye) {
    case "Image":
      return /* @__PURE__ */ e$1.createElement(
        de,
        {
          as: "img",
          alt: ye,
          css: { width: Je, height: nt },
          key: Qe,
          src: lt,
          ...be
        }
      );
    case "Video":
      return /* @__PURE__ */ e$1.createElement(
        de,
        {
          as: "video",
          css: { width: Je, height: nt },
          disablePictureInPicture: !0,
          key: Qe,
          loop: !0,
          muted: !0,
          onPause: ot,
          ref: Z,
          src: Qe
        }
      );
    default:
      return console.warn(
        `Resource type: ${Ye} is not valid or not yet supported in Primitives.`
      ), /* @__PURE__ */ e$1.createElement(e$1.Fragment, null);
  }
}, Ot = m("a", {}), Dt = (ie) => {
  const { children: Z, homepage: ee } = ie, ae = T(ie, ["children", "homepage"]);
  return /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, ee && ee.map((ve) => {
    const ye = R(
      ve.label,
      ae.lang
    );
    return /* @__PURE__ */ e$1.createElement(
      Ot,
      {
        "aria-label": Z ? ye : void 0,
        href: ve.id,
        key: ve.id,
        ...ae
      },
      Z || ye
    );
  }));
}, Wt = {
  delimiter: ", "
}, re = reactExports.createContext(void 0), Le = () => {
  const ie = reactExports.useContext(re);
  if (ie === void 0)
    throw new Error(
      "usePrimitivesContext must be used with a PrimitivesProvider"
    );
  return ie;
}, oe = ({
  children: ie,
  initialState: Z = Wt
}) => {
  const ee = jt(Z, "delimiter");
  return /* @__PURE__ */ e$1.createElement(re.Provider, { value: { delimiter: ee } }, ie);
}, jt = (ie, Z) => Object.hasOwn(ie, Z) ? ie[Z].toString() : void 0, Nt = m("span", {}), me = (ie) => {
  const { as: Z, markup: ee } = ie, { delimiter: ae } = Le();
  if (!ee)
    return /* @__PURE__ */ e$1.createElement(e$1.Fragment, null);
  const ve = T(ie, ["as", "markup"]), ye = Ft(
    R(ee, ve.lang, ae)
  );
  return /* @__PURE__ */ e$1.createElement(Nt, { as: Z, ...ve, dangerouslySetInnerHTML: ye });
}, Fe = (ie) => e$1.useContext(re) ? /* @__PURE__ */ e$1.createElement(me, { ...ie }) : /* @__PURE__ */ e$1.createElement(oe, null, /* @__PURE__ */ e$1.createElement(me, { ...ie })), Gt = ({ as: ie = "dd", lang: Z, value: ee }) => /* @__PURE__ */ e$1.createElement(Fe, { markup: ee, as: ie, lang: Z }), qt = m("span", {}), Ut = ({
  as: ie = "dd",
  customValueContent: Z,
  lang: ee,
  value: ae
}) => {
  var ve;
  const { delimiter: ye } = Le(), be = (ve = ze(ae, ee)) == null ? void 0 : ve.map((Ye) => reactExports.cloneElement(Z, {
    value: Ye
  }));
  return /* @__PURE__ */ e$1.createElement(qt, { as: ie, lang: ee }, be == null ? void 0 : be.map((Ye, Qe) => [
    Qe > 0 && `${ye}`,
    /* @__PURE__ */ e$1.createElement(reactExports.Fragment, { key: Qe }, Ye)
  ]));
}, Pe = (ie) => {
  var Z;
  const { item: ee, lang: ae, customValueContent: ve } = ie, { label: ye, value: be } = ee, Ye = (Z = R(ye)) == null ? void 0 : Z.replace(" ", "-").toLowerCase();
  return /* @__PURE__ */ e$1.createElement("div", { role: "group", "data-label": Ye }, /* @__PURE__ */ e$1.createElement(L, { as: "dt", label: ye, lang: ae }), ve ? /* @__PURE__ */ e$1.createElement(
    Ut,
    {
      as: "dd",
      customValueContent: ve,
      value: be,
      lang: ae
    }
  ) : /* @__PURE__ */ e$1.createElement(Gt, { as: "dd", value: be, lang: ae }));
};
function _t(ie, Z) {
  const ee = Z.filter((ae) => {
    const { matchingLabel: ve } = ae, ye = Object.keys(ae.matchingLabel)[0], be = R(ve, ye);
    if (R(ie, ye) === be)
      return !0;
  }).map((ae) => ae.Content);
  if (Array.isArray(ee))
    return ee[0];
}
const Zt = m("dl", {}), Xt = (ie) => {
  const { as: Z, customValueContent: ee, metadata: ae } = ie;
  if (!Array.isArray(ae))
    return /* @__PURE__ */ e$1.createElement(e$1.Fragment, null);
  const ve = Ce(ie, "customValueDelimiter"), ye = T(ie, [
    "as",
    "customValueContent",
    "customValueDelimiter",
    "metadata"
  ]);
  return /* @__PURE__ */ e$1.createElement(
    oe,
    {
      ...typeof ve == "string" ? { initialState: { delimiter: ve } } : void 0
    },
    ae.length > 0 && /* @__PURE__ */ e$1.createElement(Zt, { as: Z, ...ye }, ae.map((be, Ye) => {
      const Qe = ee ? _t(be.label, ee) : void 0;
      return /* @__PURE__ */ e$1.createElement(
        Pe,
        {
          customValueContent: Qe,
          item: be,
          key: Ye,
          lang: ye == null ? void 0 : ye.lang
        }
      );
    }))
  );
};
m("li", {});
m("ul", {});
const Yt = m("dl", {}), Kt = (ie) => {
  const { as: Z, requiredStatement: ee } = ie;
  if (!ee)
    return /* @__PURE__ */ e$1.createElement(e$1.Fragment, null);
  const ae = Ce(ie, "customValueDelimiter"), ve = T(ie, ["as", "customValueDelimiter", "requiredStatement"]);
  return /* @__PURE__ */ e$1.createElement(
    oe,
    {
      ...typeof ae == "string" ? { initialState: { delimiter: ae } } : void 0
    },
    /* @__PURE__ */ e$1.createElement(Yt, { as: Z, ...ve }, /* @__PURE__ */ e$1.createElement(Pe, { item: ee, lang: ve.lang }))
  );
}, Jt = m("li", {}), Qt = m("ul", {}), en = (ie) => {
  const { as: Z, seeAlso: ee } = ie, ae = T(ie, ["as", "seeAlso"]);
  return /* @__PURE__ */ e$1.createElement(Qt, { as: Z }, ee && ee.map((ve) => {
    const ye = R(
      ve.label,
      ae.lang
    );
    return /* @__PURE__ */ e$1.createElement(Jt, { key: ve.id }, /* @__PURE__ */ e$1.createElement("a", { href: ve.id, ...ae }, ye || ve.id));
  }));
}, tn = (ie) => {
  const { as: Z, summary: ee } = ie, ae = T(ie, ["as", "customValueDelimiter", "summary"]);
  return /* @__PURE__ */ e$1.createElement(Fe, { as: Z, markup: ee, ...ae });
}, Ve = (ie) => {
  const { thumbnail: Z, region: ee } = ie, ae = T(ie, ["thumbnail"]);
  return /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, Z && Z.map((ve) => /* @__PURE__ */ e$1.createElement(
    Ht,
    {
      contentResource: ve,
      key: ve.id,
      region: ee,
      ...ae
    }
  )));
}, nn = ({
  homepage: ie
}) => (ie == null ? void 0 : ie.length) === 0 ? /* @__PURE__ */ e$1.createElement(e$1.Fragment, null) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement("span", { className: "manifest-property-title" }, "Homepage"), /* @__PURE__ */ e$1.createElement(Dt, { homepage: ie })), rn = ({
  id: ie,
  htmlLabel: Z,
  parent: ee = "manifest"
}) => /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement("span", { className: "manifest-property-title" }, Z), /* @__PURE__ */ e$1.createElement("a", { href: ie, target: "_blank", id: `iiif-${ee}-id` }, ie)), on = ({
  metadata: ie,
  parent: Z = "manifest"
}) => ie ? /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement(Xt, { metadata: ie, id: `iiif-${Z}-metadata` })) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null), an = ({
  requiredStatement: ie,
  parent: Z = "manifest"
}) => ie ? /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement(
  Kt,
  {
    requiredStatement: ie,
    id: `iiif-${Z}-required-statement`
  }
)) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null), ln = ({ rights: ie }) => ie ? /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement("span", { className: "manifest-property-title" }, "Rights"), /* @__PURE__ */ e$1.createElement("a", { href: ie, target: "_blank" }, ie)) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null), sn = ({ seeAlso: ie }) => (ie == null ? void 0 : ie.length) === 0 ? /* @__PURE__ */ e$1.createElement(e$1.Fragment, null) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement("span", { className: "manifest-property-title" }, "See Also"), /* @__PURE__ */ e$1.createElement(en, { seeAlso: ie })), cn = ({
  summary: ie,
  parent: Z = "manifest"
}) => ie ? /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement(tn, { summary: ie, as: "p", id: `iiif-${Z}-summary` })) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null), dn = ({
  label: ie,
  thumbnail: Z
}) => (Z == null ? void 0 : Z.length) === 0 ? /* @__PURE__ */ e$1.createElement(e$1.Fragment, null) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement(
  Ve,
  {
    altAsLabel: ie || { none: ["resource"] },
    thumbnail: Z,
    style: { backgroundColor: "#6663", objectFit: "cover" }
  }
)), mn = () => {
  const ie = k(), { activeManifest: Z, vault: ee } = ie, [ae, ve] = reactExports.useState(), [ye, be] = reactExports.useState([]), [Ye, Qe] = reactExports.useState([]), [Je, nt] = reactExports.useState([]);
  return reactExports.useEffect(() => {
    var st, ot, lt;
    const ft = ee.get(Z);
    ve(ft), ((st = ft.homepage) == null ? void 0 : st.length) > 0 && be(ee.get(ft.homepage)), ((ot = ft.seeAlso) == null ? void 0 : ot.length) > 0 && Qe(ee.get(ft.seeAlso)), ((lt = ft.thumbnail) == null ? void 0 : lt.length) > 0 && nt(ee.get(ft.thumbnail));
  }, [Z, ee]), ae ? /* @__PURE__ */ e$1.createElement(Lt, null, /* @__PURE__ */ e$1.createElement(zt, null, /* @__PURE__ */ e$1.createElement(dn, { thumbnail: Je, label: ae.label }), /* @__PURE__ */ e$1.createElement(cn, { summary: ae.summary }), /* @__PURE__ */ e$1.createElement(on, { metadata: ae.metadata }), /* @__PURE__ */ e$1.createElement(an, { requiredStatement: ae.requiredStatement }), /* @__PURE__ */ e$1.createElement(ln, { rights: ae.rights }), /* @__PURE__ */ e$1.createElement(
    nn,
    {
      homepage: ye
    }
  ), /* @__PURE__ */ e$1.createElement(
    sn,
    {
      seeAlso: Ye
    }
  ), /* @__PURE__ */ e$1.createElement(rn, { id: ae.id, htmlLabel: "IIIF Manifest" }))) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null);
}, un = () => {
  function ie(ve) {
    return ve.map((ye) => {
      const be = ye.identifier || v4();
      return { ...ye, identifier: be };
    });
  }
  function Z(ve) {
    var ye;
    const be = [], Ye = [], Qe = ie(ve);
    for (const Je of Qe) {
      for (; Ye.length > 0 && Ye[Ye.length - 1].end <= Je.start; )
        Ye.pop();
      Ye.length > 0 ? (Ye[Ye.length - 1].children || (Ye[Ye.length - 1].children = []), (ye = Ye[Ye.length - 1].children) == null || ye.push(Je), Ye.push(Je)) : (be.push(Je), Ye.push(Je));
    }
    return be;
  }
  function ee(ve, ye = []) {
    return ye.some(
      (be) => ve.start >= be.start && ve.end <= be.end
    );
  }
  function ae(ve = []) {
    return ve.sort((ye, be) => ye.start - be.start);
  }
  return {
    addIdentifiersToParsedCues: ie,
    createNestedCues: Z,
    isChild: ee,
    orderCuesByTime: ae
  };
}, ue = ne({
  from: { transform: "rotate(360deg)" },
  to: { transform: "rotate(0deg)" }
}), pn = m($f99a8c78507165f7$export$be92b6f5f03c0fe9, {
  display: "flex",
  flexDirection: "column",
  width: "100%"
}), Be = m($f99a8c78507165f7$export$6d08773d2e66f8f2, {
  position: "relative",
  cursor: "pointer",
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  textAlign: "left",
  margin: "0",
  padding: "0.5rem 1.618rem",
  fontFamily: "inherit",
  lineHeight: "1.25em",
  fontSize: "1rem",
  color: "inherit",
  border: "none",
  background: "none",
  "@sm": {
    padding: "0.5rem 1rem",
    fontSize: "0.8333rem"
  },
  "&::before": {
    content: "",
    width: "12px",
    height: "12px",
    borderRadius: "12px",
    position: "absolute",
    backgroundColor: "$primaryMuted",
    opacity: "0",
    left: "8px",
    marginTop: "3px",
    boxSizing: "content-box",
    "@sm": {
      content: "unset"
    }
  },
  "&::after": {
    content: "",
    width: "4px",
    height: "6px",
    position: "absolute",
    backgroundColor: "$secondary",
    opacity: "0",
    clipPath: "polygon(100% 50%, 0 100%, 0 0)",
    left: "13px",
    marginTop: "6px",
    boxSizing: "content-box",
    "@sm": {
      content: "unset"
    }
  },
  strong: {
    marginLeft: "1rem"
  },
  "&:hover": {
    color: "$accent",
    "&::before": {
      backgroundColor: "$accent",
      opacity: "1"
    },
    "&::after": {
      content: "",
      width: "4px",
      height: "6px",
      position: "absolute",
      backgroundColor: "$secondary",
      clipPath: "polygon(100% 50%, 0 100%, 0 0)",
      opacity: "1"
    }
  },
  "&[aria-checked='true']": {
    backgroundColor: "#6663",
    "&::before": {
      content: "",
      width: "6px",
      height: "6px",
      position: "absolute",
      backgroundColor: "transparent",
      border: "3px solid $accentMuted",
      borderRadius: "12px",
      left: "8px",
      marginTop: "4px",
      opacity: "1",
      animation: "1s linear infinite",
      animationName: ue,
      boxSizing: "content-box",
      "@sm": {
        content: "unset"
      }
    },
    "&::after": {
      content: "",
      width: "6px",
      height: "6px",
      position: "absolute",
      backgroundColor: "transparent",
      border: "3px solid $accent",
      clipPath: "polygon(100% 0, 100% 100%, 0 0)",
      borderRadius: "12px",
      left: "8px",
      marginTop: "4px",
      opacity: "1",
      animation: "1.5s linear infinite",
      animationName: ue,
      boxSizing: "content-box",
      "@sm": {
        content: "unset"
      }
    }
  }
}), fn = ({ label: ie, start: Z, end: ee }) => {
  const [ae, ve] = reactExports.useState(!1), ye = document.getElementById(
    "clover-iiif-video"
  );
  reactExports.useEffect(() => (ye == null || ye.addEventListener("timeupdate", () => {
    const { currentTime: Ye } = ye;
    ve(Z <= Ye && Ye < ee);
  }), () => document.removeEventListener("timeupdate", () => {
  })), [ee, Z, ye]);
  const be = () => {
    ye && (ye.pause(), ye.currentTime = Z, ye.play());
  };
  return /* @__PURE__ */ e$1.createElement(
    Be,
    {
      "aria-checked": ae,
      "data-testid": "information-panel-cue",
      onClick: be,
      value: ie
    },
    ie,
    /* @__PURE__ */ e$1.createElement("strong", null, Ee(Z))
  );
}, gn = m("ul", {
  listStyle: "none",
  paddingLeft: "1rem",
  position: "relative",
  "&&:first-child": {
    paddingLeft: "0"
  },
  "& li ul": {
    [`& ${Be}`]: {
      backgroundColor: "unset",
      "&::before": {
        content: "none"
      },
      "&::after": {
        content: "none"
      }
    }
  },
  "&:first-child": {
    margin: "0 0 1.618rem"
  }
}), He = ({ items: ie }) => /* @__PURE__ */ e$1.createElement(gn, null, ie.map((Z) => {
  const { text: ee, start: ae, end: ve, children: ye, identifier: be } = Z;
  return /* @__PURE__ */ e$1.createElement("li", { key: be }, /* @__PURE__ */ e$1.createElement(fn, { label: ee, start: ae, end: ve }), ye && /* @__PURE__ */ e$1.createElement(He, { items: ye }));
})), hn = ({ resource: ie }) => {
  const [Z, ee] = e$1.useState([]), { id: ae, label: ve } = ie, { createNestedCues: ye, orderCuesByTime: be } = un();
  return reactExports.useEffect(() => {
    ae && fetch(ae, {
      headers: {
        "Content-Type": "text/plain",
        Accept: "application/json"
      }
    }).then((Ye) => Ye.text()).then((Ye) => {
      const Qe = nodeWebvtt.parse(Ye).cues, Je = be(Qe), nt = ye(Je);
      ee(nt);
    }).catch((Ye) => console.error(ae, Ye.toString()));
  }, [ae]), /* @__PURE__ */ e$1.createElement(
    pn,
    {
      "aria-label": `navigate ${D(ve, "en")}`
    },
    /* @__PURE__ */ e$1.createElement(He, { items: Z })
  );
}, xn = ({
  activeCanvas: ie,
  resources: Z
}) => {
  var ee;
  const ae = k(), { configOptions: ve } = ae, { informationPanel: ye } = ve, [be, Ye] = reactExports.useState(), Qe = (ye == null ? void 0 : ye.renderAbout) || ((ee = ve == null ? void 0 : ve.informationPanel) == null ? void 0 : ee.renderAbout), Je = ye == null ? void 0 : ye.renderSupplementing;
  reactExports.useEffect(() => {
    Qe ? Ye("manifest-about") : Z && (Z == null ? void 0 : Z.length) > 0 && !Qe && Ye(Z[0].id);
  }, [ie, Qe, Z]);
  const nt = (st) => {
    Ye(st);
  };
  return Z ? /* @__PURE__ */ e$1.createElement(
    Tt,
    {
      "data-testid": "information-panel",
      defaultValue: be,
      onValueChange: nt,
      orientation: "horizontal",
      value: be,
      className: "clover-viewer-information-panel"
    },
    /* @__PURE__ */ e$1.createElement(Mt, { "aria-label": "select chapter", "data-testid": "information-panel-list" }, Qe && /* @__PURE__ */ e$1.createElement(se, { value: "manifest-about" }, "About"), Je && Z && Z.map(({ id: st, label: ot }) => /* @__PURE__ */ e$1.createElement(se, { key: st, value: st }, /* @__PURE__ */ e$1.createElement(L, { label: ot })))),
    /* @__PURE__ */ e$1.createElement(Rt, null, Qe && /* @__PURE__ */ e$1.createElement(ce, { value: "manifest-about" }, /* @__PURE__ */ e$1.createElement(mn, null)), Je && Z && Z.map((st) => /* @__PURE__ */ e$1.createElement(ce, { key: st.id, value: st.id }, /* @__PURE__ */ e$1.createElement(hn, { resource: st }))))
  ) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null);
}, Oe = m("div", {
  position: "absolute",
  right: "1rem",
  top: "1rem",
  display: "flex",
  justifyContent: "flex-end",
  zIndex: "1"
}), vn = m("input", {
  flexGrow: "1",
  border: "none",
  backgroundColor: "$secondaryMuted",
  color: "$primary",
  marginRight: "1rem",
  height: "2rem",
  padding: "0 1rem",
  borderRadius: "2rem",
  fontFamily: "inherit",
  fontSize: "1rem",
  lineHeight: "1rem",
  boxShadow: "inset 1px 1px 2px #0003",
  "&::placeholder": {
    color: "$primaryMuted"
  }
}), Y = m("button", {
  display: "flex",
  background: "none",
  border: "none",
  width: "2rem !important",
  height: "2rem !important",
  padding: "0",
  margin: "0",
  fontWeight: "700",
  borderRadius: "2rem",
  backgroundColor: "$accent",
  color: "$secondary",
  cursor: "pointer",
  boxSizing: "content-box !important",
  transition: "$all",
  svg: {
    height: "60%",
    width: "60%",
    padding: "20%",
    fill: "$secondary",
    stroke: "$secondary",
    opacity: "1",
    filter: "drop-shadow(5px 5px 5px #000D)",
    boxSizing: "inherit",
    transition: "$all"
  },
  "&:disabled": {
    backgroundColor: "transparent",
    boxShadow: "none",
    svg: { opacity: "0.25" }
  }
}), bn = m("div", {
  display: "flex",
  marginRight: "0.618rem",
  backgroundColor: "$accentAlt",
  borderRadius: "2rem",
  boxShadow: "5px 5px 5px #0003",
  color: "$secondary",
  alignItems: "center",
  "> span": {
    display: "flex",
    margin: "0 0.5rem",
    fontSize: "0.7222rem"
  }
}), yn = m("div", {
  display: "flex",
  position: "relative",
  zIndex: "1",
  width: "100%",
  padding: "0",
  transition: "$all",
  variants: {
    isToggle: {
      true: {
        paddingTop: "2.618rem",
        [`& ${Oe}`]: {
          width: "calc(100% - 2rem)",
          "@sm": {
            width: "calc(100% - 2rem)"
          }
        }
      }
    }
  }
}), En = (ie, Z) => {
  reactExports.useEffect(() => {
    function ee(ae) {
      ae.key === ie && Z();
    }
    return window.addEventListener("keyup", ee), () => window.removeEventListener("keyup", ee);
  }, []);
}, wn = () => /* @__PURE__ */ e$1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, /* @__PURE__ */ e$1.createElement("title", null, "Arrow Back"), /* @__PURE__ */ e$1.createElement(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "45",
    d: "M244 400L100 256l144-144M120 256h292"
  }
)), Cn = () => /* @__PURE__ */ e$1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, /* @__PURE__ */ e$1.createElement("title", null, "Arrow Forward"), /* @__PURE__ */ e$1.createElement(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "45",
    d: "M268 112l144 144-144 144M392 256H100"
  }
)), Sn = () => /* @__PURE__ */ e$1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, /* @__PURE__ */ e$1.createElement("title", null, "Close"), /* @__PURE__ */ e$1.createElement("path", { d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" })), kn = () => /* @__PURE__ */ e$1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, /* @__PURE__ */ e$1.createElement("title", null, "Search"), /* @__PURE__ */ e$1.createElement("path", { d: "M456.69 421.39L362.6 327.3a173.81 173.81 0 0034.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 00327.3 362.6l94.09 94.09a25 25 0 0035.3-35.3zM97.92 222.72a124.8 124.8 0 11124.8 124.8 124.95 124.95 0 01-124.8-124.8z" })), In = ({
  handleCanvasToggle: ie,
  handleFilter: Z,
  activeIndex: ee,
  canvasLength: ae
}) => {
  const [ve, ye] = reactExports.useState(!1), [be, Ye] = reactExports.useState(!1), [Qe, Je] = reactExports.useState(!1);
  reactExports.useEffect(() => {
    Je(ee === 0), ee === ae - 1 ? Ye(!0) : Ye(!1);
  }, [ee, ae]), En("Escape", () => {
    ye(!1), Z("");
  });
  const nt = () => {
    ye((ot) => !ot), Z("");
  }, st = (ot) => Z(ot.target.value);
  return /* @__PURE__ */ e$1.createElement(yn, { isToggle: ve }, /* @__PURE__ */ e$1.createElement(Oe, null, ve && /* @__PURE__ */ e$1.createElement(vn, { autoFocus: !0, onChange: st, placeholder: "Search" }), !ve && /* @__PURE__ */ e$1.createElement(bn, null, /* @__PURE__ */ e$1.createElement(
    Y,
    {
      onClick: () => ie(-1),
      disabled: Qe,
      type: "button"
    },
    /* @__PURE__ */ e$1.createElement(wn, null)
  ), /* @__PURE__ */ e$1.createElement("span", null, ee + 1, " of ", ae), /* @__PURE__ */ e$1.createElement(
    Y,
    {
      onClick: () => ie(1),
      disabled: be,
      type: "button"
    },
    /* @__PURE__ */ e$1.createElement(Cn, null)
  )), /* @__PURE__ */ e$1.createElement(Y, { onClick: nt, type: "button" }, ve ? /* @__PURE__ */ e$1.createElement(Sn, null) : /* @__PURE__ */ e$1.createElement(kn, null))));
}, $n = m($f99a8c78507165f7$export$be92b6f5f03c0fe9, {
  display: "flex",
  flexDirection: "row",
  flexGrow: "1",
  padding: "1.618rem",
  overflowX: "scroll",
  position: "relative",
  zIndex: "0"
}), An = () => /* @__PURE__ */ e$1.createElement(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "32",
    d: "M256 112v288M400 256H112"
  }
), Tn = () => /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement("path", { d: "M232 416a23.88 23.88 0 01-14.2-4.68 8.27 8.27 0 01-.66-.51L125.76 336H56a24 24 0 01-24-24V200a24 24 0 0124-24h69.75l91.37-74.81a8.27 8.27 0 01.66-.51A24 24 0 01256 120v272a24 24 0 01-24 24zm-106.18-80zm-.27-159.86zM320 336a16 16 0 01-14.29-23.19c9.49-18.87 14.3-38 14.3-56.81 0-19.38-4.66-37.94-14.25-56.73a16 16 0 0128.5-14.54C346.19 208.12 352 231.44 352 256c0 23.86-6 47.81-17.7 71.19A16 16 0 01320 336z" }), /* @__PURE__ */ e$1.createElement("path", { d: "M368 384a16 16 0 01-13.86-24C373.05 327.09 384 299.51 384 256c0-44.17-10.93-71.56-29.82-103.94a16 16 0 0127.64-16.12C402.92 172.11 416 204.81 416 256c0 50.43-13.06 83.29-34.13 120a16 16 0 01-13.87 8z" }), /* @__PURE__ */ e$1.createElement("path", { d: "M416 432a16 16 0 01-13.39-24.74C429.85 365.47 448 323.76 448 256c0-66.5-18.18-108.62-45.49-151.39a16 16 0 1127-17.22C459.81 134.89 480 181.74 480 256c0 64.75-14.66 113.63-50.6 168.74A16 16 0 01416 432z" })), Mn = () => /* @__PURE__ */ e$1.createElement("path", { d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" }), Rn = () => /* @__PURE__ */ e$1.createElement("path", { d: "M416 64H96a64.07 64.07 0 00-64 64v256a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V128a64.07 64.07 0 00-64-64zm-80 64a48 48 0 11-48 48 48.05 48.05 0 0148-48zM96 416a32 32 0 01-32-32v-67.63l94.84-84.3a48.06 48.06 0 0165.8 1.9l64.95 64.81L172.37 416zm352-32a32 32 0 01-32 32H217.63l121.42-121.42a47.72 47.72 0 0161.64-.16L448 333.84z" }), zn = () => /* @__PURE__ */ e$1.createElement("path", { d: "M464 384.39a32 32 0 01-13-2.77 15.77 15.77 0 01-2.71-1.54l-82.71-58.22A32 32 0 01352 295.7v-79.4a32 32 0 0113.58-26.16l82.71-58.22a15.77 15.77 0 012.71-1.54 32 32 0 0145 29.24v192.76a32 32 0 01-32 32zM268 400H84a68.07 68.07 0 01-68-68V180a68.07 68.07 0 0168-68h184.48A67.6 67.6 0 01336 179.52V332a68.07 68.07 0 01-68 68z" }), De = m("svg", {
  display: "inline-flex",
  variants: {
    isLarge: {
      true: {
        height: "4rem",
        width: "4rem"
      }
    },
    isMedium: {
      true: {
        height: "2rem",
        width: "2rem"
      }
    },
    isSmall: {
      true: {
        height: "1rem",
        width: "1rem"
      }
    }
  }
}), Ln = ({ children: ie }) => /* @__PURE__ */ e$1.createElement("title", null, ie), S = (ie) => /* @__PURE__ */ e$1.createElement(
  De,
  {
    ...ie,
    "data-testid": "icon-svg",
    role: "img",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  },
  ie.children
);
S.Title = Ln;
S.Add = An;
S.Audio = Tn;
S.Close = Mn;
S.Image = Rn;
S.Video = zn;
const Fn = ne({
  "0%": { opacity: 0, transform: "translateY(1rem)" },
  "100%": { opacity: 1, transform: "translateY(0)" }
}), Pn = ne({
  "0%": { opacity: 0, transform: "translateY(1rem)" },
  "100%": { opacity: 1, transform: "translateY(0)" }
}), We = m($cb5cc270b50c6fcd$export$21b07c8f274aebd5, {
  fill: "$secondaryAlt"
}), Vn = m($cb5cc270b50c6fcd$export$f39c2d165cd861fe, {
  position: "absolute",
  right: "0",
  top: "0",
  padding: "0.5rem",
  margin: "0",
  cursor: "pointer",
  border: "none",
  background: "none",
  fill: "inherit",
  "&:hover": {
    opacity: "0.75"
  }
}), Bn = m($cb5cc270b50c6fcd$export$7c6e2c02157bb7d2, {
  border: "none",
  backgroundColor: "white",
  fill: "inhrerit",
  padding: "1rem 2rem 1rem 1rem",
  width: "auto",
  minWidth: "200px",
  maxWidth: "350px",
  borderRadius: "3px",
  boxShadow: "5px 5px 13px #0002",
  /**
   * Animate toggle
   */
  animationDuration: "0.3s",
  animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
  '&[data-side="top"]': { animationName: Pn },
  '&[data-side="bottom"]': { animationName: Fn },
  /**
   *
   */
  '&[data-align="end"]': {
    [`& ${We}`]: {
      margin: "0 0.7rem"
    }
  }
}), Hn = m($cb5cc270b50c6fcd$export$41fb9f06171c75f4, {
  display: "inline-flex",
  padding: "0.5rem 0",
  margin: "0 0.5rem 0 0",
  cursor: "pointer",
  border: "none",
  background: "none",
  "> button, > span": {
    margin: "0"
  }
}), On = m($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, {
  boxSizing: "content-box"
}), Dn = (ie) => /* @__PURE__ */ e$1.createElement(Hn, { ...ie }, ie.children), Wn = (ie) => /* @__PURE__ */ e$1.createElement(Bn, { ...ie }, /* @__PURE__ */ e$1.createElement(We, null), /* @__PURE__ */ e$1.createElement(Vn, null, /* @__PURE__ */ e$1.createElement(S, { isSmall: !0 }, /* @__PURE__ */ e$1.createElement(S.Close, null))), ie.children), W = ({ children: ie }) => /* @__PURE__ */ e$1.createElement(On, null, ie);
W.Trigger = Dn;
W.Content = Wn;
const J = m("div", {
  // Reset
  boxSizing: "border-box",
  // Custom
  display: "inline-flex",
  alignItems: "center",
  borderRadius: "5px",
  padding: "$1",
  marginBottom: "$2",
  marginRight: "$2",
  backgroundColor: "$lightGrey",
  color: "$richBlack50",
  textTransform: "uppercase",
  fontSize: "$2",
  objectFit: "contain",
  lineHeight: "1em !important",
  "&:last-child": {
    marginRight: "0"
  },
  [`${De}`]: {
    position: "absolute",
    left: "$1",
    height: "$3",
    width: "$3"
  },
  variants: {
    isIcon: {
      true: { position: "relative", paddingLeft: "$5" }
    }
  }
}), Q = m("span", {
  display: "flex"
}), jn = m("span", {
  display: "flex",
  width: "1.2111rem",
  height: "0.7222rem"
}), Nn = m("span", {
  display: "inline-flex",
  marginLeft: "5px",
  marginBottom: "-1px"
}), Gn = m($f99a8c78507165f7$export$6d08773d2e66f8f2, {
  display: "flex",
  flexShrink: "0",
  margin: "0 1.618rem 0 0",
  padding: "0",
  cursor: "pointer",
  background: "none",
  border: "none",
  fontFamily: "inherit",
  lineHeight: "1.25em",
  fontSize: "1rem",
  textAlign: "left",
  "&:last-child": {
    marginRight: "1rem"
  },
  figure: {
    margin: "0",
    width: "161.8px",
    "> div": {
      position: "relative",
      display: "flex",
      backgroundColor: "$secondaryAlt",
      width: "inherit",
      height: "100px",
      overflow: "hidden",
      borderRadius: "3px",
      transition: "$all",
      img: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        filter: "blur(0)",
        transform: "scale3d(1, 1, 1)",
        transition: "$all",
        color: "transparent"
      },
      [`& ${Q}`]: {
        position: "absolute",
        right: "0",
        bottom: "0",
        [`& ${J}`]: {
          margin: "0",
          paddingLeft: "0",
          fontSize: "0.7222rem",
          backgroundColor: "#000d",
          color: "$secondary",
          fill: "$secondary",
          borderBottomLeftRadius: "0",
          borderTopRightRadius: "0"
        }
      }
    },
    figcaption: {
      marginTop: "0.5rem",
      fontWeight: "400",
      fontSize: "0.8333rem",
      display: "-webkit-box",
      overflow: "hidden",
      MozBoxOrient: "vertical",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: "5",
      "@sm": {
        fontSize: "0.8333rem"
      }
    }
  },
  "&[aria-checked='true']": {
    figure: {
      "> div": {
        backgroundColor: "$primaryAlt",
        "&::before": {
          position: "absolute",
          zIndex: "1",
          color: "$secondaryMuted",
          content: "Active Item",
          textTransform: "uppercase",
          fontWeight: "700",
          fontSize: "0.6111rem",
          letterSpacing: "0.03rem",
          display: "flex",
          width: "100%",
          height: "100%",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          textShadow: "5px 5px 5px #0003"
        },
        img: {
          opacity: "0.3",
          transform: "scale3d(1.1, 1.1, 1.1)",
          filter: "blur(2px)"
        },
        [`& ${Q}`]: {
          [`& ${J}`]: {
            backgroundColor: "$accent"
          }
        }
      }
    },
    figcaption: {
      fontWeight: "700"
    }
  }
}), qn = ({ type: ie }) => {
  switch (ie) {
    case "Sound":
      return /* @__PURE__ */ e$1.createElement(S.Audio, null);
    case "Image":
      return /* @__PURE__ */ e$1.createElement(S.Image, null);
    case "Video":
      return /* @__PURE__ */ e$1.createElement(S.Video, null);
    default:
      return /* @__PURE__ */ e$1.createElement(S.Image, null);
  }
}, Un = ({
  canvas: ie,
  canvasIndex: Z,
  isActive: ee,
  thumbnail: ae,
  type: ve,
  handleChange: ye
}) => /* @__PURE__ */ e$1.createElement(
  Gn,
  {
    "aria-checked": ee,
    "data-testid": "media-thumbnail",
    "data-canvas": Z,
    onClick: () => ye(ie.id),
    value: ie.id
  },
  /* @__PURE__ */ e$1.createElement("figure", null, /* @__PURE__ */ e$1.createElement("div", null, (ae == null ? void 0 : ae.id) && /* @__PURE__ */ e$1.createElement(
    "img",
    {
      src: ae.id,
      alt: ie != null && ie.label ? D(ie.label) : ""
    }
  ), /* @__PURE__ */ e$1.createElement(Q, null, /* @__PURE__ */ e$1.createElement(J, { isIcon: !0, "data-testid": "thumbnail-tag" }, /* @__PURE__ */ e$1.createElement(jn, null), /* @__PURE__ */ e$1.createElement(S, { "aria-label": ve }, /* @__PURE__ */ e$1.createElement(qn, { type: ve })), ["Video", "Sound"].includes(ve) && /* @__PURE__ */ e$1.createElement(Nn, null, Ee(ie.duration))))), (ie == null ? void 0 : ie.label) && /* @__PURE__ */ e$1.createElement("figcaption", { "data-testid": "fig-caption" }, /* @__PURE__ */ e$1.createElement(L, { label: ie.label })))
), _n = (ie) => ie.body ? ie.body.type : "Image", Zn = ({ items: ie }) => {
  const Z = O(), ee = k(), { activeCanvas: ae, vault: ve } = ee, [ye, be] = reactExports.useState(""), [Ye, Qe] = reactExports.useState([]), [Je, nt] = reactExports.useState(0), st = e$1.useRef(null), ot = "painting", lt = (ct) => {
    ae !== ct && Z({
      type: "updateActiveCanvas",
      canvasId: ct
    });
  };
  reactExports.useEffect(() => {
    if (!Ye.length) {
      const ct = ["Image", "Sound", "Video"], _r = ie.map(
        (Kr) => Ie(ve, Kr, ot, ct)
      ).filter((Kr) => Kr.annotations.length > 0);
      Qe(_r);
    }
  }, [ie, Ye.length, ve]), reactExports.useEffect(() => {
    Ye.forEach((ct, _r) => {
      ct != null && ct.canvas && ct.canvas.id === ae && nt(_r);
    });
  }, [ae, Ye]), reactExports.useEffect(() => {
    const ct = document.querySelector(
      `[data-canvas="${Je}"]`
    );
    if (ct instanceof HTMLElement && st.current) {
      const _r = ct.offsetLeft - st.current.offsetWidth / 2 + ct.offsetWidth / 2;
      st.current.scrollTo({ left: _r, behavior: "smooth" });
    }
  }, [Je]);
  const ft = (ct) => be(ct), gt = (ct) => {
    const _r = Ye[Je + ct];
    _r != null && _r.canvas && lt(_r.canvas.id);
  };
  return /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement(
    In,
    {
      handleFilter: ft,
      handleCanvasToggle: gt,
      activeIndex: Je,
      canvasLength: Ye.length
    }
  ), /* @__PURE__ */ e$1.createElement($n, { "aria-label": "select item", "data-testid": "media", ref: st }, Ye.filter((ct) => {
    var _r;
    if ((_r = ct.canvas) != null && _r.label) {
      const Kr = D(ct.canvas.label);
      if (Array.isArray(Kr))
        return Kr[0].toLowerCase().includes(ye.toLowerCase());
    }
  }).map((ct, _r) => {
    var Kr, Xr;
    return /* @__PURE__ */ e$1.createElement(
      Un,
      {
        canvas: ct.canvas,
        canvasIndex: _r,
        handleChange: lt,
        isActive: ae === ((Kr = ct == null ? void 0 : ct.canvas) == null ? void 0 : Kr.id),
        key: (Xr = ct == null ? void 0 : ct.canvas) == null ? void 0 : Xr.id,
        thumbnail: Et(ve, ct, 200, 200),
        type: _n(ct.annotations[0])
      }
    );
  })));
}, je = m("button", {
  background: "none",
  border: "none",
  cursor: "zoom-in",
  width: "100%",
  height: "100%",
  margin: "0",
  padding: "0",
  transition: "$all",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    color: "transparent",
    transition: "$all"
  },
  variants: {
    isMedia: {
      true: {
        cursor: "pointer"
      }
    }
  }
}), Ne = m("button", {
  display: "flex",
  height: "2rem",
  width: "2rem",
  borderRadius: "2rem",
  padding: "0",
  margin: "0",
  fontFamily: "inherit",
  background: "none",
  border: "none",
  color: "white",
  cursor: "pointer",
  marginLeft: "0.618rem",
  backgroundColor: "$primary",
  filter: "drop-shadow(2px 2px 5px #0003)",
  transition: "$all",
  boxSizing: "content-box !important",
  "&:first-child": {
    marginLeft: "0"
  },
  "@xs": {
    marginBottom: "0.618rem",
    marginLeft: "0",
    "&:last-child": {
      marginBottom: "0"
    }
  },
  svg: {
    height: "60%",
    width: "60%",
    padding: "20%",
    fill: "$secondary",
    stroke: "$secondary",
    filter: "drop-shadow(2px 2px 5px #0003)",
    transition: "$all",
    boxSizing: "inherit"
  },
  "&:hover, &:focus": {
    backgroundColor: "$accent"
  },
  "&#rotateRight": {
    "&:hover, &:focus": {
      svg: {
        rotate: "45deg"
      }
    }
  },
  "&#rotateLeft": {
    transform: "scaleX(-1)",
    "&:hover, &:focus": {
      svg: {
        rotate: "45deg"
      }
    }
  },
  "&#reset": {
    "&:hover, &:focus": {
      svg: {
        rotate: "-15deg"
      }
    }
  }
}), Ge = m(Ne, {
  position: "absolute",
  width: "2rem",
  top: "1rem",
  right: "1rem",
  zIndex: 100,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  transition: "$all",
  borderRadius: "50%",
  backgroundColor: "$accent",
  cursor: "pointer",
  "&:hover, &:focus": {
    backgroundColor: "$accent !important"
  },
  variants: {
    isInteractive: {
      true: {
        "&:hover": {
          opacity: "1"
        }
      },
      false: {}
    },
    isMedia: {
      true: {
        cursor: "pointer !important"
      }
    }
  },
  compoundVariants: [
    {
      isInteractive: !1,
      isMedia: !0,
      css: {
        top: "50%",
        right: "50%",
        width: "4rem",
        height: "4rem",
        transform: "translate(50%,-50%)"
      }
    }
  ]
}), Xn = m("div", {
  position: "relative",
  zIndex: "0",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  "&:hover": {
    [`${Ge}`]: {
      backgroundColor: "$accent"
    },
    [`${je}`]: {
      backgroundColor: "#6662",
      img: {
        filter: "brightness(0.85)"
      }
    }
  }
}), Yn = m("div", {}), Kn = m("svg", {
  height: "19px",
  color: "$accent",
  fill: "$accent",
  stroke: "$accent",
  display: "flex",
  margin: "0.25rem 0.85rem"
}), Jn = m($cc7e05a45900e73f$export$41fb9f06171c75f4, {
  fontSize: "1.25rem",
  fontWeight: "400",
  fontFamily: "inherit",
  alignSelf: "flex-start",
  flexGrow: "1",
  cursor: "pointer",
  transition: "$all",
  border: "1px solid #6663",
  boxShadow: "2px 2px 5px #0001",
  borderRadius: "3px",
  display: "flex",
  alignItems: "center",
  paddingLeft: "0.5rem",
  width: "100%",
  "@sm": {
    fontSize: "1rem"
  }
}), Qn = m($cc7e05a45900e73f$export$7c6e2c02157bb7d2, {
  borderRadius: "3px",
  boxShadow: "3px 3px 8px #0003",
  backgroundColor: "$secondary",
  marginTop: "2.25rem",
  marginLeft: "6px",
  paddingBottom: "0.25rem",
  maxHeight: "calc(61.8vh - 2.5rem) !important",
  borderTopLeftRadius: "0",
  border: "1px solid $secondaryMuted",
  maxWidth: "90vw"
}), er = m($cc7e05a45900e73f$export$6d08773d2e66f8f2, {
  display: "flex",
  alignItems: "center",
  fontFamily: "inherit",
  padding: "0.25rem 0.5rem",
  color: "$primary",
  fontWeight: "400",
  fontSize: "0.8333rem",
  cursor: "pointer",
  backgroundColor: "$secondary",
  width: "calc(100% - 1rem)",
  "> span": {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  '&[data-state="checked"]': {
    fontWeight: "700",
    color: "$primary !important"
  },
  "&:hover": {
    color: "$accent"
  },
  img: {
    width: "31px",
    height: "31px",
    marginRight: "0.5rem",
    borderRadius: "3px"
  }
}), tr = m($cc7e05a45900e73f$export$b04be29aa201d4f5, {
  color: "$primaryMuted",
  fontFamily: "inherit",
  fontSize: "0.85rem",
  padding: "0.5rem 1rem 0.5rem 0.5rem",
  display: "flex",
  alignItems: "center",
  marginBottom: "0.25rem",
  borderRadius: "3px",
  borderTopLeftRadius: "0",
  borderBottomLeftRadius: "0",
  borderBottomRightRadius: "0",
  backgroundColor: "$secondaryMuted"
}), qe = m($cc7e05a45900e73f$export$be92b6f5f03c0fe9, {
  position: "relative",
  zIndex: "5",
  width: "100%"
}), K = ({ direction: ie, title: Z }) => {
  const ee = () => /* @__PURE__ */ e$1.createElement("path", { d: "M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z" }), ae = () => /* @__PURE__ */ e$1.createElement("path", { d: "M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z" });
  return /* @__PURE__ */ e$1.createElement(
    Kn,
    {
      xmlns: "http://www.w3.org/2000/svg",
      focusable: "false",
      viewBox: "0 0 512 512",
      role: "img"
    },
    /* @__PURE__ */ e$1.createElement("title", null, Z),
    ie === "up" && /* @__PURE__ */ e$1.createElement(ee, null),
    ie === "down" && /* @__PURE__ */ e$1.createElement(ae, null)
  );
}, Ue = ({
  children: ie,
  label: Z,
  maxHeight: ee,
  onValueChange: ae,
  value: ve
}) => /* @__PURE__ */ e$1.createElement(qe, { onValueChange: ae, value: ve }, /* @__PURE__ */ e$1.createElement(Jn, { "data-testid": "select-button" }, /* @__PURE__ */ e$1.createElement($cc7e05a45900e73f$export$e288731fd71264f0, { "data-testid": "select-button-value" }), /* @__PURE__ */ e$1.createElement($cc7e05a45900e73f$export$99b400cabb58c515, null, /* @__PURE__ */ e$1.createElement(K, { direction: "down", title: "select" }))), /* @__PURE__ */ e$1.createElement($cc7e05a45900e73f$export$b2af6c9944296213, null, /* @__PURE__ */ e$1.createElement(
  Qn,
  {
    css: { maxHeight: `${ee} !important` },
    "data-testid": "select-content"
  },
  /* @__PURE__ */ e$1.createElement($cc7e05a45900e73f$export$d8117927658af6d7, null, /* @__PURE__ */ e$1.createElement(K, { direction: "up", title: "scroll up for more" })),
  /* @__PURE__ */ e$1.createElement($cc7e05a45900e73f$export$9ed6e7b40248d36d, null, /* @__PURE__ */ e$1.createElement($cc7e05a45900e73f$export$ee25a334c55de1f4, null, Z && /* @__PURE__ */ e$1.createElement(tr, null, /* @__PURE__ */ e$1.createElement(L, { "data-testid": "select-label", label: Z })), ie)),
  /* @__PURE__ */ e$1.createElement($cc7e05a45900e73f$export$ff951e476c12189, null, /* @__PURE__ */ e$1.createElement(K, { direction: "down", title: "scroll down for more" }))
))), _e = (ie) => /* @__PURE__ */ e$1.createElement(er, { ...ie }, ie.thumbnail && /* @__PURE__ */ e$1.createElement(Ve, { thumbnail: ie.thumbnail }), /* @__PURE__ */ e$1.createElement($cc7e05a45900e73f$export$3572fb0fb821ff49, null, /* @__PURE__ */ e$1.createElement(L, { label: ie.label })), /* @__PURE__ */ e$1.createElement($cc7e05a45900e73f$export$6b9198de19accfe6, null)), nr = m("div", {
  position: "absolute !important",
  zIndex: "1",
  top: "1rem",
  left: "1rem",
  width: "161.8px",
  height: "100px",
  backgroundColor: "#000D",
  boxShadow: "5px 5px 5px #0002",
  borderRadius: "3px",
  ".displayregion": {
    border: " 3px solid $accent !important",
    boxShadow: "0 0 3px #0006"
  },
  "@sm": {
    width: "123px",
    height: "76px"
  },
  "@xs": {
    width: "100px",
    height: "61.8px"
  }
}), rr = m("div", {
  position: "relative",
  width: "100%",
  height: "100%",
  zIndex: "0"
}), or = m("div", {
  width: "100%",
  height: "61.8vh",
  maxHeight: "100vh",
  background: "black",
  backgroundSize: "contain",
  color: "white",
  position: "relative",
  zIndex: "1",
  overflow: "hidden"
}), z = ({ id: ie, label: Z, children: ee }) => /* @__PURE__ */ e$1.createElement(Ne, { id: ie, "data-testid": "openseadragon-button" }, /* @__PURE__ */ e$1.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": `${ie}-svg-title`,
    "data-testid": "openseadragon-button-svg",
    focusable: "false",
    viewBox: "0 0 512 512",
    role: "img"
  },
  /* @__PURE__ */ e$1.createElement("title", { id: `${ie}-svg-title` }, Z),
  ee
)), ar = m("div", {
  position: "absolute",
  zIndex: "1",
  top: "1rem",
  display: "flex",
  "@xs": {
    flexDirection: "column",
    zIndex: "2"
  },
  variants: {
    hasPlaceholder: {
      true: {
        right: "3.618rem",
        "@xs": {
          top: "3.618rem",
          right: "1rem"
        }
      },
      false: {
        right: "1rem",
        "@xs": {
          top: "1rem",
          right: "1rem"
        }
      }
    }
  }
}), ir = () => /* @__PURE__ */ e$1.createElement(
  "path",
  {
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: "45",
    d: "M256 112v288M400 256H112"
  }
), lr = () => /* @__PURE__ */ e$1.createElement(
  "path",
  {
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: "45",
    d: "M400 256H112"
  }
), sr = () => /* @__PURE__ */ e$1.createElement(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "32",
    d: "M432 320v112H320M421.8 421.77L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320M90.23 421.8L208 304"
  }
), cr = () => /* @__PURE__ */ e$1.createElement("path", { d: "M448 440a16 16 0 01-12.61-6.15c-22.86-29.27-44.07-51.86-73.32-67C335 352.88 301 345.59 256 344.23V424a16 16 0 01-27 11.57l-176-168a16 16 0 010-23.14l176-168A16 16 0 01256 88v80.36c74.14 3.41 129.38 30.91 164.35 81.87C449.32 292.44 464 350.9 464 424a16 16 0 01-16 16z" }), pe = () => /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement(
  "path",
  {
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: "45",
    d: "M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"
  }
), /* @__PURE__ */ e$1.createElement("path", { d: "M464 97.42V208a16 16 0 01-16 16H337.42c-14.26 0-21.4-17.23-11.32-27.31L436.69 86.1C446.77 76 464 83.16 464 97.42z" })), dr = ({
  hasPlaceholder: ie,
  options: Z
}) => /* @__PURE__ */ e$1.createElement(
  ar,
  {
    "data-testid": "openseadragon-controls",
    hasPlaceholder: ie,
    id: "openseadragon-controls"
  },
  Z.showZoomControl && /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement(z, { id: "zoomIn", label: "zoom in" }, /* @__PURE__ */ e$1.createElement(ir, null)), /* @__PURE__ */ e$1.createElement(z, { id: "zoomOut", label: "zoom out" }, /* @__PURE__ */ e$1.createElement(lr, null))),
  Z.showFullPageControl && /* @__PURE__ */ e$1.createElement(z, { id: "fullPage", label: "full page" }, /* @__PURE__ */ e$1.createElement(sr, null)),
  Z.showRotationControl && /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement(z, { id: "rotateRight", label: "rotate right" }, /* @__PURE__ */ e$1.createElement(pe, null)), /* @__PURE__ */ e$1.createElement(z, { id: "rotateLeft", label: "rotate left" }, /* @__PURE__ */ e$1.createElement(pe, null))),
  Z.showHomeControl && /* @__PURE__ */ e$1.createElement(z, { id: "reset", label: "reset" }, /* @__PURE__ */ e$1.createElement(cr, null))
), mr = (ie) => fetch(`${ie.replace(/\/$/, "")}/info.json`).then((Z) => Z.json()).then((Z) => Z).catch((Z) => {
  console.error(
    `The IIIF tilesource ${ie.replace(
      /\/$/,
      ""
    )}/info.json failed to load: ${Z}`
  );
}), ur = (ie) => {
  let Z, ee;
  if (Array.isArray(ie) && (Z = ie[0], Z)) {
    let ae;
    "@id" in Z ? ae = Z["@id"] : ae = Z.id, ee = ae;
  }
  return ee;
}, pr = ({ uri: ie, hasPlaceholder: Z, imageType: ee }) => {
  const [ae, ve] = reactExports.useState(), [ye, be] = reactExports.useState(), Ye = k(), { configOptions: Qe } = Ye, Je = {
    id: `openseadragon-viewport-${ye}`,
    loadTilesWithAjax: !0,
    fullPageButton: "fullPage",
    homeButton: "reset",
    rotateLeftButton: "rotateLeft",
    rotateRightButton: "rotateRight",
    zoomInButton: "zoomIn",
    zoomOutButton: "zoomOut",
    showNavigator: !0,
    showFullPageControl: !0,
    showHomeControl: !0,
    showRotationControl: !0,
    showZoomControl: !0,
    navigatorBorderColor: "transparent",
    navigatorId: `openseadragon-navigator-${ye}`,
    gestureSettingsMouse: {
      clickToZoom: !0,
      dblClickToZoom: !0,
      pinchToZoom: !0,
      scrollToZoom: !0
    },
    ...Qe.openSeadragon,
    ajaxWithCredentials: Qe.withCredentials
  };
  return reactExports.useEffect(() => {
    ie !== ae && (ve(ie), be(v4()));
  }, [ae, ie]), reactExports.useEffect(() => {
    if (ae)
      switch (ee) {
        case "simpleImage":
          le(Je).addSimpleImage({
            url: ae
          });
          break;
        case "tiledImage":
          mr(ae).then(
            (nt) => le(Je).addTiledImage({
              tileSource: nt
            })
          );
          break;
        default:
          console.warn(
            `Unable to render ${ae} in OpenSeadragon as type: "${ee}"`
          );
          break;
      }
  }, [ae]), ye ? /* @__PURE__ */ e$1.createElement(
    or,
    {
      css: {
        backgroundColor: Qe.canvasBackgroundColor,
        height: Qe.canvasHeight
      },
      className: "clover-viewer-osd-wrapper",
      "data-testid": "clover-viewer-osd-wrapper"
    },
    /* @__PURE__ */ e$1.createElement(dr, { hasPlaceholder: Z, options: Je }),
    /* @__PURE__ */ e$1.createElement(nr, { id: `openseadragon-navigator-${ye}` }),
    /* @__PURE__ */ e$1.createElement(rr, { id: `openseadragon-viewport-${ye}` })
  ) : null;
}, fr = ({
  painting: ie,
  hasPlaceholder: Z
}) => {
  const [ee, ae] = reactExports.useState(), [ve, ye] = reactExports.useState();
  return reactExports.useEffect(() => {
    Array.isArray(ie == null ? void 0 : ie.service) && (ie == null ? void 0 : ie.service.length) > 0 ? (ae("tiledImage"), ye(ur(ie == null ? void 0 : ie.service))) : (ae("simpleImage"), ye(ie == null ? void 0 : ie.id));
  }, [ie]), /* @__PURE__ */ e$1.createElement(
    pr,
    {
      uri: ve,
      key: ve,
      hasPlaceholder: Z,
      imageType: ee
    }
  );
}, gr = ({
  isMedia: ie,
  label: Z,
  placeholderCanvas: ee,
  setIsInteractive: ae
}) => {
  const { vault: ve } = k(), ye = N(ve, ee), be = ye ? ye[0] : void 0, Ye = Z ? D(Z) : ["placeholder image"];
  return /* @__PURE__ */ e$1.createElement(
    je,
    {
      onClick: () => ae(!0),
      isMedia: ie,
      className: "clover-viewer-placeholder"
    },
    /* @__PURE__ */ e$1.createElement(
      "img",
      {
        src: (be == null ? void 0 : be.id) || "",
        alt: Ye.join(),
        height: be == null ? void 0 : be.height,
        width: be == null ? void 0 : be.width
      }
    )
  );
}, hr = m("canvas", {
  position: "absolute",
  width: "100%",
  height: "100%",
  zIndex: "0"
}), xr = e$1.forwardRef(
  (ie, Z) => {
    const ee = e$1.useRef(null), ae = reactExports.useCallback(() => {
      var ye, be;
      if ((ye = Z.current) != null && ye.currentTime && ((be = Z.current) == null ? void 0 : be.currentTime) > 0)
        return;
      const Ye = Z.current;
      if (!Ye)
        return;
      const Qe = new AudioContext(), Je = Qe.createMediaElementSource(Ye), nt = Qe.createAnalyser(), st = ee.current;
      if (!st)
        return;
      st.width = Ye.offsetWidth, st.height = Ye.offsetHeight;
      const ot = st.getContext("2d");
      Je.connect(nt), nt.connect(Qe.destination), nt.fftSize = 256;
      const lt = nt.frequencyBinCount, ft = new Uint8Array(lt);
      setInterval(function() {
        ve(
          nt,
          ot,
          lt,
          ft,
          st.width,
          st.height
        );
      }, 20);
    }, [Z]);
    e$1.useEffect(() => {
      !Z || !Z.current || (Z.current.onplay = ae);
    }, [ae, Z]);
    function ve(ye, be, Ye, Qe, Je, nt) {
      const st = Je / Ye * 2.6;
      let ot, lt = 0;
      ye.getByteFrequencyData(Qe), be.fillStyle = "#000000", be.fillRect(0, 0, Je, nt);
      for (let ft = 0; ft < Ye; ft++)
        ot = Qe[ft] * 2, be.fillStyle = "rgba(78, 42, 132, 1)", be.fillRect(lt, nt - ot, st, ot), lt += st + 6;
    }
    return /* @__PURE__ */ e$1.createElement(hr, { ref: ee, role: "presentation" });
  }
), vr = m("div", {
  position: "relative",
  backgroundColor: "$primaryAlt",
  display: "flex",
  flexGrow: "0",
  flexShrink: "1",
  maxHeight: "500px",
  zIndex: "1",
  video: {
    backgroundColor: "transparent",
    objectFit: "contain",
    width: "100%",
    height: "100%",
    position: "relative",
    zIndex: "1"
  }
}), br = ({ resource: ie, ignoreCaptionLabels: Z }) => {
  const ee = D(ie.label, "en");
  return Array.isArray(ee) && ee.some((ae) => Z.includes(ae)) ? null : /* @__PURE__ */ e$1.createElement(
    "track",
    {
      key: ie.id,
      src: ie.id,
      label: Array.isArray(ee) ? ee[0] : ee,
      srcLang: "en",
      "data-testid": "player-track"
    }
  );
}, yr = ({ allSources: ie, resources: Z, painting: ee }) => {
  const [ae, ve] = e$1.useState(0), [ye, be] = e$1.useState(), Ye = e$1.useRef(null), Qe = (ee == null ? void 0 : ee.type) === "Sound", Je = k(), { activeCanvas: nt, configOptions: st, vault: ot } = Je;
  return reactExports.useEffect(() => {
    if (!ee.id || !Ye.current)
      return;
    if (Ye != null && Ye.current) {
      const gt = Ye.current;
      gt.src = ee.id, gt.load();
    }
    if (ee.id.split(".").pop() !== "m3u8")
      return;
    const lt = {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      xhrSetup: function(gt, ct) {
        gt.withCredentials = !!st.withCredentials;
      }
    }, ft = new Hls(lt);
    return ft.attachMedia(Ye.current), ft.on(Hls.Events.MEDIA_ATTACHED, function() {
      ft.loadSource(ee.id);
    }), ft.on(Hls.Events.ERROR, function(gt, ct) {
      if (ct.fatal)
        switch (ct.type) {
          case Hls.ErrorTypes.NETWORK_ERROR:
            console.error(
              `fatal ${gt} network error encountered, try to recover`
            ), ft.startLoad();
            break;
          case Hls.ErrorTypes.MEDIA_ERROR:
            console.error(
              `fatal ${gt} media error encountered, try to recover`
            ), ft.recoverMediaError();
            break;
          default:
            ft.destroy();
            break;
        }
    }), () => {
      if (ft && Ye.current) {
        const gt = Ye.current;
        ft.detachMedia(), ft.destroy(), gt.currentTime = 0;
      }
    };
  }, [st.withCredentials, ee.id]), reactExports.useEffect(() => {
    var lt, ft, gt, ct;
    const _r = ot.get(nt), Kr = (lt = _r.accompanyingCanvas) != null && lt.id ? N(ot, (ft = _r.accompanyingCanvas) == null ? void 0 : ft.id) : null, Xr = (gt = _r.placeholderCanvas) != null && gt.id ? N(ot, (ct = _r.placeholderCanvas) == null ? void 0 : ct.id) : null;
    Kr && Xr ? be(ae === 0 ? Xr[0].id : Kr[0].id) : (Kr && be(Kr[0].id), Xr && be(Xr[0].id));
  }, [nt, ae, ot]), reactExports.useEffect(() => {
    if (Ye != null && Ye.current) {
      const lt = Ye.current;
      return lt == null || lt.addEventListener(
        "timeupdate",
        () => ve(lt.currentTime)
      ), () => document.removeEventListener("timeupdate", () => {
      });
    }
  }, []), /* @__PURE__ */ e$1.createElement(
    vr,
    {
      css: {
        backgroundColor: st.canvasBackgroundColor,
        maxHeight: st.canvasHeight,
        position: "relative"
      },
      "data-testid": "player-wrapper",
      className: "clover-viewer-player-wrapper"
    },
    /* @__PURE__ */ e$1.createElement(
      "video",
      {
        id: "clover-iiif-video",
        key: ee.id,
        ref: Ye,
        controls: !0,
        height: ee.height,
        width: ee.width,
        crossOrigin: "anonymous",
        poster: ye,
        style: {
          maxHeight: st.canvasHeight,
          position: "relative",
          zIndex: "1"
        }
      },
      ie.map((lt) => /* @__PURE__ */ e$1.createElement("source", { src: lt.id, type: lt.format, key: lt.id })),
      Z.length > 0 && Z.map((lt) => /* @__PURE__ */ e$1.createElement(
        br,
        {
          resource: lt,
          ignoreCaptionLabels: st.ignoreCaptionLabels || [],
          key: lt.id
        }
      )),
      "Sorry, your browser doesn't support embedded videos."
    ),
    Qe && /* @__PURE__ */ e$1.createElement(xr, { ref: Ye })
  );
}, Er = () => /* @__PURE__ */ e$1.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "close-svg-title",
    focusable: "false",
    viewBox: "0 0 512 512",
    role: "img"
  },
  /* @__PURE__ */ e$1.createElement("title", { id: "close-svg-title" }, "close"),
  /* @__PURE__ */ e$1.createElement("path", { d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" })
), wr = ({ isMedia: ie }) => /* @__PURE__ */ e$1.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "open-svg-title",
    focusable: "false",
    viewBox: "0 0 512 512",
    role: "img"
  },
  /* @__PURE__ */ e$1.createElement("title", { id: "open-svg-title" }, "open"),
  ie ? /* @__PURE__ */ e$1.createElement("path", { d: "M133 440a35.37 35.37 0 01-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0135.77.45l247.85 148.36a36 36 0 010 61l-247.89 148.4A35.5 35.5 0 01133 440z" }) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, /* @__PURE__ */ e$1.createElement("path", { d: "m456.69,421.39l-94.09-94.09c22.65-30.16,34.88-66.86,34.84-104.58,0-96.34-78.38-174.72-174.72-174.72S48,126.38,48,222.72s78.38,174.72,174.72,174.72c37.72.04,74.42-12.19,104.58-34.84l94.09,94.09c10.29,9.2,26.1,8.32,35.3-1.98,8.48-9.49,8.48-23.83,0-33.32Zm-233.97-73.87c-68.89-.08-124.72-55.91-124.8-124.8h0c0-68.93,55.87-124.8,124.8-124.8s124.8,55.87,124.8,124.8-55.87,124.8-124.8,124.8Z" }), /* @__PURE__ */ e$1.createElement("path", { d: "m279.5,197.76h-3.35s-28.47,0-28.47,0v-31.82c-.77-13.79-12.57-24.33-26.36-23.56-12.71.71-22.85,10.86-23.56,23.56v3.35h0v28.47h-31.82c-13.79.77-24.33,12.57-23.56,26.36.71,12.71,10.86,22.85,23.56,23.56h3.35s28.47,0,28.47,0v31.82c.77,13.79,12.57,24.33,26.36,23.56,12.71-.71,22.85-10.86,23.56-23.56v-3.35h0v-28.47h31.82c13.79-.77,24.33-12.57,23.56-26.36-.71-12.71-10.86-22.85-23.56-23.56Z" }))
), Cr = ({
  handleToggle: ie,
  isInteractive: Z,
  isMedia: ee
}) => /* @__PURE__ */ e$1.createElement(
  Ge,
  {
    onClick: ie,
    isInteractive: Z,
    isMedia: ee,
    "data-testid": "placeholder-toggle"
  },
  Z ? /* @__PURE__ */ e$1.createElement(Er, null) : /* @__PURE__ */ e$1.createElement(wr, { isMedia: ee })
), Sr = ({
  activeCanvas: ie,
  isMedia: Z,
  painting: ee,
  resources: ae
}) => {
  var ve, ye, be;
  const [Ye, Qe] = e$1.useState(0), [Je, nt] = e$1.useState(!1), { configOptions: st, customDisplays: ot, vault: lt } = k(), ft = lt.get(ie), gt = (ve = ft == null ? void 0 : ft.placeholderCanvas) == null ? void 0 : ve.id, ct = !!gt, _r = (ee == null ? void 0 : ee.length) > 1, Kr = gt && !Je && !Z, Xr = () => nt(!Je), Jr = (ri) => {
    const ai = ee.findIndex((yi) => yi.id === ri);
    Qe(ai);
  }, ei = ot.find((ri) => {
    var ai;
    let yi = !1;
    const { canvasId: pi, paintingFormat: di } = ri.target;
    if (Array.isArray(pi) && pi.length > 0 && (yi = pi.includes(ie)), Array.isArray(di) && di.length > 0) {
      const xi = ((ai = ee[Ye]) == null ? void 0 : ai.format) || "";
      yi = !!(xi && di.includes(xi));
    }
    return yi;
  }), si = (ye = ei == null ? void 0 : ei.display) == null ? void 0 : ye.component;
  return /* @__PURE__ */ e$1.createElement(Xn, { className: "clover-viewer-painting" }, /* @__PURE__ */ e$1.createElement(
    Yn,
    {
      style: {
        backgroundColor: st.canvasBackgroundColor,
        maxHeight: st.canvasHeight
      }
    },
    gt && !Z && /* @__PURE__ */ e$1.createElement(
      Cr,
      {
        handleToggle: Xr,
        isInteractive: Je,
        isMedia: Z
      }
    ),
    Kr && !Z && /* @__PURE__ */ e$1.createElement(
      gr,
      {
        isMedia: Z,
        label: ft == null ? void 0 : ft.label,
        placeholderCanvas: gt,
        setIsInteractive: nt
      }
    ),
    !Kr && !ei && (Z ? /* @__PURE__ */ e$1.createElement(
      yr,
      {
        allSources: ee,
        painting: ee[Ye],
        resources: ae
      }
    ) : ee && /* @__PURE__ */ e$1.createElement(
      fr,
      {
        painting: ee[Ye],
        hasPlaceholder: ct,
        key: ie
      }
    )),
    !Kr && si && /* @__PURE__ */ e$1.createElement(
      si,
      {
        id: ie,
        annotationBody: ee[Ye],
        ...ei == null ? void 0 : ei.display.componentProps
      }
    )
  ), _r && /* @__PURE__ */ e$1.createElement(
    Ue,
    {
      value: (be = ee[Ye]) == null ? void 0 : be.id,
      onValueChange: Jr,
      maxHeight: "200px"
    },
    ee == null ? void 0 : ee.map((ri) => /* @__PURE__ */ e$1.createElement(
      _e,
      {
        value: ri == null ? void 0 : ri.id,
        key: ri == null ? void 0 : ri.id,
        label: ri == null ? void 0 : ri.label
      }
    ))
  ));
}, kr = ({
  activeCanvas: ie,
  painting: Z,
  resources: ee,
  items: ae,
  isAudioVideo: ve
}) => {
  const { informationOpen: ye, configOptions: be } = k(), { informationPanel: Ye } = be, Qe = (Ye == null ? void 0 : Ye.renderAbout) || (Ye == null ? void 0 : Ye.renderSupplementing) && ee.length > 0;
  return /* @__PURE__ */ e$1.createElement(
    Ae,
    {
      className: "clover-viewer-content",
      "data-testid": "clover-viewer-content"
    },
    /* @__PURE__ */ e$1.createElement(Te, null, /* @__PURE__ */ e$1.createElement(
      Sr,
      {
        activeCanvas: ie,
        isMedia: ve,
        painting: Z,
        resources: ee
      }
    ), Qe && /* @__PURE__ */ e$1.createElement(Me, null, /* @__PURE__ */ e$1.createElement("span", null, ye ? "View Items" : "More Information")), ae.length > 1 && /* @__PURE__ */ e$1.createElement($e, { className: "clover-viewer-media-wrapper" }, /* @__PURE__ */ e$1.createElement(Zn, { items: ae, activeItem: 0 }))),
    ye && Qe && /* @__PURE__ */ e$1.createElement($t, null, /* @__PURE__ */ e$1.createElement(Re, null, /* @__PURE__ */ e$1.createElement(
      xn,
      {
        activeCanvas: ie,
        resources: ee
      }
    )))
  );
}, Ir = m(W.Trigger, {
  width: "30px",
  padding: "5px"
}), $r = m(W.Content, {
  display: "flex",
  flexDirection: "column",
  fontSize: "0.8333rem",
  border: "none",
  boxShadow: "2px 2px 5px #0003",
  zIndex: "2",
  button: {
    display: "flex",
    textDecoration: "none",
    marginBottom: "0.5em",
    color: "$accentAlt",
    cursor: "pointer",
    background: "$secondary",
    border: "none",
    "&:last-child": {
      marginBottom: "0"
    }
  }
}), Ar = m("span", {
  fontSize: "1.33rem",
  alignSelf: "flex-start",
  flexGrow: "0",
  flexShrink: "1",
  padding: "1rem",
  "@sm": {
    fontSize: "1rem"
  },
  "&.visually-hidden": {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: "0"
  }
}), Tr = m("header", {
  display: "flex",
  backgroundColor: "transparent !important",
  justifyContent: "space-between",
  alignItems: "flex-start",
  width: "100%",
  [`> ${qe}`]: {
    flexGrow: "1",
    flexShrink: "0"
  },
  form: {
    flexGrow: "0",
    flexShrink: "1"
  }
}), Mr = m("div", {
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "flex-end",
  padding: "1rem",
  flexShrink: "0",
  flexGrow: "1"
}), Rr = () => {
  var ie;
  const Z = O(), ee = k(), { activeManifest: ae, collection: ve, configOptions: ye, vault: be } = ee, Ye = ye == null ? void 0 : ye.canvasHeight, Qe = (Je) => {
    Z({
      type: "updateActiveManifest",
      manifestId: Je
    });
  };
  return /* @__PURE__ */ e$1.createElement("div", { style: { margin: "0.75rem" } }, /* @__PURE__ */ e$1.createElement(
    Ue,
    {
      label: ve.label,
      maxHeight: Ye,
      value: ae,
      onValueChange: Qe
    },
    (ie = ve == null ? void 0 : ve.items) == null ? void 0 : ie.map((Je) => /* @__PURE__ */ e$1.createElement(
      _e,
      {
        value: Je.id,
        key: Je.id,
        thumbnail: Je != null && Je.thumbnail ? be.get(Je == null ? void 0 : Je.thumbnail) : void 0,
        label: Je.label
      }
    ))
  ));
}, zr = (ie, Z = 2500) => {
  const [ee, ae] = reactExports.useState(), ve = reactExports.useCallback(() => {
    navigator.clipboard.writeText(ie).then(
      () => ae("copied"),
      () => ae("failed")
    );
  }, [ie]);
  return reactExports.useEffect(() => {
    if (!ee)
      return;
    const ye = setTimeout(() => ae(void 0), Z);
    return () => clearTimeout(ye);
  }, [ee]), [ee, ve];
}, Lr = m("span", {
  display: "flex",
  alignContent: "center",
  alignItems: "center",
  padding: "0.125rem 0.25rem 0",
  marginTop: "-0.125rem",
  marginLeft: "0.5rem",
  backgroundColor: "$accent",
  color: "$secondary",
  borderRadius: "3px",
  fontSize: "0.6111rem",
  textTransform: "uppercase",
  lineHeight: "1em"
}), Fr = ({ status: ie }) => ie ? /* @__PURE__ */ e$1.createElement(Lr, { "data-copy-status": ie }, ie) : null, fe = ({
  textPrompt: ie,
  textToCopy: Z
}) => {
  const [ee, ae] = zr(Z);
  return /* @__PURE__ */ e$1.createElement("button", { onClick: ae }, ie, " ", /* @__PURE__ */ e$1.createElement(Fr, { status: ee }));
}, Pr = () => {
  const ie = "#ed1d33", Z = "#2873ab";
  return /* @__PURE__ */ e$1.createElement("svg", { viewBox: "0 0 493.35999 441.33334", id: "iiif-logo", version: "1.1" }, /* @__PURE__ */ e$1.createElement("title", null, "IIIF Manifest Options"), /* @__PURE__ */ e$1.createElement("g", { transform: "matrix(1.3333333,0,0,-1.3333333,0,441.33333)" }, /* @__PURE__ */ e$1.createElement("g", { transform: "scale(0.1)" }, /* @__PURE__ */ e$1.createElement(
    "path",
    {
      style: { fill: Z },
      d: "M 65.2422,2178.75 775.242,1915 773.992,15 65.2422,276.25 v 1902.5"
    }
  ), /* @__PURE__ */ e$1.createElement(
    "path",
    {
      style: { fill: Z },
      d: "m 804.145,2640.09 c 81.441,-240.91 -26.473,-436.2 -241.04,-436.2 -214.558,0 -454.511,195.29 -535.9527,436.2 -81.4335,240.89 26.4805,436.18 241.0387,436.18 214.567,0 454.512,-195.29 535.954,-436.18"
    }
  ), /* @__PURE__ */ e$1.createElement(
    "path",
    {
      style: { fill: ie },
      d: "M 1678.58,2178.75 968.578,1915 969.828,15 1678.58,276.25 v 1902.5"
    }
  ), /* @__PURE__ */ e$1.createElement(
    "path",
    {
      style: { fill: ie },
      d: "m 935.082,2640.09 c -81.437,-240.91 26.477,-436.2 241.038,-436.2 214.56,0 454.51,195.29 535.96,436.2 81.43,240.89 -26.48,436.18 -241.04,436.18 -214.57,0 -454.52,-195.29 -535.958,-436.18"
    }
  ), /* @__PURE__ */ e$1.createElement(
    "path",
    {
      style: { fill: Z },
      d: "m 1860.24,2178.75 710,-263.75 -1.25,-1900 -708.75,261.25 v 1902.5"
    }
  ), /* @__PURE__ */ e$1.createElement(
    "path",
    {
      style: { fill: Z },
      d: "m 2603.74,2640.09 c 81.45,-240.91 -26.47,-436.2 -241.03,-436.2 -214.58,0 -454.52,195.29 -535.96,436.2 -81.44,240.89 26.48,436.18 241.03,436.18 214.57,0 454.51,-195.29 535.96,-436.18"
    }
  ), /* @__PURE__ */ e$1.createElement(
    "path",
    {
      style: { fill: ie },
      d: "m 3700.24,3310 v -652.5 c 0,0 -230,90 -257.5,-142.5 -2.5,-247.5 0,-336.25 0,-336.25 l 257.5,83.75 V 1690 l -258.61,-92.5 V 262.5 L 2735.24,0 v 2360 c 0,0 -15,850 965,950"
    }
  ))));
}, Vr = m($6be4966fd9bbc698$export$be92b6f5f03c0fe9, {
  all: "unset",
  height: "2rem",
  width: "3.236rem",
  backgroundColor: "#6663",
  borderRadius: "9999px",
  position: "relative",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:focus": {
    boxShadow: "0 0 0 2px $secondaryAlt"
  },
  '&[data-state="checked"]': {
    backgroundColor: "$accent",
    boxShadow: "inset 2px 2px 5px #0003"
  }
}), Br = m($6be4966fd9bbc698$export$6521433ed15a34db, {
  display: "block",
  height: "calc(2rem - 12px)",
  width: "calc(2rem - 12px)",
  backgroundColor: "$secondary",
  borderRadius: "100%",
  boxShadow: "2px 2px 5px #0001",
  transition: "$all",
  transform: "translateX(6px)",
  willChange: "transform",
  '&[data-state="checked"]': {
    transform: "translateX(calc(1.236rem + 6px))"
  }
}), Hr = m("label", {
  fontSize: "0.8333rem",
  fontWeight: "400",
  lineHeight: "1em",
  userSelect: "none",
  cursor: "pointer",
  paddingRight: "0.618rem"
}), Or = m("form", {
  display: "flex",
  flexShrink: "0",
  flexGrow: "1",
  alignItems: "center",
  marginLeft: "1.618rem"
}), Dr = () => {
  var ie;
  const { configOptions: Z } = k(), ee = O(), [ae, ve] = reactExports.useState((ie = Z == null ? void 0 : Z.informationPanel) == null ? void 0 : ie.open);
  return reactExports.useEffect(() => {
    ee({
      type: "updateInformationOpen",
      informationOpen: ae
    });
  }, [ae]), /* @__PURE__ */ e$1.createElement(Or, null, /* @__PURE__ */ e$1.createElement(Hr, { htmlFor: "information-toggle", css: ae ? { opacity: "1" } : {} }, "More Information"), /* @__PURE__ */ e$1.createElement(
    Vr,
    {
      checked: ae,
      onCheckedChange: () => ve(!ae),
      id: "information-toggle",
      "aria-label": "information panel toggle",
      name: "toggled?"
    },
    /* @__PURE__ */ e$1.createElement(Br, null)
  ));
}, Ze = (ie) => {
  const Z = () => window.matchMedia ? window.matchMedia(ie).matches : !1, [ee, ae] = reactExports.useState(Z);
  return reactExports.useEffect(() => {
    const ve = () => ae(Z);
    return window.addEventListener("resize", ve), () => window.removeEventListener("resize", ve);
  }), ee;
}, Wr = ({ manifestId: ie, manifestLabel: Z }) => {
  const ee = k(), { collection: ae, configOptions: ve } = ee, { showTitle: ye, showIIIFBadge: be, informationPanel: Ye } = ve, Qe = be || (Ye == null ? void 0 : Ye.renderToggle), Je = Ze(te.sm);
  return /* @__PURE__ */ e$1.createElement(Tr, { className: "clover-viewer-header" }, ae != null && ae.items ? /* @__PURE__ */ e$1.createElement(Rr, null) : /* @__PURE__ */ e$1.createElement(Ar, { className: ye ? "" : "visually-hidden" }, ye && /* @__PURE__ */ e$1.createElement(L, { label: Z, className: "label" })), Qe && /* @__PURE__ */ e$1.createElement(Mr, null, be && /* @__PURE__ */ e$1.createElement(W, null, /* @__PURE__ */ e$1.createElement(Ir, null, /* @__PURE__ */ e$1.createElement(Pr, null)), /* @__PURE__ */ e$1.createElement($r, null, (ae == null ? void 0 : ae.items) && /* @__PURE__ */ e$1.createElement(
    "button",
    {
      onClick: (nt) => {
        nt.preventDefault(), window.open(ae.id, "_blank");
      }
    },
    "View Collection"
  ), /* @__PURE__ */ e$1.createElement(
    "button",
    {
      onClick: (nt) => {
        nt.preventDefault(), window.open(ie, "_blank");
      }
    },
    "View Manifest"
  ), " ", (ae == null ? void 0 : ae.items) && /* @__PURE__ */ e$1.createElement(
    fe,
    {
      textPrompt: "Copy Collection URL",
      textToCopy: ae.id
    }
  ), /* @__PURE__ */ e$1.createElement(
    fe,
    {
      textPrompt: "Copy Manifest URL",
      textToCopy: ie
    }
  ))), (Ye == null ? void 0 : Ye.renderToggle) && !Je && /* @__PURE__ */ e$1.createElement(Dr, null)));
}, jr = (ie = !1) => {
  const [Z, ee] = reactExports.useState(ie);
  return reactExports.useLayoutEffect(() => {
    if (!Z)
      return;
    const ae = document.documentElement.style.overflow;
    return document.documentElement.style.overflow = "hidden", () => {
      document.documentElement.style.overflow = ae;
    };
  }, [Z]), reactExports.useEffect(() => {
    Z !== ie && ee(ie);
  }, [ie]), [Z, ee];
}, Nr = ({ manifest: ie, theme: Z }) => {
  var ee;
  const ae = k(), ve = O(), { activeCanvas: ye, informationOpen: be, vault: Ye, configOptions: Qe } = ae, [Je, nt] = reactExports.useState(!1), [st, ot] = reactExports.useState(!1), [lt, ft] = reactExports.useState([]), [gt, ct] = reactExports.useState([]), [_r, Kr] = jr(!1), Xr = Ze(te.sm), Jr = reactExports.useCallback(
    (ei) => {
      ve({
        type: "updateInformationOpen",
        informationOpen: ei
      });
    },
    [ve]
  );
  return reactExports.useEffect(() => {
    var ei;
    (ei = Qe == null ? void 0 : Qe.informationPanel) != null && ei.open && Jr(!Xr);
  }, [
    Xr,
    (ee = Qe == null ? void 0 : Qe.informationPanel) == null ? void 0 : ee.open,
    Jr
  ]), reactExports.useEffect(() => {
    if (!Xr) {
      Kr(!1);
      return;
    }
    Kr(be);
  }, [be, Xr, Kr]), reactExports.useEffect(() => {
    const ei = N(Ye, ye), si = yt(
      Ye,
      ye,
      "text/vtt"
    );
    ei && (ot(
      ["Sound", "Video"].indexOf(ei[0].type) > -1
    ), ft(ei)), ct(si), nt(si.length !== 0);
  }, [ye, Ye]), /* @__PURE__ */ e$1.createElement(ErrorBoundary, { FallbackComponent: It }, /* @__PURE__ */ e$1.createElement(
    At,
    {
      className: `${Z} clover-viewer`,
      css: { background: Qe == null ? void 0 : Qe.background },
      "data-body-locked": _r,
      "data-information-panel": Je,
      "data-information-panel-open": be
    },
    /* @__PURE__ */ e$1.createElement(
      $409067139f391064$export$be92b6f5f03c0fe9,
      {
        open: be,
        onOpenChange: Jr
      },
      /* @__PURE__ */ e$1.createElement(
        Wr,
        {
          manifestLabel: ie.label,
          manifestId: ie.id
        }
      ),
      /* @__PURE__ */ e$1.createElement(
        kr,
        {
          activeCanvas: ye,
          painting: lt,
          resources: gt,
          items: ie.items,
          isAudioVideo: st
        }
      )
    )
  ));
}, ge = {
  ignoreCache: !1,
  headers: {
    Accept: "application/json, text/javascript, text/plain"
  },
  timeout: 5e3,
  withCredentials: !1
};
function Gr(ie) {
  return {
    ok: ie.status >= 200 && ie.status < 300,
    status: ie.status,
    statusText: ie.statusText,
    headers: ie.getAllResponseHeaders(),
    data: ie.responseText,
    json: () => JSON.parse(ie.responseText)
  };
}
function he(ie, Z = null) {
  return {
    ok: !1,
    status: ie.status,
    statusText: ie.statusText,
    headers: ie.getAllResponseHeaders(),
    data: Z || ie.statusText,
    json: () => JSON.parse(Z || ie.statusText)
  };
}
function qr(ie, Z = ge) {
  const ee = Z.headers || ge.headers;
  return new Promise((ae, ve) => {
    const ye = new XMLHttpRequest();
    ye.open("get", ie), ye.withCredentials = Z.withCredentials, ee && Object.keys(ee).forEach(
      (be) => ye.setRequestHeader(be, ee[be])
    ), ye.onload = () => {
      ae(Gr(ye));
    }, ye.onerror = () => {
      ve(he(ye, "Failed to make request."));
    }, ye.ontimeout = () => {
      ve(he(ye, "Request took longer than expected."));
    }, ye.send();
  });
}
const ao = ({
  canvasIdCallback: ie = () => {
  },
  customDisplays: Z = [],
  customTheme: ee,
  iiifContent: ae,
  id: ve,
  manifestId: ye,
  options: be
}) => {
  var Ye;
  let Qe = ae;
  return ve && (Qe = ve), ye && (Qe = ye), /* @__PURE__ */ e$1.createElement(
    bt,
    {
      initialState: {
        ..._,
        customDisplays: Z,
        informationOpen: !!((Ye = be == null ? void 0 : be.informationPanel) != null && Ye.open),
        vault: new Vault({
          customFetcher: (Je) => qr(Je, {
            withCredentials: be == null ? void 0 : be.withCredentials,
            headers: be == null ? void 0 : be.requestHeaders
          }).then((nt) => JSON.parse(nt.data))
        })
      }
    },
    /* @__PURE__ */ e$1.createElement(
      Ur,
      {
        iiifContent: Qe,
        canvasIdCallback: ie,
        customTheme: ee,
        options: be
      }
    )
  );
}, Ur = ({
  canvasIdCallback: ie,
  customTheme: Z,
  iiifContent: ee,
  options: ae
}) => {
  const ve = O(), ye = k(), { activeCanvas: be, activeManifest: Ye, isLoaded: Qe, vault: Je } = ye, [nt, st] = reactExports.useState(), [ot, lt] = reactExports.useState();
  let ft = {};
  return Z && (ft = Q$1("custom", Z)), reactExports.useEffect(() => {
    ie && ie(be);
  }, [be, ie]), reactExports.useEffect(() => {
    Ye && Je.loadManifest(Ye).then((gt) => {
      lt(gt), ve({
        type: "updateActiveCanvas",
        canvasId: gt.items[0] && gt.items[0].id
      });
    }).catch((gt) => {
      console.error(`Manifest failed to load: ${gt}`);
    }).finally(() => {
      ve({
        type: "updateIsLoaded",
        isLoaded: !0
      });
    });
  }, [Ye, ve, Je]), reactExports.useEffect(() => {
    ve({
      type: "updateConfigOptions",
      configOptions: ae
    }), Je.load(ee).then((gt) => {
      st(gt);
    }).catch((gt) => {
      console.error(
        `The IIIF resource ${ee} failed to load: ${gt}`
      );
    });
  }, [ve, ee, ae, Je]), reactExports.useEffect(() => {
    let gt = [];
    (nt == null ? void 0 : nt.type) === "Collection" ? (ve({
      type: "updateCollection",
      collection: nt
    }), gt = nt.items.filter((ct) => ct.type === "Manifest").map((ct) => ct.id), gt.length > 0 && ve({
      type: "updateActiveManifest",
      manifestId: gt[0]
    })) : (nt == null ? void 0 : nt.type) === "Manifest" && ve({
      type: "updateActiveManifest",
      manifestId: nt.id
    });
  }, [ve, nt]), Qe ? !ot || !ot.items ? (console.log(`The IIIF manifest ${ee} failed to load.`), /* @__PURE__ */ e$1.createElement(e$1.Fragment, null)) : ot.items.length === 0 ? (console.log(`The IIIF manifest ${ee} does not contain canvases.`), /* @__PURE__ */ e$1.createElement(e$1.Fragment, null)) : /* @__PURE__ */ e$1.createElement(Nr, { manifest: ot, theme: ft, key: ot.id }) : /* @__PURE__ */ e$1.createElement(e$1.Fragment, null, "Loading");
};
class CloverInitializer {
  constructor() {
    this.element = document.getElementById("clover-viewer"), this.element && (this.iiif_content = this.element.attributes.iiif_content.value);
  }
  run() {
    if (!this.iiif_content)
      return !1;
    createRoot(document.getElementById("clover-viewer")).render(reactExports.createElement(ao, { id: this.iiif_content, options: this.config }));
  }
  get config() {
    return {
      showTitle: !1,
      showIIIFBadge: !1,
      informationPanel: {
        renderToggle: !1,
        renderAbout: !1
      }
    };
  }
}
export {
  CloverInitializer as C,
  LercParameters as L,
  OlInitializer as O,
  LercAddCompression as a,
  getDefaultExportFromCjs$1 as g
};
